(function () {
    'use strict';

    angular.module('app.stats.graphe', [
        'highcharts-ng','datatables'
        ]);



})();


(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statsTechnologieService', statsTechnologieService);

    /** @ngInject */
    function statsTechnologieService(msApi, $q,StatsFiltreQuery, userManager) {


        var self = this;

        //    Initially the name is unknown....
        self.query_os = [];
        self.result_os = [];

        self.query_browser = [];
        self.result_browser = [];

        self.query_referrer = [];
        self.result_referrer = [];

        self.query_device = [];
        self.result_device = [];
        //////////

        var user = userManager.getUser();
        var channels= (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);

        function stats_os(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_os, empStatsQuery);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_os[filtre_query.index]);

            } else {
              if (!empStatsQuery.canal){
                empStatsQuery.canal=channels.join(',');
              }
              msApi.request(
                    'stats.os@save', {"empStatsQuery" : empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query = angular.copy(filtre_query.query);
                            self.query_os.push(item_query);
                            var resultat = getResult(res);
                            self.result_os.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_device(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_device, empStatsQuery);

            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_device[filtre_query.index]);

            } else {
              if (!empStatsQuery.canal){
                empStatsQuery.canal=channels.join(',');
              }
              msApi.request(
                    'stats.device@save', {"empStatsQuery" : empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query = angular.copy(filtre_query.query);
                            self.query_device.push(item_query);
                            var resultat = getResult(res);
                            self.result_device.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_browser(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_browser, empStatsQuery);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_browser[filtre_query.index]);

            } else {
              if (!empStatsQuery.canal){
                empStatsQuery.canal=channels.join(',');
              }
              msApi.request(
                    'stats.browser@save', {"empStatsQuery" : empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query = angular.copy(filtre_query.query);
                            self.query_browser.push(item_query);
                            var resultat = getResult(res);
                            self.result_browser.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_referrer(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_referrer, empStatsQuery);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_referrer[filtre_query.index]);

            } else {
              if (!empStatsQuery.canal){
                empStatsQuery.canal=channels.join(',');
              }
              msApi.request(
                    'stats.referrer@save', {"empStatsQuery" : empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query = angular.copy(filtre_query.query);
                            self.query_referrer.push(item_query);
                            var resultat = getResult(res);
                            self.result_referrer.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function getResult(res) {
            var values = res.values;
            var visite_y_axis = values.map(function (elm) {
                try {
                    return elm["visite_total"]["value"];}
                catch(e) {return 0;}
            });
            var visiteur_unique_y_axis = values.map(function (elm) {
                if(angular.isUndefined(elm["visite_unique"]["value"]))
                    return 0;
                return elm["visite_unique"]["value"];
            });
            var nombre_vue_visiteur_y_axis = values.map(function (elm) {
                var nombre_vue_visiteur = 0;
                if(angular.isUndefined(elm["visite_total"]["value"]) || angular.isUndefined(elm["visite_unique"]["value"]))
                    return 0;
                if (elm["visite_unique"]["value"] !== 0)
                    nombre_vue_visiteur = (elm["visite_total"]["value"] / elm["visite_unique"]["value"]);
                return nombre_vue_visiteur;
            });
            var duree_moyenne_par_visiteur_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_unique"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_unique"]["value"]);}
                catch(e) {return 0;}
                return pourcenta;
            });
            var duree_moyenne_par_visite_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_total"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_total"]["value"]);}
                catch(e) {return 0;}
                return pourcenta;
            });
            var duree_total_y_axis = values.map(function (elm) {
                try {
                    return elm["duree"]["duree_sum"]["value"];}
                catch(e) {return 0;}
            });


            var device_x_axis = values.map(function (elm) {
                if(angular.isUndefined(elm["key"]))
                    return 0;
                return elm["key"];
            });

            return {
                device_x_axis: device_x_axis,
                visite_y_axis: visite_y_axis,
                visiteur_unique_y_axis: visiteur_unique_y_axis,
                nombre_vue_visiteur_y_axis: nombre_vue_visiteur_y_axis,
                duree_moyenne_par_visiteur_y_axis: duree_moyenne_par_visiteur_y_axis,
                duree_moyenne_par_visite_y_axis: duree_moyenne_par_visite_y_axis,
                duree_total_y_axis: duree_total_y_axis,
                enabled: values.length > 0
            };

        }


        return {
            stats_os: stats_os,
            stats_browser: stats_browser,
            stats_referrer: stats_referrer,
            stats_device: stats_device

        };

    }
}());

(function ()
{
    'use strict';


    /** @ngInject */
function config(msApiProvider)
{
    // Api
    msApiProvider.register('stats.os',  [Routing.generate('api_technologie_post_os_all_and_disctincts')]);
    msApiProvider.register('stats.browser',  [Routing.generate('api_technologie_post_browser_all_and_disctincts')]);
    msApiProvider.register('stats.referrer',  [Routing.generate('api_technologie_post_referrer_all_and_disctincts')]);
    msApiProvider.register('stats.device',  [Routing.generate('api_technologie_post_device_all_and_disctincts')]);
}

angular.module('app.stats.graphe')
    .config(config)
    .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*technologie).*$",
                name_module: "stats_technologie",
                name_angular_module: "app.stats.graphe",
                actions: ["os", "browser", "referrer", "device"]
            };
            msRights.setPermissionsStats(permissions);
        }
    }
})();

(function ()
{
    'use strict';
    var osStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: OSWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<'
    }
};

var browserStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: BrowserWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<'
    }
};

var deviceStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: DeviceWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<'
    }
};

var referrerStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: ReferrerWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<'
    }
};

angular.module('app.stats.graphe')
    .controller('OSWidgetController', OSWidgetController)
    .controller('BrowserWidgetController', BrowserWidgetController)
    .controller('DeviceWidgetController', DeviceWidgetController)
    .controller('ReferrerWidgetController', ReferrerWidgetController)
    .component('osStats', osStats)
    .component('browserStats', browserStats)
    .component('deviceStats', deviceStats)
    .component('referrerStats', referrerStats);

function OSWidgetController($rootScope,chartWidgetService, TableWidgetService,statsTechnologieService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_repartition_os";
    var query_clone;
    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    //
    vm.title="Os";
    var type="stat_repartition_os"
    vm.chartConfig = chartWidgetService.chart_discret(type);
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret(type);
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsTechnologieService.stats_os(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.duree_total_y_axis;


                // vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                // vm.chartConfig.series[1].data = result.duree_total_y_axis;
                // vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                // vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                // vm.chartConfig.series[4].data = result.visite_y_axis;
                // vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                // vm.chartConfig.series[0].visible = true;
                // vm.chartConfig.series[1].visible = false;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_os";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };

    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;

        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories,  vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_os";
        getPieBySeriesId(0);

    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
        vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
        vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }
    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "systeme_exploitation", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "systeme_exploitation", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "systeme_exploitation", vm.query, vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_os";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_os";
            });
        }
        return chart[0];
    }

}

function BrowserWidgetController($rootScope,chartWidgetService,TableWidgetService, statsTechnologieService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_repartition_navigateur";

    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title= "Navigateur";
    var query_clone;
    //

    var type='stat_repartition_navigateur'
    vm.chartConfig = chartWidgetService.chart_discret(type);
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret(type);
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsTechnologieService.stats_browser(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.duree_total_y_axis;

                // vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                // vm.chartConfig.series[1].data = result.duree_total_y_axis;
                // vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                // vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                // vm.chartConfig.series[4].data = result.visite_y_axis;
                // vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                // vm.chartConfig.series[0].visible = true;
                // vm.chartConfig.series[1].visible = false;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_browser";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });

    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;

        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_browser";
        getPieBySeriesId(0);

    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "navigateur", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "navigateur", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "navigateur", vm.query, vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_browser";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_browser";
            });
        }
        return chart[0];
    }

}

function DeviceWidgetController($rootScope, chartWidgetService,TableWidgetService, statsTechnologieService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_audience";

    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title="Device"
    //
    var query_clone;
    vm.chartConfig = chartWidgetService.chart_discret();
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret();
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsTechnologieService.stats_device(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                vm.chartConfig.series[1].data = result.duree_total_y_axis;
                vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                vm.chartConfig.series[4].data = result.visite_y_axis;
                vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                vm.chartConfig.series[0].visible = true;
                vm.chartConfig.series[1].visible = false;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_device";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;

        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_device";
        getPieBySeriesId(0);

    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "device", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "device", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "device", vm.query, vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_device";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_device";
            });
        }
        return chart[0];
    }

}

function ReferrerWidgetController($rootScope, chartWidgetService,TableWidgetService, statsTechnologieService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_repartition_referrer";

    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title="Referrer" ;
    //

    var type='stat_repartition_referrer'
    vm.chartConfig = chartWidgetService.chart_discret(type);
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var query_clone;
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret(type);
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsTechnologieService.stats_referrer(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.duree_total_y_axis;

                // vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                // vm.chartConfig.series[1].data = result.duree_total_y_axis;
                // vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                // vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                // vm.chartConfig.series[4].data = result.visite_y_axis;
                // vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                // vm.chartConfig.series[0].visible = true;
                // vm.chartConfig.series[1].visible = false;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_referrer";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });

    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;

        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_referrer";
        getPieBySeriesId(0);

    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }
    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "referer", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "referer", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "referer", vm.query,vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_referrer";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_referrer";
            });
        }
        return chart[0];
    }

}


})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statAudienceService', statAudienceService);

    /** @ngInject */
    function statAudienceService(msApi, $q,$filter,StatsFiltreQuery, userManager) {


        var self = this;
        var format={};
        format["1d"]="dd/MM/yyyy";
        format["1h"]="dd/MM/yyyyTHH";
        format["1w"]="dd/MM/yyyy";
        format["1M"]="MM/yyyy";
        //    Initially the name is unknown....
        self.query_audience = [];
        self.result_audience = [];

        self.query_duree_chart = [];
        self.result_duree_chart = [];

        self.query_pourcentage_chart = [];
        self.result_pourcentage_chart = [];
        //////////

        var user = userManager.getUser();
        var channels= (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);

        function stats_audience(query,changeRangeStats) {
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_audience, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1 && !changeRangeStats) {
                deferred.resolve(self.result_audience[filtre_query.index]);
            } else {
                if (!query.canal){
                  query.canal=channels.join(',');
                }
              msApi.request(
                'stats.audience@save',{"empStatsQuery" : query},
                function (res) {
                    if (res.code === 200) {
                        var item_query_audienc=angular.copy( filtre_query.query);
                        self.query_audience.push(item_query_audienc);
                        var resultat = getResult(res, query.range);
                        self.result_audience.push(resultat);
                        deferred.resolve(resultat);
                    }
                },
                function () {
                }
            );}
            return deferred.promise;
        }

        function stats_duree(query) {

            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_duree_chart, query);

            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_duree_chart[filtre_query.index]);

            } else {
                if (!query.canal){
                  query.canal=channels.join(',');
                }
              msApi.request(
                    'stats.duree@save',{"empStatsQuery" : query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_duree=angular.copy( filtre_query.query);
                            self.query_duree_chart.push(item_query_duree);
                            var resultat = getResult(res,query.range);
                            self.result_duree_chart.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );}
            return deferred.promise;
        }
        function stats_pourcentage(query) {

            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_pourcentage_chart, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_pourcentage_chart[filtre_query.index]);

            } else {
                msApi.request(
                    'stats.pourcentage@save',{"empStatsQuery" : query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_pourcentage=angular.copy( filtre_query.query);
                            self.query_pourcentage_chart.push(item_query_pourcentage);

                            self.result_pourcentage_chart.push(res);
                            deferred.resolve(res);
                        }
                    },
                    function () {
                    }
                );}
            return deferred.promise;
        }

        function getResult(res,range) {
            var values = res.values;
            
            var visite_y_axis = values.map(function (elm) {
                try {
                    return angular.isUndefined(elm["visite"]) ?  elm["visite_total"]["value"] : elm["visite"]["visite_total"]["value"];
                }
                catch(e) {return 0;}
            });
            var visiteur_unique_y_axis = values.map(function (elm) {
                if(angular.isUndefined(elm["visite"]) 
               // && angular.isUndefined(elm["visite"]["visite_unique"]["value"])  
                && angular.isUndefined(elm["visite_unique"]["value"]))
                    return 0;
                return angular.isUndefined(elm["visite"]) ? elm["visite_unique"]["value"] : elm["visite"]["visite_unique"]["value"] ;
            });
            var nombre_vue_visiteur_y_axis = values.map(function (elm) {
                var nombre_vue_visiteur = 0;
                if((angular.isUndefined(elm["visite"]) 
               // && (angular.isUndefined(elm["visite"]["visite_total"]["value"]) || angular.isUndefined(elm["visite"]["visite_unique"]["value"]))
                ) && (angular.isUndefined(elm["visite_total"]["value"]) || angular.isUndefined(elm["visite_unique"]["value"])))
                    return 0;
                if (!angular.isUndefined(elm["visite"]))
                {
                    if (elm["visite"]["visite_unique"]["value"] !== 0)
                    {
                        nombre_vue_visiteur = (elm["visite"]["visite_total"]["value"] / elm["visite"]["visite_unique"]["value"]);
                    }
                } else {
                    if (elm["visite_unique"]["value"] !== 0)
                    {
                        nombre_vue_visiteur = (elm["visite_total"]["value"] / elm["visite_unique"]["value"]);
                    }
                }
               
                return nombre_vue_visiteur;
            });
            var duree_moyenne_par_visiteur_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_unique"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_unique"]["value"]);}
                catch(e) {return 0;}
                return pourcenta;
            });
            var duree_moyenne_par_visite_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_total"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_total"]["value"]);}
                catch(e) {return 0;}
                return pourcenta;
            });
            var duree_total_y_axis = values.map(function (elm) {
                try {
                    return elm["duree"]["duree_sum"]["value"];}
                catch(e) {return 0;}
            });


            var device_x_axis = values.map(function (elm) {
                if(angular.isUndefined(elm["key"]))
                    return 0;
                var key=new Date(elm["key_as_string"]).toISOString()
                return  range==='1h' ?   $filter('date')(elm["key"], format["1d"] + "T"+getHours(key))
                   : $filter('date')(elm["key"], format["1d"])
            });

            return {
                device_x_axis: device_x_axis,
                visite_y_axis: visite_y_axis,
                visiteur_unique_y_axis: visiteur_unique_y_axis,
                nombre_vue_visiteur_y_axis: nombre_vue_visiteur_y_axis,
                duree_moyenne_par_visiteur_y_axis: duree_moyenne_par_visiteur_y_axis,
                duree_moyenne_par_visite_y_axis: duree_moyenne_par_visite_y_axis,
                duree_total_y_axis: duree_total_y_axis,
                enabled: values.length > 0
            };

        }

        function getHours(date){
            return date.substr(date.lastIndexOf("T")+1,2)
        }
        return {
            stats_audience: stats_audience,
            stats_duree: stats_duree,
            stats_pourcentage: stats_pourcentage

        };

    }
}());

(function () {
    'use strict';

/** @ngInject */
function config(msApiProvider)
{
    // Api

    msApiProvider.register('stats.audience',  [Routing.generate('api_audience_post_audience_all_and_disctincts')]);
    msApiProvider.register('stats.duree',  [Routing.generate('api_audience_post_duree')]);

}

angular.module('app.stats.graphe')
    .config(config)
    .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*audience).*$",
                name_module: "stats_audience",
                name_angular_module: "app.stats.graphe",
                actions: ["audience", "duree"]
            };
            msRights.setPermissionsStats(permissions);
        }
    }

})();

(function ()
{
  'use strict';
  var audienceStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: AudienceWidgetController,
    bindings: {
      chartConfig: '<',
      query: '<',
      permission: '<'
    }
  };

  var dureeStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: DureeWidgetController,
    bindings: {
      chartConfig: '<',
      query: '<'
    }
  };

  angular.module('app.stats.graphe')
    .component('audienceStats', audienceStats)
    .component('dureeStats', dureeStats)
    .controller('AudienceWidgetController', AudienceWidgetController)
    .controller('DureeWidgetController', DureeWidgetController);

  function AudienceWidgetController($rootScope,$injector, chartWidgetService, TableWidgetService, statAudienceService, exportChartService) {
    var vm = this;
    vm.widget_audience={
      ranges:[
        {value:"15mn",code:"15m"},
        {value:"30mn",code:"30m"},
        {value:"heure",code:"1h"}
      ],
      currentRange:2,
    };
    vm.changeRangeStats=false
    vm.chart_title ="VISITSWIDGETSTATS.stat_audience";
    var $translate = $injector.get('$translate');
    var permission= vm.permission;
    console.log("permission",vm.permission);
    vm.setQueryStatsFilter=setQueryStatsFilter;

    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar = viewInBar;
    vm.exportChart = exportChart;
    vm.title = 'Date';
    // vm.zoom = zoom;
    // //
    var query_clone
    vm.chartConfig = chartWidgetService.chart_continu_audience();
    $rootScope.$on('$translateChangeSuccess', function () {
      poll(vm.query)
    });
    var poll = function (query) {
      console.log("queryy",query)
      vm.chartConfig = chartWidgetService.chart_continu_audience();
      vm.chartConfig.loding_disabled = false;
      if($rootScope.vod_id) query.vod_id=$rootScope.vod_id
      statAudienceService.stats_audience(query,vm.changeRangeStats).then(
        function (result) {
          var result_all = result.result_all;
          vm.chartConfig.xAxis.categories = result.device_x_axis;
          vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
          vm.chartConfig.series[1].data = result.visite_y_axis;
          vm.chartConfig.series[2].data = result.visiteur_unique_y_axis;
          vm.chartConfig.loding_disabled = true;
          vm.id_bar = "bar_audience";
          vm.enabled = result.enabled;
          Highcharts.setOptions({lang:{resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

        },
        function () {
          vm.chartConfig.loding_disabled = true;
          vm.enabled = false;
        });
    };
    function setQueryStatsFilter(key,range){
      vm.widget_audience.currentRange=key;
      vm.range= range;
      // query_clone.range = range;
      vm.query.range = range;
      vm.query.lunchFilter=false;
      vm.changeRangeStats=true;
      poll(vm.query);
    }
    // /**
    //  * Zoom
    //  *
    //  * @param item
    //  */
    // function zoom(item) {
    //     var chart = getChart();
    //     console.log(chart);
    //     if (item=="out"){
    //         chart.zoomOut();
    //     }
    //     else {
    //         chart.xAxis[0].setExtremes(1,2);
    //         chart.yAxis[0].setExtremes(1,2);
    //     }
    // }
    this.$onInit = function () {
      query_clone = angular.copy(vm.query);
      vm.viewInBar();
      console.log("vm.query",vm.query)
      poll(vm.query);
    };



    this.$doCheck = function () {
      var verif = angular.equals(query_clone, vm.query);
      if (!verif && vm.query.lunchFilter) {
        query_clone = angular.copy(vm.query);
        poll(vm.query);
      }
    };

    function viewInTable() {

      vm.showGraphBar = false;
      vm.showGraphTable = true;
      vm.showGraphPie = false;

      vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories,  vm.title);

    }

    function viewInPie() {
      vm.showGraphBar = false;
      vm.showGraphTable = false;
      vm.showGraphPie = true;
      vm.id_pie = "pie_audience";
      vm.pieConfig = chartWidgetService.chart_pie("audience", vm.title);
      vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
      vm.selectedSerieName = vm.pieConfig.list_select[0].val;
      getPieBySeriesId(0);

    }


    function changeSeries() {
      var id = vm.selectedSerieName;
      getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
      vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
      vm.showGraphBar = true;
      vm.showGraphTable = false;
      vm.showGraphPie = false;
    }

    function exportChart(type_export) {
      var chart = getChart();
      if(type_export == "pdf") {
        exportChartService.exportPdf(chart, "audience", vm.query);
      }else if(type_export == "image") {
        exportChartService.exportImage(chart, "audience", vm.query);
      }else if(type_export == "excel") {
        exportChartService.exportExcel(chart, "audience", vm.query, vm.title);
      }
    }

    function getChart() {
      var data = Highcharts.charts.filter(function (element) {
        return element !== undefined;
      });
      var chart;
      if (vm.showGraphPie) {
        chart = data.filter(function (element) {
          return element.renderTo.id === "pie_audience";
        });
      }
      else {
        chart = data.filter(function (element) {
          return element.renderTo.id === "bar_audience";
        });
      }
      return chart[0];
    }

  }

  function DureeWidgetController($rootScope, chartWidgetService, TableWidgetService, statAudienceService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_duration";
    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar = viewInBar;
    vm.exportChart = exportChart;
    vm.title = 'Date';

    vm.chartConfig = chartWidgetService.chart_continu();
    $rootScope.$on('$translateChangeSuccess', function () {
      poll(vm.query)
    });
    var query_clone;
    var poll = function (query) {
      vm.chartConfig = chartWidgetService.chart_continu();
      vm.chartConfig.loding_disabled = false;
      if($rootScope.vod_id) query.vod_id=$rootScope.vod_id
      statAudienceService.stats_duree(query).then(
        function (result) {
          vm.chartConfig.xAxis.categories = result.device_x_axis;
          vm.chartConfig.series[0].data = result.duree_total_y_axis;
          vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
          vm.chartConfig.series[1].data = result.duree_moyenne_par_visiteur_y_axis;
          vm.chartConfig.loding_disabled = true;
          vm.id_bar = "bar_duree";
          vm.enabled = result.enabled;
        },
        function () {
          vm.chartConfig.loding_disabled = true;
          vm.enabled = false;
        });



    };

    this.$onInit = function () {
      query_clone = angular.copy(vm.query);
      vm.viewInBar();
      poll(vm.query);
    };

    this.$doCheck = function () {
      var verif = angular.equals(query_clone, vm.query);
      if (!verif && vm.query.lunchFilter) {
        query_clone = angular.copy(vm.query);
        var query_clone_duree=angular.copy(vm.query);
        query_clone_duree.range="1h"
        poll(query_clone_duree);
      }
    };
    function viewInTable() {

      vm.showGraphBar = false;
      vm.showGraphTable = true;
      vm.showGraphPie = false;

      vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);

    }

    function viewInPie() {
      vm.showGraphBar = false;
      vm.showGraphTable = false;
      vm.showGraphPie = true;
      vm.id_pie = "pie_duree";
      vm.pieConfig = chartWidgetService.chart_pie("duration", vm.title);
      vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
      vm.selectedSerieName = vm.pieConfig.list_select[0].val;
      getPieBySeriesId(0);
    }


    function changeSeries() {
      var id = vm.selectedSerieName;
      getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
      vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
      vm.showGraphBar = true;
      vm.showGraphTable = false;
      vm.showGraphPie = false;
    }

    function exportChart(type_export) {
      var chart = getChart();
      if(chart) {
        if (type_export == "pdf") {
          exportChartService.exportPdf(chart, "duree", vm.query);
        } else if (type_export == "image") {
          exportChartService.exportImage(chart, "duree", vm.query);
        } else if (type_export == "excel") {
          exportChartService.exportExcel(chart, "duree", vm.query,vm.title);
        }
      }
    }

    function getChart() {
      var data = Highcharts.charts.filter(function (element) {
        return element !== undefined;
      });
      var chart;
      if (vm.showGraphPie) {
        chart = data.filter(function (element) {
          return element.renderTo.id === "pie_duree";
        });
      }
      else {
        chart = data.filter(function (element) {
          return element.renderTo.id === "bar_duree";
        });
      }
      return chart[0];
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statTimeReelService', statTimeReelService);

    /** @ngInject */
    function statTimeReelService(msApi, $q, $filter, userManager) {

        var user = userManager.getUser();
        var channels= (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);

        function stats_time_reel_now(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            delete empStatsQuery.dateIn;
            delete empStatsQuery.dateOut;
            var deferred = $q.defer();

            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
          msApi.request(
                'stats.time.reel.now@save', {"empStatsQuery" : empStatsQuery},
                function (res) {
                    if (res.code === 200) {

                        deferred.resolve(res.values);
                    }
                },
                function () {
                }
            );
            return deferred.promise;
        }

        function stats_time_reel_heure(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            delete empStatsQuery.dateIn;
            delete empStatsQuery.dateOut;

            var deferred = $q.defer();
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
            msApi.request(
                'stats.time.reel.hour@save', {"empStatsQuery" : empStatsQuery},
                function (res) {
                    if (res.code === 200) {
                        var resultat = getResult(res, "HH:mm:ss");
                        deferred.resolve(resultat);
                    }
                },
                function () {
                }
            );
            return deferred.promise;
        }

        function stats_time_reel_minute(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            delete empStatsQuery.dateIn;
            delete empStatsQuery.dateOut;
            var deferred = $q.defer();
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
            msApi.request(
                'stats.time.reel.minute@save', {"empStatsQuery" : empStatsQuery},
                function (res) {
                    if (res.code === 200) {
                        var resultat = getResult(res, "HH:mm");
                        deferred.resolve(resultat);
                    }
                },
                function () {
                }
            );
            return deferred.promise;
        }

        function getResult(res, format) {
            var values = res.values;
            var visite_y_axis = values.map(function (elm) {
                try {
                    return elm["visite_total"]["value"];
                }
                catch (e) {
                    return 0;
                }
            });
            var visiteur_unique_y_axis = values.map(function (elm) {
                if (angular.isUndefined(elm["visite_unique"]["value"]))
                    return 0;
                return elm["visite_unique"]["value"];
            });
            var nombre_vue_visiteur_y_axis = values.map(function (elm) {
                var nombre_vue_visiteur = 0;
                if (angular.isUndefined(elm["visite_total"]["value"]) || angular.isUndefined(elm["visite_unique"]["value"]))
                    return 0;
                if (elm["visite_unique"]["value"] !== 0)
                    nombre_vue_visiteur = (elm["visite_total"]["value"] / elm["visite_unique"]["value"]);
                return nombre_vue_visiteur;
            });
            var duree_moyenne_par_visiteur_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_unique"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_unique"]["value"]);
                }
                catch (e) {
                    return 0;
                }
                return pourcenta;
            });
            var duree_moyenne_par_visite_y_axis = values.map(function (elm) {
                var pourcenta = 0;
                try {
                    if (elm["duree"]["visite_total"]["value"] !== 0)
                        pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_total"]["value"]);
                }
                catch (e) {
                    return 0;
                }
                return pourcenta;
            });
            var duree_total_y_axis = values.map(function (elm) {
                try {
                    return elm["duree"]["duree_sum"]["value"];
                }
                catch (e) {
                    return 0;
                }
            });


            var device_x_axis = values.map(function (elm) {
                if (angular.isUndefined(elm["key"]))
                    return 0;
                return $filter('date')(elm["key"], format, 'UTC');
            });

            return {
                device_x_axis: device_x_axis,
                visite_y_axis: visite_y_axis,
                visiteur_unique_y_axis: visiteur_unique_y_axis,
                nombre_vue_visiteur_y_axis: nombre_vue_visiteur_y_axis,
                duree_moyenne_par_visiteur_y_axis: duree_moyenne_par_visiteur_y_axis,
                duree_moyenne_par_visite_y_axis: duree_moyenne_par_visite_y_axis,
                duree_total_y_axis: duree_total_y_axis,
                enabled: visite_y_axis.length > 0
            };

        }

        return {
            stats_time_reel_now: stats_time_reel_now,
            stats_time_reel_heure: stats_time_reel_heure,
            stats_time_reel_minute: stats_time_reel_minute

        };

    }
}());

(function ()
{
    'use strict';

/** @ngInject */
function config(msApiProvider)
{
    // Api
  
    msApiProvider.register('stats.time.reel.now',  [Routing.generate('api_temps_reel_post_stats_now')]);
    msApiProvider.register('stats.time.reel.hour',  [Routing.generate('api_temps_reel_post_stats_now_hours')]);
    msApiProvider.register('stats.time.reel.minute',  [Routing.generate('api_temps_reel_post_stats_now_minute')]);
}

angular.module('app.stats.graphe')
    .config(config)
    .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*temps_reel).*$",
                name_module: "stats_temps_reel",
                name_angular_module: "app.stats.graphe",
                actions: ["stats_now", "now_hours", "stats_now_minute"]
            };
            msRights.setPermissionsStats(permissions);
        }
    }
})();

(function ()
{
    'use strict';

var timeReelNowStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget-temps-reel.html',
    controller: TimeReelNowWidgetController,
    bindings: {
        mesureConfig: '<',
        query: '<',
        type: '@',
        stat: '@'
    }
};
var timeReelNowVideoStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
    controller: TimeReelNowVideoWidgetController,
    bindings: {
        mesureConfig: '<',
        query: '<',
        type: '@',
        stat: '@'
    }
};
var timeReelHeureStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: TimeReelHeureWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<',
      stat: '@'
    }
};

var timeReelMinuteStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: TimeReelMinuteWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<',
      stat: '@'
    }
};

angular.module('app.stats.graphe')
    .controller('TimeReelNowWidgetController', TimeReelNowWidgetController)
    .controller('TimeReelHeureWidgetController', TimeReelHeureWidgetController)
    .controller('TimeReelMinuteWidgetController', TimeReelMinuteWidgetController)
    .controller('TimeReelNowVideoWidgetController', TimeReelNowVideoWidgetController)
    .component('timeReelNowStats', timeReelNowStats)
    .component('timeReelHeureStats', timeReelHeureStats)
    .component('timeReelMinuteStats', timeReelMinuteStats)
    .component('timeReelNowVideoStats',timeReelNowVideoStats);


 function TimeReelNowWidgetController($rootScope,mesure_widget_constant, statTimeReelService, $interval, podcast_constants) {
    var vm = this;

    var timer;
    vm.mesureConfig = {};
    vm.mesureConfig.loding_disabled = true;
   var mesure_visite_total = mesure_widget_constant["visite_temps_reel"];
   var mesure_video_total = mesure_widget_constant["video_temps_reel"];
   if(vm.stat && vm.stat==='podcast'){
      mesure_visite_total = podcast_constants["visite_temps_reel"];
      mesure_video_total = podcast_constants["video_temps_reel"];
   }

    var query_clone;
     if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
   vm.stats_interval= $rootScope.stats_interval ?  ($rootScope.stats_interval * 1000): 10000
   var poll = function () {
        timer = $interval(function () {
            stats_time_reel_now();
        },  vm.stats_interval);
    };

    function stats_time_reel_now() {
        statTimeReelService.stats_time_reel_now(vm.query).then(
            function (result) {

                vm.mesureConfig = {};
                vm.mesureConfig.visite_total = mesure_visite_total;
                vm.mesureConfig.video_total = mesure_video_total;
                vm.mesureConfig.visite_total.value = result["visite_total"]["value"];
                vm.mesureConfig.video_total.value = result["video_total"]["value"];
                vm.mesureConfig.visite_total.title = mesure_visite_total.title;
                vm.mesureConfig.video_total.title = mesure_video_total.title;
            },
            function () {
              vm.mesureConfig = {};
              vm.mesureConfig.visite_total = mesure_visite_total;
              vm.mesureConfig.video_total = mesure_video_total;
              vm.mesureConfig.visite_total.value = 0;
              vm.mesureConfig.video_total.value = 0;
              vm.mesureConfig.visite_total.title = mesure_visite_total.title;
              vm.mesureConfig.video_total.title = mesure_video_total.title;
            });
    }

    this.$onChanges = function (changes) {
        if (changes.query)
            stats_time_reel_now();
    };

    this.$onInit = function () {
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            $interval.cancel(timer);
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    this.$onDestroy = function () {
        $interval.cancel(timer);
        timer = undefined;
    }

}

function TimeReelNowVideoWidgetController($rootScope,mesure_widget_constant, statTimeReelService, $interval, podcast_constants) {
    var vm = this;
    var timer;
    var query_clone;
    vm.mesureConfig = {};
    vm.mesureConfig.loding_disabled = true;
    if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
    vm.stats_interval= $rootScope.stats_interval ?  ($rootScope.stats_interval * 1000) : 10000

  var poll = function () {
        timer = $interval(function () {
            stats_time_reel_now();
        }, vm.stats_interval);
    };

    function stats_time_reel_now() {
      var mesure_value;
        statTimeReelService.stats_time_reel_now(vm.query).then(
            function (result) {
                mesure_value = mesure_widget_constant[vm.type];
                if(vm.stat && vm.stat==='podcast'){
                  mesure_value = podcast_constants[vm.type];
                }
                vm.mesureConfig = mesure_value;
                vm.mesureConfig.value = result["video_total"]["value"];
                vm.mesureConfig.title = mesure_value.title;
                vm.mesureConfig.loding_disabled = true;
            },
            function () {
              vm.mesureConfig = mesure_value;
              vm.mesureConfig.value = 0;
              vm.mesureConfig.title = mesure_value.title;
              vm.mesureConfig.loding_disabled = true;
            });
    }

    this.$onChanges = function (changes) {
        if (changes.query)
            stats_time_reel_now();
    };

    this.$onInit = function () {
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            $interval.cancel(timer);
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    this.$onDestroy = function () {
        $interval.cancel(timer);
        timer = undefined;
    }

}

function TimeReelHeureWidgetController($rootScope, chartWidgetService, statTimeReelService, $log, $interval, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_audience";

    var timer;
    var query_clone;
    vm.chartConfig = chartWidgetService.chart_continu();
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    vm.chartConfig.loding_disabled = true;
    if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
    vm.exportChart= exportChart;
  vm.stats_interval= $rootScope.stats_interval ?  ($rootScope.stats_interval * 1000) : 10000
    var poll = function () {
        timer = $interval(function () {
            stats_time_reel_heure();
        }, vm.stats_interval);


    };

    function stats_time_reel_heure() {
        vm.chartConfig = chartWidgetService.chart_continu();
        statTimeReelService.stats_time_reel_heure(vm.query).then(
            function (result) {
              vm.showGraphBar = true;
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.duree_total_y_axis;
                vm.chartConfig.series[1].data = result.duree_moyenne_par_visiteur_y_axis;
                vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                vm.id_bar = "bar_time_reel_heure";
                vm.enabled = result.enabled;
            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    }

    this.$onChanges = function (changes) {
        if (changes.query)
            stats_time_reel_heure();
    };

    this.$onInit = function () {
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            $interval.cancel(timer);
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    this.$onDestroy = function () {
        $interval.cancel(timer);
        timer = undefined;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "time_reel_heure", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "time_reel_heure", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "time_reel_heure", vm.query);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        chart = data.filter(function (element) {
            return element.renderTo.id === "bar_time_reel_heure";
        });
        return chart[0];
    }

}

function TimeReelMinuteWidgetController($rootScope, chartWidgetService, statTimeReelService, $log, $timeout, $interval, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_audience";

    var timer;
    var query_clone;
    vm.chartConfig = chartWidgetService.chart_continu();
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    vm.chartConfig.loding_disabled = true;
    if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
    vm.exportChart= exportChart;
  vm.stats_interval= $rootScope.stats_interval ?  ($rootScope.stats_interval * 1000) : 10000
  var poll = function () {
        timer = $interval(function () {
            stats_time_reel_minute();

        }, vm.stats_interval);
    };

    function stats_time_reel_minute() {
        vm.chartConfig = chartWidgetService.chart_continu();
        statTimeReelService.stats_time_reel_minute(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.duree_total_y_axis;
                vm.chartConfig.series[1].data = result.duree_moyenne_par_visiteur_y_axis;
                vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                vm.id_bar = "bar_time_reel_minute";
                vm.enabled = result.enabled;

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    }

    this.$onChanges = function (changes) {
        if (changes.query)
            stats_time_reel_minute();
    };

    this.$onInit = function () {
        poll();
    };

    this.$doCheck = function () {

        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            $interval.cancel(timer);
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    this.$onDestroy = function () {
        $interval.cancel(timer);
        timer = undefined;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "time_reel_minute", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "time_reel_minute", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "time_reel_minute", vm.query);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        chart = data.filter(function (element) {
            return element.renderTo.id === "bar_time_reel_minute";
        });
        return chart[0];
    }

}




})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statMoocService', statMoocService);

    /** @ngInject */
    function statMoocService(msApi, $q, StatsFiltreQuery, $filter) {

        var self = this;
        self.query_mooc = [];
        self.result_mooc = [];
        self.query_mooc_video = [];
        self.result_mooc_video = [];
        self.query_mooc_quiz_by_theme = [];
        self.result_mooc_quiz_by_theme = [];
        self.query_mooc_performance = [];
        self.result_mooc_performance = [];
        self.query_mooc_datatable_themes = [];
        self.result_mooc_datatable_themes = [];
        self.query_mooc_view_by_voyage = [];
        self.result_mooc_view_by_voyage = [];
        self.query_mooc_expedition_by_voyage = [];
        self.result_mooc_expedition_by_voyage = [];
        self.query_mooc_excursion_by_voyage = [];
        self.result_mooc_excursion_by_voyage = [];
        var format={};
        format["1d"]="dd/MM/yyyy";
        format["1h"]="dd/MM/yyyyTHH";
        format["1w"]="dd/MM/yyyy";
        format["1M"]="MM/yyyy";
        function stats_mooc(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.participation@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc.push(item_query_audienc);
                            var resultat = getResult(res, query.range);
                            self.result_mooc.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_mooc_video(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_video, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_video[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.video@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_video.push(item_query_audienc);
                            var resultat = getResultVideos(res);
                            self.result_mooc_video.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function getHours(date){
            return date.substr(date.lastIndexOf("T")+1,2)
        }
        function stats_mooc_quiz_by_theme(query, idTheme) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_quiz_by_theme, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_quiz_by_theme[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.quizByTheme@save', {idTheme: idTheme, "empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_quiz_by_theme.push(item_query_audienc);
                            var resultat = getResultQuizByTheme(res);
                            self.result_mooc_quiz_by_theme.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_mooc_performance(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_performance, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_performance[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.responses@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_performance.push(item_query_audienc);
                            var resultat = getResultPerformance(res);
                            self.result_mooc_performance.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_datatable_themes(filtre, query) {
            filtre.dateIn = query.dateIn;
            filtre.dateOut = query.dateOut;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_datatable_themes, query);
            //    If we already have the name, we can resolve the promise.

            msApi.request(
                'parameters_theme_mooc.dtable@get', filtre,
                function (res) {
                    if (res.code === 200) {
                        var item_query_audienc = angular.copy(filtre_query.query);
                        self.query_mooc_datatable_themes.push(item_query_audienc);
                        var resultat = getResultThemes(res);
                        self.result_mooc_datatable_themes.push(resultat);
                        deferred.resolve(resultat);
                    }
                },
                function () {
                }
            );

            return deferred.promise;
        }

        function stats_mooc_view_by_voyage(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_view_by_voyage, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_view_by_voyage[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.views_travel@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_view_by_voyage.push(item_query_audienc);
                            var resultat = getResultViewsByVoyage(res);
                            self.result_mooc_view_by_voyage.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_mooc_expedition_by_voyage(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_expedition_by_voyage, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_expedition_by_voyage[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.expedition_travel@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_expedition_by_voyage.push(item_query_audienc);
                            var resultat = getResultExpeditionByVoyage(res);
                            self.result_mooc_expedition_by_voyage.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function stats_mooc_excursion_by_voyage(query) {
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mooc_excursion_by_voyage, query);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mooc_excursion_by_voyage[filtre_query.index]);
            } else {
                msApi.request(
                    'stats.mooc.excursion_travel@save', {"empStatsQuery": query},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mooc_excursion_by_voyage.push(item_query_audienc);
                            var resultat = getResultExpeditionByVoyage(res);
                            self.result_mooc_excursion_by_voyage.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function getResult(res, range) {
            var values = res.values;
            var device_x_axis = values.map(function (elm) {
                if (angular.isUndefined(elm["key"]))
                    return 0;
                var key=new Date(elm["key_as_string"]).toISOString()
                return  range==='1h' ?   $filter('date')(elm["key"], format["1d"] + "T"+getHours(key))
                    : $filter('date')(elm["key"], format["1d"])
            });
            var number_active_learners = values.map(function (elm) {
                try {
                    return elm["number_active_learners"]["value"];
                }
                catch (e) {
                    return 0;
                }
            });
            var numberLearnersTriedProblem = values.map(function (elm) {
                try {
                    return elm["numberLearnersTriedProblem"]["values"]["value"];
                }
                catch (e) {
                    return 0;
                }
            });
            var numberLearnersWatchingVideo = values.map(function (elm) {
                try {
                    return elm["numberLearnersWatchingVideo"][values]["value"];
                }
                catch (e) {
                    return 0;
                }
            });
            return {
                enabled: values.length > 0,
                numberActiveLearners: number_active_learners,
                numberLearnersTriedProblem: numberLearnersTriedProblem,
                numberLearnersWatchingVideo: numberLearnersWatchingVideo,
                device_x_axis: device_x_axis
            };
        }

        function getResultPerformance(res) {
            var values = res.values;
            var questions = res.questions;
            var correct = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value["group_by_event_object"]["buckets"][1]))
                    this.push(value["group_by_event_object"]["buckets"][1]["registrations_per_week"]["value"]);
            }, correct);
            var incorrect = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value["group_by_event_object"]["buckets"][0]))
                    this.push(value["group_by_event_object"]["buckets"][0]["registrations_per_week"]["value"]);
            }, incorrect);

            var device_x_axis = values.map(function (elm) {
                if (angular.isUndefined(elm["key"]))
                    return 0;
                var question = $filter('getByCoursesId')(questions, elm["key"]);
                if (question === null)
                    return elm["key"] + " question supprimée";
                else return $filter('cut')(question.course_id + " " + question.course_name, true, 25, "...");

            });

            return {
                enabled: values.length > 0,
                questions: device_x_axis,
                correct: correct,
                incorrect: incorrect
            };
        }

        function getResultThemes(res) {
            return {
                res: res
            };
        }

        function getResultVideos(res) {
            var values = res.values;
            var videos = res.videos;
            var complete = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value["group_by_event_object"]["buckets"][1]))
                    this.push(value["group_by_event_object"]["buckets"][1]["registrations_per_week"]["value"]);
            }, complete);
            var incomplete = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value["group_by_event_object"]["buckets"][0]))
                    this.push(value["group_by_event_object"]["buckets"][0]["registrations_per_week"]["value"]);
            }, incomplete);

            var device_x_axis = values.map(function (elm) {
                if (angular.isUndefined(elm["key"]))
                    return 0;
                var video = $filter('getByKey')(res.videos, elm["key"]);
                if (video === null)
                    return elm["key"] + " vidéo supprimée";
                else return $filter('cut')(video.id + " " + video.title, true, 25, "...");

            });

            return {
                enabled: values.length > 0,
                videos: device_x_axis,
                complete: complete,
                incomplete: incomplete
            };
        }

        function getResultQuizByTheme(res) {
            var values = res;
            var correct = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value.nb_correct))
                    this.push(value.nb_correct);
            }, correct);
            var incorrect = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value.nb_incorrect))
                    this.push(value.nb_incorrect);
            }, incorrect);

            var device_x_axis = [];
            angular.forEach(values, function (elm, key) {
                if (angular.isDefined(elm.title))
                    this.push(elm.title);

            }, device_x_axis);
            var ids = [];
            angular.forEach(values, function (elm, key) {
                if (angular.isDefined(elm.id))
                    this.push(elm.id);

            }, ids);

            return {
                enabled: angular.isDefined(values[0]),
                quiz: device_x_axis,
                correct: correct,
                incorrect: incorrect,
                ids: ids
            };
        }

        function getResultViewsByVoyage(res) {
            var values = res.themes_voyage;
            var views = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value.number_videos_seen))
                    this.push(value.number_videos_seen);
            }, views);
            var device_x_axis = [];
            angular.forEach(values, function (elm, key) {
                if (angular.isDefined(elm.title))
                    this.push(elm.title);

            }, device_x_axis);

            return {
                enabled: angular.isDefined(values[0]),
                voyage: device_x_axis,
                views: views
            };
        }

        function getResultExpeditionByVoyage(res) {
            var values = res.themes_expeditions;
            var expeditions = [];
            angular.forEach(values, function (value, key) {
                if (angular.isDefined(value.number_expeditions))
                    this.push(value.number_expeditions);
            }, expeditions);
            var device_x_axis = [];
            angular.forEach(values, function (elm, key) {
                if (angular.isDefined(elm.title))
                    this.push(elm.title);

            }, device_x_axis);

            return {
                enabled: angular.isDefined(values[0]),
                voyage: device_x_axis,
                expeditions: expeditions
            };
        }


        return {
            stats_mooc: stats_mooc,
            stats_mooc_performance: stats_mooc_performance,
            stats_mooc_video: stats_mooc_video,
            stats_mooc_quiz_by_theme: stats_mooc_quiz_by_theme,
            stats_datatable_themes: stats_datatable_themes,
            stats_mooc_view_by_voyage: stats_mooc_view_by_voyage,
            stats_mooc_expedition_by_voyage: stats_mooc_expedition_by_voyage,
            stats_mooc_excursion_by_voyage: stats_mooc_excursion_by_voyage

        };

    }
}());
(function () {
    'use strict';

    /** @ngInject */
    function config(msApiProvider) {
        msApiProvider.register('stats.mooc.responses', [Routing.generate('api_mooc_post_mooc_number_correct_incorrect_responses')]);
        msApiProvider.register('stats.mooc.participation', [Routing.generate('api_mooc_post_participation_of_learners')]);
        msApiProvider.register('stats.mooc.video', [Routing.generate('api_mooc_post_mooc_number_complete_incomplete_video')]);
        msApiProvider.register('stats.mooc.quizByTheme', [Routing.generate('api_mooc_post_mooc_quiz_themes_stats', {idTheme: ':idTheme'}).replace(/%3A/, ":"), {idTheme: '@idTheme'}]);
        msApiProvider.register('stats.mooc.views_travel', [Routing.generate('api_mooc_post_mooc_number_seen_videos_for_each_travel')]);
        msApiProvider.register('stats.mooc.expedition_travel', [Routing.generate('api_mooc_post_mooc_number_expeditions')]);
        msApiProvider.register('stats.mooc.excursion_travel', [Routing.generate('api_mooc_post_mooc_number_excursion')]);

    }

    angular.module('app.stats.graphe')
        .config(config)
        .run(fetchRights);


    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions;

            permissions = {
                pattern: "^(?=.*api)(?=.*mooc).*$",
                name_module: "stats_mooc",
                name_angular_module: "app.stats.mooc",
                actions: [{"moocNoModule": ["mooc_number_correct_incorrect_responses", "participation_of_learners", "mooc_number_complete_incomplete_video"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';
    var moocStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-widget.html',
        controller: MoocWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<'
        }
    };
    var moocViewsStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-widget.html',
        controller: MoocViewWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<'
        }
    };
    var moocPerformanceStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-widget.html',
        controller: MoocPerformanceWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<'
        }
    };
    var moocReplayedSegmentsStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-widget.html',
        controller: MoocReplayedSegmentsWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<'
        }
    };
    var datatableThemes = {
        templateUrl: 'app/main/stats/charts/components/ChartView/datatable-themes-widget.html',
        controller: DatatableThemesController,
        bindings: {
            // columns: '<',
            // options: '<',
            // instance: '<',
            query: '<'

        }
    };
    var quizByTheme = {
        templateUrl: 'app/main/stats/charts/components/ChartView/quiz-by-theme-widget.html',
        controller: QuizByThemeController,
        bindings: {

            query: '<'

        }
    };
    var moocStatsViewVoayge = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-views-voyage-widget.html',
        controller: ViewsVoyageController,
        bindings: {

            query: '<'

        }
    };
    var moocStatsExpeditionVoayge = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-expedition-voyage-widget.html',
        controller: ExpeditionVoyageController,
        bindings: {

            query: '<'

        }
    };
    var moocStatsExcursionVoayge = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mooc-expedition-voyage-widget.html',
        controller: ExcursionVoyageController,
        bindings: {

            query: '<'

        }
    };
    angular.module('app.stats.graphe')
        .component('moocStats', moocStats)
        .component('moocViewsStats', moocViewsStats)
        .component('moocPerformanceStats', moocPerformanceStats)
        .component('moocReplayedSegmentsStats', moocReplayedSegmentsStats)
        .component('datatableThemes', datatableThemes)
        .component('quizByTheme', quizByTheme)
        .component('moocStatsViewVoayge', moocStatsViewVoayge)
        .component('moocStatsExpeditionVoayge', moocStatsExpeditionVoayge)
        .component('moocStatsExcursionVoayge', moocStatsExcursionVoayge)
        .controller('MoocWidgetController', MoocWidgetController)
        .controller('MoocViewWidgetController', MoocViewWidgetController)
        .controller('MoocPerformanceWidgetController', MoocPerformanceWidgetController)
        .controller('MoocReplayedSegmentsWidgetController', MoocReplayedSegmentsWidgetController)
        .controller('DatatableThemesController', DatatableThemesController)
        .controller('QuizByThemeController', QuizByThemeController)
        .controller('ViewsVoyageController', ViewsVoyageController)
        .controller('ExpeditionVoyageController', ExpeditionVoyageController)
        .controller('ExcursionVoyageController', ExcursionVoyageController)


        .filter('getByCoursesId', function () {
            return function (input, id) {
                var i = 0, len = input.length;
                for (; i < len; i++) {
                    if (+input[i].course_id === +id) {
                        return input[i];
                    }
                }
                return null;
            }
        });

    function MoocWidgetController($rootScope, $injector, chartWidgetService, statMoocService) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        var query_clone;
        vm.chartConfig = chartWidgetService.chart_continu_mooc();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_continu_mooc();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.device_x_axis;
                    vm.chartConfig.series[0].data = result.numberActiveLearners;
                    vm.chartConfig.series[1].data = result.numberLearnersTriedProblem;
                    vm.chartConfig.series[2].data = result.numberLearnersWatchingVideo;
                    vm.chartConfig.loding_disabled = true;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    vm.chartConfig.title = {text: ''};
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };


        function view() {
            vm.showGraph = true;
        }


    }

    function MoocViewWidgetController($rootScope, $injector, chartWidgetService, statMoocService) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_view";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        var query_clone;
        vm.chartConfig = chartWidgetService.chart_continu_mooc_view();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_continu_mooc_view();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_video(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.videos;
                    vm.chartConfig.series[0].data = result.complete;
                    vm.chartConfig.series[1].data = result.incomplete;
                    vm.chartConfig.loding_disabled = true;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };


        function view() {
            vm.showGraph = true;
        }

    }

    function MoocPerformanceWidgetController($rootScope, $injector, chartWidgetService, statMoocService) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_performance";
        var $translate = $injector.get('$translate');
        vm.view = view;
        var query_clone;

        vm.chartConfig = chartWidgetService.chart_continu_mooc_performance();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_continu_mooc_performance();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_performance(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.questions;
                    vm.chartConfig.series[0].data = result.correct;
                    vm.chartConfig.series[1].data = result.incorrect;
                    vm.chartConfig.loding_disabled = true;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };
        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

        function view() {
            vm.showGraph = true;
        }

    }

    function MoocReplayedSegmentsWidgetController($rootScope,$injector, chartWidgetService) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_replayed_segments";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        var query_clone;
        vm.chartConfig = chartWidgetService.chart_area();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_area();
            vm.chartConfig.loding_disabled = false;
            vm.id = "bar_mooc_view";
            vm.enabled = true;
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };


        function view() {
            vm.showGraph = true;
        }

    }

    function DatatableThemesController($scope, $injector, DTOptionsBuilder, statMoocService, $cookies, DTColumnBuilder, $compile, webTvGlobal, order_theme, dtable_language, $rootScope, $translate, msApi) {
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var columnsApi = order_theme;

        vm.getElem = getElem;
        //Data Table options
        vm.themes = [];
        vm.selectedThemes = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.themesDataTable = {};
        vm.themesServerDataTable = {};
        vm.search_themes = "";
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    width: '20%',
                    targets: [0, 1, 2]
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 50, 100])
            .withOption('pagingType', 'simple')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('autoWidth', false)
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function getElem() {
            var element = document.querySelectorAll('md-checkbox.ng-scope.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObj = {"margin-left": leftDelete}
        }

        function searchThemesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('parameters_theme_mooc.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.themes = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.themes = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }


                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedThemes = [];
            checkedSelected = false;

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_themes,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            filtre.dateIn = vm.query.dateIn;
            filtre.dateOut = vm.query.dateOut;
            vm.fnCallback = fnCallback;

            poll();
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                return angular.isDefined(data.startDate) && data.startDate ? moment(data.startDate).format("DD-MM-YYYY") : "";
            }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                return angular.isDefined(data.endDate) && data.endDate ? moment(data.endDate).format("DD-MM-YYYY") : "";
            }),
            DTColumnBuilder.newColumn('total_registrations').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : 0;
            }),
            DTColumnBuilder.newColumn('ongoing_registrations_theme').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : 0;
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.themesDataTable[data.id] = data;
                    var buttonActionStatsHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_video_stats'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button  class="m16 delete-button md-icon-button" ui-sref="app.stats_mooc_theme({id: ' + data.id + '})" aria-label="action_stats"translate translate-attr-aria-label="MESSAGES.action_video_stats">' +
                        '<md-icon  md-font-icon="icon-chart-bar" class="s18"></md-icon>' +
                        ' </md-button>';

                    return buttonActionStatsHtml;

                })
        ];

        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.isChecked = isChecked;
        vm.isIndeterminate = isIndeterminate;
        vm.exist = exist;
        vm.retour = retour;

        $rootScope.rerender = rerender;
        vm.searchThemes = searchThemes;

        /**
         * @param theme
         */
        function toggle(theme, list) {
            getElem();
            var idx = list.indexOf(theme);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(theme);
            }
        }

        /**
         * @param theme
         */
        function exist(theme, list) {
            return list.indexOf(theme) > -1;
        }

        function isIndeterminate() {
            return (vm.selectedThemes.length !== 0 && vm.selectedThemes.length !== vm.themes.length);
        }

        retour();

        function retour() {
            $rootScope.pageRetour = "app.stats_mooc.course";
        }

        function isChecked() {
            return (vm.selectedThemes.length === vm.themes.length) && (vm.selectedThemes.length > 0);
        }

        function toggleAll() {
            getElem();

            if (vm.selectedThemes.length === vm.themes.length) {
                vm.selectedThemes = [];
            }
            else if ((vm.selectedThemes.length === 0) || (vm.selectedThemes.length > 0)) {
                vm.selectedThemes = vm.themes.slice(0);

            }
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(poll(), true);
        }

        /**
         *  call the api
         */
        function searchThemes() {
            filtre["search[value]"] = vm.search_themes;
            poll();
        }

        function getQuery() {

            var query_service = angular.copy(query);
            return query_service;
        }

        var poll = function () {
            statMoocService.stats_datatable_themes(filtre, vm.query).then(
                function (result) {
                    var records = {};
                    if (result.res.code === 200) {
                        records = {
                            'draw': result.res.draw,
                            'recordsTotal': result.res.recordsTotal,
                            'recordsFiltered': result.res.recordsFiltered,
                            'data': result.res.data
                        };

                        vm.themes = result.res.data;
                        vm.fnCallback(records);
                    }

                },
                function () {

                });
        };
        var query_clone;
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            // poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };
    }

    function QuizByThemeController($injector, chartWidgetService, statMoocService, $state, TableWidgetService, $rootScope) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_quiz_theme";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        vm.viewInTable = viewInTable;
        vm.click = click;
        var query_clone;

        function click(row) {
            $rootScope.returnToQuiz = $state.params.id;
            $state.go('app.stats_mooc_persons', {id: row[0].id});


        }

        vm.chartConfig = chartWidgetService.chart_quiz_by_theme_mooc();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_quiz_by_theme_mooc();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_quiz_by_theme(vm.query, $state.params.id).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.quiz;
                    vm.chartConfig.series[0].data = result.correct;
                    vm.chartConfig.series[1].data = result.incorrect;
                    vm.chartConfig.loding_disabled = true;
                    vm.chartConfig.ids = result.ids;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

        function viewInTable() {

            vm.showGraph = false;
            vm.showGraphTable = true;
            vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, "Quiz", vm.chartConfig.ids);

        }


        function view() {
            vm.showGraph = true;
            vm.showGraphTable = false;
        }


    }

    function ViewsVoyageController($injector, chartWidgetService, statMoocService, $state, TableWidgetService, $rootScope) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_quiz_theme";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        vm.viewInTable = viewInTable;

        var query_clone;

        vm.chartConfig = chartWidgetService.chart_view_by_voyage_mooc();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_view_by_voyage_mooc();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_view_by_voyage(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.voyage;
                    vm.chartConfig.series[0].data = result.views;
                    vm.chartConfig.loding_disabled = true;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

        function viewInTable() {

            vm.showGraph = false;
            vm.showGraphTable = true;
            vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, "Thème", "theme");

        }


        function view() {
            vm.showGraph = true;
            vm.showGraphTable = false;
        }


    }

    function ExpeditionVoyageController($injector, chartWidgetService, statMoocService, $state, TableWidgetService, $rootScope) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_quiz_theme";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        vm.viewInTable = viewInTable;

        var query_clone;


        vm.chartConfig = chartWidgetService.chart_expedition_by_voyage_mooc();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_expedition_by_voyage_mooc();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_expedition_by_voyage(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.voyage;
                    vm.chartConfig.series[0].data = result.expeditions;
                    vm.chartConfig.loding_disabled = true;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

        function viewInTable() {

            vm.showGraph = false;
            vm.showGraphTable = true;
            vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, "Thème", "theme");

        }


        function view() {
            vm.showGraph = true;
            vm.showGraphTable = false;
        }


    }

    function ExcursionVoyageController($injector, chartWidgetService, statMoocService, $state, TableWidgetService, $rootScope) {
        var vm = this;
        vm.chart_title = "MOOCWIDGETSTATS.stat_mooc_quiz_theme";
        var $translate = $injector.get('$translate');

        //function
        vm.view = view;
        vm.viewInTable = viewInTable;

        var query_clone;


        vm.chartConfig = chartWidgetService.chart_expedition_by_voyage_mooc();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.chartConfig = chartWidgetService.chart_expedition_by_voyage_mooc();
            vm.chartConfig.loding_disabled = false;
            statMoocService.stats_mooc_excursion_by_voyage(vm.query).then(
                function (result) {
                    vm.chartConfig.xAxis.categories = result.voyage;
                    vm.chartConfig.series[0].data = result.expeditions;
                    vm.chartConfig.loding_disabled = true;
                    vm.id = "bar_mooc_view";
                    vm.enabled = result.enabled;
                    vm.chartConfig.legend = {align: 'center', verticalAlign: 'bottom', borderWidth: 0};
                    Highcharts.setOptions({lang: {resetZoom: $translate.instant('VISITSMESURESTATS.stat_reset_zoom')}})

                },
                function () {
                    vm.chartConfig.loding_disabled = true;
                    vm.enabled = false;
                });
        };
        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            vm.view();
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

        function viewInTable() {

            vm.showGraph = false;
            vm.showGraphTable = true;
            vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, "Thème", "theme");

        }


        function view() {
            vm.showGraph = true;
            vm.showGraphTable = false;
        }


    }


})();
(function () {
  'use strict';

  angular
    .module('app.stats.graphe')
    .factory('statsEngagementService', statsEngagementService);

  /** @ngInject */
  function statsEngagementService(msApi, $q, $filter, StatsFiltreQuery,timeHelperService, userManager) {


    var self = this;
    //    Initially the name is unknown....
    self.query_duree_visite = [];
    self.result_duree_visite = [];

    self.query_most_popular = [];
    self.result_most_popular = [];

    self.query_ip_visite = [];
    self.result_ip_visite = [];
    //////////

    var user = userManager.getUser();
    var channels= (function (list, data) {
      if (angular.isDefined(data)) {
        for (var i = 0; i < data.length; i++) {
          list.push(data[i].id);
        }
      }
      return list;
    })([], user.channels);

    function stats_duree_visite(query) {
      var empStatsQuery = angular.copy(query);
      delete empStatsQuery.range;
      var deferred = $q.defer();
      var filtre_query = StatsFiltreQuery.filtre_query(self.query_duree_visite, empStatsQuery);
      //    If we already have the name, we can resolve the promise.
      if (filtre_query.index !== -1) {
        deferred.resolve(self.result_duree_visite[filtre_query.index]);
      } else {
          if (!empStatsQuery.canal){
            empStatsQuery.canal=channels.join(',');
          }
        msApi.request(
          'stats.duree_visite@save', {"empStatsQuery" : empStatsQuery},
          function (res) {
            if (res.code === 200) {
              var item_query = angular.copy(filtre_query.query);
              self.query_duree_visite.push(item_query);
              var resultat = getResultDureePerVisite(res);
              self.result_duree_visite.push(resultat);
              deferred.resolve(resultat);
            }
          },
          function () {
          }
        );
      }
      return deferred.promise;
    }

    function stats_most_popular(query, stat) {
      var empStatsQuery = angular.copy(query);
      delete empStatsQuery.range;

      var deferred = $q.defer();
      var filtre_query = StatsFiltreQuery.filtre_query(self.query_most_popular, empStatsQuery);

      //    If we already have the name, we can resolve the promise.
      if (filtre_query.index !== -1) {
        deferred.resolve(self.result_most_popular[filtre_query.index]);

      } else {
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
        msApi.request(
          'stats.most_popular@save', {"empStatsQuery" : empStatsQuery},
          function (res) {
            if (res.code === 200) {
              var item_query = angular.copy(filtre_query.query);
              self.query_most_popular.push(item_query);
              var resultat = getResult(res, stat);
              self.result_most_popular.push(resultat);
              deferred.resolve(resultat);
            }
          },
          function () {
          }
        );
      }
      return deferred.promise;
    }

    function stats_visits_per_ip(query) {
      var empStatsQuery = angular.copy(query);
      delete empStatsQuery.range;
      var deferred = $q.defer();
      var filtre_query = StatsFiltreQuery.filtre_query(self.query_ip_visite, empStatsQuery);

      //    If we already have the name, we can resolve the promise.
      if (filtre_query.index !== -1) {
        deferred.resolve(self.result_ip_visite[filtre_query.index]);

      } else {
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
        msApi.request(
          'stats.visits_ip@save', {"empStatsQuery" : empStatsQuery},
          function (res) {
            if (res.code === 200) {
              var item_query = angular.copy(filtre_query.query);
              self.query_ip_visite.push(item_query);
              var resultat = getResultVistsPerIP(res);
              self.result_ip_visite.push(resultat);
              deferred.resolve(resultat);
            }
          },
          function () {
          }
        );
      }
      return deferred.promise;
    }


    function getResultDureePerVisite(res) {
      var values = res.values;
      var x_axis = Object.keys(values);
      var device_x_axis = Object.keys(values).map(function (key) {
        try {
          if (key > 0)
            return timeHelperService.calc_time_unite(key)+"-"+timeHelperService.calc_time_unite(parseInt(key)+30);
          else if(key == 0)
            return "0s"+"-"+timeHelperService.calc_time_unite(parseInt(key)+30);
          else return (key);

        }
        catch (e) {
          return 0;
        }

      });
      var visite_y_axis = Object.keys(values).map(function (key) {
        try {
          return {
            y: values[key],
            percent: (values[key] / res.nombre_visite_totale) * 100,
            percentage: (values[key] / res.nombre_visite_totale) * 100
          };
        }
        catch (e) {
          return 0;
        }

      });

      var pourcentage_y_axis = Object.keys(values).map(function (key) {
        try {
          return (values[key] / res.nombre_visite_totale) * 100;
        }
        catch (e) {
          return 0;
        }

      });

      return {
        x_axis: x_axis,
        device_x_axis: device_x_axis,
        visite_y_axis: visite_y_axis,
        pourcentage_y_axis: pourcentage_y_axis,
        enabled: x_axis.length > 0
      };

    }

    function getResult(res, stat) {
      var values = res.values;

      var visite_y_axis = values.map(function (elm) {
        try {
          return elm["visite_total"]["value"];
        }
        catch (e) {
          return 0;
        }
      });
      var visiteur_unique_y_axis = values.map(function (elm) {
        if (angular.isUndefined(elm["visite_unique"]["value"]))
          return 0;
        return elm["visite_unique"]["value"];
      });
      var nombre_vue_visiteur_y_axis = values.map(function (elm) {
        var nombre_vue_visiteur = 0;
        if (angular.isUndefined(elm["visite_total"]["value"]) || angular.isUndefined(elm["visite_unique"]["value"]))
          return 0;
        if (elm["visite_unique"]["value"] !== 0)
          nombre_vue_visiteur = (elm["visite_total"]["value"] / elm["visite_unique"]["value"]);
        return nombre_vue_visiteur;
      });
      var duree_moyenne_par_visiteur_y_axis = values.map(function (elm) {
        var pourcenta = 0;
        try {
          if (elm["duree"]["visite_unique"]["value"] !== 0)
            pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_unique"]["value"]);
        }
        catch (e) {
          return 0;
        }
        return pourcenta;
      });
      var duree_moyenne_par_visite_y_axis = values.map(function (elm) {
        var pourcenta = 0;
        try {
          if (elm["duree"]["visite_total"]["value"] !== 0)
            pourcenta = (elm["duree"]["duree_sum"]["value"] / elm["duree"]["visite_total"]["value"]);
        }
        catch (e) {
          return 0;
        }
        return pourcenta;
      });
      var duree_total_y_axis = values.map(function (elm) {
        try {
          return elm["duree"]["duree_sum"]["value"];
        }
        catch (e) {
          return 0;
        }
      });


      var device_x_axis = values.map(function (elm) {
        if (angular.isUndefined(elm["key"]))
          return 0;
        var video = $filter('getByKey')(res.videos, elm["key"]);
        if (video === null){
          var suppText=" vidéo supprimée";
          if(stat && stat==='podcast'){
             suppText=" podcast supprimé";
          }
          return elm["key"] + suppText
        }
        else return $filter('cut')(video.id + " " + video.title, true, 25, "...");

      });

      return {
        device_x_axis: device_x_axis,
        visite_y_axis: visite_y_axis,
        visiteur_unique_y_axis: visiteur_unique_y_axis,
        nombre_vue_visiteur_y_axis: nombre_vue_visiteur_y_axis,
        duree_moyenne_par_visiteur_y_axis: duree_moyenne_par_visiteur_y_axis,
        duree_moyenne_par_visite_y_axis: duree_moyenne_par_visite_y_axis,
        duree_total_y_axis: duree_total_y_axis,
        enabled: values.length > 0
      };

    }

    function getResultVistsPerIP(res) {
      var enabled =0;
      var visite_y_axis = [];
      var visiteur_unique_y_axis = [];
      var nombre_vue_visiteur_y_axis = [];
      var duree_moyenne_par_visiteur_y_axis = [];
      var duree_moyenne_par_visite_y_axis = [];
      var duree_total_y_axis = [];
      var device_x_axis = [];

      angular.forEach(res.values, function (value, key) {
        enabled += value.visite_total.value;
        visite_y_axis.push(value.visite_total.value);
        visiteur_unique_y_axis.push(value.visite_unique.value);
        nombre_vue_visiteur_y_axis.push(value.visite_total.value / value.visite_unique.value);
        duree_moyenne_par_visiteur_y_axis.push(value.duree.duree_sum.value / value.duree.visite_unique.value);
        duree_moyenne_par_visite_y_axis.push(value.duree.duree_sum.value / value.duree.visite_total.value);
        duree_total_y_axis.push(value.duree.duree_sum.value);
        device_x_axis.push(key);
      });


      return {
        device_x_axis: device_x_axis,
        visite_y_axis: visite_y_axis,
        visiteur_unique_y_axis: visiteur_unique_y_axis,
        nombre_vue_visiteur_y_axis: nombre_vue_visiteur_y_axis,
        duree_moyenne_par_visiteur_y_axis: duree_moyenne_par_visiteur_y_axis,
        duree_moyenne_par_visite_y_axis: duree_moyenne_par_visite_y_axis,
        duree_total_y_axis: duree_total_y_axis,
        enabled: enabled > 0
      };

    }

    return {
      stats_duree_visite: stats_duree_visite,
      stats_most_popular: stats_most_popular,
      stats_visits_per_ip: stats_visits_per_ip

    };

  }
}());

(function ()
{
    'use strict';

/** @ngInject */
function config(msApiProvider)
{
    // Api
    msApiProvider.register('stats.duree_visite',  [Routing.generate('api_engagement_post_duree_per_visite')]);
    msApiProvider.register('stats.most_popular',  [Routing.generate('api_engagement_post_most_popular')]);
    msApiProvider.register('stats.visits_ip',  [Routing.generate('api_engagement_post_visits_per_ip')]);

}

angular.module('app.stats.graphe')
    .config(config)
    .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*engagement).*$",
                name_module: "stats_engagement",
                name_angular_module: "app.stats.graphe",
                actions: ["duree_per_visite", "most_popular", "visits_per_ip"]
            };
            msRights.setPermissionsStats(permissions);
        }
    }
})();

(function ()
{
    'use strict';
    var dureeVisiteStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: DureeVisiteWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<'
        }
    };

var mostPopularStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: MostPopularWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<',
            stat: '@'
        }
    };

var visitsIpStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: VisitsPerIpWidgetController,
        bindings: {
            chartConfig: '<',
            query: '<',
            stat: '@'
        }
    };


angular.module('app.stats.graphe')
    .component('dureeVisiteStats', dureeVisiteStats)
    .component('mostPopularStats', mostPopularStats)
    .component('visitsIpStats', visitsIpStats)
    .controller('DureeVisiteWidgetController', DureeVisiteWidgetController)
    .controller('MostPopularWidgetController', MostPopularWidgetController)
    .controller('VisitsPerIpWidgetController', VisitsPerIpWidgetController)
    .filter('getByKey', function () {
        return function (input, id) {
            var i = 0, len = input.length;
            for (; i < len; i++) {
                if (+input[i].id === +id) {
                    return input[i];
                }
            }
            return null;
        }
    })
    .filter('cut', function () {
        return function (value, wordwise, max, tail) {
            if (!value) return '';

            max = parseInt(max, 10);
            if (!max) return value;
            if (value.length <= max) return value;

            value = value.substr(0, max);
            if (wordwise) {
                var lastspace = value.lastIndexOf(' ');
                if (lastspace !== -1) {
                    //Also remove . and , so its gives a cleaner result.
                    if (value.charAt(lastspace - 1) === '.' || value.charAt(lastspace - 1) === ',') {
                        lastspace = lastspace - 1;
                    }
                    value = value.substr(0, lastspace);
                }
            }

            return value + (tail || ' …');
        };
    });

function DureeVisiteWidgetController($rootScope,chartWidgetService, TableWidgetService, statsEngagementService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stat_duree_moyenne_visualisation";
    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title= "DURÉE DE LA VISITE";
    var xAxis;
    var query_clone;
    //

    vm.chartConfig = chartWidgetService.chart_discret_duree_par_visite();
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret_duree_par_visite();
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsEngagementService.stats_duree_visite(vm.query).then(
            function (result) {
                xAxis = result.x_axis;
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.visite_y_axis;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_duree_visite";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;
        vm.graphe = TableWidgetService.getTablePercentage(vm.chartConfig.series, xAxis, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.id_pie = "pie_duree_visite";
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        getPieBySeriesId(0);
    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories, true);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "duree_visite", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "duree_visite", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "duree_visite", vm.query, vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_duree_visite";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_duree_visite";
            });
        }
        return chart[0];
    }

}

function MostPopularWidgetController($rootScope,chartWidgetService, TableWidgetService, statsEngagementService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stats_most_popular_videos";
  if(vm.stat && vm.stat==='podcast'){
    vm.chart_title ='VISITSWIDGETSTATS.stats_most_popular_podcasts';
  }
    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title= "Nom de la vidéo";
    var query_clone;
    //
    var type='stats_most_popular_videos'
    vm.chartConfig = chartWidgetService.chart_discret(type);
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret(type);
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsEngagementService.stats_most_popular(vm.query, vm.stat).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                    vm.chartConfig.series[0].data = result.duree_total_y_axis;
                    // vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                    // vm.chartConfig.series[1].data = result.duree_total_y_axis;
                    // vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                    // vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                    // vm.chartConfig.series[4].data = result.visite_y_axis;
                    // vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_most_popular";
            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });


    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;
        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_most_popular";
        getPieBySeriesId(0);
    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "most_popular", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "most_popular", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "most_popular", vm.query,vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_most_popular";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_most_popular";
            });
        }
        return chart[0];
    }

}

function VisitsPerIpWidgetController($rootScope,chartWidgetService, TableWidgetService, statsEngagementService, exportChartService) {
    var vm = this;
    vm.chart_title ="VISITSWIDGETSTATS.stats_visits_per_ip";
    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
    vm.exportChart= exportChart;
    vm.title= "adresse IP";
    //
    var query_clone;
    vm.chartConfig = chartWidgetService.chart_discret();
    $rootScope.$on('$translateChangeSuccess', function () {
        poll()
    });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_discret();
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statsEngagementService.stats_visits_per_ip(vm.query).then(
            function (result) {
                vm.chartConfig.xAxis.categories = result.device_x_axis;
                vm.chartConfig.series[0].data = result.nombre_vue_visiteur_y_axis;
                vm.chartConfig.series[1].data = result.duree_total_y_axis;
                vm.chartConfig.series[2].data = result.duree_moyenne_par_visite_y_axis;
                vm.chartConfig.series[3].data = result.duree_moyenne_par_visiteur_y_axis;
                vm.chartConfig.series[4].data = result.visite_y_axis;
                vm.chartConfig.series[5].data = result.visiteur_unique_y_axis;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_visite_ip";
            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });


    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;
        vm.graphe = TableWidgetService.getTable(vm.chartConfig.series, vm.chartConfig.xAxis.categories, vm.title);
    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.chartConfig.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        vm.id_pie = "pie_visite_ip";
        getPieBySeriesId(0);
    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.chartConfig.series[id].data, vm.chartConfig.xAxis.categories);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

    function exportChart(type_export) {
        var chart = getChart();
        if(chart) {
            if (type_export == "pdf") {
                exportChartService.exportPdf(chart, "visite_ip", vm.query);
            } else if (type_export == "image") {
                exportChartService.exportImage(chart, "visite_ip", vm.query);
            } else if (type_export == "excel") {
                exportChartService.exportExcel(chart, "visite_ip", vm.query,vm.title);
            }
        }
    }

    function getChart() {
        var data = Highcharts.charts.filter(function (element) {
            return element !== undefined;
        });
        var chart;
        if (vm.showGraphPie) {
            chart = data.filter(function (element) {
                return element.renderTo.id === "pie_visite_ip";
            });
        }
        else {
            chart = data.filter(function (element) {
                return element.renderTo.id === "bar_visite_ip";
            });
        }
        return chart[0];
    }


}


})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statMesureService', statMesureService);

    /** @ngInject */
    function statMesureService(msApi, $q, $timeout, StatsFiltreQuery, userManager,$http,$cookies,$injector) {


        var self = this;
        self.time_out = false;
        self.time_out_by_ip = false;
        //    Initially the name is unknown....
        self.query_mesure = [];
        self.result_mesure = [];
        self.hasStatsPlayers=false;
        self.hasStatsPlayerById=false;
        self.query_mesure_mooc_total = [];
        self.result_mesure_mooc_total = [];

        self.query_mesure_mooc_ongoing = [];
        self.result_mesure_mooc_ongoing = [];

        self.query_mesure_actif_learners = [];
        self.result_mesure_actif_learners = [];

        self.query_mesure_video_watcher = [];
        self.result_mesure_video_watcher = [];

        self.query_mesure_problem_tester = [];
        self.result_mesure_problem_tester = [];

        self.query_mesure_mooc_increase = [];
        self.result_mesure_mooc_increase = [];

        self.query_mesure_by_ip = [];
        self.result_mesure_by_ip = [];

        self.query_mesure_taux_rebond = [];
        self.result_mesure_taux_rebond = [];

        self.query_mesure_standard_deviation = [];
        self.result_mesure_standard_deviation = [];

        self.query_mesure_persons_passport = [];
        self.result_mesure_persons_passport = [];

        self.query_mesure_views_passport = [];
        self.result_mesure_views_passport = [];

        self.query_mesure_visas_person = [];
        self.result_mesure_visas_person = [];

        self.query_mesure_expedition_person = [];
        self.result_mesure_expedition_person = [];
        var $state = $injector.get('$state');

        var user = userManager.getUser();
        var channels= (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);
        //////////


        function stats_mesure_taux_rebond(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
          var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_taux_rebond, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_taux_rebond[filtre_query.index]);
            } else {

                msApi.request(
                    'stats.taux.rebond@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_taux_rebond.push(item_query_audienc);
                            var resultat = {taux_rebond: "0%"};
                            if (res.values.visit_unique > 0) {
                                resultat = {taux_rebond: ((res.values.taux_rebond / res.values.visit_unique) * 100).toFixed(2) + "%"};
                            }
                            self.result_mesure_taux_rebond.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );

            }
            return deferred.promise;
        }

        function stats_mesure_by_ip(query) {
            var empStatsQuery = angular.copy(query);
            if (!empStatsQuery.canal){
                empStatsQuery.canal=channels.join(',');
              }
          delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_by_ip, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_by_ip[filtre_query.index]);
                self.time_out_by_ip = false;
                return deferred.promise;
            } else if (!self.time_out_by_ip) {
                self.time_out_by_ip = true;

                msApi.request(
                    'stats.mesure.by.ip@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_by_ip.push(item_query_audienc);
                            var resultat = getResultMesureByIp(res);
                            self.result_mesure_by_ip.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }
            else {
                return asyncFunc().then(function () {
                    return stats_mesure_by_ip(query);
                });
            }

        }

        function stats_mesure(query) {
            var empStatsQuery = angular.copy(query);
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
          delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure[filtre_query.index]);
                self.time_out = false;
                return deferred.promise;
            } else if (!self.time_out) {
                self.time_out = true;
                msApi.request(
                    'stats.mesure@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure.push(item_query_audienc);
                            var resultat = getResult(res);
                            self.result_mesure.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }
            else {
                return asyncFunc().then(function () {
                    return stats_mesure(query);
                });
            }

        }

        function stats_mesure_player(query){
            /** todo integrate api number loads/bue per user **/
            var empStatsQuery = angular.copy(query);
            empStatsQuery.canal=parseInt(channels.join(','));
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure, empStatsQuery);
            //    If we already have the name, we can resolve the promise.
            var route='stats-numbers/';
            if($state.current.name.indexOf("stats_vod_by_id")>0){
                route ='stats-numbers/'+empStatsQuery.vod_id;
            }else if($state.current.name.indexOf("stats_vods")>0){
                route='stats-numbers-all';
            }
            if (filtre_query.index !== -1 && $state.current.name.indexOf("stats_vod_by_id")>0) {
                deferred.resolve(self.result_mesure[filtre_query.index]);
                 self.hasStatsPlayerById = false;
                 self.hasStatsPlayers = true;
                return deferred.promise;
            } else   if (filtre_query.index !== -1 && $state.current.name.indexOf("stats_vods")>0) {
                deferred.resolve(self.result_mesure[filtre_query.index]);
                 self.hasStatsPlayerById = true;
                 self.hasStatsPlayers= false;

                return deferred.promise;
            } else  if (!self.hasStatsPlayers ) {
                self.hasStatsPlayers = true;
                self.hasStatsPlayerById = true;
                apiStats&&callStatsPlayerApi(deferred,route,empStatsQuery,filtre_query)
                return deferred.promise;
            }else  if (!self.hasStatsPlayerById ) {
                self.hasStatsPlayers = true;
                self.hasStatsPlayerById = true;
                apiStats&&callStatsPlayerApi(deferred,route,empStatsQuery,filtre_query)
                return deferred.promise;
            }
            else {
                return asyncFunc().then(function () {
                    return stats_mesure_player(query);
                });
            }
        }
        function callStatsPlayerApi(deferred,route,empStatsQuery,filtre_query){
            $http({
                url: apiStats + route,
                method: "POST",
                data:empStatsQuery,
                body:empStatsQuery,
                Origin:window.location.origin,
                headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

            }).then(function (res) {
                if (res.status === 200 || res.data.code===200) {
                    var item_query_audienc = angular.copy(filtre_query.query);
                    self.query_mesure.push(item_query_audienc);
                    var resultat = getResultPlayer(res);
                    self.result_mesure.push(resultat);
                    deferred.resolve(resultat);
                }
            }).catch(function (error) {
                console.log('error-----',error)
            });
        }
        function stats_mesure_mooc(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_mooc_total, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_mooc_total[filtre_query.index]);
                return deferred.promise;
            } else {
                msApi.request(
                    'stats.mooc.total.number.registrations@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_mooc_total.push(item_query_audienc);
                            var resultat = getResultMooc(res);
                            self.result_mesure_mooc_total.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }
        }

        function stats_mesure_mooc_ongoing_registrations(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_mooc_ongoing, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_mooc_ongoing[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number.ongoing.registrations@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_mooc_ongoing.push(item_query_audienc);
                            var resultat = getResultMoocOnGoingRegistrations(res);
                            self.result_mesure_mooc_ongoing.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_actif_learners(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_actif_learners, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_actif_learners[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number.active_learners@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            {
                                var item_query_audienc = angular.copy(filtre_query.query);
                                self.query_mesure_actif_learners.push(item_query_audienc);
                                var resultat = getResultActifLearners(res);
                                self.result_mesure_actif_learners.push(resultat);
                                deferred.resolve(resultat);
                            }
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_video_watcher(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_video_watcher, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_video_watcher[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number.watching_videos@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_video_watcher.push(item_query_audienc);
                            var resultat = getResultVideoWatcher(res);
                            self.result_mesure_video_watcher.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_problem_tester(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_problem_tester, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_problem_tester[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number.problem_tester@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_problem_tester.push(item_query_audienc);
                            var resultat = getResultProblemTester(res);
                            self.result_mesure_problem_tester.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_persons_passport(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_persons_passport, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_persons_passport[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number_users_passport@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_persons_passport.push(item_query_audienc);
                            var resultat = getResultPersonsPassport(res);
                            self.result_mesure_persons_passport.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_views_passport(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_views_passport, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_views_passport[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number_views_passport@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {

                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_views_passport.push(item_query_audienc);
                            var resultat = getResultViewsPassport(res);
                            self.result_mesure_views_passport.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_visas_person(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_visas_person, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_visas_person[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number_visas_users@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {

                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_visas_person.push(item_query_audienc);
                            var resultat = getResultVisasPersons(res);
                            self.result_mesure_visas_person.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_mooc_expedition_person(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_expedition_person, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_expedition_person[filtre_query.index]);
                return deferred.promise;
            } else {

                msApi.request(
                    'stats.mooc.number_views_passport@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {

                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_expedition_person.push(item_query_audienc);
                            var resultat = getResultExpeditionPersons(res);
                            self.result_mesure_expedition_person.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }


        function stats_mesure_mooc_increase_registrations_in_last_week(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_mooc_increase, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_mooc_increase[filtre_query.index]);
                return deferred.promise;
            } else {
                msApi.request(
                    'stats.mooc.increase.registrations@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_mooc_increase.push(item_query_audienc);
                            var resultat = getResultMoocIncreaseRegistrationsInLastWeek(res);
                            self.result_mesure_mooc_increase.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
                return deferred.promise;
            }

        }

        function stats_mesure_standard_deviation(query) {
            var empStatsQuery = angular.copy(query);
            if (!empStatsQuery.canal){
              empStatsQuery.canal=channels.join(',');
            }
          delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query = StatsFiltreQuery.filtre_query(self.query_mesure_standard_deviation, empStatsQuery);
            //    If we already have the name, we can resolve the promise.

            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_mesure_standard_deviation[filtre_query.index]);
                self.time_out = false;

            } else {
                self.time_out = true;

                msApi.request(
                    'stats.standard.deviation@save', {"empStatsQuery": empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var values = res.values;
                            var item_query_audienc = angular.copy(filtre_query.query);
                            self.query_mesure_standard_deviation.push(item_query_audienc);
                            var ecart_type = 0;
                            try {
                                ecart_type = (values["ecart_type"]["value"]);
                            }
                            catch (e) {
                            }
                            var resultat = {ecart_type: convertSeconds(ecart_type)};
                            self.result_mesure_standard_deviation.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }

            return deferred.promise;
        }

        function asyncFunc() {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, 100);

            return deferred.promise;
        }

        function convertSeconds(totalSeconds) {
            const result = new Date( Math.floor((totalSeconds * 1000 )/60)).toISOString().slice(11, 19);
            return result;
            // var hours = Math.floor(totalSeconds / 3600);
            // totalSeconds %= 3600;
            // var minutes = Math.floor(totalSeconds / 60);
            // var seconds = totalSeconds % 60;
            // return hours + ':' + ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2);
        }

        /* type = nombre_video ||
         visite_total ||
         visite_unique ||
         nombre_vue_par_visiteur ||
         nombre_vue_par_video||
         duree_total ||
         duree_moyenne_par_visiteur ||
         duree_moyenne_par_visite ||
         duree_moyenne_par_video ||
         */

        function getResult(res) {
            var values = res.values;
            var nombre_video = 0;
            var visite_total = 0;
            var visite_unique = 0;
            var nombre_vue_par_video = 0;
            var nombre_vue_par_visiteur = 0;

            var duree_total = 0;
            var duree_moyenne_par_visiteur = 0;
            var duree_moyenne_par_visite = 0;
            var duree_moyenne_par_video = 0;

            /********Mesure statistique des visites************/
            try {
                nombre_video = values["visite"]["videos_vue"]["value"];
            }
            catch (e) {
            }
            try {
                visite_total = values["visite"]["visite_total"]["value"];
            }
            catch (e) {
            }

            try {
                visite_unique = values["visite"]["visite_unique"]["value"];
            }
            catch (e) {
            }

            try {
                if (visite_unique !== 0)
                    nombre_vue_par_visiteur = visite_total / visite_unique;
            }
            catch (e) {
            }

            try {
                if (nombre_video !== 0)
                    nombre_vue_par_video = visite_total / nombre_video;
            }
            catch (e) {
            }


            /********Mesure statistique des durées************/

            try {
                duree_total = values["duree"]["duree_sum"]["value"];
            }
            catch (e) {
            }

            try {
                if (values["duree"]["visite_unique"]["value"] !== 0)
                    duree_moyenne_par_visiteur = (values["duree"]["duree_sum"]["value"] / values["duree"]["visite_unique"]["value"]);
            }
            catch (e) {
            }

            try {
                if (values["duree"]["visite_total"]["value"] !== 0)
                    duree_moyenne_par_visite = (values["duree"]["duree_sum"]["value"] / values["duree"]["visite_total"]["value"]);
            }
            catch (e) {
            }

            try {
                if (values["duree"]["videos_vue"]["value"] !== 0)
                    duree_moyenne_par_video = (values["duree"]["duree_sum"]["value"] / values["duree"]["videos_vue"]["value"]);
            }
            catch (e) {
            }


            return {
                nombre_video: nombre_video,
                visite_total: visite_total,
                visite_unique: visite_unique,
                nombre_vue_par_visiteur: nombre_vue_par_visiteur.toFixed(2),
                nombre_vue_par_video: nombre_vue_par_video.toFixed(2),
                duree_total: convertSeconds(duree_total),
                duree_moyenne_par_visiteur: convertSeconds(duree_moyenne_par_visiteur),
                duree_moyenne_par_visite: convertSeconds(duree_moyenne_par_visite),
                duree_moyenne_par_video: convertSeconds(duree_moyenne_par_video)
            };

        }

        function getResultPlayer(res){
            var values = res.data;
            var number_loads = 0;
            var number_vue_per_autoplay = 0;
            var NumberOfViewsFirstQuarter = 0;
            var NumberOfViewsFourthQuarter = 0;
            var NumberOfViewsSecondQuarter = 0;
            var NumberOfViewsThirdQuarter = 0;
            try {
                number_loads = values["NumberOfAccess"];
            }
            catch (e) {
            }
            try {
                number_vue_per_autoplay = values["NumberOfViews"];
            }
            catch (e) {
            }
            try {
                NumberOfViewsFirstQuarter = values["NumberOfViewsFirstQuarter"];
            }
            catch (e) {
            }
            try {
                NumberOfViewsFourthQuarter = values["NumberOfViewsFourthQuarter"];
            }
            catch (e) {
            }
            try {
                NumberOfViewsSecondQuarter = values["NumberOfViewsSecondQuarter"];
            }
            catch (e) {
            }
            try {
                NumberOfViewsThirdQuarter = values["NumberOfViewsThirdQuarter"];
            }
            catch (e) {
            }
            return {
                number_loads: number_loads,
                number_vue_per_autoplay: number_vue_per_autoplay,
                NumberOfViewsFirstQuarter: NumberOfViewsFirstQuarter,
                NumberOfViewsFourthQuarter: NumberOfViewsFourthQuarter,
                NumberOfViewsSecondQuarter: NumberOfViewsSecondQuarter,
                NumberOfViewsThirdQuarter: NumberOfViewsThirdQuarter,
            };
        }

        function getResultMooc(res) {
            var values = res.values;
            var total_registrations = 0;
            try {
                total_registrations = values["value"];
            }
            catch (e) {
            }
            return {
                total_registrations: total_registrations
            };
        }

        function getResultMoocOnGoingRegistrations(res) {
            var values = res.values;
            var ongoing_registrations = 0;
            try {
                ongoing_registrations = values["value"];
            }
            catch (e) {
            }
            return {
                ongoing_registrations: ongoing_registrations
            };
        }

        function getResultActifLearners(res) {
            var values = res.values;
            var actif_learners = 0;
            try {
                actif_learners = values["value"];
            }
            catch (e) {
            }
            return {
                actif_learners: actif_learners
            };
        }

        function getResultVideoWatcher(res) {
            var values = res.values;
            var video_watcher = 0;
            try {
                video_watcher = values["value"];
            }
            catch (e) {
            }
            return {
                video_watcher: video_watcher
            };
        }

        function getResultProblemTester(res) {
            var values = res.values;
            var problem_tester = 0;
            try {
                problem_tester = values["value"];
            }
            catch (e) {
            }
            return {
                problem_tester: problem_tester
            };
        }

        function getResultPersonsPassport(res) {
            var values = res.values;
            var persons_passport = 0;
            try {
                persons_passport = values["value"];
            }
            catch (e) {
            }
            return {
                persons_passport: persons_passport
            };
        }

        function getResultViewsPassport(res) {
            var values = res.values;
            var views_passport = 0;
            try {
                views_passport = values["value"];
            }
            catch (e) {
            }
            return {
                views_passport: views_passport
            };
        }

        function getResultVisasPersons(res) {
            var values = res.values;
            var visas_persons = 0;
            try {
                visas_persons = values["value"];
            }
            catch (e) {
            }
            return {
                visas_persons: visas_persons
            };
        }

        function getResultExpeditionPersons(res) {
            var values = res.values;
            var expedition_persons = 0;
            try {
                expedition_persons = values["value"];
            }
            catch (e) {
            }
            return {
                expedition_persons: expedition_persons
            };
        }

        function getResultMoocIncreaseRegistrationsInLastWeek(res) {
            var values = res.values;
            var increase_registrations = 0;
            try {
                increase_registrations = values;
            }
            catch (e) {
            }
            return {
                increase_registrations: increase_registrations
            };
        }

        function getPourcentage(used, total) {
            var percent = 0;
            if (total !== 0) {
                percent = (used / total) * 100;
                percent = percent.toFixed(2);
            }
            return percent;
        }

        function getResultMesureByIp(res) {
            var values_by_ip = res.values.mesure_ip;
            var values_all = res.values.mesure;

            var nombre_video = {"used": 0, "total": 0, "percentage": 0};
            var visite_total = {"used": 0, "total": 0, "percentage": 0};
            var visite_unique = {"used": 0, "total": 0, "percentage": 0};


            var duree_total = {"used": 0, "total": 0, "percentage": 0};


            /********Mesure statistique des visites************/
            try {
                nombre_video = {
                    "used": values_by_ip["videos_vue"]["value"],
                    "total": values_all["videos_vue"]["value"],
                    "percentage": getPourcentage(values_by_ip["videos_vue"]["value"], values_all["videos_vue"]["value"])
                };
            }
            catch (e) {
            }
            try {
                visite_total = {
                    "used": values_by_ip["visite_total"]["value"],
                    "total": values_all["visite_total"]["value"],
                    "percentage": getPourcentage(values_by_ip["visite_total"]["value"], values_all["visite_total"]["value"])
                };
            }
            catch (e) {
            }

            try {
                visite_unique = {
                    "used": values_by_ip["visite_unique"]["value"],
                    "total": values_all["visite_unique"]["value"],
                    "percentage": getPourcentage(values_by_ip["visite_unique"]["value"], values_all["visite_unique"]["value"])
                };
            }
            catch (e) {
            }


            /********Mesure statistique des durées************/

            try {
                duree_total = {
                    "used": convertSeconds(values_by_ip["duree"]["duree_sum"]["value"]),
                    "total": convertSeconds(values_all["duree"]["duree_sum"]["value"]),
                    "percentage": getPourcentage(values_by_ip["duree"]["duree_sum"]["value"], values_all["duree"]["duree_sum"]["value"])
                };
            }
            catch (e) {
            }


            return {
                nombre_video: nombre_video,
                visite_total: visite_total,
                visite_unique: visite_unique,
                duree_total: duree_total
            };

        }

        return {
            stats_mesure: stats_mesure,
            stats_mesure_player: stats_mesure_player,
            stats_mesure_standard_deviation: stats_mesure_standard_deviation,
            stats_mesure_by_ip: stats_mesure_by_ip,
            stats_mesure_taux_rebond: stats_mesure_taux_rebond,
            stats_mesure_mooc: stats_mesure_mooc,
            stats_mesure_mooc_ongoing_registrations: stats_mesure_mooc_ongoing_registrations,
            stats_mesure_mooc_actif_learners: stats_mesure_mooc_actif_learners,
            stats_mesure_mooc_video_watcher: stats_mesure_mooc_video_watcher,
            stats_mesure_mooc_problem_tester: stats_mesure_mooc_problem_tester,
            stats_mesure_mooc_increase_registrations_in_last_week: stats_mesure_mooc_increase_registrations_in_last_week,
            stats_mesure_mooc_persons_passport: stats_mesure_mooc_persons_passport,
            stats_mesure_mooc_views_passport: stats_mesure_mooc_views_passport,
            stats_mesure_mooc_visas_person: stats_mesure_mooc_visas_person,
            stats_mesure_mooc_expedition_person: stats_mesure_mooc_expedition_person

        };

    }
}());

(function () {
    'use strict';


    /** @ngInject */
    function config(msApiProvider) {
        // Api

        msApiProvider.register('stats.mesure', [Routing.generate('api_audience_post_mesure')]);
        msApiProvider.register('stats.standard.deviation', [Routing.generate('api_audience_post_standard_deviation')]);
        msApiProvider.register('stats.mesure.by.ip', [Routing.generate('api_engagement_post_mesure_by_ip')]);
        msApiProvider.register('stats.taux.rebond', [Routing.generate('api_engagement_post_taux_rebond')]);
        msApiProvider.register('stats.mooc.total.number.registrations', [Routing.generate('api_mooc_post_mooc_total_number_registrations')]);
        msApiProvider.register('stats.mooc.number.ongoing.registrations', [Routing.generate('api_mooc_post_mooc_number_on_going_registrations')]);
        msApiProvider.register('stats.mooc.increase.registrations', [Routing.generate('api_mooc_post_mooc_increase_in_registrations_in_the_last_week')]);
        msApiProvider.register('stats.mooc.number.problem_tester', [Routing.generate('api_mooc_post_mooc_number_learners_tried_problem')]);
        msApiProvider.register('stats.mooc.number.active_learners', [Routing.generate('api_mooc_post_mooc_number_active_learners')]);
        msApiProvider.register('stats.mooc.number.watching_videos', [Routing.generate('api_mooc_post_mooc_number_watching_videos_learners')]);
        msApiProvider.register('stats.mooc.number_users_passport', [Routing.generate('api_mooc_post_mooc_number_users_who_had_passport')]);
        msApiProvider.register('stats.mooc.number_views_passport', [Routing.generate('api_mooc_post_mooc_number_seen_videos_in_passport')]);
        msApiProvider.register('stats.mooc.number_visas_users', [Routing.generate('api_mooc_post_mooc_number_users_who_had_visa')]);


    }

    angular.module('app.stats.graphe')
        .config(config)
        .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions;
            permissions = {
                pattern: "^(?=.*api)(?=.*audience).*$",
                name_module: "stats_mesure_audience",
                name_angular_module: "app.stats.graphe",
                actions: ["mesure", "standard_deviation"]
            };
            msRights.setPermissionsStats(permissions);

            permissions = {
                pattern: "^(?=.*api)(?=.*engagement).*$",
                name_module: "stats_mesure_engagement",
                name_angular_module: "app.stats.graphe",
                actions: ["mesure_by_ip", "taux_rebond"]
            };
            msRights.setPermissionsStats(permissions);
            permissions = {
                pattern: "^(?=.*api)(?=.*mooc).*$",
                name_module: "stats_mooc",
                name_angular_module: "app.stats.mooc",
                actions: [{"moocNoModule": ["mooc_total_number_registrations", "mooc_number_on_going_registrations", "mooc_increase_in_registrations_in_the_last_week", "mooc_number_learners_tried_problem", "mooc_number_active_learners", "mooc_watching_videos_learners"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();


(function () {
    'use strict';
    var mesureStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesureWidgetAllController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            type: '@',
            stat: '@',
        }
    };
    var mesurePercentageStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesurePercentageWidgetAllController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            type: '@',
            stat: '@'
        }
    };
    var mesureStatsPlayer = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesureWidgetStatsPlayerController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            type: '@',
            stat: '@'
        }
    };
    var mesureByIpStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-by-ip-widget.html',
        controller: MesureByIpWidgetAllController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            type: '@',
            stat: '@'
        }
    };

    var mesureStandardDeviationStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesureStandardDeviationWidgetAllController,
        bindings: {
            mesureConfig: '<',
            query: '<'
        }
    };

    var mesureTauxRebondStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesureTauxRebondWidgetController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            stat: '@'
        }
    };

    var mesureMoocStats = {
        templateUrl: 'app/main/stats/charts/components/ChartView/mesure-widget.html',
        controller: MesureMoocWidgetAllController,
        bindings: {
            mesureConfig: '<',
            query: '<',
            type: '@'
        }
    };


    /* type = visite_total ||
              visite_unique ||
              nombre_vue_visiteur ||
              duree_moyenne_par_visiteur ||
              duree_moyenne_par_visite ||
              duree_total ||
              nombre_video */

    angular.module('app.stats.graphe')
        .controller('MesureWidgetAllController', MesureWidgetAllController)
        .controller('MesurePercentageWidgetAllController', MesurePercentageWidgetAllController)
        .controller('MesureWidgetStatsPlayerController', MesureWidgetStatsPlayerController)
        .controller('MesureStandardDeviationWidgetAllController', MesureStandardDeviationWidgetAllController)
        .controller('MesureByIpWidgetAllController', MesureByIpWidgetAllController)
        .controller('MesureTauxRebondWidgetController', MesureTauxRebondWidgetController)
        .controller('MesureMoocWidgetAllController', MesureMoocWidgetAllController)
        .component('mesureStats', mesureStats)
        .component('mesurePercentageStats', mesurePercentageStats)
        .component('mesureStatsPlayer', mesureStatsPlayer)
        .component('mesureByIpStats', mesureByIpStats)
        .component('mesureStandardDeviationStats', mesureStandardDeviationStats)
        .component('mesureTauxRebondStats', mesureTauxRebondStats)
        .component('mesureMoocStats', mesureMoocStats);

    function MesureWidgetAllController($rootScope,statMesureService, mesure_widget_constant, podcast_constants) {
        var vm = this;

        vm.mesureConfig = {};
        var query_clone;
        vm.mesureConfig = mesure_widget_constant[vm.type]
      if(vm.stat && vm.stat==='podcast'){
        vm.mesureConfig = podcast_constants[vm.type];
      }
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.mesureConfig = mesure_widget_constant[vm.type]
          if(vm.stat && vm.stat==='podcast'){
            vm.mesureConfig = podcast_constants[vm.type];
          }
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure(vm.query).then(
                function (result) {
                    var mesure_value = mesure_widget_constant[vm.type];
                  if(vm.stat && vm.stat==='podcast'){
                    mesure_value = podcast_constants[vm.type];
                  }
                    vm.mesureConfig = mesure_value;
                  if(vm.type==='duree_video'){
                    vm.mesureConfig.value =  $rootScope.infoVideo.duration;
                  }else{
                    vm.mesureConfig.value = result[vm.type];
                  }
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                },
                function () {
                    vm.mesureConfig.loding_disabled = true;
                });

        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }

    function MesurePercentageWidgetAllController($rootScope,statMesureService, mesure_percentage_widget_constant, podcast_constants) {
        var vm = this;

        vm.mesureConfig = {};
        var query_clone;
        vm.mesureConfig = mesure_percentage_widget_constant[vm.type];
      if(vm.stat && vm.stat==='podcast'){
        vm.mesureConfig = podcast_constants[vm.type];
      }
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.mesure_value = mesure_percentage_widget_constant[vm.type];
          if(vm.stat && vm.stat==='podcast'){
            vm.mesureConfig = podcast_constants[vm.type];
          }
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure_player(vm.query).then(
                function (result) {
                    var mesure_value = mesure_percentage_widget_constant[vm.type];
                  if(vm.stat && vm.stat==='podcast'){
                    mesure_value= podcast_constants[vm.type];
                  }
                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = result[vm.type];
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                },
                function () {
                    vm.mesureConfig.loding_disabled = true;
                });

        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }
    function MesureWidgetStatsPlayerController($rootScope,statMesureService, mesure_widget_constant, podcast_constants) {
        var vm = this;
        vm.mesureConfig = {};
        var query_clone;
        vm.mesureConfig = mesure_widget_constant[vm.type];
      if(vm.stat && vm.stat==='podcast'){
        vm.mesureConfig = podcast_constants[vm.type];
      }
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.mesureConfig = mesure_widget_constant[vm.type];
          if(vm.stat && vm.stat==='podcast'){
            vm.mesureConfig = podcast_constants[vm.type];
          }
            vm.mesureConfig.loding_disabled = false;
            /** todo get mesureConfig of 2 news stats **/

            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure_player(vm.query).then(
                function (result) {
                    var mesure_value = mesure_widget_constant[vm.type];
                  if(vm.stat && vm.stat==='podcast'){
                    mesure_value = podcast_constants[vm.type];
                  }
                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = result[vm.type];
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                },
                function () {
                    vm.mesureConfig.loding_disabled = true;
                });
        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }
    function MesureByIpWidgetAllController($rootScope,statMesureService, mesure_by_ip_widget_constant, podcast_constants) {
        var vm = this;
        var query_clone;
        vm.mesureConfig = {};
        vm.mesureConfig = mesure_by_ip_widget_constant[vm.type];
      if(vm.stat && vm.stat==='podcast'){
        vm.mesureConfig = podcast_constants[vm.type];
      }
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.mesureConfig = mesure_by_ip_widget_constant[vm.type];
          if(vm.stat && vm.stat==='podcast'){
            vm.mesureConfig = podcast_constants[vm.type];
          }
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure_by_ip(vm.query).then(
                function (result) {
                    var mesure_value = mesure_by_ip_widget_constant[vm.type];
                  if(vm.stat && vm.stat==='podcast'){
                    mesure_value = podcast_constants[vm.type];
                  }
                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = result[vm.type];
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;

                },
                function () {
                    vm.mesureConfig.loding_disabled = true;
                });

        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }

    function MesureStandardDeviationWidgetAllController($rootScope,statMesureService, mesure_widget_constant) {
        var vm = this;
        var query_clone;
        var mesure_value = mesure_widget_constant["ecart_type"];
        vm.mesureConfig =mesure_value
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        vm.mesureConfig = {};
        var poll = function () {
            vm.mesureConfig =mesure_value;
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure_standard_deviation(vm.query).then(
                function (result) {

                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = result["ecart_type"];
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                },
                function () {
                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = 0;
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                });

        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }

    function MesureTauxRebondWidgetController($rootScope,statMesureService, mesure_widget_constant, podcast_constants) {
        var vm = this;
        var query_clone;
        var mesure_value = mesure_widget_constant["taux_rebond"];
        if(vm.stat && vm.stat==="podcast"){
           mesure_value = podcast_constants["taux_rebond"];
       }
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        vm.mesureConfig = {};
        var poll = function () {
            vm.mesureConfig=mesure_value
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            statMesureService.stats_mesure_taux_rebond(vm.query).then(
                function (result) {

                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = result["taux_rebond"];
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;

                },
                function () {
                    vm.mesureConfig = mesure_value;
                    vm.mesureConfig.value = 0;
                    vm.mesureConfig.title = mesure_value.title;
                    vm.mesureConfig.loding_disabled = true;
                });

        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };

    }

    function MesureMoocWidgetAllController($rootScope,statMesureService, mesure_mooc_widget_constant, $state) {
        var vm = this;
        vm.mesureConfig = {};
        var query_clone;
        vm.mesureConfig = mesure_mooc_widget_constant[vm.type];
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
        var poll = function () {
            vm.mesureConfig = mesure_mooc_widget_constant[vm.type];
            vm.mesureConfig.loding_disabled = false;
            if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
            if (vm.type === "ongoing_registrations") {
                statMesureService.stats_mesure_mooc_ongoing_registrations(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "total_registrations") {

                statMesureService.stats_mesure_mooc(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "increase_registrations") {
                statMesureService.stats_mesure_mooc_increase_registrations_in_last_week(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            if (result[vm.type] > 0) {
                                vm.icon = "icon-trending-up";
                            } else {
                                vm.icon = "icon-trending-down";
                            }
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "actif_learners") {
                statMesureService.stats_mesure_mooc_actif_learners(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "video_watcher") {
                statMesureService.stats_mesure_mooc_video_watcher(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "problem_tester") {
                statMesureService.stats_mesure_mooc_problem_tester(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "persons_passport") {
                statMesureService.stats_mesure_mooc_persons_passport(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "views_passport") {
                statMesureService.stats_mesure_mooc_views_passport(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
            if (vm.type === "visas_persons") {
                statMesureService.stats_mesure_mooc_visas_person(vm.query).then(
                    function (result) {
                        var mesure_value = mesure_mooc_widget_constant[vm.type];
                        if (angular.isDefined(mesure_value)) {
                            vm.mesureConfig = mesure_value;
                            vm.mesureConfig.value = result[vm.type];
                            vm.mesureConfig.title = mesure_value.title;
                            vm.mesureConfig.loding_disabled = true;
                        }
                    },
                    function () {
                        vm.mesureConfig.loding_disabled = true;
                    });
            }
        };

        this.$onInit = function () {
            query_clone = angular.copy(vm.query);
            poll();
        };

        this.$doCheck = function () {
            var verif = angular.equals(query_clone, vm.query);
            if (!verif) {
                query_clone = angular.copy(vm.query);
                poll();
            }
        };
    }


})();

(function ()
{
    'use strict';

    Highcharts.maps["custom/world"] = {
    "title": "World, Miller projection, high resolution",
    "version": "1.1.2",
    "type": "FeatureCollection",
    "copyright": "Copyright (c) 2015 Highsoft AS, Based on data from Natural Earth",
    "copyrightShort": "Natural Earth", "copyrightUrl": "https://www.naturalearthdata.com", "crs": {
        "type": "name", "properties": {
            "name": "urn:ogc:def:crs:EPSG:54003"
        }
    }
    ,
    "hc-transform": {
        "default": {
            "crs": "+proj=mill +lat_0=0 +lon_0=0 +x_0=0 +y_0=0 +R_A +datum=WGS84 +units=m +no_defs",
            "scale": 0.0000171096809122,
            "jsonres": 15.5,
            "jsonmarginX": -999,
            "jsonmarginY": 9851,
            "xoffset": -19753395.3101,
            "yoffset": 12635908.1982
        }
    }
    ,
    "features": [
        {
            "type": "Feature",
            "id": "FO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.66,
                "hc-middle-y": 0.41,
                "hc-key": "fo",
                "hc-a2": "FO",
                "name": "Faroe Islands",
                "labelrank": "6",
                "country-abbrev": "Faeroe Is.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "FRO",
                "iso-a2": "FO",
                "woe-id": "23424816",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4046, 8611], [4037, 8582], [4033, 8610], [4014, 8609], [4028, 8619], [4046, 8611]]]
            }
        }, {
            "type": "Feature",
            "id": "UM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.58,
                "hc-key": "um",
                "hc-a2": "UM",
                "name": "United States Minor Outlying Islands",
                "labelrank": "5",
                "country-abbrev": "U.S. MOI",
                "subregion": "Seven seas (open ocean)",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "UMI",
                "iso-a2": "UM",
                "woe-id": "28289407",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[-539, 6673], [-540, 6672], [-540, 6672], [-540, 6673], [-539, 6673]]]
            }
        }, {
            "type": "Feature",
            "id": "US",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.7,
                "hc-middle-y": 0.68,
                "hc-key": "us",
                "hc-a2": "US",
                "name": "United States of America",
                "labelrank": "2",
                "country-abbrev": "U.S.A.",
                "subregion": "Northern America",
                "region-wb": "North America",
                "iso-a3": "USA",
                "iso-a2": "US",
                "woe-id": "23424977",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[-349, 7098], [-326, 7078], [-357, 7064], [-362, 7086], [-349, 7098]]], [[[-397, 7131], [-381, 7129], [-361, 7115], [-370, 7112], [-397, 7131]]], [[[2212, 7883], [2209, 7887], [2216, 7888], [2217, 7883], [2212, 7883]]], [[[614, 8046], [618, 8044], [608, 8047], [609, 8051], [614, 8046]]], [[[617, 8055], [620, 8053], [617, 8051], [612, 8052], [617, 8055]]], [[[-931, 8182], [-977, 8166], [-999, 8171], [-986, 8179], [-961, 8175], [-952, 8186], [-931, 8182]]], [[[-765, 8212], [-795, 8209], [-737, 8224], [-725, 8240], [-710, 8237], [-743, 8217], [-765, 8212]]], [[[325, 8299], [329, 8298], [328, 8293], [324, 8298], [325, 8299]]], [[[324, 8309], [327, 8304], [325, 8302], [321, 8304], [324, 8309]]], [[[316, 8310], [327, 8289], [314, 8300], [312, 8311], [316, 8310]]], [[[366, 8307], [365, 8303], [358, 8303], [361, 8313], [366, 8307]]], [[[309, 8315], [310, 8311], [305, 8311], [305, 8315], [309, 8315]]], [[[352, 8319], [358, 8315], [355, 8308], [351, 8318], [352, 8319]]], [[[299, 8321], [305, 8323], [305, 8318], [298, 8314], [299, 8321]]], [[[310, 8321], [308, 8320], [305, 8324], [310, 8324], [310, 8321]]], [[[370, 8341], [378, 8329], [371, 8310], [352, 8321], [370, 8341]]], [[[293, 8339], [297, 8346], [309, 8350], [306, 8345], [293, 8339]]], [[[333, 8352], [344, 8348], [338, 8340], [328, 8346], [333, 8352]]], [[[328, 8362], [328, 8355], [316, 8358], [320, 8362], [328, 8362]]], [[[343, 8358], [345, 8349], [337, 8355], [336, 8364], [343, 8358]]], [[[321, 8377], [331, 8368], [324, 8364], [319, 8365], [321, 8377]]], [[[295, 8389], [318, 8382], [313, 8363], [298, 8363], [295, 8389]]], [[[242, 8396], [240, 8386], [234, 8385], [238, 8393], [242, 8396]]], [[[-262, 8451], [-246, 8445], [-246, 8434], [-272, 8427], [-285, 8431], [-266, 8440], [-262, 8451]]], [[[-659, 8532], [-642, 8514], [-674, 8509], [-698, 8523], [-659, 8532]]], [[[1653, 8007], [1632, 7990], [1627, 7999], [1643, 8009], [1653, 8007]]], [[[1630, 8034], [1626, 8029], [1611, 8022], [1609, 8025], [1630, 8034]]], [[[1675, 7930], [1673, 7921], [1666, 7911], [1662, 7916], [1675, 7930]]], [[[1718, 7946], [1719, 7940], [1715, 7939], [1717, 7945], [1718, 7946]]], [[[1775, 7956], [1777, 7951], [1768, 7952], [1772, 7955], [1775, 7956]]], [[[285, 8340], [276, 8379], [288, 8381], [297, 8369], [285, 8340]]], [[[2112, 7778], [2090, 7765], [2058, 7759], [2073, 7772], [2112, 7778]]], [[[-659, 8266], [-658, 8255], [-673, 8243], [-699, 8234], [-683, 8250], [-690, 8256], [-659, 8266]]], [[[254, 8387], [239, 8401], [247, 8409], [263, 8396], [270, 8374], [269, 8351], [257, 8366], [254, 8387]]], [[[-288, 8425], [-247, 8412], [-282, 8386], [-292, 8386], [-310, 8369], [-309, 8381], [-326, 8400], [-288, 8425]]], [[[260, 8440], [282, 8433], [280, 8421], [289, 8398], [270, 8386], [274, 8402], [260, 8440]]], [[[-759, 8668], [-736, 8665], [-766, 8649], [-768, 8656], [-794, 8669], [-815, 8665], [-828, 8675], [-783, 8683], [-759, 8668]]], [[[611, 8065], [610, 8065], [610, 8065], [611, 8065]]], [[[1315, 7297], [1314, 7309], [1307, 7313], [1305, 7329], [1283, 7351], [1260, 7389], [1257, 7391], [1255, 7393], [1222, 7403], [1211, 7398], [1198, 7374], [1158, 7395], [1147, 7424], [1099, 7464], [1048, 7464], [1048, 7449], [964, 7449], [854, 7487], [857, 7494], [786, 7488], [780, 7507], [756, 7528], [749, 7517], [744, 7538], [706, 7539], [705, 7550], [682, 7556], [682, 7574], [663, 7592], [643, 7623], [648, 7630], [630, 7643], [626, 7665], [591, 7702], [587, 7734], [571, 7755], [581, 7790], [566, 7839], [579, 7877], [586, 7937], [579, 7987], [566, 8042], [581, 8035], [621, 8032], [628, 8020], [628, 8029], [620, 8037], [625, 8043], [621, 8037], [628, 8030], [628, 8051], [620, 8065], [1433, 8065], [1443, 8077], [1447, 8058], [1507, 8048], [1543, 8029], [1598, 8028], [1556, 8009], [1524, 7983], [1528, 7979], [1562, 7986], [1573, 7975], [1603, 7985], [1626, 7999], [1632, 7990], [1655, 7984], [1664, 7973], [1686, 7971], [1699, 7979], [1734, 7983], [1748, 7970], [1759, 7973], [1759, 7966], [1761, 7963], [1764, 7957], [1766, 7954], [1741, 7948], [1714, 7953], [1674, 7950], [1644, 7901], [1664, 7910], [1647, 7855], [1650, 7819], [1665, 7796], [1684, 7805], [1697, 7844], [1688, 7867], [1696, 7906], [1714, 7924], [1733, 7931], [1745, 7947], [1777, 7930], [1782, 7893], [1767, 7880], [1772, 7867], [1785, 7880], [1801, 7878], [1809, 7846], [1806, 7832], [1802, 7829], [1797, 7833], [1790, 7820], [1778, 7800], [1807, 7788], [1831, 7793], [1906, 7830], [1912, 7843], [1908, 7849], [1908, 7855], [1936, 7859], [1977, 7857], [1993, 7866], [1988, 7886], [1993, 7889], [1993, 7889], [2005, 7899], [2020, 7912], [2036, 7917], [2036, 7917], [2131, 7918], [2167, 7950], [2175, 7980], [2198, 8008], [2208, 7998], [2224, 8004], [2240, 7994], [2240, 7945], [2245, 7939], [2251, 7939], [2250, 7927], [2259, 7924], [2265, 7910], [2228, 7894], [2229, 7894], [2223, 7887], [2222, 7891], [2219, 7890], [2205, 7896], [2203, 7884], [2159, 7856], [2152, 7842], [2157, 7800], [2128, 7787], [2090, 7783], [2069, 7775], [2051, 7755], [2055, 7731], [2025, 7698], [2025, 7681], [2002, 7649], [2009, 7669], [1989, 7687], [1998, 7690], [1987, 7713], [1983, 7683], [1991, 7667], [1984, 7634], [1998, 7635], [2006, 7591], [1983, 7557], [1965, 7559], [1949, 7549], [1940, 7532], [1923, 7532], [1905, 7510], [1871, 7487], [1846, 7462], [1837, 7430], [1844, 7399], [1865, 7357], [1879, 7305], [1870, 7253], [1848, 7252], [1843, 7270], [1817, 7294], [1797, 7339], [1803, 7371], [1762, 7410], [1734, 7394], [1702, 7416], [1655, 7414], [1620, 7420], [1598, 7411], [1578, 7418], [1581, 7407], [1596, 7411], [1594, 7397], [1610, 7374], [1586, 7389], [1567, 7377], [1537, 7398], [1517, 7391], [1491, 7399], [1465, 7396], [1393, 7353], [1378, 7338], [1363, 7306], [1375, 7278], [1343, 7282], [1315, 7297]]], [[[307, 8333], [303, 8331], [299, 8337], [308, 8337], [308, 8336], [313, 8357], [348, 8311], [347, 8290], [321, 8317], [306, 8328], [307, 8333]]], [[[368, 8302], [367, 8297], [362, 8300], [368, 8302], [368, 8302], [368, 8302]]], [[[217, 8424], [216, 8421], [213, 8425], [215, 8432], [217, 8430], [217, 8431], [235, 8440], [261, 8429], [243, 8421], [261, 8417], [257, 8405], [236, 8418], [238, 8401], [217, 8421], [217, 8424]]], [[[278, 8438], [280, 8436], [270, 8438], [271, 8442], [266, 8444], [246, 8484], [257, 8443], [232, 8444], [227, 8463], [212, 8464], [226, 8442], [209, 8438], [180, 8455], [162, 8475], [115, 8495], [122, 8510], [93, 8502], [29, 8520], [-14, 8516], [-14, 8522], [-69, 8536], [-69, 8552], [-121, 8552], [-129, 8544], [-116, 8515], [-121, 8505], [-137, 8514], [-166, 8515], [-176, 8500], [-240, 8477], [-242, 8485], [-218, 8497], [-239, 8504], [-226, 8524], [-225, 8546], [-197, 8561], [-172, 8559], [-200, 8574], [-227, 8560], [-252, 8537], [-264, 8511], [-304, 8488], [-307, 8473], [-282, 8468], [-299, 8454], [-312, 8431], [-332, 8429], [-343, 8416], [-367, 8406], [-377, 8385], [-384, 8388], [-400, 8365], [-413, 8372], [-445, 8338], [-474, 8337], [-495, 8322], [-465, 8304], [-489, 8313], [-503, 8307], [-506, 8324], [-523, 8318], [-530, 8305], [-557, 8304], [-575, 8296], [-562, 8282], [-578, 8293], [-620, 8278], [-613, 8298], [-584, 8305], [-577, 8297], [-577, 8307], [-544, 8331], [-520, 8342], [-486, 8337], [-490, 8355], [-448, 8379], [-413, 8409], [-405, 8448], [-393, 8466], [-424, 8454], [-436, 8464], [-451, 8446], [-466, 8467], [-476, 8461], [-489, 8474], [-531, 8452], [-539, 8483], [-529, 8493], [-547, 8520], [-585, 8506], [-639, 8539], [-616, 8551], [-590, 8540], [-579, 8548], [-613, 8553], [-660, 8582], [-644, 8598], [-648, 8606], [-620, 8633], [-623, 8643], [-601, 8663], [-577, 8652], [-549, 8670], [-514, 8674], [-502, 8685], [-507, 8709], [-522, 8717], [-502, 8728], [-514, 8742], [-571, 8717], [-583, 8724], [-627, 8718], [-661, 8725], [-667, 8740], [-684, 8752], [-660, 8758], [-697, 8764], [-717, 8779], [-636, 8815], [-589, 8823], [-596, 8804], [-587, 8797], [-533, 8793], [-525, 8806], [-508, 8805], [-534, 8817], [-556, 8837], [-547, 8840], [-526, 8815], [-502, 8811], [-485, 8819], [-505, 8826], [-523, 8819], [-534, 8828], [-528, 8844], [-550, 8842], [-588, 8848], [-601, 8873], [-639, 8896], [-675, 8910], [-663, 8921], [-663, 8937], [-607, 8940], [-571, 8964], [-572, 8978], [-554, 9001], [-535, 9014], [-504, 9015], [-469, 9039], [-421, 9041], [-385, 9066], [-350, 9060], [-364, 9048], [-357, 9041], [-334, 9057], [-306, 9038], [-281, 9046], [-252, 9042], [-261, 9026], [-242, 9020], [-161, 9026], [-136, 9013], [-99, 9005], [-62, 9006], [-45, 8996], [-24, 8995], [14, 9002], [44, 8989], [81, 8978], [82, 8528], [111, 8523], [138, 8530], [135, 8518], [182, 8481], [187, 8467], [211, 8478], [219, 8497], [244, 8506], [260, 8483], [306, 8445], [340, 8394], [352, 8368], [403, 8348], [405, 8340], [406, 8314], [406, 8314], [395, 8299], [379, 8294], [380, 8331], [371, 8342], [355, 8339], [348, 8323], [348, 8359], [315, 8389], [281, 8437], [278, 8438]]], [[[368, 8302], [369, 8305], [369, 8302], [368, 8302], [368, 8302], [368, 8302]]]]
            }
        }, {
            "type": "Feature",
            "id": "JP",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.65,
                "hc-key": "jp",
                "hc-a2": "JP",
                "name": "Japan",
                "labelrank": "2",
                "country-abbrev": "Japan",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "JPN",
                "iso-a2": "JP",
                "woe-id": "23424856",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[8399, 7927], [8399, 7929], [8407, 7923], [8403, 7922], [8399, 7927]]], [[[8160, 7541], [8140, 7530], [8125, 7538], [8108, 7534], [8101, 7550], [8115, 7551], [8151, 7584], [8164, 7590], [8171, 7608], [8174, 7585], [8207, 7592], [8242, 7586], [8249, 7602], [8273, 7632], [8272, 7649], [8288, 7655], [8279, 7632], [8316, 7643], [8334, 7665], [8324, 7668], [8351, 7676], [8368, 7716], [8361, 7735], [8376, 7768], [8378, 7784], [8389, 7769], [8401, 7770], [8404, 7784], [8391, 7779], [8395, 7794], [8409, 7780], [8412, 7759], [8426, 7739], [8428, 7720], [8400, 7683], [8399, 7650], [8385, 7613], [8393, 7595], [8366, 7567], [8362, 7588], [8315, 7560], [8280, 7556], [8271, 7571], [8266, 7557], [8277, 7546], [8257, 7539], [8249, 7523], [8234, 7522], [8222, 7533], [8233, 7558], [8213, 7562], [8183, 7554], [8160, 7541], [8177, 7535], [8196, 7554], [8210, 7546], [8197, 7512], [8183, 7521], [8170, 7515], [8162, 7499], [8149, 7495], [8141, 7519], [8160, 7541]]], [[[8093, 7492], [8073, 7477], [8078, 7497], [8056, 7510], [8049, 7540], [8068, 7514], [8088, 7532], [8124, 7523], [8133, 7502], [8123, 7488], [8112, 7450], [8093, 7439], [8097, 7450], [8080, 7447], [8080, 7469], [8093, 7492]]], [[[8383, 7830], [8377, 7819], [8403, 7802], [8389, 7803], [8374, 7788], [8372, 7809], [8362, 7818], [8364, 7833], [8383, 7845], [8382, 7858], [8403, 7850], [8411, 7858], [8421, 7904], [8415, 7923], [8425, 7936], [8456, 7902], [8481, 7887], [8508, 7878], [8526, 7890], [8518, 7873], [8531, 7851], [8508, 7842], [8491, 7844], [8473, 7831], [8464, 7807], [8422, 7831], [8397, 7822], [8383, 7830]]]]
            }
        }, {
            "type": "Feature",
            "id": "SC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.58,
                "hc-middle-y": 0.41,
                "hc-key": "sc",
                "hc-a2": "SC",
                "name": "Seychelles",
                "labelrank": "6",
                "country-abbrev": "Syc.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SYC",
                "iso-a2": "SC",
                "woe-id": "23424941",
                "continent": "Seven seas (open ocean)"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5874, 6366], [5877, 6363], [5876, 6359], [5868, 6370], [5874, 6366]]]
            }
        }, {
            "type": "Feature",
            "id": "IN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.33,
                "hc-middle-y": 0.44,
                "hc-key": "in",
                "hc-a2": "IN",
                "name": "India",
                "labelrank": "2",
                "country-abbrev": "India",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "IND",
                "iso-a2": "IN",
                "woe-id": "23424848",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[6970, 6817], [6969, 6848], [6983, 6903], [6982, 6869], [6970, 6817]]], [[[6837, 7150], [6839, 7151], [6839, 7144], [6836, 7145], [6837, 7150]]], [[[6838, 7338], [6859, 7342], [6861, 7321], [6867, 7305], [6888, 7301], [6944, 7305], [6955, 7309], [6942, 7335], [6971, 7340], [6995, 7364], [7030, 7384], [7049, 7376], [7075, 7386], [7099, 7353], [7110, 7349], [7110, 7339], [7091, 7322], [7075, 7319], [7042, 7294], [7041, 7271], [7029, 7260], [7032, 7249], [7015, 7212], [6991, 7217], [6993, 7190], [6987, 7167], [6970, 7154], [6957, 7209], [6940, 7184], [6927, 7205], [6934, 7220], [6956, 7229], [6967, 7246], [6954, 7254], [6904, 7253], [6888, 7260], [6889, 7279], [6848, 7294], [6837, 7276], [6862, 7253], [6848, 7254], [6835, 7237], [6856, 7226], [6851, 7206], [6866, 7159], [6842, 7141], [6839, 7158], [6811, 7141], [6801, 7127], [6805, 7114], [6787, 7093], [6759, 7091], [6719, 7041], [6667, 7004], [6667, 6990], [6636, 6982], [6623, 6964], [6607, 6964], [6600, 6943], [6609, 6893], [6595, 6854], [6594, 6803], [6581, 6803], [6567, 6778], [6571, 6773], [6547, 6763], [6541, 6746], [6525, 6737], [6497, 6762], [6476, 6826], [6446, 6878], [6432, 6930], [6405, 6975], [6390, 7044], [6382, 7089], [6389, 7110], [6373, 7166], [6366, 7131], [6333, 7115], [6314, 7122], [6280, 7154], [6281, 7163], [6309, 7172], [6315, 7184], [6295, 7178], [6264, 7191], [6250, 7212], [6270, 7224], [6303, 7222], [6335, 7238], [6306, 7279], [6308, 7296], [6288, 7305], [6291, 7317], [6317, 7344], [6325, 7334], [6359, 7341], [6373, 7367], [6390, 7376], [6403, 7404], [6438, 7442], [6436, 7462], [6460, 7476], [6443, 7486], [6422, 7510], [6415, 7549], [6432, 7562], [6474, 7553], [6500, 7561], [6512, 7573], [6534, 7586], [6548, 7558], [6567, 7549], [6563, 7522], [6580, 7509], [6584, 7495], [6567, 7483], [6551, 7488], [6562, 7470], [6562, 7449], [6575, 7449], [6586, 7437], [6628, 7413], [6610, 7399], [6600, 7369], [6615, 7364], [6654, 7338], [6680, 7326], [6734, 7321], [6736, 7312], [6771, 7297], [6815, 7290], [6840, 7302], [6834, 7314], [6838, 7338]]]]
            }
        }, {
            "type": "Feature",
            "id": "FR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.29,
                "hc-middle-y": 0.05,
                "hc-key": "fr",
                "hc-a2": "FR",
                "name": "France",
                "labelrank": "2",
                "country-abbrev": "Fr.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "FRA",
                "iso-a2": "FR",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2583, 7984], [2578, 7982], [2577, 7995], [2579, 7987], [2583, 7984]]], [[[4518, 7832], [4521, 7814], [4511, 7787], [4499, 7794], [4492, 7818], [4496, 7830], [4518, 7832]]], [[[9075, 5904], [9081, 5904], [9124, 5867], [9165, 5838], [9160, 5832], [9114, 5858], [9087, 5883], [9075, 5904]]], [[[6278, 4935], [6290, 4940], [6296, 4925], [6319, 4931], [6307, 4907], [6277, 4914], [6268, 4907], [6268, 4940], [6278, 4935]]], [[[2379, 7035], [2381, 7037], [2381, 7034], [2379, 7035]]], [[[4461, 7873], [4460, 7872], [4459, 7872], [4458, 7872], [4457, 7871], [4420, 7848], [4356, 7864], [4329, 7843], [4333, 7825], [4314, 7821], [4298, 7825], [4297, 7825], [4297, 7825], [4290, 7827], [4290, 7831], [4282, 7831], [4259, 7839], [4238, 7834], [4200, 7848], [4187, 7859], [4196, 7866], [4209, 7955], [4187, 7972], [4181, 7992], [4157, 8009], [4101, 8030], [4113, 8035], [4100, 8049], [4148, 8061], [4161, 8047], [4199, 8053], [4183, 8093], [4202, 8092], [4205, 8082], [4233, 8076], [4245, 8093], [4276, 8103], [4285, 8112], [4286, 8138], [4314, 8146], [4348, 8116], [4363, 8113], [4361, 8103], [4381, 8102], [4400, 8085], [4410, 8086], [4415, 8083], [4427, 8083], [4441, 8074], [4481, 8064], [4463, 8033], [4463, 8012], [4447, 8003], [4420, 7975], [4423, 7964], [4425, 7967], [4428, 7968], [4440, 7969], [4439, 7959], [4447, 7951], [4451, 7932], [4434, 7921], [4446, 7911], [4446, 7889], [4465, 7887], [4461, 7873]]], [[[2642, 6657], [2649, 6668], [2678, 6660], [2706, 6636], [2716, 6618], [2677, 6564], [2667, 6569], [2643, 6562], [2629, 6568], [2647, 6601], [2637, 6618], [2633, 6644], [2642, 6657]]]]
            }
        }, {
            "type": "Feature",
            "id": "FM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.52,
                "hc-key": "fm",
                "hc-a2": "FM",
                "name": "Federated States of Micronesia",
                "labelrank": "6",
                "country-abbrev": "F.S.M.",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "FSM",
                "iso-a2": "FM",
                "woe-id": "23424815",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[8905, 6704], [8908, 6703], [8908, 6699], [8905, 6699], [8905, 6704]]]
            }
        }, {
            "type": "Feature",
            "id": "CN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.41,
                "hc-middle-y": 0.55,
                "hc-key": "cn",
                "hc-a2": "CN",
                "name": "China",
                "labelrank": "2",
                "country-abbrev": "China",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "CHN",
                "iso-a2": "CN",
                "woe-id": "23424781",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7445, 7068], [7471, 7094], [7503, 7099], [7513, 7084], [7496, 7053], [7475, 7039], [7445, 7049], [7445, 7068]]], [[[6861, 7321], [6859, 7342], [6838, 7338], [6810, 7337], [6792, 7346], [6775, 7339], [6767, 7353], [6749, 7352], [6719, 7382], [6703, 7380], [6692, 7394], [6662, 7408], [6660, 7417], [6628, 7413], [6586, 7437], [6575, 7449], [6562, 7449], [6562, 7470], [6551, 7488], [6567, 7483], [6584, 7495], [6580, 7509], [6563, 7522], [6567, 7549], [6548, 7558], [6534, 7586], [6522, 7585], [6504, 7591], [6486, 7597], [6480, 7619], [6455, 7637], [6438, 7638], [6433, 7641], [6448, 7645], [6444, 7689], [6416, 7691], [6411, 7720], [6421, 7741], [6446, 7757], [6468, 7762], [6471, 7750], [6499, 7761], [6503, 7772], [6542, 7776], [6550, 7788], [6604, 7810], [6605, 7816], [6603, 7832], [6622, 7850], [6602, 7918], [6648, 7930], [6672, 7921], [6666, 7936], [6688, 7998], [6738, 7984], [6761, 7992], [6761, 8025], [6769, 8043], [6792, 8048], [6801, 8070], [6815, 8069], [6820, 8070], [6829, 8072], [6833, 8051], [6865, 8028], [6881, 8029], [6904, 8015], [6924, 7974], [6923, 7954], [6913, 7935], [6919, 7924], [6998, 7915], [7042, 7890], [7052, 7891], [7067, 7854], [7081, 7835], [7106, 7837], [7173, 7829], [7189, 7833], [7237, 7828], [7248, 7816], [7298, 7801], [7321, 7805], [7342, 7800], [7388, 7820], [7430, 7826], [7468, 7825], [7495, 7837], [7512, 7856], [7540, 7870], [7525, 7897], [7543, 7920], [7590, 7908], [7617, 7931], [7651, 7934], [7665, 7943], [7678, 7965], [7699, 7966], [7727, 7980], [7769, 7975], [7775, 7987], [7735, 8027], [7712, 8027], [7710, 8026], [7705, 8020], [7685, 8023], [7656, 8017], [7646, 8033], [7680, 8097], [7712, 8085], [7738, 8102], [7755, 8105], [7753, 8118], [7781, 8168], [7801, 8186], [7800, 8203], [7779, 8212], [7803, 8232], [7875, 8244], [7917, 8227], [7947, 8221], [7971, 8188], [7968, 8182], [8002, 8112], [8001, 8096], [8016, 8087], [8055, 8082], [8081, 8061], [8097, 8039], [8104, 8016], [8146, 8017], [8164, 8032], [8203, 8042], [8212, 8038], [8214, 8017], [8196, 8000], [8188, 7963], [8176, 7940], [8157, 7919], [8149, 7928], [8132, 7925], [8101, 7911], [8110, 7883], [8111, 7861], [8102, 7840], [8089, 7828], [8069, 7844], [8064, 7825], [8041, 7810], [8015, 7809], [8018, 7788], [7973, 7798], [7955, 7771], [7923, 7756], [7907, 7743], [7900, 7734], [7878, 7732], [7851, 7719], [7833, 7703], [7812, 7696], [7831, 7718], [7816, 7718], [7824, 7735], [7846, 7757], [7833, 7768], [7813, 7772], [7791, 7746], [7765, 7736], [7749, 7712], [7712, 7709], [7706, 7692], [7722, 7676], [7744, 7676], [7748, 7646], [7762, 7641], [7800, 7665], [7825, 7651], [7858, 7651], [7847, 7631], [7838, 7636], [7800, 7619], [7799, 7608], [7768, 7589], [7755, 7571], [7768, 7555], [7786, 7547], [7805, 7504], [7804, 7493], [7832, 7469], [7833, 7453], [7807, 7465], [7837, 7436], [7807, 7424], [7838, 7406], [7845, 7421], [7849, 7401], [7837, 7401], [7835, 7376], [7825, 7384], [7827, 7353], [7807, 7342], [7794, 7317], [7774, 7300], [7762, 7279], [7771, 7261], [7745, 7251], [7701, 7207], [7688, 7205], [7675, 7184], [7655, 7178], [7624, 7180], [7608, 7161], [7590, 7187], [7588, 7159], [7562, 7144], [7555, 7150], [7504, 7135], [7491, 7124], [7495, 7103], [7481, 7101], [7473, 7122], [7476, 7139], [7438, 7151], [7424, 7139], [7405, 7143], [7381, 7166], [7387, 7178], [7361, 7183], [7345, 7197], [7305, 7171], [7286, 7179], [7277, 7168], [7261, 7179], [7251, 7167], [7233, 7163], [7239, 7128], [7223, 7141], [7221, 7148], [7194, 7137], [7187, 7156], [7163, 7160], [7174, 7188], [7155, 7191], [7147, 7219], [7118, 7212], [7121, 7250], [7150, 7276], [7150, 7329], [7138, 7328], [7133, 7346], [7116, 7359], [7110, 7349], [7099, 7353], [7075, 7386], [7049, 7376], [7030, 7384], [6995, 7364], [6971, 7340], [6942, 7335], [6900, 7354], [6881, 7347], [6861, 7321]]]]
            }
        }, {
            "type": "Feature",
            "id": "SW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.86,
                "hc-middle-y": 0.57,
                "hc-key": "sw",
                "hc-a2": "SW",
                "name": "Serranilla Bank",
                "labelrank": "5",
                "country-abbrev": "S.B.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "-99",
                "iso-a2": "SW",
                "woe-id": "-99",
                "continent": "North America"
            },
            "geometry": {"type": "Polygon", "coordinates": [[[1921, 6969], [1921, 6969], [1921, 6969], [1921, 6969]]]}
        }, {
            "type": "Feature",
            "id": "SH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.54,
                "hc-middle-y": 0.51,
                "hc-key": "sh",
                "hc-a2": "SH",
                "name": "Scarborough Reef",
                "labelrank": "6",
                "country-abbrev": "S.R.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "-99",
                "iso-a2": "SH",
                "woe-id": "-99",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7712, 6947], [7712, 6947], [7712, 6947], [7712, 6947], [7712, 6947]]]
            }
        }, {
            "type": "Feature",
            "id": "BR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.54,
                "hc-middle-y": 0.34,
                "hc-key": "br",
                "hc-a2": "BR",
                "name": "Brazil",
                "labelrank": "2",
                "country-abbrev": "Brazil",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "BRA",
                "iso-a2": "BR",
                "woe-id": "23424768",
                "continent": "South America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2774, 6496], [2812, 6492], [2799, 6457], [2771, 6447], [2747, 6448], [2741, 6483], [2755, 6497], [2774, 6496]]], [[[2661, 5478], [2673, 5503], [2689, 5510], [2687, 5523], [2672, 5507], [2629, 5546], [2611, 5553], [2600, 5566], [2588, 5559], [2582, 5575], [2564, 5590], [2541, 5588], [2576, 5623], [2595, 5650], [2621, 5669], [2652, 5684], [2657, 5712], [2650, 5732], [2629, 5734], [2630, 5735], [2629, 5738], [2640, 5762], [2639, 5781], [2628, 5789], [2605, 5784], [2599, 5825], [2576, 5843], [2569, 5838], [2530, 5843], [2535, 5877], [2525, 5901], [2542, 5961], [2535, 5981], [2518, 5989], [2516, 6017], [2466, 6019], [2456, 6093], [2439, 6103], [2416, 6101], [2406, 6113], [2380, 6127], [2341, 6133], [2323, 6147], [2311, 6172], [2314, 6200], [2309, 6215], [2274, 6209], [2226, 6177], [2188, 6178], [2156, 6176], [2160, 6223], [2140, 6208], [2111, 6206], [2107, 6220], [2081, 6224], [2088, 6233], [2057, 6279], [2065, 6298], [2083, 6312], [2080, 6322], [2089, 6349], [2119, 6368], [2152, 6378], [2176, 6376], [2192, 6458], [2187, 6485], [2173, 6495], [2174, 6517], [2201, 6519], [2194, 6531], [2180, 6531], [2180, 6550], [2230, 6550], [2254, 6561], [2261, 6534], [2268, 6536], [2289, 6521], [2306, 6519], [2319, 6533], [2348, 6546], [2371, 6571], [2351, 6572], [2346, 6605], [2333, 6616], [2369, 6616], [2388, 6606], [2389, 6618], [2424, 6625], [2453, 6645], [2448, 6652], [2471, 6649], [2467, 6632], [2484, 6615], [2475, 6606], [2470, 6579], [2477, 6555], [2505, 6535], [2520, 6547], [2556, 6559], [2574, 6557], [2588, 6554], [2589, 6574], [2618, 6574], [2629, 6568], [2643, 6562], [2667, 6569], [2677, 6564], [2716, 6618], [2720, 6630], [2733, 6614], [2735, 6589], [2745, 6564], [2768, 6549], [2764, 6515], [2770, 6500], [2748, 6500], [2725, 6486], [2746, 6447], [2788, 6443], [2817, 6475], [2833, 6484], [2878, 6473], [2889, 6461], [2913, 6460], [2927, 6444], [2923, 6421], [2938, 6417], [2951, 6434], [2988, 6419], [3012, 6415], [3060, 6416], [3105, 6392], [3143, 6356], [3191, 6350], [3200, 6339], [3214, 6289], [3213, 6267], [3198, 6230], [3166, 6191], [3151, 6183], [3118, 6128], [3091, 6110], [3088, 6067], [3094, 6032], [3083, 5992], [3085, 5977], [3071, 5961], [3069, 5925], [3028, 5860], [3032, 5846], [3002, 5828], [2999, 5815], [2932, 5816], [2900, 5795], [2855, 5775], [2829, 5754], [2806, 5719], [2804, 5698], [2812, 5677], [2802, 5641], [2771, 5611], [2756, 5579], [2729, 5587], [2723, 5559], [2700, 5537], [2688, 5493], [2666, 5472], [2661, 5475], [2661, 5478]]]]
            }
        }, {
            "type": "Feature",
            "id": "EC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.71,
                "hc-middle-y": 0.37,
                "hc-key": "ec",
                "hc-a2": "EC",
                "name": "Ecuador",
                "labelrank": "3",
                "country-abbrev": "Ecu.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "ECU",
                "iso-a2": "EC",
                "woe-id": "23424801",
                "continent": "South America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[1561, 6490], [1607, 6478], [1580, 6480], [1544, 6470], [1561, 6490]]], [[[1915, 6542], [1955, 6519], [1957, 6511], [1986, 6507], [1990, 6513], [2020, 6497], [2011, 6455], [1978, 6425], [1943, 6412], [1929, 6401], [1920, 6367], [1908, 6353], [1895, 6367], [1865, 6380], [1876, 6386], [1870, 6401], [1887, 6422], [1874, 6420], [1854, 6432], [1859, 6443], [1853, 6469], [1879, 6501], [1877, 6522], [1905, 6532], [1915, 6542]]]]
            }
        }, {
            "type": "Feature",
            "id": "AU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.41,
                "hc-key": "au",
                "hc-a2": "AU",
                "name": "Australia",
                "labelrank": "2",
                "country-abbrev": "Auz.",
                "subregion": "Australia and New Zealand",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "AUS",
                "iso-a2": "AU",
                "woe-id": "-90",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[8298, 5411], [8311, 5405], [8293, 5394], [8271, 5395], [8268, 5405], [8298, 5411]]], [[[8087, 6159], [8084, 6170], [8115, 6169], [8117, 6159], [8102, 6149], [8087, 6159]]], [[[8528, 6017], [8549, 5978], [8545, 5963], [8555, 5954], [8559, 5934], [8587, 5924], [8591, 5915], [8620, 5905], [8637, 5891], [8623, 5889], [8640, 5873], [8651, 5837], [8659, 5840], [8687, 5823], [8689, 5796], [8699, 5799], [8705, 5783], [8719, 5779], [8740, 5746], [8762, 5752], [8753, 5727], [8758, 5687], [8768, 5676], [8765, 5655], [8769, 5630], [8751, 5570], [8749, 5546], [8738, 5514], [8716, 5500], [8690, 5452], [8685, 5424], [8667, 5400], [8660, 5366], [8663, 5346], [8648, 5337], [8613, 5335], [8592, 5326], [8559, 5304], [8557, 5290], [8537, 5307], [8514, 5312], [8515, 5333], [8472, 5300], [8439, 5317], [8417, 5315], [8388, 5327], [8360, 5357], [8364, 5375], [8356, 5396], [8338, 5412], [8312, 5409], [8325, 5439], [8311, 5459], [8299, 5424], [8276, 5420], [8310, 5492], [8293, 5492], [8286, 5475], [8268, 5467], [8239, 5432], [8226, 5467], [8211, 5489], [8199, 5491], [8195, 5514], [8155, 5530], [8139, 5528], [8107, 5546], [8043, 5539], [7993, 5520], [7961, 5521], [7899, 5491], [7882, 5465], [7837, 5469], [7778, 5466], [7763, 5450], [7744, 5448], [7731, 5433], [7694, 5428], [7660, 5436], [7630, 5461], [7630, 5479], [7650, 5487], [7651, 5540], [7630, 5587], [7630, 5610], [7606, 5654], [7602, 5679], [7570, 5728], [7587, 5736], [7604, 5707], [7606, 5727], [7585, 5766], [7594, 5798], [7591, 5827], [7602, 5849], [7607, 5829], [7620, 5850], [7649, 5866], [7644, 5886], [7658, 5874], [7694, 5888], [7712, 5886], [7806, 5917], [7847, 5962], [7842, 5989], [7866, 6010], [7883, 5981], [7892, 5991], [7884, 6023], [7908, 6017], [7909, 6050], [7923, 6047], [7928, 6069], [7973, 6080], [7983, 6095], [8019, 6066], [8015, 6048], [8030, 6065], [8063, 6055], [8054, 6075], [8077, 6119], [8092, 6135], [8152, 6143], [8147, 6162], [8130, 6169], [8149, 6175], [8167, 6156], [8185, 6155], [8223, 6139], [8247, 6152], [8252, 6140], [8264, 6152], [8277, 6138], [8247, 6095], [8277, 6093], [8263, 6081], [8248, 6088], [8234, 6060], [8266, 6036], [8302, 6020], [8318, 6005], [8339, 6000], [8347, 6013], [8346, 5987], [8368, 5976], [8393, 5984], [8410, 6025], [8417, 6054], [8412, 6089], [8415, 6131], [8426, 6146], [8431, 6201], [8445, 6184], [8459, 6137], [8469, 6129], [8472, 6095], [8484, 6072], [8500, 6082], [8526, 6059], [8528, 6017]]], [[[8507, 5242], [8488, 5259], [8507, 5244], [8507, 5242], [8507, 5242], [8507, 5242]]], [[[8507, 5241], [8509, 5240], [8551, 5220], [8599, 5229], [8610, 5240], [8600, 5264], [8613, 5262], [8612, 5197], [8604, 5179], [8603, 5147], [8589, 5160], [8571, 5135], [8546, 5135], [8523, 5169], [8506, 5223], [8507, 5241], [8507, 5241], [8507, 5241]]]]
            }
        }, {
            "type": "Feature",
            "id": "KI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.28,
                "hc-middle-y": 0.65,
                "hc-key": "ki",
                "hc-a2": "KI",
                "name": "Kiribati",
                "labelrank": "6",
                "country-abbrev": "Kir.",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "KIR",
                "iso-a2": "KI",
                "woe-id": "23424867",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[-403, 6559], [-400, 6554], [-395, 6550], [-402, 6552], [-403, 6559]]]
            }
        }, {
            "type": "Feature",
            "id": "PH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.41,
                "hc-middle-y": 0.18,
                "hc-key": "ph",
                "hc-a2": "PH",
                "name": "Philippines",
                "labelrank": "2",
                "country-abbrev": "Phil.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "PHL",
                "iso-a2": "PH",
                "woe-id": "23424934",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7820, 6675], [7805, 6662], [7772, 6650], [7805, 6669], [7826, 6695], [7820, 6675]]], [[[7879, 6795], [7898, 6831], [7897, 6805], [7868, 6765], [7849, 6789], [7863, 6797], [7861, 6809], [7873, 6823], [7884, 6818], [7879, 6795]]], [[[7907, 6844], [7927, 6831], [7925, 6805], [7905, 6782], [7892, 6783], [7901, 6798], [7920, 6803], [7919, 6818], [7908, 6822], [7907, 6844]]], [[[7921, 6839], [7904, 6869], [7931, 6870], [7940, 6861], [7947, 6827], [7933, 6826], [7921, 6839]]], [[[7786, 6903], [7814, 6896], [7829, 6881], [7815, 6860], [7786, 6903]]], [[[7772, 6836], [7775, 6863], [7788, 6856], [7772, 6836], [7772, 6836]]], [[[7771, 6836], [7772, 6836], [7772, 6836], [7772, 6836], [7771, 6836], [7771, 6836], [7771, 6836]]], [[[7839, 6850], [7872, 6837], [7855, 6815], [7836, 6807], [7840, 6843], [7839, 6850], [7839, 6850], [7839, 6850]]], [[[7904, 6717], [7880, 6729], [7861, 6714], [7852, 6726], [7840, 6702], [7840, 6727], [7865, 6740], [7878, 6756], [7893, 6740], [7908, 6753], [7918, 6750], [7919, 6767], [7941, 6765], [7941, 6796], [7965, 6760], [7973, 6713], [7963, 6698], [7950, 6716], [7937, 6696], [7947, 6679], [7938, 6664], [7903, 6681], [7897, 6709], [7904, 6717]]], [[[7908, 6903], [7899, 6870], [7888, 6872], [7898, 6845], [7879, 6859], [7872, 6896], [7853, 6912], [7855, 6888], [7829, 6912], [7812, 6902], [7797, 6907], [7796, 6928], [7781, 6937], [7772, 6970], [7773, 6984], [7790, 6977], [7788, 7020], [7795, 7043], [7814, 7065], [7811, 7052], [7846, 7041], [7841, 7025], [7853, 7006], [7843, 6980], [7825, 6971], [7823, 6945], [7829, 6918], [7851, 6923], [7869, 6912], [7908, 6903]]], [[[7839, 6850], [7836, 6851], [7837, 6860], [7839, 6850], [7839, 6850], [7839, 6850]]], [[[7771, 6836], [7766, 6829], [7770, 6809], [7741, 6791], [7734, 6774], [7700, 6749], [7759, 6815], [7764, 6836], [7771, 6836], [7771, 6836], [7771, 6836]]]]
            }
        }, {
            "type": "Feature",
            "id": "MX",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.49,
                "hc-key": "mx",
                "hc-a2": "MX",
                "name": "Mexico",
                "labelrank": "2",
                "country-abbrev": "Mex.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "MEX",
                "iso-a2": "MX",
                "woe-id": "23424900",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[1681, 7111], [1674, 7102], [1673, 7106], [1676, 7110], [1681, 7111]]], [[[1094, 7147], [1098, 7145], [1107, 7133], [1100, 7138], [1094, 7147]]], [[[938, 7233], [942, 7233], [946, 7228], [945, 7226], [938, 7233]]], [[[932, 7248], [931, 7243], [928, 7242], [931, 7249], [932, 7248]]], [[[843, 7345], [841, 7344], [838, 7346], [843, 7354], [843, 7345]]], [[[753, 7372], [752, 7371], [749, 7379], [753, 7376], [753, 7372]]], [[[921, 7365], [923, 7380], [931, 7375], [928, 7366], [921, 7365]]], [[[893, 7391], [902, 7384], [904, 7374], [890, 7387], [893, 7391]]], [[[1255, 7393], [1253, 7390], [1260, 7389], [1283, 7351], [1305, 7329], [1307, 7313], [1313, 7304], [1315, 7297], [1343, 7282], [1375, 7278], [1360, 7233], [1354, 7172], [1360, 7144], [1375, 7114], [1395, 7090], [1414, 7056], [1433, 7054], [1454, 7037], [1506, 7052], [1531, 7052], [1558, 7068], [1572, 7091], [1576, 7125], [1592, 7133], [1641, 7143], [1682, 7132], [1661, 7101], [1658, 7070], [1649, 7040], [1642, 7044], [1636, 7048], [1619, 7030], [1610, 7027], [1557, 7027], [1556, 7010], [1543, 7010], [1574, 6984], [1571, 6975], [1534, 6975], [1520, 6951], [1519, 6929], [1471, 6975], [1443, 6986], [1425, 6972], [1392, 6962], [1356, 6972], [1327, 6989], [1302, 6993], [1260, 7011], [1237, 7030], [1188, 7043], [1164, 7065], [1143, 7074], [1123, 7106], [1138, 7138], [1125, 7154], [1120, 7175], [1087, 7212], [1055, 7237], [1045, 7256], [1012, 7273], [1019, 7290], [1012, 7302], [980, 7323], [970, 7337], [932, 7374], [904, 7433], [906, 7444], [861, 7463], [853, 7456], [858, 7413], [867, 7399], [889, 7383], [904, 7358], [915, 7361], [914, 7338], [926, 7328], [957, 7282], [957, 7274], [980, 7244], [978, 7225], [1002, 7222], [1012, 7193], [999, 7182], [987, 7203], [933, 7244], [930, 7281], [903, 7304], [890, 7301], [863, 7318], [847, 7337], [873, 7341], [877, 7357], [849, 7386], [828, 7398], [817, 7432], [799, 7456], [786, 7488], [857, 7494], [854, 7487], [964, 7449], [1048, 7449], [1048, 7464], [1099, 7464], [1147, 7424], [1158, 7395], [1198, 7374], [1211, 7398], [1222, 7403], [1255, 7393]], [[1363, 7262], [1357, 7247], [1360, 7234], [1367, 7261], [1363, 7262]]]]
            }
        }, {
            "type": "Feature",
            "id": "ES",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.75,
                "hc-middle-y": 0.27,
                "hc-key": "es",
                "hc-a2": "ES",
                "name": "Spain",
                "labelrank": "2",
                "country-abbrev": "Sp.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ESP",
                "iso-a2": "ES",
                "woe-id": "23424950",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4352, 7741], [4336, 7718], [4309, 7726], [4333, 7738], [4352, 7741]]], [[[4153, 7581], [4154, 7579], [4153, 7579], [4152, 7580], [4153, 7581]]], [[[4080, 7601], [4083, 7600], [4082, 7598], [4081, 7599], [4080, 7601]]], [[[4082, 7608], [4058, 7613], [4048, 7635], [4021, 7643], [4018, 7656], [4032, 7672], [4023, 7686], [4034, 7705], [4017, 7728], [4033, 7729], [4039, 7752], [4035, 7775], [4057, 7794], [4046, 7807], [3998, 7803], [3997, 7815], [3982, 7808], [3979, 7834], [3968, 7851], [3994, 7859], [4006, 7872], [4025, 7865], [4081, 7865], [4116, 7859], [4134, 7864], [4187, 7859], [4200, 7848], [4238, 7834], [4259, 7839], [4282, 7831], [4284, 7825], [4290, 7827], [4297, 7825], [4297, 7826], [4298, 7827], [4299, 7825], [4298, 7825], [4314, 7821], [4333, 7825], [4335, 7808], [4300, 7784], [4269, 7776], [4230, 7723], [4246, 7697], [4225, 7682], [4219, 7658], [4190, 7649], [4179, 7629], [4109, 7627], [4082, 7608], [4082, 7608]]], [[[3736, 7346], [3735, 7346], [3735, 7346], [3735, 7346], [3735, 7346], [3736, 7346], [3736, 7346]]], [[[3736, 7346], [3764, 7361], [3785, 7347], [3780, 7334], [3755, 7347], [3736, 7346], [3736, 7346]]], [[[3735, 7346], [3728, 7346], [3714, 7357], [3717, 7366], [3735, 7346], [3735, 7346], [3735, 7346]]]]
            }
        }, {
            "type": "Feature",
            "id": "BU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.73,
                "hc-key": "bu",
                "hc-a2": "BU",
                "name": "Bajo Nuevo Bank (Petrel Is.)",
                "labelrank": "8",
                "country-abbrev": null,
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "-99",
                "iso-a2": "BU",
                "woe-id": "-99",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1881, 6967], [1881, 6966], [1881, 6967], [1881, 6967], [1881, 6967]]]
            }
        }, {
            "type": "Feature",
            "id": "MV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.53,
                "hc-key": "mv",
                "hc-a2": "MV",
                "name": "Maldives",
                "labelrank": "5",
                "country-abbrev": "Mald.",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "MDV",
                "iso-a2": "MV",
                "woe-id": "23424899",
                "continent": "Seven seas (open ocean)"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6404, 6668], [6411, 6657], [6402, 6657], [6406, 6662], [6404, 6668]]]
            }
        }, {
            "type": "Feature",
            "id": "SP",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "sp",
                "hc-a2": "SP",
                "name": "Spratly Islands",
                "labelrank": "6",
                "country-abbrev": "Spratly Is.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "SPI",
                "iso-a2": "SP",
                "woe-id": "23424921",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7656, 6818], [7655, 6818], [7655, 6819], [7656, 6819], [7656, 6818]]]
            }
        }, {
            "type": "Feature",
            "id": "GB",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.69,
                "hc-middle-y": 0.09,
                "hc-key": "gb",
                "hc-a2": "GB",
                "name": "United Kingdom",
                "labelrank": "2",
                "country-abbrev": "U.K.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "GBR",
                "iso-a2": "GB",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4054, 8383], [4040, 8405], [4053, 8415], [4060, 8397], [4073, 8397], [4054, 8383]]], [[[4144, 8467], [4146, 8463], [4142, 8461], [4138, 8466], [4144, 8467]]], [[[4148, 8478], [4147, 8471], [4152, 8469], [4140, 8472], [4148, 8478]]], [[[4155, 8481], [4149, 8486], [4161, 8480], [4158, 8477], [4155, 8481]]], [[[4209, 8530], [4202, 8508], [4200, 8524], [4191, 8529], [4209, 8530]]], [[[4212, 8543], [4217, 8541], [4205, 8538], [4207, 8547], [4212, 8543]]], [[[4217, 8550], [4215, 8545], [4211, 8545], [4212, 8550], [4217, 8550]]], [[[1840, 7073], [1843, 7075], [1848, 7073], [1843, 7071], [1840, 7073]]], [[[2129, 7148], [2121, 7148], [2121, 7151], [2126, 7150], [2129, 7148]]], [[[2114, 7151], [2112, 7148], [2107, 7148], [2111, 7149], [2114, 7151]]], [[[4030, 8413], [4030, 8436], [4055, 8450], [4052, 8430], [4030, 8413]]], [[[2441, 4827], [2452, 4844], [2466, 4838], [2493, 4842], [2474, 4820], [2453, 4809], [2465, 4830], [2452, 4841], [2441, 4827]]], [[[2479, 4806], [2480, 4819], [2494, 4830], [2501, 4848], [2532, 4843], [2537, 4830], [2498, 4810], [2479, 4806]]], [[[3117, 4738], [3137, 4739], [3162, 4732], [3178, 4718], [3175, 4702], [3164, 4716], [3117, 4738]]], [[[5239, 7568], [5238, 7568], [5236, 7569], [5236, 7569], [5235, 7569], [5236, 7569], [5233, 7569], [5233, 7569], [5234, 7570], [5233, 7571], [5235, 7571], [5239, 7572], [5239, 7572], [5236, 7571], [5239, 7568]], [[5235, 7570], [5235, 7570], [5235, 7570], [5235, 7570]]], [[[4082, 7608], [4082, 7607], [4082, 7608], [4082, 7608]]], [[[5213, 7558], [5210, 7558], [5206, 7558], [5208, 7560], [5213, 7558]]], [[[4026, 8305], [4054, 8315], [4076, 8288], [4061, 8263], [4055, 8266], [4044, 8263], [4033, 8278], [4024, 8266], [3999, 8280], [4026, 8305]]], [[[4102, 8452], [4151, 8455], [4145, 8441], [4119, 8425], [4128, 8421], [4114, 8406], [4137, 8416], [4183, 8414], [4188, 8405], [4165, 8368], [4164, 8355], [4146, 8346], [4177, 8340], [4192, 8326], [4204, 8287], [4223, 8281], [4237, 8266], [4249, 8225], [4240, 8217], [4277, 8219], [4289, 8212], [4286, 8185], [4260, 8161], [4282, 8158], [4280, 8148], [4248, 8133], [4206, 8134], [4167, 8127], [4139, 8128], [4132, 8113], [4115, 8121], [4079, 8111], [4117, 8151], [4149, 8151], [4159, 8162], [4135, 8158], [4111, 8173], [4094, 8166], [4083, 8176], [4116, 8193], [4119, 8218], [4099, 8213], [4116, 8230], [4146, 8237], [4155, 8269], [4144, 8266], [4132, 8282], [4140, 8298], [4110, 8299], [4111, 8278], [4107, 8290], [4088, 8296], [4103, 8323], [4079, 8342], [4073, 8360], [4045, 8371], [4069, 8377], [4076, 8401], [4069, 8422], [4086, 8426], [4081, 8439], [4093, 8455], [4102, 8452]]]]
            }
        }, {
            "type": "Feature",
            "id": "GR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.32,
                "hc-middle-y": 0.74,
                "hc-key": "gr",
                "hc-a2": "GR",
                "name": "Greece",
                "labelrank": "3",
                "country-abbrev": "Greece",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "GRC",
                "iso-a2": "GR",
                "woe-id": "23424833",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5036, 7583], [5042, 7597], [5040, 7590], [5043, 7586], [5036, 7583]]], [[[5054, 7611], [5072, 7618], [5067, 7607], [5059, 7599], [5054, 7611]]], [[[5041, 7624], [5034, 7626], [5041, 7633], [5040, 7629], [5041, 7624]]], [[[5033, 7640], [5037, 7637], [5033, 7635], [5034, 7638], [5033, 7640]]], [[[4983, 7636], [4993, 7644], [4994, 7637], [4988, 7625], [4983, 7636]]], [[[5016, 7658], [5008, 7654], [5006, 7655], [5009, 7658], [5016, 7658]]], [[[5034, 7662], [5038, 7661], [5030, 7659], [5024, 7663], [5034, 7662]]], [[[5008, 7691], [5011, 7681], [5006, 7682], [5002, 7691], [5008, 7691]]], [[[4961, 7702], [4949, 7684], [4917, 7701], [4952, 7693], [4961, 7702]]], [[[5018, 7716], [5024, 7707], [5019, 7704], [5001, 7711], [5018, 7716]]], [[[4990, 7740], [4983, 7740], [4990, 7756], [4997, 7756], [4990, 7740]]], [[[5015, 7579], [5010, 7570], [4969, 7567], [4968, 7573], [4933, 7580], [4953, 7588], [5015, 7579]]], [[[4859, 7763], [4863, 7766], [4859, 7764], [4857, 7766], [4858, 7767], [4860, 7769], [4862, 7769], [4886, 7778], [4915, 7786], [4962, 7794], [4984, 7783], [5010, 7787], [5016, 7799], [5025, 7788], [5008, 7765], [4978, 7775], [4970, 7761], [4964, 7773], [4938, 7763], [4959, 7746], [4939, 7752], [4928, 7747], [4908, 7756], [4905, 7741], [4928, 7711], [4911, 7698], [4946, 7681], [4949, 7660], [4925, 7670], [4910, 7656], [4924, 7618], [4919, 7608], [4912, 7630], [4903, 7619], [4893, 7638], [4885, 7628], [4875, 7656], [4862, 7665], [4870, 7678], [4887, 7682], [4914, 7672], [4924, 7674], [4887, 7685], [4863, 7681], [4855, 7698], [4848, 7665], [4843, 7680], [4850, 7707], [4829, 7729], [4841, 7734], [4859, 7763]]]]
            }
        }, {
            "type": "Feature",
            "id": "AS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.57,
                "hc-key": "as",
                "hc-a2": "AS",
                "name": "American Samoa",
                "labelrank": "4",
                "country-abbrev": "Am. Samoa",
                "subregion": "Polynesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "ASM",
                "iso-a2": "AS",
                "woe-id": "23424746",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[-792, 6080], [-793, 6079], [-796, 6076], [-798, 6078], [-792, 6080]]]
            }
        }, {
            "type": "Feature",
            "id": "DK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.3,
                "hc-middle-y": 0.43,
                "hc-key": "dk",
                "hc-a2": "DK",
                "name": "Denmark",
                "labelrank": "4",
                "country-abbrev": "Den.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "DNK",
                "iso-a2": "DK",
                "woe-id": "23424796",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4572, 8300], [4587, 8288], [4577, 8287], [4564, 8293], [4572, 8300]]], [[[4545, 8298], [4550, 8296], [4546, 8295], [4540, 8301], [4545, 8298]]], [[[4609, 8302], [4600, 8298], [4599, 8302], [4603, 8304], [4609, 8302]]], [[[4528, 8306], [4535, 8301], [4534, 8297], [4528, 8299], [4528, 8306]]], [[[4559, 8300], [4556, 8292], [4553, 8296], [4563, 8309], [4559, 8300]]], [[[4550, 8335], [4558, 8312], [4541, 8306], [4525, 8323], [4550, 8335]]], [[[4611, 8331], [4601, 8325], [4592, 8290], [4583, 8310], [4572, 8311], [4567, 8329], [4584, 8340], [4587, 8331], [4601, 8349], [4611, 8331]]], [[[4518, 8295], [4500, 8298], [4495, 8298], [4494, 8320], [4478, 8325], [4487, 8340], [4479, 8367], [4492, 8368], [4528, 8390], [4502, 8385], [4491, 8369], [4483, 8378], [4494, 8391], [4517, 8392], [4534, 8410], [4553, 8417], [4542, 8382], [4545, 8367], [4563, 8362], [4520, 8322], [4527, 8302], [4518, 8295]]]]
            }
        }, {
            "type": "Feature",
            "id": "GL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.4,
                "hc-key": "gl",
                "hc-a2": "GL",
                "name": "Greenland",
                "labelrank": "3",
                "country-abbrev": "Grlnd.",
                "subregion": "Northern America",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "GRL",
                "iso-a2": "GL",
                "woe-id": "23424828",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2678, 8916], [2681, 8914], [2674, 8911], [2670, 8915], [2678, 8916]]], [[[2702, 8929], [2673, 8922], [2676, 8925], [2688, 8928], [2702, 8929]]], [[[2628, 9017], [2620, 9016], [2617, 9022], [2624, 9021], [2628, 9017]]], [[[3424, 9036], [3421, 9043], [3453, 9044], [3492, 9054], [3493, 9031], [3467, 9021], [3456, 9024], [3412, 9019], [3424, 9036]]], [[[2662, 9052], [2648, 9056], [2659, 9067], [2665, 9056], [2662, 9052]]], [[[2687, 9059], [2674, 9061], [2678, 9071], [2697, 9066], [2687, 9059]]], [[[2601, 9094], [2594, 9099], [2601, 9101], [2606, 9098], [2601, 9094]]], [[[2598, 9147], [2591, 9141], [2582, 9143], [2589, 9147], [2598, 9147]]], [[[2618, 9149], [2602, 9135], [2600, 9147], [2610, 9150], [2618, 9149]]], [[[3554, 9164], [3594, 9155], [3594, 9143], [3572, 9143], [3557, 9153], [3516, 9155], [3516, 9160], [3554, 9164]]], [[[2590, 9192], [2604, 9184], [2600, 9184], [2585, 9192], [2590, 9192]]], [[[2580, 9211], [2589, 9209], [2570, 9207], [2570, 9213], [2580, 9211]]], [[[3622, 9242], [3645, 9227], [3612, 9222], [3593, 9229], [3596, 9238], [3622, 9242]]], [[[2574, 9246], [2556, 9246], [2542, 9246], [2567, 9250], [2574, 9246]]], [[[3715, 9294], [3703, 9290], [3728, 9277], [3682, 9276], [3684, 9293], [3706, 9301], [3715, 9294]]], [[[2187, 9369], [2175, 9370], [2176, 9372], [2188, 9373], [2187, 9369]]], [[[2110, 9425], [2135, 9420], [2125, 9417], [2101, 9421], [2110, 9425]]], [[[2149, 9427], [2168, 9421], [2144, 9421], [2137, 9425], [2149, 9427]]], [[[3729, 9590], [3714, 9574], [3694, 9570], [3667, 9581], [3716, 9598], [3729, 9590]]], [[[2267, 9638], [2276, 9633], [2270, 9632], [2267, 9634], [2267, 9638]]], [[[2729, 9730], [2703, 9730], [2671, 9739], [2667, 9749], [2683, 9754], [2729, 9730]]], [[[3059, 9809], [3044, 9816], [3081, 9810], [3064, 9802], [3039, 9806], [3018, 9817], [3059, 9809]]], [[[2655, 8957], [2641, 8968], [2665, 8967], [2618, 8981], [2623, 9007], [2637, 9013], [2669, 9007], [2685, 8992], [2706, 8986], [2702, 8969], [2655, 8957]]], [[[3585, 9111], [3521, 9138], [3518, 9150], [3557, 9151], [3592, 9131], [3572, 9130], [3590, 9119], [3585, 9111]]], [[[3555, 9173], [3503, 9179], [3562, 9166], [3518, 9162], [3481, 9171], [3495, 9183], [3518, 9184], [3555, 9173]]], [[[2674, 8775], [2670, 8778], [2658, 8799], [2658, 8818], [2671, 8830], [2698, 8839], [2658, 8838], [2648, 8846], [2702, 8861], [2651, 8854], [2653, 8863], [2696, 8884], [2682, 8882], [2657, 8868], [2656, 8883], [2672, 8887], [2672, 8903], [2708, 8895], [2723, 8903], [2693, 8902], [2689, 8911], [2707, 8920], [2731, 8921], [2733, 8951], [2760, 8945], [2751, 8960], [2739, 8953], [2741, 8981], [2758, 8984], [2748, 8992], [2728, 8972], [2723, 8994], [2696, 8999], [2670, 9015], [2652, 9016], [2630, 9034], [2648, 9040], [2693, 9034], [2719, 9019], [2746, 9014], [2721, 9032], [2722, 9045], [2703, 9042], [2711, 9053], [2694, 9058], [2699, 9069], [2677, 9073], [2713, 9082], [2683, 9085], [2670, 9078], [2663, 9085], [2674, 9086], [2678, 9086], [2645, 9089], [2649, 9073], [2609, 9070], [2591, 9087], [2610, 9100], [2600, 9104], [2621, 9118], [2616, 9122], [2616, 9122], [2603, 9112], [2599, 9117], [2614, 9124], [2603, 9133], [2617, 9133], [2629, 9151], [2614, 9157], [2616, 9158], [2602, 9163], [2601, 9162], [2598, 9163], [2610, 9182], [2587, 9196], [2598, 9211], [2576, 9221], [2585, 9233], [2550, 9223], [2584, 9239], [2556, 9271], [2525, 9280], [2531, 9285], [2510, 9298], [2522, 9302], [2516, 9319], [2499, 9318], [2492, 9328], [2445, 9345], [2406, 9349], [2368, 9359], [2351, 9344], [2332, 9352], [2332, 9343], [2287, 9353], [2281, 9341], [2266, 9352], [2255, 9346], [2279, 9332], [2222, 9340], [2186, 9359], [2235, 9377], [2208, 9376], [2163, 9384], [2136, 9397], [2149, 9409], [2202, 9414], [2223, 9421], [2271, 9419], [2290, 9424], [2285, 9436], [2260, 9439], [2246, 9430], [2198, 9425], [2167, 9433], [2190, 9440], [2155, 9442], [2173, 9451], [2137, 9445], [2090, 9470], [2099, 9494], [2130, 9502], [2194, 9512], [2204, 9524], [2233, 9530], [2294, 9532], [2327, 9558], [2322, 9593], [2297, 9592], [2280, 9599], [2262, 9596], [2250, 9615], [2271, 9629], [2319, 9645], [2329, 9659], [2382, 9676], [2425, 9665], [2443, 9673], [2432, 9686], [2447, 9696], [2427, 9712], [2468, 9727], [2505, 9721], [2509, 9708], [2525, 9707], [2515, 9722], [2486, 9731], [2511, 9738], [2634, 9758], [2660, 9739], [2653, 9699], [2679, 9721], [2679, 9734], [2724, 9724], [2757, 9711], [2735, 9728], [2770, 9721], [2781, 9727], [2748, 9742], [2733, 9768], [2794, 9764], [2802, 9757], [2883, 9733], [2908, 9716], [2935, 9720], [2914, 9734], [2917, 9739], [2857, 9757], [2814, 9788], [2816, 9796], [2839, 9791], [2833, 9777], [2874, 9780], [2929, 9760], [2911, 9747], [2917, 9740], [2919, 9744], [2950, 9760], [2891, 9787], [3000, 9786], [3010, 9766], [3014, 9785], [3053, 9772], [3066, 9757], [3061, 9781], [3031, 9787], [2894, 9795], [2858, 9802], [2882, 9811], [2909, 9803], [2961, 9798], [2909, 9806], [2898, 9812], [2923, 9817], [2975, 9812], [2942, 9819], [2998, 9822], [3040, 9803], [3077, 9801], [3100, 9785], [3087, 9804], [3100, 9812], [3041, 9824], [3046, 9831], [3094, 9816], [3099, 9835], [3131, 9841], [3154, 9836], [3156, 9844], [3200, 9844], [3281, 9851], [3287, 9846], [3336, 9849], [3395, 9843], [3403, 9839], [3483, 9826], [3471, 9819], [3333, 9814], [3265, 9804], [3191, 9798], [3209, 9797], [3301, 9803], [3352, 9813], [3432, 9808], [3496, 9816], [3518, 9796], [3572, 9789], [3610, 9776], [3578, 9755], [3535, 9751], [3359, 9741], [3357, 9737], [3303, 9728], [3273, 9719], [3275, 9709], [3292, 9708], [3305, 9719], [3421, 9735], [3514, 9730], [3511, 9715], [3464, 9703], [3461, 9690], [3484, 9699], [3539, 9713], [3547, 9710], [3556, 9732], [3609, 9737], [3620, 9714], [3613, 9696], [3558, 9655], [3592, 9662], [3654, 9698], [3653, 9707], [3677, 9704], [3678, 9718], [3660, 9738], [3677, 9734], [3690, 9718], [3715, 9713], [3737, 9700], [3774, 9719], [3829, 9717], [3885, 9705], [3904, 9692], [3881, 9683], [3846, 9661], [3810, 9659], [3818, 9645], [3785, 9636], [3736, 9637], [3691, 9631], [3707, 9625], [3741, 9631], [3774, 9619], [3755, 9606], [3713, 9602], [3674, 9610], [3686, 9599], [3660, 9593], [3660, 9607], [3639, 9584], [3651, 9570], [3673, 9572], [3663, 9550], [3681, 9535], [3652, 9526], [3668, 9506], [3637, 9516], [3611, 9477], [3608, 9453], [3627, 9458], [3673, 9455], [3672, 9485], [3697, 9501], [3720, 9538], [3702, 9500], [3683, 9485], [3682, 9463], [3669, 9443], [3680, 9436], [3720, 9448], [3702, 9437], [3692, 9415], [3701, 9392], [3688, 9368], [3693, 9332], [3676, 9364], [3687, 9382], [3635, 9394], [3599, 9376], [3583, 9388], [3569, 9378], [3600, 9368], [3600, 9351], [3652, 9351], [3659, 9343], [3642, 9335], [3595, 9333], [3652, 9332], [3669, 9319], [3667, 9289], [3653, 9285], [3645, 9296], [3630, 9293], [3601, 9311], [3611, 9297], [3635, 9284], [3617, 9281], [3651, 9276], [3647, 9258], [3673, 9251], [3700, 9259], [3668, 9233], [3644, 9233], [3639, 9243], [3598, 9243], [3584, 9223], [3630, 9211], [3634, 9186], [3604, 9188], [3582, 9174], [3558, 9180], [3532, 9194], [3530, 9207], [3518, 9191], [3494, 9187], [3468, 9174], [3501, 9165], [3498, 9154], [3482, 9155], [3511, 9142], [3516, 9128], [3576, 9099], [3560, 9088], [3594, 9090], [3578, 9081], [3580, 9064], [3598, 9076], [3596, 9064], [3606, 9025], [3580, 9020], [3578, 9041], [3571, 9020], [3551, 9020], [3534, 9029], [3524, 9054], [3477, 9081], [3450, 9079], [3417, 9103], [3400, 9101], [3434, 9089], [3424, 9083], [3453, 9076], [3481, 9075], [3485, 9060], [3448, 9046], [3402, 9048], [3416, 9043], [3407, 9016], [3451, 9022], [3417, 9001], [3435, 8996], [3448, 9010], [3463, 9007], [3493, 9018], [3545, 9002], [3580, 9002], [3554, 8978], [3529, 8972], [3514, 8958], [3464, 8928], [3437, 8920], [3413, 8921], [3373, 8903], [3325, 8895], [3305, 8898], [3284, 8924], [3296, 8895], [3256, 8871], [3258, 8857], [3218, 8811], [3167, 8785], [3135, 8781], [3151, 8776], [3123, 8772], [3125, 8795], [3142, 8810], [3119, 8805], [3119, 8791], [3104, 8777], [3056, 8767], [3075, 8760], [3052, 8745], [3029, 8749], [3045, 8736], [3035, 8715], [3045, 8684], [3026, 8675], [3028, 8661], [2996, 8631], [2985, 8592], [2984, 8568], [2966, 8569], [2983, 8555], [2977, 8542], [2959, 8536], [2965, 8513], [2932, 8509], [2901, 8523], [2899, 8543], [2871, 8547], [2893, 8563], [2887, 8570], [2867, 8549], [2826, 8552], [2818, 8568], [2793, 8577], [2784, 8594], [2786, 8611], [2756, 8627], [2761, 8647], [2747, 8649], [2724, 8672], [2728, 8716], [2704, 8703], [2701, 8735], [2706, 8744], [2683, 8770], [2678, 8773], [2677, 8772], [2672, 8772], [2672, 8775], [2674, 8775]]]]
            }
        }, {
            "type": "Feature",
            "id": "GU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.44,
                "hc-key": "gu",
                "hc-a2": "GU",
                "name": "Guam",
                "labelrank": "6",
                "country-abbrev": "Guam",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "GUM",
                "iso-a2": "GU",
                "woe-id": "23424832",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[8510, 6896], [8506, 6890], [8504, 6896], [8512, 6902], [8510, 6896]]]
            }
        }, {
            "type": "Feature",
            "id": "MP",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.49,
                "hc-key": "mp",
                "hc-a2": "MP",
                "name": "Northern Mariana Islands",
                "labelrank": "6",
                "country-abbrev": "N.M.I.",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "MNP",
                "iso-a2": "MP",
                "woe-id": "23424788",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[8535, 6943], [8536, 6949], [8540, 6951], [8538, 6946], [8535, 6943]]]
            }
        }, {
            "type": "Feature",
            "id": "PR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.65,
                "hc-key": "pr",
                "hc-a2": "PR",
                "name": "Puerto Rico",
                "labelrank": "5",
                "country-abbrev": "P.R.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "PRI",
                "iso-a2": "PR",
                "woe-id": "23424935",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2315, 7041], [2287, 7031], [2261, 7031], [2261, 7049], [2315, 7041]]]
            }
        }, {
            "type": "Feature",
            "id": "VI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.19,
                "hc-key": "vi",
                "hc-a2": "VI",
                "name": "United States Virgin Islands",
                "labelrank": "6",
                "country-abbrev": "V.I. (U.S.)",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "VIR",
                "iso-a2": "VI",
                "woe-id": "23424985",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2331, 7026], [2336, 7025], [2326, 7023], [2326, 7026], [2331, 7026]]]
            }
        }, {
            "type": "Feature",
            "id": "CA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.29,
                "hc-middle-y": 0.66,
                "hc-key": "ca",
                "hc-a2": "CA",
                "name": "Canada",
                "labelrank": "2",
                "country-abbrev": "Can.",
                "subregion": "Northern America",
                "region-wb": "North America",
                "iso-a3": "CAN",
                "iso-a2": "CA",
                "woe-id": "23424775",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[1908, 7849], [1909, 7845], [1912, 7843], [1875, 7838], [1865, 7830], [1840, 7833], [1826, 7819], [1803, 7811], [1790, 7820], [1809, 7821], [1802, 7829], [1806, 7832], [1809, 7846], [1829, 7857], [1829, 7884], [1843, 7903], [1830, 7925], [1842, 7926], [1858, 7907], [1877, 7898], [1889, 7909], [1858, 7951], [1830, 7958], [1759, 7966], [1759, 7973], [1748, 7970], [1740, 7990], [1745, 8002], [1733, 8014], [1738, 8025], [1708, 8027], [1691, 8057], [1667, 8057], [1644, 8065], [1630, 8060], [1623, 8042], [1598, 8028], [1543, 8029], [1507, 8048], [1447, 8058], [1443, 8077], [1433, 8065], [620, 8065], [614, 8069], [611, 8065], [610, 8065], [604, 8080], [584, 8086], [561, 8102], [565, 8113], [558, 8115], [560, 8114], [563, 8111], [558, 8108], [556, 8115], [547, 8117], [548, 8119], [545, 8121], [544, 8118], [535, 8119], [532, 8119], [539, 8117], [544, 8110], [544, 8109], [549, 8104], [549, 8104], [567, 8080], [584, 8075], [596, 8060], [595, 8063], [603, 8059], [611, 8058], [600, 8055], [604, 8051], [596, 8040], [563, 8050], [528, 8069], [527, 8072], [525, 8072], [526, 8073], [522, 8083], [507, 8081], [505, 8090], [506, 8090], [502, 8098], [502, 8098], [501, 8102], [471, 8107], [453, 8134], [469, 8138], [495, 8126], [531, 8119], [527, 8120], [530, 8119], [533, 8120], [517, 8123], [517, 8126], [511, 8124], [506, 8125], [510, 8128], [517, 8126], [518, 8132], [516, 8129], [506, 8129], [515, 8136], [518, 8133], [519, 8137], [502, 8134], [472, 8149], [469, 8179], [490, 8194], [484, 8193], [484, 8192], [468, 8180], [472, 8191], [469, 8190], [461, 8212], [446, 8226], [439, 8208], [430, 8222], [431, 8226], [426, 8227], [426, 8230], [430, 8234], [431, 8227], [433, 8233], [444, 8229], [440, 8233], [447, 8263], [434, 8247], [441, 8250], [439, 8245], [433, 8242], [431, 8244], [426, 8237], [392, 8274], [406, 8303], [406, 8314], [405, 8340], [403, 8348], [352, 8368], [340, 8394], [306, 8445], [260, 8483], [244, 8506], [219, 8497], [211, 8478], [187, 8467], [182, 8481], [135, 8518], [138, 8530], [111, 8523], [82, 8528], [81, 8978], [136, 8971], [151, 8959], [193, 8941], [233, 8939], [234, 8960], [254, 8958], [255, 8969], [274, 8967], [279, 8982], [295, 8970], [280, 8956], [311, 8965], [321, 8978], [344, 8982], [395, 9005], [421, 8998], [375, 8977], [348, 8972], [323, 8956], [306, 8936], [327, 8936], [321, 8947], [348, 8957], [370, 8974], [378, 8958], [396, 8979], [430, 8987], [436, 8979], [454, 9001], [477, 9010], [460, 9016], [465, 9028], [490, 9010], [505, 8982], [540, 8960], [539, 8971], [568, 9002], [569, 8982], [581, 8982], [571, 8963], [608, 8970], [614, 8988], [659, 8984], [693, 8965], [740, 8956], [759, 8945], [820, 8934], [821, 8944], [847, 8937], [872, 8921], [877, 8905], [849, 8907], [833, 8890], [882, 8877], [950, 8879], [986, 8891], [1010, 8877], [1021, 8881], [1030, 8860], [1055, 8856], [1051, 8835], [1068, 8819], [1078, 8849], [1055, 8878], [1072, 8895], [1091, 8898], [1101, 8911], [1121, 8914], [1124, 8925], [1098, 8920], [1066, 8901], [1031, 8907], [1047, 8924], [1076, 8928], [1106, 8939], [1120, 8938], [1134, 8911], [1155, 8905], [1158, 8894], [1192, 8893], [1224, 8879], [1246, 8876], [1270, 8885], [1339, 8882], [1363, 8872], [1367, 8875], [1364, 8874], [1363, 8877], [1369, 8879], [1369, 8877], [1376, 8881], [1359, 8894], [1348, 8888], [1329, 8911], [1371, 8917], [1385, 8894], [1412, 8908], [1395, 8866], [1416, 8861], [1429, 8837], [1428, 8870], [1418, 8878], [1425, 8896], [1442, 8894], [1469, 8917], [1480, 8936], [1449, 8931], [1464, 8951], [1458, 8967], [1403, 8989], [1393, 9014], [1402, 9027], [1390, 9040], [1395, 9066], [1424, 9076], [1410, 9080], [1432, 9101], [1449, 9104], [1434, 9102], [1434, 9130], [1417, 9149], [1421, 9169], [1417, 9197], [1431, 9203], [1431, 9218], [1477, 9227], [1519, 9217], [1539, 9219], [1580, 9212], [1531, 9152], [1515, 9144], [1463, 9147], [1483, 9130], [1464, 9106], [1452, 9104], [1491, 9075], [1501, 9058], [1496, 9042], [1514, 9032], [1540, 9004], [1501, 8981], [1533, 8969], [1544, 8979], [1573, 8970], [1567, 8963], [1568, 8963], [1572, 8956], [1568, 8954], [1566, 8962], [1562, 8957], [1549, 8959], [1573, 8938], [1568, 8915], [1578, 8905], [1594, 8926], [1595, 8946], [1617, 8956], [1646, 8930], [1651, 8910], [1633, 8907], [1640, 8876], [1660, 8860], [1659, 8848], [1677, 8862], [1706, 8895], [1713, 8930], [1741, 8946], [1719, 8958], [1718, 8984], [1753, 8989], [1770, 8981], [1803, 8978], [1817, 8959], [1841, 8954], [1827, 8939], [1843, 8925], [1821, 8915], [1803, 8915], [1821, 8899], [1819, 8888], [1844, 8865], [1836, 8842], [1823, 8841], [1804, 8821], [1781, 8810], [1752, 8841], [1733, 8841], [1753, 8831], [1772, 8803], [1725, 8807], [1719, 8821], [1680, 8815], [1708, 8801], [1690, 8781], [1663, 8760], [1647, 8761], [1595, 8790], [1554, 8790], [1587, 8783], [1614, 8760], [1673, 8756], [1676, 8751], [1650, 8721], [1645, 8706], [1614, 8695], [1586, 8705], [1581, 8681], [1557, 8677], [1532, 8684], [1565, 8667], [1567, 8653], [1544, 8640], [1513, 8641], [1530, 8634], [1506, 8626], [1506, 8617], [1485, 8606], [1490, 8595], [1457, 8553], [1443, 8512], [1444, 8474], [1455, 8459], [1493, 8460], [1513, 8404], [1507, 8383], [1555, 8397], [1619, 8380], [1645, 8362], [1657, 8346], [1713, 8327], [1744, 8312], [1765, 8316], [1812, 8305], [1809, 8271], [1818, 8254], [1813, 8220], [1834, 8200], [1828, 8192], [1852, 8182], [1868, 8156], [1888, 8147], [1900, 8169], [1912, 8152], [1909, 8173], [1925, 8196], [1910, 8223], [1906, 8267], [1887, 8288], [1946, 8314], [1978, 8345], [1984, 8376], [1967, 8426], [1923, 8455], [1923, 8467], [1945, 8484], [1945, 8501], [1960, 8506], [1935, 8553], [1953, 8581], [1937, 8599], [1935, 8618], [1955, 8632], [2035, 8611], [2067, 8626], [2104, 8606], [2110, 8593], [2126, 8589], [2122, 8575], [2152, 8562], [2194, 8550], [2180, 8538], [2190, 8501], [2183, 8494], [2192, 8466], [2212, 8468], [2241, 8448], [2244, 8433], [2274, 8451], [2282, 8465], [2299, 8465], [2312, 8483], [2307, 8503], [2327, 8531], [2341, 8526], [2346, 8504], [2350, 8509], [2353, 8505], [2349, 8502], [2347, 8503], [2350, 8488], [2370, 8484], [2384, 8454], [2417, 8405], [2411, 8396], [2430, 8390], [2413, 8369], [2434, 8363], [2413, 8353], [2438, 8351], [2476, 8307], [2499, 8309], [2502, 8296], [2545, 8288], [2551, 8282], [2486, 8255], [2468, 8252], [2460, 8237], [2499, 8250], [2529, 8271], [2547, 8267], [2555, 8251], [2594, 8240], [2600, 8190], [2560, 8159], [2539, 8161], [2512, 8150], [2475, 8117], [2420, 8108], [2402, 8115], [2315, 8116], [2280, 8114], [2260, 8097], [2253, 8079], [2233, 8077], [2203, 8057], [2177, 8019], [2139, 7984], [2144, 7986], [2145, 7985], [2147, 7987], [2160, 7991], [2203, 8037], [2228, 8052], [2287, 8074], [2324, 8074], [2346, 8062], [2343, 8044], [2310, 8028], [2296, 8036], [2278, 8032], [2304, 8016], [2337, 8022], [2319, 7998], [2337, 7965], [2350, 7955], [2397, 7939], [2414, 7950], [2441, 7929], [2380, 7905], [2356, 7906], [2305, 7860], [2287, 7884], [2293, 7902], [2327, 7922], [2371, 7930], [2335, 7932], [2337, 7950], [2297, 7925], [2259, 7924], [2250, 7927], [2251, 7939], [2244, 7941], [2240, 7945], [2240, 7994], [2224, 8004], [2208, 7998], [2198, 8008], [2175, 7980], [2167, 7950], [2131, 7918], [2036, 7917], [2072, 7933], [2082, 7955], [2120, 7978], [2125, 7980], [2120, 7979], [2087, 7961], [2072, 7944], [2070, 7942], [2068, 7939], [2073, 7943], [2071, 7936], [2069, 7933], [2058, 7933], [2036, 7917], [2020, 7912], [2005, 7899], [1974, 7887], [1965, 7876], [1951, 7882], [1911, 7876], [1887, 7857], [1908, 7855], [1909, 7851], [1908, 7849]], [[2064, 7937], [2059, 7934], [2065, 7937], [2064, 7937]], [[603, 8082], [602, 8086], [599, 8085], [599, 8083], [603, 8082]]], [[[592, 8070], [596, 8065], [603, 8062], [597, 8063], [592, 8070]]], [[[522, 8076], [517, 8076], [517, 8080], [521, 8080], [522, 8076]]], [[[2348, 8102], [2371, 8097], [2415, 8079], [2404, 8068], [2364, 8081], [2341, 8096], [2348, 8102]]], [[[554, 8105], [552, 8108], [554, 8111], [557, 8107], [554, 8105]]], [[[469, 8161], [462, 8162], [460, 8167], [465, 8171], [469, 8161]]], [[[466, 8184], [461, 8172], [458, 8176], [461, 8183], [466, 8184]]], [[[1908, 8186], [1900, 8181], [1892, 8179], [1891, 8183], [1908, 8186]]], [[[376, 8186], [374, 8184], [373, 8182], [373, 8188], [376, 8186]]], [[[469, 8189], [467, 8185], [463, 8185], [461, 8188], [469, 8189]]], [[[459, 8182], [456, 8186], [458, 8189], [461, 8189], [459, 8182]]], [[[457, 8191], [455, 8188], [450, 8188], [452, 8191], [457, 8191]]], [[[466, 8193], [468, 8190], [463, 8189], [464, 8192], [466, 8193]]], [[[445, 8201], [447, 8195], [445, 8192], [442, 8200], [445, 8201]]], [[[450, 8205], [451, 8201], [449, 8199], [443, 8205], [450, 8205]]], [[[357, 8210], [363, 8211], [363, 8207], [359, 8205], [357, 8210]]], [[[454, 8197], [452, 8207], [454, 8213], [457, 8201], [454, 8197]]], [[[426, 8213], [437, 8207], [438, 8201], [432, 8204], [426, 8213]]], [[[457, 8206], [457, 8209], [455, 8213], [460, 8213], [457, 8206]]], [[[419, 8224], [419, 8220], [417, 8220], [414, 8227], [419, 8224]]], [[[423, 8227], [427, 8221], [424, 8221], [420, 8229], [423, 8227]]], [[[1838, 8231], [1847, 8230], [1860, 8209], [1820, 8222], [1838, 8231]]], [[[1885, 8228], [1886, 8226], [1883, 8225], [1884, 8229], [1885, 8228]]], [[[438, 8235], [432, 8234], [431, 8236], [436, 8243], [438, 8235]]], [[[389, 8241], [391, 8247], [410, 8237], [408, 8228], [389, 8241]]], [[[403, 8246], [396, 8246], [394, 8249], [399, 8253], [403, 8246]]], [[[413, 8248], [426, 8236], [419, 8230], [397, 8255], [413, 8248]]], [[[387, 8266], [396, 8264], [399, 8260], [388, 8253], [387, 8266]]], [[[375, 8285], [384, 8286], [386, 8276], [378, 8280], [375, 8285]]], [[[1902, 8298], [1892, 8295], [1891, 8296], [1909, 8300], [1902, 8298]]], [[[393, 8293], [392, 8295], [401, 8304], [398, 8295], [393, 8293]]], [[[1911, 8347], [1917, 8362], [1920, 8362], [1920, 8351], [1911, 8347]]], [[[1893, 8369], [1893, 8362], [1881, 8352], [1892, 8362], [1893, 8369]]], [[[1885, 8380], [1882, 8379], [1885, 8383], [1889, 8378], [1885, 8380]]], [[[2248, 8441], [2244, 8442], [2245, 8445], [2247, 8446], [2248, 8441]]], [[[2203, 8471], [2194, 8469], [2194, 8477], [2201, 8477], [2203, 8471]]], [[[1869, 8501], [1874, 8503], [1876, 8501], [1873, 8498], [1869, 8501]]], [[[1881, 8509], [1884, 8509], [1880, 8505], [1875, 8504], [1881, 8509]]], [[[2332, 8541], [2340, 8527], [2331, 8531], [2328, 8536], [2332, 8541]]], [[[2232, 8541], [2239, 8535], [2235, 8528], [2222, 8528], [2232, 8541]]], [[[1933, 8552], [1929, 8549], [1919, 8546], [1922, 8549], [1933, 8552]]], [[[2329, 8587], [2327, 8574], [2308, 8586], [2321, 8591], [2329, 8587]]], [[[2300, 8597], [2302, 8593], [2295, 8595], [2299, 8599], [2300, 8597]]], [[[1502, 8602], [1495, 8597], [1491, 8601], [1496, 8601], [1502, 8602]]], [[[2321, 8601], [2328, 8594], [2318, 8595], [2315, 8599], [2321, 8601]]], [[[1897, 8622], [1900, 8604], [1888, 8586], [1875, 8594], [1874, 8611], [1897, 8622]]], [[[1516, 8622], [1517, 8624], [1522, 8623], [1520, 8621], [1516, 8622]]], [[[2332, 8629], [2340, 8629], [2335, 8621], [2325, 8624], [2332, 8629]]], [[[1944, 8630], [1937, 8631], [1951, 8631], [1947, 8629], [1944, 8630]]], [[[2326, 8630], [2319, 8629], [2322, 8632], [2325, 8632], [2326, 8630]]], [[[2044, 8638], [2056, 8635], [2058, 8632], [2046, 8633], [2044, 8638]]], [[[2152, 8643], [2170, 8631], [2154, 8630], [2139, 8645], [2152, 8643]]], [[[1818, 8649], [1823, 8636], [1788, 8612], [1772, 8611], [1765, 8627], [1784, 8647], [1818, 8649]]], [[[2271, 8648], [2270, 8647], [2262, 8655], [2266, 8653], [2271, 8648]]], [[[1927, 8673], [1949, 8671], [1952, 8659], [1941, 8654], [1927, 8673]]], [[[1566, 8673], [1564, 8671], [1563, 8674], [1557, 8676], [1566, 8673]]], [[[2347, 8678], [2343, 8673], [2345, 8666], [2338, 8679], [2347, 8678]]], [[[1965, 8681], [1982, 8672], [1969, 8669], [1956, 8678], [1965, 8681]]], [[[2345, 8686], [2342, 8686], [2342, 8690], [2347, 8688], [2345, 8686]]], [[[1953, 8698], [1947, 8694], [1940, 8696], [1941, 8698], [1953, 8698]]], [[[2325, 8707], [2323, 8706], [2321, 8713], [2326, 8710], [2325, 8707]]], [[[2072, 8720], [2071, 8712], [2068, 8712], [2067, 8722], [2072, 8720]]], [[[2314, 8731], [2316, 8727], [2303, 8721], [2309, 8729], [2314, 8731]]], [[[2398, 8781], [2404, 8781], [2407, 8776], [2397, 8777], [2398, 8781]]], [[[1783, 8786], [1777, 8784], [1776, 8787], [1781, 8787], [1783, 8786]]], [[[1730, 8796], [1740, 8787], [1742, 8772], [1730, 8781], [1730, 8796]]], [[[1752, 8799], [1770, 8791], [1781, 8775], [1758, 8782], [1752, 8799]]], [[[1788, 8808], [1795, 8806], [1792, 8803], [1783, 8806], [1788, 8808]]], [[[2399, 8852], [2400, 8851], [2387, 8843], [2392, 8851], [2399, 8852]]], [[[1073, 8847], [1068, 8847], [1066, 8851], [1067, 8852], [1073, 8847]]], [[[2365, 8859], [2371, 8857], [2368, 8856], [2357, 8857], [2365, 8859]]], [[[1058, 8863], [1056, 8858], [1051, 8863], [1058, 8867], [1058, 8863]]], [[[1043, 8870], [1046, 8870], [1044, 8866], [1040, 8869], [1043, 8870]]], [[[2359, 8868], [2351, 8869], [2354, 8875], [2358, 8870], [2359, 8868]]], [[[1057, 8870], [1051, 8870], [1051, 8876], [1055, 8875], [1057, 8870]]], [[[900, 8889], [894, 8889], [909, 8890], [909, 8889], [900, 8889]]], [[[1053, 8888], [1047, 8887], [1049, 8890], [1052, 8892], [1053, 8888]]], [[[1020, 8892], [1029, 8890], [1027, 8886], [1021, 8889], [1020, 8892]]], [[[1015, 8895], [1016, 8892], [1011, 8895], [1011, 8898], [1015, 8895]]], [[[1000, 8901], [1008, 8904], [998, 8897], [988, 8895], [1000, 8901]]], [[[2049, 8897], [2075, 8891], [2075, 8881], [2046, 8881], [2035, 8896], [2049, 8897]]], [[[1693, 8889], [1686, 8879], [1675, 8889], [1682, 8908], [1693, 8889]]], [[[946, 8904], [944, 8904], [945, 8908], [951, 8909], [946, 8904]]], [[[2010, 8909], [2024, 8905], [2026, 8870], [2002, 8855], [1969, 8854], [1959, 8878], [1978, 8906], [2010, 8909]]], [[[1910, 8902], [1905, 8904], [1906, 8910], [1916, 8907], [1910, 8902]]], [[[1818, 8911], [1821, 8910], [1819, 8908], [1814, 8911], [1818, 8911]]], [[[2052, 8905], [2046, 8915], [2050, 8915], [2055, 8910], [2052, 8905]]], [[[973, 8922], [974, 8920], [975, 8918], [964, 8917], [973, 8922]]], [[[1157, 8913], [1141, 8921], [1153, 8922], [1159, 8919], [1157, 8913]]], [[[1922, 8925], [1920, 8917], [1911, 8917], [1919, 8923], [1922, 8925]]], [[[2042, 8921], [2034, 8921], [2031, 8925], [2034, 8927], [2042, 8921]]], [[[2031, 8921], [2033, 8910], [2016, 8919], [2021, 8930], [2031, 8921]]], [[[1238, 8933], [1236, 8922], [1221, 8928], [1231, 8935], [1238, 8933]]], [[[1286, 8940], [1278, 8929], [1272, 8932], [1272, 8944], [1286, 8940]]], [[[1290, 8941], [1284, 8944], [1287, 8952], [1290, 8949], [1290, 8941]]], [[[227, 8951], [229, 8949], [223, 8949], [223, 8953], [227, 8951]]], [[[1242, 8948], [1243, 8956], [1246, 8954], [1245, 8950], [1242, 8948]]], [[[1926, 8964], [1926, 8956], [1914, 8939], [1898, 8940], [1926, 8964]]], [[[242, 8974], [247, 8978], [241, 8967], [234, 8970], [242, 8974]]], [[[1830, 8966], [1836, 8965], [1837, 8962], [1825, 8966], [1830, 8966]]], [[[1580, 8964], [1576, 8956], [1571, 8961], [1575, 8966], [1580, 8964]]], [[[1968, 8966], [1979, 8964], [1964, 8950], [1958, 8958], [1968, 8966]]], [[[1254, 8973], [1262, 8969], [1255, 8964], [1252, 8967], [1254, 8973]]], [[[1390, 8973], [1404, 8973], [1404, 8962], [1392, 8969], [1390, 8973]]], [[[2255, 8973], [2245, 8970], [2242, 8971], [2249, 8976], [2255, 8973]]], [[[1418, 8976], [1427, 8971], [1417, 8961], [1417, 8973], [1418, 8976]]], [[[144, 8975], [137, 8972], [133, 8974], [137, 8978], [144, 8975]]], [[[2238, 8981], [2242, 8977], [2235, 8972], [2225, 8975], [2238, 8981]]], [[[1940, 8980], [1924, 8969], [1914, 8970], [1931, 8982], [1940, 8980]]], [[[1890, 8987], [1894, 8977], [1858, 8979], [1874, 8986], [1890, 8987]]], [[[1807, 8984], [1805, 8983], [1797, 8985], [1802, 8987], [1807, 8984]]], [[[1776, 8985], [1771, 8982], [1766, 8984], [1767, 8987], [1776, 8985]]], [[[1532, 8987], [1534, 8990], [1541, 8987], [1540, 8982], [1532, 8987]]], [[[1369, 8991], [1365, 8991], [1365, 8994], [1369, 8994], [1369, 8991]]], [[[1674, 9003], [1686, 9002], [1681, 8995], [1663, 9002], [1674, 9003]]], [[[947, 9013], [934, 9012], [928, 9016], [940, 9013], [947, 9013]]], [[[806, 9025], [815, 9025], [801, 9022], [796, 9026], [806, 9025]]], [[[793, 9026], [783, 9025], [780, 9027], [782, 9028], [793, 9026]]], [[[463, 9029], [458, 9028], [455, 9025], [458, 9031], [463, 9029]]], [[[1270, 9033], [1276, 9033], [1284, 9021], [1271, 9026], [1270, 9033]]], [[[2082, 9073], [2092, 9074], [2087, 9067], [2079, 9069], [2082, 9073]]], [[[2095, 9079], [2087, 9080], [2089, 9085], [2095, 9086], [2095, 9079]]], [[[1155, 9178], [1135, 9152], [1099, 9184], [1083, 9188], [1096, 9201], [1138, 9203], [1158, 9192], [1155, 9178]]], [[[1356, 9245], [1360, 9221], [1345, 9210], [1322, 9206], [1307, 9212], [1345, 9223], [1356, 9245]]], [[[1180, 9293], [1166, 9277], [1146, 9283], [1169, 9302], [1180, 9293]]], [[[770, 9343], [761, 9319], [742, 9306], [718, 9312], [742, 9331], [770, 9343]]], [[[1193, 9337], [1221, 9336], [1182, 9329], [1162, 9340], [1164, 9349], [1210, 9355], [1216, 9345], [1193, 9337]]], [[[1175, 9374], [1202, 9361], [1162, 9355], [1154, 9372], [1175, 9374]]], [[[1577, 9437], [1596, 9418], [1583, 9410], [1550, 9423], [1551, 9436], [1577, 9437]]], [[[1143, 9423], [1160, 9416], [1159, 9407], [1137, 9407], [1111, 9443], [1128, 9442], [1143, 9423]]], [[[1263, 9444], [1218, 9443], [1220, 9453], [1242, 9453], [1263, 9444]]], [[[869, 9461], [890, 9448], [873, 9441], [845, 9458], [869, 9461]]], [[[1307, 9599], [1329, 9589], [1325, 9569], [1285, 9594], [1307, 9599]]], [[[1716, 8019], [1712, 8017], [1705, 8018], [1708, 8021], [1716, 8019]]], [[[1652, 8060], [1656, 8057], [1645, 8056], [1646, 8061], [1652, 8060]]], [[[1814, 7955], [1823, 7953], [1827, 7936], [1785, 7949], [1814, 7955]]], [[[1783, 7952], [1782, 7949], [1778, 7950], [1780, 7953], [1783, 7952]]], [[[1420, 9446], [1479, 9446], [1490, 9443], [1482, 9426], [1409, 9427], [1402, 9441], [1420, 9446]]], [[[2477, 7954], [2441, 7934], [2425, 7955], [2453, 7992], [2458, 7964], [2477, 7954]]], [[[2364, 7962], [2340, 7979], [2350, 7982], [2375, 7969], [2401, 7967], [2395, 7953], [2364, 7962]]], [[[338, 8220], [330, 8227], [353, 8232], [355, 8210], [338, 8220]]], [[[317, 8269], [343, 8262], [357, 8268], [347, 8232], [322, 8240], [317, 8269]]], [[[1894, 8346], [1880, 8339], [1902, 8371], [1908, 8362], [1894, 8346]]], [[[1013, 9481], [986, 9478], [962, 9485], [954, 9478], [932, 9484], [906, 9478], [900, 9486], [983, 9510], [1011, 9498], [1013, 9481]]], [[[1761, 7963], [1761, 7965], [1769, 7962], [1764, 7957], [1764, 7956], [1761, 7961], [1761, 7963]]], [[[576, 8086], [563, 8094], [573, 8093], [576, 8086], [576, 8086], [576, 8086]]], [[[2276, 8902], [2285, 8891], [2324, 8895], [2355, 8857], [2334, 8849], [2382, 8857], [2372, 8837], [2411, 8844], [2432, 8826], [2417, 8824], [2427, 8811], [2395, 8804], [2413, 8794], [2399, 8792], [2394, 8777], [2362, 8767], [2373, 8755], [2366, 8740], [2340, 8758], [2336, 8749], [2308, 8781], [2327, 8795], [2296, 8791], [2268, 8820], [2260, 8809], [2238, 8816], [2260, 8793], [2237, 8788], [2236, 8772], [2266, 8762], [2265, 8750], [2306, 8733], [2302, 8720], [2333, 8696], [2335, 8687], [2334, 8687], [2334, 8692], [2325, 8689], [2335, 8684], [2338, 8664], [2320, 8676], [2334, 8646], [2316, 8640], [2277, 8650], [2249, 8671], [2246, 8655], [2295, 8613], [2285, 8598], [2254, 8611], [2218, 8616], [2187, 8635], [2168, 8639], [2125, 8659], [2129, 8677], [2097, 8690], [2074, 8726], [2056, 8731], [2037, 8715], [2004, 8727], [1978, 8706], [1944, 8715], [1935, 8742], [1960, 8754], [1956, 8767], [2006, 8755], [2052, 8770], [2073, 8767], [2068, 8779], [2043, 8800], [2088, 8829], [2093, 8844], [2111, 8856], [2087, 8905], [2062, 8910], [2066, 8926], [2051, 8919], [2014, 8945], [1980, 8928], [1980, 8945], [1999, 8944], [2010, 8956], [1963, 8978], [1972, 8986], [1949, 8987], [1949, 9006], [1912, 9013], [1916, 8990], [1890, 8988], [1883, 8995], [1829, 9003], [1817, 8985], [1790, 8997], [1772, 8993], [1696, 9002], [1675, 9021], [1674, 9011], [1624, 9021], [1599, 9055], [1635, 9047], [1663, 9047], [1642, 9061], [1591, 9068], [1592, 9091], [1583, 9100], [1598, 9148], [1616, 9176], [1652, 9201], [1682, 9208], [1730, 9206], [1734, 9198], [1703, 9177], [1683, 9150], [1694, 9132], [1692, 9105], [1737, 9065], [1704, 9059], [1737, 9058], [1744, 9086], [1725, 9086], [1717, 9099], [1719, 9119], [1748, 9111], [1712, 9140], [1717, 9159], [1756, 9149], [1728, 9161], [1727, 9173], [1743, 9182], [1797, 9202], [1835, 9201], [1847, 9174], [1862, 9170], [1873, 9146], [1865, 9125], [1852, 9116], [1856, 9102], [1886, 9132], [1902, 9126], [1912, 9105], [1926, 9137], [1951, 9146], [2022, 9132], [2030, 9119], [2020, 9111], [2050, 9109], [2049, 9090], [2069, 9091], [2058, 9079], [2085, 9064], [2102, 9085], [2129, 9078], [2142, 9064], [2133, 9054], [2115, 9054], [2113, 9048], [2121, 9053], [2133, 9045], [2114, 9040], [2112, 9043], [2110, 9037], [2136, 9044], [2152, 9056], [2160, 9046], [2140, 9027], [2178, 9043], [2224, 9027], [2220, 9016], [2185, 9004], [2214, 9007], [2207, 8994], [2224, 9000], [2233, 9013], [2257, 8994], [2260, 8982], [2234, 8984], [2213, 8978], [2234, 8968], [2257, 8968], [2270, 8951], [2219, 8954], [2242, 8946], [2241, 8933], [2238, 8931], [2228, 8933], [2223, 8934], [2235, 8930], [2223, 8923], [2267, 8914], [2276, 8903], [2279, 8905], [2286, 8905], [2285, 8901], [2276, 8902]]], [[[1993, 7889], [1993, 7890], [1993, 7889], [1988, 7888], [1984, 7885], [1986, 7889], [1993, 7889]]], [[[785, 9426], [807, 9432], [837, 9416], [812, 9409], [822, 9378], [787, 9367], [779, 9351], [760, 9360], [768, 9383], [745, 9380], [728, 9341], [716, 9358], [716, 9338], [687, 9325], [675, 9348], [675, 9332], [646, 9338], [629, 9332], [617, 9350], [631, 9361], [655, 9362], [669, 9377], [690, 9386], [698, 9397], [736, 9420], [764, 9421], [783, 9415], [785, 9426]]], [[[2675, 8044], [2661, 8036], [2651, 8017], [2660, 8011], [2679, 8031], [2671, 8007], [2683, 8020], [2688, 8010], [2678, 7983], [2660, 7976], [2658, 7990], [2642, 7988], [2653, 8006], [2643, 8010], [2620, 8002], [2610, 7988], [2596, 7985], [2591, 8008], [2598, 8016], [2563, 8010], [2528, 8017], [2495, 8011], [2488, 8024], [2517, 8047], [2508, 8049], [2531, 8089], [2548, 8127], [2567, 8155], [2587, 8158], [2599, 8141], [2567, 8106], [2564, 8087], [2584, 8110], [2604, 8101], [2591, 8093], [2598, 8080], [2645, 8094], [2663, 8075], [2648, 8059], [2650, 8049], [2675, 8044]]], [[[1714, 8662], [1715, 8682], [1669, 8678], [1677, 8694], [1697, 8701], [1691, 8725], [1699, 8741], [1705, 8781], [1719, 8789], [1724, 8771], [1738, 8755], [1745, 8768], [1786, 8742], [1812, 8733], [1835, 8708], [1822, 8697], [1854, 8703], [1874, 8688], [1850, 8671], [1819, 8683], [1811, 8693], [1776, 8702], [1773, 8686], [1754, 8680], [1745, 8665], [1725, 8656], [1714, 8662]]], [[[1349, 8990], [1383, 8969], [1406, 8956], [1413, 8938], [1432, 8936], [1393, 8915], [1365, 8920], [1303, 8946], [1338, 8962], [1333, 8974], [1349, 8990]]], [[[1207, 9024], [1246, 9002], [1261, 9006], [1265, 8985], [1241, 8978], [1220, 8987], [1217, 8973], [1187, 8976], [1207, 8964], [1230, 8969], [1236, 8946], [1190, 8933], [1146, 8946], [1102, 8954], [1099, 8969], [1074, 8945], [1039, 8941], [1027, 8931], [967, 8921], [900, 8916], [888, 8934], [887, 8954], [866, 8959], [820, 8960], [800, 8968], [776, 8996], [790, 9003], [872, 9013], [921, 9007], [951, 9011], [932, 9023], [878, 9034], [817, 9026], [812, 9030], [772, 9029], [749, 9051], [816, 9070], [824, 9079], [773, 9070], [755, 9070], [758, 9086], [729, 9084], [728, 9100], [756, 9117], [742, 9128], [779, 9155], [861, 9182], [879, 9168], [877, 9149], [860, 9138], [886, 9138], [907, 9161], [960, 9145], [941, 9125], [947, 9120], [978, 9138], [1002, 9132], [975, 9161], [994, 9160], [1036, 9136], [1035, 9124], [1063, 9084], [1077, 9099], [1061, 9112], [1052, 9147], [1050, 9177], [1055, 9191], [1079, 9171], [1099, 9173], [1132, 9148], [1134, 9130], [1149, 9097], [1162, 9081], [1155, 9054], [1173, 9037], [1207, 9024]]], [[[1935, 9198], [1963, 9189], [1991, 9165], [1989, 9150], [1934, 9154], [1905, 9146], [1881, 9152], [1876, 9173], [1858, 9176], [1855, 9203], [1897, 9196], [1935, 9198]]], [[[1236, 9122], [1209, 9150], [1217, 9162], [1233, 9165], [1252, 9144], [1277, 9145], [1289, 9154], [1284, 9168], [1243, 9188], [1275, 9194], [1258, 9202], [1297, 9214], [1314, 9202], [1371, 9209], [1375, 9182], [1339, 9163], [1376, 9160], [1386, 9154], [1400, 9128], [1394, 9100], [1366, 9083], [1345, 9085], [1343, 9072], [1328, 9064], [1272, 9115], [1236, 9122]]], [[[654, 9250], [696, 9233], [727, 9229], [758, 9233], [793, 9222], [839, 9187], [805, 9175], [726, 9139], [720, 9123], [696, 9113], [682, 9076], [610, 9054], [581, 9088], [546, 9102], [527, 9102], [553, 9150], [569, 9156], [558, 9164], [590, 9204], [579, 9209], [561, 9237], [654, 9250]]], [[[1378, 9305], [1398, 9315], [1415, 9306], [1448, 9320], [1482, 9292], [1479, 9255], [1436, 9257], [1428, 9246], [1412, 9251], [1423, 9265], [1390, 9275], [1403, 9303], [1383, 9297], [1378, 9305]]], [[[1349, 9277], [1281, 9277], [1269, 9302], [1296, 9315], [1248, 9312], [1213, 9305], [1215, 9319], [1193, 9321], [1201, 9330], [1225, 9335], [1251, 9322], [1234, 9341], [1250, 9351], [1229, 9349], [1237, 9364], [1296, 9333], [1257, 9371], [1262, 9381], [1301, 9375], [1318, 9360], [1323, 9374], [1360, 9365], [1367, 9304], [1348, 9305], [1362, 9285], [1349, 9277]]], [[[1028, 9305], [1030, 9317], [994, 9329], [1016, 9342], [985, 9354], [1011, 9380], [1032, 9389], [1039, 9361], [1052, 9353], [1040, 9338], [1058, 9340], [1058, 9330], [1083, 9329], [1096, 9339], [1121, 9335], [1132, 9314], [1114, 9279], [1069, 9272], [1064, 9280], [1043, 9271], [1030, 9280], [1008, 9267], [987, 9267], [947, 9246], [907, 9240], [887, 9243], [865, 9258], [913, 9275], [943, 9275], [969, 9290], [927, 9283], [879, 9280], [876, 9297], [865, 9280], [850, 9274], [840, 9285], [827, 9274], [774, 9288], [783, 9304], [818, 9305], [847, 9318], [815, 9310], [784, 9310], [793, 9323], [852, 9328], [798, 9330], [798, 9339], [825, 9350], [821, 9357], [851, 9367], [852, 9383], [865, 9390], [892, 9387], [888, 9379], [865, 9380], [879, 9347], [908, 9352], [953, 9326], [959, 9307], [981, 9310], [1028, 9305]]], [[[1898, 9268], [1873, 9261], [1876, 9254], [1828, 9244], [1794, 9249], [1788, 9266], [1777, 9251], [1755, 9247], [1655, 9244], [1629, 9246], [1629, 9270], [1620, 9256], [1587, 9248], [1549, 9260], [1526, 9263], [1512, 9289], [1526, 9312], [1523, 9328], [1508, 9336], [1493, 9358], [1466, 9351], [1414, 9360], [1395, 9378], [1385, 9396], [1415, 9402], [1476, 9392], [1495, 9374], [1543, 9378], [1569, 9370], [1572, 9361], [1606, 9354], [1604, 9347], [1549, 9346], [1580, 9340], [1553, 9338], [1558, 9331], [1585, 9337], [1609, 9323], [1618, 9301], [1623, 9317], [1639, 9307], [1663, 9312], [1692, 9301], [1703, 9308], [1746, 9313], [1770, 9325], [1789, 9320], [1812, 9326], [1848, 9322], [1891, 9304], [1891, 9286], [1867, 9278], [1893, 9277], [1898, 9268]]], [[[901, 9430], [900, 9454], [910, 9456], [975, 9467], [1005, 9466], [1005, 9458], [971, 9452], [992, 9446], [989, 9429], [934, 9417], [901, 9430]]], [[[1345, 9513], [1366, 9512], [1404, 9500], [1411, 9491], [1443, 9483], [1427, 9476], [1441, 9467], [1427, 9458], [1383, 9447], [1356, 9463], [1383, 9469], [1355, 9475], [1338, 9492], [1345, 9513]]], [[[1131, 9547], [1181, 9549], [1199, 9544], [1219, 9526], [1242, 9530], [1304, 9499], [1294, 9488], [1319, 9465], [1320, 9453], [1293, 9446], [1273, 9451], [1259, 9473], [1227, 9479], [1209, 9473], [1210, 9485], [1159, 9478], [1142, 9493], [1154, 9498], [1186, 9492], [1188, 9511], [1166, 9511], [1170, 9524], [1142, 9513], [1153, 9526], [1127, 9527], [1131, 9547]]], [[[1490, 9686], [1533, 9671], [1564, 9630], [1606, 9628], [1614, 9605], [1640, 9598], [1624, 9611], [1631, 9621], [1653, 9620], [1657, 9604], [1675, 9585], [1669, 9563], [1685, 9568], [1716, 9563], [1735, 9544], [1689, 9529], [1658, 9503], [1647, 9500], [1615, 9471], [1585, 9500], [1602, 9471], [1582, 9481], [1575, 9469], [1526, 9474], [1501, 9493], [1534, 9496], [1491, 9498], [1460, 9523], [1490, 9536], [1530, 9536], [1510, 9545], [1532, 9548], [1509, 9555], [1470, 9542], [1472, 9551], [1452, 9547], [1416, 9552], [1420, 9562], [1446, 9565], [1459, 9575], [1413, 9568], [1390, 9584], [1388, 9602], [1443, 9595], [1465, 9604], [1426, 9600], [1392, 9610], [1410, 9618], [1408, 9631], [1433, 9633], [1404, 9637], [1452, 9641], [1423, 9647], [1442, 9665], [1493, 9667], [1491, 9675], [1456, 9678], [1462, 9686], [1490, 9686]]], [[[1934, 9458], [1951, 9448], [1931, 9421], [1906, 9415], [1857, 9418], [1834, 9429], [1848, 9415], [1889, 9412], [1910, 9404], [1899, 9392], [1942, 9395], [1946, 9376], [1925, 9364], [1917, 9371], [1903, 9355], [1916, 9342], [1914, 9327], [1888, 9328], [1902, 9338], [1900, 9354], [1849, 9343], [1858, 9361], [1823, 9366], [1813, 9360], [1765, 9364], [1735, 9361], [1750, 9354], [1662, 9363], [1655, 9356], [1633, 9360], [1628, 9381], [1618, 9361], [1584, 9365], [1569, 9379], [1586, 9387], [1597, 9374], [1599, 9388], [1636, 9406], [1656, 9403], [1677, 9414], [1654, 9419], [1639, 9447], [1668, 9454], [1704, 9442], [1710, 9424], [1761, 9422], [1781, 9429], [1806, 9458], [1798, 9461], [1780, 9435], [1765, 9428], [1717, 9431], [1728, 9448], [1714, 9457], [1731, 9464], [1734, 9483], [1719, 9468], [1697, 9464], [1695, 9473], [1660, 9468], [1660, 9489], [1686, 9512], [1726, 9519], [1786, 9512], [1828, 9516], [1837, 9528], [1806, 9517], [1754, 9522], [1740, 9527], [1753, 9538], [1732, 9566], [1690, 9575], [1694, 9590], [1685, 9602], [1691, 9613], [1769, 9609], [1816, 9583], [1832, 9564], [1862, 9565], [1836, 9573], [1838, 9588], [1817, 9593], [1786, 9613], [1870, 9624], [1879, 9627], [1939, 9632], [1882, 9633], [1924, 9645], [1982, 9649], [1981, 9653], [1914, 9650], [1913, 9661], [1951, 9683], [1934, 9681], [1900, 9660], [1892, 9648], [1845, 9634], [1795, 9628], [1789, 9636], [1817, 9641], [1822, 9649], [1783, 9639], [1767, 9644], [1768, 9630], [1751, 9626], [1700, 9628], [1681, 9633], [1709, 9656], [1727, 9662], [1810, 9673], [1721, 9664], [1700, 9660], [1666, 9635], [1642, 9638], [1604, 9652], [1632, 9660], [1683, 9660], [1741, 9680], [1726, 9681], [1688, 9669], [1591, 9661], [1575, 9672], [1604, 9678], [1588, 9684], [1633, 9701], [1571, 9686], [1561, 9693], [1598, 9704], [1565, 9708], [1542, 9697], [1528, 9704], [1556, 9719], [1593, 9725], [1604, 9718], [1613, 9730], [1642, 9738], [1711, 9730], [1740, 9730], [1682, 9741], [1679, 9747], [1723, 9752], [1711, 9764], [1772, 9756], [1804, 9738], [1793, 9752], [1880, 9728], [1801, 9758], [1819, 9780], [1863, 9771], [1834, 9788], [1884, 9786], [1876, 9799], [1900, 9802], [1910, 9794], [1944, 9798], [1965, 9794], [1982, 9780], [2002, 9774], [1979, 9795], [1958, 9803], [1994, 9808], [2052, 9804], [2062, 9794], [2099, 9782], [2068, 9798], [2088, 9809], [2185, 9812], [2187, 9803], [2229, 9804], [2281, 9799], [2283, 9796], [2216, 9776], [2251, 9778], [2298, 9792], [2310, 9787], [2332, 9797], [2339, 9786], [2369, 9791], [2363, 9783], [2385, 9768], [2424, 9766], [2437, 9758], [2432, 9745], [2404, 9732], [2341, 9711], [2312, 9714], [2298, 9704], [2256, 9700], [2274, 9695], [2173, 9671], [2191, 9673], [2301, 9695], [2336, 9699], [2332, 9687], [2294, 9676], [2274, 9663], [2226, 9643], [2194, 9619], [2162, 9615], [2177, 9609], [2111, 9595], [2156, 9601], [2155, 9591], [2132, 9574], [2110, 9569], [2085, 9579], [2051, 9584], [2033, 9581], [2076, 9576], [2082, 9561], [2057, 9555], [2026, 9558], [2027, 9550], [1993, 9558], [2001, 9548], [1957, 9555], [1959, 9543], [2044, 9540], [2043, 9527], [2002, 9532], [1996, 9538], [1938, 9537], [1995, 9533], [1942, 9529], [1948, 9523], [1977, 9527], [2005, 9524], [1985, 9516], [2019, 9517], [2039, 9511], [2034, 9498], [2016, 9493], [1984, 9495], [2025, 9484], [2009, 9473], [1973, 9472], [2011, 9467], [1972, 9454], [1934, 9458]]], [[[576, 8086], [578, 8085], [578, 8083], [576, 8086], [576, 8086], [576, 8086]]]]
            }
        }, {
            "type": "Feature",
            "id": "ST",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.5,
                "hc-key": "st",
                "hc-a2": "ST",
                "name": "Sao Tome and Principe",
                "labelrank": "6",
                "country-abbrev": "S.T.P.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "STP",
                "iso-a2": "ST",
                "woe-id": "23424966",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4435, 6502], [4430, 6506], [4435, 6512], [4439, 6508], [4435, 6502]]]
            }
        }, {
            "type": "Feature",
            "id": "TZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "tz",
                "hc-a2": "TZ",
                "name": "United Republic of Tanzania",
                "labelrank": "3",
                "country-abbrev": "Tanz.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "TZA",
                "iso-a2": "TZ",
                "woe-id": "23424973",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5178, 6471], [5172, 6440], [5181, 6429], [5219, 6426], [5237, 6435], [5208, 6439], [5227, 6446], [5244, 6469], [5350, 6411], [5353, 6393], [5395, 6363], [5415, 6346], [5399, 6332], [5406, 6312], [5391, 6310], [5403, 6299], [5399, 6271], [5400, 6244], [5413, 6210], [5432, 6192], [5419, 6182], [5375, 6164], [5363, 6169], [5345, 6155], [5332, 6160], [5307, 6156], [5296, 6164], [5271, 6159], [5271, 6162], [5269, 6164], [5269, 6165], [5265, 6166], [5264, 6168], [5264, 6168], [5263, 6169], [5256, 6208], [5251, 6215], [5248, 6218], [5248, 6218], [5245, 6220], [5245, 6221], [5245, 6221], [5241, 6219], [5240, 6214], [5225, 6218], [5210, 6224], [5183, 6233], [5159, 6248], [5141, 6280], [5141, 6296], [5116, 6323], [5123, 6326], [5114, 6370], [5124, 6375], [5148, 6405], [5137, 6416], [5141, 6430], [5149, 6431], [5149, 6453], [5138, 6469], [5149, 6471], [5177, 6471], [5177, 6469], [5178, 6471], [5178, 6471]]]
            }
        }, {
            "type": "Feature",
            "id": "CV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.5,
                "hc-key": "cv",
                "hc-a2": "CV",
                "name": "Cape Verde",
                "labelrank": "4",
                "country-abbrev": "C.Vd.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "CPV",
                "iso-a2": "CV",
                "woe-id": "23424794",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3540, 6952], [3546, 6946], [3547, 6940], [3539, 6944], [3540, 6952]]]
            }
        }, {
            "type": "Feature",
            "id": "DM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.54,
                "hc-middle-y": 0.47,
                "hc-key": "dm",
                "hc-a2": "DM",
                "name": "Dominica",
                "labelrank": "6",
                "country-abbrev": "D'inca",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "DMA",
                "iso-a2": "DM",
                "woe-id": "23424798",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2429, 6961], [2433, 6955], [2430, 6949], [2427, 6957], [2429, 6961]]]
            }
        }, {
            "type": "Feature",
            "id": "NL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.99,
                "hc-middle-y": 0,
                "hc-key": "nl",
                "hc-a2": "NL",
                "name": "Netherlands",
                "labelrank": "5",
                "country-abbrev": "Neth.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "NLD",
                "iso-a2": "NL",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4404, 8239], [4393, 8236], [4394, 8238], [4406, 8240], [4404, 8239]]], [[[2381, 7034], [2379, 7034], [2379, 7035], [2381, 7034]]], [[[4338, 8157], [4350, 8156], [4364, 8157], [4352, 8151], [4338, 8157]]], [[[4452, 8231], [4447, 8191], [4428, 8175], [4416, 8133], [4411, 8149], [4387, 8161], [4365, 8157], [4353, 8166], [4373, 8195], [4383, 8230], [4389, 8220], [4404, 8234], [4430, 8244], [4452, 8231]]]]
            }
        }, {
            "type": "Feature",
            "id": "JM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "jm",
                "hc-a2": "JM",
                "name": "Jamaica",
                "labelrank": "4",
                "country-abbrev": "Jam.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "JAM",
                "iso-a2": "JM",
                "woe-id": "23424858",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1956, 7047], [1972, 7045], [1993, 7030], [1973, 7033], [1963, 7024], [1928, 7041], [1956, 7047]]]
            }
        }, {
            "type": "Feature",
            "id": "WS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.54,
                "hc-key": "ws",
                "hc-a2": "WS",
                "name": "Samoa",
                "labelrank": "4",
                "country-abbrev": "Samoa",
                "subregion": "Polynesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "WSM",
                "iso-a2": "WS",
                "woe-id": "23424992",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[-841, 6102], [-839, 6093], [-848, 6093], [-856, 6101], [-841, 6102]]]
            }
        }, {
            "type": "Feature",
            "id": "OM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.88,
                "hc-middle-y": 0.44,
                "hc-key": "om",
                "hc-a2": "OM",
                "name": "Oman",
                "labelrank": "4",
                "country-abbrev": "Oman",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "OMN",
                "iso-a2": "OM",
                "woe-id": "23424898",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5899, 7255], [5898, 7255], [5898, 7258], [5901, 7257], [5899, 7255]]], [[[5893, 7281], [5902, 7291], [5899, 7268], [5895, 7269], [5893, 7281]]], [[[5772, 7063], [5861, 7094], [5880, 7154], [5867, 7177], [5884, 7224], [5885, 7244], [5902, 7247], [5925, 7215], [5972, 7203], [6003, 7162], [5990, 7138], [5970, 7119], [5969, 7105], [5953, 7111], [5941, 7085], [5945, 7064], [5910, 7051], [5901, 7031], [5875, 7028], [5862, 7003], [5835, 7003], [5805, 6992], [5794, 7012], [5772, 7063]]]]
            }
        }, {
            "type": "Feature",
            "id": "VC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "vc",
                "hc-a2": "VC",
                "name": "Saint Vincent and the Grenadines",
                "labelrank": "6",
                "country-abbrev": "St.V.G.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "VCT",
                "iso-a2": "VC",
                "woe-id": "23424981",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2435, 6884], [2433, 6889], [2437, 6894], [2437, 6888], [2435, 6884]]]
            }
        }, {
            "type": "Feature",
            "id": "TR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.34,
                "hc-middle-y": 0.49,
                "hc-key": "tr",
                "hc-a2": "TR",
                "name": "Turkey",
                "labelrank": "2",
                "country-abbrev": "Tur.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "TUR",
                "iso-a2": "TR",
                "woe-id": "23424969",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5005, 7745], [4999, 7743], [4996, 7744], [5004, 7748], [5005, 7745]]], [[[5561, 7727], [5538, 7718], [5545, 7700], [5544, 7670], [5555, 7661], [5560, 7642], [5499, 7649], [5489, 7641], [5484, 7648], [5463, 7639], [5446, 7641], [5412, 7628], [5380, 7627], [5367, 7634], [5344, 7624], [5320, 7631], [5306, 7597], [5299, 7600], [5295, 7614], [5307, 7623], [5301, 7634], [5281, 7622], [5259, 7629], [5229, 7607], [5207, 7604], [5184, 7622], [5145, 7633], [5136, 7611], [5115, 7607], [5098, 7626], [5074, 7639], [5056, 7637], [5041, 7649], [5043, 7670], [5013, 7680], [5034, 7686], [5038, 7701], [5024, 7714], [5033, 7725], [5010, 7721], [5012, 7740], [5025, 7751], [5011, 7742], [5031, 7760], [5008, 7765], [5025, 7788], [5016, 7799], [5037, 7812], [5066, 7809], [5068, 7796], [5098, 7783], [5090, 7773], [5051, 7774], [5041, 7762], [5029, 7754], [5099, 7755], [5102, 7783], [5161, 7778], [5191, 7800], [5222, 7810], [5263, 7808], [5281, 7799], [5300, 7800], [5346, 7776], [5370, 7771], [5402, 7778], [5423, 7772], [5464, 7792], [5492, 7789], [5502, 7795], [5521, 7778], [5529, 7763], [5527, 7743], [5547, 7741], [5560, 7729], [5561, 7727]]]]
            }
        }, {
            "type": "Feature",
            "id": "BD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.86,
                "hc-middle-y": 0.78,
                "hc-key": "bd",
                "hc-a2": "BD",
                "name": "Bangladesh",
                "labelrank": "3",
                "country-abbrev": "Bang.",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "BGD",
                "iso-a2": "BD",
                "woe-id": "23424759",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6960, 7126], [6937, 7180], [6899, 7149], [6880, 7154], [6870, 7144], [6866, 7159], [6851, 7206], [6856, 7226], [6835, 7237], [6848, 7254], [6862, 7253], [6837, 7276], [6848, 7294], [6889, 7279], [6888, 7260], [6904, 7253], [6954, 7254], [6967, 7246], [6956, 7229], [6934, 7220], [6927, 7205], [6940, 7184], [6957, 7209], [6970, 7154], [6972, 7133], [6960, 7126]]]
            }
        }, {
            "type": "Feature",
            "id": "SB",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.62,
                "hc-middle-y": 0.67,
                "hc-key": "sb",
                "hc-a2": "SB",
                "name": "Solomon Islands",
                "labelrank": "3",
                "country-abbrev": "S. Is.",
                "subregion": "Melanesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "SLB",
                "iso-a2": "SB",
                "woe-id": "23424766",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[8953, 6249], [8924, 6266], [8918, 6278], [8953, 6256], [8960, 6235], [8981, 6214], [8977, 6208], [8953, 6212], [8946, 6225], [8953, 6249]]], [[[9000, 6223], [8999, 6200], [9019, 6193], [9025, 6182], [8996, 6196], [8999, 6216], [8984, 6230], [8975, 6255], [8988, 6247], [9000, 6223]]], [[[8867, 6288], [8854, 6306], [8891, 6281], [8873, 6284], [8861, 6269], [8887, 6265], [8905, 6245], [8865, 6262], [8855, 6276], [8867, 6288]]]]
            }
        }, {
            "type": "Feature",
            "id": "LC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.52,
                "hc-middle-y": 0.47,
                "hc-key": "lc",
                "hc-a2": "LC",
                "name": "Saint Lucia",
                "labelrank": "6",
                "country-abbrev": "S.L.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "LCA",
                "iso-a2": "LC",
                "woe-id": "23424951",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2442, 6904], [2438, 6909], [2443, 6916], [2444, 6911], [2442, 6904]]]
            }
        }, {
            "type": "Feature",
            "id": "NR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.5,
                "hc-key": "nr",
                "hc-a2": "NR",
                "name": "Nauru",
                "labelrank": "6",
                "country-abbrev": "Nauru",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "NRU",
                "iso-a2": "NR",
                "woe-id": "23424912",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[9163, 6484], [9162, 6484], [9162, 6485], [9163, 6485], [9163, 6484]]]
            }
        }, {
            "type": "Feature",
            "id": "NO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.13,
                "hc-middle-y": 0.9,
                "hc-key": "no",
                "hc-a2": "NO",
                "name": "Norway",
                "labelrank": "3",
                "country-abbrev": "Nor.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "NOR",
                "iso-a2": "NO",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4653, 8902], [4617, 8883], [4638, 8905], [4687, 8916], [4653, 8902]]], [[[4682, 8921], [4663, 8928], [4686, 8945], [4692, 8926], [4682, 8921]]], [[[4820, 8989], [4813, 8989], [4823, 8996], [4825, 8995], [4820, 8989]]], [[[4858, 8998], [4862, 8997], [4856, 8993], [4852, 8996], [4858, 8998]]], [[[4800, 9004], [4817, 8996], [4811, 8987], [4778, 8972], [4776, 8981], [4801, 8988], [4790, 8999], [4800, 9004]]], [[[4853, 9003], [4847, 8999], [4841, 9002], [4847, 9009], [4853, 9003]]], [[[4829, 8997], [4822, 9001], [4816, 9009], [4834, 9002], [4829, 8997]]], [[[4909, 9017], [4918, 9009], [4901, 9012], [4903, 9017], [4909, 9017]]], [[[4933, 9029], [4937, 9021], [4921, 9011], [4914, 9018], [4933, 9029]]], [[[4942, 9034], [4951, 9029], [4940, 9024], [4937, 9033], [4942, 9034]]], [[[4930, 9041], [4920, 9027], [4893, 9022], [4904, 9034], [4930, 9041]]], [[[4949, 9050], [4950, 9045], [4945, 9047], [4946, 9051], [4949, 9050]]], [[[4997, 9058], [5005, 9050], [4993, 9046], [4985, 9052], [4997, 9058]]], [[[4873, 9498], [4891, 9498], [4896, 9477], [4861, 9473], [4835, 9492], [4873, 9498]]], [[[5028, 9501], [5020, 9506], [5024, 9512], [5031, 9506], [5028, 9501]]], [[[4572, 9496], [4598, 9474], [4566, 9489], [4549, 9518], [4559, 9517], [4572, 9496]]], [[[5096, 9519], [5068, 9513], [5061, 9515], [5078, 9523], [5096, 9519]]], [[[4836, 9533], [4854, 9529], [4841, 9525], [4831, 9528], [4836, 9533]]], [[[4834, 9549], [4821, 9547], [4818, 9551], [4821, 9552], [4834, 9549]]], [[[5232, 9606], [5208, 9601], [5172, 9596], [5168, 9599], [5232, 9606]]], [[[4959, 9618], [4952, 9618], [4952, 9622], [4954, 9623], [4959, 9618]]], [[[4952, 9626], [4956, 9625], [4954, 9623], [4948, 9624], [4952, 9626]]], [[[4829, 9625], [4825, 9626], [4828, 9628], [4833, 9627], [4829, 9625]]], [[[4869, 9639], [4863, 9636], [4860, 9639], [4865, 9640], [4869, 9639]]], [[[4852, 9635], [4853, 9640], [4845, 9644], [4858, 9641], [4852, 9635]]], [[[4695, 8938], [4714, 8960], [4709, 8928], [4719, 8942], [4728, 8929], [4700, 8908], [4682, 8909], [4697, 8925], [4695, 8938]]], [[[4746, 8954], [4766, 8974], [4770, 8954], [4736, 8947], [4746, 8954]]], [[[4848, 8986], [4846, 8986], [4846, 8991], [4850, 8991], [4849, 8986], [4870, 8998], [4887, 8985], [4887, 8995], [4865, 9007], [4876, 9013], [4879, 9012], [4879, 9011], [4880, 9010], [4881, 9012], [4917, 9007], [4919, 8998], [4933, 9016], [4966, 9038], [4970, 9048], [4984, 9038], [5004, 9042], [4979, 9023], [4981, 9000], [5017, 9043], [5027, 9047], [5021, 9015], [5052, 9041], [5053, 9055], [5081, 9049], [5061, 9022], [5073, 9018], [5089, 9043], [5124, 9034], [5156, 9011], [5129, 9000], [5088, 9005], [5115, 8995], [5115, 8982], [5119, 8985], [5127, 8987], [5125, 8988], [5125, 8988], [5129, 8990], [5149, 8986], [5149, 8971], [5131, 8977], [5123, 8963], [5105, 8958], [5093, 8945], [5091, 8955], [5105, 8968], [5099, 8979], [5077, 8986], [5062, 9000], [5039, 8991], [5021, 8992], [5006, 8980], [4995, 8937], [4973, 8921], [4945, 8934], [4924, 8924], [4900, 8929], [4878, 8958], [4848, 8946], [4839, 8939], [4829, 8911], [4801, 8918], [4775, 8920], [4767, 8891], [4750, 8898], [4735, 8887], [4715, 8863], [4724, 8845], [4695, 8817], [4696, 8806], [4668, 8799], [4668, 8760], [4642, 8725], [4655, 8719], [4651, 8698], [4630, 8701], [4614, 8695], [4593, 8664], [4600, 8650], [4596, 8631], [4603, 8617], [4598, 8592], [4619, 8576], [4614, 8561], [4601, 8559], [4611, 8536], [4609, 8520], [4589, 8509], [4588, 8482], [4577, 8471], [4548, 8482], [4525, 8469], [4490, 8439], [4463, 8429], [4432, 8433], [4401, 8460], [4403, 8473], [4418, 8467], [4412, 8486], [4394, 8477], [4401, 8503], [4390, 8509], [4407, 8518], [4387, 8525], [4396, 8540], [4377, 8562], [4398, 8584], [4381, 8597], [4400, 8607], [4404, 8620], [4445, 8638], [4443, 8647], [4498, 8667], [4501, 8673], [4469, 8669], [4499, 8688], [4510, 8674], [4526, 8680], [4537, 8665], [4578, 8688], [4566, 8689], [4532, 8674], [4521, 8686], [4540, 8694], [4539, 8706], [4563, 8726], [4589, 8735], [4571, 8736], [4595, 8749], [4599, 8767], [4628, 8813], [4640, 8839], [4683, 8865], [4700, 8880], [4676, 8884], [4708, 8892], [4690, 8894], [4724, 8904], [4714, 8913], [4748, 8930], [4752, 8947], [4773, 8953], [4779, 8969], [4834, 8993], [4844, 8984], [4848, 8986]]], [[[4979, 9366], [4980, 9369], [4994, 9379], [4979, 9366], [4979, 9366], [4979, 9366]]], [[[4960, 9449], [4925, 9414], [4902, 9413], [4905, 9426], [4911, 9432], [4857, 9425], [4855, 9433], [4878, 9455], [4855, 9466], [4879, 9474], [4917, 9477], [4936, 9452], [4960, 9449]]], [[[4691, 9565], [4697, 9547], [4722, 9519], [4702, 9571], [4712, 9593], [4727, 9595], [4758, 9585], [4773, 9573], [4763, 9552], [4781, 9567], [4796, 9554], [4798, 9535], [4823, 9536], [4827, 9526], [4874, 9515], [4870, 9503], [4850, 9505], [4800, 9490], [4802, 9466], [4788, 9464], [4776, 9428], [4763, 9426], [4735, 9370], [4692, 9398], [4663, 9409], [4650, 9431], [4685, 9441], [4737, 9448], [4735, 9452], [4644, 9445], [4640, 9464], [4683, 9468], [4705, 9482], [4739, 9483], [4721, 9489], [4736, 9504], [4727, 9506], [4711, 9491], [4695, 9490], [4676, 9507], [4664, 9492], [4674, 9485], [4648, 9474], [4623, 9473], [4606, 9495], [4583, 9508], [4601, 9518], [4584, 9529], [4596, 9545], [4572, 9531], [4555, 9562], [4564, 9571], [4588, 9581], [4598, 9570], [4646, 9584], [4645, 9572], [4623, 9571], [4611, 9561], [4636, 9564], [4654, 9542], [4649, 9561], [4669, 9579], [4691, 9565]]], [[[4940, 9612], [5030, 9603], [5043, 9598], [5040, 9582], [5001, 9566], [5005, 9559], [4982, 9547], [4956, 9545], [4949, 9537], [4916, 9540], [4915, 9553], [4853, 9550], [4819, 9565], [4843, 9570], [4884, 9572], [4885, 9580], [4794, 9573], [4777, 9584], [4795, 9594], [4765, 9600], [4774, 9611], [4810, 9598], [4801, 9616], [4818, 9607], [4841, 9620], [4855, 9606], [4884, 9610], [4899, 9592], [4910, 9626], [4926, 9622], [4918, 9602], [4935, 9601], [4940, 9612]]], [[[4979, 9366], [4977, 9362], [4978, 9366], [4979, 9366], [4979, 9366], [4979, 9366]]]]
            }
        }, {
            "type": "Feature",
            "id": "KN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.49,
                "hc-key": "kn",
                "hc-a2": "KN",
                "name": "Saint Kitts and Nevis",
                "labelrank": "6",
                "country-abbrev": "St.K.N.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "KNA",
                "iso-a2": "KN",
                "woe-id": "23424940",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2394, 7009], [2386, 7014], [2387, 7015], [2391, 7013], [2394, 7009]]]
            }
        }, {
            "type": "Feature",
            "id": "BH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.5,
                "hc-key": "bh",
                "hc-a2": "BH",
                "name": "Bahrain",
                "labelrank": "4",
                "country-abbrev": "Bahr.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "BHR",
                "iso-a2": "BH",
                "woe-id": "23424753",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5728, 7287], [5732, 7285], [5731, 7273], [5728, 7279], [5728, 7287]]]
            }
        }, {
            "type": "Feature",
            "id": "TO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.54,
                "hc-middle-y": 0.34,
                "hc-key": "to",
                "hc-a2": "TO",
                "name": "Tonga",
                "labelrank": "4",
                "country-abbrev": "Tongo",
                "subregion": "Polynesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "TON",
                "iso-a2": "TO",
                "woe-id": "23424964",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[-919, 5867], [-920, 5865], [-931, 5870], [-924, 5872], [-919, 5867]]]
            }
        }, {
            "type": "Feature",
            "id": "FI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.75,
                "hc-key": "fi",
                "hc-a2": "FI",
                "name": "Finland",
                "labelrank": "3",
                "country-abbrev": "Fin.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "FIN",
                "iso-a2": "FI",
                "woe-id": "23424812",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4848, 8521], [4847, 8515], [4838, 8514], [4842, 8517], [4848, 8521]]], [[[4835, 8519], [4838, 8520], [4835, 8514], [4830, 8517], [4835, 8519]]], [[[4840, 8527], [4831, 8519], [4817, 8526], [4832, 8530], [4840, 8527]]], [[[4875, 8525], [4876, 8522], [4886, 8523], [4874, 8519], [4875, 8525]]], [[[4901, 8515], [4902, 8523], [4913, 8520], [4903, 8509], [4901, 8515]]], [[[4898, 8529], [4902, 8529], [4896, 8526], [4891, 8527], [4898, 8529]]], [[[4867, 8540], [4868, 8536], [4868, 8531], [4866, 8537], [4867, 8540]]], [[[4867, 8664], [4870, 8660], [4866, 8657], [4862, 8661], [4867, 8664]]], [[[4973, 8748], [4966, 8743], [4964, 8746], [4967, 8748], [4973, 8748]]], [[[4883, 8535], [4877, 8536], [4868, 8562], [4875, 8590], [4866, 8604], [4866, 8644], [4874, 8660], [4899, 8665], [4911, 8687], [4929, 8692], [4970, 8738], [4984, 8736], [4986, 8769], [4952, 8784], [4937, 8814], [4947, 8833], [4931, 8867], [4937, 8891], [4912, 8913], [4890, 8917], [4848, 8946], [4878, 8958], [4900, 8929], [4924, 8924], [4945, 8934], [4973, 8921], [4995, 8937], [5006, 8980], [5021, 8992], [5039, 8991], [5062, 9000], [5077, 8986], [5099, 8979], [5105, 8968], [5091, 8955], [5093, 8945], [5078, 8920], [5085, 8903], [5105, 8896], [5125, 8877], [5098, 8842], [5097, 8834], [5121, 8798], [5127, 8776], [5116, 8775], [5119, 8754], [5112, 8744], [5126, 8734], [5125, 8716], [5141, 8698], [5124, 8685], [5160, 8660], [5171, 8646], [5161, 8627], [5101, 8570], [5060, 8539], [5041, 8540], [5004, 8526], [4983, 8526], [4941, 8513], [4914, 8515], [4914, 8528], [4884, 8535], [4888, 8531], [4887, 8529], [4882, 8532], [4883, 8535]]]]
            }
        }, {
            "type": "Feature",
            "id": "ID",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.42,
                "hc-key": "id",
                "hc-a2": "ID",
                "name": "Indonesia",
                "labelrank": "2",
                "country-abbrev": "Indo.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "IDN",
                "iso-a2": "ID",
                "woe-id": "23424846",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7779, 6225], [7802, 6207], [7792, 6197], [7767, 6213], [7747, 6219], [7779, 6225]]], [[[8329, 6260], [8335, 6253], [8298, 6253], [8309, 6276], [8333, 6284], [8341, 6278], [8329, 6260]]], [[[8201, 6314], [8206, 6341], [8213, 6334], [8210, 6310], [8197, 6297], [8201, 6314]]], [[[7853, 6341], [7836, 6340], [7833, 6350], [7867, 6371], [7861, 6333], [7853, 6341]]], [[[7954, 6430], [7944, 6444], [7907, 6442], [7908, 6451], [7965, 6447], [7955, 6441], [7958, 6409], [7980, 6410], [7992, 6401], [7977, 6387], [7955, 6401], [7954, 6430]]], [[[7409, 6417], [7426, 6424], [7431, 6408], [7413, 6414], [7381, 6409], [7365, 6417], [7359, 6437], [7340, 6443], [7353, 6455], [7367, 6454], [7373, 6431], [7390, 6425], [7383, 6415], [7409, 6417]]], [[[7177, 6441], [7202, 6412], [7189, 6417], [7147, 6465], [7157, 6472], [7167, 6448], [7177, 6441]]], [[[7994, 6477], [7988, 6492], [8010, 6479], [8005, 6464], [8019, 6451], [7996, 6452], [8004, 6463], [7994, 6477]]], [[[7314, 6525], [7329, 6494], [7317, 6481], [7324, 6503], [7307, 6535], [7330, 6530], [7314, 6525]]], [[[7083, 6569], [7109, 6564], [7111, 6544], [7128, 6529], [7121, 6517], [7107, 6537], [7104, 6561], [7083, 6569]]], [[[7706, 6254], [7723, 6262], [7729, 6254], [7749, 6258], [7750, 6247], [7690, 6232], [7656, 6241], [7672, 6259], [7685, 6250], [7706, 6254]]], [[[8005, 6405], [8013, 6414], [8060, 6419], [8090, 6408], [8097, 6387], [8059, 6403], [8040, 6406], [8027, 6397], [8018, 6410], [8005, 6405]]], [[[7897, 6226], [7904, 6221], [7910, 6230], [7914, 6231], [7923, 6237], [7924, 6229], [7928, 6221], [7910, 6202], [7881, 6195], [7887, 6217], [7897, 6226]]], [[[7717, 6622], [7709, 6617], [7711, 6622], [7717, 6622]]], [[[8397, 6424], [8397, 6298], [8397, 6232], [8370, 6263], [8336, 6257], [8341, 6278], [8329, 6289], [8330, 6305], [8303, 6346], [8249, 6368], [8226, 6370], [8181, 6398], [8159, 6380], [8156, 6404], [8138, 6422], [8154, 6418], [8163, 6427], [8191, 6430], [8189, 6438], [8152, 6432], [8134, 6439], [8130, 6450], [8103, 6461], [8077, 6439], [8065, 6445], [8099, 6461], [8088, 6473], [8081, 6497], [8097, 6500], [8110, 6489], [8092, 6485], [8108, 6464], [8110, 6476], [8153, 6489], [8173, 6479], [8190, 6479], [8199, 6460], [8196, 6437], [8207, 6428], [8220, 6402], [8236, 6402], [8258, 6425], [8258, 6444], [8247, 6452], [8243, 6475], [8218, 6469], [8233, 6481], [8256, 6469], [8256, 6452], [8283, 6447], [8304, 6457], [8364, 6430], [8397, 6424]]], [[[7616, 6261], [7619, 6242], [7579, 6257], [7562, 6252], [7504, 6259], [7465, 6274], [7434, 6271], [7407, 6280], [7381, 6282], [7381, 6293], [7350, 6300], [7367, 6327], [7389, 6321], [7396, 6327], [7415, 6317], [7434, 6316], [7442, 6302], [7498, 6296], [7511, 6312], [7545, 6297], [7601, 6298], [7609, 6292], [7638, 6299], [7616, 6291], [7564, 6290], [7565, 6279], [7581, 6271], [7603, 6277], [7615, 6270], [7616, 6262], [7637, 6263], [7648, 6245], [7638, 6241], [7616, 6261]]], [[[7785, 6256], [7823, 6247], [7828, 6255], [7846, 6246], [7865, 6259], [7928, 6260], [7950, 6270], [7974, 6278], [7929, 6255], [7898, 6249], [7890, 6256], [7831, 6239], [7776, 6241], [7785, 6256]]], [[[7862, 6370], [7822, 6363], [7826, 6380], [7805, 6396], [7810, 6419], [7784, 6413], [7791, 6405], [7792, 6364], [7788, 6338], [7766, 6334], [7759, 6343], [7767, 6373], [7758, 6400], [7747, 6395], [7743, 6423], [7759, 6443], [7758, 6463], [7770, 6481], [7772, 6507], [7780, 6521], [7795, 6523], [7805, 6540], [7826, 6531], [7894, 6524], [7914, 6535], [7929, 6552], [7934, 6541], [7910, 6513], [7874, 6509], [7869, 6515], [7788, 6512], [7778, 6494], [7781, 6481], [7798, 6459], [7811, 6459], [7828, 6486], [7840, 6492], [7843, 6478], [7879, 6481], [7873, 6466], [7883, 6462], [7875, 6448], [7859, 6467], [7824, 6443], [7851, 6408], [7845, 6401], [7862, 6370]]], [[[8001, 6550], [8019, 6567], [8010, 6554], [8015, 6538], [8035, 6546], [8035, 6531], [8023, 6526], [8039, 6507], [8013, 6514], [8011, 6499], [8027, 6473], [7996, 6501], [8002, 6512], [7996, 6535], [8001, 6550]]], [[[7707, 6622], [7714, 6605], [7701, 6597], [7722, 6567], [7715, 6556], [7749, 6530], [7743, 6524], [7712, 6522], [7703, 6485], [7691, 6465], [7677, 6458], [7678, 6436], [7667, 6412], [7669, 6386], [7660, 6395], [7620, 6378], [7609, 6401], [7591, 6399], [7572, 6407], [7537, 6396], [7534, 6419], [7503, 6410], [7491, 6412], [7481, 6467], [7468, 6462], [7458, 6485], [7459, 6503], [7450, 6524], [7456, 6545], [7473, 6561], [7473, 6547], [7500, 6525], [7545, 6533], [7547, 6542], [7571, 6546], [7590, 6536], [7616, 6542], [7624, 6566], [7645, 6589], [7656, 6629], [7695, 6627], [7707, 6622]]], [[[7367, 6404], [7360, 6334], [7328, 6326], [7304, 6349], [7257, 6383], [7213, 6437], [7197, 6476], [7169, 6507], [7153, 6505], [7162, 6518], [7145, 6557], [7119, 6571], [7118, 6584], [7093, 6610], [7085, 6611], [7054, 6641], [7043, 6666], [7050, 6670], [7083, 6653], [7115, 6654], [7137, 6622], [7181, 6593], [7187, 6579], [7216, 6555], [7215, 6567], [7232, 6552], [7262, 6544], [7262, 6533], [7278, 6531], [7277, 6520], [7299, 6507], [7288, 6479], [7318, 6470], [7327, 6430], [7354, 6430], [7367, 6404]]]]
            }
        }, {
            "type": "Feature",
            "id": "MU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.63,
                "hc-middle-y": 0.58,
                "hc-key": "mu",
                "hc-a2": "MU",
                "name": "Mauritius",
                "labelrank": "5",
                "country-abbrev": "Mus.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MUS",
                "iso-a2": "MU",
                "woe-id": "23424894",
                "continent": "Seven seas (open ocean)"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5942, 5903], [5941, 5892], [5932, 5891], [5936, 5905], [5942, 5903]]]
            }
        }
        , {
            "type": "Feature",
            "id": "RE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.63,
                "hc-middle-y": 0.58,
                "hc-key": "re",
                "hc-a2": "RE",
                "name": "Reunion",
                "labelrank": "5",
                "country-abbrev": "Mus.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "RE",
                "iso-a2": "RE",
                "woe-id": "23424894",
                "continent": "Seven seas (open ocean)"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5842, 5803], [5841, 5792], [5832, 5791], [5834, 5802], [5836, 5805], [5842, 5803]]]
            }
        }, {
            "type": "Feature",
            "id": "SE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.4,
                "hc-middle-y": 0.48,
                "hc-key": "se",
                "hc-a2": "SE",
                "name": "Sweden",
                "labelrank": "3",
                "country-abbrev": "Swe.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "SWE",
                "iso-a2": "SE",
                "woe-id": "23424954",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4801, 8424], [4791, 8396], [4780, 8383], [4775, 8410], [4801, 8424]]], [[[4586, 8430], [4583, 8426], [4580, 8426], [4579, 8430], [4586, 8430]]], [[[4781, 8470], [4781, 8470], [4781, 8474], [4785, 8475], [4781, 8470]]], [[[4895, 8765], [4895, 8771], [4899, 8769], [4899, 8765], [4895, 8765]]], [[[4587, 8438], [4588, 8433], [4579, 8432], [4577, 8435], [4587, 8438], [4570, 8443], [4567, 8471], [4577, 8471], [4588, 8482], [4589, 8509], [4609, 8520], [4611, 8536], [4601, 8559], [4614, 8561], [4619, 8576], [4598, 8592], [4603, 8617], [4596, 8631], [4600, 8650], [4593, 8664], [4614, 8695], [4630, 8701], [4651, 8698], [4655, 8719], [4642, 8725], [4668, 8760], [4668, 8799], [4696, 8806], [4695, 8817], [4724, 8845], [4715, 8863], [4735, 8887], [4750, 8898], [4767, 8891], [4775, 8920], [4801, 8918], [4829, 8911], [4839, 8939], [4848, 8946], [4890, 8917], [4912, 8913], [4937, 8891], [4931, 8867], [4947, 8833], [4937, 8814], [4952, 8784], [4910, 8779], [4884, 8770], [4863, 8729], [4877, 8718], [4852, 8691], [4820, 8670], [4814, 8676], [4801, 8659], [4787, 8659], [4786, 8646], [4766, 8627], [4751, 8627], [4757, 8614], [4744, 8577], [4750, 8548], [4768, 8541], [4785, 8522], [4793, 8524], [4802, 8503], [4783, 8477], [4733, 8453], [4734, 8423], [4724, 8423], [4732, 8405], [4725, 8393], [4737, 8384], [4726, 8354], [4719, 8370], [4707, 8347], [4673, 8350], [4659, 8336], [4658, 8318], [4622, 8319], [4608, 8355], [4619, 8371], [4604, 8382], [4584, 8421], [4589, 8438], [4587, 8438]]]]
            }
        }, {
            "type": "Feature",
            "id": "TT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "tt",
                "hc-a2": "TT",
                "name": "Trinidad and Tobago",
                "labelrank": "5",
                "country-abbrev": "Tr.T.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "TTO",
                "iso-a2": "TT",
                "woe-id": "23424958",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2440, 6813], [2441, 6798], [2427, 6802], [2421, 6815], [2440, 6813]]]
            }
        }, {
            "type": "Feature",
            "id": "MY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.89,
                "hc-middle-y": 0.31,
                "hc-key": "my",
                "hc-a2": "MY",
                "name": "Malaysia",
                "labelrank": "3",
                "country-abbrev": "Malay.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "MYS",
                "iso-a2": "MY",
                "woe-id": "23424901",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7198, 6660], [7197, 6654], [7194, 6654], [7194, 6660], [7198, 6660]]], [[[7717, 6622], [7711, 6622], [7711, 6623], [7707, 6622], [7695, 6627], [7656, 6629], [7645, 6589], [7624, 6566], [7616, 6542], [7590, 6536], [7571, 6546], [7547, 6542], [7545, 6533], [7500, 6525], [7473, 6547], [7473, 6561], [7481, 6550], [7513, 6546], [7523, 6571], [7525, 6570], [7525, 6575], [7526, 6578], [7572, 6593], [7600, 6625], [7601, 6635], [7620, 6618], [7630, 6643], [7631, 6644], [7632, 6641], [7641, 6626], [7635, 6644], [7648, 6653], [7663, 6680], [7685, 6693], [7697, 6716], [7699, 6695], [7757, 6652], [7723, 6643], [7736, 6628], [7714, 6623], [7717, 6622]]], [[[7192, 6689], [7193, 6696], [7220, 6683], [7222, 6665], [7242, 6668], [7250, 6683], [7281, 6658], [7290, 6641], [7287, 6610], [7290, 6586], [7300, 6578], [7315, 6540], [7288, 6545], [7226, 6583], [7227, 6596], [7209, 6614], [7199, 6676], [7178, 6689], [7192, 6689]]]]
            }
        }, {
            "type": "Feature",
            "id": "BS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.21,
                "hc-middle-y": 0.08,
                "hc-key": "bs",
                "hc-a2": "BS",
                "name": "The Bahamas",
                "labelrank": "4",
                "country-abbrev": "Bhs.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "BHS",
                "iso-a2": "BS",
                "woe-id": "23424758",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[1949, 7226], [1951, 7209], [1931, 7237], [1933, 7254], [1949, 7226]]], [[[2028, 7190], [2026, 7190], [2025, 7195], [2025, 7195], [2028, 7190], [2028, 7190], [2028, 7190]]], [[[2025, 7195], [2024, 7197], [1999, 7207], [2016, 7223], [1993, 7237], [1994, 7252], [1961, 7276], [1953, 7308], [1967, 7296], [1963, 7277], [1995, 7252], [2019, 7221], [2025, 7195], [2025, 7195]]], [[[2028, 7190], [2094, 7166], [2090, 7140], [2085, 7166], [2057, 7165], [2060, 7173], [2033, 7182], [2028, 7190], [2028, 7190], [2028, 7190]]]]
            }
        }, {
            "type": "Feature",
            "id": "PA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.22,
                "hc-middle-y": 0.5,
                "hc-key": "pa",
                "hc-a2": "PA",
                "name": "Panama",
                "labelrank": "4",
                "country-abbrev": "Pan.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "PAN",
                "iso-a2": "PA",
                "woe-id": "23424924",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1943, 6712], [1931, 6726], [1924, 6752], [1893, 6763], [1866, 6737], [1880, 6719], [1855, 6712], [1852, 6723], [1827, 6712], [1835, 6726], [1829, 6740], [1802, 6744], [1795, 6736], [1790, 6744], [1791, 6745], [1791, 6745], [1791, 6745], [1791, 6745], [1805, 6781], [1819, 6762], [1849, 6759], [1891, 6782], [1927, 6776], [1958, 6754], [1964, 6733], [1943, 6712]]]
            }
        }, {
            "type": "Feature",
            "id": "PW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.38,
                "hc-middle-y": 0.44,
                "hc-key": "pw",
                "hc-a2": "PW",
                "name": "Palau",
                "labelrank": "6",
                "country-abbrev": "Palau",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "PLW",
                "iso-a2": "PW",
                "woe-id": "23424927",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[8207, 6715], [8205, 6719], [8208, 6723], [8211, 6723], [8207, 6715]]]
            }
        }, {
            "type": "Feature",
            "id": "TV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.25,
                "hc-middle-y": 0.5,
                "hc-key": "tv",
                "hc-a2": "TV",
                "name": "Tuvalu",
                "labelrank": "6",
                "country-abbrev": "Tuv.",
                "subregion": "Polynesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "TUV",
                "iso-a2": "TV",
                "woe-id": "23424970",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[9524, 6249], [9524, 6250], [9524, 6252], [9525, 6250], [9524, 6249]]]
            }
        }, {
            "type": "Feature",
            "id": "MH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.6,
                "hc-key": "mh",
                "hc-a2": "MH",
                "name": "Marshall Islands",
                "labelrank": "6",
                "country-abbrev": "M. Is.",
                "subregion": "Micronesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "MHL",
                "iso-a2": "MH",
                "woe-id": "23424932",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[9284, 6710], [9289, 6708], [9290, 6707], [9288, 6707], [9284, 6710]]]
            }
        }, {
            "type": "Feature",
            "id": "CL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.4,
                "hc-middle-y": 0.93,
                "hc-key": "cl",
                "hc-a2": "CL",
                "name": "Chile",
                "labelrank": "2",
                "country-abbrev": "Chile",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "CHL",
                "iso-a2": "CL",
                "woe-id": "23424782",
                "continent": "South America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2164, 5957], [2176, 5959], [2190, 5982], [2205, 5938], [2221, 5923], [2212, 5893], [2228, 5867], [2238, 5820], [2258, 5820], [2263, 5814], [2254, 5783], [2227, 5771], [2217, 5759], [2225, 5692], [2210, 5685], [2199, 5659], [2186, 5645], [2174, 5614], [2178, 5583], [2171, 5582], [2158, 5543], [2182, 5484], [2164, 5425], [2164, 5395], [2145, 5380], [2140, 5339], [2150, 5306], [2134, 5298], [2131, 5274], [2118, 5235], [2124, 5187], [2113, 5181], [2112, 5155], [2126, 5122], [2122, 5105], [2140, 5104], [2137, 5090], [2115, 5092], [2137, 5072], [2122, 5056], [2128, 5047], [2119, 5001], [2107, 4993], [2100, 4975], [2108, 4959], [2099, 4942], [2070, 4914], [2071, 4891], [2082, 4867], [2107, 4871], [2103, 4836], [2119, 4819], [2177, 4818], [2221, 4804], [2201, 4810], [2154, 4789], [2145, 4746], [2113, 4751], [2106, 4758], [2106, 4757], [2081, 4769], [2088, 4785], [2129, 4796], [2107, 4797], [2086, 4785], [2054, 4790], [2059, 4799], [2045, 4813], [2066, 4809], [2045, 4824], [2034, 4815], [2031, 4833], [2065, 4815], [2061, 4847], [2048, 4856], [2063, 4859], [2037, 4889], [2014, 4867], [2026, 4889], [2047, 4893], [2044, 4915], [2046, 4949], [2039, 4972], [2064, 4971], [2071, 4979], [2036, 4983], [2050, 5017], [2037, 5014], [2016, 5023], [2044, 5067], [2058, 5045], [2074, 5073], [2079, 5112], [2094, 5155], [2093, 5182], [2102, 5188], [2088, 5209], [2084, 5199], [2064, 5199], [2059, 5227], [2066, 5261], [2080, 5278], [2067, 5338], [2070, 5358], [2081, 5358], [2097, 5411], [2110, 5426], [2116, 5458], [2127, 5480], [2134, 5517], [2126, 5556], [2127, 5586], [2137, 5596], [2130, 5628], [2148, 5669], [2162, 5740], [2158, 5811], [2165, 5813], [2174, 5862], [2172, 5904], [2164, 5957]], [[2106, 4758], [2106, 4760], [2106, 4760], [2106, 4760], [2135, 4774], [2141, 4786], [2116, 4773], [2105, 4776], [2106, 4760], [2106, 4760], [2106, 4760], [2105, 4759], [2106, 4758]]], [[[2275, 4689], [2262, 4684], [2231, 4688], [2228, 4701], [2255, 4701], [2275, 4689]]], [[[2127, 4739], [2145, 4734], [2142, 4723], [2132, 4731], [2127, 4739]]], [[[2034, 4877], [2051, 4868], [2041, 4843], [2021, 4838], [2040, 4851], [2025, 4866], [2043, 4866], [2034, 4877]]], [[[2017, 4955], [2011, 4969], [2018, 4972], [2025, 4937], [2017, 4955]]], [[[2058, 5121], [2068, 5089], [2046, 5091], [2033, 5099], [2048, 5105], [2058, 5121]]], [[[2178, 4696], [2182, 4703], [2210, 4698], [2244, 4677], [2262, 4660], [2240, 4661], [2227, 4676], [2206, 4680], [2210, 4690], [2181, 4681], [2178, 4696]]], [[[2078, 4764], [2040, 4782], [2073, 4773], [2112, 4746], [2110, 4732], [2092, 4733], [2064, 4762], [2078, 4764]]], [[[2026, 4979], [2032, 4982], [2042, 4947], [2043, 4898], [2032, 4895], [2010, 4910], [2017, 4924], [2030, 4924], [2020, 4969], [2026, 4979]]], [[[2071, 5177], [2065, 5141], [2035, 5131], [2051, 5154], [2056, 5193], [2070, 5198], [2071, 5177]]], [[[2216, 4793], [2215, 4706], [2213, 4707], [2215, 4706], [2215, 4702], [2176, 4707], [2159, 4689], [2144, 4714], [2149, 4743], [2162, 4755], [2166, 4725], [2205, 4721], [2174, 4735], [2171, 4749], [2194, 4764], [2169, 4760], [2163, 4778], [2183, 4787], [2193, 4800], [2216, 4793]]]]
            }
        }, {
            "type": "Feature",
            "id": "TH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.26,
                "hc-middle-y": 0.49,
                "hc-key": "th",
                "hc-a2": "TH",
                "name": "Thailand",
                "labelrank": "3",
                "country-abbrev": "Thai.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "THA",
                "iso-a2": "TH",
                "woe-id": "23424960",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7255, 6858], [7258, 6856], [7261, 6853], [7256, 6852], [7255, 6858]]], [[[7250, 6683], [7242, 6668], [7222, 6665], [7220, 6683], [7193, 6696], [7192, 6689], [7170, 6711], [7168, 6724], [7135, 6751], [7142, 6787], [7152, 6804], [7152, 6814], [7178, 6848], [7162, 6884], [7164, 6904], [7137, 6937], [7145, 6952], [7146, 6974], [7154, 6977], [7142, 7004], [7120, 7028], [7113, 7048], [7130, 7088], [7145, 7084], [7187, 7107], [7191, 7103], [7205, 7096], [7202, 7079], [7225, 7078], [7219, 7046], [7222, 7017], [7250, 7039], [7265, 7028], [7289, 7046], [7306, 7043], [7331, 7014], [7329, 6989], [7354, 6964], [7353, 6942], [7341, 6923], [7296, 6926], [7275, 6918], [7257, 6900], [7262, 6872], [7274, 6843], [7266, 6858], [7242, 6873], [7217, 6871], [7217, 6897], [7190, 6895], [7189, 6859], [7168, 6813], [7167, 6771], [7184, 6773], [7197, 6744], [7201, 6710], [7234, 6701], [7250, 6683]]]]
            }
        }, {
            "type": "Feature",
            "id": "GD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "gd",
                "hc-a2": "GD",
                "name": "Grenada",
                "labelrank": "6",
                "country-abbrev": "Gren.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "GRD",
                "iso-a2": "GD",
                "woe-id": "23424826",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2422, 6854], [2419, 6854], [2419, 6858], [2423, 6860], [2422, 6854]]]
            }
        }, {
            "type": "Feature",
            "id": "EE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.35,
                "hc-middle-y": 0.41,
                "hc-key": "ee",
                "hc-a2": "EE",
                "name": "Estonia",
                "labelrank": "6",
                "country-abbrev": "Est.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "EST",
                "iso-a2": "EE",
                "woe-id": "23424805",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4907, 8453], [4918, 8443], [4894, 8434], [4883, 8450], [4907, 8453]]], [[[4928, 8455], [4924, 8451], [4920, 8454], [4923, 8457], [4928, 8455]]], [[[4924, 8473], [4928, 8473], [4929, 8470], [4922, 8470], [4924, 8473]]], [[[4910, 8472], [4919, 8464], [4903, 8458], [4890, 8468], [4910, 8472]]], [[[5057, 8471], [5034, 8462], [5055, 8428], [5051, 8420], [5046, 8408], [5021, 8407], [4985, 8431], [4956, 8422], [4964, 8442], [4951, 8438], [4933, 8452], [4932, 8480], [4964, 8491], [5006, 8499], [5031, 8492], [5066, 8492], [5068, 8490], [5071, 8487], [5069, 8486], [5065, 8486], [5065, 8486], [5067, 8485], [5067, 8485], [5068, 8485], [5067, 8485], [5064, 8484], [5061, 8478], [5057, 8471]]]]
            }
        }, {
            "type": "Feature",
            "id": "AG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.48,
                "hc-key": "ag",
                "hc-a2": "AG",
                "name": "Antigua and Barbuda",
                "labelrank": "6",
                "country-abbrev": "Ant.B.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "ATG",
                "iso-a2": "AG",
                "woe-id": "23424737",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2418, 7007], [2421, 7004], [2416, 7003], [2414, 7006], [2418, 7007]]]
            }
        }, {
            "type": "Feature",
            "id": "TW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.41,
                "hc-key": "tw",
                "hc-a2": "TW",
                "name": "Taiwan",
                "labelrank": "3",
                "country-abbrev": "Taiwan",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "TWN",
                "iso-a2": "TW",
                "woe-id": "23424971",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7765, 7202], [7781, 7201], [7810, 7250], [7834, 7252], [7820, 7190], [7803, 7153], [7780, 7188], [7765, 7202]]]
            }
        }, {
            "type": "Feature",
            "id": "BB",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.31,
                "hc-middle-y": 0.56,
                "hc-key": "bb",
                "hc-a2": "BB",
                "name": "Barbados",
                "labelrank": "5",
                "country-abbrev": "Barb.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "BRB",
                "iso-a2": "BB",
                "woe-id": "23424754",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2485, 6885], [2481, 6886], [2482, 6893], [2487, 6888], [2485, 6885]]]
            }
        }, {
            "type": "Feature",
            "id": "IT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.47,
                "hc-key": "it",
                "hc-a2": "IT",
                "name": "Italy",
                "labelrank": "2",
                "country-abbrev": "Italy",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ITA",
                "iso-a2": "IT",
                "woe-id": "23424853",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4604, 7668], [4616, 7677], [4646, 7670], [4701, 7680], [4688, 7663], [4691, 7637], [4685, 7625], [4667, 7630], [4604, 7668]]], [[[4518, 7781], [4529, 7758], [4522, 7710], [4507, 7713], [4501, 7701], [4488, 7704], [4490, 7750], [4482, 7770], [4491, 7768], [4518, 7781]]], [[[4461, 7873], [4465, 7887], [4446, 7889], [4446, 7911], [4434, 7921], [4451, 7932], [4447, 7951], [4471, 7951], [4478, 7963], [4500, 7956], [4513, 7971], [4533, 7967], [4548, 7973], [4548, 7986], [4599, 7994], [4605, 7979], [4644, 7973], [4634, 7964], [4644, 7939], [4629, 7945], [4598, 7928], [4609, 7916], [4601, 7907], [4605, 7889], [4641, 7864], [4655, 7831], [4687, 7807], [4712, 7808], [4709, 7791], [4771, 7762], [4786, 7744], [4781, 7733], [4766, 7749], [4742, 7758], [4727, 7729], [4746, 7719], [4744, 7702], [4729, 7698], [4728, 7685], [4713, 7668], [4701, 7671], [4707, 7693], [4717, 7697], [4700, 7742], [4679, 7748], [4675, 7763], [4654, 7769], [4644, 7783], [4624, 7782], [4569, 7828], [4551, 7850], [4538, 7881], [4498, 7896], [4480, 7879], [4461, 7873]], [[4607, 7806], [4607, 7806], [4607, 7806], [4607, 7806], [4607, 7806]], [[4607, 7877], [4608, 7880], [4606, 7880], [4605, 7878], [4607, 7877]]]]
            }
        }, {
            "type": "Feature",
            "id": "MT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.53,
                "hc-key": "mt",
                "hc-a2": "MT",
                "name": "Malta",
                "labelrank": "5",
                "country-abbrev": "Malta",
                "subregion": "Southern Europe",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "MLT",
                "iso-a2": "MT",
                "woe-id": "23424897",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4661, 7604], [4667, 7601], [4668, 7597], [4664, 7598], [4661, 7604]]]
            }
        }, {
            "type": "Feature",
            "id": "PG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.23,
                "hc-middle-y": 0.54,
                "hc-key": "pg",
                "hc-a2": "PG",
                "name": "Papua New Guinea",
                "labelrank": "2",
                "country-abbrev": "P.N.G.",
                "subregion": "Melanesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "PNG",
                "iso-a2": "PG",
                "woe-id": "23424926",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[8800, 6340], [8812, 6337], [8839, 6303], [8816, 6308], [8800, 6340]]], [[[8397, 6232], [8397, 6298], [8397, 6424], [8487, 6389], [8501, 6388], [8539, 6357], [8538, 6339], [8588, 6325], [8600, 6304], [8573, 6302], [8580, 6281], [8608, 6264], [8622, 6233], [8643, 6234], [8640, 6221], [8663, 6217], [8674, 6225], [8691, 6218], [8699, 6200], [8673, 6195], [8683, 6190], [8603, 6201], [8577, 6222], [8547, 6263], [8479, 6277], [8485, 6266], [8466, 6254], [8468, 6237], [8446, 6226], [8397, 6232]]], [[[8691, 6419], [8662, 6427], [8653, 6454], [8670, 6430], [8713, 6410], [8721, 6422], [8723, 6405], [8755, 6375], [8748, 6358], [8730, 6395], [8691, 6419]]], [[[8652, 6315], [8627, 6328], [8606, 6331], [8607, 6340], [8640, 6336], [8693, 6341], [8710, 6354], [8708, 6378], [8734, 6373], [8726, 6343], [8677, 6316], [8652, 6315]]]]
            }
        }, {
            "type": "Feature",
            "id": "DE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.34,
                "hc-key": "de",
                "hc-a2": "DE",
                "name": "Germany",
                "labelrank": "2",
                "country-abbrev": "Ger.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "DEU",
                "iso-a2": "DE",
                "woe-id": "23424829",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4452, 8231], [4456, 8250], [4492, 8243], [4505, 8257], [4492, 8289], [4495, 8298], [4500, 8298], [4518, 8295], [4533, 8293], [4539, 8282], [4557, 8274], [4557, 8264], [4577, 8258], [4608, 8281], [4626, 8273], [4630, 8288], [4642, 8285], [4647, 8256], [4660, 8249], [4664, 8233], [4656, 8215], [4671, 8205], [4670, 8174], [4683, 8153], [4676, 8137], [4663, 8138], [4609, 8119], [4605, 8094], [4647, 8057], [4644, 8048], [4615, 8032], [4624, 8009], [4599, 8017], [4563, 8005], [4547, 8012], [4539, 8001], [4526, 8011], [4507, 8021], [4510, 8016], [4489, 8012], [4463, 8012], [4463, 8033], [4481, 8064], [4441, 8074], [4427, 8083], [4431, 8096], [4420, 8109], [4427, 8116], [4416, 8133], [4428, 8175], [4447, 8191], [4452, 8231]]], [[[4511, 8015], [4511, 8015], [4511, 8015], [4511, 8015]]], [[[4658, 8257], [4647, 8269], [4659, 8259], [4658, 8258], [4658, 8257]]]]
            }
        }, {
            "type": "Feature",
            "id": "VU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.17,
                "hc-middle-y": 0.21,
                "hc-key": "vu",
                "hc-a2": "VU",
                "name": "Vanuatu",
                "labelrank": "4",
                "country-abbrev": "Van.",
                "subregion": "Melanesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "VUT",
                "iso-a2": "VU",
                "woe-id": "23424907",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[9176, 6081], [9167, 6053], [9171, 6035], [9157, 6038], [9158, 6053], [9176, 6081]]], [[[9199, 6027], [9199, 6028], [9199, 6028], [9199, 6028], [9199, 6027], [9199, 6027], [9199, 6027]]], [[[9199, 6027], [9201, 6010], [9201, 6010], [9191, 6020], [9199, 6027], [9199, 6027], [9199, 6027]]], [[[9207, 6003], [9201, 6006], [9201, 6010], [9201, 6010], [9207, 6003], [9207, 6003], [9207, 6003]]], [[[9207, 6003], [9211, 6000], [9210, 5973], [9199, 5977], [9209, 6000], [9207, 6003], [9207, 6003], [9207, 6003]]], [[[9199, 6028], [9190, 6043], [9198, 6045], [9199, 6028], [9199, 6028]]]]
            }
        }, {
            "type": "Feature",
            "id": "SG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.57,
                "hc-key": "sg",
                "hc-a2": "SG",
                "name": "Singapore",
                "labelrank": "6",
                "country-abbrev": "Sing.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "SGP",
                "iso-a2": "SG",
                "woe-id": "23424948",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7302, 6542], [7307, 6540], [7302, 6537], [7296, 6538], [7302, 6542]]]
            }
        }, {
            "type": "Feature",
            "id": "CY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.51,
                "hc-key": "cy",
                "hc-a2": "CY",
                "name": "Cyprus",
                "labelrank": "5",
                "country-abbrev": "Cyp.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "CYP",
                "iso-a2": "CY",
                "woe-id": "-90",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5235, 7570], [5235, 7570], [5235, 7570], [5235, 7570]]], [[[5243, 7572], [5245, 7569], [5239, 7568], [5236, 7571], [5239, 7572], [5242, 7571], [5243, 7572]]], [[[5235, 7569], [5236, 7569], [5236, 7569], [5236, 7569], [5235, 7569]]], [[[5233, 7569], [5231, 7564], [5213, 7558], [5208, 7560], [5206, 7558], [5191, 7571], [5200, 7576], [5202, 7575], [5203, 7576], [5204, 7576], [5204, 7576], [5205, 7576], [5205, 7576], [5205, 7576], [5205, 7576], [5225, 7575], [5233, 7569], [5233, 7569]]]]
            }
        }, {
            "type": "Feature",
            "id": "KM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.41,
                "hc-middle-y": 0.51,
                "hc-key": "km",
                "hc-a2": "KM",
                "name": "Comoros",
                "labelrank": "6",
                "country-abbrev": "Com.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "COM",
                "iso-a2": "KM",
                "woe-id": "23424786",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5521, 6149], [5514, 6154], [5516, 6165], [5519, 6165], [5521, 6149]]]
            }
        }, {
            "type": "Feature",
            "id": "FJ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.29,
                "hc-middle-y": 0.59,
                "hc-key": "fj",
                "hc-a2": "FJ",
                "name": "Fiji",
                "labelrank": "6",
                "country-abbrev": "Fiji",
                "subregion": "Melanesia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "FJI",
                "iso-a2": "FJ",
                "woe-id": "23424813",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[9550, 6006], [9511, 5997], [9516, 6013], [9545, 6020], [9550, 6006]]], [[[9462, 5988], [9472, 6001], [9478, 5984], [9497, 5987], [9510, 5976], [9503, 5939], [9494, 5937], [9493, 5959], [9469, 5964], [9462, 5988]]]]
            }
        }, {
            "type": "Feature",
            "id": "RU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.57,
                "hc-key": "ru",
                "hc-a2": "RU",
                "name": "Russia",
                "labelrank": "2",
                "country-abbrev": "Rus.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "RUS",
                "iso-a2": "RU",
                "woe-id": "23424936",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5839, 9180], [5840, 9194], [5821, 9203], [5856, 9216], [5873, 9243], [5899, 9245], [5877, 9255], [5902, 9259], [5888, 9267], [5911, 9273], [5904, 9280], [5922, 9299], [5942, 9295], [5937, 9307], [5955, 9311], [5971, 9329], [6002, 9331], [6017, 9342], [6041, 9341], [6041, 9353], [6079, 9348], [6128, 9355], [6174, 9371], [6214, 9394], [6233, 9398], [6269, 9389], [6273, 9370], [6255, 9357], [6220, 9342], [6050, 9296], [6033, 9284], [6005, 9254], [5988, 9255], [5984, 9243], [5955, 9251], [5971, 9231], [5957, 9228], [5938, 9195], [5913, 9197], [5928, 9186], [5913, 9174], [5886, 9178], [5904, 9173], [5895, 9148], [5883, 9148], [5873, 9121], [5876, 9099], [5894, 9064], [5939, 9035], [5925, 9023], [5875, 9036], [5866, 9026], [5811, 9042], [5820, 9060], [5810, 9074], [5800, 9070], [5804, 9052], [5759, 9080], [5757, 9101], [5769, 9113], [5785, 9109], [5796, 9140], [5791, 9152], [5812, 9153], [5806, 9166], [5825, 9177], [5839, 9180]], [[5868, 9182], [5862, 9185], [5856, 9183], [5860, 9184], [5868, 9182]]], [[[8830, 8135], [8853, 8138], [8833, 8111], [8818, 8112], [8837, 8131], [8830, 8135]]], [[[8281, 8299], [8297, 8311], [8312, 8303], [8301, 8287], [8281, 8299]]], [[[9093, 8479], [9094, 8465], [9064, 8452], [9075, 8472], [9093, 8479]]], [[[5717, 8942], [5699, 8933], [5673, 8930], [5662, 8939], [5664, 8958], [5693, 8970], [5719, 8957], [5717, 8942]]], [[[9235, 8984], [9220, 8973], [9186, 8987], [9202, 8998], [9236, 8990], [9235, 8984]]], [[[6533, 9121], [6508, 9120], [6528, 9140], [6551, 9132], [6533, 9121]]], [[[6585, 9156], [6586, 9145], [6559, 9154], [6573, 9165], [6585, 9156]]], [[[6338, 9180], [6353, 9173], [6301, 9162], [6303, 9183], [6332, 9189], [6338, 9180]]], [[[8384, 9212], [8375, 9230], [8394, 9233], [8399, 9217], [8384, 9212]]], [[[7583, 9238], [7565, 9222], [7527, 9237], [7543, 9248], [7581, 9245], [7583, 9238]]], [[[6674, 9336], [6664, 9327], [6658, 9283], [6644, 9298], [6657, 9306], [6651, 9329], [6674, 9336]]], [[[7077, 9379], [7078, 9373], [7051, 9376], [7068, 9399], [7077, 9379]]], [[[6006, 9604], [6007, 9591], [5974, 9584], [5957, 9587], [6006, 9604]]], [[[5721, 9591], [5744, 9598], [5756, 9586], [5715, 9590], [5700, 9602], [5721, 9607], [5721, 9591]]], [[[5923, 9615], [5919, 9596], [5882, 9599], [5891, 9614], [5923, 9615]]], [[[5813, 9619], [5828, 9610], [5817, 9603], [5778, 9610], [5813, 9619]]], [[[5987, 9615], [5952, 9609], [5962, 9603], [5933, 9600], [5919, 9624], [5963, 9623], [5987, 9615]]], [[[5850, 9624], [5858, 9628], [5875, 9610], [5864, 9606], [5862, 9623], [5848, 9617], [5826, 9624], [5829, 9633], [5850, 9624]]], [[[5907, 9645], [5918, 9637], [5886, 9635], [5832, 9646], [5861, 9653], [5907, 9645]]], [[[6047, 9658], [6011, 9661], [6027, 9667], [6058, 9668], [6047, 9658]]], [[[5947, 9662], [5969, 9663], [5946, 9645], [5915, 9662], [5947, 9662]]], [[[5877, 9661], [5892, 9663], [5941, 9647], [5922, 9639], [5911, 9647], [5871, 9658], [5844, 9661], [5851, 9669], [5877, 9661]]], [[[6148, 9674], [6163, 9670], [6170, 9655], [6139, 9642], [6101, 9638], [6084, 9649], [6102, 9658], [6128, 9659], [6148, 9674]]], [[[6933, 9666], [6893, 9667], [6896, 9675], [6937, 9674], [6933, 9666]]], [[[5947, 9677], [5941, 9670], [5886, 9673], [5875, 9683], [5907, 9678], [5901, 9687], [5947, 9677]]], [[[5970, 9687], [6004, 9680], [6001, 9672], [5959, 9686], [5913, 9692], [5944, 9700], [5970, 9687]]], [[[6073, 9699], [6075, 9709], [6117, 9709], [6111, 9701], [6083, 9706], [6073, 9699]]], [[[5962, 9704], [5949, 9718], [5986, 9721], [5990, 9713], [5959, 9710], [5962, 9704]]], [[[9600, 9076], [9623, 9063], [9609, 9052], [9567, 9045], [9548, 9049], [9512, 9039], [9515, 9063], [9555, 9082], [9600, 9076]]], [[[8413, 9177], [8383, 9188], [8401, 9210], [8428, 9212], [8469, 9191], [8473, 9173], [8462, 9170], [8413, 9177]]], [[[6956, 9579], [6925, 9581], [6926, 9595], [6946, 9596], [7003, 9587], [6971, 9569], [6956, 9579]]], [[[5623, 9643], [5630, 9649], [5663, 9648], [5677, 9633], [5649, 9644], [5625, 9629], [5599, 9621], [5569, 9636], [5623, 9643]]], [[[5996, 9647], [6070, 9652], [6070, 9633], [6040, 9619], [6018, 9625], [6000, 9621], [5987, 9628], [5996, 9647]]], [[[4822, 8279], [4841, 8290], [4818, 8280], [4818, 8280], [4827, 8298], [4857, 8314], [4859, 8314], [4846, 8300], [4866, 8300], [4867, 8313], [4913, 8298], [4911, 8276], [4909, 8276], [4822, 8279]]], [[[8094, 7820], [8092, 7824], [8089, 7828], [8102, 7840], [8111, 7861], [8110, 7883], [8101, 7911], [8132, 7925], [8143, 7900], [8157, 7919], [8176, 7940], [8188, 7963], [8196, 8000], [8214, 8017], [8212, 8038], [8203, 8042], [8164, 8032], [8146, 8017], [8104, 8016], [8097, 8039], [8081, 8061], [8055, 8082], [8016, 8087], [8001, 8096], [8002, 8112], [7968, 8182], [7971, 8188], [7947, 8221], [7917, 8227], [7875, 8244], [7803, 8232], [7779, 8212], [7800, 8203], [7801, 8186], [7781, 8168], [7753, 8118], [7755, 8105], [7738, 8102], [7712, 8085], [7680, 8097], [7667, 8104], [7642, 8100], [7610, 8115], [7574, 8088], [7523, 8080], [7505, 8071], [7440, 8078], [7423, 8101], [7402, 8104], [7385, 8117], [7346, 8122], [7297, 8109], [7255, 8128], [7253, 8155], [7204, 8171], [7189, 8171], [7156, 8187], [7131, 8160], [7124, 8143], [7138, 8124], [7133, 8106], [7110, 8094], [7067, 8104], [7029, 8105], [7019, 8126], [6972, 8130], [6963, 8137], [6935, 8122], [6883, 8100], [6860, 8082], [6841, 8083], [6829, 8072], [6820, 8070], [6815, 8069], [6793, 8089], [6781, 8083], [6754, 8088], [6746, 8106], [6724, 8114], [6711, 8137], [6700, 8142], [6661, 8131], [6642, 8132], [6633, 8150], [6619, 8154], [6598, 8135], [6583, 8162], [6536, 8232], [6496, 8260], [6501, 8279], [6428, 8245], [6399, 8248], [6406, 8259], [6377, 8267], [6338, 8266], [6339, 8291], [6328, 8314], [6310, 8308], [6294, 8316], [6253, 8310], [6250, 8301], [6185, 8286], [6163, 8276], [6127, 8275], [6100, 8265], [6038, 8257], [6044, 8232], [6069, 8226], [6029, 8208], [6040, 8195], [6013, 8177], [6024, 8167], [6052, 8159], [6049, 8134], [6030, 8129], [6008, 8136], [6002, 8125], [5977, 8130], [5968, 8144], [5906, 8145], [5881, 8124], [5852, 8144], [5846, 8137], [5813, 8162], [5787, 8162], [5783, 8172], [5767, 8162], [5731, 8167], [5724, 8155], [5697, 8147], [5695, 8136], [5675, 8126], [5681, 8105], [5668, 8097], [5642, 8121], [5623, 8097], [5626, 8073], [5610, 8043], [5628, 8038], [5629, 8021], [5656, 8019], [5685, 7982], [5668, 7978], [5691, 7966], [5662, 7943], [5644, 7943], [5632, 7916], [5617, 7904], [5643, 7872], [5639, 7846], [5672, 7804], [5648, 7781], [5609, 7806], [5585, 7817], [5588, 7826], [5562, 7836], [5535, 7829], [5503, 7851], [5466, 7853], [5438, 7864], [5419, 7859], [5389, 7886], [5318, 7924], [5346, 7930], [5358, 7954], [5377, 7957], [5355, 7971], [5372, 7984], [5398, 7991], [5397, 8000], [5367, 7994], [5371, 8013], [5385, 8022], [5412, 8022], [5418, 8037], [5410, 8056], [5423, 8075], [5395, 8098], [5365, 8106], [5360, 8100], [5344, 8120], [5320, 8112], [5291, 8117], [5274, 8151], [5248, 8152], [5254, 8171], [5236, 8196], [5194, 8194], [5176, 8186], [5161, 8222], [5187, 8225], [5204, 8239], [5176, 8253], [5159, 8287], [5150, 8327], [5070, 8350], [5069, 8366], [5054, 8379], [5060, 8398], [5046, 8408], [5051, 8420], [5055, 8428], [5060, 8448], [5057, 8471], [5061, 8478], [5064, 8483], [5067, 8485], [5067, 8485], [5065, 8486], [5065, 8486], [5065, 8486], [5068, 8485], [5071, 8487], [5068, 8490], [5066, 8492], [5068, 8506], [5100, 8515], [5129, 8509], [5120, 8522], [5086, 8526], [5078, 8540], [5060, 8539], [5101, 8570], [5161, 8627], [5171, 8646], [5160, 8660], [5124, 8685], [5141, 8698], [5125, 8716], [5126, 8734], [5112, 8744], [5119, 8754], [5116, 8775], [5127, 8776], [5121, 8798], [5097, 8834], [5098, 8842], [5125, 8877], [5105, 8896], [5085, 8903], [5078, 8920], [5093, 8945], [5105, 8958], [5123, 8963], [5131, 8977], [5149, 8971], [5149, 8986], [5178, 8980], [5185, 8994], [5217, 8982], [5184, 8973], [5228, 8966], [5222, 8956], [5249, 8965], [5262, 8957], [5300, 8953], [5450, 8876], [5459, 8853], [5454, 8833], [5432, 8813], [5400, 8800], [5358, 8797], [5327, 8807], [5283, 8814], [5266, 8823], [5228, 8829], [5202, 8849], [5191, 8849], [5230, 8809], [5257, 8799], [5271, 8780], [5256, 8762], [5270, 8738], [5293, 8753], [5314, 8741], [5331, 8753], [5362, 8738], [5406, 8723], [5432, 8735], [5411, 8764], [5414, 8774], [5443, 8793], [5459, 8796], [5495, 8831], [5498, 8815], [5515, 8814], [5542, 8786], [5540, 8806], [5551, 8826], [5546, 8847], [5532, 8851], [5544, 8906], [5517, 8924], [5576, 8920], [5594, 8915], [5617, 8885], [5577, 8879], [5565, 8858], [5591, 8837], [5613, 8833], [5647, 8842], [5655, 8875], [5678, 8879], [5749, 8918], [5779, 8921], [5815, 8940], [5833, 8936], [5824, 8926], [5832, 8910], [5809, 8906], [5852, 8902], [5865, 8917], [5891, 8926], [5930, 8921], [5949, 8936], [5976, 8944], [5992, 8931], [5983, 8913], [5999, 8910], [6006, 8929], [6023, 8930], [6036, 8950], [6013, 8974], [6023, 8982], [5996, 8981], [5992, 8990], [5967, 9000], [5964, 9011], [5980, 9022], [5990, 9015], [6023, 8992], [6023, 8982], [6032, 8988], [6087, 8983], [6131, 8973], [6177, 8948], [6222, 8935], [6252, 8910], [6272, 8925], [6277, 8941], [6259, 8942], [6246, 8969], [6225, 8977], [6219, 8963], [6209, 8974], [6225, 9034], [6199, 9033], [6213, 9066], [6233, 9072], [6259, 9095], [6274, 9143], [6292, 9153], [6350, 9155], [6387, 9144], [6389, 9120], [6369, 9083], [6358, 9079], [6383, 9056], [6386, 9019], [6376, 9011], [6383, 8988], [6378, 8978], [6380, 8941], [6411, 8919], [6395, 8904], [6397, 8879], [6380, 8873], [6369, 8850], [6348, 8836], [6350, 8825], [6324, 8818], [6301, 8836], [6315, 8809], [6365, 8805], [6377, 8823], [6407, 8834], [6419, 8857], [6443, 8877], [6442, 8902], [6432, 8912], [6435, 8928], [6492, 8944], [6520, 8919], [6514, 8881], [6531, 8870], [6554, 8870], [6524, 8882], [6525, 8897], [6543, 8905], [6530, 8938], [6502, 8951], [6466, 8957], [6445, 8948], [6415, 8954], [6419, 8966], [6408, 8983], [6414, 9006], [6431, 9024], [6409, 9063], [6393, 9073], [6408, 9094], [6449, 9110], [6454, 9127], [6441, 9158], [6461, 9150], [6473, 9118], [6458, 9092], [6458, 9072], [6481, 9063], [6533, 9057], [6552, 9044], [6548, 9064], [6531, 9065], [6490, 9080], [6481, 9099], [6509, 9107], [6527, 9095], [6541, 9109], [6521, 9110], [6543, 9126], [6581, 9126], [6650, 9088], [6695, 9089], [6689, 9072], [6666, 9065], [6670, 9038], [6684, 9049], [6693, 9013], [6710, 9022], [6692, 9063], [6705, 9084], [6698, 9095], [6663, 9109], [6663, 9120], [6634, 9124], [6619, 9135], [6624, 9156], [6608, 9172], [6615, 9193], [6656, 9198], [6727, 9201], [6808, 9210], [6799, 9228], [6776, 9232], [6779, 9246], [6757, 9261], [6804, 9253], [6797, 9273], [6828, 9277], [6868, 9303], [6892, 9310], [6998, 9327], [6980, 9339], [7002, 9344], [7029, 9339], [7039, 9353], [7101, 9350], [7067, 9344], [7084, 9328], [7125, 9335], [7154, 9352], [7181, 9339], [7155, 9367], [7174, 9364], [7214, 9369], [7225, 9383], [7214, 9387], [7224, 9403], [7285, 9439], [7329, 9441], [7362, 9433], [7376, 9416], [7359, 9420], [7342, 9409], [7317, 9405], [7359, 9404], [7402, 9397], [7409, 9391], [7378, 9367], [7420, 9368], [7423, 9381], [7485, 9378], [7517, 9381], [7527, 9373], [7558, 9373], [7560, 9349], [7582, 9348], [7592, 9311], [7559, 9327], [7566, 9311], [7591, 9307], [7590, 9293], [7568, 9275], [7547, 9268], [7482, 9237], [7426, 9196], [7399, 9195], [7376, 9171], [7416, 9170], [7475, 9186], [7510, 9199], [7503, 9205], [7472, 9200], [7484, 9218], [7553, 9200], [7576, 9210], [7586, 9189], [7643, 9201], [7733, 9194], [7730, 9176], [7785, 9159], [7865, 9154], [7883, 9173], [7875, 9192], [7895, 9196], [7914, 9212], [7918, 9200], [7967, 9183], [7986, 9191], [8015, 9188], [8013, 9180], [8057, 9162], [8047, 9131], [8059, 9118], [8042, 9108], [8010, 9128], [8066, 9058], [8099, 9037], [8119, 9044], [8148, 9098], [8181, 9073], [8206, 9070], [8250, 9084], [8315, 9063], [8280, 9079], [8331, 9085], [8344, 9072], [8369, 9075], [8355, 9101], [8364, 9114], [8344, 9113], [8355, 9132], [8401, 9137], [8386, 9154], [8414, 9147], [8528, 9135], [8568, 9123], [8526, 9123], [8514, 9129], [8498, 9114], [8518, 9119], [8572, 9122], [8555, 9111], [8542, 9116], [8539, 9100], [8512, 9092], [8525, 9086], [8550, 9094], [8580, 9123], [8616, 9121], [8651, 9112], [8665, 9100], [8644, 9099], [8634, 9088], [8662, 9086], [8659, 9075], [8682, 9078], [8682, 9065], [8707, 9068], [8728, 9043], [8771, 9042], [8838, 9055], [8887, 9054], [8914, 9048], [8949, 9032], [8960, 9009], [8949, 8990], [8989, 8967], [9029, 8979], [9077, 8984], [9100, 8973], [9162, 8970], [9188, 8984], [9205, 8955], [9232, 8949], [9242, 8932], [9263, 8935], [9282, 8947], [9270, 8975], [9271, 9002], [9335, 8994], [9416, 8989], [9470, 8976], [9511, 8959], [9526, 8958], [9546, 8944], [9582, 8931], [9586, 8920], [9615, 8910], [9664, 8885], [9655, 8877], [9686, 8876], [9690, 8859], [9712, 8819], [9724, 8816], [9724, 8840], [9707, 8846], [9792, 8840], [9802, 8826], [9851, 8799], [9827, 8787], [9827, 8774], [9778, 8770], [9781, 8747], [9765, 8730], [9777, 8716], [9743, 8711], [9703, 8735], [9683, 8734], [9669, 8745], [9668, 8764], [9637, 8774], [9624, 8766], [9591, 8769], [9578, 8795], [9557, 8802], [9555, 8783], [9569, 8775], [9557, 8751], [9532, 8736], [9495, 8728], [9441, 8738], [9452, 8724], [9470, 8723], [9489, 8707], [9497, 8714], [9511, 8679], [9506, 8669], [9530, 8656], [9536, 8637], [9521, 8618], [9490, 8629], [9451, 8627], [9385, 8596], [9357, 8593], [9355, 8584], [9312, 8553], [9294, 8550], [9270, 8534], [9265, 8513], [9251, 8517], [9231, 8540], [9202, 8541], [9162, 8528], [9138, 8507], [9146, 8536], [9109, 8518], [9100, 8506], [9065, 8517], [9051, 8493], [9048, 8470], [9029, 8456], [9017, 8432], [9032, 8417], [9038, 8426], [9056, 8415], [9040, 8400], [9040, 8375], [9053, 8375], [9057, 8351], [9048, 8344], [9034, 8355], [9021, 8349], [9010, 8327], [9021, 8297], [9010, 8283], [8980, 8283], [8959, 8269], [8952, 8248], [8960, 8225], [8947, 8232], [8918, 8217], [8915, 8195], [8892, 8164], [8862, 8142], [8843, 8219], [8827, 8314], [8830, 8340], [8841, 8376], [8869, 8403], [8863, 8418], [8883, 8420], [8929, 8446], [8954, 8477], [9014, 8524], [9015, 8533], [9061, 8559], [9077, 8575], [9080, 8616], [9092, 8625], [9112, 8622], [9093, 8635], [9054, 8628], [9046, 8595], [8962, 8540], [8971, 8561], [8952, 8556], [8951, 8570], [8966, 8584], [8968, 8602], [8945, 8589], [8939, 8600], [8883, 8594], [8860, 8582], [8859, 8568], [8809, 8531], [8787, 8509], [8783, 8493], [8809, 8493], [8816, 8479], [8782, 8473], [8762, 8482], [8749, 8467], [8732, 8473], [8703, 8465], [8684, 8477], [8686, 8492], [8651, 8504], [8626, 8492], [8627, 8481], [8601, 8488], [8591, 8481], [8554, 8489], [8483, 8489], [8444, 8481], [8415, 8454], [8395, 8444], [8383, 8421], [8329, 8385], [8296, 8348], [8227, 8298], [8243, 8285], [8276, 8286], [8273, 8252], [8281, 8267], [8302, 8259], [8289, 8243], [8307, 8245], [8331, 8274], [8362, 8273], [8410, 8227], [8403, 8196], [8413, 8190], [8395, 8167], [8381, 8124], [8385, 8088], [8373, 8045], [8346, 8020], [8327, 7993], [8312, 7962], [8247, 7895], [8224, 7863], [8189, 7841], [8166, 7834], [8141, 7841], [8141, 7856], [8127, 7857], [8094, 7820]]], [[[8570, 7897], [8578, 7911], [8622, 7935], [8646, 7938], [8664, 7956], [8680, 7962], [8652, 7939], [8595, 7917], [8573, 7896], [8528, 7875], [8549, 7899], [8570, 7897]]], [[[8464, 8080], [8443, 8028], [8449, 8007], [8468, 7973], [8441, 7977], [8430, 7950], [8422, 7976], [8433, 8027], [8426, 8060], [8432, 8092], [8428, 8125], [8435, 8149], [8418, 8172], [8417, 8197], [8425, 8222], [8420, 8236], [8440, 8237], [8451, 8249], [8443, 8274], [8457, 8266], [8453, 8254], [8465, 8227], [8463, 8163], [8470, 8162], [8480, 8116], [8494, 8075], [8464, 8080]]], [[[8585, 9302], [8616, 9301], [8622, 9288], [8637, 9292], [8688, 9283], [8681, 9269], [8640, 9261], [8609, 9264], [8547, 9290], [8556, 9311], [8579, 9296], [8585, 9302]]], [[[8415, 9336], [8408, 9347], [8443, 9327], [8484, 9326], [8527, 9306], [8486, 9277], [8453, 9284], [8442, 9298], [8457, 9318], [8437, 9319], [8429, 9308], [8446, 9281], [8477, 9272], [8438, 9265], [8422, 9276], [8370, 9266], [8353, 9273], [8339, 9255], [8306, 9267], [8276, 9297], [8251, 9302], [8234, 9298], [8241, 9327], [8255, 9311], [8279, 9313], [8292, 9333], [8336, 9349], [8362, 9329], [8397, 9313], [8395, 9335], [8415, 9336]]], [[[7224, 9473], [7190, 9458], [7167, 9463], [7197, 9498], [7214, 9511], [7219, 9534], [7256, 9553], [7281, 9546], [7274, 9528], [7301, 9535], [7321, 9516], [7338, 9515], [7346, 9493], [7367, 9477], [7379, 9471], [7412, 9472], [7408, 9464], [7377, 9468], [7342, 9491], [7330, 9482], [7298, 9477], [7224, 9473]]], [[[7021, 9557], [7004, 9561], [6976, 9550], [6963, 9553], [6972, 9531], [6959, 9534], [6962, 9555], [6976, 9554], [7017, 9576], [7041, 9598], [7085, 9599], [7117, 9603], [7141, 9583], [7146, 9595], [7165, 9595], [7189, 9580], [7187, 9570], [7176, 9543], [7161, 9543], [7187, 9523], [7171, 9513], [7122, 9512], [7094, 9524], [7042, 9527], [7022, 9540], [7021, 9557]]], [[[5615, 9613], [5661, 9614], [5638, 9622], [5667, 9630], [5689, 9627], [5703, 9635], [5685, 9645], [5725, 9662], [5737, 9672], [5743, 9648], [5764, 9638], [5742, 9628], [5706, 9625], [5709, 9619], [5680, 9618], [5688, 9604], [5644, 9596], [5653, 9608], [5629, 9603], [5615, 9613]]], [[[7064, 9680], [7099, 9654], [7128, 9639], [7106, 9636], [7106, 9607], [7027, 9600], [7019, 9594], [7003, 9591], [6939, 9611], [6950, 9623], [6975, 9627], [6990, 9646], [6967, 9645], [6984, 9660], [7038, 9670], [7064, 9680]]]]
            }
        }, {
            "type": "Feature",
            "id": "VA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.61,
                "hc-middle-y": 0.44,
                "hc-key": "va",
                "hc-a2": "VA",
                "name": "Vatican",
                "labelrank": "6",
                "country-abbrev": "Vat.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "VAT",
                "iso-a2": "VA",
                "woe-id": "23424986",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4607, 7806], [4607, 7806], [4607, 7806], [4607, 7806], [4607, 7806]]]
            }
        }, {
            "type": "Feature",
            "id": "SM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.42,
                "hc-key": "sm",
                "hc-a2": "SM",
                "name": "San Marino",
                "labelrank": "6",
                "country-abbrev": "S.M.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "SMR",
                "iso-a2": "SM",
                "woe-id": "23424947",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4607, 7877], [4605, 7878], [4606, 7880], [4608, 7880], [4607, 7877]]]
            }
        }, {
            "type": "Feature",
            "id": "KZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.46,
                "hc-key": "kz",
                "hc-a2": "KZ",
                "name": "Kazakhstan",
                "labelrank": "3",
                "country-abbrev": "Kaz.",
                "subregion": "Central Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "KAZ",
                "iso-a2": "KZ",
                "woe-id": "-90",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5720, 7912], [5714, 7915], [5715, 7919], [5724, 7920], [5720, 7912]]], [[[5972, 7934], [5982, 7947], [5993, 7922], [5972, 7934]]], [[[6022, 7952], [6045, 7962], [6032, 7978], [6009, 7975], [6031, 7968], [6028, 7956], [6004, 7959], [5998, 7945], [5972, 7949], [5967, 7937], [5890, 7917], [5890, 7786], [5877, 7783], [5859, 7807], [5838, 7821], [5802, 7814], [5786, 7801], [5794, 7835], [5771, 7839], [5739, 7888], [5721, 7895], [5723, 7905], [5753, 7902], [5743, 7911], [5755, 7929], [5788, 7932], [5805, 7954], [5804, 7987], [5776, 7984], [5750, 7995], [5727, 7987], [5691, 7966], [5668, 7978], [5685, 7982], [5656, 8019], [5629, 8021], [5628, 8038], [5610, 8043], [5626, 8073], [5623, 8097], [5642, 8121], [5668, 8097], [5681, 8105], [5675, 8126], [5695, 8136], [5697, 8147], [5724, 8155], [5731, 8167], [5767, 8162], [5783, 8172], [5787, 8162], [5813, 8162], [5846, 8137], [5852, 8144], [5881, 8124], [5906, 8145], [5968, 8144], [5977, 8130], [6002, 8125], [6008, 8136], [6030, 8129], [6049, 8134], [6052, 8159], [6024, 8167], [6013, 8177], [6040, 8195], [6029, 8208], [6069, 8226], [6044, 8232], [6038, 8257], [6100, 8265], [6127, 8275], [6163, 8276], [6185, 8286], [6250, 8301], [6253, 8310], [6294, 8316], [6310, 8308], [6328, 8314], [6339, 8291], [6338, 8266], [6377, 8267], [6406, 8259], [6399, 8248], [6428, 8245], [6501, 8279], [6496, 8260], [6536, 8232], [6583, 8162], [6598, 8135], [6619, 8154], [6633, 8150], [6642, 8132], [6661, 8131], [6700, 8142], [6711, 8137], [6724, 8114], [6746, 8106], [6754, 8088], [6781, 8083], [6793, 8089], [6815, 8069], [6801, 8070], [6792, 8048], [6769, 8043], [6761, 8025], [6761, 7992], [6738, 7984], [6688, 7998], [6666, 7936], [6672, 7921], [6648, 7930], [6602, 7918], [6622, 7850], [6603, 7832], [6605, 7816], [6570, 7836], [6552, 7841], [6474, 7842], [6457, 7840], [6427, 7854], [6409, 7846], [6407, 7824], [6358, 7839], [6333, 7829], [6332, 7818], [6275, 7787], [6262, 7760], [6245, 7768], [6243, 7781], [6206, 7781], [6201, 7809], [6186, 7810], [6189, 7845], [6180, 7841], [6154, 7871], [6139, 7865], [6104, 7867], [6069, 7862], [6039, 7895], [6011, 7911], [6011, 7930], [6001, 7942], [6020, 7951], [6012, 7954], [6019, 7954], [6022, 7954], [6022, 7952]]]]
            }
        }, {
            "type": "Feature",
            "id": "AZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.8,
                "hc-middle-y": 0.52,
                "hc-key": "az",
                "hc-a2": "AZ",
                "name": "Azerbaijan",
                "labelrank": "5",
                "country-abbrev": "Aze.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "AZE",
                "iso-a2": "AZ",
                "woe-id": "23424741",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5567, 7776], [5566, 7775], [5566, 7777], [5567, 7777], [5567, 7776]]], [[[5573, 7774], [5572, 7773], [5572, 7774], [5572, 7774], [5573, 7774]]], [[[5561, 7727], [5560, 7729], [5590, 7724], [5600, 7700], [5580, 7705], [5561, 7727]]], [[[5672, 7804], [5702, 7761], [5716, 7760], [5698, 7742], [5690, 7706], [5684, 7711], [5681, 7686], [5655, 7699], [5665, 7718], [5654, 7729], [5611, 7701], [5607, 7718], [5585, 7740], [5595, 7747], [5578, 7763], [5584, 7770], [5567, 7785], [5574, 7790], [5611, 7776], [5616, 7784], [5601, 7797], [5609, 7806], [5648, 7781], [5672, 7804]], [[5581, 7761], [5582, 7760], [5583, 7762], [5581, 7762], [5581, 7761]]]]
            }
        }, {
            "type": "Feature",
            "id": "AM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.1,
                "hc-middle-y": 0.12,
                "hc-key": "am",
                "hc-a2": "AM",
                "name": "Armenia",
                "labelrank": "6",
                "country-abbrev": "Arm.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ARM",
                "iso-a2": "AM",
                "woe-id": "23424743",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5581, 7761], [5581, 7762], [5583, 7762], [5582, 7760], [5581, 7761]]], [[[5611, 7701], [5607, 7702], [5600, 7700], [5590, 7724], [5560, 7729], [5547, 7741], [5527, 7743], [5529, 7763], [5521, 7778], [5542, 7782], [5567, 7785], [5584, 7770], [5578, 7763], [5595, 7747], [5585, 7740], [5607, 7718], [5611, 7701]], [[5567, 7776], [5567, 7777], [5566, 7777], [5566, 7775], [5567, 7776]], [[5573, 7774], [5572, 7774], [5572, 7774], [5572, 7773], [5573, 7774]]]]
            }
        }, {
            "type": "Feature",
            "id": "TJ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.5,
                "hc-key": "tj",
                "hc-a2": "TJ",
                "name": "Tajikistan",
                "labelrank": "4",
                "country-abbrev": "Tjk.",
                "subregion": "Central Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "TJK",
                "iso-a2": "TJ",
                "woe-id": "23424961",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[6323, 7773], [6322, 7772], [6320, 7775], [6321, 7775], [6323, 7773]]], [[[6322, 7734], [6325, 7733], [6321, 7731], [6318, 7735], [6322, 7734]]], [[[6411, 7720], [6416, 7691], [6444, 7689], [6448, 7645], [6432, 7651], [6413, 7644], [6401, 7653], [6382, 7638], [6351, 7627], [6346, 7639], [6351, 7667], [6343, 7680], [6322, 7683], [6308, 7655], [6289, 7656], [6282, 7640], [6265, 7646], [6245, 7634], [6238, 7643], [6255, 7679], [6248, 7704], [6226, 7713], [6237, 7726], [6258, 7723], [6271, 7736], [6287, 7768], [6294, 7762], [6317, 7775], [6326, 7764], [6315, 7756], [6332, 7748], [6319, 7741], [6303, 7747], [6281, 7731], [6283, 7723], [6318, 7726], [6327, 7718], [6347, 7726], [6370, 7712], [6381, 7719], [6411, 7720]]]]
            }
        }, {
            "type": "Feature",
            "id": "LS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.51,
                "hc-key": "ls",
                "hc-a2": "LS",
                "name": "Lesotho",
                "labelrank": "6",
                "country-abbrev": "Les.",
                "subregion": "Southern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "LSO",
                "iso-a2": "LS",
                "woe-id": "23424880",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5070, 5635], [5084, 5639], [5108, 5615], [5099, 5596], [5077, 5589], [5068, 5572], [5047, 5584], [5036, 5606], [5070, 5635]]]
            }
        }, {
            "type": "Feature",
            "id": "UZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.53,
                "hc-key": "uz",
                "hc-a2": "UZ",
                "name": "Uzbekistan",
                "labelrank": "3",
                "country-abbrev": "Uzb.",
                "subregion": "Central Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "UZB",
                "iso-a2": "UZ",
                "woe-id": "23424980",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[6356, 7736], [6354, 7737], [6353, 7737], [6356, 7739], [6356, 7736]]], [[[6338, 7741], [6339, 7736], [6334, 7735], [6332, 7743], [6338, 7741]]], [[[5993, 7922], [5985, 7908], [6006, 7889], [6011, 7911], [6039, 7895], [6069, 7862], [6104, 7867], [6139, 7865], [6154, 7871], [6180, 7841], [6189, 7845], [6186, 7810], [6201, 7809], [6206, 7781], [6243, 7781], [6245, 7768], [6262, 7760], [6275, 7787], [6332, 7818], [6341, 7816], [6309, 7795], [6346, 7779], [6355, 7790], [6382, 7770], [6396, 7767], [6353, 7745], [6332, 7748], [6315, 7756], [6326, 7764], [6317, 7775], [6294, 7762], [6287, 7768], [6271, 7736], [6258, 7723], [6237, 7726], [6226, 7713], [6248, 7704], [6255, 7679], [6238, 7643], [6223, 7643], [6201, 7649], [6202, 7672], [6174, 7679], [6137, 7704], [6130, 7704], [6081, 7740], [6067, 7774], [6012, 7788], [6005, 7820], [5992, 7820], [5967, 7838], [5939, 7815], [5932, 7822], [5922, 7807], [5921, 7783], [5890, 7786], [5890, 7917], [5967, 7937], [5957, 7914], [5959, 7896], [5973, 7907], [5972, 7934], [5993, 7922]], [[6323, 7773], [6321, 7775], [6320, 7775], [6322, 7772], [6323, 7773]]]]
            }
        }, {
            "type": "Feature",
            "id": "PT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.51,
                "hc-key": "pt",
                "hc-a2": "PT",
                "name": "Portugal",
                "labelrank": "2",
                "country-abbrev": "Port.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "PRT",
                "iso-a2": "PT",
                "woe-id": "23424925",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4021, 7643], [4005, 7636], [3974, 7638], [3981, 7677], [3960, 7695], [3983, 7768], [3982, 7808], [3997, 7815], [3998, 7803], [4046, 7807], [4057, 7794], [4035, 7775], [4039, 7752], [4033, 7729], [4017, 7728], [4034, 7705], [4023, 7686], [4032, 7672], [4018, 7656], [4021, 7643]]]
            }
        }, {
            "type": "Feature",
            "id": "MA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.6,
                "hc-middle-y": 0.21,
                "hc-key": "ma",
                "hc-a2": "MA",
                "name": "Morocco",
                "labelrank": "3",
                "country-abbrev": "Mor.",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "MAR",
                "iso-a2": "MA",
                "woe-id": "23424893",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4153, 7579], [4154, 7579], [4155, 7574], [4174, 7573], [4187, 7561], [4190, 7512], [4209, 7488], [4203, 7474], [4165, 7475], [4156, 7464], [4132, 7460], [4132, 7429], [4111, 7423], [4070, 7394], [4014, 7386], [3984, 7364], [3984, 7332], [3980, 7315], [3953, 7306], [3918, 7311], [3904, 7307], [3894, 7283], [3885, 7280], [3873, 7243], [3854, 7229], [3826, 7199], [3820, 7165], [3802, 7138], [3738, 7137], [3747, 7164], [3779, 7218], [3800, 7239], [3812, 7283], [3838, 7301], [3858, 7340], [3901, 7353], [3928, 7374], [3950, 7401], [3956, 7419], [3948, 7428], [3949, 7452], [3966, 7477], [3967, 7490], [3988, 7513], [4038, 7538], [4054, 7566], [4065, 7596], [4080, 7601], [4081, 7599], [4082, 7598], [4085, 7589], [4111, 7575], [4153, 7581], [4153, 7581], [4153, 7579]]]
            }
        }, {
            "type": "Feature",
            "id": "CO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.54,
                "hc-key": "co",
                "hc-a2": "CO",
                "name": "Colombia",
                "labelrank": "2",
                "country-abbrev": "Col.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "COL",
                "iso-a2": "CO",
                "woe-id": "23424787",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2020, 6497], [1990, 6513], [1986, 6507], [1957, 6511], [1955, 6519], [1915, 6542], [1919, 6564], [1930, 6578], [1944, 6580], [1966, 6613], [1953, 6623], [1959, 6631], [1962, 6670], [1959, 6693], [1943, 6712], [1964, 6733], [1958, 6754], [1976, 6733], [1971, 6751], [2010, 6778], [2012, 6811], [2033, 6827], [2047, 6817], [2054, 6834], [2078, 6832], [2131, 6866], [2136, 6849], [2117, 6843], [2089, 6807], [2087, 6788], [2075, 6769], [2087, 6773], [2105, 6745], [2102, 6720], [2114, 6708], [2172, 6705], [2192, 6680], [2249, 6682], [2239, 6655], [2238, 6633], [2255, 6600], [2239, 6585], [2258, 6570], [2268, 6536], [2261, 6534], [2254, 6561], [2230, 6550], [2180, 6550], [2180, 6531], [2194, 6531], [2201, 6519], [2174, 6517], [2173, 6495], [2187, 6485], [2192, 6458], [2176, 6376], [2154, 6389], [2174, 6420], [2145, 6436], [2124, 6437], [2105, 6428], [2081, 6435], [2081, 6448], [2068, 6463], [2050, 6471], [2033, 6495], [2020, 6497]]]
            }
        }, {
            "type": "Feature",
            "id": "TL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.63,
                "hc-middle-y": 0.31,
                "hc-key": "tl",
                "hc-a2": "TL",
                "name": "East Timor",
                "labelrank": "5",
                "country-abbrev": "T.L.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "TLS",
                "iso-a2": "TL",
                "woe-id": "23424968",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7897, 6226], [7903, 6228], [7910, 6230], [7904, 6221], [7897, 6226]]], [[[7923, 6237], [7930, 6246], [7984, 6256], [7994, 6253], [7969, 6237], [7928, 6221], [7924, 6229], [7923, 6237]]]]
            }
        }, {
            "type": "Feature",
            "id": "KH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.83,
                "hc-middle-y": 0.49,
                "hc-key": "kh",
                "hc-a2": "KH",
                "name": "Cambodia",
                "labelrank": "3",
                "country-abbrev": "Camb.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "KHM",
                "iso-a2": "KH",
                "woe-id": "23424776",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7320, 6806], [7295, 6809], [7297, 6825], [7280, 6822], [7274, 6843], [7262, 6872], [7257, 6900], [7275, 6918], [7296, 6926], [7341, 6923], [7362, 6910], [7365, 6924], [7381, 6930], [7389, 6922], [7410, 6934], [7404, 6916], [7413, 6898], [7410, 6863], [7378, 6844], [7366, 6846], [7358, 6824], [7337, 6821], [7320, 6806]]]
            }
        }, {
            "type": "Feature",
            "id": "AR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.27,
                "hc-key": "ar",
                "hc-a2": "AR",
                "name": "Argentina",
                "labelrank": "2",
                "country-abbrev": "Arg.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "ARG",
                "iso-a2": "AR",
                "woe-id": "23424747",
                "continent": "South America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2215, 4706], [2218, 4703], [2215, 4702], [2215, 4706]]], [[[2215, 4706], [2216, 4793], [2227, 4779], [2221, 4767], [2255, 4736], [2298, 4712], [2319, 4712], [2334, 4702], [2302, 4701], [2277, 4696], [2263, 4701], [2215, 4706]]], [[[2541, 5588], [2523, 5532], [2523, 5514], [2519, 5492], [2518, 5486], [2512, 5454], [2525, 5438], [2555, 5415], [2547, 5401], [2568, 5367], [2541, 5324], [2498, 5305], [2445, 5296], [2409, 5298], [2408, 5266], [2397, 5250], [2410, 5245], [2401, 5230], [2380, 5220], [2357, 5220], [2326, 5236], [2318, 5227], [2321, 5192], [2335, 5175], [2359, 5188], [2364, 5164], [2349, 5159], [2339, 5172], [2323, 5163], [2340, 5156], [2313, 5131], [2316, 5106], [2304, 5095], [2305, 5082], [2287, 5083], [2254, 5061], [2245, 5040], [2251, 5025], [2270, 5009], [2294, 5007], [2301, 4990], [2294, 4970], [2247, 4934], [2237, 4896], [2209, 4883], [2200, 4858], [2207, 4832], [2221, 4804], [2177, 4818], [2119, 4819], [2103, 4836], [2107, 4871], [2082, 4867], [2071, 4891], [2070, 4914], [2099, 4942], [2108, 4959], [2100, 4975], [2107, 4993], [2119, 5001], [2128, 5047], [2122, 5056], [2137, 5072], [2115, 5092], [2137, 5090], [2140, 5104], [2122, 5105], [2126, 5122], [2112, 5155], [2113, 5181], [2124, 5187], [2118, 5235], [2131, 5274], [2134, 5298], [2150, 5306], [2140, 5339], [2145, 5380], [2164, 5395], [2164, 5425], [2182, 5484], [2158, 5543], [2171, 5582], [2178, 5583], [2174, 5614], [2186, 5645], [2199, 5659], [2210, 5685], [2225, 5692], [2217, 5759], [2227, 5771], [2254, 5783], [2263, 5814], [2258, 5820], [2286, 5851], [2301, 5841], [2335, 5839], [2343, 5818], [2354, 5845], [2387, 5845], [2392, 5838], [2413, 5813], [2441, 5789], [2469, 5783], [2505, 5759], [2536, 5746], [2542, 5738], [2527, 5717], [2511, 5679], [2529, 5681], [2553, 5674], [2585, 5680], [2595, 5675], [2624, 5700], [2629, 5734], [2650, 5732], [2657, 5712], [2652, 5684], [2621, 5669], [2595, 5650], [2576, 5623], [2541, 5588]]]]
            }
        }, {
            "type": "Feature",
            "id": "SA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.43,
                "hc-middle-y": 0.5,
                "hc-key": "sa",
                "hc-a2": "SA",
                "name": "Saudi Arabia",
                "labelrank": "2",
                "country-abbrev": "Saud.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "SAU",
                "iso-a2": "SA",
                "woe-id": "23424938",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5668, 7360], [5681, 7329], [5719, 7300], [5718, 7271], [5738, 7240], [5743, 7235], [5750, 7236], [5752, 7226], [5760, 7225], [5789, 7184], [5865, 7174], [5867, 7177], [5880, 7154], [5861, 7094], [5772, 7063], [5688, 7052], [5660, 7038], [5638, 7006], [5571, 7016], [5512, 7013], [5514, 6997], [5501, 6984], [5494, 6999], [5483, 6990], [5472, 6997], [5489, 7008], [5455, 7054], [5447, 7079], [5409, 7108], [5392, 7134], [5392, 7172], [5374, 7210], [5346, 7225], [5338, 7253], [5319, 7272], [5308, 7299], [5278, 7343], [5259, 7346], [5270, 7386], [5302, 7380], [5323, 7402], [5345, 7406], [5360, 7422], [5329, 7454], [5394, 7475], [5432, 7468], [5480, 7441], [5558, 7381], [5612, 7377], [5638, 7374], [5645, 7359], [5668, 7360]]]
            }
        }, {
            "type": "Feature",
            "id": "PK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.29,
                "hc-middle-y": 0.74,
                "hc-key": "pk",
                "hc-a2": "PK",
                "name": "Pakistan",
                "labelrank": "2",
                "country-abbrev": "Pak.",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "PAK",
                "iso-a2": "PK",
                "woe-id": "23424922",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6250, 7212], [6226, 7219], [6221, 7238], [6206, 7243], [6196, 7263], [6112, 7254], [6056, 7254], [6063, 7286], [6100, 7299], [6107, 7314], [6090, 7319], [6090, 7350], [6065, 7360], [6034, 7402], [6082, 7387], [6129, 7387], [6192, 7401], [6197, 7436], [6214, 7449], [6226, 7445], [6249, 7465], [6269, 7458], [6283, 7469], [6281, 7485], [6290, 7506], [6313, 7514], [6304, 7538], [6335, 7538], [6332, 7553], [6352, 7576], [6338, 7605], [6379, 7631], [6438, 7638], [6455, 7637], [6480, 7619], [6486, 7597], [6504, 7591], [6512, 7573], [6500, 7561], [6474, 7553], [6432, 7562], [6415, 7549], [6422, 7510], [6443, 7486], [6460, 7476], [6436, 7462], [6438, 7442], [6403, 7404], [6390, 7376], [6373, 7367], [6359, 7341], [6325, 7334], [6317, 7344], [6291, 7317], [6288, 7305], [6308, 7296], [6306, 7279], [6335, 7238], [6303, 7222], [6270, 7224], [6250, 7212]]]
            }
        }, {
            "type": "Feature",
            "id": "YE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.75,
                "hc-key": "ye",
                "hc-a2": "YE",
                "name": "Yemen",
                "labelrank": "3",
                "country-abbrev": "Yem.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "YEM",
                "iso-a2": "YE",
                "woe-id": "23425002",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5772, 7063], [5794, 7012], [5805, 6992], [5789, 6986], [5780, 6961], [5754, 6950], [5702, 6935], [5676, 6914], [5656, 6914], [5617, 6896], [5591, 6894], [5570, 6882], [5536, 6871], [5522, 6878], [5499, 6960], [5501, 6984], [5514, 6997], [5512, 7013], [5571, 7016], [5638, 7006], [5660, 7038], [5688, 7052], [5772, 7063]]]
            }
        }, {
            "type": "Feature",
            "id": "AE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.59,
                "hc-middle-y": 0.64,
                "hc-key": "ae",
                "hc-a2": "AE",
                "name": "United Arab Emirates",
                "labelrank": "4",
                "country-abbrev": "U.A.E.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "ARE",
                "iso-a2": "AE",
                "woe-id": "23424738",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5899, 7268], [5902, 7264], [5902, 7247], [5885, 7244], [5884, 7224], [5867, 7177], [5865, 7174], [5789, 7184], [5760, 7225], [5767, 7217], [5790, 7222], [5836, 7221], [5893, 7281], [5895, 7269], [5899, 7268]], [[5899, 7255], [5901, 7257], [5898, 7258], [5898, 7255], [5899, 7255]]]
            }
        }, {
            "type": "Feature",
            "id": "KE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.87,
                "hc-middle-y": 0.7,
                "hc-key": "ke",
                "hc-a2": "KE",
                "name": "Kenya",
                "labelrank": "2",
                "country-abbrev": "Ken.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "KEN",
                "iso-a2": "KE",
                "woe-id": "23424863",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5395, 6363], [5353, 6393], [5350, 6411], [5244, 6469], [5250, 6493], [5242, 6507], [5271, 6548], [5269, 6573], [5255, 6593], [5255, 6607], [5242, 6624], [5253, 6635], [5284, 6647], [5299, 6635], [5326, 6630], [5363, 6606], [5405, 6600], [5415, 6613], [5442, 6626], [5453, 6616], [5475, 6617], [5448, 6582], [5448, 6474], [5464, 6450], [5424, 6419], [5423, 6404], [5401, 6364], [5395, 6363]]]
            }
        }, {
            "type": "Feature",
            "id": "PE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.68,
                "hc-middle-y": 0.7,
                "hc-key": "pe",
                "hc-a2": "PE",
                "name": "Peru",
                "labelrank": "2",
                "country-abbrev": "Peru",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "PER",
                "iso-a2": "PE",
                "woe-id": "23424919",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2194, 6042], [2184, 6048], [2175, 6032], [2202, 6020], [2203, 6021], [2206, 6021], [2202, 6012], [2204, 6011], [2185, 5988], [2190, 5982], [2176, 5959], [2164, 5957], [2135, 5976], [2131, 5988], [2105, 6005], [2066, 6021], [2022, 6046], [1990, 6085], [1992, 6106], [1950, 6168], [1925, 6230], [1910, 6259], [1896, 6273], [1882, 6301], [1848, 6322], [1855, 6334], [1845, 6347], [1844, 6376], [1870, 6401], [1876, 6386], [1865, 6380], [1895, 6367], [1908, 6353], [1920, 6367], [1929, 6401], [1943, 6412], [1978, 6425], [2011, 6455], [2020, 6497], [2033, 6495], [2050, 6471], [2068, 6463], [2081, 6448], [2081, 6435], [2105, 6428], [2124, 6437], [2145, 6436], [2174, 6420], [2154, 6389], [2176, 6376], [2152, 6378], [2119, 6368], [2089, 6349], [2080, 6322], [2083, 6312], [2065, 6298], [2057, 6279], [2088, 6233], [2081, 6224], [2107, 6220], [2111, 6206], [2140, 6208], [2160, 6223], [2156, 6176], [2188, 6178], [2214, 6132], [2205, 6120], [2202, 6097], [2209, 6081], [2194, 6058], [2194, 6042]]]
            }
        }, {
            "type": "Feature",
            "id": "DO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.43,
                "hc-key": "do",
                "hc-a2": "DO",
                "name": "Dominican Republic",
                "labelrank": "5",
                "country-abbrev": "Dom. Rep.",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "DOM",
                "iso-a2": "DO",
                "woe-id": "23424800",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2119, 7048], [2119, 7048], [2118, 7049], [2118, 7049], [2116, 7051], [2125, 7056], [2124, 7085], [2146, 7092], [2177, 7084], [2187, 7066], [2213, 7062], [2224, 7053], [2217, 7036], [2207, 7045], [2178, 7047], [2159, 7039], [2155, 7046], [2134, 7021], [2123, 7034], [2125, 7042], [2119, 7048]]]
            }
        }, {
            "type": "Feature",
            "id": "HT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.8,
                "hc-middle-y": 0.08,
                "hc-key": "ht",
                "hc-a2": "HT",
                "name": "Haiti",
                "labelrank": "5",
                "country-abbrev": "Haiti",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "HTI",
                "iso-a2": "HT",
                "woe-id": "23424839",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2119, 7048], [2118, 7048], [2118, 7049], [2118, 7049], [2119, 7048]]], [[[2124, 7085], [2125, 7056], [2116, 7051], [2117, 7048], [2119, 7048], [2125, 7042], [2123, 7034], [2114, 7040], [2078, 7041], [2060, 7034], [2043, 7046], [2050, 7053], [2095, 7046], [2095, 7076], [2074, 7087], [2094, 7092], [2124, 7085]]]]
            }
        }, {
            "type": "Feature",
            "id": "AO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.67,
                "hc-key": "ao",
                "hc-a2": "AO",
                "name": "Angola",
                "labelrank": "3",
                "country-abbrev": "Ang.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "AGO",
                "iso-a2": "AO",
                "woe-id": "23424745",
                "continent": "Africa"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4600, 6331], [4600, 6340], [4594, 6353], [4616, 6371], [4625, 6364], [4607, 6352], [4608, 6332], [4600, 6331]]], [[[4587, 5989], [4586, 6033], [4602, 6065], [4609, 6104], [4642, 6139], [4646, 6186], [4623, 6233], [4634, 6255], [4618, 6297], [4602, 6321], [4628, 6328], [4721, 6328], [4729, 6326], [4741, 6286], [4759, 6262], [4810, 6265], [4815, 6295], [4847, 6297], [4845, 6286], [4882, 6286], [4887, 6252], [4882, 6224], [4893, 6208], [4895, 6169], [4946, 6180], [4947, 6117], [4888, 6117], [4888, 6022], [4891, 6011], [4929, 5978], [4853, 5966], [4793, 5975], [4784, 5985], [4651, 5985], [4628, 5999], [4610, 5990], [4587, 5989]]]]
            }
        }, {
            "type": "Feature",
            "id": "VN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.42,
                "hc-middle-y": 0.96,
                "hc-key": "vn",
                "hc-a2": "VN",
                "name": "Vietnam",
                "labelrank": "2",
                "country-abbrev": "Viet.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "VNM",
                "iso-a2": "VN",
                "woe-id": "23424984",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7320, 6806], [7337, 6821], [7358, 6824], [7366, 6846], [7378, 6844], [7410, 6863], [7413, 6898], [7404, 6916], [7410, 6934], [7415, 6951], [7399, 6966], [7406, 6970], [7381, 7002], [7357, 7023], [7327, 7057], [7302, 7072], [7306, 7084], [7325, 7082], [7335, 7096], [7317, 7107], [7325, 7114], [7308, 7123], [7297, 7114], [7281, 7120], [7276, 7142], [7251, 7167], [7261, 7179], [7277, 7168], [7286, 7179], [7305, 7171], [7345, 7197], [7361, 7183], [7387, 7178], [7381, 7166], [7405, 7143], [7424, 7139], [7418, 7124], [7393, 7122], [7382, 7101], [7366, 7094], [7354, 7063], [7378, 7037], [7384, 7017], [7421, 6981], [7430, 6979], [7447, 6954], [7463, 6909], [7468, 6880], [7460, 6872], [7462, 6852], [7454, 6834], [7403, 6805], [7387, 6809], [7380, 6780], [7352, 6768], [7339, 6753], [7329, 6759], [7330, 6800], [7307, 6795], [7302, 6805], [7320, 6806]]]
            }
        }, {
            "type": "Feature",
            "id": "MZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.83,
                "hc-middle-y": 0.28,
                "hc-key": "mz",
                "hc-a2": "MZ",
                "name": "Mozambique",
                "labelrank": "3",
                "country-abbrev": "Moz.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MOZ",
                "iso-a2": "MZ",
                "woe-id": "23424902",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5268, 6102], [5263, 6141], [5271, 6159], [5296, 6164], [5307, 6156], [5332, 6160], [5345, 6155], [5363, 6169], [5375, 6164], [5419, 6182], [5432, 6192], [5431, 6167], [5438, 6124], [5435, 6098], [5444, 6063], [5437, 6043], [5416, 6015], [5357, 5986], [5333, 5971], [5308, 5940], [5305, 5943], [5268, 5910], [5262, 5893], [5286, 5842], [5283, 5788], [5275, 5764], [5234, 5749], [5208, 5734], [5198, 5722], [5210, 5694], [5194, 5694], [5187, 5694], [5184, 5712], [5182, 5722], [5183, 5770], [5169, 5800], [5162, 5833], [5195, 5867], [5198, 5889], [5213, 5905], [5206, 5922], [5214, 5956], [5212, 6007], [5181, 6014], [5161, 6027], [5136, 6027], [5136, 6038], [5131, 6058], [5219, 6087], [5232, 6069], [5252, 6076], [5259, 6048], [5249, 6031], [5280, 5993], [5276, 6011], [5295, 6026], [5297, 6068], [5268, 6102]]]
            }
        }, {
            "type": "Feature",
            "id": "CR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.09,
                "hc-middle-y": 0.05,
                "hc-key": "cr",
                "hc-a2": "CR",
                "name": "Costa Rica",
                "labelrank": "5",
                "country-abbrev": "C.R.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "CRI",
                "iso-a2": "CR",
                "woe-id": "23424791",
                "continent": "North America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[1773, 6821], [1778, 6808], [1805, 6781], [1791, 6745], [1791, 6745], [1787, 6754], [1743, 6784], [1730, 6781], [1707, 6804], [1712, 6826], [1752, 6823], [1773, 6821]]], [[[1795, 6736], [1790, 6744], [1791, 6745], [1791, 6745], [1795, 6736]]]]
            }
        }, {
            "type": "Feature",
            "id": "IR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.58,
                "hc-middle-y": 0.5,
                "hc-key": "ir",
                "hc-a2": "IR",
                "name": "Iran",
                "labelrank": "2",
                "country-abbrev": "Iran",
                "subregion": "Southern Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "IRN",
                "iso-a2": "IR",
                "woe-id": "23424851",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5560, 7642], [5555, 7661], [5544, 7670], [5545, 7700], [5538, 7718], [5561, 7727], [5580, 7705], [5600, 7700], [5607, 7702], [5611, 7701], [5654, 7729], [5665, 7718], [5655, 7699], [5681, 7686], [5685, 7662], [5720, 7650], [5746, 7628], [5770, 7623], [5816, 7633], [5832, 7631], [5829, 7648], [5855, 7655], [5875, 7674], [5927, 7680], [5931, 7670], [5974, 7660], [6010, 7638], [6019, 7625], [6044, 7622], [6046, 7590], [6035, 7547], [6023, 7540], [6034, 7522], [6026, 7506], [6033, 7479], [6033, 7455], [6059, 7451], [6062, 7434], [6034, 7402], [6065, 7360], [6090, 7350], [6090, 7319], [6107, 7314], [6100, 7299], [6063, 7286], [6056, 7254], [6051, 7250], [6025, 7262], [6006, 7258], [5930, 7272], [5921, 7306], [5901, 7317], [5887, 7303], [5869, 7304], [5855, 7295], [5791, 7322], [5787, 7331], [5755, 7340], [5733, 7389], [5716, 7413], [5702, 7407], [5683, 7419], [5671, 7405], [5655, 7421], [5655, 7438], [5645, 7438], [5650, 7463], [5638, 7484], [5604, 7502], [5593, 7524], [5578, 7536], [5579, 7551], [5606, 7597], [5576, 7603], [5560, 7642]]]
            }
        }, {
            "type": "Feature",
            "id": "SV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.51,
                "hc-key": "sv",
                "hc-a2": "SV",
                "name": "El Salvador",
                "labelrank": "6",
                "country-abbrev": "El. S.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "SLV",
                "iso-a2": "SV",
                "woe-id": "23424807",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1650, 6895], [1647, 6888], [1621, 6890], [1583, 6905], [1582, 6908], [1604, 6925], [1630, 6912], [1653, 6907], [1650, 6895]]]
            }
        }, {
            "type": "Feature",
            "id": "SL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.48,
                "hc-key": "sl",
                "hc-a2": "SL",
                "name": "Sierra Leone",
                "labelrank": "4",
                "country-abbrev": "S.L.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SLE",
                "iso-a2": "SL",
                "woe-id": "23424946",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3901, 6703], [3858, 6722], [3847, 6766], [3871, 6789], [3908, 6794], [3925, 6773], [3936, 6749], [3927, 6728], [3901, 6703]]]
            }
        }, {
            "type": "Feature",
            "id": "GW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.55,
                "hc-middle-y": 0.49,
                "hc-key": "gw",
                "hc-a2": "GW",
                "name": "Guinea Bissau",
                "labelrank": "6",
                "country-abbrev": "GnB.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GNB",
                "iso-a2": "GW",
                "woe-id": "23424929",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3797, 6823], [3785, 6833], [3771, 6830], [3758, 6858], [3746, 6863], [3777, 6866], [3792, 6873], [3835, 6873], [3828, 6858], [3835, 6845], [3806, 6838], [3797, 6823]]]
            }
        }, {
            "type": "Feature",
            "id": "HR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.35,
                "hc-middle-y": 0.6,
                "hc-key": "hr",
                "hc-a2": "HR",
                "name": "Croatia",
                "labelrank": "6",
                "country-abbrev": "Cro.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "HRV",
                "iso-a2": "HR",
                "woe-id": "23424843",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4785, 7824], [4765, 7838], [4760, 7841], [4766, 7838], [4783, 7829], [4783, 7827], [4785, 7824]]], [[[4640, 7935], [4692, 7934], [4701, 7961], [4727, 7972], [4751, 7952], [4782, 7944], [4797, 7951], [4801, 7922], [4800, 7912], [4790, 7920], [4766, 7919], [4739, 7927], [4721, 7917], [4705, 7923], [4706, 7906], [4718, 7888], [4758, 7848], [4758, 7843], [4731, 7849], [4694, 7873], [4678, 7887], [4678, 7920], [4664, 7908], [4659, 7922], [4652, 7911], [4640, 7935]]]]
            }
        }, {
            "type": "Feature",
            "id": "BZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.5,
                "hc-key": "bz",
                "hc-a2": "BZ",
                "name": "Belize",
                "labelrank": "6",
                "country-abbrev": "Belize",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "BLZ",
                "iso-a2": "BZ",
                "woe-id": "23424760",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1610, 7027], [1619, 7030], [1636, 7048], [1642, 7044], [1642, 7044], [1638, 7002], [1618, 6969], [1608, 6969], [1610, 7027]]]
            }
        }, {
            "type": "Feature",
            "id": "ZA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.36,
                "hc-middle-y": 0.7,
                "hc-key": "za",
                "hc-a2": "ZA",
                "name": "South Africa",
                "labelrank": "2",
                "country-abbrev": "S.Af.",
                "subregion": "Southern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "ZAF",
                "iso-a2": "ZA",
                "woe-id": "23424942",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5187, 5694], [5194, 5694], [5210, 5694], [5194, 5640], [5159, 5608], [5136, 5566], [5091, 5520], [5039, 5479], [4997, 5470], [4998, 5463], [4973, 5457], [4937, 5464], [4906, 5464], [4885, 5452], [4845, 5448], [4819, 5438], [4785, 5468], [4766, 5502], [4778, 5508], [4776, 5539], [4749, 5582], [4736, 5622], [4726, 5639], [4743, 5657], [4753, 5635], [4803, 5627], [4829, 5644], [4829, 5760], [4840, 5751], [4854, 5716], [4850, 5693], [4878, 5693], [4910, 5721], [4919, 5743], [4972, 5726], [4994, 5733], [5002, 5760], [5031, 5775], [5036, 5794], [5058, 5807], [5071, 5824], [5105, 5839], [5134, 5834], [5162, 5833], [5169, 5800], [5183, 5770], [5182, 5722], [5166, 5729], [5148, 5708], [5158, 5683], [5182, 5679], [5187, 5694]], [[5070, 5635], [5036, 5606], [5047, 5584], [5068, 5572], [5077, 5589], [5099, 5596], [5108, 5615], [5084, 5639], [5070, 5635]]]
            }
        }, {
            "type": "Feature",
            "id": "CD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.58,
                "hc-middle-y": 0.42,
                "hc-key": "cd",
                "hc-a2": "CD",
                "name": "Democratic Republic of the Congo",
                "labelrank": "2",
                "country-abbrev": "D.R.C.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "COD",
                "iso-a2": "CD",
                "woe-id": "23424780",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5101, 6402], [5098, 6351], [5100, 6326], [5109, 6303], [5128, 6287], [5141, 6259], [5092, 6251], [5075, 6233], [5081, 6224], [5086, 6212], [5076, 6163], [5096, 6135], [5118, 6142], [5118, 6104], [5100, 6104], [5075, 6134], [5055, 6138], [5041, 6160], [5027, 6146], [4987, 6157], [4986, 6171], [4956, 6165], [4946, 6180], [4895, 6169], [4893, 6208], [4882, 6224], [4887, 6252], [4882, 6286], [4845, 6286], [4847, 6297], [4815, 6295], [4810, 6265], [4759, 6262], [4741, 6286], [4729, 6326], [4721, 6328], [4628, 6328], [4606, 6323], [4600, 6331], [4608, 6332], [4607, 6352], [4625, 6364], [4635, 6357], [4664, 6375], [4664, 6357], [4677, 6359], [4718, 6403], [4718, 6438], [4736, 6463], [4763, 6485], [4769, 6511], [4766, 6530], [4773, 6563], [4789, 6602], [4786, 6627], [4802, 6644], [4821, 6651], [4846, 6629], [4903, 6623], [4915, 6641], [4927, 6635], [4962, 6649], [4986, 6647], [4994, 6658], [5021, 6648], [5049, 6649], [5076, 6625], [5088, 6633], [5101, 6627], [5118, 6634], [5130, 6616], [5149, 6602], [5145, 6572], [5162, 6564], [5139, 6544], [5138, 6536], [5123, 6524], [5115, 6497], [5104, 6485], [5114, 6486], [5111, 6473], [5112, 6459], [5105, 6456], [5101, 6451], [5093, 6443], [5091, 6427], [5092, 6422], [5095, 6420], [5102, 6411], [5101, 6402]]]
            }
        }, {
            "type": "Feature",
            "id": "KW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.51,
                "hc-key": "kw",
                "hc-a2": "KW",
                "name": "Kuwait",
                "labelrank": "6",
                "country-abbrev": "Kwt.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "KWT",
                "iso-a2": "KW",
                "woe-id": "23424870",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5668, 7360], [5645, 7359], [5638, 7374], [5612, 7377], [5629, 7405], [5654, 7406], [5665, 7400], [5646, 7386], [5658, 7385], [5668, 7360]]]
            }
        }, {
            "type": "Feature",
            "id": "IE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.43,
                "hc-middle-y": 0.51,
                "hc-key": "ie",
                "hc-a2": "IE",
                "name": "Ireland",
                "labelrank": "3",
                "country-abbrev": "Ire.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "IRL",
                "iso-a2": "IE",
                "woe-id": "23424803",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4026, 8305], [3999, 8280], [4024, 8266], [4033, 8278], [4044, 8263], [4055, 8266], [4063, 8220], [4052, 8189], [4017, 8185], [3983, 8165], [3950, 8160], [3933, 8178], [3947, 8184], [3958, 8207], [3947, 8204], [3976, 8232], [3944, 8237], [3949, 8275], [3985, 8272], [4000, 8288], [3980, 8290], [3995, 8309], [4027, 8316], [4026, 8305]]]
            }
        }, {
            "type": "Feature",
            "id": "KP",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.32,
                "hc-middle-y": 0.64,
                "hc-key": "kp",
                "hc-a2": "KP",
                "name": "North Korea",
                "labelrank": "3",
                "country-abbrev": "N.K.",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "PRK",
                "iso-a2": "KP",
                "woe-id": "23424865",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[8094, 7820], [8075, 7812], [8063, 7794], [8065, 7769], [8050, 7763], [8024, 7740], [8000, 7730], [7998, 7711], [8025, 7692], [8019, 7683], [7989, 7681], [7975, 7665], [7943, 7672], [7936, 7660], [7920, 7689], [7939, 7716], [7907, 7735], [7907, 7743], [7923, 7756], [7955, 7771], [7973, 7798], [8018, 7788], [8015, 7809], [8041, 7810], [8064, 7825], [8069, 7844], [8089, 7828], [8092, 7824], [8094, 7820]]]
            }
        }, {
            "type": "Feature",
            "id": "KR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.49,
                "hc-key": "kr",
                "hc-a2": "KR",
                "name": "South Korea",
                "labelrank": "2",
                "country-abbrev": "S.K.",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "KOR",
                "iso-a2": "KR",
                "woe-id": "23424868",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7975, 7665], [7989, 7681], [8019, 7683], [8025, 7692], [8053, 7646], [8060, 7606], [8057, 7587], [8032, 7561], [8016, 7567], [7999, 7550], [7985, 7557], [7973, 7544], [7966, 7557], [7969, 7631], [7980, 7647], [7962, 7664], [7975, 7665]]]
            }
        }, {
            "type": "Feature",
            "id": "GY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.26,
                "hc-middle-y": 0.07,
                "hc-key": "gy",
                "hc-a2": "GY",
                "name": "Guyana",
                "labelrank": "4",
                "country-abbrev": "Guy.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "GUY",
                "iso-a2": "GY",
                "woe-id": "23424836",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2470, 6751], [2497, 6735], [2529, 6699], [2554, 6678], [2551, 6661], [2550, 6647], [2537, 6646], [2527, 6622], [2539, 6599], [2550, 6599], [2554, 6583], [2574, 6557], [2556, 6559], [2520, 6547], [2505, 6535], [2477, 6555], [2470, 6579], [2475, 6606], [2484, 6615], [2467, 6632], [2471, 6649], [2448, 6652], [2430, 6673], [2435, 6692], [2461, 6709], [2452, 6711], [2455, 6729], [2476, 6743], [2470, 6751]]]
            }
        }, {
            "type": "Feature",
            "id": "HN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.71,
                "hc-middle-y": 0.09,
                "hc-key": "hn",
                "hc-a2": "HN",
                "name": "Honduras",
                "labelrank": "5",
                "country-abbrev": "Hond.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "HND",
                "iso-a2": "HN",
                "woe-id": "23424841",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1638, 6964], [1653, 6970], [1693, 6966], [1706, 6973], [1754, 6967], [1770, 6949], [1788, 6943], [1748, 6931], [1739, 6937], [1712, 6912], [1681, 6905], [1683, 6891], [1665, 6882], [1659, 6891], [1650, 6895], [1653, 6907], [1630, 6912], [1604, 6925], [1610, 6944], [1638, 6964]]]
            }
        }, {
            "type": "Feature",
            "id": "MM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.17,
                "hc-middle-y": 0.49,
                "hc-key": "mm",
                "hc-a2": "MM",
                "name": "Myanmar",
                "labelrank": "3",
                "country-abbrev": "Myan.",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "MMR",
                "iso-a2": "MM",
                "woe-id": "23424763",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6960, 7126], [6972, 7133], [6970, 7154], [6987, 7167], [6993, 7190], [6991, 7217], [7015, 7212], [7032, 7249], [7029, 7260], [7041, 7271], [7042, 7294], [7075, 7319], [7091, 7322], [7110, 7339], [7110, 7349], [7116, 7359], [7133, 7346], [7138, 7328], [7150, 7329], [7150, 7276], [7121, 7250], [7118, 7212], [7147, 7219], [7155, 7191], [7174, 7188], [7163, 7160], [7187, 7156], [7194, 7137], [7221, 7148], [7223, 7141], [7210, 7134], [7191, 7103], [7187, 7107], [7145, 7084], [7130, 7088], [7113, 7048], [7120, 7028], [7142, 7004], [7154, 6977], [7146, 6974], [7145, 6952], [7137, 6937], [7164, 6904], [7162, 6884], [7178, 6848], [7152, 6814], [7152, 6804], [7143, 6815], [7152, 6846], [7145, 6867], [7147, 6888], [7123, 6939], [7119, 6981], [7106, 7003], [7089, 6988], [7067, 6980], [7053, 6964], [7018, 6974], [7030, 7019], [7016, 7058], [7002, 7059], [6996, 7074], [7011, 7076], [6993, 7096], [6983, 7094], [6960, 7126]]]
            }
        }, {
            "type": "Feature",
            "id": "GA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.36,
                "hc-middle-y": 0.65,
                "hc-key": "ga",
                "hc-a2": "GA",
                "name": "Gabon",
                "labelrank": "4",
                "country-abbrev": "Gabon",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GAB",
                "iso-a2": "GA",
                "woe-id": "23424822",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4529, 6529], [4574, 6529], [4573, 6563], [4574, 6567], [4630, 6567], [4632, 6563], [4630, 6536], [4660, 6539], [4666, 6527], [4649, 6506], [4647, 6494], [4667, 6482], [4664, 6444], [4655, 6427], [4645, 6439], [4636, 6428], [4606, 6445], [4607, 6432], [4581, 6432], [4589, 6391], [4578, 6397], [4567, 6385], [4532, 6421], [4513, 6446], [4496, 6483], [4513, 6488], [4514, 6516], [4529, 6529]]]
            }
        }, {
            "type": "Feature",
            "id": "GQ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.53,
                "hc-middle-y": 0.55,
                "hc-key": "gq",
                "hc-a2": "GQ",
                "name": "Equatorial Guinea",
                "labelrank": "4",
                "country-abbrev": "Eq. G.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GNQ",
                "iso-a2": "GQ",
                "woe-id": "23424804",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4573, 6563], [4574, 6529], [4529, 6529], [4515, 6535], [4529, 6557], [4529, 6569], [4534, 6563], [4573, 6563]]]
            }
        }, {
            "type": "Feature",
            "id": "NI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.86,
                "hc-key": "ni",
                "hc-a2": "NI",
                "name": "Nicaragua",
                "labelrank": "5",
                "country-abbrev": "Nic.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "NIC",
                "iso-a2": "NI",
                "woe-id": "23424915",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1712, 6826], [1681, 6859], [1655, 6879], [1665, 6882], [1683, 6891], [1681, 6905], [1712, 6912], [1739, 6937], [1748, 6931], [1788, 6943], [1787, 6923], [1776, 6895], [1767, 6835], [1773, 6821], [1752, 6823], [1712, 6826]]]
            }
        }, {
            "type": "Feature",
            "id": "UG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.16,
                "hc-middle-y": 0.55,
                "hc-key": "ug",
                "hc-a2": "UG",
                "name": "Uganda",
                "labelrank": "3",
                "country-abbrev": "Uga.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "UGA",
                "iso-a2": "UG",
                "woe-id": "23424974",
                "continent": "Africa"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5178, 6471], [5178, 6471], [5178, 6471], [5178, 6471]]], [[[5177, 6471], [5149, 6471], [5138, 6469], [5122, 6457], [5112, 6459], [5111, 6473], [5114, 6486], [5121, 6496], [5115, 6497], [5123, 6524], [5138, 6536], [5142, 6531], [5166, 6556], [5162, 6564], [5145, 6572], [5149, 6602], [5177, 6612], [5188, 6603], [5213, 6614], [5227, 6610], [5242, 6624], [5255, 6607], [5255, 6593], [5269, 6573], [5271, 6548], [5242, 6507], [5201, 6504], [5183, 6491], [5177, 6471]]]]
            }
        }, {
            "type": "Feature",
            "id": "MW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.2,
                "hc-middle-y": 0.31,
                "hc-key": "mw",
                "hc-a2": "MW",
                "name": "Malawi",
                "labelrank": "6",
                "country-abbrev": "Mal.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MWI",
                "iso-a2": "MW",
                "woe-id": "23424889",
                "continent": "Africa"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5269, 6164], [5269, 6164], [5269, 6165], [5269, 6164]]], [[[5264, 6168], [5264, 6169], [5263, 6169], [5264, 6168], [5264, 6168]]], [[[5251, 6215], [5248, 6218], [5248, 6218], [5251, 6215]]], [[[5245, 6220], [5245, 6221], [5245, 6221], [5245, 6220]]], [[[5210, 6224], [5225, 6218], [5240, 6214], [5252, 6156], [5244, 6136], [5251, 6106], [5279, 6075], [5268, 6102], [5297, 6068], [5295, 6026], [5276, 6011], [5280, 5993], [5249, 6031], [5259, 6048], [5252, 6076], [5232, 6069], [5219, 6087], [5207, 6096], [5213, 6129], [5223, 6131], [5220, 6180], [5233, 6189], [5210, 6224]]]]
            }
        }, {
            "type": "Feature",
            "id": "SX",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.76,
                "hc-middle-y": 0.53,
                "hc-key": "sx",
                "hc-a2": "SX",
                "name": "Somaliland",
                "labelrank": "5",
                "country-abbrev": "Solnd.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "-99",
                "iso-a2": "SX",
                "woe-id": "-99",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5515, 6838], [5545, 6807], [5565, 6806], [5589, 6820], [5609, 6814], [5638, 6829], [5683, 6831], [5683, 6778], [5654, 6735], [5625, 6735], [5538, 6764], [5520, 6776], [5497, 6813], [5505, 6823], [5515, 6838]]]
            }
        }, {
            "type": "Feature",
            "id": "TM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.38,
                "hc-middle-y": 0.41,
                "hc-key": "tm",
                "hc-a2": "TM",
                "name": "Turkmenistan",
                "labelrank": "4",
                "country-abbrev": "Turkm.",
                "subregion": "Central Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "TKM",
                "iso-a2": "TM",
                "woe-id": "23424972",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5922, 7807], [5931, 7793], [5946, 7798], [5939, 7815], [5967, 7838], [5992, 7820], [6005, 7820], [6012, 7788], [6067, 7774], [6081, 7740], [6130, 7704], [6137, 7704], [6174, 7679], [6202, 7672], [6201, 7649], [6179, 7656], [6171, 7645], [6149, 7640], [6141, 7612], [6108, 7598], [6100, 7584], [6076, 7574], [6068, 7584], [6046, 7590], [6044, 7622], [6019, 7625], [6010, 7638], [5974, 7660], [5931, 7670], [5927, 7680], [5875, 7674], [5855, 7655], [5829, 7648], [5827, 7689], [5831, 7702], [5820, 7716], [5819, 7738], [5795, 7741], [5800, 7773], [5824, 7761], [5842, 7765], [5853, 7778], [5835, 7791], [5829, 7812], [5807, 7813], [5797, 7788], [5786, 7801], [5802, 7814], [5838, 7821], [5859, 7807], [5877, 7783], [5890, 7786], [5921, 7783], [5922, 7807]]]
            }
        }, {
            "type": "Feature",
            "id": "ZM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.24,
                "hc-middle-y": 0.67,
                "hc-key": "zm",
                "hc-a2": "ZM",
                "name": "Zambia",
                "labelrank": "3",
                "country-abbrev": "Zambia",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "ZMB",
                "iso-a2": "ZM",
                "woe-id": "23425003",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5081, 6224], [5099, 6245], [5092, 6251], [5141, 6259], [5155, 6242], [5159, 6248], [5183, 6233], [5210, 6224], [5233, 6189], [5220, 6180], [5223, 6131], [5213, 6129], [5207, 6096], [5219, 6087], [5131, 6058], [5136, 6038], [5119, 6039], [5091, 6026], [5088, 6011], [5068, 6001], [5052, 5993], [5036, 5968], [5027, 5965], [4984, 5973], [4954, 5983], [4929, 5978], [4891, 6011], [4888, 6022], [4888, 6117], [4947, 6117], [4946, 6180], [4956, 6165], [4986, 6171], [4987, 6157], [5027, 6146], [5041, 6160], [5055, 6138], [5075, 6134], [5100, 6104], [5118, 6104], [5118, 6142], [5096, 6135], [5076, 6163], [5086, 6212], [5081, 6224]]]
            }
        }, {
            "type": "Feature",
            "id": "NC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.71,
                "hc-key": "nc",
                "hc-a2": "NC",
                "name": "Northern Cyprus",
                "labelrank": "6",
                "country-abbrev": "N. Cy.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "-99",
                "iso-a2": "NC",
                "woe-id": "-90",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5239, 7572], [5235, 7571], [5233, 7571], [5225, 7576], [5205, 7576], [5205, 7576], [5205, 7576], [5205, 7576], [5204, 7576], [5204, 7576], [5260, 7593], [5241, 7580], [5243, 7572], [5239, 7572]]], [[[5201, 7576], [5202, 7576], [5202, 7575], [5201, 7576]]]]
            }
        }, {
            "type": "Feature",
            "id": "MR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.62,
                "hc-middle-y": 0.63,
                "hc-key": "mr",
                "hc-a2": "MR",
                "name": "Mauritania",
                "labelrank": "3",
                "country-abbrev": "Mrt.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MRT",
                "iso-a2": "MR",
                "woe-id": "23424896",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3984, 7320], [4077, 7261], [4097, 7248], [4045, 7248], [4074, 6989], [4082, 6982], [4077, 6957], [3964, 6958], [3923, 6956], [3918, 6946], [3903, 6961], [3894, 6959], [3891, 6940], [3878, 6936], [3849, 6961], [3842, 6977], [3832, 6976], [3817, 6992], [3758, 6986], [3752, 6967], [3754, 6992], [3767, 7032], [3762, 7063], [3752, 7075], [3762, 7100], [3741, 7129], [3737, 7117], [3740, 7135], [3856, 7135], [3856, 7186], [3885, 7200], [3885, 7279], [3983, 7279], [3984, 7320]]]
            }
        }, {
            "type": "Feature",
            "id": "DZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.63,
                "hc-middle-y": 0.5,
                "hc-key": "dz",
                "hc-a2": "DZ",
                "name": "Algeria",
                "labelrank": "3",
                "country-abbrev": "Alg.",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "DZA",
                "iso-a2": "DZ",
                "woe-id": "23424740",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4097, 7248], [4077, 7261], [3984, 7320], [3984, 7332], [3984, 7364], [4014, 7386], [4070, 7394], [4111, 7423], [4132, 7429], [4132, 7460], [4156, 7464], [4165, 7475], [4203, 7474], [4209, 7488], [4190, 7512], [4187, 7561], [4174, 7573], [4188, 7574], [4205, 7589], [4270, 7620], [4316, 7623], [4326, 7630], [4381, 7633], [4394, 7625], [4457, 7640], [4473, 7632], [4493, 7635], [4486, 7618], [4482, 7558], [4460, 7533], [4468, 7511], [4485, 7488], [4506, 7473], [4520, 7414], [4513, 7410], [4529, 7378], [4533, 7338], [4526, 7320], [4530, 7295], [4517, 7283], [4535, 7258], [4535, 7244], [4580, 7226], [4593, 7202], [4460, 7120], [4410, 7077], [4364, 7068], [4331, 7067], [4334, 7087], [4295, 7101], [4274, 7116], [4273, 7127], [4097, 7248]]]
            }
        }, {
            "type": "Feature",
            "id": "LT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.27,
                "hc-middle-y": 0.06,
                "hc-key": "lt",
                "hc-a2": "LT",
                "name": "Lithuania",
                "labelrank": "5",
                "country-abbrev": "Lith.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "LTU",
                "iso-a2": "LT",
                "woe-id": "23424875",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4867, 8313], [4863, 8330], [4860, 8347], [4891, 8361], [4961, 8354], [4973, 8362], [4980, 8351], [4996, 8349], [5024, 8330], [5029, 8315], [5002, 8300], [4990, 8274], [4958, 8257], [4932, 8259], [4931, 8268], [4911, 8276], [4913, 8298], [4867, 8313]]], [[[4857, 8314], [4861, 8323], [4859, 8314], [4857, 8314]]]]
            }
        }, {
            "type": "Feature",
            "id": "ET",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.58,
                "hc-key": "et",
                "hc-a2": "ET",
                "name": "Ethiopia",
                "labelrank": "2",
                "country-abbrev": "Eth.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "ETH",
                "iso-a2": "ET",
                "woe-id": "23424808",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5472, 6832], [5469, 6829], [5472, 6826], [5476, 6821], [5505, 6823], [5497, 6813], [5520, 6776], [5538, 6764], [5625, 6735], [5654, 6735], [5609, 6691], [5565, 6644], [5536, 6645], [5511, 6636], [5503, 6626], [5475, 6617], [5453, 6616], [5442, 6626], [5415, 6613], [5405, 6600], [5363, 6606], [5326, 6630], [5299, 6635], [5295, 6656], [5282, 6657], [5264, 6695], [5234, 6725], [5214, 6729], [5220, 6748], [5241, 6748], [5244, 6778], [5259, 6820], [5267, 6815], [5278, 6850], [5292, 6873], [5305, 6874], [5317, 6921], [5339, 6926], [5347, 6916], [5357, 6939], [5373, 6925], [5390, 6932], [5422, 6927], [5444, 6916], [5489, 6867], [5471, 6839], [5472, 6832]]]
            }
        }, {
            "type": "Feature",
            "id": "SD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "sd",
                "hc-a2": "SD",
                "name": "Sudan",
                "labelrank": "3",
                "country-abbrev": "Sudan",
                "subregion": "Northern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SDN",
                "iso-a2": "SD",
                "woe-id": "-90",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5317, 6921], [5305, 6874], [5292, 6873], [5278, 6850], [5267, 6815], [5259, 6820], [5244, 6778], [5240, 6799], [5218, 6819], [5219, 6859], [5186, 6853], [5195, 6825], [5161, 6788], [5147, 6786], [5125, 6802], [5090, 6774], [5067, 6774], [5062, 6782], [5023, 6780], [5001, 6806], [4979, 6802], [4964, 6761], [4952, 6755], [4932, 6758], [4937, 6790], [4914, 6821], [4915, 6836], [4894, 6875], [4883, 6877], [4896, 6893], [4891, 6906], [4904, 6917], [4921, 6964], [4947, 6964], [4947, 7078], [4947, 7094], [4976, 7094], [4976, 7155], [5161, 7155], [5327, 7155], [5339, 7119], [5336, 7094], [5347, 7055], [5378, 7033], [5366, 7019], [5331, 7005], [5329, 6981], [5314, 6947], [5317, 6921]]]
            }
        }, {
            "type": "Feature",
            "id": "ER",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.1,
                "hc-middle-y": 0.24,
                "hc-key": "er",
                "hc-a2": "ER",
                "name": "Eritrea",
                "labelrank": "4",
                "country-abbrev": "Erit.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "ERI",
                "iso-a2": "ER",
                "woe-id": "23424806",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5489, 6867], [5444, 6916], [5422, 6927], [5390, 6932], [5373, 6925], [5357, 6939], [5347, 6916], [5339, 6926], [5317, 6921], [5314, 6947], [5329, 6981], [5331, 7005], [5366, 7019], [5378, 7033], [5388, 7015], [5399, 6969], [5410, 6946], [5415, 6958], [5424, 6942], [5454, 6932], [5469, 6911], [5487, 6900], [5511, 6874], [5498, 6864], [5489, 6867]]]
            }
        }, {
            "type": "Feature",
            "id": "GH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.13,
                "hc-middle-y": 0.77,
                "hc-key": "gh",
                "hc-a2": "GH",
                "name": "Ghana",
                "labelrank": "3",
                "country-abbrev": "Ghana",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GHA",
                "iso-a2": "GH",
                "woe-id": "23424824",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4275, 6679], [4268, 6670], [4247, 6669], [4216, 6653], [4178, 6639], [4148, 6649], [4148, 6650], [4152, 6649], [4156, 6651], [4145, 6701], [4166, 6741], [4160, 6779], [4153, 6813], [4158, 6823], [4215, 6824], [4235, 6827], [4237, 6813], [4250, 6800], [4246, 6781], [4255, 6776], [4250, 6758], [4259, 6715], [4255, 6701], [4275, 6679]]]
            }
        }, {
            "type": "Feature",
            "id": "SI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.52,
                "hc-middle-y": 0.57,
                "hc-key": "si",
                "hc-a2": "SI",
                "name": "Slovenia",
                "labelrank": "6",
                "country-abbrev": "Slo.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "SVN",
                "iso-a2": "SI",
                "woe-id": "23424945",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4640, 7935], [4640, 7937], [4644, 7939], [4634, 7964], [4644, 7973], [4668, 7968], [4678, 7976], [4712, 7979], [4714, 7985], [4719, 7985], [4727, 7972], [4701, 7961], [4692, 7934], [4640, 7935]]]
            }
        }, {
            "type": "Feature",
            "id": "GT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.23,
                "hc-middle-y": 0.79,
                "hc-key": "gt",
                "hc-a2": "GT",
                "name": "Guatemala",
                "labelrank": "3",
                "country-abbrev": "Guat.",
                "subregion": "Central America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "GTM",
                "iso-a2": "GT",
                "woe-id": "23424834",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1618, 6969], [1626, 6965], [1638, 6964], [1610, 6944], [1604, 6925], [1582, 6908], [1583, 6905], [1547, 6911], [1519, 6929], [1520, 6951], [1534, 6975], [1571, 6975], [1574, 6984], [1543, 7010], [1556, 7010], [1557, 7027], [1610, 7027], [1608, 6969], [1618, 6969]]]
            }
        }, {
            "type": "Feature",
            "id": "BA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.91,
                "hc-middle-y": 0.56,
                "hc-key": "ba",
                "hc-a2": "BA",
                "name": "Bosnia and Herzegovina",
                "labelrank": "5",
                "country-abbrev": "B.H.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "BIH",
                "iso-a2": "BA",
                "woe-id": "23424761",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4760, 7841], [4757, 7843], [4758, 7843], [4758, 7848], [4718, 7888], [4706, 7906], [4705, 7923], [4721, 7917], [4739, 7927], [4766, 7919], [4790, 7920], [4800, 7912], [4811, 7913], [4805, 7891], [4806, 7864], [4784, 7845], [4783, 7829], [4766, 7838], [4760, 7841]]]
            }
        }, {
            "type": "Feature",
            "id": "JO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.07,
                "hc-middle-y": 0.78,
                "hc-key": "jo",
                "hc-a2": "JO",
                "name": "Jordan",
                "labelrank": "4",
                "country-abbrev": "Jord.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "JOR",
                "iso-a2": "JO",
                "woe-id": "23424860",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5284, 7442], [5287, 7445], [5284, 7446], [5283, 7447], [5284, 7449], [5288, 7449], [5288, 7463], [5288, 7492], [5294, 7495], [5325, 7481], [5383, 7516], [5391, 7487], [5394, 7475], [5329, 7454], [5360, 7422], [5345, 7406], [5323, 7402], [5302, 7380], [5270, 7386], [5272, 7391], [5270, 7392], [5276, 7420], [5284, 7442]]]
            }
        }, {
            "type": "Feature",
            "id": "SY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.25,
                "hc-middle-y": 0.54,
                "hc-key": "sy",
                "hc-a2": "SY",
                "name": "Syria",
                "labelrank": "3",
                "country-abbrev": "Syria",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "SYR",
                "iso-a2": "SY",
                "woe-id": "23424956",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5383, 7516], [5325, 7481], [5294, 7495], [5298, 7502], [5296, 7517], [5319, 7543], [5300, 7558], [5299, 7584], [5299, 7600], [5306, 7597], [5320, 7631], [5344, 7624], [5367, 7634], [5380, 7627], [5412, 7628], [5446, 7641], [5463, 7639], [5484, 7648], [5489, 7641], [5474, 7624], [5460, 7621], [5455, 7563], [5440, 7548], [5383, 7516]]]
            }
        }, {
            "type": "Feature",
            "id": "MC",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.67,
                "hc-key": "mc",
                "hc-a2": "MC",
                "name": "Monaco",
                "labelrank": "6",
                "country-abbrev": "Mco.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "MCO",
                "iso-a2": "MC",
                "woe-id": "23424892",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4459, 7872], [4458, 7871], [4457, 7871], [4458, 7872], [4459, 7872]]]
            }
        }, {
            "type": "Feature",
            "id": "AL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.49,
                "hc-key": "al",
                "hc-a2": "AL",
                "name": "Albania",
                "labelrank": "6",
                "country-abbrev": "Alb.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ALB",
                "iso-a2": "AL",
                "woe-id": "23424742",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4858, 7770], [4857, 7770], [4857, 7771], [4858, 7770]]], [[[4811, 7813], [4811, 7818], [4812, 7821], [4821, 7833], [4831, 7829], [4844, 7817], [4846, 7805], [4842, 7794], [4848, 7777], [4849, 7772], [4851, 7771], [4854, 7772], [4857, 7771], [4857, 7771], [4858, 7769], [4858, 7769], [4856, 7767], [4858, 7767], [4857, 7766], [4859, 7764], [4859, 7763], [4859, 7763], [4841, 7734], [4829, 7729], [4809, 7762], [4817, 7803], [4811, 7804], [4810, 7808], [4811, 7813]]], [[[4811, 7820], [4811, 7819], [4811, 7819], [4811, 7820]]]]
            }
        }, {
            "type": "Feature",
            "id": "UY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.81,
                "hc-middle-y": 0.63,
                "hc-key": "uy",
                "hc-a2": "UY",
                "name": "Uruguay",
                "labelrank": "4",
                "country-abbrev": "Ury.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "URY",
                "iso-a2": "UY",
                "woe-id": "23424979",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2672, 5507], [2658, 5493], [2661, 5478], [2661, 5475], [2666, 5472], [2654, 5450], [2619, 5432], [2607, 5437], [2584, 5432], [2554, 5448], [2534, 5448], [2518, 5465], [2518, 5486], [2518, 5491], [2519, 5492], [2527, 5495], [2523, 5514], [2523, 5532], [2541, 5588], [2564, 5590], [2582, 5575], [2588, 5559], [2600, 5566], [2611, 5553], [2629, 5546], [2672, 5507]]]
            }
        }, {
            "type": "Feature",
            "id": "CNM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.11,
                "hc-key": "cnm",
                "hc-a2": "CN",
                "name": "Cyprus No Mans Area",
                "labelrank": "9",
                "country-abbrev": null,
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "-99",
                "iso-a2": null,
                "woe-id": "-99",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[5243, 7572], [5243, 7572], [5242, 7571], [5239, 7572], [5239, 7572], [5243, 7572]]], [[[5200, 7576], [5201, 7576], [5202, 7575], [5202, 7576], [5203, 7576], [5202, 7575], [5200, 7576]]], [[[5204, 7576], [5204, 7576], [5204, 7576], [5205, 7576], [5205, 7576], [5204, 7576]]], [[[5233, 7571], [5234, 7570], [5233, 7569], [5225, 7575], [5205, 7576], [5205, 7576], [5225, 7576], [5233, 7571]]]]
            }
        }, {
            "type": "Feature",
            "id": "MN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.53,
                "hc-key": "mn",
                "hc-a2": "MN",
                "name": "Mongolia",
                "labelrank": "3",
                "country-abbrev": "Mong.",
                "subregion": "Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "MNG",
                "iso-a2": "MN",
                "woe-id": "23424887",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7705, 8020], [7716, 8023], [7712, 8027], [7735, 8027], [7775, 7987], [7769, 7975], [7727, 7980], [7699, 7966], [7678, 7965], [7665, 7943], [7651, 7934], [7617, 7931], [7590, 7908], [7543, 7920], [7525, 7897], [7540, 7870], [7512, 7856], [7495, 7837], [7468, 7825], [7430, 7826], [7388, 7820], [7342, 7800], [7321, 7805], [7298, 7801], [7248, 7816], [7237, 7828], [7189, 7833], [7173, 7829], [7106, 7837], [7081, 7835], [7067, 7854], [7052, 7891], [7042, 7890], [6998, 7915], [6919, 7924], [6913, 7935], [6923, 7954], [6924, 7974], [6904, 8015], [6881, 8029], [6865, 8028], [6833, 8051], [6829, 8072], [6841, 8083], [6860, 8082], [6883, 8100], [6935, 8122], [6963, 8137], [6972, 8130], [7019, 8126], [7029, 8105], [7067, 8104], [7110, 8094], [7133, 8106], [7138, 8124], [7124, 8143], [7131, 8160], [7156, 8187], [7189, 8171], [7204, 8171], [7253, 8155], [7255, 8128], [7297, 8109], [7346, 8122], [7385, 8117], [7402, 8104], [7423, 8101], [7440, 8078], [7505, 8071], [7523, 8080], [7574, 8088], [7610, 8115], [7642, 8100], [7667, 8104], [7680, 8097], [7646, 8033], [7656, 8017], [7685, 8023], [7705, 8020]]]
            }
        }, {
            "type": "Feature",
            "id": "RW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.56,
                "hc-key": "rw",
                "hc-a2": "RW",
                "name": "Rwanda",
                "labelrank": "3",
                "country-abbrev": "Rwa.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "RWA",
                "iso-a2": "RW",
                "woe-id": "23424937",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5095, 6420], [5092, 6422], [5091, 6427], [5106, 6440], [5101, 6451], [5105, 6456], [5112, 6459], [5122, 6457], [5138, 6469], [5149, 6453], [5149, 6431], [5141, 6430], [5122, 6432], [5121, 6422], [5095, 6420]]]
            }
        }, {
            "type": "Feature",
            "id": "SO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.74,
                "hc-key": "so",
                "hc-a2": "SO",
                "name": "Somalia",
                "labelrank": "6",
                "country-abbrev": "Som.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SOM",
                "iso-a2": "SO",
                "woe-id": "-90",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5475, 6617], [5503, 6626], [5511, 6636], [5536, 6645], [5565, 6644], [5609, 6691], [5654, 6735], [5683, 6778], [5683, 6831], [5722, 6841], [5738, 6853], [5752, 6848], [5739, 6778], [5695, 6706], [5686, 6680], [5654, 6631], [5597, 6571], [5567, 6555], [5521, 6518], [5495, 6491], [5464, 6450], [5448, 6474], [5448, 6582], [5475, 6617]]]
            }
        }, {
            "type": "Feature",
            "id": "BO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.59,
                "hc-key": "bo",
                "hc-a2": "BO",
                "name": "Bolivia",
                "labelrank": "3",
                "country-abbrev": "Bolivia",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "BOL",
                "iso-a2": "BO",
                "woe-id": "23424762",
                "continent": "South America"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[2202, 6020], [2201, 6026], [2206, 6021], [2203, 6021], [2202, 6020]]], [[[2190, 5982], [2185, 5988], [2204, 6011], [2217, 6017], [2194, 6042], [2194, 6058], [2209, 6081], [2202, 6097], [2205, 6120], [2214, 6132], [2188, 6178], [2226, 6177], [2274, 6209], [2309, 6215], [2314, 6200], [2311, 6172], [2323, 6147], [2341, 6133], [2380, 6127], [2406, 6113], [2416, 6101], [2439, 6103], [2456, 6093], [2466, 6019], [2516, 6017], [2518, 5989], [2535, 5981], [2542, 5961], [2525, 5901], [2524, 5912], [2497, 5928], [2470, 5928], [2419, 5917], [2403, 5889], [2403, 5874], [2392, 5838], [2387, 5845], [2354, 5845], [2343, 5818], [2335, 5839], [2301, 5841], [2286, 5851], [2258, 5820], [2238, 5820], [2228, 5867], [2212, 5893], [2221, 5923], [2205, 5938], [2190, 5982]]]]
            }
        }, {
            "type": "Feature",
            "id": "CM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.27,
                "hc-middle-y": 0.67,
                "hc-key": "cm",
                "hc-a2": "CM",
                "name": "Cameroon",
                "labelrank": "3",
                "country-abbrev": "Cam.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "CMR",
                "iso-a2": "CM",
                "woe-id": "23424785",
                "continent": "Africa"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4632, 6563], [4630, 6567], [4574, 6567], [4573, 6563], [4534, 6563], [4529, 6569], [4532, 6595], [4523, 6614], [4505, 6620], [4493, 6641], [4500, 6671], [4539, 6706], [4552, 6709], [4573, 6689], [4590, 6709], [4600, 6745], [4617, 6758], [4619, 6775], [4652, 6832], [4670, 6838], [4672, 6858], [4658, 6864], [4654, 6885], [4662, 6885], [4660, 6880], [4667, 6882], [4677, 6872], [4686, 6839], [4684, 6817], [4702, 6794], [4658, 6793], [4651, 6783], [4687, 6749], [4696, 6721], [4674, 6683], [4664, 6677], [4668, 6654], [4687, 6610], [4714, 6583], [4717, 6565], [4716, 6551], [4669, 6565], [4632, 6563]]], [[[4663, 6885], [4664, 6885], [4663, 6885], [4663, 6885]]]]
            }
        }, {
            "type": "Feature",
            "id": "CG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.15,
                "hc-middle-y": 0.78,
                "hc-key": "cg",
                "hc-a2": "CG",
                "name": "Republic of Congo",
                "labelrank": "4",
                "country-abbrev": "Rep. Congo",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "COG",
                "iso-a2": "CG",
                "woe-id": "23424779",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4625, 6364], [4616, 6371], [4594, 6353], [4588, 6366], [4567, 6385], [4578, 6397], [4589, 6391], [4581, 6432], [4607, 6432], [4606, 6445], [4636, 6428], [4645, 6439], [4655, 6427], [4664, 6444], [4667, 6482], [4647, 6494], [4649, 6506], [4666, 6527], [4660, 6539], [4630, 6536], [4632, 6563], [4669, 6565], [4716, 6551], [4717, 6565], [4728, 6601], [4754, 6609], [4789, 6602], [4773, 6563], [4766, 6530], [4769, 6511], [4763, 6485], [4736, 6463], [4718, 6438], [4718, 6403], [4677, 6359], [4664, 6357], [4664, 6375], [4635, 6357], [4625, 6364]]]
            }
        }, {
            "type": "Feature",
            "id": "EH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.41,
                "hc-middle-y": 0.71,
                "hc-key": "eh",
                "hc-a2": "EH",
                "name": "Western Sahara",
                "labelrank": "7",
                "country-abbrev": "W. Sah.",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "ESH",
                "iso-a2": "EH",
                "woe-id": "23424990",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3737, 7117], [3735, 7120], [3738, 7137], [3802, 7138], [3820, 7165], [3826, 7199], [3854, 7229], [3873, 7243], [3885, 7280], [3894, 7283], [3904, 7307], [3918, 7311], [3953, 7306], [3980, 7315], [3984, 7332], [3984, 7320], [3983, 7279], [3885, 7279], [3885, 7200], [3856, 7186], [3856, 7135], [3740, 7135], [3737, 7117]]]
            }
        }, {
            "type": "Feature",
            "id": "RS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.43,
                "hc-middle-y": 0.51,
                "hc-key": "rs",
                "hc-a2": "RS",
                "name": "Republic of Serbia",
                "labelrank": "5",
                "country-abbrev": "Serb.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "SRB",
                "iso-a2": "RS",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4806, 7864], [4805, 7891], [4811, 7913], [4800, 7912], [4801, 7922], [4797, 7951], [4816, 7960], [4837, 7958], [4852, 7935], [4873, 7922], [4871, 7909], [4892, 7899], [4901, 7907], [4909, 7889], [4899, 7874], [4917, 7849], [4901, 7838], [4899, 7821], [4886, 7821], [4876, 7818], [4881, 7833], [4852, 7854], [4840, 7839], [4818, 7851], [4806, 7864]]]
            }
        }, {
            "type": "Feature",
            "id": "ME",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.42,
                "hc-middle-y": 0.47,
                "hc-key": "me",
                "hc-a2": "ME",
                "name": "Montenegro",
                "labelrank": "6",
                "country-abbrev": "Mont.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "MNE",
                "iso-a2": "ME",
                "woe-id": "20069817",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4806, 7864], [4818, 7851], [4840, 7839], [4830, 7835], [4831, 7829], [4821, 7833], [4812, 7821], [4811, 7820], [4811, 7819], [4804, 7819], [4811, 7813], [4810, 7808], [4811, 7804], [4793, 7819], [4785, 7824], [4783, 7827], [4783, 7829], [4784, 7845], [4806, 7864]]]
            }
        }, {
            "type": "Feature",
            "id": "BJ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.57,
                "hc-middle-y": 0.5,
                "hc-key": "bj",
                "hc-a2": "BJ",
                "name": "Benin",
                "labelrank": "5",
                "country-abbrev": "Benin",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "BEN",
                "iso-a2": "BJ",
                "woe-id": "23424764",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4319, 6687], [4295, 6684], [4287, 6682], [4287, 6766], [4279, 6794], [4262, 6805], [4266, 6823], [4282, 6838], [4299, 6836], [4310, 6850], [4323, 6865], [4346, 6844], [4342, 6836], [4353, 6812], [4343, 6789], [4321, 6766], [4319, 6687]]]
            }
        }, {
            "type": "Feature",
            "id": "NG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.33,
                "hc-key": "ng",
                "hc-a2": "NG",
                "name": "Nigeria",
                "labelrank": "2",
                "country-abbrev": "Nigeria",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "NGA",
                "iso-a2": "NG",
                "woe-id": "23424908",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4319, 6687], [4321, 6766], [4343, 6789], [4353, 6812], [4342, 6836], [4346, 6844], [4347, 6869], [4360, 6883], [4361, 6897], [4402, 6909], [4427, 6902], [4444, 6883], [4470, 6893], [4496, 6881], [4524, 6878], [4538, 6890], [4577, 6894], [4607, 6885], [4620, 6898], [4641, 6904], [4654, 6885], [4658, 6864], [4672, 6858], [4670, 6838], [4652, 6832], [4619, 6775], [4617, 6758], [4600, 6745], [4590, 6709], [4573, 6689], [4552, 6709], [4539, 6706], [4500, 6671], [4493, 6641], [4484, 6633], [4454, 6635], [4422, 6625], [4405, 6636], [4384, 6676], [4370, 6686], [4319, 6687]]]
            }
        }, {
            "type": "Feature",
            "id": "TG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.76,
                "hc-middle-y": 0.81,
                "hc-key": "tg",
                "hc-a2": "TG",
                "name": "Togo",
                "labelrank": "6",
                "country-abbrev": "Togo",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "TGO",
                "iso-a2": "TG",
                "woe-id": "23424965",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4266, 6823], [4262, 6805], [4279, 6794], [4287, 6766], [4287, 6682], [4282, 6681], [4275, 6679], [4255, 6701], [4259, 6715], [4250, 6758], [4255, 6776], [4246, 6781], [4250, 6800], [4237, 6813], [4235, 6827], [4254, 6824], [4266, 6823]]]
            }
        }, {
            "type": "Feature",
            "id": "LA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.88,
                "hc-middle-y": 0.75,
                "hc-key": "la",
                "hc-a2": "LA",
                "name": "Laos",
                "labelrank": "4",
                "country-abbrev": "Laos",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "LAO",
                "iso-a2": "LA",
                "woe-id": "23424872",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[7191, 7103], [7210, 7134], [7223, 7141], [7239, 7128], [7233, 7163], [7251, 7167], [7276, 7142], [7281, 7120], [7297, 7114], [7308, 7123], [7325, 7114], [7317, 7107], [7335, 7096], [7325, 7082], [7306, 7084], [7302, 7072], [7327, 7057], [7357, 7023], [7381, 7002], [7406, 6970], [7399, 6966], [7415, 6951], [7410, 6934], [7389, 6922], [7381, 6930], [7365, 6924], [7362, 6910], [7341, 6923], [7353, 6942], [7354, 6964], [7329, 6989], [7331, 7014], [7306, 7043], [7289, 7046], [7265, 7028], [7250, 7039], [7222, 7017], [7219, 7046], [7225, 7078], [7202, 7079], [7205, 7096], [7191, 7103]]]
            }
        }, {
            "type": "Feature",
            "id": "AF",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.38,
                "hc-middle-y": 0.52,
                "hc-key": "af",
                "hc-a2": "AF",
                "name": "Afghanistan",
                "labelrank": "3",
                "country-abbrev": "Afg.",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "AFG",
                "iso-a2": "AF",
                "woe-id": "23424739",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6448, 7645], [6433, 7641], [6438, 7638], [6379, 7631], [6338, 7605], [6352, 7576], [6332, 7553], [6335, 7538], [6304, 7538], [6313, 7514], [6290, 7506], [6281, 7485], [6283, 7469], [6269, 7458], [6249, 7465], [6226, 7445], [6214, 7449], [6197, 7436], [6192, 7401], [6129, 7387], [6082, 7387], [6034, 7402], [6062, 7434], [6059, 7451], [6033, 7455], [6033, 7479], [6026, 7506], [6034, 7522], [6023, 7540], [6035, 7547], [6046, 7590], [6068, 7584], [6076, 7574], [6100, 7584], [6108, 7598], [6141, 7612], [6149, 7640], [6171, 7645], [6179, 7656], [6201, 7649], [6223, 7643], [6238, 7643], [6245, 7634], [6265, 7646], [6282, 7640], [6289, 7656], [6308, 7655], [6322, 7683], [6343, 7680], [6351, 7667], [6346, 7639], [6351, 7627], [6382, 7638], [6401, 7653], [6413, 7644], [6432, 7651], [6448, 7645]]]
            }
        }, {
            "type": "Feature",
            "id": "UA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.7,
                "hc-middle-y": 0.46,
                "hc-key": "ua",
                "hc-a2": "UA",
                "name": "Ukraine",
                "labelrank": "3",
                "country-abbrev": "Ukr.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "UKR",
                "iso-a2": "UA",
                "woe-id": "23424976",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4892, 8043], [4898, 8054], [4904, 8068], [4914, 8065], [4907, 8086], [4921, 8102], [4951, 8125], [4952, 8137], [4936, 8163], [4959, 8177], [4999, 8179], [5043, 8166], [5073, 8168], [5104, 8157], [5140, 8165], [5151, 8184], [5176, 8186], [5194, 8194], [5236, 8196], [5254, 8171], [5248, 8152], [5274, 8151], [5291, 8117], [5320, 8112], [5344, 8120], [5360, 8100], [5365, 8106], [5395, 8098], [5423, 8075], [5410, 8056], [5418, 8037], [5412, 8022], [5385, 8022], [5371, 8013], [5367, 7994], [5298, 7978], [5266, 7960], [5286, 7928], [5318, 7933], [5315, 7920], [5289, 7921], [5274, 7910], [5256, 7907], [5241, 7895], [5228, 7904], [5229, 7920], [5210, 7930], [5209, 7940], [5236, 7951], [5175, 7962], [5193, 7971], [5158, 7977], [5119, 7939], [5114, 7925], [5104, 7933], [5089, 7926], [5071, 7934], [5094, 7954], [5093, 7970], [5127, 7967], [5111, 7989], [5111, 8003], [5098, 8010], [5102, 8023], [5058, 8045], [5025, 8038], [5011, 8028], [4985, 8024], [4914, 8026], [4906, 8032], [4892, 8043]], [[5128, 7967], [5137, 7957], [5139, 7959], [5130, 7968], [5128, 7967]], [[5242, 7957], [5271, 7941], [5266, 7955], [5248, 7964], [5242, 7957]]]
            }
        }, {
            "type": "Feature",
            "id": "SK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.21,
                "hc-middle-y": 0.57,
                "hc-key": "sk",
                "hc-a2": "SK",
                "name": "Slovakia",
                "labelrank": "6",
                "country-abbrev": "Svk.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "SVK",
                "iso-a2": "SK",
                "woe-id": "23424877",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4904, 8068], [4898, 8054], [4892, 8043], [4871, 8049], [4844, 8048], [4827, 8033], [4795, 8029], [4794, 8022], [4765, 8019], [4745, 8028], [4736, 8042], [4739, 8051], [4773, 8069], [4795, 8085], [4813, 8089], [4831, 8072], [4839, 8081], [4883, 8080], [4904, 8068]]]
            }
        }, {
            "type": "Feature",
            "id": "JK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.4,
                "hc-middle-y": 0.63,
                "hc-key": "jk",
                "hc-a2": "JK",
                "name": "Siachen Glacier",
                "labelrank": "5",
                "country-abbrev": "Siachen",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "-99",
                "iso-a2": "JK",
                "woe-id": "23424928",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6534, 7586], [6512, 7573], [6504, 7591], [6522, 7585], [6534, 7586]]]
            }
        }, {
            "type": "Feature",
            "id": "BG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.76,
                "hc-middle-y": 0.51,
                "hc-key": "bg",
                "hc-a2": "BG",
                "name": "Bulgaria",
                "labelrank": "4",
                "country-abbrev": "Bulg.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "BGR",
                "iso-a2": "BG",
                "woe-id": "23424771",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5082, 7872], [5069, 7859], [5056, 7825], [5066, 7809], [5037, 7812], [5016, 7799], [5010, 7787], [4984, 7783], [4962, 7794], [4915, 7786], [4918, 7800], [4899, 7821], [4901, 7838], [4917, 7849], [4899, 7874], [4909, 7889], [4927, 7877], [4987, 7868], [5011, 7881], [5037, 7887], [5082, 7872]]]
            }
        }, {
            "type": "Feature",
            "id": "QA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.5,
                "hc-key": "qa",
                "hc-a2": "QA",
                "name": "Qatar",
                "labelrank": "5",
                "country-abbrev": "Qatar",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "QAT",
                "iso-a2": "QA",
                "woe-id": "23424930",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5738, 7240], [5736, 7263], [5751, 7284], [5761, 7276], [5757, 7238], [5750, 7236], [5743, 7235], [5738, 7240]]]
            }
        }, {
            "type": "Feature",
            "id": "LI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.61,
                "hc-middle-y": 0.53,
                "hc-key": "li",
                "hc-a2": "LI",
                "name": "Liechtenstein",
                "labelrank": "6",
                "country-abbrev": "Liech.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "LIE",
                "iso-a2": "LI",
                "woe-id": "23424879",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4520, 8000], [4523, 7995], [4522, 7993], [4519, 7993], [4520, 8000]]]
            }
        }, {
            "type": "Feature",
            "id": "AT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.6,
                "hc-key": "at",
                "hc-a2": "AT",
                "name": "Austria",
                "labelrank": "4",
                "country-abbrev": "Aust.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "AUT",
                "iso-a2": "AT",
                "woe-id": "23424750",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4522, 7993], [4523, 7995], [4520, 8000], [4524, 8006], [4521, 8010], [4525, 8009], [4526, 8011], [4539, 8001], [4547, 8012], [4563, 8005], [4599, 8017], [4624, 8009], [4615, 8032], [4644, 8048], [4647, 8057], [4673, 8050], [4681, 8065], [4739, 8051], [4736, 8042], [4745, 8028], [4743, 8017], [4728, 8019], [4724, 7991], [4714, 7985], [4712, 7979], [4678, 7976], [4668, 7968], [4644, 7973], [4605, 7979], [4599, 7994], [4548, 7986], [4538, 7985], [4522, 7993]]]
            }
        }, {
            "type": "Feature",
            "id": "SZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.52,
                "hc-key": "sz",
                "hc-a2": "SZ",
                "name": "Swaziland",
                "labelrank": "4",
                "country-abbrev": "Swz.",
                "subregion": "Southern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SWZ",
                "iso-a2": "SZ",
                "woe-id": "23424993",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5182, 5722], [5184, 5712], [5187, 5694], [5182, 5679], [5158, 5683], [5148, 5708], [5166, 5729], [5182, 5722]]]
            }
        }, {
            "type": "Feature",
            "id": "HU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.27,
                "hc-middle-y": 0.59,
                "hc-key": "hu",
                "hc-a2": "HU",
                "name": "Hungary",
                "labelrank": "5",
                "country-abbrev": "Hun.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "HUN",
                "iso-a2": "HU",
                "woe-id": "23424844",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4892, 8043], [4906, 8032], [4914, 8026], [4888, 8009], [4863, 7964], [4837, 7958], [4816, 7960], [4797, 7951], [4782, 7944], [4751, 7952], [4727, 7972], [4719, 7985], [4714, 7985], [4724, 7991], [4728, 8019], [4743, 8017], [4745, 8028], [4765, 8019], [4794, 8022], [4795, 8029], [4827, 8033], [4844, 8048], [4871, 8049], [4892, 8043]]]
            }
        }, {
            "type": "Feature",
            "id": "RO",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.67,
                "hc-middle-y": 0.5,
                "hc-key": "ro",
                "hc-a2": "RO",
                "name": "Romania",
                "labelrank": "3",
                "country-abbrev": "Rom.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ROU",
                "iso-a2": "RO",
                "woe-id": "23424933",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4909, 7889], [4901, 7907], [4892, 7899], [4871, 7909], [4873, 7922], [4852, 7935], [4837, 7958], [4863, 7964], [4888, 8009], [4914, 8026], [4985, 8024], [5011, 8028], [5025, 8038], [5036, 8034], [5045, 8015], [5066, 7992], [5073, 7976], [5068, 7954], [5071, 7934], [5089, 7926], [5104, 7933], [5114, 7925], [5111, 7911], [5098, 7909], [5084, 7892], [5082, 7872], [5037, 7887], [5011, 7881], [4987, 7868], [4927, 7877], [4909, 7889]]]
            }
        }, {
            "type": "Feature",
            "id": "LU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.48,
                "hc-middle-y": 0.6,
                "hc-key": "lu",
                "hc-a2": "LU",
                "name": "Luxembourg",
                "labelrank": "6",
                "country-abbrev": "Lux.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "LUX",
                "iso-a2": "LU",
                "woe-id": "23424881",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4427, 8083], [4415, 8083], [4410, 8086], [4408, 8099], [4420, 8109], [4431, 8096], [4427, 8083]]]
            }
        }, {
            "type": "Feature",
            "id": "AD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.58,
                "hc-middle-y": 0.28,
                "hc-key": "ad",
                "hc-a2": "AD",
                "name": "Andorra",
                "labelrank": "6",
                "country-abbrev": "And.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "AND",
                "iso-a2": "AD",
                "woe-id": "23424744",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4282, 7831], [4290, 7831], [4290, 7827], [4284, 7825], [4282, 7831]]]
            }
        }, {
            "type": "Feature",
            "id": "CI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.52,
                "hc-key": "ci",
                "hc-a2": "CI",
                "name": "Ivory Coast",
                "labelrank": "3",
                "country-abbrev": "I.C.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "CIV",
                "iso-a2": "CI",
                "woe-id": "23424854",
                "continent": "Africa"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4148, 6649], [4143, 6650], [4148, 6650], [4148, 6649]]], [[[4017, 6628], [4019, 6670], [4008, 6682], [3985, 6690], [3995, 6709], [3989, 6722], [3997, 6721], [3998, 6749], [4008, 6776], [3999, 6780], [4004, 6799], [4014, 6807], [4034, 6799], [4055, 6815], [4056, 6801], [4077, 6806], [4089, 6803], [4102, 6784], [4145, 6791], [4160, 6779], [4166, 6741], [4145, 6701], [4156, 6651], [4122, 6653], [4067, 6647], [4017, 6628]]]]
            }
        }, {
            "type": "Feature",
            "id": "LR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.96,
                "hc-middle-y": 0.75,
                "hc-key": "lr",
                "hc-a2": "LR",
                "name": "Liberia",
                "labelrank": "4",
                "country-abbrev": "Liberia",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "LBR",
                "iso-a2": "LR",
                "woe-id": "23424876",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3989, 6722], [3995, 6709], [3985, 6690], [4008, 6682], [4019, 6670], [4017, 6628], [3966, 6651], [3935, 6680], [3901, 6703], [3927, 6728], [3936, 6749], [3959, 6745], [3971, 6711], [3989, 6722]]]
            }
        }, {
            "type": "Feature",
            "id": "BN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.32,
                "hc-middle-y": 0.34,
                "hc-key": "bn",
                "hc-a2": "BN",
                "name": "Brunei",
                "labelrank": "6",
                "country-abbrev": "Brunei",
                "subregion": "South-Eastern Asia",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "BRN",
                "iso-a2": "BN",
                "woe-id": "23424773",
                "continent": "Asia"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[7632, 6641], [7635, 6642], [7635, 6644], [7641, 6626], [7632, 6641]]], [[[7601, 6635], [7617, 6638], [7630, 6643], [7620, 6618], [7601, 6635]]]]
            }
        }, {
            "type": "Feature",
            "id": "BE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.51,
                "hc-middle-y": 0.36,
                "hc-key": "be",
                "hc-a2": "BE",
                "name": "Belgium",
                "labelrank": "2",
                "country-abbrev": "Belg.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "BEL",
                "iso-a2": "BE",
                "woe-id": "23424757",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4420, 8109], [4408, 8099], [4410, 8086], [4400, 8085], [4381, 8102], [4361, 8103], [4363, 8113], [4348, 8116], [4314, 8146], [4332, 8155], [4338, 8157], [4352, 8151], [4364, 8157], [4366, 8155], [4365, 8157], [4387, 8161], [4411, 8149], [4416, 8133], [4427, 8116], [4420, 8109]]]
            }
        }, {
            "type": "Feature",
            "id": "IQ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.46,
                "hc-middle-y": 0.44,
                "hc-key": "iq",
                "hc-a2": "IQ",
                "name": "Iraq",
                "labelrank": "3",
                "country-abbrev": "Iraq",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "IRQ",
                "iso-a2": "IQ",
                "woe-id": "23424855",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5671, 7405], [5659, 7408], [5654, 7406], [5629, 7405], [5612, 7377], [5558, 7381], [5480, 7441], [5432, 7468], [5394, 7475], [5391, 7487], [5383, 7516], [5440, 7548], [5455, 7563], [5460, 7621], [5474, 7624], [5489, 7641], [5499, 7649], [5560, 7642], [5576, 7603], [5606, 7597], [5579, 7551], [5578, 7536], [5593, 7524], [5604, 7502], [5638, 7484], [5650, 7463], [5645, 7438], [5655, 7438], [5655, 7421], [5671, 7405]]]
            }
        }, {
            "type": "Feature",
            "id": "GE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.25,
                "hc-middle-y": 0.44,
                "hc-key": "ge",
                "hc-a2": "GE",
                "name": "Georgia",
                "labelrank": "5",
                "country-abbrev": "Geo.",
                "subregion": "Western Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "GEO",
                "iso-a2": "GE",
                "woe-id": "23424823",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5567, 7785], [5542, 7782], [5521, 7778], [5502, 7795], [5492, 7789], [5464, 7792], [5471, 7803], [5463, 7832], [5449, 7845], [5419, 7859], [5438, 7864], [5466, 7853], [5503, 7851], [5535, 7829], [5562, 7836], [5588, 7826], [5585, 7817], [5609, 7806], [5601, 7797], [5616, 7784], [5611, 7776], [5574, 7790], [5567, 7785]]]
            }
        }, {
            "type": "Feature",
            "id": "GM",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.22,
                "hc-middle-y": 0.53,
                "hc-key": "gm",
                "hc-a2": "GM",
                "name": "Gambia",
                "labelrank": "6",
                "country-abbrev": "Gambia",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GMB",
                "iso-a2": "GM",
                "woe-id": "23424821",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3746, 6885], [3743, 6893], [3751, 6900], [3782, 6900], [3801, 6906], [3831, 6893], [3816, 6890], [3793, 6901], [3773, 6888], [3746, 6885]]]
            }
        }, {
            "type": "Feature",
            "id": "CH",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.12,
                "hc-middle-y": 0.61,
                "hc-key": "ch",
                "hc-a2": "CH",
                "name": "Switzerland",
                "labelrank": "4",
                "country-abbrev": "Switz.",
                "subregion": "Western Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "CHE",
                "iso-a2": "CH",
                "woe-id": "23424957",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4510, 8016], [4511, 8015], [4511, 8015], [4511, 8015], [4520, 8009], [4521, 8010], [4524, 8006], [4520, 8000], [4519, 7993], [4522, 7993], [4538, 7985], [4548, 7986], [4548, 7973], [4533, 7967], [4513, 7971], [4500, 7956], [4478, 7963], [4471, 7951], [4447, 7951], [4439, 7959], [4440, 7969], [4435, 7973], [4428, 7968], [4423, 7964], [4420, 7975], [4447, 8003], [4463, 8012], [4489, 8012], [4510, 8016]]]
            }
        }, {
            "type": "Feature",
            "id": "TD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.47,
                "hc-middle-y": 0.63,
                "hc-key": "td",
                "hc-a2": "TD",
                "name": "Chad",
                "labelrank": "3",
                "country-abbrev": "Chad",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "TCD",
                "iso-a2": "TD",
                "woe-id": "23424777",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4667, 6882], [4675, 6885], [4663, 6885], [4663, 6885], [4661, 6887], [4662, 6885], [4654, 6885], [4641, 6904], [4636, 6924], [4663, 6965], [4696, 7000], [4704, 7091], [4711, 7104], [4687, 7139], [4681, 7186], [4711, 7200], [4947, 7078], [4947, 6964], [4921, 6964], [4904, 6917], [4891, 6906], [4896, 6893], [4883, 6877], [4894, 6875], [4915, 6836], [4914, 6821], [4902, 6823], [4842, 6768], [4803, 6765], [4804, 6755], [4788, 6736], [4760, 6734], [4734, 6722], [4728, 6731], [4696, 6721], [4687, 6749], [4651, 6783], [4658, 6793], [4702, 6794], [4684, 6817], [4686, 6839], [4677, 6872], [4667, 6882]]]
            }
        }, {
            "type": "Feature",
            "id": "KV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.52,
                "hc-key": "kv",
                "hc-a2": "KV",
                "name": "Kosovo",
                "labelrank": "6",
                "country-abbrev": "Kos.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "-99",
                "iso-a2": "KV",
                "woe-id": "-90",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4846, 7805], [4844, 7817], [4831, 7829], [4830, 7835], [4840, 7839], [4852, 7854], [4881, 7833], [4876, 7818], [4862, 7816], [4846, 7805]]]
            }
        }, {
            "type": "Feature",
            "id": "LB",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.39,
                "hc-middle-y": 0.57,
                "hc-key": "lb",
                "hc-a2": "LB",
                "name": "Lebanon",
                "labelrank": "5",
                "country-abbrev": "Leb.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "LBN",
                "iso-a2": "LB",
                "woe-id": "23424873",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5275, 7507], [5289, 7534], [5300, 7558], [5319, 7543], [5296, 7517], [5286, 7507], [5275, 7507]]]
            }
        }, {
            "type": "Feature",
            "id": "DJ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.55,
                "hc-key": "dj",
                "hc-a2": "DJ",
                "name": "Djibouti",
                "labelrank": "5",
                "country-abbrev": "Dji.",
                "subregion": "Eastern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "DJI",
                "iso-a2": "DJ",
                "woe-id": "23424797",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5505, 6823], [5476, 6821], [5472, 6826], [5475, 6830], [5472, 6832], [5471, 6839], [5489, 6867], [5498, 6864], [5511, 6874], [5518, 6853], [5499, 6840], [5515, 6838], [5505, 6823]]]
            }
        }, {
            "type": "Feature",
            "id": "BI",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.56,
                "hc-middle-y": 0.47,
                "hc-key": "bi",
                "hc-a2": "BI",
                "name": "Burundi",
                "labelrank": "6",
                "country-abbrev": "Bur.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "BDI",
                "iso-a2": "BI",
                "woe-id": "23424774",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5114, 6370], [5106, 6386], [5101, 6402], [5102, 6411], [5095, 6420], [5121, 6422], [5122, 6432], [5141, 6430], [5137, 6416], [5148, 6405], [5124, 6375], [5114, 6370]]]
            }
        }, {
            "type": "Feature",
            "id": "SR",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.93,
                "hc-middle-y": 0.13,
                "hc-key": "sr",
                "hc-a2": "SR",
                "name": "Suriname",
                "labelrank": "4",
                "country-abbrev": "Sur.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "SUR",
                "iso-a2": "SR",
                "woe-id": "23424913",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2629, 6568], [2618, 6574], [2589, 6574], [2588, 6554], [2574, 6557], [2554, 6583], [2550, 6599], [2539, 6599], [2527, 6622], [2537, 6646], [2550, 6647], [2551, 6661], [2560, 6676], [2647, 6671], [2642, 6657], [2633, 6644], [2637, 6618], [2647, 6601], [2629, 6568]]]
            }
        }, {
            "type": "Feature",
            "id": "IL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.68,
                "hc-middle-y": 0.1,
                "hc-key": "il",
                "hc-a2": "IL",
                "name": "Israel",
                "labelrank": "4",
                "country-abbrev": "Isr.",
                "subregion": "Western Asia",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "ISR",
                "iso-a2": "IL",
                "woe-id": "23424852",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5248, 7449], [5267, 7480], [5275, 7507], [5286, 7507], [5296, 7517], [5298, 7502], [5294, 7495], [5288, 7492], [5288, 7463], [5283, 7455], [5284, 7449], [5283, 7447], [5284, 7446], [5282, 7444], [5284, 7442], [5276, 7420], [5270, 7392], [5269, 7390], [5268, 7390], [5267, 7398], [5248, 7449]]]
            }
        }, {
            "type": "Feature",
            "id": "ML",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.59,
                "hc-middle-y": 0.38,
                "hc-key": "ml",
                "hc-a2": "ML",
                "name": "Mali",
                "labelrank": "3",
                "country-abbrev": "Mali",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MLI",
                "iso-a2": "ML",
                "woe-id": "23424891",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4077, 6806], [4056, 6801], [4055, 6815], [4034, 6799], [4014, 6807], [4004, 6799], [3993, 6834], [3979, 6843], [3969, 6867], [3953, 6854], [3937, 6860], [3924, 6850], [3904, 6865], [3904, 6881], [3883, 6904], [3878, 6936], [3891, 6940], [3894, 6959], [3903, 6961], [3918, 6946], [3923, 6956], [3964, 6958], [4077, 6957], [4082, 6982], [4074, 6989], [4045, 7248], [4097, 7248], [4273, 7127], [4274, 7116], [4295, 7101], [4334, 7087], [4331, 7067], [4364, 7068], [4363, 6985], [4343, 6953], [4279, 6951], [4268, 6942], [4246, 6940], [4218, 6945], [4177, 6917], [4156, 6914], [4135, 6888], [4119, 6895], [4105, 6858], [4087, 6851], [4077, 6806]]]
            }
        }, {
            "type": "Feature",
            "id": "SN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.23,
                "hc-middle-y": 0.5,
                "hc-key": "sn",
                "hc-a2": "SN",
                "name": "Senegal",
                "labelrank": "3",
                "country-abbrev": "Sen.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SEN",
                "iso-a2": "SN",
                "woe-id": "23424943",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3746, 6863], [3744, 6877], [3746, 6885], [3773, 6888], [3793, 6901], [3816, 6890], [3831, 6893], [3801, 6906], [3782, 6900], [3751, 6900], [3740, 6924], [3722, 6935], [3734, 6941], [3752, 6967], [3758, 6986], [3817, 6992], [3832, 6976], [3842, 6977], [3849, 6961], [3878, 6936], [3883, 6904], [3904, 6881], [3904, 6865], [3875, 6862], [3835, 6873], [3792, 6873], [3777, 6866], [3746, 6863]]]
            }
        }, {
            "type": "Feature",
            "id": "GN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.26,
                "hc-middle-y": 0.52,
                "hc-key": "gn",
                "hc-a2": "GN",
                "name": "Guinea",
                "labelrank": "3",
                "country-abbrev": "Gin.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "GIN",
                "iso-a2": "GN",
                "woe-id": "23424835",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3835, 6873], [3875, 6862], [3904, 6865], [3924, 6850], [3937, 6860], [3953, 6854], [3969, 6867], [3979, 6843], [3993, 6834], [4004, 6799], [3999, 6780], [4008, 6776], [3998, 6749], [3997, 6721], [3989, 6722], [3971, 6711], [3959, 6745], [3936, 6749], [3925, 6773], [3908, 6794], [3871, 6789], [3847, 6766], [3831, 6790], [3797, 6823], [3806, 6838], [3835, 6845], [3828, 6858], [3835, 6873]]]
            }
        }, {
            "type": "Feature",
            "id": "ZW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.81,
                "hc-middle-y": 0.43,
                "hc-key": "zw",
                "hc-a2": "ZW",
                "name": "Zimbabwe",
                "labelrank": "3",
                "country-abbrev": "Zimb.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "ZWE",
                "iso-a2": "ZW",
                "woe-id": "23425004",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4984, 5973], [5027, 5965], [5036, 5968], [5068, 6001], [5069, 6002], [5088, 6011], [5091, 6026], [5119, 6039], [5136, 6038], [5136, 6027], [5161, 6027], [5181, 6014], [5212, 6007], [5214, 5956], [5206, 5922], [5213, 5905], [5198, 5889], [5195, 5867], [5162, 5833], [5134, 5834], [5105, 5839], [5096, 5850], [5066, 5858], [5055, 5873], [5056, 5891], [5010, 5921], [4984, 5973]]]
            }
        }, {
            "type": "Feature",
            "id": "PL",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.52,
                "hc-middle-y": 0.27,
                "hc-key": "pl",
                "hc-a2": "PL",
                "name": "Poland",
                "labelrank": "3",
                "country-abbrev": "Pol.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "POL",
                "iso-a2": "PL",
                "woe-id": "23424923",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4818, 8280], [4811, 8273], [4822, 8279], [4909, 8276], [4911, 8276], [4931, 8268], [4932, 8259], [4944, 8227], [4943, 8208], [4923, 8193], [4937, 8185], [4936, 8163], [4952, 8137], [4951, 8125], [4921, 8102], [4907, 8086], [4914, 8065], [4904, 8068], [4883, 8080], [4839, 8081], [4831, 8072], [4813, 8089], [4795, 8085], [4787, 8100], [4766, 8103], [4746, 8119], [4732, 8108], [4717, 8120], [4724, 8127], [4676, 8137], [4683, 8153], [4670, 8174], [4671, 8205], [4656, 8215], [4664, 8233], [4660, 8249], [4671, 8256], [4658, 8257], [4658, 8258], [4659, 8259], [4715, 8273], [4728, 8284], [4780, 8296], [4788, 8279], [4818, 8280], [4818, 8280]]]
            }
        }, {
            "type": "Feature",
            "id": "MK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.44,
                "hc-key": "mk",
                "hc-a2": "MK",
                "name": "Macedonia",
                "labelrank": "6",
                "country-abbrev": "Mkd.",
                "subregion": "Southern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "MKD",
                "iso-a2": "MK",
                "woe-id": "23424890",
                "continent": "Europe"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[4858, 7769], [4858, 7769], [4858, 7769], [4858, 7769]]], [[[4899, 7821], [4918, 7800], [4915, 7786], [4886, 7778], [4862, 7769], [4858, 7775], [4858, 7770], [4857, 7771], [4857, 7771], [4854, 7772], [4851, 7771], [4854, 7778], [4848, 7777], [4842, 7794], [4846, 7805], [4862, 7816], [4876, 7818], [4886, 7821], [4899, 7821]]]]
            }
        }, {
            "type": "Feature",
            "id": "PY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.5,
                "hc-key": "py",
                "hc-a2": "PY",
                "name": "Paraguay",
                "labelrank": "4",
                "country-abbrev": "Para.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "PRY",
                "iso-a2": "PY",
                "woe-id": "23424917",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2639, 5781], [2636, 5769], [2629, 5738], [2630, 5735], [2629, 5734], [2624, 5700], [2595, 5675], [2585, 5680], [2553, 5674], [2529, 5681], [2511, 5679], [2527, 5717], [2542, 5738], [2536, 5746], [2505, 5759], [2469, 5783], [2441, 5789], [2413, 5813], [2392, 5838], [2403, 5874], [2403, 5889], [2419, 5917], [2470, 5928], [2497, 5928], [2524, 5912], [2525, 5901], [2535, 5877], [2530, 5843], [2569, 5838], [2576, 5843], [2599, 5825], [2605, 5784], [2628, 5789], [2639, 5781]]]
            }
        }, {
            "type": "Feature",
            "id": "BY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.5,
                "hc-key": "by",
                "hc-a2": "BY",
                "name": "Belarus",
                "labelrank": "4",
                "country-abbrev": "Bela.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "BLR",
                "iso-a2": "BY",
                "woe-id": "23424765",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4936, 8163], [4937, 8185], [4923, 8193], [4943, 8208], [4944, 8227], [4932, 8259], [4958, 8257], [4990, 8274], [5002, 8300], [5029, 8315], [5024, 8330], [5053, 8335], [5070, 8350], [5150, 8327], [5159, 8287], [5176, 8253], [5204, 8239], [5187, 8225], [5161, 8222], [5176, 8186], [5151, 8184], [5140, 8165], [5104, 8157], [5073, 8168], [5043, 8166], [4999, 8179], [4959, 8177], [4936, 8163]]]
            }
        }, {
            "type": "Feature",
            "id": "LV",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.05,
                "hc-middle-y": 0.36,
                "hc-key": "lv",
                "hc-a2": "LV",
                "name": "Latvia",
                "labelrank": "5",
                "country-abbrev": "Lat.",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "LVA",
                "iso-a2": "LV",
                "woe-id": "23424874",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5070, 8350], [5053, 8335], [5024, 8330], [4996, 8349], [4980, 8351], [4973, 8362], [4961, 8354], [4891, 8361], [4860, 8347], [4861, 8379], [4880, 8410], [4906, 8417], [4926, 8390], [4938, 8384], [4959, 8395], [4956, 8422], [4985, 8431], [5021, 8407], [5046, 8408], [5060, 8398], [5054, 8379], [5069, 8366], [5070, 8350]]]
            }
        }, {
            "type": "Feature",
            "id": "CZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.56,
                "hc-key": "cz",
                "hc-a2": "CZ",
                "name": "Czech Republic",
                "labelrank": "5",
                "country-abbrev": "Cz. Rep.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "CZE",
                "iso-a2": "CZ",
                "woe-id": "23424810",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4795, 8085], [4773, 8069], [4739, 8051], [4681, 8065], [4673, 8050], [4647, 8057], [4605, 8094], [4609, 8119], [4663, 8138], [4676, 8137], [4724, 8127], [4717, 8120], [4732, 8108], [4746, 8119], [4766, 8103], [4787, 8100], [4795, 8085]]]
            }
        }, {
            "type": "Feature",
            "id": "BF",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.64,
                "hc-middle-y": 0.41,
                "hc-key": "bf",
                "hc-a2": "BF",
                "name": "Burkina Faso",
                "labelrank": "3",
                "country-abbrev": "B.F.",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "BFA",
                "iso-a2": "BF",
                "woe-id": "23424978",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4266, 6823], [4254, 6824], [4235, 6827], [4215, 6824], [4158, 6823], [4153, 6813], [4160, 6779], [4145, 6791], [4102, 6784], [4089, 6803], [4077, 6806], [4087, 6851], [4105, 6858], [4119, 6895], [4135, 6888], [4156, 6914], [4177, 6917], [4218, 6945], [4246, 6940], [4244, 6929], [4269, 6884], [4286, 6872], [4304, 6871], [4310, 6850], [4299, 6836], [4282, 6838], [4266, 6823]]]
            }
        }, {
            "type": "Feature",
            "id": "NA",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.33,
                "hc-middle-y": 0.37,
                "hc-key": "na",
                "hc-a2": "NA",
                "name": "Namibia",
                "labelrank": "3",
                "country-abbrev": "Nam.",
                "subregion": "Southern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "NAM",
                "iso-a2": "NA",
                "woe-id": "23424987",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4929, 5978], [4954, 5983], [4984, 5973], [4954, 5967], [4935, 5953], [4926, 5967], [4858, 5957], [4858, 5846], [4829, 5845], [4829, 5760], [4829, 5644], [4803, 5627], [4753, 5635], [4743, 5657], [4726, 5639], [4702, 5659], [4691, 5679], [4670, 5766], [4664, 5836], [4635, 5880], [4610, 5933], [4594, 5952], [4587, 5989], [4610, 5990], [4628, 5999], [4651, 5985], [4784, 5985], [4793, 5975], [4853, 5966], [4929, 5978]]]
            }
        }, {
            "type": "Feature",
            "id": "NE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.64,
                "hc-middle-y": 0.53,
                "hc-key": "ne",
                "hc-a2": "NE",
                "name": "Niger",
                "labelrank": "3",
                "country-abbrev": "Niger",
                "subregion": "Western Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "NER",
                "iso-a2": "NE",
                "woe-id": "23424906",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4593, 7202], [4637, 7191], [4659, 7174], [4681, 7186], [4687, 7139], [4711, 7104], [4704, 7091], [4696, 7000], [4663, 6965], [4636, 6924], [4641, 6904], [4620, 6898], [4607, 6885], [4577, 6894], [4538, 6890], [4524, 6878], [4496, 6881], [4470, 6893], [4444, 6883], [4427, 6902], [4402, 6909], [4361, 6897], [4360, 6883], [4347, 6869], [4346, 6844], [4323, 6865], [4310, 6850], [4304, 6871], [4286, 6872], [4269, 6884], [4244, 6929], [4246, 6940], [4268, 6942], [4279, 6951], [4343, 6953], [4363, 6985], [4364, 7068], [4410, 7077], [4460, 7120], [4593, 7202]]]
            }
        }, {
            "type": "Feature",
            "id": "LY",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.39,
                "hc-key": "ly",
                "hc-a2": "LY",
                "name": "Libya",
                "labelrank": "3",
                "country-abbrev": "Libya",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "LBY",
                "iso-a2": "LY",
                "woe-id": "23424882",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4681, 7186], [4659, 7174], [4637, 7191], [4593, 7202], [4580, 7226], [4535, 7244], [4535, 7258], [4517, 7283], [4530, 7295], [4526, 7320], [4533, 7338], [4529, 7378], [4513, 7410], [4520, 7414], [4542, 7436], [4538, 7452], [4560, 7475], [4581, 7486], [4579, 7510], [4604, 7498], [4633, 7501], [4687, 7484], [4696, 7460], [4713, 7447], [4752, 7441], [4802, 7415], [4822, 7423], [4834, 7446], [4827, 7463], [4846, 7489], [4877, 7502], [4893, 7502], [4921, 7492], [4920, 7482], [4950, 7471], [4976, 7470], [4981, 7460], [4973, 7451], [4977, 7432], [4968, 7412], [4976, 7380], [4976, 7155], [4976, 7094], [4947, 7094], [4947, 7078], [4711, 7200], [4681, 7186]]]
            }
        }, {
            "type": "Feature",
            "id": "TN",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.42,
                "hc-middle-y": 0.09,
                "hc-key": "tn",
                "hc-a2": "TN",
                "name": "Tunisia",
                "labelrank": "3",
                "country-abbrev": "Tun.",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "TUN",
                "iso-a2": "TN",
                "woe-id": "23424967",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4579, 7510], [4581, 7486], [4560, 7475], [4538, 7452], [4542, 7436], [4520, 7414], [4506, 7473], [4485, 7488], [4468, 7511], [4460, 7533], [4482, 7558], [4486, 7618], [4493, 7635], [4527, 7649], [4543, 7643], [4544, 7628], [4565, 7640], [4568, 7632], [4550, 7614], [4553, 7598], [4569, 7578], [4552, 7555], [4538, 7547], [4544, 7527], [4566, 7530], [4569, 7511], [4579, 7510]]]
            }
        }, {
            "type": "Feature",
            "id": "BT",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.49,
                "hc-key": "bt",
                "hc-a2": "BT",
                "name": "Bhutan",
                "labelrank": "5",
                "country-abbrev": "Bhutan",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "BTN",
                "iso-a2": "BT",
                "woe-id": "23424770",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6861, 7321], [6881, 7347], [6900, 7354], [6942, 7335], [6955, 7309], [6944, 7305], [6888, 7301], [6867, 7305], [6861, 7321]]]
            }
        }, {
            "type": "Feature",
            "id": "MD",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.52,
                "hc-middle-y": 0.41,
                "hc-key": "md",
                "hc-a2": "MD",
                "name": "Moldova",
                "labelrank": "6",
                "country-abbrev": "Mda.",
                "subregion": "Eastern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "MDA",
                "iso-a2": "MD",
                "woe-id": "23424885",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5071, 7934], [5068, 7954], [5073, 7976], [5066, 7992], [5045, 8015], [5036, 8034], [5025, 8038], [5058, 8045], [5102, 8023], [5098, 8010], [5111, 8003], [5111, 7989], [5127, 7967], [5093, 7970], [5094, 7954], [5071, 7934]]]
            }
        }, {
            "type": "Feature",
            "id": "SS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.58,
                "hc-key": "ss",
                "hc-a2": "SS",
                "name": "South Sudan",
                "labelrank": "3",
                "country-abbrev": "S. Sud.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "SSD",
                "iso-a2": "SS",
                "woe-id": "-99",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5242, 6624], [5227, 6610], [5213, 6614], [5188, 6603], [5177, 6612], [5149, 6602], [5130, 6616], [5118, 6634], [5101, 6627], [5088, 6633], [5076, 6625], [5049, 6649], [5039, 6669], [5019, 6678], [5017, 6695], [4987, 6715], [4972, 6740], [4953, 6743], [4952, 6755], [4964, 6761], [4979, 6802], [5001, 6806], [5023, 6780], [5062, 6782], [5067, 6774], [5090, 6774], [5125, 6802], [5147, 6786], [5161, 6788], [5195, 6825], [5186, 6853], [5219, 6859], [5218, 6819], [5240, 6799], [5244, 6778], [5241, 6748], [5220, 6748], [5214, 6729], [5234, 6725], [5264, 6695], [5282, 6657], [5295, 6656], [5299, 6635], [5284, 6647], [5253, 6635], [5242, 6624]]]
            }
        }, {
            "type": "Feature",
            "id": "CF",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.47,
                "hc-middle-y": 0.46,
                "hc-key": "cf",
                "hc-a2": "CF",
                "name": "Central African Republic",
                "labelrank": "4",
                "country-abbrev": "C.A.R.",
                "subregion": "Middle Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "CAF",
                "iso-a2": "CF",
                "woe-id": "23424792",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4717, 6565], [4714, 6583], [4687, 6610], [4668, 6654], [4664, 6677], [4674, 6683], [4696, 6721], [4728, 6731], [4734, 6722], [4760, 6734], [4788, 6736], [4804, 6755], [4803, 6765], [4842, 6768], [4902, 6823], [4914, 6821], [4937, 6790], [4932, 6758], [4952, 6755], [4953, 6743], [4972, 6740], [4987, 6715], [5017, 6695], [5019, 6678], [5039, 6669], [5049, 6649], [5021, 6648], [4994, 6658], [4986, 6647], [4962, 6649], [4927, 6635], [4915, 6641], [4903, 6623], [4846, 6629], [4821, 6651], [4802, 6644], [4786, 6627], [4789, 6602], [4754, 6609], [4728, 6601], [4717, 6565]]]
            }
        }, {
            "type": "Feature",
            "id": "NZ",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.24,
                "hc-middle-y": 0.82,
                "hc-key": "nz",
                "hc-a2": "NZ",
                "name": "New Zealand",
                "labelrank": "2",
                "country-abbrev": "N.Z.",
                "subregion": "Australia and New Zealand",
                "region-wb": "East Asia & Pacific",
                "iso-a3": "NZL",
                "iso-a2": "NZ",
                "woe-id": "23424916",
                "continent": "Oceania"
            },
            "geometry": {
                "type": "MultiPolygon",
                "coordinates": [[[[9271, 5057], [9242, 5025], [9202, 5027], [9193, 5021], [9198, 5005], [9180, 4999], [9188, 5014], [9185, 5039], [9157, 5038], [9149, 5053], [9163, 5077], [9205, 5118], [9244, 5134], [9286, 5169], [9296, 5199], [9307, 5202], [9315, 5230], [9334, 5242], [9344, 5215], [9365, 5228], [9365, 5215], [9377, 5195], [9350, 5157], [9334, 5145], [9344, 5124], [9324, 5129], [9292, 5109], [9288, 5086], [9271, 5057]]], [[[9463, 5272], [9432, 5221], [9407, 5204], [9389, 5215], [9407, 5250], [9399, 5263], [9364, 5281], [9388, 5301], [9396, 5337], [9381, 5376], [9383, 5391], [9371, 5388], [9344, 5423], [9332, 5447], [9343, 5450], [9349, 5430], [9367, 5430], [9387, 5410], [9385, 5397], [9405, 5390], [9425, 5372], [9430, 5342], [9472, 5330], [9488, 5345], [9505, 5339], [9497, 5311], [9485, 5292], [9471, 5293], [9456, 5280], [9463, 5272]]]]
            }
        }, {
            "type": "Feature",
            "id": "CU",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.67,
                "hc-middle-y": 0.64,
                "hc-key": "cu",
                "hc-a2": "CU",
                "name": "Cuba",
                "labelrank": "3",
                "country-abbrev": "Cuba",
                "subregion": "Caribbean",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "CUB",
                "iso-a2": "CU",
                "woe-id": "23424793",
                "continent": "North America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[1948, 7089], [1967, 7108], [1959, 7116], [1938, 7116], [1925, 7126], [1920, 7114], [1900, 7127], [1904, 7141], [1867, 7157], [1827, 7161], [1825, 7176], [1799, 7177], [1787, 7165], [1806, 7143], [1797, 7138], [1780, 7161], [1765, 7160], [1747, 7148], [1751, 7166], [1785, 7186], [1821, 7192], [1879, 7188], [1903, 7167], [1918, 7171], [1929, 7172], [1983, 7130], [2011, 7125], [2014, 7116], [2036, 7112], [2050, 7096], [2010, 7090], [1992, 7094], [1948, 7089]]]
            }
        }, {
            "type": "Feature",
            "id": "VE",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.44,
                "hc-middle-y": 0.25,
                "hc-key": "ve",
                "hc-a2": "VE",
                "name": "Venezuela",
                "labelrank": "3",
                "country-abbrev": "Ven.",
                "subregion": "South America",
                "region-wb": "Latin America & Caribbean",
                "iso-a3": "VEN",
                "iso-a2": "VE",
                "woe-id": "23424982",
                "continent": "South America"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[2136, 6849], [2119, 6842], [2129, 6815], [2113, 6789], [2131, 6766], [2145, 6786], [2129, 6818], [2171, 6837], [2175, 6859], [2186, 6837], [2209, 6837], [2236, 6808], [2285, 6813], [2296, 6802], [2329, 6797], [2355, 6813], [2390, 6816], [2412, 6813], [2388, 6808], [2402, 6785], [2404, 6795], [2447, 6776], [2444, 6762], [2470, 6751], [2476, 6743], [2455, 6729], [2452, 6711], [2461, 6709], [2435, 6692], [2430, 6673], [2448, 6652], [2453, 6645], [2424, 6625], [2389, 6618], [2388, 6606], [2369, 6616], [2333, 6616], [2346, 6605], [2351, 6572], [2371, 6571], [2348, 6546], [2319, 6533], [2306, 6519], [2289, 6521], [2268, 6536], [2258, 6570], [2239, 6585], [2255, 6600], [2238, 6633], [2239, 6655], [2249, 6682], [2192, 6680], [2172, 6705], [2114, 6708], [2102, 6720], [2105, 6745], [2087, 6773], [2075, 6769], [2087, 6788], [2089, 6807], [2117, 6843], [2136, 6849]]]
            }
        }, {
            "type": "Feature",
            "id": "MG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.45,
                "hc-middle-y": 0.48,
                "hc-key": "mg",
                "hc-a2": "MG",
                "name": "Madagascar",
                "labelrank": "3",
                "country-abbrev": "Mad.",
                "subregion": "Eastern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "MDG",
                "iso-a2": "MG",
                "woe-id": "23424883",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5700, 5975], [5661, 5851], [5652, 5830], [5642, 5788], [5628, 5753], [5571, 5733], [5538, 5752], [5528, 5770], [5530, 5800], [5514, 5837], [5523, 5866], [5551, 5907], [5551, 5921], [5539, 5954], [5535, 5983], [5550, 6006], [5550, 6021], [5585, 6028], [5640, 6055], [5661, 6105], [5676, 6104], [5692, 6148], [5712, 6116], [5728, 6044], [5721, 6028], [5703, 6041], [5710, 6011], [5697, 5989], [5700, 5975]]]
            }
        }, {
            "type": "Feature",
            "id": "IS",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.65,
                "hc-middle-y": 0.5,
                "hc-key": "is",
                "hc-a2": "IS",
                "name": "Iceland",
                "labelrank": "3",
                "country-abbrev": "Iceland",
                "subregion": "Northern Europe",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "ISL",
                "iso-a2": "IS",
                "woe-id": "23424845",
                "continent": "Europe"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[3578, 8735], [3530, 8739], [3596, 8746], [3574, 8753], [3591, 8764], [3556, 8772], [3535, 8764], [3516, 8769], [3540, 8782], [3548, 8803], [3567, 8793], [3578, 8797], [3557, 8814], [3574, 8816], [3611, 8792], [3606, 8772], [3623, 8762], [3630, 8778], [3642, 8782], [3646, 8799], [3667, 8781], [3669, 8797], [3684, 8803], [3699, 8791], [3700, 8802], [3721, 8792], [3730, 8801], [3753, 8802], [3752, 8818], [3776, 8812], [3786, 8800], [3807, 8796], [3802, 8780], [3833, 8770], [3841, 8748], [3811, 8716], [3768, 8703], [3750, 8691], [3716, 8683], [3687, 8669], [3644, 8676], [3614, 8692], [3570, 8689], [3570, 8700], [3591, 8701], [3599, 8716], [3581, 8723], [3578, 8735]]]
            }
        }, {
            "type": "Feature",
            "id": "EG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.5,
                "hc-middle-y": 0.66,
                "hc-key": "eg",
                "hc-a2": "EG",
                "name": "Egypt",
                "labelrank": "2",
                "country-abbrev": "Egypt",
                "subregion": "Northern Africa",
                "region-wb": "Middle East & North Africa",
                "iso-a3": "EGY",
                "iso-a2": "EG",
                "woe-id": "23424802",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[5268, 7390], [5250, 7334], [5219, 7361], [5217, 7375], [5198, 7405], [5193, 7393], [5202, 7373], [5230, 7336], [5243, 7299], [5287, 7216], [5292, 7184], [5327, 7155], [5161, 7155], [4976, 7155], [4976, 7380], [4968, 7412], [4977, 7432], [4973, 7451], [4981, 7460], [5046, 7450], [5096, 7433], [5135, 7455], [5170, 7453], [5186, 7440], [5216, 7446], [5232, 7442], [5248, 7449], [5267, 7398], [5268, 7390]]]
            }
        }, {
            "type": "Feature",
            "id": "LK",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.54,
                "hc-middle-y": 0.93,
                "hc-key": "lk",
                "hc-a2": "LK",
                "name": "Sri Lanka",
                "labelrank": "3",
                "country-abbrev": "Sri L.",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "LKA",
                "iso-a2": "LK",
                "woe-id": "23424778",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6605, 6778], [6597, 6784], [6621, 6775], [6652, 6723], [6651, 6694], [6616, 6674], [6601, 6680], [6595, 6700], [6593, 6737], [6605, 6778]]]
            }
        }, {
            "type": "Feature",
            "id": "BW",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.6,
                "hc-key": "bw",
                "hc-a2": "BW",
                "name": "Botswana",
                "labelrank": "4",
                "country-abbrev": "Bwa.",
                "subregion": "Southern Africa",
                "region-wb": "Sub-Saharan Africa",
                "iso-a3": "BWA",
                "iso-a2": "BW",
                "woe-id": "23424755",
                "continent": "Africa"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[4829, 5760], [4829, 5845], [4858, 5846], [4858, 5957], [4926, 5967], [4935, 5953], [4954, 5967], [4984, 5973], [5010, 5921], [5056, 5891], [5055, 5873], [5066, 5858], [5096, 5850], [5105, 5839], [5071, 5824], [5058, 5807], [5036, 5794], [5031, 5775], [5002, 5760], [4994, 5733], [4972, 5726], [4919, 5743], [4910, 5721], [4878, 5693], [4850, 5693], [4854, 5716], [4840, 5751], [4829, 5760]]]
            }
        }, {
            "type": "Feature",
            "id": "KG",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.49,
                "hc-middle-y": 0.43,
                "hc-key": "kg",
                "hc-a2": "KG",
                "name": "Kyrgyzstan",
                "labelrank": "4",
                "country-abbrev": "Kgz.",
                "subregion": "Central Asia",
                "region-wb": "Europe & Central Asia",
                "iso-a3": "KGZ",
                "iso-a2": "KG",
                "woe-id": "23424864",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6332, 7748], [6353, 7745], [6396, 7767], [6382, 7770], [6355, 7790], [6346, 7779], [6309, 7795], [6341, 7816], [6332, 7818], [6333, 7829], [6358, 7839], [6407, 7824], [6409, 7846], [6427, 7854], [6457, 7840], [6474, 7842], [6552, 7841], [6570, 7836], [6605, 7816], [6604, 7810], [6550, 7788], [6542, 7776], [6503, 7772], [6499, 7761], [6471, 7750], [6468, 7762], [6446, 7757], [6421, 7741], [6411, 7720], [6381, 7719], [6370, 7712], [6347, 7726], [6327, 7718], [6318, 7726], [6283, 7723], [6281, 7731], [6303, 7747], [6319, 7741], [6332, 7748]], [[6322, 7734], [6318, 7735], [6321, 7731], [6325, 7733], [6322, 7734]], [[6356, 7736], [6356, 7739], [6353, 7737], [6354, 7737], [6356, 7736]], [[6338, 7741], [6332, 7743], [6334, 7735], [6339, 7736], [6338, 7741]]]
            }
        }, {
            "type": "Feature",
            "id": "NP",
            "properties": {
                "hc-group": "admin0",
                "hc-middle-x": 0.52,
                "hc-middle-y": 0.55,
                "hc-key": "np",
                "hc-a2": "NP",
                "name": "Nepal",
                "labelrank": "3",
                "country-abbrev": "Nepal",
                "subregion": "Southern Asia",
                "region-wb": "South Asia",
                "iso-a3": "NPL",
                "iso-a2": "NP",
                "woe-id": "23424911",
                "continent": "Asia"
            },
            "geometry": {
                "type": "Polygon",
                "coordinates": [[[6838, 7338], [6834, 7314], [6840, 7302], [6815, 7290], [6771, 7297], [6736, 7312], [6734, 7321], [6680, 7326], [6654, 7338], [6615, 7364], [6600, 7369], [6610, 7399], [6628, 7413], [6660, 7417], [6662, 7408], [6692, 7394], [6703, 7380], [6719, 7382], [6749, 7352], [6767, 7353], [6775, 7339], [6792, 7346], [6810, 7337], [6838, 7338]]]
            }
        }]
}
})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('statGeoService', statGeoService);

    /** @ngInject */
    function statGeoService(msApi, $q, StatsFiltreQuery, userManager) {


        var self = this;
        //    Initially the name is unknown....
        self.query_geo_per_pays = [];
        self.result_geo_per_pays = [];

        //////////
        var user = userManager.getUser();
        console.log( user);
        var channels= (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);

        function stats_geo_per_pays(query) {
            var empStatsQuery = angular.copy(query);
            delete empStatsQuery.range;
            var deferred = $q.defer();
            var filtre_query=StatsFiltreQuery.filtre_query(self.query_geo_per_pays, empStatsQuery);
            //    If we already have the name, we can resolve the promise.
            if (filtre_query.index !== -1) {
                deferred.resolve(self.result_geo_per_pays[filtre_query.index]);
            } else {
                if (!empStatsQuery.canal){
                  empStatsQuery.canal=channels.join(',');
                }
              msApi.request(
                    'stats.geo_per_pays@save', {"empStatsQuery" : empStatsQuery},
                    function (res) {
                        if (res.code === 200) {
                            var item_query = angular.copy(filtre_query.query);
                            self.query_geo_per_pays.push(item_query);
                            var resultat = getResult(res);
                            self.result_geo_per_pays.push(resultat);
                            deferred.resolve(resultat);
                        }
                    },
                    function () {
                    }
                );
            }
            return deferred.promise;
        }

        function getResult(res) {
            var values = res.values;
            var geo_per_pays_map = {};
            var geo_per_pays_bar = {};
            var max=100;
            try {
                geo_per_pays_map = values.countriesMap;
            }
            catch (e) {
            }
            try {
                geo_per_pays_bar = values.visits_dis;
            }
            catch (e) {
            }
            try {
                max = values.max;
            }
            catch (e) {
            }
            return {
                geo_per_pays_map: geo_per_pays_map,
                geo_per_pays_bar: geo_per_pays_bar,
                max: max,
                enabled: max > 0

            };

        }

        return {
            stats_geo_per_pays: stats_geo_per_pays

        };

    }
}());

(function ()
{
    'use strict';


    /** @ngInject */
function config(msApiProvider)
{
    // Api
    msApiProvider.register('stats.geo_per_pays',  [Routing.generate('api_geo_post_geo_per_pays')]);

}

angular.module('app.stats.graphe')
    .config(config)
    .run(fetchRights);

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*geo).*$",
                name_module: "stats_geo",
                name_angular_module: "app.stats.graphe",
                actions: ["geo_per_pays"]
            };
            msRights.setPermissionsStats(permissions);
        }
    }

})();


(function ()
{
    'use strict';
var mapGeoStats = {
    templateUrl: 'app/main/stats/charts/components/ChartView/audience-widget.html',
    controller: MapGeoWidgetController,
    bindings: {
        chartConfig: '<',
        query: '<'
    }
};


angular.module('app.stats.graphe')
    .controller('MapGeoWidgetController', MapGeoWidgetController)
    .component('mapGeoStats', mapGeoStats)
    ;

    function MapGeoWidgetController($rootScope, $injector, TableWidgetService, chartWidgetService, statGeoService, exportChartService) {
    var vm = this;
    var $translate = $injector.get('$translate');
    vm.chart_title ="VISITSWIDGETSTATS.stat_geolocalisation";

    //function
    vm.viewInTable = viewInTable;
    vm.viewInPie = viewInPie;
    vm.changeSeries = changeSeries;
    vm.viewInBar= viewInBar;
        vm.exportChart= exportChart;
        vm.title= "Pays";
    //
    var query_clone;
    var geo_per_pays_bar;
        vm.chartConfig = chartWidgetService.chart_map();
        $rootScope.$on('$translateChangeSuccess', function () {
            poll()
        });
    var poll = function () {
        vm.chartConfig = chartWidgetService.chart_map();
        vm.chartConfig.loding_disabled = false;
        if($rootScope.vod_id) vm.query.vod_id=$rootScope.vod_id
        statGeoService.stats_geo_per_pays(vm.query).then(
            function (result) {
                geo_per_pays_bar = result.geo_per_pays_bar;
                vm.chartConfig.series[0].data = result.geo_per_pays_map;
                vm.chartConfig.colorAxis.max = result.max;
                vm.chartConfig.loding_disabled = true;
                vm.enabled = result.enabled;
                vm.id_bar = "bar_map_geo";

            },
            function () {
              vm.chartConfig.loding_disabled = true;
              vm.enabled = false;
            });
    };

    this.$onInit = function () {
        query_clone = angular.copy(vm.query);
        vm.viewInBar();
        poll();
    };

    this.$doCheck = function () {
        var verif = angular.equals(query_clone, vm.query);
        if (!verif) {
            query_clone = angular.copy(vm.query);
            poll();
        }
    };
    function viewInTable() {

        vm.showGraphBar = false;
        vm.showGraphTable = true;
        vm.showGraphPie = false;

        var categories = Object.keys(geo_per_pays_bar.visits);
        var values_visits = Object.keys(geo_per_pays_bar.visits).map(function(e) {
            return geo_per_pays_bar.visits[e]
        });
        var values_uniq_visits = Object.keys(geo_per_pays_bar.uniq_visits).map(function(e) {
            return geo_per_pays_bar.uniq_visits[e]
        });
        var series = [{name: $translate.instant('VISITSMESURESTATS.stat_visits'), data: values_visits}
            , {name: $translate.instant('VISITSMESURESTATS.stat_visits_unique'), data: values_uniq_visits}];

        vm.graphe = TableWidgetService.getTableMap(series, categories, vm.title);

    }

    function viewInPie() {
        vm.showGraphBar = false;
        vm.showGraphTable = false;
        vm.showGraphPie = true;
        vm.id_pie = "pie_map_geo";
        vm.pieConfig = chartWidgetService.chart_pie(null, vm.title);
        var values_visits = Object.keys(geo_per_pays_bar.visits).map(function(e) {
            return geo_per_pays_bar.visits[e]
        });
        var values_uniq_visits = Object.keys(geo_per_pays_bar.uniq_visits).map(function(e) {
            return geo_per_pays_bar.uniq_visits[e]
        });
        vm.series = [{name: $translate.instant('VISITSMESURESTATS.stat_visits'), data: values_visits}
            , {name: $translate.instant('VISITSMESURESTATS.stat_visits_unique'), data: values_uniq_visits}];
        vm.pieConfig.list_select = chartWidgetService.getSeriesName(vm.series);
        vm.selectedSerieName = vm.pieConfig.list_select[0].val;
        getPieBySeriesId(0);

    }


    function changeSeries() {
        var id = vm.selectedSerieName;
        getPieBySeriesId(id);
    }

    function getPieBySeriesId(id) {
        vm.pieConfig.series[0].name = vm.pieConfig.list_select[id].option;
      vm.pieConfig.series[0].duration = vm.pieConfig.list_select[id].duration;
      var categories = Object.keys(geo_per_pays_bar.visits);

        vm.pieConfig.series[0].data = chartWidgetService.getDataPie(vm.series [id].data, categories);
    }

    function viewInBar() {
        vm.showGraphBar = true;
        vm.showGraphTable = false;
        vm.showGraphPie = false;
    }

        function exportChart(type_export) {
            var chart = getChart();
            if(chart) {
                if (type_export == "pdf") {
                    exportChartService.exportPdf(chart, "geolocalisation", vm.query);
                } else if (type_export == "image") {
                    exportChartService.exportImage(chart, "geolocalisation", vm.query);
                } else if (type_export == "excel") {
                    exportChartService.exportExcel(chart, "geolocalisation", vm.query,  vm.title);
                }
            }
        }

        function getChart() {
            var data = Highcharts.charts.filter(function (element) {
                return element !== undefined;
            });
            var chart;
            if (vm.showGraphPie) {
                chart = data.filter(function (element) {
                    return element.renderTo.id === "pie_map_geo";
                });
            }
            else {
                chart = data.filter(function (element) {
                    return element.renderTo.id === "bar_map_geo";
                });
            }
            return chart[0];
        }

}

})();

(function () {
    'use strict';

    angular
        .module('app.stats.export_vod_live.tab',
            [
                'mdPickers'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        var parentStates = [
            {
                state: 'stats_export_vod_by_id',
                url: '/export/export_vod/:token',
                template: 'app/main/stats/export/vod_live/stat.vod.html',
                permission: "vod_by_id"
            },
            {
                state: 'stats_export_vod_secure_by_id',
                url: '/export/export_vod_secure/:token',
                template: 'app/main/stats/export/vod_live/stat.vod.html',
                permission: "vod_by_id"
            },
            {
                state: 'stats_export_event_by_id',
                url: '/export/export_event/:token',
                template: 'app/main/stats/export/vod_live/stat.vod.html',
                permission: "live_by_id"
            }

        ];

        var tabStates = [
            {
                state: 'audience',
                url: '/audience',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.audience.html'
            },
            {
                state: 'technologie',
                url: '/technologie',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.technologie.html'
            },
            {
                state: 'engagement',
                url: '/engagement',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.engagement.html'
            },
            {
                state: 'geo',
                url: '/geo',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.geo.html'
            },
            {
                state: 'mobile',
                url: '/mobile',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.mobile.html'
            },
            {
                state: 'temp_reel',
                url: '/temps_reel',
                template: 'app/main/stats/export/vod_live/tabStats/stat.vod.temp_reel.html'
            }
        ];
        parentStates.forEach(function (valueParent) {

            tabStates.forEach(function (valueTabs) {
                $stateProvider.state('app.' + valueParent.state + '.' + valueTabs.state, {
                    url: valueTabs.url,
                    views: {
                        "": {
                            templateUrl: valueTabs.template,
                            controller: 'ExportVodLiveTabsStatsController as vm'
                        }
                    },
                    resolve: {
                        query: function (query_vod_audience) {
                            return query_vod_audience;
                        },
                        permission: function () {
                            return valueParent.permission;
                        }
                    }
                });

            })
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.stats.export_vod_live.tab')
        .controller('ExportVodLiveTabsStatsController', ExportVodLiveTabsStatsController);

    /** @ngInject */
    function ExportVodLiveTabsStatsController($rootScope, query, ExportStatsVodLiveService, webTvGlobal, $state, $stateParams, permission) {
        var vm = this;
        vm.query = ExportStatsVodLiveService.getQuery();
        vm.permission = permission;
        var query_service = getQuery();
        var existType = false;
        ExportStatsVodLiveService.verifQuery(query_service);
        // Data
        $rootScope.types = getListType($rootScope.types_all);

        if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && existType){
            var q = {};
            q.type = $rootScope.types_query;
            ExportStatsVodLiveService.setQuery(q);
        }

        vm.isById = angular.isDefined($rootScope.vod_id);
        $rootScope.showExportSecureStats = true;
        function getListType(types_all) {
            var state_neme = $state.current.name;
            var listType = {};
            if (state_neme.indexOf("mobile") > 0) {
                angular.forEach(types_all, function (value, key) {
                    if (value.indexOf("mobile") > 0) {
                        listType[key] = value;
                    }
                });
            }
            else {
                listType = types_all;
            }
            listType = getConvertToSelectWithNone(listType);
            angular.forEach(listType, function (value, key) {
                if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && value.val===$rootScope.types_query){
                    existType = true;
                }
            });
            return listType;
        }

        function getConvertToSelectWithNone(choices) {
            var result = [];
            if (angular.isDefined(choices)) {
                if (angular.isUndefined(choices.none)) {
                    var types = angular.isDefined(choices) ? Object.values(choices).join(',') : "0";
                    result.push({val: types, option: "none", options: "none"});
                }
                var data = webTvGlobal.convertToSelectChoicesFormat(choices);
                for (var i = 0; i < data.length; i++) {
                    result.push(data[i]);
                }
            }
            return result;
        }

        function getQuery() {

            var query_service = angular.copy(query);

            if (angular.isDefined($stateParams.id)) {
                query_service.vod_id = $stateParams.id;
            }
            else {
                delete  query_service.vod_id;
            }
            return query_service;
        }

    }
})();

(function () {
  'use strict';
  /** @ngInject */

  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m-1, 1);
  var lastDay = new Date(y, m + 1, 0);

  var card_right = {
    audience: {title: "Audience", option: "vm.audience.audience.options", data: "vm.audience.audience.data"},
    duree: {title: "Duree", option: "vm.audience.duree.options", data: "vm.audience.duree.data"},
    pourcentage: {
      title: "Pourcentage",
      option: "vm.audience.pourcentage.options",
      data: "vm.audience.pourcentage.data"
    }
  };
  var query_vod_audience = {
    is_vod: true,
    is_live: false,
    is_range: true,
    dateIn: firstDay,
    dateOut: lastDay,
    range: "1d"

  };

  var query_vod_time_reel = {
    is_vod: true,
    is_live: false
  };



  angular
    .module('app.stats.export_vod_live.tab')
    .constant('card_right', card_right)
    .constant('query_vod_audience', query_vod_audience)
    .constant('query_vod_time_reel', query_vod_time_reel)



})();

(function () {
    'use strict';

    angular
        .module('app.media.video.add_externel', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_video_add_externel', {
                url: "/medias/videos/add/:title",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/add_edit_external.template.html',
                        controller: 'mediaVideoAddExternelController as vm'
                    }
                },
                resolve: {
                    videoMetaData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video_external.getExternal@save', {urlExternal: $stateParams.title});
                    },
                    videoData: function (msApi) {
                        return msApi.resolve('media_video_external.getData@get', {id: 0});
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    }
                },
                "bodyClass": "forms"
            });

        //API
        msApiProvider.register('media_video_external.getExternal', [Routing.generate('api_media_get_external_video_info')]);
        msApiProvider.register('media_video_external.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_themes.getSelectChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input')]);
        msApiProvider.register('media_video_external.addVideo', [Routing.generate('api_media_post_add_video')]);
        msApiProvider.register('parameters_themes.getThumbs', [Routing.generate('api_parameters_get_themes_thumbs')]);
        msApiProvider.register('media_video_external.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_external_link', {
            externalLink: ':externalLink',
            y: ':y'
        }).replace(/%3A/g, ":")])


    }
})();

(function () {
  'use strict';
  angular
    .module('app.media.video.add_externel')
    .controller('mediaVideoAddExternelController', mediaVideoAddExternelController);

  /** @ngInject */
  function mediaVideoAddExternelController($scope, userManager, videoData,contributorsData, $injector, videoMetaData, $cookies, themesThumbs, $mdConstant,webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */

    var $rootScope = $injector.get('$rootScope'),
      webTvGlobal = $injector.get('webTvGlobal'),
      $sce = $injector.get('$sce'),
      $timeout = $injector.get('$timeout'),
      $translate = $injector.get('$translate'),
      $stateParams = $injector.get('$stateParams'),
      $state = $injector.get('$state'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');

    var vm = this,
      t1 = moment();

      vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];
    vm.isNew = true;
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
    else vm.testMultiLangue = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
    else vm.testIntranetInternet = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
    else vm.testNotificationClient = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
    else vm.testMultiFormat = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_general_condition)) var testCondition = webTvGlobal.$constant().webTvParameterBag().video_general_condition;
    else var testCondition = '0';
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];


        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
      (function (contributors, data) {

        contributors['none'] = "0";
        for (var i = 0; i < data.length; i++) {
          contributors[data[i].name] = data[i].id;
        }
        return contributors;
      })({}, contributorsData.contributors)
    );

    var user = userManager.getUser();

    vm.empMediaVideoForm = {};
    vm.sendPushNotifications = 0;
    vm.minDate = undefined;
    vm.changeDate = changeDate;
    // vm.showVideoDetail = showVideoDetail;
    // vm.getTitle = getTitle;
    vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
    // vm.setNone = setNone;
    vm.imageNameTranscription = "";
    vm.setEmptyPassword = setEmptyPassword;
    vm.returnToList = returnToList;

    vm.playerIsLoading = 0;
    vm.showPlayer = 0;
    vm.playerLink = "";
    vm.filesChips = [];
    vm.filesChipsTranscription = [];
    var filesChips = [];
    var fileChipsTranscription = [] ;
    var filesUrl = [];

    var tabFiles = [];
    /**
     * Upload File (NG FLOW) Parameters and methods
     */
    vm.videoThumb = null;
    $scope.someModel = null;
    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    $scope.currentNavItem = "page1";
    $scope.goto = function(page) {
      $scope.status = "Goto " + page;
    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {flow: {}};
    // Methods
    vm.fileAdded = fileAdded;
    vm.fileAddedTranscription = fileAddedTranscription;
    vm.uploadFile = uploadFile;
    vm.uploadFileTranscription = uploadFileTranscription;
    vm.fileSuccess = fileSuccess;
    vm.fileSuccessTranscription = fileSuccessTranscription;
    vm.fileError = fileError;
    vm.fileErrorTranscription = fileErrorTranscription;
    vm.uploadComplete = uploadComplete;
    vm.uploadCompleteTranscription = uploadCompleteTranscription;
    vm.showCondtionTerms = showCondtionTerms;
    vm.testVignette = testVignette;

    function testVignette() {
      if (angular.isDefined(vm.selectedThumbs[0])) {
        vm.videoThumb = vm.selectedThumbs[0];
      }
    }


    vm.selectThemes = selectThemes;
    initHelp();

    function initHelp() {
      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
        $rootScope.titre3 = "";
      } else {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
      }
      $rootScope.pageRoute = "app.media_video_list_ongoing";
      $rootScope.welcome = "welcome_video";
      $rootScope.text = [{
        texte: "parameters_video_add_help"
      }, {
        texte: "upload_button_video_external_add_help"
      }, {
        texte: "send_button_video_add_help"
      }, {
        texte: "cancel_button_video_add_help"
      }];
    }

    String.prototype.toSeconds = function () {
      var sec_num = this.split(':');
      var hour = parseInt(sec_num[0]);
      var minute = parseInt(sec_num[1]);
      var seconds = parseInt(sec_num[2]);
      return seconds + minute * 60 + hour * 3600;
    };


    function selectThemes(test, themeModel) {

      vm.empMediaVideoForm.themes = [];
      var themes=[];

        var canalTheme = [];
      angular.forEach(themeModel, function (value) {
          value=value.toString();
        themes.push(value.substring(value.indexOf('-') + 1, value.length));
          canalTheme.push(value);
      });
        vm.theme=canalTheme;
        vm.empMediaVideoForm.themes=themes;
      vm.setSelectedThumbs();
      if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
        vm.videoThumb = vm.selectedThumbs[0];
      }
      else if (vm.imageFrom === 'theme') {
        vm.videoThumb = vm.empMediaVideoForm.logo;


      }


    }

    vm.imageName = "";
    vm.uploadingInPogress = 0;
    vm.themesThumbs = themesThumbs.thumbs;
    vm.selectedThumbs = [];
    vm.setSelectedThumbs = setSelectedThumbs;
    // vm.productImageStyle = {
    //     width: "100px",
    //     height: "100px",
    //     "max-height": "100px"
    // };
    // vm.innerThumbStyle = {
    //     position: 'relative',
    //     width: '200px',
    //     height: '200px',
    //     border: '1px solid rgba(0, 0, 0, 0.12)',
    //     margin: '8px'
    // };
    // vm.productImageMediaStyle = {cursor: "pointer"};
    // vm.setAndPreviewThumb = setAndPreviewThumb;
    // vm.loadingGeneratedThumbs = 0;
    // vm.errorOnGettingGeneratedThumbs = 0;
    // vm.generatedThumbs = [];
    // vm.getGeneratedThumbs = getGeneratedThumbs;
    // vm.requestThumbs = requestThumbs;
    // vm.regenerateThumbs = regenerateThumbs;
    // vm.requestNumber = 0;
    // vm.numberofGeneratedThumbs = 5;

    // function requestThumbs() {
    //     vm.loadingGeneratedThumbs = 1;
    //     vm.errorOnGettingGeneratedThumbs = 0;
    //     vm.requestNumber = 0;
    //     var duration = vm.videoMetaData.all.format.duration;
    //     switch (true) {
    //         case (duration <= 300 ):
    //             vm.numberofGeneratedThumbs = 5;
    //             break;
    //         case (duration > 300 && duration <= 600 ):
    //             vm.numberofGeneratedThumbs = 4;
    //             break;
    //         case (duration > 600 && duration <= 900 ):
    //             vm.numberofGeneratedThumbs = 3;
    //             break;
    //         case (duration > 900 && duration <= 1200 ):
    //             vm.numberofGeneratedThumbs = 2;
    //             break;
    //         default:
    //             vm.numberofGeneratedThumbs = 1;
    //             break;
    //
    //     }
    //
    //     if (angular.isDefined(vm.empMediaVideoForm.validity)) vm.empMediaVideoForm.validity = null;
    //     for (var i = 0; i < vm.numberofGeneratedThumbs; i++) {
    //         vm.getGeneratedThumbs(1);
    //     }
    // }

    // function regenerateThumbs() {
    //     vm.getGeneratedThumbs(1);
    // }
    //
    // function getGeneratedThumbs(nbr) {
    //     if (angular.isUndefined(nbr)) nbr = 0;
    //
    //     var requestData = {"title": $stateParams.title};
    //     if (nbr) requestData.nbr = nbr;
    //     msApi.request('media_video.getAutoGeneratedThumbs@get',
    //         requestData,
    //         function (res) {
    //             vm.requestNumber++;
    //             var data = angular.fromJson(res.response);
    //             if (data.thumbnails.length) {
    //                 for (var i = 0; i < data.thumbnails.length; i++) {
    //                     vm.generatedThumbs.push(data.path_to_thumbnail + "/" + data.thumbnails[i]);
    //                 }
    //                 vm.empMediaVideoForm.logo = vm.generatedThumbs[0];
    //                 vm.videoThumb = vm.generatedThumbs[0];
    //             }
    //             if (!nbr || vm.requestNumber === vm.numberofGeneratedThumbs) {
    //                 $timeout(function () {
    //                     vm.loadingGeneratedThumbs = 0;
    //                     vm.errorOnGettingGeneratedThumbs = 0;
    //                     vm.empMediaVideoForm.validity = 1;
    //                 });
    //             }
    //         },
    //         function () {
    //             vm.loadingGeneratedThumbs = 0;
    //             vm.errorOnGettingGeneratedThumbs = 1;
    //             vm.empMediaVideoForm.validity = 1;
    //             vm.requestNumbe = vm.numberofGeneratedThumbs;
    //         }
    //     );
    // }

    function setSelectedThumbs() {
      vm.selectedThumbs = [];
      var selectedThumbs=[];
      if (angular.isArray(vm.empMediaVideoForm.themes)) {
        for (var i = 0; i < vm.empMediaVideoForm.themes.length; i++) {
          if (angular.isDefined(vm.themesThumbs[vm.empMediaVideoForm.themes[i]]) && vm.themesThumbs[vm.empMediaVideoForm.themes[i]] !== "") selectedThumbs.push(vm.themesThumbs[vm.empMediaVideoForm.themes[i]]);
        }
          vm.selectedThumbs=selectedThumbs
      }
    }

    // function setAndPreviewThumb(thumb, choix) {
    //     if (choix === 'theme')
    //         vm.empMediaVideoForm.logo = thumb.split('/').pop();//.replace(rx,"");
    //     else
    //         vm.empMediaVideoForm.logo = thumb;//.replace(rx,"");
    //     vm.videoThumb = thumb;
    // }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      vm.imageName = file.name;

    }
    function fileAddedTranscription(file) {
      if (!/(doc|docx|html|htm|odt|pdf|xls|xlsx|ods|ppt|pptx|txt)$/.test(file.getExtension().toLowerCase())) {
        vm.imageNameTranscription = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_document_message'));
        return false;
      }
      vm.imageNameTranscription = file.name;
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }
    function uploadFileTranscription() {
      // Set headers
      vm.ngFlowFileTranscripton.flow.upload();
      vm.inProgress = true;
    }


    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.videoThumb = res.location.url;
      }

    }

    function fileSuccessTranscription(file, message) {
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.imageNameTranscription = file.name
        fileChipsTranscription.push(res.location.path);
        vm.filesChipsTranscription.push(file.relativePath);
        filesUrl.push(res.location.url);
      }

    }

    function fileError() {
      vm.uploadingInPogress = 0;
      vm.imageName = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }
    function fileErrorTranscription() {
      vm.uploadingInPogress = 0;
      vm.imageNameTranscription = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }


    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (vm.imageName) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
      }

    }
    function uploadCompleteTranscription() {
      if (vm.imageNameTranscription) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageNameTranscription}));
      }

    }


    /**
     * End Ng Flow
     */


    fillData();

    function makeid(length) {
      var result           = '';
      var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      var charactersLength = characters.length;
      for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * 
   charactersLength));
     }
     return result;
  }

    function getPlayerLink() {
      msApi.request(
        'media_video_external.getPreviewLinkByTitle@get',
        {"externalLink": $stateParams.title,"y":"bo"},
        function (res) {
          if (res.code === 200) {
            vm.showPlayer = 1;
            vm.playerIsLoading = 0;
            vm.playerLink = $sce.trustAsResourceUrl(res.link);


          }
          else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      ).then(function () {
        // vm.requestThumbs();
      });
    }

    function splitKeyWords(chain) {
      var words = chain.split(' ') || [];
      words = words.filter(function (item, pos) {
        return words.indexOf(item) === pos;
      });
      return words;
    }

    function testMp4() {
      if (/\.mp4$/.test($stateParams.title)) {
        vm.playerIsLoading = 1;
        getPlayerLink()
      }
      else vm.requestThumbs();
    }

    function fillData() {

      if (videoMetaData.code === 200 && videoMetaData.data.video && videoMetaData.data.video.duration) {
        vm.empMediaVideoForm = {
          "fileTitle": makeid(10),
          "title": videoMetaData.data.video.title,
          "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
          "insertDate": new Date(t1.format('YYYY-MM-DD HH:mm:ss')),
          "startDate": new Date(t1.format('YYYY-MM-DD')),
          "endDate": new Date(moment().add(10, "years").format('YYYY-MM-DD')),
          "duration": new Date(moment.utc(videoMetaData.data.video.duration.toSeconds() * 1000).format('YYYY-MM-DD HH:mm:ss')),
          "themes": [],
          "secure": videoData.secure ? 1 : 0,
          "downloadable": videoData.downloadable ? 1 : 0,
          "offline": videoData.offline ? 1 : 0,
          "description": videoMetaData.data.video.description,
          "transcription": null,
          "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
          "contributor": user.id,
          "author": "",
          "copyright": "",
          "keyWords": videoMetaData.data.video.tags,
          "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
          "isVisibleOnInternet": videoData.isVisibleOnInternet,
          "passwordInternet": null,
          "logo": videoMetaData.data.video.thumbnails,
          "mainPage": videoData.mainPage ? 1 : 0,
          "metaData": "",
          "externalLinkVideo": $stateParams.title,
          "mdTime": {
            start: new Date(t1.format('YYYY-MM-DD')),
            end: new Date(moment().add(10, "years").format('YYYY-MM-DD'))
          },
          'validity': null
        };
        //vm.minDate = vm.empMediaVideoForm.mdTime.start;
        if (vm.testMultiLangue === '1') {
          vm.language = $translate.preferredLanguage();

        }
        getPlayerLink();
        vm.videoThumb = videoMetaData.data.video.thumbnails || "";
      }
      else {
          if ($stateParams.title.indexOf("youtube")>-1)
              $rootScope.uploadMetaDataExternalError = "youtube";
          else if ($stateParams.title.indexOf("dailymotion")>-1)
              $rootScope.uploadMetaDataExternalError = "dailymotion";
          else $rootScope.uploadMetaDataExternalError = true;
        $rootScope.index = 1;
        $state.go('app.media_video_upload');
      }
    }


    // function setNone() {
    //     if (!vm.empMediaVideoForm.useTheme) vm.empMediaVideoForm.themes = [];
    // }

    function setEmptyPassword() {
      if (!vm.empMediaVideoForm.isSecuredOnInternet) vm.empMediaVideoForm.passwordInternet = null;
    }

    // /**
    //  * Return Imported Video Title if exists
    //  * @return string title
    //  */
    // function getTitle() {
    //     return vm.empMediaVideoForm.title || "";
    // }

    /**
     * set The selected in the form appropriate field
     * @param copyFrom  from where
     * @param pasteIn to whom the date will be setted
     */
    function changeDate(copyFrom, pasteIn) {
      if (angular.isDefined(vm.empMediaVideoForm[pasteIn]) && angular.isDefined(vm.empMediaVideoForm.mdTime[copyFrom])) vm.empMediaVideoForm[pasteIn] = vm.empMediaVideoForm.mdTime[copyFrom];
    }

    /**
     *
     * @param  {[type]} formData [description]
     * @return {[type]}          [description]
     */
    function preapreFormDataToSend(formData) {
      var formFormattedData = formData;
      if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
      /**
       * convert null to empty string loop
       */
      for (var attr in formFormattedData) {
        if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
        if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
        if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

      }
      if (formFormattedData.contributor === "0") formFormattedData.contributor = null;
      if (angular.isDefined(formFormattedData.keyWords))
        formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
      return formFormattedData;
    }

    function cleanArray(array) {
      var i, j, len = array.length, out = [], obj = {};
      for (i = 0; i < len; i++) {
        obj[array[i]] = 0;
      }
      for (j in obj) {
        out.push(j);
      }
      return out;
    }
      vm.selectChip = selectChip;
      vm.deleteAddedChip = deleteAddedChip;

      function deleteAddedChip(chip) {
          vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);

      }

      function selectChip(chip) {
          window.open(filesUrl[vm.filesChips.indexOf(chip)],'_blank');
      }
      vm.testExtension=testExtension;
      function testExtension(file) {
          var extn = file.split(".").pop();
          if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(extn.toLowerCase())) {
             return "video";
          } else
          if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
              return "audio";
          }
          else
          if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
              return "excel";
          }
          else
          if (/(doc|docx)$/i.test(extn.toLowerCase())) {
              return "word";
          }
          else
          if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
              return "image";
          }
          else
          if (/(pdf)$/i.test(extn.toLowerCase())) {
              return "pdf";
          }
          else
              return "other";


      }
    /**
     * Send add Video Form
     */

    function submitAddMediaVideoForm() {
      vm.empMediaVideoForm.logo = vm.videoThumb;
      angular.forEach(vm.filesChips, function (value, index) {
        tabFiles.push({"title": filesChips[index], "fileName": value});
      });
      angular.forEach(vm.filesChipsTranscription, function (value, index) {
        tabFiles.push({
          "title": fileChipsTranscription[index],
          "fileName": value,
          "mimeType": vm.imageNameTranscription ? "transcription" : ""
        });
      });
      var formData = preapreFormDataToSend(angular.copy(vm.empMediaVideoForm));
      formData.themes = cleanArray(vm.empMediaVideoForm.themes);
        if(vm.empMediaVideoForm.themes.length<=0) {
            formData.mainPage = false;
        }
      formData.filesVideo = tabFiles;
      if (formData.title === " ") {
        vm.empMediaVideoForm.title = "";
        formData.title = "";
      }

      formData.medias = [];
      formData.medias.push({lang: vm.language});
      // if (formData.isVisibleOnIntranet === "") delete formData.isVisibleOnIntranet;
      // if (formData.isVisibleOnInternet === "") delete formData.isVisibleOnInternet;
      formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
      formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet

      var state_type="ongoing";
      if (formData.offline) {
        state_type="offline";
      }

      if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
      }
      else if (angular.isDefined(formData.validity)) delete formData.validity;
     if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
       msApi.request('media_video_external.addVideo@save',
        {"empMediaVideoForm": formData, 'sendPushNotif': vm.sendPushNotifications},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('MediaVideoAdd', {title: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : "VID"});
            $state.go('app.media_video_list', {type: state_type});
          }
          else if (angular.isDefined(res.errors)) {

            vm.empMediaVideoError = [];
            vm.errors = res.errors;
            vm.errors.forEach(function (item) {

              vm.empMediaVideoForm[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empMediaVideoForm[item.for])
              };
            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );}
    }

    function returnToList() {
      $state.go('app.media_video_list', {type: "ongoing"});
    }

    /**
     * Open Imported Video Detail dialog
     * @param ev
     */
    // function showVideoDetail(event) {
    //     $mdDialog.show({
    //         controller: 'mediaVideoMetaModalController',
    //         controllerAs: 'vm',
    //         templateUrl: 'app/main/media/video/list/modal.template.html',
    //         parent: angular.element($document.find('#content-container')),
    //         targetEvent: event,
    //         clickOutsideToClose: true,
    //         locals: {
    //             metaData: videoMetaData.data.video,
    //             mdDialogTitle: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : (videoMetaData.data.video.basic.title ? videoMetaData.data.video.basic.title : vm.empMediaVideoForm.fileTitle)
    //
    //         }
    //     });
    // }

    vm.files = [];
    vm.ngFlowOptionsFile = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    // ngFlow Option Transcription
    vm.ngFlowOptionsFileTranscription = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]',
      query:{
        mimeType:"transcription",
      },
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
      //attributes: 'image/*',
      //testMethod: false,

    };
    vm.ngFlowFileTranscripton = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };

    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlowFile = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };
    vm.filefAdded = filefAdded;
    vm.filefSuccess = filefSuccess;
    vm.uploadfComplete = uploadfComplete;
    vm.filefProgress = filefProgress;
    vm.uploadFilef = uploadFilef;
    vm.cancelUploadf = cancelUploadf;
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressf = false;
    vm.filesChips = [];
      var filesChips=[];
      var filesUrl=[];
    var tabFiles = [];

    function cancelUploadf() {
      $timeout(function () {
        vm.ngFlowFile.flow.cancel();

      });
    }

    function filefAdded(file) {

      vm.fileName = file.name;

    }

    function filefProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    function uploadFilef() {
      // Set headers
      vm.ngFlowFile.flow.upload();
      vm.inProgressf = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filefSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
          filesChips.push(res.location.path);
          vm.filesChips.push(file.relativePath);
          filesUrl.push(res.location.url);

      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadfComplete() {
      vm.progressBarValue = 0;
      vm.inProgressf = false;

    }


    function showCondtionTerms(ev) {
      if (testCondition === "1") {
        if ($cookies.get('WEBTV.locale') === "fr") {
          vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_fr
        }
        else {
          vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_en

        }
        $mdDialog.show({
          controller: conditionsTermsController,
          templateUrl: 'app/main/media/video/condition-terms.modal.html',
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: true
          // fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
        })
          .then(function (answer) {

          }, function () {

          })
      }
      else {
        vm.submitAddMediaVideoForm();
      }
    }

    function conditionsTermsController($scope, $mdDialog) {
      $scope.text = vm.text;
      $scope.cancel = function () {
        $mdDialog.hide();
      };
      $scope.accept = function () {
        $mdDialog.hide();
        vm.submitAddMediaVideoForm();
      };
    }
  }

})();


(function () {
    'use strict';

    angular
        .module('app.media.video.edit_external', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_video_edit_external', {
                url: "/editExternal",
                parent: 'app.access_rapid',
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/add_edit_external.template.html',
                        controller: 'mediaVideoEditExternalController as vm'
                    }
                },
                resolve: {
                    videoMetaData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video_external.getTransodedMetaData@get', {id: $stateParams.id});
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    themesByChannels: function (msApi) {
                        return msApi.resolve('parameters_theme.getThemesByChannelAndParent@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "media_video_post_edit_action"
            });


        // Translation

        //API
        msApiProvider.register('media_video_external.getTransodedMetaData', [Routing.generate('api_media_get_transcoded_video_meta_data', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video_external.getExternal', [Routing.generate('api_media_get_external_video_info')]);
        msApiProvider.register('media_video_external.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video_external.generateThumb', [Routing.generate('api_media_get_video_transcoded_auto_generated_thumbs', {idVideo: ':idVideo'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video_external.editVideo', [Routing.generate('api_media_post_edit_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_themes.getSelectChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input')]);
        msApiProvider.register('parameters_themes.getThumbs', [Routing.generate('api_parameters_get_themes_thumbs')]);
        msApiProvider.register('media_video_external.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_external_link', {externalLink: ':externalLink'}).replace(/%3A/g, ":")])
        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_group_by_themes') + "/:list";
        msApiProvider.register('parameters_theme.getThemesByChannelAndParent', [themesByChannelsAndParent, {list: '@list'}]);
        msApiProvider.register('media_video.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);



    }
})();

(function () {
  'use strict';
  angular
    .module('app.media.video.edit_external')
    .controller('mediaVideoEditExternalController', mediaVideoEditExternalController);

  /** @ngInject */
  function mediaVideoEditExternalController(webTvGlobal,$cookies,$location, videoMetaData, videoData, contributorsData, $injector, themesByChannels, $timeout, $scope,themesThumbs, $mdConstant,webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */
    var $rootScope = $injector.get('$rootScope'),
      $sce = $injector.get('$sce'),
      $translate = $injector.get('$translate'),
      $stateParams = $injector.get('$stateParams'),
      $state = $injector.get('$state'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');

    var url = $location.url();
    var urlToken = url.slice(url.lastIndexOf("/")+1,url.length);

    var vm = this;
    vm.urlToken = urlToken;
    vm.allThemes = themesByChannels;
    vm.isNew = false;
    var tabTheme = [];
    var tabIdThemes = [];
    vm.download = download;
    vm.imageNameTranscription = "";
    vm.filesChips = [];
    vm.filesChipsTranscription = [];
    var filesChips = [];
    var fileChipsTranscription = [] ;
    var filesUrl = [];
    var filesUrlTranscription = [];
    var tabFiles = [];
    var idCanal;
      vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];
    $scope.currentNavItem = "page1";
    $scope.goto = function(page) {
      $scope.status = "Goto " + page;
    };
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
    else vm.testMultiLangue = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
    else vm.testIntranetInternet = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
    else vm.testNotificationClient = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
    else vm.testMultiFormat = '0';

    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];


        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
      (function (contributors, data) {

        contributors['none'] = "0";
        for (var i = 0; i < data.length; i++) {
          contributors[data[i].name] = data[i].id;
        }
        return contributors;
      })({}, contributorsData.contributors)
    );


    vm.empMediaVideoForm = {};
    vm.sendPushNotifications = 0;
    // vm.showVideoDetail = showVideoDetail;
    vm.minDate = undefined;
    vm.changeDate = changeDate;
    // vm.getTitle = getTitle;
    vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
    // vm.setNone = setNone;
    vm.setEmptyPassword = setEmptyPassword;
    vm.returnToList = returnToList;

    vm.selectThemes = selectThemes;
    vm.playerIsLoading = 0;
    vm.showPlayer = 0;
    vm.playerLink = "";
    vm.showCondtionTerms = showCondtionTerms;
    vm.testVignette = testVignette;

    function testVignette() {
      if (angular.isDefined(vm.selectedThumbs[0])) {
        vm.videoThumb = vm.selectedThumbs[0];
      }
    }

    /**
     * Upload File (NG FLOW) && Vignette Tabs Parameters and methods
     */

    vm.imageFrom = "generated";
    vm.videoThumb = null;


    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}


    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {flow: {}};
    // Methods

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    initHelp();

    function initHelp() {
      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
        $rootScope.titre3 = "";
      }else{
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_video";
      $rootScope.text = [{

        texte: "parameters_video_add_help"
      }, {
        texte: "upload_button_video_external_add_help"
      }, {
        texte: "send_button_video_add_help"
      }, {
        texte: "cancel_button_video_add_help"
      }];

    }
    if($cookies.get('WEBTV.locale') === 'fr'){
      $('#datepicker').datepicker({
        format : 'dd-mm-yyyy',
      });
    }else if($cookies.get('WEBTV.locale') === 'en'){
      $('#datepicker').datepicker({
        format : 'mm-dd-yyyy',
      });
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      vm.imageName = file.name;
    }
    function fileAddedTranscription(file) {
      if (!/(doc|docx|html|htm|odt|pdf|xls|xlsx|ods|ppt|pptx|txt)$/.test(file.getExtension().toLowerCase())) {
        vm.imageNameTranscription = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_document_message'));
        return false;
      }
      vm.imageNameTranscription = file.name;
    }

    function download() {
      var last = filesUrlTranscription.pop();
      window.location.href = last;
      // var filter = {};
      // filter.length = filtre.length;
      // filter.start = filtre.start;
      // filter.searchWord = vm.word;
      // filter.idTheme = vm.res;
      // filter.idChannel = vm.canal;
      // filter.uniqueVisits = true;
      // if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
      //   filter.startDate = moment(vm.startDate).format("YYYY-MM-DD");
      // }
      // else {
      //   filter.startDate = "";
      // }
      // if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
      //   filter.endDate = moment(vm.endDate).format("YYYY-MM-DD");
      // }
      // else {
      //   filter.endDate = "";
      // }
      // msApi.request("stats_list_video.exportXls@get", filter,
      //   function (response) {
      //     if (response.code === 200) {
      //       window.location.href = filesUrlTranscription[0];
      //     }
      //     else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
      //   });
    }

    function uploadFile() {
      // Set headers
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }
    function uploadFileTranscription() {
      // Set headers
      vm.ngFlowFileTranscripton.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */

    function fileSuccess(file, message) {
      $scope.empMediaVideoForm.$pristine = false;
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.videoThumb = res.location.url;
      }

    }


    function fileSuccessTranscription(file, message) {
      $scope.empMediaVideoForm.$pristine = false;
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.videoThumb = res.location.url;
        vm.imageNameTranscription = file.name
        fileChipsTranscription.push(res.location.path);
        vm.filesChipsTranscription.push(file.relativePath);
        filesUrlTranscription.push(res.location.url);
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */

    function uploadComplete() {
      if (vm.imageName) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
      }

    }
    function uploadCompleteTranscription() {
      if (vm.imageNameTranscription) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageNameTranscription}));
      }

    }

    // Methods
    vm.fileAdded = fileAdded;
    vm.fileAddedTranscription = fileAddedTranscription;
    vm.uploadFile = uploadFile;
    vm.uploadFileTranscription = uploadFileTranscription;
    vm.fileSuccess = fileSuccess;
    vm.fileSuccessTranscription = fileSuccessTranscription;
    vm.fileError = fileError;
    vm.fileErrorTranscription = fileErrorTranscription;
    vm.uploadComplete = uploadComplete;
    vm.uploadCompleteTranscription = uploadCompleteTranscription;
    // var currentTime = 0;
    // vm.takeVignette = takeVignette;
    // vm.goToTop = goToTop;
    //
    // function goToTop(value) {
    //
    //     if (value === "top") {
    //         $location.hash('div1');
    //
    //         // call $anchorScroll()
    //         $anchorScroll();
    //     }
    //
    //
    // }
    //
    // function takeVignette() {
    //     var requestData = {"idVideo": vm.videoData.id};
    //     document.getElementById('player_add').contentWindow.postMessage({
    //         "fn": "getCurrentTime",
    //         "params": []
    //     }, "*");
    //     var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    //     var eventer = window[eventMethod];
    //     var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    //     eventer(messageEvent, function (e) {
    //         currentTime = e.data.value[0];
    //         requestData.nbr = 1;
    //         requestData.timecode = transformSecTOTime(currentTime);
    //         msApi.request('media_video.generateThumb@get',
    //             requestData,
    //             function (res) {
    //
    //                 var data = angular.fromJson(res.response);
    //                 vm.empMediaVideoForm.logo = (data.path_to_thumbnail + "/" + data.thumbnails);
    //                 vm.videoThumb = (data.path_to_thumbnail + "/" + data.thumbnails);
    //
    //             });
    //
    //     }, false);
    //
    //
    // }
    //
    // function transformSecTOTime(s) {
    //     var secs = s % 60;
    //     s = (s - secs) / 60;
    //     var mins = s % 60;
    //     var hrs = (s - mins) / 60;
    //     return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
    // }
    //

    vm.imageName = "";
    // vm.imageBaseUrl = "";

    vm.uploadingInPogress = 0;
    vm.themesThumbs = themesThumbs.thumbs;
    vm.selectedThumbs = [];
    vm.setSelectedThumbs = setSelectedThumbs;
    // vm.productImageStyle = {
    //     width: "100px",
    //     height: "100px",
    //     "max-height": "100px"
    // };
    // vm.productImageMediaStyle = {cursor: "pointer"};
    vm.innerThumbStyle = {
      position: 'relative',
      width: '200px',
      height: '200px',
      border: '1px solid rgba(0, 0, 0, 0.12)',
      margin: '8px'
    };
    // vm.setAndPreviewThumb = setAndPreviewThumb;
    // vm.loadingGeneratedThumbs = 0;
    // vm.errorOnGettingGeneratedThumbs = 0;
    // vm.generatedThumbs = [];
    // vm.requestThumbs = requestThumbs;
    // vm.getGeneratedThumbs = getGeneratedThumbs;
    // vm.regenerateThumbs = regenerateThumbs;
    // vm.requestNumber = 0;
    // vm.numberofGeneratedThumbs = 5;
    //
    // function requestThumbs() {
    //     vm.loadingGeneratedThumbs = 1;
    //     vm.errorOnGettingGeneratedThumbs = 0;
    //     vm.requestNumber = 0;
    //     var duration = moment.utc(vm.videoData.duration.replace(/\+\d+$/, "")).format('HH:mm:ss').toSeconds();
    //     switch (true) {
    //         case (duration <= 300 ):
    //             vm.numberofGeneratedThumbs = 5;
    //             break;
    //         case (duration > 300 && duration <= 600 ):
    //             vm.numberofGeneratedThumbs = 4;
    //             break;
    //         case (duration > 600 && duration <= 900 ):
    //             vm.numberofGeneratedThumbs = 3;
    //             break;
    //         case (duration > 900 && duration <= 1200 ):
    //             vm.numberofGeneratedThumbs = 2;
    //             break;
    //         default:
    //             vm.numberofGeneratedThumbs = 1;
    //             break;
    //
    //     }
    //     if (angular.isDefined(vm.empMediaVideoForm.validity)) vm.empMediaVideoForm.validity = null;
    //
    //     for (var i = 0; i < vm.numberofGeneratedThumbs; i++) {
    //         vm.getGeneratedThumbs(1);
    //     }
    // }
    //
    // function regenerateThumbs() {
    //     vm.getGeneratedThumbs(1);
    // }
    //
    // function getGeneratedThumbs(nbr) {
    //     if (angular.isUndefined(nbr)) nbr = 0;
    //     var pattern = new RegExp("_" + $stateParams.id);
    //
    //     var requestData = {"title": $stateParams.title.replace(pattern, "")};
    //     if (nbr) requestData.nbr = nbr;
    //     msApi.request('media_video.getAutoGeneratedThumbs@get',
    //         requestData,
    //         function (res) {
    //             vm.requestNumber++;
    //             var data = angular.fromJson(res.response);
    //             if (data.thumbnails.length) {
    //                 for (var i = 0; i < data.thumbnails.length; i++) {
    //                     vm.generatedThumbs.push(data.path_to_thumbnail + "/" + data.thumbnails[i]);
    //                 }
    //             }
    //             vm.loadingGeneratedThumbs = 0;
    //             vm.errorOnGettingGeneratedThumbs = 0;
    //             vm.empMediaVideoForm.validity = 1;
    //
    //
    //         },
    //         function () {
    //             vm.loadingGeneratedThumbs = 0;
    //             vm.errorOnGettingGeneratedThumbs = 1;
    //             vm.empMediaVideoForm.validity = 1;
    //             vm.requestNumbe = vm.numberofGeneratedThumbs;
    //
    //         }
    //     );
    // }

    function setSelectedThumbs() {
      vm.selectedThumbs = [];
        var selectedThumbs = [];
      if (angular.isArray(vm.empMediaVideoForm.themes)) {
        for (var i = 0; i < vm.empMediaVideoForm.themes.length; i++) {
          if (angular.isDefined(vm.themesThumbs[vm.empMediaVideoForm.themes[i]]) && vm.themesThumbs[vm.empMediaVideoForm.themes[i]] !== "") selectedThumbs.push(vm.themesThumbs[vm.empMediaVideoForm.themes[i]]);
        }
          vm.selectedThumbs=selectedThumbs;
      }
    }

    // function setAndPreviewThumb(thumb) {
    //     vm.empMediaVideoForm.logo = thumb;
    //     vm.videoThumb = thumb;
    // }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */


    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */


    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */


    function fileError() {
      vm.uploadingInPogress = 0;
      vm.imageName = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }

    function fileErrorTranscription() {
      vm.uploadingInPogress = 0;
      vm.imageNameTranscription = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */


    /**
     * End Ng Flow
     */
    fillData();


    function getPlayerLink() {
      msApi.request(
        'media_video.getPreviewLink@get',
        {"id": $stateParams.id,"y":"bo"},
        function (res) {
          if (res.code === 200) {
            vm.showPlayer = 1;
            vm.playerIsLoading = 0;
            vm.playerLink = $sce.trustAsResourceUrl(res.link);
          }
          else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      ).then(function () {
        // vm.requestThumbs();
      });
    }

    function getThemesIds(list, data) {
      for (var i = 0; i < data.length; i++) {
        list.push(data[i].id);
      }
      return list;
    }

    function splitKeyWords(chain) {
      var words = chain.split(' ') || [];
      words = words.filter(function (item, pos) {
        return words.indexOf(item) === pos;
      });
      return words;
    }

    function fillData() {
      var themes = [];
      if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
      if (videoData.isTranscoded) {
        fillSelectListThemes();
          angular.forEach(videoData.filesVideo, function (value) {
            // return value of files when edit
            if(value.mimeType === null){
              vm.filesChips.push(value.fileName);
              var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
              filesChips.push(res);
              filesUrl.push(value.title);
            }else if(value.mimeType === "transcription"){
              vm.filesChipsTranscription.push(value.fileName);
              var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
              fileChipsTranscription.push(res);
              filesUrlTranscription.push(value.title);
              vm.imageNameTranscription = value.fileName
            }

          });
        vm.empMediaVideoForm = {
          "fileTitle": videoData.fileTitle ? videoData.fileTitle : "",
          "title": videoData.title ? videoData.title : "",
          "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
          "insertDate": new Date(moment(videoData.insertDate)),
          "startDate": new Date(moment(videoData.startDate)),
          "endDate": new Date(moment(videoData.endDate)),
          "duration": new Date(moment(videoData.duration)),
          "useTheme": videoData.useTheme ? 1 : 0,
          "themes": tabTheme,
          "secure": videoData.secure ? 1 : 0,
          "downloadable": videoData.downloadable ? 1 : 0,
          "offline": videoData.offline ? 1 : 0,
          "description": videoData.description ? videoData.description : "",
          "transcription": videoData.transcription ? videoData.transcription : "",
          "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
          "contributor": videoData.contributor !== null && angular.isDefined(videoData.contributor.id) ? videoData.contributor.id : "",
          "author": videoData.author ? videoData.author : "",
          "copyright": videoData.copyright ? videoData.copyright : "",
          "keyWords": splitKeyWords(videoData.keyWords),
          "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
          "passwordInternet": videoData.passwordInternet ? videoData.passwordInternet : "",
          "logo": videoData.logo ? videoData.logo : null,
          "mainPage": videoData.mainPage ? 1 : 0,
          "metaData": videoData.metaData,
          "isVisibleOnIntranet": videoData.isVisibleOnIntranet,
          "isVisibleOnInternet": videoData.isVisibleOnInternet,
          "externalLinkVideo": videoData.externalLinkVideo,
          "mdTime": {
            start: new Date(moment(videoData.startDate)),
            end: new Date(moment(videoData.endDate))
          },
          "validity": null
        };
        angular.forEach(tabTheme, function (value) {
          value=value.toString();
          themes.push(value.substring(value.indexOf('-') + 1, value.length));
        });
        vm.empMediaVideoForm.themes= themes;
        $rootScope.itemName = vm.empMediaVideoForm.title || '';
    //    vm.minDate = vm.empMediaVideoForm.mdTime.start;
        vm.videoThumb = vm.empMediaVideoForm.logo || null;

        vm.theme = themes;
        if (videoData.isTranscoded) {
          vm.playerIsLoading = 1;
          getPlayerLink();

        }

      }
      else {
        if (videoMetaData.status === -1) {
          $rootScope.uploadMetaDataExternalError = true;
          $rootScope.index = 1;
        }
        $state.go('app.media_video_upload');
      }
    }


    // function setNone() {
    //     if (!vm.empMediaVideoForm.useTheme) vm.empMediaVideoForm.themes = [];
    // }

    function setEmptyPassword() {
      if (!vm.empMediaVideoForm.isSecuredOnInternet) vm.empMediaVideoForm.passwordInternet = null;
    }

    //
    // /**
    //  * Return Imported Video Title if exists
    //  * @return string title
    //  */
    // function getTitle() {
    //     return vm.empMediaVideoForm.title || "";
    // }

    /**
     * set The selected in the form appropriate field
     * @param copyFrom  from where
     * @param pasteIn to whom the date will be setted
     */
    function changeDate(copyFrom, pasteIn) {
      // if (angular.isDefined(vm.empMediaVideoForm[pasteIn]) && angular.isDefined(vm.empMediaVideoForm.mdTime[copyFrom])) vm.empMediaVideoForm[pasteIn] = vm.empMediaVideoForm.mdTime[copyFrom];
      if(vm.empMediaVideoForm.mdTime.end < vm.empMediaVideoForm.mdTime.start){
        vm.empMediaVideoForm.mdTime.end = vm.empMediaVideoForm.mdTime.start
      }

    }

    /**
     * return to video list page
     * @return redirect to canal list page
     */
    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go('app.media_video_list', {type: "ongoing"});
      }
      else {
        $state.go($rootScope.currentState);
      }


    }


    /**
     *
     * @param  {[type]} formData [description]
     * @return {[type]}          [description]
     */
    function preapreFormDataToSend(formData) {
      var formFormattedData = formData;
      if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
      /**
       * convert null to empty string loop
       */
      for (var attr in formFormattedData) {
        if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
        if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
        if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

      }
      if (formFormattedData.contributor === "0") formFormattedData.contributor = null;
      formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
      return formFormattedData;
    }

    function selectThemes(test, themeModel) {

      vm.empMediaVideoForm.themes = [];
      var themes=[];

        var canalTheme = [];
      angular.forEach(themeModel, function (value) {
          value=value.toString();
        themes.push(value.substring(value.indexOf('-') + 1, value.length));
          canalTheme.push(value);
      });
        vm.theme=canalTheme;
        vm.empMediaVideoForm.themes=themes;
      vm.setSelectedThumbs();
      if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
        vm.videoThumb = vm.selectedThumbs[0];
      }
      else if (vm.imageFrom === 'theme') {
        vm.videoThumb = vm.empMediaVideoForm.logo;


      }

    }


    function cleanArray(array) {
      var i, j, len = array.length, out = [], obj = {};
      for (i = 0; i < len; i++) {
        obj[array[i]] = 0;
      }
      for (j in obj) {
        out.push(j);
      }
      return out;
    }


    function exist(id, tab) {
      for (var i = 0, len = tab.length; i < len; i++) {
        if (tab[i] === id) {
          return true;
          break;
        }

      }
      return false;
    }

    function fillSelectListThemes() {
      var i = 1;


      function sousGroupe(value, index) {
        if (index === 1) {
          idCanal = value.id;
        }
        if (angular.isArray(value.themes)) {
          index = index + 1;
          angular.forEach(videoData.themes, function (v2) {
            angular.forEach(value.themes, function (v1) {
              if (v2.id === v1.id && exist(v2.id, tabIdThemes) === false) {
                tabTheme.push(idCanal + '-' + v2.id);
                tabIdThemes.push(v2.id);
              }
              else
                sousGroupe(v1, index);
            });


          });
        }

      };
      angular.forEach(themesByChannels.channels, function (value) {
        sousGroupe(value, 1);
        if (i === Object.keys(themesByChannels.channels).length) {

        }
        i++;
      });

    }
      vm.selectChip = selectChip;
      vm.deleteAddedChip = deleteAddedChip;

      function deleteAddedChip(chip) {
          vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);
          $scope.empMediaVideoForm.$pristine = false;
      }

      function selectChip(chip) {
          window.open(filesUrl[vm.filesChips.indexOf(chip)],'_blank');
      }
      vm.testExtension=testExtension;
      function testExtension(file) {
          var extn = file.split(".").pop();
          if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(extn.toLowerCase())) {
              return "video";
          } else
          if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
              return "audio";
          }
          else
          if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
              return "excel";
          }
          else
          if (/(doc|docx)$/i.test(extn.toLowerCase())) {
              return "word";
          }
          else
          if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
              return "image";
          }
          else
          if (/(pdf)$/i.test(extn.toLowerCase())) {
              return "pdf";
          }
          else
              return "other";


      }
    /**
     * Send add Video Form
     */
    function submitAddMediaVideoForm() {
      console.log("fdsfdsd12365fs",vm.filesChipsTranscription ,fileChipsTranscription  )
      vm.empMediaVideoForm.logo = vm.videoThumb;
        angular.forEach(vm.filesChips, function (value, index) {
            tabFiles.push({"title": filesChips[index], "fileName": value});
        });
         // Push transcription File
        tabFiles.push({
          "title": fileChipsTranscription.pop(),
          "fileName": vm.imageNameTranscription,
          "mimeType": vm.imageNameTranscription ? "transcription" : ""
        });

      var formData = preapreFormDataToSend(angular.copy(vm.empMediaVideoForm));
      formData.themes = cleanArray(vm.empMediaVideoForm.themes);
        if(vm.empMediaVideoForm.themes.length<=0) {
            formData.mainPage = false;
        }
      formData.filesVideo = tabFiles;
      //  // if (formData.isVisibleOnIntranet === "") formData.isVisibleOnIntranet = false;
      //  // if (formData.isVisibleOnInternet === "") formData.isVisibleOnInternet = false;
      formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
      formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet
      if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
      }
      if (angular.isDefined(formData.validity)) delete formData.validity;
      if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
      msApi.request('media_video.editVideo@save',
        {"empMediaVideoForm": formData, id: videoData.id, 'sendPushNotif': vm.sendPushNotifications},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('MediaVideoEdit', {title: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : "VID"});
            if (angular.isUndefined($rootScope.currentState)) {
              $state.go('app.media_video_list', {type: "ongoing"});
            }
            else {
              $state.go($rootScope.currentState);
            }
          }
          else if (angular.isDefined(res.errors)) {

            vm.empMediaVideoError = [];
            vm.errors = res.errors;
            vm.errors.forEach(function (item) {

              vm.empMediaVideoForm[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empMediaVideoForm[item.for])
              };
            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );}
    }


    // /**
    //  * Open Imported Video Detail dialog
    //  * @param ev
    //  */
    // function showVideoDetail(event) {
    //     var meta = {
    //         status: videoMetaData.status,
    //         all: videoMetaData.metaData
    //     };
    //     $mdDialog.show({
    //         controller: 'mediaVideoMetaModalController',
    //         controllerAs: 'vm',
    //         templateUrl: 'app/main/media/video/list/modal.template.html',
    //         parent: angular.element($document.find('#content-container')),
    //         targetEvent: event,
    //         clickOutsideToClose: true,
    //         locals: {
    //             metaData: meta,
    //             mdDialogTitle: videoData.title
    //         }
    //     });
    // }


    vm.ngFlowOptionsFile = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    vm.ngFlowOptionsFileTranscription = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]',
      query:{
        type:"transcription",
      },
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
      //attributes: 'image/*',
      //testMethod: false,

    };
    vm.ngFlowFileTranscripton = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };

    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlowFile = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };
    vm.filefAdded = filefAdded;
    vm.filefSuccess = filefSuccess;
    vm.uploadfComplete = uploadfComplete;
    vm.filefProgress = filefProgress;
    vm.uploadFilef = uploadFilef;
    vm.cancelUploadf = cancelUploadf;
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressf = false;


    function cancelUploadf() {
      $timeout(function () {
        vm.ngFlowFile.flow.cancel();

      });
    }

    function filefAdded(file) {

      vm.fileName = file.name;

    }

    function filefProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    function uploadFilef() {
      // Set headers
      vm.ngFlowFile.flow.upload();
      vm.inProgressf = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filefSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        console.log("res.location.path",res.location.path)
          filesChips.push(res.location.path);
          vm.filesChips.push(file.relativePath);
          filesUrl.push(res.location.url);

      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadfComplete() {
      vm.progressBarValue = 0;
      vm.inProgressf = false;

    }

    function showCondtionTerms(ev) {

      vm.submitAddMediaVideoForm();

    }


  }


})();

(function ()
{
    'use strict';

    angular
        .module('app.lives.pearl',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider
            .state('app.lives_pearl', {
                url    :"/lives/:id/pearl",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/pearl/template.diffusion.html',
                        controller : 'livesLivePearlController as vm'
                    }
                },
                resolve: {
                    livesData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('livesLiveDiffusion.getNewLives@get',{id:$stateParams.id,get_export:true});
                    },
                    paramsChannelpearl: function (msApi) {
                        return msApi.resolve('livesLivePeral.ParamChannel@get');
                    }
                }
            });

        msApiProvider.register('livesLiveDiffusion.getNewLives', [Routing.generate('api_get_lives_live_detail',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('livesLivePeral.startLive', [Routing.generate('api_encoder_live_start_or_end_live_channel',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('livesLiveDiffusion.syncRTC', [Routing.generate('api_sync_r_t_c')]);
        msApiProvider.register('livesLiveDiffusion.writeLog', [Routing.generate('api_write_log')]);
        msApiProvider.register('livesLiveDiffusion.urlJitsi', [Routing.generate('api_get_url_jitsi_fo',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('livesLivePeral.ParamChannel', [Routing.generate('api_encoder_live_get_param_encoder')]);
        msApiProvider.register('livesLivePeral.Updatestreaming', [Routing.generate('api_encoder_live_post_add_channel_streaming', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('livesLivePeral.status_streaming', [Routing.generate('api_encoder_live_get_status_streaming', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('livesLivePeral.get_url_live_pearl', [Routing.generate('api_encoder_live_get_url_live_pearl', {id: ':id'}).replace(/%3A/, ":")]);

    }
})();

(function () {
  'use strict';

  angular
    .module('app.lives.pearl')
    .controller('livesLivePearlController', livesLivePearlController)
    .controller('livesLiveDiffusionJitsiController', livesLiveDiffusionJitsiController);

  /** @ngInject */
  function livesLivePearlController(paramsChannelpearl, $window, webTvGlobal, $scope, livesData, $injector, swfService) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var $timeout = $injector.get('$timeout'),
      $rootScope = $injector.get('$rootScope'),
        $sce = $injector.get('$sce'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      $filter = $injector.get('$filter'),
      msApi = $injector.get('msApi');

    var vm = this;
    var livedata = livesData.data;
    vm.lives = livedata.live;
    var params = {
      Stream_name: vm.lives.streamName,
      UrlDiffusion: livedata.urlDiffusion,
      debug: false,
      live_id: vm.lives.id,
      rm: {'chapitres': [], 'chapitresTmp': [], 'slides': [], 'slidesTmp': []}
    };
    var chapters = livedata.chapters;
    var slides = livedata.slides;
    vm.url_live= "";
    vm.start = true;
    var ratio = "16/9";
    var chapterId = 0;
    var slideId = 0;
    var compteurLiveSeconde = 0;
    var swfVersionStr = "9.0.124";
    var xiSwfUrlStr = "";
    var flApp;
    var flashvars = {
      d: params.debug
    };
    var origin = window.location.origin;
    var pathname = window.location.pathname;
    var baseIndex = pathname.indexOf("/lives");
    var base = origin + pathname.slice(0, baseIndex);
    var config_object = {
      fps: 15,
      width: 460,
      height: 258,
      bdwith: 6,
      bitrate: 3,
      samplerate: 4
    };
    var counterLive;
    var parameters = {};
    var attributes = {};
    parameters.quality = "high";
    parameters.play = "true";
    parameters.loop = "false";
    parameters.wmode = "transparent";
    parameters.scale = "showall";
    parameters.menu = "false";
    parameters.devicefont = "true";
    parameters.salign = "";
    parameters.allowscriptaccess = "sameDomain";
    parameters.allowFullScreen = "true";
    attributes.id = "flApp";
    attributes.name = "flApp";
    attributes.align = "middle";

    vm.clickedVideo = false;
    vm.clickedChapter = false;
    vm.clickedSlide = false;
    vm.clickedMicro = false;
    vm.videoActivate = true;
    vm.audioActivate = true;
    vm.counter = "00:00:00";
    vm.translateStart = "LIVEDIFFUSION.start";
    vm.recordButton = "#43A047";
    vm.recordClass = "button-start-glow";
    vm.videoState = "video-on-button";
    vm.videoButtonIcon = "icon-camcorder";
    vm.audioState = "video-on-button";
    vm.audioButtonIcon = "icon-microphone";
    vm.translateVideoActivation = "LIVEDIFFUSION.disable_video";
    vm.translateAudioActivation = "LIVEDIFFUSION.disable_audio";
    vm.lowResolutionClass = "resolutionActivated";
    vm.medResolutionClass = "";
    vm.highResolutionClass = "";
    vm.normalRatioClass = "resolutionActivated";
    vm.smallRatioClass = "";
    vm.cameras = [];
    vm.cameraSelected = "";
    vm.micSelected = "";
    vm.mics = [];
    vm.activated = false;
    vm.volume = 50;
    vm.resolution = "Med";
    vm.ratioSelected = "16:9";
    vm.chapter = {};
    vm.slide = {};
    vm.chapters = [];
    vm.slides = [];
      angular.forEach(chapters, function (value) {
         var chap = {
              "ID": value.id,
             "TimeCode": value.timeCode?value.timeCode:"00:00:00",
             "Title": value.title,
             "Diffuse": false
         };
          vm.chapters.push(chap);

      });
      vm.chapters = sortValues(vm.chapters);
      angular.forEach(slides, function (value) {
          var slid = {
              "ID": value.id,
              "TimeCode": value.timeCode?value.timeCode:"00:00:00",
              "Title": value.slide,
              "Name": value.urlSlide,
              "Order": value.slideOrder,
              "Diffuse" : false
          };
          vm.slides.push(slid);
      });
      vm.slides = sortValues(vm.slides);
      vm.loading = false;
      vm.channelId= paramsChannelpearl.data.params.pearl_id_channel;
      vm.statusStreaming = "stopped";
      $rootScope.loadingProgress = true;
      vm.showLoading = false;
      vm.permalien_live = livedata.permalien_live;
      vm.height_iframe = "99%";
      vm.errorPage=false;
      msApi.request('livesLivePeral.status_streaming@get', {id: vm.channelId},
          function (res) {
              $rootScope.loadingProgress = false;
              if(!angular.isDefined(res.data.status_streaming[0])){
                  vm.errorPage = true;
              }else {
                  if (angular.isDefined(res.data.status_streaming[0]) && res.data.status_streaming[0].status)
                      vm.statusStreaming = res.data.status_streaming[0].status.state;
                  if (vm.statusStreaming === "started") {
                      compteurLiveSeconde = res.data.status_streaming[0].status.duration;
                      vm.counter = transformSecTOTime(compteurLiveSeconde);
                      counterLive = $timeout(vm.compteur, 1000);
                      vm.start = false;
                      vm.showLoading = true;
                      msApi.request('livesLivePeral.get_url_live_pearl@get', {id: vm.channelId},
                          function (res) {
                              vm.showLoading = false;
                              vm.activated = true;
                              vm.url_live = $sce.trustAsResourceUrl(res.data.url_live);
                              rearrangeplayer();
                          }, function () {

                          }
                      );

                  }
              }
          },function () {
              vm.errorPage = true;
          }
      );
      function transformSecTOTime(s) {
          var secs = s % 60;
          s = (s - secs) / 60;
          var mins = s % 60;
          var hrs = (s - mins) / 60;
          return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
      }

      function rearrangeplayer() {
          var width = document.getElementById('content-live').offsetWidth;
          var height = (width * 9) / 16;
          vm.height_iframe = height +"px";
      }

    vm.recordingStart = recordingStart;
    vm.videoActivation = videoActivation;
    vm.audioActivation = audioActivation;
    vm.resolutionChange = resolutionChange;
    vm.ratioChange = ratioChange;
    vm.volumeChanged = volumeChanged;
    vm.audioSelect = audioSelect;
    vm.videoSelect = videoSelect;
    vm.compteur = compteur;
    vm.clickVideoListItem = clickVideoListItem;
    vm.clickChapterListItem = clickChapterListItem;
    vm.clickSlideListItem = clickSlideListItem;
    vm.clickMicroListItem = clickMicroListItem;
    vm.addSlide = addSlide;
    vm.addChapter = addChapter;
    vm.confirmDeleteChapter = confirmDeleteChapter;
    vm.confirmDeleteSlide = confirmDeleteSlide;
    vm.modifyChapter = modifyChapter;
    vm.broadcastSlide = broadcastSlide;
    vm.broadcastChapter = broadcastChapter;
    vm.slideBroadcasted = slideBroadcasted;
    vm.modifySlide = modifySlide;


    window.connexion = connexion;
    window.deconnexion = deconnexion;
    window.demarrerLesServices = demarrerLesServices;
    window.fireError = fireError;
    window.listCams = listCams;
    window.listMics = listMics;
    window.write_log = write_log;

    function write_log(msg) {
        msApi.request('livesLiveDiffusion.writeLog@save',
            {
                file_log: "encoder_flash_",
                message: msg
            },
            function (res) {
            })
    }


    // $scope.$on('$viewContentLoaded', function () {
    //   var flashVersion = swfService.getFlashPlayerVersion();
    //   if (flashVersion.major > 0 || flashVersion.minor > 0 || flashVersion.release > 0) {
    //     $timeout(function () {
    //       swfService.embedSWF(
    //         base + "/app/swf/encoder.swf", "flashContent",
    //         "900", "670",
    //         swfVersionStr, xiSwfUrlStr,
    //         flashvars, parameters, attributes
    //       );
    //       vm.activated = true;
    //       flApp = document.getElementById("flApp");
    //     }, 5000);
    //   } else {
    //     //Flash is not installed
    //     var confirm = $mdDialog.confirm()
    //       .title($translate.instant('MESSAGES.alert_error'))
    //       .htmlContent($translate.instant('LIVEDIFFUSION.alert_flash_not_found'))
    //       .ariaLabel($translate.instant('LIVEDIFFUSION.alert_flash_not_found'))
    //       .ok($translate.instant('LIVEDIFFUSION.install_flash'))
    //       .cancel($translate.instant('MESSAGES.dialog_cancel'));
    //     $mdDialog.show(confirm).then(function () {
    //       $window.open('https://get.adobe.com/flashplayer');
    //     })
    //   }
    //
    // });

    function connexion() {
      flApp.connexion();
    }

    function deconnexion() {
      flApp.deconnexion();
    }

    function syncStreamInfo() {
      var data = params.UrlDiffusion + "\trecord\t" + params.Stream_name;
      flApp = document.getElementById("flApp");
      flApp.connexion(data);
    }

    function demarrerLesServices(i) {
      if (i === 1) {
        syncStreamInfo();
      } else if (i === 2) {
        resolutionChange()
      }

    }

    function fireError(state) {
      webTvGlobal.alertDialog(state);

    }

    function recordingStart() {
        $rootScope.loadingProgress=true;
      if (vm.start) {
          msApi.request('livesLivePeral.Updatestreaming@save', {id: vm.channelId, get_server_pearl:1,liveId:vm.lives.id},
              function (res) {
                  vm.url_live = $sce.trustAsResourceUrl(res.data.url_live);
                  msApi.request('livesLivePeral.startLive@get', {id: vm.channelId, idLive:vm.lives.id,start:1},
                    function () {
                        $rootScope.loadingProgress = false;
                        vm.activated = true;
                        vm.statusStreaming = "started";
                        rearrangeplayer();
                      webTvGlobal
                        .$toast()
                        .showSimple($translate.instant('LIVEDIFFUSION.live_start_stream'), {}, 1000, true);
                      counterLive = $timeout(vm.compteur, 1000);
                        vm.start = false;
                      //   flApp.streamer();
                    },
                    function () {
                      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    })
              },
              function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              })

      } else {
          vm.start = true;
        msApi.request('livesLivePeral.startLive@get', {id: vm.channelId, idLive:vm.lives.id,start:0},
          function () {
              $rootScope.loadingProgress = false;
              vm.activated = false;
              vm.statusStreaming = "stopped";
              vm.start = true;
            webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.live_end_stream'));
            vm.counter = "00:00:00";
            compteurLiveSeconde = 0;
            $timeout.cancel(counterLive);

              // flApp.stopStream();
          },
          function () {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          })
      }

    }

    function videoActivation() {
      if (vm.videoActivate) {
        vm.videoActivate = false;
        vm.videoButtonIcon = "icon-camcorder-off";
        vm.videoState = "video-off-button";
        vm.translateVideoActivation = "LIVEDIFFUSION.activate_video";
        flApp.disableCam();

      }
      else {
        vm.videoActivate = true;
        vm.videoButtonIcon = "icon-camcorder";
        vm.videoState = "video-on-button";
        vm.translateVideoActivation = "LIVEDIFFUSION.disable_video";
        flApp.enableCam(0);
        vm.cameraSelected = vm.cameras[0];

      }
    }

    function audioActivation() {
      if (vm.audioActivate) {
        vm.audioActivate = false;
        vm.audioButtonIcon = "icon-microphone-off";
        vm.audioState = "video-off-button";
        vm.translateAudioActivation = "LIVEDIFFUSION.activate_audio";
        vm.volume = 0;
        volumeChanged();
        flApp.disableMicro();
      }
      else {
        vm.audioActivate = true;
        vm.audioButtonIcon = "icon-microphone";
        vm.audioState = "video-on-button";
        vm.translateAudioActivation = "LIVEDIFFUSION.disable_audio";
        vm.volume = 50;
        volumeChanged();
        flApp.enableMicro(0, vm.mics.indexOf(vm.micSelected));

      }
    }

    function resolutionChange() {
      if (vm.resolution === "Low") {
        setConfigFaible();
        majSetting();

      } else {
        if (vm.resolution === "Med") {
          setConfigMoyenne();
          majSetting();

        } else {
          setConfigHaut();
          majSetting();
        }
      }
    }

    function ratioChange() {
      ratio = vm.ratioSelected;
      majConfigCam()

    }

    function volumeChanged() {
      majSetting()
    }

    function audioSelect() {
      var index = vm.mics.indexOf(vm.micSelected);
      flApp.selectMic(0, index);
    }

    function videoSelect() {
      var index = vm.cameras.indexOf(vm.cameraSelected);
      flApp.selectCam(index);
    }

    function listCams(list) {
      vm.cameras = list;
      vm.cameraSelected = list[0];
    }

    function listMics(list) {
      vm.mics = list;
      vm.micSelected = list[0];
    }

    function majConfigCam() {
      switch (vm.resolution) {
        case "Low":
          setConfigFaible();
          break;
        case "Med":
          setConfigMoyenne();
          break;
        case "High":
          setConfigHaut();
          break;
        default:
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          break;
      }
      majSetting();
    }


    function setConfigHaut() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 960;
      config_object.height = format === "4/3" ? 720 : 540;
      config_object.bdwith = 1500;
      config_object.bitrate = 10;
      config_object.samplerate = 44;
    }

    function setConfigMoyenne() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 640;
      config_object.height = format === "4/3" ? 480 : 360;
      config_object.bdwith = 1200;
      config_object.bitrate = 9;
      config_object.samplerate = 22;
    }

    function setConfigFaible() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 480;
      config_object.height = format === "4/3" ? 360 : 270;
      config_object.bdwith = 400;
      config_object.bitrate = 8;
      config_object.samplerate = 11;
    }


    function majSetting() {
      //camera
      var fps = config_object.fps;
      var width = config_object.width;
      var height = config_object.height;
      var bdwith = config_object.bdwith * 1000;
      //micro
      var volume = vm.volume;
      var codec = 0;
      var bitrate = config_object.bitrate;
      var samplerate = config_object.samplerate;

      if (angular.isDefined(flApp)) {
        flApp.majSetting(bdwith, fps, width, height, volume, codec, bitrate, samplerate, true, true);

      }

    }

    function compteur() {
      compteurLiveSeconde++;
      var diffTime = compteurLiveSeconde;
      var h = parseInt(diffTime / 3600);
      diffTime -= h * 3600;
      var m = parseInt(diffTime / 60);
      var s = (diffTime % 3600) % 60;
      var heure;
      if (h < 10) {
        heure = "0" + h.toString();
      } else {
        heure = h.toString();
      }
      var minute;
      if (m < 10) {
        minute = "0" + m.toString();
      } else {
        minute = m.toString();
      }
      var seconde;
      if (s < 10) {
        seconde = "0" + s.toString();
      } else {
        seconde = s.toString();
      }
      vm.counter = heure + ":" + minute + ":" + seconde;
      counterLive = $timeout(vm.compteur, 1000)

    }

    function clickVideoListItem() {
      vm.clickedVideo = !vm.clickedVideo;
    }

    function clickChapterListItem() {
      vm.clickedChapter = !vm.clickedChapter;
    }

    function clickSlideListItem() {
      vm.clickedSlide = !vm.clickedSlide;
    }

    function clickMicroListItem() {
      vm.clickedMicro = !vm.clickedMicro;
    }

    function addSlide() {
        var time = vm.counter;
        $rootScope.time = time;
      var id = incremanteId(slideId);
      slideId++;
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/pearl/add.slide.html',
        clickOutsideToClose: true,
        controller: "addSlideController",
        fullscreen: true
      }).then(function (slides) {
          vm.slides = vm.slides.concat(slides);
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function addChapter() {
      var time = vm.counter;
      var id = incremanteId(chapterId);
      chapterId++;
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/pearl/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.time = time;
          $scope.text = "";
          $scope.add = true;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;
          $scope.timeExist = false;
          $scope.confirmAdd = confirmAdd;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmAdd() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }
          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters.push(chapter);
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );


    }

    function confirmDeleteChapter(chapter) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteChapter(chapter);

      }, function () {

      });
    }

    function confirmDeleteSlide(slide) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteSlide(slide);

      }, function () {

      });
    }

    function deleteChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      vm.chapters.splice(index, 1);
      // params.rm.chapitres = vm.chapters.slice();
      // updateRM();
    }

    function deleteSlide(slide) {
      var index = vm.slides.indexOf(slide);
      vm.slides.splice(index, 1);
      // params.rm.slidesTmp = vm.slides.slice();
      // updateRM();
    }

    function modifyChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/pearl/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.add = false;
          $scope.time = chapter.TimeCode;
          $scope.text = chapter.Title;
          $scope.id = chapter.ID;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;

          $scope.timeExist = false;
          $scope.confirmModify = confirmModify;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmModify() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: $scope.id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: $scope.id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }

          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters[index] = chapter;
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );
    }

    function broadcastChapter(chapter) {
        if (uniqueValue({TimeCode: vm.counter}, params.rm.chapitresTmp)) {
            chapter.TimeCode = vm.counter;
            params.rm.chapitresTmp.push(chapter);
            var index = vm.chapters.indexOf(chapter);
            vm.chapters[index].Diffuse = true;
            sortValues(params.rm.chapitresTmp);
            updateRM();

        } else {
            webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
        }
    }

    function broadcastSlide(slide) {
      if (uniqueValue({TimeCode: vm.counter}, params.rm.slidesTmp)) {
          slide.TimeCode = vm.counter;
          params.rm.slidesTmp.push(slide);
          var index = vm.slides.indexOf(slide);
          vm.slides[index].Diffuse = true;
          sortValues(params.rm.slidesTmp);
          updateRM();

      } else {
        webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
      }

    }

    function slideBroadcasted(slide) {
      return (slide.TimeCode === "--:--:--");
    }

    function modifySlide(slide) {

      var id = slide.ID;
      var time = slide.TimeCode;
      var index = vm.slides.indexOf(slide);
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/pearl/add.slide.html',
        clickOutsideToClose: true,
        controller: "modifySlideController",
        fullscreen: true
      }).then(function (slideModified) {
              slideModified.TimeCode = time;
          vm.slides[index] = slideModified;
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function uniqueValue(item, items) {
      var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
      return (angular.isUndefined(unique));
    }

    String.prototype.toSeconds = function () {
      var sec_num = this.split(':');
      var hour = parseInt(sec_num[0]);
      var minute = parseInt(sec_num[1]);
      var seconds = parseInt(sec_num[2]);
      return seconds + minute * 60 + hour * 3600;
    };

    function sortValues(items) {
      var arrayToSort = items;
      if (arrayToSort.length) {
        arrayToSort.sort(function (a, b) {
          if (angular.isDefined(a.TimeCode) && angular.isDefined(b.TimeCode)) {
            return a.TimeCode.toSeconds() - b.TimeCode.toSeconds();
          }
          else {
            return 0;
          }
        });
      }
      return arrayToSort;
    }


    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.form_diffusion_title_menu_title";
        if (angular.isUndefined($rootScope.currentState)) {
            $rootScope.pageRoute = 'app.lives_list_ongoing';
        }
        else {
            $rootScope.pageRoute = $rootScope.currentState;
        }
        $rootScope.welcome = "";

    }

    function updateRM() {
        params.rm.slides=params.rm.slidesTmp;
        params.rm.chapitres=params.rm.chapitresTmp ;
      msApi.request('livesLiveDiffusion.syncRTC@save',
        {
          live_id: vm.lives.id,
          rm: params.rm
        },
        function (res) {
          if (res.message === 'success') {
            webTvGlobal
              .$toast()
              .showSimple($translate.instant('LIVEDIFFUSION.live_rm_update'), {}, 1000, true);
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        })
    }

    function incremanteId(id) {
      id = id + 1;
      return vm.lives.id + "_" + id;
    }
  }
  function livesLiveDiffusionJitsiController($cookies, $sce, webTvGlobal, $injector,urlJitsi) {
      var myEl = angular.element(document.querySelector('#content'));
      if (angular.isDefined(myEl)) ;
      myEl.removeClass('animate-slide-up');
      var $rootScope = $injector.get('$rootScope');
      var vm = this;
      if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().use_jitsi)) vm.use_jitsi = webTvGlobal.$constant().webTvParameterBag().use_jitsi;
      else vm.use_jitsi = '0';
      vm.use_jitsi = vm.use_jitsi == "1" || vm.use_jitsi == true || angular.isDefined(urlJitsi.url) ? true : false;
      if(vm.use_jitsi){
        vm.urlJitsi = $sce.trustAsResourceUrl(urlJitsi.url);
      }
      try{
          if($cookies.get('layoutStyle') ==="horizontalNavigation") {
              document.querySelector('#url_jitsi').style.height = window.innerHeight - 150 + "px";
          }else{
              document.querySelector('#url_jitsi').style.height = window.innerHeight - 100 + "px";
          }
      }
      catch(e){

      }
      initHelp();
      function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.form_diffusion_title_menu_title";
            $rootScope.titre3 = ""
            if (angular.isUndefined($rootScope.currentState)) {
                $rootScope.pageRoute = 'app.lives_list_ongoing';
            }
            else {
                $rootScope.pageRoute = $rootScope.currentState;
            }
            $rootScope.welcome = "";

        }
  }
})();



(function () {
  angular
    .module('app.lives.pearl')
    .controller('modifySlideController', modifySlideController);

  /** @ngInject */
  function modifySlideController($scope, $mdDialog, $rootScope, webTvGlobal, $translate, id) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    $scope.add = false;
    $scope.time = "--:--:--";
    $scope.imageName;
    $scope.slideFile;
    $scope.inProgress = true;
    $scope.progressBarValue = 10;
    $scope.progress = false;
    $scope.ngFlowImageOptions = {
      chunkSize: (function () {
        return Math.pow(10, 8);
      })(),
      testChunks: false,
      target: Routing.generate('api_post_lives_slide'),
      singleFile: true,
      extendChunks: false,
      fileParameterName: 'empApiFileForm[thumb]'
    };
    $scope.ngFlow = {
      flow: {}
    };
    $scope.ngFlowImage = {
      flow: {}
    };
    var slide = {};
    $scope.fileImgAdded = fileImgAdded;
    $scope.fileProgress = fileProgress;
    $scope.uploadFileImage = uploadFileImage;
    $scope.fileSuccess = fileSuccess;
    $scope.uploadComplete = uploadComplete;

    function fileImgAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        $scope.imageName = false;
        webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.alert_not_valid_slide_image_message'));
        return false;
      }
      $scope.progress = true;
      $scope.slideFile = file;
      $rootScope.loadingProgress = true;
      $scope.inProgress = false;
    }

    function fileProgress(file) {
      $scope.progressBarValue = Math.floor(file.progress() * 100);
    }

    function uploadFileImage() {
      $scope.ngFlowImage.flow.opts.headers = {};
      $scope.ngFlowImage.flow.upload();
      $scope.inProgress = true;
    }

    function fileSuccess(file, message) {
      var data = null;
      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      $scope.slideFileName = $scope.slideFile.name;
      if (angular.isDefined($scope.slideFile)) {
        if (angular.isDefined(data.location.url)) {
          slide = {
            "ID": id,
            "TimeCode": $scope.time,
            "Title": data.location.path,
            "Name": data.location.url,
            "Order": null
          };
        }
      } else {
        webTvGlobal
          .$toast()
          .showSimple($translate.instant('MESSAGES.alert_xhr_error'), {}, 1000, true);
      }

      if (/^ERROR !$/.test(message) || /^ERROR$/.test(message)) return;
    }

    function uploadComplete() {
      $scope.progressBarValue = 0;
      $scope.inProgress = false;
      $rootScope.loadingProgress = false;
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.file_import'), {}, 1000, true);
      $mdDialog.hide(slide);
    }

    $scope.cancel = function () {
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
      $mdDialog.cancel();
    };
  }
})();

(function () {
  angular
    .module('app.lives.pearl')
    .controller('addSlideController', addSlideController);

  /** @ngInject */
  function addSlideController($scope, $mdDialog, $rootScope, webTvGlobal, $translate, id) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    $scope.add = true;
    $scope.time = "--:--:--";
    $scope.imageName;
    $scope.slideFile;
    $scope.inProgress = true;
    $scope.progressBarValue = 10;
    $scope.progress = false;
    $scope.ngFlowImageOptions = {
      chunkSize: (function () {
        return Math.pow(10, 8);
      })(),
      testChunks: false,
      target: Routing.generate('api_post_lives_slide'),
      singleFile: false,
      extendChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      query: {id: id}
    };
    $scope.ngFlow = {
      flow: {}
    };
    $scope.ngFlowImage = {
      flow: {}
    };
    var slides = [];
    $scope.fileImgAdded = fileImgAdded;
    $scope.fileProgress = fileProgress;
    $scope.uploadFileImage = uploadFileImage;
    $scope.fileSuccess = fileSuccess;
    $scope.uploadComplete = uploadComplete;


    function fileImgAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        $scope.imageName = false;
        webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.alert_not_valid_slide_image_message'));
        return false;
      }
      $scope.progress = true;
      $scope.slideFile = file;
      $rootScope.loadingProgress = true;
      $scope.inProgress = false;
    }

    function fileProgress(file) {
      $scope.progressBarValue = Math.floor(file.progress() * 100);
    }

    function uploadFileImage() {
      $scope.ngFlowImage.flow.opts.headers = {};
      $scope.ngFlowImage.flow.upload();
      $scope.inProgress = true;
    }

    function fileSuccess(file, message) {
      var data = null;
      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      $scope.slideFileName = $scope.slideFile.name;
      if (angular.isDefined($scope.slideFile)) {
        if (angular.isDefined(data.location.url)) {
          slides.push({
            "ID": id,
            "TimeCode": $rootScope.time,
            "Title": data.location.path,
            "Name": data.location.url,
            "Order": null
          });
        }

      } else {
        webTvGlobal
          .$toast()
          .showSimple($translate.instant('MESSAGES.alert_xhr_error'), {}, 1000, true);
        return;
      }

    }

    function uploadComplete() {
      $scope.progressBarValue = 0;
      $scope.inProgress = false;
      $rootScope.loadingProgress = false;
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.file_import'), {}, 1000, true);
      $mdDialog.hide(slides);
    }

    $scope.cancel = function () {
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
      $mdDialog.cancel();

    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.encodeurlive', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {


        // State
        $stateProvider
            .state('app.lives_encodeur', {
                url: "/lives",
                abstract: true,
                resolve: {
                    paramsChannelpearl: function (msApi) {
                        return msApi.resolve('encoder_pearl.ParamChannel@get');
                    }
                }
            })
            .state('app.lives_encodeur_test', {
                parent: 'app.lives_encodeur',
                url: "/:id/encodeurlive",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/encodeurlive/encodeur.html',
                        controller: 'EncodeurLive as vm'
                    }
                },

                resolve: {

                    // channelChoices: function (msApi) {
                    //     return msApi.resolve('media_home.channelChoices@get');
                    // },
                    mediaVideoGetUrlUpdate: function (msApi) {
                        return msApi.resolve('media_video.getUrlUpdate@get');
                    },
                    listtemplate: function (msApi, paramsChannelpearl) {
                        if (angular.isDefined(paramsChannelpearl.data.params.pearl_id_channel))
                            var test = paramsChannelpearl.data.params.pearl_id_channel;
                        else
                            var test = 0;
                        return msApi.resolve("encoder_pearl.listTtemplate@get", {
                            id: test
                        })
                    },
                    statusStreaming: function (msApi, paramsChannelpearl) {
                        if (angular.isDefined(paramsChannelpearl.data.params.pearl_id_channel))
                            var test = paramsChannelpearl.data.params.pearl_id_channel;
                        else
                            var test = 0;
                        return msApi.resolve("encoder_pearl.status_streaming@get", {
                            id: test
                        })
                    },
                    statusRecording: function (msApi, paramsChannelpearl) {
                        if (angular.isDefined(paramsChannelpearl.data.params.pearl_id_channel))
                            var test = paramsChannelpearl.data.params.pearl_id_channel;
                        else
                            var test = 0;
                        return msApi.resolve("encoder_pearl.status_recording@get", {
                            id: test
                        })
                    },
                    getPublishPearl: function (msApi) {
                        return msApi.resolve('encoder_pearl.getPublishPearl@get');
                    },
                    getInteractPearl: function (msApi) {
                        return msApi.resolve('encoder_pearl.getInteractivityPearl@get');
                    },
                    // getListSource: function (msApi) {
                    //     return msApi.resolve('encoder_pearl.getListSource@get');
                    // },
                    // getSurvey: function (msApi, $stateParams) {
                    //     return msApi.resolve('encoder_pearl.survey@get', {
                    //         id: $stateParams.id
                    //     })
                    // },
                    // getVideoSources: function (msApi) {
                    //     return msApi.resolve('encoder_pearl.getVideoSources@get');
                    // },
                    // getAudioSources: function (msApi) {
                    //     return msApi.resolve('encoder_pearl.getAudioSources@get');
                    // },
                     getInfoIframe: function (msApi, paramsChannelpearl) {
                         if (angular.isDefined(paramsChannelpearl.data.params.pearl_id_channel))
                             var test = paramsChannelpearl.data.params.pearl_id_channel;
                         else
                             var test = 0;
                         return msApi.resolve('encoder_pearl.getInfoIframe@get', {
                             idChannel: test
                         })
                     }

                },
                "bodyClass":
                    "forms"
            })
        ;

        msApiProvider.register('encodeur_start', [Routing.generate('api_encoder_live_start_or_end_live_channel', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('encodeur_preview', [Routing.generate('api_encoder_live_preview_live', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);

        msApiProvider.register('encodeur_start_recorder', [Routing.generate('api_encoder_live_start_or_end_live_recorder', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_home.channelChoices', [Routing.generate('api_encoder_live_get_list_channel')]);
        msApiProvider.register('encoder_pearl.ParamChannel', [Routing.generate('api_encoder_live_get_param_encoder')]);
        msApiProvider.register('encoder_pearl.Updateparams', [Routing.generate('api_encoder_live_post_edit_param_encoder')]);
        msApiProvider.register('encoder_pearl.Updatestreaming', [Routing.generate('api_encoder_live_post_add_channel_streaming', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('encoder_pearl.channeldetailStreaming', [Routing.generate('api_encoder_live_get_detail_channel_streaming', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('encoder_pearl.getDefaultTemplate', [Routing.generate('api_encoder_live_get_default_template', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('encoder_pearl.activeTemplate', [Routing.generate('api_encoder_live_get_activate_template')]);
        msApiProvider.register('livesLivePeral.startLive', [Routing.generate('api_encoder_live_start_or_end_live_channel',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('livesLivePeral.Updatestreaming', [Routing.generate('api_encoder_live_post_add_channel_streaming', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);

        msApiProvider.register('encoder_pearl.addPublishPearl', [Routing.generate('api_encoder_live_add_publish_pearl_config')]);
        msApiProvider.register('encoder_pearl.getPublishPearl', [Routing.generate('api_encoder_live_get_publish_pearl_config')]);

        msApiProvider.register('encoder_pearl.addInteractivityPearl', [Routing.generate('api_encoder_live_add_interactivity_pearl_config')]);
        msApiProvider.register('encoder_pearl.getInteractivityPearl', [Routing.generate('api_encoder_live_get_interactivity_pearl_config')]);

        msApiProvider.register('media_video.getUrlUpdate', [Routing.generate('api_media_get_url_update_step_video')]);

        msApiProvider.register('encoder_pearl.addRollPearl', [Routing.generate('api_encoder_live_add_roll_pearl_config')]);
        msApiProvider.register('encoder_pearl.getRollPearl', [Routing.generate('api_encoder_live_get_roll_pearl_config')]);
        //api_encoder_live_get_list_template
        msApiProvider.register('encoder_pearl.listTtemplate', [Routing.generate('api_encoder_live_get_list_template', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('encoder_pearl.previewTemplate', [Routing.generate('api_encoder_live_get_url_preview_layout')]);

        msApiProvider.register('encoder_pearl.status_recording', [Routing.generate('api_encoder_live_get_status_recording', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('encoder_pearl.status_streaming', [Routing.generate('api_encoder_live_get_status_streaming', {id: ':id'}).replace(/%3A/, ":")]);

        msApiProvider.register('encoder_pearl.survey', [Routing.generate('api_get_survey_for_live', {id: ':id'}).replace(/%3A/, ":")]);

        msApiProvider.register('encoder_pearl.getLayouts', [Routing.generate('api_encoder_live_get_layout_characteristics')]);
        msApiProvider.register('encoder_pearl.getAudioSources', [Routing.generate('api_encoder_live_get_list_audio_sources')]);

        msApiProvider.register('encoder_pearl.getInfoIframe', [Routing.generate('api_encoder_live_get_infos_iframe_live')]);

        msApiProvider.register('encoder_pearl.getImageBase64', [Routing.generate('api_encoder_live_get_image_base64')]);
        msApiProvider.register('encoder_pearl.get_url_live_pearl', [Routing.generate('api_encoder_live_get_url_live_pearl', {id: ':id'}).replace(/%3A/, ":")]);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.lives.encodeurlive')
        .controller('PopupControl', PopupControl);

    /** @ngInject */
    function PopupControl($mdDialog, paramsChannelpearl, $rootScope, msApi, webTvGlobal, $translate, id, num, $state) {
        var vm = this;
        vm.paramspearl = paramsChannelpearl.data.params;
        vm.activeTemplate = activeTemplate;
        vm.cancel = cancel;
        vm.submitUpdateparams = submitUpdateparams;
        vm.list = [];
        vm.templateid = id;
        vm.canalid = num;
        vm.list.push({"channel": 2, "nb_template": 5}, {"channel": 3, "nb_template": 5});
        vm.params = {
            activate_pearl_encoder: vm.paramspearl.activate_pearl_encoder || "",
            pearl_url: vm.paramspearl.pearl_url || "",
            pearl_api_username: vm.paramspearl.pearl_api_username || "",
            pearl_api_pwd: vm.paramspearl.pearl_api_pwd || "",
            pearl_live_url_preview: vm.paramspearl.pearl_live_url_preview || "",
            pearl_live_url_preview_layout: vm.paramspearl.pearl_live_url_preview_layout || "",
            pearl_live_url_preview_source: vm.paramspearl.pearl_live_url_preview_source || "",
            pearl_id_channel: vm.paramspearl.pearl_id_channel || "",
            pearl_nbr_source: vm.paramspearl.pearl_nbr_source,
            pearl_nbr_layout: vm.paramspearl.pearl_nbr_layout

        };

        function cancel() {
            $mdDialog.hide();
        }

        /**
         * Check if group exists
         * @return if exists get Group Data else redirect to 404 page
         */

        function submitUpdateparams() {
            $rootScope.loadingProgress = true;
            msApi.request('encoder_pearl.Updateparams@save',
                angular.copy({
                    "params": {
                        activate_pearl_encoder: vm.paramspearl.activate_pearl_encoder,
                        pearl_url: vm.paramspearl.pearl_url,
                        pearl_api_username: vm.paramspearl.pearl_api_username,
                        pearl_api_pwd: vm.paramspearl.pearl_api_pwd,
                        pearl_live_url_preview: vm.paramspearl.pearl_live_url_preview,
                        pearl_live_url_preview_layout: vm.paramspearl.pearl_live_url_preview_layout,
                        pearl_live_url_preview_source: vm.paramspearl.pearl_live_url_preview_source || "",
                        pearl_id_channel: vm.paramspearl.pearl_id_channel || "",
                        pearl_nbr_source: vm.paramspearl.pearl_nbr_source,
                        pearl_nbr_layout: vm.paramspearl.pearl_nbr_layout
                    }
                }),
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        vm.canal = vm.params;
                        webTvGlobal.$flashMessages().set('parametersChutierAdd', {title: vm.params.activate_pearl_encoder ? vm.params.activate_pearl_encoder : ""});
                        $state.reload();
                        //$state.go('app.chutier_list');
                        cancel();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                },
                function () {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );
        }

        function activeTemplate(id, num) {
            vm.spinner = false;
            msApi.request('encoder_pearl.activeTemplate@get', {idChannel: id, idLayout: num},
                function (res) {
                    if (res.code === 200) {
                        if (angular.isDefined(res.data)) {
                            vm.detailstream = res.data;
                        }
                        cancel();
                    }

                },
                function (res) {

                }
            );

        }


    }


})();
(function () {
    'use strict';

    angular
        .module('app.lives.encodeurlive')
        .controller('EncodeurLive', EncodeurLive)
        .directive('ngToggle', [
            '$parse',
            function ($parse) {
                return {
                    restrict: 'A',
                    link: function (scope, element, attrs) {
                        var modelFn = $parse(attrs.ngToggle);
                        element.on('click', function () {
                            scope.$apply(function () {
                                modelFn.assign(scope, !modelFn(scope));
                            });
                        });
                        scope.$watch(modelFn, function (value) {
                            element.toggleClass('toggled', !!value);
                        });
                    }
                }
            }
        ]);


    /** @ngInject */
    function EncodeurLive(getInfoIframe,$sce,webTvGlobal, $http, $mdDialog, msApi, $rootScope, $stateParams, $translate, $interval, paramsChannelpearl, $state, $timeout, userManager, mediaVideoGetUrlUpdate, listtemplate, statusStreaming, statusRecording, getPublishPearl) {

    var vm = this;
    // vm.lives = "";
    // vm.live_id = $stateParams.id;
    // vm.cancel = cancel;
    // vm.startLive = startLive;
    var parameters = webTvGlobal.$constant().webTvParameterBag();
    vm.popup = popup;
    // vm.live_id = $stateParams.id;
    // vm.cancel = cancel;
    // vm.startLive = startLive;
    // vm.click = click;
    // vm.startRecorder = startRecorder;
    vm.submitUpdatestreaming = submitUpdatestreaming;
    // vm.getchannelStreaming = getchannelStreaming;
    // // vm.getchannelTemplate = getchannelTemplate;
    // vm.endLive = endLive;
    // vm.preveiwLive = preveiwLive;
    // vm.defaultTemplate = defaultTemplate;
    vm.showDiv = showDiv;
    vm.showDivWebcast = showDivWebcast;
    vm.previewTemplate = previewTemplate;
    vm.streaming = [];
      var permission = {};
      if (userManager.isActionGranted('pearl_encoder_webcast')) {
        permission.pearl_encoder_webcast = true;
      }
      if (userManager.isActionGranted('pearl_encoder_settings')) {
        permission.pearl_encoder_settings = true;
      }
      if (userManager.isActionGranted('pearl_encoder_interaction')) {
        permission.pearl_encoder_interaction = true;
      }
      if (userManager.isActionGranted('pearl_encoder_vue_web')) {
        permission.pearl_encoder_vue_web = true;
      }
      vm.permission = permission;
    // vm.channels = channelChoices.data.channels;
    var alert;
    // vm.showAlert = showAlert;
    vm.next = next;
    vm.previous = previous;
    // vm.num = 1;
    vm.test = true;
    var counterLive;
    vm.counter = "00:00:00";
    vm.translateStart = "LIVEDIFFUSION.start";
    vm.recordClass = "button-start-glow";
    vm.url_live = "";
    vm.url_live_web = "";
    vm.height_iframe = "99%";
    vm.width_iframe_vue_web = "99%";
    vm.showLoading = false;
    vm.start = true;
    var compteurLiveSeconde = 0;
    // vm.isActive = true;
    vm.selected = "publish";
    vm.recordingStart = recordingStart;
    vm.selectedWebcast = "sidebyside";
    // var element, x = 0, y = 0;
    var time;
        vm.errorPage = false;
    // if (getSurvey.data.survey)
    //     vm.surveyQuestions = getSurvey.data.survey.questions;
    if (angular.isDefined(statusRecording.data.status_recording) && statusRecording.data.status_recording)
      vm.statusRecording = statusRecording.data.status_recording.active;
        if(!angular.isDefined(statusStreaming.data.status_streaming[0])){
            vm.errorPage = true;
        }else {
            if (angular.isDefined(statusStreaming.data.status_streaming[0] && statusStreaming.data.status_streaming[0].status))
                vm.statusStreaming = statusStreaming.data.status_streaming[0].status.started;
        }
    vm.activeTemplate = activeTemplate;
    vm.activeWebcastTab = activeWebcastTab;
    vm.stream = getPublishPearl.data.config_publish_pearl.streaming || false;
    vm.record = getPublishPearl.data.config_publish_pearl.record || false;
    vm.preview = getPublishPearl.data.config_publish_pearl.preview || false;
    if (paramsChannelpearl.data.params.pearl_id_channel)
      vm.idChannel = paramsChannelpearl.data.params.pearl_id_channel;
    else {
      vm.idChannel = 0;
    }
    if (paramsChannelpearl.data.params.pearl_nbr_source)
      vm.nbr_source = paramsChannelpearl.data.params.pearl_nbr_source;
    else {
      vm.nbr_source = "";
    }
    if (paramsChannelpearl.data.params.pearl_live_url_preview_layout) {
      vm.srcImg = paramsChannelpearl.data.params.pearl_live_url_preview_layout;
      vm.srcImgBig = paramsChannelpearl.data.params.pearl_live_url_preview_layout;
      vm.test = true;
    } else vm.test = false;
    if (paramsChannelpearl.data.params.pearl_live_url_preview_source) {
      vm.source = paramsChannelpearl.data.params.pearl_live_url_preview_source;
    }
    vm.login = paramsChannelpearl.data.params.pearl_api_username;
    vm.password = paramsChannelpearl.data.params.pearl_api_pwd;

        vm.testApi = testApi;

        function testApi() {
            $http.get(paramsChannelpearl.data.params.pearl_url + "admin/channel/4/get_params.cgi?active_layout")
                .then(function (response) {
                });

        }

        // vm.changeColor = changeColor;
        // vm.color = '#FF0000';

// options - if a list is given then choose one of the items. The first item in the list will be the default


        // function changeColor() {
        //     vm.urlVignette = "";
        //     console.log(vm.color);
        // }

        vm.count = 0;


        function next() {

            if (vm.count < vm.surveyQuestions.length - 1)
                vm.count++;

        }


        function previous() {


            if (vm.count >= 0)
                vm.count--;

        }

        function activeWebcastTab() {
            $state.reload();
        }

        function activeTemplate() {
            $rootScope.loadingProgress = true;

            msApi.request('encoder_pearl.activeTemplate@get', {idChannel: vm.idChannel, idLayout: vm.idtemplate},

                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant('LIVESPEARL.success_layout'));
                        vm.preview_template_final = vm.preview_template;

                    } else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                })
        }

        function showDivWebcast(selected) {
            vm.selectedWebcast = selected;
        }

        vm.startEndStreaming = startEndStreaming;
        vm.startEndRecording = startEndRecording;
        vm.get_url_live = get_url_live;

        function get_url_live() {
            if(!vm.url_live_web) {
                vm.showLoading = true;
                msApi.request('encoder_pearl.get_url_live_pearl@get', {id: vm.idChannel},
                    function (res) {
                        vm.showLoading = false;
                        vm.url_live_web = $sce.trustAsResourceUrl(res.data.url_live);
                        rerangeFrameVueWeb();
                    }, function () {

                    }
                );
            }
        }
        function startEndRecording() {
            if (vm.statusRecording === '0')
                var start = '1';
            else var start = '0';
            msApi.request('encodeur_start_recorder@get', {id: vm.idChannel, idLive: $stateParams.id, start: start},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        msApi.request('encoder_pearl.status_recording@get', {id: vm.idChannel},
                            function (response) {
                                $rootScope.loadingProgress = false;
                                if (angular.isDefined(response.code) && response.code === 200) {

                                    time = response.data.status_recording.time;
                                    vm.statusRecording = response.data.status_recording.active;
                                }
                            });

                    } else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    })

                    }

    function recordingStart() {
      if (vm.start) {
        msApi.request('livesLivePeral.Updatestreaming@save', {
            id: vm.idChannel,
            get_server_pearl: 1,
            liveId: $stateParams.id
          },
          function (res) {
            vm.url_live = $sce.trustAsResourceUrl(res.data.url_live);
            msApi.request('livesLivePeral.startLive@get', {id: vm.idChannel, idLive: $stateParams.id, start: 1},
              function () {
                $rootScope.loadingProgress = false;
                vm.activated = true;
                vm.statusStreaming = "started";
                rerangeFramePlayer();
                webTvGlobal
                  .$toast()
                  .showSimple($translate.instant('LIVEDIFFUSION.live_start_stream'), {}, 1000, true);
                counterLive = $timeout(compteur, 1000);
                vm.start = false;
                //   flApp.streamer();
              },
              function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              })
          },
          function () {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          })

      } else {
        vm.start = true;
        msApi.request('livesLivePeral.startLive@get', {id: vm.idChannel, idLive: $stateParams.id, start: 0},
          function () {
            $rootScope.loadingProgress = false;
            vm.activated = false;
            vm.statusStreaming = "stopped";
            vm.start = true;
            webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.live_end_stream'));
            vm.counter = "00:00:00";
            compteurLiveSeconde = 0;
            $timeout.cancel(counterLive);
          },
          function () {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          })
      }

    }
        function rerangeFrameVueWeb() {
            var height = document.getElementById("iframe_vue_web").offsetHeight;
            console.log(height);
            var width = (height * 16) / 9;
            vm.width_iframe_vue_web = width +"px";
        }

    function rerangeFramePlayer() {
      var width = document.getElementById('content_urlLive').offsetWidth;
      var height = (width * 9) / 16;
      vm.height_iframe = height +"px";
        }
      window.onresize = function(event) {
        rerangeFramePlayer();
          rerangeFrameVueWeb();
      };
    function compteur() {
      compteurLiveSeconde++;
      var diffTime = compteurLiveSeconde;
      var h = parseInt(diffTime / 3600);
      diffTime -= h * 3600;
      var m = parseInt(diffTime / 60);
      var s = (diffTime % 3600) % 60;
      var heure;
      if (h < 10) {
        heure = "0" + h.toString();
      } else {
        heure = h.toString();
      }
      var minute;
      if (m < 10) {
        minute = "0" + m.toString();
      } else {
        minute = m.toString();
      }
      var seconde;
      if (s < 10) {
        seconde = "0" + s.toString();
      } else {
        seconde = s.toString();
      }
      vm.counter = heure + ":" + minute + ":" + seconde;
      counterLive = $timeout(compteur, 1000)

    }

        function transformSecTOTime(s) {
            var secs = s % 60;
            s = (s - secs) / 60;
            var mins = s % 60;
            var hrs = (s - mins) / 60;
            return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
        }

        if (angular.isDefined(statusRecording.data.status_recording) && statusRecording.data.status_recording && statusRecording.data.status_recording.active === "1")
            time = statusRecording.data.status_recording.time;
        $interval(function () {
            if (time) {
                time++;
                vm.timer = transformSecTOTime(time);
            }
        }, 1000);

      function startEndStreaming() {
        $rootScope.loadingProgress = true;
        if (vm.statusStreaming === true)
          var start = 0;
        else var start = 1;

        if(start === 1){
          msApi.request('livesLivePeral.Updatestreaming@save', {
            id: vm.idChannel,
            get_server_pearl: 1,
            liveId: $stateParams.id
          },function(response){
            startEndLivePearl(start)
          },function(response){

          })
        }else{
          startEndLivePearl(start)
        }


      }

      function startEndLivePearl(start){
        msApi.request('encodeur_start@get', {id: vm.idChannel, idLive: $stateParams.id, start: start},
          function (response) {
            if (angular.isDefined(response.code) && response.code === 200) {
              msApi.request('encoder_pearl.status_streaming@get', {id: vm.idChannel},
                function (response) {
                  $rootScope.loadingProgress = false;
                  if (angular.isDefined(response.code) && response.code === 200) {
                    vm.statusStreaming = response.data.status_streaming[0].status.started;
                  }
                });

            } else {
              if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                $translate('VALIDATION.' + response.data.message).then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
              }
              else {

                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              }
            }
          },
          function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATION.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          })
      }

        function previewTemplate(selected, testFinal, v, testSourceTemplate) {
            if (testFinal === false)
                $rootScope.loadingProgress = true;
            vm.imageBig = vm.srcImgBig.replace("[login]", vm.login).replace("[password]", vm.password).replace("[channelId]", vm.idChannel).replace("[layoutId]", selected).replace("[widht]", 380).replace("[height]", 214).replace("[timestimp]", moment().unix());
            //vm.imageBig = "https://nbouaziz-web-dev.webtv-solution.com/FO/desangosse/web/data/vignettes/prev2_380_214.png";
            var url = vm.srcImg.replace("[login]", vm.login).replace("[password]", vm.password).replace("[channelId]", vm.idChannel).replace("[layoutId]", selected).replace("[widht]", 182).replace("[height]", 104).replace("[timestimp]", moment().unix());
            msApi.request('encoder_pearl.getImageBase64@get', {pearl_url_image: url},
                function (response) {
                    if (angular.isDefined(response.code) && response.code === 200) {
                        if (testSourceTemplate === 'template'){
                            vm.tabImg[vm.listTemplate.indexOf(v)]  = response.src;
                        }
                        if (testSourceTemplate === 'source'){
                            vm.tabSrc[vm.listSources.indexOf(v)] = response.src;
                        }
                    }
                });

            // vm.imageBig = vm.srcImgBig.replace("[channelId]", vm.idChannel);
            // vm.imageBig = vm.srcImgBig.replace("[layoutId]", selected);
            // vm.imageBig = vm.srcImgBig.replace("[widht]", 380);
            // vm.imageBig = vm.srcImgBig.replace("[height]", 214);
            // vm.imageBig = vm.srcImgBig.replace("[timestimp]", moment().unix());

            $rootScope.loadingProgress = false;
            vm.idtemplate = selected;
            msApi.request('encoder_pearl.getImageBase64@get', {pearl_url_image: vm.imageBig},
                function (response) {
                    if (angular.isDefined(response.code) && response.code === 200) {
                        vm.preview_template = response.src;
                        if (testFinal === true){
                            vm.preview_template_final = response.src;
                        }
                    }
                });
            if (testFinal === true && angular.isDefined(getInfoIframe.data)) {
                vm.srcFinal = $sce.trustAsResourceUrl(getInfoIframe.data.playerUrl);

            }
            // if (testFinal === true && angular.isDefined(getInfoIframe.data)) {
            //     vm.srcFinal = $sce.trustAsResourceUrl(getInfoIframe.data.src);
            //     vm.idFinal = getInfoIframe.data.id;
            //     vm.nameFinal = getInfoIframe.data.name;
            //     vm.flashvarsFinal = getInfoIframe.data.flashvars;
            //     vm.preview_template_final = vm.imageBig;
            // }


        }

    vm.tabImg = [];
    vm.tabSrc = [];
    vm.listTemplate = [];
    vm.listSources = [];
    // var listSources = getListSource.data.sources;
    var listTemplate = listtemplate.data.templates;
    if (listTemplate.length>0 && vm.nbr_source) {
      for (var i = 0; i < vm.nbr_source; i++) {
        if (vm.test === true) {
          vm.listSources.push(listTemplate[i]);
          vm.src = vm.srcImg.replace("[login]", vm.login).replace("[password]", vm.password).replace("[channelId]", vm.idChannel).replace("[layoutId]", listTemplate[i].id).replace("[widht]", 182).replace("[height]", 104).replace("[timestimp]", moment().unix());
          msApi.request('encoder_pearl.getImageBase64@get', {pearl_url_image: vm.src},
            function (response) {
              if (angular.isDefined(response.code) && response.code === 200) {
                vm.tabSrc.push(response.src);
              }
            });
          if (angular.isDefined(listTemplate[i]) && listTemplate[i].active) {
            vm.idtemplate = listTemplate[i].id;
            vm.previewTemplate(listTemplate[i].id, true);
          }
        }


            }


            for (var i = vm.nbr_source; i < listTemplate.length; i++) {
                if (vm.test === true) {
                    vm.listTemplate.push(listTemplate[i]);
                    vm.image = vm.srcImg.replace("[login]", vm.login).replace("[password]", vm.password).replace("[channelId]", vm.idChannel).replace("[layoutId]", listTemplate[i].id).replace("[widht]", 182).replace("[height]", 104).replace("[timestimp]", moment().unix());
                    // vm.image = "https://nbouaziz-web-dev.webtv-solution.com/FO/desangosse/web/data/vignettes/prev5_182_104.png";
                    msApi.request('encoder_pearl.getImageBase64@get', {pearl_url_image: vm.image},
                        function (response) {
                            if (angular.isDefined(response.code) && response.code === 200) {
                                vm.tabImg.push(response.src);
                            }
                        });
                    if (angular.isDefined(listTemplate[i]) && listTemplate[i].active) {
                        vm.idtemplate = listTemplate[i].id;
                        vm.previewTemplate(listTemplate[i].id, true);
                    }
                }
            }
        }else{
        vm.errorPage = true;
    }
        // angular.forEach(vm.listTemplate, function (value) {
        //     if (vm.test === true) {
        //         //vm.image = vm.srcImg.replace("[channelId]", vm.idChannel).replace("[layoutId]", value.id).replace("[widht]", 182).replace("[height]", 104).replace("[timestimp]", moment().unix());
        //         vm.image = "https://nbouaziz-web-dev.webtv-solution.com/FO/desangosse/web/data/vignettes/prev5_182_104.png";
        //         vm.tabImg.push(vm.image);
        //         if (angular.isDefined(value) && value.active) {
        //             vm.idtemplate = value.id;
        //             vm.previewTemplate(value.id, true);
        //         }
        //     }
        //
        // });
        // vm.ngFlowOptions = {
        //     target: Routing.generate('api_post_lives_thumb'),
        //     singleFile: true,
        //     testChunks: false,
        //     fileParameterName: 'empApiFileForm[thumb]'
        //     //attributes: 'image/*',
        //     //testMethod: false,
        //
        // };
        //
        // if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        // vm.ngFlow = {
        //     // ng-flow will be injected into here through its directive
        //     flow: {}
        //
        // };
        //
        //
        // // Methods
        // vm.fileAdded = fileAdded;
        // vm.uploadFile = uploadFile;
        // vm.fileSuccess = fileSuccess;
        // vm.uploadComplete = uploadComplete;
        //
        // function fileAdded(file) {
        //     if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        //         vm.imageName = false;
        //         webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        //         return false;
        //     }
        //     vm.imageName = file.name;
        //     $rootScope.loadingProgress = true;
        //     angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
        //     angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
        //     angular.element("#empLivesForm button[type='submit']").hide();
        // }
        //
        // /**
        //  * Upload
        //  * Automatically triggers when files added to the uploader
        //  */
        // function uploadFile() {
        //     // Set headers
        //     vm.ngFlow.flow.opts.headers = {};
        //     vm.ngFlow.flow.upload();
        //     vm.inProgress = true;
        // }
        //
        //
        // /**
        //  * File upload success callback
        //  * Triggers when single upload completed
        //  *
        //  * @param file
        //  * @param message
        //  */
        // function fileSuccess(file, message) {
        //     var res = angular.fromJson(message);
        //     if (res.location.path) {
        //
        //         // vm.empLivesForm.userFile=vm.lives.userFile=
        //         vm.urlVignette = res.location.url;
        //
        //     }
        //
        // }
        //
        // /**
        //  * File Upload complete callback
        //  * triggers when upload operation : succes or error or not valid
        //  */
        // function uploadComplete() {
        //     if (vm.imageName) {
        //         angular.element('#file-uploader').find("button").removeAttr('disabled');
        //         angular.element('#file-uploader').find(".file-name").remove();
        //         angular.element("#empLivesForm button[type='submit']").show();
        //         $rootScope.loadingProgress = false;
        //         webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}), '', function () {
        //
        //         });
        //     }
        // }

        function showDiv(selected) {

            // if (selected === 'source') {
            //     vm.sourcesVid = getVideoSources.data.sources;
            //     vm.sourcesAud = getAudioSources.data.sources;
            //
            //     $rootScope.loadingProgress = true;
            //     msApi.request('encoder_pearl.getLayouts@get', {channelId: vm.idChannel, layoutId: vm.idtemplate},
            //         function (response) {
            //             var test = "";
            //             var result;
            //             vm.trustedHtml = function (html) {
            //                 return $sce.trustAsHtml(html);
            //             };
            //             vm.background = 'black';
            //             $rootScope.loadingProgress = false;
            //             angular.forEach(response.data.characteristics_layout.video, function (value) {
            //                 vm.srcLayout = vm.source.replace("[idSource]", value.settings.source).replace("[timestimp]", moment().unix());
            //
            //                 test = "<div><img src=" + vm.srcLayout + " ></div>";
            //                 var el = document.createElement('div');
            //                 el.innerHTML = test;
            //                 el.childNodes[0].style.left = value.position.left;
            //                 el.childNodes[0].style.top = value.position.top;
            //                 el.childNodes[0].style.bottom = value.position.bottom;
            //                 el.childNodes[0].style.right = value.position.right;
            //                 el.childNodes[0].style.position = "absolute";
            //                 el.childNodes[0].style.color = "white";
            //                 result = result + el.childNodes[0].outerHTML;
            //             });
            //             vm.divHtmlVar = vm.trustedHtml(result);
            //         },
            //         function (response) {
            //             $rootScope.loadingProgress = false;
            //             if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            //                 $translate('VALIDATION.' + response.data.message).then(function (message) {
            //                     webTvGlobal.alertDialog(message);
            //                 }, function () {
            //                     webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            //                 });
            //             }
            //             else {
            //
            //                 webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            //
            //             }
            //         })
            //
            //
            //     // vm.divHtmlVar.style.left = vm.left;
            //     // vm.divHtmlVar.style.top = vm.top;
            //     // vm.divHtmlVar.style.color = "white";
            // }
            // if (getSurvey.data.survey)
            //     vm.surveyQuestions = getSurvey.data.survey.questions;

            fillData(selected);
            if (selected === 'form')
                getchannelStreaming();
            vm.selected = selected;
        }

        // function cancel() {
        //     $mdDialog.hide();
        // }

        // preveiwLive(vm.num, vm.live_id);

        // function startLive(live, id) {
        //
        //     vm.spinner = false;
        //     msApi.request('encodeur_start@get', {id: id, idLive: live, start: 1},
        //         function (res) {
        //             vm.spinner = true;
        //             vm.starts = "Idlive :  " + live.toString() + "    Start: 1";
        //             if (angular.isDefined(res.data)) {
        //                 console.log("Start channel (" + id + ") ### url pearl: " + res.data.url_pearl);
        //             }
        //         }, function (res) {
        //
        //         }
        //     );
        //
        //
        // }

        // function endLive(live, id) {
        //     vm.spinner = false;
        //     msApi.request('encodeur_start@get', {id: id, idLive: live, start: 0},
        //         function (res) {
        //             vm.spinner = true;
        //
        //             vm.ends = "Idlive :  " + live.toString() + "     Start: 0";
        //             if (angular.isDefined(res.data)) {
        //                 console.log("End channel (" + id + ") ### url pearl: " + res.data.url_pearl);
        //             }
        //         }, function (res) {
        //
        //         }
        //     );
        //
        //
        // }

        // function preveiwLive(id, live) {
        //     vm.spinner = false;
        //     msApi.request('encodeur_preview@get', {id: id, idLive: live.id},
        //         function (res) {
        //             vm.spinner = true;
        //
        //
        //             if (angular.isDefined(res.data)) {
        //                 vm.trustedUrl = $sce.trustAsResourceUrl(res.data.live_url_preview);
        //                 console.log("Preview channel (" + id + ") ### url pearl: " + vm.trustedUrl);
        //             }
        //             else {
        //                 console.log("pearl_live_url_preview_is_not_accessible");
        //             }
        //
        //
        //         }, function (res) {
        //             console.log("res not execute ");
        //
        //         }
        //     );
        //
        // }


        // function startRecorder(live, id, type) {
        //     vm.spinner = false;
        //     msApi.request('encodeur_start_recorder@get', {id: vm.tem, idLive: live, start: type},
        //         function (res) {
        //
        //             vm.spinner = true;
        //             if (angular.isDefined(res.data)) {
        //                 if (type === '1') {
        //                     console.log("Start recorder channel (" + id + ") ### url pearl: " + res.data.url_pearl);
        //                 } else {
        //                     console.log("end recorder channel (" + id + ") ### url pearl: " + res.data.url_pearl);
        //                 }
        //
        //             }
        //
        //
        //         }, function (res) {
        //
        //
        //         }
        //     );
        //
        // }

        // function getchannelTemplate(num) {
        //     vm.spinner = false;
        //     msApi.request('media_home.channelTemplate@get', {id: num},
        //         function (res) {
        //
        //             vm.templates = res.data.templates;
        //         }, function (res) {
        //
        //
        //         }
        //     );
        //
        // }

        function getchannelStreaming(num) {
            $rootScope.loadingProgress = true;
            msApi.request('encoder_pearl.channeldetailStreaming@get', {id: vm.idChannel},
                function (res) {
                    if (res.code === 200) {
                        vm.detailstream = res.data;
                        $rootScope.loadingProgress = false;


                    }

                },
                function (res) {


                }
            );

        }


        // function defaultTemplate(num) {
        //     vm.spinner = false;
        //     msApi.request('encoder_pearl.getDefaultTemplate@get', {id: num},
        //         function (res) {
        //             if (angular.isDefined(res.data)) {
        //                 vm.detailstream = res.data;
        //
        //                 vm.idtemplate = vm.detailstream.id_active_layout;
        //                 console.log(vm.idtemplate);
        //             }
        //             else {
        //
        //                 console.log("pearl_url_is_not_accessible");
        //
        //             }
        //
        //         },
        //         function (res) {
        //
        //             console.log("res not execute");
        //         }
        //     );
        //
        // }

        // function showAlert(id) {
        //     // $mdDialog.show({
        //     //
        //     //     templateUrl: 'app/main/media/lives/live/encodeurlive/confirmtemplate.html',
        //     //     clickOutsideToClose: true,
        //     //     controller: 'PopupControl',
        //     //     controllerAs: 'vm',
        //     //     locals: {
        //     //         paramsChannelpearl: paramsChannelpearl,
        //     //         id: id,
        //     //         num: vm.tem
        //     //     }
        //     // });
        //     vm.spinner = false;
        //     msApi.request('encoder_pearl.activeTemplate@get', {idChannel: vm.tem, idLayout: id},
        //         function (res) {
        //             if (res.code === 200) {
        //                 if (angular.isDefined(res.data)) {
        //                     vm.detailstream = res.data;
        //                     console.log("Active template (" + vm.tem + ") of channel (" + id + ") ### url pearl: " + vm.detailstream.url_pearl);
        //                     webTvGlobal.$toast().showSimple($translate.instant('LIVESPEARL.success_layout'));
        //                 }
        //
        //             }
        //
        //             else {
        //                 webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
        //
        //             }
        //         },
        //         function (response) {
        //             if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
        //                 $translate('VALIDATIONS.' + response.data.message).then(function (message) {
        //                     webTvGlobal.alertDialog(message);
        //                 }, function () {
        //                     webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        //                 });
        //             }
        //             else {
        //
        //                 webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        //
        //             }
        //         }
        //     );
        //
        // }


        function popup() {
            $mdDialog.show({

                templateUrl: 'app/main/media/lives/live/encodeurlive/popupconfig.html',
                clickOutsideToClose: true,
                controller: 'PopupControl',
                controllerAs: 'vm',
                locals: {
                    paramsChannelpearl: paramsChannelpearl,
                    id: '',
                    num: vm.tem
                }
            });
        }


        // function click(id, num) {
        //     if (id === '1') {
        //         getchannelTemplate(num);
        //         defaultTemplate(num);
        //         vm.toggle = id;
        //     }
        //     if (id === '01') {
        //         vm.isActive = false;
        //
        //         startLive(vm.live_id, num);
        //         vm.toggle = id;
        //
        //     }
        //     if (id === '00') {
        //         vm.isActive = true;
        //         endLive(vm.live_id, num);
        //         vm.toggle = id;
        //
        //     }
        //
        //     if (id === '3') {
        //
        //         vm.toggle = id;
        //     }
        //
        //
        //     if (id === '2') {
        //
        //         getchannelStreaming(num);
        //         vm.toggle = id;
        //     }
        //     preveiwLive(num, vm.live_id);
        //     vm.showme = id;
        //     vm.tem = num;
        //
        //
        // }


        function submitUpdatestreaming(num) {
            if (angular.isDefined(num)) {
            }
            else {
                num = vm.tem;
            }

            vm.streaming = {
                pswStreaming: vm.detailstream.pswStreaming || '',
                urlStreaming: vm.detailstream.urlStreaming || '',
                nameStreaming: vm.detailstream.nameStreaming || '',
                loginStreaming: vm.detailstream.loginStreaming || '',
                idchannel: vm.tem || ''


            };

            $rootScope.loadingProgress = true;
            msApi.request('encoder_pearl.Updatestreaming@save',

                {id: vm.idChannel, "empParametersStreamingForm": angular.copy(vm.streaming)},
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        vm.canal = vm.streaming;
                        webTvGlobal.$flashMessages().set('parametersstreamAdd', {title: vm.streaming.urlStreaming ? vm.streaming.urlStreaming : ""});
                        // https://192.168.1.112/api/channels/[channelId]/layouts/[layoutId]/preview?resolution=[widht]x[height]at=[timestimp]
                        //$state.go('app.chutier_list');
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                },
                function () {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );
        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.lives_list_encodeur_pearl";

            $rootScope.welcome = "welcome_live";
            $rootScope.text = [{
                texte: "add_button_live_help"
            }, {
                texte: "arrow_button_live_help"
            }, {
                texte: "search_area_live_help"
            }, {
                texte: "tri_column_live_help"
            },
                {
                    texte: "buttons_live_help"
                }];

        }

        vm.returnToList = returnToList;

        function returnToList() {
            if (angular.isUndefined($rootScope.currentState) || $rootScope.currentState === '') {
                $state.go('app.lives_list_ongoing', {diffusion: "endless"});
            }
            else {
                $state.go($rootScope.currentState);
            }
        }


        function fillData(type) {
            if (type === 'publish') {
                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.getPublishPearl@get",

                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            vm.stream = response.data.config_publish_pearl.streaming || false;
                            vm.record = response.data.config_publish_pearl.record || false;
                            vm.preview = response.data.config_publish_pearl.preview || false;

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    }

                    ,

                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                )

            }
            if (type === 'interact') {
                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.getInteractivityPearl@get",
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            vm.chatRoom = response.data.config_interactivity_pearl.chatRoom || false,
                                vm.sondage = response.data.config_interactivity_pearl.sondage || false,
                                vm.questions = response.data.config_interactivity_pearl.questions || false,
                                vm.commentaires = response.data.config_interactivity_pearl.commentaires || false,
                                vm.facebook = response.data.config_interactivity_pearl.facebook || false,
                                vm.twitter = response.data.config_interactivity_pearl.twitter || false,
                                vm.linkedIn = response.data.config_interactivity_pearl.linkedIn || false

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                )
            }
            if (type === 'prerol') {
                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.getRollPearl@get",
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            vm.preroll = response.data.config_roll_pearl.preRoll;
                            vm.postroll = response.data.config_roll_pearl.postRoll;

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                )
            }


    }

        vm.saveConf = saveConf;

        function saveConf(type) {

            if (type === 'publish') {

                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.addPublishPearl@get", {
                        streaming: vm.stream || false,
                        record: vm.record || false,
                        preview: vm.preview || false
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    })
            }
            if (type === 'interact') {
                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.addInteractivityPearl@get", {
                        chatRoom: vm.chatRoom || false,
                        sondage: vm.sondage || false,
                        questions: vm.questions || false,
                        commentaires: vm.commentaires || false,
                        facebook: vm.facebook || false,
                        twitter: vm.twitter || false,
                        linkedIn: vm.linkedIn || false
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    })
            }
            if (type === 'prerol') {
                if (vm.videoKeyNamePre)
                    vm.preroll = parameters['upload.server'] + parameters['upload.from_server_root_path'] + parameters['app.webtv.name'] + '/' + vm.videoKeyNamePre;
                if (vm.videoKeyNamePost)
                    vm.postroll = parameters['upload.server'] + parameters['upload.from_server_root_path'] + parameters['app.webtv.name'] + '/' + vm.videoKeyNamePost;

                $rootScope.loadingProgress = true;
                msApi.request("encoder_pearl.addRollPearl@get", {
                        preRoll: vm.preroll,
                        postRoll: vm.postroll
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));

                        } else {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    })

            }
        }

        vm.ngFlowOptionsPre = {
            chunkSize: (function () {
                return Math.pow(10, 8);
            })(),
            testChunks: false,
            target: parameters['upload.script_url'],
            singleFile: true,
            extendChunks: false,
            fileParameterName: 'Filedata',
            query: {
                webtv_name: parameters['app.webtv.name'],
                path_file: parameters['upload.from_server_root_path'],
                user_id: userManager.getId(),
                timestamp: moment().unix(),
                token: md5("unique_salt" + moment().unix()),
                callback_step_url: mediaVideoGetUrlUpdate.link_update_step
            }
        };
        vm.ngFlowOptionsPost = {
            chunkSize: (function () {
                return Math.pow(10, 8);
            })(),
            testChunks: false,
            target: parameters['upload.script_url'],
            singleFile: true,
            extendChunks: false,
            fileParameterName: 'Filedata',
            query: {
                webtv_name: parameters['app.webtv.name'],
                path_file: parameters['upload.from_server_root_path'],
                user_id: userManager.getId(),
                timestamp: moment().unix(),
                token: md5("unique_salt" + moment().unix()),
                callback_step_url: mediaVideoGetUrlUpdate.link_update_step
            }
        };
        vm.ngFlowPre = {
            flow: {}
        };
        vm.ngFlowPost = {
            flow: {}
        };
        vm.droppingPre = false;
        vm.droppingPost = false;

        vm.fileAddedPre = fileAddedPre;
        vm.fileAddedPost = fileAddedPost;
        vm.uploadFilePre = uploadFilePre;
        vm.uploadFilePost = uploadFilePost;
        vm.fileSuccessPre = fileSuccessPre;
        vm.fileSuccessPost = fileSuccessPost;
        vm.uploadCompletePost = uploadCompletePost;
        vm.uploadCompletePre = uploadCompletePre;
        vm.fileProgressPre = fileProgressPre;
        vm.fileProgressPost = fileProgressPost;
        vm.cancelUploadPre = cancelUploadPre;
        vm.cancelUploadPost = cancelUploadPost;
        vm.progressBarValuePre = 0;
        vm.progressBarValuePost = 0;
        vm.roundWithPrecision = roundWithPrecision;

        vm.inProgressPre = false;
        vm.inProgressPost = false;
        vm.videoKeyNamePre = "";
        vm.videoKeyNamePost = "";


        function fileAddedPre(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageNamePre = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            vm.videoFilePre = file;
        }

        function fileAddedPost(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageNamePost = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            vm.videoFilePost = file;
        }

        function fileProgressPre(file) {
            vm.progressBarValuePre = file.progress() * 100;
        }

        function fileProgressPost(file) {
            vm.progressBarValuePost = file.progress() * 100;
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFilePre() {
            // Set headers
            vm.ngFlowPre.flow.opts.headers = {};
            vm.ngFlowPre.flow.upload();
            vm.inProgressPre = true;
        }

        function uploadFilePost() {
            // Set headers
            vm.ngFlowPost.flow.opts.headers = {};
            vm.ngFlowPost.flow.upload();
            vm.inProgressPost = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccessPre(file, message) {
            var data = JSON.parse(message);
            if (angular.isDefined(data.file_name)) {
                vm.videoKeyNamePre = data.file_name;
            } else return;

        }

        function fileSuccessPost(file, message) {
            var data = JSON.parse(message);
            if (angular.isDefined(data.file_name)) {
                vm.videoKeyNamePost = data.file_name;
            } else return;

        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadCompletePre() {
            vm.progressBarValuePre = 0;
            vm.inProgressPre = false;
            if (angular.isDefined(vm.videoFilePre) && vm.videoKeyNamePre) {

                webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFilePre.name}), '', function () {
                    vm.videoKeyNamePre = "";
                }, false, 500).then(function () {
                });
            }
            else {
                if (!angular.isDefined(vm.videoFilePre) && vm.imageNamePre) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }

        }

        /**
         * Stop upload operation
         */
        function cancelUploadPre() {
            $timeout(function () {
                vm.ngFlowPre.flow.cancel();

            });
            vm.videoFilePre.name = "";
        }

        function cancelUploadPost() {
            $timeout(function () {
                vm.ngFlowPost.flow.cancel();

            });
            vm.videoFilePost.name = "";

        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadCompletePost() {
            vm.progressBarValuePost = 0;
            vm.inProgressPost = false;
            if (angular.isDefined(vm.videoFilePost) && vm.videoKeyNamePost) {

                webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFilePost.name}), '', function () {
                    vm.videoKeyNamePost = "";
                }, false, 500).then(function () {
                });
            }
            else {
                if (!angular.isDefined(vm.videoFilePost) && vm.imageNamePost) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }

        }
    }


})
();

(function () {
    'use strict';

    angular
        .module('app.lives.list', ['app.stats.vod_live', 'app.lives.diffuse', 'app.lives.encodeurlive', "datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_list', {
                url: "/lives/list",
                abstract: true
            })
            .state('app.lives_list_ongoing', {
                parent: 'app.lives_list',
                url: '?diffusion:type:ids',
                reloadOnSearch:false,
                views: {
                  'content@app'
                :
                  {
                    templateUrl: 'app/main/media/lives/live/list/list.template.html',
                      controller
                  :
                    'livesLiveListController as vm'
                  }
                }
              ,
                resolve: {
                  livesData: function () {
                    return "lives.dtableOnGoing@get";
                  }
                ,
                  contributorsData: function (msApi) {
                    return msApi.resolve('contributors.getContributors@get');
                  }
                ,
                  AbonnementUserData: function (msApi) {
                    return msApi.resolve('lives.AbonnementUserlist@get');
                  }
                ,
                  finish: function () {
                    return false;
                  }
                }
              ,
                "bodyClass"
              :
                "e-commerce"

            });


        // Api
        msApiProvider.register('lives.AbonnementUserlist', [Routing.generate('api_subscription_user_get_users')]);
        msApiProvider.register('lives.getOnGoinglives', [Routing.generate('api_get_on_going_lives')]);
        msApiProvider.register('lives.getUpCominglives', [Routing.generate('api_get_up_coming_lives')]);
        msApiProvider.register('lives.getArchivedlives', [Routing.generate('api_get_archived_lives')]);
        var deleteLivesRoute = Routing.generate('api_delete_lives_live') + "/:id";

        var enableLiveRoute = Routing.generate('api_post_enable_live') + "/:id";
        var disableLiveRoute = Routing.generate('api_post_disable_live') + "/:id";
        msApiProvider.register('live.enable', [enableLiveRoute, {id: '@id'}]);
        msApiProvider.register('live.disable', [disableLiveRoute, {id: '@id'}]);

        msApiProvider.register('livesLive.list', [Routing.generate('api_get_livess_live')]);
        msApiProvider.register('livesLive.delete', [deleteLivesRoute, {id: '@id'}]);
        msApiProvider.register('livesLive.modalGetLives', [Routing.generate('api_get_lives_live_detail', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('livesLive.mdelete', [deleteLivesRoute, {id: '@id'}]);
        msApiProvider.register('lives.sendIvitationMails', [Routing.generate('api_post_invitation_mails')]);
        msApiProvider.register('lives.getExportDetail', [Routing.generate('api_getlink_export', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('lives.reviveLive', [Routing.generate('api_post_live_revive', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('lives.getLiveDetail', [Routing.generate('api_get_live_detail', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('lives.addScreenShare', [Routing.generate('api_add_screen_share', {
            id: ':id',
            screenType: ':screenType'
        }).replace(/%3A/, ":"), {id: '@id', screenType: '@screenType'}]);
        msApiProvider.register('lives.getDownloadScreenShareFile', [Routing.generate('api_get_url_jnlp_file', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('lives.dtableArchieved', [Routing.generate('api_dtable_list_dtable_lives_archived')]);
        msApiProvider.register('lives.dtableOnGoing', [Routing.generate('api_dtable_list_dtable_lives_endless')]);
        msApiProvider.register('lives.dtableAll', [Routing.generate('api_dtable_list_dtable_lives_all')]);
        msApiProvider.register('lives.dtableUpComing', [Routing.generate('api_dtable_list_dtable_lives_upcoming')]);
        var deleteListLives = Routing.generate('api_multi_delete_livess') + "/:list";
        msApiProvider.register('lives.deleteLives', [deleteListLives, {list: '@list'}]);
        msApiProvider.register('lives.getUrlListLive', [Routing.generate('api_get_url_list_live')]);

    }


})();

(function () {
  angular
    .module('app.lives.list')
    .controller('screenShareController', screenShareController);

  /** @ngInject */
  function screenShareController($mdDialog) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.param;
    vm.cancel = cancel;
    vm.validate = validate;

    function validate() {
      $mdDialog.hide(vm.param);
    }

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.diffuse', [])
        .constant('IS_NEW_JITSI', window.process.env.isNewJitsi)
        .controller('MainController', MainController)
        .config(['$stateProvider', '$httpProvider', 'msApiProvider', 'IS_NEW_JITSI', config]);

    MainController.$inject = ['$scope', 'IS_NEW_JITSI'];

    function MainController($scope, IS_NEW_JITSI) {
        $scope.isNewJitsi = IS_NEW_JITSI;
    }

    /** @ngInject */
    function config($stateProvider, $httpProvider, msApiProvider, IS_NEW_JITSI) {
        $stateProvider
            .state('app.lives_diffuse', {
                url    :"/lives/:id/diffuse",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/diffusion/template.diffusion.html',
                        controller : 'livesLiveDiffusionJitsiController as vm'
                    }
                },
                resolve: {
                    urlJitsi: function (msApi,$stateParams) {
                        return msApi.resolve('livesLiveDiffusion.urlJitsi@get',{id:$stateParams.id});
                    }
                }
            })
          .state('app.lives_extern_diffuse', {
            url    :"/lives/:id/diffuse/extern",
            views  : {
              'content@app': {
                templateUrl: 'app/main/media/lives/live/diffusion/templateExtern.diffusion.html',
                controller : 'livesLiveExternDiffusionController as vm'
              }
            },
            resolve: {
              livesData: function (msApi,$stateParams)
              {
                return msApi.resolve('livesLiveDiffusion.getNewLives@get',{id:$stateParams.id});
              }
            }
          })
            .state('app.lives_diffuse_jitsi', {
                url    :"/lives/:id/diffuse/live-web",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/diffusion/template.diffusion.html',
                        controller : 'livesLiveDiffusionJitsiController as vm'
                    }
                },
                resolve: {
                    urlJitsi: function (msApi,$stateParams) {
                        return msApi.resolve('livesLiveDiffusion.urlJitsi@get',{id:$stateParams.id});
                    }
                }
            });

        msApiProvider.register('livesLiveDiffusion.getNewLives', [Routing.generate('api_get_lives_live_detail',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('livesLiveDiffusion.syncRTC', [Routing.generate('api_sync_r_t_c')]);
        msApiProvider.register('livesLiveDiffusion.writeLog', [Routing.generate('api_write_log')]);
        if (IS_NEW_JITSI) {
            msApiProvider.register('livesLiveDiffusion.urlJitsi',  [Routing.generate('api_get_url_jitsi_fo', { id: ':id' }).replace(/%3A/,":").replace(/\/lives\//, "/live/")]);
        } else {
            msApiProvider.register('livesLiveDiffusion.urlJitsi', [Routing.generate('api_get_url_jitsi_fo',{id: ':id'}).replace(/%3A/,":")]);

        }
        msApiProvider.register('livesLiveDiffusion.startLiveExtern', [apiGo + 'live/change-active'+"/:id", {id: '@id'}]);
        msApiProvider.register('livesLiveDiffusion.stopLiveExtern', [apiGo + 'live/change-status'+"/:id", {id: '@id'}]);
        msApiProvider.register('livesLiveDiffusion.externLiveInfo', [Routing.generate('api_get_lives_live_info',{id: ':id'}).replace(/%3A/,":")]);


        var enableLiveRoute = Routing.generate('api_post_enable_live') + "/:id";
        var disableLiveRoute = Routing.generate('api_post_disable_live') + "/:id";
        var endedLiveRoute = Routing.generate('api_post_live_ended') + "/:id";
        msApiProvider.register('live.enableExtern', [enableLiveRoute, {id: '@id'}]);
        msApiProvider.register('live.disableExtern', [disableLiveRoute, {id: '@id'}]);
        msApiProvider.register('live.endedLiveExtern', [endedLiveRoute, {id: '@id'}]);


    }
})();

(function () {
  angular
    .module('app.lives.diffuse')
    .controller('modifySlideController', modifySlideController);

  /** @ngInject */
  function modifySlideController($scope, $mdDialog, $rootScope, webTvGlobal, $translate, id) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    $scope.add = false;
    $scope.time = "--:--:--";
    $scope.imageName;
    $scope.slideFile;
    $scope.inProgress = true;
    $scope.progressBarValue = 10;
    $scope.progress = false;
    $scope.ngFlowImageOptions = {
      chunkSize: (function () {
        return Math.pow(10, 8);
      })(),
      testChunks: false,
      target: Routing.generate('api_post_lives_slide'),
      singleFile: true,
      extendChunks: false,
      fileParameterName: 'empApiFileForm[thumb]'
    };
    $scope.ngFlow = {
      flow: {}
    };
    $scope.ngFlowImage = {
      flow: {}
    };
    var slide = {};
    $scope.fileImgAdded = fileImgAdded;
    $scope.fileProgress = fileProgress;
    $scope.uploadFileImage = uploadFileImage;
    $scope.fileSuccess = fileSuccess;
    $scope.uploadComplete = uploadComplete;

    function fileImgAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        $scope.imageName = false;
        webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.alert_not_valid_slide_image_message'));
        return false;
      }
      $scope.progress = true;
      $scope.slideFile = file;
      $rootScope.loadingProgress = true;
      $scope.inProgress = false;
    }

    function fileProgress(file) {
      $scope.progressBarValue = Math.floor(file.progress() * 100);
    }

    function uploadFileImage() {
      $scope.ngFlowImage.flow.opts.headers = {};
      $scope.ngFlowImage.flow.upload();
      $scope.inProgress = true;
    }

    function fileSuccess(file, message) {
      var data = null;
      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      $scope.slideFileName = $scope.slideFile.name;
      if (angular.isDefined($scope.slideFile)) {
        if (angular.isDefined(data.location.url)) {
          slide = {
            "ID": id,
            "TimeCode": $scope.time,
            "Title": data.location.path,
            "Name": data.location.url,
            "Order": null
          };
        }
      } else {
        webTvGlobal
          .$toast()
          .showSimple($translate.instant('MESSAGES.alert_xhr_error'), {}, 1000, true);
      }

      if (/^ERROR !$/.test(message) || /^ERROR$/.test(message)) return;
    }

    function uploadComplete() {
      $scope.progressBarValue = 0;
      $scope.inProgress = false;
      $rootScope.loadingProgress = false;
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.file_import'), {}, 1000, true);
      $mdDialog.hide(slide);
    }

    $scope.cancel = function () {
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
      $mdDialog.cancel();
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.lives.diffuse')
    .controller('livesLiveDiffusionController', livesLiveDiffusionController)
    .controller('livesLiveDiffusionJitsiController', livesLiveDiffusionJitsiController)
    .controller('livesLiveExternDiffusionController', livesLiveExternDiffusionController);

  /** @ngInject */
  function livesLiveDiffusionController($window, webTvGlobal, $scope, livesData, $injector, swfService) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var $timeout = $injector.get('$timeout'),
      $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      $filter = $injector.get('$filter'),
      msApi = $injector.get('msApi');


    var vm = this;
    var livedata = livesData.data;
    vm.lives = livedata.live;
    var params = {
      Stream_name: vm.lives.streamName,
      UrlDiffusion: livedata.urlDiffusion,
      debug: false,
      live_id: vm.lives.id,
      rm: {'chapitres': [], 'chapitresTmp': [], 'slides': [], 'slidesTmp': []}
    };

    var start = true;
    var ratio = "16/9";
    var chapterId = 0;
    var slideId = 0;
    var compteurLiveSeconde = 0;
    var swfVersionStr = "9.0.124";
    var xiSwfUrlStr = "";
    var flApp;
    var flashvars = {
      d: params.debug
    };
    var origin = window.location.origin;
    var pathname = window.location.pathname;
    var baseIndex = pathname.indexOf("/lives");
    var base = origin + pathname.slice(0, baseIndex);
    var config_object = {
      fps: 15,
      width: 460,
      height: 258,
      bdwith: 6,
      bitrate: 3,
      samplerate: 4
    };
    var counterLive;
    var parameters = {};
    var attributes = {};
    parameters.quality = "high";
    parameters.play = "true";
    parameters.loop = "false";
    parameters.wmode = "transparent";
    parameters.scale = "showall";
    parameters.menu = "false";
    parameters.devicefont = "true";
    parameters.salign = "";
    parameters.allowscriptaccess = "sameDomain";
    parameters.allowFullScreen = "true";
    attributes.id = "flApp";
    attributes.name = "flApp";
    attributes.align = "middle";

    vm.clickedVideo = false;
    vm.clickedChapter = false;
    vm.clickedSlide = false;
    vm.clickedMicro = false;
    vm.videoActivate = true;
    vm.audioActivate = true;
    vm.counter = "00:00:00";
    vm.translateStart = "LIVEDIFFUSION.start";
    vm.recordButton = "#43A047";
    vm.recordClass = "button-start-glow";
    vm.videoState = "video-on-button";
    vm.videoButtonIcon = "icon-camcorder";
    vm.audioState = "video-on-button";
    vm.audioButtonIcon = "icon-microphone";
    vm.translateVideoActivation = "LIVEDIFFUSION.disable_video";
    vm.translateAudioActivation = "LIVEDIFFUSION.disable_audio";
    vm.lowResolutionClass = "resolutionActivated";
    vm.medResolutionClass = "";
    vm.highResolutionClass = "";
    vm.normalRatioClass = "resolutionActivated";
    vm.smallRatioClass = "";
    vm.cameras = [];
    vm.cameraSelected = "";
    vm.micSelected = "";
    vm.mics = [];
    vm.activated = false;
    vm.volume = 50;
    vm.resolution = "Med";
    vm.ratioSelected = "16:9";
    vm.chapter = {};
    vm.slide = {};
    vm.chapters = [];
    vm.slides = [];
      var chapters =livedata.chapters;
      var slides =livedata.slides;
      angular.forEach(chapters, function (value) {
          var chap = {
              "ID": value.id,
              "TimeCode": value.timeCode?value.timeCode:"00:00:00",
              "Title": value.title,
              "Diffuse": false
          };
          vm.chapters.push(chap);

      });
      vm.chapters = sortValues(vm.chapters);
      angular.forEach(slides, function (value) {
          var slid = {
              "ID": value.id,
              "TimeCode": value.timeCode?value.timeCode:"00:00:00",
              "Title": value.slide,
              "Name": value.urlSlide,
              "Order": value.slideOrder,
              "Diffuse" : false
          };
          vm.slides.push(slid);
      });
      vm.slides = sortValues(vm.slides);


    vm.recordingStart = recordingStart;
    vm.videoActivation = videoActivation;
    vm.audioActivation = audioActivation;
    vm.resolutionChange = resolutionChange;
    vm.ratioChange = ratioChange;
    vm.volumeChanged = volumeChanged;
    vm.audioSelect = audioSelect;
    vm.videoSelect = videoSelect;
    vm.compteur = compteur;
    vm.clickVideoListItem = clickVideoListItem;
    vm.clickChapterListItem = clickChapterListItem;
    vm.clickSlideListItem = clickSlideListItem;
    vm.clickMicroListItem = clickMicroListItem;
    vm.addSlide = addSlide;
    vm.addChapter = addChapter;
    vm.confirmDeleteChapter = confirmDeleteChapter;
    vm.confirmDeleteSlide = confirmDeleteSlide;
    vm.modifyChapter = modifyChapter;
    vm.broadcastSlide = broadcastSlide;
    vm.slideBroadcasted = slideBroadcasted;
    vm.modifySlide = modifySlide;
    vm.broadcastChapter = broadcastChapter;


      function broadcastChapter(chapter) {
          if (uniqueValue({TimeCode: vm.counter}, params.rm.chapitresTmp)) {
              chapter.TimeCode = vm.counter;
              params.rm.chapitresTmp.push(chapter);
              var index = vm.chapters.indexOf(chapter);
              vm.chapters[index].Diffuse = true;
              sortValues(params.rm.chapitresTmp);
              updateRM();

          } else {
              webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
          }
      }

    window.connexion = connexion;
    window.deconnexion = deconnexion;
    window.demarrerLesServices = demarrerLesServices;
    window.fireError = fireError;
    window.listCams = listCams;
    window.listMics = listMics;
    window.write_log = write_log;
    function write_log(msg) {
        msApi.request('livesLiveDiffusion.writeLog@save',
            {
                file_log: "encoder_flash_",
                message: msg
            },
            function (res) {
            })
    }


    $scope.$on('$viewContentLoaded', function () {
      var flashVersion = swfService.getFlashPlayerVersion();
      if (flashVersion.major > 0 || flashVersion.minor > 0 || flashVersion.release > 0) {
        $timeout(function () {
          swfService.embedSWF(
            base + "/app/swf/encoder.swf", "flashContent",
            "900", "670",
            swfVersionStr, xiSwfUrlStr,
            flashvars, parameters, attributes
          );
          vm.activated = true;
          flApp = document.getElementById("flApp");
        }, 5000);
      } else {
        //Flash is not installed
        var confirm = $mdDialog.confirm()
          .title($translate.instant('MESSAGES.alert_error'))
          .htmlContent($translate.instant('LIVEDIFFUSION.alert_flash_not_found'))
          .ariaLabel($translate.instant('LIVEDIFFUSION.alert_flash_not_found'))
          .ok($translate.instant('LIVEDIFFUSION.install_flash'))
          .cancel($translate.instant('MESSAGES.dialog_cancel'));
        $mdDialog.show(confirm).then(function () {
          $window.open('https://get.adobe.com/flashplayer');
        })
      }

    });

    function connexion() {
      flApp.connexion();
    }

    function deconnexion() {
      flApp.deconnexion();
    }

    function syncStreamInfo() {
      var data = params.UrlDiffusion + "\trecord\t" + params.Stream_name;
      flApp = document.getElementById("flApp");
      flApp.connexion(data);
    }

    function demarrerLesServices(i) {
      if (i === 1) {
        syncStreamInfo();
      } else if (i === 2) {
        resolutionChange()
      }

    }

    function fireError(state) {
      webTvGlobal.alertDialog(state);

    }

    function recordingStart() {
      if (start) {


      } else {


      }

    }

    function videoActivation() {
      if (vm.videoActivate) {
        vm.videoActivate = false;
        vm.videoButtonIcon = "icon-camcorder-off";
        vm.videoState = "video-off-button";
        vm.translateVideoActivation = "LIVEDIFFUSION.activate_video";
        flApp.disableCam();

      }
      else {
        vm.videoActivate = true;
        vm.videoButtonIcon = "icon-camcorder";
        vm.videoState = "video-on-button";
        vm.translateVideoActivation = "LIVEDIFFUSION.disable_video";
        flApp.enableCam(0);
        vm.cameraSelected = vm.cameras[0];

      }
    }

    function audioActivation() {
      if (vm.audioActivate) {
        vm.audioActivate = false;
        vm.audioButtonIcon = "icon-microphone-off";
        vm.audioState = "video-off-button";
        vm.translateAudioActivation = "LIVEDIFFUSION.activate_audio";
        vm.volume = 0;
        volumeChanged();
        flApp.disableMicro();
      }
      else {
        vm.audioActivate = true;
        vm.audioButtonIcon = "icon-microphone";
        vm.audioState = "video-on-button";
        vm.translateAudioActivation = "LIVEDIFFUSION.disable_audio";
        vm.volume = 50;
        volumeChanged();
        flApp.enableMicro(0, vm.mics.indexOf(vm.micSelected));

      }
    }

    function resolutionChange() {
      if (vm.resolution === "Low") {
        setConfigFaible();
        majSetting();

      } else {
        if (vm.resolution === "Med") {
          setConfigMoyenne();
          majSetting();

        } else {
          setConfigHaut();
          majSetting();
        }
      }
    }

    function ratioChange() {
      ratio = vm.ratioSelected;
      majConfigCam()

    }

    function volumeChanged() {
      majSetting()
    }

    function audioSelect() {
      var index = vm.mics.indexOf(vm.micSelected);
      flApp.selectMic(0, index);
    }

    function videoSelect() {
      var index = vm.cameras.indexOf(vm.cameraSelected);
      flApp.selectCam(index);
    }

    function listCams(list) {
      vm.cameras = list;
      vm.cameraSelected = list[0];
    }

    function listMics(list) {
      vm.mics = list;
      vm.micSelected = list[0];
    }

    function majConfigCam() {
      switch (vm.resolution) {
        case "Low":
          setConfigFaible();
          break;
        case "Med":
          setConfigMoyenne();
          break;
        case "High":
          setConfigHaut();
          break;
        default:
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          break;
      }
      majSetting();
    }


    function setConfigHaut() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 960;
      config_object.height = format === "4/3" ? 720 : 540;
      config_object.bdwith = 1500;
      config_object.bitrate = 10;
      config_object.samplerate = 44;
    }

    function setConfigMoyenne() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 640;
      config_object.height = format === "4/3" ? 480 : 360;
      config_object.bdwith = 1200;
      config_object.bitrate = 9;
      config_object.samplerate = 22;
    }

    function setConfigFaible() {
      var format = ratio;
      config_object.fps = 15;
      config_object.width = 480;
      config_object.height = format === "4/3" ? 360 : 270;
      config_object.bdwith = 400;
      config_object.bitrate = 8;
      config_object.samplerate = 11;
    }


    function majSetting() {
      //camera
      var fps = config_object.fps;
      var width = config_object.width;
      var height = config_object.height;
      var bdwith = config_object.bdwith * 1000;
      //micro
      var volume = vm.volume;
      var codec = 0;
      var bitrate = config_object.bitrate;
      var samplerate = config_object.samplerate;

      if (angular.isDefined(flApp)) {
        flApp.majSetting(bdwith, fps, width, height, volume, codec, bitrate, samplerate, true, true);

      }

    }

    function compteur() {
      compteurLiveSeconde++;
      var diffTime = compteurLiveSeconde;
      var h = parseInt(diffTime / 3600);
      diffTime -= h * 3600;
      var m = parseInt(diffTime / 60);
      var s = (diffTime % 3600) % 60;
      var heure;
      if (h < 10) {
        heure = "0" + h.toString();
      } else {
        heure = h.toString();
      }
      var minute;
      if (m < 10) {
        minute = "0" + m.toString();
      } else {
        minute = m.toString();
      }
      var seconde;
      if (s < 10) {
        seconde = "0" + s.toString();
      } else {
        seconde = s.toString();
      }
      vm.counter = heure + ":" + minute + ":" + seconde;
      counterLive = $timeout(vm.compteur, 1000)

    }

    function clickVideoListItem() {
      vm.clickedVideo = !vm.clickedVideo;
    }

    function clickChapterListItem() {
      vm.clickedChapter = !vm.clickedChapter;
    }

    function clickSlideListItem() {
      vm.clickedSlide = !vm.clickedSlide;
    }

    function clickMicroListItem() {
      vm.clickedMicro = !vm.clickedMicro;
    }

    function addSlide() {
        var time = vm.counter;
        $rootScope.time = time;
      var id = incremanteId(slideId);
      slideId++;
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/diffusion/add.slide.html',
        clickOutsideToClose: true,
        controller: "addSlideController",
        fullscreen: true
      }).then(function (slides) {
          vm.slides = vm.slides.concat(slides);
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function addChapter() {
      var time = vm.counter;
      var id = incremanteId(chapterId);
      chapterId++;
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/diffusion/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.time = time;
          $scope.text = "";
          $scope.add = true;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;
          $scope.timeExist = false;
          $scope.confirmAdd = confirmAdd;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmAdd() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }
          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters.push(chapter);
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );


    }

    function confirmDeleteChapter(chapter) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteChapter(chapter);

      }, function () {

      });
    }

    function confirmDeleteSlide(slide) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteSlide(slide);

      }, function () {

      });
    }

    function deleteChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      vm.chapters.splice(index, 1);
      // params.rm.chapitres = vm.chapters.slice();
      // updateRM();
    }

    function deleteSlide(slide) {
      var index = vm.slides.indexOf(slide);
      vm.slides.splice(index, 1);
      // params.rm.slidesTmp = vm.slides.slice();
      // updateRM();
    }

    function modifyChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/diffusion/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.add = false;
          $scope.time = chapter.TimeCode;
          $scope.text = chapter.Title;
          $scope.id = chapter.ID;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;

          $scope.timeExist = false;
          $scope.confirmModify = confirmModify;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmModify() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: $scope.id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: $scope.id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }

          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters[index] = chapter;
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );
    }

    function broadcastSlide(slide) {
        if (uniqueValue({TimeCode: vm.counter}, params.rm.slidesTmp)) {
            slide.TimeCode = vm.counter;
            params.rm.slidesTmp.push(slide);
            var index = vm.slides.indexOf(slide);
            vm.slides[index].Diffuse = true;
            sortValues(params.rm.slidesTmp);
            updateRM();

        } else {
            webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
        }

    }

    function slideBroadcasted(slide) {
      return (slide.TimeCode === "--:--:--");
    }

    function modifySlide(slide) {

      var id = slide.ID;
      var time = slide.TimeCode;
      var index = vm.slides.indexOf(slide);
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/diffusion/add.slide.html',
        clickOutsideToClose: true,
        controller: "modifySlideController",
        fullscreen: true
      }).then(function (slideModified) {
              slideModified.TimeCode = time;
          vm.slides[index] = slideModified;
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function uniqueValue(item, items) {
      var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
      return (angular.isUndefined(unique));
    }

    String.prototype.toSeconds = function () {
      var sec_num = this.split(':');
      var hour = parseInt(sec_num[0]);
      var minute = parseInt(sec_num[1]);
      var seconds = parseInt(sec_num[2]);
      return seconds + minute * 60 + hour * 3600;
    };

    function sortValues(items) {
      var arrayToSort = items;
      if (arrayToSort.length) {
        arrayToSort.sort(function (a, b) {
          if (angular.isDefined(a.TimeCode) && angular.isDefined(b.TimeCode)) {
            return a.TimeCode.toSeconds() - b.TimeCode.toSeconds();
          }
          else {
            return 0;
          }
        });
      }
      return arrayToSort;
    }


    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.form_diffusion_title_menu_title";
        if (angular.isUndefined($rootScope.currentState)) {
            $rootScope.pageRoute = 'app.lives_list_ongoing';
        }
        else {
            $rootScope.pageRoute = $rootScope.currentState;
        }
        $rootScope.welcome = "";

    }

    function updateRM() {
        params.rm.slides=params.rm.slidesTmp;
        params.rm.chapitres=params.rm.chapitresTmp ;
      msApi.request('livesLiveDiffusion.syncRTC@save',
        {
          live_id: vm.lives.id,
          rm: params.rm
        },
        function (res) {
          if (res.message === 'success') {
            webTvGlobal
              .$toast()
              .showSimple($translate.instant('LIVEDIFFUSION.live_rm_update'), {}, 1000, true);
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        })
    }

    function incremanteId(id) {
      id = id + 1;
      return vm.lives.id + "_" + id;
    }
  }
  function livesLiveDiffusionJitsiController($cookies, $sce,$scope, webTvGlobal, $injector,urlJitsi,$mdDialog,$state) {
      var myEl = angular.element(document.querySelector('#content'));
      if (angular.isDefined(myEl)) ;
      myEl.removeClass('animate-slide-up');
      var $rootScope = $injector.get('$rootScope');
      var vm = this;
      if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().use_jitsi)) vm.use_jitsi = webTvGlobal.$constant().webTvParameterBag().use_jitsi;
      else vm.use_jitsi = '0';
      vm.use_jitsi = vm.use_jitsi == "1" || vm.use_jitsi == true || angular.isDefined(urlJitsi.url) ? true : false;
      if(vm.use_jitsi){
        vm.urlJitsi = $sce.trustAsResourceUrl(urlJitsi.url);
      }
    vm.confirmChangeState=false
      if ($state.current.name==="app.lives_diffuse_jitsi"){
        if(document.getElementById("theme-config"))
            document.getElementById("theme-config").style.display="none"
      }else{
        if(document.getElementById("theme-config"))
            document.getElementById("theme-config").style.display="flex"

      }
      $rootScope.$on('$stateChangeStart',
          function(event, toState, toParams, fromState, fromParams){
            if ((fromState.name==="app.lives_diffuse_jitsi" || fromState.name==="app.lives_diffuse") && !vm.confirmChangeState){
              $mdDialog.show({
                templateUrl: 'app/main/media/lives/live/diffusion/modalDiffusion.template.html',
                clickOutsideToClose: true,
                controller: function($scope, $mdDialog, $rootScope,$injector) {
                  var $state = $injector.get('$state');
                  $scope.cancel = cancel;
                  $scope.confirm=confirm;

                  function cancel() {
                    $mdDialog.hide();
                  }
                  function confirm(){
                    vm.confirmChangeState=true;
                    $mdDialog.hide();
                      if (toState.name === "app.lives_list_ongoing") {
                          var params = {diffusion: "endless"};
                          $state.go(toState.name, params);
                      }else{
                          $state.go(toState.name);
                      }
                   // $state.go(toState.name);
                      setTimeout(function(){
                        if(document.getElementById("theme-config"))
                            document.getElementById("theme-config").style.display="flex";
                        }, 500);

                  }
                },


              });

            }
            if (!vm.confirmChangeState){
              event.preventDefault();

            }
          });

    window.onbeforeunload = function(){
      return "Do you want to leave?"
    }
    try{
        if($cookies.get('layoutStyle') ==="horizontalNavigation") {
            document.querySelector('#url_jitsi').style.height = window.innerHeight - 150 + "px"
        }else{
            document.querySelector('#url_jitsi').style.height = window.innerHeight - 100 + "px"
        }
      }
      catch(e){

      }
      initHelp();
      function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.form_diffusion_title_menu_title";
            $rootScope.titre3 = ""
            if (angular.isUndefined($rootScope.currentState)) {
                $rootScope.pageRoute = 'app.lives_list_ongoing';
            }
            else {
                $rootScope.pageRoute = $rootScope.currentState;
            }
            $rootScope.welcome = "";

        }
  }
  function livesLiveExternDiffusionController($window, webTvGlobal, $scope,$sce, livesData, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var $timeout = $injector.get('$timeout'),
      $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      $filter = $injector.get('$filter'),
      msApi = $injector.get('msApi');


    var vm = this;
    var livedata = livesData.data;
    vm.lives = livedata.live;
    vm.compteur = compteur;
    function compteur() {
      compteurLiveSeconde++;
      var diffTime = compteurLiveSeconde;
      var h = parseInt(diffTime / 3600);
      diffTime -= h * 3600;
      var m = parseInt(diffTime / 60);
      var s = (diffTime % 3600) % 60;
      var heure;
      if (h < 10) {
        heure = "0" + h.toString();
      } else {
        heure = h.toString();
      }
      var minute;
      if (m < 10) {
        minute = "0" + m.toString();
      } else {
        minute = m.toString();
      }
      var seconde;
      if (s < 10) {
        seconde = "0" + s.toString();
      } else {
        seconde = s.toString();
      }
      vm.counter = heure + ":" + minute + ":" + seconde;
      counterLive = $timeout(vm.compteur, 1000)

    }
    var params = {
      Stream_name: vm.lives.streamName,
      UrlDiffusion: livedata.urlDiffusion,
      debug: false,
      live_id: vm.lives.id,
      rm: {'chapitres': [], 'chapitresTmp': [], 'slides': [], 'slidesTmp': []}
    };

    var start = true;
    var ratio = "16/9";
    var chapterId = 0;
    var slideId = 0;
    var compteurLiveSeconde = 0;
    var swfVersionStr = "9.0.124";
    var xiSwfUrlStr = "";
    var flApp;
    var flashvars = {
      d: params.debug
    };
    var origin = window.location.origin;
    var pathname = window.location.pathname;
    var baseIndex = pathname.indexOf("/lives");
    var base = origin + pathname.slice(0, baseIndex);
    var config_object = {
      fps: 15,
      width: 460,
      height: 258,
      bdwith: 6,
      bitrate: 3,
      samplerate: 4
    };
    var counterLive;
    var parameters = {};
    var attributes = {};
    parameters.quality = "high";
    parameters.play = "true";
    parameters.loop = "false";
    parameters.wmode = "transparent";
    parameters.scale = "showall";
    parameters.menu = "false";
    parameters.devicefont = "true";
    parameters.salign = "";
    parameters.allowscriptaccess = "sameDomain";
    parameters.allowFullScreen = "true";
    attributes.id = "flApp";
    attributes.name = "flApp";
    attributes.align = "middle";

    vm.clickedChapter = false;
    vm.clickedSlide = false;
    vm.counter = "00:00:00";
    vm.translateStart = "LIVEDIFFUSION.start";
    vm.recordButton = "#43A047";
    vm.recordClass = "button-start-glow";
    vm.activated = false;
    vm.volume = 50;
    vm.chapter = {};
    vm.slide = {};
    vm.chapters = [];
    vm.slides = [];
    var chapters =livedata.chapters;
    var slides =livedata.slides;
    if(livedata.live.active){
      vm.translateStart = "LIVEDIFFUSION.stop";
      vm.recordButton = "#E53935";
      vm.recordClass = "button-end-glow";
      counterLive = $timeout(vm.compteur, 1000);
      start = false;
      vm.activated = true;
      vm.showLoading = false;
      vm.activated = true;
    }
    angular.forEach(chapters, function (value) {
      var chap = {
        "ID": value.id,
        "TimeCode": value.timeCode?value.timeCode:"00:00:00",
        "Title": value.title,
        "Diffuse": false
      };
      vm.chapters.push(chap);

    });
    vm.chapters = sortValues(vm.chapters);
    angular.forEach(slides, function (value) {
      var slid = {
        "ID": value.id,
        "TimeCode": value.timeCode?value.timeCode:"00:00:00",
        "Title": value.slide,
        "Name": value.urlSlide,
        "Order": value.slideOrder,
        "Diffuse" : false
      };
      vm.slides.push(slid);
    });
    vm.slides = sortValues(vm.slides);


    vm.recordingStart = recordingStart;
    vm.clickChapterListItem = clickChapterListItem;
    vm.clickSlideListItem = clickSlideListItem;
    vm.addSlide = addSlide;
    vm.addChapter = addChapter;
    vm.confirmDeleteChapter = confirmDeleteChapter;
    vm.confirmDeleteSlide = confirmDeleteSlide;
    vm.modifyChapter = modifyChapter;
    vm.broadcastSlide = broadcastSlide;
    vm.slideBroadcasted = slideBroadcasted;
    vm.modifySlide = modifySlide;
    vm.broadcastChapter = broadcastChapter;
    function broadcastChapter(chapter) {
      if (uniqueValue({TimeCode: vm.counter}, params.rm.chapitresTmp)) {
        chapter.TimeCode = vm.counter;
        params.rm.chapitresTmp.push(chapter);
        var index = vm.chapters.indexOf(chapter);
        vm.chapters[index].Diffuse = true;
        sortValues(params.rm.chapitresTmp);
        updateRM();

      } else {
        webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
      }
    }

    window.demarrerLesServices = demarrerLesServices;
    window.fireError = fireError;
    window.write_log = write_log;
    vm.height_iframe="100%";
    window.onresize = function(event) {
      rerangePlayer()
    };

    function write_log(msg) {
      msApi.request('livesLiveDiffusion.writeLog@save',
        {
          file_log: "encoder_flash_",
          message: msg
        },
        function (res) {
        })
    }
    msApi.request('livesLiveDiffusion.externLiveInfo@get', {id: vm.lives.id , y : 'bo'},
      function (res) {
        $rootScope.loadingProgress = false;
        if(res.code===200){
          vm.url_live = $sce.trustAsResourceUrl(res.data.urlPlayer);
          rerangePlayer()
        }
      },function () {
        vm.errorPage = true;
      }
    );


    function demarrerLesServices(i) {
      if (i === 1) {
        syncStreamInfo();
      } else if (i === 2) {
        resolutionChange()
      }

    }

    function fireError(state) {
      webTvGlobal.alertDialog(state);

    }
    function rerangePlayer() {
      var width = document.getElementById('content-extern-live').offsetWidth;
      var height = (width * 9) / 16;
      vm.height_iframe = height +"px";
    }
    function recordingStart() {

      if (start) {
        msApi.request('live.enableExtern@save',{id:vm.lives.id},
          function () {
            webTvGlobal
              .$toast()
              .showSimple($translate.instant('LIVEDIFFUSION.live_start_stream'), {}, 1000, true);
            vm.translateStart = "LIVEDIFFUSION.stop";
            vm.recordButton = "#E53935";
            vm.recordClass = "button-end-glow";
            counterLive = $timeout(vm.compteur, 1000);
            start = false;
            vm.activated = true;
            vm.showLoading = false;
            vm.activated = true;
            rerangePlayer();
          },
          function () {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          })

      } else {

        msApi.request('live.disableExtern@save',{id: vm.lives.id},
          function () {

            msApi.request('live.endedLiveExtern@save',{id: vm.lives.id},
              function () {},
              function () {
            })
            webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.live_end_stream'));
            vm.translateStart = "LIVEDIFFUSION.start";
            vm.recordButton = "#43A047";
            vm.recordClass = "button-start-glow";
            vm.counter = "00:00:00";
            compteurLiveSeconde = 0;
            $timeout.cancel(counterLive);
            start = true;
            vm.activated = false;
            rerangePlayer();
            },
          function () {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          })
      }

    }

    function clickChapterListItem() {
      vm.clickedChapter = !vm.clickedChapter;
    }

    function clickSlideListItem() {
      vm.clickedSlide = !vm.clickedSlide;
    }
    function addSlide() {
      var time = vm.counter;
      $rootScope.time = time;
      var id = incremanteId(slideId);
      slideId++;
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/diffusion/add.slide.html',
        clickOutsideToClose: true,
        controller: "addSlideController",
        fullscreen: true
      }).then(function (slides) {
          vm.slides = vm.slides.concat(slides);
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function addChapter() {
      var time = vm.counter;
      var id = incremanteId(chapterId);
      chapterId++;
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/diffusion/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.time = time;
          $scope.text = "";
          $scope.add = true;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;
          $scope.timeExist = false;
          $scope.confirmAdd = confirmAdd;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmAdd() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }
          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters.push(chapter);
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );


    }

    function confirmDeleteChapter(chapter) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_chapter_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteChapter(chapter);

      }, function () {

      });
    }

    function confirmDeleteSlide(slide) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .htmlContent($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_content'))
        .ariaLabel($translate.instant('LIVEDIFFUSION.live_delete_confirm_slide_title'))
        .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
        .cancel($translate.instant('MESSAGES.dialog_cancel'));

      $mdDialog.show(confirm).then(function () {

        deleteSlide(slide);

      }, function () {

      });
    }

    function deleteChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      vm.chapters.splice(index, 1);
      // params.rm.chapitres = vm.chapters.slice();
      // updateRM();
    }

    function deleteSlide(slide) {
      var index = vm.slides.indexOf(slide);
      vm.slides.splice(index, 1);
      // params.rm.slidesTmp = vm.slides.slice();
      // updateRM();
    }

    function modifyChapter(chapter) {
      var index = vm.chapters.indexOf(chapter);
      $mdDialog.show({
        locals: {data: vm.chapters},
        templateUrl: 'app/main/media/lives/live/diffusion/add.chapter.html',
        clickOutsideToClose: true,
        controller: function ($scope, $translate, $mdDialog, $state, data) {
          $scope.add = false;
          $scope.time = chapter.TimeCode;
          $scope.text = chapter.Title;
          $scope.id = chapter.ID;
          $scope.errorTime = "";
          $scope.nullError = false;
          $scope.invalidForm = false;

          $scope.timeExist = false;
          $scope.confirmModify = confirmModify;

          function uniqueValue(item, items) {
            var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
            return (angular.isUndefined(unique));
          }


          function confirmModify() {
            var output;
            var timeContent = [];
            var minute;
            var seconde;
            $scope.errorTime = "";
            $scope.nullError = false;
            $scope.invalidForm = false;
            $scope.timeExist = false;
            if ($scope.time !== null && $scope.time !== "") {
              if ($scope.time.indexOf(":") === -1) {
                output = [$scope.time.slice(0, 2), ":", $scope.time.slice(2, 4), ":", $scope.time.slice(4)].join('');
              } else {
                output = $scope.time;
              }
              timeContent = output.split(":");
              minute = parseInt(timeContent[1]);
              seconde = parseInt(timeContent[2]);
              if (minute < 60 && seconde < 60) {
                if (uniqueValue({ID: $scope.id, Title: $scope.text, TimeCode: output}, data)) {
                  $mdDialog.hide({ID: $scope.id, Title: $scope.text, TimeCode: output});
                } else {
                  $scope.errorTime = "md-red-100-bg";
                  $scope.timeExist = true;
                }
              } else {
                $scope.errorTime = "md-red-100-bg";
                $scope.invalidForm = true;

              }

            } else {
              $scope.errorTime = "md-red-100-bg";
              $scope.nullError = true;
            }

          }

          $scope.cancel = function () {
            $mdDialog.cancel();
          };
        },
        fullscreen: true
      }).then(function (chapter) {
          vm.chapters[index] = chapter;
          vm.chapters = sortValues(vm.chapters);
          // params.rm.chapitres = vm.chapters.slice();
          // updateRM();
        }
      );
    }

    function broadcastSlide(slide) {
      if (uniqueValue({TimeCode: vm.counter}, params.rm.slidesTmp)) {
        slide.TimeCode = vm.counter;
        params.rm.slidesTmp.push(slide);
        var index = vm.slides.indexOf(slide);
        vm.slides[index].Diffuse = true;
        sortValues(params.rm.slidesTmp);
        updateRM();

      } else {
        webTvGlobal.alertDialog($translate.instant('LIVEDIFFUSION.error_time_exist'));
      }

    }

    function slideBroadcasted(slide) {
      return (slide.TimeCode === "--:--:--");
    }

    function modifySlide(slide) {

      var id = slide.ID;
      var time = slide.TimeCode;
      var index = vm.slides.indexOf(slide);
      $mdDialog.show({
        locals: {id: id},
        templateUrl: 'app/main/media/lives/live/diffusion/add.slide.html',
        clickOutsideToClose: true,
        controller: "modifySlideController",
        fullscreen: true
      }).then(function (slideModified) {
          slideModified.TimeCode = time;
          vm.slides[index] = slideModified;
          vm.slides = sortValues(vm.slides);
          // params.rm.slidesTmp = vm.slides.slice();
          // updateRM();
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal
            .$toast()
            .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
        }
      );

    }

    function uniqueValue(item, items) {
      var unique = $filter('filter')(items, {TimeCode: item.TimeCode})[0];
      return (angular.isUndefined(unique));
    }

    String.prototype.toSeconds = function () {
      var sec_num = this.split(':');
      var hour = parseInt(sec_num[0]);
      var minute = parseInt(sec_num[1]);
      var seconds = parseInt(sec_num[2]);
      return seconds + minute * 60 + hour * 3600;
    };

    function sortValues(items) {
      var arrayToSort = items;
      if (arrayToSort.length) {
        arrayToSort.sort(function (a, b) {
          if (angular.isDefined(a.TimeCode) && angular.isDefined(b.TimeCode)) {
            return a.TimeCode.toSeconds() - b.TimeCode.toSeconds();
          }
          else {
            return 0;
          }
        });
      }
      return arrayToSort;
    }


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.form_diffusion_title_menu_title";
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.lives_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";

    }

    function updateRM() {
      params.rm.slides=params.rm.slidesTmp;
      params.rm.chapitres=params.rm.chapitresTmp ;
      msApi.request('livesLiveDiffusion.syncRTC@save',
        {
          live_id: vm.lives.id,
          rm: params.rm
        },
        function (res) {
          if (res.message === 'success') {
            webTvGlobal
              .$toast()
              .showSimple($translate.instant('LIVEDIFFUSION.live_rm_update'), {}, 1000, true);
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        })
    }

    function incremanteId(id) {
      id = id + 1;
      return vm.lives.id + "_" + id;
    }
  }

})();



(function () {
  angular
    .module('app.lives.diffuse')
    .controller('addSlideController', addSlideController);

  /** @ngInject */
  function addSlideController($scope, $mdDialog, $rootScope, webTvGlobal, $translate, id) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    $scope.add = true;
    $scope.time = "--:--:--";
    $scope.imageName;
    $scope.slideFile;
    $scope.inProgress = true;
    $scope.progressBarValue = 10;
    $scope.progress = false;
    $scope.ngFlowImageOptions = {
      chunkSize: (function () {
        return Math.pow(10, 8);
      })(),
      testChunks: false,
      target: Routing.generate('api_post_lives_slide'),
      singleFile: false,
      extendChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      query: {id: id}
    };
    $scope.ngFlow = {
      flow: {}
    };
    $scope.ngFlowImage = {
      flow: {}
    };
    var slides = [];
    $scope.fileImgAdded = fileImgAdded;
    $scope.fileProgress = fileProgress;
    $scope.uploadFileImage = uploadFileImage;
    $scope.fileSuccess = fileSuccess;
    $scope.uploadComplete = uploadComplete;


    function fileImgAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        $scope.imageName = false;
        webTvGlobal.$toast().showSimple($translate.instant('LIVEDIFFUSION.alert_not_valid_slide_image_message'));
        return false;
      }
      $scope.progress = true;
      $scope.slideFile = file;
      $rootScope.loadingProgress = true;
      $scope.inProgress = false;
    }

    function fileProgress(file) {
      $scope.progressBarValue = Math.floor(file.progress() * 100);
    }

    function uploadFileImage() {
      $scope.ngFlowImage.flow.opts.headers = {};
      $scope.ngFlowImage.flow.upload();
      $scope.inProgress = true;
    }

    function fileSuccess(file, message) {
      var data = null;
      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      $scope.slideFileName = $scope.slideFile.name;
      if (angular.isDefined($scope.slideFile)) {
        if (angular.isDefined(data.location.url)) {
          slides.push({
            "ID": id,
            "TimeCode": $rootScope.time,
            "Title": data.location.path,
            "Name": data.location.url,
            "Order": null
          });
        }

      } else {
        webTvGlobal
          .$toast()
          .showSimple($translate.instant('MESSAGES.alert_xhr_error'), {}, 1000, true);
        return;
      }

    }

    function uploadComplete() {
      $scope.progressBarValue = 0;
      $scope.inProgress = false;
      $rootScope.loadingProgress = false;
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.file_import'), {}, 1000, true);
      $mdDialog.hide(slides);
    }

    $scope.cancel = function () {
      webTvGlobal
        .$toast()
        .showSimple($translate.instant('LIVEDIFFUSION.live_file_import_canceled'), {}, 1000, true);
      $mdDialog.cancel();

    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.list')
        .controller('livesLiveListController', livesLiveListController)
        .controller('DialogController', DialogController)
        .controller('linkExportController', linkExportController)
        .controller('liveDetailController', liveDetailController);

    /** @ngInject */
    function livesLiveListController(livesData, $cookies, AbonnementUserData, $injector,$location,$window, DTOptionsBuilder, contributorsData, DTColumnBuilder, $scope, finish, $mdSidenav, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        /**
         *Injected Vars
         */
        var $rootScope = $injector.get('$rootScope'),
            webTvGlobal = $injector.get('webTvGlobal'),
            $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi'),
            $translate = $injector.get('$translate'),
            $sce = $injector.get('$sce'),
            $mdDialog = $injector.get('$mdDialog'),
            $stateParams = $injector.get('$stateParams'),
            $timeout = $injector.get("$timeout");
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.toggleSidenav = toggleSidenav;
        vm.restoreFilter = restoreFilter;
        vm.startDate = null;
        // vm.contributorChoice = contributorsData.contributors;
        vm.lives = [];
        vm.users = AbonnementUserData.data.users;
        vm.selectedlives = [];
        var selectedlives = [];
        vm.liveDataTable = {};
        vm.dtInstance = {};
      vm.language = $translate.preferredLanguage();
        $rootScope.currentState = $state.current.name;
        vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
            (function (contributors, data) {

                contributors['none'] = "0";
                for (var i = 0; i < data.length; i++) {
                    contributors[data[i].name] = data[i].id;
                }
                return contributors;
            })({}, contributorsData.contributors)
        );

        var color = $cookies.get('selectedThemeColor');
        var type = "list";
        var id_edit = null;
        if(angular.isDefined($stateParams.type)){
            type = $stateParams.type;
        }
        if(angular.isDefined($stateParams.ids) && $stateParams.ids){
            id_edit = $stateParams.ids;
        }
      msApi.request('lives.getUrlListLive@get', {type: type, diffusion:$stateParams.diffusion, id: id_edit},
        function (response) {
          vm.urlLiveList = $sce.trustAsResourceUrl(response.url+'&color='+color);
        });

      function toggleSidenav(sidenavId) {
        $mdSidenav(sidenavId).toggle();
      }

      if(type==="list") {
          initHelp();
      }else if(type==="add") {
          initHelpAdd();
      }else if(type==="edit") {
          initHelpEdit();
      }else if(type==="calender"){
          initHelpCalendar();
      }

      function restoreFilter(sidenavId) {
        vm.startDate = null;
        vm.period = "";
        vm.search_lives = "";
        vm.contributor = 0;
        vm.searchLives();
        toggleSidenav(sidenavId);
      }

      function searchLivesInAPI(filtre) {
        $cookies.put('numberRecords', filtre.length);
        msApi.request(livesData, filtre,
          function (response) {
            var records = {};
            if (response.code === 200) {
              var lives = response.data;


              records = {
                'draw': response.draw,
                'recordsTotal': response.recordsTotal,
                'recordsFiltered': response.recordsFiltered,
                'data': lives
              };
              vm.lives = lives;
              vm.recordsTotal = response.recordsTotal;
              vm.fnCallback(records);
              webTvGlobal.fixDatatableFirefox();
            }
            else {
              if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
              }
              else {
                records = {
                  'draw': 0,
                  'recordsTotal': 0,
                  'recordsFiltered': 0,
                  'data': 0
                };

                vm.lives = [];
                vm.recordsTotal = 0;
                vm.fnCallback(records);
                $rootScope.loadingProgress = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              }

            }
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        );

      }


      vm.deleteSelectedLivesConfirm = deleteSelectedLivesConfirm;
      vm.searchLives = searchLives;
      // vm.getTitleKey = getTitleKey;
      // vm.getIcon = getIcon;
      vm.deleteLivesConfirm = deleteLivesConfirm;
      vm.deleteLives = deleteLives;
      vm.enableLive = enableLive;
      vm.toggleAll = toggleAll;
      vm.toggle = toggle;
      vm.showLivesDetail = showLivesDetail;
      vm.addNewLives = addNewLives;
      $rootScope.rerender = rerender;
      var flashMessages = {title: ""};
      vm.sendIvitationMails = sendIvitationMails;
      vm.linkExportDetail = linkExportDetail;
      vm.liveDetail = liveDetail;
      vm.statsPerLive = statsPerLive;
      vm.restartLive = restartLive;
      vm.diffuseLive = diffuseLive;
      vm.screenShare = screenShare;
      vm.downloadScreenShare = downloadScreenShare;

      showFlasMessageToast('LivesAdd', $translate.instant('LIVESLIST.added'), {
        bottom: true,
        top: false,
        left: false,
        right: true
      });
      showFlasMessageToast('LivesEdit', $translate.instant('LIVESLIST.edited'));

      function diffuseLive(live) {
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().live_extern)) {
          vm.live_extern = webTvGlobal.$constant().webTvParameterBag().live_extern;
        }
        else {
          vm.live_extern = '0';
        }
        vm.live_extern = vm.live_extern == "1" || vm.live_extern == true ? true : false;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().use_jitsi)) vm.use_jitsi = webTvGlobal.$constant().webTvParameterBag().use_jitsi;
        else vm.use_jitsi = '0';
        vm.use_jitsi = vm.use_jitsi == "1" || vm.use_jitsi == true ? true : false;

            if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().use_pearl_rtc)) vm.use_pearl_rtc = webTvGlobal.$constant().webTvParameterBag().use_pearl_rtc;
            else vm.use_pearl_rtc = '0';
            vm.use_pearl_rtc = vm.use_pearl_rtc == "1" || vm.use_pearl_rtc == true ? true : false;

            if(vm.use_pearl_rtc && live.isPearl) {
                $state.go("app.lives_diffuse_jitsi", { "id": live.id});
            }
            else if(vm.live_extern){
              $state.go("app.lives_extern_diffuse", { "id": live.id});
            }
            else if(live.isPearl && live.isRm){
                $state.go("app.lives_pearl", { "id": live.id});
            }
            else if(live.isPearl && !live.isRm){
                 $state.go("app.lives_encodeur_test", { "id": live.id});
            }
            else if(live.webinar && vm.use_jitsi){
                $state.go("app.lives_diffuse_jitsi", { "id": live.id});
            }
            else{
              $state.go("app.lives_diffuse", { "id": live.id});

            }

      }

      //
      // /**
      //  * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
      //  * @param  op : crud operation
      //  * @param  message message to show
      //  * @param  toastPosition position of the toast
      //  */
      // function diffuseLive(live) {
      //     clearFlashMessage();
      //     $state.go('app.lives_diffuse', {id: live.id});
      // }

      function restartLive(live) {
        $rootScope.loadingProgress = true;
        msApi.request("lives.reviveLive@get", {id: live.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.code) && response.code === 200) {
              webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
              rerender();
            } else {
              if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                $translate('VALIDATION.' + response.data.message).then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
              }
              else {

                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              }
            }
          },
          function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATION.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          })
      }


      function showFlasMessageToast(op, message, toastPosition) {
        if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

      }

      // function showCalendar() {
      //     $rootScope.currentState = $state.current.name;
      //     $state.go('app.lives_calendar');
      //
      // }

      /**
       * Check If there's and CRUD Operation that happened before getting to the list page
       * @param   op : operation name
       * @return  bool
       */

      function checkFlashMessage(op) {
        var data = webTvGlobal.$flashMessages().get(op);
        if (!flashMessages.title) flashMessages.title = data ? data.title : "";
        return data ? true : false;
      }

      /**
       * Clear Flash Message when an action is triggered
       */
      function clearFlashMessage() {
        if (flashMessages.title) {
          flashMessages.title = "";
          webTvGlobal.$flashMessages().clear();
        }
        webTvGlobal.$toast().hide();
      }

      // /**
      //  * Get Page Title Translation Key from the current state
      //  * @return string : translation key for the page title
      //  */
      // function getTitleKey() {
      //     return $state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_pagetitle');
      // }

      // /**
      //  * Get icon from the current state
      //  * @return string : icon
      //  */
      // function getIcon() {
      //     var item = msNavigationService.getActiveItem();
      //     return angular.isObject(item) && angular.isDefined(item.node) && angular.isDefined(item.node.icon) ? item.node.icon : "icon-cube-outline";
      // }

      /**
       * @param live
       */
      function toggle(live) {
        live.checked = !live.checked;
        var idx = selectedlives.indexOf(live);
        if (idx > -1) {
          selectedlives.splice(idx, 1);
        }
        else {
          selectedlives.push(live);
        }
        vm.selectedlives = angular.copy(selectedlives);
      }


      function toggleAll() {
        if (selectedlives.length === vm.lives.length) {
          vm.selectedlives = [];
        }
        else if ((selectedlives.length === 0) || (selectedlives.length > 0)) {
          vm.selectedlives = vm.lives.slice(0);
        }
        selectedlives = angular.copy(vm.selectedlives);
        var list_lives = angular.copy(vm.liveDataTable);
        angular.forEach(list_lives, function (value, key) {
          if (value !== undefined)
            vm.liveDataTable[key].checked = selectedlives.length > 0;
        });
      }


      function getTitleKey() {
        console.log($state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_pagetitle'));
        switch ($stateParams.diffusion) {
          case "endless":
            return "PAGESMENUSTITLES.lives_list_ongoing_pagetitle";
          case "upcoming":
            return "PAGESMENUSTITLES.lives_list_upcoming_pagetitle";
          case "all":
            return "PAGESMENUSTITLES.lives_list_all_pagetitle";
          case "archived":
            return "PAGESMENUSTITLES.lives_list_archived_pagetitle";
          default:
            return "PAGESMENUSTITLES.lives_list_ongoing_pagetitle";
        }
      }


      function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
        $rootScope.titre3 = getTitleKey();
        $rootScope.pageRoute = '';
        $rootScope.welcome = "welcome_live";
        $rootScope.text = [{
          texte: "add_button_live_help"
        }, {
          texte: "diffusion_types_live_help"
        }, {
          texte: "arrow_button_live_help"
        }, {
          texte: "search_tools_live_help"
        }, {
          texte: "tri_column_live_help"
        },
          {
            texte: "buttons_live_help"
          }];

      }
        function initHelpAdd() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.lives_add_menuTitle";
            $rootScope.pageRoute = "app.lives_list_ongoing";

            $rootScope.welcome = "welcome_live_add";
            $rootScope.text = [
                {
                    texte: "parameters_live_add_help"
                },
                {
                    texte: "upload_button_live_add_help"
                },
                {
                    texte: "upload_doc_button_live_add_help"
                },
                {
                    texte: "send_button_live_add_help"
                },
                {
                    texte: "cancel_button_live_add_help"
                }
            ];
        }

        function initHelpEdit() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.lives_edit_pagetitle";
            $rootScope.pageRoute = "app.lives_list_ongoing";

            $rootScope.welcome = "welcome_live_edit";
            $rootScope.text = [
                {
                    texte: "parameters_live_edit_help"
                },
                {
                    texte: "upload_button_live_add_help"
                },
                {
                    texte: "upload_doc_button_live_add_help"
                },
                {
                    texte: "send_button_live_edit_help"
                },
                {
                    texte: "cancel_button_live_add_help"
                }
            ];
        }

        function initHelpCalendar(){
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.lives_calendar_menuTitle";
            $rootScope.pageRoute = "app.lives_list_ongoing";

            $rootScope.welcome = "welcome_live_edit";
            $rootScope.text = [
                {
                    texte: "parameters_live_edit_help"
                },
                {
                    texte: "upload_button_live_add_help"
                },
                {
                    texte: "upload_doc_button_live_add_help"
                },
                {
                    texte: "send_button_live_edit_help"
                },
                {
                    texte: "cancel_button_live_add_help"
                }
            ];
        }

      // function listfinish() {
      //     $state.go("app.lives_list_archived");
      // }
      //
      // function listongiong() {
      //     $state.go("app.lives_list_ongoing");
      // }

      /**
       * Show lives Details
       * @param lives
       */
      function showLivesDetail(liveslist, lives) {

        clearFlashMessage();
        if (lives) {
          lives.preventDefault();
        }
        $rootScope.loadingProgress = true;
        msApi.request('livesLive.modalGetLives@get', {id: liveslist.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.code) && response.code === 200) {

              $mdDialog.show({
                locals: {livesData: response},
                templateUrl: 'app/main/media/lives/live/detail/detail.modal.html',
                clickOutsideToClose: true,
                controller: 'livesLiveDetailController',
                controllerAs: 'vm'
              })
            }
            else {
              $rootScope.loadingProgress = false;
              if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                $translate('VALIDATION.' + response.data.message).then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
              }
              else {

                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              }
            }
          }, function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATION.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        );

      }


      /**
       * rerender datatable
       */
      function rerender() {
        if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchLivesInAPI(filtre), true);
      }

      // function editLives(lives) {
      //     clearFlashMessage();
      //     $rootScope.currentState = $state.current.name;
      //     $state.go('app.lives_edit', {id: lives.id});
      // }


      // function encodeurlive(lives) {
      //     clearFlashMessage();
      //     $rootScope.currentState = $state.current.name;
      //     $state.go('app.lives_encodeur_test', {id: lives.id});
      // }


      // function liveComment(lives) {
      //     clearFlashMessage();
      //     $state.go('app.comments_list.live', {id: lives.id});
      // }

      /**
       * redirection to add new lives page
       * @param lives
       */
      function addNewLives() {
        clearFlashMessage();
        $state.go('app.lives_addLive');
      }


      /**
       * Open Live export links Detail dialog
       * @param $live
       * @param $event
       */
      function linkExportDetail(live) {
        vm.spinner = false;
        msApi.request('lives.getExportDetail@get', {id: live.id},
          function (res) {
            vm.spinner = true;
            $mdDialog.show({
              controller: 'linkExportController',
              controllerAs: 'vm',
              templateUrl: 'app/main/media/lives/live/list/linkExport.modal.html',
              clickOutsideToClose: true,
              locals: {
                data: res,
                mdDialogTitle: res.status
              }
            }).then(function () {

            });
          }
        ).then(function () {
        });

      }

      /**
       * Open Live information Detail dialog
       * @param $live
       * @param $event
       */
      function liveDetail(live) {
        vm.spinner = false;
        msApi.request('lives.getLiveDetail@get', {id: live.id},
          function (res) {
            vm.spinner = true;
            $mdDialog.show({

              controller: 'liveDetailController',
              controllerAs: 'vm',
              templateUrl: 'app/main/media/lives/live/list/infoDetail.modal.html',
              clickOutsideToClose: true,
              locals: {
                data: res,
                mdDialogTitle: res.status
              }
            }).then(function () {
            });
          }
          , function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        ).then(function () {
        });
        $rootScope.currentState = $state.current.name;
      }


      /**
       * Dialog invetation subscribt
       */
      function sendIvitationMails(ev, id) {
        $mdDialog.show({
          templateUrl: 'app/main/media/lives/live/list/mail.modal.html',
          controller: 'DialogController',
          controllerAs: 'vm',
          locals: {
            'users': vm.users,
            'id': id
          },
          clickOutsideToClose: true,
          escapeToClose: true,
          targetEvent: ev
        });
      }

      function screenShare(live) {
        var id = live.id;
        $mdDialog.show({
          controller: 'screenShareController',
          controllerAs: 'vm',
          templateUrl: 'app/main/media/lives/live/screenShare/screen.share.template.html',
          clickOutsideToClose: true
        }).then(function (param) {
            msApi.request('lives.addScreenShare@get', {id: id, screenType: param}, function (res) {
              if (res.code === 200) {
                webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                rerender();
              }
              else {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              }
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            })
          }
        )

      }

      function downloadScreenShare(live) {
        msApi.request('lives.getDownloadScreenShareFile@get', {id: live.id}, function (res) {
          if (res.code === 200 && angular.isDefined(res.url_jnlp_file)) {
            window.open(res.url_jnlp_file, '_blank');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }, function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        })
      }

      /////////////////////////////
      function deleteSelectedLivesConfirm(ev) {
        var title;
        var ariaLabel;
        if (vm.selectedlives.length !== 0) {
          if (vm.selectedlives.length === 1) {
            title = 'LIVESLIST.delete_selected_live_message';
            ariaLabel = 'LIVESLIST.delete_selected_livee_aria_label';
          } else {
            title = 'LIVESLIST.delete_selected_lives_msg';
            ariaLabel = 'LIVESLIST.delete_selected_lives_aria_label';
          }
          $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedlives.length, title, ariaLabel)).then(function () {
            deleteSelectedLives(ev);
          }, function () {
          });

        }
      }

      ////////////////
      function deleteSelectedLives(ev) {
        clearFlashMessage();
        $rootScope.loadingProgress = true;

        msApi.request('lives.deleteLives@delete', {
            list: (function (list) {
              vm.selectedlives.forEach(function (item) {
                list.push(item.id);
              });
              return list;
            })([])
          },
          function (response) {
            $rootScope.loadingProgress = false;

            if (response.code === 200) {
              var undeleted = "";
              var deleted = "";
              if (response.result.undeleted.length !== 0) {
                undeleted = $translate.instant("LIVESLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
              }
              deleted = $translate.instant("LIVESLIST.deleted_are", {'list': response.result.deleted.join(",")});
              webTvGlobal.alertDialog(
                deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                $translate.instant('LIVESLIST.dialog_alert_delete_title'),
                '',
                ev
              );
              vm.selectedlives = [];
              selectedlives = [];
              rerender();


            } else {
              webTvGlobal.alertDialog(
                $translate.instant('LIVESLIST.dialog_alert_delete_error_title'),
                $translate.instant('LIVESLIST.dialog_alert_delete_error_description'),
                '',
                ev
              );
              vm.selectedlives = [];
              selectedlives = [];
            }
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
            vm.selectedlives = [];
            selectedlives = [];
            vm.modelCheckAll = false;
          }
        );

      }

      /**
       * Delete lives Confirm Dialog
       */
      function deleteLivesConfirm(lives, ev) {
        $translate([
          "MESSAGES.dialog_confirm_delete",
          "MESSAGES.dialog_cancel",
          "MESSAGES.dialog_will_be_deleted",
          "LIVESLIST.delete_lives_msg",
          "LIVESLIST.delete_lives_aria_label"
        ])
          .then(function (translatedValues) {
            var confirm = $mdDialog.confirm()
              .title(translatedValues['LIVESLIST.delete_lives_msg'])
              .htmlContent('<b>' + lives.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
              .ariaLabel(translatedValues['LIVESLIST.delete_lives_aria_label'])
              .targetEvent(ev)
              .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
              .cancel(translatedValues['MESSAGES.dialog_cancel']);

            $mdDialog.show(confirm).then(function () {

              deleteLives(lives);
              vm.selectedlives = [];
              selectedlives = [];

            }, function () {

            });
          });


      }

      /**
       * Delete lives
       */
      function deleteLives(lives) {
        clearFlashMessage();
        if (vm.lives.indexOf(lives) !== -1) {
          $rootScope.loadingProgress = true;
          msApi.request('livesLive.delete@delete', {id: lives.id},
            function (response) {
              $rootScope.loadingProgress = false;
              if (response.code === 200) {
                $translate([
                  "LIVESLIST.dialog_alert_delete_title",
                  "LIVESLIST.dialog_alert_delete_description",
                  "LIVESLIST.dialog_alert_delete_close"
                ])
                  .then(function (translatedValues) {
                    webTvGlobal.$toast().showSimple(lives.title + translatedValues['LIVESLIST.dialog_alert_delete_description']);
                    vm.lives.splice(vm.lives.indexOf(lives), 1);
                    rerender();
                  });

              }
              else {
                $translate([
                  "LIVESLIST.dialog_alert_delete_error_title",
                  "LIVESLIST.dialog_alert_delete_error_description",
                  "LIVESLIST.dialog_alert_delete_close"
                ])
                  .then(function (translatedValues) {
                    var alert = $mdDialog.alert({
                      title: translatedValues['LIVESLIST.dialog_alert_delete_error_title'],
                      textContent: translatedValues['LIVESLIST.dialog_alert_delete_error_description'],
                      ok: translatedValues['LIVESLIST.dialog_alert_delete_close']
                    });

                    $mdDialog
                      .show(alert)
                      .finally(function () {
                        alert = undefined;
                      });
                  });

              }
            }
          );

        }


      }


      /**
       * Enable Live
       */
      function enableLive(Lives) {
        if (Lives.active == true) {
          clearFlashMessage();
          if (vm.lives.indexOf(Lives) !== -1) {
            $rootScope.loadingProgress = true;
            msApi.request('live.enable@save', {id: Lives.id},
              function (response) {
                $rootScope.loadingProgress = false;
                if (response.code === 200) {
                  $translate([
                    "LIVESLIST.dialog_alert_enable_title",
                    "LIVESLIST.dialog_alert_enable_description",
                    "LIVESLIST.dialog_alert_enable_close"
                  ])
                    .then(function (translatedValues) {
                      webTvGlobal.$toast().showSimple(Lives.title + translatedValues['LIVESLIST.dialog_alert_enable_description']);
                      vm.lives[vm.lives.indexOf(Lives)].active = true;
                      rerender();
                    });

                }
                else {
                  $translate([
                    "LIVESLIST.dialog_alert_enable_error_title",
                    "LIVESLIST.dialog_alert_enable_error_description",
                    "LIVESLIST.dialog_alert_enable_close"
                  ])
                    .then(function (translatedValues) {
                      var alert = $mdDialog.alert({
                        title: translatedValues['LIVESLIST.dialog_alert_enable_error_title'],
                        textContent: translatedValues['LIVESLIST.dialog_alert_enable_error_description'],
                        ok: translatedValues['LIVESLIST.dialog_alert_enable_close']
                      });

                      $mdDialog
                        .show(alert)
                        .finally(function () {
                          alert = undefined;
                        });
                    });

                }
              }
            );

          }
        }
        else {
          clearFlashMessage();
          if (vm.lives.indexOf(Lives) !== -1) {
            $rootScope.loadingProgress = true;
            msApi.request('live.disable@save', {id: Lives.id},
              function (response) {
                $rootScope.loadingProgress = false;
                if (response.code === 200) {
                  $translate([
                    "LIVESLIST.dialog_alert_delete_title",
                    "LIVESLIST.dialog_alert_disable_description",
                    "LIVESLIST.dialog_alert_disable_close"
                  ])
                    .then(function (translatedValues) {
                      webTvGlobal.$toast().showSimple(Lives.title + translatedValues['LIVESLIST.dialog_alert_disable_description']);
                      vm.lives[vm.lives.indexOf(Lives)].active = false;
                      rerender();
                    });

                }
                else {
                  $translate([
                    "LIVESLIST.dialog_alert_disable_error_title",
                    "LIVESLIST.dialog_alert_disable_error_description",
                    "LIVESLIST.dialog_alert_disable_close"
                  ])
                    .then(function (translatedValues) {
                      var alert = $mdDialog.alert({
                        title: translatedValues['LIVESLIST.dialog_alert_disable_error_title'],
                        textContent: translatedValues['LIVESLIST.dialog_alert_disable_error_description'],
                        ok: translatedValues['LIVESLIST.dialog_alert_disable_close']
                      });

                      $mdDialog
                        .show(alert)
                        .finally(function () {
                          alert = undefined;
                        });
                    });

                }
              }
            );

          }
        }

      }

      function searchLives() {
        filtre.searchWord = vm.search_lives;
        filtre.idContributor = vm.contributor;
        filtre.period = vm.period;
        if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
          filtre.startDate = moment(vm.startDate).format("YYYY-MM-DD");
        }
        else {
          filtre.startDate = "";
        }
        searchLivesInAPI(filtre);
      }

      /**
       * stats per live
       * @param   live
       */
      function statsPerLive(live) {
        $rootScope.name_state_parent = angular.isDefined($state.current.name) ? $state.current.name : 'app.media_video_list_ongoing';
        // app.stats_vod_by_id.audience({ id: vm.videosDataTable[' + data.id + '].id})
        $state.go('app.stats_live_by_id.audience', {id: live.id});

      }
      $scope.iframeLoadedCallBack = function(){
        sendPostMessage(vm.language)
      }

      function  sendPostMessage(lang){
        document.getElementById('iframe_live').contentWindow.postMessage({
          info: "updateLang",
          lang:lang
        }, "*");
      }
      eventPostMessage()
      function eventPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageListLive)) {
          window.dataEventPostMessageListLive = true;
          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
          eventer(messageEvent, function (e) {
            if (typeof e.data !== "undefined") {
              if (e.data.info === "goToStaticsLive") {
                $state.go('app.stats_live_by_id.audience', {id: e.data.id});
              }
              if (e.data.info === "goToDiffusionLive" ) {
                $rootScope.confirm = false;
                diffuseLive(e.data.live);
              }
              if (e.data.info === "goToCommentLive") {
                $state.go('app.comments_list.live', {id: e.data.id});
              }
              if (e.data.info === "goToEncodingLive") {
                $state.go('app.lives_encodeur_test', {id: e.data.id});
              }
              if(e.data.info === "diffusionLive"){
                  $timeout(function() {
                    $state.go('app.lives_list_'+e.data.value, { type: 'list', diffusion: e.data.value});
                  },500)
              }
              if (e.data.info === "goToAddLive") {
                $rootScope.live = "add"
                $state.go('app.lives_list_ongoing', { type: 'add', diffusion: e.data.value});
               $timeout(function() {
                 $rootScope.confirm = true;
                },500);
                  initHelpAdd();
                if (!$rootScope.alert) {
                  openAlertModal(e.data.value);
                }
              }
              if (e.data.info === "goToCalendar") {
                $rootScope.live = "calender";
                  $timeout(function() {
                $state.go('app.lives_list_ongoing', {type: 'calender'});
                  },500);
                  initHelpCalendar();
              }
              if (e.data.info === "goToListLive") {
                $rootScope.live = "list"
                $rootScope.confirm = false;
                  $rootScope.pageRoute = "";
                $timeout(function() {
                  $state.go('app.lives_list_ongoing',{type: 'list',diffusion:e.data.value,ids:null});
                },500);
                  initHelp();
              }
              if (e.data.info === "goToEditLive") {
                $rootScope.live = "edit"
                $state.go('app.lives_list_ongoing', {type: 'edit', ids: e.data.id,diffusion:e.data.value});
                  $timeout(function() {
                      $rootScope.confirm = true;
                  },500);
                  initHelpEdit();
                if (!$rootScope.alert) {
                  openAlertModal();
                }
              }
            }
          }, false);
        }

      }
      if(document.getElementById('app.lives_list_ongoing') && !!!$rootScope.hasClickLive ) {
        $rootScope.hasClickLive = true;
        document.getElementById('app.lives_list_ongoing').addEventListener('click', eventListenerModal)
      }
      function eventListenerModal(){
        /*todo click sur liste live */
        if($state.current.name.indexOf('live') > 0)
          modalAlert('endless')
      }

      function openAlertModal(diffusion) {
          $rootScope.alert = true;
          $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
               if ($rootScope.confirm) {
                $mdDialog.show({
                  templateUrl: 'app/main/media/lives/live/diffusion/modalDiffusion.template.html',
                  clickOutsideToClose: true,
                  controller: function ($scope, $mdDialog, $rootScope, $injector) {
                    var $state = $injector.get('$state');
                    $scope.cancel = cancel;
                    $scope.confirm = confirm;

                    function cancel() {
                      $mdDialog.hide();
                    }
                    function confirm() {
                      $rootScope.confirm = false;
                      $mdDialog.hide();
                          if (toState.name === "app.lives_list_ongoing") {
                              var params = {type: 'list',diffusion:diffusion,ids:null};
                              $timeout(function() {
                                $state.go(toState.name, params);
                              }, 500);
                              $rootScope.pageRoute = "";
                              document.getElementById('iframe_live').contentWindow.postMessage({
                                  info: "redirectListLive",
                              }, "*");
                          }else{
                              $timeout(function() {
                                $state.go(toState.name);
                              }, 500);
                          }
                        if(document.getElementById("theme-config"))
                            document.getElementById("theme-config").style.display = "flex";
                    }
                  },
                });
                event.preventDefault();
              }

            });

    }

    function modalAlert(diffusion){
      var $state = $injector.get('$state');
        if($state && $state.params && $state.params.type && $state.params.type !== "list")
        {

          $mdDialog.show({
        templateUrl: 'app/main/media/lives/live/diffusion/modalDiffusion.template.html',
        clickOutsideToClose: true,
        controller: function ($scope, $mdDialog, $rootScope, $injector) {

          $scope.cancel = cancel;
          $scope.confirm = confirm;

          function cancel() {451
            $mdDialog.hide();
          }
          function confirm() {
            $rootScope.confirm = false;
            $mdDialog.hide();
            $timeout(function() {
              $state.go('app.lives_list_ongoing',{type: 'list',diffusion:diffusion,ids:null});
            },500);
              $rootScope.pageRoute = "";
              document.getElementById('iframe_live').contentWindow.postMessage({
                info: "redirectListLive",
              }, "*");

            if(document.getElementById("theme-config"))
              document.getElementById("theme-config").style.display = "flex";
          }
        },
      });}
    }
    }

    function DialogController(users, id, $mdDialog, msApi, webTvGlobal, $translate) {
        var vm = this;
        vm.spinner = true;
        vm.msg = "";
        vm.users = users;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        var nbMail = parameters['nb_subscription_mail'];
        vm.selectedItems = [];
        var selectedItems = [];
        vm.toogle = toogle;

        function toogle(user) {
            if (selectedItems.indexOf(user) > -1)
                selectedItems.splice(selectedItems.indexOf(user), 1);
            else
                selectedItems.push(user);
            vm.selectedItems = selectedItems;


        }

        vm.cancel = $mdDialog.cancel;
        vm.save = save;

        function save() {
            var listMail = vm.selectedItems.map(function (obj) {
                return obj.email;
            });
            if (listMail.length < nbMail) {
                vm.msg = $translate.instant('LIVESLIST.send_failed_nb_mail', {'nb_mail': nbMail});
            }
            else {
                vm.spinner = false;
                msApi.request('lives.sendIvitationMails@save', {mails: listMail, id: id},
                    function (res) {
                        vm.spinner = true;
                        if (res.code === 200) {

                            webTvGlobal.$toast().showCustom($translate.instant('LIVESLIST.send_succes'));
                            vm.cancel();

                        }
                        else {
                            vm.msg = $translate.instant('LIVESLIST.send_failed');
                            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );
            }
        }
    }


    function linkExportController(data, $mdDialog) {
        var vm = this;
        vm.spinner = true;
        vm.data = data;
      if(typeof vm.data.permalien === 'string')
      {
        vm.data.permalien = vm.data.permalien.split(" ");
      }
      vm.data.permalien = Object.values(vm.data.permalien);
        vm.title = data.title;
        vm.cancel = $mdDialog.cancel;
    }

    function liveDetailController(data, $mdDialog) {
        var vm = this;
        vm.spinner = true;
        vm.data = data;
        vm.title = data.title;
        vm.cancel = $mdDialog.cancel;

    }


})();

(function () {
    'use strict';

    angular
        .module('app.lives.list.calendar', ['ui.calendar'])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_list_calendar', {
                url: '/lives/list/calendar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/calendarListLive/calendar.template.html',
                        controller: 'livesLiveListCalendarController as vm'
                    }
                },
                resolve: {
                    urlLiveCalendar: function (msApi,$stateParams) {
                        return msApi.resolve('livesLiveListCalendar.urlLiveCalendar@get',{type:'calender'});
                    }
                },
                bodyClass: 'calendar'
            });

        msApiProvider.register('livesLiveListCalendar.urlLiveCalendar', [Routing.generate('api_get_url_list_live')]);

        //MS API
        // msApiProvider.register('livesLive.list_by_date', [Routing.generate('api_get_lives_lists_in_interval', {
        //     from: 'start',
        //     to: 'end'
        // }).replace(/from_start_to_end/, ":id"), {id: "@id"}])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.lives.list.calendar')
    .controller('livesLiveListCalendarController', livesLiveCalendarController);

  /** @ngInject */
  function livesLiveCalendarController($state,$translate,$scope, msApi, $sce,$rootScope,urlLiveCalendar) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl))
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.language = $translate.preferredLanguage();
    $scope.iframeLoadedCallBack = function(){
      sendPostMessage( vm.language )
    }
    vm.calendarLink=$sce.trustAsResourceUrl(urlLiveCalendar.url);//"https://mkharrat-web02-dev.webtv-solution.com:8063/live/calendar?cryptext=g-BQU5vciA98g68FZ9aPhFbt8F1UIEVp8X4fe9UCe08"
    // vm.next = next;
    // vm.prev = prev;

    //////////

    // /**
    //  * Go to next on current view (week, month etc.)
    //  */
    // function next() {
    //     vm.calendarView.calendar.next();
    // }
    //
    // /**
    //  * Go to previous on current view (week, month etc.)
    //  */
    // function prev() {
    //     vm.calendarView.calendar.prev();
    // }

    // function returnToList() {
    //   if (angular.isUndefined($rootScope.currentState)) {
    //     $state.go('app.lives_list_ongoing');
    //   }
    //   else {
    //     $state.go($rootScope.currentState);
    //   }
    // }

    function  sendPostMessage(lang){
      document.getElementById('iframe_live').contentWindow.postMessage({
        info: "updateLang",
        lang:lang
      }, "*");
    }
      initHelp();
      function initHelp() {
          $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
          $rootScope.titre3 = "PAGESMENUSTITLES.lives_calendar_menuTitle";
          $rootScope.pageRoute = '';


      }
  }


})();

(function () {
    'use strict';

    angular
        .module('app.lives.edit', ['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State


        $stateProvider
            .state('app.lives_edit', {
                url: "/lives/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/views_add_edit_live/add_edit.template.html',
                        controller: 'livesLiveEditController as vm'
                    }
                },
                resolve: {
                    livesData: function (msApi, $stateParams) {
                        return msApi.resolve('livesLive.getNewLives@get', {id: $stateParams.id});
                    },
                    liveConfGetSondages: function (msApi) {
                        return msApi.resolve('livesLive.getSondages@get');
                    },
                    liveConfGetVideos: function (msApi) {
                        return msApi.resolve('livesLive.getVideos@get');
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    }
                },
                "bodyClass": "forms"
            });


        //API
        msApiProvider.register('livesLive.getNewLives', [Routing.generate('api_get_lives_live_detail', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('livesLive.editLives', [Routing.generate('api_post_edit_lives_live', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('livesLive.getSondages', [Routing.generate('api_survey_get_list_surveys')]);
        msApiProvider.register('livesLive.getVideos', [Routing.generate('api_media_get_transcoded_videos')]);
        msApiProvider.register('parametersBagLogin.app', [Routing.generate('api_get_app_parameter_bag')]);


    }
})();
(function() {
  "use strict";

  angular
    .module("app.lives.edit")
    .controller("livesLiveEditController", livesLiveEditController)
    .controller("liveRMController", liveRMController);

  /** @ngInject */
  function livesLiveEditController(
    liveConfGetSondages,
    liveConfGetVideos,
    livesData,
    contributorsData,
    webTvGlobal,
    $injector,
    $scope,
    $cookies,
    $mdDialog,
    webTv_min_size_logo,userManager
  ) {
    var myEl = angular.element(document.querySelector("#content"));
    if (angular.isDefined(myEl));
    myEl.removeClass("animate-slide-up");
    var $rootScope = $injector.get("$rootScope"),
      $translate = $injector.get("$translate"),
      $state = $injector.get("$state"),
      msApi = $injector.get("msApi"),
      $timeout = $injector.get("$timeout"),
      msUtils = $injector.get("msUtils");
    var vm = this;
    var imageName;
    vm.isNew = false;
    vm.lives = livesData.data.live;
    $rootScope.chapters = livesData.data.chapters;
    $rootScope.questions = livesData.data.questions;
    vm.hasDefault = true;

    vm.empLivesConfForm = {};
    vm.empLivesForm = {};
    vm.urlVignette = "";
    vm.urlVignette2 = "";
    vm.isSubmitTriggered = false;
    vm.submitAddLivesForm = submitAddLivesForm;
    vm.submitTriggered = submitTriggered;
    vm.returnToList = returnToList;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;
    vm.changeEndtime = changeEndtime;
    $rootScope.slidesChips = [];
    $rootScope.slidesTypes = [];
    $rootScope.slidesUrl = [];
    $rootScope.vignetteSlidesUrl = [];
    $rootScope.slidesLoop = [];
    vm.vignetteSlidesUrl = $rootScope.vignetteSlidesUrl;
    vm.slidesLoop = $rootScope.slidesLoop;
    vm.slidesChips = $rootScope.slidesChips;
    vm.slidesUrl = $rootScope.slidesUrl;
    vm.slidesTypes = $rootScope.slidesTypes;
    vm.filesChips = [];
    var filesChips = [];
    var mimeTypeFilesChips = [];
    var filesUrl = [];
    var tabFiles = [];
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressf = false;
    $rootScope.is_changed = false;
    fillData();
    vm.sondages = webTvGlobal.convertToSelectChoicesFormat(
      liveConfGetSondages.data.names
    );
    vm.videos = webTvGlobal.convertToSelectChoicesFormat(
      liveConfGetVideos.data.names
    );
    vm.currentTab = "chapter";
    vm.tooltip_name = "MESSAGES.add_chapter";
    vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
      (function(contributors, data) {
        for (var i = 0; i < data.length; i++) {
          contributors[data[i].name] = data[i].id;
        }
        return contributors;
      })({}, contributorsData.contributors)
    );
    function splitKeyWords(chain) {
      var words = "";
      if (chain !== null) {
        words = chain.split(" ") || [];
        words = words.filter(function(item, pos) {
          return words.indexOf(item) === pos;
        });
      }
      return words;
    }

      var pemission = {};
      if (userManager.isActionGranted('lives_type_no_api') || userManager.isActionGranted('lives_private_no_api') || userManager.isActionGranted('lives_active_no_api') && userManager.isActionGranted('lives_autopub_no_api') || userManager.isActionGranted('lives_screen_share_no_api') || userManager.isActionGranted('lives_webinar_no_api') || userManager.isActionGranted('lives_encoder_no_api') || userManager.isActionGranted('lives_rich_media_no_api') || userManager.isActionGranted('lives_associate_files_no_api') || userManager.isActionGranted('lives_associate_users_no_api')) {
          pemission.lives_tab_settings = true;
      }
      if (userManager.isActionGranted('lives_fo_like_no_api') || userManager.isActionGranted('lives_fo_chat_no_api') || userManager.isActionGranted('lives_social_media_no_api') && userManager.isActionGranted('lives_fo_files_share_no_api') || userManager.isActionGranted('lives_password_security_no_api') || userManager.isActionGranted('lives_fo_subscript_no_api') || userManager.isActionGranted('lives_fo_sondage_no_api') || userManager.isActionGranted('lives_fo_comment_no_api') || userManager.isActionGranted('lives_conf_post_add')) {
          pemission.lives_tab_fo_settings = true;
      }
      vm.permission = pemission;

    vm.selectChip = selectChip;
    vm.deleteAddedChip = deleteAddedChip;
    vm.openMenu = openMenu;
    vm.selectTab = selectTab;
    function selectTab(type) {
      vm.currentTab = type;
      if (type == "slide") {
        vm.tooltip_name = "MESSAGES.add_slides";
      } else if (type == "survey") {
        vm.tooltip_name = "MESSAGES.add_survey";
      } else {
        vm.tooltip_name = "MESSAGES.add_chapter";
      }
    }
    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function deleteAddedChip(chip) {
      var index = vm.filesChips.indexOf(chip);
      vm.filesChips.splice(index, 1);
      mimeTypeFilesChips.splice(index, 1);
      $rootScope.is_changed = true;
    }

    function selectChip(chip) {
      window.open(filesUrl[vm.filesChips.indexOf(chip)], "_blank");
    }
    vm.ngFlowOptionsFile = {
      target: Routing.generate("api_post_lives_thumb"),
      chunkSize: (function() {
        return Math.pow(10, 100);
      })(),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: "empApiFileForm[thumb]",
      query: {
        type: "attatched_files"
      },
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptionsFile.attributes = "image/*";
    vm.ngFlowFile = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    function testExtension(file) {
      var extn = file.split(".").pop();
      if (
        /(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(
          extn.toLowerCase()
        )
      ) {
        return "video";
      } else if (
        /(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())
      ) {
        return "audio";
      } else if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
        return "excel";
      } else if (/(doc|docx)$/i.test(extn.toLowerCase())) {
        return "word";
      } else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
        return "image";
      } else if (/(pdf)$/i.test(extn.toLowerCase())) {
        return "pdf";
      } else return "other";
    }
    function cancelUploadf() {
      $timeout(function() {
        vm.ngFlowFile.flow.cancel();
      });
    }

    function filefProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    function uploadFilef() {
      // Set headers
      vm.ngFlowFile.flow.upload();
      vm.inProgressf = true;
    }

    /**
     * Check if lives exists
     * @return if exists get Theme Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.lives.code) && vm.lives.code !== 200)
        $state.go("app.error_404");
      else {
        if (vm.lives.conf !== null) {
          vm.empLivesConfForm = {
            type: vm.lives.conf.type,
            message: vm.lives.conf.message,
            image: vm.lives.conf.image,
            imageText: vm.lives.conf.imageText,
            titleLive: vm.lives.conf.titleLive,
            descLive: vm.lives.conf.descLive
          };
          if(!vm.empLivesConfForm.type){
              vm.empLivesConfForm.type = "Counter";
          }
          if (vm.lives.conf.type === "Video") vm.vid = vm.lives.conf.video.id;
        }

        if (vm.lives.pwd !== null) {
          vm.password = true;
        } else {
          vm.password = "";
        }
        if (
          vm.lives.foWisembly === true ||
          vm.lives.foFacebook === true ||
          vm.lives.foTwitter === true
        ) {
          vm.reseaux = true;
        } else {
          vm.reseaux = "";
        }
        var survey;
        if (vm.lives.survey !== null) {
          vm.lives.foSondage = true;
          survey = vm.lives.survey.id;
        } else {
          vm.lives.foSondage = false;
          survey = "";
        }
        if (vm.lives.screenType !== null) {
          vm.lives.screenShare = true;
        } else {
          vm.lives.screenShare = false;
        }
        angular.forEach(livesData.data.files, function(value) {
          vm.filesChips.push(value.fileName);
          filesChips.push(value.title);
          filesUrl.push(value.url);
          mimeTypeFilesChips.push(value.mimeType);
        });
        angular.forEach(livesData.data.slides, function(value) {
          vm.slidesChips.push(value.slide);
          vm.slidesTypes.push(value.slideType);
          vm.slidesUrl.push(value.urlSlide);
          vm.slidesLoop.push(value.slideLoop);
          if (value.slideType == "Video") {
            vm.vignetteSlidesUrl.push(value.urlSlide.replace(".mp4", ".jpg"));
          } else {
            vm.vignetteSlidesUrl.push(value.urlSlide);
          }
        });
        vm.joinFile = filesChips.length > 0;
        vm.empLivesForm = {
          conf: vm.empLivesConfForm,
          defaultConf: vm.lives.defaultConf,
          dateStart: vm.lives.dateStart,
          thumbnail: vm.lives.thumbnail,
          userFile: vm.lives.userFile,
          dateEnd: vm.lives.dateEnd,
          active: vm.lives.active,
          isCdn: vm.lives.isCdn,
          screenShare: vm.lives.screenShare,
          screenType: vm.lives.screenType,
          autoPub: vm.lives.autoPub,
          description: vm.lives.description,
          foComment: vm.lives.foComment,
          foFilesShare: vm.lives.foFilesShare,
          foLike: vm.lives.foLike,
          foSondage: vm.lives.foSondage,
          foSubscript: vm.lives.foSubscript,
          private: vm.lives.private,
          tags: vm.lives.tags !== null ? splitKeyWords(vm.lives.tags) : [],
          chat: vm.lives.chat,
          webinar: vm.lives.webinar,
          isPearl: vm.lives.isPearl,
          isCommentValidation: vm.lives.isCommentValidation,
          isRm: vm.lives.isRm,
          title: vm.lives.title,
          pwd: vm.lives.pwd,
          foWisembly: vm.lives.foWisembly,
          foFacebook: vm.lives.foFacebook,
          foTwitter: vm.lives.foTwitter,
          survey: survey,
          diffusion:'',


          contributors: (function(list, data) {
            for (var i = 0; i < data.length; i++) {
              list.push(data[i].id);
            }
            return list;
          })([], vm.lives.contributors),
          questions: $rootScope.questions,
          chapters: $rootScope.chapters,
          mdTime: {
            date: new Date(moment(vm.lives.dateStart)),
            time: new Date(moment(vm.lives.dateStart))
          },
          endtime: new Date(moment(vm.lives.dateEnd))
        };
        if (vm.empLivesForm.tags[0] === "") vm.empLivesForm.tags = [];
        if(vm.lives.screenShare)
          vm.empLivesForm.diffusion= 'screenShare';
        else if(vm.lives.webinar)
          vm.empLivesForm.diffusion= 'webinar';
        else if(vm.lives.isPearl)
          vm.empLivesForm.diffusion= 'isPearl';

      }
    }

    // vm.minDate = vm.empLivesForm.mdTime.date;
    // vm.minTime = vm.empLivesForm.mdTime.time;

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    // vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptions.attributes = "image/*";
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: [{}, {}]
    };
    vm.ngFlowOptions2 = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptions2.attributes = "image/*";
    vm.ngFlow2 = {
      // ng-flow will be injected into here through its directive
      flow: [{}, {}]
    };
    vm.ngFlowfOptions = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowfOptions.attributes = "image/*";
    vm.ngFlowf = {
      // ng-flow will be injected into here through its directive
      flow: [{}, {}]
    };
    vm.uploadingInPogress = 0;
    vm.uploadingInPogressf = 0;
    vm.uploadingInPogressf2 = 0;

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.uploadfFile = uploadfFile;
    vm.filefAdded = filefAdded;
    vm.filefSuccess = filefSuccess;
    vm.uploadfComplete = uploadfComplete;
    vm.filef2Added = filef2Added;
    vm.uploadFilef = uploadFilef;
    vm.cancelUploadf = cancelUploadf;
    vm.filefProgress = filefProgress;
    vm.testExtension = testExtension;
    vm.filef2Success = filef2Success;
    vm.uploadf2Complete = uploadf2Complete;
    vm.uploadFile2 = uploadFile2;
    vm.cancel = $mdDialog.cancel;
    vm.addInteract = addInteract;
    vm.deleteChapter = deleteChapter;
    vm.deleteQuestion = deleteQuestion;
    vm.editQuestion = editQuestion;
    vm.editChapter = editChapter;
    vm.addSlide = addSlide;
    vm.deleteAddedSlideChip = deleteAddedSlideChip;
    vm.selectSlide = selectSlide;
    vm.loopSlideChip = loopSlideChip;

    function addInteract() {
      var data = { type: vm.currentTab, action: "add" };
      open_modal_rm(data);
    }

    function deleteChapter(chapter) {
      var index = $rootScope.chapters.indexOf(chapter);
      $rootScope.chapters.splice(index, 1);
      $rootScope.is_changed = true;
    }

    function deleteQuestion(question) {
      var index = $rootScope.questions.indexOf(question);
      $rootScope.questions.splice(index, 1);
      $rootScope.is_changed = true;
    }
    function editQuestion(question) {
      var index = $rootScope.questions.indexOf(question);
      var data = {
        type: "survey",
        action: "modify",
        info: question,
        index: index
      };
      open_modal_rm(data);
    }
    function editChapter(chapter) {
      var index = $rootScope.chapters.indexOf(chapter);
      var data = {
        type: "chapter",
        action: "modify",
        info: chapter,
        index: index
      };
      open_modal_rm(data);
    }
    function addSlide(type) {
      var data = { type: "slides", action: "add", typeSlide: type };
      open_modal_rm(data);
    }

    function open_modal_rm(data) {
      $mdDialog
        .show({
          controller: "liveRMController",
          controllerAs: "vm",
          templateUrl:
            "app/main/media/lives/live/views_add_edit_live/add_rich_media.modal.html",
          clickOutsideToClose: true,
          locals: {
            data: data,
            server_infos: livesData.data.server_infos
          }
        })
        .then(function() {});
    }

    function deleteAddedSlideChip(chip) {
      var index = $rootScope.slidesChips.indexOf(chip);
      $rootScope.slidesChips.splice(index, 1);
      $rootScope.slidesTypes.splice(index, 1);
      $rootScope.slidesUrl.splice(index, 1);
      $rootScope.vignetteSlidesUrl.splice(index, 1);
      $rootScope.slidesLoop.splice(index, 1);
      $rootScope.is_changed = true;
    }

    function loopSlideChip(slide, val) {
      var index = vm.slidesChips.indexOf(slide);
      vm.slidesLoop[index] = val;
      $rootScope.is_changed = true;
    }
    function selectSlide(chip) {
      var index = $rootScope.slidesChips.indexOf(chip);
      window.open($rootScope.slidesUrl[index], "_blank");
    }

    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.lives_edit_pagetitle";
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = "app.lives_list_ongoing";
      } else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_live_edit";
      $rootScope.text = [
        {
          texte: "parameters_live_edit_help"
        },
        {
          texte: "upload_button_live_add_help"
        },
        {
          texte: "upload_doc_button_live_add_help"
        },
        {
          texte: "send_button_live_edit_help"
        },
        {
          texte: "cancel_button_live_add_help"
        }
      ];
    }

    /**
     * return to lives list page
     * @return redirect to lives list page
     */
    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go("app.lives_list_ongoing", {diffusion: "endless"});
      } else {
        $state.go($rootScope.currentState);
      }
    }

    function changeDate() {
      vm.empLivesForm.dateStart = vm.empLivesForm.dateStart.replace(
        /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.date).format("YYYY-MM-DD")
      );
      vm.empLivesForm.dateEnd = vm.empLivesForm.dateEnd.replace(
        /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.date).format("YYYY-MM-DD")
      );
    }

    function changeTime() {
      vm.empLivesForm.dateStart = vm.empLivesForm.dateStart.replace(
        /[0-9]{2}:[0-9]{2}:[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.time).format("HH:mm:ss")
      );
    }

    function changeEndtime() {
      vm.empLivesForm.dateEnd = vm.empLivesForm.dateEnd.replace(
        /[0-9]{2}:[0-9]{2}:[0-9]{2}/,
        moment(vm.empLivesForm.endtime).format("HH:mm:ss")
      );
    }

    function submitTriggered() {
      this.isSubmitTriggered = true;
    }

    /**
     * Send add lives Form
     */
    function submitAddLivesForm() {
      if (!this.isSubmitTriggered) {
        return;
      }
      this.isSubmitTriggered = false;
      var formData = angular.copy(vm.empLivesForm);
      angular.forEach(vm.filesChips, function(value, index) {
        tabFiles.push({
          title: filesChips[index],
          fileName: value,
          mimeType: mimeTypeFilesChips[index]
        });
      });
      var interactivity = [];
      var slides = [];
      angular.forEach($rootScope.chapters, function(value) {
        interactivity.push({ type: "chapter", content: value.title });
      });
      angular.forEach($rootScope.questions, function(value) {
        var nsp = value.nsp;
        var type = "question";
        if (nsp == 2) {
          nsp = 0;
          type = "quiz";
        } else if (nsp == 3) {
          nsp = 1;
          type = "quiz";
        }
        interactivity.push({
          type: type,
          content: value.question,
          nsp: nsp,
          choices: value.choices
        });
      });
      angular.forEach($rootScope.slidesChips, function(value, index) {
        if ($rootScope.slidesTypes[index] == "Video") {
          slides.push({
            slide: value,
            slideType: $rootScope.slidesTypes[index],
            slideLoop: $rootScope.slidesLoop[index]
          });
        } else {
          slides.push({
            slide: value,
            slideType: $rootScope.slidesTypes[index]
          });
        }
      });

      formData.interactivity = interactivity;
      formData.slides = slides;
      switch (formData.conf.type) {
        case "Message":
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
        case "Image":
          delete formData.conf.message;
          delete formData.conf.video;
          break;
        case "Counter":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
        case "Video":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          formData.conf.video = vm.vid;
          break;
        case "Pearl":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
      }

      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      if (angular.isDefined(formData.endtime)) delete formData.endtime;
      if (formData.defaultConf === "1" || formData.defaultConf === true)
        delete formData.conf;
      if (formData.defaultConf === "0") formData.defaultConf = false;
      switch (formData.diffusion) {
        case "isPearl":
          formData.webinar=false;
          formData.screenShare=false;
          formData.isPearl=true;
          break;
        case "webinar":
          formData.webinar=true;
          formData.screenShare=false;
          formData.isPearl=false;

          break;
        case "screenShare":
          formData.webinar=false;
          formData.screenShare=true;
          formData.isPearl=false;
          break;
      }

      if (formData.screenShare === false) delete formData.screenType;
      if (formData.foSubscript === false) delete formData.foSondage;
      if (formData.foSondage === false) delete formData.survey;
      if (formData.foComment === false) delete formData.isCommentValidation;
      formData.tags = angular.isFunction(formData.tags.join)
        ? formData.tags.join(" ")
        : "none";
      formData.files = tabFiles;
      $rootScope.loadingProgress = true;
        if(vm.password){
            formData.isProtected = vm.password;
        }else{
            formData.pwd = "";
        }
      msApi.request(
        "livesLive.editLives@save",
        { empLivesForm: formData, id: vm.lives.id },
        function(res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set("LivesEdit", { title: "" });
            $state.go("app.lives_list_ongoing", {diffusion: "endless"});
          } else if (angular.isDefined(res.errors)) {
            vm.empLivesError = [];
            vm.errors = res.errors;
            vm.errors.forEach(function(item) {
              vm.empLivesError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empLivesForm[item.for])
              };
            });
            if (angular.isDefined(vm.empLivesError["dateStart"]))
              webTvGlobal.alertDialog(
                $translate.instant(
                  "VALIDATIONS." + vm.empLivesError["dateStart"].message
                )
              );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_operation_not_completed")
            );
          }
        },
        function(response) {
          if (
            angular.isDefined(response.data) &&
            angular.isDefined(response.data.message)
          ) {
            $translate("VALIDATIONS." + response.data.message).then(
              function(message) {
                webTvGlobal.alertDialog(message);
              },
              function() {
                webTvGlobal.alertDialog(
                  $translate.instant("MESSAGES.alert_xhr_error")
                );
              }
            );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_xhr_error")
            );
          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog(
          $translate.instant("MESSAGES.alert_not_valid_image_message")
        );
        return false;
      }
      var fileReader = new FileReader();
      var image = new Image();
      var width;
      var height;
      imageName = false;
      fileReader.onload = function(event) {
        var uri = event.target.result;
        image.src = uri;
        image.onload = function() {
          width = this.width;
          height = this.height;
          if (
            width < webTv_min_size_logo.width ||
            height < webTv_min_size_logo.height
          ) {
            imageName = false;
            webTvGlobal.alertDialog(
              $translate.instant(
                "MESSAGES.alert_not_valid_size_image_message"
              ) +
                " " +
                webTv_min_size_logo.width +
                "x" +
                webTv_min_size_logo.height
            );
            return false;
          } else {
            imageName = file.name;
            angular
              .element("#file-uploader")
              .find("button")
              .attr("disabled", "disabled");
            angular
              .element("<span>")
              .addClass("file-name")
              .html(file.name)
              .appendTo("#file-uploader");
            angular.element("#empLivesForm button[type='submit']").hide();
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
          }
        };
      };
      fileReader.readAsDataURL(file.file);
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile(index) {
      // Set headers
      // vm.ngFlow.flow.upload();
      // vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      vm.uploadingInPogress = 0;

      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empLivesForm.thumbnail = vm.lives.thumbnail = res.location.path;
        vm.urlVignette = res.location.url;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular
          .element("#file-uploader")
          .find("button")
          .removeAttr("disabled");
        angular
          .element("#file-uploader")
          .find(".file-name")
          .remove();
        angular.element("#empLivesForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        $scope.empLivesForm.$pristine = false;

        webTvGlobal.$toast().showCustom(
          $translate.instant("MESSAGES.file_imported", {
            fileName: imageName
          }),
          "",
          function() {
            vm.empLivesForm.thumbnail = "";
          }
        );
      }
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function filefAdded(file) {
      vm.fileName = file.name;
      angular
        .element("#filef-uploader")
        .find("button")
        .attr("disabled", "disabled");
      angular
        .element("<span>")
        .addClass("file-name")
        .html(file.name)
        .appendTo("#filef-uploader");
    }
    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile2() {
      // Set headers
      vm.ngFlow2.flow.upload();
      vm.inProgress = true;
    }

    function uploadfFile() {
      // Set headers
      vm.ngFlowf.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filefSuccess(file, message) {
      vm.uploadingInPogressf = 0;
      var res = angular.fromJson(message);
      if (res.location.path) {
        filesChips.push(res.location.path);
        if (angular.isDefined(res.location.mimeType)) {
          mimeTypeFilesChips.push(res.location.mimeType);
        }
        vm.filesChips.push(file.relativePath);
        filesUrl.push(res.location.url);
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadfComplete() {
      vm.progressBarValue = 0;
      vm.inProgressf = false;
      $rootScope.is_changed = true;
    }

    function filef2Added(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog(
          $translate.instant("MESSAGES.alert_not_valid_image_message")
        );
        return false;
      }
      imageName = file.name;
      angular
        .element("#filef2-uploader")
        .find("button")
        .attr("disabled", "disabled");
      angular
        .element("<span>")
        .addClass("file-name")
        .html(file.name)
        .appendTo("#filef2-uploader");
      angular.element("#empLivesForm button[type='submit']").hide();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filef2Success(file, message) {
      vm.uploadingInPogressf2 = 0;

      var res = angular.fromJson(message);

      if (res.location.path) {
        vm.empLivesConfForm.image = res.location.path;
        vm.urlVignette2 = res.location.url;
      }
      $rootScope.loadingProgress = false;
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadf2Complete() {
      if (imageName) {
        angular
          .element("#filef2-uploader")
          .find("button")
          .removeAttr("disabled");
        angular
          .element("#filef2-uploader")
          .find(".file-name")
          .remove();
        angular.element("#empLivesForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom(
          $translate.instant("MESSAGES.file_imported", {
            fileName: imageName
          }),
          "",
          function() {
            vm.empLivesConfForm.image = "";
          }
        );
      }
    }
  }
  function liveRMController(
    data,
    server_infos,
    $mdDialog,
    $injector,
    $cookies,
    webTvGlobal,
    $translate
  ) {
    var vm = this;
    vm.spinner = true;
    vm.data = data;
    vm.action = data.action;
    vm.type = data.type;
    vm.cancel = $mdDialog.cancel;
    vm.server_infos = server_infos;
    vm.typeSlide = data.typeSlide;
    var $rootScope = $injector.get("$rootScope"),
      $timeout = $injector.get("$timeout"),
      msUtils = $injector.get("msUtils");

    var parameters = webTvGlobal.$constant().webTvParameterBag();
    if (angular.isUndefined(parameters["app.client.name"])) {
      msApi.request("parametersBagLogin.app@get", function(res) {
        parameters = res.bag;
      });
    }

    vm.empRmForm = {
      title: "",
      nsp: 0,
      choices: []
    };
    if (angular.isDefined(data.info)) {
      if (vm.type == "chapter") {
        vm.empRmForm.title = data.info.title;
      } else if (vm.type == "survey") {
        vm.empRmForm.title = data.info.question;
        vm.empRmForm.nsp = data.info.nsp;
      }
    }
    vm.index = null;
    if (angular.isDefined(data.index)) {
      vm.index = data.index;
    }
    vm.progressBarValueSlide = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressSlide = false;
    vm.uploadingInPogressSlide = 0;
    if (angular.isDefined(data.info) && angular.isDefined(data.info.choices)) {
      vm.choicesQuestion = data.info.choices;
      vm.choicesQuestion[0].required = true;
    } else {
      vm.choicesQuestion = [];
      vm.choicesQuestion.push({ response: "", required: true });
    }

    vm.addRm = addRm;
    vm.addAnswer = addAnswer;
    vm.deleteAnswer = deleteAnswer;
    vm.uploadSlide = uploadSlide;
    vm.slideAdded = slideAdded;
    vm.slideProgress = slideProgress;
    vm.slideSuccess = slideSuccess;
    vm.uploadSlideComplete = uploadSlideComplete;
    vm.uploadSlideComplete = uploadSlideComplete;
    vm.cancelUploadSlide = cancelUploadSlide;

    if (data.typeSlide == "Video") {
      vm.ngFlowOptionsSlide = {
        target: vm.server_infos.target,
        chunkSize: (function() {
          return Math.pow(10, 100);
        })(),
        testChunks: false,
        maxChunkRetries: 1,
        chunkRetryInterval: 5000,
        simultaneousUploads: 1,
        fileParameterName: "userfile",
        query: {
          client: parameters["app.webtv.name"],
          server: vm.server_infos.server_name,
          login: vm.server_infos.server_login,
          password: vm.server_infos.server_password,
          dir: vm.server_infos.server_dir,
          ssh_key: vm.server_infos.server_ssh_key,
          target_dir: "images/",
          type_transfert: "sftp"
        },
        headers: {}
        //attributes: 'image/*',
        //testMethod: false,
      };
    } else {
      vm.ngFlowOptionsSlide = {
        target: Routing.generate("api_post_lives_thumb"),
        chunkSize: (function() {
          return Math.pow(10, 100);
        })(),
        testChunks: false,
        maxChunkRetries: 1,
        chunkRetryInterval: 5000,
        simultaneousUploads: 1,
        fileParameterName: "empApiFileForm[thumb]",
        query: {
          type: "slides"
        },
        headers: { Authorization: "Bearer " + $cookies.get("authToken") }
        //attributes: 'image/*',
        //testMethod: false,
      };
    }
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptionsSlide.attributes = "image/*";
    vm.ngFlowSlide = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    function cancelUploadSlide() {
      $timeout(function() {
        vm.ngFlowSlide.flow.cancel();
      });
    }

    function slideProgress(file) {
      vm.progressBarValueSlide = file.progress() * 100;
    }

    function uploadSlide() {
      // Set headers
      vm.ngFlowSlide.flow.upload();
      vm.inProgressSlide = true;
    }
    function slideAdded(file) {
      if (data.typeSlide == "Video") {
        if (!/(mp4)$/i.test(file.getExtension().toLowerCase())) {
          webTvGlobal
            .$toast()
            .showSimple(
              $translate.instant(
                "LIVEDIFFUSION.alert_not_valid_slide_video_message"
              )
            );
          return false;
        }
      } else {
        if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
          webTvGlobal
            .$toast()
            .showSimple(
              $translate.instant(
                "LIVEDIFFUSION.alert_not_valid_slide_image_message"
              )
            );
          return false;
        }
      }
      vm.fileName = file.name;
      angular
        .element("#filef-uploader")
        .find("button")
        .attr("disabled", "disabled");
      angular
        .element("<span>")
        .addClass("file-name")
        .html(file.name)
        .appendTo("#filef-uploader");
    }
    function slideSuccess(file, message) {
      vm.uploadingInPogressSlide = 0;
      var res = angular.fromJson(message);
      if (data.typeSlide == "Video") {
        if (res.file_name) {
          $rootScope.slidesChips.push(res.file_name + ".mp4");
          $rootScope.slidesUrl.push(
            vm.server_infos.url + res.file_name + ".mp4"
          );
          $rootScope.vignetteSlidesUrl.push(
            vm.server_infos.url + res.file_name + ".jpg"
          );
        }
      } else {
        if (res.location.path) {
          $rootScope.slidesChips.push(res.location.path);
          $rootScope.slidesUrl.push(res.location.url);
          $rootScope.vignetteSlidesUrl.push(res.location.url);
        }
      }
      $rootScope.slidesTypes.push(data.typeSlide);
      $rootScope.slidesLoop.push(0);
    }
    function uploadSlideComplete() {
      vm.progressBarValueSlide = 0;
      vm.inProgressSlide = false;
      $rootScope.is_changed = true;
      $mdDialog.hide();
    }

    function addRm(action, type) {
      var formData = angular.copy(vm.empRmForm);
      if (type == "chapter" && action == "add") {
        $rootScope.chapters.push({ title: formData.title });
        $rootScope.is_changed = true;
      }
      if (type == "survey" && action == "add") {
        $rootScope.questions.push({
          question: formData.title,
          nsp: formData.nsp,
          choices: vm.choicesQuestion
        });
        $rootScope.is_changed = true;
      }
      if (type == "survey" && action == "modify") {
        $rootScope.questions[vm.index] = {
          question: formData.title,
          nsp: formData.nsp,
          choices: vm.choicesQuestion
        };
        $rootScope.is_changed = true;
      }
      if (type == "chapter" && action == "modify") {
        $rootScope.chapters[vm.index] = { title: formData.title };
        $rootScope.is_changed = true;
      }
      $mdDialog.hide();
    }

    function getExtension(file) {
      var extn = file.split(".").pop();
      if (
        /(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(
          extn.toLowerCase()
        )
      ) {
        return "Video";
      } else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
        return "Image";
      }
    }

    function addAnswer() {
      vm.choicesQuestion.push({ response: "", required: false });
    }

    function deleteAnswer(choice) {
      var index = vm.choicesQuestion.indexOf(choice);
      vm.choicesQuestion.splice(index, 1);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.editLive', [])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_editLive', {
                url: '/lives/:id/edit_live',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/editLive/editLive.template.html',
                        controller: 'livesEditLiveController as vm'
                    }
                },
                resolve: {
                    urlLiveEdit: function (msApi,$stateParams) {
                        console.log("urlLiveEDit")
                        return msApi.resolve('livesEditLive.urlLiveEdit@get',{type:'edit',id:$stateParams.id});
                    }
                },
                bodyClass: 'calendar'

            });

        msApiProvider.register('livesEditLive.urlLiveEdit', [Routing.generate('api_get_url_list_live')]);

        //MS API
        // msApiProvider.register('livesLive.list_by_date', [Routing.generate('api_get_lives_lists_in_interval', {
        //     from: 'start',
        //     to: 'end'
        // }).replace(/from_start_to_end/, ":id"), {id: "@id"}])


    }
})();

(function () {
  'use strict';

  angular
    .module('app.lives.editLive')
      .controller('livesEditLiveController', livesEditLiveController);

  /** @ngInject */
  function livesEditLiveController($state,$injector,$translate, $scope,msApi, $sce,$rootScope,urlLiveEdit,$cookies) {
    var vm = this;
      var color = $cookies.get('selectedThemeColor');
      vm.editLink=$sce.trustAsResourceUrl(urlLiveEdit.url+'&lang='+$cookies.get('WEBTV.locale')+'&color='+color);//"https://mkharrat-web02-dev.webtv-solution.com:8063/live/add?cryptext=g-BQU5vciA98g68FZ9aPhFbt8F1UIEVp8X4fe9UCe08"
      vm.language = $translate.preferredLanguage();
    $scope.iframeLoadedCallBack = function(){
      sendPostMessage( vm.language )
    }
    eventPostMessage();
    function eventPostMessage() {
      if (angular.isUndefined(window.dataEventPostMessageEditLive)) {
        window.dataEventPostMessageEditLive = true;
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
          function(event) {
            if (event.data !== 'undefined') {
              if (event.data.info === 'goToListLive') {
                $state.go("app.lives_list_ongoing", {diffusion: "endless"});
              }
            }
          },
          false
        );
      }
    }
    function  sendPostMessage(lang){
      document.getElementById('iframe_live').contentWindow.postMessage({
        info: "updateLang",
        lang:lang
      }, "*");
    }

  }


})();

(function () {
    'use strict';

    angular
        .module('app.lives.list')
        .controller('livesLiveDetailController', livesLiveDetailController);

    /** @ngInject */
    function livesLiveDetailController(livesData, $mdDialog) {
        var vm = this;
        vm.lives = livesData.data.live;
        vm.cancel = cancel;


        function cancel() {
            $mdDialog.hide();
        }


    }


})();

(function () {
    'use strict';

    angular
        .module('app.lives.addLive', [])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_addLive', {
                url: '/lives/add_live',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/addLive/addLive.template.html',
                        controller: 'livesAddLiveController as vm'
                    }
                },
                resolve: {
                    urlLiveAdd: function (msApi,$stateParams) {
                        return msApi.resolve('livesAddLive.urlLiveAdd@get',{type:'add'});
                    }
                },
                bodyClass: 'calendar'

            });

        msApiProvider.register('livesAddLive.urlLiveAdd', [Routing.generate('api_get_url_list_live')]);

        //MS API
        // msApiProvider.register('livesLive.list_by_date', [Routing.generate('api_get_lives_lists_in_interval', {
        //     from: 'start',
        //     to: 'end'
        // }).replace(/from_start_to_end/, ":id"), {id: "@id"}])


    }
})();

(function () {
  'use strict';

  angular
    .module('app.lives.addLive')
      .controller('livesAddLiveController', livesAddLiveController);

  /** @ngInject */
  function livesAddLiveController($state,$scope,$injector,$translate, msApi, $sce,$rootScope,urlLiveAdd,$cookies) {
    var vm = this;
      var color = $cookies.get('selectedThemeColor');
    vm.addLink=$sce.trustAsResourceUrl(urlLiveAdd.url+'&lang='+$cookies.get('WEBTV.locale')+'&color='+color);//"https://mkharrat-web02-dev.webtv-solution.com:8063/live/add?cryptext=g-BQU5vciA98g68FZ9aPhFbt8F1UIEVp8X4fe9UCe08"
    vm.language = $translate.preferredLanguage();
    $scope.iframeLoadedCallBack = function(){
      sendPostMessage( vm.language )
    }

    eventPostMessage();
    function eventPostMessage() {
      if (angular.isUndefined(window.dataEventPostMessageAddLive)) {
        window.dataEventPostMessageAddLive = true;
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

        eventer(
          messageEvent,
          function(event) {
            if (event.data !== 'undefined') {
              if (event.data.info === 'goToListLive') {
                $state.go("app.lives_list_ongoing", {diffusion: "endless"});
              }
            }
          },
          false
        );
      }
    }
  function  sendPostMessage(lang){
      document.getElementById('iframe_live').contentWindow.postMessage({
        info: "updateLang",
        lang:lang
      }, "*");
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.lives.calendar', ['ui.calendar'])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_calendar', {
                url: '/lives/calendar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/calendar/calendar.template.html',
                        controller: 'livesLiveCalendarController as vm'
                    }
                },
                bodyClass: 'calendar'
            });


        //MS API
        msApiProvider.register('livesLive.list_by_date', [Routing.generate('api_get_lives_lists_in_interval', {
            from: 'start',
            to: 'end'
        }).replace(/from_start_to_end/, ":id"), {id: '@id'}])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.lives.calendar')
    .controller('livesLiveCalendarController', livesLiveCalendarController);

  /** @ngInject */
  function livesLiveCalendarController($state, msApi, $rootScope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    // Data


    vm.lives = [];
    vm.calendarUiConfig = {
      calendar: {
        editable: false,
        livesLimit: false,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        selectable: false,
        selectHelper: false,
        allDaySlot: false,
        loading: function (bool) {
          if (bool) $rootScope.loadingProgress = true;
          else $rootScope.loadingProgress = false;
        },
        events: function (start, end, timezone, pushIntoCalendarEvents) {
          msApi.request('livesLive.list_by_date@get',
            {id: "from_" + start.format('YYYY-MM-DD') + "_to_" + end.format('YYYY-MM-DD')},
            function (res) {
              var events = [];
              var now = moment();
              for (var i = 0; i < res.data.liveslists.length; i++) {
                var liveslist = res.data.liveslists[i];
                events.push({
                  "allDay": false,
                  "id": liveslist.id,
                  "title": liveslist.title,
                  "start": (moment(liveslist.dateStart))/*.format('YYYY-MM-DD HH:mm:ss')*/,
                  "end": (moment(liveslist.dateStart)).add(liveslist.maxDuration, "hours")/*.format('YYYY-MM-DD HH:mm:ss')*/,
                  "className": moment(liveslist.dateStart) < now ? "red-bg" : "green-bg"
                });
              }
              pushIntoCalendarEvents(events);
            },
            function () {

            }
          );
        }
      }
    };

    // vm.next = next;
    // vm.prev = prev;
    vm.returnToList = returnToList;

    //////////

    // /**
    //  * Go to next on current view (week, month etc.)
    //  */
    // function next() {
    //     vm.calendarView.calendar.next();
    // }
    //
    // /**
    //  * Go to previous on current view (week, month etc.)
    //  */
    // function prev() {
    //     vm.calendarView.calendar.prev();
    // }

    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go('app.lives_list_ongoing', {diffusion: "endless"});
      }
      else {
        $state.go($rootScope.currentState);
      }
    }


  }


})();

(function () {
    'use strict';

    angular
        .module('app.lives.add', ['mdPickers',"flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {


        // State
        $stateProvider
            .state('app.lives_add', {
                url: "/lives/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/live/views_add_edit_live/add_edit.template.html',
                        controller: 'livesLiveAddController as vm'
                    }
                },
                resolve: {
                    livesData: function (msApi) {
                        return msApi.resolve('livesLive.getNewLives@get', {id: 0});
                    },
                    liveConfData: function (msApi) {
                        return msApi.resolve('livesLive.getNewConfData@get', {id: 0});
                    },
                    liveConfGetVideos: function (msApi) {
                        return msApi.resolve('livesLive.getVideos@get');
                    },
                    liveConfGetSondages: function (msApi) {
                        return msApi.resolve('livesLive.getSondages@get');
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "lives_post_add_action"
            });


        //API
        msApiProvider.register('livesLive.getNewLives', [Routing.generate('api_get_lives_live_detail', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('livesLive.addLives', [Routing.generate('api_post_add_lives_live')]);
        msApiProvider.register('livesLive.getVideos', [Routing.generate('api_media_get_transcoded_videos')]);
        msApiProvider.register('livesLive.getSondages', [Routing.generate('api_survey_get_list_surveys')]);
        msApiProvider.register('livesLive.addConfLive', [Routing.generate('api_lives_post_add_lives_conf')]);
        msApiProvider.register('livesLive.getNewConfData', [Routing.generate('api_lives_get_lives_confd', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('live_conf.addConf', [Routing.generate('api_lives_post_add_lives_conf')]);


    }
})();
(function() {
  "use strict";

  angular
    .module("app.lives.add")
    .controller("livesLiveAddController", livesLiveAddController);

  /** @ngInject */
  function livesLiveAddController(
    liveConfGetSondages,
    userManager,
    liveConfGetVideos,
    livesData,
    contributorsData,
    webTvGlobal,
    $injector,
    $cookies,
    $mdDialog,
    webTv_min_size_logo
  ) {
    var myEl = angular.element(document.querySelector("#content"));
    if (angular.isDefined(myEl));
    myEl.removeClass("animate-slide-up");
    var $rootScope = $injector.get("$rootScope"),
      $translate = $injector.get("$translate"),
      $state = $injector.get("$state"),
      msApi = $injector.get("msApi"),
      $timeout = $injector.get("$timeout"),
      msUtils = $injector.get("msUtils");
    var vm = this;
    vm.isNew = true;
    var imageName;
    vm.minDate = undefined;
    $rootScope.chapters = [];
    $rootScope.questions = [];
    $rootScope.slidesChips = [];
    $rootScope.slidesTypes = [];
    $rootScope.slidesUrl = [];
    $rootScope.vignetteSlidesUrl = [];
    $rootScope.slidesLoop = [];
    vm.vignetteSlidesUrl = $rootScope.vignetteSlidesUrl;
    vm.slidesLoop = $rootScope.slidesLoop;
    vm.slidesChips = $rootScope.slidesChips;
    vm.slidesUrl = $rootScope.slidesUrl;
    vm.slidesTypes = $rootScope.slidesTypes;

    vm.fileName;
    vm.lives = livesData.live;
    vm.hasDefault = livesData.hasDefault;
    vm.urlVignette = "";
    vm.urlVignette2 = "";
    vm.reseaux = "";
    vm.password = "";
    vm.videos = webTvGlobal.convertToSelectChoicesFormat(
      liveConfGetVideos.data.names
    );
    vm.sondages = webTvGlobal.convertToSelectChoicesFormat(
      liveConfGetSondages.data.names
    );
    vm.filesChips = [];
    var filesChips = [];
    var mimeTypeFilesChips = [];
    var filesUrl = [];
    var tabFiles = [];
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressf = false;
    vm.currentTab = "chapter";
    vm.tooltip_name = "MESSAGES.add_chapter";

    vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
      (function(contributors, data) {
        for (var i = 0; i < data.length; i++) {
          contributors[data[i].name] = data[i].id;
        }
        return contributors;
      })({}, contributorsData.contributors)
    );

      var pemission = {};
      if (userManager.isActionGranted('lives_type_no_api') || userManager.isActionGranted('lives_private_no_api') || userManager.isActionGranted('lives_active_no_api') && userManager.isActionGranted('lives_autopub_no_api') || userManager.isActionGranted('lives_screen_share_no_api') || userManager.isActionGranted('lives_webinar_no_api') || userManager.isActionGranted('lives_encoder_no_api') || userManager.isActionGranted('lives_rich_media_no_api') || userManager.isActionGranted('lives_associate_files_no_api') || userManager.isActionGranted('lives_associate_users_no_api')) {
          pemission.lives_tab_settings = true;
      }
      if (userManager.isActionGranted('lives_fo_like_no_api') || userManager.isActionGranted('lives_fo_chat_no_api') || userManager.isActionGranted('lives_social_media_no_api') && userManager.isActionGranted('lives_fo_files_share_no_api') || userManager.isActionGranted('lives_password_security_no_api') || userManager.isActionGranted('lives_fo_subscript_no_api') || userManager.isActionGranted('lives_fo_sondage_no_api') || userManager.isActionGranted('lives_fo_comment_no_api') || userManager.isActionGranted('lives_conf_post_add')) {
          pemission.lives_tab_fo_settings = true;
      }
      vm.permission = pemission;

    vm.empLivesConfForm = {
      type: "Counter",
      message: "",
      image: "",
      imageText: "",
      titleLive: "",
      descLive: ""
    };
    if (userManager.isActionGranted("lives_associate_users_no_api")) {
      var user = userManager.getUser();
      var default_contributors = [user.id];
    } else {
      var default_contributors = [];
    }
    vm.empLivesForm = {
      conf: vm.empLivesConfForm,
      defaultConf: vm.lives.defaultConf,
      isCdn: vm.lives.isCdn,
      dateStart: vm.lives.dateStart,
      dateEnd: vm.lives.dateEnd,
      thumbnail: vm.lives.thumbnail || "",
      userFile: vm.lives.userFile || "",
      foSondage: false,
      foSubscript: false,
      foComment: false,
      screenShare: false,
      screenType: "",
      tags: [],
      contributors: default_contributors,
      mdTime: {
        date: new Date(moment(vm.lives.dateStart)),
        time: new Date(moment(vm.lives.dateStart))
      },
      questions: $rootScope.questions,
      chapters: $rootScope.chapters,
      endtime: new Date(moment(vm.lives.dateEnd))
    };
    // vm.minDate = vm.empLivesForm.mdTime.date;
    vm.isSubmitTriggered = false;
    vm.submitAddLivesForm = submitAddLivesForm;
    vm.submitTriggered = submitTriggered;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;
    vm.changeEndtime = changeEndtime;
    vm.clearSearchTerm = clearSearchTerm;
    vm.searchTerm;

    vm.selectChip = selectChip;
    vm.deleteAddedChip = deleteAddedChip;

    vm.cancel = $mdDialog.cancel;
    vm.addInteract = addInteract;
    vm.deleteChapter = deleteChapter;
    vm.deleteQuestion = deleteQuestion;
    vm.addSlide = addSlide;
    vm.deleteAddedSlideChip = deleteAddedSlideChip;
    vm.selectSlide = selectSlide;
    vm.editQuestion = editQuestion;
    vm.editChapter = editChapter;

    vm.openMenu = openMenu;
    vm.loopSlideChip = loopSlideChip;
    vm.selectTab = selectTab;
    function selectTab(type) {
      vm.currentTab = type;
      if (type == "slide") {
        vm.tooltip_name = "MESSAGES.add_slides";
      } else if (type == "survey") {
        vm.tooltip_name = "MESSAGES.add_survey";
      } else {
        vm.tooltip_name = "MESSAGES.add_chapter";
      }
    }
    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function editQuestion(question) {
      var index = $rootScope.questions.indexOf(question);
      var data = {
        type: "survey",
        action: "modify",
        info: question,
        index: index
      };
      open_modal_rm(data);
    }
    function editChapter(chapter) {
      var index = $rootScope.chapters.indexOf(chapter);
      var data = {
        type: "chapter",
        action: "modify",
        info: chapter,
        index: index
      };
      open_modal_rm(data);
    }
    function addInteract() {
      var data = { type: vm.currentTab, action: "add" };
      open_modal_rm(data);
    }

    function deleteChapter(chapter) {
      var index = $rootScope.chapters.indexOf(chapter);
      $rootScope.chapters.splice(index, 1);
    }

    function deleteQuestion(question) {
      var index = $rootScope.questions.indexOf(question);
      $rootScope.questions.splice(index, 1);
    }
    function addSlide(type) {
      var data = { type: "slides", action: "add", typeSlide: type };
      open_modal_rm(data);
    }

    function open_modal_rm(data) {
      $mdDialog
        .show({
          controller: "liveRMController",
          controllerAs: "vm",
          templateUrl:
            "app/main/media/lives/live/views_add_edit_live/add_rich_media.modal.html",
          clickOutsideToClose: true,
          locals: {
            data: data,
            server_infos: livesData.server_infos
          }
        })
        .then(function() {});
    }

    function deleteAddedSlideChip(chip) {
      var index = $rootScope.slidesChips.indexOf(chip);
      $rootScope.slidesChips.splice(index, 1);
      $rootScope.slidesTypes.splice(index, 1);
      $rootScope.slidesUrl.splice(index, 1);
      $rootScope.vignetteSlidesUrl.splice(index, 1);
      $rootScope.slidesLoop.splice(index, 1);
    }
    function selectSlide(chip) {
      var index = $rootScope.slidesChips.indexOf(chip);
      window.open($rootScope.slidesUrl[index], "_blank");
    }

    function loopSlideChip(slide, val) {
      var index = vm.slidesChips.indexOf(slide);
      vm.slidesLoop[index] = val;
      $rootScope.is_changed = true;
    }
    function deleteAddedChip(chip) {
      var index = vm.filesChips.indexOf(chip);
      vm.filesChips.splice(index, 1);
      mimeTypeFilesChips.splice(index, 1);
    }

    function selectChip(chip) {
      window.open(filesUrl[vm.filesChips.indexOf(chip)], "_blank");
    }
    vm.ngFlowOptionsFile = {
      target: Routing.generate("api_post_lives_thumb"),
      chunkSize: (function() {
        return Math.pow(10, 100);
      })(),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: "empApiFileForm[thumb]",
      query: {
        type: "attatched_files"
      },
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptionsFile.attributes = "image/*";
    vm.ngFlowFile = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    function testExtension(file) {
      var extn = file.split(".").pop();
      if (
        /(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(
          extn.toLowerCase()
        )
      ) {
        return "video";
      } else if (
        /(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())
      ) {
        return "audio";
      } else if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
        return "excel";
      } else if (/(doc|docx)$/i.test(extn.toLowerCase())) {
        return "word";
      } else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
        return "image";
      } else if (/(pdf)$/i.test(extn.toLowerCase())) {
        return "pdf";
      } else return "other";
    }
    function cancelUploadf() {
      $timeout(function() {
        vm.ngFlowFile.flow.cancel();
      });
    }

    function filefProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    function uploadFilef() {
      // Set headers
      vm.ngFlowFile.flow.upload();
      vm.inProgressf = true;
    }

    function clearSearchTerm() {
      vm.searchTerm = "";
    }

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    // vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };

    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptions.attributes = "image/*";
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    vm.ngFlowOptions2 = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };
    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowOptions2.attributes = "image/*";
    vm.ngFlow2 = {
      // ng-flow will be injected into here through its directive
      flow: [{}, {}]
    };
    vm.ngFlowfOptions = {
      target: Routing.generate("api_post_lives_thumb"),
      singleFile: true,
      testChunks: false,
      fileParameterName: "empApiFileForm[thumb]",
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
      //attributes: 'image/*',
      //testMethod: false,
    };

    if (/chrome/.test(msUtils.detectBrowser().browser))
      vm.ngFlowfOptions.attributes = "image/*";
    vm.ngFlowf = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    vm.uploadingInPogress = 0;
    vm.uploadingInPogressf = 0;
    vm.uploadingInPogressf2 = 0;

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.uploadfFile = uploadfFile;
    vm.filefAdded = filefAdded;
    vm.uploadFilef = uploadFilef;
    vm.cancelUploadf = cancelUploadf;
    vm.filefProgress = filefProgress;
    vm.filefSuccess = filefSuccess;
    vm.testExtension = testExtension;
    vm.uploadfComplete = uploadfComplete;
    vm.filef2Added = filef2Added;
    vm.uploadFile2 = uploadFile2;

    vm.filef2Success = filef2Success;
    vm.uploadf2Complete = uploadf2Complete;
    vm.returnToList = returnToList;

    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.lives_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.lives_add_menuTitle";
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = "app.lives_list_ongoing";
      } else {
        $rootScope.pageRoute = $rootScope.currentState;
      }

      $rootScope.welcome = "welcome_live_add";
      $rootScope.text = [
        {
          texte: "parameters_live_add_help"
        },
        {
          texte: "upload_button_live_add_help"
        },
        {
          texte: "upload_doc_button_live_add_help"
        },
        {
          texte: "send_button_live_add_help"
        },
        {
          texte: "cancel_button_live_add_help"
        }
      ];
    }

    function changeDate() {
      vm.empLivesForm.dateStart = vm.empLivesForm.dateStart.replace(
        /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.date).format("YYYY-MM-DD")
      );
      vm.empLivesForm.dateEnd = vm.empLivesForm.dateEnd.replace(
        /[0-9]{4}-[0-9]{2}-[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.date).format("YYYY-MM-DD")
      );
    }

    function changeTime() {
      vm.empLivesForm.dateStart = vm.empLivesForm.dateStart.replace(
        /[0-9]{2}:[0-9]{2}:[0-9]{2}/,
        moment(vm.empLivesForm.mdTime.time).format("HH:mm:ss")
      );
    }

    function changeEndtime() {
      vm.empLivesForm.dateEnd = vm.empLivesForm.dateEnd.replace(
        /[0-9]{2}:[0-9]{2}:[0-9]{2}/,
        moment(vm.empLivesForm.endtime).format("HH:mm:ss")
      );
    }

    function submitTriggered() {
      this.isSubmitTriggered = true;
    }

    /**
     * Send add lives Form
     */
    function submitAddLivesForm() {
      if (!this.isSubmitTriggered) {
        return;
      }
      this.isSubmitTriggered = false;
      angular.forEach(vm.filesChips, function(value, index) {
        tabFiles.push({
          title: filesChips[index],
          fileName: value,
          mimeType: mimeTypeFilesChips[index]
        });
      });
      var formData = angular.copy(vm.empLivesForm);

      var interactivity = [];
      var slides = [];
      angular.forEach($rootScope.chapters, function(value) {
        interactivity.push({ type: "chapter", content: value.title });
      });
      angular.forEach($rootScope.questions, function(value) {
        var nsp = value.nsp;
        var type = "question";
        if (nsp == 2) {
          nsp = 0;
          type = "quiz";
        } else if (nsp == 3) {
          nsp = 1;
          type = "quiz";
        }
        interactivity.push({
          type: type,
          content: value.question,
          nsp: nsp,
          choices: value.choices
        });
      });
      angular.forEach($rootScope.slidesChips, function(value, index) {
        if ($rootScope.slidesTypes[index] == "Video") {
          slides.push({
            slide: value,
            slideType: $rootScope.slidesTypes[index],
            slideLoop: $rootScope.slidesLoop[index]
          });
        } else {
          slides.push({
            slide: value,
            slideType: $rootScope.slidesTypes[index]
          });
        }
      });

      formData.interactivity = interactivity;
      formData.slides = slides;
      switch (formData.conf.type) {
        case "Message":
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
        case "Image":
          delete formData.conf.message;
          delete formData.conf.video;
          break;
        case "Counter":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
        case "Video":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          formData.conf.video = vm.vid;
          break;
        case "Pearl":
          delete formData.conf.message;
          delete formData.conf.image;
          delete formData.conf.imageText;
          delete formData.conf.video;
          break;
      }
      var formDataConf = angular.copy(vm.empLivesConfForm);

      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      if (angular.isDefined(formData.endtime)) delete formData.endtime;
      if (formData.defaultConf === "1" || formData.defaultConf === true)
        delete formData.conf;
      if (formData.defaultConf === "0") formData.defaultConf = false;
      if (formData.isCdn === false) formData.isCdn = "0";
      if (formData.foSubscript === false) delete formData.foSondage;
      if (formData.foSondage === false) delete formData.survey;
      if (formData.foComment === false) delete formData.isCommentValidation;
      formData.tags = angular.isFunction(formData.tags.join)
        ? formData.tags.join(" ")
        : "none";
      formData.files = tabFiles;
      $rootScope.loadingProgress = true;

      if(vm.password){
          formData.isProtected = vm.password;
      }else{
          formData.pwd = "";
      }
      switch (formData.diffusion) {
        case "isPearl":
          formData.webinar=false;
          formData.screenShare=false;
          formData.isPearl=true;
          break;
        case "webinar":
          formData.webinar=true;
          formData.screenShare=false;
          formData.isPearl=false;

          break;
        case "screenShare":
          formData.webinar=false;
          formData.screenShare=true;
          formData.isPearl=false;
          break;
      }
      if (formData.screenShare === false) delete formData.screenType;

      msApi.request(
        "livesLive.addLives@save",
        { empLivesForm: formData },
        function(res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            if (vm.hasDefault === false) {
              if (vm.empLivesConfForm.type === "Message") {
                delete formDataConf.image;
                delete formDataConf.imageText;
                delete formDataConf.video;
              }
              if (vm.empLivesConfForm.type === "Image") {
                delete formDataConf.message;
                delete formDataConf.video;
              }
              if (vm.empLivesConfForm.type === "Counter") {
                delete formDataConf.message;
                delete formDataConf.image;
                delete formDataConf.imageText;
                delete formDataConf.video;
              }
              if (vm.empLivesConfForm.type === "Video") {
                delete formDataConf.message;
                delete formDataConf.image;
                delete formDataConf.imageText;
                formDataConf.video = vm.vid;
              }
              if (vm.empLivesConfForm.type === "Pearl") {
                delete formDataConf.message;
                delete formDataConf.image;
                delete formDataConf.imageText;
                delete formDataConf.video;
              }

              msApi.request(
                "live_conf.addConf@save",
                { empLivesConfForm: formDataConf },
                function(res) {
                  $rootScope.loadingProgress = false;
                  if (res.code === 200) {
                  } else {
                    webTvGlobal.alertDialog(
                      $translate.instant(
                        "MESSAGES.alert_operation_not_completed"
                      )
                    );
                    //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                  }
                },
                function() {
                  $rootScope.loadingProgress = false;
                  webTvGlobal.alertDialog(
                    $translate.instant("MESSAGES.alert_xhr_error")
                  );
                }
              );
            }
            webTvGlobal
              .$toast()
              .showSimple($translate.instant("LIVESLIST.added"));
            $state.go("app.lives_list_ongoing", {diffusion: "endless"});
          } else if (angular.isDefined(res.errors)) {
            vm.empLivesError = [];
            vm.errors = res.errors;
            vm.errors.forEach(function(item) {
              vm.empLivesError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empLivesForm[item.for])
              };
            });
            if (angular.isDefined(vm.empLivesError["dateStart"]))
              webTvGlobal.alertDialog(
                $translate.instant(
                  "VALIDATIONS." + vm.empLivesError["dateStart"].message
                )
              );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_operation_not_completed")
            );
          }
        },
        function(response) {
          if (
            angular.isDefined(response.data) &&
            angular.isDefined(response.data.message)
          ) {
            $translate("VALIDATIONS." + response.data.message).then(
              function(message) {
                webTvGlobal.alertDialog(message);
              },
              function() {
                webTvGlobal.alertDialog(
                  $translate.instant("MESSAGES.alert_xhr_error")
                );
              }
            );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_xhr_error")
            );
          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog(
          $translate.instant("MESSAGES.alert_not_valid_image_message")
        );
        return false;
      }
      var fileReader = new FileReader();
      var image = new Image();
      var width;
      var height;
      imageName = false;
      fileReader.onload = function(event) {
        var uri = event.target.result;
        image.src = uri;
        image.onload = function() {
          width = this.width;
          height = this.height;
          if (
            width < webTv_min_size_logo.width ||
            height < webTv_min_size_logo.height
          ) {
            imageName = false;
            webTvGlobal.alertDialog(
              $translate.instant(
                "MESSAGES.alert_not_valid_size_image_message"
              ) +
                " " +
                webTv_min_size_logo.width +
                "x" +
                webTv_min_size_logo.height
            );
            return false;
          } else {
            imageName = file.name;
            angular
              .element("#file-uploader")
              .find("button")
              .attr("disabled", "disabled");
            angular
              .element("<span>")
              .addClass("file-name")
              .html(file.name)
              .appendTo("#file-uploader");
            angular.element("#empLivesForm button[type='submit']").hide();
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
          }
        };
      };
      fileReader.readAsDataURL(file.file);
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.upload();
      // vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      vm.uploadingInPogress = 0;

      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empLivesForm.thumbnail = res.location.path;
        // vm.empLivesForm.userFile=vm.lives.userFile=
        vm.urlVignette = res.location.url;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular
          .element("#file-uploader")
          .find("button")
          .removeAttr("disabled");
        angular
          .element("#file-uploader")
          .find(".file-name")
          .remove();
        angular.element("#empLivesForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom(
          $translate.instant("MESSAGES.file_imported", {
            fileName: imageName
          }),
          "",
          function() {
            vm.empLivesForm.thumbnail = "";
          }
        );
      }
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function filefAdded(file) {
      vm.fileName = file.name;
    }

    function uploadfFile() {
      // Set headers
      vm.ngFlowf.flow.upload();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile2() {
      // Set headers
      vm.ngFlow2.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filefSuccess(file, message) {
      vm.uploadingInPogressf = 0;
      var res = angular.fromJson(message);
      if (res.location.path) {
        filesChips.push(res.location.path);
        if (angular.isDefined(res.location.mimeType)) {
          mimeTypeFilesChips.push(res.location.mimeType);
        }
        vm.filesChips.push(file.relativePath);
        filesUrl.push(res.location.url);
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadfComplete() {
      vm.progressBarValue = 0;
      vm.inProgressf = false;
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function filef2Added(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog(
          $translate.instant("MESSAGES.alert_not_valid_image_message")
        );
        return false;
      }
      imageName = file.name;
      angular
        .element("#filef2-uploader")
        .find("button")
        .attr("disabled", "disabled");
      angular
        .element("<span>")
        .addClass("file-name")
        .html(file.name)
        .appendTo("#filef2-uploader");
      angular.element("#empLivesForm button[type='submit']").hide();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filef2Success(file, message) {
      vm.uploadingInPogressf2 = 0;

      var res = angular.fromJson(message);

      if (res.location.path) {
        vm.empLivesConfForm.image = res.location.path;
        vm.urlVignette2 = res.location.url;
      }
      $rootScope.loadingProgress = false;
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadf2Complete() {
      if (imageName) {
        angular
          .element("#filef2-uploader")
          .find("button")
          .removeAttr("disabled");
        angular
          .element("#filef2-uploader")
          .find(".file-name")
          .remove();
        angular.element("#empLivesForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom(
          $translate.instant("MESSAGES.file_imported", {
            fileName: imageName
          }),
          "",
          function() {
            vm.empLivesConfForm.image = "";
          }
        );
      }
    }

    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go("app.lives_list_ongoing", {diffusion: "endless"});
      } else {
        $state.go($rootScope.currentState);
      }
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.display_new.schedule', [
      'app.display_new.schedule.calendar',
      'app.display_new.schedule.add',
      'app.display_new.schedule.list',
      'app.display_new.schedule.edit',
    ])
    .config(config)
    .run(fetchRights);

  /** @ngInject */
  function config(msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
    msNavigationServiceProvider.saveItem('display_new.schedule', {
      title: 'Users',
      translate: 'PAGESMENUSTITLES.display_schedule_menuTitle',
      permission: 'display_schedule_list_dtable',
      icon: 'icon-calendar-text',
      state: 'app.display_schedule_list_new',
      weight: 4,
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/displayNew/schedule');
  }
  function fetchRights(msRights) {
    if (mod === 'dev') {
      var permissions = {
        pattern: '^(?=.*api)(?=.*schedule).*$',
        name_module: 'display_new_schedule',
        name_angular_module: 'app.display_new.schedule',
        actions: [
          { add: ['post_add'] },
          { edit: ['post_edit', 'post_edit_order'] },
          {
            list: [
              'post_disable',
              'post_enable',
              'list_dtable',
              'get_all',
              'delete_many',
              'delete_one',
              'get_one',
              'get_reload',
            ],
          },
        ],
      };
      msRights.setPermissions(permissions);
    }
  }
})();

(function ()
{
    'use strict';

    angular.module('app.display_new.schedule')
        .controller('DisplayNewScheduleDetailController', DisplayNewScheduleDetailController);

    /** @ngInject */
    function DisplayNewScheduleDetailController($mdDialog, calendarEvent,$rootScope,$state,$translate, webTvGlobal,msApi, $cookies, event)
    {
        var vm = this;

        // Data
        vm.slot=parseInt($cookies.get('slotSchedule')) || 1;
        function convertMinsToHrsMins(minutes) {
            var h = Math.floor(minutes / 60);
            var m = minutes % 60;
            h = h < 10 ? '0' + h : h;
            m = m < 10 ? '0' + m : m;
            return h + ':' + m + ':' + '00';
        }
        var slot= convertMinsToHrsMins(vm.slot);

        vm.calendarEvent = calendarEvent;
        vm.events=[];
        vm.deleteTemplate=deleteTemplate;
        // Methods
      //  vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;
        vm.status="";
        vm.updateSchedule=updateSchedule;
        vm.setCalendarConfigLanguage=setCalendarConfigLanguage;
        vm.editSchedule=editSchedule;
        $rootScope.setCalendarConfigLanguage=setCalendarConfigLanguage;

        vm.testDate = testDate;


        function testDate(){
            var startDate =vm.calendarEvent._event.startAt;
            var endDate =vm.calendarEvent._event.endAt;
            var currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ");
            startDate = (moment(startDate).format("YYYY-MM-DD HH:mm:ssZ"));
            endDate = (moment(endDate).format("YYYY-MM-DD HH:mm:ssZ"));

            if((currentDate >= startDate)&&(currentDate <= endDate))
            {
                //en cours de diffusion

                return true;
            }
            else {
                //n'est pas en cours de diffusion
                return false;
            }
        }
         vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                slotDuration      : slot,
                header            : '',
                handleWindowResize: false,
                allDay:false,
                aspectRatio       : 1,
                lang: $translate.preferredLanguage(),
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                },
                height: 500,
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                loading: function (bool) {
                    if(bool)$rootScope.loadingProgress = true;
                    else $rootScope.loadingProgress = false;
                },
                events: function(start, end, timezone, pushIntoCalendarEvents) {
                            vm.status=vm.calendarEvent.status;
                           var events = [];
                           var now = moment();
                            for(var i = 0; i <vm.calendarEvent.schedulePrograms.length; i++){
                                var event = vm.calendarEvent.schedulePrograms[i];
                                 events.push({
                                    "allDay":false,
                                    "id":event.id,
                                    "title":event.template.title,
                                    "start":moment(event.startAt),
                                    "end":moment(event.endAt),
                                    "className":vm.calendarEvent.backgroundColor,
                                    "backgroundColor":(getRandomColor()+"!important"),
                                    "unixStart" : moment(event.startAt).format('x'),
                                    "unixEnd" : moment(event.endAt).format('x'),
                                    "template":event.template,
                                    "_event":event
                                });
                            }
                            vm.events = events;
                           pushIntoCalendarEvents(events);

                },
                eventDrop:function(event, delta,revertFunc) {
                    var e={};
                   for(var j=0;j<vm.events.length;j++){


                                if(event.id === vm.events[j].id ){

                                     vm.events.splice(j, 1);
                                    break;
                                }
                            }
                  var start=moment(event.start.format("YYYY-MM-DD HH:mm:ss"));

                  if(event.end !==null)
                  var end=moment(event.end.format("YYYY-MM-DD HH:mm:ss"));
                  else
                    var end=null;
                     e.allDay=false;
                     e.start=start;
                     e.id=event.id;
                     e.title=event.title;
                     e.end=end;
                     e.template=event.template;
                     e.className=event.backgroundColor;
                     e.backgroundColor=event.backgroundColor;
                     e.unixStart= start.format('x');
                     e.unixEnd=end.format('x');
                     e._event=event;
                    vm.events.push(e);

                    updateSchedule(start,end,event,vm.calendarEvent);
                },
                selectable        : true,
                selectHelper      : true
            }
        };
        function getRandomClassName(){
            var classes = [
                'md-primary-bg',
                'md-primary-bg md-hue-1',
                'md-primary-bg md-hue-2',
                'md-primary-bg md-hue-3',
                'md-accent-bg',
                'md-accent-bg md-hue-1',
                'md-accent-bg md-hue-2',
                'md-accent-bg md-hue-3',
                'md-warn-bg',
                'md-warn-bg md-hue-1',
                'md-warn-bg md-hue-2',
                'md-warn-bg md-hue-3'
            ];
            return classes[Math.floor( Math.random() * classes.length)];
        }
        function setCalendarConfigLanguage(lang){
            vm.calendarUiConfig.calendar.lang=lang;
        }

        function closeDialog()
        {
            $mdDialog.hide();
        }

           function timeSlotIsOccupied(start,end,id){
            if(moment(Number(end)).format("YYYY-MM-DD") !== vm.today.format("YYYY-MM-DD"))return true;
            for (var i = vm.eventsUnixDates.length - 1; i >= 0; i--) {
                if( id !== vm.eventsUnixDates[i].id &&( (start >= vm.eventsUnixDates[i].start && start <= vm.eventsUnixDates[i].end) || end >= vm.eventsUnixDates[i].start && end <= vm.eventsUnixDates[i].end ) )return true;
            }
            return false;
        }

        function ColorLuminance(hex, lum) {

            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '');
            if (hex.length < 6) {
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            lum = lum || 0;

            // convert to decimal and change luminosity
            var rgb = "#", c, i;
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i*2,2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00"+c).substr(c.length);
            }

            return rgb;
        }
        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
         function getRandomColor() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
                     for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
                      return ColorLuminance(color.toString(),-0.7);
        }

 /*       function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
*/
          vm.next = next;
        vm.prev = prev;
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }


           function deleteTemplate(template) {

                $rootScope.loadingProgress = true;
                msApi.request('programDisplay.delete@delete', {id:template.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                             webTvGlobal.$toast().showSimple(template.title + $translate.instant('DISPLAYPROGRAMSLIST.dialog_alert_delete_description'));

                             closeDialog();
                            $state.reload();}
                        else {
                            var alert = $mdDialog.alert({
                                    title: $translate.instant('DISPLAYSCHEDULECALENDAR.dialog_alert_delete_error_title'),
                                    textContent: $translate.instant('DISPLAYSCHEDULECALENDAR.dialog_alert_delete_error_description'),
                                    ok: $translate.instant('DISPLAYSCHEDULECALENDAR.dialog_alert_delete_close')
                                });

                            $mdDialog
                                .show(alert)
                                .finally(function () {
                                    alert = undefined;
                                });

                        }
                    }, function (response) {
                        webTvGlobal.alertDialog(response.statusText);

                    }
                );




        }


         function updateSchedule(start,end,ev,CalendarEvent) {


             var events = angular.copy(vm.events);
             vm.schedule={};


            vm.schedule.schedulePrograms = [];
            vm.schedule.title=CalendarEvent.title;
            vm.schedule.enable=CalendarEvent.enable;
            vm.schedule.description=CalendarEvent.description;


            events.sort(orderEvents);
             events.forEach(function (event, index) {


                if (index === 0) {
                    vm.schedule.startAt = (new Date(event.start));
                }


                vm.schedule.schedulePrograms.push({
                    templateOrder: index,
                    startAt: new Date(event.start),
                    endAt: new Date(event.end),
                    template: event.template.id
                });
            });

            msApi.request('programDisplay.edit@save',
                    {id: CalendarEvent.id, "data": angular.copy(vm.schedule)},
                    function (res) {
                        if (res.code === 200) {
                            webTvGlobal.$flashMessages().set(res.message);

                        } else if (angular.isDefined(res.errors)) {
                            vm.errors = res.errors;
                            webTvGlobal.alertDialog("Errors");
                        } else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        }
                        }, function (response) {
                       if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                         $translate('VALIDATIONS.' + response.data.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        } else {

                         webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                }
            }
            );

        }

         function orderEvents(a, b) {
            if (a.unixStart < b.unixStart)
                return -1;
            if (a.unixStart > b.unixStart)
                return 1;
            return 0;
        }

        function editSchedule(){
            closeDialog();
            $state.go("app.display_schedule_edit_new", { "id": vm.calendarEvent.id});

        }

        if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"]))&&($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "date")) {
        vm.paramschedule="date";
        }
        else if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"]))&&($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "actif")) {
            vm.paramschedule="actif";
        }
        else {
            vm.paramschedule="none";
        }
        // var buttonActionEditHtml = "";
        // var buttonActionDeleteHtml = "";
        // if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"]))&&($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "date")) {
        //     buttonActionEditHtml =
        //         '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
        //         '<md-button class="edit-button md-icon-button" ng-click="vm.editSchedule()" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" ng-hide = "vm.testDate()">' +
        //         '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
        //         '</md-button>' +
        //         '</a>';
        //     buttonActionDeleteHtml =
        //         '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
        //         '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteTemplate(vm.calendarEvent)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete" ng-hide = "vm.testDate()">' +
        //         '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
        //         '</md-button>' +
        //         '</a>';
        // }
        // else if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"]))&&($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "actif")) {
        //     if (vm.calendarEvent.enable==true) {
        //         buttonActionEditHtml =
        //             "<a tooltips tooltip-template=" + "{{'MESSAGES.action_edit'|translate}}" + " tooltip-side='bottom' tooltip-speed='fast'>" +
        //             "<md-button class='edit-button md-icon-button' ng-click='vm.editSchedule()' aria-label='action_edit' translate translate-attr-aria-label='MESSAGES.action_edit'>" +
        //             "<md-icon  md-font-icon='icon-pencil' class='s18'></md-icon>" +
        //             "</md-button>" +
        //             "</a>";
        //         buttonActionDeleteHtml =
        //             "<a tooltips tooltip-template=" + "{{'MESSAGES.action_delete'|translate}}" + " tooltip-side='bottom' tooltip-speed='fast'>" +
        //             "<md-button class='m16 delete-button md-icon-button' ng-click='vm.deleteTemplate(vm.calendarEvent)' aria-label='action_delete' translate translate-attr-aria-label='MESSAGES.action_delete'>" +
        //             "<md-icon  md-font-icon='icon-delete' class='s18'></md-icon>" +
        //             "</md-button>" +
        //             "</a>";
        //     }
        // }
        // else {
        //     buttonActionEditHtml =
        //         '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
        //         '<md-button class="edit-button md-icon-button" ng-click="vm.editSchedule()" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
        //         '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
        //         '</md-button>' +
        //         '</a>';
        //     buttonActionDeleteHtml =
        //         '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
        //         '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteTemplate(vm.calendarEvent)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete">' +
        //         '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
        //         '</md-button>' +
        //         '</a>';
        // }
        // vm.btnEdit= buttonActionEditHtml + buttonActionDeleteHtml;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.comments.edit', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_comments_edit', {
                url: "/interactivity/comments/comments_lives/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/comments/comments_lives/edit/edit.template.html',
                        controller: 'CommentsLiveEditController as vm'
                    }
                },
                resolve: {
                    CommentsData: function (msApi, $stateParams) {
                        return msApi.resolve('comments.live.getComments@get', {id: $stateParams.id});
                    }
                },
                "bodyClass": "forms"
            });


        // API

        msApiProvider.register('comments.live.getComments', [Routing.generate('api_lives_get_detail_comments', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('comments.live.editComments', [Routing.generate('api_lives_post_edit_comments', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.lives.comments.edit')
    .controller('CommentsLiveEditController', CommentsLiveEditController);

  /** @ngInject */
  function CommentsLiveEditController(webTvGlobal,$cookies, msUtils, CommentsData, HelpGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    $rootScope.itemName = "";

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.media_comments_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.media_comments_edit_pagetitle";

      $rootScope.welcome = "welcome_comment_add";
      $rootScope.text = [{
        texte: "parameters_comment_add_help"
      }, {
        texte: "send_button_comment_add_help"
      }, {
        texte: "cancel_button_comment_add_help"
      }];
    }

    var comments = CommentsData;
    vm.emplivesCommentsForm = {};
    vm.submitAddCommentsForm = submitAddCommentsForm;
    vm.returnToList = returnToList;
    fillData();

    /**
     * Check if comments exists
     * @return if exists get Comments Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(comments.code) && comments.code !== 200) $state.go('app.error_404');
      else {
        comments = comments.CommentsLive;
        vm.emplivesCommentsForm = {
          email: comments.email,
          comment: comments.comment,
          img: comments.img || ""
        };
        $rootScope.itemName = comments.id || '';
      }
    }

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_lives_post_comments_thumb'),
      singleFile: true,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    var imageName;

    /**
     * return to comments list page
     * @return redirect to comments list page
     */
    function returnToList() {
      $state.go('app.comments_list.live');
      $rootScope.selectedIndex = 0;
    }

    /**
     * Send add Comments Form
     */
    function submitAddCommentsForm() {
      $rootScope.loadingProgress = true;
      msApi.request('comments.live.editComments@save',
        {id: comments.id, "emplivesCommentsForm": angular.copy(vm.emplivesCommentsForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            comments = vm.emplivesCommentsForm;
            webTvGlobal.$flashMessages().set('CommentsEdit', comments);
            $state.go('app.comments_list.live');
            $rootScope.selectedIndex = 0;
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );


    }


    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#emplivesCommentsForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.path) {
        vm.emplivesCommentsForm.img = comments.img = res.path;
        vm.is_image_not_pristine = true;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#emplivesCommentsForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.emplivesCommentsForm.img = "";
        });
      }
    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider, $urlRouterProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmbox_intervention_list', {
                url: "/configuration/rmbox/interventions/list/:id",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/interventions/list/list.template.html',
                        controller: 'configurationRmboxInterventionListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_rmbox_list_dtable_action"
            });


        // Api


        $urlRouterProvider.otherwise('/configuration/rmbox/list');
        var deletermboxRoute = Routing.generate('api_configuration_delete_intervention_rmbox') + "/:id";
        msApiProvider.register('configuration_rmbox_intervention.mdelete', [deletermboxRoute, {id: '@id'}]);
        msApiProvider.register('configuration_rmbox_intervention.dtable', [Routing.generate('api_dtable_list_dtable_intervention_rmboxs_list')]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.list')
        .controller('configurationRmboxInterventionListController', configurationRmboxInterventionListController);

    /** @ngInject */
    function configurationRmboxInterventionListController(order_video, $cookies, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $injector, $scope, dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            $compile = $injector.get('$compile'),
            msUtils = $injector.get('msUtils');
        initHelp();
        var parameters = webTvGlobal.$constant().webTvParameterBag();

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_list_pagetitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmbox_interventions_pagetitle";
            $rootScope.pageRoute = "app.configuration_rmbox_list";

            $rootScope.welcome = "welcome_rmbox";
            // $rootScope.text = [{
            //     texte: "add_button_rmbox_help"
            // }, {
            //     texte: "arrow_button_rmbox_help"
            // }, {
            //     texte: "search_area_rmbox_help"
            // }, {
            //     texte: "tri_column_rmbox_help"
            // },
            //     {
            //         texte: "edit_button_rmbox_help"
            //     }, {
            //         texte: "detail_button_rmbox_help"
            //     },
            //     {
            //         texte: "delete_button_rmbox_help"
            //     },
            //     {texte: "pdf_button_rmbox_help"}];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.rmboxs = [];
        vm.selectedRmboxs = [];
        var selectedRmboxs = [];
        vm.rmboxsDataTable = {};
        vm.rmboxsPrograms = {};
        vm.dtInstance = {};
        var state = 0;
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');

        // $rootScope.DtOptions = vm.dtOptions;

        function searchRmboxInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_rmbox_intervention.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.rmboxs = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.recordsTotal = 0;
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }

                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedRmboxs = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.searchWord,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir,
                idRmbox: $state.params.id

            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchRmboxInAPI(filtre);
        }

        function searchRmboxs() {
            filtre["search[value]"] = vm.searchWord;
            filtre.searchWord = vm.searchWord;
            filtre.idRmbox = $state.params.id;
            searchRmboxInAPI(filtre);
        }

        function deleteSelectedRmboxsConfirm(ev) {
            if (vm.selectedRmboxs.length !== 0) {
                $translate([
                    "MESSAGES.dialog_confirm_delete",
                    "MESSAGES.dialog_cancel",
                    "MESSAGES.dialog_list_will_be_deleted",
                    "RMBOXLIST.delete_list_RmBoxs_msg",
                    "RMBOXLIST.delete_RmBoxs_aria_label"
                ])
                    .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['RMBOXLIST.delete_list_RmBoxs_msg'])
                            .htmlContent(translatedValues['MESSAGES.dialog_list_will_be_deleted'])
                            .ariaLabel(translatedValues['RMBOXLIST.delete_RmBoxs_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteSelectedRmbox(ev);


                        });
                    });

            }

        }

        /* delete selected groups*/
        function deleteSelectedRmbox(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('configuration_rmbox.deleteRmboxs@delete', {
                    list: (function (list) {
                        vm.selectedRmboxs.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("RMBOXLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("RMBOXLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('RMBOXLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedRmboxs = [];
                        rerender();

                    }
                    else if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('RMBOXLIST.dialog_alert_delete_error_title'),
                            $translate.instant('RMBOXLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );

                    }
                    selectedRmboxs = [];
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedRmboxs = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn('remarque').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('receptionDate').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('sendDate').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('newMac').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('firstStartedDate').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";

            }),

            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxsDataTable[data.id] = data;
                    //icon-open-in-new
                    // var buttonActionDetailHtml =
                    //     '<a tooltips tooltip-template=' + "{{'RMBOXLIST.detail_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                    //     '<md-button has-permission="configuration_rmbox_get_detail" class="show-button md-icon-button" ng-click="vm.showRmboxDetail(vm.rmboxsDataTable[' + data.id + '],$event)" aria-label="detail_rmbox"translate translate-attr-aria-label="RMBOXLIST.detail_rmbox">' +
                    //     '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                    //     '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.update_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" has-permission="configuration_rmbox_edit_intervention_no_api" ui-sref="app.configuration_rmbox_intervention_edit({id: ' + data.id + '})" aria-label="update_rmbox" translate translate-attr-aria-label="RMBOXLIST.update_rmbox">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.delete_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  has-permission="configuration_rmbox_delete_intervention_no_api" ng-click="vm.deleteRmboxConfirm(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="delete_rmbox" translate translate-attr-aria-label="RMBOXLIST.delete_rmbox">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '</md-button></a>';

                    return buttonActionEditHtml + buttonActionDeleteHtml;


                })

        ];
        vm.deleteSelectedRmboxsConfirm = deleteSelectedRmboxsConfirm;
        vm.searchRmboxs = searchRmboxs;
        vm.deleteRmboxConfirm = deleteRmboxConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showRmboxDetail = showRmboxDetail;
        vm.addNewRmbox = addNewRmbox;
        $rootScope.rerender = rerender;
        vm.showScheduleByRmbox = showScheduleByRmbox;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationRmboxAdd', $translate.instant('RMBOXLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationRmboxEdit', $translate.instant('RMBOXLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        function showScheduleByRmbox(rmbox, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            var urlFoDisplay = angular.isDefined(parameters.url_fo_display) ? parameters.url_fo_display : "";
            webTvGlobal.openNewWindow(urlFoDisplay + "show-schedule-by-rmbox/" + rmbox.id);
        }


        /**
         * Toggle selected status of the user
         *
         * @param rmbox
         */
        function toggle(rmbox) {
            rmbox.checked = !rmbox.checked;
            var idx = selectedRmboxs.indexOf(rmbox);
            if (idx > -1) {
                selectedRmboxs.splice(idx, 1);
            }
            else {
                selectedRmboxs.push(rmbox);
            }
            vm.selectedRmboxs = angular.copy(selectedRmboxs);
        }

        function toggleAll() {
            getElement();
            if (selectedRmboxs.length === vm.rmboxs.length) {
                vm.selectedRmboxs = [];
            }
            else if ((selectedRmboxs.length === 0) || (selectedRmboxs.length > 0)) {
                vm.selectedRmboxs = vm.rmboxs.slice(0);
            }
            selectedRmboxs = angular.copy(vm.selectedRmboxs);
            var list_rmbox = angular.copy(vm.rmboxsDataTable);
            angular.forEach(list_rmbox, function (value, key) {
                if (value !== undefined)
                    vm.rmboxsDataTable[key].checked = selectedRmboxs.length > 0;
            });
        }


        /**
         * Show rmbox Details
         * @param rmbox
         */
        function showRmboxDetail(rmbox, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('configuration_rmbox.getRmbox@get', {id: rmbox.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationRmboxData: response},
                            templateUrl: 'app/main/boitier/rmbox/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationRmboxDetailController',
                            controllerAs: 'vm'
                        });
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchRmboxInAPI(filtre), true);
        }


        /**
         * redirection to add new rmbox page
         * @param event
         */
        function addNewRmbox() {
            clearFlashMessage();
            $state.go('app.configuration_rmbox_intervention_add', {idRmbox: $state.params.id});
        }

        /**
         * Delete rmbox Confirm Dialog
         */
        function deleteRmboxConfirm(rmbox, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "INTERVENTIONS.dialog_will_be_deleted",
                "RMBOXLIST.delete_intervention_msg",
                "RMBOXLIST.delete_intervention_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['RMBOXLIST.delete_intervention_msg'])
                        .htmlContent('<b> Intervention </b>' + translatedValues['INTERVENTIONS.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['RMBOXLIST.delete_intervention_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteRmbox(rmbox);
                        vm.selectedRmboxs = [];

                    }, function () {

                    });

                });


        }


        /**
         * Delete rmbox
         */
        function deleteRmbox(Rmbox) {
            clearFlashMessage();
            if (vm.rmboxs.indexOf(Rmbox) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_rmbox_intervention.mdelete@delete', {id: Rmbox.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "RMBOXLIST.dialog_alert_delete_title",
                                "INTERVENTIONS.dialog_alert_delete_description",
                                "RMBOXLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple("Intervention" + translatedValues['INTERVENTIONS.dialog_alert_delete_description']);
                                    vm.rmboxs.splice(vm.rmboxs.indexOf(Rmbox), 1);
                                    rerender();
                                });
                        }
                        else {
                            $translate([
                                "RMBOXLIST.dialog_alert_delete_error_title",
                                "RMBOXLIST.dialog_alert_delete_error_description",
                                "RMBOXLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['RMBOXLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['RMBOXLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['RMBOXLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                        vm.selectedRmboxs = [];
                        vm.modelCheckAll = false;

                    }
                );

            }


        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmbox_intervention_edit', {
                url: "/boitier/rmbox/interventions/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/interventions/add_edit_view/add_edit.template.html',
                        controller: 'configurationRmboxInterventionEditController as vm'
                    }
                },
                resolve: {
                    configurationRmboxInterventionData: function (msApi, $stateParams) {
                        return msApi.resolve('configuration_intervention.getDetail@get', {id: $stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "configuration_rmbox_post_edit_action"
            });


        // API

        msApiProvider.register('configuration_rmbox_intervention.editRmbox', [Routing.generate('api_configuration_post_edit_intervention_rmbox', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_intervention.getDetail', [Routing.generate('api_configuration_get_detail_intervention_rmbox', {id: ':id'}).replace(/%3A/, ":")]);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.edit')
        .controller('configurationRmboxInterventionEditController', configurationRmboxInterventionEditController);

    /** @ngInject */
    function configurationRmboxInterventionEditController($injector, $rootScope, webTvGlobal, configurationRmboxInterventionData) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');
        var vm = this;
        vm.isNew = false;

        var intervention = configurationRmboxInterventionData;

        vm.empConfigurationRmboxInterventionForm = {};
        vm.submitAddRmboxInterventionForm = submitAddRmboxInterventionForm;
        fillData();
        initHelp();


        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_interventions_pagetitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_intervention_edit_menuTitle";
            $rootScope.pageRoute = "app.configuration_rmbox_intervention_list";
            $rootScope.welcome = "welcome_rmbox_edit";
            $rootScope.text = [{
                texte: "parameters_rmbox_add_help"
            }, {
                texte: "send_button_rmbox_add_help"
            }, {
                texte: "cancel_button_rmbox_add_help"
            }];
        }


        /**
         * Check if RmBox exists
         * @return if exists get RmBox Data else redirect to 404 page
         */
        function fillData() {
            if (angular.isDefined(intervention.code) && intervention.code !== 200) $state.go('app.error_404');
            else {
                vm.empConfigurationRmboxInterventionForm = {
                    remarque: intervention.remarque,
                    receptionDate: intervention.receptionDate === null ? null : new Date(moment(intervention.receptionDate)),
                    sendDate: intervention.sendDate === null ? null : new Date(moment(intervention.sendDate)),
                    oldMac: intervention.oldMac,
                    newMac: intervention.newMac,
                    firstStartedDate: intervention.firstStartedDate === null ? null : new Date(moment(intervention.firstStartedDate)),
                    rmbox: intervention.rmbox.id
                };


            }
        }

        /**
         * Send add RmBox Form
         */
        function submitAddRmboxInterventionForm() {
            if (vm.empConfigurationRmboxInterventionForm.sendDate !== null) vm.empConfigurationRmboxInterventionForm.sendDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.sendDate.toString()));
            if (vm.empConfigurationRmboxInterventionForm.receptionDate !== null) vm.empConfigurationRmboxInterventionForm.receptionDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.receptionDate.toString()));
            if (vm.empConfigurationRmboxInterventionForm.firstStartedDate !== null) vm.empConfigurationRmboxInterventionForm.firstStartedDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.firstStartedDate.toString()));

            $rootScope.loadingProgress = true;
            msApi.request('configuration_rmbox_intervention.editRmbox@save',
                {
                    id: intervention.id,
                    "empConfigurationRmboxInterventionForm": angular.copy(vm.empConfigurationRmboxInterventionForm)
                },
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        intervention = vm.empConfigurationRmboxInterventionForm;
                        webTvGlobal.$toast().showSimple($translate.instant('INTERVENTIONS.edited'));
                        $state.go('app.configuration_rmbox_intervention_list', {id: vm.empConfigurationRmboxInterventionForm.rmbox});
                    }
                    else if (res.code === 400 && angular.isDefined(res.message)) {
                        $translate('VALIDATIONS.' + res.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                },
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(res.message)) {
                        $translate('VALIDATIONS.' + res.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                }
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmbox_intervention_add', {
                url: "/boitier/rmbox/interventions/:idRmbox/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/interventions/add_edit_view/add_edit.template.html',
                        controller: 'configurationRmboxInterventionAddController as vm'
                    }
                },
                resolve: {
                    configurationRmboxInterventionData: function (msApi,$stateParams) {
                        return msApi.resolve('configuration_rmbox_intervention.getDetail@get', {id: $stateParams.idRmbox});
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "configuration_rmbox_post_add_action"
            });


        //API

        msApiProvider.register('configuration_rmbox_intervention.addIntervention', [Routing.generate('api_configuration_post_add_intervention_rmbox')]);
        msApiProvider.register('configuration_rmbox_intervention.getDetail', [Routing.generate('api_configuration_get_intervention_rmbox', {id: ':id'}).replace(/%3A/, ":")]);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.interventions.add')
        .controller('configurationRmboxInterventionAddController', configurationRmboxInterventionAddController);

    /** @ngInject */
    function configurationRmboxInterventionAddController(configurationRmboxInterventionData, webTvGlobal, $injector) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');
        var vm = this;
        vm.isNew = true;

        var intervention = configurationRmboxInterventionData;
        vm.empConfigurationRmboxInterventionForm = {
            remarque: intervention.remarque,
            receptionDate: intervention.receptionDate,
            sendDate: intervention.sendDate,
            oldMac: intervention.oldMac,
            newMac: intervention.newMac,
            firstStartedDate: intervention.firstStartedDate,
            rmbox: $state.params.idRmbox
        };

        vm.submitAddRmboxInterventionForm = submitAddRmboxInterventionForm;

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_interventions_pagetitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_intervention_add_menuTitle";
            $rootScope.pageRoute = "app.configuration_rmbox_intervention_list";
            $rootScope.welcome = "welcome_rmbox_add";
            // $rootScope.text = [{
            //     texte: "parameters_rmbox_add_help"
            // }, {
            //     texte: "send_button_rmbox_add_help"
            // }, {
            //     texte: "cancel_button_rmbox_add_help"
            // }];
        }

        /**
         * Send add RmBox Form
         */
        function submitAddRmboxInterventionForm() {
            if (vm.empConfigurationRmboxInterventionForm.sendDate !== null) vm.empConfigurationRmboxInterventionForm.sendDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.sendDate.toString()));
            if (vm.empConfigurationRmboxInterventionForm.receptionDate !== null) vm.empConfigurationRmboxInterventionForm.receptionDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.receptionDate.toString()));
            if (vm.empConfigurationRmboxInterventionForm.firstStartedDate !== null) vm.empConfigurationRmboxInterventionForm.firstStartedDate = new Date(moment.utc(vm.empConfigurationRmboxInterventionForm.firstStartedDate.toString()));

            $rootScope.loadingProgress = true;
            vm.empConfigurationRmboxInterventionForm.rmbox = $state.params.idRmbox;
            msApi.request('configuration_rmbox_intervention.addIntervention@save',
                {"empConfigurationRmboxInterventionForm": angular.copy(vm.empConfigurationRmboxInterventionForm)},
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        intervention = vm.empConfigurationRmboxInterventionForm;
                        webTvGlobal.$toast().showSimple($translate.instant('INTERVENTIONS.added'));
                        $state.go('app.configuration_rmbox_intervention_list', {id: $state.params.idRmbox});
                    }
                    else if (res.code === 400 && angular.isDefined(res.message)) {
                        $translate('VALIDATIONS.' + res.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                },
                function () {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(res.message)) {
                        $translate('VALIDATIONS.' + res.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                }
            );
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.stats.vod_live.tab',
            [
                'mdPickers'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        var parentStates = [
            {
                state: 'stats_vods',
                url: '/stat/vods',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "vod"
            },
            {
                state: 'stats_lives',
                url: '/stat/lives',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "live"
            },
            {
                state: 'stats_vod_by_id',
                url: '/stat/vod_by_id/:id',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "vod_by_id"
            },
            {
                state: 'stats_event_by_id',
                url: '/stat/event_by_id/:id',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "live_by_id"
            },
            {
                state: 'stats_live_by_id',
                url: '/stat/live_by_id/:id',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "live_by_id"
            },
            {
                state: 'stats_zone_by_id',
                url: '/stat/zone_by_id/:id',
                template: 'app/main/stats/vod_live/stat.vod.html',
                permission: "live_by_id"
            }

        ];

        var tabStates = [
            {
                state: 'audience',
                url: '/audience',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.audience.html'
            },
            {
                state: 'technologie',
                url: '/technologie',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.technologie.html'
            },
            {
                state: 'engagement',
                url: '/engagement',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.engagement.html'
            },
            {
                state: 'geo',
                url: '/geo',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.geo.html'
            },
            {
                state: 'mobile',
                url: '/mobile',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.mobile.html'
            },
            {
                state: 'temp_reel',
                url: '/temps_reel',
                template: 'app/main/stats/vod_live/tabStats/stat.vod.temp_reel.html'
            }
        ];
        parentStates.forEach(function (valueParent) {
            tabStates.forEach(function (valueTabs) {
                $stateProvider.state('app.' + valueParent.state + '.' + valueTabs.state, {
                    url: valueTabs.url,
                    views: {
                        "": {
                            templateUrl: valueTabs.template,
                            controller: 'VodLiveTabsStatsController as vm'
                        }
                    },
                    resolve: {
                        query: function (query_vod_audience) {
                            return query_vod_audience;
                        },
                        permission: function () {
                            return valueParent.permission;
                        }
                    },
                    "actionPermission" : "stats_"+valueParent.permission+"_"+valueTabs.state+"_action"
                });

            })
        });

    }

})();

(function () {
  'use strict';

  angular
    .module('app.stats.vod_live.tab')
    .controller('VodLiveTabsStatsController', VodLiveTabsStatsController);

  /** @ngInject */
  function VodLiveTabsStatsController($rootScope, query, statsVodLiveService, webTvGlobal, $state, $stateParams,permission) {
    var vm = this;

    vm.query = statsVodLiveService.getQuery();
    vm.permission = permission;
    var query_service = getQuery();
    var existType = false;
    statsVodLiveService.verifQuery(query_service);
    // Data
    $rootScope.types = getListType($rootScope.types_all);
   // $rootScope.types_all =  $rootScope.types;
    $rootScope.default_type_stats = 'all';
    if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && existType){
      var q = {};
      q.type = $rootScope.types_query;
      statsVodLiveService.setQuery(q, $rootScope.endtDateFromLive,false,permission);
    }
    vm.infoVideo= $rootScope.infoVideo;
    function getListType(types_all) {
      var state_neme = $state.current.name;
      var listType = {};
      if (state_neme.indexOf("mobile") > 0) {
        angular.forEach(types_all, function (value, key) {
          if (value.indexOf("mobile") > 0) {
            listType[key] = value;
          }
        });
      }
      else {
        listType = types_all;
      }
     
      listType = getConvertToSelectWithNone(listType);
      angular.forEach(listType, function (value, key) {
        if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && value.val===$rootScope.types_query){
          existType = true;
        }
      });
      return listType;
    }

    function getConvertToSelectWithNone(choices) {
      var result = [];
      if(angular.isDefined(choices))
      {
        if (angular.isUndefined(choices.none)) {
          var types = angular.isDefined(choices) ? Object.values(choices).join(',') : "0";
          //vm.query.type = types;
          $rootScope.types_query = types;
          result.push({val: types, option: 'none', options: 'none'});
        }
        var data = webTvGlobal.convertToSelectChoicesFormat(choices);
        for (var i = 0; i < data.length; i++) {
          result.push(data[i]);
        }}
      return result;
    }

    function getQuery() {

      var query_service = angular.copy(query);

      if (angular.isDefined($stateParams.id)) {
        query_service.vod_id = $stateParams.id;
      }
      else {
        delete  query_service.vod_id;
      }
      return query_service;
    }

  }
})();

(function () {
  'use strict';
  /** @ngInject */

  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m-1, 1);
  var lastDay = new Date(y, m + 1, 0);

  var card_right = {
    audience: {title: "Audience", option: "vm.audience.audience.options", data: "vm.audience.audience.data"},
    duree: {title: "Duree", option: "vm.audience.duree.options", data: "vm.audience.duree.data"},
    pourcentage: {
      title: "Pourcentage",
      option: "vm.audience.pourcentage.options",
      data: "vm.audience.pourcentage.data"
    }
  };
  var query_vod_audience = {
    is_vod: true,
    is_live: false,
    is_range: true,
    dateIn: firstDay,
    dateOut: lastDay,
    range: "1d"

  };

  var query_vod_time_reel = {
    is_vod: true,
    is_live: false
  };



  angular
    .module('app.stats.vod_live.tab')
    .constant('card_right', card_right)
    .constant('query_vod_audience', query_vod_audience)
    .constant('query_vod_time_reel', query_vod_time_reel)



})();

(function () {
    'use strict';

    angular
        .module('app.stats.mooc.persons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.stats_mooc_persons', {
                url: "/mooc/list-persons/:id",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/stats/mooc/list-persons/list-persons.template.html',
                        controller: 'moocListPersonsController as vm'
                    }
                },
                resolve: {
                    entities: function (msApi) {
                        return msApi.resolve('getEntities.list@get');
                    },
                    functions: function (msApi) {
                        return msApi.resolve('getFunctions.list@get');
                    }
                },
                "bodyClass": "forms"
            });
        msApiProvider.register('persons_by_quiz.list', [Routing.generate('api_mooc_get_list_subscribers_answered_quiz')]);
        msApiProvider.register('getFunctions.list', [Routing.generate('api_subscription_user_get_functions')]);
        msApiProvider.register('getEntities.list', [Routing.generate('api_subscription_user_get_entities')]);


        // API


    }
})();
(function () {
    'use strict';

    angular
        .module('app.stats.mooc.persons')
        .controller('moocListPersonsController', moocListPersonsController);

    /** @ngInject */
    function moocListPersonsController($injector, $rootScope, webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $scope, $cookies, dtable_language, $state, entities, functions) {
        var
            $compile = $injector.get('$compile'),
            msApi = $injector.get('msApi'),
            $translate = $injector.get('$translate');
        var vm = this;
        initHelp();
        vm.entities = [];
        vm.functions = [];
        if (angular.isDefined(entities.names)) {
            var ent = webTvGlobal.convertToSelectChoicesFormat(entities.names);
            angular.forEach(ent, function (value) {
                if (value.options.length > 0)
                    vm.entities.push(value);
            });
        }
        if (angular.isDefined(functions.names)) {
            var func = webTvGlobal.convertToSelectChoicesFormat(functions.names);
            angular.forEach(func, function (value) {
                if (value.options.length > 0)
                    vm.functions.push(value);
            });
        }

        function initHelp() {
            var $rootScope = $injector.get('$rootScope');
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_mooc";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
        }

        vm.persons = [];
        vm.selectedPersons = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.searchPersons = searchPersons;
        vm.returnPage = returnPage;
        $rootScope.rerender = rerender;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.personsDataTable = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: 2,
                    filterable: true,
                    sortable: true,
                    width: '80px'
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchPersonsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('persons_by_quiz.list@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.persons = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.persons = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedpersons = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                idQuiz: $state.params.id,
                dateIn: vm.currentDateIn,
                dateOut: vm.currentDateOut,
                "search[value]": vm.search_persons,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchPersonsInAPI(filtre);
        }

        function searchPersons() {

            filtre["search[value]"] = vm.search_persons;
            filtre.dateIn = vm.currentDateIn;
            filtre.dateOut = vm.currentDateOut;
            filtre.entity = vm.entity;
            filtre.function = vm.function;
            searchPersonsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn('user').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('created_at ').notSortable().renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('response').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('is_correct').notSortable()
                .renderWith(function (data) {

                    if (data)
                        var response = '<span translate="MOOCSTATS.correct">';
                    else
                        var response = '<span translate="MOOCSTATS.incorrect">';

                    return response;

                })

        ];

        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchPersonsInAPI(filtre), true);
        }

        function returnPage() {
            if ($rootScope.returnToQuiz)
                $state.go('app.stats_mooc_theme', {id: $rootScope.returnToQuiz});
            else
                $state.go('app.stats_mooc.course');

        }

    }
})();
(function () {
    'use strict';

    angular
        .module('app.stats.mooc.tab',
            [
                'mdPickers'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        var tabStates = [
            {
                state: 'course',
                url: '/course',
                template: 'app/main/stats/mooc/tabStats/stat.mooc.course.html'
            },
            {
                state: 'performance',
                url: '/performance',
                template: 'app/main/stats/mooc/tabStats/stat.mooc.performance.html'
            },
            {
                state: 'video',
                url: '/video',
                template: 'app/main/stats/mooc/tabStats/stat.mooc.video.html'
            },
            {
                state: 'voyage',
                url: '/voyage',
                template: 'app/main/stats/mooc/tabStats/stat.mooc.voyage.html'
            }
        ];
            tabStates.forEach(function (valueTabs) {
                $stateProvider.state('app.stats_mooc.' + valueTabs.state, {
                    url: valueTabs.url,
                    views: {
                        "": {
                            templateUrl: valueTabs.template,
                            controller: 'MoocTabsStatsController as vm'
                        }
                    },
                    resolve: {
                        query: function (query_mooc_course) {
                            return query_mooc_course;
                        }
                    }
                });
            });


    }

})();
(function () {
    'use strict';

    angular
        .module('app.stats.mooc.tab')
        .controller('MoocTabsStatsController', MoocTabsStatsController);

    /** @ngInject */
    function MoocTabsStatsController($scope, $injector, DTOptionsBuilder, $cookies, DTColumnBuilder, $compile, webTvGlobal, order_theme, dtable_language, statsMoocService, query, widgetDefaultMooc) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.query = statsMoocService.getQuery();
        var query_service = getQuery();
        statsMoocService.verifQuery(query_service);
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            msApi = $injector.get('msApi');
        var filtre = {};
        var columnsApi = order_theme;

        vm.getElem = getElem;
        //Data Table options
        vm.themes = [];
        vm.selectedThemes = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.themesDataTable = {};
        vm.themesServerDataTable = {};
        vm.search_themes = "";
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    width: '20%',
                    targets: [0, 1, 2]
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 50, 100])
            .withOption('pagingType', 'simple')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('autoWidth', false)
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function getElem() {
            var element = document.querySelectorAll('md-checkbox.ng-scope.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObj = {"margin-left": leftDelete}
        }

        function searchThemesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('parameters_theme_mooc.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.themes = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.themes = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }


                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedThemes = [];
            checkedSelected = false;

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_themes,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            filtre.dateIn = vm.query.dateIn;
            filtre.dateOut = vm.query.dateOut;
            vm.fnCallback = fnCallback;

            searchThemesInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                return angular.isDefined(data.startDate) && data.startDate ? moment(data.startDate).format("DD-MM-YYYY") : "";
            }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                return angular.isDefined(data.endDate) && data.endDate ? moment(data.endDate).format("DD-MM-YYYY") : "";
            }),
            DTColumnBuilder.newColumn('total_registrations').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : 0;
            }),
            DTColumnBuilder.newColumn('ongoing_registrations_theme').notSortable().renderWith(function (data) {
                return angular.isDefined(data) ? data : 0;
            }),
            DTColumnBuilder.newColumn('increase_registrations').notSortable().renderWith(function (data) {
                var increase_registrations = angular.isDefined(data) ? data : 0;
                var serverHtml = "";
                if (increase_registrations < 0) {
                    serverHtml += '<span class="ng-binding">' + increase_registrations + '</span> <md-icon md-font-icon="icon-trending-down" class="s36 ml-16 md-default-theme md-font material-icons icon-trending-down" style="color:red;" aria-hidden="true"></md-icon>';
                } else if (increase_registrations > 0) {
                    serverHtml += '<span class="ng-binding">' + increase_registrations + '</span> <md-icon md-font-icon="icon-trending-up" class="s36 ml-16 md-default-theme md-font material-icons icon-trending-up" style="color:green;" aria-hidden="true"></md-icon>';
                } else {
                    serverHtml += '<span class="ng-binding">' + increase_registrations + '</span>';
                }
                return serverHtml;

            }),

            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.themesDataTable[data.id] = data;
                    var buttonActionStatsHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_video_stats'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button  class="m16 delete-button md-icon-button" ui-sref="app.stats_mooc_theme({id: ' + data.id + '})" aria-label="action_stats"translate translate-attr-aria-label="MESSAGES.action_video_stats">' +
                        '<md-icon  md-font-icon="icon-chart-bar" class="s18"></md-icon>' +
                        ' </md-button>';

                    return buttonActionStatsHtml;

                })
        ];

        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.isChecked = isChecked;
        vm.isIndeterminate = isIndeterminate;
        vm.exist = exist;
        vm.retour = retour;

        $rootScope.rerender = rerender;
        vm.searchThemes = searchThemes;

        /**
         * @param theme
         */
        function toggle(theme, list) {
            getElem();
            var idx = list.indexOf(theme);
            if (idx > -1) {
                list.splice(idx, 1);
            }
            else {
                list.push(theme);
            }
        }

        /**
         * @param theme
         */
        function exist(theme, list) {
            return list.indexOf(theme) > -1;
        }

        function isIndeterminate() {
            return (vm.selectedThemes.length !== 0 && vm.selectedThemes.length !== vm.themes.length);
        }

        retour();

        function retour() {
            $rootScope.pageRetour = "app.stats_mooc.course";
        }

        function isChecked() {
            return (vm.selectedThemes.length === vm.themes.length) && (vm.selectedThemes.length > 0);
        }

        function toggleAll() {
            getElem();

            if (vm.selectedThemes.length === vm.themes.length) {
                vm.selectedThemes = [];
            }
            else if ((vm.selectedThemes.length === 0) || (vm.selectedThemes.length > 0)) {
                vm.selectedThemes = vm.themes.slice(0);

            }
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchThemesInAPI(filtre), true);
        }

        /**
         *  call the api
         */
        function searchThemes() {
            filtre["search[value]"] = vm.search_themes;
            searchThemesInAPI(filtre);
        }

        function getQuery() {

            var query_service = angular.copy(query);
            return query_service;
        }

        var res = "";
        var valueData = widgetDefaultMooc;
        init();

        function init() {

            vm.widget_mooc = {
                ranges: valueData.widget_mooc.ranges,
                currentRange: valueData.widget_mooc.currentRange,
                title: valueData.widget_mooc.title,
                changeRange: function (range) {
                    vm.widget_mooc.currentRange = range;
                    vm.query.range = range;

                }
            };
        }
    }
})();

(function () {
    'use strict';
    /** @ngInject */

    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m-1, 1);
    var lastDay = new Date(y, m + 1, 0);

    var query_mooc_course = {
        is_vod: true,
        is_live: false,
        is_range: true,
        dateIn: firstDay,
        dateOut: lastDay,
        range: "1d"

    };

    var widgetDefaultMooc = {"widget_mooc": {
        "title": "MOOCSTATS.title",
        "ranges": {
            "1d": "MOOCSTATS.day",
            "1w": "MOOCSTATS.week",
            "1M": "MOOCSTATS.month"
        },
        "currentRange" : "1d",
        "date" : {
            "currentDateIn":firstDay,
            "currentDateOut":lastDay
        }

    }};

    angular
        .module('app.stats.mooc.tab')
        .constant('query_mooc_course', query_mooc_course)
        .constant('widgetDefaultMooc', widgetDefaultMooc)

})();
(function () {
    'use strict';

    angular
        .module('app.stats.podcast.tab',
            [
                'mdPickers'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider) {

        var parentStates = [
            {
                state: 'stats_podcast',
                url: '/stat/podcast',
                template: 'app/main/stats/podcast/stat.vod.html',
                permission: "podcast"
            },

            {
                state: 'stats_podcast_by_id',
                url: '/stat/podcast_by_id/:id',
                template: 'app/main/stats/podcast/stat.vod.html',
                permission: "podcast_by_id"
            },

        ];

        var tabStates = [
            {
                state: 'audience',
                url: '/audience',
                template: 'app/main/stats/podcast/tabStats/stat.vod.audience.html'
            },
            {
                state: 'technologie',
                url: '/technologie',
                template: 'app/main/stats/podcast/tabStats/stat.vod.technologie.html'
            },
            {
                state: 'engagement',
                url: '/engagement',
                template: 'app/main/stats/podcast/tabStats/stat.vod.engagement.html'
            },
            {
                state: 'geo',
                url: '/geo',
                template: 'app/main/stats/podcast/tabStats/stat.vod.geo.html'
            },
            {
                state: 'mobile',
                url: '/mobile',
                template: 'app/main/stats/podcast/tabStats/stat.vod.mobile.html'
            },
            {
                state: 'temp_reel',
                url: '/temps_reel',
                template: 'app/main/stats/podcast/tabStats/stat.vod.temp_reel.html'
            }
        ];
        parentStates.forEach(function (valueParent) {
            tabStates.forEach(function (valueTabs) {
                $stateProvider.state('app.' + valueParent.state + '.' + valueTabs.state, {
                    url: valueTabs.url,
                    views: {
                        "": {
                            templateUrl: valueTabs.template,
                            controller: 'PodcastStatsController as vm'
                        }
                    },
                    resolve: {
                        query: function (query_vod_audience) {
                            return query_vod_audience;
                        },
                        permission: function () {
                            return valueParent.permission;
                        }
                    },
                    "actionPermission" : "stats_"+valueParent.permission+"_"+valueTabs.state+"_action"
                });

            })
        });

    }

})();

(function () {
    'use strict';

    angular
        .module('app.stats.podcast.tab')
        .controller('PodcastStatsController', PodcastStatsController);

    /** @ngInject */
    function PodcastStatsController($rootScope, query, statsPodcastService, webTvGlobal, $state, $stateParams,permission) {
        var vm = this;
        vm.query = statsPodcastService.getQuery();
        vm.permission = permission;
        var query_service = getQuery();
        var existType = false;
        statsPodcastService.verifQuery(query_service);
        // Data
        $rootScope.types = getListType($rootScope.types_all);
        if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && existType){
            var q = {};
            q.type = $rootScope.types_query;
            statsPodcastService.setQuery(q);
        }
        function getListType(types_all) {
            var state_neme = $state.current.name;
            var listType = {};
            if (state_neme.indexOf("mobile") > 0) {
                angular.forEach(types_all, function (value, key) {
                    if (value.indexOf("mobile") > 0) {
                        listType[key] = value;
                    }
                });
            }
            else {
                listType = types_all;
            }
            listType = getConvertToSelectWithNone(listType);
            angular.forEach(listType, function (value, key) {
                if(angular.isDefined($rootScope.types_query) && $rootScope.types_query && value.val===$rootScope.types_query){
                    existType = true;
                }
            });
            return listType;
        }

        function getConvertToSelectWithNone(choices) {
            var result = [];
            if(angular.isDefined(choices))
            {
            if (angular.isUndefined(choices.none)) {
                var types = angular.isDefined(choices) ? Object.values(choices).join(',') : "0";
                result.push({val: types, option: "none", options: "none"});
            }
            var data = webTvGlobal.convertToSelectChoicesFormat(choices);
            for (var i = 0; i < data.length; i++) {
                result.push(data[i]);
            }}
            return result;
        }

        function getQuery() {

            var query_service = angular.copy(query);

            if (angular.isDefined($stateParams.id)) {
                query_service.vod_id = $stateParams.id;
            }
            else {
                 delete  query_service.vod_id;
            }
            return query_service;
        }

    }
})();

(function () {
  'use strict';
  /** @ngInject */

  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m-1, 1);
  var lastDay = new Date(y, m + 1, 0);

  var card_right = {
    audience: {title: "Audience", option: "vm.audience.audience.options", data: "vm.audience.audience.data"},
    duree: {title: "Duree", option: "vm.audience.duree.options", data: "vm.audience.duree.data"},
    pourcentage: {
      title: "Pourcentage",
      option: "vm.audience.pourcentage.options",
      data: "vm.audience.pourcentage.data"
    }
  };
  var query_vod_audience = {
    is_vod: false,
    is_live: false,
    is_podcast: true,
    is_range: true,
    dateIn: firstDay,
    dateOut: lastDay,
    range: "1d"

  };

  var query_vod_time_reel = {
    is_vod: true,
    is_live: false
  };



  angular
    .module('app.stats.podcast.tab')
    .constant('card_right', card_right)
    .constant('query_vod_audience', query_vod_audience)
    .constant('query_vod_time_reel', query_vod_time_reel)



})();

(function () {
    'use strict';

    angular
        .module('app.stats.export_vod_live',
            [
                'mdPickers',
                'app.stats.graphe',
                'app.stats.export_vod_live.tab'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        var parentStates = [

            {
                state: 'stats_export_vod_by_id',
                url: '/export/export_vod/:token',
                template: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                getById: "export.get.video.by.id", right: "stats.type.vod", filter: "vod",
                view: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    "content@app.stats_export_vod_by_id": {
                        templateUrl: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                        controller: 'ExportVodLiveStatsController as vm'
                    }

                }
            },
            {
                state: 'stats_export_vod_secure_by_id',
                url: '/export/export_vod_secure/:token',
                template: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                getById: "export.get.video.by.id", right: "stats.type.vod", filter: "vod",
                view: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    "content@app.stats_export_vod_secure_by_id": {
                        templateUrl: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                        controller: 'ExportVodLiveStatsController as vm'
                    }

                }
            },
            {
                state: 'stats_export_event_by_id',
                url: '/export/export_event/:token',
                template: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                getById: "export.get.event.by.id",
                right: "stats.type.live", filter: "live",
                view: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    "content@app.stats_export_event_by_id": {
                        templateUrl: 'app/main/stats/export/vod_live/stat.vod_by_id.html',
                        controller: 'ExportVodLiveStatsController as vm'
                    }
                }
            }
        ];

        parentStates.forEach(function (value) {
            var url=value.url;
            if(value.state==="stats_export_vod_secure_by_id"){
               url=value.url+"?signed"
            }
            $stateProvider
                .state("app." + value.state, {
                    url: url,
                    views: value.view,
                    resolve: {
                        res: function (msApi, $stateParams, $rootScope) {
                            console.log('resolve', $rootScope.show_stats);
                            return msApi.resolve('stats.getInfos@get', {token: $stateParams.token})
                        },
                        tabs_vod: function (tab_key_value_vod_by_id) {
                            return tab_key_value_vod_by_id;
                        }
                        ,
                        typeChoices: function () {
                            return value.right;
                        }
                        ,
                        searchFiltreRight: function (is_show_filtre_vod) {
                            return is_show_filtre_vod;
                        }
                        ,
                        typeStatsFilter: function () {
                            return value.filter;
                        }
                        ,
                        parent_state: function () {
                            return "app." + value.state;
                        }
                        ,
                        getVideoById: function (msApi, res, $http, $cookies, $rootScope) {
                            console.log('resolve getVideoById', $rootScope.show_stats);
                          if($rootScope.show_stats && angular.isDefined(res.id) && !res.isTheme) {
                                if (angular.isUndefined($cookies.get('authToken'))) {
                                    $http.defaults.headers.common.Authorization = res.auth_token;
                                }
                                return msApi.resolve(value.getById + '@get', {id: res.id});
                            }else if($rootScope.show_stats && angular.isDefined(res.id) && res.isTheme) {
                              var idTheme=res.idCanal+"-"+res.id;
                              return {isTheme:res.isTheme, id :idTheme, idCanal:res.idCanal}
                            }else{
                                return null;
                            }
                        }
                        ,
                        parametersCanalNamesData: function (msApi, res, $http, $cookies, $rootScope) {
                            console.log('resolve parametersCanalNamesData', $rootScope.show_stats);
                            if($rootScope.show_stats) {
                                if (angular.isUndefined($cookies.get('authToken'))) {
                                    $http.defaults.headers.common.Authorization = res.auth_token;
                                }
                                return msApi.resolve('export.getNames@get');
                            }
                        }
                    }
                })
        });

        // Api
        msApiProvider.register('parameters_theme.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('parameters_theme.themeChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
        msApiProvider.register('stats.right.vod.types', [Routing.generate('api_right_stats_get_right_types_vod_stats')]);
        msApiProvider.register('stats.right.live.types', [Routing.generate('api_right_stats_get_right_types_live_stats')]);
        msApiProvider.register('export.get.video.by.id', [Routing.generate('api_media_get_video_by_id_stat_export', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('stats.get.event.by.id', [Routing.generate('api_get_event_video_by_id', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('export.get.event.by.id', [Routing.generate('api_get_event_video_by_id_stat_export', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('stats.get.live.by.id', [Routing.generate('api_get_lives_live_detail', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('export.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('stats.right.live.types', [Routing.generate('api_right_stats_get_right_types_live_stats')]);
        msApiProvider.register('userManager.getUserDataStat', [Routing.generate('api_core_rights_get_user_rights_by_module')]);
        msApiProvider.register('stats.getInfos', [Routing.generate('api_stats_acces_get_infos_stat_export')]);
        msApiProvider.register('stats.secureUrl', [apiSecureUrl, {token: ':token'}]);

        //api_stats_acces_get_url_stat_export

//api_media_get_event_video_by_id_stat_export
    }


})();

(function () {
    'use strict';

    angular
        .module('app.stats.export_vod_live')
        .factory('ExportStatsVodLiveService', ExportStatsVodLiveService);

    /** @ngInject */
    function ExportStatsVodLiveService( $state) {

        var query = {};

        function getQuery() {
            return query;
        }

        function setQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.canal)) {
                query.canal = query_param.canal;
            }
            if (!angular.isUndefined(query_param.theme)) {
                query.theme = query_param.theme;
            }
            if (!angular.isUndefined(query_param.type)) {
                query.type = query_param.type;
            }
            if (!angular.isUndefined(query_param.range) ) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.vod_id) ) {
                query.vod_id = query_param.vod_id;
            }
        }

        function verifQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn) && angular.isUndefined(query.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut) && angular.isUndefined(query.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.canal) && angular.isUndefined(query.canal)) {
                query.canal = query_param.canal;
            }
            if (!angular.isUndefined(query_param.theme) && angular.isUndefined(query.theme)) {
                query.theme = query_param.theme;
            }
            if (!angular.isUndefined(query_param.type) && angular.isUndefined(query.type)) {
                query.type = query_param.type;
            }else {
                if ($state.current.name.indexOf("live") > 0) {
                query.type = "live_internet";}
                else
                    query.type = "internet";}


            if (!angular.isUndefined(query_param.range) && angular.isUndefined(query.range)) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.vod_id)) {
                query.vod_id = query_param.vod_id;
            }
            if(angular.isUndefined(query_param.vod_id))
            {
                delete query.vod_id;
            }
        }

        return {
            setQuery: setQuery,
            getQuery: getQuery,
            verifQuery: verifQuery

        };

    }
}());

(function () {
    'use strict';

    angular
        .module('app.stats.export_vod_live')
        .controller('ExportVodLiveStatsController', ExportVodLiveStatsController);

    /** @ngInject */
    function ExportVodLiveStatsController($injector, res, $rootScope, msApi, $scope, getVideoById, tabs_vod, typeChoices, webTvGlobal, dateMoisCourantConstant, parent_state, parametersCanalNamesData, typeStatsFilter, searchFiltreRight) {

        var $stateParams = $injector.get('$stateParams'),
            $state = $injector.get('$state'),
            ExportStatsVodLiveService = $injector.get('ExportStatsVodLiveService');
        var filterShow = searchFiltreRight;

        var parameterBag = webTvGlobal.$constant().webTvParameterBag();

        var vm = this;
        //function
        vm.typeStatsFilter = typeStatsFilter;
        vm.changeQuery = changeQuery;
        vm.changeDate = changeDate;
        vm.isHiddenFilter = isHiddenFilter;
        //scope
        vm.query = ExportStatsVodLiveService.getQuery();
        $scope.someModel = null;
        vm.tabs_title = getUiSrefTabs();
        vm.currentDateIn = angular.isUndefined(vm.query.dateIn) ? dateMoisCourantConstant.date.currentDateIn : vm.query.dateIn;
        vm.currentDateOut = angular.isUndefined(vm.query.dateOut) ? dateMoisCourantConstant.date.currentDateOut : vm.query.dateOut;
        if (!angular.isUndefined(parametersCanalNamesData)) {
            vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);
            vm.theme = "";
            vm.canal = "";

        }
      initInfoVideoById();
        if (angular.isDefined(parameterBag[typeChoices]))
            $rootScope.types_all = parameterBag[typeChoices];
        else if (angular.isDefined(res.stats_config))
            $rootScope.types_all = res.stats_config;
        vm.md_selected_index = getMdSelectedIndex();
        if ($state.current.name === "app.stats_export_event_by_id")
            $state.go('app.stats_export_event_by_id.audience', {id: res.id});
        if ($state.current.name === "app.stats_export_vod_by_id")
            $state.go('app.stats_export_vod_by_id.audience', {id: res.id});

        if ($state.current.name === "app.stats_export_vod_secure_by_id")
            $state.go('app.stats_export_vod_secure_by_id.audience', {id: res.id});


        if(angular.isDefined($rootScope.types_all)) {
            var types_all_values = Object.values($rootScope.types_all);
            if (angular.isDefined(types_all_values[0])) {
                vm.types_query = types_all_values[0];
                $rootScope.types_query = vm.types_query;
                var query = {};
                query.type = vm.types_query;
                ExportStatsVodLiveService.setQuery(query);
            }
        }

        function changeDate() {
            //verification date in et date out
            var in_date = new Date(vm.currentDateIn);
            var out_date = new Date(vm.currentDateOut);
            if (out_date < in_date) {
                vm.currentDateOut = vm.currentDateIn;
            }
            // end verification
            var dateIn = vm.currentDateIn;
            var dateOut = vm.currentDateOut;

            var query = {};
            if (!angular.isUndefined(dateIn)) {
                query.dateIn = dateIn;
            }
            if (!angular.isUndefined(dateOut)) {
                query.dateOut = dateOut;
            }

            ExportStatsVodLiveService.setQuery(query);
        }

        function changeQuery(test, themeModel) {
            var res;
            if (test === 'canal') {
                vm.theme = '';
            }

            if (angular.isDefined(themeModel) && test !== 'canal') {
                res = themeModel.substring(themeModel.indexOf('-') + 1, themeModel.length);
            }
            else {
                res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
            }
            // end verification
            var canal = vm.canal;
            var type = vm.types_query;
            var query = {};

            if (!angular.isUndefined(canal)) {
                query.canal = canal;
            }
            if (!angular.isUndefined(res)) {
                query.theme = res;
            }
            if (!angular.isUndefined(type)) {
                query.type = type;
                $rootScope.types_query = type;
            }
            ExportStatsVodLiveService.setQuery(query);
        }

        function getMdSelectedIndex() {
            var md_selected_index = 0;
            angular.forEach(tabs_vod, function (value) {
                if ($state.current.name.indexOf(value.ui_sref) > 0) {
                    md_selected_index = value.md_selected_index;
                }
            });
            return md_selected_index;
        }

        function getUiSrefTabs() {
            var tabs_ui_sref = angular.copy(tabs_vod);
            angular.forEach(tabs_vod, function (value, key) {
                tabs_ui_sref[key].ui_sref = parent_state + value.ui_sref;
            });
            return tabs_ui_sref;
        }

        function initInfoVideoById() {
            var this_video = getVideoById;
            vm.isTheme=false;
            if(this_video && this_video.id){
                if( angular.isDefined(this_video.isTheme)){
                    vm.isTheme=this_video.isTheme
                }
                if(! vm.isTheme){
                    $rootScope.vod_id=this_video.id
                }else{
                    $rootScope.theme=this_video.id
                    vm.theme=  this_video.id;
                    vm.canal= this_video.idCanal
                    changeQuery('theme', vm.theme)
                }
            }
            if (angular.isDefined($stateParams.id) && ! vm.isTheme) {
                vm.videoById = this_video;
                if (($state.current.name.indexOf("live") > 0) || ($state.current.name.indexOf("event") > 0)) {
                    vm.videoById.logo = this_video.thumbnail;
                }
            }


        }

        /*function gotoListVideo() {
          if (angular.isDefined($stateParams.id)) {
            var stat_default = 'app.media_video_list_ongoing';
            if ($state.current.name.indexOf("live") > 0) {
              stat_default = "app.lives_list_ongoing";
            }
            var state_parent = angular.isDefined($rootScope.name_state_parent) ? $rootScope.name_state_parent : stat_default;
            $state.go(state_parent);
          }

        }*/

        function isHiddenFilter(tab_list, value) {
            var type = angular.isDefined(tab_list.filter) ? tab_list.filter : typeStatsFilter;
            return filterShow[type][value];

        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_" + vm.typeStatsFilter + "_pagetitle";
            $rootScope.titre3 = "";
            $rootScope.welcome = "";
            $rootScope.pageRoute = '';

        }

    }
})();

(function () {
    'use strict';
    /** @ngInject */
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m - 1, 0);
    var lastDay = new Date(y, m + 1, 0,23);
    console.log(lastDay);
    var dateMoisCourantConstant = {
        "date": {
            "currentDateIn": firstDay,
            "currentDateOut": lastDay
        }
    };
   console.log(dateMoisCourantConstant);
    var tab_key_value_vod_by_id = {
        audience: {
            title: "STATSTITLE.stat_audience",
            ui_sref: ".audience",
            ui_view: "audience",
            md_selected_index: 0
        },
        technologie: {
            title: "STATSTITLE.stat_technologie",
            ui_sref: ".technologie",
            ui_view: "technologie",
            md_selected_index: 1
        },
        mobile: {
            title: "STATSTITLE.stat_mobile",
            ui_sref: ".mobile",
            ui_view: "mobile",
            md_selected_index: 2,
            filter: "vod"
        },
        engagement: {
            title: "STATSTITLE.stat_engagement",
            ui_sref: ".engagement",
            ui_view: "engagement",
            md_selected_index: 3
        },
        geo: {title: "STATSTITLE.stat_geolocalisation", ui_sref: ".geo", ui_view: "geo", md_selected_index: 4},
        temp_reel: {
            title: "STATSTITLE.stat_real_time",
            ui_sref: ".temp_reel",
            ui_view: "temp_reel",
            md_selected_index: 5,
            filter: "time_reel"
        }
    };

    var is_show_filtre_vod = {
        vod: {
            dateIn: true,
            dateOut: true,
            canal: true,
            theme: true,
            type: true
        }, live: {
            dateIn: true,
            dateOut: true,
            canal: false,
            theme: false,
            type: true
        },
        event: {
            dateIn: true,
            dateOut: true,
            canal: false,
            theme: false,
            type: true
        },
        time_reel: {
            dateIn: false,
            dateOut: false,
            canal: true,
            theme: true,
            type: true
        }
    };


    angular
        .module('app.stats.export_vod_live')
        .constant('tab_key_value_vod_by_id', tab_key_value_vod_by_id)
        .constant('dateMoisCourantConstant', dateMoisCourantConstant)
        .constant('is_show_filtre_vod', is_show_filtre_vod);

})();

(function () {
    'use strict';
    /** @ngInject */
    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m-5, 1);
    var lastDay = new Date(y, m + 1, 0);

    var color_nombre_video = "#3F51B5"; //indigo500
    var color_visites = "#2196f3"; //bleu 500
    var color_visiteurs_uniques = "#FF9800"; // pink 500
    var color_nombre_vue_par_visiteur = "#3F51B5"; // orange 500
    var color_nombre_vue_par_video = "#F44336"; // red 500


    var color_duree_moyenne_par_video = "#FF9800"; // deep purple 500
    var color_duree_moyenne_par_visiteur_unique = "#1F9FE8"; // green 500
    var color_duree_moyenne_par_visite = "#97C0E8"; //purple 500
    var color_duree_total = "#F5B159"; //teal 500
    var color_ecart_type =  "#607D8B"; // bleu gree 500

    var color_taux_rebond =  "#00BCD4"; // cyan 500
    var color_number_loads =  "#3F51B5"; // cyan 500
    var color_number_vue_per_autoplay =  "#FF9800"; // cyan 500
    var color_duree_video = "#F44336"; //  red 500
    //var color_taux_rebond =  "#9E9E9E"; //grey 500
    var color_constant = {
        color_nombre_vue_par_visiteur: color_nombre_vue_par_visiteur,
        color_duree_total: color_duree_total,
        color_duree_moyenne_par_visite: color_duree_moyenne_par_visite,
        color_duree_moyenne_par_visiteur_unique: color_duree_moyenne_par_visiteur_unique,
        color_visites: color_visites,
        color_visiteurs_uniques: color_visiteurs_uniques,
        color_nombre_vue_par_video:color_nombre_vue_par_video,
        color_nombre_video:color_nombre_video,
        color_taux_rebond:color_taux_rebond,
        color_duree_video:color_duree_video
    };

    var mesure_widget_constant = {
        total_registrations: {title: "VISITSMESURESTATS.stat_different_views_videos", color: color_nombre_video},
        ongoing_registrations: {title: "VISITSMESURESTATS.stat_different_views_videos", color: color_nombre_video},
        nombre_video: {title: "VISITSMESURESTATS.stat_different_views_videos", color: color_nombre_video},
        visite_total: {title: "VISITSMESURESTATS.stat_views_videos", color: color_visites},
        visite_unique: {title: "VISITSMESURESTATS.stat_uniq_visits", color: color_visiteurs_uniques},
        nombre_vue_par_visiteur: {title: "VISITSMESURESTATS.stat_nombre_vue_par_visiteur", color: color_nombre_vue_par_visiteur},
        nombre_vue_par_video: {title: "VISITSMESURESTATS.stat_nombre_vue_par_video", color: color_nombre_vue_par_video},
        duree_total: {title: "VISITSMESURESTATS.stat_total_duration", color: color_duree_total},
        duree_moyenne_par_visiteur: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visiteur", color: color_duree_moyenne_par_visite},
        duree_video: {title: "VISITSMESURESTATS.stat_duree_video", color: color_duree_video},
        duree_moyenne_par_visite: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visite", color: color_duree_moyenne_par_visiteur_unique},
        duree_moyenne_par_video: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_video", color: color_duree_moyenne_par_video},
        ecart_type: {title: "VISITSMESURESTATS.stat_standard_deviation", color: color_ecart_type},
        taux_rebond: {title: "VISITSMESURESTATS.stat_different_views_videos", color: color_taux_rebond},
        visite_temps_reel:{title: "VISITSMESURESTATS.stat_visite_temps_reel", color: color_visites},
        video_temps_reel:{title: "VISITSMESURESTATS.stat_video_temps_reel", color: color_nombre_video},
        number_loads:{title: "VISITSMESURESTATS.number_loads", color: color_number_loads},
        number_vue_per_autoplay:{title: "VISITSMESURESTATS.number_vue_per_autoplay", color: color_number_vue_per_autoplay}

    };
    var mesure_percentage_widget_constant = {
  // {
  //   "NumberOfAccess": 5,
  //   "NumberOfViews": 2,
  //   "NumberOfViewsFourthQuarter": 2,
  //   "NumberOfViewsThirdQuarter": 2,
  //   "NumberOfViewsSecondQuarter": 2,
  //   "NumberOfViewsFirstQuarter": 2,
  //   "NumberOfVisitors":2
  // }
      NumberOfAccess: {title: "VISITSMESURESTATS.NumberOfAccess", color: color_visites},
      NumberOfViews: {title: "VISITSMESURESTATS.stat_visite_nb_views", color: color_visites},
      NumberOfVisitors: {title: "VISITSMESURESTATS.stat_visite_nb_visiteur", color: color_visites},
      NumberOfViewsFourthQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_100", color: color_visites},
      NumberOfViewsFirstQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_25", color: color_visiteurs_uniques},
      NumberOfViewsThirdQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_75", color: color_nombre_vue_par_visiteur},
      NumberOfViewsSecondQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_50", color: color_nombre_vue_par_video},
    };
    var mesure_mooc_widget_constant = {
        total_registrations: {title: "MOOCMESURESTATS.stat_mooc_total_registrations", color: color_duree_moyenne_par_visiteur_unique},
        ongoing_registrations: {title: "MOOCMESURESTATS.stat_mooc_ongoing_registrations", color: color_visites},
        actif_learners: {title: "MOOCMESURESTATS.stat_mooc_actif_learners", color: color_duree_moyenne_par_visiteur_unique},
        video_watcher: {title: "MOOCMESURESTATS.stat_mooc_video_watcher", color: color_visites},
        problem_tester: {title: "MOOCMESURESTATS.stat_mooc_problem_tester", color: color_visiteurs_uniques},
        persons_passport: {title: "MOOCMESURESTATS.stat_mooc_nbr_persons_passport", color: color_visiteurs_uniques},
        views_passport: {title: "MOOCMESURESTATS.stat_mooc_nbr_views_persons_passport", color: color_visiteurs_uniques},
        visas_persons: {title: "MOOCMESURESTATS.stat_mooc_nbr_visas_person", color: color_visiteurs_uniques}



    };
    var mesure_by_ip_widget_constant = {
        nombre_video: {title: "VISITSMESURESTATS.stat_different_views_videos", color: color_nombre_video},
        visite_total: {title: "VISITSMESURESTATS.stat_views_videos", color: color_visites},
        visite_unique: {title: "VISITSMESURESTATS.stat_uniq_visits", color: color_visiteurs_uniques},
        nombre_vue_par_visiteur: {title: "VISITSMESURESTATS.stat_nombre_vue_par_visiteur", color: color_nombre_vue_par_visiteur},
        nombre_vue_par_video: {title: "VISITSMESURESTATS.stat_nombre_vue_par_video", color: color_nombre_vue_par_video},
        duree_total: {title: "VISITSMESURESTATS.stat_total_duration", color: color_duree_total},
        duree_moyenne_par_visiteur: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visiteur", color: color_duree_moyenne_par_visite},
        duree_moyenne_par_visite: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visite", color: color_duree_moyenne_par_visiteur_unique},
        duree_moyenne_par_video: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_video", color: color_duree_moyenne_par_video},
        ecart_type: {title: "VISITSMESURESTATS.stat_standard_deviation", color: color_ecart_type},



    };

    var podcast_constants={
      nombre_video: {title: "VISITSMESURESTATS.stat_different_views_podcasts", color: color_nombre_video},
      visite_total: {title: "VISITSMESURESTATS.stat_views_podcasts", color: color_visites},
      visite_unique: {title: "VISITSMESURESTATS.stat_uniq_visits", color: color_visiteurs_uniques},
      nombre_vue_par_visiteur: {title: "VISITSMESURESTATS.stat_nombre_vue_par_visiteur", color: color_nombre_vue_par_visiteur},
      nombre_vue_par_video: {title: "VISITSMESURESTATS.stat_nombre_vue_par_podcast", color: color_nombre_vue_par_video},
      duree_total: {title: "VISITSMESURESTATS.stat_total_duration", color: color_duree_total},
      duree_moyenne_par_visiteur: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visiteur", color: color_duree_moyenne_par_visite},
      duree_moyenne_par_visite: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_visite", color: color_duree_moyenne_par_visiteur_unique},
      duree_moyenne_par_video: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_podcast", color: color_duree_moyenne_par_video},
      ecart_type: {title: "VISITSMESURESTATS.stat_standard_deviation", color: color_ecart_type},
      taux_rebond: {title: "VISITSMESURESTATS.stat_different_views_podcasts", color: color_taux_rebond},
      number_loads:{title: "VISITSMESURESTATS.number_loads", color: color_number_loads},
      number_vue_per_autoplay:{title: "VISITSMESURESTATS.number_vue_per_autoplay", color: color_number_vue_per_autoplay},


      video_temps_reel:{title: "VISITSMESURESTATS.stat_podcast_temps_reel", color: color_nombre_video},

      visite_temps_reel:{title: "VISITSMESURESTATS.stat_visite_temps_reel_podcast", color: color_visites},
      total_registrations: {title: "VISITSMESURESTATS.stat_different_views_podcasts", color: color_nombre_video},
      ongoing_registrations: {title: "VISITSMESURESTATS.stat_different_views_podcasts", color: color_nombre_video},
      nombre_vue_par_podcast: {title: "VISITSMESURESTATS.stat_nombre_vue_par_podcast", color: color_nombre_vue_par_video},


      duree_moyenne_par_podcast: {title: "VISITSMESURESTATS.stat_duree_moyenne_par_podcast", color: color_duree_moyenne_par_video},

      podcast_watcher: {title: "MOOCMESURESTATS.stat_mooc_podcast_watcher", color: color_visites},


      NumberOfViewsFourthQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_100_podcast", color: color_visites},
      NumberOfViewsFirstQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_25_podcast", color: color_visiteurs_uniques},
      NumberOfViewsThirdQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_75_podcast", color: color_nombre_vue_par_visiteur},
      NumberOfViewsSecondQuarter: {title: "VISITSMESURESTATS.stat_nbre_vue_50_podcast", color: color_nombre_vue_par_video},
      NumberOfAccess: {title: "VISITSMESURESTATS.NumberOfAccess", color: color_visites},
      NumberOfViews: {title: "VISITSMESURESTATS.stat_visite_nb_views", color: color_visites},
      NumberOfVisitors: {title: "VISITSMESURESTATS.stat_visite_nb_visiteur", color: color_visites},



    }


    angular
        .module('app.stats.graphe')
        .constant('mesure_widget_constant', mesure_widget_constant)
        .constant('mesure_percentage_widget_constant', mesure_percentage_widget_constant)
        .constant('mesure_mooc_widget_constant', mesure_mooc_widget_constant)
        .constant('mesure_by_ip_widget_constant',mesure_by_ip_widget_constant)
        .constant('podcast_constants',podcast_constants)
        .constant('color_constant', color_constant);

})();

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('timeHelperService', timeHelperService);

    /** @ngInject */
    function timeHelperService() {


        // return hh:mm:ss
        function secondsTimeSpanToHMS(s) {

            var h = Math.floor(s / 3600); //Get whole hours
            s -= h * 3600;
            var m = Math.floor(s / 60); //Get remaining minutes
            s -= m * 60;
            s = Math.floor(s);
            return h + ":" + (m < 10 ? '0' + m : m) + ":" + (s < 10 ? '0' + s : s); //zero padding on minutes and seconds
        }

        // return HH h MM m SS s
        function calc_time_unite(seconds) {
            var hours = parseInt(seconds / 3600);
            var mod = seconds % 3600;
            var minutes = parseInt(mod / 60);
            mod = mod % 60;
            if (seconds === 0)
                return "0s";
            if (hours !== 0) {
                hours = hours + "h";
            } else {
                hours = "";
            }
            if (minutes !== 0) {
                minutes = minutes + "m";
            } else {
                minutes = "";
            }

            if (mod !== 0) {
                mod = mod + "s";
            } else {
                mod = "";
            }

            return hours + minutes + mod;
        }


        return {
            secondsTimeSpanToHMS: secondsTimeSpanToHMS,
            calc_time_unite: calc_time_unite

        };

    }
}());

(function () {
        'use strict';

        angular
            .module('app.stats.graphe')
            .factory('TableWidgetService', TableWidgetService);

        /** @ngInject */
        function TableWidgetService(chartWidgetService, timeHelperService) {
            var dtOptionsQuiz = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                searching: false,
                order: [1, 'desc'],
                pageLength: 5,
                lengthMenu: [5, 10, 20, 30, 50, 100],
                autoWidth: false,
                responsive: true,
                columnDefs: [
                    {
                        width: '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns: [
                    {},
                    {},
                    {
                        render: function (data, type) {
                          if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    value = 0;
                                return value;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {},
                    {}
                    ,
                    {}
                    ,
                    {}
                ]
            };
            var dtOptions = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                searching: false,
                order: [1, 'desc'],
                pageLength: 5,
                lengthMenu: [5, 10, 20, 30, 50, 100],
                autoWidth: false,
                responsive: true,
                columnDefs: [
                    {
                        width: '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns: [
                    {},
                    {
                        render: function (data, type) {
                            if (type === 'display') {
                                var el = angular.element(data);
                              var value = el.text();
                              if (isNaN(value) && value.indexOf(':')===-1 )
                                value = 0;
                                var data_number =  !dtOptions.duration && value.indexOf(':')===-1 ? parseFloat(value) : value;
                                return   !dtOptions.duration && value.indexOf(':')===-1 && !Number.isInteger(data_number) ? data_number.toFixed(2): data_number  ;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {
                          if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                            if (isNaN(value) && value.indexOf(':')===-1)
                                    value = 0;
                            var data_number =  !dtOptions.duration && value.indexOf(':')===-1? parseFloat(value) : value;
                            return  !dtOptions.duration && value.indexOf(':')===-1 && !Number.isInteger(data_number) ? data_number.toFixed(2) : value;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {
                          if (type === 'display') {
                                var el = angular.element(data);

                                var value = el.text();
                            if (isNaN(value) && value.indexOf(':')===-1)
                                    value = 0;
                            var data_number =  !dtOptions.duration && value.indexOf(':')===-1? parseFloat(value) : value;
                            return !dtOptions.duration && value.indexOf(':')===-1 && !Number.isInteger(data_number) ? data_number.toFixed(2) :  value;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {
                          if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                            if (isNaN(value) && value.indexOf(':')===-1)
                                    value = 0;
                            var data_number =  !dtOptions.duration && value.indexOf(':')===-1 ? parseFloat(value) : value;
                            return !dtOptions.duration && value.indexOf(':')===-1 && !Number.isInteger(data_number) ? data_number.toFixed(2) :  value;
                            }
                            else {
                                return data;
                            }
                        }
                    }
                    ,
                    {}
                    ,
                    {}
                ]
            };
            var dtOptionsPercentage = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                searching: false,
                pageLength: 5,
                order: [1, 'desc'],
                lengthMenu: [5, 10, 20, 30, 50, 100],
                autoWidth: false,
                responsive: true,
                columnDefs: [
                    {
                        targets: 0,
                        width: '30%'
                    }, //0 is the column index

                    {
                        width: '30%',
                        targets: [1, 2]
                    }
                ],
                columns: [
                    {
                        render: function (data, type) {

                            if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    return data;
                                var data_number = parseInt(value);
                                return timeHelperService.calc_time_unite(data_number) + "-" + timeHelperService.calc_time_unite(data_number + 30);
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {

                            if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    value = 0;
                                var data_number = parseFloat(value);
                                return  !Number.isInteger(data_number) ? data_number.toFixed(2) : data_number;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {

                            if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    value = 0;
                                var data_number = parseFloat(value);
                                return data_number.toFixed(2) + "%";
                            }
                            else {
                                return data;
                            }
                        }
                    }
                ]
            };
            var dtOptionsMap = {
                dom: '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                searching: false,
                pageLength: 5,
                order: [1, 'desc'],
                lengthMenu: [5, 10, 20, 30, 50, 100],
                autoWidth: false,
                responsive: true,
                columnDefs: [
                    {
                        width: '20%',
                        targets: [0, 1, 2]
                    }
                ],
                columns: [
                    {},
                    {
                        render: function (data, type) {

                            if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    value = 0;
                                var data_number = parseFloat(value);
                                return  !Number.isInteger(data_number) ? data_number.toFixed(2):data_number ;
                            }
                            else {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type) {

                            if (type === 'display') {
                                var el = angular.element(data);
                                var value = el.text();
                                if (isNaN(value))
                                    value = 0;
                                var data_number = parseFloat(value);
                                return !Number.isInteger(data_number) ? data_number.toFixed(2) : data_number;
                            }
                            else {
                                return data;
                            }
                        }
                    }
                ]
            };

            function getTable(series, categories, title, ids) {
                var rows = [];
                var columns = [];
                var key_row = 0;
              columns.push({"title": title});
                angular.forEach(series, function (value) {
                    columns.push({"title": value.name});
                });
                angular.forEach(categories, function (value, key) {
                    var row = [];
                    // if (ids)
                    //     row.push({"id": ids[key]});

                  row.push({"value": value});
                  angular.forEach(series, function (value) {
                    dtOptionsQuiz.duration=value.duration ? true: false
                    dtOptions.duration=value.duration? true: false;
                      if(isNaN(value.data[key_row])){
                        value.data[key_row]=0
                      }

                    var rowValue= value.duration ? timeHelperService.secondsTimeSpanToHMS( value.data[key_row] ) : !Number.isInteger(value.data[key_row]) ? value.data[key_row].toFixed(2) :  value.data[key_row];
                      row.push({"value":rowValue  , duration: value.duration ? true : false });
                    });
                    key_row++;
                    if (ids && ids !== "theme")
                        row[0].id = ids[key];
                    rows.push(row);
                });
                if (ids)
                    return {
                        table: {
                            "columns": columns,
                            "rows": rows
                        },
                        dtOptions: dtOptionsQuiz
                    };
                else
                    return {
                        table: {
                            "columns": columns,
                            "rows": rows
                        },
                        dtOptions: dtOptions
                    };
            }

            function getTableMap(series, categories, title) {
                var rows = [];
                var columns = [];
                var key_row = 0;
                columns.push({"title": title});
                angular.forEach(series, function (value) {
                    columns.push({"title": value.name});
                });
                angular.forEach(categories, function (value) {

                    var row = [];
                    row.push({"value": value});
                    angular.forEach(series, function (value) {
                      dtOptionsQuiz.duration=value.duration ? true: false
                      dtOptions.duration=value.duration? true: false;
                        row.push({"value": value.data[key_row]});
                    });
                    key_row++;
                    rows.push(row);
                });
                return {
                    table: {
                        "columns": columns,
                        "rows": rows
                    },
                    dtOptions: dtOptionsMap
                };
            }

            function getTablePercentage(series, categories, title) {
                var rows = [];
                var columns = [];
                var key_row = 0;
                columns.push({"title": title});
                angular.forEach(series, function (value) {
                    columns.push({"title": value.name});
                });
                columns.push({"title": "pourcentage"});
                angular.forEach(categories, function (value) {
                    var row = [];
                    row.push({"value": value, "classes": "amber-700-fg"});
                    angular.forEach(series, function (value) {
                      dtOptionsQuiz.duration=value.duration ? true: false
                      dtOptions.duration=value.duration? true: false;
                      var y_and_percentage = value.data[key_row];
                        row.push({"value": y_and_percentage.y});
                        row.push({"value": y_and_percentage.percentage});
                    });
                    key_row++;
                    rows.push(row);
                });
                return {
                    table: {
                        "columns": columns,
                        "rows": rows
                    },
                    dtOptions: dtOptionsPercentage
                };
            }

            return {
                getTable: getTable,
                getTablePercentage: getTablePercentage,
                getTableMap: getTableMap

            };

        }
    }()
)
;

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('exportChartService', exportChartService);

    /** @ngInject */
    function exportChartService($injector,timeHelperService, $rootScope) {

        function exportPdf(chart, type, query) {
            chart.exportChart({
                type: 'application/pdf',
                filename: getTitleChartExport(type, query)
            }, {
                chart: {
                    height: (90) + '%'
                }, legend: {
                    layout: 'horizontal',
                    enabled: true,
                    verticalAlign: 'bottom',
                    align:'center',
                    y:-5
                }
            });

        };

        function exportImage(chart, type, query) {
            chart.exportChart({
                type: 'image/png',
                filename: getTitleChartExport(type, query)
            }, {
                chart: {
                    height: (100) + '%' // 16:9 ratio
                }
            });
        };
        function exportExcel(chart, type, query, title) {
          chart.options.exporting.filename = getTitleChartExport(type, query);
          chart.options.exporting.tableCaption =getFiltreChartExport(type, query);
          if(title){
              chart.options.title.text =title;
              chart.options.xAxis[0].title.text =title;
          }
          var infoVideo= $rootScope.infoVideo
          if(query.vod_id && angular.isDefined(query.vod_id) && query.vod_id!=="" && infoVideo){
            chart.options.exporting.tableInfos =infoVideo
          }
          setValueChartExprt(chart.series)
          chart.downloadXLS();
        }
        function setValueChartExprt(series){
          if(series && series.length>0){
            series.forEach(function (serie) {
              var hasDuration= serie.userOptions.duration;
                serie.data.forEach(function(val){
                  if(!val.y){
                    val.y=0
                  }
                  if(hasDuration){
                    val.y=val.y.toString();
                    val.y= (val.y.indexOf(":") === -1 ? timeHelperService.secondsTimeSpanToHMS( val.y) :val.y);
                  }else{
                    val.y=parseFloat(val.y);
                    val.y=  !Number.isInteger( val.y) ?  val.y.toFixed(2) : val.y;
                  }
                })
            })
          }
        }
        function getTitleChartExport(chart, query) {
            var title = "graphe_" + chart;
            if(angular.isDefined(query.type)){
                title  = title + "_" + query.type;
            }
            if(angular.isDefined(query.dateIn)){
                title  = title + "_" + moment(query.dateIn).format("DD_MM_YYYY");
            }
            if(angular.isDefined(query.dateOut)){
                title  = title + "__" + moment(query.dateOut).format("DD_MM_YYYY");
            }
            return title;
        };
      function getFiltreChartExport(chart, query) {
        var title = "Graphe " + chart;
        var tableCaptions=[{title: title}];
        var dateIn='';
        var dateOut='';
        var type='';
        var group='';
        var theme='';
        if(angular.isDefined(query.dateIn) && query.dateIn!==""){
          dateIn  =  moment(query.dateIn).format("DD/MM/YYYY");
          tableCaptions.push({dateIn : dateIn})
        }
        if(angular.isDefined(query.dateOut) && query.dateOut!==""){
          dateOut = moment(query.dateOut).format("DD/MM/YYYY");
          tableCaptions.push({dateOut : dateOut})
        }
        if (angular.isDefined(query.theme) && query.theme!=="") {
          theme = query.theme;
          tableCaptions.push({theme : theme})
        }
        if (angular.isDefined(query.group) && query.group!=="") {
          group = query.group;
          tableCaptions.push({group : group})
        }
        if (angular.isDefined(query.type) && query.type!=="") {
          type = query.type;
          tableCaptions.push({type : type})
        }
        return tableCaptions;
      };

        return {
            exportExcel: exportExcel,
            exportImage: exportImage,
            exportPdf: exportPdf

        };

    }
}());

(function (H) {
  'use strict';

  angular
    .module('app.stats.graphe')
    .factory('chartWidgetService', chartWidgetService);

  /** @ngInject */
  function chartWidgetService($injector, color_constant, timeHelperService) {
    var $translate = $injector.get('$translate');
    var color_nombre_vue_par_visiteur = color_constant.color_nombre_vue_par_visiteur;
    var color_duree_total = color_constant.color_duree_total;
    var color_duree_moyenne_par_visite = color_constant.color_duree_moyenne_par_visite;
    var color_duree_moyenne_par_visiteur_unique = color_constant.color_duree_moyenne_par_visiteur_unique;
    var color_visites = color_constant.color_visites;
    var color_visiteurs_uniques = color_constant.color_visiteurs_uniques;
    var self = this;
    function htmlencode(html) {
      return html
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#x27;')
        .replace(/\//g, '&#x2F;');
    }
    H.wrap(H.Chart.prototype, 'getTable', function(proceed, useLocalDecimalPoint) {
      var html = '<table id="highcharts-data-table-' + this.index + '">',
        options = this.options,
        decimalPoint = useLocalDecimalPoint ? (1.1).toLocaleString()[1] : '.',
        useMultiLevelHeaders = H.pick(
          options.exporting.useMultiLevelHeaders, true
        ),
        rows = this.getDataRows(useMultiLevelHeaders),
        rowLength = 0,
        topHeaders = useMultiLevelHeaders ? rows.shift() : null,
        subHeaders = rows.shift(),
        // Compare two rows for equality
        isRowEqual = function(row1, row2) {
          var i = row1.length;

          if (row2.length === i) {
            while (i--) {
              if (row1[i] !== row2[i]) {
                return false;
              }
            }
          } else {
            return false;
          }
          return true;
        },
        // Get table cell HTML from value
        getCellHTMLFromValue = function(tag, classes, attrs, value) {
          var val = H.pick(value, ''),
            className = 'text' + (classes ? ' ' + classes : '');

          // Convert to string if number
          if (typeof val === 'number') {
            val = val.toString();
            if (decimalPoint === ',') {
              val = val.replace('.', decimalPoint);
            }
            className = 'number';
          } else if (!value) {
            className = 'empty';
          }
          return '<' + tag + (attrs ? ' ' + attrs : '') +
            ' class="' + className + '">' +
            val + '</' + tag + '>';
        },
        // Get table header markup from row data
        getTableHeaderHTML = function(topheaders, subheaders, rowLength) {
          var html = '<thead>',
            i = 0,
            len = rowLength || subheaders && subheaders.length,
            next,
            cur,
            curColspan = 0,
            rowspan;

          // Clean up multiple table headers. Chart.getDataRows() returns two
          // levels of headers when using multilevel, not merged. We need to
          // merge identical headers, remove redundant headers, and keep it
          // all marked up nicely.
          if (
            useMultiLevelHeaders &&
            topheaders &&
            subheaders &&
            !isRowEqual(topheaders, subheaders)
          ) {
            html += '<tr>';
            for (; i < len; ++i) {
              cur = topheaders[i];
              next = topheaders[i + 1];
              if (cur === next) {
                ++curColspan;
              } else if (curColspan) {
                // Ended colspan
                // Add cur to HTML with colspan.
                html += getCellHTMLFromValue(
                  'th',
                  'highcharts-table-topheading',
                  'scope="col" ' +
                  'colspan="' + (curColspan + 1) + '"',
                  cur
                );
                curColspan = 0;
              } else {
                // Cur is standalone. If it is same as sublevel,
                // remove sublevel and add just toplevel.
                if (cur === subheaders[i]) {
                  if (options.exporting.useRowspanHeaders) {
                    rowspan = 2;
                    delete subheaders[i];
                  } else {
                    rowspan = 1;
                    subheaders[i] = '';
                  }
                } else {
                  rowspan = 1;
                }
                html += getCellHTMLFromValue(
                  'th',
                  'highcharts-table-topheading',
                  'scope="col"' +
                  (rowspan > 1 ?
                    ' valign="top" rowspan="' + rowspan + '"' :
                    ''),
                  cur
                );
              }
            }
            html += '</tr>';
          }

          // Add the subheaders (the only headers if not using multilevels)
          if (subheaders) {
            html += '<tr>';
            for (i = 0, len = subheaders.length; i < len; ++i) {
              if (subheaders[i] !== undefined) {
                html += getCellHTMLFromValue(
                  'td', null, 'scope="col"', subheaders[i]
                );
              }
            }
            html += '</tr>';
          }
          html += '</thead>';
          return html;
        };
      // Add table infos
      if (options.exporting.tableInfos && Object.keys(options.exporting.tableInfos).length) {
        var infosLength= 2;
        var keysTableInfo=Object.keys(options.exporting.tableInfos );
        for (var k=0; k< keysTableInfo.length ; k++) {
             if(!k){
               html += '<tr><th style="text-align: center;vertical-align: middle;" colspan="2" rowspan='+infosLength+'>Information Video</th>';
             }else{
               html += '<tr>';
             }
              html += '<th  colspan="2"><span class="highcharts-table-caption title-caption">' + H.pick(
                keysTableInfo[k],
                (
                  keysTableInfo[k] ?
                    htmlencode(   keysTableInfo[k]) :
                    'Chart'
                )
              ) + '</span></th>';
              html += '<td  colspan="2"><span class="highcharts-table-caption subtitle-caption">' + H.pick(
               options.exporting.tableInfos[keysTableInfo[k]],
                (
                  options.exporting.tableInfos[keysTableInfo[k]] ?
                    htmlencode( options.exporting.tableInfos[keysTableInfo[k]]) :
                    'Chart'
                )
              ) + '</span></td>';
              html += '</tr>';
            }
        html += '<tr></tr>';
      }


      // Add table caption
      if (options.exporting.tableCaption !== false) {
        var captionsLength= (options.exporting.tableCaption.length > 0 ?options.exporting.tableCaption.length : 1);
         Array.isArray(options.exporting.tableCaption) ?
          options.exporting.tableCaption.forEach(function(caption, index){
            var keysTableCaption=Object.keys(caption);
            for (var c=0; c< keysTableCaption.length ; c++) {
              if(!index){
                  html += '<tr><th style="text-align: center;vertical-align: middle;" colspan="2" rowspan='+captionsLength+'>Filtres</th>';
                }else{
                  html += '<tr>';
                }
                html += '<th  colspan="2"><span class="highcharts-table-caption title-caption">' + H.pick(
                  keysTableCaption[c],
                  (
                    keysTableCaption[c] ?
                      htmlencode(  keysTableCaption[c]) :
                      'Chart'
                  )
                ) + '</span></th>';
                html += '<td  colspan="2"><span class="highcharts-table-caption subtitle-caption">' + H.pick(
                  caption[ keysTableCaption[c]],
                  (
                    caption[ keysTableCaption[c]] ?
                      htmlencode( caption[ keysTableCaption[c]]) :
                      'Chart'
                  )
                ) + '</span></td>';
                html += '</tr>';

              }
      }) :
          (html += '<span class="highcharts-table-caption">' + H.pick(
          options.exporting.tableCaption,
          (
            options.exporting.tableCaption ?
              htmlencode( options.title.text ) :
              'Chart'
          )

        ) +'</span>' );

        html += '<tr></tr>';
      }

      // Find longest row
      for (var i = 0, len = rows.length; i < len; ++i) {
        if (rows[i].length > rowLength) {
          rowLength = rows[i].length;
        }
      }
      // Add header
      html += getTableHeaderHTML(
        topHeaders,
        subHeaders,
        Math.max(rowLength, subHeaders.length)
      );

      // Transform the rows to HTML
      html += '<tbody>';
      rows.forEach(function(row) {
        html += '<tr>';
        for (var j = 0; j < rowLength; j++) {
          // Make first column a header too. Especially important for
          // category axes, but also might make sense for datetime? Should
          // await user feedback on this.
          html += getCellHTMLFromValue(
             'td',
            null,
            j ? '' : 'scope="row"',
            row[j]
          );
        }
        html += '</tr>';
      });
      html += '</tbody></table>';
      var e = {
        html: html
      };

      H.fireEvent(this, 'afterGetTable', e);

      return e.html;
    })

function chart_discret(type) {
        var series= [
            {
                name: $translate.instant('VISITSMESURESTATS.stat_nombre_vue_par_visiteur'),
                type: 'column',
                yAxis: 0,
                id: 'series1',
                data: [],
                color: color_nombre_vue_par_visiteur

            }, {
                name: $translate.instant('VISITSMESURESTATS.stat_duree_tot'),
                type: 'column',
                yAxis: 2,
                id: 'series2',
                data: [],
                color: color_duree_total,
                duration :  true
            }, {
                name: $translate.instant('VISITSMESURESTATS.stat_duree_moyenne_par_visite'),
                type: 'column',
                yAxis: 3,
                id: 'series3',
                data: [],
                color: color_duree_moyenne_par_visite,
                duration :  true
            }, {
                name: $translate.instant('VISITSMESURESTATS.stat_duree_moyenne_par_visiteur_unique'),
                type: 'column',
                id: 'series4',
                yAxis: 3,
                data: [],
                color: color_duree_moyenne_par_visiteur_unique,
                duration :  true
            }, {
                name: $translate.instant('VISITSMESURESTATS.stat_visits'),
                type: 'column',
                yAxis: 1,
                id: 'series5',
                data: [],
                color: color_visites

            },
            {
                name: $translate.instant('VISITSMESURESTATS.stat_uniq_visits'),
                type: 'column',
                yAxis: 1,
                id: 'series6',
                data: [],
                color: color_visiteurs_uniques

            }]
        if(type){
             series=   [
                 {
                     name: $translate.instant('VISITSMESURESTATS.stat_duree_tot'),
                     type: 'column',
                     yAxis: 2,
                     id: 'series2',
                     data: [],
                     color: color_duree_total,
                     duration :  true
                 }
            ]
        }
      return  {
          chart: {
              zoomType: 'xy',
              marginBottom: 100
          },
          title: {
              text: ''
          },
        exporting: {
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }
            }
          },
        },
          xAxis: {
              categories: [],
            type: '',
            title: {
              text: ''
            },
          },
          yAxis: [
              { // Primary yAxis % de vue
                  labels: {
                      format: '{value}',
                      style: {
                          color: color_nombre_vue_par_visiteur
                      }
                  },
                  title: {
                      text: $translate.instant('VISITSMESURESTATS.stat_nombre_vue_par_visiteur'),
                      style: {
                          color: color_nombre_vue_par_visiteur
                      }
                  },
                  showEmpty: false,
                  crosshair: true

              },
              { // Secondary yAxis Nombre de vue
                  gridLineWidth: 0,
                  title: {
                      text: $translate.instant('VISITSMESURESTATS.stat_visite_nb_views'),
                      style: {
                          color: "#edede"
                      }
                  },
                  labels: {
                      format: '{value}',
                      style: {
                          color: "#edede"
                      }
                  },
                  showEmpty: false,
                  crosshair: true

              },
              { // Tertiary yAxis duree Total
                  gridLineWidth: 0,
                  title: {
                      text: $translate.instant('VISITSMESURESTATS.stat_duree_tot'),
                      style: {
                          color: color_duree_total
                      }
                  },
                  labels: {
                      formatter: function () {
                          return timeHelperService.secondsTimeSpanToHMS(this.value);
                      },
                      min: 0,
                      style: {
                          color: color_duree_total
                      }
                  },
                  opposite: true,
                  showEmpty: false,
                  crosshair: true,
                duration :  true
              },
              { // Tertiary yAxis duree Moyenne
                  gridLineWidth: 0,
                  title: {
                      text: $translate.instant('VISITSMESURESTATS.stat_duree_moy'),
                      style: {
                          color: "#edede"
                      }
                  },
                  labels: {
                      formatter: function () {
                          return timeHelperService.secondsTimeSpanToHMS(this.value);
                      },
                      style: {
                          color: "#edede"
                      }
                  },
                  opposite: true,
                  showEmpty: false,
                  crosshair: true,
                duration :  true
              }
          ],
          tooltip: {
              shared: true,
              formatter: function () {
                  var s = '<b>' + this.x + '</b>';

                  $.each(this.points, function (i, point) {
                      if (point.series.index === 1 || point.series.index === 2 || point.series.index === 3 || type){
                        s += '<br/><span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + (point.y.toString().indexOf(":") === -1 ? timeHelperService.secondsTimeSpanToHMS(point.y) : point.y);
                      }
                      else
                          s += '<br/><span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + point.y.toFixed(2);
                  });

                  return s;
              }
          },
          legend: {
              layout: 'horizontal',
              align: 'center',
              floating: true,
              verticalAlign: 'buttom',
              y: 350,
              borderWidth: 0
          },
          credits: {
              enabled: true,
              text: 'powered by www.empreinte.com',
              href: 'https://www.empreinte.com'
          },
          navigation: {
              buttonOptions: {
                  enabled: false
              }
          },
          series:series

      };

    }

    function chart_discret_duree_par_visite() {
      return {
        chart: {
          type: 'column',
          zoomType: 'xy',
          marginBottom: 220
        },
        title: {
          text: ''
        },
        exporting: {
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }
            }
          },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          gridLineWidth: 0,
          title: {
            text: $translate.instant('VISITSMESURESTATS.stat_visite_nb_views'),
            style: {
              color: "#edede"
            }
          },
          labels: {
            format: '{value}',
            style: {
              color: "#edede"
            }
          },
          showEmpty: false,
          crosshair: true

        },
        plotOptions: {
          series: {
            shadow: false,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              formatter: function () {
                return this.percentage.toFixed(2) + '%';
              }
            }
          }
        },
        tooltip: {
          shared: true,
          formatter: function () {
            var s = '<b>' + this.x + '</b>';

            $.each(this.points, function (i, point) {
              if (point.series.index === 0)
                s += '<br/><span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + point.y + '(' + (point.percentage.toFixed(2)) + '%)';
              else
                s += '<br/><span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + point.y;
            });

            return s;
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'buttom',
          y: 300,
          borderWidth: 0
        },
        credits: {
          enabled: true,
          text: 'powered by www.empreinte.com',
          href: 'https://www.empreinte.com'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        series: [
          {
            name: $translate.instant('VISITSMESURESTATS.stat_visits'),
            id: 'series1',
            data: [],
            color: color_visites
          }]
      };
    }

    function chart_continu() {
      return {
        chart: {
          zoomType: 'xy',
          marginBottom: 100
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          crosshair: true,
          type: '',
          title: {
            text: ''
          },

        },
        exporting: {
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }
            }
          },
        },
        plotOptions: {
          series: {
            lineWidth: 4,
            fillOpacity: 0.4

          }
        },
        yAxis: [
          { // Primary yAxis % de vue
            labels: {
              format: '{value}',
              style: {
                color: color_nombre_vue_par_visiteur
              }
            },
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_nombre_vue_par_visiteur'),
              style: {
                color: color_nombre_vue_par_visiteur
              }
            },
            showEmpty: false,
            crosshair: true

          }, { // Secondary yAxis Nombre de vue
            gridLineWidth: 0,
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_visite_nb_views'),
              style: {
                color: "#edede"
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: "#edede"
              }
            },
            showEmpty: false,
            crosshair: true

          }, { // Tertiary yAxis duree Total
            gridLineWidth: 0,
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_duree_tot'),
              style: {
                color: color_duree_total
              }
            },
            labels: {
              formatter: function () {
                return timeHelperService.secondsTimeSpanToHMS(this.value);
              },
              min: 0,
              style: {
                color: color_duree_total
              }
            },
            opposite: true,
            showEmpty: false,
            crosshair: true,
            duration :  true
          }, { // Tertiary yAxis duree Moyenne
            gridLineWidth: 0,
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_duree_moy'),
              style: {
                color: "#edede"
              }
            },
            labels: {
              formatter: function () {
                return timeHelperService.secondsTimeSpanToHMS(this.value);
              },
              style: {
                color: "#edede"
              }
            },
            opposite: true,
            showEmpty: false,
            crosshair: true,
            duration :  true
          }],
        tooltip: {
          shared: true,
          formatter: function () {
            var s = '<b>' + this.x + '</b>';

            $.each(this.points, function (i, point) {
              if (point.series.index === 0 || point.series.index === 1 || point.series.index === 2)
                s += '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + (point.y.toString().indexOf(":")===-1 ? timeHelperService.secondsTimeSpanToHMS(point.y) : point.y);
              else
                s += '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + point.y.toFixed(2);
            });

            return s;
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'buttom',
          y: 350,
          borderWidth: 0
        },
        credits: {
          enabled: true,
          text: 'powered by www.empreinte.com',
          href: 'https://www.empreinte.com'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        series: [
          {
            name: $translate.instant('VISITSMESURESTATS.stat_duree_tot'),
            type: 'areaspline',
            yAxis: 2,
            id: 'spline',
            data: [],
            color: 'rgba(245, 177, 89, 0.1)',
            duration :  true
          },
          {
            name: $translate.instant('VISITSMESURESTATS.stat_duree_moyenne_par_visiteur_unique'),
            type: 'areaspline',
            id: 'series4',
            yAxis: 3,
            data: [],
            color: 'rgba(31, 159, 232,0.7)',
            duration :  true
          }, {
            name: $translate.instant('VISITSMESURESTATS.stat_duree_moyenne_par_visite'),
            type: 'areaspline',
            yAxis: 3,
            id: 'series3',
            data: [],
            color: 'rgba(151, 192, 232,1)',
            duration :  true
          }]
      };
    }

    function chart_continu_mooc() {
        return {
        chart: {
          type: 'line'
        },
        title: {
          text: ""
        },
        credits: {
          enabled: false
        },
        xAxis: {
          categories: [],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: $translate.instant('MOOCSTATS.stat_number_learners')
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y} ' + $translate.instant('MOOCSTATS.stat_apprenants')
        },
        plotOptions: {
          column: {
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          },
          series: {
            fillOpacity: 0.1
          }
        },
        series: [{
          name: $translate.instant('MOOCSTATS.stat_number_active_learners'),
          data: [],
          color: '#F39C11'
        }, {
          name: $translate.instant('MOOCSTATS.stat_learners_watching_video'),
          data: [],
          color: '#3498db'
        }, {
          name: $translate.instant('MOOCSTATS.stat_learners_tried_problem'),
          data: [],
          color: '#EB4A40'
        }]
      };
    }

    function chart_continu_mooc_view() {
      return {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: ['vidéo 1', 'vidéo 2', 'vidéo 3', 'vidéo 4', 'vidéo 5', 'vidéo 6', 'vidéo 7', 'vidéo 8', 'vidéo 9', 'vidéo 10', 'vidéo 11'],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: 'nombre des vues'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        }, series: [{
          name: 'Incomplètes',
          data: [2, 2, 2, 2, 0, 0, 0, 0, 1, 0, 1],
          color: '#808080'
        }, {
          name: 'Complètes ',
          data: [5, 8, 9, 5, 7, 7, 2, 2, 10, 1, 14],
          color: '#0aa000'
        }]
      };
    }

    function chart_quiz_by_theme_mooc() {
      return {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: ['quiz 1', 'quiz 2', 'quiz 3', 'quiz 4', 'quiz 5', 'quiz 6', 'quiz 7', 'quiz 8', 'quiz 9', 'quiz 10', 'quiz 11'],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Nombre des réponses'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        }, series: [{
          name: 'Incorrectes',
          data: [2, 2, 2, 2, 0, 0, 0, 0, 1, 0, 1],
          color: '#808080'
        }, {
          name: 'Correcte ',
          data: [5, 8, 9, 5, 7, 7, 2, 2, 10, 1, 14],
          color: '#0aa000'
        }]
      };
    }

    function chart_view_by_voyage_mooc() {
      return {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: ['v 1', 'v 2', 'v 3', 'v 4', 'v 5', 'v 6', 'v 7', 'v 8', 'v 9', 'v 10', 'v 11'],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: 'Nombre de vue'
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        }, series: [
          {
            name: 'Nombre de vues ',
            data: [5, 8, 9, 5, 7, 7, 2, 2, 10, 1, 14],
            color: '#0aa000'
          }]
      };
    }

    function chart_expedition_by_voyage_mooc() {
      return {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ""
        },
        xAxis: {
          categories: ['v 1', 'v 2', 'v 3', 'v 4', 'v 5', 'v 6', 'v 7', 'v 8', 'v 9', 'v 10', 'v 11'],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Nombre de vidéos"
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        }, series: [
          {
            name: "Expédition",
            data: [5, 8, 9, 5, 7, 7, 2, 2, 10, 1, 14],
            color: '#0aa000'
          }]
      };
    }

    function chart_continu_audience() {
      return {
        chart: {
          zoomType: 'xy',
          marginBottom: 100
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        exporting: {
          allowHTML:true,
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }
            }
          },
        },
        xAxis: {
          categories: [],
          crosshair: true,
          type: '',
          title: {
            text: ''
          },
        },
        plotOptions: {
          series: {
            lineWidth: 4
          },
        },
        yAxis: [
          { // Primary yAxis % de vue
            labels: {
              format: '{value}',
              style: {
                color: color_nombre_vue_par_visiteur
              }
            },
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_nombre_vue_par_visiteur'),
              style: {
                color: color_nombre_vue_par_visiteur
              }
            },
            showEmpty: false,
            crosshair: true

          }, { // Secondary yAxis Nombre de vue
            gridLineWidth: 0,
            title: {
              text: $translate.instant('VISITSMESURESTATS.stat_visite_nb_views'),
              style: {
                color: "#edede"
              }
            },
            labels: {
              format: '{value}',
              style: {
                color: "#edede"
              }
            },
            showEmpty: false,
            crosshair: true

          }],
        tooltip: {
          shared: true,
          formatter: function () {
            var s = '<b>' + this.x + '</b>';
            $.each(this.points, function (i, point) {
              if (point.series.index !== 0 && point.series.index !== 1 && point.series.index !== 2)
                  s += '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + (point.y.toString().indexOf(":")===-1 ? timeHelperService.secondsTimeSpanToHMS(point.y) : point.y);
               else
                  s += '<span style="color:' + point.color + '">\u25CF</span> ' + point.series.name + ': ' + (Number.isInteger(point.y) ?  point.y: point.y.toFixed(2));
            });

            return s;
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'buttom',
          y: 350,
          borderWidth: 0
        },
        credits: {
          enabled: true,
          text: 'powered by www.empreinte.com',
          href: 'https://www.empreinte.com'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        series: [
          {
            name: $translate.instant('VISITSMESURESTATS.stat_nombre_vue_par_visiteur'),
            type: 'spline',
            yAxis: 0,
            id: 'series1',
            data: [],
            color: color_nombre_vue_par_visiteur,

          }, {
            name: $translate.instant('VISITSMESURESTATS.stat_visits'),
            type: 'spline',
            yAxis: 1,
            id: 'series5',
            data: [],
            color: color_visites

          },
          {
            name: $translate.instant('VISITSMESURESTATS.stat_uniq_visits'),
            type: 'spline',
            yAxis: 1,
            id: 'series6',
            data: [],
            color: color_visiteurs_uniques

          }]
      };
    }

    function chart_continu_mooc_performance() {
      return {
        chart: {
          type: 'column'
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: [],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: $translate.instant('MOOCSTATS.stat_performance_percent_response')
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/><br>' + $translate.instant('MOOCSTATS.stat_performance_percentage') + ': <b>{point.percentage:.1f} %</b><br>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'percent',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        },
        series: [{
          name: $translate.instant('MOOCSTATS.stat_performance_correct'),
          data: [],
          color: '#0aa000'
        }, {
          name: $translate.instant('MOOCSTATS.stat_performance_incorrect'),
          data: [],
          color: '#EB4A40'
        }]
      };
    }

    function chart_area() {
      return {
        chart: {
          type: 'area'
        },
        credits: {
          enabled: false
        },
        title: {
          text: 'Segments rejoués'
        },
        xAxis: {
          categories: ['0s-5s', '5s-10s', '10s-15s ', '15s-20s', '20s-25s', '25s-30s', '30s-35s', '35s-40s', '40s-45s'],
          type: '',
          title: {
            text: ''
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "le nombre d'événements de lecture."
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: 'bold',
              color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
          }
        },
        legend: {
          align: 'right',
          x: -30,
          verticalAlign: 'top',
          y: 25,
          floating: true,
          backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
          borderColor: '#CCC',
          borderWidth: 1,
          shadow: false
        },
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true,
              color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
          }
        }, series: [{
          name: 'le nombre de vues supplémentaires(replay)',
          data: [12, 22, 32, 12, 10, 20, 10, 10, 11],
          color: '#0084ff'
        }, {
          name: "le nombre d'utilisateurs uniques",
          data: [10, 14, 30, 5, 7, 14, 2, 2, 10],
          color: '#98c2e8'
        }]
      };
    }

    function chart_map() {
      return {
        chartType: 'map',
        chart: {
          borderWidth: 1,
          map: 'custom/world'
        },
        title: {
          text: ''
        },
        exporting: {
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }
            }
          },
        },
        legend: {
          enabled: false
        },
        mapNavigation: {
          enabled: true,
          buttonOptions: {
            width: 5,
            height: 5,
            padding: 5,
            style: {
              fontSize: '7px',
              textAlign: 'center'
            },
            theme: {
              fill: '#d3d3d3',
              'stroke-width': 1,
              r: 9,
              states: {
                hover: {
                  fill: "rgba(18, 97, 148, 0.54)"
                },
                select: {
                  stroke: "rgba(18, 97, 148, 0.54)",
                  fill: "rgba(18, 97, 148, 0.54)"
                }
              }
            },
            verticalAlign: 'top'
          }
        },
        credits: {
          enabled: true,
          text: 'powered by www.empreinte.com',
          href: 'https://www.empreinte.com'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        tooltip: {
          backgroundColor: 'none',
          borderWidth: 0,
          shadow: false,
          useHTML: true,
          padding: 0,
          formatter: function () {
            return '<b>Series name: ' + this.series.name + '</b><br>' +
              'Point name: ' + this.point.name + '<br>' +
              'Value: ' + this.point.value;
          },
          positioner: function () {
            return {x: 0, y: 250};
          }
        },
        colorAxis: {
          min: 1,
          max: 10000,
          type: 'logarithmic',
          minColor: '#B3E5FC',
          maxColor: '#0067AC'
        },
        series: [{
          name: 'visit',
          joinBy: ['iso-a2', 'code'],
          data: [],
          states: {
            hover: {
              color: '#FF7373'
            }
          }
        }]
      };
    }

    function chart_pie(type, title) {
      return {
        chart: {
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        colors: ['#058DC7', '#50B432', '#ED561B', '#DDDF00', '#24CBE5', '#64E572', '#FF9655', '#FFF263', '#6AF9C4'],
        title: {
          text: ''
        },
        exporting: {
          tableCaption: true,
          tableInfos: {},
          csv: {
            columnHeaderFormatter: function(item, key) {
              if (item) {
                if (item.userOptions && item.userOptions.title) {
                  return item.userOptions.title.text;
                }
                return item.name
              }else{
                return title
              }
            }
          },
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        tooltip: {
          formatter: function () {
            var s = '<b>' + this.series.name + '</b>';
            s += '<br/><span style="color:' + this.point.color + '">\u25CF</span> ' + this.point.name + ': ' + this.point.percentage.toFixed(2) + "%";
            return s;
          }
        },
        legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'top',
          x: -5,
          y: 10,
          borderWidth: 0
        },
        credits: {
          enabled: true,
          text: 'powered by www.empreinte.com',
          href: 'https://www.empreinte.com'
        },
        navigation: {
          buttonOptions: {
            enabled: false
          }
        },
        xAxis: {
          categories: [],
          crosshair: true,
          type: '',
          title: {
            text: ''
          },
        },
        series: [
          {
            name: '',
            id: 'series1',
            data: [],
            color: color_nombre_vue_par_visiteur,
            duration : type && type==='duration' ? true : false
          }
          ],
        func: function (chart) {
          self._chart = chart;
          if (!self.exportPng) {
            self.exportPng = function (chartTitle) {
              chart.exportChart({type: 'image/png', filename: chartTitle}, {title: {text: chartTitle}});
            };
          }
        }
      };
    }

    function getDataPie(series, categories, is_object) {
      var rows = [];
      var key_row = 0;
      angular.forEach(categories, function (value) {
        var y_value = series[key_row];

        if (!angular.isUndefined(is_object) && is_object) {
          y_value = y_value.y;
        }
        if (isNaN(y_value)) {
          y_value = 0;
        }

        rows.push({"name": value, "y": y_value});
        key_row++;

      });
      return rows;
    }

    function getSeriesName(series) {
      var rows = [];
      angular.forEach(series, function (value, key) {
        rows.push({val: key, option: value.name, options: value.name, duration : value.duration ? true : false});
      });
      return rows;
    }

    return {
      chart_discret: chart_discret,
      chart_continu: chart_continu,
      chart_continu_audience: chart_continu_audience,
      chart_continu_mooc: chart_continu_mooc,
      chart_continu_mooc_view: chart_continu_mooc_view,
      chart_continu_mooc_performance: chart_continu_mooc_performance,
      chart_area: chart_area,
      chart_discret_duree_par_visite: chart_discret_duree_par_visite,
      chart_quiz_by_theme_mooc: chart_quiz_by_theme_mooc,
      chart_view_by_voyage_mooc: chart_view_by_voyage_mooc,
      chart_expedition_by_voyage_mooc: chart_expedition_by_voyage_mooc,
      chart_map: chart_map,
      chart_pie: chart_pie,
      getDataPie: getDataPie,
      getSeriesName: getSeriesName,
      ddd: self.exportPng,
      _chart: self.__chart

    };

  }
}(Highcharts));

(function () {
    'use strict';

    angular
        .module('app.stats.graphe')
        .factory('StatsFiltreQuery', StatsFiltreQuery);

    /** @ngInject */
    function StatsFiltreQuery($filter) {

        function filtre_query(self_input_query, input_query) {
            var query = angular.copy(input_query);
            if (!angular.isUndefined(query.dateIn)) {
                query.dateIn = new Date(query.dateIn).getTime();
            }
            if (!angular.isUndefined(query.dateOut)) {
                query.dateOut = new Date(query.dateOut).getTime();
            }

            if (!angular.isUndefined(query.startDate)) {
              query.startDate = new Date(query.startDate).getTime();
            }
            if (!angular.isUndefined(query.endDate)) {
              query.endDate = new Date(query.endDate).getTime();
            }

          var foundItem = $filter('filter')(self_input_query, query, true);
            var result_input_query = {};
            angular.forEach(foundItem, function(value) {
                if(angular.isUndefined(input_query.vod_id) && angular.isUndefined(value.vod_id) )
                    result_input_query = value;
                else
                {
                    if(angular.isDefined(input_query.vod_id) && angular.isDefined(value.vod_id) )
                        result_input_query = value;
                }
            });

            var index_of_query = self_input_query.indexOf(result_input_query);
            return {index: index_of_query, query: query}

        }

        return {
            filtre_query: filtre_query

        };

    }
}());

(function () {
    'use strict';

    angular
        .module('app.specifics.direction.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.specifics_direction_edit', {
                url: "/specifics/direction/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/specifics/direction/add_edit_view/add_edit.template.html',
                        controller: 'specificsDirectionEditController as vm'
                    }
                },
                resolve: {
                    specificsDirectionData: function (msApi, $stateParams) {
                        return msApi.resolve('specifics_direction.getDirection@get', {id: $stateParams.id});
                    },
                    specificsDirectionNames: function (msApi) {
                        return msApi.resolve('direction.getDirectionsNames@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "specifics_directions_post_edit_action"
            });


        // API
        msApiProvider.register('specifics_direction.editDirection', [Routing.generate('api_direction_post_edit_direction', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.direction.edit')
    .controller('specificsDirectionEditController', specificsDirectionEditController);

  /** @ngInject */
  function specificsDirectionEditController(webTvGlobal, specificsDirectionData, specificsDirectionNames, $rootScope, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var direction = specificsDirectionData;
    vm.empSpecificsDirectionForm = {};
    vm.submitAddDirectionForm = submitAddDirectionForm;
    fillData();
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_direction_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_direction_edit_pagetitle";
      $rootScope.pageRoute = "app.specifics_direction_list";

      $rootScope.welcome = "welcome_direction_edit";
      $rootScope.text = [{
        texte: "parameters_direction_add_help"
      }, {
        texte: "send_button_direction_edit_help"
      }, {
        texte: "cancel_button_direction_add_help"
      }];

    }

    vm.visibilityChoices = convertDirectionIdToSelectList({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });
    vm.directionChoices = webTvGlobal.convertToSelectChoicesFormat(specificsDirectionNames.names);

    /**
     * Check if direction exists
     * @return if exists get Direction Data else redirect to 404 page
     */

    function fillData() {
      if (direction.visible === true) {
        direction.visible = 1;
      }
      if (direction.visible === false) {
        direction.visible = 0;
      }
      if (angular.isDefined(direction.code) && direction.code !== 200) $state.go('app.error_404');
      else {
        if (direction.parent !== null) {
          vm.empSpecificsDirectionForm = {
            parent: direction.parent.id,
            title: direction.title,
            visible: direction.visible
          };
        }
        else {
          vm.empSpecificsDirectionForm = {
            title: direction.title,
            visible: direction.visible
          };
        }

        $rootScope.itemName = direction.title || '';
      }
    }


    /**
     * Convert List To Select Option format
     */
    function convertDirectionIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Direction Form
     */
    function submitAddDirectionForm() {
      $rootScope.loadingProgress = true;
      msApi.request('specifics_direction.editDirection@save',
        {id: direction.id, "empDirectionForm": angular.copy(vm.empSpecificsDirectionForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            direction = vm.empSpecificsDirectionForm;
            webTvGlobal.$flashMessages().set('specificsDirectionEdit', direction);
            $state.go('app.specifics_direction_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );


    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.specifics.direction.list', ["datatables"])
        .config(config);

   

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.specifics_direction_list', {
                url: "/specifics/direction/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/specifics/direction/list/list.template.html',
                        controller: 'specificsDirectionListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "specifics_directions_list_dtable_direction"              
            });

        // Api
        var deleteDirectionRoute = Routing.generate('api_direction_delete_direction') + "/:id";
        msApiProvider.register('specifics_direction.list', [Routing.generate('api_dtable_list_dtable_direction')]);
        msApiProvider.register('specifics_direction.mdelete', [deleteDirectionRoute, {id: '@id'}]);
        var deleteListDirections = Routing.generate('api_multi_delete_multi_directions') + "/:list";
        msApiProvider.register('specifics_direction.deleteDirections', [deleteListDirections, {list: '@list'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics.direction.list')
        .controller('specificsDirectionListController', specificsDirectionListController);

    /** @ngInject */
    function specificsDirectionListController(webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $scope, $cookies, $injector, dtable_language, dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.specifics_direction_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.specifics_direction_list_pagetitle";

            $rootScope.welcome = "welcome_direction";
            $rootScope.text = [{
                texte: "add_button_direction_help"
            }, {
                texte: "arrow_button_direction_help"
            }, {
                texte: "search_area_direction_help"
            }, {
                texte: "tri_column_direction_help"
            },
                {
                    texte: "edit_button_direction_help"
                }, {
                    texte: "detail_button_direction_help"
                },
                {
                    texte: "delete_button_direction_help"
                }];

        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        //vm.partentIdPlaceHolder="STATIONADD.form_placeholder_parentId";
        //vm.stations=specificsStationListData.data.stations;
        //Data Table options
        vm.directions = [];
        vm.selectedDirections = [];
        var selectedDirections = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.directionsDataTable = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: 2,
                    filterable: true,
                    sortable: true,
                    width: '80px'
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchDirectionsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('specifics_direction.list@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.directions = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.directions = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedDirections = [];
            selectedDirections = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_directions,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchDirectionsInAPI(filtre);
        }

        function searchDirections() {
            filtre["search[value]"] = vm.search_directions;
            searchDirectionsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.directionsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.directionsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.directionsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.directionsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'DIRECTIONLIST.detail_direction'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showDirectionDetail(vm.directionsDataTable[' + data.id + '],$event)" aria-label="detail_direction"translate translate-attr-aria-label="DIRECTIONLIST.detail_direction" has-permission="specifics_directions_get_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'DIRECTIONLIST.update_direction'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.specifics_direction_edit({id: ' + data.id + '})" aria-label="update_direction" translate translate-attr-aria-label="DIRECTIONLIST.update_direction" has-permission="specifics_directions_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'DIRECTIONLIST.delete_direction'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteDirectionConfirm(vm.directionsDataTable[' + data.id + '],ev)" aria-label="delete_direction" translate translate-attr-aria-label="DIRECTIONLIST.delete_direction" has-permission="specifics_directions_delete_direction">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button>' +
                        '</a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchDirections = searchDirections;
        vm.deleteDirectionConfirm = deleteDirectionConfirm;
        vm.deleteSelectedDirectionsConfirm = deleteSelectedDirectionsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showDirectionDetail = showDirectionDetail;
        vm.addNewDirection = addNewDirection;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('specificsDirectionAdd', $translate.instant('DIRECTIONLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('specificsDirectionEdit', $translate.instant('DIRECTIONLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param direction
         */
        function toggle(direction) {
            getElement();
            direction.checked = !direction.checked;
            var idx = selectedDirections.indexOf(direction);
            if (idx > -1) {
                selectedDirections.splice(idx, 1);
            }
            else {
                selectedDirections.push(direction);
            }
            vm.selectedDirections = angular.copy(selectedDirections);
        }


        function toggleAll() {
            getElement();
            if (selectedDirections.length === vm.directions.length) {
                vm.selectedDirections = [];
            }

            else if ((selectedDirections.length === 0) || (selectedDirections.length > 0)) {
                vm.selectedDirections = vm.directions.slice(0);
            }
            selectedDirections = angular.copy(vm.selectedDirections);
            var list_directions = angular.copy(vm.directionsDataTable);
            angular.forEach(list_directions, function (value, key) {
                if (value !== undefined)
                    vm.directionsDataTable[key].checked = selectedDirections.length > 0;
            });
        }

        /**
         * Show DirectionDetails
         * @param direction
         */
        function showDirectionDetail(direction, ev) {
            $rootScope.userManager.statsAccesAction("specifics_directions_get_detail_action")
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('specifics_direction.getDirection@get', {id: direction.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {specificsDirectionData: response},
                            templateUrl: 'app/main/specifics/direction/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'specificsDirectionDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchDirectionsInAPI(filtre), true);
        }


        /**
         * redirection to add new direction page
         * @param event
         */
        function addNewDirection() {
            clearFlashMessage();
            $state.go('app.specifics_direction_add');
        }

        /**
         * Delete DirectionConfirm Dialog
         */
        function deleteDirectionConfirm(Direction, ev) {
            $rootScope.userManager.statsAccesAction("specifics_directions_delete_direction_action")
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "DIRECTIONLIST.dialog_will_be_deleted_direction",
                "DIRECTIONLIST.delete_direction_msg",
                "DIRECTIONLIST.delete_direction_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['DIRECTIONLIST.delete_direction_msg'])
                        .htmlContent('<b>' + Direction.title + '</b>' + translatedValues['DIRECTIONLIST.dialog_will_be_deleted_direction'])
                        .ariaLabel(translatedValues['DIRECTIONLIST.delete_direction_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteDirection(Direction);
                        vm.selectedDirections = [];
                        selectedDirections = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete Direction
         */
        function deleteDirection(Direction) {
            clearFlashMessage();
            if (vm.directions.indexOf(Direction) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('specifics_direction.mdelete@delete', {id: Direction.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "DIRECTIONLIST.dialog_alert_delete_title",
                                "DIRECTIONLIST.dialog_alert_delete_description",
                                "DIRECTIONLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['DIRECTIONLIST.dialog_alert_delete_title'],
                                        textContent: Direction.title + translatedValues['DIRECTIONLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['DIRECTIONLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.directions.splice(vm.directions.indexOf(Direction), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "DIRECTIONLIST.dialog_alert_delete_error_title",
                                "DIRECTIONLIST.dialog_alert_delete_error_description",
                                "DIRECTIONLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['DIRECTIONLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['DIRECTIONLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['DIRECTIONLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                                webTvGlobal.alertDialog(message);
                            }), function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            };
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        function deleteSelectedDirectionsConfirm(ev) {
            $rootScope.userManager.statsAccesAction("specifics_directions_delete_multi_action")
            var title;
            var ariaLabel;
            if (vm.selectedDirections.length!== 0) {
                if(vm.selectedDirections.length === 1){
                    title = 'DIRECTIONLIST.delete_direction_msg';
                    ariaLabel = 'DIRECTIONLIST.delete_direction_aria_label';
                }else{
                    title = 'DIRECTIONLIST.delete_list_directions_msg';
                    ariaLabel = 'DIRECTIONLIST.delete_directions_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedDirections.length,title,ariaLabel)).then(function () {
                    deleteSelectedDirections(ev);
                });

            }

        }

        /* delete selected groups*/
        function deleteSelectedDirections(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('specifics_direction.deleteDirections@delete', {
                    list: (function (list) {
                        vm.selectedDirections.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("DIRECTIONLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("DIRECTIONLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('DIRECTIONLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedDirections = [];
                        selectedDirections = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('DIRECTIONLIST.dialog_alert_delete_error_title'),
                            $translate.instant('DIRECTIONLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedDirections = [];
                        selectedDirections = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedDirections = [];
                    selectedDirections = [];
                    vm.modelCheckAll = false;

                }
            );


        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.specifics.iptv.edit',["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.specifics_iptv_edit', {
                url    : "/specifics/iptv/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/specifics/iptv/add_edit_view/add_edit.template.html',
                        controller : 'specificsIptvEditController as vm'
                    }
                },
                resolve: {
                     specificsIptvData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('specifics_iptv.getIptv@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission":"specifics_iptv_get_detail_action"
            });


        // API
        msApiProvider.register('specifics_iptv.getIptv', [Routing.generate('api_specifics_get_detail_iptv',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('specifics_iptv.editIptv', [Routing.generate('api_specifics_post_edit_iptv',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}])
        
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.iptv.edit')
    .controller('specificsIptvEditController', specificsIptvEditController);

  /** @ngInject */
  function specificsIptvEditController(webTvGlobal,$cookies, $translate, msApi, $rootScope, $state, specificsIptvData, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_iptv_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_iptv_edit_pagetitle";
      $rootScope.pageRoute = "app.specifics_iptv_list";

      $rootScope.welcome = "welcome_iptv_edit";
      $rootScope.text = [{
        texte: "parameters_iptv_add_help"
      }, {
        texte: "send_button_iptv_edit_help"
      }, {
        texte: "cancel_button_iptv_add_help"
      }];
    }

    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    vm.visibilityChoices = convertIptvIdToSelectList({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });
    vm.iptv = specificsIptvData;
    vm.empSpecificsIptvForm = {};
    var empSpecificsIptvError = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_specifics_post_iptv_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      attributes: 'image/*',
      testMethod: false,
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    vm.submitAddIptvForm = submitAddIptvForm;
    // vm.submitAddIptvForm = convertIptvIdToSelectList;
    fillData();
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    var validImage;

    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        validImage = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }

      validImage = true;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empSpecificsIptvForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empSpecificsIptvForm.image =  res.location.path;
        vm.is_image_not_pristine = true;
      }
      vm.urlVignette = res.location.url;
      vm.iptv.image =vm.urlVignette;
    }

    function uploadComplete() {
      if (validImage) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empSpecificsIptvForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
      }
    }

    /**
     * Check if iptv exists
     * @return if exists get IP-TV Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.iptv.code) && vm.iptv.code !== 200) $state.go('app.error_404');
      else {

        vm.empSpecificsIptvForm = {
          name: vm.iptv.name,
          description: vm.iptv.description,
          visible: (vm.iptv.visible === 1) ? 1 : 0,
          linkUrl: vm.iptv.linkUrl,
          image: vm.iptv.image || ""
        };
        $rootScope.itemName = vm.iptv.name || '';
      }
    }


    /**
     * Convert List To Select Option format
     */
    function convertIptvIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add IP-TV Form
     */
    console.log("jhfjfsdjjhsdf546564879",vm.iptv);
    function submitAddIptvForm() {
      $rootScope.loadingProgress = true;
      msApi.request('specifics_iptv.editIptv@save',
        {id: vm.iptv.id, "empSpecificsIptvForm": angular.copy(vm.empSpecificsIptvForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.iptv = vm.empSpecificsIptvForm;
            webTvGlobal.$flashMessages().set('specificsIptvEdit', vm.iptv);
            $state.go('app.specifics_iptv_list');
          }
          else if (angular.isDefined(res.errors)) {
            vm.errors = res.errors;
            empSpecificsIptvError = [];
            vm.errors.forEach(function (item) {
              empSpecificsIptvError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empSpecificsIptvForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.specifics.direction.list')
        .controller('specificsDirectionDetailController', specificsDirectionDetailController);

    /** @ngInject */
    function specificsDirectionDetailController(specificsDirectionData, $mdDialog) {
        var vm = this;
        vm.direction = specificsDirectionData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }

    }


})();

(function () {
    'use strict';

    angular
        .module('app.specifics.iptv.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.specifics_iptv_list', {
                url: "/specifics/iptv/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/specifics/iptv/list/list.template.html',
                        controller: 'specificsIptvListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "specifics_iptv_list_dtable_action"
            });
        // Api
        var deleteIptvRoute = Routing.generate('api_specifics_delete_iptv') + "/:id";
        msApiProvider.register('specifics_iptv.list', [Routing.generate('api_specifics_get_iptvs')]);
        msApiProvider.register('specifics_iptv.mdelete', [deleteIptvRoute, {id: '@id'}]);
        msApiProvider.register('specifics_iptv.modalGetIptv', [Routing.generate('api_specifics_get_detail_iptv', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('specifics_iptv.list_data_table', [Routing.generate('api_dtable_list_dtable_specifics_iptvs')]);
        var deleteListIpTvs = Routing.generate('api_multi_delete_multi_specifics_iptvs') + "/:list";
        msApiProvider.register('specifics_iptv.deleteIpTvs', [deleteListIpTvs, {list: '@list'}]);

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.specifics.iptv.list')
        .controller('specificsIptvDetailController', specificsIptvDetailController);

    /** @ngInject */
    function specificsIptvDetailController(specificsIptvData,$mdDialog)
    {
    	var vm = this;
        vm.iptv = specificsIptvData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }



    }



})();

(function () {
    'use strict';

    angular
        .module('app.specifics.direction.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.specifics_direction_add', {
                url: "/specifics/direction/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/specifics/direction/add_edit_view/add_edit.template.html',
                        controller: 'specificsDirectionAddController as vm'
                    }
                },
                resolve: {
                    specificsDirectionData: function (msApi) {
                        return msApi.resolve('specifics_direction.getDirection@get', {id: 0});
                    },
                    specificsDirectionNames: function (msApi) {
                        return msApi.resolve('direction.getDirectionsNames@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "specifics_directions_post_add_action"
            });

        //API
        msApiProvider.register('specifics_direction.addDirection', [Routing.generate('api_direction_post_add_direction')]);

    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.direction.add')
    .controller('specificsDirectionAddController', specificsDirectionAddController);

  /** @ngInject */
  function specificsDirectionAddController(specificsDirectionData, webTvGlobal, specificsDirectionNames, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_direction_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_direction_add_menuTitle";
      $rootScope.pageRoute = "app.specifics_direction_list";

      $rootScope.welcome = "welcome_direction_add";
      $rootScope.text = [{
        texte: "parameters_direction_add_help"
      }, {
        texte: "send_button_direction_add_help"
      }, {
        texte: "cancel_button_direction_add_help"
      }];

    }

    var vm = this;
    vm.isNew = true;
    vm.directionChoices = webTvGlobal.convertToSelectChoicesFormat(specificsDirectionNames.names);
    var direction = specificsDirectionData;
    vm.empSpecificsDirectionForm = {
      title: direction.title


    };
    vm.visibilityChoices = convertDirectionIdToSelectList({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });
    vm.submitAddDirectionForm = submitAddDirectionForm;


    /**
     * Convert List To Select Option format
     */
    function convertDirectionIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Direction Form
     */
    function submitAddDirectionForm() {
      $rootScope.loadingProgress = true;
      msApi.request('specifics_direction.addDirection@save',
        {"empDirectionForm": angular.copy(vm.empSpecificsDirectionForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            direction = vm.empSpecificsDirectionForm;
            webTvGlobal.$flashMessages().set('specificsDirectionAdd', {title: vm.empSpecificsDirectionForm.title ? vm.empSpecificsDirectionForm.title : ""});
            $state.go('app.specifics_direction_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.specifics.iptv.list')
        .controller('specificsIptvListController', specificsIptvListController);

    /** @ngInject */
    function specificsIptvListController(DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $cookies, $scope, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.specifics_iptv_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.specifics_iptv_list_pagetitle";

            $rootScope.welcome = "welcome_iptv";
            $rootScope.text = [{
                texte: "add_button_iptv_help"
            }, {
                texte: "arrow_button_iptv_help"
            }, {
                texte: "search_area_iptv_help"
            }, {
                texte: "tri_column_iptv_help"
            },
                {
                    texte: "edit_button_iptv_help"
                }, {
                    texte: "detail_button_iptv_help"
                },
                {
                    texte: "delete_button_iptv_help"
                }];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.iptvs = [];
        vm.selectedIptvs = [];
        var selectedIptvs = [];
        var checkedSelected = false;
        vm.ipTvDataTable = {};
        vm.dtInstance = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the image column
                    targets: 2,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    targets: 4
                },
                {
                    // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchIpTvInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('specifics_iptv.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.iptvs = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else if (angular.isDefined(response.errors)) {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.iptvs = [];

                        var errors = response.errors;
                        errors.forEach(function (item) {
                            $translate('VALIDATION.' + item.messages[0]).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });


                        });
                        vm.fnCallback(records);
                    }
                    else {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.iptvs = [];

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.iptvs = [];
                    vm.fnCallback(records);
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedIptvs = [];
            selectedIptvs = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_iptvs,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchIpTvInAPI(filtre);
        }

        function searchIpTvs() {
            filtre["search[value]"] = vm.search_iptvs;
            searchIpTvInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipTvDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.ipTvDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.ipTvDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : ""
            }),
            DTColumnBuilder.newColumn("image")
                .renderWith(function (data) {


                    var serverHtml = "";
                    if (data === null || data === "" || data === false || data === 'not_found') {
                        serverHtml += '<div style="position: relative;max-width: 100px;max-height: 56px;">' +
                            '<md-icon md-font-icon="icon-no-image-custom" class="s48" style="opacity: .6;position: absolute;top: 0;bottom: 0;right: 0;left: 0;"></md-icon>' +
                            '</div>';
                    }
                    else {
                        serverHtml +=
                            '<img width="100" height="100" class="product-image" ng-src="' + data + '"/></img>';
                    }
                    return serverHtml;
                }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : ""
            }),
            DTColumnBuilder.newColumn('visible').renderWith(function (data) {
                var serverHtml = "";
                if (data === null) {
                    serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                }
                else {
                    if (data) {
                        serverHtml += '<i class="icon-checkbox-marked-circle green-500-fg"><span class="hide">1</span></i>';
                    }
                    else {
                        serverHtml += '<i class="icon-cancel red-500-fg"><span class="hide">0</span></i>';
                    }
                }

                return serverHtml;
            }),
            DTColumnBuilder.newColumn('description').renderWith(function (data) {
                return angular.isDefined(data) ? data : ""
            }),
            DTColumnBuilder.newColumn('linkUrl').renderWith(function (data) {
                return angular.isDefined(data) ? data : ""
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipTvDataTable[data.id] = data;
                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showIptvDetail(vm.ipTvDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail" has-permission="specifics_iptv_get_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.specifics_iptv_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" has-permission="specifics_iptv_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteIptvConfirm(vm.ipTvDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete" has-permission="specifics_iptv_delete_iptv">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })
        ]
        ;

        function deleteSelectedIpTvsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedIptvs.length!== 0) {
                if(vm.selectedIptvs.length === 1){
                    title = 'IPTVLIST.delete_iptv_msg';
                    ariaLabel = 'IPTVLIST.delete_iptv_aria_label';
                }else{
                    title = 'IPTVLIST.delete_list_iptv_msg';
                    ariaLabel = 'IPTVLIST.delete_iptvs_aria_label';
                }
                $rootScope.userManager.statsAccesAction("specifics_iptv_delete_multi_action")
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedIptvs.length,title,ariaLabel)).then(function () {
                    deleteSelectedIpTvs(ev);
                });

            }

        }

        /* delete selected groups*/
        function deleteSelectedIpTvs(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('specifics_iptv.deleteIpTvs@delete', {
                    list: (function (list) {
                        vm.selectedIptvs.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("IPTVLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("IPTVLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('IPTVLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedIptvs = [];
                        selectedIptvs = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('IPTVLIST.dialog_alert_delete_error_title'),
                            $translate.instant('IPTVLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedIptvs = [];
                        selectedIptvs = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedIptvs = [];
                    selectedIptvs = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        vm.deleteSelectedIpTvsConfirm = deleteSelectedIpTvsConfirm;
        vm.searchIpTvs = searchIpTvs;
        vm.deleteIptvConfirm = deleteIptvConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showIptvDetail = showIptvDetail;
        vm.addNewIptv = addNewIptv;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        showFlasMessageToast('specificsIptvAdd', $translate.instant('IPTVLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('specificsIptvEdit', $translate.instant('IPTVLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param iptv
         */
        function toggle(iptv) {
            getElement();
            iptv.checked = !iptv.checked;
            var idx = selectedIptvs.indexOf(iptv);
            if (idx > -1) {
                selectedIptvs.splice(idx, 1);
            }
            else {
                selectedIptvs.push(iptv);
            }
            vm.selectedIptvs = angular.copy(selectedIptvs);
        }

        function toggleAll() {
            getElement();
            if (selectedIptvs.length === vm.iptvs.length) {
                vm.selectedIptvs = [];
            }

            else if ((selectedIptvs.length === 0) || (selectedIptvs.length > 0)) {
                vm.selectedIptvs = vm.iptvs.slice(0);
            }
            selectedIptvs = angular.copy(vm.selectedIptvs);
            var list_iptvs = angular.copy(vm.ipTvDataTable);
            angular.forEach(list_iptvs, function (value, key) {
                if (value !== undefined)
                    vm.ipTvDataTable[key].checked = selectedIptvs.length > 0;
            });
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Show IP-TV Details
         * @param iptv
         * @param ev
         */
        function showIptvDetail(iptv, ev) {
            // "actionPermission":"specifics_iptv_get_detail_action"
            $rootScope.userManager.statsAccesAction("specifics_iptv_get_detail_action")
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('specifics_iptv.modalGetIptv@get', {id: iptv.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {specificsIptvData: response},
                            templateUrl: 'app/main/specifics/iptv/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'specificsIptvDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchIpTvInAPI(filtre), true);
        }


        /**
         * redirection to add new iptv page
         * @param event
         */
        function addNewIptv() {
            clearFlashMessage();
            $state.go('app.specifics_iptv_add');
        }

        /**
         * Delete IP-TV Confirm Dialog
         */
        function deleteIptvConfirm(Iptv, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "IPTVLIST.delete_iptv_msg",
                "IPTVLIST.delete_iptv_aria_label"
            ])
                .then(function (translatedValues) {
                   console.log(Iptv,ev,"action");
                   if(Iptv)
                   {
                    $rootScope.userManager.statsAccesAction("specifics_iptv_delete_iptv_action")
                   }
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['IPTVLIST.delete_iptv_msg'])
                        .htmlContent('<b>' + Iptv.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['IPTVLIST.delete_iptv_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {
                       
                        deleteIptv(Iptv);
                        vm.selectedIptvs = [];
                        selectedIptvs = [];
                    }, function () {

                    });
                });


        }

        /**
         * Delete IP-TV
         */
        function deleteIptv(Iptv) {
            clearFlashMessage();
            if (vm.iptvs.indexOf(Iptv) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('specifics_iptv.mdelete@delete', {id: Iptv.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "IPTVLIST.dialog_alert_delete_title",
                                "IPTVLIST.dialog_alert_delete_description",
                                "IPTVLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['IPTVLIST.dialog_alert_delete_title'],
                                        textContent: Iptv.name + translatedValues['IPTVLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['IPTVLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.iptvs.splice(vm.iptvs.indexOf(Iptv), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "IPTVLIST.dialog_alert_delete_error_title",
                                "IPTVLIST.dialog_alert_delete_error_description",
                                "IPTVLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['IPTVLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['IPTVLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['IPTVLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.specifics.iptv.add', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.specifics_iptv_add', {
                url    : "/specifics/iptv/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/specifics/iptv/add_edit_view/add_edit.template.html',
                        controller : 'specificsIptvAddController as vm'
                    }
                },
                resolve: {
                     specificsIptvData: function (msApi)
                    {
                        return msApi.resolve('specifics_iptv.getNewIptvData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "specifics_iptv_post_add_action"
            });
        //API
        msApiProvider.register('specifics_iptv.getNewIptvData', [Routing.generate('api_specifics_get_detail_iptv',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('specifics_iptv.addIptv', [Routing.generate('api_specifics_post_add_iptv')]);
        
        
    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.iptv.add')
    .controller('specificsIptvAddController', specificsIptvAddController);

  /** @ngInject */
  function specificsIptvAddController($translate,$cookies, msApi, $rootScope, $state, specificsIptvData, webTvGlobal, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_iptv_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_iptv_add_menuTitle";
      $rootScope.pageRoute = "app.specifics_iptv_list";

      $rootScope.welcome = "welcome_iptv_add";
      $rootScope.text = [{
        texte: "parameters_iptv_add_help"
      }, {
        texte: "send_button_iptv_add_help"
      }, {
        texte: "cancel_button_iptv_add_help"
      }];
    }

    var vm = this;
    vm.isNew = true;
    var validImage ;
    var urlVignette = "";
    var errors = [];
    var empSpecificsIptvError = [];
    vm.visibilityChoices = convertIptvIdToSelectList({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });

    vm.iptv = specificsIptvData;
    vm.empSpecificsIptvForm = {

      name: vm.iptv.name,
      description: vm.iptv.description,
      visible: vm.iptv.visible ? 1 : 0,
      linkUrl: vm.iptv.linkUrl,
      image: vm.iptv.image || ""
    };
    vm.submitAddIptvForm = submitAddIptvForm;

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.ngFlowOptions = {
      allowDuplicateUploads: true,
      target: Routing.generate('api_specifics_post_iptv_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      attributes: 'image/*',
      testMethod: false,
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;


    /**
     * Convert List To Select Option format
     */
    function convertIptvIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add IP-TV Form
     */
    function submitAddIptvForm() {
      var formData = angular.copy(vm.empSpecificsIptvForm);
      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      $rootScope.loadingProgress = true;
      msApi.request('specifics_iptv.addIptv@save',
        {"empSpecificsIptvForm": angular.copy(vm.empSpecificsIptvForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.iptv = vm.empSpecificsIptvForm;
            webTvGlobal.$flashMessages().set('specificsIptvAdd', {title: vm.empSpecificsIptvForm.name ? vm.empSpecificsIptvForm.name : ""});
            $state.go('app.specifics_iptv_list');
          }
          else if (angular.isDefined(res.errors)) {
            errors = res.errors;
            empSpecificsIptvError = [];
            errors.forEach(function (item) {
              empSpecificsIptvError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empSpecificsIptvForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        validImage = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }

      validImage = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empSpecificsIptvForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      //vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empSpecificsIptvForm.image = res.location.path;
        vm.is_image_not_pristine = true;
      }
      urlVignette = res.location.url;
      vm.iptv.image=urlVignette;
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (validImage) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empSpecificsIptvForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: validImage}), '', function () {
          vm.empParametersThemeForm.logo = "";
        });
      }
    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.specifics.station.list', ["datatables"])
        .config(config);

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.specifics_station_list', {
                url: "/specifics/station/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/specifics/station/list/list.template.html',
                        controller: 'specificsStationListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" :"specifics_stations_list_dtable_action"
            });

        // Api
        var deleteStationRoute = Routing.generate('api_specifics_delete_station') + "/:id";
        msApiProvider.register('specifics_station.list', [Routing.generate('api_dtable_list_dtable_specifics_stations')]);
        msApiProvider.register('specifics_station.mdelete', [deleteStationRoute, {id: '@id'}]);
        msApiProvider.register('specifics_station.modalGetStation', [Routing.generate('api_specifics_get_detail_station', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteListStations = Routing.generate('api_multi_delete_multi_specifics_stations') + "/:list";
        msApiProvider.register('specifics_station.deleteStations', [deleteListStations, {list: '@list'}]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics.station.list')
        .controller('specificsStationListController', specificsStationListController);

    /** @ngInject */
    function specificsStationListController(webTvGlobal, DTOptionsBuilder, $cookies, DTColumnBuilder, $scope, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.specifics_station_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.specifics_station_list_pagetitle";

            $rootScope.welcome = "welcome_station";
            $rootScope.text = [{
                texte: "add_button_station_help"
            }, {
                texte: "arrow_button_station_help"
            }, {
                texte: "search_area_station_help"
            }, {
                texte: "tri_column_station_help"
            },
                {
                    texte: "edit_button_station_help"
                }, {
                    texte: "detail_button_station_help"
                },
                {
                    texte: "delete_button_station_help"
                }];

        }

        //Data Table options
        vm.stations = [];
        vm.selectedStations = [];
        var selectedStations = [];
        vm.dtInstance = {};
        vm.stationsDataTable = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: 2,
                    filterable: true,
                    sortable: true,
                    width: '80px'
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchStationsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('specifics_station.list@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.stations = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.stations = response.data;
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedstations = [];
            selectedStations = [];
            vm.checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_stations,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchStationsInAPI(filtre);
        }

        function searchStations() {
            filtre["search[value]"] = vm.search_stations;
            searchStationsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.stationsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.stationsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.stationsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('ip').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('domain').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('intranetStreamFr').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('intranetStreamEn').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('intranetStreamEs').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('intranetStreamOr').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('description').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.stationsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'STATIONLIST.detail_station'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showStationDetail(vm.stationsDataTable[' + data.id + '],$event)" aria-label="detail_station"translate translate-attr-aria-label="STATIONLIST.detail_station" has-permission="specifics_stations_get_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'STATIONLIST.update_station'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.specifics_station_edit({id: ' + data.id + '})" aria-label="update_station" translate translate-attr-aria-label="STATIONLIST.update_station" has-permission="specifics_stations_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'STATIONLIST.delete_station'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteStationConfirm(vm.stationsDataTable[' + data.id + '],ev)" aria-label="delete_station" translate translate-attr-aria-label="STATIONLIST.delete_station" has-permission="specifics_stations_delete_station">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchStations = searchStations;
        vm.deleteStationConfirm = deleteStationConfirm;
        vm.deleteSelectedStationsConfirm = deleteSelectedStationsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showStationDetail = showStationDetail;
        vm.addNewStation = addNewStation;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        showFlasMessageToast('specificsStationAdd', $translate.instant('STATIONLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('specificsStationEdit', $translate.instant('STATIONLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param station
         */
        function toggle(station) {
            getElement();
            station.checked = !station.checked;
            var idx = selectedStations.indexOf(station);
            if (idx > -1) {
                selectedStations.splice(idx, 1);
            }
            else {
                selectedStations.push(station);
            }
            vm.selectedStations = angular.copy(selectedStations);
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }


        function toggleAll() {
            getElement();
            if (selectedStations.length === vm.stations.length) {
                vm.selectedStations = [];
            }

            else if ((selectedStations.length === 0) || (selectedStations.length > 0)) {
                vm.selectedStations = vm.stations.slice(0);
            }
            selectedStations = angular.copy(vm.selectedStations);
            var list_stations = angular.copy(vm.stationsDataTable);
            angular.forEach(list_stations, function (value, key) {
                if (value !== undefined)
                    vm.stationsDataTable[key].checked = selectedStations.length > 0;
            });
        }

        /**
         * Show StationDetails
         * @param station
         */
        function showStationDetail(station, ev) {
            $rootScope.userManager.statsAccesAction("specifics_stations_get_detail_action")
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('specifics_station.modalGetStation@get', {id: station.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {specificsStationData: response},
                            templateUrl: 'app/main/specifics/station/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'specificsStationDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchStationsInAPI(filtre), true);
        }


        /**
         * redirection to add new station page
         * @param event
         */
        function addNewStation() {
            clearFlashMessage();
            $state.go('app.specifics_station_add');
        }

        /**
         * Delete StationConfirm Dialog
         */
        function deleteStationConfirm(Station, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "STATIONLIST.dialog_will_be_deleted_station",
                "STATIONLIST.delete_station_msg",
                "STATIONLIST.delete_station_aria_label"
            ])
                .then(function (translatedValues) {
                    $rootScope.userManager.statsAccesAction("specifics_stations_delete_station_action")
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['STATIONLIST.delete_station_msg'])
                        .htmlContent('<b>' + Station.name + '</b>' + translatedValues['STATIONLIST.dialog_will_be_deleted_station'])
                        .ariaLabel(translatedValues['STATIONLIST.delete_station_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteStation(Station);
                        vm.selectedStations = [];
                        selectedStations = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete Station
         */
        function deleteStation(Station) {
            clearFlashMessage();
            if (vm.stations.indexOf(Station) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('specifics_station.mdelete@delete', {id: Station.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "STATIONLIST.dialog_alert_delete_title",
                                "STATIONLIST.dialog_alert_delete_description",
                                "STATIONLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['STATIONLIST.dialog_alert_delete_title'],
                                        textContent: Station.name + translatedValues['STATIONLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['STATIONLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.stations.splice(vm.stations.indexOf(Station), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "STATIONLIST.dialog_alert_delete_error_title",
                                "STATIONLIST.dialog_alert_delete_error_description",
                                "STATIONLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['STATIONLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['STATIONLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['STATIONLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }

        function deleteSelectedStationsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedStations.length!== 0) {
                if(vm.selectedStations.length === 1){
                    title = 'STATIONLIST.delete_station_msg';
                    ariaLabel = 'STATIONLIST.delete_station_aria_label';
                }else{
                    title = 'STATIONLIST.delete_list_stations_msg';
                    ariaLabel = 'STATIONLIST.delete_stations_aria_label';
                }
                $rootScope.userManager.statsAccesAction("specifics_stations_delete_multi_action")
                
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedStations.length,title,ariaLabel)).then(function () {
                    
                    deleteSelectedStations(ev);
                });

            }

        }

        /* delete selected groups*/
        function deleteSelectedStations(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('specifics_station.deleteStations@delete', {
                    list: (function (list) {
                        vm.selectedStations.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("STATIONLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("STATIONLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('STATIONLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedStations = [];
                        selectedStations = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('STATIONLIST.dialog_alert_delete_error_title'),
                            $translate.instant('STATIONLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedStations = [];
                        selectedStations = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedStations = [];
                    selectedStations = [];
                    vm.modelCheckAll = false;

                }
            );


        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics.station.list')
        .controller('specificsStationDetailController', specificsStationDetailController);

    /** @ngInject */
    function specificsStationDetailController(specificsStationData, $mdDialog) {
        var vm = this;
        vm.station = specificsStationData;
        vm.cancel = cancel;

        function cancel() {
            $mdDialog.hide();
        }


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.specifics.station.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.specifics_station_edit', {
                url    :"/specifics/station/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/specifics/station/add_edit_view/add_edit.template.html',
                        controller : 'specificsStationEditController as vm'
                    }
                },
                resolve: {
                    specificsStationData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('specifics_station.getStation@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" :"specifics_stations_post_edit_action"
            });


        // API
        msApiProvider.register('specifics_station.getStation', [Routing.generate('api_specifics_get_detail_station',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('specifics_station.editStation', [Routing.generate('api_specifics_post_edit_station',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}])

    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.station.edit')
    .controller('specificsStationEditController', specificsStationEditController);

  /** @ngInject */
  function specificsStationEditController(webTvGlobal, $translate, msApi, $rootScope, $state, specificsStationData, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_station_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_station_edit_pagetitle";
      $rootScope.pageRoute = "app.specifics_station_list";

      $rootScope.welcome = "welcome_station_edit";
      $rootScope.text = [{
        texte: "parameters_station_add_help"
      }, {
        texte: "send_button_station_edit_help"
      }, {
        texte: "cancel_button_station_add_help"
      }];

    }

    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var station = specificsStationData;
    vm.empSpecificsStationForm = {};
    vm.submitAddStationForm = submitAddStationForm;
    fillData();

    /**
     * Check if station exists
     * @return if exists get Station Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(station.code) && station.code !== 200) $state.go('app.error_404');
      else {

        vm.empSpecificsStationForm = {

          ip: station.ip,
          name: station.name,
          domain: station.domain,
          intranetStreamFr: station.intranetStreamFr,
          intranetStreamEn: station.intranetStreamEn,
          intranetStreamEs: station.intranetStreamEs,
          intranetStreamOr: station.intranetStreamOr,
          description: station.description
        };
        $rootScope.itemName = station.name || '';
      }
    }


    /**
     * Convert List To Select Option format
     */

    /*function convertStationIdToSelectList(choices) {
        var converted = Object.keys(choices).map(function (key) {
            return {val: choices[key], options: key};
        });
        converted.sort(function (a, b) {
            return a.val - b.val;
        });
        return converted;
    }*/

    /**
     * Send add Station Form
     */
    function submitAddStationForm() {
      $rootScope.loadingProgress = true;
      msApi.request('specifics_station.editStation@save',
        {id: station.id, "empSpecificsStationForm": angular.copy(vm.empSpecificsStationForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            station = vm.empSpecificsStationForm;
            webTvGlobal.$flashMessages().set('specificsStationEdit', station);
            $state.go('app.specifics_station_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.profiles.user.password', [])
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.profiles_user_password', {
                url: "/profiles/user/create-password/:token",
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.profiles_user_password': {
                        templateUrl: 'app/main/profiles/user/password/password.html',
                        controller: 'ProfilesUserCreatePasswordController as vm'
                    }
                },
                bodyClass: 'register'
            });


        // Translation
        msApiProvider.register('profiles_user.editRandomPassword', [Routing.generate('api_profiles_post_edit_password_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('profiles_user.editTokenPassword', [Routing.generate('api_profiles_post_add_password_user', {token: ':token'}).replace(/%3A/, ":"), {token: '@token'}]);
        msApiProvider.register('profiles_user.changePassword', [Routing.generate('api_profiles_create_new_password', {token: ':token'}).replace(/%3A/, ":"), {token: '@token'}]);

    }

})();
(function () {
    'use strict';

    angular
        .module('app.profiles.user.password')
        .controller('ProfilesUserCreatePasswordController', ProfilesUserCreatePasswordController)
        .directive('confirmPassword', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, mCtrl) {
                    function myValidation(value) {
                        var password = angular.element('input[type="password"].first').val();
                        if (value !== password) mCtrl.$setValidity('confirmPassword', false);
                        else mCtrl.$setValidity('confirmPassword', true);
                        return value;
                    }

                    mCtrl.$parsers.push(myValidation);

                }
            };
        });

    function ProfilesUserCreatePasswordController($translate, userManager, msApi, webTvGlobal, $state, $cookies,logo) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var _token = webTvGlobal.getQueryVariable("token");
        var vm = this;
        vm.empProfilesUserPasswordForm = {};
        vm.empProfilesUserPasswordForm.plainPassword = {
            first: "",
            second: ""
        };

      vm.logo = {
        "logo_image": logo.image,
        "logo_text": logo.text,
        "logo_text1":logo.text1
      };

        vm.submitAddUserPasswordForm = submitAddUserPasswordForm;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        if (angular.isUndefined(parameters['app.client.name'])) {
            msApi.request('parametersBagLogin.app@get', function (res) {
                parameters = res.bag;
                if (angular.isDefined(parameters['use_special_character_password_user']) && parameters['use_special_character_password_user']==="1") {
                    vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[!?,;:.\\/|@#$%^\\-_&*<>+={}([\\]"\')éèêîôçàâûäëïöüÀÇÉÈÂÊÎÔÛÄËÏÖÜ]).*$';
                    vm.msgErrorPatern = "MESSAGES.form_is_patternpwdspecial";
                }else{
                    vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
                    vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
                }
            });
        }
        if (angular.isDefined(parameters['use_special_character_password_user']) && parameters['use_special_character_password_user']==="1") {
            vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[!?,;:.\\/|@#$%^\\-_&*<>+={}([\\]"\')éèêîôçàâûäëïöüÀÇÉÈÂÊÎÔÛÄËÏÖÜ]).*$';
            vm.msgErrorPatern = "MESSAGES.form_is_patternpwdspecial";
        }else{
            vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
            vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
        }
        function submitAddUserPasswordForm() {
            if (angular.isDefined($state.params.token))
                msApi.request('profiles_user.changePassword@save',
                    {
                        token: $state.params.token,
                        'empProfilesUserForm': angular.copy(vm.empProfilesUserPasswordForm)
                    },
                    function (res) {
                        if (res.code === 200) {
                            // $cookies.put("authToken", $state.params.token);
                            // userManager.setUserData(res.userData);
                            webTvGlobal.$toast().showSimple($translate.instant('USERPASSWORD.password_changed'));
                            $state.go("app.login-v2", {token: ""});
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    }
                );
            else {
                if (_token) {
                    msApi.request('profiles_user.editTokenPassword@save',
                        {
                            token: _token,
                            'empProfilesUserForm': angular.copy(vm.empProfilesUserPasswordForm)
                        },
                        function (res) {
                            if (res.code === 200) {
                                $cookies.put("authToken", res.token);
                                userManager.setUserData(res.userData);
                                $state.go('app.dashboard');
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                            }
                        },
                        function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    );
                }
                else {
                    msApi.request('profiles_user.editRandomPassword@save',
                        {
                            id: userManager.getId(),
                            'empProfilesUserForm': angular.copy(vm.empProfilesUserPasswordForm)
                        },
                        function (res) {
                            if (res.code === 200) {
                                $state.go('app.dashboard');
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                            }
                        },
                        function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    );
                }
            }
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.specifics.station.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.specifics_station_add', {
                url    : "/specifics/station/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/specifics/station/add_edit_view/add_edit.template.html',
                        controller : 'specificsStationAddController as vm'
                    }
                },
                resolve: {
                    specificsStationData: function (msApi)
                    {
                        return msApi.resolve('specifics_station.getNewStationData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" :"specifics_stations_post_add_action"
            });
        
        //API
        msApiProvider.register('specifics_station.getNewStationData', [Routing.generate('api_specifics_get_detail_station',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('specifics_station.addStation', [Routing.generate('api_specifics_post_add_station')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.specifics.station.add')
    .controller('specificsStationAddController', specificsStationAddController);

  /** @ngInject */
  function specificsStationAddController($rootScope, $translate, msApi, $state, specificsStationData, webTvGlobal, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();


    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.specifics_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.specifics_station_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.specifics_station_add_menuTitle";
      $rootScope.pageRoute = "app.specifics_station_list";

      $rootScope.welcome = "welcome_station_add";
      $rootScope.text = [{
        texte: "parameters_station_add_help"
      }, {
        texte: "send_button_station_add_help"
      }, {
        texte: "cancel_button_station_add_help"
      }];
    }

    var vm = this;
    vm.isNew = true;
    var station = specificsStationData;
    vm.empSpecificsStationForm = {
      ip: station.ip,
      name: station.name,
      domain: station.domain,
      intranetStreamFr: station.intranetStreamFr,
      intranetStreamEn: station.intranetStreamEn,
      intranetStreamEs: station.intranetStreamEs,
      intranetStreamOr: station.intranetStreamOr,
      description: station.description

    };
    vm.submitAddStationForm = submitAddStationForm;


    /**
     * Convert List To Select Option format
     */

    /*function convertStationIdToSelectList(choices) {
        var converted = Object.keys(choices).map(function (key) {
            return {val: choices[key], options: key};
        });
        converted.sort(function (a, b) {
            return a.val - b.val;
        });
        return converted;
    }*/

    /**
     * Send add Station Form
     */
    function submitAddStationForm() {
      $rootScope.loadingProgress = true;
      msApi.request('specifics_station.addStation@save',
        {"empSpecificsStationForm": angular.copy(vm.empSpecificsStationForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            station = vm.empSpecificsStationForm;
            webTvGlobal.$flashMessages().set('specificsStationAdd', {title: vm.empSpecificsStationForm.name ? vm.empSpecificsStationForm.name : ""});
            $state.go('app.specifics_station_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.profiles.user.profilconnected', ['angularCroppie'])
    .config(config);


  function config($stateProvider, msApiProvider) {
    // State
    $stateProvider
      .state('app.profiles_user_profilconnected', {
        url: "/profiles/user/profilconnected",
        views: {
          'content@app': {
            templateUrl: 'app/main/profiles/user/profilconnected/profile-conceted-v2.html',
            controller: 'EditUserConnectedController as vm'
          }
        },
          resolve: {
              channelChoices: function (msApi) {
                  return msApi.resolve('channel.channelChoices@get');
              },
              data :function (msApi){
                  return msApi.resolve('profiles_user.getGroups@get');
              }

          },


        "bodyClass": "profile",
          "actionPermission" : "profiles_user_post_edit_connected_user_action"
      });


    //Api
      msApiProvider.register('profiles_user.getGroups', [Routing.generate('api_profiles_get_groups_choices')]);

      msApiProvider.register('profiles_connected_user.editPassword', [Routing.generate('api_profiles_post_edit_password_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
      msApiProvider.register('profiles_connected_user.editUserConnected', [Routing.generate('api_profiles_post_edit_connected_user')]);
      msApiProvider.register('channel.channelChoices',[Routing.generate('api_parameters_get_channels_choices_for_select_input')]);



  }
})();


(function () {
  'use strict';

  angular
    .module('app.profiles.user.profilconnected')
    .controller('profilesUserprofilconnectedController', profilesUserprofilconnectedController)
    .controller('EditUserConnectedController', EditUserConnectedController)
    .controller('EditPasswordUserConnectedController', EditPasswordUserConnectedController)
    .directive('fileOnChange', function () {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        var onChangeHandler = scope.$eval(attrs.fileOnChange);
        element.bind('change', onChangeHandler);
      }
    };
  });

  /** @ngInject */
  function profilesUserprofilconnectedController($injector, userManager, $document, channelChoices, webTvGlobal, profilesUserGroupsData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $mdDialog = $injector.get('$mdDialog');

    var vm = this;
    vm.user = userManager.getUser();
    vm.quotasPermission=false
    if (userManager.isActionGranted("profiles_user_quotas")){
      vm.quotasPermission = true;
    }
    vm.editDialog = editDialog;
    vm.editPasswordDialog = editPasswordDialog;
    vm.getFullName = $rootScope.userFullName = userManager.getFullName();
    $rootScope.channelsChoices = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    $rootScope.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserGroupsData.data.groups);

    /**
     * Open compose dialog
     *
     * @param ev
     */
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_user_detail_pagetitle";
      $rootScope.pageRoute = "app.profiles_user_list";


    }

    function editDialog(ev) {
      $mdDialog.show({
        controller: 'EditUserConnectedController',
        controllerAs: 'vm',
        locals: {
          data: vm.user
        },
        templateUrl: 'app/main/profiles/user/profilconnected/edit.modal.template.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true
      }).then(function () {
        vm.user = userManager.getUser();
        vm.getFullName = $rootScope.userFullName = userManager.getFullName();
        $rootScope.toolbarController.getFullName = vm.getFullName;
      });


    }

    function editPasswordDialog(ev) {
          $mdDialog.show({
              controller: 'EditPasswordUserConnectedController',
              controllerAs: 'vm',
              locals: {
                  data: vm.user
              },
              templateUrl: 'app/main/profiles/user/profilconnected/edit.password.modal.template.html',
              parent: angular.element($document.body),
              targetEvent: ev,
              clickOutsideToClose: true
          }).then(function () {
              vm.user = userManager.getUser();
              vm.getFullName = $rootScope.userFullName = userManager.getFullName();
              $rootScope.toolbarController.getFullName = vm.getFullName;
          });


      }


  }

  function EditUserConnectedController(msUtils, webTvGlobal, userManager, $injector, data, $mdDialog,$cookies,$scope,$http,$compile) {
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.quotasPermission=false
    if (userManager.isActionGranted("profiles_user_quotas")){
      vm.quotasPermission = true;
    }
    vm.uploadUserAvatar=uploadUserAvatar;
    vm.returnToUpload=returnToUpload;
    vm.croppedImage={};
    vm.zoomOut=zoomOut;
    vm.zoomIn=zoomIn;

    vm.cropped = {
      source: '',
      zoom:{type:'', value:0}
    };
    vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
    vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
    vm.user = userManager.getUser();
    vm.urlVignette = "";
    vm.empProfilesUserEditForm = {};
    vm.groups = $rootScope.groups;
    vm.ngFlowOptions = {
      target: Routing.generate('api_profiles_post_user_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      flow: {}
    };
    vm.channels = $rootScope.channelsChoices;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.goBack = goBack
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.submitAddUserForm = submitAddUserForm;
    vm.closeDialog = closeDialog;
    var imageName;
    fillData();
    vm.citiesFrance = webTvGlobal.convertToSelectChoicesFormat(
      (function (cities, data) {
        for (var i = 0; i < data.length; i++) {
          cities[data[i]] = data[i];
        }
        return cities;
      })({}, webTvGlobal.$constant().citiesFranceList())
    );
   function returnToUpload(){
       vm.cropped.source = '';
       vm.cropped.zoom={type:'', value:0};
   }
    function uploadUserAvatar($event){
      var input = event.target;

      if (input.files && input.files[0]) {
        vm.croppedImage={name:input.files[0].name, type:input.files[0].type}

        var reader = new FileReader();

        reader.onload = function (e) {
          // bind new Image to Component
          $scope.$apply(function () {
            vm.cropped.source = e.target.result;
          });
        }

        reader.readAsDataURL(input.files[0]);
      }
      var zoom=document.querySelector('.btn-zoomOut')
      if(!zoom) {
        var slider = angular.element(document.querySelector('.cr-slider-wrap'));
        var zoomOut = angular.element('<md-button class="md-fab btn-zoomOut" aria-label="zoomOut" ng-click="vm.zoomOut()"><md-icon md-svg-src="assets/icons/zoom-out.svg" aria-label="zoom-out "></md-icon></md-button>');
        var zoomIn = angular.element('<md-button class="md-fab btn-zoomIn" aria-label="zoomIn" ng-click="vm.zoomIn()"><md-icon md-svg-src="assets/icons/zoom-in.svg" aria-label="zoom-in "></md-icon></md-button>');
        $compile(zoomOut)($scope);
        $compile(zoomIn)($scope);
        slider.prepend(zoomOut);
        slider.append(zoomIn);
      }
    }
    function zoomOut(){
      clearZoom();
      vm.cropped.zoom={type:'out', value:0.01}
    }
    function zoomIn(){
      clearZoom()
      vm.cropped.zoom={type:'in', value:0.01}
    }
    function clearZoom(){
      vm.cropped.zoom={}
    }
    // fonction de retour avec le clique sur le bouton annuler de profile

    function goBack() {
      window.history.back();
    }
    /**
     * Check if user exists
     * @return if exists get User Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.user.code) && vm.user.code !== 200) $state.go('app.error_404');
      else {
        vm.profile_pic_not_pristine = false;
        vm.empProfilesUserEditForm = {
          vignette: vm.user.vignette===null?'':vm.user.vignette.substring(vm.user.vignette.lastIndexOf('/')+1),
          firstName: vm.user.firstName,
          lastName: vm.user.lastName,
          email: vm.user.email,
          phone: vm.user.phone,
          mobile: vm.user.mobile,
          adresse: vm.user.adresse,
          city: vm.user.city,
          society: vm.user.society,
          postalCode: vm.user.postalCode,
          numberPerson: vm.user.numberPerson,
          description: vm.user.description,
          group: angular.isObject(vm.user.group) && angular.isDefined(vm.user.group.id) ? vm.user.group.id : "",
          channels: (function (list, data) {
            if (angular.isDefined(data)) {
              for (var i = 0; i < data.length; i++) {
                list.push(data[i].id);
              }
            }
            return list;
          })([], vm.user.channels)
        };
        $rootScope.itemName = vm.user.username || '';
      }
    }


    /**
     * Send add User  Form
     */
    function submitAddUserForm() {
      var profileUserData = angular.copy(vm.empProfilesUserEditForm);
      //delete profileUserData.vignette;
      console.log(profileUserData)
      console.log(vm.empProfilesUserEditForm)
      if (profileUserData.channels.length === 0) delete profileUserData.channels;
      if (profileUserData.description === null) delete profileUserData.description;
      if (profileUserData.phone === null) delete profileUserData.phone;
      msApi.request('profiles_connected_user.editUserConnected@save',
        {"empProfilesUserEditForm": profileUserData},
        function (res) {
          if (res.code === 200) {
            var user = res.user;
            vm.user = user;
            userManager.setUser(user);
            $rootScope.toolbarController.user=user;
            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
            closeDialog();

          }
          else {
            if (res.code === -1) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        },

        function () {
          vm.user = userManager.setUser();
          $state.go('app.profiles_user_profilconnected');
        }
      );


    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersThemeForm button[type='submit']").hide();

    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function urltoFile(url, filename, mimeType){
      return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename,{type:mimeType});})
      );
    }
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.upload();
      var formData = new FormData();

      urltoFile(vm.cropped.image, vm.croppedImage.name,vm.croppedImage.type)
        .then(function(file){
          console.log(file)
          formData.append('flowChunkNumber', 1);
          formData.append('empApiFileForm[thumb]',file);
          $http.post(Routing.generate('api_profiles_post_user_thumb'), formData,{ transformRequest: angular.identity,headers: {"Authorization": 'Bearer ' + $cookies.get('authToken'),'Content-Type': undefined}})
            .success(function(res){
              fileSuccess(res);
              imageName=file.name;
              uploadComplete();
            })
            .error(function(){
            });
        });

    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param message
     */
    function fileSuccess( message) {
      var res = angular.fromJson(message);
      if (angular.isDefined(res.location) && angular.isDefined(res.location.url) && res.location.url) {
        vm.empProfilesUserEditForm.vignette = res.location.path;
        vm.urlVignette = res.location.url;

      }
      else {
        vm.profile_pic_not_pristine = false;
      }
    }


    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('uploader').find("button").removeAttr('disabled');
        angular.element('uploader').find(".file-name").remove();
        angular.element("#empParametersThemeForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        vm.profile_pic_not_pristine = true;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empProfilesUserEditForm.vignette = "";
        });
      }
    }

    // Methods

    function closeDialog() {
      $mdDialog.hide();
    }


  }

    function EditPasswordUserConnectedController(msUtils, webTvGlobal, userManager, $injector, $mdDialog) {
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');
        var vm = this;
      vm.quotasPermission=false
      if (userManager.isActionGranted("profiles_user_quotas")){
        vm.quotasPermission = true;
       }
        vm.user = userManager.getUser();
        vm.password = null;
        vm.empProfilesUserEditPasswordForm = {};
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        if (angular.isUndefined(parameters['app.client.name'])) {
            msApi.request('parametersBagLogin.app@get', function (res) {
                parameters = res.bag;
            });
        }
        if (angular.isDefined(parameters['use_special_character_password_user']) && parameters['use_special_character_password_user']==="1") {
            vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[!?,;:.\\/|@#$%^\\-_&*<>+={}([\\]"\')éèêîôçàâûäëïöüÀÇÉÈÂÊÎÔÛÄËÏÖÜ]).*$';
            vm.msgErrorPatern = "MESSAGES.form_is_patternpwdspecial";
        }else{
            vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
            vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
        }


        vm.submitEditPasswordUserForm = submitEditPasswordUserForm;
        vm.closeDialog = closeDialog;
        var imageName;

        // Methods

        /**
         * Send edit password User  Form
         */
        function submitEditPasswordUserForm() {

            msApi.request('profiles_connected_user.editPassword@save',
                {
                    id: userManager.getId(),
                    'empProfilesUserForm': angular.copy(vm.empProfilesUserEditPasswordForm)
                },
                function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                        //vm.empProfilesUserEditPasswordForm = {}
                        closeDialog();
                    }
                    else {
                        if (res.code === -1) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                    }
                },
                function () {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },

                function () {
                    vm.user = userManager.setUser();
                    $state.go('app.profiles_user_profilconnected');
                }
            );
        }

        function closeDialog() {
            $mdDialog.hide();
        }


    }


})();

(function () {
  'use strict';

  angular
    .module('app.profiles.user.profilConnectedV2', ['angularCroppie'])
    .config(config);

  function config($stateProvider, msApiProvider) {
    // State
    $stateProvider
      .state('app.profiles_user_profilConnectedV2', {
        url: "/profiles/user/profilconnected-v2",
        views: {
          'content@app': {
            templateUrl: 'app/main/profiles/user/profilConnectedV2/profile-connected-v2.html',
            controller: 'EditProfileConnectedController as vm'
          }
        },
        resolve: {
          urlProfileConnected: function (msApi) {
            return msApi.resolve('url_profile_connected_v2@get',{type : 'profile_connected_v2'});
          }
        },
        "bodyClass": "profile",
        "actionPermission" : "profiles_user_post_edit_connected_user_action"
      });


    msApiProvider.register('url_profile_connected_v2', [Routing.generate('api_media_get_url_per_type_cryptext')]);
  }
})();


(function () {
  'use strict';
  angular
    .module('app.profiles.user.profilConnectedV2')
    .controller('EditProfileConnectedController', EditProfileConnectedController)
    .directive('fileOnChange', function () {
      return {
        restrict: 'A',
        link: function (scope, element, attrs) {
          var onChangeHandler = scope.$eval(attrs.fileOnChange);
          element.bind('change', onChangeHandler);
        }
      };
    });
  /** @ngInject */
  function EditProfileConnectedController($state,fuseTheming,$injector,$translate, $scope,msApi, $sce,$rootScope,urlProfileConnected,$cookies) {
    var vm = this;
    var activeTheme = fuseTheming.themes.active.theme;
    var colors = {
      "primary": activeTheme.primary.color,
      "accent": activeTheme.accent.color,
      "warn": activeTheme.warn.color
    };

    vm.urlProfileList=$sce.trustAsResourceUrl(urlProfileConnected.url+'&lang='+$cookies.get('WEBTV.locale')+'&primaryColor='+colors.accent+'&secondaryColor='+colors.warn)
    vm.language = $translate.preferredLanguage();
    $scope.iframeLoadedCallBack = function(){
      sendPostMessage( vm.language )
    }
    function  sendPostMessage(lang){
      document.getElementById('iframe_profile').contentWindow.postMessage({
        info: "updateLang",
        lang:lang
      }, "*");
    }

  }


})();

(function () {
    'use strict';

    angular
        .module('app.profiles.ip.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.profiles_ip_list', {
                url: "/profiles/ip/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profiles/ip/list/list.template.html',
                        controller: 'ProfilesIpListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "profiles_ip_list_dtable_action"
            });

        // Api

        var deleteIpRoute = Routing.generate('api_profiles_ips_delete_ips') + "/:id";
        msApiProvider.register('profiles_ip.list', [Routing.generate('api_profiles_ips_get_ipss')]);
        msApiProvider.register('profiles_ip.mdelete', [deleteIpRoute, {id: '@id'}]);
        msApiProvider.register('profiles_ip.modalGetIp', [Routing.generate('api_profiles_ips_get_detail_ips', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_Ips.dtable', [Routing.generate('api_dtable_list_dtable_profiles_ips')]);
        var deleteListIps = Routing.generate('api_multi_delete_multi_profiles_ips') + "/:list";
        msApiProvider.register('profiles_ip.deleteIps', [deleteListIps, {list: '@list'}]);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.ip.list')
        .controller('ProfilesIpListController', ProfilesIpListController);

    /** @ngInject */
    function ProfilesIpListController(DTColumnBuilder, msUtils, $cookies, $scope, msApi, DTOptionsBuilder, webTvGlobal, $injector, dtable_language,dialogConfirmDeleteService, $sce) {

        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.ips = [];
        vm.selectedIps = [];
        var selectedIps = [];
        vm.ipsDataTable = {};
        vm.dtInstance = {};
        vm.search_ips = "";
        var drawIndex=0;
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        if (window.process.env.isNew_Profile_IP) {
          vm.isNewProfileIP = window.process.env.isNew_Profile_IP;
        }
        if (vm.isNewProfileIP){
          $scope.ProfileIPIframe = $sce.trustAsResourceUrl(
            "https:" + window.process.env.URL_Profile_IP+ "?lang="+ $cookies.get("WEBTV.locale") +  "&token="  +  $cookies.get("authToken")
          );
          $scope.$watch(
            function () {
              $scope.ProfileIPIframe = $sce.trustAsResourceUrl(
                "https:" + window.process.env.URL_Profile_IP + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")
              );
              return $cookies.get("WEBTV.locale");
            },
            function (newValue) {}
          );
        }



        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
          .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
          .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        //searchIpsInAP method
        function searchIpsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('parameters_Ips.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.ips = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };
                            vm.ips = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                }
                ,
                function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        //serverData method
        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_ips,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };

            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchIpsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.ipsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.ipsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id'),
            DTColumnBuilder.newColumn('ip'),
            DTColumnBuilder.newColumn('description'),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a has-permission="profiles_ip_get_detail" tooltips tooltip-template=' + "{{'IPLIST.detail_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showIpDetail(vm.ipsDataTable[' + data.id + '],$event)" aria-label="detail_ip"translate translate-attr-aria-label="IPLIST.detail_ip">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a has-permission="profiles_ip_post_edit" tooltips tooltip-template=' + "{{'IPLIST.update_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.profiles_ip_edit({id: ' + data.id + '})" aria-label="update_ip" translate translate-attr-aria-label="IPLIST.update_ip" >' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a has-permission="profiles_ip_delete_ips" tooltips tooltip-template=' + "{{'IPLIST.delete_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button aria-label="delete_ip" class="m16 delete-button md-icon-button"  ng-click="vm.deleteIpConfirm(vm.ipsDataTable[' + data.id + '],ev)" translate translate-attr-aria-label="IPLIST.delete_ip" >' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';
                  var actionButtons='<div class="actionList"> '+buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + '</div>'

                    return actionButtons;

                })

        ];
        vm.searchIps = searchIps;

        vm.deleteIpConfirm = deleteIpConfirm;
        vm.deleteSelectedIpsConfirm = deleteSelectedIpsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showIpDetail = showIpDetail;
        vm.addNewIp = addNewIp;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('profilesIpAdd', $translate.instant('IPLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('profilesIpEdit', $translate.instant('IPLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }


        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.profiles_ip_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.profiles_ip_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_profil_ip";
            $rootScope.text = [{
                texte: "add_button_profil_ip_help"
            }, {
                texte: "arrow_button_profil_ip_help"
            }, {
                texte: "search_area_profil_ip_help"
            }, {
                texte: "tri_column_profil_ip_help"
            },
                {
                    texte: "edit_button_profil_ip_help"
                }, {
                    texte: "detail_button_profil_ip_help"
                },
                {
                    texte: "delete_button_profil_ip_help"
                }];
        }


        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }


        /**
         * @param ip
         */
        function toggle(ip) {
            ip.checked = !ip.checked;
            var idx = selectedIps.indexOf(ip);
            if (idx > -1) {
                selectedIps.splice(idx, 1);
            }
            else {
                selectedIps.push(ip);
            }
            vm.selectedIps = angular.copy(selectedIps);
        }


        function toggleAll() {
            if (selectedIps.length === vm.ips.length) {
                vm.selectedIps = [];
            }
            else if ((selectedIps.length === 0) || (selectedIps.length > 0)) {
                vm.selectedIps = vm.ips.slice(0);
            }
            selectedIps = angular.copy(vm.selectedIps);
            var list_ip = angular.copy(vm.ipsDataTable);
            angular.forEach(list_ip, function (value,key) {
                if(value !== undefined)
                    vm.ipsDataTable[key].checked =  selectedIps.length>0;
            });
        }

        /**
         * Show ip adress Details
         * @param ip adress
         */
        function showIpDetail(ip, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('profiles_ip.modalGetIp@get', {id: ip.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {profilesIpData: response},
                            templateUrl: 'app/main/profiles/ip/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'profilesIpDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * Get Detail Link
         * @param ip
         * @return string detail link
         */

        /*function getDetailLink(ip) {
            return /chrome/.test(msUtils.detectBrowser().browser) ? $state.href('app.profiles_ip_detail_modal', {id: ip.id}) : $state.href('app.profiles_ip_detail', {id: ip.id});

        }*/


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchIpsInAPI(filtre), true);
        }

        /*function editIp(ip) {
            clearFlashMessage();
            $state.go('app.profiles_ip_edit', {id: ip.id});
        }*/

        /**
         * redirection to add new ip adress page
         * @param event
         */
        function addNewIp() {
            clearFlashMessage();
            $state.go('app.profiles_ip_add');
        }

        /**
         * Delete ip adress Confirm Dialog
         */
        function deleteIpConfirm(ip, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "IPLIST.delete_ip_msg",
                "IPLIST.delete_ip_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .htmlContent('<b>' + ip.ip + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['IPLIST.delete_ip_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteIp(ip);
                        vm.selectedIps = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete ip adress
         */
        function deleteIp(ip) {
            clearFlashMessage();
            if (vm.ips.indexOf(ip) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('profiles_ip.mdelete@delete', {id: ip.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "IPLIST.dialog_alert_delete_title",
                                "IPLIST.dialog_alert_delete_description",
                                "IPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(ip.ip + translatedValues['IPLIST.dialog_alert_delete_description']);
                                    vm.ips.splice(vm.ips.indexOf(ip), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "IPLIST.dialog_alert_delete_error_title",
                                "IPLIST.dialog_alert_delete_error_description",
                                "IPLIST.dialog_alert_delete_close"
                            ])
                                .then(function () {


                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                                webTvGlobal.alertDialog(message);
                            }), function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            };
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        function deleteSelectedIpsConfirm(ev) {
          var title;
          var ariaLabel;
            if (selectedIps.length !== 0) {
              if (selectedIps.length === 1) {
                title = 'IPLIST.delete_element_ip_msg';
                ariaLabel = 'IPLIST.delete_ip_aria_label';
              } else {
                title = 'IPLIST.delete_list_ips_msg';
                ariaLabel = 'IPLIST.delete_ips_aria_label';
              }

              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, selectedIps.length, title, ariaLabel)).then(function () {

                            deleteSelectedIps(ev);


                        });


            }

        }

        /* delete selected groups*/
        function deleteSelectedIps(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('profiles_ip.deleteIps@delete', {
                    list: (function (list) {
                        selectedIps.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("IPLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("IPLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('IPLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedIps = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('IPLIST.dialog_alert_delete_error_title'),
                            $translate.instant('IPLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedIps = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedIps = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        /**
         *  call the api
         */
        function searchIps() {
            filtre["search[value]"] = vm.search_ips;
            searchIpsInAPI(filtre);
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.user.list', ["datatables"])
        .config(config);



    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.profiles_user_list', {
                url: "/profiles/user/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profiles/user/list/list.template.html',
                        controller: 'profilesUserListController as vm'
                    }
                },
                resolve: {
                    profilesUserListGroups: function (msApi) {
                        return msApi.resolve('profiles_user.list_get_groups@get');
                    }
                }
                , "bodyClass": "e-commerce",
                "actionPermission" : "profiles_user_list_dtable_action"
            });

        // Api
        var deleteUserRoute = Routing.generate('api_profiles_delete_user') + "/:id";
        var deleteListUser = Routing.generate('api_multi_delete_multi_profiles_users') + "/:list";

        msApiProvider.register('profiles_user.list', [Routing.generate('api_profiles_get_users')]);
        msApiProvider.register('profiles_user.list_data_table', [Routing.generate('api_dtable_list_dtable_profiles_users')]);
        msApiProvider.register('profiles_user.list_get_groups', [Routing.generate('api_profiles_get_groups_choices')]);


        msApiProvider.register('profiles_user.mdelete', [deleteUserRoute, {id: '@id'}]);
        msApiProvider.register('profiles_user.modalGetUser', [Routing.generate('api_profiles_get_detail_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('profiles_user.enableUser', [Routing.generate('api_profiles_put_enable_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('profiles_user.disableUser', [Routing.generate('api_profiles_put_disable_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_user.deleteUsers', [deleteListUser, {list: '@list'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.user.list')
        .controller('profilesUserListController', profilesUserListController);

    /** @ngInject */
    function profilesUserListController(order_user, $scope, $sce, $cookies,profilesUserListGroups, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $injector, dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.users = [];
        vm.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserListGroups.data.groups);
        vm.groups.splice(0, 0, {
            val: 0,
            option: $translate.instant('GROUPADD.form_attr_none'),
            options: $translate.instant('GROUPADD.form_attr_none')
        });
        //Data Table options
        vm.filtreGroupSelect = [];

        vm.getElement = getElement;

        vm.selectedUsers = [];
        var selectedUsers = [];
        vm.dataTableSearchWord = "";
        var filtre = {};
        vm.users = vm.usersDataTable = [];
        var drawIndex = 1;

        vm.fnCallback = undefined;
        var recordsTotal = 0;
        vm.dtInstance = {};
        vm.dtColumns = {};
        var checkedSelected = false;
        var language = $cookies.get('WEBTV.locale');
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        if (window.process.env.isNew_User) {
            vm.isNew_User = window.process.env.isNew_User;
            vm.UserIframe = $sce.trustAsResourceUrl(
                "https:" + window.process.env.URL_Profile_User +"?lang="+ $cookies.get("WEBTV.locale") +  "&token="  + $cookies.get("authToken") +"&embedded=true"
               );
            $scope.$watch(function () {
                vm.UserIframe = $sce.trustAsResourceUrl(
                    "https:" + window.process.env.URL_Profile_User + "?lang=" + $cookies.get("WEBTV.locale") + "&token=" + $cookies.get("authToken") + "&embedded=true"
              )});
          }
         
        
      

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withDataProp('data')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    targets: [1],
                    width: '72px'
                },
                {
                    targets: 4,
                    render: function (data) {
                        if (data === "") return "--";
                        if (parseInt(data) < 1) return "--";
                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets: 5,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
                .renderWith(function (data) {
                    vm.usersDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.usersDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.usersDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('username').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('email').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('group.name').renderWith(function (data) {
                if (!data) return "<ANY md-colors=\"{color:'#000000'}\" translate='MESSAGES.none'>none</ANY>";
                else return data;

            }),
            DTColumnBuilder.newColumn('firstName').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('lastName').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('lastLogin').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : $translate.instant('MESSAGES.nonef');
            }),
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
                .renderWith(function (data, type, full, meta) {
                    vm.usersDataTable[data.id] = data;
                    var buttonActionDetailHtml =
                        '<a has-permission="profiles_user_get_detail" tooltips tooltip-template=' + "{{'USERLIST.detail_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button " ng-click="vm.showUserDetail(vm.usersDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="USERLIST.detail_user">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditPwdHtml = "";
                    var buttonActionEditHtml = "";
                    var buttonActionDeleteHtml = "";
                    if ($rootScope.userManager.hasAccessToUserAction(vm.usersDataTable[data.id])) {
                        buttonActionEditPwdHtml =
                            '<a has-permission="profiles_user_edit_password_no_api" tooltips tooltip-template=' + "{{'USERLIST.update_pwd_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button style="display: inline-flex;" class="edit-button md-icon-button" ui-sref="app.profiles_user_pwd_edit({id: ' + data.id + '})" aria-label="update_user" translate translate-attr-aria-label="USERLIST.update_user">' +
                            '<md-icon  md-font-icon="icon-lock" class="s18"></md-icon>' +
                            '</md-button></a>';
                        buttonActionEditHtml =
                            '<a has-permission="profiles_user_post_edit_user" tooltips tooltip-template=' + "{{'USERLIST.update_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button style="display: inline-flex;" class="edit-button md-icon-button"  ui-sref="app.profiles_user_edit({id: ' + data.id + '})" aria-label="update_user" translate translate-attr-aria-label="USERLIST.update_user">' +
                            '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                            '</md-button></a>';

                    }
                    if (!$rootScope.userManager.isSameUser(vm.usersDataTable[data.id].id) && $rootScope.userManager.hasAccessToUserAction(vm.usersDataTable[data.id])) {
                        buttonActionDeleteHtml =
                            '<a has-permission="profiles_user_profiles_delete_user" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteUserConfirm(vm.usersDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete">' +
                            '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                            ' </md-button></a>';
                    }
                    var buttonActionEnableDisableHtml = "";
                    if (data.enabled) buttonActionEnableDisableHtml =
                        '<a has-permission="profiles_user_put_disable_user" tooltips tooltip-template=' + "{{'USERLIST.disable_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="edit-button md-icon-button" ng-click="vm.stateUser(vm.usersDataTable[' + data.id + '],false,' + meta.row + ',$event)()" aria-label="update_user" translate translate-attr-aria-label="USERLIST.disable_user">' +
                        '<md-icon  md-font-icon="icon-account-remove" class="s18"></md-icon>' +
                        '</md-button></a>';
                    else
                        buttonActionEnableDisableHtml =
                            '<a has-permission="profiles_user_put_enable_user" tooltips tooltip-template=' + "{{'USERLIST.enable_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.stateUser(vm.usersDataTable[' + data.id + '],true,' + meta.row + ',$event)()" aria-label="update_user" translate translate-attr-aria-label="USERLIST.enable_user">' +
                            '<md-icon  md-font-icon="icon-account-check" class="s18"></md-icon>' +
                            '</md-button></a>';
                    var actionButtons='<div class="actionList"> '+buttonActionDetailHtml + buttonActionEditHtml + buttonActionEditPwdHtml + buttonActionEnableDisableHtml + buttonActionDeleteHtml +'</div>'

                    return actionButtons;
                })
        ];
        vm.deleteUserConfirm = deleteUserConfirm;
        vm.showUserDetail = showUserDetail;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.stateUser = stateUser;
        vm.addNewUser = addNewUser;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('profilesUserAdd', $translate.instant('USERLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('profilesUserEdit', $translate.instant('USERLIST.edited'));
        vm.searchUsers = searchUsers;
        vm.deleteSelectedUserConfirm = deleteSelectedUserConfirm;


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.profiles_user_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.profiles_user_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_profil_user";
            $rootScope.text = [{
                texte: "add_button_profil_user_help"
            }, {
                texte: "arrow_button_profil_user_help"
            }, {
                texte: "search_area_profil_user_help"
            }, {
                texte: "tri_column_profil_user_help"
            },
                {
                    texte: "edit_button_profil_user_help"
                }, {
                    texte: "editpwd_button_profil_user_help"
                }, {
                    texte: "detail_button_profil_user_help"
                }, {
                    texte: "activate_button_profil_user_help"
                },
                {
                    texte: "delete_button_profil_user_help"
                }];
        }


        //Server Side process
        vm.groupFiltreSelected = function (group) {
            if (group === "Aucun") {
                filtre.idGroup = null;
                searchUsersInAPI(filtre);
                return;
            }
            vm.groups.forEach(function (item) {
                if (item.option === vm.filtreGroupSelect) {
                    filtre.idGroup = item.val;
                    searchUsersInAPI(filtre);
                    return;
                }
            })
        };

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var columnsApi = order_user;
            var numColum = angular.isUndefined(columnsApi.data) || angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];
            checkedSelected = false;
            vm.selectedUsers = [];
            selectedUsers = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.dataTableSearchWord,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
          filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchUsersInAPI(filtre);
        }

        function searchUsers(e) {
            filtre["search[value]"] = vm.dataTableSearchWord;
            searchUsersInAPI(filtre);
        }

        // Probleme au niveau de l'API: l'API n'envoie pas le username
        // On injecte manuellement une valeur de test en attendant l'envoie correcte du données
        function searchUsersInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('profiles_user.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var users = response.data;

                        for (var i = 0; i < response.data.length; i++) {
                            users[i].username = angular.isDefined(response.data[i].username) ? response.data[i].username : " ";
                            users[i].email = angular.isDefined(response.data[i].email) ? response.data[i].email : " ";
                            users[i].lastLogin = angular.isDefined(response.data[i].lastLogin) ? response.data[i].lastLogin : " ";
                        }
                        records = {
                            'draw': drawIndex,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': users
                        };
                        drawIndex = drawIndex + 1;
                        vm.users = response.data;
                        recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.users = [];
                            recordsTotal = 0;
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }

        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         /**
         * Toggle selected status of the user
         *
         * @param user
         */
        function toggle(user) {
            user.checked = !user.checked;
            var idx = selectedUsers.indexOf(user);
            if (idx > -1) {
                selectedUsers.splice(idx, 1);
            }
            else {
                selectedUsers.push(user);
            }
            vm.selectedUsers = angular.copy(selectedUsers);
        }

        function toggleAll() {
            if (selectedUsers.length === vm.users.length) {
                vm.selectedUsers = [];
            }
            else if ((selectedUsers.length === 0) || (selectedUsers.length > 0)) {
                vm.selectedUsers = vm.users.slice(0);
            }
            selectedUsers= angular.copy(vm.selectedUsers);
            var list_users = angular.copy(vm.usersDataTable);
            angular.forEach(list_users, function (value,key) {
                if(value !== undefined)
                     vm.usersDataTable[key].checked =  selectedUsers.length>0;
            });
        }

        /**
         * Show UserDetails
         * @param user
         */
        function showUserDetail(user, ev) {
            clearFlashMessage();
            $rootScope.is_modal = true;

            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('profiles_user.modalGetUser@get', {id: user.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {profilesUserData: response},
                            templateUrl: 'app/main/profiles/user/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'profilesUserDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {

            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchUsersInAPI(filtre), true);
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function stateUser(user, userState, index, $event) {
            clearFlashMessage();
            var link = "";
            userState ? link = "profiles_user.enableUser@save" : link = "profiles_user.disableUser@save";
            msApi.request(link, {id: user.id},
                function (res) {
                    if (res.done === 1) {
                        angular.isUndefined(vm.users[index].enabled) ? vm.users[index].enabled = false : vm.users[index].enabled = userState;
                        webTvGlobal.$toast().showSimple(user.username + $translate.instant("MESSAGES.update_success"));
                        rerender();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'), '', '', $event);
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );


        }

        /**
         * redirection to add new user page
         * @param event
         */
        function addNewUser() {
            clearFlashMessage();
            $state.go('app.profiles_user_add');
        }

        /**
         * Delete UserConfirm Dialog
         */
        function deleteUserConfirm(User, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "USERLIST.delete_user_msg",
                "USERLIST.delete_user_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['USERLIST.delete_user_msg'])
                        .htmlContent('<b>' + User.username + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['USERLIST.delete_user_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteUser(User);
                        vm.selectedUsers = [];

                    });
                });


        }

        /**
         * Delete selected user Confirm Dialog
         */
        function deleteSelectedUserConfirm(ev) {
            if (selectedUsers.length !== 0) {

                $translate([
                    "MESSAGES.dialog_confirm_delete",
                    "MESSAGES.dialog_cancel",
                    "MESSAGES.dialog_list_will_be_deleted",
                    "USERLIST.delete_list_user_msg",
                    "USERLIST.delete_user_aria_label"
                ])
                    .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['USERLIST.delete_list_user_msg'])
                            .htmlContent(translatedValues['MESSAGES.dialog_list_will_be_deleted'])
                            .ariaLabel(translatedValues['USERLIST.delete_user_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteSelectedUsers(ev);


                        });
                    });
            }
        }

        /**
         * Delete selected users
         */
        function deleteSelectedUsers(ev) {
            $rootScope.loadingProgress = true;
            msApi.request('configuration_user.deleteUsers@delete', {
                    list: (function (list) {
                        selectedUsers.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("USERLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("USERLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('USERLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedUsers = [];
                        vm.selectedUsers = [];
                        rerender();
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('USERLIST.dialog_alert_delete_error_title'),
                            $translate.instant('USERLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedUsers = [];

                    }

                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * Delete User
         */
        function deleteUser(User) {
            clearFlashMessage();
            if (vm.users.indexOf(User) !== -1) {
                $rootScope.loadingProgress = true;
               new Promise(function(resolve,reject){
                   msApi.request('profiles_user.mdelete@delete', {id: User.id}).then(

                       function (response) {
                           resolve(response)
                           if (response.code === 200) {
                               $rootScope.loadingProgress = false;
                               $translate([
                                   "USERLIST.dialog_alert_delete_title",
                                   "USERLIST.dialog_alert_delete_description",
                                   "USERLIST.dialog_alert_delete_close"
                               ])
                                   .then(function (translatedValues) {
                                       var alert = $mdDialog.alert({
                                           title: translatedValues['USERLIST.dialog_alert_delete_title'],
                                           textContent: User.username + " " + translatedValues['USERLIST.dialog_alert_delete_description'],
                                           ok: translatedValues['USERLIST.dialog_alert_delete_close']
                                       });

                                       $mdDialog
                                           .show(alert)
                                           .finally(function () {
                                               alert = undefined;
                                           });
                                       vm.users.splice(vm.users.indexOf(User), 1);
                                       rerender();
                                   });

                           }
                           else {
                               $translate([
                                   "USERLIST.dialog_alert_delete_error_title",
                                   "USERLIST.dialog_alert_delete_error_description",
                                   "USERLIST.dialog_alert_delete_close"
                               ])
                                   .then(function (translatedValues) {
                                       var alert = $mdDialog.alert({
                                           title: translatedValues['USERLIST.dialog_alert_delete_error_title'],
                                           textContent: translatedValues['USERLIST.dialog_alert_delete_error_description'],
                                           ok: translatedValues['USERLIST.dialog_alert_delete_close']
                                       });

                                       $mdDialog
                                           .show(alert)
                                           .finally(function () {
                                               alert = undefined;
                                           });
                                   });

                           }
                       },
                       function (error) {
                           $rootScope.loadingProgress = false;
                           if (angular.isDefined(error.data) && angular.isDefined(error.data.message)) {
                               $translate([
                                   "USERLIST.dialog_alert_failed_delete_title",
                                   "USERLIST.dialog_alert_failed_delete_description",
                                   "USERLIST.dialog_alert_delete_close"
                               ])
                                   .then(function (translatedValues) {
                                       webTvGlobal.alertDialog(User.username + translatedValues['USERLIST.dialog_alert_failed_delete_description']);
                                   });
                           }else{
                               webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                           }
                       }
                   )
                })
            }


        }


    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.profiles.user.list')
        .controller('profilesUserDetailController', profilesUserDetailController);

    /** @ngInject */
    function profilesUserDetailController(profilesUserData,$mdDialog)
    {
    	var vm = this;
        vm.user = profilesUserData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }



    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles.user.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.profiles_user_edit', {
                url    :"/profiles/user/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/user/add_edit_view/add_edit.template.html',
                        controller : 'profilesUserEditController as vm'
                    }
                },
                resolve: {
                    channelChoices: function (msApi)
                    {
                    return msApi.resolve('channel.channelChoices@get');
                    },
                    profilesUserGroupsData: function (msApi)
                    {
                        return msApi.resolve('prof_user.getGroups@get');
                    },
                    profilesUserData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('profiles_user.getUser@get',{id:$stateParams.id});
                    },
                    profilesUserCodeValidation: function (msApi,$stateParams)
                    {
                        return msApi.resolve('profiles_user.useCodeValidation@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_user_post_edit_user_action"
            })
                .state('app.profiles_user_pwd_edit', {
                url    :"/profiles/user/:id/password/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/user/add_edit_view/form.pwd.template.html',
                        controller : 'profilesUserEditpwdController as vm'
                    }
                },
                resolve: {
                    profilesUserData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('profiles_user.getUser@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms"
            });

        // API
        //msApiProvider.register('profiles_user.getGroups', [Routing.generate('api_profiles_get_groups_choices')]);
        msApiProvider.register('prof_user.getGroups', [Routing.generate('api_profiles_get_connected_user_groups_permission')]);
        msApiProvider.register('profiles_user.getUser', [Routing.generate('api_profiles_get_detail_user',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('profiles_user.useCodeValidation', [Routing.generate('api_profiles_use_code_validation_user',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('profiles_user.editpwdUser', [Routing.generate('api_profiles_post_edit_password_user',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
        msApiProvider.register('profiles_user.editUser', [Routing.generate('api_profiles_post_edit_user',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
        msApiProvider.register('channel.channelChoices',[Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('prof_user.generateCodeValidation',[Routing.generate('api_profiles_generate_validation_code_user')]);
        msApiProvider.register('prof_user.checkCodeValidation',[Routing.generate('api_profiles_check_validation_code_user')]);
        msApiProvider.register('profiles_user.desactivateCodeValidation', [Routing.generate('api_profiles_desactivate_code_validation_user', {id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);

    }
})();

(function () {
  'use strict';

  angular
    .module('app.profiles.user.edit')
    .controller('profilesUserEditpwdController', profilesUserEditpwdController);

  /** @ngInject */
  function profilesUserEditpwdController(webTvGlobal, profilesUserData, $rootScope, $translate, msApi, $state, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var vm = this;
    initHelp();
      var parameters = webTvGlobal.$constant().webTvParameterBag();
      if (angular.isUndefined(parameters['app.client.name'])) {
          msApi.request('parametersBagLogin.app@get', function (res) {
              parameters = res.bag;
          });
      }
      console.log(parameters);
      if (angular.isDefined(parameters['use_special_character_password_user']) && parameters['use_special_character_password_user']==="1") {
          vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[!?,;:.\\/|@#$%^\\-_&*<>+={}([\\]"\')éèêîôçàâûäëïöüÀÇÉÈÂÊÎÔÛÄËÏÖÜ]).*$';
          vm.msgErrorPatern = "MESSAGES.form_is_patternpwdspecial";
      }else{

          vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
          vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
      }

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_user_edit_pwd_pagetitle";
      $rootScope.pageRoute = "app.profiles_user_list";
      vm.welcome = "welcome_editpwd_add";
      vm.text = [{
        texte: "parameters_editpwd_add_help"
      }, {
        texte: "send_button_editpwd_add_help"
      }, {
        texte: "cancel_button_editpwd_add_help"
      }];

    }

    $rootScope.itemName = "";
    vm.user = profilesUserData;
    vm.fillData = fillData;
    vm.empProfilesUserForm = {
      plainPassword: {
        first: vm.plainPassword || "",
        second: vm.plainPassword || ""
      }
    };
    vm.submitEditPwdUserForm = submitEditPwdUserForm;
    vm.fillData();

    /**
     * Check if user exists
     * @return if exists get User Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.user.status) && vm.user.status === 0) $state.go('app.error_404');
      else {

        vm.empProfilesUserForm = {

          plainPassword: {
            first: vm.empProfilesUserForm.plainPassword.first,
            second: vm.empProfilesUserForm.plainPassword.second
          }
        };
        $rootScope.itemName = vm.user.username || '';
      }
    }


    /**
     * Send add User password Form
     */
    vm.submitEditPwdUserForm = submitEditPwdUserForm;

    function submitEditPwdUserForm() {

      msApi.request('profiles_user.editpwdUser@save',
        {id: vm.user.id, "empProfilesUserForm": angular.copy(vm.empProfilesUserForm)},
        function (res) {
          if (res.code === 200) {
            vm.user = vm.empProfilesUserForm;
            webTvGlobal.$flashMessages().set('profilesUserEdit', vm.user);
            $state.go('app.profiles_user_list');
          }
          else {
            if (res.code === 200) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                    webTvGlobal.alertDialog(message);
                }, function () {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
        }
      );


    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.profiles.user.edit')
    .controller('profilesUserEditController', profilesUserEditController)
    .controller('activateCodeValidationController', activateCodeValidationController);

  /** @ngInject */
  function profilesUserEditController(webTvGlobal,$cookies, profilesUserData, profilesUserCodeValidation, profilesUserGroupsData, $injector, channelChoices, msUtils,$scope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
        $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi');
    var vm = this;
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_user_edit_pagetitle";
      $rootScope.pageRoute = "app.profiles_user_list";
        $rootScope.welcome = "welcome_profil_user_edit";
        $rootScope.text =  [{
            texte: "parameters_profil_user_add_help"
        }, {
            texte: "send_button_profil_user_edit_help"
        }, {
            texte: "cancel_button_profil_user_add_help"
        }];

    }

    vm.isNew = false;
    vm.urlVignette = "";
    vm.confirmChangeState=false;
    vm.profile_pic_not_pristine = false;
    vm.empProfilesUsersError = [];
    $rootScope.itemName = "";
    vm.ngFlowOptions = {
      target: Routing.generate('api_profiles_post_user_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      flow: {}
    };
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    console.log("$cookies.get('authToken')",$cookies.get('authToken'))
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.user = profilesUserData;
    //vm.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserGroupsData.data.groups);
    vm.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserGroupsData.data.groups);
    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    vm.empProfilesUserForm = {};
    vm.submitAddUserForm = submitAddUserForm;
    vm.activate_code_validation = activate_code_validation;
    $rootScope.activateCodeValidation = profilesUserCodeValidation.use_code_validation;
    var imageName;
    fillData();

    function activate_code_validation() {
        $rootScope.activateCodeValidation = !$rootScope.activateCodeValidation;
        if($rootScope.activateCodeValidation){
            $mdDialog.show({
                controller: "activateCodeValidationController",
                controllerAs: 'vm',
                templateUrl: 'app/main/profiles/user/add_edit_view/activate.code.validation.html',
                clickOutsideToClose: false,
                locals: {
                    data: {email: vm.empProfilesUserForm.email, id: vm.user.id},
                }
            }).then(function () {
            }, function () {
            });

        }
    }
    $scope.forms = {};

    $rootScope.$on('$stateChangeStart',
      function(event, toState, toParams, fromState, fromParams){
        var validForm=$scope.forms.empProfilesUserForm.$valid && !($scope.forms.empProfilesUserForm.$pristine && !vm.profile_pic_not_pristine);
        if (fromState.name==="app.profiles_user_edit" && !vm.confirmChangeState && validForm){
          $mdDialog.show({
            templateUrl: 'app/main/profiles/user/add_edit_view/modalUser.html',
            clickOutsideToClose: true,
            controller: function($scope, $mdDialog, $rootScope,$injector) {
              var $state = $injector.get('$state');
              $scope.cancel = cancel;
              $scope.confirm=confirm;

              function cancel() {
                $mdDialog.hide();
              }
              function confirm(){
                vm.confirmChangeState=true;
                $mdDialog.hide();
                $state.go(toState.name);

              }
            },


          });

        }
        if (!vm.confirmChangeState && validForm){
          event.preventDefault();

        }
      });
    /**
     * Check if user exists
     * @return if exists get User Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.user.status) && vm.user.status === 0) $state.go('app.error_404');
      else {

        vm.empProfilesUserForm = {
          vignette: vm.user.vignette,
          firstName: vm.user.firstName,
          lastName: vm.user.lastName,
          username: vm.user.username,
          email: vm.user.email,
          phone: vm.user.phone,
          mobile: vm.user.mobile,
          description: vm.user.description,
            activateCodeValidation: $rootScope.activateCodeValidation,
          group: angular.isObject(vm.user.group) && angular.isDefined(vm.user.group.id) ? vm.user.group.id : "",
          channels: (function (list, data) {
            for (var i = 0; i < data.length; i++) {
              list.push(data[i].id);
            }
            return list;
          })([], vm.user.channels)


        };
        $rootScope.itemName = vm.user.username || '';
      }
    }


    /**
     * Send add User Form
     */
    function submitAddUserForm() {
      vm.confirmChangeState=true;
      $rootScope.loadingProgress = true;
      msApi.request('profiles_user.editUser@save',
        {id: vm.user.id, "empProfilesUserForm": angular.copy(vm.empProfilesUserForm), tokenValidation:  $rootScope.activateCodeValidation},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.user = vm.empProfilesUserForm;

            webTvGlobal.$flashMessages().set('profilesUserEdit', vm.user);
            $state.go('app.profiles_user_list');
          }
          else {
            if (angular.isDefined(res.errors)) {

              var errors = res.errors;


              vm.empProfilesUsersError = [];

              errors.forEach(function (item) {

                vm.empProfilesUsersError[item.for] = {
                  message: item.messages[0],
                  value_old: angular.copy(vm.empProfilesUserForm[item.for])
                };
              });
            }
            else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersThemeForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      //vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (angular.isDefined(res.location) && angular.isDefined(res.location.url) && res.location.url) {
        vm.empProfilesUserForm.vignette = res.location.path;
        vm.urlVignette = res.location.url;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empParametersThemeForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        vm.profile_pic_not_pristine = true;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empProfilesUserForm.vignette = "";

        });
      }
    }


  }

    function activateCodeValidationController(data, webTvGlobal, $injector) {
        var $rootScope = $injector.get('$rootScope'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog'),
            $filter = $injector.get('$filter'),
            msApi = $injector.get('msApi');
        var appParameters = webTvGlobal.$constant().webTvParameterBag();
        var vm = this;
        vm.data = data;
        vm.show_loading = true;
        vm.show_msg =false;
        vm.msg_error = "";
        vm.cancel = $mdDialog.cancel;
        vm.closeDialog = closeDialog;
        vm.check_code_validation = check_code_validation;
        vm.change_code = change_code;
        function closeDialog() {
            $mdDialog.hide();
            $rootScope.activateCodeValidation = false;
            msApi.request(
                'profiles_user.desactivateCodeValidation@save',
                {id: vm.data.id},
                function (res) {

                }, function (response) {
                });
        }
        function check_code_validation() {
            $rootScope.loadingProgress = true;
            msApi.request(
                'prof_user.checkCodeValidation@save',
                {id: vm.data.id, code:vm.empUserCodeForm.code},
                function (res) {
                    $rootScope.loadingProgress = false;
                    $rootScope.activateCodeValidation = true;
                    $mdDialog.hide();
                }, function (response) {
                  $rootScope.loadingProgress = false;
                  if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                      $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                          vm.msg_error = message;
                      });
                  }
                });
        }
        function change_code() {
            vm.msg_error = "";
        }
        msApi.request(
            'prof_user.generateCodeValidation@save',
            {id: vm.data.id, email: vm.data.email},
            function (res) {
                if(res.message === "success_send_code") {
                  vm.show_loading = false;
                  vm.show_msg = true;
                }
            });
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.profiles.ip.list')
        .controller('profilesIpDetailController', profilesIpDetailController);

    /** @ngInject */
    function profilesIpDetailController(profilesIpData,$mdDialog)
    {
    	var vm = this;
        vm.ip = profilesIpData;


      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }


    }



})();

(function () {
    'use strict';

    angular
        .module('app.profiles.user.add', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.profiles_user_add', {
                url: "/profiles/user/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profiles/user/add_edit_view/add_edit.template.html',
                        controller: 'profilesUserAddController as vm'
                    }
                },
                resolve: {
                    profilesUserGroupsData: function (msApi) {
                        return msApi.resolve('prof_user.getGroups@get');
                    },
                    channelChoices: function (msApi) {
                        return msApi.resolve('channel.channelChoices@get');
                    },
                    profilesUserData: function (msApi) {
                        return msApi.resolve('profiles_user.getNewUserData@get', {id: 0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_user_post_add_action"
            })
            /*.state('app.profiles_user_detail',{
             url: Routing.generate('emp_video_settings_user_detail')+"/:id"
             })*/;


        //API
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        //msApiProvider.register('profiles_user.getGroups', [Routing.generate('api_profiles_get_groups_choices')]);
        msApiProvider.register('prof_user.getGroups', [Routing.generate('api_profiles_get_connected_user_groups_permission')]);
        msApiProvider.register('profiles_user.getNewUserData', [Routing.generate('api_profiles_get_detail_user', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('profiles_user.addUser', [Routing.generate('api_profiles_post_add_user')]);
        msApiProvider.register('prof_user.generateCodeValidation',[Routing.generate('api_profiles_generate_validation_code_user')]);
        msApiProvider.register('prof_user.checkCodeValidation',[Routing.generate('api_profiles_check_validation_code_user')]);
        msApiProvider.register('profiles_user.desactivateCodeValidation', [Routing.generate('api_profiles_desactivate_code_validation_user', {id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);


    }
})();

(function () {
  'use strict';

  angular
    .module('app.profiles.user.add')
    .controller('profilesUserAddController', profilesUserAddController)
    .controller('activateCodeValidationFormAddController', activateCodeValidationFormAddController)
    .directive('confirmPassword', function () {
      return {
        require: 'ngModel',
        link: function (scope, element, attr, mCtrl) {
          function myValidation(value) {
            var password = angular.element('input[type="password"].first').val();
            if (value !== password) mCtrl.$setValidity('confirmPassword', false);
            else mCtrl.$setValidity('confirmPassword', true);
            return value;
          }

          mCtrl.$parsers.push(myValidation);

        }
      };
    });


  /** @ngInject */
  function profilesUserAddController(profilesUserGroupsData,$cookies ,channelChoices, msUtils, msApi, profilesUserData, webTvGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      HelpGlobal = $injector.get('HelpGlobal'),
      $state = $injector.get('$state'),
        $mdDialog = $injector.get('$mdDialog'),
      $translate = $injector.get('$translate');
    var vm = this;
    vm.isNew = true;
    var errors = [];
    vm.urlVignette = "";
    vm.empProfilesUsersError = [];
    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    //vm.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserGroupsData.data.groups);
    vm.groups = webTvGlobal.convertToSelectChoicesFormat(profilesUserGroupsData.data.groups);
    vm.connectionTypeChoices = webTvGlobal.convertToSelectChoicesFormat({
      "ct_default": 0,
      "ct_random": 1,
      "ct_email": 2
    });
      $rootScope.activateCodeValidation = false;
    vm.user = profilesUserData;
    vm.empProfilesUserForm = {
      username: vm.username || "",
      email: vm.email || "",
      firstName: vm.user.firstName || "",
      lastName: vm.user.lastName || "",
      phone: vm.user.phone || "",
      mobile: vm.user.mobile || "",
      description: vm.user.description || "",
      plainPassword: {
        first: vm.plainPassword || "",
        second: vm.plainPassword || ""
      },
      group: vm.group,
      channels: vm.user.channels || [],
      connectionType: 0,
      vignette: '',
        activateCodeValidation: $rootScope.activateCodeValidation
    };

    var parameters = webTvGlobal.$constant().webTvParameterBag();
      if (angular.isUndefined(parameters['app.client.name'])) {
          msApi.request('parametersBagLogin.app@get', function (res) {
              parameters = res.bag;
          });
      }
      if (angular.isDefined(parameters['use_special_character_password_user']) && parameters['use_special_character_password_user']==="1") {
          vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z])(?=.*[!?,;:.\\/|@#$%^\\-_&*<>+={}([\\]"\')éèêîôçàâûäëïöüÀÇÉÈÂÊÎÔÛÄËÏÖÜ]).*$';
          vm.msgErrorPatern = "MESSAGES.form_is_patternpwdspecial";
      }else{
          vm.patern = '(?=^.{8,}$)((?=.*\\d)|(?=.*\\W+))(?![.\\n])(?=.*[A-Z])(?=.*[a-z]).*$';
          vm.msgErrorPatern = "MESSAGES.form_is_patternpwd";
      }

    vm.submitAddUserForm = submitAddUserForm;

    vm.activate_code_validation = activate_code_validation;
    function activate_code_validation() {
        $rootScope.activateCodeValidation = !$rootScope.activateCodeValidation;
    }
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_user_add_menuTitle";
      $rootScope.pageRoute = "app.profiles_user_list";

      $rootScope.welcome = "welcome_user_add";
      $rootScope.text = [{
        texte: "parameters_profil_user_add_help"
      }, {
        texte: "send_button_profil_user_add_help"
      }, {
        texte: "cancel_button_profil_user_add_help"
      }];

    }


    vm.ngFlowOptions = {
      target: Routing.generate('api_profiles_post_user_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    var imageName;

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersThemeForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (angular.isDefined(res.location) && angular.isDefined(res.location.path) && res.location.path) {
        vm.empProfilesUserForm.vignette = res.location.path;
        vm.urlVignette = res.location.url;

      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element('#file-uploader').find("label").remove();
        angular.element("#empParametersThemeForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empProfilesUserForm.vignette = "";
        });
      }
    }


    /**
     * Send add User Form
     */
    function submitAddUserForm() {
      $rootScope.loadingProgress = true;
      msApi.request('profiles_user.addUser@save',
        angular.copy({
          "empProfilesUserForm": {
            username: vm.empProfilesUserForm.username,
            email: vm.empProfilesUserForm.email,
            phone: vm.empProfilesUserForm.phone,
            mobile: vm.empProfilesUserForm.mobile,
            firstName: vm.empProfilesUserForm.firstName,
            lastName: vm.empProfilesUserForm.lastName,
            description: vm.empProfilesUserForm.description,
            plainPassword: {
              first: vm.empProfilesUserForm.plainPassword.first,
              second: vm.empProfilesUserForm.plainPassword.second
            },
            channels: vm.empProfilesUserForm.channels,
            group: vm.empProfilesUserForm.group,
            connectionType: vm.empProfilesUserForm.connectionType,
            vignette: vm.empProfilesUserForm.vignette
          }
        }),
        function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isUndefined(res.errors) || (res.code === 200)) {
              vm.user = vm.empProfilesUserForm;
            if(angular.isDefined(res.id) && vm.empProfilesUserForm.activateCodeValidation){
                $mdDialog.show({
                    controller: "activateCodeValidationFormAddController",
                    controllerAs: 'vm',
                    templateUrl: 'app/main/profiles/user/add_edit_view/activate.code.validation.html',
                    clickOutsideToClose: false,
                    locals: {
                        data: {email: vm.empProfilesUserForm.email, id: res.id, username: vm.empProfilesUserForm.username},
                    }
                }).then(function () {
                }, function () {
                });
            }else {
                webTvGlobal.$flashMessages().set('profilesUserAdd', {title: vm.empProfilesUserForm.username ? vm.empProfilesUserForm.username : ""});
                $state.go('app.profiles_user_list');
            }
          }
          else if (angular.isDefined(res.errors)) {

            errors = res.errors;


            vm.empProfilesUsersError = [];

            errors.forEach(function (item) {
              vm.empProfilesUsersError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empProfilesUserForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


  }

    function activateCodeValidationFormAddController(data, webTvGlobal, $injector) {
        var $rootScope = $injector.get('$rootScope'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog'),
            $filter = $injector.get('$filter'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');
        var vm = this;
        vm.data = data;
        vm.show_loading = true;
        vm.show_msg =false;
        vm.msg_error = "";
        vm.cancel = $mdDialog.cancel;
        vm.closeDialog = closeDialog;
        vm.check_code_validation = check_code_validation;
        vm.change_code = change_code;
        function closeDialog() {
            $mdDialog.hide();
            desactivate_code_valiadation();
        }
        function desactivate_code_valiadation() {
            msApi.request(
                'profiles_user.desactivateCodeValidation@save',
                {id: vm.data.id},
                function (res) {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.$flashMessages().set('profilesUserAdd', {title: vm.data.username ? vm.data.username : ""});
                    $state.go('app.profiles_user_list');
                }, function (response) {
                });
        }
        function check_code_validation() {
            $rootScope.loadingProgress = true;
            msApi.request(
                'prof_user.checkCodeValidation@save',
                {id: vm.data.id, code:vm.empUserCodeForm.code},
                function (res) {
                    $rootScope.loadingProgress = false;
                    $mdDialog.hide();
                    webTvGlobal.$flashMessages().set('profilesUserAdd', {title: vm.data.username ? vm.data.username : ""});
                    $state.go('app.profiles_user_list');
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            vm.msg_error = message;
                        });
                    }
                });
        }
        function change_code() {
            vm.msg_error = "";
        }
        msApi.request(
            'prof_user.generateCodeValidation@save',
            {id: vm.data.id, email: vm.data.email},
            function (res) {
                if(res.message === "success_send_code") {
                    vm.show_loading = false;
                    vm.show_msg = true;
                }
            });
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles.ip.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.profiles_ip_edit', {
                url: "/profiles/ip/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/ip/add_edit_view/add_edit.template.html',
                        controller : 'ProfilesIpEditController as vm'
                    }
                },
                resolve: {
                     profilesIpData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('profiles_ip.getIp@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_ip_post_edit_action"
            });


        // API
         msApiProvider.register('profiles_ip.getIp', [Routing.generate('api_profiles_ips_get_detail_ips', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('profiles_ip.editIp', [Routing.generate('api_profiles_ips_post_edit_ips',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.profiles.ip.edit')
    .controller('ProfilesIpEditController', ProfilesIpEditController);

  /** @ngInject */
  function ProfilesIpEditController(webTvGlobal, $translate, msApi, $rootScope, $state, profilesIpData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var ip = profilesIpData;
    var empProfilesIpError = [];
    vm.empProfilesIpForm = {};
    vm.submitIpForm = submitIpForm;
    fillData();


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_ip_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_ip_edit_pagetitle";
      $rootScope.pageRoute = "app.profiles_ip_list";
      $rootScope.welcome = "welcome_profil_ip_edit";
      $rootScope.text = [{
        texte: "parameters_profil_ip_add_help"
      }, {
        texte: "send_button_profil_ip_edit_help"
      }, {
        texte: "cancel_button_profil_ip_add_help"
      }];
    }

    /**
     * Check if ip exists
     * @return if exists get ip Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(ip.code) && ip.code !== 200) $state.go('app.error_404');
      else {
        vm.empProfilesIpForm = {
          ip: ip.ip,
          description: ip.description

        };
        $rootScope.itemName = ip.ip || '';
      }
    }


    /**
     * Send add ip Form
     */
    function submitIpForm() {
      msApi.request('profiles_ip.editIp@save',
        {id: ip.id, "empProfilesIpForm": angular.copy(vm.empProfilesIpForm)},
        function (res) {
          if (res.code === 200) {
            ip = vm.empProfilesIpForm;
            webTvGlobal.$flashMessages().set('profilesIpEdit', {title: vm.empProfilesIpForm.ip ? vm.empProfilesIpForm.ip : ""});
            $state.go('app.profiles_ip_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


            empProfilesIpError = [];

            errors.forEach(function (item) {
              empProfilesIpError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empProfilesUserForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles.ip.add',["datatables"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.profiles_ip_add', {
                url: "/profiles/ip/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/ip/add_edit_view/add_edit.template.html',
                        controller : 'ProfilesIpAddController as vm'
                    }
                },
                resolve: {
                     profilesIpData: function (msApi)
                    {
						return msApi.resolve('profiles_ip.getNewIpData@get',{id:0});
                    }
                    
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_ip_post_add_action"
            });
        
        //API
        msApiProvider.register('profiles_ip.getNewIpData', [Routing.generate('api_profiles_ips_get_detail_ips',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('profiles_ip.addIp', [Routing.generate('api_profiles_ips_post_add_ips')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.profiles.ip.add')
    .controller('ProfilesIpAddController', ProfilesIpAddController);

  /** @ngInject */
  function ProfilesIpAddController($rootScope, $translate, msApi, $state, profilesIpData, webTvGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = true;

    var ip = profilesIpData;
    var empProfilesIpError = [];
    vm.empProfilesIpForm = {
      ip: ip.ip,
      description: ip.description

    };
    vm.submitIpForm = submitIpForm;


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_ip_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_ip_add_menuTitle";
      $rootScope.pageRoute = "app.profiles_ip_list";

      $rootScope.welcome = "welcome_profil_ip_add";
      $rootScope.text = [{
        texte: "parameters_profil_ip_add_help"
      }, {
        texte: "send_button_profil_ip_add_help"
      }, {
        texte: "cancel_button_profil_ip_add_help"
      }];
    }


    /**
     * Send add ip Form
     */
    function submitIpForm() {
      $rootScope.loadingProgress = true;
      msApi.request('profiles_ip.addIp@save',
        {"empProfilesIpForm": angular.copy(vm.empProfilesIpForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('profilesIpAdd', {title: vm.empProfilesIpForm.name ? vm.empProfilesIpForm.name : ""});
            $state.go('app.profiles_ip_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


            empProfilesIpError = [];

            errors.forEach(function (item) {
              empProfilesIpError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empProfilesIpForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.profiles.group.permission', [])
        .config(config);

    /** @ngInject */
    function config(msApiProvider, $stateProvider,$translatePartialLoaderProvider) {
        $stateProvider
            .state('app.core_rights_group', {
                url: "/profiles/group/:id/permission",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profiles/group/permission/permission.template.html',
                        controller: 'PermissionController as vm'
                    }
                },
                resolve: {
                    rightsData: function (msApi, $stateParams) {
                        return msApi.resolve('profilesGroupRights.getGroupByModules@get', {'id': $stateParams.id});
                    },
                    savedModules: function (msApi) {
                        return msApi.resolve('profilesGroupRights.get_saved_modules@get');
                    }
                },
                "actionPermission" : "profiles_group_list_dtable_action"

            });

        //api_export_get_actions
        msApiProvider.register('profilesGroupRights.getGroupByModules', [Routing.generate('api_core_rights_get_group_modules', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('profilesGroupRights.updatePermission', [Routing.generate('api_core_rights_update_group_right_by_permission').replace(/%3A/g, ":")]);
        msApiProvider.register('profilesGroupRights.get_saved_modules', [Routing.generate('api_core_rights_get_modules')]);

      $translatePartialLoaderProvider.addPart('app/main/core_new');
    }
})();

/**
 * Created by ZCONSULTING on 02/10/2017.
 */
(function () {
  'use strict';

  angular
    .module('app.profiles.group.permission')
    .controller('PermissionController', PermissionController);

  /** @ngInject */
  function PermissionController(savedModules, webTvGlobal, $injector, rightsData, $state, $mdDialog, msApi, $rootScope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_group_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.core_rights_module_menuTitle";

      vm.welcome = "welcome_group_permession";
      vm.text = [{
        texte: "add_button_group_permession_help"
      }];

    }

    vm.isSelected = isSelected;
    vm.toggleSelectModules = toggleSelectModules;
    vm.permissionList = permissionList;
    vm.toggleSelectModule = toggleSelectModule;
    vm.showContent = showContent;
    vm.updatePermission = updatePermission;
    vm.updatePermissions = updatePermissions;
    var $translate = $injector.get('$translate');

    vm.modules = [];
    var modules=[];


    var savedModulesArray = [];
    angular.forEach(savedModules.modules, function (item) {
      savedModulesArray.push(item);
    });
    var group = rightsData.group;
    //vm.modulesList = msRights.getModules();
    vm.savedModules = savedModules.modules;

    vm.searchModule = "";
    vm.searchPermission = "";
    vm.selectedModules = [];
    var currentModule = "all";
    vm.selectedModules = [];
    var countItem = 0;
    var rightDataLength = 0;
    angular.forEach(vm.savedModules, function (key, module) {
      countItem++;
      vm.savedModules[module].contents.forEach(function (action) {
        action.authorized = false;
        action.name = action.action.name;
      });
      if (countItem === savedModulesArray.length) {
        if (angular.isDefined(rightsData.modules[0])) {
          vm.rightData = rightsData.modules[0];
          var keys = Object.keys(rightsData.modules[0]);
          rightDataLength = keys.length;
          structurePermission()
        } else {
          angular.forEach(vm.savedModules, function (key, module) {
            modules.push(vm.savedModules[module]);
          });
            vm.modules=modules;
        }
      }
    });

    function structurePermission() {
      var count = 0;
      angular.forEach(vm.rightData, function (key, value) {
        count++;
        var item = vm.rightData[value];
        vm.savedModules[item.module].contents.forEach(function (action) {
          item.contents.forEach(function (elem) {
            if (action.name === elem.action.name) {
              action.authorized = elem.authorized;
              action.actionId = elem.actionId;
              action.permissionId = elem.permissionId;
            }
          })
        });
        if (count === rightDataLength) {
          angular.forEach(vm.savedModules, function (key, module) {
            modules.push(vm.savedModules[module]);
          });
            vm.modules=modules;
        }
      });
    }


    function showContent(module) {
      if (currentModule === "all" || currentModule === module) {
        return true;
      }
      return false

    }

    /*function selectPermission(state) {
        vm.selectedModules = [];
        currentModule.contents.forEach(function (item) {

            if (item.authorized === state) {
                vm.selectedModules.push(item);
            }
        });
        for (var i = 0; i < currentModule.contents.length; i++) {
            if (currentModule.contents[i].authorized === state) {
                vm.selectedModules.push(currentModule[i]);
                continue;
            }


        }
    }*/

    function permissionList(module) {
      deselectModules();
      vm.selectedModules = [];
      currentModule = module;
    }

    function isSelected(module) {
      return vm.selectedModules.indexOf(module) > -1;
    }

    function toggleSelectModule(module, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedModules.indexOf(module) > -1) {
        vm.selectedModules.splice(vm.selectedModules.indexOf(module), 1);
      }
      else {
        vm.selectedModules.push(module);
      }
    }

    function deselectModules() {
      vm.selectedModules = [];
    }

    function updatePermissions() {

      var idGroup = group.id;
      var idPermission;
      var authorization;
      var changePermission;
      var permissions = [];
      $rootScope.loadingProgress = true;
      vm.selectedModules.forEach(function (item) {
        idPermission = item.permission_id;
        authorization = item.authorized ? 'unauthorize' : 'authorize';
        changePermission = {idg: idGroup, idp: idPermission, authorize: authorization};
        permissions.push(changePermission);
      });
      msApi.request("profilesGroupRights.updatePermission@save", {permissions: permissions},
        function (res) {
          $rootScope.loadingProgress = false;
          var confirm = $mdDialog.confirm()
            .title($translate.instant('VALIDATIONS.permission_edit'))
            .htmlContent($translate.instant('VALIDATIONS.permission_success'))
            .ok("OK");
          $mdDialog.show(confirm).then(
            function () {
              $state.reload();
            },
            function () {
              $state.reload();
            });
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {


            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );

    }

    function updatePermission(right) {
      $rootScope.loadingProgress = true;
      var permissions = [];
      var idGroup = group.id;
      var idPermission = right.permission_id;
      var authorization = right.authorized ? 'unauthorize' : 'authorize';
      var changePermission = {idg: idGroup, idp: idPermission, authorize: authorization};
      permissions.push(changePermission);
      msApi.request("profilesGroupRights.updatePermission@save", {permissions: permissions},
        function (res) {
          $rootScope.loadingProgress = false;
          right.authorized = authorization === 'authorize' ? true : false;
          var confirm = $mdDialog.confirm()
            .title($translate.instant('VALIDATIONS.permission_edit'))
            .htmlContent($translate.instant('VALIDATIONS.permission_success'))
            .ok("OK");

          $mdDialog.show(confirm).then(
            function () {
              $state.reload();
            },
            function () {
              $state.reload();
            });
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }

    function selectModules() {
      // Make sure the current selection is cleared
      // before trying to select new threads
      vm.selectedModules = [];
      vm.modules.forEach(function (item) {
        if (currentModule === "all") {
          vm.selectedModules = vm.selectedModules.concat(item.contents);
        }
        else if (currentModule === item.module) {
          vm.selectedModules = vm.selectedModules.concat(item.contents);
          return;
        }

      });

    }

    function toggleSelectModules() {
      if (vm.selectedModules.length > 0) {
        deselectModules();
      }
      else {
        selectModules();
      }
    }


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles.group.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.profiles_group_edit', {
                url    :"/profiles/group/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/group/add_edit_view/add_edit.template.html',
                        controller : 'profilesGroupEditController as vm'
                    }
                },
                resolve: {
                    profilesGroupListRolesData: function (msApi)
                    {
                        return msApi.resolve('profiles_group.getRolesNames@get');
                    },
                    profilesGroupData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('profiles_group.getGroup@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_group_post_edit_action"
            })
            /*.state('app.profiles_group_detail',{
                url: Routing.generate('emp_video_settings_group_detail')+"/:id"
            })*/;


        // Translation
        msApiProvider.register('profiles_group.getRolesNames', [Routing.generate('api_profiles_get_groups_roles')]);
        msApiProvider.register('profiles_group.getGroup', [Routing.generate('api_profiles_get_detail_group',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('profiles_group.editGroup', [Routing.generate('api_profiles_post_edit_group',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}])

    }
})();
(function () {
  'use strict';

  angular
    .module('app.profiles.group.edit')
    .controller('profilesGroupEditController', profilesGroupEditController);

  /** @ngInject */
  function profilesGroupEditController(webTvGlobal, profilesGroupData, profilesGroupListRolesData, $injector) {

    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    vm.groupsRoles = profilesGroupListRolesData.data;
    vm.groupsRoles = convertGroupIdToSelectList(vm.groupsRoles);


    var group = profilesGroupData;
    vm.empProfilesGroupError = [];


    vm.empProfilesGroupForm = {};
    vm.submitAddGroupForm = submitAddGroupForm;
    fillData();


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_group_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_group_edit_pagetitle";
      $rootScope.pageRoute = "app.profiles_group_list";

      $rootScope.welcome = "welcome_group_edit";
      $rootScope.text = [{
        texte: "parameters_profil_group_add_help"
      }, {
        texte: "send_button_profil_group_add_help"
      }, {
        texte: "cancel_button_profil_group_add_help"
      }];
    }

    /**
     * Check if group exists
     * @return if exists get Group Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(group.code) && group.code !== 200) $state.go('app.error_404');
      else {

        vm.empProfilesGroupForm = {
          name: group.name,
          roles: group.roles.length ? group.roles : [],
          description: group.description
        };
        $rootScope.itemName = group.name || '';
      }
    }


    /**
     * Convert List To Select Option format
     */
    function convertGroupIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Group Form
     */
    function submitAddGroupForm() {
      $rootScope.loadingProgress = true;
      msApi.request('profiles_group.editGroup@save',
        {id: group.id, "empProfilesGroupForm": angular.copy(vm.empProfilesGroupForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            group = vm.empProfilesGroupForm;
            webTvGlobal.$flashMessages().set('profilesGroupEdit', group);
            $state.go('app.profiles_group_list');
          }
          else {
            if (angular.isDefined(res.errors)) {

              var errors = res.errors;


              vm.empProfilesGroupError = [];

              errors.forEach(function (item) {

                vm.empProfilesGroupError[item.for] = {
                  message: item.messages[0],
                  value_old: angular.copy(vm.empProfilesGroupForm[item.for])
                };
              });
            }
            else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.profiles.group.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.profiles_group_list', {
                url: "/profiles/group/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/profiles/group/list/list.template.html',
                        controller: 'profilesGroupListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "profiles_group_list_dtable_action"
            });


        // Api
        msApiProvider.register('profiles_group.list', [Routing.generate('api_profiles_get_groups')]);
        msApiProvider.register('profiles_group.list_data_table', [Routing.generate('api_dtable_list_dtable_profiles_groups')]);
        msApiProvider.register('profiles_group.mdelete', [Routing.generate('api_profiles_delete_group') + "/:id", {id: '@id'}]);
        msApiProvider.register('profiles_group.deleteGroups', [Routing.generate('api_multi_delete_multi_profiles_groups') + "/:list", {list: '@list'}]);
        msApiProvider.register('profiles_group.modalGetGroup', [Routing.generate('api_profiles_get_detail_group', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}])


    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.profiles.group.list')
        .controller('profilesGroupDetailController', profilesGroupDetailController);

    /** @ngInject */
    function profilesGroupDetailController(profilesGroupData,$mdDialog)
    {
    	var vm = this;
        vm.group = profilesGroupData;

      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }



    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.profiles.group.add', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.profiles_group_add', {
                url    :"/profiles/group/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/profiles/group/add_edit_view/add_edit.template.html',
                        controller : 'profilesGroupAddController as vm'
                    }
                },
                resolve: {
                    profilesGroupListRolesData: function (msApi)
                    {
                        return msApi.resolve('profiles_group.getRolesNames@get');
                    },
                    profilesGroupData: function (msApi)
                    {
                        return msApi.resolve('profiles_group.getNewGroupData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "profiles_group_post_add_action"
            })
            /*.state('app.profiles_group_detail',{
                url: Routing.generate('emp_video_settings_group_detail')+"/:id"
            })*/;

       
        // Translation
       
        //API
        msApiProvider.register('profiles_group.getRolesNames', [Routing.generate('api_profiles_get_groups_roles')]);
        msApiProvider.register('profiles_group.getNewGroupData', [Routing.generate('api_profiles_get_detail_group',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('profiles_group.addGroup', [Routing.generate('api_profiles_post_add_group')]);
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.profiles.group.add')
    .controller('profilesGroupAddController', profilesGroupAddController);

  /** @ngInject */
  function profilesGroupAddController(msApi, profilesGroupData, webTvGlobal, profilesGroupListRolesData, userManager, $injector) {
    // Translation
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate');
    var vm = this;
    vm.isNew = true;
    vm.empProfilesGroupError = [];

    vm.groupsRoles = profilesGroupListRolesData.data;

    vm.groupsRoles = convertGroupIdToSelectList(vm.groupsRoles);


    var group = profilesGroupData;
    vm.empProfilesGroupForm = {
      name: '',
      roles: userManager.isSuperAdmin() ? [] : ["ROLE_USER"],
      description: ''
    };

    vm.submitAddGroupForm = submitAddGroupForm;
    vm.convertGroupIdToSelectList = convertGroupIdToSelectList;

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_group_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_group_add_menuTitle";
      $rootScope.pageRoute = "app.profiles_group_list";

      $rootScope.welcome = "welcome_profil_group";
      $rootScope.text = [{
        texte: "parameters_profil_group_add_help"
      }, {
        texte: "send_button_profil_group_add_help"
      }, {
        texte: "cancel_button_profil_group_add_help"
      }];
    }


    /**
     * Convert List To Select Option format
     */
    function convertGroupIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Group Form
     */
    function submitAddGroupForm() {
      $rootScope.loadingProgress = true;
      msApi.request('profiles_group.addGroup@save',
        angular.copy({
          "empProfilesGroupForm": {
            name: vm.empProfilesGroupForm.name,
            roles: vm.empProfilesGroupForm.roles,
            description: vm.empProfilesGroupForm.description
          }
        }),
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            group = vm.empProfilesGroupForm;
            webTvGlobal.$flashMessages().set('profilesGroupAdd', {title: vm.empProfilesGroupForm.name ? vm.empProfilesGroupForm.name : ""});
            $state.go('app.profiles_group_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


            vm.empProfilesGroupError = [];

            errors.forEach(function (item) {
              vm.empProfilesGroupError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empProfilesGroupForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.profiles.group.list')
    .controller('profilesGroupListController', profilesGroupListController);

  /** @ngInject */
  function profilesGroupListController(msUtils, msApi, $cookies, webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $injector, $scope, dtable_language,dialogConfirmDeleteService, $sce) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $compile = $injector.get('$compile'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog');
    var vm = this;
    var numberRecords = $cookies.get('numberRecords') || 10;
    vm.groups = [];
    vm.selectedGroups = [];
    var selectedGroups = [];
    vm.dataTableSearchWord = "";
    vm.searchGroups = searchGroups;
    var checkedSelected = false;
    vm.dtInstance = {};
    vm.groups = vm.groupsDataTable = [];
    vm.fnCallback = undefined;
    var drawIndex = 1;
    var filtre = {};
    var recordsTotal = 0;
    if (window.process.env.isNewGroup) {
      vm.isNewGroup = window.process.env.isNewGroup;
      vm.newGroupIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_Profile_Group + "?lang="+ $cookies.get("WEBTV.locale") +  "&token="  + $cookies.get("authToken")
       );
      $scope.$watch(function () {
        vm.newGroupIframe = $sce.trustAsResourceUrl(
            "https:" +
            window.process.env.URL_Profile_Group +"?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")
        );
      });
    }
    $rootScope.DTOptionsBuilder = DTOptionsBuilder;
    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withFnServerData(serverData)
      .withDataProp('data')
      .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
      .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
      .withOption('processing', true)
      .withOption('serverSide', true)
      .withOption('columnDefs', [[
        {
          // Target the checkbox column
          targets: 0,
          responsivePriority: 1
        },
        {
          targets: [1],
          width: '72px'
        },
        {
          targets: 4,
          render: function (data) {
            if (data === "") return "--";
            if (parseInt(data) < 1) return "--";
            return data;
          }
        },
        {
          // Target the actions column
          targets: 5,
          filterable: false,
          sortable: false
        }
      ]
      ])
      .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
      .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
      .withOption('pageLength', parseInt(numberRecords))
      .withOption('scrollY', 'auto')
      .withOption('responsive', true)
      .withOption('createdRow', function (row) {
        $compile(angular.element(row).contents())($scope);
      })
      .withPaginationType('full_numbers');
    $rootScope.DtOptions = vm.dtOptions;
    vm.dtColumns = [
      DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
        .renderWith(function (data) {
          vm.groupsDataTable[data.id] = data;
          return '<md-checkbox ng-checked="vm.groupsDataTable[' + data.id + '].checked"' +
            'ng-click="vm.toggle(vm.groupsDataTable[' + data.id + '])"' +
            'aria-label="-">' +
            '</md-checkbox> ';
        }),
      DTColumnBuilder.newColumn('id').renderWith(function (data) {
        return angular.isDefined(data) ? data : "";
      }),
      DTColumnBuilder.newColumn('name').renderWith(function (data) {
        return angular.isDefined(data) ? data : "";
      }),
      DTColumnBuilder.newColumn('roles')
        .renderWith(function (data) {
          if (!data.length) return "<strong md-colors=\"{color:'#000000'}\" translate='MESSAGES.none'></strong>";
          var list = "<div >__items</div>";
          var item = "<div><strong translate=\"GROUPADD.__item\"> __item</strong></div>";
          var items = "";
          data.forEach(function (element) {
            items += item.replace(/__item/g, element);
          });
          return list.replace(/__items/, items);
        }),
      DTColumnBuilder.newColumn('description').renderWith(function (data) {
        return angular.isDefined(data) ? data : "";
      }),
      DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
        .renderWith(function (data) {
          vm.groupsDataTable[data.id] = data;
          var buttonActionPermissionHtml =
            '<a has-permission="profiles_group_permission_no_api" tooltips tooltip-template=' + "{{'GROUPLIST.permission_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
            '<md-button class="edit-button md-icon-button" ui-sref="app.core_rights_group({id: ' + data.id + '})"  aria-label="permission_group" translate translate-attr-aria-label="GROUPLIST.permission_group">' +
            '<md-icon  md-font-icon="icon-lock-unlocked" class="s18"></md-icon>' +
            '</md-button></a>';
          var buttonActionDetailHtml =
            '<a has-permission="profiles_group_get_detail_action" tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
            '<md-button class="show-button md-icon-button" ng-click="vm.showGroupDetail(vm.groupsDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail" >' +
            '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
            '</md-button></a>';
          var buttonActionEditHtml =
            '<a has-permission="profiles_group_post_edit_action" tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
            '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.profiles_group_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" >' +
            '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
            '</md-button></a>';
          var buttonActionDeleteHtml =
            '<a has-permission="profiles_group_delete_group_action" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
            '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteGroupConfirm(vm.groupsDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete" >' +
            '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
            ' </md-button></a>';
          var actionButtons='<div class="actionList"> '+buttonActionPermissionHtml + buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + '</div>'

          return actionButtons;
        })
    ];


    function serverData(sSource, aoData, fnCallback) {

      //All the parameters you need is in the aoData variable
      var draw = aoData[0].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var sort = angular.copy(order[0]);
      var numColum = sort.column - 1 < 0 ? 0 : sort.column - 1;
      vm.selectedGroups = [];
      checkedSelected = false;
      filtre = {
        draw: draw,
        start: start,
        length: length,
        "search[value]": vm.dataTableSearchWord,
        "order[0][column]": numColum,
        "order[0][dir]": sort.dir
      };
      filtre["columns[" + numColum + "][orderable]"] = true;
      vm.fnCallback = fnCallback;
      searchGroupsInAPI(filtre);
    }

    function searchGroupsInAPI(filtre) {
      $cookies.put('numberRecords', filtre.length);
      msApi.request('profiles_group.list_data_table@get', filtre,
        function (response) {
          var records = {};
          if (response.code === 200) {
            records = {
              'draw': drawIndex,
              'recordsTotal': response.recordsTotal,
              'recordsFiltered': response.recordsFiltered,
              'data': response.data
            };
            drawIndex = drawIndex + 1;
            vm.groups = response.data;
            recordsTotal = response.recordsTotal;
            vm.fnCallback(records);
            webTvGlobal.fixDatatableFirefox();
          }
          else {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {
              records = {
                'draw': 0,
                'recordsTotal': 0,
                'recordsFiltered': 0,
                'data': 0
              };
              vm.groups = [];
              recordsTotal = 0;
              vm.fnCallback(records);
              $rootScope.loadingProgress = false;
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }

          }
        },
        function (response) {
          if (response.status != 401) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        }
      );

    }

    function getElement() {
      var element = document.querySelectorAll('md-checkbox.md-default-theme');

      var left = element[0].offsetLeft;

      var leftDelete = left - 35;

      $scope.myObjStyle = {"margin-left": leftDelete}
    }

    /**
     * Trigger DataTable Search procedure using the server side method
     */
    function searchGroups() {
      filtre["search[value]"] = vm.dataTableSearchWord;
      searchGroupsInAPI(filtre);
    }

    vm.deleteGroupConfirm = deleteGroupConfirm;
    vm.deleteGroupsConfirm = deleteGroupsConfirm;
    vm.toggleAll = toggleAll;
    vm.toggle = toggle;
    vm.showGroupDetail = showGroupDetail;
    vm.addNewGroup = addNewGroup;
    $rootScope.rerender = rerender;
    var flashMessages = {title: ""};
    showFlasMessageToast('profilesGroupAdd', $translate.instant('GROUPLIST.added'), {
      bottom: true,
      top: false,
      left: false,
      right: true
    });
    showFlasMessageToast('profilesGroupEdit', $translate.instant('GROUPLIST.edited'));


    /**
     * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
     * @param  op : crud operation
     * @param  message message to show
     * @param  toastPosition position of the toast
     */
    function showFlasMessageToast(op, message, toastPosition) {
      if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.profiles_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.profiles_group_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.profiles_group_list_pagetitle";
      $rootScope.pageRoute = "";

      $rootScope.welcome = "welcome_profil_group";
      $rootScope.text = [{
        texte: "add_button_profil_group_help"
      }, {
        texte: "arrow_button_profil_group_help"
      }, {
        texte: "search_area_profil_group_help"
      }, {
        texte: "tri_column_profil_group_help"
      }, {
        texte: "permission_button_profil_group_help"
      },
        {
          texte: "edit_button_profil_group_help"
        }, {
          texte: "detail_button_profil_group_help"
        },
        {
          texte: "delete_button_profil_group_help"
        }];
    }


    /**
     * Check If there's and CRUD Operation that happened before getting to the list page
     * @param   op : operation name
     * @return  bool
     */

    function checkFlashMessage(op) {
      var data = webTvGlobal.$flashMessages().get(op);
      if (!flashMessages.title) flashMessages.title = data ? data.title : "";
      return data ? true : false;
    }

    /**
     * Clear Flash Message when an action is triggered
     */
    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    /**
     * Toggle selected status of the user
     *
     * @param group
     */
    function toggle(group) {
      group.checked = !group.checked;
      var idx = selectedGroups.indexOf(group);
      if (idx > -1) {
        selectedGroups.splice(idx, 1);
      }
      else {
        selectedGroups.push(group);
      }
      vm.selectedGroups = angular.copy(selectedGroups);
    }

    function toggleAll() {
      // getElement();
      if (selectedGroups.length === vm.groups.length) {
        vm.selectedGroups = [];
      }
      else if ((selectedGroups.length === 0) || (selectedGroups.length > 0)) {
        vm.selectedGroups = vm.groups.slice(0);
      }
      selectedGroups = angular.copy(vm.selectedGroups);
      var list_group = angular.copy(vm.groupsDataTable);
      angular.forEach(list_group, function (value, key) {
        if (value !== undefined)
          vm.groupsDataTable[key].checked = selectedGroups.length > 0;
      });
    }

    /**
     * Show GroupDetails
     * @param group
     */
    function showGroupDetail(group, ev) {
      clearFlashMessage();
      if (ev) {
        ev.preventDefault();
      }
      $rootScope.loadingProgress = true;

      msApi.request('profiles_group.modalGetGroup@get', {id: group.id},
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.code) && response.code === 200) {
            $mdDialog.show({
              locals: {profilesGroupData: response},
              templateUrl: 'app/main/profiles/group/detail/detail.modal.html',
              clickOutsideToClose: true,
              controller: 'profilesGroupDetailController',
              controllerAs: 'vm'
            })
          }
          else {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATION.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );

    }

    /**
     * rerender datatable
     */
    function rerender() {
      if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchGroupsInAPI(filtre), true);
    }


    /**
     * redirection to add new group page
     * @param event
     */
    function addNewGroup() {
      clearFlashMessage();
      $state.go('app.profiles_group_add');
    }

    /**
     * Delete GroupConfirm Dialog
     */
    function deleteGroupConfirm(Group, ev) {
      $translate([
        "MESSAGES.dialog_confirm_delete",
        "MESSAGES.dialog_cancel",
        "MESSAGES.dialog_will_be_deleted",
        "GROUPLIST.delete_group_msg",
        "GROUPLIST.delete_group_aria_label"
      ])
        .then(function (translatedValues) {
          var confirm = $mdDialog.confirm()
            .title(translatedValues['GROUPLIST.delete_group_msg'])
            .htmlContent('<b>' + Group.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
            .ariaLabel(translatedValues['GROUPLIST.delete_group_aria_label'])
            .targetEvent(ev)
            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
            .cancel(translatedValues['MESSAGES.dialog_cancel']);

          $mdDialog.show(confirm).then(function () {

            deleteGroup(Group);
            vm.selectedGroups = [];

          }, function () {

          });
        });


    }

    /**
     * Delete Group
     */
    function deleteGroup(Group) {
      clearFlashMessage();
      if (vm.groups.indexOf(Group) !== -1) {
        $rootScope.loadingProgress = true;
        msApi.request('profiles_group.mdelete@delete', {id: Group.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (response.code === 200) {
              $translate([
                "GROUPLIST.dialog_alert_delete_title",
                "GROUPLIST.dialog_alert_delete_description",
                "GROUPLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['GROUPLIST.dialog_alert_delete_title'],
                    textContent: Group.name + " " + translatedValues['GROUPLIST.dialog_alert_delete_description'],
                    ok: translatedValues['GROUPLIST.dialog_alert_delete_close']
                  });

                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                  vm.groups.splice(vm.groups.indexOf(Group), 1);
                  rerender();
                });

            }
            else {
              $translate([
                "GROUPLIST.dialog_alert_delete_error_title",
                "GROUPLIST.dialog_alert_delete_error_description",
                "GROUPLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['GROUPLIST.dialog_alert_delete_error_title'],
                    textContent: translatedValues['GROUPLIST.dialog_alert_delete_error_description'],
                    ok: translatedValues['GROUPLIST.dialog_alert_delete_close']
                  });

                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                });

            }
          },
          function (response) {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                $translate([
                  "GROUPLIST.dialog_alert_delete_error_title",
                  "GROUPLIST.dialog_alert_delete_error_description",
                  "GROUPLIST.dialog_alert_delete_close"
                ])
                  .then(function (translatedValues) {
                    var alert = $mdDialog.alert({
                      title: translatedValues['GROUPLIST.dialog_alert_delete_error_title'],
                      textContent: translatedValues['GROUPLIST.dialog_alert_delete_error_description'],
                      ok: translatedValues['GROUPLIST.dialog_alert_delete_close']
                    });

                    $mdDialog
                      .show(alert)
                      .finally(function () {
                        alert = undefined;
                      });
                  });
              })
            }
            else {
              $translate([
                "GROUPLIST.dialog_alert_delete_error_title",
                "GROUPLIST.dialog_alert_delete_error_description",
                "GROUPLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['GROUPLIST.dialog_alert_delete_error_title'],
                    textContent: translatedValues['GROUPLIST.dialog_alert_delete_error_description'],
                    ok: translatedValues['GROUPLIST.dialog_alert_delete_close']
                  });

                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                });
            }
          }
        );

      }
      else {
        $translate([
          "GROUPLIST.dialog_alert_delete_error_title",
          "GROUPLIST.dialog_alert_delete_error_description",
          "GROUPLIST.dialog_alert_delete_close"
        ])
          .then(function (translatedValues) {
            var alert = $mdDialog.alert({
              title: translatedValues['GROUPLIST.dialog_alert_delete_error_title'],
              textContent: translatedValues['GROUPLIST.dialog_alert_delete_error_description'],
              ok: translatedValues['GROUPLIST.dialog_alert_delete_close']
            });

            $mdDialog
              .show(alert)
              .finally(function () {
                alert = undefined;
              });
          });
      }


    }


    /**
     * Delete Mulitple groups Confirm Dialog
     * @param  ev : triggered element
     */
    function deleteGroupsConfirm(ev) {
      var title;
      var ariaLabel;
      if (selectedGroups.length !==0 )
{
  if (selectedGroups.length === 1) {
    title = 'GROUPLIST.delete_group_msg';
    ariaLabel = 'GROUPLIST.delete_group_aria_label';
  } else {
    title = 'GROUPLIST.delete_list_group_msg';
    ariaLabel = 'GROUPLIST.delete_groups_aria_label';
  }


  $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, selectedGroups.length, title, ariaLabel)).then(function () {


    deleteGroups(ev);
  }, function () {

  });


}
}

/**
 * Delete Mulitple request
 * @param  ev : triggered element
 */
function deleteGroups(ev) {
  $rootScope.loadingProgress = true;
  msApi.request(
    'profiles_group.deleteGroups@delete',
    {
      list: (function (list) {
        selectedGroups.forEach(function (item) {
          list.push(item.id);
        });
        return list;
      })([])
    },
    function (response) {
      $rootScope.loadingProgress = false;
      if (response.code === 200) {
        var undeleted = "";
        var deleted = "";
        if (response.result.undeleted.length !== 0) {
          undeleted = $translate.instant("GROUPLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
        }
        deleted = $translate.instant("GROUPLIST.deleted_are", {'list': response.result.deleted.join(",")});
        webTvGlobal.alertDialog(
          deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
          $translate.instant('GROUPLIST.mdelete_success'),
          '',
          ev
        );
        selectedGroups = [];
        rerender();

      }
      else {
        webTvGlobal.alertDialog(
          $translate.instant('GROUPLIST.dialog_alert_delete_error_title'),
          $translate.instant('GROUPLIST.dialog_alert_delete_error_description'),
          '',
          ev
        );
        selectedGroups = [];
      }
    },
    function (response) {
      $rootScope.loadingProgress = false;
      if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
        $translate('VALIDATIONS.' + response.data.message).then(function (message) {

          webTvGlobal.alertDialog(message);
        }), function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        };
      }
      else {

        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      }

      selectedGroups = [];
    }
  );
}


}
})
();

(function () {
    'use strict';

    angular
        .module('app.media.video.list', ['app.export', 'ngSanitize', 'datatables', 'angularMultiSlider', 'ui.mask', 'ngclipboard', 'datatables', 'app.stats.vod_live', 'ngAnimate', 'app.media.video.email','ngMaterial'])
        .config(config);

    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.media_video', {
                url: "/medias/videos",
                abstract: true,
                resolve: {}
            })
            .state('app.media_video_list', {
            parent: 'app.media_video',
            url: '?type',
                reloadOnSearch:false,
            views: {
                'content@app': {
                    templateUrl: 'app/main/media/video/list/list.template.html',
                    controller: 'mediaVideoListController as vm'
                }
            },
            resolve: {},
            "bodyClass": "e-commerce",
            "actionPermission": {all: "media_video_list_dtable_videos_all_action", ongoing:"media_video_list_dtable_videos_ongoing_action", archived:"media_video_list_dtable_videos_archived_action", upcoming:"media_video_list_dtable_videos_upcoming_action", offline:"media_video_list_dtable_videos_offline_action"}
        });


        var deleteListVideos = Routing.generate('api_multi_delete_videos') + "/:list";
        msApiProvider.register('media_video.getTransodedMetaData', [Routing.generate('api_media_get_transcoded_video_meta_data', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getUrlListVideo', [Routing.generate('api_media_get_url_list_video')]);
        msApiProvider.register('parameters_themes.getThemes', [Routing.generate('api_parameters_get_themes_for_mobile')]);
        msApiProvider.register('media_video.toogleHomePage', [Routing.generate('api_media_add_home_page_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.toogleByType', [Routing.generate('api_media_post_toggle_video_by_type')]);
        msApiProvider.register('media_video.saveVideoSettings', [Routing.generate('api_media_post_save_setting_video')]);
        msApiProvider.register('media_video.saveVideoSkin', [Routing.generate('api_media_post_set_default_skin_video')]);
        msApiProvider.register('media_video.deleteHomePage', [Routing.generate('api_media_delete_home_page_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video.checkTranscodOperation', [Routing.generate('api_media_post_check_if_videos_are_done_transoding')]);
        msApiProvider.register('media_video.getMetaData', [Routing.generate('api_media_get_video_meta_data')]);
        msApiProvider.register('media_video.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.enablePushVideo', [Routing.generate('api_media_post_enable_push_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('media_video.disablePushVideo', [Routing.generate('api_media_post_disable_push_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('media_home.getpushVod', [Routing.generate('api_media_get_push_video')]);
        msApiProvider.register('media_video.exportYoutube', [Routing.generate('api_export_get_authentication_code')]);
        msApiProvider.register('media_video.exportDailmymotion', [Routing.generate('api_export_dailymotion_get_login')]);
        msApiProvider.register('media_video.delete', [Routing.generate('api_media_delete_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video.getUrlExport', [Routing.generate('api_media_get_video_url') + "/:id", {id: '@id'}]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('media_video.dtableAll', [Routing.generate('api_dtable_list_dtable_videos')]);
        msApiProvider.register('media_video.dtableOnGoing', [Routing.generate('api_dtable_list_dtable_videos_ongoing')]);
        msApiProvider.register('media_video.dtableUpComing', [Routing.generate('api_dtable_list_dtable_videos_upcoming')]);
        msApiProvider.register('media_video.dtableArchieved', [Routing.generate('api_dtable_list_dtable_videos_archived')]);
        msApiProvider.register('media_video.dtableOffLine', [Routing.generate('api_dtable_list_dtable_videos_offline')]);
        msApiProvider.register('media_video.download', [Routing.generate('api_media_download_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video.deleteVideos', [deleteListVideos, {list: '@list'}]);
        msApiProvider.register('media_video.deleteAudioDescription', [Routing.generate('api_media_delete_audio_description') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video.checkTranscodAudioDesc', [Routing.generate('api_media_post_check_treatment_audio_description')]);
        msApiProvider.register('media_video.lastMontage', [Routing.generate('api_media_get_date_last_montage') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video.getChronologie', [Routing.generate('api_media_get_list_steps_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video_add_language.getUrlUpdate', [Routing.generate('api_media_get_url_update_step_video')]);
        msApiProvider.register('media_video_add_language.addLang', [Routing.generate('api_media_post_adds_video')]);
        msApiProvider.register('media_video_list_subscribers.subscribers', [Routing.generate('api_subscription_user_get_users')]);
        msApiProvider.register('media_video_list_subscribers.getVideoSubscribers', [Routing.generate('api_media_get_subscription_users_for_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('media_video_list_subscribers.addVideoSubscribers', [Routing.generate('api_media_add_subscription_users_for_video') + "/:id" + '?idsSubscriptionUsers=[:list]', {
            id: '@id',
            list: '@list'
        }]);
        msApiProvider.register('media_video.number_visits', [Routing.generate('api_media_get_number_visits')]);
        msApiProvider.register('media_video.transcription', [Routing.generate('api_media_get_transcription_video')]);
        msApiProvider.register('media_video.checkTranscodTranscription', [Routing.generate('api_media_post_check_if_videos_are_done_transcription')]);
        msApiProvider.register('multilangue.deleteLang', [Routing.generate('api_media_delete_lang_video')]);
        msApiProvider.register('multilangue.getUrlExport', [Routing.generate('api_media_get_video_url') + "/:id", {id: '@id'}]);
        msApiProvider.register('multilangue.editLang', [Routing.generate('api_media_edit_lang_video')]);
        msApiProvider.register('multilangue_video.getAutoGeneratedThumbs', [Routing.generate('api_media_get_video_auto_generated_thumbs', {title: ':title'}).replace(/%3A/, ":")]);
        msApiProvider.register('multilangue_video.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")]);
        msApiProvider.register('multilangue_video.updateSource', [Routing.generate('api_media_post_update_video_source', {id: ':id'}).replace(/%3A/g, ":"), {id: '@id'}]);
        msApiProvider.register('media_video.getOnHoldVids', [Routing.generate('api_media_on_hold_videos')]);
        msApiProvider.register('modal-preview-montage-video.getMontageNewPreview', [Routing.generate('api_media_get_video_preview_link_by_source_montage_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_richMedia_player_new.getPreviewNewLink', [Routing.generate('api_media_get_video_editor_preview_link', {id: ':id'}).replace(/%3A/, ":")]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.media.video.list')
        .controller('multilangueVideoReuploadController', multilangueVideoReuploadController);

    /** @ngInject */
    function multilangueVideoReuploadController(lang, video, $scope, $translate, msApi, $rootScope, $state, webTvGlobal, $stateParams, $timeout, userManager, $sce, $mdDialog, webTv_msNavigation) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var vm = this;
        vm.uploadStep = 1;
        var videoThemesIds = [];
        // var videoData = {};
        vm.videoThumb = "";
        var mediaVideoOnHoldData;
        var applyingModification = true;


        function setThemesIds(data) {
            for (var i = 0; i < data.length; i++) videoThemesIds.push(data[i].id);
        }

        /*** Upload Parameters *******/
        vm.videoFile = undefined;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        vm.ngFlowOptions = {
            chunkSize: (function () {
                return Math.pow(10, 100);
            })(),
            testChunks: false,
            target: parameters['upload.script_url'],
            singleFile: true,
            extendChunks: false,
            fileParameterName: 'Filedata',
            query: {
                webtv_name: parameters['app.webtv.name'],
                path_file: parameters['upload.from_server_root_path'],
                user_id: userManager.getId(),
                timestamp: moment().unix(),
                token: md5("unique_salt" + moment().unix())
                //callback_step_url:Routing.generate("emp_site_homepage",{},true)//Use the step Callback Later
            }
        };
        vm.ngFlow = {
            flow: {}
        };
        vm.dropping = false;
        vm.fileAdded = fileAdded;
        vm.uploadFile = uploadFile;
        vm.fileSuccess = fileSuccess;
        vm.uploadComplete = uploadComplete;
        vm.fileProgress = fileProgress;
        vm.cancelUpload = cancelUpload;
        vm.cancel = cancel;
        vm.save = save;
        vm.showMore = showMore;
        vm.progressBarValue = 0;
        vm.roundWithPrecision = roundWithPrecision;
        vm.inProgress = false;
        vm.videoKeyName = "";
        vm.videoSuibFolder = "";

        function cancel() {
            $mdDialog.cancel();
        }

        function getPlayerLink() {
            msApi.request(
                'multilangue_video.getPreviewLinkByTitle@get',
                {"title": vm.videoKeyName, "y": "bo", "subFolder": vm.videoSubFolder},
                function (res) {
                    if (res.code === 200) {
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                        vm.getGeneratedThumbs();
                        vm.uploadStep = 2;
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            vm.videoFile = file;
        }

        function fileProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            vm.ngFlow.flow.opts.headers = {};
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            var data = JSON.parse(message);
            if (angular.isDefined(data.file_name)) {
                vm.videoKeyName = data.file_name;
            } else return;
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            vm.progressBarValue = 0;
            vm.inProgress = false;
            $rootScope.loadingProgress = false;
            if (angular.isDefined(vm.videoFile) && vm.videoKeyName) {
                save();
                vm.cancel();
                // webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFile.name}), '', function () {
                //   vm.videoKeyName = "";
                // }).then(function () {
                // if (videoData.isTranscoded) {
                vm.playerIsLoading = 1;

                // }
                // else {
                //   vm.getGeneratedThumbs();
                //   applyingModification = false;
                //   vm.uploadStep = 2;
                // }
                // });
            }
            else {
                if (!angular.isDefined(vm.videoFile)) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }

        }

        /**
         * Stop upload operation
         */
        function cancelUpload() {
            $timeout(function () {
                vm.ngFlow.flow.cancel();
            });

        }


        /*** End Upload Parameters and Methods ***/
        //******** Thumbs part Parameters and Methods ***********//
        vm.thumbs = [];
        vm.setAndPreviewThumb = setAndPreviewThumb;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        vm.productImageMediaStyle = {cursor: "pointer"};
        vm.innerThumbStyle = {
            position: 'relative',
            width: '200px',
            height: '200px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            margin: '8px'
        };
        vm.getGeneratedThumbs = getGeneratedThumbs;
        vm.loadingGeneratedThumbs = 1;
        vm.errorOnGettingGeneratedThumbs = 0;
        vm.playerLink = "";
        vm.playerIsLoading = 0;


        /**
         * This function asks the api to communicate with the processing server and return us array of 5 thumbs
         */
        function getGeneratedThumbs() {
            vm.loadingGeneratedThumbs = 1;
            vm.errorOnGettingGeneratedThumbs = 0;
            msApi.request('multilangue_video.getAutoGeneratedThumbs@get',
                {"title": vm.videoKeyName, "subFolder": vm.videoSuibFolder},
                function (res) {
                    var data = angular.fromJson(res.response);
                    if (data.thumbnails.length) {
                        vm.thumbs = [];
                        var thumbs = [];
                        for (var i = 0; i < data.thumbnails.length; i++) {
                            thumbs.push(data.path_to_thumbnail + "/" + data.thumbnails[i]);
                        }
                        vm.thumbs = thumbs;
                    }
                    $timeout(function () {
                        vm.loadingGeneratedThumbs = 0;
                        vm.errorOnGettingGeneratedThumbs = 0;
                    })

                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.loadingGeneratedThumbs = 0;
                    vm.errorOnGettingGeneratedThumbs = 1;
                }
            );
        }

        function setAndPreviewThumb(thumb) {
            vm.videoThumb = thumb;
        }

        /*** End Thumbs part  Parameters and Methods ***/
        // fillData();
        //
        // function fillData() {
        //   if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
        //   setThemesIds(videoData.themes);
        //   $rootScope.itemName = videoData.title || '';
        //   vm.videoThumb = videoData.logo || null;
        //
        // }


        function save() {
            applyingModification = true;
            msApi.request('multilangue_video.updateSource@save',
                {
                    "id": video.id,
                    title: vm.videoKeyName,
                    thumb: vm.videoThumb,
                    lang: lang,
                    "subFolder": vm.videoSuibFolder,
                     "client": parameters['app.client.name']
                },
                function (res) {

                    if (res.code === 200) {
                        webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                        document.getElementById('iframe_list').contentWindow.postMessage({
                            "info": "successEditSrc"
                        }, "*");
                    }
                    else {
                        vm.uploadStep = 1;
                        webTvGlobal.alertDialog(res.message);
                    }
                },
                function (response) {
                    vm.uploadStep = 1;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        init();

        function init() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
            $rootScope.titre3 = "";
          }else{
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
          }
            $rootScope.pageRoute = "app.media_video_list_ongoing";
        }

        $scope.treeEventsObj = {
            'changed.jstree': selectNode

        };

        function selectNode(e, data) {
            var i, j;
            vm.videoKeyName = "";
            vm.videoSubFolder = "";
            if (data.node.icon === "icon-video") {
                for (i = 0, j = data.selected.length; i < j; i++) {
                    vm.videoKeyName = data.instance.get_node(data.selected[i]).text;
                    vm.videoSubFolder = webTvGlobal.getPathFile(vm.videoSubFolder, data, data.instance.get_node(data.selected[i]));
                    //$state.go('app.media_video_add', {"slug": md5(moment().unix), "title": title})
                }
                save();
                cancel();
                // if (videoData.isTranscoded) {
                //     vm.playerIsLoading = 1;
                //     getPlayerLink()
                // }
                // else {
                //     vm.getGeneratedThumbs();
                //     vm.uploadStep = 2;
                // }
            }

        }

        $scope.treeConfig = {
            core: {
                multiple: false,
                animation: false,
                error: function (error) {
                    $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback: true,
                worker: true
            },

            'plugins': ['sort', 'wholerow'],

            'sort': function (a, b) {
                var a1 = this.get_node(a);
                var b1 = this.get_node(b);
                if (a1.icon === b1.icon) {
                    return (a1.text > b1.text) ? 1 : -1;
                } else {
                    return (a1.icon > b1.icon) ? 1 : -1;
                }
            }

            ,
            version: 1
        };
        msApi.request(
            'media_video.getOnHoldVids@get',
            function (res) {
                mediaVideoOnHoldData = res;
                var test = mediaVideoOnHoldData.data;
                vm.treeInstance = [];
                vm.tree = [];
                var tree = [];
                if (test.length > 0) {
                    showMore();
                }
                if (test.length > 20) {
                    vm.testData = true;

                }
                else
                    vm.testData = false;
            })


        function showMore() {
            var i = 0;
            var j = tree.length;
            do {
                tree.push(test[i + j]);
                if (test[i + j].parent === "#") {
                    i++;
                } else {
                    j++
                }
            } while (i < 20 && i + j < test.length);
            if (i < 19) {
                vm.testData = false;
            }

            vm.tree = tree;
        }

    }

})();




(function () {


  'use strict';

  angular
    .module('app.media.video.list')
    .controller('mediaVideoUrlModalController', mediaVideoUrlModalController);

  /** @ngInject */
  function mediaVideoUrlModalController($mdDialog, $injector, video, id, webTvGlobal, msApi, $animate,$rootScope, $cookies) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.socialNetwork=false;
      if (video.isVisibleOnInternet && video.isVisibleOnIntranet)
          vm.intranet = false;
      else if (video.isVisibleOnInternet)
          vm.intranet = true;
      else if (video.isVisibleOnIntranet)
          vm.intranet = false;
    vm.listSubscriptionGroup = listSubscriptionGroup;
    var $document = webTvGlobal.$document;
    vm.spinner = true;
    var $window = $injector.get('$window');
    vm.video = video?video:{};
    vm.video_id = id;
    var isOpen = false;
    var $state = $injector.get('$state');
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.isIntranet_Internet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
    else vm.isIntranet_Internet = '0';
    vm.title = vm.video.title;
    vm.link_embed = vm.video.link_embed;
    vm.link_embed_simple = angular.isDefined(vm.video.link_embed_simple)?vm.video.link_embed_simple:"";
    vm.link_embed_richmedia = angular.isDefined(vm.video.link_embed_interactivity_with_timeline)?vm.video.link_embed_interactivity_with_timeline:"";
    vm.link_embed_intranet = vm.video.link_embed_intranet;
    vm.link_permalien = vm.video.link;
    vm.isChannelExport = typeof vm.link_permalien === 'object';
    vm.show_more_mp4 = "min";
    vm.show_more_embed = "min";
    vm.link_permalien_intranet = vm.video.link_intranet;
    vm.show_cdn_url = vm.video.show_cdn_url;
    vm.cdn_web = vm.show_cdn_url;
    $animate.enabled(true);
    if (vm.show_cdn_url === "1") {
      vm.link_embed = vm.video.link_cdn_web;
      vm.link_embed_intranet = vm.video.link_cdn_web;
      vm.link_permalien = vm.video.link_cdn_web;
      vm.link_permalien_intranet = vm.video.link_cdn_web;
      vm.cdn_web = true;
    }
    vm.export_facebook = "https://www.facebook.com/sharer/sharer.php?u=";
    vm.export_twitter = "https://twitter.com/share?text=" + vm.video.title + "&url=";
    vm.export_linkedin = "https://www.linkedin.com/shareArticle?mini=true&url=";
    vm.options = "";

    var link_embed_intranet_origin = angular.copy(vm.link_embed_intranet);
    var link_permalien_intranet_origin = angular.copy(vm.link_permalien_intranet);
    var link_embed_origin = angular.copy(vm.link_embed);
    var link_embed_simple_origin = angular.copy(vm.link_embed_simple);
    var link_embed_navigation_origin = angular.copy(vm.link_embed_richmedia);
    var link_permalien_origin = angular.copy(vm.link_permalien);
    var link_cdn_web_origin = angular.copy(vm.video.link_cdn_web);

    vm.checkOptionFunction = checkOptionFunction;
    vm.checkOptionIntranetFunction = checkOptionIntranetFunction;
    vm.closeDialog = closeDialog;
    vm.checkOptionCDNFunction = checkOptionCDNFunction;
    vm.checkOptionCDNIntranetFunction = checkOptionCDNIntranetFunction;
    vm.exportDailymotion = exportDailymotion;
    vm.exportYoutube = exportYoutube;
    vm.opens = opens;

    vm.selectedMode = 'md-fling';
    vm.selectedDirection = 'up';
    function checkOptionCDNFunction() {
      if (vm.cdn_web) {
        if(vm.isChannelExport) {
              angular.forEach(link_embed_origin, function (value, key) {
                  vm.link_embed[key] = link_cdn_web_origin[key] + vm.options;
                  vm.link_permalien[key] = link_cdn_web_origin[key] + vm.options;
              });
          }else {
              vm.link_embed = link_cdn_web_origin + vm.options;
              vm.link_permalien = link_cdn_web_origin + vm.options;
          }
      } else {
          if(vm.isChannelExport) {
              angular.forEach(link_embed_origin, function (value, key) {
                  vm.link_embed[key] = vm.video.link_embed[key] + vm.options;
                  vm.link_permalien[key] = vm.video.link[key] + vm.options;
              });
          }else {
              vm.link_embed = vm.video.link_embed + vm.options;
              vm.link_permalien = vm.video.link + vm.options;
          }
      }
    }

    function opens(v) {
      if (v == "internet") {
        if (isOpen === false) {
          document.getElementById("listbtn2").style.display = "block";
          isOpen = true;
        }
        else {
          document.getElementById("listbtn2").style.display = "none";
          isOpen = false;
        }
      }
      else {
        if (isOpen === false) {
          document.getElementById("listbtn").style.display = "block";
          isOpen = true;
        }
        else {
          document.getElementById("listbtn").style.display = "none";
          isOpen = false;
        }
      }

    }
      $rootScope.idvid=id;
    function exportDailymotion(video, lang) {

      msApi.request('media_video.exportDailmymotion@get', {idVod: id, lang: lang},
        function (response) {
          if (!response.logged) {//view login

              $rootScope.datacompte=response;
              $state.go('app.export_dailymotion_login', {id:id});
          } else {
              $rootScope.datacompte=response;
              $state.go('app.export_dailymotion', {id:id, lang: lang});

          }
          $mdDialog.hide();

        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }

    function exportYoutube(video, lang) {
      msApi.request('media_video.exportYoutube@get', {id: id, lang:lang},
        function (response) {
          if($cookies.get("accessTokenYoutube")){
              $mdDialog.hide();
              $state.go('app.export_youtube', {state:response.params});
          }else{
              $window.parent.open(response.urlAuth, "Google", "location=yes,menubar=no,status=no,scrollbars=no, width=0,height=0,left=-1000,top=-1000");
          }

        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }

    function listSubscriptionGroup(id, $ev, lang) {
      vm.spinner = false;
        // $mdDialog.hide();

          $mdDialog.show({
            controller: 'sendMailController',
            controllerAs: 'vm',
            templateUrl: 'app/main/media/video/email/email.template.html',
            targetEvent: $ev,
            clickOutsideToClose: true,
            locals: {
              video: vm.video,
              id: id,
                lang: lang
            }
          });


    }

    function checkOptionCDNIntranetFunction() {
      if (vm.cdn_web) {
          if(vm.isChannelExport) {
              angular.forEach(link_embed_intranet_origin, function (value, key) {
                  vm.link_embed_intranet[key] = link_cdn_web_origin[key] + vm.options;
                  vm.link_permalien_intranet[key] = link_cdn_web_origin[key] + vm.options;
              });
          }else {
              vm.link_embed_intranet = link_cdn_web_origin + vm.options;
              vm.link_permalien_intranet = link_cdn_web_origin + vm.options;
          }
      } else {
          if(vm.isChannelExport) {
              angular.forEach(link_embed_intranet_origin, function (value, key) {
                  vm.link_embed_intranet[key] = vm.video.link_embed_intranet[key] + vm.options;
                  vm.link_permalien_intranet[key] = vm.video.link_intranet[key] + vm.options;
              });
          }else {
              vm.link_embed_intranet = vm.link_embed_intranet?vm.video.link_embed_intranet + vm.options:vm.link_embed_intranet;
              vm.link_permalien_intranet = video.link_intranet?vm.video.link_intranet + vm.options:video.link_intranet;
          }
      }
    }

    function checkOptionFunction(valueCheck, option) {
     console.log("vvvvvvvvvvvvvvvvvvvvvvvv")
      if (valueCheck) {
        if (vm.options === "") {
          vm.options = "?" + option + "=1";
        } else {
          vm.options += "&" + option + "=1";
        }
      } else {
        if (vm.options.indexOf("?" + option + "=1") !== -1) {
          vm.options = vm.options.replace("?" + option + "=1", "");
          var index = vm.options.indexOf("&");
          if (index !== -1)
            vm.options = vm.options.replace("&", "?");
        } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
          vm.options = vm.options.replace("&" + option + "=1", "");
        }
      }
        if(vm.isChannelExport){
            angular.forEach(link_embed_origin, function (value, key) {
                vm.link_embed[key] = value + vm.options;
                vm.link_permalien[key] = link_permalien_origin[key] + vm.options;
            });
        }else {
          vm.link_embed_simple = link_embed_simple_origin + vm.options.replace("?", "&");
          vm.link_embed_richmedia = link_embed_navigation_origin + vm.options.replace("?", "&");
            vm.link_embed =link_embed_origin ?  link_embed_origin + vm.options :link_embed_origin;
            vm.link_permalien = link_permalien_origin ? link_permalien_origin + vm.options : link_permalien_origin;
        }
    }

    function checkOptionIntranetFunction(valueCheck, option) {
      if (valueCheck) {
        if (vm.options === "") {
          vm.options = "?" + option + "=1";
        } else {
          vm.options += "&" + option + "=1";
        }
      } else {
        if (vm.options.indexOf("?" + option + "=1") !== -1) {
          vm.options = vm.options.replace("?" + option + "=1", "");
          var index = vm.options.indexOf("&");
          if (index !== -1)
            vm.options = vm.options.replace("&", "?");
        } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
          vm.options = vm.options.replace("&" + option + "=1", "");
        }
      }
      if(vm.isChannelExport){
          angular.forEach(link_embed_intranet_origin, function (value, key) {
              vm.link_embed_intranet[key] = value + vm.options;
              vm.link_permalien_intranet[key] = link_permalien_intranet_origin[key] + vm.options;
          });
      }else {
          vm.link_embed_intranet = link_embed_intranet_origin?link_embed_intranet_origin + vm.options:link_embed_intranet_origin;
          vm.link_permalien_intranet = link_permalien_intranet_origin?link_permalien_intranet_origin + vm.options:link_permalien_intranet_origin;
      }
    }

    function closeDialog() {

      $mdDialog.hide();
    }
  }


})();

(function () {
    'use strict';

    angular
        .module("app.media.video.richMedia_new", ["textAngular", "flow"])
        .config(config)
        .run(fetchRights);

    function config($stateProvider, msApiProvider) {

        $stateProvider
            .state('app.media_video_rich_media_new', {
                parent: 'app.access_rapid',
                url: "/rich-media-new",
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/rich-media-new/template.html',
                        controller: 'richMediaNewActionsController as vm'
                    }
                },
                "actionPermission" : "rich_media_video_preview_link_by_title_action"
            });

        msApiProvider.register('media_richMedia_player_new.getPreviewNewLink', [Routing.generate('api_media_get_video_editor_preview_link', {id: ':id'}).replace(/%3A/, ":")]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*media).*$",
                name_module: "rich_media_video_new",
                name_angular_module: "app.media.video",
                actions: [
                    {"rich_media": ["preview_link_by_title"]}

                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
  'use strict';
  angular
    .module("app.media.video.richMedia_new")
    .controller('richMediaNewActionsController', richMediaNewActionsController);

  function richMediaNewActionsController($rootScope, video,$stateParams,webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    /* End Injection*/
    var vm = this;
    vm.event = "media_richMedia_player_new.getPreviewNewLink@get";
    vm.params = {id: $stateParams.id, isRm: 1};
    vm.isNavigationNew=false;
    if(video.isNew){
      vm.isNavigationNew=true;
    }
    initHelp();

    function initHelp() {

      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_rich_media_pagetitle";
        $rootScope.titre3 = "";
      }else {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_rich_media_pagetitle";
      }

      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";
    }

  }


})();

(function () {
    'use strict';

    angular
        .module('app.media.video.uploadAudio', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_video_uploadAudio', {
                url: "/medias/videos/uploadAudio/:videoId/:videoToken",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/uploadAudio/uploadAudio.template.html',
                        controller: 'mediaVideoUploadAudioController as vm'
                    }
                },

                resolve: {
                    mediaVideoOnHoldData: function (msApi) {
                        return msApi.resolve('media_video.getOnHoldVids@get');
                    },
                    mediaVideoGetUrlUpdate: function (msApi) {
                        return msApi.resolve('media_video.getUrlUpdate@get');
                    }

                },
                bodyClass: 'e-commerce',
                "actionPermission" : "media_video_audio_no_api_action"
            });


        //API
        msApiProvider.register('media_video.getOnHoldVids', [Routing.generate('api_media_on_hold_videos')]);
        msApiProvider.register('media_video.getAudioDescription', [Routing.generate('api_media_add_audio_description') + "/:id/:audioFileName", {
            id: '@id',
            audioFileName: '@audioFileName'
        }]);
        msApiProvider.register('media_video.getUrlUpdate', [Routing.generate('api_media_get_url_update_step_video')]);


    }
})();

(function () {
  'use strict';

  angular
    .module('app.media.video.uploadAudio')
    .controller('mediaVideoUploadAudioController', mediaVideoUploadAudioController);

  /** @ngInject */
  function mediaVideoUploadAudioController(mediaVideoGetUrlUpdate, mediaVideoOnHoldData, $scope,$cookies,$location, webTvGlobal, $injector, userManager, webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      HelpGlobal = $injector.get('HelpGlobal'),
      $timeout = $injector.get('$timeout'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi'),
      $stateParams = $injector.get('$stateParams');
    var vm = this;
    var audioFile = undefined;

    var url = $location.url();
    var urlToken = url.slice(url.lastIndexOf("/")+1,url.length);
    var addToken = "_ad";


    var parameters = webTvGlobal.$constant().webTvParameterBag();
    vm.ngFlowOptions = {
      chunkSize: (function () {
        return Math.pow(10, 100);
      })(),
      testChunks: false,
      target: parameters['url_import_video_piper'],
      singleFile: true,
      extendChunks: false,
      fileParameterName: 'uploadfile',
      query: {
        clientname: parameters['app.client.name'],
        type:'videos',
        userid: userManager.getId(),
        // webtv_name: parameters['app.webtv.name'],
        // path_file: parameters['upload.from_server_root_path'],
        // user_id: userManager.getId(),
        // timestamp: moment().unix(),
        token: urlToken ? urlToken+addToken : null,
        // callback_step_url: mediaVideoGetUrlUpdate.link_update_step
      },
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
    };
    !urlToken && delete vm.ngFlowOptions.query.token

    vm.ngFlow = {
      flow: {}
    };
    vm.dropping = false;

    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.fileProgress = fileProgress;
    vm.cancelUpload = cancelUpload;
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.inProgress = false;
    vm.audioKeyName = "";

    vm.uploadMetaDataError = false;
    checkUploadMetaDataError();
    vm.showMore = showMore;
    init();

    function init() {
      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_audio_upload_menuTitle";
        $rootScope.titre3 = "";
      }else{
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_audio_upload_menuTitle";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_upload_add";
      $rootScope.text = [{
        texte: "button_upload_add_help"
      }];
    }


    /**
     * Check if after upload , has an error on generating meta data has been thrown
     */
    function checkUploadMetaDataError() {
      if (angular.isDefined($rootScope.uploadMetaDataError) && $rootScope.uploadMetaDataError) {
        $rootScope.uploadMetaDataError = undefined;
        vm.uploadMetaDataError = true;
      }
    }

    function fileAdded(file) {
      if (!/(mp3|wav |cda|mid|mod|wma|m4a|ogg|aac |flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_audio_message'));
        return false;
      }
      audioFile = file;
      $rootScope.loadingProgress = true;
    }

    function fileProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      //vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var data = JSON.parse(message);
      if (angular.isDefined(data.file_name)) {
        vm.audioKeyName = data.file_name;
      } else return;
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      vm.progressBarValue = 0;
      vm.inProgress = false;
      $rootScope.loadingProgress = false;
      if (angular.isDefined(audioFile) && vm.audioKeyName) {
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: audioFile.name}), '', function () {
          vm.audioKeyName = "";
        }, false, 2000).then(function () {
          audioFile = undefined;
          msApi.request(
            'media_video.getAudioDescription@get',
            {id: $stateParams.videoId, audioFileName: vm.audioKeyName},
            function () {
            });
          $state.go('app.media_video_list', {type: "ongoing", "slug": md5(moment().unix), "title": vm.audioKeyName})
        });
      }
      else {
        if (!angular.isDefined(audioFile)) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
      }

    }

    /**
     * Stop upload operation
     */
    function cancelUpload() {
      $timeout(function () {
        vm.ngFlow.flow.cancel();
      });
    }

    // select from on hold video
    $scope.treeEventsObj = {
      'changed.jstree': selectNode

    };


    function selectNode(e, data) {
        var i, j;
        var subFolder = "";
        for (i = 0, j = data.selected.length; i < j; i++) {
            var title = data.instance.get_node(data.selected[i]).text;
            var subFolder = "";
            subFolder = webTvGlobal.getPathFile(subFolder, data, data.instance.get_node(data.selected[i]));
            if (data.node.icon === "icon-video") {
                msApi.request(
                    'media_video.getAudioDescription@get',
                    {id: $stateParams.videoId, audioFileName: title, subFolder: subFolder},
                    function () {
                    });
                $state.go('app.media_video_list', {type: "ongoing", "slug": md5(moment().unix), "title": data.node.text})
            }
        }
    }

    $scope.treeConfig = {
      core: {
        multiple: false,
        animation: false,
        error: function (error) {
          $log.error('treeCtrl: error from js tree - ' + angular.toJson(error));
        },
        check_callback: true,
        worker: true
      },

      'plugins': ['sort', 'wholerow'],

      'sort': function (a, b) {
        var a1 = this.get_node(a);
        var b1 = this.get_node(b);
        if (a1.icon === b1.icon) {
          return (a1.text > b1.text) ? 1 : -1;
        } else {
          return (a1.icon > b1.icon) ? 1 : -1;
        }
      }

      ,
      version: 1
    };

    var test = mediaVideoOnHoldData.data;
    vm.treeInstance = [];
    vm.tree = [];
      var tree = [];
    if (test.length > 0) {
      showMore();
    }
    if (test.length > 20) {
      vm.testData = true;

    }
    else
      vm.testData = false;

    function showMore() {
      var i = 0;
      var j = tree.length;
      do {
        tree.push(test[i + j]);
        if (test[i + j].parent === "#") {
          i++;
        } else {
          j++
        }
      } while (i < 20 && i + j < test.length);
      if (i < 19) {
        vm.testData = false;
      }
        vm.tree=tree;
    }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.media.video.upload', ["flow", "angularFileUpload"])
        .config(config);

    /** @ngInject */
    function config( msApiProvider) {

        //API
        msApiProvider.register('media_video.getSFTPVids', [apiPiper + 'video/pending']);
        msApiProvider.register('media_video.getOnHoldVodsPiper', [Routing.generate('api_media_on_hold_videos_piper')]);
        msApiProvider.register('media_video.deleteOnHoldVid', [apiPiper + 'video/delete-pending']);
        msApiProvider.register('media_video.deleteVideos', [Routing.generate('api_multi_delete_videos') + "/:list", {list: '@list'}]);
        msApiProvider.register('parametersBagLogin.app', [Routing.generate('api_get_app_parameter_bag')]);
        msApiProvider.register('media_video.getUrlUpdate', [Routing.generate('api_media_get_url_update_step_video')]);
        msApiProvider.register('media_video.getExistToken', [Routing.generate('api_media_exist_token_video', {token: ':token'}).replace(/%3A/g, ":")]);
        msApiProvider.register('media_video.dupliquateSource', [apiPiper + 'assets/duplicate-video']);
        msApiProvider.register('preview-modal.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")]);
        msApiProvider.register('preview-modal.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.automaticAddVideo', [Routing.generate('api_media_add_video')]);
        msApiProvider.register('media_video.getMetaData', [Routing.generate('api_media_get_video_meta_data')]);
        msApiProvider.register('media_video.verifExistSource', [Routing.generate('api_media_exist_source_video', {hashSource: ':hashSource'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getGeneratedThumbs', [apiPiper + 'thumbnail']);
        msApiProvider.register('media_video.getOnHoldVodsPiper', [Routing.generate('api_dtable_list_dtable_videos_onhold')]);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.upload')
        .controller('mediaVideoUploadController', mediaVideoUploadController)
        .controller('previewModalController', previewModalController);

    /** @ngInject */
    function mediaVideoUploadController(msApi, video,$scope, webTvGlobal, userManager, $injector, $window, $mdDialog, FileUploader,dialogConfirmDeleteService,$http, dtable_language, $cookies, DTOptionsBuilder, DTColumnBuilder,webTv_msNavigation, order_onhold_video) {
        var columnsApi = order_onhold_video ;
        var myEl = angular.element(document.querySelector('#content'));
        var date = new Date();

        var pemission = {};
        if (userManager.isActionGranted('media_video_add_option_extern_link')) {
            pemission.media_video_add_option_extern_link = true;
        }
        if (userManager.isActionGranted('media_video_add_option_webcam')) {
            pemission.media_video_add_option_webcam = true;
        }
        if (userManager.isActionGranted('media_video_add_option_on_hold_action')) {
            pemission.media_video_add_option_on_hold = true;
        }
        if (userManager.isActionGranted('media_video_add_option_on_hold_sftp_action')) {
            pemission.media_video_add_option_on_hold_sftp = true;
        }
        if (userManager.isActionGranted('media_video_add_option_presentation')) {
            pemission.media_video_add_option_presentation = true;
        }
        if (userManager.isActionGranted('media_video_add_option_story_board')) {
            pemission.media_video_add_option_story_board = true;
        }

        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $compile = $injector.get('$compile'),
            $sce = $injector.get('$sce'),
            $state = $injector.get('$state');
        if ($state.current.url === "/medias/videos/upload") {
            date = new Date();

            var vm = this;
            vm.permission = pemission;
            vm.fillData = fillData;
            vm.deleteNodeConfirm = deleteNodeConfirm;
            vm.deleteNodesConfirm = deleteNodesConfirm;
            vm.getVideoOnHoldSFTP = getVideoOnHoldSFTP;
            vm.addSelectedNodes = addSelectedNodes;
            vm.hide = false;
            var folder_sftp_piper = "";
            vm.isFM=false;
            $rootScope.isFM = false;
            if(video.isNew){
                vm.isFM=true;
                $rootScope.isFM = true;
            }
            vm.fillData1 = fillData1;
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            var uploader = $scope.uploader = new FileUploader({
                // url: parameters['upload.script_url'],$stateParams
                alias: 'uploadfile',
                formData: [{
                    type:'videos',
                    userid: userManager.getId()
                }]
            });
            var added_item = null;
            // console.log(webTvGlobal.$constant().webTvParameterBag().has_upload_multiple);
            if (!$rootScope.index)
                $rootScope.index = 0;
            vm.videoFile = undefined;
            vm.ngFlowOptions = {query: {}};
            vm.getVideoOnHold = getVideoOnHold;
            date = new Date();
            vm.videoDataTable = [];
            vm.vods = [];
            vm.draw=0;
            var data = [];
            var filtre = {};
            var load_data = false;
            vm.dtInstance = {};
            vm.selectedVods = [];
            var selectedVods = [];
            vm.urlUpload="";
            vm.render = rerender;
            vm.preview_onhold_video = preview_onhold_video;
            vm.deleteOnHoldConfirm = deleteOnHoldConfirm;
            vm.deleteOnHoldVideosConfirm = deleteOnHoldVideosConfirm;
            vm.toggleOnHoldVod = toggleOnHoldVod;
            vm.toggleAll = toggleAll;
            $rootScope.rerender = rerender;
            vm.searchVods = searchVods;
            vm.cancelItem = false;

          vm.uploadTus = false;
          vm.isCloudFlare=false;
          vm.videoToken="";
          eventPostMessage();
          function eventPostMessage() {
            if (angular.isUndefined(window.dataEventPostMessageUploadVideo)) {
              window.dataEventPostMessageUploadVideo = true;
              var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
              var eventer = window[eventMethod];
              var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

              eventer(
                messageEvent,
                function(event) {
                  if (event.data !== 'undefined') {
                    if (angular.isDefined(event.data) && event.data.info === 'addVideoForm' && $state.current.name === "app.media_video_upload") {
                      console.log('addVideoForm');
                      console.log(event.data);
                      vm.uploadTus = true;
                      if(event.data.type==='cloud_flare'){
                        vm.isCloudFlare=true;
                        vm.videoToken=event.data.value.token
                      }
                        vm.VerifHashSourceAndOpenAdd(event.data.value.file, event.data.value.hashSource);

                    }else if(event.data.info === 'completeUploadBOVideo'){
                     var title =event.data.filename;
                     var isMulti =event.data.isMulti;
                     var tokenTitle = title.split('.').slice(0, -1).join('.');
                     var hashSource = "";
                     $rootScope.uploadedFiles=event.data.uploadedFiles;
                      var request = {firstStep: true, fileTitle: title, hashSource: hashSource, metaData: "", token: tokenTitle};
                      callApiAutomaticAddVideo(title,"",false, isMulti, request );
                    }
                  }
                },
                false
              );
            }
          }




          var numberRecords = $cookies.get('numberRecords') || 10;
            vm.selectedNodes = [];
            vm.dtColumns = [
                DTColumnBuilder.newColumn(null).notSortable()
                    .renderWith(function (data) {
                        vm.videoDataTable[data.id] = data;
                        return '<md-checkbox ng-checked="vm.videoDataTable[' + data.id + '].checked"' +
                            'ng-click="vm.toggleOnHoldVod(vm.videoDataTable[' + data.id + '])"' +
                            'aria-label="-">' +
                            '</md-checkbox> ';
                    }),
                DTColumnBuilder.newColumn('id').renderWith(function (data) {
                    return angular.isDefined(data) ? data : "";
                }),

                DTColumnBuilder.newColumn('fileTitle').renderWith(function (data) {
                    return angular.isDefined(data) ? data : "";
                }),
                DTColumnBuilder.newColumn('startDate').renderWith(function (data) {
                    return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
                }),
                DTColumnBuilder.newColumn('contributor').notSortable()
                    .renderWith(function (data, type, full) {
                        var name_contributor = contributorName(data);
                        var serverHtml = "";
                        if (data === null) {
                            serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" ></Any>';
                        }
                        else {
                            serverHtml += '<Any>' + name_contributor + '</Any>';
                        }
                        return serverHtml;
                    }),
                DTColumnBuilder.newColumn(null).notSortable()
                    .renderWith(function (data) {
                        var buttons = "";
                        vm.videoDataTable[data.id] = data;
                        buttons = '<a  tooltips tooltip-template=' + "{{'MESSAGES.preview_video'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  ng-click="vm.preview_onhold_video('+data.id+')" style="display: inline-flex;" aria-label="preview_video" translate translate-attr-aria-label="MESSAGES.preview_video"><md-icon md-font-icon="icon-play" class="s18"></md-icon></md-button></a>';
                        buttons += '<a  tooltips tooltip-template=' + "{{'MESSAGES.form_add'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  style="display: inline-flex;" ng-click="vm.add('+data.id+')" aria-label="form_add" translate translate-attr-aria-label="MESSAGES.form_add"><md-icon md-font-icon="icon-upload-custom" class="s18"></md-icon></md-button></a>';
                        buttons += '<a  tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  style="display: inline-flex;" ng-click="vm.deleteOnHoldConfirm('+data.id+')" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete"><md-icon md-font-icon="icon-delete" class="s18"></md-icon></md-button></a>';
                        return '<div><div layout="row" style="width: 460px" show-gt-sm hide-sm hide-xs layout-wrap>' + buttons + '</div><div layout="row" style="width: 260px" hide-gt-sm show-sm hide-xs layout-wrap>' + buttons + '</div><div layout="row" style="width: 120px" hide-gt-sm hide-sm show-xs layout-wrap>' + buttons + '</div></div>';
                    })


            ];
            $rootScope.DTOptionsBuilder = DTOptionsBuilder;
            var newOptions = DTOptionsBuilder.newOptions();
            vm.dtOptions = newOptions
                .withFnServerData(serverData)
                // or here
                .withDataProp('data')
                .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
                .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('columnDefs', [[
                    {
                        targets: 0,
                        responsivePriority: 1,
                        width: '30px'
                    },
                    {
                        targets: 1,
                        responsivePriority: 7,
                        filterable: true,
                        sortable: true,
                        width: '40px'
                    },
                    {
                        targets: 2,
                        responsivePriority: 5,
                        filterable: true,
                        sortable: false,
                        visible: false,
                        width: '100px'
                    },
                    {
                        targets: 3,
                        responsivePriority: 2,
                        filterable: true,
                        sortable: true,
                        width: '50px'
                    },
                    {
                        targets: 4,
                        responsivePriority: 6,
                        filterable: true,
                        sortable: true,
                        width: '100px'
                    },
                    {
                        targets: 5,
                        responsivePriority: 3,
                        filterable: false,
                        sortable: false,
                        width: '100px'
                    }

            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

      if (angular.isUndefined(parameters['app.client.name'])) {
        msApi.request('parametersBagLogin.app@get', function (res) {
            if (angular.isDefined(res.bag)){
                parameters = res.bag;
            }
          if (angular.isDefined(res.bag.video_simple_multiple) && res.bag.video_simple_multiple === "1")
            vm.isMultiUpload = true;
          else
            vm.isMultiUpload = false;

          console.log(res.bag);
          vm.urlUpload = $sce.trustAsResourceUrl(res.bag.url_upload_video_fo);
          if(vm.urlUpload){
            vm.urlUpload =  $sce.trustAsResourceUrl(vm.urlUpload  +"&reset="+$rootScope.delete_all_files_uploaded)
          }

          vm.ngFlowOptions = {
            chunkSize: (function () {
              return Math.pow(10, 100);
            })(),
            testChunks: false,
            target: res.bag['url_import_video_piper'],
            simultaneousUploads: 1,
            extendChunks: false,
            fileParameterName: 'uploadfile',
            query: {
              type:'videos',
              userid: userManager.getId()

                      },
                        headers: { Authorization: "Bearer " + $cookies.get("authToken") }
                    };
                    if (res.bag.save_step_video === "1") {
                        vm.ngFlowOptions.query.saveStepVideo = res.bag.save_step_video;
                        uploader.formData[0].saveStepVideo = res.bag.save_step_video;
                    }
                    uploader.url = $scope.uploader.url = res.bag['url_import_video_piper'];
                    uploader.headers = { Authorization: "Bearer " + $cookies.get("authToken") };
                    uploader.formData[0].clientname = $scope.uploader.formData[0].clientname = res.bag['app.webtv.name'];
                    //     alias: 'Filedata',
                    //     formData: [{
                    //         webtv_name: res.bag['app.webtv.name'],
                    //         path_file: res.bag['upload.from_server_root_path'],
                    //         user_id: userManager.getId(),
                    //         timestamp: moment().unix(),
                    //         token: md5("unique_salt" + moment().unix())
                    //
                    //     }]
                    // });

                });


      }
      else {
        if (angular.isDefined(parameters.video_simple_multiple) && parameters.video_simple_multiple === "1")
          vm.isMultiUpload = true;
        else
          vm.isMultiUpload = false;

        vm.urlUpload = $sce.trustAsResourceUrl(parameters.url_upload_video_fo);
        if(vm.urlUpload){
          vm.urlUpload =  $sce.trustAsResourceUrl(vm.urlUpload  +"&reset="+$rootScope.delete_all_files_uploaded)
        }
        vm.ngFlowOptions = {
          chunkSize: (function () {
            return Math.pow(10, 100);
          })(),
          testChunks: false,
          target: parameters['url_import_video_piper'],
          simultaneousUploads: 1,
          extendChunks: false,
          fileParameterName: 'uploadfile',
          query: {
            clientname: parameters['app.client.name'],
            type:'videos',
            userid: userManager.getId(),
          },
            headers: { Authorization: "Bearer " + $cookies.get("authToken") }
        };
        if (parameters.save_step_video === "1") {
          vm.ngFlowOptions.query.saveStepVideo = parameters.save_step_video;
          uploader.formData[0].saveStepVideo = parameters.save_step_video;
        }
        uploader.url = $scope.uploader.url = parameters['url_import_video_piper'];
        uploader.headers = { Authorization: "Bearer " + $cookies.get("authToken") };
          uploader.formData[0].clientname = $scope.uploader.formData[0].clientname = parameters['app.webtv.name'];
        //     alias: 'Filedata',
        //     formData: [{
        //         webtv_name: res.bag['app.webtv.name'],
        //         path_file: res.bag['upload.from_server_root_path'],
        //         user_id: userManager.getId(),
        //         timestamp: moment().unix(),
        //         token: md5("unique_salt" + moment().unix())
        //
        //     }]
        // });
      }

            date = new Date();

            vm.ngFlow = {
                flow: {}
            };
            vm.dropping = false;
            // msApi.request('media_video.getUrlUpdate@get', function (res) {
            //     vm.ngFlowOptions.query.callback_step_url = res.link_update_step;
            //     uploader.formData.callback_step_url = res.link_update_step;
            // });
            if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
                vm.isChrome = true;

            }
            else vm.isChrome = false;
            vm.fileAdded = fileAdded;
            vm.uploadFile = uploadFile;
            vm.fileSuccess = fileSuccess;
            vm.uploadComplete = uploadComplete;
            vm.fileProgress = fileProgress;
            vm.cancelUpload = cancelUpload;
            vm.progressBarValue = 0;
            vm.roundWithPrecision = roundWithPrecision;
            vm.inProgress = false;
            vm.automatic_addition = false;
            var videoKeyName = "";
            var videoHash = "";
            var tokenVideo = "";
            vm.click = click;
            vm.click();
            vm.icon = true;
            $rootScope.endUpload = false;
            vm.hide = false;
            vm.uploadMetaDataError = false;
            checkUploadMetaDataError();
            // vm.goToStoryBoard = goToStoryBoard;
            vm.redirect = redirect;
            // vm.returnToList = returnToList;
            vm.uploadExternel = uploadExternel;
            vm.isInstalledExtension = false;
            vm.onWebcamSelected = onWebcamSelected;
            vm.add = add;
            vm.add_sftp_vod = add_sftp_vod;
            vm.VerifHashSourceAndOpenAdd = VerifHashSourceAndOpenAdd;
            vm.removeItemUpload = removeItemUpload;
            init();
            onWebcamSelected();

            vm.getElement = getElement;

            // select from on hold video
            $scope.treeEventsObj = {
                'changed.jstree': selectNode
            };
            // FILTERS
            uploader.filters.push({
                name: 'Extensions',
                fn: function (item, options) {
                    var allowedExtensions = ['flv', 'm4v', 'avi', 'wmv', 'mp4', 'mpeg', 'mpg', 'mpe', 'dat', 'vob', 'asf', 'asx', 'mov', '3gp', '3g2', '3gpp', 'dv', 'qt', 'rm', 'rmvb', 'webm'];

                    var ext = item.name.split('.').pop().toLowerCase(); //get the file extension
                    return allowedExtensions.indexOf(ext) !== -1;
                }
            });
            // a sync filter
            var files = [];
            var tokens = [];
            vm.filesNames = [];
            var hashSources = [];

            // CALLBACKS

            // uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
            //     console.info('onWhenAddingFileFailed', item, filter, options);
            // };
            // uploader.onAfterAddingFile = function (fileItem) {
            //     console.info('onAfterAddingFile', fileItem);
            // };
            uploader.onAfterAddingAll = function (addedFileItems) {
                uploader.uploadAll();
            };
            uploader.onBeforeUploadItem = function (item) {
                $rootScope.isUploading = true;

            };
            uploader.onProgressItem = function (fileItem, progress) {
              if (vm.filesNames.length === 0 && progress === 100) {
                $rootScope.loadingProgress=true;

              }

            };
            // uploader.onProgressAll = function (progress) {
            //     console.info('onProgressAll', progress);
            // };
            // uploader.onSuccessItem = function (fileItem, response, status, headers) {
            //     console.info('onSuccessItem', fileItem, response, status, headers);
            // };
            // uploader.onErrorItem = function (fileItem, response, status, headers) {
            //     console.info('onErrorItem', fileItem, response, status, headers);
            // };
            uploader.onCancelItem = function (fileItem, response, status, headers) {
                $rootScope.isUploading = false;
                console.log('------onCancelItem-----------');
                vm.cancelItem = true;
                vm.filesNames = [];
                files = [];
                tokens = [];
                hashSources = [];

            };
            vm.clearUpload = clearUpload;

            uploader.onCompleteItem = function (fileItem, response, status, headers) {
                if(!vm.cancelItem) {
                    console.log('------onCompleteItem-----------');
                    files.push(response.file_name);
                    hashSources.push(response.hashSource);
                    fileItem.file.hashSource = response.hashSource;
                    vm.filesNames.push(fileItem.file.name);
                    if (angular.isDefined(response.token)) {
                        tokens.push(response.token);
                    }
                }else{
                    vm.cancelItem = false;
                }

            };
            uploader.onCompleteAll = function () {
              console.log('------onCompleteAll-----------');
                // uploader.queue = vm.selected;
                $rootScope.loadingProgress=false;
                $rootScope.files = files;
                $rootScope.filesNames = vm.filesNames;
                var testFiles = true;
                angular.forEach(files, function (value) {
                    if (angular.isUndefined(value))
                        testFiles = false;

                });
                $rootScope.endUpload = true;
                var messageToast = $translate.instant('VIDEOUPLOAD.complete_upload_video');
                if (files.length > 1) {
                    messageToast += $translate.instant('VIDEOUPLOAD.complete_multi_upload');
                }
                webTvGlobal.$toast().showSimple(messageToast);
                if (testFiles && $state.current.url === '/medias/videos/upload')
                //$state.go('app.media_video_add', {"slug": md5(moment().unix), "title": "multiUpload"});
                {
                    if (files.length === 1) {
                        added_item = uploader.queue[0];
                        if (angular.isDefined( tokens[0])) {
                            tokenVideo = tokens[0];
                        }
                        if(vm.automatic_addition){
                            var subFolder = "";
                            var title = files[0];
                            vm.VerifHashSourceAndOpenAdd(files[0], hashSources[0], subFolder, true);
                        }else{
                            vm.VerifHashSourceAndOpenAdd(files[0], hashSources[0]);
                        }
                    }
                    // else
                    //     $rootScope.index = 2;
                }else if(!testFiles && $state.current.url === '/medias/videos/upload'){
                  console.log(vm.filesNames)
                  var parameters = webTvGlobal.$constant().webTvParameterBag();
                    if (vm.filesNames.length === 1) {
                        $http({
                            url: apiPiper + 'assets/check-video-exist',
                            method: "POST",
                            data: {client: parameters['app.client.name'], fileName: vm.filesNames[0]},
                        }).success(function (res) {
                            if(res.files) {
                                files = res.files.sort(function (a, b) {
                                    return new Date(b.lastModified)
                                        - new Date(a.lastModified)
                                })
                                added_item = uploader.queue[0];
                                try {
                                    var title = files[0].filePath.substring(files[0].filePath.lastIndexOf("/") + 1, files[0].filePath.length);
                                    console.log(title)
                                    if (vm.automatic_addition) {
                                        var subFolder = "";
                                        vm.VerifHashSourceAndOpenAdd(title, hashSources[0], subFolder, true);
                                    } else {
                                        vm.VerifHashSourceAndOpenAdd(title, hashSources[0]);
                                    }
                                } catch (e) {

                                }
                            }
                        });
                    }
                }
            };

          function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
          }


            vm.keys = [];

            vm.selected = [];
            vm.toggle = function (item, list) {
                var idx = list.indexOf(item);
                if (idx > -1) {
                    vm.selected.splice(idx, 1);
                }
                else {
                    vm.selected.push(item);
                }
            };
            vm.exists = function (item, list) {
                return list.indexOf(item) > -1;
            };
            vm.closeUpload = closeUpload;

            vm.goToAddPage = goToAddPage;


            vm.goToAddPageMulti = goToAddPageMulti;

            // var testUpload = false;


            vm.closeUploadMulti = closeUploadMulti;


        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchVodsInAPI(filtre), true);

        }
        function serverData(sSource, aoData, fnCallback) {
            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];
            vm.checkedSelected = false;
            vm.selectedVods = [];
            vm.draw = draw;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_videos,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre.searchWord = vm.search_videos;
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;
            if(load_data) {
                searchVodsInAPI(filtre);
            }
        }
        function searchVods() {
            filtre.searchWord = vm.search_videos;
            filtre.start=0;
            filtre.draw= vm.draw;
            searchVodsInAPI(filtre);
            rerender()
        }
        function searchVodsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request("media_video.getOnHoldVodsPiper@get", filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var vods = response.data;

                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.vods = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        console.log(records);
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                        vm.selectedVods = [];
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.vods = [];
                            vm.recordsTotal = 0;
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.vods = [];
                }
            );

        }
        function clearUpload() {
            console.log('clearUpload');
            uploader.clearQueue();
            vm.filesNames = [];
            files = [];
            tokens = [];
            hashSources = [];
        }

        function preview_onhold_video(id){
            var title = vm.videoDataTable[id].fileTitle;
            var video_id = vm.videoDataTable[id].id;
            var hashSource = vm.videoDataTable[id].hashSource;
            $mdDialog.show({
                controller: 'previewModalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/upload/preview-modal.template.html',
                clickOutsideToClose: true,
                locals: {
                    video_id: video_id,
                    title: title,
                    hashSource: hashSource,
                    subFolder: "",
                    reupload: false,
                    functionVerifHashSource: vm.VerifHashSourceAndOpenAdd

                }
            }).then(function () {
                // $rootScope.$broadcast('VideoList::setInactive');
            }, function () {
                //     $rootScope.$broadcast('VideoList::setInactive');
            });
        }


        function deleteOnHoldConfirm(id) {
            var title = vm.videoDataTable[id].fileTitle;
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted_video",
                "VIDEOLIST.delete_video_msg",
                "VIDEOLIST.delete_video_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_video_msg'])
                        .htmlContent('<b>' + title + '</b>' + translatedValues['VIDEOLIST.dialog_will_be_deleted_video'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_video_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteOnHoldVideo(id, title);
                    }, function () {
                        $mdDialog.hide();
                    });
                });
        }
        function deleteOnHoldVideo(id, title) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.deleteVideos@delete', {list: [id]},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_title",
                            "VIDEOLIST.dialog_alert_delete_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                webTvGlobal.$toast().showSimple(title + translatedValues['VIDEOLIST.dialog_alert_delete_description']);
                                vm.vods.splice(vm.vods.indexOf(vm.videoDataTable[id]), 1);
                                rerender();
                            });
                    }
                    else {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_error_title",
                            "VIDEOLIST.dialog_alert_delete_error_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                var alert = $mdDialog.alert({
                                    title: translatedValues['VIDEOLIST.dialog_alert_delete_error_title'],
                                    textContent: translatedValues['VIDEOLIST.dialog_alert_delete_error_description'],
                                    ok: translatedValues['VIDEOLIST.dialog_alert_delete_close']
                                });

                                $mdDialog
                                    .show(alert)
                                    .finally(function () {
                                        alert = undefined;
                                    });
                            });

                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                   vm.modelCheckAll = false;
                }
            );
        }

        function deleteOnHoldVideosConfirm(e) {
            var title;
            var ariaLabel;
            if (selectedVods.length !== 0) {
                if(selectedVods.length === 1){
                    title = 'VIDEOLIST.delete_selected_video_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_video_aria_label';
                }else{
                    title = 'VIDEOLIST.delete_selected_videos_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_videos_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(e,vm.selectedVods.length,title,ariaLabel)).then(function () {

                    deleteOnHoldVideos();
                    selectedVods = [];
                    vm.selectedVods = [];
                }, function () {
                });
            }
        }

        function deleteOnHoldVideos() {
            $rootScope.loadingProgress = true;
            var list_vods_selected = angular.copy(vm.selectedVods);
            var ids = [];
            angular.forEach(list_vods_selected, function (value, key) {
                ids.push(value.id);
            });
            if(ids.length !==0) {
                msApi.request('media_video.deleteVideos@delete', {list: ids},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "VIDEOLIST.dialog_alert_delete_title",
                                "VIDEOLIST.dialog_alert_delete_all_description",
                                "VIDEOLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(translatedValues['VIDEOLIST.dialog_alert_delete_all_description']);
                                    rerender();
                                });
                        }
                        else {
                            $translate([
                                "VIDEOLIST.dialog_alert_delete_error_title",
                                "VIDEOLIST.dialog_alert_delete_error_description",
                                "VIDEOLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['VIDEOLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['VIDEOLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['VIDEOLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    }
                );
            }
        }

        function toggleOnHoldVod(vod) {
            vod.checked = !vod.checked;
            var idx = selectedVods.indexOf(vod);
            if (idx > -1) {
                selectedVods.splice(idx, 1);
                console.log("dkjkjdsfkjldfs4dfs456dfs",vod,selectedVods)
            }
            else {
                selectedVods.push(vod);
            }
            vm.selectedVods = angular.copy(selectedVods);
        }
        function toggleAll() {
            if (selectedVods.length === vm.vods.length) {
                vm.selectedVods = [];
            }
            else if ((selectedVods.length === 0) || (selectedVods.length > 0)) {
                vm.selectedVods = vm.vods.slice(0);
            }
            selectedVods = angular.copy(vm.selectedVods);
            var list_vods = angular.copy(vm.videoDataTable);
            angular.forEach(list_vods, function (value, key) {
                if (value !== undefined)
                    vm.videoDataTable[key].checked = selectedVods.length > 0;
            });
        }
        $.jstree.defaults.appendContent = {
            'content': null,
            'callback': $.noop,
            'className': 'jstree-appendContent'
        };

        $.jstree.plugins.appendContent = function (options, parent) {
            this.bind = function () {
                parent.bind.call(this);

                if (this.settings.appendContent.callback !== null) {
                    this.element.on('click.jstree', '.' + 'icon-delete',
                        $.proxy(function (e) {
                            e.stopImmediatePropagation();
                            this.settings.appendContent.callback.call(this,
                                this.get_node(e.target));
                            var node = this.get_node(e.target);
                            if(node.icon ==="icon-video") {
                                var title = node.text;
                                vm.deleteNodeConfirm(node);
                            }
                        }, this));

                    this.element.on('click.jstree', '.' + 'icon-upload-custom',
                        $.proxy(function (e) {
                            e.stopImmediatePropagation();
                            this.settings.appendContent.callback.call(this,
                                this.get_node(e.target));
                            var node = this.get_node(e.target);
                            if(node.icon ==="icon-video") {
                                var title = node.text;
                                var subFolder = node.original.file.replace('/' + title, "");
                                var hashSource = node.original.hashSource;
                                if (folder_sftp_piper) {
                                    folder_sftp_piper = folder_sftp_piper.trimEnd('/');
                                    subFolder = folder_sftp_piper + (subFolder ? subFolder : "");
                                }
                                var tokenTitle = title.split('.').slice(0, -1).join('.');
                                msApi.request('media_video.getExistToken@get',{"token":tokenTitle}, function (res) {
                                    if(angular.isDefined(res.exist_token) && !res.exist_token){
                                        tokenVideo = tokenTitle;
                                        vm.add_sftp_vod(title, hashSource, subFolder);
                                    }else{
                                        msApi.request('media_video.dupliquateSource@save', {videoName: title, userid: userManager.getId()},function (response) {
                                            if(angular.isDefined(response.token) && response.token){
                                                tokenVideo = response.token;
                                                title = response.duplicatedVideo;
                                                vm.add_sftp_vod(title, hashSource, subFolder);
                                            }
                                        });
                                    }
                                });
                            }
                        }, this));
                    this.element.on("check_node.jstree uncheck_node.jstree", function(e, data) {
                        if(data.node.icon ==="icon-video") {
                            if (data.node.state.checked) {
                                vm.selectedNodes.push(data.node.id);
                            } else {
                                var index = vm.selectedNodes.indexOf(data.node.id);
                                if (index !== -1) vm.selectedNodes.splice(index, 1);
                            }
                        }

                    })
                }
            };

            this.teardown = function () {
                if (this.settings.appendContent) {
                    this.element.find('.' + this.settings.appendContent.className).remove();
                }
                parent.teardown.call(this);
            };

            this.redraw_node = function (obj, deep, callback) {
                obj = parent.redraw_node.call(this, obj, deep, callback);
                if (obj) {
                    $('a', obj).first().after(
                        $(this.settings.appendContent.content).clone()
                            .addClass(this.settings.appendContent.className));
                }
                return obj;
            };
        };
        var callbackButtonUpload = false;
        var callbackButtonDelete = false;
        $scope.treeConfig = {
            core: {
                multiple: false,
                animation: false,
                error: function (error) {
                    console.log('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback: true,
                worker: true,
                themes : { "stripes" : true }
            },
            'plugins': ['sort', "dnd", "search","checkbox","appendContent"],
            'appendContent': {
                'content': $('<span style="float:right;line-height: 0;">').append($('<button>', {
                    'class': 'addNodeBtn',
                    'html': '<md-icon md-font-icon="icon-upload-custom" class="sb18 ng-scope md-default-theme md-font material-icons icon-upload-custom"></md-icon>',
                })).append('&nbsp;').append($('<button>', {
                    'class': 'deleteNodeBtn',
                    'html': '<md-icon md-font-icon="icon-delete" class="sb18 ng-scope md-default-theme md-font material-icons icon-delete"></md-icon>',
                })),
                'callback': function (node) {
                }
            },
            "checkbox": {
                "three_state": false,
                "real_checkboxes": false,
                "tie_selection" : false,
                "whole_node" : false,
                "keep_selected_style" : false
            },
            'sort': function (a, b) {
                var a1 = this.get_node(a);
                var b1 = this.get_node(b);
                if (a1.icon === b1.icon) {
                    return (a1.original.time < b1.original.time) ? 1 : -1;
                } else {
                    return (a1.icon > b1.icon) ? 1 : -1;
                }
            }
            ,
            version: 1
        };
        var mediaVideoOnHoldData;
        var tree = [];
        function getVideoOnHoldSFTP() {
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            folder_sftp_piper = angular.isDefined(parameters["folder_sftp_piper"]) && parameters["folder_sftp_piper"] ? parameters["folder_sftp_piper"]:"";
            msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                mediaVideoOnHoldData = res.data;
                vm.treeInstance = [];
                vm.tree = [];

                if (mediaVideoOnHoldData.length > 0) {
                    vm.fillData1();
                }
                if (mediaVideoOnHoldData.length > 20) {
                    vm.testData = true;

                }
                else
                    vm.testData = false;

            });
        }
        function selectNode(e, data) {
            var i, j;
            for (i = 0, j = data.selected.length; i < j; i++) {
                var title = data.instance.get_node(data.selected[i]).text;
                var subFolder = "";
                subFolder = webTvGlobal.getPathFile(subFolder, data, data.instance.get_node(data.selected[i]));
                var hashSource = data.instance.get_node(data.selected[i]).original.hashSource;
                if(folder_sftp_piper){
                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                    if (lastChar === '/') {         // If the last character is not a slash
                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                    }
                    subFolder = folder_sftp_piper + (subFolder ? '/'+subFolder : "");
                }
                if(subFolder.charAt(0) === '/')
                    subFolder = subFolder.substr(1);
                if (data.node.icon === "icon-video") {
                    $mdDialog.show({
                        controller: 'previewModalController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/upload/preview-modal.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            video_id: null,
                            title: title,
                            hashSource: hashSource,
                            subFolder: subFolder,
                            reupload: false,
                            functionVerifHashSource: vm.add_sftp_vod

                        }
                    }).then(function () {
                        // $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        //     $rootScope.$broadcast('VideoList::setInactive');
                    });
                }
            }
        }
        function fillData() {
            var i = 0;
            var j = tree.length;
            do {
                tree.push(mediaVideoOnHoldData[i + j]);
                if (mediaVideoOnHoldData[i + j].parent === "#") {
                    i++;
                } else {
                    j++
                }
            } while (i < 20 && i + j < mediaVideoOnHoldData.length);
            if (i < 19) {
                vm.testData = false;
            }

            vm.tree = tree;
        }

        function addSelectedNodes() {
            var selected_nodes = vm.treeInstance.jstree(true).get_checked();
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            var videoMultiTitle  =  angular.isDefined(parameters["video_multi_title"])?parameters["video_multi_title"] == "1" ? true:false:false;
            var index = 0;
            selected_nodes.forEach(function (id_node) {
                var node = vm.treeInstance.jstree(true).get_node(id_node);
                if(folder_sftp_piper){
                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                    if (lastChar === '/') {         // If the last character is not a slash
                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                    }
                }
                var sub_folder_file = node.original.file.replace(node.text, "");
                add_video_redirect(node.text, node.original.hashSource, folder_sftp_piper + sub_folder_file, videoMultiTitle, "", null, (index===0?'':'multi'));
                index ++;
            });
        }

        /**
         * delete nodes confirm
         */
        function deleteNodesConfirm(e) {
            var selected_nodes = vm.treeInstance.jstree(true).get_checked();
            var allText =[];
            var allVideoName =[];
            selected_nodes.forEach(function (id_node) {
                var node = vm.treeInstance.jstree(true).get_node(id_node);
                allText.push(node.text);
                var video_name = node.original.file;
                if(folder_sftp_piper){
                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                    if (lastChar === '/') {         // If the last character is not a slash
                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                    }
                    video_name = folder_sftp_piper + video_name;
                }
                allVideoName.push(video_name);
            });
            var title;
            var ariaLabel;
            if (selected_nodes.length !== 0) {
                if(selected_nodes.length === 1){
                    title = 'VIDEOLIST.delete_selected_video_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_video_aria_label';
                }else{
                    title = 'VIDEOLIST.delete_selected_videos_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_videos_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(e,selected_nodes.length,title,ariaLabel)).then(function () {
                    deleteNodes(selected_nodes);
                    removeNodes(allVideoName);
                    selected_nodes = [];
                }, function () {
                });
            }
        }
        function removeNodes(allVideoName) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.deleteOnHoldVid@save', {videoNames: allVideoName},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        if(allVideoName.length === 1 ){
                            webTvGlobal.$toast().showSimple(allVideoName[0] + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
                        }else{
                            webTvGlobal.$toast().showSimple($translate.instant('VIDEOLIST.dialog_alert_delete_all_description'));
                        }
                        callbackButtonUpload = false;
                        callbackButtonDelete = false;
                        msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                            mediaVideoOnHoldData = res.data;
                            if(mediaVideoOnHoldData.length === 0){
                                vm.hide = true;
                            }
                        });
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_title'),
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }
        function deleteNodes(selected_nodes) {
            selected_nodes.forEach(function (id_node) {
                var node = vm.treeInstance.jstree(true).get_node(id_node);
                vm.treeInstance.jstree(true).delete_node(node);
            });
        }

        /**
         * delete node confirm
         * @param   node
         */
        function deleteNodeConfirm(node) {
            var title = node.text;
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted_video",
                "VIDEOLIST.delete_video_msg",
                "VIDEOLIST.delete_video_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_video_msg'])
                        .htmlContent('<b>' + title + '</b>' + translatedValues['VIDEOLIST.dialog_will_be_deleted_video'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_video_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteNode(node);
                        removeNode(node);
                    }, function () {
                        $mdDialog.hide();
                        callbackButtonDelete = false;
                        vm.treeInstance.jstree(true).refresh();
                    });
                });
        }

        function deleteNode(node) {
            vm.treeInstance.jstree(true).delete_node(node);
        }

        function removeNode(node) {
            $rootScope.loadingProgress = true;
            var video_name = node.original.file;
            if(folder_sftp_piper){
                var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                if (lastChar === '/') {         // If the last character is not a slash
                    folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                }
                video_name = folder_sftp_piper + video_name;
            }
            var videos_names = [];
            videos_names.push(video_name);
            msApi.request('media_video.deleteOnHoldVid@save', {videoNames: videos_names},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple(node.text + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
                        callbackButtonUpload = false;
                        callbackButtonDelete = false;
                        msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                            mediaVideoOnHoldData = res.data;
                            if(mediaVideoOnHoldData.length === 0){
                                vm.hide = true;
                            }
                        });
                    }
                    else {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_error_title",
                            "VIDEOLIST.dialog_alert_delete_error_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                $mdDialog.show(alert).finally(function () {
                                    translatedValues.alert = undefined;
                                });
                            });
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        function closeUpload(ev) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('VIDEOUPLOAD.cancel_confirm'))
                .targetEvent(ev)
                .ok($translate.instant('VIDEOUPLOAD.yes'))
                .cancel($translate.instant('VIDEOUPLOAD.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.isUploading = false;
                vm.cancelUpload();
            }, function () {

            });


        }

        function goToAddPage() {
            if(vm.automatic_addition){
                var subFolder = "";
                vm.VerifHashSourceAndOpenAdd(videoKeyName, videoHash, subFolder, true);
            }else{
                vm.VerifHashSourceAndOpenAdd(videoKeyName, videoHash);
            }
        }

        function goToAddPageMulti(test, item, isUploadPage) {
            added_item = item;
            tokenVideo = tokens[$rootScope.filesNames.indexOf(test)];
            if(vm.automatic_addition){
                var subFolder = "";
                var title = $rootScope.files[$rootScope.filesNames.indexOf(test)];
                vm.VerifHashSourceAndOpenAdd(title, item.file.hashSource, subFolder, true);
            }else{
                var title = $rootScope.files[$rootScope.filesNames.indexOf(test)];
                if (isUploadPage && item) {
                    if (item.isSuccess && $state.current.name !== 'app.media_video_add')
                        vm.VerifHashSourceAndOpenAdd(title, item.file.hashSource);
                } else
                    vm.VerifHashSourceAndOpenAdd(title, item.file.hashSource);
            }

        }

        function click() {
            if ($('div').hasClass('showMail-upload')) {
                $('.theme-config-box-upload').removeClass('showMail-upload');
                vm.icon = false;
            }
            else {
                $('.theme-config-box-upload').addClass('showMail-upload');
                vm.icon = true;

            }
        }

        function closeUploadMulti(ev) {
            if ($rootScope.endUpload) {
                var confirm = $mdDialog.confirm()
                    .title($translate.instant('VIDEOUPLOAD.close_confirm'))
                    .targetEvent(ev)
                    .ok($translate.instant('VIDEOUPLOAD.yes'))
                    .cancel($translate.instant('VIDEOUPLOAD.no'));

                $mdDialog.show(confirm).then(function () {
                    $rootScope.isUploading = false;
                    // uploader.cancelAll();
                }, function () {

                });
            } else {
                var confirm = $mdDialog.confirm()
                    .title($translate.instant('VIDEOUPLOAD.cancel_confirm'))
                    .targetEvent(ev)
                    .ok($translate.instant('VIDEOUPLOAD.yes'))
                    .cancel($translate.instant('VIDEOUPLOAD.no'));

                $mdDialog.show(confirm).then(function () {
                    $rootScope.isUploading = false;
                    uploader.cancelAll();
                }, function () {

                });
            }
        }

        function onWebcamSelected() {
            // The ID of the extension we want to talk to.
            if ("uid_extension" in parameters && vm.isChrome) {
                var editorExtensionId = parameters['uid_extension'];
                // Make a simple request:
                if(!angular.isUndefined(chrome.runtime)) {
                    chrome.runtime.sendMessage(editorExtensionId, {},
                        function (response) {
                            vm.isInstalledExtension = (response && response.data == "success");
                        });
                }
            }
        }

        function uploadExternel() {
            $state.go('app.media_video_add_externel', {"title": vm.video_link});
        }


        // function returnToList() {
        //     $state.go('app.media_video_list_ongoing');
        // }

        function redirect() {
            if ("url_extension" in parameters) {
                var linkExtension = parameters['url_extension'];
                $window.open(linkExtension);
            }
        }


        function init() {
            if (webTv_msNavigation['media_video']) {
                $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
                $rootScope.titre3 = "";
            }else{
                $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
                $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
            }

            $rootScope.pageRoute = "app.media_video_list_ongoing";
            $rootScope.welcome = "welcome_upload_add";
            $rootScope.text = [{
                texte: "button_upload_add_help"
            }];
        }


        /**
         * Check if after upload , has an error on generating meta data has been thrown
         */
        function checkUploadMetaDataError() {
            if (angular.isDefined($rootScope.uploadMetaDataError) && $rootScope.uploadMetaDataError) {
                $rootScope.uploadMetaDataError = undefined;
                vm.uploadMetaDataError = true;
            }
            if (angular.isDefined($rootScope.uploadMetaDataExternalError) && $rootScope.uploadMetaDataExternalError) {
                vm.uploadMetaDataExternalError = $rootScope.uploadMetaDataExternalError;
                $rootScope.uploadMetaDataExternalError = undefined;
                // vm.uploadMetaDataExternalError = true;
            }
        }


        function fileAdded(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            else $rootScope.isUploading = true;

            vm.videoFile = file;
        }

        function fileProgress(file) {

            vm.progressBarValue = file.progress() * 100;
            if(vm.progressBarValue===100){
                $rootScope.loadingProgress=true;
            }

            console.log("-------fileProgress--------------")
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            // Set headers
            // vm.ngFlow.flow.opts.headers = {};
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }


        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            var data = JSON.parse(message);
            if (angular.isDefined(data.file_name)) {
                videoKeyName = data.file_name;
                videoHash = data.hashSource;
                if (angular.isDefined(data.token)) {
                    tokenVideo = data.token;
                }
            } else return;
            // if (/^error !$/.test(message) || /^error$/.test(message)) return;
            // else vm.videoKeyName = message;
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            vm.progressBarValue = 0;
            vm.inProgress = false;
            $rootScope.endUpload = true;
            console.log(videoKeyName);
            if (angular.isDefined(vm.videoFile) && videoKeyName  && $state.current.url === "/medias/videos/upload") {
                if(!vm.automatic_addition){
                    vm.VerifHashSourceAndOpenAdd(videoKeyName, videoHash);
                    webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFile.name}), '', function () {
                        videoKeyName = "";
                    }, false, 500).then(function () {
                    });
                }else{
                    var subFolder = "";
                    vm.VerifHashSourceAndOpenAdd(videoKeyName, videoHash, subFolder, true);
                }
            }
            else {
                if (!angular.isDefined(vm.videoFile) && vm.imageName) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }

        }

        /**
         * Stop upload operation
         */
        function cancelUpload() {
            $timeout(function () {
                vm.ngFlow.flow.cancel();
            });
        }


        function add(video_id) {
            var title = vm.videoDataTable[video_id].fileTitle;
            var hashSource = vm.videoDataTable[video_id].hashSource;
            vm.VerifHashSourceAndOpenAdd(title, hashSource, "", false,'on-hold', video_id );
            $mdDialog.hide();

        }

        function add_sftp_vod(title, hashSource, subFolder) {
            vm.VerifHashSourceAndOpenAdd(title, hashSource, subFolder, false);
            $mdDialog.hide();
        }



        function fillData1() {
            tree = [];
            var i = 0;
            var j = tree.length;
            do {
                tree.push(mediaVideoOnHoldData[i + j]);
                if (mediaVideoOnHoldData[i + j].parent === "#") {
                    i++;
                } else {
                    j++
                }
            } while (i < 20 && i + j < mediaVideoOnHoldData.length);
            if (i < 19) {
                vm.testData = false;
            }

            vm.tree = tree;
        }
        function getVideoOnHold() {
            load_data = true;
            searchVodsInAPI(filtre);
        }


        function contributorName(contributor) {
            if (!contributor || angular.isUndefined(contributor.id)) return $translate.instant('MESSAGES.none');
            var fullName = contributor.lastName + " " + contributor.firstName;
            fullName = fullName.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
            return $sce.trustAsResourceUrl("<strong>" + fullName + "</strong>");
        }


        function addVideo(request,title){
            msApi.request('media_video.automaticAddVideo@save',request,
                function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$flashMessages().set('MediaVideoAdd', {title: title ? title : "VID"});
                        $rootScope.isUploading = false;
                        if(vm.isMultiUpload) {
                            if (!$rootScope.addedMultiUpload) {
                                var fileName = "";
                                if (added_item) {
                                    fileName = added_item.file.name;
                                    added_item.remove();
                                }
                                if (uploader.queue.length > 0) {
                                    var messageToast = $translate.instant('VIDEOUPLOAD.add_video_automatic', {fileName: fileName}) + $translate.instant('VIDEOUPLOAD.add_video_automatic_multiple');
                                    webTvGlobal.$toast().showSimple(messageToast);
                                } else {
                                    $state.go('app.media_video_list', {type: "ongoing"});
                                }
                            } else {
                                if (added_item) {
                                    fileName = added_item.file.name;
                                    $rootScope.uploader_queue = $rootScope.uploader_queue.filter(function (item) {
                                        return item !== added_item
                                    });
                                }
                                if ($rootScope.uploader_queue.length > 0) {
                                    var messageToast = $translate.instant('VIDEOUPLOAD.add_video_automatic', {fileName: fileName}) + $translate.instant('VIDEOUPLOAD.add_video_automatic_multiple');
                                    webTvGlobal.$toast().showSimple(messageToast);
                                } else {
                                    $state.go('app.media_video_list', {type: "ongoing"});
                                }
                            }
                        }else{
                            $state.go('app.media_video_list', {type: "ongoing"});
                        }
                    }else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }
        function automaticAddVideo(title,subFolder, hashSource){
            var metaData ;
            var author ;
            var copyright ;
            var request;
            var parameters = webTvGlobal.$constant().webTvParameterBag();

            $http({
                url:apiPiper + 'assets/metadata',
                method: "GET",
                params: {client: parameters['app.client.name'] , video: title},
            }).success(function (res) {
                if (angular.isDefined(res.format) && angular.isDefined(res.streams)) {
                    metaData = angular.toJson({"contentJson" : res});
                    author = "";
                    if (angular.isDefined(res.format.tags) && res.format.tags && angular.isDefined(res.format.tags.copyright)){
                        copyright = res.format.tags.copyright;
                    }else{
                        copyright = "";
                    }
                    if (angular.isDefined(res.format.tags) && res.format.tags && angular.isDefined(res.format.tags.artist)){
                        author = res.format.tags.artist;
                    }else{
                        author = "";
                    }
                    var videoThumb = "";
                    var requestData = {"fileName": title};
                    var token = tokenVideo ? tokenVideo : title.split('.').slice(0, -1).join('.');
                  var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
                    msApi.request('media_video.getGeneratedThumbs@get',
                        requestData,
                        function (res) {
                            if (res.thumbnails.length) {
                                videoThumb = url_thumbnails_video_piper + res.thumbnails[0];
                                request ={"fileTitle":title,"subFolder":subFolder,"logo":videoThumb,"metaData":metaData,"author": author,"copyright": copyright, "hashSource": hashSource, "token": token};
                                addVideo(request,title);
                            }else{
                                request ={"fileTitle":title,"subFolder":subFolder,"logo":videoThumb,"metaData":metaData,"author": author,"copyright": copyright, "hashSource": hashSource, "token": token};
                                addVideo(request,title);
                            }
                        }
                    );
                }else {
                    $rootScope.uploadMetaDataError = true;
                    $rootScope.index = 0;
                    $state.go('app.media_video_upload', {}, {reload: true});
                }
            });

        }

        function VerifHashSourceAndOpenAdd( title, hashSource, subFolder, callAutomaticAddVideo, page, video_id) {
            console.log('VerifHashSourceAndOpenAdd');
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            var videoMultiTitle  =  angular.isDefined(parameters["video_multi_title"])?parameters["video_multi_title"] == "1" ? true:false:false;
            $rootScope.loadingProgress=false;
            if (angular.isDefined(parameters['verif_source_video_exist']) && parameters['verif_source_video_exist']=== "1") {
                msApi.request('media_video.verifExistSource@get', {"hashSource": hashSource}, function (res) {
                    if (res.message === "video_source_already_exist") {
                        var videosExist = "";
                        angular.forEach(res.videos, function (value) {
                            if (value.link) {
                                videosExist += "<br>- Identifiant: " + value.id + " ( <a href='" + value.link + "' target='_blank' >Voir</a> ) ";
                            } else {
                                videosExist += "<br>- Identifiant: " + value.id + " ( " + value.extra + " ) ";
                            }
                        });
                        $translate([
                            "MESSAGES.form_choices_yes",
                            "MESSAGES.form_choices_no",
                            "MESSAGES.video_source_already_exist_video",
                            "MESSAGES.video_source_already_exist_video_request",
                            "MESSAGES.video_source_already_exist",
                            "MESSAGES.video_source_already_exist"
                        ])
                            .then(function (translatedValues) {
                                var confirm = $mdDialog.confirm()
                                    .title(translatedValues['MESSAGES.video_source_already_exist'])
                                    .htmlContent(translatedValues['MESSAGES.video_source_already_exist_video'] + videosExist + translatedValues['MESSAGES.video_source_already_exist_video_request'])
                                    .ariaLabel(translatedValues['MESSAGES.video_source_already_exist'])
                                    .ok(translatedValues['MESSAGES.form_choices_yes'])
                                    .cancel(translatedValues['MESSAGES.form_choices_no']);
                                $mdDialog.show(confirm).then(function () {
                                    if (callAutomaticAddVideo) {
                                        automaticAddVideo(title, subFolder, hashSource);
                                    } else {
                                        add_video_redirect(title, hashSource, subFolder, videoMultiTitle, page, video_id);
                                    }
                                }, function () {
                                });
                            });
                    } else {
                        if (callAutomaticAddVideo) {
                            automaticAddVideo(title, subFolder, hashSource);
                        } else {
                            add_video_redirect(title, hashSource, subFolder, videoMultiTitle, page, video_id);
                        }
                    }
                });
            }else{
                console.log('VerifHashSourceAndOpenAdd else');
                console.log(callAutomaticAddVideo);
                if (callAutomaticAddVideo) {
                    automaticAddVideo(title, subFolder, hashSource);
                } else {
                    add_video_redirect(title, hashSource, subFolder, videoMultiTitle, page, video_id);
                }
            }
        }
        function removeItemUpload(elm) {
            $rootScope.uploader_queue = $rootScope.uploader_queue.filter(function (item) {
                return item !== elm
            });
        }
        function add_video_redirect(title, hashSource, subFolder, videoMultiTitle, page, video_id, redirect){
            console.log('callAutomaticAddVideo');
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            var not_automatic_transcode  =  angular.isDefined(parameters["not_automatic_transcode"])?parameters["not_automatic_transcode"] == "1" ? true:false:false;
          var token = tokenVideo  ? tokenVideo : title.split('.').slice(0, -1).join('.')
          if (page == "on-hold") {
                if (videoMultiTitle) {
                    $state.go('app.media_video_edit_multi_title', {id: video_id, hold: "hold"});
                } else {
                    $state.go('app.media_video_edit', {id: video_id, hold: "hold"});
                }
            } else {
              var request = {firstStep: true, fileTitle: title, hashSource: hashSource, metaData: "", token: token};
                if(subFolder){
                    request.subFolder = subFolder;
                }
                if(vm.isCloudFlare){
                    request.external= true
                    request.isCloudflare= true
                    request.token= vm.videoToken ? vm.videoToken : token
                }
                $rootScope.loadingProgress=true;
                console.log('callAutomaticAddVideo else')
                console.log(not_automatic_transcode)
                if(not_automatic_transcode){
                    redirectFormAdd(title, hashSource, subFolder, videoMultiTitle, redirect);
                }else{
                    callApiAutomaticAddVideo(title, hashSource, subFolder, videoMultiTitle, request, redirect);
                }
            }
        }
        function redirectFormAdd(title, hashSource, subFolder, videoMultiTitle, redirect) {
            var state_go = "";
            if (redirect !== "multi") {
                state_go = "app.media_video_add_form_new";
                if (videoMultiTitle) {
                    state_go = "app.media_video_add_multi_title_form_new";
                }
            }
            var request = {
                "slug": md5(moment().unix),
                "title": title,
                "hashSource": hashSource
            };
            if (subFolder) {
                request.subFolder = subFolder;
            }
            if (vm.isMultiUpload) {
              if ($rootScope.uploadedFiles) {
                $rootScope.uploader_queue = $rootScope.uploadedFiles;
              } else {
                if (!$rootScope.addedMultiUpload) {
                  if (added_item) {
                    added_item.remove();
                  }
                    $rootScope.uploader_queue = uploader.queue;
                } else {
                  $rootScope.uploader_queue = $rootScope.uploader_queue.filter(function (item) {
                    return item !== added_item
                  });
                }
              }
            }

            if (state_go) {
                $state.go(state_go, request);
            }
        }
        function callApiAutomaticAddVideo(title, hashSource, subFolder, videoMultiTitle, request, redirect){
            console.log('callApiAutomaticAddVideo')
            var state_go = "";
            new Promise(function(resolve, reject) {
                msApi.request('media_video.automaticAddVideo@save', request).then(
                    function (res) {
                        resolve(res)
                        if (res.code === 200) {

                            if (redirect !== "multi") {
                                state_go = "app.media_video_add";
                                if (videoMultiTitle) {
                                    state_go = "app.media_video_add_multi_title";
                                }
                            }
                            var request = {
                                "id": res.id,
                                "slug": md5(moment().unix),
                                "title": title,
                                "hashSource": hashSource
                            };
                            if (subFolder) {
                                request.subFolder = subFolder;
                            }
                            if (vm.isMultiUpload) {
                              if($rootScope.uploadedFiles){
                                $rootScope.uploader_queue = $rootScope.uploadedFiles;
                              }else{
                                if (!$rootScope.addedMultiUpload) {
                                  if (added_item) {
                                    added_item.remove();
                                  }
                                  $rootScope.uploader_queue = uploader.queue;
                                } else {
                                  $rootScope.uploader_queue = $rootScope.uploader_queue.filter(function (item) {
                                    return item !== added_item
                                  });
                                }
                              }

                            }
                            if (state_go) {
                              if(res.fileTitle){
                                request.title = res.fileTitle;
                              }
                                $state.go(state_go, request);
                            }
                        } else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    }
                )
            })
        }
    }

    function previewModalController(video_id, title, hashSource, subFolder, functionVerifHashSource ,reupload, userManager, $sce, $translate, webTvGlobal, msApi, $state, $mdDialog,$rootScope) {



        var vm = this;
        getPlayerLink();
        vm.add = add;
        vm.change_video_source = change_video_source;
        vm.closeDialog = closeDialog;
        vm.reupload = reupload;
        var tokenVideo;
        /**
         * Close the dialog
         */
        function closeDialog() {
            $mdDialog.hide("close");

        }

        function add() {
            if(video_id) {
                functionVerifHashSource(title, hashSource, subFolder, false, 'on-hold', video_id);
            }else{
              var tokenTitle = title.split('.').slice(0, -1).join('.');
              msApi.request('media_video.getExistToken@get',{"token":tokenTitle}, function (res) {
                if(angular.isDefined(res.exist_token) && !res.exist_token){
                  tokenVideo = tokenTitle;
                  functionVerifHashSource(title, hashSource, subFolder);
                }else{
                  msApi.request('media_video.dupliquateSource@save', {videoName: title, userid: userManager.getId()},function (response) {
                    if(angular.isDefined(response.token) && response.token){
                      tokenVideo = response.token;
                      title = response.duplicatedVideo;
                      functionVerifHashSource(title, hashSource, subFolder);
                    }
                  });
                }
              });
            }
            $mdDialog.hide();

        }
        function change_video_source() {
            $rootScope.confirm_reupload = true;
            $mdDialog.hide("change");
        }

        function getPlayerLink() {
            if(video_id) {
                var api = "preview-modal.getPreviewLink@get";
                var request = {"id": video_id, "y": "bo"};
            }else {
                var api = 'preview-modal.getPreviewLinkByTitle@get';
                var request = {"title": title, "y": "bo", "subFolder": subFolder};
            }
            msApi.request(
                api,
                request,
                function (res) {
                    if (res.code === 200) {
                        vm.showPlayer = 1;
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {

            });
        }


    }
})();




(function () {
    'use strict';

    angular
        .module('app.media.video.upload-vod', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.media_video_upload', {
                url: "/medias/videos/upload",

                bodyClass: 'e-commerce',
                "actionPermission" : "media_video_post_add_action"
            });


        //API


    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.upload-vod')
        .controller('uploadVodController', uploadVodController);

    /** @ngInject */
    function uploadVodController($rootScope,$timeout) {

    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.montage_new', ['textAngular', "flow"])
        .config(config);

    function config($stateProvider) {

        $stateProvider
            .state('app.media_video_montage_new', {
                parent: 'app.access_rapid',
                url: "/montage-new",
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/montage-new/montage.template.html',
                        controller: 'mediaVideoMontageNewController as vm'
                    }
                },
                "actionPermission" : "media_video_get_date_last_montage_action"
            });

    }


})();
(function () {
  'use strict';
  angular
    .module('app.media.video.montage_new')
    .controller('mediaVideoMontageNewController', mediaVideoMontageNewController);

  function mediaVideoMontageNewController($rootScope, $stateParams,$state,webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    /* End Injection*/
    var vm = this;
    vm.event = "modal-preview-montage-video.getMontageNewPreview@get";
    vm.params = {id: $stateParams.id, isMontage: 1};
    initHelp();

    function initHelp() {

      if(webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_montage_pagetitle";
        $rootScope.titre3 = "";
      }else{
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_montage_pagetitle";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";
    }
    var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    var eventer = window[eventMethod];
    var messageEvent = eventMethod == "attachEvent" ? "onmessage" : "message";
    eventer(messageEvent, function (e) {
      if (e.data.info === "redirectionVideoOffLigne") {
          try {
              $state.go("app.media_video_list", {type: "offline"});
          } catch (e) {

          }

      }
    }, false);

  }
})();

(function () {


  'use strict';

  angular
    .module('app.media.video.list')
    .controller('mediaVideoMetaModalController', mediaVideoMetaModalController);

  /** @ngInject */
  function mediaVideoMetaModalController($mdDialog, metaData, $translate, mdDialogTitle, webTvGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.spinner = true;
    vm.metaData = metaData;
    console.log(metaData);
    vm.title = mdDialogTitle;
    vm.other = other;
    vm.detailMetaData = {};
    vm.closeDialog = closeDialog;
    vm.roundWithPrecision = roundWithPrecision;

    setDetailMetaData();

    vm.hasMetaData = hasMetaData;

    function other() {
      return angular.isDefined(vm.metaData.other) ? true : false;
    }

    /**
     * Close the dialog
     */
    function closeDialog() {
      $mdDialog.hide();

    }

    /**
     * Check if imported video has metdata
     * @return Boolean
     */
    function hasMetaData() {
      return angular.isDefined(vm.detailMetaData.video) || angular.isDefined(vm.detailMetaData.audio) || false;
    }
    console.log( "has m "+ vm.hasMetaData);
    function setDetailMetaData() {
      if (angular.isDefined(vm.metaData) && angular.isDefined(vm.metaData.format) && angular.isDefined(vm.metaData.streams)) {

        var video = vm.metaData.streams[0];
        var audio = vm.metaData.streams[1];


        if (video.codec_type === "audio") {
          audio = vm.metaData.streams[0];
          video = vm.metaData.streams[1];
        }
        if (video) {
          var format = vm.metaData.format;
          vm.detailMetaData.video = {
              bitrate: (format.bit_rate / 1000) + " " + $translate.instant('MESSAGES.kb_per_s'),
              resolution: video.width + " x " + video.height,
              duration: moment.utc(format.duration * 1000).format("HH:mm:ss"),
              size: (function () {
                var bytes = format.size,
                  kilobyte = 1024,
                  megabyte = kilobyte * 1024,
                  gigabyte = megabyte * 1024,
                  terabyte = gigabyte * 1024,
                  precision = 2,
                  size;
                if ((bytes >= kilobyte) && (bytes < megabyte)) size = vm.roundWithPrecision(bytes / kilobyte, precision) + ' ' + $translate.instant('MESSAGES.size_kb');
                else if ((bytes >= megabyte) && (bytes < gigabyte)) size = vm.roundWithPrecision(bytes / megabyte, precision) + ' ' + $translate.instant('MESSAGES.size_mb');
                else if ((bytes >= gigabyte) && (bytes < terabyte)) size = vm.roundWithPrecision(bytes / gigabyte, precision) + ' ' + $translate.instant('MESSAGES.size_gb');
                else if (bytes >= terabyte) size = vm.roundWithPrecision(bytes / terabyte, precision) + ' ' + $translate.instant('MESSAGES.size_tb');
                else size = bytes + ' ' + $translate.instant('MESSAGES.size_bytes');
                return size;

              })(),
              framerate: video.r_frame_rate,
              codec: video.codec_long_name && video.codec_long_name!=="unknown" ? video.codec_long_name : video.codec_name
            };
          }
          if(audio){
              vm.detailMetaData.audio= {
                  samplerate: audio.sample_rate,
                      codec: audio.codec_long_name  && audio.codec_long_name!=="unknown" ? audio.codec_long_name : audio.codec_name,
                      bitrate: (audio.bit_rate / 100) + " " + $translate.instant('MESSAGES.kb_per_s')
              }
          }
      }

    }


  }


})();

(function () {
    'use strict';

    angular
        .module('app.media.video.questions_quiz', [])
        .config(config)
        .run(fetchRights);

    function config($stateProvider, msApiProvider) {

        $stateProvider
            .state('app.media_video_questions_quiz', {
                parent: 'app.access_rapid',
                url: "/questions-quiz",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/questions-quiz/questions_quiz.template.html',
                        controller: 'QuestionsQuizTemplateController as vm'
                    }
                },
                "bodyClass": "e-commerce"
            })
            .state('app.media_video_questions_quiz.questions', {
                url: "/questions",
                views: {
                    'questions@app.media_video_questions_quiz': {
                        templateUrl: 'app/main/media/video/questions-quiz/questions.template.html',
                        controller: 'QuestionsQuizController as vm'

                    }
                },
                resolve: {
                    ResponsesListData: function (msApi, $stateParams) {
                        return msApi.resolve('responses.list@get', {idVideo: $stateParams.id});
                    }
                }
            })
            .state('app.media_video_questions_quiz.quiz', {
                url: "/quiz",
                views: {
                    'quiz@app.media_video_questions_quiz': {
                        templateUrl: 'app/main/media/video/questions-quiz/quiz.template.html',
                        controller: 'QuestionsQuizController as vm'

                    }
                },
                resolve: {
                    ResponsesListData: function (msApi, $stateParams) {
                        return msApi.resolve('responses.list@get', {idVideo: $stateParams.id});
                    }
                }
            });
        // Api
        msApiProvider.register('responses.list', [Routing.generate('api_media_get_responses_for_questions_and_quiz', {idVideo: ':idVideo'}).replace(/%3A/, ":"), {idVideo: '@idVideo'}]);
        msApiProvider.register('quiz_questions.exportCsv', [Routing.generate('api_media_get_questions_and_quiz_excel')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*media)(?=.*questions_and_quiz).*$",
                name_module: "questions_quiz",
                name_angular_module: "app.media.video.questions_quiz",
                actions: [
                    {"list_questions_and_quiz": ["get_responses"]}

                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.media.video.questions_quiz')
    .controller('QuestionsQuizController', QuestionsQuizController)
    .controller('QuestionsQuizTemplateController', QuestionsQuizTemplateController);

  /** @ngInject */
  function QuestionsQuizController(dtable_language, $cookies, ResponsesListData, msUtils, $mdDialog, msApi, webTvGlobal, DTOptionsBuilder, $injector, webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var $rootScope = $injector.get('$rootScope'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate');
    var vm = this;
    vm.questions = angular.isDefined(ResponsesListData.data) && angular.isDefined(ResponsesListData.data.responses_questions) ? ResponsesListData.data.responses_questions : [];
    vm.quiz = angular.isDefined(ResponsesListData.data) && angular.isDefined(ResponsesListData.data.responses_quiz) ? ResponsesListData.data.responses_quiz : [];
    vm.dtInstance = {};
    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withDataProp('data')
      .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
      .withOption('columnDefs', [[
        {
          // Target the checkbox column
          responsivePriority: 1,
          filterable: false,
          sortable: false
        },
        {
          targets: [1],
          width: '72px'
        }
      ]
      ])
      .withOption("order", [[0, 'desc']])
      .withOption('lengthMenu', [5,10, 20, 30, 50, 100])
      .withOption('pageLength', 20)
      .withOption('scrollY', 'auto')
      .withOption('responsive', true)
      .withPaginationType('full_numbers')
      .withOption('language', dtable_language[$cookies.get('WEBTV.locale')])
    ;

    $rootScope.rerender = rerender;

    /**
     * rerender datatable
     */
    function rerender() {
      vm.dtInstance.rerender();
    }

    initHelp();

    function initHelp() {
      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_questions_quiz";
        $rootScope.titre3 = "";
      }else {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_questions_quiz";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_video";
      $rootScope.text = [{

        texte: "parameters_video_add_help"
      }, {
        texte: "upload_button_video_add_help"
      }, {
        texte: "send_button_video_add_help"
      }, {
        texte: "cancel_button_video_add_help"
      }];
    }
  }

  function QuestionsQuizTemplateController($rootScope, msApi, HelpGlobal) {
    var vm = this;
    vm.testInQuestions = '';
    if ($rootScope.state.params.id) {
      if ($rootScope.state.current.url.indexOf('questions') > 0) {
        vm.testInQuestions = 'questions';
      }
      else {
        if ($rootScope.state.current.url.indexOf('quiz') > 0) {
          vm.testInQuestions = 'quiz';
        }
      }

    }
      vm.exportCsv=exportCsv;
      function exportCsv() {
          if ($rootScope.state.current.url.indexOf('questions') > 0) {
              vm.testInQuestions = 'questions';
          }
          else {
              if ($rootScope.state.current.url.indexOf('quiz') > 0) {
                  vm.testInQuestions = 'quiz';
              }
          }
          msApi.request("quiz_questions.exportCsv@get", {id_video:$rootScope.state.params.id,type:vm.testInQuestions},
              function (response) {
                  if (response.code === 200) {
                      window.location.href = response.url;
                  }
                  else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              });

      }
  }


})();

(function () {
    'use strict';

    angular
        .module('app.media.video.reupload', ['flow'])
        .config(config);

    /** @ngInject */
    function config( msApiProvider) {


        msApiProvider.register('media_video.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getTokenVideo', [Routing.generate('api_media_get_token_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getGeneratedThumbs', [apiPiper + 'thumbnail']);
        msApiProvider.register('media_video.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")]);
        msApiProvider.register('media_video.updateSource', [Routing.generate('api_media_post_update_video_source', {id: ':id'}).replace(/%3A/g, ":"), {id: '@id'}]);
        msApiProvider.register('media_video.deleteVideos', [Routing.generate('api_multi_delete_videos') + "/:list", {list: '@list'}]);
        msApiProvider.register('parametersBagLogin.app', [Routing.generate('api_get_app_parameter_bag')]);
        msApiProvider.register('media_video.verifExistSource', [Routing.generate('api_media_exist_source_video', {hashSource: ':hashSource'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getMetaDataPiper', [apiPiper + 'assets/metadata']);
        msApiProvider.register('media_video.getOnHoldVodsPiper', [Routing.generate('api_dtable_list_dtable_videos_onhold')]);
        msApiProvider.register('media_video.getSFTPVids', [apiPiper + 'video/pending']);
        msApiProvider.register('media_video.deleteOnHoldVid', [apiPiper + 'video/delete-pending']);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.reupload')
        .controller('mediaVideoReuploadController', mediaVideoReuploadController);

    function mediaVideoReuploadController($scope, userManager, $injector, $window, $mdDialog, $cookies, dtable_language, DTOptionsBuilder, DTColumnBuilder, dialogConfirmDeleteService, webTv_msNavigation ) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            webTvGlobal = $injector.get('webTvGlobal'),
            $sce = $injector.get('$sce'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $stateParams = $injector.get('$stateParams'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            msUtils = $injector.get('msUtils'),
            msApi = $injector.get('msApi');
        var vm = this;
      var pemission = {};
      if (userManager.isActionGranted('media_video_add_option_extern_link')) {
        pemission.media_video_add_option_extern_link = true;
      }
      if (userManager.isActionGranted('media_video_add_option_webcam')) {
        pemission.media_video_add_option_webcam = true;
      }
      if (userManager.isActionGranted('media_video_add_option_on_hold_action')) {
        pemission.media_video_add_option_on_hold = true;
      }
      if (userManager.isActionGranted('media_video_add_option_on_hold_sftp_action')) {
        pemission.media_video_add_option_on_hold_sftp = true;
      }
      if (userManager.isActionGranted('media_video_add_option_presentation')) {
        pemission.media_video_add_option_presentation = true;
      }
      if (userManager.isActionGranted('media_video_add_option_story_board')) {
        pemission.media_video_add_option_story_board = true;
      }
      vm.permission = pemission;
        vm.uploadStep = 1;
        var videoThemesIds = [];
        vm.videoThumb = "";
        var videoData;
        if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1) {
            vm.isChrome = true;

        }
        vm.ngFlowOptionsVignette = {
            target: Routing.generate('api_media_post_thumb'),
            singleFile: true,
            testChunks: false,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
            //attributes: 'image/*',
            //testMethod: false,

        };
        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptionsVignette.attributes = 'image/*';
        vm.ngFlowVignette = {flow: {}};
        vm.imageNameVignette = "";
        vm.uploadingInPogressVignette = 0;
        vm.droppingVignette = false;
        vm.inProgressVignette = false;
        // Methods
        vm.fileAddedVignette = fileAddedVignette;
        vm.uploadFileVignette = uploadFileVignette;
        vm.fileSuccessVignette = fileSuccessVignette;
        vm.fileErrorVignette = fileErrorVignette;
        vm.uploadCompleteVignette = uploadCompleteVignette;

        vm.is_on_hold = false;
        vm.videoOnHoldId = null;
        vm.metadata = "";
        vm.idVideoToReupload = $rootScope.idVideoToReupload ? $rootScope.idVideoToReupload:$state.params.id;
        vm.returnToList = returnToList;
        vm.save = save;
        vm.redirect = redirect;
        vm.isInstalledExtension = false;
        vm.onWebcamSelected = onWebcamSelected;
        vm.chaneSource = chaneSource;
        vm.verifExistSource = verifExistSource;
        vm.click = click;
        vm.click();
        vm.icon = true;
        vm.videoDataTable = {};
        vm.vods = [];
        var data = [];
        var filtre = {};
        var load_data = false;
        vm.dtInstance = {};
        vm.selectedVods = [];
        var selectedVods = [];
        vm.render = rerender;
        vm.preview_onhold_video = preview_onhold_video;
        vm.select_vod_to_change = select_vod_to_change;
        vm.deleteOnHoldConfirm = deleteOnHoldConfirm;
        vm.deleteOnHoldVideosConfirm = deleteOnHoldVideosConfirm;
        vm.toggleOnHoldVod = toggleOnHoldVod;
        vm.toggleAll = toggleAll;
        $rootScope.rerender = rerender;
        vm.searchVods = searchVods;
        vm.getVideoOnHold = getVideoOnHold;
        vm.deleteNodeConfirm = deleteNodeConfirm;
        vm.deleteNodesConfirm = deleteNodesConfirm;
        vm.getVideoOnHoldSFTP = getVideoOnHoldSFTP;
        vm.fillData1 = fillData1;
        vm.hide = false;
        var folder_sftp_piper = "";
        vm.add_sftp_vod = add_sftp_vod;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.videoDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.videoDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggleOnHoldVod(vm.videoDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn('fileTitle').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('startDate').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('contributor').notSortable()
                .renderWith(function (data, type, full) {
                    var name_contributor = contributorName(data);
                    var serverHtml = "";
                    if (data === null) {
                        serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" ></Any>';
                    }
                    else {
                        serverHtml += '<Any>' + name_contributor + '</Any>';
                    }
                    return serverHtml;
                }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    var buttons = "";
                    vm.videoDataTable[data.id] = data;
                    buttons = '<a  tooltips tooltip-template=' + "{{'MESSAGES.preview_video'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  ng-click="vm.preview_onhold_video('+data.id+')" style="display: inline-flex;" aria-label="preview_video" translate translate-attr-aria-label="MESSAGES.preview_video"><md-icon md-font-icon="icon-play" class="s18"></md-icon></md-button></a>';
                    buttons += '<a  tooltips tooltip-template=' + "{{'MESSAGES.form_change'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  style="display: inline-flex;" ng-click="vm.select_vod_to_change('+data.id+')" aria-label="form_change" translate translate-attr-aria-label="MESSAGES.form_change"><md-icon md-font-icon="icon-upload-custom" class="s18"></md-icon></md-button></a>';
                    buttons += '<a  tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button"  style="display: inline-flex;" ng-click="vm.deleteOnHoldConfirm('+data.id+')" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete"><md-icon md-font-icon="icon-delete" class="s18"></md-icon></md-button></a>';
                    return '<div><div layout="row" style="width: 460px" show-gt-sm hide-sm hide-xs layout-wrap>' + buttons + '</div><div layout="row" style="width: 260px" hide-gt-sm show-sm hide-xs layout-wrap>' + buttons + '</div><div layout="row" style="width: 120px" hide-gt-sm hide-sm show-xs layout-wrap>' + buttons + '</div></div>';
                })


        ];
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        var newOptions = DTOptionsBuilder.newOptions();
        vm.dtOptions = newOptions
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    targets: 0,
                    responsivePriority: 1,
                    width: '30px'
                },
                {
                    targets: 1,
                    responsivePriority: 7,
                    filterable: true,
                    sortable: true,
                    width: '40px'
                },
                {
                    targets: 2,
                    responsivePriority: 5,
                    filterable: true,
                    sortable: false,
                    visible: false,
                    width: '100px'
                },
                {
                    targets: 3,
                    responsivePriority: 2,
                    filterable: true,
                    sortable: true,
                    width: '50px'
                },
                {
                    targets: 4,
                    responsivePriority: 6,
                    filterable: true,
                    sortable: true,
                    width: '100px'
                },
                {
                    targets: 5,
                    responsivePriority: 3,
                    filterable: false,
                    sortable: false,
                    width: '100px'
                }

            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function getVideoOnHold() {
            vm.is_on_hold = true;
            load_data = true;
            searchVodsInAPI(filtre);
        }
        function contributorName(contributor) {
            if (!contributor || angular.isUndefined(contributor.id)) return $translate.instant('MESSAGES.none');
            var fullName = contributor.lastName + " " + contributor.firstName;
            fullName = fullName.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
            return $sce.trustAsResourceUrl("<strong>" + fullName + "</strong>");
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchVodsInAPI(filtre), true);

        }
        function serverData(sSource, aoData, fnCallback) {
            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = sort.column - 1 < 0 ? 0 : sort.column - 1;
            vm.checkedSelected = false;

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_videos,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre.searchWord = vm.search_videos;
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;
            if(load_data) {
                searchVodsInAPI(filtre);
            }
        }
        function searchVods() {
            filtre.searchWord = vm.search_videos;
            filtre.start=0;
            filtre.draw=0;
            searchVodsInAPI(filtre);
        }
        function searchVodsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request("media_video.getOnHoldVodsPiper@get", filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var vods = response.data;


                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': vods
                        };
                        vm.vods = vods;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.vods = [];
                            vm.recordsTotal = 0;
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }

        function preview_onhold_video(id){
            var title = vm.videoDataTable[id].fileTitle;
            var video_id = vm.videoDataTable[id].id;
            var hashSource = vm.videoDataTable[id].hashSource;
            $mdDialog.show({
                controller: 'previewModalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/upload/preview-modal.template.html',
                clickOutsideToClose: true,
                locals: {
                    video_id: video_id,
                    title: title,
                    hashSource: hashSource,
                    subFolder: "",
                    reupload: true,
                    functionVerifHashSource: vm.VerifHashSourceAndOpenAdd

                }
            }).then(function () {
                vm.select_vod_to_change(id);
            }, function () {
                //     $rootScope.$broadcast('VideoList::setInactive');
            });
        }

        function select_vod_to_change(id) {
            var title = vm.videoDataTable[id].fileTitle;
            var video_id = vm.videoDataTable[id].id;
            var hashSource = vm.videoDataTable[id].hashSource;
            vm.hashSource = hashSource;
            vm.videoKeyName = title;
            vm.videoOnHoldId = video_id;
            $scope.confirm_reupload = $rootScope.confirm_reupload;
            vm.verifExistSource('on-hold');
            $rootScope.confirm_reupload = true;
        }


        function deleteOnHoldConfirm(id) {
            var title = vm.videoDataTable[id].fileTitle;
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted_video",
                "VIDEOLIST.delete_video_msg",
                "VIDEOLIST.delete_video_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_video_msg'])
                        .htmlContent('<b>' + title + '</b>' + translatedValues['VIDEOLIST.dialog_will_be_deleted_video'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_video_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteOnHoldVideo(id, title);
                    }, function () {
                        $mdDialog.hide();
                    });
                });
        }
        function deleteOnHoldVideo(id, title) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.deleteVideos@delete', {list: [id]},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_title",
                            "VIDEOLIST.dialog_alert_delete_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                webTvGlobal.$toast().showSimple(title + translatedValues['VIDEOLIST.dialog_alert_delete_description']);
                                vm.vods.splice(vm.vods.indexOf(vm.videoDataTable[id]), 1);
                                rerender();
                            });
                    }
                    else {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_error_title",
                            "VIDEOLIST.dialog_alert_delete_error_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                var alert = $mdDialog.alert({
                                    title: translatedValues['VIDEOLIST.dialog_alert_delete_error_title'],
                                    textContent: translatedValues['VIDEOLIST.dialog_alert_delete_error_description'],
                                    ok: translatedValues['VIDEOLIST.dialog_alert_delete_close']
                                });

                                $mdDialog
                                    .show(alert)
                                    .finally(function () {
                                        alert = undefined;
                                    });
                            });

                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        function deleteOnHoldVideosConfirm(e) {
            var title;
            var ariaLabel;
            if (selectedVods.length !== 0) {
                if(selectedVods.length === 1){
                    title = 'VIDEOLIST.delete_selected_video_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_video_aria_label';
                }else{
                    title = 'VIDEOLIST.delete_selected_videos_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_videos_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(e,vm.selectedVods.length,title,ariaLabel)).then(function () {

                    deleteOnHoldVideos();
                    selectedVods = [];
                    vm.selectedVods = [];
                }, function () {
                });
            }
        }

        function deleteOnHoldVideos() {
            $rootScope.loadingProgress = true;
            var list_vods_selected = angular.copy(vm.selectedVods);
            var ids = [];
            angular.forEach(list_vods_selected, function (value, key) {
                ids.push(value.id);
            });
            if(ids.length !==0) {
                msApi.request('media_video.deleteVideos@delete', {list: ids},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "VIDEOLIST.dialog_alert_delete_title",
                                "VIDEOLIST.dialog_alert_delete_all_description",
                                "VIDEOLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(translatedValues['VIDEOLIST.dialog_alert_delete_all_description']);
                                    rerender();
                                });
                        }
                        else {
                            $translate([
                                "VIDEOLIST.dialog_alert_delete_error_title",
                                "VIDEOLIST.dialog_alert_delete_error_description",
                                "VIDEOLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['VIDEOLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['VIDEOLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['VIDEOLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    }
                );
            }
        }

        function toggleOnHoldVod(vod) {
            vod.checked = !vod.checked;
            var idx = selectedVods.indexOf(vod);
            if (idx > -1) {
                selectedVods.splice(idx, 1);
            }
            else {
                selectedVods.push(vod);
            }
            vm.selectedVods = angular.copy(selectedVods);
        }
        function toggleAll() {
            if (selectedVods.length === vm.vods.length) {
                vm.selectedVods = [];
            }
            else if ((selectedVods.length === 0) || (selectedVods.length > 0)) {
                vm.selectedVods = vm.vods.slice(0);
            }
            selectedVods = angular.copy(vm.selectedVods);
            var list_vods = angular.copy(vm.videoDataTable);
            angular.forEach(list_vods, function (value, key) {
                if (value !== undefined)
                    vm.videoDataTable[key].checked = selectedVods.length > 0;
            });
        }

        function click() {
            if ($('div').hasClass('showMail-upload')) {
                $('.theme-config-box-upload').removeClass('showMail-upload');
                vm.icon = false;
            }
            else {
                $('.theme-config-box-upload').addClass('showMail-upload');
                vm.icon = true;

            }
        }

        vm.goToReuploadPage = goToReuploadPage;

        function goToReuploadPage() {
            vm.verifExistSource("goToReuploadPage");
        }

        function onWebcamSelected() {
            // The ID of the extension we want to talk to.
            if ("uid_extension" in parameters && vm.isChrome) {
                var editorExtensionId = parameters['uid_extension'];
                // Make a simple request:
                chrome.runtime.sendMessage(editorExtensionId, {},
                    function (response) {
                        vm.isInstalledExtension = (response && response.data == "success");
                    });
            }
        }

        init();


        function redirect() {
            $window.open('https://chrome.google.com/webstore/detail/take-webpage-screenshots/mcbpblocgmgfnpjjppndjkmgjaogfceg?hl=fr', '_blank');


        }


        function setThemesIds(data) {
            for (var i = 0; i < data.length; i++) videoThemesIds.push(data[i].id);
        }

        /*** Upload Parameters *******/
        vm.videoFile = undefined;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        vm.ngFlowOptions = {query: {}};
        vm.tokenVideo = "";
        msApi.request('media_video.getTokenVideo@get', {id: $rootScope.idVideoToReupload ? $rootScope.idVideoToReupload:$state.params.id}
            , function (res) {
                vm.tokenVideo = res.token;
                if (angular.isUndefined(parameters['app.client.name'])) {
                    msApi.request('parametersBagLogin.app@get', function (res) {
                        parameters = res.bag;
                      vm.urlUpload = $sce.trustAsResourceUrl(parameters.url_upload_video_fo);
                      vm.ngFlowOptions = {
                            chunkSize: (function () {
                                return Math.pow(10, 100);
                            })(),
                            testChunks: false,
                            target: res.bag['url_import_video_piper'],
                            singleFile: true,
                            extendChunks: false,
                            fileParameterName: 'uploadfile',
                            query: {
                                type: 'videos',
                                userid: userManager.getId(),
                                token: vm.tokenVideo
                            },
                            headers: {Authorization: "Bearer " + $cookies.get("authToken")}
                        };
                    });
                }
                else {
                  vm.urlUpload = $sce.trustAsResourceUrl(parameters.url_upload_video_fo);

                  vm.ngFlowOptions = {
                        chunkSize: (function () {
                            return Math.pow(10, 100);
                        })(),
                        testChunks: false,
                        target: parameters['url_import_video_piper'],
                        singleFile: true,
                        extendChunks: false,
                        fileParameterName: 'uploadfile',
                        query: {
                            type: 'videos',
                            userid: userManager.getId(),
                            token: vm.tokenVideo
                        },
                        headers: {Authorization: "Bearer " + $cookies.get("authToken")}
                    };
                }


                vm.ngFlow = {
                    flow: {}
                };
                vm.dropping = false;
                vm.fileAdded = fileAdded;
                vm.uploadFile = uploadFile;
                vm.fileSuccess = fileSuccess;
                vm.uploadComplete = uploadComplete;
                vm.fileProgress = fileProgress;
                vm.cancelUpload = cancelUpload;
                vm.progressBarValue = 0;
                vm.roundWithPrecision = roundWithPrecision;
                vm.inProgress = false;
                vm.videoKeyName = "";
                vm.hashSource = "";
                vm.videoSubFolder = "";
                init();
            });

      eventPostMessage();
      function eventPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageReUploadVideo)) {
          window.dataEventPostMessageReUploadVideo = true;
          var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

          eventer(
            messageEvent,
            function(event) {
              if (event.data !== 'undefined') {
                if (event.data.info === 'addVideoForm' && $state.current.name === "app.media_video_reupload") {
                  console.log('addVideoForm');
                  console.log(event.data);
                  vm.videoFile = {name : event.data.value.file};
                  vm.uploadTus = true;

                  fileSuccess(event,{file_name:event.data.value.file, hashSource : event.data.value.hashSource });
                  vm.uploadComplete();
                }
              }
            },
            false
          );
        }
      }
        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAddedVignette(file) {
            if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
                vm.imageNameVignette = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
                return false;
            }
            if (file.size > 1024000) {
                vm.imageNameVignette = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_image_too_large_message'));
                return false;
            }
            vm.imageNameVignette = file.name;

        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFileVignette() {
            // Set headers
            vm.ngFlowVignette.flow.opts.headers = {};
            vm.ngFlowVignette.flow.upload();
            vm.inProgressVignette = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccessVignette(file, message) {
            vm.uploadingInPogressVignette = 0;
            var res = angular.fromJson(message);
            if (res.location.url) {
                //$rootScope.empMediaVideoForm.logo = res.location.url;
                vm.videoThumb = res.location.url;
            }

        }

        function fileErrorVignette() {
            vm.uploadingInPogressVignette = 0;
            vm.imageNameVignette = "";
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadCompleteVignette() {
            if (vm.imageNameVignette) {
                webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageNameVignette}));
            }

        }


        // select from on hold video
        $scope.treeEventsObj = {
            'changed.jstree': selectNode,
        };

        $.jstree.defaults.appendContent = {
            'content': null,
            'callback': $.noop,
            'className': 'jstree-appendContent'
        };

        $.jstree.plugins.appendContent = function (options, parent) {
            this.bind = function () {
                parent.bind.call(this);

                if (this.settings.appendContent.callback !== null) {
                    this.element.on('click.jstree', '.' + 'icon-delete',
                        $.proxy(function (e) {
                            e.stopImmediatePropagation();
                            this.settings.appendContent.callback.call(this,
                                this.get_node(e.target));
                            var node = this.get_node(e.target);
                            if(node.icon ==="icon-video") {
                                var title = node.text;
                                vm.deleteNodeConfirm(node);
                            }
                        }, this));

                    this.element.on('click.jstree', '.' + 'icon-upload-custom',
                        $.proxy(function (e) {
                            e.stopImmediatePropagation();
                            this.settings.appendContent.callback.call(this,
                                this.get_node(e.target));
                            var node = this.get_node(e.target);
                            if(node.icon ==="icon-video") {
                                var title = node.text;
                                var subFolder = node.original.file.replace('/' + title, "");
                                var hashSource = node.original.hashSource;
                                if(folder_sftp_piper){
                                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                                    if (lastChar === '/') {         // If the last character is not a slash
                                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                                    }
                                    subFolder = folder_sftp_piper + (subFolder ? subFolder : "");
                                }
                                vm.videoKeyName = title;
                                vm.videoSubFolder = subFolder;
                                vm.hashSource = hashSource;
                                $rootScope.confirm_reupload = true;
                                $scope.confirm_reupload = $rootScope.confirm_reupload;
                                getPlayerLink();
                                vm.verifExistSource('on-hold');
                            }
                        }, this));
                }
            };

            this.teardown = function () {
                if (this.settings.appendContent) {
                    this.element.find('.' + this.settings.appendContent.className).remove();
                }
                parent.teardown.call(this);
            };

            this.redraw_node = function (obj, deep, callback) {
                obj = parent.redraw_node.call(this, obj, deep, callback);
                if (obj) {
                    $('a', obj).first().after(
                        $(this.settings.appendContent.content).clone()
                            .addClass(this.settings.appendContent.className));
                }
                return obj;
            };
        };
        var callbackButtonUpload = false;
        var callbackButtonDelete = false;
        $scope.treeConfig = {
            core: {
                multiple: false,
                animation: false,
                error: function (error) {
                    console.log('treeCtrl: error from js tree - ' + angular.toJson(error));
                },
                check_callback: true,
                worker: true,
                themes : { "stripes" : true }
            },
            'plugins': ['sort', "dnd", "search","checkbox","appendContent"],
            'appendContent': {
                'content': $('<span style="float:right;line-height: 0;">').append($('<button>', {
                    'class': 'addNodeBtn',
                    'html': '<md-icon md-font-icon="icon-upload-custom" class="sb18 ng-scope md-default-theme md-font material-icons icon-upload-custom"></md-icon>',
                })).append('&nbsp;').append($('<button>', {
                    'class': 'deleteNodeBtn',
                    'html': '<md-icon md-font-icon="icon-delete" class="sb18 ng-scope md-default-theme md-font material-icons icon-delete"></md-icon>',
                })),
                'callback': function (node) {
                }
            },
            "checkbox": {
                "three_state": false,
                "real_checkboxes": false,
                "tie_selection" : false,
                "whole_node" : false,
                "keep_selected_style" : false
            },
            'sort': function (a, b) {
                var a1 = this.get_node(a);
                var b1 = this.get_node(b);
                if (a1.icon === b1.icon) {
                    return (a1.original.time < b1.original.time) ? 1 : -1;
                } else {
                    return (a1.icon > b1.icon) ? 1 : -1;
                }
            }
            ,
            version: 1
        };
        var mediaVideoOnHoldData;
        var tree = [];
        function getVideoOnHoldSFTP() {
            vm.is_on_hold = false;
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            folder_sftp_piper = angular.isDefined(parameters["folder_sftp_piper"]) && parameters["folder_sftp_piper"] ? parameters["folder_sftp_piper"]:"";
            msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                mediaVideoOnHoldData = res.data;
                vm.treeInstance = [];
                vm.tree = [];

                if (mediaVideoOnHoldData.length > 0) {
                    vm.fillData1();
                }
                if (mediaVideoOnHoldData.length > 20) {
                    vm.testData = true;

                }
                else
                    vm.testData = false;

            });
        }
        function selectNode(e, data) {
            var i, j;
            for (i = 0, j = data.selected.length; i < j; i++) {
                var title = data.instance.get_node(data.selected[i]).text;
                var subFolder = "";
                subFolder = webTvGlobal.getPathFile(subFolder, data, data.instance.get_node(data.selected[i]));
                var hashSource = data.instance.get_node(data.selected[i]).original.hashSource;
                if(folder_sftp_piper){
                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                    if (lastChar === '/') {         // If the last character is not a slash
                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                    }
                    subFolder = folder_sftp_piper + (subFolder ? '/'+subFolder : "");
                }
                vm.videoKeyName = title;
                vm.videoSubFolder = subFolder;
                vm.hashSource = hashSource;
                if (data.node.icon === "icon-video") {
                    if (angular.isDefined(videoData)) {
                        if(videoData.isTranscoded){
                            vm.playerIsLoading = 1;
                            getPlayerLink()
                        }
                    }
                    else {
                        if ($state.current.name === "app.media_video_reupload") {
                            $mdDialog.show({
                                controller: 'previewModalController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/media/video/upload/preview-modal.template.html',
                                clickOutsideToClose: true,
                                locals: {
                                    video_id: null,
                                    title: title,
                                    hashSource: hashSource,
                                    subFolder: subFolder,
                                    reupload: true,
                                    functionVerifHashSource: ""

                                }
                            }).then(function (action) {
                                if(action==="change") {
                                    $scope.confirm_reupload = $rootScope.confirm_reupload;
                                    getPlayerLink();
                                    vm.verifExistSource('on-hold');
                                }
                            }, function () {
                            });

                        }
                    }
                }
            }
        }
        function fillData() {
            var i = 0;
            var j = tree.length;
            do {
                tree.push(mediaVideoOnHoldData[i + j]);
                if (mediaVideoOnHoldData[i + j].parent === "#") {
                    i++;
                } else {
                    j++
                }
            } while (i < 20 && i + j < mediaVideoOnHoldData.length);
            if (i < 19) {
                vm.testData = false;
            }

            vm.tree = tree;
        }

        /**
         * delete nodes confirm
         */
        function deleteNodesConfirm(e) {
            var selected_nodes = vm.treeInstance.jstree(true).get_checked();
            var allText =[];
            var allVideoName =[];
            selected_nodes.forEach(function (id_node) {
                var node = vm.treeInstance.jstree(true).get_node(id_node);
                allText.push(node.text);
                var video_name = node.original.file;
                if(folder_sftp_piper){
                    var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                    if (lastChar === '/') {         // If the last character is not a slash
                        folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                    }
                    video_name = folder_sftp_piper + video_name;
                }
                allVideoName.push(video_name);
            });
            var title;
            var ariaLabel;
            if (selected_nodes.length !== 0) {
                if(selected_nodes.length === 1){
                    title = 'VIDEOLIST.delete_selected_video_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_video_aria_label';
                }else{
                    title = 'VIDEOLIST.delete_selected_videos_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_videos_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(e,selected_nodes.length,title,ariaLabel)).then(function () {
                    deleteNodes(selected_nodes);
                    removeNodes(allVideoName);
                    selected_nodes = [];
                }, function () {
                });
            }
        }
        function removeNodes(allVideoName) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.deleteOnHoldVid@save', {videoNames: allVideoName},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        if(allVideoName.length === 1 ){
                            webTvGlobal.$toast().showSimple(allVideoName[0] + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
                        }else{
                            webTvGlobal.$toast().showSimple($translate.instant('VIDEOLIST.dialog_alert_delete_all_description'));
                        }
                        callbackButtonUpload = false;
                        callbackButtonDelete = false;
                        msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                            mediaVideoOnHoldData = res.data;
                            if(mediaVideoOnHoldData.length === 0){
                                vm.hide = true;
                            }
                        });
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_title'),
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }
        function deleteNodes(selected_nodes) {
            selected_nodes.forEach(function (id_node) {
                var node = vm.treeInstance.jstree(true).get_node(id_node);
                vm.treeInstance.jstree(true).delete_node(node);
            });
        }

        /**
         * delete node confirm
         * @param   node
         */
        function deleteNodeConfirm(node) {
            var title = node.text;
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted_video",
                "VIDEOLIST.delete_video_msg",
                "VIDEOLIST.delete_video_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_video_msg'])
                        .htmlContent('<b>' + title + '</b>' + translatedValues['VIDEOLIST.dialog_will_be_deleted_video'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_video_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteNode(node);
                        removeNode(node);
                    }, function () {
                        $mdDialog.hide();
                        callbackButtonDelete = false;
                        vm.treeInstance.jstree(true).refresh();
                    });
                });
        }

        function deleteNode(node) {
            vm.treeInstance.jstree(true).delete_node(node);
        }

        function removeNode(node) {
            $rootScope.loadingProgress = true;
            var video_name = node.original.file;
            if(folder_sftp_piper){
                var lastChar = folder_sftp_piper.substr(-1); // Selects the last character
                if (lastChar === '/') {         // If the last character is not a slash
                    folder_sftp_piper = folder_sftp_piper.slice(0, -1);          // Append a slash to it.
                }
                video_name = folder_sftp_piper + video_name;
            }
            var videos_names = [];
            videos_names.push(video_name);
            msApi.request('media_video.deleteOnHoldVid@save', {videoNames: videos_names},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple(node.text + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
                        callbackButtonUpload = false;
                        callbackButtonDelete = false;
                        msApi.request('media_video.getSFTPVids@get',{"subFolder":folder_sftp_piper}, function (res) {
                            mediaVideoOnHoldData = res.data;
                            if(mediaVideoOnHoldData.length === 0){
                                vm.hide = true;
                            }
                        });
                    }
                    else {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_error_title",
                            "VIDEOLIST.dialog_alert_delete_error_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                $mdDialog.show(alert).finally(function () {
                                    translatedValues.alert = undefined;
                                });
                            });
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        function add_sftp_vod(title, hashSource, subFolder) {
            vm.VerifHashSourceAndOpenAdd(title, hashSource, subFolder, false);
            $mdDialog.hide();
        }
        function fillData1() {
            tree = [];
            var i = 0;
            var j = tree.length;
            do {
                tree.push(mediaVideoOnHoldData[i + j]);
                if (mediaVideoOnHoldData[i + j].parent === "#") {
                    i++;
                } else {
                    j++
                }
            } while (i < 20 && i + j < mediaVideoOnHoldData.length);
            if (i < 19) {
                vm.testData = false;
            }

            vm.tree = tree;
        }
        function init() {
          if(webTv_msNavigation['media_video']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
            $rootScope.titre3 = "";
          }
          else {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
          }
            if (angular.isUndefined($rootScope.currentState)) {
                $rootScope.pageRoute = 'app.media_video_list_ongoing';
            }
            else {
                $rootScope.pageRoute = $rootScope.currentState;
            }
            $rootScope.welcome = "welcome_upload_add";
            $rootScope.text = [{
                texte: "button_upload_add_help"
            }];
        }


        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            else $rootScope.isReuploading = true;
            vm.videoFile = file;
            // $rootScope.loadingProgress = true;
        }

        function fileProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            //vm.ngFlow.flow.opts.headers = {};
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            var data = null;
            try {
              data = JSON.parse(message);
            } catch (e) {
              data = message;
            }
            if (angular.isDefined(data.hashSource)) {
                vm.hashSource = data.hashSource;
            }
            if (angular.isDefined(data.file_name)) {
                vm.videoKeyName = data.file_name;
            } else return;
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            vm.progressBarValue = 0;
            vm.inProgress = false;
            $rootScope.loadingProgress = false;
            if ($state.current.name === "app.media_video_reupload") {
                vm.verifExistSource('upload');
            }
        }
        function verifExistSource(action) {
            if (angular.isDefined(parameters['verif_source_video_exist']) && parameters['verif_source_video_exist']=== "1") {
                msApi.request('media_video.verifExistSource@get', {"hashSource": vm.hashSource}, function (res) {
                    if (res.message === "video_source_already_exist") {
                        var videosExist = "";
                        angular.forEach(res.videos, function (value) {
                            if (value.link) {
                                videosExist += "<br>- Identifiant: " + value.id + " ( <a href='" + value.link + "' target='_blank' >Voir</a> ) ";
                            } else {
                                videosExist += "<br>- Identifiant: " + value.id + " ( " + value.extra + " ) ";
                            }
                        });
                        $translate([
                            "MESSAGES.form_choices_yes",
                            "MESSAGES.form_choices_no",
                            "MESSAGES.video_source_already_exist_video",
                            "MESSAGES.video_source_already_exist_video_request",
                            "MESSAGES.video_source_already_exist",
                            "MESSAGES.video_source_already_exist"
                        ])
                            .then(function (translatedValues) {
                                var confirm = $mdDialog.confirm()
                                    .title(translatedValues['MESSAGES.video_source_already_exist'])
                                    .htmlContent(translatedValues['MESSAGES.video_source_already_exist_video'] + videosExist + translatedValues['MESSAGES.video_source_already_exist_video_request'])
                                    .ariaLabel(translatedValues['MESSAGES.video_source_already_exist'])
                                    .ok(translatedValues['MESSAGES.form_choices_yes'])
                                    .cancel(translatedValues['MESSAGES.form_choices_no']);
                                $mdDialog.show(confirm).then(function () {
                                    if (action === 'upload') {
                                        vm.chaneSource();
                                    } else if (action === "on-hold") {
                                        on_hold_trait();
                                    } else {
                                        $state.go('app.choose_thumb', {
                                            "id": vm.idVideoToReupload,
                                            "title": vm.videoKeyName,
                                            'hashSource': vm.hashSource
                                        });
                                    }
                                }, function () {
                                });
                            });
                    } else {
                        if (action === 'upload') {
                            vm.chaneSource();
                        } else if (action === "on-hold") {
                            on_hold_trait();
                        } else {
                            $state.go('app.choose_thumb', {
                                "id": vm.idVideoToReupload,
                                "title": vm.videoKeyName,
                                'hashSource': vm.hashSource
                            });
                        }
                    }
                });
            }else{
                if (action === 'upload') {
                    vm.chaneSource();
                } else if (action === "on-hold") {
                    on_hold_trait();
                } else {
                    $state.go('app.choose_thumb', {"id": vm.idVideoToReupload, "title": vm.videoKeyName, 'hashSource':vm.hashSource});
                }
            }
        }
        function on_hold_trait() {
            $scope.confirm_reupload = $rootScope.confirm_reupload;
            if ($scope.confirm_reupload) {
                if(!vm.is_on_hold) {
                    vm.getGeneratedThumbs();
                    getMetaData();
                }
                vm.uploadStep = 2;
                $scope.confirm_reupload = false;
            }
        }
        function chaneSource() {

            if (angular.isDefined(vm.videoFile) && vm.videoKeyName) {
                if ($state.current.name === "app.media_video_reupload") {
                    msApi.request('media_video.getData@get', {id: $rootScope.idVideoToReupload ? $rootScope.idVideoToReupload:$state.params.id}
                        , function (res) {
                            videoData = res;
                            webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFile.name}), '', function () {
                                vm.videoKeyName = "";
                            }).then(function () {
                              getMetaData();
                              if (videoData.isTranscoded) {
                                    vm.playerIsLoading = 1;
                                    getPlayerLink();

                                }
                                else {
                                    if ($state.current.name === "app.media_video_reupload") {
                                        vm.getGeneratedThumbs();

                                        vm.uploadStep = 2;
                                    }
                                }
                            });
                            fillData();
                        });

                }
                // console.log($state.current);
                // console.log(vm.videoFile);
                // console.log(vm.videoKeyName);

            }
            else {
                if (!angular.isDefined(vm.videoFile) && vm.imageName) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
        }

        /**
         * Stop upload operation
         */
        function cancelUpload() {
            $timeout(function () {
                vm.ngFlow.flow.cancel();
                $rootScope.isReuploading = false;
            });

        }

        vm.closeUpload = closeUpload;

        function closeUpload(ev) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('VIDEOUPLOAD.cancel_reupload'))
                .targetEvent(ev)
                .ok($translate.instant('VIDEOUPLOAD.yes'))
                .cancel($translate.instant('VIDEOUPLOAD.no'));

            $mdDialog.show(confirm).then(function () {
                $rootScope.isReuploading = false;
                vm.cancelUpload();
            }, function () {

            });


        }

        /*** End Upload Parameters and Methods ***/
        //******** Thumbs part Parameters and Methods ***********//
        vm.thumbs = [];
        vm.setAndPreviewThumb = setAndPreviewThumb;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        vm.productImageMediaStyle = {cursor: "pointer"};
        vm.innerThumbStyle = {
            position: 'relative',
            width: '200px',
            height: '200px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            margin: '8px'
        };
        vm.getGeneratedThumbs = getGeneratedThumbs;
        vm.loadingGeneratedThumbs = 1;
        vm.errorOnGettingGeneratedThumbs = 0;
        vm.playerLink = "";
        vm.playerIsLoading = 0;

        function getMetaData() {
            var requestData = {"video": vm.videoKeyName};
            if (vm.videoSubFolder) requestData.subFolder = vm.videoSubFolder;

            msApi.request(
                'media_video.getMetaDataPiper@get',
                requestData,
                function (res) {
                    if (angular.isDefined(res.format) && angular.isDefined(res.streams)) {
                        vm.metadata = angular.toJson({"contentJson" : res});
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }
        function getPlayerLink() {
            msApi.request(
                'media_video.getPreviewLinkByTitle@get',
                {"title": vm.videoKeyName, "y": "bo", "subFolder": vm.videoSubFolder},
                function (res) {
                    if (res.code === 200) {
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                        if ($state.current.name === "app.media_video_reupload") {
                            vm.getGeneratedThumbs();
                            vm.uploadStep = 2;
                        }
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * This function asks the api to communicate with the processing server and return us array of 5 thumbs
         */
        function getGeneratedThumbs() {
            vm.loadingGeneratedThumbs = 1;
            vm.errorOnGettingGeneratedThumbs = 0;
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            var requestData = {"fileName": vm.videoKeyName, "count":5};
            if (vm.videoSubFolder) requestData.subFolder = vm.videoSubFolder;
            msApi.request('media_video.getGeneratedThumbs@get',
                requestData,
                function (res) {

                    if (res.thumbnails.length) {
                        vm.thumbs = [];
                        var thumbs = [];
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            thumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                        }
                        vm.thumbs = thumbs;
                    }
                    $timeout(function () {
                        vm.loadingGeneratedThumbs = 0;
                        vm.errorOnGettingGeneratedThumbs = 0;
                    })

                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.loadingGeneratedThumbs = 0;
                    vm.errorOnGettingGeneratedThumbs = 1;
                }
            );
        }

        function setAndPreviewThumb(thumb) {
            vm.videoThumb = thumb;
        }

        /*** End Thumbs part  Parameters and Methods ***/
        // if ($state.current.name === "app.media_video_reupload") {
        //     msApi.request('media_video.getData@get', {id: $rootScope.idVideoToReupload}
        //         , function (res) {
        //             console.log(res);
        //             videoData = res;
        //             fillData();
        //         });
        // }

        // fillData();

        function fillData() {
            if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
            setThemesIds(videoData.themes);
            $rootScope.itemName = videoData.title || '';
            vm.videoThumb = videoData.logo || null;

        }

        function returnToList() {
            vm.uploadStep = 1;
            if (angular.isUndefined($rootScope.currentState)) {
                $state.go('app.media_video_list', {type: "ongoing"});
            }
            else {
                $state.go($rootScope.currentState);
            }
        }

        function save(videoOnHoldId) {
            $rootScope.loadingProgress = true;
            var request = {
                "id": $stateParams.id,
                title: vm.videoKeyName,
                thumb: vm.videoThumb,
                "subFolder": vm.videoSubFolder,
                "hashSource": vm.hashSource,
                 "client": parameters['app.client.name']
            };
            if(videoOnHoldId) {
                request.id_video_hold=videoOnHoldId;
            }else{
                request.metadata=vm.metadata;
            }

            msApi.request('media_video.updateSource@save',
                request,
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant("VIDEOUPLOAD.video")+ $translate.instant("MESSAGES.update_success"));
                        $rootScope.isReuploading = false;
                        vm.uploadStep = 1;
                        vm.returnToList();
                    }
                    else {
                        vm.uploadStep = 1;
                        webTvGlobal.alertDialog(res.message);
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    vm.uploadStep = 1;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.media.video.reupload-vod', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider) {
        $stateProvider
            .state('app.media_video_reupload', {
                url: "/medias/videos/:id/change-video-source",
                views: {
                    'content@app': {
                        template: '',
                        controller: 'reuploadVodController as vm'
                    }
                },
                bodyClass: 'e-commerce',
                "actionPermission" : "media_video_reupload_no_api_action"
            });


        //API


    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.reupload-vod')
        .controller('reuploadVodController', reuploadVodController);

    /** @ngInject */
    function reuploadVodController($rootScope, $timeout, $state) {
        $rootScope.idVideoToReupload = $state.params.id;
        $rootScope.isReuploading = false;
        $rootScope.loadingProgress = true;
        $timeout(function () {
            $rootScope.loadingProgress = false;
        }, 500);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.choose_thumb', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        $stateProvider
            .state('app.choose_thumb', {
                url: "/medias/videos/choose_thumb/:id/:title/:hashSource",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/reupload/choose-thumb.template.html',
                        controller: 'chooseThumbController as vm'
                    }
                },
                resolve: {
                    videoData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video.getData@get', {id: $stateParams.id});
                    }

                },
                bodyClass: 'e-commerce'
            });


        //API
        msApiProvider.register('media_video.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getGeneratedThumbs', [apiPiper + 'thumbnail']);
        msApiProvider.register('media_video.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")]);
        msApiProvider.register('media_video.updateSource', [Routing.generate('api_media_post_update_video_source', {id: ':id'}).replace(/%3A/g, ":"), {id: '@id'}]);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.media.video.choose_thumb')
        .controller('chooseThumbController', chooseThumbController);

    /** @ngInject */
    function chooseThumbController($rootScope, $timeout, $state, msApi, webTvGlobal, $translate, videoData, $stateParams, $sce, webTv_msNavigation) {
        var vm = this;
        $rootScope.isReuploading = false;
        vm.videoSubFolder = "";
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        init();

        function init() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
            $rootScope.titre3 = "";
          }else{
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_reupload_pagetitle";
          }
            if (angular.isUndefined($rootScope.currentState)) {
                $rootScope.pageRoute = 'app.media_video_list_ongoing';
            }
            else {
                $rootScope.pageRoute = $rootScope.currentState;
            }
            $rootScope.welcome = "welcome_upload_add";
            $rootScope.text = [{
                texte: "button_upload_add_help"
            }];
        }

        vm.thumbs = [];
        vm.setAndPreviewThumb = setAndPreviewThumb;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        vm.productImageMediaStyle = {cursor: "pointer"};
        vm.innerThumbStyle = {
            position: 'relative',
            width: '200px',
            height: '200px',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            margin: '8px'
        };
        vm.getGeneratedThumbs = getGeneratedThumbs;
        vm.loadingGeneratedThumbs = 1;
        vm.errorOnGettingGeneratedThumbs = 0;
        vm.playerLink = "";
        vm.playerIsLoading = 0;
        getPlayerLink();
      vm.metadata = "";
      getMetaData();

        function getPlayerLink() {
            msApi.request(
                'media_video.getPreviewLinkByTitle@get',
                {"title": $stateParams.title, "y": "bo", "subFolder": vm.videoSubFolder},
                function (res) {
                    if (res.code === 200) {
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                        vm.getGeneratedThumbs();
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

      function getMetaData() {
        var requestData = {"video": $stateParams.title};
        if (vm.videoSubFolder) requestData.subFolder = vm.videoSubFolder;
        msApi.request(
          'media_video.getMetaDataPiper@get',
          requestData,
          function (res) {
            if (angular.isDefined(res.format) && angular.isDefined(res.streams)) {
              vm.metadata = angular.toJson({"contentJson" : res});
            }
            else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        );
      }

        /**
         * This function asks the api to communicate with the processing server and return us array of 5 thumbs
         */
        function getGeneratedThumbs() {
            vm.loadingGeneratedThumbs = 1;
            vm.errorOnGettingGeneratedThumbs = 0;
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            msApi.request('media_video.getGeneratedThumbs@get',
                {"fileName": $stateParams.title},
                function (res) {

                    if (res.thumbnails.length) {
                        vm.thumbs = [];
                        var thumbs = [];
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            thumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                        }
                        vm.thumbs = thumbs;
                    }
                    $timeout(function () {
                        vm.loadingGeneratedThumbs = 0;
                        vm.errorOnGettingGeneratedThumbs = 0;
                    })

                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.loadingGeneratedThumbs = 0;
                    vm.errorOnGettingGeneratedThumbs = 1;
                }
            );
        }

        function setAndPreviewThumb(thumb) {
            vm.videoThumb = thumb;
        }

        fillData();

        function fillData() {
            if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
            $rootScope.itemName = videoData.title || '';
            vm.videoThumb = videoData.logo || null;

        }

        vm.save = save;
        vm.returnToList = returnToList;

        function returnToList() {
            if (angular.isUndefined($rootScope.currentState)) {
                $state.go('app.media_video_list', {type: "ongoing"});
            }
            else {
                $state.go($rootScope.currentState);
            }
        }

        function save() {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.updateSource@save',
                {
                    "id": $stateParams.id,
                    title: $stateParams.title,
                    hashSource: $stateParams.hashSource,
                    thumb: vm.videoThumb,
                    "subFolder": vm.videoSubFolder,
                    "metadata": vm.metadata,
                    "client": parameters['app.client.name']
                },
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        webTvGlobal.$toast().showSimple(videoData.title + $translate.instant("MESSAGES.update_success"));
                        $rootScope.isReuploading = false;
                        vm.returnToList();
                    }
                    else {
                        vm.uploadStep = 1;
                        webTvGlobal.alertDialog(res.message);
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    vm.uploadStep = 1;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.media.video.caption_new', ["textAngular", "flow"])
        .config(config)
        .run(fetchRights);

    function config($stateProvider, msApiProvider, $translateProvider) {

        //app.media_video_caption
        $stateProvider
            .state('app.media_video_caption_new', {
                parent: 'app.access_rapid',
                url: "/captions-new",
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/caption-new/template.html',
                        controller: 'mediaVideoCaptionNewActionsController as vm'
                    }
                },
                "bodyClass": "captions",
                "actionPermission" : "media_video_caption_post_generate_caption_action"
            });

        msApiProvider.register('media_video.getCaptionNewPreviewLink', [Routing.generate('api_media_get_video_editor_preview_link', {id: ':id'}).replace(/%3A/, ":")]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*media)(?=.*caption).*$",
                name_module: "media_video_caption",
                name_angular_module: "app.media.video",
                actions: [
                    {"caption": ["post_generate_caption"]}

                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
  'use strict';
  angular
    .module('app.media.video.caption_new')
    .controller('mediaVideoCaptionNewActionsController', mediaVideoCaptionActionsController)
    .directive('ngEnter', function () {
      return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
          if (event.which === 13) {
            scope.$apply(function () {
              scope.$eval(attrs.ngEnter);
            });

            event.preventDefault();
          }
        });
      };
    })

  ;

  function mediaVideoCaptionActionsController($rootScope, video,$stateParams, videoData,webTv_msNavigation) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    /* End Injection*/
    var vm = this;
    vm.event = "media_video.getCaptionNewPreviewLink@get";
      if (videoData.hasCaption === "1" && videoData.refTranscription==='Visited')
          vm.params = {id: $stateParams.id, preview: "caption", cc: "visited"};
      else
          vm.params = {id: $stateParams.id, preview: "caption"};

      initHelp();
    vm.isNavigationNew=false;
    if(video.isNew){
      vm.isNavigationNew=true;
    }
    function initHelp() {

      if(webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_caption_pagetitle";
        $rootScope.titre3 = "";
      } else {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_caption_pagetitle";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.media.video.edit', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_video_edit', {
                parent: 'app.access_rapid',
                url: "/edit",
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/add_edit.template.html',
                        controller: 'mediaVideoEditController as vm'
                    }
                },
                resolve: {
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    },
                    themesByChannels: function (msApi) {
                        return msApi.resolve('parameters_theme.getThemesByChannelAndParent@get');
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    listGroups: function (msApi) {
                        return msApi.resolve('abonnement_group.getGroups@get');
                    },

                },
                "bodyClass": "forms",
                "actionPermission": "media_video_post_edit_action"
            })
            .state('app.media_video_edit_multi_title', {
                parent: 'app.access_rapid',
                url: "/multiTitle/edit",
                views: {
                    'acces@app.access_rapid': {
                        templateUrl: 'app/main/media/video/add_edit_multi_title.template.html',
                        controller: 'mediaVideoEditMultiTitleController as vm'
                    }
                },
                resolve: {
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    },
                    themesByChannels: function (msApi) {
                        return msApi.resolve('parameters_theme.getThemesByChannelAndParent@get');
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    channelChoices: function (msApi) {
                        return msApi.resolve('channel.channelChoices@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "media_video_post_edit_action"
            });


        // Translation

        //API
        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('media_video.getTransodedMetaData', [Routing.generate('api_media_get_transcoded_video_meta_data', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.getMetaData', [Routing.generate('api_media_get_video_meta_data')]);
        msApiProvider.register('media_video.generateThumb', [apiPiper + 'thumbnail']);
        msApiProvider.register('media_video.editVideo', [Routing.generate('api_media_post_edit_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_themes.getSelectChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input')]);
        msApiProvider.register('parameters_themes.getThumbs', [Routing.generate('api_parameters_get_themes_thumbs')]);
        msApiProvider.register('media_video.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);
        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_group_by_themes') + "/:list";
        msApiProvider.register('parameters_theme.getThemesByChannelAndParent', [themesByChannelsAndParent, {list: '@list'}]);
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);




    }
})();

(function () {
    'use strict';
    angular
        .module('app.media.video.edit')
        .controller('mediaVideoEditController', mediaVideoEditController)
        .controller('selectChannelsEditController', selectChannelsEditController)
        .controller('mediaVideoEditMultiTitleController', mediaVideoEditMultiTitleController);

  /** @ngInject */
  function mediaVideoEditController(webTvGlobal, videoData,$cookies,$location, contributorsData, $injector, themesByChannels, $scope, listGroups,themesThumbs, $mdConstant,webTv_msNavigation, video) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */
    var $rootScope = $injector.get('$rootScope'),

      HelpGlobal = $injector.get('HelpGlobal'),
      $sce = $injector.get('$sce'),
      $translate = $injector.get('$translate'),
      $stateParams = $injector.get('$stateParams'),
      $state = $injector.get('$state'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');
    $rootScope.videoData=videoData
    var url = $location.url();
    var urlToken = url.slice(url.lastIndexOf("/")+1,url.length);
    var vm = this;
    vm.isGV=isGV;
    $rootScope.isGV=isGV
      if(angular.isDefined(videoData.metaData)) {
          try {
              vm.videoMetaData = JSON.parse(videoData.metaData);
          } catch (e) {
              vm.videoMetaData = "";
          }
      }else{
          vm.videoMetaData = "";
      }
    $rootScope.generatingThumbnail=false
    vm.generatingMultiThumbs=false
    vm.urlToken = urlToken;
    vm.isNew = false;
    var tabTheme = [];
    var tabIdThemes = [];
    vm.filesChips = [];
    vm.filesChipsTranscription = [];
    var filesChips=[];
    var fileChipsTranscription = [] ;
    var filesUrl=[];
    var filesUrlTranscription = [] ;
    var tabFiles = [];
    var idCanal;
    vm.download = download;
    vm.groups=listGroups ? listGroups.data.groups : [];
      vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];
    $scope.currentNavItem = "page1";
    $scope.goto = function(page) {
      $scope.status = "Goto " + page;
    };
      vm.requredTheme = false;
      var parameters = webTvGlobal.$constant().webTvParameterBag();
      if (angular.isDefined(parameters['use_not_classified_theme']) && parameters['use_not_classified_theme'] ==="1")
          vm.requredTheme = true;

    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
    else vm.testMultiLangue = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
    else vm.testIntranetInternet = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
    else vm.testNotificationClient = '0';
    if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
    else vm.testMultiFormat = '0';
      if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().has_upload_multiple) && webTvGlobal.$constant().webTvParameterBag().has_upload_multiple === "1")
          vm.isMultiUpload = true;
      else
          vm.isMultiUpload = false;
      vm.hasSourceVideo = videoData.fileTitle?true:false;
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];


        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
      (function (contributors, data) {

        contributors['none'] = "0";
        for (var i = 0; i < data.length; i++) {
          contributors[data[i].name] = data[i].id;
        }
        return contributors;
      })({}, contributorsData.contributors)
    );

    vm.allThemes = themesByChannels;
    vm.empMediaVideoForm = {};
      $rootScope.notCapture = true;
    $rootScope.empMediaVideoForm = {};
    $scope.empMediaVideoForm = {};
    vm.sendPushNotifications = 0;
    vm.showVideoDetail = showVideoDetail;
    vm.minDate = undefined;
    vm.changeDate = changeDate;
    vm.imageNameTranscription = "";
    // vm.getTitle = getTitle;
    vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
    // vm.setNone = setNone;
    vm.setEmptyPassword = setEmptyPassword;
    vm.returnToList = returnToList;
    vm.selectThemes = selectThemes;
    vm.showCondtionTerms = showCondtionTerms;
    vm.testVignette = testVignette;
    vm.randomValue="";
    vm.changedThmb=false;
    randomValue()
    function randomValue(){
      var dt = new Date().getTime();
      var result = 'xyxxxyxxxy'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
      vm.randomValue=result
    }

    function download() {
       var last = filesUrlTranscription.pop();
      window.open(last, 'Download');
      // var filter = {};
      // filter.length = filtre.length;
      // filter.start = filtre.start;
      // filter.searchWord = vm.word;
      // filter.idTheme = vm.res;
      // filter.idChannel = vm.canal;
      // filter.uniqueVisits = true;
      // if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
      //   filter.startDate = moment(vm.startDate).format("YYYY-MM-DD");
      // }
      // else {
      //   filter.startDate = "";
      // }
      // if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
      //   filter.endDate = moment(vm.endDate).format("YYYY-MM-DD");
      // }
      // else {
      //   filter.endDate = "";
      // }
      // msApi.request("stats_list_video.exportXls@get", filter,
      //   function (response) {
      //     if (response.code === 200) {
      //       window.location.href = filesUrlTranscription[0];
      //     }
      //     else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
      //   });
    }

    function testVignette() {
      
      if(!angular.isDefined(vm.selectedThumbs)) {
          vm.setSelectedThumbs();
      }
      if (angular.isDefined(vm.selectedThumbs[0])) {
        vm.videoThumb = vm.selectedThumbs[0];
        $rootScope.videoThumb = vm.selectedThumbs[0];
        vm.empMediaVideoForm.logo = vm.selectedThumbs[0];
        $rootScope.empMediaVideoForm.logo = "//" + vm.selectedThumbs[0].replace(/(^\w+:|^)\/\//, '');
      }
    }

      if($stateParams.hold === 'hold') {
        vm.generateThumbs=true;
        getGeneratedThumbs(3, "hold");
      }

    vm.playerIsLoading = 0;
    vm.showPlayer = 0;
    vm.playerLink = "";

    /**
     * Upload File (NG FLOW) && Vignette Tabs Parameters and methods
     */

    vm.imageFrom = "generated";
    vm.videoThumb = null;
    $rootScope.videoThumb = null;

    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}


    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {flow: {}};
    // Methods

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    initHelp();

    function initHelp() {
      if (webTv_msNavigation['media_video']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
        $rootScope.titre3 = "";
      }else{
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
      }
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_video";
      $rootScope.text = [{

        texte: "parameters_video_add_help"
      }, {
        texte: "upload_button_video_add_help"
      }, {
        texte: "send_button_video_edit_help"
      }, {
        texte: "cancel_button_video_add_help"
      }];
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      vm.imageName = file.name;
    }

    function fileAddedTranscription(file) {
      if (!/(doc|docx|html|htm|odt|pdf|xls|xlsx|ods|ppt|pptx|txt)$/.test(file.getExtension().toLowerCase())) {
        vm.imageNameTranscription = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_document_message'));
        return false;
      }
      vm.imageNameTranscription = file.name;
    }

    function uploadFile() {
      // Set headers
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }

    function uploadFileTranscription() {
      // Set headers
      vm.ngFlowFileTranscripton.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */

    function fileSuccess(file, message) {
      $scope.empMediaVideoForm.$pristine = true;
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.empMediaVideoForm.logo = res.location.url;
        $rootScope.empMediaVideoForm.logo = res.location.url;
        vm.videoThumb = res.location.url;
        $rootScope.videoThumb = res.location.url;
      }

    }

    function fileSuccessTranscription(file, message) {
      $scope.empMediaVideoForm.$pristine = true;
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location.url) {
        vm.imageNameTranscription = file.name
        fileChipsTranscription.push(res.location.path);
        vm.filesChipsTranscription.push(file.relativePath);
        filesUrl.push(res.location.url);
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */

    function uploadComplete() {
      if (vm.imageName) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
      }

    }

    function uploadCompleteTranscription() {
      if (vm.imageNameTranscription) {
        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageNameTranscription}));
      }

    }

    function fileErrorTranscription() {
      vm.uploadingInPogress = 0;
      vm.imageNameTranscription = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.uploadComplete = uploadComplete;
    vm.fileAddedTranscription = fileAddedTranscription;
    vm.uploadFileTranscription = uploadFileTranscription;
    vm.fileSuccessTranscription = fileSuccessTranscription;
    vm.fileErrorTranscription = fileErrorTranscription;
    vm.uploadCompleteTranscription = uploadCompleteTranscription;
    vm.currentTime = 0;
    vm.takeVignette = takeVignette;
    window.dataEventPostMessageEditVideo = undefined;
      if(angular.isUndefined(window.dataEventPostMessageEditVideo)) {
        window.dataEventPostMessageEditVideo = true;
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent,  function (e) {
          if (angular.isDefined(e.data) && angular.isDefined(e.data.info) && e.data.info === "currenttime" || e.data.info === "moveToNextChapSld" ) {
            vm.currentTime = e.data.value[0];
          }
        }, false);
    }

    function getThumbnail(currentTime){
      if (videoData.fileTitle && currentTime) {
        $rootScope.changedThmb=true
        $rootScope.generatingThumbnail=true;
        var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
        var requestData = {"fileName": $rootScope.videoData.fileTitle};
         requestData.mode = 'edit';
         requestData.count = 1;
        requestData.timecode = webTvGlobal.toHHMMSS(currentTime.toString());
        var hasparams =  requestData && angular.isDefined(requestData.mode) && angular.isDefined(requestData.count)
          && angular.isDefined(requestData.fileName)  && angular.isDefined(requestData.timecode)
        if(hasparams){
          msApi.request('media_video.generateThumb@get',
            requestData,
            function (res) {
              if (res.thumbnails && res.thumbnails.length) {
                // $scope.empMediaVideoForm= vm.empMediaVideoForm;
                setAndPreviewThumb(url_thumbnails_video_piper + res.thumbnails[0])
                $rootScope.generatingThumbnail=false;
              }
            });
        }
      }
    }
    function takeVignette() {
      $rootScope.changedThmb=false;
      $rootScope.generatingThumbnail=true;
      getThumbnail(vm.currentTime)
    }

    vm.imageName = "";

    vm.uploadingInPogress = 0;
    vm.setSelectedThumbs = setSelectedThumbs;
    // vm.productImageStyle = {
    //     width: "100px",
    //     height: "100px",
    //     "max-height": "100px"
    // };
    // vm.productImageMediaStyle = {cursor: "pointer"};
    // vm.innerThumbStyle = {
    //     position: 'relative',
    //     width: '200px',
    //     height: '200px',
    //     border: '1px solid rgba(0, 0, 0, 0.12)',
    //     margin: '8px'
    // };
    vm.setAndPreviewThumb = setAndPreviewThumb;
    var loadingGeneratedThumbs = 0;
    var errorOnGettingGeneratedThumbs = 0;
    vm.generatedThumbs = [];

    vm.regenerateThumbs = regenerateThumbs;
    var requestNumber = 0;
    var numberofGeneratedThumbs = 3;

    getGeneratedThumbs(numberofGeneratedThumbs);
    vm.clickVignette = clickVignette;

    function clickVignette() {
      vm.imageFrom = null;
    }

    function requestThumbs() {
      loadingGeneratedThumbs = 1;
      errorOnGettingGeneratedThumbs = 0;
      requestNumber = 0;
      // var duration = moment.utc(videoData.duration.replace(/\+\d+$/, "")).format('HH:mm:ss').toSeconds();
      // switch (true) {
      //   case (duration <= 300):
      //     numberofGeneratedThumbs = 3;
      //     break;
      //   case (duration > 300 && duration <= 600):
      //     numberofGeneratedThumbs = 4;
      //     break;
      //   case (duration > 600 && duration <= 900):
      //     numberofGeneratedThumbs = 3;
      //     break;
      //   case (duration > 900 && duration <= 1200):
      //     numberofGeneratedThumbs = 2;
      //     break;
      //   default:
      //     numberofGeneratedThumbs = 1;
      //     break;
      //
      // }
      if (angular.isDefined(vm.empMediaVideoForm.validity)) vm.empMediaVideoForm.validity = null;

      // for (var i = 0; i < numberofGeneratedThumbs; i++) {
      //   getGeneratedThumbs(numberofGeneratedThumbs);
      // }
    }

    function regenerateThumbs() {
      getGeneratedThumbs(1);
    }

    function getGeneratedThumbs(nbr, page) {
      if (angular.isUndefined(nbr)) nbr = 0;
      vm.generatingMultiThumbs=true

      if( videoData.fileTitle) {
          var requestData = {"fileName": videoData.fileTitle};
          if (nbr) requestData.count = nbr;
          requestData.mode = 'edit';
          var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
          if (angular.isDefined(requestData.fileName) ){
            msApi.request('media_video.generateThumb@get',
              requestData,
              function (res) {
                requestNumber++;
                if (angular.isDefined(res.thumbnails)) {

                  if (res.thumbnails.length) {
                    for (var i = 0; i < res.thumbnails.length; i++) {
                      vm.generatedThumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                    }
                    if (vm.generatedThumbs.length > 3) {
                      vm.generatedThumbs = vm.generatedThumbs.slice(1, 4);
                    }
                    if (page === "hold") {
                      vm.empMediaVideoForm.logo = vm.generatedThumbs[0];
                      $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
                      vm.videoThumb = vm.generatedThumbs[0];
                      $rootScope.videoThumb = vm.generatedThumbs[0];
                      vm.empMediaVideoForm.$pristine = false;
                      $rootScope.empMediaVideoForm.$pristine = false;
                    }
                  }
                  vm.generatingMultiThumbs=false
                  loadingGeneratedThumbs = 0;
                  errorOnGettingGeneratedThumbs = 0;
                  vm.empMediaVideoForm.validity = 1;


                }
                else {

                }
              },
              function () {
                loadingGeneratedThumbs = 0;
                errorOnGettingGeneratedThumbs = 1;
                vm.empMediaVideoForm.validity = 1;
                vm.requestNumbe = numberofGeneratedThumbs;

              }
            );
          }
      }
    }
    function setSelectedThumbs() {
      vm.selectedThumbs = [];
      if (angular.isArray(vm.empMediaVideoForm.themes)) {
        for (var i = 0; i < vm.empMediaVideoForm.themes.length; i++) {
          if (angular.isDefined(themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]]) && themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]] !== "") vm.selectedThumbs.push(themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]]);
        }
      }
    }

    function setAndPreviewThumb(thumb) {
      thumb = thumb+"?v="+Date.now();
      vm.empMediaVideoForm.logo = thumb;
      $rootScope.empMediaVideoForm.logo = thumb;
      vm.videoThumb = thumb;
      $rootScope.videoThumb = thumb;
        $rootScope.notCapture = false;
      if($scope && $scope.empMediaVideoForm){
        $scope.empMediaVideoForm.$pristine = false;
      }else{
         $scope.empMediaVideoForm =  $rootScope.empMediaVideoForm;
      }
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */


    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */


    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */


    function fileError() {
      vm.uploadingInPogress = 0;
      vm.imageName = "";
      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */


    /**
     * End Ng Flow
     */
    fillData();


    function getPlayerLink() {
      msApi.request(
        'media_video.getPreviewLink@get',
        {"id": $stateParams.id,"y":"bo"},
        function (res) {
          if (res.code === 200) {
            vm.showPlayer = 1;
            vm.playerIsLoading = 0;
            vm.playerLink = $sce.trustAsResourceUrl(res.link);
          }
          else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      ).then(function () {
      });
    }

    function splitKeyWords(chain) {
      var words = "";
      if (chain !== null) {
        words = chain.split(' ') || [];
        words = words.filter(function (item, pos) {
          return words.indexOf(item) === pos;
        });
      }
      return words;
    }

    function fillData() {
        var themes = [];
        if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
        if (videoData.isTranscoded || !videoData.isVod) {
            fillSelectListThemes();
            angular.forEach(videoData.filesVideo, function (value) {
              // return value of files when edit
              if(value.mimeType === null){
                vm.filesChips.push(value.fileName);
                var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
                filesChips.push(res);
                filesUrl.push(value.title);
              }else if(value.mimeType === "transcription"){
                vm.filesChipsTranscription.push(value.fileName);
                var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
                fileChipsTranscription.push(res);
                filesUrlTranscription.push(value.title);
                vm.imageNameTranscription = value.fileName
              }
            });
            var groupList=getSubscriptionsGroup(videoData.subscriptionGroups);
        vm.empMediaVideoForm = {
          "fileTitle": videoData.fileTitle ? videoData.fileTitle : "",
          "title": videoData.title ? videoData.title : "",
          "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
          "insertDate": new Date(moment(videoData.insertDate)),
          "startDate": new Date(moment(videoData.startDate)),
          "endDate": new Date(moment(videoData.endDate)),
          "duration": new Date(moment(videoData.duration)),
          "useTheme": videoData.useTheme ? 1 : 0,
          "themes": [],
          "secure": videoData.secure ? 1 : 0,
          "downloadable": videoData.downloadable ? 1 : 0,
          "offline": videoData.offline ? 1 : 0,
          "is_accessible": videoData.is_accessible ? 1 : 0,
          "shared": videoData.shared ? 1 : 0,
          "description": videoData.description ? videoData.description : "",
          "transcription": videoData.transcription ? videoData.transcription : "",
          "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
          "contributor": videoData.contributor !== null && angular.isDefined(videoData.contributor.id) ? videoData.contributor.id : "",
          "author": videoData.author ? videoData.author : "",
          "copyright": videoData.copyright ? videoData.copyright : "",
          "keyWords": videoData.keyWords !== null ? splitKeyWords(videoData.keyWords) : [],
          "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
          "passwordInternet": videoData.passwordInternet ? videoData.passwordInternet : "",
          "logo": videoData.logo ? videoData.logo : null,
          "mainPage": videoData.mainPage ? 1 : 0,
          "metaData": videoData.metaData,
          "isVisibleOnIntranet": videoData.isVisibleOnIntranet,
          "isVisibleOnInternet": videoData.isVisibleOnInternet,
          "mdTime": {
            start: new Date(moment(videoData.startDate)),
            end: new Date(moment(videoData.endDate))
          },
          "validity": null,
          "subscriptionGroups": groupList
        };
          $scope.empMediaVideoForm= vm.empMediaVideoForm;
          $rootScope.empMediaVideoForm= vm.empMediaVideoForm
      angular.forEach(tabTheme, function (value) {
          themes.push(value.substring(value.indexOf('-') + 1, value.length));
        });
          vm.empMediaVideoForm.themes=themes;
        if (vm.empMediaVideoForm.keyWords[0] == "")
          vm.empMediaVideoForm.keyWords = [];
        $rootScope.itemName = vm.empMediaVideoForm.title || '';
       // vm.minDate = vm.empMediaVideoForm.mdTime.start;
            vm.videoThumb = vm.empMediaVideoForm.logo || "null";
          $rootScope.videoThumb = vm.empMediaVideoForm.logo || "null";

        vm.theme = themes;

        if (videoData.isTranscoded) {
          vm.playerIsLoading = 1;
          getPlayerLink();
        }
         requestThumbs();

      }
      else {
        // if (!videoMetaData) $rootScope.uploadMetaDataError = true;
        // $state.go('app.media_video_upload');
     }
    }
  function getSubscriptionsGroup(subscriptionGroups){
    var array=[]
   if(subscriptionGroups && subscriptionGroups.length>0 ){
     subscriptionGroups.forEach(function(group, index){
       array.push(group.id)
     })
     return array
   }
  }

    // function setNone() {
    //     if (!vm.empMediaVideoForm.useTheme) vm.empMediaVideoForm.themes = [];
    // }

    function setEmptyPassword() {
      if (!vm.empMediaVideoForm.isSecuredOnInternet) vm.empMediaVideoForm.passwordInternet = null;
    }

    //
    // /**
    //  * Return Imported Video Title if exists
    //  * @return string title
    //  */
    // function getTitle() {
    //     return vm.empMediaVideoForm.title || "";
    // }

    /**
     * set The selected in the form appropriate field
     * @param copyFrom  from where
     * @param pasteIn to whom the date will be setted
     */
    function changeDate(copyFrom, pasteIn) {
      if (angular.isDefined(vm.empMediaVideoForm[pasteIn]) && angular.isDefined(vm.empMediaVideoForm.mdTime[copyFrom])) vm.empMediaVideoForm[pasteIn] = vm.empMediaVideoForm.mdTime[copyFrom];
    }

    /**
     * return to video list page
     * @return redirect to canal list page
     */
    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go('app.media_video_list', {type: "ongoing"});
      }
      else {
          if($rootScope.currentState == "app.media_video_list"){
              $state.go($rootScope.currentState, {type: $rootScope.typeList});
          }else {
              $state.go($rootScope.currentState);
          }
      }


    }


    /**
     *
     * @param  {[type]} formData [description]
     * @return {[type]}          [description]
     */
    function preapreFormDataToSend(formData) {
      var formFormattedData = formData;
      if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
      /**
       * convert null to empty string loop
       */
      for (var attr in formFormattedData) {
        if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
        if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
        if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

      }
      if (formFormattedData.contributor === "0") formFormattedData.contributor = null;
      formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
      return formFormattedData;
    }

    function selectThemes(test, themeModel) {

      vm.empMediaVideoForm.themes = [];
      var themes=themeModel;

      //   var canalTheme = [];
      // angular.forEach(themeModel, function (value) {
      //   themes.push(value.substring(value.indexOf('-') + 1, value.length));
      //     canalTheme.push(value);
      // });
        vm.theme=themeModel;
        vm.empMediaVideoForm.themes=themes;
      vm.setSelectedThumbs();
      if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
        vm.videoThumb = vm.selectedThumbs[0];
        $rootScope.videoThumb = vm.selectedThumbs[0];
        vm.empMediaVideoForm.logo = vm.selectedThumbs[0];
        $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];

      }
      else if (angular.isDefined(vm.generatedThumbs[0]) && vm.imageFrom === 'theme') {
        vm.videoThumb = vm.generatedThumbs[0];
        $rootScope.videoThumb = vm.generatedThumbs[0];
        vm.empMediaVideoForm.logo = vm.generatedThumbs[0];
        $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
      }


    }


    function cleanArray(array) {
      var i, j, len = array.length, out = [], obj = {};
      for (i = 0; i < len; i++) {
        obj[array[i]] = 0;
      }
      for (j in obj) {
        out.push(j);
      }
      return out;
    }


    function exist(id, tab) {
      for (var i = 0, len = tab.length; i < len; i++) {
        if (tab[i] === id) {
          return true;
          break;
        }

      }
      return false;
    }

    function fillSelectListThemes() {
      var i = 1;


      function sousGroupe(value, index) {
        if (index === 1) {
          idCanal = value.id;
        }
        if (angular.isArray(value.themes)) {
          index = index + 1;
          angular.forEach(videoData.themes, function (v2) {
            angular.forEach(value.themes, function (v1) {
              if (v2.id === v1.id && exist(v2.id, tabIdThemes) === false) {
                tabTheme.push(idCanal + '-' + v2.id);
                tabIdThemes.push(v2.id);
              }
              else
                sousGroupe(v1, index);
            });


          });
        }

      };
      angular.forEach(themesByChannels.channels, function (value) {
        sousGroupe(value, 1);
        if (i === Object.keys(themesByChannels.channels).length) {

        }
        i++;
      });

    }

      vm.selectChip = selectChip;
      vm.deleteAddedChip = deleteAddedChip;

      function deleteAddedChip(chip) {
          vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);
          $scope.empMediaVideoForm.$pristine = false;
      }

      function selectChip(chip) {
          window.open(filesUrl[vm.filesChips.indexOf(chip)],'_blank');
      }
      vm.testExtension=testExtension;
      function testExtension(file) {
          var extn = file.split(".").pop();
          if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(extn.toLowerCase())) {
              return "video";
          } else
          if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
              return "audio";
          }
          else
          if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
              return "excel";
          }
          else
          if (/(doc|docx)$/i.test(extn.toLowerCase())) {
              return "word";
          }
          else
          if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
              return "image";
          }
          else
          if (/(pdf)$/i.test(extn.toLowerCase())) {
              return "pdf";
          }
          else
              return "other";


      }
    /**
     * Send add Video Form
     */
    function submitAddMediaVideoForm() {
      angular.forEach(vm.filesChips, function (value, index) {
        tabFiles.push({"title": filesChips[index], "fileName": value});
      });
      // Push transcription File
      tabFiles.push({
        "title": fileChipsTranscription.pop(),
        "fileName": vm.imageNameTranscription,
        "mimeType": vm.imageNameTranscription ? "transcription" : ""
      });
      if(vm.empMediaVideoForm.logo.includes('http')) {
        vm.empMediaVideoForm.logo = "//" + vm.empMediaVideoForm.logo.replace(/(^\w+:|^)\/\//, '');
      }
      var formData = preapreFormDataToSend(angular.copy(vm.empMediaVideoForm));
      var state_type="ongoing";
      if (formData.offline) {
        state_type="offline";
      }
      formData.themes = cleanArray(vm.empMediaVideoForm.themes);
      formData.subscriptionGroups = vm.empMediaVideoForm.subscriptionGroups ? cleanArray(vm.empMediaVideoForm.subscriptionGroups): vm.empMediaVideoForm.subscriptionGroups;
        if(vm.empMediaVideoForm.themes.length<=0) {
            formData.mainPage = false;
        }
      formData.filesVideo = tabFiles;
      // // if (formData.isVisibleOnIntranet === "") formData.isVisibleOnIntranet = false;
      // // if (formData.isVisibleOnInternet === "") formData.isVisibleOnInternet = false;
       formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
       formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet
      if (angular.isDefined(formData.validity)) delete formData.validity;
      var request = {"empMediaVideoForm": formData, id: videoData.id, 'sendPushNotif': vm.sendPushNotifications};
      if($stateParams.hold === 'hold'){
          request.secondStep = true;
      }
      if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
      }
      if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
      msApi.request('media_video.editVideo@save',request,
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('MediaVideoEdit', {title: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : "VID"});
            if (angular.isUndefined($rootScope.currentState)) {
              $state.go('app.media_video_list', {type: state_type});
            }
            else {
                if($rootScope.currentState == "app.media_video_list"){
                    $state.go($rootScope.currentState, {type: $rootScope.typeList});
                }else {
                    $state.go($rootScope.currentState);
                }
            }
          }
          else if (angular.isDefined(res.errors)) {

            vm.empMediaVideoError = [];
            vm.errors = res.errors;
            vm.errors.forEach(function (item) {

              vm.empMediaVideoForm[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empMediaVideoForm[item.for])
              };
            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );}
    }


    /**
     * Open Imported Video Detail dialog
     * @param ev
     */
    function showVideoDetail(event) {
      $mdDialog.show({
        controller: 'mediaVideoMetaModalController',
        controllerAs: 'vm',
        templateUrl: 'app/main/media/video/list/modal.template.html',
        targetEvent: event,
        clickOutsideToClose: true,
        locals: {
          metaData: vm.videoMetaData.contentJson,
          mdDialogTitle: videoData.title
        }
      });
    }

    vm.ngFlowOptionsFile = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]'
      //attributes: 'image/*',
      //testMethod: false,

    };

    vm.ngFlowOptionsFileTranscription = {
      target: Routing.generate('api_media_post_video_attached_file'),
      testChunks: false,
      maxChunkRetries: 1,
      chunkRetryInterval: 5000,
      simultaneousUploads: 1,
      fileParameterName: 'empApiFileForm[thumb]',
      query:{
        type:"transcription",
      },
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
      //attributes: 'image/*',
      //testMethod: false,

    };
    vm.ngFlowFileTranscripton = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };

    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlowFile = {
      // ng-flow will be injected into here through its directive
      flow: {}

    };
    vm.filefAdded = filefAdded;
    vm.filefSuccess = filefSuccess;
    vm.uploadfComplete = uploadfComplete;
    vm.filefProgress = filefProgress;
    vm.uploadFilef = uploadFilef;
    vm.cancelUploadf = cancelUploadf;
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.dropping = false;
    vm.inProgressf = false;


    function cancelUploadf() {
      $timeout(function () {
        vm.ngFlowFile.flow.cancel();

      });
    }

    function filefAdded(file) {

      vm.fileName = file.name;

    }

    function filefProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    function uploadFilef() {
      // Set headers
      vm.ngFlowFile.flow.upload();
      vm.inProgressf = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function filefSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
          filesChips.push(res.location.path);
          vm.filesChips.push(file.relativePath);
          filesUrl.push(res.location.url);

      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadfComplete() {
      vm.progressBarValue = 0;
      vm.inProgressf = false;

    }

    function showCondtionTerms(ev) {

      vm.submitAddMediaVideoForm();

    }

    if( navigator.userAgent.indexOf('MSIE') !== -1 ||
        navigator.appVersion.indexOf('Trident/') > -1){
        setTimeout(function() {
          var player_add = document.querySelector('#player_add');
          var image = document.querySelector('#IE-div-vignettes img');
          var ie_exception = document.querySelector('.ie-exception-3');
          var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
          ie_exception.setAttribute('style','display: flex; position: relative;min-height:'+player_add.offsetHeight +'px !important');
          imgWrapper.style.height = image.offsetHeight +'px';
        },5000);
        window.onresize=function (event) {
            var player_add = document.querySelector('#player_add');
            var image = document.querySelector('#IE-div-vignettes img');
            var ie_exception = document.querySelector('.ie-exception-3');
            var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
            ie_exception.setAttribute('style','display: flex; position: relative;min-height:'+player_add.offsetHeight +'px !important');
            imgWrapper.style.height = image.offsetHeight +'px';
        }
     }

  }
    /** @ngInject */
    function mediaVideoEditMultiTitleController(webTvGlobal, videoData, contributorsData, $injector, $cookies, themesByChannels, $scope, themesThumbs, channelChoices, $mdConstant,webTv_msNavigation) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        /**
         *Injected Vars
         */
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $sce = $injector.get('$sce'),
            $translate = $injector.get('$translate'),
            $stateParams = $injector.get('$stateParams'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');

        var vm = this;
        if(angular.isDefined(videoData.metaData)) {
            try {
                vm.videoMetaData = JSON.parse(videoData.metaData);
            } catch (e) {
                vm.videoMetaData = "";
            }
        }else{
            vm.videoMetaData = "";
        }
        vm.isNew = false;
        var tabTheme = [];
        var tabIdThemes = [];
        vm.filesChips = [];
        vm.filesChipsTranscription = [];
        var filesChips = [];
        var fileChipsTranscription = [];
        var filesUrl = [];
        var tabFiles = [];
        var idCanal;
        vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];

        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
        else vm.testMultiLangue = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
        else vm.testIntranetInternet = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
        else vm.testNotificationClient = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
        else vm.testMultiFormat = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().has_upload_multiple) && webTvGlobal.$constant().webTvParameterBag().has_upload_multiple === "1")
            vm.isMultiUpload = true;
        else
            vm.isMultiUpload = false;
        vm.hasSourceVideo = videoData.fileTitle?true:false;
        vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
            (function (languages, data) {
                for (var i = 0; i < data.length; i++) {
                    languages[data[i]] = data[i];


                }
                return languages;
            })({}, webTvGlobal.$constant().languagesList())
        );
        vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
            (function (contributors, data) {

                contributors['none'] = "0";
                for (var i = 0; i < data.length; i++) {
                    contributors[data[i].name] = data[i].id;
                }
                return contributors;
            })({}, contributorsData.contributors)
        );
        vm.existDefault = true;
        $rootScope.videoSelectedChannels = [];
        vm.channels = getChannels();
        function getChannels() {
            var channels = [];
            var videoChannels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
            var ids = [];
            angular.forEach(videoData.videoChannels, function (value) {
                ids.push(value.channel.id);
                if(value.defaut){
                    vm.existDefault = true;
                }
            });
            angular.forEach(videoChannels, function (value) {
                value.add = ids.indexOf(value.val) === -1;
                if(ids.indexOf(value.val) !== -1){
                    $rootScope.videoSelectedChannels.push(value);
                }
                channels.push(value);
            });
            return channels;
        }
        vm.allThemes = themesByChannels;
        $rootScope.empMediaVideoForm = {};
        vm.sendPushNotifications = 0;
        vm.showVideoDetail = showVideoDetail;
        vm.minDate = undefined;
        vm.changeDate = changeDate;

        // vm.getTitle = getTitle;
        vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
        // vm.setNone = setNone;
        vm.setEmptyPassword = setEmptyPassword;
        vm.returnToList = returnToList;
        vm.selectThemes = selectThemes;
        vm.showCondtionTerms = showCondtionTerms;
        vm.testVignette = testVignette;


        function testVignette() {
            if (angular.isDefined(vm.selectedThumbs[0])) {
                vm.videoThumb = vm.selectedThumbs[0];
                $rootScope.videoThumb = vm.selectedThumbs[0];
                $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            }
        }

        if($stateParams.hold === 'hold') {
            getGeneratedThumbs(3, "hold");
        }

        vm.playerIsLoading = 0;
        vm.showPlayer = 0;
        vm.playerLink = "";

        /**
         * Upload File (NG FLOW) && Vignette Tabs Parameters and methods
         */

        vm.imageFrom = "generated";
        vm.videoThumb = null;
      $rootScope.videoThumb = null;

        vm.ngFlowOptions = {
            target: Routing.generate('api_media_post_thumb'),
            singleFile: true,
            testChunks: false,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}


        };
        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlow = {flow: {}};
        // Methods

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        initHelp();

        function initHelp() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
            $rootScope.titre3 = "";
          }else{
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_edit_pagetitle";
          }
            if (angular.isUndefined($rootScope.currentState)) {
                $rootScope.pageRoute = 'app.media_video_list_ongoing';
            }
            else {
                $rootScope.pageRoute = $rootScope.currentState;
            }
            $rootScope.welcome = "welcome_video";
            $rootScope.text = [{

                texte: "parameters_video_add_help"
            }, {
                texte: "upload_button_video_add_help"
            }, {
                texte: "send_button_video_edit_help"
            }, {
                texte: "cancel_button_video_add_help"
            }];
        }
        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function fileAdded(file) {
            if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
                return false;
            }
            vm.imageName = file.name;
        }



        function uploadFile() {
            // Set headers
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */

        function fileSuccess(file, message) {
           $scope.empMediaVideoForm.$pristine = false;
            vm.uploadingInPogress = 0;
            var res = angular.fromJson(message);
            if (res.location.url) {
                $rootScope.empMediaVideoForm.logo = res.location.url;
                vm.videoThumb = res.location.url;
              $rootScope.videoThumb = res.location.url;
            }

        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */

        function uploadComplete() {
            if (vm.imageName) {
                webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
            }

        }
        // Methods
        vm.fileAdded = fileAdded;
        vm.uploadFile = uploadFile;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.uploadComplete = uploadComplete;
        var currentTime = 0;
        vm.takeVignette = takeVignette;
      $rootScope.generatingThumbnail=false
        vm.generatingMultiThumbs=false
      $rootScope.changedThmb=false;
      window.dataEventPostMessageEditVideo = undefined;

    //   if(angular.isUndefined(window.dataEventPostMessageEditVideo)) {
    //         window.dataEventPostMessageEditVideo = true;
    //         var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
    //         var eventer = window[eventMethod];
    //         var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
    //         eventer(messageEvent, function (e) {
    //             if (angular.isDefined(e.data) && angular.isDefined(e.data.info) && e.data.info === "currenttime") {
    //                 currentTime = e.data.value[0];
    //               if(!$rootScope.changedThmb){
    //                 getThumbnail(currentTime)
    //               }
    //             }
    //         }, false);
    //     }
    //
    // function  getThumbnail(currentTime){
    //     if (videoData.fileTitle) {
    //       $rootScope.changedThmb=true;
    //       $rootScope.generatingThumbnail=true
    //       var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
    //       var requestData = {"fileName": videoData.fileTitle};
    //       requestData.mode = 'edit';
    //       requestData.count = 1;
    //       requestData.timecode = webTvGlobal.toHHMMSS(currentTime.toString());
    //       var hasparams =  requestData && angular.isDefined(requestData.mode) && angular.isDefined(requestData.count)
    //         && angular.isDefined(requestData.fileName)  && angular.isDefined(requestData.timecode)
    //       if(hasparams){
    //         msApi.request('media_video.generateThumb@get',
    //           requestData,
    //           function (res) {
    //             if (res.thumbnails && res.thumbnails.length) {
    //               $scope.empMediaVideoForm.logo = (url_thumbnails_video_piper + res.thumbnails[0]);
    //               vm.videoThumb = (url_thumbnails_video_piper + res.thumbnails[0]);
    //               $rootScope.videoThumb = (url_thumbnails_video_piper + res.thumbnails[0]);
    //               $scope.empMediaVideoForm.$pristine = false;
    //               $rootScope.generatingThumbnail=false
    //             }
    //           });
    //       }
    //     }
    //   }
        function takeVignette() {
          $rootScope.changedThmb=false;
          $rootScope.generatingThumbnail=true
          document.getElementById('player_add').contentWindow.postMessage({
                  "fn": "getCurrentTime",
                  "params": []
              }, "*");
        }
        angular.forEach(videoData.videoChannels, function (value) {
            if(value.defaut === true){
                $rootScope.idChannel = value.channel.id;
            }
        });
        vm.imageName = "";

        vm.uploadingInPogress = 0;
        vm.setSelectedThumbs = setSelectedThumbs;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        // vm.productImageMediaStyle = {cursor: "pointer"};
        // vm.innerThumbStyle = {
        //     position: 'relative',
        //     width: '200px',
        //     height: '200px',
        //     border: '1px solid rgba(0, 0, 0, 0.12)',
        //     margin: '8px'
        // };
        vm.setAndPreviewThumb = setAndPreviewThumb;
        var loadingGeneratedThumbs = 0;
        var errorOnGettingGeneratedThumbs = 0;
        vm.generatedThumbs = [];
        vm.regenerateThumbs = regenerateThumbs;
        var requestNumber = 0;
        var numberofGeneratedThumbs = 3;
        getGeneratedThumbs(numberofGeneratedThumbs);
        vm.clickVignette = clickVignette;

        function clickVignette() {
            vm.imageFrom = null;
        }

        function requestThumbs() {
            loadingGeneratedThumbs = 1;
            errorOnGettingGeneratedThumbs = 0;
            requestNumber = 0;
            // var duration = moment.utc(videoData.duration.replace(/\+\d+$/, "")).format('HH:mm:ss').toSeconds();
            // switch (true) {
            //   case (duration <= 300):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 300 && duration <= 600):
            //     numberofGeneratedThumbs = 4;
            //     break;
            //   case (duration > 600 && duration <= 900):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 900 && duration <= 1200):
            //     numberofGeneratedThumbs = 2;
            //     break;
            //   default:
            //     numberofGeneratedThumbs = 1;
            //     break;
            //
            // }
            if (angular.isDefined($rootScope.empMediaVideoForm.validity)) $rootScope.empMediaVideoForm.validity = null;

            // for (var i = 0; i < numberofGeneratedThumbs; i++) {
            // getGeneratedThumbs(numberofGeneratedThumbs);
            // }
        }

        function regenerateThumbs() {
             getGeneratedThumbs(1);
        }

        function getGeneratedThumbs(nbr, page) {
          if (angular.isUndefined(nbr)) nbr = 0;
          vm.generatingMultiThumbs=true

            var requestData = {"fileName": videoData.fileTitle};
            if (nbr) requestData.count = nbr;
            requestData.mode='edit';
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            if (angular.isDefined(requestData.fileName) ) {
              msApi.request('media_video.generateThumb@get',
                requestData,
                function (res) {
                  requestNumber++;
                  if (angular.isDefined(res.thumbnails)) {
                    if (res.thumbnails.length) {
                      for (var i = 0; i < res.thumbnails.length; i++) {
                        vm.generatedThumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                      }
                    }
                    if (page === "hold") {
                      $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
                      vm.videoThumb = vm.generatedThumbs[0];
                      $rootScope.videoThumb = vm.generatedThumbs[0];
                      vm.empMediaVideoForm.$pristine = false;
                    }
                    loadingGeneratedThumbs = 0;
                    errorOnGettingGeneratedThumbs = 0;
                    $rootScope.empMediaVideoForm.validity = 1;
                    vm.generatingMultiThumbs = false


                  } else {

                  }
                },
                function () {
                  loadingGeneratedThumbs = 0;
                  errorOnGettingGeneratedThumbs = 1;
                  $rootScope.empMediaVideoForm.validity = 1;
                  vm.requestNumbe = numberofGeneratedThumbs;

                }
              );
            }
        }

        function setSelectedThumbs() {
            vm.selectedThumbs = [];
            if (angular.isArray($rootScope.empMediaVideoForm.themes)) {
                for (var i = 0; i < $rootScope.empMediaVideoForm.themes.length; i++) {
                    if (angular.isDefined(themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]]) && themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]] !== "") vm.selectedThumbs.push(themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]]);
                }
            }
        }

        function setAndPreviewThumb(thumb) {
            $scope.empMediaVideoForm.$pristine = false;
            $rootScope.empMediaVideoForm.logo = thumb;
            vm.videoThumb = thumb;
          $rootScope.videoThumb = thumb;
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */


        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */


        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */


        function fileError() {
            vm.uploadingInPogress = 0;
            vm.imageName = "";
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */


        /**
         * End Ng Flow
         */
        fillData();


        function getPlayerLink() {
            msApi.request(
                'media_video.getPreviewLink@get',
                {"id": $stateParams.id, "y": "bo"},
                function (res) {
                    if (res.code === 200) {
                        vm.showPlayer = 1;
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {
            });
        }

        function splitKeyWords(chain) {
            var words = "";
            if (chain !== null) {
                words = chain.split(' ') || [];
                words = words.filter(function (item, pos) {
                    return words.indexOf(item) === pos;
                });
            }
            return words;
        }

        function fillData() {
            var themes = [];
            if (angular.isDefined(videoData.code) && videoData.code !== 200) $state.go('app.error_404');
            if (videoData.isTranscoded || !videoData.isVod) {
                fillSelectListThemes();
                angular.forEach(videoData.filesVideo, function (value) {
                  if(value.mimeType === null){
                    vm.filesChips.push(value.fileName);
                    var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
                    filesChips.push(res);
                    filesUrl.push(value.title);
                  }else if(value.mimeType === "transcription"){
                    vm.filesChipsTranscription.push(value.fileName);
                    var res = value.title.slice(value.title.lastIndexOf("attachedFile/") + 13, value.title.length);
                    fileChipsTranscription.push(res);
                    filesUrlTranscription.push(value.title);
                    vm.imageNameTranscription = value.fileName
                  }
                });
                var channels = [];
                angular.forEach(videoData.videoChannels, function (value) {
                    channels[value.channel.id]={"title":value.title,"description":value.description,"defaut":value.defaut};
                });
                $rootScope.empMediaVideoForm = {
                    "fileTitle": videoData.fileTitle ? videoData.fileTitle : "",
                    "title": videoData.title ? videoData.title : "",
                    "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
                    "insertDate": new Date(moment(videoData.insertDate)),
                    "startDate": new Date(moment(videoData.startDate)),
                    "endDate": new Date(moment(videoData.endDate)),
                    "duration": new Date(moment(videoData.duration)),
                    "useTheme": videoData.useTheme ? 1 : 0,
                    "themes": [],
                    "secure": videoData.secure ? 1 : 0,
                    "downloadable": videoData.downloadable ? 1 : 0,
                    "shared": videoData.shared ? 1 : 0,
                    "offline": videoData.offline ? 1 : 0,
                    "description": videoData.description ? videoData.description : "",
                    "transcription": videoData.transcription ? videoData.transcription : "",
                    "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
                    "contributor": videoData.contributor !== null && angular.isDefined(videoData.contributor.id) ? videoData.contributor.id : "",
                    "author": videoData.author ? videoData.author : "",
                    "copyright": videoData.copyright ? videoData.copyright : "",
                    "keyWords": videoData.keyWords !== null ? splitKeyWords(videoData.keyWords) : [],
                    "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
                    "passwordInternet": videoData.passwordInternet ? videoData.passwordInternet : "",
                    "logo": videoData.logo ? videoData.logo : null,
                    "mainPage": videoData.mainPage ? 1 : 0,
                    "metaData": videoData.metaData,
                    "isVisibleOnIntranet": videoData.isVisibleOnIntranet,
                    "isVisibleOnInternet": videoData.isVisibleOnInternet,
                    "mdTime": {
                        start: new Date(moment(videoData.startDate)),
                        end: new Date(moment(videoData.endDate))
                    },
                    "validity": null,
                    "channels": channels
                };
                angular.forEach(tabTheme, function (value) {
                    value=value.toString();
                    themes.push(value.substring(value.indexOf('-') + 1, value.length));
                });
                $rootScope.empMediaVideoForm.themes = themes;
                if ($rootScope.empMediaVideoForm.keyWords[0] === "")
                    $rootScope.empMediaVideoForm.keyWords = [];
                $rootScope.itemName = $rootScope.empMediaVideoForm.title || '';
                // vm.minDate = $rootScope.empMediaVideoForm.mdTime.start;
                vm.videoThumb = $rootScope.empMediaVideoForm.logo || "null";
              $rootScope.videoThumb = $rootScope.empMediaVideoForm.logo || "null";

                vm.theme = tabTheme;
                if (videoData.isTranscoded) {
                    vm.playerIsLoading = 1;
                    getPlayerLink();
                }
                requestThumbs();
            }
            else {
                // if (!videoMetaData) $rootScope.uploadMetaDataError = true;
                // $state.go('app.media_video_upload');
            }
        }


        // function setNone() {
        //     if (!$rootScope.empMediaVideoForm.useTheme) $rootScope.empMediaVideoForm.themes = [];
        // }

        function setEmptyPassword() {
            if (!$rootScope.empMediaVideoForm.isSecuredOnInternet) $rootScope.empMediaVideoForm.passwordInternet = null;
        }

        //
        // /**
        //  * Return Imported Video Title if exists
        //  * @return string title
        //  */
        // function getTitle() {
        //     return $rootScope.empMediaVideoForm.title || "";
        // }

        /**
         * set The selected in the form appropriate field
         * @param copyFrom  from where
         * @param pasteIn to whom the date will be setted
         */
        function changeDate(copyFrom, pasteIn) {
            if (angular.isDefined($rootScope.empMediaVideoForm[pasteIn]) && angular.isDefined($rootScope.empMediaVideoForm.mdTime[copyFrom])) $rootScope.empMediaVideoForm[pasteIn] = $rootScope.empMediaVideoForm.mdTime[copyFrom];
        }

        /**
         * return to video list page
         * @return redirect to canal list page
         */
        function returnToList() {
            if (angular.isUndefined($rootScope.currentState)) {
                $state.go('app.media_video_list', {type: "ongoing"});
            }
            else {
              if($rootScope.currentState == "app.media_video_list"){
                  $state.go($rootScope.currentState, {type: $rootScope.typeList});
              }else {
                  $state.go($rootScope.currentState);
              }
            }


        }


        /**
         *
         * @param  {[type]} formData [description]
         * @return {[type]}          [description]
         */
        function preapreFormDataToSend(formData) {
            var formFormattedData = formData;
            if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
            /**
             * convert null to empty string loop
             */
            for (var attr in formFormattedData) {
                if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
                if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
                if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

            }
            if (formFormattedData.contributor === "0") formFormattedData.contributor = null;
            formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
            return formFormattedData;
        }

        function selectThemes(test, themeModel) {

            $rootScope.empMediaVideoForm.themes = [];
            var themes = [];

            var canalTheme = [];
            angular.forEach(themeModel, function (value) {
                value=value.toString();
                themes.push(value.substring(value.indexOf('-') + 1, value.length));
                canalTheme.push(value);
            });
            vm.theme=canalTheme;
            $rootScope.empMediaVideoForm.themes = themes;
            vm.setSelectedThumbs();
            if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
                vm.videoThumb = vm.selectedThumbs[0];
              $rootScope.videoThumb = vm.selectedThumbs[0];
                $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            }
            else if (angular.isDefined(vm.generatedThumbs[0]) && vm.imageFrom === 'theme') {
                vm.videoThumb = vm.generatedThumbs[0];
              $rootScope.videoThumb = vm.generatedThumbs[0];
                $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
            }


        }


        function cleanArray(array) {
            var i, j, len = array.length, out = [], obj = {};
            for (i = 0; i < len; i++) {
                obj[array[i]] = 0;
            }
            for (j in obj) {
                out.push(j);
            }
            return out;
        }


        function exist(id, tab) {
            for (var i = 0, len = tab.length; i < len; i++) {
                if (tab[i] === id) {
                    return true;
                    break;
                }

            }
            return false;
        }

        function fillSelectListThemes() {
            var i = 1;


            function sousGroupe(value, index) {
                if (index === 1) {
                    idCanal = value.id;
                }
                if (angular.isArray(value.themes)) {
                    index = index + 1;
                    angular.forEach(videoData.themes, function (v2) {
                        angular.forEach(value.themes, function (v1) {
                            if (v2.id === v1.id && exist(v2.id, tabIdThemes) === false) {
                                tabTheme.push(idCanal + '-' + v2.id);
                                tabIdThemes.push(v2.id);
                            }
                            else
                                sousGroupe(v1, index);
                        });


                    });
                }

            }
            angular.forEach(themesByChannels.channels, function (value) {
                sousGroupe(value, 1);
                if (i === Object.keys(themesByChannels.channels).length) {

                }
                i++;
            });

        }

        vm.selectChip = selectChip;
        vm.deleteAddedChip = deleteAddedChip;

        function deleteAddedChip(chip) {
            vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);

        }

        function selectChip(chip) {
            window.open(filesUrl[vm.filesChips.indexOf(chip)], '_blank');
        }

        vm.testExtension = testExtension;

        function testExtension(file) {
            var extn = file.split(".").pop();
            if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(extn.toLowerCase())) {
                return "video";
            } else if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
                return "audio";
            }
            else if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
                return "excel";
            }
            else if (/(doc|docx)$/i.test(extn.toLowerCase())) {
                return "word";
            }
            else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
                return "image";
            }
            else if (/(pdf)$/i.test(extn.toLowerCase())) {
                return "pdf";
            }
            else
                return "other";


        }

        /**
         * Send add Video Form
         */
        function submitAddMediaVideoForm() {
          angular.forEach(vm.filesChips, function (value, index) {
            tabFiles.push({"title": filesChips[index], "fileName": value});
          });
          // Push transcription File
          tabFiles.push({
            "title": fileChipsTranscription.pop(),
            "fileName": vm.imageNameTranscription,
            "mimeType": vm.imageNameTranscription ? "transcription" : ""
          });
            var formData = preapreFormDataToSend(angular.copy($rootScope.empMediaVideoForm));
            formData.themes = cleanArray($rootScope.empMediaVideoForm.themes);
            if($rootScope.empMediaVideoForm.themes.length<=0) {
                formData.mainPage = false;
            }
            var channels = [];
            var ids = [];
            angular.forEach($rootScope.videoSelectedChannels, function (value) {
                ids.push(value.val);
            });
            angular.forEach(formData.channels, function (value,key) {
                if (angular.isDefined(value) && ids.indexOf(key) !== -1) {
                    channels.push({
                        "id": key,
                        "title": value["title"],
                        "description": value["description"],
                        "defaut": value["defaut"]
                    });
                    if (value["defaut"]) {
                        formData.title = value["title"];
                        formData.description = value["description"];
                    }

                }
            });
            formData.channels = channels;
            formData.filesVideo = tabFiles;
          //   // if (formData.isVisibleOnIntranet === "") formData.isVisibleOnIntranet = false;
          //   // if (formData.isVisibleOnInternet === "") formData.isVisibleOnInternet = false;
           formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
           formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet
            if (angular.isDefined(formData.validity)) delete formData.validity;
            var request = {"empMediaVideoForm": formData, id: videoData.id, 'sendPushNotif': vm.sendPushNotifications};
            if($stateParams.hold === 'hold'){
                request.secondStep = true;
            }
          if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
          }
          if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
            msApi.request('media_video.editVideo@save',request,
                function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$flashMessages().set('MediaVideoEdit', {title: $rootScope.empMediaVideoForm.title ? $rootScope.empMediaVideoForm.title : "VID"});
                        if (angular.isUndefined($rootScope.currentState)) {
                            $state.go('app.media_video_list', {type: "ongoing"});
                        }
                        else {
                            if($rootScope.currentState == "app.media_video_list"){
                                $state.go($rootScope.currentState, {type: $rootScope.typeList});
                            }else {
                                $state.go($rootScope.currentState);
                            }
                        }
                    }
                    else if (angular.isDefined(res.errors)) {

                        vm.empMediaVideoError = [];
                        vm.errors = res.errors;
                        vm.errors.forEach(function (item) {

                            $rootScope.empMediaVideoForm[item.for] = {
                                message: item.messages[0],
                                value_old: angular.copy($rootScope.empMediaVideoForm[item.for])
                            };
                        });


                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );}
        }


        /**
         * Open Imported Video Detail dialog
         * @param event
         */
        function showVideoDetail(event) {
            $mdDialog.show({
                controller: 'mediaVideoMetaModalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/list/modal.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    metaData: vm.videoMetaData.contentJson,
                    mdDialogTitle: videoData.title
                }
            });
        }

        vm.ngFlowOptionsFile = {
            target: Routing.generate('api_media_post_video_attached_file'),
            testChunks: false,
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
            //attributes: 'image/*',
            //testMethod: false,

        };

        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlowFile = {
            // ng-flow will be injected into here through its directive
            flow: {}

        };
        vm.filefAdded = filefAdded;
        vm.filefSuccess = filefSuccess;
        vm.uploadfComplete = uploadfComplete;
        vm.filefProgress = filefProgress;
        vm.uploadFilef = uploadFilef;
        vm.cancelUploadf = cancelUploadf;
        vm.progressBarValue = 0;
        vm.roundWithPrecision = roundWithPrecision;
        vm.dropping = false;
        vm.inProgressf = false;


        function cancelUploadf() {
            $timeout(function () {
                vm.ngFlowFile.flow.cancel();

            });
        }

        function filefAdded(file) {

            vm.fileName = file.name;

        }

        function filefProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        function uploadFilef() {
            // Set headers
            vm.ngFlowFile.flow.upload();
            vm.inProgressf = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function filefSuccess(file, message) {
            var res = angular.fromJson(message);
            if (res.location.path) {
                filesChips.push(res.location.path);
                vm.filesChips.push(file.relativePath);
                filesUrl.push(res.location.url);

            }
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadfComplete() {
            vm.progressBarValue = 0;
            vm.inProgressf = false;

        }

        function showCondtionTerms(ev) {

            vm.submitAddMediaVideoForm();

        }

        if (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) {
            setTimeout(function () {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style', 'display: flex; position: relative;min-height:' + player_add.offsetHeight + 'px !important');
                imgWrapper.style.height = image.offsetHeight + 'px';
            }, 5000);
            window.onresize = function (event) {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style', 'display: flex; position: relative;min-height:' + player_add.offsetHeight + 'px !important');
                imgWrapper.style.height = image.offsetHeight + 'px';
            }
        }
        vm.changeDefaultChannel = changeDefaultChannel;

        function changeDefaultChannel(id) {
            vm.existDefault = false;
            if ($rootScope.empMediaVideoForm.channels[id].defaut === true) {
                vm.existDefault = true;
                angular.forEach($rootScope.empMediaVideoForm.channels, function (value, key) {
                    if (angular.isDefined(value)) {
                        if (key !== id) {
                            $rootScope.empMediaVideoForm.channels[key].defaut = false;
                        }
                    }
                });
            }
        }

        vm.changeTitle = changeTitle;

        function changeTitle(id) {
            $rootScope.empMediaVideoForm.channels[id].changedTitle = true;
        }

        vm.selectChannels = selectChannels;

        function selectChannels() {
            var title = $rootScope.empMediaVideoForm.title;
            $mdDialog.show({
                controller: "selectChannelsEditController",
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/channel.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    channels: vm.channels,
                    videoData: videoData,
                    title: title
                }
            }).then(function () {
            }, function () {
            });
        }

    }

    function selectChannelsEditController($rootScope, $mdDialog, channels, videoData, title) {
        var vm = this;
        var selectedChannels = [];
        angular.forEach($rootScope.videoSelectedChannels, function (value) {
            selectedChannels.push(value);
        });

        vm.allChannels = channels;

        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide();
        }

        vm.validate = validate;

        function validate() {
            var defaultChannel = 0;
            var existDefault = false;
            for (var i = 0; i < videoData.videoChannels.length; i++) {
                if (angular.isDefined(videoData.videoChannels[i].defaut)) {
                    if (videoData.videoChannels[i].defaut) {
                        defaultChannel = videoData.videoChannels[i].channel.id;
                    }
                }
            }
            $rootScope.videoSelectedChannels = selectedChannels;
            for (i = 0; i < $rootScope.videoSelectedChannels.length; i++) {
                if ($rootScope.videoSelectedChannels[i].val == defaultChannel) {
                    existDefault = true;
                }
            }
            if (($rootScope.videoSelectedChannels.length > 0 && videoData.videoChannels.length === 0) || ($rootScope.videoSelectedChannels.length > 0 && !existDefault)) {
                $rootScope.idChannel = $rootScope.videoSelectedChannels[0].val;
                if (!angular.isDefined($rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val])) {
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val] = {};
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val].title = title;
                }
                $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val].defaut = true;
                for (i = 1; i < $rootScope.videoSelectedChannels.length; i++) {
                    if (!angular.isDefined($rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val])) {
                        $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val] = {};
                        $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].title = title;
                    }
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].defaut = false;
                }
            } else if ($rootScope.videoSelectedChannels.length > 0 && existDefault) {
                $rootScope.idChannel = defaultChannel;
                $rootScope.empMediaVideoForm.channels[defaultChannel].defaut = true;
                for (i = 0; i < $rootScope.videoSelectedChannels.length; i++) {
                    if ($rootScope.videoSelectedChannels[i].val !== defaultChannel) {
                        if (!angular.isDefined($rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val])) {
                            $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val] = {};
                            $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].title = title;
                        }
                        $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].defaut = false;
                    }
                }
            }
            $mdDialog.hide();
        }

        vm.removeChannel = removeChannel;

        function removeChannel(channel) {
            var index = selectedChannels.indexOf(channel);
            if (index !== -1) {
                selectedChannels.splice(index, 1);
                channel.add = true;
            }
        }

        vm.addChannel = addChannel;

        function addChannel(channel) {
            channel.add = false;
            selectedChannels.push(channel);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.media.video.list')
        .controller('mediaVideoListController', mediaVideoListController)
        .controller('chronologieController', chronologieController)
        .controller('addLanguagesController', addLanguagesController)
        .filter('startFrom', function () {
            return function (input, start) {
                start = +start;
                return input.slice(start);
            }
        });

    /** @ngInject */
    function mediaVideoListController( VideoGlobal, DTOptionsBuilder, DTColumnBuilder, $rootScope, $injector, $scope, order_video, $mdSidenav, $cookies, dtable_language, dialogConfirmDeleteService,webTv_msNavigation) {
        /**
         *Injected Vars
         */
        var myEl = angular.element(document.querySelector('#content'));
        var IFrame = angular.element(document.querySelector('#iframe_list'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $sce = $injector.get('$sce'),
            webTvGlobal = $injector.get('webTvGlobal'),
            $interval = $injector.get('$interval'),
            $window = $injector.get('$window'),
            $compile = $injector.get('$compile'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            $stateParams = $injector.get('$stateParams'),
            msApi = $injector.get('msApi');

        var vm = this;
        vm.isRM = '';
        var deletedAudioDescription = false
        var currentWidth = window.innerWidth;
        var subscribersList;
        var oldMode = $cookies.get('viewMode') || 'simpleList';
        var lengthTable = $cookies.get('lengthTable') || 20;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag()) && angular.isDefined(webTvGlobal.$constant().webTvParameterBag().nb_video_default)) {
            lengthTable = webTvGlobal.$constant().webTvParameterBag().nb_video_default;
        }
        var previousWidth = window.innerWidth;
        var columnsApi = order_video;
        vm.restoreFilter = restoreFilter;
        vm.toggleSidenav = toggleSidenav;
        vm.videos = [];
        vm.mode = $cookies.get('viewMode') || 'simpleList';
        var typeList = $stateParams.type;
        $rootScope.typeList = typeList;
        var color = $cookies.get('selectedThemeColor');
        if (window.process.env.isNew_Media_Vod) {
            vm.isNewMediaVod = window.process.env.isNew_Media_Vod;
        }
        if (vm.isNewMediaVod) {
            const filename = localStorage.getItem("edit_filename")
            const videoId = localStorage.getItem("edit_id")
            if(filename && videoId){
                vm.urlVideoList = $sce.trustAsResourceUrl("https:" + window.process.env.URL_Media + "/video/"+filename+"/"+videoId+"/edit?token="+$cookies.get("authToken"))
                localStorage.removeItem("edit_filename")
                localStorage.removeItem("edit_id")
            }else{
                vm.urlVideoList = $sce.trustAsResourceUrl("https:" + window.process.env.URL_Media + "/Medias?token="+$cookies.get("authToken"));
            }
        } else {
            msApi.request('media_video.getUrlListVideo@get', { typeList: typeList },
                function (response) {
                    vm.urlVideoList = $sce.trustAsResourceUrl(response.url + '&lang=' + $cookies.get('WEBTV.locale') + '&color=' + color + (isGV ? '&rubric=true' : ''));
                });
        }
        $rootScope.currentState = $state.current.name;
        if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
            vm.isFirefox = true;
        }
        else vm.isFirefox = false;
        // vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);
        $scope.someModel = null;
        $scope.someModelChannel = null;
        $scope.someModelContributor = null;
        var notTranscodedVideos = [];
        var notTranscodedAudio = [];
        var notTranscodedTranscription = [];
        var isTransformed = false;
        vm.selectedVideos = [];
        var selectedVideos = [];
        vm.myStyles = {
            'margin-bottom': '2px',
            'height': '100%',
        }
        if($cookies.get('layoutStyle') ==="horizontalNavigation"){
            vm.myStyles = {
                'margin-bottom': '2px',
                'height': 'calc(100vh - 150px)',
            }
        }


        // on doit modifier les valeurs de themes par API
        vm.dtInstance = {};
        vm.dtInstance2 = {};
        vm.videosDataTable = {};
        var videosServerDataTable = {};
        vm.theme = "";
        vm.canal = "";
        vm.testListButtons = false;
        vm.startDate = null;
        vm.render = rerender;
        vm.type = "1";
        var startFilter = 0;
        console.log("vmmm",vm);


        // var lengthTable = $cookies.get('lengthTable') || 20;

        var testData = true;
        var resSaved;
        var filtre = {};
        var isFolder = false;
        var numberVisits = [];
        ////////////////

        vm.trustedHtml = function (plainText) {
            return $sce.trustAsHtml($translate.instant('MESSAGES.' + plainText + ''));
        };

        function restoreFilter(sidenavId) {
            vm.word = "";
            vm.canal = "";
            vm.theme = "";
            vm.contributor = "";
            vm.period = "";
            vm.startDate = null;
            vm.searchVideos();
            toggleSidenav(sidenavId);
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }


        // vm.checkFlashMessage = checkFlashMessage;
        var flashMessages = {};
        vm.previewVideo = previewVideo;

        vm.addLanguage = addLanguage;
        vm.searchVideos = searchVideos;
        vm.enableAndDisablePushVideo = enableAndDisablePushVideo;
        vm.deleteVideoConfirm = deleteVideoConfirm;
        vm.deleteAudioDescriptionConfirm = deleteAudioDescriptionConfirm;
        vm.deleteSelectedVideoConfirm = deleteSelectedVideoConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.toogleChoice = toogleChoice;
        vm.toogleHomePage = toogleHomePage;
        vm.showSideNav = showSideNav;


        function showSideNav(video) {
            vm.selectedVideo = video;
            vm.visits = 0;
            if (angular.isDefined(numberVisits)) {
                angular.forEach(numberVisits, function (value) {

                    if (value.id === video.id)
                        vm.visits = value.number_visits;


                });
            }
            vm.selectedVideo.startDate = moment(video.startDate).format("DD-MM-YYYY");

            $rootScope.selectedVideo =  vm.selectedVideo;
            $mdSidenav('right').toggle();
        }

        init();

        function init() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre2 = getTitleKey(typeList);
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = getTitleKey(typeList);
          }
            $rootScope.pageRoute = "";
            $rootScope.welcome = "welcome_video";
            $rootScope.text = [{
                texte: "add_button_video_help"
            }, {
                texte: "search_tools_video_help"
            }, {
                texte: "diffusion_types_video_help"
            }, {
                texte: "display_types_video_help"
            }, {
                texte: "tri_column_video_help"
            },
                {
                    texte: "buttons_video_help"
                },
                {
                    texte: "navigation_video_help"
                }];

        }


        /**
         * This variable contains the number of time the checkIfNotTranscodedVideosAreTranscoded operation is done
         * it auto incriment on each try
         * when it reach 10 and some video are not transcoded we presume that there is some kind of error and we stop checking
         */
        /**
         * The variable that contains the cheker for the completion of the non transcoded videos
         * the checker process is done every 10 seconds until all video are transcoded
         */
        var checkIfNotTranscodedVideosAreTranscodedInterval = $interval(function () {
            checkIfNotTranscodedVideosAreTranscoded()

        }, 30000);
        var checkIfNotTranscodedAudioDescAreTranscodedInterval = $interval(function () {
            checkIfNotTranscodedAudiosDescriptionAreTranscoded()

        }, 30000);
        // var checkIfNotTranscodedTranscriptionAreTranscodedInterval = $interval(function () {
        //     checkIfNotTranscodedTranscriptionAreTranscoded()
        //
        // }, 30000);
        $rootScope.rerender = rerender;


        showFlasMessageToast('MediaVideoAdd', $translate.instant('MESSAGES.add_success'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('MediaVideoEdit', $translate.instant('MESSAGES.update_success'));
        var activeIndex = 0;
        vm.setActive = setActive;

        // vm.richMedia = richMedia;

        function setActive(index) {
            activeIndex = index;
        }

        /*
        function openMenu($mdOpenMenu, ev) {
            $mdOpenMenu(ev);
        }*/

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple((flashMessages.title ? (flashMessages.title + " ") : "Vid ") + message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * @param video
         */
        function toggle(video) {
            vm.videosDataTable[video.id].checked = !vm.videosDataTable[video.id].checked;
            var idx = selectedVideos.indexOf(video);
            if (idx > -1) {
                selectedVideos.splice(idx, 1);
            }
            else {
                selectedVideos.push(video);
            }
            vm.selectedVideos = angular.copy(selectedVideos);
        }


        function toggleAll() {

            if (selectedVideos.length === vm.videos.length) {
                vm.selectedVideos = [];
            }
            else if ((selectedVideos.length === 0) || (selectedVideos.length > 0)) {
                vm.selectedVideos = vm.videos.slice(0);
            }
            selectedVideos = angular.copy(vm.selectedVideos);
            var list_video = angular.copy(vm.videosDataTable);
            angular.forEach(list_video, function (value, key) {
                vm.videosDataTable[key].checked = selectedVideos.length > 0;
            });


        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (data && angular.isUndefined(flashMessages.title)) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Get Page Title Translation Key from the current state
         * @return string : translation key for the page title
         */
        function getTitleKey(type) {
            if(angular.isDefined(type)){
                return $state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_'+type+'_pagetitle');
            }
            return $state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_ongoing_pagetitle');

        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchVideosInAPI(filtre), true);
            if (angular.isFunction(vm.dtInstance2.reloadData)) vm.dtInstance2.reloadData(searchVideosInAPI(filtre), true);

        }


        function contributorName(contributor) {
            if (!contributor || angular.isUndefined(contributor.id)) return $translate.instant('MESSAGES.none');
            var fullName = contributor.lastName + " " + contributor.firstName;
            fullName = fullName.replace(/\w\S*/g, function (txt) {
                return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
            });
            return $sce.trustAsResourceUrl("<strong>" + fullName + "</strong>");
        }

        /**
         * If video is yet to be transcoded , put in the array else remove it if is transcoded
         * @param  video
         *
         */
        function toggleInNotTranscodedVideos(video) {
            if (!video.isTranscoded && notTranscodedVideos.indexOf(video.id) === -1) {
                notTranscodedVideos.push(video.id);
            }
            return video.isTranscoded ? true : false;
        }

        function toggleInNotTranscodedAudioDesc(video) {
            if (video.audioDescription === 1 && notTranscodedAudio.indexOf(video.id) === -1) {
                notTranscodedAudio.push(video.id);
            }
        }

        function toggleInNotTranscodedTranscription(video) {
            if (video.refTranscription && video.refTranscription !== 'Finished' && video.refTranscription !== 'Visited' && notTranscodedTranscription.indexOf(video.id) === -1) {
                notTranscodedTranscription.push(video.id);
            }
        }

        /**
         * Check if all video are transcoded, if so stop checking
         */
        function removeFromNotTranscodedArray(video) {
            for (var k = 0; k < vm.videos.length; k++) {
                if (vm.videos[k].id === video.id) {
                    vm.videos[k] = video;
                    notTranscodedVideos.splice(notTranscodedVideos.indexOf(video.id), 1);
                    break;
                }
            }
        }

        function removeFromNotTranscodedArrayAudio(id) {
            for (var k = 0; k < notTranscodedAudio.length; k++) {
                if (notTranscodedAudio[k] === id) {
                    notTranscodedAudio.splice(k, 1);
                }
            }
        }

        function removeFromNotTranscodedArrayTranscription(id) {
            for (var k = 0; k < notTranscodedTranscription.length; k++) {
                if (notTranscodedTranscription[k] === id) {
                    notTranscodedTranscription.splice(k, 1);
                }
            }
        }

        function checkIfNotTranscodedAudiosDescriptionAreTranscoded() {
            if (notTranscodedAudio.length) {
                msApi.request(
                    'media_video.checkTranscodAudioDesc@save',
                    {list: notTranscodedAudio},
                    function (res) {
                        angular.forEach(res.data, function (item, key) {
                            if (item === true) {
                                removeFromNotTranscodedArrayAudio(key);
                                rerender();
                            }
                        });
                    },
                    function () {
                        $interval.cancel(checkIfNotTranscodedAudioDescAreTranscodedInterval);
                    }
                );
            }
            else {
                $interval.cancel(checkIfNotTranscodedAudioDescAreTranscodedInterval);
            }
        }

        function checkIfNotTranscodedVideosAreTranscoded() {
            if (notTranscodedVideos.length) {
                msApi.request(
                    'media_video.checkTranscodOperation@save',
                    {list: notTranscodedVideos},
                    function (res) {
                        if (res.code === 200 && res.videos.length) {
                            for (var i = 0; i < res.videos.length; i++) {
                                removeFromNotTranscodedArray(res.videos[i]);
                            }
                            rerender();
                            if (notTranscodedVideos.length === 0) $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
                        }
                    },
                    function () {
                        $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
                    }
                );
            }
            else {
                $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
            }
        }

        // function checkIfNotTranscodedTranscriptionAreTranscoded() {
        //     if (notTranscodedTranscription.length) {
        //         msApi.request(
        //             'media_video.checkTranscodTranscription@save',
        //             {list: notTranscodedTranscription},
        //             function (res) {
        //                 angular.forEach(res.data, function (item, key) {
        //                     if (item === true) {
        //                         removeFromNotTranscodedArrayTranscription(key);
        //                         rerender();
        //                     }
        //                 });
        //             },
        //             function () {
        //                 $interval.cancel(checkIfNotTranscodedTranscriptionAreTranscodedInterval);
        //             }
        //         );
        //     }
        //     else {
        //         $interval.cancel(checkIfNotTranscodedTranscriptionAreTranscodedInterval);
        //     }
        // }

        $scope.$on('$destroy', function () {
            $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
            $interval.cancel(checkIfNotTranscodedAudioDescAreTranscodedInterval);
            // $interval.cancel(checkIfNotTranscodedTranscriptionAreTranscodedInterval);
        });

        /**
         * Open Imported Video Preview dialog
         * @param   video
         * @param   event
         */
        function previewVideo(video, event) {
            if (!video.isTranscoded) return;
            var isIntranet_Internet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
            VideoGlobal.showPreviewVideo({id: video.id}, event, video.isVisibleOnInternet, video.isVisibleOnIntranet, isIntranet_Internet);
        }

        function addLanguage(video) {
            var parameters, updateUrl;

            msApi.request(
                'media_video_add_language.getUrlUpdate@get',
                function (res) {
                    updateUrl = res;
                    $mdDialog.show({
                        controller: "addLanguagesController",
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/list/add-language.modal.html',
                        clickOutsideToClose: true,
                        locals: {
                            mediaVideoGetUrlUpdate: updateUrl,
                            video: video
                        }
                    }).then(function () {
                        // $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        // $rootScope.$broadcast('VideoList::setInactive');
                    });
                });

        }

        function enableAndDisablePushVideo(video, type) {
            if (type == "enable") {
                enablePushVideo(video)
            }
            else {
                disablePushVideo(video)
            }
        }

        /**
         * enable video push
         * @param   video
         */
        function enablePushVideo(video) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.enablePushVideo@save', {id: video.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                        var videos = angular.copy(vm.videosDataTable);
                        angular.forEach(videos, function (value, index) {
                            if (value.isPush === true) {
                                vm.videosDataTable[index].isPush = false;
                            }
                        });

                        vm.videosDataTable[video.id].isPush = true;

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );

        }

        /**
         * disable video push
         * @param   video
         */
        function disablePushVideo(video) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video.disablePushVideo@save', {id: video.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                        vm.videosDataTable[video.id].isPush = false;
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        function deleteAudioDescriptionConfirm(idVideo, ev) {
          $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted",
                "VIDEOLIST.delete_audio_msg",
                "VIDEOLIST.delete_audio_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_audio_msg'])
                        .htmlContent(translatedValues['VIDEOLIST.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_audio_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteAudioDescription(idVideo);
                    }, function () {
                    });
                });
        }

        function deleteAudioDescription(idVideo) {
            $rootScope.loadingProgress = true;
            var deleteAudioDescrip=false
            msApi.request('media_video.deleteAudioDescription@get', {id: idVideo},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant('VIDEOLIST.dialog_alert_delete_audio_description'));
                        rerender();
                      document.getElementById('iframe_list').contentWindow.postMessage({
                          info: "deleteDescriptionSuccess",
                          value:true
                        },
                        "*");
                      deleteAudioDescrip=true
                      document.getElementById('iframe_list').src += '';
                      document.getElementById('iframe_list').contentWindow.location.reload(true);
                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                      deleteAudioDescrip=false

                    }
                },
                function (response) {
                  deleteAudioDescrip=false
                  if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        /**
         * delete video
         * @param   video
         * @param   ev
         */
        function deleteVideoConfirm(video) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "VIDEOLIST.dialog_will_be_deleted_video",
                "VIDEOLIST.delete_video_msg",
                "VIDEOLIST.delete_video_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['VIDEOLIST.delete_video_msg'])
                        .htmlContent('<b>' + video.title + '</b>' + translatedValues['VIDEOLIST.dialog_will_be_deleted_video'])
                        .ariaLabel(translatedValues['VIDEOLIST.delete_video_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        deleteVideo(video);
                    }, function () {
                    });
                });
        }

        /**
         * Delete video
         */
        function deleteVideo(video) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;
            msApi.request('media_video.delete@delete', {id: video.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple(video.title + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
                        rerender();
                        document.getElementById('iframe_list').contentWindow.postMessage({
                            "info": "videoDeletedSuccessfully"
                        }, "*");
                    } else {
                        $translate([
                            "VIDEOLIST.dialog_alert_delete_error_title",
                            "VIDEOLIST.dialog_alert_delete_error_description",
                            "VIDEOLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {
                                $mdDialog.show(alert).finally(function () {
                                    translatedValues.alert = undefined;
                                });
                            });
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );
        }

        function deleteSelectedVideoConfirm(ev) {
            var title;
            var ariaLabel;
            if (selectedVideos.length !== 0) {
                if (selectedVideos.length === 1) {
                    title = 'VIDEOLIST.delete_selected_video_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_video_aria_label';
                } else {
                    title = 'VIDEOLIST.delete_selected_videos_msg';
                    ariaLabel = 'VIDEOLIST.delete_selected_videos_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, selectedVideos.length, title, ariaLabel)).then(function () {
                    deleteSelectedVideo(ev);
                }, function () {
                });
            }
        }

        /**
         * Delete video
         */


        function deleteSelectedVideo(ev) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;
            msApi.request('media_video.deleteVideos@delete', {
                    list: (function (list) {
                        selectedVideos.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("VIDEOLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("VIDEOLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('VIDEOLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedVideos = [];
                        rerender();
                    } else {
                        webTvGlobal.alertDialog(
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_title'),
                            $translate.instant('VIDEOLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedVideos = [];
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                    vm.selectedVideos = [];
                    selectedVideos = [];
                    vm.modelCheckAll = false;
                }
            );

        }

        function updateVideoSettings(video) {
            $rootScope.loadingProgress = true;
                msApi.request('media_video.saveVideoSettings@save',
                    {id: video.id, allow_comment: video.allow_comment, allow_rating: video.allow_rating, allow_share: video.allow_share },
                    function (res) {
                        if (res && res.code && res.code === 200) {
                            webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                            rerender();
                            document.getElementById('iframe_list').contentWindow.postMessage({
                                "info": "videoUpdatedSuccessfully",
                                value: video
                            }, "*");
                            document.getElementById('iframe_list').src += '';
                            document.getElementById('iframe_list').contentWindow.location.reload(true);
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                ).then(function () {
                    $rootScope.loadingProgress = false;
                });
        }

        function updateVideoSkin(video) {
            $rootScope.loadingProgress = true;
                msApi.request('media_video.saveVideoSkin@save',
                    {id: video.id, skin: video.defaultSkin },
                    function (res) {
                        if (res && res.code && res.code === 200) {
                            webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                            rerender();
                            document.getElementById('iframe_list').contentWindow.postMessage({
                                "info": "videoUpdatedSuccessfully",
                                value: video
                            }, "*");
                            document.getElementById('iframe_list').src += '';
                            document.getElementById('iframe_list').contentWindow.location.reload(true);
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                ).then(function () {
                    $rootScope.loadingProgress = false;
                });
        }

        function putVideoOfflineOrOnline(video, type) {
            var parameters = webTvGlobal.$constant().webTvParameterBag();
            console.log("parameters['app.client.name']", parameters['app.client.name'])
            $translate([
                "MESSAGES.ok",
                "MESSAGES.dialog_cancel",
                "MESSAGES.put_video_offline",
                "MESSAGES.set_offline",
                "MESSAGES.put_video_online",
                "MESSAGES.set_online"])
                .then(function (translatedValues) {
                    var title = type === "online" ? translatedValues['MESSAGES.put_video_online'] : translatedValues['MESSAGES.put_video_offline']
                    var content = type === "offline" ? translatedValues['MESSAGES.set_online'] : translatedValues['MESSAGES.set_offline']
                    var confirm = $mdDialog.confirm()
                        .title(title)
                        .htmlContent(content)
                        .ok(translatedValues['MESSAGES.ok'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    $mdDialog.show(confirm).then(function () {
                        toogleChoice(type, video)
                    }, function () {});
                });
        }

        function searchVideos(test, model) {
            var idCanal = vm.canal;
            var idContributor = vm.contributor;
            testData = true;
            if (test === 'canal') {
                vm.theme = '';
                idCanal = model;
            }
            if (test === 'contributor') {
                idContributor = model;
            }


            if (angular.isDefined(model) && test !== 'canal') {
                vm.res = model.substring(model.indexOf('-') + 1, model.length);
            }
            if (!angular.isDefined(model) && test === 'canal') {
                vm.res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
            }
            filtre.searchWord = vm.word;
            filtre.idContributor = idContributor;
            filtre.period = vm.period;
            if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
                filtre.startDate = moment(vm.startDate).format("YYYY-MM-DD");
            }
            else {
                filtre.startDate = "";
            }
            filtre.idChannel = idCanal;
            filtre.idTheme = vm.res;
            if (test === '1' || test === '0' || test === '') {
                filtre.is_rm = test;
                vm.isRM = test;
            }
            else {
                vm.is_rm = '';
                filtre.isRM = '';

            }

            if (vm.mode === "gallery") {
                $rootScope.loadingProgress = true;
                getVideosForGallery(filtre);
            }
            else {
                searchVideosInAPI(filtre);
            }

        }


        function toogleChoice(choice, video) {
            if (angular.isDefined(video["offline"])) {
                $rootScope.loadingProgress = true;
                var initialValue = video["offline"];
                video["offline"] = video["offline"] ? 0 : 1;

                msApi.request('media_video.toogleByType@save',
                    {id: video.id, value: video["offline"], type: "offline"},
                    function (res) {
                        if (res.done) {
                            webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                            if (choice === "offline") {
                                rerender();
                            }
                            document.getElementById('iframe_list').src += '';
                            document.getElementById('iframe_list').contentWindow.location.reload(true);
                        }
                        else {
                            video[choice] = initialValue;
                        }

                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                        video[choice] = initialValue;
                    }
                ).then(function () {
                    $rootScope.loadingProgress = false;
                });

            }
        }

        function toogleHomePage(choice, video) {
            if (angular.isDefined(video[choice])) {
                $rootScope.loadingProgress = true;
                var initialValue = video[choice] ? 1 : 0;
                video[choice] = video[choice] ? 0 : 1;
                var name_api = video.mainPage ? 'media_video.toogleHomePage@get' : 'media_video.deleteHomePage@delete';
                msApi.request(name_api,
                    {id: video.id},
                    function (res) {
                        if (res.code === 200) {
                            webTvGlobal.$toast().showSimple(video.title + $translate.instant("MESSAGES.update_success"));
                        }
                        else {
                            video[choice] = initialValue;
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                        video[choice] = initialValue;
                    }
                ).then(function () {
                    $rootScope.loadingProgress = false;
                });
            }
        }

        function viewMedia(id, lang) {
            VideoGlobal.showPreviewVideo({id: id, langVod: lang});
        }

        function deleteLanguageConfirm(id, lang) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "EVENTLIST.delete_language_msg",
                "EVENTLIST.delete_event_aria_label",
                "LANGUAGES.Names." + lang])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['EVENTLIST.delete_language_msg'])
                        .htmlContent(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['EVENTLIST.delete_event_aria_label'])
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteLanguage(id, lang);


                    }, function () {

                    });
                });
        }

        function deleteLanguage(videoId, lang) {
            $rootScope.loadingProgress = true;
            msApi.request('multilangue.deleteLang@save', {video_id: videoId, lang: lang},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        $translate([
                            "EVENTLIST.dialog_alert_delete_title",
                            "EVENTLIST.dialog_alert_delete_description",
                            "EVENTLIST.dialog_alert_delete_close",
                            "LANGUAGES.Names." + lang
                        ])
                            .then(function (translatedValues) {
                                webTvGlobal.$toast().showSimple(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                                document.getElementById('iframe_list').contentWindow.postMessage({
                                    "info": "deleteLang"
                                }, "*");
                            });

                    }
                    else {
                        $rootScope.loadingProgress = false;
                        $translate([
                            "EVENTLIST.dialog_alert_delete_error_title",
                            "EVENTLIST.dialog_alert_delete_error_description",
                            "EVENTLIST.dialog_alert_delete_close"
                        ])
                            .then(function (translatedValues) {

                                $mdDialog
                                    .show(alert)
                                    .finally(function () {
                                        alert = undefined;
                                    });
                            });

                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            );


        }

        function editLanguage(video, lang) {
            $mdDialog.show({
                controller: 'editLanguageModalController',
                controllerAs: 'vm',
                templateUrl: 'app/core/directives/ms-multilangue-menu/edit-language.modal.html',
                clickOutsideToClose: true,
                locals: {
                    lang: lang,
                    video: video
                }
            })
        }

        function showEmbed(id, lang) {
            vm.spinner = false;
            msApi.request(
                'multilangue.getUrlExport@get',
                {
                    id: id,
                    lang: lang
                },
                function (res) {
                    vm.spinner = true;
                    $mdDialog.show({
                        controller: 'embedModalController',
                        controllerAs: 'vm',
                        templateUrl: 'app/core/directives/ms-multilangue-menu/embed.modal.html',
                        clickOutsideToClose: true,
                        locals: {
                            video: res.video
                        }
                    }).then(function () {
                        $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        $rootScope.$broadcast('VideoList::setInactive');
                    });
                }, function (response) {
                    vm.spinner = true;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {
            });
        }

        function editVideoFile(video, lang) {
            $mdDialog.show({
                controller: 'multilangueVideoReuploadController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/reupload-multilangue/reupload.list.html',
                clickOutsideToClose: true,
                locals: {
                    lang: lang,
                    video: video
                }
            })
        }

        vm.senByMail = senByMail;

        function senByMail(video) {
            $mdDialog.show({
                controller: 'sendMailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/email/email.template.html',
                clickOutsideToClose: true,
                locals: {
                    video: video,
                    id: video.id
                    // subscriptionGroups:subscriptionGroups
                }
            }).then(function () {
            }, function () {
            });
        }

        eventPostMessage();
        function transcription(trans, id) {
          if (trans)
            msApi.request(
              'media_video.transcription@get',
              {
                id_video: id,
                is_correction: "1"
              },
              function (res) {


              }, function () {

              });
          else msApi.request(
            'media_video.transcription@get',
            {
              id_video: id
            },
            function (res) {
              if (res.code === 200) {
              }

            }, function () {

            });


        }


      function eventPostMessage() {
            if (angular.isUndefined(window.dataEventPostMessage)) {
                window.dataEventPostMessage = true;
                console.log("eventPostMessage");
                var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
                var eventer = window[eventMethod];
                var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
                //eventer(messageEvent, function (e) <=> window.addEventListener("message", receiveMessage, false): to listen to the dispached event
                //receiveMessage = function(event)
                eventer(messageEvent, function (e) {
                    if (typeof e.data !== "undefined") {
                        var video = e.data.value;
                        if (e.data.info === "showModalPlayer") {
                            console.log(e.data.value);
                            console.log("showModalPlayer");
                            previewVideo(e.data.value, 'e')
                        }
                        if (e.data.info === "transcription") {
                          console.log(e.data.value);
                          console.log(e.data.value);
                          console.log("transcription");
                          transcription(e.data.type,e.data.value.id)
                        }
                        else if (e.data.info === "showModalExport") {
                            console.log(e.data.value);
                            exportVideo(e.data.value);
                            console.log("showModalExport");
                        }
                        else if (e.data.info === "showModalSendMail") {
                            console.log(e.data.value);
                            showModalEmail(e.data.value);
                            console.log("showModalEmail");
                        }
                        else if (e.data.info === "showListAction") {
                            console.log(e.data.value);
                            console.log("showListAction");
                            showSideNav(e.data.value)
                        }
                        else if (e.data.info === "editVideo") {
                            console.log(e.data.value);
                            editVideo(e.data.value);
                            console.log("editVideo");
                        }
                        else if (e.data.info === "montageVideo") {
                            console.log(e.data.value);
                            console.log("montageVideo");
                            $state.go('app.media_video_montage_new', {id: video.id});
                        }
                        else if (e.data.info === "sousTitragesVideo") {
                            console.log(e.data.value);
                            $state.go('app.media_video_caption_new', {id: video.id});
                        }
                        else if (e.data.info === "richMediaVideo") {
                            console.log(e.data.value);
                            console.log("richMediaVideo");
                            $state.go('app.media_video_rich_media_new', {id: video.id});
                        } else if (e.data.info === "changeSource") {
                            console.log(e.data.value);
                            console.log("changeSource");
                            $state.go('app.media_video_reupload', {id: video.id});

                        }
                        else if (e.data.info === "listComments") {
                            console.log(e.data.value);
                            console.log("listComments");
                            $state.go('app.comments_list.media', {id: video.id});

                        }
                        else if (e.data.info === "statsPerVideo") {
                            console.log(e.data.value);
                            statsPerVideo(e.data.value);
                            console.log("statsPerVideo");
                        } else if (e.data.info === "addVideo") {
                            $state.go('app.media_video_upload');
                        }
                        else if (e.data.info === "addSubscribers") {
                            console.log(e.data.value);
                            console.log("addSubscribers");
                            addSubscribers(e.data.value)
                        }
                        else if (e.data.info === "downloadVideo") {
                            console.log(e.data.value);
                            downloadVideo(e.data.value.id);
                            console.log("downloadVideo");
                        }
                        else if (e.data.info === "downloadVideoCC") {
                            console.log(e.data.value);
                            downloadVideoCC(e.data.value.id);
                            console.log("downloadVideoCC");
                        }
                        else if (e.data.info === "showVideoDetail") {
                            console.log(e.data.value);
                            console.log("showVideoDetail");
                            showVideoDetail(e.data.value)
                        } else if (e.data.info === "enableAndDisablePushVideo") {
                            console.log(e.data.value);
                            enableAndDisablePushVideo(e.data.value, e.data.type);
                            console.log("enableAndDisablePushVideo");
                        }
                        else if (e.data.info === "chronologieVideo") {
                            console.log(e.data.value);
                            console.log("chronologieVideo");
                            chronologieVideo(e.data.value)
                        } else if (e.data.info === "deleteVideoConfirm") {
                            console.log(e.data.value);
                            deleteVideoConfirm(e.data.value);
                            console.log("deleteVideoConfirm");
                        }
                        else if (e.data.info === "toogleChoice") {
                            console.log(e.data.value);
                            console.log("toogleChoice");
                            toogleChoice(e.data.type, e.data.value)
                        }
                        else if (e.data.info === "responsesVideo") {
                            console.log(e.data.value);
                            console.log("responsesVideo");
                            $state.go('app.media_video_questions_quiz.questions', {id: video.id});
                        }
                        else if (e.data.info === "addDescription") {
                            $state.go('app.media_video_uploadAudio', {videoId: video.id , videoToken: video.token});
                        }
                        else if (e.data.info === "editDescription") {
                            $state.go('app.media_video_uploadAudio', {videoId: video.id , videoToken: video.token});
                        }
                        else if (e.data.info === "deleteDescription") {
                            deleteAudioDescriptionConfirm(video.id);
                        }
                        else if (e.data.info === "showMediaLang") {

                            viewMedia(video.id, e.data.lang);
                        }
                        else if (e.data.info === "deleteMediaLang") {

                            deleteLanguageConfirm(video.id, e.data.lang);
                        }
                        else if (e.data.info === "editMediaLang") {

                            editLanguage(video, e.data.lang);
                        }
                        else if (e.data.info === "embedMediaLang") {

                            showEmbed(video.id, e.data.lang);
                        }
                        else if (e.data.info === "addMediaLang") {

                            addLanguage(video);
                        }
                        else if (e.data.info === "editSourceMediaLang") {

                            editVideoFile(video, e.data.lang);
                        }
                        else if (e.data.info === "putVideoOffline") {
                            putVideoOfflineOrOnline(video, "offline")
                        }
                        else if (e.data.info === "putVideoOnline") {
                            putVideoOfflineOrOnline(video, "online")
                        }
                        else if (e.data.info === "allow_share" || e.data.info === "allow_rating" || e.data.info === "allow_comment" ) {
                            if(e.data.info === "allow_share") video.allow_share = !video.allow_share
                            else if(e.data.info === "allow_rating") video.allow_rating = !video.allow_rating
                            else if(e.data.info === "allow_comment") video.allow_comment = !video.allow_comment
                            updateVideoSettings(video)
                        }else if (e.data.info.includes('skin_player')) {
                            if(e.data.info === "simple_skin_player") video.defaultSkin = "simple"
                            else if(e.data.info === "navigation_skin_player") video.defaultSkin = "navigation"
                            else if(e.data.info === "interactivity_with_timeline_skin_player") video.defaultSkin = "interactivity_with_timeline"
                            else if(e.data.info === "interactivity_without_timeline_skin_player") video.defaultSkin = "interactivity_without_timeline"
                            updateVideoSkin(video)
                        }
                        else if (e.data.info === "diffusion" || e.data.info === "edit_video") {
                           window.history.replaceState({}, '','medias/videos?type='+e.data.value);
                            typeList = e.data.value;
                            $stateParams.type=typeList
                            $state.params.type=typeList
                            $rootScope.typeList = typeList;
                        }
                    }
                }, false);
            }

        }

        function showModalEmail(video) {
            vm.spinner = false;
            // $mdDialog.hide();

            $mdDialog.show({
                controller: 'sendMailController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/email/email.template.html',
                clickOutsideToClose: true,
                locals: {
                    video: video,
                    id: video.id,
                    lang: ""
                }
            });


        }

        function editVideo(video) {
            $rootScope.currentState = $state.current.name;
            if (video.externalLinkVideo) {
                $state.go('app.media_video_edit_external', {id: video.id});
            }
            else {
                var appParameters = webTvGlobal.$constant().webTvParameterBag();
                var videoMultiTitle = angular.isDefined(appParameters["video_multi_title"])?appParameters["video_multi_title"] == "1" ? true:false:false;
                if (videoMultiTitle) {
                    $state.go('app.media_video_edit_multi_title', {id: video.id});
                }else{
                    $state.go('app.media_video_edit', {id: video.id});
                }
            }
        }

        /**
         * stats per video
         * @param   video
         */
        function statsPerVideo(video) {
            $rootScope.name_state_parent = angular.isDefined($state.current.name) ? $state.current.name + (angular.isDefined($stateParams.type) ? "_" + $stateParams.type : "") : 'app.media_video_list_ongoing';
            $state.go('app.stats_vod_by_id.audience', {id: video.id});
        }

        function addSubscribers(video) {
            $rootScope.loadingProgress = true;
            msApi.request('media_video_list_subscribers.getVideoSubscribers@get', {id: video.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    $mdDialog.show({
                        locals: {
                            video: video,
                            subscribersList: response.data.users,
                            videoSubscribers: response.data.subscriptionUsers
                        },
                        templateUrl: 'app/main/media/video/abonnement/add.remove.subscribers.html',
                        clickOutsideToClose: true,
                        controller: "addRemoveSubscribersController",
                        controllerAs: "vm",
                        fullscreen: true
                    }).then(function (subList) {
                        $rootScope.loadingProgress = true;
                        msApi.request('media_video_list_subscribers.addVideoSubscribers@get', {
                                id: video.id, list: (function (list) {
                                    subList.forEach(function (item) {
                                        list.push(item);
                                    });
                                    return list;
                                })([])
                            },
                            function (response) {
                                $rootScope.loadingProgress = false;
                                webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.alert_edit_confirm"));
                            },
                            function (response) {
                                $rootScope.loadingProgress = false;
                                if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                    $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                        webTvGlobal.alertDialog(message);
                                    }, function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    });
                                }
                                else {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                }
                            });


                    })
                },
                function (response) {

                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                })

        }

        function downloadVideo(video) {

            var ua = navigator.userAgent;

            msApi.request('media_video.download@get', {id: video}, function (response) {


                if (response.data.exist) {

                    if (ua.indexOf('Firefox') !== -1) {
                        var popup = $window.open('', '_blank');
                        popup.location.href = response.data.file;
                    }

                    else
                        window.location.href = response.data.file;

                }
                else {
                    $translate([
                        "VIDEOLIST.dialog_download_error_title",
                        "VIDEOLIST.dialog_download_error_text"
                    ])
                        .then(function (translatedValues) {
                            $mdDialog.show(
                                $mdDialog.alert()
                                    .clickOutsideToClose(true)
                                    .title(translatedValues['VIDEOLIST.dialog_download_error_title'])
                                    .textContent(translatedValues['VIDEOLIST.dialog_download_error_text'])
                                    .ok('OK')
                            );
                        });
                }

            }, function (error) {
                if (error.data === null) {
                    webTvGlobal.alertDialog($translate.instant('VIDEOLIST.video_not_found'));
                }
            });


        }
        function downloadVideoCC(video) {

            /** todo integrate api download video cc**/
        }

        /**
         * Open Imported Video Detail dialog
         * @param video
         * @param $event
         */
        function showVideoDetail(video) {
            msApi.request(
                'media_video.getTransodedMetaData@get',
                {id: video.id},
                function (res) {
                    if(angular.isDefined(res.metaData.data) && angular.isDefined(res.metaData.data.contentJson)) {
                        var meta = {
                            format: angular.isDefined(res.metaData.data.contentJson.format) ? res.metaData.data.contentJson.format : "",
                            streams: angular.isDefined(res.metaData.data.contentJson.streams) ? res.metaData.data.contentJson.streams : "",
                            other: video
                        };
                        $mdDialog.show({
                            controller: 'mediaVideoMetaModalController',
                            controllerAs: 'vm',
                            templateUrl: 'app/main/media/video/list/modal.template.html',
                            clickOutsideToClose: true,
                            locals: {
                                metaData: meta,
                                mdDialogTitle: video.title
                            }
                        }).then(function () {
                            // $rootScope.$broadcast('VideoList::setInactive');
                        }, function () {
                            // $rootScope.$broadcast('VideoList::setInactive');
                        });
                    }else{
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            ).then(function () {
            });
        }

        function chronologieVideo(video, event) {
            $mdDialog.show({
                controller: "chronologieController",
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/list/chronologie.modal.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    video: video
                }
            }).then(function () {
                // $rootScope.$broadcast('VideoList::setInactive');
            }, function () {
                // $rootScope.$broadcast('VideoList::setInactive');
            });
        }

        function exportVideo(video) {
            var lang = "";
            if (angular.isDefined(video.medias[0])) {
                lang = video.medias[0].lang;
            }
            msApi.request(
                'media_video.getUrlExport@get',
                {id: video.id, lang: lang},
              function (res) {

                }, function (response) {
                    console.log("response",response)
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            )
            .then(function (res) {
                console.log("videeeo*****",res);
                $mdDialog.show({
                  controller: 'mediaVideoUrlModalController',
                  controllerAs: 'vm',
                  templateUrl: 'app/main/media/video/list/url.modale.template.html',
                  clickOutsideToClose: true,
                  locals: {
                    video: res.video,
                    id: video.id
                  }
                }).then(function () {
                  // $rootScope.$broadcast('VideoList::setInactive');
                }, function () {
                  // $rootScope.$broadcast('VideoList::setInactive');
                });
              });
        }


    }

    function chronologieController(webTvGlobal, msApi, video, $rootScope, $mdDialog) {
        var vm = this;
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide();
        }

        vm.jsonList = [];
        var jsonList = [];
        vm.spinner = false;
        msApi.request('media_video.getChronologie@get', {id: video.id}, function (res) {
            if (res.code === 200) {
                angular.forEach(res.data, function (value) {
                    if (angular.isDefined(value.date)) {
                        value.date = moment(new Date(value.date)).format($rootScope.defaultTimeFormat);
                    }
                    jsonList.push(value);
                    vm.spinner = true;
                });
                vm.jsonList = jsonList;
            }
            else {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
        });
    }

    function addLanguagesController(webTvGlobal, userManager, mediaVideoGetUrlUpdate, video, $injector) {
        var $rootScope = $injector.get('$rootScope'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog'),
            $filter = $injector.get('$filter'),
            msApi = $injector.get('msApi');
        var appParameters = webTvGlobal.$constant().webTvParameterBag();
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.language = '';
        vm.selectLang = selectLang;
        vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
            (function (languages, data) {
                for (var i = 0; i < data.length; i++) {
                    var has_lang = $filter('filter')(video.medias, {lang: data[i]}, true);
                    if (has_lang.length === 0) {
                        languages[data[i]] = data[i];
                    }

                }
                return languages;
            })({}, webTvGlobal.$constant().languagesList())
        );

        function selectLang() {
            vm.testLang = false;
            angular.forEach(video.medias, function (value) {
                if (value.lang === vm.language) {
                    vm.testLang = true;
                }
            });
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        vm.videoFile = undefined;
        vm.ngFlowOptions = {
            chunkSize: (function () {
                return Math.pow(10, 8);
            })(),
            testChunks: false,
            target: appParameters['upload.script_url'],
            singleFile: true,
            extendChunks: false,
            fileParameterName: 'Filedata',
            query: {
                webtv_name: appParameters['app.webtv.name'],
                path_file: appParameters['upload.from_server_root_path'],
                user_id: userManager.getId(),
                timestamp: moment().unix(),
                token: md5("unique_salt" + moment().unix()),
                callback_step_url: mediaVideoGetUrlUpdate.link_update_step
            }
        };
        vm.ngFlow = {
            flow: {}
        };
        vm.dropping = false;
        vm.fileAdded = fileAdded;
        vm.uploadFile = uploadFile;
        vm.fileSuccess = fileSuccess;
        vm.uploadComplete = uploadComplete;
        vm.fileProgress = fileProgress;
        vm.cancelUpload = cancelUpload;
        vm.progressBarValue = 0;
        vm.roundWithPrecision = roundWithPrecision;
        vm.inProgress = false;
        vm.videoKeyName = "";
        vm.sendLanguage = sendLanguage;

        vm.uploadMetaDataError = false;
        checkUploadMetaDataError();

        /**
         * Check if after upload , has an error on generating meta data has been thrown
         */
        function checkUploadMetaDataError() {
            if (angular.isDefined($rootScope.uploadMetaDataError) && $rootScope.uploadMetaDataError) {
                $rootScope.uploadMetaDataError = undefined;
                vm.uploadMetaDataError = true;
            }
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */

        function fileAdded(file) {
            if (!/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_video_message'));
                return false;
            }
            vm.videoFile = file;
            $rootScope.loadingProgress = true;
        }

        function fileProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        function sendLanguage() {
            if (vm.testLang === false) {
                vm.closeDialog();
                msApi.request('media_video_add_language.addLang@save', {
                    video_id: video.id,
                    video_lang: vm.language,
                    video_file: vm.videoKeyName
                }, function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.added_language"));
                        document.getElementById('iframe_list').contentWindow.postMessage({
                            "info": "addLang"
                        }, "*");

                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                });
            }
        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            vm.ngFlow.flow.opts.headers = {};
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            var data = JSON.parse(message);
            if (angular.isDefined(data.file_name)) {
                vm.videoKeyName = data.file_name;
            } else return;
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            vm.progressBarValue = 0;
            vm.inProgress = false;
            $rootScope.loadingProgress = false;
        }

        /**
         * Stop upload operation
         */
        function cancelUpload() {
            $timeout(function () {
                vm.ngFlow.flow.cancel();
            });
        }

    }
})
();

(function () {
    'use strict';

    angular
        .module('app.media.video.add', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {





        // State
        $stateProvider
            .state('app.media_video_add_form_new', {
                url: "/medias/videos/:slug/add/:hashSource/:title/:subFolder",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/add_edit.template.html',
                        controller: 'mediaVideoAddController as vm'
                    }
                },
                resolve: {
                    videoMetaData: function (msApi, $stateParams) {
                        msApiProvider.register('media_video.getMetaDataPiper', [apiPiper + 'assets/metadata']);
                        return msApi.resolve('media_video.getMetaDataPiper@get', {video: $stateParams.title, subFolder: $stateParams.subFolder});
                    },
                    videoData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video.getData@get', {id: 0});
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    },
                    listGroups: function (msApi) {
                      return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "media_video_post_add_action"
            })
            .state('app.media_video_add', {
                url: "/medias/videos/:slug/add/:id/:hashSource/:title/:subFolder",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/add_edit.template.html',
                        controller: 'mediaVideoAddController as vm'
                    }
                },
                resolve: {
                    videoMetaData: function (msApi, $stateParams) {
                               msApiProvider.register('media_video.getMetaDataPiper', [apiPiper + 'assets/metadata']);
                               return msApi.resolve('media_video.getMetaDataPiper@get', {video: $stateParams.title, subFolder: $stateParams.subFolder});
                      },
                    videoData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video.getData@get', {id: $stateParams.id, secondStep: true});
                    },
                    themesThumbs: function (msApi) {
                        return msApi.resolve('parameters_themes.getThumbs@get');
                    },
                    contributorsData: function (msApi) {
                        return msApi.resolve('contributors.getContributors@get');
                    },
                    listGroups: function (msApi) {
                      return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission": "media_video_post_add_action"
            })
            .state('app.media_video_add_multi_title_form_new', {
                    url: "/medias/videos/:slug/add/multiTitle/:hashSource/:title/:subFolder",
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/media/video/add_edit_multi_title.template.html',
                            controller: 'mediaVideoAddMultiTitleController as vm'
                        }
                    },
                    resolve: {
                        videoMetaData: function (msApi, $stateParams) {
                            msApiProvider.register('media_video.getMetaDataPiper', [apiPiper + 'assets/metadata']);
                            return msApi.resolve('media_video.getMetaDataPiper@get', {
                                video: $stateParams.title,
                                subFolder: $stateParams.subFolder
                            });
                        },
                        videoData: function (msApi, $stateParams) {
                            return msApi.resolve('media_video.getData@get', {id: 0, secondStep: true});
                        },
                        themesThumbs: function (msApi) {
                            return msApi.resolve('parameters_themes.getThumbs@get');
                        },
                        contributorsData: function (msApi) {
                            return msApi.resolve('contributors.getContributors@get');
                        },
                        channelChoices: function (msApi) {
                            return msApi.resolve('channel.channelChoices@get');
                        }
                    },
                    "bodyClass": "forms",
                    "actionPermission": "media_video_post_add_action"
                }
            )
            .state('app.media_video_add_multi_title', {
                    url: "/medias/videos/:slug/add/multiTitle/:id/:hashSource/:title/:subFolder",
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/media/video/add_edit_multi_title.template.html',
                            controller: 'mediaVideoAddMultiTitleController as vm'
                        }
                    },
                    resolve: {
                        videoMetaData: function (msApi, $stateParams) {
                                msApiProvider.register('media_video.getMetaDataPiper', [apiPiper + 'assets/metadata']);
                                return msApi.resolve('media_video.getMetaDataPiper@get', {
                                    video: $stateParams.title,
                                    subFolder: $stateParams.subFolder
                                });
                        },
                        videoData: function (msApi, $stateParams) {
                            return msApi.resolve('media_video.getData@get', {id: $stateParams.id, secondStep: true});
                        },
                        themesThumbs: function (msApi) {
                            return msApi.resolve('parameters_themes.getThumbs@get');
                        },
                        contributorsData: function (msApi) {
                            return msApi.resolve('contributors.getContributors@get');
                        },
                        channelChoices: function (msApi) {
                            return msApi.resolve('channel.channelChoices@get');
                        }
                    },
                    "bodyClass": "forms",
                    "actionPermission": "media_video_post_add_action"
                }
            );

        //API
        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('media_video.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_themes.getSelectChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input')]);
        msApiProvider.register('media_video.editVideo', [Routing.generate('api_media_post_edit_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('media_video.addVideo', [Routing.generate('api_media_post_add_video')]);
        msApiProvider.register('media_video.editMetaDataVideo', [Routing.generate('api_media_post_edit_meta_data_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_themes.getThumbs', [Routing.generate('api_parameters_get_themes_thumbs')]);
        msApiProvider.register('media_video.getGeneratedThumbs', [apiPiper + 'thumbnail']);
        msApiProvider.register('media_video.validateForm', [apiPiper + 'video/validate-form']);
        msApiProvider.register('media_video.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")])
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);

    }
})();

(function () {
    'use strict';
    angular
        .module('app.media.video.add')
        .controller('mediaVideoAddController', mediaVideoAddController)
        .controller('selectChannelsController', selectChannelsController)
        .controller('mediaVideoAddMultiTitleController', mediaVideoAddMultiTitleController);

    /** @ngInject */
    function mediaVideoAddController($scope, userManager, videoData, contributorsData, $injector,videoMetaData,$cookies,listGroups, themesThumbs, $mdConstant,webTv_msNavigation) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        /**
         *Injected Vars
         */
        var $rootScope = $injector.get('$rootScope'),
            webTvGlobal = $injector.get('webTvGlobal'),
            $sce = $injector.get('$sce'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $stateParams = $injector.get('$stateParams'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');

        var vm = this,
            t1 = moment();
        vm.videoMetaData=videoMetaData;
        if(videoMetaData && angular.isDefined($stateParams.id)){
            var metaData = angular.toJson({"contentJson" : videoMetaData});
            msApi.request('media_video.editMetaDataVideo@save',
                {metaData: metaData, id:$stateParams.id},
                function (res) {

                });
        }
      vm.isGV=isGV;
      $rootScope.isGV=isGV
      vm.groups=listGroups ? listGroups.data.groups : [];
        vm.isNew = true;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().has_upload_multiple) && webTvGlobal.$constant().webTvParameterBag().has_upload_multiple === "1")
            vm.isMultiUpload = true;
        else
            vm.isMultiUpload = false;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_simple_multiple) && webTvGlobal.$constant().webTvParameterBag().video_simple_multiple === "1")
            vm.isMultiUploadVod = true;
        else
            vm.isMultiUploadVod = false;

        //$rootScope.isUploading = false;
        if ($rootScope.endUpload) {
            $rootScope.isUploading = false;
        }
        //$rootScope.isUploading = false;
        $rootScope.loadingProgress=false;
        vm.requredTheme = false;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        if (angular.isDefined(parameters['use_not_classified_theme']) && parameters['use_not_classified_theme'] ==="1")
            vm.requredTheme = true;

        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
        else vm.testMultiLangue = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
        else vm.testIntranetInternet = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
        else vm.testNotificationClient = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
        else vm.testMultiFormat = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_general_condition)) var testCondition = webTvGlobal.$constant().webTvParameterBag().video_general_condition;
        else var testCondition = '0';
        vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
            (function (languages, data) {
                for (var i = 0; i < data.length; i++) {
                    languages[data[i]] = data[i];


                }
                return languages;
            })({}, webTvGlobal.$constant().languagesList())
        );
        vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
            (function (contributors, data) {

                contributors['none'] = "0";
                for (var i = 0; i < data.length; i++) {
                    contributors[data[i].name] = data[i].id;
                }
                return contributors;
            })({}, contributorsData.contributors)
        );

        var user = userManager.getUser();
        vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];
        vm.empMediaVideoForm = {};
        $scope.empMediaVideoForm = {};
        vm.sendPushNotifications = 0;
        vm.minDate = undefined;
        $scope.currentNavItem = "page1"
        vm.changeDate = changeDate;
        vm.showVideoDetail = showVideoDetail;
        // vm.getTitle = getTitle;
        vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
        // vm.setNone = setNone;
        vm.imageNameTranscription = "";
        vm.setEmptyPassword = setEmptyPassword;
        vm.returnToList = returnToList;
        vm.playerIsLoading = 0;
        vm.showPlayer = 0;
        vm.playerLink = "";
        vm.generatingMultiThumbs=false
        $rootScope.generatingThumbnail=false

      /**
         * Upload File (NG FLOW) Parameters and methods
         */
        vm.imageFrom = "generated";
        vm.videoThumb = null;
        $rootScope.videoThumb = null;
        $scope.someModel = null;
        vm.ngFlowOptions = {
            target: Routing.generate('api_media_post_thumb'),
            singleFile: true,
            testChunks: false,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
            //attributes: 'image/*',
            //testMethod: false,

        };
        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlow = {flow: {}};
        // Methods
      vm.fileAdded = fileAdded;
      vm.uploadFile = uploadFile;
      vm.fileSuccess = fileSuccess;
      vm.fileError = fileError;
      vm.uploadComplete = uploadComplete;
      vm.fileAddedTranscription = fileAddedTranscription;
      vm.uploadFileTranscription = uploadFileTranscription;
      vm.fileSuccessTranscription = fileSuccessTranscription;
      vm.fileErrorTranscription = fileErrorTranscription;
      vm.uploadCompleteTranscription = uploadCompleteTranscription;
        var currentTime = 0;
        vm.takeVignette = takeVignette;
        vm.testVignette = testVignette;
        $rootScope.changedThmb=false;
      vm.randomValue="";
        randomValue();
      function randomValue(){
        var dt = new Date().getTime();
        var result = 'xyxxxyxxxy'.replace(/[xy]/g, function (c) {
          var r = (dt + Math.random() * 16) % 16 | 0;
          dt = Math.floor(dt / 16);
          return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
        vm.randomValue=result
      }
        function testVignette() {
            if (angular.isDefined(vm.selectedThumbs[0])) {
                vm.videoThumb = vm.selectedThumbs[0];
              $rootScope.videoThumb = vm.selectedThumbs[0];
                vm.empMediaVideoForm.logo = vm.selectedThumbs[0];
              $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            }
        }
      $scope.goto = function(page) {
        $scope.status = "Goto " + page;
      };
        if(window.dataEventPostMessageAddVideo === undefined) {
            window.dataEventPostMessageAddVideo = true;
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
            eventer(messageEvent,  function (e) {
                if (angular.isDefined(e.data) && angular.isDefined(e.data.info) && e.data.info === "currenttime") {
                  currentTime = e.data.value[0];
                  if(!$rootScope.changedThmb){
                    getThumbnail(currentTime);
                  }
                }
            }, false);
        }
       function getThumbnail(currentTime){
        if ($stateParams.title) {
          $rootScope.generatingThumbnail=true
          $rootScope.changedThmb=true;
          var newThumb=vm.videoThumb
          var requestData = {"fileName": $stateParams.title};
          var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
          requestData.timecode = webTvGlobal.toHHMMSS(currentTime.toString());
          if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
          var hasparams =  requestData && angular.isDefined(requestData.fileName)  && angular.isDefined(requestData.timecode)

          if(hasparams){
             msApi.request('media_video.getGeneratedThumbs@get',
              requestData,
               function (res) {
                if (res.thumbnails && res.thumbnails.length) {
                  setAndPreviewThumb(url_thumbnails_video_piper + res.thumbnails[0])
                  $rootScope.generatingThumbnail=false
                }
              });
          }
        }
      }
        function takeVignette() {
          $rootScope.changedThmb=false;
          $rootScope.generatingThumbnail=true
          document.getElementById('player_add').contentWindow.postMessage({
                "fn": "getCurrentTime",
                "params": []
            }, "*");
        }


        vm.ngFlowOptionsFile = {
            target: Routing.generate('api_media_post_video_attached_file'),
            testChunks: false,
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
            //attributes: 'image/*',
            //testMethod: false,

        };
      // ngFlow Option Transcription
      vm.ngFlowOptionsFileTranscription = {
        target: Routing.generate('api_media_post_video_attached_file'),
        testChunks: false,
        maxChunkRetries: 1,
        chunkRetryInterval: 5000,
        simultaneousUploads: 1,
        fileParameterName: 'empApiFileForm[thumb]',
        query:{
          mimeType:"transcription",
        },
        headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
        //attributes: 'image/*',
        //testMethod: false,

      };
      vm.ngFlowFileTranscripton = {
        // ng-flow will be injected into here through its directive
        flow: {}

      };

        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlowFile = {
            // ng-flow will be injected into here through its directive
            flow: {}

        };
        vm.filefAdded = filefAdded;
        vm.filefSuccess = filefSuccess;
        vm.uploadfComplete = uploadfComplete;
        vm.filefProgress = filefProgress;
        vm.uploadFilef = uploadFilef;
        vm.cancelUploadf = cancelUploadf;
        vm.progressBarValue = 0;
        vm.roundWithPrecision = roundWithPrecision;
        vm.dropping = false;
        vm.inProgressf = false;
        vm.filesChips = [];
        vm.filesChipsTranscription = [];
        var filesChips = [];
        var fileChipsTranscription = [] ;
        var filesUrl = [];

        var tabFiles = [];



        function cancelUploadf() {
            $timeout(function () {
                vm.ngFlowFile.flow.cancel();

            });
        }

        function filefAdded(file) {

            vm.fileName = file.name;

        }

        function filefProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        function uploadFilef() {
            // Set headers
            vm.ngFlowFile.flow.upload();
            vm.inProgressf = true;
        }


        vm.theme = [];
        function fillSelectListThemes() {
            angular.forEach(videoData.themes, function (value) {
                vm.theme.push(value.id);
            });
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function filefSuccess(file, message) {
            var res = angular.fromJson(message);
            if (res.location.path) {
                filesChips.push(res.location.path);
                vm.filesChips.push(file.relativePath);
                filesUrl.push(res.location.url);
            }

        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadfComplete() {
            vm.progressBarValue = 0;
            vm.inProgressf = false;

        }

        // getCurrentTimeFromPlayer();
        //
        // function getCurrentTimeFromPlayer() {
        //     if (document.getElementById('player_add')) {
        //         document.getElementById('player_add').contentWindow.postMessage({
        //             "fn": "getCurrentTime",
        //             "params": []
        //         }, "*");
        //     }
        // }


        vm.selectThemes = selectThemes;
        initHelp();

        function initHelp() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
            $rootScope.titre3 = "";
          }else{
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
          }
            $rootScope.pageRoute = "app.media_video_list_ongoing";
            $rootScope.welcome = "welcome_video";
            $rootScope.text = [{
                texte: "parameters_video_add_help"
            }, {
                texte: "upload_button_video_add_help"
            }, {
                texte: "send_button_video_add_help"
            }, {
                texte: "cancel_button_video_add_help"
            }];
        }


        function selectThemes(test, themeModel) {
            vm.empMediaVideoForm.themes = [];
            var canalTheme = [];
            var themes=[];
            angular.forEach(themeModel, function (value) {
                value=value.toString();
                themes.push(value.substring(value.indexOf('-') + 1, value.length));
                canalTheme.push(value);
            });
            vm.theme=canalTheme;
            vm.empMediaVideoForm.themes = themes;
            vm.setSelectedThumbs();
            if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
                vm.videoThumb = vm.selectedThumbs[0];
              $rootScope.videoThumb = vm.selectedThumbs[0];
                vm.empMediaVideoForm.logo = vm.selectedThumbs[0];
              $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            } else if (vm.imageFrom === 'theme') {
                vm.videoThumb = vm.generatedThumbs[0];
              $rootScope.videoThumb = vm.generatedThumbs[0];

                vm.empMediaVideoForm.logo = vm.generatedThumbs[0];
              $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
            }

        }
        vm.imageName = "";
        vm.uploadingInPogress = 0;
        vm.selectedThumbs = [];
        vm.setSelectedThumbs = setSelectedThumbs;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        // vm.innerThumbStyle = {
        //     position: 'relative',
        //     width: '200px',
        //     height: '200px',
        //     border: '1px solid rgba(0, 0, 0, 0.12)',
        //     margin: '8px'
        // };
        vm.setAndPreviewThumb = setAndPreviewThumb;
        var loadingGeneratedThumbs = 0;
        var errorOnGettingGeneratedThumbs = 0;
        vm.generatedThumbs = [];
        var generatedThumbs = [];
        vm.regenerateThumbs = regenerateThumbs;
        var requestNumber = 0;
        var numberofGeneratedThumbs = 3;
        vm.clickVignette = clickVignette;
        vm.showCondtionTerms = showCondtionTerms;

        function clickVignette() {
            vm.imageFrom = null;
        }

        function requestThumbs() {
            loadingGeneratedThumbs = 1;
            errorOnGettingGeneratedThumbs = 0;
            requestNumber = 0;
            // var duration = videoMetaData.metaData.all.data.contentJson.format.duration;
            // switch (true) {
            //   case (duration <= 300):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 300 && duration <= 600):
            //     numberofGeneratedThumbs = 4;
            //     break;
            //   case (duration > 600 && duration <= 900):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 900 && duration <= 1200):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   default:
            //     numberofGeneratedThumbs = 3;
            //     break;
            //
            // }

            if (angular.isDefined(vm.empMediaVideoForm.validity)) vm.empMediaVideoForm.validity = null;
            // for (var i = 0; i < numberofGeneratedThumbs; i++) {
            getGeneratedThumbs(numberofGeneratedThumbs);
            // }
        }

        function regenerateThumbs() {
            getGeneratedThumbs(1);
        }

        function getGeneratedThumbs(nbr) {
            if (angular.isUndefined(nbr)) nbr = 0;
          vm.generatingMultiThumbs=true

          var requestData = {"fileName": $stateParams.title};
            if (nbr) requestData.count = nbr;
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
            msApi.request('media_video.getGeneratedThumbs@get',
                requestData,
                function (res) {
                    requestNumber++;
                    if (res.thumbnails.length) {
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            generatedThumbs.push( url_thumbnails_video_piper + res.thumbnails[i]);

                        }
                        if(generatedThumbs.length > 3){
                          generatedThumbs=generatedThumbs.slice(1, 4);
                        }

                        vm.empMediaVideoForm.logo = generatedThumbs[0];
                      $rootScope.empMediaVideoForm.logo = generatedThumbs[0];
                        vm.videoThumb = generatedThumbs[0];
                        $rootScope.videoThumb = generatedThumbs[0];

                    }
                    if (!nbr || requestNumber === numberofGeneratedThumbs) {
                        $timeout(function () {
                            loadingGeneratedThumbs = 0;
                            errorOnGettingGeneratedThumbs = 0;
                            vm.empMediaVideoForm.validity = 1;
                        });
                    }
                    // $location.hash('v' + vm.generatedThumbs.length);
                    //
                    // // call $anchorScroll()
                    // $anchorScroll();
                  vm.generatingMultiThumbs=false

                  vm.generatedThumbs = generatedThumbs;

                },
                function () {
                    loadingGeneratedThumbs = 0;
                    errorOnGettingGeneratedThumbs = 1;
                    vm.empMediaVideoForm.validity = 1;
                    vm.requestNumbe = numberofGeneratedThumbs;
                }
            );
        }

        function setSelectedThumbs() {
            vm.selectedThumbs = [];
            var selectedThumb = [];
            if (angular.isArray(vm.empMediaVideoForm.themes)) {
                for (var i = 0; i < vm.empMediaVideoForm.themes.length; i++) {
                    if (angular.isDefined(themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]]) && themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]] !== "") selectedThumb.push(themesThumbs.thumbs[vm.empMediaVideoForm.themes[i]]);
                }
                vm.selectedThumbs = selectedThumb
            }
        }

        function setAndPreviewThumb(thumb, choix) {
          $rootScope.empMediaVideoForm.$pristine = false;
            if (choix === 'theme'){
              vm.empMediaVideoForm.logo = thumb.split('/').pop();//.replace(rx,"");
              $rootScope.empMediaVideoForm.logo = thumb.split('/').pop();//.replace(rx,"");
            }
            else{
              vm.empMediaVideoForm.logo = thumb;//.replace(rx,"");
              $rootScope.empMediaVideoForm.logo = thumb;//.replace(rx,"");
            }
            vm.videoThumb = thumb;
            $rootScope.videoThumb = thumb;
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
                return false;
            }
            if (file.size > 1024000) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_image_too_large_message'));
                return false;
            }
            vm.imageName = file.name;

        }
      /**
       * File added callback
       * Triggers when files added to the uploader transcription
       *
       */
      function fileAddedTranscription(file) {
        if (!/(doc|docx|html|htm|odt|pdf|xls|xlsx|ods|ppt|pptx|txt)$/.test(file.getExtension().toLowerCase())) {
          vm.imageNameTranscription = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_document_message'));
          return false;
        }
        vm.imageNameTranscription = file.name;
      }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            // Set headers
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }
      /**
       * Upload
       * Automatically triggers when files added to the uploader transcription
       */
      function uploadFileTranscription() {
        // Set headers
        vm.ngFlowFileTranscripton.flow.upload();
        vm.inProgress = true;
      }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
          vm.uploadingInPogress = 0;
          var res = angular.fromJson(message);
          if (res.location.url) {
            vm.empMediaVideoForm.logo = res.location.url;
            $rootScope.empMediaVideoForm.logo = res.location.url;
            vm.videoThumb = res.location.url;
            $rootScope.videoThumb = res.location.url;

          }
        }
      /**
       * File upload success callback
       * Triggers when single upload completed Transcription
       *
       */
          function fileSuccessTranscription(file, message) {
            vm.uploadingInPogress = 0;
            var res = angular.fromJson(message);
            if (res.location.url) {
              vm.imageNameTranscription = file.name
              fileChipsTranscription.push(res.location.path);
              vm.filesChipsTranscription.push(file.relativePath);
              filesUrl.push(res.location.url);
            }

        }

        function fileError() {
            vm.uploadingInPogress = 0;
            vm.imageName = "";
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
        }

      function fileErrorTranscription() {
        vm.uploadingInPogress = 0;
        vm.imageNameTranscription = "";
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
      }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            if (vm.imageName) {
                webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
            }

        }
      function uploadCompleteTranscription() {
        if (vm.imageNameTranscription) {
          webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageNameTranscription}));
        }

      }


        /**
         * End Ng Flow
         */


        if (!vm.isMultiUpload)
            fillData();
        else {
            if (angular.isDefined($rootScope.files)) {
                fillDataMultiUpload();
                getGeneratedThumbsMultiUpload();
            } else $state.go('app.media_video_upload');
        }

        function getPlayerLink() {
            msApi.request(
                'media_video.getPreviewLinkByTitle@get',
                {"title": $stateParams.title, "y": "bo", "subFolder": $stateParams.subFolder},
                function (res) {
                    if (res.code === 200) {
                        vm.showPlayer = 1;
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                    } else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {
            });
        }

        function splitKeyWords(chain) {
            var words = chain.split(' ') || [];
            words = words.filter(function (item, pos) {
                return words.indexOf(item) === pos;
            });
            return words;
        }

        function testMp4(codecVideo) {
            if ((/\.mp4$/.test($stateParams.title.toLowerCase())) && (!/mpeg4/.test(codecVideo))) {
                vm.playerIsLoading = 1;
                getPlayerLink()
            } else requestThumbs();

        }

        function testFlv() {
            if (/\.flv$/.test($stateParams.title.toLowerCase()) || /\.webm$/.test($stateParams.title)) {
                vm.playerIsLoading = 1;
                getPlayerLink()
            } else requestThumbs();

        }

        function fillData() {
            if (videoMetaData.format && videoMetaData.streams && videoMetaData.format.duration) {
                var codecVideo = angular.isDefined(videoMetaData.streams[0]["codec_long_name"]) && videoMetaData.streams[0]["codec_long_name"]!=="unknown"
                    ? videoMetaData.streams[0]["codec_long_name"] : videoMetaData.streams[0]["codec_name"]  ;
                var title = $stateParams.title;
              //   title = title.substring(0, title.lastIndexOf("-"));
              // title = title.substring(0, title.lastIndexOf("-"));
              // for (var i = 0; i < $stateParams.title.length; i++) {
              //       title = title.replace("_", " ");
              //       title = title.replace("-", " ");
              //   }
                var is_360;

                try{
                    if (angular.isDefined(videoMetaData.streams[0]["display_aspect_ratio"])) {
                        if (videoMetaData.streams[0]["display_aspect_ratio"] === "2:1") {
                            is_360 = 1;
                        } else {
                            is_360 = 0;
                        }
                    } else {
                        is_360 = 0;
                    }
                }catch(e){
                    is_360 = 0;
                    console.log('videoMetaData.metaData.all.data',e)
                }
                if (angular.isDefined(videoMetaData.format.tags) && videoMetaData.format.tags && angular.isDefined(videoMetaData.format.tags.copyright)){
                    var copyright = videoMetaData.format.tags.copyright;
                }else{
                    var copyright = "";
                }
                if (videoMetaData.format.tags && angular.isDefined(videoMetaData.format.tags.artist)){
                    var author = videoMetaData.format.tags.artist;
                }else{
                    var author = "";
                }
                if (videoMetaData.format.tags && angular.isDefined(videoMetaData.format.tags.title) && videoMetaData.format.tags.title){
                    var titleForm = videoMetaData.format.tags.title;
                }else{
                    var titleForm = title;
                }
                 fillSelectListThemes();
                vm.empMediaVideoForm = {
                    "fileTitle": $stateParams.title,
                    "subFolder": $stateParams.subFolder,
                    "hashSource": $stateParams.hashSource,
                    "title": titleForm,
                    "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
                    "insertDate": new Date(t1.format('YYYY-MM-DD HH:mm:ss')),
                    "startDate": new Date(t1.format('YYYY-MM-DD')),
                    "endDate": new Date(moment().add(10, "years").format('YYYY-MM-DD')),
                    "duration": new Date(moment.utc(videoMetaData.format.duration * 1000).format('YYYY-MM-DDTHH:mm:ss.SSS')),
                    "themes": [],
                    "secure": videoData.secure ? 1 : 0,
                    "downloadable": videoData.downloadable ? 1 : 0,
                    "offline": videoData.offline ? 1 : 0,
                    "is_accessible": videoData.is_accessible ? 1 : 0,
                    "shared": videoData.shared ? 1 : 0,
                    "description": null,
                    "transcription": null,
                    "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
                    "contributor": user.id,
                    "author": author,
                    "copyright": copyright,
                    "keyWords": [],
                    "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
                    "isVisibleOnInternet": videoData.isVisibleOnInternet,
                    "passwordInternet": null,
                    "logo": vm.generatedThumbs[0],
                    "mainPage": videoData.mainPage ? 1 : 0,
                    "metaData": angular.toJson({"contentJson" : videoMetaData}),
                    "mdTime": {
                        start: new Date(t1.format('YYYY-MM-DD')),
                        end: new Date(moment().add(10, "years").format('YYYY-MM-DD'))
                    },
                    "is_360": is_360,
                    'validity': null,
                  "subscriptionGroups": videoData.subscriptionGroups
                };
                $rootScope.empMediaVideoForm=vm.empMediaVideoForm
                // vm.empMediaVideoForm.title=vm.srcImgBig.replace("-", " ").replace("_", " ");
                //vm.srcImgBig.replace("[login]", vm.login).replace("[password]", vm.password)
                //   vm.minDate = vm.empMediaVideoForm.mdTime.start;
                if (vm.testMultiLangue === '1') {
                    vm.language = $translate.preferredLanguage();

                }
                testMp4(codecVideo);
                testFlv();
            } else {
                $rootScope.uploadMetaDataError = true;
                $rootScope.index = 0;
                $state.go('app.media_video_upload');
            }
        }

        function fillDataMultiUpload() {
        }

        function getGeneratedThumbsMultiUpload() {
            var requestData = {"fileName": $rootScope.files[0]};
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
            msApi.request('media_video.getGeneratedThumbs@get',
                requestData,
                function (res) {
                    requestNumber++;
                    if (res.thumbnails.length) {
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            generatedThumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                        }
                        vm.empMediaVideoForm.logo = generatedThumbs[0];
                      $rootScope.empMediaVideoForm.logo = generatedThumbs[0];
                        vm.videoThumb = generatedThumbs[0];
                        $rootScope.videoThumb = generatedThumbs[0];
                    }

                },
                function () {
                    loadingGeneratedThumbs = 0;
                    errorOnGettingGeneratedThumbs = 1;
                    vm.empMediaVideoForm.validity = 1;
                    vm.requestNumbe = numberofGeneratedThumbs;
                }
            );
            vm.generatedThumbs = generatedThumbs;
        }


        // function setNone() {
        //     if (!vm.empMediaVideoForm.useTheme) vm.empMediaVideoForm.themes = [];
        // }

        function setEmptyPassword() {
            if (!vm.empMediaVideoForm.isSecuredOnInternet) vm.empMediaVideoForm.passwordInternet = null;
        }

        // /**
        //  * Return Imported Video Title if exists
        //  * @return string title
        //  */
        // function getTitle() {
        //     return vm.empMediaVideoForm.title || "";
        // }

        /**
         * set The selected in the form appropriate field
         * @param copyFrom  from where
         * @param pasteIn to whom the date will be setted
         */
        function changeDate(copyFrom, pasteIn) {
            if (angular.isDefined(vm.empMediaVideoForm[pasteIn]) && angular.isDefined(vm.empMediaVideoForm.mdTime[copyFrom])) vm.empMediaVideoForm[pasteIn] = vm.empMediaVideoForm.mdTime[copyFrom];
        }

        /**
         *
         * @param  {[type]} formData [description]
         * @return {[type]}          [description]
         */
        function preapreFormDataToSend(formData) {
            var formFormattedData = formData;
            if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
            /**
             * convert null to empty string loop
             */
            for (var attr in formFormattedData) {
                if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
                if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
                if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

            }
            if (formFormattedData.contributor === "0") formFormattedData.contributor = null;

            formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
            return formFormattedData;
        }

        function cleanArray(array) {
            var i, j, len = array.length, out = [], obj = {};
            for (i = 0; i < len; i++) {
                obj[array[i]] = 0;
            }
            for (j in obj) {
                out.push(j);
            }
            return out;
        }

        function showCondtionTerms(ev) {
            if (testCondition === "1") {
                if ($cookies.get('WEBTV.locale') === "fr") {
                    vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_fr
                } else {
                    vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_en

                }
                $mdDialog.show({
                    controller: conditionsTermsController,
                    templateUrl: 'app/main/media/video/condition-terms.modal.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                    // fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (answer) {

                    }, function () {

                    })
            } else {
                vm.submitAddMediaVideoForm();

            }
        }

        function conditionsTermsController($scope, $mdDialog) {
            $scope.text = vm.text;
            $scope.cancel = function () {
                $mdDialog.hide();
            };
            $scope.accept = function () {
                $mdDialog.hide();
                vm.submitAddMediaVideoForm();
            };
        }

        vm.selectChip = selectChip;
        vm.deleteAddedChip = deleteAddedChip;

        function deleteAddedChip(chip) {
            vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);

        }

        function selectChip(chip) {
            window.open(filesUrl[vm.filesChips.indexOf(chip)], '_blank');
        }

        vm.testExtension = testExtension;

        function testExtension(file) {
            var extn = file.split(".").pop();
            if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(extn.toLowerCase())) {
                return "video";
            } else if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
                return "audio";
            } else if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
                return "excel";
            } else if (/(doc|docx)$/i.test(extn.toLowerCase())) {
                return "word";
            } else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
                return "image";
            } else if (/(pdf)$/i.test(extn.toLowerCase())) {
                return "pdf";
            } else
                return "other";


        }

        /**
         * Send add Video Form
         */
        function submitAddMediaVideoForm() {
          console.log("submitAddMediaVideoForm simple")
          angular.forEach(vm.filesChips, function (value, index) {
            tabFiles.push({
              "title": filesChips[index],
              "fileName": value,
            });
          });
          // Push transcription File
          tabFiles.push({
            "title": fileChipsTranscription.pop(),
            "fileName": vm.imageNameTranscription,
            "mimeType": vm.imageNameTranscription ? "transcription" : ""
          });
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            if (isIE) {
                vm.empMediaVideoForm.insertDate = t1.format('YYYY-MM-DD HH:mm:ss')
            }
            var formData = preapreFormDataToSend(angular.copy(vm.empMediaVideoForm));
            formData.themes = cleanArray(vm.empMediaVideoForm.themes);
            formData.subscriptionGroups = vm.empMediaVideoForm.subscriptionGroups ? cleanArray(vm.empMediaVideoForm.subscriptionGroups): vm.empMediaVideoForm.subscriptionGroups;
          if(vm.empMediaVideoForm.themes.length<=0) {
                formData.mainPage = false;
            }
            formData.filesVideo = tabFiles;
            if (formData.title === " ") {
                vm.empMediaVideoForm.title = "";
                formData.title = "";
            }

            formData.medias = [];
            formData.medias.push({lang: vm.language});
          formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
          formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet
            // if (formData.isVisibleOnIntranet === "") delete formData.isVisibleOnIntranet;
            // if (formData.isVisibleOnInternet === "") delete formData.isVisibleOnInternet;

            if (angular.isDefined(formData.validity)) delete formData.validity;
          console.log("formData on addVideo",formData)
          var requestForm = {"empMediaVideoForm": formData, 'sendPushNotif': vm.sendPushNotifications};
            if(angular.isDefined($stateParams.id)){
                var api_submit_form = "media_video.editVideo@save";
                requestForm.id = $stateParams.id;
                requestForm.secondStep = true;
            }else {
                var api_submit_form = "media_video.addVideo@save";
            }
          if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
          }
          if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
            $rootScope.loadingProgress=true;
            msApi.request(api_submit_form,
                requestForm,
                function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$flashMessages().set('MediaVideoAdd', {title: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : "VID"});
                      if(angular.isDefined($stateParams.id)) {
                          msApi.request("media_video.validateForm@get",
                            {fileName: formData.fileTitle, subFolder: $stateParams.subFolder, clientName: "test"},
                            function (res) {
                              console.log("validateForm file: " + formData.fileTitle);
                            });
                      }
                        $rootScope.isUploading = false;
                        var type_state_go = "ongoing";
                        if(formData.offline){
                            type_state_go = "offline";
                        }else {
                            var startDate = formData.startDate;
                            var endDate = formData.endDate;
                            var now = new Date(moment().format('YYYY-MM-DD HH:mm:ss'));
                            if (startDate > now) {
                                type_state_go = "upcoming";
                            }
                            if (endDate < now) {
                                type_state_go = "archived";
                            }
                        }
                        if(vm.isMultiUploadVod) {
                            if ($rootScope.uploader_queue.length > 0) {
                                $rootScope.addedMultiUpload = true;
                                $state.go('app.media_video_upload');
                            } else {
                                $rootScope.addedMultiUpload = false;
                                $state.go('app.media_video_list', {type: type_state_go});
                            }
                        }else{
                            $state.go('app.media_video_list', {type: type_state_go});
                        }
                    } else if (angular.isDefined(res.errors)) {

                        vm.empMediaVideoError = [];
                        vm.errors = res.errors;
                        vm.errors.forEach(function (item) {

                            vm.empMediaVideoForm[item.for] = {
                                message: item.messages[0],
                                value_old: angular.copy(vm.empMediaVideoForm[item.for])
                            };
                        });


                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );}
        }

        function returnToList() {
            if(vm.isMultiUploadVod) {
                if ($rootScope.uploader_queue.length > 0) {
                    $rootScope.addedMultiUpload = true;
                    $state.go('app.media_video_upload');
                } else {
                    $rootScope.addedMultiUpload = false;
                    $state.go('app.media_video_list', {type: "ongoing"});
                }
            }else{
                $state.go('app.media_video_list', {type: "ongoing"});
            }
        }

        /**
         * Open Imported Video Detail dialog
         * @param ev
         */
        function showVideoDetail(event) {
            $mdDialog.show({
                controller: 'mediaVideoMetaModalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/list/modal.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    metaData: videoMetaData,
                    mdDialogTitle: vm.empMediaVideoForm.title ? vm.empMediaVideoForm.title : vm.empMediaVideoForm.fileTitle

                }
            });
        }
        if( navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1){
            setTimeout(function() {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style','display: flex; position: relative;min-height:'+player_add.offsetHeight +'px !important');
                imgWrapper.style.height = image.offsetHeight +'px';
            },5000);
            window.onresize=function (event) {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style','display: flex; position: relative;min-height:'+player_add.offsetHeight +'px !important');
                imgWrapper.style.height = image.offsetHeight +'px';
            }
        }
    }
    function mediaVideoAddMultiTitleController($scope, userManager, videoData, contributorsData, $injector, videoMetaData, $cookies, themesThumbs, channelChoices, $mdConstant,webTv_msNavigation ) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        /**
         *Injected Vars
         */

        var $rootScope = $injector.get('$rootScope'),
            webTvGlobal = $injector.get('webTvGlobal'),
            $sce = $injector.get('$sce'),
            $timeout = $injector.get('$timeout'),
            $translate = $injector.get('$translate'),
            $stateParams = $injector.get('$stateParams'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');

        var vm = this,
            t1 = moment();
        vm.videoMetaData=videoMetaData;
        vm.isNew = true;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().has_upload_multiple) && webTvGlobal.$constant().webTvParameterBag().has_upload_multiple === "1")
            vm.isMultiUpload = true;
        else
            vm.isMultiUpload = false;
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_simple_multiple) && webTvGlobal.$constant().webTvParameterBag().video_simple_multiple === "1")
            vm.isMultiUploadVod = true;
        else
            vm.isMultiUploadVod = false;
        //$rootScope.isUploading = false;
        if ($rootScope.endUpload) {
            $rootScope.isUploading = false;
        }
        //$rootScope.isUploading = false;
        $rootScope.loadingProgress=false;
        vm.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.TAB];
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_multilangue)) vm.testMultiLangue = webTvGlobal.$constant().webTvParameterBag().video_multilangue;
        else vm.testMultiLangue = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)) vm.testIntranetInternet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
        else vm.testIntranetInternet = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().notificationMobileClient)) vm.testNotificationClient = webTvGlobal.$constant().webTvParameterBag().notificationMobileClient;
        else vm.testNotificationClient = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video)) vm.testMultiFormat = webTvGlobal.$constant().webTvParameterBag().generate_multifomat_video;
        else vm.testMultiFormat = '0';
        if (angular.isDefined(webTvGlobal.$constant().webTvParameterBag().video_general_condition)) var testCondition = webTvGlobal.$constant().webTvParameterBag().video_general_condition;
        else var testCondition = '0';
        vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
            (function (languages, data) {
                for (var i = 0; i < data.length; i++) {
                    languages[data[i]] = data[i];


                }
                return languages;
            })({}, webTvGlobal.$constant().languagesList())
        );
        vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
            (function (contributors, data) {

                contributors['none'] = "0";
                for (var i = 0; i < data.length; i++) {
                    contributors[data[i].name] = data[i].id;
                }
                return contributors;
            })({}, contributorsData.contributors)
        );

        var user = userManager.getUser();

        vm.channels = $rootScope.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
        $rootScope.videoSelectedChannels = [];
        $rootScope.empMediaVideoForm = {};
        vm.sendPushNotifications = 0;
        vm.minDate = undefined;
        vm.changeDate = changeDate;
        vm.showVideoDetail = showVideoDetail;
        // vm.getTitle = getTitle;
        vm.submitAddMediaVideoForm = submitAddMediaVideoForm;
        // vm.setNone = setNone;

        vm.setEmptyPassword = setEmptyPassword;
        vm.returnToList = returnToList;
        vm.playerIsLoading = 0;
        vm.showPlayer = 0;
        vm.playerLink = "";
        /**
         * Upload File (NG FLOW) Parameters and methods
         */
        vm.imageFrom = "generated";
        vm.videoThumb = null;
        $scope.someModel = null;
        vm.ngFlowOptions = {
            target: Routing.generate('api_media_post_thumb'),
            singleFile: true,
            testChunks: false,
            fileParameterName: 'empApiFileForm[thumb]',
            headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
            //attributes: 'image/*',
            //testMethod: false,

        };
        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlow = {flow: {}};
        // Methods
        vm.fileAdded = fileAdded;
        vm.uploadFile = uploadFile;
        vm.fileSuccess = fileSuccess;
        vm.fileError = fileError;
        vm.uploadComplete = uploadComplete;
        var currentTime = 0;
        vm.takeVignette = takeVignette;
        vm.testVignette = testVignette;
      $rootScope.generatingThumbnail=false
      vm.generatingMultiThumbs=false
      $rootScope.changedThmb=false;
        function testVignette() {
            if (angular.isDefined(vm.selectedThumbs[0])) {
                vm.videoThumb = vm.selectedThumbs[0];
                $rootScope.videoThumb = vm.selectedThumbs[0];
                $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            }
        }

        if(window.dataEventPostMessageAddVideo === undefined) {
            window.dataEventPostMessageAddVideo = true;
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
            var eventer = window[eventMethod];
            var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
            eventer(messageEvent, function (e) {
                if (angular.isDefined(e.data) && angular.isDefined(e.data.info) && e.data.info === "currenttime") {
                    currentTime = e.data.value[0];
                  if(!$rootScope.changedThmb){
                    getThumbnail(currentTime)
                  }
                }
            }, false);
        }
      function getThumbnail(currentTime){
        if ($stateParams.title) {
          $rootScope.changedThmb=true
          $rootScope.generatingThumbnail=true
          var requestData = {"fileName": $stateParams.title};
          var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
          requestData.timecode = webTvGlobal.toHHMMSS(currentTime.toString());
          if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
          if(requestData && angular.isDefined(requestData.fileName)  && angular.isDefined(requestData.timecode)){
            msApi.request('media_video.getGeneratedThumbs@get',
              requestData,
              function (res) {
                if (res.thumbnails && res.thumbnails.length) {
                  vm.empMediaVideoForm.logo = (url_thumbnails_video_piper + res.thumbnails[0]);
                  $rootScope.empMediaVideoForm.logo =(url_thumbnails_video_piper + res.thumbnails[0]);;
                  vm.videoThumb = (url_thumbnails_video_piper + res.thumbnails[0]);
                  $rootScope.videoThumb = (url_thumbnails_video_piper + res.thumbnails[0]);
                  $rootScope.generatingThumbnail=false
                  $rootScope.empMediaVideoForm.$pristine = false;

                }

              });
          }

        }
      }
        function takeVignette() {
          $rootScope.changedThmb=false;
          $rootScope.generatingThumbnail=true;
          document.getElementById('player_add').contentWindow.postMessage({
                "fn": "getCurrentTime",
                "params": []
            }, "*");
        }

        vm.ngFlowOptionsFile = {
            target: Routing.generate('api_media_post_video_attached_file'),
            testChunks: false,
            maxChunkRetries: 1,
            chunkRetryInterval: 5000,
            simultaneousUploads: 1,
            fileParameterName: 'empApiFileForm[thumb]'
            //attributes: 'image/*',
            //testMethod: false,

        };

        if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
        vm.ngFlowFile = {
            // ng-flow will be injected into here through its directive
            flow: {}

        };
        vm.filefAdded = filefAdded;
        vm.filefSuccess = filefSuccess;
        vm.uploadfComplete = uploadfComplete;
        vm.filefProgress = filefProgress;
        vm.uploadFilef = uploadFilef;
        vm.cancelUploadf = cancelUploadf;
        vm.progressBarValue = 0;
        vm.roundWithPrecision = roundWithPrecision;
        vm.dropping = false;
        vm.inProgressf = false;
        vm.filesChips = [];
        vm.filesChipsTranscription = [];
        var filesChips = [];
        var fileChipsTranscription = [];
        var filesUrl = [];

        var tabFiles = [];

        function cancelUploadf() {
            $timeout(function () {
                vm.ngFlowFile.flow.cancel();

            });
        }

        function filefAdded(file) {

            vm.fileName = file.name;

        }

        function filefProgress(file) {
            vm.progressBarValue = file.progress() * 100;
        }

        function uploadFilef() {
            // Set headers
            vm.ngFlowFile.flow.upload();
            vm.inProgressf = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function filefSuccess(file, message) {
            var res = angular.fromJson(message);
            if (res.location.path) {
                filesChips.push(res.location.path);
                vm.filesChips.push(file.relativePath);
                filesUrl.push(res.location.url);
            }

        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadfComplete() {
            vm.progressBarValue = 0;
            vm.inProgressf = false;

        }

        // getCurrentTimeFromPlayer();
        //
        // function getCurrentTimeFromPlayer() {
        //     if (document.getElementById('player_add')) {
        //         document.getElementById('player_add').contentWindow.postMessage({
        //             "fn": "getCurrentTime",
        //             "params": []
        //         }, "*");
        //     }
        // }


        vm.selectThemes = selectThemes;
        initHelp();

        function initHelp() {
          if (webTv_msNavigation['media_video']) {
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
            $rootScope.titre3 = "";
          }else{
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.media_video_upload_menuTitle";
          }
            $rootScope.pageRoute = "app.media_video_list_ongoing";
            $rootScope.welcome = "welcome_video";
            $rootScope.text = [{
                texte: "parameters_video_add_help"
            }, {
                texte: "upload_button_video_add_help"
            }, {
                texte: "send_button_video_add_help"
            }, {
                texte: "cancel_button_video_add_help"
            }];
        }


        function selectThemes(test, themeModel) {

            $rootScope.empMediaVideoForm.themes = [];
            var themes = [];

            var canalTheme = [];
            angular.forEach(themeModel, function (value) {
                themes.push(value.substring(value.indexOf('-') + 1, value.length));
                canalTheme.push(value);
            });
            vm.theme=canalTheme;
            $rootScope.empMediaVideoForm.themes = themes;
            vm.setSelectedThumbs();
            if (angular.isDefined(vm.selectedThumbs[0]) && vm.imageFrom === 'theme') {
                vm.videoThumb = vm.selectedThumbs[0];
              $rootScope.videoThumb = vm.selectedThumbs[0];
                $rootScope.empMediaVideoForm.logo = vm.selectedThumbs[0];
            } else if (vm.imageFrom === 'theme') {
                vm.videoThumb = vm.generatedThumbs[0];
              $rootScope.videoThumb = vm.generatedThumbs[0];

                $rootScope.empMediaVideoForm.logo = vm.generatedThumbs[0];
            }

        }
        vm.imageName = "";
        vm.uploadingInPogress = 0;
        vm.selectedThumbs = [];
        vm.setSelectedThumbs = setSelectedThumbs;
        // vm.productImageStyle = {
        //     width: "100px",
        //     height: "100px",
        //     "max-height": "100px"
        // };
        // vm.innerThumbStyle = {
        //     position: 'relative',
        //     width: '200px',
        //     height: '200px',
        //     border: '1px solid rgba(0, 0, 0, 0.12)',
        //     margin: '8px'
        // };
        vm.setAndPreviewThumb = setAndPreviewThumb;
        var loadingGeneratedThumbs = 0;
        var errorOnGettingGeneratedThumbs = 0;
        vm.generatedThumbs = [];
        var generatedThumbs = [];
        vm.regenerateThumbs = regenerateThumbs;
        var requestNumber = 0;
        var numberofGeneratedThumbs = 3;
        vm.clickVignette = clickVignette;
        vm.showCondtionTerms = showCondtionTerms;
        $rootScope.idChannel = "";
        function clickVignette() {
            vm.imageFrom = null;
        }

        function requestThumbs() {
            loadingGeneratedThumbs = 1;
            errorOnGettingGeneratedThumbs = 0;
            requestNumber = 0;
            // var duration = videoMetaData.metaData.all.data.contentJson.format.duration;
            // switch (true) {
            //   case (duration <= 300):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 300 && duration <= 600):
            //     numberofGeneratedThumbs = 4;
            //     break;
            //   case (duration > 600 && duration <= 900):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   case (duration > 900 && duration <= 1200):
            //     numberofGeneratedThumbs = 3;
            //     break;
            //   default:
            //     numberofGeneratedThumbs = 3;
            //     break;
            //
            // }

            if (angular.isDefined($rootScope.empMediaVideoForm.validity)) $rootScope.empMediaVideoForm.validity = null;
            // for (var i = 0; i < numberofGeneratedThumbs; i++) {
            getGeneratedThumbs(numberofGeneratedThumbs);
            // }
        }

        function regenerateThumbs() {
            getGeneratedThumbs(1);
        }

        function getGeneratedThumbs(nbr) {
            if (angular.isUndefined(nbr)) nbr = 0;
          vm.generatingMultiThumbs=true

          var requestData = {"fileName": $stateParams.title};
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            if (nbr) requestData.count = nbr;
            if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
            msApi.request('media_video.getGeneratedThumbs@get',
                requestData,
                function (res) {
                    requestNumber++;
                    if (res.thumbnails.length) {
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            generatedThumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                        }

                        $rootScope.empMediaVideoForm.logo = generatedThumbs[0];
                        vm.videoThumb = generatedThumbs[0];
                        $rootScope.videoThumb = generatedThumbs[0];
                    }
                    if (!nbr || requestNumber === numberofGeneratedThumbs) {
                        $timeout(function () {
                            loadingGeneratedThumbs = 0;
                            errorOnGettingGeneratedThumbs = 0;
                            $rootScope.empMediaVideoForm.validity = 1;
                        });
                    }
                    // $location.hash('v' + vm.generatedThumbs.length);
                    //
                    // // call $anchorScroll()
                    // $anchorScroll();
                  vm.generatingMultiThumbs=false
                  vm.generatedThumbs = generatedThumbs;
                },
                function () {
                    loadingGeneratedThumbs = 0;
                    errorOnGettingGeneratedThumbs = 1;
                    $rootScope.empMediaVideoForm.validity = 1;
                    vm.requestNumbe = numberofGeneratedThumbs;
                }
            );
        }

        function setSelectedThumbs() {
            vm.selectedThumbs = [];
            var selectedThumb = [];
            if (angular.isArray($rootScope.empMediaVideoForm.themes)) {
                for (var i = 0; i < $rootScope.empMediaVideoForm.themes.length; i++) {
                    if (angular.isDefined(themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]]) && themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]] !== "") selectedThumb.push(themesThumbs.thumbs[$rootScope.empMediaVideoForm.themes[i]]);
                }
                vm.selectedThumbs = selec
            }
        }

        function setAndPreviewThumb(thumb, choix) {

            if (choix === 'theme'){
              vm.empMediaVideoForm.logo = thumb.split('/').pop();//.replace(rx,"");
              $rootScope.empMediaVideoForm.logo = thumb.split('/').pop();//.replace(rx,"");
            }
            else{
              vm.empMediaVideoForm.logo = thumb;//.replace(rx,"");
              $rootScope.empMediaVideoForm.logo = thumb;//.replace(rx,"");
            }
            vm.videoThumb = thumb;
            $rootScope.videoThumb = thumb;
        }

        /**
         * File added callback
         * Triggers when files added to the uploader
         *
         * @param file
         */
        function fileAdded(file) {
            if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
                return false;
            }
            if (file.size > 1024000) {
                vm.imageName = false;
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_image_too_large_message'));
                return false;
            }
            vm.imageName = file.name;

        }

        /**
         * Upload
         * Automatically triggers when files added to the uploader
         */
        function uploadFile() {
            // Set headers
            vm.ngFlow.flow.upload();
            vm.inProgress = true;
        }

        /**
         * File upload success callback
         * Triggers when single upload completed
         *
         * @param file
         * @param message
         */
        function fileSuccess(file, message) {
            vm.uploadingInPogress = 0;
            var res = angular.fromJson(message);
            if (res.location.url) {
                $rootScope.empMediaVideoForm.logo = res.location.url;
                vm.videoThumb = res.location.url;
              $rootScope.videoThumb = res.location.url;
            }

        }

        function fileError() {
            vm.uploadingInPogress = 0;
            vm.imageName = "";
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
        }

        /**
         * File Upload complete callback
         * triggers when upload operation : succes or error or not valid
         */
        function uploadComplete() {
            if (vm.imageName) {
                webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}));
            }

        }


        /**
         * End Ng Flow
         */


        if (!vm.isMultiUpload)
            fillData();
        else {
            if (angular.isDefined($rootScope.files)) {
                fillDataMultiUpload();
                getGeneratedThumbsMultiUpload();
            } else $state.go('app.media_video_upload');
        }

        function getPlayerLink() {
            msApi.request(
                'media_video.getPreviewLinkByTitle@get',
                {"title": $stateParams.title, "y": "bo", "subFolder": $stateParams.subFolder},
                function (res) {
                    if (res.code === 200) {
                        vm.showPlayer = 1;
                        vm.playerIsLoading = 0;
                        vm.playerLink = $sce.trustAsResourceUrl(res.link);
                    } else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {
            });
        }

        function splitKeyWords(chain) {
            var words = chain.split(' ') || [];
            words = words.filter(function (item, pos) {
                return words.indexOf(item) === pos;
            });
            return words;
        }

        function testMp4(codecVideo) {
            if ((/\.mp4$/.test($stateParams.title)) && (!/mpeg4/.test(codecVideo))) {
                vm.playerIsLoading = 1;
                getPlayerLink()
            } else requestThumbs();

        }

        function testFlv() {
            if (/\.flv$/.test($stateParams.title) || /\.webm$/.test($stateParams.title)) {
                vm.playerIsLoading = 1;
                getPlayerLink()
            } else requestThumbs();

        }

        function fillData() {
            if (videoMetaData.format && videoMetaData.streams && videoMetaData.format.duration) {
                var codecVideo = angular.isDefined(videoMetaData.streams[0]["codec_long_name"]) ? videoMetaData.streams[0]["codec_long_name"] : videoMetaData.streams[0]["codec_name"];
                var title = $stateParams.title;

                // title = title.substring(0, title.lastIndexOf("-"));
                // title = title.substring(0, title.lastIndexOf("-"));
                // for (var i = 0; i < $stateParams.title.length; i++) {
                //
                //     title = title.replace("_", " ");
                //     title = title.replace("-", " ");
                //
                // }
                var is_360;

                try {
                    if (angular.isDefined(videoMetaData.streams[0]["display_aspect_ratio"])) {
                        if (videoMetaData.streams[0]["display_aspect_ratio"] === "2:1") {
                            is_360 = 1;
                        } else {
                            is_360 = 0;
                        }
                    } else {
                        is_360 = 0;
                    }
                } catch (e) {
                    is_360 = 0;
                    console.log('videoMetaData.metaData.all.data', e)
                }

                if (angular.isDefined(videoMetaData.format.tags) && videoMetaData.format.tags && angular.isDefined(videoMetaData.format.tags.copyright)){
                    var copyright = videoMetaData.format.tags.copyright;
                }else{
                    var copyright = "";
                }
                if (angular.isDefined(videoMetaData.format.tags) && videoMetaData.format.tags && angular.isDefined(videoMetaData.format.tags.artist)){
                    var author = videoMetaData.format.tags.artist;
                }else{
                    var author = "";
                }
                if (angular.isDefined(videoMetaData.format.tags) && videoMetaData.format.tags &&  angular.isDefined(videoMetaData.format.tags.title) && videoMetaData.format.tags.title){
                    var titleForm = videoMetaData.format.tags.title;
                }else{
                    var titleForm = title;
                }
                $rootScope.empMediaVideoForm = {
                    "fileTitle": $stateParams.title,
                    "subFolder": $stateParams.subFolder,
                    "hashSource": $stateParams.hashSource,
                    "title": titleForm,
                    "generateMultipleFormats": videoData.generateMultipleFormats ? 1 : 0,
                    "insertDate": new Date(t1.format('YYYY-MM-DD HH:mm:ss')),
                    "startDate": new Date(t1.format('YYYY-MM-DD')),
                    "endDate": new Date(moment().add(10, "years").format('YYYY-MM-DD')),
                    "duration": new Date(moment.utc(videoMetaData.format.duration * 1000).format('YYYY-MM-DDTHH:mm:ss.SSS')),
                    "themes": [],
                    "secure": videoData.secure ? 1 : 0,
                    "downloadable": videoData.downloadable ? 1 : 0,
                    "offline": videoData.offline ? 1 : 0,
                    "description": null,
                    "transcription": null,
                    "logoIncrusted": videoData.logoIncrusted ? 1 : 0,
                    "contributor": user.id,
                    "author": author,
                    "copyright": copyright,
                    "keyWords": [],
                    "isSecuredOnInternet": videoData.isSecuredOnInternet ? 1 : 0,
                    "isVisibleOnInternet": videoData.isVisibleOnInternet,
                    "passwordInternet": null,
                    "logo": vm.generatedThumbs[0],
                    "mainPage": videoData.mainPage ? 1 : 0,
                    "metaData": angular.toJson({"contentJson" : videoMetaData}),
                    "mdTime": {
                        start: new Date(t1.format('YYYY-MM-DD')),
                        end: new Date(moment().add(10, "years").format('YYYY-MM-DD'))
                    },
                    "is_360": is_360,
                    'validity': null,
                    'channels': []
                };
                // $rootScope.empMediaVideoForm.title=vm.srcImgBig.replace("-", " ").replace("_", " ");
                //vm.srcImgBig.replace("[login]", vm.login).replace("[password]", vm.password)
                //   vm.minDate = $rootScope.empMediaVideoForm.mdTime.start;
                if (vm.testMultiLangue === '1') {
                    vm.language = $translate.preferredLanguage();

                }
                testMp4(codecVideo);
                testFlv();
            } else {
                $rootScope.uploadMetaDataError = true;
                $rootScope.index = 0;
                $state.go('app.media_video_upload');
            }
        }

        function fillDataMultiUpload() {
        }

        function getGeneratedThumbsMultiUpload() {
            var requestData = {"fileName": $rootScope.files[0]};
            var url_thumbnails_video_piper = webTvGlobal.$constant().webTvParameterBag().url_thumbnails_video_piper;
            if ($stateParams.subFolder) requestData.subFolder = $stateParams.subFolder;
            msApi.request('media_video.getGeneratedThumbs@get',
                requestData,
                function (res) {
                    requestNumber++;
                    if (res.thumbnails.length) {
                        for (var i = 0; i < res.thumbnails.length; i++) {
                            generatedThumbs.push(url_thumbnails_video_piper + res.thumbnails[i]);
                        }
                        $rootScope.empMediaVideoForm.logo = generatedThumbs[0];
                        vm.videoThumb = generatedThumbs[0];
                      $rootScope.videoThumb = generatedThumbs[0];
                    }

                },
                function () {
                    loadingGeneratedThumbs = 0;
                    errorOnGettingGeneratedThumbs = 1;
                    $rootScope.empMediaVideoForm.validity = 1;
                    vm.requestNumbe = numberofGeneratedThumbs;
                }
            );
            vm.generatedThumbs = generatedThumbs;
        }


        // function setNone() {
        //     if (!$rootScope.empMediaVideoForm.useTheme) $rootScope.empMediaVideoForm.themes = [];
        // }

        function setEmptyPassword() {
            if (!$rootScope.empMediaVideoForm.isSecuredOnInternet) $rootScope.empMediaVideoForm.passwordInternet = null;
        }

        // /**
        //  * Return Imported Video Title if exists
        //  * @return string title
        //  */
        // function getTitle() {
        //     return $rootScope.empMediaVideoForm.title || "";
        // }

        /**
         * set The selected in the form appropriate field
         * @param copyFrom  from where
         * @param pasteIn to whom the date will be setted
         */
        function changeDate(copyFrom, pasteIn) {
            if (angular.isDefined($rootScope.empMediaVideoForm[pasteIn]) && angular.isDefined($rootScope.empMediaVideoForm.mdTime[copyFrom])) $rootScope.empMediaVideoForm[pasteIn] = $rootScope.empMediaVideoForm.mdTime[copyFrom];
        }

        /**
         *
         * @param  {[type]} formData [description]
         * @return {[type]}          [description]
         */
        function preapreFormDataToSend(formData) {
            var formFormattedData = formData;
            if (angular.isDefined(formFormattedData.mdTime)) delete formFormattedData.mdTime;
            /**
             * convert null to empty string loop
             */
            for (var attr in formFormattedData) {
                if (formFormattedData[attr] === null || formFormattedData[attr] === false) formFormattedData[attr] = "";
                if (formFormattedData[attr] === 1) formFormattedData[attr] = true;
                if (formFormattedData[attr] === 0) formFormattedData[attr] = false;

            }
            if (formFormattedData.contributor === "0") formFormattedData.contributor = null;

            formFormattedData.keyWords = angular.isFunction(formFormattedData.keyWords.join) ? formFormattedData.keyWords.join(' ') : "none";
            return formFormattedData;
        }

        function cleanArray(array) {
            var i, j, len = array.length, out = [], obj = {};
            for (i = 0; i < len; i++) {
                obj[array[i]] = 0;
            }
            for (j in obj) {
                out.push(j);
            }
            return out;
        }

        function showCondtionTerms(ev) {
            if (testCondition === "1") {
                if ($cookies.get('WEBTV.locale') === "fr") {
                    vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_fr
                } else {
                    vm.text = webTvGlobal.$constant().webTvParameterBag().video_general_condition_text_en

                }
                $mdDialog.show({
                    controller: conditionsTermsController,
                    templateUrl: 'app/main/media/video/condition-terms.modal.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true
                    // fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
                })
                    .then(function (answer) {

                    }, function () {

                    })
            } else {
                vm.submitAddMediaVideoForm();

            }
        }

        function conditionsTermsController($scope, $mdDialog) {
            $scope.text = vm.text;
            $scope.cancel = function () {
                $mdDialog.hide();
            };
            $scope.accept = function () {
                $mdDialog.hide();
                vm.submitAddMediaVideoForm();
            };
        }

        vm.selectChip = selectChip;
        vm.deleteAddedChip = deleteAddedChip;

        function deleteAddedChip(chip) {
            vm.filesChips.splice(vm.filesChips.indexOf(chip), 1);

        }

        function selectChip(chip) {
            window.open(filesUrl[vm.filesChips.indexOf(chip)], '_blank');
        }

        vm.testExtension = testExtension;

        function testExtension(file) {
            var extn = file.split(".").pop();
            if (/(flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb|webm)$/i.test(extn.toLowerCase())) {
                return "video";
            } else if (/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac)$/i.test(extn.toLowerCase())) {
                return "audio";
            } else if (/(csv|xls|xlsx)$/i.test(extn.toLowerCase())) {
                return "excel";
            } else if (/(doc|docx)$/i.test(extn.toLowerCase())) {
                return "word";
            } else if (/(jpg|jpeg|png|gif)$/i.test(extn.toLowerCase())) {
                return "image";
            } else if (/(pdf)$/i.test(extn.toLowerCase())) {
                return "pdf";
            } else
                return "other";


        }

        /**
         * Send add Video Form
         */
        function submitAddMediaVideoForm() {
          console.log("submitAddMediaVideoForm multiple")
          angular.forEach(vm.filesChips, function (value, index) {
            tabFiles.push({
              "title": filesChips[index],
              "fileName": value,
              "fileTitle": vm.imageNameTranscription,
            });
          });
          // Push transcription File
          tabFiles.push({
            "title": fileChipsTranscription.pop(),
            "fileName": vm.imageNameTranscription,
            "mimeType": vm.imageNameTranscription ? "transcription" : ""
          });
            var isIE = /*@cc_on!@*/false || !!document.documentMode;
            if (isIE) {
                $rootScope.empMediaVideoForm.insertDate = t1.format('YYYY-MM-DD HH:mm:ss')
            }
            var formData = preapreFormDataToSend(angular.copy($rootScope.empMediaVideoForm));
            formData.themes = cleanArray($rootScope.empMediaVideoForm.themes);
            if($rootScope.empMediaVideoForm.themes.length<=0) {
                formData.mainPage = false;
            }
            formData.filesVideo = tabFiles;
            if (formData.title === " ") {
                $rootScope.empMediaVideoForm.title = "";
                formData.title = "";
            }
            var channels = [];
            angular.forEach(formData.channels, function (value, key) {
                if (angular.isDefined(value)) {
                    channels.push({
                        "id": key,
                        "title": value["title"],
                        "description": value["description"],
                        "defaut": value["defaut"]
                    });
                    if (value["defaut"]) {
                        formData.title = value["title"];
                        formData.description = value["description"];
                    }

                }
            });
            formData.channels = channels;
            formData.medias = [];
            formData.medias.push({lang: vm.language});
            // if (formData.isVisibleOnIntranet === "") delete formData.isVisibleOnIntranet;
            // if (formData.isVisibleOnInternet === "") delete formData.isVisibleOnInternet;
            formData.isVisibleOnInternet = vm.empMediaVideoForm.isVisibleOnInternet
            formData.isVisibleOnIntranet = vm.empMediaVideoForm.isVisibleOnIntranet
            if (angular.isDefined(formData.validity)) delete formData.validity;

            var requestForm = {"empMediaVideoForm": formData, 'sendPushNotif': vm.sendPushNotifications};
            if(angular.isDefined($stateParams.id)){
                var api_submit_form = "media_video.editVideo@save";
                requestForm.id = $stateParams.id;
                requestForm.secondStep = true;
            }else {
                var api_submit_form = "media_video.addVideo@save";
            }

          if(vm.empMediaVideoForm.isVisibleOnInternet === false && vm.empMediaVideoForm.isVisibleOnIntranet === undefined){
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_diffusion'));
          }
          if(vm.empMediaVideoForm.isVisibleOnInternet === true || vm.empMediaVideoForm.isVisibleOnIntranet === true){
            msApi.request(api_submit_form,
                requestForm,
                function (res) {
                    if (res.code === 200) {
                        webTvGlobal.$flashMessages().set('MediaVideoAdd', {title: $rootScope.empMediaVideoForm.title ? $rootScope.empMediaVideoForm.title : "VID"});
                        $rootScope.isUploading = false;
                        var type_state_go = "ongoing";
                        if(formData.offline){
                            type_state_go = "offline";
                        }else {
                            var startDate = formData.startDate;
                            var endDate = formData.endDate;
                            var now = new Date(moment().format('YYYY-MM-DD HH:mm:ss'));
                            if (startDate > now) {
                                type_state_go = "upcoming";
                            }
                            if (endDate < now) {
                                type_state_go = "archived";
                            }
                        }
                        if(vm.isMultiUploadVod) {
                            if ($rootScope.uploader_queue.length > 0) {
                                $rootScope.addedMultiUpload = true;
                                $state.go('app.media_video_upload');
                            } else {
                                $rootScope.addedMultiUpload = false;
                                $state.go('app.media_video_list', {type: type_state_go});
                            }
                        }else{
                            $state.go('app.media_video_list', {type: type_state_go});
                        }
                    } else if (angular.isDefined(res.errors)) {

                        vm.empMediaVideoError = [];
                        vm.errors = res.errors;
                        vm.errors.forEach(function (item) {

                            $rootScope.empMediaVideoForm[item.for] = {
                                message: item.messages[0],
                                value_old: angular.copy($rootScope.empMediaVideoForm[item.for])
                            };
                        });


                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );}
        }

        function returnToList() {
            if(vm.isMultiUploadVod) {
                if ($rootScope.uploader_queue.length > 0) {
                    $rootScope.addedMultiUpload = true;
                    $state.go('app.media_video_upload');
                } else {
                    $rootScope.addedMultiUpload = false;
                    $state.go('app.media_video_list', {type: "ongoing"});
                }
            }else {
                $state.go('app.media_video_list', {type: "ongoing"});
            }
        }

        /**
         * Open Imported Video Detail dialog
         * @param event
         */
        function showVideoDetail(event) {
            $mdDialog.show({
                controller: 'mediaVideoMetaModalController',
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/list/modal.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    metaData: videoMetaData,
                    mdDialogTitle: $rootScope.empMediaVideoForm.title ? $rootScope.empMediaVideoForm.title : (videoMetaData.metaData.basic.data.title ? videoMetaData.metaData.basic.data.title : $rootScope.empMediaVideoForm.fileTitle)

                }
            });
        }

        if (navigator.userAgent.indexOf('MSIE') !== -1 ||
            navigator.appVersion.indexOf('Trident/') > -1) {
            setTimeout(function () {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style', 'display: flex; position: relative;min-height:' + player_add.offsetHeight + 'px !important');
                imgWrapper.style.height = image.offsetHeight + 'px';
            }, 5000);
            window.onresize = function (event) {
                var player_add = document.querySelector('#player_add');
                var image = document.querySelector('#IE-div-vignettes img');
                var ie_exception = document.querySelector('.ie-exception-3');
                var imgWrapper = document.querySelector('#IE-div-vignettes .img-wrapper');
                ie_exception.setAttribute('style', 'display: flex; position: relative;min-height:' + player_add.offsetHeight + 'px !important');
                imgWrapper.style.height = image.offsetHeight + 'px';
            }
        }
        vm.existDefault = true;
        vm.changeDefaultChannel = changeDefaultChannel;

        function changeDefaultChannel(id) {
            if ($rootScope.empMediaVideoForm.channels[id].defaut === true) {
                vm.existDefault = true;
                var title = $stateParams.title;

                title = title.substring(0, title.lastIndexOf("-"));
                title = title.substring(0, title.lastIndexOf("-"));
                for (var i = 0; i < $stateParams.title.length; i++) {

                    title = title.replace("_", " ");
                    title = title.replace("-", " ");

                }
                $rootScope.empMediaVideoForm.channels[id].title = title;
                angular.forEach($rootScope.empMediaVideoForm.channels, function (value, key) {
                    if (angular.isDefined(value)) {
                        if (key !== id) {
                            $rootScope.empMediaVideoForm.channels[key].defaut = false;
                        }
                    }
                });
            }
        }
        vm.changeTitle = changeTitle;

        function changeTitle(id) {
            $rootScope.empMediaVideoForm.channels[id].changedTitle = true;
        }

        vm.allChannels = [];
        vm.selectChannels = selectChannels;

        function selectChannels() {
            if(vm.allChannels.length === 0){
                vm.allChannels = vm.channels;
                for(var i=0;i<vm.allChannels.length;i++){
                    vm.allChannels[i].add = true;
                }
            }
            var title = $stateParams.title;

            title = title.substring(0, title.lastIndexOf("-"));
            title = title.substring(0, title.lastIndexOf("-"));
            for (i = 0; i < $stateParams.title.length; i++) {

                title = title.replace("_", " ");
                title = title.replace("-", " ");

            }
            title = videoMetaData.metaData.basic.data.title ? videoMetaData.metaData.basic.data.title : title;
            $mdDialog.show({
                controller: "selectChannelsController",
                controllerAs: 'vm',
                templateUrl: 'app/main/media/video/channel.template.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    channels: vm.allChannels,
                    title: title
                }
            }).then(function () {
            }, function () {
            });
        }
    }
    function selectChannelsController($rootScope, $mdDialog,channels,title) {
        var vm = this;
        var selectedChannels = [];
        angular.forEach($rootScope.videoSelectedChannels, function (value) {
            selectedChannels.push(value);
        });
        vm.allChannels = channels;
        vm.closeDialog = closeDialog;

        function closeDialog() {
            $mdDialog.hide();
        }
        vm.validate = validate;

        function validate() {
            $rootScope.videoSelectedChannels = selectedChannels;
            if($rootScope.videoSelectedChannels.length > 0){
                $rootScope.idChannel = $rootScope.videoSelectedChannels[0].val;
                if (!angular.isDefined($rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val])) {
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val] = {};
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val].title = title;
                }
                $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[0].val].defaut = true;
                for(var i = 1; i <$rootScope.videoSelectedChannels.length; i++){
                    if (!angular.isDefined($rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val])) {
                        $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val] = {};
                        $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].title = title;
                    }
                    $rootScope.empMediaVideoForm.channels[$rootScope.videoSelectedChannels[i].val].defaut = false;
                }
            }
            $mdDialog.hide();
        }

        vm.removeChannel = removeChannel;

        function removeChannel(channel) {
            var index = selectedChannels.indexOf(channel);
            if(index !== -1){
                selectedChannels.splice(index, 1);
                channel.add = true;
            }
        }

        vm.addChannel = addChannel;

        function addChannel(channel) {
            channel.add = false;
            selectedChannels.push(channel);
        }
    }

})();


angular.module('app.media.video.list')

    .directive('actionButtonVideo', function () {
        return {
            scope: {
                video: '=video',
                handler: '='
            },
            restrict: 'E',
            replace: false,
            controller: function ($scope, $rootScope, $state, webTvGlobal, msApi, $translate, $mdDialog) {
                function openMenu($mdOpenMenu, ev) {
                    $mdOpenMenu(ev);
                }

                function editVideo(video) {
                    $rootScope.currentState = $state.current.name;
                    if (video.externalLinkVideo) {
                        $state.go('app.media_video_edit_external', {id: video.id});
                    }
                    else {
                        $state.go('app.media_video_edit', {id: video.id});
                    }
                }

                function addSubscribers(video) {
                    $rootScope.loadingProgress = true;
                    msApi.request('media_video_list_subscribers.getVideoSubscribers@get', {id: video.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            $mdDialog.show({
                                locals: {
                                    video: video,
                                    subscribersList: response.data.users,
                                    videoSubscribers: response.data.subscriptionUsers
                                },
                                templateUrl: 'app/main/media/video/abonnement/add.remove.subscribers.html',
                                clickOutsideToClose: true,
                                controller: "addRemoveSubscribersController",
                                controllerAs: "vm",
                                fullscreen: true
                            }).then(function (subList) {
                                $rootScope.loadingProgress = true;
                                msApi.request('media_video_list_subscribers.addVideoSubscribers@get', {
                                        id: video.id, list: (function (list) {
                                            subList.forEach(function (item) {
                                                list.push(item);
                                            });
                                            return list;
                                        })([])
                                    },
                                    function (response) {
                                        $rootScope.loadingProgress = false;
                                        webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.alert_edit_confirm"));
                                    },
                                    function (response) {
                                        $rootScope.loadingProgress = false;
                                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                                webTvGlobal.alertDialog(message);
                                            }, function () {
                                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                            });
                                        }
                                        else {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                        }
                                    });


                            })
                        },
                        function (response) {

                            $rootScope.loadingProgress = false;
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }
                        })

                }

                function downloadVideo(video) {

                    var ua = navigator.userAgent;

                    msApi.request('media_video.download@get', {id: video}, function (response) {


                        if (response.data.exist) {

                            if (ua.indexOf('Firefox') !== -1) {
                                var popup = $window.open('', '_blank');
                                popup.location.href = response.data.file;
                            }

                            else
                                window.location.href = response.data.file;

                        }
                        else {
                            $translate([
                                "VIDEOLIST.dialog_download_error_title",
                                "VIDEOLIST.dialog_download_error_text"
                            ])
                                .then(function (translatedValues) {
                                    $mdDialog.show(
                                        $mdDialog.alert()
                                            .clickOutsideToClose(true)
                                            .title(translatedValues['VIDEOLIST.dialog_download_error_title'])
                                            .textContent(translatedValues['VIDEOLIST.dialog_download_error_text'])
                                            .ok('OK')
                                    );
                                });
                        }

                    }, function (error) {
                        if (error.data === null) {
                            webTvGlobal.alertDialog($translate.instant('VIDEOLIST.video_not_found'));
                        }
                    });


                }

                // Todo Faiez
                /**
                 * stats per video
                 * @param   video
                 */
                function statsPerVideo(video) {
                    $rootScope.name_state_parent = angular.isDefined($state.current.name) ? $state.current.name : 'app.media_video_list_ongoing';
                    $state.go('app.stats_vod_by_id.audience', {id: video.id});
                }

                /**
                 * Open Imported Video Detail dialog
                 * @param video
                 * @param $event
                 */
                function showVideoDetail(video) {
                    msApi.request(
                        'media_video.getTransodedMetaData@get',
                        {id: video.id},
                        function (res) {
                            var meta = {
                                format: angular.isDefined(res.metaData.data.contentJson.format) ? res.metaData.data.contentJson.format : "",
                                streams: angular.isDefined(res.metaData.data.contentJson.streams) ? res.metaData.data.contentJson.streams : "",
                                other: video
                            };
                            $mdDialog.show({
                                controller: 'mediaVideoMetaModalController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/media/video/list/modal.template.html',
                                clickOutsideToClose: true,
                                locals: {
                                    metaData: meta,
                                    mdDialogTitle: video.title
                                }
                            }).then(function () {
                                // $rootScope.$broadcast('VideoList::setInactive');
                            }, function () {
                                // $rootScope.$broadcast('VideoList::setInactive');
                            });
                        }, function (response) {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }
                        }
                    ).then(function () {
                    });
                }

                function chronologieVideo(video, event) {
                    $mdDialog.show({
                        controller: "chronologieController",
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/list/chronologie.modal.template.html',
                        targetEvent: event,
                        clickOutsideToClose: true,
                        locals: {
                            video: video
                        }
                    }).then(function () {
                        // $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        // $rootScope.$broadcast('VideoList::setInactive');
                    });
                }

                /**
                 * export video
                 * @param   video
                 * @param   ev
                 */
                function exportVideo(video) {
                    debugger;
                    var lang = "";
                    if (angular.isDefined(video.medias[0])) {
                        lang = video.medias[0].lang;
                    }
                    msApi.request(
                        'media_video.getUrlExport@get',
                        {id: video.id, lang: lang},
                        function (res) {
                            $mdDialog.show({
                                controller: 'mediaVideoUrlModalController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/media/video/list/url.modale.template.html',
                                clickOutsideToClose: true,
                                locals: {
                                    video: res.video,
                                    id: video.id
                                }
                            }).then(function () {
                                // $rootScope.$broadcast('VideoList::setInactive');
                            }, function () {
                                // $rootScope.$broadcast('VideoList::setInactive');
                            });
                        }, function (response) {
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }
                        }
                    ).then(function () {
                    });
                }

                function showLess() {
                    var element = document.querySelector('.show_more');
                    if (element) {
                        element.classList.remove('show_more')
                    }
                }

                function showMore(id) {
                    showLess();
                    var element = document.querySelector('.small_td_' + id);
                    if (element) {
                        element.classList.add('show_more')
                    }
                }

                function responsesVideo(video) {
                    $rootScope.currentState = $state.current.name;
                    $state.go('app.media_video_questions_quiz.questions', {id: video.id});
                }

                function transcription(trans, id) {
                    if (trans)
                        msApi.request(
                            'media_video.transcription@get',
                            {
                                id_video: id,
                                is_correction: "1"
                            },
                            function (res) {
                                if (res.code === 200) {
                                    $scope.video.refTranscription = true;
                                }

                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            });
                    else msApi.request(
                        'media_video.transcription@get',
                        {
                            id_video: id
                        },
                        function (res) {
                            if (res.code === 200) {
                                $scope.video.refTranscription = true;
                            }
                            // $state.go("app.media_video_caption_new", {id: id});

                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        });


                }

                $scope.testTranscription = webTvGlobal.$constant().webTvParameterBag().use_transcription_authot;
                $scope.editVideo = editVideo;
                $scope.openMenu = openMenu;
                $scope.statsPerVideo = statsPerVideo;
                $scope.downloadVideo = downloadVideo;
                $scope.showVideoDetail = showVideoDetail;
                $scope.chronologieVideo = chronologieVideo;
                $scope.addSubscribers = addSubscribers;
                $scope.exportVideo = exportVideo;
                $scope.showLess = showLess;
                $scope.showMore = showMore;
                $scope.responsesVideo = responsesVideo;
                $scope.transcription = transcription;
            },
            templateUrl: 'app/main/media/video/action_button/actions_button.html'
        };
    });

(function () {
    'use strict';

    angular
        .module('app.media.video.email', [])
        .config(config);

    /** @ngInject */
    function config(msApiProvider) {

        // Translation
        msApiProvider.register('media_video.send_vid_by_mail', [Routing.generate('api_media_send_video_by_mail', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.send_vid_by_mail_to_subscribers', [Routing.generate('api_media_send_video_to_subscription_users', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('media_video.get_subscription_group_by_group', [Routing.generate('api_subscription_group_get_subscription_group_by_group')]);



    }
})();
/**
 * Created by Mohammad on 10/11/2017.
 */
angular.module('app.media.video.email')
    .directive("collection", function ($compile) {
        return {
            replace: true,
            scope: {
                collection: '='
            },
            restrict: "E",
            link: function (scope, element) {
                var i = 1;
                var htmSubscriptionGroup = "<md-option value='all' translate='MESSAGES.select_all' >   </md-option>";
                var sousGroupe = function (value, index) {
                    if (angular.isArray(value.subscriptionGroups)) {
                        index = index + 1;
                        var val = value.id;
                        htmSubscriptionGroup += "<md-option value=" + val + " >" + value.name + "</md-option>";
                        angular.forEach(value.subscriptionGroups, function (value) {
                            sousGroupe(value, index);
                        });
                    }

                };
                angular.forEach(scope.collection, function (value) {
                    sousGroupe(value, 1);
                    if (i === Object.keys(scope.collection).length) {
                        element.append(htmSubscriptionGroup);
                        $compile(element.contents())(scope);
                    }
                    i++;
                });


            }
        };
    });

(function () {

  'use strict';

  angular
    .module('app.media.video.email')
    .controller('sendMailController', sendMailController);

  function sendMailController($scope, $mdDialog, msApi, $translate, webTvGlobal, id, $rootScope, lang) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;

      vm.email=[];
      vm.invalidEmailBtn = true;
      vm.groupId = "";
      msApi.request('media_video.get_subscription_group_by_group@get', function (res) {
          vm.subscriptionGroups = res.subscriptionGroups;
      });

      vm.labelEmails = "VIDEOLIST.envoyer_mail_video";
      var isMailValidation = 0;
      if(angular.isDefined(webTvGlobal.$constant().webTvParameterBag().export_mail_video) && webTvGlobal.$constant().webTvParameterBag().export_mail_video==="validation"){
          vm.labelEmails = "VIDEOLIST.envoyer_mail";
          isMailValidation = 1;
      }


    vm.searchFlight = {
      email: 'Auto'
    };

    vm.closeDialog = closeDialog;
    vm.sendVideoByMail = sendVideoByMail;

    function closeDialog() {
      $mdDialog.hide();

    }
    vm.validateEmail=validateEmail;
    function validateEmail(emails) {



        // for (var i = 0; i < emails.length; i++) {
            var reg = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/;
            if (!reg.test(emails[emails.length-1])) {


                emails.splice(emails.length-1, 1);
                vm.invalidEmail = true;
            }
            else {
                vm.invalidEmail = false;
                if(emails.length==1) {
                    vm.invalidEmailBtn = false;
                }
            }
        // }

    }
    function enableSubmitButton(){
      if(vm.invalidEmailBtn)
      {
        vm.invalidEmailBtn = false;
      }
    }

    vm.enableSubmitButton = enableSubmitButton;
    function sendVideoByMail() {

      $rootScope.loadingProgress = true;
      if (vm.searchFlight.email === "Auto") {
        msApi.request('media_video.send_vid_by_mail@get', {id: id, mails: [vm.email], langCanal: lang, isMailValidation:isMailValidation},
          function (response) {
            $rootScope.loadingProgress = false;

            if (response.code === 200) {
              webTvGlobal.$toast().showSimple($translate.instant('VIDEOLIST.dialog_alert_send_video_description'));

              $mdDialog.hide();
            } else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              });
            }
            else {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
          }
        );
      }
      else {
        var request = {
          id: id,
          groupId: vm.groupId,
          langCanal: lang,
          isMailValidation:isMailValidation
        }
        if(vm.groupId === "all"){
          request.groupId = "";
        }

        msApi.request('media_video.send_vid_by_mail_to_subscribers@get', request,
          function (response) {
            $rootScope.loadingProgress = false;

            if (response.code === 200) {
              if (response.message === "no_subscriptionUser_was_found") {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.no_subscriptionUser_was_found'));
              }
              else
                webTvGlobal.$toast().showSimple($translate.instant('VIDEOLIST.dialog_alert_send_video_description'));

              $mdDialog.hide();
            } else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              });
            }
            else {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
          }
        );
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.playlist.list', ["datatables","ngclipboard"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.playlist_list', {
                url: "/playlist/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/playlist/list/list_tab.html',
                        controller: 'playlistListTemplateController as vm'
                    }
                },
                "bodyClass": "e-commerce"
            })
            .state('app.playlist_list.simple', {
                url: "/simple",
                views: {
                    'media@app.playlist_list': {
                        templateUrl: 'app/main/media/playlist/list/list.template.html',
                        controller: 'playlistListController as vm'

                    }
                },
                resolve: {
                    PlayListData: function () {
                        return "playlist.list@get";
                    }
                }
            }).state('app.playlist_list.live', {
            url: "/live",
            views: {
                'live@app.playlist_list': {
                    templateUrl: 'app/main/media/playlist/list/list.template.html',
                    controller: 'playlistListController as vm'

                }
            },
            resolve: {
                PlayListData: function () {
                    return "playlistLive.list@get";
                }
            }
        });


        // Api
        var deleteThemeRoute = Routing.generate('api_delete_playlist') + "/:id";
        msApiProvider.register('playlist.list', [Routing.generate('api_dtable_list_dtable_playlists')]);
        msApiProvider.register('playlistLive.list', [Routing.generate('api_dtable_list_dtable_playlist_lives')]);

        msApiProvider.register('playlist.delete', [deleteThemeRoute, {id: '@id'}]);
        msApiProvider.register('playlist.modalGetPlaylist', [Routing.generate('api_get_detail_playlist', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('playlist.modalEmbedPlaylist', [Routing.generate('api_get_playlist_link', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteListplaylists = Routing.generate('api_multi_delete_multi_playlists') + "/:list";
        msApiProvider.register('playlist.deletePlaylists', [deleteListplaylists, {list: '@list'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.playlist.list')
        .controller('playlistDetailController', playlistDetailController);

    /** @ngInject */
    function playlistDetailController(playlistData, $mdDialog) {
        var vm = this;
        vm.playlist = playlistData.playlist;
        vm.url_playlist_permalien = playlistData.url_playlist_permalien;
        vm.url_playlist_embed = playlistData.url_playlist_embed;
        if (!isNaN(playlistData.maxDuration)) {
            vm.playlist.maxDuration = playlistData.maxDuration * 3600;
        }
        else {
            vm.playlist.maxDuration = 0;
        }


        vm.cancel = cancel;


        function cancel() {
            $mdDialog.hide();
        }

    }


})();

angular.module('app.media.video.list')

    .directive('accesButtonVideo', function () {
        return {
            scope: {
                video: '=video',
                selectedMenu: '=selected',
                handler: '='
            },
            restrict: 'E',
            controller: function ($window,video,$document,$rootScope,msApi,$state,VideoGlobal,$mdDialog,$translate,webTvGlobal,$scope) {
                var vm = this;
                vm.openMenu = openMenu;
                vm.editVideo = editVideo;
                vm.previewVideo =previewVideo;
                vm.downloadVideo = downloadVideo;
                vm.showVideoDetail = showVideoDetail;
                vm.chronologieVideo = chronologieVideo;
                vm.exportVideo = exportVideo;
                vm.redirectToCaption = redirectToCaption;
                vm.redirectToRichMedia = redirectToRichMedia;
                vm.redirectToMontage = redirectToMontage;
                vm.goBackBo = goBackBo;
                vm.isNavigationNew=false;
                if(video.isNew){
                  vm.isNavigationNew=true;
                }
                function previewVideo(video){
                    if (!video.isTranscoded) return;
                    var isIntranet_Internet = webTvGlobal.$constant().webTvParameterBag().intranet_internet_video;
                    VideoGlobal.showPreviewVideo({id: video.id}, event, video.isVisibleOnInternet, video.isVisibleOnIntranet, isIntranet_Internet);

                }
                function showFullEditor(){
                  var access = document.getElementById('acces');
                  var navigation = document.getElementById('vertical-navigation') || document.getElementById("horizontal-navigation");
                  var toolbar = document.getElementById('toolbar');
                  var content = document.getElementById('content');
                  var btnClose = document.getElementById('goBack');
                  var layoutMenu = document.querySelector('.menu-express-access');
                  var layout = document.querySelector('.layout-align-start-start');
                  var mdMenu = document.querySelector('button.md-access-button.md-button.ng-scope.md-default-theme') ||
                  document.querySelector('button.md-access-button.md-button.ng-scope.md-greenV2Theme-theme');
                  btnClose.classList.add("fulled")
                  navigation.classList.add('fulled')
                  toolbar.classList.add('fulled')
                  content.classList.add('fulled')
                  layoutMenu.classList.add('fulled')
                  layout.classList.add('fulled')
                  mdMenu.classList.add('fulled')
                  access.classList.add('fulled')
                }
              function  goBackBo(){
                 document.querySelectorAll('.fulled').forEach(function(el) {
                  el.classList.remove('fulled')
                     $rootScope.$broadcast('isFulled',false)
                })
              };
                function redirectToCaption(video){
                    var params = {id: video.id, preview: "caption", y: "bo"};
                    msApi.request(
                        "media_richMedia_player_new.getPreviewNewLink@get", params,
                        function (res) {
                            if (res.code === 200) {
                                var link = res.link;
                                console.log("link = "+link);
                                // $window.open(link, '_blank');
                              showFullEditor();
                              $rootScope.isFulled=true;
                              $rootScope.$broadcast('isFulled',{isFulled : true})

                            }
                            else {
                            }
                        }, function (response) {
                        }
                    );
                }
                function redirectToRichMedia(video){
                    var params = {id: video.id, isRm: 1, y: "bo"};
                    msApi.request(
                        "media_richMedia_player_new.getPreviewNewLink@get", params,
                        function (res) {
                            if (res.code === 200) {
                                var link = res.link;
                                console.log("link = "+link);
                                // $window.open(link, '_blank');
                              showFullEditor();
                                $rootScope.$broadcast('isFulled',true)
                            }
                            else {
                            }
                        }, function (response) {
                        }
                    );
                }
                function redirectToMontage(video){
                    var params = {id: video.id, isMontage: 1, y: "bo"};
                    msApi.request(
                        "modal-preview-montage-video.getMontageNewPreview@get", params,
                        function (res) {
                            if (res.code === 200) {
                                var link = res.link;
                                console.log("link = "+link);
                                // $window.open(link, '_blank');
                              showFullEditor();
                                $rootScope.$broadcast('isFulled',true)
                            }
                            else {
                            }
                        }, function (response) {
                        }
                    );

                }
                function showVideoDetail(video){
                    vm.spinner = false;

                    msApi.request(
                        'media_video.getTransodedMetaData@get',
                        {id: video.id},
                        function (res) {
                            vm.spinner = true;
                            var meta = {
                                format: angular.isDefined(res.metaData.data.contentJson.format) ? res.metaData.data.contentJson.format : "",
                                streams: angular.isDefined(res.metaData.data.contentJson.streams) ? res.metaData.data.contentJson.streams : "",
                                other: video
                            };
                            $mdDialog.show({
                                controller: 'mediaVideoMetaModalController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/media/video/list/modal.template.html',
                                clickOutsideToClose: true,
                                locals: {
                                    metaData: meta,
                                    mdDialogTitle: video.title
                                }
                            }).then(function () {
                                $rootScope.$broadcast('VideoList::setInactive');
                            }, function () {
                                $rootScope.$broadcast('VideoList::setInactive');
                            });
                        }, function (response) {
                            vm.spinner = true;
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }
                        }
                    ).then(function () {
                    });
                }
                function downloadVideo(video){
                  //  var popup = $window.open('', '_blank');
                  new Promise(function (resolve, reject) {
                      msApi.request('media_video.download@get', {id: video.id}).then(
                          function (response) {
                              resolve(response);
                          if (response.data.exist) {
                              // console.log(response)
                              //window.open(response.data.file, '_blank');
                               $window.location.href = response.data.file;
                              // $timeout(function () {
                              //     popup.close();
                              // }, 2500);
                              //

                          }
                          else {
                              $translate([
                                  "VIDEOLIST.dialog_download_error_title",
                                  "VIDEOLIST.dialog_download_error_text"
                              ])
                                  .then(function (translatedValues) {
                                      $mdDialog.show(
                                          $mdDialog.alert()
                                              .clickOutsideToClose(true)
                                              .title(translatedValues['VIDEOLIST.dialog_download_error_title'])
                                              .textContent(translatedValues['VIDEOLIST.dialog_download_error_text'])
                                              .ok('OK')
                                      );
                                  });
                          }

                      },
                          function (error) {
                          if (error.data === null) {
                              webTvGlobal.alertDialog($translate.instant('VIDEOLIST.video_not_found'));
                          }
                      });
                  })


                }
                function exportVideo(video){

                    vm.spinner = false;
                    var lang = "";
                    if (angular.isDefined(video.medias[0])) {
                        lang = video.medias[0].lang;
                    }

                    msApi.request(
                        'media_video.getUrlExport@get',
                        {id: video.id, lang: lang},
                        function (res) {
                            vm.spinner = true;
                            $mdDialog.show({
                                controller: 'mediaVideoUrlModalController',
                                controllerAs: 'vm',
                                templateUrl: 'app/main/media/video/list/url.modale.template.html',
                                clickOutsideToClose: true,
                                locals: {
                                    video: res.video,
                                    id: video.id
                                }
                            }).then(function () {
                                $rootScope.$broadcast('VideoList::setInactive');
                            }, function () {
                                $rootScope.$broadcast('VideoList::setInactive');
                            });
                        }, function (response) {
                            vm.spinner = true;
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }
                        }
                    ).then(function () {
                    });

                }
                function chronologieVideo(video){
                    $mdDialog.show({
                        controller: "chronologieController",
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/list/chronologie.modal.template.html',
                        targetEvent: event,
                        clickOutsideToClose: true,
                        locals: {
                            video: video
                        }
                    }).then(function () {
                        $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        $rootScope.$broadcast('VideoList::setInactive');
                    });
                }
                function openMenu($mdOpenMenu, ev) {
                    $mdOpenMenu(ev);
                }
                function editVideo(video)
                {
                    if (video.externalLinkVideo) {
                        $state.go('app.media_video_edit_external', {id: video.id});
                    }
                    else {
                        $state.go('app.media_video_edit', {id: video.id});
                    }

                }
            },
            controllerAs: 'vm',
            replace: false,
            link: function () {
            },
            templateUrl: 'app/main/media/video/access_button/actions_button.html'
        };
    });

(function () {
    'use strict';

    angular
        .module('app.media.video.access', [])
        .config(config);

    function config($stateProvider,msApiProvider) {

        $stateProvider
            .state('app.access_rapid', {
                url: "/medias/video/:id/:hold",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/video/accessView/template.html',
                        controller: 'mediaVideoAccessVideoController as vm'
                    }
                },
                resolve:{
                    videoData: function (msApi, $stateParams) {
                        var request = {id: $stateParams.id};
                        if($stateParams.hold ==="hold"){
                            request.secondStep = true;
                        }
                        return msApi.resolve('media_video.getData@get',request);
                    }
                }
            });
        msApiProvider.register('media_video.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);

    }

})();
(function () {
    'use strict';
    angular
        .module('app.media.video.access')
        .controller('mediaVideoAccessVideoController', mediaVideoAccessVideoController);

    function mediaVideoAccessVideoController(videoData, $injector) {
        var vm = this;
        vm.video = videoData;
        vm.hold = $injector.get('$stateParams').hold;
        vm.hold = vm.hold === 'hold' ? true: false;
    }
})();

(function () {
  angular
    .module('app.media.video.list')
    .controller('addRemoveSubscribersController', addRemoveSubscribersController);

  /** @ngInject */
  function addRemoveSubscribersController($filter, $mdDialog, subscribersList, videoSubscribers) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    var listAdd = [];
    var listRemove = [];
    var idList = [];
    vm.subscribers = subscribersList;
    vm.videoSubscribers = videoSubscribers;
    vm.cancel = cancel;
    vm.submit = submit;
    vm.addSub = addSub;
    vm.removeSub = removeSub;
    vm.checkRemoveElement = checkRemoveElement;
    vm.checkAddElement = checkAddElement;
    vm.notSubscribed = notSubscribed;
    fillData();

    function fillData() {
      vm.videoSubscribers.forEach(function (item) {
        idList.push(item.id);
      })
    }

    function notSubscribed(sub) {
      var existe = angular.isDefined($filter('filter')(vm.videoSubscribers, {id: sub.id}, true)[0]);
      return (!existe)
    }

    function removeSub() {
      listRemove.forEach(function (item) {
        var indexSub = vm.videoSubscribers.indexOf(item);
        var index = idList.indexOf(item.id);
        vm.videoSubscribers.splice(indexSub, 1);
        idList.splice(index, 1);
      });
      listRemove = [];
    }

    function addSub() {
      listAdd.forEach(function (item) {
        vm.videoSubscribers.push(item);
        idList.push(item.id);
      });
      listAdd = [];
    }

    function cancel() {
      $mdDialog.cancel();
    }

    function submit() {
      $mdDialog.hide(idList);
    }

    function checkAddElement(item) {
      listAdd = toggleElement(item, listAdd);
    }

    function checkRemoveElement(item) {
      listRemove = toggleElement(item, listRemove);
    }

    function toggleElement(item, list) {
      var idx = list.indexOf(item);
      if (idx > -1) {
        list.splice(idx, 1);
      }
      else {
        list.push(item);
      }
      return list;
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.lives.conf', ["flow"])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.lives_conf', {
                url: "/lives/conf/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/lives/conf/add_edit.template.html',
                        controller: 'liveConfAddController as vm'
                    }
                },
                resolve: {
                    liveConfData: function (msApi) {
                        return msApi.resolve('live_conf.getNewConfData@get');
                    },
                    liveConfGetVideos: function (msApi) {
                        return msApi.resolve('live_conf.getVideos@get');
                    }
                },
                "bodyClass": "forms"
            });

        //API
        msApiProvider.register('live_conf.getNewConfData', [Routing.generate('api_lives_get_lives_confd')]);
        msApiProvider.register('live_conf.addConf', [Routing.generate('api_lives_post_add_lives_conf')]);
        msApiProvider.register('live_conf.getVideos', [Routing.generate('api_media_get_transcoded_videos')]);


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api_lives)(?=.*conf).*$",
                name_module: "lives_conf",
                name_angular_module: "app.lives.conf",
                actions: [
                    {"add": ["post_add"]}

                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
  'use strict';

  angular
    .module('app.lives.conf')
    .controller('liveConfAddController', liveConfAddController);

  /** @ngInject */
  function liveConfAddController(liveConfGetVideos, msUtils, $scope, liveConfData, webTvGlobal, $injector,$cookies) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = true;
    $scope.minDate = new Date();
    vm.conf = liveConfData;
    vm.urlVignette = "";
    vm.videos = webTvGlobal.convertToSelectChoicesFormat(liveConfGetVideos.data.names);
    if (vm.conf.type === "Message") {
      vm.empLivesConfForm = {
        "type": vm.conf.type,
        "titleLive": vm.conf.titleLive,
        "descLive": vm.conf.descLive,
        "message": vm.conf.message

      };
    }
    if (vm.conf.type === "Video") {
      vm.empLivesConfForm = {
        "type": vm.conf.type,
        "titleLive": vm.conf.titleLive,
        "descLive": vm.conf.descLive,
        "video": vm.conf.video.id

      };
    }
    if (vm.conf.type === "Image") {
      vm.empLivesConfForm = {
        "type": vm.conf.type,
        "titleLive": vm.conf.titleLive,
        "descLive": vm.conf.descLive,
        "image": vm.conf.image || "",
        "imageText": vm.conf.imageText
      };
    }
    if (vm.conf.type === "Counter") {
      vm.empLivesConfForm = {
        "type": vm.conf.type,
        "titleLive": vm.conf.titleLive,
        "descLive": vm.conf.descLive
      };
    }

    vm.clearSearchTerm = clearSearchTerm;
    vm.searchTerm;

    function clearSearchTerm() {
      vm.searchTerm = '';
    }


    vm.submitAddConfForm = submitAddConfForm;


    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_post_lives_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')},
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: [{}, {}]
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.lives_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.live_conf_add_menuTitle";
      $rootScope.titre3 = "";

      $rootScope.welcome = "welcome_conf_live_add";
      $rootScope.text = [{
        texte: "parameters_live_add_help"
      }, {
        texte: "upload_button_conf_live_add_help"
      }, {
        texte: "send_button_conf_live_add_help"
      }, {
        texte: "cancel_button_conf_live_add_help"
      }];

    }

    /**
     * Send add Conf Form
     */
    function submitAddConfForm() {
      $rootScope.loadingProgress = true;
      var formData = angular.copy(vm.empLivesConfForm);
      if (vm.empLivesConfForm.type === "Message") {
        delete formData.image;
        delete formData.imageText;
        delete formData.video;
      }
      if (vm.empLivesConfForm.type === "Image") {
        delete formData.message;
        delete formData.video;
      }
      if (vm.empLivesConfForm.type === "Counter") {
        delete formData.message;
        delete formData.image;
        delete formData.imageText;
        delete formData.video;
      }
      if (vm.empLivesConfForm.type === "Video") {
        delete formData.message;
        delete formData.image;
        delete formData.imageText;

      }

      msApi.request('live_conf.addConf@save',
        {"empLivesConfForm": formData},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.conf = vm.empLivesConfForm;
            webTvGlobal.$toast().showCustom(vm.empLivesConfForm.type + ' ' + $translate.instant('CONFADD.added'));
            $state.go('app.lives_conf');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      vm.imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile(index) {
      // Set headers
      vm.ngFlow.flow[index].opts.headers = {
        'X-Requested-With': 'XMLHttpRequest'
        //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
      };

      vm.ngFlow.flow[index].upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);

      if (res.location.path) {
        vm.empLivesConfForm.image = res.location.path;
        vm.urlVignette = res.location.url;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (vm.imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empLivesConfForm button[type='submit']").removeAttr('disabled');
        angular.element("#empLivesConfForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.imageName}), '', function () {
          vm.empLivesConfForm.image = "";
        });
      }
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.playlist.edit', ['textAngular', "ui.sortable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.playlist_edit', {
                url: "/playlist/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/playlist/view_add_edit_playlist/add_edit.template.html',
                        controller: 'playlistEditController as vm'
                    }
                },
                resolve: {
                    playlistData: function (msApi, $stateParams) {
                        return msApi.resolve('playlist.getNewPlaylist@get', {id: $stateParams.id});
                    },
                    // getMediasData: function (msApi) {
                    //     return msApi.resolve('media.getMedias@get');
                    // },
                    rmboxesData: function (msApi)
                    {
                        return msApi.resolve('playlist.getRmboxes@get', {type: "Display"});
                    }
                },
                "bodyClass": "forms"
            });


        //API
        msApiProvider.register('playlist.getNewPlaylist', [Routing.generate('api_get_detail_playlist', {id: ':id'}).replace(/%3A/, ":")]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('media.getMedias', [Routing.generate('api_media_get_media')]);
        msApiProvider.register('playlist.editPlaylist', [Routing.generate('api_post_edit_playlist', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('playlist.getMediasByTheme', [Routing.generate('api_media_get_by_theme', {themeId: ':themeId'}).replace(/%3A/, ":")]);
        // msApiProvider.register('theme.themeChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
        // msApiProvider.register('theme.getNewThemeData', [Routing.generate('api_parameters_get_detail_theme', {id: ':id'}).replace(/%3A/, ":")]);


    }
})();

(function () {
  'use strict';

  angular
    .module('app.playlist.edit')
    .controller('playlistEditController', playlistEditController).directive('whenScrolledPlaylist', function () {
      return function (scope, elm, attr) {
          var raw = elm[0];
          elm.bind('scroll', function () {
              if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                  scope.$apply(attr.whenScrolledPlaylist);
              }
          });
      };
  });

  /** @ngInject */
  function playlistEditController($scope, $filter, msApi, playlistData, rmboxesData, webTvGlobal,  $injector, $mdDialog) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate');
    var vm = this;
    var indexToRemove;
    var totalDuration = 0;

    vm.isNew = false;
    vm.playlist = playlistData.playlist;
    vm.videos = [];
    vm.minDate = undefined;
    vm.minTime = undefined;
    vm.rmboxs = rmboxesData.data.rmboxs;
    vm.rmboxs = webTvGlobal.convertArrayToSelectList(vm.rmboxs);

    vm.subTitle = subTitle;
    vm.themeModel = "";
    vm.themes = [];
      vm.theme = angular.isDefined(playlistData.default_theme_playlist) &&  playlistData.default_theme_playlist ? playlistData.default_theme_playlist : "";

    vm.yesNoChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });

      vm.convertDuration = convertDuration;
      vm.showDuration = showDuration;
      function showDuration(data) {
          if(data.typeDuration === 'sec'){
              return convertDuration(data.duration);
          }else{
              return convertDuration(convertDurationToSeconds(data.duration));
          }
      }
      function convertDuration(duration) {
          var res =  moment().startOf('day')
              .seconds(duration)
              .format('HH:mm:ss');
          return res;
      }

      var nbr_total = 0;
      var last = 1;
      var nbr_per_page = 8;
      var id_theme = null;
      var requestMedia = {"page": 1, "nbParPage": nbr_per_page};
      if(angular.isDefined(playlistData.default_theme_playlist) && playlistData.default_theme_playlist){
          id_theme = playlistData.default_theme_playlist.split('-')[1];
          requestMedia.idTheme=id_theme;
      }
      msApi.request(
          "media.getMedias@get",
          requestMedia,
          function (res) {
              if (res.code === 200) {
                  nbr_total = res.nombre_total;
                  for (var i = 0; i < res.medias.length; i++) {
                      vm.videos.push(res.medias[i]);
                  }
              }
          }
      );
      $scope.loadMore = function () {
          last = last + 1;
          if (last - nbr_total / nbr_per_page < 1 && last - nbr_total / nbr_per_page > 0)
              var nbr = nbr_total / nbr_per_page + 1;
          else var nbr = nbr_total / nbr_per_page;
          if (last <= (nbr))
              msApi.request(
                  "media.getMedias@get",
                  {"page": last, "nbParPage": nbr_per_page, "idTheme": id_theme},
                  function (res) {
                      if (res.code === 200) {
                          nbr_total = res.nombre_total;
                          for (var i = 0; i < res.medias.length; i++) {
                              vm.videos.push(res.medias[i]);
                          }
                      }
                  }
              );
      };
    vm.empPlaylistForm = {};

    vm.submitAddPlaylistForm = submitAddPlaylistForm;
    vm.returnToList = returnToList;
    vm.addVideoToPlayList = addVideoToPlayList;
    vm.removeVideofromPlayList2 = removeVideofromPlayList2;
    vm.removeVideofromPlayList = removeVideofromPlayList;

    fillData();
    vm.onChange = onChange;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;

    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.playlist_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.playlist_edit_pagetitle";
      if (angular.isDefined($rootScope.playlist)) {
        $rootScope.pageRoute = $rootScope.playlist;

      }
      else {
        $rootScope.pageRoute = "app.playlist_list.simple";

      }


      $rootScope.welcome = "welcome_playlist_edit";
      $rootScope.text = [{
        texte: "list_video_playlist_add_help"
      },
        {
            texte: "parameters_playlist_edit_help"
        }, {
              texte: "send_button_playlist_edit_help"
        }, {
          texte: "cancel_button_playlist_add_help"
        }, {
          texte: "delete_button_playlist_add_help"
        }];
    }

    /**
     * convert a duration into seconds
     */

    function convertDurationToSeconds(duration) {
      var formatedDate = $filter('date')(duration, "HH:mm:ss");
      var hours = formatedDate.split(":")[0];
      var min = formatedDate.split(":")[1];
      var seconds = formatedDate.split(":")[2];
      var durationInSeconds = hours * 3600 + min * 60 + seconds * 1;

      return durationInSeconds;
    }

    /**
     * Check if playlist exists
     * @return if exists get Theme Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.playlist.code) && vm.playlist.code !== 200) $state.go('app.error_404');
      else {
        vm.empPlaylistForm = {
          title: vm.playlist.title,
          loopp: vm.playlist.loopp ? 1 : 0,
          maxDuration: vm.playlist.maxDuration,
          autoSort: vm.playlist.autoSort ? 1 : 0,
          playlist_media: vm.playlist.playlist_media,
          startDate: vm.playlist.startDate,
          isLive: vm.playlist.isLive,
          mdTime: {
            date: new Date(moment(vm.playlist.startDate)),
            time: new Date(moment(vm.playlist.startDate))
          },
          rmboxes: getIdsRmboxes(vm.playlist.rmboxes)

        };
        if (vm.playlist.isLive) {
          vm.empPlaylistForm.onAir = vm.playlist.onAir
        }
        $rootScope.itemName = vm.playlist.title || '';
      }
      vm.minDate = vm.empPlaylistForm.mdTime.start;
      vm.minTime = vm.empPlaylistForm.mdTime.time;
    }

    $scope.$watch('vm.empPlaylistForm.loopp', function (newVal) {
      if (newVal == 1) {
        vm.loopNot = true;
      }
      else {
        vm.loopNot = false;
      }
    });
      $scope.$watch('vm.empPlaylistForm.maxDuration', function (newVal) {
          totalDuration=newVal;
          vm.empPlaylistForm.maxDuration = newVal;
      });
    vm.videos_of_playList = getMedias(vm.playlist.playlist_media);
      var videos_of_playList = getMedias(vm.playlist.playlist_media);

      vm.videos_of_playList.forEach(function (value) {
      if (value.duration != null) {
        var durationInSeconds = convertDurationToSeconds(value.duration);
        totalDuration += durationInSeconds;
        vm.empPlaylistForm.maxDuration = totalDuration;
      }
      vm.videos.forEach(function (video) {
        if (value.id == video.id) {
          video.isInPlayList = true;
        }
      })
    })
    vm.videos = webTvGlobal.getArrayDiff(vm.videos, vm.videos_of_playList);


    function subTitle(title) {
      var text;
      if (angular.isDefined(title)) {
        if (title.length >= 20) {
          text = title.substring(0, 20) + '...'
        } else {
          text = title;
        }
      } else text = "";
      return text;
    }

      function getIdsRmboxes(data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
              res.push(data[i].rmbox.id);
          }
          return res;
      }

      function getobjRmboxes(data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
              res.push({rmbox: data[i]});
          }
          return res;
      }


    /**
     * return to canal list page
     * @return redirect to canal list page
     */
    function returnToList() {
      if (angular.isDefined($rootScope.playlist)) {
        $state.go($rootScope.playlist);
        $rootScope.selectedIndex = 1;
      }
      else {
        $state.go("app.playlist_list.simple");
        $rootScope.selectedIndex = 0;
      }

    }


    function onChange(theme) {
        if (theme === "") {
            id_theme = null;
        }else {
            id_theme = theme.substring(theme.indexOf('-') + 1, theme.length);
        }
        last = 1;
        msApi.request(
            "media.getMedias@get",
            {"page": 1, "nbParPage": nbr_per_page, "idTheme": id_theme},
            function (res) {
                if (res.code === 200) {
                    nbr_total = res.nombre_total;
                    vm.videos = res.medias;
                    vm.videos.forEach(function (video) {
                        video.isInPlayList = false;
                    });
                    vm.videos_of_playList.forEach(function (value) {
                        vm.videos.forEach(function (video) {
                            if (value.id == video.id) {
                                video.isInPlayList = true;
                            }
                        })
                    })
                }
            }
        );
    }

    function changeDate() {
      vm.empPlaylistForm.startDate = vm.empPlaylistForm.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empPlaylistForm.mdTime.date).format('YYYY-MM-DD'));
    }

    function changeTime() {
      vm.empPlaylistForm.startDate = vm.empPlaylistForm.startDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empPlaylistForm.mdTime.time).format('HH:mm:ss'));
    }

    /**
     * Send add canal Form
     */
    function submit(formData) {
      if (formData.isLive) {
        $state.go('app.playlist_list.live');
        $rootScope.selectedIndex = 1;
      }
      else {
        $state.go('app.playlist_list.simple');
        $rootScope.selectedIndex = 0;
      }
    }

    function submitAddPlaylistForm() {
      var formData = angular.copy(vm.empPlaylistForm);
      delete formData.mdTime;
      if (formData.isLive === false) {
        delete formData.startDate;
      }
      $rootScope.loadingProgress = true;
      formData.playlist_media = getIdsMedias(vm.videos_of_playList);
        if(angular.isDefined(vm.empPlaylistForm.rmboxes)) {
            formData.rmboxes = getobjRmboxes(vm.empPlaylistForm.rmboxes);
        }
        msApi.request('playlist.editPlaylist@save',
        {"empPlaylistForm": formData, id: vm.playlist.id},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('parametersPlaylistEdit', {title: vm.empPlaylistForm.title ? vm.empPlaylistForm.title : ""});
            if (formData.isLive && formData.onAir === true) {
              $mdDialog.show({
                locals: {sendFilesApi: Routing.generate('api_send_playlists_live_files')},
                templateUrl: 'app/main/media/playlist/view_add_edit_playlist/on.air.confirm.html',
                clickOutsideToClose: true,
                controller: 'onAirController',
                controllerAs: 'vm'
              }).then(function () {
                submit(formData)
              }, function () {
                submit(formData)
              })
            } else {
              submit(formData)
            }

          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        });
    }

    function addVideoToPlayList(array, key) {
        array.typeDuration = "sec";
        vm.videos_of_playList.push(array);
      vm.list_video_not_pristine = true;
      vm.videos[key].isInPlayList = true;
      if (array.duration != null) {
        var durationInSeconds = array.duration;
        totalDuration += durationInSeconds;
        vm.empPlaylistForm.maxDuration = totalDuration;
      }
    }

    function removeVideofromPlayList(data, key) {
      vm.list_video_not_pristine = true;
      vm.videos_of_playList.forEach(function (video) {
        if (video.id == data.id) {
          indexToRemove = vm.videos_of_playList.indexOf(video);
        }
      })
      vm.videos_of_playList.splice(indexToRemove, 1);
      vm.videos[key].isInPlayList = false;

    }

    //we use this one in form.template.html
    function removeVideofromPlayList2(data,index) {
      var key = vm.videos.indexOf(data);
      var nbreOfInstances = 0;
      if (key == -1) {
        var idVid = data.id;
        vm.videos.forEach(function (video) {
          if (video.id == idVid) {
            //video.isInPlayList = false;
          }
        })
      }
      vm.videos_of_playList.forEach(function (video) {
        if (video.id == data.id) {
          nbreOfInstances++;
        }
      })

      if (nbreOfInstances == 1) {
        vm.videos.forEach(function (video) {
          if (video.id == data.id) {
            video.isInPlayList = false;
          }
        })
      }
      vm.list_video_not_pristine = true;
        vm.videos_of_playList.splice(index, 1);

      if (data.duration != null) {
          if(data.typeDuration==="sec"){
              var durationInSeconds = data.duration;
          }else {
              var durationInSeconds = convertDurationToSeconds(data.duration);
          }
        totalDuration -= durationInSeconds;
        vm.empPlaylistForm.maxDuration = totalDuration;
      }
    }


    function getIdsMedias(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var element = {};
        element.sort = data[i].id;
        res.push({sort: i, media: element.sort});
      }
      return res;
    }

    function getMedias(data) {
      var res = [];

      if (angular.isDefined(data)) {
        for (var i = 0; i < data.length; i++) {
          var element = {};
          element.sort = data[i].media.video;
          element.sort.id = data[i].media.id;
          res.push(element.sort);
        }
      }
      return res;
    }


      var ids=[];


      vm.video_of_playListOrder = "";
      vm.sortableOptions = {
          items: '>li',
          handle: '> .myHandleCursor',
          update: function (e, ui) {


          },
          stop: function () {
              var videos = angular.copy(vm.videos_of_playList);
              var video_playlist = [];


              angular.element('md-content ul li').each(function (index) {
                  // ids[ index] = parseInt(angular.element(this)[0]);
                  ids[index] = angular.element(this).context.dataset.idVideo


              });

              angular.forEach(ids, function (v) {
                  var video= videos.filter(function(video){return video.id.toString() === v.toString()});
                  video_playlist.push(video[0]);
              });
              vm.videos_of_playList=[];
              vm.videos_of_playList = video_playlist;
          }
      };
    vm.msScrollOptions = {
      suppressScrollX: true
    };

  }

})();


(function () {
    'use strict';

    angular
        .module('app.playlist.add', ['textAngular', "ui.sortable"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.playlist_add', {
                url: "/playlist/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/playlist/view_add_edit_playlist/add_edit.template.html',
                        controller: 'playlistAddController as vm'
                    }
                },
                resolve: {
                    playlistData: function (msApi) {
                        return msApi.resolve('playlist.getNewPlaylist@get', {id: 0});
                    },
                    // getMediasData: function (msApi) {
                    //     return msApi.resolve('media.getMedias@get');
                    // },
                    // themeChoices: function (msApi) {
                    //     return msApi.resolve('theme.themeChoices@get', {idToIgnore: 0});
                    // },
                    // parametersThemeData: function (msApi) {
                    //     return msApi.resolve('theme.getNewThemeData@get', {id: 0});
                    // },
                    sendFilesApi: function () {
                        return Routing.generate('api_send_playlists_live_files')
                    },
                    rmboxesData: function (msApi)
                    {
                        return msApi.resolve('playlist.getRmboxes@get', {type: "Display"});
                    }
                },
                "bodyClass": "forms"
            });


        //API
        msApiProvider.register('playlist.getNewPlaylist', [Routing.generate('api_get_detail_playlist', {id: ':id'}).replace(/%3A/, ":")]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('media.getMedias', [Routing.generate('api_media_get_media')]);
        msApiProvider.register('playlist.addPlaylist', [Routing.generate('api_post_add_playlist')]);
        msApiProvider.register('playlist.getMediasByTheme', [Routing.generate('api_media_get_by_theme', {themeId: ':themeId'}).replace(/%3A/, ":")]);
        // msApiProvider.register('theme.themeChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
        // msApiProvider.register('theme.getNewThemeData', [Routing.generate('api_parameters_get_detail_theme', {id: ':id'}).replace(/%3A/, ":")]);


    }
})();

(function () {
  angular
    .module('app.playlist.add')
    .controller('onAirController', onAirController);

  /** @ngInject */
  function onAirController($mdDialog, sendFilesApi) {
    var vm = this;
    vm.cancel = cancel;
    vm.confirm = confirm;
    vm.sendFiles = "u="+sendFilesApi;

    function confirm(){
      $mdDialog.hide();
    }

    function cancel() {
      $mdDialog.cancel();
    };
  }

})();

(function () {
    'use strict';

    angular
        .module('app.playlist.list')
        .controller('playlistListController', playlistListController)
        .controller('playlistListTemplateController', playlistListTemplateController);

    /** @ngInject */
    function playlistListController($rootScope, $scope,$cookies, webTvGlobal, DTOptionsBuilder, DTColumnBuilder, PlayListData, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate'),
            msApi = $injector.get('msApi'),
            $mdDialog = $injector.get('$mdDialog');
        var vm = this;
        vm.addNewPlaylist = addNewPlaylist;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre;
        vm.playlists = [];
        vm.selectedPlaylists = [];
        var selectedPlaylists = [];
        vm.search_playlist = "";
        vm.dtInstance = {};
        vm.playlistsDataTable = {};
        if ($rootScope.state.current.url === '/live') $rootScope.selectedIndex = 1;
        else $rootScope.selectedIndex = 0;
        function addNewPlaylist() {

          $state.go('app.playlist_add');
        }
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: 1,
                    width: '72px'
                },

                {
                    targets: 3,
                    filterable: true,
                    sortable: true
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function searchPlaylistInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request(PlayListData, filtre,
                function (response) {
                    var records = {};
                    $rootScope.records = response.recordsTotal;
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.playlists = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.playlists = response.data;
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = sort.column - 1 < 0 ? 0 : sort.column - 1;
            vm.selectedPlaylists = [];
            selectedPlaylists = [];
            // var filtre = {
            //     draw: draw,
            //     start: start,
            //     length: length,
            //     "search[value]": vm.search_playlist,
            //     "order[0][column]": numColum,
            //     "order[0][dir]": sort.dir
            // };
            // filtre["columns[" + numColum + "][orderable]"] = true;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_playlist,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchPlaylistInAPI(filtre);
        }

        function searchPlaylist() {
            filtre["search[value]"] = vm.search_playlist;
            searchPlaylistInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.playlistsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.playlistsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.playlistsDataTable[' + data.id + '])"' +
                        'aria-label=""' +
                        '>' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('maxDuration').renderWith(function (data) {

                if (!isNaN(data)) {
                    return (data)
                }
                else {
                    return 0;
                }
            }),
            DTColumnBuilder.newColumn('loopp').renderWith(function (data) {
                var serverHtml = "";
                if (data === null) {
                    serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                }
                else {
                    if (data) {
                        serverHtml += '<i class="icon-checkbox-marked-circle green-500-fg"><span class="hide">1</span></i>';
                    }
                    else {
                        serverHtml += '<i class="icon-cancel red-500-fg"><span class="hide">0</span></i>';
                    }
                }

                return serverHtml;
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.playlistsDataTable[data.id] = data;

                    var buttonActionDetailHtml = '<a has-permission="playlist_get_detail" tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showPlaylistDetail(vm.playlistsDataTable[' + data.id + '],$event)" aria-label="action_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml = '<a has-permission="playlist_post_edit" tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="edit-button md-icon-button" ng-click="vm.editPlaylist(vm.playlistsDataTable[' + data.id + '])" aria-label="action_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml = '<a has-permission="playlist_delete_playlist" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deletePlaylistConfirm(vm.playlistsDataTable[' + data.id + '],ev)" aria-label="action_delete">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';
                    var buttonActionPlayHtml = '<a has-permission="playlist_playlist_link" tooltips tooltip-template=' + "{{'MESSAGES.preview_video'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="edit-button md-icon-button" ng-click="vm.playPlaylist(vm.playlistsDataTable[' + data.id + '])" aria-label="action_edit">' +
                        '<md-icon  md-font-icon="icon-play" class="s18"></md-icon>' +
                        '</md-button></a>';

                    return buttonActionPlayHtml + buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchPlaylist = searchPlaylist;
        vm.deletePlaylistConfirm = deletePlaylistConfirm;
        vm.deleteSelectedPlaylistsConfirm = deleteSelectedPlaylistsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showPlaylistDetail = showPlaylistDetail;
        vm.editPlaylist = editPlaylist;
        vm.playPlaylist = playPlaylist;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        showFlasMessageToast('parametersPlaylistAdd', $translate.instant('PLAYLISTLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('parametersPlaylistEdit', $translate.instant('PLAYLISTLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Visualiser la playlist
         */
        function playPlaylist(playlist) {
            $rootScope.loadingProgress = true;
            msApi.request('playlist.modalEmbedPlaylist@get', {id: playlist.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            controller: function (playlistData, playlist, $mdDialog, $translate, $sce) {
                                var vm = this;
                                vm.trustLink = trustLink;

                                function trustLink(link) {
                                    return $sce.trustAsResourceUrl(link);
                                }

                                vm.link = playlistData.link;
                                vm.embed = playlistData.embed;
                                vm.closeDialog = closeDialog;

                                /**
                                 * Close the dialog
                                 */
                                function closeDialog() {
                                    $mdDialog.hide();

                                }
                            },
                            controllerAs: 'vm',
                            locals: {
                                playlistData: response,
                                playlist: playlist
                            },
                            templateUrl: 'app/main/media/playlist/list/embed.modal.html',
                            clickOutsideToClose: true

                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('PLAYLISTLIST.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param playlist
         */
        function toggle(playlist) {
            getElement();
            playlist.checked = !playlist.checked;
            var idx = selectedPlaylists.indexOf(playlist);
            if (idx > -1) {
                selectedPlaylists.splice(idx, 1);
            }
            else {
                selectedPlaylists.push(playlist);
            }
            vm.selectedPlaylists = angular.copy(selectedPlaylists);
        }

        /**
         * @param playlist
         */


        function toggleAll() {
            getElement();
            if (selectedPlaylists.length === vm.playlists.length) {
                vm.selectedPlaylists = [];
            }

            else if ((selectedPlaylists.length === 0) || (selectedPlaylists.length > 0)) {
                vm.selectedPlaylists = vm.playlists.slice(0);
            }
            selectedPlaylists = angular.copy(vm.selectedPlaylists);
            var list_playlists = angular.copy(vm.playlistsDataTable);
            angular.forEach(list_playlists, function (value, key) {
                if (value !== undefined)
                    vm.playlistsDataTable[key].checked = selectedPlaylists.length > 0;
            });

        }

        /**
         * Show playlist Details
         * @param playlist
         */
        function showPlaylistDetail(playlist, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('playlist.modalGetPlaylist@get', {id: playlist.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {playlistData: response},
                            templateUrl: 'app/main/media/playlist/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'playlistDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchPlaylistInAPI(filtre), true);
        }

        function editPlaylist(playlist) {
            clearFlashMessage();

            $rootScope.playlist = $state.current.name;
            $state.go('app.playlist_edit', {id: playlist.id});
        }


        /**
         * Delete playlist Confirm Dialog
         */
        function deletePlaylistConfirm(playlist, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "PLAYLISTLIST.delete_playlist_msg",
                "PLAYLISTLIST.delete_playlist_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['PLAYLISTLIST.delete_playlist_msg'])
                        .htmlContent('<b>' + playlist.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['PLAYLISTLIST.delete_playlist_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deletePlaylist(playlist);
                        vm.selectedPlaylists = [];
                        selectedPlaylists = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete playlist
         */
        function deletePlaylist(playlist) {
            clearFlashMessage();
            if (vm.playlists.indexOf(playlist) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('playlist.delete@delete', {id: playlist.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "PLAYLISTLIST.dialog_alert_delete_title",
                                "PLAYLISTLIST.dialog_alert_delete_description",
                                "PLAYLISTLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(playlist.title + translatedValues['PLAYLISTLIST.dialog_alert_delete_description']);
                                    vm.playlists.splice(vm.playlists.indexOf(playlist), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "PLAYLISTLIST.dialog_alert_delete_error_title",
                                "PLAYLISTLIST.dialog_alert_delete_error_description",
                                "PLAYLISTLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['PLAYLISTLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['PLAYLISTLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['PLAYLISTLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }

        function deleteSelectedPlaylistsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedPlaylists.length !== 0) {
                if(vm.selectedPlaylists.length === 1){
                    title = 'PLAYLISTLIST.delete_playlist_msg';
                    ariaLabel = 'PLAYLISTLIST.delete_playlist_aria_label';
                }else{
                    title = 'PLAYLISTLIST.delete_list_playlist_msg';
                    ariaLabel = 'PLAYLISTLIST.delete_playlists_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedPlaylists.length,title,ariaLabel)).then(function () {
                    deleteSelectedPlaylists(ev);
                }, function () {
                });


            }

        }

        /* delete selected groups*/
        function deleteSelectedPlaylists(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('playlist.deletePlaylists@delete', {
                    list: (function (list) {
                        selectedPlaylists.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("PLAYLISTLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("PLAYLISTLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('PLAYLISTLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedPlaylists = [];
                        rerender();
                        vm.selectedPlaylists = []
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('PLAYLISTLIST.dialog_alert_delete_error_title'),
                            $translate.instant('PLAYLISTLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedPlaylists = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedPlaylists = [];
                    selectedPlaylists = [];
                    vm.modelCheckAll = false;

                }
            );


        }




    }

    function playlistListTemplateController($state,userManager, HelpGlobal, $rootScope, $sce, $cookies, $scope) {
        var vm = this;
        vm.addNewPlaylist = addNewPlaylist;
        initHelp();
        var pemission = {};
        if (userManager.isActionGranted('playlist_live_list_dtable')) {
          pemission.playlist_live_list_dtable = true;
        }
        if (userManager.isActionGranted('playlist_list_dtable')) {
          pemission.playlist_list_dtable = true;
        }
        vm.permission = pemission;
        vm.chageTitle = chageTitle;

        if (window.process.env.isNewPlaylist) {
            vm.isNewPlaylist = window.process.env.isNewPlaylist;
          }
        if (vm.isNewPlaylist) {
            vm.newPlayListIframe = $sce.trustAsResourceUrl(
              "https:" +
                window.process.env.URL_Media +
                "/playlist?token=" +
                $cookies.get("authToken")
            );
            $scope.$watch(function () {
              vm.newPlayListIframe = $sce.trustAsResourceUrl(
                "https:" +
                  window.process.env.URL_Media +
                  "/playlist?token=" +
                  $cookies.get("authToken")
              );
              return $cookies.get("WEBTV.locale");
            });
        }

        function chageTitle(type) {
            $rootScope.titre3 = "PAGESMENUSTITLES.playlist_list_"+type;
            $state.go('app.playlist_list.'+type);
        }
        /**
         * Get Page Title Translation Key from the current state
         * @return string : translation key for the page title
         */
        function getTitleKey() {
            if($state.current.name ==="app.playlist_list.simple"){
                return "PAGESMENUSTITLES.playlist_list_simple";
            }else if($state.current.name ==="app.playlist_list.live"){
                return "PAGESMENUSTITLES.playlist_list_live";
            }
        }

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.playlist_menuTitle";
            $rootScope.titre3 = getTitleKey();
            $rootScope.pageRoute = "";


            $rootScope.welcome = "welcome_playlist";
            $rootScope.text = [{
                texte: "add_button_playlist_help"
            }, {
                texte: "arrow_button_playlist_help"
            }, {
                texte: "search_area_playlist_help"
            }, {
                texte: "tri_column_playlist_help"
            },
                {
                    texte: "edit_button_playlist_help"
                }, {
                    texte: "detail_button_playlist_help"
                },
                {
                    texte: "preview_button_playlist_help"
                },
                {
                    texte: "delete_button_playlist_help"
                }];
        }

        function addNewPlaylist() {

            $state.go('app.playlist_add');
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.podcast.upload', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.podcast_upload', {
                url: "/media/podcast/upload",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/podcast/upload/upload.template.html',
                        controller: 'podcastUploadController as vm'
                    }
                },
                bodyClass: 'e-commerce'
            });


        //API
        msApiProvider.register('media_video.getUrlUpdate', [Routing.generate('api_media_get_url_update_step_video')]);
        msApiProvider.register('preview-modal.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.podcast.upload')
    .controller('podcastUploadController', podcastUploadController);

  /** @ngInject */
  function podcastUploadController(webTvGlobal, userManager, $injector, $window, $cookies) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $timeout = $injector.get('$timeout'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state');
    var vm = this;
    if (!$rootScope.index)
      $rootScope.index = 0;
    vm.videoFile = undefined;

    var parameters = webTvGlobal.$constant().webTvParameterBag();
    vm.ngFlowOptions = {
      chunkSize: (function () {
        return Math.pow(10, 100);
      })(),
      testChunks: false,
      target: parameters['url_import_video_piper'],
      simultaneousUploads: 1,
      extendChunks: false,
      fileParameterName: 'uploadfile',
      query: {
        clientname: parameters['app.client.name'],
        type:'podcasts',
        user_id: userManager.getId(),
      },
      headers: { Authorization: "Bearer " + $cookies.get("authToken") }
    };
    vm.ngFlow = {
      flow: {}
    };
    vm.dropping = false;


    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.fileProgress = fileProgress;
    vm.cancelUpload = cancelUpload;
    vm.progressBarValue = 0;
    vm.roundWithPrecision = roundWithPrecision;
    vm.inProgress = false;
    var videoKeyName = "";
    $rootScope.arrayPodcast = [];
    var arrayPodcast=[];

    vm.uploadMetaDataError = false;
    checkUploadMetaDataError();
    vm.redirect = redirect;


    init();

    // function returnToList() {
    //     $state.go('app.media_video_list_ongoing');
    // }

    function redirect() {
      if ("url_extension" in parameters) {
        var linkExtension = parameters['url_extension'];
        $window.open(linkExtension);
      }
    }


    function init() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.parameters_podcast_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.parameters_podcast_add_menuTitle";
      $rootScope.pageRoute = "app.podcast_list";
      $rootScope.welcome = "";
      $rootScope.text = [];
    }


    /**
     * Check if after upload , has an error on generating meta data has been thrown
     */
    function checkUploadMetaDataError() {
      if (angular.isDefined($rootScope.uploadMetaDataError) && $rootScope.uploadMetaDataError) {
        $rootScope.uploadMetaDataError = undefined;
        vm.uploadMetaDataError = true;
      }
      if (angular.isDefined($rootScope.uploadMetaDataExternalError) && $rootScope.uploadMetaDataExternalError) {
        $rootScope.uploadMetaDataExternalError = undefined;
        vm.uploadMetaDataExternalError = true;
      }
    }


    function fileAdded(file) {
      if (!/(mp3|wav|cda|mid|mod|wma|m4a|ogg|aac|flv|m4v|avi|wmv|mp4|mpeg|mpg|mpe|dat|vob|asf|asx|mov|3gp|3g2|3gpp|dv|qt|rm|rmvb)$/i.test(file.getExtension().toLowerCase())) {
        vm.imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_audio_message'));
        return false;
      }
      vm.videoFile = file;
    }

    function fileProgress(file) {
      vm.progressBarValue = file.progress() * 100;
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      //  vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var data = JSON.parse(message);
      if (angular.isDefined(data.file_name)) {
        videoKeyName = data.file_name;
        arrayPodcast.push({audio: videoKeyName});
      } else return;
      // if (/^error !$/.test(message) || /^error$/.test(message)) return;
      // else vm.videoKeyName = message;
    }
      $rootScope.arrayPodcast=arrayPodcast;

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      vm.progressBarValue = 0;
      vm.inProgress = false;
      if (angular.isDefined(vm.videoFile) && videoKeyName) {
        $state.go('app.podcast_add');
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: vm.videoFile.name}), '', function () {
          videoKeyName = "";
        }, false, 500).then(function () {
        });
      }
      else {
        if (!angular.isDefined(vm.videoFile) && vm.imageName) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
      }

    }

    /**
     * Stop upload operation
     */
    function cancelUpload() {
      $timeout(function () {
        vm.ngFlow.flow.cancel();
      });
    }

    // select from on hold video


  }


})();





(function () {
  'use strict';

  angular
    .module('app.playlist.add')
    .controller('playlistAddController', playlistAddController).directive('whenScrolledPlaylist', function () {
      return function (scope, elm, attr) {
          var raw = elm[0];
          elm.bind('scroll', function () {
              if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight) {
                  scope.$apply(attr.whenScrolledPlaylist);
              }
          });
      };
  });


  /** @ngInject */
  function playlistAddController($scope, $filter, msApi, playlistData, rmboxesData, webTvGlobal,  $injector, sendFilesApi) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $state = $injector.get('$state'),
      $mdDialog = $injector.get('$mdDialog'),
      $translate = $injector.get('$translate');
    var vm = this;
    var totalDuration = 0;
    vm.isNew = true;
    vm.playlist = playlistData.playlist;
    // vm.theme = parametersThemeData;
      vm.videos = [];
    vm.theme = angular.isDefined(playlistData.default_theme_playlist) && playlistData.default_theme_playlist ? playlistData.default_theme_playlist : "";
      $scope.$on('changeModal', function(event, args){
          if(args){
              onChange($scope.defaultIdTheme)
          }

      });
      console.log("$scope", $scope)
    vm.rmboxs = rmboxesData.data.rmboxs;
    vm.rmboxs = webTvGlobal.convertArrayToSelectList(vm.rmboxs);

    vm.yesNoChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });

    vm.convertDuration = convertDuration;
    vm.showDuration = showDuration;
    function showDuration(data) {
        if(data.typeDuration === 'sec'){
            return convertDuration(data.duration);
        }else{
            return convertDuration(convertDurationToSeconds(data.duration));
        }
    }
    function convertDuration(duration) {
        var res =  moment().startOf('day')
            .seconds(duration)
            .format('HH:mm:ss');
        return res;
    }

    vm.empPlaylistForm = {
      title: vm.playlist.title ? vm.playlist.title : null,
      loopp: vm.playlist.loopp ? 1 : 0,
      maxDuration: vm.playlist.maxDuration,
      autoSort: vm.playlist.autoSort ? 1 : 0,
      playlist_media: vm.playlist.playlist_media,
      startDate: vm.playlist.startDate,
      isLive: false,
      mdTime: {
        date: new Date(moment(vm.playlist.startDate)),
        time: new Date(moment(vm.playlist.startDate))
      }
    };
    var nbr_total = 0;
    var last = 1;
    var nbr_per_page = 8;
    var id_theme = null;
    var requestMedia = {"page": 1, "nbParPage": nbr_per_page};
    if(angular.isDefined(playlistData.default_theme_playlist) && playlistData.default_theme_playlist){
        id_theme = playlistData.default_theme_playlist.split('-')[1];
        requestMedia.idTheme=id_theme;
    }
    msApi.request(
          "media.getMedias@get",
        requestMedia,
          function (res) {
              if (res.code === 200) {
                  nbr_total = res.nombre_total;
                  for (var i = 0; i < res.medias.length; i++) {
                      vm.videos.push(res.medias[i]);
                  }
              }
          }
    );
    $scope.loadMore = function () {
        last = last + 1;
        if (last - nbr_total / nbr_per_page < 1 && last - nbr_total / nbr_per_page > 0)
            var nbr = nbr_total / nbr_per_page + 1;
        else var nbr = nbr_total / nbr_per_page;
        if (last <= (nbr))
            msApi.request(
                "media.getMedias@get",
                {"page": last, "nbParPage": nbr_per_page, "idTheme": id_theme},
                function (res) {
                    if (res.code === 200) {
                        nbr_total = res.nombre_total;
                        for (var i = 0; i < res.medias.length; i++) {
                            vm.videos.push(res.medias[i]);
                        }
                    }
                }
            );
    };

    vm.submitAddPlaylistForm = submitAddPlaylistForm;
    vm.addVideoToPlayList = addVideoToPlayList;
    vm.removeVideofromPlayList2 = removeVideofromPlayList2;

    //vm.addToVideosList = addToVideosList;
    vm.onChange = onChange;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;
    vm.returnToList = returnToList;
    vm.subTitle = subTitle;

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.playlist_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.playlist_add_menuTitle";
      $rootScope.pageRoute = 'app.playlist_list.simple';


      $rootScope.welcome = "welcome_playlist_add";
      $rootScope.text = [{
        texte: "list_video_playlist_add_help"
      },
        {
          texte: "parameters_playlist_add_help"
        }, {
          texte: "send_button_playlist_add_help"
        }, {
          texte: "cancel_button_playlist_add_help"
        }, {
          texte: "delete_button_playlist_add_help"
        }];
    }

    /**
     * convert a duration into seconds
     */

    function convertDurationToSeconds(duration) {
      var formatedDate = $filter('date')(duration, "HH:mm:ss");
      var hours = formatedDate.split(":")[0];
      var min = formatedDate.split(":")[1];
      var seconds = formatedDate.split(":")[2];
      var durationInSeconds = hours * 3600 + min * 60 + seconds * 1;

      return durationInSeconds;
    }

    /**
     * return to canal list page
     * @return redirect to canal list page
     */
    function returnToList() {
      $state.go('app.playlist_list.simple');
    }


    function onChange(theme) {
      if (theme === "") {
          id_theme = null;
      }else {
          id_theme = theme.substring(theme.indexOf('-') + 1, theme.length);
      }
        last = 1;
        msApi.request(
            "media.getMedias@get",
            {"page": 1, "nbParPage": nbr_per_page, "idTheme": id_theme},
            function (res) {
                if (res.code === 200) {
                    nbr_total = res.nombre_total;
                    vm.videos = res.medias;
                    vm.videos.forEach(function (video) {
                        video.isInPlayList = false;
                    });
                    vm.videos_of_playList.forEach(function (value) {
                        vm.videos.forEach(function (video) {
                            if (value.id == video.id) {
                                video.isInPlayList = true;
                            }
                        })
                    })
                }
            }
        );

    }

    function changeDate() {
      vm.empPlaylistForm.startDate = vm.empPlaylistForm.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empPlaylistForm.mdTime.date).format('YYYY-MM-DD'));
    }

    function changeTime() {
      vm.empPlaylistForm.startDate = vm.empPlaylistForm.startDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empPlaylistForm.mdTime.time).format('HH:mm:ss'));
    }


    /**
     * Send add canal Form
     */
    function submit(formData) {
      if (formData.isLive) {
        $state.go('app.playlist_list.live');
        $rootScope.selectedIndex = 1;
      }
      else {
        $state.go('app.playlist_list.simple');
        $rootScope.selectedIndex = 0;
      }
    }

    function submitAddPlaylistForm() {
      var formData = angular.copy(vm.empPlaylistForm);
      delete formData.mdTime;
      if (formData.isLive === false) {
        delete formData.startDate;
      }
      $rootScope.loadingProgress = true;
      formData.playlist_media = getIdsMedias(vm.videos_of_playList);
      if(angular.isDefined(vm.empPlaylistForm.rmboxes)) {
          formData.rmboxes = getIdsRmboxes(vm.empPlaylistForm.rmboxes);
      }
      msApi.request('playlist.addPlaylist@save',
        {"empPlaylistForm": formData},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('parametersPlaylistAdd', {title: vm.empPlaylistForm.title ? vm.empPlaylistForm.title : ""});
            if (formData.isLive && formData.onAir === true) {
              $mdDialog.show({
                locals: {sendFilesApi: sendFilesApi},
                templateUrl: 'app/main/media/playlist/view_add_edit_playlist/on.air.confirm.html',
                clickOutsideToClose: true,
                controller: 'onAirController',
                controllerAs: 'vm'
              }).then(function () {
                submit(formData)
              }, function () {
                submit(formData)
              })
            } else {
              submit(formData)
            }


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );

    }

    vm.videos_of_playList = [];

    function addVideoToPlayList(array, key) {
        array.typeDuration = "sec";
      vm.videos_of_playList.push(array);
      vm.list_video_not_pristine = true;
      vm.videos[key].isInPlayList = true;
      if (array.duration != null) {
        var durationInSeconds = array.duration;
        totalDuration += durationInSeconds;
        vm.empPlaylistForm.maxDuration = totalDuration;
      };
    }

    $scope.$watch('vm.empPlaylistForm.loopp', function (newVal) {
      if (newVal == 1) {
        vm.empPlaylistForm.maxDuration = 0;
        vm.loopNot = true;
      }
      else {
        vm.empPlaylistForm.maxDuration = totalDuration;
        vm.loopNot = false;
      }
    });


    function removeVideofromPlayList2(data,index) {
       var key = vm.videos.indexOf(data);
        vm.list_video_not_pristine = true;
        vm.videos_of_playList.splice(index, 1);
         vm.videos[key].isInPlayList = false;
      if (data.duration != null) {
        var durationInSeconds = data.duration;
        totalDuration -= durationInSeconds;
        vm.empPlaylistForm.maxDuration = totalDuration;
      }
    }

    function subTitle(title) {
      var text;
      if (angular.isDefined(title)) {
        if (title.length >= 20) {
          text = title.substring(0, 20) + '...'
        } else {
          text = title;
        }
      } else text = "";
      return text;
    }

    function getIdsMedias(data) {
      var res = [];
      for (var i = 0; i < data.length; i++) {
        var element = {};
        element.sort = data[i].id;
        res.push({sort: i, media: element.sort});
      }
      return res;
    }
      function getIdsRmboxes(data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
              res.push({rmbox: data[i]});
          }
          return res;
      }
      var ids=[];


    vm.video_of_playListOrder = "";
      vm.sortableOptions = {
          items: '>li',
          handle: '> .myHandleCursor',
          update: function (e, ui) {
          },
          stop: function () {
              var videos = angular.copy(vm.videos_of_playList);
              var video_playlist = [];


              angular.element('md-content ul li').each(function (index) {
                  // ids[ index] = parseInt(angular.element(this)[0]);
                  ids[index] = angular.element(this).context.dataset.idVideo


              });

              angular.forEach(ids, function (v) {
                  var video= videos.filter(function(video){return video.id.toString() === v.toString()});
                  video_playlist.push(video[0]);
              });
              vm.videos_of_playList=[];
              vm.videos_of_playList = video_playlist;
          }
      };
    vm.msScrollOptions = {
      suppressScrollX: true
    };


  }
})();

(function () {
    'use strict';

    angular
        .module('app.podcast.list', ["datatables", "ngclipboard"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.podcast_list', {
                url: "/podcast/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/podcast/list/list.template.html',
                        controller: 'podcastListController as vm'
                    }
                },

                "bodyClass": "e-commerce"
            });

        // Api
        var deletePodcast = Routing.generate('api_podcast_delete_podcast') + "/:id";
        var deleteListThemes = Routing.generate('api_multi_delete_podcasts') + "/:list";
        msApiProvider.register('podcast.list', [Routing.generate('api_podcast_get_podcasts')]);
        msApiProvider.register('podcast.mdelete', [deletePodcast, {id: '@id'}]);
        msApiProvider.register('podcast.deletePodcasts', [deleteListThemes, {list: '@list'}]);
        msApiProvider.register('podcast.modalGetPodcast', [Routing.generate('api_podcast_get_detail_podcast', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('podcast.getExportLinks', [Routing.generate('api_podcast_get_url_export_podcast', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('podcast.getLinkPreview', [Routing.generate('api_podcast_get_link_podcast', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('podcast.dtable', [Routing.generate('api_dtable_list_dtable_podcast')]);
        msApiProvider.register('podcast.check_transcoding', [Routing.generate('api_podcast_post_check_if_podcasts_are_done_transoding')]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.podcast.list')
        .controller('podcastListController', podcastListController);

    /** @ngInject */
    function podcastListController($scope, DTOptionsBuilder, $cookies, DTColumnBuilder, $compile, webTvGlobal, order_podcast, $injector, dtable_language, $interval,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $document = webTvGlobal.$document;
        var vm = this;
        var $sce = $injector.get("$sce");
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var columnsApi = order_podcast;


        //Data Table options
        vm.podcasts = [];
        vm.selectedPodcasts = [];
        var notTranscodedPodcasts = [];
        var selectedPodcasts = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.podcastsDataTable = {};
        vm.podcastsServerDataTable = {};
        vm.search_podcast = "";
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;

        vm.isNewPodcast = false;
            if (window.process.env.isNew_Media_Podcast) {
              vm.isNewPodcast = window.process.env.isNew_Media_Podcast;
            }
        if (vm.isNewPodcast){
          $scope.PodcastIframe = $sce.trustAsResourceUrl(
            "https:" + window.process.env.URL_Media + "/podcasts?token="+$cookies.get("authToken")
          );
          $scope.$watch(
            function () {
              $scope.PodcastIframe = $sce.trustAsResourceUrl(
                "https:" + window.process.env.URL_Media + "/podcasts?token="+$cookies.get("authToken")
              );
              return $cookies.get("WEBTV.locale");
            },
            function (newValue) {}
          );
        }

        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the image column
                    targets: 2,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchPodcastsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('podcast.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.podcasts = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.podcasts = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }


                },
                function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedPodcasts = [];
            selectedPodcasts = [];
            checkedSelected = false;

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_podcasts,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchPodcastsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.podcastsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.podcastsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.podcastsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn("vignette").notSortable()
                .renderWith(function (data) {
                    var serverHtml = "";
                    if (data === null || data === "" || data === false) {
                        serverHtml += '<span>-</span>';
                    }
                    else {
                        serverHtml += '<img  width="100" height="100" class="product-image" ng-src= ' + data + '>';
                    }
                    return serverHtml;
                }),
            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn("podcastCategory").notSortable()
                .renderWith(function (data, type, full) {

                    vm.podcastsServerDataTable[full.id] = data;

                    var serverHtml = "";
                    if (!data) {
                        serverHtml += '<Any translate="MESSAGES.none" md-colors="{color: \'#000000\'}">Aucun</Any>';
                    }
                    else {
                        serverHtml += data;
                    }
                    return serverHtml;
                }),

            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                        vm.podcastsDataTable[data.id] = data;

                        if (!toggleInNotTranscodedPodcasts(data)) {
                            var buttonTransparent =
                                '<div><a tooltips tooltip-template=' + "{{'MESSAGES.pod_is_transcoding'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="md-icon-button cursor-initial" aria-label="transcoding_podcast">' +
                                '<md-progress-circular md-mode="indeterminate" class="md-accent" md-diameter="14">' +
                                '</md-progress-circular>' +
                                '</md-button></a></div>';
                            return buttonTransparent;
                        }
                        else {
                            var buttonExport = '<a has-permission="podcast_url_export" tooltips tooltip-template=' + "{{'MESSAGES.export_podcast'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button  class="md-icon-button"  ng-click="vm.getExportLinks(vm.podcastsDataTable[' + data.id + '],$event,' + data.id + ')" ' +
                                'aria-label="export_podcast" translate translate-attr-aria-label="MESSAGES.export_podcast"><md-icon md-font-icon="icon-link-variant" class="s18"></md-icon>' +
                                '</md-button></a>';

                            var buttonActionDetailHtml =
                                '<a has-permission="podcast_get_detail" tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="show-button md-icon-button" ng-click="vm.showPodcastDetail(vm.podcastsDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail">' +
                                '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                                '</md-button></a>';
                            var buttonActionEditHtml =
                                '<a has-permission="podcast_post_edit" tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.podcast_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                                '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                                '</md-button>';
                            var buttonActionDeleteHtml =
                                '<a has-permission="podcast_delete_podcast" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deletePodcastConfirm(vm.podcastsDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete">' +
                                '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                                ' </md-button>';

                            var buttonActionPreviewHtml =
                                '<a has-permission="podcast_preview_podcast" tooltips tooltip-template=' + "{{'MESSAGES.preview'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="m16 delete-button md-icon-button" ng-click="vm.previewPodcast(' + data.id + ')" aria-label="preview" translate translate-attr-aria-label="MESSAGES.preview">' +
                                '<md-icon  md-font-icon="icon-play" class="s18"></md-icon>' +
                                ' </md-button>';
                          var buttonActionStatsHtml =
                            '<a has-permission="stats_podcast_by_id_all" tooltips tooltip-template=' + "{{'MESSAGES.stats'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="m16 stats-button md-icon-button" ng-click="vm.goToStatsPodcast(' + data.id + ')" aria-label="stats" translate translate-attr-aria-label="MESSAGES.stats">' +
                            '<md-icon  md-font-icon="icon-chart-bar" class="s18"></md-icon>' +
                            ' </md-button>';

                            return buttonActionPreviewHtml + buttonExport + buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml+buttonActionStatsHtml;
                        }
                    }
                )
        ];

        vm.deletePodcastConfirm = deletePodcastConfirm;
        vm.deleteSelectedPodcastsConfirm = deleteSelectedPodcastsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showPodcastDetail = showPodcastDetail;
        // vm.editPodcast = editPodcast;
        vm.addNewPodcast = addNewPodcast;
        vm.getExportLinks = getExportLinks;
        vm.previewPodcast = previewPodcast;
        vm.goToStatsPodcast = goToStatsPodcast;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        showFlasMessageToast('parametersPodcastAdd', $translate.instant('PODCASTLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('parametersPodcastEdit', $translate.instant('PODCASTLIST.edited'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        vm.searchPodcasts = searchPodcasts;


        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.parameters_podcast_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.parameters_podcast_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "";
            $rootScope.text = [
                // {
                //     texte: "add_button_podcast_help"
                // }, {
                //     texte: "arrow_button_podcast_help"
                // }, {
                //     texte: "search_area_podcast_help"
                // }, {
                //     texte: "tri_column_podcast_help"
                // },
                // {
                //     texte: "edit_button_podcast_help"
                // }, {
                //     texte: "detail_button_podcast_help"
                // },
                // {
                //     texte: "delete_button_podcast_help"
                // }, {texte: "export_button_podcast_help"}
            ];
        }

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param podcast
         */
        function toggle(podcast) {
            getElement();
            podcast.checked = !podcast.checked;
            var idx = selectedPodcasts.indexOf(podcast);
            if (idx > -1) {
                selectedPodcasts.splice(idx, 1);
            }
            else {
                selectedPodcasts.push(podcast);
            }
            vm.selectedPodcasts = angular.copy(selectedPodcasts);
        }


        function toggleAll() {
            getElement();
            if (selectedPodcasts.length === vm.podcasts.length) {
                vm.selectedPodcasts = [];
            }

            else if ((selectedPodcasts.length === 0) || (selectedPodcasts.length > 0)) {
                vm.selectedPodcasts = vm.podcasts.slice(0);
            }
            selectedPodcasts = angular.copy(vm.selectedPodcasts);
            var list_podcasts = angular.copy(vm.podcastsDataTable);
            angular.forEach(list_podcasts, function (value, key) {
                if (value !== undefined)
                    vm.podcastsDataTable[key].checked = selectedPodcasts.length > 0;
            });
        }

        /**
         * Show Podcast Details
         * @param podcast
         */
        function showPodcastDetail(podcast, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('podcast.modalGetPodcast@get', {id: podcast.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {parametersPodcastData: response},
                            templateUrl: 'app/main/media/podcast/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: function (parametersPodcastData, $mdDialog) {
                                var vm = this;
                                vm.podcast = parametersPodcastData;
                                vm.cancel = cancel;

                                function cancel() {
                                    $mdDialog.hide();
                                }
                            },
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchPodcastsInAPI(filtre), true);
        }


        /**
         * redirection to add new podcast page
         * @param event
         */
        function addNewPodcast() {
            clearFlashMessage();
            $state.go('app.podcast_upload');
        }

        /**
         * Delete Podcast Confirm Dialog
         */
        function deletePodcastConfirm(Podcast, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "PODCASTLIST.delete_podcast_msg",
                "PODCASTLIST.delete_podcast_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['PODCASTLIST.delete_podcast_msg'])
                        .htmlContent('<b>' + Podcast.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['PODCASTLIST.delete_podcast_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deletePodcast(Podcast);
                        vm.selectedPodcasts = [];
                        selectedPodcasts = [];

                    });
                });


        }

        /**
         * Delete Podcast
         */
        function deletePodcast(Podcast) {
            clearFlashMessage();
            if (vm.podcasts.indexOf(Podcast) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('podcast.mdelete@delete', {id: Podcast.id},
                    function (response) {

                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "PODCASTLIST.dialog_alert_delete_title",
                                "PODCASTLIST.dialog_alert_delete_description",
                                "PODCASTLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Podcast.title + translatedValues['PODCASTLIST.dialog_alert_delete_description']);
                                    $state.reload();
                                });

                        }
                        else {

                            $translate([
                                "PODCASTLIST.dialog_alert_delete_error_title",
                                "PODCASTLIST.dialog_alert_delete_error_description",
                                "PODCASTLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['PODCASTLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['PODCASTLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['PODCASTLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        ///////////////////////////////////////////////////////////////////////////////////
        /**
         * Delete Podcast Confirm Dialog
         */
        function deleteSelectedPodcastsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedPodcasts.length !== 0) {
                if(vm.selectedPodcasts.length === 1){
                    title = 'PODCASTLIST.delete_podcast_msg';
                    ariaLabel = 'PODCASTLIST.delete_podcast_aria_label';
                }else{
                    title = 'PODCASTLIST.delete_list_podcast_msg';
                    ariaLabel = 'PODCASTLIST.delete_podcasts_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedPodcasts.length,title,ariaLabel)).then(function () {
                    deleteSelectedPodcasts(ev);
                }, function () {
                });

            }

        }

        /**
         * Delete Podcast
         */
        function deleteSelectedPodcasts(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;


            msApi.request('podcast.deletePodcasts@delete', {
                    list: (function (list) {
                        vm.selectedPodcasts.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("PODCASTLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("PODCASTLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('PODCASTLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedPodcasts = [];
                        selectedPodcasts = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('PODCASTLIST.dialog_alert_delete_error_title'),
                            $translate.instant('PODCASTLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedPodcasts = [];
                        selectedPodcasts = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedPodcasts = [];
                    selectedPodcasts = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function goToStatsPodcast(id){
          console.log("id------",id)
            $state.go('app.stats_podcast_by_id.audience', {id: id});
        }
        function previewPodcast(id) {
            $rootScope.loadingProgress = true;
            msApi.request('podcast.getLinkPreview@get', {id: id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            controller: function (podcastData, $mdDialog, $translate, $sce) {
                                var vm = this;
                                vm.trustLink = trustLink;

                                function trustLink(link) {
                                    return $sce.trustAsResourceUrl(link);
                                }

                                vm.link = podcastData.link;

                                vm.closeDialog = closeDialog;

                                /**
                                 * Close the dialog
                                 */
                                function closeDialog() {
                                    $mdDialog.hide();

                                }
                            },
                            controllerAs: 'vm',
                            locals: {
                                podcastData: response
                            },
                            templateUrl: 'app/main/media/podcast/list/preview.modal.html',
                            clickOutsideToClose: true

                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                console.log('error');
                console.log(response);
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        console.log(response.data.message);
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            console.log(message);
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function getExportLinks(podcast, $ev) {
            msApi.request('podcast.getExportLinks@get', {id: podcast.id},
                function (res) {
                    $mdDialog.show({
                        controller: function (entity, links, $mdDialog) {
                            var vm = this;
                            vm.podcast = entity;
                            vm.links = links;
                            vm.closeDialog = closeDialog;
                            vm.link_embed =  vm.links.url_export_podcast;
                            function closeDialog() {
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/podcast/list/url.modale.template.html',
                        targetEvent: $ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: podcast,
                            links: res.data
                        }
                    });
                },
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
                        $translate('VALIDATIONS.' + res.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         *  call the api
         */
        function searchPodcasts() {
            filtre["search[value]"] = vm.search_podcasts;
            searchPodcastsInAPI(filtre);
        }

        var checkIfNotTranscodedPodcastsAreTranscodedInterval = $interval(function () {
            checkIfNotTranscodedPodcastsAreTranscoded()

        }, 30000);

        function checkIfNotTranscodedPodcastsAreTranscoded() {
            if (notTranscodedPodcasts.length) {
                msApi.request(
                    'podcast.check_transcoding@save',
                    {list: notTranscodedPodcasts},
                    function (res) {
                        if (res.code === 200 && res.podcasts.length) {
                            for (var i = 0; i < res.podcasts.length; i++) {
                                removeFromNotTranscodedArrayPodcasts(res.podcasts[i]);
                            }
                            rerender();
                            if (notTranscodedPodcasts.length === 0) $interval.cancel(checkIfNotTranscodedPodcastsAreTranscodedInterval);
                        }
                    },
                    function () {
                        $interval.cancel(checkIfNotTranscodedPodcastsAreTranscodedInterval);
                    }
                );
            }
            else {
                $interval.cancel(checkIfNotTranscodedPodcastsAreTranscodedInterval);
            }
        }

        function toggleInNotTranscodedPodcasts(podcast) {
            if (!podcast.isReady && notTranscodedPodcasts.indexOf(podcast.id) === -1) {
                notTranscodedPodcasts.push(podcast.id);
            }
            return podcast.isReady ? true : false;
        }

        /**
         * Check if all video are transcoded, if so stop checking
         */
        function removeFromNotTranscodedArrayPodcasts(podcast) {
            for (var k = 0; k < vm.podcasts.length; k++) {
                if (vm.podcasts[k].id === podcast.id) {
                    vm.podcasts[k] = podcast;
                    notTranscodedPodcasts.splice(notTranscodedPodcasts.indexOf(podcast.id), 1);
                    break;
                }
            }
        }

        $scope.$on('$destroy', function () {
            $interval.cancel(checkIfNotTranscodedPodcastsAreTranscodedInterval);
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.podcast.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.podcast_add', {
                url: "/podcast/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/podcast/add_edit_view/form.template.html',
                        controller: 'podcastAddController as vm'
                    }
                },
                resolve: {

                    categoryChoices: function (msApi) {
                        return msApi.resolve('podcast.categoryChoices@get');
                    },
                    parametersPodcastData: function (msApi) {
                        return msApi.resolve('podcast.getNewPodcastData@get', {id: 0});
                    }
                },
                "bodyClass": "forms"
            })
        /*.state('app.parameters_theme_detail',{
            url: Routing.generate('emp_video_settings_theme_detail')+"/:id"
        })*/;


        //API
        msApiProvider.register('podcast.getNewPodcastData', [Routing.generate('api_podcast_get_detail_podcast', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('podcast.addPodcast', [Routing.generate('api_podcast_post_add_podcast')]);
        msApiProvider.register('podcast.categoryChoices', [Routing.generate('api_podcast_category_get_podcast_category_choices_for_select_input')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.podcast.add')
    .controller('podcastAddController', podcastAddController);

  /** @ngInject */
  function podcastAddController(parametersPodcastData,$cookies, webTvGlobal, $injector, categoryChoices, $scope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msUtils = $injector.get('msUtils'),
      msApi = $injector.get('msApi');

    var vm = this;
    vm.isNew = true;
    var imageName;
    vm.urlVignette = "";
    vm.minDate = new Date(moment(new Date()).format("YYYY-MM-DD"));
    vm.maxDate = new Date(moment(new Date()).add(10,'years').format("YYYY-MM-DD"));

    //vm.category = webTvGlobal.convertToSelectChoicesFormat(categoryChoices.choices);
    vm.category =categoryChoices;
    if (angular.isUndefined($rootScope.arrayPodcast))
      $state.go('app.podcast_upload');
    //
    // vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
    //   "form_choices_yes": 1,
    //   "form_choices_no": 0
    // });
    //
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.array = $rootScope.arrayPodcast;
    vm.empParametersPodcastError = [];
    vm.podcast = parametersPodcastData;
    vm.empParametersPodcastForm = {
      title: vm.podcast.title,
      description: vm.podcast.description,
      explicite: vm.podcast.explicite ? vm.podcast.explicite : 0,
      lang: vm.podcast.lang ? vm.podcast.lang : "",
      vignette: vm.podcast.vignette || "",
      podcastCategory: vm.podcast.podcastCategory ? vm.podcast.podcastCategory : null,
      podcastItems: [],
      startDate: new Date(moment().format('YYYY-MM-DD')),
      endDate: new Date(moment().add(10, "years").format('YYYY-MM-DD')),
      is_accessible:true,
    };

    var i;
    vm.click = click;

    function click($index) {

      var acc = document.getElementsByClassName("accordion");

      acc[$index].classList.toggle("active");
      var panel = acc[$index].nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }


    }

    vm.submitAddPodcastForm = submitAddPodcastForm;
// vm.returnToList = returnToList;


//FILE PARAMETERS DEFINITION AND FUNCTIONS
// vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_podcast_post_podcast_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    angular.forEach(vm.array, function (value, key) {

      value.ngFlowPodcastOptions = {
        target: Routing.generate('api_podcast_post_podcast_thumb'),
        singleFile: true,
        testChunks: false,
        fileParameterName: 'empApiFileForm[thumb]',
        headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      };
      if (/chrome/.test(msUtils.detectBrowser().browser)) value.ngFlowPodcastOptions.attributes = 'image/*';
      value.ngFlowPodcast = {
        flow: {}
      };
    });
// Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.selectCategory = selectCategory;
    $scope.indexToModify = null;
    $scope.message = "";
    vm.uploadingInPogress = 0;
    vm.changeDate = changeDate;


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.parameters_podcast_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.parameters_podcast_add_menuTitle";
      $rootScope.pageRoute = "app.podcast_list";
      $rootScope.welcome = "";
      $rootScope.text = [];
    }

    function changeDate() {
      //verification date in et date out
      if(vm.empParametersPodcastForm.endDate < vm.empParametersPodcastForm.startDate){
        vm.empParametersPodcastForm.endDate = vm.empParametersPodcastForm.startDate
      }
    }


    /**
     * Send add Theme Form
     */
    function submitAddPodcastForm() {
      $rootScope.loadingProgress = true;
      for (var i = 0; i < vm.array.length; i++) {
          if(!angular.isDefined(vm.empParametersPodcastForm.podcastItems[i]) || !vm.empParametersPodcastForm.podcastItems[i].title){
              vm.empParametersPodcastForm.podcastItems.splice(i, 1, {title : vm.array[i].audio});
          }
          if(angular.isDefined(vm.empParametersPodcastForm.podcastItems[i])){
              vm.empParametersPodcastForm.podcastItems[i].audio = vm.array[i].audio;
              vm.empParametersPodcastForm.podcastItems[i].vignette = vm.array[i].vignette;
          }
      }
      if (vm.empParametersPodcastForm.explicite === '1')
        vm.empParametersPodcastForm.explicite = true;
      else
        vm.empParametersPodcastForm.explicite = false;
      msApi.request('podcast.addPodcast@save',
        {"empParametersPodcastForm": angular.copy(vm.empParametersPodcastForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.podcast = vm.empParametersPodcastForm;
            webTvGlobal.$flashMessages().set('parametersPodcastAdd', {title: vm.empParametersPodcastForm.title ? vm.empParametersPodcastForm.title : ""});
            $state.go('app.podcast_list');

          }
          else if (angular.isDefined(res.errors)) {

            vm.empParametersPodcastError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empParametersPodcastError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersPodcastForm[item.for])
              };
            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersPodcastForm button[type='submit']").hide();
    }

    function selectCategory(type, value){
      vm.empParametersPodcastForm.podcastCategory=value
      $rootScope.ngModel=value
    }
    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {

      vm.ngFlow.flow.upload();

    }


    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location) {
        vm.empParametersPodcastForm.vignette = vm.podcast.vignette = res.location.path;
        vm.urlVignette = res.location.url;
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {

      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empParametersPodcastForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empParametersPodcastForm.vignette = "";
        });
      }
    }


    vm.uploadPodcastFile = uploadPodcastFile;
    vm.filePodcastAdded = filePodcastAdded;
    vm.filePodcastSuccess = filePodcastSuccess;
    vm.uploadPodcastComplete = uploadPodcastComplete;
    var slideFile, slideFileName = undefined;


    function uploadPodcastFile(thumb) {
      // thumb.ngFlowPodcast.flow.opts.headers = {};
      thumb.ngFlowPodcast.flow.upload();
    }

    function filePodcastAdded(file, slide) {
      slideFile = undefined;
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('VIDEORICHMEDIA.alert_not_valid_slide_image_message'));
        return false;
      }
      slideFile = file;
    }

    function filePodcastSuccess(file, message) {
      $scope.message = message;
      if (/^ERROR !$/.test(message) || /^ERROR$/.test(message)) return;

    }

    function uploadPodcastComplete() {

      $rootScope.loadingProgress = false;
    }

    vm.chooseThumb = chooseThumb;

    function chooseThumb(index) {
      $scope.indexToModify = index;
    }

    vm.tab = [];
    $scope.$watch('[message,indexToModify]', function (newValue) {
      var index = newValue[1];

      var message = newValue[0];
      var data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      if (angular.isDefined(slideFile)) {

        vm.array[index].vignette = data.location.url;


      }
      slideFile = undefined;
    });
  }

})
();

(function () {
    'use strict';

    angular
        .module('app.podcast.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.podcast_edit', {
                url: "/podcast/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/podcast/add_edit_view/form.template.html',
                        controller: 'podcastEditController as vm'
                    }
                },
                resolve: {
                    categoryChoices: function (msApi) {
                        return msApi.resolve('podcast.categoryChoices@get');
                    },
                    parametersPodcastData: function (msApi, $stateParams) {
                        return msApi.resolve('podcast.getPodcast@get', {id: $stateParams.id});
                    }

                },
                "bodyClass": "forms"
            });


        // API

        msApiProvider.register('podcast.getPodcast', [Routing.generate('api_podcast_get_detail_podcast', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('podcast.editPodcast', [Routing.generate('api_podcast_post_edit_podcast', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('podcast.categoryChoices', [Routing.generate('api_podcast_category_get_podcast_category_choices_for_select_input')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.podcast.edit')
    .controller('podcastEditController', podcastEditController);

  /** @ngInject */
  function podcastEditController($scope, $cookies,webTvGlobal, parametersPodcastData, categoryChoices, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');

    var vm = this;
    var imageName;
    vm.isNew = false;
    vm.empParametersPodcastError = [];
    $rootScope.itemName = "";
    vm.urlVignette = "";
    // var listPodcasts = parametersPodcastsByChannelsAndParent;
    var podcastListBefore = [];
    // vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
    //   "form_choices_yes": 1,
    //   "form_choices_no": 0
    // });
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.category =categoryChoices;// webTvGlobal.convertToSelectChoicesFormat(categoryChoices.choices);
    vm.podcast = parametersPodcastData;
    vm.empParametersPodcastForm = {};
    vm.submitAddPodcastForm = submitAddPodcastForm;
    vm.selectCategory = selectCategory;
    vm.changeDate = changeDate;
    // vm.returnToList = returnToList;
    fillData();
    vm.ngFlowOptions = {
      target: Routing.generate('api_podcast_post_podcast_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    angular.forEach(vm.array, function (value, key) {

      value.ngFlowPodcastOptions = {
        target: Routing.generate('api_podcast_post_podcast_thumb'),
        singleFile: true,
        testChunks: false,
        fileParameterName: 'empApiFileForm[thumb]',
        headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      };
      if (/chrome/.test(msUtils.detectBrowser().browser)) value.ngFlowPodcastOptions.attributes = 'image/*';
      value.ngFlowPodcast = {
        flow: {}
      };
    });
    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    $scope.indexToModify = null;
    $scope.message = "";
    vm.uploadingInPogress = 0;
    initHelp();
   // checkAccessible()
    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.parameters_podcast_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.parameters_podcast_edit_menuTitle";
      $rootScope.pageRoute = "app.podcast_list";
      $rootScope.welcome = "";
      $rootScope.text = [];
    }
    vm.minDate = new Date(moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ"));
    vm.maxDate = new Date(moment(new Date()).add(10,'years').format("YYYY-MM-DD HH:mm:ssZ"));
    /**
     * Check if podcast exists
     * @return if exists get Podcast Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.podcast.code) && vm.podcast.code !== 200) $state.go('app.error_404');
      else {

        vm.empParametersPodcastForm = {
          title: vm.podcast.title,
          description: vm.podcast.description,
          explicite: vm.podcast.explicite ? 1 : 0,
          lang: vm.podcast.lang ? vm.podcast.lang : $translate.preferredLanguage(),
          vignette: vm.podcast.vignette || "",
          podcastCategory: vm.podcast.podcastCategory && vm.podcast.podcastCategory.id ? vm.podcast.podcastCategory.id : null,
          podcastItems: vm.podcast.podcastItems ? vm.podcast.podcastItems : [],
          startDate: new Date(moment( vm.podcast.startDate)),
          endDate: new Date(moment( vm.podcast.endDate)),
          is_accessible:vm.podcast.is_accessible,
        };
        vm.array = angular.copy(vm.empParametersPodcastForm.podcastItems);

      }
    }

    function changeDate() {
      //verification date in et date out
      if(vm.empParametersPodcastForm.endDate < vm.empParametersPodcastForm.startDate){
        vm.empParametersPodcastForm.endDate = vm.empParametersPodcastForm.startDate
      }
    }

    var i;
    vm.click = click;

    function click($index) {

      var acc = document.getElementsByClassName("accordion");

      acc[$index].classList.toggle("active");
      var panel = acc[$index].nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }


    }

    /**
     * Send add Podcast Form
     */
    function submitAddPodcastForm() {
      $rootScope.loadingProgress = true;
      for (var i = 0; i < vm.array.length; i++) {
          if(!vm.empParametersPodcastForm.podcastItems[i].title){
              vm.empParametersPodcastForm.podcastItems[i].title = vm.array[i].audio;
          }
        vm.empParametersPodcastForm.podcastItems[i].audio = vm.array[i].audio;
        vignetteArray = vm.array[i].vignette.split("/")
        vm.empParametersPodcastForm.podcastItems[i].vignette = vignetteArray[vignetteArray.length - 1];
      }
      const vignetteArray = vm.empParametersPodcastForm.vignette.split("/")
      vm.empParametersPodcastForm.vignette = vignetteArray[vignetteArray.length - 1]
      if (vm.empParametersPodcastForm.explicite === '1')
        vm.empParametersPodcastForm.explicite = true;
      else
        vm.empParametersPodcastForm.explicite = false;

      msApi.request('podcast.editPodcast@save',
        {id: vm.podcast.id, "empParametersPodcastForm": angular.copy(vm.empParametersPodcastForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.podcast = vm.empParametersPodcastForm;
            webTvGlobal.$flashMessages().set('parametersPodcastEdit', vm.podcast);
            $state.go('app.podcast_list');
          }
          else if (angular.isDefined(res.errors)) {
            vm.empParametersPodcastError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empParametersPodcastError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersPodcastForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    function selectCategory(type, value){
      vm.empParametersPodcastForm.podcastCategory=value
      $rootScope.ngModel=value
    }
    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersPodcastForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      vm.uploadingInPogress = 0;
      var res = angular.fromJson(message);
      if (res.location) {
          vm.empParametersPodcastForm.vignette = vm.podcast.vignette = res.location.path;
        vm.urlVignette = res.location.url;
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {

        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empParametersPodcastForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        vm.loadComplete = true;
        $scope.empParametersPodcastForm.$pristine = false;
        empParametersPodcastForm.$invalid = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empParametersPodcastForm.vignette = "";
        });
      }
    }

    vm.uploadPodcastFile = uploadPodcastFile;
    vm.filePodcastAdded = filePodcastAdded;
    vm.filePodcastSuccess = filePodcastSuccess;
    vm.uploadPodcastComplete = uploadPodcastComplete;
    var slideFile, slideFileName = undefined;


    function uploadPodcastFile(thumb) {
      // thumb.ngFlowPodcast.flow.opts.headers = {};
      thumb.ngFlowPodcast.flow.upload();
    }

    function filePodcastAdded(file, slide) {
      slideFile = undefined;
      if (!/(jpg|jpeg|png|gif)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('VIDEORICHMEDIA.alert_not_valid_slide_image_message'));
        return false;
      }
      slideFile = file;
    }

    function filePodcastSuccess(file, message) {
      $scope.message = message;
      if (/^ERROR !$/.test(message) || /^ERROR$/.test(message)) return;

    }

    function uploadPodcastComplete() {

      $rootScope.loadingProgress = false;
    }

    vm.chooseThumb = chooseThumb;

    function chooseThumb(index) {
      $scope.indexToModify = index;
    }

    $scope.$watch('[message,indexToModify]', function (newValue) {
      var index = newValue[1];

      var message = newValue[0];
      var data = null;

      try {
        data = JSON.parse(message);
      } catch (e) {
        return;
      }
      if (angular.isDefined(slideFile)) {

        vm.array[index].vignette = data.location.url;


      }
      slideFile = undefined;
    });


  }

})();

(function ()
{
    'use strict';

    /** @ngInject */
function config(msApiProvider) {
    // Api

    msApiProvider.register('addLanguageToEvent', [Routing.generate('api_post_add_lang_event')]);

}

angular.module('app.event.list.language', [])
    .config(config);

})();
(function ()
{
    'use strict';
angular.module('app.event.list.language')

    .directive('chooseLanguage', function () {
        return {
            scope: {
                event: '=event',
                render: "=render"
            },
            controllerAs: 'vm',
            controller: 'addLanguageController',
            restrict: 'E',
            link: function () {
            },
            templateUrl: 'app/main/media/event_live/language/language.html'
        };
    });

})();
(function () {
  'use strict';

  angular
    .module('app.event.list.language')
    .controller('addLanguageController', addLanguageController);

  function addLanguageController(webTvGlobal, $rootScope, msApi, $translate, $filter) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    var flashMessages = {title: ""};
    vm.sendLanguage = sendLanguage;
    vm.openMenu = openMenu;


    function openMenu($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    }

    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    function sendLanguage(language, event) {
      clearFlashMessage();
      var has_lang = $filter('filter')(event.video.medias, {lang: language}, true);
      if (has_lang.length === 0) {
        $rootScope.loadingProgress = true;
        msApi.request('addLanguageToEvent@save', {
          event_id: event.id,
          event_lang: language
        }, function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.added_language"));
            $rootScope.rerender();
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }

        })
      }
      else {
        webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.language_exist"));
      }

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.event.edit', ['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State


        $stateProvider
            .state('app.event_edit', {
                url: "/event/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/event_live/add_edit_view/form.template.html',
                        controller: 'eventLiveEditController as vm'
                    }
                },
                resolve: {
                    eventData: function (msApi, $stateParams) {
                        return msApi.resolve('eventLive.getNewEvent@get', {id: $stateParams.id});
                    },
                    eventLiveStations: function (msApi) {
                        return msApi.resolve('eventLive.getStations@get');
                    },
                    specificsDirectionNames: function (msApi) {
                        return msApi.resolve('direction.getDirectionsNames@get');
                    },
                    themesNames: function (msApi) {
                        return msApi.resolve('eventLive.getThemesNames@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "event_post_add_action"
            });


        //API
        msApiProvider.register('eventLive.editEvent', [Routing.generate('api_post_edit_event_live', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('eventLive.getStations', [Routing.generate('api_specifics_get_list_station')]);
        msApiProvider.register('eventLive.getThemesNames', [Routing.generate('api_parameters_get_themes_names')]);

    }
})();
(function () {
  'use strict';

  angular
    .module('app.event.edit')
    .controller('eventLiveEditController', eventLiveEditController);

  /** @ngInject */
  function eventLiveEditController(eventData, $cookies,webTvGlobal, eventLiveStations, specificsDirectionNames, themesNames, $injector, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msUtils = $injector.get('msUtils'),
      msApi = $injector.get('msApi');
    var vm = this;
    var imageName;
    var inProgress;
    vm.urlVignette = "";
      if(angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)&& webTvGlobal.$constant().webTvParameterBag().intranet_internet_video==='1')
          vm.isIntranet_Internet = true;
      else vm.isIntranet_Internet = false;
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.event = eventData;
    vm.categoryChoices = webTvGlobal.convertToSelectChoicesFormat(specificsDirectionNames.names);
    vm.themesNames = webTvGlobal.convertToSelectChoicesFormat(themesNames.names);
    vm.accessChoices = webTvGlobal.convertToSelectChoicesFormat({
      "Public": "Public",
      "loginRequired": "loginRequired",
      "protected": "protected"
    });

    vm.stations = webTvGlobal.convertToSelectChoicesFormat(eventLiveStations.names);


    vm.empEventForm = {};
    vm.submitAddEventForm = submitAddEventForm;
    vm.returnToList = returnToList;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;
    vm.changeEndtime = changeEndtime;
    vm.change = change;
    fillData();


    function change() {
      if (vm.external_link)
        vm.empEventForm.station = "";
      else vm.empEventForm.station = null;
    }

    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.event_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.event_edit_pagetitle";
      if (angular.isUndefined($rootScope.currentState) || $rootScope.currentState === "") {
        $rootScope.pageRoute = 'app.event_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "welcome_event_edit";
      $rootScope.text = [{
        texte: "parameters_event_add_help"
      }, {
        texte: "upload_button_event_add_help"
      }, {
        texte: "send_button_event_add_help"
      }, {
        texte: "cancel_button_event_add_help"
      }];

    }

    function getLanguagesList(list, data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].lang !== "or") {
          list.push(data[i].lang);
        }

      }
      return list;
    }

    function splitKeyWords(chain) {
      var words = chain.split(' ') || [];
      words = words.filter(function (item, pos) {
        return words.indexOf(item) === pos;
      });
      return words;
    }

    /**
     * Check if event exists
     * @return if exists get Theme Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.event.code) && vm.event.code !== 200) $state.go('app.error_404');
      else {
        vm.empEventForm = {


          language: getLanguagesList([], vm.event.video.medias),
          conference_key: vm.event.conference_key,
          category: vm.event.category.id,
          date_start: vm.event.date_start,
          date_end: vm.event.date_end,

          mdTime: {
            date: new Date(moment(vm.event.video.startDate)),
            time: new Date(moment(vm.event.video.startDate)),
            timeMin: new Date(new Date(moment(vm.event.video.startDate)).getTime() + 300000)
          },
          endtime: new Date(moment(vm.event.video.endDate)),
          rich_media_presentation: vm.event.rich_media_presentation,
          url_title: vm.event.url_title,
          url: vm.event.url,
          organizer_name: vm.event.organizer_name,
          organizer_email: vm.event.organizer_email,
          sms_count: vm.event.sms_count,
          access_type: vm.event.access_type,
          comment: vm.event.comment,
          video: {
            author: vm.event.video.author,
            copyright: vm.event.video.copyright,
            description: vm.event.video.description,
            logo: vm.event.video.logo,
            downloadable: vm.event.video.downloadable,
            startDate: vm.event.video.startDate,
            endDate: vm.event.video.endDate,
            title: vm.event.video.title,
            keyWords: vm.event.video.keyWords !== null ? splitKeyWords(vm.event.video.keyWords) : [],
            // offline: vm.event.video.offline,
            direction: vm.event.video.themes[0].id,
            medias: vm.event.video.medias,
            themes: vm.event.video.themes,
            isVisibleOnInternet: vm.event.video.isVisibleOnInternet,
            isVisibleOnIntranet: vm.event.video.isVisibleOnIntranet,
            isSecuredOnInternet: vm.event.video.isSecuredOnInternet,
            isSecuredOnIntranet: vm.event.video.isSecuredOnIntranet,
            passwordInternet: vm.event.video.passwordInternet,
            passwordIntranet: vm.event.video.passwordIntranet

          }

        };
        if(vm.event.video.offline)
            vm.empEventForm.offline=false;
        else
            vm.empEventForm.offline=true;

          if (vm.empEventForm.video.keyWords[0] == "")
          vm.empEventForm.video.keyWords = [];
        if (vm.event.externalUrl) {
          vm.external_link = true;
          vm.empEventForm.station = "";
          vm.empEventForm.externalUrl = vm.event.externalUrl;
        }
        else {
          if (vm.event.station)
            vm.empEventForm.station = vm.event.station.id;
          else
              vm.empEventForm.station="";
        }


        // speaker: vm.event.speaker ? vm.event.speaker : true,
        angular.forEach(vm.event.video.medias, function (value) {
          if (value.lang === "or") {
            vm.empEventForm.speaker = true;
          }
        });
      }
    }


    //vm.minDate = vm.empEventForm.mdTime.date;

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;


    /**
     * return to event list page
     * @return redirect to event list page
     */
    function returnToList() {

      if (angular.isUndefined($rootScope.currentState) || $rootScope.currentState === "") {
        $state.go('app.event_list_ongoing');
      }
      else {
        $state.go($rootScope.currentState);
      }
    }


    function changeDate() {
      vm.empEventForm.video.startDate = vm.empEventForm.video.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empEventForm.mdTime.date).format('YYYY-MM-DD'));
      vm.empEventForm.video.endDate = vm.empEventForm.video.endDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empEventForm.mdTime.date).format('YYYY-MM-DD'));


    }

    function changeTime() {
      vm.empEventForm.video.startDate = vm.empEventForm.video.startDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empEventForm.mdTime.time).format('HH:mm:ss'));
      vm.empEventForm.mdTime.timeMin = new Date(new Date(moment(vm.empEventForm.video.startDate)).getTime() + 300000);
    }

    function changeEndtime() {
      vm.empEventForm.video.endDate = vm.empEventForm.video.endDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empEventForm.endtime).format('HH:mm:ss'));

    }


    /**
     * Send add event Form
     */
    function submitAddEventForm() {
      var formData = angular.copy(vm.empEventForm);
      formData.video.medias = [];
      formData.video.themes = [];
      angular.forEach(formData.language, function (value) {
        formData.video.medias.push({lang: value});
      });
      if (formData.speaker) {
        formData.video.medias.push({lang: "or"});
      }
      formData.video.themes.push(formData.video.direction);
      delete formData.video.direction;
      delete formData.language;
      delete formData.keyWords;
      delete formData.date_start;
      delete formData.date_end;
        if(angular.isDefined(formData.video.offline && formData.video.offline===true)){
            formData.video.offline=false;

        }   else
            formData.video.offline=true;
      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      if (angular.isDefined(formData.endtime)) delete formData.endtime;
      if (angular.isUndefined(formData.access_type)) delete formData.access_type;
      if (formData.video.isVisibleOnInternet === false) delete formData.video.isVisibleOnInternet;
      if (formData.video.isVisibleOnIntranet === false) delete formData.video.isVisibleOnIntranet;
      if (formData.video.isSecuredOnInternet) {
        delete formData.video.isSecuredOnIntranet;
        delete formData.video.passwordIntranet;
      } else {
        delete formData.video.isSecuredOnInternet;
        delete formData.video.passwordInternet;
      }
      if (formData.video.isSecuredOnIntranet) {
        delete formData.video.isSecuredOnInternet;
        delete formData.video.passwordInternet;
      }
      else {
        delete formData.video.isSecuredOnIntranet;
        delete formData.video.passwordIntranet;
      }
      formData.video.keyWords = angular.isFunction(formData.video.keyWords.join) ? formData.video.keyWords.join(' ') : "none";
      delete formData.speaker;
      $rootScope.loadingProgress = true;
      msApi.request('eventLive.editEvent@save',
        {"empEventForm": formData, id: vm.event.id},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('EventEdit', {title: vm.empEventForm.title ? vm.empEventForm.title : ""});
            $state.go('app.event_list_ongoing');
          }
          else if (angular.isDefined(res.errors)) {
              vm.empEventError = [];
              var errors = res.errors;
              errors.forEach(function (item) {
                  vm.empEventError[item.for] = {
                      message: item.messages[0],
                      value_old: angular.copy(vm.empEventForm[item.for])
                  };
              });
              if(angular.isDefined(vm.empEventError["conference_key"]))
                  webTvGlobal.alertDialog($translate.instant('VALIDATIONS.eventOrganizer.conference_key.unique'));
          }
          else {
              $rootScope.loadingProgress = false;
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empEventForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empEventForm.video.logo = vm.event.video.logo = res.location.url;

        vm.urlVignette = res.location.url;

      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empEventForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empEventForm.thumbnail = "";
        });
      }
    }


  }
})();


(function () {
    'use strict';

    angular
        .module('app.event.list', ['datatables', 'ngclipboard', 'app.event.list.language'])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.event_list', {
                url: "/event/list",
                abstract: true,
                resolve: {
                    // parametersCanalNamesData: function (msApi) {
                    //     return msApi.resolve('parameters_canal.getNames@get');
                    // }
                }
            })
            .state('app.event_list_ongoing', {
                parent: 'app.event_list',
                url: '/on-going',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/event_live/list/list.template.html',
                        controller: 'eventLiveListController as vm'
                    }
                },
                resolve: {
                    eventsData: function () {
                        return "event.getOnGoingEvents@get";
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "event_list_dtable_events_ongoing_action"
            })
            .state('app.event_list_upcoming', {
                parent: 'app.event_list',
                url: '/up-coming',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/event_live/list/list.template.html',
                        controller: 'eventLiveListController as vm'
                    }
                },
                resolve: {
                    eventsData: function () {
                        return "event.getUpComingEvents@get";
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "event_list_dtable_events_upcoming_action"
            });

        // Api
        msApiProvider.register('event.getOnGoingEvents', [Routing.generate('api_dtable_list_dtable_events_ongoing')]);
        msApiProvider.register('event.getUpComingEvents', [Routing.generate('api_dtable_list_dtable_events_upcoming')]);
        msApiProvider.register('event.getArchivedEvents', [Routing.generate('api_get_archived_events')]);
        var deleteEventRoute = Routing.generate('api_delete_event_live') + "/:id";
        msApiProvider.register('eventLive.list', [Routing.generate('api_dtable_list_dtable_events')]);
        msApiProvider.register('eventLive.delete', [deleteEventRoute, {id: '@id'}]);
        msApiProvider.register('eventLive.mdelete', [deleteEventRoute, {id: '@id'}]);
        var deleteListEvents = Routing.generate('api_multi_delete_multi_events') + "/:list";
        msApiProvider.register('eventLive.deleteEvents', [deleteListEvents, {list: '@list'}]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('parameters_themes.getNames', [Routing.generate('api_parameters_get_themes_names')]);
        msApiProvider.register('eventLive.getExportLinks', [Routing.generate('api_event_url_export_detail', {id: ':id'}).replace(/%3A/, ":")]);
        var deleteLanguageOrateur = Routing.generate('api_delete_lang_event_live') + "/:id/:lang";
        msApiProvider.register('eventLive.deleteLanguageOrateur', [deleteLanguageOrateur, {
            id: '@id', lang: '@lang'
        }])
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('app.event.list')
        .controller('eventLiveListController', eventLiveListController);

    /** @ngInject */
    function eventLiveListController(DTOptionsBuilder, $cookies, DTColumnBuilder, eventsData, $scope, webTvGlobal, order_video, $injector, dtable_language, dialogConfirmDeleteService,$sce) {

        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            msUtils = $injector.get('msUtils'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $compile = $injector.get('$compile'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            $document = webTvGlobal.$document;
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var columnsApi = order_video;
        // vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);
        vm.events = eventsData.data;
        vm.selectedEvents = [];
        var selectedEvents = [];
        vm.eventsDataTable = {};
        vm.dtInstance = {};
        vm.search_events = "";
        vm.search_event = "";
        vm.theme = "";
        vm.canal = "";
        $scope.someModel = null;
        $scope.someModelChannel = null;
        vm.startDate = null;

        vm.render = rerender;

        // on doit modifier les valeurs de themes par API
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    targets: 1,
                    width: '72px'
                },
                {
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }

            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.eventsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.eventsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggleSelectEvent(vm.eventsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.eventsDataTable[data.id] = data;
                    var intranetHtml = "";
                    var internetHtml = "";
                    var serverHtml = "";
                    if (data.rich_media_presentation) {
                        serverHtml +=
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.rich_media_presentation'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<any class="ng-binding" style="font-size: 12px;margin-left: 15px;">&nbsp;RM' +
                            '</any>' +
                            '</a>';
                    }
                    if (data.video.isVisibleOnIntranet)
                        intranetHtml = '<a tooltips tooltip-template=' + "{{'MESSAGES.intranet_broadcast'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="md-icon-button" aria-label="description_audio" translate translate-attr-aria-label="MESSAGES.description_audio"><img ng-src="assets/icons/intranet.png"/></md-button></a>';
                    if (data.video.isVisibleOnInternet)
                        internetHtml = '<a tooltips tooltip-template=' + "{{'MESSAGES.internet_broadcast'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="md-icon-button" aria-label="description_audio" translate translate-attr-aria-label="MESSAGES.description_audio"><img ng-src="assets/icons/internet.png"/></md-button></a>';
                    return intranetHtml + internetHtml + serverHtml;
                }),


            DTColumnBuilder.newColumn('video.title').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.eventsDataTable[data.id] = data;
                    var serverHtml = "";
                    var languageHtml, speakerHtml = "";
                    if (angular.isDefined(data)) {
                        languageHtml = '<div>';
                        angular.forEach(data.video.medias, function (value) {
                            if (value.lang === "or") {
                                speakerHtml = '<a tooltips tooltip-template=' + "{{'EVENTADD.form_attr_speaker'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button style="width: auto;" class="" ng-click="vm.deleteLanguageConfirm(vm.eventsDataTable[' + data.id + '],\'' + value.lang + '\',$event)" aria-label="description_audio"><md-icon  style="font-size: 20px;" md-font-icon="icon-microphone" class="s18"></md-icon></md-button></a>';
                            }
                            else if (angular.isDefined(value.lang) && value.lang !== null) {
                                languageHtml += '<ms-delete-menu  render="vm.render" type="' + 'md-icon-button' + '" text="' + value.lang + '" icon="' + 'icon-unfold-more' + '" event= "vm.eventsDataTable[' + data.id + ']" > </ms-delete-menu>';
                            }
                        });
                        languageHtml += '</div>';
                        serverHtml = '<choose-Language render="vm.render" event="vm.eventsDataTable[' + data.id + ']" ></choose-Language>';
                    }
                    else {
                        serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                        languageHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                    }
                    return speakerHtml + languageHtml + serverHtml;
                }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                var htmladd = '<div style="padding: 5px;"><span>' + angular.isDefined(data.video.startDate) ? moment(data.video.startDate).format($rootScope.defaultDateFormat) : $translate.instant('MESSAGES.nonef') + '</span></div>';
                if (angular.isDefined(data.video.startDate)) {
                    htmladd += '<br>';
                    htmladd += ' <md-icon  md-font-icon="icon-play" class="s16" style="color: #5fa35f;margin-top: -3px;padding-right: 5px;"></md-icon>';
                    htmladd += '<span>' + angular.isDefined(data.video.startDate) ? moment(data.video.startDate).format('HH:mm:ss') : $translate.instant('MESSAGES.nonef') + '</span>';
                    htmladd += '<br>';
                    htmladd += ' <md-icon md-font-icon="icon-stop" class="s16" style="color: #e64242;margin-top: -3px;padding-right: 5px;"></md-icon>';
                    htmladd += '<span>' + angular.isDefined(data.video.endDate) ? moment(data.video.endDate).format('HH:mm:ss') : $translate.instant('MESSAGES.nonef') + '</span>';
                }
                return htmladd;
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    var buttons = "";
                    vm.eventsDataTable[data.id] = data;

                    var buttonEventsDetail = '<a has-permission="event_get_detail" tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="m16 md-icon-button" ng-click="vm.showEventDetail(vm.eventsDataTable[' + data.id + '])" aria-label="action_livedetail" translate translate-attr-aria-label="LIVESLIST.action_livedetail"><md-icon md-font-icon="icon-eye" class="s18"></md-icon></md-button></a>';
                    var buttonEditEvents = '<a has-permission="event_post_edit" tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="edit-button md-icon-button" ui-sref="app.event_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit"><md-icon md-font-icon="icon-pencil" class="s18"></md-icon></md-button></a>';
                    var buttonDeleteEvents = '<a has-permission="event_delete_event_live" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteEventConfirm(vm.eventsDataTable[' + data.id + '],ev)" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete">' + '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button>' +
                        '</a>';
                    var buttonExportEvents = '<a has-permission="event_export_no_api" tooltips tooltip-template=' + "{{'MESSAGES.action_export_event'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="m16 md-icon-button" ng-click="vm.getExportLinks(vm.eventsDataTable[' + data.id + '])" aria-label="action_export_event" translate translate-attr-aria-label="MESSAGES.action_export_event"><md-icon md-font-icon="icon-link-variant" class="s18"></md-icon></md-button></a>';
                    var buttonStatsEvents = '<a has-permission="event_stats_no_api" tooltips tooltip-template=' + "{{'MESSAGES.action_video_stats'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button class="m16 md-icon-button" ng-click="vm.getStatsEvent(vm.eventsDataTable[' + data.id + '])" aria-label="action_export_event" translate translate-attr-aria-label="MESSAGES.action_export_event"><md-icon md-font-icon="icon-chart-bar" class="s18"></md-icon></md-button></a>';
                    buttons += buttonEventsDetail + buttonEditEvents + buttonDeleteEvents + buttonExportEvents + buttonStatsEvents;
                    return buttons;


                })
        ];

        vm.getStatsEvent = getStatsEvent;

        /**
         * stats per video
         * @param   event
         */
        function getStatsEvent(event) {
            $rootScope.name_state_parent = angular.isDefined($state.current.name) ? $state.current.name : 'app.media_video_list_ongoing';
            $state.go('app.stats_event_by_id.audience', {id: event});
        }

        function deleteLanguage(event, lang) {
            clearFlashMessage();
            if (vm.events.indexOf(event) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('eventLive.deleteLanguageOrateur@delete', {id: event.id, lang: lang},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "EVENTLIST.dialog_alert_delete_title",
                                "EVENTLIST.dialog_alert_delete_description",
                                "EVENTLIST.dialog_alert_delete_close",
                                "EVENTLIST.delete_speaker",
                                "LANGUAGES.Names." + lang
                            ])
                                .then(function (translatedValues) {
                                    if (lang === "or") {
                                        webTvGlobal.$toast().showSimple(translatedValues['EVENTLIST.delete_speaker'] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                                    }
                                    else {
                                        webTvGlobal.$toast().showSimple(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                                    }

                                    vm.rerender();
                                });

                        }
                        else {
                            $translate([
                                "EVENTLIST.dialog_alert_delete_error_title",
                                "EVENTLIST.dialog_alert_delete_error_description",
                                "EVENTLIST.dialog_alert_delete_close"
                            ])
                                .then(function () {

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }
        }

        function searchEventsLivesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request(eventsData, filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var events = response.data;


                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': events
                        };
                        vm.events = events;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };

                            vm.events = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );


        }


        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);


            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedEvents = [];
            selectedEvents = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_events,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchEventsLivesInAPI(filtre);
        }


        vm.deleteSelectedEventsConfirm = deleteSelectedEventsConfirm;
        vm.deleteLanguageConfirm = deleteLanguageConfirm;
        vm.searchEventsLives = searchEventsLives;
        vm.deleteEventConfirm = deleteEventConfirm;
        vm.toogleSelection = toogleSelection;
        vm.toggleSelectEvent = toggleSelectEvent;
        vm.showEventDetail = showEventDetail;
        $rootScope.currentState = $state.current.name;
        // vm.listeOngoing = listeOngoing;
        // vm.listeUpgoing = listeUpgoing;
        // vm.editEvent = editEvent;
        vm.addNewEvent = addNewEvent;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        // vm.showCalendar = showCalendar;
        showFlasMessageToast('EventAdd', $translate.instant('EVENTLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('EventEdit', $translate.instant('EVENTLIST.edited'));
        vm.getExportLinks = getExportLinks;

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        // function showCalendar() {
        //     $rootScope.currentState = $state.current.name;
        //     $state.go('app.event_calendar');
        //
        // }
        //
        // function listeOngoing() {
        //
        //     $state.go('app.event_list_ongoing');
        //
        // }
        //
        // function listeUpgoing() {
        //
        //     $state.go('app.event_list_upcoming');
        //
        // }

        function getExportLinks(events, $ev) {
            msApi.request('eventLive.getExportLinks@get', {id: events.id},
                function (res) {
                    $mdDialog.show({
                        controller: function (entity, links, $mdDialog) {
                            var vm = this;
                            vm.events = entity;
                            vm.title = vm.events.video.title;
                            vm.links = res;
                            vm.urlEmbed = {};
                            vm.urlPermalien = {};
                            vm.searchLink = "auto";
                            // vm.intranet = false;
                            vm.changeIntraInter = changeIntraInter;
                            var msg = "";
                            if (vm.links.data.url.length > 1)
                                vm.intranet = true;
                            else if (vm.links.data.url[0].name === 'intranet')
                                vm.intranet = true;
                            else if (vm.links.data.url[0].name === 'internet')
                                vm.intranet = false;

                            changeIntraInter();

                            function changeIntraInter() {
                                if (vm.intranet || vm.links.data.url.length === 1) {
                                    initData();
                                    if (angular.isDefined(vm.options)) {
                                        vm.urlEmbed['intranet'] = vm.links.data.url[0].value[vm.searchLink].embed + vm.options;
                                        vm.urlPermalien['intranet'] = vm.links.data.url[0].value[vm.searchLink].permalien + vm.options;
                                        vm.embed = vm.links.data.url[0].value[vm.searchLink].embed;
                                        vm.permalien = vm.links.data.url[0].value[vm.searchLink].permalien;
                                    } else {
                                        vm.urlEmbed['intranet'] = vm.links.data.url[0].value[vm.searchLink].embed;
                                        vm.urlPermalien['intranet'] = vm.links.data.url[0].value[vm.searchLink].permalien;
                                        vm.embed = vm.links.data.url[0].value[vm.searchLink].embed;
                                        vm.permalien = vm.links.data.url[0].value[vm.searchLink].permalien;

                                    }
                                }
                                else {
                                    initData();
                                    if (angular.isDefined(vm.options)) {
                                        vm.urlEmbed['internet'] = vm.links.data.url[1].value[vm.searchLink].embed + vm.options;
                                        vm.urlPermalien['internet'] = vm.links.data.url[1].value[vm.searchLink].permalien + vm.options;
                                        vm.embed = vm.links.data.url[1].value[vm.searchLink].embed;
                                        vm.permalien = vm.links.data.url[1].value[vm.searchLink].permalien;
                                    } else {
                                        vm.urlEmbed['internet'] = vm.links.data.url[1].value[vm.searchLink].embed;
                                        vm.urlPermalien['internet'] = vm.links.data.url[1].value[vm.searchLink].permalien;
                                        vm.embed = vm.links.data.url[1].value[vm.searchLink].embed;
                                        vm.permalien = vm.links.data.url[1].value[vm.searchLink].permalien;

                                    }
                                }

                            }

                            function initData() {

                                var type = angular.isDefined(vm.links.data.url[0]) && angular.isDefined(vm.links.data.url[0].name) ? vm.links.data.url[0].name : null;
                                var value = angular.isDefined(vm.links.data.url[0]) && angular.isDefined(vm.links.data.url[0].value) ? vm.links.data.url[0].value : null;
                                vm.urlEmbed[type] = value[vm.searchLink].embed;
                                vm.urlPermalien[type] = value[vm.searchLink].permalien;
                                vm.embed = value[vm.searchLink].embed;
                                vm.permalien = value[vm.searchLink].permalien;
                            }

                            vm.ckeked = false;
                            vm.checkOptionFunction = checkOptionFunction;

                            function checkOptionFunction(valueCheck, option) {


                                if (valueCheck) {
                                    if (angular.isUndefined(vm.options) || vm.options === '') {
                                        vm.options = "?" + option + "=1";
                                    } else {
                                        vm.options += "&" + option + "=1";
                                    }
                                } else {
                                    if (vm.options.indexOf("?" + option + "=1") !== -1) {
                                        vm.options = vm.options.replace("?" + option + "=1", "");
                                        var index = vm.options.indexOf("&");
                                        if (index !== -1)
                                            vm.options = vm.options.replace("&", "?");
                                    } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
                                        vm.options = vm.options.replace("&" + option + "=1", "");
                                    }
                                }
                                angular.forEach(vm.links.data.url, function (value) {

                                    vm.urlPermalien[value.name] = vm.permalien + vm.options;
                                    vm.urlEmbed[value.name] = vm.embed + vm.options;
                                })


                            }

                            /*function isCopied() {
                             vm.ckeked = true;
                             if (vm.ckeked) {
                             msg = true;
                             vm.ckeked = false;
                             }
                             else msg = false;

                             }*/

                            // vm.changeIntranet = changeIntranet;
                            //
                            // function changeIntranet(value, type) {
                            //     initData();
                            //     if (angular.isDefined(vm.options)) {
                            //         vm.urlEmbed[1] = value[vm.searchLink].embed + vm.options;
                            //         vm.urlPermalien[1] = value[vm.searchLink].permalien + vm.options;
                            //         vm.embed = value[vm.searchLink].embed;
                            //         vm.permalien = value[vm.searchLink].permalien;
                            //     } else {
                            //         vm.urlEmbed[1] = value[vm.searchLink].embed;
                            //         vm.urlPermalien[1] = value[vm.searchLink].permalien;
                            //         vm.embed = value[vm.searchLink].embed;
                            //         vm.permalien = value[vm.searchLink].permalien;
                            //
                            //     }
                            //
                            //
                            // }
                            //
                            // vm.changeInternet = changeInternet;
                            //
                            // function changeInternet(value, type) {
                            //     initData();
                            //     if (angular.isDefined(vm.options)) {
                            //         vm.urlEmbed[0] = value[vm.searchLink].embed + vm.options;
                            //         vm.urlPermalien[0] = value[vm.searchLink].permalien + vm.options;
                            //         vm.embed = value[vm.searchLink].embed;
                            //         vm.permalien = value[vm.searchLink].permalien;
                            //     } else {
                            //         vm.urlEmbed[0] = value[vm.searchLink].embed;
                            //         vm.urlPermalien[0] = value[vm.searchLink].permalien;
                            //         vm.embed = value[vm.searchLink].embed;
                            //         vm.permalien = value[vm.searchLink].permalien;
                            //
                            //     }
                            //
                            //
                            // }

                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/event_live/list/url.modale.template.html',
                        targetEvent: $ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: events,
                            links: vm.links
                        }
                    });
                },
                function (res) {
                    webTvGlobal.alertDialog(res.data.message, '', '', $ev);
                }
            );
        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        eventPostMessage()
        initHelp();
        function getTitleKey() {
            return $state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_pagetitle');
        }
        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.event_menuTitle";
            $rootScope.titre3 = getTitleKey();
            $rootScope.pageRoute = "";


            $rootScope.welcome = "welcome_event";
            $rootScope.text = [{
                texte: "add_button_event_help"
            },{
                texte: "diffusion_types_event_help"
            }, {
                texte: "arrow_button_event_help"
            }, {
                texte: "search_area_event_help"
            }, {
                texte: "tri_column_event_help"
            },
                {
                    texte: "edit_button_event_help"
                }, {
                    texte: "detail_button_event_help"
                },
                {
                    texte: "delete_button_event_help"
                }, {texte: "export_button_event_help"}, {texte: "stat_button_event_help"}];

        }


        /**
         * Get Page Title Translation Key from the current state
         * @return string : translation key for the page title
         */
        /*function getTitleKey() {
         return $state.current.name.replace(/^app\.(.+)/, 'PAGESMENUSTITLES.$1_pagetitle');
         }*/

        /*function getIcon() {
         var item = msNavigationService.getActiveItem();
         return angular.isObject(item) && angular.isDefined(item.node) && angular.isDefined(item.node.icon) ? item.node.icon : "icon-cube-outline";
         }*/

        /**
         * Toggle selected status of the event
         *
         * @param event
         * @param event
         */
        function toggleSelectEvent(eventlist, event) {
            eventlist.checked = !eventlist.checked;
            var idx = selectedEvents.indexOf(eventlist);
            if (idx > -1) {
                selectedEvents.splice(idx, 1);
            }
            else {
                selectedEvents.push(eventlist);
            }
            vm.selectedEvents = angular.copy(selectedEvents);
        }

        /**
         * Toggle selected status of all the events
         *
         * @param event
         */
        function toogleSelection() {
            if (selectedEvents.length === vm.events.length) {
                vm.selectedEvents = [];
            }

            else if ((selectedEvents.length === 0) || (selectedEvents.length > 0)) {
                vm.selectedEvents = vm.events.slice(0);
            }
            selectedEvents = angular.copy(vm.selectedEvents);
            var list_events = angular.copy(vm.eventsDataTable);
            angular.forEach(list_events, function (value, key) {
                if (value !== undefined)
                    vm.eventsDataTable[key].checked = selectedEvents.length > 0;
            });
        }


        /**
         * Show event Details
         * @param event
         */
        function showEventDetail(eventlist, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('eventLive.getNewEvent@get', {id: eventlist.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {eventData: response},
                            templateUrl: 'app/main/media/event_live/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'eventLiveDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchEventsLivesInAPI(filtre), true);
        }

        // function editEvent(event) {
        //     clearFlashMessage();
        //     $rootScope.currentState = $state.current.name;
        //     $state.go('app.event_edit', {id: event.id});
        // }

        /**
         * redirection to add new event page
         * @param event
         */
        function addNewEvent() {
            clearFlashMessage();
            $state.go('app.event_add');
        }

        function deleteLanguageConfirm(event, lang, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "EVENTLIST.delete_language_msg",
                "EVENTLIST.delete_lang_event_aria_label",
                "EVENTLIST.delete_speaker",
                "LANGUAGES.Names." + lang])
                .then(function (translatedValues) {
                    var confirm;
                    if (lang === "or") {
                        confirm = $mdDialog.confirm()
                            .title(translatedValues['EVENTLIST.delete_language_msg'])
                            .htmlContent(translatedValues['EVENTLIST.delete_speaker'] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['EVENTLIST.delete_lang_event_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    }
                    else {
                        confirm = $mdDialog.confirm()
                            .title(translatedValues['EVENTLIST.delete_language_msg'])
                            .htmlContent(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['EVENTLIST.delete_lang_event_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);
                    }

                    $mdDialog.show(confirm).then(function () {

                        deleteLanguage(event, lang);


                    }, function () {

                    });
                });


        }

        /////////////////////////////
        function deleteSelectedEventsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedEvents.length !== 0) {
                if (vm.selectedEvents.length === 1) {
                    title = 'EVENTLIST.delete_selected_event_msg';
                    ariaLabel = 'EVENTLIST.delete_selected_event_aria_label';
                } else {
                    title = 'EVENTLIST.delete_selected_events_msg';
                    ariaLabel = 'EVENTLIST.delete_selected_events_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedEvents.length, title, ariaLabel)).then(function () {
                    deleteSelectedEvents(ev);
                }, function () {
                });

            }
        }

        ////////////////
        function deleteSelectedEvents(ev) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;

            msApi.request('eventLive.deleteEvents@delete', {
                    list: (function (list) {
                        vm.selectedEvents.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;

                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("EVENTLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("EVENTLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('EVENTLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedEvents = [];
                        selectedEvents = [];
                        rerender();


                    } else {
                        webTvGlobal.alertDialog(
                            $translate.instant('EVENTLIST.dialog_alert_delete_error_title'),
                            $translate.instant('EVENTLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedEvents = [];
                        selectedEvents = [];
                    }
                },
                function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedEvents = [];
                    selectedEvents = [];
                    vm.modelCheckAll = false;
                }
            );

        }

        /**
         * Delete event Confirm Dialog
         */
        function deleteEventConfirm(event, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "EVENTLIST.delete_event_msg",
                "EVENTLIST.delete_event_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['EVENTLIST.delete_event_msg'])
                        .htmlContent('<b>' + event.video.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['EVENTLIST.delete_event_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteEvent(event);
                        vm.selectedEvents = [];
                        selectedEvents = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete event
         */
        function deleteEvent(event) {
            clearFlashMessage();
            if (vm.events.indexOf(event) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('eventLive.delete@delete', {id: event.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "EVENTLIST.dialog_alert_delete_title",
                                "EVENTLIST.dialog_alert_delete_description",
                                "EVENTLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(event.video.title + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                                    vm.events.splice(vm.events.indexOf(event), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "EVENTLIST.dialog_alert_delete_error_title",
                                "EVENTLIST.dialog_alert_delete_error_description",
                                "EVENTLIST.dialog_alert_delete_close"
                            ])
                                .then(function () {

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }

        function eventPostMessage() {
            if (angular.isUndefined(window.dataEventPostMessageListLive)) {
              window.dataEventPostMessageListLive = true;
              var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
              var eventer = window[eventMethod];
              var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
              eventer(messageEvent, function (e) {
                if (typeof e.data !== "undefined") {
                    if(e.data.info==="showEventStat"){
                 $rootScope.eventId = e.data.value;
                         getStatsEvent(e.data.value)
                    }
                }
              }, false);
            }
    
          }

        function searchEventsLives(test, model) {
            var idCanal = vm.canal;
            if (test === 'canal') {
                vm.theme = '';
                idCanal = model;
            }
            var res;
            if (angular.isDefined(model) && test !== 'canal') {
                res = model.substring(model.indexOf('-') + 1, model.length);
            }
            else {
                res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
            }
            filtre.searchId = vm.search_events;
            filtre.searchWord = vm.search_event;
            if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
                filtre.startDate = moment(vm.startDate).format("YYYY-MM-DD");
            }
            else {
                filtre.startDate = "";
            }
            filtre.idChannel = idCanal;
            filtre.idTheme = res;
            searchEventsLivesInAPI(filtre);
        }
        // integration iframe event
        if (window.process.env.isNewEvent) {
            vm.isNewEvent = window.process.env.isNewEvent;
          }
        if (vm.isNewEvent) {
            vm.newEventIframe = $sce.trustAsResourceUrl(
                "https:" +
                window.process.env.URL_EVENT +
                "/list?token=" +
                $cookies.get("authToken") +
                "&lang=" + $cookies.get("WEBTV.locale") 
            );
            $scope.$watch(function () {
                vm.newEventIframe = $sce.trustAsResourceUrl(
                    "https:" +
                window.process.env.URL_EVENT +
                "/list?token=" +
                $cookies.get("authToken") +
                "&lang=" + $cookies.get("WEBTV.locale") 
                  );
              });
        }
    }

})
();

(function () {
    'use strict';

    angular
        .module('app.event.list')
        .controller('eventLiveDetailController', eventLiveDetailController);

    /** @ngInject */
    function eventLiveDetailController(eventData, $mdDialog) {
        var vm = this;
        vm.event = eventData;

        vm.cancel = cancel;


        function cancel() {
            $mdDialog.hide();
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('app.event.add', ['mdPickers', "flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider
            .state('app.event_add', {
                url: "/event/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/event_live/add_edit_view/form.template.html',
                        controller: 'eventLiveAddController as vm'
                    }
                },
                resolve: {
                    eventData: function (msApi) {
                        return msApi.resolve('eventLive.getNewEvent@get', {id: 0});
                    },
                    eventLiveStations: function (msApi) {
                        return msApi.resolve('eventLive.getStations@get');
                    },
                    specificsDirectionNames: function (msApi) {
                        return msApi.resolve('direction.getDirectionsNames@get');
                    },
                    themesNames: function (msApi) {
                        return msApi.resolve('eventLive.getThemesNames@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "event_post_add_action"
            });


        //API

        msApiProvider.register('eventLive.addEvent', [Routing.generate('api_post_add_event_live')]);
        msApiProvider.register('eventLive.getStations', [Routing.generate('api_specifics_get_list_station')]);
        msApiProvider.register('eventLive.getThemesNames', [Routing.generate('api_parameters_get_themes_names')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.event.add')
    .controller('eventLiveAddController', eventLiveAddController);

  /** @ngInject */
  function eventLiveAddController(eventData,$cookies, webTvGlobal, eventLiveStations, specificsDirectionNames, themesNames, $injector, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      msUtils = $injector.get('msUtils'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    var imageName;
    var inProgress;
    vm.urlVignette = "";
    if(angular.isDefined(webTvGlobal.$constant().webTvParameterBag().intranet_internet_video)&& webTvGlobal.$constant().webTvParameterBag().intranet_internet_video==='1')
      vm.isIntranet_Internet = true;
    else vm.isIntranet_Internet = false;
      vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );
    vm.event = eventData;

    vm.categoryChoices = webTvGlobal.convertToSelectChoicesFormat(specificsDirectionNames.names);
    vm.themesNames = webTvGlobal.convertToSelectChoicesFormat(themesNames.names);

    vm.accessChoices = webTvGlobal.convertToSelectChoicesFormat({
      "Public": "Public",
      "loginRequired": "loginRequired",
      "protected": "protected"
    });
    vm.stations = webTvGlobal.convertToSelectChoicesFormat(eventLiveStations.names);

    vm.empEventForm = {
      speaker: vm.event.speaker ? vm.event.speaker : true,
      language: vm.event.language ? vm.event.language : [$translate.preferredLanguage()],
      video: {
        keyWords: [],
        startDate: moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ"),
        endDate: moment(new Date(new Date().getTime() + 300000)).format("YYYY-MM-DD HH:mm:ssZ"),
        medias: vm.event.video.medias,
        themes: vm.event.video.themes,
        logo: "",
        isVisibleOnIntranet: vm.event.video.isVisibleOnIntranet,
        isVisibleOnInternet: vm.event.video.isVisibleOnInternet
      },
      date_start: vm.event.date_start ? vm.event.date_start : moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ"),
      date_end: vm.event.date_end ? vm.event.date_end : moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ"),
      mdTime: {
        date: new Date(moment(vm.event.date_start)),
        time: new Date(moment(vm.event.date_start)),
        timeMin: new Date(new Date(moment(vm.event.date_start)).getTime() + 300000)
      },
      endtime: new Date(new Date(moment(vm.event.date_end)).getTime() + 300000)

    };
   // vm.minDate = vm.empEventForm.mdTime.date;
    /* if (vm.event.video.medias) {
         vm.empEventForm.video.medias = vm.event.video.medias;
     }
     if (vm.event.video.themes) {
         vm.empEventForm.video.themes = vm.event.video.themes;
     }*/
    vm.submitAddEventForm = submitAddEventForm;
    vm.returnToList = returnToList;
    vm.changeDate = changeDate;
    vm.changeTime = changeTime;
    vm.changeEndtime = changeEndtime;
    vm.change = change;

    function change() {
      if (vm.external_link)
        vm.empEventForm.station = "";
      else vm.empEventForm.station = null;
    }

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}


    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;


    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.event_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.event_add_menuTitle";
      $rootScope.pageRoute = "app.event_list_ongoing";
      $rootScope.welcome = "welcome_event_add";
      $rootScope.text = [{
        texte: "parameters_event_add_help"
      }, {
        texte: "upload_button_event_add_help"
      }, {
        texte: "send_button_event_add_help"
      }, {
        texte: "cancel_button_event_add_help"
      }];

    }


    /**
     * return to event list page
     * @return redirect to event list page
     */
    function returnToList() {
      $state.go('app.event_list_ongoing');
    }


    function changeDate() {
      vm.empEventForm.video.startDate = vm.empEventForm.video.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empEventForm.mdTime.date).format('YYYY-MM-DD'));
      vm.empEventForm.video.endDate = vm.empEventForm.video.endDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empEventForm.mdTime.date).format('YYYY-MM-DD'));


    }

    function changeTime() {
      vm.empEventForm.video.startDate = vm.empEventForm.video.startDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empEventForm.mdTime.time).format('HH:mm:ss'));
      vm.empEventForm.mdTime.timeMin = new Date(new Date(moment(vm.empEventForm.video.startDate)).getTime() + 300000);
    }

    function changeEndtime() {
      vm.empEventForm.video.endDate = vm.empEventForm.video.endDate.replace(/[0-9]{2}:[0-9]{2}:[0-9]{2}/, moment(vm.empEventForm.endtime).format('HH:mm:ss'));

    }


    /**
     * Send add event Form
     */
    function submitAddEventForm() {
      var formData = angular.copy(vm.empEventForm);
      angular.forEach(formData.language, function (value) {
        formData.video.medias.push({lang: value});
      });
      if (formData.speaker) {
        formData.video.medias.push({lang: "or"});
      }
      formData.video.themes.push(formData.video.direction);
      delete formData.video.direction;
      delete formData.language;
      delete formData.keyWords;
      delete formData.date_start;
      delete formData.date_end;
    if(angular.isDefined(formData.video.offline && formData.video.offline===true)){
        formData.video.offline=false;

    }   else
        formData.video.offline=true;

        if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      if (angular.isDefined(formData.endtime)) delete formData.endtime;
      if (angular.isUndefined(formData.access_type)) delete formData.access_type;
      if ((formData.url === "")) delete formData.url;
      if (angular.isDefined(formData.direction)) {
        formData.direction = formData.direction.substring(formData.direction.indexOf('-') + 1, formData.direction.length);
      }
      formData.video.keyWords = angular.isFunction(formData.video.keyWords.join) ? formData.video.keyWords.join(' ') : "";
      delete formData.speaker;
      $rootScope.loadingProgress = true;
      msApi.request('eventLive.addEvent@save',
        {"empEventForm": formData},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('EventAdd', {title: vm.empEventForm.title ? vm.empEventForm.title : ""});
            $state.go('app.event_list_ongoing');
          }
          else if (angular.isDefined(res.errors)) {
            vm.empEventError = [];
            var errors = res.errors;
            errors.forEach(function (item) {
              vm.empEventError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empEventForm[item.for])
              };
            });
            if(angular.isDefined(vm.empEventError["conference_key"]))
              webTvGlobal.alertDialog($translate.instant('VALIDATIONS.eventOrganizer.conference_key.unique'));
          }
          else {
              $rootScope.loadingProgress = false;
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empEventForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empEventForm.video.logo = res.location.url;

        vm.urlVignette = res.location.url;

      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empEventForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empEventForm.thumbnail = "";
        });
      }
    }


  }

})();


(function () {
    'use strict';

    angular
        .module('app.event.calendar', ["ui.calendar"])
        .config(config);


    function config($stateProvider,  msApiProvider) {
        // State
        $stateProvider
            .state('app.event_calendar', {
                url: "/event/calendar",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/media/event_live/calendar/calendar.template.html',
                        controller: 'eventLiveCalendarController as vm'
                    }
                },
                bodyClass: 'calendar',
                "actionPermission" : "event_list_dtable_events_ongoing_action"
            });


        
        //API
        msApiProvider.register('eventLive.list_by_date', [Routing.generate('api_get_events_live_in_interval', {
            from: 'start',
            to: 'end'
        }).replace(/from_start_to_end/, ":id"), {id: "@id"}])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.event.calendar')
    .controller('eventLiveCalendarController', eventLiveCalendarController);

  /** @ngInject */
  function eventLiveCalendarController(msApi, $rootScope, $state) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;


    vm.events = [];

    vm.calendarUiConfig = {
      calendar: {
        editable: false,
        eventLimit: false,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        selectable: false,
        selectHelper: false,
        allDaySlot: false,
        loading: function (bool) {
          if (bool) $rootScope.loadingProgress = true;
          else $rootScope.loadingProgress = false;
        },
        events: function (start, end, timezone, pushIntoCalendarEvents) {
          msApi.request('eventLive.list_by_date@get',
            {id: "from_" + start.format('YYYY-MM-DD') + "_to_" + end.format('YYYY-MM-DD')},
            function (res) {
              var events = [];
              var now = moment();
              for (var i = 0; i < res.data.eventlists.length; i++) {
                var eventlist = res.data.eventlists[i];
                events.push({
                  "allDay": false,
                  "id": eventlist.id,
                  "title": eventlist.title,
                  "start": (moment(eventlist.date_start))/*.format('YYYY-MM-DD HH:mm:ss')*/,
                  "end": (moment(eventlist.date_start)).add(eventlist.maxDuration, "hours")/*.format('YYYY-MM-DD HH:mm:ss')*/,
                  "className": moment(eventlist.date_start) < now ? "red-bg" : "green-bg"
                });
              }
              pushIntoCalendarEvents(events);
            },
            function () {

            }
          );
        }
      }
    };


    //vm.next = next;
    //vm.prev = prev;
    vm.returnToList = returnToList;

    //////////

    /**
     * Go to next on current view (week, month etc.)
     */
    /*function next() {
        vm.calendarView.calendar.next();
    }*/

    /**
     * Go to previous on current view (week, month etc.)
     */

    /*function prev() {
        vm.calendarView.calendar.prev();
    }*/

    function returnToList() {
      if (angular.isUndefined($rootScope.currentState)) {
        $state.go('app.event_list_ongoing');
      }
      else {
        $state.go($rootScope.currentState);
      }

    }
      initHelp();
      function initHelp() {

          $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.event_menuTitle";
          $rootScope.titre3 = "PAGESMENUSTITLES.event_calendar_menuTitle";
          if (angular.isUndefined($rootScope.currentState) || $rootScope.currentState === "") {
              $rootScope.pageRoute = 'app.event_list_ongoing';
          }
          else {
              $rootScope.pageRoute = $rootScope.currentState;
          }
          $rootScope.welcome = "";

      }

  }


})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.comments.edit', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_comments_edit', {
                url: "/interactivity/comments/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/comments/edit/edit.template.html',
                        controller: 'CommentsEditController as vm'
                    }
                },
                resolve: {
                    CommentsData: function (msApi, $stateParams) {
                        return msApi.resolve('comments.getComments@get', {id: $stateParams.id});
                    }
                },
                "bodyClass": "forms"
            });


        msApiProvider.register('comments.getComments', [Routing.generate('api_media_get_detail_comments', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('comments.editComments', [Routing.generate('api_media_post_edit_comments', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.interactivity.comments.edit')
    .controller('CommentsEditController', CommentsEditController);

  /** @ngInject */
  function CommentsEditController(webTvGlobal,$cookies, msUtils, CommentsData, HelpGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.media_comments_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.media_comments_edit_pagetitle";

      $rootScope.welcome = "welcome_comment_add";
      $rootScope.text = [{
        texte: "parameters_comment_add_help"
      }, {
        texte: "send_button_comment_add_help"
      }, {
        texte: "cancel_button_comment_add_help"
      }];
    }

    var vm = this;
    $rootScope.itemName = "";
    var comments = CommentsData;
    vm.fillData = fillData;
    vm.empMediaCommentsForm = {};
    vm.submitAddCommentsForm = submitAddCommentsForm;
    vm.returnToList = returnToList;
    vm.fillData();

    /**
     * Check if comments exists
     * @return if exists get Comments Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(comments.code) && comments.code !== 200) $state.go('app.error_404');
      else {
        vm.empMediaCommentsForm = {
          email: comments.email,
          comment: comments.comment,
          img: comments.img || "",
          media: comments.media ? comments.media.id : null
        };
        $rootScope.itemName = comments.id || '';
      }
    }

    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_media_post_comments_thumb'),
      singleFile: true,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    var imageName;

    /**
     * return to comments list page
     * @return redirect to comments list page
     */
    function returnToList() {
        if(CommentsData.media && CommentsData.media.video && CommentsData.media.video.id){
            $state.go('app.comments_list.media', {id: CommentsData.media.video.id});
        }else {
            $state.go('app.comments_list.media');
        }
      $rootScope.selectedIndex = 1;
    }

    /**
     * Send add Comments Form
     */
    function submitAddCommentsForm() {
      $rootScope.loadingProgress = true;
      msApi.request('comments.editComments@save',
        {id: comments.id, "empMediaCommentsForm": angular.copy(vm.empMediaCommentsForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            comments = vm.empMediaCommentsForm;
            webTvGlobal.$flashMessages().set('CommentsEdit', comments);
            if(CommentsData.media && CommentsData.media.video && CommentsData.media.video.id){
                $state.go('app.comments_list.media', {id: CommentsData.media.video.id});
            }else {
                $state.go('app.comments_list.media');
            }
            $rootScope.selectedIndex = 1;
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            // else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );


    }


    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empMediaCommentsForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.path) {
        vm.empMediaCommentsForm.img = comments.img = res.path;
        vm.is_image_not_pristine = true;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empMediaCommentsForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empMediaCommentsForm.img = "";
        });
      }
    }


  }

})();

(function () {
  'use strict';

  angular
    .module('app.new_template_segment.list', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.new_template_segment', {
        url: "/new-template-segment/list", abstract: true,
        "actionPermission" : "display_new_segment_list_dtable_action"
      })
      .state('app.new_template_segment_list',
        {
          parent: 'app.new_template_segment',
          url: "?type:id",
          reloadOnSearch:false,
          views: {
            'content@app': {
              templateUrl: 'app/main/displayNew/template_segment/list/list.html',
              controller: 'templateSegmentListNew as vm'
            }
          },
          onEnter: function(){
            if(document.getElementById('mail')){
              document.getElementById('mail').style.display = 'none';
            }
          },
          onExit: function(){
            if(document.getElementById('mail')){
              document.getElementById('mail').style.display = 'block';
            }
          },
          resolve: {
            getUrlListSegment: function (msApi,$stateParams) {
              var typeRouter = $stateParams.type ? $stateParams.type : "list";
              return msApi.resolve('listSegments.getUrlListSegment@get', {type: typeRouter ,id:$stateParams.id});
            }
          },
          "actionPermission" : "display_new_segment_list_dtable_action"
        })
    msApiProvider.register('listSegments.getUrlListSegment', [Routing.generate('api_programDisplay_get_client_display_segment')]);
  }
})();



(function () {
  'use strict';

  angular
    .module('app.new_template_segment.list')
    .controller('templateSegmentListNew', templateSegmentListNewt);

  /** @ngInject */

  function templateSegmentListNewt($state, $scope,$injector,getUrlListSegment,$translate,$rootScope,$sce,$cookies,webTv_msNavigation) {
    var vm = this;
    initHelp();
    var $stateParams = $injector.get('$stateParams');

    console.log("$stateParams",$stateParams)

    function initHelp() {

      if(webTv_msNavigation['display_new_new_template_segment']) {
        $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
        $rootScope.titre3 = "";
      }else {
        $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
        $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
      }
      $rootScope.pageRoute = "app.new_template_segment_list";
      $rootScope.welcome = "";

    }
    vm.language = $translate.preferredLanguage();
    vm.trustLink=trustLink;
      var color = $cookies.get('selectedThemeColor');
      vm.urlSegmentList=getUrlListSegment.url_display_segment+'&lang='+$cookies.get('WEBTV.locale')+'&color='+color;
    eventPostMessage();
    var version = 0;
    function eventPostMessage() {

      if (angular.isUndefined(window.dataEventPostMessageEditSegment)) {
        window.dataEventPostMessageEditSegment = true;
        var eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
        eventer(
          messageEvent,
            function(event) {
            if (event.data !== 'undefined') {
              console.log('event.data',event.data)
              if(event.data.EditSegment || event.data.AddSegment || event.data.ListSegment ){
                setTimeout(function () {
                  version++;
                  if (event.data.EditSegment) {
                    $state.go("app.new_template_segment_list", {type:"edit",id:event.data.id});
                  }else if (event.data.AddSegment) {
                    $state.go("app.new_template_segment_list",{type:"add"}, {inherit:false});

                  }else if (event.data.ListSegment) {
                    $state.go("app.new_template_segment_list",{type:"list"}, {inherit:false});
                  }
                    $rootScope.pageRoute = "app.new_template_segment_list";
                },500);

                //$state.reload();
              }
              if (event.data.info === "fullScreen") {
                $rootScope.$apply(function() {
                  $rootScope.fullScreen=event.data.value;
                });
              }

            }
          },
          false
        );
      }
    }
     function trustLink(link) {
      return $sce.trustAsResourceUrl(link);
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.advertising.list', [])
        .config(config);

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.advertising_list', {
                url: "/parameters/advertising/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/advertising/list/list.template.html',
                        controller: 'advertisingListController as vm'
                    }
                },
                "bodyClass": "e-commerce"
            });

        // Api
        var deleteAdvertisingRoute = Routing.generate('api_parameters_delete_advertising') + "/:id";
        var deleteListAdvertising = Routing.generate('api_multi_delete_multi_parameters_advertisings') + "/:list";
        msApiProvider.register('advertising.deleteAdvertising', [deleteListAdvertising, {list: '@list'}]);
        msApiProvider.register('advertising.list', [Routing.generate('api_parameters_get_advertisings')]);
        msApiProvider.register('advertising.mdelete', [deleteAdvertisingRoute, {id: '@id'}]);
        msApiProvider.register('advertising.modalGetAdvertising', [Routing.generate('api_parameters_get_detail_advertising', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('advertising.dtable', [Routing.generate('api_dtable_list_dtable_parameters_advertisings')]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.advertising.list')
        .controller('advertisingListController', advertisingListController);

    /** @ngInject */
    function advertisingListController($scope, DTOptionsBuilder, webTvGlobal, $cookies, DTColumnBuilder, $injector, $compile, dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');

        //initiation toolbar path and aide page
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.advertising_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.advertising_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_advert";
            $rootScope.text = [{
                texte: "add_button_advert_help"
            }, {
                texte: "arrow_button_advert_help"
            }, {
                texte: "search_area_advert_help"
            }, {
                texte: "tri_column_advert_help"
            },
                {
                    texte: "edit_button_advert_help"
                }, {
                    texte: "detail_button_advert_help"
                },
                {
                    texte: "delete_button_advert_help"
                }];
        }


        //Data Table options
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.advertisings = [];
        vm.selectedAdvertisings = [];
        var selectedAdvertisings = [];
        vm.checkedSelected = false;
        vm.advertisingsDataTable = {};
        vm.dtInstance = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[{
                // Target the id column
                targets: [0, 1],
                width: '72px'
            },

                {
                    // Target the image column
                    targets: 2,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchAdvertisingInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('advertising.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.advertisings = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.advertising = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            vm.selectedAdvertisings = [];
            selectedAdvertisings = [];
            vm.checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_advertisings,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchAdvertisingInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.advertisingsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.advertisingsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggleSelectAdvertising(vm.advertisingsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('logo').notSortable()
                .renderWith(function (data) {
                    var serverHtml = "";
                    if (data === null || data === "" || data === false) {
                        serverHtml += '<span>-</span>';
                    }
                    else {
                        serverHtml += '<img  width="100" height="100" class="product-image" ng-src= ' + data + '>';
                    }
                    return serverHtml;
                }),
            DTColumnBuilder.newColumn('title').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('link_url').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('date_start').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('date_end').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn('active').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.advertisingsDataTable[data.id] = data;

                    var buttonActionDetailHtml = '<md-button class="show-button md-icon-button" ng-click="vm.showAdvertisingDetail(vm.advertisingsDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail" has-permission="parameters_advertising_get_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_detail" +
                        "'|translate}}" +
                        '</md-tooltip>' +
                        '</md-button>';
                    var buttonActionEditHtml = '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.advertising_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" has-permission="parameters_advertising_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_edit'|translate}}" +
                        '</md-tooltip>' +
                        '</md-button>';
                    var buttonActionDeleteHtml = '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteAdvertisingConfirm(vm.advertisingsDataTable[' + data.id + '],ev)" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete" has-permission="parameters_advertising_delete_advertising">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_delete'|translate}}" +
                        '</md-tooltip>' +
                        ' </md-button>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.deleteSelectedAdvertisingsConfirm = deleteSelectedAdvertisingsConfirm;
        vm.searchAdvertisings = searchAdvertisings;
        vm.deleteAdvertisingConfirm = deleteAdvertisingConfirm;
        vm.toogleSelection = toogleSelection;
        vm.toggleSelectAdvertising = toggleSelectAdvertising;
        vm.showAdvertisingDetail = showAdvertisingDetail;
        vm.addNewAdvertising = addNewAdvertising;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        showFlasMessageToast('advertisingAdd', $translate.instant('ADVERTISINGLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('advertisingEdit', $translate.instant('ADVERTISINGLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the advertising
         *
         * @param advertising
         * @param list
         */
        function toggleSelectAdvertising(advertising) {

            advertising.checked = !advertising.checked;
            var idx = selectedAdvertisings.indexOf(advertising);
            if (idx > -1) {
                selectedAdvertisings.splice(idx, 1);
            }
            else {
                selectedAdvertisings.push(advertising);
            }
            vm.selectedAdvertisings = angular.copy(selectedAdvertisings);

        }

        /**
         * Toggle selected status of all the advertisings
         *
         * @param event
         */
        function toogleSelection() {
            if (selectedAdvertisings.length === vm.advertisings.length) {
                vm.selectedAdvertisings = [];
            }

            else if ((selectedAdvertisings.length === 0) || (selectedAdvertisings.length > 0)) {
                vm.selectedAdvertisings = vm.advertisings.slice(0);
            }
            selectedAdvertisings = angular.copy(vm.selectedAdvertisings);
            var list_canals = angular.copy(vm.advertisingsDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.advertisingsDataTable[key].checked = selectedAdvertisings.length > 0;
            });

        }


        /**
         * Show Advertising Details
         * @param advertising
         */
        function showAdvertisingDetail(advertising, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('advertising.modalGetAdvertising@get', {id: advertising.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {advertisingData: response},
                            templateUrl: 'app/main/interactivity/advertising/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'advertisingDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchAdvertisingInAPI(filtre), true);
        }


        /**
         * redirection to add new advertising page
         * @param event
         */
        function addNewAdvertising() {
            clearFlashMessage();
            $state.go('app.advertising_add');
        }

        /**
         * Delete Advertising Confirm Dialog
         */
        function deleteAdvertisingConfirm(Advertising, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "ADVERTISINGLIST.delete_advertising_msg",
                "ADVERTISINGLIST.delete_advertising_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['ADVERTISINGLIST.delete_advertising_msg'])
                        .htmlContent('<b>' + Advertising.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['ADVERTISINGLIST.delete_advertising_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteAdvertising(Advertising);
                        vm.selectedAdvertisings = [];
                        selectedAdvertisings = [];

                    });
                });


        }

        /**
         * Delete Advertising
         */
        function deleteAdvertising(Advertising) {
            clearFlashMessage();
            if (vm.advertisings.indexOf(Advertising) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('advertising.mdelete@delete', {id: Advertising.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "ADVERTISINGLIST.dialog_alert_delete_title",
                                "ADVERTISINGLIST.dialog_alert_delete_description",
                                "ADVERTISINGLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Advertising.title + translatedValues['ADVERTISINGLIST.dialog_alert_delete_description']);
                                    $state.reload();
                                });

                        }
                        else {
                            $translate([
                                "ADVERTISINGLIST.dialog_alert_delete_error_title",
                                "ADVERTISINGLIST.dialog_alert_delete_error_description",
                                "ADVERTISINGLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['ADVERTISINGLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['ADVERTISINGLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['ADVERTISINGLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }
        }

        /////////////////////////////////////////////
        function deleteSelectedAdvertisingsConfirm(ev) {
            if (vm.selectedAdvertisings.length !== 0) {
                $translate([
                    "MESSAGES.dialog_confirm_delete",
                    "MESSAGES.dialog_cancel",
                    "MESSAGES.dialog_list_will_be_deleted",
                    "ADVERTISINGLIST.delete_list_advertising_msg",
                    "ADVERTISINGLIST.delete_advertising_aria_label"
                ])
                    .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['ADVERTISINGLIST.delete_list_advertising_msg'])
                            .htmlContent(translatedValues['MESSAGES.dialog_list_will_be_deleted'])
                            .ariaLabel(translatedValues['ADVERTISINGLIST.delete_advertising_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteSelectedAdvertisings(ev);


                        });
                    });

            }

        }

        //////////////////////////////////////////////
        function deleteSelectedAdvertisings(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('advertising.deleteAdvertising@delete', {
                    list: (function (list) {
                        vm.selectedAdvertisings.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("ADVERTISINGLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("ADVERTISINGLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('ADVERTISINGLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedAdvertisings = [];
                        selectedAdvertisings = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('ADVERTISINGLIST.dialog_alert_delete_error_title'),
                            $translate.instant('ADVERTISINGLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedAdvertisings = [];
                        selectedAdvertisings = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedAdvertisings = [];
                    selectedAdvertisings = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        ///////////////////////////////////////////

        function searchAdvertisings() {
            filtre["search[value]"] = vm.search_advertisings;
            searchAdvertisingInAPI(filtre);
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.advertising.list')
        .controller('advertisingDetailController', advertisingDetailController);

    /** @ngInject */
    function advertisingDetailController(advertisingData, $mdDialog) {
        var vm = this;
        vm.advertising = advertisingData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.new_template_manager.editornew',["datatables"])
        .config(config);
    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.new_template_manager_editornew', {
                url: "/new-template-manager/editornew",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/displayNew/template_manager/editorNew/editornew.html',
                        controller: 'EditorNewTemplate as vm'
                    }
                },
              onEnter: function(){
                  if(document.getElementById('mail')){
                    document.getElementById('mail').style.display = 'none';
                  }
              },
              onExit: function(){
                if(document.getElementById('mail')){
                  document.getElementById('mail').style.display = 'block';
                }
                },
                resolve: {
                    displayNewUrl: function (msApi)
                    {
                        return msApi.resolve('display_new.getUrlAdd@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "display_new_template_post_add_action"
            })
            .state('app.new_template_manager_edit', {
                url: "/new-template-manager/editornew/edit/:id",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/displayNew/template_manager/editorNew/editornew.html',
                        controller: 'EditorEditTemplate as vm'
                    }
                },
              onEnter: function(){
                if(document.getElementById('mail')){
                  document.getElementById('mail').style.display = 'none';
                }
              },
              onExit: function(){
                if(document.getElementById('mail')){
                  document.getElementById('mail').style.display = 'block';
                }
              },
                resolve: {
                    displayEditUrl: function ($stateParams,msApi)
                    {
                        return msApi.resolve('templates.getUrlsEditTemplate@get', {id: $stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "display_new_template_post_edit_action"
            })




        ;

        msApiProvider.register('display_new.getUrlAdd', [Routing.generate('api_programDisplay_get_client_display')]);

        msApiProvider.register('templates.getUrlsEditTemplate', [Routing.generate('api_templateDisplay_get_template_urls', {id: ':id'}).replace(/%3A/, ":")]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.new_template_manager.editornew')
        .controller('EditorNewTemplate', EditorNewTemplate)
.controller('EditorEditTemplate', EditorEditTemplate);

    /** @ngInject */
    function EditorNewTemplate( $rootScope,$sce, displayNewUrl,$cookies,$state,webTv_msNavigation) {
        var vm = this;
        initHelp();
        eventPostMessage();
        function initHelp() {

        if(webTv_msNavigation['display_new_new_template_manager']){
          $rootScope.titre1 = "PAGESMENUSTITLES.display_programs_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.display_programs_add_menuTitle";
          $rootScope.titre3 = "";
        }else {
          $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.display_programs_menuTitle";
          $rootScope.titre3 = "PAGESMENUSTITLES.display_programs_add_menuTitle";
        }
            $rootScope.pageRoute = "app.new_template_manager_list_all";

            $rootScope.welcome = "";

        }


        vm.trustLink=trustLink;


        if(angular.isDefined(displayNewUrl.url_display))
        {
            vm.urldisplay=displayNewUrl.url_display+'&lang='+$cookies.get('WEBTV.locale');

        }



        function trustLink(link) {
            return $sce.trustAsResourceUrl(link);
        }

      function eventPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageDisplayNew)) {
          window.dataEventPostMessageDisplayNew = true;
          console.log("eventPostMessage");
          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
          //eventer(messageEvent, function (e) <=> window.addEventListener("message", receiveMessage, false): to listen to the dispached event
          //receiveMessage = function(event)
          eventer(messageEvent, function (e) {
            if (typeof e.data !== "undefined") {
              var video = e.data.value;
              if (e.data.info === "publishDisplay") {

                $state.go('app.new_template_manager_list_all');
              }
              if (e.data.backToBoProgram) {
                $state.go('app.new_template_manager_list_all');
              }
              if (e.data.info === "fullScreen") {
                $rootScope.$apply(function() {
                  $rootScope.fullScreen=e.data.value;
                });              }

            }
          })
        }
      }


        /*initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.support_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.key_menuTitle";
            $rootScope.titre3 = "";
            $rootScope.welcome = "";
        }
*/
    }
    function EditorEditTemplate( $rootScope,$sce, displayEditUrl,$cookies,$state,webTv_msNavigation) {
        var vm = this;
        initHelp();
         eventPostMessage();
        function initHelp() {

          if(webTv_msNavigation['display_new_new_template_manager']){
            $rootScope.titre1 = "PAGESMENUSTITLES.display_programs_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_programs_edit_menuTitle";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_programs_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_programs_edit_menuTitle";
          }
            $rootScope.pageRoute = "app.new_template_manager_list_all";

            $rootScope.welcome = "";

        }

      function eventPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageDisplayNew)) {
          window.dataEventPostMessageDisplayNew = true;
          console.log("eventPostMessage");
          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
          //eventer(messageEvent, function (e) <=> window.addEventListener("message", receiveMessage, false): to listen to the dispached event
          //receiveMessage = function(event)
          eventer(messageEvent, function (e) {
            if (typeof e.data !== "undefined") {
              var video = e.data.value;
              if (e.data.info === "publishDisplay") {

                $state.go('app.new_template_manager_list_all');
              }
              if (e.data.info === "fullScreen") {
                $rootScope.$apply(function() {
                  $rootScope.fullScreen=e.data.value;
                });
              }
            }
          })
        }
      }
        vm.trustLink=trustLink;


        if(angular.isDefined(displayEditUrl.data.url_edit))
        {
            vm.urldisplay=displayEditUrl.data.url_edit+'&lang='+$cookies.get('WEBTV.locale');

        }







        function trustLink(link) {
            return $sce.trustAsResourceUrl(link);
        }


        /*initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.support_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.key_menuTitle";
            $rootScope.titre3 = "";
            $rootScope.welcome = "";
        }
*/
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.advertising.edit',['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.advertising_edit', {
                url    : "/parameters/advertising/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/advertising/add_edit_view/add_edit.template.html',
                        controller : 'advertisingEditController as vm'
                    }
                },
                resolve: {
                     advertisingData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('advertising.getAdvertising@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms"
            });


        // API
        msApiProvider.register('advertising.getAdvertising', [Routing.generate('api_parameters_get_detail_advertising',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('advertising.editAdvertising', [Routing.generate('api_parameters_post_edit_advertising',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}])

    }
})();
(function () {
  'use strict';

  angular
    .module('app.interactivity.advertising.edit')
    .controller('advertisingEditController', advertisingEditController);

  /** @ngInject */
  function advertisingEditController(webTvGlobal,$cookies, $translate, msApi, $rootScope, $state, advertisingData, msUtils) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    //initiation toolbar path and aide page
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.advertising_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.advertising_edit_pagetitle";
      $rootScope.pageRoute = "app.advertising_list";

      $rootScope.welcome = "welcome_advert_edit";
      $rootScope.text = [{
        texte: "parameters_advert_add_help"
      }, {
        texte: "send_button_advert_add_help"
      }, {
        texte: "cancel_button_advert_add_help"
      }];
    }

    var vm = this;
    $rootScope.itemName = "";
    vm.isNew = false;

    vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });


    vm.advertising = advertisingData;
    var empAdvertisingError = [];
    vm.empAdvertisingForm = {};
    vm.urlVignette = "";
    var dateStart = new Date(vm.advertising.date_start);
    var dateEnd = new Date(vm.advertising.date_end);
    vm.submitAddAdvertisingForm = submitAddAdvertisingForm;
    fillData();

    /**
     * Check if advertising exists
     * @return if exists get Advertising Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.advertising.code) && vm.advertising.code !== 200) $state.go('app.error_404');
      else {

        vm.empAdvertisingForm = {
          title: vm.advertising.title,
          link_url: vm.advertising.link_url,
          active: vm.advertising.active ? 1 : 0,
          date_start: new Date(moment(dateStart).format('YYYY-MM-DD')),
          date_end: new Date(moment(dateEnd).format('YYYY-MM-DD')),
          logo: vm.advertising.logo
        };
        $rootScope.itemName = vm.advertising.title || '';
      }

    }


    /**
     * Send add Advertising Form
     */
    function submitAddAdvertisingForm() {
      var formData = angular.copy(vm.empAdvertisingForm);
      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;
      $rootScope.loadingProgress = true;
      msApi.request('advertising.editAdvertising@save',
        {id: vm.advertising.id, "empAdvertisingForm": angular.copy(vm.empAdvertisingForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.advertising = vm.empAdvertisingForm;
            webTvGlobal.$flashMessages().set('advertisingEdit', vm.advertising);
            $state.go('app.advertising_list');
          } else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            empAdvertisingError = [];
            errors.forEach(function (item) {
              empAdvertisingError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAdvertisingForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    vm.ngFlowOptions = {
      target: Routing.generate('api_parameters_post_advertising_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };
    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    var imageName;

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empAdvertisingForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empAdvertisingForm.logo = vm.advertising.logo = res.location.path;
        vm.urlVignette = res.location.url;

      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empAdvertisingForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empAdvertisingForm.logo = "";
        });
      }
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.new_template_manager.list',["datatables"])
        .config(config);
    /** @ngInject */
    function config($stateProvider,$translatePartialLoaderProvider, msApiProvider,msNavigationServiceProvider)
    {
        // State
        $stateProvider
                .state('app.new_template_manager_list', {
                    url: "/new-template-manager/list",
                    abstract: true,
                  "actionPermission" : "display_new_template_list_dtable_action"
                }).state('app.new_template_manager_list_all', {
                    parent: 'app.new_template_manager_list',
                    url: '/all',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/displayNew/template_manager/list/list.html',
                            controller: 'templateManagerTemplateListNew as vm'
                        }
                    },
                    resolve: {
                        templatesData: function () {
                            return 'templatesDisplay.list_data_table@get';
                        },
                        pagetitle: function () {
                            return 'PAGESMENUSTITLES.display_programs_list_pagetitle';
                        },
                        labelDiffusion: function () {
                            return 'TMTEMPLATESLIST.all';
                        }
                    },
                    "actionPermission" : "display_new_template_list_dtable_action"
                }).state('app.new_template_manager_list_on_going', {
                    parent: 'app.new_template_manager_list',
                    url: '/on-going',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/displayNew/template_manager/list/list.html',
                            controller: 'templateManagerTemplateListNew as vm'
                        }
                    },
                    resolve: {
                        templatesData: function () {
                            return 'templatesDisplay.list_data_table_on_going@get';
                        },
                        pagetitle: function () {
                            return 'TMTEMPLATESLIST.display_programs_list_pagetitle_on_going';
                        },
                        labelDiffusion: function () {
                            return 'TMTEMPLATESLIST.ongoing';
                        }
                    },
          "actionPermission" : "display_new_template_list_dtable_action"
                }).state('app.new_template_manager_list_archived', {
                    parent: 'app.new_template_manager_list',
                    url: '/archived',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/displayNew/template_manager/list/list.html',
                            controller: 'templateManagerTemplateListNew as vm'
                        }
                    },
                    resolve: {
                        templatesData: function () {
                            return 'templatesDisplay.list_data_table_offline@get';
                        },
                        pagetitle: function () {
                            return 'TMTEMPLATESLIST.display_programs_list_pagetitle_archive';
                        },
                        labelDiffusion: function () {
                            return 'TMTEMPLATESLIST.show_archive';
                        }
                    },
                    "actionPermission" : "display_new_template_list_dtable_action"
                }).state('app.new_template_manager_list_upcoming', {
                    parent: 'app.new_template_manager_list',
                    url: '/up-coming',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/displayNew/template_manager/list/list.html',
                            controller: 'templateManagerTemplateListNew as vm'
                        }
                    },
                    resolve: {
                        templatesData: function () {
                            return 'templatesDisplay.list_data_table_up_coming@get';
                        },
                        pagetitle: function () {
                            return 'TMTEMPLATESLIST.display_programs_list_pagetitle_upcoming';
                        },
                        labelDiffusion: function () {
                            return 'TMTEMPLATESLIST.upcoming';
                        }
                    },
                   "actionPermission" : "display_new_template_list_dtable_action"
                });

        msApiProvider.register('templatesDisplay.list_data_table', [Routing.generate('api_dtable_displaylist_dtable_templates_display')]);
        msApiProvider.register('templatesDisplay.list_data_table_on_going', [Routing.generate('api_dtable_displaylist_on_going_dtable_templates_display')]);
        msApiProvider.register('templatesDisplay.list_data_table_offline', [Routing.generate('api_dtable_displaylist_offline_dtable_templates_display')]);
        msApiProvider.register('templatesDisplay.list_data_table_up_coming', [Routing.generate('api_dtable_displaylist_up_coming_dtable_templates_display')]);
        msApiProvider.register('templates.deleteTemplateNewDisplay', [Routing.generate('api_templateDisplay_delete_one_template', {id: ':id'}).replace(/%3A/, ":"),{id: '@id'}]);
        msApiProvider.register('templates.duplicateTemplateNewDisplay', [Routing.generate('api_templateDisplay_post_duplicate_template_segment', {id: ':id'}).replace(/%3A/, ":"),{id: '@id'}]);
        $translatePartialLoaderProvider.addPart('app/main/displayNew/template_manager/list');
        msApiProvider.register('template.deleteByListNewDisplay', [Routing.generate('api_templateDisplay_delete_template_many') + "/:list", {list: '@list'}]);
        msApiProvider.register('templates.getUrlsTemplate', [Routing.generate('api_templateDisplay_get_template_urls', {id: ':id'}).replace(/%3A/, ":"),{id: '@id'}]);
        msApiProvider.register('template.editTitle', [Routing.generate('api_templateDisplay_post_edit_title_template')]);
        msApiProvider.register('template.editLigne', [Routing.generate('api_templateDisplay_post_edit_ligne_template')]);
        msApiProvider.register('template.showVideoTemplate', [Routing.generate('api_templateDisplay_get_video_template', {id: ':id'}).replace(/%3A/, ":"),{id: '@id'}]);
        msApiProvider.register('template.downloadVideoTemplate', [Routing.generate('api_media_download_video') + "/:id", {id: '@id'}]);
        msApiProvider.register('template.checkTranscodOperation', [Routing.generate('api_media_post_check_if_videos_are_done_transoding')]);

        
    }
})();

(function () {
    'use strict';

    angular
        .module('app.new_template_manager.list')
        .controller('templateManagerTemplateListNew', templateManagerTemplateListNew)
    ;

    /** @ngInject */
    function templateManagerTemplateListNew(templatesData,pagetitle, labelDiffusion, userManager, $injector, $scope, $window, $rootScope, $cookies, $translate, $compile, $mdDialog, $state, msApi, webTvGlobal, DTColumnBuilder, msUtils, order_template, DTOptionsBuilder, dtable_language,dialogConfirmDeleteService,webTv_msNavigation) {
        var columnsApi = order_template;
        var vm = this;
        var $interval = $injector.get('$interval');
        var numberRecords = $cookies.get('numberRecords') || 10;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        var urlFoDisplay = angular.isDefined(parameters.url_fo_display) ? parameters.url_fo_display : "";
        vm.nb_list = 0;
        vm.nb_list_diffusion = 0;
        vm.labelDiffusion = labelDiffusion;
        if (userManager.isActionGranted('display_new_template_list_dtable')) {
            vm.nb_list++;
        }
        if (userManager.isActionGranted('display_new_template_list_dtable_ongoing')) {
            vm.nb_list++;
            vm.nb_list_diffusion++;
        }
        if (userManager.isActionGranted('display_new_template_list_dtable_offline')) {
            vm.nb_list++;
            vm.nb_list_diffusion++;
        }
        if (userManager.isActionGranted('display_new_template_list_dtable_upcoming')) {
            vm.nb_list++;
            vm.nb_list_diffusion++;
        }
        vm.empTemplateListStatus = "all";
        vm.search_template = "";
        vm.selectedTemplates = [];
        var selectedTemplates = [];
        vm.templates = [];
        vm.recordsTotal = 0;
        vm.dtInstance = {};
        vm.editTitle = false;
        vm.editLigne = false;
        vm.focusEditLigne = false;
        vm.focusEditTitle = false;
        vm.templatesDataTable = {};

        var listNotTranscodedVideo = [];

      if (angular.isUndefined(parameters['app.client.name'])) {
            $rootScope.loadingProgress = true;
            msApi.request('parametersBagLogin.app@get', function (res) {
                parameters = res.bag;
                $rootScope.loadingProgress = false;
                init_controller();

            });
        }else{
            init_controller();
        }

        function init_controller(){
            var urlFoDisplay = angular.isDefined(parameters.url_fo_display) ? parameters.url_fo_display : "";
            initHelp();

            function initHelp() {

              if(webTv_msNavigation['display_new_new_template_manager']) {
                $rootScope.titre1 = "PAGESMENUSTITLES.display_programs_menuTitle";
                $rootScope.titre2 = pagetitle;
                $rootScope.titre3 ='';
              } else{
                $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.display_programs_menuTitle";
                $rootScope.titre3 = pagetitle;
              }

                $rootScope.welcome = "welcome_tem_manager";
                $rootScope.text = [{
                    texte: "add_button_manager_help"
                }, {
                    texte: "arrow_button_manager_help"
                }, {
                    texte: "search_area_manager_help"
                }, {
                    texte: "tri_column_manager_help"
                },
                    {
                        texte: "edit_button_manager_help"
                    }, {
                        texte: "detail_button_manager_help"
                    },
                    {
                        texte: "delete_button_manager_help"
                    },
                    {texte: "export_button_manager_help"}];

            }

            $rootScope.DTOptionsBuilder = DTOptionsBuilder;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                // or here
                .withDataProp('data')
                .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
                .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('columnDefs', [[
                    {
                        // Target the checkbox column
                        targets: 0,
                        responsivePriority: 1
                    },
                    {
                    // Target the id column
                    targets: [1],
                    width: '250px'
                  },

                {
                    // Target the actions column
                    targets: 8,
                    width: '100px',
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false).withOption('defaultContent', '')
                .renderWith(function (data, type, full, meta) {
                    vm.templatesDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.templatesDataTable[' + data.id + '].checked"' + 'ng-click="vm.toggle(vm.templatesDataTable[' + data.id + '])"' + 'aria-label="-">' + '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).renderWith(function (data, type, full, meta) {
                vm.templatesDataTable[data.id] = data;
                var input = '<div show-gt-md show-sm show-md hide-xs flex><form ng-if="vm.templatesDataTable[' + data.id + '].editTitle" ng-submit="vm.onSubmitEditTitle(vm.templatesDataTable[' + data.id + '])">' +
                    '<input style="padding: 10px;border: 1px solid rgb(230, 230, 230);text-align: center;font-size: 14px;background: #f9f8f8;width: 250px;" ' +
                    'ng-if="vm.templatesDataTable[' + data.id + '].editTitle" ' +
                    'data-ng-style="vm.focusEditTitle  && {\'border-color\':\'#1a73e8\'}"' +
                    'ng-blur="vm.blurEditTitle('+data.id +')" ' +
                    'ng-mouseout="vm.leaveEditTitle('+data.id +')" ' +
                    'ng-keydown="vm.hasEditTitle()" ' +
                    'ng-click="vm.hasFocusEditTitle()" '+
                    ' type="text" ng-model="vm.templatesDataTable[' + data.id + '].title"' + ' aria-labelledby="" /> ' +
                    '</form> ' +
                    '<label ng-if="'+data.title.length+'<=30 && !vm.templatesDataTable[' + data.id + '].editTitle" style="padding: 5px" data-ng-style="'+data.title.length+'==0 && {\'padding\': \'20px\'}" ng-mouseover="vm.editTitleTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.title + ' </label>'+
                    '<label ng-if="'+data.title.length+'>30 && !vm.templatesDataTable[' + data.id + '].editTitle" style="padding: 5px" data-ng-style="'+data.title.length+'==0 && {\'padding\': \'20px\'}"  ng-mouseover="vm.editTitleTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.title.substring(0,30) + '... </label></div>';

                input += '<div hide-md hide-sm show-xs hide-gt-md flex><form ng-if="vm.templatesDataTable[' + data.id + '].editTitle" ng-submit="vm.onSubmitEditTitle(vm.templatesDataTable[' + data.id + '])">' +
                    '<input style="padding: 10px;border: 1px solid rgb(230, 230, 230);text-align: center;font-size: 14px;background: #f9f8f8;width: 92px;" ' +
                    'ng-if="vm.templatesDataTable[' + data.id + '].editTitle" ' +
                    'data-ng-style="vm.focusEditTitle  && {\'border-color\':\'#1a73e8\'}"' +
                    'ng-blur="vm.blurEditTitle('+data.id +')" ' +
                    'ng-mouseout="vm.leaveEditTitle('+data.id +')" ' +
                    'ng-keydown="vm.hasEditTitle()" ' +
                    'ng-click="vm.hasFocusEditTitle()" '+
                    ' type="text" ng-model="vm.templatesDataTable[' + data.id + '].title"' + ' aria-labelledby="" /> ' +
                    '</form> ' +
                    '<label ng-if="'+data.title.length+'<=30 && !vm.templatesDataTable[' + data.id + '].editTitle" style="padding: 5px" data-ng-style="'+data.title.length+'==0 && {\'padding\': \'20px\'}" ng-mouseover="vm.editTitleTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.title + ' </label>'+
                    '<label ng-if="'+data.title.length+'>30 && !vm.templatesDataTable[' + data.id + '].editTitle" style="padding: 5px" data-ng-style="'+data.title.length+'==0 && {\'padding\': \'20px\'}"  ng-mouseover="vm.editTitleTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.title.substring(0,30) + '... </label></div>';

                return '<div class="title_programme">' + input  + '</div>';
            }),
            DTColumnBuilder.newColumn(null).renderWith(function (data, type, full, meta) {
                vm.templatesDataTable[data.id] = data;
                if(data.ligne===null){
                    data.ligne = "";
                }
                var input = '<div show-gt-md show-sm show-md hide-xs flex><form ng-if="vm.templatesDataTable[' + data.id + '].editLigne" ng-submit="vm.onSubmitEditLigne(vm.templatesDataTable[' + data.id + '])">' +
                    '<input style="padding: 10px;border: 1px solid rgb(230, 230, 230);text-align: center;font-size: 14px;background: #f9f8f8;width: 250px;" ' +
                    'ng-if="vm.templatesDataTable[' + data.id + '].editLigne" ' +
                    'data-ng-style="vm.focusEditLigne  && {\'border-color\':\'#1a73e8\'}"' +
                    'ng-blur="vm.blurEditLigne('+data.id +')" ' +
                    'ng-mouseout="vm.leaveEditLigne('+data.id +')" ' +
                    'ng-keydown="vm.hasEditLigne()" ' +
                    'ng-click="vm.hasFocusEditLigne()" '+
                    ' type="text" ng-model="vm.templatesDataTable[' + data.id + '].ligne"' + ' aria-labelledby="" /> ' +
                    '</form> ' +
                    '<label ng-if="'+data.ligne.length+'<=30 && !vm.templatesDataTable[' + data.id + '].editLigne" style="padding: 5px" data-ng-style="'+data.ligne.length+'==0 && {\'padding\': \'20px\'}" ng-mouseover="vm.editLigneTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.ligne + ' </label>'+
                    '<label ng-if="'+data.ligne.length+'>30 && !vm.templatesDataTable[' + data.id + '].editLigne" style="padding: 5px" data-ng-style="'+data.ligne.length+'==0 && {\'padding\': \'20px\'}"  ng-mouseover="vm.editLigneTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.ligne.substring(0,30) + '... </label></div>';

                input += '<div hide-md hide-sm show-xs hide-gt-md flex><form ng-if="vm.templatesDataTable[' + data.id + '].editLigne" ng-submit="vm.onSubmitEditLigne(vm.templatesDataTable[' + data.id + '])">' +
                    '<input style="padding: 10px;border: 1px solid rgb(230, 230, 230);text-align: center;font-size: 14px;background: #f9f8f8;width: 92px;" ' +
                    'ng-if="vm.templatesDataTable[' + data.id + '].editLigne" ' +
                    'data-ng-style="vm.focusEditLigne  && {\'border-color\':\'#1a73e8\'}"' +
                    'ng-blur="vm.blurEditLigne('+data.id +')" ' +
                    'ng-mouseout="vm.leaveEditLigne('+data.id +')" ' +
                    'ng-keydown="vm.hasEditLigne()" ' +
                    'ng-click="vm.hasFocusEditLigne()" '+
                    ' type="text" ng-model="vm.templatesDataTable[' + data.id + '].ligne"' + ' aria-labelledby="" /> ' +
                    '</form> ' +
                    '<label ng-if="'+data.ligne.length+'<=30 && !vm.templatesDataTable[' + data.id + '].editLigne" style="padding: 5px" data-ng-style="'+data.ligne.length+'==0 && {\'padding\': \'20px\'}" ng-mouseover="vm.editLigneTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.ligne + ' </label>'+
                    '<label ng-if="'+data.ligne.length+'>30 && !vm.templatesDataTable[' + data.id + '].editLigne" style="padding: 5px" data-ng-style="'+data.ligne.length+'==0 && {\'padding\': \'20px\'}"  ng-mouseover="vm.editLigneTemplate(vm.templatesDataTable[' + data.id + '])"> ' + data.ligne.substring(0,30) + '... </label></div>';

                return data.ligne;
            }),
            DTColumnBuilder.newColumn('duration').notSortable().renderWith(function (data) {
                if(angular.isDefined(data)){
                    return data;
                }else{
                    return "";
                }
            }),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(function (data) {
                if(angular.isDefined(data.video) && data.video && angular.isDefined(data.video.created_at) && data.video.created_at){
                    return moment(data.video.created_at).format(("DD/MM/YYYY"));
                }else{
                    return "";
                }
            }),
            DTColumnBuilder.newColumn(null).notSortable().renderWith(function (data) {
              if(angular.isDefined(data.contributor) && data.contributor && angular.isDefined(data.contributor.id) && data.contributor.id){
                return data.contributor.firstName +" "+ data.contributor.lastName;
              }else{
                return "";
              }
            }),
            DTColumnBuilder.newColumn('statut').renderWith(function (data) {
                if(angular.isDefined(data)){
                    return $translate.instant('TMTEMPLATESLIST.'+data)
                }else{
                    return "";
                }
            }),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data, type, full, meta) {
                    vm.templatesDataTable[data.id] = data;

                        var buttonActionDetailHtml =
                            '<a has-permission="display_new_template_preview"  tooltips tooltip-template=' + "{{'TMTEMPLATESLIST.action_open'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.showTemplateDetail(vm.templatesDataTable[' + data.id + '],$event)" aria-label="action_open"translate translate-attr-aria-label="TMTEMPLATESLIST.action_open">' +
                            '<md-icon  md-font-icon="icon-open-in-new" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                        var buttonActionExport =
                            '<a has-permission="display_new_template_export"  tooltips tooltip-template=' + "{{'TMTEMPLATESLIST.action_export'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.exportTemplateLink(vm.templatesDataTable[' + data.id + '],$event)" aria-label="action_export"translate translate-attr-aria-label="TMTEMPLATESLIST.action_export">' +
                            '<md-icon  md-font-icon="icon-export" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                        var buttonActionEditHtml =
                            '<a has-permission="display_new_template_edit"  tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.editTemplate(vm.templatesDataTable[' + data.id + '])" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                            '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                            '</md-button></a>';
                        var buttonActionDelete =
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.deleteTemplateConfirm(vm.templatesDataTable[' + data.id + '])" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                            '<md-icon  md-font-icon="icon-trash" class="s18"></md-icon>' +
                            '</md-button></a>';

                        var buttonActionDuplicate =
                            '<a has-permission="display_new_template_duplicate" tooltips tooltip-template=' + "{{'MESSAGES.action_duplicate'|translate}}" + ' tooltip-side="bottom left" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.duplicateTemplate(' + data.id + ')" aria-label="action_duplicate" translate translate-attr-aria-label="MESSAGES.action_duplicate">' +
                            '<md-icon  md-font-icon="icon-content-duplicate" class="s18"></md-icon>' +
                            '</md-button></a>';

                        var buttonActionPreviewVideo =
                            '<a has-permission="display_new_template_preview_video" tooltips tooltip-template=' + "{{'MESSAGES.video_preview'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.previewVideoTemplate(' + data.id + ',$event)" aria-label="video_preview" translate translate-attr-aria-label="MESSAGES.video_preview">' +
                            '<md-icon  md-font-icon="icon-play-circle" class="s18"></md-icon>' +
                            '</md-button></a>';




                        if(!data.isDuplicable || data.isDuplicable==="0"){
                            buttonActionDuplicate = "";
                        }
                        var progress = '<md-progress-circular md-mode="indeterminate" md-diameter="20px" style="display:inline"></md-progress-circular>';
                        if (parameters.generate_video_display === "1" && angular.isDefined(data.video) && data.video && angular.isDefined(data.video.id) && angular.isDefined(data.video.isTranscoded) && !data.video.isTranscoded) {
                            if(listNotTranscodedVideo.indexOf(data.video.id) ===-1) {
                                listNotTranscodedVideo.push(data.video.id);
                            }
                            return buttonActionDetailHtml + buttonActionExport + buttonActionDelete + buttonActionDuplicate+progress ;
                        }else if (parameters.generate_video_display === "1" && angular.isDefined(data.video) && data.video && angular.isDefined(data.video.id) && angular.isDefined(data.video.isTranscoded) && data.video.isTranscoded) {
                          var buttonActionDownloadVideo =
                            '<a has-permission="display_new_template_preview_video" tooltips tooltip-template=' + "{{'MESSAGES.upload'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.downloadVideo(' + data.video.id + ',$event)" aria-label="upload" translate translate-attr-aria-label="MESSAGES.upload">' +
                            '<md-icon  md-font-icon="icon-download" class="s18"></md-icon>' +
                            '</md-button></a>';
                          var buttonActionExportLink=
                            '<a  has-permission="media_video_get_video_url" tooltips tooltip-template='+"{{'MESSAGES.export_video'|translate}}" +' tooltip-side="bottom left" tooltip-speed="fast">'
                            + '<md-button class="edit-button md-icon-button" ng-click="vm.exportProgramme('+ data.video.id +',$event)" aria-label="export">'
                            + '<md-icon md-font-icon="icon-link-variant" class="s18"></md-icon>'
                            +'</md-button></a>';
                            return buttonActionDetailHtml + buttonActionExport + buttonActionDelete + buttonActionDuplicate + buttonActionPreviewVideo + buttonActionDownloadVideo +buttonActionExportLink;
                        } else {
                            return buttonActionDetailHtml + buttonActionEditHtml + buttonActionExport + buttonActionDelete + buttonActionDuplicate ;
                        }
                    })
            ]
            ;

          if(vm.labelDiffusion !== 'TMTEMPLATESLIST.all' || (!userManager.isActionGranted('display_new_template_list_dtable_ongoing') && !userManager.isActionGranted('display_new_template_list_dtable_offline'))) {
            vm.dtColumns[7].bVisible = false;
          }
            if(!userManager.isActionGranted("display_new_template_list_show_ligne")){
                vm.dtColumns[3].bVisible = false;
          }
            if(!userManager.isActionGranted("display_new_template_list_show_duration")){
                vm.dtColumns[4].bVisible = false;
            }
            if(!userManager.isActionGranted("display_new_template_list_show_date_generation")){
                vm.dtColumns[5].bVisible = false;
            }
            if(!userManager.isActionGranted("display_new_template_list_show_contributor")){
              vm.dtColumns[6].bVisible = false;
            }
        }
        var checkIfNotTranscodedVideosAreTranscodedInterval = $interval(function () {
            checkIfNotTranscodedVideosAreTranscoded()
        }, 30000);
        vm.screen = [];
        vm.broadcastedEvents = [];
        $rootScope.stages = [];
        $rootScope.option = [];
        vm.initiaBlock = initiaBlock;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.rerender = rerender;
        vm.addNewTemplateNew = addNewTemplateNew;
        vm.editTemplate = editTemplate;
        vm.editTitleTemplate = editTitleTemplate;
        vm.editLigneTemplate = editLigneTemplate;
        vm.leaveEdittLigne = leaveEdittLigne;
        vm.blurEditLigne = blurEditLigne;
        vm.hasEditLigne = hasEditLigne;
        vm.onSubmitEditLigne = onSubmitEditLigne;
        vm.leaveEditLigne = leaveEditLigne;
        vm.leaveEditTitle = leaveEditTitle;
        vm.blurEditTitle = blurEditTitle;
        vm.hasEditTitle = hasEditTitle;
        vm.hasFocusEditTitle = hasFocusEditTitle;
        vm.hasFocusEditLigne = hasFocusEditLigne;
        vm.onSubmitEditTitle = onSubmitEditTitle;
        vm.showTemplateDetail = showTemplateDetail;
        vm.exportTemplateLink = exportTemplateLink;
        $rootScope.rerender = rerender;
        vm.searchTemplate = searchTemplate;
        vm.deleteTemplateConfirm = deleteTemplateConfirm;
        vm.duplicateTemplate = duplicateTemplate;
        vm.previewVideoTemplate = previewVideoTemplate;
        vm.downloadVideo = downloadVideo;
        vm.deleteTemplate = deleteTemplate;
        vm.deleteSelectedTemplatesConfirm = deleteSelectedTemplatesConfirm;
        vm.deleteSelectedTemplates = deleteSelectedTemplates;
        vm.convertDuration = convertDuration;
        vm.checkFlashMessage = checkFlashMessage;
        vm.clearFlashMessage = clearFlashMessage;
        vm.flashMessages = {title: ""};
        vm.showFlasMessageToast = showFlasMessageToast;
        vm.exportProgramme=exportProgramme;
        vm.showFlasMessageToast('displayGroupAdd', $translate.instant('TMTEMPLATESLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        vm.showFlasMessageToast('displayGroupEdit', $translate.instant('TMTEMPLATESLIST.edited'));
      function exportProgramme(id) {
        var lang = "";
        msApi.request(
          'media_video.getUrlExport@get',
          {id: id, lang: lang},
          function (res) {
            $mdDialog.show({
              controller: 'mediaVideoUrlModalController',
              controllerAs: 'vm',
              templateUrl: 'app/main/media/video/list/url.modale.template.html',
              clickOutsideToClose: true,
              locals: {
                video: res.video,
                id: id
              }
            }).then(function () {
              // $rootScope.$broadcast('VideoList::setInactive');
            }, function () {
              // $rootScope.$broadcast('VideoList::setInactive');
            });
          }, function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            }
          }
        ).then(function () {
        });
      }
        function convertDuration(seconds) {
            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;
            var minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;
            return (days ? (days + "<strong> " + $translate.instant("TMTEMPLATESLIST." + (days > 1 ? "days" : "day")) + "</strong> ") : "")
                + (hours ? (hours + "<strong> " + $translate.instant("TMTEMPLATESLIST." + (hours > 1 ? "hours" : "hour")) + "</strong> ") : "")
                + (minutes ? (minutes + "<strong> " + $translate.instant("TMTEMPLATESLIST." + (minutes > 1 ? "minutes" : "minute")) + "</strong> ") : "")
                + (seconds ? (seconds + "<strong> " + $translate.instant("TMTEMPLATESLIST." + (seconds > 1 ? "seconds" : "second")) + "</strong> ") : "")
        }

        function checkIfNotTranscodedVideosAreTranscoded() {
            if (listNotTranscodedVideo.length) {
                msApi.request(
                    'template.checkTranscodOperation@save',
                    {list: listNotTranscodedVideo},
                    function (res) {
                        if (res.code === 200 && res.videos.length) {
                            for (var i = 0; i < res.videos.length; i++) {
                                listNotTranscodedVideo.splice(listNotTranscodedVideo.indexOf(res.videos[i].id), 1);
                            }
                            rerender();
                            if (listNotTranscodedVideo.length === 0) $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
                        }

                    },
                    function () {
                        $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
                    }
                );
            }
            else {
                $interval.cancel(checkIfNotTranscodedVideosAreTranscodedInterval);
            }
        }
        function initiaBlock() {
            vm.broadcastedEvents[vm.broadcastedEvents.length] = $rootScope.$on('Editor::sideNav-screen', function (event, data) {
                vm.screen = data.screen;
                if (angular.isDefined(vm.screen.background.allowedToUseBackgroundImage) && !vm.screen.background.allowedToUseBackgroundImage) vm.screen.background.useBackgroundImage = "no";
                if (!vm.screenOptions) vm.screenOptions = data.screenOptions;
                vm.showParams = 1;
                vm.paramTabIsDiabled = true;
                vm.transitionWay = "in";
                $rootScope.option = vm.screenOptions;
                $rootScope.stages = vm.screen;
                $window.localStorage.setItem("array", JSON.stringify(vm.screen));
                $window.localStorage.setItem("arrayopption", JSON.stringify(vm.screenOptions));

            });
        }


        /*DATABLE METHOD*/
        function searchTemplatesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request(templatesData, filtre,
                function (response) {
                    if (response.code === 200) {
                        var records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.templates = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else if (angular.isDefined(response.errors)) {
                        var records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.templates = [];
                        vm.recordsTotal = 0;

                        var errors = response.errors;
                        errors.forEach(function (item) {

                            $translate('VALIDATION.' + item.messages[0]).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });


                        });
                        vm.fnCallback(records);
                    } else {
                        var records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.templates = [];
                        vm.recordsTotal = 0;

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.templates = [];
                    vm.recordsTotal = 0;
                    vm.fnCallback(records);
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        } else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback, oSettings) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedTemplates = [];
            vm.checkedSelected = false;
            vm.filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_template,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            vm.filtre["columns[" + numColum + "][orderable]"] = true;

            vm.fnCallback = fnCallback;
            searchTemplatesInAPI(vm.filtre);
        }


        vm.getElement = getElement;
        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }


        /**
         * Toggle selected status of the user
         *
         * @param template
         */
        function toggle(template) {
            template.checked = !template.checked;
            var idx = selectedTemplates.indexOf(template);
            if (idx > -1) {
                selectedTemplates.splice(idx, 1);
            }
            else {
                selectedTemplates.push(template);
            }
            vm.selectedTemplates = angular.copy(selectedTemplates);
        }

        function toggleAll() {
            getElement();
            if (selectedTemplates.length === vm.templates.length) {
                vm.selectedTemplates = [];
            }
            else if ((selectedTemplates.length === 0) || (selectedTemplates.length > 0)) {
                vm.selectedTemplates = vm.templates.slice(0);
            }
            selectedTemplates = angular.copy(vm.selectedTemplates);
            var list_template = angular.copy(vm.templatesDataTable);
            angular.forEach(list_template, function (value, key) {
                if (value !== undefined)
                    vm.templatesDataTable[key].checked = selectedTemplates.length > 0;
            });
        }

        /**
         * rerender datatable
         */
        function rerender() {
            vm.dtInstance.rerender();
        }

        /**
         * Show Template Details
         * @param template
         */
        function showTemplateDetail(template, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('templates.getUrlsTemplate@get', {id: template.id},
                function (response) {
                    $rootScope.loadingProgress = false;

                    if (response.code === 200) {
                        webTvGlobal.openNewWindow(response.data.url_preview);





                    }
                }, function (response) {
                    return response;
                    $rootScope.loadingProgress = false;

                }
            );
        }


        /**
         * Submit stepper form
         *
         * @param ev
         */
        function exportTemplateLink(template, ev) {
            $rootScope.loadingProgress = true;

            msApi.request('templates.getUrlsTemplate@get', {id: template.id},
                function (response) {
                    if (response.code === 200) {
                        $rootScope.loadingProgress = false;

                        $mdDialog.show({
                            controller: function ($mdDialog, link, $translate) {
                                var vm = this;
                                vm.link = link;
                                vm.closeDialog = function () {
                                    $mdDialog.hide();
                                };
                            },
                            templateUrl: 'app/main/displayNew/template_manager/list/url.modale.template.html',
                            parent: angular.element('body'),
                            targetEvent: ev,
                            locals: {
                                link: (response.data.url_preview)
                            },
                            controllerAs: 'vm',
                            clickOutsideToClose: true
                        });




                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;

                    return response;
                }
            );

        }

        /**
         * redirection to edit template page
         * @param template
         */
        function editTemplate(template) {
            vm.clearFlashMessage();
            $rootScope.titre3 = "PAGESMENUSTITLES.display_programs_edit_pagetitle";
            $state.go('app.new_template_manager_edit', {id: template.id});
            initiaBlock();
             }

            function blurEditTitle(id){
                if(vm.focusEditTitle && vm.editTitle ){
                    vm.templatesDataTable[id].editTitle = false;
                    onSubmitEditTitle(vm.templatesDataTable[id]);
                }else{
                    vm.templatesDataTable[id].editTitle=false;
                    vm.focusEditTitle = false;
                }
            }

             function leaveEditTitle(id) {

                if(!vm.focusEditTitle ){
                    vm.templatesDataTable[id].editTitle=false;
                }
             }
             function hasEditTitle() {
                 vm.editTitle = true;
             }
             function hasFocusEditTitle() {
                 vm.focusEditTitle = true;
             }
        function editTitleTemplate(template) {
            if(!vm.focusEditTitle) {
                var list_template = angular.copy(vm.templatesDataTable);
                angular.forEach(list_template, function (value, key) {
                    if (value !== undefined)
                        vm.templatesDataTable[key].editTitle = false;
                });

                template.editTitle = true;
            }
        }

        function onSubmitEditTitle(template) {
            $rootScope.loadingProgress = true;
            msApi.request('template.editTitle@save',
                {"id": template.id, "title": template.title},
                function (res) {
                    if (res.code === 200) {
                        template.editTitle = false;
                        vm.focusEditTitle = false;
                        vm.editTitle = false;
                        vm.rerender();
                        $rootScope.loadingProgress = false;
                        webTvGlobal.$toast().showSimple($translate.instant('TMTEMPLATESLIST.dialog_alert_edit_title'));
                    }
                    else {
                        webTvGlobal.alertDialog(res.message);

                    }
                },
                function (res) {
                    webTvGlobal.alertDialog(res.data.message);
                }
            );
        }
        function leaveEditLigne(id) {

            if(!vm.focusEditLigne ){
                vm.templatesDataTable[id].editLigne=false;
            }
        }
        function editLigneTemplate(template) {
            if(!vm.focusEditLigne) {
                var list_template = angular.copy(vm.templatesDataTable);
                angular.forEach(list_template, function (value, key) {
                    if (value !== undefined)
                        vm.templatesDataTable[key].editLigne = false;
                });

                template.editLigne = true;
            }
        }
        function hasFocusEditLigne() {
            vm.focusEditLigne = true;
        }
        function hasEditLigne() {
            vm.editLigne = true;
        }
        function blurEditLigne(id){
            if(vm.focusEditLigne && vm.editLigne ){
                vm.templatesDataTable[id].editLigne = false;
                onSubmitEditLigne(vm.templatesDataTable[id]);
            }else{
                vm.templatesDataTable[id].editLigne=false;
                vm.focusEditLigne = false;
            }
        }
        function leaveEdittLigne(id) {

            if(!vm.focusEditLigne ){
                vm.templatesDataTable[id].editLigne=false;
            }
        }
        function onSubmitEditLigne(template) {
            $rootScope.loadingProgress = true;
            msApi.request('template.editLigne@save',
                {"id": template.id, "ligne": template.ligne},
                function (res) {
                    if (res.code === 200) {
                        template.editLigne = false;
                        vm.focusEditLigne = false;
                        vm.editLigne = false;
                        vm.rerender();
                        $rootScope.loadingProgress = false;
                        webTvGlobal.$toast().showSimple($translate.instant('TMTEMPLATESLIST.dialog_alert_edit_ligne'));
                    }
                    else {
                        webTvGlobal.alertDialog(res.message);

                    }
                },
                function (res) {
                    webTvGlobal.alertDialog(res.data.message);
                }
            );
        }
        /**
         * redirection to add new template page
         */
        function addNewTemplateNew() {
            vm.clearFlashMessage();
            $rootScope.titre3 = "PAGESMENUSTITLES.display_programs_add_menuTitle";
            $state.go('app.new_template_manager_editornew');
        }

        /**
         * Search template
         */
        function searchTemplate(value) {
            vm.filtre["search[value]"] = vm.search_template;
            vm.filtre.status = value ;
            vm.labelDiffusion = value  == 'pending' ? 'TMTEMPLATESLIST.ongoing' : ( value  == 'finish' ? 'TMTEMPLATESLIST.finish' : 'TMTEMPLATESLIST.all');
            searchTemplatesInAPI(vm.filtre);
        }


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op))
                webTvGlobal.$toast().showSimple((vm.flashMessages.title ? ("\"" + vm.flashMessages.title + "\" ") : "Template ") + message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!vm.flashMessages.title)
                vm.flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (vm.flashMessages.title) {
                vm.flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }


        /**
         * Delete template Confirm Dialog
         */
        function deleteTemplateConfirm(template, ev) {
                var confirm = $mdDialog.confirm()
                    .title($translate.instant('TMTEMPLATESLIST.delete_template_message'))
                    .htmlContent('<b>' + template.title + '</b>' + $translate.instant('MESSAGES.dialog_will_be_deleted'))
                    .ariaLabel($translate.instant('TMTEMPLATESLIST.delete_template_label'))
                    .targetEvent(ev)
                    .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
                    .cancel($translate.instant('MESSAGES.dialog_cancel'));

                $mdDialog.show(confirm).then(function () {
                    deleteTemplate(template);
                }, function () {
                });


        }

        function duplicateTemplate(id) {
            $rootScope.loadingProgress = true;
            msApi.request('templates.duplicateTemplateNewDisplay@save', {id: id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        webTvGlobal.$toast().showSimple($translate.instant('TMTEMPLATESLIST.dialog_alert_delete_title'));
                        vm.rerender();

                    } else {
                        var alert = $mdDialog.alert({
                            title: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_title'),
                            textContent: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_description'),
                            ok: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_close')
                        });

                        $mdDialog
                            .show(alert)
                            .finally(function () {
                                alert = undefined;
                            });

                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    $rootScope.loadingProgress = false;
                }
            );
        }

        function downloadVideo(vod_id) {
            var ua = navigator.userAgent;
            msApi.request('template.downloadVideoTemplate@get', {id: vod_id},
                function (response) {
                    if (response.data.exist) {
                        if (ua.indexOf('Firefox') !== -1) {
                            var popup = $window.open('', '_blank');
                            popup.location.href = response.data.file;
                        }else
                            window.location.href = response.data.file;
                    }
                    else {
                        $translate([
                            "VIDEOLIST.dialog_download_error_title",
                            "VIDEOLIST.dialog_download_error_text"
                        ])
                            .then(function (translatedValues) {
                                $mdDialog.show(
                                    $mdDialog.alert()
                                        .clickOutsideToClose(true)
                                        .title(translatedValues['VIDEOLIST.dialog_download_error_title'])
                                        .textContent(translatedValues['VIDEOLIST.dialog_download_error_text'])
                                        .ok('OK')
                                );
                            });
                    }
                }, function (error) {
                    if (error.data === null) {
                        webTvGlobal.alertDialog($translate.instant('VIDEOLIST.video_not_found'));
                    }
                }
            );
        };
        function previewVideoTemplate(id, ev) {
            $rootScope.loadingProgress = true;

            msApi.request('template.showVideoTemplate@get', {id: id},
                function (response) {
                    if (response.code === 200) {
                        $rootScope.loadingProgress = false;

                        $mdDialog.show({
                            controller: function ($mdDialog, video_id, url_video, metaData, $translate, $sce,title) {
                                var vm = this;
                                vm.video_id = video_id;
                                vm.url_video = url_video;
                              console.log(title);
                              var videoMetaData = JSON.parse(metaData);

                              var streamVideo = videoMetaData &&
                                                videoMetaData.contentJson &&
                                                videoMetaData.contentJson.streams.length!==0
                                                ? videoMetaData.contentJson.streams.find(function(stream){ return stream.codec_type === "video"}) : undefined;

                              var video_width = streamVideo ? streamVideo.width : undefined;
                              var video_height = streamVideo ? streamVideo.height : undefined;

                              vm.scaled = (video_width === undefined || video_height === undefined ) ? (9/16)*100 : (video_height/video_width)*100 ;
                              vm.closeDialog = function () {
                                    $mdDialog.hide();
                                };
                                vm.trustLink = trustLink;
                                vm.title=title;
                                function trustLink(link) {
                                    return $sce.trustAsResourceUrl(link);
                                }

                            },
                            templateUrl: 'app/main/displayNew/template_manager/list/preview.modal.template.html',
                            parent: angular.element('body'),
                            targetEvent: ev,
                            locals: {
                                video_id: (response.data.video_id),
                                url_video: (response.data.url_video),
                                metaData: (response.data.metaData),
                                title: ( vm.templatesDataTable[id].title ?  vm.templatesDataTable[id].title : ""),
                            },
                            controllerAs: 'vm',
                            clickOutsideToClose: true
                        });




                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('TMTEMPLATESLIST.'+response.data.message));
                    return response;
                }
            );
        }

        /**
         * Delete template
         */
        function deleteTemplate(template) {
            clearFlashMessage();
            if (vm.templates.indexOf(template) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('templates.deleteTemplateNewDisplay@delete', {id: template.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            webTvGlobal.$toast().showSimple(template.title + $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_description'));
                            vm.rerender();

                        } else {
                            var alert = $mdDialog.alert({
                                title: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_title'),
                                textContent: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_description'),
                                ok: $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_close')
                            });

                            $mdDialog
                                .show(alert)
                                .finally(function () {
                                    alert = undefined;
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        } else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                        $rootScope.loadingProgress = false;
                    }
                );

            }


        }


        /**
         * Delete selected templates Confirm Dialog
         */
        function deleteSelectedTemplatesConfirm(ev) {
            var title;
            var ariaLabel;
            if (selectedTemplates.length!== 0) {
                if(selectedTemplates.length === 1){
                    title = 'TMTEMPLATESLIST.delete_template_message';
                    ariaLabel = 'TMTEMPLATESLIST.delete_template_aria_label';
                }else{
                    title = 'TMTEMPLATESLIST.delete_list_templates_message';
                    ariaLabel = 'TMTEMPLATESLIST.delete_templates_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,selectedTemplates.length,title,ariaLabel)).then(function () {
                    deleteSelectedTemplates(ev);
                });

            }

        }

        /**
         * Delete Selected Porgrams
         */
        function deleteSelectedTemplates(ev) {
            if (vm.selectedTemplates.length === 0)
                return;
            $rootScope.loadingProgress = true;
            msApi.request('template.deleteByListNewDisplay@delete', {
                    list: (function (list) {
                        vm.selectedTemplates.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("TMTEMPLATESLIST.undeleted_are", {'list': response.result.undeleted.join(" ")})
                        }
                        deleted = $translate.instant("TMTEMPLATESLIST.deleted_are", {'list': response.result.deleted.join(" ")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedTemplates = [];
                        vm.rerender();

                    } else {
                        webTvGlobal.alertDialog(
                            $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_title'),
                            $translate.instant('TMTEMPLATESLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedTemplates = [];

                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    } else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }


                    selectedTemplates = [];
                    vm.modelCheckAll = false;

                }
            );

        }


    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.advertising.add',['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.advertising_add', {
                url    : "/parameters/advertising/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/advertising/add_edit_view/add_edit.template.html',
                        controller : 'advertisingAddController as vm'
                    }
                },
                resolve: {
                    advertisingData: function (msApi)
                    {
                        return msApi.resolve('advertising.getNewAdvertisingData@get',{id:0});
                    }
                },
                "bodyClass": "forms"
            });
        
        //API
        msApiProvider.register('advertising.getNewAdvertisingData', [Routing.generate('api_parameters_get_detail_advertising',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('advertising.addAdvertising', [Routing.generate('api_parameters_post_add_advertising')]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.interactivity.advertising.add')
    .controller('advertisingAddController', advertisingAddController);

  /** @ngInject */
  function advertisingAddController($cookies,$scope, advertisingData, webTvGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');
    //initiation toolbar path and aide page
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.advertising_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.advertising_add_menuTitle";
      $rootScope.pageRoute = "app.advertising_list";

      $rootScope.welcome = "welcome_advert_add";
      $rootScope.text = [{
        texte: "parameters_advert_add_help"
      }, {
        texte: "send_button_advert_add_help"
      }, {
        texte: "cancel_button_advert_add_help"
      }];
    }

    var vm = this;
    $scope.minDate = new Date();
    vm.isNew = true;
    var imageName;
    vm.urlVignette = "";
    vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });
    var errors = [];
    var empAdvertisingError = [];
    vm.advertising = advertisingData;
    vm.advertising.date_start = new Date();
    vm.advertising.date_end = new Date();
    vm.advertising.date_start = new Date(moment().format('YYYY-MM-DD'));
    vm.advertising.date_end = new Date(moment().format('YYYY-MM-DD'));
    vm.empAdvertisingForm = {
      title: vm.advertising.title,
      link_url: vm.advertising.link_url,
      active: vm.advertising.active ? 1 : 0,
      date_start: new Date(vm.advertising.date_start),
      date_end: new Date(vm.advertising.date_end),
      logo: vm.advertising.logo || ""
    };


    vm.submitAddAdvertisingForm = submitAddAdvertisingForm;


    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    vm.files = [];
    vm.ngFlowOptions = {
      target: Routing.generate('api_parameters_post_advertising_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;


    /**
     * Send add Advertising Form
     */
    function submitAddAdvertisingForm() {
      var formData = angular.copy(vm.empAdvertisingForm);
      if (angular.isDefined(formData.mdTime)) delete formData.mdTime;

      $rootScope.loadingProgress = true;
      msApi.request('advertising.addAdvertising@save',
        {
          "empAdvertisingForm": angular.copy(vm.empAdvertisingForm)
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.advertising = vm.empAdvertisingForm;
            webTvGlobal.$flashMessages().set('advertisingAdd', {title: vm.empAdvertisingForm.title ? vm.empAdvertisingForm.title : ""});
            $state.go('app.advertising_list');
          }
          else if (angular.isDefined(res.errors)) {
            errors = res.errors;
            empAdvertisingError = [];
            errors.forEach(function (item) {
              empAdvertisingError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAdvertisingForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        }, function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empAdvertisingForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location.path) {
        vm.empAdvertisingForm.logo = vm.advertising.logo = res.location.path;
        vm.urlVignette = res.location.url;
      }
    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empAdvertisingForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empAdvertisingForm.logo = "";
        });
      }
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.display_new.schedule.list',
            ["datatables"]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.display_schedule_list_new', {
                url    :"/displayNew/schedule/list",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/displayNew/schedule/list/list.html',
                        controller : 'DisplayNewScheduleListControllerNew as vm'
                    }
                },
                "actionPermission" : "display_schedule_list_dtable_action"
            });
            


        //API
        msApiProvider.register('programDisplay.list', [Routing.generate('api_dtable_displaylist_dtable_program')]);
        msApiProvider.register('programDisplay.getOne', [Routing.generate('api_programDisplay_get_one_program') + "/:id", {id: '@id'}]);
        msApiProvider.register('programDisplay.delete', [Routing.generate('api_programDisplay_delete_one') + "/:id", {id: '@id'}]);
        msApiProvider.register('programDisplay.reloadSchedule', [Routing.generate('api_programDisplay_get_reload_program') + "/:id", {id: '@id'}]);

        msApiProvider.register('programDisplay.deleteByList', [Routing.generate('api_programDisplay_delete_many') + "/:list", {list: '@list'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.display_new.schedule.list')
        .controller('DisplayNewScheduleListControllerNew', DisplayNewScheduleListControllerNew);

    /** @ngInject */
    function DisplayNewScheduleListControllerNew(msUtils, order_schedule, $mdDialog, $cookies, $scope, $translate, msApi, $rootScope, $state, webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $compile, $filter, $document, dtable_language,dialogConfirmDeleteService) {

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;

        //vm.disabled = true;

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_schedule_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_schedule_calendar_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_schedule";
            $rootScope.text = [{
                texte: "add_button_schedule_help"
            }, {
                texte: "arrow_button_schedule_help"
            }, {
                texte: "search_area_schedule_help"
            }, {
                texte: "tri_column_schedule_help"
            },
                {texte:"calendar_button_schedule_help"},
                {
                    texte: "edit_button_schedule_help"
                }, {
                    texte: "delete_button_schedule_help"
                },
                {texte:"open_button_schedule_help"},
                {texte: "refresh_button_schedule_help"}];

        }

        var parameters = webTvGlobal.$constant().webTvParameterBag();
        var columnsApi = order_schedule;

        vm.search_Schedule = "";
        vm.selectedschedules = [];
        var selectedschedules = [];
        vm.schedules = [];
        vm.recordsTotal = 0;
        vm.dtInstance = {};
        vm.schedulesDataTable = {};

        vm.disabled = true;

        vm.addNewSchedule = addNewSchedule;
        vm.showCalendar = showCalendar;
        vm.editSchedule = editSchedule;
        vm.reloadSchedule = reloadSchedule;
        vm.StatusGrille = StatusGrille;

        vm.StatusGrilleTest = StatusGrilleTest;
        vm.testDate = testDate;


        function testDate(startDate, endDate) {
            var currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ");
            startDate = (moment(startDate).format("YYYY-MM-DD HH:mm:ssZ"));
            endDate = (moment(endDate).format("YYYY-MM-DD HH:mm:ssZ"));

            if ((currentDate >= startDate) && (currentDate <= endDate)) {
                //en cours de diffusion

                return true;
            }
            else {
                //n'est pas en cours de diffusion
                return false;
            }
        }


        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    // Target the id column
                    targets: [1],
                    width: '272px'
                },

                {
                    // Target the actions column
                    targets: 3,
                    width: '100px',
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row, data, dataIndex) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false).withOption('defaultContent', '')
                .renderWith(function (data, type, full, meta) {
                    vm.schedulesDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.schedulesDataTable[' + data.id + '].checked"' + 'ng-click="vm.toggle(vm.schedulesDataTable[' + data.id + '])"' + 'aria-label="-">' + '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('title').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('startAt')
                .renderWith(function (data, type, full, meta) {
                    return moment(data).format(("YYYY-MM-DD HH:mm:ss"));

                }).withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('endAt')
                .renderWith(function (data, type, full, meta) {

                    return moment(data).format(("YYYY-MM-DD HH:mm:ss"));
                }).withOption('defaultContent', ''),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data, type, full, meta) {
                    var buttonActionShowHtml = "";
                    var buttonActionEditHtml = "";
                    var buttonActionDeleteHtml = "";
                    vm.schedulesDataTable[data.id] = data;
                    vm.dataTitle = data.title;
                    buttonActionShowHtml =
                        '<a tooltips tooltip-template=' + "{{'DISPLAYSCHEDULELIST.action_open'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showSchedule(vm.schedulesDataTable[' + data.id + '],$event)" aria-label="action_open"translate translate-attr-aria-label="DISPLAYSCHEDULELIST.action_open">' +
                        '<md-icon  md-font-icon="icon-open-in-new" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"])) && ($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "date")) {
                        buttonActionEditHtml =
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.editSchedule( vm.schedulesDataTable[' + data.id + '].id )" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" ng-hide = "vm.testDate( vm.schedulesDataTable[' + data.id + '].startAt, vm.schedulesDataTable[' + data.id + '].endAt )">' +
                            '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                        buttonActionDeleteHtml =
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteScheduleConfirm(vm.schedulesDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete" ng-hide = "vm.testDate( vm.schedulesDataTable[' + data.id + '].startAt, vm.schedulesDataTable[' + data.id + '].endAt )">' +
                            '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                    }
                    else if ((angular.isDefined($rootScope.webTv_parameterBag["modif_delete_schedule_cond"])) && ($rootScope.webTv_parameterBag["modif_delete_schedule_cond"] == "actif")) {
                        if (data.enable === false) {
                            buttonActionEditHtml =
                                '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="edit-button md-icon-button" ng-click="vm.editSchedule( vm.schedulesDataTable[' + data.id + '].id )" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                                '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                                '</md-button>' +
                                '</a>';
                            buttonActionDeleteHtml =
                                '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                                '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteScheduleConfirm(vm.schedulesDataTable[' + data.id + '],ev)" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete">' +
                                '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                                '</md-button>' +
                                '</a>';
                        }
                    }
                    else {
                        buttonActionEditHtml =
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="edit-button md-icon-button" ng-click="vm.editSchedule( vm.schedulesDataTable[' + data.id + '].id )" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                            '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                        buttonActionDeleteHtml =
                            '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteScheduleConfirm(vm.schedulesDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete">' +
                            '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';
                    }

                    var buttonActionReloadHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.button_reload_display'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="display_schedule_get_reload" class="edit-button md-icon-button" ng-click="vm.reloadSchedule( vm.schedulesDataTable[' + data.id + '] )" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                        '<md-icon  md-font-icon="icon-refresh" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';


                    return buttonActionReloadHtml + buttonActionShowHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })
        ]
        ;


        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.rerender = rerender;
        vm.showSchedule = showSchedule;
        $rootScope.rerender = rerender;
        vm.searchSchedule = searchSchedule;

        vm.deleteScheduleConfirm = deleteScheduleConfirm;
        vm.deleteSchedule = deleteSchedule;
        vm.deleteSelectedschedulesConfirm = deleteSelectedschedulesConfirm;
        vm.deleteSelectedschedules = deleteSelectedschedules;
        vm.convertDuration = convertDuration;
        vm.checkFlashMessage = checkFlashMessage;
        vm.clearFlashMessage = clearFlashMessage;
        vm.flashMessages = {title: ""};
        vm.showFlasMessageToast = showFlasMessageToast;
        vm.showFlasMessageToast('displayGroupAdd', $translate.instant('DISPLAYSCHEDULELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        vm.showFlasMessageToast('displayGroupEdit', $translate.instant('DISPLAYSCHEDULELIST.edited'));

        function convertDuration(seconds) {
            var days = Math.floor(seconds / (3600 * 24));
            seconds -= days * 3600 * 24;
            var hours = Math.floor(seconds / 3600);
            seconds -= hours * 3600;
            var minutes = Math.floor(seconds / 60);
            seconds -= minutes * 60;
            return ( days ? ( days + "<strong> " + $translate.instant("DISPLAYschedulesLIST." + (days > 1 ? "days" : "day" )) + "</strong> " ) : "" )
                + ( hours ? ( hours + "<strong> " + $translate.instant("DISPLAYschedulesLIST." + (hours > 1 ? "hours" : "hour" )) + "</strong> " ) : "" )
                + ( minutes ? ( minutes + "<strong> " + $translate.instant("DISPLAYschedulesLIST." + (minutes > 1 ? "minutes" : "minute" )) + "</strong> " ) : "" )
                + ( seconds ? ( seconds + "<strong> " + $translate.instant("DISPLAYschedulesLIST." + (seconds > 1 ? "seconds" : "second" )) + "</strong> " ) : "" )
        }


        /*DATABLE METHOD*/
        function searchschedulesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('programDisplay.list@get', filtre,
                function (response) {

                    if (response.code === 200) {
                        var records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data

                        };

                        vm.schedules = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else if (angular.isDefined(response.errors)) {
                        var records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.schedules = [];
                        vm.recordsTotal = 0;

                        var errors = response.errors;
                        errors.forEach(function (item) {

                            $translate('VALIDATION.' + item.messages[0]).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });


                        });
                        vm.fnCallback(records);
                    }
                    else {
                        var records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.schedules = [];
                        vm.recordsTotal = 0;

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.schedules = [];
                    vm.recordsTotal = 0;
                    vm.fnCallback(records);
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback, oSettings) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedschedules = [];
            vm.checkedSelected = false;
            vm.filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_Schedule,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            vm.filtre["columns[" + numColum + "][orderable]"] = true;

            vm.fnCallback = fnCallback;
            searchschedulesInAPI(vm.filtre);
        }


        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Toggle selected status of the user
         *
         * @param schedule
         */
        function toggle(schedule) {
            schedule.checked = !schedule.checked;
            var idx = selectedschedules.indexOf(schedule);
            if (idx > -1) {
                selectedschedules.splice(idx, 1);
            }
            else {
                selectedschedules.push(schedule);
            }
            vm.selectedschedules = angular.copy(selectedschedules);
        }

        function toggleAll() {
            getElement();
            if (selectedschedules.length === vm.schedules.length) {
                vm.selectedschedules = [];
            }
            else if ((selectedschedules.length === 0) || (selectedschedules.length > 0)) {
                vm.selectedschedules = vm.schedules.slice(0);
            }
            selectedschedules = angular.copy(vm.selectedschedules);
            var list_schedule = angular.copy(vm.schedulesDataTable);
            angular.forEach(list_schedule, function (value, key) {
                if (value !== undefined)
                    vm.schedulesDataTable[key].checked = selectedschedules.length > 0;
            });
        }

        /**
         * rerender datatable
         */
        function rerender() {
            vm.dtInstance.rerender();
        }

        /**
         * Show Schedule Details
         * @param Schedule
         */
        function StatusGrille(endAt, start_at) {
            var d = new Date();
            if (endAt !== null) {
                if (moment(endAt).isBefore(d) && moment(start_at).isBefore(d)) return -1;//achevé

                if (moment(endAt).isAfter(d) && moment(start_at).isBefore(d)) return 0;//en cours de diffusion

                if (moment(start_at).isAfter(d)) return 1;//à venir

            }


        }


        function StatusGrilleTest(startDate, endDate) {
            var currentDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ssZ");
            startDate = (moment(startDate).format("YYYY-MM-DD HH:mm:ssZ"));
            endDate = (moment(endDate).format("YYYY-MM-DD HH:mm:ssZ"));

            if ((currentDate >= startDate) && (currentDate <= endDate)) {
                //en cours de diffusion

                return 0;
            }
            else if (currentDate < startDate) {
                //à venir

                return 1;
            }
            else {
                //achevé
                return -1;
            }
        }


        function showSchedule(template, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            var urlFoDisplay = angular.isDefined(parameters.url_fo_display) ? parameters.url_fo_display : "";
            var cryptext = angular.isDefined(parameters.display_default_urls.video) ? parameters.display_default_urls.video.split("/")[3] : ""
            webTvGlobal.openNewWindow(urlFoDisplay + "/display/show-schedule/" + template.id + "/" + cryptext);
        }
/*
        function showEventFormDialog(type, calendarEvent, start, end, e) {
            var dialogData = {
                type: type,
                calendarEvent: calendarEvent,
                start: start,
                end: end
            };

            $mdDialog.show({
                controller: 'EventFormDialogController',
                controllerAs: 'vm',
                templateUrl: 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent: angular.element($document.body),
                targetEvent: e,
                clickOutsideToClose: true,
                locals: {
                    dialogData: dialogData
                }
            }).then(function (response) {
                switch (response.type) {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id: vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end: response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for (var i = 0; i < vm.events[0].length; i++) {
                            // Update
                            if (vm.events[0][i].id === response.calendarEvent.id) {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end: response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for (var j = 0; j < vm.events[0].length; j++) {
                            // Update
                            if (vm.events[0][j].id === response.calendarEvent.id) {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
*/
        /**
         * redirection to edit Schedule page
         * @param Schedule
         */
        function editSchedule(id) {

            vm.clearFlashMessage();
            $state.go('app.display_schedule_edit_new', {id: id});
        }

        /**
         * redirection to edit Schedule page
         * @param Schedule
         */
        function reloadSchedule(Schedule) {

            msApi.request('programDisplay.reloadSchedule@get',
                {id: Schedule.id},
                function (res) {
                    if (res.code === 200)
                        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.success_reload'));

                }, function (response) {
                }
            );
        }


        /**
         * redirection to add new Schedule page
         */
        function addNewSchedule() {
            vm.clearFlashMessage();
            $state.go('app.display_schedules_add_new');
        }

        function showCalendar() {
            $rootScope.currentState = $state.current.name;
            $state.go('app.display_schedule_calendar_new');

        }

        /**
         * Search Schedule
         */
        function searchSchedule() {
            vm.filtre["search[value]"] = vm.search_Schedule;
            searchschedulesInAPI(vm.filtre);
        }


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple((vm.flashMessages.title ? ("\"" + vm.flashMessages.title + "\" ") : "Scheduleme ") + message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!vm.flashMessages.title) vm.flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (vm.flashMessages.title) {
                vm.flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }


        /**
         * Delete Schedule Confirm Dialog
         */
        function deleteScheduleConfirm(schedule, ev) {
            var confirm = $mdDialog.confirm()
                .title($translate.instant('DISPLAYSCHEDULELIST.delete_schedule_message'))
                .htmlContent('<b>' + schedule.title + '</b>' + $translate.instant('MESSAGES.dialog_will_be_deleted'))
                .ariaLabel($translate.instant('DISPLAYSCHEDULELIST.delete_schedule_label'))
                .targetEvent(ev)
                .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
                .cancel($translate.instant('MESSAGES.dialog_cancel'));

            $mdDialog.show(confirm).then(function () {
                deleteSchedule(schedule);
            }, function () {
            });
        }

        /**
         * Delete Schedule
         */
        function deleteSchedule(schedule) {

            if (vm.schedules.indexOf(schedule) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('programDisplay.delete@delete', {id: schedule.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            webTvGlobal.$toast().showSimple(schedule.title + $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_description'));
                            vm.rerender();

                        }
                        else {
                            var alert = $mdDialog.alert({
                                title: $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_error_title'),
                                textContent: $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_error_description'),
                                ok: $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_close')
                            });

                            $mdDialog
                                .show(alert)
                                .finally(function () {
                                    alert = undefined;
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                        $rootScope.loadingProgress = false;
                    }
                );

            }


        }


        /**
         * Delete selected schedules Confirm Dialog
         */
        function deleteSelectedschedulesConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedschedules.length!== 0) {
                if(vm.selectedschedules.length === 1){
                    title = 'DISPLAYSCHEDULELIST.delete_schedule_message';
                    ariaLabel = 'DISPLAYSCHEDULELIST.delete_schedule_label';
                }else{
                    title = 'DISPLAYSCHEDULELIST.delete_list_schedule_message';
                    ariaLabel = 'DISPLAYSCHEDULELIST.delete_schedules_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedschedules.length,title,ariaLabel)).then(function () {
                    deleteSelectedschedules(ev);
                });

            }

        }
        /**
         * Delete Selected Porgrams
         */
        function deleteSelectedschedules(ev) {
            if (vm.selectedschedules.length === 0) return;
            $rootScope.loadingProgress = true;
            msApi.request('programDisplay.deleteByList@delete', {
                    list: (function (list) {
                        selectedschedules.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("DISPLAYSCHEDULELIST.undeleted_are", {'list': response.result.undeleted.join(" ")})
                        }
                        deleted = $translate.instant("DISPLAYSCHEDULELIST.deleted_are", {'list': response.result.deleted.join(" ")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedschedules = [];
                        vm.rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_error_title'),
                            $translate.instant('DISPLAYSCHEDULELIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedschedules = [];

                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }


                    selectedschedules = [];
                    vm.modelCheckAll = false;

                }
            );

        }


    }
})();
(function() {
  'use strict';

  angular
    .module('app.display_new.schedule')
    .controller('programDetailsModalController', programDetailsModalController);

  /** @ngInject */
  function programDetailsModalController(programData, $mdDialog, $rootScope) {
    var vm = this;
    vm.screenshot = programData.template
      ? programData.template.screenShot
      : programData.program.screenShot;

    vm.periodLoop = programData.periodLoop;
    vm.startDate = moment(programData.startDetail).local()
      .toDate();
    vm.endDate = moment(programData.endDetail).local()
      .toDate();

    if (programData.periodEnd) {
      vm.repeatEndDate = moment(programData.periodEnd)
        .local()
        .toDate();
    }

    vm.program = programData;

    vm.cancel = cancel;
    vm.save = save;
    vm.remove = remove;
    vm.isFormValid = isFormValid;
    vm.errorMessage = '';
    function cancel() {
      $mdDialog.hide();
    }

    function save() {
      if (!vm.isFormValid()) {
        return;
      }
      var start = Object.assign({},vm.startDate);
      var end = Object.assign({},vm.endDate);
      vm.program.startDetail = vm.startDate;
      vm.program.endDetail = vm.endDate;
      vm.program.start = moment(vm.startDate).subtract(moment(vm.startDate).utcOffset(), "minutes");
      vm.program.end = moment(vm.endDate).subtract(moment(vm.endDate).utcOffset(), "minutes");
      vm.program.periodEnd = moment(vm.repeatEndDate);

      if (vm.periodLoop) {
        vm.program.periodLoop = vm.periodLoop;
        vm.program.loop = 1;
      } else {
        vm.program.loop = 0;
        vm.program.periodLoop = '';
      }
      if(vm.program.isNew){
        $rootScope.$broadcast('programUpdated', vm.program);
      }else{
        $rootScope.$broadcast('programUpdatedEditSchedule', vm.program);
      }
      this.cancel();
    }
    function remove() {
      if(vm.program.isNew){
        $rootScope.$broadcast('programRemoved', programData);
      }else{
        $rootScope.$broadcast('programRemovedEditSchedule', programData);
      }

      this.cancel();
    }

    function isFormValid() {
      if (new Date(vm.startDate).getTime() >= new Date(vm.endDate).getTime()) {
        vm.errorMessage = 'la date de fin doit etre superieure a la date de debut';
        return false;
      }
      if (vm.periodLoop && new Date(vm.repeatEndDate).getTime() < new Date().getTime()) {
        vm.errorMessage = "la date de repetititon doit etre superieure a la date d'aujourdhui";
        return false;
      }
      vm.errorMessage = '';
      return true;
    }
  }
})();

(function() {
  'use strict';

  angular.module('app.display_new.schedule.edit', ['ui.calendar', 'ui.sortable']).config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.display_schedule_edit_new', {
      url: '/displayNew/schedule/edit/:id',
      views: {
        'content@app': {
          templateUrl: 'app/main/displayNew/schedule/edit/edit.html',
          controller: 'displayNewScheduleEditController as vm',
        },
      },
      resolve: {
        templatesData: function(msApi, $stateParams) {
          return msApi.resolve('programDisplay.tenTemplates@get',  {page: $stateParams.id });
        },
        scheduleData: function(msApi, $stateParams) {
          var start = moment()
            .add(-31, 'days')
            .format('YYYY-MM-DD');
          var end = moment()
            .add(31, 'days')
            .format('YYYY-MM-DD');
          return msApi.resolve('programDisplay.getOne@get', {
            id: $stateParams.id,
            start: start,
            end: end,
          });
        },
      },
      actionPermission: 'display_schedule_post_edit_action',
    });

    msApiProvider.register('programDisplay.tenTemplates', [
      Routing.generate('api_templateDisplay_get_ten_templates', { page: ':page' }).replace(
        /%3A/,
        ':'
      ),
    ]);
    msApiProvider.register('programDisplay.getOne', [
      Routing.generate('api_programDisplay_get_one_program', { id: ':id' }).replace(/%3A/, ':'),
      { id: '@id' },
    ]);
    msApiProvider.register('programDisplay.edit', [
      Routing.generate('api_programDisplay_post_add', { id: ':id' }).replace(/%3A/, ':'),
      { id: '@id' },
    ]);
    msApiProvider.register('programs.list_data_table', [
      Routing.generate('api_dtable_list_dtable_programs'),
    ]);

    $translatePartialLoaderProvider.addPart('app/main/displayNew/schedule/edit');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.display_new.schedule.edit')
    .controller('displayNewScheduleEditController', displayNewScheduleEditController);

  /** @ngInject */
  function displayNewScheduleEditController(
    $mdSidenav,
    webTvGlobal,
    msApi,
    $translate,
    $state,
    $rootScope,
    $mdDialog,
    $cookies,
    msUtils,
    templatesData,
    scheduleData,
    $scope
  ) {
    var vm = this;
    vm.listDate = [];

    vm.alert = function (event) {
      var parentEl = angular.element(document.body);
      var screenshot =
        event.screenShot ||
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAoAAAAFoCAMAAADw7LpjAAAAP1BMVEXq7OzAwcPt7+6+wMHe3+DFx8jg4uPp6url5+fc3t7KzM3Nz9DW2NnT1dbCxMbj5eXMzc/IycvQ0tPZ29zn6erbzWZrAAAG8klEQVR4Ae3d25LaMLaAYXkJMAewMfj9n3UHOuodYhBMOPRUzfddu3L1lxVZi1b6rwIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEZHgx+Ib+8WYPgril5TGxXG3H7q8ivQZECdp7GfbzdA1+ZcmbyPBh1bc5Wx7WM+7c3pf8iHB+197y9lxt583ubRX5CHBm3yl1692m6Err72/dWOCt6TXnlfc8tq7ZRHpZSBO2q8V9/dGo+4Y6VXQXjv2q91+mDelvHvyLtIrYMXtV/dW3OLPbfAmEjz32usXq93msRU3n3TD+jCUbXCb4N/SS+cV9/ur8v32mq5bH7azfozY5eas6yP9JyBOvlbc7qEV96wbNrtVP6Y4SXHMzVn+D7fBeO31i+Nh/bXiNg+99ub7w3GxbP+cfolZeeAYiccZIdgMXX54o3FacVd9GyfpT9HPs20wj4iT0wjBYegeeu39ueK2k/SK4XeA+0g1GCFYfI8Q5AdX3N1x0d9Ir4j97wDnbYKJ+OVrxX3880r+veKm0l5F2QbnK9tgGGfbixGCmv9fcZfltXdfrHLzZRbpEsQxP/jaa7puvzvOykbjYdHf3AZDLO6nl5t5dcWti+X85mkwjF19ozHs6yvufe26bIMTTKzzjU9789OKu0xxkp4Qh9yczdtIf4FDnrQ3X2+2q+VYVtwnxbacBi8jwfU8yqe9zXa1KK+914hVYxvM/a8kw2E7W5azuBeKvmvO/DSTeh4R6R3aLjcn+SBAJsb52/Mo2+B1gpt5DOlNyjY4z8dIMM3jrGvfd9piKJr7X0kuR5bHw+ZFDkNuvqwPmyv69D+MmJU8VnFxgtbll2l+y1edv85gG7y7DHCem7fzeZD43gZvkgB/AJuyDW5DgB9H7CZntQL8GCa/3BXgRxGzsgs5Xg8wv4kAT4jlxVntJMD5+j0GAXL5y931tQDzLrXvkFYCPCPKNnjexrUA400rvwAvOIzLXS/AH2QmNa8E+EFMfrm7vR1gvJIAKS5aO6SbAa62r3NsBcjVkeX2ZoDr/DrdMgR4jZnU8WaA+9y8Sp4L8Do/zexDgJ/G9M/o3g8w/yLA9zGTWg3wfAHD0GUB8hJtiW3/UIB5OC5TavttlwXIK+y/Z1IfCDAf2ojTI9EPWYDPY/pndCsB5kN8PzQOWYAvZSa1EuB0cj8WTRbgi9kGVwIsjxSxEeCzmNRWCTB343SQQYCvZSa1EuAwGWSoyTkLsI7pbTK1ANeTT4gVedgNOQuQO6aXqj76BlzkWn9dH+1qnQXI47fJ3NmEdP1k/3xL7han0tp9FuDjzKRWAyxPFOt89xe/MQ5ZgDXEOC9fmasBlnyKWDW35WOUvLsswBray5nU6knIeozS36Kr9LeNNH1OgHVmUpdx9yx46OMsrSrTCHkXMf0/pgCpz6TmPu5Pw3SHVb/sj/um0t9h8u8LkPu3yeRVLcAi527e5doGeHPrQ48Aqc+k1gMscm4q8rqNdCHSJguQ+7fJbO4GeF8exphutNdZgDx0XcgTAZbCKhMPAqR2m0wfTwaYuz5uLPNZgNyZSW1mTwaYu0VUxw4FSH0m9akAc7OK25ULkPvb4GcCzM0x6lM31wKE9nsmNT0V4DZSzSELkPpM6j8HWJ6uiHadBcidmdR/DjAf0h2xHARIdSZ19c8B5k2KB/6z2QmQykzqrh7g/QO4upjN+78DhBi7soxWArx/AHdfLLwBqW2D28eGEXJTXJyh3Hftb0TD4eKoth5g7laLIdcP4CoESGUmdXEvwJw3fUS6+PNs3SKSAHnVdSH1iehjivO+ZZPz9ABOgDx/GHcjwPL6S2eRVuWpY6SnAoSxxLSpBZi7Y0QqYjw0uRzAPRMgRNkGD7d3wTlvLodNI2ZDPj8jQF40k9r1cTXA8vq7FO3u4K44XnldyOxagOV/fxMR6fkAIWa5zKReDbBsfqcEyEu3wYd0JcC87+N917VCjN+HcdMA1+X197YAoXxrmY9/B9ge+3BhNR+aSW36mF5YnT4XIH6a+fEr+yEWZReyjegFyI/NpK6Ph6FrPhwgDHlyv8fnAoRNbr59OkCI7Q8GCLESID+/DRYgP3hr5jTA95gGCOv899+AzpvVe+wEyLWZ1HzWDV3zISVAiG3uumG/Wy2W/Tx/OkDoj4sxxcnyBwKEiHT2owGCAPkfDBAEiAChXXzKmKYgPiUBAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAP8Hm8VqRqr30KcAAAAASUVORK5CYII';

      $mdDialog.show({
        controllerAs: 'modalCtrl',
        parent: parentEl,
        targetEvent: event,
        template:
          '<md-dialog  class="_md md-delete-theme md-transition-in delete-program-modal" >' +
          '<md-dialog-content class="md-dialog-content">' +
          '<h2 class="md-title" style="border-color: ' +
          event.color +
          ';">' +
          event.title +
          '</h2>' +
          '<div class="md-dialog-content-body">' +
          '<img src="' +
          screenshot +
          '"> ' +
          '</div>' +
          '</md-dialog-content>' +
          '<md-dialog-actions>' +
          '<button class="md-primary md-cancel-button md-button ng-scope md-delete-theme md-ink-ripple md-icon-button close-btn" type="button" ng-click="modalCtrl.hide()">' +
          '<span class="ng-binding ng-scope"></span></button>' +
          '</md-dialog-actions>' +
          '</md-dialog>',
        clickOutsideToClose: true,
        bindToController: true,
        controller: function ($mdDialog) {
          var vm = this;
          vm.hide = function hide() {
            $mdDialog.hide();
          };
        },
      });
    };

    initHelp();
    vm.type = 'month';

    vm.pageChanged = pageChanged;
    vm.totalPrograms = 0;
    vm.initialCalender = initialCalender;
    vm.slot = parseInt($cookies.get('slotSchedule')) || 1;
    vm.click = click;
    vm.changeSlot = changeSlot;

    function convertMinsToHrsMins(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m + ':' + '00';
    }

    var slot = convertMinsToHrsMins(vm.slot);

    function changeSlot() {
      //vm.slot = vm.screenForm.dateStart.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.slot).format('YYYY-MM-DD'));
      if (angular.isDefined(vm.slot) && vm.slot !== 0) {
        vm.calendarUiConfig.calendar.slotDuration = convertMinsToHrsMins(vm.slot);
        vm.calendarUiConfig.calendar.defaultView = vm.type;
        vm.langChanged = 1;
        vm.calendarUiConfig.calendar.defaultDate = vm.calendar.getDate();
      }
    }

    function click(type) {
      vm.type = type;
    }

    function initialCalender() {
      vm.calendarUiConfig = {
        calendar: {
          editable: true,
          droppable: true,
          slotDuration: slot,
          header: '',
          height: 700,
          lang: $translate.preferredLanguage(),
          viewRender: function (view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
          },
          drop: dropExternal,
          eventDrop: dropInternal,
          eventClick: clickEvent,
          events: function (start, end, timezone, pushIntoCalendarEvents) {
            if (vm.langChanged) {
              vm.langChanged = 0;
              if (vm.events) {
                pushIntoCalendarEvents(vm.events);
              }
            }
          },
        },
      };
    }

    function initHelp() {
      $rootScope.titre1 = 'PAGESMENUSTITLES.display_menuTitle';
      $rootScope.titre2 = 'PAGESMENUSTITLES.display_schedule_menuTitle';
      $rootScope.titre3 = 'PAGESMENUSTITLES.display_schedule_edit_menuTitle';
      $rootScope.pageRoute = 'app.display_schedule_list_new';

      $rootScope.welcome = 'welcome_schedule_edit';
      $rootScope.text = [
        {
          texte: 'schedule_add_help',
        },
        {texte: 'schedule_associate_help'},
        {
          texte: 'send_button_schedule_edit_help',
        },
      ];
    }

    vm.empScheduleError = [];
    vm.dragOptions = {};
    vm.today = moment();

    vm.programs = angular.copy(templatesData.data.templates);
    vm.totalPrograms = angular.copy(templatesData.data.count);
    vm.programsss = [];
    vm.programColors = [];

    vm.programColors = vm.programs.map(function (p) {
      p.color = materialColor();
      return p;
    });

    vm.programs.forEach(function (value) {
      vm.programsss.push(value.title);
    });

    vm.pagination = {
      current: 1,
    };

    function pageChanged(newPage) {
      getResultsPage(newPage);
    }

    function getResultsPage(pageNumber) {
      msApi.request(
        'programDisplay.tenTemplates@get',
        {page: pageNumber, searchWord: vm.templateName},
        //SUCCESS
        function (response) {
          vm.prog = [];
          vm.programs = angular.copy(response.data.templates);
          vm.programs.forEach(function (value) {
            vm.prog.push(value.title);
          });
          vm.programsss = vm.prog;

          vm.programColors = vm.programs.map(function (p) {
            p.color = materialColor();
            return p;
          });
        },
        // ERROR
        function (response) {
        }
      );
    }

    vm.searchTenTemplates = searchTenTemplates;

    function searchTenTemplates() {
      msApi.request(
        'programDisplay.tenTemplates@get',
        {page: 1, searchWord: vm.templateName},
        //SUCCESS
        function (response) {
          vm.prog = [];
          vm.programs = angular.copy(response.data.templates);
          vm.programs.forEach(function (value) {
            vm.prog.push(value.title);
          });
          vm.programsss = vm.prog;
          vm.totalPrograms = angular.copy(response.data.count);
          vm.programColors = vm.programs.map(function (p) {
            p.color = materialColor();
            return p;
          });
        },
        // ERROR
        function (response) {
        }
      );
    }

    vm.events = vm.events || [];
    vm.expanded = {
      form: true,
      calendar: true,
    };
    vm.langChanged = 0;

    var date = new Date();
    var d = date.getDate();
    var m = date.getMonth();
    var y = date.getFullYear();

    vm.updateSchedule = updateSchedule;
    vm.toggleSidenav = toggleSidenav;
    vm.fillData = fillData;

    vm.calendarUiConfig = {
      calendar: {
        editable: true,
        defaultView: vm.type,
        droppable: true,
        slotDuration: convertMinsToHrsMins(vm.slot),
        header: '',
        height: 700,
        columnFormat: {
          month: 'dddd',
          week: 'ddd D',
          day: 'ddd M',
        },
        lang: $translate.preferredLanguage(),
        viewRender: function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        drop: dropExternal,
        eventRender: function (event, element) {
          var overlayEl = element[0].querySelector('.fc-time');

          if (!overlayEl) {
            var span = document.createElement('span');
            span.className = 'fc-time';
            element[0].querySelector('.fc-content').appendChild(span);
            overlayEl = element[0].querySelector('.fc-time');
          }

          element.find('.fc-time').html('');
          element.find('.fc-time').append(' ' + moment(event.start).format('HH:mm:ss'));

          element.css('color', event.template.color);
          element.css('border-color', event.template.color);
          overlayEl.style.backgroundColor = event.template.color;
        },
        eventDrop: dropInternal,
        eventClick: clickEvent,
        events: function (start, end, timezone, pushIntoCalendarEvents) {

          var startAT = "start=" + moment(start).format('YYYY-MM-DD') + "end=" + moment(end).format('YYYY-MM-DD')
          if (vm.listDate.indexOf(startAT) === -1) {
            vm.listDate.push(startAT);
            msApi.request(
              'programDisplay.getOne@get',
              {
                id: scheduleData.id,
                start: moment(start).format('YYYY-MM-DD'),
                end: moment(end)
                  .format('YYYY-MM-DD'),
              },
              function (res) {
                vm.fillData(res);
                if (vm.langChanged) {
                  vm.langChanged = 0;
                  if (vm.events) {
                    pushIntoCalendarEvents(vm.events);
                  }
                }
              }
            );
          }

        },
        eventAfterRender: function (event, element, view) {
          var overlayEl = element[0].querySelector('.fc-time');
          element.css('color', event.template.color);
          element.css('border-color', event.template.color);
          overlayEl.style.backgroundColor = event.template.color;
        },
      },
    };

    vm.setCalendarConfigLanguage = setCalendarConfigLanguage;
    $rootScope.setCalendarConfigLanguage = setCalendarConfigLanguage;

    function setCalendarConfigLanguage(lang) {
      vm.calendarUiConfig.calendar.lang = lang;
      vm.langChanged = 1;
    }

    function searchProgramParent(program) {
      var result = vm.events.filter(function (event) {
        return event.id == program.id && event.isParent
      });
      return result.length > 0 ? result[0] : program;
    }

    function repeatingEvent(program, period,diff,hourStart,endP) {
      var programParent = searchProgramParent(program);
      var startT = new Date(programParent.start);
      if(diff || diff==0){
        startT = new Date(startT.getTime() + diff);
        startT.setHours(hourStart);
      }
      var endProgram = new Date(program.end);
      if(endP)
      {
        endProgram = new Date(endP);
      }

      var realEnd = new Date(program.periodEnd);
      vm.newEvents = [];
      vm.events = vm.events.filter(function(value, index, arr){
        return value.id !== program.id;
      });
      var i = 0;
      for (var start = startT; start <= realEnd; start.setDate(start.getDate() + period)) {
        var end = new Date(start);
        end.setHours(endProgram.getHours());
        end.setMinutes(endProgram.getMinutes());
        var eventP = angular.copy(program);
        var event = eventP;
        if(hourStart){
          event.start = moment(start);
          event.startDetail = new Date(start);
          event.end = moment(end);
          event.endDetail = new Date(end);
        }else{
          event.start = moment(start).add(moment(start).utcOffset(), "minutes");
          event.startDetail = new Date(start);
          event.end = moment(end).add(moment(end).utcOffset(), "minutes");
          event.endDetail = new Date(end);
        }

        event.orStart = angular.copy(event.start);
        event.orEnd = angular.copy(event.end);
        event.index = vm.events.length;
        event.indexProgramm = i;
        event.isParent = false;
        if (i === 0) {
          event.isParent = true;
        }
        i++;
        vm.newEvents.push(event);
        vm.events.push(event);
      }
      vm.calendar.removeEvents(program.id);
      vm.calendar.addEventSource(vm.newEvents);

    }

    function fillData(scheduleData) {
      vm.langChanged = 1;
      vm.id = scheduleData.id;
      vm.schedule = scheduleData;
      vm.schedule = {
        title: scheduleData.title,
        enable: scheduleData.enable,
        description: scheduleData.description,
        startAt: scheduleData.startAt,
        schedulePrograms: scheduleData.schedulePrograms,
        rmbox: scheduleData.rmbox,
        rmboxgroup: scheduleData.rmboxgroup
      };

      var templates = vm.schedule.schedulePrograms;

      angular.forEach(templates, function (value, key) {
        value.template.color = materialColor();
        var result = vm.events.filter(function(e) {
          return e.id === value.id  });
        const color = materialColor();
        var event = {};
        var startAT = angular.copy(value.startAt);
        var endAT = angular.copy(value.endAt);
        var listEventsCurrent = vm.events.filter(function(e) {
          var unixStart = moment(startAT).add(moment(startAT).utcOffset(), "minutes").format('x');
          var unixEnd = moment(endAT).add(moment(endAT).utcOffset(), "minutes").format('x');
          return e.id === value.id && e.unixStart ===  unixStart &&  e.unixEnd === unixEnd });

        if(listEventsCurrent.length === 0){
          event.id = value.id;
          event.indexProgramm = result.length;
          event.idProgram = value.id;
          event.editable = true;
          event.durationEditable = true;
          event.overlap = true;
          event.color = color;
          event.borderColor = color;
          event.title = value.template.title;
          event.start = moment(startAT).add(moment(startAT).utcOffset(), "minutes");
          event.end = moment(endAT).add(moment(endAT).utcOffset(), "minutes");
          event.orStart = angular.copy(event.start);
          event.orEnd = angular.copy(event.end);
          event.unixStart = event.start.format('x');
          event.unixEnd = event.end.format('x');
          event.allDay = false;
          event.startEditable = true;
          //event.className = "_event" + event.id + " " + "md-primary-bg";
          event.content = '';
          event.index = key;
          event.template = value.template;

          event.periodLoop = value.periodLoop;
          event.periodStart = value.periodStart;
          event.periodEnd = value.periodEnd;
          event.startDetail = angular.copy(moment(value.startAt));
          event.endDetail = angular.copy(moment(value.endAt));
          vm.events.push(event);
        }

      });
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function clickEvent(event, e) {
      event.template.screenShot =
        event.template.screenShot ||
        'data:image/png;base64,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';

      if (!!!event.startDetail)
        event.startDetail = Object.assign({}, event.start.subtract(moment(event.start).utcOffset(), "minutes"));
      if (!!!event.endDetail){
        if(event.end)
          event.endDetail = Object.assign({}, event.end.subtract(moment(event.end).utcOffset(), "minutes"));
        else
          event.endDetail = Object.assign({}, event.orEnd.subtract(moment(event.orEnd).utcOffset(), "minutes"));

      }

      $mdDialog.show({
        locals: {programData: event},
        templateUrl: 'app/main/displayNew/schedule/details-modal/details-modal.html',
        clickOutsideToClose: true,
        controller: 'programDetailsModalController',
        controllerAs: 'vm',
      });
    }

    $rootScope.$on('programUpdatedEditSchedule', function (event, obj) {
      $scope.programForm.$pristine = false;
      var isRepating = true;
      vm.events = vm.events.map(function (e) {
        if (e.id === obj.id && isRepating) {
          obj.start = obj.start.add(obj.start.utcOffset(), "minutes");
          obj.end = obj.end.add(obj.end.utcOffset(), "minutes");
          if (obj.periodLoop) {
            isRepating = false;
            switch (obj.periodLoop) {
              case 'day':
                repeatingEvent(obj, 1);
                break;
              case 'week':
                repeatingEvent(obj, 7);
                break;
              case 'month':
                repeatingEvent(obj, 7);
                break;
              case 'year':
                repeatingEvent(obj, '1y');
                break;
              default:

            }
          }
          return obj;
        }
        return e;
      });
      vm.calendar.updateEvent(obj, true);
      if ($scope.programForm) {
        $scope.programForm.$pristine = false;
      }
    });

    $rootScope.$on('programRemovedEditSchedule', function (event, obj) {
      for (var i = 0; i < vm.events.length; i++) {
        if (vm.events[i].id === obj.id) {
          vm.events.splice(i, 1);
          break;
        }
      }
      vm.calendar.removeEvents(obj.id);
      $scope.programForm.$pristine = false;
    });
    function searchProgramByIndex(program) {
      var result = vm.events.filter(function(event) {
        return event.id == program.id && event.indexProgramm === program.indexProgramm });
      return result.length > 0 ? result[0] : program;
    }

    function dropInternal(event, delta, revertFunc) {
      $scope.programForm.$pristine = false;
      if (event.periodLoop) {
        var originProgram = searchProgramByIndex(event);
        var diff = event.start.diff(originProgram.start.add(originProgram.start.utcOffset(), "minutes"));
        try{
          var hours = new Date(originProgram.startDetail).getHours();
          var end = originProgram.endDetail;
        }catch(e){
          var hours = originProgram.startDetail.getHours();
          var end = originProgram.endDetail;
        }

        //event.start = obj.start.add(obj.start.utcOffset(), "minutes");
        //event.end = obj.end.add(obj.end.utcOffset(), "minutes");
        switch (event.periodLoop) {
          case 'day':
            repeatingEvent(event, 1,diff,hours,end);
            break;
          case 'week':
            repeatingEvent(event, 7,diff,hours,end);
            break;
          case 'month':
            repeatingEvent(event, 30,diff,hours,end);
            break;
          case 'year':
            repeatingEvent(event, 360,diff,hours,end);
            break;
          default:

        }
        revertFunc();
        return;

      } else {
        $scope.programForm.$pristine = false;
        if (
          timeSlotIsOccupied(moment(event.start).format('x'), moment(event.end).format('x'), event.id)
        ) {
          var list_event = filterSlotIsOccupied(moment(event.start).format('x'));
          if (list_event.length > 0) {
            var index_of_max = indexOfMax(list_event);
            var event_by_index = list_event[index_of_max];
            var new_start = parseInt(moment(event_by_index.end).format('x')) + 1000;
            var new_end = event.end - event.start + new_start;
            event.start = moment(new_start);
            event.end = moment(new_end);
          } else {
            webTvGlobal.alertDialog($translate.instant('DISPLAYSCHEDULEEDIT.time_slot_occupied'));
            revertFunc();
            return;
          }
        }

        var template = event.template;
        var eventN = {template: {}};
        for (var prop in template) {
          eventN.template[prop] = template[prop];
        }

        var end = new Date(event.end);
        end.setHours(end.getHours() - 1);
        var start = new Date(event.start);
        start.setHours(start.getHours() - 1);

        eventN.id = msUtils.guidGenerator();
        eventN.editable = true;
        eventN.durationEditable = true;
        eventN.overlap = true;
        eventN.title = template.title;
        eventN.start = start;
        eventN.end = end;
        eventN.orStart = angular.copy(eventN.start);
        eventN.orEnd = angular.copy(eventN.end);
        eventN.unixStart = moment(eventN.start).format('x');
        eventN.unixEnd = moment(eventN.end).format('x');
        eventN.allDay = false;
        eventN.startEditable = true;
        //event.className = "_event" + event.id + " " + "md-primary-bg";
        eventN.content = '';
        eventN.index = vm.events.length - 1;

        /*****/
        for (var i = 0; i < vm.events.length; i++) {
          if (vm.events[i].id === event.id) {
            vm.events.splice(i, 1);
            break;
          }
        }

        vm.calendar.removeEvents(event.id);
        /*******/

        vm.events.push(eventN);
        vm.calendar.renderEvent(eventN, true);
      }
    }

    function dropExternal(eventDate, allDay) {

      $scope.programForm.$pristine = false;
      var programs_list = angular.copy(vm.programColors);
      var template = programs_list[angular.element(this).data('index')];
      var start = eventDate;
      var durationTemplate = template.options.duration ? template.options.duration : 0;
      var end = moment(new Date(eventDate)).add(durationTemplate, 'seconds');
      if (timeSlotIsOccupied(moment(start).format('x'), moment(end).format('x'), 0)) {
        var list_event = filterSlotIsOccupied(moment(start).format('x'));
        if (list_event.length > 0) {
          var index_of_max = indexOfMax(list_event);
          var event_by_index = list_event[index_of_max];
          var new_start = parseInt(moment(event_by_index.end).format('x')) + 1000;
          var new_end = end - start + new_start;
          start = new_start;
          end = new_end;
        } else {
          webTvGlobal.alertDialog($translate.instant('DISPLAYSCHEDULEEDIT.time_slot_occupied'));
          return;
        }
      }
      var start = new Date(start).toGMTString();
      var end = new Date(end).toGMTString();
      var event = {template: {}};
      for (var prop in template) {
        event.template[prop] = template[prop];
      }
      event.id = msUtils.guidGenerator();
      event.editable = true;
      event.durationEditable = true;
      event.overlap = true;
      event.title = template.title;
      event.start = moment(start);
      event.end = moment(end);
      event.orStart = angular.copy(event.start);
      event.orEnd = angular.copy(event.end);
      // event.unixStart = start.format('x');
      // event.unixEnd = end.format('x');
      event.allDay = false;
      event.startEditable = true;
      //event.className = "_event" + event.id + " " + "md-primary-bg";
      event.content = '';
      event.index = vm.events.length;

      vm.events.push(event);
      vm.calendar.renderEvent(event, true);
    }

    function updateSchedule(click, zone) {
      if (click === undefined) {
        click = true;
      }
      var events = angular.copy(vm.events);
      vm.schedule.schedulePrograms = [];
      events.sort(orderEvents);
      events.forEach(function (event, index) {
        if (index === 0) {
          vm.schedule.startAt = new Date(event.start);
        }
        var program = {
          templateOrder: index,
          template: event.template.id,
        };
        if (zone === -1) {
          program.startAt = event.start;
          program.endAt = event.end;
        } else {
          program.startAt = new Date(event.start);
          program.endAt = new Date(event.end);
        }
        if (event.periodLoop) {

          if(event.indexProgramm == 0)
          {
            program.periodLoop = event.periodLoop;
            program.periodEnd = event.periodEnd;
            program.loop = 1;
            vm.schedule.schedulePrograms.push(program);
          }
        }else{
          vm.schedule.schedulePrograms.push(program);
        }

      });
      msApi.request(
        'programDisplay.edit@save',
        {id: vm.id, data: angular.copy(vm.schedule)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal
              .$flashMessages()
              .set('displayGroupAdd', {title: vm.schedule.title ? vm.schedule.title : ''});
            if (click) {
              $state.go('app.display_schedule_list_new');
            }
          } else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            var empScheduleError = [];
            errors.forEach(function (item) {
              empScheduleError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.schedule[item.for]),
              };
            });
            vm.empScheduleError = empScheduleError;
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(
              function (message) {
                webTvGlobal.alertDialog(message);
              },
              function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              }
            );
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }

    function indexOfMax(events) {
      if (events.length === 0) {
        return -1;
      }

      var max = parseInt(moment(events[0]['end']).format('x'));
      var maxIndex = 0;

      for (var i = 1; i < events.length; i++) {
        if (parseInt(moment(events[i]['end']).format('x')) > max) {
          maxIndex = i;
          max = parseInt(moment(events[i]['end']).format('x'));
        }
      }

      return maxIndex;
    }

    function isSameDay(event, start) {
      var date_end = new Date(parseInt(moment(event.end).format('x')));
      var date_start = new Date(parseInt(start));
      var is_same_day = date_end.getDate() === date_start.getDate();
      return parseInt(start) - parseInt(moment(event.end).format('x')) < 86399 && is_same_day;
    }

    function filterSlotIsOccupied(start) {
      const result = vm.events.filter(function (event) {
        return isSameDay(event, start);
      });

      return result;
    }

    function timeSlotIsOccupied(start, end, id) {
      var intStart = parseInt(start);
      var intEnd = parseInt(end);

      for (var i = vm.events.length - 1; i >= 0; i--) {
        if (
          id !== vm.events[i].id &&
          ((intStart >= parseInt(moment(vm.events[i].start).format('x')) &&
            intStart <= parseInt(moment(vm.events[i].end).format('x'))) ||
            (intEnd >= parseInt(moment(vm.events[i].start).format('x')) &&
              intEnd <= parseInt(moment(vm.events[i].end).format('x'))))
        )
          return true;

        if (
          id !== vm.events[i].id &&
          (intStart <= parseInt(moment(vm.events[i].start).format('x')) &&
            intEnd >= parseInt(moment(vm.events[i].end).format('x')))
        )
          return true;
      }

      return false;
    }

    function orderEvents(a, b) {
      if (a.unixStart < b.unixStart) return -1;
      if (a.unixStart > b.unixStart) return 1;
      return 0;
    }

    vm.attributeFrom = '';
    vm.attributeRmbox = attributeRmbox;

    /**
     * Attribute rmbox to schedule
     */
    function attributeRmbox(schedule, ev) {
      var hide = false;
      msApi.request('configuration_rmbox.listRmboxAndRmboxGroup@get', function (res) {
        $mdDialog
          .show({
            controller: function (entity, rmboxs, rmboxgroups, $mdDialog) {
              var vm = this;
              vm.schedule = entity;
              if (vm.schedule.rmbox.length > 0) {
                vm.attributeFrom = 'rmbox';
              } else if (vm.schedule.rmboxgroup.length > 0) {
                vm.attributeFrom = 'rmboxgroup';
              }
              vm.rmboxs = webTvGlobal.convertToSelectChoicesFormat(rmboxs);
              vm.rmboxgroups = webTvGlobal.convertToSelectChoicesFormat(rmboxgroups);
              vm.validate = validate;

              function validate() {
                var param = [];
                param['rmbox'] = vm.attributeFrom === 'rmbox' ? vm.schedule.rmbox : [];
                param['rmboxgroup'] =
                  vm.attributeFrom === 'rmboxgroup' ? vm.schedule.rmboxgroup : [];
                $mdDialog.hide(param);
              }

              vm.closeDialog = closeDialog;

              function closeDialog() {
                $mdDialog.hide();
                hide = true;
              }
            },
            controllerAs: 'vm',
            templateUrl: 'app/main/displayNew/schedule/add/associate.rmbox.modale.template.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              entity: schedule,
              rmboxs: res.data.rmboxs,
              rmboxgroups: res.data.rmboxGroups,
            },
          })
          .then(function (param) {
            if (!hide) {
              vm.schedule.rmbox = param['rmbox'];
              vm.schedule.rmboxgroup = param['rmboxgroup'];
            }
          });
      });
    }

    function materialColor() {
      // colors from https://github.com/egoist/color-lib/blob/master/color.json
      var colors = [
        '#1abc9c',
        '#16a085',
        '#2ecc71',
        '#27ae60',
        '#4caf50',
        '#8bc34a',
        //Blues
        '#3498db',
        '#2980b9',
        '#34495e',
        '#2c3e50',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        //Reds
        '#e74c3c',
        '#c0392b',
        '#f44336',
        //Oranges
        '#e67e22',
        '#d35400',
        '#f39c12',
        '#ff9800',
        '#ff5722',
        '#ffc107',

        //Purples + Pinks
        '#9b59b6',
        '#8e44ad',
        '#9c27b0',
        '#673ab7',
        '#e91e63',
        '#3f51b5',
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.display_new.schedule.calendar',
            ["ui.calendar"]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.display_schedule_calendar_new', {
                url    :"/displayNew/schedule/calendar",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/displayNew/schedule/calendar/calendar.html',
                        controller : 'DisplayNewScheduleCalendarController as vm'
                    }
                },
                resolve: {
                    scheduleList: function (msApi)
                    {
                        return msApi.resolve('programDisplay.calendar@get');
                    }
                },
                bodyClass: 'calendar',
                "actionPermission" : "display_schedule_list_dtable_action"
            });


        //API
       msApiProvider.register('programDisplay.calendar', [Routing.generate('api_programDisplay_get_templates')]);







    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.display_new.schedule.calendar')
        .controller('DisplayNewScheduleCalendarController', DisplayNewScheduleCalendarController);

    /** @ngInject */
    function DisplayNewScheduleCalendarController($mdDialog , $state,scheduleList,$translate,$document,$rootScope,msApi,webTvGlobal)
    {

        var vm = this;
        initHelp();

        function initHelp() {
            $rootScope.titre1="PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2="PAGESMENUSTITLES.display_schedule_menuTitle";
            $rootScope.titre3="PAGESMENUSTITLES.display_schedule_list_menuTitle";
            $rootScope.pageRoute = "app.display_schedule_list_new";
            $rootScope.welcome = "welcome_calendar";
            $rootScope.text = [{
                texte: "display_calendar_today"
            }, {
                texte: "display_calendar_day"
            }, {
                texte: "display_calendar_week"
            }, {
                texte: "display_calendar_month"
            },
                {
                    texte: "display_calendar_next_prev"
                },{texte: "display_list_schedules"}];

        }
        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        vm.data=scheduleList.data;

        vm.event=[];
        vm.events=[];
        vm.StatusGrille=StatusGrille;
        vm.setCalendarConfigLanguage=setCalendarConfigLanguage;
        $rootScope.setCalendarConfigLanguage=setCalendarConfigLanguage;



        function StatusGrille(endAt,start_at){
            var d =new Date();
            if(endAt !==null)
            {
                if( moment(endAt).isBefore(d) && moment(start_at).isBefore(d) ) return -1 ;

                 if( moment(endAt).isAfter(d) && moment(start_at).isBefore(d) )  return 0 ;

                 if( moment(start_at).isAfter(d) ) return  1 ;



             }

        return  1;
         }
         vm.shortMonths=webTvGlobal.$constant().shortMonths();
        vm.calendarUiConfig = {
            calendar: {
                editable          : false,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                height: 700,
                lang: $translate.preferredLanguage(),
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.shortMonths[vm.calendar.getDate().format('M') - 1];
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                loading: function (bool) {
                    if(bool)$rootScope.loadingProgress = true;
                    else $rootScope.loadingProgress = false;
                },
                events: function(start, end, timezone, pushIntoCalendarEvents) {
                    msApi.request('programDisplay.calendar@get',
                         null,
                         function(res){
                            var events = [];
                            var now = moment();
                            for(var i = 0; i < res.data.schedules.length; i++){

                               var d =new Date();

                                var event = res.data.schedules[i];


                                var resultatstatus =StatusGrille(event.endAt,event.startAt);


                                events.push({
                                    "allDay":false,
                                    "id":event.id,
                                    "title":event.title,
                                    "start":moment(event.startAt),
                                    "end":moment(event.endAt),
                                    "className":("_event"+event.id+" "+getRandomClassName()),
                                    "_event":event,
                                    "schedulePrograms":event.schedulePrograms,
                                    "enable":event.enable,
                                     "description":event.description,
                                    "status":resultatstatus


                                });
                            }
                            vm.events = events;
                           pushIntoCalendarEvents(events);
                         },
                         function(){
                         }
                    );
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true
                //select            : select
            }
        };
        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;
        vm.showListe=showListe;

        //////////
        function getRandomClassName(){
            var classes = [
                'md-primary-bg',
                'md-primary-bg md-hue-1',
                'md-primary-bg md-hue-2',
                'md-primary-bg md-hue-3',
                'md-accent-bg',
                'md-accent-bg md-hue-1',
                'md-accent-bg md-hue-2',
                'md-accent-bg md-hue-3',
                'md-warn-bg',
                'md-warn-bg md-hue-1',
                'md-warn-bg md-hue-2',
                'md-warn-bg md-hue-3'
            ];
            return classes[Math.floor( Math.random() * classes.length)];
        }
        function setCalendarConfigLanguage(lang){

            vm.calendarUiConfig.calendar.lang=lang;
        }
        function getRandomColor() {
            var letters = '0123456789ABCDEF'.split('');
            var color = '#';
            for (var i = 0; i < 6; i++ ) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        }
        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();

        }

        function showListe() {
            //    $rootScope.currentState = $state.current.name;
            $state.go('app.display_schedule_list_new');

        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            //vm.calendar.refetchEvents();
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
         //   showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

         //   showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */



        function showEventDetailDialog(calendarEvent, e){
            $mdDialog.show({
                controller         : 'DisplayNewScheduleDetailController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/displayNew/schedule/calendar/detail/detail.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                onRemoving :function(){

                    vm.calendar.refetchEvents();
                },
                locals             : {
                    calendarEvent      : calendarEvent,
                   // showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }
    /**function StatusGrille(date){

        var date =new Date();
        if ( date <d){

            return "terminé"
        }
    }*/
        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */

/*
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                console.log(response);

                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }

*/

    }

})();

(function ()
{
    'use strict';

    angular
            .module('app.display_new.schedule.add', ['ui.sortable','ui.calendar'])
            .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider) {

        // State
        $stateProvider
                .state('app.display_schedules_add_new', {
                    url: "/displayNew/schedule/add",
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/displayNew/schedule/add/add.html',
                            controller: 'displayNewScheduleAddController as vm'
                        }
                    },
                    resolve: {
                        programsData: function (msApi)
                        {
                            return msApi.resolve('programDisplay.tenTemplates@get', {page: 65});
                        }
                    },
                    "actionPermission" : "display_schedule_post_add_action"
                });
        $translatePartialLoaderProvider.addPart('app/main/displayNew/schedule/add');
        msApiProvider.register('programDisplay.tenTemplates', [Routing.generate('api_templateDisplay_get_ten_templates', {page: ':page'}).replace(/%3A/,":")]);
        msApiProvider.register('programDisplay.add', [Routing.generate('api_programDisplay_post_add')]);
        msApiProvider.register('configuration_rmbox.listRmboxAndRmboxGroup', [Routing.generate('api_configuration_list_rmbox_and_rmbox_group')]);
    }
    
})();

(function () {
  'use strict';

  angular
    .module('app.display_new.schedule.add')
    .controller('displayNewScheduleAddController', displayNewScheduleAddController);

  /** @ngInject */
  function displayNewScheduleAddController(
    $filter,
    $mdSidenav,
    webTvGlobal,
    msApi,
    $translate,
    $state,
    $mdDialog,
    $rootScope,
    msUtils,
    $cookies,
    programsData
  ) {
    var vm = this;

    vm.alert = function (event) {
      var parentEl = angular.element(document.body);
      var screenshot =
        event.screenShot ||
        'data:image/png;base64,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';
      $mdDialog.show({
        controllerAs: 'modalCtrl',
        parent: parentEl,
        targetEvent: event,
        template:
          '<md-dialog  class="_md md-delete-theme md-transition-in delete-program-modal" >' +
          '<md-dialog-content class="md-dialog-content">' +
          '<h2 class="md-title" style="border-color: ' +
          event.color +
          ';">' +
          event.title +
          '</h2>' +
          '<div class="md-dialog-content-body">' +
          '<img src="' +
          screenshot +
          '"> ' +
          '</div>' +
          '</md-dialog-content>' +
          '<md-dialog-actions>' +
          '<button class="md-primary md-cancel-button md-button ng-scope md-delete-theme md-ink-ripple md-icon-button close-btn" type="button" ng-click="modalCtrl.hide()">' +
          '<span class="ng-binding ng-scope"></span></button>' +
          '</md-dialog-actions>' +
          '</md-dialog>',
        clickOutsideToClose: true,
        bindToController: true,
        controller: function ($mdDialog) {
          var vm = this;
          vm.hide = function hide() {
            $mdDialog.hide();
          };
        },
      });
    };

    initHelp();
    vm.slot = parseInt($cookies.get('slotSchedule')) || 1;

    vm.type = 'month';
    vm.click = click;
    vm.pageChanged = pageChanged;
    vm.changeSlot = changeSlot;
    vm.initialCalender = initialCalender;
    vm.totalPrograms = 0;

    function convertMinsToHrsMins(minutes) {
      var h = Math.floor(minutes / 60);
      var m = minutes % 60;
      h = h < 10 ? '0' + h : h;
      m = m < 10 ? '0' + m : m;
      return h + ':' + m + ':' + '00';
    }

    var slot = convertMinsToHrsMins(vm.slot);

    function indexOfMax(events) {
      if (events.length === 0) {
        return -1;
      }

      var max = parseInt(moment(events[0]['end']).format('x'));
      var maxIndex = 0;

      for (var i = 1; i < events.length; i++) {
        if (parseInt(moment(events[i]['end']).format('x')) > max) {
          maxIndex = i;
          max = parseInt(moment(events[i]['end']).format('x'));
        }
      }

      return maxIndex;
    }

    function isSameDay(event, start) {
      var date_end = new Date(parseInt(moment(event.end).format('x')));
      var date_start = new Date(parseInt(start));
      var is_same_day = date_end.getDate() === date_start.getDate();
      return parseInt(start) - parseInt(moment(event.end).format('x')) < 86399 && is_same_day;
    }

    function filterSlotIsOccupied(start) {
      const result = vm.events.filter(function (event) {
        return isSameDay(event, start);
      });

      return result;
    }

    function changeSlot() {
      //vm.slot = vm.screenForm.dateStart.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.slot).format('YYYY-MM-DD'));
      if (angular.isDefined(vm.slot) && vm.slot !== 0) {
        $cookies.put('slotSchedule', vm.slot);
        vm.calendarUiConfig.calendar.slotDuration = convertMinsToHrsMins(vm.slot);
        vm.calendarUiConfig.calendar.defaultView = vm.type;
        vm.langChanged = 1;
        vm.calendarUiConfig.calendar.defaultDate = vm.calendar.getDate();
      }
    }

    function click(type) {
      vm.type = type;
    }

    function initHelp() {
      $rootScope.titre1 = 'PAGESMENUSTITLES.display_menuTitle';
      $rootScope.titre2 = 'PAGESMENUSTITLES.display_schedule_menuTitle';
      $rootScope.titre3 = 'PAGESMENUSTITLES.display_schedule_add_menuTitle';
      $rootScope.pageRoute = 'app.display_schedule_list_new';

      $rootScope.welcome = 'welcome_schedule_add';
      $rootScope.text = [
        {
          texte: 'schedule_add_help',
        },
        {texte: 'schedule_associate_help'},
        {
          texte: 'send_button_schedule_add_help',
        },
      ];
    }

    vm.dragOptions = {};
    vm.today = moment();
    vm.programs = angular.copy(programsData.data.templates);
    vm.totalPrograms = angular.copy(programsData.data.count);
    vm.programsss = [];
    vm.programColors = [];

    vm.programColors = vm.programs.map(function (p) {
      p.color = materialColor();
      return p;
    });

    vm.programs.forEach(function (value) {
      vm.programsss.push(value.title);
    });

    vm.pagination = {
      current: 1,
    };

    function pageChanged(newPage) {
      getResultsPage(newPage);
    }

    function getResultsPage(pageNumber) {
      msApi.request(
        'programDisplay.tenTemplates@get',
        {page: pageNumber, searchWord: vm.templateName},
        //SUCCESS
        function (response) {
          vm.prog = [];
          vm.programs = angular.copy(response.data.templates);
          vm.programs.forEach(function (value) {
            vm.prog.push(value.title);
          });
          vm.programsss = vm.prog;

          vm.programColors = vm.programs.map(function (p) {
            p.color = materialColor();
            return p;
          });
        },
        // ERROR
        function (response) {
        }
      );
    }

    vm.searchTenTemplates = searchTenTemplates;

    function searchTenTemplates() {
      msApi.request(
        'programDisplay.tenTemplates@get',
        {page: 1, searchWord: vm.templateName},
        //SUCCESS
        function (response) {
          vm.prog = [];
          vm.programs = angular.copy(response.data.templates);
          vm.programs.forEach(function (value) {
            vm.prog.push(value.title);
          });
          vm.programsss = vm.prog;
          vm.totalPrograms = angular.copy(response.data.count);
          vm.programColors = vm.programs.map(function (p) {
            p.color = materialColor();
            return p;
          });
        },
        // ERROR
        function (response) {
        }
      );
    }

    vm.langChanged = 0;
    vm.empScheduleError = [];

    vm.expanded = {
      form: true,
      calendar: true,
    };
    vm.schedule = {
      title: '',
      description: '',
      enable: false,
      startAt: new Date(),
      schedulePrograms: [],
      rmbox: '',
      rmboxgroup: '',
    };

    var dateNow = new Date();
    var d = dateNow.getDate();
    var m = dateNow.getMonth();
    var y = dateNow.getFullYear();

    vm.events = [];
    initialCalender();

    function initialCalender() {
      vm.calendarUiConfig = {
        calendar: {
          editable: true,
          defaultView: vm.type,
          droppable: true,
          slotDuration: convertMinsToHrsMins(vm.slot),
          header: '',
          height: 700,
          columnFormat: {
            month: 'dddd',
            week: 'ddd D',
            day: 'ddd M',
          },
          lang: $translate.preferredLanguage(),
          viewRender: function (view) {
            vm.calendarView = view;
            vm.calendar = vm.calendarView.calendar;
            vm.currentMonthShort = vm.calendar.getDate().format('MMM');
          },
          drop: dropExternal,
          eventRender: function (event, element) {
            var overlayEl = element[0].querySelector('.fc-time');

            if (!overlayEl) {
              var span = document.createElement('span');
              span.className = 'fc-time';
              element[0].querySelector('.fc-content').appendChild(span);
              overlayEl = element[0].querySelector('.fc-time');
            }

            element.find('.fc-time').html('');
            element.find('.fc-time').append(' ' + moment(event.start).format('HH:mm:ss'));

            element.css('color', event.program.color);
            element.css('border-color', event.program.color);
            overlayEl.style.backgroundColor = event.program.color;
          },
          eventDrop: dropInternal,
          eventClick: clickEvent,
          events: function (start, end, timezone, pushIntoCalendarEvents) {
            if (vm.langChanged) {
              vm.langChanged = 0;
              if (vm.events) pushIntoCalendarEvents(vm.events);
            }
          },
          eventAfterRender: function (event, element, view) {
            var overlayEl = element[0].querySelector('.fc-time');

            element.css('color', event.program.color);
            element.css('border-color', event.program.color);
            overlayEl.style.backgroundColor = event.program.color;
          },
        },
      };
    }

    vm.setCalendarConfigLanguage = setCalendarConfigLanguage;
    $rootScope.setCalendarConfigLanguage = setCalendarConfigLanguage;

    vm.dragOptions = {};
    vm.addNewSchedule = addNewSchedule;
    vm.toggleSidenav = toggleSidenav;

    //////////
    function setCalendarConfigLanguage(lang) {
      vm.calendarUiConfig.calendar.lang = lang;
      vm.langChanged = 1;
    }

    function clickEvent(event, e) {
      event.program.screenShot =
        event.program.screenShot ||
        'data:image/png;base64,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';
      event.isNew = true;
      if (!!!event.startDetail)
        event.startDetail = Object.assign({}, event.start.subtract(moment(event.start).utcOffset(), "minutes"));
      if (!!!event.endDetail)
      {
        if(event.end)
          event.endDetail = Object.assign({}, event.end.subtract(moment(event.end).utcOffset(), "minutes"));
        else
          event.endDetail = Object.assign({}, event.orEnd.subtract(moment(event.orEnd).utcOffset(), "minutes"));
      }
      $mdDialog.show({
        locals: {programData: event},
        templateUrl: 'app/main/displayNew/schedule/details-modal/details-modal.html',
        clickOutsideToClose: true,
        controller: 'programDetailsModalController',
        controllerAs: 'vm',
      });
    }

    function searchProgramParent(program) {
      var result = vm.events.filter(function(event) {
        return event.id == program.id && event.isParent});
      return result.length > 0 ? result[0] : program;
    }

    function searchProgramByIndex(program) {
      var result = vm.events.filter(function(event) {
        return event.id == program.id && event.indexProgramm === program.indexProgramm });
      return result.length > 0 ? result[0] : program;
    }

    function repeatingEvent(program, period,diff,hourStart,endP) {
      var programParent = searchProgramParent(program);
      var startT = new Date(programParent.start);
      if(diff || diff==0){
        startT = new Date(startT.getTime() + diff);
        startT.setHours(hourStart);
      }
      var endProgram = new Date(program.end);
      if(endP)
      {
        endProgram = new Date(endP);
      }

      var realEnd = new Date(program.periodEnd);
      vm.newEvents = [];
      vm.events = vm.events.filter(function(value, index, arr){
        return value.id !== program.id;
      });
      var i = 0;
      for (var start = startT; start <= realEnd; start.setDate(start.getDate() + period)) {
        var end = new Date(start);
        end.setHours(endProgram.getHours());
        end.setMinutes(endProgram.getMinutes());
        var eventP = angular.copy(program);
        var event = eventP;
        if(hourStart){
          event.start = moment(start);
          event.startDetail = new Date(start);
          event.end = moment(end);
          event.endDetail = new Date(end);
        }else{
          event.start = moment(start).add(moment(start).utcOffset(), "minutes");
          event.startDetail = new Date(start);
          event.end = moment(end).add(moment(end).utcOffset(), "minutes");
          event.endDetail = new Date(end);
        }

        event.orStart = angular.copy(event.start);
        event.orEnd = angular.copy(event.end);
        event.index = vm.events.length;
        event.indexProgramm = i;
        event.isParent = false;
        if (i === 0) {
          event.isParent = true;
        }
        i++;
        vm.newEvents.push(event);
        vm.events.push(event);
      }
      vm.calendar.removeEvents(program.id);
      vm.calendar.addEventSource(vm.newEvents);

    }

    $rootScope.$on('programUpdated', function (event, obj) {
      vm.events = vm.events.map(function (e) {
        if (e.id === obj.id) {
          try {
            obj.start = obj.start.add(obj.start.utcOffset(), "minutes");
            obj.end = obj.end.add(obj.end.utcOffset(), "minutes");
            // toDo add parent id
            if (obj.loop) {
              switch (obj.periodLoop) {
                case 'day':
                  repeatingEvent(obj, 1);
                  break;
                case 'week':
                  repeatingEvent(obj, 7);
                  break;
                case 'month':
                  repeatingEvent(obj, 30);
                  break;
                case 'year':
                  repeatingEvent(obj, 360);
                  break;
                default:

              }
            }
          } catch (e) {
            console.log('e catch', e)
          }
          return obj;
        }
        return e;
      });
      vm.calendar.updateEvent(obj, true);
    });

    $rootScope.$on('programRemoved', function (event, obj) {
      for (var i = 0; i < vm.events.length; i++) {
        if (vm.events[i].id === obj.id) {
          vm.events.splice(i, 1);
          break;
        }
      }
      vm.calendar.removeEvents(obj.id);
    });

    function dropInternal(event, delta, revertFunc) {
      if (event.loop) {
        var originProgram = searchProgramByIndex(event);
        var diff = event.start.diff(originProgram.start.add(originProgram.start.utcOffset(), "minutes"));
        var hours = originProgram.startDetail.getHours();
        var end = originProgram.endDetail;
        //event.start = obj.start.add(obj.start.utcOffset(), "minutes");
        //event.end = obj.end.add(obj.end.utcOffset(), "minutes");
        switch (event.periodLoop) {
          case 'day':
            repeatingEvent(event, 1,diff,hours,end);
            break;
          case 'week':
            repeatingEvent(event, 7,diff,hours,end);
            break;
          case 'month':
            repeatingEvent(event, 7,diff,hours,end);
            break;
          case 'year':
            repeatingEvent(event, '1y',diff,hours,end);
            break;
          default:

        }
        revertFunc();
        return;

      } else {
        if (
          timeSlotIsOccupied(moment(event.start).format('x'), moment(event.end).format('x'), event.id)
        ) {
          var list_event = filterSlotIsOccupied(moment(event.start).format('x'));
          if (list_event.length > 0) {
            var index_of_max = indexOfMax(list_event);
            var event_by_index = list_event[index_of_max];
            var new_start = parseInt(moment(event_by_index.end).format('x')) + 1000;
            var new_end = event.end - event.start + new_start;
            event.start = moment(new_start);
            event.end = moment(new_end);
          } else {
            webTvGlobal.alertDialog($translate.instant('DISPLAYSCHEDULEEDIT.time_slot_occupied'));
            revertFunc();
            return;
          }
        }

        var program = event.program;
        var eventN = {program: {}};
        for (var prop in program) {
          eventN.program[prop] = program[prop];
        }

        eventN.id = msUtils.guidGenerator();
        eventN.editable = true;
        eventN.durationEditable = true;
        eventN.overlap = true;
        //eventN.color = "#FFFFFF";
        //eventN.backgroundColor = "#3a87ad";
        eventN.title = program.title;
        eventN.start = event.start;
        eventN.end = event.end;
        eventN.orStart = angular.copy(eventN.start);
        eventN.orEnd = angular.copy(eventN.end);
        eventN.unixStart = moment(eventN.start).format('x');
        eventN.unixEnd = moment(eventN.end).format('x');
        eventN.allDay = false;
        eventN.startEditable = true;
        eventN.className = '_event' + event.id + ' ' + 'md-primary-bg';
        eventN.content = '';
        eventN.index = vm.events.length - 1;

        /*****/
        for (var i = 0; i < vm.events.length; i++) {
          if (vm.events[i].id === event.id) {
            vm.events.splice(i, 1);
            break;
          }
        }

        vm.calendar.removeEvents(event.id);
        /*******/

        vm.events.push(eventN);
        vm.calendar.renderEvent(eventN, true);
      }
    }

    function dropExternal(eventDate, allDay) {
      var programs_list = angular.copy(vm.programColors);
      var index = angular.element(this).data('index');
      var program = angular.copy(programs_list[index]);
      var start = eventDate;
      var durationProgramme = program.options.duration ? program.options.duration : 0;
      var end = moment(new Date(eventDate)).add(durationProgramme, 'seconds');
      if (timeSlotIsOccupied(moment(start).format('x'), moment(end).format('x'), 0)) {
        var list_event = filterSlotIsOccupied(moment(start).format('x'));
        if (list_event.length > 0) {
          var index_of_max = indexOfMax(list_event);
          var event_by_index = list_event[index_of_max];
          var new_start = parseInt(moment(event_by_index.end).format('x')) + 1000;
          var new_end = end - start + new_start;
          start = new_start;
          end = new_end;
        } else {
          webTvGlobal.alertDialog($translate.instant('DISPLAYSCHEDULEEDIT.time_slot_occupied'));
          return;
        }
      }
      var start = new Date(start).toGMTString();
      var end = new Date(end).toGMTString();
      var event = {program: {}};
      for (var prop in program) {
        event.program[prop] = program[prop];
      }
      event.id = msUtils.guidGenerator();
      event.editable = true;
      event.durationEditable = true;
      event.overlap = true;
      event.className = '_event' + event.id + ' ' + 'md-primary-bg';
      event.title = program.title;
      event.start = moment(start);
      event.end = moment(end);
      event.orStart = angular.copy(event.start);
      event.orEnd = angular.copy(event.end);
      // event.unixStart = start.format('x');
      // event.unixEnd = end.format('x');
      event.allDay = false;
      event.content = '';
      event.index = vm.events.length;

      vm.events.push(event);
      vm.calendar.renderEvent(event, true);
    }

    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    function addNewSchedule() {
      var events = angular.copy(vm.events);
      var program = {};
      vm.schedule.schedulePrograms = [];
      events.sort(orderEvents);
      events.forEach(function (event, index) {
        if (index === 0) {
          vm.schedule.startAt = new Date(event.start);
        }


        if (event.periodLoop) {
          if(event.indexProgramm == 0)
          {
            program = {
              templateOrder: index,
              template: event.program.id,
              startAt: new Date(event.start),
              endAt: new Date(event.end),
            };
            program.periodLoop = event.periodLoop;
            program.loop = 1;
            program.periodEnd = event.periodEnd;
            vm.schedule.schedulePrograms.push(program);
          }

        }else {
          program = {
            templateOrder: index,
            template: event.program.id,
            startAt: new Date(event.start),
            endAt: new Date(event.end),
          };
          vm.schedule.schedulePrograms.push(program);
        }

      });

      msApi.request(
        'programDisplay.add@save',
        {data: angular.copy(vm.schedule)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal
              .$flashMessages()
              .set('displayGroupAdd', {title: vm.schedule.title ? vm.schedule.title : ''});
            $state.go('app.display_schedule_list_new');
          } else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            var empScheduleError = [];
            errors.forEach(function (item) {
              empScheduleError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.schedule[item.for]),
              };
            });
            vm.empScheduleError = empScheduleError;
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (response) {
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(
              function (message) {
                webTvGlobal.alertDialog(message);
              },
              function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              }
            );
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }

    function timeSlotIsOccupied(start, end, id) {
      var intStart = parseInt(start);
      var intEnd = parseInt(end);

      for (var i = vm.events.length - 1; i >= 0; i--) {
        if (
          id !== vm.events[i].id &&
          ((intStart >= parseInt(moment(vm.events[i].start).format('x')) &&
            intStart <= parseInt(moment(vm.events[i].end).format('x'))) ||
            (intEnd >= parseInt(moment(vm.events[i].start).format('x')) &&
              intEnd <= parseInt(moment(vm.events[i].end).format('x'))))
        )
          return true;

        if (
          id !== vm.events[i].id &&
          (intStart <= parseInt(moment(vm.events[i].start).format('x')) &&
            intEnd >= parseInt(moment(vm.events[i].end).format('x')))
        )
          return true;
      }
      return false;
    }

    function orderEvents(a, b) {
      if (a.unixStart < b.unixStart) return -1;
      if (a.unixStart > b.unixStart) return 1;
      return 0;
    }

    vm.attributeFrom = '';
    vm.attributeRmbox = attributeRmbox;

    /**
     * Attribute rmbox to schedule
     */
    function attributeRmbox(program, ev) {
      var hide = false;
      msApi.request('configuration_rmbox.listRmboxAndRmboxGroup@get', function (res) {
        $mdDialog
          .show({
            controller: function (entity, rmboxs, rmboxgroups, $mdDialog) {
              var vm = this;
              vm.program = entity;
              vm.rmboxs = webTvGlobal.convertToSelectChoicesFormat(rmboxs);
              vm.rmboxgroups = webTvGlobal.convertToSelectChoicesFormat(rmboxgroups);
              vm.validate = validate;

              function validate() {
                var param = [];
                param['rmbox'] = vm.attributeFrom === 'rmbox' ? vm.schedule.rmbox : [];
                param['rmboxgroup'] =
                  vm.attributeFrom === 'rmboxgroup' ? vm.schedule.rmboxgroup : [];
                $mdDialog.hide(param);
              }

              vm.closeDialog = closeDialog;

              function closeDialog() {
                $mdDialog.hide();
                hide = true;
              }
            },
            controllerAs: 'vm',
            templateUrl: 'app/main/displayNew/schedule/add/associate.rmbox.modale.template.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
              entity: program,
              rmboxs: res.data.rmboxs,
              rmboxgroups: res.data.rmboxGroups,
            },
          })
          .then(function (param) {
            if (!hide) {
              vm.schedule.rmbox = param['rmbox'];
              vm.schedule.rmboxgroup = param['rmboxgroup'];
            }
          });
      });
    }

    function materialColor() {
      // colors from https://github.com/egoist/color-lib/blob/master/color.json
      var colors = [
        '#1abc9c',
        '#16a085',
        '#2ecc71',
        '#27ae60',
        '#4caf50',
        '#8bc34a',
        //Blues
        '#3498db',
        '#2980b9',
        '#34495e',
        '#2c3e50',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        //Reds
        '#e74c3c',
        '#c0392b',
        '#f44336',
        //Oranges
        '#e67e22',
        '#d35400',
        '#f39c12',
        '#ff9800',
        '#ff5722',
        '#ffc107',

        //Purples + Pinks
        '#9b59b6',
        '#8e44ad',
        '#9c27b0',
        '#673ab7',
        '#e91e63',
        '#3f51b5',
      ];
      return colors[Math.floor(Math.random() * colors.length)];
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.comments.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.comments_list', {
                url: "/interactivity/comments/list",
                abstract: true,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/comments/list/list.template.html',
                        controller: 'CommentsListTemplateController as vm'

                    }
                },
                "bodyClass": "e-commerce"
            })
            .state('app.comments_list.live', {
                url: "/live?id=all",
                views: {
                    'live@app.comments_list': {
                        templateUrl: 'app/main/interactivity/comments/list/list_dataTable.html',
                        controller: 'CommentsListController as vm'

                    }
                },
                resolve: {
                    CommentsListData: function () {
                        return "comments.dtable@get";
                    },
                    TypeList: function () {
                        return "live";
                    },
                    getExportExcelApi: function () {
                          return "api_lives_get_comment_live_excel";
                    },

                }
            }).state('app.comments_list.media', {
            url: "/media?id=all",
            views: {
                'live@app.comments_list': {
                    templateUrl: 'app/main/interactivity/comments/list/list_dataTable.html',
                    controller: 'CommentsListController as vm'

                }
            },
            resolve: {
                CommentsListData: function () {
                    return "comments.dtableMedia@get";
                },
                TypeList: function () {
                    return "vod";
                },
                getExportExcelApi: function () {
                  return "api_lives_get_comment_live_excel";
                },
            }
        });
        // Api
        var routes=Routing.getRoutes().a;
        var deleteCommentsRoute = Routing.generate('api_lives_delete_comments') + "/:id";
        var enableCommentsRoute = Routing.generate('api_lives_post_enable_comments') + "/:id";
        var disableCommentsRoute = Routing.generate('api_lives_post_disable_comments') + "/:id";
        msApiProvider.register('comments.live.list', [Routing.generate('api_lives_get_commentss', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('comments.live.mdelete', [deleteCommentsRoute, {id: '@id'}]);
        msApiProvider.register('comments.live.enable', [enableCommentsRoute, {id: '@id'}]);
        msApiProvider.register('comments.live.disable', [disableCommentsRoute, {id: '@id'}]);
        msApiProvider.register('comments.live.modalGetComments', [Routing.generate('api_lives_get_detail_comments', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('comments.dtable', [Routing.generate('api_dtable_list_dtable_lives_comments')]);
        msApiProvider.register('comments.dtableMedia', [Routing.generate('api_dtable_list_dtable_media_comments')]);
        routes.indexOf("api_lives_get_comment_live_excel") >-1 ?  msApiProvider.register('comments.exportExcel', [Routing.generate('api_lives_get_comment_live_excel')]) : "";
        var deleteListComments = Routing.generate('api_multi_delete_multi_lives_comments') + "/:list";
        msApiProvider.register('comments.deleteComments', [deleteListComments, {list: '@list'}]);
        msApiProvider.register('comments.modalGetComments', [Routing.generate('api_media_get_detail_comments', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteCommentsMedia = Routing.generate('api_media_delete_comments') + "/:id";
        var enableCommentsMedia = Routing.generate('api_media_post_enable_comments') + "/:id";
        var disableCommentsMedia = Routing.generate('api_media_post_disable_comments') + "/:id";
        msApiProvider.register('comments.mdelete', [deleteCommentsMedia, {id: '@id'}]);
        msApiProvider.register('comments.enable', [enableCommentsMedia, {id: '@id'}]);
        msApiProvider.register('comments.disable', [disableCommentsMedia, {id: '@id'}]);
        var deleteListCommentsMedia = Routing.generate('api_multi_delete_multi_media_commentss') + "/:list";
        msApiProvider.register('commentsMedia.deleteComments', [deleteListCommentsMedia, {list: '@list'}]);
        msApiProvider.register('commentsLive.getNameLive', [Routing.generate('api_get_title_live', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('commentsMedia.getNameMedia', [Routing.generate('api_media_get_title_video', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.comments.list')
        .controller('CommentsListController', CommentsListController)
        .controller('CommentsListTemplateController', CommentsListTemplateController);

    /** @ngInject */
    function CommentsListController(CommentsListData, TypeList, $compile, $cookies, $scope, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $injector, dtable_language, userManager,getExportExcelApi) {

        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');

        initHelp();
        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.live_comment_list_pagetitle";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
            $rootScope.welcome = "welcome_comment";
            $rootScope.text = [{
                texte: "arrow_button_comment_help"
            }, {
                texte: "search_area_comment_help"
            }, {
                texte: "tri_column_comment_help"
            },
                {
                    texte: "edit_button_comment_help"
                },
                {
                    texte: "activate_button_comment_help"
                }, {
                    texte: "detail_button_comment_help"
                },
                {
                    texte: "delete_button_comment_help"
                }];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var defaultDateFormat = $rootScope.defaultDateFormat + ' HH:mm:ss';
        //Data Table options
        vm.commentsDataTable = {};
        vm.selectedCommentss = [];
        var selectedCommentss = [];
        vm.exportExcelComments = exportExcelComments;

        vm.pemission = {};
        if (userManager.isActionGranted('comment_post_multi_delete')) {
            vm.pemission.comment_post_multi_delete = true;
        }
        var routes = webTvGlobal.getApiRoutes();
        vm.hasExportExcelApi=routes.indexOf(getExportExcelApi)>-1;
      vm.dtInstance = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    // Target the image column
                    targets: 2,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    targets: 4,
                    render: function (data) {
                        if (data === "") return "--";
                        if (parseInt(data) < 1) return "--";
                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.commentsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.commentsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggleSelectComments(vm.commentsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('status').notSortable()
                .renderWith(function (data) {
                    var serverHtml = "";
                    if (data === null) {
                        serverHtml += '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                    }
                    else {
                        if (data) {
                            serverHtml += '<i ' +
                                'style="color: green;"' +
                                'class="icon icon-check">';
                        }
                        else {
                            serverHtml += '<i ' +
                                'style="color: red;"' +
                                'class="icon icon-alert">';
                        }
                    }

                    return serverHtml;
                }),
            DTColumnBuilder.newColumn("img")
                .renderWith(function (data, type, full) {
                    vm.commentsDataTable[full.id] = full;


                    var serverHtml = "";
                    if (data === null || data === "" || data === false || data === 'not_found') {
                        serverHtml +=
                            '<span md-font-icon="icon-picture" class="s72" width="100" height="100">-</span>';
                    }
                    else {
                        serverHtml += '<div class="parentImg">' +
                            '<img width="100" height="100" class="product-image" ng-src="' + data + '"/>' +
                            '</div>';
                    }
                    return serverHtml;
                }),
            DTColumnBuilder.newColumn('comment').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('user').renderWith(function (data) {
                if(angular.isDefined(data) && data){
                    var name = data.split(';');
                    if(typeof name[1] === 'undefined') {
                        name = data;
                    }else{
                        name = name[1];
                    }
                }else{
                    var name = "";
                }
                return name;
            }),
            DTColumnBuilder.newColumn('created_at').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null && angular.isDefined(data)) ? moment(data).format(defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.commentsDataTable[data.id] = data;

                    var buttonActionDetailHtml = '<md-button class="show-button md-icon-button" has-permission="comment_detail" ng-click="vm.showCommentsDetail(vm.commentsDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_detail" +
                        "'|translate}}" +
                        '</md-tooltip>' +
                        '</md-button>';
                    var buttonActionEditHtml = '<md-button class="edit-button md-icon-button" has-permission="comment_post_edit" ng-click="vm.editComments(vm.commentsDataTable[' + data.id + '])" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_edit'|translate}}" +
                        '</md-tooltip>' +
                        '</md-button>';
                    var buttonActionDeleteHtml = '<md-button class="m16 delete-button md-icon-button" has-permission="comment_post_delete" ng-click="vm.deleteCommentsConfirm(vm.commentsDataTable[' + data.id + '],ev)" aria-label="action_delete" translate translate-attr-aria-label="MESSAGES.action_delete">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'MESSAGES.action_delete'|translate}}" +
                        '</md-tooltip>' +
                        ' </md-button>';
                    var buttonActionStatusEnableHtml = '<md-button class="m16 md-icon-thumb-up md-icon-button" has-permission="comment_post_activate" ng-if="vm.commentsDataTable[' + data.id + '].status==false"  ng-click="vm.enableComments(vm.commentsDataTable[' + data.id + '],ev)" aria-label="enable_comments" translate translate-attr-aria-label="COMMENTSLIST.enable_comments">' +
                        '<md-icon md-font-icon="icon-thumb-up"  class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'COMMENTSLIST.enable_comments'|translate}}" +
                        '</md-tooltip md-direction="bottom">' +
                        ' </md-button>';
                    var buttonActionStatusdisableHtml = '<md-button class="m16 md-icon-thumb-down md-icon-button" has-permission="comment_post_activate" ng-if="vm.commentsDataTable[' + data.id + '].status==true"  ng-click="vm.disableComments(vm.commentsDataTable[' + data.id + '],ev)" aria-label="disable_comments" translate translate-attr-aria-label="COMMENTSLIST.disable_comments">' +
                        '<md-icon  md-font-icon="icon-thumb-down" class="s18"></md-icon>' +
                        '<md-tooltip md-autohide="true"  md-direction="bottom">' +
                        "{{'COMMENTSLIST.disable_comments'|translate}}" +
                        '</md-tooltip md-direction="bottom">' +
                        ' </md-button>';
                    var buttonDiv = '<div style="height:10px"> </div>';
                    if(TypeList ==="vod" || (TypeList ==="live" && angular.isDefined(data.live) && angular.isDefined(data.live.isCommentValidation) && data.live.isCommentValidation )){
                        return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + buttonDiv + buttonActionStatusEnableHtml + buttonActionStatusdisableHtml;
                    }
                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + buttonDiv;

                })

        ];

        if (!vm.pemission.comment_post_multi_delete) {
            vm.dtColumns[0].bVisible = false;
        }
      function exportExcelComments() {
        msApi.request("comments.exportExcel@get", {id: $state.params.id},
          function (response) {
            if (response.code === 200) {
              window.location.href = response.url;
            } else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        );
      }
        if(!userManager.isActionGranted("comment_image")){
          vm.dtColumns[2].bVisible = false;
        }
        function searchCommentsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request(CommentsListData, filtre,
                function (response) {
                    //$rootScope.records = response.recordsTotal;
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.commentss = response.data;

                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.commentss = response.data;
                        vm.fnCallback(records);

                    }
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedCommentss = [];
            selectedCommentss = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_Comments,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;

            if (!isNaN($state.params.id) && $state.current.name.indexOf("detail") < 0 && $state.current.name.indexOf("live") > 0) {
                filtre["idLive"] = $state.params.id;
            }
            if (!isNaN($state.params.id) && $state.current.name.indexOf("detail") < 0 && $state.current.name.indexOf("media") > 0) {
                filtre["idVideo"] = $state.params.id;
            }

            vm.fnCallback = fnCallback;


            searchCommentsInAPI(filtre);

        }

        vm.deleteSelectedCommentsConfirm = deleteSelectedCommentsConfirm;
        vm.deleteCommentsConfirm = deleteCommentsConfirm;
        vm.searchComments = searchComments;
        vm.enableComments = enableComments;
        vm.disableComments = disableComments;
        vm.toogleSelection = toogleSelection;
        vm.toggleSelectComments = toggleSelectComments;
        vm.showCommentsDetail = showCommentsDetail;
        vm.editComments = editComments;
        vm.addNewComments = addNewComments;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('CommentsAdd', $translate.instant('COMMENTSLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('CommentsEdit', $translate.instant('COMMENTSLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the comments
         *
         * @param comments
         * @param list
         */
        function toggleSelectComments(comments) {
            comments.checked = !comments.checked;
            var idx = selectedCommentss.indexOf(comments);
            if (idx > -1) {
                selectedCommentss.splice(idx, 1);
            }
            else {
                selectedCommentss.push(comments);
            }
            vm.selectedCommentss = angular.copy(selectedCommentss);
        }

        /**
         * Toggle selected status of all the commentss
         *
         * @param event
         */
        function toogleSelection() {
            if (selectedCommentss.length === vm.commentss.length) {
                vm.selectedCommentss = [];
            }

            else if ((selectedCommentss.length === 0) || (selectedCommentss.length > 0)) {
                vm.selectedCommentss = vm.commentss.slice(0);
            }
            selectedCommentss = angular.copy(vm.selectedCommentss);
            var list_canals = angular.copy(vm.commentsDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.commentsDataTable[key].checked = selectedCommentss.length > 0;
            });
        }

        /**
         * Show Comments Details
         * @param comments
         */
        function showCommentsDetail(comments, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            if (CommentsListData === "comments.dtable@get") {

                msApi.request('comments.live.modalGetComments@get', {id: comments.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            $mdDialog.show({
                                locals: {CommentsData: response, type: "live"},
                                templateUrl: 'app/main/interactivity/comments/detail/detail.modal.html',
                                clickOutsideToClose: true,
                                controller: 'CommentsDetailController',
                                controllerAs: 'vm'
                            })
                        }
                        else {
                            $rootScope.loadingProgress = false;
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );
            }
            else {
                msApi.request('comments.modalGetComments@get', {id: comments.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.code) && response.code === 200) {
                            $mdDialog.show({
                                locals: {CommentsData: response, type: "media"},
                                templateUrl: 'app/main/interactivity/comments/detail/detail.modal.html',
                                clickOutsideToClose: true,
                                controller: 'CommentsDetailController',
                                controllerAs: 'vm'
                            })
                        }
                        else {
                            $rootScope.loadingProgress = false;
                            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                                $translate('VALIDATION.' + response.data.message).then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                            }
                            else {

                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );
            }


        }

        function deleteSelectedCommentsConfirm(ev) {
            if (vm.selectedCommentss.length !== 0) {
                var confirm = $mdDialog.confirm()
                    .title($translate.instant('MESSAGES.delete_selected_comments_msg'))
                    .htmlContent($translate.instant('MESSAGES.dialog_list_will_be_deleted'))
                    .ariaLabel($translate.instant('COMMENTSLIST.delete_selected_comments_aria_label'))
                    .targetEvent(ev)
                    .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
                    .cancel($translate.instant('MESSAGES.dialog_cancel'));

                $mdDialog.show(confirm).then(function () {
                    deleteSelectedComments(ev);
                }, function () {
                });

            }
        }

        /**
         * Delete video
         */
        function deleteSelectedComments(ev) {
            if (CommentsListData === "comments.dtable@get") {
                clearFlashMessage();
                $rootScope.loadingProgress = true;
                msApi.request('comments.deleteComments@delete', {
                        list: (function (list) {
                            vm.selectedCommentss.forEach(function (item) {
                                list.push(item.id);
                            });
                            return list;
                        })([])
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            var undeleted = "";
                            var deleted = "";
                            if (response.result.undeleted.length !== 0) {
                                undeleted = $translate.instant("MESSAGES.undeleted_are", {'list': response.result.undeleted.join(",")})
                            }
                            deleted = $translate.instant("MESSAGES.deleted_are", {'list': response.result.deleted.join(",")});
                            webTvGlobal.alertDialog(
                                deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_title'), '', ev);
                            vm.selectedCommentss = [];
                            selectedCommentss = [];
                            rerender();
                        } else {
                            webTvGlobal.alertDialog(
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_error_title'),
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_error_description'), '', ev);
                            vm.selectedCommentss = [];
                            selectedCommentss = [];
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                        vm.selectedCommentss = [];
                        selectedCommentss = [];
                        vm.modelCheckAll = false;
                    }
                );
            }
            else {
                clearFlashMessage();
                $rootScope.loadingProgress = true;
                msApi.request('commentsMedia.deleteComments@delete', {
                        list: (function (list) {
                            vm.selectedCommentss.forEach(function (item) {
                                list.push(item.id);
                            });
                            return list;
                        })([])
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;

                        if (response.code === 200) {
                            var undeleted = "";
                            var deleted = "";
                            if (response.result.undeleted.length !== 0) {
                                undeleted = $translate.instant("COMMENTSLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                            }
                            deleted = $translate.instant("COMMENTSLIST.deleted_are", {'list': response.result.deleted.join(",")});
                            webTvGlobal.alertDialog(
                                deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_title'), '', ev);
                            vm.selectedCommentss = [];
                            selectedCommentss = [];
                            rerender();
                        } else {
                            webTvGlobal.alertDialog(
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_error_title'),
                                $translate.instant('COMMENTSLIST.dialog_alert_delete_error_description'), '', ev);
                            vm.selectedCommentss = [];
                            selectedCommentss = [];
                        }
                    },
                    function (response) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                        vm.selectedCommentss = [];
                        selectedCommentss = [];
                        vm.modelCheckAll = false;
                    }
                );
            }
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchCommentsInAPI(filtre), true);
        }

        function editComments(comments) {
            clearFlashMessage();
            if (CommentsListData === "comments.dtable@get") {
                $state.go('app.lives_comments_edit', {id: comments.id});
            }
            else {
                $state.go('app.media_comments_edit', {id: comments.id});
            }
        }

        /**
         * redirection to add new comments page
         * @param event
         */
        function addNewComments() {
            clearFlashMessage();
            $state.go('app.lives_comments_add');
        }

        /**
         * Delete Comments Confirm Dialog
         */
        function deleteCommentsConfirm(Comments, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "COMMENTSLIST.delete_comments_msg",
                "COMMENTSLIST.delete_comments_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['COMMENTSLIST.delete_comments_msg'])
                        .htmlContent('<b>' + Comments.comment + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['COMMENTSLIST.delete_comments_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteComments(Comments);
                        vm.selectedCommentss = [];
                        selectedCommentss = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete Comments
         */
        function deleteComments(Comments) {
            if (CommentsListData === "comments.dtable@get") {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.live.mdelete@delete', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_delete_title",
                                    "COMMENTSLIST.dialog_alert_delete_description",
                                    "COMMENTSLIST.dialog_alert_delete_close"
                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_delete_description']);

                                        vm.commentss.splice(vm.commentss.indexOf(Comments), 1);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_delete_error_title",
                                    "COMMENTSLIST.dialog_alert_delete_error_description",
                                    "COMMENTSLIST.dialog_alert_delete_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_delete_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_delete_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_delete_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }
            else {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.mdelete@delete', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_delete_title",
                                    "COMMENTSLIST.dialog_alert_delete_description",
                                    "COMMENTSLIST.dialog_alert_delete_close"
                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_delete_description']);

                                        vm.commentss.splice(vm.commentss.indexOf(Comments), 1);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_delete_error_title",
                                    "COMMENTSLIST.dialog_alert_delete_error_description",
                                    "COMMENTSLIST.dialog_alert_delete_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_delete_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_delete_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_delete_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }

        }

        /**
         * Enable Comments
         */
        function enableComments(Comments) {
            if (CommentsListData === "comments.dtable@get") {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.live.enable@save', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_enable_title",
                                    "COMMENTSLIST.dialog_alert_enable_description",
                                    "COMMENTSLIST.dialog_alert_enable_close"
                                ])
                                    .then(function (translatedValues) {

                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_enable_description']);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_enable_error_title",
                                    "COMMENTSLIST.dialog_alert_enable_error_description",
                                    "COMMENTSLIST.dialog_alert_enable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_enable_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_enable_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_enable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            } else {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.enable@save', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_enable_title",
                                    "COMMENTSLIST.dialog_alert_enable_description",
                                    "COMMENTSLIST.dialog_alert_enable_close"
                                ])
                                    .then(function (translatedValues) {

                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_enable_description']);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_enable_error_title",
                                    "COMMENTSLIST.dialog_alert_enable_error_description",
                                    "COMMENTSLIST.dialog_alert_enable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_enable_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_enable_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_enable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }
        }

        /**
         * Enable Comments
         */
        function disableComments(Comments) {
            if (CommentsListData === "comments.dtable@get") {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.live.disable@save', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_disable_title",
                                    "COMMENTSLIST.dialog_alert_disable_description",
                                    "COMMENTSLIST.dialog_alert_disable_close"
                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_disable_description']);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_disable_error_title",
                                    "COMMENTSLIST.dialog_alert_disable_error_description",
                                    "COMMENTSLIST.dialog_alert_disable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_disable_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_disable_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_disable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            } else {
                clearFlashMessage();
                if (vm.commentss.indexOf(Comments) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('comments.disable@save', {id: Comments.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_disable_title",
                                    "COMMENTSLIST.dialog_alert_disable_description",
                                    "COMMENTSLIST.dialog_alert_disable_close"
                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(Comments.comment + translatedValues['COMMENTSLIST.dialog_alert_disable_description']);
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "COMMENTSLIST.dialog_alert_disable_error_title",
                                    "COMMENTSLIST.dialog_alert_disable_error_description",
                                    "COMMENTSLIST.dialog_alert_disable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['COMMENTSLIST.dialog_alert_disable_error_title'],
                                            textContent: translatedValues['COMMENTSLIST.dialog_alert_disable_error_description'],
                                            ok: translatedValues['COMMENTSLIST.dialog_alert_disable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }
        }

        function searchComments() {
            filtre["search[value]"] = vm.search_Comments;
            searchCommentsInAPI(filtre);
        }

    }

    function CommentsListTemplateController($rootScope, msApi, HelpGlobal) {
        var vm = this;
        var title = "";
        vm.testInLiveMedia = '';

        function getName(apiName, id) {
            msApi.request(apiName, {id: id},
                function (response) {
                    if (response.code === 200) {
                        if (response.Titre.length >= 20) {
                            title = response.Titre.substring(0, 20) + '...';
                        }
                        else {
                            title = response.Titre;
                        }
                    }


                });
        }

        if ($rootScope.state.params.id) {
            if ($rootScope.state.current.url.indexOf('live') > 0) {
                vm.testInLiveMedia = 'live';
                getName('commentsLive.getNameLive@get', $rootScope.state.params.id);
            }
            else {
                if ($rootScope.state.current.url.indexOf('media') > 0) {
                    vm.testInLiveMedia = 'media';
                    getName('commentsMedia.getNameMedia@get', $rootScope.state.params.id);
                }
            }

        }
    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.interactivity.comments.list')
        .controller('CommentsDetailController', CommentsDetailController);

    /** @ngInject */
    function CommentsDetailController(CommentsData,type,$mdDialog)
    {
    	var vm = this;
    	if (type === "live"){

        vm.comments = CommentsData.CommentsLive;
      }
      else {
        vm.comments = CommentsData;
      }
        vm.cancel = cancel;
        function cancel() {
        $mdDialog.hide();
      }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.sondage.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.sondage_list', {
                url: "/sondage/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/sondage/list/list.template.html',
                        controller: 'SondageListController as vm'
                    }
                },

                "bodyClass": "e-commerce",
                "actionPermission" : "sondage_list_dtable_action"
            });

        // Api
        var deletesondageRoute = Routing.generate('api_survey_delete_survey') + "/:id";
        var deleteListSondage = Routing.generate('api_multi_delete_multi_surveys') + "/:list";
        msApiProvider.register('sondage.deleteSondages', [deleteListSondage, {list: '@list'}]);
        msApiProvider.register('sondage.list', [Routing.generate('api_survey_get_surveys')]);
        msApiProvider.register('sondage.mdelete', [deletesondageRoute, {id: '@id'}]);
        msApiProvider.register('sondage.modalGetSondage', [Routing.generate('api_survey_get_detail_survey', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('sondage.list_data_table', [Routing.generate('api_dtable_list_dtable_surveys')]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.sondage.list')
        .controller('SondageListController', SondageListController);

    /** @ngInject */
    function SondageListController(msUtils, $scope, msApi, $cookies, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog');
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.sondage_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.sondage_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_sondage";
            $rootScope.text = [{
                texte: "add_button_sondage_help"
            }, {
                texte: "arrow_button_sondage_help"
            }, {
                texte: "search_area_sondage_help"
            }, {
                texte: "tri_column_sondage_help"
            },
                {
                    texte: "edit_button_sondage_help"
                }, {
                    texte: "detail_button_sondage_help"
                }, {
                    texte: "detail_sondage_button_help"
                }, {
                    texte: "download_button_sondage_help"
                },
                {
                    texte: "delete_button_sondage_help"
                }];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.sondages = [];
        vm.sondages = vm.sondagesDataTable = [];
        vm.fnCallback = undefined;
        var drawIndex = 1;
        var filtre = {};
        var checkedSelected = false;
        vm.dtInstance = {};
        var recordsTotal = 0;
        vm.selectedSondages = [];
        var selectedSondages = [];
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    targets: [1],
                    width: '72px'
                }
            ]
            ])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers')
        ;
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
                .renderWith(function (data) {
                    vm.sondagesDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.sondagesDataTable[' + data.id + '].checked"' + 'ng-click="vm.toggleSelectSondage(vm.sondagesDataTable[' + data.id + '])"' + 'aria-label="-">' + '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false)
                .renderWith(function (data) {
                    vm.sondagesDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a has-permission="sondage_get_detail" tooltips tooltip-template=' + "{{'SONDAGELIST.detail_sondage'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showSondageDetail(vm.sondagesDataTable[' + data.id + '],$event)" aria-label="Détails" translate translate-attr-aria-label="SONDAGELIST.detail_sondage" >' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDetailVoteHtml =
                        '<a has-permission="sondage_post_edit" tooltips tooltip-template=' + "{{'SONDAGELIST.detail_vote'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.sondageVoteList(vm.sondagesDataTable[' + data.id + '],$event)" aria-label="Détails vote" translate translate-attr-aria-label="SONDAGELIST.detail_vote" >' +
                        '<md-icon  md-font-icon="icon-chart-histogram" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'SONDAGELIST.update_sondage'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="edit-button md-icon-button" ng-click="vm.editSondage(vm.sondagesDataTable[' + data.id + '])" aria-label="Modifier" translate translate-attr-aria-label="SONDAGELIST.update_sondage">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a has-permission="sondage_delete_survey" tooltips tooltip-template=' + "{{'SONDAGELIST.delete_sondage'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteSondageConfirm(vm.sondagesDataTable[' + data.id + '],ev)" aria-label="action_delete" translate translate-attr-aria-label="SONDAGELIST.delete_sondage">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';
                    var buttonActionDownloadHtml =
                        '<a tooltips tooltip-template=' + "{{'SONDAGELIST.download_sondage'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="download-button md-icon-button" ng-click="vm.getCsvSondage(vm.sondagesDataTable[' + data.id + '],$event)" aria-label="Télécharger Détails" translate translate-attr-aria-label="SONDAGELIST.download_sondage">' +
                        '<md-icon  md-font-icon="icon-download" class="s18"></md-icon>' +
                        '</md-button></a>';

                    return buttonActionDetailVoteHtml + buttonActionDownloadHtml + buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;
                })
        ];

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = sort.column - 1 < 0 ? 0 : sort.column - 1;
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_sondage,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchSondageInAPI(filtre);
        }

        function searchSondageInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('sondage.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': drawIndex,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        drawIndex = drawIndex + 1;
                        vm.sondages = response.data;
                        recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };
                            vm.sondages = [];
                            recordsTotal = 0;
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                },
                function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );

        }

        vm.toogleSelection = toogleSelection;
        vm.searchSondages = searchSondages;
        vm.getCsvSondage = getCsvSondage;
        vm.deleteSondageConfirm = deleteSondageConfirm;
        vm.actionPermission=actionPermission;
        vm.deleteSondagesConfirm = deleteSondagesConfirm;
        vm.toggleSelectSondage = toggleSelectSondage;
        vm.showSondageDetail = showSondageDetail;
        vm.editSondage = editSondage;
        vm.addNewSondage = addNewSondage;
        vm.sondageVoteList = sondageVoteList;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('SondageAdd', $translate.instant('SONDAGELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('SondageEdit', $translate.instant('SONDAGELIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the sondage
         *
         * @param sondage
         * @param list
         */
        function toggleSelectSondage(sondage) {
            sondage.checked = !sondage.checked;
            var idx = selectedSondages.indexOf(sondage);
            if (idx > -1) {
                selectedSondages.splice(idx, 1);
            }
            else {
                selectedSondages.push(sondage);
            }
            vm.selectedSondages = angular.copy(selectedSondages);
        }

        function toogleSelection() {
            if (selectedSondages.length === vm.sondages.length) {
                vm.selectedSondages = [];
            }

            else if ((selectedSondages.length === 0) || (selectedSondages.length > 0)) {
                vm.selectedSondages = vm.sondages.slice(0);
            }
            selectedSondages = angular.copy(vm.selectedSondages);
            var list_canals = angular.copy(vm.sondagesDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.sondagesDataTable[key].checked = selectedSondages.length > 0;
            });
        }

        /**
         * Show sondage Details
         * @param sondage
         */
        function showSondageDetail(sondage, event) {
            $rootScope.userManager.statsAccesAction("sondage_get_detail_action")
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('sondage.modalGetSondage@get', {id: sondage.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {SondageData: response},
                            templateUrl: 'app/main/interactivity/sondage/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'SondageDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchSondageInAPI(filtre), true);
        }

        function editSondage(sondage) {
            clearFlashMessage();
            $state.go('app.sondage_edit', {id: sondage.id});
        }

        function sondageVoteList(sondage) {
            clearFlashMessage();
            $state.go('app.sondage_vote', {id: sondage.id});
        }

        /**
         * redirection to add new sondage page
         * @param event
         */
        function addNewSondage() {
            clearFlashMessage();
            $state.go('app.sondage_add');
        }

        /**
         * Delete sondage
         */
        function getCsvSondage(Sondage) {
            return webTvGlobal.openNewWindow(Routing.generate('api_survey_vote_get_csv_votes', {id: Sondage.id}));
        }

        /**
         * Delete sondage Confirm Dialog
         */
        function actionPermission(action){
            $rootScope.userManager.statsAccesAction(action)
        }
        function deleteSondageConfirm(sondage, ev) {
           vm.actionPermission("sondage_delete_survey_action")
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "SONDAGELIST.delete_sondage_msg",
                "SONDAGELIST.delete_sondage_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title($translate.instant('SONDAGELIST.delete_sondage_msg'))
                        .htmlContent('<b>' + sondage.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['SONDAGELIST.delete_sondage_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {                     
                        deleteSondage(sondage);
                        vm.selectedSondages = [];
                        selectedSondages = [];
                    }, function () {

                    });
                });


        }

        function deleteSondagesConfirm(ev) {
            vm.actionPermission("sondage_delete_multi_action")
            var title;
            var ariaLabel;
            if (vm.selectedSondages.length !== 0) {
                if(vm.selectedSondages.length === 1){
                    title = 'SONDAGELIST.delete_sondage_msg';
                    ariaLabel = 'SONDAGELIST.delete_sondage_aria_label';
                }else{
                    title = 'SONDAGELIST.delete_list_sondage_msg';
                    ariaLabel = 'SONDAGELIST.delete_sondages_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedSondages.length,title,ariaLabel)).then(function () {
                   
                    deleteSondages(ev);
                }, function () {
                });

            }


        }

        function deleteSondages(ev) {
            $rootScope.loadingProgress = true;
            msApi.request(
                'sondage.deleteSondages@delete',
                {
                    list: (function (list) {
                        vm.selectedSondages.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("SONDAGELIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("SONDAGELIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('SONDAGELIST.mdelete_success'),
                            '',
                            ev
                        );
                        vm.selectedSondages = [];
                        selectedSondages = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('SONDAGELIST.dialog_alert_delete_error_title'),
                            $translate.instant('SONDAGELIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedSondages = [];
                        selectedSondages = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                            webTvGlobal.alertDialog(message);
                        }), function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        };
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }

                    vm.selectedSondages = [];
                    selectedSondages = [];
                }
            );
        }

        /**
         * Delete sondage
         */
        function deleteSondage(Sondage) {
            clearFlashMessage();
            if (Sondage !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('sondage.mdelete@delete', {id: Sondage.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "SONDAGELIST.dialog_alert_delete_title",
                                "SONDAGELIST.dialog_alert_delete_description",
                                "SONDAGELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Sondage.name + translatedValues['SONDAGELIST.dialog_alert_delete_description']);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "SONDAGELIST.dialog_alert_delete_error_title",
                                "SONDAGELIST.dialog_alert_delete_error_description",
                                "SONDAGELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['SONDAGELIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['SONDAGELIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['SONDAGELIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }


        function searchSondages() {
            filtre["search[value]"] = vm.search_sondage;
            searchSondageInAPI(filtre);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.sondage.vote', ["datatables"])
        .config(config);

    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.sondage_vote', {
                url    : "/sondage/:id/vote",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/sondage/vote/list.template.html',
                        controller : 'SondageVoteController as vm'
                    }
                },
                resolve: {
                    VoteListData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('vote.list@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "e-commerce"
            });
           
        
        // Api
        var deletevoteRoute=Routing.generate('api_survey_vote_delete_vote')+"/:id";
        msApiProvider.register('vote.list', [Routing.generate('api_survey_get_nb_votes_survey',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
        msApiProvider.register('vote.mdelete', [deletevoteRoute, {id: '@id'}]);
		msApiProvider.register('vote.getVote', [Routing.generate('api_survey_vote_get_vote',{id: ':id'}).replace(/%3A/,":")]);
		msApiProvider.register('vote.modalGetVote', [Routing.generate('api_survey_vote_get_vote',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
        
        



    }
})();
(function () {
    'use strict';

    angular
        .module('app.interactivity.sondage.vote')
        .controller('SondageVoteController', SondageVoteController);

    /** @ngInject */
    function SondageVoteController(VoteListData, msUtils, $mdDialog, msApi, webTvGlobal, DTOptionsBuilder, $injector, $cookies,dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.questions = angular.isDefined(VoteListData.data) && angular.isDefined(VoteListData.data.questions) ? VoteListData.data.questions : [];
        var selectedVotes = [];
        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: [1],
                    width: '72px'
                }
            ]
            ])
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption("order", [[0, 'desc']])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withPaginationType('full_numbers')
        ;


        vm.sondageDetailVoteList = sondageDetailVoteList;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('VoteAdd', $translate.instant('SONDAGELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('VoteEdit', $translate.instant('SONDAGELIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selection status of all the votes
         *
         * @param event
         */
        function toogleSelection(event) {
            if (event) {
                event.stopPropagation();
            }

            if (selectedVotes.length === vm.votes.length) {
                selectedVotes = [];
            }
            else {
                selectedVotes = vm.votes;
            }
        }


        /**
         * Toggle selected status of the vote
         *
         * @param vote
         * @param event
         */
        function toggleSelectVote(vote, event) {
            if (event) {
                event.stopPropagation();
            }

            if (selectedVotes.indexOf(vote) > -1) {
                selectedVotes.splice(selectedVotes.indexOf(vote), 1);
            }
            else {
                selectedVotes.push(vote);
            }
        }

        /**
         * Deselect votes
         */
        function deselectVotes() {
            selectedVotes = [];
        }

        /**
         * Select all votes
         */
        function selectAllVotes() {
            selectedVotes = vm.votes;
        }

        function sondageDetailVoteList(question) {
            clearFlashMessage();
            $rootScope.questionId = $state.params.id;
            $state.go('app.sondage_detailVote', {id: question.id});
        }

        function goToList() {
            $state.go('app.sondage_list');
        }

        /**
         * rerender datatable
         */
        function rerender() {
            vm.dtInstance.rerender();
        }

        function editVote(vote) {
            clearFlashMessage();
            $state.go('app.vote_edit', {id: vote.id});
        }

        function voteVoteList(vote) {
            clearFlashMessage();
            $state.go('app.vote_vote', {id: vote.id});
        }

        /**
         * redirection to add new vote page
         * @param event
         */
        function addNewVote() {
            clearFlashMessage();
            $state.go('app.vote_add');
        }

        /**
         * Delete vote Confirm Dialog
         */
        function deleteVoteConfirm(vote, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "VoteLIST.delete_vote_msg",
                "VoteLIST.delete_vote_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .htmlContent('<b>' + vote.question.question + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['VoteLIST.delete_vote_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteVote(vote);
                        selectedVotes = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete vote
         */
        function deleteVote(Vote) {
            clearFlashMessage();
            if (vm.votes.indexOf(Vote) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('vote.mdelete@delete', {id: Vote.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "SONDAGELIST.dialog_alert_delete_title",
                                "SONDAGELIST.dialog_alert_delete_description",
                                "SONDAGELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Vote.question.question + translatedValues['SONDAGELIST.dialog_alert_delete_description']);
                                    vm.votes.splice(vm.votes.indexOf(Vote), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "SONDAGELIST.dialog_alert_delete_error_title",
                                "SONDAGELIST.dialog_alert_delete_error_description",
                                "SONDAGELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['SONDAGELIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['SONDAGELIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['SONDAGELIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.sondage.detailVote', ['angularMoment',"datatables"])
        .config(config);


    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.sondage_detailVote', {
                url    : "/sondage/:id/detailVote",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/sondage/detailVote/detailVote.template.html',
                        controller : 'SondageDetailVoteController as vm'
                    }
                },
                resolve: {
                    VoteListData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('voteQuestion.list@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "sondage_get_detail_action"
            });
           
        
        // Api
        var deletevoteRoute=Routing.generate('api_survey_vote_delete_vote')+"/:id";
        msApiProvider.register('voteQuestion.list', [Routing.generate('api_survey_vote_get_votes_question',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
        msApiProvider.register('vote.mdelete', [deletevoteRoute, {id: '@id'}]);
		msApiProvider.register('vote.getVote', [Routing.generate('api_survey_vote_get_vote',{id: ':id'}).replace(/%3A/,":")]);
		msApiProvider.register('vote.modalGetVote', [Routing.generate('api_survey_vote_get_vote',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
        
        



    }
})();
(function () {
    'use strict';

    angular
        .module('app.interactivity.sondage.detailVote')
        .controller('SondageDetailVoteController', SondageDetailVoteController);

    /** @ngInject */
    function SondageDetailVoteController(VoteListData, msUtils, webTvGlobal, DTOptionsBuilder, HelpGlobal, $injector, $cookies,dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.votes = angular.isDefined(VoteListData.data) ? VoteListData.data : [];
        vm.dtInstance = {};
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: [1],
                    width: '72px'
                }
            ]
            ])
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withPaginationType('full_numbers')
        ;

        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        vm.showHelp = showHelp;
        showFlasMessageToast('VoteAdd', $translate.instant('SONDAGELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('VoteEdit', $translate.instant('SONDAGELIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        function showHelp() {
            var welcome = "welcome_vote_details";
            var text = [
                {
                    texte: "arrow_button_vote_details_help"
                }, {
                    texte: "tri_column_vote_details_help"
                }];
            HelpGlobal.showHelp(text, welcome);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        /*function clearFlashMessage() {
            if (vm.flashMessages.title) {
                vm.flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }*/

        /*function showVoteDetail() {
            vm.clearFlashMessage();
            $state.go('app.sondage_detailVote');
        }*/

        /*function goToList() {
            if (angular.isDefined($rootScope.questionId)) {
                $state.go('app.sondage_vote', {id: $rootScope.questionId});
            }
            else {
                $state.go('app.sondage_list');
            }

        }*/

        /**
         * rerender datatable
         */
        function rerender() {
            vm.dtInstance.rerender();
        }

        /*function editVote(vote) {
            vm.clearFlashMessage();
            $state.go('app.vote_edit', {id: vote.id});
        }*/

        /*function voteVoteList(vote) {
            vm.clearFlashMessage();
            $state.go('app.vote_vote', {id: vote.id});
        }*/

        /**
         * redirection to add new vote page
         * @param event
         */
        /*function addNewVote() {
            vm.clearFlashMessage();
            $state.go('app.vote_add');
        }*/

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.interactivity.sondage.list')
        .controller('SondageDetailController', SondageDetailController);

    /** @ngInject */
    function SondageDetailController(SondageData,$mdDialog)
    {
    	var vm = this;
        vm.sondage = SondageData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }


    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.sondage.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.sondage_edit', {
                url    :"/sondage/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/sondage/add_edit_view/add_edit.template.html',
                        controller : 'SondageEditController as vm'
                    }
                },
                resolve: {
                     SondageData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('sondage.getSondage@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "sondage_post_edit_action"
            });


        // API
        msApiProvider.register('sondage.getSondage', [Routing.generate('api_survey_get_detail_survey',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('sondage.editSondage', [Routing.generate('api_survey_post_edit_survey',{id: ':id'}).replace(/%3A/,":"),{id: '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.interactivity.sondage.edit')
    .controller('SondageEditController', SondageEditController);

  /** @ngInject */
  function SondageEditController(webTvGlobal, $translate, msApi, $rootScope, $state, SondageData, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.sondage_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.sondage_edit_pagetitle";
      $rootScope.pageRoute = "app.sondage_list";

      $rootScope.welcome = "welcome_sondage_edit";
      $rootScope.text = [{
        texte: "parameters_sondage_add_help"
      }, {
        texte: "send_button_sondage_edit_help"
      }, {
        texte: "cancel_button_sondage_add_help"
      },{
        texte: "parameters_sondage_add_question_help"
      },{
        texte: "parameters_sondage_delete_question_help"
      }];
    }

    var vm = this;
    vm.isNew = false;

    $rootScope.itemName = "";
    var sondage = SondageData;
    vm.empSondageError = [];

    /**
     collection
     */
    var counter = 0;
    vm.questionelemnt = (function (data) {
      for (var i = 0; i < sondage.questions.length; i++) {
        data.push({
          nsp: sondage.questions[i].nsp,
          question: sondage.questions[i].question
        })
      }
      return data;
    })([]);

    vm.addFormField = function ($event) {
      counter++;
      vm.questionelemnt.push({
        question: '',
        nsp: '1'
      });
      $event.preventDefault();
    };

    vm.showitems = function () {
      $('#displayitems').css('visibility', 'none');
    };

    /**
     * return to Sondage list page
     * @return redirect to Sondage list page
     */
    function goToList() {
      $state.go('app.sondage_list');
    }

    vm.submitAddSondageForm = submitAddSondageForm;
    vm.deleteQuestion = deleteQuestion;
    vm.goToList = goToList;
    fillData();

    /**
     * Check if Sondage exists
     * @return if exists get Sondage Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(sondage.code) && sondage.code !== 200) $state.go('app.error_404');
      else {
        vm.empSondageForm = {
          name: sondage.name,
          questions: vm.questionelemnt
        };
        $rootScope.itemName = sondage.name || '';
      }
    }

    /**
     * Send add Sondage Form
     */
    function submitAddSondageForm() {
      $rootScope.loadingProgress = true;
      msApi.request('sondage.editSondage@save',
        {id: sondage.id, "empSondageForm": angular.copy(vm.empSondageForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            sondage = vm.empSondageForm;
            webTvGlobal.$flashMessages().set('SondageEdit', {title: vm.empSondageForm.name ? vm.empSondageForm.name : ""});
            $state.go('app.sondage_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


            vm.empSondageError = [];

            errors.forEach(function (item) {
              vm.empSondageError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empSondageForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

              webTvGlobal.alertDialog(message);
            }), function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            };
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }

          vm.selectedSondages = [];
        }
      );
    }

    /**
     * delete question
     * @param $index
     */
    function deleteQuestion($index) {
      vm.questionelemnt.splice($index, 1);
      vm.delete_question_is_not_pristine = true;

    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity.sondage.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.sondage_add', {
                url    : "/sondage/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/interactivity/sondage/add_edit_view/add_edit.template.html',
                        controller : 'SondageAddController as vm'
                    }
                },
                resolve: {
                     SondageData: function (msApi)
                    {
						return msApi.resolve('sondage.getNewSondageData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "sondage_post_add_action"
            });

       
        //API
		msApiProvider.register('sondage.getNewSondageData', [Routing.generate('api_survey_get_detail_survey',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('sondage.addSondage', [Routing.generate('api_survey_post_add_survey')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.interactivity.sondage.add')
    .controller('SondageAddController', SondageAddController);

  /** @ngInject */
  function SondageAddController($rootScope, $translate, msApi, $state, SondageData, webTvGlobal, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.interactivity_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.sondage_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.sondage_add_menuTitle";
      $rootScope.pageRoute = "app.sondage_list";

      $rootScope.welcome = "welcome_sondage_add";
      $rootScope.text = [{
        texte: "parameters_sondage_add_help"
      }, {
        texte: "send_button_sondage_add_help"
      }, {
        texte: "cancel_button_sondage_add_help"
      },{
          texte: "parameters_sondage_add_question_help"
      },{
          texte: "parameters_sondage_delete_question_help"
      }];
    }

    var vm = this;
    vm.isNew = true;
    vm.empSondageError = [];
    /**
     collection
     */
    var counter = 0;
    vm.questionelemnt = [{
      question: '',
      nsp: '1'
    }];

    vm.addFormField = function ($event) {
      counter++;
      vm.questionelemnt.push({
        question: '',
        nsp: '1'
      });
      $event.preventDefault();
    };

    vm.showitems = function () {
      $('#displayitems').css('visibility', 'none');
    };
    var sondage = SondageData;
    vm.empSondageForm = {
      name: sondage.name,
      questions: vm.questionelemnt
    };

    vm.submitAddSondageForm = submitAddSondageForm;
    vm.deleteQuestion = deleteQuestion;

    /**
     * Send add Sondage Form
     */
    function submitAddSondageForm() {
      $rootScope.loadingProgress = true;
      msApi.request('sondage.addSondage@save',
        {"empSondageForm": angular.copy(vm.empSondageForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            sondage = vm.empSondageForm;
            webTvGlobal.$flashMessages().set('SondageAdd', {title: vm.empSondageForm.name ? vm.empSondageForm.name : ""});
            $state.go('app.sondage_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


            vm.empSondageError = [];

            errors.forEach(function (item) {
              vm.empSondageError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empSondageForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

              webTvGlobal.alertDialog(message);
            }), function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            };
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }

          vm.selectedSondages = [];
        }
      );
    }

    /**
     * delete question
     * @param $index
     */
    function deleteQuestion($index) {
      vm.questionelemnt.splice($index, 1)

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.classifying.theme.list', ["datatables","ngclipboard"])
        .config(config);

  

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.parameters_theme_list', {
                url: "/classifying/theme/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/classifying/theme/list/list.template.html',
                        controller: 'parametersThemeListController as vm'
                    }
                },
                resolve: {
                    parametersThemeListData: function (msApi) {
                        return msApi.resolve('parameters_theme.list@get');
                    }
                },

                "bodyClass": "e-commerce",
                "actionPermission" : "parameters_theme_list_dtable_action"
            });

        // Api
        var deleteThemeRoute = Routing.generate('api_parameters_delete_theme') + "/:id";
        var deleteListThemes = Routing.generate('api_multi_delete_multi_parameters_themes') + "/:list";
        msApiProvider.register('parameters_theme.list', [Routing.generate('api_parameters_get_sort_themes')]);
        msApiProvider.register('parameters_theme.mdelete', [deleteThemeRoute, {id: '@id'}]);
        msApiProvider.register('parameters_theme.deleteThemes', [deleteListThemes, {list: '@list'}]);
        msApiProvider.register('parameters_theme.modalGetTheme', [Routing.generate('api_parameters_get_detail_theme', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_theme.getExportLinks', [Routing.generate('api_parameters_get_export_links', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_theme.dtable', [Routing.generate('api_dtable_list_dtable_parameters_themes')]);
        msApiProvider.register('parameters_theme.edit_sort', [Routing.generate('api_parameters_edit_sort_themes')]);




    }
})();

(function () {
    'use strict';

    angular
        .module('app.classifying.theme.list')
        .controller('parametersThemeListController', parametersThemeListController);

    /** @ngInject */
    function parametersThemeListController(parametersThemeListData, $injector, $scope,msUtils, $mdDialog, dtable_language, $cookies, $translate, msApi, $rootScope, $state, DTOptionsBuilder, webTvGlobal,$http) {
        var vm = this;
        vm.partentIdPlaceHolder = "THEMEADD.form_placeholder_parentId";
        vm.themes = parametersThemeListData.data.themes;
        //Data Table options
        vm.selectedThemes = [];
        var ids = [];
        var $sce = $injector.get("$sce");

        vm.dtInstance = {};
        vm.isGV = isGV;
        vm.dtOptions = {
            dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
            columnDefs: [
                {
                    // Target the id column
                    targets: [0],
                    width: '72px',
                    sortable: false


                },
                {
                    // Target the image column
                    targets: 1,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                  },
               {
                  // Target the image column
                  targets: [2,3,4],
                  filterable: false,
                  sortable: false
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ],
            initComplete: function () {
                var api = this.api(),
                    searchBox = angular.element('body').find('#themes-search');

                // Bind an external input as a table wide search box
                if (searchBox.length > 0) {
                    searchBox.on('keydown keypress', function (event) {
                      if (event.which === 13){
                        api.search(event.target.value).draw();
                      }
                    });
                }
            },
            pagingType: 'full_numbers',
            lengthMenu: [10, 20, 30, 50, 100],
            pageLength: 10,
            scrollY: 'auto',
            responsive: true,
            deferRender: false,
            language: dtable_language[$cookies.get('WEBTV.locale')]

        };
        $rootScope.mahmoud=false;
        $rootScope.DtOptions = vm.dtOptions;
        
        vm.sortableOptions = {
            items: '>tr',
            handle: '> .myHandleCursor',
            update: function (e, ui) {
                var length = vm.dtInstance.dataTable.fnSettings()._iDisplayLength;
                var currentPage = vm.dtInstance.DataTable.page();
                var initInterval = currentPage * length;

                for (var i = 0; i < initInterval; i++) {
                    ids[i] = vm.themes[i].id;
                }

                angular.element('table tbody tr').each(function (index) {
                    ids[initInterval + index] = parseInt(angular.element(this)[0].getAttribute('data-index'));

                });

                for (var j = initInterval + length; j < vm.themes.length; j++) {
                    ids[j] = vm.themes[j].id;
                }
                msApi.request('parameters_theme.edit_sort@get', {ids: [ids]}, function () {

                }, function () {
                    ui.item.sortable.cancel();
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                })
            },
            stop: function () {
            }
        };
        var filtre = {};

        vm.deleteThemeConfirm = deleteThemeConfirm;
        vm.deleteTheme = deleteTheme;
        vm.toogleSelection = toogleSelection;
        vm.toggleSelectTheme = toggleSelectTheme;
        vm.deselectThemes = deselectThemes;
        vm.selectAllThemes = selectAllThemes;
        vm.showThemeDetail = showThemeDetail;
        vm.rerender = rerender;
        vm.editTheme = editTheme;
        vm.addNewTheme = addNewTheme;
        vm.getExportLinks = getExportLinks;
        $rootScope.rerender = rerender;
        vm.flashMessages = {title: ""};
        vm.checkFlashMessage = checkFlashMessage;
        vm.clearFlashMessage = clearFlashMessage;
        vm.showFlasMessageToast = showFlasMessageToast;
        vm.exportYoutube = exportYoutube;

        vm.showFlasMessageToast('parametersThemeAdd', $translate.instant('THEMELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        vm.showFlasMessageToast('parametersThemeEdit', $translate.instant('THEMELIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (vm.flashMessages.title ? (" : " + vm.flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }
        vm.isNewTheme = false;
        if (window.process.env.isNew_class_theme) {
          vm.isNewTheme = window.process.env.isNew_class_theme;
        }
        function checkRedirectTheme (){
            window.addEventListener("message",function(event){
                console.log("event in redirect Theme",event)
                if(event.data.info === "redirect_theme"){
                    this.document.querySelector("#titre3").innerText = $translate.instant("PAGESMENUSTITLES.parameters_theme_" + event.data.value)
                    $rootScope.titre3 = $translate.instant("PAGESMENUSTITLES.parameters_theme_" + event.data.value)
                }
            })
        }
        checkRedirectTheme()
        if (vm.isNewTheme){
          $scope.ThemeIframe = $sce.trustAsResourceUrl(
            "https:" + window.process.env.URL_Classement + "/themes?lang="+$cookies.get('WEBTV.locale') +"&token="+$cookies.get("authToken")+"&embedded=true"
          );
          $scope.$watch(
            function () {
              $scope.ThemeIframe = $sce.trustAsResourceUrl(
                "https:" + window.process.env.URL_Classement + "/themes?lang="+$cookies.get('WEBTV.locale') +"&token="+$cookies.get("authToken")+"&embedded=true"
              );
              return $cookies.get("WEBTV.locale");
            },
            function (newValue) {}
          );
        }

        function  exportYoutube(theme,ev) {
            console.log('theme---',theme)
           new Promise(function (resolve, reject) {
               $http({
                   url:"https://dev-beta.webtv-solution.com:7009/add-section/",
                   method: "POST",
                   params: {
                       section_type: theme.type !== null ? theme.type : ""  ,
                       section_title: theme.title
                   },
               }).then(
                   function (res) {
                   resolve(res)
                   console.log("res----",res)
                  },
                   function (error) {
                   console.log("error----",error)
                   }
               )
           })
        }
        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!vm.flashMessages.title) vm.flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (vm.flashMessages.title) {
                vm.flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the theme
         *
         * @param theme
         * @param event
         */
        function toggleSelectTheme(theme, event) {
            if (event) {
                event.stopPropagation();
            }

            if (vm.selectedThemes.indexOf(theme) > -1) {
                vm.selectedThemes.splice(vm.selectedThemes.indexOf(theme), 1);
            }
            else {
                vm.selectedThemes.push(theme);
            }
        }

        /**
         * Toggle selected status of all the themes
         *
         * @param event
         */
        function toogleSelection(event) {
            if (event) {
                event.stopPropagation();
            }
            if (vm.selectedThemes.length === vm.themes.length) vm.deselectThemes();
            else vm.selectAllThemes()
        }

        /**
         * Deselect Themes
         */
        function deselectThemes() {
            vm.selectedThemes = [];
        }

        /**
         * Select all Themes
         */
        function selectAllThemes() {
            vm.selectedThemes = vm.themes;
        }

        /**
         * Show Theme Details
         * @param theme
         */
        function showThemeDetail(theme, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;
            vm.has_mooc = false;

            msApi.request('parameters_theme.modalGetTheme@get', {id: theme.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {parametersThemeData: response},
                            templateUrl: 'app/main/classifying/theme/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: function (parametersThemeData, $mdDialog) {
                                var vm = this;
                                vm.theme = parametersThemeData;
                                vm.cancel = cancel;
                                vm.isGV = isGV;
                                if (webTvGlobal.$constant().webTvParameterBag().has_mooc == "1") {
                                    vm.has_mooc = true;

                                }

                                function cancel() {
                                    $mdDialog.hide();
                                }
                            },
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }

        /**
         * rerender datatable
         */
        function rerender() {
            vm.dtInstance.rerender();
        }

        function editTheme(theme) {
            vm.clearFlashMessage();
            $state.go('app.parameters_theme_edit', {id: theme.id});
        }

        /**
         * redirection to add new theme page
         * @param event
         */
        function addNewTheme() {
            vm.clearFlashMessage();
            $state.go('app.parameters_theme_add');
        }

        /**
         * Delete Theme Confirm Dialog
         */
        function deleteThemeConfirm(Theme, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "THEMELIST.delete_theme_msg",
                "THEMELIST.delete_theme_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['THEMELIST.delete_theme_msg'])
                        .htmlContent('<b>' + Theme.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['THEMELIST.delete_theme_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteTheme(Theme);
                        vm.selectedThemes = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete Theme
         */
        function deleteTheme(Theme) {
            clearFlashMessage();
            if (vm.themes.indexOf(Theme) !== -1) {
                $rootScope.loadingProgress = true;
                 new Promise(function(resolve, reject){
                    msApi.request('parameters_theme.mdelete@delete', {id: Theme.id}).then(
                    function (response) {
                        resolve(response)
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "THEMELIST.dialog_alert_delete_title",
                                "THEMELIST.dialog_alert_delete_description",
                                "THEMELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Theme.title + translatedValues['THEMELIST.dialog_alert_delete_description']);
                                    $state.reload();
                                });

                        }
                        else {
                            $translate([
                                "THEMELIST.dialog_alert_delete_error_title",
                                "THEMELIST.dialog_alert_delete_error_description",
                                "THEMELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['THEMELIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['THEMELIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['THEMELIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (error) {
                        $rootScope.loadingProgress = false;
                        if (error.data.code === 400 || error.status===400 ) {
                            $translate([
                                "THEMELIST.dialog_alert_failed_delete_title",
                                "THEMELIST.dialog_alert_failed_delete_description",
                                "THEMELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Theme.title + translatedValues['THEMELIST.dialog_alert_failed_delete_description']);
                                });
                        }else{
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                    }
                    )
            })

            }


        }

        function getExportLinks(theme, $ev) {
            msApi.request('parameters_theme.getExportLinks@get', {id: theme.id},
                function (res) {
                    $mdDialog.show({
                        controller: function (entity, links, $mdDialog) {
                            var vm = this;
                            vm.theme = entity;
                            vm.links = links;
                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/classifying/theme/list/url.modale.template.html',
                        targetEvent: $ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: theme,
                            links: res.links
                        }
                    });
                },
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
                        $translate('VALIDATIONS.' + res.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
            $rootScope.titre2 = isGV ? "PAGESMENUSTITLES.parameters_rubric_menuTitle" : "PAGESMENUSTITLES.parameters_theme_menuTitle";
            $rootScope.titre3 = isGV ? "PAGESMENUSTITLES.parameters_rubric_list_pagetitle" : "PAGESMENUSTITLES.parameters_theme_list_pagetitle";
            $rootScope.pageRoute = "";
            $rootScope.pageRetour = "app.parameters_theme_list";

            $rootScope.welcome = "welcome_theme";
            $rootScope.text = [{
                texte: "add_button_theme_help"
            }, {
                texte: "arrow_button_theme_help"
            }, {
                texte: "search_area_theme_help"
            }, {
                texte: "tri_column_theme_help"
            },
                {
                    texte: "edit_button_theme_help"
                }, {
                    texte: "detail_button_theme_help"
                },
                {
                    texte: "delete_button_theme_help"
                }, {texte: "export_button_theme_help"}];
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.classifying.theme.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider)
    {
        // State
        $stateProvider
            .state('app.parameters_theme_add', {
                url    : "/classifying/theme/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/classifying/theme/add_edit_view/form.template.html',
                        controller : 'parametersThemeAddController as vm'
                    }
                },
                resolve: {
                    channelChoices: function (msApi)
                    {
                        return msApi.resolve('channel.channelChoices@get');
                    },
                    themeChoices: function (msApi)
                    {
                        return msApi.resolve('parameters_theme.themeChoices@get',{idToIgnore:0});
                    },
                    parametersThemeData: function (msApi)
                    {
                        return msApi.resolve('parameters_theme.getNewThemeData@get',{id:0});
                    },
                    parametersThemesByChannelsAndParent: function (msApi) {
                        return msApi.resolve('parameters_theme.getThemesByChannelsAndParent@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "parameters_theme_post_add_action"
            })
            /*.state('app.parameters_theme_detail',{
                url: Routing.generate('emp_video_settings_theme_detail')+"/:id"
            })*/;


        //API
        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_grouped_by_themes') + "/:list";
        msApiProvider.register('channel.channelChoices',[Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('parameters_theme.themeChoices',[Routing.generate('api_parameters_get_themes_choices_for_select_input',{idToIgnore: ':idToIgnore'}).replace(/%3A/,":")]);
        msApiProvider.register('parameters_theme.getParentsIds', [Routing.generate('api_parameters_get_themes_ids')]);
        msApiProvider.register('parameters_theme.getNewThemeData', [Routing.generate('api_parameters_get_detail_theme',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('parameters_theme.addTheme', [Routing.generate('api_parameters_post_add_theme')]);
        msApiProvider.register('parameters_theme.getThemeForCanal', [Routing.generate('api_parameters_get_detail_theme', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_theme.getThemesByChannelsAndParent', [themesByChannelsAndParent, {list: '@list'}]);






    }
})();

(function () {
  'use strict';

  angular
    .module('app.classifying.theme.add')
    .controller('parametersThemeAddController', parametersThemeAddController);

  /** @ngInject */
  function parametersThemeAddController(channelChoices,$cookies, themeChoices, parametersThemeData, webTvGlobal, $injector, parametersThemesByChannelsAndParent) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msUtils = $injector.get('msUtils'),
      msApi = $injector.get('msApi');

    var vm = this;
    vm.isNew = true;
    var imageName;
    vm.urlVignette = "";
    vm.has_mooc=false;
if(webTvGlobal.$constant().webTvParameterBag().has_mooc=="1")
{
    vm.has_mooc=true;


}


    vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });

    vm.orderChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_title": "title",
      "form_choices_videodate": "VideoDate"
    });

      vm.typethemes = webTvGlobal.convertToSelectChoicesFormat({
          "form_type_visa": "visa",
          "form_type_Passport": "passport"
      });


    vm.empParametersThemeError = [];
    var themes = webTvGlobal.convertToSelectChoicesFormatWithNull(themeChoices.choices);
    var listThemes = parametersThemesByChannelsAndParent;
    var themeListBefore = [];

    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    vm.theme = parametersThemeData;
    vm.empParametersThemeForm = {
      title: vm.theme.title,
      parent: vm.theme.parent || "",
      channels: vm.theme.channels || [],
      description: vm.theme.description,
      type: vm.theme.type,
      visible: vm.theme.visible ? 1 : 0,
      classifiedBy: vm.theme.classifiedBy,
      logo: vm.theme.logo || ""
    };

    vm.submitAddThemeForm = submitAddThemeForm;
    // vm.returnToList = returnToList;


    //FILE PARAMETERS DEFINITION AND FUNCTIONS
    // vm.files = [];
    vm.ngFlowOptions = {
      chunkSize: (function () {
        return Math.pow(10, 8);
      })(),
      allowDuplicateUploads: true,
      target: Routing.generate('api_parameters_post_theme_thumb'),
      singleFile: true,
      testChunks: false,
      extendChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.changeCanal = changeCanal;
    vm.clicked = clicked;
    vm.isGV=isGV;
    loadThemes();


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
      $rootScope.titre2 = isGV ? "PAGESMENUSTITLES.parameters_rubric_menuTitle" : "PAGESMENUSTITLES.parameters_theme_menuTitle";
      $rootScope.titre3 = isGV ? "PAGESMENUSTITLES.parameters_rubric_add_menuTitle" : "PAGESMENUSTITLES.parameters_theme_add_menuTitle";
      $rootScope.pageRoute = "app.parameters_theme_list";
      $rootScope.welcome = "welcome_theme_add";
      $rootScope.text = [{
        texte: "parameters_theme_add_help"
      }, {
        texte: "send_button_theme_add_help"
      }, {
        texte: "cancel_button_theme_add_help"
      }];
    }

    // /**
    //  * return to theme list page
    //  * @return redirect to theme list page
    //  */
    // function returnToList() {
    //     $state.go('app.parameters_theme_list');
    // }


    /**
     * Send add Theme Form
     */
    function submitAddThemeForm() {
      $rootScope.loadingProgress = true;
      if (vm.empParametersThemeForm.parent === 0) delete vm.empParametersThemeForm.parent;
      msApi.request('parameters_theme.addTheme@save',
        {"empParametersThemeForm": angular.copy(vm.empParametersThemeForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.theme = vm.empParametersThemeForm;
            webTvGlobal.$flashMessages().set('parametersThemeAdd', {title: vm.empParametersThemeForm.title ? vm.empParametersThemeForm.title : ""});
            $state.go('app.parameters_theme_list');

          }
          else if (angular.isDefined(res.errors)) {

            vm.empParametersThemeError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empParametersThemeError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersThemeForm[item.for])
              };
            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersThemeForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function clicked() {
      vm.btnClicked = true;

    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location) {
        vm.empParametersThemeForm.logo = vm.theme.logo = res.location.path;
        vm.urlVignette = res.location.url;
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {
        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empParametersThemeForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empParametersThemeForm.logo = "";
        });
      }
    }

    function loadThemes() {
      vm.themesList = themes;
      // angular.forEach(listThemes.channels, function (value) {
      //     if (value.themes.length > 0) {
      //
      //         angular.forEach(value.themes, function (v) {
      //             themeListBefore.push(v);
      //
      //         });
      //
      //     }
      //
      // });
      //
      // var result = themeListBefore.reduce(function (map, obj) {
      //     map[obj.title] = obj.id;
      //     return map;
      // }, {});
      //
      // vm.themesList = webTvGlobal.convertToSelectChoicesFormatWithNull(result);

    }

    function changeCanal() {

      if (angular.isDefined(vm.empParametersThemeForm.channels) && vm.empParametersThemeForm.channels.length > 0) {

        themeListBefore = [{id: null,
            themeid: null,
            themeparentid: null,
            themetitle: "Aucun"}];
        for (var i = 0; i <= vm.empParametersThemeForm.channels.length; i++) {

          angular.forEach(listThemes.channels, function (value) {

            if (value.themes.length > 0 && vm.empParametersThemeForm.channels[i] === value.id) {

              angular.forEach(value.themes, function (v) {
                themeListBefore.push(v);

              });

            }

          });
        }

        var result = themeListBefore.reduce(function (map, obj) {
          map[obj.themetitle] = obj.themeid;
          return map;
        }, {});
        vm.themesList = webTvGlobal.convertToSelectChoicesFormat(result);
      }
      else {
        loadThemes();
      }


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.classifying.theme.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.parameters_theme_edit', {
                url: "/classifying/theme/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/classifying/theme/add_edit_view/form.template.html',
                        controller: 'parametersThemeEditController as vm'
                    }
                },
                resolve: {
                    channelChoices: function (msApi) {
                        return msApi.resolve('parameters_theme.channelChoices@get');
                    },
                    themeChoices: function (msApi, $stateParams) {
                        return msApi.resolve('parameters_theme.themeChoices@get', {idToIgnore: $stateParams.id});
                    },
                    parametersThemeData: function (msApi, $stateParams) {
                        return msApi.resolve('parameters_theme.getTheme@get', {id: $stateParams.id});
                    },
                    parametersThemesByChannelsAndParent: function (msApi) {
                        return msApi.resolve('parameters_theme.getThemesByChannelsAndParent@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "parameters_theme_post_edit_action"
            });


        // API
        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_grouped_by_themes') + "/:list";
        msApiProvider.register('parameters_theme.getThemesByChannelsAndParent', [themesByChannelsAndParent, {list: '@list'}]);
        msApiProvider.register('parameters_theme.getParentsIds', [Routing.generate('api_parameters_get_themes_ids')]);
        msApiProvider.register('parameters_theme.getTheme', [Routing.generate('api_parameters_get_detail_theme', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_theme.editTheme', [Routing.generate('api_parameters_post_edit_theme', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.classifying.theme.edit')
    .controller('parametersThemeEditController', parametersThemeEditController);

  /** @ngInject */
  function parametersThemeEditController($scope,$cookies, webTvGlobal, channelChoices, themeChoices, parametersThemeData, parametersThemesByChannelsAndParent, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');

    var vm = this;
    var imageName;
    vm.isNew = false;
    vm.empParametersThemeError = [];
    $rootScope.itemName = "";
    vm.urlVignette = "";
    vm.isGV=isGV;

    var themes = webTvGlobal.convertToSelectChoicesFormatWithNull(themeChoices.choices);
    var listThemes = parametersThemesByChannelsAndParent;
    var themeListBefore = [];
    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    vm.visibilityChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });
    vm.orderChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_title": "title",
      "form_choices_videodate": "VideoDate"
    });
      vm.typethemes = webTvGlobal.convertToSelectChoicesFormat({
          "form_type_visa": "visa",
          "form_type_Passport": "passport"
      });
      vm.has_mooc=false;

      if(webTvGlobal.$constant().webTvParameterBag().has_mooc=="1")
      {
          vm.has_mooc=true;


      }
    vm.theme = parametersThemeData;
    vm.empParametersThemeForm = {};
    vm.submitAddThemeForm = submitAddThemeForm;
    // vm.returnToList = returnToList;
    fillData();
    vm.ngFlowOptions = {
      target: Routing.generate('api_parameters_post_theme_thumb'),
      singleFile: true,
      testChunks: false,
      fileParameterName: 'empApiFileForm[thumb]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}
      //attributes: 'image/*',
      //testMethod: false,

    };
    if (/chrome/.test(msUtils.detectBrowser().browser)) vm.ngFlowOptions.attributes = 'image/*';
    vm.ngFlow = {
      // ng-flow will be injected into here through its directive
      flow: {}
    };

    // Methods
    vm.fileAdded = fileAdded;
    vm.uploadFile = uploadFile;
    vm.fileSuccess = fileSuccess;
    vm.uploadComplete = uploadComplete;
    vm.changeCanal = changeCanal;
    loadThemes();

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
      $rootScope.titre2 = isGV ?   "PAGESMENUSTITLES.parameters_rubric_menuTitle" : "PAGESMENUSTITLES.parameters_theme_menuTitle";
      $rootScope.titre3 =isGV ? "PAGESMENUSTITLES.parameters_rubric_edit_pagetitle" : "PAGESMENUSTITLES.parameters_theme_edit_pagetitle"  ;
      $rootScope.pageRoute = "app.parameters_theme_list";

      $rootScope.welcome = "welcome_theme_edit";
      $rootScope.text = [{
        texte: "parameters_theme_add_help"
      }, {
        texte: "send_button_theme_edit_help"
      }, {
        texte: "cancel_button_theme_add_help"
      }];
    }

    /**
     * Check if theme exists
     * @return if exists get Theme Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(vm.theme.code) && vm.theme.code !== 200) $state.go('app.error_404');
      else {

        vm.empParametersThemeForm = {
          title: vm.theme.title,
          parent: angular.isObject(vm.theme.parent) && angular.isDefined(vm.theme.parent.id) ? vm.theme.parent.id : "",
          channels: (function (list, data) {
            for (var i = 0; i < data.length; i++) {
              list.push(data[i].id);
            }
            return list;
          })([], vm.theme.channels),
            type:vm.theme.type,
          description: vm.theme.description,
          visible: vm.theme.visible ? 1 : 0,
          classifiedBy: vm.theme.classifiedBy,
          logo: vm.theme.logo
        };
        $rootScope.itemName = vm.theme.title || '';
      }
    }

    // /**
    //  * return to theme list page
    //  * @return redirect to theme list page
    //  */
    // function returnToList() {
    //     $state.go('app.parameters_theme_list');
    // }
    //

    /**
     * Send add Theme Form
     */
    function submitAddThemeForm() {
      if (vm.empParametersThemeForm.parent === 0) delete vm.empParametersThemeForm.parent;
      $rootScope.loadingProgress = true;
      msApi.request('parameters_theme.editTheme@save',
        {id: vm.theme.id, "empParametersThemeForm": angular.copy(vm.empParametersThemeForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            vm.theme = vm.empParametersThemeForm;
            webTvGlobal.$flashMessages().set('parametersThemeEdit', vm.theme);
            $state.go('app.parameters_theme_list');
          }
          else if (angular.isDefined(res.errors)) {
            vm.empParametersThemeError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empParametersThemeError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersThemeForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(file) {
      if (!/(jpg|jpeg|png|gif)$/.test(file.getExtension().toLowerCase())) {
        imageName = false;
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_image_message'));
        return false;
      }
      imageName = file.name;
      $rootScope.loadingProgress = true;
      angular.element('#file-uploader').find("button").attr('disabled', 'disabled');
      angular.element("<span>").addClass('file-name').html(file.name).appendTo('#file-uploader');
      angular.element("#empParametersThemeForm button[type='submit']").hide();
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function uploadFile() {
      // Set headers
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
    }

    /**
     * File upload success callback
     * Triggers when single upload completed
     *
     * @param file
     * @param message
     */
    function fileSuccess(file, message) {
      var res = angular.fromJson(message);
      if (res.location) {
        vm.empParametersThemeForm.logo = vm.theme.logo = res.location.path;
        vm.urlVignette = res.location.url;
      }

    }

    /**
     * File Upload complete callback
     * triggers when upload operation : succes or error or not valid
     */
    function uploadComplete() {
      if (imageName) {

        angular.element('#file-uploader').find("button").removeAttr('disabled');
        angular.element('#file-uploader').find(".file-name").remove();
        angular.element("#empParametersThemeForm button[type='submit']").show();
        $rootScope.loadingProgress = false;
        vm.loadComplete = true;
        $scope.empParametersThemeForm.$pristine = false;
        empParametersThemeForm.$invalid = false;
        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: imageName}), '', function () {
          vm.empParametersThemeForm.logo = "";
        });
      }
    }

    function loadThemes() {
      vm.themesList = themes;
      // angular.forEach(listThemes.channels, function (value) {
      //     if (value.themes.length > 0) {
      //
      //         angular.forEach(value.themes, function (v) {
      //             themeListBefore.push(v);
      //
      //         });
      //
      //     }
      //
      // });
      //
      // var result = themeListBefore.reduce(function (map, obj) {
      //     map[obj.title] = obj.id;
      //     return map;
      // }, {});
      //
      // vm.themesList = webTvGlobal.convertToSelectChoicesFormatWithNull(result);

    }

    function changeCanal() {

      if (angular.isDefined(vm.empParametersThemeForm.channels) && vm.empParametersThemeForm.channels.length > 0) {

          themeListBefore = [{id: null,
              themeid: null,
              themeparentid: null,
              themetitle: "Aucun"}];
        for (var i = 0; i <= vm.empParametersThemeForm.channels.length; i++) {

          angular.forEach(listThemes.channels, function (value) {
            if (value.themes.length > 0 && vm.empParametersThemeForm.channels[i] === value.id) {

              angular.forEach(value.themes, function (v) {
                themeListBefore.push(v);
              });
            }

          });
        }

        var result = themeListBefore.reduce(function (map, obj) {
          if (vm.theme.id != obj.themeid)
            map[obj.themetitle] = obj.themeid;
          return map;
        }, {});
        vm.themesList = webTvGlobal.convertToSelectChoicesFormat(result);
      }
      else {
        loadThemes();
      }


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.classifying.canal.list', ['datatables','ngclipboard'])
        .config(config);

  
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.parameters_canal_list', {
                url: "/classifying/canal/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/classifying/canal/list/list.template.html',
                        controller: 'parametersCanalListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "parameters_canal_list_dtable_action"
            });


        // Api
        var deleteCanalRoute = Routing.generate('api_parameters_delete_channel') + "/:id";
        var deleteListCanals = Routing.generate('api_multi_delete_multi_parameters_channels') + "/:list";
        msApiProvider.register('parameters_canal.list_data_table', [Routing.generate('api_dtable_list_dtable_parameters_channels')]);
        msApiProvider.register('parameters_canal.list', [Routing.generate('api_parameters_get_channels')]);
        msApiProvider.register('parameters_canal.deleteCanals', [deleteListCanals, {list: '@list'}]);
        msApiProvider.register('parameters_canal.mdelete', [deleteCanalRoute, {id: '@id'}]);
        msApiProvider.register('parameters_canal.modalGetCanal', [Routing.generate('api_parameters_get_detail_channel', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('parameters_channel.getUrlExport', [Routing.generate('api_parameters_get_url_export_channel') + "/:id", {id: '@id'}]);
        msApiProvider.register('parameters_channel.get_storage_servers_by_channel', [Routing.generate('api_configuration_get_storage_servers_by_channel') + "/:id", {id: '@id'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.classifying.canal.list')
        .controller('parametersCanalListController', parametersCanalListController);

    /** @ngInject */
    function parametersCanalListController($injector, $scope,  $cookies, $compile, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, order_channel, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $filter = $injector.get('$filter'),
            $document = webTvGlobal.$document;
        var $sce = $injector.get("$sce");
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var columnsApi = order_channel;
        //Data Table options
        vm.canals = [];
        vm.selectedCanals = [];
        var selectedCanals = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.canalsDataTable = {};
        vm.canalsServerDataTable = {};
        vm.search_canals = "";
        vm.getElement = getElement;


        vm.isNewCanal = false;
        if (window.process.env.isNew_class_canal) {
          vm.isNewCanal = window.process.env.isNew_class_canal;
        }
    if (vm.isNewCanal){
      $scope.CanalIframe = $sce.trustAsResourceUrl(
        "https:" + window.process.env.URL_Classement + "/channels?lang="+$cookies.get('WEBTV.locale') +"&token="+$cookies.get("authToken")
      );
      $scope.$watch(
        function () {
          $scope.CanalIframe = $sce.trustAsResourceUrl(
            "https:" + window.process.env.URL_Classement + "/channels?lang="+$cookies.get('WEBTV.locale') +"&token="+$cookies.get("authToken")
          );
          return $cookies.get("WEBTV.locale");
        },
        function (newValue) {}
      );
    }
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the checkbox column
                    targets: 0,
                    responsivePriority: 1
                },
                {
                    // Target the id column
                    targets: [1],
                    width: '72px'
                },

                {
                    // Target the actions column
                    targets: 6,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');

        $rootScope.DtOptions = vm.dtOptions;

        function searchCanalsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('parameters_canal.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.canals = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else if (angular.isDefined(response.errors)) {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.canals = [];

                        var errors = response.errors;
                        errors.forEach(function (item) {
                            $translate('VALIDATION.' + item.messages[0]).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });


                        });
                        vm.fnCallback(records);
                    }
                    else {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.canals = [];

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.canals = [];
                    vm.fnCallback(records);
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];

            vm.selectedCanals = [];
            selectedCanals = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_canals,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;

            vm.fnCallback = fnCallback;
            searchCanalsInAPI(filtre);
        }


        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('searchable', false).withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.canalsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.canalsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.canalsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('title').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('language')
                .renderWith(function (data) {
                    var language;
                    if (data === "") {
                        language = '<strong style="text-transform: capitalize;" translate="LANGUAGES.Names.Null"></strong> '
                    } else {
                        language = '<strong style="text-transform: capitalize;" translate="LANGUAGES.Names.' + data + '"></strong> '
                    }
                    return language;
                }).withOption('defaultContent', ''),
            DTColumnBuilder.newColumn("servers").notSortable()
                .renderWith(function (data, type, full) {

                    vm.canalsServerDataTable[full.id] = data;
                    var serverHtml = "";
                    if (data.length === 0) {
                        var none = $filter('translate')('MESSAGES.none');
                        serverHtml += '<Any style="text-transform: capitalize; font-weight: bold " translate="MESSAGES.none">' + none + '</Any>';
                    }
                    else {
                        serverHtml += '<div>';
                        angular.forEach(vm.canalsServerDataTable[full.id], function (value) {
                            serverHtml += '<span>  - ' + value.name + ' </span></br>';
                        });
                        serverHtml += '</div>';
                    }

                    return serverHtml;
                }).withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('quota').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.canalsDataTable[data.id] = data;
                    var buttonDetailServeur = "";
                    if (data.servers.length > 0) {
                        buttonDetailServeur = '<a has-permission="parameters_canal_get_storage_servers" tooltips tooltip-template=' + "{{'MESSAGES.stockage_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="md-icon-button"  ng-click="vm.showDetailStockage(vm.canalsDataTable[' + data.id + '],$event,' + data.id + ')" ' +
                            'aria-label="stockage_detail" translate translate-attr-aria-label="MESSAGES.stockage_detail">' +
                            '<md-icon md-font-icon="icon-floppy" class="s18"></md-icon>' +
                            '</md-button></a>';
                    }
                    var buttonExport = '<a has-permission="parameters_canal_get_url_export" tooltips tooltip-template=' + "{{'MESSAGES.export_canal'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="md-icon-button" ng-click="vm.showUrlCanal(vm.canalsDataTable[' + data.id + '],$event,' + data.id + ')" ' +
                        'aria-label="export_canal" translate translate-attr-aria-label="MESSAGES.export_canal"><md-icon md-font-icon="icon-link-variant" class="s18"></md-icon>' +
                        '</md-button></a>';

                    var buttonActionDetailHtml =
                        '<a has-permission="parameters_canal_get_detail" tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showCanalDetail(vm.canalsDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a has-permission="parameters_canal_post_edit" tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.parameters_canal_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a has-permission="parameters_canal_delete_channel" tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteCanalConfirm(vm.canalsDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button>';

                    return buttonExport + buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + buttonDetailServeur;

                })
        ]
        ;

        vm.deleteCanalConfirm = deleteCanalConfirm;
        vm.deleteCanal = deleteCanal;
        vm.deleteSelectedCanalsConfirm = deleteSelectedCanalsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showCanalDetail = showCanalDetail;
        vm.showUrlCanal = showUrlCanal;
        vm.showDetailStockage = showDetailStockage;
        // vm.editCanal = editCanal;
        vm.addNewCanal = addNewCanal;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        vm.searchCanals = searchCanals;
        showFlasMessageToast('parametersCanalAdd', $translate.instant('CANALLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('parametersCanalEdit', $translate.instant('CANALLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }


        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.parameters_canal_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.parameters_canal_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_canal";
            $rootScope.text = [{
                texte: "add_button_canal_help"
            }, {
                texte: "arrow_button_canal_help"
            }, {
                texte: "search_area_canal_help"
            }, {
                texte: "tri_column_canal_help"
            },
                {
                    texte: "edit_button_canal_help"
                }, {
                    texte: "detail_button_canal_help"
                },
                {
                    texte: "delete_button_canal_help"
                }, {texte: "export_button_canal_help"},
                {texte: "stockage_button_canal_help"}
                ];
        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }


        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }


        /**
         * Toggle selected status of the user
         *
         * @param canal
         */
        function toggle(canal) {
            getElement();
            canal.checked = !canal.checked;
            var idx = selectedCanals.indexOf(canal);
            if (idx > -1) {
                selectedCanals.splice(idx, 1);
            }
            else {
                selectedCanals.push(canal);
            }
            vm.selectedCanals = angular.copy(selectedCanals);
        }


        function toggleAll() {
            getElement();
            if (selectedCanals.length === vm.canals.length) {
                vm.selectedCanals = [];
            }

            else if ((selectedCanals.length === 0) || (selectedCanals.length > 0)) {
                vm.selectedCanals = vm.canals.slice(0);
            }
            selectedCanals = angular.copy(vm.selectedCanals);
            var list_canals = angular.copy(vm.canalsDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.canalsDataTable[key].checked = selectedCanals.length > 0;
            });
        }

        /**
         * Show canal Details
         * @param canal
         */
        function showCanalDetail(canal, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('parameters_canal.modalGetCanal@get', {id: canal.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {parametersCanalData: response},
                            templateUrl: 'app/main/classifying/canal/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'parametersCanalDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function showUrlCanal(canal, $ev) {
            vm.spinner = false;
            msApi.request('parameters_channel.getUrlExport@get', {id: canal.id},
                function (res) {
                    $mdDialog.show({
                        controller: function (entity, links, $mdDialog) {
                            var vm = this;
                            vm.spinner = true;
                            vm.canal = entity;
                            vm.links = links;
                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/classifying/canal/list/url.modale.template.html',
                        targetEvent: $ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: canal,
                            links: res.data
                        }
                    });
                }
                , function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        ////////////
        function showDetailStockage(canal, $ev) {
            vm.spinner = false;
            msApi.request('parameters_channel.get_storage_servers_by_channel@get', {id: canal.id},
                function (res) {
                    $mdDialog.show({
                        controller: function (entity, servers, $mdDialog) {
                            var vm = this;
                            vm.spinner = true;
                            vm.canal = entity;
                            vm.servers = servers;
                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/classifying/canal/list/serverDetail.modale.template.html',
                        targetEvent: $ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: canal,
                            servers: res.data.servers
                        }
                    });
                }
                , function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchCanalsInAPI(filtre), true);
        }


        // function editCanal(canal) {
        //     vm.clearFlashMessage();
        //     $state.go('app.parameters_canal_edit', {id: canal.id});
        // }

        /**
         * redirection to add new canal page
         * @param event
         */
        function addNewCanal() {
            clearFlashMessage();
            $state.go('app.parameters_canal_add');
        }

        /**
         * Delete Canal Confirm Dialog
         */
        function deleteCanalConfirm(canal, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "CANALLIST.delete_canal_msg",
                "CANALLIST.delete_canal_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['CANALLIST.delete_canal_msg'])
                        .htmlContent('<b>' + canal.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['CANALLIST.delete_canal_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteCanal(canal);
                        vm.selectedCanals = [];
                        selectedCanals = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete canal
         */
        function deleteCanal(canal) {
            clearFlashMessage();
            if (vm.canals.indexOf(canal) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('parameters_canal.mdelete@delete', {id: canal.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "CANALLIST.dialog_alert_delete_title",
                                "CANALLIST.dialog_alert_delete_description",
                                "CANALLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(canal.title + translatedValues['CANALLIST.dialog_alert_delete_description']);
                                    $state.reload();
                                });

                        }
                        else {
                            $translate([
                                "CANALLIST.dialog_alert_delete_error_title",
                                "CANALLIST.dialog_alert_delete_error_description",
                                "CANALLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['CANALLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['CANALLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['CANALLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                        $rootScope.loadingProgress = false;
                    }
                );

            }


        }

        /**
         * Delete selected Canals Confirm Dialog
         */
        function deleteSelectedCanalsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedCanals.length !== 0) {
                if(vm.selectedCanals.length === 1){
                    title = 'CANALLIST.delete_canal_msg';
                    ariaLabel = 'CANALLIST.delete_canal_aria_label';
                }else{
                    title = 'CANALLIST.delete_list_canal_msg';
                    ariaLabel = 'CANALLIST.delete_canals_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedCanals.length,title,ariaLabel)).then(function () {
                    deleteSelectedCanals(ev);
                }, function () {
                });

            }

        }

        /**
         * Delete Selected canals
         */
        function deleteSelectedCanals(ev) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;
            msApi.request('parameters_canal.deleteCanals@delete', {
                    list: (function (list) {
                        vm.selectedCanals.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("CANALLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("CANALLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('CANALLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedCanals = [];
                        selectedCanals = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('CANALLIST.dialog_alert_delete_error_title'),
                            $translate.instant('CANALLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedCanals = [];
                        selectedCanals = [];

                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }


                    vm.selectedCanals = [];
                    vm.modelCheckAll = false;

                }
            );

        }

        /**
         * Search canal
         */
        function searchCanals() {
            filtre["search[value]"] = vm.search_canals;
            searchCanalsInAPI(filtre);
        }

    }
})
();

(function ()
{
    'use strict';

    angular
        .module('app.classifying.canal.list')
        .controller('parametersCanalDetailController', parametersCanalDetailController);

    /** @ngInject */
    function parametersCanalDetailController(parametersCanalData,$mdDialog)
    {
    	var vm = this;
        vm.canal = parametersCanalData;
      vm.cancel = cancel;
      function cancel(){
        $mdDialog.hide();
      }




    }



})();

(function () {
    'use strict';

    angular
        .module('app.classifying.canal.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider) {
        // State
        $stateProvider
            .state('app.parameters_canal_edit', {
                url: "/classifying/canal/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/classifying/canal/add_edit_view/add_edit.template.html',
                        controller: 'parametersCanalEditController as vm'
                    }
                },
                resolve: {
                    parametersCanalData: function (msApi, $stateParams) {
                        return msApi.resolve('parameters_canal.getCanal@get', {id: $stateParams.id});
                    },
                    serverChoicesData: function (msApi) {
                        return msApi.resolve('parameters_canal.serverChoices@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "parameters_canal_post_edit_action"
            })
        ;


        // API
        
        msApiProvider.register('parameters_canal.getCanal', [Routing.generate('api_parameters_get_detail_channel', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_canal.editCanal', [Routing.generate('api_parameters_post_edit_channel',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);

    }
})();
(function () {
  'use strict';

  angular
    .module('app.classifying.canal.edit')
    .controller('parametersCanalEditController', parametersCanalEditController);

  /** @ngInject */
  function parametersCanalEditController(webTvGlobal, parametersCanalData, serverChoicesData, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );

    vm.serverChoices = webTvGlobal.convertToSelectChoicesFormat(serverChoicesData.choices);
    vm.readingProtocolChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_use_default_config": "-1",
      "form_RTMP": "RTMP",
      "form_HDS": "HDS"
    });
    vm.mbrChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_use_default_config": "-1",
      "form_choices_disable": "0",
      "form_choices_enable": "1"
    });
    vm.yesNoChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });


    var canal = parametersCanalData;
    var channelConfig = null;
    vm.empParametersCanalForm = {};
    vm.submitAddCanalForm = submitAddCanalForm;
    // vm.returnToList = returnToList;
    fillData();


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.parameters_canal_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.parameters_canal_edit_pagetitle";
      $rootScope.pageRoute = "app.parameters_canal_list";

      $rootScope.welcome = "welcome_canal_edit";
      $rootScope.text = [{
        texte: "parameters_canal_add_help"
      }, {
        texte: "send_button_canal_add_help"
      }, {
        texte: "cancel_button_canal_add_help"
      }];

    }

    /*function getServers(data) {
        var list = [];
        for (var i = 0; i < data.length; i++) {
            list.push(data[i].id);
        }
        return list;
    }*/

    /**
     * Check if canal exists
     * @return if exists get canal Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(canal.code) && canal.code !== 200) $state.go('app.error_404');
      else {
        if (angular.isDefined(canal.channelConfig) && canal.channelConfig !== null) {
          channelConfig = {
            defaultBitrateComputer: canal.channelConfig.defaultBitrateComputer,
            defaultBitrateTablet: canal.channelConfig.defaultBitrateTablet,
            defaultBitrateMobile: canal.channelConfig.defaultBitrateMobile,
            readingProtocol: canal.channelConfig.readingProtocol ? canal.channelConfig.readingProtocol : "-1",
            isCdn: canal.channelConfig.isCdn ? (canal.channelConfig.isCdn ? "1" : "0") : "0",
            showMbr: canal.channelConfig.showMbr ? canal.channelConfig.showMbr : "-1"
          };
        }
        vm.empParametersCanalForm = {
          "title": canal.title,
          "description": canal.description,
          "language": canal.language ? canal.language : "",
          "servers": (function (list, data) {
            for (var i = 0; i < data.length; i++) {
              list.push(data[i].id);
            }
            return list;
          })([], canal.servers),
          "quota": canal.quota,
          "sendPushNotification": canal.sendPushNotification ? 1 : 0,
          "isVBR": canal.isVBR ? 1 : 0,
          "channelConfig": channelConfig
        };

        $rootScope.itemName = canal.title || '';

      }
    }

    // /**
    //  * return to canal list page
    //  * @return redirect to canal list page
    //  */
    // function returnToList() {
    //     $state.go('app.parameters_canal_list');
    // }


    /**
     * Send add canal Form
     */
    function submitAddCanalForm() {
      vm.empParametersCanalForm.quota = webTvGlobal.floatisizeNumericElements(vm.empParametersCanalForm.quota);
      vm.empParametersCanalForm.channelConfig = webTvGlobal.floatisizeNumericElements(vm.empParametersCanalForm.channelConfig);
      $rootScope.loadingProgress = true;
      msApi.request('parameters_canal.editCanal@save',
        {id: canal.id, "empParametersCanalForm": angular.copy(vm.empParametersCanalForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            canal = vm.empParametersCanalForm;
            webTvGlobal.$flashMessages().set('parametersCanalEdit', canal);
            $state.go('app.parameters_canal_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            vm.empParametersCanalError = [];
            errors.forEach(function (item) {
              vm.empParametersCanalError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersCanalForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.classifying.canal.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.parameters_canal_add', {
                url: "/classifying/canal/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/classifying/canal/add_edit_view/add_edit.template.html',
                        controller: 'parametersCanalAddController as vm'
                    }
                },
                resolve: {
                    parametersCanalData: function (msApi) {
                        return msApi.resolve('parameters_canal.getNewCanalData@get', {id: 0});
                    },
                    serverChoicesData: function (msApi) {
                        return msApi.resolve('parameters_canal.serverChoices@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "parameters_canal_post_add_action"
            });


        //API
        msApiProvider.register('parameters_canal.getNewCanalData', [Routing.generate('api_parameters_get_detail_channel', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('parameters_canal.addCanal', [Routing.generate('api_parameters_post_add_channel')]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.classifying.canal.add')
    .controller('parametersCanalAddController', parametersCanalAddController);

  /** @ngInject */
  function parametersCanalAddController(parametersCanalData, serverChoicesData, webTvGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = true;

    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
      (function (languages, data) {
        for (var i = 0; i < data.length; i++) {
          languages[data[i]] = data[i];
        }
        return languages;
      })({}, webTvGlobal.$constant().languagesList())
    );

    vm.serverChoices = webTvGlobal.convertToSelectChoicesFormat(serverChoicesData.choices);
    vm.readingProtocolChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_use_default_config": "-1",
      "form_RTMP": "RTMP",
      "form_HDS": "HDS"
    });
    vm.mbrChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_use_default_config": "-1",
      "form_choices_disable": "0",
      "form_choices_enable": "1"
    });
    vm.yesNoChoices = webTvGlobal.convertToSelectChoicesFormat({
      "form_choices_yes": 1,
      "form_choices_no": 0
    });


    var canal = parametersCanalData;
    var channelConfig = angular.isObject(canal.channelConfig)
      ?
      canal.channelConfig
      :
      {
        defaultBitrateComputer: "",
        defaultBitrateTablet: "",
        defaultBitrateMobile: "",
        readingProtocol: "-1",
        isCdn: "0",
        showMbr: "-1"
      }
    ;

    vm.empParametersCanalForm = {
      "title": canal.title ? canal.title : null,
      "description": canal.description ? canal.description : null,
      "language": canal.language ? canal.language : null,
      "servers": canal.servers,
      "quota": canal.quota ? canal.quota : 10000,
      "sendPushNotification": canal.sendPushNotification ? 1 : 0,
      "isVBR": canal.isVBR ? 1 : 0,
      "channelConfig": channelConfig
    };

    vm.submitAddCanalForm = submitAddCanalForm;
    // vm.returnToList = returnToList;

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.classifying_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.parameters_canal_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.parameters_canal_add_menuTitle";
      $rootScope.pageRoute = "app.parameters_canal_list";
      $rootScope.welcome = "welcome_canal_add";
      $rootScope.text = [{
        texte: "parameters_canal_add_help"
      }, {
        texte: "send_button_canal_add_help"
      }, {
        texte: "cancel_button_canal_add_help"
      }];

    }

    // /**
    //  * return to canal list page
    //  * @return redirect to canal list page
    //  */
    // function returnToList() {
    //     $state.go('app.parameters_canal_list');
    // }
    //

    /**
     * Send add canal Form
     */
    function submitAddCanalForm() {
      $rootScope.loadingProgress = true;
      if (vm.empParametersCanalForm.language === "null") vm.empParametersCanalForm.language = null;
      vm.empParametersCanalForm.quota = webTvGlobal.floatisizeNumericElements(vm.empParametersCanalForm.quota);
      vm.empParametersCanalForm.channelConfig = webTvGlobal.floatisizeNumericElements(vm.empParametersCanalForm.channelConfig);
      msApi.request('parameters_canal.addCanal@save',
        {"empParametersCanalForm": angular.copy(vm.empParametersCanalForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('parametersCanalAdd', {title: vm.empParametersCanalForm.title ? vm.empParametersCanalForm.title : ""});
            $state.go('app.parameters_canal_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            vm.empParametersCanalError = [];
            errors.forEach(function (item) {
              vm.empParametersCanalError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersCanalForm[item.for])
              };

            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


  }

})();


(function () {
    'use strict';

    angular
        .module('app.player_parameters.list_intra', ["datatables"])
        .config(config);



    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.player_parameters_list_intra', {
                url: '/player_intranet',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/playerParameters/list_intra/list_intra.template.html',
                        controller: 'PlayerParametersIntraListController as vm'
                    }
                },
                resolve: {
                    playerParametersData: function (msApi) {
                        return msApi.resolve('player_parameters.list_intra@get');
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // Api
        msApiProvider.register('player_parameters.list_intra', [Routing.generate('api_get_intranet_player_parameters')]);
        msApiProvider.register('player_parameters.updateKey', [Routing.generate('api_update_player_parameter')]);

    }
})();

(function () {
  'use strict';

  angular
    .module('app.player_parameters.list_intra')
    .controller('PlayerParametersIntraListController', PlayerParametersIntraListController);

  /** @ngInject */
  function PlayerParametersIntraListController(playerParametersData, $injector, $cookies,webTvGlobal,dtable_language) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      $document = webTvGlobal.$document;


    var vm = this;
    vm.playerParametersArray = formatPPdata(playerParametersData.playerParameters, []);
    var playerParameters = playerParametersData.playerParameters;
    vm.dtInstance = {};
    vm.selectedCles = [];
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the actions column
          targets: 2,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#pp-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            api.search(event.target.value).draw();
          });
        }
      },
      pagingType: 'full_numbers',
      lengthMenu: [5,10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true,
      language: dtable_language[$cookies.get('WEBTV.locale')]

    };
    vm.toogleSelection = toogleSelection;
    vm.openPPEditDialog = openPPEditDialog;
    vm.deselectKeys = deselectKeys;
    $rootScope.rerender = rerender;

    function toogleSelection(event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedCles.length === playerParameters.length) {
        vm.selectedCles = [];
      }
      else {
        vm.selectedCles = playerParameters;
      }
    }

    /*function toggleSelectKey(cle, event) {
        if (event) {
            event.stopPropagation();
        }

        if (vm.selectedCles.indexOf(cle) > -1) {
            vm.selectedCles.splice(vm.selectedCles.indexOf(cle), 1);
        }
        else {
            vm.selectedCles.push(cle);
        }
    }*/

    /**
     * Deselect cle
     */
    function deselectKeys() {
      vm.selectedCles = [];
    }

    /**
     * Select all Keys
     */

    /*function selectAllKeys() {
        vm.selectedCles = playerParameters;
    }*/

    function rerender() {
      if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }

    function openPPEditDialog(pair, index, event) {
      $mdDialog.show({
        controller: function ($mdDialog, $translate, pair, listController, index) {
          var vm = this;
          vm.pair = pair;
          vm.listController = listController;
          vm.closeDialog = closeDialog;
          vm.editPPKey = editPPKey;

          function closeDialog() {
            $mdDialog.hide();
          }

          function editPPKey($ev) {
            msApi.request(
              'player_parameters.updateKey@save',
              {
                key: vm.pair.key,
                value: vm.listController.playerParameters[vm.pair.key],
                id: vm.listController.playerParameters.id
              },
              function (res) {
                if (res.done) {
                  vm.listController.playerParametersArray[index].value = vm.listController.playerParameters[vm.pair.key];
                  closeDialog();
                }
                else vm.listController.playerParameters[vm.pair.key] = vm.pair.value;
                closeDialog();
              },
              function (res) {
                vm.listController.playerParameters[vm.pair.key] = vm.pair.value;
                webTvGlobal.alertDialog(res.data.message, '', '', $ev);
              }
            )
          }

        },
        controllerAs: 'vm',
        templateUrl: 'app/main/configuration/playerParameters/list_intra/list_intra.controller_template.html',
        targetEvent: event,
        clickOutsideToClose: true,
        locals: {
          pair: pair,
          listController: vm,
          index: index

        }
      }).then(function () {
        rerender();
      });
    }

    function formatPPdata(data, formattedArray) {
      for (var prop in data) {
        if (prop === "id") continue;
        formattedArray.push({
          key: prop,
          value: data[prop]
        })
      }
      return formattedArray;
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.player_parameters";
      $rootScope.titre2 = "PAGESMENUSTITLES.player_parameters_list_intra_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.player_parameters_list_intra_menuTitle";

      $rootScope.welcome = "welcome_group_add";
      $rootScope.text = [{
        texte: "add_button_user_help"
      }, {
        texte: "arrow_button_user_help"
      }, {
        texte: "search_area_user_help"
      }, {
        texte: "tri_column_user_help"
      },
        {
          texte: "edit_button_user_help"
        }, {
          texte: "detail_button_user_help"
        },
        {
          texte: "delete_button_user_help"
        }];

    }


  }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.server.list', ["datatables"])
        .config(config);

  

    function config($stateProvider,  msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_server_list', {
                url    :"/configuration/serveur/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/server/list/list.template.html',
                        controller: 'configurationServerListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_server_list_dtable_action"
            });

        // Api
        var deleteserverRoute = Routing.generate('api_configuration_delete_server') + "/:id";
        var deleteListServers = Routing.generate('api_multi_delete_multi_configuration_servers') + "/:list";
        msApiProvider.register('configuration_server.list_data_table', [Routing.generate('api_dtable_list_dtable_configuration_servers')]);
        msApiProvider.register('configuration_server.list', [Routing.generate('api_configuration_get_servers')]);
        msApiProvider.register('configuration_server.deleteServers', [deleteListServers, {list: '@list'}]);
        msApiProvider.register('configuration_server.mdelete', [deleteserverRoute, {id: '@id'}]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.server.list')
        .controller('configurationServerListController', configurationServerListController);

    /** @ngInject */
    function configurationServerListController(order_server, $cookies, DTOptionsBuilder, DTColumnBuilder, $compile, webTvGlobal, $injector, $scope, dtable_language,dialogConfirmDeleteService, $sce) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');

        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        var columnsApi = order_server;
        var numColumType = angular.isUndefined(columnsApi.data["type"]) ? 0 : columnsApi.data["type"];
        vm.types = convertItemsToChoices({
            Real: "Real",
            WinMedia: "WinMedia",
            Akamai: "Akamai",
            QuickTime: "QuickTime",
            Flv: "Flv",
            FO: "FO",
            live: 'live',
            live_mobile: 'live_mobile',
            Live_yacast: 'Live_yacast',
            Live_internet: 'Live_internet',
            Ftp: 'Ftp'

        });
        vm.servers = [];
        vm.empServerList = {type: ""};
        vm.search_servers = "";
        vm.selectedServers = [];
        var selectedServers = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.ServersDataTable = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;

            if (window.process.env.isNew_Configuration_Server) {
              vm.isNewServer = window.process.env.isNew_Configuration_Server;
            }
        if (vm.isNewServer){
          $scope.ServerIframe = $sce.trustAsResourceUrl(
            "https:" + window.process.env.URL_Configuration_Server +  "?lang="+ $cookies.get("WEBTV.locale") +"&token=" + $cookies.get("authToken")
          );
          $scope.$watch(
            function () {
              $scope.ServerIframe = $sce.trustAsResourceUrl(
                "https:" + window.process.env.URL_Configuration_Server + "?lang="+ $cookies.get("WEBTV.locale") +"&token=" + $cookies.get("authToken")
              );
              return $cookies.get("WEBTV.locale");
            },
            function (newValue) {}
          );
        }



        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the image column
                    targets: 2,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    targets: 4,
                    render: function (data) {
                        if (data === "") return "--";
                        if (parseInt(data) < 1) return "--";
                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets: 7,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.ServersDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.ServersDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.ServersDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('type').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn("internet").notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    var serverHtml = "";

                    if (data === true) {
                        serverHtml += '<i class="icon-checkbox-marked-circle green-500-fg"><span class="hide">1</span></i>';
                    }
                    else {
                        serverHtml += '<i  class="icon-cancel red-500-fg"><span class="hide">1</span></i>';
                    }

                    return serverHtml;
                }),
            DTColumnBuilder.newColumn('name').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('urlVideo').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('urlMp4').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn('urlDiffusion').withOption('defaultContent', ''),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.ServersDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" has-permission="configuration_server_get_detail" ng-click="vm.showServerDetail(vm.ServersDataTable[' + data.id + '],$event)" aria-label="action_detail"translate translate-attr-aria-label="MESSAGES.action_detail">' + '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_edit'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.configuration_server_edit({id: ' + data.id + '})" aria-label="action_edit" translate translate-attr-aria-label="MESSAGES.action_edit" has-permission="configuration_server_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.action_delete'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteServerConfirm(vm.ServersDataTable[' + data.id + '],ev)" aria-label="action_delete"translate translate-attr-aria-label="MESSAGES.action_delete" has-permission="configuration_server_delete_server">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })
        ];

        function searchServersInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_server.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.servers = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else if (angular.isDefined(response.errors)) {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.servers = [];

                        var errors = response.errors;
                        errors.forEach(function (item) {
                            $translate('VALIDATION.' + item.messages[0]).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });

                        });
                        vm.fnCallback(records);
                    }
                    else {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.servers = [];

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

                        vm.fnCallback(records);

                    }
                }, function (response) {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.servers = [];
                    vm.fnCallback(records);
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var columns = aoData[1].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];
            vm.selectedServers = [];
            selectedServers = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_servers,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            filtre.type = vm.empServerList.type;


            vm.fnCallback = fnCallback;
            searchServersInAPI(filtre);
        }

        vm.deleteServerConfirm = deleteServerConfirm;
        vm.deleteSelectedServerConfirm = deleteSelectedServerConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showServerDetail = showServerDetail;
        vm.addNewServer = addNewServer;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};

        function convertItemsToChoices(choices) {
            var converted = Object.keys(choices).map(function (key) {
                return {val: choices[key], option: key};
            });
            converted.sort(function (a, b) {
                return a.val - b.val;
            });
            return converted;
        }

        showFlasMessageToast('configurationServerAdd', $translate.instant('SERVERLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationServerEdit', $translate.instant('SERVERLIST.edited'));
        vm.searchServers = searchServers;

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param server
         */
        function toggle(server) {
            server.checked = !server.checked;
            var idx = selectedServers.indexOf(server);
            if (idx > -1) {
                selectedServers.splice(idx, 1);
            }
            else {
                selectedServers.push(server);
            }
            vm.selectedServers = angular.copy(selectedServers);
        }

        function toggleAll() {
            if (selectedServers.length === vm.servers.length) {
                vm.selectedServers = [];
            }

            else if ((selectedServers.length === 0) || (selectedServers.length > 0)) {
                vm.selectedServers = vm.servers.slice(0);
            }
            selectedServers = angular.copy(vm.selectedServers);
            var list_canals = angular.copy(vm.ServersDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.ServersDataTable[key].checked = selectedServers.length > 0;
            });
        }


        /**
         * Show server Details
         * @param server
         */
        function showServerDetail(server, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('configuration_server.getServer@get', {id: server.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationServerData: response},
                            templateUrl: 'app/main/configuration/server/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationServerDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchServersInAPI(filtre), true);
        }


        /**
         * redirection to add new server page
         * @param event
         */
        function addNewServer() {
            clearFlashMessage();
            $state.go('app.configuration_server_add');
        }

        /**
         * Delete server Confirm Dialog
         */
        function deleteServerConfirm(Server, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "SERVERLIST.delete_server_msg",
                "SERVERLIST.delete_server_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .htmlContent('<b>' + Server.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['SERVERLIST.delete_server_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteServer(Server);
                        vm.selectedServers = [];
                        selectedServers = [];
                    }, function () {

                    });
                });


        }

        /**
         * Delete server
         */
        function deleteServer(Server) {
            if (vm.servers.indexOf(Server) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_server.mdelete@delete', {id: Server.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "SERVERLIST.dialog_alert_delete_title",
                                "SERVERLIST.dialog_alert_delete_description",
                                "SERVERLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        textContent: Server.name + translatedValues['SERVERLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['SERVERLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.servers.splice(vm.servers.indexOf(Server), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "SERVERLIST.dialog_alert_delete_error_title",
                                "SERVERLIST.dialog_alert_delete_error_description",
                                "SERVERLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['SERVERLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['SERVERLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['SERVERLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        /**
         * Delete selected server Confirm Dialog
         */
        function deleteSelectedServerConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedServers.length!== 0) {
                if(vm.selectedServers.length === 1){
                    title = 'SERVERLIST.delete_server_msg';
                    ariaLabel = 'SERVERLIST.delete_server_aria_label';
                }else{
                    title = 'SERVERLIST.delete_list_server_msg';
                    ariaLabel = 'SERVERLIST.delete_servers_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedServers.length,title,ariaLabel)).then(function () {
                    deleteSelectedServer(ev);
                }, function () {
                });

            }
        }

        /**
         * Delete selected server
         */
        function deleteSelectedServer(ev) {
            $rootScope.loadingProgress = true;
            msApi.request('configuration_server.deleteServers@delete', {
                    list: (function (list) {
                        vm.selectedServers.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted;
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("SERVERLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("SERVERLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('SERVERLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedServers = [];
                        selectedServers = [];
                        rerender();
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('SERVERLIST.dialog_alert_delete_error_title'),
                            $translate.instant('SERVERLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedServers = [];
                        selectedServers = [];

                    }

                },


                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedServers = [];
                    selectedServers = [];
                    vm.modelCheckAll = false;

                }
            );
        }

        function searchServers() {
            filtre["search[value]"] = vm.search_servers;
            filtre.type = vm.empServerList.type;
            searchServersInAPI(filtre);

        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_server_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_server_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_server";
            $rootScope.text = [{
                texte: "add_button_server_help"
            }, {
                texte: "arrow_button_server_help"
            }, {
                texte: "search_area_server_help"
            }, {
                texte: "tri_column_server_help"
            },
                {
                    texte: "edit_button_server_help"
                }, {
                    texte: "detail_button_server_help"
                },
                {
                    texte: "delete_button_server_help"
                }];

        }


    }
})();

(function () {
    'use strict';

    angular
        .module('app.player_parameters.list', ["datatables"])
        .config(config);

  

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.player_parameters_list', {
                url: '/player_internet',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/playerParameters/list/list.template.html',
                        controller: 'PlayerParametersListController as vm'
                    }
                },
                resolve: {
                    playerParametersData: function (msApi) {
                        return msApi.resolve('player_parameters.list@get');
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // Api
        var deleteparamRoute = Routing.generate('api_delete_player_param') + "/:id";
        msApiProvider.register('cle.mdelete', [deleteparamRoute, {id: '@id'}]);
        msApiProvider.register('player_parameters.list', [Routing.generate('api_get_player_parameters')]);
        msApiProvider.register('player_parameters.updateKey', [Routing.generate('api_update_player_parameter')]);


    }
})();

(function () {
  'use strict';

  angular
    .module('app.player_parameters.list')
    .controller('PlayerParametersListController', PlayerParametersListController);

  /** @ngInject */
  function PlayerParametersListController(dtable_language, $cookies, playerParametersData, $injector, webTvGlobal, $state,dialogConfirmDeleteService) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      $document = webTvGlobal.$document;


    var vm = this;
    vm.paramss = [];
    if (!angular.isDefined(vm.playerParametersArray)) {
      vm.playerParametersArray = formatPPdata(playerParametersData.playerParameters, []);
      vm.paramss = vm.playerParametersArray;
    }
    vm.playerParameters = playerParametersData.playerParameters;
    vm.deleteSelectedParamsConfirm = deleteSelectedParamsConfirm;
    vm.deleteParamsConfirm = deleteParamsConfirm;
    vm.toggleAll = toggleAll;
    vm.toggle = toggle;
    var flashMessages = {title: ""};
    vm.selectedParamss = [];
    var selectedParamss = [];
    vm.dtInstance = {};
    vm.paramsDataTable = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the actions column
          targets: 2,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],

      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#pp-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            if(event.which === 13){
              api.search(event.target.value).draw();
            }
          });
        }
      },
      pagingType: 'full_numbers',
      lengthMenu: [5,10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true,
      language: dtable_language[$cookies.get('WEBTV.locale')]

    };
    vm.openPPEditDialog = openPPEditDialog;
    vm.addNewInternet = addNewInternet;
    $rootScope.rerender = rerender;

    function rerender() {
      if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }

    $rootScope.DtOptions = vm.dtOptions;

    function addNewInternet() {
      clearFlashMessage();
      $state.go('app.configuration_general_add');
    }

    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    function getElement() {
      var element = document.querySelectorAll('md-checkbox.ng-scope.md-default-theme');

      var left = element[0].offsetLeft;

      var leftDelete = left - 35;

      $scope.myObjStyle = {"margin-left": leftDelete}
    }

    function openPPEditDialog(pair, index, event) {
      $mdDialog.show({
        controller: function ($mdDialog, $translate, pair, listController, index) {
          var vm = this;
          vm.pair = angular.copy(pair);
          vm.listController = listController;
          vm.closeDialog = closeDialog;
          vm.editPPKey = editPPKey;

          function closeDialog() {
            $mdDialog.hide();
          }

          function editPPKey($ev) {
            msApi.request(
              'player_parameters.updateKey@save',
              {
                key: vm.pair.key,
                value: vm.pair.value,
                id: vm.pair.id
              },
              function (res) {
                if (res.code === 200) {
                  vm.listController.playerParametersArray[index].value = vm.pair.value;

                }
                else vm.listController.playerParameters[vm.pair.key] = vm.pair.key;
                vm.playerParametersArray = formatPPdata(vm.listController.playerParameters, []);
                closeDialog();
              },
              function (res) {
                vm.listController.playerParameters[vm.pair.key] = vm.pair.value;
                webTvGlobal.alertDialog(res.data.message, '', '', $ev);
              }
            );

          }

        },
        controllerAs: 'vm',
        templateUrl: 'app/main/configuration/playerParameters/list/list.controller_template.html',
        targetEvent: event,
        clickOutsideToClose: true,
        locals: {
          pair: pair,
          listController: vm,
          index: index

        }
      }).then(function () {
        // rerender();
      });
    }

    function formatPPdata(data, formattedArray) {
      var dataFormatted = [];
      var key, value, id;
      for (var i = 0; i < data.length; i++) {
        dataFormatted = data[i];
        for (var prop in dataFormatted) {
          if (prop !== "id") {
            key = prop;
            value = dataFormatted[prop];
          }
          else if (prop === "id") {
            formattedArray.push({
              key: key,
              value: value,
              id: dataFormatted[prop]
            });
          }

        }
      }
      return formattedArray;
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.player_parameters";
      $rootScope.titre3 = "PAGESMENUSTITLES.player_parameters_list_menuTitle";
      $rootScope.welcome = "welcome_player";
      $rootScope.text = [{
        texte: "add_button_player_help"
      }, {
        texte: "arrow_button_player_help"
      }, {
        texte: "search_area_player_help"
      }, {
        texte: "tri_column_player_help"
      },
        {
          texte: "edit_button_player_help"
        }, {
          texte: "detail_button_player_help"
        },
        {
          texte: "delete_button_player_help"
        }];

    }

    /**
     * Clear Flash Message when an action is triggered
     */
    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    /**
     * Delete param Confirm Dialog
     */
    function deleteParamsConfirm(param, ev) {
      $translate([
        "MESSAGES.dialog_confirm_delete",
        "MESSAGES.dialog_cancel",
        "MESSAGES.dialog_will_be_deleted",
        "PARAMLIST.delete_Params_msg",
        "PARAMLIST.delete_param_aria_label"
      ])
        .then(function (translatedValues) {
          var confirm = $mdDialog.confirm()
            .title(translatedValues['PARAMLIST.delete_Params_msg'])
            .htmlContent('<b>' + param.key + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
            .ariaLabel(translatedValues['PARAMLIST.delete_param_aria_label'])
            .targetEvent(ev)
            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
            .cancel(translatedValues['MESSAGES.dialog_cancel']);

          $mdDialog.show(confirm).then(function () {

            deleteParams(param);
            // vm.selectedParamss = [];
              selectedParamss = [];
            //rerender();
          }, function () {
          });
        });
    }

    function toggle(server) {
        server.checked = !server.checked;
        var idx = selectedParamss.indexOf(server);
        if (idx > -1) {
            selectedParamss.splice(idx, 1);
        }
        else {
            selectedParamss.push(server);
        }
        vm.selectedParamss = angular.copy(selectedParamss);
    }


    function toggleAll() {
        if (selectedParamss.length === vm.paramss.length) {
            vm.selectedParamss = [];
        }

        else if ((selectedParamss.length === 0) || (selectedParamss.length > 0)) {
            vm.selectedParamss = vm.paramss.slice(0);
        }
        selectedParamss = angular.copy(vm.selectedParamss);
        var list_canals = angular.copy(vm.paramss);
        angular.forEach(list_canals, function (value, key) {
            if (value !== undefined)
                vm.paramss[key].checked = selectedParamss.length > 0;
        });
    }



    /**
     * Delete param
     */
    function deleteParams(params) {
      clearFlashMessage();
      if (vm.playerParametersArray.indexOf(params) !== -1) {
        $rootScope.loadingProgress = true;
        msApi.request('cle.mdelete@delete', {id: params.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (response.code === 200) {
              $translate([
                "PARAMLIST.dialog_alert_delete_title",
                "PARAMLIST.dialog_alert_delete_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  webTvGlobal.$toast().showSimple(params.key + translatedValues['PARAMLIST.dialog_alert_delete_description']);
                  vm.playerParametersArray.splice(vm.playerParametersArray.indexOf(params), 1);
                  //rerender();
                });

            }
            else {
              $translate([
                "PARAMLIST.dialog_alert_delete_error_title",
                "PARAMLIST.dialog_alert_delete_error_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['PARAMLIST.dialog_alert_delete_error_title'],
                    textContent: translatedValues['PARAMLIST.dialog_alert_delete_error_description'],
                    ok: translatedValues['PARAMLIST.dialog_alert_delete_close']
                  });

                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                });

            }
          }
        );

      }
    }

    function deleteSelectedParamsConfirm(ev) {
      var title;
      var ariaLabel;
      if (vm.selectedParamss.length !== 0) {

        if (vm.selectedParamss.length === 1) {
          title = 'PLAYERPARAMETERSLIST.delete_element_Param_msg';
          ariaLabel = 'PLAYERPARAMETERSLIST.delete_Param_aria_label';
          console.log('vm.playerParametersArray.length'+vm.playerParametersArray.length);
        } else {
          title = 'PLAYERPARAMETERSLIST.delete_list_Param_msg';
          ariaLabel = 'PLAYERPARAMETERSLIST.delete_Params_aria_label';
          console.log('else'+vm.playerParametersArray.length);
        }

        $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.playerParametersArray.length, title, ariaLabel)).then(function () {

          deleteSelectedParams(ev);


        });

      }

    }
    /* delete selected groups*/
    function deleteSelectedParams(ev) {
      clearFlashMessage();

      $rootScope.loadingProgress = true;

      msApi.request('cle.deleteParams@delete', {
          list: (function (list) {
            vm.playerParametersArray.forEach(function (item) {
              list.push(item.id);
            });
            return list;
          })([])
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (response.code === 200) {
            var undeleted = "";
            var deleted;
            if (response.result.undeleted.length !== 0) {
              undeleted = $translate.instant("PARAMLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
            }
            deleted = $translate.instant("PARAMLIST.deleted_are", {'list': response.result.deleted.join(",")});
            webTvGlobal.alertDialog(
              deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
              $translate.instant('PARAMLIST.dialog_alert_delete_title'),
              '',
              ev
            );
            vm.playerParametersArray = [];
            selectedParamss = [];
            rerender();

          }
          else {
            webTvGlobal.alertDialog(
              $translate.instant('PARAMLIST.dialog_alert_delete_error_title'),
              $translate.instant('PARAMLIST.dialog_alert_delete_error_description'),
              '',
              ev
            );
            vm.playerParametersArray = [];
            selectedParamss = [];
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
          vm.playerParametersArray = [];
          selectedParamss = [];
          vm.modelCheckAll = false;

        }
      );


    }




  }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.presets.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_presets_list', {
                url: "/configuration/presets/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/presets/list/list.template.html',
                        controller: 'configurationPresetsListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_presets_list_dtable_action"
            });


        // Api
        var deletepresetsRoute = Routing.generate('api_configuration_delete_preset') + "/:id";
        msApiProvider.register('configuration_presets.list', [Routing.generate('api_configuration_get_presets')]);
        msApiProvider.register('configuration_presets.mdelete', [deletepresetsRoute, {id: '@id'}]);
        msApiProvider.register('configuration_presets.list_data_table', [Routing.generate('api_dtable_list_dtable_configuration_presets')]);
        var deleteListPresetss = Routing.generate('api_multi_delete_multi_configuration_presets') + "/:list";
        msApiProvider.register('configuration_presets.deletePresets', [deleteListPresetss, {list: '@list'}]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.presets.list')
        .controller('configurationPresetsListController', configurationPresetsListController);

    /** @ngInject */
    function configurationPresetsListController($scope, DTOptionsBuilder, $cookies, $compile, webTvGlobal, DTColumnBuilder, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.presetss = [];
        vm.selectedPresetss = [];
        var selectedPresetss = [];
        vm.dtInstance = {};
        vm.PresetsDataTable = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the actions column
                    targets: 7,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchPresetsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_presets.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.presetss = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.presetss = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            vm.selectedPresetss = [];
            selectedPresetss = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_Presets,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };

            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchPresetsInAPI(filtre);
        }

        function searchPresetss() {
            filtre["search[value]"] = vm.search_Presets;
            searchPresetsInAPI(filtre);

        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.PresetsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.PresetsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.PresetsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('state').renderWith(function (data) {
                var serverHtml = "";
                if (data) {
                    serverHtml += '<i class="icon icon-check"></i>';
                }
                else {
                    serverHtml += '<i class="icon icon-alert"></i>';
                }

                return serverHtml;
            }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('bitrateVideo').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('bitrateAudio').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('samplerateAudio').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('framerate').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.PresetsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'PRESETSLIST.detail_presets'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showPresetsDetail(vm.PresetsDataTable[' + data.id + '],$event)" aria-label="detail_presets"translate translate-attr-aria-label="PRESETSLIST.detail_presets" has-permission="configuration_presets_get_detail">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'PRESETSLIST.update_presets'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.configuration_presets_edit({id: ' + data.id + '})" aria-label="update_presets" translate translate-attr-aria-label="PRESETSLIST.update_presets" has-permission="configuration_presets_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'PRESETSLIST.delete_presets'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deletePresetsConfirm(vm.PresetsDataTable[' + data.id + '],ev)" aria-label="delete_presets"translate translate-attr-aria-label="PRESETSLIST.delete_presets" has-permission="configuration_presets_delete_preset">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })
        ];
        vm.deleteSelectedPresetsConfirm = deleteSelectedPresetsConfirm;
        vm.searchPresetss = searchPresetss;
        vm.deletePresetsConfirm = deletePresetsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showPresetsDetail = showPresetsDetail;
        vm.addNewPresets = addNewPresets;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationPresetsAdd', $translate.instant('PRESETSLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationPresetsEdit', $translate.instant('PRESETSLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param presets
         */
        function toggle(presets) {
            getElement();
            presets.checked = !presets.checked;
            var idx = selectedPresetss.indexOf(presets);
            if (idx > -1) {
                selectedPresetss.splice(idx, 1);
            }
            else {
                selectedPresetss.push(presets);
            }
            vm.selectedPresetss = angular.copy(selectedPresetss);
        }


        function toggleAll() {
            getElement();
            if (selectedPresetss.length === vm.presetss.length) {
                vm.selectedPresetss = [];
            }

            else if ((selectedPresetss.length === 0) || (selectedPresetss.length > 0)) {
                vm.selectedPresetss = vm.presetss.slice(0);
            }
            selectedPresetss = angular.copy(vm.selectedPresetss);
            var list_canals = angular.copy(vm.PresetsDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.PresetsDataTable[key].checked = selectedPresetss.length > 0;
            });
        }


        /**
         * Show presets Details
         * @param presets
         */
        function showPresetsDetail(presets, ev) {

            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('configuration_presets.getNewPresetsData@get', {id: presets.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationPresetsData: response},
                            templateUrl: 'app/main/configuration/presets/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationPresetsDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchPresetsInAPI(filtre), true);
        }


        /**
         * redirection to add new presets page
         * @param event
         */
        function addNewPresets() {
            clearFlashMessage();
            $state.go('app.configuration_presets_add');
        }

        /**
         * Delete presets Confirm Dialog
         */
        function deleteSelectedPresetsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedPresetss.length!== 0) {
                if(vm.selectedPresetss.length === 1){
                    title = 'PRESETSLIST.delete_preset_msg';
                    ariaLabel = 'PRESETSLIST.delete_preset_aria_label';
                }else{
                    title = 'PRESETSLIST.delete_list_presetss_msg';
                    ariaLabel = 'PRESETSLIST.delete_presetss_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedPresetss.length,title,ariaLabel)).then(function () {
                    deleteSelectedPresets(ev);
                }, function () {
                });

            }

        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Delete Selected Presets
         */
        function deleteSelectedPresets(ev) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;
            msApi.request('configuration_presets.deletePresets@delete', {
                    list: (function (list) {
                        vm.selectedPresetss.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted;
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("PRESETSLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("PRESETSLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('PRESETSLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedPresetss = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('PRESETSLIST.dialog_alert_delete_error_title'),
                            $translate.instant('PRESETSLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedPresetss = [];

                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }


                    vm.selectedPresetss = [];
                    vm.modelCheckAll = false;

                }
            );

        }

        function deletePresetsConfirm(presets, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "PRESETSLIST.delete_presets_msg",
                "PRESETSLIST.delete_presets_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['PRESETSLIST.delete_presets_msg'])
                        .htmlContent('<b>' + presets.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['PRESETSLIST.delete_presets_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deletePresets(presets);
                        vm.selectedPresetss = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete presets
         */
        function deletePresets(Presets) {
            clearFlashMessage();
            if (vm.presetss.indexOf(Presets) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_presets.mdelete@delete', {id: Presets.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "PRESETSLIST.dialog_alert_delete_title",
                                "PRESETSLIST.dialog_alert_delete_description",
                                "PRESETSLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Presets.name + translatedValues['PRESETSLIST.dialog_alert_delete_description']);
                                    vm.presetss.splice(vm.presetss.indexOf(Presets), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "PRESETSLIST.dialog_alert_delete_error_title",
                                "PRESETSLIST.dialog_alert_delete_error_description",
                                "PRESETSLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['PRESETSLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['PRESETSLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['PRESETSLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }
                );

            }


        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_presets_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_presets_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_preset";
            $rootScope.text = [{
                texte: "add_button_preset_help"
            }, {
                texte: "arrow_button_preset_help"
            }, {
                texte: "search_area_preset_help"
            }, {
                texte: "tri_column_preset_help"
            },
                {
                    texte: "edit_button_preset_help"
                }, {
                    texte: "detail_button_preset_help"
                },
                {
                    texte: "delete_button_preset_help"
                }];

        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.server.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_server_add', {
                url    : "/configuration/serveur/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/server/add_edit_view/add_edit.template.html',
                        controller : 'configurationServerAddController as vm'
                    }
                },
                resolve: {
                     configurationServerData: function (msApi)
                    {
                        return msApi.resolve('configuration_server.getServer@get',{id:'0'});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_server_post_add_action"
            })
            /*.state('app.configuration_server_detail',{
                url: Routing.generate('emp_server_detail')+"/:id"
            })*/;

        //API
        msApiProvider.register('configuration_server.addServer', [Routing.generate('api_configuration_post_add_server')]);






    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.server.add')
    .controller('configurationServerAddController', configurationServerAddController);

  /** @ngInject */
  function configurationServerAddController($rootScope, $translate, msApi, $state, configurationServerData, webTvGlobal, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;

    var server = configurationServerData;
    vm.isNew = true;
    vm.typesServer = convertItemsToChoices({
      Buffer: "Buffer",
      Wowza: "Wowza",
      Akamai: "Akamai"
    });
    vm.empConfigurationServerForm = {
      type: server.type,
      protocol: server.protocol,
      internet: server.internet,
      record: server.record,
      name: server.name,
      login: server.login,
      serverName: server.serverName,
      serverType: server.serverType,

      pwd: server.pwd,
      dir: server.dir,
      urlVideo: server.urlVideo,
      urlMp4: server.urlMp4,
      urlDiffusion: server.urlDiffusion,
      urlVodAndroid: server.urlVodAndroid,

      urlLiveAndroid: server.urlLiveAndroid,
      urlCdnAndroid: server.urlCdnAndroid,
      urlVodIos: server.urlVodIos,
      urlLiveIos: server.urlLiveIos,
      urlCdnIos: server.urlCdnIos,
      dirLecture: server.dirLecture,

      urlBackup: server.urlBackup,
      urlMobile: server.urlMobile,
      urlServerFtp: server.urlServerFtp,
      loginLive: server.loginLive,
      pwdLive: server.pwdLive,
      bitrate: server.bitrate
    };
    vm.submitAddServerForm = submitAddServerForm;


    vm.types = convertItemsToChoices({
      Real: "Real",
      WinMedia: "WinMedia",
      Akamai: "Akamai",
      QuickTime: "QuickTime",
      Flv: "Flv",
      FO: "FO",
      live: 'live',
      live_mobile: 'live_mobile',
      Live_yacast: 'Live_yacast',
        Live_internet: 'Live_internet',
      Ftp: 'Ftp'

    });
    vm.protocols = convertItemsToChoices({
      rtmp: "rtmp",
      https: "http",
      ftp: "ftp",
      hds_wowza: "hds_wowza",
      hds_ambr: "hds_ambr",
      hls: "hls"
    });

    function convertItemsToChoices(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], option: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Server Form
     */
    function submitAddServerForm() {
      $rootScope.loadingProgress = true;

      msApi.request('configuration_server.addServer@save',
        {"empConfigurationServerForm": angular.copy(vm.empConfigurationServerForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            server = vm.empConfigurationServerForm;
            webTvGlobal.$flashMessages().set('configurationServerAdd', {title: vm.empConfigurationServerForm.name ? vm.empConfigurationServerForm.name : ""});
            $state.go('app.configuration_server_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            vm.empConfigurationServerError = [];
            errors.forEach(function (item) {
              vm.empConfigurationServerError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empConfigurationServerForm[item.for])
              };

            });

          } else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_server_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_server_add_menuTitle";
      $rootScope.pageRoute = "app.configuration_server_list";
      $rootScope.welcome = "welcome_server_add";
      $rootScope.text = [{
        texte: "parameters_server_add_help"
      }, {
        texte: "send_button_server_add_help"
      }, {
        texte: "cancel_button_server_add_help"
      }];
    }

  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.server.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider,  msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_server_edit', {
                url    :"/configuration/serveur/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/server/add_edit_view/add_edit.template.html',
                        controller : 'configurationServerEditController as vm'
                    }
                },
                resolve: {
                     configurationServerData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('configuration_server.getServer@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_server_post_edit_action"
            });


        // API
        msApiProvider.register('configuration_server.editServer', [Routing.generate('api_configuration_post_edit_server',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.server.edit')
    .controller('configurationServerEditController', configurationServerEditController);

  /** @ngInject */
  function configurationServerEditController($rootScope, webTvGlobal, $translate, msApi, $state, configurationServerData, HelpGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = false;
    vm.typesServer = convertItemsToChoices({
      Buffer: "Buffer",
      Wowza: "Wowza",
      Akamai: "Akamai"
    });
    vm.types = convertItemsToChoices({
      Real: "Real",
      WinMedia: "WinMedia",
      Akamai: "Akamai",
      QuickTime: "QuickTime",
      Flv: "Flv",
      FO: "FO",
      live: 'live',
      live_mobile: 'live_mobile',
      Live_yacast: 'Live_yacast',
        Live_internet: 'Live_internet',
      Ftp: 'Ftp'

    });
    vm.protocols = convertItemsToChoices({
      rtmp: "rtmp",
      https: "http",
      ftp: "ftp",
      hds_wowza: "hds_wowza",
      hds_ambr: "hds_ambr",
      hls: "hls"
    });


    function convertItemsToChoices(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], option: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    var server = configurationServerData;
    vm.empConfigurationServerForm = {};
    vm.submitAddServerForm = submitAddServerForm;
    fillData();

    /**
     * Check if Server exists
     * @return if exists get Server Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(server.code) && server.code !== 200) $state.go('app.error_404');
      else {
        vm.empConfigurationServerForm = {
          type: server.type,
          protocol: server.protocol,
          internet: server.internet,
          record: server.record,
          name: server.name,
          login: server.login,
          serverName: server.serverName,
          serverType: server.serverType,

          pwd: server.pwd,
          dir: server.dir,
          urlVideo: server.urlVideo,
          urlMp4: server.urlMp4,
          urlDiffusion: server.urlDiffusion,
          urlVodAndroid: server.urlVodAndroid,

          urlLiveAndroid: server.urlLiveAndroid,
          urlCdnAndroid: server.urlCdnAndroid,
          urlVodIos: server.urlVodIos,
          urlLiveIos: server.urlLiveIos,
          urlCdnIos: server.urlCdnIos,
          dirLecture: server.dirLecture,

          urlBackup: server.urlBackup,
          urlMobile: server.urlMobile,
          urlServerFtp: server.urlServerFtp,
          loginLive: server.loginLive,
          pwdLive: server.pwdLive,
          bitrate: server.bitrate
        };
      }
    }


    /**
     * Send add Server Form
     */
    function submitAddServerForm() {
      $rootScope.loadingProgress = true;

      msApi.request('configuration_server.editServer@save',
        {id: server.id, "empConfigurationServerForm": angular.copy(vm.empConfigurationServerForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            server = vm.empConfigurationServerForm;
            webTvGlobal.$flashMessages().set('configurationServerEdit', {title: vm.empConfigurationServerForm.name ? vm.empConfigurationServerForm.name : ""});
            $state.go('app.configuration_server_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            vm.empConfigurationServerError = [];
            errors.forEach(function (item) {
              vm.empConfigurationServerError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empConfigurationServerForm[item.for])
              };
            });

          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_server_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_server_edit_pagetitle";
      $rootScope.pageRoute = "app.configuration_server_list";
      $rootScope.welcome = "welcome_server_edit";
      $rootScope.text = [{
        texte: "parameters_server_add_help"
      }, {
        texte: "send_button_server_edit_help"
      }, {
        texte: "cancel_button_server_add_help"
      }];

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.configuration.server.list')
    .controller('configurationServerDetailController', configurationServerDetailController);

  /** @ngInject */
  function configurationServerDetailController(configurationServerData, $mdDialog) {
    var vm = this;
    vm.server = configurationServerData;
    vm.cancel = cancel;




    function cancel() {
      $mdDialog.hide();
    }


  }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.referrers_list', {
                url: "/configuration/referrers/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/referrers/list/list.template.html',
                        controller: 'referrersListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });

        // Api
        var deleteReferrerRoute = Routing.generate('api_referrer_delete_referrer') + "/:id";
        msApiProvider.register('referrers.list', [Routing.generate('api_dtable_list_dtable_referrer')]);
        msApiProvider.register('referrers.mdelete', [deleteReferrerRoute, {id: '@id'}]);
        msApiProvider.register('referrers.modalGetReferrer', [Routing.generate('api_referrer_get_detail_referrer', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteListReferrers = Routing.generate('api_multi_delete_referrers') + "/:list";
        msApiProvider.register('referrers.deleteReferrers', [deleteListReferrers, {list: '@list'}]);

        var enableReferrer = Routing.generate('api_referrer_post_enable_referrer') + "/:id";
        var disableReferrer = Routing.generate('api_referrer_post_disable_referrer') + "/:id";
        msApiProvider.register('referrer.enable', [enableReferrer, {id: '@id'}]);
        msApiProvider.register('referrer.disable', [disableReferrer, {id: '@id'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers.list')
        .controller('referrersListController', referrersListController);

    /** @ngInject */
    function referrersListController(webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $scope, $cookies, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_referrers_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_referrers_list_pagetitle";

            $rootScope.welcome = "";
            $rootScope.text = [];

        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        //Data Table options
        vm.referrers = [];
        vm.selectedReferrers = [];
        var selectedReferrers = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.referrersDataTable = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: 2,
                    filterable: true,
                    sortable: true,
                    width: '80px'
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchReferrersInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('referrers.list@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.referrers = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.referrers = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedReferrers = [];
            selectedReferrers = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_referrers,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchReferrersInAPI(filtre);
        }

        function searchReferrers() {
            filtre["search[value]"] = vm.search_referrers;
            searchReferrersInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.referrersDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.referrersDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.referrersDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('url').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {


                    var serverHtml = "";

                    serverHtml += '<div style="    display: table;margin: 0 auto;" ><md-switch  aria-label="Switch 1" ng-model="vm.referrersDataTable[' + data.id + '].mode" ng-change="vm.enable_disable_referrer(vm.referrersDataTable[' + data.id + '])"></div>' +
                        '</md-switch>';


                    return serverHtml;
                }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.referrersDataTable[data.id] = data;

                    var buttonActionEditHtml =
                        '<a has-permission="referrers_post_edit" tooltips tooltip-template=' + "{{'REFERRERLIST.update_referrer'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.referrers_edit({id: ' + data.id + '})" aria-label="update_referrer" translate translate-attr-aria-label="REFERRERLIST.update_referrer" has-permission="configuration_referrers_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'REFERRERLIST.delete_referrer'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteReferrerConfirm(vm.referrersDataTable[' + data.id + '],ev)" aria-label="delete_referrer" translate translate-attr-aria-label="REFERRERLIST.delete_referrer" has-permission="configuration_referrers_delete_referrer">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button>' +
                        '</a>';

                    return buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchReferrers = searchReferrers;
        vm.deleteReferrerConfirm = deleteReferrerConfirm;
        vm.deleteSelectedReferrersConfirm = deleteSelectedReferrersConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showReferrerDetail = showReferrerDetail;
        vm.addNewReferrer = addNewReferrer;
        $rootScope.rerender = rerender;
        vm.enable_disable_referrer = enable_disable_referrer;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationReferrerAdd', $translate.instant('REFERRERLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationReferrerEdit', $translate.instant('REFERRERLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param referrer
         */
        function toggle(referrer) {
            getElement();
            referrer.checked = !referrer.checked;
            var idx = selectedReferrers.indexOf(referrer);
            if (idx > -1) {
                selectedReferrers.splice(idx, 1);
            }
            else {
                selectedReferrers.push(referrer);
            }
            vm.selectedReferrers = angular.copy(selectedReferrers);
        }


        function toggleAll() {
            getElement();
            if (selectedReferrers.length === vm.referrers.length) {
                vm.selectedReferrers = [];
            }

            else if ((selectedReferrers.length === 0) || (selectedReferrers.length > 0)) {
                vm.selectedReferrers = vm.referrers.slice(0);
            }
            selectedReferrers = angular.copy(vm.selectedReferrers);
            var list_canals = angular.copy(vm.referrersDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.referrersDataTable[key].checked = selectedReferrers.length > 0;
            });
        }

        /**
         * Show ReferrerDetails
         * @param referrer
         */
        function showReferrerDetail(referrer, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('referrers.modalGetReferrer@get', {id: referrer.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {referrerData: response},
                            templateUrl: 'app/main/configuration/referrers/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'referrersDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchReferrersInAPI(filtre), true);
        }


        /**
         * redirection to add new referrer page
         * @param event
         */
        function addNewReferrer() {
            clearFlashMessage();
            $state.go('app.referrers_add');
        }

        /**
         * Delete ReferrerConfirm Dialog
         */
        function deleteReferrerConfirm(Referrer, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "REFERRERLIST.dialog_will_be_deleted_referrer",
                "REFERRERLIST.delete_referrer_msg",
                "REFERRERLIST.delete_referrer_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['REFERRERLIST.delete_referrer_msg'])
                        .htmlContent('<b>' + Referrer.url + '</b>' + translatedValues['REFERRERLIST.dialog_will_be_deleted_referrer'])
                        .ariaLabel(translatedValues['REFERRERLIST.delete_referrer_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteReferrer(Referrer);
                        vm.selectedReferrers = [];
                        selectedReferrers = [];
                    }, function () {

                    });
                });


        }

        /**
         * Delete Referrer
         */
        function deleteReferrer(Referrer) {
            clearFlashMessage();
            if (vm.referrers.indexOf(Referrer) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('referrers.mdelete@delete', {id: Referrer.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "REFERRERLIST.dialog_alert_delete_title",
                                "REFERRERLIST.dialog_alert_delete_description",
                                "REFERRERLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['REFERRERLIST.dialog_alert_delete_title'],
                                        textContent: Referrer.title + translatedValues['REFERRERLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['REFERRERLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.referrers.splice(vm.referrers.indexOf(Referrer), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "REFERRERLIST.dialog_alert_delete_error_title",
                                "REFERRERLIST.dialog_alert_delete_error_description",
                                "REFERRERLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['REFERRERLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['REFERRERLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['REFERRERLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                                webTvGlobal.alertDialog(message);
                            }), function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            };
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        function deleteSelectedReferrersConfirm(ev) {
          var title;
          var ariaLabel;
            if (vm.selectedReferrers.length !== 0) {
              if (vm.selectedReferrers.length === 1) {
                title = 'REFERRERLIST.delete_element_referrers_msg';
                ariaLabel = 'REFERRERLIST.delete_referrer_aria_label';
              } else {
                title = 'REFERRERLIST.delete_list_referrers_msg';
                ariaLabel = 'REFERRERLIST.delete_referrers_aria_label';
              }



              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedReferrers.length, title, ariaLabel)).then(function () {

                            deleteSelectedReferrers(ev);



                    });

            }

        }

        /* delete selected groups*/
        function deleteSelectedReferrers(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('referrers.deleteReferrers@delete', {
                    list: (function (list) {
                        vm.selectedReferrers.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("REFERRERLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("REFERRERLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('REFERRERLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedReferrers = [];
                        selectedReferrers = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('REFERRERLIST.dialog_alert_delete_error_title'),
                            $translate.instant('REFERRERLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedReferrers = [];
                        selectedReferrers = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedReferrers = [];
                    selectedReferrers = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        function enable_disable_referrer(referrer) {
            if (referrer.mode == true) {
                clearFlashMessage();
                if (vm.referrers.indexOf(referrer) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('referrer.enable@save', {id: referrer.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([

                                    "REFERRERLIST.dialog_alert_enable_description"
                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(translatedValues['REFERRERLIST.dialog_alert_enable_description']);
                                        vm.referrers[vm.referrers.indexOf(referrer)].mode = true;
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "LIVESLIST.dialog_alert_enable_error_title",
                                    "LIVESLIST.dialog_alert_enable_error_description",
                                    "LIVESLIST.dialog_alert_enable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['LIVESLIST.dialog_alert_enable_error_title'],
                                            textContent: translatedValues['LIVESLIST.dialog_alert_enable_error_description'],
                                            ok: translatedValues['LIVESLIST.dialog_alert_enable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }
            else {
                clearFlashMessage();
                if (vm.referrers.indexOf(referrer) !== -1) {
                    $rootScope.loadingProgress = true;
                    msApi.request('referrer.disable@save', {id: referrer.id},
                        function (response) {
                            $rootScope.loadingProgress = false;
                            if (response.code === 200) {
                                $translate([
                                    "REFERRERLIST.dialog_alert_disable_description"

                                ])
                                    .then(function (translatedValues) {
                                        webTvGlobal.$toast().showSimple(translatedValues['REFERRERLIST.dialog_alert_disable_description']);
                                        vm.referrers[vm.referrers.indexOf(referrer)].mode = false;
                                        rerender();
                                    });

                            }
                            else {
                                $translate([
                                    "LIVESLIST.dialog_alert_disable_error_title",
                                    "LIVESLIST.dialog_alert_disable_error_description",
                                    "LIVESLIST.dialog_alert_disable_close"
                                ])
                                    .then(function (translatedValues) {
                                        var alert = $mdDialog.alert({
                                            title: translatedValues['LIVESLIST.dialog_alert_disable_error_title'],
                                            textContent: translatedValues['LIVESLIST.dialog_alert_disable_error_description'],
                                            ok: translatedValues['LIVESLIST.dialog_alert_disable_close']
                                        });

                                        $mdDialog
                                            .show(alert)
                                            .finally(function () {
                                                alert = undefined;
                                            });
                                    });

                            }
                        }
                    );

                }
            }

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.referrers_edit', {
                url: "/configuration/referrers/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/referrers/add_edit_view/add_edit.template.html',
                        controller: 'referrersEditController as vm'
                    }
                },
                resolve: {
                    referrerData: function (msApi, $stateParams) {
                        return msApi.resolve('referrers.getReferrer@get', {id: $stateParams.id});
                    }

                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // API
        msApiProvider.register('referrers.getReferrer', [Routing.generate('api_referrer_get_detail_referrer', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('referrers.editReferrer', [Routing.generate('api_referrer_post_edit_referrer', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.referrers.edit')
    .controller('referrersEditController', referrersEditController);

  /** @ngInject */
  function referrersEditController(webTvGlobal, referrerData, $rootScope, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var referrer = referrerData;
    vm.empConfigurationReferrerForm = {};
    vm.submitAddReferrerForm = submitAddReferrerForm;
    fillData();
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_referrers_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_referrers_edit_menuTitle";
      $rootScope.pageRoute = "app.referrers_list";

      $rootScope.welcome = "";
      $rootScope.text = [];

    }

    vm.visibilityChoices = convertReferrerIdToSelectList({
      "whitelist": true,
      "blacklist": false
    });

    /**
     * Check if referrer exists
     * @return if exists get Referrer Data else redirect to 404 page
     */

    function fillData() {
      // if (referrer.mode === true) {
      //     referrer.mode = 1;
      // }
      // if (referrer.mode === false) {
      //     referrer.mode = 0;
      // }
      if (angular.isDefined(referrer.code) && referrer.code !== 200) $state.go('app.error_404');
      else {
        if (referrer.parent !== null) {
          vm.empConfigurationReferrerForm = {

            url: referrer.url,
            mode: referrer.mode
          };
        }
        else {
          vm.empConfigurationReferrerForm = {
            title: referrer.title,
            visible: referrer.visible
          };
        }

        $rootScope.itemName = referrer.title || '';
      }
    }


    /**
     * Convert List To Select Option format
     */
    function convertReferrerIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Referrer Form
     */
    function submitAddReferrerForm() {
      $rootScope.loadingProgress = true;
      msApi.request('referrers.editReferrer@save',
        {id: referrer.id, "empParametersReferrerForm": angular.copy(vm.empConfigurationReferrerForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            referrer = vm.empConfigurationReferrerForm;
            webTvGlobal.$flashMessages().set('configurationReferrerEdit', referrer);
            $state.go('app.referrers_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );


    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers.list')
        .controller('referrersDetailController', referrersDetailController);

    /** @ngInject */
    function referrersDetailController(referrerData, $mdDialog) {
        var vm = this;
        vm.referrer = referrerData;
      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.presets.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_presets_edit', {
                url    : "/configuration/presets/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/presets/add_edit_view/add_edit.template.html',
                        controller : 'configurationPresetsEditController as vm'
                    }
                },
                resolve: {
                     configurationPresetsData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('configuration_presets.getNewPresetsData@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_presets_post_edit_action"
            });


        // API
        msApiProvider.register('configuration_presets.editPresets', [Routing.generate('api_configuration_post_edit_preset',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.presets.edit')
    .controller('configurationPresetsEditController', configurationPresetsEditController);

  /** @ngInject */
  function configurationPresetsEditController(webTvGlobal, $translate, msApi, $rootScope, $state, configurationPresetsData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var presets = configurationPresetsData;
    vm.empConfigurationPresetsForm = {};
    vm.submitAddPresetsForm = submitAddPresetsForm;

    fillData();

    /**
     * Check if Presets exists
     * @return if exists get Presets Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(presets.code) && presets.code !== 200) $state.go('app.error_404');
      else {
        vm.empConfigurationPresetsForm = {
          name: presets.name,
          bitrateVideo: presets.bitrateVideo,
          bitrateAudio: presets.bitrateAudio,
          samplerateAudio: presets.samplerateAudio,
          framerate: presets.framerate,
          state: presets.state
        };
        $rootScope.itemName = presets.name || '';
      }
    }


    /**
     * Send add Presets Form
     */
    function submitAddPresetsForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_presets.editPresets@save',
        {id: presets.id, "empConfigurationPresetsForm": angular.copy(vm.empConfigurationPresetsForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            presets = vm.empConfigurationPresetsForm;
            webTvGlobal.$flashMessages().set('configurationPresetsEdit', {title: vm.empConfigurationPresetsForm.name ? vm.empConfigurationPresetsForm.name : ""});
            $state.go('app.configuration_presets_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            // else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_presets_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_presets_edit_pagetitle";
      $rootScope.pageRoute = "app.configuration_presets_list";

      $rootScope.welcome = "welcome_preset_edit";
      $rootScope.text = [{
        texte: "parameters_preset_add_help"
      }, {
        texte: "send_button_preset_edit_help"
      }, {
        texte: "cancel_button_preset_add_help"
      }];

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.referrers_add', {
                url: "/configuration/referrers/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/referrers/add_edit_view/add_edit.template.html',
                        controller: 'referrersAddController as vm'
                    }
                },
                resolve: {
                    referrerData: function (msApi) {
                        return msApi.resolve('referrers.getNewReferrerData@get', {id: 0});
                    }

                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });

        //API
        msApiProvider.register('referrers.getNewReferrerData', [Routing.generate('api_referrer_get_detail_referrer', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('referrers.addReferrer', [Routing.generate('api_referrer_post_add_referrer')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.referrers.add')
    .controller('referrersAddController', referrersAddController);

  /** @ngInject */
  function referrersAddController(referrerData, webTvGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_referrers_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_referrers_add_menuTitle";
      $rootScope.pageRoute = "app.referrers_list";

      $rootScope.welcome = "";
      $rootScope.text = [];

    }

    var vm = this;
    vm.isNew = true;
    var referrer = referrerData;
    vm.empConfigurationReferrerForm = {
      url: referrer.url


    };
    vm.visibilityChoices = convertReferrerIdToSelectList({
      "whitelist": true,
      "blacklist": false
    });
    vm.submitAddReferrerForm = submitAddReferrerForm;


    /**
     * Convert List To Select Option format
     */
    function convertReferrerIdToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Send add Referrer Form
     */
    function submitAddReferrerForm() {
      $rootScope.loadingProgress = true;
      msApi.request('referrers.addReferrer@save',
        {"empParametersReferrerForm": angular.copy(vm.empConfigurationReferrerForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            referrer = vm.empConfigurationReferrerForm;
            webTvGlobal.$flashMessages().set('configurationReferrerAdd', {url: vm.empConfigurationReferrerForm.url ? vm.empConfigurationReferrerForm.url : ""});
            $state.go('app.referrers_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }


  }

})();


(function ()
{
    'use strict';

    angular
        .module('app.configuration.presets.list')
        .controller('configurationPresetsDetailController', configurationPresetsDetailController);

    /** @ngInject */
    function configurationPresetsDetailController(configurationPresetsData,$mdDialog)
    {
    	var vm = this;
      vm.preset = configurationPresetsData;
      vm.cancel = cancel;

      function cancel(){
        $mdDialog.hide();
      }



    }



})();

(function () {
    'use strict';

    angular
        .module('app.media.home.push', [])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_home_push', {
                url: "/medias/homepage/push",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/home/push/push_video.template.html',
                        controller: 'HomeConfPushController as vm'
                    }
                },
                resolve: {
                    PushVideoData: function (msApi) {
                        return msApi.resolve('media_home.getpushVod@get');
                    }
                },
                "actionPermission" : "media_home_post_disable_push_video_action"
            });

        msApiProvider.register('media_home.getpushVod', [Routing.generate('api_media_get_push_video')]);
        msApiProvider.register('video-push.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('media_video.disablePushVideo', [Routing.generate('api_media_post_disable_push_video') + "/:id", {id: '@id'}]);

    }
})();


(function () {
  'use strict';

  angular
    .module('app.media.home.push')
    .controller('HomeConfPushController', HomeConfPushController);

  /** @ngInject */
  function HomeConfPushController(PushVideoData, webTvGlobal, $injector, $rootScope,$cookies,$sce,$scope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $sce = $injector.get('$sce'),
      msApi = $injector.get('msApi'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate');

    var vm = this;
    vm.disablePushVideo = disablePushVideo;
    initHelp();

    if (window.process.env.isNewPush) {
      vm.isNewPush = window.process.env.isNewPush;
      vm.newPushIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_Home_Videopush + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")
      );
      $scope.$watch(function () {
        vm.newPushIframe = $sce.trustAsResourceUrl(
          "https:" +
            window.process.env.URL_Home_Videopush + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")
        );
      });
    }
    

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.home_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_home_push_menuTitle";
        $rootScope.titre3 = "";
        $rootScope.pageRoute = '';
        $rootScope.welcome = "";
    }

    vm.PushVideoData = PushVideoData.data.video;
    vm.showPlayer = 0;
    vm.hasPushVideo = 0;
    if (vm.PushVideoData !== null) {
      var title_video = vm.PushVideoData.media.mp4File;
      var id_video = vm.PushVideoData.id;
      vm.startDate = new Date(vm.PushVideoData.startDate);
      vm.endDate = new Date(vm.PushVideoData.endDate);
      if (title_video)
        getPlayerLink();
      vm.hasPushVideo = 1;
    }

    /**
     * Get Player link, if a url is returned put in the iframe and show the player
     * @return {[type]} [description]
     */
    function getPlayerLink() {
      msApi.request(
        'video-push.getPreviewLink@get',
        {"id": id_video},
        function (res) {
          if (res.code === 200) {
            vm.showPlayer = 1;
            vm.playerLink = $sce.trustAsResourceUrl(res.link);
          }
          else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    /**
     * disable video push
     * @param   video
     * @param   event
     * @param index
     */
    function disablePushVideo(video) {
      msApi.request('media_video.disablePushVideo@save', {id: video.id},
        function (response) {
          if (response.code === 200) {
            $state.go('app.media_video_list', {type: "ongoing"});
          }
        }
      );
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.presets.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_presets_add', {
                url    : "/configuration/presets/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/presets/add_edit_view/add_edit.template.html',
                        controller : 'configurationPresetsAddController as vm'
                    }
                },
                resolve: {
                     configurationPresetsData: function (msApi)
                    {
						return msApi.resolve('configuration_presets.getNewPresetsData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_presets_post_add_action"
            });
        
        //API
        msApiProvider.register('configuration_presets.addPresets', [Routing.generate('api_configuration_post_add_preset')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.presets.add')
    .controller('configurationPresetsAddController', configurationPresetsAddController);

  /** @ngInject */
  function configurationPresetsAddController($rootScope, $translate, msApi, $state, configurationPresetsData, webTvGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = true;

    var presets = configurationPresetsData;
    vm.empConfigurationPresetsForm = {
      name: presets.name,
      bitrateVideo: presets.bitrateVideo,
      bitrateAudio: presets.bitrateAudio,
      samplerateAudio: presets.samplerateAudio,
      framerate: presets.framerate,
      state: presets.state
    };
    vm.submitAddPresetsForm = submitAddPresetsForm;


    /**
     * Send add Presets Form
     */
    function submitAddPresetsForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_presets.addPresets@save',
        {"empConfigurationPresetsForm": angular.copy(vm.empConfigurationPresetsForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            presets = vm.empConfigurationPresetsForm;
            webTvGlobal.$flashMessages().set('configurationPresetsAdd', {title: vm.empConfigurationPresetsForm.name ? vm.empConfigurationPresetsForm.name : ""});
            $state.go('app.configuration_presets_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_presets_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_presets_add_menuTitle";
      $rootScope.pageRoute = "app.configuration_presets_list";

      $rootScope.welcome = "welcome_preset_add";
      $rootScope.text = [{
        texte: "parameters_preset_add_help"
      }, {
        texte: "send_button_preset_add_help"
      }, {
        texte: "cancel_button_preset_add_help"
      }];

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.media.home.list', ["datatables"])
        .config(config);

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_home_list', {
                url: "/medias/homepage/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/home/list/list.template.html',
                        controller: 'HomeConfListController as vm'
                    }
                },
                resolve: {
                    channelChoices: function (msApi) {
                        return msApi.resolve('channel.channelChoices@get');
                    },
                    mediaList: function (msApi) {
                        return msApi.resolve('media_home.list@get');
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "media_home_get_home_conf_videos_action"
            });

        msApiProvider.register('media_home.list', [Routing.generate('api_media_get_home_page_videos', {idChannel: ':idChannel'}).replace(/%3A/, ":")]);
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('media_video.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);
        var deletevideoRoute = Routing.generate('api_media_delete_home_page_video') + "/:id";
        msApiProvider.register('media_video_home.delete', [deletevideoRoute, {id: '@id'}]);
        msApiProvider.register('media_home.updateOrder', [Routing.generate('api_media_edit_sort_home_page_videos')]);

    }

})();

(function () {
  'use strict';

  angular
    .module('app.media.home.list')
    .controller('HomeConfListController', HomeConfListController);

  /** @ngInject */
  function HomeConfListController(dtable_language, $cookies, mediaList, VideoGlobal, channelChoices, $mdSidenav, webTvGlobal, $injector,$scope,$sce) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);

    if (window.process.env.isNewHomeVid) {
      vm.isNewHomeVid = window.process.env.isNewHomeVid;
      vm.newHomeVideoIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_Home_VideosHome + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")
      );
      $scope.$watch(function () {
        vm.newHomeVideoIframe = $sce.trustAsResourceUrl(
          "https:" +
            window.process.env.URL_Home_VideosHome + "?lang="+ $cookies.get("WEBTV.locale") + "&token=" + $cookies.get("authToken")
        );
      });
    }


    vm.dtInstance = {};
    vm.search_homeVide = "";
    vm.mediaList = mediaList.data.videos;
    var recordsTotal = vm.mediaList.length;
    var order = {};
    order.channel = "";
    order.ids = [];
    var currentChannel = 0;
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the id column
          targets: 0,
          width: '72px',
          sortable: false
        },
        {
          // Target the id column
          targets: 1,
          width: '72px'
        },
        {
          // Target the image column
          targets: 2,
          filterable: false,
          sortable: false,
          width: '80px'
        },

        {
          // Target the actions column
          targets: 6,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#abonnement-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            if(event.which === 13){
              api.search(event.target.value).draw();
            }
          });
        }
      },
      pagingType: 'full_numbers',
      lengthMenu: [5,10, 20, 30, 50, 100],
      pageLength: 10,
      scrollY: 'auto',
      deferRender: false,
      responsive: true,
      language: dtable_language[$cookies.get('WEBTV.locale')]

    };
    $rootScope.DtOptions = vm.dtOptions;
    vm.sortableOptions = {
      items: '>tr',
      handle: '> .myHandleCursor',
      update: function (e, ui) {
        var length = vm.dtInstance.dataTable.fnSettings()._iDisplayLength;
        var currentPage = vm.dtInstance.DataTable.page();
        var initInterval = currentPage * length;
        order.channel = currentChannel;
        for (var i = 0; i < initInterval; i++) {
          order.ids[i] = vm.mediaList[i].id;
        }

        angular.element('table tbody tr').each(function (index) {
          order.ids[initInterval + index] = parseInt(angular.element(this)[0].cells[1].innerText);

        });

        for (var j = initInterval + length; j < vm.mediaList.length; j++) {
          order.ids[j] = vm.mediaList[j].id;
        }
        msApi.request('media_home.updateOrder@get', {data: order}, function () {

        }, function () {
          ui.item.sortable.cancel();
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        })
      },
      stop: function () {
      }
    };
    var filtre = {};

    vm.selectChanged = selectChanged;
    // Data

    // Methods
    vm.searchHomeVideo = searchHomeVideo;
    vm.deleteHomeVideoConfirm = deleteHomeVideoConfirm;
    vm.previewHomeVideo = previewHomeVideo;
    initHelp();

    function initHelp() {
        $rootScope.titre1 = "PAGESMENUSTITLES.home_menuTitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.media_home_list_menuTitle";
        $rootScope.titre3 = "";
        $rootScope.pageRoute = '';
        $rootScope.welcome = "";

    }

    //////////

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    /*function toggleSidenav(sidenavId) {
        $mdSidenav(sidenavId).toggle();
    }*/

    /////////////
    /*function preventDefault(event) {
        event.preventDefault();
        event.stopPropagation();
    }*/

    /**
     * Change canal
     */

    function selectChanged($id) {
      currentChannel = $id;
      if ($id) {
        msApi.request('media_home.list@get', {idChannel: $id},
          function (response) {
            if (response.code === 200) {
              vm.mediaList = response.data.videos;
              recordsTotal = vm.mediaList.length;
            }
            else {
              webTvGlobal.alertDialog($translate.instant('HOMECONFLIST.dialog_alert_get_list_by_canal'));
            }
          }, function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message)
                .then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        );
      } else {
        updateMedia();
      }

    }

    function deleteHomeVideoConfirm(video, ev) {
      $translate([
        "MESSAGES.dialog_confirm_delete",
        "MESSAGES.dialog_cancel",
        "MESSAGES.dialog_will_be_deleted",
        "HOMECONFLIST.delete_video_msg",
        "HOMECONFLIST.delete_group_aria_label"
      ])
        .then(function (translatedValues) {
          var confirm = $mdDialog.confirm()
            .title(translatedValues['HOMECONFLIST.delete_group_msg'])
            .htmlContent('<b>' + video.title + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
            .ariaLabel(translatedValues['HOMECONFLIST.delete_group_aria_label'])
            .targetEvent(ev)
            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
            .cancel(translatedValues['MESSAGES.dialog_cancel']);

          $mdDialog.show(confirm).then(function () {
            deleteHomeConf(video);
          }, function () {

          });
        });


    }

    function previewHomeVideo(video, event) {
      if (!video) return;
      VideoGlobal.showPreviewVideo({id: video}, event);


    }

    function updateMedia() {

      msApi.request('media_home.list@get', function (res) {
          vm.mediaList = res.data.videos;
          recordsTotal = vm.mediaList.length;
        },
        function () {
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        });
    }

    function deleteHomeConf(video) {
      if (vm.mediaList.indexOf(video) !== -1) {
        $rootScope.loadingProgress = true;
        msApi.request('media_video_home.delete@delete', {id: video.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (response.code === 200) {
              webTvGlobal.$toast().showSimple(video.title + $translate.instant('VIDEOLIST.dialog_alert_delete_description'));
              vm.mediaList.splice(vm.mediaList.indexOf(video), 1);

            } else {
              $translate([
                "VIDEOLIST.dialog_alert_delete_error_title",
                "VIDEOLIST.dialog_alert_delete_error_description",
                "VIDEOLIST.dialog_alert_delete_close"
              ])
                .then(function () {
                  $mdDialog.show(alert).finally(function () {
                    alert = undefined;
                  });
                });
            }
          },
          function (response) {
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        );
      }
    }


    function searchHomeVideo() {
      filtre["search[value]"] = vm.search_homeVideo;
      searchHomeVideoInAPI(filtre);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.media.home.conf', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.media_home_conf', {
                url: "/medias/homepage/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/home/conf/add_edit.template.html',
                        controller: 'homeConfAddController as vm'
                    }
                },
                resolve: {
                    homeConfData: function (msApi) {
                        return msApi.resolve('home_conf.getNewConfData@get');
                    },
                    channelChoices: function (msApi) {
                        return msApi.resolve('channel.channelChoices@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "media_home_post_add_home_conf_action"
            });

        //API
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('home_conf.getNewConfData', [Routing.generate('api_media_get_home_confd')]);
        msApiProvider.register('home_conf.addConf', [Routing.generate('api_media_post_add_home_conf')]);
        msApiProvider.register('home_conf.gethomeConfByCanal', [Routing.generate('api_media_gethome_conf_by_canal', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('home_conf.gethomeConfVideoByCanal', [Routing.generate('api_media_get_home_conf_video_by_canal', {id: ':id'}).replace(/%3A/, ":")])


    }
})();
(function () {
  'use strict';

  angular
    .module('app.media.home.conf')
    .controller('homeConfAddController', homeConfAddController);

  /** @ngInject */
  function homeConfAddController(homeConfData, channelChoices, $injector,$sce, webTvGlobal, $rootScope, $state,$scope,$cookies,$http) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    /**
     *Injected Vars
     */

    var $translate = $injector.get('$translate'),
      msApi = $injector.get('msApi');


    var vm = this;
    vm.channels = webTvGlobal.convertToSelectChoicesFormat(channelChoices.choices);
    var conf = homeConfData;

    vm.empHomeConfForm = {
      "pageOption": conf.pageOption,
      "nbVid": conf.nbVid,
      "channel": conf.channel
    };
    vm.submitAddConfForm = submitAddConfForm;
    vm.selectChanged = selectChanged;
    initHelp();

    if (window.process.env.isNewConf) {
      vm.isNewConf = window.process.env.isNewConf;
      vm.newConfIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_Home_Conf  + "?lang="+ $cookies.get("WEBTV.locale") + "&token=" + $cookies.get('authToken')
      );
      $scope.$watch(function () {
        vm.newConfIframe = $sce.trustAsResourceUrl(
          "https:" +
            window.process.env.URL_Home_Conf  + "?lang="+ $cookies.get("WEBTV.locale") + "&token=" + $cookies.get('authToken')
        );
      });
    }
 
 

    function initHelp() {

      $rootScope.titre1 = "PAGESMENUSTITLES.home_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.home_conf_add_menuTitle";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = '';
      $rootScope.welcome = "";

    }

    /**
     * Send add Conf Form
     */
    function submitAddConfForm() {
      $rootScope.loadingProgress = true;
      var empHomeConfForm = angular.copy(vm.empHomeConfForm);
      if(empHomeConfForm.video && empHomeConfForm.video == -1){
        delete empHomeConfForm.video;
      }
      msApi.request('home_conf.addConf@save',
        {"empHomeConfForm": empHomeConfForm, 'channel': vm.empHomeConfForm.channel},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            conf = vm.empHomeConfForm;
            webTvGlobal.$toast().showSimple(vm.empHomeConfForm.channel + $translate.instant("MESSAGES.update_success"));
            $state.go('app.media_home_conf');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));

          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    /**
     * Change canal
     */
    function selectChanged($id) {
      msApi.request('home_conf.gethomeConfByCanal@get', {id: $id},
        function (res) {
          if (res.code === 200) {
            var msg = $translate.instant('LIVESLIST.send_succes');
            if (!angular.isUndefined(res.home[0])) {
              conf = res.home[0];
              vm.empHomeConfForm = {
                "pageOption": conf.pageOption,
                "nbVid": conf.nbVid,
                "video": conf.video,
                "channel": $id
              };
            }

          }
          /*  else if (res.code !== 200) {
                if (!angular.isUndefined(res.home)) {
                    vm.conf = res.home;
                    vm.empHomeConfForm = {
                        "pageOption": vm.conf.pageOption,
                        "firstVid": vm.conf.firstVid,
                        "channel": $id
                    };
                } else {
                    vm.empHomeConfForm = {
                        "pageOption": null,
                        "nbVid": 0,
                        "firstVid": null,
                        "video": null,
                        "channel": $id
                    };
                }

            }*/
        }
      );
      msApi.request('home_conf.gethomeConfVideoByCanal@get', {id: $id},
        function (res) {
          vm.videos = webTvGlobal.convertToSelectChoicesFormat(res.data.videos);

        }
      );
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.mooc.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.param_mooc_add', {
                url: "/configuration/mooc/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/mooc/add_edit_view/add_edit.template.html',
                        controller : 'ParamMoocAddController as vm'
                    }
                },
                resolve: {
                     ParamData: function (msApi)
                    {
						return msApi.resolve('mooc.getNewMoocsData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });
        
        //API
msApiProvider.register('mooc.getNewMoocsData', [Routing.generate('api_get_detail_param_mooc',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('mooc.addMooc', [Routing.generate('api_post_add_mooc_param')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.mooc.add')
    .controller('ParamMoocAddController', ParamMoocAddController);

  /** @ngInject */
  function ParamMoocAddController($rootScope, $translate, msApi, $state, ParamData, webTvGlobal) {
      var myEl = angular.element(document.querySelector('#content'));
      if (angular.isDefined(myEl)) ;
      myEl.removeClass('animate-slide-up');
      var vm = this;
      vm.isNew = true;
      var param = ParamData;

      vm.empParamForm = {
          cle: param.cle,
          value: param.value
      };
      vm.submitAddParamForm = submitAddParamForm;


      /**
       * Send add Params Form
       */
      function submitAddParamForm() {
          $rootScope.loadingProgress = true;
          msApi.request('mooc.addMooc@save',
              {"empMoocParametersForm": angular.copy(vm.empParamForm)},
              function (res) {
                  $rootScope.loadingProgress = false;
                  if (res.code === 200) {

                      param = vm.empParamForm;
                      webTvGlobal.$flashMessages().set('ParamAdd', {title: vm.empParamForm.cle ? vm.empParamForm.cle : ""});
                      $state.go('app.configuration_mooc_list');
                  }
                  else {
                      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                  }
              },
              function () {
                  $rootScope.loadingProgress = false;
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              }
          );
      }


      initHelp();

      function initHelp() {
          $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.param_list_menuTitle";
          $rootScope.titre3 = "PAGESMENUSTITLES.param_add_menuTitle";
          $rootScope.pageRoute = "app.configuration_mooc_list";
          $rootScope.welcome = "welcome_client_add";
          $rootScope.text = [{
              texte: "parameters_client_add_help"
          }, {
              texte: "send_button_client_add_help"
          }, {
              texte: "cancel_button_client_add_help"
          }];

      }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration_mooc.list', ["datatables"])
        .config(config);

  

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_mooc_list', {
                url: '/mooc_config',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/mooc/list/list.template.html',
                        controller: 'MoocConfigurationListController as vm'
                    }
                },
                resolve: {
                    moocParametersData: function (msApi) {
                        return msApi.resolve('mooc_parameters.list@get');
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // Api
        var deleteparamRoute = Routing.generate('api_delete_mooc_param') + "/:id";
        msApiProvider.register('cle_mooc.mdelete', [deleteparamRoute, {id: '@id'}]);

        msApiProvider.register('mooc_parameters.list', [Routing.generate('api_get_mooc_parameters')]);
        msApiProvider.register('mooc_parameters.updateKey', [Routing.generate('api_update_mooc_parameter')]);
        var deleteListParams=Routing.generate('api_multi_delete_multi_configuration_mooc')+"/:list";
        msApiProvider.register('mooc.deleteMoocs', [deleteListParams, {list: '@list'}]);

    }
})();

(function () {
  'use strict';

  angular
    .module('app.configuration_mooc.list')
    .controller('MoocConfigurationListController', MoocConfigurationListController);

  /** @ngInject */
  function MoocConfigurationListController(dtable_language, $cookies, moocParametersData, $injector, webTvGlobal, $state,dialogConfirmDeleteService) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      $document = webTvGlobal.$document;

    var vm = this;

      vm.moocParameters = moocParametersData.MoocParameters;

      if (!angular.isDefined(vm.moocParametersArray)) {

      vm.moocParametersArray = formatPPdata(moocParametersData.MoocParameters, []);

    }
      vm.deleteSelectedParamsConfirm = deleteSelectedParamsConfirm;
      vm.deleteParamsConfirm = deleteParamsConfirm;
    vm.toggleAll = toggleAll;
    vm.toggle = toggle;
    var flashMessages = {title: ""};
    vm.selectedParamss = [];
    var selectedParamss = [];
    vm.dtInstance = {};
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the actions column
          targets: 2,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#pp-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            if(event.which === 13){
              api.search(event.target.value).draw();
            }
          });
        }
      },
      pagingType: 'full_numbers',
      lengthMenu: [5,10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true,
      language: dtable_language[$cookies.get('WEBTV.locale')]

    };
    vm.openPPEditDialog = openPPEditDialog;
    vm.addNewMooc = addNewMooc;
    $rootScope.rerender = rerender;

    function rerender() {
      if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }

    $rootScope.DtOptions = vm.dtOptions;

    function addNewMooc() {
      clearFlashMessage();
      $state.go('app.param_mooc_add');
    }

    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    function getElement() {
      var element = document.querySelectorAll('md-checkbox.md-default-theme');

      var left = element[0].offsetLeft;

      var leftDelete = left - 35;

      $scope.myObjStyle = {"margin-left": leftDelete}
    }

    function openPPEditDialog(pair, index, event) {
      $mdDialog.show({
        controller: function ($mdDialog, $translate, pair, listController, index) {
          var vm = this;
          vm.pair = angular.copy(pair);
          vm.listController = listController;
          vm.closeDialog = closeDialog;
          vm.editPPKey = editPPKey;

          function closeDialog() {
            $mdDialog.hide();
          }

          function editPPKey($ev) {
            msApi.request(
              'mooc_parameters.updateKey@save',
              {
                key: vm.pair.key,
                value: vm.pair.value,
                id: vm.pair.id
              },
              function (res) {
                if (res.code === 200) {
                  vm.listController.moocParametersArray[index].value = vm.pair.value;

                }
                else vm.listController.moocParameters[vm.pair.key] = vm.pair.key;
                vm.moocParametersArray = formatPPdata(vm.listController.moocParameters, []);
                closeDialog();
              },
              function (res) {
                vm.listController.moocParameters[vm.pair.key] = vm.pair.value;
                webTvGlobal.alertDialog(res.data.message, '', '', $ev);
              }
            );

          }

        },
        controllerAs: 'vm',
        templateUrl: 'app/main/configuration/mooc/list/list.controller_template.html',
        targetEvent: event,
        clickOutsideToClose: true,
        locals: {
          pair: pair,
          listController: vm,
          index: index

        }
      }).then(function () {
        // rerender();
      });
    }

    function formatPPdata(data, formattedArray) {
      var dataFormatted = [];
      var key, value, id;
      for (var i = 0; i < data.length; i++) {
        dataFormatted = data[i];
        for (var prop in dataFormatted) {
          if (prop !== "id") {
            key = prop;
            value = dataFormatted[prop];
          }
          else if (prop === "id") {
            formattedArray.push({
              key: key,
              value: value,
              id: dataFormatted[prop]
            })
          }

        }
      }
      return formattedArray;
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_mooc";
      $rootScope.titre3 = "PAGESMENUSTITLES.config_mooc_list_menuTitle";
      $rootScope.pageRoute = "";
      $rootScope.welcome = "welcome_group_add";
      $rootScope.text = [{
        texte: "add_button_user_help"
      }, {
        texte: "arrow_button_user_help"
      }, {
        texte: "search_area_user_help"
      }, {
        texte: "tri_column_user_help"
      },
        {
          texte: "edit_button_user_help"
        }, {
          texte: "detail_button_user_help"
        },
        {
          texte: "delete_button_user_help"
        }];

    }

    /**
     * Clear Flash Message when an action is triggered
     */
    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    /**
     * Delete param Confirm Dialog
     */
    function deleteParamsConfirm(param, ev) {
      $translate([
        "MESSAGES.dialog_confirm_delete",
        "MESSAGES.dialog_cancel",
        "MESSAGES.dialog_will_be_deleted",
        "PARAMLIST.delete_Params_msg",
        "PARAMLIST.delete_param_aria_label"
      ])
        .then(function (translatedValues) {
          var confirm = $mdDialog.confirm()
            .title(translatedValues['PARAMLIST.delete_Params_msg'])
            .htmlContent('<b>' + param.key + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
            .ariaLabel(translatedValues['PARAMLIST.delete_param_aria_label'])
            .targetEvent(ev)
            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
            .cancel(translatedValues['MESSAGES.dialog_cancel']);

          $mdDialog.show(confirm).then(function () {

            deleteParams(param);
            // vm.selectedParamss = [];
              selectedParamss = [];
            //rerender();
          }, function () {
          });
        });
    }

    function toggle(mooc) {
        // getElement();
        mooc.checked = !mooc.checked;
        var idx = selectedParamss.indexOf(mooc);
        if (idx > -1) {
            selectedParamss.splice(idx, 1);
        }
        else {
            selectedParamss.push(mooc);
        }
        vm.selectedParamss = angular.copy(selectedParamss);
    }



    function toggleAll() {
        // getElement();
        if (selectedParamss.length === vm.moocParametersArray.length) {
            vm.selectedParamss = [];
        }

        else if ((selectedParamss.length === 0) || (selectedParamss.length > 0)) {
            vm.selectedParamss = vm.moocParametersArray.slice(0);
        }
        selectedParamss = angular.copy(vm.selectedParamss);
        var list_mooc = angular.copy(vm.moocParametersArray);
        angular.forEach(list_mooc, function (value, key) {
            if (value !== undefined)
                vm.moocParametersArray[key].checked = selectedParamss.length > 0;
        });
    }


    /**
     * Delete param
     */
    function deleteParams(params) {
      clearFlashMessage();
      if (vm.moocParametersArray.indexOf(params) !== -1) {
        $rootScope.loadingProgress = true;
        msApi.request('cle_mooc.mdelete@delete', {id: params.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (response.code === 200) {
              $translate([
                "PARAMLIST.dialog_alert_delete_title",
                "PARAMLIST.dialog_alert_delete_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  webTvGlobal.$toast().showSimple(params.key + translatedValues['PARAMLIST.dialog_alert_delete_description']);
                  vm.moocParametersArray.splice(vm.moocParametersArray.indexOf(params), 1);
                  //rerender();
                });

            }
            else {
              $translate([
                "PARAMLIST.dialog_alert_delete_error_title",
                "PARAMLIST.dialog_alert_delete_error_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['PARAMLIST.dialog_alert_delete_error_title'],
                    textContent: translatedValues['PARAMLIST.dialog_alert_delete_error_description'],
                    ok: translatedValues['PARAMLIST.dialog_alert_delete_close']
                  });
                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                });

            }
          }
        );

      }
    }
      /* delete selected groups*/
      function deleteSelectedParamsConfirm(ev) {
          var title;
          var ariaLabel;
          if (selectedParamss.length !== 0) {
              if(selectedParamss.length === 1){
                  title = 'PARAMLIST.delete_Param_msg';
                  ariaLabel = 'PARAMLIST.delete_Param_aria_label';
              }else{
                  title = 'PARAMLIST.delete_list_Param_msg';
                  ariaLabel = 'PARAMLIST.delete_Params_aria_label';
              }
              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,selectedParamss.length,title,ariaLabel)).then(function () {
                  deleteSelectedParams(ev);
              }, function () {
              });

          }



      }
      function deleteSelectedParams(ev) {
          clearFlashMessage();

          $rootScope.loadingProgress = true;

          msApi.request('mooc.deleteMoocs@delete', {
                  list: (function (list) {
                      selectedParamss.forEach(function (item) {
                          list.push(item.id);
                      });
                      return list;
                  })([])
              },
              function (response) {
                  $rootScope.loadingProgress = false;
                  if (response.code === 200) {
                      var undeleted = "";
                      var deleted;
                      if (response.result.undeleted.length !== 0) {
                          undeleted = $translate.instant("PARAMLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                      }
                      deleted = $translate.instant("PARAMLIST.deleted_are", {'list': response.result.deleted.join(",")});
                      webTvGlobal.alertDialog(
                          deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                          $translate.instant('PARAMLIST.dialog_alert_delete_title'),
                          '',
                          ev
                      );
                      selectedParamss = [];
                      rerender();

                  }
                  else {
                      webTvGlobal.alertDialog(
                          $translate.instant('PARAMLIST.dialog_alert_delete_error_title'),
                          $translate.instant('PARAMLIST.dialog_alert_delete_error_description'),
                          '',
                          ev
                      );
                      selectedParamss = [];
                  }
              },
              function (response) {
                  $rootScope.loadingProgress = false;
                  if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                      $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                          webTvGlobal.alertDialog(message);
                      }, function () {
                          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                      });
                  }
                  else {
                      webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                  }
                  selectedParamss = [];
                  vm.modelCheckAll = false;

              }
          );


      }

  }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_news_list', {
                url: "/configuration/news/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/news/list/list.template.html',
                        controller: 'configurationNewsListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });

        // Api
        var deleteNewsRoute = Routing.generate('api_news_delete_new') + "/:id";
        msApiProvider.register('configuration_news.list', [Routing.generate('api_dtable_list_dtable_news')]);
        msApiProvider.register('configuration_news.mdelete', [deleteNewsRoute, {id: '@id'}]);
        msApiProvider.register('configuration_news.modalGetNews', [Routing.generate('api_news_get_detail_new', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteListNewss = Routing.generate('api_multi_delete_news') + "/:list";
        msApiProvider.register('configuration_news.deleteNewss', [deleteListNewss, {list: '@list'}]);


    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news.list')
        .controller('configurationNewsListController', configurationNewsListController);

    /** @ngInject */
    function configurationNewsListController(webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $scope, $cookies, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $state = $injector.get('$state'),
            $compile = $injector.get('$compile'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils'),
            $translate = $injector.get('$translate');

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_news_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_news_list_pagetitle";

            $rootScope.welcome = "welcome_news";
            $rootScope.text = [{
                texte: "add_button_news_help"
            }, {
                texte: "arrow_button_news_help"
            }, {
                texte: "search_area_news_help"
            }, {
                texte: "tri_column_news_help"
            },
                {
                    texte: "edit_button_news_help"
                },
                {
                    texte: "delete_button_news_help"
                }];

        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        //vm.partentIdPlaceHolder="STATIONADD.form_placeholder_parentId";
        //vm.stations=configurationStationListData.data.stations;
        //Data Table options
        vm.newss = [];
        vm.selectedNewss = [];
        var selectedNewss = [];
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.newssDataTable = {};
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: 2,
                    filterable: true,
                    sortable: true,
                    width: '80px'
                }, {
                    targets: 4,
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchNewssInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_news.list@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.newss = response.data;
                        vm.fnCallback(records);
                       webTvGlobal.fixDatatableFirefox();

                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.newss = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectednewss = [];
            selectedNewss = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_newss,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchNewssInAPI(filtre);

        }

        function searchNewss() {
            filtre["search[value]"] = vm.search_newss;
            searchNewssInAPI(filtre);

        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.newssDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.newssDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.newssDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('content').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('startDate').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? moment(data).format($rootScope.defaultDateFormat) : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.newssDataTable[data.id] = data;

                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'NEWSLIST.update_news'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.configuration_news_edit({id: ' + data.id + '})" aria-label="update_news" translate translate-attr-aria-label="NEWSLIST.update_news" has-permission="configuration_newss_post_edit">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'NEWSLIST.delete_news'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button"  ng-click="vm.deleteNewsConfirm(vm.newssDataTable[' + data.id + '],ev)" aria-label="delete_news" translate translate-attr-aria-label="NEWSLIST.delete_news" has-permission="configuration_newss_delete_news">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button>' +
                        '</a>';

                    return buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchNewss = searchNewss;
        vm.deleteNewsConfirm = deleteNewsConfirm;
        vm.deleteSelectedNewssConfirm = deleteSelectedNewssConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showNewsDetail = showNewsDetail;
        vm.addNewNews = addNewNews;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationNewsAdd', $translate.instant('NEWSLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationNewsEdit', $translate.instant('NEWSLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * @param news
         */
        function toggle(news) {
            getElement();
            news.checked = !news.checked;
            var idx = selectedNewss.indexOf(news);
            if (idx > -1) {
                selectedNewss.splice(idx, 1);
            }
            else {
                selectedNewss.push(news);
            }
            vm.selectedNewss = angular.copy(selectedNewss);
        }


        function toggleAll() {
            getElement();
            if (selectedNewss.length === vm.newss.length) {
                vm.selectedNewss = [];
            }

            else if ((selectedNewss.length === 0) || (selectedNewss.length > 0)) {
                vm.selectedNewss = vm.newss.slice(0);
            }
            selectedNewss = angular.copy(vm.selectedNewss);
            var list_canals = angular.copy(vm.newssDataTable);
            angular.forEach(list_canals, function (value, key) {
                if (value !== undefined)
                    vm.newssDataTable[key].checked = selectedNewss.length > 0;
            });
        }

        /**
         * Show NewsDetails
         * @param news
         */
        function showNewsDetail(news, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('configuration_news.modalGetNews@get', {id: news.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationNewsData: response},
                            templateUrl: 'app/main/configuration/news/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationNewsDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchNewssInAPI(filtre), true);
        }


        /**
         * renews to add new news page
         * @param event
         */
        function addNewNews() {
            clearFlashMessage();
            $state.go('app.configuration_news_add');
        }

        /**
         * Delete NewsConfirm Dialog
         */
        function deleteNewsConfirm(News, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "NEWSLIST.dialog_will_be_deleted_news",
                "NEWSLIST.delete_news_msg",
                "NEWSLIST.delete_news_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['NEWSLIST.delete_news_msg'])
                        .htmlContent('<b>' + News.content + '</b>' + translatedValues['NEWSLIST.dialog_will_be_deleted_news'])
                        .ariaLabel(translatedValues['NEWSLIST.delete_news_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteNews(News);
                        vm.selectedNewss = [];
                        selectedNewss = [];
                    }, function () {

                    });
                });


        }

        /**
         * Delete News
         */
        function deleteNews(News) {
            clearFlashMessage();
            if (vm.newss.indexOf(News) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_news.mdelete@delete', {id: News.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "NEWSLIST.dialog_alert_delete_title",
                                "NEWSLIST.dialog_alert_delete_description",
                                "NEWSLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['NEWSLIST.dialog_alert_delete_title'],
                                        textContent: News.title + translatedValues['NEWSLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['NEWSLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.newss.splice(vm.newss.indexOf(News), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "NEWSLIST.dialog_alert_delete_error_title",
                                "NEWSLIST.dialog_alert_delete_error_description",
                                "NEWSLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['NEWSLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['NEWSLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['NEWSLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                                webTvGlobal.alertDialog(message);
                            }), function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            };
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        function deleteSelectedNewssConfirm(ev) {
          var title;
          var ariaLabel;
            if (vm.selectedNewss.length !== 0) {
              if (vm.selectedNewss.length === 1) {
                title = 'NEWSLIST.delete_element_newss_msg';
                ariaLabel = 'NEWSLIST.delete_newss_aria_label';
              } else {
                title = 'NEWSLIST.delete_list_newss_msg';
                ariaLabel = 'NEWSLIST.delete_newss_aria_label';
              }

              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedNewss.length, title, ariaLabel)).then(function () {

                            deleteSelectedNewss(ev);



                    });

            }

        }

        /* delete selected groups*/
        function deleteSelectedNewss(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('configuration_news.deleteNewss@delete', {
                    list: (function (list) {
                        vm.selectedNewss.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("NEWSLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("NEWSLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('NEWSLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        vm.selectedNewss = [];
                        selectedNewss = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('NEWSLIST.dialog_alert_delete_error_title'),
                            $translate.instant('NEWSLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        vm.selectedNewss = [];
                        selectedNewss = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.selectedNewss = [];
                    selectedNewss = [];
                    vm.modelCheckAll = false;

                }
            );


        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_news_edit', {
                url: "/configuration/news/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/news/add_edit_view/add_edit.template.html',
                        controller: 'configurationNewsEditController as vm'
                    }
                },
                resolve: {
                    configurationNewsData: function (msApi, $stateParams) {
                        return msApi.resolve('configuration_news.getNews@get', {id: $stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // API
        msApiProvider.register('configuration_news.getNews', [Routing.generate('api_news_get_detail_new', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('configuration_news.editNews', [Routing.generate('api_news_post_edit_new', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.configuration.news.edit')
        .controller('configurationNewsEditController', configurationNewsEditController);

    /** @ngInject */
    function configurationNewsEditController(webTvGlobal, configurationNewsData, $rootScope, $injector) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');
        var vm = this;
        vm.isNew = false;
        $rootScope.itemName = "";
        var news = configurationNewsData;
        vm.empConfigurationNewsForm = {};
        vm.submitAddNewsForm = submitAddNewsForm;
        fillData();
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_news_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_news_edit_pagetitle";
            $rootScope.pageRoute = "app.configuration_news_list";

            $rootScope.welcome = "welcome_news_edit";
            $rootScope.text = [{
                texte: "parameters_news_add_help"
            }, {
                texte: "send_button_news_edit_help"
            }, {
                texte: "cancel_button_news_add_help"
            }];

        }


        /**
         * Check if news exists
         * @return if exists get News Data else redirect to 404 page
         */

        function fillData() {

            if (angular.isDefined(news.code) && news.code !== 200) $state.go('app.error_404');
            else {

                vm.empConfigurationNewsForm = {
                    content: news.content,
                    startDate: new Date(moment(news.startDate))

                };

            }
        }

        // vm.changeDate = changeDate;
        //
        // function changeDate() {
        //     vm.empConfigurationNewsForm.startDate = vm.empConfigurationNewsForm.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empConfigurationNewsForm.startDate).format('YYYY-MM-DD'));
        // }

        /**
         * Send add News Form
         */
        function submitAddNewsForm() {
            $rootScope.loadingProgress = true;
            msApi.request('configuration_news.editNews@save',
                {id: news.id, "empParametersNewsForm": angular.copy(vm.empConfigurationNewsForm)},
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        news = vm.empConfigurationNewsForm;
                        // webTvGlobal.$flashMessages().set('configurationNewsEdit', news);
                        $state.go('app.configuration_news_list');
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                    }
                },
                function () {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );


        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news.list')
        .controller('configurationNewsDetailController', configurationNewsDetailController);

    /** @ngInject */
    function configurationNewsDetailController(configurationNewsData, $mdDialog) {
        var vm = this;
        vm.news = configurationNewsData;
        vm.cancel = cancel;


        function cancel() {
            $mdDialog.hide();
        }

    }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration.client.list', ["datatables"])
        .config(config);

  

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.param_list', {
                url: "/configuration/client/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/client/list/list.template.html',
                        controller: 'ParamListController as vm'
                    }
                },
                resolve: {
                    ParamListData: function (msApi) {
                        return msApi.resolve('param.list@get');
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "param_list_dtable_params_action"
            });

        // Api
        var deleteparamRoute = Routing.generate('api_params_delete_param') + "/:id";
        msApiProvider.register('param.list', [Routing.generate('api_params_get_params')]);
        msApiProvider.register('param.mdelete', [deleteparamRoute, {id: '@id'}]);
        msApiProvider.register('param.modalGetParam', [Routing.generate('api_params_get_detail_param', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        var deleteListParams=Routing.generate('api_multi_delete_multi_params')+"/:list";
        msApiProvider.register('param.deleteParams', [deleteListParams, {list: '@list'}]);

    }
})();

(function () {
  'use strict';

  angular
    .module('app.configuration.client.list')
    .controller('ParamDetailController', ParamDetailController);

  /** @ngInject */
  function ParamDetailController(ParamData,$mdDialog) {
    var vm = this;
    vm.param = ParamData;
    vm.cancel = cancel;

    function cancel() {
      $mdDialog.hide();
    }

  }

})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_news_add', {
                url: "/configuration/news/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/news/add_edit_view/add_edit.template.html',
                        controller: 'configurationNewsAddController as vm'
                    }
                },
                resolve: {
                    configurationNewsData: function (msApi) {
                        return msApi.resolve('configuration_news.getNewNewsData@get', {id: 0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });

        //API
        msApiProvider.register('configuration_news.getNewNewsData', [Routing.generate('api_news_get_detail_new', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('configuration_news.addNews', [Routing.generate('api_news_post_add_new')]);


    }
})();
(function () {
    'use strict';

    angular
        .module('app.configuration.news.add')
        .controller('configurationNewsAddController', configurationNewsAddController);

    /** @ngInject */
    function configurationNewsAddController(configurationNewsData, webTvGlobal, $injector) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi');

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_news_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_news_add_menuTitle";
            $rootScope.pageRoute = "app.configuration_news_list";

            $rootScope.welcome = "welcome_news_add";
            $rootScope.text = [{
                texte: "parameters_news_add_help"
            }, {
                texte: "send_button_news_add_help"
            }, {
                texte: "cancel_button_news_add_help"
            }];

        }

        var vm = this;
        vm.isNew = true;
        var news = configurationNewsData;
        vm.empConfigurationNewsForm = {
            content: news.content,
            startDate: new Date()


        };
        vm.submitAddNewsForm = submitAddNewsForm;
        vm.changeDate = changeDate;

        function changeDate() {
            vm.empConfigurationNewsForm.startDate = vm.empConfigurationNewsForm.startDate.replace(/[0-9]{4}-[0-9]{2}-[0-9]{2}/, moment(vm.empConfigurationNewsForm.startDate).format('YYYY-MM-DD'));
        }

        /**
         * Send add News Form
         */
        function submitAddNewsForm() {
            $rootScope.loadingProgress = true;
            if (angular.isDefined(vm.empConfigurationNewsForm.mdTime)) delete vm.empConfigurationNewsForm.mdTime;
            msApi.request('configuration_news.addNews@save',

                {"empParametersNewsForm": angular.copy(vm.empConfigurationNewsForm)},
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        news = vm.empConfigurationNewsForm;
                        // webTvGlobal.$flashMessages().set('configurationNewsAdd', {title: vm.empConfigurationNewsForm.title ? vm.empConfigurationNewsForm.title : ""});
                        $state.go('app.configuration_news_list');
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                        //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
                    }
                },
                function () {
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );
        }


    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.client.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.param_edit', {
                url: "/configuration/client/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/client/add_edit_view/add_edit.template.html',
                        controller : 'ParamEditController as vm'
                    }
                },
                resolve: {
                     ParamData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('param.getParams@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });


        // API
        msApiProvider.register('param.getParams', [Routing.generate('api_params_get_detail_param',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('param.editParams', [Routing.generate('api_params_post_edit_param',{id: ':id'}).replace(/%3A/,":"),{id : '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.client.edit')
    .controller('ParamEditController', ParamEditController);

  /** @ngInject */
  function ParamEditController(webTvGlobal, $translate, msApi, $rootScope, $state, ParamData) {

    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var param = ParamData;
    var empParamForm = {};
    vm.submitAddParamForm = submitAddParamForm;
    fillData();


    /**
     * Check if Params exists
     * @return if exists get Params Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(param.code) && param.code !== 200) $state.go('app.error_404');
      else {
        vm.empParamForm = {
          cle: param.cle,
          value: param.value
        };
      }
    }


    /**
     * Send add Params Form
     */
    function submitAddParamForm() {
      $rootScope.loadingProgress = true;
      msApi.request('param.editParams@save',
        {id: param.id, "empParamForm": angular.copy(vm.empParamForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            param = vm.empParamForm;
            webTvGlobal.$flashMessages().set('ParamEdit', {title: vm.empParamForm.cle ? vm.empParamForm.cle : ""});
            $state.go('app.param_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.param_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.param_edit_pagetitle";
      $rootScope.pageRoute = "app.param_list";
      $rootScope.welcome = "welcome_client_edit";
      $rootScope.text = [{
        texte: "parameters_client_add_help"
      }, {
        texte: "send_button_client_edit_help"
      }, {
        texte: "cancel_button_client_add_help"
      }];

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('app.configuration.client.list')
    .controller('ParamListController', ParamListController);

  /** @ngInject */
  function ParamListController(ParamListData, webTvGlobal, $injector,$cookies, $scope,dialogConfirmDeleteService,dtable_language, $sce) {

    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi'),
      msUtils = $injector.get('msUtils');
    var vm = this;
    vm.params = ParamListData.data.params;
    vm.selectedParamss = [];
    var selectedParamss = [];
    vm.dtInstance = {};
    if (window.process.env.isNewClient) {
      vm.isNewClient = window.process.env.isNewClient;
      vm.newClientIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_Configuration_Client + "?lang="+ $cookies.get("WEBTV.locale") + "&token=" + $cookies.get("authToken") 
      );
      $scope.$watch(function () {
        vm.newClientIframe = $sce.trustAsResourceUrl(
          "https:" +
          window.process.env.URL_Configuration_Client + "?lang="+ $cookies.get("WEBTV.locale") + "&token=" + $cookies.get("authToken")
        );
      });
    }
    vm.dtOptions = {
      dom: 'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>',
      columnDefs: [
        {
          // Target the id column
          targets: [0, 1],
          width: '72px'
        },


        {
          // Target the actions column
          targets: 3,
          responsivePriority: 1,
          filterable: false,
          sortable: false
        }
      ],
      language:dtable_language[$cookies.get('WEBTV.locale')],
      initComplete: function () {
        var api = this.api(),
          searchBox = angular.element('body').find('#params-search');

        // Bind an external input as a table wide search box
        if (searchBox.length > 0) {
          searchBox.on('keyup', function (event) {
            if(event.which === 13){
              api.search(event.target.value).draw();
            }
          });
        }
      },
      pagingType: 'full_numbers',
      lengthMenu: [5,10, 20, 30, 50, 100],
      pageLength: 20,
      scrollY: 'auto',
      responsive: true

    };
    var flashMessages = {title: ""};

    vm.deleteSelectedParamsConfirm = deleteSelectedParamsConfirm;
    vm.deleteParamsConfirm = deleteParamsConfirm;
    vm.toggleAll = toggleAll;
    vm.toggle = toggle;
    vm.showParamsDetail = showParamsDetail;

    vm.addNewParams = addNewParams;
    $rootScope.rerender = rerender;
    showFlasMessageToast('ParamAdd', $translate.instant('PARAMLIST.added'), {
      bottom: true,
      top: false,
      left: false,
      right: true
    });
    showFlasMessageToast('ParamEdit', $translate.instant('PARAMLIST.edited'));

    /**
     * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
     * @param  op : crud operation
     * @param  message message to show
     * @param  toastPosition position of the toast
     */
    function showFlasMessageToast(op, message, toastPosition) {
      if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

    }


    /**
     * Check If there's and CRUD Operation that happened before getting to the list page
     * @param   op : operation name
     * @return  bool
     */
    function checkFlashMessage(op) {
      var data = webTvGlobal.$flashMessages().get(op);
      if (!flashMessages.title) flashMessages.title = data ? data.title : "";
      return data ? true : false;
    }

    /**
     * Clear Flash Message when an action is triggered
     */
    function clearFlashMessage() {
      if (flashMessages.title) {
        flashMessages.title = "";
        webTvGlobal.$flashMessages().clear();
      }
      webTvGlobal.$toast().hide();
    }

    function getElement() {
      var element = document.querySelectorAll('md-checkbox.md-default-theme');

      var left = element[0].offsetLeft;

      var leftDelete = left - 35;

      $scope.myObjStyle = {"margin-left": leftDelete}
    }

    /**
     * @param param
     */
    function toggle(param) {
        getElement();
        param.checked = !param.checked;
        var idx = selectedParamss.indexOf(param);
        if (idx > -1) {
            selectedParamss.splice(idx, 1);
        }
        else {
            selectedParamss.push(param);
        }
        vm.selectedParamss = angular.copy(selectedParamss);
    }


    function toggleAll() {
        getElement();
        if (selectedParamss.length === vm.params.length) {
            vm.selectedParamss = [];
        }

        else if ((selectedParamss.length === 0) || (selectedParamss.length > 0)) {
            vm.selectedParamss = vm.params.slice(0);
        }
        selectedParamss = angular.copy(vm.selectedParamss);
        var list_canals = angular.copy(vm.params);
        angular.forEach(list_canals, function (value, key) {
            if (value !== undefined)
                vm.params[key].checked = selectedParamss.length > 0;
        });
    }

    /**
     * Show param Details
     * @param param
     */
    function showParamsDetail(param) {
      $rootScope.loadingProgress = true;
      msApi.request('param.modalGetParam@get', {id: param.id},
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.code) && response.code === 200) {
            $mdDialog.show({
              locals: {ParamData: response},
              templateUrl: 'app/main/configuration/client/detail/detail.modal.html',
              clickOutsideToClose: true,
              controller: 'ParamDetailController',
              controllerAs: 'vm'
            })
          }
          else {
            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
              $translate('VALIDATION.' + response.data.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    /**
     * rerender datatable
     */
    function rerender() {
      vm.dtInstance.rerender();
    }


    /**
     * redirection to add new param page
     * @param event
     */
    function addNewParams() {
      clearFlashMessage();
      $state.go('app.param_add');
    }

    /**
     * Delete param Confirm Dialog
     */
    function deleteParamsConfirm(param, ev) {
      $translate([
        "MESSAGES.dialog_confirm_delete",
        "MESSAGES.dialog_cancel",
        "MESSAGES.dialog_will_be_deleted",
        "PARAMLIST.delete_Params_msg",
        "PARAMLIST.delete_param_aria_label"
      ])
        .then(function (translatedValues) {
          var confirm = $mdDialog.confirm()
            .title(translatedValues['PARAMLIST.delete_Params_msg'])
            .htmlContent('<b>' + param.cle + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
            .ariaLabel(translatedValues['PARAMLIST.delete_param_aria_label'])
            .targetEvent(ev)
            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
            .cancel(translatedValues['MESSAGES.dialog_cancel']);

          $mdDialog.show(confirm).then(function () {

            deleteParams(param);
            vm.selectedParamss = [];
              selectedParamss = [];

          }, function () {

          });
        });


    }

    /**
     * Delete param
     */
    function deleteParams(Params) {
      clearFlashMessage();
      if (vm.params.indexOf(Params) !== -1) {
        $rootScope.loadingProgress = true;
        msApi.request('param.mdelete@delete', {id: Params.id},
          function (response) {
            $rootScope.loadingProgress = false;
            if (response.code === 200) {
              $translate([
                "PARAMLIST.dialog_alert_delete_title",
                "PARAMLIST.dialog_alert_delete_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  webTvGlobal.$toast().showSimple(Params.cle + translatedValues['PARAMLIST.dialog_alert_delete_description']);
                  vm.params.splice(vm.params.indexOf(Params), 1);
                  rerender();
                });

            }
            else {
              $translate([
                "PARAMLIST.dialog_alert_delete_error_title",
                "PARAMLIST.dialog_alert_delete_error_description",
                "PARAMLIST.dialog_alert_delete_close"
              ])
                .then(function (translatedValues) {
                  var alert = $mdDialog.alert({
                    title: translatedValues['PARAMLIST.dialog_alert_delete_error_title'],
                    textContent: translatedValues['PARAMLIST.dialog_alert_delete_error_description'],
                    ok: translatedValues['PARAMLIST.dialog_alert_delete_close']
                  });

                  $mdDialog
                    .show(alert)
                    .finally(function () {
                      alert = undefined;
                    });
                });

            }
          }
        );

      }

    }

    function deleteSelectedParamsConfirm(ev) {
      var title;
      var ariaLabel;
      if (vm.selectedParamss.length !== 0) {

          if (vm.selectedParamss.length === 1) {
            title = 'PARAMLIST.delete_element_Param_msg';
            ariaLabel = 'PARAMLIST.delete_Param_aria_label';
          } else {
            title = 'PARAMLIST.delete_list_Param_msg';
            ariaLabel = 'PARAMLIST.delete_Params_aria_label';
          }

          $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedParamss.length, title, ariaLabel)).then(function () {

              deleteSelectedParams(ev);


          });

      }

    }

    /* delete selected groups*/
    function deleteSelectedParams(ev) {
      clearFlashMessage();

      $rootScope.loadingProgress = true;

      msApi.request('param.deleteParams@delete', {
          list: (function (list) {
            vm.selectedParamss.forEach(function (item) {
              list.push(item.id);
            });
            return list;
          })([])
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (response.code === 200) {
            var undeleted = "";
            var deleted;
            if (response.result.undeleted.length !== 0) {
              undeleted = $translate.instant("PARAMLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
            }
            deleted = $translate.instant("PARAMLIST.deleted_are", {'list': response.result.deleted.join(",")});
            webTvGlobal.alertDialog(
              deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
              $translate.instant('PARAMLIST.dialog_alert_delete_title'),
              '',
              ev
            );
            vm.selectedParamss = [];
              selectedParamss = [];
            rerender();

          }
          else {
            webTvGlobal.alertDialog(
              $translate.instant('PARAMLIST.dialog_alert_delete_error_title'),
              $translate.instant('PARAMLIST.dialog_alert_delete_error_description'),
              '',
              ev
            );
            vm.selectedParamss = [];
              selectedParamss = [];
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
          vm.selectedParamss = [];
            selectedParamss = [];
          vm.modelCheckAll = false;

        }
      );


    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.param_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.param_list_pagetitle";
      $rootScope.pageRoute = "";
      $rootScope.welcome = "welcome_client";
      $rootScope.text = [{
        texte: "add_button_client_help"
      }, {
        texte: "arrow_button_client_help"
      }, {
        texte: "search_area_client_help"
      }, {
        texte: "tri_column_client_help"
      },
        {
          texte: "edit_button_client_help"
        }, {
          texte: "detail_button_client_help"
        },
        {
          texte: "delete_button_client_help"
        }];

    }


  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration.client.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.param_add', {
                url: "/configuration/client/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/configuration/client/add_edit_view/add_edit.template.html',
                        controller : 'ParamAddController as vm'
                    }
                },
                resolve: {
                     ParamData: function (msApi)
                    {
						return msApi.resolve('param.getNewParamsData@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });
        
        //API
		msApiProvider.register('param.getNewParamsData', [Routing.generate('api_params_get_detail_param',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('param.addParam', [Routing.generate('api_params_post_add_param')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.configuration.client.add')
    .controller('ParamAddController', ParamAddController);

  /** @ngInject */
  function ParamAddController($rootScope, $translate, msApi, $state, ParamData, webTvGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = true;
    var param = ParamData;

    vm.empParamForm = {
      cle: param.cle,
      value: param.value
    };
    vm.submitAddParamForm = submitAddParamForm;


    /**
     * Send add Params Form
     */
    function submitAddParamForm() {
      $rootScope.loadingProgress = true;
      msApi.request('param.addParam@save',
        {"empParamForm": angular.copy(vm.empParamForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            param = vm.empParamForm;
            webTvGlobal.$flashMessages().set('ParamAdd', {title: vm.empParamForm.cle ? vm.empParamForm.cle : ""});
            $state.go('app.param_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
        }
      );
    }


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.param_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.param_add_menuTitle";
      $rootScope.pageRoute = "app.param_list";
      $rootScope.welcome = "welcome_client_add";
      $rootScope.text = [{
        texte: "parameters_client_add_help"
      }, {
        texte: "send_button_client_add_help"
      }, {
        texte: "cancel_button_client_add_help"
      }];

    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.zone.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_zone_edit', {
                url: "/boitier/zone/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/zone/add_edit_view/form.template.html',
                        controller : 'configurationZoneEditController as vm'
                    }
                },
                resolve: {
                     configurationZoneData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('configuration_zone.getZone@get',{id:$stateParams.id});
                    },
                    configurationRmboxsData: function (msApi)
                    {
                        return msApi.resolve('configuration_zone.getRmboxs@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_zone_post_edit_action"
            });


        // API
        msApiProvider.register('configuration_zone.editZone', [Routing.generate('api_configuration_post_edit_zone',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.zone.edit')
    .controller('configurationZoneEditController', configurationZoneEditController);

  /** @ngInject */
  function configurationZoneEditController(webTvGlobal, configurationZoneData, configurationRmboxsData, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');

    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_zone_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_zone_edit_pagetitle";
      $rootScope.pageRoute = "app.configuration_zone_list";

      $rootScope.welcome = "welcome_zone_edit";
      $rootScope.text = [{
        texte: "parameters_zone_add_help"
      }, {
        texte: "send_button_zone_edit_help"
      }, {
        texte: "cancel_button_zone_add_help"
      },
          {texte:"zone_import_help"}];

    }

    var vm = this;
    vm.isNew = false;
    var empParametersZoneError = [];
    $rootScope.itemName = "";
    var zone = configurationZoneData;
    vm.rmboxs = configurationRmboxsData.data.rmboxs;
    vm.rmboxs = convertRmboxToSelectList(vm.rmboxs);
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.ngFlowOptions = {
      target: Routing.generate('api_configuration_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]'
    };
    vm.ngFlow = {
      flow: {}
    };
    vm.empConfigurationZoneForm = {};
    vm.submitAddZoneForm = submitAddZoneForm;

    fillData();
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;
    vm.downloadfile = downloadfile;

    function uploadFile() {
      vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function fileAdded(file) {

      if (!/(xlsx)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
      else  vm.inProgress = true;

      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.zones;
        vm.file = message.zones.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ZONELIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);
      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'xlsx',
        'type': 'zone'
      })
    }

    /**
     * Convert List To Select Option format
     */
    function convertRmboxToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Check if Zone exists
     * @return if exists get Zone Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(zone.code) && zone.code !== 200) $state.go('app.error_404');
      else {
        vm.empConfigurationZoneForm = {
          name: zone.name,
          path: zone.path,
          ipStart: zone.ipStart,
          ipEnd: zone.ipEnd,
          bandwidthLimit: zone.bandwidthLimit,
          zonelimit: zone.zonelimit,
          usersimultane: zone.usersimultane,
          bandwidthDisponible: zone.bandwidthDisponible,
          rmbox: (zone.rmbox !== null ? zone.rmbox.id : zone.rmbox)
        };
        $rootScope.itemName = zone.name || '';
      }
    }


    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('configuration_zone.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ZONELIST.add_zone'));
            $state.go('app.configuration_zone_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }

    /**
     * Send add Zone Form
     */
    function submitAddZoneForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_zone.editZone@save',
        {id: zone.id, "empConfigurationZoneForm": angular.copy(vm.empConfigurationZoneForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            zone = vm.empConfigurationZoneForm;
            webTvGlobal.$flashMessages().set('configurationZoneEdit', {title: vm.empConfigurationZoneForm.name ? vm.empConfigurationZoneForm.name : ""});
            $state.go('app.configuration_zone_list');
          }
          else if (angular.isDefined(res.errors)) {
            empParametersZoneError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              empParametersZoneError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empConfigurationZoneForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.zone.list', ["datatables"])
        .config(config);

   

    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_zone_list', {
                url: "/boitier/zone/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/zone/list/list.template.html',
                        controller: 'configurationZoneListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_zone_list_dtable_action"
            });

        // Api
        var deleteListZones=Routing.generate('api_multi_delete_multi_configuration_zones')+"/:list";
        var deletezoneRoute = Routing.generate('api_configuration_delete_zone') + "/:id";
        msApiProvider.register('configuration_zone.list_data_table', [Routing.generate('api_dtable_list_dtable_configuration_zones')]);
        msApiProvider.register('configuration_zone.mdelete', [deletezoneRoute, {id: '@id'}]);
        msApiProvider.register('Configuration_zone.deleteZones', [deleteListZones, {list: '@list'}]);

    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.zone.list')
        .controller('configurationZoneListController', configurationZoneListController);

    /** @ngInject */
    function configurationZoneListController($scope, DTOptionsBuilder, $cookies, $compile, webTvGlobal, DTColumnBuilder, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');

        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_zone_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_zone_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_zone";
            $rootScope.text = [{
                texte: "add_button_zone_help"
            }, {
                texte: "arrow_button_zone_help"
            }, {
                texte: "search_area_zone_help"
            }, {
                texte: "tri_column_zone_help"
            },
                {
                    texte: "edit_button_zone_help"
                }, {
                    texte: "detail_button_zone_help"
                },
                {
                    texte: "delete_button_zone_help"
                },
                {texte: "stat_button_zone_help"}];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.zones = [];
        vm.selectedZones = [];
        var selectedZones = [];
        vm.dtInstance = {};
        vm.ZonesDataTable = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the image column
                    targets: 10,
                    filterable: false,
                    sortable: false,
                    width: '80px'
                },
                {
                    targets: 4,
                    render: function (data) {
                        if (data === "") return "--";
                        if (parseInt(data) < 1) return "--";
                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets: 7,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.ZonesDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.ZonesDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.ZonesDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('path}').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('ipStart').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('ipEnd').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('rmbox.name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('bandwidthLimit').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('zonelimit').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('usersimultane').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('bandwidthDisponible').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable().withOption('defaultContent', '')
                .renderWith(function (data) {
                    vm.ZonesDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'ZONELIST.detail_zone'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" has-permission="configuration_zone_get_detail" ng-click="vm.showZoneDetail(vm.ZonesDataTable[' + data.id + '],$event)" aria-label="detail_zone"translate translate-attr-aria-label="ZONELIST.detail_zone">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'ZONELIST.update_zone'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" has-permission="configuration_zone_post_edit" ui-sref="app.configuration_zone_edit({id:' + data.id + '})" aria-label="update_zone" translate translate-attr-aria-label="ZONELIST.update_zone">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'ZONELIST.delete_zone'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" has-permission="configuration_zone_delete_zone" ng-click="vm.deleteZoneConfirm(vm.ZonesDataTable[' + data.id + '],ev)" aria-label="delete_zone"translate translate-attr-aria-label="ZONELIST.delete_zone">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '</md-button>' +
                        '</a>';
                    var buttonStatsZone = '<a tooltips tooltip-template=' + "{{'MESSAGES.action_video_stats'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' + '<md-button has-permission="configuration_zone_stat_zone_no_api" class="m16 md-icon-button" ng-click="vm.showStatZone(vm.ZonesDataTable[' + data.id + '])" aria-label="action_export_event" translate translate-attr-aria-label="MESSAGES.action_export_event"><md-icon md-font-icon="icon-chart-bar" class="s18"></md-icon></md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + buttonStatsZone;

                })
        ];

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function searchZonesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_zone.list_data_table@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.zones = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.zones = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            vm.selectedZones = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_zones,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };

            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchZonesInAPI(filtre);
        }

        vm.showStatZone = showStatZone;
        vm.deleteZoneConfirm = deleteZoneConfirm;
        vm.deleteSelectedZonesConfirm = deleteSelectedZonesConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showZoneDetail = showZoneDetail;
        var checkedSelected = false;
        vm.addNewZone = addNewZone;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationZoneAdd', $translate.instant('ZONELIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationZoneEdit', $translate.instant('ZONELIST.edited'));
        vm.searchZones = searchZones;

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        function showStatZone(zone) {
            $state.go('app.stats_zone_by_id.audience', {id: zone.id});
        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the user
         *
         * @param zone
         */
        function toggle(zone) {
            zone.checked = !zone.checked;
            var idx = selectedZones.indexOf(zone);
            if (idx > -1) {
                selectedZones.splice(idx, 1);
            }
            else {
                selectedZones.push(zone);
            }
            vm.selectedZones = angular.copy(selectedZones);
        }

        function toggleAll() {
            getElement();
            if (selectedZones.length === vm.zones.length) {
                vm.selectedZones = [];
            }
            else if ((selectedZones.length === 0) || (selectedZones.length > 0)) {
                vm.selectedZones = vm.zones.slice(0);
            }
            selectedZones = angular.copy(vm.selectedZones);
            var list_zone = angular.copy(vm.ZonesDataTable);
            angular.forEach(list_zone, function (value, key) {
                if (value !== undefined)
                    vm.ZonesDataTable[key].checked = selectedZones.length > 0;
            });
        }

        /**
         * Show zone Details
         * @param zone
         */
        function showZoneDetail(zone, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('configuration_zone.getZone@get', {id: zone.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined($rootScope.itemName)) $rootScope.itemName = "";
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationZoneData: response},
                            templateUrl: 'app/main/boitier/zone/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationZoneDetailController',
                            controllerAs: 'vm'

                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchZonesInAPI(filtre), true);
        }


        /**
         * redirection to add new zone page
         * @param event
         */
        function addNewZone() {
            clearFlashMessage();
            $state.go('app.configuration_zone_add');
        }

        /**
         * Delete zone Confirm Dialog
         */
        function deleteZoneConfirm(zone, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "ZONELIST.dialog_will_be_deleted_zone",
                "ZONELIST.delete_zone_msg",
                "ZONELIST.delete_zone_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .title(translatedValues['ZONELIST.delete_zone_msg'])
                        .htmlContent('<b>' + zone.name + '</b>' + translatedValues['ZONELIST.dialog_will_be_deleted_zone'])
                        .ariaLabel(translatedValues['ZONELIST.delete_zone_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteZone(zone);
                        vm.selectedZones = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete zone
         */

        /*
         * delete selected zone confirm
         * */
        function deleteSelectedZonesConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedZones.length!== 0) {
                if(vm.selectedZones.length === 1){
                    title = 'ZONELIST.delete_zone_msg';
                    ariaLabel = 'ZONELIST.delete_zone_aria_label';
                }else{
                    title = 'ZONELIST.delete_list_zones_msg';
                    ariaLabel = 'ZONELIST.delete_zones_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedZones.length,title,ariaLabel)).then(function () {
                    deleteSelectedZones(ev);
                });

            }

        }

        function deleteSelectedZones(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('Configuration_zone.deleteZones@delete', {
                    list: (function (list) {
                        vm.selectedZones.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("ZONELIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("ZONELIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('ZONELIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedZones = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('ZONELIST.dialog_alert_delete_error_title'),
                            $translate.instant('ZONELIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedZones = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedZones = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        function deleteZone(Zone) {
            clearFlashMessage();
            if (vm.zones.indexOf(Zone) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_zone.mdelete@delete', {id: Zone.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "ZONELIST.dialog_alert_delete_title",
                                "ZONELIST.dialog_alert_delete_description",
                                "ZONELIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Zone.name + translatedValues['ZONELIST.dialog_alert_delete_description']);
                                    vm.zones.splice(vm.zones.indexOf(Zone), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "ZONELIST.dialog_alert_delete_error_title",
                                "ZONELIST.dialog_alert_delete_error_description",
                                "ZONELIST.dialog_alert_delete_close"
                            ])
                                .then(function () {


                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }

                    }
                    , function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }


        function searchZones() {
            filtre["search[value]"] = vm.search_zones;
            searchZonesInAPI(filtre);

        }

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.boitier.zone.list')
        .controller('configurationZoneDetailController', configurationZoneDetailController);

    /** @ngInject */
    function configurationZoneDetailController(configurationZoneData,$mdDialog)
    {
    	var vm = this;
        vm.zone = configurationZoneData;
      vm.cancel = cancel;

      function cancel(){
        $mdDialog.hide();
      }
        /**
         * Check if zone exists
         * @return if exists get Zone Data else redirect to 404 page
         */





    }



})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.user.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.abonnement_user_edit', {
                url: "/abonnement/user/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/user/add_edit_view/form.template.html',
                        controller: 'abonnementUserEditController as vm'
                    }
                },
                resolve: {
                    abonnementUserData: function (msApi, $stateParams) {
                        return msApi.resolve('abonnement_user.getUser@get', {id: $stateParams.id});
                    },
                    abonnementGroupsData: function (msApi) {
                        return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "subscription_user_post_edit_action"
            });


        //API
        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('abonnement_user.getUser', [Routing.generate('api_subscription_user_get_detail_user', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('abonnement_user.editUser', [Routing.generate('api_subscription_user_post_edit_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.abonnement.user.edit')
    .controller('abonnementUserEditController', abonnementUserEditController);

  /** @ngInject */
  function abonnementUserEditController(webTvGlobal, $cookies, $injector, abonnementUserData, abonnementGroupsData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;

    $rootScope.itemName = "";
    var user = abonnementUserData;
    vm.isNew = false;
    var errors = [];
    vm.empAbonnementUserError = [];
    vm.groups = abonnementGroupsData.data.groups;
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.ngFlowOptions = {
      target: Routing.generate('api_subscription_user_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      flow: {}
    };
    vm.groups = convertParentToSelectList(vm.groups);
    vm.empAbonnementUserForm = {};
    vm.submitAddUserForm = submitAddUserForm;
    // vm.goToList = goToList;
    fillData();
    vm.downloadfile = downloadfile;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'csv',
        'type': 'subscriptionUser'
      })
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.abonnement_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.abonnement_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.abonnement_user_edit_pagetitle";
      $rootScope.pageRoute = "app.abonnement_user_list";
      $rootScope.welcome = "welcome_user_edit";
      $rootScope.text = [{
        texte: "parameters_user_add_help"
      }, {
        texte: "send_button_user_edit_help"
      }, {
        texte: "cancel_button_user_add_help"
      },{
          texte: "parameters_user_import_help"
      }];

    }

    /**
     * Convert List To Select Option format
     */
    function convertParentToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Check if User exists
     * @return if exists get User Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(user.code) && user.code !== 200) $state.go('app.error_404');
      else {
        vm.empAbonnementUserForm = {
            name: user.name,
            lastName: user.lastName,
            function: user.function,
            entity: user.entity,
            email: user.email,
            login: user.login,
            protect: user.protect,
            group: (user.group !== null ? user.group.id : user.group)
        };
        $rootScope.itemName = user.name || '';
      }
    }

    // /**
    //  * return to User list page
    //  * @return redirect to User list page
    //  */
    // function goToList() {
    //     $state.go('app.abonnement_user_list');
    // }


    /**
     * Send add User Form
     */
    function submitAddUserForm() {
      $rootScope.loadingProgress = true;
      msApi.request('abonnement_user.editUser@save',
        {id: user.id, "empAbonnementUserForm": angular.copy(vm.empAbonnementUserForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            user = vm.empAbonnementUserForm;
            webTvGlobal.$flashMessages().set('abonnementUserEdit', {title: vm.empAbonnementUserForm.name ? vm.empAbonnementUserForm.name : ""});
            $state.go('app.abonnement_user_list');
          }
          else if (angular.isDefined(res.errors)) {
            errors = res.errors;
            vm.empAbonnementUserError = [];
            errors.forEach(function (item) {
              vm.empAbonnementUserError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAbonnementUserForm[item.for])
              };
            });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
            //else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    function uploadFile() {
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function fileAdded(file) {
      if (!/(csv)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
      else  vm.inProgress = true;
      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.subscriptions;
        vm.file = message.subscriptions.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTUSERLIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);
      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('abonnement_user.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTUSERLIST.add_user'));
            $state.go('app.abonnement_user_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          } else if (response.code === 400) {
            webTvGlobal.alertDialog($translate.instant('VALIDATIONS.subscriptionUser.name.not_blank'));
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }


    vm.checkMail = checkMail;
    vm.checkMail(vm.empAbonnementUserForm.email);

    function checkMail(mail) {
      var reg = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');
      vm.testMail = reg.test(mail);
      vm.empAbonnementUserForm.email = mail;

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmbox_edit', {
                url: "/boitier/rmbox/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/add_edit_view/add_edit.template.html',
                        controller: 'configurationRmboxEditController as vm'
                    }
                },
                resolve: {
                    configurationRmboxData: function (msApi, $stateParams) {
                        return msApi.resolve('configuration_rmbox.getRmbox@get', {id: $stateParams.id});
                    },
                    configurationRmboxgroupsData: function (msApi) {
                        return msApi.resolve('configuration_rmbox.getRmboxgroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_rmbox_post_edit_action"
            });


        // API
		
        msApiProvider.register('configuration_rmbox.editRmbox', [Routing.generate('api_configuration_post_edit_rmbox',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.rmbox.edit')
    .controller('configurationRmboxEditController', configurationRmboxEditController);

  /** @ngInject */
  function configurationRmboxEditController($scope, $injector, $rootScope, webTvGlobal, configurationRmboxData, configurationRmboxgroupsData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";

    var rmbox = configurationRmboxData;
    vm.groups = configurationRmboxgroupsData.data.rmboxgroups;
    vm.groups = webTvGlobal.convertToSelectChoicesFormatWithNullOption(vm.groups);
    vm.groups.forEach(function (group) {
      if (group.option == "null") {
        group.val.name = $translate.instant('MESSAGES.none');
      }
    })

    vm.empConfigurationRmboxForm = {};
    vm.submitAddRmboxForm = submitAddRmboxForm;
    // vm.goToList = goToList;
    fillData();
    initHelp();


    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmbox_edit_pagetitle";
      $rootScope.pageRoute = "app.configuration_rmbox_list";
      $rootScope.welcome = "welcome_rmbox_edit";
      $rootScope.text = [{
        texte: "parameters_rmbox_add_help"
      }, {
        texte: "send_button_rmbox_edit_help"
      }, {
        texte: "cancel_button_rmbox_add_help"
      }];
    }

    vm.types = convertItemsToChoices({
      Display: "Display",
      Proxy_cache: "Proxy cache"
    });

    function convertItemsToChoices(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], option: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Check if RmBox exists
     * @return if exists get RmBox Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(rmbox.code) && rmbox.code !== 200) $state.go('app.error_404');
      else {
        vm.empConfigurationRmboxForm = {
          name: rmbox.name,
          type: rmbox.type,
          ip: rmbox.ip,
          mac: rmbox.mac,
          postal: rmbox.postal,
          group: (angular.isDefined(rmbox.group) && rmbox.group !== null && angular.isDefined(rmbox.group.id)   ? rmbox.group.id : null)
        };
        $rootScope.itemName = rmbox.name || '';
      }
    }

    // /**
    //  * return to RmBox list page
    //  * @return redirect to RmBox list page
    //  */
    // function goToList() {
    //     $state.go('app.configuration_rmbox_list');
    // }


    /**
     * Send add RmBox Form
     */
    function submitAddRmboxForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_rmbox.editRmbox@save',
        {id: rmbox.id, "empConfigurationRmboxForm": angular.copy(vm.empConfigurationRmboxForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            rmbox = vm.empConfigurationRmboxForm;
            webTvGlobal.$flashMessages().set('configurationRmboxEdit', {title: vm.empConfigurationRmboxForm.name ? vm.empConfigurationRmboxForm.name : ""});
            $state.go('app.configuration_rmbox_list');
          }
          else if (res.code === 400 && angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
      );
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.zone.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_zone_add', {
                url: "/boitier/zone/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/zone/add_edit_view/form.template.html',
                        controller : 'configurationZoneAddController as vm'
                    }
                },
                resolve: {
                     configurationZoneData: function (msApi)
                    {
						return msApi.resolve('configuration_zone.getZone@get',{id:0});
                    },
                    configurationRmboxsData: function (msApi)
                    {
                        return msApi.resolve('configuration_zone.getRmboxs@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_zone_post_add_action"
            });
        
        //API
        msApiProvider.register('configuration_zone.postImportFile', [Routing.generate('api_configuration_post_add_zone_import')]);
        msApiProvider.register('configuration_zone.addZone', [Routing.generate('api_configuration_post_add_zone')]);

    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.zone.add')
    .controller('configurationZoneAddController', configurationZoneAddController);

  /** @ngInject */
  function configurationZoneAddController(configurationZoneData, webTvGlobal, configurationRmboxsData, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_zone_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_zone_add_menuTitle";
      $rootScope.pageRoute = "app.configuration_zone_list";

      $rootScope.welcome = "welcome_zone_add";
      $rootScope.text = [{
        texte: "parameters_zone_add_help"
      }, {
        texte: "send_button_zone_add_help"
      }, {
        texte: "cancel_button_zone_add_help"
      },
          {texte: "zone_import_help"}];

    }

    var vm = this;
    vm.isNew = true;
    vm.empConfigurationZoneError = [];
    var zone = configurationZoneData;
    vm.empConfigurationZoneForm = {
      name: zone.name,
      path: zone.path,
      ipStart: zone.ipStart,
      ipEnd: zone.ipEnd,
      bandwidthLimit: zone.bandwidthLimit,
      zonelimit: zone.zonelimit,
      usersimultane: zone.usersimultane,
      bandwidthDisponible: zone.bandwidthDisponible,
      rmbox: zone.rmbox
    };
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.ngFlowOptions = {
      target: Routing.generate('api_configuration_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]'
    };
    vm.ngFlow = {
      flow: {}
    };
    vm.rmboxs = configurationRmboxsData.data.rmboxs;
    vm.rmboxs = convertRmboxToSelectList(vm.rmboxs);
    vm.submitAddZoneForm = submitAddZoneForm;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;
    vm.downloadfile = downloadfile;

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'xlsx',
        'type': 'zone'
      })
    }


    function uploadFile() {
      vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();
      vm.inProgress = true;
    }

    function fileAdded(file) {

      if (!/(xlsx)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
      else  vm.inProgress = true;

      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.zones;
        vm.file = message.zones.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ZONELIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);
      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    /**
     * Convert List To Select Option format
     */
    function convertRmboxToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('configuration_zone.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ZONELIST.add_zone'));
            $state.go('app.configuration_zone_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }

    /**
     * Send add Zone Form
     */
    function submitAddZoneForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_zone.addZone@save',
        {"empConfigurationZoneForm": angular.copy(vm.empConfigurationZoneForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            zone = vm.empConfigurationZoneForm;
            webTvGlobal.$flashMessages().set('configurationZoneAdd', {title: vm.empConfigurationZoneForm.name ? vm.empConfigurationZoneForm.name : ""});
            $state.go('app.configuration_zone_list');
          }
          else if (angular.isDefined(res.errors)) {
            vm.empConfigurationZoneError = [];
            var errors = res.errors;
            errors.forEach(function (item) {
              vm.empConfigurationZoneError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersThemeForm[item.for])
              };
            });
          } else if (angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATION.' + response.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider, $urlRouterProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmbox_list', {
                url: "/configuration/rmbox/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/list/list.template.html',
                        controller: 'configurationRmboxListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_rmbox_list_dtable_action"
            });


        // Api


        $urlRouterProvider.otherwise('/configuration/rmbox/list');
        var deletermboxRoute = Routing.generate('api_configuration_delete_rmbox') + "/:id";
        msApiProvider.register('configuration_rmbox.ReloadRmbox', [Routing.generate('api_configuration_get_reload_rmbox', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_rmbox.mdelete', [deletermboxRoute, {id: '@id'}]);
        msApiProvider.register('configuration_rmbox.getStatutRmbox', [Routing.generate('api_configuration_get_statut_rmbox', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_rmbox.getReportsRmbox', [Routing.generate('api_configuration_get_reports_rmbox', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_rmbox.dtable', [Routing.generate('api_dtable_list_dtable_configuration_rmboxs')]);
        var deleteListRmbox = Routing.generate('api_multi_delete_multi_configuration_rmboxs') + "/:list";
        msApiProvider.register('configuration_rmbox.deleteRmboxs', [deleteListRmbox, {list: '@list'}]);
        msApiProvider.register('configuration_rmbox_video.dtableOnGoing', [Routing.generate('api_dtable_list_dtable_rmbox_video')]);
        msApiProvider.register('configuration_rmbox_zone.dtableList', [Routing.generate('api_dtable_list_dtable_rmbox_zone')]);
        msApiProvider.register('configuration_rmbox.listSchedules', [Routing.generate('api_display_schedule_list_schedules')]);
        msApiProvider.register('configuration_rmbox.associateSchedule', [Routing.generate('api_configuration_associate_schedule_to_rmbox')]);
        msApiProvider.register('configuration_rmbox.associateProgram', [Routing.generate('api_configuration_post_associate_program_to_rmbox')]);
        msApiProvider.register('configuration_rmbox.listPlaylists', [Routing.generate('api_get_list_playlists_rmbox', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('configuration_rmbox.activatePlaylist', [Routing.generate('api_configuration_post_activate_playlist_to_rmbox')]);
        msApiProvider.register('configuration_rmbox.listPrograms', [Routing.generate('api_programDisplay_list_schedules')]);

    }
})();

(function () {
    angular
        .module('app.boitier.rmbox.list')
        .controller('zoneListController', zoneListController);

    /** @ngInject */
    function zoneListController($injector, DTOptionsBuilder, DTColumnBuilder, $cookies, webTvGlobal, $compile, $scope, rmboxId, dtable_language) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $mdDialog = $injector.get('$mdDialog'),
            $rootScope = $injector.get('$rootScope'),
            msApi = $injector.get('msApi');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.zones = [];
        vm.dtInstance = {};
        vm.search_zones = "";
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                }

            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        vm.dtColumns = [

            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            })
        ];

        vm.cancel = cancel;
        vm.searchZones = searchZones;


        function searchZonesInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_rmbox_zone.dtableList@get', filtre,
                function (response) {
                    if (response.code === 200) {
                        var records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };

                        vm.zones = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.zones = [];
                        vm.recordsTotal = 0;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_zones,
                "order[0][column]": 0,
                "idRmbox": rmboxId,
                "order[0][dir]": sort.dir
            };

            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;
            searchZonesInAPI(filtre);
        }

        function cancel() {
            $mdDialog.cancel();
        }

        function searchZones() {
            filtre["search[value]"] = vm.search_zones;
            searchZonesInAPI(filtre);

        }
    }
})();

(function () {
  angular
    .module('app.boitier.rmbox.list')
    .controller('videoListController', videoListController);

  /** @ngInject */
  function videoListController(webTvGlobal, $scope, $cookies, DTOptionsBuilder, DTColumnBuilder, $compile, parametersOrdersListData, $injector, rmboxId, dtable_language) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get('msApi');


    var vm = this;
    var columnsApi = parametersOrdersListData;
    var filtre = {};

    vm.search_videos = "";
    vm.recordsTotal = 0;
    vm.videos = [];
    $rootScope.DTOptionsBuilder = DTOptionsBuilder;
    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withFnServerData(serverData)
      // or here
      .withDataProp('data')
      .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
      .withOption('processing', true)
      .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
      .withOption('serverSide', true)
      .withOption('columnDefs', [[
        {
          targets: [0, 1],
          width: '72px'
        }
      ]
      ])
      .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
      .withOption('pageLength', 50)
      .withOption('scrollY', 'auto')
      .withOption('responsive', true)
      .withOption('createdRow', function (row) {
        $compile(angular.element(row).contents())($scope);
      })
      .withPaginationType('full_numbers');
    $rootScope.DtOptions = vm.dtOptions;

    function searchVideosInAPI(filtre) {

      msApi.request('configuration_rmbox_video.dtableOnGoing@get', filtre,
        function (response) {
          if (response.code === 200) {
            var videos = response.data;


            var records = {
              'draw': response.draw,
              'recordsTotal': response.recordsTotal,
              'recordsFiltered': response.recordsFiltered,
              'data': videos
            };
            vm.videos = videos;
            vm.recordsTotal = response.recordsTotal;
            vm.fnCallback(records);
              webTvGlobal.fixDatatableFirefox();
          }
          else {
            records = {
              'draw': 0,
              'recordsTotal': 0,
              'recordsFiltered': 0,
              'data': 0
            };

            vm.videos = [];
            vm.recordsTotal = 0;

            $rootScope.loadingProgress = false;
            if (angular.isDefined(response.message)) {
              $translate('VALIDATIONS.' + response.message).then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
            vm.fnCallback(records);
          }
        },
        function (response) {
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );


    }

    function serverData(sSource, aoData, fnCallback) {

      //All the parameters you need is in the aoData variable
      var draw = aoData[0].value;
      var columns = aoData[1].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var sort = angular.copy(order[0]);

      var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];
      filtre = {
        draw: draw,
        start: start,
        length: length,
        "search[value]": vm.search_videos,
        "order[0][column]": numColum,
        "idRmbox": rmboxId,
        "order[0][dir]": sort.dir
      };
      filtre["columns[" + numColum + "][orderable]"] = true;
      vm.fnCallback = fnCallback;
      searchVideosInAPI(filtre);
    }

    vm.dtColumns = [
      DTColumnBuilder.newColumn('id').renderWith(function (data) {
        return angular.isDefined(data) ? data : "";
      }),
      DTColumnBuilder.newColumn('title').renderWith(function (data) {
        return angular.isDefined(data) ? data : "";
      })
    ];

    vm.searchVideos = searchVideos;
    vm.cancel = cancel;

    /*function rerender() {
        if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }*/

    function cancel() {
      $mdDialog.cancel();
    }

    function searchVideos() {
      filtre["searchWord"] = vm.search_videos;
      searchVideosInAPI(filtre);
    }
  }
})();

(function () {
    angular
        .module('app.boitier.rmbox.list')
        .controller('stateDetailsController', stateDetailsController);

    /** @ngInject */
    function stateDetailsController(detailState, $mdDialog) {
        var vm = this;
        vm.detail = detailState.statut;
        vm.cancel = cancel;

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();

(function () {
  angular
    .module('app.boitier.rmbox.list')
    .controller('pdfHistoryController', pdfHistoryController);

  /** @ngInject */
  function pdfHistoryController(reports, $mdDialog) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.reports = reports.history.reports;
    vm.cancel = cancel;

    /*function fileName(file) {
        var last = file.lastIndexOf("/");
        return name = file.substring(last + 1, file.length);
    }*/

    function cancel() {
      $mdDialog.cancel();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox.list')
        .controller('configurationRmboxListController', configurationRmboxListController);

    /** @ngInject */
    function configurationRmboxListController(order_video, $cookies, DTOptionsBuilder, DTColumnBuilder, webTvGlobal, $injector, $scope, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            $compile = $injector.get('$compile'),
            msUtils = $injector.get('msUtils');
        initHelp();
        var parameters = webTvGlobal.$constant().webTvParameterBag();

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmbox_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_rmbox";
            $rootScope.text = [{
                texte: "add_button_rmbox_help"
            }, {
                texte: "arrow_button_rmbox_help"
            }, {
                texte: "search_area_rmbox_help"
            }, {
                texte: "tri_column_rmbox_help"
            },

                {texte: "actions_button_rmbox_help"}];
        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.rmboxs = [];
        vm.selectedRmboxs = [];
        var selectedRmboxs = [];
        vm.rmboxsDataTable = {};
        vm.rmboxsPrograms = {};
        if(angular.isDefined(parameters.show_display_grapes) && parameters.show_display_grapes==='1') {vm.displayNew=true;} else {vm.displayNew=false;}
        if (vm.displayNew===true)
        {
            vm.Activatedisplay='programs[]';
            vm.apiListe='configuration_rmbox.listPrograms@get';

        }else {
            vm.Activatedisplay='schedule';
            vm.apiListe='configuration_rmbox.listSchedules@get';
        }
        vm.dtInstance = {};
        var state = 0;
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the id column
                    targets: [2],
                    width: '150px;'
                },
                {
                    // Target the actions column
                    targets: 9,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchRmboxInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_rmbox.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.rmboxs = response.data;
                        vm.recordsTotal = response.recordsTotal;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.zones = [];
                        vm.recordsTotal = 0;
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }

                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedRmboxs = [];
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_rmboxs,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchRmboxInAPI(filtre);
        }

        function searchRmboxs() {
            filtre["search[value]"] = vm.search_rmboxs;
            filtre["start"] = 0;
            filtre["draw"] = 1;
            vm.dtInstance.DataTable.page(0).draw( false );
        }

        function deleteSelectedRmboxsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedRmboxs.length!== 0) {
                if(vm.selectedRmboxs.length === 1){
                    title = 'RMBOXLIST.delete_rmbox_msg';
                    ariaLabel = 'RMBOXLIST.delete_rmbox_aria_label';
                }else{
                    title = 'RMBOXLIST.delete_list_RmBoxs_msg';
                    ariaLabel = 'RMBOXLIST.delete_RmBoxs_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedRmboxs.length,title,ariaLabel)).then(function () {
                    deleteSelectedRmbox(ev);
                }, function () {
                });

            }

        }

        /* delete selected groups*/
        function deleteSelectedRmbox(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('configuration_rmbox.deleteRmboxs@delete', {
                    list: (function (list) {
                        vm.selectedRmboxs.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("RMBOXLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("RMBOXLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('RMBOXLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedRmboxs = [];
                        rerender();

                    }
                    else if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('RMBOXLIST.dialog_alert_delete_error_title'),
                            $translate.instant('RMBOXLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );

                    }
                    selectedRmboxs = [];
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedRmboxs = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.rmboxsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.rmboxsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),

            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                var adresse = angular.isDefined(data.ip) ? '<Strong> IP:</Strong> '+ data.ip +'<br> ': " ";
                adresse+=angular.isDefined(data.mac) ? '<Strong> MAC:</Strong> '+ data.mac : " ";
                return adresse;
            }),
            DTColumnBuilder.newColumn('group.name').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";

            }),
            DTColumnBuilder.newColumn(vm.Activatedisplay+'.title').renderWith(function (data) {
                var serverHtml = "";
                if (vm.displayNew)
                {
                    serverHtml += '<ul>';

                    for (var i = 0; i <data.length; i++) {
                        serverHtml += '<li style="padding-right: 90%;"> ' + data[i] + ' </li>';
                    }
                    serverHtml += '</ul>';

                }

                else {
                    serverHtml += '<ul>';
                    if(angular.isDefined(data))
                    {
                        serverHtml += '<li style="padding-right: 90%;"> ' + data + ' </li>';

                    }

                    serverHtml += '</ul>';
                }
                return serverHtml;

            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxsDataTable[data.id] = data;
                    var buttonOpenDetails = "";

                    if (data.statut === "OK") {
                        buttonOpenDetails = '<div layout="row" layout-align="center center">' +
                            '<a tooltips tooltip-template=' + "{{'RMBOXLIST.state_ok'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.showStateDetails(vm.rmboxsDataTable[' + data.id + '])" aria-label="ok"translate translate-attr-aria-label="RMBOXLIST.state_ok">' +
                            '<md-icon  md-font-icon="icon-checkbox-marked-circle" style="color : #43A047" class="s24"></md-icon>' +
                            '</md-button>' +
                            '</a>' +
                            '<p>' + (moment(data.updated_at).format($rootScope.defaultDateFormat) + ' ' + (moment(data.updated_at).format('HH:mm:ss'))) + '</p>' +
                            '</div>';
                        data.statut++;
                    }
                    else if (data.statut === "WARNING") {
                        buttonOpenDetails = '<div layout="row" layout-align="center center">' +
                            '<a tooltips tooltip-template=' + "{{'RMBOXLIST.state_warning'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.showStateDetails(vm.rmboxsDataTable[' + data.id + '])" aria-label="warning"translate translate-attr-aria-label="RMBOXLIST.state_warning">' +
                            '<md-icon  md-font-icon="icon-information" style="color : #FFC107;transform: rotate(180deg)" class="s24"></md-icon>' +
                            '</md-button>' +
                            '</a>' +
                            '<p>' + (moment(data.updated_at).format($rootScope.defaultDateFormat) + ' ' + (moment(data.updated_at).format('HH:mm:ss'))) + '</p>' +
                            '</div>';
                        data.statut++;
                    }
                    else if (data.statut === "CRITICAL") {
                        buttonOpenDetails = '<div layout="row" layout-align="center center">' +
                            '<a tooltips tooltip-template=' + "{{'RMBOXLIST.state_critical'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.showStateDetails(vm.rmboxsDataTable[' + data.id + '])" aria-label="critical"translate translate-attr-aria-label="RMBOXLIST.state_critical">' +
                            '<md-icon  md-font-icon="icon-minus-circle" style="color : #F44336" class="s24"></md-icon>' +
                            '</md-button></a>' +
                            '<p>' + (moment(data.updated_at).format($rootScope.defaultDateFormat) + ' ' + (moment(data.updated_at).format('HH:mm:ss'))) + '</p>' +
                            '</div>';
                        data.statut++;
                    }
                    else if (data.statut === "UNREACHABLE") {
                        buttonOpenDetails = '<div layout="row" layout-align="center center">' +
                            '<a tooltips tooltip-template=' + "{{'RMBOXLIST.state_unknown'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button class="show-button md-icon-button" ng-click="vm.showStateDetails(vm.rmboxsDataTable[' + data.id + '])" aria-label="unknown"translate translate-attr-aria-label="RMBOXLIST.state_unknown">' +
                            '<md-icon  md-font-icon="icon-checkbox-blank-circle" style="color : #424242" class="s24"></md-icon>' +
                            '</md-button></a>' +
                            '<p>' + (moment(data.updated_at).format($rootScope.defaultDateFormat) + ' ' + (moment(data.updated_at).format('HH:mm:ss'))) + '</p>' +
                            '</div>';
                        data.statut = 0;
                    }

                    return buttonOpenDetails
                }),
            DTColumnBuilder.newColumn(null).renderWith(function (data) {

                var textValue = "";
                var buttonOpenDetailsZone = "";

                buttonOpenDetailsZone =
                    '<a tooltips tooltip-template=' + "{{'RMBOXLIST.list_zone'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                    '<md-button class="show-button md-icon-button" ng-click="vm.showListZone(vm.rmboxsDataTable[' + data.id + '])" aria-label="list_zone"translate translate-attr-aria-label="RMBOXLIST.list_zone">' +
                    '<md-icon  md-font-icon="icon-open-in-new" class="s18"></md-icon>' +
                    '</md-button></a>';
                if (data.count_zones === 1) {
                    textValue = '<p><span translate="RMBOXLIST.un_zone_attrebu"></span></p>';
                } else if (data.count_zones > 1) {
                    textValue = '<p>' + data.count_zones + '<span translate="RMBOXLIST.zone_attrebu"></span></p>';
                }
                else {
                    textValue = '<p><span translate="RMBOXLIST.zone_attrebu_none"></span></p>';
                }
                return textValue + buttonOpenDetailsZone
            }),
            DTColumnBuilder.newColumn(null).renderWith(function (data) {
                var textValue = "";
                var buttonOpenDetailsVideo = "";


                buttonOpenDetailsVideo =
                    '<a tooltips tooltip-template=' + "{{'RMBOXLIST.list_video'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                    '<md-button class="show-button md-icon-button" ng-click="vm.showListVideo(vm.rmboxsDataTable[' + data.id + '])" aria-label="list_video"translate translate-attr-aria-label="RMBOXLIST.list_video">' +
                    '<md-icon  md-font-icon="icon-open-in-new" class="s18"></md-icon>' +
                    '</md-button>' +
                    '</a>';
                if (data.count_videos === 1) {
                    textValue = '<span translate="RMBOXLIST.un_video_attrebu"></span></p>';
                } else if (data.count_videos > 1) {
                    textValue = '<p>' + data.count_videos + '<span translate="RMBOXLIST.video_attrebu"></span></p>';
                }
                else {
                    textValue = '<p><span translate="RMBOXLIST.video_attrebu_none"></span></p>';
                }
                return textValue + buttonOpenDetailsVideo
            }),
            DTColumnBuilder.newColumn('espace_rest').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxsDataTable[data.id] = data;
                    //icon-open-in-new
                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.detail_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_get_detail" class="show-button md-icon-button" ng-click="vm.showRmboxDetail(vm.rmboxsDataTable[' + data.id + '],$event)" aria-label="detail_rmbox"translate translate-attr-aria-label="RMBOXLIST.detail_rmbox">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.update_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" has-permission="configuration_rmbox_post_edit" ui-sref="app.configuration_rmbox_edit({id: ' + data.id + '})" aria-label="update_rmbox" translate translate-attr-aria-label="RMBOXLIST.update_rmbox">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionRapportPdf =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.pdf_list'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_get_reports" class="edit-button md-icon-button" ng-click="vm.pdfHistoryList(vm.rmboxsDataTable[' + data.id + '])" aria-label="pdf_list" translate translate-attr-aria-label="RMBOXLIST.pdf_list">' +
                        '<md-icon  md-font-icon="icon-file-pdf-box" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.delete_rmbox'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" has-permission="configuration_rmbox_delete_rmbox" ng-click="vm.deleteRmboxConfirm(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="delete_rmbox" translate translate-attr-aria-label="RMBOXLIST.delete_rmbox">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionAssociateScheduleHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.associate_schedule'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_associate_schedule_no_api" class="m16 delete-button md-icon-button" ng-click="vm.associateSchedule(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="associate_schedule" translate translate-attr-aria-label="RMBOXLIST.associate_schedule">' +
                        '<md-icon  md-font-icon="icon-calendar-text" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionActivatePlaylistHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.activate_playlist'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_activate_playlist_no_api" class="m16 delete-button md-icon-button" ng-if="vm.rmboxsDataTable[' + data.id + '].count_playlists>0" ng-click="vm.getPlaylist(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="activate_playlist" translate translate-attr-aria-label="RMBOXLIST.activate_playlist">' +
                        '<md-icon  md-font-icon="icon-wifi" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionShowScheduleHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXLIST.show_schedule'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_show_schedule_no_api" class="m16 delete-button md-icon-button" ng-click="vm.showScheduleByRmbox(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="show_schedule" translate translate-attr-aria-label="RMBOXLIST.show_schedule">' +
                        '<md-icon  md-font-icon="icon-open-in-new" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionReloadScheduleHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.button_reload_display'|translate}}" + ' tooltip-side="lebottomft" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmbox_get_reload" class="m16 delete-button md-icon-button" ng-click="vm.reloadRmbox(vm.rmboxsDataTable[' + data.id + '],ev)" aria-label="show_schedule" translate translate-attr-aria-label="RMBOXLIST.show_schedule">' +
                        '<md-icon  md-font-icon="icon-refresh" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionInterventionHtml =
                        '<a tooltips tooltip-template=' + "{{'MESSAGES.intervention'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" has-permission="configuration_rmbox_list_intervention_no_api" ui-sref="app.configuration_rmbox_intervention_list({id: ' + data.id + '})" aria-label="update_rmbox" translate translate-attr-aria-label="RMBOXLIST.update_rmbox">' +
                        '<md-icon  md-font-icon="icon-worker" class="s18"></md-icon>' +
                        '</md-button></a>';
                    if (data.type === "Display") {
                        return buttonActionReloadScheduleHtml + buttonActionDetailHtml + buttonActionRapportPdf + buttonActionEditHtml + buttonActionDeleteHtml + buttonActionAssociateScheduleHtml + buttonActionActivatePlaylistHtml + buttonActionShowScheduleHtml +buttonActionInterventionHtml;
                    }
                    else {
                        return buttonActionDetailHtml + buttonActionRapportPdf + buttonActionEditHtml + buttonActionDeleteHtml +buttonActionInterventionHtml;
                    }


                })

        ];
        vm.deleteSelectedRmboxsConfirm = deleteSelectedRmboxsConfirm;
        vm.searchRmboxs = searchRmboxs;
        vm.deleteRmboxConfirm = deleteRmboxConfirm;
        vm.associateSchedule = associateSchedule;
        vm.getPlaylist = getPlaylist;

        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showRmboxDetail = showRmboxDetail;

        vm.addNewRmbox = addNewRmbox;
        $rootScope.rerender = rerender;
        vm.showListZone = showListZone;
        vm.showListVideo = showListVideo;
        vm.showStateDetails = showStateDetails;
        vm.pdfHistoryList = pdfHistoryList;
        vm.showScheduleByRmbox = showScheduleByRmbox;
        vm.reloadRmbox = reloadRmbox;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationRmboxAdd', $translate.instant('RMBOXLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationRmboxEdit', $translate.instant('RMBOXLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        function showScheduleByRmbox(rmbox, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            var urlFoDisplay = angular.isDefined(parameters.url_fo_display) ? parameters.url_fo_display : "";
            webTvGlobal.openNewWindow(urlFoDisplay + "show-schedule-by-rmbox/" + rmbox.id+'-bo');
        }


        /**
         * redirection to edit Schedule page
         * @param rmbox
         */
        function reloadRmbox(rmbox) {

            msApi.request('configuration_rmbox.ReloadRmbox@get',
                {id: rmbox.id},
                function (res) {

                    if (res.code === 200)
                        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.success_reload'));

                }, function (response) {
                }
            );
        }

        /**
         * Toggle selected status of the user
         *
         * @param rmbox
         */
        function toggle(rmbox) {
            rmbox.checked = !rmbox.checked;
            var idx = selectedRmboxs.indexOf(rmbox);
            if (idx > -1) {
                selectedRmboxs.splice(idx, 1);
            }
            else {
                selectedRmboxs.push(rmbox);
            }
            vm.selectedRmboxs = angular.copy(selectedRmboxs);
        }

        function toggleAll() {
            getElement();
            if (selectedRmboxs.length === vm.rmboxs.length) {
                vm.selectedRmboxs = [];
            }
            else if ((selectedRmboxs.length === 0) || (selectedRmboxs.length > 0)) {
                vm.selectedRmboxs = vm.rmboxs.slice(0);
            }
            selectedRmboxs = angular.copy(vm.selectedRmboxs);
            var list_rmbox = angular.copy(vm.rmboxsDataTable);
            angular.forEach(list_rmbox, function (value, key) {
                if (value !== undefined)
                    vm.rmboxsDataTable[key].checked = selectedRmboxs.length > 0;
            });
        }


        /**
         * Show rmbox Details
         * @param rmbox
         */
        function showRmboxDetail(rmbox, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('configuration_rmbox.getRmbox@get', {id: rmbox.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationRmboxData: response},
                            templateUrl: 'app/main/boitier/rmbox/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationRmboxDetailController',
                            controllerAs: 'vm'
                        });
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchRmboxInAPI(filtre), true);
        }


        /**
         * redirection to add new rmbox page
         * @param event
         */
        function addNewRmbox() {
            clearFlashMessage();
            $state.go('app.configuration_rmbox_add');
        }

        /**
         * Delete rmbox Confirm Dialog
         */
        function deleteRmboxConfirm(rmbox, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "RMBOXLIST.delete_rmbox_msg",
                "RMBOXLIST.delete_rmbox_aria_label"
            ])
                .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['RMBOXLIST.delete_rmbox_msg'])
                            .htmlContent('<b>' + rmbox.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['RMBOXLIST.delete_rmbox_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteRmbox(rmbox);
                            vm.selectedRmboxs = [];

                        }, function () {

                        });
                });


        }

        function getPlaylist(rmbox, ev) {
            var hide = false;
            msApi.request('configuration_rmbox.listPlaylists@get', {id: rmbox.id},
                function (res) {
                    vm.dataPlaylist=res.playlists;

                    $mdDialog.show({


                        controller: function (entity, playlists, playlist, $mdDialog) {
                            var vm = this;
                            vm.rmbox = entity;
                            vm.playlists = playlists;
                            vm.playlist = playlist;

                            vm.validate = validate;

                            function validate() {

                                $mdDialog.hide(vm.playlist);
                            }

                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                hide = true;
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/boitier/rmbox/list/activate.playlist.modale.template.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: rmbox,
                            playlists: getListPlaylist(vm.dataPlaylist),
                            playlist: vm.playlist,
                        }




                    }).then(function (param) {
                            if (!hide) {
                                param = angular.isDefined(param) ?  param : null;
                                msApi.request('configuration_rmbox.activatePlaylist@save', {
                                    idRmbox: rmbox.id,
                                    idPlaylist:param,
                                }, function (res) {
                                    if (res.code === 200) {
                                        webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                                        rerender();
                                    }
                                    else {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    }
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                })

                            }
                        }
                    )
                }
            );
        }

        function getListPlaylist(playlists) {
            var res = [];
            vm.playlist = "";
            for (var i = 0; i < playlists.length; i++) {
                if(playlists[i].active){
                    vm.playlist=playlists[i].playlist.id;
                }
                res.push({option: playlists[i].playlist.title,options: playlists[i].playlist.title, val: playlists[i].playlist.id});
            }
            return res;
        }
        /**
         * Associate schedule to rmbox
         */
        function associateSchedule(rmbox, ev) {
            var hide = false;
            msApi.request(vm.apiListe,
                function (res) {
                    if (vm.displayNew)
                    {
                        vm.dataProg=res.data.programs;
                    }
                    else
                    {
                        vm.dataProg=res.data.schedules;
                    }


                    $mdDialog.show({


                        controller: function (entity, schedules, $mdDialog,display) {
                            var vm = this;
                            vm.rmbox = entity;
                            vm.displayNew=display;
                            if (vm.displayNew)
                            {
                                vm.schedule = angular.isDefined(vm.rmbox.programs) ? vm.rmbox.programs !== null ? vm.rmbox.programs["id"] : "" : "";


                            }
                            else
                            {
                                vm.schedule = angular.isDefined(vm.rmbox.schedule) ? vm.rmbox.schedule !== null ? vm.rmbox.schedule["id"] : "" : "";

                            }

                            vm.schedules = webTvGlobal.convertToSelectChoicesFormat(schedules);

                            vm.validate = validate;

                            function validate() {

                                $mdDialog.hide(vm.schedule);
                            }

                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                hide = true;
                                $mdDialog.hide();

                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/boitier/rmbox/list/associate.schedule.modale.template.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: rmbox,
                            display:vm.displayNew,
                            schedules: vm.dataProg,

                        }




                    }).then(function (param) {
                            if (!hide) {
                                if (vm.displayNew)
                                {
                                    param = angular.isDefined(param) ? param === "idSchedule" ? null : param : null;
                                    msApi.request('configuration_rmbox.associateProgram@save', {
                                        idRmbox: rmbox.id,
                                        ids:param
                                    }, function (res) {
                                        if (res.code === 200) {
                                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                                            rerender();
                                        }
                                        else {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                        }
                                    }, function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    })
                                }else {
                                    param = angular.isDefined(param) ? param === "idSchedule" ? null : param : null;

                                    msApi.request('configuration_rmbox.associateSchedule@get', {
                                        idRmbox: rmbox.id,
                                        idSchedule: param
                                    }, function (res) {
                                        if (res.code === 200) {
                                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                                            rerender();
                                        }
                                        else {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                        }
                                    }, function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    })

                                }
                            }
                        }
                    )
                }
            );
        }

        /**
         * Delete rmbox
         */
        function deleteRmbox(Rmbox) {
            clearFlashMessage();
            if (vm.rmboxs.indexOf(Rmbox) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_rmbox.mdelete@delete', {id: Rmbox.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "RMBOXLIST.dialog_alert_delete_title",
                                "RMBOXLIST.dialog_alert_delete_description",
                                "RMBOXLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(Rmbox.name + translatedValues['RMBOXLIST.dialog_alert_delete_description']);
                                    vm.rmboxs.splice(vm.rmboxs.indexOf(Rmbox), 1);
                                    rerender();
                                });
                        }
                        else {
                            $translate([
                                "RMBOXLIST.dialog_alert_delete_error_title",
                                "RMBOXLIST.dialog_alert_delete_error_description",
                                "RMBOXLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['RMBOXLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['RMBOXLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['RMBOXLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        }
                        vm.selectedRmboxs = [];
                        vm.modelCheckAll = false;

                    }
                );

            }


        }

        function showListZone(rmbox) {
            $mdDialog.show({
                locals: {rmboxId: rmbox.id},
                templateUrl: "app/main/boitier/rmbox/list/preview.zone.liste.html",
                clickOutsideToClose: true,
                controller: 'zoneListController',
                controllerAs: 'vm'
            });
        }

        function showListVideo(rmbox) {
            $mdDialog.show({
                locals: {parametersOrdersListData: order_video, rmboxId: rmbox.id},
                templateUrl: "app/main/boitier/rmbox/list/preview.video.liste.html",
                clickOutsideToClose: true,
                controller: 'videoListController',
                controllerAs: 'vm'

            });
        }

        function showStateDetails(rmbox) {
            $rootScope.loadingProgress = true;
            msApi.request('configuration_rmbox.getStatutRmbox@get', {id: rmbox.id}, function (response) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(response.code) && response.code === 200) {
                    $mdDialog.show({
                        locals: {detailState: response},
                        templateUrl: "app/main/boitier/rmbox/list/preview.state.details.html",
                        clickOutsideToClose: true,
                        controller: 'stateDetailsController',
                        controllerAs: 'vm'
                    });
                } else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            }, function (error) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(error.message)) {
                    $translate('VALIDATIONS.' + error.message).then(function (message) {
                        webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                    }, function () {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                }
                else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                }
            })
        }

        function pdfHistoryList(rmbox) {
            $rootScope.loadingProgress = true;
            msApi.request('configuration_rmbox.getReportsRmbox@get', {id: rmbox.id}, function (response) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(response.code) && response.code === 200) {
                    $mdDialog.show({
                        locals: {reports: response},
                        templateUrl: "app/main/boitier/rmbox/list/preview.pdf.history.html",
                        clickOutsideToClose: true,
                        controller: 'pdfHistoryController',
                        controllerAs: 'vm'
                    });
                } else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            }, function (error) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(error.message)) {
                    $translate('VALIDATIONS.' + error.message).then(function (message) {
                        webTvGlobal.alertDialog($translate.instant('RMBOXLIST.dialog_alert_delete_error_title'), message);
                    }, function () {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                }
                else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            })
        }


    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.boitier.rmbox.list')
        .controller('configurationRmboxDetailController', configurationRmboxDetailController);

    /** @ngInject */
    function configurationRmboxDetailController(configurationRmboxData,$mdDialog)
    {
    	var vm = this;
        vm.rmbox = configurationRmboxData;
        vm.cancel = cancel;

        /**
         * Check if rmbox exists
         * @return if exists get RmBox Data else redirect to 404 page
         */

        function cancel () {
          $mdDialog.cancel();
        };

    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.rmbox.add',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_rmbox_add', {
                url: "/boitier/rmbox/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmbox/add_edit_view/add_edit.template.html',
                        controller : 'configurationRmboxAddController as vm'
                    }
                },
                resolve: {
                     configurationRmboxData: function (msApi)
                    {
						return msApi.resolve('configuration_rmbox.getRmbox@get',{id:0});
                    }
                    ,
                    configurationRmboxgroupsData: function (msApi)
                    {
                        return msApi.resolve('configuration_rmbox.getRmboxgroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_rmbox_post_add_action"
            });

       
        //API

        msApiProvider.register('configuration_rmbox.addRmbox', [Routing.generate('api_configuration_post_add_rmbox')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.rmbox.add')
    .controller('configurationRmboxAddController', configurationRmboxAddController);

  /** @ngInject */
  function configurationRmboxAddController(configurationRmboxData, configurationRmboxgroupsData, webTvGlobal, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $rootScope = $injector.get('$rootScope'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');
    var vm = this;
    vm.isNew = true;

    var rmbox = configurationRmboxData;
    vm.empConfigurationRmboxForm = {
      name: rmbox.name,
      type: rmbox.type,
      ip: rmbox.ip,
      mac: rmbox.mac,
      postal: rmbox.postal,
      group: rmbox.group
    };

    vm.groups = configurationRmboxgroupsData.data.rmboxgroups;
    vm.groups = webTvGlobal.convertToSelectChoicesFormat(vm.groups);
    vm.submitAddRmboxForm = submitAddRmboxForm;
    // vm.goToList = goToList;
    vm.types = convertItemsToChoices({
      Display: "Display",
      Proxy_cache: "Proxy cache"
    });

    function convertItemsToChoices(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], option: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmbox_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmbox_add_menuTitle";
      $rootScope.pageRoute = "app.configuration_rmbox_list";
      $rootScope.welcome = "welcome_rmbox_add";
      $rootScope.text = [{
        texte: "parameters_rmbox_add_help"
      }, {
        texte: "send_button_rmbox_add_help"
      }, {
        texte: "cancel_button_rmbox_add_help"
      }];
    }

    /**
     * Send add RmBox Form
     */
    function submitAddRmboxForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_rmbox.addRmbox@save',
        {"empConfigurationRmboxForm": angular.copy(vm.empConfigurationRmboxForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            rmbox = vm.empConfigurationRmboxForm;
            webTvGlobal.$flashMessages().set('configurationRmboxAdd', {title: vm.empConfigurationRmboxForm.name ? vm.empConfigurationRmboxForm.name : ""});
            $state.go('app.configuration_rmbox_list');
          }
          else if (res.code === 400 && angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function () {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
      );
    }

    // function goToList() {
    //     $state.go('app.configuration_rmbox_list');
    // }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.user.list', ["datatables"])
        .config(config);

    

    function config($stateProvider,  msApiProvider) {
        // State
        $stateProvider
            .state('app.abonnement_user_list', {
                url: "/abonnement/user/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/user/list/list.template.html',
                        controller: 'abonnementUserListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "subscription_user_list_dtable_action"
            });


        // Api
        var deleteuserRoute = Routing.generate('api_subscription_user_delete_user') + "/:id";
        var deleteListUsers=Routing.generate('api_multi_delete_multi_subscription_users')+"/:list";
        msApiProvider.register('abonnement_group.deleteUsers', [deleteListUsers, {list: '@list'}]);
        msApiProvider.register('abonnement_user.list', [Routing.generate('api_subscription_user_get_users')]);
        msApiProvider.register('abonnement_user.mdelete', [deleteuserRoute, {id: '@id'}]);
        msApiProvider.register('abonnement_user.modalGetUser', [Routing.generate('api_subscription_user_get_detail_user', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('abonnement_User.dtable', [Routing.generate('api_dtable_list_dtable_subscription_users')]);

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.abonnement.user.list')
        .controller('abonnementUserDetailController', abonnementUserDetailController);

    /** @ngInject */
    function abonnementUserDetailController(abonnementUserData,$mdDialog)
    {
    	var vm = this;
        vm.user = abonnementUserData;
        vm.cancel = cancel;

        /**
         * Check if user exists
         * @return if exists get User Data else redirect to 404 page
         */
        function cancel(){
          $mdDialog.hide();
        }



    }



})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.user.list')
        .controller('abonnementUserListController', abonnementUserListController);

    /** @ngInject */
    function abonnementUserListController($injector, $scope, $cookies, $translate, webTvGlobal, DTOptionsBuilder, DTColumnBuilder, $compile, dtable_language,dialogConfirmDeleteService , $http) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            HelpGlobal = $injector.get('HelpGlobal'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.users = [];
        vm.selectedUsers = [];
        var selectedUsers = [];
        vm.usersDataTable = {};
        vm.dtInstance = {};
        vm.getElement = getElement;
        var filtre = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[{
                // Target the id column
                targets: [0, 1],
                width: '72px'
            },

                {
                    targets: [2, 5],
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        function searchUsersInAPI(filtre) {
            let field = null;
            if (filtre.field) {
                if (filtre.field === "lastName") {
                    field = "LAST_NAME";
                  }else{
                field = filtre.field.toUpperCase();
                  }
            }
            let searchParam = null;

            if (vm.search_users) {
                searchParam =vm.search_users
            }
         
            const getUsersGql = "mutation ($pagination: Pagination!, $orderBy: SubscriptionUserOrder , $where: SubscriptionUserWhereInput!) { SubscriptionUsers(pagination: $pagination, orderBy: $orderBy, where: $where) { totalCount edges { node { Id Name LastName Email Login GroupID SubscriptionGroup { Id , Name } Protect } } } }";

            const variables = {
                pagination: {
                    offset: filtre.start === undefined ? 0 : filtre.start,
                    limit: filtre.length ===undefined ? 10 : filtre.length
                },
                orderBy: {
                    field: field || 'ID', 
                    direction: filtre.direction || 'DESC'
                },
                where: {} ,
                
            };
            if (searchParam) {
                if (!isNaN(searchParam)) {
                  variables.where = {
                    id: parseInt(searchParam),
                  };
                } else {
                  variables.where = {
                    nameContains: searchParam,
                  };
                }
            }
                                
            $http.post("https://" + window.process.env.API_HOST_GLOBAL + "/query", {
                query: getUsersGql,
                variables: variables
            }).then(function(response) {
                const usersData = response.data.data.SubscriptionUsers.edges.map(function(t) {
                    return {
                        id: t.node.Id,
                        email: t.node.Email,
                        lastName: t.node.LastName,
                        login: t.node.Login,
                        protect: t.node.Protect,
                        name: t.node.Name,
                        group: {
                            name: !!t.node.SubscriptionGroup ? t.node.SubscriptionGroup.Name :''  
                        } 

                        
                    };
                });
                
                const records = {
                    draw: filtre.draw,
                    recordsTotal: response.data.data.SubscriptionUsers.totalCount,
                    recordsFiltered: response.data.data.SubscriptionUsers.totalCount,
                    data: usersData
                };
        
                vm.users = usersData;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
            }).catch(function(error) {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                const records = {
                    draw: 0,
                    recordsTotal: 0,
                    recordsFiltered: 0,
                    data: []
                };
                vm.users = [];
                vm.fnCallback(records);
            });
        }
        

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }


        function serverData(sSource, aoData, fnCallback) {
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColumn = sort.column - 1 < 0 ? 0 : sort.column - 1;
            var orderByField = "";
            var orderByDirection = ""; 
            if (sort) {
                var clickedColumn = aoData[1].value.find(function(column, index) {
                    return index === sort.column;
                });
                if (clickedColumn) {
                    orderByField = clickedColumn.data;
                } else {
                    orderByField = "";
                }
            
                orderByDirection = sort.dir.toUpperCase();
            
                var filtre = {
                    draw: draw,
                    start: start,
                    length: length,
                    "search[value]": vm.search_users,
                    field: orderByField,
                    direction: orderByDirection
                };
                vm.fnCallback = fnCallback;
                searchUsersInAPI(filtre);
            }
            
        
    }
        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.usersDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.usersDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.usersDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('lastName').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('email').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('login').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn("group").notSortable().renderWith(function (data) {
                return data && angular.isDefined(data.name) ? data.name : "-";
            }),
            DTColumnBuilder.newColumn('protect').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.usersDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a has-permission="subscription_user_get_detail_action" tooltips tooltip-template=' + "{{'ABONNEMENTUSERLIST.detail_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button"  ng-click="vm.showUserDetail(vm.usersDataTable[' + data.id + '],$event)" aria-label="detail_user"translate translate-attr-aria-label="ABONNEMENTUSERLIST.detail_user">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a has-permission="subscription_user_post_edit_action" tooltips tooltip-template=' + "{{'ABONNEMENTUSERLIST.update_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex;" class="edit-button md-icon-button"  ui-sref="app.abonnement_user_edit({ id: ' + data.id + '})" aria-label="update_user" translate translate-attr-aria-label="ABONNEMENTUSERLIST.update_user">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a has-permission="subscription_user_delete_user_action" tooltips tooltip-template=' + "{{'ABONNEMENTUSERLIST.delete_user'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" ng-click="vm.deleteUserConfirm(vm.usersDataTable[' + data.id + '],ev)" aria-label="delete_user" translate translate-attr-aria-label="ABONNEMENTUSERLIST.delete_user">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        vm.searchUsers = searchUsers;
        vm.deleteSelectedUsersConfirm = deleteSelectedUsersConfirm;
        vm.deleteSelectedUsers = deleteSelectedUsers;
        vm.deleteUserConfirm = deleteUserConfirm;
        vm.deleteUser = deleteUser;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showUserDetail = showUserDetail;
        // vm.editUser = editUser;
        vm.addNewUser = addNewUser;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('abonnementUserAdd', $translate.instant('ABONNEMENTUSERLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('abonnementUserEdit', $translate.instant('ABONNEMENTUSERLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.abonnement_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.abonnement_user_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.abonnement_user_list_pagetitle";
            $rootScope.pageRoute = "";
            $rootScope.welcome = "welcome_user";
            $rootScope.text = [{
                texte: "add_button_user_help"
            }, {
                texte: "arrow_button_user_help"
            }, {
                texte: "search_area_user_help"
            }, {
                texte: "tri_column_user_help"
            },
                {
                    texte: "edit_button_user_help"
                }, {
                    texte: "detail_button_user_help"
                },
                {
                    texte: "delete_button_user_help"
                }];

        }


        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }



        /**
         * Toggle selected status of the user
         *
         * @param user
         */
        function toggle(user) {
            user.checked = !user.checked;
            var idx = selectedUsers.indexOf(user);
            if (idx > -1) {
                selectedUsers.splice(idx, 1);
            }
            else {
                selectedUsers.push(user);
            }
            vm.selectedUsers = angular.copy(selectedUsers);
        }

        function toggleAll() {
            getElement();
            if (selectedUsers.length === vm.users.length) {
                vm.selectedUsers = [];
            }
            else if ((selectedUsers.length === 0) || (selectedUsers.length > 0)) {
                vm.selectedUsers = vm.users.slice(0);
            }
            selectedUsers = angular.copy(vm.selectedUsers);
            var list_user = angular.copy(vm.usersDataTable);
            angular.forEach(list_user, function (value, key) {
                if (value !== undefined)
                    vm.usersDataTable[key].checked = selectedUsers.length > 0;
            });
        }

        /**
         * Show user Details
         * @param user
         */
        function showUserDetail(user, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;
            const mutation = "mutation GetSubscriptionUser($id: Int!) { SubscriptionUser(id: $id) { Id GroupID  Name LastName Email   Login Entity   CreatedAt   } }";
        
            const variables = {
                id: user.id
            };
        
            $http.post("https://" + window.process.env.API_HOST_GLOBAL + "/query", {
                query: mutation,
                variables: variables
            }).then(function(response) {
                $rootScope.loadingProgress = false;
                const userData = response.data.data.SubscriptionUser;
     

                if (userData) {
                    $mdDialog.show({
                        locals: { abonnementUserData: userData },
                        templateUrl: 'app/main/abonnement/user/detail/detail.modal.html',
                        clickOutsideToClose: true,
                        controller: 'abonnementUserDetailController',
                        controllerAs: 'vm'
                    })
                }
                else {
                    webTvGlobal.alertDialog("User data not found.");
                }
            }).catch(function(err) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(err.data) && angular.isDefined(err.data.message)) {
                    $translate('VALIDATIONS.' + err.data.message).then(function(message) {
                        webTvGlobal.alertDialog(message);
                    }, function() {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                } else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            });
        }
        

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchUsersInAPI(filtre), true);
        }

        // function editUser(user) {
        //     vm.clearFlashMessage();
        //     $state.go('app.abonnement_user_edit', {id: user.id});
        // }

        /**
         * redirection to add new user page
         * @param event
         */
        function addNewUser() {
            clearFlashMessage();
            $state.go('app.abonnement_user_add');
        }

        /**
         * Delete user Confirm Dialog
         */
        function deleteUserConfirm(user, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "ABONNEMENTUSERLIST.delete_user_msg",
                "ABONNEMENTUSERLIST.delete_user_aria_label"
            ])
                .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['ABONNEMENTUSERLIST.delete_user_msg'])
                            .htmlContent('<b>' + user.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['ABONNEMENTUSERLIST.delete_user_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteUser(user);
                            vm.selectedUsers = [];

                        }, function () {

                        });
                });


        }

        /*
        delete select users
        */
        function deleteSelectedUsersConfirm(ev) {
          var title;
          var ariaLabel;
            if (vm.selectedUsers.length !== 0) {
              if (vm.selectedUsers.length === 1) {
                title = 'ABONNEMENTUSERLIST.delete_element_user_msg';
                ariaLabel = 'ABONNEMENTUSERLIST.delete_user_aria_label';
              } else {
                title = 'ABONNEMENTUSERLIST.delete_list_users_msg';
                ariaLabel = 'ABONNEMENTUSERLIST.delete_users_aria_label';
              }


                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedUsers.length, title, ariaLabel)).then(function () {

                            deleteSelectedUsers(ev);



                    });

            }

        }

        /* delete selected groups*/
        function deleteSelectedUsers(ev) {
            clearFlashMessage();
            $rootScope.loadingProgress = true;
        
            var ids = [];
            for (var i = 0; i < vm.selectedUsers.length; i++) {
                ids.push(vm.selectedUsers[i].id);
            }
        
            var mutation = "mutation DeleteSubscriptionUsers($ids: [Int!]!) { DeleteSubscriptionUsers(ids: $ids) { code deleteditems undeleteditems } }";
        
            var variables = {
                ids: ids
            };
        
            $http({
                method: 'POST',
                url: "https://" + window.process.env.API_HOST_GLOBAL + "/query",
                data: {
                    query: mutation,
                    variables: variables
                }
            }).then(function(response) {
                $rootScope.loadingProgress = false;
                var data = response.data.data.DeleteSubscriptionUsers;
        
                if (data.code === 200) {
                    var undeleted = "";
                    var deleted = "";
                    if (data.undeleteditems !== null && data.undeleteditems.length !== 0) {
                        undeleted = $translate.instant("ABONNEMENTUSERLIST.undeleted_are", {'list': data.undeleteditems.join(",")});
                    }
                    deleted = $translate.instant("ABONNEMENTUSERLIST.deleted_are", {'list': data.deleteditems});
                    webTvGlobal.alertDialog(
                        deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                        $translate.instant('ABONNEMENTUSERLIST.dialog_alert_delete_title'),
                        '',
                        ev
                    );
                    selectedUsers = [];
                    rerender();
                } else {
                    webTvGlobal.alertDialog(
                        $translate.instant('ABONNEMENTUSERLIST.dialog_alert_delete_error_title'),
                        $translate.instant('ABONNEMENTUSERLIST.dialog_alert_delete_error_description'),
                        '',
                        ev
                    );
                    selectedUsers = [];
                }
            }).catch(function(err) {
                $rootScope.loadingProgress = false;
                if (angular.isDefined(err.data) && angular.isDefined(err.data.message)) {
                    $translate('VALIDATIONS.' + err.data.message).then(function (message) {
                        webTvGlobal.alertDialog(message);
                    }, function () {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                } else {
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
                selectedUsers = [];
                vm.modelCheckAll = false;
            });
        }
        

        /**
         * Delete user
         */

        function deleteUser(User) {
            clearFlashMessage();
            var index = -1;
            for (var i = 0; i < vm.users.length; i++) {
                if (vm.users[i] === User) {
                    index = i;
                    break;
                }
            }
            if (index !== -1) {
                $rootScope.loadingProgress = true;
        
                var mutation = "mutation DeleteSubscriptionUsers($id: [Int!]!) { DeleteSubscriptionUsers(ids: $id) { code deleteditems undeleteditems } }";
        
                var variables = {
                    id: User.id
                };
        
                $http({
                    method: 'POST',
                    url: "https://" + window.process.env.API_HOST_GLOBAL + "/query",
                    data: {
                        query: mutation,
                        variables: variables
                    },
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }).then(function(response) {
                    $rootScope.loadingProgress = false;
                    var data = response.data.data.DeleteSubscriptionUsers;
                    if (data.code === 200) {
                        $translate([
                            "ABONNEMENTUSERLIST.dialog_alert_delete_title",
                            "ABONNEMENTUSERLIST.dialog_alert_delete_description",
                            "ABONNEMENTUSERLIST.dialog_alert_delete_close"
                        ]).then(function (translatedValues) {
                            webTvGlobal.$toast().showSimple(User.name + translatedValues['ABONNEMENTUSERLIST.dialog_alert_delete_description']);
                            vm.users.splice(vm.users.indexOf(User), 1);
                            rerender();
                        });
                    }else {
                        $translate([
                            "ABONNEMENTUSERLIST.dialog_alert_delete_error_title",
                            "ABONNEMENTUSERLIST.dialog_alert_delete_error_description",
                            "ABONNEMENTUSERLIST.dialog_alert_delete_close"
                        ]).then(function (translatedValues) {
                            var alert = $mdDialog.alert({
                                title: translatedValues['ABONNEMENTUSERLIST.dialog_alert_delete_error_title'],
                                textContent: translatedValues['ABONNEMENTUSERLIST.dialog_alert_delete_error_description'],
                                ok: translatedValues['ABONNEMENTUSERLIST.dialog_alert_delete_close']
                            });
                            $mdDialog.show(alert).finally(function () {
                                alert = undefined;
                            });
                        });
                    }
                })
        .catch(function(err) {
                    $rootScope.loadingProgress = false;
                    var translatedValues = {
                        'MESSAGES.alert_xhr_error': 'XHR Error Message'
                    };
                    alert(translatedValues['MESSAGES.alert_xhr_error']);
                });
            }
        }
        
        
        

        
        function searchUsers() {
            filtre["search[value]"] = vm.search_users;
            filtre["start"] = 0;
            searchUsersInAPI(filtre);

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmboxgroup.list', ["datatables"])
        .config(config);


    function config($stateProvider,  msApiProvider) {
        // State
        $stateProvider
            .state('app.configuration_rmboxgroup_list', {
                url: "/boitier/rmboxgroup/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmboxgroup/list/list.template.html',
                        controller: 'configurationRmboxgroupListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "configuration_rmboxgroup_list_dtable_action"
            });



        // Api
        var deleteRmboxgroupRoute = Routing.generate('api_configuration_delete_rmboxgroup') + "/:id";
        var deleteListRmboxgroup=Routing.generate('api_multi_delete_multi_configuration_rmboxgroups')+"/:list";
        msApiProvider.register('configuration_rmboxgroup.deleteRmboxgroups', [deleteListRmboxgroup, {list: '@list'}]);
        msApiProvider.register('configuration_rmboxgroup.mdelete', [deleteRmboxgroupRoute, {id: '@id'}]);
        msApiProvider.register('configuration_rmboxgroup.dtable', [Routing.generate('api_dtable_list_dtable_configuration_rmboxgroups')]);
        msApiProvider.register('configuration_rmboxgroup.listSchedules', [Routing.generate('api_display_schedule_list_schedules')]);
        msApiProvider.register('configuration_rmboxgroup.associateSchedule', [Routing.generate('api_configuration_associate_schedule_to_rmboxgroup')]);

        msApiProvider.register('configuration_rmboxgroup.associateProgram', [Routing.generate('api_configuration_post_associate_program_to_rmboxgroup')]);
        msApiProvider.register('configuration_rmboxgroup.listPrograms', [Routing.generate('api_programDisplay_list_schedules')]);

    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.boitier.rmboxgroup.list')
        .controller('configurationRmboxgroupDetailController', configurationRmboxgroupDetailController);

    /** @ngInject */
    function configurationRmboxgroupDetailController(configurationRmboxgroupData,$mdDialog)
    {
    	var vm = this;
        vm.rmboxgroup = configurationRmboxgroupData;

      vm.cancel = cancel;

        /**
         * Check if rmboxgroup exists
         * @return if exists get RmBox group Data else redirect to 404 page
         */

        function cancel () {
          $mdDialog.cancel();
        };




    }



})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.user.add', ["flow"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.abonnement_user_add', {
                url: "/abonnement/user/add",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/user/add_edit_view/form.template.html',
                        controller: 'abonnementUserAddController as vm'
                    }
                },
                resolve: {
                    abonnementUserData: function (msApi) {
                        return msApi.resolve('abonnement_user.getNewUserData@get', {id: 0});
                    },
                    abonnementGroupsData: function (msApi) {
                        return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "subscription_user_post_add_action"
            });


        //API
        msApiProvider.register('abonnement_user.postImportFile', [Routing.generate('api_subscription_user_post_add_import')]);
        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('abonnement_user.getNewUserData', [Routing.generate('api_subscription_user_get_detail_user', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('abonnement_user.addUser', [Routing.generate('api_subscription_user_post_add_user')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.abonnement.user.add')
    .controller('abonnementUserAddController', abonnementUserAddController);

  /** @ngInject */
  function abonnementUserAddController($injector, $cookies, $rootScope, abonnementUserData, webTvGlobal, abonnementGroupsData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    var vm = this;
    vm.isNew = true;
    vm.empAbonnementUserError = [];
    var user = abonnementUserData;
    vm.empAbonnementUserForm = {
      name: user.name,
      group: user.group,
      email: ""
    };
    vm.groups = convertGroupsToSelectList(abonnementGroupsData.data.groups);
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.ngFlowOptions = {
      target: Routing.generate('api_subscription_user_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      flow: {}
    };

    vm.submitAddUserForm = submitAddUserForm;
    // vm.goToList = goToList;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;

    vm.downloadfile = downloadfile;

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'csv',
        'type': 'subscriptionUser'
      })
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.abonnement_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.abonnement_user_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.abonnement_user_add_menuTitle";
      $rootScope.pageRoute = "app.abonnement_user_list";
      $rootScope.welcome = "welcome_user_add";
      $rootScope.text = [{
        texte: "parameters_group_add_help"
      }, {
        texte: "send_button_group_add_help"
      }, {
        texte: "cancel_button_group_add_help"
      },{
            texte: "parameters_user_import_help"
          }];

    }

    function uploadFile() {
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function fileAdded(file) {
      if (!/(csv)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
      else  vm.inProgress = true;
      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.subscriptions;
        vm.file = message.subscriptions.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTUSERLIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);
      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    /**
     * Convert List To Select Option format
     */
    function convertGroupsToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    // function goToList() {
    //     $state.go('app.abonnement_user_list');
    // }

    // NOW UPLOAD THE FILES.
    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('abonnement_user.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTUSERLIST.add_user'));
            $state.go('app.abonnement_user_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          } else if (response.code === 400) {
            webTvGlobal.alertDialog($translate.instant('VALIDATIONS.subscriptionUser.name.not_blank'));
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }


    /**
     * Send add User Form
     */
    function submitAddUserForm() {
      $rootScope.loadingProgress = true;
      msApi.request('abonnement_user.addUser@save',
        {"empAbonnementUserForm": angular.copy(vm.empAbonnementUserForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            user = vm.empAbonnementUserForm;
            webTvGlobal.$flashMessages().set('abonnementUserAdd', {title: vm.empAbonnementUserForm.name ? vm.empAbonnementUserForm.name : ""});
            $state.go('app.abonnement_user_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            var empAbonnementUserError = [];
            errors.forEach(function (item) {
              empAbonnementUserError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAbonnementUserForm[item.for])
              };
            });
            vm.empAbonnementUserError = empAbonnementUserError;
          } else if (res.code === 400 && angular.isDefined(res.message)) {
            $translate('VALIDATIONS.' + res.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    vm.testMail = true;
    vm.checkMail = checkMail;

    function checkMail(mail) {
      var reg = new RegExp('^[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*@[a-z0-9]+([_|\.|-]{1}[a-z0-9]+)*[\.]{1}[a-z]{2,6}$', 'i');
      vm.testMail = reg.test(mail);
      vm.empAbonnementUserForm.email = mail;

    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.autoriseip.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.boitier_autoriseip_list', {
                url: "/boitier/autoriseip/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/boitier/autoriseip/list/list.template.html',
                        controller: 'boitierAutoriseipListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "boitier_autoriseip_list_dtable_action"
            });

        // Api

        var deleteIpRoute = Routing.generate('api_autorise_ips_delete_ips') + "/:id";
        msApiProvider.register('boitier_autoriseip.mdelete', [deleteIpRoute, {id: '@id'}]);
        msApiProvider.register('boitier_autoriseip.modalGetIp', [Routing.generate('api_autorise_ips_get_detail_ips', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('boitier_autoriseip.dtable', [Routing.generate('api_dtable_list_dtable_autorise_ips')]);
        var deleteListIps = Routing.generate('api_multi_delete_multi_autorise_ips') + "/:list";
        msApiProvider.register('boitier_autoriseip.deleteIps', [deleteListIps, {list: '@list'}]);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.autoriseip.list')
        .controller('boitierAutoriseipListController', boitierAutoriseipListController);

    /** @ngInject */
    function boitierAutoriseipListController(userManager, DTColumnBuilder, msUtils, $cookies, $scope, msApi, DTOptionsBuilder, webTvGlobal, $injector, dtable_language,dialogConfirmDeleteService) {

        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $rootScope = $injector.get('$rootScope'),
            $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate'),
            $mdDialog = $injector.get('$mdDialog');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var filtre = {};
        vm.ips = [];
        vm.selectedIps = [];
        var selectedIps = [];
        vm.ipsDataTable = {};
        vm.dtInstance = {};
        vm.search_ips = "";
        vm.boitier_autoriseip_delete_multi = false;
        if (userManager.isActionGranted('boitier_autoriseip_delete_multi')) {
            vm.boitier_autoriseip_delete_multi = true;
        }
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },
                {
                    // Target the actions column
                    targets: 3,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])

            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;

        //searchIpsInAP method
        function searchIpsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('boitier_autoriseip.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.ips = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    } else {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {
                            records = {
                                'draw': 0,
                                'recordsTotal': 0,
                                'recordsFiltered': 0,
                                'data': 0
                            };
                            vm.ips = [];
                            vm.fnCallback(records);
                            $rootScope.loadingProgress = false;
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }

                    }
                }
                ,
                function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );


        }

        //serverData method
        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_ips,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchIpsInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.ipsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.ipsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id'),
            DTColumnBuilder.newColumn('ip'),
            DTColumnBuilder.newColumn('description'),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.ipsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a has-permission="boitier_autoriseip_get_detail" tooltips tooltip-template=' + "{{'IPLIST.detail_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" ng-click="vm.showIpDetail(vm.ipsDataTable[' + data.id + '],$event)" aria-label="detail_ip"translate translate-attr-aria-label="IPLIST.detail_ip">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a has-permission="boitier_autoriseip_post_edit" tooltips tooltip-template=' + "{{'IPLIST.update_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" ui-sref="app.boitier_autoriseip_edit({id: ' + data.id + '})" aria-label="update_ip" translate translate-attr-aria-label="IPLIST.update_ip" >' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a has-permission="boitier_autoriseip_delete_ips" tooltips tooltip-template=' + "{{'IPLIST.delete_ip'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button aria-label="delete_ip" class="m16 delete-button md-icon-button"  ng-click="vm.deleteIpConfirm(vm.ipsDataTable[' + data.id + '],ev)" translate translate-attr-aria-label="IPLIST.delete_ip" >' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

                })

        ];
        if(!vm.boitier_autoriseip_delete_multi) {
            vm.dtColumns[0].bVisible = false;
        }

        vm.searchIps = searchIps;

        vm.deleteIpConfirm = deleteIpConfirm;
        vm.deleteSelectedIpsConfirm = deleteSelectedIpsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showIpDetail = showIpDetail;
        vm.addNewIp = addNewIp;
        $rootScope.rerender = rerender;
        var flashMessages = {title: ""};
        showFlasMessageToast('boitierAutoriseipAdd', $translate.instant('IPLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('boitierAutoriseipEdit', $translate.instant('IPLIST.edited'));


        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }


        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.rmbox_autorise_ip_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.rmbox_autorise_ip_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_boitier_autorise_ip";
            $rootScope.text = [{
                texte: "add_button_profil_ip_help"
            }, {
                texte: "arrow_button_profil_ip_help"
            }, {
                texte: "search_area_profil_ip_help"
            }, {
                texte: "tri_column_profil_ip_help"
            },
                {
                    texte: "edit_button_profil_ip_help"
                }, {
                    texte: "detail_button_profil_ip_help"
                },
                {
                    texte: "delete_button_profil_ip_help"
                }];
        }


        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */
        flashMessages = {title: ""};

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }


        /**
         * @param ip
         */
        function toggle(ip) {
            ip.checked = !ip.checked;
            var idx = selectedIps.indexOf(ip);
            if (idx > -1) {
                selectedIps.splice(idx, 1);
            }
            else {
                selectedIps.push(ip);
            }
            vm.selectedIps = angular.copy(selectedIps);
        }


        function toggleAll() {
            getElement();
            if (selectedIps.length === vm.ips.length) {
                vm.selectedIps = [];
            }
            else if ((selectedIps.length === 0) || (selectedIps.length > 0)) {
                vm.selectedIps = vm.ips.slice(0);
            }
            selectedIps = angular.copy(vm.selectedIps);
            var list_ip = angular.copy(vm.ipsDataTable);
            angular.forEach(list_ip, function (value,key) {
                if(value !== undefined)
                    vm.ipsDataTable[key].checked =  selectedIps.length>0;
            });
        }

        /**
         * Show ip adress Details
         * @param ip adress
         */
        function showIpDetail(ip, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }
            $rootScope.loadingProgress = true;
            msApi.request('boitier_autoriseip.modalGetIp@get', {id: ip.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {autoriseIpData: response},
                            templateUrl: 'app/main/boitier/autoriseip/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'boitierAutoriseipDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATION.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATION.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }

        /**
         * Get Detail Link
         * @param ip
         * @return string detail link
         */

        /*function getDetailLink(ip) {
            return /chrome/.test(msUtils.detectBrowser().browser) ? $state.href('app.profiles_ip_detail_modal', {id: ip.id}) : $state.href('app.profiles_ip_detail', {id: ip.id});

        }*/


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchIpsInAPI(filtre), true);
        }

        /*function editIp(ip) {
            clearFlashMessage();
            $state.go('app.profiles_ip_edit', {id: ip.id});
        }*/

        /**
         * redirection to add new ip adress page
         * @param event
         */
        function addNewIp() {
            clearFlashMessage();
            $state.go('app.boitier_autoriseip_add');
        }

        /**
         * Delete ip adress Confirm Dialog
         */
        function deleteIpConfirm(ip, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "IPLIST.delete_ip_msg",
                "IPLIST.delete_ip_aria_label"
            ])
                .then(function (translatedValues) {
                    var confirm = $mdDialog.confirm()
                        .htmlContent('<b>' + ip.ip + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['IPLIST.delete_ip_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);

                    $mdDialog.show(confirm).then(function () {

                        deleteIp(ip);
                        vm.selectedIps = [];

                    }, function () {

                    });
                });


        }

        /**
         * Delete ip adress
         */
        function deleteIp(ip) {
            clearFlashMessage();
            if (vm.ips.indexOf(ip) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('boitier_autoriseip.mdelete@delete', {id: ip.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "IPLIST.dialog_alert_delete_title",
                                "IPLIST.dialog_alert_delete_description",
                                "IPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    webTvGlobal.$toast().showSimple(ip.ip + translatedValues['IPLIST.dialog_alert_delete_description']);
                                    vm.ips.splice(vm.ips.indexOf(ip), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "IPLIST.dialog_alert_delete_error_title",
                                "IPLIST.dialog_alert_delete_error_description",
                                "IPLIST.dialog_alert_delete_close"
                            ])
                                .then(function () {


                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    },
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {

                                webTvGlobal.alertDialog(message);
                            }), function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            };
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }

        function deleteSelectedIpsConfirm(ev) {
          var title;
          var ariaLabel;
            if (selectedIps.length !== 0) {
              if (selectedIps.length === 1) {
                title = 'IPLIST.delete_element_ip_msg';
                ariaLabel = 'IPLIST.delete_ip_aria_label';
              } else {
                title = 'IPLIST.delete_list_ips_msg';
                ariaLabel = 'IPLIST.delete_ips_aria_label';
              }

              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, selectedIps.length, title, ariaLabel)).then(function () {

                            deleteSelectedIps(ev);


                        });


            }

        }

        /* delete selected groups*/
        function deleteSelectedIps(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('boitier_autoriseip.deleteIps@delete', {
                    list: (function (list) {
                        selectedIps.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("IPLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("IPLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('IPLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedIps = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('IPLIST.dialog_alert_delete_error_title'),
                            $translate.instant('IPLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedIps = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedIps = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        /**
         *  call the api
         */
        function searchIps() {
            filtre["search[value]"] = vm.search_ips;
            searchIpsInAPI(filtre);
        }


    }
})();


(function ()
{
    'use strict';

    angular
        .module('app.boitier.autoriseip.list')
        .controller('boitierAutoriseipDetailController', boitierAutoriseipDetailController);

    /** @ngInject */
    function boitierAutoriseipDetailController(autoriseIpData,$mdDialog)
    {
    	var vm = this;
        vm.ip = autoriseIpData;


      vm.cancel = cancel;




      function cancel() {
        $mdDialog.hide();
      }


    }



})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.autoriseip.edit',[])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.boitier_autoriseip_edit', {
                url: "/boitier/autoriseip/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/autoriseip/add_edit_view/add_edit.template.html',
                        controller : 'boitierAutoriseipEditController as vm'
                    }
                },
                resolve: {
                    autoriseIpData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('boitier_autoriseip.getNewIpData@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "boitier_autoriseip_post_edit_action"
            });


        // API
        msApiProvider.register('boitier_autoriseip.getNewIpData', [Routing.generate('api_autorise_ips_get_detail_ips',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('boitier_autoriseip.editIp', [Routing.generate('api_autorise_ips_post_edit_ips',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}]);
	}
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.autoriseip.edit')
    .controller('boitierAutoriseipEditController', boitierAutoriseipEditController);

  /** @ngInject */
  function boitierAutoriseipEditController(webTvGlobal, $translate, msApi, $rootScope, $state, autoriseIpData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    var ip = autoriseIpData;
    var empAutoriseIpError = [];
    vm.empAutoriseIpForm = {};
    vm.submitIpForm = submitIpForm;
    fillData();


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.rmbox_autorise_ip_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.rmbox_autorise_ip_edit_menuTitle";
      $rootScope.pageRoute = "app.boitier_autoriseip_list";
      $rootScope.welcome = "welcome_boitier_autorise_ip_edit";
      $rootScope.text = [{
        texte: "parameters_profil_ip_add_help"
      }, {
        texte: "send_button_profil_ip_edit_help"
      }, {
        texte: "cancel_button_profil_ip_add_help"
      }];
    }

    /**
     * Check if ip exists
     * @return if exists get ip Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(ip.code) && ip.code !== 200) $state.go('app.error_404');
      else {
        vm.empAutoriseIpForm = {
          ip: ip.ip,
          description: ip.description

        };
        $rootScope.itemName = ip.ip || '';
      }
    }


    /**
     * Send add ip Form
     */
    function submitIpForm() {
      msApi.request('boitier_autoriseip.editIp@save',
        {id: ip.id, "empAutoriseIpForm": angular.copy(vm.empAutoriseIpForm)},
        function (res) {
          if (res.code === 200) {
            ip = vm.empAutoriseIpForm;
            webTvGlobal.$flashMessages().set('boitierAutoriseipEdit', {title: vm.empAutoriseIpForm.ip ? vm.empAutoriseIpForm.ip : ""});
            $state.go('app.boitier_autoriseip_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


              empAutoriseIpError = [];

            errors.forEach(function (item) {
                empAutoriseIpError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empProfilesUserForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.autoriseip.add',["datatables"])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.boitier_autoriseip_add', {
                url: "/boitier/autoriseip/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/autoriseip/add_edit_view/add_edit.template.html',
                        controller : 'boitierAutoriseipAddController as vm'
                    }
                },
                resolve: {
                     autoriseIpData: function (msApi)
                    {
						return msApi.resolve('boitier_autoriseip.getNewIpData@get',{id:0});
                    }
                    
                },
                "bodyClass": "forms",
                "actionPermission" : "boitier_autoriseip_post_add_action"
            });
        
        //API
        msApiProvider.register('boitier_autoriseip.getNewIpData', [Routing.generate('api_autorise_ips_get_detail_ips',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('boitier_autoriseip.addIp', [Routing.generate('api_autorise_ips_post_add_ips')]);
        
        



    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.autoriseip.add')
    .controller('boitierAutoriseipAddController', boitierAutoriseipAddController);

  /** @ngInject */
  function boitierAutoriseipAddController($rootScope, $translate, msApi, $state, autoriseIpData, webTvGlobal) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.isNew = true;

    var ip = autoriseIpData;
    var empAutoriseIpError = [];
    vm.empAutoriseIpForm = {
      ip: ip.ip,
      description: ip.description

    };
    vm.submitIpForm = submitIpForm;


    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.rmbox_autorise_ip_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.rmbox_autorise_ip_add_menuTitle";
      $rootScope.pageRoute = "app.boitier_autoriseip_list";

      $rootScope.welcome = "welcome_boitier_autorise_ip_add";
      $rootScope.text = [{
        texte: "parameters_profil_ip_add_help"
      }, {
        texte: "send_button_profil_ip_add_help"
      }, {
        texte: "cancel_button_profil_ip_add_help"
      }];
    }


    /**
     * Send add ip Form
     */
    function submitIpForm() {
      $rootScope.loadingProgress = true;
      msApi.request('boitier_autoriseip.addIp@save',
        {"empAutoriseIpForm": angular.copy(vm.empAutoriseIpForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            webTvGlobal.$flashMessages().set('boitierAutoriseipAdd', {title: vm.empAutoriseIpForm.ip ? vm.empAutoriseIpForm.ip : ""});
            $state.go('app.boitier_autoriseip_list');
          }
          else if (angular.isDefined(res.errors)) {

            var errors = res.errors;


              empAutoriseIpError = [];

            errors.forEach(function (item) {
                empAutoriseIpError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAutoriseIpForm[item.for])
              };

            });


          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(res.data) && angular.isDefined(res.data.message)) {
            $translate('VALIDATIONS.' + res.data.message).then(function (message) {
              webTvGlobal.alertDialog(message);
            }, function () {
              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
            });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }
  }

})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmboxgroup.list')
        .controller('configurationRmboxgroupListController', configurationRmboxgroupListController);

    /** @ngInject */
    function configurationRmboxgroupListController($scope, DTOptionsBuilder, $cookies, DTColumnBuilder, webTvGlobal, $compile, $injector, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');

        var $rootScope = $injector.get('$rootScope'),
            $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            $mdDialog = $injector.get('$mdDialog'),
            msApi = $injector.get('msApi'),
            msUtils = $injector.get('msUtils');
        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmboxgroup_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmboxgroup_list_pagetitle";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "welcome_rmbox_group";
            $rootScope.text = [{
                texte: "add_button_rmbox_group_help"
            }, {
                texte: "arrow_button_rmbox_group_help"
            }, {
                texte: "search_area_rmbox_group_help"
            }, {
                texte: "tri_column_rmbox_group_help"
            },
                {
                    texte: "edit_button_rmbox_group_help"
                }, {
                    texte: "detail_button_rmbox_group_help"
                },
                {
                    texte: "delete_button_rmbox_group_help"
                },
                {texte: "associate_schedule_button_rmbox_group_help"}];

        }

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var parameters = webTvGlobal.$constant().webTvParameterBag();

        var filtre = {};
        //Data Table options
        vm.rmboxgroups = [];
        vm.selectedRmboxgroups = [];
        var selectedRmboxgroups = [];
        vm.rmboxgroupsDataTable = {};
        vm.dtInstance = {};
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('serverSide', true)
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: false,
                    filterable: false,
                    sortable: false
                },
                {
                    targets: 4,
                    render: function (data) {
                        if (data === "") return "--";
                        if (parseInt(data) < 1) return "--";
                        return data;
                    }
                },
                {
                    // Target the actions column
                    targets: 5,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        if (angular.isDefined(parameters.show_display_grapes) && parameters.show_display_grapes === '1') {
            vm.displayNew = true;
        } else {
            vm.displayNew = false;
        }
        if (vm.displayNew === true) {
            vm.Activatedisplay = 'programs[]';
            vm.apiListe = 'configuration_rmboxgroup.listPrograms@get';

        } else {
            vm.Activatedisplay = 'schedule';
            vm.apiListe = 'configuration_rmboxgroup.listSchedules@get';
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function searchRmboxgroupInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('configuration_rmboxgroup.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.rmboxgroups = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();

                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }

                }
            );
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);

            vm.selectedRmboxgroups = [];
            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_rmboxgroups,
                "order[0][column]": 0,
                "order[0][dir]": sort.dir
            };
            filtre["columns[0][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchRmboxgroupInAPI(filtre);
        }

        vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxgroupsDataTable[data.id] = data;
                    return '<md-checkbox ng-checked="vm.rmboxgroupsDataTable[' + data.id + '].checked"' +
                        'ng-click="vm.toggle(vm.rmboxgroupsDataTable[' + data.id + '])"' +
                        'aria-label="-">' +
                        '</md-checkbox> ';
                }),
            DTColumnBuilder.newColumn('id').renderWith(function (data) {
                return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('bandwidthLimit').renderWith(function (data) {
                return angular.isDefined(data) ? data : " ";
            }), DTColumnBuilder.newColumn('syncTime').renderWith(function (data) {
                return (angular.isDefined(data) && data !== null) ? (moment(data).format('HH:mm:ss')) : "";
            }),
            DTColumnBuilder.newColumn(vm.Activatedisplay + '.title').renderWith(function (data) {
                var serverHtml = "";
                if (vm.displayNew) {
                    serverHtml += '<ul>';

                    for (var i = 0; i < data.length; i++) {
                        serverHtml += '<li style="padding-right: 90%;"> ' + data[i] + ' </li>';
                    }
                    serverHtml += '</ul>';

                }

                else {
                    serverHtml += '<ul>';
                    if (angular.isDefined(data)) {
                        serverHtml += '<li style="padding-right: 90%;"> ' + data + ' </li>';

                    }

                    serverHtml += '</ul>';
                }
                return serverHtml;
            }),
            DTColumnBuilder.newColumn(null).notSortable()
                .renderWith(function (data) {
                    vm.rmboxgroupsDataTable[data.id] = data;

                    var buttonActionDetailHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXGROUPLIST.detail_rmboxgroup'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="show-button md-icon-button" has-permission="configuration_rmboxgroup_get_detail" ng-click="vm.showRmboxgroupDetail(vm.rmboxgroupsDataTable[' + data.id + '],$event)" aria-label="detail_rmboxgroup"translate translate-attr-aria-label="RMBOXGROUPLIST.detail_rmboxgroup">' +
                        '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionEditHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXGROUPLIST.update_rmboxgroup'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button style="display: inline-flex" class="edit-button md-icon-button" has-permission="configuration_rmboxgroup_post_edit" ui-sref="app.configuration_rmboxgroup_edit({id:' + data.id + '})" aria-label="update_rmboxgroup" translate translate-attr-aria-label="RMBOXGROUPLIST.update_rmboxgroup">' +
                        '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                        '</md-button></a>';
                    var buttonActionDeleteHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXGROUPLIST.delete_rmboxgroup'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button class="m16 delete-button md-icon-button" has-permission="configuration_rmboxgroup_delete_rmboxgroup" ng-click="vm.deleteRmboxgroupConfirm(vm.rmboxgroupsDataTable[' + data.id + '],ev)" aria-label="delete_rmboxgroup" translate translate-attr-aria-label="RMBOXGROUPLIST.delete_rmboxgroup">' +
                        '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                        ' </md-button></a>';
                    var buttonActionAssociateScheduleHtml =
                        '<a tooltips tooltip-template=' + "{{'RMBOXGROUPLIST.associate_schedule'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                        '<md-button has-permission="configuration_rmboxgroup_associate_schedule_no_api" class="m16 delete-button md-icon-button" ng-click="vm.associateSchedule(vm.rmboxgroupsDataTable[' + data.id + '],ev)" aria-label="associate_schedule" translate translate-attr-aria-label="RMBOXGROUPLIST.associate_schedule">' +
                        '<md-icon  md-font-icon="icon-calendar-text" class="s18"></md-icon>' +
                        '</md-button></a>';

                    return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml + buttonActionAssociateScheduleHtml;

                })

        ];
        vm.searchRmboxgroups = searchRmboxgroups;
        vm.deleteRmboxgroupConfirm = deleteRmboxgroupConfirm;
        vm.deleteSelectedRmboxgroupsConfirm = deleteSelectedRmboxgroupsConfirm;
        vm.associateSchedule = associateSchedule;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showRmboxgroupDetail = showRmboxgroupDetail;
        vm.addNewRmboxgroup = addNewRmboxgroup;
        $rootScope.rerender = rerender;
        var checkedSelected = false;
        var flashMessages = {title: ""};
        showFlasMessageToast('configurationRmboxgroupAdd', $translate.instant('RMBOXGROUPLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('configurationRmboxgroupEdit', $translate.instant('RMBOXGROUPLIST.edited'));

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message + (flashMessages.title ? (" : " + flashMessages.title) : ""), angular.isDefined(toastPosition) ? toastPosition : false);

        }


        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */

        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the user
         *
         * @param rmboxgroup
         */
        function toggle(rmboxgroup) {
            rmboxgroup.checked = !rmboxgroup.checked;
            var idx = selectedRmboxgroups.indexOf(rmboxgroup);
            if (idx > -1) {
                selectedRmboxgroups.splice(idx, 1);
            }
            else {
                selectedRmboxgroups.push(rmboxgroup);
            }
            vm.selectedRmboxgroups = angular.copy(selectedRmboxgroups);
        }

        function toggleAll() {
            getElement();
            if (selectedRmboxgroups.length === vm.rmboxgroups.length) {
                vm.selectedRmboxgroups = [];
            }
            else if ((selectedRmboxgroups.length === 0) || (selectedRmboxgroups.length > 0)) {
                vm.selectedRmboxgroups = vm.rmboxgroups.slice(0);
            }
            selectedRmboxgroups = angular.copy(vm.selectedRmboxgroups);
            var list_rmboxgroup = angular.copy(vm.rmboxgroupsDataTable);
            angular.forEach(list_rmboxgroup, function (value, key) {
                if (value !== undefined)
                    vm.rmboxgroupsDataTable[key].checked = selectedRmboxgroups.length > 0;
            });
        }


        /**
         * Show RmboxgroupDetails
         * @param rmboxgroup
         */
        function showRmboxgroupDetail(rmboxgroup, ev) {
            clearFlashMessage();
            if (ev) {
                ev.preventDefault();
            }

            $rootScope.loadingProgress = true;

            msApi.request('configuration_rmboxgroup.getRmboxgroup@get', {id: rmboxgroup.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.code) && response.code === 200) {
                        $mdDialog.show({
                            locals: {configurationRmboxgroupData: response},
                            templateUrl: 'app/main/boitier/rmboxgroup/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'configurationRmboxgroupDetailController',
                            controllerAs: 'vm'
                        })
                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );

        }

        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchRmboxgroupInAPI(filtre), true);
        }


        /**
         * redirection to add new rmboxgroup page
         * @param event
         */
        function addNewRmboxgroup() {
            clearFlashMessage();
            $state.go('app.configuration_rmboxgroup_add');
        }

        /**
         * Associate schedule to rmboxgroup
         */
        function associateSchedule(Rmboxgroup, ev) {
            var hide = false;
            msApi.request(vm.apiListe,
                function (res) {
                    if (vm.displayNew) {
                        vm.dataProg = res.data.programs;
                    }
                    else {
                        vm.dataProg = res.data.schedules;
                    }


                    $mdDialog.show({


                        controller: function (entity, schedules, $mdDialog, display) {
                            var vm = this;
                            vm.rmbox = entity;
                            vm.displayNew = display;
                            if (vm.displayNew) {
                                vm.schedule = angular.isDefined(vm.rmbox.programs) ? vm.rmbox.programs !== null ? vm.rmbox.programs["id"] : "" : "";


                            }
                            else {
                                vm.schedule = angular.isDefined(vm.rmbox.schedule) ? vm.rmbox.schedule !== null ? vm.rmbox.schedule["id"] : "" : "";

                            }

                            vm.schedules = webTvGlobal.convertToSelectChoicesFormat(schedules);

                            vm.validate = validate;

                            function validate() {

                                $mdDialog.hide(vm.schedule);
                            }

                            vm.closeDialog = closeDialog;

                            function closeDialog() {
                                $mdDialog.hide();
                                hide = true;
                            }
                        },
                        controllerAs: 'vm',
                        templateUrl: 'app/main/boitier/rmbox/list/associate.schedule.modale.template.html',
                        targetEvent: ev,
                        clickOutsideToClose: true,
                        locals: {
                            entity: Rmboxgroup,
                            display: vm.displayNew,
                            schedules: vm.dataProg,

                        }


                    }).then(function (param) {
                            if (!hide) {
                                if (vm.displayNew) {
                                    param = angular.isDefined(param) ? param === "idSchedule" ? null : param : null;
                                    msApi.request('configuration_rmboxgroup.associateProgram@save', {
                                        idRmboxgroup: Rmboxgroup.id,
                                        ids: param
                                    }, function (res) {
                                        if (res.code === 200) {
                                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                                            rerender();
                                        }
                                        else {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                        }
                                    }, function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    })
                                } else {
                                    param = angular.isDefined(param) ? param === "idSchedule" ? null : param : null;

                                    msApi.request('configuration_rmboxgroup.associateSchedule@get', {
                                        idRmboxgroup: Rmboxgroup.id,
                                        idSchedule: param
                                    }, function (res) {
                                        if (res.code === 200) {
                                            webTvGlobal.$toast().showSimple($translate.instant('MESSAGES.alert_edit_confirm'));
                                            rerender();
                                        }
                                        else {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                        }
                                    }, function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                    })

                                }
                            }
                        }
                    )
                }
            );
        }

        /**
         * Delete RmboxgroupConfirm Dialog
         */
        function deleteRmboxgroupConfirm(Rmboxgroup, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "RMBOXGROUPLIST.delete_rmboxgroup_msg",
                "RMBOXGROUPLIST.delete_rmboxgroup_aria_label"
            ])
                .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['RMBOXGROUPLIST.delete_rmboxgroup_msg'])
                            .htmlContent('<b>' + Rmboxgroup.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['RMBOXGROUPLIST.delete_rmboxgroup_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {

                            deleteRmboxgroup(Rmboxgroup);
                            vm.selectedRmboxgroups = [];

                        }, function () {

                        });
                });


        }

        function deleteSelectedRmboxgroupsConfirm(ev) {
            var title;
            var ariaLabel;
            if (vm.selectedRmboxgroups.length!== 0) {
                if(vm.selectedRmboxgroups.length === 1){
                    title = 'RMBOXGROUPLIST.delete_rmboxgroup_msg';
                    ariaLabel = 'RMBOXGROUPLIST.delete_rmboxgroup_aria_label';
                }else{
                    title = 'RMBOXGROUPLIST.delete_list_rmboxgroup_msg';
                    ariaLabel = 'RMBOXGROUPLIST.delete_rmboxgroups_aria_label';
                }
                $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev,vm.selectedRmboxgroups.length,title,ariaLabel)).then(function () {
                    deleteSelectedRmboxgroups(ev);
                });

            }

        }

        /* delete selected groups*/
        function deleteSelectedRmboxgroups(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('configuration_rmboxgroup.deleteRmboxgroups@delete', {
                    list: (function (list) {
                        selectedRmboxgroups.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = "";
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("RMBOXGROUPLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        deleted = $translate.instant("RMBOXGROUPLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('RMBOXGROUPLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedRmboxgroups = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('RMBOXGROUPLIST.dialog_alert_delete_error_title'),
                            $translate.instant('RMBOXGROUPLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedRmboxgroups = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.message)) {
                        $translate('VALIDATIONS.' + response.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedRmboxgroups = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        /**
         * Delete RmBox group
         */
        function deleteRmboxgroup(Rmboxgroup) {
            clearFlashMessage();
            if (vm.rmboxgroups.indexOf(Rmboxgroup) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('configuration_rmboxgroup.mdelete@delete', {id: Rmboxgroup.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "RMBOXGROUPLIST.dialog_alert_delete_title",
                                "RMBOXGROUPLIST.dialog_alert_delete_description",
                                "RMBOXGROUPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['RMBOXGROUPLIST.dialog_alert_delete_title'],
                                        textContent: Rmboxgroup.name + translatedValues['RMBOXGROUPLIST.dialog_alert_delete_description'],
                                        ok: translatedValues['RMBOXGROUPLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                    vm.rmboxgroups.splice(vm.rmboxgroups.indexOf(Rmboxgroup), 1);
                                    rerender();
                                });

                        }
                        else {
                            $translate([
                                "RMBOXGROUPLIST.dialog_alert_delete_error_title",
                                "RMBOXGROUPLIST.dialog_alert_delete_error_description",
                                "RMBOXGROUPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['RMBOXGROUPLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['RMBOXGROUPLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['RMBOXGROUPLIST.dialog_alert_delete_close']
                                    });

                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }


        }


        function searchRmboxgroups() {
            filtre["search[value]"] = vm.search_rmboxgroups;
            searchRmboxgroupInAPI(filtre);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.group.list', ["datatables"])
        .config(config);


    function config($stateProvider, msApiProvider) {

        // State
        $stateProvider
            .state('app.abonnement_group_list', {
                url: "/abonnement/group/list",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/group/list/list.template.html',
                        controller: 'abonnementGroupListController as vm'
                    }
                },
                "bodyClass": "e-commerce",
                "actionPermission" : "subscription_group_list_dtable_action"
            });

        // Api
        var deletegroupRoute = Routing.generate('api_subscription_group_delete_group') + "/:id";
        var deleteListGroups = Routing.generate('api_multi_delete_multi_subscription_groups') + "/:list";
        msApiProvider.register('abonnement_group.list', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('abonnement_group.mdelete', [deletegroupRoute, {id: '@id'}]);
        msApiProvider.register('abonnement_group.deleteGroups', [deleteListGroups, {list: '@list'}]);
        msApiProvider.register('abonnement_group.modalGetGroup', [Routing.generate('api_subscription_group_get_detail_group', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('abonnement_Group.dtable', [Routing.generate('api_dtable_list_dtable_subscription_groups')]);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.group.list')
        .controller('abonnementGroupListController', abonnementGroupListController);

    /** @ngInject */
    function abonnementGroupListController(webTvGlobal, DTOptionsBuilder, $cookies, DTColumnBuilder, $compile, $injector, $scope, dtable_language,dialogConfirmDeleteService) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var $translate = $injector.get('$translate'),
            $state = $injector.get('$state'),
            msApi = $injector.get('msApi'),
            $rootScope = $injector.get('$rootScope'),
            $filter = $injector.get('$filter'),
            $mdDialog = $injector.get('$mdDialog');

        $rootScope.rerender = rerender;


        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        vm.groups = [];
        vm.selectedGroups = [];
        var selectedGroups = [];
        vm.abonnementDataTable = {};
        var flashMessages = {title: ""};
        var checkedSelected = false;
        vm.dtInstance = {};
        vm.isGV=isGV;
        $rootScope.DTOptionsBuilder = DTOptionsBuilder;
        vm.dtOptions = DTOptionsBuilder.newOptions()
            .withFnServerData(serverData)
            // or here
            .withDataProp('data')
            .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
            .withOption('processing', true)
            .withOption('serverSide', true)
            .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
            .withOption('columnDefs', [[
                {
                    // Target the id column
                    targets: [0, 1],
                    width: '72px'
                },

                {
                    targets: [2, 5],
                    filterable: true,
                    sortable: true
                },
                {
                    // Target the actions column
                    targets: 6,
                    responsivePriority: 1,
                    filterable: false,
                    sortable: false
                }
            ]
            ])
            .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
            .withOption('pagingType', 'full_numbers')
            .withOption('pageLength', parseInt(numberRecords))
            .withOption('scrollY', 'auto')
            .withOption('responsive', true)
            .withOption('createdRow', function (row) {
                $compile(angular.element(row).contents())($scope);
            })
            .withPaginationType('full_numbers');
        $rootScope.DtOptions = vm.dtOptions;
        if(isGV){
          vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
              .renderWith(function (data) {
                vm.abonnementDataTable[data.id] = data;
                return '<md-checkbox ng-checked="vm.abonnementDataTable[' + data.id + '].checked"' +
                  'ng-click="vm.toggle(vm.abonnementDataTable[' + data.id + '])"' +
                  'aria-label="-">' +
                  '</md-checkbox> ';
              }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
              return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn(null).notSortable()
              .renderWith(function (data) {
                vm.abonnementDataTable[data.id] = data;

                var buttonActionDetailHtml =
                  '<a has-permission="subscription_group_get_detail_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.detail_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button class="show-button md-icon-button"  ng-click="vm.showGroupDetail(vm.abonnementDataTable[' + data.id + '],$event)" aria-label="detail_group"translate translate-attr-aria-label="ABONNEMENTGROUPLIST.detail_group">' +
                  '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                  '</md-button></a>';
                var buttonActionEditHtml =
                  '<a has-permission="subscription_group_post_edit_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.update_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button style="display: inline-flex;" class="md-icon-button"  ui-sref="app.abonnement_group_edit({ id: ' + data.id + '})"aria-label="update_group" translate translate-attr-aria-label="ABONNEMENTGROUPLIST.update_group">' +
                  '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                  '</md-button></a>';
                var buttonActionDeleteHtml =
                  '<a has-permission="subscription_group_delete_group_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.delete_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button class="m16 delete-button md-icon-button"  aria-label="delete_group" ng-click="vm.deleteGroupConfirm(vm.abonnementDataTable[' + data.id + '],ev)" aria-label="delete_group" translate translate-attr-aria-label="ABONNEMENTGROUPLIST.delete_group">' +
                  '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                  ' </md-button></a>';

                return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

              })

          ];
        }else{
          vm.dtColumns = [
            DTColumnBuilder.newColumn(null).notSortable()
              .renderWith(function (data) {
                vm.abonnementDataTable[data.id] = data;
                return '<md-checkbox ng-checked="vm.abonnementDataTable[' + data.id + '].checked"' +
                  'ng-click="vm.toggle(vm.abonnementDataTable[' + data.id + '])"' +
                  'aria-label="-">' +
                  '</md-checkbox> ';
              }),
            DTColumnBuilder.newColumn('name').renderWith(function (data) {
              return angular.isDefined(data) ? data : "";
            }),
            DTColumnBuilder.newColumn('parent.name').renderWith(function (data) {
              return angular.isDefined(data) ? data : " ";
            }),
            DTColumnBuilder.newColumn('startDate').renderWith(function (data) {
              return (angular.isDefined(data) && data !== null && angular.isDefined(data.date)) ? moment(data.date).format($rootScope.defaultDateFormat) : $translate.instant('MESSAGES.nonef');
            }),
            DTColumnBuilder.newColumn('endDate').renderWith(function (data) {
              return (angular.isDefined(data) && data !== null && angular.isDefined(data.date)) ? moment(data.date).format($rootScope.defaultDateFormat) : $translate.instant('MESSAGES.nonef');
            }),
            DTColumnBuilder.newColumn('updated_at').renderWith(function (data) {
              return (angular.isDefined(data) && data !== null && angular.isDefined(data.date)) ? moment(data.date).format($rootScope.defaultDateFormat) : $translate.instant('MESSAGES.nonef');
            }),
            DTColumnBuilder.newColumn(null).notSortable()
              .renderWith(function (data) {
                vm.abonnementDataTable[data.id] = data;

                var buttonActionDetailHtml =
                  '<a has-permission="subscription_group_get_detail_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.detail_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button class="show-button md-icon-button"  ng-click="vm.showGroupDetail(vm.abonnementDataTable[' + data.id + '],$event)" aria-label="detail_group"translate translate-attr-aria-label="ABONNEMENTGROUPLIST.detail_group">' +
                  '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                  '</md-button></a>';
                var buttonActionEditHtml =
                  '<a has-permission="subscription_group_post_edit_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.update_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button style="display: inline-flex;" class="md-icon-button"  ui-sref="app.abonnement_group_edit({ id: ' + data.id + '})"aria-label="update_group" translate translate-attr-aria-label="ABONNEMENTGROUPLIST.update_group">' +
                  '<md-icon  md-font-icon="icon-pencil" class="s18"></md-icon>' +
                  '</md-button></a>';
                var buttonActionDeleteHtml =
                  '<a has-permission="subscription_group_delete_group_action" tooltips tooltip-template=' + "{{'ABONNEMENTGROUPLIST.delete_group'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                  '<md-button class="m16 delete-button md-icon-button"  aria-label="delete_group" ng-click="vm.deleteGroupConfirm(vm.abonnementDataTable[' + data.id + '],ev)" aria-label="delete_group" translate translate-attr-aria-label="ABONNEMENTGROUPLIST.delete_group">' +
                  '<md-icon  md-font-icon="icon-delete" class="s18"></md-icon>' +
                  ' </md-button></a>';

                return buttonActionDetailHtml + buttonActionEditHtml + buttonActionDeleteHtml;

              })

          ];
        }

        vm.searchAbonnement = searchAbonnement;
        vm.deleteGroupConfirm = deleteGroupConfirm;
        vm.deleteSelectedGroupsConfirm = deleteSelectedGroupsConfirm;
        vm.toggleAll = toggleAll;
        vm.toggle = toggle;
        vm.showGroupDetail = showGroupDetail;
        // vm.editGroup = editGroup;
        vm.addNewGroup = addNewGroup;
        vm.getElement = getElement;

        var filtre = {};
        showFlasMessageToast('abonnementGroupAdd', $translate.instant('ABONNEMENTGROUPLIST.added'), {
            bottom: true,
            top: false,
            left: false,
            right: true
        });
        showFlasMessageToast('abonnementGroupEdit', $translate.instant('ABONNEMENTGROUPLIST.edited'));

        function searchAbonnementInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request('abonnement_Group.dtable@get', filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': response.data
                        };
                        vm.groups = response.data;
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };
                        vm.groups = [];
                        vm.fnCallback(records);
                    }
                }, function (response) {
                    if (response.status != 401) {
                        if (angular.isDefined(response.message)) {
                            $translate('VALIDATIONS.' + response.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }
            );
        }

        function getElement() {
            var element = document.querySelectorAll('md-checkbox.md-default-theme');

            var left = element[0].offsetLeft;

            var leftDelete = left - 35;

            $scope.myObjStyle = {"margin-left": leftDelete}
        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var order = aoData[2].value;
            var start = aoData[3].value;
            var length = aoData[4].value;
            var sort = angular.copy(order[0]);
            var numColum = sort.column - 1 < 0 ? 0 : sort.column - 1;
            vm.selectedGroups = [];

            checkedSelected = false;
            filtre = {
                draw: draw,
                start: start,
                length: length,
                "search[value]": vm.search_abonnement,
                "order[0][column]": numColum,
                "order[0][dir]": sort.dir
            };
            filtre["columns[" + numColum + "][orderable]"] = true;
            vm.fnCallback = fnCallback;

            searchAbonnementInAPI(filtre);
        }

        /**
         * If there's was a CRUD Operation that happened before getting to the list page then show a toast to describe it
         * @param  op : crud operation
         * @param  message message to show
         * @param  toastPosition position of the toast
         */
        function showFlasMessageToast(op, message, toastPosition) {
            if (checkFlashMessage(op)) webTvGlobal.$toast().showSimple(message, angular.isDefined(toastPosition) ? toastPosition : false);

        }

        /**
         * Check If there's and CRUD Operation that happened before getting to the list page
         * @param   op : operation name
         * @return  bool
         */


        function checkFlashMessage(op) {
            var data = webTvGlobal.$flashMessages().get(op);
            if (!flashMessages.title) flashMessages.title = data ? data.title : "";
            return data ? true : false;
        }

        /**
         * Clear Flash Message when an action is triggered
         */
        function clearFlashMessage() {
            if (flashMessages.title) {
                flashMessages.title = "";
                webTvGlobal.$flashMessages().clear();
            }
            webTvGlobal.$toast().hide();
        }

        /**
         * Toggle selected status of the user
         *
         * @param group
         */
        function toggle(group) {
            group.checked = !group.checked;
            var idx = selectedGroups.indexOf(group);
            if (idx > -1) {
                selectedGroups.splice(idx, 1);
            }
            else {
                selectedGroups.push(group);
            }
            vm.selectedGroups = angular.copy(selectedGroups);
        }

        function toggleAll() {
            getElement();
            if (selectedGroups.length === vm.groups.length) {
                vm.selectedGroups = [];
            }
            else if ((selectedGroups.length === 0) || (selectedGroups.length > 0)) {
                vm.selectedGroups = vm.groups.slice(0);
            }
            selectedGroups = angular.copy(vm.selectedGroups);
            var list_group = angular.copy(vm.abonnementDataTable);
            angular.forEach(list_group, function (value, key) {
                if (value !== undefined)
                    vm.abonnementDataTable[key].checked = selectedGroups.length > 0;
            });
        }

        /**
         * Show group Details
         * @param group
         */
        function showGroupDetail(group, event) {
            clearFlashMessage();
            if (event) {
                event.preventDefault();
            }
            $rootScope.loadingProgress = true;

            msApi.request('abonnement_group.modalGetGroup@get', {id: group.id},
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined($rootScope.itemName)) $rootScope.itemName = "";
                    if (angular.isDefined(response.code) && response.code === 200) {

                        $mdDialog.show({
                            locals: {abonnementGroupData: response},
                            templateUrl: 'app/main/abonnement/group/detail/detail.modal.html',
                            clickOutsideToClose: true,
                            controller: 'abonnementGroupDetailController',
                            controllerAs: 'vm'
                        })

                    }
                    else {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message)
                                .then(function (message) {
                                    webTvGlobal.alertDialog(message);
                                }, function () {
                                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                                });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                }, function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message)
                            .then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            );
        }


        /**
         * rerender datatable
         */
        function rerender() {
            if (angular.isFunction(vm.dtInstance.reloadData)) vm.dtInstance.reloadData(searchAbonnementInAPI(filtre), true);
        }

        // function editGroup(group) {
        //     vm.clearFlashMessage();
        //     $state.go('app.abonnement_group_edit', {id: group.id});
        // }

        /**
         * redirection to add new group page
         * @param event
         */
        function addNewGroup() {
            clearFlashMessage();
            $state.go('app.abonnement_group_add');
        }

        /**
         * Delete group Confirm Dialog
         */
        function deleteGroupConfirm(group, ev) {
            $translate([
                "MESSAGES.dialog_confirm_delete",
                "MESSAGES.dialog_cancel",
                "MESSAGES.dialog_will_be_deleted",
                "ABONNEMENTGROUPLIST.delete_group_msg",
                "ABONNEMENTGROUPLIST.delete_group_aria_label"
            ])
                .then(function (translatedValues) {
                        var confirm = $mdDialog.confirm()
                            .title(translatedValues['ABONNEMENTGROUPLIST.delete_group_msg'])
                            .htmlContent('<b>' + group.name + '</b>' + translatedValues['MESSAGES.dialog_will_be_deleted'])
                            .ariaLabel(translatedValues['ABONNEMENTGROUPLIST.delete_group_aria_label'])
                            .targetEvent(ev)
                            .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                            .cancel(translatedValues['MESSAGES.dialog_cancel']);

                        $mdDialog.show(confirm).then(function () {
                            deleteGroup(group);
                            vm.selectedGroups = [];
                        }, function () {

                        });
                });


        }

        /**
         * Delete Group Confirm Dialog
         */
        function deleteSelectedGroupsConfirm(ev) {
          var title;
          var ariaLabel;
            if (vm.selectedGroups.length !== 0) {
              if (vm.selectedGroups.length === 1) {
                title = 'ABONNEMENTGROUPLIST.delete_element_groups_msg';
                ariaLabel = 'ABONNEMENTGROUPLIST.delete_group_aria_label';
              } else {
                title = 'ABONNEMENTGROUPLIST.delete_list_groups_msg';
                ariaLabel = 'ABONNEMENTGROUPLIST.delete_groups_aria_label';
              }


              $mdDialog.show(dialogConfirmDeleteService.getConfirm(ev, vm.selectedGroups.length, title, ariaLabel)).then(function () {

                            deleteSelectedGroups(ev);



                    });

            }

        }

        /* delete selected groups*/
        function deleteSelectedGroups(ev) {
            clearFlashMessage();

            $rootScope.loadingProgress = true;

            msApi.request('abonnement_group.deleteGroups@delete', {
                    list: (function (list) {
                        selectedGroups.forEach(function (item) {
                            list.push(item.id);
                        });
                        return list;
                    })([])
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (response.code === 200) {
                        var undeleted = "";
                        var deleted = $translate.instant("ABONNEMENTGROUPLIST.deleted_are", {'list': response.result.deleted.join(",")});
                        if (response.result.undeleted.length !== 0) {
                            undeleted = $translate.instant("ABONNEMENTGROUPLIST.undeleted_are", {'list': response.result.undeleted.join(",")})
                        }
                        webTvGlobal.alertDialog(
                            deleted + (undeleted ? ('<br><strong>' + undeleted + '</strong>') : ''),
                            $translate.instant('ABONNEMENTGROUPLIST.dialog_alert_delete_title'),
                            '',
                            ev
                        );
                        selectedGroups = [];
                        rerender();

                    }
                    else {
                        webTvGlobal.alertDialog(
                            $translate.instant('ABONNEMENTGROUPLIST.dialog_alert_delete_error_title'),
                            $translate.instant('ABONNEMENTGROUPLIST.dialog_alert_delete_error_description'),
                            '',
                            ev
                        );
                        selectedGroups = [];
                    }
                },
                function (response) {
                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    selectedGroups = [];
                    vm.modelCheckAll = false;

                }
            );


        }

        /**
         * Delete group
         */
        function deleteGroup(Group) {
            clearFlashMessage();
            if (vm.groups.indexOf(Group) !== -1) {
                $rootScope.loadingProgress = true;
                msApi.request('abonnement_group.mdelete@delete', {id: Group.id},
                    function (response) {
                        $rootScope.loadingProgress = false;
                        if (response.code === 200) {
                            $translate([
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_title",
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_description",
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {

                                    webTvGlobal.$toast().showSimple(Group.name + translatedValues['ABONNEMENTGROUPLIST.dialog_alert_delete_description']);
                                    vm.groups.splice(vm.groups.indexOf(Group), 1);
                                    vm.groups = $filter('deleteByPropNotIds')(vm.groups, "parent", [Group.id]);
                                    rerender();
                                });
                        }
                        else {
                            $translate([
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_error_title",
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_error_description",
                                "ABONNEMENTGROUPLIST.dialog_alert_delete_close"
                            ])
                                .then(function (translatedValues) {
                                    var alert = $mdDialog.alert({
                                        title: translatedValues['ABONNEMENTGROUPLIST.dialog_alert_delete_error_title'],
                                        textContent: translatedValues['ABONNEMENTGROUPLIST.dialog_alert_delete_error_description'],
                                        ok: translatedValues['ABONNEMENTGROUPLIST.dialog_alert_delete_close']
                                    });
                                    $mdDialog
                                        .show(alert)
                                        .finally(function () {
                                            alert = undefined;
                                        });
                                });

                        }
                    }, function (response) {
                        $rootScope.loadingProgress = false;
                        if (angular.isDefined(response.data.message)) {
                            $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                                webTvGlobal.alertDialog(message);
                            }, function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            });
                        }
                        else {

                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                        }
                    }
                );

            }
        }

        /**
         *  call the api
         */
        function searchAbonnement() {
            filtre["search[value]"] = vm.search_abonnement;
            searchAbonnementInAPI(filtre);
        }


        initHelp();

        function initHelp() {
            $rootScope.titre1 = isGV ? "PAGESMENUSTITLES.classifying_menuTitle" :  "PAGESMENUSTITLES.abonnement_menuTitle";
            $rootScope.titre2 = isGV ? "PAGESMENUSTITLES.classifying_thematic_menuTitle" : "PAGESMENUSTITLES.abonnement_group_menuTitle";
            $rootScope.titre3 = isGV ? "PAGESMENUSTITLES.classifying_thematic_list_pageTitle" : "PAGESMENUSTITLES.abonnement_group_list_pagetitle";
            $rootScope.pageRoute = "";
            $rootScope.welcome = "welcome_group";
            $rootScope.text = [{
                texte: "add_button_group_help"
            }, {
                texte: "arrow_button_group_help"
            }, {
                texte: "search_area_group_help"
            }, {
                texte: "tri_column_group_help"
            },
                {
                    texte: "edit_button_group_help"
                }, {
                    texte: "detail_button_group_help"
                },
                {
                    texte: "delete_button_group_help"
                }];
        }

    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.rmboxgroup.add',['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_rmboxgroup_add', {
                url    :"/boitier/rmboxgroup/add",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmboxgroup/add_edit_view/add_edit.template.html',
                        controller : 'configurationRmboxgroupAddController as vm'
                    }
                },
                resolve: {
                    configurationRmboxgroupData: function (msApi)
                    {
                        return msApi.resolve('configuration_rmboxgroup.getRmboxgroup@get',{id:0});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_rmboxgroup_post_add_action"
            });
            

       
        //API
        msApiProvider.register('configuration_rmboxgroup.addRmboxgroup', [Routing.generate('api_configuration_post_add_rmboxgroup')])
        
    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.rmboxgroup.add')
    .controller('configurationRmboxgroupAddController', configurationRmboxgroupAddController);

  /** @ngInject */
  function configurationRmboxgroupAddController($rootScope, $translate, msApi, $state, configurationRmboxgroupData, webTvGlobal) {

    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmboxgroup_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmboxgroup_add_menuTitle";
      $rootScope.pageRoute = "app.configuration_rmboxgroup_list";

      $rootScope.welcome = "welcome_rmbox_group_add";
      $rootScope.text = [{
        texte: "parameters_rmbox_group_add_help"
      }, {
        texte: "send_button_rmbox_group_add_help"
      }, {
        texte: "cancel_button_rmbox_group_add_help"
      }];

    }

    var vm = this;
    vm.isNew = true;
    vm.empConfigurationRmboxgroupError = [];
    var rmboxgroup = configurationRmboxgroupData;
    vm.empConfigurationRmboxgroupForm = {
      name: rmboxgroup.name,
      bandwidthLimit: rmboxgroup.bandwidthLimit,
      syncTime: new Date(rmboxgroup.syncTime)

    };
    vm.submitAddRmboxgroupForm = submitAddRmboxgroupForm;

    /**
     * Convert List To Select Option format
     */

    /*function convertRmboxgroupIdToSelectList(choices) {
        var converted = Object.keys(choices).map(function (key) {
            return {val: choices[key], options: key};
        });
        converted.sort(function (a, b) {
            return a.val - b.val;
        });
        return converted;
    }*/

    /**
     * Send add RmBox group Form
     */
    function submitAddRmboxgroupForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_rmboxgroup.addRmboxgroup@save',
        {"empConfigurationRmboxgroupForm": angular.copy(vm.empConfigurationRmboxgroupForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            rmboxgroup = vm.empConfigurationRmboxgroupForm;
            webTvGlobal.$flashMessages().set('configurationRmboxgroupAdd', {title: vm.empConfigurationRmboxgroupForm.title ? vm.empConfigurationRmboxgroupForm.title : ""});
            $state.go('app.configuration_rmboxgroup_list');
          } else if (angular.isDefined(res.errors)) {
            vm.empConfigurationRmboxgroupError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empConfigurationRmboxgroupError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersThemeForm[item.for])
              };
            });
          }
          else if (res.code === 400) {
            if (angular.isDefined(res.message)) {
              $translate('VALIDATIONS.' + res.message)
                .then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        },
        function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }


  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.boitier.rmboxgroup.edit',['mdPickers'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider
            .state('app.configuration_rmboxgroup_edit', {
                url    :"/boitier/rmboxgroup/:id/edit",
                views  : {
                    'content@app': {
                        templateUrl: 'app/main/boitier/rmboxgroup/add_edit_view/add_edit.template.html',
                        controller : 'configurationRmboxgroupEditController as vm'
                    }
                },
                resolve: {
                    configurationRmboxgroupData: function (msApi,$stateParams)
                    {
                        return msApi.resolve('configuration_rmboxgroup.getRmboxgroup@get',{id:$stateParams.id});
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "configuration_rmboxgroup_post_edit_action"
            });


        // API
        msApiProvider.register('configuration_rmboxgroup.editRmboxgroup', [Routing.generate('api_configuration_post_edit_rmboxgroup',{id: ':id'}).replace(/%3A/,":"), {id: '@id'}])

    }
})();
(function () {
  'use strict';

  angular
    .module('app.boitier.rmboxgroup.edit')
    .controller('configurationRmboxgroupEditController', configurationRmboxgroupEditController);

  /** @ngInject */
  function configurationRmboxgroupEditController(webTvGlobal, $translate, msApi, $rootScope, $state, configurationRmboxgroupData) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.boitier_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.configuration_rmboxgroup_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.configuration_rmboxgroup_edit_pagetitle";
      $rootScope.pageRoute = "app.configuration_rmboxgroup_list";

      $rootScope.welcome = "welcome_rmbox_group_edit";
      $rootScope.text = [{
        texte: "parameters_rmbox_group_add_help"
      }, {
        texte: "send_button_rmbox_group_edit_help"
      }, {
        texte: "cancel_button_rmbox_group_add_help"
      }];
    }

    var vm = this;
    vm.isNew = false;
    $rootScope.itemName = "";
    vm.empConfigurationRmboxgroupError = [];
    var rmboxgroup = configurationRmboxgroupData;
    vm.empConfigurationRmboxgroupForm = {};
    vm.submitAddRmboxgroupForm = submitAddRmboxgroupForm;
    fillData();


    /**
     * Check if rmboxgroup exists
     * @return if exists get RmBox group Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(rmboxgroup.code) && rmboxgroup.code !== 200) $state.go('app.error_404');
      else {

        vm.empConfigurationRmboxgroupForm = {
          name: rmboxgroup.name,
          bandwidthLimit: rmboxgroup.bandwidthLimit,
          syncTime: new Date(moment(rmboxgroup.syncTime))
        };
        $rootScope.itemName = rmboxgroup.name || '';
      }
    }


    /**
     * return to rmboxgroup list page
     * @return redirect to rmboxgroup list page
     */
    /*function goToList() {
        $state.go('app.configuration_rmboxgroup_list');
    }*/

    /**
     * Convert List To Select Option format
     */

    /*function convertRmboxgroupIdToSelectList(choices) {
        var converted = Object.keys(choices).map(function (key) {
            return {val: choices[key], options: key};
        });
        converted.sort(function (a, b) {
            return a.val - b.val;
        });
        return converted;
    }*/

    /**
     * Send add RmBox group Form
     */
    function submitAddRmboxgroupForm() {
      $rootScope.loadingProgress = true;
      msApi.request('configuration_rmboxgroup.editRmboxgroup@save',
        {
          id: rmboxgroup.id,
          "empConfigurationRmboxgroupForm": angular.copy(vm.empConfigurationRmboxgroupForm)
        },
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            rmboxgroup = vm.empConfigurationRmboxgroupForm;
            webTvGlobal.$flashMessages().set('configurationRmboxgroupEdit', rmboxgroup);
            $state.go('app.configuration_rmboxgroup_list');
          } else if (angular.isDefined(res.errors)) {
            vm.empConfigurationRmboxgroupError = [];
            var errors = res.errors;
            errors.forEach(function (item) {

              vm.empConfigurationRmboxgroupError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empParametersThemeForm[item.for])
              };
            });
          }
          else if (res.code === 400) {
            if (angular.isDefined(res.message)) {
              $translate('VALIDATIONS.' + res.message)
                .then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }

        }
      );


    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.group.list')
        .controller('abonnementGroupDetailController', abonnementGroupDetailController);

    /** @ngInject */
    function abonnementGroupDetailController(abonnementGroupData, $mdDialog) {
        var vm = this;
        vm.group = abonnementGroupData;
        vm.cancel = cancel;
        vm.isGV = isGV;

        function cancel(){
          $mdDialog.hide();
        }

        /**
         * Check if group exists
         * @return if exists get Group Data else redirect to 404 page
         */
    }


})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.group.edit', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.abonnement_group_edit', {
                url: "/abonnement/group/:id/edit",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/group/add_edit_view/form.template.html',
                        controller: 'abonnementGroupEditController as vm'
                    }
                },
                resolve: {
                    abonnementGroupData: function (msApi, $stateParams) {
                        return msApi.resolve('abonnement_group.getGroup@get', {id: $stateParams.id});
                    },
                    abonnementGroupsData: function (msApi) {
                        return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "subscription_group_post_edit_action"
            });

        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('abonnement_group.getGroup', [Routing.generate('api_subscription_group_get_detail_group', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('abonnement_group.editGroup', [Routing.generate('api_subscription_group_post_edit_group', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
    }
})();
(function () {
  'use strict';

  angular
    .module('app.abonnement.group.edit')
    .controller('abonnementGroupEditController', abonnementGroupEditController);

  /** @ngInject */
  function abonnementGroupEditController(webTvGlobal, $cookies,$timeout, $scope, abonnementGroupData, abonnementGroupsData, $injector) {

    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi'),
      $rootScope = $injector.get('$rootScope'),
      $filter = $injector.get('$filter');


    var group = abonnementGroupData;

    var dateStart = new Date(group.startDate);
    var dateEnd = new Date(group.endDate);

    $rootScope.itemName = "";
    var vm = this;

    vm.isNew = false;
    vm.empAbonnementGroupError = [];
    vm.empAbonnementGroupForm = {};
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.ngFlowOptions = {
      target: Routing.generate('api_subscription_group_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      flow: {}
    };
      vm.isGV=isGV;
    vm.downloadfile = downloadfile;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;

    function uploadFile() {
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function fileAdded(file) {

      if (!/(csv)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
else   vm.inProgress = true;
      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.subscriptions;
        vm.file = message.subscriptions.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTGROUPLIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);

      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('abonnement_group.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTGROUPLIST.add_group'));
            $state.go('app.abonnement_group_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'csv',
        'type': 'subscriptionGroup'
      })
    }

    vm.submitAddGroupForm = submitAddGroupForm;
    // vm.goToList = goToList;

    fillData();
    initHelp();

    function initHelp() {
      $rootScope.titre1 =isGV ? "PAGESMENUSTITLES.classifying_menuTitle" : "PAGESMENUSTITLES.abonnement_menuTitle";
      $rootScope.titre2 = isGV ?  "PAGESMENUSTITLES.classifying_thematic_menuTitle" :"PAGESMENUSTITLES.abonnement_group_menuTitle";
      $rootScope.titre3 = isGV ?  "PAGESMENUSTITLES.classifying_thematic_edit_menuTitle" :"PAGESMENUSTITLES.abonnement_group_edit_pagetitle";

      $rootScope.pageRoute = "app.abonnement_group_list";
      $rootScope.welcome = "welcome_group_edit";
      $rootScope.text = [{
        texte: "parameters_group_add_help"
      }, {
        texte: "send_button_group_edit_help"
      }, {
        texte: "cancel_button_group_add_help"
      },{
          texte: "parameters_group_import_help"
      }];

    }

    /**
     * Convert List To Select Option format
     */
    function convertParentToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    /**
     * Check if Group exists
     * @return if exists get Group Data else redirect to 404 page
     */
    function fillData() {
      if (angular.isDefined(group.code) && group.code !== 200) $state.go('app.error_404');
      else {
        vm.empAbonnementGroupForm = {
          name: group.name,
          startDate: new Date(moment(dateStart).format('YYYY-MM-DD')),
          endDate: new Date(moment(dateEnd).format('YYYY-MM-DD')),
          parent: angular.isUndefined(group.parent) || group.parent === null ? group.parent : group.parent.id
        };
        if (group.startDate === null)
          vm.empAbonnementGroupForm.startDate = null;
        if (group.endDate === null)
          vm.empAbonnementGroupForm.endDate = null;
        var parents = $filter('filterByNotIds')(abonnementGroupsData.data.groups, [group.id]);
        vm.parents = convertParentToSelectList(parents);
        $rootScope.itemName = group.name || '';
      }
    }

    // /**
    //  * return to Group list page
    //  * @return redirect to Group list page
    //  */
    // function goToList() {
    //     $state.go('app.abonnement_group_list');
    // }
    //

    /**
     * Send add Group Form
     */
    function submitAddGroupForm() {
      $rootScope.loadingProgress = true;
      msApi.request('abonnement_group.editGroup@save',
        {id: group.id, "empAbonnementGroupForm": angular.copy(vm.empAbonnementGroupForm)},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            group = vm.empAbonnementGroupForm;
            webTvGlobal.$flashMessages().set('abonnementGroupEdit', {title: vm.empAbonnementGroupForm.name ? vm.empAbonnementGroupForm.name : ""});
            $state.go('app.abonnement_group_list');
          } else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            var empAbonnementGroupError = [];
            errors.forEach(function (item) {
              empAbonnementGroupError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAbonnementGroupForm[item.for])
              };
            });
            vm.empAbonnementGroupError = empAbonnementGroupError;
          } else if (res.code === 400) {
            if (angular.isDefined(res.message)) {
              $translate('VALIDATIONS.' + res.message)
                .then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    // WORKAROUND to force validation after mdMinDate change
    $scope.$watch('vm.empAbonnementGroupForm.startDate', function () {
      var end = vm.empAbonnementGroupForm.endDate;
      vm.empAbonnementGroupForm.endDate = null;

      $timeout(function () {
        vm.empAbonnementGroupForm.endDate = end;
      });
    });
  }
})();

(function () {
    'use strict';

    angular
        .module('app.abonnement.group.add', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.abonnement_group_add', {
                url: '/abonnement/group/add',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/abonnement/group/add_edit_view/form.template.html',
                        controller: 'abonnementGroupAddController as vm'
                    }
                },
                resolve: {
                    abonnementGroupData: function (msApi) {
                        return msApi.resolve('abonnement_group.getNewGroupData@get', {id: 0});
                    },
                    abonnementGroupsData: function (msApi) {
                        return msApi.resolve('abonnement_group.getGroups@get');
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "subscription_group_post_add_action"
            });

        //API
        msApiProvider.register('abonnement_group.postImportFile', [Routing.generate('api_subscription_group_post_add_group_import')]);
        msApiProvider.register('abonnement_group.getGroups', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('abonnement_group.getNewGroupData', [Routing.generate('api_subscription_group_get_detail_group', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('abonnement_group.addGroup', [Routing.generate('api_subscription_group_post_add_group')]);


    }
})();
(function () {
  'use strict';

  angular
    .module('app.abonnement.group.add')
    .controller('abonnementGroupAddController', abonnementGroupAddController);

  /** @ngInject */
  function abonnementGroupAddController($injector, $cookies, $rootScope, $scope, abonnementGroupData, webTvGlobal, abonnementGroupsData, $timeout) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      msApi = $injector.get('msApi');

    var vm = this;
    vm.isNew = true;
    vm.empAbonnementGroupError = [];
      vm.isGV=isGV;
    var group = abonnementGroupData;
    // group.startDate = new Date(moment().format('YYYY-MM-DD'));
    // group.endDate = new Date(moment().format('YYYY-MM-DD'));
    vm.empAbonnementGroupForm = {
      name: group.name,
      startDate: null,
      endDate: null,
      parent: group.parent
    };
    vm.parents = convertParentToSelectList(abonnementGroupsData.data.groups);
    var progressBarValue = 0;
    vm.inProgress = false;
    var populatingfile = 0;
    vm.submitAddGroupForm = submitAddGroupForm;
    // vm.goToList = goToList;
    vm.uploadFile = uploadFile;
    vm.fileAdded = fileAdded;
    vm.fileSuccess = fileSuccess;
    vm.fileError = fileError;
    vm.fileProgress = fileProgress;
    vm.uploadAddFile = uploadAddFile;
    vm.ngFlowOptions = {
      target: Routing.generate('api_subscription_group_post_import'),
      singleFile: false,
      testChunks: false,
      fileParameterName: 'empApiFileForm[file]',
      headers: {"Authorization": 'Bearer ' + $cookies.get('authToken')}

    };
    vm.ngFlow = {
      flow: {}
    };
      vm.dropping = false;
      vm.downloadfile = downloadfile;

    function downloadfile() {
      return Routing.generate('emp_output_download_sample', {
        'name': 'csv',
        'type': 'subscriptionGroup'
      })
    }


    function uploadFile() {
      // vm.ngFlow.flow.opts.headers = {};
      vm.ngFlow.flow.upload();

    }

    function fileAdded(file) {

      if (!/(csv)$/i.test(file.getExtension().toLowerCase())) {
        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_not_valid_csvfile_message'));
        return false;
      }
      else  vm.inProgress = true;

      $rootScope.loadingProgress = true;
    }

    function fileSuccess(file, message) {
      message = angular.fromJson(message);
      if (message.code === 200) {
        vm.response = message.subscriptions;
        vm.file = message.subscriptions.file;
        $rootScope.loadingProgress = false;
        populatingfile = 1;
        webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTGROUPLIST.dialog_alert_upload_description'));

      }

    }

    function fileError(file, message) {
      message = angular.fromJson(message);

      if (angular.isDefined(message.code) && angular.isDefined(message.message)) webTvGlobal.alertDialog(message.message);
      else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

      $rootScope.loadingProgress = false;
    }

    function fileProgress(file) {
      progressBarValue = file.progress() * 100;
    }

    /**
     * Convert List To Select Option format
     */
    function convertParentToSelectList(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], options: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

    // function goToList() {
    //     $state.go('app.abonnement_group_list');
    // }

    function uploadAddFile() {
      // SEND THE FILES.
      msApi.request('abonnement_group.postImportFile@save', {file: angular.copy(vm.file)},
        function (res) {
          if (res.code === 200) {
            webTvGlobal.$toast().showSimple($translate.instant('ABONNEMENTGROUPLIST.add_group'));
            $state.go('app.abonnement_group_list');
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }
        , function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
      // Add code to submit the formData
    }

    /**
     *
     * @param  {[type]} formData [description]
     * @return {[type]}          [description]
     */
    function preapreFormDataToSend(formData) {
      var formFormattedData = formData;
      if (formFormattedData.startDate !== null) formFormattedData.startDate = new Date(moment.utc(formFormattedData.startDate.toString()));
      if (formFormattedData.endDate !== null) formFormattedData.endDate = new Date(moment.utc(formFormattedData.endDate.toString()));
      return formFormattedData;
    }

    /**
     * Send add Group Form
     */
    function submitAddGroupForm() {
      $rootScope.loadingProgress = true;
      var formData = preapreFormDataToSend(angular.copy(vm.empAbonnementGroupForm));
      msApi.request('abonnement_group.addGroup@save',
        {"empAbonnementGroupForm": formData},
        function (res) {
          $rootScope.loadingProgress = false;
          if (res.code === 200) {
            group = vm.empAbonnementGroupForm;
            webTvGlobal.$flashMessages().set('abonnementGroupAdd', {title: vm.empAbonnementGroupForm.name ? vm.empAbonnementGroupForm.name : ""});
            $state.go('app.abonnement_group_list');
          }
          else if (angular.isDefined(res.errors)) {
            var errors = res.errors;
            var empAbonnementGroupError = [];
            errors.forEach(function (item) {
              empAbonnementGroupError[item.for] = {
                message: item.messages[0],
                value_old: angular.copy(vm.empAbonnementGroupForm[item.for])
              };
            });
            vm.empAbonnementGroupError = empAbonnementGroupError;
          } else if (res.code === 400) {
            if (angular.isDefined(res.message)) {
              $translate('VALIDATIONS.' + res.message)
                .then(function (message) {
                  webTvGlobal.alertDialog(message);
                }, function () {
                  webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                });
            }
            else {

              webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

            }
          }
          else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
          }
        }, function (response) {
          $rootScope.loadingProgress = false;
          if (angular.isDefined(response.message)) {
            $translate('VALIDATIONS.' + response.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          } else if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
            $translate('VALIDATIONS.' + response.data.message)
              .then(function (message) {
                webTvGlobal.alertDialog(message);
              }, function () {
                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
              });
          }
          else {

            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

          }
        }
      );
    }

    initHelp();

    function initHelp() {
      $rootScope.titre1 = isGV ? "PAGESMENUSTITLES.classifying_menuTitle" :  "PAGESMENUSTITLES.abonnement_menuTitle";
      $rootScope.titre2 =isGV ?  "PAGESMENUSTITLES.classifying_thematic_menuTitle" :"PAGESMENUSTITLES.abonnement_group_menuTitle";
      $rootScope.titre3 = isGV ?  "PAGESMENUSTITLES.classifying_thematic_add_menuTitle" :  "PAGESMENUSTITLES.abonnement_group_add_menuTitle";
      $rootScope.pageRoute = "app.abonnement_group_list";
      $rootScope.welcome = "welcome_group_add";
      $rootScope.text = [{
        texte: "parameters_group_add_help"
      }, {
        texte: "send_button_group_add_help"
      }, {
        texte: "cancel_button_group_add_help"
      },{
            texte: "parameters_group_import_help"
          }];

    }

    // WORKAROUND to force validation after mdMinDate change
    $scope.$watch('vm.empAbonnementGroupForm.startDate', function () {
      var end = vm.empAbonnementGroupForm.endDate;
      vm.empAbonnementGroupForm.endDate = null;

      $timeout(function () {
        vm.empAbonnementGroupForm.endDate = end;
      });
    });
  }

})();

(function () {
  'use strict';

  angular
      .module('app.stats.vod_live',
          [
              'mdPickers',
              'app.stats.graphe',
              'app.stats.vod_live.tab'
          ]
      )
      .config(config)
      .run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
      var parentStates = [
          {
              state: 'stats_vods',
              url: '/stat/vods',
              template:  (window.process.env.isNew_Stats && window.process.env.isNew_Stats === true) ? 'app/main/stats/vod_live/stat.videos.html' : 'app/main/stats/vod_live/stat.vod.html' ,
              right: "stats.type.vod",
              filter: "vod"
          },
          {
              state: 'stats_lives',
              url: '/stat/lives',
              template: 'app/main/stats/vod_live/stat.vod.html',
              right: "stats.type.live",
              filter: "live"
          },
          {
              state: 'stats_vod_by_id',
              url: '/stat/vod_by_id/:id',
              template: 'app/main/stats/vod_live/stat.vod_by_id.html',
              getById: "stats.get.video.by.id", right: "stats.type.vod", filter: "vod_by_id"
          },
          {
              state: 'stats_live_by_id',
              url: '/stat/live_by_id/:id',
              template: 'app/main/stats/vod_live/stat.live_by_id.html',
              getById: "stats.get.live.by.id",
              right: "stats.type.live", filter: "live_by_id"
          },
          {
              state: 'stats_zone_by_id',
              url: '/stat/zone_by_id/:id',
              template: 'app/main/stats/vod_live/stat.vod_by_id.html',
              getById: "stats.get.zone.by.id",
              right: "stats.type.live", filter: "live"
          }
      ];
      var eventStates = [
        {
            state: 'stats_event_by_id',
            url: '/stat/event_by_id/:id',
            template: 'app/main/stats/vod_live/event_by_id.template.html',
            right: "stats.type.event", filter: "event"
        },
      ]
      parentStates.forEach(function (value) {
          $stateProvider
              .state("app." + value.state, {
                  url: value.url,
                  views: {
                      'content@app': {
                          templateUrl: value.template,
                          controller: 'VodLiveStatsController as vm'
                      }
                  },
                  resolve: {
                      tabs_vod: function (tab_key_value_vod_by_id_stat) {
                          return tab_key_value_vod_by_id_stat;
                      },
                      typeChoices: function () {
                          return value.right;
                      },
                      searchFiltreRight: function (is_show_filtre_vod_stat) {
                          return is_show_filtre_vod_stat;
                      },
                      typeStatsFilter: function () {
                          return value.filter;
                      },
                      parent_state: function () {
                          return "app." + value.state;
                      },
                      getVideoById: function (msApi, $stateParams, $state) {
                          if (angular.isDefined($stateParams.id)) {
                              return msApi.resolve(value.getById + '@get', {id: $stateParams.id});
                          } else
                              return null;
                      },
                      GroupSubscriptionsList: function (msApi) {
                          return msApi.resolve('abonnement_group.list@get');
                      },
                      typesVideo: function (msApi, getVideoById, $stateParams, $state) {
                          if (angular.isDefined($stateParams.id)) {
                              if (value.state === "stats_event_by_id"){
                                  return msApi.resolve('stats.getVideoTypes@get', {id: getVideoById.id});
                              }
                              else if (value.state === "stats_vod_by_id"){
                                  return msApi.resolve('stats.getVideoTypes@get', {id: $stateParams.id});
                              }
                          } else
                              return null;
                      }
                      // parametersCanalNamesData: function (msApi) {
                      //     return msApi.resolve('parameters_canal.getNames@get');
                      // }
                  }
              })
      });
      eventStates.forEach(function (value) {
        $stateProvider
            .state("app." + value.state, {
                url: value.url,
                views: {
                    'content@app': {
                        templateUrl: value.template,
                        controller: 'EventByIdStatsController as vm'
                    }
                },
                resolve: {
                    tabs_vod: function (tab_key_value_vod_by_id_stat) {
                        return tab_key_value_vod_by_id_stat;
                    },
                    typeChoices: function () {
                        return value.right;
                    },
                    searchFiltreRight: function (is_show_filtre_vod_stat) {
                        return is_show_filtre_vod_stat;
                    },
                    typeStatsFilter: function () {
                        return value.filter;
                    },
                    parent_state: function () {
                        return "app." + value.state;
                    }
                }
            })
    });
      // Api
      msApiProvider.register('abonnement_group.list', [Routing.generate('api_subscription_group_get_groups')]);
      msApiProvider.register('parameters_theme.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
      msApiProvider.register('parameters_theme.themeChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
      msApiProvider.register('stats.right.vod.types', [Routing.generate('api_right_stats_get_right_types_vod_stats')]);
      msApiProvider.register('stats.right.live.types', [Routing.generate('api_right_stats_get_right_types_live_stats')]);
      msApiProvider.register('stats.get.video.by.id', [Routing.generate('api_media_get_video_by_id', {id: ':id'}).replace(/%3A/, ":")]);
      msApiProvider.register('stats.get.event.by.id', [Routing.generate('api_get_event_video_by_id', {id: ':id'}).replace(/%3A/, ":")]);
      msApiProvider.register('stats.get.live.by.id', [Routing.generate('api_get_lives_live_detail', {id: ':id'}).replace(/%3A/, ":")]);
      // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
      msApiProvider.register('stats.right.live.types', [Routing.generate('api_right_stats_get_right_types_live_stats')]);
      msApiProvider.register('userManager.getUserDataStat', [Routing.generate('api_core_rights_get_user_rights_by_module')]);
      msApiProvider.register('stats.getVideoTypes', [Routing.generate('api_media_get_type_video', {id: ':id'}).replace(/%3A/, ":")]);
      msApiProvider.register('stats.getUrlExport', [Routing.generate('api_stats_acces_get_url_stat_export')]);
      msApiProvider.register('stats.get.zone.by.id', [Routing.generate('api_configuration_get_detail_zone', {id: ':id'}).replace(/%3A/, ":")]);
      msApiProvider.register('media_video.getUrlListVideo', [Routing.generate('api_media_get_url_list_video')]);
      //api_stats_acces_get_url_stat_export
  }
  function fetchRights(msRights) {
      if (mod === 'dev') {
          var permissions = {
              name_module: "stats",
              name_angular_module: "app.stats.vod_live",
              actions: [
                  {"all": ["all_NoApi"]},
                  {"audience": ["audience_NoApi"]},
                  {"technologie": ["technologie_"]},
                  {"engagement": ["engagement"]},
                  {"mobile": ["get_detail"]},
                  {"temp_reel": ["get_detail"]}]
          };
          var permissions2 = {
              name_module: "stats_export",
              name_angular_module: "app.stats.vod_live",
              actions: [

                  {"export": ["export_no_api"]}]
          };
          msRights.setPermissions(permissions2);
          msRights.setPermissionsStatsTabsAndApiNull(permissions);
      }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.stats.vod_live')
      .factory('statsVodLiveService', statsVodLiveService);

  /** @ngInject */
  function statsVodLiveService( $state,$rootScope) {

      var query = {};

      function getQuery() {
          return query;
      }

      function setQuery(query_param, endDateFromLive,lunchFilter,typeStatFilter ) {
        if (query_param.dateIn || query_param.startDate) {
          if (typeStatFilter==="live_by_id"||typeStatFilter==="live"){
            query.dateIn = query_param.dateIn?moment(query_param.dateIn).subtract({days:1}).set({
              hour: 23,
              minute: 0,
              second: 0,
              millisecond: 0,
            }).format("YYYY-MM-DDTHH:mm:ss.000[Z]"):'';
            query.startDate = query_param.startDate?moment(query_param.dateIn).set({
              hour: 0,
              minute: 0,
              second: 0,
              millisecond: 0,
            }).format("YYYY-MM-DDTHH:mm:ss.000[Z]"):'';
          }
          else{
            query.dateIn = query_param.dateIn ? query_param.dateIn : "";
            query.startDate = query_param.startDate ? query_param.startDate : "";
          }
        }

        if (query_param.endDate || query_param.dateOut) {
          if (typeStatFilter === "live_by_id" || typeStatFilter === "live") {
            query.endDate = query_param.endDate?oment(query_param.dateOut).set({
              hour: 23,
              minute: 0,
              second: 0,
              millisecond: 0,
            }).format("YYYY-MM-DDTHH:mm:ss.000[Z]"):'';
            query.dateOut = query_param.dateOut?moment(query_param.dateOut).set({
              hour: 23,
              minute: 0,
              second: 0,
              millisecond: 0,
            }).format("YYYY-MM-DDTHH:mm:ss.000[Z]"):'';
          }
          else{
            query.endDate = query_param.endDate ? query_param.endDate : "";
            query.dateOut = query_param.dateOut ? query_param.dateOut : "";
          }
        }

        if (!angular.isUndefined(query_param.canal)) {
              query.canal = query_param.canal;
          }
          if (!angular.isUndefined(query_param.theme)) {
              query.theme = query_param.theme;
          }
          if (!angular.isUndefined(query_param.type)) {
              query.type = query_param.type;
          }
          if (!angular.isUndefined(query_param.range) ) {
              query.range = query_param.range;
          }
          if (!angular.isUndefined(query_param.vod_id) ) {
              query.vod_id = query_param.vod_id;
          }
          if (!angular.isUndefined(query_param.group) ) {
              query.group = query_param.group;
          }
          console.log("lunchFilter",lunchFilter);
          query.lunchFilter=lunchFilter===undefined?true:lunchFilter;
      }

      function verifQuery(query_param, endDateFromLive) {
          if (!angular.isUndefined(query_param.dateIn) && angular.isUndefined(query.dateIn)) {
              query.dateIn = query_param.dateIn;
          }
          if (!angular.isUndefined(query_param.dateOut) && angular.isUndefined(query.dateOut)) {
              var out_date = query_param.dateOut;
            if(angular.isUndefined(endDateFromLive)) {
              out_date.setHours(out_date.getHours() + 23);
            }
              query.dateOut = query_param.dateOut;
          }
          if (!angular.isUndefined(query_param.canal) && angular.isUndefined(query.canal)) {
              query.canal = query_param.canal;
          }
          if (!angular.isUndefined(query_param.theme) && angular.isUndefined(query.theme)) {
              query.theme = query_param.theme;
          }
          if (!angular.isUndefined(query_param.group) && angular.isUndefined(query.group)) {
              query.group = query_param.group;
          }
          if (!angular.isUndefined(query_param.type) && angular.isUndefined(query.type)) {
              query.type = query_param.type;
          }else {
              if ($state.current.name.indexOf("live") > 0) {
              query.type = "live_internet";}
              else
                  query.type = $rootScope.types_all && Object.keys($rootScope.types_all).length> 0 ? Object.values($rootScope.types_all)[0] : '';
          }


          if (!angular.isUndefined(query_param.range) && angular.isUndefined(query.range)) {
              query.range = query_param.range;
          }
          if (!angular.isUndefined(query_param.vod_id)) {
              query.vod_id = query_param.vod_id;
          }
          if(angular.isUndefined(query_param.vod_id))
          {
              delete query.vod_id;
          }
      }

      return {
          setQuery: setQuery,
          getQuery: getQuery,
          verifQuery: verifQuery

      };

  }
}());

(function () {
  'use strict';

  angular
    .module('app.stats.vod_live')
    .controller('VodLiveStatsController', VodLiveStatsController);

  /** @ngInject */
  function VodLiveStatsController($location,$injector,typesVideo, dtable_language, $rootScope,msApi,$scope,getVideoById, tabs_vod, typeChoices, webTvGlobal, dateMoisCourantConstant, parent_state,userManager,typeStatsFilter,searchFiltreRight,GroupSubscriptionsList, $cookies) {
    var $stateParams = $injector.get('$stateParams'),
    $state = $injector.get('$state'),
    statsVodLiveService = $injector.get('statsVodLiveService'),    
    $sce = $injector.get('$sce');
    var language = $cookies.get('WEBTV.locale');
    var vm = this;
     //Get cryptext
         var type = $stateParams.type;
 
              $scope.detailFrame = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/videos?lng=" + language + '&token='  + $cookies.get("authToken"));
              $scope.statByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/videos?id=" + $stateParams.id+ '&lng='+language + '&token=' + $cookies.get("authToken"));
              $scope.detailFrameDirect = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/direct?lng=" + language + '&token='  + $cookies.get("authToken")); 
              $scope.statLiveByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/direct?id=" + $stateParams.id +'&lng='+ language + '&token='  + $cookies.get("authToken"));
      
    var parameterBag = webTvGlobal.$constant().webTvParameterBag();
    //function
    vm.typeStatsFilter = typeStatsFilter;
    vm.endtDateFromLive=false;
    vm.changeQuery = changeQuery;
    vm.changeDate = changeDate;
    vm.isNewStats = false;
    vm.isMobile = false;

    if ($location.path() === "/stat/vods/mobile" ) {
      vm.isMobile = true;
    } 
    if (window.process.env.isNew_Stats) {
    vm.isNewStats =  window.process.env.isNew_Stats; }
    vm.filters =[
      {
        value: "Visualisation" 
      },
      {
        value: "Publication"
      }];
    vm.filter="Visualisation";
    vm.isHiddenFilter = isHiddenFilter;
    vm.groups=convertParentToSelectList(GroupSubscriptionsList.data.groups);
    vm.groups_query='';
    //scope
    var isLive=vm.typeStatsFilter==='live' && $state.current.name.indexOf("live_by_id") > -1;
    setQueryStatsFilter()
    vm.query = statsVodLiveService.getQuery();
    setQueryDateStatsFilter()
    initInfoVideoById();
    vm.hasGroupsPermission= userManager.isActionGranted('stats_filter_groups');
    $rootScope.types_all = parameterBag[typeChoices];
    vm.default_type_stats = 'all';
    vm.listType =angular.isDefined($rootScope.types_all) && $rootScope.types_all ? Object.values($rootScope.types_all): null;
    getAllTypes();

    $rootScope.types_all = parameterBag[typeChoices];
    vm.default_type_stats = 'all';
    vm.listType =angular.isDefined($rootScope.types_all) && $rootScope.types_all ? Object.values($rootScope.types_all): null;
    getAllTypes();

    if( vm.hasGroupsPermission){
      vm.query.group= ""
    }
    $scope.$on('parameterBag', function (event, obj) {
      if(obj) parameterBag = obj;
    });
    if($state.current.name.indexOf("stats_vod_by_id")>0)
      msApi.request('stats.getUrlExport@get',
        {
          id_video: $state.params.id
        },
        function (res) {
          vm.urlExport =  res.url_stat_export;
        });
    if($state.current.name.indexOf("stats_event_by_id")>0)
      msApi.request('stats.getUrlExport@get',
        {
          id_event: $state.params.id
        },
        function (res) {
          vm.urlExport =  res.url_stat_export;
        });
    // console.log($state.params.id);
    // console.log(parameterBag["app.client.name"]);
    $scope.$watch(function () { 
        language = $cookies.get("WEBTV.locale");
      $scope.detailFrame = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/videos?lng=" + language + '&token=' + $cookies.get("authToken"));  
      $scope.statByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/videos?id=" + $stateParams.id +'&lng='+ language + '&token=' + $cookies.get("authToken"));  
      $scope.detailFrameDirect = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/direct?lng=" + language + '&token=' + $cookies.get("authToken")); 
      $scope.statLiveByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/direct?id=" + $stateParams.id +'&lng='+ language + '&token=' + $cookies.get("authToken"));
         
          return $cookies.get('WEBTV.locale');
         }, function(newValue) {  
  });
    $scope.someModel = null;
    $scope.someModelChannel = null;
    vm.tabs_title = getUiSrefTabs();

    vm.theme = angular.isUndefined(vm.query.theme) ? "": vm.query.theme;

    // if (!angular.isUndefined(parametersCanalNamesData)) {
    //   vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);

    vm.theme = "";
    vm.canal = "";
    // }
    vm.md_selected_index = getMdSelectedIndex();
    /*** todo get type choices intranet ****/
    // if (typesVideo) {
    //     $rootScope.types_all = typesVideo.data;
    // }
    // else {
    //  }
    function getAllTypes(){
      if(angular.isDefined($rootScope.types_all) ) {
        var types_all_values = Object.values($rootScope.types_all);
        // console.log(" $rootScope.types_all", $rootScope.types_all);
        // console.log(" $state.current.name", $state.current.name);
        var state_neme = $state.current.name;
        if ( state_neme.indexOf("mobile") > -1) {
          vm.listType=types_all_values.filter(function(x){return x.indexOf("mobile") > -1})
        }  else  {
          vm.listType=types_all_values
        }
        // console.log("vm.queryyy",vm.query);
        if(angular.isDefined(vm.default_type_stats ) && vm.default_type_stats && vm.default_type_stats ==='all' && angular.isDefined(  vm.listType) &&   vm.listType.length>1){
          var types = angular.isDefined(  vm.listType) ? vm.listType.join(','): "0";
          vm.types_query =types;


          setSelectedTypeStats()
        }
        else if (angular.isDefined(  vm.listType[0])) {
          vm.types_query =   vm.listType[0];
          setSelectedTypeStats()
        }
      }
    }
    function setSelectedTypeStats(){
      $rootScope.types_query = vm.types_query;
      var query = {};
      query.type = vm.types_query;

      statsVodLiveService.setQuery(query,   vm.endtDateFromLive);
    }
    function setQueryDateStatsFilter(){
      vm.currentDateIn = dateMoisCourantConstant.date.currentDateIn
      vm.currentDateOut = dateMoisCourantConstant.date.currentDateOut
    }
    function setQueryStatsFilter(){
      var query={}
      if(vm.typeStatsFilter==='live_by_id' && $state.current.name.indexOf("live_by_id") > -1){
        query.range="1h";
      }
      else{
        query.range="1d"
      }
      vm.query=query;
      statsVodLiveService.setQuery(query,  vm.endtDateFromLive);

    }
    function convertParentToSelectList(choices) {
      choices.sort(function (a, b) {
        return a.id - b.id;
      });
      return choices;
    }

    function changeDate(endDateFromLive,model) {
      var in_date = new Date(vm.currentDateIn);
      var out_date = new Date(vm.currentDateOut);
      if (out_date < in_date) {
        vm.currentDateOut = vm.currentDateIn;
      }
      // end verification
      var dateIn =  vm.currentDateIn;
      var dateOut = vm.currentDateOut;
      var query = {};
      if (!angular.isUndefined(dateIn)) {
        if (model === "Publication") {
          query.startDate = dateIn;
          query.dateIn = "";
        }
        else if (model === "Visualisation"){
            query.dateIn = dateIn;
            query.startDate =""
        }
      }
      if (!angular.isUndefined(dateOut)) {
        if (model === "Publication"){
          query.dateOut = "";
          query.endDate=dateOut
        }else if (model === "Visualisation"){
            query.dateOut = dateOut;
            query.endDate=""
        }
      }
      statsVodLiveService.setQuery(query,endDateFromLive,true,typeStatsFilter);
    }

    function changeQuery(test, model) {
      var res;
      var idCanal= test==="accessCanal"?model:vm.canal;
      if (test === 'canal') {
        vm.theme = '';
        idCanal=model
      }
      if (test !=="accessCanal") {
        if (angular.isDefined(model) && test !== 'canal') {
          res = model.substring(model.indexOf('-') + 1, model.length);
        } else {
          if (vm.theme)
            res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
        }
      }
      // end verification
      var canal = String(idCanal);
      var type = vm.types_query;
      var query = {};
      if(!angular.isUndefined(vm.groups_query)){
        query.group=vm.groups_query
      }
      if (!angular.isUndefined(canal)) {
        query.canal = canal;
      }
      if (!angular.isUndefined(res)) {
        query.theme = res;
      }
      if (!angular.isUndefined(type)) {
        query.type = type;
        $rootScope.types_query = type;
      }
      statsVodLiveService.setQuery(query,   vm.endtDateFromLive, true,typeStatsFilter);
      vm.theme=model;
    }

    function getMdSelectedIndex() {
      var md_selected_index = 0;
      angular.forEach(tabs_vod, function (value) {
        if ($state.current.name.indexOf(value.ui_sref) > 0) {
          md_selected_index = value.md_selected_index;
        }
      });
      return md_selected_index;
    }

    function getUiSrefTabs() {
      var tabs_ui_sref = angular.copy(tabs_vod);
      angular.forEach(tabs_vod, function (value, key) {
        tabs_ui_sref[key].ui_sref = parent_state + value.ui_sref;
      });
      return tabs_ui_sref;
    }

    function initInfoVideoById() {
      var this_video = getVideoById;

      if (angular.isDefined($stateParams.id)) {
        vm.videoById = this_video;
        if (($state.current.name.indexOf("live") > 0) || ($state.current.name.indexOf("event") > 0) || ($state.current.name.indexOf("zone") > 0)) {
          vm.videoById.logo = this_video.thumbnail;
        }
        if(this_video && this_video.date &&  this_video.duration){
          $rootScope.infoVideo={date:this_video.date, duration : this_video.duration}
        }
        var stats_interval = angular.isDefined(webTvGlobal.$constant().webTvParameterBag().stats_interval);
        if( stats_interval){
          $rootScope.stats_interval=stats_interval
        }

        if(this_video.data && this_video.data.live){

          var live = this_video.data.live;
          if(live.dateStartDiffusion && angular.isDefined(live.dateStartDiffusion)){

            vm.currentDateIn=new Date(live.dateStartDiffusion)
          }else if(live.dateStart && angular.isDefined(live.dateStart)){
            vm.currentDateIn=new Date(live.dateStart)
          }
          if(live.dateEndDiffusion && angular.isDefined(live.dateEndDiffusion)){
            vm.currentDateOut=new Date(live.dateEndDiffusion)
            vm.endtDateFromLive=true;
          }else if(live.dateStartDiffusion && angular.isDefined(live.dateStartDiffusion)){
            vm.currentDateOut=new Date()
            vm.dateOut=new Date()
            vm.endtDateFromLive=true;
          }else if(live.dateEnd && angular.isDefined(live.dateEnd)){
            vm.currentDateOut=new Date(live.dateEnd)
            vm.endtDateFromLive=true;
          }else{
            vm.endtDateFromLive=false;
          }
          $rootScope.endtDateFromLive=vm.endtDateFromLive
          changeDate(vm.endtDateFromLive,"Visualisation",false,typeStatsFilter)
        }
      }
    }

    /*function gotoListVideo() {
      if (angular.isDefined($stateParams.id)) {
        var stat_default = 'app.media_video_list_ongoing';
        if ($state.current.name.indexOf("live") > 0) {
          stat_default = "app.lives_list_ongoing";
        }
        var state_parent = angular.isDefined($rootScope.name_state_parent) ? $rootScope.name_state_parent : stat_default;
        $state.go(state_parent);
      }

    }*/

    function  isHiddenFilter  (tab_list,value) {

      var type = angular.isDefined(tab_list.filter) ? tab_list.filter : typeStatsFilter;

      return searchFiltreRight [type][value];

    }

    msApi.request('userManager.getUserDataStat@get',
      {},
      function (res) {
        vm.statuser = res.userData.modules.stats_module;
        var i=0;
        angular.forEach(vm.tabs_title, function (value, key) {
          if(vm.statuser===undefined || vm.statuser.length===0)
          {
            vm.tabs_title[key].permission=true;
          }
          var j=0;
          angular.forEach(vm.statuser, function (value, keys) {

            if  (   (vm.statuser[keys].name=="stats_"+ vm.typeStatsFilter+"_"+ vm.tabs_title[key].ui_view) )
            {
              vm.tabs_title[key].permission=vm.statuser[keys].authorized;
            }

            j++;
          });

          i++;
        });

      },
      function () {

      }
    );

    initHelp();

    function initHelp() {
      $rootScope.titre1="PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2="PAGESMENUSTITLES.stats_"+vm.typeStatsFilter+"_pagetitle";
      $rootScope.titre3="";
      $rootScope.welcome = "";
      $rootScope.pageRoute = '';
      if(getVideoById !== null) {
        if ($rootScope.name_state_parent == "app.media_video_list_ongoing") {
          $rootScope.pageRoute = 'app.media_video_list_ongoing';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.media_video_list_archived") {
          $rootScope.pageRoute = 'app.media_video_list_archived';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.media_video_list_offline") {
          $rootScope.pageRoute = 'app.media_video_list_offline';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.media_video_list_upcoming") {
          $rootScope.pageRoute = 'app.media_video_list_upcoming';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.media_video_list_all") {
          $rootScope.pageRoute = 'app.media_video_list_all';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.lives_list_archived") {
          $rootScope.pageRoute = 'app.lives_list_archived';
          $rootScope.titre3 = getVideoById.data.live.title;
        }
        else if ($rootScope.name_state_parent == "app.lives_list_ongoing") {
          $rootScope.pageRoute = 'app.lives_list_ongoing';
          $rootScope.titre3 = getVideoById.data.live.title;
        }
        else if ($rootScope.name_state_parent == "app.event_list_ongoing") {
          $rootScope.pageRoute = 'app.event_list_ongoing';
          $rootScope.titre3 = getVideoById.title;
        }
        else if ($rootScope.name_state_parent == "app.event_list_upcoming") {
          $rootScope.pageRoute = 'app.event_list_upcoming';
          $rootScope.titre3 = getVideoById.title;
        }
      }
    }

  }
})();

(function () {
  'use strict';
  /** @ngInject */
  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m-1, 0);
  var lastDay = new Date(y, m + 1, 0,23);

  var dateMoisCourantConstant = {
          "date": {
              "currentDateIn": firstDay,
              "currentDateOut": lastDay
          }
  };

  var tab_key_value_vod_by_id_stat = {
      audience: {title: "STATSTITLE.stat_audience", ui_sref: ".audience", ui_view: "audience", permission:"", md_selected_index : 0},
      technologie: {title: "STATSTITLE.stat_technologie", ui_sref: ".technologie", ui_view: "technologie", permission:"", md_selected_index : 1 },
      mobile: {title: "STATSTITLE.stat_mobile", ui_sref: ".mobile", ui_view: "mobile" , md_selected_index : 2, permission:""},
      engagement: {title: "STATSTITLE.stat_engagement", ui_sref: ".engagement", ui_view: "engagement" , permission:"", md_selected_index : 3},
      geo: {title: "STATSTITLE.stat_geolocalisation", ui_sref: ".geo", ui_view: "geo" , permission:"", md_selected_index : 4},
      temp_reel: {title: "STATSTITLE.stat_real_time", ui_sref: ".temp_reel",ui_view: "temp_reel", permission:"", md_selected_index : 5,filter : "time_reel"}
  };

  var is_show_filtre_vod_stat = {
    vod: {
      dateIn: true,
      dateOut: true,
      canal: true,
      theme: true,
      type: true
    },
    vod_by_id: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: true,
      type: true
    },
    live: {
          dateIn: true,
          dateOut: true,
          canal: false,
          theme: false,
          type: true
    },
    live_by_id: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: false,
      type: true
    },
    event: {
          dateIn: true,
          dateOut: true,
          canal: false,
          theme: false,
          type: true
    },
      time_reel: {
          dateIn: false,
          dateOut: false,
          canal: true,
          theme: true,
          type: true
      },
      zone: {
          dateIn: true,
          dateOut: true,
          canal: false,
          theme: false,
          type: true
      },
  };


  angular
      .module('app.stats.vod_live')
      .constant('tab_key_value_vod_by_id_stat', tab_key_value_vod_by_id_stat)
      .constant('dateMoisCourantConstant', dateMoisCourantConstant)
      .constant('is_show_filtre_vod_stat', is_show_filtre_vod_stat);

})();

(function () {
    "use strict";
  
    angular
      .module("app.stats.vod_live")
      .controller("EventByIdStatsController", EventByIdStatsController);
  
    /** @ngInject */
    function EventByIdStatsController(
      $rootScope,
      $sce,
      $scope,
      $cookies,
      $injector,
      $stateParams
    ) {
      var vm = this;
      initHelp();
  
      // functions
            function initHelp() {
                var $rootScope = $injector.get("$rootScope"), msApi = $injector.get("msApi"), $stateParams = $injector.get("$stateParams");
        var language = $cookies.get('WEBTV.locale');
        $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.stats_event_by_id_pagetitle";
        $rootScope.titre3 = "";
        $rootScope.pageRoute = "";
        setStatsIframe(msApi, $stateParams, language);
      }
      function setStatsIframe(msApi, type, language) {
        if (window.process.env.FO_STATS_URL) {
          var eventId = $stateParams.id;
            vm.eventsStatsIframe = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/event?lng=" + language +"&id="+eventId + "&token=" +$cookies.get("authToken"));
        
         
        }
      }
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.skin', [])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.skin', {
            url: '/skin/vod',
            views: {
                'content@app': {
                    templateUrl: 'app/main/skin/player/player.template.html',
                    controller: 'skinPlayerController as vm'

                }
            },
            resolve: {
                urlSkinPlayer: function (msApi) {
                    return msApi.resolve('url_skin_player.get@get',{type:"vod"});
                }
            },
            bodyClass: 'dashboard-project'
            // "actionPermission": "scorms_noApiRoute_action"
        });


      $stateProvider.state('app.skin_live', {
        url: '/skin/live',
        views: {
          'content@app': {
            templateUrl: 'app/main/skin/player/player.template.html',
            controller: 'skinPlayerController as vm'

          }
        },
        resolve: {
          urlSkinPlayer: function (msApi) {
            return msApi.resolve('url_skin_player.get@get',{type:"live"});
          }
        },
        bodyClass: 'dashboard-project'
        // "actionPermission": "scorms_noApiRoute_action"
      });

      $stateProvider.state('app.skin_player', {
        url: '/skin/player',
        views: {
          'content@app': {
            templateUrl: 'app/main/skin/player/player.template.html',
            controller: 'skinPlayerController as vm'

          }
        },
        resolve: {
          urlSkinPlayer: function (msApi) {
            return msApi.resolve('url_skin_player.get@get',{type:"player"});
          }
        },
        bodyClass: 'dashboard-project'
        // "actionPermission": "scorms_noApiRoute_action"
      });
        // Translation
        $translatePartialLoaderProvider.addPart('app/main/skin/player');

        msApiProvider.register('url_skin_player.get', [Routing.generate('api_media_get_url_skin_generator')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*skin).*$",
                name_module: "skin",
                name_angular_module: "app.skin",
                actions: [
                    {"skinNoModule": ["skin_no_api"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.skin')
        .controller('skinPlayerController', skinPlayerController);


    /** @ngInject */
    function skinPlayerController($sce,$scope, fuseTheming,$translate,urlSkinPlayer, $rootScope) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var vm = this;
      vm.language = $translate.preferredLanguage();
        initHelp();
      $scope.iframeLoadedCallBack = function(){
        console.log('vm.language',vm.language)
        sendPostMessage( vm.language )
      }
        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.skin_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.skin_player_menuTitle";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "";


        }
        var activeTheme = fuseTheming.themes.active.theme;
        var colors = {
            "primary": activeTheme.primary.color,
            "accent": activeTheme.accent.color,
            "warn": activeTheme.warn.color
        };
        vm.urlSkinPlayerList = $sce.trustAsResourceUrl(urlSkinPlayer.url+'?&primaryColor='+colors.accent+'&secondaryColor='+colors.warn);
      function  sendPostMessage(lang){
        document.getElementById('iframe_skin').contentWindow.postMessage({
          info: "updateLang",
          lang:lang
        }, "*");
      }

    }

})();

(function () {
  "use strict";

  angular.module("app.stats.list_podcasts", []).config(config).run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider.state("app.stats_list_podcasts", {
      url: "/stat/list_podcasts",
      views: {
        "content@app": {
          templateUrl: "app/main/stats/list-podcasts/list_podcasts.template.html",
          controller: "ListPodcastsStatsController as vm",
        },
      },
      resolve: {
        MediaVideoList: function () {
          return "stats_list_podcast.dtableAll@get";
        },
      },
      "actionPermission":"stats_podcasts_list_export_action"
    });
  }

  function fetchRights(msRights) {
    if (mod === "dev") {
      var permissions = {
        name_module: "stats_list_podcasts",
        name_angular_module: "app.stats.list_podcasts",
        actions: [{ list_podcasts: ["stats_podcasts_list_export"] }],
      };
      msRights.setPermissions(permissions);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.stats.list_podcasts")
    .controller("ListPodcastsStatsController", ListPodcastsStatsController);

  /** @ngInject */
  function ListPodcastsStatsController(
    DTOptionsBuilder,
    DTColumnBuilder,
    $rootScope,
    MediaVideoList,
    $injector,
    $scope,
    order_video,
    $cookies,
    dtable_language,
    dateMoisCourantConstant,
    $http,
    $q
  ) {
    /**
     *Injected Vars
     */
    var $sce = $injector.get("$sce")
    var vm = this;
    initHelp();

    function initHelp() {
      var $rootScope = $injector.get("$rootScope");
      $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.stats_list_podcasts_pagetitle";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
    }
    if (window.process.env.isNewListStat) {
      vm.isNewListStat = window.process.env.isNewListStat;
      vm.newStatListIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_STAT_LIST_PODCAST_EXPORT + "?lang=" + $cookies.get("WEBTV.locale")  +  "&token=" + $cookies.get("authToken")
      );
    }
  }
})();

(function () {
  "use strict";

  angular.module("app.stats.users", []).config(config).run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider.state("app.stats_users", {
      url: "/stat/users",
      views: {
        "content@app": {
          templateUrl: "app/main/stats/users/users.template.html",
          controller: "usersStatsController as vm",
        },
      },
      "actionPermission": "stats_users_list_acces"
    })
  }

  function fetchRights(msRights) {
    if (mod === "dev") {
      var permissions = {
        name_module: "stats_users",
        name_angular_module: "app.stats.users",
        actions: [{ users: ["stats_users_list_acces"] }],
      };
      msRights.setPermissions(permissions);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.stats.users")
    .controller("usersStatsController", usersStatsController);

  /** @ngInject */
  function usersStatsController(
    $rootScope,
    $sce,
    $scope,
    $cookies,
    $injector
  ) {
    var vm = this;
    initHelp();

    // functions
    function initHelp() {
      var $rootScope = $injector.get("$rootScope"), msApi = $injector.get("msApi"), $stateParams = $injector.get("$stateParams");
      var language = $cookies.get('WEBTV.locale');
      $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.stats_users";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
      setStatsIframe(msApi, $stateParams, language);
    }
    function setStatsIframe(msApi, type, language) {
      if (window.process.env.FO_STATS_URL) {
         vm.usersStatsIframe = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/statsUsers?lng=" + language +  "&token=" + $cookies.get("authToken"));
   
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.stats.podcast',
            [
                'mdPickers',
                'app.stats.graphe',
                'app.stats.podcast.tab'
            ]
        )
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        var parentStates = [
          {
            state: 'stats_podcast',
            url: '/stat/podcast',
            template: 'app/main/stats/podcast/stat.vod.html',
            right: "stats.type.podcast",
            filter: "podcast"
          },
          {
            state: 'stats_podcast_by_id',
            url: '/stat/podcast_by_id/:id',
            template: 'app/main/stats/podcast/stat.vod_by_id.html',
            right: "stats.type.podcast",
            filter: "podcast"
          },
        ];

        parentStates.forEach(function (value) {
            $stateProvider
                .state("app." + value.state, {
                    url: value.url,
                    views: {
                        'content@app': {
                            templateUrl: value.template,
                            controller: 'PodcastTabsStatsController as vm'
                        }
                    },
                    resolve: {
                        tabs_podcast: function (tab_key_value_vod_by_id) {
                            return tab_key_value_vod_by_id;
                        },
                        typeChoices: function () {
                            return value.right;
                        },
                        searchFiltreRight: function (is_show_filtre_vod) {
                            return is_show_filtre_vod;
                        },
                        typeStatsFilter: function () {
                            return value.filter;
                        },
                        parent_state: function () {
                            return "app." + value.state;
                        },

                    }
                })
        });

        // Api
        msApiProvider.register('parameters_theme.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        msApiProvider.register('parameters_theme.themeChoices', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
        msApiProvider.register('userManager.getUserDataStat', [Routing.generate('api_core_rights_get_user_rights_by_module')]);
        msApiProvider.register('stats.getUrlExport', [Routing.generate('api_stats_acces_get_url_stat_export')]);
        msApiProvider.register('media_video.getUrlListVideo', [Routing.generate('api_media_get_url_list_video')]);
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                name_module: "stats",
                name_angular_module: "app.stats.podcast",
                actions: [
                    {"all": ["all_NoApi"]},
                    {"audience": ["audience_NoApi"]},
                    {"technologie": ["technologie_"]},
                    {"engagement": ["engagement"]},
                    {"mobile": ["get_detail"]},
                    {"temp_reel": ["get_detail"]}]
            };
            var permissions2 = {
                name_module: "stats_export",
                name_angular_module: "app.stats.podcast",
                actions: [

                    {"export": ["export_no_api"]}]
            };
            msRights.setPermissions(permissions2);
            msRights.setPermissionsStatsTabsAndApiNull(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.stats.podcast')
        .factory('statsPodcastService', statsPodcastService);

    /** @ngInject */
    function statsPodcastService( $state,$rootScope) {

        var query = {};

        function getQuery() {
            return query;
        }

        function setQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.theme)) {
                query.theme = query_param.theme;
            }
            if (!angular.isUndefined(query_param.type)) {
                query.type = query_param.type;
            }
            if (!angular.isUndefined(query_param.range) ) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.vod_id) ) {
                query.vod_id = query_param.vod_id;
            }
        }

        function verifQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn) && angular.isUndefined(query.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut) && angular.isUndefined(query.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.theme) && angular.isUndefined(query.theme)) {
                query.theme = query_param.theme;
            }
            if (!angular.isUndefined(query_param.group) && angular.isUndefined(query.group)) {
                query.group = query_param.group;
            }
            if (!angular.isUndefined(query_param.type) && angular.isUndefined(query.type)) {
                query.type = query_param.type;
            }else {
                if ($state.current.name.indexOf("live") > 0) {
                query.type = "live_internet";}
                else
                    query.type = $rootScope.types_all && Object.keys($rootScope.types_all).length> 0 ? Object.values($rootScope.types_all)[0] : '';
            }


            if (!angular.isUndefined(query_param.range) && angular.isUndefined(query.range)) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.vod_id)) {
                query.vod_id = query_param.vod_id;
            }
            if(angular.isUndefined(query_param.vod_id))
            {
                delete query.vod_id;
            }

        }

        return {
            setQuery: setQuery,
            getQuery: getQuery,
            verifQuery: verifQuery

        };

    }
}());

(function () {
  'use strict';

  angular
    .module('app.stats.podcast')
    .controller('PodcastTabsStatsController', PodcastTabsStatsController);

  /** @ngInject */
  function PodcastTabsStatsController($injector,$rootScope,msApi,  $scope,   tabs_podcast, typeChoices, webTvGlobal, dateMoisCourantConstant, parent_state,userManager,typeStatsFilter,searchFiltreRight,  $cookies) {

    var $stateParams = $injector.get('$stateParams'),
      $state = $injector.get('$state'),
      $sce = $injector.get('$sce'),
      $sce = $injector.get('$sce'),
      statsPodcastService = $injector.get('statsPodcastService');
    var filterShow = searchFiltreRight;
    var vm = this;
    var language = $cookies.get('WEBTV.locale');
    
    var parameterBag = webTvGlobal.$constant().webTvParameterBag();
    
    //function
    vm.typeStatsFilter = typeStatsFilter;
    vm.isNewStats = false;
    vm.isNewStats = false;
    vm.changeQuery = changeQuery;
    vm.changeDate = changeDate;
    vm.isHiddenFilter = isHiddenFilter;
    $scope.podcast=true;
    if (window.process.env.isNew_Stats) {
      vm.isNewStats =  window.process.env.isNew_Stats; }
      var type = $stateParams.type;
              $scope.PodcastdetailFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/podcast?lng="  + language +'&token='+ $cookies.get("authToken"));     
              $scope.PodcaststatByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/podcast?id=" + $stateParams.id + '&lng=' + language +'&token='+ $cookies.get("authToken"));
      
    $scope.$watch(function () { 
          language = $cookies.get("WEBTV.locale");
         $scope.PodcastdetailFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/podcast?lng=" + language + '&token='+ $cookies.get("authToken"));     
         $scope.PodcaststatByIdFrame =  $sce.trustAsResourceUrl("https:"+ window.process.env.FO_STATS_URL + "/podcast?id=" + $stateParams.id + '&lng='+language + '&token='+ $cookies.get("authToken"));
          return $cookies.get('WEBTV.locale');
         }, function(newValue) {  
  });
    //scope
      if(vm.typeStatsFilter==='podcast'){
          var query={}
          query.range="1h"
          if($state.params.id){
            query.vod_id=$state.params.id;
          }
          statsPodcastService.setQuery(query);
      }
    var stats_interval = angular.isDefined(webTvGlobal.$constant().webTvParameterBag().stats_interval);
    if( stats_interval){
      $rootScope.stats_interval=stats_interval
    }
    vm.query =statsPodcastService.getQuery();

    $scope.$on('parameterBag', function (event, obj) {
          if(obj) parameterBag = obj;
      });

      // console.log($state.params.id);
      // console.log(parameterBag["app.client.name"]);

    $scope.someModel = null;
    $scope.someModelChannel = null;
    vm.tabs_title = getUiSrefTabs();
    vm.currentDateIn = angular.isUndefined(vm.query.dateIn) ? dateMoisCourantConstant.date.currentDateIn : vm.query.dateIn;
    vm.currentDateOut = angular.isUndefined(vm.query.dateOut) ? dateMoisCourantConstant.date.currentDateOut : vm.query.dateOut;
    vm.theme = angular.isUndefined(vm.query.theme) ? "": vm.query.theme;

    // if (!angular.isUndefined(parametersCanalNamesData)) {
    //   vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);

      vm.theme = "";
      vm.canal = "";
    // }

      vm.md_selected_index = getMdSelectedIndex();
      if(parameterBag[typeChoices]) {
          $rootScope.types_all = parameterBag[typeChoices];
      }else{
          if ( $state.current.name.indexOf("mobile") > -1) {
              $rootScope.types_all = {"Internet Mobile": "podcast_internet_mobile"};
              $rootScope.types_query = "podcast_internet_mobile";
          }else {
              $rootScope.types_all = {"Internet": "podcast_internet", "Internet Mobile": "podcast_internet_mobile"};
              $rootScope.types_query = "podcast_internet";
          }
      }
     vm.listType=angular.isDefined($rootScope.types_all) && $rootScope.types_all ? Object.values($rootScope.types_all) : null;
    vm.default_type_stats = parameterBag["default_type_stats"];

    getAllTypes();
    function getAllTypes(){
      if(angular.isDefined($rootScope.types_all) ) {
        var types_all_values = Object.values($rootScope.types_all);
        var state_neme = $state.current.name;
        if ( state_neme.indexOf("mobile") > -1) {
          vm.listType=types_all_values.filter(function(x){ return x.indexOf("mobile") > -1 })
        }
         if(angular.isDefined(vm.default_type_stats ) && vm.default_type_stats && vm.default_type_stats ==='all' && angular.isDefined(  vm.listType) &&   vm.listType.length>1){
          var types = angular.isDefined(  vm.listType) ? vm.listType.join(','): "0";
          vm.types_query =types;
          setSelectedTypeStats()
        }
        else if (angular.isDefined(  vm.listType[0])) {
          vm.types_query =   vm.listType[0];
          setSelectedTypeStats()
        }
      }
    }
    function setSelectedTypeStats(){
      $rootScope.types_query = vm.types_query;
      var query = {};
      query.type = vm.types_query;
      statsPodcastService.setQuery(query);
    }

    function convertParentToSelectList(choices) {
      choices.sort(function (a, b) {
        return a.id - b.id;
      });
      return choices;
    }

    function changeDate() {
      //verification date in et date out
      var in_date = new Date(vm.currentDateIn);
      var out_date = new Date(vm.currentDateOut);
      if (out_date < in_date) {
        vm.currentDateOut = vm.currentDateIn;
      }
      // end verification
      var dateIn = vm.currentDateIn;
      var dateOut = vm.currentDateOut;

      var query = {};
      if (!angular.isUndefined(dateIn)) {
        query.dateIn = dateIn;
      }
      if (!angular.isUndefined(dateOut)) {
        query.dateOut = dateOut;
      }

      statsPodcastService.setQuery(query);
    }

    function changeQuery(test, model) {
      var res;
      var idCanal=vm.canal;
      if (test === 'canal') {
        vm.theme = '';
          idCanal=model
      }

      if (angular.isDefined(model) && test !== 'canal') {
        res = model.substring(model.indexOf('-') + 1, model.length);
      }
      else {
        if(vm.theme)
          res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
      }

      // end verification
      var canal = idCanal;
      var type = vm.types_query;
      var query = {};
      if (!angular.isUndefined(canal)) {
        query.canal = canal;
      }
      if (!angular.isUndefined(res)) {
        query.theme = res;
      }
      if (!angular.isUndefined(type)) {
          query.type = type;
          $rootScope.types_query = type;
      }
      statsPodcastService.setQuery(query);
        vm.theme=model;
    }

    function getMdSelectedIndex() {
      var md_selected_index = 0;
      angular.forEach(tabs_podcast, function (value) {
        if ($state.current.name.indexOf(value.ui_sref) > 0) {
          md_selected_index = value.md_selected_index;
        }
      });
      return md_selected_index;
    }

    function getUiSrefTabs() {
      var tabs_ui_sref = angular.copy(tabs_podcast);
      angular.forEach(tabs_podcast, function (value, key) {
    tabs_ui_sref[key].ui_sref = parent_state + value.ui_sref;
      });
      return tabs_ui_sref;
    }


    /*function gotoListVideo() {
      if (angular.isDefined($stateParams.id)) {
        var stat_default = 'app.media_video_list_ongoing';
        if ($state.current.name.indexOf("live") > 0) {
          stat_default = "app.lives_list_ongoing";
        }
        var state_parent = angular.isDefined($rootScope.name_state_parent) ? $rootScope.name_state_parent : stat_default;
        $state.go(state_parent);
      }

    }*/

    function isHiddenFilter(tab_list,value) {
      var type = angular.isDefined(tab_list.filter) ? tab_list.filter : typeStatsFilter;
      return filterShow [type][value];

    }

      msApi.request('userManager.getUserDataStat@get',
          {},
          function (res) {
              res.userData.menus.push('stats.podcast')
              vm.statuser = res.userData.modules.stats_module;
              var i=0;
              angular.forEach(vm.tabs_title, function (value, key) {
                  if(angular.isUndefined(res.userData.modules.stats_module))
                  {
                      vm.tabs_title[key].permission=true;
                  }
                  var j=0;
                  angular.forEach(vm.statuser, function (value, keys) {

                    if  (   (vm.statuser[keys].name=="stats_"+ vm.typeStatsFilter+"_"+ vm.tabs_title[key].ui_view) )
                    {
                        vm.tabs_title[key].permission=vm.statuser[keys].authorized;
                    }

                      j++;
                  });

                  i++;
              });

          },
          function () {

          }
      );

      initHelp();

    function initHelp() {
      $rootScope.titre1="PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2="PAGESMENUSTITLES.stats_"+vm.typeStatsFilter+"_pagetitle";
      $rootScope.titre3="";
      $rootScope.welcome = "";
      $rootScope.pageRoute = '';
    }

  }
})();

(function () {
  'use strict';
  /** @ngInject */
  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m-1, 0);
  var lastDay = new Date(y, m + 1, 0,23);

  var dateMoisCourantConstant = {
    "date": {
      "currentDateIn": firstDay,
      "currentDateOut": lastDay
    }
  };

  var tab_key_value_vod_by_id = {
    audience: {title: "STATSTITLE.stat_audience", ui_sref: ".audience", ui_view: "audience", permission:"", md_selected_index : 0},
    technologie: {title: "STATSTITLE.stat_technologie", ui_sref: ".technologie", ui_view: "technologie", permission:"", md_selected_index : 1 },
    mobile: {title: "STATSTITLE.stat_mobile", ui_sref: ".mobile", ui_view: "mobile" , md_selected_index : 2, permission:"",filter : "vod"},
    engagement: {title: "STATSTITLE.stat_engagement", ui_sref: ".engagement", ui_view: "engagement" , permission:"", md_selected_index : 3},
    geo: {title: "STATSTITLE.stat_geolocalisation", ui_sref: ".geo", ui_view: "geo" , permission:"", md_selected_index : 4},
    temp_reel: {title: "STATSTITLE.stat_real_time", ui_sref: ".temp_reel",ui_view: "temp_reel", permission:"", md_selected_index : 5,filter : "time_reel"}
  };

  var is_show_filtre_vod = {
    vod: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: true,
      type: true
    },
    podcast: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: true,
      type: true
    },
    live: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: false,
      type: true
    },
    event: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: false,
      type: true
    },
    time_reel: {
      dateIn: false,
      dateOut: false,
      canal: true,
      theme: true,
      type: true
    },
    zone: {
      dateIn: true,
      dateOut: true,
      canal: false,
      theme: false,
      type: true
    },
  };


  angular
    .module('app.stats.podcast')
    .constant('tab_key_value_vod_by_id', tab_key_value_vod_by_id)
    .constant('dateMoisCourantConstant', dateMoisCourantConstant)
    .constant('is_show_filtre_vod', is_show_filtre_vod);

})();

(function () {
  "use strict";

  angular.module("app.stats.p2p", []).config(config).run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider.state("app.stats_p2p", {
      url: "/stat/p2p",
      views: {
        "content@app": {
          templateUrl: "app/main/stats/p2p/p2p.template.html",
          controller: "P2pStatsController as vm",
        },
      },
      "actionPermission": "stats_p2p_acces"
    })
  }

  function fetchRights(msRights) {
    if (mod === "dev") {
      var permissions = {
        name_module: "stats_p2p",
        name_angular_module: "app.stats.p2p",
        actions: [{ p2p: ["stats_p2p_acces"] }],
      };
      msRights.setPermissions(permissions);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.stats.p2p")
    .controller("P2pStatsController", P2pStatsController);

  /** @ngInject */
  function P2pStatsController(
    $rootScope,
    $sce,
    $scope,
    $cookies,
    $injector
  ) {
    var vm = this;
    initHelp();

    // functions
    function initHelp() {
      var $rootScope = $injector.get("$rootScope"), msApi = $injector.get("msApi"), $stateParams = $injector.get("$stateParams");
      var language = $cookies.get('WEBTV.locale');
      $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.stats_p2p";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
      setStatsIframe(msApi, $stateParams, language);
    }
    function setStatsIframe(msApi, type, language) {
      if (window.process.env.FO_STATS_URL) {
          vm.p2pStatsIframe = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/p2p?lng=" + language +"&token=" +$cookies.get("authToken"));
  
      }
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.stats.storage',
            ['nvd3','mdPickers'
            ]
        )
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider.state('app.stats_storage', {
            url: "/stats/storage",
            views: {
                'content@app': {
                    templateUrl: "app/main/stats/storage/stat.storage.html",
                    controller: 'StorageStatsController as vm'
                }
            },
            resolve: {
                // parametersCanalNamesData: function (msApi) {
                //     return msApi.resolve('parameters_canal.getNames@get');
                // }
            },
            bodyClass: 'storage',
            "actionPermission" : "stats_storage_post_storage_action"
        });

       $translatePartialLoaderProvider.addPart('app/main/stats/storage');
        msApiProvider.register('stats.storage', [Routing.generate('api_storage_post_storage')]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*storage).*$",
                name_module: "stats_storage",
                name_angular_module: "app.stats",
                actions: [
                    {"storage": ["post_storage"]}]
            };
            msRights.setPermissions(permissions);
        }
    }

})();

(function () {
  'use strict';

  angular
    .module('app.stats.storage')
    .controller('StorageStatsController', StorageStatsController);

  /** @ngInject */
  function StorageStatsController($rootScope,$scope, $sce, $cookies) {
    var vm = this;
    $scope.someModel = null;
    $scope.someModelChannel = null;
    initHelp();
    function initHelp() {
      $rootScope.titre1="PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2="PAGESMENUSTITLES.stats_storage_pagetitle";
      $rootScope.titre3="";
      $rootScope.pageRoute = '';
      $rootScope.welcome = "";

      vm.newStatStockage = $sce.trustAsResourceUrl(
        "https:" +
        window.process.env.FO_STATS_URL +
        "/stockage?lng=" + $cookies.get("WEBTV.locale") + 
        "&token="  + $cookies.get("authToken")
      );  
    }
  }
})();
(function () {
  'use strict';
  /** @ngInject */
  var date = new Date(), y = date.getFullYear(), m = date.getMonth();
  var firstDay = new Date(y, m, 1);
  var lastDay = new Date(y, m + 1, 0);
  function FileConvertSizeStorage(aSize){
    aSize = Math.abs(parseInt(aSize, 10));
    var def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];
    if(aSize > 0)
    {for(var i=0; i<def.length; i++){
      if( aSize<def[i][0])
        return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1];
    }}
    return 0;
  }

  var OptionsStatsStorageGraphe = {
    year:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#000000'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.values.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            return FileConvertSizeStorage(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    month:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F1'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.values.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%B %Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            return FileConvertSizeStorage(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%B %Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    days:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F3'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {

          return d.key;
        },
        y                      : function (d)
        {
          return d.values.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%d %B %Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: true,
          tickFormat: function (d)
          {
            return FileConvertSizeStorage(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%d %B %Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    week:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F5'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        duration               : 1,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.values.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%b %d %B %Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            return FileConvertSizeStorage(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%b %d %B %Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        },
        callback: function(){ //remove 'Line' from the chart and legend
          d3.selectAll('.nv-y2 .nv-axis').style('display', 'none');
          d3.selectAll('g.nv-legend g.nv-series').style('display', function(d){
            return d.remove ? 'none' : 'true';
          });
        }
      }}
  };
  var widgetDefault = {"widget_storage": {
      "title": "STATSSTORAGE.title",
      "ranges": {
        "1d": "STATSSTORAGE.day",
        "1w": "STATSSTORAGE.week",
        "1M": "STATSSTORAGE.month"
      },
      "currentRange" : "1d",
      "date" : {
        "currentDateIn":firstDay,
        "currentDateOut":lastDay
      }

    }};
  angular
    .module('app.stats.storage')
    .value('OptionsStatsStorageGraphe', OptionsStatsStorageGraphe)
    .constant('widgetDefault',widgetDefault)




})();
(function () {
    'use strict';

    angular
        .module('app.stats.mooc',
            ['nvd3', 'mdPickers',
                'app.stats.graphe',
                'app.stats.mooc.tab',
                'app.stats.mooc.persons'
            ]
        )
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {
        $stateProvider.state('app.stats_mooc', {
            url: "/stats/mooc",
            views: {
                'content@app': {
                    templateUrl: "app/main/stats/mooc/stats.mooc.html",
                    controller: 'MoocStatsController as vm'
                }
            },
            resolve: {
                tabs_m: function (tab_key_value_mooc) {
                    return tab_key_value_mooc;
                },

            }
        });
        $stateProvider.state('app.stats_mooc_theme', {
            url: "/stats/mooc/:id",
            views: {
                'content@app': {
                    templateUrl: "app/main/stats/mooc/stats.mooc.theme.html",
                    controller: 'MoocStatsThemeController as vm'
                }
            }
        });
        msApiProvider.register('parameters_theme_mooc.dtable', [Routing.generate('api_dtable_list_dtable_parameters_themes_mooc')]);
        msApiProvider.register('mooc.export_csv', [Routing.generate('api_mooc_export_csv')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                name_module: "stats_mooc",
                name_angular_module: "app.stats.mooc",
                actions: [
                    {"course": ["course_NoApi", "list_dtable_parameters_themes_mooc"]},
                    {"performance": ["performance_NoApi"]},
                    {"video": ["video_NoApi"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.stats.mooc')
        .factory('statsMoocService', statsMoocService);

    /** @ngInject */
    function statsMoocService() {

        var query = {};

        function getQuery() {
            return query;
        }

        function setQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.range)) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.theme)) {
                query.id_object = query_param.theme;
            }
        }

        function verifQuery(query_param) {
            if (!angular.isUndefined(query_param.dateIn) && angular.isUndefined(query.dateIn)) {
                query.dateIn = query_param.dateIn;
            }
            if (!angular.isUndefined(query_param.dateOut) && angular.isUndefined(query.dateOut)) {
                var out_date = query_param.dateOut;
                out_date.setHours(out_date.getHours() + 23);
                query.dateOut = query_param.dateOut;
            }
            if (!angular.isUndefined(query_param.range) && angular.isUndefined(query.range)) {
                query.range = query_param.range;
            }
            if (!angular.isUndefined(query_param.theme) && angular.isUndefined(query.id_object)) {
                query.id_object = query_param.theme;
            }
        }

        return {
            setQuery: setQuery,
            getQuery: getQuery,
            verifQuery: verifQuery

        };

    }
}());

(function () {
    'use strict';

    angular
        .module('app.stats.mooc')
        .controller('MoocStatsController', MoocStatsController)
        .controller('MoocStatsThemeController', MoocStatsThemeController);

    /** @ngInject */
    function MoocStatsThemeController($injector, dateMoisCourantConstant, $state, statsMoocService) {
        initHelp();

        function initHelp() {
            var $rootScope = $injector.get('$rootScope');
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_mooc";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
        }

        var vm = this;

        vm.changeDate = changeDate;

        if ($state.params.id) {
            var query = {};
            query.theme = $state.params.id;
            statsMoocService.setQuery(query);
        }
        vm.query = statsMoocService.getQuery();
        vm.currentDateIn = angular.isUndefined(vm.query.dateIn) ? dateMoisCourantConstant.date.currentDateIn : vm.query.dateIn;
        vm.currentDateOut = angular.isUndefined(vm.query.dateOut) ? dateMoisCourantConstant.date.currentDateOut : vm.query.dateOut;


        function changeDate() {

            //verification date in et date out
            var in_date = new Date(vm.currentDateIn);
            var out_date = new Date(vm.currentDateOut);
            if (out_date < in_date) {
                vm.currentDateOut = vm.currentDateIn;
            }
            // end verification
            var dateIn = vm.currentDateIn;
            var dateOut = vm.currentDateOut;

            var query = {};
            if (!angular.isUndefined(dateIn)) {
                query.dateIn = dateIn;
            }
            if (!angular.isUndefined(dateOut)) {
                query.dateOut = dateOut;
            }

            statsMoocService.setQuery(query);

        }
    }

    /** @ngInject */
    function MoocStatsController($injector, tabs_m, dateMoisCourantConstant, msApi) {
        initHelp();

        function initHelp() {
            var $rootScope = $injector.get('$rootScope');
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_mooc";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
        }

        var vm = this;
        var $state = $injector.get('$state');
        var statsMoocService = $injector.get('statsMoocService');
        vm.tabs_title_mooc = getUiSrefTabs();
        vm.md_selected_index = getMdSelectedIndex();

        vm.changeDate = changeDate;
        var query = {};
        query.theme = "";
        statsMoocService.setQuery(query);
        vm.query = statsMoocService.getQuery();
        vm.currentDateIn = angular.isUndefined(vm.query.dateIn) ? dateMoisCourantConstant.date.currentDateIn : vm.query.dateIn;
        vm.currentDateOut = angular.isUndefined(vm.query.dateOut) ? dateMoisCourantConstant.date.currentDateOut : vm.query.dateOut;

        function getUiSrefTabs() {
            var tabs_ui_sref = angular.copy(tabs_m);
            angular.forEach(tabs_m, function (value, key) {
                tabs_ui_sref[key].ui_sref = "app.stats_mooc" + value.ui_sref;
            });
            return tabs_ui_sref;
        }

        function getMdSelectedIndex() {
            var md_selected_index = 0;
            angular.forEach(tabs_m, function (value) {
                if ($state.current.name.indexOf(value.ui_sref) > 0) {
                    md_selected_index = value.md_selected_index;
                }
            });
            return md_selected_index;
        }

        function changeDate() {

            //verification date in et date out
            var in_date = new Date(vm.currentDateIn);
            var out_date = new Date(vm.currentDateOut);
            if (out_date < in_date) {
                vm.currentDateOut = vm.currentDateIn;
            }
            // end verification
            var dateIn = vm.currentDateIn;
            var dateOut = vm.currentDateOut;

            var query = {};
            if (!angular.isUndefined(dateIn)) {
                query.dateIn = dateIn;
            }
            if (!angular.isUndefined(dateOut)) {
                query.dateOut = dateOut;
            }

            statsMoocService.setQuery(query);
        }

        vm.exportcsv = exportcsv;

        function exportcsv() {
            msApi.request(
                'mooc.export_csv@get',
                function (res) {
                    if (res.code === 200) {
                        window.location.href = res.path_file_stats_mooc;
                    }
                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );
        }

    }
})();




(function () {
    'use strict';
    /** @ngInject */

    var tab_key_value_mooc = {
        course: {title: "STATSTITLE.stat_course", ui_sref: ".course", ui_view: "course" , md_selected_index : 0},
        performance: {title: "STATSTITLE.stat_performance", ui_sref: ".performance", ui_view: "performance", md_selected_index : 1 },
        video: {title: "STATSTITLE.stat_video", ui_sref: ".video", ui_view: "video" , md_selected_index : 2,filter : "vod"},
        voyage_passport: {title: "STATSTITLE.stat_voyage_passport", ui_sref: ".voyage", ui_view: "voyage" , md_selected_index : 3 }
    };

    angular
        .module('app.stats.mooc')
        .constant('tab_key_value_mooc', tab_key_value_mooc);

})();
(function () {
    "use strict";
  
    angular.module("app.stats.podcasts", []).config(config).run(fetchRights);
  
    /** @ngInject */
    function config($stateProvider, msApiProvider) {
      $stateProvider.state("app.stats_podcasts", {
        url: "/stat/podcasts",
        views: {
          "content@app": {
            templateUrl: "app/main/stats/podcasts/podcasts.template.html",
            controller: "podcastsStatsController as vm",
          },
        },
        "actionPermission": "stats_podcasts_list_acces"
      })
    }
  
    function fetchRights(msRights) {
      if (mod === "dev") {
        var permissions = {
          name_module: "stats_podcasts",
          name_angular_module: "app.stats.podcasts",
          actions: [{ podcasts: ["stats_podcasts_list_acces"] }],
        };
        msRights.setPermissions(permissions);
      }
    }
  })();
  

(function () {
    "use strict";
  
    angular
      .module("app.stats.podcasts")
      .controller("podcastsStatsController", podcastsStatsController);
  
    /** @ngInject */
    function podcastsStatsController(
      $rootScope,
      $sce,
      $scope,
      $cookies,
      $injector
    ) {
      var vm = this;
      initHelp();
  
      // functions
      function initHelp() {
        var $rootScope = $injector.get("$rootScope"), msApi = $injector.get("msApi"), $stateParams = $injector.get("$stateParams");
        var language = $cookies.get('WEBTV.locale');
        $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.stats_podcasts";
        $rootScope.titre3 = "";
        $rootScope.pageRoute = "";
        setStatsIframe(msApi, $stateParams, language);
      }
      function setStatsIframe(msApi, type, language) {
        if (window.process.env.FO_STATS_URL) {
            vm.podcastsStatsIframe = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/podcast?lng=" + language +"&token=" +$cookies.get("authToken"));
    
        }
      }
    }
  })();
  
(function () {
  "use strict";

  angular.module("app.stats.list_videos", []).config(config).run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    $stateProvider.state("app.stats_list_videos", {
      url: "/stat/list_videos",
      views: {
        "content@app": {
          templateUrl: "app/main/stats/list-videos/list_videos.template.html",
          controller: "ListVideosStatsController as vm",
        },
      },
      resolve: {
        MediaVideoList: function () {
          return "stats_list_video.dtableAll@get";
        },
        // parametersCanalNamesData: function (msApi) {
        //     return msApi.resolve('parameters_canal.getNames@get');
        // }
      },
      "actionPermission":"stats_list_videos_list_dtable_videos_stats"  
    });
    msApiProvider.register("stats_list_video.dtableAll", [
      Routing.generate("api_dtable_list_dtable_videos_stats"),
    ]);
    // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
    msApiProvider.register("stats_list_video.exportXls", [
      Routing.generate("api_media_get_videos_export_excel"),
    ]);
  }

  function fetchRights(msRights) {
    if (mod === "dev") {
      var permissions = {
        name_module: "stats_list_videos",
        name_angular_module: "app.stats.list_videos",
        actions: [{ list_videos: ["list_dtable_videos_stats"] }],
      };
      msRights.setPermissions(permissions);
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("app.stats.list_videos")
    .controller("ListVideosStatsController", ListVideosStatsController);

  /** @ngInject */
  function ListVideosStatsController(
    DTOptionsBuilder,
    DTColumnBuilder,
    $rootScope,
    MediaVideoList,
    $injector,
    $scope,
    order_video,
    $cookies,
    dtable_language,
    dateMoisCourantConstant,
    $http,
    $q
  ) {
    /**
     *Injected Vars
     */
    var $sce = $injector.get("$sce"),
      webTvGlobal = $injector.get("webTvGlobal"),
      // $interval = $injector.get('$interval'),
      // $window = $injector.get('$window'),
      $compile = $injector.get("$compile"),
      $translate = $injector.get("$translate"),
      // $state = $injector.get('$state'),
      // $mdDialog = $injector.get('$mdDialog'),
      msApi = $injector.get("msApi"),
      // msUtils = $injector.get('msUtils'),
      // msNavigationService = $injector.get('msNavigationService'),
      $document = webTvGlobal.$document;
    var vm = this;
    initHelp();

    function initHelp() {
      var $rootScope = $injector.get("$rootScope");
      $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.stats_list_videos_pagetitle";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
    }

    vm.isGV = isGV;
    vm.dtInstance = {};
    vm.dtInstance2 = {};
    vm.videosDataTable = {};
    var filtre = {};
    var columnsApi = order_video;
    var videosServerDataTable = {};
    vm.theme = "";
    vm.canal = "";
    var sortedColumn = "";
    var sortedType = 0;
    vm.filters = [{ value: "Visualisation" }, { value: "Publication" }];
    vm.filter = "Visualisation";
    vm.startDate = dateMoisCourantConstant.date.currentDateIn;
    vm.endDate = dateMoisCourantConstant.date.currentDateOut;
    $scope.someModel = null;
    $scope.someModelChannel = null;
    // vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);
    vm.searchVideos = searchVideos;
    vm.exportExcel = exportExcel;
    vm.sortData = sortData;
    vm.dtOptions = DTOptionsBuilder.newOptions()
      .withFnServerData(serverData)
      // or here
      .withDataProp("data")
      .withDOM(
        'rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>'
      )
      .withLanguage(dtable_language[$cookies.get("WEBTV.locale")])
      .withOption("processing", true)
      .withOption("serverSide", true)
      // .withOption('columnDefs', [[]
      // ])
      .withOption("order", [[0, "desc"]])
      .withOption("lengthMenu", [5, 10, 20, 30, 50, 100])
      .withOption("pageLength", parseInt(20))
      .withOption("scrollY", "auto")
      .withOption("bInfo", false)
      .withOption("responsive", true)
      .withOption("createdRow", function (row) {
        $compile(angular.element(row).contents())($scope);
      })
      .withPaginationType("simple_numbers");

    function searchVideosInAPI(filtre) {
      msApi.request(
        MediaVideoList,
        filtre,
        function (response) {
          var records = {};
          if (response.code === 200) {
            var videos = response.data;
            let formattedVideos = videos;
            let prepareApiTotalCalls = [];
            let prepareApiUniqueCalls = [];
            formattedVideos.forEach(function (v, index) {
              prepareApiTotalCalls.push(
                $http.post(
                  "https://" +
                    window.process.env.API_HOST_STATS +
                    "/mesure/visite/visite-total",
                  {
                    empStatsQuery: {
                      vod_id: "" + v.id,
                      host_api: "https:" + window.process.env.API_HOST_GLOBAL,
                      type: "internet,internet_mobile",
                      dateIn: filtre.dateIn,
                      dateOut: filtre.dateOut,
                      startDate: filtre.startDate,
                      endDate: filtre.endDate,
                      theme: filtre.idTheme,
                      canal: "" + filtre.idChannel,
                    },
                  },

                  {
                    headers: {
                      Authorization: "Bearer " + window.process.env.API_TOKEN,
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                )
              );
              prepareApiUniqueCalls.push(
                $http.post(
                  "https://" +
                    window.process.env.API_HOST_STATS +
                    "/mesure/visite/visite-unique",
                  {
                    empStatsQuery: {
                      vod_id: "" + v.id,
                      host_api: "https:" + window.process.env.API_HOST_GLOBAL,
                      type: "internet,internet_mobile",
                      dateIn: filtre.dateIn,
                      dateOut: filtre.dateOut,
                      startDate: filtre.startDate,
                      endDate: filtre.endDate,
                      theme: filtre.idTheme,
                      canal: "" + filtre.idChannel,
                    },
                  },

                  {
                    headers: {
                      Authorization: "Bearer " + window.process.env.API_TOKEN,
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                )
              );
            });

            $q.all(prepareApiTotalCalls)
              .then(function (results) {
                results.forEach(function (res, index) {
                  formattedVideos[index].nbVisits =
                    res.data.values.visite.visite_total.value;
                });
              })
              .catch(function (e) {
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: [],
                };
                vm.videos = [];
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              });
            $q.all(prepareApiUniqueCalls)
              .then(function (results) {
                results.forEach(function (res, index) {
                  formattedVideos[index].nbUniqueVisits =
                    res.data.values.visite.visite_unique.value;
                });
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: formattedVideos,
                };
                vm.videos = formattedVideos;
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              })
              .catch(function (e) {
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: [],
                };
                vm.videos = [];
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              });

            //deferred.resolve(records);
          } else {
            if (
              angular.isDefined(response.data) &&
              angular.isDefined(response.data.message)
            ) {
              $translate("VALIDATIONS." + response.data.message).then(
                function (message) {
                  webTvGlobal.alertDialog(message);
                },
                function () {
                  webTvGlobal.alertDialog(
                    $translate.instant("MESSAGES.alert_xhr_error")
                  );
                }
              );
            } else {
              records = {
                draw: 0,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: 0,
              };
              vm.videos = [];
              vm.recordsTotal = 0;
              vm.fnCallback(records);
              $rootScope.loadingProgress = false;
              webTvGlobal.alertDialog(
                $translate.instant("MESSAGES.alert_xhr_error")
              );
            }
          }
        },
        function (response) {
          if (
            angular.isDefined(response.data) &&
            angular.isDefined(response.data.message)
          ) {
            $translate("VALIDATIONS." + response.data.message).then(
              function (message) {
                webTvGlobal.alertDialog(message);
              },
              function () {
                webTvGlobal.alertDialog(
                  $translate.instant("MESSAGES.alert_xhr_error")
                );
              }
            );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_xhr_error")
            );
          }
        }
      );
    }

    function serverData(sSource, aoData, fnCallback) {
      //All the parameters you need is in the aoData variable
      var draw = aoData[0].value;
      var columns = aoData[1].value;
      var order = aoData[2].value;
      var start = aoData[3].value;
      var length = aoData[4].value;
      var sort = angular.copy(order[0]);
      // var numColum = angular.isUndefined(columnsApi.data[columns[sort.column].data]) ? 0 : columnsApi.data[columns[sort.column].data];
      vm.selectedVideos = [];
      filtre = {
        draw: draw,
        start: start,
        length: length,
        "search[value]": vm.word,
        "order[0][column]": 0,
        "order[0][dir]": sort.dir,
      };
      filtre["columns[" + 0 + "][orderable]"] = true;
      filtre.searchWord = vm.word;
      filtre.idChannel = vm.canal;
      filtre.idTheme = vm.res;
      filtre.startDate = "";
      filtre.endDate = "";
      filtre.uniqueVisits = true;
      if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
        filtre.dateIn = moment(vm.startDate).format();
      }
      if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
        filtre.dateOut = moment(vm.endDate).format();
      }
      vm.fnCallback = fnCallback;

      searchVideosInAPI(filtre);
    }

    vm.trustedHtml = function (plainText) {
      return $sce.trustAsHtml($translate.instant("MESSAGES." + plainText + ""));
    };

    vm.dtColumns = [
      DTColumnBuilder.newColumn("title")
        .notSortable()
        .renderWith(function (data) {
          var title;
          if (angular.isDefined(data)) {
            if (data.length >= 50) {
              title = data.substring(0, 50) + "...";
            } else {
              title = data;
            }
          } else title = "";
          return '<div style="text-align: left">' + title + "</div>";
        }),
      // DTColumnBuilder.newColumn(null).notSortable().renderWith(function (data) {
      //
      //     var htmladd = ' <md-icon  md-font-icon="icon-play" class="s16" style="color: #5fa35f;margin-top: -3px;padding-right: 5px;"></md-icon>';
      //
      //     htmladd += '<span style="padding-left: 5px;">' + angular.isDefined(data.startDate) ? moment(data.startDate).format("DD-MM-YYYY") : "" + '</span>';
      //     htmladd += '<br>';
      //     htmladd += ' <md-icon md-font-icon="icon-stop" class="s16" style="color: #e64242;margin-top: -3px; padding-right: 5px;"></md-icon>';
      //     htmladd += '<span style="padding-left: 5px;">' + angular.isDefined(data.endDate) ? moment(data.endDate).format("DD-MM-YYYY") : "" + '</span>';
      //     return '<div style="min-width: 110px">' + htmladd + '</div>';
      // }),

      DTColumnBuilder.newColumn("themes")
        .notSortable()
        .renderWith(function (data, type, full) {
          videosServerDataTable[full.id] = data;
          var serverHtml = "";
          if (!data || data.length === 0) {
            serverHtml +=
              '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
          } else {
            angular.forEach(videosServerDataTable[full.id], function (value) {
              serverHtml +=
                '<span style="white-space: pre">' +
                '<md-icon md-font-icon="icon-chevron-right" class="s16"></md-icon> ' +
                value.title +
                "<br></span>";
            });
          }
          return '<div style="text-align: left">' + serverHtml + "</div>";
        }),
    ];
    if (window.process.env.isNewListStat) {
      vm.isNewListStat = window.process.env.isNewListStat;
      vm.newStatListIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_STAT_LIST_EXPORT + "?lang=" + $cookies.get("WEBTV.locale")  +  "&token=" + $cookies.get("authToken")
      );
      $scope.$watch(function () {
        vm.newStatListIframe = $sce.trustAsResourceUrl(
          "https:" +
            window.process.env.URL_STAT_LIST_EXPORT + "?lang="+ $cookies.get("WEBTV.locale")  +  "&token=" + $cookies.get("authToken")
        );
      });
    }
    if (vm.isGV) {
      vm.dtColumns.push(
        DTColumnBuilder.newColumn("subscriptionGroups")
          .notSortable()
          .renderWith(function (data, type, full) {
            videosServerDataTable[full.id] = data;
            var serverHtml = "";
            if (!data || data.length === 0) {
              serverHtml +=
                '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
            } else {
              angular.forEach(videosServerDataTable[full.id], function (value) {
                serverHtml +=
                  '<span style="white-space: pre">' +
                  '<md-icon md-font-icon="icon-chevron-right" class="s16"></md-icon> ' +
                  value.name +
                  "<br></span>";
              });
            }
            return '<div style="text-align: left">' + serverHtml + "</div>";
          })
      );
    }
    vm.dtColumns.push(
      DTColumnBuilder.newColumn("channels")
        .notSortable()
        .renderWith(function (data, type, full) {
          videosServerDataTable[full.id] = data;
          var serverHtml = "";
          if (!data || data.length === 0) {
            serverHtml +=
              '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
          } else {
            angular.forEach(videosServerDataTable[full.id], function (value) {
              serverHtml +=
                '<span style="white-space: pre">' +
                '<md-icon md-font-icon="icon-chevron-right" class="s16"></md-icon> ' +
                value.title +
                "<br></span>";
            });
          }
          return '<div style="text-align: left">' + serverHtml + "</div>";
        })
    );
    vm.dtColumns.push(
      DTColumnBuilder.newColumn("nbVisits")
        .notSortable()
        .renderWith(function (data) {
          return angular.isDefined(data) ? data : 0;
        })
    );
    vm.dtColumns.push(
      DTColumnBuilder.newColumn("nbUniqueVisits")
        .notSortable()
        .renderWith(function (data) {
          return angular.isDefined(data) ? data : 0;
        })
    );
    vm.dtColumns.push(
      DTColumnBuilder.newColumn("startDate")
        .notSortable()
        .renderWith(function (data) {
          return angular.isDefined(data)
            ? convertDate(new Date(data))
            : convertDate(new Date(moment().format("YYYY-MM-DDTHH:mm:ss.SSS")));
        })
    );
    vm.dtColumns.push(
      DTColumnBuilder.newColumn("duration")
        .notSortable()
        .renderWith(function (data) {
          return angular.isDefined(data)
            ? convertDuration(new Date(data))
            : convertDuration(
                new Date(moment().format("YYYY-MM-DDTHH:mm:ss.SSS"))
              );
        })
    );
    function convertDuration(date) {
      var seconds =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      var minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      var hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
      return hour + ":" + minutes + ":" + seconds;
    }
    function convertDate(date) {
      var years = date.getFullYear();
      var months =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var days = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      return days + "/" + months + "/" + years;
    }
    function searchVideos(test, model) {
      var idCanal = vm.canal;
      if (test === "canal") {
        vm.theme = "";
        idCanal = model;
      }
      if (test !== "access") {
        if (angular.isDefined(model) && test !== "canal") {
          vm.res = model.substring(model.indexOf("-") + 1, model.length);
        }
        if (!angular.isDefined(model) && test === "canal") {
          vm.res = vm.theme.substring(
            vm.theme.indexOf("-") + 1,
            vm.theme.length
          );
        }
      }
      filtre.searchWord = vm.word;

      if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
        if (model === "Publication") {
          filtre.startDate = moment(vm.startDate).format();
          filtre.dateIn = "";
        } else if (model === "Visualisation") {
          filtre.startDate = "";
          filtre.dateIn = moment(vm.startDate).format();
        }
      } else {
        filtre.startDate = "";
        filtre.dateIn = "";
      }

      if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
        if (model === "Publication") {
          filtre.endDate = moment(vm.endDate).format();
          filtre.dateOut = "";
        } else if (model === "Visualisation") {
          filtre.endDate = "";
          filtre.dateOut = moment(vm.endDate).format();
        }
      } else {
        filtre.endDate = "";
        filtre.dateOut = "";
      }

      filtre.idChannel = idCanal;
      filtre.idTheme = vm.res;

      filtre.uniqueVisits = true;

      searchVideosInAPI(filtre);
    }

    function exportExcel() {
      var filter = {};
      filter.length = filtre.length;
      filter.start = filtre.start;
      filter.searchWord = vm.word;
      filter.idTheme = vm.res;
      filter.idChannel = vm.canal;
      filter.uniqueVisits = true;
      if (vm.filter === "Publication") {
        if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
          filter.startDate = moment(vm.startDate).format();
          filter.dateIn = "";
        } else {
          filter.startDate = "";
          filter.dateIn = "";
        }
        if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
          filter.endDate = moment(vm.endDate).format();
          filter.dateOut = "";
        } else {
          filter.endDate = "";
          filter.dateOut = "";
        }
      } else if (vm.filter === "Visualisation") {
        if (angular.isDefined(vm.startDate) && vm.startDate !== null) {
          filter.dateIn = moment(vm.startDate).format();
          filter.startDate = "";
        } else {
          filter.dateIn = "";
          filter.startDate = "";
        }
        if (angular.isDefined(vm.endDate) && vm.endDate !== null) {
          filter.dateOut = moment(vm.endDate).format();
          filter.endDate = "";
        } else {
          filter.dateOut = "";
          filter.endDate = "";
        }
      }

      msApi.request(
        "stats_list_video.exportXls@get",
        filter,
        function (response) {
          if (response.code === 200) {
            window.location.href = response.url;
          } else
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_xhr_error")
            );
        }
      );
    }
    function sortData(column, asc) {
      sortedColumn = column;
      sortedType = asc;
      msApi.request(
        MediaVideoList,
        { length: filtre.length, draw: filtre.draw, uniqueVisits: true },
        function (response) {
          var records = {};
          if (response.code === 200) {
            var videos = response.data;
            let formattedVideos = videos;
            let prepareApiTotalCalls = [];
            let prepareApiUniqueCalls = [];
            formattedVideos.forEach(function (v, index) {
              prepareApiTotalCalls.push(
                $http.post(
                  "https://" +
                    window.process.env.API_HOST_STATS +
                    "/mesure/visite/visite-total",
                  {
                    empStatsQuery: {
                      vod_id: "" + v.id,
                      host_api: "https:" + window.process.env.API_HOST_GLOBAL,
                      type: "internet,internet_mobile",
                      dateIn: filtre.dateIn,
                      dateOut: filtre.dateOut,
                      startDate: filtre.startDate,
                      endDate: filtre.endDate,
                      theme: filtre.idTheme,
                      canal: "" + filtre.idChannel,
                    },
                  },

                  {
                    headers: {
                      Authorization: "Bearer " + window.process.env.API_TOKEN,
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                )
              );
              prepareApiUniqueCalls.push(
                $http.post(
                  "https://" +
                    window.process.env.API_HOST_STATS +
                    "/mesure/visite/visite-unique",
                  {
                    empStatsQuery: {
                      vod_id: "" + v.id,
                      host_api: "https:" + window.process.env.API_HOST_GLOBAL,
                      type: "internet,internet_mobile",
                      dateIn: filtre.dateIn,
                      dateOut: filtre.dateOut,
                      startDate: filtre.startDate,
                      endDate: filtre.endDate,
                      theme: filtre.idTheme,
                      canal: "" + filtre.idChannel,
                    },
                  },

                  {
                    headers: {
                      Authorization: "Bearer " + window.process.env.API_TOKEN,
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }
                )
              );
            });

            $q.all(prepareApiTotalCalls)
              .then(function (results) {
                results.forEach(function (res, index) {
                  formattedVideos[index].nbVisits =
                    res.data.values.visite.visite_total.value;
                });
              })
              .catch(function (e) {
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: [],
                };
                vm.videos = [];
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              });
            $q.all(prepareApiUniqueCalls)
              .then(function (results) {
                results.forEach(function (res, index) {
                  formattedVideos[index].nbUniqueVisits =
                    res.data.values.visite.visite_unique.value;
                });
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: formattedVideos,
                };
                if (sortedColumn && sortedType != 0) {
                  if (["duration", "startDate"].includes(sortedColumn)) {
                    records.data = records.data
                      .sort(function (a, b) {
                        const date1 = new Date(a[sortedColumn]);
                        const date2 = new Date(b[sortedColumn]);
                        return (date1 - date2) * sortedType;
                      })
                      .slice(filtre.start, filtre.start + filtre.length);
                  } else {
                    records.data = records.data
                      .sort(function (a, b) {
                        return (a[sortedColumn] - b[sortedColumn]) * sortedType;
                      })
                      .slice(filtre.start, filtre.start + filtre.length);
                  }
                }
                vm.videos = formattedVideos;
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              })
              .catch(function (e) {
                records = {
                  draw: response.draw,
                  recordsTotal: response.recordsTotal,
                  recordsFiltered: response.recordsFiltered,
                  data: [],
                };
                vm.videos = [];
                vm.recordsTotal = response.recordsTotal;
                vm.fnCallback(records);
                webTvGlobal.fixDatatableFirefox();
              });
          } else {
            if (
              angular.isDefined(response.data) &&
              angular.isDefined(response.data.message)
            ) {
              $translate("VALIDATIONS." + response.data.message).then(
                function (message) {
                  webTvGlobal.alertDialog(message);
                },
                function () {
                  webTvGlobal.alertDialog(
                    $translate.instant("MESSAGES.alert_xhr_error")
                  );
                }
              );
            } else {
              records = {
                draw: 0,
                recordsTotal: 0,
                recordsFiltered: 0,
                data: 0,
              };
              vm.videos = [];
              vm.recordsTotal = 0;
              vm.fnCallback(records);
              $rootScope.loadingProgress = false;
              webTvGlobal.alertDialog(
                $translate.instant("MESSAGES.alert_xhr_error")
              );
            }
          }
        },
        function (response) {
          if (
            angular.isDefined(response.data) &&
            angular.isDefined(response.data.message)
          ) {
            $translate("VALIDATIONS." + response.data.message).then(
              function (message) {
                webTvGlobal.alertDialog(message);
              },
              function () {
                webTvGlobal.alertDialog(
                  $translate.instant("MESSAGES.alert_xhr_error")
                );
              }
            );
          } else {
            webTvGlobal.alertDialog(
              $translate.instant("MESSAGES.alert_xhr_error")
            );
          }
        }
      );
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.stats.dashboard',
            ['ngSanitize','ui.sortable','ngMaterialDateRangePicker']
        )
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider) {

        $stateProvider
            .state('app.stats_dashboard', {
                url: "/stat/dashboard",
                views: {
                    'content@app': {
                        templateUrl: "app/main/stats/dashboard/stats.dashboard.html",
                        controller: 'StatsDashboardController as vm'
                    }
                }, resolve: {
                    themeList: function (msApi) {
                        return msApi.resolve('stats_theme.list@get');
                    },
                    channelList: function (msApi) {
                        return msApi.resolve('channel.channelChoices@get');
                    },
                    htmlContent: function (htmlContent) {
                        return (htmlContent);
                    },
                    GroupSubscriptionsList: function (msApi) {
                      return msApi.resolve('abonnement_group.list@get');
                    },


                // parametersCanalNamesData: function (msApi) {
                    //     return msApi.resolve('parameters_canal.getNames@get');
                    // }
                }
            });
        msApiProvider.register('abonnement_group.list', [Routing.generate('api_subscription_group_get_groups')]);
        msApiProvider.register('stats_theme.list', [Routing.generate('api_parameters_get_themes_choices_for_select_input', {idToIgnore: ':idToIgnore'}).replace(/%3A/, ":")]);
        msApiProvider.register('channel.channelChoices', [Routing.generate('api_parameters_get_channels_choices_for_select_input')]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('media_video.getUrlListVideo', [Routing.generate('api_media_get_url_list_video')]);
    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*stat)(?=.*dashboard).*$",
                name_module: "stats_dashboard",
                name_angular_module: "app.stats",
                actions: [
                    {"dashboard": ["dashboard_noApiRoute"]}]
            };
            msRights.setPermissions(permissions);
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.stats.dashboard')
        .controller('StatsDashboardController', StatsDashboardController);

    /** @ngInject */
    function StatsDashboardController($injector,$cookies,themeList, $rootScope, htmlContent, webTvGlobal, dateMoisCourantConstant, HelpGlobal, $scope, logo, userManager,GroupSubscriptionsList) {
        var $cookies = $injector.get('$cookies'),
            $sce = $injector.get('$sce'),
            $mdSidenav = $injector.get('$mdSidenav');
            var language = $cookies.get('WEBTV.locale');
        
        var $rootScope = $injector.get("$rootScope"),
          msApi = $injector.get("msApi"),
          $stateParams = $injector.get("$stateParams");
        var vm = this;
        vm.hasPermissionCalendar= userManager.isActionGranted('stats_filter_calendar');
        vm.isFM="";
        vm.isNewStats = false;
        if (window.process.env.isNew_Stats) {
        vm.isNewStats =  window.process.env.isNew_Stats; }
      vm.showCalendar = showCalendar;
      vm.showCalendarRange =false;
      vm.startDate = new Date();
      vm.endDate = new Date();
      vm.endDate.setMonth(vm.endDate.getMonth() + 1);
       vm.changedDate="start";
       vm.previewDate = previewDate;
        vm.nextDate = nextDate;
        vm.changeTheme = changeTheme;
      vm.groups=convertParentToSelectList(GroupSubscriptionsList.data.groups);
        vm.groups_query = ''; 
        //Get cryptext
         var type = $stateParams.type;
        
      $scope.$watch(function() { 
          language = $cookies.get("WEBTV.locale");
          $scope.StatFrame = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/dashboard?lng=" + language+ "&token=" + $cookies.get("authToken"));         
          return $cookies.get('WEBTV.locale');
         }, function(newValue) {  
      });
       
        // WORKAROUND to force validation after mdMinDate change
      $scope.$watch('vm.startDate', function () {
        vm.changedDate="start";

      });
      $scope.$watch('vm.endDate', function () {
        vm.changedDate="end";

      });
        if(logo.text1){
          vm.isFM="blueWhiteTheme";
        }
        vm.showHelp = showHelp;
        $scope.someModelChannel = null;
        vm.query = {
            dateIn: dateMoisCourantConstant.date.currentDateIn,
            dateOut: dateMoisCourantConstant.date.currentDateOut,
            theme: "",
            canal: "",
            range: "1d"
        };
      vm.hasGroupsPermission= userManager.isActionGranted('stats_filter_groups');
      if( vm.hasGroupsPermission){
          vm.query.group= ""
        }
        vm.sortableOptions = {
            items: '>md-card',
            handle: '>md-card-header',
            placeholder: "app",
            connectWith: ".apps-container",
            update: function () {
                var items = [];
                vm.left.forEach(function (item) {
                    items.push(item.id.toString());
                });
                $cookies.put('left', items);
                items = [];
                vm.right.forEach(function (item) {
                    items.push(item.id.toString());
                });
                $cookies.put('right', items);

            }
        };
        vm.dateIn = dateMoisCourantConstant.date.currentDateIn;
        vm.dateOut = dateMoisCourantConstant.date.currentDateOut;
        var themes = webTvGlobal.convertToSelectChoicesFormat(themeList.choices);
        // vm.canals = webTvGlobal.convertToSelectChoicesFormat(parametersCanalNamesData.names);
        vm.theme = "";
        vm.canal = "";
        var dateInchanged = false;
        var dateOutchanged = false;
        vm.htmlContents = htmlContent;
        vm.searchGraph = "";
        vm.left = [];
        vm.right = [];
        vm.trustedHtml = function (plainText) {
            return $sce.trustAsHtml(plainText);
        };
        vm.themeListByChannel = themeListByChannel;
        vm.changeDateIn = changeDateIn;
        vm.changeDateOut = changeDateOut;
        vm.toggleSidenav = toggleSidenav;
        vm.restoreFilter = restoreFilter;
        vm.toggleLeft = toggleLeft;
        vm.confirmDate=confirmDate;
        vm.toggle = toggle;
        init();
        //vm.themeListByChannel();
      function showCalendar() {
       vm.showCalendarRange= !vm.showCalendarRange;

      }
      function convertParentToSelectList(choices) {
        choices.sort(function (a, b) {
          return a.id - b.id;
        });
        return choices;
      }
      function previewDate(type) {
        if(type==="start") {
          vm.startDate = new Date(vm.startDate.setMonth(vm.startDate.getMonth() - 1));
        }else{
          vm.endDate = new Date(vm.endDate.setMonth(vm.endDate.getMonth() - 1));
        }

      }
      function nextDate(type) {
        if(type==="start") {
          vm.startDate = new Date(vm.startDate.setMonth(vm.startDate.getMonth() + 1));
        }else{
          vm.endDate = new Date(vm.endDate.setMonth(vm.endDate.getMonth() + 1));

        }

      }
        function iframeLoadedCallBack() {}
        function changeDateIn() {
            dateInchanged = true;
        }

        /*function isEmpty() {
            return (themes.length === 0);
        }*/

        function changeDateOut() {
            dateOutchanged = true;
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }
        function changeTheme(type,model){
          var res;
          if (angular.isDefined(model)) {
            res = model.substring(model.indexOf('-') + 1, model.length);
            vm.theme=res
          }
        }
        function toggleLeft(sidenavId) {
          if (dateInchanged) {
                vm.query.dateIn = vm.dateIn;
            }
            if (dateOutchanged) {
                vm.query.dateOut = vm.dateOut;
            }
            if (vm.theme && !angular.isUndefined(vm.theme)) {
                vm.query.theme = vm.theme;
            }
            if (vm.canal && !angular.isUndefined(vm.canal)) {
              console.log("defined canal", vm.canal)
                vm.query.canal = vm.canal;
            }
            if (!angular.isUndefined(vm.groups_query)) {
                vm.query.group = vm.groups_query;
            }
            toggleSidenav(sidenavId);
        }
      function confirmDate(){
          vm.query.dateIn = vm.startDate;
          vm.query.dateOut = vm.endDate;
        if (angular.isDefined(vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length))) {
          vm.query.theme = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
        }
        if (angular.isDefined(vm.canal)) {
          vm.query.canal = vm.canal;
        }
        vm.showCalendarRange=false;
      }

        function init() {
            var graphe = [];
            var show = [];
            if (angular.isUndefined($cookies.get('showed'))) {
                $cookies.put('showed', [0, 1, 2, 3, 4, 5, 6, 7, 8]);
            } else {
                var i = 0;
                show = $cookies.get('showed').split(',');
                vm.htmlContents.forEach(function (item) {
                    if (show[i] === "") {
                        item.showed = false;
                    }
                    i++;
                })
            }
            if (angular.isUndefined($cookies.get('left'))) {

                for (var k = 0; k < 4; k++) {
                    vm.left.push(vm.htmlContents[k]);
                }
                $cookies.put('left', "0,1,2,3");
            } else {
                graphe = $cookies.get('left').split(',');
                graphe.forEach(function (i) {
                    vm.left.push(vm.htmlContents[i]);
                });


            }
            if (angular.isUndefined($cookies.get('right'))) {

                for (var j = 4; j < 9; j++) {
                    vm.right.push(vm.htmlContents[j]);
                }
                $cookies.put('right', "4,5,6,7,8");
            } else {
                graphe = $cookies.get('right').split(',');
                graphe.forEach(function (i) {
                    vm.right.push(vm.htmlContents[i]);
                });

            }


        }

        function themeListByChannel(test, model) {
            if (test === "canal")
                vm.canal = model;
            if (test === "canal" && vm.theme !== "") {
                vm.theme = "";
            }


        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "DASHBOARD.dashboard_title";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
            $rootScope.welcome = "";


        }

        function restoreFilter(sidenavId) {


            vm.dateIn = dateMoisCourantConstant.date.currentDateIn;
            vm.dateOut = dateMoisCourantConstant.date.currentDateOut;
            dateInchanged = false;
            dateOutchanged = false;
            vm.theme = "";
            vm.canal = "";
            vm.group = "";
            vm.themeListByChannel();
            vm.query = {
                dateIn: dateMoisCourantConstant.date.currentDateIn,
                dateOut: dateMoisCourantConstant.date.currentDateOut,
                theme: "",
                canal: "",
            };
            if( vm.hasGroupsPermission){
              vm.query.group= ""
            }
            toggleSidenav(sidenavId);
        }

        function toggle(item) {
            var index;
            var show = $cookies.get('showed').split(',');

            if (vm.left.indexOf(item) > -1) {
                index = vm.left.indexOf(item);
                vm.left[index].showed = !(vm.left[index].showed);
                if (vm.left[index].showed) {
                    show[item.id] = item.id.toString();

                } else {
                    show[item.id] = "";
                }
            }
            else if (vm.right.indexOf(item) > -1) {
                index = vm.right.indexOf(item);
                vm.right[index].showed = !(vm.right[index].showed);
                if (vm.right[index].showed) {
                    show[item.id] = item.id.toString();
                } else {
                    show[item.id] = "";
                }
            }
            $cookies.put('showed', show);
        }

        function showHelp(item) {
            var welcome = "welcome_vote_details_stats";
            var text;
            if (item == 0) {
                text = [
                    {
                        texte: "form_attr_Statistique_audience"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 1) {
                text = [
                    {
                        texte: "form_attr_Statistique_duree"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 2) {
                text = [
                    {
                        texte: "form_attr_Statistique_duree_visite"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 3) {
                text = [
                    {
                        texte: "form_attr_Statistique_plus_populaire"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 4) {
                text = [
                    {
                        texte: "form_attr_Statistique_map"
                    }];
            }
            else if (item == 5) {
                text = [
                    {
                        texte: "form_attr_Statistique_os"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 6) {
                text = [
                    {
                        texte: "form_attr_Statistique_navigateur"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 7) {
                text = [
                    {
                        texte: "form_attr_Statistique_referrer"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            else if (item == 8) {
                text = [
                    {
                        texte: "form_attr_Statistique_device"
                    }, {
                        texte: "stat_zoom_message"
                    }];
            }
            HelpGlobal.showHelp(text, welcome);

        }
    }
})();

(function () {
    'use strict';
    /** @ngInject */

    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
    var firstDay = new Date(y, m-1, 1);
    var lastDay = new Date(y, m + 1, 0,23);

    var dateMoisCourantConstant = {
        "date": {
            "currentDateIn": firstDay,
            "currentDateOut": lastDay
        }
    };

    var htmlContent = [

        {
            id: 0,
            name: "SEARCHSTATS.form_attr_Statistique_audience",
            html: '<audience-stats query="vm.query"></audience-stats>',
            showed: true,
            permission : "stats_audience_vod_audience_all"
        },

        {
            id: 1,
            name: "SEARCHSTATS.form_attr_Statistique_duree_visite",
            html: '<duree-visite-stats query="vm.query"></duree-visite-stats>',
            showed: true,
            permission : "stats_engagement_vod_duree_per_visite_all"
        },
        {
            id: 2,
            name: "SEARCHSTATS.form_attr_Statistique_plus_populaire",
            html: '<most-popular-stats query="vm.query"></most-popular-stats>',
            showed: true,
            permission : "stats_engagement_vod_most_popular_all"
        }, {
            id: 3,
            name: "SEARCHSTATS.form_attr_Statistique_map",
            html: '<map-geo-stats query="vm.query"></map-geo-stats>',
            showed: true,
            permission : "stats_geo_vod_geo_per_pays_all"
        },
        {
          id: 4,
          name: "SEARCHSTATS.form_attr_Statistique_duree",
          html: '<duree-stats query="vm.query"></duree-stats>',
          showed: true ,
          permission : "stats_audience_vod_duree_all"
        },
        {
            id: 5,
            name: "SEARCHSTATS.form_attr_Statistique_os",
            html: '<os-stats query="vm.query"></os-stats>',
            showed: true,
            permission : "stats_technologie_vod_os_all"
        },
        {
            id: 6,
            name: "SEARCHSTATS.form_attr_Statistique_navigateur",
            html: '<browser-stats query="vm.query"></browser-stats>',
            showed: true,
            permission : "stats_technologie_vod_browser_all"
        },
        {
            id: 7,
            name: "SEARCHSTATS.form_attr_Statistique_referrer",
            html: '<referrer-stats query="vm.query"></referrer-stats>',
            showed: true,
            permission : "stats_technologie_vod_referrer_all"
        },
        {
            id: 8,
            name: "SEARCHSTATS.form_attr_Statistique_device",
            html: '<device-stats query="vm.query"></device-stats>',
            showed: true,
            permission : "stats_technologie_vod_device_all"
        }
    ];


    angular
        .module('app.stats.dashboard')
        .constant('htmlContent', htmlContent)
        .constant('dateMoisCourantConstant', dateMoisCourantConstant);

})();

(function () {
    'use strict';
    angular
        .module('app.stats.dashboard')
        .directive('compileTemplate', compileTemplate);


    function compileTemplate($compile, $parse) {
        return {
            link: function (scope, element, attr) {
                var parsed = $parse(attr.ngBindHtml);

                function getStringValue() {
                    return (parsed(scope) || '').toString();
                }

                // Recompile if the template changes
                scope.$watch(getStringValue, function () {
                    $compile(element, null, -9999)(scope);  // The -9999 makes it skip directives so that we do not recompile ourselves
                });
            }
        }
    }

})();

(function () {
    "use strict";
  
    angular.module("app.stats.event", []).config(config).run(fetchRights);
  
    /** @ngInject */
    function config($stateProvider, msApiProvider) {
      $stateProvider.state("app.stats_event", {
        url: "/stat/event",
        views: {
          "content@app": {
            templateUrl: "app/main/stats/event/event.template.html",
            controller: "eventStatsController as vm",
          },
        },
        resolve: {
          MediaVideoList: function () {
            return "stats_event.dtableAll@get";
          },
        },
        "actionPermission":"stats_event_all"
      });
    }
  
    function fetchRights(msRights) {
      if (mod === "dev") {
        var permissions = {
          name_module: "stats_event",
          name_angular_module: "app.stats.event",
          actions: [{ event: ["stats_event_all"] }],
        };
        msRights.setPermissions(permissions);
      }
    }
  })();
  
(function () {
    "use strict";
  
    angular
      .module("app.stats.event")
      .controller("eventStatsController", eventStatsController);
  
    /** @ngInject */
    function eventStatsController(
      $rootScope,
      $sce,
      $scope,
      $cookies,
      $injector
    ) {
      var vm = this;
      initHelp();
  
      // functions
            function initHelp() {
                var $rootScope = $injector.get("$rootScope"), msApi = $injector.get("msApi"), $stateParams = $injector.get("$stateParams");
        var language = $cookies.get('WEBTV.locale');
        $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
        $rootScope.titre2 = "PAGESMENUSTITLES.stats_event_pagetitle";
        $rootScope.titre3 = "";
        $rootScope.pageRoute = "";
        setStatsIframe(msApi, $stateParams, language);
      }
            function setStatsIframe(msApi, type, language) {
        if (window.process.env.FO_STATS_URL) {

               vm.eventsStatsIframe = $sce.trustAsResourceUrl("https:" + window.process.env.FO_STATS_URL + "/event?lng=" + language  + "&token=" +$cookies.get("authToken"));
  
        }
      }
    }
  })();
  
(function () {
    'use strict';

    angular
        .module('app.stats.bande.passante',
            ['nvd3', 'mdPickers'
            ]
        )
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.stats_bande_passante', {
            url: "/stat/consumption",
            views: {
                'content@app': {
                    templateUrl: "app/main/stats/bandePassante/stat.bande.passante.html",
                    controller: 'BandePassanteStatsController as vm'
                }
            },
            resolve: {
                RightStatsBandePassante: function (msApi) {
                    return msApi.resolve('stats.right.types@get');
                }
                // parametersCanalNamesData: function (msApi) {
                //     return msApi.resolve('parameters_canal.getNames@get');
                // }
            },
            bodyClass: 'bande-passante',
            "actionPermission":"stats_bande_passante_post_bande_passante"
        });
        $translatePartialLoaderProvider.addPart('app/main/stats/bandePassante');
        // Api
        msApiProvider.register('stats.right.types', [Routing.generate('api_right_stats_get_right_types_stats_bande_passante')]);
        msApiProvider.register('stats.bande.passante', [Routing.generate('api_bande_passante_post_bande_passante')]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*bande_passante).*$",
                name_module: "stats_bande_passante",
                name_angular_module: "app.stats",
                actions: [
                    {"bande.passante": ["post_bande_passante"]}]
            };
            msRights.setPermissions(permissions);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.stats.bande.passante')
        .controller('BandePassanteStatsController', BandePassanteStatsController);

    /** @ngInject */
    function BandePassanteStatsController($rootScope, $scope, $sce, $cookies, userManager) {
        var vm = this;
        $scope.someModel = null;
        $scope.someModelChannel = null;

        initHelp();
        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.stats_pagetitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_consumption_pagetitle";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = '';
            $rootScope.welcome = "";
            
            vm.newBandPassant = $sce.trustAsResourceUrl(
                "https:" +
                window.process.env.FO_STATS_URL +
                "/bp?lng="+ localStorage.getItem("i18nextLng") + 
                "&token="  + $cookies.get("authToken")
            );  
        }
    }
})();

(function () {
  'use strict';
  /** @ngInject */
  function FileConvertSize(aSize){
    aSize = Math.abs(parseInt(aSize, 10));
    var def = [[1, 'octets'], [1024, 'ko'], [1024*1024, 'Mo'], [1024*1024*1024, 'Go'], [1024*1024*1024*1024, 'To']];
    if(aSize > 0)
    {for(var i=0; i<def.length; i++){
      if( aSize<def[i][0])
        return (aSize/def[i-1][0]).toFixed(2)+' '+def[i-1][1];
    }}
    return 0;
  };
  var OptionsStatsBandePassanteGraphe = { year:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#000000'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.consumptions_sum.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    month:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F1'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        duration               : 1,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.consumptions_sum.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%B %Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,

          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%B %Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    days:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F3'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.consumptions_sum.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%d-%m')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,

          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%d-%m-%Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false,

          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    week:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F5'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        duration               : 1,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return d.key;
        },
        y                      : function (d)
        {
          return d.consumptions_sum.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%b %d %B %Y')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,

          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%b %d %B %Y')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }},
    allHours:{
      chart: {
        type                   : 'lineWithFocusChart',
        color                  : ['#2196F4'],
        height                 : 400,
        margin                 : {
          top   : 32,
          right : 32,
          bottom: 64,
          left  : 100
        },
        isArea                 : true,
        useInteractiveGuideline: true,
        duration               : 1,
        clipEdge               : true,
        clipVoronoi            : false,
        interpolate            : 'cardinal',
        showLegend             : false,
        x                      : function (d)
        {
          return +d.key;
        },
        y                      : function (d)
        {
          return +d.consumptions_sum.value;
        },
        xAxis                  : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%H H')(date);
          }
        },
        yAxis                  : {
          showMaxMin: false,

          tickFormat: function (d)
          {
            return FileConvertSize(d);
          }
        },
        x2Axis                 : {
          showMaxMin: false,
          tickFormat: function (d)
          {
            var date = new Date(d);
            return d3.time.format('%H H')(date);
          }
        },
        y2Axis                 : {
          showMaxMin: false
        },
        interactiveLayer       : {
          tooltip: {
            gravity: 's',
            classes: 'gravity-s'
          }
        },
        legend                 : {
          margin    : {
            top   : 8,
            right : 0,
            bottom: 32,
            left  : 0
          },
          rightAlign: false
        }
      }}
  };
  var widget = {"widget1": {
      "ranges": {
        "1h": "STATSCONSUMPTION.hour",
        "1d": "STATSCONSUMPTION.day",
        "1w": "STATSCONSUMPTION.week",
        "1M": "STATSCONSUMPTION.month"
      },
      "title": "STATSCONSUMPTION.title",
      "bigChart": {
      }
    }};
  angular
    .module('app.stats.bande.passante')
    .value('OptionsStatsBandePassanteGraphe', OptionsStatsBandePassanteGraphe)
    .constant('widget',widget);
})();
(function () {
    'use strict';

    angular
        .module('app.stats.acces', ["datatables"])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {

        // State
        $stateProvider
            .state('app.stats_acces', {
                url: "/stat/acces",
                views: {
                    'content@app': {
                        templateUrl: "app/main/stats/acces/stat.acces.html",
                        controller: 'StatsAccesListController as vm'
                    }
                },
                resolve: {
                    users: function (msApi) {
                        return msApi.resolve('profiles_user.list@get');
                    }
                },
                "bodyClass": "acces",
                "actionPermission":"stats_acces_list_acces_action"
            })
            .state('app.stats_acces_detail_modal', {
                url: "/stat/acces/:id/detail",
                views: {
                    'content@app': {
                        templateUrl: "app/main/stats/acces/stat.acces.detail.html",
                        controller: 'StatsAccesListDetailController as vm'
                    }
                },
                "bodyClass": "acces",
                "actionPermission":"stats_acces_detail_action"
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/stats/acces');

        msApiProvider.register('statsAcces.list_by_date_by_user_from_size', [Routing.generate('api_stats_acces_get_list_acces_from_size')]);
        msApiProvider.register('statsAcces.list_detail_from_size', [Routing.generate('api_stats_acces_get_list_acces_detail_from_size')]);
        msApiProvider.register('profiles_user.list', [Routing.generate('api_profiles_get_users_choices_for_select_input')]);


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*stats)(?=.*acces).*$",
                name_module: "stats_acces",
                name_angular_module: "app.stats",
                actions: [
                    {"acces": ["list_acces", "detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.stats.acces')
        .controller('StatsAccesListDetailController', StatsAccesListDetailController);

    /** @ngInject */
    function StatsAccesListDetailController($injector, DTOptionsBuilder, $cookies, DTColumnBuilder, $scope, $stateParams, webTvGlobal, dtable_language) {

        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var $rootScope = $injector.get('$rootScope'),
            $compile = $injector.get('$compile'),
            $filter = $injector.get('$filter'),
            msApi = $injector.get('msApi');
        var filtre = {};
        vm.dtInstance = {};
        var $translate = $filter('translate');

        var headerCallback = function (thead) {
            $compile(angular.element(thead).contents())($scope);
        };

        function ServerSideProcessingCtrl(DTOptionsBuilder, DTColumnBuilder) {

            $rootScope.DTOptionsBuilder = DTOptionsBuilder;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                // or here
                .withDataProp('data')
                .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
                .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('columnDefs', [{targets: 1, width: '72px'}
                ])
                .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
                .withOption('pageLength', parseInt(numberRecords))
                .withOption('scrollY', 'auto')
                .withOption('responsive', true)
                .withOption('headerCallback', headerCallback)
                .withOption('createdRow', function (row) {
                    $compile(angular.element(row).contents())($scope);
                })
                .withPaginationType('full_numbers');
            $rootScope.DtOptions = vm.dtOptions;
            vm.dtColumns = [
                DTColumnBuilder.newColumn('model_id').notSortable().renderWith(function (data) {
                    if (data === null) {
                        return '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                    }
                    else {
                        return '<Any translate=MODULESLIST.' + data.substring(0, data.indexOf('_module')) + '></Any>';
                    }
                }),
                DTColumnBuilder.newColumn('user_id').notSortable().renderWith(function (data) {
                    return angular.isDefined(data) ? data : "";
                }),
                DTColumnBuilder.newColumn(null).notSortable().renderWith(function (data) {
                    if (data === null || !angular.isDefined(data.function)) {
                        return '<Any style="text-transform: capitalize;" translate="MESSAGES.none" md-colors="{color: \'#000000\'}"></Any>';
                    }
                    else {
                        var action = '<Any translate=ACTIONSLIST.' + data.function.substring(0, data.function.indexOf('_action'))+'></Any>';
                        if(angular.isDefined(data.model_info) && data.model_info){
                            action = action + ' ( id: '+data.model_info+')';
                        }
                        return action;
                    }
                }),
                DTColumnBuilder.newColumn('date').notSortable().renderWith(function (data) {
                    $filter('date')(data, "HH:mm:ss"); //date filter
                    return moment(new Date(data)).format($rootScope.defaultTimeFormat);

                })
            ];

        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.stats";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_access";
            //    $rootScope.titre2="PAGESMENUSTITLES.stats_access_detail";

            $rootScope.titre3 = "PAGESMENUSTITLES.stats_access_detail_pageTitle";
            $rootScope.pageRoute = '';
            $rootScope.welcome = "";


        }

        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            filtre = {
                draw: draw,
                start: start,
                length: length,
                id_session: $stateParams.id
            };
            vm.fnCallback = fnCallback;
            searchAccesDetailStatsInAPI(filtre);
        }

        function searchAccesDetailStatsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request("statsAcces.list_detail_from_size@get", filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var videos = response.data;


                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': videos
                        };
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.fnCallback(records);
                        $rootScope.loadingProgress = false;
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                },
                function () {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.fnCallback(records);
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );


        }

        ServerSideProcessingCtrl(DTOptionsBuilder, DTColumnBuilder);


    }

})();


(function () {
    'use strict';

    angular
        .module('app.stats.acces')
        .controller('StatsAccesListController', StatsAccesListController);

    /** @ngInject */
    function StatsAccesListController($injector, $http, users, DTOptionsBuilder,$sce , $cookies, DTColumnBuilder, $scope, webTvGlobal, dtable_language) {
        var $rootScope = $injector.get('$rootScope'),
            $compile = $injector.get('$compile'),
            $state = $injector.get('$state'),
            $filter = $injector.get('$filter'),
            msApi = $injector.get('msApi');
        var vm = this;
        var numberRecords = $cookies.get('numberRecords') || 10;
        var $translate = $filter('translate');
        var filtre = {};
        vm.dtInstance = {};
        vm.empStatsAcces = {};
        vm.empStatsAcces.date = new Date();
        vm.empStatsAcces.users = webTvGlobal.convertToSelectChoicesFormat(users.choices);
        vm.FiltrechangeData = FiltrechangeData;
        vm.showSessionDetail = showSessionDetail;
        
        if (window.process.env.isNewAccessStatistics) {
            vm.isNewAccessStatistics = window.process.env.isNewAccessStatistics;
            vm.newAccessStatsIframe = $sce.trustAsResourceUrl(
                "https:" +
                window.process.env.FO_STATS_URL +
                "/access_statistics?lng="+ localStorage.getItem("i18nextLng") + 
                "&token="  + $cookies.get("authToken")
            );
        }
       

        var headerCallback = function (thead) {
            $compile(angular.element(thead).contents())($scope);
        };

        function ServerSideProcessingCtrl(DTOptionsBuilder, DTColumnBuilder) {
            $rootScope.DTOptionsBuilder = DTOptionsBuilder;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withFnServerData(serverData)
                // or here
                .withDataProp('data')
                .withDOM('rt<"bottom"<"left"<"length"l>><"left"<"info"i><"pagination"p>>>')
                .withLanguage(dtable_language[$cookies.get('WEBTV.locale')])
                .withOption('processing', true)
                .withOption('serverSide', true)
                .withOption('columnDefs', [{targets: 1, width: '72px'}
                ])
                .withOption('lengthMenu', [5, 10, 20, 30, 50, 100])
                .withOption('pageLength', parseInt(numberRecords))
                .withOption('scrollY', 'auto')
                .withOption('responsive', true)
                .withOption('headerCallback', headerCallback)
                .withOption('createdRow', function (row) {
                    $compile(angular.element(row).contents())($scope);
                })
                .withPaginationType('full_numbers');
            $rootScope.DtOptions = vm.dtOptions;
            vm.dtColumns = [
                DTColumnBuilder.newColumn('session_id').notSortable(),
                DTColumnBuilder.newColumn('user_ip').notSortable(),
                DTColumnBuilder.newColumn('user_id').notSortable(),
                DTColumnBuilder.newColumn('date').notSortable().renderWith(function (data) {
                    return (angular.isDefined(data) && data !== null && angular.isDefined(data)) ? moment(data).format($rootScope.defaultDateFormat) + ' ' + moment(data).format('HH:mm:ss') : $translate.instant('MESSAGES.nonef');
                }),
                DTColumnBuilder.newColumn(null).notSortable()
                    .renderWith(function (data) {

                        return '<a tooltips tooltip-template=' + "{{'MESSAGES.action_detail'|translate}}" + ' tooltip-side="bottom" tooltip-speed="fast">' +
                            '<md-button has-permission="stats_acces_detail" class="show-button md-icon-button" ng-click="vm.showSessionDetail(\'' + data.session_id + '\')"' +
                            'aria-label="' + $translate('MESSAGES.action_detail') + '"' + ' > ' +
                            '<md-icon  md-font-icon="icon-eye" class="s18"></md-icon>' +
                            '</md-button>' +
                            '</a>';


                    })
            ];

        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.stats";
            $rootScope.titre2 = "PAGESMENUSTITLES.stats_access";
            $rootScope.titre3 = "PAGESMENUSTITLES.stats_access_pageTitle";
            $rootScope.pageRoute = '';
            $rootScope.welcome = "";


        }


        ServerSideProcessingCtrl(DTOptionsBuilder, DTColumnBuilder);

        //////////////////////////////////////////////////////////
        function serverData(sSource, aoData, fnCallback) {

            //All the parameters you need is in the aoData variable
            var draw = aoData[0].value;
            var start = aoData[3].value;
            var length = aoData[4].value;

            filtre = {
                draw: draw,
                start: start,
                length: length
            };
            vm.fnCallback = fnCallback;
            searchAccesStatsInAPI(filtre);
        }


        function searchAccesStatsInAPI(filtre) {
            $cookies.put('numberRecords', filtre.length);
            msApi.request("statsAcces.list_by_date_by_user_from_size@get", filtre,
                function (response) {
                    var records = {};
                    if (response.code === 200) {
                        var videos = response.data;


                        records = {
                            'draw': response.draw,
                            'recordsTotal': response.recordsTotal,
                            'recordsFiltered': response.recordsFiltered,
                            'data': videos
                        };
                        vm.fnCallback(records);
                        webTvGlobal.fixDatatableFirefox();
                    }
                    else {
                        records = {
                            'draw': 0,
                            'recordsTotal': 0,
                            'recordsFiltered': 0,
                            'data': 0
                        };

                        vm.fnCallback(records);
                        $rootScope.loadingProgress = false;
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                },
                function () {
                    var records = {
                        'draw': 0,
                        'recordsTotal': 0,
                        'recordsFiltered': 0,
                        'data': 0
                    };

                    vm.fnCallback(records);
                    $rootScope.loadingProgress = false;
                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                }
            );


        }

        /**
         * Show Session Details
         * @param session_id
         */
        function showSessionDetail(session_id) {

            $state.go('app.stats_acces_detail_modal', {id: session_id});

        }

        function FiltrechangeData() {
            filtre["user_id"] = vm.empStatsAcces.user;
            filtre["date"] = vm.empStatsAcces.date.getDate();
            searchAccesStatsInAPI(filtre);
        }


    }

})();


(function () {
  "use strict";

  angular.module("app.metaData.list", ["datatables"]).config(config);

  function config($stateProvider) {
    // State
    $stateProvider.state("app.metaData_list", {
      url: "/metaData",
      views: {
        "content@app": {
          templateUrl: "app/main/metaData/list/list.template.html",
          controller: "metaDataListController as vm",
        },
      },

      bodyClass: "e-commerce",
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.metaData.list")
    .controller("metaDataListController", metaDataListController);

  /** @ngInject */
  function metaDataListController($injector, $scope,$cookies) {
    var $cookies = $injector.get('$cookies');
    var myEl = angular.element(document.querySelector("#content"));
    if (angular.isDefined(myEl));
    myEl.removeClass("animate-slide-up");
    var $rootScope = $injector.get("$rootScope");
    var vm = this;
    var $sce = $injector.get("$sce");
    vm.dtInstance = {};
    initHelp();
    $rootScope.rerender = rerender;
    var language = $cookies.get('WEBTV.locale');
    var token = $cookies.get('authToken');
    $scope.metaDataIframe = $sce.trustAsResourceUrl(
      "https:" + window.process.env.URL_metaData+"?lang="+language +"&token=" + token
    );
    
    $scope.$watch(function() { 
      language = $cookies.get('WEBTV.locale');
      token = $cookies.get('authToken');
      $scope.metaDataIframe =  $sce.trustAsResourceUrl("https:"+ window.process.env.URL_metaData + "?lang=" + language +"&token="+token);         
      return $cookies.get('WEBTV.locale');
     }, function(newValue) {  
    });

    /**
     * rerender datatable
     */
    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.metaData_menuTitle";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
    }
    function rerender() {
      if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.export.youtube', [])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.export_youtube', {
                url: "/export/youtube?:state",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/export/youtube/export.template.html',
                        controller: 'YoutubeController as vm'
                    }
                },
                resolve: {
                    YoutubeData: function (msApi) {
                        return msApi.resolve('media_video.getNewYoutube@get');
                    }
                },
                "actionPermission" : "export_video_get_authentication_code_action"

            });
        //Api
        msApiProvider.register('media_video.infoYoutube', [Routing.generate('api_export_get_access_code_redirect')]);
        msApiProvider.register('media_video.exportYoutubeSubmit', [Routing.generate('api_export_post_export_youtube')]);
        msApiProvider.register('media_video.getNewYoutube', [Routing.generate('api_export_get_new_youtube')]);
    }
})();


(function () {
  'use strict';
  angular
    .module('app.export.youtube')
    .controller('YoutubeController', YoutubeController);
  /** @ngInject */
  function YoutubeController(webTvGlobal, YoutubeData, $rootScope, $injector, $cookies) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var msApi = $injector.get('msApi'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state'),
      $stateParams = $injector.get('$stateParams');
    var stateParam = $stateParams.state;///state=([^&]+)/.exec(window.location.href)[1]; // Value is in [1]
    var vm = this;
    vm.submitExportYoutubeForm = submitExportYoutubeForm;
    vm.returnToList = returnToList;
    var youtube = YoutubeData;
    var code = getQueryVariable('code');
    vm.empExportYoutubeForm = {
      title: youtube.title ? youtube.title : null,
      description: youtube.description ? youtube.description : null,
      keyWords: youtube.keyWords ? youtube.keyWords : null,
      categories: youtube.categories ? youtube.categories : null,
      pub: youtube.pub ? youtube.pub : 0,
      src: youtube.src ? youtube.src : null
    };
    // if (code) {
    getInfoYoutube();
    // }
    function getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split('&');
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) === variable) {
          return decodeURIComponent(pair[1]);
        }
      }
    }
    function returnToList() {
      //  $state.go('app.media_video_list_ongoing');
      if(window.name == "Google") {
        window.close();
      }else{
        $state.go('app.media_video_list', {type: "ongoing"});
      }
    }
    /**
     * get info video and categories video youtube
     */
    function getInfoYoutube() {
      msApi.request('media_video.infoYoutube@get', {code: code, state_redirect:stateParam},
        function (response) {
          if (response.code === 200) {
            if (response.video_info) {
              vm.empExportYoutubeForm.title = response.video_info.title;
              vm.empExportYoutubeForm.description = response.video_info.description;
              vm.empExportYoutubeForm.keyWords = response.video_info.keyWords;
              vm.empExportYoutubeForm.src = response.video_info.src;
            }
            if(response.accessToken && response.accessToken.access_token) {
                var expireDate = new Date();
                expireDate.setDate(expireDate.getDate() + 1);
                // Setting a cookie
                $cookies.put('accessTokenYoutube', response.accessToken.access_token, {'expires': expireDate});
            }
            if (response.categories) {
              vm.youtube_categories = response.categories;
            }
          } else if (response.code === 0) {
            webTvGlobal.alertDialog(response.error);
            $state.go('app.media_video_list', {type: "ongoing"});
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }
    /**
     * Send add lives Form
     */
    function submitExportYoutubeForm() {
      var formData = angular.copy(vm.empExportYoutubeForm);
      msApi.request('media_video.exportYoutubeSubmit@save', {"empExportYoutubeForm": formData, "state_redirect":stateParam, "accessTokenYoutube":$cookies.get("accessTokenYoutube")},
        function (response) {
          if (response.code === 200) {
              if(window.name == "Google") {
                  window.close();
              }else{
                  $state.go('app.media_video_list', {type: "ongoing"});
              }
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );
    }
    initHelp();
    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
      $rootScope.titre3 = "EXPORT.page_export_youtube_title";
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.export.dailymotion', [])
        .config(config);


    function config($stateProvider, msApiProvider) {
        // State
        $stateProvider
            .state('app.export_dailymotion_login', {
                url: "/export/dailymotion/:id",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/export/dailymotion/login.template.html',
                        controller: 'DailymotionController as vm'
                    }
                },
                params: {
                    'error_export': ''
                },
                resolve: {
                    CompteData: function (msApi) {
                        return msApi.resolve('media_video.getNewCompte@get');
                    }
                },
                "actionPermission" : "export_video_dailymotion_get_login_action"

            })

            .state('app.export_dailymotion', {
                url: "/export/dailymotionExport/:id/:lang",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/export/dailymotion/export.template.html',
                        controller: 'DailymotionExportController as vm'
                    }
                },
                resolve: {
                    DailymotionData: function (msApi) {
                        return msApi.resolve('media_video.getNewDailymotion@get');
                    },
                    VideoData: function (msApi, $stateParams) {
                        return msApi.resolve('media_video.getVideoDailymotion@get', {'id': $stateParams.id,'lang':$stateParams.lang});
                    }
                },
                "actionPermission" : "export_video_dailymotion_get_login_action"

            });
        //API
        msApiProvider.register('media_video.getNewCompte', [Routing.generate('api_export_dailymotion_get_new_compte')]);
        msApiProvider.register('media_video.loginDailymotionSubmit', [Routing.generate('api_export_dailymotion_post_connect')]);
        msApiProvider.register('media_video.getNewDailymotion', [Routing.generate('api_export_dailymotion_get_new_dailymotion')]);
        msApiProvider.register('media_video.getVideoDailymotion', [Routing.generate('api_export_dailymotion_get_export')]);
        msApiProvider.register('media_video.exportDailymotionSubmit', [Routing.generate('api_export_dailymotion_post_export_dailymotion')]);
    }
})();


(function () {
  'use strict';

  angular
    .module('app.export.dailymotion')
    .controller('DailymotionController', DailymotionController)
    .controller('DailymotionExportController', DailymotionExportController);

  /** @ngInject */
  function DailymotionController(webTvGlobal, CompteData, $stateParams, $rootScope, $injector) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var msApi = $injector.get('msApi'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state');

    var vm = this;


    vm.submitLoginDailymotionForm = submitLoginDailymotionForm;
    vm.error_message = $stateParams.error_export;
    var compte = CompteData;
    vm.empExportCompteForm = {
      title: compte.title ? compte.title : null,
      login: compte.login ? compte.login : null,
      password: compte.password ? compte.password : null
    };
    vm.empExportDailymotionForm = {};
    initHelp();
      $rootScope.compte=compte;
    function initHelp() {

      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.page_export_dailymotion_title";

      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";

    }

    /**
     * Send add lives Form
     */
    function submitLoginDailymotionForm() {

      var formData = angular.copy(vm.empExportCompteForm);
      msApi.request('media_video.loginDailymotionSubmit@save', {"empExportCompteForm": formData},
        function (response) {
          if (response.code === 200) {

              $rootScope.datacompte.logged=true;
              $rootScope.datacompte.data_compte = {
                  username: response.compte.login,
                  password: response.compte.password
              };
            $state.go('app.export_dailymotion', {"id": $stateParams.id});
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );

    }


  }

  function DailymotionExportController(webTvGlobal,$injector, DailymotionData, VideoData, $rootScope) {
    var msApi = $injector.get('msApi'),
      $translate = $injector.get('$translate'),
      $state = $injector.get('$state');

    var vm = this;

    vm.submitExportDailymotionForm = submitExportDailymotionForm;
    initHelp();
      vm.compte=$rootScope.datacompte;
    function initHelp() {

      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.media_video_menuTitle";
      $rootScope.titre3 = "PAGESMENUSTITLES.page_export_dailymotion_title";
      if (angular.isUndefined($rootScope.currentState)) {
        $rootScope.pageRoute = 'app.media_video_list_ongoing';
      }
      else {
        $rootScope.pageRoute = $rootScope.currentState;
      }
      $rootScope.welcome = "";

    }

    if (angular.isDefined(VideoData.video_info)) {
      vm.empExportDailymotionForm = {
        title: VideoData.video_info.title,
        description: VideoData.video_info.description,
        keyWords: VideoData.video_info.keyWords,
        src:  vm.compte.video_info.src,
          idVod: $rootScope.idvid,
        login: vm.compte.data_compte.username,
        password:  vm.compte.data_compte.password
      };
    }
    else {
      vm.empExportDailymotionForm = {
        title: "",
        description: "",
        keyWords: "",
          idVod: "",
        src: "",
        login: "",
        password: ""
      };
    }
    vm.canaux = convertItemsToChoices({
      'news': 'Actu et Politique',
      'people': 'Amis et Famille',
      'animals': 'Animaux',
      'creation': 'Art et Création',
      'auto': 'Auto et Moto',
      'school': 'Campus',
      'shortfilms': 'Cinéma',
      'webcam': 'Expression Libre',
      'tech': 'High-tech et Science',
      'fun': 'Humour',
      'videogames': 'Jeux vidéo',
      'lifestyle': 'Lifestyle',
      'music': 'Musique',
      'sexy': 'Sexy',
      'sport': 'Sports et Extrème',
      'tv': 'TV',
      'travel': 'Voyages'
    });

    function convertItemsToChoices(choices) {
      var converted = Object.keys(choices).map(function (key) {
        return {val: choices[key], option: key};
      });
      converted.sort(function (a, b) {
        return a.val - b.val;
      });
      return converted;
    }

          /**
     * Send add lives Form
     */
    function submitExportDailymotionForm() {
      var formData = angular.copy(vm.empExportDailymotionForm);
        formData.login=vm.compte.data_compte.username;
        formData.password= vm.compte.data_compte.password;
        formData.idVod=$rootScope.idvid;
        formData.src=vm.compte.video_info.src;
      msApi.request('media_video.exportDailymotionSubmit@save', {"empExportDailymotionForm": formData},
        function (response) {
          if (response.code === 200) {
            $state.go('app.media_video_list', {type: "ongoing"});
          } else if (response.message_error) {
            $state.go('app.export_dailymotion_login', {'error_export': response.message_error});
          } else {
            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
          }
        }
      );

    }


  }

})();

(function () {
    'use strict';

    angular
        .module('app.media.video', ['ngJsTree', 'jsTree.directive','app.media.video.access','app.media.video.upload-vod',
          'app.media.video.add', 'app.media.video.edit', 'app.media.video.list', 'app.media.video.reupload-vod', 'app.media.video.choose_thumb','app.media.video.uploadAudio', 'app.interactivity.comments.list', "app.media.video.add_externel", "app.media.video.edit_external",
          "app.media.video.richMedia_new", "app.media.video.montage_new", "app.media.video.questions_quiz", "app.media.video.caption_new"])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('media.video', {
            title: 'Videos',
            translate: 'PAGESMENUSTITLES.media_video_menuTitle',
            icon: 'icon-play-box-outline',
            state: "app.media_video_list({type: 'ongoing'})",
            permission: 'media_video_list_dtable_videos_ongoing',
            weight: 1
        });

        $translatePartialLoaderProvider.addPart('app/main/media/video');


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*media)(?=.*video)|(?=.*dtable)(?=.*video)|(?=.*multi_delete)(?=.*video).*$",
                name_module: "media_video",
                name_angular_module: "app.media.video",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_videos_ongoing", "list_dtable_videos_upcoming", "list_dtable_videos_archived", "list_dtable_videos_offline", "download_video", "delete_video", "multi_delete", "post_enable_push", "post_disable_push", "get_video_url", "get_video_meta_data", "get_list_steps", "get_date_last_montage", "post_toggle"]},
                    {"videoNoModule": ["reupload_no_api", "preview_no_api", "subscribers_no_api", "audio_no_api", "send_mail_no_api", "social_network_embed_no_api", "progressif_download_embed_no_api", "uid_embed_no_api", "permalien_embed_no_api", "mp4_embed_no_api", "embed_no_api", "options_embed_no_api", "contributor_form_no_api", "password_form_no_api", "downloadable_vid_form_no_api", "list_by_contributor_no_api", "transcription_auto_no_api", "transcription_reload_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('app.media.video')
        .directive('isSuperiorToVidDuration', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, mCtrl) {
                    var pattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                    var duration = attr.duration;

                    function myValidation(value) {
                        if (value && pattern.test(value)) {
                            if (value.toSeconds() > duration) mCtrl.$setValidity('isSuperiorToVidDuration', false);
                            else mCtrl.$setValidity('isSuperiorToVidDuration', true);
                        }
                        return value;
                    }

                    mCtrl.$parsers.push(myValidation);

                }
            };
        })
        .directive('isInferiorToStartDuration', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, mCtrl) {
                    var pattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                    var caption = scope.caption;
                    scope.$watch(function () {
                        if (caption.start && caption.end) {
                            if (caption.end.toSeconds() > caption.start.toSeconds()) {
                                mCtrl.$setValidity('isSuperiorToEndDuration', true);
                                mCtrl.$setValidity('isInferiorToStartDuration', true);
                            }
                            mCtrl.$parsers.push(myValidation);
                        }
                    });

                    function myValidation(value) {
                        if (value && pattern.test(value) && pattern.test(caption.start)) {
                            if (value.toSeconds() < caption.start.toSeconds()) {
                                mCtrl.$setValidity('isInferiorToStartDuration', false);
                            }
                            else {
                                mCtrl.$setValidity('isInferiorToStartDuration', true);
                            }
                        }
                        return value;
                    }

                    mCtrl.$parsers.push(myValidation);

                }
            };
        })
        .directive('isSuperiorToEndDuration', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attr, mCtrl) {
                    var pattern = /^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/;
                    var caption = scope.caption;
                    scope.$watch(function () {
                        if (caption.start && caption.end) {
                            if (caption.end.toSeconds() > caption.start.toSeconds()) {
                                mCtrl.$setValidity('isSuperiorToEndDuration', true);
                                mCtrl.$setValidity('isInferiorToStartDuration', true);
                            }
                            mCtrl.$parsers.push(myValidation);
                        }
                    });

                    function myValidation(value) {
                        if (value && pattern.test(value) && pattern.test(caption.end)) {
                            if (value.toSeconds() > caption.end.toSeconds()) {
                                mCtrl.$setValidity('isSuperiorToEndDuration', false);


                            }
                            else {
                                mCtrl.$setValidity('isSuperiorToEndDuration', true);

                            }
                        }
                        return value;
                    }

                    mCtrl.$parsers.push(myValidation);

                }
            };
        })

    ;
})();
(function () {
    'use strict';

    angular
        .module('app.scorm', [])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.scorm', {
            url: '/scorm',
            views: {
                'content@app': {
                    templateUrl: 'app/main/media/scorms/scorm.template.html',
                    controller: 'scormController as vm'

                }
            },
            resolve: {
                urlScorms: function (msApi) {
                    return msApi.resolve('url_scorm.get@get');
                }
            },
            bodyClass: 'dashboard-project',
            "actionPermission": "scorms_noApiRoute_action"
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/media/scorms');

        msApiProvider.register('url_scorm.get', [Routing.generate('api_get_url_scorm_fo')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*scorm).*$",
                name_module: "scorm",
                name_angular_module: "app.scorm",
                actions: [
                    {"scormNoModule": ["scorm_no_api", "edit_scorm_no_api", "edit_source_scorm_no_api", "delete_scorm_no_api", "add_scorm_no_api", "export_scorm_no_api"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.scorm')
        .controller('scormController', scormController);


    /** @ngInject */
    function scormController($sce, urlScorms,$rootScope) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var vm = this;
        initHelp();
        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.scorm_menuTitle";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "";


        }

        vm.urlScormList = $sce.trustAsResourceUrl(urlScorms.url);


    }

})();

(function () {
    'use strict';

    angular
        .module('app.image', [])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.image', {
            url: '/image',
            views: {
                'content@app': {
                    templateUrl: 'app/main/media/images/image.template.html',
                    controller: 'imageController as vm'

                }
            },
            resolve: {
                urlImages: function (msApi) {
                    return msApi.resolve('url_image.get@get');
                }
            },
            bodyClass: 'dashboard-project',
            "actionPermission": "images_noApiRoute_action"
        });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/media/images');

        msApiProvider.register('url_image.get', [Routing.generate('api_get_url_photoprisme_fo')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*photoprism).*$",
                name_module: "image",
                name_angular_module: "app.image",
                actions: [
                    {"scormNoModule": ["photoprism_list_menu"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.image')
        .controller('imageController', imageController);


    /** @ngInject */
    function imageController($sce, urlImages,$rootScope,webTv_msNavigation,$translate,$cookies,$injector) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
       var msApi = $injector.get('msApi');

      myEl.removeClass('animate-slide-up');
        var vm = this;
      vm.language = $translate.preferredLanguage();
      var color = $cookies.get('selectedThemeColor');

      msApi.request('url_image.get@get',{},
        function (response) {
          vm.urlImageList = $sce.trustAsResourceUrl(response.url+'&lang='+vm.language+'&color='+color);
        });
      initHelp();
        function initHelp() {

          if(webTv_msNavigation['media_image']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre2 = "";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre3 = "";
          }
            $rootScope.pageRoute = "";

            $rootScope.welcome = "";


        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.error.404', [])
        .config(config).factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
        return function myExceptionHandler(exception, cause) {
            var $state = $injector.get("$state");
            var $rootScope = $injector.get("$rootScope");
            var msApi = $injector.get("msApi");
            $log.warn(exception, cause);
            var errorObjectLog = {
                "cause": cause,
                "exception": exception.toString(),
                "module": $rootScope.currentState,
                "error_code": "404"
            };
           /* msApi.request('error_404.logError404@save',
                errorObjectLog
            );*/
            // $state.go('app.error_404')

        };
    }]);
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        $stateProvider
            .state('app.error_404', {
                url: "/404",
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.error_404': {
                        templateUrl: 'app/main/error/404/error-404.html',
                        controller: 'Error404Controller as vm'
                    }
                },
                bodyClass: 'error-404'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/error/404');
        msApiProvider.register('error_404.logError404', [Routing.generate('api_log')]);
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.error.404')
        .controller('Error404Controller', Error404Controller);

    function Error404Controller()
    {
    }
})();
(function () {
    'use strict';

    angular
        .module('app.error.500', [])
        .config(config)
        .factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
            return function myExceptionHandler(exception, cause) {
                var $state = $injector.get("$state");
                var $rootScope = $injector.get("$rootScope");
                var msApi = $injector.get("msApi");
                $log.warn(exception, cause);
                var errorObjectLog = {
                    "cause": cause,
                    "exception": exception.toString(),
                    "module": $rootScope.currentState,
                    "error_code": "500"
                };
                msApi.request('error_500.logError500@save',
                    errorObjectLog);
                $state.go('app.error_500')

            };
        }]);


    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        $stateProvider
            .state('app.error_500', {
                url: "/500",
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.error_500': {
                        templateUrl: 'app/main/error/500/error-500.html',
                        controller: 'Error500Controller as vm'
                    }
                },
                bodyClass: 'error-500'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/error/500');


        msApiProvider.register('error_500.logError500', [Routing.generate('api_log')]);
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.error.500')
        .controller('Error500Controller', Error500Controller);

    function Error500Controller()
    {

    }
})();
(function () {
    'use strict';

    angular
        .module('app.error.403', [])
        .config(config).factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
        return function myExceptionHandler(exception, cause) {
            var $state = $injector.get("$state");
            var $rootScope = $injector.get("$rootScope");
            var msApi = $injector.get("msApi");
            $log.warn(exception, cause);
            var errorObjectLog = {
                "cause": cause,
                "exception": exception.toString(),
                "module": $rootScope.currentState,
                "error_code": "403"
            };
            msApi.request('error_403.logError403@save',
                errorObjectLog
            );
            $state.go('app.error_403')

        };
    }]);
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        $stateProvider
            .state('app.error_403', {
                url: "/403",
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.error_403': {
                        templateUrl: 'app/main/error/403/error-403.html',
                        controller: 'Error403Controller as vm'
                    }
                },
                bodyClass: 'error-403'
            });


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/error/403');
        msApiProvider.register('error_403.logError403', [Routing.generate('api_log')]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.error.403')
        .controller('Error403Controller', Error403Controller);

    function Error403Controller($rootScope,$translate)
    {
    	var vm=this;
    	vm.nonAuhtorizedState=function(){
    		if(angular.isDefined($rootScope.nonAuhtorizedState)){
    			return $translate.instant('PAGESMENUSTITLES.'+$rootScope.nonAuhtorizedState.name.replace(/^app\.(.*)$/,'$1')+'_pagetitle');
    		}
    		return "";
    	}
    }
})();
(function () {
  "use strict";

  angular.module("app.chutier.list", ["datatables"]).config(config);

  function config($stateProvider) {
    // State
    $stateProvider.state("app.chutier_list", {
      url: "/chutier",
      views: {
        "content@app": {
          templateUrl: "app/main/chutier/list/list.template.html",
          controller: "chutierListController as vm",
        },
      },

      bodyClass: "e-commerce",
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("app.chutier.list")
    .controller("chutierListController", chutierListController);

  /** @ngInject */
  function chutierListController($injector, $scope,$cookies) {
    var $cookies = $injector.get('$cookies');
    var myEl = angular.element(document.querySelector("#content"));
    if (angular.isDefined(myEl));
    myEl.removeClass("animate-slide-up");
    var $rootScope = $injector.get("$rootScope");
    var vm = this;
    var $sce = $injector.get("$sce");
    vm.dtInstance = {};
    initHelp();
    $rootScope.rerender = rerender;
    var language = $cookies.get('WEBTV.locale');
    var token = $cookies.get('authToken');
    $scope.ChutierIframe = $sce.trustAsResourceUrl(
      "https:" + window.process.env.URL_Chutier+"?lng="+language +"&token=" + token
    );
    
    $scope.$watch(function() { 
      language = $cookies.get('WEBTV.locale');
      token = $cookies.get('authToken');
      $scope.ChutierIframe =  $sce.trustAsResourceUrl("https:"+ window.process.env.URL_Chutier + "?lng=" + language +"&token="+token);         
      return $cookies.get('WEBTV.locale');
     }, function(newValue) {  
    });

    /**
     * rerender datatable
     */
    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.chutier_menuTitle";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
    }
    function rerender() {
      if (angular.isFunction(vm.dtInstance.rerender)) vm.dtInstance.rerender();
    }
  }
})();

(function () {
  'use strict';

  angular
      .module('app.configuration.skinPlayer', [])
      .config(config)
      // .run(fetchRights);

  /** @ngInject */
  function config($stateProvider, msApiProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
      // State for skin player
      $stateProvider.state('app.skin_theme', {
          url: '/skin',
          views: {
              'content@app': {
                  templateUrl: 'app/main/configuration/skinPlayer/skin.template.html',
                  controller: 'ThemePlayerController as vm'
              }
          },
          "bodyClass": "e-commerce",
          "actionPermission": "media_video_skin_player_action"
      });


      // Translation
      $translatePartialLoaderProvider.addPart('app/main/configuration/skinPlayer');
   
      // Register API endpoint for skin URL
      // msApiProvider.register('url_skin_player.get', [Routing.generate('api_media_post_set_default_skin_video')]);

  }

  function fetchRights(msRights) {
      if (mod === 'dev') {
        console.log("mod==>",mod)
          var permissions = {
              pattern: "^(?=.*api)(?=.*skin).*$",
              name_module: "media_video_skin_player",
              name_angular_module: "app.configuration.skinPlayer",
              actions: [
                  {"skinNoModule": ["skin_no_api"]},
                  { "media_video_skin_player": ["view"] }
              ]
          };
          msRights.setPermissions(permissions);
      }
  }

})();

(function () {
    'use strict';

    angular.module('app.configuration.skinPlayer')
    .controller('ThemePlayerController', ThemePlayerController);

    /** @ngInject */
    function ThemePlayerController($injector,$scope, fuseTheming,$translate, $rootScope,$cookies) {
        var myEl = angular.element(document.querySelector('#content'));
          if (angular.isDefined(myEl)) {
            myEl.removeClass('animate-slide-up');
        }
        var $sce = $injector.get('$sce'),
      msApi = $injector.get('msApi'),
      $state = $injector.get('$state'),
      $translate = $injector.get('$translate');

        var vm = this;
      vm.language = $translate.preferredLanguage();
        initHelp();
      $scope.iframeLoadedCallBack = function(){
         console.log('vm.language',vm.language)
        sendPostMessage( vm.language )
      }
    if (window.process.env.isSkinPlayer) {
      vm.isSkinPlayer = window.process.env.isSkinPlayer;
      vm.skinPlayerIframe = $sce.trustAsResourceUrl(
        "https:" +
          window.process.env.URL_SKIN_PLAYER + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")+"&embed=true"
      );
      $scope.$watch(function () {
        vm.skinPlayerIframe = $sce.trustAsResourceUrl(
          "https:" +
            window.process.env.URL_SKIN_PLAYER + "?lang="+ $cookies.get("WEBTV.locale") +  "&token=" + $cookies.get("authToken")+"&embed=true"
        );
      });
    }
    
        function initHelp() {
          $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
          $rootScope.titre2 = "PAGESMENUSTITLES.skin";
            $rootScope.titre3 = "";
            $rootScope.pageRoute = "";

            $rootScope.welcome = "";


        }
        var activeTheme = fuseTheming.themes.active.theme;
        var colors = {
            "primary": activeTheme.primary.color,
            "accent": activeTheme.accent.color,
            "warn": activeTheme.warn.color
        };

    }

})();

(function () {
    'use strict';

    angular
        .module('app.display_options', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.display_options_conf', {
                url: "/configuration/display_options",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/configuration/display_options/display_options.template.html',
                        controller: 'display_optionsController as vm'
                    }
                },
                "bodyClass": "forms",
                "actionPermission" : "param_list_dtable_params_action"
            });
        $translatePartialLoaderProvider.addPart('app/main/configuration/display_options');

    }
})();
(function () {
  'use strict';

  angular
    .module('app.display_options')
    .controller('display_optionsController', display_optionsController);

  /** @ngInject */
  function display_optionsController($mdSidenav, $cookies, $rootScope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.toggleOptionsSidenav = toggleOptionsSidenav;
    vm.change = change;
    vm.changeCheckBox = changeCheckBox;
    vm.changeLength = changeLength;
    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.configuration_menuTitle";
      $rootScope.titre2 = "MESSAGES.display_options";
      $rootScope.titre3 = "";
      $rootScope.pageRoute = "";
      $rootScope.welcome = "";
    }

    vm.mode = $cookies.get('viewMode') || 'simpleList';
    vm.lengthTable = $cookies.get('lengthTable') || 20;
    if ($cookies.get('block1') === 'true')
      vm.block1 = true;
    if ($cookies.get('block2') === 'true')
      vm.block2 = true;
    if ($cookies.get('block3') === 'true')
      vm.block3 = true;
    if ($cookies.get('block4') === 'true')
      vm.block4 = true;

    function changeLength(length) {
      $cookies.put('lengthTable', length);
    }

    function changeCheckBox() {
      $cookies.put('block1', vm.block1);
      $cookies.put('block2', vm.block2);
      $cookies.put('block3', vm.block3);
      $cookies.put('block4', vm.block4);
    }

    function change(mode) {
      $cookies.put('viewMode', mode);
    }

    function toggleOptionsSidenav(navId) {
      $mdSidenav(navId).toggle();
      $rootScope.showStyleLayout = true;
    }
  }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                '720kb.tooltips',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
    'use strict';
    angular
        .module('app.core')
        .service('VideoGlobal', VideoGlobalService);

    /** @ngInject */
    function VideoGlobalService($document, $mdDialog, $rootScope) {
        var vm = this;

        vm.services = {
            showPreviewVideo: showPreviewVideo

        };

        /**
         * Open a new window
         * @param  video : link to open
         * @param  event : link to open
         */
        function showPreviewVideo(params, event, isVisibleOnInternet, isVisibleOnIntranet, isIntranet_Internet) {
            $rootScope.loadingProgress = true;
            $mdDialog.show({
                controller: function (params, $mdDialog, $translate) {
                    var vm = this;

                    vm.event = "modal-preview-video.getPreviewLink@get";
                    vm.params = params;
                    vm.isVisibleOnInternet = isVisibleOnInternet;
                    vm.isVisibleOnIntranet = isVisibleOnIntranet;
                    vm.isIntranet_Internet = angular.isDefined(isIntranet_Internet) ? isIntranet_Internet : '0';
                    vm.closeDialog = closeDialog;
                    if (vm.isVisibleOnInternet && vm.isVisibleOnIntranet)
                        vm.intranet = false;
                    else if (vm.isVisibleOnInternet)
                        vm.intranet = true;
                    else if (vm.isVisibleOnIntranet)
                        vm.intranet = false;

                    /**
                     * Close the dialog
                     */
                    function closeDialog() {
                        $mdDialog.hide();

                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/core/services/videoService/preview-video.modal.html',
                targetEvent: event,
                clickOutsideToClose: true,
                locals: {
                    params: params
                }
            }).then(function () {
                $rootScope.loadingProgress = false;
                $rootScope.$broadcast('VideoList::setInactive');
            }, function () {
                $rootScope.loadingProgress = false;
                $rootScope.$broadcast('VideoList::setInactive');
            });

        }

        return vm.services;
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .service('HelpGlobal', HelpGlobalService);

    /** @ngInject */
    function HelpGlobalService($mdDialog) {
        var vm = this;

        vm.services = {
            showHelp: showHelp

        };

        /**
         * Open a new window
         * @param  params : link to open
         * @param  welcome : link to open
         */
        function showHelp(params, welcome) {
            $mdDialog.show({
                controller: function (params, $mdDialog, $translate) {
                    var vm = this;
                    vm.welcome = welcome;
                    vm.text = params;
                    vm.closeDialog = closeDialog;
                    /**
                     * Close the dialog
                     */
                    function closeDialog() {
                        $mdDialog.hide();

                    }
                },
                controllerAs: 'vm',
                templateUrl: 'app/core/services/helpService/help.modal.html',
                clickOutsideToClose: true,
                locals: {
                    params: params
                }
            }).then(function () {
            }, function () {
            });

        }

        return vm.services;
    }
})();
(function () {
    angular
        .module('app.core')
        .service('swfService', swfObjectService);

    /** @ngInject */
    function swfObjectService() {




            var UNDEF = "undefined",
              OBJECT = "object",
              SHOCKWAVE_FLASH = "Shockwave Flash",
              SHOCKWAVE_FLASH_AX = "ShockwaveFlash.ShockwaveFlash",
              FLASH_MIME_TYPE = "application/x-shockwave-flash",
              EXPRESS_INSTALL_ID = "SWFObjectExprInst",
              ON_READY_STATE_CHANGE = "onreadystatechange",

              win = window,
              doc = document,
              nav = navigator,

              plugin = false,
              domLoadFnArr = [main],
              regObjArr = [],
              objIdArr = [],
              listenersArr = [],
              storedAltContent,
              storedAltContentId,
              storedCallbackFn,
              storedCallbackObj,
              isDomLoaded = false,
              isExpressInstallActive = false,
              dynamicStylesheet,
              dynamicStylesheetMedia,
              autoHideShow = true,

            /* Centralized function for browser feature detection
             - User agent string detection is only used when no good alternative is possible
             - Is executed directly for optimal performance
             */
              ua = function() {
                  var w3cdom = typeof doc.getElementById !== UNDEF && typeof doc.getElementsByTagName !== UNDEF && typeof doc.createElement !== UNDEF,
                    u = nav.userAgent.toLowerCase(),
                    p = nav.platform.toLowerCase(),
                    windows = p ? /win/.test(p) : /win/.test(u),
                    mac = p ? /mac/.test(p) : /mac/.test(u),
                    webkit = /webkit/.test(u) ? parseFloat(u.replace(/^.*webkit\/(\d+(\.\d+)?).*$/, "$1")) : false, // returns either the webkit version or false if not webkit
                    ie = !+"\v1", // feature detection based on Andrea Giammarchi's solution: https://webreflection.blogspot.com/2009/01/32-bytes-to-know-if-your-browser-is-ie.html
                    playerVersion = [0,0,0],
                    d = null;
                  if (typeof nav.plugins !== UNDEF && typeof nav.plugins[SHOCKWAVE_FLASH] === OBJECT) {
                      d = nav.plugins[SHOCKWAVE_FLASH].description;
                      if (d && !(typeof nav.mimeTypes !== UNDEF && nav.mimeTypes[FLASH_MIME_TYPE] && !nav.mimeTypes[FLASH_MIME_TYPE].enabledPlugin)) { // navigator.mimeTypes["application/x-shockwave-flash"].enabledPlugin indicates whether plug-ins are enabled or disabled in Safari 3+
                          plugin = true;
                          ie = false; // cascaded feature detection for Internet Explorer
                          d = d.replace(/^.*\s+(\S+\s+\S+$)/, "$1");
                          playerVersion[0] = parseInt(d.replace(/^(.*)\..*$/, "$1"), 10);
                          playerVersion[1] = parseInt(d.replace(/^.*\.(.*)\s.*$/, "$1"), 10);
                          playerVersion[2] = /[a-zA-Z]/.test(d) ? parseInt(d.replace(/^.*[a-zA-Z]+(.*)$/, "$1"), 10) : 0;
                      }
                  }
                  else if (typeof win.ActiveXObject !== UNDEF) {
                      try {
                          var a = new ActiveXObject(SHOCKWAVE_FLASH_AX);
                          if (a) { // "a" will return null when ActiveX is disabled
                              d = a.GetVariable("$version");
                              if (d) {
                                  ie = true; // cascaded feature detection for Internet Explorer
                                  d = d.split(" ")[1].split(",");
                                  playerVersion = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
                              }
                          }
                      }
                      catch(e) {}
                  }
                  return { w3:w3cdom, pv:playerVersion, wk:webkit, ie:ie, win:windows, mac:mac };
              }(),

            /* Cross-browser onDomLoad
             - Will fire an event as soon as the DOM of a web page is loaded
             - Internet Explorer workaround based on Diego Perini's solution: https://javascript.nwbox.com/IEContentLoaded/
             - Regular onload serves as fallback
             */
              onDomLoad = function() {
                  if (!ua.w3) { return; }
                  if ((typeof doc.readyState !== UNDEF && doc.readyState === "complete") || (typeof doc.readyState === UNDEF && (doc.getElementsByTagName("body")[0] || doc.body))) { // function is fired after onload, e.g. when script is inserted dynamically
                      callDomLoadFunctions();
                  }
                  if (!isDomLoaded) {
                      if (typeof doc.addEventListener !== UNDEF) {
                          doc.addEventListener("DOMContentLoaded", callDomLoadFunctions, false);
                      }
                      if (ua.ie && ua.win) {
                          doc.attachEvent(ON_READY_STATE_CHANGE, function() {
                              if (doc.readyState === "complete") {
                                  doc.detachEvent(ON_READY_STATE_CHANGE, arguments.callee);
                                  callDomLoadFunctions();
                              }
                          });
                          if (win === top) { // if not inside an iframe
                              (function(){
                                  if (isDomLoaded) { return; }
                                  try {
                                      doc.documentElement.doScroll("left");
                                  }
                                  catch(e) {
                                      setTimeout(arguments.callee, 0);
                                      return;
                                  }
                                  callDomLoadFunctions();
                              })();
                          }
                      }
                      if (ua.wk) {
                          (function(){
                              if (isDomLoaded) { return; }
                              if (!/loaded|complete/.test(doc.readyState)) {
                                  setTimeout(arguments.callee, 0);
                                  return;
                              }
                              callDomLoadFunctions();
                          })();
                      }
                      addLoadEvent(callDomLoadFunctions);
                  }
              }();

            function callDomLoadFunctions() {
                if (isDomLoaded) { return; }
                try { // test if we can really add/remove elements to/from the DOM; we don't want to fire it too early
                    var t = doc.getElementsByTagName("body")[0].appendChild(createElement("span"));
                    t.parentNode.removeChild(t);
                }
                catch (e) { return; }
                isDomLoaded = true;
                var dl = domLoadFnArr.length;
                for (var i = 0; i < dl; i++) {
                    domLoadFnArr[i]();
                }
            }

            function addDomLoadEvent(fn) {
                if (isDomLoaded) {
                    fn();
                }
                else {
                    domLoadFnArr[domLoadFnArr.length] = fn; // Array.push() is only available in IE5.5+
                }
            }

            /* Cross-browser onload
             - Based on James Edwards' solution: https://brothercake.com/site/resources/scripts/onload/
             - Will fire an event as soon as a web page including all of its assets are loaded
             */
            function addLoadEvent(fn) {
                if (typeof win.addEventListener !== UNDEF) {
                    win.addEventListener("load", fn, false);
                }
                else if (typeof doc.addEventListener !== UNDEF) {
                    doc.addEventListener("load", fn, false);
                }
                else if (typeof win.attachEvent !== UNDEF) {
                    addListener(win, "onload", fn);
                }
                else if (typeof win.onload === "function") {
                    var fnOld = win.onload;
                    win.onload = function() {
                        fnOld();
                        fn();
                    };
                }
                else {
                    win.onload = fn;
                }
            }

            /* Main function
             - Will preferably execute onDomLoad, otherwise onload (as a fallback)
             */
            function main() {
                if (plugin) {
                    testPlayerVersion();
                }
                else {
                    matchVersions();
                }
            }

            /* Detect the Flash Player version for non-Internet Explorer browsers
             - Detecting the plug-in version via the object element is more precise than using the plugins collection item's description:
             a. Both release and build numbers can be detected
             b. Avoid wrong descriptions by corrupt installers provided by Adobe
             c. Avoid wrong descriptions by multiple Flash Player entries in the plugin Array, caused by incorrect browser imports
             - Disadvantage of this method is that it depends on the availability of the DOM, while the plugins collection is immediately available
             */
            function testPlayerVersion() {
                var b = doc.getElementsByTagName("body")[0];
                var o = createElement(OBJECT);
                o.setAttribute("type", FLASH_MIME_TYPE);
                var t = b.appendChild(o);
                if (t) {
                    var counter = 0;
                    (function(){
                        if (typeof t.GetVariable !== UNDEF) {
                            var d = t.GetVariable("$version");
                            if (d) {
                                d = d.split(" ")[1].split(",");
                                ua.pv = [parseInt(d[0], 10), parseInt(d[1], 10), parseInt(d[2], 10)];
                            }
                        }
                        else if (counter < 10) {
                            counter++;
                            setTimeout(arguments.callee, 10);
                            return;
                        }
                        b.removeChild(o);
                        t = null;
                        matchVersions();
                    })();
                }
                else {
                    matchVersions();
                }
            }

            /* Perform Flash Player and SWF version matching; static publishing only
             */
            function matchVersions() {
                var rl = regObjArr.length;
                if (rl > 0) {
                    for (var i = 0; i < rl; i++) { // for each registered object element
                        var id = regObjArr[i].id;
                        var cb = regObjArr[i].callbackFn;
                        var cbObj = {success:false, id:id};
                        if (ua.pv[0] > 0) {
                            var obj = getElementById(id);
                            if (obj) {
                                if (hasPlayerVersion(regObjArr[i].swfVersion) && !(ua.wk && ua.wk < 312)) { // Flash Player version >= published SWF version: We have found a match!
                                    setVisibility(id, true);
                                    if (cb) {
                                        cbObj.success = true;
                                        cbObj.ref = getObjectById(id);
                                        cb(cbObj);
                                    }
                                }
                                else if (regObjArr[i].expressInstall && canExpressInstall()) { // show the Adobe Express Install dialog if set by the web page author and if supported
                                    var att = {};
                                    att.data = regObjArr[i].expressInstall;
                                    att.width = obj.getAttribute("width") || "0";
                                    att.height = obj.getAttribute("height") || "0";
                                    if (obj.getAttribute("class")) { att.styleclass = obj.getAttribute("class"); }
                                    if (obj.getAttribute("align")) { att.align = obj.getAttribute("align"); }
                                    // parse HTML object param element's name-value pairs
                                    var par = {};
                                    var p = obj.getElementsByTagName("param");
                                    var pl = p.length;
                                    for (var j = 0; j < pl; j++) {
                                        if (p[j].getAttribute("name").toLowerCase() !== "movie") {
                                            par[p[j].getAttribute("name")] = p[j].getAttribute("value");
                                        }
                                    }
                                    showExpressInstall(att, par, id, cb);
                                }
                                else { // Flash Player and SWF version mismatch or an older Webkit engine that ignores the HTML object element's nested param elements: display alternative content instead of SWF
                                    displayAltContent(obj);
                                    if (cb) { cb(cbObj); }
                                }
                            }
                        }
                        else {	// if no Flash Player is installed or the fp version cannot be detected we let the HTML object element do its job (either show a SWF or alternative content)
                            setVisibility(id, true);
                            if (cb) {
                                var o = getObjectById(id); // test whether there is an HTML object element or not
                                if (o && typeof o.SetVariable !== UNDEF) {
                                    cbObj.success = true;
                                    cbObj.ref = o;
                                }
                                cb(cbObj);
                            }
                        }
                    }
                }
            }

            function getObjectById(objectIdStr) {
                var r = null;
                var o = getElementById(objectIdStr);
                if (o && o.nodeName === "OBJECT") {
                    if (typeof o.SetVariable !== UNDEF) {
                        r = o;
                    }
                    else {
                        var n = o.getElementsByTagName(OBJECT)[0];
                        if (n) {
                            r = n;
                        }
                    }
                }
                return r;
            }

            /* Requirements for Adobe Express Install
             - only one instance can be active at a time
             - fp 6.0.65 or higher
             - Win/Mac OS only
             - no Webkit engines older than version 312
             */
            function canExpressInstall() {
                return !isExpressInstallActive && hasPlayerVersion("6.0.65") && (ua.win || ua.mac) && !(ua.wk && ua.wk < 312);
            }

            /* Show the Adobe Express Install dialog
             - Reference: https://www.adobe.com/go/flashpro_player_express_install
             */
            function showExpressInstall(att, par, replaceElemIdStr, callbackFn) {
                isExpressInstallActive = true;
                storedCallbackFn = callbackFn || null;
                storedCallbackObj = {success:false, id:replaceElemIdStr};
                var obj = getElementById(replaceElemIdStr);
                if (obj) {
                    if (obj.nodeName === "OBJECT") { // static publishing
                        storedAltContent = abstractAltContent(obj);
                        storedAltContentId = null;
                    }
                    else { // dynamic publishing
                        storedAltContent = obj;
                        storedAltContentId = replaceElemIdStr;
                    }
                    att.id = EXPRESS_INSTALL_ID;
                    if (typeof att.width === UNDEF || (!/%$/.test(att.width) && parseInt(att.width, 10) < 310)) { att.width = "310"; }
                    if (typeof att.height === UNDEF || (!/%$/.test(att.height) && parseInt(att.height, 10) < 137)) { att.height = "137"; }
                    doc.title = doc.title.slice(0, 47) + " - Flash Player Installation";
                    var pt = ua.ie && ua.win ? "ActiveX" : "PlugIn",
                      fv = "MMredirectURL=" + win.location.toString().replace(/&/g,"%26") + "&MMplayerType=" + pt + "&MMdoctitle=" + doc.title;
                    if (typeof par.flashvars !== UNDEF) {
                        par.flashvars += "&" + fv;
                    }
                    else {
                        par.flashvars = fv;
                    }
                    // IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
                    // because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
                    if (ua.ie && ua.win && obj.readyState !== 4) {
                        var newObj = createElement("div");
                        replaceElemIdStr += "SWFObjectNew";
                        newObj.setAttribute("id", replaceElemIdStr);
                        obj.parentNode.insertBefore(newObj, obj); // insert placeholder div that will be replaced by the object element that loads expressinstall.swf
                        obj.style.display = "none";
                        (function(){
                            if (obj.readyState === 4) {
                                obj.parentNode.removeChild(obj);
                            }
                            else {
                                setTimeout(arguments.callee, 10);
                            }
                        })();
                    }
                    createSWF(att, par, replaceElemIdStr);
                }
            }

            /* Functions to abstract and display alternative content
             */
            function displayAltContent(obj) {
                if (ua.ie && ua.win && obj.readyState !== 4) {
                    // IE only: when a SWF is loading (AND: not available in cache) wait for the readyState of the object element to become 4 before removing it,
                    // because you cannot properly cancel a loading SWF file without breaking browser load references, also obj.onreadystatechange doesn't work
                    var el = createElement("div");
                    obj.parentNode.insertBefore(el, obj); // insert placeholder div that will be replaced by the alternative content
                    el.parentNode.replaceChild(abstractAltContent(obj), el);
                    obj.style.display = "none";
                    (function(){
                        if (obj.readyState === 4) {
                            obj.parentNode.removeChild(obj);
                        }
                        else {
                            setTimeout(arguments.callee, 10);
                        }
                    })();
                }
                else {
                    obj.parentNode.replaceChild(abstractAltContent(obj), obj);
                }
            }

            function abstractAltContent(obj) {
                var ac = createElement("div");
                if (ua.win && ua.ie) {
                    ac.innerHTML = obj.innerHTML;
                }
                else {
                    var nestedObj = obj.getElementsByTagName(OBJECT)[0];
                    if (nestedObj) {
                        var c = nestedObj.childNodes;
                        if (c) {
                            var cl = c.length;
                            for (var i = 0; i < cl; i++) {
                                if (!(c[i].nodeType === 1 && c[i].nodeName === "PARAM") && !(c[i].nodeType === 8)) {
                                    ac.appendChild(c[i].cloneNode(true));
                                }
                            }
                        }
                    }
                }
                return ac;
            }

            /* Cross-browser dynamic SWF creation
             */
            function createSWF(attObj, parObj, id) {
                var r, el = getElementById(id);
                if (ua.wk && ua.wk < 312) { return r; }
                if (el) {
                    if (typeof attObj.id === UNDEF) { // if no 'id' is defined for the object element, it will inherit the 'id' from the alternative content
                        attObj.id = id;
                    }
                    if (ua.ie && ua.win) { // Internet Explorer + the HTML object element + W3C DOM methods do not combine: fall back to outerHTML
                        var att = "";
                        for (var i in attObj) {
                            if (attObj[i] !== Object.prototype[i]) { // filter out prototype additions from other potential libraries
                                if (i.toLowerCase() === "data") {
                                    parObj.movie = attObj[i];
                                }
                                else if (i.toLowerCase() === "styleclass") { // 'class' is an ECMA4 reserved keyword
                                    att += ' class="' + attObj[i] + '"';
                                }
                                else if (i.toLowerCase() !== "classid") {
                                    att += ' ' + i + '="' + attObj[i] + '"';
                                }
                            }
                        }
                        var par = "";
                        for (var j in parObj) {
                            if (parObj[j] !== Object.prototype[j]) { // filter out prototype additions from other potential libraries
                                par += '<param name="' + j + '" value="' + parObj[j] + '" />';
                            }
                        }
                        el.outerHTML = '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000"' + att + '>' + par + '</object>';
                        objIdArr[objIdArr.length] = attObj.id; // stored to fix object 'leaks' on unload (dynamic publishing only)
                        r = getElementById(attObj.id);
                    }
                    else { // well-behaving browsers
                        var o = createElement(OBJECT);
                        o.setAttribute("type", FLASH_MIME_TYPE);
                        for (var m in attObj) {
                            if (attObj[m] !== Object.prototype[m]) { // filter out prototype additions from other potential libraries
                                if (m.toLowerCase() === "styleclass") { // 'class' is an ECMA4 reserved keyword
                                    o.setAttribute("class", attObj[m]);
                                }
                                else if (m.toLowerCase() !== "classid") { // filter out IE specific attribute
                                    o.setAttribute(m, attObj[m]);
                                }
                            }
                        }
                        for (var n in parObj) {
                            if (parObj[n] !== Object.prototype[n] && n.toLowerCase() !== "movie") { // filter out prototype additions from other potential libraries and IE specific param element
                                createObjParam(o, n, parObj[n]);
                            }
                        }
                        el.parentNode.replaceChild(o, el);
                        r = o;
                    }
                }
                return r;
            }

            function createObjParam(el, pName, pValue) {
                var p = createElement("param");
                p.setAttribute("name", pName);
                p.setAttribute("value", pValue);
                el.appendChild(p);
            }

            /* Cross-browser SWF removal
             - Especially needed to safely and completely remove a SWF in Internet Explorer
             */
            function removeSWF(id) {
                var obj = getElementById(id);
                if (obj && obj.nodeName === "OBJECT") {
                    if (ua.ie && ua.win) {
                        obj.style.display = "none";
                        (function(){
                            if (obj.readyState === 4) {
                                removeObjectInIE(id);
                            }
                            else {
                                setTimeout(arguments.callee, 10);
                            }
                        })();
                    }
                    else {
                        obj.parentNode.removeChild(obj);
                    }
                }
            }

            function removeObjectInIE(id) {
                var obj = getElementById(id);
                if (obj) {
                    for (var i in obj) {
                        if (typeof obj[i] === "function") {
                            obj[i] = null;
                        }
                    }
                    obj.parentNode.removeChild(obj);
                }
            }

            /* Functions to optimize JavaScript compression
             */
            function getElementById(id) {
                var el = null;
                try {
                    el = doc.getElementById(id);
                }
                catch (e) {}
                return el;
            }

            function createElement(el) {
                return doc.createElement(el);
            }

            /* Updated attachEvent function for Internet Explorer
             - Stores attachEvent information in an Array, so on unload the detachEvent functions can be called to avoid memory leaks
             */
            function addListener(target, eventType, fn) {
                target.attachEvent(eventType, fn);
                listenersArr[listenersArr.length] = [target, eventType, fn];
            }

            /* Flash Player and SWF content version matching
             */
            function hasPlayerVersion(rv) {
                var pv = ua.pv, v = rv.split(".");
                v[0] = parseInt(v[0], 10);
                v[1] = parseInt(v[1], 10) || 0; // supports short notation, e.g. "9" instead of "9.0.0"
                v[2] = parseInt(v[2], 10) || 0;
                return (pv[0] > v[0] || (pv[0] === v[0] && pv[1] > v[1]) || (pv[0] === v[0] && pv[1] === v[1] && pv[2] >= v[2])) ? true : false;
            }

            /* Cross-browser dynamic CSS creation
             - Based on Bobby van der Sluis' solution: https://www.bobbyvandersluis.com/articles/dynamicCSS.php
             */
            function createCSS(sel, decl, media, newStyle) {
                if (ua.ie && ua.mac) { return; }
                var h = doc.getElementsByTagName("head")[0];
                if (!h) { return; } // to also support badly authored HTML pages that lack a head element
                var m = (media && typeof media === "string") ? media : "screen";
                if (newStyle) {
                    dynamicStylesheet = null;
                    dynamicStylesheetMedia = null;
                }
                if (!dynamicStylesheet || dynamicStylesheetMedia !== m) {
                    // create dynamic stylesheet + get a global reference to it
                    var s = createElement("style");
                    s.setAttribute("type", "text/css");
                    s.setAttribute("media", m);
                    dynamicStylesheet = h.appendChild(s);
                    if (ua.ie && ua.win && typeof doc.styleSheets !== UNDEF && doc.styleSheets.length > 0) {
                        dynamicStylesheet = doc.styleSheets[doc.styleSheets.length - 1];
                    }
                    dynamicStylesheetMedia = m;
                }
                // add style rule
                if (ua.ie && ua.win) {
                    if (dynamicStylesheet && typeof dynamicStylesheet.addRule === OBJECT) {
                        dynamicStylesheet.addRule(sel, decl);
                    }
                }
                else {
                    if (dynamicStylesheet && typeof doc.createTextNode !== UNDEF) {
                        dynamicStylesheet.appendChild(doc.createTextNode(sel + " {" + decl + "}"));
                    }
                }
            }

            function setVisibility(id, isVisible) {
                if (!autoHideShow) { return; }
                var v = isVisible ? "visible" : "hidden";
                if (isDomLoaded && getElementById(id)) {
                    getElementById(id).style.visibility = v;
                }
                else {
                    createCSS("#" + id, "visibility:" + v);
                }
            }

            /* Filter to avoid XSS attacks
             */
            function urlEncodeIfNecessary(s) {
                var regex = /[\\\"<>\.;]/;
                var hasBadChars = regex.exec(s) !== null;
                return hasBadChars && typeof encodeURIComponent !== UNDEF ? encodeURIComponent(s) : s;
            }

            /* Release memory to avoid memory leaks caused by closures, fix hanging audio/video threads and force open sockets/NetConnections to disconnect (Internet Explorer only)
             */
            var cleanup = function() {
                if (ua.ie && ua.win) {
                    window.attachEvent("onunload", function() {
                        // remove listeners to avoid memory leaks
                        var ll = listenersArr.length;
                        for (var i = 0; i < ll; i++) {
                            listenersArr[i][0].detachEvent(listenersArr[i][1], listenersArr[i][2]);
                        }
                        // cleanup dynamically embedded objects to fix audio/video threads and force open sockets and NetConnections to disconnect
                        var il = objIdArr.length;
                        for (var j = 0; j < il; j++) {
                            removeSWF(objIdArr[j]);
                        }
                        // cleanup library's main closures to avoid memory leaks
                        for (var k in ua) {
                            ua[k] = null;
                        }
                        ua = null;
                        for (var l in swfobject) {
                            swfobject[l] = null;
                        }
                        swfobject = null;
                    });
                }
            }();

            return {
                /* Public API
                 - Reference: https://code.google.com/p/swfobject/wiki/documentation
                 */
                registerObject: function(objectIdStr, swfVersionStr, xiSwfUrlStr, callbackFn) {
                    if (ua.w3 && objectIdStr && swfVersionStr) {
                        var regObj = {};
                        regObj.id = objectIdStr;
                        regObj.swfVersion = swfVersionStr;
                        regObj.expressInstall = xiSwfUrlStr;
                        regObj.callbackFn = callbackFn;
                        regObjArr[regObjArr.length] = regObj;
                        setVisibility(objectIdStr, false);
                    }
                    else if (callbackFn) {
                        callbackFn({success:false, id:objectIdStr});
                    }
                },

                getObjectById: function(objectIdStr) {
                    if (ua.w3) {
                        return getObjectById(objectIdStr);
                    }
                },

                embedSWF: function(swfUrlStr, replaceElemIdStr, widthStr, heightStr, swfVersionStr, xiSwfUrlStr, flashvarsObj, parObj, attObj, callbackFn) {
                    var callbackObj = {success:false, id:replaceElemIdStr};
                    if (ua.w3 && !(ua.wk && ua.wk < 312) && swfUrlStr && replaceElemIdStr && widthStr && heightStr && swfVersionStr) {
                        setVisibility(replaceElemIdStr, false);
                        addDomLoadEvent(function() {
                            widthStr += ""; // auto-convert to string
                            heightStr += "";
                            var att = {};
                            if (attObj && typeof attObj === OBJECT) {
                                for (var i in attObj) { // copy object to avoid the use of references, because web authors often reuse attObj for multiple SWFs
                                    att[i] = attObj[i];
                                }
                            }
                            att.data = swfUrlStr;
                            att.width = widthStr;
                            att.height = heightStr;
                            var par = {};
                            if (parObj && typeof parObj === OBJECT) {
                                for (var j in parObj) { // copy object to avoid the use of references, because web authors often reuse parObj for multiple SWFs
                                    par[j] = parObj[j];
                                }
                            }
                            if (flashvarsObj && typeof flashvarsObj === OBJECT) {
                                for (var k in flashvarsObj) { // copy object to avoid the use of references, because web authors often reuse flashvarsObj for multiple SWFs
                                    if (typeof par.flashvars !== UNDEF) {
                                        par.flashvars += "&" + k + "=" + flashvarsObj[k];
                                    }
                                    else {
                                        par.flashvars = k + "=" + flashvarsObj[k];
                                    }
                                }
                            }
                            if (hasPlayerVersion(swfVersionStr)) { // create SWF
                                var obj = createSWF(att, par, replaceElemIdStr);
                                if (att.id === replaceElemIdStr) {
                                    setVisibility(replaceElemIdStr, true);
                                }
                                callbackObj.success = true;
                                callbackObj.ref = obj;
                            }
                            else if (xiSwfUrlStr && canExpressInstall()) { // show Adobe Express Install
                                att.data = xiSwfUrlStr;
                                showExpressInstall(att, par, replaceElemIdStr, callbackFn);
                                return;
                            }
                            else { // show alternative content
                                setVisibility(replaceElemIdStr, true);
                            }
                            if (callbackFn) { callbackFn(callbackObj); }
                        });
                    }
                    else if (callbackFn) { callbackFn(callbackObj);	}
                },

                switchOffAutoHideShow: function() {
                    autoHideShow = false;
                },

                ua: ua,

                getFlashPlayerVersion: function() {
                    return { major:ua.pv[0], minor:ua.pv[1], release:ua.pv[2] };
                },

                hasFlashPlayerVersion: hasPlayerVersion,

                createSWF: function(attObj, parObj, replaceElemIdStr) {
                    if (ua.w3) {
                        return createSWF(attObj, parObj, replaceElemIdStr);
                    }
                    else {
                        return undefined;
                    }
                },

                showExpressInstall: function(att, par, replaceElemIdStr, callbackFn) {
                    if (ua.w3 && canExpressInstall()) {
                        showExpressInstall(att, par, replaceElemIdStr, callbackFn);
                    }
                },

                removeSWF: function(objElemIdStr) {
                    if (ua.w3) {
                        removeSWF(objElemIdStr);
                    }
                },

                createCSS: function(selStr, declStr, mediaStr, newStyleBoolean) {
                    if (ua.w3) {
                        createCSS(selStr, declStr, mediaStr, newStyleBoolean);
                    }
                },

                addDomLoadEvent: addDomLoadEvent,

                addLoadEvent: addLoadEvent,

                getQueryParamValue: function(param) {
                    var q = doc.location.search || doc.location.hash;
                    if (q) {
                        if (/\?/.test(q)) { q = q.split("?")[1]; } // strip question mark
                        if (param === null) {
                            return urlEncodeIfNecessary(q);
                        }
                        var pairs = q.split("&");
                        for (var i = 0; i < pairs.length; i++) {
                            if (pairs[i].substring(0, pairs[i].indexOf("=")) === param) {
                                return urlEncodeIfNecessary(pairs[i].substring((pairs[i].indexOf("=") + 1)));
                            }
                        }
                    }
                    return "";
                },

                // For internal usage only
                expressInstallCallback: function() {
                    if (isExpressInstallActive) {
                        var obj = getElementById(EXPRESS_INSTALL_ID);
                        if (obj && storedAltContent) {
                            obj.parentNode.replaceChild(storedAltContent, obj);
                            if (storedAltContentId) {
                                setVisibility(storedAltContentId, true);
                                if (ua.ie && ua.win) { storedAltContent.style.display = "block"; }
                            }
                            if (storedCallbackFn) { storedCallbackFn(storedCallbackObj); }
                        }
                        isExpressInstallActive = false;
                    }
                }
            };



    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.core')
    .directive('whenScrolledPlaylist', whenScrolledPlaylist);

  /** @ngInject */
  function whenScrolledPlaylist()
  {
      return {
          restrict: 'A',
          scope : {
            "onScroll" : "&whenScrolledPlaylist"
          },
        link: function (scope, element, attrs) {
          var raw = element[0];
          element.bind("wheel", function() {
            var  bottomOfWindow = raw.scrollTop + raw.offsetHeight > raw.scrollHeight;
            if (bottomOfWindow) {
                  return  scope.onScroll();
                }
          });
        }
      };
  }
})();



(function ()
{
  'use strict';


  var myApp = angular
    .module('app.core');

  /** @ngInject */
  myApp.directive('onErrorSrc', function() {
    return {
      link: function(scope, element, attrs) {
        element.bind('error', function() {
          if (attrs.src != attrs.onErrorSrc) {
            var imgEl=attrs.$$element.context;
            var width= imgEl.width;
            var heightCalc=(width* 9)/16 ;
            var height = heightCalc + "px";
            imgEl.style.height=height;
            attrs.$set('src', attrs.onErrorSrc);
          }
        });
      }
    }
  });

})();



(function ()
{
  'use strict';


  var myApp = angular
    .module('app.core');

  /** @ngInject */
  myApp.directive('onResizeEl', function ($window) {
    return function (scope, element) {
      function handleResponsiveHeight(){
        scope.style = function () {
          return {
            'height': ((element.context.width * 9)/16 ) + 'px',
          };
        };
        scope.$apply();
      }
      var w = angular.element($window);
       handleResponsiveHeight();
      w.bind('resize', function () {
        handleResponsiveHeight();
      });
    }
  })

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function () {
    'use strict';

    function config(msApiProvider) {


        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_group_by_themes') + "/:list";
        msApiProvider.register('msThemes.getThemesByChannelAndParent', [themesByChannelsAndParent, {list: '@list'}]);
    }

    /** @ngInject */
    function themesListController($scope, webTvGlobal, msApi, $mdSelect, $rootScope) {
        var vm = this;
        vm.loadThemes = loadThemes;
        vm.closeSelect = closeSelect;
        vm.hide = false;
        vm.showLabel = $scope.showLabel;
        vm.required = $scope.required;
        vm.multi = $scope.multi;
        vm.hasCategories = $scope.hasCategories;
        vm.categories = $scope.allThemes;
        vm.isGV=$rootScope.isGV;
console.log("$rootScope.isGV",$rootScope.isGV)
        var defaultSelected=$scope.ngModel && (angular.isUndefined(vm.hasCategories )  || !vm.hasCategories )? $scope.ngModel.map(Number) : $scope.hasCategories ? $scope.ngModel:  [];
         vm.selectedtheme=[]
         vm.selectedCategory=""
        vm.ngModel=$scope.ngModel;
      vm.ngDisabled=$scope.ngDisabled;
         vm.themes = [];
         if(   vm.hasCategories ==='true'){
           vm.themes=vm.categories
         }
        var listThemes = "";

      if(angular.isUndefined($scope.allThemes))
        {
            msApi.request('msThemes.getThemesByChannelAndParent@get',
                function (res) {
                    listThemes = res.channels;
                    if (listThemes.length === 0){
                        vm.hide = true;
                    }
                  vm.loadThemes();
                });
        }else
        {
            listThemes = $scope.allThemes.channels;
            if (listThemes.length === 0){
                vm.hide = true;
            }
          vm.loadThemes();
        }
        function closeSelect() {
          $mdSelect.hide();
        }
        function loadThemes() {
            if ($scope.type === "canal" && $scope.theme !== "") {
                $scope.theme = "";
            }
            if ((vm.multi === false) || $scope.multiTitle )
                vm.themes = webTvGlobal.loadSelectListThemes(listThemes, $scope.canal);
            else vm.themes = webTvGlobal.loadSelectListThemes(listThemes, 0);
          selectAllTheme();
        }

      function  selectAllTheme() {
        var list = [];
        vm.themes.map(function(theme,index){
          if (Object.keys(theme.themes).length === 0) {
            list.push({ id: theme.id, title: theme.title });
          }

          if (Object.keys(theme.themes).length > 0) {
            theme.themes.map(function(child) {
              var themeId=theme.id+ "-"+ child.id
              list.push({ id: child.id, title: child.title, group: theme.title});
              if (child.themes.length > 0) {
                child.themes.map( function(grandChild, index) {
                  list.push({
                    id: grandChild.id,
                    title: grandChild.title,
                    group: theme.title + '/' + child.title,
                  });
                });
              }
            });
          }
        });
        vm.themes=list;
        console.log("vm.themes",vm.themes)
        if(vm.hasCategories ) {
          var existCategory = list.filter(function(theme){return defaultSelected===theme.id});
          if(existCategory && existCategory.length>0){
            vm.selectedCategory=existCategory[0].id
          }

        }else{
          vm.selectedtheme = list.filter(function(theme){return defaultSelected.includes(theme.id)});
        }

      }
        vm.selectAllTest = function() {

            if(document.querySelectorAll('.class-none-options .md-checkbox-enabled[selected]')){
              document.querySelectorAll('.class-none-options .md-checkbox-enabled[selected]').forEach(function(element) {
                element.removeAttribute("selected");
                element.setAttribute("aria-selected",false);
              })
            }
            vm.ngModel=[];
            $scope.ngModel=[];
            $scope.theme =[];
            $mdSelect.hide();
        };
    }

    angular.module('app.core.themesBootstrap', ['app.core', 'ui.select', 'ngSanitize'])
        .config(config);

    angular.module('app.core.themesBootstrap')
        .directive('msThemesBootstrap', function () {
            return {
                scope: {
                    allThemes: '=allThemes',
                    theme: '=?theme',
                    canal: '=canal',
                    type: '=type',
                    multi: '=multi',
                    hasCategories: '=hasCategories',
                    multiTitle: '=multiTitle',
                    ngModel: '=ngModel',
                    ngChange: '&',
                    disabled: '=disabled',
                    showLabel: '@',
                    required: '@'
                },
                controller: 'themesListController',
                controllerAs: 'vm',
                restrict: 'E',
                link: function ($scope, element, attrs) {
                },
                templateUrl: 'app/core/directives/ms-themes-bootstrap/ms-themes-bootstrap.html'
            };
        })
        .controller('themesListController', themesListController);


})();

(function () {
    'use strict';

    function config(msApiProvider) {


        var themesByChannelsAndParent = Routing.generate('api_parameters_get_channels_group_by_themes') + "/:list";
        msApiProvider.register('msThemes.getThemesByChannelAndParent', [themesByChannelsAndParent, {list: '@list'}]);
    }

    /** @ngInject */
    function themesListControllerDirective($scope, webTvGlobal, msApi, $mdSelect,$rootScope) {
        var vm = this;

        vm.loadThemes = loadThemes;
        vm.closeSelect = closeSelect;
        vm.hide = false;
        vm.showLabel = $scope.showLabel;
        vm.multi = $scope.multi;
        vm.ngModel=$scope.ngModel;
        vm.ngDisabled=$scope.ngDisabled;

        $scope.$on('themes', function(event, args){
            $scope.themes=args.themes;
        });
        var listThemes = "";
        if(angular.isUndefined($scope.allThemes))
        {
            msApi.request('msThemes.getThemesByChannelAndParent@get',
                function (res) {
                    listThemes = res.channels;
                    $rootScope.listThemes=listThemes;
                    if (listThemes.length === 0){
                        vm.hide = true;
                    }
                  vm.loadThemes();
                });
        }else
        {
            listThemes = $scope.allThemes.channels;
            $rootScope.listThemes=listThemes;
            if (listThemes.length === 0){
                vm.hide = true;
            }
          vm.loadThemes();
        }
        function closeSelect() {
          $mdSelect.hide();
        }
        function loadThemes() {
            if ($scope.type === "canal" && $scope.theme !== "") {
                $scope.theme = "";
            }
            if ((vm.multi === false) || $scope.multiTitle )
                $scope.themes = webTvGlobal.loadSelectListThemes(listThemes, $scope.canal);
            else $scope.themes = webTvGlobal.loadSelectListThemes(listThemes, 0);

        }

        vm.selectAllTest = function() {

            if(document.querySelectorAll('.class-none-options .md-checkbox-enabled[selected]')){
              document.querySelectorAll('.class-none-options .md-checkbox-enabled[selected]').forEach(function(element) {
                element.removeAttribute("selected");
                element.setAttribute("aria-selected",false);
              })
            }
            vm.ngModel=[];
            $scope.ngModel=[];
            $scope.theme =[];
            $mdSelect.hide();
        };
    }

    angular.module('app.core.themes', ["app.core"])
        .config(config);

    angular.module('app.core.themes')
        .directive('msOption', msOption)
        .directive('msThemes', function () {
            return {
                scope: {
                    allThemes: '=allThemes',
                    theme: '=?theme',
                    canal: '=canal',
                    type: '=type',
                    multi: '=multi',
                    multiTitle: '=multiTitle',
                    ngModel: '=ngModel',
                    ngChange: '&',
                    disabled: '=disabled',
                    showLabel: '@'
                },
                controller: 'themesListControllerDirective',
                controllerAs: 'vm',
                restrict: 'E',
                link: function ($scope, element, attrs) {
                },
                templateUrl: 'app/core/directives/ms-themes/ms-themes.html'
            };
        })
        .controller('themesListControllerDirective', themesListControllerDirective);

    function msOption($compile) {
        return {
            replace: true,
            scope: {
                collection: '=',
                canal: '='
            },
            restrict: "E",
            link: function (scope, element, attrs) {
                var i = 1;
                var htmSubscriptionGroup = "";
                var sousGroupe = function (value, index, test) {
                    if (angular.isArray(value.themes)) {
                        index = index + 1;
                        var val = scope.canal + '-' + value.id;
                        if (test) {
                            var size = index * 20;
                            var sizePX = size + 'px';
                            htmSubscriptionGroup += "<md-option style='padding-left: "+sizePX+"'  value=" + val + " >" + value.title + "</md-option>";

                        }

                        else htmSubscriptionGroup += "<md-option style='font-weight: bold;'  value=" + val + " >" + value.title + "</md-option>";
                        angular.forEach(value.themes, function (value) {
                            sousGroupe(value, index, true);
                        });
                    }

                };
                angular.forEach(scope.collection, function (value) {
                    sousGroupe(value, 1);
                    if (i === Object.keys(scope.collection).length) {
                        element.append(htmSubscriptionGroup);
                        $compile(element.contents())(scope);
                    }
                    i++;
                });


            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout,$state) {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;
        vm.testShowHide = false;
        vm.twice = false ;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;
        vm.setStep = setStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isCurrent = isCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation) {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form) {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form) {
            var step = {
                element: element,
                scope: scope,
                form: form,
                stepNumber: scope.step || (vm.steps.length + 1),
                stepTitle: scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b) {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps() {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm() {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function () {
                // Reset all the steps
                for (var x = 0; x < vm.steps.length; x++) {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        function setStep(stepNumber) {
            vm.twice = false;
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            // Update the current step number


            if (vm.orientation === 'horizontal') {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++) {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[stepNumber - 1].element.show();
            }
            else if (vm.orientation === 'vertical') {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++) {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                    vm.steps[j].element.find('.icon')[0].classList.replace("icon-check-circle","icon-checkbox-blank-circle-outline");
                }


                if (isStepCurrent(stepNumber) && vm.testShowHide === false) {

                    vm.steps[stepNumber - 1].element.find('.ms-stepper-step-content').hide();
                    vm.steps[stepNumber - 1].element.find('.icon')[0].classList.replace("icon-check-circle","icon-checkbox-blank-circle-outline");
                    vm.testShowHide = true;
                    vm.twice = true;

                }
                else {

                    vm.steps[stepNumber - 1].element.find('.ms-stepper-step-content').show();
                    vm.steps[stepNumber - 1].element.find('.icon')[0].classList.replace("icon-checkbox-blank-circle-outline","icon-check-circle");
                    vm.testShowHide = false;
                }
                // Show the current step content

            }
            vm.currentStepNumber = stepNumber;
            if($state.current.name == "app.media_video_edit"){
              try{
                var height = document.querySelector("#empMediaVideoForm_description").scrollHeight;
                document.querySelector("#empMediaVideoForm_description").style.height=height+"px";
              }catch(e)
              {

              }
            }

        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if (vm.orientation === 'horizontal') {
                // Hide all steps
                for (var i = 0; i < vm.steps.length; i++) {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
                // vm.steps[vm.currentStepNumber - 1].element.find('.icon')[0].classList.replace("icon-checkbox-blank-circle-outline","icon-check-circle");
            }
            else if (vm.orientation === 'vertical') {
                // Hide all step content
                for (var j = 0; j < vm.steps.length; j++) {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.icon')[0].classList.replace("icon-checkbox-blank-circle-outline","icon-check-circle");
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();

            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber) {
            // If the step we are about to go
            // is hidden, bail...
            if (isStepHidden(stepNumber)) {
                return;
            }
            vm.setStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep() {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s >= 1; s--) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep() {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for (var s = stepNumber; s <= vm.steps.length; s++) {
                if (!isStepHidden(s)) {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep() {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep() {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep() {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep() {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        function isCurrent(stepNumber) {

            var i, j;
            for (i = 0; i < 10000; i++) {
                j+=1;
            }

            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            var disabled = false;

            for (var i = 1; i < stepNumber; i++) {
                if (!isStepValid(i)) {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step) {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber) {
            // If the stepNumber is not a valid step number, bail...
            if (!isStepNumberValid(stepNumber)) {
                return null;
            }

            // If the step is optional, always return true
            if (isStepOptional(stepNumber)) {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber) {

            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid() {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective() {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msHorizontalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            compile: function (tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout) {
        return {
            restrict: 'A',
            scope: {},
            require: ['form', 'msVerticalStepper'],
            priority: 1001,
            controller: 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function () {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective() {
        return {
            restrict: 'E',
            require: ['form', '^msVerticalStepper'],
            priority: 1000,
            scope: {
                step: '=?',
                stepTitle: '=?',
                stepTitleTranslate: '=?',
                optionalStep: '=?',
                hideStep: '=?'
            },
            transclude: true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile: function (tElement) {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls) {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    if (scope.step === "1" || scope.step === 1) {
                        iElement.find('.icon')[0].classList.replace("icon-checkbox-blank-circle-outline","icon-check-circle");
                        iElement.find('.ms-stepper-step-content').show();
                    } else {
                        iElement.find('.ms-stepper-step-content').hide();
                    }
                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msShowElementConfigDisplay', msShowElementConfigDisplay);

    /** @ngInject */
    function msShowElementConfigDisplay() {
        return {
            restrict: 'E',
            scope: {
                componentItem: '=',
                vm: '=',
                componentKey: "@",
                keyTranslate: "@"
            },
            templateUrl: 'app/core/directives/ms-show-element-config-display/ms-show-element-config-display.html',
            link: function (scope, iElement) {
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

            // Methods
            this.config = config;

            //////////

            /**
             * Extend default configuration with the given one
             *
             * @param configuration
             */
            function config(configuration) {
                defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
            }

            /**
             * Service
             */
            this.$get = function () {
                var service = {
                    getConfig: getConfig
                };

                return service;

                //////////

                /**
                 * Return the config
                 */
                function getConfig() {
                    return defaultConfiguration;
                }
            };
        }
        /**
         * display toolbar on scroll
         *
         */
        function displayToolbar(event) {
            var menuMobile = document.querySelector(".ms-navigation-horizontal.navigation-horizontal-mobile")
            var toolbar=document.getElementById("toolbar")
            var currentScrollPos = event.target.scrollTop;

            if (menuMobile) {
                menuMobile.style.paddingTop = '';
            }
                if ( currentScrollPos <=  98) {
                if(toolbar){
                    toolbar.style.display = "block";
                    toolbar.style.opacity = "1";
                    toolbar.style.transition = "all 2s linear";
                }
            } else {
                    if (menuMobile) {
                        menuMobile.style.minHeight = 'initial'
                    }
                if (window.innerWidth <= 1279) {
                    document.getElementById("toolbar-navigation-container").style.minHeight = 'initial'
                    if (menuMobile) {
                        menuMobile.style.minHeight = 'initial'
                        menuMobile.style.paddingTop = '76px';
                    }
                }
                if(toolbar) {
                    toolbar.style.display = "none";
                    toolbar.style.opacity = "0";
                }
            }

        }
        /** @ngInject */
        function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig,video) {
            return {
                restrict: 'AE',
                compile: function (tElement) {
                    // Do not replace scrollbars if
                    // 'disableCustomScrollbars' config enabled
                    var ps = {};
                    if (fuseConfig.getConfig('disableCustomScrollbars')) {
                        return;
                    }

                    // Do not replace scrollbars on mobile devices
                    // if 'disableCustomScrollbarsOnMobile' config enabled
                    if (fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile()) {
                        return;
                    }

                    // Add class
                    tElement.addClass('ms-scroll');

                    return function postLink(scope, iElement, iAttrs) {
                        var options = {};

                        // If options supplied, evaluate the given
                        // value. This is because we don't want to
                        // have an isolated scope but still be able
                        // to use scope variables.
                        // We don't want an isolated scope because
                        // we should be able to use this everywhere
                        // especially with other directives
                        if (iAttrs.msScroll) {
                            options = scope.$eval(iAttrs.msScroll);
                        }
                        // Extend the given config with the ones from provider
                        options = angular.extend({}, msScrollConfig.getConfig(), options);

                        // Initialize the scrollbar
                        $timeout(function () {
                            ps = new PerfectScrollbar(iElement[0], options);
                        }, 0);

                        // Update the scrollbar on element mouseenter
                        iElement.on('mouseenter', updateScrollbar);

                        iElement.on('scroll', function (event) {
                           if(video.isNew){
                               displayToolbar(event)
                           }
                        });
                        // iElement.on('resize', function(event){console.log('resize-----------');displayToolbar(event)});
                        // Watch scrollHeight and update
                        // the scrollbar if it changes
                        /* scope.$watch(function ()
                         {
                             console.log("---------scrollHeight-------");
                             return iElement.prop('scrollHeight');
                         }, function (current, old)
                         {
                             if ( angular.isUndefined(current) || angular.equals(current, old) )
                             {
                                 return;
                             }

                             updateScrollbar();
                         });

                         // Watch scrollWidth and update
                         // the scrollbar if it changes
                         scope.$watch(function ()
                         {
                             console.log("---------scrollWidth-------");
                             return iElement.prop('scrollWidth');
                         }, function (current, old)
                         {
                             if ( angular.isUndefined(current) || angular.equals(current, old) )
                             {
                                 return;
                             }

                             updateScrollbar();
                         });*/



                        /**
                         * Update the scrollbar
                         */
                        function updateScrollbar() {
                            ps.update(iElement[0]);
                        }

                        // Cleanup on destroy
                        scope.$on('$destroy', function () {
                            iElement.off('mouseenter');
                            ps.destroy(iElement[0]);
                        });
                    };
                }
            };
        }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem2(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }
        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            return;
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for (var p = 0; p < parts.length; p++) {
                var id = parts[p];

                for (var i = 0; i < item.length; i++) {
                    if (item[i]._id === id) {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if (item[i]._path === path) {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent) {
            // If parent not provided, sort the root items
            if (!parent) {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for (var i = 0; i < parent.length; i++) {
                var children = parent[i].children;

                if (children.length > 1) {
                    children.sort(_byWeight);
                }

                if (children.length > 0) {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */

        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts) {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if (parts.length === 1) {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for (var i = 0; i < parts.length; i++) {
                var _id = parts[i],
                    createParent = true;

                for (var p = 0; p < parent.length; p++) {
                    if (parent[p]._id === _id) {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if (createParent) {
                    var item = {
                        _id: _id,
                        _path: parts.join('.'),
                        title: _id,
                        weight: 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y) {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item) {
            var uisref = '';

            if (angular.isDefined(item.state)) {
                uisref = item.state;

                if (angular.isDefined(item.stateParams) && angular.isObject(item.stateParams)) {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function () {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem: saveItem,
                saveItem2: saveItem2,
                deleteItem: deleteItem,
                sort: sortByWeight,
                clearNavigation: clearNavigation,
                setActiveItem: setActiveItem,
                getActiveItem: getActiveItem,
                getNavigation: getNavigation,
                getFlatNavigation: getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded: setFolded,
                getFolded: getFolded,
                setFoldedOpen: setFoldedOpen,
                getFoldedOpen: getFoldedOpen,
                toggleFolded: toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation() {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if (navigationScope) {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope) {
                activeItem = {
                    node: node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem() {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root) {
                if (root) {
                    for (var i = 0; i < navigation.length; i++) {
                        if (navigation[i]._id === root) {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root) {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope) {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status) {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded() {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status) {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen() {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded() {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation) {
                var flatNav = [];

                for (var x = 0; x < navigation.length; x++) {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if (navigation[x].children.length > 0) {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
      function MsNavigationController(msApi, $scope,video, msNavigationService,$state, $cookies, $mdMedia,$rootScope,webTvGlobal) {
        var vm = this;
        var parameters = webTvGlobal.$constant().webTvParameterBag();
        var originatorEv;
        // Data
        if ($scope.root) {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else {
            vm.navigation = msNavigationService.getNavigation();
        }
        if($cookies.get('layoutStyle')==="horizontalNavigation" && (($cookies.get('layoutMode')==="boxed" && !$mdMedia('(max-width: 960px)')) || ($cookies.get('layoutMode')!=="boxed" && $mdMedia('(min-width: 961px)') && $mdMedia('(max-width: 1700px)')))) {//boxed and (tablet or desktop)
            var item_more = {
                children: [],
                icon: "icon-chevron-double-right",
                title: "list",
                position: "right",
                translate: "PAGESMENUSTITLES.media_comments_list_menuTitle",
                _id: "more",
                _path: "more"
            };
            item_more.children = vm.navigation.slice(6, vm.navigation.length);
            vm.navigation.splice(6, 0, item_more);
            vm.navigation.splice(7, vm.navigation.length);
        }
        vm.isNavigationNew=false;
        if(video.isNew){
          vm.isNavigationNew=true;
        }
        if (angular.isUndefined(parameters['app.client.name'])) {
            msApi.request('parametersBagLogin.app@get', function (res) {
                if (angular.isDefined(res.bag)) {
                    parameters = res.bag;
                    vm.url_tv_show = parameters.url_tv;
                }
            });
        }else {
            vm.url_tv_show = parameters.url_tv;
        }
        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.openMenu = openMenu;
        vm.goToUrlMedias = goToUrlMedias;
        vm.clickMenu = clickMenu;
        vm.redirectTv = function(){
            return vm.url_tv_show;
        };
      function clickMenu(event){
       alert("ggggggggggggg")
      };

        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Sort the navigation before doing anything else
            msNavigationService.sort();

        }

      // $(".ng-scope").click(function () {
      //   var div = $('.scrollable');
      //   var win = $(window).height();
      //   var scro = $('.scrollable ul').height()
      //   if(scro >= 816 ){
      //     div.animate({
      //       scrollTop: div[0].scrollHeight
      //     }, 1000);
      //   }
      // });

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }
        function goToUrlMedias(item,route) {
            var navigationNode = null;
            if ($scope.root) {
                vm.navigation = msNavigationService.getNavigation($scope.root);
            }
            else {
                vm.navigation = msNavigationService.getNavigation();
            }

            if ( vm.navigation) {
                vm.navigation.forEach(function(navigation){
                    if(navigation._id.indexOf(item)>-1){
                        $state.go(route)
                        navigationNode = navigation;
                    }
                })

            }
            if(navigationNode){
               setTimeout(function(){
                   msNavigationService.setActiveItem({_id : navigationNode._id,
                       _path: navigationNode._path}, $scope);
                   var externNode=true

                   $rootScope.$broadcast('msNavigation::clearActive',externNode);
               },500)

            }


        }



    }

    /** @ngInject */
    function msNavigationDirective( msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                folded: '=',
                root: '@'
            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);


                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope,video, $element, $animate, $state, msNavigationService, userManager) {
        var vm = this;
        // Data
        vm.element = $element;
        vm.node = angular.copy($scope.node);
        var hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        var animateHeightClass = 'animate-height';
        vm.isNavigationNew=false;
        if(video.isNew){
          vm.isNavigationNew=true;
        }
        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;

        init();

        vm.returnHomePage = function(){
            if(document.getElementById('iframe_list')){
                document.getElementById('iframe_list').contentWindow.postMessage({
                    info: "redirectHomepage",
                }, "*")
            }
            if(document.getElementById('iframe_podcast')){
                document.getElementById('iframe_podcast').contentWindow.postMessage({
                    info: "redirectHomepage",
                }, "*")
            }
            if(document.getElementById('iframe_playlist')){
                document.getElementById('iframe_playlist').contentWindow.postMessage({
                    info: "redirectHomepage",
                }, "*")
            }
        }
        /**
         * Initialize
         */
        function init() {

            var node = angular.copy(vm.node);
            // Setup the initial values

            // Has children?
            hasChildren = node.children.length > 0;


            // Is collapsable?
            if (!hasChildren) {
                vm.collapsable = false;
            }
            else {
                vm.collapsable = !!(angular.isUndefined(node.collapsable) || typeof node.collapsable !== 'boolean' || node.collapsable === true);
            }

            // Is collapsed?
            if (!vm.collapsable) {
                vm.collapsed = false;
            }
            else {
                vm.collapsed = !!(angular.isUndefined(node.collapsed) || typeof node.collapsed !== 'boolean' || node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if (node.state === $state.current.name || $state.includes(node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(node.stateParams) && angular.isDefined($state.params) && !angular.equals(node.stateParams, $state.params)) {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Expand if the current scope is collapsable and is collapsed
                if (vm.collapsable && vm.collapsed) {
                    $scope.$evalAsync(function () {
                        vm.collapsed = false;
                    });
                }
            });

           /* $scope.$evalAsync(function () {
                isHidden();
            });*/

        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed() {
            if (vm.collapsed) {
                vm.expand();
            }
            else {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse() {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                // vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height': height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height': ''
                        });

                        // Clear collapsing class from the node
                        // vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                //$scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand() {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position': 'absolute',
                'visibility': 'hidden',
                'display': 'block',
                'height': 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position': '',
                'visibility': '',
                'display': '',
                'height': ''
            });

            $scope.$evalAsync(function () {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height': '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    animateHeightClass
                ).then(
                    function () {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

            });
        }


        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden() {
            var found;
            var is_show = false;
            if (angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden)) {
                    if(vm.node.hidden())
                    {
                        msNavigationService.deleteItem(vm.node._path, $scope);
                    }
                return vm.node.hidden();
            }
            else if (vm.node.children.length > 0) {
                for (var i = 0; i < vm.node.children.length; i++) {
                    if (angular.isDefined(vm.node.children[i].permission)) {
                        if (vm.node.children[i].permission === "core_super_admin") {
                            if (userManager.isSuperAdmin()) found = true;
                            else found = false;
                        } else {
                            if (vm.node.children[i].uisref !== "")
                                found = userManager.isActionGranted(vm.node.children[i].permission);
                            else
                                found = userManager.isModuleGranted(vm.node.children[i].permission);
                        }
                        is_show = !is_show ? found : is_show;
                    }
                }
                if(!is_show)
                {
                    msNavigationService.deleteItem(vm.node._path, $scope);
                }
                return !is_show;

            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller: 'MsNavigationNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // Add group class if it's a group
                    if (MsNavigationNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective() {
        return {
            restrict: 'A',
            require: '^msNavigationNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl) {
                    // If the item is collapsable...
                    if (MsNavigationNodeCtrl.collapsable) {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService) {
        return {
            restrict: 'E',
            scope: {
                root: '@',
                pathActive: '@'

            },
            controller: 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude: true,
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope) {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService) {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        var hasChildren = undefined;
        vm.group = undefined;


        //////////

        init();

        /**
         * Initialize
         */
        function init() {
            // Setup the initial values

            // Is active
            vm.isActive = false;
            vm.pathActive = $scope.pathActive;
            // Has children?
            hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if (vm.node.state === $state.current.name || $state.includes(vm.node.state)) {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                    return;
                }
                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function () {
                // Mark as active if has children
                if (hasChildren) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function (event,externNode ) {
                if (!hasChildren && !externNode) {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if (activeItem) {
                    activePathParts = activeItem.node._path.split('.');
                    vm.pathActive = activePathParts[0];
                }

                // Test for active path
                if (activePathParts.indexOf(vm.node._id) > -1) {
                    $scope.$evalAsync(function () {
                        vm.isActive = true;
                    });
                }
                else {
                    $scope.$evalAsync(function () {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function () {
                if (vm.node.state === $state.current.name || vm.node.stateList === $state.current.name || $state.includes(vm.node.state)) {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if (angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params)) {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);
                    angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');

                  // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }


    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective() {
        return {
            restrict: 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller: 'MsNavigationHorizontalNodeController as vm',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    // Add custom classes

                    // Add group class if it's a group
                    if (MsNavigationHorizontalNodeCtrl.group) {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia) {
        return {
            restrict: 'A',
            require: '^msNavigationHorizontalNode',
            compile: function (tElement) {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl) {
                    iElement.on('click', onClick);

                    function onClick() {

                        if ((!iElement[0] || !iElement[0].querySelector(".icon-chevron-right")) || $mdMedia('gt-md')) {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function () {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function () {
    'use strict';

    /** @ngInject */
    function config(msApiProvider) {

        msApiProvider.register('multilangue.getUrlExport', [Routing.generate('api_media_get_video_url') + "/:id", {id: '@id'}]);
        msApiProvider.register('multilangue.editLang', [Routing.generate('api_media_edit_lang_video')]);
        msApiProvider.register('multilangue.deleteLang', [Routing.generate('api_media_delete_lang_video')]);


    }

    angular.module('app.core.multilangue', ["app.core"])
        .config(config);
})();
(function ()
{
    'use strict';
    angular.module('app.core.multilangue')

    .directive('msMultilangueMenu', function () {
        return {
            scope: {
                text: "@text",
                video: "=video",
                render: "=render"
            },
            controller: 'multilangueMenuController',
            controllerAs: 'vm',
            restrict: 'E',
            link: function ($scope, element, attrs) {
            },
            templateUrl: 'app/core/directives/ms-multilangue-menu/ms-multilangue-menu.html'
        };
    });

})();

(function ()
{
    'use strict';
    /** @ngInject */
function multilangueMenuController(webTvGlobal, $translate, msApi, $state, $scope, VideoGlobal, $mdDialog, $document, $rootScope) {
    var vm = this;

    vm.viewMedia = viewMedia;
    vm.deleteLanguage = deleteLanguage;
    vm.editLanguage = editLanguage;
    vm.editVideoFile = editVideoFile;
    vm.showEmbed = showEmbed;
    vm.openMenu = openMenu;
    vm.deleteLanguageConfirm = deleteLanguageConfirm;
    vm.text = $scope.text;
    var originatorEv;


    function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
    }

    function viewMedia() {

        VideoGlobal.showPreviewVideo({id: $scope.video.id, langVod: vm.text});
    }

    function deleteLanguageConfirm(ev) {
        $translate([
            "MESSAGES.dialog_confirm_delete",
            "MESSAGES.dialog_cancel",
            "MESSAGES.dialog_will_be_deleted",
            "EVENTLIST.delete_language_msg",
            "EVENTLIST.delete_event_aria_label",
            "LANGUAGES.Names." + vm.text])
            .then(function (translatedValues) {
                var confirm = $mdDialog.confirm()
                    .title(translatedValues['EVENTLIST.delete_language_msg'])
                    .htmlContent(translatedValues['LANGUAGES.Names.' + vm.text] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                    .ariaLabel(translatedValues['EVENTLIST.delete_event_aria_label'])
                    .targetEvent(ev)
                    .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                    .cancel(translatedValues['MESSAGES.dialog_cancel']);

                $mdDialog.show(confirm).then(function () {

                    deleteLanguage($scope.video.id, vm.text);


                }, function () {

                });
            });
    }

    function deleteLanguage(videoId, lang) {

        $rootScope.loadingProgress = true;
        msApi.request('multilangue.deleteLang@save', {video_id: videoId, lang: lang},
            function (response) {
                $rootScope.loadingProgress = false;
                if (response.code === 200) {
                    $translate([
                        "EVENTLIST.dialog_alert_delete_title",
                        "EVENTLIST.dialog_alert_delete_description",
                        "EVENTLIST.dialog_alert_delete_close",
                        "LANGUAGES.Names." + lang
                    ])
                        .then(function (translatedValues) {
                            webTvGlobal.$toast().showSimple(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                            $scope.render();

                        });

                }
                else {
                    $translate([
                        "EVENTLIST.dialog_alert_delete_error_title",
                        "EVENTLIST.dialog_alert_delete_error_description",
                        "EVENTLIST.dialog_alert_delete_close"
                    ])
                        .then(function (translatedValues) {

                            $mdDialog
                                .show(alert)
                                .finally(function () {
                                    alert = undefined;
                                });
                        });

                }
            }
        );


    }

    function editLanguage(ev) {
        $mdDialog.show({
            controller: 'editLanguageModalController',
            controllerAs: 'vm',
            templateUrl: 'app/core/directives/ms-multilangue-menu/edit-language.modal.html',
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                lang: vm.text,
                video: $scope.video,
                render: $scope.render
            }
        })
    }

    function editVideoFile() {
        $state.go('app.multilangue_video_reupload', {'id': $scope.video.id, 'lang': vm.text});
    }

    function showEmbed(ev) {
        vm.spinner = false;
        msApi.request(
            'multilangue.getUrlExport@get',
            {
                id: $scope.video.id,
                lang: vm.text
            },
            function (res) {
                vm.spinner = true;
                $mdDialog.show({
                    controller: 'embedModalController',
                    controllerAs: 'vm',
                    templateUrl: 'app/core/directives/ms-multilangue-menu/embed.modal.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        video: res.video
                    }
                }).then(function () {
                    $rootScope.$broadcast('VideoList::setInactive');
                }, function () {
                    $rootScope.$broadcast('VideoList::setInactive');
                });
            }, function (response) {
                vm.spinner = true;
                if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                    $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                        webTvGlobal.alertDialog(message);
                    }, function () {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                }
                else {

                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                }
            }
        ).then(function () {
        });
    }
}

function editLanguageModalController(msApi, webTvGlobal, $mdDialog, lang, video, $filter) {
    var vm = this;
    vm.language = '';
    vm.closeDialog = closeDialog;
    vm.sendLanguage = sendLanguage;

    function closeDialog() {
        $mdDialog.hide();

    }

    function sendLanguage(ev) {
        msApi.request(
            'multilangue.editLang@save',
            {
                video_id: video.id,
                lang: lang,
                lang_new: vm.language
            },
            function (res) {
                if (res.code === 200) {
                }
                else {

                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                }
            });
        $mdDialog.hide();
    }

    vm.languageChoices = webTvGlobal.convertToSelectChoicesFormat(
        (function (languages, data) {
            for (var i = 0; i < data.length; i++) {
                var has_lang = $filter('filter')(video.medias, {lang: data[i]}, true);
                if (has_lang.length === 0) {
                    languages[data[i]] = data[i];
                }
            }
            return languages;
        })({}, webTvGlobal.$constant().languagesList())
    );
}

function embedModalController($mdDialog, video) {
    var vm = this;
    vm.spinner = true;
    vm.video = video;
    vm.title = vm.video.title;
    vm.link_embed = vm.video.link_embed;
    vm.link_permalien = vm.video.link;
    vm.show_cdn_url = vm.video.show_cdn_url;
    vm.cdn_web = vm.show_cdn_url;
    if (vm.show_cdn_url === 1) {
        vm.link_embed = vm.video.link_cdn_web;
        vm.link_permalien = vm.video.link_cdn_web;
        vm.cdn_web = true;
    }
    vm.export_facebook = "https://www.facebook.com/sharer/sharer.php?u=" + vm.video.link_to_player;
    vm.export_twitter = "https://twitter.com/share?text=test+2&url=" + vm.video.link_embed;
    vm.export_linkedin = "https://www.linkedin.com/shareArticle?mini=true&url=" + vm.video.link_embed;
    vm.options = "";

    vm.checkOptionFunction = checkOptionFunction;
    vm.closeDialog = closeDialog;
    vm.checkOptionCDNFunction = checkOptionCDNFunction;

    function checkOptionCDNFunction() {
        if (vm.cdn_web) {
            vm.link_embed = vm.video.link_cdn_web + vm.options;
            vm.link_permalien = vm.video.link_cdn_web + vm.options;
        } else {
            vm.link_embed = vm.video.link_embed + vm.options;
            vm.link_permalien = vm.video.link + vm.options;
        }
    }

    function checkOptionFunction(valueCheck, option) {
        if (valueCheck) {
            if (vm.options === "") {
                vm.options = "?" + option + "=1";
            } else {
                vm.options += "&" + option + "=1";
            }
        } else {
            if (vm.options.indexOf("?" + option + "=1") !== -1) {
                vm.options = vm.options.replace("?" + option + "=1", "");
                var index = vm.options.indexOf("&");
                if (index !== -1)
                    vm.options = vm.options.replace("&", "?");
            } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
                vm.options = vm.options.replace("&" + option + "=1", "");
            }
        }
        vm.link_embed = vm.video.link_embed + vm.options;
        vm.link_permalien = vm.video.link + vm.options;
    }

    function closeDialog() {
        $mdDialog.hide();
    }

}

angular
    .module('app.core.multilangue')
    .controller('multilangueMenuController', multilangueMenuController)
    .controller('editLanguageModalController', editLanguageModalController)
    .controller('embedModalController', embedModalController);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;
        vm.isWhiteColor=function(){
            return vm.modelCtrl.$viewValue === "ms-custom-white-bg";
        };
        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                
                if(vm.modelCtrl.$viewValue==="ms-custom-white-bg"){
                    palette='custom';
                    hue='0';
                }
                else{
                    var color = vm.modelCtrl.$viewValue.split('-');
                    if ( color.length >= 5 )
                    {
                        palette = color[1] + '-' + color[2];
                        hue = color[3];
                    }
                    else
                    {
                        palette = color[1];
                        hue = color[2];
                    }
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            if(palette==="custom"){
                 vm.selectedColor = {
                    palette     : "custom",
                    hue         : "0",
                    class       : 'ms-custom-white-bg',
                    bgColorValue: "rgb(255,255,255)",
                    fgColorValue: "rgb(0,0,0)"
                };
            }
            else{
                vm.selectedColor = {
                    palette     : palette,
                    hue         : hue,
                    class       : 'md-' + palette + '-' + hue + '-bg',
                    bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                    fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
                };
            }

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }
            if(palette!=="custom"){
                activateHueSelection(palette, vm.palettes[palette]);
                
            }
            else{
                activateHueSelection(palette,0);
            }
            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 );
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document,$cookies)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar-display/ms-info-bar-display.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                    $cookies.put('WEBTV.removeInfoBar',1,{expires :new Date(+new Date()+2592000000)});
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document,$cookies)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                    $cookies.put('WEBTV.removeInfoBar',1,{expires :new Date(+new Date()+2592000000)});
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';/** @ngInject */
function config(msApiProvider) {

    msApiProvider.register('multilangues.getUrlExport', [Routing.generate('api_event_url_export_detail') + "/:id", {id: '@id'}]);
    var deleteLanguage = Routing.generate('api_delete_lang_event_live') + "/:id/:lang";
    msApiProvider.register('eventLive.deleteLanguages', [deleteLanguage, {id: '@id', lang: '@lang'}]);}

angular.module('app.core.menu', ["app.core"])
    .config(config);
})();
(function ()
{
    'use strict';
    angular.module('app.core.menu')

    .directive('msDeleteMenu', function () {
        return {
            scope: {
                type: '@type',
                text: '@text',
                icon: '@icon',
                event: "=event",
                render: "=render"
            },
            controller: 'deleteMenuController',
            controllerAs: 'vm',
            restrict: 'E',
            link: function ($scope, element, attrs) {
            },
            templateUrl: 'app/core/directives/ms-delete-menu/ms-delete-menu.html'
        };
    });

})();

(function ()
{
    'use strict';
    /** @ngInject */
function deleteMenuController(webTvGlobal, $translate, msApi, $scope, $mdDialog, $document, $rootScope) {
    var vm = this;
    vm.type = $scope.type;
    vm.text = $scope.text;
    vm.icon = $scope.icon;
    vm.openMenu = openMenu;
    vm.deleteLanguageConfirm = deleteLanguageConfirm;
    vm.deleteLanguage = deleteLanguage;
    vm.showEmbed = showEmbed;
    var originatorEv;

    function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
    }

    function deleteLanguageConfirm(ev) {
        $translate([
            "MESSAGES.dialog_confirm_delete",
            "MESSAGES.dialog_cancel",
            "MESSAGES.dialog_will_be_deleted",
            "EVENTLIST.delete_language_msg",
            "EVENTLIST.delete_lang_event_aria_label",
            "EVENTLIST.delete_speaker",
            "LANGUAGES.Names." + vm.text])
            .then(function (translatedValues) {
                var confirm;
                if (vm.text === "or") {
                    confirm = $mdDialog.confirm()
                        .title(translatedValues['EVENTLIST.delete_language_msg'])
                        .htmlContent(translatedValues['EVENTLIST.delete_speaker'] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['EVENTLIST.delete_lang_event_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                }
                else {
                    confirm = $mdDialog.confirm()
                        .title(translatedValues['EVENTLIST.delete_language_msg'])
                        .htmlContent(translatedValues['LANGUAGES.Names.' + vm.text] + translatedValues['MESSAGES.dialog_will_be_deleted'])
                        .ariaLabel(translatedValues['EVENTLIST.delete_lang_event_aria_label'])
                        .targetEvent(ev)
                        .ok(translatedValues['MESSAGES.dialog_confirm_delete'])
                        .cancel(translatedValues['MESSAGES.dialog_cancel']);
                }

                $mdDialog.show(confirm).then(function () {

                    deleteLanguage($scope.event.id, vm.text);
                   

                }, function () {

                });
            });


    }

    function deleteLanguage(event, lang) {
        $rootScope.loadingProgress = true;
        msApi.request('eventLive.deleteLanguages@delete', {id: event, lang: lang},
            function (response) {
                $rootScope.loadingProgress = false;
                if (response.code === 200) {
                    $translate([
                        "EVENTLIST.dialog_alert_delete_title",
                        "EVENTLIST.dialog_alert_delete_description",
                        "EVENTLIST.dialog_alert_delete_close",
                        "EVENTLIST.delete_speaker",
                        "LANGUAGES.Names." + lang
                    ])
                        .then(function (translatedValues) {
                            if (lang === "or") {
                                webTvGlobal.$toast().showSimple(translatedValues['EVENTLIST.delete_speaker'] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                            }
                            else {
                                webTvGlobal.$toast().showSimple(translatedValues['LANGUAGES.Names.' + lang] + translatedValues['EVENTLIST.dialog_alert_delete_description']);
                            }

                            $scope.render();
                        });

                }
                else {
                    $translate([
                        "EVENTLIST.dialog_alert_delete_error_title",
                        "EVENTLIST.dialog_alert_delete_error_description",
                        "EVENTLIST.dialog_alert_delete_close"
                    ])
                        .then(function () {

                            $mdDialog
                                .show(alert)
                                .finally(function () {
                                    alert = undefined;
                                });
                        });

                }
            }
        );


    }

    function showEmbed(ev) {
        vm.spinner = false;
        msApi.request(
            'multilangues.getUrlExport@get',
            {
                id: $scope.event.id,
                lang: vm.text
            },
            function (res) {
                vm.spinner = true;
                $mdDialog.show({
                    controller: 'embedModalLanguageController',
                    controllerAs: 'vm',
                    templateUrl: 'app/core/directives/ms-delete-menu/embed.modal.html',
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    locals: {
                        event: res.data
                    }
                })
            }, function (response) {
                vm.spinner = true;
                if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                    $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                        webTvGlobal.alertDialog(message);
                    }, function () {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    });
                }
                else {

                    webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                }
            }
        ).then(function () {
        });
    }

}
function embedModalLanguageController($mdDialog, event) {
    var vm = this;
    vm.spinner = true;
    vm.event = event;
    vm.url_embed_auto = vm.event.iframe_embed.replace("[linkEmbed]", vm.event.url_embed_auto);
    vm.url_embed = vm.event.iframe_embed.replace("[linkEmbed]", vm.event.url_embed);
    vm.url_embed_video = vm.event.iframe_embed.replace("[linkEmbed]", vm.event.url_embed_video);
    vm.url_permalien_auto = vm.event.url_permalien_auto;
    vm.url_permalien = vm.event.url_permalien;
    vm.url_permalien_video = vm.event.url_permalien_video;
    vm.searchFlight = {
        exportLink: 'Auto'
    };
    vm.options = "";

    vm.closeDialog = closeDialog;
    vm.checkOptionFunction = checkOptionFunction;
    vm.checkOptionFunction2 = checkOptionFunction2;
    vm.checkOptionFunction3 = checkOptionFunction3;

    function checkOptionFunction(valueCheck, option) {
        if (valueCheck) {
            if (vm.options === "") {
                vm.options = "?" + option + "=1";
            } else {
                vm.options += "&" + option + "=1";
            }
        } else {
            if (vm.options.indexOf("?" + option + "=1") !== -1) {
                vm.options = vm.options.replace("?" + option + "=1", "");
                var index = vm.options.indexOf("&");
                if (index !== -1)
                    vm.options = vm.options.replace("&", "?");
            } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
                vm.options = vm.options.replace("&" + option + "=1", "");
            }
        }
        vm.url_permalien_auto = vm.event.url_permalien_auto + vm.options;
        vm.auto = vm.event.url_embed_auto + vm.options;
        vm.url_embed_auto = vm.event.iframe_embed.replace("[linkEmbed]", vm.auto);


    }

    function checkOptionFunction2(valueCheck, option) {
        if (valueCheck) {
            if (vm.options === "") {
                vm.options = "?" + option + "=1";
            } else {
                vm.options += "&" + option + "=1";
            }
        } else {
            if (vm.options.indexOf("?" + option + "=1") !== -1) {
                vm.options = vm.options.replace("?" + option + "=1", "");
                var index = vm.options.indexOf("&");
                if (index !== -1)
                    vm.options = vm.options.replace("&", "?");
            } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
                vm.options = vm.options.replace("&" + option + "=1", "");
            }
        }
        vm.url_permalien = vm.event.url_permalien + vm.options;
        vm.permalien = vm.event.url_embed + vm.options;
        vm.url_embed = vm.event.iframe_embed.replace("[linkEmbed]", vm.permalien);
    }

    function checkOptionFunction3(valueCheck, option) {
        if (valueCheck) {
            if (vm.options === "") {
                vm.options = "?" + option + "=1";
            } else {
                vm.options += "&" + option + "=1";
            }
        } else {
            if (vm.options.indexOf("?" + option + "=1") !== -1) {
                vm.options = vm.options.replace("?" + option + "=1", "");
                var index = vm.options.indexOf("&");
                if (index !== -1)
                    vm.options = vm.options.replace("&", "?");
            } else if (vm.options.indexOf("&" + option + "=1") !== -1) {
                vm.options = vm.options.replace("&" + option + "=1", "");
            }
        }
        vm.url_permalien_video = vm.event.url_permalien_video + vm.options;
        vm.permalien_video = vm.event.url_embed_video + vm.options;
        vm.url_embed_video = vm.event.iframe_embed.replace("[linkEmbed]", vm.permalien_video);
    }

    function closeDialog() {
        $mdDialog.hide();
    }

}
angular
    .module('app.core.menu')
    .controller('deleteMenuController', deleteMenuController)
    .controller('embedModalLanguageController', embedModalLanguageController);

})();

(function () {
    'use strict';

    function config(msApiProvider) {

        msApiProvider.register('contributors.getContributors', [Routing.generate('api_media_get_contributors')]);

    }

    /** @ngInject */
    function contributorsListController($scope, webTvGlobal, msApi, $mdSelect) {
        var vm = this;

        vm.hide = false;
        vm.ngModel = $scope.ngModel;

        msApi.request('contributors.getContributors@get',
            function (res) {
                vm.contributors = webTvGlobal.convertToSelectChoicesFormat(
                    (function (contributors, data) {

                        contributors['none'] = "0";
                        for (var i = 0; i < data.length; i++) {
                            contributors[data[i].name] = data[i].id;
                        }
                        return contributors;
                    })({}, res.contributors)
                );

            });


    }

    angular.module('app.core.contributors', ["app.core"])
        .config(config);

    angular.module('app.core.contributors')
        .directive('msContributors', function () {
            return {
                scope: {
                    ngModel: '=ngModel',
                    ngChange: '&'
                },
                controller: 'contributorsListController',
                controllerAs: 'vm',
                restrict: 'E',
                link: function ($scope, element, attrs) {
                },
                templateUrl: 'app/core/directives/ms-contributors/ms-contributors.html'
            };
        })
        .controller('contributorsListController', contributorsListController);

})();
(function () {
    'use strict';

    function config(msApiProvider) {


        msApiProvider.register('msChannels.getNames', [Routing.generate('api_parameters_get_channels_names')]);

    }

    /** @ngInject */
    function channelsListController($scope, webTvGlobal, msApi, $mdSelect) {
        var vm = this;

        vm.hide = false;
        vm.ngModel = $scope.ngModel;

        msApi.request('msChannels.getNames@get',
            function (res) {
                vm.canals = webTvGlobal.convertToSelectChoicesFormat(res.names);

            });







    }

    angular.module('app.core.channels', ["app.core"])
        .config(config);

    angular.module('app.core.channels')
        .directive('msChannels', function () {
            return {
                scope: {
                    ngModel: '=ngModel',
                    ngChange: '&'
                },
                controller: 'channelsListController',
                controllerAs: 'vm',
                restrict: 'E',
                link: function ($scope, element, attrs) {
                },
                templateUrl: 'app/core/directives/ms-channels/ms-channels.html'
            };
        })
        .controller('channelsListController', channelsListController);

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msBlockDisplay', msBlockDisplayDirective);

    /** @ngInject */
    function msBlockDisplayDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msBlockDisplay: '='
            },
            link    : function (scope, iElement)
            {
                var msBlockDisplay = String.fromCharCode(65 + (Number)(scope.msBlockDisplay));
                iElement.text(msBlockDisplay);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('msBlockComponentDisplay', msBlockComponentDisplay);

    /** @ngInject */
    function msBlockComponentDisplay($document, $cookies) {
        return {
            restrict: 'E',
            scope: {
                block: '@',
                vm: '=',
                index: "@"
            },
            templateUrl: 'app/core/directives/ms-block-component-display/ms-block-component-display.html',
            link: function (scope, iElement) {
            }
        };
    }
})();
(function ()
{
  'use strict';

  angular
    .module('app.core')
    .directive('iframeOnload', iframeOnloadDirective);

  /** @ngInject */
  function iframeOnloadDirective()
  {
    return {
      scope: {
        callBack: '&iframeOnload'
      },
      link: function(scope, element, attrs){
        element.on('load', function(){
          return scope.callBack();
        })
      }
    };
  }
})();



(function () {
  'use strict';

  var TEMPLATE = '<div class="png-time form-control" ng-click="focus()">' +
    '<input type="text" name="hour" class="hour" maxlength="2" ng-model="hour" />' +
    '<span>:</span>' +
    '<input type="text" name="minute" class="minute" maxlength="2" ng-model="minute" />' +
    '<input type="text" name="mode" class="mode" maxlength="2" ng-model="mode" ng-show="timeMode !== 24" />' +
    '</div>';

  angular.module('app.core').directive('inlineTimeInput', TimeInputDirective);


  function TimeInputDirective() {
    return {
      restrict: 'E',
      replace: true,
      template: TEMPLATE,
      scope: {
        model: '=',
        timeMode: '='
      },
      link: timepickerLinkFn
    };

    function timepickerLinkFn(scope, element, attr) {
      var hourInput, minuteInput, modeInput,
        hourInputEl, minuteInputEl, modeInputEl,
        hourInputCtrl, minuteInputCtrl, modeInputCtrl,
        currentFocusEl,
        keyCount = 2;

      //default time mode to 12h
      var timeMode = scope.timeMode = scope.timeMode !== 24 ? 12 : 24;

      function hourInputParser(value) {
        var hour = parseInt(value);

        if (isNaN(hour)) {
          hourInputCtrl.$viewValue = '00';
          hourInputCtrl.$render();
          hourInput.select();
          return hourInputCtrl.$viewValue;
        }

        // Some logic If we're in military time and the user wants to input 00
        if (timeMode === 24 && hour === 0) {
          // Check for '10' input
          if (parseInt(hourInputCtrl.$modelValue) === 0) {
            hourInputCtrl.$viewValue = '00';
            hourInputCtrl.$commitViewValue();
            hourInputCtrl.$render();
            minuteInput.focus();
            minuteInput.select();
            return hourInputCtrl.$viewValue;
          }
        }

        //if user meant to type 10, 11 or 12 for standard or 10 - 23 for military
        var squashTime = false;
        if (timeMode === 24) {
          if (parseInt(hourInputCtrl.$modelValue) === 2 && hour < 4) {
            squashTime = true;
          } else if (parseInt(hourInputCtrl.$modelValue) < 2 && hour < 10) {
            squashTime = true;
          }
        } else {
          if (parseInt(hourInputCtrl.$modelValue) < 2 && hour < 3) {
            squashTime = true;
          }
        }
        if (squashTime) {
          hourInputCtrl.$viewValue = parseInt(hourInputCtrl.$modelValue) + '' + hour;
          hourInputCtrl.$commitViewValue();
          hourInputCtrl.$render();
          minuteInput.focus();
          minuteInput.select();
          return hourInputCtrl.$viewValue;
        }

        if (hour < 10 && value.length === 1) {
          hourInputCtrl.$viewValue = '0' + value;
          hourInputCtrl.$commitViewValue();
          hourInputCtrl.$render();
        }

        if (hour > (timeMode === 24 ? 2 : 1)) {
          minuteInput.focus();
          minuteInput.select();
        } else {
          hourInput.select();
        }

        return hourInputCtrl.$viewValue;
      }

      function minuteInputParser(value) {
        var minute = parseInt(value);

        if (isNaN(minute)) {
          minuteInputCtrl.$viewValue = '00';
          minuteInputCtrl.$render();
          minuteInput.select();
          return minuteInputCtrl.$viewValue;
        }

        if (parseInt(minuteInputCtrl.$modelValue) < 6 && minute < 10) {
          minuteInputCtrl.$viewValue = parseInt(minuteInputCtrl.$modelValue) + '' + minute;
          minuteInputCtrl.$commitViewValue();
          minuteInputCtrl.$render();
          if (timeMode === 12) {
            modeInput.focus();
            modeInput.select();
          }
          minuteInput.select();
          return minuteInputCtrl.$viewValue;
        }

        if (minute < 10 && value.length === 1) {
          minuteInputCtrl.$viewValue = '0' + value;
          minuteInputCtrl.$commitViewValue();
          minuteInputCtrl.$render();
        }

        if (parseInt(value) > 5 && timeMode === 12) {
          modeInput.focus();
          modeInput.select();
        } else {
          minuteInput.focus();
          minuteInput.select();
        }

        return minuteInputCtrl.$viewValue;
      }

      function modeInputParser(value) {
        //if user has typed 'a', or has typed 'm' with 'AM' showing
        if ((value.toLowerCase().indexOf('a') >= 0) || (value.toLowerCase() === 'm' && modeInputCtrl.$modelValue === 'AM')) {
          modeInputCtrl.$viewValue = 'AM';
        } else {
          modeInputCtrl.$viewValue = 'PM';
        }
        modeInputCtrl.$commitViewValue();
        modeInputCtrl.$render();

        modeInput.select();

        return modeInputCtrl.$viewValue;
      }

      function resetKeyCount() {
        keyCount = 2;
      }

      function inputBlurHandler() {
        element.removeClass('time-focus');

        if (currentFocusEl === this) {// jshint ignore:line
          currentFocusEl = null;
        }
      }

      function inputFocusHandler() {
        element.addClass('time-focus');
        currentFocusEl = this;// jshint ignore:line
      }

      function modelWatcher(dt) {
        if (!dt) {
          scope.hour = '--';
          scope.minute = '--';
          scope.mode = '--';
          return;
        }

        if (angular.isString(dt)) {
          dt = new Date(dt);
        }

        if (angular.isDate(dt)) {
          var tempHour = dt.getHours();
          scope.minute = dt.getMinutes();

          if (timeMode === 12) {
            if (tempHour > 11) {
              scope.hour = tempHour === 12 ? tempHour : tempHour - 12;
              scope.mode = 'PM';
            } else {
              scope.hour = tempHour === 0 ? 12 : tempHour;
              scope.mode = 'AM';
            }
          } else {
            scope.hour = tempHour === 0 ? 0 : tempHour; // Default to 00 for military time
          }
          if (scope.hour < 10) {
            scope.hour = '0' + scope.hour;
          }
          if (scope.minute < 10) {
            scope.minute = '0' + scope.minute;
          }
        }
      }

      angular.forEach(element.find('input'), function (input) {
        if (input.name === 'hour') {
          hourInput = input;
          hourInputEl = angular.element(input);
          hourInputCtrl = hourInputEl.controller('ngModel');
        } else if (input.name === 'minute') {
          minuteInput = input;
          minuteInputEl = angular.element(input);
          minuteInputCtrl = minuteInputEl.controller('ngModel');
        } else if (input.name === 'mode') {
          modeInput = input;
          modeInputEl = angular.element(input);
          modeInputCtrl = modeInputEl.controller('ngModel');
        }
      });

      scope.$watch('model', modelWatcher);

      scope.$watch('timeMode', function (value) {
        timeMode = value;
        modelWatcher(scope.model);
      });

      scope.$watch(function () {
          var hour = parseInt(scope.hour);
          var minute = parseInt(scope.minute);

          if (isNaN(hour) || isNaN(minute)) {
            return null;
          }

          if (timeMode === 12) {
            if (scope.mode === 'AM') {
              return (hour === 12 ? 0 : hour) + ':' + minute;
            } else {
              return (hour === 12 ? hour : hour + 12) + ':' + minute;
            }
          } else {
            return hour + ':' + minute;
          }
        },
        function inputWatcher(value) {
          if (!value) {
            return;
          }

          var dateParts = value.split(':');

          if (!scope.model) {
            scope.model = new Date();
          }

          scope.model.setHours(dateParts[0]);
          scope.model.setMinutes(dateParts[1]);
          scope.model.setSeconds(0);
        });

      scope.focus = function elementFocus() {
        if (document.activeElement !== minuteInput && document.activeElement !== modeInput) {
          hourInput.focus();
          hourInput.select();
        }
      };

      hourInputCtrl.$parsers.unshift(hourInputParser);
      minuteInputCtrl.$parsers.unshift(minuteInputParser);
      modeInputCtrl.$parsers.unshift(modeInputParser);

      hourInputEl.on('focus', resetKeyCount);
      minuteInputEl.on('focus', resetKeyCount);
      hourInputEl.on('focus', inputFocusHandler);
      minuteInputEl.on('focus', inputFocusHandler);
      modeInputEl.on('focus', inputFocusHandler);

      hourInputEl.on('blur', inputBlurHandler);
      minuteInputEl.on('blur', inputBlurHandler);
      modeInputEl.on('blur', inputBlurHandler);

      hourInputEl.on('keydown', function (evt) {
        keyCount--;

        switch (evt.keyCode) {
          case 37: //left key
            evt.preventDefault();
            evt.stopPropagation();
            break;
          case 38://up key
          case 40://down key
            evt.preventDefault();
            evt.stopPropagation();
            break;
          case 39: //right key
            evt.preventDefault();
            evt.stopPropagation();
            minuteInput.focus();
            minuteInput.select();
            break;
        }
      });
      minuteInputEl.on('keydown', function (evt) {
        keyCount--;

        switch (evt.keyCode) {
          case 37: //left key
            evt.preventDefault();
            evt.stopPropagation();
            hourInput.focus();
            hourInput.select();
            break;
          case 38://up key
          case 40://down key
            evt.preventDefault();
            evt.stopPropagation();
            break;
          case 39: //right key
            evt.preventDefault();
            evt.stopPropagation();
            modeInput.focus();
            modeInput.select();
            break;
        }
      });
      modeInputEl.on('keydown', function (evt) {
        keyCount--;

        switch (evt.keyCode) {
          case 37: //left key
            evt.preventDefault();
            evt.stopPropagation();
            minuteInput.focus();
            minuteInput.select();
            break;
          case 38://up key
          case 40://down key
            evt.preventDefault();
            evt.stopPropagation();
            break;
          case 39: //right key
            evt.preventDefault();
            evt.stopPropagation();
            break;
        }
      });

      hourInputEl.on('click', function () {
        hourInput.select();
        //safari
        hourInput.setSelectionRange(0, 2)
      });
      minuteInputEl.on('click', function () {
        minuteInput.select();
        //safari
        minuteInput.setSelectionRange(0, 2)
      });
      modeInputEl.on('click', function () {
        modeInput.select();
        //safari
        modeInput.setSelectionRange(0, 2)
      });

      scope.$on('$destroy', function () {
        hourInputEl.off('click');
        hourInputEl.off('focus');
        hourInputEl.off('keydown');
        hourInputEl.off('blur');
        minuteInputEl.off('click');
        minuteInputEl.off('focus');
        minuteInputEl.off('keydown');
        minuteInputEl.off('blur');
        modeInputEl.off('blur');
        modeInputEl.off('click');
        modeInputEl.off('keydown');
        modeInputEl.off('blur');
      });
    }
  }
})();

/**
 * Angular JS horizontal timeline
 *
 * (c) eowo
 * https://github.com/eowo/angularjs-horizontal-timeline
 *
 * Licensed under the MIT license
 */

var template =
    '<div style="background: white" class="timeline">' +
    '<div class="timeline-left">' +
    '	<span style="font-size: 135%; font-family: Roboto, Helvetica Neue, sans-serif;!important;" translate="MESSAGES.{{type}}">Type</span>' +
    '</div>' +
    '<div class="timeline-center">' +
    '<div class="progress">' +
    '	<label style="margin-left: 1%;font-family: Roboto, Helvetica Neue, sans-serif;">{{startDate}}</label>' +
    '<div style="font-family: Roboto, Helvetica Neue, sans-serif;"class="timeline-right">' +
    '	<label>{{endDate}}</label>' +
    '</div>' +
    '	<span ng-style="{width:progress_percent+\'%\'}"></span>' +
    '	<ul class="timeline-events">' +
    '		<li  class="timeline-event {{type}}" ng-repeat="event in events"' +
    '			ng-mouseenter="selectedEvent[$index]=true"' +
    '			ng-mouseleave="selectedEvent[$index]=false"' +
    '			event-date="event.date"' +
    '			timeline-event-marker>' +
    '			<div class="timeline-event-box"' +
    '				ng-if="selectedEvent[$index]"' +
    '				ng-hide="!selectedEvent[$index]"' +
    '				ng-bind-html="event.content | unsafe"> <h4>Marouene</h4>' +
    '			</div>' +
    '		</li>' +
    '	</ul>' +
    '	<ul class="timeline-bg">' +
    '		<li  class="timeline-month" ng-repeat="month in minutes"' +
    '			timeline-month><span title="{{month.date}}">{{month.name}}</span>' +
    '			<ul>' +
    '				<li class="timeline-day" ng-repeat="day in month.days"' +
    '					ng-style="{ \'left\' : ($index * (100/month.days.length) )+\'%\'}">' +
    '					<span title="{{month.date + \'-\' + day}}"><i></i>{{day}}</span>' +
    '				</li>' +
    '			</ul></li>' +
    '	</ul>' +
    '</div>' +
    '</div>' +
    '</div>';

angular.module('angular-horizontal-timeline', ['ngSanitize'])

    .filter('unsafe', ['$sce', function ($sce) {
        return function (val) {
            return $sce.trustAsHtml(val);
        };
    }])
    //moment.utc(full.duration.replace(/\+\d+$/, "")).format('HH:mm:ss')
    .directive('horizontalTimeline', function () {
        function controller($scope) {
            $scope.format = $scope.format || 'HH:mm:ss';
            $scope.selectedEvent = [];
            $scope.minutes = [];


            function timeToSeconds(time) {

                var a = time.split(':'); // split it at the colons

                // minutes are worth 60 seconds. Hours are worth 60 minutes.
                var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60 + (+a[2]);

                return seconds;
            }

            $scope.timePrecent = function (time) {

                var diff = timeToSeconds($scope.endDate) - timeToSeconds($scope.startDate);

                var percent = (timeToSeconds(time) * 100) / diff;

                return percent;
            };

            /*function currentToPercent (time) {var diff= timeToSeconds($scope.endDate)-timeToSeconds($scope.startDate);
            var percent=(time*100)/diff;

            return percent;
            }*/
            /*$scope.getPosition = function (date) {
                date = moment(date, $scope.format);
                var diff = date.diff(moment($scope.startDate, $scope.format), 'minutes');
                var curWeekWidth = 100 / $scope.minutes[diff].seconds.length;
                var monthsWidth = 100 / $scope.minutes.length;
                var ixOfWeek = Math.ceil(date.format('D') / 7) - 1;
                var curDOfMPercent = (date.format('D') - $scope.minutes[diff].days[ixOfWeek]) * 14.28;

                return ((monthsWidth * diff) + (((ixOfWeek * curWeekWidth) + (curDOfMPercent / 100 * curWeekWidth)) / 100 * monthsWidth));
            };*/

            // var range = moment().range(moment($scope.startDate, $scope.format), moment($scope.endDate, $scope.format));
            // range.by('minutes', function (month) {
            //     $scope.minutes.push({
            //         'date': month.format('HH:mm:ss'),
            //         //'name': moment.utc().format('HH:mm:ss'),
            //         'days': []
            //     });
            //
            //     //var dayrange = moment().range(moment(month.startOf('month'), $scope.format), moment(month.endOf('month'), $scope.format));
            //     //dayrange.by('weeks', function (week) {
            //     //$scope.minutes[$scope.minutes.length - 1].days.push(week.format('DD'));
            //     //});
            // });
            $scope.progress_percent = 0;//currentToPercent($scope.current);

        }


        controller.$inject = ['$scope'];

        return {
            restrict: 'AEC',
            controller: controller,
            scope: {
                startDate: '@',
                endDate: '@',
                events: '=',
                format: '@',
                type: '@'
            },
            template: template
        };
    })

    .directive('timelineMonth', function () {
        function link(scope, element, attr) {
            var monthWidth = 100 / scope.minutes.length;
            element.css({'width': monthWidth + '%'});
        }

        return {
            restrict: 'A',
            link: link
        };
    })

    .directive('timelineEventMarker', function () {
        function link(scope, element, attr) {
            var eventDate = scope.$eval(attr.eventDate);
            var pos = scope.timePrecent(eventDate);

            // console.warn(element);
            // element[0].style.left = pos + '%';
            // element["context"].style.left = pos + '%';
            //
            // element.context.style.left = pos + '%';
            element.css({'left': pos + '%'});
        }

        return {
            restrict: 'A',
            link: link,
            scope: false
        };
    });


(function () {
  'use strict';
  angular.module('angularCroppie', []).component('croppie',{
      bindings: {
        src: '<',
        ngModel: '=',
        options: '<',
        zoom: '<',
      },
      controller: ['$scope', '$element', function ($scope, $element) {
        var ctrl = this;

        this.$onInit = function () {
          var options = angular.extend({
            viewport: {
              width: 200,
              height: 200
            }
          }, ctrl.options);

          options.update = function () {
            c.result('canvas').then(function (img) {
              $scope.$apply(function () {
                ctrl.ngModel = img;
              });
            });
          };

          var c = new Croppie($element[0], options);

          ctrl.$onChanges = function (changesObj) {
            var src = changesObj.src && changesObj.src.currentValue;
            var zoom = changesObj.zoom && changesObj.zoom.currentValue;
            if (src) {
              // bind an image to croppie
              c.bind({
                url: src,
                zoom:zoom
              });
            }
            if (zoom) {
              // bind an image to croppie
              var value=0;
              var zoomValue =c.get().zoom;
              if(zoom.type==="out"){
                value=zoomValue-zoom.value
                c.setZoom(value);

              }else{
                value=zoomValue+zoom.value
                c.setZoom(value);
              }
            }
          };
        };
      }]

  });
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('hcPieChart', hcPieChartDirective);

    /** @ngInject */
    function hcPieChartDirective()
    {
        return {
            restrict: 'E',
            template: '<div></div>',
            scope: {
                title: '@',
                data: '='
            },
            link: function (scope, element) {
                Highcharts.chart(element[0], {
                    chart: {
                        type: 'pie',
                        spacingBottom: 0,
                        spacingTop: 10,
                        spacingLeft: 10,
                        spacingRight: 10,
                        marginBottom: 0,
                        width: 700,
                        height: 220
                    },
                    title: {
                        text: scope.title
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            size : '30%',
                            dataLabels: {
                                enabled: true,
                                format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                            },
                            showInLegend: true,
                            center: ['50%', '50%']
                        }
                    },
                    exporting: {
                        buttons: {
                            contextButton: {
                                enabled: false

                            }
                        }
                    },
                    credits: {
                        enabled: false
                    },
                    legend: {
                        align: 'left',
                        layout: 'vertical',
                        verticalAlign: 'top',
                        itemStyle: {
                            width: 90
                        }

                    },
                    tooltip: {
                        formatter: function() {
                            return '<b>'+ this.point.name.toLowerCase() +'</b> :'+ this.point.y*100 + '%';

                        }
                    },
                    series: [{
                        // name: null,
                        data: scope.data
                    }]
                });
            }
        };
    }
})();



(function () {
    'use strict';
    angular
        .module('app.core')
        .directive('hasPermission', hasPermission);

    /** @ngInject */
    function hasPermission(userManager) {
        return {
            restrict: 'A',
            scope: false,
            link: function (scope, element, attrs) {
                var found = false;
                if (attrs.hasPermission === "btn_menu_edition") {
                    if (!userManager.isActionGranted("media_video_post_edit"))
                        found = true;
                }
                else {
                    if (attrs.hasPermission === "core_super_admin") {
                        if (userManager.isSuperAdmin()) found = true;
                    }
                    else {
                        if (attrs.hasPermission.indexOf(',') > -1) {
                            var words = "";
                            if (attrs.hasPermission !== null) {
                                words = attrs.hasPermission.split(',') || [];
                                words = words.filter(function (item, pos) {
                                    return words.indexOf(item) === pos;
                                });
                            }
                            angular.forEach(words, function (value) {
                                if (userManager.isActionGranted(value))
                                    found = true;
                            });

                        }
                        else if (attrs.hasStat === "stat")
                            found = userManager.isActionGranted(attrs.hasPermission);
                        else if (attrs.hasStat === "global")
                            found = userManager.isModuleGranted(attrs.hasPermission);
                        else found = userManager.isActionGranted(attrs.hasPermission);
                    }
                }
                /*element.click(function () {
                    if (attrs.hasStat !== "global")
                        userManager.statsAccesAction(attrs.hasPermission);
                });*/

                var toggleVisibilityBasedOnPermission = function (elem1, found) {
                    if (elem1) {
                        if (found) {
                            element.show();
                        }
                        else {
                            element.hide();
                        }
                    }
                    else {
                        scope.enableState = !!found;
                    }

                };
                var elem = element[0].nodeName;
                toggleVisibilityBasedOnPermission(elem, found);
            }
        };
    }
})();

(function ()
{
    'use strict';

    var helpPage = {
    templateUrl: 'app/core/components/modal-help-page/modal-help-page.html',
    controller: helpPageController,
    controllerAs: 'vm',
    bindings: {
        params: '<',
        welcome: '='
    }
};
angular.module('app.core.componentsHelp', ["app.core"]);
angular.module('app.core.componentsHelp')
    .config(config)
    .controller('helpPageController', helpPageController)
    .component('helpPage', helpPage);

function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/core/components/modal-help-page');
}



function helpPageController($sce, $translate) {
    var vm = this;
    vm.trustedHtml = function (plainText) {
        return $sce.trustAsHtml($translate.instant('HELP.' + plainText + ''));
    };
}
})();

(function () {
    'use strict';
    var previewVideo = {
        templateUrl: 'app/core/components/modal-preview-video/modal-preview-video.html',
        controller: previewVideoModaleController,
        controllerAs: 'vm',
        bindings: {
            params: '<',
            event: '<',
            diffusion: '=',
            handler: '<'
        }
    };

    function config(msApiProvider) {
        msApiProvider.register('modal-preview-video.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":"), {id: '@id'}]);
        msApiProvider.register('modal-preview-video.getMontagePreview', [Routing.generate('api_media_get_video_preview_link_by_source_video', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('modal-preview-montage-video.getMontageNewPreview', [Routing.generate('api_media_get_video_preview_link_by_source_montage_video', {id: ':id'}).replace(/%3A/, ":")]);
    }

    function previewVideoModaleController(msApi, $sce, webTvGlobal, video,$translate, $q, $rootScope,$state) {
        var vm = this;
        vm.trustLink = trustLink;
        vm.isCaptionNew=false;
        if($rootScope.state.current.url==='/captions-new'){
            vm.isCaptionNew=true;
        }
        vm.isNavigationNew=false;
        if(video.isNew){
          vm.isNavigationNew=true;
        }
        $rootScope.$on('isFulled',function (event,data) {
            vm.isFulled=data;
            var headerHeight = data ? '56':'90'
            handleIframeSize(headerHeight);

        })
        setTimeout(function () {
        handleIframeSize()
        },1000)

       function handleIframeSize(headerHeight){
            var container=document.querySelector('#IE-add-edit-video-page.page-layout.isNavigationNew')
            var height='100%';
            var paddingTop='56.25%';
            if(container){
                height= container.offsetHeight+'px';
            }
            updateHeight(height,paddingTop,headerHeight);
        }
      window.addEventListener('resize',function (e) {
          var headerHeight =  vm.isFulled ? '56':'90';
          handleIframeSize(headerHeight);
      })
        function trustLink(link) {
            return $sce.trustAsResourceUrl(link);
        }
        function updateHeight(height,paddingTop,headerHeight){
          var i=0;
          var  nbr=100;
          var interval = setInterval(function () {
            i++;
            var editorIframe= document.getElementById('iframe-editor');
            var editorWrapper= document.getElementById('wrapper-editor');
            if (i === nbr || (editorIframe && editorWrapper  )) {
              clearInterval(interval);
            }
            try {
             var editorIframeHeight='100%';
             var editorWrapperPadding='56.25%';
                if(editorIframe && editorWrapper){
                    if( $state.current.url === '/captions-new'
                        || $state.current.url === '/rich-media-new'
                        || $state.current.url ==='/montage-new')
                    {
                        if(window.innerWidth >768) {
                            editorIframeHeight='calc('+height+' - '+(headerHeight && headerHeight!== "undefined" ? headerHeight : '90')+'px)';
                            editorWrapperPadding ='calc(' + paddingTop + ' + '+height+' - 90px)';
                        }else{
                            editorIframeHeight='calc('+height+' - 65px)';
                            editorWrapperPadding ='calc(' + paddingTop + ' + '+height+' - 65px)';
                        }
                    }
                    editorIframe.style.height=editorIframeHeight;
                    editorWrapper.style.paddingTop=editorWrapperPadding;
                }

            } catch(e) {
              console.log(e);
            }
          }, 1000);
      }
        vm.percentPreview = "45%";
        var plugin = "";
        this.$onInit = function () {
            vm.params.y = "bo";
            $rootScope.loadingProgress = true;

            msApi.request(
                vm.event, vm.params,
                function (res) {
                    $rootScope.loadingProgress = false;
                    if (res.code === 200) {
                        if (vm.diffusion === "intranet") {
                            if (angular.isDefined(vm.params.preview) && vm.params.preview === "richMedia") {
                                if ($rootScope.typeRichMedia === 'interactivity')
                                    vm.link_intranet = res.link_intranet.substring(0, res.link_intranet.indexOf("navigation")) + 'interactivity';
                                else
                                    vm.link_intranet = res.link_intranet;
                            }
                            else
                                vm.link_intranet = res.link_intranet + plugin;
                        }
                        if (angular.isDefined(vm.params.preview) && vm.params.preview === "richMedia") {
                            if ($rootScope.typeRichMedia === 'interactivity') {
                                vm.link = res.link.substring(0, res.link.indexOf("navigation")) + 'interactivity';
                            }
                            else {
                                vm.link = res.link;
                            }
                        }
                        else {
                            if (res.link === false)
                                vm.link = res.link;
                            else
                                vm.link = res.link + plugin;
                        }
                        if (angular.isDefined(vm.handler) && angular.isDefined(vm.handler.link_exist)) vm.handler.link_exist = res.link;
                        if (vm.link !== false)
                            vm.percentPreview = vm.link.indexOf("navigation") > 0 ? "45%" : "56%";
                      var videoMetaData = res.metaData && typeof(res.metaData)==="object" ? JSON.parse(res.metaData) :
                          {"contentJson":

                                {"streams":
                                        [
                                            {"index":0,"codec_name":"h264","codec_long_name":"aac","codec_type":"video","codec_time_base":"1/50","codec_tag_string":"avc1","codec_tag":"0x31637661","r_frame_rate":"25/1","avg_frame_rate":"25/1","time_base":"1/12800","start_pts":0,"start_time":"0.000000","duration_ts":67584,"duration":"5.280000","bit_rate":"1205959","bits_per_raw_sample":"8","nb_frames":"132","disposition":{"default":1,"dub":0,"original":0,"comment":0,"lyrics":0,"karaoke":0,"forced":0,"hearing_impaired":0,"visual_impaired":0,"clean_effects":0,"attached_pic":0},"tags":{"creation_time":"1970-01-01T00:00:00.000000Z","language":"und"},"profile":"77","width":1280,"height":720,"sample_aspect_ratio":"1:1","display_aspect_ratio":"16:9","pix_fmt":"yuv420p","level":31},{"index":1,"codec_name":"aac","codec_long_name":"unknown","codec_type":"audio","codec_time_base":"1/48000","codec_tag_string":"mp4a","codec_tag":"0x6134706d","r_frame_rate":"0/0","avg_frame_rate":"0/0","time_base":"1/48000","start_pts":0,"start_time":"0.000000","duration_ts":254976,"duration":"5.312000","bit_rate":"384828","bits_per_raw_sample":"","nb_frames":"249","disposition":{"default":1,"dub":0,"original":0,"comment":0,"lyrics":0,"karaoke":0,"forced":0,"hearing_impaired":0,"visual_impaired":0,"clean_effects":0,"attached_pic":0},"tags":{"creation_time":"1970-01-01T00:00:00.000000Z","language":"und"},"profile":"1","width":0,"height":0,"sample_fmt":"fltp","sample_rate":"48000","channels":6,"channel_layout":"5.1"}]
                                    ,"format":{"filename":"/var/www/videos/probtp/videos/big_bunny_124-82tvjzjp-30.mp4","nb_streams":2,"nb_programs":0,"format_name":"mov,mp4,m4a,3gp,3g2,mj2","format_long_name":"","start_time":"0","duration":"5.312","size":"1055736","bit_rate":"1589963","probe_score":100,"tags":{"major_brand":"isom","minor_version":"512","compatible_brands":"isomiso2avc1mp41","artist":"","copyright":"","title":""}
                        },

                                }
                        }


                      var streamVideo = videoMetaData &&
                      videoMetaData.contentJson &&
                      videoMetaData.contentJson.streams.length!==0
                      ? videoMetaData.contentJson.streams.find(function(stream) {return stream.codec_type === "video"}) : undefined;

                      var video_width = streamVideo ? streamVideo.width : undefined;
                      var video_height = streamVideo ? streamVideo.height : undefined;

                      vm.scaled = (video_width === undefined || video_height === undefined ) ? (9/16)*100 : (video_height/video_width)*100 ;
                      if(document.getElementById('dialog-video-preview'))
                      {
                          if(vm.scaled > 60)
                        {
                          document.getElementById('dialog-video-preview').style.width = '50%'
                        }else{
                          document.getElementById('dialog-video-preview').style.width = '100%'
                        }
                      }

                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }, function (response) {

                    $rootScope.loadingProgress = false;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                    vm.activeIndex = 0;
                }
            );
        }
    }

    angular.module('app.core.components', ["app.core"]);
    angular.module('app.core.components')
        .config(config)
        .controller('previewVideoModaleController', previewVideoModaleController)
        .component('previewVideo', previewVideo);

})();

(function () {
    'use strict';

    angular
        .module('app.support', [])
        .config(config)
        .run(fetchRights);


    function config($stateProvider, msApiProvider,$translatePartialLoaderProvider) {
        // State
        $stateProvider
            .state('app.support_key_list', {
                url: "/support/Api/Key",
                views: {
                    'content@app': {
                        templateUrl: 'app/main/support/list.template.html',
                        controller: 'keyListController as vm'
                    }
                }
                , "bodyClass": "e-commerce"
            });

        // Api
        $translatePartialLoaderProvider.addPart('app/main/support');
        msApiProvider.register('key_api.getToken', [Routing.generate('api_tokens_token_fo')]);

    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*support).*$",
                name_module: "support",
                name_angular_module: "app.support",
                actions: [
                    {"supportNoModule": ["documentation_no_api", "key_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.support')
    .controller('keyListController', keyListController);

  /** @ngInject */
  function keyListController($cookies, $rootScope) {
    var myEl = angular.element(document.querySelector('#content'));
    if (angular.isDefined(myEl)) ;
    myEl.removeClass('animate-slide-up');
    var vm = this;
    vm.key = $cookies.get("authToken");

    initHelp();

    function initHelp() {
      $rootScope.titre1 = "PAGESMENUSTITLES.support_menuTitle";
      $rootScope.titre2 = "PAGESMENUSTITLES.key_menuTitle";
      $rootScope.titre3 = "";
      $rootScope.welcome = "";
    }

  }

})();

/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.PerfectScrollbar=e()}(this,function(){"use strict";function t(t){return getComputedStyle(t)}function e(t,e){for(var i in e){var r=e[i];"number"==typeof r&&(r+="px"),t.style[i]=r}return t}function i(t){var e=document.createElement("div");return e.className=t,e}function r(t,e){if(!v)throw new Error("No element matching method supported");return v.call(t,e)}function l(t){t.remove?t.remove():t.parentNode&&t.parentNode.removeChild(t)}function n(t,e){return Array.prototype.filter.call(t.children,function(t){return r(t,e)})}function o(t,e){var i=t.element.classList,r=m.state.scrolling(e);i.contains(r)?clearTimeout(Y[e]):i.add(r)}function s(t,e){Y[e]=setTimeout(function(){return t.isAlive&&t.element.classList.remove(m.state.scrolling(e))},t.settings.scrollingThreshold)}function a(t,e){o(t,e),s(t,e)}function c(t){if("function"==typeof window.CustomEvent)return new CustomEvent(t);var e=document.createEvent("CustomEvent");return e.initCustomEvent(t,!1,!1,void 0),e}function h(t,e,i,r,l){var n=i[0],o=i[1],s=i[2],h=i[3],u=i[4],d=i[5];void 0===r&&(r=!0),void 0===l&&(l=!1);var f=t.element;t.reach[h]=null,f[s]<1&&(t.reach[h]="start"),f[s]>t[n]-t[o]-1&&(t.reach[h]="end"),e&&(f.dispatchEvent(c("ps-scroll-"+h)),e<0?f.dispatchEvent(c("ps-scroll-"+u)):e>0&&f.dispatchEvent(c("ps-scroll-"+d)),r&&a(t,h)),t.reach[h]&&(e||l)&&f.dispatchEvent(c("ps-"+h+"-reach-"+t.reach[h]))}function u(t){return parseInt(t,10)||0}function d(t){return r(t,"input,[contenteditable]")||r(t,"select,[contenteditable]")||r(t,"textarea,[contenteditable]")||r(t,"button,[contenteditable]")}function f(e){var i=t(e);return u(i.width)+u(i.paddingLeft)+u(i.paddingRight)+u(i.borderLeftWidth)+u(i.borderRightWidth)}function p(t,e){return t.settings.minScrollbarLength&&(e=Math.max(e,t.settings.minScrollbarLength)),t.settings.maxScrollbarLength&&(e=Math.min(e,t.settings.maxScrollbarLength)),e}function b(t,i){var r={width:i.railXWidth},l=Math.floor(t.scrollTop);i.isRtl?r.left=i.negativeScrollAdjustment+t.scrollLeft+i.containerWidth-i.contentWidth:r.left=t.scrollLeft,i.isScrollbarXUsingBottom?r.bottom=i.scrollbarXBottom-l:r.top=i.scrollbarXTop+l,e(i.scrollbarXRail,r);var n={top:l,height:i.railYHeight};i.isScrollbarYUsingRight?i.isRtl?n.right=i.contentWidth-(i.negativeScrollAdjustment+t.scrollLeft)-i.scrollbarYRight-i.scrollbarYOuterWidth:n.right=i.scrollbarYRight-t.scrollLeft:i.isRtl?n.left=i.negativeScrollAdjustment+t.scrollLeft+2*i.containerWidth-i.contentWidth-i.scrollbarYLeft-i.scrollbarYOuterWidth:n.left=i.scrollbarYLeft+t.scrollLeft,e(i.scrollbarYRail,n),e(i.scrollbarX,{left:i.scrollbarXLeft,width:i.scrollbarXWidth-i.railBorderXWidth}),e(i.scrollbarY,{top:i.scrollbarYTop,height:i.scrollbarYHeight-i.railBorderYWidth})}function g(t,e){function i(e){b[d]=g+Y*(e[a]-v),o(t,f),R(t),e.stopPropagation(),e.preventDefault()}function r(){s(t,f),t[p].classList.remove(m.state.clicking),t.event.unbind(t.ownerDocument,"mousemove",i)}var l=e[0],n=e[1],a=e[2],c=e[3],h=e[4],u=e[5],d=e[6],f=e[7],p=e[8],b=t.element,g=null,v=null,Y=null;t.event.bind(t[h],"mousedown",function(e){g=b[d],v=e[a],Y=(t[n]-t[l])/(t[c]-t[u]),t.event.bind(t.ownerDocument,"mousemove",i),t.event.once(t.ownerDocument,"mouseup",r),t[p].classList.add(m.state.clicking),e.stopPropagation(),e.preventDefault()})}var v="undefined"!=typeof Element&&(Element.prototype.matches||Element.prototype.webkitMatchesSelector||Element.prototype.mozMatchesSelector||Element.prototype.msMatchesSelector),m={main:"ps",element:{thumb:function(t){return"ps__thumb-"+t},rail:function(t){return"ps__rail-"+t},consuming:"ps__child--consume"},state:{focus:"ps--focus",clicking:"ps--clicking",active:function(t){return"ps--active-"+t},scrolling:function(t){return"ps--scrolling-"+t}}},Y={x:null,y:null},X=function(t){this.element=t,this.handlers={}},w={isEmpty:{configurable:!0}};X.prototype.bind=function(t,e){void 0===this.handlers[t]&&(this.handlers[t]=[]),this.handlers[t].push(e),this.element.addEventListener(t,e,!1)},X.prototype.unbind=function(t,e){var i=this;this.handlers[t]=this.handlers[t].filter(function(r){return!(!e||r===e)||(i.element.removeEventListener(t,r,!1),!1)})},X.prototype.unbindAll=function(){var t=this;for(var e in t.handlers)t.unbind(e)},w.isEmpty.get=function(){var t=this;return Object.keys(this.handlers).every(function(e){return 0===t.handlers[e].length})},Object.defineProperties(X.prototype,w);var y=function(){this.eventElements=[]};y.prototype.eventElement=function(t){var e=this.eventElements.filter(function(e){return e.element===t})[0];return e||(e=new X(t),this.eventElements.push(e)),e},y.prototype.bind=function(t,e,i){this.eventElement(t).bind(e,i)},y.prototype.unbind=function(t,e,i){var r=this.eventElement(t);r.unbind(e,i),r.isEmpty&&this.eventElements.splice(this.eventElements.indexOf(r),1)},y.prototype.unbindAll=function(){this.eventElements.forEach(function(t){return t.unbindAll()}),this.eventElements=[]},y.prototype.once=function(t,e,i){var r=this.eventElement(t),l=function(t){r.unbind(e,l),i(t)};r.bind(e,l)};var W=function(t,e,i,r,l){void 0===r&&(r=!0),void 0===l&&(l=!1);var n;if("top"===e)n=["contentHeight","containerHeight","scrollTop","y","up","down"];else{if("left"!==e)throw new Error("A proper axis should be provided");n=["contentWidth","containerWidth","scrollLeft","x","left","right"]}h(t,i,n,r,l)},L={isWebKit:"undefined"!=typeof document&&"WebkitAppearance"in document.documentElement.style,supportsTouch:"undefined"!=typeof window&&("ontouchstart"in window||window.DocumentTouch&&document instanceof window.DocumentTouch),supportsIePointer:"undefined"!=typeof navigator&&navigator.msMaxTouchPoints,isChrome:"undefined"!=typeof navigator&&/Chrome/i.test(navigator&&navigator.userAgent)},R=function(t){var e=t.element,i=Math.floor(e.scrollTop);t.containerWidth=e.clientWidth,t.containerHeight=e.clientHeight,t.contentWidth=e.scrollWidth,t.contentHeight=e.scrollHeight,e.contains(t.scrollbarXRail)||(n(e,m.element.rail("x")).forEach(function(t){return l(t)}),e.appendChild(t.scrollbarXRail)),e.contains(t.scrollbarYRail)||(n(e,m.element.rail("y")).forEach(function(t){return l(t)}),e.appendChild(t.scrollbarYRail)),!t.settings.suppressScrollX&&t.containerWidth+t.settings.scrollXMarginOffset<t.contentWidth?(t.scrollbarXActive=!0,t.railXWidth=t.containerWidth-t.railXMarginWidth,t.railXRatio=t.containerWidth/t.railXWidth,t.scrollbarXWidth=p(t,u(t.railXWidth*t.containerWidth/t.contentWidth)),t.scrollbarXLeft=u((t.negativeScrollAdjustment+e.scrollLeft)*(t.railXWidth-t.scrollbarXWidth)/(t.contentWidth-t.containerWidth))):t.scrollbarXActive=!1,!t.settings.suppressScrollY&&t.containerHeight+t.settings.scrollYMarginOffset<t.contentHeight?(t.scrollbarYActive=!0,t.railYHeight=t.containerHeight-t.railYMarginHeight,t.railYRatio=t.containerHeight/t.railYHeight,t.scrollbarYHeight=p(t,u(t.railYHeight*t.containerHeight/t.contentHeight)),t.scrollbarYTop=u(i*(t.railYHeight-t.scrollbarYHeight)/(t.contentHeight-t.containerHeight))):t.scrollbarYActive=!1,t.scrollbarXLeft>=t.railXWidth-t.scrollbarXWidth&&(t.scrollbarXLeft=t.railXWidth-t.scrollbarXWidth),t.scrollbarYTop>=t.railYHeight-t.scrollbarYHeight&&(t.scrollbarYTop=t.railYHeight-t.scrollbarYHeight),b(e,t),t.scrollbarXActive?e.classList.add(m.state.active("x")):(e.classList.remove(m.state.active("x")),t.scrollbarXWidth=0,t.scrollbarXLeft=0,e.scrollLeft=0),t.scrollbarYActive?e.classList.add(m.state.active("y")):(e.classList.remove(m.state.active("y")),t.scrollbarYHeight=0,t.scrollbarYTop=0,e.scrollTop=0)},T={"click-rail":function(t){t.event.bind(t.scrollbarY,"mousedown",function(t){return t.stopPropagation()}),t.event.bind(t.scrollbarYRail,"mousedown",function(e){var i=e.pageY-window.pageYOffset-t.scrollbarYRail.getBoundingClientRect().top>t.scrollbarYTop?1:-1;t.element.scrollTop+=i*t.containerHeight,R(t),e.stopPropagation()}),t.event.bind(t.scrollbarX,"mousedown",function(t){return t.stopPropagation()}),t.event.bind(t.scrollbarXRail,"mousedown",function(e){var i=e.pageX-window.pageXOffset-t.scrollbarXRail.getBoundingClientRect().left>t.scrollbarXLeft?1:-1;t.element.scrollLeft+=i*t.containerWidth,R(t),e.stopPropagation()})},"drag-thumb":function(t){g(t,["containerWidth","contentWidth","pageX","railXWidth","scrollbarX","scrollbarXWidth","scrollLeft","x","scrollbarXRail"]),g(t,["containerHeight","contentHeight","pageY","railYHeight","scrollbarY","scrollbarYHeight","scrollTop","y","scrollbarYRail"])},keyboard:function(t){function e(e,r){var l=Math.floor(i.scrollTop);if(0===e){if(!t.scrollbarYActive)return!1;if(0===l&&r>0||l>=t.contentHeight-t.containerHeight&&r<0)return!t.settings.wheelPropagation}var n=i.scrollLeft;if(0===r){if(!t.scrollbarXActive)return!1;if(0===n&&e<0||n>=t.contentWidth-t.containerWidth&&e>0)return!t.settings.wheelPropagation}return!0}var i=t.element,l=function(){return r(i,":hover")},n=function(){return r(t.scrollbarX,":focus")||r(t.scrollbarY,":focus")};t.event.bind(t.ownerDocument,"keydown",function(r){if(!(r.isDefaultPrevented&&r.isDefaultPrevented()||r.defaultPrevented)&&(l()||n())){var o=document.activeElement?document.activeElement:t.ownerDocument.activeElement;if(o){if("IFRAME"===o.tagName)o=o.contentDocument.activeElement;else for(;o.shadowRoot;)o=o.shadowRoot.activeElement;if(d(o))return}var s=0,a=0;switch(r.which){case 37:s=r.metaKey?-t.contentWidth:r.altKey?-t.containerWidth:-30;break;case 38:a=r.metaKey?t.contentHeight:r.altKey?t.containerHeight:30;break;case 39:s=r.metaKey?t.contentWidth:r.altKey?t.containerWidth:30;break;case 40:a=r.metaKey?-t.contentHeight:r.altKey?-t.containerHeight:-30;break;case 32:a=r.shiftKey?t.containerHeight:-t.containerHeight;break;case 33:a=t.containerHeight;break;case 34:a=-t.containerHeight;break;case 36:a=t.contentHeight;break;case 35:a=-t.contentHeight;break;default:return}t.settings.suppressScrollX&&0!==s||t.settings.suppressScrollY&&0!==a||(i.scrollTop-=a,i.scrollLeft+=s,R(t),e(s,a)&&r.preventDefault())}})},wheel:function(e){function i(t,i){var r=Math.floor(o.scrollTop),l=0===o.scrollTop,n=r+o.offsetHeight===o.scrollHeight,s=0===o.scrollLeft,a=o.scrollLeft+o.offsetWidth===o.scrollWidth;return!(Math.abs(i)>Math.abs(t)?l||n:s||a)||!e.settings.wheelPropagation}function r(t){var e=t.deltaX,i=-1*t.deltaY;return void 0!==e&&void 0!==i||(e=-1*t.wheelDeltaX/6,i=t.wheelDeltaY/6),t.deltaMode&&1===t.deltaMode&&(e*=10,i*=10),e!==e&&i!==i&&(e=0,i=t.wheelDelta),t.shiftKey?[-i,-e]:[e,i]}function l(e,i,r){if(!L.isWebKit&&o.querySelector("select:focus"))return!0;if(!o.contains(e))return!1;for(var l=e;l&&l!==o;){if(l.classList.contains(m.element.consuming))return!0;var n=t(l);if([n.overflow,n.overflowX,n.overflowY].join("").match(/(scroll|auto)/)){var s=l.scrollHeight-l.clientHeight;if(s>0&&!(0===l.scrollTop&&r>0||l.scrollTop===s&&r<0))return!0;var a=l.scrollWidth-l.clientWidth;if(a>0&&!(0===l.scrollLeft&&i<0||l.scrollLeft===a&&i>0))return!0}l=l.parentNode}return!1}function n(t){var n=r(t),s=n[0],a=n[1];if(!l(t.target,s,a)){var c=!1;e.settings.useBothWheelAxes?e.scrollbarYActive&&!e.scrollbarXActive?(a?o.scrollTop-=a*e.settings.wheelSpeed:o.scrollTop+=s*e.settings.wheelSpeed,c=!0):e.scrollbarXActive&&!e.scrollbarYActive&&(s?o.scrollLeft+=s*e.settings.wheelSpeed:o.scrollLeft-=a*e.settings.wheelSpeed,c=!0):(o.scrollTop-=a*e.settings.wheelSpeed,o.scrollLeft+=s*e.settings.wheelSpeed),R(e),(c=c||i(s,a))&&!t.ctrlKey&&(t.stopPropagation(),t.preventDefault())}}var o=e.element;void 0!==window.onwheel?e.event.bind(o,"wheel",n):void 0!==window.onmousewheel&&e.event.bind(o,"mousewheel",n)},touch:function(e){function i(t,i){var r=Math.floor(h.scrollTop),l=h.scrollLeft,n=Math.abs(t),o=Math.abs(i);if(o>n){if(i<0&&r===e.contentHeight-e.containerHeight||i>0&&0===r)return 0===window.scrollY&&i>0&&L.isChrome}else if(n>o&&(t<0&&l===e.contentWidth-e.containerWidth||t>0&&0===l))return!0;return!0}function r(t,i){h.scrollTop-=i,h.scrollLeft-=t,R(e)}function l(t){return t.targetTouches?t.targetTouches[0]:t}function n(t){return!(t.pointerType&&"pen"===t.pointerType&&0===t.buttons||(!t.targetTouches||1!==t.targetTouches.length)&&(!t.pointerType||"mouse"===t.pointerType||t.pointerType===t.MSPOINTER_TYPE_MOUSE))}function o(t){if(n(t)){var e=l(t);u.pageX=e.pageX,u.pageY=e.pageY,d=(new Date).getTime(),null!==p&&clearInterval(p)}}function s(e,i,r){if(!h.contains(e))return!1;for(var l=e;l&&l!==h;){if(l.classList.contains(m.element.consuming))return!0;var n=t(l);if([n.overflow,n.overflowX,n.overflowY].join("").match(/(scroll|auto)/)){var o=l.scrollHeight-l.clientHeight;if(o>0&&!(0===l.scrollTop&&r>0||l.scrollTop===o&&r<0))return!0;var s=l.scrollLeft-l.clientWidth;if(s>0&&!(0===l.scrollLeft&&i<0||l.scrollLeft===s&&i>0))return!0}l=l.parentNode}return!1}function a(t){if(n(t)){var e=l(t),o={pageX:e.pageX,pageY:e.pageY},a=o.pageX-u.pageX,c=o.pageY-u.pageY;if(s(t.target,a,c))return;r(a,c),u=o;var h=(new Date).getTime(),p=h-d;p>0&&(f.x=a/p,f.y=c/p,d=h),i(a,c)&&t.preventDefault()}}function c(){e.settings.swipeEasing&&(clearInterval(p),p=setInterval(function(){e.isInitialized?clearInterval(p):f.x||f.y?Math.abs(f.x)<.01&&Math.abs(f.y)<.01?clearInterval(p):(r(30*f.x,30*f.y),f.x*=.8,f.y*=.8):clearInterval(p)},10))}if(L.supportsTouch||L.supportsIePointer){var h=e.element,u={},d=0,f={},p=null;L.supportsTouch?(e.event.bind(h,"touchstart",o),e.event.bind(h,"touchmove",a),e.event.bind(h,"touchend",c)):L.supportsIePointer&&(window.PointerEvent?(e.event.bind(h,"pointerdown",o),e.event.bind(h,"pointermove",a),e.event.bind(h,"pointerup",c)):window.MSPointerEvent&&(e.event.bind(h,"MSPointerDown",o),e.event.bind(h,"MSPointerMove",a),e.event.bind(h,"MSPointerUp",c)))}}},H=function(r,l){var n=this;if(void 0===l&&(l={}),"string"==typeof r&&(r=document.querySelector(r)),!r||!r.nodeName)throw new Error("no element is specified to initialize PerfectScrollbar");this.element=r,r.classList.add(m.main),this.settings={handlers:["click-rail","drag-thumb","keyboard","wheel","touch"],maxScrollbarLength:null,minScrollbarLength:null,scrollingThreshold:1e3,scrollXMarginOffset:0,scrollYMarginOffset:0,suppressScrollX:!1,suppressScrollY:!1,swipeEasing:!0,useBothWheelAxes:!1,wheelPropagation:!0,wheelSpeed:1};for(var o in l)n.settings[o]=l[o];this.containerWidth=null,this.containerHeight=null,this.contentWidth=null,this.contentHeight=null;var s=function(){return r.classList.add(m.state.focus)},a=function(){return r.classList.remove(m.state.focus)};this.isRtl="rtl"===t(r).direction,this.isNegativeScroll=function(){var t=r.scrollLeft,e=null;return r.scrollLeft=-1,e=r.scrollLeft<0,r.scrollLeft=t,e}(),this.negativeScrollAdjustment=this.isNegativeScroll?r.scrollWidth-r.clientWidth:0,this.event=new y,this.ownerDocument=r.ownerDocument||document,this.scrollbarXRail=i(m.element.rail("x")),r.appendChild(this.scrollbarXRail),this.scrollbarX=i(m.element.thumb("x")),this.scrollbarXRail.appendChild(this.scrollbarX),this.scrollbarX.setAttribute("tabindex",0),this.event.bind(this.scrollbarX,"focus",s),this.event.bind(this.scrollbarX,"blur",a),this.scrollbarXActive=null,this.scrollbarXWidth=null,this.scrollbarXLeft=null;var c=t(this.scrollbarXRail);this.scrollbarXBottom=parseInt(c.bottom,10),isNaN(this.scrollbarXBottom)?(this.isScrollbarXUsingBottom=!1,this.scrollbarXTop=u(c.top)):this.isScrollbarXUsingBottom=!0,this.railBorderXWidth=u(c.borderLeftWidth)+u(c.borderRightWidth),e(this.scrollbarXRail,{display:"block"}),this.railXMarginWidth=u(c.marginLeft)+u(c.marginRight),e(this.scrollbarXRail,{display:""}),this.railXWidth=null,this.railXRatio=null,this.scrollbarYRail=i(m.element.rail("y")),r.appendChild(this.scrollbarYRail),this.scrollbarY=i(m.element.thumb("y")),this.scrollbarYRail.appendChild(this.scrollbarY),this.scrollbarY.setAttribute("tabindex",0),this.event.bind(this.scrollbarY,"focus",s),this.event.bind(this.scrollbarY,"blur",a),this.scrollbarYActive=null,this.scrollbarYHeight=null,this.scrollbarYTop=null;var h=t(this.scrollbarYRail);this.scrollbarYRight=parseInt(h.right,10),isNaN(this.scrollbarYRight)?(this.isScrollbarYUsingRight=!1,this.scrollbarYLeft=u(h.left)):this.isScrollbarYUsingRight=!0,this.scrollbarYOuterWidth=this.isRtl?f(this.scrollbarY):null,this.railBorderYWidth=u(h.borderTopWidth)+u(h.borderBottomWidth),e(this.scrollbarYRail,{display:"block"}),this.railYMarginHeight=u(h.marginTop)+u(h.marginBottom),e(this.scrollbarYRail,{display:""}),this.railYHeight=null,this.railYRatio=null,this.reach={x:r.scrollLeft<=0?"start":r.scrollLeft>=this.contentWidth-this.containerWidth?"end":null,y:r.scrollTop<=0?"start":r.scrollTop>=this.contentHeight-this.containerHeight?"end":null},this.isAlive=!0,this.settings.handlers.forEach(function(t){return T[t](n)}),this.lastScrollTop=Math.floor(r.scrollTop),this.lastScrollLeft=r.scrollLeft,this.event.bind(this.element,"scroll",function(t){return n.onScroll(t)}),R(this)};return H.prototype.update=function(){this.isAlive&&(this.negativeScrollAdjustment=this.isNegativeScroll?this.element.scrollWidth-this.element.clientWidth:0,e(this.scrollbarXRail,{display:"block"}),e(this.scrollbarYRail,{display:"block"}),this.railXMarginWidth=u(t(this.scrollbarXRail).marginLeft)+u(t(this.scrollbarXRail).marginRight),this.railYMarginHeight=u(t(this.scrollbarYRail).marginTop)+u(t(this.scrollbarYRail).marginBottom),e(this.scrollbarXRail,{display:"none"}),e(this.scrollbarYRail,{display:"none"}),R(this),W(this,"top",0,!1,!0),W(this,"left",0,!1,!0),e(this.scrollbarXRail,{display:""}),e(this.scrollbarYRail,{display:""}))},H.prototype.onScroll=function(t){this.isAlive&&(R(this),W(this,"top",this.element.scrollTop-this.lastScrollTop),W(this,"left",this.element.scrollLeft-this.lastScrollLeft),this.lastScrollTop=Math.floor(this.element.scrollTop),this.lastScrollLeft=this.element.scrollLeft)},H.prototype.destroy=function(){this.isAlive&&(this.event.unbindAll(),l(this.scrollbarX),l(this.scrollbarY),l(this.scrollbarXRail),l(this.scrollbarYRail),this.removePsClasses(),this.element=null,this.scrollbarX=null,this.scrollbarY=null,this.scrollbarXRail=null,this.scrollbarYRail=null,this.isAlive=!1)},H.prototype.removePsClasses=function(){this.element.className=this.element.className.split(" ").filter(function(t){return!t.match(/^ps([-_].+|)$/)}).join(" ")},H});
/*!
 * perfect-scrollbar v1.4.0
 * (c) 2018 Hyunje Jun
 * @license MIT
 */
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.PerfectScrollbar = factory());
}(this, (function () { 'use strict';

function get(element) {
  return getComputedStyle(element);
}

function set(element, obj) {
  for (var key in obj) {
    var val = obj[key];
    if (typeof val === 'number') {
      val = val + "px";
    }
    element.style[key] = val;
  }
  return element;
}

function div(className) {
  var div = document.createElement('div');
  div.className = className;
  return div;
}

var elMatches =
  typeof Element !== 'undefined' &&
  (Element.prototype.matches ||
    Element.prototype.webkitMatchesSelector ||
    Element.prototype.mozMatchesSelector ||
    Element.prototype.msMatchesSelector);

function matches(element, query) {
  if (!elMatches) {
    throw new Error('No element matching method supported');
  }

  return elMatches.call(element, query);
}

function remove(element) {
  if (element.remove) {
    element.remove();
  } else {
    if (element.parentNode) {
      element.parentNode.removeChild(element);
    }
  }
}

function queryChildren(element, selector) {
  return Array.prototype.filter.call(element.children, function (child) { return matches(child, selector); }
  );
}

var cls = {
  main: 'ps',
  element: {
    thumb: function (x) { return ("ps__thumb-" + x); },
    rail: function (x) { return ("ps__rail-" + x); },
    consuming: 'ps__child--consume',
  },
  state: {
    focus: 'ps--focus',
    clicking: 'ps--clicking',
    active: function (x) { return ("ps--active-" + x); },
    scrolling: function (x) { return ("ps--scrolling-" + x); },
  },
};

/*
 * Helper methods
 */
var scrollingClassTimeout = { x: null, y: null };

function addScrollingClass(i, x) {
  var classList = i.element.classList;
  var className = cls.state.scrolling(x);

  if (classList.contains(className)) {
    clearTimeout(scrollingClassTimeout[x]);
  } else {
    classList.add(className);
  }
}

function removeScrollingClass(i, x) {
  scrollingClassTimeout[x] = setTimeout(
    function () { return i.isAlive && i.element.classList.remove(cls.state.scrolling(x)); },
    i.settings.scrollingThreshold
  );
}

function setScrollingClassInstantly(i, x) {
  addScrollingClass(i, x);
  removeScrollingClass(i, x);
}

var EventElement = function EventElement(element) {
  this.element = element;
  this.handlers = {};
};

var prototypeAccessors = { isEmpty: { configurable: true } };

EventElement.prototype.bind = function bind (eventName, handler) {
  if (typeof this.handlers[eventName] === 'undefined') {
    this.handlers[eventName] = [];
  }
  this.handlers[eventName].push(handler);
  this.element.addEventListener(eventName, handler, false);
};

EventElement.prototype.unbind = function unbind (eventName, target) {
    var this$1 = this;

  this.handlers[eventName] = this.handlers[eventName].filter(function (handler) {
    if (target && handler !== target) {
      return true;
    }
    this$1.element.removeEventListener(eventName, handler, false);
    return false;
  });
};

EventElement.prototype.unbindAll = function unbindAll () {
    var this$1 = this;

  for (var name in this$1.handlers) {
    this$1.unbind(name);
  }
};

prototypeAccessors.isEmpty.get = function () {
    var this$1 = this;

  return Object.keys(this.handlers).every(
    function (key) { return this$1.handlers[key].length === 0; }
  );
};

Object.defineProperties( EventElement.prototype, prototypeAccessors );

var EventManager = function EventManager() {
  this.eventElements = [];
};

EventManager.prototype.eventElement = function eventElement (element) {
  var ee = this.eventElements.filter(function (ee) { return ee.element === element; })[0];
  if (!ee) {
    ee = new EventElement(element);
    this.eventElements.push(ee);
  }
  return ee;
};

EventManager.prototype.bind = function bind (element, eventName, handler) {
  this.eventElement(element).bind(eventName, handler);
};

EventManager.prototype.unbind = function unbind (element, eventName, handler) {
  var ee = this.eventElement(element);
  ee.unbind(eventName, handler);

  if (ee.isEmpty) {
    // remove
    this.eventElements.splice(this.eventElements.indexOf(ee), 1);
  }
};

EventManager.prototype.unbindAll = function unbindAll () {
  this.eventElements.forEach(function (e) { return e.unbindAll(); });
  this.eventElements = [];
};

EventManager.prototype.once = function once (element, eventName, handler) {
  var ee = this.eventElement(element);
  var onceHandler = function (evt) {
    ee.unbind(eventName, onceHandler);
    handler(evt);
  };
  ee.bind(eventName, onceHandler);
};

function createEvent(name) {
  if (typeof window.CustomEvent === 'function') {
    return new CustomEvent(name);
  } else {
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(name, false, false, undefined);
    return evt;
  }
}

var processScrollDiff = function(
  i,
  axis,
  diff,
  useScrollingClass,
  forceFireReachEvent
) {
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var fields;
  if (axis === 'top') {
    fields = [
      'contentHeight',
      'containerHeight',
      'scrollTop',
      'y',
      'up',
      'down' ];
  } else if (axis === 'left') {
    fields = [
      'contentWidth',
      'containerWidth',
      'scrollLeft',
      'x',
      'left',
      'right' ];
  } else {
    throw new Error('A proper axis should be provided');
  }

  processScrollDiff$1(i, diff, fields, useScrollingClass, forceFireReachEvent);
};

function processScrollDiff$1(
  i,
  diff,
  ref,
  useScrollingClass,
  forceFireReachEvent
) {
  var contentHeight = ref[0];
  var containerHeight = ref[1];
  var scrollTop = ref[2];
  var y = ref[3];
  var up = ref[4];
  var down = ref[5];
  if ( useScrollingClass === void 0 ) useScrollingClass = true;
  if ( forceFireReachEvent === void 0 ) forceFireReachEvent = false;

  var element = i.element;

  // reset reach
  i.reach[y] = null;

  // 1 for subpixel rounding
  if (element[scrollTop] < 1) {
    i.reach[y] = 'start';
  }

  // 1 for subpixel rounding
  if (element[scrollTop] > i[contentHeight] - i[containerHeight] - 1) {
    i.reach[y] = 'end';
  }

  if (diff) {
    element.dispatchEvent(createEvent(("ps-scroll-" + y)));

    if (diff < 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + up)));
    } else if (diff > 0) {
      element.dispatchEvent(createEvent(("ps-scroll-" + down)));
    }

    if (useScrollingClass) {
      setScrollingClassInstantly(i, y);
    }
  }

  if (i.reach[y] && (diff || forceFireReachEvent)) {
    element.dispatchEvent(createEvent(("ps-" + y + "-reach-" + (i.reach[y]))));
  }
}

function toInt(x) {
  return parseInt(x, 10) || 0;
}

function isEditable(el) {
  return (
    matches(el, 'input,[contenteditable]') ||
    matches(el, 'select,[contenteditable]') ||
    matches(el, 'textarea,[contenteditable]') ||
    matches(el, 'button,[contenteditable]')
  );
}

function outerWidth(element) {
  var styles = get(element);
  return (
    toInt(styles.width) +
    toInt(styles.paddingLeft) +
    toInt(styles.paddingRight) +
    toInt(styles.borderLeftWidth) +
    toInt(styles.borderRightWidth)
  );
}

var env = {
  isWebKit:
    typeof document !== 'undefined' &&
    'WebkitAppearance' in document.documentElement.style,
  supportsTouch:
    typeof window !== 'undefined' &&
    ('ontouchstart' in window ||
      (window.DocumentTouch && document instanceof window.DocumentTouch)),
  supportsIePointer:
    typeof navigator !== 'undefined' && navigator.msMaxTouchPoints,
  isChrome:
    typeof navigator !== 'undefined' &&
    /Chrome/i.test(navigator && navigator.userAgent),
};

var updateGeometry = function(i) {
  var element = i.element;
  var roundedScrollTop = Math.floor(element.scrollTop);

  i.containerWidth = element.clientWidth;
  i.containerHeight = element.clientHeight;
  i.contentWidth = element.scrollWidth;
  i.contentHeight = element.scrollHeight;

  if (!element.contains(i.scrollbarXRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('x')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarXRail);
  }
  if (!element.contains(i.scrollbarYRail)) {
    // clean up and append
    queryChildren(element, cls.element.rail('y')).forEach(function (el) { return remove(el); }
    );
    element.appendChild(i.scrollbarYRail);
  }

  if (
    !i.settings.suppressScrollX &&
    i.containerWidth + i.settings.scrollXMarginOffset < i.contentWidth
  ) {
    i.scrollbarXActive = true;
    i.railXWidth = i.containerWidth - i.railXMarginWidth;
    i.railXRatio = i.containerWidth / i.railXWidth;
    i.scrollbarXWidth = getThumbSize(
      i,
      toInt(i.railXWidth * i.containerWidth / i.contentWidth)
    );
    i.scrollbarXLeft = toInt(
      (i.negativeScrollAdjustment + element.scrollLeft) *
        (i.railXWidth - i.scrollbarXWidth) /
        (i.contentWidth - i.containerWidth)
    );
  } else {
    i.scrollbarXActive = false;
  }

  if (
    !i.settings.suppressScrollY &&
    i.containerHeight + i.settings.scrollYMarginOffset < i.contentHeight
  ) {
    i.scrollbarYActive = true;
    i.railYHeight = i.containerHeight - i.railYMarginHeight;
    i.railYRatio = i.containerHeight / i.railYHeight;
    i.scrollbarYHeight = getThumbSize(
      i,
      toInt(i.railYHeight * i.containerHeight / i.contentHeight)
    );
    i.scrollbarYTop = toInt(
      roundedScrollTop *
        (i.railYHeight - i.scrollbarYHeight) /
        (i.contentHeight - i.containerHeight)
    );
  } else {
    i.scrollbarYActive = false;
  }

  if (i.scrollbarXLeft >= i.railXWidth - i.scrollbarXWidth) {
    i.scrollbarXLeft = i.railXWidth - i.scrollbarXWidth;
  }
  if (i.scrollbarYTop >= i.railYHeight - i.scrollbarYHeight) {
    i.scrollbarYTop = i.railYHeight - i.scrollbarYHeight;
  }

  updateCss(element, i);

  if (i.scrollbarXActive) {
    element.classList.add(cls.state.active('x'));
  } else {
    element.classList.remove(cls.state.active('x'));
    i.scrollbarXWidth = 0;
    i.scrollbarXLeft = 0;
    element.scrollLeft = 0;
  }
  if (i.scrollbarYActive) {
    element.classList.add(cls.state.active('y'));
  } else {
    element.classList.remove(cls.state.active('y'));
    i.scrollbarYHeight = 0;
    i.scrollbarYTop = 0;
    element.scrollTop = 0;
  }
};

function getThumbSize(i, thumbSize) {
  if (i.settings.minScrollbarLength) {
    thumbSize = Math.max(thumbSize, i.settings.minScrollbarLength);
  }
  if (i.settings.maxScrollbarLength) {
    thumbSize = Math.min(thumbSize, i.settings.maxScrollbarLength);
  }
  return thumbSize;
}

function updateCss(element, i) {
  var xRailOffset = { width: i.railXWidth };
  var roundedScrollTop = Math.floor(element.scrollTop);

  if (i.isRtl) {
    xRailOffset.left =
      i.negativeScrollAdjustment +
      element.scrollLeft +
      i.containerWidth -
      i.contentWidth;
  } else {
    xRailOffset.left = element.scrollLeft;
  }
  if (i.isScrollbarXUsingBottom) {
    xRailOffset.bottom = i.scrollbarXBottom - roundedScrollTop;
  } else {
    xRailOffset.top = i.scrollbarXTop + roundedScrollTop;
  }
  set(i.scrollbarXRail, xRailOffset);

  var yRailOffset = { top: roundedScrollTop, height: i.railYHeight };
  if (i.isScrollbarYUsingRight) {
    if (i.isRtl) {
      yRailOffset.right =
        i.contentWidth -
        (i.negativeScrollAdjustment + element.scrollLeft) -
        i.scrollbarYRight -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.right = i.scrollbarYRight - element.scrollLeft;
    }
  } else {
    if (i.isRtl) {
      yRailOffset.left =
        i.negativeScrollAdjustment +
        element.scrollLeft +
        i.containerWidth * 2 -
        i.contentWidth -
        i.scrollbarYLeft -
        i.scrollbarYOuterWidth;
    } else {
      yRailOffset.left = i.scrollbarYLeft + element.scrollLeft;
    }
  }
  set(i.scrollbarYRail, yRailOffset);

  set(i.scrollbarX, {
    left: i.scrollbarXLeft,
    width: i.scrollbarXWidth - i.railBorderXWidth,
  });
  set(i.scrollbarY, {
    top: i.scrollbarYTop,
    height: i.scrollbarYHeight - i.railBorderYWidth,
  });
}

var clickRail = function(i) {
  i.event.bind(i.scrollbarY, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarYRail, 'mousedown', function (e) {
    var positionTop =
      e.pageY -
      window.pageYOffset -
      i.scrollbarYRail.getBoundingClientRect().top;
    var direction = positionTop > i.scrollbarYTop ? 1 : -1;

    i.element.scrollTop += direction * i.containerHeight;
    updateGeometry(i);

    e.stopPropagation();
  });

  i.event.bind(i.scrollbarX, 'mousedown', function (e) { return e.stopPropagation(); });
  i.event.bind(i.scrollbarXRail, 'mousedown', function (e) {
    var positionLeft =
      e.pageX -
      window.pageXOffset -
      i.scrollbarXRail.getBoundingClientRect().left;
    var direction = positionLeft > i.scrollbarXLeft ? 1 : -1;

    i.element.scrollLeft += direction * i.containerWidth;
    updateGeometry(i);

    e.stopPropagation();
  });
};

var dragThumb = function(i) {
  bindMouseScrollHandler(i, [
    'containerWidth',
    'contentWidth',
    'pageX',
    'railXWidth',
    'scrollbarX',
    'scrollbarXWidth',
    'scrollLeft',
    'x',
    'scrollbarXRail' ]);
  bindMouseScrollHandler(i, [
    'containerHeight',
    'contentHeight',
    'pageY',
    'railYHeight',
    'scrollbarY',
    'scrollbarYHeight',
    'scrollTop',
    'y',
    'scrollbarYRail' ]);
};

function bindMouseScrollHandler(
  i,
  ref
) {
  var containerHeight = ref[0];
  var contentHeight = ref[1];
  var pageY = ref[2];
  var railYHeight = ref[3];
  var scrollbarY = ref[4];
  var scrollbarYHeight = ref[5];
  var scrollTop = ref[6];
  var y = ref[7];
  var scrollbarYRail = ref[8];

  var element = i.element;

  var startingScrollTop = null;
  var startingMousePageY = null;
  var scrollBy = null;

  function mouseMoveHandler(e) {
    element[scrollTop] =
      startingScrollTop + scrollBy * (e[pageY] - startingMousePageY);
    addScrollingClass(i, y);
    updateGeometry(i);

    e.stopPropagation();
    e.preventDefault();
  }

  function mouseUpHandler() {
    removeScrollingClass(i, y);
    i[scrollbarYRail].classList.remove(cls.state.clicking);
    i.event.unbind(i.ownerDocument, 'mousemove', mouseMoveHandler);
  }

  i.event.bind(i[scrollbarY], 'mousedown', function (e) {
    startingScrollTop = element[scrollTop];
    startingMousePageY = e[pageY];
    scrollBy =
      (i[contentHeight] - i[containerHeight]) /
      (i[railYHeight] - i[scrollbarYHeight]);

    i.event.bind(i.ownerDocument, 'mousemove', mouseMoveHandler);
    i.event.once(i.ownerDocument, 'mouseup', mouseUpHandler);

    i[scrollbarYRail].classList.add(cls.state.clicking);

    e.stopPropagation();
    e.preventDefault();
  });
}

var keyboard = function(i) {
  var element = i.element;

  var elementHovered = function () { return matches(element, ':hover'); };
  var scrollbarFocused = function () { return matches(i.scrollbarX, ':focus') || matches(i.scrollbarY, ':focus'); };

  function shouldPreventDefault(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    if (deltaX === 0) {
      if (!i.scrollbarYActive) {
        return false;
      }
      if (
        (scrollTop === 0 && deltaY > 0) ||
        (scrollTop >= i.contentHeight - i.containerHeight && deltaY < 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }

    var scrollLeft = element.scrollLeft;
    if (deltaY === 0) {
      if (!i.scrollbarXActive) {
        return false;
      }
      if (
        (scrollLeft === 0 && deltaX < 0) ||
        (scrollLeft >= i.contentWidth - i.containerWidth && deltaX > 0)
      ) {
        return !i.settings.wheelPropagation;
      }
    }
    return true;
  }

  i.event.bind(i.ownerDocument, 'keydown', function (e) {
    if (
      (e.isDefaultPrevented && e.isDefaultPrevented()) ||
      e.defaultPrevented
    ) {
      return;
    }

    if (!elementHovered() && !scrollbarFocused()) {
      return;
    }

    var activeElement = document.activeElement
      ? document.activeElement
      : i.ownerDocument.activeElement;
    if (activeElement) {
      if (activeElement.tagName === 'IFRAME') {
        activeElement = activeElement.contentDocument.activeElement;
      } else {
        // go deeper if element is a webcomponent
        while (activeElement.shadowRoot) {
          activeElement = activeElement.shadowRoot.activeElement;
        }
      }
      if (isEditable(activeElement)) {
        return;
      }
    }

    var deltaX = 0;
    var deltaY = 0;

    switch (e.which) {
      case 37: // left
        if (e.metaKey) {
          deltaX = -i.contentWidth;
        } else if (e.altKey) {
          deltaX = -i.containerWidth;
        } else {
          deltaX = -30;
        }
        break;
      case 38: // up
        if (e.metaKey) {
          deltaY = i.contentHeight;
        } else if (e.altKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = 30;
        }
        break;
      case 39: // right
        if (e.metaKey) {
          deltaX = i.contentWidth;
        } else if (e.altKey) {
          deltaX = i.containerWidth;
        } else {
          deltaX = 30;
        }
        break;
      case 40: // down
        if (e.metaKey) {
          deltaY = -i.contentHeight;
        } else if (e.altKey) {
          deltaY = -i.containerHeight;
        } else {
          deltaY = -30;
        }
        break;
      case 32: // space bar
        if (e.shiftKey) {
          deltaY = i.containerHeight;
        } else {
          deltaY = -i.containerHeight;
        }
        break;
      case 33: // page up
        deltaY = i.containerHeight;
        break;
      case 34: // page down
        deltaY = -i.containerHeight;
        break;
      case 36: // home
        deltaY = i.contentHeight;
        break;
      case 35: // end
        deltaY = -i.contentHeight;
        break;
      default:
        return;
    }

    if (i.settings.suppressScrollX && deltaX !== 0) {
      return;
    }
    if (i.settings.suppressScrollY && deltaY !== 0) {
      return;
    }

    element.scrollTop -= deltaY;
    element.scrollLeft += deltaX;
    updateGeometry(i);

    if (shouldPreventDefault(deltaX, deltaY)) {
      e.preventDefault();
    }
  });
};

var wheel = function(i) {
  var element = i.element;

  function shouldPreventDefault(deltaX, deltaY) {
    var roundedScrollTop = Math.floor(element.scrollTop);
    var isTop = element.scrollTop === 0;
    var isBottom =
      roundedScrollTop + element.offsetHeight === element.scrollHeight;
    var isLeft = element.scrollLeft === 0;
    var isRight =
      element.scrollLeft + element.offsetWidth === element.scrollWidth;

    var hitsBound;

    // pick axis with primary direction
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      hitsBound = isTop || isBottom;
    } else {
      hitsBound = isLeft || isRight;
    }

    return hitsBound ? !i.settings.wheelPropagation : true;
  }

  function getDeltaFromEvent(e) {
    var deltaX = e.deltaX;
    var deltaY = -1 * e.deltaY;

    if (typeof deltaX === 'undefined' || typeof deltaY === 'undefined') {
      // OS X Safari
      deltaX = -1 * e.wheelDeltaX / 6;
      deltaY = e.wheelDeltaY / 6;
    }

    if (e.deltaMode && e.deltaMode === 1) {
      // Firefox in deltaMode 1: Line scrolling
      deltaX *= 10;
      deltaY *= 10;
    }

    if (deltaX !== deltaX && deltaY !== deltaY /* NaN checks */) {
      // IE in some mouse drivers
      deltaX = 0;
      deltaY = e.wheelDelta;
    }

    if (e.shiftKey) {
      // reverse axis with shift key
      return [-deltaY, -deltaX];
    }
    return [deltaX, deltaY];
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    // FIXME: this is a workaround for <select> issue in FF and IE #571
    if (!env.isWebKit && element.querySelector('select:focus')) {
      return true;
    }

    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollWidth - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function mousewheelHandler(e) {
    var ref = getDeltaFromEvent(e);
    var deltaX = ref[0];
    var deltaY = ref[1];

    if (shouldBeConsumedByChild(e.target, deltaX, deltaY)) {
      return;
    }

    var shouldPrevent = false;
    if (!i.settings.useBothWheelAxes) {
      // deltaX will only be used for horizontal scrolling and deltaY will
      // only be used for vertical scrolling - this is the default
      element.scrollTop -= deltaY * i.settings.wheelSpeed;
      element.scrollLeft += deltaX * i.settings.wheelSpeed;
    } else if (i.scrollbarYActive && !i.scrollbarXActive) {
      // only vertical scrollbar is active and useBothWheelAxes option is
      // active, so let's scroll vertical bar using both mouse wheel axes
      if (deltaY) {
        element.scrollTop -= deltaY * i.settings.wheelSpeed;
      } else {
        element.scrollTop += deltaX * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    } else if (i.scrollbarXActive && !i.scrollbarYActive) {
      // useBothWheelAxes and only horizontal bar is active, so use both
      // wheel axes for horizontal bar
      if (deltaX) {
        element.scrollLeft += deltaX * i.settings.wheelSpeed;
      } else {
        element.scrollLeft -= deltaY * i.settings.wheelSpeed;
      }
      shouldPrevent = true;
    }

    updateGeometry(i);

    shouldPrevent = shouldPrevent || shouldPreventDefault(deltaX, deltaY);
    if (shouldPrevent && !e.ctrlKey) {
      e.stopPropagation();
      e.preventDefault();
    }
  }

  if (typeof window.onwheel !== 'undefined') {
    i.event.bind(element, 'wheel', mousewheelHandler);
  } else if (typeof window.onmousewheel !== 'undefined') {
    i.event.bind(element, 'mousewheel', mousewheelHandler);
  }
};

var touch = function(i) {
  if (!env.supportsTouch && !env.supportsIePointer) {
    return;
  }

  var element = i.element;

  function shouldPrevent(deltaX, deltaY) {
    var scrollTop = Math.floor(element.scrollTop);
    var scrollLeft = element.scrollLeft;
    var magnitudeX = Math.abs(deltaX);
    var magnitudeY = Math.abs(deltaY);

    if (magnitudeY > magnitudeX) {
      // user is perhaps trying to swipe up/down the page

      if (
        (deltaY < 0 && scrollTop === i.contentHeight - i.containerHeight) ||
        (deltaY > 0 && scrollTop === 0)
      ) {
        // set prevent for mobile Chrome refresh
        return window.scrollY === 0 && deltaY > 0 && env.isChrome;
      }
    } else if (magnitudeX > magnitudeY) {
      // user is perhaps trying to swipe left/right across the page

      if (
        (deltaX < 0 && scrollLeft === i.contentWidth - i.containerWidth) ||
        (deltaX > 0 && scrollLeft === 0)
      ) {
        return true;
      }
    }

    return true;
  }

  function applyTouchMove(differenceX, differenceY) {
    element.scrollTop -= differenceY;
    element.scrollLeft -= differenceX;

    updateGeometry(i);
  }

  var startOffset = {};
  var startTime = 0;
  var speed = {};
  var easingLoop = null;

  function getTouch(e) {
    if (e.targetTouches) {
      return e.targetTouches[0];
    } else {
      // Maybe IE pointer
      return e;
    }
  }

  function shouldHandle(e) {
    if (e.pointerType && e.pointerType === 'pen' && e.buttons === 0) {
      return false;
    }
    if (e.targetTouches && e.targetTouches.length === 1) {
      return true;
    }
    if (
      e.pointerType &&
      e.pointerType !== 'mouse' &&
      e.pointerType !== e.MSPOINTER_TYPE_MOUSE
    ) {
      return true;
    }
    return false;
  }

  function touchStart(e) {
    if (!shouldHandle(e)) {
      return;
    }

    var touch = getTouch(e);

    startOffset.pageX = touch.pageX;
    startOffset.pageY = touch.pageY;

    startTime = new Date().getTime();

    if (easingLoop !== null) {
      clearInterval(easingLoop);
    }
  }

  function shouldBeConsumedByChild(target, deltaX, deltaY) {
    if (!element.contains(target)) {
      return false;
    }

    var cursor = target;

    while (cursor && cursor !== element) {
      if (cursor.classList.contains(cls.element.consuming)) {
        return true;
      }

      var style = get(cursor);
      var overflow = [style.overflow, style.overflowX, style.overflowY].join(
        ''
      );

      // if scrollable
      if (overflow.match(/(scroll|auto)/)) {
        var maxScrollTop = cursor.scrollHeight - cursor.clientHeight;
        if (maxScrollTop > 0) {
          if (
            !(cursor.scrollTop === 0 && deltaY > 0) &&
            !(cursor.scrollTop === maxScrollTop && deltaY < 0)
          ) {
            return true;
          }
        }
        var maxScrollLeft = cursor.scrollLeft - cursor.clientWidth;
        if (maxScrollLeft > 0) {
          if (
            !(cursor.scrollLeft === 0 && deltaX < 0) &&
            !(cursor.scrollLeft === maxScrollLeft && deltaX > 0)
          ) {
            return true;
          }
        }
      }

      cursor = cursor.parentNode;
    }

    return false;
  }

  function touchMove(e) {
    if (shouldHandle(e)) {
      var touch = getTouch(e);

      var currentOffset = { pageX: touch.pageX, pageY: touch.pageY };

      var differenceX = currentOffset.pageX - startOffset.pageX;
      var differenceY = currentOffset.pageY - startOffset.pageY;

      if (shouldBeConsumedByChild(e.target, differenceX, differenceY)) {
        return;
      }

      applyTouchMove(differenceX, differenceY);
      startOffset = currentOffset;

      var currentTime = new Date().getTime();

      var timeGap = currentTime - startTime;
      if (timeGap > 0) {
        speed.x = differenceX / timeGap;
        speed.y = differenceY / timeGap;
        startTime = currentTime;
      }

      if (shouldPrevent(differenceX, differenceY)) {
        e.preventDefault();
      }
    }
  }
  function touchEnd() {
    if (i.settings.swipeEasing) {
      clearInterval(easingLoop);
      easingLoop = setInterval(function() {
        if (i.isInitialized) {
          clearInterval(easingLoop);
          return;
        }

        if (!speed.x && !speed.y) {
          clearInterval(easingLoop);
          return;
        }

        if (Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
          clearInterval(easingLoop);
          return;
        }

        applyTouchMove(speed.x * 30, speed.y * 30);

        speed.x *= 0.8;
        speed.y *= 0.8;
      }, 10);
    }
  }

  if (env.supportsTouch) {
    i.event.bind(element, 'touchstart', touchStart);
    i.event.bind(element, 'touchmove', touchMove);
    i.event.bind(element, 'touchend', touchEnd);
  } else if (env.supportsIePointer) {
    if (window.PointerEvent) {
      i.event.bind(element, 'pointerdown', touchStart);
      i.event.bind(element, 'pointermove', touchMove);
      i.event.bind(element, 'pointerup', touchEnd);
    } else if (window.MSPointerEvent) {
      i.event.bind(element, 'MSPointerDown', touchStart);
      i.event.bind(element, 'MSPointerMove', touchMove);
      i.event.bind(element, 'MSPointerUp', touchEnd);
    }
  }
};

var defaultSettings = function () { return ({
  handlers: ['click-rail', 'drag-thumb', 'keyboard', 'wheel', 'touch'],
  maxScrollbarLength: null,
  minScrollbarLength: null,
  scrollingThreshold: 1000,
  scrollXMarginOffset: 0,
  scrollYMarginOffset: 0,
  suppressScrollX: false,
  suppressScrollY: false,
  swipeEasing: true,
  useBothWheelAxes: false,
  wheelPropagation: true,
  wheelSpeed: 1,
}); };

var handlers = {
  'click-rail': clickRail,
  'drag-thumb': dragThumb,
  keyboard: keyboard,
  wheel: wheel,
  touch: touch,
};

var PerfectScrollbar = function PerfectScrollbar(element, userSettings) {
  var this$1 = this;
  if ( userSettings === void 0 ) userSettings = {};

  if (typeof element === 'string') {
    element = document.querySelector(element);
  }

  if (!element || !element.nodeName) {
    throw new Error('no element is specified to initialize PerfectScrollbar');
  }

  this.element = element;

  element.classList.add(cls.main);

  this.settings = defaultSettings();
  for (var key in userSettings) {
    this$1.settings[key] = userSettings[key];
  }

  this.containerWidth = null;
  this.containerHeight = null;
  this.contentWidth = null;
  this.contentHeight = null;

  var focus = function () { return element.classList.add(cls.state.focus); };
  var blur = function () { return element.classList.remove(cls.state.focus); };

  this.isRtl = get(element).direction === 'rtl';
  this.isNegativeScroll = (function () {
    var originalScrollLeft = element.scrollLeft;
    var result = null;
    element.scrollLeft = -1;
    result = element.scrollLeft < 0;
    element.scrollLeft = originalScrollLeft;
    return result;
  })();
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? element.scrollWidth - element.clientWidth
    : 0;
  this.event = new EventManager();
  this.ownerDocument = element.ownerDocument || document;

  this.scrollbarXRail = div(cls.element.rail('x'));
  element.appendChild(this.scrollbarXRail);
  this.scrollbarX = div(cls.element.thumb('x'));
  this.scrollbarXRail.appendChild(this.scrollbarX);
  this.scrollbarX.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarX, 'focus', focus);
  this.event.bind(this.scrollbarX, 'blur', blur);
  this.scrollbarXActive = null;
  this.scrollbarXWidth = null;
  this.scrollbarXLeft = null;
  var railXStyle = get(this.scrollbarXRail);
  this.scrollbarXBottom = parseInt(railXStyle.bottom, 10);
  if (isNaN(this.scrollbarXBottom)) {
    this.isScrollbarXUsingBottom = false;
    this.scrollbarXTop = toInt(railXStyle.top);
  } else {
    this.isScrollbarXUsingBottom = true;
  }

  this.railBorderXWidth =
    toInt(railXStyle.borderLeftWidth) + toInt(railXStyle.borderRightWidth);
  // Set rail to display:block to calculate margins
  set(this.scrollbarXRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(railXStyle.marginLeft) + toInt(railXStyle.marginRight);
  set(this.scrollbarXRail, { display: '' });
  this.railXWidth = null;
  this.railXRatio = null;

  this.scrollbarYRail = div(cls.element.rail('y'));
  element.appendChild(this.scrollbarYRail);
  this.scrollbarY = div(cls.element.thumb('y'));
  this.scrollbarYRail.appendChild(this.scrollbarY);
  this.scrollbarY.setAttribute('tabindex', 0);
  this.event.bind(this.scrollbarY, 'focus', focus);
  this.event.bind(this.scrollbarY, 'blur', blur);
  this.scrollbarYActive = null;
  this.scrollbarYHeight = null;
  this.scrollbarYTop = null;
  var railYStyle = get(this.scrollbarYRail);
  this.scrollbarYRight = parseInt(railYStyle.right, 10);
  if (isNaN(this.scrollbarYRight)) {
    this.isScrollbarYUsingRight = false;
    this.scrollbarYLeft = toInt(railYStyle.left);
  } else {
    this.isScrollbarYUsingRight = true;
  }
  this.scrollbarYOuterWidth = this.isRtl ? outerWidth(this.scrollbarY) : null;
  this.railBorderYWidth =
    toInt(railYStyle.borderTopWidth) + toInt(railYStyle.borderBottomWidth);
  set(this.scrollbarYRail, { display: 'block' });
  this.railYMarginHeight =
    toInt(railYStyle.marginTop) + toInt(railYStyle.marginBottom);
  set(this.scrollbarYRail, { display: '' });
  this.railYHeight = null;
  this.railYRatio = null;

  this.reach = {
    x:
      element.scrollLeft <= 0
        ? 'start'
        : element.scrollLeft >= this.contentWidth - this.containerWidth
          ? 'end'
          : null,
    y:
      element.scrollTop <= 0
        ? 'start'
        : element.scrollTop >= this.contentHeight - this.containerHeight
          ? 'end'
          : null,
  };

  this.isAlive = true;

  this.settings.handlers.forEach(function (handlerName) { return handlers[handlerName](this$1); });

  this.lastScrollTop = Math.floor(element.scrollTop); // for onScroll only
  this.lastScrollLeft = element.scrollLeft; // for onScroll only
  this.event.bind(this.element, 'scroll', function (e) { return this$1.onScroll(e); });
  updateGeometry(this);
};

PerfectScrollbar.prototype.update = function update () {
  if (!this.isAlive) {
    return;
  }

  // Recalcuate negative scrollLeft adjustment
  this.negativeScrollAdjustment = this.isNegativeScroll
    ? this.element.scrollWidth - this.element.clientWidth
    : 0;

  // Recalculate rail margins
  set(this.scrollbarXRail, { display: 'block' });
  set(this.scrollbarYRail, { display: 'block' });
  this.railXMarginWidth =
    toInt(get(this.scrollbarXRail).marginLeft) +
    toInt(get(this.scrollbarXRail).marginRight);
  this.railYMarginHeight =
    toInt(get(this.scrollbarYRail).marginTop) +
    toInt(get(this.scrollbarYRail).marginBottom);

  // Hide scrollbars not to affect scrollWidth and scrollHeight
  set(this.scrollbarXRail, { display: 'none' });
  set(this.scrollbarYRail, { display: 'none' });

  updateGeometry(this);

  processScrollDiff(this, 'top', 0, false, true);
  processScrollDiff(this, 'left', 0, false, true);

  set(this.scrollbarXRail, { display: '' });
  set(this.scrollbarYRail, { display: '' });
};

PerfectScrollbar.prototype.onScroll = function onScroll (e) {
  if (!this.isAlive) {
    return;
  }

  updateGeometry(this);
  processScrollDiff(this, 'top', this.element.scrollTop - this.lastScrollTop);
  processScrollDiff(
    this,
    'left',
    this.element.scrollLeft - this.lastScrollLeft
  );

  this.lastScrollTop = Math.floor(this.element.scrollTop);
  this.lastScrollLeft = this.element.scrollLeft;
};

PerfectScrollbar.prototype.destroy = function destroy () {
  if (!this.isAlive) {
    return;
  }

  this.event.unbindAll();
  remove(this.scrollbarX);
  remove(this.scrollbarY);
  remove(this.scrollbarXRail);
  remove(this.scrollbarYRail);
  this.removePsClasses();

  // unset elements
  this.element = null;
  this.scrollbarX = null;
  this.scrollbarY = null;
  this.scrollbarXRail = null;
  this.scrollbarYRail = null;

  this.isAlive = false;
};

PerfectScrollbar.prototype.removePsClasses = function removePsClasses () {
  this.element.className = this.element.className
    .split(' ')
    .filter(function (name) { return !name.match(/^ps([-_].+|)$/); })
    .join(' ');
};

return PerfectScrollbar;

})));

(function () {
    'use strict';

    angular
        .module('app.two-factor-auth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider) {
        // State

        $stateProvider.state('app.two-factor-auth', {
            url: "/login/two-factor-auth",
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.two-factor-auth': {
                    templateUrl: "app/main/two-factor-auth/two-factor-auth.html",
                    controller: 'TwoFactorAuthController as vm'
                }
            },
            bodyClass: 'two-factor-auth'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/two-factor-auth');
    }


})();
(function () {
    'use strict';

    angular
        .module('app.two-factor-auth')
        .controller('TwoFactorAuthController', TwoFactorAuthController);

    
    function TwoFactorAuthController($scope, $rootScope, $window, msNavigationService, userManager, msApi, webtv_clients, $location, $translate, $cookies, webTvGlobal, $state, webtv_client_images, webtv_client_images_style, logo) {
        var vm = this;
        var webTv_parameterBag = undefined;
        if (!$window.localStorage.getItem("user_id")) {
            if(angular.isUndefined($cookies.get('authToken'))) {
                $state.go("app.login-v2", {token: ""});
            } else {
                $state.go('app.dashboard');
            }
        }
        vm.userId = atob($window.localStorage.getItem("user_id"));
        vm.isFM=false;
        if(logo.text1){
          vm.isFM=true;
        }
        vm.logo=false;

        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image = webtv_client_images[value];
            }

        });
        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image_style = webtv_client_images_style[value];
            }

        });
        if(angular.isUndefined(vm.image_style)){
            vm.image_style = {"width": "35%"};
        }
        if (angular.isUndefined(vm.image) && !vm.isFM) {
            vm.image = "assets/clients/webtv.png";
        }else{
          if(angular.isUndefined(vm.image))
          {
            vm.image = "assets/clients/frogmediaV2.0.png";
            vm.logo=true;
          }
        }

        vm.showSpinner = false;

        vm.languages = {
            fr: {
                'title': 'Francais',
                'translation': 'TOOLBAR.FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };
        vm.changeLanguage = changeLanguage;
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            $rootScope.selectedLanguage = lang;
            $cookies.put('WEBTV.locale', lang.code);
            $translate.use(lang.code).then(function () {
                $translate.preferredLanguage(lang.code)
            });
            webTvGlobal.translateDatePicker();
            if ($state.current.url === "/all")
                $state.go($state.current, {}, {reload: true});

            if ($rootScope.DtOptions) {
                $rootScope.DtOptions.language = dtable_language[lang.code];

            }
        }
        vm.selectedLanguage = angular.copy(vm.languages[$translate.preferredLanguage()]);
        vm.codeForm = {
            code1: "",
            code2: "",
            code3: "",
            code4: "",
            code5: "",
            code6: "",
        };

        vm.submitCodeForm = submitCodeForm;
        vm.empLoginForm = {
            username: undefined,
            password: undefined
        };

        if ($window.localStorage.getItem("token_auth") !== null && $window.localStorage.getItem("password") !== null) {
            vm.empLoginForm.username = atob($window.localStorage.getItem("token_auth"));
            vm.empLoginForm.password = atob($window.localStorage.getItem("password"));
        }

        var pasteCode = function () {
            event.preventDefault();
            let paste = (event.clipboardData || window.clipboardData).getData("text");
            console.log("paste event value", paste);
            if(paste) {
                for (let i = 0; i < paste.length; i++) {
                    let element = +paste[i];
                    Object.keys(vm.codeForm).map(function(key, y) {
                        if(i === y) vm.codeForm[key] = element
                    })
                }
                $scope.$apply();
            }
        }

        $window.addEventListener("paste", pasteCode);

        $scope.$on('$destroy', function () {
          $window.removeEventListener('paste', pasteCode);
        });

        var isNotEmpty = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    return true;
                }
            }
            return false;
        };

        function submitCodeForm () {
            vm.showSpinner = true;
            var code='';
            Object.keys(vm.codeForm).map(function(key) {
              code = ''+ code + vm.codeForm[key]
            })
            if (!vm.userId) {
              $state.go("app.login-v2", {token: ""});
            }
            msApi.request('prof_user.checkCodeValidation@save', {id: vm.userId, code: code},
                function (res) {
                    vm.showSpinner = false;
                    if(res && res.message && res.message === "success_check_code") {
                        $window.localStorage.removeItem("user_id");
                        $cookies.put("authToken", res.token);
                        msNavigationService.clearNavigation();
                        userManager.setUserData(res.userData);
                        msApi.request('parametersBagLogin.app@get',
                            function (res) {
                                var bag = res.bag;
                                vm.showSpinner = false;

                                if ($rootScope.remember && vm.empLoginForm.username && vm.empLoginForm.password ) {
                                    $window.localStorage.setItem("token_auth", btoa(vm.empLoginForm.username));
                                    $window.localStorage.setItem("password", btoa(vm.empLoginForm.password));

                                }
                                if (angular.isObject(bag) && isNotEmpty(bag)) {
                                    webTv_parameterBag = bag;
                                    $rootScope.webTv_parameterBag = webTv_parameterBag;
                                    if(angular.isDefined($rootScope.webTv_parameterBag["route_redirect"])){
                                        var route_redirect = $rootScope.webTv_parameterBag["route_redirect"];
                                        if(angular.isDefined(webTv_msNavigation[route_redirect])) {
                                            var route = webTv_msNavigation[route_redirect];
                                            var permission = route.permission;
                                            var state = route.state;
                                            if (permission && state && userManager.isActionGranted(permission)) {
                                                $state.go(state);
                                            } else {
                                                $state.go('app.dashboard');
                                            }
                                        }else {
                                            $state.go('app.dashboard');
                                        }
                                    }else {
                                        if (userManager.isActionGranted('media_video_list_dtable_videos_ongoing')) {
                                            $state.go('app.media_video_list', {type: "ongoing"});
                                        }
                                        else {
                                            $state.go('app.dashboard');
                                        }
                                    }
                                    return;
                                }
                                if (userManager.isActionGranted('media_video_list_dtable_videos_ongoing')) {
                                    $state.go('app.media_video_list', {type: "ongoing"});
                                }
                                else {
                                    $state.go('app.dashboard');
                                }
                                return;
                            },
                            function () {
                                webTv_parameterBag = {};
                            }
                        );
                    } else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_login_badCode'));
                    }
                },function (response) {
                    vm.showSpinner = false;
                    if (angular.isDefined(response.data.message) && response.data.message === "invalid_code") {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_login_badCode'));
                    }
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.login-step2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        // State

        $stateProvider.state('app.login-step2', {
            url: "/login/step2/:token",
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login-step2': {
                    templateUrl: "app/main/login-step2/login-step2.html",
                    controller: 'LoginStep2Controller as vm'
                }
            },
            bodyClass: 'login-step2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login-step2');

        msApiProvider.register('parametersBagLogin.app', [Routing.generate('api_get_app_parameter_bag')]);
        msApiProvider.register('login-step2.loginAuth', [Routing.generate('post_login')]);
        msApiProvider.register('login-step2.getTokenInitPassword', [Routing.generate('api_profiles_get_token_init_password', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('login-step2.forgetPassword', [Routing.generate('api_profiles_post_forgot_password')]);
        msApiProvider.register('login-step2.sendMailToEmpreinte', [Routing.generate('api_profiles_send_mail_tentative_usurpation', {token: ':token'}).replace(/%3A/, ":"), {token: '@token'}]);

    }


})();
(function () {
    'use strict';

    angular
        .module('app.login-step2')
        .controller('LoginStep2Controller', LoginStep2Controller);


    function LoginStep2Controller(msNavigationService, webTv_msNavigation, $translate, msApi, $state, webTvGlobal, userManager, $cookies, $rootScope, $scope, $location, webtv_client_images, webtv_client_images_style, webtv_clients, $window, $mdDialog,logo) {
        var vm = this;
        var webTv_parameterBag = undefined;

        vm.isFM=false;
        /*todo OPTIMISE */
        if(logo.text1){
          vm.isFM=true;
        }
        vm.logo=false;

        vm.returnToStep1 = returnToStep1;
        if (angular.isDefined($state.params.token) && $state.params.token !== "") {
            msApi.request('login-step2.sendMailToEmpreinte@save',
                {
                    token: $state.params.token
                },
                function (res) {
                    if (res.code === 200) {

                    }

                }
            );
        }
        vm.empLoginForm = {
            username: atob($window.localStorage.getItem("token_auth")),
            password: ""
        };
        if ($window.localStorage.getItem("token_auth") !== null && $window.localStorage.getItem("password") !== null) {
            vm.empLoginForm.username = atob($window.localStorage.getItem("token_auth"));
            vm.empLoginForm.password = atob($window.localStorage.getItem("password"));
        }


        vm.submitLoginForm = submitLoginForm;
        $scope.date = new Date();
        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image = webtv_client_images[value];
            }

        });
        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image_style = webtv_client_images_style[value];
            }

        });
        if(angular.isUndefined(vm.image_style)){
            vm.image_style = {"width": "35%"};
        }
        if (angular.isUndefined(vm.image) && !vm.isFM) {
            vm.image = "assets/clients/webtv.png";
        }else{
          if(angular.isUndefined(vm.image))
          {
            vm.image = "assets/clients/frogmediaV2.0.png";
            vm.logo=true;
          }
        }
        vm.showSpinner = false;

        vm.languages = {
            fr: {
                'title': 'Francais',
                'translation': 'TOOLBAR.FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };
        vm.changeLanguage = changeLanguage;
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            $rootScope.selectedLanguage = lang;
            $cookies.put('WEBTV.locale', lang.code);
            $translate.use(lang.code).then(function () {
                $translate.preferredLanguage(lang.code)
            });
            webTvGlobal.translateDatePicker();
            if ($state.current.url === "/all")
                $state.go($state.current, {}, {reload: true});

            if ($rootScope.DtOptions) {
                $rootScope.DtOptions.language = dtable_language[lang.code];

            }
        }
        vm.selectedLanguage = angular.copy(vm.languages[$translate.preferredLanguage()]);


        var isNotEmpty = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    return true;
                }
            }
            return false;
        };

        function submitLoginForm() {
            vm.showSpinner = true;
            msApi.request('login-step2.loginAuth@save',
                angular.copy({token_auth: vm.empLoginForm.username, password: vm.empLoginForm.password}),
                function (res) {
                    if(res.isDoubleAuthentication) {
                        var userId = res.userData && res.userData.user ? res.userData.user.id : undefined;
                        var email = res.userData && res.userData.user ? res.userData.user.email : undefined;
                        if(userId && email) {
                            msApi.request(
                                'prof_user.generateCodeValidation@save',
                                {id: userId, email: email},
                                function (res) {
                                    if(res.message === "success_send_code") {
                                        $window.localStorage.setItem("user_id", btoa(userId));
                                        vm.showSpinner = false;
                                        $state.go('app.two-factor-auth');
                                    }
                                });
                        }
                    } else if(res.token) {
                        $cookies.put("authToken", res.token);
                        msNavigationService.clearNavigation();
                        userManager.setUserData(res.userData);
                        msApi.request('parametersBagLogin.app@get',
                            function (res) {
                                var bag = res.bag;
                                vm.showSpinner = false;

                                if ($rootScope.remember) {
                                    $window.localStorage.setItem("token_auth", btoa(vm.empLoginForm.username));
                                    $window.localStorage.setItem("password", btoa(vm.empLoginForm.password));
                                }
                                if (angular.isObject(bag) && isNotEmpty(bag)) {
                                    webTv_parameterBag = bag;
                                    $rootScope.webTv_parameterBag = webTv_parameterBag;
                                    if(angular.isDefined($rootScope.webTv_parameterBag["route_redirect"])){
                                        var route_redirect = $rootScope.webTv_parameterBag["route_redirect"];
                                        if(angular.isDefined(webTv_msNavigation[route_redirect])) {
                                            var route = webTv_msNavigation[route_redirect];
                                            var permission = route.permission;
                                            var state = route.state;
                                            if (permission && state && userManager.isActionGranted(permission)) {
                                                $state.go(state);
                                            } else {
                                                $state.go('app.dashboard');
                                            }
                                        }else {
                                            $state.go('app.dashboard');
                                        }
                                    }else {
                                        if (userManager.isActionGranted('media_video_list_dtable_videos_ongoing')) {
                                            $state.go('app.media_video_list', {type: "ongoing"});
                                        }
                                        else {
                                            $state.go('app.dashboard');
                                        }
                                    }
                                    return;
                                }
                                if (userManager.isActionGranted('media_video_list_dtable_videos_ongoing')) {
                                    $state.go('app.media_video_list', {type: "ongoing"});
                                }
                                else {
                                    $state.go('app.dashboard');
                                }
                                return;
                            },
                            function () {
                                webTv_parameterBag = {};
                            }
                        );
                    }

                },
                function (res) {
                    vm.showSpinner = false;
                    if (res.status === 308) {
                        var res_message = res.data.message;
                        msApi.request(
                            'login-step2.getTokenInitPassword@get',
                            {id: res.data.userData.user.id},
                            function (res) {
                                if(res.token) {
                                    vm.showSpinner = false;
                                    if(res_message==="expired_password") {
                                        webTvGlobal.$toast().showSimple($translate.instant('LOGINV2.expired_password'));
                                    }
                                    $state.go("app.profiles_user_password", {token: res.token});
                                }
                            },
                            function (res) {
                                if(res.data.token) {
                                    vm.showSpinner = false;
                                    $state.go("app.profiles_user_password", {token: res.data.token});
                                }
                            }

                        );

                    }

                    else if (res.message) {
                        webTvGlobal.alertDialog(res.message);
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_login_badCredentials'));
                    }

                }
            );
        }

        vm.forgetPassword = forgetPassword;

        function forgetPassword() {
            $mdDialog.show({
                templateUrl: 'app/main/login-step2/forget-password.html',
                clickOutsideToClose: true,
                controller: 'forgetPassword',
                controllerAs: 'vm'
            })
        }

        function returnToStep1() {
            $state.go("app.login-v2", {token: ""});
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.login-step2')
        .controller('forgetPassword', forgetPassword);


    function forgetPassword($translate, msApi, $state, webTvGlobal, $cookies, $rootScope, $scope, $location, $window, $mdDialog) {
        var vm = this;
        vm.cancel = cancel;
        vm.sendEmailReset = sendEmailReset;

        function sendEmailReset() {
            msApi.request('login-step2.forgetPassword@save', {email: vm.email},
                function (response) {
                    webTvGlobal.$toast().showSimple($translate.instant('LOGINV2.email_sent'));

                },
                function () {
                    webTvGlobal.alertDialog($translate.instant('LOGINV2.email_not_exist'));


                });
            $mdDialog.hide();
        }


        function cancel() {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.pricing-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        // State

        $stateProvider.state('app.pricing-v2', {
            url: "/pricing-v2",
            views: {
                'content@app': {
                  templateUrl: 'app/main/pricing-v2/pricing-v2.template.html',
                  controller: 'PricingV2Controller as vm'

                }
            },
            resolve: {
                urlPricing: function (msApi) {
                   // return msApi.resolve('url_pricing.get@get');
                }
            },
            bodyClass: 'pricing'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pricing-v2');

    }


})();

(function () {
    'use strict';

    angular
        .module('app.pricing-v2')
        .controller('PricingV2Controller', PricingV2Controller);

    /** @ngInject */
    function PricingV2Controller($sce,$scope, fuseTheming,$translate,urlPricing, $rootScope) {

                var vm = this;
                vm.language = $translate.preferredLanguage();
                $scope.iframeLoadedCallBack = function(){
                    console.log('vm.language',vm.language)
                    sendPostMessage( vm.language )
                }
                var activeTheme = fuseTheming.themes.active.theme;
                var colors = {
                    "primary": activeTheme.primary.color,
                    "accent": activeTheme.accent.color,
                    "warn": activeTheme.warn.color
                };
                vm.urlPricing = $sce.trustAsResourceUrl(urlPricing.url+'lang='+vm.language+'&primaryColor='+colors.accent+'&secondaryColor='+colors.warn);
                function  sendPostMessage(lang){
                    document.getElementById('iframe_pricing').contentWindow.postMessage({
                        info: "updateLang",
                        lang:lang
                    }, "*");
                }

            }

})();

(function () {
    'use strict';

    angular
        .module('app.pricing', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        // State

        $stateProvider.state('app.pricing', {
            url: "/pricing",
            views: {
                'content@app': {
                  templateUrl: 'app/main/pricing/pricing.template.html',
                  controller: 'PricingController as vm'

                }
            },
            bodyClass: 'pricing'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pricing');

    }


})();

(function () {
    'use strict';

    angular
        .module('app.pricing')
        .controller('PricingController', PricingController);

    /** @ngInject */
    function PricingController() {

    }
})();

(function () {
    'use strict';

    angular
        .module('app.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider) {
        // State

        $stateProvider.state('app.login-v2', {
            url: "/login/?email:token",
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@app.login-v2': {
                    templateUrl: "app/main/login-v2/login-v2.html",
                    controller: 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/login-v2');

        msApiProvider.register('login-v2.checkUser', [Routing.generate('api_profiles_check_user')]);
        msApiProvider.register('login-v2.getTokenInitPassword', [Routing.generate('api_profiles_get_token_init_password', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('login-v2.sendMailToEmpreinte', [Routing.generate('api_profiles_send_mail_tentative_usurpation', {token: ':token'}).replace(/%3A/, ":"), {token: '@token'}]);

    }


})();
(function () {
    'use strict';

    angular
        .module('app.login-v2')
        .controller('LoginV2Controller', LoginV2Controller);


    function LoginV2Controller($cookies, $translate, msApi, $state, webTvGlobal, $scope, $location, webtv_client_images, webtv_client_images_style, webtv_clients, $window, $mdDialog, $rootScope,logo,inscription) {
        var vm = this;
      vm.isFM=false;
      vm.logo=false;
        console.log('login----v2-----')

        if(logo.text1){
        vm.isFM=true;
      }
      vm.inscription = inscription;
        var webTv_parameterBag = undefined;
        if (angular.isDefined($state.params.token) && $state.params.token !== "") {
            msApi.request('login-v2.sendMailToEmpreinte@save',
                {
                    token: $state.params.token
                },
                function (res) {
                    if (res.code === 200) {


                    }

                }
            );
        }
        vm.empLoginForm = {
            username: "",
        };
        if ($window.localStorage.getItem("login") !== null) {
            vm.empLoginForm.username = atob($window.localStorage.getItem("login"));
        }
       if( angular.isDefined($rootScope.username) && $rootScope.username!==""){
           vm.empLoginForm.username=$rootScope.username;
       }
       if($state.params.email){
           vm.empLoginForm.username=$state.params.email;
       }
            vm.submitLoginForm = submitLoginForm;
        $scope.date = new Date();
        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image = webtv_client_images[value];
            }

        });
        angular.forEach(webtv_clients, function (value) {
            if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
                vm.image_style = webtv_client_images_style[value];
            }

        });
        if(angular.isUndefined(vm.image_style)){
            vm.image_style = {"width": "35%"};
        }
        if (angular.isUndefined(vm.image) && !vm.isFM) {
            vm.image = "assets/clients/webtv.png";
        }else{
            if(angular.isUndefined(vm.image))
            {
              vm.image = "assets/clients/frogmediaV2.0.png";
              vm.logo=true;
            }
        }

        vm.showSpinner = false;
        vm.languages = {
            fr: {
                'title': 'Francais',
                'translation': 'TOOLBAR.FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };
        vm.changeLanguage = changeLanguage;
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            $rootScope.selectedLanguage = lang;
            $cookies.put('WEBTV.locale', lang.code);
            $translate.use(lang.code).then(function () {
                $translate.preferredLanguage(lang.code)
            });
            webTvGlobal.translateDatePicker();
            if ($state.current.url === "/all")
                $state.go($state.current, {}, {reload: true});

            if ($rootScope.DtOptions) {
                $rootScope.DtOptions.language = dtable_language[lang.code];

            }
        }
        vm.selectedLanguage = angular.copy(vm.languages[$translate.preferredLanguage()]);

        var isNotEmpty = function (obj) {
            for (var prop in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                    return true;
                }
            }
            return false;
        };

        function submitLoginForm() {
            vm.showSpinner = true;
            msApi.request('login-v2.checkUser@save',

                angular.copy({username: vm.empLoginForm.username}),
                function (res) {
                    if(res.code===200) {
                        vm.showSpinner = false;
                        if($rootScope.remember) {
                            $window.localStorage.setItem("login", btoa(vm.empLoginForm.username));
                        }
                        $window.localStorage.setItem("token_auth", btoa(res.token_auth));
                        $state.go('app.login-step2');
                    }
                },
                function (res) {
                    vm.showSpinner = false;

                    if(res.data.message) {
                        $translate('LOGINV2.' + res.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }else{
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }

                }
            );
        }

      vm.goToSingUp=goToSingUp;
      function goToSingUp() {
        $state.go('app.inscription');

      }

      }
})();

(function () {
  'use strict';

  angular
    .module('app.inscription', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msApiProvider) {
    // State
    $stateProvider
      .state('app.inscription', {
        url: "/inscription",
        views: {
            'main@': {
              templateUrl: 'app/core/layouts/content-only.html',
              controller: 'MainController as vm'
            },
            'content@app.inscription': {
              templateUrl: 'app/main/inscription-v2/inscription-v2.html',
              controller: 'inscriptionController as vm'
            }
          },
          resolve: {
            getUrlInscription: function () {
              return urlInscription ? urlInscription : "null";
            }
          }
      }
      )
      msApiProvider.register('inscription.getUrl', [Routing.generate('api_get_url_per_type')]);
  }
})();



(function () {
  'use strict';

  angular
    .module('app.inscription')
    .controller('inscriptionController', InscriptionController);


  function InscriptionController($state, $scope,$window, $injector,fuseTheming, getUrlInscription, $translate, $rootScope, $sce, $cookies, logo, webtv_client_images,webtv_client_images_style, webtv_clients, $location) {
    var vm = this;
    vm.isFM = false;
    if (logo.text1) {
      vm.isFM = true;
    }
    angular.forEach(webtv_clients, function (value) {
      if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
        vm.image = webtv_client_images[value];
      }

    });
      angular.forEach(webtv_clients, function (value) {
          if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
              vm.image_style = webtv_client_images_style[value];
          }

      });
      if(angular.isUndefined(vm.image_style)){
          vm.image_style = {"width": "35%"};
      }
    if (angular.isUndefined(vm.image) && !vm.isFM) {
      /* todo optimise this function */
      vm.image = "assets/clients/webtv.png";


    } else {
      if(angular.isUndefined(vm.image)){
        vm.image = "assets/clients/frogmediaV2.0.png";
        vm.logo = true;
      }
    }
    vm.language = $translate.preferredLanguage();
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const lang = urlParams.get('lang')
    vm.trustLink = trustLink;
      var activeTheme = fuseTheming.themes.active.theme;
      var colors = {
          "primary": activeTheme.primary.color,
          "accent": activeTheme.accent.color,
          "warn": activeTheme.warn.color
      };
      //Todo  secondaryColor
    // Todo optimise color params
      vm.urlInscription =getUrlInscription+'?lang=' + (lang ? lang : $cookies.get('WEBTV.locale'))+'&primaryColor='+colors.accent+'&secondaryColor=rgb(210, 207, 207)';
    vm.date = new Date();
    eventPostMessage();

    function eventPostMessage() {
      if (angular.isUndefined(window.dataEventPostMessageInscription)) {
        window.dataEventPostMessageInscription = true;
        var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
        var eventer = window[eventMethod];
        var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
        eventer(messageEvent, function (e) {
          if (typeof e.data !== "undefined") {
            if (e.data.info === "goToLoginPage") {
                if(e.data.username){
                    $rootScope.username=e.data.username;
                }
              $state.go("app.login-v2", {token: ""});
            }

          }
        }, false);
      }

    }

    function trustLink(link) {
      return $sce.trustAsResourceUrl(link);
    }
  }
})();

(function () {
    'use strict';

    angular
        .module('app.dashboard', [])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
        // State
        $stateProvider.state('app.dashboard', {
            url: '/dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/dashboard/dashboard.template.html',
                    controller: 'DashboardController as vm'

                }
            },
            bodyClass: 'dashboard-project',
            "actionPermission" : "stats_dashboard_dashboard_noApiRoute_action"
        });


        msApiProvider.register('dashboard.latest_videos', [Routing.generate('api_media_get_latest_videos', {"_format": "json"})]);
        msApiProvider.register('dashboard.most_viewed_videos', [Routing.generate('api_engagement_post_most_popular')]);
        msApiProvider.register('dashboard.getTransodedMetaData', [Routing.generate('api_media_get_transcoded_video_meta_data', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('dashboard.getUrlExport', [Routing.generate('api_media_get_video_url') + "/:id", {id: '@id'}]);
        msApiProvider.register('dashboard.getPreviewLink', [Routing.generate('api_media_get_video_preview_link', {id: ':id'}).replace(/%3A/, ":")]);
        // msApiProvider.register('parameters_canal.getNames', [Routing.generate('api_parameters_get_channels_names')]);
        msApiProvider.register('dashboard.getNbrVideos', [Routing.generate('api_media_get_nb_videos')]);


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/dashboard');


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*engagement)(?=.*most_popular).*$",
                name_module: "dashboard",
                name_angular_module: "app.dashboard",
                actions: [

                    {"most_popular": ["most_popular"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.dashboard')
        .controller('DashboardController', DashboardController);


    /** @ngInject */
    function DashboardController($scope, video,VideoGlobal,msNavigationService,dateMoisCourantConstant, $rootScope, $translate, msApi, webTvGlobal, $mdDialog, $cookies, userManager, $state) {
        var myEl = angular.element(document.querySelector('#content'));
        if (angular.isDefined(myEl)) ;
        myEl.removeClass('animate-slide-up');
        var vm = this;
        var appParameters = webTvGlobal.$constant().webTvParameterBag();
        var videoMultiTitle = angular.isDefined(appParameters["video_multi_title"]) ? appParameters["video_multi_title"] : '0';
        vm.spinnerTop5 = false;
        vm.spinnerLatestVideos = false;
        vm.spinnerNbVideos = false;
        vm.showVideoDetail = showVideoDetail;
        var $document = webTvGlobal.$document;
        vm.exportVideo = exportVideo;
        vm.editVideo = editVideo;
        vm.goToAddVideo = goToAddVideo;
        vm.theme = "";
        vm.canal = "";
        vm.query = {};
        vm.previewVideo = previewVideo;
      if(video.isNew){
        vm.isFM=true;
        $rootScope.isFM = true;
      }
        var user = userManager.getUser();
        var channels = (function (list, data) {
            if (angular.isDefined(data)) {
                for (var i = 0; i < data.length; i++) {
                    list.push(data[i].id);
                }
            }
            return list;
        })([], user.channels);
        $scope.someModel = null;
        $scope.someModelChannel = null;
        vm.searchOnMostViewedVideos = searchOnMostViewedVideos;
        var layoutStyle = $cookies.get('viewMode') || (angular.isDefined(defaultlayout.viewMode) ? defaultlayout.viewMode : "") || 'simpleList';
        if(!!!$cookies.get('viewMode') && (angular.isDefined(defaultlayout.viewMode))) {
          $cookies.put('viewMode',defaultlayout.viewMode)
        }

        vm.mode = layoutStyle;
        vm.block1 = $cookies.get('block1')|| (angular.isDefined(defaultlayout.block) ? defaultlayout.block[1] : "") || 'true';
        vm.block2 = $cookies.get('block2')|| (angular.isDefined(defaultlayout.block) ? defaultlayout.block[2] : "") || 'false';
        vm.block3 = $cookies.get('block3')|| (angular.isDefined(defaultlayout.block) ? defaultlayout.block[3] : "") || 'false';
        vm.block4 = $cookies.get('block4')|| (angular.isDefined(defaultlayout.block) ? defaultlayout.block[4] : "") || 'false';

        vm.query.canal = "";
        vm.query.theme = "";
        vm.query.dateIn = dateMoisCourantConstant.date.currentDateIn;
        vm.query.dateOut = dateMoisCourantConstant.date.currentDateOut ;
        console.log( vm.query)
        console.log( dateMoisCourantConstant.date)
        vm.query.range = "1d";
        vm.latestVideos = [];
        vm.nbVideos = 0;


        vm.mostViewd = [];
        var mostViewd = [];
        searchOnMostViewedVideos();
        $scope.$watch("themes", function () {
            $scope.$broadcast('themes',{themes: $rootScope.themes})
        });
        function goToAddVideo() {
            var navigationNode = null;


            if ($scope.root) {
                vm.navigation = msNavigationService.getNavigation($scope.root);
            }
            else {
                vm.navigation = msNavigationService.getNavigation();
            }

            if ( vm.navigation) {
                vm.navigation.forEach(function(navigation){
                    if(navigation._id.indexOf('media_video')>-1){
                        $state.go('app.media_video_upload');
                        navigationNode = navigation;
                    }
                })

            }
            if(navigationNode){
                setTimeout(function(){
                    msNavigationService.setActiveItem({_id : navigationNode._id,
                        _path: navigationNode._path}, $scope);
                    var externNode=true

                    $rootScope.$broadcast('msNavigation::clearActive',externNode);
                },500)

            }


        }
        function searchOnMostViewedVideos(test, model) {


            var idCanal = vm.canal;
            var idCanalStat = channels.join(',');
            if (test === 'canal') {
                vm.theme = '';
                idCanal = model;
                idCanalStat = model;
                vm.canal=idCanal;
                $rootScope.canal=idCanal;
                $rootScope.themes = webTvGlobal.loadSelectListThemes($scope.listThemes, idCanal);
            }
            var res;
            if (angular.isDefined(model) && test !== 'canal') {
                res = model.substring(model.indexOf('-') + 1, model.length);
            }
            else {
                res = vm.theme.substring(vm.theme.indexOf('-') + 1, vm.theme.length);
            }
            vm.spinnerTop5 = false;
            vm.spinnerLatestVideos = false;
            vm.spinnerNbVideos = false;
            vm.mostViewd = [];
            mostViewd = [];
            vm.latestVideos = [];
            vm.nbVideos = 0;


            var empStatsQuery = {
                "type": "internet",
                "size": 5,
                "canal": idCanalStat,
                "theme": res
            };
            msApi.request('dashboard.getNbrVideos@get', {
                    "idTheme": res,
                    "idChannel": idCanal
                },
                function (response) {

                    vm.nbVideos = response.data.NbVideos;
                    vm.spinnerNbVideos = true;


                });
            var filtre = {
              "idTheme": res,
              "idChannel": idCanal
            };
            if(vm.mode == "gallery"){
              filtre['length'] = 10;
            }

            msApi.request('dashboard.latest_videos@get', filtre,
                function (response) {


                    vm.latestVideos = response.data.videos;
                    vm.spinnerLatestVideos = true;
                    angular.forEach(vm.latestVideos, function (value, key) {
                        if (value.title.length >= 50) {
                            vm.latestVideos[key].title = value.title.substring(0, 50) + '...';
                        }
                        vm.latestVideos[key].insertDate = moment(value.insertDate).format($rootScope.defaultDateFormat);

                    })

                });
            msApi.request('dashboard.most_viewed_videos@save', {
                    "empStatsQuery": empStatsQuery
                },
                function (response) {
                    vm.spinnerTop5 = true;
                    angular.forEach(response.values, function (value) {
                        var testExistVideo = true;
                        angular.forEach(response.videos, function (v) {
                            if (parseInt(value.key) === v.id) {
                                var title;
                                if (v.title.length >= 50) {
                                    title = v.title.substring(0, 50) + '...'
                                } else {
                                    title = v.title;
                                }
                                mostViewd.push({
                                    "id": v.id,
                                    "title": title,
                                    "views": value.visite_total.value,
                                    "duree": transformSecTOTime(value.duree.duree_sum.value),
                                    "logo": v.logo,
                                    "fileTitle": v.fileTitle
                                });
                                testExistVideo = false;

                            }
                        });
                        vm.mostViewd = mostViewd;
                    });
                    vm.spinnerTop5 = true;

                });
        }

        initHelp();

        function initHelp() {
            $rootScope.titre1 = "PAGESMENUSTITLES.dashboard_menuTitle";
            $rootScope.titre2 = "";
            $rootScope.titre3 = "";

            $rootScope.welcome = "";


        }

        function transformSecTOTime(s) {
            var secs = s % 60;
            s = (s - secs) / 60;
            var mins = s % 60;
            var hrs = (s - mins) / 60;
            return (hrs < 10 ? '0' + hrs : hrs) + ':' + (mins < 10 ? '0' + mins : mins) + ':' + (secs < 10 ? '0' + secs : secs);
        }


        function showVideoDetail(video) {
            msApi.request(
                'dashboard.getTransodedMetaData@get',
                {id: video.id},
                function (res) {
                    var meta = {
                      format: angular.isDefined(res.metaData.data.contentJson.format) ? res.metaData.data.contentJson.format : "",
                      streams: angular.isDefined(res.metaData.data.contentJson.streams) ? res.metaData.data.contentJson.streams : "",
                      other: video
                    };
                    $mdDialog.show({
                        controller: 'mediaVideoMetaModalController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/list/modal.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            metaData: meta,
                            mdDialogTitle: video.title
                        }
                    }).then(function () {
                        //  $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        //   $rootScope.$broadcast('VideoList::setInactive');
                    });
                }, function (response) {
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {

                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                    }
                }
            ).then(function () {
            });

        }

        function exportVideo(video) {

            var spinner = false;
            var lang = "";
            msApi.request(
                'dashboard.getUrlExport@get',
                {id: video.id, lang: lang},
                function (res) {
                    spinner = true;
                    $mdDialog.show({
                        controller: 'mediaVideoUrlModalController',
                        controllerAs: 'vm',
                        templateUrl: 'app/main/media/video/list/url.modale.template.html',
                        clickOutsideToClose: true,
                        locals: {
                            video: res.video,
                            id: video.id
                        }
                    }).then(function () {
                        //    $rootScope.$broadcast('VideoList::setInactive');
                    }, function () {
                        //   $rootScope.$broadcast('VideoList::setInactive');
                    });
                }, function (response) {
                    spinner = true;
                    if (angular.isDefined(response.data) && angular.isDefined(response.data.message)) {
                        $translate('VALIDATIONS.' + response.data.message).then(function (message) {
                            webTvGlobal.alertDialog(message);
                        }, function () {
                            webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                        });
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
            ).then(function () {
            });
        }

        function previewVideo(video, event) {
            VideoGlobal.showPreviewVideo({id: video.id}, event);


        }

        function editVideo(video) {
            if(window.process.env.isNew_Media_Vod){
                localStorage.setItem("edit_filename",video.fileTitle)
                localStorage.setItem("edit_id",video.id)
                $state.go('app.media_video_list');
            }
            else if (video.externalLinkVideo) {
                $state.go('app.media_video_edit_external', {"id": video.id, "title": video.fileTitle});

            } else if (!video.externalLinkVideo && videoMultiTitle !== '0') {
                $state.go('app.media_video_edit_multi_title', {id: video.id, "title": video.fileTitle});

            } else {
                $state.go('app.media_video_edit', {id: video.id, "title": video.fileTitle});
            }
        }


    }

})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .service('webTvGlobal', webTvGlobalService);

    /** @ngInject */
    function webTvGlobalService($injector, webTv_shortMonths, msApi,webtv_france_cities, webTv_languages_list_mini, webTv_languages_list, webTv_parameterBag_callback, app_modules, $timeout, datepicker) {
        var $mdDialog = $injector.get('$mdDialog'),
            $translate = $injector.get('$translate'),
            $rootScope = $injector.get('$rootScope'),
            $mdToast = $injector.get('$mdToast'),
            $cookies = $injector.get('$cookies'),
            msNavigationService = $injector.get('msNavigationService');
        $rootScope.defaultDateFormat = "YYYY-MM-DD";
        var vm = this;
        vm.parameterBag = undefined;
        vm.appModules = undefined;
        var _modules = [];
        var navModules = [];
        vm.services = {
            alertDialog: alertDialog,
            $flashMessages: $flashMessages,
            $constant: $constant,
            $toast: $toast,
            $parameterBag: $parameterBag,
            convertToSelectChoicesFormat: convertToSelectChoicesFormat,
            convertToSelectChoicesFormatWithNull: convertToSelectChoicesFormatWithNull,
            convertToSelectChoicesFormatWithNullOption: convertToSelectChoicesFormatWithNullOption,
            loadSelectListThemes: loadSelectListThemes,
            floatisizeNumericElements: floatisizeNumericElements,
            appServices: appServices,
            setInjectedDependencies: setInjectedDependencies,
            getInjectedDependencies: getInjectedDependencies,
            injectedDependencies: null,
            $window: angular.element(window)[0],
            $document: angular.element(window.document),
            getArrayDiff: getArrayDiff,
            getAppModules: getAppModules,
            getApiRoutes: getApiRoutes,
            underScroreWords: underScroreWords,
            getQueryVariable: getQueryVariable,
            openNewWindow: openNewWindow,
            getUppyUploader: getUppyUploader,
            translateDatePicker: translateDatePicker,
            toHHMMSS: toHHMMSS,
            getPathFile: getPathFile,
            convertArrayToSelectList: convertArrayToSelectList,
            fixDatatableFirefox:fixDatatableFirefox

        };
        if (!vm.services.$parameterBag().hasParameterBag()) vm.services.$constant().webTvParamsCallback();
        if (angular.isUndefined(vm.appModules)) setAppModules(app_modules);
        return vm.services;

        /**
         * Open a new window
         * @param  url : link to open
         */
        function openNewWindow(url) {
            var win = window.open(url, '_blank');
            win.focus();
        }


        function translateDatePicker() {

            /**
             /**
             * Date Picker && Time Picker translation
             */
            //SET Default Date Format
            $rootScope.defaultDateFormat = "YYYY-MM-DD";
            $rootScope.langu = $cookies.get('WEBTV.locale');
            var $mdDateLocaleProvider = $injector.get('$mdDateLocale');
            if (angular.isUndefined($rootScope.toolbarController)) {
                var lang = "fr";
            }
            else {
                var lang = $rootScope.toolbarController.selectedLanguage.code;
            }

            var datePickerTrans = datepicker[lang].data;
            $rootScope.defaultDateFormat = datePickerTrans.dateFormat;
            $rootScope.defaultTimeFormat = datePickerTrans.timeFormat;
            $mdDateLocaleProvider.formatDate = function (date) {
                if (angular.isUndefined(date) || date !== null)
                    return moment(date).format(datePickerTrans.dateFormat);
                else return date;
            };
            $mdDateLocaleProvider.months = datePickerTrans.months;
            $mdDateLocaleProvider.shortMonths = datePickerTrans.shortMonths;
            $mdDateLocaleProvider.days = datePickerTrans.days;
            $mdDateLocaleProvider.shortDays = datePickerTrans.shortDays;
            $mdDateLocaleProvider.msgCalendar = datePickerTrans.msgCalendar;
            $mdDateLocaleProvider.msgOpenCalendar = datePickerTrans.msgOpenCalendar;
            $mdDateLocaleProvider.firstRenderableDate = new Date(datePickerTrans.firstRenderableDate);
            $mdDateLocaleProvider.lastRenderableDate = new Date(datePickerTrans.lastRenderableDate);
            /* if (angular.isDefined(appServices.$mdpLocale)) {
                 var $mdpLocaleProvider = appServices.$mdpLocale;
                 $mdpLocaleProvider.time.okLabel = datePickerTrans.LABEL_OK;
                 $mdpLocaleProvider.time.cancelLabel = datePickerTrans.LABEL_CANCEL;
             }*/


            /**
             * Set FUll CALendar Language
             */
            try {
                if (angular.isDefined($rootScope.setCalendarConfigLanguage) && angular.isFunction($rootScope.setCalendarConfigLanguage)) $rootScope.setCalendarConfigLanguage(lang.language);
            }
            catch (e) {
                $log.debug(e);
            }
            $timeout(function () {
                $rootScope.translationloadingProgress = false;
                //
            });

        }

        /**
         * Gets Query variable
         */
        function getQueryVariable(variable) {
            var query = window.location.search.substring(1);
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (decodeURIComponent(pair[0]) === variable) {
                    return decodeURIComponent(pair[1]);
                }
            }

        }

        /**
         * Set App Available Dependencies
         */
        function setInjectedDependencies() {
            vm.services.injectedDependencies = appServices('WebTv');
        }

        /**
         * Get Dependency
         * @param  dependency : dependency to get
         * @return dependency or null
         */
        function getInjectedDependencies(dependency) {
            return angular.isDefined(dependency) && angular.isObject(vm.services.injectedDependencies) && angular.isDefined(vm.services.injectedDependencies[dependency]) ? vm.services.injectedDependencies[dependency] : null;
        }

        /**
         * Return Application Injected Services
         * @param   mod : application module
         * @param   r : the object where to put services names
         * @return services
         */
        function appServices(mod, r) {
            var inj = angular.isUndefined(angular.element(document).injector()) ? angular.element(document.body).injector() : angular.element(document).injector().get;
            if (!r) r = {};
            angular.forEach(angular.module(mod).requires, function (m) {
                appServices(m, r)
            });
            angular.forEach(angular.module(mod)._invokeQueue, function (a) {
                try {
                    r[a[2][0]] = inj(a[2][0]);
                } catch (e) {
                }
            });
            return r;
        }

        /**
         * store all application module in an array
         */
        function setAppModules(mod) {
            var rx = new RegExp("^app\.", 'i');
            if (angular.isString(mod)) {
                var _mod = angular.module(mod).requires;
                for (var j = 0; j < _mod.length; j++) {
                    var _m = _mod[j];
                    if (!rx.test(_m)) continue;
                    if (_modules.indexOf(_m) === -1) _modules.push(_m);
                    try {
                        setAppModules(_m)
                    } catch (err) {
                    }
                }
            }
            for (var i = 0; i < mod.length; i++) {
                var m = mod[i];
                if (angular.isString(m)) {
                    var _mod = angular.module(m).requires;
                    for (var j = 0; j < _mod.length; j++) {
                        var _m = _mod[j];
                        if (!rx.test(_m)) continue;
                        if (_modules.indexOf(_m) === -1) _modules.push(_m);
                        try {
                            setAppModules(_m)
                        } catch (err) {
                        }
                    }
                }
                if (_modules.indexOf(m) === -1) _modules.push(m);
                try {
                    var _mod = angular.module(m).requires;
                    for (var j = 0; j < _mod.length; j++) {
                        var _m = _mod[j];
                        if (!rx.test(_m)) continue;
                        if (_modules.indexOf(_m) === -1) _modules.push(_m);
                        try {
                            setAppModules(_m)
                        } catch (err) {
                        }
                    }
                }
                catch (err) {
                }
            }
            _modules.sort();
            vm.appModules = _modules;
        }

        /**
         * Get Application Modules
         * @return array containing Apllication modules
         */
        function getNavigationModules(modules) {
            modules.forEach(function (mod) {
                navModules.push("app." + mod._path);
                if (mod.children.length) getNavigationModules(mod.children);
            })
        }

        function getAppModules() {
            _modules = [];
            setAppModules(app_modules);
            getNavigationModules(msNavigationService.getNavigation());
            var appModules = angular.isDefined(vm.appModules) ? vm.appModules : [];
            navModules.forEach(function (mod) {
                if (appModules.indexOf(mod) === -1) appModules.push(mod);
            });
            appModules.sort();
            return appModules;
        }

        /**
         * Get API ROUTES
         * @return array containing API ROUTES
         */
        function getApiRoutes() {
            var routes = [],
                rx = new RegExp('^api_', 'i');
            Routing.getRoutes().a.forEach(function (route) {
                if (rx.test(route)) routes.push(route);
            });
            return routes;
        }

        /**
         * Show Alert Message
         * @param  content Alert Content
         * @param  title   Alert Title , if false then is setted with MESSAGE.alert_error
         * @param  close   Alert close , if false then is setted with MESSAGE.alert_close
         * @param  ev   element
         * @return  Alert Dialog
         */
        function alertDialog(content, title, close, ev) {
            title = title || $translate.instant('MESSAGES.alert_error');
            close = close || $translate.instant('MESSAGES.alert_close');
            var params = {
                title: title,
                htmlContent: content,
                ok: close,
                clickOutsideToClose: true
            };
            if (ev) params.targetEvent = ev;
            var alert = $mdDialog.alert(params);
            $mdDialog
                .show(alert)
                .finally(function () {
                    alert = undefined;
                });
        }

        /**
         * Return Unique array obj from trargetArr and sourceArr
         * @param   trargetArr : the target Object
         * @param   sourceArr : the Source object
         * @return array obj
         */
        function getArrayDiff(trargetArr, sourceArr) {
            var cleaned = [];
            trargetArr.forEach(function (itm) {
                var unique = true;
                sourceArr.forEach(function (itm2) {
                    if (_.isEqual(itm, itm2)) unique = false;
                });
                if (unique) cleaned.push(itm);
            });
            return cleaned;
        }

        /**
         * Flash Messages Getter & Setter
         * @return Getter & Setter
         */
        function $flashMessages() {
            var services = {
                /**
                 * Check If op is the last operation
                 * @param op: name of the operation
                 * @return   true If op is the last operation else false in all cases
                 */
                get: function (op) {
                    if (angular.isUndefined(op) || angular.isUndefined($rootScope.flashMessages)) return false;
                    var hasFlashMeassge = angular.isDefined($rootScope.flashMessages[op]) ? $rootScope.flashMessages[op] : false;
                    return hasFlashMeassge ? $rootScope.flashMessages[op] : false;
                },
                /**
                 * Set the last operation
                 * @param op: name of the operation
                 * @param object: Object treated in the operation
                 */
                set: function (op, $object) {
                    if (angular.isUndefined(op)) return;
                    if (angular.isUndefined($rootScope.flashMessages) || angular.isDefined($rootScope.flashMessages)) $rootScope.flashMessages = {};
                    $rootScope.flashMessages[op] = $object;
                },
                /**
                 * Clear Flash Messages
                 */
                clear: function () {
                    if (angular.isDefined($rootScope.flashMessages)) {
                        $rootScope.flashMessages = undefined;
                        delete $rootScope.flashMessages;
                    }
                }
            };
            return services;
        }

        /**
         * Constants getter
         * @return constant
         */
        function $constant() {
            var constants = {
                /**
                 * languages list
                 * @return array of languages List
                 */
                languagesList: function () {
                    return webTv_languages_list;
                },
                languagesListMini: function () {
                    return webTv_languages_list_mini;
                },
                citiesFranceList: function () {
                    return webtv_france_cities;
                },
                /**
                 * webTv ParameterBag Callback
                 * @return function contains the callback for the ParametersBag Initialisation
                 */
                webTvParamsCallback: function (requestAgain, anotherCallback) {
                    requestAgain = angular.isDefined(requestAgain) ? true : false;
                    var invalidToken = getQueryVariable('r') && getQueryVariable('r') === "cbit" ? true : false;
                    anotherCallback = angular.isDefined(anotherCallback) && angular.isFunction(anotherCallback) ? anotherCallback : null;
                    return webTv_parameterBag_callback(vm.services.$parameterBag().initializeCallback, $cookies, msApi, requestAgain, anotherCallback, invalidToken, $rootScope);
                },
                /**
                 * webTv ParameterBag
                 * @return object containing app parameters
                 */
                webTvParameterBag: function () {
                    if($rootScope.webTv_parameterBag ) $rootScope.$broadcast('parameterBag',$rootScope.webTv_parameterBag );
                    return angular.isDefined($rootScope.webTv_parameterBag) && $rootScope.webTv_parameterBag || {};
                },
                /**
                 * Short Months (exp "Feb.")
                 * @return array of Short Months
                 * The short months are used to show Calendar logo per month
                 */
                shortMonths: function () {
                    return webTv_shortMonths;
                }
            };
            return constants;
        }

        /**
         * Gets Uppy Uploader
         */
        function getUppyUploader(webtvName, userId, scriptURL, state, webTvGlobal) {
            var progressFiles = [];
            var nbSuccess = 0;
            var video = [];
            const uppy = Uppy.Core({
                id: 'uppy',
                debug: true,
                autoProceed: true,
                restrictions: {
                    maxFileSize: 10000000000,
                    maxNumberOfFiles: false,
                    minNumberOfFiles: false,
                    allowedFileTypes: ['video/*']
                }
            })
            uppy.use(Uppy.Dashboard, {
                inline: true,
                maxHeight: 400,
                disableStatusBar: true,
                hideUploadButton: false,
                showProgressDetails: true,
                hideProgressAfterFinish: false,
                disableInformer: false,
                target: '#uppy-dashboard-container',
                locale: {
                    strings: {
                        dropPaste: $translate.instant('MESSAGES.video_upload_uppy_drop'),
                        browse: $translate.instant('MESSAGES.video_upload_uppy_browse')
                    }
                },
                replaceTargetContent: true,
                note: $translate.instant('MESSAGES.video_upload_uppy_message')
            })
            uppy.setMeta({
                path_file: "up-webtv/",
                user_id: userId,
                timestamp: moment().unix(),
                token: md5("unique_salt" + moment().unix()),
                webtv_name: webtvName
            })
            uppy.use(Uppy.XHRUpload, {
                endpoint: scriptURL,
                metaFields: ['path_file', 'timestamp', 'token', 'user_id', 'webtv_name'],
                fieldName: 'Filedata'
            })
            uppy.run()
            uppy.on('upload-progress', function (file, progress) {
                if (progressFiles.indexOf(file.id) === -1) {
                    progressFiles.push(file.id);
                }
            })
            uppy.on('complete', function (result) {
                // console.log('successful files:', result.successful)
                // console.log('failed files:', result.failed)
                for (var i = 0; i < result.successful.length; i++) {
                    var index = progressFiles.indexOf(result.successful[i].id);
                    if (index > -1) {
                        progressFiles.splice(index, 1);
                    }
                }
                for (var i = 0; i < result.failed.length; i++) {
                    var index = progressFiles.indexOf(result.failed[i].id);
                    if (index > -1) {
                        progressFiles.splice(index, 1);
                    }
                }

                nbSuccess = nbSuccess + result.successful.length;
                if ((progressFiles.length == 0) && (nbSuccess == 1)) {
                    var videoKeyName = result.successful["0"].response.body.file_name;
                    var videoFileName = result.successful["0"].name;
                    if (videoFileName && videoKeyName) {
                        state.go('app.media_video_add', {"slug": md5(moment().unix), "title": videoKeyName});
                        webTvGlobal.$toast().showCustom($translate.instant('MESSAGES.file_imported', {fileName: videoFileName}), '', function () {
                            videoKeyName = "";
                        }, false, 500).then(function () {
                        });
                    }
                    else {
                        if (!videoFileName) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                }
                else if ((progressFiles.length == 0) && (nbSuccess > 1)) {
                    $rootScope.index = 2;
                }
            })
        }

        /**
         * Return Array of Objects
         * @param   choicesToConvert
         * @return an array of objects to populate the md-select add add a (number) to end val when val is duplicated
         */
        function convertToSelectChoicesFormat(choicesToConvert) {
            var allOptions = ",";
            var i = 1;
            var converted = Object.keys(choicesToConvert).map(function (key) {
                var val = choicesToConvert[key];
                var regExpression = new RegExp(',' + val, "i");
                if (regExpression.test(allOptions)) val = val + " (" + (i++) + ")";
                allOptions += "," + val;
                var obj = {val: val, option: key, options: key};
                return obj;
            });
            converted.sort(function (a, b) {
                return a.val - b.val;
            });
            return converted;
        }

        function convertToSelectChoicesFormatWithNull(choicesToConvert) {
            var allOptions = ",";
            var i = 1;
            choicesToConvert.null = 0;
            var converted = Object.keys(choicesToConvert).map(function (key) {
                var val = choicesToConvert[key];
                var regExpression = new RegExp(',' + val, "i");
                if (regExpression.test(allOptions)) val = val + " (" + (i++) + ")";
                allOptions += "," + val;
                var obj = {val: val, option: key, options: key};
                return obj;
            });
            converted.sort(function (a, b) {
                return a.val - b.val;
            });
            return converted;
        }

        function convertToSelectChoicesFormatWithNullOption(choicesToConvert) {
            var allOptions = ",";
            var i = 1;
            choicesToConvert.null = {name:"none"};
            var converted = Object.keys(choicesToConvert).map(function (key) {
                var val = choicesToConvert[key];
                var regExpression = new RegExp(',' + val, "i");
                if (regExpression.test(allOptions)) val = val + " (" + (i++) + ")";
                allOptions += "," + val;
                var obj = {val: val, option: key, options: key};
                return obj;
            });
            converted.sort(function (a, b) {
                return a.val - b.val;
            });
            return converted;
        }


        function loadSelectListThemes(listTheme, canalModel) {
            var themes = [];
            if (angular.isUndefined(canalModel) || canalModel.length === 0 || canalModel === 0) {


                angular.forEach(listTheme, function (value) {

                    if (value.themes.length > 0) {
                        themes.push(value);
                    }

                });
                return themes;
            }
            else {


                angular.forEach(listTheme, function (value) {
                    if (value.themes.length > 0 && canalModel === value.id) {
                        themes.push(value);
                    }

                });
                return themes;
            }

        }

        function $toast() {
            var last = {
                    bottom: false,
                    top: true,
                    left: false,
                    center: true,
                    right: false
                },
                toastPosition,
                hideAfter = 5000,
                services = {
                    showSimple: showSimple,
                    showCustom: showCustom,
                    hide: hide
                };
            setToastPosition();
            return services;

            /**
             * Set Toast Position
             * @param position the toast postion , if false we take the initial position setted in the last variable
             */
            function setToastPosition(position) {
                var mdToastPosition;
                if (angular.isDefined(position) && angular.isDefined(position.bottom) && angular.isDefined(position.top) && angular.isDefined(position.left) && angular.isDefined(position.right)) mdToastPosition = position;
                else mdToastPosition = last;
                toastPosition = angular.extend({}, mdToastPosition);
                return toastPosition;
            }

            /**
             * Get Toast Postion
             * @return toastPosition : the position of the toast
             */
            function getToastPosition() {
                return toastPosition;
            }

            /**
             * prepare toast postion before showing it
             */
            function sanitizePosition() {
                var current = getToastPosition();
                if (current.bottom && last.top) current.top = false;
                if (current.top && last.bottom) current.bottom = false;
                if (current.right && last.left) current.left = false;
                if (current.left && last.right) current.right = false;
                last = setToastPosition(current);
            }

            /**
             * get the preShow toast Postion in string format for exemple : "TOP RIGHT"
             * @return string that contain the toast position
             */
            function getToastShowPosition() {
                if (angular.element('ms-info-bar').length) return "bottom right";
                sanitizePosition();
                return Object.keys(toastPosition)
                    .filter(function (pos) {
                        return toastPosition[pos];
                    })
                    .join(' ');
            }

            /**
             * Hide toast(s)
             * @param  toast if setted then hide it else hide all toasts
             */
            function hide(toast) {
                if (toast) $mdToast.hide(toast);
                else $mdToast.hide();
            }

            /**
             * A Simple toast is a toast that contain no action , just a message
             * @param  message       toast message
             * @param  toastPosition toast postion , if not setted  we use the initial position ("TOP RIGHT")
             * @param  hideTimer     hide toast afer x milliseconds , if not setted we use the hideAfter parameters which is equal to 5000ms
             * @param  return Promise   if true return promise
             * @return               toast
             */
            function showSimple(message, toastPosition, hideTimer, returnPromise) {
                setToastPosition(toastPosition);
                var pinTo = getToastShowPosition();
                hideAfter = angular.isDefined(hideTimer) && angular.isNumber(hideTimer) ? hideTimer : hideAfter;
                var toast = $mdToast.simple()
                    .textContent(message)
                    .position(pinTo)
                    .hideDelay(hideAfter);
                if (angular.isDefined(returnPromise) && returnPromise) return $mdToast.show(toast);
                $mdToast.show(toast).then(function () {
                    $flashMessages().clear();
                });
                return toast;
            }

            /**
             * A custom toast is a toast that contain a message + action or actions
             * @param  string   message       toast message
             * @param  string   action        toast action text , if not setted default is "UNDO"
             * @param  {Function} callback    toast action callback , if not setted , just the toast will be closed on action click
             * @param  object   toastPosition toast postion , if not setted  we use the initial position ("TOP RIGHT")
             * @param  hideTimer     hide toast afer x milliseconds , if not setted we use the hideAfter parameters which is equal to 5000ms
             * @return   toast
             */
            function showCustom(message, action, callback, toastPosition, hideTimer) {
                message = message || "";
                action = action || "";
                callback = callback || undefined;
                hideAfter = angular.isDefined(hideTimer) && angular.isNumber(hideTimer) ? hideTimer : hideAfter;
                setToastPosition(toastPosition);
                var pinTo = getToastShowPosition();
                var template = '<md-toast> <span class="md-toast-text" flex>__message__</span> <md-button class="md-highlight" ng-click="doAction($event)"> __action__ </md-button> <md-button class="md-icon-button" ng-click="closeToast()" aria-label="' + $translate.instant('MESSAGES.hide') + '"translate translate-attr-aria-label="MESSAGES.hide"><md-icon md-font-icon="icon-close"></md-icon><md-tooltip md-autohide="true"  md-direction="bottom">{{"MESSAGES.hide"|translate}}</md-tooltip></md-button></md-toast>';
                template = message && template.replace(/__message__/, message);
                template = template.replace(/__action__/, action ? action : $translate.instant('MESSAGES.undo'));
                var customToast = $mdToast.show({
                    hideDelay: hideAfter,
                    position: pinTo,
                    template: template,
                    controller: function ($scope, $mdToast) {
                        $scope.closeToast = closeToast;
                        $scope.doAction = doAction;

                        function closeToast() {
                            $mdToast.hide(customToast);
                        }

                        function doAction() {
                            if (angular.isDefined(callback) && angular.isFunction(callback)) callback();
                            closeToast();
                        }
                    }

                });
                return customToast;
            }
        }

        /**
         * parse float numerical elements
         * @param  object|array|simple elements()
         * @return object|array|simple which its numerical elements are converted to float
         */
        function floatisizeNumericElements(elements) {
            if (typeof elements === "string")
                if (angular.isObject(elements) && angular.isUndefined(elements.length)) {
                    var obj = {};
                    for (var attr in elements) {
                        obj[attr] = !isNaN(elements[attr]) && parseFloat(elements[attr]) || elements[attr];
                    }
                    return obj;
                }
                else if (angular.isArray(elements)) {
                    var arr = {};
                    for (var i = 0; i < elements.length; i++) {
                        arr[i] = !isNaN(elements[i]) && parseFloat(elements[i]) || elements[i];
                    }
                    return arr;
                }
            return !isNaN(elements) && parseFloat(elements) || elements;
        }

        function $parameterBag() {
            var parameterBag = undefined,
                services = {
                    hasParameterBag: hasParameterBag,
                    hasParameter: hasParameter,
                    initialize: initialize,
                    initializeCallback: initializeCallback,
                    get: get,
                    set: set,
                    all: all
                };
            return services;

            function hasParameterBag() {
                return angular.isDefined(vm.parameterBag) || 0;
            }

            function hasParameter(param) {
                return angular.isDefined(vm.parameterBag) && angular.isDefined(vm.parameterBag[param]) || 0;
            }

            function initializeCallback(data) {
                vm.services.$parameterBag().initialize(data);
            }

            function initialize(data) {
                parameterBag = vm.parameterBag = data;
            }

            function get(param) {
                return hasParameter(param) && vm.parameterBag[param] || null;
            }

            function set(param, value) {
                parameterBag[param] = vm.parameterBag[param] = value;
                return vm.services;
            }

            function all() {
                return vm.parameterBag;
            }
        }

        /**
         * Separate Words with underscore+ Letter lower case
         * exp : WebTv ==> web_tv
         * @param  word input
         * @return underscored word
         */
        function underScroreWords(word) {
            if (!/[A-Z]/g.test(word)) return word;
            var _w = word;
            word.replace(/([A-Z])/g, function (rx, match) {
                rx = new RegExp(rx);
                _w = _w.replace(rx, (word.indexOf(match) !== 0 ? "_" : "") + match.toLowerCase());
            });
            return _w;
        }

        function toHHMMSS(string) {
            var sec_num = parseInt(string, 10); // don't forget the second param
            var hours = Math.floor(sec_num / 3600);
            var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
            var seconds = sec_num - (hours * 3600) - (minutes * 60);

            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            var time = hours + ':' + minutes + ':' + seconds;
            return time;
        }

        function fixDatatableFirefox() {
            if (angular.isDefined(document.getElementsByClassName("dataTables_empty")[0])) {
                document.getElementsByClassName("dataTables_empty")[0].setAttribute("colspan", 20);
                document.getElementsByClassName("dataTables_scrollBody")[0].classList.add("scroll_none");
            }


        }

        function getPathFile(subFolder, data, selectedData) {
            var parent = selectedData.parent;
            if(parent && parent!="#"){
                subFolder = subFolder ? data.instance.get_node(parent).text + '/' + subFolder : data.instance.get_node(parent).text;
                return getPathFile(subFolder, data, data.instance.get_node(parent));
            }
            return subFolder;
        };

        function convertArrayToSelectList(choices) {
            var converted = Object.keys(choices).map(function (key) {
                return {val: choices[key], options: key};
            });
            converted.sort(function (a, b) {
                return a.val - b.val;
            });
            return converted;
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(config)
        .service('userManager', userManager);

    /** @ngInject */
    function config(msApiProvider) {
        msApiProvider.register('userManager.getUserData', [Routing.generate('api_core_rights_get_user_rights_by_module')]);
        msApiProvider.register('stats_acces.send_stats_acces', [Routing.generate('api_stats_acces_post_add_stats_acces') ]);

    }

    function userManager(webTv_msNavigation,msNavigationService,webTvGlobal, msApi, $cookies, msUtils, $filter,$rootScope) {
        var um = this;
        um.userData = undefined;
        um.angularAccessList = {};
        um.actionAccessList = {};
        um.actionListByIdByModule = {};
        um.groupIds = [];
        um.actionModule = {};
        um.services = {
            setUserDataCallback: setUserDataCallback,
            setMsNavigation: setMsNavigation,
            setUserData: setUserData,
            getUserData: getUserData,
            hasUserData: hasUserData,
            setAccessList: setAccessList,
            getUser: getUser,
            isGranted: isGranted,
            isActionGranted: isActionGranted,
            isModuleGranted: isModuleGranted,
            isSuperAdmin: isSuperAdmin,
            isAdmin: isAdmin,
            isUser: isUser,
            whoAmI: whoAmI,
            hasRole: hasRole,
            hasRoleGroup: hasRoleGroup,
            getFullName: getFullName,
            getLastName: getLastName,
            getFirstName: getFirstName,
            getEmail: getEmail,
            getUserName: getUserName,
            getId: getId,
            getRoles: getRoles,
            getRolesGroup: getRolesGroup,
            getGroupIds: getGroupIds,
            setGroupIds: setGroupIds,
            hasAccessToGroupAction: hasAccessToGroupAction,
            isSameGroup: isSameGroup,
            hasAccessToUserAction: hasAccessToUserAction,
            isSameUser: isSameUser,
            setUser: setUser,
            statsAccesAction :statsAccesAction,
            getActionIdAndModuleId: getActionIdAndModuleId

        };

        return um.services;

        function hasUserData() {
            return angular.isDefined(um.userData) || 0;
        }

        function setMsNavigation(menu) {
            if(webTv_msNavigation[menu])
            msNavigationService.saveItem2(menu, webTv_msNavigation[menu]);
        }

        function setUserDataCallback(stateCurrent) {
            var invalidToken = webTvGlobal.getQueryVariable('r') && webTvGlobal.getQueryVariable('r') === "cbit" ? true : false;

            if (angular.isUndefined($cookies.get('authToken'))) return;
            else {
                if (invalidToken) return
            }
            msApi.request('userManager.getUserData@get',
                {},
                function (res) {
                    var userData = res.userData;
                    if (angular.isObject(userData)) setUserData(userData);
                    else setUserData(undefined);

                    if (stateCurrent) {
                        setStatsAccesByState(stateCurrent);
                    }
                },
                function () {
                    setUserData(undefined);
                }
            );

        }

        function setAccessList() {
            if (angular.isUndefined(um.userData) || angular.isUndefined(um.userData.modules) || !angular.isObject(um.userData.modules)) return;
            for (var module in um.userData.modules) {
                um.actionModule[module] = false;
                if (angular.isObject(um.userData.modules[module])) {
                    for (var action in um.userData.modules[module]) {
                        if (angular.isObject(um.userData.modules[module][action])) {

                            var _action = um.userData.modules[module][action];
                            um.actionAccessList[_action.name] = _action.authorized;
                            um.actionListByIdByModule[_action.name] = {
                                idAction: _action.idAction,
                                idModule: _action.idModule,
                                authorized: _action.authorized
                            };
                            um.actionModule[module] = !um.actionModule[module] ? _action.authorized : um.actionModule[module];
                            if (angular.isDefined(_action.angModule) && _action.angModule)
                                um.angularAccessList[_action.angModule] = _action.authorized;
                        }
                    }
                }
            }
        }

        function getUserData() {
            return um.userData;
        }

        function setUserData(data) {

            $rootScope.isLoadingApp = true;
            um.userData = data;
            um.services.setAccessList();
            var testValues = angular.isDefined(um.userData) && angular.isDefined(um.userData.user);
            testValues = testValues && angular.isDefined(um.userData.user.groups) && angular.isArray(um.userData.user.groups);
            um.services.setGroupIds(testValues ? um.userData.user.groups : []);
            if(um.services.isSuperAdmin())
            {
                Object.keys(webTv_msNavigation).forEach(function (value) {
                    setMsNavigation(value);
                });
            }
            else
            {
                var menus = data.menus;
                menus.forEach(function (value) {
                    setMsNavigation(value);
                });
            }
        }

        function getUser() {
            var guestUser = {
                "firstName": "Empreinte",
                "lastName": "Guest",
                "username": "guest",
                "email": "guest@empreinte.com",
                "id": -1,
                "vignette": null,
                "phone": null,
                "mobile": null,
                "description": null,
                "groups": null,
                "channels": [],
                "group": null
            };
            return angular.isDefined(um.services.getUserData()) && angular.isDefined(um.services.getUserData().user) ? um.services.getUserData().user : guestUser
        }

        function setUser(user) {
            um.userData.user = user;
        }


        function isGranted(right) {
            if (angular.isUndefined(right) || !right) return true;
            if (um.services.isSuperAdmin()) return true;
            // /*if (/core.*/i.test(right)) {
            //     if (right === "app.core_rights_group" && um.services.isAdmin()) return true;
            //     return false;
            // }
            if (um.services.isUser() && (/^profiles.*/i.test(right) || /^app\.pprofiles.*/i.test(right)))
                return false;
            if (/^app\./i.test(right)) {
                var d = "app." + right.replace(/app\./, "").replace(/_/g, ".");
                var _isGranted = true;
                if (angular.isDefined(um.angularAccessList[right])) _isGranted = um.angularAccessList[right];
                else if (angular.isDefined(um.angularAccessList[d])) _isGranted = um.angularAccessList[d];
                return _isGranted
            }
            return true;
        }

        function isActionGranted(right) {
            if (um.services.isSuperAdmin()) return true;
            if (angular.isUndefined(right) || !right) return true;
            if (right === "") return true;
            var d = right.replace("_action", "");
            var _isGranted = false;
            if (angular.isDefined(um.actionListByIdByModule[right])) _isGranted = um.actionListByIdByModule[right]['authorized'];
            else if (angular.isDefined(um.actionListByIdByModule[d])) _isGranted = um.actionListByIdByModule[d]['authorized'];
            return _isGranted
        }

        function isModuleGranted(right) {
            if (um.services.isSuperAdmin()) return true;
            if (angular.isUndefined(right) || !right) return true;
            if (right === "") return true;
            var _isGranted = false;
            if (angular.isDefined(um.actionModule[right])) _isGranted = um.actionModule[right];
            return _isGranted
        }

        function getRoles() {
            var rolesObject = angular.isDefined(um.services.getUserData()) && angular.isDefined(um.services.getUserData().roles) ? um.services.getUserData().roles : {};
            var roles = [];
            for (var prop in rolesObject) {
                if (angular.isDefined(rolesObject[prop])) {
                    roles.push(rolesObject[prop]);
                }
            }
            return roles;
        }
        function getRolesGroup() {
            var rolesObject = angular.isDefined(um.services.getUserData()) && angular.isDefined(um.services.getUserData().roleGroup) ? um.services.getUserData().roleGroup : {};
            var roles = [];
            for (var prop in rolesObject) {
                if (angular.isDefined(rolesObject[prop])) {
                    roles.push(rolesObject[prop]);
                }
            }
            return roles;
        }
        function hasRoleGroup(role) {
            return angular.isDefined(um.services.getRolesGroup()) && angular.isArray(um.services.getRolesGroup()) ? msUtils.exists(role, um.services.getRolesGroup()) : false
        }

        function whoAmI() {
            return um.services.getFullName() + " and i'am  " + (um.services.isSuperAdmin() ? "SUPER ADMIN" : (um.services.isAdmin() ? "ADMIN" : "USER")) + "  and my roles Are " + angular.toJson(um.services.getRoles());
        }

        function hasRole(role) {
            return angular.isDefined(um.services.getRoles()) && angular.isArray(um.services.getRoles()) ? msUtils.exists(role, um.services.getRoles()) : false
        }

        function isSuperAdmin() {
            return um.services.hasRole('ROLE_SUPERADMIN') || um.services.hasRole('ROLE_SUPER_ADMIN') ? true : false;
        }

        function isAdmin() {
            if (!um.services.isSuperAdmin()) {
                return um.services.hasRole('ROLE_ADMIN') ? true : false;
            }
            return false;
        }

        function isUser() {
            return !!(!um.services.isSuperAdmin() && !um.services.isAdmin());
        }

        function getFullName() {
            var user = um.services.getUser();
            return (angular.isDefined(user.lastName) ? user.lastName : "") + " " + (angular.isDefined(user.firstName) ? user.firstName : "")
        }

        function getLastName() {
            var user = um.services.getUser();
            return (angular.isDefined(user.lastName) ? user.lastName : "");
        }

        function getFirstName() {
            var user = um.services.getUser();
            return (angular.isDefined(user.firstName) ? user.firstName : "");
        }

        function getUserName() {
            var user = um.services.getUser();
            return (angular.isDefined(user.username) ? user.username : "");
        }

        function getEmail() {
            var user = um.services.getUser();
            return (angular.isDefined(user.email) ? user.email : "");
        }

        function getId() {
            var user = um.services.getUser();
            return (angular.isDefined(user.id) ? user.id : "");
        }

        function setGroupIds(groups) {
            um.groupIds = [];
            groups.forEach(function (item) {
                if (angular.isDefined(item.id)) um.groupIds.push(item.id);
            })
        }

        function getGroupIds() {
            return um.groupIds;
        }

        function hasAccessToGroupAction(group) {
            if (um.services.isSuperAdmin()) return true;
            if (um.services.isUser()) return false;
            if (um.services.isAdmin()) {
                if (um.services.isSameGroup(group.id)) return true;
                var isUserGroup = true;
                if (angular.isUndefined(group.roles) || (angular.isArray(group.roles) && group.roles.length === 0 )) return false;
                for (var i = 0; i < group.roles.length; i++) {
                    if (group.roles[i] === "ROLE_ADMIN" || group.roles[i] === "ROLE_SUPERADMIN") {
                        isUserGroup = false;
                        break;
                    }

                }
                return isUserGroup;
            }
        }


        function isSameGroup(groupId) {
            return msUtils.exists(groupId, um.services.getGroupIds()) ? true : false;
        }

        function isSameUser(userId) {
            return userId === um.services.getUser().id;
        }

        function hasAccessToUserAction(user) {
            if (um.services.isSuperAdmin()) return true;
            if (um.services.isUser() && !um.services.hasRoleGroup("ROLE_ADMIN")) return false;
            if (um.services.isAdmin() || um.services.hasRoleGroup("ROLE_ADMIN")) {
                if (um.services.isSameUser(user.id)) return true;
                var isSimpleUser = true;
                var roles = [];
                if (angular.isDefined(user.roles) && angular.isArray(user.roles)) {
                    for (var i = 0; i < user.roles.length; i++) {
                        if (!msUtils.exists(user.roles[i], roles)) roles.push(user.roles[i])
                    }
                }
                if (angular.isDefined(user.groups) && angular.isArray(user.groups)) {
                    for (var k = 0; k < user.groups.length; k++) {
                        if (angular.isDefined(user.groups[k].roles) && angular.isArray(user.groups[k].roles)) {
                            for (var j = 0; j < user.groups[k].roles.length; j++) {
                                if (!msUtils.exists(user.groups[k].roles[j], roles)) roles.push(user.groups[k].roles[j])
                            }
                        }
                    }
                }
                if (roles.length === 0) return false;
                for (var l = 0; l < roles.length; l++) {
                    if (roles[l] === "ROLE_ADMIN" || roles[l] === "ROLE_SUPER_ADMIN") {
                        isSimpleUser = false;
                        break;
                    }

                }
                return isSimpleUser;
            }
        }


        /** Returns Acces Information */
        function statsAccesAction(action, id_object) {
            if(angular.isDefined(action) && action !== "" )
            {
                if (angular.isDefined($cookies.get('authToken'))) {
                    var acces = {};
                    // session id
                    if (angular.isDefined($cookies.get('session_acces'))) {
                        acces.session_id = $cookies.get('session_acces');
                    }
                    else {
                        var currentDate = new Date();
                        var expireDate = new Date(currentDate.getTime() + (20 * 60 * 1000));
                        $cookies.put("session_acces", guidGenerator(), {'expires': expireDate, 'path':"/"});
                        acces.session_id = $cookies.get('session_acces');
                    }
                    acces.action = action;
                    if(id_object){
                        acces.id_object = id_object;
                    }
                    msApi.request(
                      'stats_acces.send_stats_acces@save',
                      acces,
                      function () {

                      },
                      function () {
                      }
                    );
                }
            }

        }

        /** Returns Acces Information */
        function setStatsAccesByState(stateName) {
            if (/^app\./i.test(stateName)) {
                var d = "^(?=.*app." + stateName.replace(/app\./, "").replace(/_/g, ")(.*") + ")*$";
                var angularModule = $filter('regex')(Object.keys(um.angularAccessList), d);
                if (angular.isDefined(angularModule) && angularModule.length > 0) {
                    var values_modules = Object.keys(um.userData.modules).map(function(e) {
                        return um.userData.modules[e]
                    });
                    var m = listModule[0];
                    var values_list_modules = Object.keys(m).map(function(e) {
                        return m[e]
                    });
                    var listModule = $filter('filter')(values_modules, {$: angularModule[0]});
                    var action = $filter('filter')(values_list_modules, {angModule: angularModule[0]}, true);
                    statsAccesAction(action[0].name);
                }
            }
        }

        function getActionIdAndModuleId(action) {
            var response = {};
            var d = action.replace("_action", "");
            if (angular.isDefined(um.actionListByIdByModule[action]))response = um.actionListByIdByModule[action];
            else if (angular.isDefined(um.actionListByIdByModule[d]))response = um.actionListByIdByModule[d];

            return response;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */


        function guidGenerator() {
            /**
             * @return {string}
             */
            var S4 = function () {
                return Math.random().toString(36).substr(2, 9);
            };
            return '_' + S4() + S4() + S4() + S4();
        }


    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at https://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
/**
 * Created by ZCONSULTING on 02/10/2017.
 */
(function () {
    'use strict';
    angular
        .module('app.core')
        .config(config)
        .service('msRights', msRightsService)
        .filter('regex', function () {
            return function (input, regex) {
                var patt = new RegExp(regex);
                var out = [];
                for (var i = 0; i < input.length; i++) {
                    if (patt.test(input[i]))
                        out.push(input[i]);
                }
                return out;
            };
        });

    /** @ngInject */
    function config(msApiProvider) {
        msApiProvider.register('get_saved_modules', [Routing.generate('api_core_rights_get_modules')]);
    }

    function msRightsService(msApi, webTvGlobal, $filter) {
        var rights =
            {
                content: [],
                modules: ["all"]
            };
        var modules = [];
        var savedModules = [];
        var savedModulesArray = [];
        var routes = webTvGlobal.getApiRoutes();
        //modulesInApi();
        var service = {
            saveItem: saveItem,
            getModules: getModules,
            refresh: refresh,
            getContent: getContent,
            getRights: getRights,
            modulesInApi: modulesInApi,
            getSavedModules: getSavedModules,
            getLocalRights: getLocalRights,
            setPermissions: setPermissions,
            setPermissionsStats: setPermissionsStats,
            setPermissionsStatsTabsAndApiNull: setPermissionsStatsTabsAndApiNull,
            getSavedModulesArray: getSavedModulesArray,
            modulesLength: modulesLength
        };
        return service;

        function refresh() {
            modulesInApi();
        }

        function modulesInApi() {
            msApi.request("get_saved_modules@get",
                function (res) {
                    savedModulesArray = [];
                    angular.forEach(res.modules, function (item) {
                        savedModulesArray.push(item);
                    });
                    savedModules = res.modules;
                    return res;
                },
                function (res) {
                    return res;
                }
            );
        }

        function saveItem(item) {
            rights.content.push(item);
            rights.modules.push(item.module);
        }

        function getSavedModulesArray() {
            return (savedModulesArray);
        }

        function modulesLength() {
            return (savedModulesArray.length)
        }

        function getSavedModules() {
            return (savedModules);
        }

        function getModules() {
            return modules;
        }

        function getLocalRights(path) {
            var JsonPath = path + "/modules.json";
            $.getJSON(JsonPath, function (json) {
                saveItem(json);
            });
        }

        function setPermissions(permissions) {

            var permession_by_module = {};
            var routes_by_module = $filter('regex')(routes, permissions.pattern);
            permession_by_module.module = permissions.name_module;
            permession_by_module.contents = [];
            permissions.actions.forEach(function (value_action) {
                var list_action_api = Object.keys(value_action).map(function (e) {
                    return value_action[e]
                });
                var suffix_angular = Object.keys(value_action)[0];
                list_action_api[0].forEach(function (action) {
                    var content = {};
                    content.action = {};
                    content.action.name = permissions.name_module + "_" + action;
                    content.route = $filter('filter')(routes_by_module, action)[0];
                    content.angular_module = permissions.name_angular_module + "." + suffix_angular;
                    content.module = permissions.name_module;
                    permession_by_module.contents.push(content);
                });

            });
            saveItem(permession_by_module);
        }


        function setPermissionsStats(permissions_stats) {

            var actions = [];
            angular.forEach(permissions_stats.actions, function (value_methode) {
                angular.forEach(["vod", "live"], function (type) {
                    angular.forEach(["all", "internet", "intranet", "internet_mobile", "intranet_mobile"], function (value_action) {
                        var action = {};
                        action[type + "_" + value_methode + "_" + value_action] = ["post_" + value_methode];
                        this.push(action);
                    }, actions);
                });
            });
            var permissions = {
                pattern: permissions_stats.pattern,
                name_module: permissions_stats.name_module,
                name_angular_module: permissions_stats.name_angular_module,
                actions: actions
            };

            var permession_by_module = {};
            var routes_by_module = $filter('regex')(routes, permissions.pattern);
            permession_by_module.module = permissions.name_module;
            permession_by_module.contents = [];
            permissions.actions.forEach(function (value_action) {
                var list_action_api = Object.keys(value_action).map(function (e) {
                    return value_action[e]
                });
                var suffix_angular = Object.keys(value_action)[0];
                list_action_api[0].forEach(function (action) {
                    var content = {};
                    content.action = {};
                    content.action.name = permissions.name_module + "_" + suffix_angular;
                    content.route = $filter('filter')(routes_by_module, action)[0];
                    content.angular_module = permissions.name_angular_module;
                    content.module = permissions.name_module;
                    permession_by_module.contents.push(content);
                });

            });
            saveItem(permession_by_module);
        }

        function setPermissionsStatsTabsAndApiNull(permissions) {

            angular.forEach(["vod", "live", "vod_by_id", "live_by_id"], function (type) {
                var permession_by_module = {};
                permession_by_module.module = permissions.name_module + type;
                permession_by_module.contents = [];
                permissions.actions.forEach(function (value_action) {
                    var list_action_api = Object.keys(value_action).map(function (e) {
                        return value_action[e]
                    });
                    var suffix_angular = Object.keys(value_action)[0];
                    list_action_api[0].forEach(function (action) {
                        var content = {};
                        content.action = {};
                        content.action.name = permissions.name_module + "_" + type + "_" + suffix_angular;
                        content.route = permissions.name_module + "_" + type + "_" + action;
                        content.angular_module = permissions.name_angular_module;
                        content.module = permissions.name_module;
                        permession_by_module.contents.push(content);
                    });

                });
                saveItem(permession_by_module);
            });
        }

        function getContent() {
            return rights.content;
        }

        function getRights() {
            var actionName = "";
            rights.content.forEach(function (right) {
                right.contents.forEach(function (element) {
                    element.saved = false;
                    if (angular.isDefined(savedModules[element.module + "_module"])) {
                        savedModules[element.module + "_module"].contents.forEach(function (module) {
                            actionName = element.action.name + "_action";
                            if (module.action.name === actionName) {
                                element.saved = true;
                            }
                        })
                    }
                })
            });
            return rights;
        }

    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .config(function ($httpProvider) {
            $httpProvider.interceptors.push(['$q', '$cookies', 'tokenService', '$injector',
                function ($q, $cookies, tokenService, $injector) {
                    var apiRegExp = new RegExp(Routing.getBaseUrl()+'|'+apiPiper+'|'+apiGo);
                    return {
                        request: function (config) {
                            if (angular.isDefined($cookies.get('authToken'))) {
                                if (apiRegExp.test(config.url) && !/login/.test(config.url)) {
                                    config.headers['Authorization'] = "Bearer " + $cookies.get('authToken');
                                }
                            }
                            return config;
                        },
                        responseError: function(rejection) {
                            if (rejection.status === 401 && rejection.data.message === "Expired JWT Token") {
                  
                              return tokenService.refreshToken()
                                .then(function() {
                                  var $http = $injector.get('$http');
                  
                                  return $http(rejection.config);
                                })
                                .catch(function() {
                                  console.log('Failed to refresh the token');
                                  return $q.reject(rejection);
                                });
                            } else if (rejection.status === 401 && rejection.data.message === "Invalid JWT Token" && window.location.href.indexOf("/profiles/user/create-password") === -1) {
                                return tokenService.deleteAuthToken();
                            }
                      
                            return $q.reject(rejection);
                          }
                    };
                }
            ]);
        })
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider() {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url) {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl() {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject() {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource) {
            if (!angular.isString(key)) {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if (!angular.isArray(resource)) {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url: baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions: resource[2] || [],
                options: resource[3] || {}
            };
        }

        function hasAuthToken(){
         var hasToken = window.location.href.indexOf("login/two-factor-auth") === -1 && window.location.href.indexOf("export/export_") === -1 && window.location.href.indexOf("profiles/user/create-password")=== -1 && window.location.href.indexOf("login/step2")=== -1 && window.location.href.indexOf("inscription") === -1
         console.log(hasToken);
         return hasToken;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope, $state, $cookies, action_delete, $injector) {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register: register,
                resolve: resolve,
                request: request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters) {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object


                    if (angular.isUndefined($cookies.get('authToken')) && hasAuthToken()) {
                        $state.go("app.login-v2", {token: ""});
                    }
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);
                    // Make the call...
                    console.log("params ",params)
                    resourceObject[method](params,

                        // Success
                        function (response) {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response) {
                            deferred.reject(response);

                            if (response.status === 308 && angular.isUndefined(response.data.token)) $state.go("app.profiles_user_password");
                            if (angular.isUndefined($cookies.get('authToken')) && hasAuthToken()) {
                                $state.go("app.login-v2", {token: ""});
                            }else if(window.location.href.indexOf("videos/upload") !==-1){
                                var webTvGlobal = $injector.get('webTvGlobal'),
                                    $translate = $injector.get('$translate');
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                            }else{
                                if (response.status === '401' || response.status === '402' || response.status === '403')
                                    $state.go("app.error_403");
                                if (response.status === '404')
                                    $state.go("app.error_404");
                                // Emit an event
                                $rootScope.$broadcast('msApi::resolveError');
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error) {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if (!resource || !method) {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }
                if(method === "delete"){
                    var indexDelete = resource.replace(".","_");
                    if(angular.isDefined(action_delete[indexDelete])){
                        var actionDelete = action_delete[indexDelete];
                        var id_param;
                        if(angular.isDefined(params.id)){
                            id_param = params.id;
                        }
                        if(!id_param && angular.isDefined(params.list)) {
                            var id_param = params.list.toString();
                        }
                        $rootScope.userManager.statsAccesAction(actionDelete, id_param);
                    }
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];
                var apiObject_paramDefaults = apiObject.paramDefaults;

                if (!apiObject) {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else {
                    // Generate the $resource object based on the stored API object

                    if (angular.isUndefined($cookies.get('authToken')) &&  -1 && hasAuthToken()) {
                         $state.go("app.login-v2", {token: ""});
                    }

                    var resourceObject = $resource(apiObject.url, apiObject_paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if (angular.isDefined(success) && angular.isFunction(success)) {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response) {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);
                            // Call the error function if there is one
                            if ($state.current.url.indexOf("/login") === -1 && angular.isUndefined($cookies.get('authToken')) && hasAuthToken()) {
                                $state.go("app.login-v2", {token: ""});
                            }
                            else if (angular.isDefined(error) && angular.isFunction(error)) {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .service('displayService', displayService);

    /** @ngInject */
    function displayService($templateCache) {
        var vm = this;
        vm.services = {
            renderTemplate: renderTemplate,
            renderScript: renderScript,
            initScreen: initScreen

        };


        return vm.services;


        function initScreen(vm, editorConstants) {
            var screenData = vm.getNewScreenData();
            var widget = vm.disposition.widget;
            screenData.screenName = vm.disposition.type;
            screenData.disposition = vm.disposition.disposition;
            screenData.screenId = vm.disposition.screenId;
            screenData.templateName = vm.disposition.templateName;
            screenData.screenClass = vm.disposition.screenClass;
            screenData.editorWidth = angular.element('.editor-wrapper').innerWidth() - (angular.element('#parametre-content').is(":visible") ? 0 : 350);
            var rat1 = 16;
            var rat2 = 9;
            var ratio = screenData.editorWidth / rat1;
            var calculated_height = ratio * rat2;
            screenData.height =vm.disposition.height ? vm.disposition.height: Math.round(calculated_height) + 200;
            screenData.width = vm.disposition.width ? vm.disposition.width: angular.copy(screenData.editorWidth);
            if (vm.disposition.background) {
                screenData.background = {
                    allowedToUseBackgroundImage: true,
                    useBackgroundImage: "no",
                    color: '#ffffff'
                };
            }
            else {
                screenData.background.allowedToUseBackgroundImage = true;
                screenData.background.color = "#FFFFFF";
            }
            screenData.hasInfoBar = false;
            screenData.useTrans = true;
            screenData.infoBarOptions = editorConstants.infoBar.options;

            if (vm.disposition.background_url) {
                screenData.background.url = vm.disposition.background_url;
            }
            if (vm.disposition.toolbar) {
                screenData.toolbar = vm.disposition.toolbar;
            }
            vm.setScreenBlocs(
                widget,
                screenData,
                screenData.rid
            );
            vm.blocsContent = screenData.blocsContent;
            vm.screens[vm.currentScreenIndex] = screenData;
            vm.screens[vm.currentScreenIndex].originalIndex = vm.currentScreenIndex;
            //editorConstants.infoBar.initialize(vm.screens[vm.currentScreenIndex].infoBarOptions,vm)
            vm.showSideNav();
        }

        /**
         * Open a new window
         * @param  url : link to open
         */
        function getFile(url) {
            return $templateCache.get(url);
        }

        function renderClass(template, screenData) {
            //block
            //class
            var class_screen = template.match(/{{vm\.screens\[vm\.currentScreenIndex\]\.screenClass}}/g);
            angular.forEach(class_screen, function (value, key) {
                template = template.replace(value, screenData.screenClass);
            });

            return template;
        }


        function renderIsDefined(template, screenData) {
            var is_definded = template.match(/ng-if="vm.isDefined(.*?)"/g);
            angular.forEach(is_definded, function (value, key) {
                template = template.replace(value, '');
            });

            return template;
        }

        function renderIdTag(template, screenData) {
            var id_tag = template.match(/{{vm\.screens\[vm\.currentScreenIndex\]\.screenId}}/g);
            angular.forEach(id_tag, function (value, key) {
                template = template.replace(value, screenData.screenId);
            });

            return template;
        }

        function renderInfoBar(template, screenData) {
            var has_info_bar = template.match(/ng-class="{'has-info-bar on-editor':vm.screens(.*?).hasInfoBar}"/g);
            angular.forEach(has_info_bar, function (value, key) {
                if (screenData.hasInfoBar)
                    template = template.replace(value, 'class="has-info-bar on-editor"');
                else
                    template = template.replace(value, '');
            });

            return template;
        }

        function renderScreenRid(template, screenData) {
            var screen_rid = template.match(/{{vm\.screens\[vm\.currentScreenIndex\]\.rid}}/g);

            angular.forEach(screen_rid, function (value, key) {
                template = template.replace(value, screenData.rid);
            });

            return template;
        }


        function renderBackground(template, screenData, backgroundStyle) {

            var background_style = template.match(/{{vm.getBackgroundStyle(.*?)}}/g);
            angular.forEach(background_style, function (value, key) {
                template = template.replace(value, backgroundStyle);
            });

            return template;
        }

        function renderFullScreen(template, screenData) {

            var fullscreen = template.match(/fullscreen="vm.isFullScreen"/g);
            angular.forEach(fullscreen, function (value, key) {
                template = template.replace(value, '');
            });

            return template;
        }

        function renderBlocks(template, screenData) {
            //block
            template = template.replace(/(\r\n\t|\n|\r\t)/gm,"");
            var blocks = template.match(/<ms-block-component-display(.*?)index="(.*?)"(.*?)>/g);
            angular.forEach(blocks, function (value, key) {
                var my_regex = /<ms-block-component-display(.*?)index="(.*?)"(.*?)>/g;
                var index_plock = my_regex.exec(value);
                if(angular.isDefined(screenData.screenBlocsRenderedData) && angular.isDefined(screenData.screenBlocsRenderedData[index_plock[2]])&& angular.isDefined(screenData.screenBlocsRenderedData[index_plock[2]].html))
                template = template.replace(value, "<div id='bloc" + index_plock[2] + "'>" + screenData.screenBlocsRenderedData[index_plock[2]].html + "</div>");
                else template = template.replace(value, "<div id='bloc" + index_plock[2] + "'></div>");
            });

            return template;
        }

        function renderTemplateId(script, template) {
            //block
            var blocks = script.match(/___template_id/g);
            angular.forEach(blocks, function (value, key) {
                script = script.replace(value, template.id);
            });

            return script;
        }


        function renderTemplateFunction(script, template) {
            //block
            var blocks = script.match(/___template_functions/g);
            angular.forEach(blocks, function (value, key) {
                script = script.replace(value, template.functions);
            });

            return script;
        }

        function renderTemplateData(script, template) {
            //block
            var blocks = script.match(/___template_data/g);
            angular.forEach(blocks, function (value, key) {
                script = script.replace(value, template.data);
            });

            return script;
        }

        function renderTemplateStart(script, template) {
            //block
            var blocks = script.match(/___template_start/g);
            angular.forEach(blocks, function (value, key) {
                script = script.replace(value, template.start);
            });

            return script;
        }


        function renderDestroyInfoBarScript(script, destroyInfoBarScript) {
            //block
            var blocks = script.match(/destroyInfoBarScript/g);
            angular.forEach(blocks, function (value, key) {
                script = script.replace(value, destroyInfoBarScript);
            });

            return script;
        }

        /**
         * Open a new window
         * @param  url : link to open
         * @param  screenData : screenData
         * @param  backgroundStyle : template
         */
        function renderTemplate(url, screenData, backgroundStyle) {
            var template = getFile(url);
            template = renderBlocks(template, screenData);
            template = renderBackground(template, screenData, backgroundStyle);
            template = renderFullScreen(template, screenData);
            template = renderScreenRid(template, screenData);
            template = renderClass(template, screenData);
            template = renderInfoBar(template, screenData);
            template = renderIdTag(template, screenData);
            template = renderIsDefined(template, screenData);
            return template;
        }


        /**
         * Open a new window
         * @param  script : link to open
         * @param  template : template
         * @param  destroyInfoBarScript : template
         */
        function renderScript(script, template, destroyInfoBarScript) {
            script = renderTemplateId(script, template);
            script = renderTemplateFunction(script, template);
            script = renderTemplateData(script, template);
            script = renderTemplateStart(script, template);
            script = renderDestroyInfoBarScript(script, destroyInfoBarScript);

            return script;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .service('displayBlocService', displayBlocService);

    /** @ngInject */
    function displayBlocService(urlAssetsConstants, msUtils, $timeout, weatherService) {
        var vm = this;
        var isBlockClickable = ['logo', 'image', 'textEditor'];
        vm.services = {
            initializeBloc: initializeBloc,
            styleFunction: styleFunction,
            getStyle: getStyle,
            blocBasicData: blocBasicData,
            ngIncludeData: ngIncludeData,
            initBlocks: initBlocks
        };


        return vm.services;


        function randomId(length) {
            var chaine = "abcdefghijklmnpqrstuvwxy123456789AZERTYUPQSDFGHJKLMWXCVBN";
            var number = parseInt(Math.random() * 40);
            number = angular.isDefined(length) && length ? length : (number < 22 ? 22 : number);

            var secret = "";
            for (var i = 0; i < number; i++) {
                secret += chaine[parseInt(Math.random() * (chaine.length - 1))];
            }
            return secret;
        }

        function initBlocks(blocks, disableBlocks) {
            var resultBlocks = [];


            angular.forEach(blocks, function (item, key) {
                if (disableBlocks.indexOf(item.type) === -1)
                    resultBlocks.push(blocBasicDataEditorDisposition(item.type + "_" + randomId(4), blocks[item.type]));
            });


            return resultBlocks;
        }

        function getRandomId() {
            return msUtils.guidGenerator().replace(/\./g, "-")
        }

        function getWeather(item) {
            $timeout().then(function () {
                item.data = weatherService.getWeather(item.options.location)
                return item;
            });
        }

        function setSize(val) {
            var value = (Number)(val);
            return !isNaN(value) ? (value + "px") : "auto";
        }

        function pxTOvw(value) {
            var w = window,
                d = document,
                e = d.documentElement,
                g = d.getElementsByTagName('body')[0],
                x = w.innerWidth || e.clientWidth || g.clientWidth,
                y = w.innerHeight || e.clientHeight || g.clientHeight;

            var result = (100 * value) / x;
            return result;
        }

        function getStyle(vm, item) {
            item.options.color = !item.options.color ? vm.activeTheme.primary.contrast1 : item.options.color;
            item.options.background = !item.options.background ? vm.activeTheme.primary.color : item.options.background;
            var style = {
                width: setSize(item.options.width),
                height: setSize(item.options.height),
                display: item.options.display,
                color: item.options.color,
                background: item.options.background,
                render: 'display: ___item_options_display; width:___vm_setSize(item_options_width);height:___vm_setSize(item_options_height);color:___item_options_color;background:___item_options_background;'.replace(/___vm_setSize\(item_options_height\)/, setSize(item.options.height)).replace(/___vm_setSize\(item_options_width\)/, setSize(item.options.width)).replace(/___item_options_color/, item.options.color).replace(/___item_options_background/, item.options.background).replace(/___item_options_display/, item.options.display)

            };
            if (item.options.url) style.href = item.options.url;


            if (item.type === "weather") {
                style.margin_bottom = item.options.margin_bottom;
                style.overflow = "hidden";
                style.render = 'margin-bottom: ___item_options_margin_bottom; display: ___item_options_display; width:___vm_setSize(item_options_width);height:___vm_setSize(item_options_height);color:___item_options_color;background:___item_options_background;'.replace(/___item_options_margin_bottom/, item.options.margin_bottom).replace(/___vm_setSize\(item_options_height\)/, setSize(item.options.height)).replace(/___vm_setSize\(item_options_width\)/, setSize(item.options.width)).replace(/___item_options_color/, item.options.color).replace(/___item_options_background/, item.options.background).replace(/___item_options_display/, item.options.display);
            }
            if (item.type === "video") {

                var width = pxTOvw(item.options.width);
                style.width = width + "vw";
                style.render = 'position:___item_options_position;padding-bottom:___item_options_padding;display: ___item_options_display; width:___vm_setSize(item_options_width);height:___vm_setSize(item_options_height);color:___item_options_color;background:___item_options_background;'.replace(/___vm_setSize\(item_options_height\)/, setSize(item.options.height)).replace(/___vm_setSize\(item_options_width\)/, width + 'vw').replace(/___item_options_color/, item.options.color).replace(/___item_options_background/, item.options.background).replace(/___item_options_display/, item.options.display).replace(/___item_options_padding/, "56.25%").replace(/___item_options_position/, "relative")
            }

            return style;

        }

        function styleFunction() {
            return getStyle;
        }


        function blocBasicData(id, bloc) {
            var blockBasic = {
                "eid": id,
                "type": bloc.type,
                "options": bloc.options,
                "style": getStyle,
                "ngIncludeData": ngIncludeData
            };

            return blockBasic;
        }

        function blocBasicDataEditorDisposition(id, bloc) {
            var blockBasic = {
                "eid": id,
                "icon": bloc.icon,
                templateBlock: bloc.templateBlock,
                "type": bloc.type,
                "options": bloc.options,
                "style": getStyle,
                "ngIncludeData": ngIncludeData
            };

            return blockBasic;
        }


        function ngIncludeData(vm, bloc, item) {
            var newItem = item;
            newItem.style = getStyle;
            var type = bloc.type;
            var isClickable = isBlockClickable.indexOf(type) >= 0 ? true : false;
            return {
                blockType: type,
                templateBlock: bloc.templateBlock,
                bcid: bloc._id,
                id: getRandomId(),
                repeatFrom: [newItem],
                isClickable: isClickable,
                "clickableFunction": isClickable ? function (item, $event) {
                    if (angular.element($event.target).parents('.toolbar').length) {
                        $event.stopPropagation();
                    }
                    if (type === "textEditor") return vm.showElementConfigTab(item, "textEditor", $event); else return vm.showElementConfigTab({"logo": item}, "logo", $event)

                } : null
            }
        }


        /**
         * Open a new window
         * @param  item : link to open
         */
        function initializeBloc(item) {

            var self_item = angular.isDefined(item) ? item : {};
            self_item.defaultOptions = angular.copy(self_item.options);


            if (item.type !== "weather") {
                self_item.defaultOptions.noUrlTrans = "TEMPALTEMANAGEREDITOR.no_link";
                self_item.none = {
                    message: angular.copy(self_item.defaultOptions.noUrlTrans),
                    color: "transparent"
                };
            }
            else if (item.type === "weather") {
                self_item.defaultOptions.noLocationTrans = "TEMPALTEMANAGEREDITOR.no_position";
                self_item.defaultOptions.weatherOnTrans = "TEMPALTEMANAGEREDITOR.weather_on";
                self_item.defaultOptions.currentTrans = "TEMPALTEMANAGEREDITOR.current";
                self_item.none = {
                    message: angular.copy(self_item.defaultOptions.noLocationTrans),
                    color: "primary.color"
                };
                self_item.style_value = {
                    background: "accent.color",
                    color: "accent.contrast1",
                    loading: urlAssetsConstants + "assets/images/display/logos/loading.png"
                };

                self_item.hasPosition = {
                    weatherOn: angular.copy(self_item.defaultOptions.weatherOnTrans),
                    current: angular.copy(self_item.defaultOptions.currentTrans)
                }
            }
            return self_item;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('app.core')
        .service('dialogConfirmDeleteService', dialogConfirmDeleteService);

    /** @ngInject */
    function dialogConfirmDeleteService($injector) {
        var vm = this;
        vm.services = {
            getConfirm: getConfirm

        };
        return vm.services;
        function getConfirm(ev,nbSelectedElements,title,ariaLabel) {
            var confirm;
            var message;
            var $mdDialog = $injector.get('$mdDialog'),
            $translate = $injector.get('$translate');
            if(nbSelectedElements === 1){
                message = 'MESSAGES.dialog_element_will_be_deleted';
            }else{
                message = 'MESSAGES.dialog_list_will_be_deleted';
            }
            confirm = $mdDialog.confirm()
                .title($translate.instant(title))
                .htmlContent($translate.instant(message))
                .ariaLabel($translate.instant(ariaLabel))
                .targetEvent(ev)
                .ok($translate.instant('MESSAGES.dialog_confirm_delete'))
                .cancel($translate.instant('MESSAGES.dialog_cancel'));

            return confirm;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);
              $cookies.put('selectedThemeColor', service.themes.active.theme.accent.color);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
            $cookies.put('selectedThemeColor', service.themes.active.theme.accent.color);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';
    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'purpleTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'deep-purple',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'greenTheme': {
            primary   : {
                name: 'green',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'redTheme': {
            primary   : {
                name: 'red',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'cyan',
                hues: {
                    'default': '400',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'orange',
                hues: {
                    'default': '900',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'blueTheme': {
          primary   : {
            name: 'jordy-blue',
            hues: {
              'default': '400',
              'hue-1'  : '600',
              'hue-2'  : '500',
              'hue-3'  : 'A100'
            }
          },
          accent    : {
            name: 'summer-sky',
            hues: {
              'default': '900',
              'hue-1'  : '400',
              'hue-2'  : '600',
              'hue-3'  : 'A100'
            }
          },
          warn      : {
            name: 'sandy-brown'
          },
          background: {
            name: 'grey',
            hues: {
              'default': 'A100',
              'hue-1'  : 'A100',
              'hue-2'  : '100',
              'hue-3'  : '300'
            }
          }
        },
      'greenV2Theme': {
        primary : {
          name: 'de-york',
          hues: {
            'default': '400',
            'hue-1'  : '600',
            'hue-2'  : '500',
            'hue-3'  : 'A100'
          }
        },
        accent : {
          name: 'Sushi',
          hues: {
            'default': '900',
            'hue-1'  : '400',
            'hue-2'  : '600',
            'hue-3'  : 'A100'
          }
        },
        warn : {
          name: 'Charcoal'
        },
        background : {
          name: 'grey',
          hues: {
            'default': 'A100',
            'hue-1'  : 'A100',
            'hue-2'  : '100',
            'hue-3'  : '300'
          }
        }
      }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();




(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
      {
        name: 'sandy-brown',
        options: {
          '50': '#ffdaab',
          '100': '#ffc880',
          '200': '#dd9434',
          '300': '#F5B159',
          '400': '#F5B159',
          '500': '#F5B159',
          '600': '#F5B159',
          '700': '#F5B159',
          '800': '#F5B159',
          '900': '#F5B159',
          'A100': '#ffc880',
          'A200': '#dd9434',
          'A400': '#b47017',
          'A700': '#F5B159',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
      {
        name: 'summer-sky',
        options: {
          '50': '#a9e1f9',
          '100': '#77cdf2',
          '200': '#2baae1',
          '300': '#099ad0',
          '400': '#4fbceb',
          '500': '#77cdf2',
          '600': '#77cdf2',
          '700': '#2baae1',
          '800': '#2baae1',
          '900': '#2baae1',
          'A100': '#77cdf2',
          'A200': '#77cdf2',
          'A400': '#4fbceb',
          'A700': '#099ad0',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
      {
        name: 'jordy-blue',
        options: {
          '50': '#c4d6f7',
          '100': '#91b1ea',
          '200': '#4875c7',
          '300': '#2a59b0',
          '400': '#6990da',
          '500': '#0b3178',
          '600': '#0b3178',
          '700': '#0b3178',
          '800': '#0b3178',
          '900': '#0b3178',
          'A100': '#91b1ea',
          'A200': '#4875c7',
          'A400': '#6990da',
          'A700': '#304FFE',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
      {
        name: 'de-york',
        options: {
          '50': '#61942C',
          '100': '#61942C',
          '200': '#61942C',
          '300': '#61942C',
          '400': '#61942C',
          '500': '#61942C',
          '600': '#61942C',
          '700': '#61942C',
          '800': '#61942C',
          '900': '#61942C',
          'A100': '#61942C',
          'A200': '#61942C',
          'A400': '#61942C',
          'A700': '#61942C',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
      {
        name: 'Sushi',
        options: {
          '50': '#79BA37',
          '100': '#79BA37',
          '200': '#79BA37',
          '300': '#79BA37',
          '400': '#79BA37',
          '500': '#79BA37',
          '600': '#79BA37',
          '700': '#79BA37',
          '800': '#79BA37',
          '900': '#79BA37',
          'A100': '#79BA37',
          'A200': '#79BA37',
          'A400': '#79BA37',
          'A700': '#79BA37',//'#44C544',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
      {
        name: 'Charcoal',
        options: {
          '50': '#FD8A26',
          '100': '#FD8A26',
          '200': '#FD8A26',//'#606060',
          '300': '#FD8A26',
          '400': '#FD8A26',
          '500': '#FD8A26',
          '600': '#FD8A26',
          '700': '#FD8A26',
          '800': '#FD8A26',
          '900': '#FD8A26',
          'A100': '#FD8A26',
          'A200': '#FD8A26',
          'A400': '#FD8A26',
          'A700': '#FD8A26',
          'contrastDefaultColor': 'light',
          'contrastDarkColors': '50 100 200 A100',
          'contrastStrongLightColors': '300 400'
        }
      },
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

              var gradientColor = theme.accent && theme.accent.levels.default.color?theme.accent.levels.default.color:theme.primary.levels.default.color;
              styleVars['@gradientDefaultColor'] = 'linear-gradient(90deg,'+theme.primary.levels.default.color+' 0%,'+ gradientColor +' 100%)';

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n} [md-theme="@themeName"] .md-gradient-bg {\n    background-image: @gradientDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n} [md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal ul.horizontal > li > div > div.ms-navigation-horizontal-button.ng-scope.active > i, [md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal ul.horizontal > li > div > a.ms-navigation-horizontal-button.ng-scope.active > i, [md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal ul.horizontal > li > div > a.ms-navigation-horizontal-button.ng-scope.active > span.title, [md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal ul.horizontal > li.has-children > div > div.ms-navigation-horizontal-button.ng-scope.active > span.title {color: @accentDefaultColor !important;} [md-theme="@themeName"] #horizontal-navigation .ms-navigation-horizontal ul.horizontal > li > div > a.ms-navigation-horizontal-button.ng-scope.active{    border-bottom: 2px solid @accentDefaultColor;} [md-theme="@themeName"] .confirm-Quitt-Diffusion{color:@backgroundHue1Color !important; background-color: @accentDefaultColor !important;} [md-theme="@themeName"] .page-add-edit .md-accent.md-active, [md-theme="@themeName"] .page-add-edit .md-accent.md-active md-icon{color:@accentDefaultColor !important;} [md-theme="@themeName"] .acces_button .active{    border-bottom: 3px solid @accentDefaultColor;}  [md-theme="@themeName"] md-switch.md-checked.md-primary .md-bar{background-color: @backgroundDefaultContrast3 !important;} [md-theme="@themeName"] md-switch .md-bar {background-color:@accentHue3Color!important;}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

      // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: 'assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: 'assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: 'assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: 'assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: 'assets/images/theme-options/content-only.jpg'
            }
        ];
        vm.layoutMode = $cookies.get('layoutMode') || (angular.isDefined(defaultlayout.mode) ? defaultlayout.mode : "") || 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || (angular.isDefined(defaultlayout.style) ? defaultlayout.style : "") || 'verticalNavigation';
        var layoutTheme = $cookies.get('selectedTheme') || (angular.isDefined(defaultlayout.theme) ? defaultlayout.theme : "") || 'default';
        updateLayoutMode(true);
        $cookies.put('layoutStyle', vm.layoutStyle);
        setActiveTheme(layoutTheme);

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode(init)
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
            $cookies.put('layoutMode', vm.layoutMode);
            if(!init && vm.layoutStyle==="horizontalNavigation") {
                location.reload();
            }
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();

(function ($) {
  'use strict';

  /*
  * Add integers, wrapping at 2^32. This uses 16-bit operations internally
  * to work around bugs in some JS interpreters.
  */
  function safeAdd (x, y) {
    var lsw = (x & 0xFFFF) + (y & 0xFFFF);
    var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
    return (msw << 16) | (lsw & 0xFFFF)
  }

  /*
  * Bitwise rotate a 32-bit number to the left.
  */
  function bitRotateLeft (num, cnt) {
    return (num << cnt) | (num >>> (32 - cnt))
  }

  /*
  * These functions implement the four basic operations the algorithm uses.
  */
  function md5cmn (q, a, b, x, s, t) {
    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
  }
  function md5ff (a, b, c, d, x, s, t) {
    return md5cmn((b & c) | ((~b) & d), a, b, x, s, t)
  }
  function md5gg (a, b, c, d, x, s, t) {
    return md5cmn((b & d) | (c & (~d)), a, b, x, s, t)
  }
  function md5hh (a, b, c, d, x, s, t) {
    return md5cmn(b ^ c ^ d, a, b, x, s, t)
  }
  function md5ii (a, b, c, d, x, s, t) {
    return md5cmn(c ^ (b | (~d)), a, b, x, s, t)
  }

  /*
  * Calculate the MD5 of an array of little-endian words, and a bit length.
  */
  function binlMD5 (x, len) {
    /* append padding */
    x[len >> 5] |= 0x80 << (len % 32);
    x[(((len + 64) >>> 9) << 4) + 14] = len;

    var i;
    var olda;
    var oldb;
    var oldc;
    var oldd;
    var a = 1732584193;
    var b = -271733879;
    var c = -1732584194;
    var d = 271733878;

    for (i = 0; i < x.length; i += 16) {
      olda = a;
      oldb = b;
      oldc = c;
      oldd = d;

      a = md5ff(a, b, c, d, x[i], 7, -680876936);
      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
      c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
      
      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
      b = md5gg(b, c, d, a, x[i], 20, -373897302);
      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);

      a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
      d = md5hh(d, a, b, c, x[i], 11, -358537222);
      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);

      a = md5ii(a, b, c, d, x[i], 6, -198630844);
      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);

      a = safeAdd(a, olda);
      b = safeAdd(b, oldb);
      c = safeAdd(c, oldc);
      d = safeAdd(d, oldd)
    }
    return [a, b, c, d]
  }

  /*
  * Convert an array of little-endian words to a string
  */
  function binl2rstr (input) {
    var i;
    var output = '';
    var length32 = input.length * 32;
    for (i = 0; i < length32; i += 8) {
      output += String.fromCharCode((input[i >> 5] >>> (i % 32)) & 0xFF)
    }
    return output
  }

  /*
  * Convert a raw string to an array of little-endian words
  * Characters >255 have their high-byte silently ignored.
  */
  function rstr2binl (input) {
    var i;
    var output = [];
    output[(input.length >> 2) - 1] = undefined;
    for (i = 0; i < output.length; i += 1) {
      output[i] = 0
    }
    var length8 = input.length * 8;
    for (i = 0; i < length8; i += 8) {
      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xFF) << (i % 32)
    }
    return output
  }

  /*
  * Calculate the MD5 of a raw string
  */
  function rstrMD5 (s) {
    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
  }

  /*
  * Calculate the HMAC-MD5, of a key and some data (raw strings)
  */
  function rstrHMACMD5 (key, data) {
    var i;
    var bkey = rstr2binl(key);
    var ipad = [];
    var opad = [];
    var hash;
    ipad[15] = opad[15] = undefined;
    if (bkey.length > 16) {
      bkey = binlMD5(bkey, key.length * 8)
    }
    for (i = 0; i < 16; i += 1) {
      ipad[i] = bkey[i] ^ 0x36363636;
      opad[i] = bkey[i] ^ 0x5C5C5C5C
    }
    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8);
    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
  }

  /*
  * Convert a raw string to a hex string
  */
  function rstr2hex (input) {
    var hexTab = '0123456789abcdef';
    var output = '';
    var x;
    var i;
    for (i = 0; i < input.length; i += 1) {
      x = input.charCodeAt(i);
      output += hexTab.charAt((x >>> 4) & 0x0F) +
      hexTab.charAt(x & 0x0F)
    }
    return output
  }

  /*
  * Encode a string as utf-8
  */
  function str2rstrUTF8 (input) {
    return unescape(encodeURIComponent(input))
  }

  /*
  * Take string arguments and return either raw or hex encoded strings
  */
  function rawMD5 (s) {
    return rstrMD5(str2rstrUTF8(s))
  }
  function hexMD5 (s) {
    return rstr2hex(rawMD5(s))
  }
  function rawHMACMD5 (k, d) {
    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
  }
  function hexHMACMD5 (k, d) {
    return rstr2hex(rawHMACMD5(k, d))
  }

  function md5 (string, key, raw) {
    if (!key) {
      if (!raw) {
        return hexMD5(string)
      }
      return rawMD5(string)
    }
    if (!raw) {
      return hexHMACMD5(key, string)
    }
    return rawHMACMD5(key, string)
  }

  if (typeof define === 'function' && define.amd) {
    define(function () {
      return md5;
    });
    define(function () {
      return roundWithPrecision;
    })
  } else if (typeof module === 'object' && module.exports) {
    module.exports = md5
  } else {
    $.md5 = md5;
    $.roundWithPrecision = roundWithPrecision
  }



  function roundWithPrecision (value, precision) {
    var m, f, isHalf, sgn; // helper variables
    if(angular.isUndefined(precision))precision=0;
    m = Math.pow(10, precision);
    value *= m;
    sgn = (value > 0 ? 1 : (value < 0 ? -1 : 0) );
    isHalf = value % 1 === 0.5 * sgn;
    f = Math.floor(value);
    if (isHalf)value = f + (sgn > 0);
    return (isHalf ? value : Math.round(value)) / m
  }
        

  if (typeof define === 'function' && define.amd) {
    define(function () {
      return roundWithPrecision
    })
  } else if (typeof module === 'object' && module.exports) {
    module.exports = roundWithPrecision
  } else {
    
  }






}(this));


(function (global)
{
    'use strict';
    var getVarFromArguments = function(varToLooKFor,args){
        if(angular.isDefined(varToLooKFor) && varToLooKFor && angular.isDefined(args)){
            if(args instanceof Array && args.length > 0){
                for(var i=0;i<args.length;i++){
                    if(angular.isObject(args[i]) && angular.isDefined(args[i].name) && args[i].name == varToLooKFor)return args[i];
                }
            }
            else if(args instanceof Object){
                for(var attr in args){
                    if(angular.isFunction(args[attr]) && angular.isDefined(args[attr].name) && args[attr].name == varToLooKFor)return args[attr]();
                }
            }
            return false;

        }
        else return null;
    };
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return getVarFromArguments
        })
    } else if (typeof module === 'object' && module.exports) {
        module.exports = getVarFromArguments
    } else {
        global.getVarFromArguments=getVarFromArguments
    }

})(window);
(function (){
String.prototype.toSeconds = function () { if (!this) return null; var hms = this.split(':'); return (+hms[0]) * 60 * 60 + (+hms[1]) * 60 + (+hms[2] || 0); };
Array.prototype.diffFrom=function(d){var a=[];this.forEach(function(b){var c=!0;d.forEach(function(a){_.isEqual(b,a)&&(c=!1)});c&&a.push(b)});return a};
String.prototype.capitalize = function() {return this.charAt(0).toUpperCase() + this.slice(1);};
String.prototype.humanize=function() {
    var frags = this.split('_');
    for (i = 1; i < frags.length; i++) {
        frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join('');
};
})();



(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('translateFilter', translateFilter);

    /** @ngInject */
    function translateFilter($translate) {
        return _.memoize(function (input, param) {
            if (!param) {
                return input;
            }
            var searchVal = param.toLowerCase();
            var result = [];
            angular.forEach(input, function (value) {
                var translated = $translate("LANGUAGES.Names."+value.val);
                translated.then(function (translatedValues) {
                    if (translatedValues.toLowerCase().indexOf(searchVal) !== -1) {
                        result.push(value);
                    }
                })
            });
            return result;
        }, function(input, param) { return JSON.stringify(input)+JSON.stringify(param) });
    }


})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds)
        .filter('deleteByPropNotIds', deleteByPropNotIds);

    /** @ngInject */
    function filterByPropIds() {
        return function (items, parameter, ids) {
            if (items.length === 0 || !ids || ids.length === 0) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var match = false;

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter].indexOf(id) > -1) {
                        match = true;
                        break;
                    }
                }

                if (match) {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

    function deleteByPropNotIds() {
        return function (items, parameter, ids) {
            if (items.length === 0 || !ids || ids.length === 0) {
                return items;
            }

            var filtered = [];

            for (var i = 0; i < items.length; i++) {
                var item = items[i];

                for (var j = 0; j < ids.length; j++) {
                    var id = ids[j];
                    if (item[parameter] === null)
                        filtered.push(item);
                    else if (item[parameter]["id"] === id) {
                            item[parameter] = null;
                            filtered.push(item);

                        }
                        else {
                            filtered.push(item);
                        }
                    }



            }

            return filtered;

        };
    }


})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds)
        .filter('filterByNotIds', filterByNotIds)
        .filter('dataFilter', dataFilter)

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

    function filterByNotIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id !== id )
                    {
                        filtered.push(item);
                    }
                }
                
            }

            return filtered;

        };
    }

    function dataFilter() {
      return function (data, params) {
        var filtred = [];
        var match = false;
        if (angular.isUndefined(params)) {
          return data;
        }
        for (var i = 0; i < data.length; i++) {
          var item = data[i];
          if (item.title.indexOf(params) > -1) {
            match = true;

          }
          for (var j = 0; j < item.themes; j++) {
            if (item.themes[j].indexOf(params) > -1) {
              match = true;
              break;
            }
          }
          for (var k = 0; k < item.canals; k++) {
            if (item.canals[k].indexOf(params) > -1) {
              match = true;
              break;
            }
          }
          if (match) {
            filtred.push(item);
          }
        }
        return filtred;
      }

    }
})();

/**
 * Created by ZCONSULTING on 18/10/2017.
 */

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('deletestring', function () {
            return function (input, word) {
                if (input.indexOf(word) > 0)
                    return input.substring(0, input.indexOf(word));
                else
                    return input;

            };
        });
})();
(function () {
  'use strict';
  /*todo font menu frog*/
  var webTv_msNavigation = window.menu_app
  angular
    .module('app.core')
    .constant('webTv_msNavigation', webTv_msNavigation);

})();




(function () {
    'use strict';
    var isNotEmpty = function (obj) {
        for (var prop in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, prop)) {
                return true;
            }
        }
        return false;
    };
    var webtv_client_images = {
      demo: "assets/clients/empreinte.png",
      dassault: "assets/clients/dassault.png",
      frogmedia: "assets/clients/frogmedia.png",
      "matele-ad": "assets/clients/matele-ad.png",
      safran: "assets/clients/safran.png",
      safran_preprod: "assets/clients/safran_preprod.png",
      cnam: "assets/clients/cnam.png",
      gers: "assets/clients/gers.png",
      minefi:"assets/clients/minefi.png",
      cned:"assets/clients/cned.png",
      assur:"assets/clients/assur-media.png",
      unesco:"assets/clients/unesco.svg"
    };
    var webtv_client_images_style = {
        "matele-ad": {"width": "29%"},
    };
    var webtv_client_logo_style = {
        "gers": {"max-width": "35%"},
        "minefi": {"max-width": "54%"},
        "cned":{"max-width":"56%"}
    };
    
    var webtv_client_header_style = {
        "matele-ad": {"isNew":true, "logo_image": "empreinte","logo_text":"TV Center","isMG":false,"logo_image_path":"assets/clients/matele-ad.png", "logo_image_style":{"span":{"width": "40px","height": "40px"},"img":{"vertical-align": "bottom"}}}
    };
    var webtv_icons = {
        "programZone": "icon-calendar-plus",
        "video": "icon-video",
        "videoIntro": "icon-video",
        "logo": "icon-file-image-box",
        "image": "icon-file-image",
        "textEditor": "icon-format-align-left",
        "weather": "icon-white-balance-sunny",
        "youtube": "icon-youtube",
        "twitter": "icon-twitter-circle",
        "scoop": "icon-receipt",
        "web": "icon-web",
        "facebook": "icon-facebook-box"
    }
    var webtv_clients = ["demo", "dassault", "matele-ad","safran","safran_preprod","cnam","gers","minefi","cned","assur","unesco"];
    var webtv_france_cities = ["Aast","Abancourt","Abbans-Dessus","Abbaretz","Abbecourt","Abbeville","Abbeville-les-Conflans","Abeilhan","Abere","Abergement-Saint-Jean","Abilly","Ablain-Saint-Nazaire","Ablaincourt-Pressoir","Ablainzevelle","Ablis","Ablon-sur-Seine","Abondance","Abondant","Abreschviller","Abrest","Abscon","Abzac","Abzac","Achatel","Achenheim","Acheres","Acheville","Achicourt","Achiet-le-Grand","Achiet-le-Petit","Acigne","Acq","Acquigny","Acy-en-Multien","Adam-les-Vercel","Adamswiller","Adelans-et-le-Val-de-Bithaine","Adissan","Adriers","Afa","Agay","Agde","Agen","Agneaux","Agnetz","Agnin","Agnos","Agny","Aguilcourt","Ahaxe-Alciette-Bascassan","Ahuille","Ahun","Ahuy","Aiffres","Aigaliers","Aiglemont","Aignan","Aigne","Aigny","Aigonnay","Aigre","Aigrefeuille","Aigrefeuille-d'Aunis","Aigrefeuille-sur-Maine","Aigremont","Aigremont","Aiguebelette-le-Lac","Aiguebelle","Aigueblanche","Aiguefonde","Aigueperse","Aigueperse","Aigues-Mortes","Aigues-Vives","Aigues-Vives","Aiguillon","Ailette","Aillas","Aillevillers-et-Lyaumont","Aillon-le-Vieux","Ailly-le-Haut-Clocher","Ailly-sur-Noye","Ailly-sur-Somme","Aimargues","Aime","Ainay-le-Chateau","Aincourt","Ainhoa","Airaines","Aire-sur-l'Adour","Aire-sur-la-Lys","Airel","Airvault","Aiserey","Aissey","Aiton","Aix-Noulette","Aix-en-Ergny","Aix-en-Issart","Aix-en-Othe","Aix-en-Provence","Aix-les-Bains","Aixe-sur-Vienne","Aizenay","Ajaccio","Alairac","Alata","Alban","Albas","Albefeuille-Lagarde","Albens","Albert","Albertville","Albi","Albias","Albigny-sur-Saone","Albiosc","Albon-d'Ardeche","Alboussiere","Albussac","Alby-sur-Cheran","Alenya","Alençon","Alfortville","Algolsheim","Algrange","Alignan-du-Vent","Alissas","Alix","Alixan","Alizay","Allain","Allaire","Allan","Allassac","Allauch","Allegre","Alleins","Allemans-du-Dropt","Allennes-les-Marais","Alleriot","Allery","Allevard","Alliancelles","Allier","Allieres","Allinges","Allogny","Allondrelle-la-Malmaison","Allonne","Allonne","Allonnes","Allonnes","Allonville","Allonzier-la-Caille","Allos","Allouagne","Alloue","Allouis","Allouville-Bellefosse","Alluy","Alluyes","Ally","Alos-Sibas-Abense","Alteckendorf","Altkirch","Altorf","Altviller","Alvimare","Alzonne","Alès","Aléria","Amagney","Amailloux","Amancey","Amancy","Amange","Amanlis","Amanvillers","Amathay-Vesigneux","Amaye-sur-Orne","Ambazac","Amberac","Amberieux","Amberieux-en-Dombes","Ambert","Ambes","Ambierle","Ambleny","Ambleteuse","Amboise","Ambon","Ambonnay","Ambres","Ambrieres","Ambronay","Ambrus","Ambutrix","Ambérieu-en-Bugey","Amelecourt","Amelie-les-Bains-Palalda","Amen","Ames","Amfreville","Amfreville-la-Mi-Voie","Amfreville-sous-les-Monts","Amiens","Amigny","Amigny-Rouy","Amillis","Amilly","Ammerschwihr","Ammerzwiller","Amneville","Amou","Amplepuis","Amponville","Ampuis","Ampus","Amure","Anais","Ance","Anceaumeville","Ancemont","Ancenis","Ancerville","Anche","Anchenoncourt-et-Chazel","Ancinnes","Ancizan","Ancone","Ancy","Ancy-le-Franc","Ancy-sur-Moselle","Andance","Andancette","Andard","Ande","Andechy","Andel","Andelot-Morval","Andernos-les-Bains","Andeville","Andigne","Andilly","Andilly","Andilly","Andoins","Andolsheim","Andon","Andonville","Andouille","Andouille-Neuville","Andres","Andrest","Andresy","Andreze","Andrezieux-Boutheon","Anduze","Anet","Anetz","Ange","Angeac-Champagne","Angeac-Charente","Angely","Angers","Angerville-l'Orcher","Angerville-la-Martel","Angervilliers","Angevillers","Angicourt","Angiens","Anglade","Anglefort","Angles","Anglesqueville-l'Esneval","Anglet","Angliers","Anglure","Angoulins","Angoulême","Angoume","Angoville-sur-Ay","Angres","Anguerny","Angy","Anhaux","Anhiers","Aniane","Aniche","Anizy-le-Chateau","Anjou","Anjoutey","Anlhiac","Annay","Annay-sur-Serein","Annebault","Annecy","Annecy-le-Vieux","Annemasse","Annepont","Annequin","Annesse-et-Beaulieu","Annet-sur-Marne","Anneville-Ambourville","Anneyron","Annezay","Annezin","Annoeullin","Annois","Annonay","Annot","Annouville-Vilmesnil","Anor","Anould","Ansac-sur-Vienne","Ansauvillers","Anse","Ansouis","Antagnac","Anteuil","Anthe","Antheuil-Portes","Anthon","Anthy-sur-Leman","Antibes","Antignac","Antignac","Antigny","Antilly","Antilly","Antogny le Tillac","Antony","Antrain","Anzat-le-Luguet","Anzin","Anzin-Saint-Aubin","Anzy-le-Duc","Aoste","Aougny","Aouste-sur-Sye","Apach","Apcher","Apcher","Appenwihr","Appeville","Appeville-Annebault","Appietto","Appoigny","Apprieu","Apremont","Apremont","Apt","Araches-la-Frasse","Aragon","Aramits","Aramon","Arancou","Arbent","Arberats-Sillegue","Arbin","Arbois","Arbonne","Arboucave","Arbus","Arbusigny","Arc-et-Senans","Arc-sur-Tille","Arcachon","Arcay","Arcens","Arces","Archamps","Arche","Arches","Archettes","Archiac","Archingeay","Arcine","Arcis-sur-Aube","Arcon","Arcon","Arcueil","Arcy-Sainte-Restitue","Ardenay-sur-Merize","Ardentes","Ardes","Ardiege","Ardillieres","Ardoix","Ardon","Ardres","Areines","Arengosse","Arenthon","Ares","Aressy","Arette","Argancy","Argelers","Argeles-Gazost","Argeliers","Argelliers","Argences","Argens","Argent-sur-Sauldre","Argentan","Argentat","Argenteuil","Argentiere","Argentine","Argenton-les-Vallees","Argenton-sur-Creuse","Argentre","Argentre-du-Plessis","Argeville","Argol","Argueil","Arinthod","Arlanc","Arlay","Arlebosc","Arles","Arles","Arleux","Arleux-en-Gohelle","Armaucourt","Armbouts-Cappel","Armenonville-les-Gatineaux","Armentières","Armes","Armoy","Arnac-Pompadour","Arnage","Arnas","Arnay-le-Duc","Arnieres-sur-Iton","Arnouville","Arnouville-les-Mantes","Aron","Arpaillargues-et-Aureillac","Arpajon","Arpajon-sur-Cere","Arpenans","Arpheuilles-Saint-Priest","Arques","Arques-la-Bataille","Arquettes-en-Val","Arrabloy","Arradon","Arras","Arraute-Charritte","Arreau","Arrenes","Arrigas","Arrigny","Arrou","Ars","Ars-Laquenexy","Ars-en-Re","Ars-sur-Formans","Ars-sur-Moselle","Arsac","Arsac-en-Velay","Arsague","Artannes-sur-Indre","Artas","Artenay","Arthaz-Pont-Notre-Dame","Arthes","Arthez-d'Asson","Arthez-de-Bearn","Arthon","Arthon-en-Retz","Artigat","Artigueloutan","Artiguelouve","Artigues","Artigues-pres-Bordeaux","Artix","Artolsheim","Arudy","Arvert","Arveyres","Arvillard","Arville","Arvillers","Arx","Arzacq-Arraziguet","Arzal","Arzano","Arzon","Asasp-Arros","Ascain","Ascheres-le-Marche","Ascoux","Ascq","Aslonnes","Asnans-Beauvoisin","Asnieres","Asnieres-sur-Oise","Asnieres-sur-Seine","Aspach-le-Bas","Aspach-le-Haut","Asperes","Aspet","Aspremont","Asque","Assas","Assat","Assay","Assevent","Assier","Assignan","Asson","Astaffort","Astille","Astis","Athee","Athesans-Etroitefontaine","Athies","Athies-sous-Laon","Athis-Mons","Athis-de-l'Orne","Attenschwiller","Attiches","Attichy","Attignat-Oncin","Attigny","Atton","Atur","Aubagne","Aubais","Aubas","Aubenas","Auberchicourt","Aubergenville","Auberives-sur-Vareze","Aubers","Auberville-la-Campagne","Auberville-la-Renault","Aubervilliers","Aubevoye","Aubiac","Aubie-et-Espessas","Aubiere","Aubiet","Aubignan","Aubigne","Aubigne-Racan","Aubigney","Aubigny","Aubigny-au-Bac","Aubigny-en-Artois","Aubigny-en-Laonnois","Aubigny-en-Plaine","Aubigny-sur-Nère","Aubin","Aubin","Aubin-Saint-Vaast","Aubinges","Aubord","Auboue","Aubrac","Aubrives","Aubry-du-Hainaut","Aubusson","Auby","Aucamville","Auch","Auchel","Auchy-les-Hesdin","Auchy-les-Mines","Auchy-lez-Orchies","Audelange","Audenge","Audes","Audierne","Audignies","Audincourt","Audincthun","Audruicq","Audun-le-Roman","Audun-le-Tiche","Auffargis","Auffay","Auffreville-Brasseuil","Auga","Augignac","Augny","Aulhat-Saint-Privat","Aulnat","Aulnay","Aulnay-sous-Bois","Aulnay-sur-Marne","Aulnay-sur-Mauldre","Aulnoye-Aymeries","Ault","Aumagne","Aumale","Aumenancourt","Aumetz","Aumont","Aumont-Aubrac","Aumont-en-Halatte","Aumontzey","Aumur","Aunay-les-Bois","Aunay-sous-Auneau","Aunay-sur-Odon","Auneau","Auneuil","Aups","Auray","Aurec-sur-Loire","Aureil","Aureilhan","Aureilhan","Auriac","Auriac","Auriac-sur-Vendinelle","Auribeau-sur-Siagne","Aurignac","Aurillac","Auriol","Aurons","Aussevielle","Aussillon","Aussonce","Aussonne","Autechaux","Auterive","Auterive","Auteuil","Auteuil","Autevielle-Saint-Martin-Bideren","Authevernes","Authie","Authie","Authon","Authou","Authouillet","Autoreille","Autrans","Autreche","Autremencourt","Autreville","Autry-le-Chatel","Autun","Auvergny","Auvers","Auvers-Saint-Georges","Auvers-sur-Oise","Auvillar","Auvillars","Auvillers-les-Forges","Auvilliers-en-Gatinais","Auxais","Auxances","Auxange","Auxerre","Auxey-Duresses","Auxi-le-Chateau","Auxon","Auxon-Dessous","Auxon-Dessus","Auxonne","Auxy","Auzances","Auzeville-Tolosane","Auzielle","Auzon","Auzouer-en-Touraine","Availles-Limouzine","Avallon","Avancon","Avanne-Aveney","Avanton","Avaray","Aveize","Aveizieux","Avelin","Aveluy","Avenay","Avenay-Val-d'Or","Avensan","Aventignan","Averdoingt","Averdon","Averton","Avesnelles","Avesnes-en-Bray","Avesnes-le-Comte","Avesnes-le-Sec","Avesnes-les-Aubert","Avesnes-sur-Helpe","Aveze","Aveze","Aviernoz","Avignon","Avignonet-Lauragais","Avion","Aviron","Avize","Avoine","Avon","Avon-la-Peze","Avord","Avot","Avrainville","Avranches","Avremesnil","Avressieux","Avril","Avrille","Ax-les-Thermes","Aydat","Ayencourt","Ayette","Ayguemorte-les-Graves","Ayguesvives","Aymeries","Aynac","Ayrens","Ayse","Aytre","Azas","Azay-le-Brule","Azay-le-Rideau","Azay-sur-Cher","Azay-sur-Indre","Aze","Aze","Azerables","Azerailles","Azet","Azille","Azur","Azy-sur-Marne","Aÿ","Babeau-Bouldoux","Baccarat","Bach","Bachant","Bachy","Bacilly","Baconnes","Bacqueville","Bacqueville-en-Caux","Baden","Badevel","Bagard","Bagas","Bage-la-Ville","Bages","Bagnac-sur-Cele","Bagneaux","Bagneaux-sur-Loing","Bagneux","Bagnoles-de-l'Orne","Bagnolet","Bagnols","Bagnols","Bagnols-en-Foret","Bagnols-sur-Ceze","Bagnères-de-Bigorre","Bagnères-de-Luchon","Baguer-Morvan","Baguer-Pican","Baho","Baignes-Sainte-Radegonde","Baigneux-les-Juifs","Baillargues","Bailleau-l'Évêque","Bailleau-le-Pin","Baillet-en-France","Bailleul","Bailleul-Sir-Berthoult","Bailleul-le-Soc","Bailleul-sur-Therain","Bailly","Bailly","Bailly-Carrois","Bailly-Romainvilliers","Bailly-le-Franc","Bain-de-Bretagne","Bains","Bains-les-Bains","Bains-sur-Oust","Bainville-sur-Madon","Baisieux","Baixas","Bajus","Balagny-sur-Therain","Balan","Balanod","Balaruc-le-Vieux","Balaruc-les-Bains","Balaze","Balbigny","Baldenheim","Baldersheim","Balgau","Ballainvilliers","Ballaison","Ballan-Mire","Ballancourt-sur-Essonne","Balleroy","Ballon","Ballon","Balma","Balschwiller","Balzac","Ban-de-Laveline","Banassac","Bandol AOC","Bangor","Banize","Bannalec","Banne","Bannes","Bannieres","Banon","Bantigny","Bantzenheim","Banville","Banvou","Banyuls de la Marenda","Banyuls-dels-Aspres","Bapaume","Bar-le-Duc","Bar-sur-Aube","Bar-sur-Seine","Baraqueville","Barastre","Barbaira","Barbaste","Barbatre","Barbazan-Debat","Barbechat","Barbentane","Barberaz","Barbery","Barbeville","Barbezieux-Saint-Hilaire","Barbieres","Barbizon","Barby","Barc","Barcelonnette","Bardos","Barembach","Barentin","Barenton-Bugny","Barfleur","Barges","Barinque","Barisey-au-Plain","Barisey-la-Cote","Barjac","Barjols","Barjon","Barjouville","Barlin","Barneville-Carteret","Baron","Baron","Baronville","Barr","Barraux","Barreme","Barro","Barrou","Bartenheim","Barville-en-Gâtinais","Barzy-en-Thierache","Bas-en-Basset","Bascons","Bassan","Basse-Goulaine","Basse-Ham","Basse-Rentgen","Basse-sur-le-Rupt","Bassemberg","Bassens","Bassens","Bassigney","Bassillac","Bassoles-Aulers","Bassou","Bassu","Bassussarry","Bastennes","Bastia","Batilly","Batilly-en-Gatinais","Battenheim","Battrans","Batz-sur-Mer","Batzendorf","Baud","Baudemont","Baudreix","Baulay","Baule","Baulne","Baulon","Baume-les-Dames","Baume-les-Messieurs","Baune","Baupte","Baurech","Bauvin","Bavans","Bavay","Bavent","Bavilliers","Bavincourt","Baye","Bayet","Bayeux","Bayon","Bayonne","Bazailles","Bazancourt","Bazarnes","Bazas","Bazeilles","Bazemont","Bazens","Bazet","Bazian","Bazicourt","Baziege","Bazien","Bazincourt-sur-Epte","Bazoches","Bazoches-les-Gallerandes","Bazoches-sur-Guyonne","Bazoches-sur-Hoene","Bazoches-sur-le-Betz","Bazoges-en-Paillers","Bazoilles-sur-Meuse","Bazoncourt","Bazouges-la-Perouse","Bazouges-sous-Hede","Bazouges-sur-le-Loir","Bazuel","Beaucaire","Beaucamps-Ligny","Beaucamps-le-Vieux","Beauce","Beauchamp","Beauchamps","Beauchamps","Beauchamps-sur-Huillard","Beauchastel","Beauchene","Beaucourt","Beaucouze","Beaucroissant","Beaudricourt","Beaufort","Beaufort","Beaufort","Beaufort-en-Vallee","Beaufou","Beaugency","Beaujeu","Beaulieu-sous-Parthenay","Beaulieu-sur-Dordogne","Beaulieu-sur-Loire","Beaulieu-sur-Mer","Beaumetz-les-Loges","Beaumont","Beaumont","Beaumont","Beaumont-Hague","Beaumont-Pied-de-Boeuf","Beaumont-de-Lomagne","Beaumont-de-Pertuis","Beaumont-du-Gatinais","Beaumont-du-Perigord","Beaumont-en-Veron","Beaumont-le-Roger","Beaumont-les-Autels","Beaumont-les-Nonains","Beaumont-les-Valence","Beaumont-sur-Oise","Beaumont-sur-Sarthe","Beaune","Beaune-la-Rolande","Beaupont","Beaupreau","Beaupuy","Beauquesne","Beaurains","Beaurainville","Beauregard-Baret","Beauregard-Vendon","Beauregard-l'Eveque","Beaurepaire","Beaurepaire","Beaurepaire","Beaurevoir","Beaurieux","Beausemblant","Beausoleil","Beaussault","Beautheil","Beautiran","Beautor","Beautot","Beauvais","Beauvais-sur-Matha","Beauval","Beauvallon","Beauvene","Beauvernois","Beauvezer","Beauville","Beauvoir","Beauvoir","Beauvoir-de-Marc","Beauvoir-sur-Mer","Beauvoir-sur-Niort","Beauvoisin","Beauvoisin","Beauvoisin","Beauzac","Beauzelle","Bechy","Becon-les-Granits","Bedarrides","Bedee","Bedous","Beganne","Begard","Begles","Beguey","Behren-les-Forbach","Beignon","Beine-Nauroy","Beinheim","Beire-le-Chatel","Bel Air","Belarga","Belaye","Belbeuf","Belcodene","Belfort","Belfort-du-Quercy","Belgentier","Belgodere","Belhade","Beliet","Beligneux","Bellac","Bellaing","Bellancourt","Belle-Isle-en-Terre","Belleau","Bellebrune","Bellechaume","Bellefond","Bellefontaine","Bellefosse","Bellegarde","Bellegarde-Sainte-Marie","Bellegarde-du-Razes","Bellegarde-en-Diois","Bellegarde-sur-Valserine","Bellemagny","Bellenaves","Bellencombre","Belleneuve","Bellengreville","Bellentre","Belleray","Bellerive-sur-Allier","Bellesserre","Belleu","Bellevaux","Bellevesvre","Belleville","Belleville","Belleville-en-Caux","Belleville-sur-Loire","Belleville-sur-Mer","Belleville-sur-Meuse","Belleville-sur-Vie","Bellevue-la-Montagne","Belley","Bellignat","Belloy-en-France","Bellême","Belmont","Belmont","Belmont-sur-Rance","Belmontet","Belpech","Belrupt-en-Verdunois","Belveze","Belvès","Belz","Benamenil","Bene","Benerville-sur-Mer","Benesse-Maremne","Benestroff","Benevent-l'Abbaye","Benfeld","Benifontaine","Benney","Bennwihr","Benon","Benouville","Beon","Berat","Bercenay-en-Othe","Berck","Berck-Plage","Berd'huis","Berdoues","Berenx","Berg-sur-Moselle","Bergerac","Bergheim","Bergholtz","Bergonne","Bergues","Berjou","Berlaimont","Berles-au-Bois","Bermeries","Bermicourt","Bernadets","Bernard","Bernaville","Bernay","Bernay-Saint-Martin","Berne","Bernes-sur-Oise","Berneuil-sur-Aisne","Berneval-le-Grand","Bernex","Bernieres-le-Patry","Bernieres-sur-Mer","Bernin","Bernis","Bernos-Beaulac","Berre-l'Etang","Berriac","Berric","Berry-Bouy","Bersaillin","Bersee","Berson","Berthecourt","Berthelange","Berthen","Bertholene","Bertin","Bertincourt","Bertrange","Bertrimoutier","Bertry","Berville-en-Roumois","Berville-la-Campagne","Berville-sur-Seine","Berviller-en-Moselle","Berzeme","Berzet","Besançon","Besayes","Besne","Bessais-le-Fromental","Bessan","Bessancourt","Bessay","Besse","Besse","Besse-sur-Braye","Besse-sur-Issole","Besseges","Bessenay","Bessens","Bessey-les-Citeaux","Bessieres","Bessines","Bessines-sur-Gartempe","Besson","Bessoncourt","Bessonies","Betaille","Bethancourt-en-Valois","Bethencourt-sur-Mer","Betheniville","Betheny","Bethisy-Saint-Pierre","Bethoncourt","Betschdorf","Bettancourt-la-Ferree","Bettignies","Betting","Betton","Bettviller","Bettwiller","Betz","Beugin","Beugneux","Beure","Beurlay","Beuste","Beutal","Beuvillers","Beuvrages","Beuvraignes","Beuvron-en-Auge","Beuvry-la-Foret","Beuzec-Cap-Sizun","Beuzeville","Bevenais","Beychac-et-Caillau","Beynes","Beynost","Beyrede-Jumet","Beyrie-en-Bearn","Beyssenac","Bezac","Bezannes","Bezons","Bezouce","Bezu-Saint-Eloi","Biache-Saint-Vaast","Biard","Biarritz","Biars-sur-Cere","Biaudos","Bichancourt","Bicqueley","Bidache","Bidarray","Bidart","Bief-du-Fourg","Bielle","Bienville","Bienvillers-au-Bois","Biermont","Bierne","Bierry-les-Belles-Fontaines","Biesheim","Biesles","Bietlenheim","Bieville-Beuville","Bievres","Biganos","Bignac","Bignan","Bignoux","Biguglia","Bihorel","Bilieu","Billere","Billey","Billiers","Billom","Billy","Billy","Billy-Berclau","Billy-Montigny","Billy-sous-les-Cotes","Billy-sur-Ourcq","Bindernheim","Binges","Binic","Bining","Bionville-sur-Nied","Biot","Biot","Bioule","Birac-sur-Trec","Biriatou","Birieux","Biscarrosse","Bischheim","Bischoffsheim","Bischwihr","Bischwiller","Bisel","Bitche","Biviers","Biville-sur-Mer","Bizanos","Blacourt","Blacqueville","Blacy","Blaesheim","Blagnac","Blagny","Blaignan","Blain","Blainville","Blainville-sur-Mer","Blainville-sur-Orne","Blainville-sur-l'Eau","Blaise","Blaise-sous-Arzillieres","Blaison-Gohier","Blamont","Blamont","Blan","Blancafort","Blanchefosse-et-Bay","Blangy-sur-Bresle","Blanot","Blanquefort","Blanzat","Blanzay-sur-Boutonne","Blanzy","Blanzy-la-Salonnaise","Blaringhem","Blaudeix","Blausasc","Blauzac","Blavozy","Blaye","Blaye-les-Mines","Bleigny-le-Carreau","Blendecques","Blenod-les-Pont-a-Mousson","Blenod-les-Toul","Blerancourdelle","Blere","Bleriot-Plage","Blesle","Bletterans","Bleury","Bligny-les-Beaune","Blincourt","Blingel","Blodelsheim","Blois","Blomard","Blondefontaine","Blonville-sur-Mer","Blotzheim","Blou","Bloye","Blyes","Blérancourt","Bobigny","Bocquegney","Boe","Boege","Boeil-Bezing","Boen-sur-Lignon","Boersch","Boeschepe","Boeseghem","Boesenbiesen","Bohain-en-Vermandois","Bohal","Boigneville","Boigny","Boigny-sur-Bionne","Bois","Bois-Anzeray","Bois-Arnault","Bois-Colombes","Bois-Grenier","Bois-Guillaume","Bois-Jerome-Saint-Ouen","Bois-d'Amont","Bois-d'Arcy","Bois-de-Cene","Bois-de-Gand","Bois-de-la-Pierre","Bois-le-Roi","Bois-le-Roi","Boisbergues","Boiscommun","Boisemont","Boisemont","Boisjean","Boisleux-au-Mont","Boismont","Boismorand","Boisse-Penchot","Boisseron","Boisset-et-Gaujac","Boisseuil","Boissey-le-Chatel","Boissezon","Boissieres","Boissise-la-Bertrand","Boissise-le-Roi","Boissy-Fresnoy","Boissy-Maugis","Boissy-Mauvoisin","Boissy-Saint-Léger","Boissy-l'Aillerie","Boissy-le-Bois","Boissy-le-Chatel","Boissy-le-Girard","Boissy-sous-Saint-Yon","Boisville-la-Saint-Pere","Boisyvon","Bolandoz","Bolbec","Bollene","Bolleville","Bollezeele","Bollwiller","Bolsenheim","Bommes","Bompas","Bompas","Bon-Encontre","Bonchamp-les-Laval","Boncourt-le-Bois","Boncourt-sur-Meuse","Bondeville","Bondigoux","Bondoufle","Bondues","Bondy","Bongheat","Bonifacio","Bonlier","Bonnard","Bonnat","Bonnebosq","Bonnee","Bonnegarde","Bonneguete","Bonneil","Bonnelles","Bonnemain","Bonnes","Bonnet","Bonnet","Bonnet","Bonnetable","Bonnetage","Bonnetan","Bonneuil-en-France","Bonneuil-en-Valois","Bonneuil-les-Eaux","Bonneuil-sur-Marne","Bonneval","Bonnevaux-le-Prieure","Bonnevent-Velloreille","Bonneville","Bonneville","Bonneville-Aptot","Bonneville-la-Louvet","Bonnieres-sur-Seine","Bonnieux","Bonny-sur-Loire","Bonrepos","Bonrepos-Riquet","Bons-en-Chablais","Bonsecours","Bonson","Bonzac","Boos","Boos","Boqueho","Bor-et-Bar","Boran-sur-Oise","Bord","Bord","Bordeaux","Borderes","Borderes-et-Lamensans","Borderes-sur-l'Echez","Bordes","Bords","Borgo","Bormes-les-Mimosas","Bornay","Bornel","Bort-l'Etang","Bosc Renoult","Bosc-Guerard-Saint-Adrien","Bosc-Mesnil","Bosc-le-Hard","Bosgouet","Bosguerard-de-Marcouville","Bosjean","Bosmie-l'Aiguille","Bosmont-sur-Serre","Bosrobert","Bossancourt","Bossay-sur-Claise","Bossendorf","Bossey","Botsorhel","Bouafles","Bouan","Bouaye","Boubers-sur-Canche","Boubiers","Bouc-Bel-Air","Boucau","Bouchain","Bouchemaine","Boucheporn","Bouchet","Boucoiran-et-Nozieres","Bouee","Bouer","Bouere","Bouex","Bouffemont","Bouffere","Bougarber","Bouge-Chambalud","Bougival","Bougnon","Bougue","Bouguenais","Bougy","Bouhet","Bouillargues","Bouilly","Bouilly","Bouilly-en-Gatinais","Bouin","Boujan-sur-Libron","Boulages","Boulancourt","Boulange","Boulay-Moselle","Boulay-les-Barres","Boulazac","Bouleurs","Bouliac","Boulieu-les-Annonay","Bouligney","Bouligny","Boullay-les-Troux","Boulleret","Boulleville","Bouloc","Boulogne-Billancourt","Boulogne-la-Grasse","Boulogne-sur-Gesse","Boulogne-sur-Mer","Bouloire","Boult-sur-Suippe","Boulzicourt","Bouniagues","Bouquet","Bouquetot","Bouray-sur-Juine","Bourbon-Lancy","Bourbon-l'Archambault","Bourbonne-les-Bains","Bourbourg","Bourbriac","Bourcefranc-le-Chapus","Bourdenay","Bourdon","Bouresse","Bourg","Bourg-Achard","Bourg-Argental","Bourg-Blanc","Bourg-Saint-Andeol","Bourg-Saint-Maurice","Bourg-Sainte-Marie","Bourg-de-Péage","Bourg-de-Thizy","Bourg-en-Bresse","Bourg-la-Reine","Bourg-le-Comte","Bourg-le-Roi","Bourg-les-Valence","Bourg-sous-Chatelet","Bourganeuf","Bourgbarre","Bourges","Bourget","Bourghelles","Bourgneuf","Bourgneuf","Bourgneuf-en-Retz","Bourgogne","Bourgogne","Bourgoin","Bourguebus","Bourgueil","Bourguignon-sous-Coucy","Bourlon","Bourneville","Bournezeau","Bourogne","Bourran","Bourron-Marlotte","Bours","Bours","Boursault","Bourseville","Boursieres","Bourth","Boury-en-Vexin","Bousbach","Bousbecque","Bousies","Boussac","Boussac","Boussay","Boussenac","Boussens","Boussieres","Boussois","Boussy-Saint-Antoine","Boust","Boutancourt","Boutiers-Saint-Trojan","Boutigny-Prouais","Boutigny-sur-Essonne","Bouvaincourt-sur-Bresle","Bouvante","Bouvelinghem","Bouvesse-Quirieu","Bouvigny-Boyeffles","Bouville","Bouvincourt-en-Vermandois","Bouvron","Bouxieres-aux-Chenes","Bouxieres-aux-Dames","Bouxwiller","Bouzel","Bouzigues","Bouzincourt","Bouzonville","Bouzonville-en-Beauce","Bouzy","Bouzy-la-Foret","Boves","Boyer","Boynes","Boz","Bozel","Bozouls","Brachy","Bracieux","Brain-sur-Allonnes","Brain-sur-Vilaine","Brain-sur-l'Authion","Braine","Brains","Bram","Bramans","Branches","Brancourt-en-Laonnois","Brandivy","Brando","Brandonnet","Branges","Branne","Branoux-les-Taillades","Bransles","Braquis","Bras","Brasles","Brasparts","Brassac","Brassac-les-Mines","Brassempouy","Braucourt","Braud-et-Saint-Louis","Brax","Brax","Bray","Bray-Dunes","Bray-Saint-Christophe","Bray-en-Val","Bray-et-Lu","Bray-sur-Seine","Bray-sur-Somme","Braye-sous-Faye","Brazey-en-Plaine","Breal-sous-Montfort","Brebieres","Brece","Brecey","Brech","Breconchaux","Bree","Bregy","Brehal","Brehand","Breil-sur-Roya","Breitenbach-Haut-Rhin","Breles","Bremenil","Bremontier-Merval","Brenouille","Brens","Bresles","Bresse-sur-Grosne","Bressolles","Bressolles","Bressols","Bresson","Bressuire","Brest","Bretagne","Breteil","Breteniere","Bretenoux","Breteuil","Breteuil","Bretignolles","Bretignolles-sur-Mer","Bretigny","Bretigny","Bretteville-l'Orgueilleuse","Bretteville-sur-Laize","Bretteville-sur-Odon","Breuil","Breuil","Breuil-Magne","Breuil-le-Sec","Breuil-le-Vert","Breuillet","Breuillet","Breuilpont","Breuschwickersheim","Breuvannes-en-Bassigny","Breux-sur-Avre","Breval","Breviandes","Brexent-Enocq","Breze","Brezins","Brezolles","Brianconnet","Briançon","Briare","Briarres-sur-Essonne","Briatexte","Bricon","Bricquebec","Bricqueville-la-Blouette","Bricqueville-sur-Mer","Bricy","Brides-les-Bains","Bridore","Brie","Brie","Brie-Comte-Robert","Brie-et-Angonnes","Briec","Brienne-la-Vieille","Brienne-le-Château","Briennon","Brienon-sur-Armancon","Brieres-les-Scelles","Brieuil-sur-Chize","Brieulles-sur-Meuse","Briey","Brignac-la-Plaine","Brignais","Brigne","Brignoles","Brignon","Brignoud","Brigueuil","Briis-sous-Forges","Brimeux","Brin-sur-Seille","Brinay","Brindas","Bringolo","Brinon-sur-Beuvron","Briollay","Brion","Brion","Brionne","Briord","Brioude","Brioux-sur-Boutonne","Briouze","Briscous","Brison-Saint-Innocent","Brissac","Brissac-Quince","Brissy-Hamegicourt","Brive","Brive-la-Gaillarde","Brives-Charensac","Brives-sur-Charente","Brix","Brochon","Broglie","Brognon","Broin","Brombos","Bron","Broons","Brossac","Brosville","Brou","Brou-sur-Chantereine","Brouay","Brouckerque","Brouderdorff","Broue","Brouennes","Brouilla","Brouqueyran","Brousse","Brousse","Brousseval","Brouviller","Bru","Bruay-sur-l'Escaut","Bruch","Brue-Auriac","Bruebach","Bruges","Brugheas","Brugny-Vaudancourt","Bruguieres","Bruille-Saint-Amand","Bruley","Brullioles","Brulon","Brumath","Brunoy","Brunstatt","Brussey","Brussieu","Brusvily","Brux","Bruyeres-et-Montberault","Bruyeres-le-Chatel","Bruyeres-sur-Oise","Bruyères","Bruz","Bry-sur-Marne","Brétigny-sur-Orge","Bu","Buanes","Bubry","Buc","Buceels","Bucey-les-Gy","Bucheres","Buchy","Bucquoy","Bucy-le-Long","Bucy-les-Cerny","Budos","Bueil","Buellas","Buffard","Bugeat","Bugnicourt","Buhl","Buigny-les-Gamaches","Buire-le-Sec","Buironfosse","Buis-les-Baronnies","Bulat-Pestivien","Bulgneville","Bulhon","Bulles","Bully","Bully-les-Mines","Buno-Bonnevaux","Bunzac","Burbure","Bures-sur-Yvette","Burie","Burlats","Burnhaupt-le-Haut","Buros","Bury","Busigny","Busloup","Busque","Bussac-Foret","Bussang","Bussiere-Galant","Bussiere-Poitevine","Bussieres-les-Belmont","Bussunarits-Sarrasquette","Bussus-Bussuel","Bussy-Lettree","Bussy-Saint-Georges","Bussy-le-Chateau","Bussy-le-Grand","Bussy-les-Daours","Busy","Buthiers","Butry-sur-Oise","Buxerolles","Buxeuil","Buxieres-les-Mines","Buxy","Buzan","Buzancais","Buzet-sur-Baise","Buzet-sur-Tarn","Buzy","Bédarieux","Bédoin","Bénodet","Bénouville","Béthune","Béziers","Cabanac","Cabanac-et-Villagrains","Cabannes","Cabara","Cabariot","Cabasse","Cabestany","Cabourg","Cabrieres-d'Aigues","Cabrieres-d'Avignon","Cabries","Cabris","Cachan","Cadalen","Cadaujac","Caden","Cadenet","Cadillac","Cadillac-en-Fronsadais","Cadolive","Cadours","Caen","Caestre","Cagnac-les-Mines","Cagnes-sur-Mer","Cagnicourt","Cagny","Cagny","Cahagnes","Cahors","Cahuzac","Cahuzac","Cahuzac-sur-Vere","Caille","Caillouel-Crepigny","Cailloux-sur-Fontaines","Cairanne","Cairon","Caissargues","Cajarc","Calais","Calas","Calavante","Calcatoggio","Calenzana","Callac","Callac","Callas","Calleville","Callian","Calmels-et-le-Viala","Calmont","Calonne-Ricouart","Calonne-sur-la-Lys","Caluire-et-Cuire","Calvi","Calvisson","Camaret-sur-Aigues","Camaret-sur-Mer","Camarsac","Cambes","Cambieure","Camblain-Chatelain","Camblain-lAbbé","Camblanes-et-Meynac","Cambo-les-Bains","Cambounet-sur-le-Sor","Cambrai","Cambrin","Cambronne-les-Ribecourt","Came","Cameyrac","Camiac-et-Saint-Denis","Camiers","Camlez","Camoel","Camon","Camon","Camors","Campagnan","Campagne","Campagne","Campagne-les-Hesdin","Campagne-les-Wardrecques","Campagnolles","Campeaux","Campeneac","Campet-et-Lamolere","Camphin-en-Carembault","Camphin-en-Pevele","Campigneulles-les-Petites","Campremy","Camprond","Camps-la-Source","Campuac","Campugnan","Canaples","Cancale","Cancon","Cande","Cande-sur-Beuvron","Candillargues","Candresse","Canejan","Canet-Plage","Canet-de-Salars","Cangey","Canisy","Canlers","Canly","Cannes","Cannes-Ecluse","Cannet","Canohes","Canouville","Canteleu","Cantin","Cany-Barville","Cap-d'Ail","Capbreton","Capdenac-Gare","Capelle","Capelle-Fermont","Capendu","Capens","Capestang","Capinghem","Capoulet-et-Junac","Cappel","Cappelle-Brouck","Cappelle-en-Pevele","Cappelle-la-Grande","Captieux","Capvern","Caragoudes","Caraman","Carantec","Carantilly","Carbon-Blanc","Carbonne","Carcans","Carcassonne","Carces","Carcopino","Cardaillac","Cardesse","Cardonville","Cardroc","Carency","Carentan","Carentoir","Cargèse","Carhaix-Plouguer","Carignan","Carling","Carlipa","Carlucet","Carlus","Carmaux","Carnac","Carneville","Carnieres","Carnin","Carnon-Plage","Carnoules","Carolles","Caromb","Carpentras","Carpiquet","Carquefou","Carqueiranne","Carresse-Cassaber","Carrieres-sous-Poissy","Carrieres-sur-Seine","Carros","Carrouges","Carry-le-Rouet","Carsac-Aillac","Carspach","Cartelegue","Cartignies","Cartigny-l'Epinay","Carville-la-Folletiere","Carvin","Casanova","Cases-de-Pene","Cassagne","Cassagnes","Cassagnes-Begonhes","Cassagnoles","Cassel","Casseneuil","Cassis","Casson","Cast","Castagnede","Castanet-Tolosan","Castanet-le-Haut","Casteide-Cami","Castelginest","Casteljaloux","Castellane","Castellar","Castellare-di-Mercurio","Castello-di-Rostino","Castelmoron-sur-Lot","Castelnau-Durban","Castelnau-Montratier","Castelnau-Valence","Castelnau-d'Estretefonds","Castelnau-de-Brassac","Castelnau-de-Levis","Castelnau-de-Montmiral","Castelnau-le-Lez","Castelnau-sur-Gupie","Castelnaud-de-Gratecambe","Castelnaudary","Castels","Castelsagrat","Castelsarrasin","Castera-Loubix","Castet","Castetner","Castets-en-Dorthe","Castiglione","Castillon-Debats","Castillon-Massas","Castillon-du-Gard","Castillon-la-Bataille","Castillonnes","Castilly","Castres","Castres-Gironde","Castries","Catenay","Catenoy","Cattenom","Catus","Caucalieres","Cauchy-à-la-Tour","Caudan","Caudebec-en-Caux","Caudebec-lès-Elbeuf","Caudecoste","Caudrot","Caudry","Cauge","Caullery","Caulnes","Caumont","Caumont","Caumont-l'Evente","Caumont-sur-Durance","Caumont-sur-Garonne","Cauneille","Caunes-Minervois","Caurel","Cauroir","Cauroy-les-Hermonville","Caussade-Riviere","Causse-de-la-Selle","Cauvigny","Cauville-sur-Mer","Caux","Caux-et-Sauzens","Cauzac","Cavaillon","Cavalaire-sur-Mer","Cavan","Caveirac","Cavignac","Cavillargues","Cavillon","Cayeux-sur-Mer","Caylus","Cayrac","Cazals-des-Bayles","Cazaux","Cazaux-Layrisse","Cazavet","Cazeres","Cazes-Mondenard","Cazevieille","Cazilhac","Cazouls-les-Beziers","Ceauce","Ceaux","Ceaux-d'Allegre","Cebazat","Ceignes","Ceintrey","Celle-Levescault","Celles-en-Bassigny","Celles-sur-Belle","Celles-sur-Durolle","Cellettes","Cellieu","Celon","Cenac","Cendras","Cenon","Cenon-sur-Vienne","Centres","Cepet","Cepie","Cepoy","Cerans-Foulletourte","Cercier","Cercoux","Cerdon","Cere","Cerelles","Cereste","Ceret","Cergy","Cerilly","Cerise","Cerisiers","Cerisy-la-Foret","Cerisy-la-Salle","Cerizay","Cernay","Cernay-la-Ville","Cerneux","Cerny","Cerons","Cers","Certines","Cervens","Cervera de la Marenda","Cervieres","Cervione","Cesar","Cesarches","Cescau","Cesny-Bois-Halbout","Cesny-aux-Vignes","Cessales","Cessenon-sur-Orb","Cesseras","Cessey","Cessieu","Cesson","Cesson","Cessy","Cestas","Ceton","Ceyrat","Ceyreste","Ceyssat","Ceyzeriat","Cezay","Chaban","Chabanais","Chabestan","Chabeuil","Chablis","Chabons","Chabottes","Chabrillan","Chabris","Chacenay","Chadeleuf","Chadrac","Chadron","Chaffois","Chagey","Chagny","Chaignay","Chail","Chaillac","Chaillac-sur-Vienne","Chaille-les-Marais","Chailles","Chaillevette","Chailloue","Chailly-en-Biere","Chailly-en-Gatinais","Chainaz-les-Frasses","Chaingy","Chaix","Chalais","Chalamont","Chalampe","Chalandry-Elaire","Chaleins","Chalencon","Chalette-sur-Loing","Chalette-sur-Voire","Chaleze","Chalezeule","Chaligny","Chalindrey","Challain-la-Potherie","Challans","Challes-les-Eaux","Challet","Challex","Chalmaison","Chalo-Saint-Mars","Chalon","Chalon-sur-Saône","Chalonnes-sur-Loire","Chalons-en-Champagne","Chalonvillars","Chalou-Moulineux","Chamagne","Chamagnieu","Chamalières","Chambalud","Chamberet","Chambilly","Chamblac","Chamblanc","Chambles","Chamblet","Chambley-Bussieres","Chambly","Chamboeuf","Chambon","Chambon-sur-Lac","Chambon-sur-Voueize","Chambonas","Chambord","Chamboret","Chamborigaud","Chambors","Chambost-Longessaigne","Chamboulive","Chambourcy","Chambourg-sur-Indre","Chambray-lès-Tours","Chambrecy","Chambretaud","Chambry","Chambéry","Chamelet","Chameyrat","Chamigny","Chamonix","Chamouilley","Chamoux","Chamoux-sur-Gelon","Champ","Champ-le-Duc","Champ-sur-Drac","Champagnac","Champagnac-le-Vieux","Champagnat","Champagne","Champagne","Champagne-Mouton","Champagne-au-Mont-d'Or","Champagne-les-Marais","Champagne-sur-Oise","Champagne-sur-Seine","Champagney","Champagnole","Champanges","Champcenest","Champcerie","Champcevinel","Champcueil","Champdieu","Champdotre","Champdray","Champeaux","Champeaux","Champeix","Champenay","Champenoux","Champeon","Champey-sur-Moselle","Champforgeuil","Champfromier","Champhol","Champien","Champier","Champigne","Champigneulles","Champigny","Champigny-sur-Marne","Champlan","Champlemy","Champlitte","Champniers","Champoly","Champoulet","Champs","Champs-sur-Marne","Champs-sur-Tarentaine-Marchal","Champs-sur-Yonne","Champsac","Champtercier","Champtoce-sur-Loire","Champtoceaux","Champvans","Chanas","Chanceaux-sur-Choisille","Chancelade","Chancenay","Change","Changis-sur-Marne","Chaniers","Chanonat","Chanoz-Chatenay","Chanteau","Chantecorps","Chanteheux","Chanteloup","Chanteloup-en-Brie","Chanteloup-les-Bois","Chanteloup-les-Vignes","Chantemerle-sur-la-Soie","Chantepie","Chanteuges","Chantilly","Chantome","Chantonnay","Chantraine","Chantrans","Chanveaux","Chaon","Chapareillan","Chapdes-Beaufort","Chapeiry","Chapelle-Vallon","Chapelle-Voland","Chaponnay","Chaponost","Chaptelat","Chaptuzat","Charancieu","Charantonnay","Charavines","Charbonnieres-les-Bains","Charbonnieres-les-Varennes","Charbuy","Charentay","Charenton-le-Pont","Charge","Chargey-les-Gray","Chargey-les-Port","Charleval","Charleval","Charleville","Charleville-Mézières","Charlieu","Charly","Charly-sur-Marne","Charmant","Charmes","Charmes","Charmes-sur-Rhone","Charmont-en-Beauce","Charmont-sous-Barbuise","Charnas","Charnay","Charnay","Charnay-les-Macon","Charnecles","Charny","Charolles","Charonville","Charost","Charquemont","Charrecey","Charron","Charroux","Charsonville","Charteves","Chartres","Chartres-de-Bretagne","Chartrettes","Charvieu-Chavagneux","Charvonnex","Chas","Chasnais","Chasne-sur-Illet","Chaspinhac","Chassagnes","Chassagny","Chasse-sur-Rhone","Chasselay","Chassemy","Chassenard","Chasseneuil","Chasseneuil-du-Poitou","Chasseneuil-sur-Bonnieure","Chassey-le-Camp","Chassiers","Chassieu","Chataincourt","Chateau","Chateau-Arnoux-Saint-Auban","Chateau-Chervix","Chateau-Chinon(Ville)","Chateau-Gontier","Chateau-Landon","Chateau-Porcien","Chateau-Renault","Chateau-Salins","Chateau-d'Olonne","Chateau-du-Loir","Chateau-sur-Epte","Chateaubleau","Chateaubourg","Chateaubriand","Chateaubriant","Chateaudouble","Chateaufort","Chateaugay","Chateaugiron","Chateaumeillant","Chateauneuf","Chateauneuf-Grasse","Chateauneuf-de-Bordette","Chateauneuf-de-Gadagne","Chateauneuf-de-Galaure","Chateauneuf-du-Faou","Chateauneuf-du-Rhone","Chateauneuf-en-Thymerais","Chateauneuf-la-Foret","Chateauneuf-le-Rouge","Chateauneuf-les-Martigues","Chateauneuf-sur-Charente","Chateauneuf-sur-Loire","Chateauneuf-sur-Sarthe","Chateaurenard","Chateauvillain","Chatel","Chatel-Guyon","Chatel-Saint-Germain","Chatel-de-Neuvre","Chatel-sur-Moselle","Chatelaillon-Plage","Chatelaines","Chatelais","Chatelaudren","Chateldon","Chatelet","Chatelus","Chatelus-le-Marcheix","Chatenay-sur-Seine","Chatenet","Chatenois","Chatenois","Chatenois-les-Forges","Chatenoy","Chatenoy-le-Royal","Chatignonville","Chatillon","Chatillon-Coligny","Chatillon-la-Palud","Chatillon-le-Duc","Chatillon-le-Roi","Chatillon-les-Sons","Chatillon-sur-Chalaronne","Chatillon-sur-Cher","Chatillon-sur-Indre","Chatillon-sur-Loire","Chatillon-sur-Saone","Chatillon-sur-Seiche","Chatillon-sur-Thouet","Chatonnay","Chatonrupt-Sommermont","Chatou","Chatres","Chatres-sur-Cher","Chatte","Chatuzange-le-Goubet","Chauche","Chaudefonds-sur-Layon","Chaudefontaine","Chaudon","Chaudron-en-Mauges","Chauffailles","Chauffry","Chaufour-Notre-Dame","Chaufour-les-Bonnieres","Chaulnes","Chaumes","Chaumes-en-Brie","Chaumont","Chaumont","Chaumont-en-Vexin","Chaumontel","Chaumousey","Chauny","Chauray","Chauriat","Chaussin","Chaussoy-Epagny","Chaussy","Chauve","Chauvigny","Chauvincourt-Provemont","Chauvry","Chaux","Chavagne","Chavagnes-en-Paillers","Chavagnes-les-Redoux","Chavaignes","Chavanay","Chavannes-sur-Reyssouze","Chavanod","Chavanoz","Chavaroux","Chavenay","Chavigny","Chaville","Chazay-d'Azergues","Chazelles","Chazelles-sur-Lyon","Checy","Chedigny","Chef-Boutonne","Cheffes","Chehery","Chelan","Chelles","Chemaze","Chemere","Chemere-le-Roi","Chemery","Chemery-les-Deux","Chemille-Melay","Chemilly-sur-Serein","Chemin-d'Aisey","Cheminot","Chemy","Chenailler-Mascheix","Chenaud","Chenay-le-Chatel","Chenerailles","Chenevelles","Chenex","Chenimenil","Chennevieres-sur-Marne","Chenonceaux","Chenou","Chenove","Chens-sur-Leman","Cheny","Chepoix","Cheptainville","Chepy","Cherac","Cherbourg-Octeville","Chereng","Cheret","Cherier","Cherisey","Cherisy","Cheron","Cheroy","Cherre","Cherreau","Cherves-Chatelars","Cherves-Richemont","Chervettes","Cherveux","Chesley","Chessy","Chessy","Chessy-les-Pres","Cheux","Chevaigne","Cheval-Blanc","Chevalet-le-Haut","Chevanceaux","Chevannes","Chevannes","Cheverny","Chevigny","Chevigny-Saint-Sauveur","Chevillon","Chevillon","Chevillon-sur-Huillard","Chevilly","Chevilly-Larue","Chevincourt","Chevire-le-Rouge","Chevrainvilliers","Chevremont","Chevreuse","Chevrier","Chevrieres","Chevrieres","Chevrotaine","Chevru","Chevry","Chevry-Cossigny","Chevry-en-Sereine","Cheyssieu","Chezery-Forens","Chezy","Chezy-sur-Marne","Chiche","Chichery","Chierry","Chieulles","Chignin","Chigny-les-Roses","Chigy","Chilhac","Chille","Chilly","Chilly-Mazarin","Chimilin","Chinon","Chirat-l'Église","Chire-en-Montreuil","Chirens","Chiry-Ourscamp","Chissay-en-Touraine","Chisseaux","Chissey-en-Morvan","Chitenay","Chivres-en-Laonnois","Chize","Chocques","Choisel","Choisey","Choisy","Choisy-au-Bac","Choisy-en-Brie","Choisy-le-Roi","Cholet","Chomerac","Chonas-l'Amballan","Chorges","Chourgnac","Chouy","Choye","Chozeau","Chuelles","Chuzelles","Châlus","Château de Loches","Château-Thierry","Château-lÉvêque","Châteaudun","Châteaulin","Châteauneuf-dIlle-et-Vilaine","Châteauneuf-du-Pape","Châteauneuf-sur-Cher","Châteauponsac","Châteauroux","Châtellerault","Châtelperron","Châtenay-Malabry","Châtillon","Châtillon-sur-Seine","Ciboure","Ciel","Cierrey","Cieurac","Cieux","Cinq-Mars-la-Pile","Cinqueux","Cintegabelle","Cintheaux","Cintre","Cire-d'Aunis","Cires-les-Mello","Cirey","Cirey-sur-Vezouze","Ciron","Ciry-le-Noble","Cissac-Medoc","Cisse","Cistrieres","Citerne","Citry","Civaux","Civens","Civrac-de-Blaye","Civrac-en-Medoc","Civray","Civray","Civray-de-Touraine","Civrieux","Civrieux-d'Azergues","Civry-en-Montagne","Cize","Cizely","Claira","Clairac","Clairfontaine","Clairmarais","Clairoix","Clairvaux-dAveyron","Clairvaux-les-Lacs","Claix","Claix","Clamart","Clamecy","Clamecy","Claouey","Clapiers","Clarac","Claracq","Clarafond","Clarensac","Clarques","Clary","Classun","Clasville","Clavel","Clavette","Claviers","Claville","Claye-Souilly","Cleder","Cleguer","Cleguerec","Clelles","Clement","Clemery","Clemont","Clenay","Cleon","Cleon-d'Andran","Clerieux","Clermont","Clermont","Clermont","Clermont","Clermont-Ferrand","Clermont-l'Herault","Clerval","Clery-Saint-Andre","Clesse","Clety","Clevilliers","Clichy","Clichy-sous-Bois","Clinchamps-sur-Orne","Cliron","Clisson","Clohars-Carnoet","Clohars-Fouesnant","Clouange","Clouzeau","Cloyes-sur-le-Loir","Cluny","Cluses","Clères","Coaraze","Coarraze","Cobrieux","Cocheren","Cocumont","Codognan","Codolet","Coesmes","Coeuvres-et-Valsery","Coex","Cogles","Cogna","Cognac","Cognin","Cogolin","Coignet","Coignieres","Coimeres","Coincy","Coirac","Coise-Saint-Jean-Pied-Gauthier","Coivrel","Colayrac-Saint-Cirq","Colembert","Coligny","Collandres-Quincarnon","Collegien","Colleret","Colleville","Colleville-Montgomery","Collias","Collioure","Collobrieres","Collonges-au-Mont-d'Or","Collonges-les-Premieres","Collonges-sous-Saleve","Collorgues","Colmar","Colmars","Cologne","Colomars","Colombe","Colombelles","Colombes","Colombier","Colombier","Colombier-Fontaine","Colombier-Saugnieu","Colombier-le-Cardinal","Colombier-le-Vieux","Colombieres-sur-Orb","Colombiers","Colomby-sur-Thaon","Colomiers","Colomieu","Colondannes","Colonzelle","Colpo","Coltainville","Combas","Comblanchien","Combloux","Combon","Combourg","Combrand","Combree","Combrit","Combronde","Combs-la-Ville","Comines","Commelle-Vernay","Commenchon","Commensacq","Commentry","Commeny","Commequiers","Commer","Commercy","Commes","Commissey","Communay","Compans","Compertrix","Compiègne","Compolibat","Compreignac","Comps","Concarneau","Conceze","Conches-en-Ouche","Conches-sur-Gondoire","Conchy-les-Pots","Condac","Condat","Condat-sur-Vienne","Conde-Northen","Conde-Sainte-Libiaire","Conde-en-Brie","Conde-sur-Iton","Conde-sur-Marne","Conde-sur-Noireau","Conde-sur-Sarthe","Conde-sur-Suippe","Conde-sur-Vesgre","Conde-sur-Vire","Conde-sur-l'Escaut","Condecourt","Condeon","Condette","Condezaygues","Condillac","Condom","Condrieu","Condé-sur-Huisne","Conflans-Sainte-Honorine","Conflans-en-Jarnisy","Conflans-sur-Loing","Conflans-sur-Seine","Confolens","Congenies","Conliege","Connantray-Vaurefroy","Conne-de-Labarde","Connerre","Conquereuil","Conques-sur-Orbiel","Cons-Sainte-Colombe","Contamine-sur-Arve","Contes","Contigne","Contoire","Contre","Contres","Contrexeville","Contrisson","Contz-les-Bains","Copponex","Coquelles","Corancez","Coray","Corbara","Corbarieu","Corbas","Corbehem","Corbeil-Cerf","Corbeil-Essonnes","Corbeilles","Corbelin","Corbeny","Corbere-Aberes","Corbere-les-Cabanes","Corbie","Corbieres","Corbieres","Corbigny","Corbonod","Corbreuse","Corcelles-les-Citeaux","Corcelles-les-Monts","Corcieux","Corconne","Corcy","Cordelle","Cordemais","Cordes-Tolosannes","Cordes-sur-Ciel","Cordon","Corenc","Corgnac-sur-lIsle","Corgoloin","Corignac","Corlay","Cormainville","Corme-Ecluse","Corme-Royal","Cormeilles","Cormeilles-en-Parisis","Cormeilles-en-Vexin","Cormelles-le-Royal","Cormeray","Cormery","Cormes","Cormicy","Cormolain","Cormontreuil","Cormoranche-sur-Saone","Cornac","Cornas","Corne","Cornebarrieu","Corneilla-de-Conflent","Corneilla-del-Vercol","Corneilla-la-Riviere","Cornier","Cornille","Cornillon-Confoux","Cornillon-en-Trieves","Cornimont","Cornus","Corny-sur-Moselle","Coron","Corpe","Corps-Nuds","Correze","Corroy","Cors","Corsept","Corseul","Corte","Corveissiat","Corze","Cosges","Cosmes","Cosne-Cours-sur-Loire","Cosne-d'Allier","Cosqueville","Cosse-le-Vivien","Cossesseville","Costaros","Cotdoussan","Cotignac","Cottenchy","Cottevrard","Cottun","Couargues","Coublevie","Coubon","Coubron","Couches","Couchey","Coucy-le-Chateau-Auffrique","Couddes","Coudehard","Coudekerque-Branche","Coudes","Coudoux","Coudray","Coudray-Rabut","Coudray-au-Perche","Coudroy","Coudun","Coueron","Couesmes-Vauce","Coufouleux","Couhe","Couilly-Pont-aux-Dames","Couiza","Coulaines","Coulandon","Coulans-sur-Gee","Coulaures","Coullons","Coulogne","Couloisy","Coulombiers","Coulombiers","Coulomby","Coulommes","Coulommiers","Coulommiers-la-Tour","Coulon","Coulonces","Coulonges","Coulonges-Thouarsais","Coulounieix-Chamiers","Coulouvray-Boisbenatre","Coulvain","Coulx","Coume","Coupelle-Vieille","Coupesarte","Coupeville","Coupigny","Coupru","Coupvray","Cour-Cheverny","Cour-et-Buis","Cour-sur-Loire","Courances","Courbeveille","Courbevoie","Courcais","Courcay","Courcelles","Courcelles","Courcelles-Chaussy","Courcelles-Epayelles","Courcelles-Val-d'Esnoms","Courcelles-en-Bassee","Courcelles-les-Gisors","Courcelles-les-Lens","Courcelles-sur-Nied","Courcelles-sur-Seine","Courcelles-sur-Viosne","Courcemont","Courcerac","Courchaton","Courchelettes","Courchevel","Courcon","Courcouronnes","Courcy","Courcy","Courcy-aux-Loges","Courdemanche","Courdemanche","Courdimanche-sur-Essonne","Courgis","Courlans","Courlaoux","Courlay","Courmelles","Courmemin","Cournon","Cournon-dAuvergne","Cournonsec","Cournonterral","Courpalay","Courpiere","Courquetaine","Courrières","Cours","Cours-de-Monsegur","Cours-la-Ville","Cours-les-Bains","Cours-les-Barres","Coursac","Coursan","Courseulles-sur-Mer","Courson","Courson-Monteloup","Courson-les-Carrieres","Courtelevant","Courtenay","Courtenay","Courtenot","Courteranges","Courthezon","Courtisols","Courtomer","Courtonne-la-Meurdrac","Courtry","Courville-sur-Eure","Courzieu","Cousance","Cousances-les-Forges","Cousolre","Coussay-les-Bois","Coutances","Coutarnoux","Couterne","Couternon","Couteuges","Coutevroult","Coutiches","Coutras","Couvains","Couville","Couvron-et-Aumencourt","Coux","Couy","Couze-et-Saint-Front","Couzeix","Couzon","Coye-la-Foret","Coyriere","Cozes","Crach","Craincourt","Cramant","Cran-Gevrier","Crancey","Crancot","Cransac","Cranves-Sales","Craon","Craonne","Craponne","Cras-sur-Reyssouze","Cravanche","Cravans","Cravant","Cravant-les-Coteaux","Cravent","Crayssac","Crazannes","Creances","Creches-sur-Saone","Crecy-sur-Serre","Credin","Cregy-les-Meaux","Crehange","Crehen","Creil","Creissan","Creissels","Cremeaux","Cremieu","Creon-d'Armagnac","Crepey","Cresancey","Crespieres","Crespin","Crespin","Cressat","Cresse","Cresserons","Crest","Creully","Creusot","Creutzwald","Creuzier-le-Neuf","Creuzier-le-Vieux","Crevant-Laveine","Crevechamps","Crevecoeur-le-Grand","Crevin","Crezancy","Criel-sur-Mer","Crillon-le-Brave","Crimolois","Criquetot-l'Esneval","Crisenoy","Crisolles","Crissey","Crissey","Crochte","Crocq","Croisette","Croisilles","Croisilles","Croisilles","Croissanville","Croissy-Beaubourg","Croissy-sur-Celle","Croissy-sur-Seine","Croix","Croix","Croix-Chapeau","Croix-Mare","Croix-de-Vie","Croixanvec","Crolles","Cros-de-Ronesque","Crosne","Crottet","Crouay","Croutelle","Crouttes","Crouy-sur-Cosson","Crouy-sur-Ourcq","Croze","Crozes-Hermitage","Crozon","Cruas","Cruet","Crugny","Cruscades","Cruseilles","Crusnes","Cruzilles-les-Mepillat","Cruzy","Crépy-en-Valois","Créteil","Cublac","Cubry-les-Soing","Cubzac-les-Ponts","Cucq","Cucuron","Cuers","Cuffies","Cuffy","Cugand","Cuges-les-Pins","Cugnaux","Cuigy-en-Bray","Cuinchy","Cuincy","Cuinzier","Cuise-la-Motte","Cuiseaux","Cuisery","Culhat","Culmont","Culoz","Cumieres","Cunfin","Cunlhat","Cuon","Cuperly","Cuqueron","Curchy","Curdin","Curel","Curgies","Curtafond","Curzay-sur-Vonne","Cussay","Cusset","Cussey-les-Forges","Cussy-les-Forges","Custines","Cusy","Cuttoli-Corticchiato","Cuvergnon","Cuverville","Cuvilly","Cuvry","Cuxac-Cabardes","Cuxac-d'Aude","Cuy","Cuy-Saint-Fiacre","Cuzieu","Cysoing","Dabo","Dachstein","Dadonville","Dagneux","Dainville","Dalhunden","Dallet","Dalmas","Damazan","Dambach-la-Ville","Dambenois","Dame-Marie","Damelevieres","Damerey","Damery","Damgan","Damiatte","Damigny","Dammarie-les-Lys","Dammarie-sur-Saulx","Dammartin-en-Goele","Dammartin-en-Serve","Damparis","Dampierre","Dampierre-au-Temple","Dampierre-en-Burly","Dampierre-en-Crot","Dampierre-les-Bois","Dampierre-les-Conflans","Dampierre-sur-Blevy","Dampierre-sur-Boutonne","Dampmart","Damprichard","Dampsmesnil","Dampvalley-les-Colombe","Damville","Damvix","Dancevoir","Dangeau","Dangeul","Danjoutin","Danne-et-Quatre-Vents","Dannemoine","Daoulas","Dardilly","Dareize","Dargnies","Dargoire","Darmont","Darnetal","Darney","Darnieulles","Darvoy","Dasle","Daubensand","Daubeuf-la-Campagne","Dauendorf","Daumeray","Daux","Dauzat-sur-Vodable","Davenescourt","Davezieux","Dax","Deauville","Decazeville","Dechy","Decines-Charpieu","Decize","Delettes","Delle","Delme","Demouville","Demuin","Denain","Denat","Denee","Denevre","Denice","Denier","Dennebroeucq","Denneville","Denney","Denting","Dercy","Dernancourt","Derval","Desaignes","Desertines","Desvres","Detrier","Dettwiller","Deuil-la-Barre","Deulemont","Devecey","Devillac","Deville-les-Rouen","Devrouze","Deyme","Deyvillers","Dezize-les-Maranges","Dhuisy","Diarville","Didenheim","Die","Diebling","Dieffenbach-au-Val","Diemeringen","Diemoz","Dienville","Dieppe","Dieppe-sous-Douaumont","Dierre","Dietwiller","Dieue-sur-Meuse","Dieulefit","Dieulouard","Dieupentale","Dieuze","Dieval","Diffembach-les-Hellimer","Diges","Digne-les-Bains","Digoin","Dijon","Dimbsthal","Dimechaux","Dinan","Dinard","Dinge","Dingsheim","Dingy-Saint-Clair","Dingy-en-Vuache","Dinoze","Dionay","Dissay","Disse-sous-Ballon","Distre","Distroff","Dive","Dives-sur-Mer","Divion","Divonne-les-Bains","Dixmont","Dizy","Doazit","Docelles","Doeuil-sur-le-Mignon","Dogneville","Doingt","Doissin","Doix","Dol-de-Bretagne","Dole","Dollon","Dolo","Dolomieu","Dolus-d'Oleron","Domagne","Domaize","Domalain","Domancy","Domart-sur-la-Luce","Domats","Dombasle-sur-Meurthe","Domene","Domerat","Domessargues","Domessin","Domevre-sur-Durbion","Domezain-Berraute","Domfront","Domgermain","Domjevin","Dommartin","Dommartin","Dommartin-les-Remiremont","Dommartin-les-Toul","Domont","Dompierre-les-Ormes","Dompierre-sur-Besbre","Dompierre-sur-Mer","Dompierre-sur-Veyle","Dompierre-sur-Yon","Donchery","Doncourt-les-Conflans","Donges","Donjeux","Donnemarie-Dontilly","Donnery","Donneville","Donnezac","Dontrien","Donville-les-Bains","Donzacq","Donzere","Donzy","Donzy-le-Pertuis","Dordives","Dorlisheim","Dormans","Dormelles","Dornes","Dornot","Dortan","Dorval","Douai","Douarnenez","Doubs","Douchy","Douchy-les-Mines","Doudeville","Doue-la-Fontaine","Douilly","Doulezon","Doullens","Doumy","Dounoux","Dourdain","Dourdan","Dourges","Dourgne","Doussard","Douvaine","Douville","Douvres","Douvres-la-Delivrande","Douvrin","Doux","Douy-la-Ramee","Douzy","Doville","Doyet","Dozule","Drace","Drachenbronn-Birlenbach","Dracy-le-Fort","Draguignan","Draillant","Drain","Drancy","Drap","Draveil","Dreffeac","Dremil-Lafage","Dreslincourt","Dreuil-les-Amiens","Dreux","Dreville","Drocourt","Drom","Droupt-Saint-Basle","Drouville","Druillat","Drulingen","Drusenheim","Druye","Druyes-les-Belles-Fontaines","Dry","Ducey","Duclair","Duerne","Dugny","Dugny-sur-Meuse","Duingt","Duisans","Dullin","Dun-le-Poelier","Dun-sur-Auron","Duneau","Dunes","Duniere","Dunkirk","Duppigheim","Durance","Duranus","Durban-Corbieres","Durcet","Durette","Durfort","Durlinsdorf","Durmenach","Durrenbach","Durrenentzen","Durstel","Durtal","Durtol","Dury","Duttlenheim","Déols","Eance","Eaubonne","Eaucourt-sur-Somme","Eaunes","Eaux-Bonnes","Eaux-Puiseaux","Eauze","Ebersviller","Eblange","Ecaillon","Ecalles-Alix","Ecaquelon","Ecardenville-la-Campagne","Ecardenville-sur-Eure","Ecault","Eccles","Echalas","Echarcon","Echauffour","Echavanne","Echemire","Echenans","Echenevex","Echenon","Echenoz-la-Meline","Echevannes","Echevis","Echillais","Echinghen","Echire","Eckbolsheim","Eckwersheim","Eclaron-Braucourt-Sainte-Liviere","Ecleux","Ecluzelles","Ecoche","Ecole","Ecole-Valentin","Ecommoy","Ecorcei","Ecos","Ecouen","Ecouflant","Ecourt-Saint-Quentin","Ecouviez","Ecoyeux","Ecques","Ecquevilly","Ecretteville-les-Baons","Ecrosnes","Ecrouves","Ectot-les-Baons","Ecueil","Ecueille","Ecuelles","Ecuille","Ecuires","Ecuisses","Ecully","Ecury-sur-Coole","Edern","Effiat","Effry","Egletons","Egligny","Egly","Egreville","Eguilles","Eichhoffen","Einville-au-Jard","Elbeuf","Eletot","Eleu-dit-Leauwette","Elincourt","Elincourt-Sainte-Marguerite","Elliant","Ellon","Elna","Elnes","Eloise","Eloyes","Elven","Emance","Embrun","Embry","Emerainville","Emieville","Emmerin","Enchenberg","Enencourt-le-Sec","Enghien-les-Bains","Engins","Englefontaine","Englos","Ennery","Ennery","Ennevelin","Ennezat","Ennordres","Enquin-les-Mines","Ensisheim","Ensues-la-Redonne","Entraigues-sur-la-Sorgue","Entrains-sur-Nohain","Entrammes","Entrange","Entraygues-sur-Truyere","Entre-deux-Guiers","Entrecasteaux","Entremont-le-Vieux","Entressen","Entzheim","Enveig","Envermeu","Epagne-Epagnette","Epagny","Epaignes","Epegard","Epenancourt","Epenede","Epercieux-Saint-Paul","Eperlecques","Epernon","Epertully","Epervans","Epfig","Epiais-Rhus","Epieds-en-Beauce","Epierre","Epinac","Epinay","Epinay-sous-Senart","Epineuil-le-Fleuriel","Epinouze","Epinoy","Episy","Epoisses","Epone","Epouville","Eppe-Sauvage","Eppeville","Epping","Epuisay","Equeurdreville-Hainneville","Equihen-Plage","Er","Eragny","Erbray","Erbree","Erce-en-Lamee","Erce-pres-Liffre","Erceville","Ercheu","Erdeven","Ergersheim","Ergny","Ergue-Gaberic","Erize-Saint-Dizier","Ermenonville","Ermont","Ernee","Ernemont-sur-Buchy","Ernestviller","Ernolsheim-Bruche","Erome","Eroudeville","Erquinghem-Lys","Erquinvillers","Erquy","Erre","Errouville","Erstein","Ervauville","Esbarres","Esbly","Escalquens","Escames","Escassefort","Escaudain","Escaudoeuvres","Escautpont","Escazeaux","Eschau","Eschbach-au-Val","Eschentzwiller","Esches","Esclainvillers","Escolives-Sainte-Camille","Escombres-et-le-Chesnois","Escondeaux","Escorneboeuf","Escou","Escout","Escoutoux","Escurolles","Esery","Eslettes","Esmery-Hallon","Esnandes","Esnouveaux","Espagnac","Espalais","Espalion","Espaly-Saint-Marcel","Esparron-de-Verdon","Espedaillac","Espelette","Espeluche","Espezel","Espiet","Espinasses","Espira-de-Conflent","Espira-de-l'Agly","Espirat","Espondeilhan","Esquay-Notre-Dame","Esquay-sur-Seulles","Esquelbecq","Esquerchin","Esquerdes","Esquibien","Esquieze-Sere","Essegney","Essert","Essertaux","Esserts-Saleve","Essey","Essey-les-Nancy","Essia","Essigny-le-Grand","Esson","Essoyes","Estadens","Estagel","Estaing","Estaires","Esternay","Estevelles","Estillac","Estivareilles","Estouches","Estouteville-Ecalles","Estouy","Estrablin","Estree-Blanche","Estrees","Estrees-Saint-Denis","Estrees-les-Crecy","Estrees-sur-Noye","Esvres","Etable","Etables","Etables-sur-Mer","Etaimpuis","Etaing","Etainhus","Etalondes","Etampes-sur-Marne","Etang-sur-Arroux","Etaules","Etauliers","Etaux","Etaves-et-Bocquiaux","Eteimbes","Etel","Etelfay","Etercy","Eternoz","Eterville","Etevaux","Eth","Etigny","Etiolles","Etival","Etival-Clairefontaine","Etival-les-le-Mans","Etoges","Etoile-sur-Rhone","Etourvy","Etouvans","Etouvy","Etrechy","Etrechy","Etreillers","Etrelles","Etrembieres","Etrepagny","Etrepilly","Etreux","Etrez","Etriac","Etriche","Etricourt-Manancourt","Etroeungt","Etroussat","Ettendorf","Etting","Etupes","Etuz","Etzling","Eu","Eulmont","Euville","Evans","Evenos","Everly","Eveux","Evin-Malmaison","Evran","Evrecy","Evron","Excenevex","Excideuil","Exideuil","Exincourt","Exireuil","Exoudun","Eybens","Eybouleuf","Eygalieres","Eyguieres","Eygurande-et-Gardedeuil","Eyjeaux","Eyliac","Eymet","Eymoutiers","Eyragues","Eyrans","Eysines","Eyzin-Pinet","Ezanville","Eze","Ezy-sur-Eure","Fabregues","Fabrezan","Faches","Faches-Thumesnil","Fagnieres","Faimbe","Fains-Veel","Falaise","Falaise","Falck","Falicon","Fallerans","Falleron","Falletans","Famars","Fameck","Fampoux","Fanjeaux","Faramans","Farbus","Farebersviller","Fareins","Faremoutiers","Farges-les-Chalon","Fargues","Fargues","Fargues-Saint-Hilaire","Farincourt","Fatouville-Grestain","Fauch","Faucigny","Faucogney-et-la-Mer","Faucompierre","Faulquemont","Faulx","Faumont","Fauquembergues","Fauville-en-Caux","Favars","Faverges","Faverges-de-la-Tour","Faverolles-la-Campagne","Faverolles-sur-Cher","Favieres","Favieres","Fay-aux-Loges","Fay-de-Bretagne","Fay-les-Nemours","Faye-l'Abbesse","Fayence","Fayet-le-Chateau","Fayl-Billot","Fays-la-Chapelle","Fayssac","Feas","Fechain","Feche-l'Eglise","Fegersheim","Fegreac","Feigeres","Feignies","Feillens","Fein","Feissons-sur-Isere","Feldkirch","Felines","Felines","Felix","Fellering","Felletin","Fenain","Fenay","Fendeille","Fenetrange","Feneu","Feneyrols","Fenioux","Fenouillet","Fenouillet","Fere-Champenoise","Fere-en-Tardenois","Ferel","Ferfay","Fericy","Ferin","Fermanville","Ferney-Voltaire","Ferolles-Attilly","Ferques","Ferrals-les-Corbieres","Ferreol","Ferrette","Ferreux-Quincey","Ferriere-Larcon","Ferriere-la-Grande","Ferriere-la-Petite","Ferrieres","Ferrieres","Ferrieres-Haut-Clocher","Ferrieres-en-Brie","Ferrieres-en-Gatinais","Ferrieres-les-Scey","Ferrieres-sur-Ariege","Fesches-le-Chatel","Fesques","Fessenheim","Festieux","Festubert","Feternes","Feucherolles","Feuges","Feuguerolles-sur-Seulles","Feuilla","Feuquieres","Feuquieres-en-Vimeu","Feurs","Feves","Fey","Feytiat","Feyzin","Fiefs","Fiennes","Fierville-Bray","Fierville-les-Mines","Figanieres","Figeac","Fignieres","Filain","Fille","Fillievres","Fillinges","Filstroff","Finhan","Firmi","Firminy","Fislis","Fismes","Fitilieu","Fitz-James","Flagnac","Flamanville","Flamarens","Flancourt-Catelon","Flangebouche","Flaucourt","Flaux","Flavacourt","Flavigny","Flavigny-sur-Moselle","Flavin","Flavy-le-Martel","Flaxlanden","Flayosc","Fleac","Flechin","Flee","Flers","Flers-en-Escrebieux","Flers-sur-Noye","Fletrange","Fletre","Fleurance","Fleurbaix","Fleure","Fleurey-sur-Ouche","Fleurie","Fleuriel","Fleurieux-sur-l'Arbresle","Fleury","Fleury-Merogis","Fleury-en-Biere","Fleury-les-Aubrais","Fleury-sur-Andelle","Fleury-sur-Orne","Fleville-devant-Nancy","Flevy","Flines-les-Mortagne","Flines-lez-Raches","Flins-sur-Seine","Flixecourt","Floing","Floirac","Florac","Florange","Florensac","Florent-en-Argonne","Florentin","Florentin","Floyon","Flumet","Foameix-Ornel","Foecy","Foissiat","Foix","Folelli","Folembray","Folgensbourg","Follainville-Dennemont","Folles","Folleville","Folschviller","Fonbeauzard","Foncine-le-Haut","Fondettes","Fons","Fons","Fonsorbes","Font-Romeu-Odeillo-Via","Fontain","Fontaine","Fontaine","Fontaine-Bonneleau","Fontaine-Etoupefour","Fontaine-Guerin","Fontaine-Heudebourg","Fontaine-Milon","Fontaine-Notre-Dame","Fontaine-Notre-Dame","Fontaine-Simon","Fontaine-Uterte","Fontaine-au-Bois","Fontaine-en-Dormois","Fontaine-la-Mallet","Fontaine-le-Comte","Fontaine-le-Dun","Fontaine-le-Pin","Fontaine-les-Bassets","Fontaine-les-Dijon","Fontaine-les-Gres","Fontaine-les-Luxeuil","Fontaine-sous-Jouy","Fontaine-sous-Preaux","Fontaine-sur-Somme","Fontainebleau","Fontaines","Fontaines","Fontaines-Saint-Martin","Fontaines-sur-Saone","Fontanes","Fontanil-Cornillon","Fontannes","Fontcouverte","Fontenai-les-Louvets","Fontenay","Fontenay-Tresigny","Fontenay-aux-Roses","Fontenay-en-Parisis","Fontenay-le-Comte","Fontenay-le-Fleury","Fontenay-le-Vicomte","Fontenay-sous-Bois","Fontenay-sur-Loing","Fontenay-sur-Vegre","Fontenelle-en-Brie","Fontenilles","Fontenoy","Fontenoy-la-Joute","Fontenoy-le-Chateau","Fontes","Fontjoncouse","Fontpedrosa","Fontrabiouse","Fontvannes","Fontvieille","Forbach","Forcalqueiret","Forcalquier","Force","Forest-sur-Marque","Foret-la-Folie","Forfry","Forges","Forges-les-Bains","Forges-les-Eaux","Forleans","Formerie","Fors","Fort-Mahon-Plage","Fort-Mardyck","Fortschwihr","Fos-sur-Mer","Fosse","Fossemanant","Fosses","Fosses-et-Baleyssac","Fouchy","Fouday","Fouencamps","Fouesnant","Foug","Fougax-et-Barrineuf","Fougere","Fougeres","Fougeres","Fougeres-sur-Bievre","Fougerolles","Fouillard","Fouilleuse","Foulangues","Foulayronnes","Foulcrey","Fouquebrune","Fouquieres-les-Lens","Four","Fouras","Fourchambault","Fourches","Fourdrinoy","Fourg","Fourmies","Fournes-en-Weppes","Fournier","Fournival","Fournols","Fouronnes","Fourques","Fourques-sur-Garonne","Fourqueux","Fours-Saint-Laurent","Foussemagne","Fragnes","Fraisans","Fraisses","Fraize","Fralignes","Frambouhans","Framerville-Rainecourt","Francaltroff","Francardo","Francheleins","Francheville","Francieres","Franclens","Francois","Franconville","Francourville","Frangy","Franois","Franqueville","Franvillers","Franxault","Frauenberg","Frebuans","Frechede","Frechencourt","Frechou","Fredille","Fregimont","Fregouville","Freistroff","Frejairolles","Freland","Frelinghien","Fremainville","Fremifontaine","Fremonville","Frencq","Frenes","Freneuse","Frepillon","Fresnay-en-Retz","Fresnay-l'Eveque","Fresnay-le-Gilmert","Fresnay-sur-Sarthe","Fresne","Fresne-Cauverville","Fresne-Saint-Mames","Fresne-la-Mere","Fresneaux-Montchevreuil","Fresnes","Fresnes-au-Mont","Fresnes-en-Woevre","Fresnes-les-Montauban","Fresnes-sur-Escaut","Fresnes-sur-Marne","Fresnicourt-le-Dolmen","Fresnoy-la-Riviere","Fresnoy-le-Grand","Frespech","Fressac","Fressain","Fresse","Fresse-sur-Moselle","Fressenneville","Fressies","Fressines","Frethun","Fretigney-et-Velloreille","Fretin","Frevent","Frevillers","Frevin-Capelle","Friauville","Frieres-Faillouel","Friesen","Friville-Escarbotin","Frocourt","Froges","Froidestrees","Froidfond","Froissy","Fromelles","Fromont","Fromonville","Froncles","Fronsac","Frontenac","Frontenas","Frontenay-Rohan-Rohan","Frontenay-sur-Dive","Frontenex","Frontignan","Frontignan-Saves","Fronton","Frontonas","Frossay","Frouard","Frouzins","Frozes","Frucourt","Frugeres-les-Mines","Fruges","Fréjus","Fuisse","Fultot","Fumay","Fumel","Furchhausen","Furiani","Fussy","Fuveau","Fye","Fécamp","Gaas","Gabaston","Gabat","Gace","Gagnac-sur-Garonne","Gagnieres","Gagny","Gahard","Gailhan","Gaillac","Gaillac-Toulza","Gaillan-en-Medoc","Gaillard","Gaillefontaine","Gaillon","Galametz","Galapian","Galargues","Galfingue","Galgon","Galie","Gallardon","Gallician","Galluis","Gamaches","Gamarde-les-Bains","Gambais","Gambsheim","Gan","Ganac","Gandrange","Ganges","Gannat","Gap","Garancieres-en-Drouais","Garanou","Garat","Garche","Garches","Garchizy","Gardanne","Gardonne","Garencieres","Garennes-sur-Eure","Gareoult","Gargenville","Garges-lès-Gonesse","Garlan","Garlin","Garons","Garrevaques","Garrigues","Garris","Garrosse","Gas","Gasny","Gassin","Gasville-Oiseme","Gatelles","Gatey","Gattieres","Gauchy","Gauciel","Gauriac","Gauriaguet","Gauville-la-Campagne","Gavarnie","Gavray","Gaye","Geanges","Geaune","Geay","Gee","Geispolsheim","Gelannes","Gelles","Gelos","Geloux","Gemeaux","Gemenos","Gemil","Gemozac","Genac","Genas","Genay","Gencay","Gendrey","Gene","Genebrieres","Genech","Genelard","Generac","Generargues","Genet","Geneuille","Geney","Genille","Genis","Genissac","Genissiat","Genissieux","Genlis","Gennes","Gennes-sur-Seiche","Gennetines","Gennevilliers","Gensac","Gensac-la-Pallue","Gente","Gentilly","Georges","Geovreisset","Ger","Ger","Gerard","Gerbaix","Gerbecourt-et-Haplemont","Gerbeviller","Gergy","Gerland","Germaine","Germainville","Germenay","Germigny-des-Prés","Germigny-l'Eveque","Germigny-sur-Loire","Germond-Rouvre","Gerstheim","Gervais","Gervans","Gerzat","Gesnes-le-Gandelin","Geste","Gestel","Gesvres","Getigne","Geudertheim","Geveze","Gevrey-Chambertin","Gevrieux","Gex","Geyssans","Gezaincourt","Gezoncourt","Ghisonaccia","Ghyvelde","Giat","Giberville","Gidy","Gien","Gieres","Gievres","Gif-sur-Yvette","Gigean","Gignac","Gignac","Gignac-la-Nerthe","Gigny-sur-Saone","Gilette","Gilles","Gilley","Gilly-les-Citeaux","Gilly-sur-Isere","Gimbrett","Gimeux","Gimont","Ginasservis","Ginestas","Ginestet","Girancourt","Giraumont","Girolles","Giromagny","Giron","Gironcourt-sur-Vraine","Gironde-sur-Dropt","Giroussens","Gisors","Givenchy-en-Gohelle","Givet","Givors","Givraines","Givrand","Givrauval","Givron","Givry","Glanon","Glatigny","Gleize","Glenic","Glomel","Glos-sur-Risle","Goderville","Godewaersvelde","Goersdorf","Goes","Goetzenbruck","Goeulzin","Goin","Goincourt","Golbey","Golfe-Juan","Gombergean","Gomelange","Gomene","Gomer","Gometz-la-Ville","Gometz-le-Chatel","Gommegnies","Gommerville","Gommerville","Goncelin","Gondecourt","Gondeville","Gondrecourt-le-Chateau","Gondreville","Gonesse","Gonfaron","Gonfreville-Caillot","Gonfreville-lOrcher","Gonnehem","Gonneville-la-Mallet","Gonneville-sur-Mer","Gontier","Gorbio","Gorcy","Gordes","Gorges","Gornac","Gorre","Gorron","Gorze","Gosnay","Gosné","Gosselming","Gottenhouse","Gouaix","Gouaux","Goudelin","Goudourville","Gouesnach","Gouesnou","Gouezec","Gouillons","Gouise","Goulet","Goult","Goupillieres","Goupillieres","Gourdan-Polignan","Gourdon","Gourge","Gourhel","Gourin","Gourlizon","Gournay-en-Bray","Gournay-sur-Marne","Gourvillette","Goury","Goussainville","Goussainville","Gousse","Goutrens","Gouts","Gouttieres","Gouvernes","Gouves","Gouvieux","Gouville-sur-Mer","Goux-les-Dambelin","Goux-les-Usiers","Gouy-Saint-Andre","Gouy-en-Artois","Gouy-en-Ternois","Gouy-sous-Bellonne","Gouze","Gouzeaucourt","Goven","Goxwiller","Goyrans","Grabels","Gracay","Graces","Gradignan","Gragnague","Graincourt-les-Havrincourt","Grainville","Grainville-la-Teinturiere","Grainville-sur-Odon","Graissessac","Gramat","Grammond","Grand","Grand Champ","Grand'Combe-Chateleu","Grand-Auverne","Grand-Charmont","Grand-Fort-Philippe","Grand-Fougeray","Grand-Laviers","Grand-Rozoy","Grandchamp","Grandchamps-des-Fontaines","Grande-Synthe","Grandfontaine","Grandfontaine-Fournets","Grandfresnoy","Grandpre","Grandris","Grandsaigne","Grandvaux","Grandvillars","Grandville-Gaudreville","Grandvillers","Grandvilliers","Grane","Granges","Granges-le-Bourg","Granges-sur-Vologne","Grangues","Grans","Granville","Grasse","Grassendorf","Gratentour","Gratot","Graulhet","Grauves","Gravelines","Graveron-Semerville","Graveson","Gravigny","Gray","Grazac","Grazay","Greasque","Gremecey","Gremevillers","Gremonville","Grenade","Grenay","Greneville-en-Beauce","Grenoble","Grentheville","Grentzingen","Greolieres","Greoux-les-Bains","Grepiac","Gresse-en-Vercors","Gresswiller","Gressy","Gresy-sur-Aix","Gresy-sur-Isere","Gretz-Armainvilliers","Grez-en-Bouere","Grez-sur-Loing","Grezieu-la-Varenne","Grezillac","Grezolles","Gries","Griesbach-au-Val","Griesheim-pres-Molsheim","Grignan","Grignols","Grigny","Grigny","Grillon","Grilly","Grimaud","Gripport","Griselles","Griselles","Grisolles","Grisy-Suisnes","Grisy-sur-Seine","Grivillers","Groffliers","Groissiat","Groisy","Groix","Gron","Gros-Rederching","Grosbliederstroff","Grosbreuil","Groslay","Grosrouvre","Grosseto-Prugna","Grossoeuvre","Grozon","Gruchet-le-Valasse","Gruey-les-Surance","Gruffy","Grugies","Gruissan","Grun-Bordas","Grundviller","Gruson","Grussenheim","Guebwiller","Guecelard","Guegon","Guemar","Guemene-Penfao","Guemene-sur-Scorff","Guenange","Guengat","Guenin","Guenrouet","Guer","Guerande","Guerard","Guercheville","Gueret","Guerigny","Guerlesquin","Guernes","Guerting","Guerville","Guerville","Guesnain","Guessling-Hemering","Guethary","Gueugnon","Gueures","Gueux","Guewenheim","Guiche","Guichen","Guiclan","Guidel","Guignen","Guignes","Guigneville","Guignicourt","Guignicourt-sur-Vence","Guiler-sur-Goyen","Guilers","Guilherand-Granges","Guillestre","Guilliers","Guilly","Guilvinec","Guines","Guingamp","Guipavas","Guipel","Guipronvel","Guipry","Guiscard","Guise","Guiseniers","Guitalens","Guivry","Gujan-Mestras","Gumbrechtshoffen","Gundershoffen","Gundolsheim","Guntzviller","Guny","Gurs","Guyancourt","Gy-en-Sologne","Gérardmer","Habas","Habere-Lullin","Habsheim","Hadol","Hagenbach","Hagenthal-le-Haut","Hagetmau","Hageville","Hagondange","Haguenau","Haillicourt","Haironville","Haisnes","Hallencourt","Hallennes-lez-Haubourdin","Hallering","Hallines","Halloy-les-Pernois","Halluin","Ham","Ham-en-Artois","Ham-sous-Varsberg","Ham-sur-Meuse","Hamars","Hambach","Hambers","Hamel","Hammeville","Han-sur-Nied","Hanches","Hangenbieten","Hangest-en-Santerre","Hannogne-Saint-Martin","Hantay","Hanvec","Happonvilliers","Haramont","Haraucourt","Haraucourt","Harbonnieres","Harcanville","Harcigny","Harcourt","Hardelot-Plage","Hardencourt","Hardifort","Hardinvast","Harfleur","Hargicourt","Hargnies","Harnes","Haroue","Harprich","Harreberg","Harreville-les-Chanteurs","Harskirchen","Hartmannswiller","Hary","Hasnon","Hasparren","Haspres","Hastingues","Hatten","Hattenville","Hattstatt","Haubourdin","Hauconcourt","Haucourt-Moulaine","Haudiomont","Haudivillers","Haulchin","Haussignemont","Haussimont","Haussy","Haut-Clocher","Haute-Goulaine","Haute-Isle","Haute-Rivoire","Haute-Vigneulles","Hautecloque","Hautefage-la-Tour","Hautefort","Hauteluce","Hauterive","Hauterive","Hauterives","Hauteville-Lompnes","Hauteville-les-Dijon","Hauteville-sur-Mer","Hautmont","Hautot-sur-Mer","Hautvillers","Hautvillers-Ouville","Haveluy","Haverskerque","Havrincourt","Hayange","Haybes","Hazebrouck","Hebecourt","Hebecrevon","Hebuterne","Hede-Bazouges","Hegenheim","Heidwiller","Heiligenberg","Heillecourt","Heilly","Heimersdorf","Heimsbrunn","Heiteren","Helesmes","Helette","Helfaut","Hellemmes-Lille","Hellimer","Hem","Hemevillers","Heming","Hemonstoir","Henansal","Hendaye","Henin-Beaumont","Henin-sur-Cojeul","Hennebont","Henon","Henonville","Henouville","Henrichemont","Henridorff","Henvic","Herbeys","Herbignac","Herblay","Herchies","Herepian","Heres","Hergnies","Heric","Hericourt","Hericy","Herimoncourt","Herin","Herisson","Herlies","Hermanville-sur-Mer","Hermelange","Hermeray","Hermes","Hermies","Hermillon","Herny","Herouvillette","Herpy-l'Arlesienne","Herrlisheim-pres-Colmar","Herserange","Hersin-Coupigny","Hery-sur-Alby","Herzeele","Hesdin","Hesdin-l'Abbe","Hesingue","Hestrus","Hettange-Grande","Heuchin","Heudebouville","Heudicourt","Heudicourt-sous-les-Cotes","Heudreville-sur-Eure","Heugas","Heuqueville","Heurtevent","Heutregiville","Heyrieux","Higueres-Souye","Hilbesheim","Hillion","Hindlingen","Hinges","Hipsheim","Hirel","Hirsingue","Hirson","Hochfelden","Hochstatt","Hocquigny","Hodenc-en-Bray","Hodeng-Hodenger","Hoenheim","Hoerdt","Hohfrankenheim","Hohwiller","Holnon","Holtzheim","Holtzwihr","Holving","Hombleux","Homblieres","Hombourg","Hombourg-Budange","Hombourg-Haut","Homecourt","Homps","Hon-Hergies","Hondeghem","Hondouville","Hondschoote","Honfleur","Honnecourt-sur-Escaut","Hopital-Camfrout","Horbourg-Wihr","Hordain","Horgues","Hornaing","Hossegor","Houchin","Houdain-lez-Bavay","Houdan","Houdelmont","Houdemont","Houeilles","Houilles","Houlbec-Cocherel","Houlette","Houlgate","Houlle","Houplin-Ancoisne","Houplines","Houppeville","Hourtin","Houry","Houssen","Housseville","Houville-la-Branche","Houx","Hoymille","Hubersent","Huberville","Huchenneville","Hucqueliers","Hudimesnil","Huelgoat","Huest","Huez","Hugier","Huiron","Huisseau-sur-Cosson","Huisseau-sur-Mauves","Hulluch","Hultehouse","Hundling","Hundsbach","Huningue","Hunspach","Huppy","Hure","Huriel","Hurigny","Husseren-Wesserling","Husseren-les-Chateaux","Hussigny-Godbrange","Huttenheim","Hyemondans","Hyères","Hérouville-Saint-Clair","Idrac-Respailles","Idron","Iffendic","Ifs","Igney","Igny","Igon","Igoville","Ile-d'Arz","Illange","Ille-sur-Tet","Illfurth","Illhaeusern","Illiat","Illiers-Combray","Illiers-l'Eveque","Illifaut","Illkirch-Graffenstaden","Illois","Illzach","Imling","Imphy","Incheville","Inchy","Indre","Ingersheim","Ingolsheim","Ingrandes","Ingre","Inguiniel","Ingwiller","Innenheim","Inxent","Ippling","Irai","Irancy","Irigny","Irissarry","Irodouer","Irouleguy","Irreville","Is-sur-Tille","Isbergues","Isches","Isigny-le-Buat","Isigny-sur-Mer","Isle","Isle-et-Bardais","Isles-les-Villenoy","Isneauville","Isola","Ispoure","Isques","Issancourt-et-Rumel","Issenhausen","Issenheim","Issoire","Issou","Issoudun","Issus","Issy-les-Moulineaux","Istres","Itancourt","Iteuil","Ittenheim","Itteville","Itxassou","Iville","Ivoy-le-Pre","Ivry-la-Bataille","Ivry-le-Temple","Ivry-sur-Seine","Iwuy","Izeaux","Izernore","Izeron","Izier","Izon","Izotges","Jabreilles-les-Bordes","Jacob-Bellecombette","Jacou","Jainvillotte","Jallais","Jallans","Jallerange","Jalognes","Jalogny","Jalons","Jambles","Jametz","Jandun","Janneyrias","Janville","Janville","Janville-sur-Juine","Janvilliers","Janvry","Janze","Jarcieu","Jard-sur-Mer","Jardin","Jardres","Jargeau","Jarmenil","Jarnac-Champagne","Jarnages","Jarny","Jarrie","Jarrier","Jars","Jarville-la-Malgrange","Jarze","Jassans-Riottier","Jasseron","Jaucourt","Jaujac","Jaunay-Clan","Jaure","Jausiers","Jaux","Javene","Javrezac","Jayat","Jazeneuil","Jeandelaincourt","Jeanmenil","Jebsheim","Jegun","Jenlain","Jesonville","Jettingen","Jeu-les-Bois","Jeufosse","Jeumont","Jeune","Jeurre","Jeux-les-Bard","Jeuxey","Jezainville","Job","Jobourg","Joch","Joeuf","Joigny","Joigny-sur-Meuse","Joinville","Joinville-le-Pont","Jolimetz","Jolivet","Jonage","Jonchery-sur-Vesle","Joncourt","Jonquerets-de-Livet","Jonquerettes","Jonquieres","Jonquieres","Jonquieres","Jons","Jonvelle","Jonvilliers","Jonzac","Jonzier-Epagny","Jonzieux","Josnes","Josse","Josselin","Jossigny","Jouarre","Jouars-Pontchartrain","Jouaville","Joudreville","Joue-l'Abbe","Joue-sur-Erdre","Jougne","Jouhet","Jouques","Journans","Journiac","Journy","Joux","Jouy-en-Josas","Jouy-le-Chatel","Jouy-le-Moutier","Jouy-le-Potier","Jouy-sous-Thelle","Jouy-sur-Eure","Jouy-sur-Morin","Joué-lès-Tours","Juan-les-Pins","Jugeals-Nazareth","Jugon-les-Lacs","Juigne-sur-Loire","Juigne-sur-Sarthe","Juillac","Juillan","Juilles","Juilly","Juilly","Jujurieux","Julienas","Julienne","Jully-sur-Sarce","Jumeauville","Jumelles","Jumelles","Jumilhac-le-Grand","Jumièges","Junay","Jungholtz","Juniville","Jupilles","Jurancon","Jury","Jussey","Jussy","Jussy","Juvaincourt","Juvignac","Juvigny","Juvigny","Juvigny-en-Perthois","Juville","Juvisy-sur-Orge","Juziers","Kaltenhouse","Kappelen","Katzenthal","Kaysersberg","Kedange-sur-Canner","Kembs","Kerbach","Kerfot","Kerfourn","Kergloff","Kerien","Kerity","Kerlaz","Kerlouan","Kernascleden","Kerpert","Kervignac","Kesseldorf","Kienheim","Kientzheim","Killem","Kilstett","Kingersheim","Kintzheim","Knutange","Koenigsmacker","Koeur-la-Petite","Krafft","Krautergersheim","Kriegsheim","Kruth","Kunheim","Kuntzig","Kurtzenhouse","Kutzenhausen","L'Aigle","L'Albenc","L'Argentiere-la-Bessee","L'Epine","L'Etang-Vergy","L'Etang-la-Ville","L'Etoile","L'Etrat","L'Haÿ-les-Roses","L'Herbergement","L'Hermitage","L'Hopital","L'Horme","L'Houmeau","L'Huisserie","L'Ile-Saint-Denis","L'Isle-Adam","L'Isle-Jourdain","L'Isle-Jourdain","L'Isle-d'Abeau","L'Isle-sur-la-Sorgue","L'Orbrie","L'Union","L'Île-Rousse","LAiguillon-sur-Mer","LArbresle","LIsle-dEspagnac","LIsle-sur-le-Doubs","La Baconniere","La Balme-d'Epy","La Barben","La Barre-de-Monts","La Barre-en-Ouche","La Barthe","La Bassee","La Bastide","La Bastide","La Bastide","La Bathie","La Batie","La Baule-Escoublac","La Baume-de-Transit","La Baussaine","La Bazoche-Gouet","La Bazoge","La Begue","La Bernerie-en-Retz","La Berthenoux","La Bigne","La Biolle","La Bohalle","La Boissiere-des-Landes","La Bosse","La Bosse-de-Bretagne","La Bouexiere","La Bouilladisse","La Bourboule","La Bourgonce","La Boussac","La Bresse","La Bretonne","La Bridoire","La Brigue","La Brillanne","La Broque","La Brosse","La Bruffiere","La Brulatte","La Buisse","La Buissiere","La Bussiere","La Cadiere-d'Azur","La Calmette","La Calotterie","La Canourgue","La Capelle","La Caunette","La Cavalerie","La Celle","La Celle","La Celle","La Celle-Saint-Cloud","La Celle-sous-Montmirail","La Celle-sur-Seine","La Cerlangue","La Chaise","La Chaise","La Chaise-Baudouin","La Chaize-le-Vicomte","La Chapelaude","La Chapelle","La Chapelle-Baton","La Chapelle-Blanche","La Chapelle-Gaudin","La Chapelle-Gauthier","La Chapelle-Heulin","La Chapelle-Laurent","La Chapelle-Montligeon","La Chapelle-Orthemale","La Chapelle-Saint-Luc","La Chapelle-Yvon","La Chapelle-aux-Bois","La Chapelle-aux-Lys","La Chapelle-d'Alagnon","La Chapelle-d'Armentieres","La Chapelle-de-Brain","La Chapelle-de-Guinchay","La Chapelle-en-Vercors","La Chapelle-sur-Chezy","La Charité-sur-Loire","La Charme","La Charmee","La Chartre-sur-le-Loir","La Chataigneraie","La Chatre","La Chatre-Langlin","La Chaumusse","La Chaussaire","La Chaussee","La Chaux-du-Dombief","La Cheneviere","La Chevallerais","La Chevroliere","La Ciotat","La Clayette","La Clisse","La Clotte","La Clusaz","La Cluse-et-Mijoux","La Colle-sur-Loup","La Combelle","La Copechagniere","La Coquille","La Cornuaille","La Cote","La Cote","La Couarde-sur-Mer","La Coucourde","La Coudre","La Coulonche","La Courneuve","La Couronne","La Couronne","La Couture-Boussey","La Crau","La Croix-Valmer","La Cropte","La Dagueniere","La Defense","La Destrousse","La Digne-d'Amont","La Dominelais","La Fare-en-Champsaur","La Farlede","La Faute-sur-Mer","La Faye","La Fere","La Ferriere","La Ferriere-Bochard","La Ferte","La Ferte-Alais","La Ferte-Mace","La Ferte-Milon","La Ferte-Saint-Cyr","La Ferte-Saint-Samson","La Ferte-sous-Jouarre","La Feuillade","La Feuillie","La Feuillie","La Flachere","La Fleche","La Flocelliere","La Flotte","La Force","La Forest-Landerneau","La Foret","La Foret","La Foret-Fouesnant","La Forie","La Fouillade","La Fouillouse","La Foux","La Foye-Monjault","La Frasse","La Frenaye","La Fresnais","La Frette","La Frette","La Frette-sur-Seine","La Gacilly","La Gaillarde","La Gaillarde","La Garde","La Garde","La Garenne","La Garenne-Colombes","La Garnache","La Gaubretiere","La Gaude","La Gavotte","La Glacerie","La Gorgue","La Gouesniere","La Grand-Croix","La Grande-Motte","La Grandville","La Grave","La Graverie","La Gree-Saint-Laurent","La Greve-sur-Mignon","La Grigonnais","La Groise","La Guerche","La Guerche-de-Bretagne","La Gueroulde","La Guierche","La Guyonniere","La Haie","La Halle","La Hallotiere","La Haye","La Haye-Saint-Sylvestre","La Houblonniere","La Houssaye-en-Brie","La Houssoye","La Jaille-Yvon","La Jarne","La Jarrie","La Jubaudiere","La Jumelliere","La Laigne","La Lande","La Lande","La Landec","La Laupie","La Lechere","La Limouziniere","La Liviniere","La Londe","La Londe-les-Maures","La Loubiere","La Loupe","La Lucerne-dOutremer","La Machine","La Madeleine","La Madeleine","La Madeleine-sur-Loing","La Magdelaine-sur-Tarn","La Mailleraye-sur-Seine","La Malhoure","La Marche","La Marolle-en-Sologne","La Martiniere","La Maxe","La Meauffe","La Meaugon","La Meignanne","La Meilleraie-Tillay","La Meilleraye-de-Bretagne","La Membrolle-sur-Choisille","La Membrolle-sur-Longuenee","La Menitre","La Meziere","La Milesse","La Montagne","La Montagne","La Montagne","La Mothe-Saint-Heray","La Motte","La Motte-Chalancon","La Motte-Fouquet","La Motte-Saint-Jean","La Motte-Saint-Martin","La Motte-Servolex","La Motte-du-Caire","La Mulatiere","La Muraz","La Mure","La Napoule","La Nerthe","La Neuveville-devant-Lepanges","La Neuville-d'Aumont","La Neuville-du-Bosc","La Noe","La Norville","La Palud","La Paute","La Penne-sur-Huveaune","La Perche","La Place","La Plagne","La Plaine","La Plaine","La Plaine-Saint-Denis","La Planche","La Plane","La Pointe","La Poiteviniere","La Pommeraye","La Porcherie","La Porte","La Possonniere","La Poste","La Poterie","La Poterie-Mathieu","La Poueze","La Puye","La Queue-en-Brie","La Queue-les-Yvelines","La Ravoire","La Remuee","La Renaudiere","La Reole","La Reorthe","La Ricamarie","La Richardais","La Riche","La Riviere","La Riviere","La Riviere","La Riviere","La Riviere-de-Corps","La Rixouse","La Roche","La Roche","La Roche","La Roche","La Roche-Blanche","La Roche-des-Arnauds","La Roche-sur-Yon","La Roche-sur-le-Buis","La Rochefoucauld","La Rochegiron","La Rochelle","La Rochenard","La Rochette","La Rochette","La Rochette-sur-Crest","La Romagne","La Ronde","La Roque-Baignard","La Roque-d'Antheron","La Roquebrussanne","La Roquette-sur-Siagne","La Rouine","La Rouquette","La Rouviere","La Salette-Fallavaux","La Salle-de-Vihiers","La Salvetat-Lauragais","La Salvetat-Saint-Gilles","La Salvetat-sur-Agout","La Saulce","La Sauve","La Sauvetat-de-Saveres","La Seauve-sur-Semene","La Seguiniere","La Selle-en-Hermoy","La Selve","La Sentinelle","La Seyne-sur-Mer","La Sone","La Souche","La Souterraine","La Suze-sur-Sarthe","La Tagniere","La Taillee","La Talaudiere","La Tardiere","La Terrasse","La Tessoualle","La Teste-de-Buch","La Tour","La Tour","La Tour-Saint-Gelin","La Tour-dAuvergne","La Tour-de-Scay","La Tour-du-Crieu","La Tour-sur-Orb","La Tourette","La Tranche-sur-Mer","La Treille","La Tremblade","La Trimouille","La Trinite","La Trinite-de-Reville","La Trinité-sur-Mer","La Tronche","La Tuiliere","La Turballe","La Turbie","La Vacherie","La Valette-du-Var","La Vallee de Dormelles","La Varenne","La Varenne","La Vaupaliere","La Verpilliere","La Verrie","La Verriere","La Vespiere","La Veze","La Ville","La Ville aux Chiens","La Ville-aux-Bois","La Villedieu","La Villedieu-les-Quenoche","La Villeneuve","La Villetelle","La Voulte-sur-Rhone","La Vraie-Croix","La Walck","La Wantzenau","Laas","Labaroche","Labarthe-sur-Leze","Labastide-Beauvoir","Labastide-Cezeracq","Labastide-Gabausse","Labastide-Rouairoux","Labastide-Saint-Pierre","Labastide-d'Anjou","Labastide-dArmagnac","Labastide-de-Virac","Labastidette","Labatut","Labege","Labenne","Labessiere-Candeil","Labeuvriere","Lablachere","Labouheyre","Labouquerie","Labourse","Labretonie","Labruguiere","Labruyere","Labry","Labuissiere","Lacabarede","Lacadee","Lacanau","Lacapelle-Cabanac","Lacapelle-Marival","Lacapelle-Viescamp","Lacaune","Lacaussade","Lachapelle","Lachapelle-sous-Chaux","Lachapelle-sous-Rougemont","Lachaux","Lacour","Lacq","Lacroix-Falgarde","Lacroix-Saint-Ouen","Lacroix-sur-Meuse","Lacrost","Lacs","Ladoix-Serrigny","Ladon","Laduz","Lafare","Lafeuillade-en-Vezie","Lafitole","Lafox","Lagarde-d'Apt","Lagardelle-sur-Leze","Lagardere","Lagarrigue","Lagnes","Lagnieu","Lagny-le-Sec","Lagor","Lagord","Lagrave","Laguenne","Laguiole","Lagupie","Lahitte-Toupiere","Lahonce","Lahontan","Lahosse","Lahourcade","Laifour","Laigne","Laigne-en-Belin","Laignelet","Laignes","Laigneville","Laille","Lailly-en-Val","Lainsecq","Laissac","Laissaud","Laissey","Laiz","Laize","Lalanne-Arque","Lalbenque","Laleu","Lalinde","Lallaing","Lalonquette","Laloubere","Lamagdelaine","Lamagistere","Lamaire","Lamalou-les-Bains","Lamanon","Lamarche","Lamarche-sur-Saone","Lamastre","Lamativie","Lamaziere-Basse","Lamballe","Lambersart","Lambert","Lambesc","Lambres-lez-Douai","Lamnay","Lamorlaye","Lamorville","Lamothe-Landerron","Lamothe-Montravel","Lamotte-Beuvron","Lampaul-Guimiliau","Lampaul-Plouarzel","Lampertheim","Lampertsloch","Lancey","Lancie","Lancieux","Lancon-Provence","Lancrans","Landas","Landebia","Landeda","Landelles","Landelles-et-Coupigny","Landemont","Landepereuse","Landerneau","Landeronde","Landes","Landevant","Landevieille","Landivisiau","Landogne","Landos","Landrecies","Landres","Landrethun-le-Nord","Landrethun-les-Ardres","Landrevarzec","Landry","Landser","Landujan","Landunvez","Lanester","Laneuvelotte","Laneuveville-aux-Bois","Laneuveville-devant-Bayon","Laneuveville-devant-Nancy","Langan","Langeac","Langeais","Langensoultzbach","Langlade","Langoat","Langoelan","Langoiran","Langolen","Langon","Langon","Langonnet","Langourla","Langres","Langrune-sur-Mer","Langueux","Languidic","Lanhelin","Laning","Lanleff","Lanmerin","Lanmeur","Lanne","Lanne-en-Baretous","Lannebert","Lannemezan","Lannilis","Lannion","Lannoy","Lannoy-Cuillere","Lanobre","Lanouee","Lanrelas","Lanrodec","Lans","Lans-en-Vercors","Lansac","Lansargues","Lanta","Lantenne-Vertiere","Lanthenans","Lantignie","Lantilly","Lanton","Lantriac","Lanvallay","Lanvaudan","Lanveoc","Lanvollon","Lanzac","Laon","Lapalisse","Lapalme","Lapalud","Laparrouquial","Lapenche","Laperriere-sur-Saone","Lapeyrouse-Fossat","Lapeyrouse-Mornay","Lapoutroie","Lapouyade","Lapte","Lapugnoy","Laquenexy","Laqueuille","Laragne-Monteglin","Larcay","Larchant","Larche","Lardy","Largeasse","Largentière","Largillay-Marsonnay","Lariviere-Arnoncourt","Larmor-Baden","Larmor-Plage","Laroche-Saint-Cydroine","Laroin","Laroque-d'Olmes","Laroque-de-Fa","Larrazet","Larressore","Larriviere-Saint-Savin","Laruns","Larzicourt","Lasalle","Lasbordes","Lassay-les-Chateaux","Lassay-sur-Croisne","Lasseran","Lasserre","Lasseube","Lassigny","Lasson","Lassy","Lastic","Lathuile","Latille","Latour","Latour-Bas-Elne","Latresne","Latronquiere","Lattainville","Lattes","Lattre-Saint-Quentin","Laudun-lArdoise","Laugnac","Launaguet","Launay","Laurabuc","Laure","Laurede","Laurenan","Laurens","Laurent","Lauret","Lauris","Laussonne","Lautenbach","Lauterbourg","Lautrec","Lauzerte","Lauzerville","Lauzun","Laval","Laval-d'Aix","Laval-sur-Doulon","Laval-sur-Vologne","Lavannes","Lavans-Vuillafans","Lavans-les-Saint-Claude","Lavardac","Lavardens","Lavardin","Lavardin","Lavau","Lavaur","Lavaur","Lavaurette","Lavelanet","Laventie","Lavergne","Lavernose-Lacasse","Laversine","Laversines","Laverune","Lavit","Lavours","Lavoute-Chilhac","Laxou","Laye","Layrac","Layrisse","Le Baizil","Le Ban-Saint-Martin","Le Bar-sur-Loup","Le Barboux","Le Barcares","Le Bardon","Le Barp","Le Beausset","Le Bernard","Le Bessat","Le Bez","Le Bignon","Le Blanc","Le Blanc-Mesnil","Le Bleymard","Le Bocasse","Le Bois","Le Bois-Plage-en-Re","Le Bonhomme","Le Bono","Le Bosc","Le Bosc-Roger-en-Roumois","Le Bouchage","Le Boulay-Morin","Le Boupere","Le Bourg","Le Bourget","Le Bourget","Le Bourgneuf-la-Foret","Le Bouscat","Le Bousquet","Le Breil","Le Breuil","Le Breuil","Le Breuil","Le Breuil","Le Breuil-sur-Couze","Le Broc","Le Broc","Le Brugeron","Le Buisson-de-Cadouin","Le Cailar","Le Cannet","Le Cap D'Agde","Le Castellet","Le Castera","Le Cateau-Cambresis","Le Caylar","Le Cellier","Le Cendre","Le Cergne","Le Chambon","Le Chambon","Le Chambon","Le Champ-Saint-Pere","Le Champ-pres-Froges","Le Chateau","Le Chateau Gaillard","Le Chatel","Le Chatelard","Le Chatelet-en-Brie","Le Chatelet-sur-Retourne","Le Chaylard","Le Chesnay","Le Chesne","Le Cheylas","Le Château-dOléron","Le Collet-de-Deze","Le Comte","Le Conquet","Le Coteau","Le Coudray","Le Coudray-Baillet","Le Coudray-Montceaux","Le Cres","Le Crest","Le Creusot","Le Croisic","Le Crotoy","Le Deluge","Le Deschaux","Le Dezert","Le Donjon","Le Dorat","Le Doulieu","Le Falgoux","Le Faou","Le Faouet","Le Fayet","Le Fenouiller","Le Ferre","Le Fidelaire","Le Fief-Sauvin","Le Foeil","Le Folgoet","Le Fossat","Le Fousseret","Le Fraysse","Le Fresne-Camilly","Le Fuilet","Le Garric","Le Gavre","Le Gond","Le Grand Village","Le Grand-Bornand","Le Grand-Pressigny","Le Grand-Quevilly","Le Gratteris","Le Grau-du-Roi","Le Gua","Le Guerno","Le Guildo","Le Haillan","Le Havre","Le Herie-la-Vieville","Le Hohwald","Le Houlme","Le Kremlin-Bicetre","Le Landin","Le Landreau","Le Lardin-Saint-Lazare","Le Lavandou","Le Lez","Le Longeron","Le Loroux","Le Loroux-Bottereau","Le Louroux-Beconnais","Le Luart","Le Luc","Le Lude","Le Manoir","Le Mans","Le Marillais","Le Martinet","Le Mas","Le Mas-d'Agenais","Le Mas-d'Azil","Le May-sur-Evre","Le Mayet","Le Mazeau","Le Mee-sur-Seine","Le Meix-Saint-Epoing","Le Mele-sur-Sarthe","Le Menil","Le Meriot","Le Merlerault","Le Mesnil-Amelot","Le Mesnil-Esnard","Le Mesnil-Fuguet","Le Mesnil-Ozenne","Le Mesnil-Vigot","Le Mesnil-Villeman","Le Mesnil-en-Thelle","Le Mesnil-en-Vallee","Le Mesnil-le-Roi","Le Meux","Le Molard","Le Molay","Le Monastier-Pin-Mories","Le Monastier-sur-Gazeille","Le Mont-Dore","Le Monteil","Le Montel","Le Muy","Le Neubourg","Le Noyer","Le Palais","Le Pallet","Le Parc","Le Parcq","Le Passage","Le Passage","Le Pecq","Le Pellerin","Le Perray-en-Yvelines","Le Perreux-sur-Marne","Le Perrier","Le Petit-Quevilly","Le Pian-sur-Garonne","Le Pin","Le Pin","Le Pin","Le Pin","Le Pin-la-Garenne","Le Pizou","Le Plan-de-la-Tour","Le Planois","Le Plessier-sur-Bulles","Le Plessis","Le Plessis-Belleville","Le Plessis-Bouchard","Le Plessis-Grammoire","Le Plessis-Hebert","Le Plessis-Pate","Le Plessis-Robinson","Le Plessis-Trevise","Le Poet","Le Poet-Laval","Le Poinconnet","Le Poire-sur-Velluire","Le Pont","Le Pont","Le Pont-de-Claix","Le Pontet","Le Porge","Le Port","Le Port","Le Port-Marly","Le Portel","Le Pouget","Le Pouliguen","Le Pout","Le Pouzin","Le Pradet","Le Pre-Saint-Gervais","Le Pre-d'Auge","Le Puy","Le Puy-Sainte-Reparade","Le Puy-en-Velay","Le Quesnel","Le Quesnoy","Le Raincy","Le Relecq-Kerhuon","Le Renouard","Le Revest-les-Eaux","Le Rheu","Le Roncenay-Authenay","Le Rouget","Le Rouret","Le Rove","Le Sacq","Le Sap","Le Segur","Le Soler","Le Sourn","Le Syndicat","Le Taillan-Medoc","Le Tallud","Le Teich","Le Teil","Le Teilleul","Le Temple-de-Bretagne","Le Theil","Le Theil-de-Bretagne","Le Thieulin","Le Thillay","Le Thillot","Le Tholonet","Le Tholy","Le Thor","Le Thou","Le Thoureil","Le Thuit-Signol","Le Thuit-Simer","Le Tignet","Le Torquesne","Le Touquet-Paris-Plage","Le Tourne","Le Tourneur","Le Touvet","Le Trait","Le Treport","Le Trevoux","Le Tronchet","Le Tronquay","Le Val","Le Val-dAjol","Le Vaudioux","Le Vaudreuil","Le Vaumain","Le Verger","Le Vernet","Le Vernet","Le Versoud","Le Vesinet","Le Vieux","Le Vieux Bourg","Le Vieux Bourg","Le Vigan","Le Vigean","Le Vigeant","Le Vigen","Le Vivier-sur-Mer","Le Voide","Lealvillers","Leaz","Lecelles","Lechatelet","Lechelle","Lecousse","Lectoure","Ledenon","Lederzeele","Leers","Leffincourt","Leffrinckoucke","Leforest","Lege","Lege-Cap-Ferret","Leguevin","Lehon","Leigneux","Leintrey","Lelling","Lemainville","Lembach","Lemberg","Leme","Lemmes","Lempdes","Lempdes-sur-Allagnon","Lemps","Lencloitre","Lennon","Lenoncourt","Lens","Lens-Lestang","Lent","Lentigny","Lentilly","Lentiol","Leojac","Leon","Leouville","Lepin-le-Lac","Lepuix","Lepuy","Lere","Lery","Les Abrets","Les Adrets-de-l'Esterel","Les Ageux","Les Aix-d'Angillon","Les Alleuds","Les Allies","Les Allues","Les Ancizes-Comps","Les Andelys","Les Angles","Les Arcs","Les Ardillats","Les Artigues-de-Lussac","Les Assions","Les Aubiers","Les Avanchers-Valmorel","Les Avenieres","Les Bains","Les Baux de Provence","Les Baux-de-Breteuil","Les Billanges","Les Bordes","Les Bordes","Les Bordes-sur-Lez","Les Breviaires","Les Brouzils","Les Cabanes","Les Cabannes","Les Cars","Les Champs","Les Chapelles","Les Charmontois","Les Cheres","Les Clayes-sous-Bois","Les Clouzeaux","Les Combes","Les Deux-Fays","Les Echelles","Les Ecrennes","Les Eglises-d'Argenteuil","Les Eglisottes-et-Chalaures","Les Eparres","Les Epesses","Les Essards","Les Essards-Taignevaux","Les Essarts","Les Essarts","Les Essarts","Les Etangs","Les Eyzies-de-Tayac-Sireuil","Les Fins","Les Fontaines","Les Fonts","Les Forges","Les Forges","Les Fourgs","Les Gets","Les Gours","Les Grands-Chezeaux","Les Granges","Les Granges","Les Gras","Les Halles","Les Hays","Les Herbiers","Les Hogues","Les Hopitaux-Vieux","Les Hotelleries","Les Houches","Les Jumeaux","Les Landes","Les Landes-Genusson","Les Laumes","Les Lilas","Les Loges","Les Loges","Les Loges-en-Josas","Les Lucs-sur-Boulogne","Les Mages","Les Marches","Les Martres","Les Mathes","Les Maures","Les Mees","Les Mesneux","Les Mesnuls","Les Milles","Les Moitiers-en-Bauptois","Les Molieres","Les Montils","Les Mureaux","Les Nouillers","Les Ollieres-sur-Eyrieux","Les Olmes","Les Ormes","Les Ormes","Les Ormes-sur-Voulzie","Les Palais","Les Pavillons-sous-Bois","Les Peintures","Les Pennes-Mirabeau","Les Petites Loges","Les Pieux","Les Pineaux","Les Pins","Les Pins","Les Pins","Les Places","Les Rives","Les Rivieres-Henruel","Les Roches","Les Rosiers","Les Rosiers-sur-Loire","Les Rousses","Les Sables","Les Sauvages","Les Sorinieres","Les Taillades","Les Thilliers-en-Vexin","Les Touches","Les Vallees","Les Vans","Les Varennes","Les Vigneaux","Les Villedieu","Lescar","Lescheraines","Lescherolles","Lesches","Lesconil","Lescout","Lescure","Lescure-d'Albigeois","Lesdain","Lesigny","Lesneven","Lesparre-Médoc","Lespesses","Lespielle","Lespignan","Lespinasse","Lesquin","Lessay","Lesse","Lessy","Lestelle-Betharram","Lestiou","Lestrem","Letanne","Letricourt","Leuc","Leucate","Leudeville","Leugny","Leuilly-sous-Coucy","Leuville-sur-Orge","Leuvrigny","Levainville","Leval","Leval","Levallois-Perret","Levens","Levernois","Leves","Levet","Levie","Levier","Levignacq","Levis","Levroux","Lewarde","Lexy","Leyme","Leyr","Leyrieu","Leysse","Lezan","Lezardrieux","Lezat-sur-Leze","Lezay","Lezennes","Lezignan-Corbieres","Lezigne","Lezigneux","Lezoux","Lheraule","Lherm","Lhommaize","Lhuis","Liancourt","Liancourt-Saint-Pierre","Liart","Libercourt","Libourne","Licques","Liepvre","Lieramont","Liergues","Liernais","Lieu-Saint-Amand","Lieuran-les-Beziers","Lieurey","Lieuron","Lieusaint","Lieuvillers","Liffol-le-Grand","Liffre","Ligescourt","Lignan-sur-Orb","Ligne","Ligne","Lignerolles","Lignerolles","Lignieres-Chatelain","Lignieres-la-Carelle","Lignol","Ligny-en-Barrois","Ligny-en-Cambresis","Ligny-le-Chatel","Ligny-le-Ribault","Ligsdorf","Ligueil","Liguge","Lihons","Lihus","Lille","Lillebonne","Lillers","Limas","Limay","Limeil-Brevannes","Limeray","Limersheim","Limerzel","Limesy","Limetz-Villez","Limoges","Limoges-Fourches","Limogne-en-Quercy","Limonest","Limony","Limours","Limoux","Linars","Linas","Lincel","Lingolsheim","Lingreville","Linselles","Linxe","Liocourt","Lion-en-Sullias","Lion-sur-Mer","Liouc","Lipsheim","Lire","Lisieux","Lisle","Lisle-sur-Tarn","Lisors","Lisses","Lissieu","Lissy","Listrac-Médoc","Lit-et-Mixe","Livarot","Liverdun","Liverdy-en-Brie","Livernon","Livet-et-Gavet","Livet-sur-Authou","Livinhac-le-Haut","Livre-sur-Changeon","Livron","Livron-sur-Drome","Livry-Gargan","Livry-sur-Seine","Lixhausen","Lixheim","Lizac","Lizy-sur-Ourcq","Liévin","Llupia","Loche","Loche-sur-Indrois","Locmaria-Grand-Champ","Locmaria-Plouzane","Locmariaquer","Locmine","Locmiquelic","Locoal-Mendon","Locon","Locquemeau","Locquirec","Loctudy","Lodève","Loge-Fougereuse","Logelbach","Logelheim","Lognes","Logonna-Daoulas","Logonna-Quimerch","Logrian-Florian","Lohr","Loire","Loire-les-Marais","Loire-sur-Rhone","Loiron","Loisin","Loison-sous-Lens","Loisy","Loisy-sur-Marne","Loix","Lokmaria","Lombers","Lombez","Lombron","Lomme","Lommerange","Lompret","Londigny","Londinieres","Longages","Longchamp","Longchamp-sous-Chatenois","Longeault","Longecourt-en-Plaine","Longes","Longessaigne","Longevelle-sur-Doubs","Longeves","Longeville-en-Barrois","Longeville-les-Metz","Longeville-les-Saint-Avold","Longeville-sur-Mer","Longevilles-Mont-d'Or","Longfosse","Longjumeau","Longlaville","Longnes","Longpont-sur-Orge","Longpre-les-Corps-Saints","Longue-Jumelles","Longueau","Longueil-Annel","Longueil-Sainte-Marie","Longuenesse","Longueville","Longueville-sur-Scie","Longuyon","Longvic","Longwy","Lons","Lons-le-Saunier","Loon-Plage","Loos","Loos-en-Gohelle","Loperhet","Lorcieres","Lorette","Lorey","Lorgies","Lorgues","Lorient","Lorignac","Loriol-du-Comtat","Loriol-sur-Drome","Lorlanges","Lormaison","Lormaye","Lormont","Lorquin","Lorrez-le-Bocage-Preaux","Lorris","Lorry-Mardigny","Los Masos","Losne","Louailles","Louannec","Louargat","Louatre","Loubaresse","Loubes-Bernac","Loubeyrat","Loubieng","Loubigne","Loubille","Loudeac","Loudes","Loudrefing","Loudun","Loue","Louer","Lougres","Louhans","Loupershouse","Loupes","Loupiac-de-la-Reole","Loupian","Louplande","Lourches","Lourdes","Lourenties","Loures-Barousse","Louresse-Rochemenier","Lourmarin","Lourties-Monbrun","Loury","Louveciennes","Louvemont","Louverne","Louvie-Juzon","Louviers","Louvigne-de-Bais","Louvignies-Quesnoy","Louvigny","Louvigny","Louvigny","Louvil","Louvrechy","Louvres","Louvroil","Louzouer","Louzy","Lovagny","Loyat","Loyes","Loyettes","Lozanne","Lozinghem","Lozon","Luant","Lubersac","Luc","Luc-sur-Mer","Luc-sur-Orbieu","Lucciana","Luce","Luce","Luceau","Lucenay","Lucenay-l'Eveque","Lucey","Luchy","Lucon","Lucq-de-Bearn","Lucy-sur-Cure","Ludon-Medoc","Ludres","Luemschwiller","Lugny-Champagne","Lugny-les-Charolles","Lugrin","Luisant","Luitre","Lullin","Lully","Lumbin","Lumbres","Lumeau","Lumio","Lunel","Lunel-Viel","Luneray","Lunéville","Lupe","Luppy","Lupstein","Luquet","Lurais","Luray","Lurcy","Lurcy-Levis","Lure","Lury-sur-Arnon","Lus-la-Croix-Haute","Lusanger","Lusignan","Lusignan-Grand","Lusigny","Lusigny-sur-Barse","Lussac","Lussac-les-Chateaux","Lussac-les-Eglises","Lussant","Lussas","Lussat","Luttange","Lutter","Lutterbach","Lutz-en-Dunois","Lux","Lux","Luxe","Luxeuil-les-Bains","Luxey","Luynes","Luynes","Luz-Saint-Sauveur","Luzarches","Luze","Luzille","Luzinay","Luzy","Lyaud","Lynde","Lyon","Lyons-la-Forêt","Léognan","Mably","Macau","Mache","Machecoul","Machemont","Macheren","Machezal","Maclas","Macot-la-Plagne","Madirac","Madre","Madriat","Mael-Carhaix","Maennolsheim","Maffliers","Magagnosc","Magalas","Magenta","Magescq","Magland","Magnan","Magnanville","Magne","Magneux-Haute-Rive","Magnieres","Magny","Magny-Cours","Magny-en-Vexin","Magny-le-Desert","Magny-le-Hongre","Magny-les-Hameaux","Magny-les-Villers","Magny-sur-Tille","Magrie","Magstatt-le-Haut","Maiche","Maidieres","Maigne","Maignelay-Montigny","Maillane","Maille","Maillebois","Mailly-Champagne","Mailly-Maillet","Mailly-Raineval","Mailly-la-Ville","Mailly-le-Camp","Maincy","Maing","Maintenon","Mainvilliers","Mainxe","Mairieux","Mairy-sur-Marne","Maisdon-sur-Sevre","Maisnil","Maisnil-les-Ruitz","Maison-Ponthieu","Maisons-Alfort","Maisons-Laffitte","Maisonsgoutte","Maisontiers","Maisse","Maizeroy","Maizieres-les-Metz","Malabry","Malafretaz","Malain","Malakoff","Malancourt-la-Montagne","Malange","Malansac","Malataverne","Malaucene","Malaumont","Malaunay","Malause","Malaussanne","Malay-le-Grand","Malegoude","Malemort-du-Comtat","Malemort-sur-Correze","Malesherbes","Malestroit","Maleville","Malguenac","Malicorne","Malicorne-sur-Sarthe","Malijai","Malincourt","Malintrat","Malissard","Malleloy","Mallemoisson","Mallemort","Malling","Malmerspach","Malmont","Malpas","Malras","Malrevers","Malves-en-Minervois","Malville","Malzeville","Mamers","Mametz","Mamey","Mamirolle","Manchecourt","Mancieulles","Mandagout","Mandelieu-la-Napoule","Mandeure","Mandres-la-Cote","Mandres-les-Roses","Manduel","Mane","Maneglise","Mangiennes","Mangonville","Manicamp","Maninghen-Henne","Manneville-es-Plains","Mannevillette","Manom","Manoncourt-sur-Seille","Manonviller","Manosque","Manot","Mansigne","Mansle","Manspach","Mantes-la-Jolie","Mantes-la-Ville","Manthelan","Mantoche","Mantry","Manzat","Manziat","Marange-Silvange","Marange-Zondrange","Marans","Maraussan","Marbache","Marc","Marcamps","Marcay","Marce-sur-Esves","Marcelcave","Marcellaz-Albanais","Marchainville","Marchaux","Marche-Allouarde","Marcheprime","Marchesieux","Marcheville","Marchiennes","Marciac","Marcigny","Marcilhac-sur-Cele","Marcillac","Marcillac-la-Croisille","Marcillat-en-Combraille","Marcilloles","Marcilly-d'Azergues","Marcilly-en-Bassigny","Marcilly-en-Beauce","Marcilly-en-Villette","Marcilly-sur-Eure","Marcilly-sur-Seine","Marcilly-sur-Tille","Marcilly-sur-Vienne","Marck","Marckolsheim","Marcoing","Marcollin","Marconnelle","Marcoussis","Marcouville","Marcoux","Marcq","Marcq-en-Baroeul","Marcq-en-Ostrevent","Marcy-l'Etoile","Mardeuil","Mardie","Mardyck","Mareau-aux-Bois","Mareau-aux-Pres","Mareil-Marly","Mareil-en-France","Mareil-sur-Loir","Mareil-sur-Mauldre","Marenla","Marennes","Marennes","Marest","Marestaing","Mareuil","Mareuil","Mareuil-Caubert","Mareuil-en-Brie","Mareuil-le-Port","Mareuil-les-Meaux","Mareuil-sur-Cher","Mareuil-sur-Lay-Dissais","Mareuil-sur-Ourcq","Margaux","Margencel","Margency","Margerie-Chantagret","Margny","Margny-les-Compiegne","Margon","Marguerittes","Margut","Marie","Marienthal","Marignac","Marignac-Lasclares","Marignane","Marigne","Marignier","Marigny","Marigny","Marigny-Brizay","Marigny-Chemereau","Marigny-Marmande","Marigny-en-Orxois","Marigny-le-Chatel","Marigny-les-Usages","Marin","Marines","Maringes","Maringues","Marle","Marlenheim","Marles-en-Brie","Marles-les-Mines","Marliens","Marlioz","Marlotte","Marly","Marly","Marly-la-Ville","Marly-le-Roi","Marmagne","Marmande","Marmanhac","Marmoutier","Marnand","Marnaz","Marnes","Marnes-la-Coquette","Maroeuil","Marolles","Marolles-en-Brie","Marolles-en-Hurepoix","Marols","Maromme","Maron","Maron","Marpent","Marquay","Marquefave","Marqueglise","Marques","Marquillies","Marquion","Marquise","Marquixanes","Mars","Mars","Mars-sur-Allier","Marsac","Marsac-en-Livradois","Marsac-sur-lIsle","Marsainvilliers","Marsais","Marsais-Sainte-Radegonde","Marsaneix","Marsangy","Marsannay-la-Côte","Marsannay-le-Bois","Marsanne","Marsat","Marsaz","Marseillan","Marseille","Marseille-en-Beauvaisis","Marseilles-les-Aubigny","Marsillargues","Marsilly","Marsilly","Marssac-sur-Tarn","Martainville-Epreville","Martel","Marthod","Martiel","Martignas-sur-Jalle","Martigne-Briand","Martigne-Ferchaud","Martigny","Martigues","Martillac","Martin-Eglise","Martinet","Martinvast","Martot","Martres-Tolosane","Marval","Marvejols","Marville-les-Bois","Marzan","Marzy","Mas-Grenier","Mas-Saintes-Puelles","Masevaux","Maslacq","Maslives","Masnieres","Masny","Masparraute","Massat","Masserac","Masseret","Massiac","Massieu","Massieux","Massingy-les-Semur","Massugas","Massy","Mastaing","Matha","Mathay","Mathenay","Mathieu","Mathieu","Matignon","Matigny","Matour","Mattaincourt","Mattexey","Matzenheim","Maubeuge","Maubourguet","Mauchamps","Maucor","Mauguio","Maule","Mauleon-Licharre","Maulevrier","Mauperthuis","Mauprevoir","Mauran","Maure","Maure-de-Bretagne","Maurecourt","Maureilhan","Maureillas-las-Illas","Mauremont","Maurens","Maurepas","Mauressargues","Maureville","Mauriac","Maurois","Mauron","Maurrin","Maurs","Maussane-les-Alpilles","Mauves","Mauves-sur-Huisne","Mauves-sur-Loire","Mauvezin-de-Prat","Maux","Mauzac","Mauze-sur-le-Mignon","Mauzens-et-Miremont","Maxent","Maxeville","Maxilly-sur-Saone","May-en-Multien","May-sur-Orne","Mayenne","Mayet","Maysel","Mazamet","Mazan","Mazange","Maze","Mazeray","Mazeres-de-Neste","Mazeres-sur-Salat","Mazerolles","Mazerolles-le-Salin","Mazet-Saint-Voy","Mazeuil","Mazeyrat-d'Allier","Mazieres-en-Gatine","Mazieres-en-Mauges","Mazingarbe","Mazion","Meaudre","Meaulte","Meaux","Meauzac","Medan","Medis","Medreac","Mees","Megrit","Megève","Meharicourt","Mehun-sur-Yevre","Meigneux","Meilhac","Meilhan","Meilhan","Meilhan-sur-Garonne","Meillant","Meillerie","Meillon","Meillonnas","Meisenthal","Mejannes-le-Clap","Mejannes-les-Ales","Melay","Melay","Melesse","Melgven","Mellac","Melle","Mellecey","Melleran","Melleray","Mellionnec","Mello","Melrand","Melsheim","Melun","Membrey","Menat","Mende","Mendionde","Meneac","Menerbes","Menesplet","Menestreau-en-Villette","Menetou-Salon","Menetreol-sur-Sauldre","Menetrol","Menil-Erreux","Menil-Hermei","Menil-la-Horgne","Menil-sur-Belvitte","Menilles","Mennecy","Mennevret","Mens","Mensignac","Menthon-Saint-Bernard","Menton","Menucourt","Menville","Meounes-les-Montrieux","Mer","Mercenac","Merckeghem","Mercues","Mercurol","Mercy-le-Bas","Merdrignac","Mere","Mereau","Merenvielle","Mereville","Merey-sous-Montrond","Mergey","Mericourt","Meriel","Merignac","Merignas","Merignat","Merignies","Merigny","Merindol","Merlas","Merlebach","Merlevenez","Merlimont","Merlines","Mernel","Meroux","Merry-la-Vallee","Merry-sur-Yonne","Mers-les-Bains","Mertzen","Mertzwiller","Meru","Mervans","Merville","Merville","Merville-Franceville-Plage","Merxheim","Mery","Mery-es-Bois","Mery-sur-Oise","Mery-sur-Seine","Mesanger","Mesangueville","Meschers-sur-Gironde","Mescoules","Mesland","Meslay","Meslay-du-Maine","Meslay-le-Vidame","Meslin","Mesnil-Raoul","Mesnil-Saint-Georges","Mesnil-Saint-Nicaise","Mesnil-Sellieres","Mesnil-sous-Vienne","Mesnil-sur-l'Estree","Mesplede","Messac","Messanges","Messei","Messein","Messia-sur-Sorne","Messigny-et-Vantoux","Messimy","Messon","Messy","Metabief","Meteren","Mettray","Metz","Metz-Tessy","Metzeral","Metzeresche","Metzervisse","Meucon","Meudon","Meulan-en-Yvelines","Meung-sur-Loire","Meurchin","Meursault","Meuse","Meusnes","Meuzac","Mevoisins","Meximieux","Mexy","Meyenheim","Meylan","Meymac","Meynes","Meyrargues","Meyras","Meyreuil","Meyssac","Meythet","Meyzieu","Meze","Mezel","Mezel","Mezeres","Mezeriat","Mezidon-Canon","Mezieres-en-Drouais","Mezieres-lez-Clery","Mezieres-sous-Lavardin","Mezieres-sur-Couesnon","Mezieres-sur-Seine","Mezzavia","Michelbach-le-Bas","Mielan","Miellin","Mietesheim","Mieussy","Migennes","Miglos","Mignaloux-Beauvoir","Migne-Auxances","Mignieres","Migron","Milhaud","Milizac","Millac","Millas","Millau","Millencourt","Millery","Millery","Milly","Milly-Lamartine","Milly-la-Foret","Milly-sur-Therain","Milon-la-Chapelle","Mimbaste","Mimet","Mimizan","Mine de Bert","Mingot","Miniac-Morvan","Miniac-sous-Becherel","Minihy-Treguier","Minversheim","Minzier","Mionnay","Mions","Mios","Mirabel-aux-Baronnies","Miradoux","Miramas","Mirambeau","Miramont-Sensacq","Miramont-de-Guyenne","Mirande","Mirebeau","Mirebeau-sur-Beze","Mirecourt","Miremont","Mirepeix","Mirepoix","Mirepoix-sur-Tarn","Mireval-Lauragais","Miribel","Miserey","Miserey-Salines","Mison","Misse","Missillac","Missiriac","Misson","Missy-sur-Aisne","Mitry-Mory","Mittelbronn","Mittelhausbergen","Mittelwihr","Mitterand","Mittersheim","Modane","Moelan-sur-Mer","Moens","Moernach","Moeslains","Mogneville","Mogues","Mohon","Moineville","Moinville-la-Jeulin","Moirans","Moirans-en-Montagne","Moire","Moisdon-la-Riviere","Moislains","Moissac","Moissat","Moisselles","Moissieu-sur-Dolon","Moissy-Cramayel","Moisville","Molac","Molandier","Molesme","Moliens","Molieres-sur-Ceze","Moliets-et-Maa","Molinet","Molineuf","Molleges","Molliens-au-Bois","Mollkirch","Moloy","Molsheim","Moltifao","Momas","Mombrier","Momeres","Mommenheim","Momy","Monbahus","Monbalen","Monbrun","Moncale","Monce-en-Belin","Monceau-Saint-Waast","Monceau-le-Neuf-et-Faucouzy","Monceau-le-Waast","Monceaux","Moncel-sur-Seille","Moncetz-Longevas","Moncheaux-les-Frevent","Monchecourt","Monchy-Breton","Monchy-Humieres","Monchy-Saint-Eloi","Monclar-de-Quercy","Moncontour","Moncoutant","Mondelange","Mondescourt","Mondetour","Mondeville","Mondeville","Mondon","Mondonville","Mondragon","Mondrainville","Mondrepuis","Monein","Monestier-de-Clermont","Monesties","Monetay-sur-Loire","Moneteau","Monferran-Plaves","Monferran-Saves","Monflanquin","Monistrol-d'Allier","Monistrol-sur-Loire","Monnaie","Monnetier-Mornex","Monneville","Monnieres","Monpazier","Mons","Mons","Mons","Mons","Mons-en-Baroeul","Mons-en-Montois","Mons-en-Pevele","Monsac","Monsegur","Monsempron-Libos","Monsireigne","Monsteroux-Milieu","Mont","Mont","Mont","Mont-Bonvillers","Mont-Cauvaire","Mont-Notre-Dame","Mont-Saint-Aignan","Mont-Saint-Martin","Mont-Saint-Martin","Mont-Saint-Pere","Mont-Saxonnex","Mont-de-Marsan","Mont-pres-Chambord","Mont-sur-Meurthe","Mont-sur-Monnet","Montabard","Montady","Montagnac","Montagnat","Montagne","Montagney","Montagnieu","Montagnole","Montagny-Sainte-Felicite","Montagny-en-Vexin","Montagny-les-Lanches","Montagny-les-Seurre","Montagny-sur-Grosne","Montagrier","Montagut","Montaigu","Montaigu","Montaigu","Montaigu-de-Quercy","Montaigut-sur-Save","Montainville","Montalet-le-Bois","Montalieu-Vercieu","Montamise","Montanay","Montardon","Montargis","Montarlot-les-Rioz","Montarnaud","Montastruc-de-Salies","Montastruc-la-Conseillere","Montataire","Montauban","Montauban-de-Bretagne","Montaud","Montaudin","Montaulieu","Montaure","Montauroux","Montaut","Montaut","Montayral","Montbard","Montbartier","Montbazin","Montbazon","Montbel","Montbellet","Montberon","Montbert","Montbeton","Montbeugny","Montbizot","Montblanc","Montboillon","Montbonnot-Saint-Martin","Montboucher-sur-Jabron","Montbouton","Montbrison","Montbron","Montbronn","Montbrun-Bocage","Montbéliard","Montcaret","Montcarra","Montceau","Montceau-les-Mines","Montceaux","Montceaux-les-Meaux","Montcel","Montcenis","Montcey","Montchamp","Montchanin","Montchaude","Montclar","Montcornet","Montcourt-Fromonville","Montcoy","Montcuq","Montcy-Notre-Dame","Montdidier","Montdoumerc","Montdragon","Monteaux","Montebourg","Montech","Montecheroux","Monteglin","Monteils","Montel-de-Gelat","Montelier","Montemboeuf","Montendre","Montenescourt","Montenois","Montenoison","Monterblanc","Montereau-Fault-Yonne","Monterfil","Montescot","Montesquieu","Montesquieu-Volvestre","Montesquieu-des-Alberes","Montessaux","Montesson","Montestruc-sur-Gers","Montestrucq","Monteux","Montevrain","Monteynard","Montfarville","Montfaucon","Montfaucon","Montfaucon","Montfaucon-Montigne","Montfaucon-en-Velay","Montfavet","Montfermeil","Montfermy","Montferrand-du-Perigord","Montferrand-le-Chateau","Montferrat","Montferrier-sur-Lez","Montfleur","Montfort","Montfort-en-Chalosse","Montfort-l'Amaury","Montfort-sur-Meu","Montfrin","Montfroc","Montfuron","Montgaillard","Montgaroult","Montgermont","Montgeron","Montgesty","Montgirod","Montgiscard","Montgivray","Montherme","Monthieux","Monthodon","Monthou-sur-Bievre","Monthou-sur-Cher","Monthureux-sur-Saone","Monthyon","Monticello","Montier-en-Der","Montierchaume","Montiers","Montignac-de-Lauzun","Montignac-le-Coq","Montigne-le-Brillant","Montigne-les-Rairies","Montigny","Montigny","Montigny-Lengrain","Montigny-en-Cambresis","Montigny-en-Gohelle","Montigny-le-Bretonneux","Montigny-le-Chartif","Montigny-les-Cormeilles","Montigny-lès-Metz","Montigny-sur-Loing","Montilly","Montilly-sur-Noireau","Montiron","Montivilliers","Montjavoult","Montjean-sur-Loire","Montlhery","Montliard","Montlieu-la-Garde","Montlignon","Montlivault","Montlouis","Montlouis-sur-Loire","Montluel","Montluçon","Montmacq","Montmagny","Montmalin","Montmarault","Montmartin","Montmartin-en-Graignes","Montmartin-sur-Mer","Montmelian","Montmerle-sur-Saone","Montmeyran","Montmirail","Montmiral","Montmirat","Montmoreau-Saint-Cybard","Montmorency","Montmorency-Beaufort","Montmorillon","Montmorot","Montmédy","Montoir-de-Bretagne","Montoire-sur-le-Loir","Montois-la-Montagne","Montoison","Montolivet","Montournais","Montpellier","Montpeyroux","Montpeyroux","Montpezat","Montpezat-de-Quercy","Montpezat-sous-Bauzon","Montpincon","Montpinier","Montpitol","Montpon-Menesterol","Montpothier","Montrabe","Montreal","Montreal","Montreal-la-Cluse","Montredon-Labessonnie","Montredon-des-Corbieres","Montrejeau","Montrelais","Montrem","Montrequienne","Montresor","Montret","Montreuil","Montreuil","Montreuil-Bonnin","Montreuil-aux-Lions","Montreuil-en-Caux","Montreuil-l'Argille","Montreuil-sous-Perouse","Montreuil-sur-Blaise","Montreuil-sur-Breche","Montreuil-sur-Lozon","Montreuil-sur-Mer","Montreux-Jeune","Montrevel","Montrevel-en-Bresse","Montrichard","Montricoux","Montrodat","Montrond","Montrond","Montrond-les-Bains","Montrouge","Montrouveau","Montry","Monts","Monts-en-Bessin","Monts-sur-Guesnes","Montsalvy","Montsauche-les-Settons","Montsegur-sur-Lauzon","Montseveroux","Montsoreau","Montsoult","Montussan","Montvalen","Montvalent","Montvendre","Montverdun","Montville","Montélimar","Moon-sur-Elle","Moosch","Moragne","Morainvilliers","Morance","Morancez","Morangis","Morangis","Morbecque","Morbier","Morcenx","Mordelles","Moreac","Moree","Morelmaison","Morestel","Moret-sur-Loing","Moreuil","Morez","Morgny","Morgny-la-Pommeraye","Morhange","Morienval","Morieres-les-Avignon","Morieux","Morigny-Champigny","Morisel","Moriville","Morlaas","Morlaix","Mormant","Mornac","Mornac-sur-Seudre","Mornant","Mornay","Mornay-sur-Allier","Moroges","Morogues","Morre","Morsain","Morsang-sur-Orge","Morsbach","Morsbronn-les-Bains","Morschwiller-le-Bas","Mortagne","Mortagne-au-Perche","Mortagne-du-Nord","Mortagne-sur-Sevre","Mortain","Mortcerf","Morteau","Morteaux-Couliboeuf","Mortefontaine","Mortefontaine-en-Thelle","Mortree","Mortzwiller","Morvillers-Saint-Saturnin","Morvilliers","Morzine","Moslins","Mosnac","Mosson","Motteville","Mouans-Sartoux","Mouaze","Mouchin","Mouflers","Mougins","Mougon","Mouguerre","Mouilleron-en-Pareds","Mouilleron-le-Captif","Mouledous","Moules","Mouliets-et-Villemartin","Moulin","Moulin-Mage","Moulin-Neuf","Moulin-sous-Touvent","Moulineaux","Moulines","Moulinet","Moulinet","Moulins","Moulins-Engilbert","Moulins-les-Metz","Moulins-sur-Cephons","Moulins-sur-Yevre","Moulle","Moult","Moumour","Mourenx","Moureze","Mouries","Mourioux-Vieilleville","Mourmelon-le-Grand","Mourmelon-le-Petit","Mouroux","Mours","Mours-Saint-Eusebe","Moussan","Mousseaux-Neuville","Moussey","Mousson","Moussoulens","Moussy","Moussy-le-Neuf","Moussy-le-Vieux","Mousteru","Moustier-en-Fagne","Mouthe","Mouthier-en-Bresse","Mouthiers-sur-Boeme","Moutiers","Moutiers","Moutiers-les-Mauxfaits","Moutiers-sur-le-Lay","Mouvaux","Mouxy","Mouy","Mouzeil","Mouzieys-Teulet","Mouzillon","Mouzon","Moy-de-l'Aisne","Moyaux","Moyencourt","Moyenmoutier","Moyenneville","Moyenneville","Moyeuvre-Grande","Moyon","Moyrazes","Moyvillers","Mozac","Muespach-le-Haut","Muides-sur-Loire","Muidorge","Muirancourt","Muizon","Mulcent","Mulcey","Mulhouse","Mulsanne","Munchhouse","Mundolsheim","Munster","Munster","Mur-de-Bretagne","Mur-de-Sologne","Murat","Mures","Muret","Murianette","Muro","Murol","Muron","Murs-Erigne","Murviel-les-Beziers","Murviel-les-Montpellier","Mus","Mussidan","Mussig","Mutzig","Muzillac","Mâcon","Méribel","Mérignac","Nadillac","Nages-et-Solorgues","Nailloux","Naintre","Naizin","Najac","Nalliers","Nancy","Nandy","Nangis","Nans-les-Pins","Nanterre","Nantes","Nanteuil-en-Vallee","Nanteuil-le-Haudouin","Nanteuil-les-Meaux","Nantiat","Nantoin","Nanton","Nantua","Naours","Narbonne","Narbonne-Plage","Nargis","Narrosse","Nattages","Naucelle","Naujan-et-Postiac","Naux","Navailles-Angos","Navarrenx","Naves","Nay","Nayemont-les-Fosses","Nazelles-Negron","Neauphle-le-Chateau","Neauphlette","Nebian","Nebouzat","Nedonchel","Neewiller-pres-Lauterbourg","Neffes","Neffies","Nefiach","Negrepelisse","Negron","Nehou","Nemours","Neoules","Nercillac","Nere","Neris-les-Bains","Neron","Neronde-sur-Dore","Ners","Nersac","Nerville-la-Foret","Nery","Nesle","Nesles","Nesles-la-Montagne","Nesles-la-Vallee","Nesmy","Nessa","Neuf Eglise","Neuf-Brisach","Neufchateau","Neufchatel-en-Bray","Neufchef","Neufgrange","Neuflize","Neufmanil","Neufmesnil","Neufmoutiers-en-Brie","Neufvy-sur-Aronde","Neuil","Neuille","Neuilly","Neuilly-Plaisance","Neuilly-Saint-Front","Neuilly-en-Thelle","Neuilly-l'Hopital","Neuilly-le-Bisson","Neuilly-le-Real","Neuilly-les-Dijon","Neuilly-sous-Clermont","Neuilly-sur-Marne","Neuilly-sur-Seine","Neulliac","Neung-sur-Beuvron","Neure","Neussargues-Moissac","Neuve-Maison","Neuvecelle","Neuves-Maisons","Neuvic","Neuvic-Entier","Neuvicq-le-Chateau","Neuville","Neuville","Neuville-Bosc","Neuville-Ferrieres","Neuville-Saint-Remy","Neuville-Saint-Vaast","Neuville-aux-Bois","Neuville-de-Poitou","Neuville-en-Ferrain","Neuville-les-Dames","Neuville-les-Dieppe","Neuville-sur-Ain","Neuville-sur-Brenne","Neuville-sur-Escaut","Neuville-sur-Oise","Neuville-sur-Saone","Neuville-sur-Sarthe","Neuville-sur-Seine","Neuviller-sur-Moselle","Neuvireuil","Neuvy","Neuvy","Neuvy-Bouin","Neuvy-Saint-Sepulchre","Neuvy-en-Beauce","Neuvy-en-Sullias","Neuvy-le-Roi","Nevers","Nevez","Nevian","Neville","Nexon","Neydens","Nezignan-l'Eveque","Nibas","Nibelle","Nice","Nicole","Nicorps","Niderhoff","Niderviller","Niederbronn-les-Bains","Niederbruck","Niederentzen","Niederhaslach","Niederhausbergen","Niedermodern","Niederschaeffolsheim","Nieppe","Niergnies","Nieuil","Nieuil-l'Espoir","Nieul-le-Virouil","Nieul-les-Saintes","Nieul-sur-Mer","Nievroz","Niffer","Niherne","Nilvange","Niort","Nissan-lez-Enserune","Nitting","Nivillac","Nivolas-Vermelle","Nizas","Noailhac","Noaillac","Noaillan","Noailles","Noailles","Noe","Noeux-les-Auxi","Noeux-les-Mines","Nogent","Nogent-l'Artaud","Nogent-le-Phaye","Nogent-le-Roi","Nogent-le-Rotrou","Nogent-sur-Eure","Nogent-sur-Marne","Nogent-sur-Oise","Nogent-sur-Seine","Nogent-sur-Vernisson","Nohanent","Nohic","Noidans-le-Ferroux","Noidans-les-Vesoul","Noilhan","Nointel","Nointot","Noirmoutier-en-l'Ile","Noiron","Noiron-sous-Gevrey","Noirterre","Noiseau","Noisiel","Noisseville","Noisy-Rudignon","Noisy-le-Grand","Noisy-le-Roi","Noisy-le-Sec","Noisy-sur-Ecole","Noisy-sur-Oise","Nolay","Nomain","Nomeny","Nomexy","Nommay","Nonancourt","Nonette","Nonneville","Nontron","Nonville","Nonvilliers-Grandhoux","Noordpeene","Nordausques","Nordhouse","Norges-la-Ville","Normanville","Normier","Norrent-Fontes","Norrey-en-Auge","Norroy-le-Sec","Norroy-le-Veneur","Norroy-les-Pont-a-Mousson","Nort-sur-Erdre","Nostang","Nothalten","Notre-Dame-d'Aliermont","Notre-Dame-d'Oe","Notre-Dame-de-Boisset","Notre-Dame-de-Bondeville","Notre-Dame-de-Cenilly","Notre-Dame-de-Commiers","Notre-Dame-de-Gravenchon","Notre-Dame-de-Livaye","Notre-Dame-de-Livoye","Notre-Dame-de-Mesage","Notre-Dame-de-Riez","Notre-Dame-de-Sanilhac","Notre-Dame-de-la-Rouviere","Notre-Dame-des-Landes","Notre-Dame-du-Pre","Nouaille-Maupertuis","Nouainville","Nouan-le-Fuzelier","Noueilles","Nouilly","Nousseviller-Saint-Nabor","Nousseviller-les-Bitche","Nouvelle-Eglise","Nouvion-le-Comte","Nouvion-le-Vineux","Nouvion-sur-Meuse","Nouvoitou","Nouzonville","Novalaise","Noveant-sur-Moselle","Noves","Novillard","Novillars","Novion-Porcien","Noyal-Muzillac","Noyal-Pontivy","Noyal-sur-Vilaine","Noyant-d'Allier","Noyant-de-Touraine","Noyant-la-Gravoyere","Noyant-la-Plaine","Noyarey","Noyelles-Godault","Noyelles-sous-Lens","Noyelles-sur-Escaut","Noyen-sur-Sarthe","Noyers","Noyers","Noyers-Bocage","Noyers-sur-Cher","Noyon","Nozay","Nozay","Nuaille","Nuaille-sur-Boutonne","Nueil-sur-Layon","Nuelles","Nuits-Saint-Georges","Nyoiseau","Nyons","Nérac","Nîmes","OEting","Obenheim","Oberbronn","Oberentzen","Oberhaslach","Oberhausbergen","Oberhergheim","Oberhoffen-sur-Moder","Oberlauterbach","Obermodern-Zutzendorf","Obermorschwihr","Obermorschwiller","Obernai","Obersaasheim","Oberschaeffolsheim","Objat","Oblinghem","Obtree","Ochey","Octeville","Octeville-sur-Mer","Oderen","Odomez","Odos","Oelleville","Oeyreluy","Offekerque","Offemont","Offendorf","Offoy","Offranville","Ogenne-Camptort","Oger","Ogeu-les-Bains","Ogeviller","Ogy","Oignies","Oingt","Oinville-sur-Montcient","Oiron","Oiselay-et-Grachaux","Oisemont","Oisly","Oisseau","Oissel","Oisy","Oisy-le-Verger","Oizon","Olargues","Olby","Olemps","Oletta","Olivet","Ollainville","Olle","Ollezy","Ollieres","Olliergues","Ollioules","Olloix","Olmet","Olonne-sur-Mer","Olonzac","Oloron-Sainte-Marie","Olwisheim","Omessa","Omonville-la-Rogue","Ondes","Ondres","Ondreville-sur-Essonne","Onet-le-Chateau","Onnaing","Onnion","Ons-en-Bray","Onzain","Opio","Oppede","Optevoz","Oradour","Oradour-Fanais","Oradour-sur-Glane","Oraison","Orangis","Orbais-l'Abbaye","Orban","Orbec","Orbeil","Orbey","Orcet","Orchaise","Orchamps-Vennes","Orches","Orchies","Orcier","Orcines","Ordan-Larroque","Ordiarp","Oregue","Oresmaux","Orgelet","Orgeres","Orgerus","Orgeval","Orgon","Orgueil","Orignolles","Origny-Sainte-Benoite","Origny-en-Thierache","Origny-le-Sec","Oriol-en-Royans","Orion","Orleat","Orlienas","Orlu","Orly","Orléans","Ormersviller","Ormes","Ormes-et-Ville","Ormesson-sur-Marne","Ormoy","Ormoy","Ormoy-Villers","Ornacieux","Ornans","Ornex","Orny","Orphin","Orrouer","Orrouy","Orry-la-Ville","Orsan","Orsanco","Orsonville","Orthez","Ortoncourt","Orval","Orval","Orvault","Orvaux","Orveau-Bellesauve","Orvillers-Sorel","Osne-le-Val","Osny","Ossages","Osse","Osses","Ossun","Ostheim","Ostricourt","Ostwald","Ota","Othis","Ottange","Ottmarsheim","Ottonville","Ottrott","Ouanne","Ouarville","Ouchamps","Oucques","Oudon","Ouerre","Ouezy","Ouffieres","Ougney","Ouhans","Ouilly-le-Tesson","Ouilly-le-Vicomte","Ouistreham","Oulchy-le-Chateau","Oullins","Oupia","Ourches","Ouroux","Ouroux-sur-Saone","Oursbelille","Ousse","Ousson-sur-Loire","Outarville","Outille","Outines","Outreau","Ouveillan","Ouville","Ouville","Ouville-l'Abbaye","Ouzilly","Ouzouer-le-Marche","Ouzouer-sur-Loire","Ouzouer-sur-Trezee","Ovanches","Ovillers-la-Boisselle","Oye-Plage","Oyeu","Oyonnax","Oytier-Saint-Oblas","Ozan","Ozoir-la-Ferriere","Ozolles","Ozouer-le-Voulgis","Pabu","Pace","Pact","Pacy-sur-Eure","Pageas","Pagny-la-Ville","Pagny-sur-Meuse","Pagny-sur-Moselle","Paillart","Paillencourt","Paillet","Paimboeuf","Paimpol","Paimpont","Painblanc","Pair-et-Grandrupt","Paix","Paizay-le-Chapt","Paizay-le-Sec","Paizay-le-Tort","Palaiseau","Palaja","Palalda","Palaminy","Palau-del-Vidre","Palavas-les-Flots","Paleyrac","Palinges","Palleau","Palluau","Palluau-sur-Indre","Pallud","Pamfou","Pamiers","Pamproux","Panassac","Panazol","Panissieres","Pannece","Pannes","Panossas","Pantin","Panzoult","Paradou","Paray-Vieille-Poste","Paray-le-Monial","Paray-sous-Briailles","Paraza","Parc-d'Anxtot","Parcay-Meslay","Parce-sur-Sarthe","Parcieux","Pareds","Parempuyre","Parent","Parentis-en-Born","Pargny-Filain","Pargny-la-Dhuys","Pargny-les-Bois","Pargny-sur-Saulx","Parigne","Parigne-l'Eveque","Parigne-sur-Braye","Parigny","Paris","Paris 17 Batignolles-Monceau","Parisot","Parly","Parmain","Parnans","Parnay","Parne-sur-Roc","Paron","Parsac","Parthenay","Parthenay-de-Bretagne","Parzac","Pas-en-Artois","Paslieres","Pasly","Pasques","Passel","Passy","Patay","Pau","Pauilhac","Pauillac Haut","Paul","Paulhac","Paulhaguet","Paulhan","Paulx","Pavie","Pavilly","Payrac","Payrin-Augmontel","Payroux","Payzac","Payzac","Peaugres","Peaule","Pebrac","Pechabou","Pechbonnieu","Pecquencourt","Pecqueuse","Pegomas","Peillac","Peille","Peillon","Peillonnex","Peipin","Peisey-Nancroix","Pelissanne","Pellegrue","Pellevoisin","Pellouailles-les-Vignes","Pelousey","Peltre","Pelussin","Penchard","Pencran","Pende","Penestin","Penguily","Penmarch","Pennautier","Penne-dAgenais","Pennedepie","Penol","Penta-di-Casinca","Penvenan","Pepieux","Peray","Percy","Pere","Perenchies","Peret","Peri","Periers","Perignac","Perignat-les-Sarlieve","Perigne","Perigneux","Perigny","Perigny","Perillos","Pern","Pernay","Pernes","Pernes-les-Boulogne","Pernes-les-Fontaines","Perols","Perols","Peron","Peronnas","Peronne","Peronne","Peronne-en-Melantois","Perouse","Peroy-les-Gombries","Perpezac-le-Noir","Perpignan","Perrecy-les-Forges","Perreux","Perreux","Perrex","Perrier","Perriers-sur-Andelle","Perrignier","Perrigny","Perrigny-les-Dijon","Perrogney-les-Fontaines","Perros-Guirec","Perrou","Perruel","Pers","Pers-Jussy","Persan","Persquen","Perthes-les-Brienne","Pertheville-Ners","Pertuis","Pessac","Pessac-sur-Dordogne","Pessan","Pessans","Pessat-Villeneuve","Petit Chaumont","Petit-Couronne","Petit-Landau","Petit-Mars","Petit-Palais-et-Cornemps","Petite-Foret","Petite-Rosselle","Petiville","Petreto-Bicchisano","Peumerit","Pexonne","Pey","Peymeinade","Peynier","Peypin","Peypin-d'Aigues","Peyrat-le-Chateau","Peyrehorade","Peyriac-Minervois","Peyriac-de-Mer","Peyrignac","Peyrilhac","Peyrilles","Peyrins","Peyrissas","Peyrolles-en-Provence","Peyruis","Peyrus","Peyrusse-Massas","Pezenas","Pezens","Pezilla-la-Riviere","Pezou","Pfaffenheim","Pfaffenhoffen","Pfastatt","Pfettisheim","Pfulgriesheim","Phaffans","Phalempin","Phalsbourg","Pia","Piazza","Piblange","Pibrac","Picauville","Picquigny","Piegros-la-Clastre","Piegut-Pluviers","Piennes","Pierre","Pierre-Benite","Pierre-Levee","Pierre-de-Bresse","Pierre-la-Treiche","Pierrefeu-du-Var","Pierrefitte-Nestalas","Pierrefitte-sur-Seine","Pierrefonds","Pierrefort","Pierregot","Pierrelatte","Pierrelaye","Pierremande","Pierrepont-sur-Avre","Pierrerue","Pierres","Pierrevert","Pierrevillers","Pierric","Pierry","Pietralba","Pieusse","Pignan","Pignans","Pignols","Pihem","Pimbo","Pimprez","Pin","Pinet","Pineuilh","Piney","Pinon","Pinsaguel","Piolenc","Pionsat","Pipriac","Piquecos","Pire-sur-Seiche","Pirey","Pirou","Piscop","Piseux","Pissos","Pissotte","Pissy-Poville","Pithiviers","Pitres","Pizay","Plabennec","Place","Plailly","Plaimpied-Givaudins","Plaine-Haute","Plaine-de-Walsch","Plaintel","Plaisance","Plaisance-du-Touch","Plaisir","Plan-d'Orgon","Plan-de-Cuques","Planay","Plancher-Bas","Planches","Planguenoual","Planzolles","Plappeville","Plassay","Plateau","Plaudren","Plauzat","Pleboulle","Plechatel","Pledran","Plehedel","Plelan-le-Grand","Plelan-le-Petit","Plelauff","Plelo","Plemet","Plenee-Jugon","Pleneuf-Val-Andre","Plerguer","Plerin","Plerneuf","Plescop","Plesidy","Plesnois","Plessala","Plesse","Plessis-Barbuise","Plessis-de-Roye","Plestan","Plestin-les-Greves","Pleucadeuc","Pleudihen-sur-Rance","Pleugriffet","Pleugueneuc","Pleumartin","Pleumeleuc","Pleumeur-Bodou","Pleure","Pleurs","Pleurtuit","Pleuven","Pleyben","Pleyber-Christ","Plobannalec-Lesconil","Plobsheim","Ploemel","Ploemeur","Ploerdut","Ploeren","Ploermel","Ploeuc-sur-Lie","Ploeven","Plogonnec","Plomb","Plombieres-les-Bains","Plombieres-les-Dijon","Plomelin","Plomeur","Plonevez-du-Faou","Plonéour-Lanvern","Plorec-sur-Arguenon","Plottes","Plouagat","Plouaret","Plouarzel","Plouasne","Plouay","Ploubalay","Ploubazlanec","Ploubezre","Ploudalmezeau","Ploudaniel","Plouec-du-Trieux","Plouedern","Plouer-sur-Rance","Plouescat","Plouezec","Ploufragan","Plougar","Plougasnou","Plougastel-Daoulas","Plougonvelin","Plougonven","Plougoulm","Plougoumelen","Plougourvest","Plougrescant","Plouguerneau","Plouguin","Plouha","Plouharnel","Plouigneau","Ploumagoar","Ploumilliau","Ploumoguer","Plouneour-Menez","Plouneour-Trez","Plounerin","Plounevez-Lochrist","Plounevezel","Plourin","Plourivo","Plouvain","Plouvara","Plouvien","Plouvorn","Plouzane","Plozevet","Pludual","Pluduno","Pluguffan","Pluherlin","Plumaugat","Plumeliau","Plumelin","Plumergat","Plumoison","Pluneret","Plurien","Plusquellec","Plussulien","Pluvault","Pluvigner","Pluzunet","Poce-sur-Cisse","Podensac","Poeuilly","Poey-de-Lescar","Poggio-dOletta","Pogny","Poigny-la-Foret","Poilly-lez-Gien","Poilly-sur-Tholon","Poinsenot","Pointis-Inard","Poisat","Poiseul-les-Saulx","Poisieux","Poisson","Poissons","Poissy","Poisy","Poitiers","Poix","Poix-de-Picardie","Poix-du-Nord","Poligny","Poligny","Pollestres","Polliat","Pomacle","Pomarez","Pomerols","Pomeys","Pommard","Pommeret","Pommerit-Jaudy","Pommerit-le-Vicomte","Pommeuse","Pommevic","Pommiers","Pommiers-la-Placette","Pompadour","Pompaire","Pompertuzat","Pompey","Pompidou","Pompignan","Pomponne","Pomport","Poncey-les-Athee","Ponchon","Poncin","Poncins","Pons","Pons","Pont","Pont-Audemer","Pont-Aven","Pont-Eveque","Pont-Hebert","Pont-Noyelles","Pont-Remy","Pont-Saint-Esprit","Pont-Saint-Mard","Pont-Saint-Martin","Pont-Saint-Pierre","Pont-Saint-Vincent","Pont-Sainte-Marie","Pont-Sainte-Maxence","Pont-Salomon","Pont-Scorff","Pont-a-Marcq","Pont-a-Vendin","Pont-d'Ain","Pont-de-Barret","Pont-de-Beauvoisin","Pont-de-Briques","Pont-de-Buis-les-Quimerch","Pont-de-Cheruy","Pont-de-Labeaume","Pont-de-Larn","Pont-de-Metz","Pont-de-Roide","Pont-de-Salars","Pont-de-Vaux","Pont-de-Veyle","Pont-de-l'Arche","Pont-de-l'Isere","Pont-du-Casse","Pont-du-Chateau","Pont-en-Royans","Pont-l'Abbe-d'Arnoult","Pont-l'Abbé","Pont-l'Eveque","Pont-sur-Sambre","Pont-sur-Seine","Pont-sur-Yonne","Pont-à-Mousson","Pontacq","Pontailler-sur-Saone","Pontarlier","Pontarme","Pontaubault","Pontault-Combault","Pontaumur","Pontaut","Pontavert","Pontcarre","Pontcharra","Pontcharra-sur-Turdine","Pontchateau","Pontcirq","Ponte-Leccia","Ponteilla","Pontenx-les-Forges","Pontgibaud","Pontgouin","Ponthevrard","Ponthierry","Pontigne","Pontigny","Pontivy","Pontlevoy","Pontoise","Pontonx-sur-l'Adour","Pontorson","Pontours","Pontpoint","Pontruet","Ponts","Pontvallain","Popian","Porcelette","Porcheres","Porcheresse","Porcheville","Porcieu-Amblagnieu","Pordic","Pornic","Pornichet","Port-Brillet","Port-Cros","Port-Joinville","Port-Launay","Port-Louis","Port-Mort","Port-Saint-Louis-du-Rhone","Port-Saint-Pere","Port-Sainte-Foy-et-Ponchapt","Port-Sainte-Marie","Port-de-Bouc","Port-des-Barques","Port-en-Bessin-Huppain","Port-la-Nouvelle","Port-sur-Saone","Portbail","Portel-des-Corbieres","Portes-les-Valence","Portet-sur-Garonne","Portets","Porticcio","Portieux","Portiragnes","Porto","Porto-Vecchio","Portrieux","Ports","Portvendres","Poses","Potigny","Pouan-les-Vallees","Pouance","Pouffonds","Pougny","Pougues-les-Eaux","Pougy","Pouille","Pouille","Pouillenay","Pouilley-Francais","Pouilley-les-Vignes","Pouillon","Pouilloux","Pouilly","Pouilly","Pouilly-en-Auxois","Pouilly-le-Monial","Pouilly-les-Nonains","Pouilly-sous-Charlieu","Pouilly-sur-Loire","Pouilly-sur-Serre","Pouilly-sur-Vingeanne","Poulainville","Poulan-Pouzols","Pouldergat","Pouldreuzic","Poule-les-Echarmeaux","Pouligney-Lusans","Poullan-sur-Mer","Poullaouen","Poulx","Pournoy-la-Grasse","Pourrain","Pourrieres","Pouru-Saint-Remy","Poussan","Pouxeux","Pouydesseaux","Pouzauges","Pouzay","Pouzilhac","Pouzolles","Pouzols-Minervois","Poville","Pradelles","Prades","Prades-le-Lez","Pradieres","Prahecq","Pralognan-la-Vanoise","Pranzac","Prasville","Prat","Prats-de-Carlux","Pray","Prayssac","Prayssas","Praz","Praz-sur-Arly","Pre-en-Pail","Preaux","Precey","Prechac","Prechac","Precieux","Precigne","Precorbin","Precy-sous-Thil","Precy-sur-Marne","Precy-sur-Oise","Precy-sur-Vrin","Prefailles","Prefontaines","Preguillac","Preignac","Preignan","Premanon","Premery","Premian","Premontre","Preseau","Presles-en-Brie","Presles-et-Thierny","Pressagny-le-Val","Pressignac-Vicq","Pressigny","Pressigny-les-Pins","Pretot-Vicquemare","Preuschdorf","Prevessin-Moens","Prey","Preyssac-d'Excideuil","Prigonrieux","Primarette","Primat","Prin-Deyrancon","Princay","Pringy","Pringy","Prinquiau","Prisse","Privas","Prix","Prix-les-Mezieres","Proissans","Prompsat","Pronville","Propriano","Prouais","Prouilly","Prouvy","Prouzel","Provencheres-sur-Fave","Provencheres-sur-Meuse","Proveysieux","Proville","Provin","Provins","Proyart","Prudhomat","Pruille-l'Eguille","Prunay-Cassereau","Prunay-le-Gillon","Prunay-sur-Essonne","Prunelli-di-Fiumorbo","Prunieres","Pruniers","Pruzilly","Publier","Puceul","Puchevillers","Puget-Ville","Puget-sur-Argens","Pugey","Pugieu","Pugnac","Pugny-Chatenod","Puicheric","Puihardy","Puilacher","Puilboreau","Puimichel","Puiseaux","Puiseux-en-France","Puiseux-le-Hauberger","Puisieulx","Puisieux","Puissalicon","Puisseguin","Puisserguier","Pujaudran","Pujaut","Pujo-le-Plan","Pujols","Puligny-Montrachet","Pulligny","Pulnoy","Pulversheim","Pusignan","Pussay","Puteaux","Putot-en-Bessin","Puttelange-les-Thionville","Puy-Guillaume","Puy-Saint-Andre","Puy-Saint-Martin","Puybegon","Puybrun","Puycelsi","Puycornet","Puygouzon","Puygros","Puylaurens","Puyloubier","Puymiclan","Puyravault","Puyravault","Puyreaux","Puyricard","Périgueux","Quaedypre","Quarouble","Quarre-les-Tombes","Quatremare","Queaux","Quebriac","Quedillac","Queige","Quelaines-Saint-Gault","Quelneuc","Quenoche","Querenaing","Quernes","Querqueville","Querrien","Querrieu","Quers","Quesnoy-sur-Deule","Quessoy","Questembert","Quetigny","Quettehou","Quettreville-sur-Sienne","Quevauvillers","Queven","Quevert","Quevillon","Queyrac","Queyrieres","Quezac","Quiberon","Quiberville","Quibou","Quiers","Quievrechain","Quievrecourt","Quievy","Quillan","Quillebeuf-sur-Seine","Quilly","Quilly","Quily","Quimper","Quimperlé","Quincampoix","Quincie-en-Beaujolais","Quincieu","Quincy","Quincy-Voisins","Quincy-sous-Senart","Quineville","Quingey","Quinsac","Quint-Fonsegrives","Quintenic","Quintin","Quissac","Quéménéven","Rabastens-de-Bigorre","Rabat-les-Trois-Seigneurs","Rablay-sur-Layon","Rabou","Raches","Racquinghem","Racrange","Radinghem","Radinghem-en-Weppes","Radon","Radonvilliers","Raedersheim","Raffetot","Rahon","Rai","Raids","Raimbeaucourt","Rainfreville","Rainneville","Rainville","Rainvillers","Raismes","Raizeux","Ramatuelle","Rambert","Rambervillers","Rambouillet","Rammersmatt","Ramonchamp","Ramonville-Saint-Agne","Rance","Rancogne","Randan","Randan","Randens","Ranes","Rang","Rang-du-Fliers","Rans","Ranspach","Rantigny","Ranville","Raon-aux-Bois","Raon-l'Etape","Raon-sur-Plaine","Rarecourt","Ratieres","Ratte","Raucourt-et-Flaba","Rauville-la-Place","Rauwiller","Rauzan","Ravenel","Ravieres","Ray-sur-Saone","Rayssac","Razac-d'Eymet","Razac-sur-lIsle","Real","Realmont","Realville","Reaumont","Reaumur","Rebais","Rebenacq","Rebrechien","Rebreuve-sur-Canche","Rebreuviette","Recey-sur-Ource","Rechesy","Rechicourt-le-Chateau","Recloses","Recologne","Recologne-les-Rioz","Recques-sur-Course","Recquignies","Redene","Redessan","Reding","Redon","Reffuveille","Regniowez","Reguiny","Reguisheim","Regusse","Rehainviller","Rehon","Reichshoffen","Reichstett","Reignac-sur-Indre","Reignier-Esery","Reillanne","Reilly","Reims","Reims-la-Brulee","Reiners","Reiningue","Reipertswiller","Reitwiller","Relanges","Remaucourt","Remecourt","Remelfang","Remelfing","Remenoville","Remerangles","Remereville","Remering-les-Puttelange","Remigny","Remilly","Reminiac","Remiremont","Remoulins","Remungol","Remuzat","Remy","Renage","Renaison","Renault","Renaze","Rene","Renescure","Rennes","Renneville","Renève","Repaix","Reparsac","Replonges","Requeil","Requista","Ressons-le-Long","Ressons-sur-Matz","Restinclieres","Rethel","Rethondes","Retiers","Retonfey","Retournac","Retschwiller","Rettel","Rety","Reuil-en-Brie","Reuil-sur-Breche","Reuilly","Reuilly","Reuilly-Sauvigny","Reumont","Reuves","Revel","Revel-Tourdan","Reventin-Vaugris","Revest-des-Brousses","Reviers","Revigny","Revigny-sur-Ornain","Reville","Revin","Reynies","Reyrieux","Reyssouze","Rezonville","Rezé","Rhinau","Riaille","Rians","Rians","Riantec","Ribaute-les-Tavernes","Ribeauvillé","Ribecourt-Dreslincourt","Ribemont","Ribemont-sur-Ancre","Riberac","Ribiers","Ricarville","Richardmenil","Richebourg","Richebourg","Richelieu","Richeling","Richemont","Richemont","Richwiller","Ricquebourg","Riec-sur-Belon","Riedisheim","Riedseltz","Riencourt-les-Bapaume","Rieulay","Rieumes","Rieupeyroux","Rieux","Rieux","Rieux","Rieux-Minervois","Rieux-de-Pelleport","Rieux-en-Cambresis","Riez","Rignac","Rignieux-le-Franc","Rilhac-Rancon","Rillieux-la-Pape","Rimbaud","Rimogne","Ringendorf","Rinxent","Riocaud","Riom","Riom-es-Montagnes","Rion-des-Landes","Rions","Riorges","Riotord","Rioz","Ris-Orangis","Rittershoffen","Rivarennes","Rive-de-Gier","Rivecourt","Rivedoux-Plage","Rivery","Rivesaltes","Riviere","Rivieres","Rivieres","Riville","Rixheim","Roaillan","Roanne","Roannes-Saint-Mary","Robert","Robion","Rocbaron","Roche","Roche","Roche-la-Moliere","Roche-le-Peyroux","Roche-lez-Beaupre","Rochechouart","Rochecorbon","Rochefort","Rochefort-du-Gard","Rochefort-en-Terre","Rochefort-sur-Loire","Rochefort-sur-Nenon","Rochegude","Rochemaure","Rocher","Roches","Roches-Premarie-Andille","Roches-les-Blamont","Roches-sur-Marne","Rocheserviere","Rochesson","Rochetoirin","Rochetrejoux","Rochy-Conde","Rocquemont","Rocquencourt","Rocroi","Rodelinghem","Roderen","Rodern","Rodez","Roeschwoog","Roeulx","Roeux","Roeze-sur-Sarthe","Roffey","Roffiac","Rogerville","Rognac","Rognaix","Rognes","Rognonas","Rohan","Rohan","Rohr","Rohrbach-les-Bitche","Roiffieux","Roisel","Roissy-en-Brie","Roissy-en-France","Rolampont","Rollancourt","Rolleville","Rollot","Romagnat","Romagne","Romagne","Romagne","Romagnieu","Romain","Romain-sur-Meuse","Romaine","Romainville","Romaneche-Thorins","Romange","Romans","Romans-sur-Isère","Rombas","Romegoux","Romeny-sur-Marne","Romeries","Romille","Romilly-sur-Andelle","Romilly-sur-Seine","Romorantin-Lanthenay","Rompon","Roncey","Ronchin","Roncq","Ronnet","Ronno","Ronsenac","Ronthon","Roost-Warendin","Roppe","Roppenheim","Roppentzwiller","Roquebilliere","Roquebrune","Roquebrune-Cap-Martin","Roquebrune-sur-Argens","Roquecor","Roquecourbe","Roquefort","Roquefort","Roquefort-de-Sault","Roquefort-des-Corbieres","Roquefort-la-Bedoule","Roquefort-sur-Garonne","Roquefort-sur-Soulzon","Roquelaure-Saint-Aubin","Roquemaure","Roques","Roqueseriere","Roquesteron","Roquetoire","Roquettes","Roquevaire","Rosay","Rosay-sur-Lieure","Roscoff","Rosel","Rosenwiller","Rosheim","Rosieres","Rosieres-aux-Salines","Rosieres-en-Haye","Rosieres-en-Santerre","Rosieres-pres-Troyes","Rosieres-sur-Mance","Rosny-sous-Bois","Rosny-sur-Seine","Rosoy-en-Multien","Rospez","Rosporden","Rosselange","Rossfeld","Rosteig","Rostrenen","Rosult","Rothau","Rotherens","Rots","Rott","Rouans","Roubaix","Roubia","Roubion","Roucy","Rouen","Rouffach","Rouffiac-Tolosan","Rouffignac","Rouffignac-Saint-Cernin-de-Reilhac","Rouge-Perriers","Rougegoutte","Rougemont","Rougiers","Rouillac","Rouille","Rouillon","Rouilly-Sacey","Roujan","Roulans","Roullens","Roullet-Saint-Estephe","Roumare","Roumazieres","Roumegoux","Roumoules","Rountzenheim","Rouperroux","Rousies","Roussay","Rousseloy","Rousset","Roussillon","Roussillon","Rousson","Roussy","Roussy-le-Village","Routot","Rouville","Rouvillers","Rouvre","Rouvres-la-Chetive","Rouvroy","Rouvroy","Rouvroy-sur-Audry","Rouvroy-sur-Marne","Rouxmesnil-Bouteilles","Rouy-le-Grand","Rouziers-de-Touraine","Roville-aux-Chenes","Royan","Royas","Royat","Roybon","Roye","Roye","Roye-sur-Matz","Rozay-en-Brie","Rozerieulles","Rozier-en-Donzy","Rozieres-en-Beauce","Rozoy-Bellevalle","Rozoy-sur-Serre","Ruaudin","Rubelles","Rubempre","Ruch","Rucqueville","Rue","Rueil-Malmaison","Ruelisheim","Ruelle","Ruelle-sur-Touvre","Ruesnes","Ruffec","Ruffey-les-Beaune","Ruffey-les-Echirey","Ruffey-sur-Seille","Ruffiac","Rugles","Ruille-Froid-Fonds","Ruille-le-Gravelais","Ruitz","Rully","Rully","Rumaucourt","Rumegies","Rumersheim-le-Haut","Rumigny","Rumilly","Rumilly-en-Cambresis","Rungis","Ruoms","Rupt","Rupt-sur-Moselle","Rurange-les-Thionville","Russ","Ruy","Ry","Saacy-sur-Marne","Saales","Sabatier","Sable-sur-Sarthe","Sablonceaux","Sablons","Sabres","Sacey","Sachin","Saclas","Saclay","Sacquenville","Sacy","Sadirac","Saessolsheim","Saffre","Sagy","Sahurs","Saignes","Sail-sous-Couzan","Saillans","Sailly-Flibeaucourt","Sailly-Labourse","Sailly-en-Ostrevent","Sailly-le-Sec","Sailly-lez-Cambrai","Sailly-sur-la-Lys","Sain-Bel","Sainghin-en-Melantois","Sainghin-en-Weppes","Sainneville","Sainpuits","Sains-du-Nord","Sains-en-Amienois","Sains-en-Gohelle","Saint Nicolas Les Arras","Saint-Abit","Saint-Adrien","Saint-Affrique","Saint-Agathon","Saint-Agnant","Saint-Agoulin","Saint-Agreve","Saint-Aignan-des-Noyers","Saint-Aignan-sur-Roe","Saint-Aigulin","Saint-Albain","Saint-Alban-Leysse","Saint-Alban-d'Ay","Saint-Alban-de-Roche","Saint-Alban-du-Rhone","Saint-Alexandre","Saint-Amancet","Saint-Amand-Magnazeix","Saint-Amand-Montrond","Saint-Amand-de-Belves","Saint-Amand-de-Coly","Saint-Amand-en-Puisaye","Saint-Amand-les-Eaux","Saint-Amand-sur-Fion","Saint-Amans-Soult","Saint-Amans-Valtoret","Saint-Amant-Tallende","Saint-Amant-de-Boixe","Saint-Amarin","Saint-Ambroix","Saint-Amour","Saint-Andeol-de-Vals","Saint-Andeux","Saint-Andiol","Saint-Andre","Saint-Andre-Farivillers","Saint-Andre-Goule-d'Oie","Saint-Andre-Treize-Voies","Saint-Andre-de-Chalencon","Saint-Andre-de-Corcy","Saint-Andre-de-Messei","Saint-Andre-de-Roquelongue","Saint-Andre-de-Rosans","Saint-Andre-de-Sangonis","Saint-Andre-de-l'Eure","Saint-Andre-des-Eaux","Saint-Andre-en-Vivarais","Saint-Andre-le-Gaz","Saint-Andre-le-Puy","Saint-Andre-les-Alpes","Saint-Andre-les-Vergers","Saint-Andre-lez-Lille","Saint-Andre-sur-Orne","Saint-Androny","Saint-André-dAllas","Saint-Angeau","Saint-Angel","Saint-Antoine-Cumond","Saint-Antoine-du-Rocher","Saint-Antoine-la-Foret","Saint-Antonin-sur-Bayon","Saint-Apollinaire","Saint-Appolinard","Saint-Aquilin-de-Pacy","Saint-Armel","Saint-Arnoult","Saint-Arnoult","Saint-Arnoult-des-Bois","Saint-Arnoult-en-Yvelines","Saint-Astier","Saint-Auban","Saint-Aubert","Saint-Aubin","Saint-Aubin-d'Aubigne","Saint-Aubin-de-Baubigne","Saint-Aubin-de-Lanquais","Saint-Aubin-de-Medoc","Saint-Aubin-des-Chateaux","Saint-Aubin-du-Cormier","Saint-Aubin-du-Plain","Saint-Aubin-en-Bray","Saint-Aubin-en-Charollais","Saint-Aubin-les-Elbeuf","Saint-Aubin-les-Forges","Saint-Aubin-sous-Erquery","Saint-Aubin-sur-Gaillon","Saint-Aubin-sur-Mer","Saint-Aubin-sur-Scie","Saint-Augustin","Saint-Augustin","Saint-Augustin","Saint-Aunes","Saint-Avaugourd-des-Landes","Saint-Ave","Saint-Avertin","Saint-Avit","Saint-Avit-les-Guespieres","Saint-Avold","Saint-Avre","Saint-Ay","Saint-Aygulf","Saint-Baldoph","Saint-Bardoux","Saint-Barnabe","Saint-Barnabe","Saint-Barthelemy-Lestra","Saint-Barthelemy-d'Anjou","Saint-Barthelemy-de-Bussiere","Saint-Barthelemy-de-Vals","Saint-Baudille-de-la-Tour","Saint-Bauzille-de-Montmel","Saint-Bauzille-de-Putois","Saint-Beat","Saint-Benezet","Saint-Benin-dAzy","Saint-Benoit","Saint-Benoit-des-Ondes","Saint-Benoit-sur-Loire","Saint-Berain-sur-Dheune","Saint-Bernard","Saint-Beron","Saint-Berthevin","Saint-Bihy","Saint-Blaise-la-Roche","Saint-Bohaire","Saint-Boil","Saint-Boingt","Saint-Bonnet-de-Mure","Saint-Bonnet-le-Chateau","Saint-Bonnet-le-Troncy","Saint-Bonnet-les-Allier","Saint-Branchs","Saint-Brandan","Saint-Bres","Saint-Brevin-l'Ocean","Saint-Brevin-les-Pins","Saint-Briac-sur-Mer","Saint-Brice","Saint-Brice-de-Landelles","Saint-Brice-sous-Foret","Saint-Brieuc","Saint-Bris-le-Vineux","Saint-Brisson-sur-Loire","Saint-Calais","Saint-Cannat","Saint-Caprais-de-Bordeaux","Saint-Carne","Saint-Carreuc","Saint-Cassin","Saint-Cast-le-Guildo","Saint-Cere","Saint-Cergues","Saint-Cesaire","Saint-Cezaire-sur-Siagne","Saint-Cezert","Saint-Chamassy","Saint-Chamond","Saint-Chaptes","Saint-Chartres","Saint-Chef","Saint-Chely-d'Apcher","Saint-Cheron-du-Chemin","Saint-Chinian","Saint-Christo-en-Jarez","Saint-Christol","Saint-Christol","Saint-Christol-les-Ales","Saint-Christophe-de-Valains","Saint-Christophe-du-Bois","Saint-Christophe-du-Ligneron","Saint-Christophe-en-Boucherie","Saint-Christophe-en-Brionnais","Saint-Christophe-sur-Avre","Saint-Christophe-sur-Guiers","Saint-Christophe-sur-Roc","Saint-Christophe-sur-le-Nais","Saint-Ciers-sur-Gironde","Saint-Cirgues","Saint-Clair","Saint-Clair-de-la-Tour","Saint-Clair-du-Rhone","Saint-Clair-sur-Galaure","Saint-Clair-sur-l'Elle","Saint-Clar-de-Riviere","Saint-Claud","Saint-Claude","Saint-Claude-de-Diray","Saint-Clement","Saint-Clement","Saint-Clement","Saint-Clement-de-la-Place","Saint-Clement-des-Levees","Saint-Clet","Saint-Cloud","Saint-Colomban","Saint-Congard","Saint-Contest","Saint-Corneille","Saint-Cornier-des-Landes","Saint-Coulitz","Saint-Coulomb","Saint-Creac","Saint-Crepin-Ibouvillers","Saint-Crespin-sur-Moine","Saint-Cyprien","Saint-Cyprien","Saint-Cyprien-Plage","Saint-Cyr-au-Mont-d'Or","Saint-Cyr-du-Gault","Saint-Cyr-en-Pail","Saint-Cyr-en-Val","Saint-Cyr-l'École","Saint-Cyr-la-Campagne","Saint-Cyr-le-Chatoux","Saint-Cyr-les-Champagnes","Saint-Cyr-sur-Loire","Saint-Cyr-sur-Menthon","Saint-Cyr-sur-Mer","Saint-Cyr-sur-Morin","Saint-Cyr-sur-le-Rhone","Saint-Denis","Saint-Denis-d'Oleron","Saint-Denis-dAnjou","Saint-Denis-de-Cabanne","Saint-Denis-de-Palin","Saint-Denis-de-Pile","Saint-Denis-de-Vaux","Saint-Denis-des-Murs","Saint-Denis-en-Bugey","Saint-Denis-en-Val","Saint-Denis-le-Gast","Saint-Denis-le-Thiboult","Saint-Denis-les-Rebais","Saint-Denis-sur-Coise","Saint-Denis-sur-Sarthon","Saint-Derrien","Saint-Desir","Saint-Desirat","Saint-Desire","Saint-Dezery","Saint-Didier-au-Mont-d'Or","Saint-Didier-d'Aussiat","Saint-Didier-de-Formans","Saint-Didier-de-la-Tour","Saint-Didier-en-Donjon","Saint-Didier-en-Velay","Saint-Didier-sous-Riverie","Saint-Didier-sur-Chalaronne","Saint-Didier-sur-Rochefort","Saint-Die-des-Vosges","Saint-Dier-d'Auvergne","Saint-Dionisy","Saint-Disdier","Saint-Divy","Saint-Dizier","Saint-Dizier-en-Diois","Saint-Dolay","Saint-Domet","Saint-Domineuc","Saint-Donan","Saint-Donat-sur-l'Herbasse","Saint-Doulchard","Saint-Drezery","Saint-Ebremond-de-Bonfosse","Saint-Elier","Saint-Eliph","Saint-Elix-Seglan","Saint-Eloi","Saint-Eloi","Saint-Eloy-de-Gy","Saint-Eloy-la-Glaciere","Saint-Eloy-les-Mines","Saint-Emilion","Saint-Erblon","Saint-Erme-Outre-et-Ramecourt","Saint-Esteve","Saint-Esteve-Janson","Saint-Etienne","Saint-Etienne-au-Mont","Saint-Etienne-au-Temple","Saint-Etienne-d'Albagnan","Saint-Etienne-d'Orthe","Saint-Etienne-de-Baigorry","Saint-Etienne-de-Brillouet","Saint-Etienne-de-Crossey","Saint-Etienne-de-Cuines","Saint-Etienne-de-Fontbellon","Saint-Etienne-de-Montluc","Saint-Etienne-de-Saint-Geoirs","Saint-Etienne-de-Tinee","Saint-Etienne-de-Tulmont","Saint-Etienne-de-Valoux","Saint-Etienne-des-Oullieres","Saint-Etienne-du-Bois","Saint-Etienne-du-Gres","Saint-Etienne-du-Valdonnez","Saint-Etienne-du-Vauvray","Saint-Etienne-en-Cogles","Saint-Etienne-la-Varenne","Saint-Etienne-le-Molard","Saint-Etienne-les-Orgues","Saint-Etienne-sous-Bailleul","Saint-Etienne-sur-Chalaronne","Saint-Etienne-sur-Suippe","Saint-Eulien","Saint-Eustache-la-Foret","Saint-Evarzec","Saint-Faust","Saint-Felicien","Saint-Feliu-d'Amont","Saint-Felix-de-Rieutord","Saint-Felix-de-Villadeix","Saint-Fiacre","Saint-Fiacre-sur-Maine","Saint-Firmin","Saint-Firmin-des-Pres","Saint-Florent","Saint-Florent-le-Vieil","Saint-Florent-sur-Auzonnet","Saint-Florent-sur-Cher","Saint-Florentin","Saint-Floret","Saint-Floris","Saint-Flour","Saint-Flovier","Saint-Folquin","Saint-Fons","Saint-Forgeux","Saint-Fort","Saint-Fregant","Saint-Fromond","Saint-Front","Saint-Front","Saint-Front-d'Alemps","Saint-Fulgent","Saint-Fuscien","Saint-Galmier","Saint-Gatien-des-Bois","Saint-Gaudens","Saint-Gaultier","Saint-Gein","Saint-Gelais","Saint-Gely-du-Fesc","Saint-Gence","Saint-Generoux","Saint-Genes-du-Retz","Saint-Genest-Lerpt","Saint-Genest-Malifaux","Saint-Gengoux-de-Scisse","Saint-Genies-Bellevue","Saint-Genies-de-Comolas","Saint-Genies-de-Malgoires","Saint-Genies-des-Mourgues","Saint-Geniez-d'Olt","Saint-Genis-Laval","Saint-Genis-Pouilly","Saint-Genis-les-Ollieres","Saint-Genix-sur-Guiers","Saint-Genou","Saint-Geoire-en-Valdaine","Saint-Geoirs","Saint-Georges-Haute-Ville","Saint-Georges-Montcocq","Saint-Georges-d'Esperanche","Saint-Georges-d'Oleron","Saint-Georges-d'Orques","Saint-Georges-de-Baroille","Saint-Georges-de-Didonne","Saint-Georges-de-Luzencon","Saint-Georges-de-Montaigu","Saint-Georges-de-Pointindoux","Saint-Georges-de-Poisieux","Saint-Georges-de-Reneins","Saint-Georges-des-Coteaux","Saint-Georges-du-Bois","Saint-Georges-du-Rosay","Saint-Georges-du-Vievre","Saint-Georges-le-Flechard","Saint-Georges-les-Baillargeaux","Saint-Georges-sur-Allier","Saint-Georges-sur-Arnon","Saint-Georges-sur-Baulche","Saint-Georges-sur-Cher","Saint-Georges-sur-Eure","Saint-Georges-sur-Fontaine","Saint-Georges-sur-Loire","Saint-Georges-sur-Renon","Saint-Geours-d'Auribat","Saint-Gerand","Saint-Gerand-de-Vaux","Saint-Gereon","Saint-Germain","Saint-Germain-Langot","Saint-Germain-Laprade","Saint-Germain-Laxis","Saint-Germain-Lembron","Saint-Germain-Nuelles","Saint-Germain-Village","Saint-Germain-de-Joux","Saint-Germain-de-Princay","Saint-Germain-de-Tournebut","Saint-Germain-de-la-Grange","Saint-Germain-des-Fosses","Saint-Germain-des-Pres","Saint-Germain-du-Corbeis","Saint-Germain-du-Plain","Saint-Germain-du-Puch","Saint-Germain-du-Puy","Saint-Germain-en-Laye","Saint-Germain-la-Blanche-Herbe","Saint-Germain-la-Ville","Saint-Germain-les-Arpajon","Saint-Germain-les-Belles","Saint-Germain-les-Corbeil","Saint-Germain-les-Paroisses","Saint-Germain-les-Vergnes","Saint-Germain-sous-Doue","Saint-Germain-sur-Avre","Saint-Germain-sur-Moine","Saint-Germain-sur-Morin","Saint-Germain-sur-Rhone","Saint-Germainmont","Saint-Germer-de-Fly","Saint-Gervais-en-Belin","Saint-Gervais-la-Foret","Saint-Gervais-les-Bains","Saint-Gervais-sous-Meymont","Saint-Gervais-sur-Roubion","Saint-Gervazy","Saint-Geyrac","Saint-Gildas-des-Bois","Saint-Gilles","Saint-Gilles-des-Marais","Saint-Gilles-les-Bois","Saint-Gingolph","Saint-Girons","Saint-Goazec","Saint-Gobain","Saint-Gondon","Saint-Gondran","Saint-Gonnery","Saint-Gratien","Saint-Gratien","Saint-Grave","Saint-Gregoire","Saint-Gregoire","Saint-Guilhem-le-Desert","Saint-Guinoux","Saint-Heand","Saint-Helen","Saint-Herblain","Saint-Herve","Saint-Hilaire-Cusson-la-Valmitte","Saint-Hilaire-Peyroux","Saint-Hilaire-Saint-Mesmin","Saint-Hilaire-de-Brethmas","Saint-Hilaire-de-Chaleons","Saint-Hilaire-de-Court","Saint-Hilaire-de-Loulay","Saint-Hilaire-de-Riez","Saint-Hilaire-de-Talmont","Saint-Hilaire-de-Voust","Saint-Hilaire-de-la-Cote","Saint-Hilaire-du-Harcouet","Saint-Hilaire-le-Vouhis","Saint-Hilaire-les-Andresis","Saint-Hilaire-les-Courbes","Saint-Hilaire-lez-Cambrai","Saint-Hilarion","Saint-Hilliers","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte","Saint-Hippolyte-de-Montaigu","Saint-Hippolyte-du-Fort","Saint-Honore-les-Bains","Saint-Hostien","Saint-Igneuc","Saint-Illide","Saint-Imoges","Saint-Ismier","Saint-Jacques-de-la-Lande","Saint-Jean-Bonnefonds","Saint-Jean-Brevelay","Saint-Jean-Kerdaniel","Saint-Jean-Kourtzerode","Saint-Jean-Lasseille","Saint-Jean-Ligoure","Saint-Jean-Pied-de-Port","Saint-Jean-Rohrbach","Saint-Jean-Saint-Germain","Saint-Jean-Trolimon","Saint-Jean-aux-Amognes","Saint-Jean-d'Aigues-Vives","Saint-Jean-d'Angely","Saint-Jean-d'Ardieres","Saint-Jean-d'Aubrigoux","Saint-Jean-d'Illac","Saint-Jean-de-Boiseau","Saint-Jean-de-Bournay","Saint-Jean-de-Braye","Saint-Jean-de-Chevelu","Saint-Jean-de-Cornies","Saint-Jean-de-Gonville","Saint-Jean-de-Laur","Saint-Jean-de-Lier","Saint-Jean-de-Liversay","Saint-Jean-de-Losne","Saint-Jean-de-Luz","Saint-Jean-de-Marcel","Saint-Jean-de-Marsacq","Saint-Jean-de-Maurienne","Saint-Jean-de-Moirans","Saint-Jean-de-Monts","Saint-Jean-de-Muzols","Saint-Jean-de-Sauves","Saint-Jean-de-Serres","Saint-Jean-de-Sixt","Saint-Jean-de-Soudain","Saint-Jean-de-Vedas","Saint-Jean-de-la-Ruelle","Saint-Jean-des-Baisants","Saint-Jean-des-Champs","Saint-Jean-des-Mauvrets","Saint-Jean-des-Ollieres","Saint-Jean-des-Vignes","Saint-Jean-du-Bruel","Saint-Jean-du-Cardonnay","Saint-Jean-du-Falga","Saint-Jean-en-Royans","Saint-Jean-la-Poterie","Saint-Jean-le-Blanc","Saint-Jean-le-Blanc","Saint-Jean-le-Centenier","Saint-Jean-le-Thomas","Saint-Jean-les-Deux-Jumeaux","Saint-Jean-sur-Erve","Saint-Jean-sur-Vilaine","Saint-Jeannet","Saint-Jeoire","Saint-Jeoire-Prieure","Saint-Jeure-d'Andaure","Saint-Jeures","Saint-Joachim","Saint-Jorioz","Saint-Jory","Saint-Joseph-de-Riviere","Saint-Jouan-des-Guerets","Saint-Jouvent","Saint-Judoce","Saint-Julien","Saint-Julien-de-Cassagnas","Saint-Julien-de-Chedon","Saint-Julien-de-Concelles","Saint-Julien-de-Coppel","Saint-Julien-de-Lampon","Saint-Julien-de-Vouvantes","Saint-Julien-des-Landes","Saint-Julien-du-Puy","Saint-Julien-du-Sault","Saint-Julien-en-Born","Saint-Julien-en-Champsaur","Saint-Julien-en-Genevois","Saint-Julien-le-Roux","Saint-Julien-le-Vendomois","Saint-Julien-les-Metz","Saint-Julien-les-Villas","Saint-Julien-sur-Bibost","Saint-Julien-sur-Sarthe","Saint-Junien","Saint-Just-Chaleyssin","Saint-Just-Malmont","Saint-Just-de-Claix","Saint-Just-en-Bas","Saint-Just-en-Chaussee","Saint-Just-en-Chevalet","Saint-Just-le-Martel","Saint-Just-pres-Brioude","Saint-Lactencin","Saint-Lager","Saint-Lager-Bressac","Saint-Lambert-du-Lattay","Saint-Lambert-la-Potherie","Saint-Lambert-sur-Dive","Saint-Lanne","Saint-Lary-Boujean","Saint-Lary-Soulan","Saint-Launeuc","Saint-Laurent-Blangy","Saint-Laurent-Bretagne","Saint-Laurent-Rochefort","Saint-Laurent-d'Agny","Saint-Laurent-d'Aigouze","Saint-Laurent-d'Arce","Saint-Laurent-de-Levezou","Saint-Laurent-de-Mure","Saint-Laurent-de-Neste","Saint-Laurent-de-la-Plaine","Saint-Laurent-de-la-Pree","Saint-Laurent-de-la-Salanque","Saint-Laurent-des-Autels","Saint-Laurent-des-Combes","Saint-Laurent-du-Bois","Saint-Laurent-du-Mottay","Saint-Laurent-du-Pont","Saint-Laurent-du-Var","Saint-Laurent-en-Beaumont","Saint-Laurent-en-Gatines","Saint-Laurent-la-Roche","Saint-Laurent-sur-Gorre","Saint-Laurent-sur-Sevre","Saint-Laurs","Saint-Leger-aux-Bois","Saint-Leger-de-Rotes","Saint-Leger-des-Vignes","Saint-Leger-du-Bourg-Denis","Saint-Leger-en-Bray","Saint-Leger-les-Domart","Saint-Leger-sous-Brienne","Saint-Leger-sous-Cholet","Saint-Leger-sur-Dheune","Saint-Leon-sur-l'Isle","Saint-Leonard","Saint-Leonard-de-Noblat","Saint-Leopardin-d'Augy","Saint-Leu-d'Esserent","Saint-Leu-la-Foret","Saint-Lezin","Saint-Lieux-les-Lavaur","Saint-Lo-d'Ourville","Saint-Lormel","Saint-Loubes","Saint-Louis","Saint-Louis-de-Montferrand","Saint-Loup","Saint-Loup-Cammas","Saint-Loup-Hors","Saint-Lubin-des-Joncherets","Saint-Lumier-en-Champagne","Saint-Lumine-de-Clisson","Saint-Luperce","Saint-Lupicin","Saint-Lye","Saint-Lye-la-Foret","Saint-Lyphard","Saint-Lys","Saint-Lô","Saint-M'Herve","Saint-Macaire","Saint-Macaire-du-Bois","Saint-Macaire-en-Mauges","Saint-Magne-de-Castillon","Saint-Maigner","Saint-Maigrin","Saint-Maime","Saint-Maixant","Saint-Maixent-l'Ecole","Saint-Malo-de-Guersac","Saint-Malo-de-Phily","Saint-Malo-de-la-Lande","Saint-Malo-du-Bois","Saint-Malo-en-Donziois","Saint-Mamert-du-Gard","Saint-Mamet-la-Salvetat","Saint-Mammes","Saint-Mande","Saint-Mandrier-sur-Mer","Saint-Marc-Jaumegarde","Saint-Marceau","Saint-Marcel-Bel-Accueil","Saint-Marcel-d'Ardeche","Saint-Marcel-d'Urfe","Saint-Marcel-les-Valence","Saint-Marcel-sur-Aude","Saint-Marcellin","Saint-Marcellin-en-Forez","Saint-Mard","Saint-Mard-de-Vaux","Saint-Mariens","Saint-Mars-d'Outille","Saint-Mars-de-Coutais","Saint-Mars-de-Locquenay","Saint-Mars-du-Desert","Saint-Mars-la-Jaille","Saint-Martial","Saint-Martial-de-Vitaterne","Saint-Martin-Belle-Roche","Saint-Martin-Bellevue","Saint-Martin-Boulogne","Saint-Martin-Choquel","Saint-Martin-Lacaussade","Saint-Martin-Lalande","Saint-Martin-Longueau","Saint-Martin-Osmonville","Saint-Martin-Sainte-Catherine","Saint-Martin-Terressus","Saint-Martin-Valmeroux","Saint-Martin-au-Laert","Saint-Martin-d'Ablois","Saint-Martin-d'Arrossa","Saint-Martin-d'Auxigny","Saint-Martin-d'Heuille","Saint-Martin-d'Hères","Saint-Martin-d'Uriage","Saint-Martin-de-Belleville","Saint-Martin-de-Bernegoue","Saint-Martin-de-Blagny","Saint-Martin-de-Crau","Saint-Martin-de-Fontenay","Saint-Martin-de-Lenne","Saint-Martin-de-Londres","Saint-Martin-de-Nigelles","Saint-Martin-de-Re","Saint-Martin-de-Riberac","Saint-Martin-de-Seignanx","Saint-Martin-de-Valamas","Saint-Martin-de-Valgalgues","Saint-Martin-de-la-Brasque","Saint-Martin-des-Bois","Saint-Martin-des-Champs","Saint-Martin-des-Champs","Saint-Martin-des-Noyers","Saint-Martin-des-Olmes","Saint-Martin-du-Bois","Saint-Martin-du-Bois","Saint-Martin-du-Bosc","Saint-Martin-du-Manoir","Saint-Martin-du-Mont","Saint-Martin-du-Puy","Saint-Martin-du-Tertre","Saint-Martin-du-Tilleul","Saint-Martin-du-Var","Saint-Martin-en-Biere","Saint-Martin-en-Bresse","Saint-Martin-en-Campagne","Saint-Martin-en-Gatinois","Saint-Martin-en-Haut","Saint-Martin-la-Campagne","Saint-Martin-la-Plaine","Saint-Martin-le-Beau","Saint-Martin-le-Noeud","Saint-Martin-le-Pin","Saint-Martin-le-Vieil","Saint-Martin-le-Vinoux","Saint-Martin-les-Melle","Saint-Martin-sur-Arve","Saint-Martin-sur-Nohain","Saint-Martin-sur-Ocre","Saint-Martin-sur-le-Pre","Saint-Mary","Saint-Mathieu-de-Treviers","Saint-Mathurin","Saint-Maudan","Saint-Maulvis","Saint-Maur-des-Fossés","Saint-Maurice","Saint-Maurice-Montcouronne","Saint-Maurice-de-Cazevieille","Saint-Maurice-de-Gourdans","Saint-Maurice-de-Lignon","Saint-Maurice-de-Remens","Saint-Maurice-l'Exil","Saint-Maurice-la-Clouere","Saint-Maurice-la-Souterraine","Saint-Maurice-les-Brousses","Saint-Maurice-sur-Aveyron","Saint-Maurice-sur-Dargoire","Saint-Maurice-sur-Eygues","Saint-Maurice-sur-Fessard","Saint-Maurice-sur-Moselle","Saint-Max","Saint-Maxent","Saint-Maximin","Saint-Maximin","Saint-Maximin","Saint-Maximin-la-Sainte-Baume","Saint-Maxire","Saint-Meard-de-Gurcon","Saint-Medard-d'Aunis","Saint-Medard-d'Eyrans","Saint-Medard-de-Guizieres","Saint-Medard-en-Forez","Saint-Meen-le-Grand","Saint-Melaine-sur-Aubance","Saint-Meloir-des-Ondes","Saint-Meme-les-Carrieres","Saint-Memmie","Saint-Michel","Saint-Michel","Saint-Michel-Chef-Chef","Saint-Michel-Mont-Mercure","Saint-Michel-Treve","Saint-Michel-de-Chabrillanoux","Saint-Michel-de-Maurienne","Saint-Michel-de-Rieufret","Saint-Michel-de-Volangis","Saint-Michel-des-Andaines","Saint-Michel-lObservatoire","Saint-Michel-le-Cloucq","Saint-Michel-sous-Bois","Saint-Michel-sur-Meurthe","Saint-Michel-sur-Orge","Saint-Michel-sur-Savasse","Saint-Michel-sur-Ternoise","Saint-Mihiel","Saint-Mitre-les-Remparts","Saint-Morillon","Saint-Médard-en-Jalles","Saint-Nabord","Saint-Nauphary","Saint-Nazaire","Saint-Nazaire","Saint-Nazaire-de-Valentane","Saint-Nectaire","Saint-Nicolas-d'Aliermont","Saint-Nicolas-de-Bliquetuit","Saint-Nicolas-de-Port","Saint-Nicolas-de-Redon","Saint-Nicolas-de-la-Grave","Saint-Nicolas-du-Pelem","Saint-Nolff","Saint-Nom-la-Breteche","Saint-Offenge-Dessous","Saint-Offenge-Dessus","Saint-Omer","Saint-Omer-en-Chaussee","Saint-Orens-Pouy-Petit","Saint-Orens-de-Gameville","Saint-Ouen","Saint-Ouen","Saint-Ouen-de-Thouberville","Saint-Ouen-des-Besaces","Saint-Ouen-des-Toits","Saint-Ouen-du-Breuil","Saint-Ouen-du-Mesnil-Oger","Saint-Ouen-du-Tilleul","Saint-Ouen-en-Brie","Saint-Ouen-l'Aumone","Saint-Ouen-les-Parey","Saint-Ouen-sur-Iton","Saint-Ouen-sur-Morin","Saint-Oulph","Saint-Ours","Saint-Pabu","Saint-Pair-du-Mont","Saint-Pair-sur-Mer","Saint-Pal-de-Mons","Saint-Palais","Saint-Pancre","Saint-Pandelon","Saint-Pantaleon-de-Larche","Saint-Papoul","Saint-Pardoux-du-Breuil","Saint-Pargoire","Saint-Parize-le-Chatel","Saint-Parres-aux-Tertres","Saint-Parres-les-Vaudes","Saint-Paterne","Saint-Paterne-Racan","Saint-Pathus","Saint-Patrice-de-Claids","Saint-Paul","Saint-Paul","Saint-Paul-Trois-Chateaux","Saint-Paul-de-Jarrat","Saint-Paul-de-Varces","Saint-Paul-de-Vence","Saint-Paul-de-Vezelin","Saint-Paul-du-Vernay","Saint-Paul-en-Chablais","Saint-Paul-en-Cornillon","Saint-Paul-en-Foret","Saint-Paul-en-Jarez","Saint-Paul-en-Pareds","Saint-Paul-les-Dax","Saint-Paul-les-Durance","Saint-Paul-les-Romans","Saint-Paulet-de-Caisson","Saint-Pee-sur-Nivelle","Saint-Pellerin","Saint-Peray","Saint-Perdon","Saint-Pere","Saint-Pere-en-Retz","Saint-Pern","Saint-Philbert-de-Bouaine","Saint-Philbert-de-Grand-Lieu","Saint-Philbert-du-Pont-Charrault","Saint-Philibert","Saint-Piat","Saint-Pierre-Bois","Saint-Pierre-Brouck","Saint-Pierre-Lavis","Saint-Pierre-Montlimart","Saint-Pierre-Tarentaine","Saint-Pierre-d'Albigny","Saint-Pierre-d'Autils","Saint-Pierre-d'Entremont","Saint-Pierre-d'Irube","Saint-Pierre-d'Oleron","Saint-Pierre-dAllevard","Saint-Pierre-de-Boeuf","Saint-Pierre-de-Bressieux","Saint-Pierre-de-Chandieu","Saint-Pierre-de-Jards","Saint-Pierre-de-Lages","Saint-Pierre-de-Maille","Saint-Pierre-de-Mons","Saint-Pierre-de-Plesguen","Saint-Pierre-de-Trivisy","Saint-Pierre-de-Varengeville","Saint-Pierre-de-Varennes","Saint-Pierre-des-Corps","Saint-Pierre-des-Echaubrognes","Saint-Pierre-des-Fleurs","Saint-Pierre-du-Chemin","Saint-Pierre-du-Mont","Saint-Pierre-du-Palais","Saint-Pierre-du-Perray","Saint-Pierre-du-Regard","Saint-Pierre-du-Vauvray","Saint-Pierre-en-Port","Saint-Pierre-en-Val","Saint-Pierre-la-Bourlhonne","Saint-Pierre-la-Cour","Saint-Pierre-la-Garenne","Saint-Pierre-la-Palud","Saint-Pierre-le-Chastel","Saint-Pierre-le-Moutier","Saint-Pierre-le-Vieux","Saint-Pierre-le-Vieux","Saint-Pierre-les-Elbeuf","Saint-Pierre-sur-Dives","Saint-Pierreville","Saint-Pol-de-Léon","Saint-Pol-sur-Mer","Saint-Pol-sur-Ternoise","Saint-Pompont","Saint-Pont","Saint-Porchaire","Saint-Porquier","Saint-Pouange","Saint-Pourcain-sur-Sioule","Saint-Prest","Saint-Priest-Taurion","Saint-Priest-des-Champs","Saint-Priest-en-Jarez","Saint-Priest-la-Roche","Saint-Priest-la-Vetre","Saint-Prim","Saint-Privat","Saint-Privat","Saint-Privat-d'Allier","Saint-Privat-de-Vallongue","Saint-Privat-la-Montagne","Saint-Prix","Saint-Projet","Saint-Prouant","Saint-Pryve-Saint-Mesmin","Saint-Python","Saint-Pé-dArdet","Saint-Quay-Perros","Saint-Quay-Portrieux","Saint-Quentin","Saint-Quentin-Fallavier","Saint-Quentin-de-Baron","Saint-Quentin-du-Dropt","Saint-Quentin-en-Mauges","Saint-Quentin-la-Poterie","Saint-Quentin-le-Verger","Saint-Quentin-les-Chardonnets","Saint-Quentin-sur-Indrois","Saint-Quentin-sur-le-Homme","Saint-Rambert-d'Albon","Saint-Rambert-en-Bugey","Saint-Rambert-l'Ile-Barbe","Saint-Raphaël","Saint-Regle","Saint-Remeze","Saint-Remimont","Saint-Remy","Saint-Remy","Saint-Remy","Saint-Remy-du-Nord","Saint-Remy-en-Mauges","Saint-Remy-en-Rollat","Saint-Remy-l'Honore","Saint-Remy-la-Vanne","Saint-Remy-la-Varenne","Saint-Remy-les-Chevreuse","Saint-Remy-sur-Avre","Saint-Remy-sur-Durolle","Saint-Renan","Saint-Reverien","Saint-Riquier","Saint-Rirand","Saint-Robert","Saint-Roch","Saint-Rogatien","Saint-Romain-Lachalm","Saint-Romain-d'Ay","Saint-Romain-de-Colbosc","Saint-Romain-de-Lerps","Saint-Romain-en-Gal","Saint-Romain-en-Gier","Saint-Romain-la-Motte","Saint-Romain-la-Virvee","Saint-Romain-le-Preux","Saint-Romain-le-Puy","Saint-Romain-les-Atheux","Saint-Rome-de-Tarn","Saint-Rémy-de-Provence","Saint-Saens","Saint-Saire","Saint-Samson-sur-Rance","Saint-Sandoux","Saint-Sardos","Saint-Saturnin-du-Limet","Saint-Saturnin-les-Apt","Saint-Saturnin-les-Avignon","Saint-Saturnin-sur-Loire","Saint-Saulge","Saint-Saulve","Saint-Sauvant","Saint-Sauveur-Gouvernet","Saint-Sauveur-Lendelin","Saint-Sauveur-dAunis","Saint-Sauveur-de-Montagut","Saint-Sauveur-la-Sagne","Saint-Sauveur-le-Vicomte","Saint-Savin","Saint-Savin","Saint-Savin","Saint-Savinien","Saint-Saviol","Saint-Savournin","Saint-Sebastien","Saint-Sebastien","Saint-Sebastien-de-Morsent","Saint-Secondin","Saint-Segal","Saint-Seglin","Saint-Seine-sur-Vingeanne","Saint-Selve","Saint-Senoch","Saint-Senoux","Saint-Series","Saint-Sernin","Saint-Sernin-du-Bois","Saint-Servant","Saint-Seurin-de-Cadourne","Saint-Seurin-de-Cursac","Saint-Seurin-de-Prats","Saint-Seurin-sur-l'Isle","Saint-Sever","Saint-Sever-Calvados","Saint-Siffret","Saint-Sigismond","Saint-Simeon-de-Bressieux","Saint-Simon","Saint-Simon-de-Pellouaille","Saint-Sixt","Saint-Sixte","Saint-Sorlin-en-Valloire","Saint-Souplet","Saint-Soupplets","Saint-Suliac","Saint-Sulpice-d'Arnoult","Saint-Sulpice-de-Faleyrens","Saint-Sulpice-de-Royan","Saint-Sulpice-et-Cameyrac","Saint-Sulpice-la-Foret","Saint-Sulpice-le-Vieux","Saint-Sulpice-les-Feuilles","Saint-Sulpice-sur-Leze","Saint-Sulpice-sur-Risle","Saint-Sylvain","Saint-Sylvain-d'Anjou","Saint-Sylvestre-sur-Lot","Saint-Symphorien-d'Ancelles","Saint-Symphorien-dOzon","Saint-Symphorien-de-Lay","Saint-Symphorien-sur-Coise","Saint-Symphorien-sur-Saone","Saint-Sébastien-sur-Loire","Saint-Theodorit","Saint-Thibaud-de-Couz","Saint-Thibault","Saint-Thibault-des-Vignes","Saint-Thibery","Saint-Thierry","Saint-Thurial","Saint-Trivier-de-Courtes","Saint-Trivier-sur-Moignans","Saint-Trojan-les-Bains","Saint-Tropez","Saint-Tugdual","Saint-Urbain","Saint-Urbain","Saint-Urbain-Maconcourt","Saint-Usage","Saint-Uze","Saint-Vaast-du-Val","Saint-Vaast-en-Auge","Saint-Vaast-la-Hougue","Saint-Vaast-les-Mello","Saint-Valery-en-Caux","Saint-Valery-sur-Somme","Saint-Vallier","Saint-Vallier","Saint-Vallier-de-Thiey","Saint-Varent","Saint-Vaury","Saint-Venant","Saint-Verand","Saint-Viance","Saint-Viatre","Saint-Viaud","Saint-Victor-d'Epine","Saint-Victor-de-Cessieu","Saint-Victor-la-Coste","Saint-Victor-sur-Arlanc","Saint-Victor-sur-Loire","Saint-Victor-sur-Rhins","Saint-Victoret","Saint-Victurnien","Saint-Vigor","Saint-Vincent-de-Connezac","Saint-Vincent-de-Durfort","Saint-Vincent-de-Paul","Saint-Vincent-de-Tyrosse","Saint-Vincent-des-Landes","Saint-Vincent-sur-Graon","Saint-Vit","Saint-Vital","Saint-Vite","Saint-Vivien","Saint-Vivien-de-Medoc","Saint-Vrain","Saint-Vulbas","Saint-Witz","Saint-Xandre","Saint-Ybars","Saint-Yorre","Saint-Yrieix-la-Perche","Saint-Yrieix-sur-Charente","Saint-Yvi","Saint-Yzan-de-Soudiac","Saint-Zacharie","Saint-Étienne-du-Rouvray","Sainte-Adresse","Sainte-Agathe-d'Aliermont","Sainte-Anastasie-sur-Issole","Sainte-Anne-Saint-Priest","Sainte-Anne-sur-Vilaine","Sainte-Austreberthe","Sainte-Bazeille","Sainte-Blandine","Sainte-Catherine","Sainte-Catherine","Sainte-Cecile","Sainte-Cecile","Sainte-Colombe-de-Duras","Sainte-Colombe-sur-Gand","Sainte-Colombe-sur-Guette","Sainte-Consorce","Sainte-Croix","Sainte-Croix-Grand-Tonne","Sainte-Croix-Hague","Sainte-Croix-Volvestre","Sainte-Croix-aux-Mines","Sainte-Croix-en-Jarez","Sainte-Croix-en-Plaine","Sainte-Eanne","Sainte-Enimie","Sainte-Eulalie-en-Born","Sainte-Eusoye","Sainte-Fauste","Sainte-Fereole","Sainte-Flaive-des-Loups","Sainte-Florence","Sainte-Florine","Sainte-Fortunade","Sainte-Foy-d'Aigrefeuille","Sainte-Foy-de-Longas","Sainte-Foy-de-Peyrolieres","Sainte-Foy-l'Argentiere","Sainte-Foy-la-Grande","Sainte-Foy-les-Lyon","Sainte-Gemme-Martaillac","Sainte-Gemme-la-Plaine","Sainte-Genevieve","Sainte-Genevieve","Sainte-Geneviève-des-Bois","Sainte-Helene","Sainte-Hermine","Sainte-Honorine-du-Fay","Sainte-Livrade-sur-Lot","Sainte-Luce-sur-Loire","Sainte-Lucie de Porto-Vecchio","Sainte-Lucie-de-Tallano","Sainte-Marguerite","Sainte-Marguerite-des-Loges","Sainte-Marie","Sainte-Marie-Cappel","Sainte-Marie-Kerque","Sainte-Marie-Laumont","Sainte-Marie-aux-Chenes","Sainte-Marie-aux-Mines","Sainte-Marie-de-Chignac","Sainte-Marie-de-Cuines","Sainte-Marie-de-Re","Sainte-Marie-du-Mont","Sainte-Maure-de-Touraine","Sainte-Maxime","Sainte-Menehould","Sainte-Mere-Eglise","Sainte-Neomaye","Sainte-Opportune-du-Bosc","Sainte-Ouenne","Sainte-Pazanne","Sainte-Preuve","Sainte-Radegonde","Sainte-Reine-de-Bretagne","Sainte-Sabine-sur-Longeve","Sainte-Savine","Sainte-Seve","Sainte-Sigolene","Sainte-Solange","Sainte-Soulle","Sainte-Suzanne","Sainte-Terre","Sainte-Tulle","Sainte-Valiere","Sainte-Verge","Saintes","Saintes-Maries-de-la-Mer","Saintry-sur-Seine","Saints","Saints-Geosmes","Sainville","Saissac","Saisseval","Saivres","Saix","Salagnon","Salaise-sur-Sanne","Salans","Salbert","Salbris","Saleich","Saleilles","Salernes","Salers","Sales","Saleux","Salies-de-Bearn","Salies-du-Salat","Saligny","Saligny-le-Vif","Saligny-sur-Roudon","Salin-de-Giraud","Salindres","Salins","Salins-les-Bains","Salins-les-Thermes","Sallanches","Sallaumines","Salleboeuf","Salleles-d'Aude","Sallertaine","Salles-Mongiscard","Salles-d'Angles","Salles-d'Aude","Salles-de-Barbezieux","Salles-la-Source","Salles-sur-Mer","Salome","Salon-de-Provence","Salouel","Salses-le-Chateau","Salvagnac","Salviac","Salvizinet","Salzuit","Samadet","Samatan","Samazan","Sambin","Sameon","Samer","Samognat","Samois-sur-Seine","Samoreau","Samoëns","Sampigny-les-Maranges","Samson","San-Giuliano","San-Nicolao","Sanary-sur-Mer","Sancerre","Sanchey","Sancourt","Sand","Sandillon","Sandouville","Sandrans","Sangatte","Sanguinet","Sannerville","Sannois","Sansais","Sant Andreu de Sureda","Sant Genis de Fontanes","Sant Joan de Pladecorts","Santa-Maria-Poggio","Santeny","Santes","Santeuil","Santranges","Sanvignes-les-Mines","Sanxay","Saone","Sapogne-et-Feucheres","Sapogne-sur-Marche","Saramon","Saran","Sarcelles","Sarcey","Sarcicourt","Sardan","Sardieu","Sardon","Sare","Sarge-sur-Braye","Sari-d'Orcino","Sarlat-la-Canéda","Sarliac-sur-lIsle","Sarralbe","Sarraltroff","Sarrant","Sarras","Sarrazac","Sarre","Sarre-Union","Sarrebourg","Sarreguemines","Sarrey","Sarrians","Sarrola-Carcopino","Sarry","Sars-Poteries","Sartrouville","Sartène","Sarzeau","Sassay","Sassenage","Sassenay","Sassey-sur-Meuse","Sathonay-Camp","Sathonay-Village","Satillieu","Satolas-et-Bonce","Saubens","Saubion","Saubrigues","Saubusse","Saucats","Saudoy","Saugon","Saugues","Saujon","Saulces-Monclin","Saulcy-sur-Meurthe","Saules","Saulge","Saulieu","Saulnes","Saulnieres","Saulnot","Saulny","Saulon-la-Chapelle","Saulon-la-Rue","Sault","Sault-Brenaz","Sault-Saint-Remy","Sault-les-Rethel","Saultain","Saulx-Marchais","Saulx-les-Chartreux","Saulxures","Saulxures-les-Nancy","Saulxures-sur-Moselotte","Saulzoir","Saumane-de-Vaucluse","Saumeray","Saumur","Saurat","Sauret-Besserve","Sausheim","Saussan","Saussay-la-Campagne","Saussemesnil","Saussenac","Sausset-les-Pins","Saussey","Saussines","Sautel","Sauteyrargues","Sautron","Sauvage","Sauvagney","Sauvagnon","Sauvat","Sauve","Sauverny","Sauvessanges","Sauveterre","Sauveterre-de-Bearn","Sauveterre-de-Comminges","Sauveterre-de-Guyenne","Sauveterre-la-Lemance","Sauvian","Sauvigney-les-Pesmes","Sauvigny-les-Bois","Sauxillanges","Sauze","Sauze-Vaussais","Sauzelles","Sauzet","Sauzet","Sauzon","Savasse","Savenay","Savennieres","Saverdun","Saverne","Savieres","Savignac-les-Eglises","Savignac-sur-Leyze","Savigne","Savigne-l'Eveque","Savigne-sous-le-Lude","Savigneux","Savigny","Savigny-en-Revermont","Savigny-en-Septaine","Savigny-le-Sec","Savigny-le-Temple","Savigny-les-Beaune","Savigny-sur-Braye","Savigny-sur-Clairis","Savigny-sur-Orge","Savoie","Savonnieres","Savouges","Savoyeux","Savy","Savy-Berlette","Sayat","Scaer","Sceaux","Sceaux-d'Anjou","Sceaux-du-Gatinais","Sceaux-sur-Huisne","Scharrachbergheim-Irmstett","Scherwiller","Schillersdorf","Schiltigheim","Schirmeck","Schirrhein","Schmittviller","Schnersheim","Schoeneck","Schopperten","Schorbach","Schweighouse-Thann","Schwenheim","Scientrier","Sciez","Scionzier","Scorbe-Clairvaux","Scrignac","Scy-Chazelles","Sebazac-Concoures","Sebecourt","Sebourg","Secheval","Seclin","Secondigny","Sedan","Sedzere","Sees","Seez","Segalas","Segny","Segonzac","Segonzat","Segre","Segrie","Segry","Seichamps","Seiches-sur-le-Loir","Seignalens","Seignelay","Seignosse","Seilh","Seilhac","Seillons-Source-d'Argens","Seine-Port","Seingbouse","Seissan","Selle","Selles","Selles-Saint-Denis","Selles-sur-Cher","Selles-sur-Nahon","Sellieres","Selommes","Seloncourt","Selongey","Seltz","Semalens","Semblancay","Semeac","Semeacq-Blachon","Semecourt","Semoine","Semoutiers-Montsaon","Semoy","Sempigny","Semur-en-Brionnais","Senan","Senas","Sendets","Sene","Senlecques","Senlis","Sennece-les-Macon","Sennecey-le-Grand","Sennely","Senneville-sur-Fecamp","Senonches","Senones","Senonges","Senozan","Sens","Sens-de-Bretagne","Sentheim","Senuc","Sepmeries","Seppois-le-Bas","Seppois-le-Haut","Sept-Forges","Sept-Saulx","Septeme","Septemes-les-Vallons","Septeuil","Septfonds","Septvaux","Sequedin","Seraincourt","Serans","Seraucourt-le-Grand","Serbannes","Serdinya","Sereilhac","Serein","Seremange-Erzange","Serent","Serezin-de-la-Tour","Serezin-du-Rhone","Sergeac","Sergy","Serifontaine","Serignan","Serignan-du-Comtat","Serigne","Sermaises","Sermamagny","Sermerieu","Sermoise","Sermoyer","Sernhac","Serocourt","Seronville","Serques","Serquigny","Serre-les-Sapins","Serres","Serres-Castet","Serres-Gaston","Serres-Morlaas","Serres-Sainte-Marie","Serres-sur-Arget","Serrieres","Serrieres-de-Briord","Serrieres-en-Chautagne","Serris","Serrouville","Sers","Servais","Servance","Servant","Servas","Servaville-Salmonville","Servian","Servon","Servon-sur-Vilaine","Sery","Sery-les-Mezieres","Sessenheim","Seugy","Seuil","Seuillet","Seurre","Sevelinges","Severac","Severac-le-Chateau","Seveux","Sevran","Sevres-Anxaumont","Sevrey","Sevrier","Sewen","Sexey-aux-Forges","Seyches","Seyne-les-Alpes","Seynod","Seyre","Seyssel","Seysses","Seyssinet","Seyssinet-Pariset","Seyssins","Seyssuel","Sezanne","Sibiril","Siccieu-Saint-Julien-et-Carisieu","Siegen","Sierck-les-Bains","Sierentz","Sierville","Sigean","Sigloy","Signes","Signy","Signy-Signets","Signy-le-Petit","Sigogne","Sigoules","Sigournais","Sigy-en-Bray","Silfiac","Sillans","Sille-le-Guillaume","Sillery","Sillingy","Silly-Tillard","Silly-la-Poterie","Silly-le-Long","Silly-sur-Nied","Simandre","Simandres","Simiane-Collongue","Simorre","Sin-le-Noble","Sinard","Sinceny","Sion-les-Mines","Siran","Sireuil","Siros","Sisco","Sissonne","Sissy","Sisteron","Sivry-Courtry","Sivry-sur-Meuse","Six-Fours-les-Plages","Sizun","Smarves","Sochaux","Soignolles-en-Brie","Soing-Cubry-Charentenay","Soissons","Soissons-sur-Nacey","Soisy-sous-Montmorency","Soisy-sur-Ecole","Soisy-sur-Seine","Soize","Solaize","Solaro","Solers","Solesmes","Solesmes","Soleymieux","Solferino","Solgne","Soliers","Solignac","Solignac-sous-Roche","Solignac-sur-Loire","Soligny-la-Trappe","Sollies-Pont","Sollies-Toucas","Sollies-Ville","Sologny","Somain","Sombacour","Sombernon","Somloire","Sommaing","Somme","Sommecaise","Sommedieue","Sommelonne","Sommerance","Sommervieu","Sommerviller","Sommieres","Sommieres-du-Clain","Sonchamp","Sondernach","Songeons","Sonnac-sur-l'Hers","Sonnay","Sonnaz","Sonzay","Soorts-Hossegor","Sorbey","Sorbiers","Sorcy-Saint-Martin","Sore","Sorede","Sorel-Moussel","Sorel-en-Vimeu","Soreze","Sorges","Sorgues","Sorigny","Sormonne","Sornay","Sorquainville","Sorrus","Sort-en-Chalosse","Sospel","Sottevast","Sotteville","Sotteville-lès-Rouen","Sotteville-sur-Mer","Souastre","Soubise","Soublecause","Souchez","Soucht","Soucieu-en-Jarrest","Soucy","Soudan","Soues","Souesmes","Souffelweyersheim","Soufflenheim","Sougy","Sougy-sur-Loire","Souilhanels","Souillac","Soulac-sur-Mer","Soulaincourt","Soulaines-Dhuys","Soulaines-sur-Aubance","Soulaire-et-Bourg","Soulanges","Soulangis","Soulge-sur-Ouette","Soulieres","Souligne-sous-Ballon","Soulitre","Soullans","Soultz-Haut-Rhin","Soultz-sous-Forets","Soultzeren","Soultzmatt","Soulvache","Soumeras","Soumoulou","Souppes-sur-Loing","Souprosse","Souraide","Sourcieux-les-Mines","Sourdeval","Sourdon","Sourdun","Sourribes","Sours","Souspierre","Soustons","Souvans","Souvigne","Souvigne-sur-Sarthe","Souvigny","Souvigny-en-Sologne","Souzay-Champigny","Souzy","Souzy-la-Briche","Soyaux","Soyers","Soyons","Spay","Spechbach-le-Bas","Spechbach-le-Haut","Speracedes","Spezet","Spicheren","Spincourt","Sponville","Spycker","Squiffiec","St Chamas","St Laurent des Arbres","St-Malo","Staffelfelden","Stains","Steenbecque","Steenvoorde","Steenwerck","Steige","Steinbach","Steinbourg","Stella-Plage","Stenay","Still","Stiring-Wendel","Stosswihr","Strasbourg","Strazeele","Strueth","Succieu","Suce-sur-Erdre","Sucy-en-Brie","Suhescun","Suin","Suippes","Sully-la-Chapelle","Sully-sur-Loire","Sulniac","Sundhoffen","Supt","Surat","Surba","Suresnes","Surgeres","Surgy","Surin","Surques","Surtainville","Surville","Surville","Survilliers","Sury-en-Vaux","Sury-le-Comtal","Surzur","Sus","Sussargues","Suzanne","Suze-la-Rousse","Sète","Sèvres","Sélestat","Tabanac","Tacoignieres","Taden","Taglio-Isolaccio","Tagnon","Taillades","Taillebourg","Taillis","Tailly","Tain-l'Hermitage","Taintrux","Taissy","Taize-Aizie","Tajan","Talange","Talant","Talence","Talensac","Tallard","Tallende","Taller","Talloires","Tallud-Sainte-Gemme","Talon","Taluyers","Tamnay-en-Bazois","Tancrou","Taninges","Tanneron","Taradeau","Tarare","Tarascon","Tarascon-sur-Ariege","Tarbes","Tarcenay","Tarentaise","Targassonne","Targon","Tarnes","Tarnos","Tartaras","Tartas","Tartigny","Tassille","Tassin-la-Demi-Lune","Tatinghem","Taule","Taulignan","Taupont","Tauriac","Tauriac-de-Camares","Tautavel","Tauxieres-Mutry","Tauxigny","Tavaux","Tavel","Tavera","Tavernes","Taverny","Tavers","Tavey","Tayrac","Tecou","Teillet-Argenty","Teissieres-de-Cornet","Telgruc-sur-Mer","Teloche","Templemars","Templeuve","Tence","Tende","Tendon","Terce","Tercis-les-Bains","Terdeghem","Tergnier","Ternand","Ternay","Ternay","Terrasson-Lavilledieu","Terraube","Terrebasse","Terssac","Terves","Terville","Tessy-sur-Vire","Teteghem","Teuillac","Teurtheville-Hague","Teyjat","Teyran","Thaims","Thaire","Thal-Drulingen","Thann","Thaon","Thaon-les-Vosges","Thauron","Theding","Thegra","Theil-sur-Vanne","Theillay","Theix","Theize","Thelus","Themericourt","Thenay","Thenelles","Thenezay","Thenissey","Thennelieres","Thennes","Thenon","Theoule-sur-Mer","Therdonne","Therouanne","Theuville","Theuville-aux-Maillots","Theys","Thezan-les-Beziers","Theze","Theziers","Thezy-Glimont","Thiais","Thiant","Thiberville","Thiefosse","Thiergeville","Thiers","Thiers-sur-Theve","Thierville","Thierville-sur-Meuse","Thietreville","Thieuloy-Saint-Antoine","Thieville","Thil","Thil","Thilay","Thilouze","Thimert-Gatelles","Thimory","Thin-le-Moutier","Thionville","Thise","Thivars","Thivencelle","Thiverval-Grignon","Thiviers","Thizy-les-Bourgs","Thodure","Thoirette","Thoiry","Thoiry","Thoissey","Thomery","Thones","Thonnance-les-Joinville","Thonon-les-Bains","Thoraise","Thorens-Glieres","Thorigne-d'Anjou","Thorigny","Thorigny-sur-Marne","Thou","Thouare-sur-Loire","Thouars","Thourotte","Thoux","Thuir","Thuit-Hebert","Thulay","Thumeries","Thun-Saint-Amand","Thun-l'Eveque","Thurageau","Thure","Thuret","Thurins","Thury-Harcourt","Thusy","Thyez","Tierce","Tiercelet","Tigery","Tignes","Tignieu-Jameyzieu","Tigy","Til-Chatel","Tillay-le-Peneux","Tille","Tillenay","Tillieres","Tillieres-sur-Avre","Tilloy-et-Bellay","Tilloy-lez-Cambrai","Tilloy-lez-Marchiennes","Tilly-sur-Meuse","Tilques","Tinchebray","Tincques","Tincry","Tinqueux","Tinteniac","Tiranges","Tirepied","Tivernon","Tocqueville","Tocqueville","Tocqueville-en-Caux","Tollevast","Tombeboeuf","Tomblaine","Tonnay-Boutonne","Tonnay-Charente","Tonneins","Tonnerre","Tonnoy","Torce-en-Vallee","Torcieu","Torcy","Torcy","Torcy-le-Grand","Torderes","Torfou","Torigni-sur-Vire","Torpes","Torreilles","Torsac","Torvilliers","Torxe","Tosse","Tossiat","Totes","Touchay","Toucy","Toudon","Toufflers","Toul","Toulaud","Toulenne","Toulon","Toulon-sur-Arroux","Toulouges","Toulouse","Toulouzette","Toulx-Sainte-Croix","Touques","Touquin","Tour-en-Sologne","Tourbes","Tourcoing","Tourgeville","Tourlaville","Tourly","Tournan-en-Brie","Tournay-sur-Odon","Tournecoupe","Tournedos-Bois-Hubert","Tournefeuille","Tournehem-sur-la-Hem","Tournieres","Tournoisis","Tournon-Saint-Martin","Tournon-sur-Rhône","Tournus","Tourouvre","Tourrette-Levens","Tourrettes-sur-Loup","Tourriers","Tours","Tours-en-Savoie","Tours-sur-Marne","Tours-sur-Meymont","Tourtrol","Tourves","Tourville-en-Auge","Tourville-la-Campagne","Tourville-la-Chapelle","Tourville-la-Riviere","Tourville-les-Ifs","Tourville-sur-Odon","Tourville-sur-Sienne","Toury","Toussaint","Toussieu","Toussieux","Toussus-le-Noble","Toutlemonde","Touville","Touvois","Touvre","Touzac","Tracy-le-Mont","Tracy-le-Val","Tracy-sur-Loire","Traenheim","Trainel","Trainou","Tramole","Tramoyes","Trange","Trans-en-Provence","Trappes","Traubach-le-Bas","Trausse","Travecy","Treauville","Trebes","Trebeurden","Trebry","Treclun","Tredarzec","Treduder","Treffendel","Treffieux","Trefflean","Treffort","Treffrin","Treflez","Tregarantec","Tregastel","Treglamus","Tregourez","Treguidel","Tregunc","Treignac","Treillieres","Treize-Septiers","Trelaze","Trelevern","Trelissac","Trelivan","Trelly","Trelon","Tremblay","Tremblay","Tremel","Trementines","Tremery","Tremeven","Tremilly","Tremons","Tremont-sur-Saulx","Tremuson","Treon","Trepied","Trept","Tresilley","Tresques","Tressan","Tressange","Tresserve","Tresses","Trets","Treuzy-Levelay","Treve","Treveneuc","Treveray","Treverien","Treves","Trevien","Trevignin","Trevoux","Trezioux","Triaize","Tricot","Trie-Chateau","Trie-sur-Baise","Triel-sur-Seine","Trieux","Trigavou","Trignac","Trigueres","Trilbardou","Trilport","Triors","Trith-Saint-Leger","Trizac","Trizay","Troarn","Troche","Trogues","Troissereux","Troissy","Troisvilles","Tronville-en-Barrois","Trosly-Breuil","Trouhans","Trouillas","Trouley-Labarthe","Troussencourt","Troussey","Trouville","Trouville-la-Haule","Trouville-sur-Mer","Trouy","Troyes","Troyon","Truchtersheim","Trumilly","Truyes","Tréguier","Tubersent","Tuchan","Tucquegnieux","Tuffe","Tulle","Tullins","Tupigny","Turckheim","Turquant","Tursac","Tuzaguet","Uberach","Uchacq-et-Parentis","Uchaud","Uchaux","Uckange","Ueberstrass","Ugine","Ugny-sur-Meuse","Uhrwiller","Ully-Saint-Georges","Umpeau","Undurein","Ungersheim","Unieux","Ur","Urbeis","Urcay","Urcel","Urcuit","Urdos","Uriage-les-Bains","Urmatt","Urou-et-Crennes","Urrugne","Urt","Uruffe","Urval","Urville-Nacqueville","Ury","Urzy","Us","Ussac","Usseau","Ussel","Usson-du-Poitou","Ussy","Ustaritz","Utelle","Uvernet-Fours","Uxegney","Uxem","Uzein","Uzerche","Uzos","Uzès","Vaas","Vabres-l'Abbaye","Vacheresse","Vacognes-Neuilly","Vacon","Vacquieres","Vacquiers","Vadenay","Vadencourt","Vagney","Vahl-les-Benestroff","Vailhauques","Vaillant","Vailly","Vailly","Vailly-sur-Aisne","Vailly-sur-Sauldre","Vaire","Vaire-sous-Corbie","Vaires-sur-Marne","Vaison-la-Romaine","Vaissac","Vaivre-et-Montoille","Val d'Isère","Val-dIzé","Val-de-Fier","Val-de-la-Haye","Val-et-Chatillon","Valaire","Valay","Valberg","Valbonne","Valcourt","Valdahon","Valdampierre","Valdoie","Valdurenque","Valencay","Valence","Valence","Valence-d'Albigeois","Valence-sur-Baise","Valenciennes","Valencin","Valencogne","Valensole","Valentigney","Valenton","Valescourt","Valff","Valflaunes","Valines","Vallangoujard","Vallans","Vallant-Saint-Georges","Vallauris","Valle-di-Mezzana","Vallegue","Valleiry","Valleraugue","Valleres","Vallerois-Lorioz","Valleroy-le-Sec","Vallesvilles","Vallet","Vallier","Valliguieres","Valliquerville","Vallon-Pont-d'Arc","Vallon-en-Sully","Vallouise","Valmestroff","Valmondois","Valmont","Valmont","Valmy","Valognes","Valpuiseaux","Valras-Plage","Valreas","Valros","Vals-les-Bains","Vals-pres-le-Puy","Vanclans","Vandieres","Vandoeuvre-les-Nancy","Vandoncourt","Vandre","Vandrimare","Vandy","Vannes","Vanosc","Vantoux","Vanves","Vanville","Vanzac","Varades","Varages","Varaignes","Varaize","Varanges","Varangeville","Varaville","Varces-Allieres-et-Risset","Varen","Varennes","Varennes","Varennes-Jarcy","Varennes-Vauzelles","Varennes-en-Argonne","Varennes-le-Grand","Varennes-les-Macon","Varennes-sous-Dun","Varennes-sur-Allier","Varennes-sur-Loire","Varennes-sur-Seine","Varesnes","Varetz","Varilhes","Varinfroy","Varois-et-Chaignot","Varrains","Varreddes","Vars","Vars","Varsberg","Varzay","Varzy","Vascœuil","Vasles","Vassel","Vasselay","Vassy","Vasteville","Vatan","Vathimenil","Vatimesnil","Vauban","Vaubecourt","Vauchamps","Vauchelles","Vauchelles-les-Domart","Vauchelles-les-Quesnoy","Vauchonvilliers","Vaucouleurs","Vaucresson","Vaudebarrier","Vaudemange","Vaudesson","Vaudeville","Vaudoy-en-Brie","Vaudreching","Vaudrey","Vaugneray","Vaugrigneuse","Vauhallan","Vaujours","Vaulry","Vault-de-Lugny","Vaulx-Milieu","Vaulx-en-Velin","Vaumas","Vaumoise","Vaumort","Vaureal","Vaureilles","Vauvert","Vauville","Vauvillers","Vaux-en-Bugey","Vaux-la-Petite","Vaux-le-Penil","Vaux-les-Pres","Vaux-les-Saint-Claude","Vaux-sur-Aure","Vaux-sur-Blaise","Vaux-sur-Eure","Vaux-sur-Mer","Vaux-sur-Poligny","Vaux-sur-Seine","Vauxbuin","Vauxtin","Vaxoncourt","Vay","Vayrac","Vayres","Veauche","Veaugues","Vecoux","Vecquemont","Vecqueville","Vedene","Veho","Veigne","Veigy-Foncenex","Velaine-en-Haye","Velaines","Velars-sur-Ouche","Velaux","Velines","Velle-le-Chatel","Velleches","Velleminfroy","Velleron","Velotte-et-Tatignecourt","Velye","Velzic","Vemars","Venables","Venansault","Venant","Venarey-les-Laumes","Venasque","Vence","Vendargues","Vendat","Vendays-Montalivet","Vendegies-sur-Ecaillon","Vendemian","Vendenheim","Vendeuil-Caply","Vendeuvre-du-Poitou","Vendeville","Vendin-le-Vieil","Vendin-les-Bethune","Vendome","Vendrennes","Vendres","Venejan","Venelles","Venerand","Venerque","Venette","Veneux-les-Sablons","Venizel","Venizy","Vennecy","Venon","Venoy","Ventabren","Ventes-Saint-Remy","Venteuil","Venthon","Ventiseri","Ver-sur-Launette","Verac","Verargues","Verberie","Verchaix","Verchamp","Verchin","Verdelais","Verderonne","Verdon","Verdun","Verdun-en-Lauragais","Verdun-sur-Garonne","Verdun-sur-le-Doubs","Veretz","Verfeil","Vergeze","Vergongheon","Vergt","Veria","Verigny","Verines","Verjux","Verlinghem","Vermand","Vermelles","Vermenton","Vern-d'Anjou","Vern-sur-Seiche","Vernaison","Verne","Verne","Vernegues","Verneil-le-Chetif","Vernet-les-Bains","Verneugheol","Verneuil","Verneuil-en-Bourbonnais","Verneuil-en-Halatte","Verneuil-l'Etang","Verneuil-sous-Coucy","Verneuil-sur-Avre","Verneuil-sur-Seine","Verneuil-sur-Vienne","Vernierfontaine","Vernines","Verniolle","Vernioz","Vernon","Vernon","Vernosc-les-Annonay","Vernou-sur-Brenne","Vernouillet","Vernouillet","Vernoux-en-Vivarais","Verny","Veron","Verpillieres","Verquieres","Verquigneul","Verquin","Verrey-sous-Salmaise","Verrieres","Verrieres","Verrieres-le-Buisson","Vers","Vers-Pont-du-Gard","Vers-en-Montagne","Vers-sur-Selles","Versailles","Versailleux","Versigny","Verson","Versonnex","Vert","Vert-Saint-Denis","Vert-en-Drouais","Vert-le-Grand","Vert-le-Petit","Vertaizon","Verthemex","Vertolaye","Verton","Vertou","Vertrieu","Vertus","Vervezelle","Vervins","Very","Verze","Verzeille","Verzenay","Vescovato","Vesigneul-sur-Coole","Vesly","Vesoul","Vestric-et-Candiac","Vetheuil","Vetraz-Monthoux","Veuil","Veurey-Voroize","Veynes","Veyrac","Veyras","Veyre-Monton","Veyrier-du-Lac","Veyrignac","Vezac","Vezelise","Vezenobres","Vezezoux","Vezin-le-Coquet","Vezins","Viabon","Vialas","Vianne","Viarmes","Vias","Vibersviller","Vibraye","Vic-Fezensac","Vic-en-Bigorre","Vic-la-Gardiole","Vic-le-Comte","Vic-le-Fesq","Vic-sur-Aisne","Vic-sur-Cere","Vic-sur-Seille","Vichy","Vico","Vicq","Vicq-d'Auribat","Vidauban","Videix","Vieille-Brioude","Vieille-Eglise","Vieille-Eglise-en-Yvelines","Vieillevigne","Vieillevigne","Vieilley","Vielle-Saint-Girons","Vielle-Tursan","Viellespeze","Vielmur-sur-Agout","Viels-Maisons","Vienne","Vienville","Vierville","Vierzon","Viesly","Viessoix","Vieux","Vieux","Vieux Conde","Vieux-Berquin","Vieux-Boucau-les-Bains","Vieux-Charmont","Vieux-Conde","Vieux-Ferrette","Vieux-Fume","Vieux-Manoir","Vieux-Moulin","Vieux-Rouen-sur-Bresle","Vieux-Thann","Vif","Vigeois","Vignacourt","Vignes","Vignes","Vigneulles","Vigneulles-les-Hattonchatel","Vigneux-de-Bretagne","Vigneux-sur-Seine","Vignoc","Vignolles","Vignols","Vignonet","Vignot","Vigny","Vigny","Vigny","Vigoulet-Auzil","Vigouroux","Vigueron","Vigy","Vihiers","Vilallonga dels Monts","Villabe","Villabon","Villacourt","Village-Neuf","Villaines-la-Juhel","Villaines-les-Rochers","Villaines-sous-Bois","Villaines-sous-Luce","Villaines-sous-Malicorne","Villamblard","Villamee","Villard","Villard-Bonnot","Villard-Saint-Christophe","Villard-de-Lans","Villard-sur-Doron","Villards","Villargondran","Villaries","Villarlurin","Villars","Villars-Brandis","Villars-Colmars","Villars-en-Pons","Villars-et-Villenotte","Villars-les-Dombes","Villars-sur-Var","Villarzel-Cabardes","Villasavary","Villaz","Ville","Ville","Ville-d'Avray","Ville-du-Pont","Ville-en-Tardenois","Ville-la-Grand","Ville-sous-Anjou","Ville-sur-Cousances","Ville-sur-Jarnioux","Ville-sur-Lumes","Ville-sur-Tourbe","Villebarou","Villebernier","Villeblevin","Villebois-Lavalette","Villebon-sur-Yvette","Villebret","Villebrumier","Villecerf","Villeconin","Villecresnes","Villecroze","Villedieu","Villedieu","Villedieu-les-Poeles","Villedomer","Villedoux","Villefagnan","Villefontaine","Villefranche-d'Albigeois","Villefranche-d'Allier","Villefranche-de-Lauragais","Villefranche-de-Rouergue","Villefranche-du-Queyran","Villefranche-le-Chateau","Villefranche-sur-Cher","Villefranche-sur-Mer","Villefranche-sur-Saône","Villefranque","Villegailhenc","Villegats","Villegouge","Villejesus","Villejoubert","Villejuif","Villejust","Villelaure","Villelongue-de-la-Salanque","Villemandeur","Villemarechal","Villembray","Villemeux-sur-Eure","Villemoirieu","Villemoisson-sur-Orge","Villemolaque","Villemomble","Villemort","Villemotier","Villemoustaussou","Villemoyenne","Villemur","Villemur-sur-Tarn","Villemurlin","Villenauxe-la-Grande","Villenave","Villenave-d'Ornon","Villeneuve","Villeneuve","Villeneuve les beziers","Villeneuve-Frouville","Villeneuve-Lecussan","Villeneuve-Loubet","Villeneuve-Minervois","Villeneuve-Saint-Georges","Villeneuve-Saint-Germain","Villeneuve-Tolosane","Villeneuve-au-Chemin","Villeneuve-d'Olmes","Villeneuve-de-Berg","Villeneuve-de-Duras","Villeneuve-de-Marc","Villeneuve-de-Marsan","Villeneuve-de-la-Raho","Villeneuve-des-Escaldes","Villeneuve-la-Garenne","Villeneuve-la-Guyard","Villeneuve-la-Riviere","Villeneuve-le-Comte","Villeneuve-le-Roi","Villeneuve-les-Avignon","Villeneuve-les-Bouloc","Villeneuve-les-Genets","Villeneuve-les-Maguelone","Villeneuve-les-Sablons","Villeneuve-sur-Allier","Villeneuve-sur-Fere","Villeneuve-sur-Lot","Villeneuve-sur-Yonne","Villennes-sur-Seine","Villenouvelle","Villenoy","Villeny","Villeparisis","Villeperdue","Villepinte","Villepinte","Villepreux","Villequier-Aumont","Villerable","Villerest","Villermain","Villeron","Villers","Villers","Villers-Allerand","Villers-Bocage","Villers-Bocage","Villers-Bretonneux","Villers-Canivet","Villers-Cotterêts","Villers-Farlay","Villers-Helon","Villers-Outreaux","Villers-Plouich","Villers-Pol","Villers-Saint-Frambourg","Villers-Saint-Genest","Villers-Saint-Paul","Villers-Saint-Sepulcre","Villers-Semeuse","Villers-Sire-Nicole","Villers-au-Bois","Villers-au-Tertre","Villers-aux-Vents","Villers-la-Montagne","Villers-le-Lac","Villers-le-Sec","Villers-les-Nancy","Villers-les-Ormes","Villers-les-Pots","Villers-les-Roye","Villers-sous-Preny","Villers-sous-Saint-Leu","Villers-sur-Fere","Villers-sur-Mer","Villers-sur-Meuse","Villers-sur-Port","Villers-sur-Saulnot","Villers-sur-le-Mont","Villersexel","Villerupt","Villerville","Villes-sur-Auzon","Villesequelande","Villesiscle","Villetaneuse","Villetelle","Villeton","Villetrun","Villette","Villette-d'Anthon","Villettes","Villeurbanne","Villevallier","Villevaude","Villeve","Villeveque","Villeveyrac","Villevieux","Villevillon","Villevocance","Villexavier","Villey-Saint-Etienne","Villey-sur-Tille","Villez-sous-Bailleul","Villie-Morgon","Villiers-Adam","Villiers-Couture","Villiers-Saint-Georges","Villiers-au-Bouin","Villiers-en-Desoeuvre","Villiers-en-Plaine","Villiers-le-Bacle","Villiers-le-Bel","Villiers-le-Mahieu","Villiers-sous-Grez","Villiers-sur-Chize","Villiers-sur-Marne","Villiers-sur-Morin","Villiers-sur-Orge","Villiers-sur-Seine","Villiers-sur-Tholon","Villieu-Loyes-Mollon","Villing","Villons-les-Buissons","Villorceau","Villotte-sur-Aire","Villy-Bocage","Villy-le-Bouveret","Villy-le-Pelloux","Vimines","Vimory","Vimoutiers","Vimy","Vinassan","Vinay","Vinca","Vincelles","Vincelles","Vincennes","Vincent","Vincey","Vincly","Vindelle","Vineuil","Vineuil","Vineuil-Saint-Firmin","Vinneuf","Vinon-sur-Verdon","Vinzelles","Vinzier","Viodos-Abense-de-Bas","Violaines","Violay","Viomenil","Vion","Vion","Viplaix","Vire","Vire","Virelade","Vireux-Molhain","Vireux-Wallerand","Virey-le-Grand","Viriat","Virieu-le-Grand","Virignin","Viriville","Viroflay","Virville","Viry","Viry","Viry-Châtillon","Viry-Noureuil","Vitrac","Vitrac-Saint-Vincent","Vitreux","Vitrimont","Vitrolles","Vitry-aux-Loges","Vitry-en-Artois","Vitry-en-Perthois","Vitry-la-Ville","Vitry-le-François","Vitry-sur-Orne","Vitry-sur-Seine","Vitré","Vitteaux","Vittel","Vittersbourg","Viuz-en-Sallaz","Viven","Vivier","Vivier-au-Court","Vivieres","Viviers","Viviers-du-Lac","Viviers-les-Montagnes","Viviez","Vivonne","Vivy","Vix","Vizille","Vocance","Voglans","Voillecomte","Voiron","Voisin","Voisins-le-Bretonneux","Voissant","Vollore-Ville","Volmerange-les-Boulay","Volmerange-les-Mines","Volonne","Volvic","Volx","Vonnas","Voreppe","Vorey","Vorges","Vosne-Romanée","Vouel","Vouhe","Vouille","Vouille-les-Marais","Vouillers","Voujeaucourt","Voulangis","Voultegon","Voulton","Voulx","Vouneuil-sous-Biard","Vouneuil-sur-Vienne","Vourey","Vourles","Voutezac","Voutre","Vouvant","Vouvray","Vouzan","Vouzeron","Vouziers","Vouzon","Vouzy","Voves","Vraiville","Vraux","Vred","Vriange","Vrigne-aux-Bois","Vrigny","Vritz","Vue","Vulaines-sur-Seine","Vulbens","Vélizy-Villacoublay","Vénissieux","Wahagnies","Wahlenheim","Wail","Wailly","Wailly-Beaucamp","Waldhouse","Waldighofen","Waldweistroff","Waldwisse","Walheim","Wallers","Walscheid","Wambaix","Wambercourt","Wambrechies","Wandignies-Hamage","Wangen","Wangenbourg-Engenthal","Wanquetin","Warcq","Warendin","Wargnies-le-Petit","Warhem","Warlaing","Warlus","Warluzel","Warmeriville","Warnecourt","Wasnes-au-Bac","Wasquehal","Wasselonne","Wassy","Watten","Wattignies","Wattrelos","Wattwiller","Wavignies","Waville","Wavrechain-sous-Denain","Wavrechain-sous-Faulx","Wavrin","Waziers","Weislingen","Weitbruch","Wentzwiller","Werentzhouse","Wervicq-Sud","Westbecourt","Westhoffen","Westhouse","Weyersheim","Wickerschwihr","Widensolen","Wierre-Effroy","Wignehies","Wihr-au-Val","Wildersbach","Willems","Willencourt","Willer-sur-Thur","Willerwald","Willgottheim","Wimereux","Wimille","Wingen-sur-Moder","Wingersheim","Wingles","Winnezeele","Wintersbourg","Wintzenbach","Wintzenheim","Wintzfelden","Wirwignes","Wissant","Wissembourg","Wissignicourt","Wissous","Witry-les-Reims","Wittelsheim","Wittenheim","Witternheim","Wittersdorf","Wittersheim","Wittes","Wittisheim","Wiwersheim","Wizernes","Woerth","Woincourt","Woippy","Wolfgantzen","Wolfisheim","Wolschheim","Wolxheim","Wormhout","Woustviller","Wuenheim","Xaintray","Xanton-Chassenon","Xertigny","Xures","Yaucourt-Bussus","Ychoux","Ydes","Yebleron","Yebles","Yenne","Yermenonville","Yerres","Yerville","Yevre-la-Ville","Yffiniac","Ygos-Saint-Saturnin","Ygrande","Ymare","Youx","Yport","Ypreville-Biville","Yronde-et-Buron","Yssac-la-Tourette","Yssandon","Yssingeaux","Ytrac","Yversay","Yves","Yvetot","Yvette","Yvias","Yvoire","Yvrac","Yvrac-et-Malleyrand","Yvre-l'Eveque","Yzernay","Yzeure","Yzeures-sur-Creuse","Yzosse","Zellwiller","Zillisheim","Zimmersheim","Zimming","Zinswiller","Zittersheim","Zouafques","Zutzendorf","el Volo","els Banys de la Presta","la Roca d'Albera","Échirolles","Élancourt","Épernay","Épinal","Épinay-sur-Orge","Épinay-sur-Seine","Étain","Étampes","Étaples","Étretat","Évian-les-Bains","Évreux","Évry"];
    var webTv_shortMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    var webTv_languages_list = ['aa', 'ab', 'ace', 'ach', 'ada', 'ady', 'ae', 'af', 'afh', 'agq', 'ain', 'ak', 'akk', 'ale', 'alt', 'am', 'an', 'ang', 'anp', 'ar', 'ar_001', 'arc', 'arn', 'arp', 'arw', 'as', 'asa', 'ast', 'av', 'awa', 'ay', 'az', 'ba', 'bal', 'ban', 'bas', 'bax', 'bbj', 'be', 'bej', 'bem', 'bez', 'bfd', 'bg', 'bgn', 'bho', 'bi', 'bik', 'bin', 'bkm', 'bla', 'bm', 'bn', 'bo', 'br', 'bra', 'brx', 'bs', 'bss', 'bua', 'bug', 'bum', 'byn', 'byv', 'ca', 'cad', 'car', 'cay', 'cch', 'ce', 'ceb', 'cgg', 'ch', 'chb', 'chg', 'chk', 'chm', 'chn', 'cho', 'chp', 'chr', 'chy', 'ckb', 'co', 'cop', 'cr', 'crh', 'cs', 'csb', 'cu', 'cv', 'cy', 'da', 'dak', 'dar', 'dav', 'de', 'de_AT', 'de_CH', 'del', 'den', 'dgr', 'din', 'dje', 'doi', 'dsb', 'dua', 'dum', 'dv', 'dyo', 'dyu', 'dz', 'dzg', 'ebu', 'ee', 'efi', 'egy', 'eka', 'el', 'elx', 'en', 'en_AU', 'en_CA', 'en_GB', 'en_US', 'enm', 'eo', 'es', 'es_419', 'es_ES', 'es_MX', 'et', 'eu', 'ewo', 'fa', 'fan', 'fat', 'ff', 'fi', 'fil', 'fj', 'fo', 'fon', 'fr', 'fr_CA', 'fr_CH', 'frm', 'fro', 'frp', 'frr', 'frs', 'fur', 'fy', 'ga', 'gaa', 'gag', 'gay', 'gba', 'gd', 'gez', 'gil', 'gl', 'gmh', 'gn', 'goh', 'gon', 'gor', 'got', 'grb', 'grc', 'gsw', 'gu', 'guz', 'gv', 'gwi', 'ha', 'hai', 'haw', 'he', 'hi', 'hil', 'hit', 'hmn', 'ho', 'hr', 'hsb', 'ht', 'hu', 'hup', 'hy', 'hz', 'ia', 'iba', 'ibb', 'id', 'ie', 'ig', 'ii', 'ik', 'ilo', 'inh', 'io', 'is', 'it', 'iu', 'ja', 'jbo', 'jgo', 'jmc', 'jpr', 'jrb', 'jv', 'ka', 'kaa', 'kab', 'kac', 'kaj', 'kam', 'kaw', 'kbd', 'kbl', 'kcg', 'kde', 'kea', 'kfo', 'kg', 'kha', 'kho', 'khq', 'ki', 'kj', 'kk', 'kkj', 'kl', 'kln', 'km', 'kmb', 'kn', 'ko', 'koi', 'kok', 'kos', 'kpe', 'kr', 'krc', 'krl', 'kru', 'ks', 'ksb', 'ksf', 'ksh', 'ku', 'kum', 'kut', 'kv', 'kw', 'ky', 'la', 'lad', 'lag', 'lah', 'lam', 'lb', 'lez', 'lg', 'li', 'lkt', 'ln', 'lo', 'lol', 'loz', 'lrc', 'lt', 'lu', 'lua', 'lui', 'lun', 'luo', 'lus', 'luy', 'lv', 'mad', 'maf', 'mag', 'mai', 'mak', 'man', 'mas', 'mde', 'mdf', 'mdr', 'men', 'mer', 'mfe', 'mg', 'mga', 'mgh', 'mgo', 'mh', 'mi', 'mic', 'min', 'mk', 'ml', 'mn', 'mnc', 'mni', 'moh', 'mos', 'mr', 'ms', 'mt', 'mua', 'mul', 'mus', 'mwl', 'mwr', 'my', 'mye', 'myv', 'mzn', 'na', 'nap', 'naq', 'nb', 'nd', 'nds', 'nds_NL', 'ne', 'new', 'ng', 'nia', 'niu', 'nl', 'nl_BE', 'nmg', 'nn', 'nnh', 'no', 'nog', 'non', 'nqo', 'nr', 'nso', 'nus', 'nv', 'nwc', 'ny', 'nym', 'nyn', 'nyo', 'nzi', 'oc', 'oj', 'om', 'or', 'os', 'osa', 'ota', 'pa', 'pag', 'pal', 'pam', 'pap', 'pau', 'peo', 'phn', 'pi', 'pl', 'pon', 'pro', 'ps', 'pt', 'pt_BR', 'pt_PT', 'qu', 'quc', 'raj', 'rap', 'rar', 'rm', 'rn', 'ro', 'ro_MD', 'rof', 'rom', 'root', 'ru', 'rup', 'rw', 'rwk', 'sa', 'sad', 'sah', 'sam', 'saq', 'sas', 'sat', 'sba', 'sbp', 'sc', 'scn', 'sco', 'sd', 'sdh', 'se', 'see', 'seh', 'sel', 'ses', 'sg', 'sga', 'sh', 'shi', 'shn', 'shu', 'si', 'sid', 'sk', 'sl', 'sm', 'sma', 'smj', 'smn', 'sms', 'sn', 'snk', 'so', 'sog', 'sq', 'sr', 'srn', 'srr', 'ss', 'ssy', 'st', 'su', 'suk', 'sus', 'sux', 'sv', 'sw', 'sw_CD', 'swb', 'syc', 'syr', 'ta', 'te', 'tem', 'teo', 'ter', 'tet', 'tg', 'th', 'ti', 'tig', 'tiv', 'tk', 'tkl', 'tl', 'tlh', 'tli', 'tmh', 'tn', 'to', 'tog', 'tpi', 'tr', 'trv', 'ts', 'tsi', 'tt', 'tum', 'tvl', 'tw', 'twq', 'ty', 'tyv', 'tzm', 'udm', 'ug', 'uga', 'uk', 'umb', 'und', 'ur', 'uz', 'vai', 've', 'vi', 'vo', 'vot', 'vun', 'wa', 'wae', 'wal', 'war', 'was', 'wbp', 'wo', 'xal', 'xh', 'xog', 'yao', 'yap', 'yav', 'ybb', 'yi', 'yo', 'yue', 'za', 'zap', 'zbl', 'zen', 'zgh', 'zh', 'zh_Hans', 'zh_Hant', 'zu', 'zun', 'zxx', 'zza'];
    var webTv_languages_list_mini = ['fr', 'en', 'it', 'es'];

    var dtable_language = {
        fr: {
            "sProcessing": "Traitement en cours...",
            "sSearch": "Rechercher&nbsp;:",
            "sLengthMenu":"<span class='info-menu'>Afficher</span> _MENU_ <span class='info-menu'>&eacute;l&eacute;ments</span>",
            "sInfo": " _START_ - _END_ sur _TOTAL_ ",
            "sInfoEmpty": "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ments",
            "sInfoFiltered": "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
            "sInfoPostFix": "",
            "sLoadingRecords": "Chargement en cours...",
            "sZeroRecords": "Aucun &eacute;l&eacute;ment &agrave; afficher",
            "sEmptyTable": "Aucune donn&eacute;e disponible dans le tableau",
            "oPaginate": {
              "sNext":   "<i class='icon-chevron-right'></i>",
              "sPrevious":  "<i class='icon-chevron-left'></i>",
              "sFirst":   "<i class='icon-chevron-double-left'></i>",
              "sLast":    "<i class='icon-chevron-double-right'></i>",
            },
            "oAria": {
                "sSortAscending": ": activer pour trier la colonne par ordre croissant",
                "sSortDescending": ": activer pour trier la colonne par ordre d&eacute;croissant"
            }
        }, en: {
            "sEmptyTable": "No data available in table",
            "sInfo": "_START_ - _END_ of _TOTAL_ entries",
            "sInfoEmpty": "Showing 0 to 0 of 0 entries",
            "sInfoFiltered": "(filtered from _MAX_ total entries)",
            "sInfoPostFix": "",
            "sInfoThousands": ",",
            "sLengthMenu": "<span class='info-menu'>Show</span> _MENU_ <span class='info-menu'>entries</span>",
            "sLoadingRecords": "Loading...",
            "sProcessing": "Processing...",
            "sSearch": "Search:",
            "sZeroRecords": "No matching records found",
            "oPaginate": {
              "sNext":   "<i class='icon-chevron-right'></i>",
              "sPrevious":  "<i class='icon-chevron-left'></i>",
              "sFirst":   "<i class='icon-chevron-double-left'></i>",
              "sLast":    "<i class='icon-chevron-double-right'></i>",
            },
            "oAria": {
                "sSortAscending": ": activate to sort column ascending",
                "sSortDescending": ": activate to sort column descending"
            }
        }
    };
    var datepicker = {
        fr: {
            "data": {
                "months": [
                    "Janvier",
                    "Février",
                    "Mars",
                    "Avril",
                    "Mai",
                    "Juin",
                    "Juillet",
                    "Août",
                    "Septembre",
                    "Octobre",
                    "Novembre",
                    "Décembre"
                ],
                "shortMonths": [
                    "Jan.",
                    "Fév.",
                    "Mar.",
                    "Avr.",
                    "Mai.",
                    "Juin",
                    "Juil",
                    "Août",
                    "Sep.",
                    "Oct.",
                    "Nov.",
                    "Déc."
                ],
                "days": [
                    "Dimanche",
                    "Lundi",
                    "Mardi",
                    "Mercredi",
                    "Jeudi",
                    "Vendredi",
                    "Samedi"
                ],
                "shortDays": [
                    "Dim.",
                    "Lun.",
                    "Mar.",
                    "Mer.",
                    "Jeu.",
                    "Ven.",
                    "Sam."
                ],
                "dates": [
                    null,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31
                ],
                "firstDayOfWeek": 0,
                "msgCalendar": "Calndrier",
                "msgOpenCalendar": "Ouvrir Calendrier",
                "firstRenderableDate": "1980-12-31T23:00:00.000Z",
                "lastRenderableDate": "2100-12-31T23:00:00.000Z",
                "dateFormat": "DD/MM/YYYY",
                "timeFormat": "DD/MM/YYYY HH:mm:ss",
                "LABEL_OK": "Valider",
                "LABEL_CANCEL": "Annuler"
            }
        }, en: {
            "data": {
                "months": [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December"
                ],
                "shortMonths": [
                    "Jan",
                    "Feb",
                    "Mar",
                    "Apr",
                    "May",
                    "Jun",
                    "Jul",
                    "Aug",
                    "Sep",
                    "Oct",
                    "Nov",
                    "Dec"
                ],
                "days": [
                    "Sunday",
                    "Monday",
                    "Tuesday",
                    "Wednesday",
                    "Thursday",
                    "Friday",
                    "Saturday"
                ],
                "shortDays": [
                    "S",
                    "M",
                    "T",
                    "W",
                    "T",
                    "F",
                    "S"
                ],
                "dates": [
                    null,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31
                ],
                "firstDayOfWeek": 0,
                "msgCalendar": "Calendar",
                "msgOpenCalendar": "Open calendar",
                "firstRenderableDate": "1980-12-31T23:00:00.000Z",
                "lastRenderableDate": "2100-12-31T23:00:00.000Z",
                "dateFormat": "YYYY-MM-DD",
                "timeFormat": "YYYY-MM-DD HH:mm:ss",
                "LABEL_OK": "OK",
                "LABEL_CANCEL": "Cancel"
            }
        }

    }
    var webTv_parameterBag = undefined;
    var webTv_min_size_logo = {width: 1280, height:720};

    var action_delete = [];
    action_delete["livesLive_delete"]= "lives_delete_live_action";
    action_delete["lives_deleteLives"]= "lives_multi_delete_action";
    action_delete["parameters_canal_mdelete"]= "parameters_canal_delete_channel_action";
    action_delete["parameters_canal_deleteCanals"]= "parameters_canal_delete_multi_action";
    action_delete["media_video_home_delete"]= "media_video_delete_home_page_action";
    action_delete["podcast_mdelete"]= "podcast_delete_podcast_action";
    action_delete["podcast_deletePodcasts"]= "podcast_multi_delete_action";
    action_delete["schedule_delete"]= "display_schedule_delete_one_action";
    action_delete["abonnement_group_deleteGroups"]= "subscription_group_delete_multi_action";
    action_delete["abonnement_group_mdelete"]= "subscription_group_delete_group_action";
    action_delete["abonnement_group_deleteUsers"]= "subscription_user_delete_multi_action";
    action_delete["abonnement_user_mdelete"]= "subscription_user_delete_user_action";
    action_delete["configuration_rmbox_deleteRmboxs"]= "configuration_rmbox_delete_multi_action";
    action_delete["configuration_rmbox_mdelete"]= "configuration_rmbox_delete_rmbox_action";
    action_delete["configuration_rmbox_intervention_mdelete"]= "configuration_rmbox_delete_intervention_no_api_action";
    action_delete["configuration_rmboxgroup_deleteRmboxgroups"]= "configuration_rmboxgroup_delete_multi_action";
    action_delete["configuration_rmboxgroup_mdelete"]= "configuration_rmboxgroup_delete_rmboxgroup_action";
    action_delete["Configuration_zone_deleteZones"]= "configuration_zone_delete_multi_action";
    action_delete["configuration_zone_mdelete"]= "configuration_zone_delete_zone_action";
    action_delete["parameters_theme_mdelete"]= "parameters_theme_delete_theme_action";
    action_delete["param_mdelete"]= "param_delete_param_action";
    action_delete["param_deleteParams"]= "param_delete_multi_action";
    action_delete["cle_mooc_mdelete"]= "mooc_delete_param_action";
    action_delete["mooc_deleteMoocs"]= "mooc_delete_multi_action";
    action_delete["mooc_deleteMoocs"]= "mooc_delete_multi_action";
    action_delete["configuration_news_mdelete"]= "configuration_newss_delete_new_action";
    action_delete["configuration_news_deleteNewss"]= "configuration_newss_multi_delete_action";
    action_delete["configuration_presets_deletePresets"]= "configuration_presets_delete_multi_action";
    action_delete["configuration_presets_mdelete"]= "configuration_presets_delete_preset_action";
    action_delete["referrers_mdelete"]= "referrers_delete_action";
    action_delete["referrers_deleteReferrers"]= "referrers_delete_multi_action";
    action_delete["configuration_server_mdelete"]= "configuration_server_delete_server_action";
    action_delete["configuration_server_deleteServers"]= "configuration_server_delete_multi_action";
    action_delete["programs_delete"]= "display_template_delete_one_action";
    action_delete["programs_deleteByList"]= "display_template_delete_many_action";
    action_delete["schedule_delete"]= "display_schedule_delete_one_action";
    action_delete["schedule_deleteByList"]= "display_schedule_delete_many_action";
    action_delete["templates_deleteTemplate"]= "display_template_delete_one_action";
    action_delete["template_deleteByList"]= "display_template_delete_many_action";
    action_delete["templates_deleteTemplateNewDisplay"]= "display_new_template_delete_one_action";
    action_delete["template_deleteByListNewDisplay"]= "display_new_template_delete_many_action";
    action_delete["advertising_mdelete"]= "parameters_advertising_delete_multi_action";
    action_delete["advertising_deleteAdvertising"]= "parameters_advertising_delete_advertising_action";
    action_delete["comments_deleteComments"]= "comments_delete_multi_lives_action";
    action_delete["comments_live_mdelete"]= "comments_lives_delete_action";
    action_delete["comments_mdelete"]= "comments_delete_comments_action";
    action_delete["commentsMedia_deleteComments"]= "comments_delete_multi_action";
    action_delete["sondage_mdelete_deleteComments"]= "sondage_delete_survey_action";
    action_delete["sondage_deleteSondages"]= "sondage_delete_multi_action";
    action_delete["eventLive_delete"]= "event_delete_event_live_action";
    action_delete["eventLive_deleteEvents"]= "event_delete_multi_action";
    action_delete["playlist_delete"]= "playlist_delete_playlist_action";
    action_delete["playlist_deletePlaylists"]= "playlist_delete_multi_action";
    action_delete["profiles_group_mdelete"]= "profiles_group_delete_group_action";
    action_delete["profiles_group_deleteGroups"]= "profiles_group_delete_multi_action";
    action_delete["profiles_ip_mdelete"]= "profiles_ip_delete_ips_action";
    action_delete["profiles_ip_deleteIps"]= "profiles_ip_delete_multi_action";
    action_delete["configuration_user_deleteUsers"]= "profiles_user_delete_multi_action";
    action_delete["profiles_user_mdelete"]= "profiles_user_profiles_delete_user_action";
    action_delete["specifics_direction_mdelete"]= "specifics_directions_delete_direction_action";
    action_delete["specifics_direction_deleteDirections"]= "specifics_directions_delete_multi_action";
    action_delete["specifics_iptv_deleteIpTvs"]= "specifics_iptv_delete_multi_action";
    action_delete["specifics_iptv_mdelete"]= "specifics_iptv_delete_iptv_action";
    action_delete["specifics_station_mdelete"]= "specifics_stations_delete_station_action";
    action_delete["specifics_station_deleteStations"]= "specifics_stations_delete_multi_action";

    var webTv_parameterBag_callback = function (callback, $cookies, msApi, requestAgain, anotherCallback, invalidToken, $rootScope) {




        if (angular.isUndefined($cookies.get('authToken'))) return;
        else {
            if (invalidToken) return
        }
        if (angular.isDefined($rootScope.webTv_parameterBag) && angular.isObject($rootScope.webTv_parameterBag) && !requestAgain) {
            if (angular.isFunction(callback)) callback($rootScope.webTv_parameterBag);
            return $rootScope.webTv_parameterBag;
        }
        msApi.request('parametersBag.app@get',
            {},
            function (res) {
                var bag = res.bag;
                if (angular.isObject(bag) && isNotEmpty(bag)) {
                    if (angular.isFunction(callback)) callback(bag);
                    if (angular.isFunction(anotherCallback)) anotherCallback(bag);
                    webTv_parameterBag = bag;
                    $rootScope.webTv_parameterBag = webTv_parameterBag;
                    return;
                }
                return;
            },
            function () {
                webTv_parameterBag = {};
            }
        );


    };
    angular
        .module('app.core')
        .config(config)
        .constant('webTv_languages_list', webTv_languages_list)
        .constant('webTv_languages_list_mini', webTv_languages_list_mini)
        .constant('webTv_shortMonths', webTv_shortMonths)
        .constant('webtv_client_images', webtv_client_images)
        .constant('webtv_client_images_style', webtv_client_images_style)
        .constant('webtv_client_logo_style', webtv_client_logo_style)
        .constant('webtv_client_header_style', webtv_client_header_style)
        .constant('dtable_language', dtable_language)
        .constant('datepicker', datepicker)
        .constant('webtv_clients', webtv_clients)
        .constant('webtv_france_cities', webtv_france_cities)
        .constant('webtv_icons', webtv_icons)
        .constant('webTv_parameterBag_callback', webTv_parameterBag_callback)
        .constant('webTv_min_size_logo', webTv_min_size_logo)
        .constant('action_delete', action_delete)
        .value('webTv_parameterBag', webTv_parameterBag);

    function config(msApiProvider) {
        msApiProvider.register('parametersBag.app', [Routing.generate('api_get_app_parameter_bag')]);

    }
})();




(function () {
    'use strict';    
    var order_video = {"data":{"id":0,"contributor.id":1,"contributor.firstName":2,"contributor.lastName":3,"audioDescription":4,"isVisibleOnInternet":5,"isVisibleOnIntranet":6,"medias.lang":7,"medias.mp4VideoStatus":8,"startDate":9,"endDate":10,"themes.id":11,"themes.title":12,"title":13,"description":14,"logo":15,"fileTitle":16,"duration":17,"externalLinkVideo":18,"isPush":19,"isTranscoded":20,"mainPage":21,"offline":22},"code":200} 
    var order_user = {"data":{"id":0,"firstName":1,"lastName":2,"username":3,"lastLogin":4,"email":5,"description":6,"enabled":7,"group.id":8,"group.name":9,"group.description":10},"code":200} 
    var order_advertising = {"data":{"id":0,"title":1,"logo":2,"link_url":3,"date_start":4,"date_end":5,"active":6,"created_at":7,"updated_at":8},"code":200} 
    var order_channel = {"data":{"id":0,"title":1,"description":2,"language":3,"quota":4,"servers.id":5,"servers.name":6},"code":200} 
    var order_chutier = {"data":{"id":0,"title":1,"isLoop":2,"maxDuration":3,"autoSort":4,"created_at":5,"updated_at":6,"channel.id":7,"channel.title":8},"code":200} 
    var order_direction = {"data":{"id":0,"title":1,"visible":2,"created_at":3,"updated_at":4,"parent.id":5,"parent.title":6},"code":200} 
    var order_iptv = {"data":{"id":0,"image":1,"name":2,"visible":3,"description":4,"linkUrl":5},"code":200} 
    var order_message = {"data":{"id":0,"subject":1,"message":2,"ipUser":3,"client":4,"created_at":5,"user.id":6,"user.firstName":7,"user.lastName":8,"user.username":9},"code":200} 
    var order_param = {"data":{"id":0,"cle":1,"value":2,"created_at":3,"updated_at":4},"code":200} 
    var order_preset = {"data":{"id":0,"name":1,"bitrateVideo":2,"bitrateAudio":3,"samplerateAudio":4,"framerate":5,"state":6,"created_at":7,"updated_at":8},"code":200} 
    var order_rmbox = {"data":{"id":0,"name":1,"ip":2,"mac":3,"postal":4,"created_at":5,"updated_at":6,"group.id":7,"group.name":8},"code":200} 
    var order_rmboxgroup = {"data":{"id":0,"name":1,"bandwidthLimit":2,"syncTime":3},"code":200} 
    var order_server = {"data":{"id":0,"type":1,"internet":2,"record":3,"dir":4,"urlVideo":5,"urlMp4":6,"urlDiffusion":7,"name":8},"code":200} 
    var order_station = {"data":{"id":0,"ip":1,"name":2,"domain":3,"intranetStreamFr":4,"intranetStreamEn":5,"intranetStreamEs":6,"intranetStreamOr":7,"description":8},"code":200} 
    var order_subscriptionGroup = {"data":{"name":0,"parent.name":1,"startDate":2,"endDate":3,"updated_at":4,"modDate":5,"created_at":6},"code":200} 
    var order_subscriptionUser = {"data":{"name":0,"lastName":1,"email":2,"login":3,"protect":4,"group.id":5,"group.name":6},"code":200} 
    var order_survey = {"data":{"id":0,"name":1,"created_at":2,"updated_at":3},"code":200} 
    var order_synchronisation = {"data":{"id":0,"active":1,"nameUser":2,"pwd":3,"urlWp":4,"cookie":5,"httpUser":6,"activeWp":7,"urlImage":8,"urlBoWp":9,"created_at":10,"updated_at":11,"general.id":12,"general.titleBo":13},"code":200} 
    var order_theme = {"data":{"id":0,"title":1,"description":2,"logo":3,"parent.id":4,"parent.title":5,"channels.id":6,"channels.title":7},"code":200} 
    var order_vote = {"data":{"id":0,"vote":1,"created_at":2,"updated_at":3,"question.id":4,"question.question":5,"question.nsp":6,"abonne":7},"code":200} 
    var order_zone = {"data":{"id":0,"name":1,"path":2,"ipStart":3,"ipEnd":4,"bandwidthLimit":5,"zonelimit":6,"usersimultane":7,"bandwidthDisponible":8,"rmbox.id":9,"rmbox.name":10},"code":200} 
    var order_group = {"data":{"id":0,"name":1,"roles":2,"description":3},"code":200} 
    var order_ips = {"data":{"id":0,"ip":1,"description":2},"code":200} 
    var order_program = {"data":{"id":0,"title":1,"duration":2},"code":200} 
    var order_schedule = {"data":{"id":0,"title":1,"startAt":2,"enable":3},"code":200} 
    var order_mooc = {"data":{"id":0,"cle":1,"title":2,"url":3,"created_at":4,"updated_at":5},"code":200} 
    var order_podcast = {"data":{"id":0,"title":1,"description":2,"vignette":3,"lang":4,"podcastCategory":5,"explicite":6,"isReady":7,"created_at":8,"updated_at":9,"created_by.firstName":10,"created_by.lastName":11,"podcastItems.title":12},"code":200} 
    var order_podcastItem = {"data":{"id":0,"title":1,"description":2,"vignette":3,"audio":4,"size":5,"type":6,"podcast.title":7},"code":200} 
    var order_screen = {"data":{"id":0,"title":1,"description":2,"duration":3},"code":200} 
    var order_template = {"data":{"id":0,"title":1,"description":2},"code":200} 
    var order_caption = {"data":{"id":0,"captionOrder":1,"start":2,"end":3,"content":4,"lang":5,"video.id":6,"video.title":7},"code":200} 
    var order_comments = {"data":{"id":0,"comment":1,"user":2,"img":3,"userip":4,"status":5,"email":6,"created_at":7,"updated_at":8,"media.id":9},"code":200} 
    var order_commentsLive = {"data":{"id":0,"comment":1,"user":2,"img":3,"userip":4,"status":5,"email":6,"created_at":7,"updated_at":8,"live.id":9,"live.title":10},"code":200} 
    var order_homeConf = {"data":{"id":0,"pageOption":1,"nbVid":2,"defaultConf":3,"created_at":4,"updated_at":5,"channel.id":6,"channel.title":7,"video.id":8,"video.title":9},"code":200} 
    var order_liveConf = {"data":{"id":0,"message":1,"image":2,"imageText":3,"titleLive":4,"descLive":5,"type":6,"defaultConf":7,"created_at":8,"updated_at":9,"video.id":10,"video.title":11},"code":200} 
    var order_lives = {"data":{"id":0,"thumbnail":1,"title":2,"description":3,"active":4,"dateStart":5,"screenShare":6,"status":7,"survey.name":8},"code":200} 
    var order_media = {"data":{"id":0,"type":1,"lang":2,"dir":3,"smilFile":4,"bdFile":5,"ogvFile":6,"webMFile":7,"link":8,"mp4File":9,"isMp4":10,"isTmpMp4":11,"seenNbr":12,"debit":13,"width":14,"height":15,"startHour":16,"startMinute":17,"startSecond":18,"startFrame":19,"endHour":20,"endMinute":21,"endSecond":22,"endFrame":23,"volume":24,"mp4Volume":25,"bdVolume":26,"ogvVolume":27,"webMVolume":28,"hdVideoStatus":29,"bdVideoStatus":30,"mp4VideoStatus":31,"ogvVideoStatus":32,"webMVideoStatus":33,"metaData":34,"start":35,"end":36,"streamingSource":37,"multiCast":38,"tmpVideo":39,"tmpMp4VideoStatus":40,"smilFiles":41,"created_at":42,"updated_at":43,"video.id":44,"video.title":45},"code":200} 
    var order_playerParameters = {"data":{"id":0,"type":1,"defaultColor":2,"defaultLang":3,"defaultAutoplay":4,"contextMenu":5,"transcription":6,"showmbrlist":7,"showInfosBlock":8,"showMenu":9,"showShortcutButton":10,"audioDescription":11,"infosBlockMode":12,"showRichMediaBlock":13,"socialMedia":14,"exportRight":15,"mailRight":16,"displayChapter":17,"showSwithBtn":18,"controlBarEffect":19,"cbbOpacity":20,"cbbColor":21,"textColor":22,"textFocusColor":23,"progressColor":24,"cpbColor":25,"popupColor":26,"popupTitleColor":27,"textControlbarColor":28,"popupMenuColor":29,"btnFocusColor":30,"transparentBackground":31,"volumeCookieDelai":32,"allowProtectedVideoAccess":33,"multicastToUnicastDelai":34,"autoMbrSwitch":35,"limiterDebit":36,"authType":37,"ssoAuthSource":38,"restAuthKey":39,"restUrl":40,"zoningUrl":41,"progressiveHttpServer":42,"useNginx":43,"secureStream":44,"bo":45,"fo":46,"pathVignettes":47,"urlVignettes":48,"richMediaPath":49,"liveRichMediaPath":50,"slidesPath":51,"slidesUrl":52,"smilPath":53,"smilUrl":54,"ccPath":55,"ccUrl":56,"liveRmInterval":57,"statsInterval":58,"streamType":59,"statsComputerVideo":60,"statsComputerLive":61,"statsMobileVideo":62,"statsMobileLive":63,"statVisioUrlComputerVideo":64,"statVisioUrlComputerLive":65,"statVisioUrlMobileVideo":66,"statVisioUrlMobileLive":67,"expandVideo":68,"multilangue":69,"downloadVideo":70,"downloadRm":71,"downloadVideoUrl":72,"hlsKey":73,"useHostForExport":74},"code":200} 
    var order_playlist = {"data":{"id":0,"title":1,"maxDuration":2,"loopp":3},"code":200} 
    var order_homePageVideo = {"code":400,"message":"Error,Please contact admin"} 
    var order_eventOrganizer = {"code":400,"message":"Error,Please contact admin"} 
    var order_onhold_video = {"data":{"id":0,"fileTitle":6,"startDate":4},"code":200}

    angular
    .module('app.core')
        .constant('order_video', order_video)
        .constant('order_user', order_user)
        .constant('order_advertising', order_advertising)
        .constant('order_channel', order_channel)
        .constant('order_chutier', order_chutier)
        .constant('order_direction', order_direction)
        .constant('order_iptv', order_iptv)
        .constant('order_message', order_message)
        .constant('order_param', order_param)
        .constant('order_preset', order_preset)
        .constant('order_rmbox', order_rmbox)
        .constant('order_rmboxgroup', order_rmboxgroup)
        .constant('order_server', order_server)
        .constant('order_station', order_station)
        .constant('order_subscriptionGroup', order_subscriptionGroup)
        .constant('order_subscriptionUser', order_subscriptionUser)
        .constant('order_survey', order_survey)
        .constant('order_synchronisation', order_synchronisation)
        .constant('order_theme', order_theme)
        .constant('order_vote', order_vote)
        .constant('order_zone', order_zone)
        .constant('order_group', order_group)
        .constant('order_ips', order_ips)
        .constant('order_program', order_program)
        .constant('order_schedule', order_schedule)
        .constant('order_mooc', order_mooc)
        .constant('order_podcast', order_podcast)
        .constant('order_podcastItem', order_podcastItem)
        .constant('order_screen', order_screen)
        .constant('order_template', order_template)
        .constant('order_caption', order_caption)
        .constant('order_comments', order_comments)
        .constant('order_commentsLive', order_commentsLive)
        .constant('order_homeConf', order_homeConf)
        .constant('order_liveConf', order_liveConf)
        .constant('order_lives', order_lives)
        .constant('order_media', order_media)
        .constant('order_playerParameters', order_playerParameters)
        .constant('order_playlist', order_playlist)
        .constant('order_homePageVideo', order_homePageVideo)
        .constant('order_eventOrganizer', order_eventOrganizer)
        .constant('order_onhold_video', order_onhold_video)
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.toolbar', ['app.display_options'])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q,video, $state, $timeout, userManager, $mdSidenav, $translate, msNavigationService, environment, $cookies, dtable_language, logo, HelpGlobal, webTvGlobal, $window,webTv_msNavigation) {
        var vm = this;
        vm.parameters = webTvGlobal.$constant().webTvParameterBag();
        vm.url_documentation = "";
        if (angular.isDefined(vm.parameters.url_documentation)) vm.url_documentation = webTvGlobal.$constant().webTvParameterBag().url_documentation;
        // Data
        $rootScope.global = {
            search: ''
        };
      vm.isFM=false;
      if(video.isNew){
        vm.isFM=true;
      }
      $rootScope.isFM=vm.isFM;
        vm.logoToolbar = {
            "logo_image": logo.image,
            "logo_text": logo.text,
            "logo_text1":logo.text1
        };
        /////permission frogmedia
        vm.isNotBo=true;
        var typeList = "ongoing";
        vm.app = {environment: environment};
        vm.bodyEl = angular.element('body');
        vm.languages = {
            fr: {
                'title': 'Francais',
                'translation': 'TOOLBAR.FRENCH',
                'code': 'fr',
                'flag': 'fr'
            },
            en: {
                'title': 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code': 'en',
                'flag': 'us'
            }
        };

        // Methods
        vm.toggleOptionsSidenav = toggleOptionsSidenav;
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.refreshPageContent = refreshPageContent;
        vm.showHelp = showHelp;
        vm.goTo = goTo;
        vm.saveView = saveView;
        vm.getFullName = userManager.getFullName();
        vm.user = userManager.getUser();
        $rootScope.toolbarController = vm;
        vm.goToConf = goToConf;

        function goToConf() {
            $state.go("app.display_options_conf");
        }

        //////////
        function saveView(mode) {
            $cookies.put('viewMode', mode);
            webTvGlobal.$toast().showSimple($translate.instant("MESSAGES.success_change"));
            if ($state.current.url === "/on-going" || $state.current.url === "/archived" || $state.current.url === "/up-coming" || $state.current.url === "/offline")
                $window.location.reload();
        }

        function goTo(routePage) {
            var params = false;
            if(routePage ==='app.new_template_segment_list' && document.getElementById('iframe_segment_display')){
              document.getElementById('iframe_segment_display').contentWindow.postMessage({"info": "go_to_list_segment", "params": []}, "*");
              if(webTv_msNavigation['display_new_new_template_manager']){
                $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
                $rootScope.titre3 = "";
              }else {
                $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
                $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
              }
              if(document.getElementById('titre2')) {
                document.getElementById('titre2').innerText = $translate.instant($rootScope.titre2);
              }
              if(document.getElementById('titre3')) {
                document.getElementById('titre3').innerText = $translate.instant($rootScope.titre3);
              }
            }
            if(routePage ==='app.image' && document.getElementById('iframe_image')){
              document.getElementById('iframe_image').contentWindow.postMessage({"info": "closeModal", "params": []}, "*");
              if(webTv_msNavigation['media_image']) {
                $rootScope.titre1 = "PAGESMENUSTITLES.images_menuTitle";
                $rootScope.titre2 = "";
                $rootScope.titre3 = "";
              }else {
                $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
                $rootScope.titre2 = "PAGESMENUSTITLES.images_menuTitle";
                $rootScope.titre3 = "";
              }
              if(document.getElementById('titre2')) {
                document.getElementById('titre2').innerText = $translate.instant($rootScope.titre2);
              }
              if(document.getElementById('titre3')) {
                document.getElementById('titre3').innerText = $translate.instant($rootScope.titre3);
              }
            }
            if(routePage ==='app.media_video_list_ongoing'){
                params = {type: "ongoing"};
                routePage = "app.media_video_list";
            }else if (routePage === "app.media_video_list_archived") {
                params = {type: "archived"};
                routePage = "app.media_video_list";
            }
            else if (routePage === "app.media_video_list_offline") {
                params = {type: "offline"};
                routePage = "app.media_video_list";
            }
            else if (routePage === "app.media_video_list_upcoming") {
                params = {type: "upcoming"};
                routePage = "app.media_video_list";
            }
            else if (routePage === "app.media_video_list_all") {
                params = {type: "all"};
                routePage = "app.media_video_list";
            }
            else if (routePage === "app.media_video_list") {
                params = {type: typeList};
                routePage = "app.media_video_list";
            }
            else if (routePage === "app.lives_list_ongoing") {
                params = {type: 'list',diffusion:"endless",ids:null};
                routePage = "app.lives_list_ongoing";
            }
            if(params){
                $state.go(routePage, params);
            }else{
                $state.go(routePage);
            }
            if($state.current.name == "app.lives_list_ongoing")
              $state.reload();
        }

        init();

        /**
         * Initialize
         */
        function init() {
            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = angular.copy(vm.languages[$translate.preferredLanguage()]);
            var lang = vm.selectedLanguage && vm.selectedLanguage.code ? vm.selectedLanguage.code : vm.selectedLanguage;
          eventPostMessage(lang);
          listenPostMessage();
        }

        /**
         * Refresh Content : remove current template from cache and reload state
         */
        function refreshPageContent() {
            // if (angular.isDefined($state.current) && angular.isDefined($state.current.views) && angular.isDefined($state.current.views["content@app"]) && angular.isDefined($state.current.views["content@app"].templateUrl) && $state.current.views["content@app"].templateUrl) {
            //     $templateCache.remove(
            //         angular.isFunction($state.current.views["content@app"].templateUrl)
            //             ?
            //             $state.current.views["content@app"].templateUrl($state.params)
            //             :
            //             $state.current.views["content@app"].templateUrl);
            //     $state.reload();
            // }
            $state.reload();
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleOptionsSidenav(navId) {
            $mdSidenav(navId).toggle();
            $rootScope.showStyleLayout = true;
        }

        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Logout Function
         */
        function logout() {
            $cookies.remove('authToken');
            $state.go("app.login-v2", {token: ""});
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;
            $rootScope.selectedLanguage = lang;
            $cookies.put('WEBTV.locale', lang.code);
            $translate.use(lang.code).then(function () {
                $translate.preferredLanguage(lang.code)
            });
            webTvGlobal.translateDatePicker();
            if ($state.current.url === "/all")
                $state.go($state.current, {}, {reload: true});

            if ($rootScope.DtOptions) {
                $rootScope.DtOptions.language = dtable_language[lang.code];

            }
          eventPostMessage( lang.code);

        }
      function eventPostMessage(lang) {
        if(document.getElementById('iframe_live'))
        {
          document.getElementById('iframe_live').contentWindow.postMessage({
            info: "updateLang",
            lang:lang
          }, "*");
        }
        if(document.getElementById('iframe_display'))
        {
          document.getElementById('iframe_display').contentWindow.postMessage({
            info: "updateLang",
            lang:lang
          }, "*");
        }
        if(document.getElementById('iframe_profile'))
        {
          document.getElementById('iframe_profile').contentWindow.postMessage({
            info: "updateLang",
            lang:lang
          }, "*");
        }
        if(document.getElementById('iframe_segment_display'))
        {
          document.getElementById('iframe_segment_display').contentWindow.postMessage({
            info: "updateLang",
            lang:lang
          }, "*");
        }
        if(document.getElementById('iframe_list'))
        {
          document.getElementById('iframe_list').contentWindow.postMessage({
            "info": "updateLang",
            "lang":[lang]

          }, "*");
        }
        if(document.getElementById('iframe_podcast'))
        {
          document.getElementById('iframe_podcast').contentWindow.postMessage({
            "info": "updateLang",
            "lang":[lang]
          }, "*");
        }
           if (document.getElementById("iframe_playlist")) {
             document
               .getElementById("iframe_playlist")
               .contentWindow.postMessage(
                 {
                   info: "updateLang",
                   lang: [lang],
                 },
                 "*"
               );
           }
        if(document.getElementById('iframe_skin'))
        {
          document.getElementById('iframe_skin').contentWindow.postMessage({
            "info": "updateLang",
            "lang":lang

          }, "*");
        }
        if(document.getElementById('iframe_image'))
        {
          document.getElementById('iframe_image').contentWindow.postMessage({
            "info": "updateLang",
            "lang":lang

          }, "*");
        }
        if(document.getElementById('iframe_event')){
          document.getElementById('iframe_event').contentWindow.postMessage({
            "info": "updateLang",
            "lang":lang
          }, "*");
        }
      }


      /***/

      function listenPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageIitle)) {
          window.dataEventPostMessageIitle = true;
          console.log("eventPostMessage");
            var mail=document.getElementById('theme-config');
            var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
          //eventer(messageEvent, function (e) <=> window.addEventListener("message", receiveMessage, false): to listen to the dispached event
          //receiveMessage = function(event)
          eventer(messageEvent, function (e) {
            if (typeof e.data !== "undefined") {
              if (e.data.info === "diffusion") {
                if(document.getElementById('titre3')) {
                  document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.media_video_list_" + e.data.value + "_pagetitle");
                  $rootScope.titre3 = "PAGESMENUSTITLES.media_video_list_" + e.data.value + "_pagetitle";
                }
              }
              if (e.data.info === "event") {
                if(document.getElementById('titre3')) {
                    document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.event_list_" + e.data.value + "_pagetitle");
                    $rootScope.titre3 = "PAGESMENUSTITLES.event_list_" + e.data.value + "_pagetitle";
                  }
                }
  
                 if (e.data.info.startsWith('event_')) {
                  if(document.getElementById('titre3')) {
                    document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.event_" + e.data.value + "_pagetitle");
                    $rootScope.titre3 = "PAGESMENUSTITLES.event_" + e.data.value + "_pagetitle";
                  }
                }
  
              if (e.data.info === "edit_video") {
                if(document.getElementById('titre3')) {
                  if(e.data.value === "upload"){
                    document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.media_video_" + e.data.value + "_menuTitle");
                  $rootScope.titre3 = "PAGESMENUSTITLES.media_video_" + e.data.value + "_menuTitle";
                  }else{
                    document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.media_video_" + e.data.value + "_pagetitle");
                    $rootScope.titre3 = "PAGESMENUSTITLES.media_video_" + e.data.value + "_pagetitle";
                  }
                }
              }
                if (e.data.info === "editVideo") {
                    typeList = e.data.type
                }
              if (e.data.info === "diffusionLive") {
                console.log(e.data.value);
                console.log("diffusionLive");
                if(document.getElementById('titre3')) {
                  document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.lives_list_" + e.data.value + "_pagetitle");
                  $rootScope.titre3 = "PAGESMENUSTITLES.lives_list_" + e.data.value + "_pagetitle";
                }
              }

                if (e.data.info === "goToListLive") {
                    if(document.getElementById('titre3')) {
                        document.getElementById('titre3').innerText = $translate.instant("PAGESMENUSTITLES.lives_list_" + e.data.value + "_pagetitle");
                        $rootScope.titre3 = "PAGESMENUSTITLES.lives_list_" + e.data.value + "_pagetitle";
                    }
                }
              if (event.data.info === 'leaveLive') {
                $state.go("app.lives_list_ongoing", {diffusion: "endless"});
              }
                if (e.data.info === "ShowPreview" ) {
                  if(mail ){
                      mail.style.zIndex="";
                      if(e.data.value){
                          mail.style.zIndex="-1";
                      }

                  }
              }
            }
          }, false);
        }

      }

      /***/
        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();
            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1
                        ||
                        (angular.isDefined(item.translate) && angular.lowercase($translate.instant(item.translate)).search(angular.lowercase(vm.query)) > -1)
                        ||
                        (angular.isDefined(item.translate) && angular.lowercase($translate.instant(item.translate.replace(/menuTitle/i, "pagetitle"))).search(angular.lowercase(vm.query)) > -1)
                    ) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                }
                else {
                    $state.go(item.state);
                }
            }
        }

        function showHelp() {
            HelpGlobal.showHelp($rootScope.text, $rootScope.welcome);
        }
    }

})();

/**
 * Portions of this code are from the Google Closure Library,
 * received from the Closure Authors under the Apache 2.0 license.
 *
 * All other code is (C) FriendsOfSymfony and subject to the MIT license.
 */
(function() {
    var f = !1,
        i, k = this;

    function l(a, c) {
        var b = a.split("."),
            d = k;
        !(b[0] in d) && d.execScript && d.execScript("var " + b[0]);
        for (var e; b.length && (e = b.shift());) !b.length && void 0 !== c ? d[e] = c : d = d[e] ? d[e] : d[e] = {}
    }
    var m = Array.prototype,
        n = m.forEach ? function(a, c, b) {
            m.forEach.call(a, c, b)
        } : function(a, c, b) {
            for (var d = a.length, e = "string" === typeof a ? a.split("") : a, g = 0; g < d; g++) g in e && c.call(b, e[g], g, a)
        };

    function q(a, c) {
        this.c = {};
        this.a = [];
        var b = arguments.length;
        if (1 < b) {
            if (b % 2) throw Error("Uneven number of arguments");
            for (var d = 0; d < b; d += 2) this.set(arguments[d], arguments[d + 1])
        } else if (a) {
            var e;
            if (a instanceof q) {
                r(a);
                d = a.a.concat();
                r(a);
                e = [];
                for (b = 0; b < a.a.length; b++) e.push(a.c[a.a[b]])
            } else {
                var b = [],
                    g = 0;
                for (d in a) b[g++] = d;
                d = b;
                b = [];
                g = 0;
                for (e in a) b[g++] = a[e];
                e = b
            }
            for (b = 0; b < d.length; b++) this.set(d[b], e[b])
        }
    }
    q.prototype.f = 0;
    q.prototype.p = 0;

    function r(a) {
        if (a.f !== a.a.length) {
            for (var c = 0, b = 0; c < a.a.length;) {
                var d = a.a[c];
                t(a.c, d) && (a.a[b++] = d);
                c++
            }
            a.a.length = b
        }
        if (a.f !== a.a.length) {
            for (var e = {}, b = c = 0; c < a.a.length;) d = a.a[c], t(e, d) || (a.a[b++] = d, e[d] = 1), c++;
            a.a.length = b
        }
    }
    q.prototype.get = function(a, c) {
        return t(this.c, a) ? this.c[a] : c
    };
    q.prototype.set = function(a, c) {
        t(this.c, a) || (this.f++, this.a.push(a), this.p++);
        this.c[a] = c
    };

    function t(a, c) {
        return Object.prototype.hasOwnProperty.call(a, c)
    }
    var u, v, w, x;

    function y() {
        return k.navigator ? k.navigator.userAgent : null
    }
    x = w = v = u = f;
    var C;
    if (C = y()) {
        var D = k.navigator;
        u = 0 === C.indexOf("Opera");
        v = !u && -1 !== C.indexOf("MSIE");
        w = !u && -1 !== C.indexOf("WebKit");
        x = !u && !w && "Gecko" === D.product
    }
    var E = v,
        F = x,
        G = w;
    var I;
    if (u && k.opera) {
        var J = k.opera.version;
        "function" === typeof J && J()
    } else F ? I = /rv\:([^\);]+)(\)|;)/ : E ? I = /MSIE\s+([^\);]+)(\)|;)/ : G && (I = /WebKit\/(\S+)/), I && I.exec(y());

    function K(a, c) {
        this.b = a || {
            e: "",
            prefix: "",
            host: "",
            scheme: ""
        };
        this.h(c || {})
    }
    K.g = function() {
        return K.j ? K.j : K.j = new K
    };
    i = K.prototype;
    i.h = function(a) {
        this.d = new q(a)
    };
    i.o = function() {
        return this.d
    };
    i.k = function(a) {
        this.b.e = a
    };
    i.n = function() {
        return this.b.e
    };
    i.l = function(a) {
        this.b.prefix = a
    };

    function L(a, c, b, d) {
        var e, g = RegExp(/\[\]$/);
        if (b instanceof Array) n(b, function(b, e) {
            g.test(c) ? d(c, b) : L(a, c + "[" + ("object" === typeof b ? e : "") + "]", b, d)
        });
        else if ("object" === typeof b)
            for (e in b) L(a, c + "[" + e + "]", b[e], d);
        else d(c, b)
    }
    i.i = function(a) {
        var c = this.b.prefix + a;
        if (t(this.d.c, c)) a = c;
        else if (!t(this.d.c, a)) throw Error('The route "' + a + '" does not exist.');
        return this.d.get(a)
    };
    api = [];
    api_2 = [];
    i.m = function(a, c, b) {
        api[a]= api[a]!== undefined ? api[a]+1 : 1;
        if(api[a] >= 2)
        {
            api_2[a] = api[a];
        }
        var d = this.i(a),
            e = c || {},
            g = {},
            z;
        for (z in e) g[z] = e[z];
        var h = "",
            s = !0,
            j = "";
        n(d.tokens, function(b) {
            if ("text" === b[0]) h = b[1] + h, s = f;
            else if ("variable" === b[0]) {
                var c = b[3] in d.defaults;
                if (f === s || !c || b[3] in e && e[b[3]] !== d.defaults[b[3]]) {
                    if (b[3] in e) {
                        var c = e[b[3]],
                            p = b[3];
                        p in g && delete g[p]
                    } else if (c) c = d.defaults[b[3]];
                    else {
                        if (s) return;
                        throw Error('The route "' + a + '" requires the parameter "' + b[3] + '".');
                    }
                    if (!(!0 === c || f === c || "" === c) || !s) p = encodeURIComponent(c).replace(/%2F/g, "/"), "null" === p &&
                        null === c && (p = ""), h = b[1] + p + h;
                    s = f
                } else c && (b = b[3], b in g && delete g[b])
            } else throw Error('The token type "' + b[0] + '" is not supported.');
        });
        "" === h && (h = "/");
        n(d.hosttokens, function(a) {
            var b;
            if ("text" === a[0]) j = a[1] + j;
            else if ("variable" === a[0]) {
                if (a[3] in e) {
                    b = e[a[3]];
                    var c = a[3];
                    c in g && delete g[c]
                } else a[3] in d.defaults && (b = d.defaults[a[3]]);
                j = a[1] + b + j
            }
        });
        h = this.b.e + h;
        "_scheme" in d.requirements && this.b.scheme !== d.requirements._scheme ? h = d.requirements._scheme + "://" + (j || this.b.host) + h : j && this.b.host !== j ? h =
            this.b.scheme + "://" + j + h : !0 === b && (h = this.b.scheme + "://" + this.b.host + h);
        var c = 0,
            A;
        for (A in g) c++;
        if (0 < c) {
            var B, H = [];
            A = function(a, b) {
                b = "function" === typeof b ? b() : b;
                H.push(encodeURIComponent(a) + "=" + encodeURIComponent(null === b ? "" : b))
            };
            for (B in g) L(this, B, g[B], A);
            h = h + "?" + H.join("&").replace(/%20/g, "+")
        }
        return h
    };
    l("Router", K);
    l("Router.setData", function(a) {
        var c = K.g();
        c.k(a.base_url);
        c.h(a.routes);
        "prefix" in a && c.l(a.prefix);
        c.b.host = a.host;
        c.b.scheme = a.scheme
    });
    K.getInstance = K.g;
    K.prototype.setRoutes = K.prototype.h;
    K.prototype.getRoutes = K.prototype.o;
    K.prototype.setBaseUrl = K.prototype.k;
    K.prototype.getBaseUrl = K.prototype.n;
    K.prototype.generate = K.prototype.m;
    K.prototype.setPrefix = K.prototype.l;
    K.prototype.getRoute = K.prototype.i;
    window.Routing = K.g();
})();

(function () {
  'use strict';

  /**
   * Main module of the Fuse
   */
  var app_modules = modules;

  angular
    .module('WebTv', [
      //config
      "Webtv.config",
      // Core
      'app.core',

      // Navigation
      'app.navigation',
      // Toolbar
      'app.toolbar',
      // Quick Panel
      "app.core.components",
      "app.core.componentsHelp",
      "app.core.themes",
      "app.core.themesBootstrap",
      "angularCroppie",
      "app.core.channels",
      "app.core.contributors",
      //"app.core.themesFilter",
      "app.core.menu",
      "app.core.multilangue",
      'datatables',
      'angularUtils.directives.dirPagination',
      "app.error", "app.mail", "app.login-v2", "app.login-step2", "app.two-factor-auth", "app.media.video.reupload", "app.media.video.upload", 'app.media', 'app.profiles', 'app.configuration', 'app.classifying', 'app.support','app.stats'
    ].concat(app_modules))
    .constant('app_modules', app_modules)
    .config(config);

  function config(msApiProvider,$translatePartialLoaderProvider) {
    msApiProvider.register('checkToken', [Routing.generate('api_profiles_check_link_forgot_password_expired')]);
    $translatePartialLoaderProvider.addPart('app');
    $translatePartialLoaderProvider.addPart('app/languages');
    msApiProvider.register('userManager.getUserIpData', [Routing.generate('api_profiles_ips_get_autorisation_ip')]);
  }
 
})();

(function ()
{
    'use strict';

    angular
        .module('WebTv')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope)
    {
        // Data
      window.onresize= function() {
        var selector = 'body>.md-select-menu-container.md-default-theme';
        if(document.querySelector(selector)){
            if(document.querySelector(selector).classList.contains('md-active')){
                document.querySelector(selector).classList.remove('md-active','md-clickable');

            }
        }
          initialiseToolbarMenu();

      };
      function initialiseToolbarMenu(){
          var menuMobile=document.querySelector(".ms-navigation-horizontal.navigation-horizontal-mobile")
          var toolbar= document.getElementById("toolbar")
          var toolbarNav=  document.getElementById("toolbar-navigation-container")
          if( toolbar &&  toolbar.style.display==='none'){
              if(toolbarNav){
                  toolbarNav.style.minHeight='initial';
              }

          }
      }
        /**
         * watch changed route
         */
        $rootScope.$on("$locationChangeStart", function() {
            var toolbar=  document.getElementById("toolbar");
            if(toolbar){
                toolbar.style.display = "block";
                toolbar.style.opacity = "1";
                toolbar.style.transition = "all 2s linear";
            }
            if(angular.element('body')[0].classList.contains('ms-navigation-horizontal-mobile-menu-active')){
                angular.element('body')[0].classList.remove('ms-navigation-horizontal-mobile-menu-active')
            }


        });
        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function(e){"function"==typeof define&&define.amd?define(["jquery","moment"],e):e(jQuery,moment)})(function(e,t){(function(){(t.defineLocale||t.lang).call(t,"ar-ma",{months:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split("_"),weekdays:"الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:6,doy:12}}),e.fullCalendar.datepickerLang("ar-ma","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ar-ma",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى"})})(),function(){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"};(t.defineLocale||t.lang).call(t,"ar-sa",{months:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e){return 12>e?"ص":"م"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}}),e.fullCalendar.datepickerLang("ar-sa","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ar-sa",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى"})}(),function(){(t.defineLocale||t.lang).call(t,"ar-tn",{months:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),monthsShort:"جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split("_"),weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[اليوم على الساعة] LT",nextDay:"[غدا على الساعة] LT",nextWeek:"dddd [على الساعة] LT",lastDay:"[أمس على الساعة] LT",lastWeek:"dddd [على الساعة] LT",sameElse:"L"},relativeTime:{future:"في %s",past:"منذ %s",s:"ثوان",m:"دقيقة",mm:"%d دقائق",h:"ساعة",hh:"%d ساعات",d:"يوم",dd:"%d أيام",M:"شهر",MM:"%d أشهر",y:"سنة",yy:"%d سنوات"},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("ar-tn","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ar-tn",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى"})}(),function(){var a={1:"١",2:"٢",3:"٣",4:"٤",5:"٥",6:"٦",7:"٧",8:"٨",9:"٩",0:"٠"},n={"١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","٠":"0"},r=function(e){return 0===e?0:1===e?1:2===e?2:e%100>=3&&10>=e%100?3:e%100>=11?4:5},i={s:["أقل من ثانية","ثانية واحدة",["ثانيتان","ثانيتين"],"%d ثوان","%d ثانية","%d ثانية"],m:["أقل من دقيقة","دقيقة واحدة",["دقيقتان","دقيقتين"],"%d دقائق","%d دقيقة","%d دقيقة"],h:["أقل من ساعة","ساعة واحدة",["ساعتان","ساعتين"],"%d ساعات","%d ساعة","%d ساعة"],d:["أقل من يوم","يوم واحد",["يومان","يومين"],"%d أيام","%d يومًا","%d يوم"],M:["أقل من شهر","شهر واحد",["شهران","شهرين"],"%d أشهر","%d شهرا","%d شهر"],y:["أقل من عام","عام واحد",["عامان","عامين"],"%d أعوام","%d عامًا","%d عام"]},s=function(e){return function(t,a){var n=r(t),s=i[e][r(t)];return 2===n&&(s=s[a?0:1]),s.replace(/%d/i,t)}},o=["كانون الثاني يناير","شباط فبراير","آذار مارس","نيسان أبريل","أيار مايو","حزيران يونيو","تموز يوليو","آب أغسطس","أيلول سبتمبر","تشرين الأول أكتوبر","تشرين الثاني نوفمبر","كانون الأول ديسمبر"];(t.defineLocale||t.lang).call(t,"ar",{months:o,monthsShort:o,weekdays:"الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),weekdaysShort:"أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),weekdaysMin:"ح_ن_ث_ر_خ_ج_س".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},meridiemParse:/ص|م/,isPM:function(e){return"م"===e},meridiem:function(e){return 12>e?"ص":"م"},calendar:{sameDay:"[اليوم عند الساعة] LT",nextDay:"[غدًا عند الساعة] LT",nextWeek:"dddd [عند الساعة] LT",lastDay:"[أمس عند الساعة] LT",lastWeek:"dddd [عند الساعة] LT",sameElse:"L"},relativeTime:{future:"بعد %s",past:"منذ %s",s:s("s"),m:s("m"),mm:s("m"),h:s("h"),hh:s("h"),d:s("d"),dd:s("d"),M:s("M"),MM:s("M"),y:s("y"),yy:s("y")},preparse:function(e){return e.replace(/[١٢٣٤٥٦٧٨٩٠]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},week:{dow:6,doy:12}}),e.fullCalendar.datepickerLang("ar","ar",{closeText:"إغلاق",prevText:"&#x3C;السابق",nextText:"التالي&#x3E;",currentText:"اليوم",monthNames:["كانون الثاني","شباط","آذار","نيسان","مايو","حزيران","تموز","آب","أيلول","تشرين الأول","تشرين الثاني","كانون الأول"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesShort:["الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت"],dayNamesMin:["ح","ن","ث","ر","خ","ج","س"],weekHeader:"أسبوع",dateFormat:"dd/mm/yy",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ar",{buttonText:{month:"شهر",week:"أسبوع",day:"يوم",list:"أجندة"},allDayText:"اليوم كله",eventLimitText:"أخرى"})}(),function(){(t.defineLocale||t.lang).call(t,"bg",{months:"януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split("_"),monthsShort:"янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),weekdays:"неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split("_"),weekdaysShort:"нед_пон_вто_сря_чет_пет_съб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"D.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[Днес в] LT",nextDay:"[Утре в] LT",nextWeek:"dddd [в] LT",lastDay:"[Вчера в] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[В изминалата] dddd [в] LT";case 1:case 2:case 4:case 5:return"[В изминалия] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"след %s",past:"преди %s",s:"няколко секунди",m:"минута",mm:"%d минути",h:"час",hh:"%d часа",d:"ден",dd:"%d дни",M:"месец",MM:"%d месеца",y:"година",yy:"%d години"},ordinalParse:/\d{1,2}-(ев|ен|ти|ви|ри|ми)/,ordinal:function(e){var t=e%10,a=e%100;return 0===e?e+"-ев":0===a?e+"-ен":a>10&&20>a?e+"-ти":1===t?e+"-ви":2===t?e+"-ри":7===t||8===t?e+"-ми":e+"-ти"},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("bg","bg",{closeText:"затвори",prevText:"&#x3C;назад",nextText:"напред&#x3E;",nextBigText:"&#x3E;&#x3E;",currentText:"днес",monthNames:["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],monthNamesShort:["Яну","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Нов","Дек"],dayNames:["Неделя","Понеделник","Вторник","Сряда","Четвъртък","Петък","Събота"],dayNamesShort:["Нед","Пон","Вто","Сря","Чет","Пет","Съб"],dayNamesMin:["Не","По","Вт","Ср","Че","Пе","Съ"],weekHeader:"Wk",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("bg",{buttonText:{month:"Месец",week:"Седмица",day:"Ден",list:"График"},allDayText:"Цял ден",eventLimitText:function(e){return"+още "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"ca",{months:"gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split("_"),monthsShort:"gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.".split("_"),weekdays:"diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split("_"),weekdaysShort:"dg._dl._dt._dc._dj._dv._ds.".split("_"),weekdaysMin:"Dg_Dl_Dt_Dc_Dj_Dv_Ds".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:function(){return"[avui a "+(1!==this.hours()?"les":"la")+"] LT"},nextDay:function(){return"[demà a "+(1!==this.hours()?"les":"la")+"] LT"},nextWeek:function(){return"dddd [a "+(1!==this.hours()?"les":"la")+"] LT"},lastDay:function(){return"[ahir a "+(1!==this.hours()?"les":"la")+"] LT"},lastWeek:function(){return"[el] dddd [passat a "+(1!==this.hours()?"les":"la")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"fa %s",s:"uns segons",m:"un minut",mm:"%d minuts",h:"una hora",hh:"%d hores",d:"un dia",dd:"%d dies",M:"un mes",MM:"%d mesos",y:"un any",yy:"%d anys"},ordinalParse:/\d{1,2}(r|n|t|è|a)/,ordinal:function(e,t){var a=1===e?"r":2===e?"n":3===e?"r":4===e?"t":"è";return("w"===t||"W"===t)&&(a="a"),e+a},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("ca","ca",{closeText:"Tanca",prevText:"Anterior",nextText:"Següent",currentText:"Avui",monthNames:["gener","febrer","març","abril","maig","juny","juliol","agost","setembre","octubre","novembre","desembre"],monthNamesShort:["gen","feb","març","abr","maig","juny","jul","ag","set","oct","nov","des"],dayNames:["diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte"],dayNamesShort:["dg","dl","dt","dc","dj","dv","ds"],dayNamesMin:["dg","dl","dt","dc","dj","dv","ds"],weekHeader:"Set",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ca",{buttonText:{month:"Mes",week:"Setmana",day:"Dia",list:"Agenda"},allDayText:"Tot el dia",eventLimitText:"més"})}(),function(){function a(e){return e>1&&5>e&&1!==~~(e/10)}function n(e,t,n,r){var i=e+" ";switch(n){case"s":return t||r?"pár sekund":"pár sekundami";case"m":return t?"minuta":r?"minutu":"minutou";case"mm":return t||r?i+(a(e)?"minuty":"minut"):i+"minutami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?i+(a(e)?"hodiny":"hodin"):i+"hodinami";case"d":return t||r?"den":"dnem";case"dd":return t||r?i+(a(e)?"dny":"dní"):i+"dny";case"M":return t||r?"měsíc":"měsícem";case"MM":return t||r?i+(a(e)?"měsíce":"měsíců"):i+"měsíci";case"y":return t||r?"rok":"rokem";case"yy":return t||r?i+(a(e)?"roky":"let"):i+"lety"}}var r="leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split("_"),i="led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_");(t.defineLocale||t.lang).call(t,"cs",{months:r,monthsShort:i,monthsParse:function(e,t){var a,n=[];for(a=0;12>a;a++)n[a]=RegExp("^"+e[a]+"$|^"+t[a]+"$","i");return n}(r,i),weekdays:"neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split("_"),weekdaysShort:"ne_po_út_st_čt_pá_so".split("_"),weekdaysMin:"ne_po_út_st_čt_pá_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd D. MMMM YYYY LT"},calendar:{sameDay:"[dnes v] LT",nextDay:"[zítra v] LT",nextWeek:function(){switch(this.day()){case 0:return"[v neděli v] LT";case 1:case 2:return"[v] dddd [v] LT";case 3:return"[ve středu v] LT";case 4:return"[ve čtvrtek v] LT";case 5:return"[v pátek v] LT";case 6:return"[v sobotu v] LT"}},lastDay:"[včera v] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulou neděli v] LT";case 1:case 2:return"[minulé] dddd [v] LT";case 3:return"[minulou středu v] LT";case 4:case 5:return"[minulý] dddd [v] LT";case 6:return"[minulou sobotu v] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"před %s",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("cs","cs",{closeText:"Zavřít",prevText:"&#x3C;Dříve",nextText:"Později&#x3E;",currentText:"Nyní",monthNames:["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],monthNamesShort:["led","úno","bře","dub","kvě","čer","čvc","srp","zář","říj","lis","pro"],dayNames:["neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota"],dayNamesShort:["ne","po","út","st","čt","pá","so"],dayNamesMin:["ne","po","út","st","čt","pá","so"],weekHeader:"Týd",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("cs",{buttonText:{month:"Měsíc",week:"Týden",day:"Den",list:"Agenda"},allDayText:"Celý den",eventLimitText:function(e){return"+další: "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"da",{months:"januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tir_ons_tor_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd [d.] D. MMMM YYYY LT"},calendar:{sameDay:"[I dag kl.] LT",nextDay:"[I morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[I går kl.] LT",lastWeek:"[sidste] dddd [kl] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"%s siden",s:"få sekunder",m:"et minut",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dage",M:"en måned",MM:"%d måneder",y:"et år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("da","da",{closeText:"Luk",prevText:"&#x3C;Forrige",nextText:"Næste&#x3E;",currentText:"Idag",monthNames:["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNames:["Søndag","Mandag","Tirsdag","Onsdag","Torsdag","Fredag","Lørdag"],dayNamesShort:["Søn","Man","Tir","Ons","Tor","Fre","Lør"],dayNamesMin:["Sø","Ma","Ti","On","To","Fr","Lø"],weekHeader:"Uge",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("da",{buttonText:{month:"Måned",week:"Uge",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"flere"})}(),function(){function a(e,t,a){var n={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?n[a][0]:n[a][1]}(t.defineLocale||t.lang).call(t,"de-at",{months:"Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[Heute um] LT [Uhr]",sameElse:"L",nextDay:"[Morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[Gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("de-at","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("de-at",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e}})}(),function(){function a(e,t,a){var n={m:["eine Minute","einer Minute"],h:["eine Stunde","einer Stunde"],d:["ein Tag","einem Tag"],dd:[e+" Tage",e+" Tagen"],M:["ein Monat","einem Monat"],MM:[e+" Monate",e+" Monaten"],y:["ein Jahr","einem Jahr"],yy:[e+" Jahre",e+" Jahren"]};return t?n[a][0]:n[a][1]}(t.defineLocale||t.lang).call(t,"de",{months:"Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split("_"),monthsShort:"Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split("_"),weekdays:"Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split("_"),weekdaysShort:"So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),weekdaysMin:"So_Mo_Di_Mi_Do_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[Heute um] LT [Uhr]",sameElse:"L",nextDay:"[Morgen um] LT [Uhr]",nextWeek:"dddd [um] LT [Uhr]",lastDay:"[Gestern um] LT [Uhr]",lastWeek:"[letzten] dddd [um] LT [Uhr]"},relativeTime:{future:"in %s",past:"vor %s",s:"ein paar Sekunden",m:a,mm:"%d Minuten",h:a,hh:"%d Stunden",d:a,dd:a,M:a,MM:a,y:a,yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("de","de",{closeText:"Schließen",prevText:"&#x3C;Zurück",nextText:"Vor&#x3E;",currentText:"Heute",monthNames:["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],monthNamesShort:["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],dayNames:["Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag"],dayNamesShort:["So","Mo","Di","Mi","Do","Fr","Sa"],dayNamesMin:["So","Mo","Di","Mi","Do","Fr","Sa"],weekHeader:"KW",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("de",{buttonText:{month:"Monat",week:"Woche",day:"Tag",list:"Terminübersicht"},allDayText:"Ganztägig",eventLimitText:function(e){return"+ weitere "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"el",{monthsNominativeEl:"Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split("_"),monthsGenitiveEl:"Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split("_"),months:function(e,t){return/D/.test(t.substring(0,t.indexOf("MMMM")))?this._monthsGenitiveEl[e.month()]:this._monthsNominativeEl[e.month()]},monthsShort:"Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),weekdays:"Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split("_"),weekdaysShort:"Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),weekdaysMin:"Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),meridiem:function(e,t,a){return e>11?a?"μμ":"ΜΜ":a?"πμ":"ΠΜ"},isPM:function(e){return"μ"===(e+"").toLowerCase()[0]},meridiemParse:/[ΠΜ]\.?Μ?\.?/i,longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendarEl:{sameDay:"[Σήμερα {}] LT",nextDay:"[Αύριο {}] LT",nextWeek:"dddd [{}] LT",lastDay:"[Χθες {}] LT",lastWeek:function(){switch(this.day()){case 6:return"[το προηγούμενο] dddd [{}] LT";default:return"[την προηγούμενη] dddd [{}] LT"}},sameElse:"L"},calendar:function(e,t){var a=this._calendarEl[e],n=t&&t.hours();return"function"==typeof a&&(a=a.apply(t)),a.replace("{}",1===n%12?"στη":"στις")},relativeTime:{future:"σε %s",past:"%s πριν",s:"λίγα δευτερόλεπτα",m:"ένα λεπτό",mm:"%d λεπτά",h:"μία ώρα",hh:"%d ώρες",d:"μία μέρα",dd:"%d μέρες",M:"ένας μήνας",MM:"%d μήνες",y:"ένας χρόνος",yy:"%d χρόνια"},ordinalParse:/\d{1,2}η/,ordinal:"%dη",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("el","el",{closeText:"Κλείσιμο",prevText:"Προηγούμενος",nextText:"Επόμενος",currentText:"Σήμερα",monthNames:["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάιος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],monthNamesShort:["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],dayNames:["Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο"],dayNamesShort:["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"],dayNamesMin:["Κυ","Δε","Τρ","Τε","Πε","Πα","Σα"],weekHeader:"Εβδ",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("el",{buttonText:{month:"Μήνας",week:"Εβδομάδα",day:"Ημέρα",list:"Ατζέντα"},allDayText:"Ολοήμερο",eventLimitText:"περισσότερα"})}(),function(){(t.defineLocale||t.lang).call(t,"en-au",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,a=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+a},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("en-au","en-AU",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("en-au")}(),function(){(t.defineLocale||t.lang).call(t,"en-ca",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"h:mm A",LTS:"h:mm:ss A",L:"YYYY-MM-DD",LL:"D MMMM, YYYY",LLL:"D MMMM, YYYY LT",LLLL:"dddd, D MMMM, YYYY LT"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,a=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+a}}),e.fullCalendar.lang("en-ca")}(),function(){(t.defineLocale||t.lang).call(t,"en-gb",{months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),monthsShort:"Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),weekdaysShort:"Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),weekdaysMin:"Su_Mo_Tu_We_Th_Fr_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"HH:mm:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},relativeTime:{future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},ordinalParse:/\d{1,2}(st|nd|rd|th)/,ordinal:function(e){var t=e%10,a=1===~~(e%100/10)?"th":1===t?"st":2===t?"nd":3===t?"rd":"th";return e+a},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("en-gb","en-GB",{closeText:"Done",prevText:"Prev",nextText:"Next",currentText:"Today",monthNames:["January","February","March","April","May","June","July","August","September","October","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"],dayNamesShort:["Sun","Mon","Tue","Wed","Thu","Fri","Sat"],dayNamesMin:["Su","Mo","Tu","We","Th","Fr","Sa"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("en-gb")}(),function(){var a="ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split("_"),n="ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_");(t.defineLocale||t.lang).call(t,"es",{months:"enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split("_"),monthsShort:function(e,t){return/-MMM-/.test(t)?n[e.month()]:a[e.month()]},weekdays:"domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),weekdaysShort:"dom._lun._mar._mié._jue._vie._sáb.".split("_"),weekdaysMin:"Do_Lu_Ma_Mi_Ju_Vi_Sá".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY LT",LLLL:"dddd, D [de] MMMM [de] YYYY LT"},calendar:{sameDay:function(){return"[hoy a la"+(1!==this.hours()?"s":"")+"] LT"},nextDay:function(){return"[mañana a la"+(1!==this.hours()?"s":"")+"] LT"},nextWeek:function(){return"dddd [a la"+(1!==this.hours()?"s":"")+"] LT"},lastDay:function(){return"[ayer a la"+(1!==this.hours()?"s":"")+"] LT"},lastWeek:function(){return"[el] dddd [pasado a la"+(1!==this.hours()?"s":"")+"] LT"},sameElse:"L"},relativeTime:{future:"en %s",past:"hace %s",s:"unos segundos",m:"un minuto",mm:"%d minutos",h:"una hora",hh:"%d horas",d:"un día",dd:"%d días",M:"un mes",MM:"%d meses",y:"un año",yy:"%d años"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("es","es",{closeText:"Cerrar",prevText:"&#x3C;Ant",nextText:"Sig&#x3E;",currentText:"Hoy",monthNames:["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],monthNamesShort:["ene","feb","mar","abr","may","jun","jul","ago","sep","oct","nov","dic"],dayNames:["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],dayNamesShort:["dom","lun","mar","mié","jue","vie","sáb"],dayNamesMin:["D","L","M","X","J","V","S"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("es",{buttonText:{month:"Mes",week:"Semana",day:"Día",list:"Agenda"},allDayHtml:"Todo<br/>el día",eventLimitText:"más"})}(),function(){var a={1:"۱",2:"۲",3:"۳",4:"۴",5:"۵",6:"۶",7:"۷",8:"۸",9:"۹",0:"۰"},n={"۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","۰":"0"};(t.defineLocale||t.lang).call(t,"fa",{months:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),monthsShort:"ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split("_"),weekdays:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysShort:"یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),weekdaysMin:"ی_د_س_چ_پ_ج_ش".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},meridiemParse:/قبل از ظهر|بعد از ظهر/,isPM:function(e){return/بعد از ظهر/.test(e)},meridiem:function(e){return 12>e?"قبل از ظهر":"بعد از ظهر"},calendar:{sameDay:"[امروز ساعت] LT",nextDay:"[فردا ساعت] LT",nextWeek:"dddd [ساعت] LT",lastDay:"[دیروز ساعت] LT",lastWeek:"dddd [پیش] [ساعت] LT",sameElse:"L"},relativeTime:{future:"در %s",past:"%s پیش",s:"چندین ثانیه",m:"یک دقیقه",mm:"%d دقیقه",h:"یک ساعت",hh:"%d ساعت",d:"یک روز",dd:"%d روز",M:"یک ماه",MM:"%d ماه",y:"یک سال",yy:"%d سال"},preparse:function(e){return e.replace(/[۰-۹]/g,function(e){return n[e]}).replace(/،/g,",")},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]}).replace(/,/g,"،")},ordinalParse:/\d{1,2}م/,ordinal:"%dم",week:{dow:6,doy:12}}),e.fullCalendar.datepickerLang("fa","fa",{closeText:"بستن",prevText:"&#x3C;قبلی",nextText:"بعدی&#x3E;",currentText:"امروز",monthNames:["ژانویه","فوریه","مارس","آوریل","مه","ژوئن","ژوئیه","اوت","سپتامبر","اکتبر","نوامبر","دسامبر"],monthNamesShort:["1","2","3","4","5","6","7","8","9","10","11","12"],dayNames:["يکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"],dayNamesShort:["ی","د","س","چ","پ","ج","ش"],dayNamesMin:["ی","د","س","چ","پ","ج","ش"],weekHeader:"هف",dateFormat:"yy/mm/dd",firstDay:6,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("fa",{buttonText:{month:"ماه",week:"هفته",day:"روز",list:"برنامه"},allDayText:"تمام روز",eventLimitText:function(e){return"بیش از "+e
}})}(),function(){function a(e,t,a,r){var i="";switch(a){case"s":return r?"muutaman sekunnin":"muutama sekunti";case"m":return r?"minuutin":"minuutti";case"mm":i=r?"minuutin":"minuuttia";break;case"h":return r?"tunnin":"tunti";case"hh":i=r?"tunnin":"tuntia";break;case"d":return r?"päivän":"päivä";case"dd":i=r?"päivän":"päivää";break;case"M":return r?"kuukauden":"kuukausi";case"MM":i=r?"kuukauden":"kuukautta";break;case"y":return r?"vuoden":"vuosi";case"yy":i=r?"vuoden":"vuotta"}return i=n(e,r)+" "+i}function n(e,t){return 10>e?t?i[e]:r[e]:e}var r="nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(" "),i=["nolla","yhden","kahden","kolmen","neljän","viiden","kuuden",r[7],r[8],r[9]];(t.defineLocale||t.lang).call(t,"fi",{months:"tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split("_"),monthsShort:"tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split("_"),weekdays:"sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split("_"),weekdaysShort:"su_ma_ti_ke_to_pe_la".split("_"),weekdaysMin:"su_ma_ti_ke_to_pe_la".split("_"),longDateFormat:{LT:"HH.mm",LTS:"HH.mm.ss",L:"DD.MM.YYYY",LL:"Do MMMM[ta] YYYY",LLL:"Do MMMM[ta] YYYY, [klo] LT",LLLL:"dddd, Do MMMM[ta] YYYY, [klo] LT",l:"D.M.YYYY",ll:"Do MMM YYYY",lll:"Do MMM YYYY, [klo] LT",llll:"ddd, Do MMM YYYY, [klo] LT"},calendar:{sameDay:"[tänään] [klo] LT",nextDay:"[huomenna] [klo] LT",nextWeek:"dddd [klo] LT",lastDay:"[eilen] [klo] LT",lastWeek:"[viime] dddd[na] [klo] LT",sameElse:"L"},relativeTime:{future:"%s päästä",past:"%s sitten",s:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("fi","fi",{closeText:"Sulje",prevText:"&#xAB;Edellinen",nextText:"Seuraava&#xBB;",currentText:"Tänään",monthNames:["Tammikuu","Helmikuu","Maaliskuu","Huhtikuu","Toukokuu","Kesäkuu","Heinäkuu","Elokuu","Syyskuu","Lokakuu","Marraskuu","Joulukuu"],monthNamesShort:["Tammi","Helmi","Maalis","Huhti","Touko","Kesä","Heinä","Elo","Syys","Loka","Marras","Joulu"],dayNamesShort:["Su","Ma","Ti","Ke","To","Pe","La"],dayNames:["Sunnuntai","Maanantai","Tiistai","Keskiviikko","Torstai","Perjantai","Lauantai"],dayNamesMin:["Su","Ma","Ti","Ke","To","Pe","La"],weekHeader:"Vk",dateFormat:"d.m.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("fi",{buttonText:{month:"Kuukausi",week:"Viikko",day:"Päivä",list:"Tapahtumat"},allDayText:"Koko päivä",eventLimitText:"lisää"})}(),function(){(t.defineLocale||t.lang).call(t,"fr-ca",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|)/,ordinal:function(e){return e+(1===e?"er":"")}}),e.fullCalendar.datepickerLang("fr-ca","fr-CA",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"yy-mm-dd",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("fr-ca",{buttonText:{month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus"})}(),function(){(t.defineLocale||t.lang).call(t,"fr",{months:"janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"),monthsShort:"janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"),weekdays:"dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),weekdaysShort:"dim._lun._mar._mer._jeu._ven._sam.".split("_"),weekdaysMin:"Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[Aujourd'hui à] LT",nextDay:"[Demain à] LT",nextWeek:"dddd [à] LT",lastDay:"[Hier à] LT",lastWeek:"dddd [dernier à] LT",sameElse:"L"},relativeTime:{future:"dans %s",past:"il y a %s",s:"quelques secondes",m:"une minute",mm:"%d minutes",h:"une heure",hh:"%d heures",d:"un jour",dd:"%d jours",M:"un mois",MM:"%d mois",y:"un an",yy:"%d ans"},ordinalParse:/\d{1,2}(er|)/,ordinal:function(e){return e+(1===e?"er":"")},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("fr","fr",{closeText:"Fermer",prevText:"Précédent",nextText:"Suivant",currentText:"Aujourd'hui",monthNames:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthNamesShort:["janv.","févr.","mars","avr.","mai","juin","juil.","août","sept.","oct.","nov.","déc."],dayNames:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],dayNamesShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],dayNamesMin:["D","L","M","M","J","V","S"],weekHeader:"Sem.",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("fr",{buttonText:{month:"Mois",week:"Semaine",day:"Jour",list:"Mon planning"},allDayHtml:"Toute la<br/>journée",eventLimitText:"en plus"})}(),function(){(t.defineLocale||t.lang).call(t,"he",{months:"ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split("_"),monthsShort:"ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split("_"),weekdays:"ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),weekdaysShort:"א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),weekdaysMin:"א_ב_ג_ד_ה_ו_ש".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D [ב]MMMM YYYY",LLL:"D [ב]MMMM YYYY LT",LLLL:"dddd, D [ב]MMMM YYYY LT",l:"D/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY LT",llll:"ddd, D MMM YYYY LT"},calendar:{sameDay:"[היום ב־]LT",nextDay:"[מחר ב־]LT",nextWeek:"dddd [בשעה] LT",lastDay:"[אתמול ב־]LT",lastWeek:"[ביום] dddd [האחרון בשעה] LT",sameElse:"L"},relativeTime:{future:"בעוד %s",past:"לפני %s",s:"מספר שניות",m:"דקה",mm:"%d דקות",h:"שעה",hh:function(e){return 2===e?"שעתיים":e+" שעות"},d:"יום",dd:function(e){return 2===e?"יומיים":e+" ימים"},M:"חודש",MM:function(e){return 2===e?"חודשיים":e+" חודשים"},y:"שנה",yy:function(e){return 2===e?"שנתיים":0===e%10&&10!==e?e+" שנה":e+" שנים"}}}),e.fullCalendar.datepickerLang("he","he",{closeText:"סגור",prevText:"&#x3C;הקודם",nextText:"הבא&#x3E;",currentText:"היום",monthNames:["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],monthNamesShort:["ינו","פבר","מרץ","אפר","מאי","יוני","יולי","אוג","ספט","אוק","נוב","דצמ"],dayNames:["ראשון","שני","שלישי","רביעי","חמישי","שישי","שבת"],dayNamesShort:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],dayNamesMin:["א'","ב'","ג'","ד'","ה'","ו'","שבת"],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!0,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("he",{defaultButtonText:{month:"חודש",week:"שבוע",day:"יום",list:"סדר יום"},weekNumberTitle:"שבוע",allDayText:"כל היום",eventLimitText:"אחר"})}(),function(){var a={1:"१",2:"२",3:"३",4:"४",5:"५",6:"६",7:"७",8:"८",9:"९",0:"०"},n={"१":"1","२":"2","३":"3","४":"4","५":"5","६":"6","७":"7","८":"8","९":"9","०":"0"};(t.defineLocale||t.lang).call(t,"hi",{months:"जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split("_"),monthsShort:"जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split("_"),weekdays:"रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),weekdaysShort:"रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),weekdaysMin:"र_सो_मं_बु_गु_शु_श".split("_"),longDateFormat:{LT:"A h:mm बजे",LTS:"A h:mm:ss बजे",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY, LT",LLLL:"dddd, D MMMM YYYY, LT"},calendar:{sameDay:"[आज] LT",nextDay:"[कल] LT",nextWeek:"dddd, LT",lastDay:"[कल] LT",lastWeek:"[पिछले] dddd, LT",sameElse:"L"},relativeTime:{future:"%s में",past:"%s पहले",s:"कुछ ही क्षण",m:"एक मिनट",mm:"%d मिनट",h:"एक घंटा",hh:"%d घंटे",d:"एक दिन",dd:"%d दिन",M:"एक महीने",MM:"%d महीने",y:"एक वर्ष",yy:"%d वर्ष"},preparse:function(e){return e.replace(/[१२३४५६७८९०]/g,function(e){return n[e]})},postformat:function(e){return e.replace(/\d/g,function(e){return a[e]})},meridiemParse:/रात|सुबह|दोपहर|शाम/,meridiemHour:function(e,t){return 12===e&&(e=0),"रात"===t?4>e?e:e+12:"सुबह"===t?e:"दोपहर"===t?e>=10?e:e+12:"शाम"===t?e+12:void 0},meridiem:function(e){return 4>e?"रात":10>e?"सुबह":17>e?"दोपहर":20>e?"शाम":"रात"},week:{dow:0,doy:6}}),e.fullCalendar.datepickerLang("hi","hi",{closeText:"बंद",prevText:"पिछला",nextText:"अगला",currentText:"आज",monthNames:["जनवरी ","फरवरी","मार्च","अप्रेल","मई","जून","जूलाई","अगस्त ","सितम्बर","अक्टूबर","नवम्बर","दिसम्बर"],monthNamesShort:["जन","फर","मार्च","अप्रेल","मई","जून","जूलाई","अग","सित","अक्ट","नव","दि"],dayNames:["रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार"],dayNamesShort:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],dayNamesMin:["रवि","सोम","मंगल","बुध","गुरु","शुक्र","शनि"],weekHeader:"हफ्ता",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("hi",{buttonText:{month:"महीना",week:"सप्ताह",day:"दिन",list:"कार्यसूची"},allDayText:"सभी दिन",eventLimitText:function(e){return"+अधिक "+e}})}(),function(){function a(e,t,a){var n=e+" ";switch(a){case"m":return t?"jedna minuta":"jedne minute";case"mm":return n+=1===e?"minuta":2===e||3===e||4===e?"minute":"minuta";case"h":return t?"jedan sat":"jednog sata";case"hh":return n+=1===e?"sat":2===e||3===e||4===e?"sata":"sati";case"dd":return n+=1===e?"dan":"dana";case"MM":return n+=1===e?"mjesec":2===e||3===e||4===e?"mjeseca":"mjeseci";case"yy":return n+=1===e?"godina":2===e||3===e||4===e?"godine":"godina"}}(t.defineLocale||t.lang).call(t,"hr",{months:"sječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split("_"),monthsShort:"sje._vel._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split("_"),weekdays:"nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split("_"),weekdaysShort:"ned._pon._uto._sri._čet._pet._sub.".split("_"),weekdaysMin:"ne_po_ut_sr_če_pe_su".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedjelju] [u] LT";case 3:return"[u] [srijedu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[jučer u] LT",lastWeek:function(){switch(this.day()){case 0:case 3:return"[prošlu] dddd [u] LT";case 6:return"[prošle] [subote] [u] LT";case 1:case 2:case 4:case 5:return"[prošli] dddd [u] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"prije %s",s:"par sekundi",m:a,mm:a,h:a,hh:a,d:"dan",dd:a,M:"mjesec",MM:a,y:"godinu",yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("hr","hr",{closeText:"Zatvori",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Danas",monthNames:["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],monthNamesShort:["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],dayNames:["Nedjelja","Ponedjeljak","Utorak","Srijeda","Četvrtak","Petak","Subota"],dayNamesShort:["Ned","Pon","Uto","Sri","Čet","Pet","Sub"],dayNamesMin:["Ne","Po","Ut","Sr","Če","Pe","Su"],weekHeader:"Tje",dateFormat:"dd.mm.yy.",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("hr",{buttonText:{month:"Mjesec",week:"Tjedan",day:"Dan",list:"Raspored"},allDayText:"Cijeli dan",eventLimitText:function(e){return"+ još "+e}})}(),function(){function a(e,t,a,n){var r=e;switch(a){case"s":return n||t?"néhány másodperc":"néhány másodperce";case"m":return"egy"+(n||t?" perc":" perce");case"mm":return r+(n||t?" perc":" perce");case"h":return"egy"+(n||t?" óra":" órája");case"hh":return r+(n||t?" óra":" órája");case"d":return"egy"+(n||t?" nap":" napja");case"dd":return r+(n||t?" nap":" napja");case"M":return"egy"+(n||t?" hónap":" hónapja");case"MM":return r+(n||t?" hónap":" hónapja");case"y":return"egy"+(n||t?" év":" éve");case"yy":return r+(n||t?" év":" éve")}return""}function n(e){return(e?"":"[múlt] ")+"["+r[this.day()]+"] LT[-kor]"}var r="vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(" ");(t.defineLocale||t.lang).call(t,"hu",{months:"január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split("_"),monthsShort:"jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec".split("_"),weekdays:"vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),weekdaysShort:"vas_hét_kedd_sze_csüt_pén_szo".split("_"),weekdaysMin:"v_h_k_sze_cs_p_szo".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"YYYY.MM.DD.",LL:"YYYY. MMMM D.",LLL:"YYYY. MMMM D., LT",LLLL:"YYYY. MMMM D., dddd LT"},meridiemParse:/de|du/i,isPM:function(e){return"u"===e.charAt(1).toLowerCase()},meridiem:function(e,t,a){return 12>e?a===!0?"de":"DE":a===!0?"du":"DU"},calendar:{sameDay:"[ma] LT[-kor]",nextDay:"[holnap] LT[-kor]",nextWeek:function(){return n.call(this,!0)},lastDay:"[tegnap] LT[-kor]",lastWeek:function(){return n.call(this,!1)},sameElse:"L"},relativeTime:{future:"%s múlva",past:"%s",s:a,m:a,mm:a,h:a,hh:a,d:a,dd:a,M:a,MM:a,y:a,yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("hu","hu",{closeText:"bezár",prevText:"vissza",nextText:"előre",currentText:"ma",monthNames:["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],monthNamesShort:["Jan","Feb","Már","Ápr","Máj","Jún","Júl","Aug","Szep","Okt","Nov","Dec"],dayNames:["Vasárnap","Hétfő","Kedd","Szerda","Csütörtök","Péntek","Szombat"],dayNamesShort:["Vas","Hét","Ked","Sze","Csü","Pén","Szo"],dayNamesMin:["V","H","K","Sze","Cs","P","Szo"],weekHeader:"Hét",dateFormat:"yy.mm.dd.",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),e.fullCalendar.lang("hu",{buttonText:{month:"Hónap",week:"Hét",day:"Nap",list:"Napló"},allDayText:"Egész nap",eventLimitText:"további"})}(),function(){(t.defineLocale||t.lang).call(t,"id",{months:"Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split("_"),monthsShort:"Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des".split("_"),weekdays:"Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),weekdaysShort:"Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),weekdaysMin:"Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),longDateFormat:{LT:"HH.mm",LTS:"LT.ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY [pukul] LT",LLLL:"dddd, D MMMM YYYY [pukul] LT"},meridiemParse:/pagi|siang|sore|malam/,meridiemHour:function(e,t){return 12===e&&(e=0),"pagi"===t?e:"siang"===t?e>=11?e:e+12:"sore"===t||"malam"===t?e+12:void 0},meridiem:function(e){return 11>e?"pagi":15>e?"siang":19>e?"sore":"malam"},calendar:{sameDay:"[Hari ini pukul] LT",nextDay:"[Besok pukul] LT",nextWeek:"dddd [pukul] LT",lastDay:"[Kemarin pukul] LT",lastWeek:"dddd [lalu pukul] LT",sameElse:"L"},relativeTime:{future:"dalam %s",past:"%s yang lalu",s:"beberapa detik",m:"semenit",mm:"%d menit",h:"sejam",hh:"%d jam",d:"sehari",dd:"%d hari",M:"sebulan",MM:"%d bulan",y:"setahun",yy:"%d tahun"},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("id","id",{closeText:"Tutup",prevText:"&#x3C;mundur",nextText:"maju&#x3E;",currentText:"hari ini",monthNames:["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","Nopember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agus","Sep","Okt","Nop","Des"],dayNames:["Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu"],dayNamesShort:["Min","Sen","Sel","Rab","kam","Jum","Sab"],dayNamesMin:["Mg","Sn","Sl","Rb","Km","jm","Sb"],weekHeader:"Mg",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("id",{buttonText:{month:"Bulan",week:"Minggu",day:"Hari",list:"Agenda"},allDayHtml:"Sehari<br/>penuh",eventLimitText:"lebih"})}(),function(){function a(e){return 11===e%100?!0:1===e%10?!1:!0}function n(e,t,n,r){var i=e+" ";switch(n){case"s":return t||r?"nokkrar sekúndur":"nokkrum sekúndum";case"m":return t?"mínúta":"mínútu";case"mm":return a(e)?i+(t||r?"mínútur":"mínútum"):t?i+"mínúta":i+"mínútu";case"hh":return a(e)?i+(t||r?"klukkustundir":"klukkustundum"):i+"klukkustund";case"d":return t?"dagur":r?"dag":"degi";case"dd":return a(e)?t?i+"dagar":i+(r?"daga":"dögum"):t?i+"dagur":i+(r?"dag":"degi");case"M":return t?"mánuður":r?"mánuð":"mánuði";case"MM":return a(e)?t?i+"mánuðir":i+(r?"mánuði":"mánuðum"):t?i+"mánuður":i+(r?"mánuð":"mánuði");case"y":return t||r?"ár":"ári";case"yy":return a(e)?i+(t||r?"ár":"árum"):i+(t||r?"ár":"ári")}}(t.defineLocale||t.lang).call(t,"is",{months:"janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split("_"),monthsShort:"jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),weekdays:"sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split("_"),weekdaysShort:"sun_mán_þri_mið_fim_fös_lau".split("_"),weekdaysMin:"Su_Má_Þr_Mi_Fi_Fö_La".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] LT",LLLL:"dddd, D. MMMM YYYY [kl.] LT"},calendar:{sameDay:"[í dag kl.] LT",nextDay:"[á morgun kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[í gær kl.] LT",lastWeek:"[síðasta] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"eftir %s",past:"fyrir %s síðan",s:n,m:n,mm:n,h:"klukkustund",hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("is","is",{closeText:"Loka",prevText:"&#x3C; Fyrri",nextText:"Næsti &#x3E;",currentText:"Í dag",monthNames:["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],monthNamesShort:["Jan","Feb","Mar","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],dayNames:["Sunnudagur","Mánudagur","Þriðjudagur","Miðvikudagur","Fimmtudagur","Föstudagur","Laugardagur"],dayNamesShort:["Sun","Mán","Þri","Mið","Fim","Fös","Lau"],dayNamesMin:["Su","Má","Þr","Mi","Fi","Fö","La"],weekHeader:"Vika",dateFormat:"dd.mm.yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("is",{buttonText:{month:"Mánuður",week:"Vika",day:"Dagur",list:"Dagskrá"},allDayHtml:"Allan<br/>daginn",eventLimitText:"meira"})}(),function(){(t.defineLocale||t.lang).call(t,"it",{months:"gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split("_"),monthsShort:"gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),weekdays:"Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato".split("_"),weekdaysShort:"Dom_Lun_Mar_Mer_Gio_Ven_Sab".split("_"),weekdaysMin:"D_L_Ma_Me_G_V_S".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[Oggi alle] LT",nextDay:"[Domani alle] LT",nextWeek:"dddd [alle] LT",lastDay:"[Ieri alle] LT",lastWeek:function(){switch(this.day()){case 0:return"[la scorsa] dddd [alle] LT";default:return"[lo scorso] dddd [alle] LT"}},sameElse:"L"},relativeTime:{future:function(e){return(/^[0-9].+$/.test(e)?"tra":"in")+" "+e},past:"%s fa",s:"alcuni secondi",m:"un minuto",mm:"%d minuti",h:"un'ora",hh:"%d ore",d:"un giorno",dd:"%d giorni",M:"un mese",MM:"%d mesi",y:"un anno",yy:"%d anni"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("it","it",{closeText:"Chiudi",prevText:"&#x3C;Prec",nextText:"Succ&#x3E;",currentText:"Oggi",monthNames:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthNamesShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],dayNames:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],dayNamesShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],dayNamesMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("it",{buttonText:{month:"Mese",week:"Settimana",day:"Giorno",list:"Agenda"},allDayHtml:"Tutto il<br/>giorno",eventLimitText:function(e){return"+altri "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"ja",{months:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split("_"),weekdaysShort:"日_月_火_水_木_金_土".split("_"),weekdaysMin:"日_月_火_水_木_金_土".split("_"),longDateFormat:{LT:"Ah時m分",LTS:"LTs秒",L:"YYYY/MM/DD",LL:"YYYY年M月D日",LLL:"YYYY年M月D日LT",LLLL:"YYYY年M月D日LT dddd"},meridiemParse:/午前|午後/i,isPM:function(e){return"午後"===e},meridiem:function(e){return 12>e?"午前":"午後"},calendar:{sameDay:"[今日] LT",nextDay:"[明日] LT",nextWeek:"[来週]dddd LT",lastDay:"[昨日] LT",lastWeek:"[前週]dddd LT",sameElse:"L"},relativeTime:{future:"%s後",past:"%s前",s:"数秒",m:"1分",mm:"%d分",h:"1時間",hh:"%d時間",d:"1日",dd:"%d日",M:"1ヶ月",MM:"%dヶ月",y:"1年",yy:"%d年"}}),e.fullCalendar.datepickerLang("ja","ja",{closeText:"閉じる",prevText:"&#x3C;前",nextText:"次&#x3E;",currentText:"今日",monthNames:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],monthNamesShort:["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],dayNames:["日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日"],dayNamesShort:["日","月","火","水","木","金","土"],dayNamesMin:["日","月","火","水","木","金","土"],weekHeader:"週",dateFormat:"yy/mm/dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.lang("ja",{buttonText:{month:"月",week:"週",day:"日",list:"予定リスト"},allDayText:"終日",eventLimitText:function(e){return"他 "+e+" 件"}})}(),function(){(t.defineLocale||t.lang).call(t,"ko",{months:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),monthsShort:"1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),weekdays:"일요일_월요일_화요일_수요일_목요일_금요일_토요일".split("_"),weekdaysShort:"일_월_화_수_목_금_토".split("_"),weekdaysMin:"일_월_화_수_목_금_토".split("_"),longDateFormat:{LT:"A h시 m분",LTS:"A h시 m분 s초",L:"YYYY.MM.DD",LL:"YYYY년 MMMM D일",LLL:"YYYY년 MMMM D일 LT",LLLL:"YYYY년 MMMM D일 dddd LT"},calendar:{sameDay:"오늘 LT",nextDay:"내일 LT",nextWeek:"dddd LT",lastDay:"어제 LT",lastWeek:"지난주 dddd LT",sameElse:"L"},relativeTime:{future:"%s 후",past:"%s 전",s:"몇초",ss:"%d초",m:"일분",mm:"%d분",h:"한시간",hh:"%d시간",d:"하루",dd:"%d일",M:"한달",MM:"%d달",y:"일년",yy:"%d년"},ordinalParse:/\d{1,2}일/,ordinal:"%d일",meridiemParse:/오전|오후/,isPM:function(e){return"오후"===e},meridiem:function(e){return 12>e?"오전":"오후"}}),e.fullCalendar.datepickerLang("ko","ko",{closeText:"닫기",prevText:"이전달",nextText:"다음달",currentText:"오늘",monthNames:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],monthNamesShort:["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],dayNames:["일요일","월요일","화요일","수요일","목요일","금요일","토요일"],dayNamesShort:["일","월","화","수","목","금","토"],dayNamesMin:["일","월","화","수","목","금","토"],weekHeader:"Wk",dateFormat:"yy-mm-dd",firstDay:0,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"년"}),e.fullCalendar.lang("ko",{buttonText:{month:"월",week:"주",day:"일",list:"일정목록"},allDayText:"종일",eventLimitText:"개"})}(),function(){function a(e,t,a,n){return t?"kelios sekundės":n?"kelių sekundžių":"kelias sekundes"}function n(e,t,a,n){return t?i(a)[0]:n?i(a)[1]:i(a)[2]}function r(e){return 0===e%10||e>10&&20>e}function i(e){return d[e].split("_")}function s(e,t,a,s){var o=e+" ";return 1===e?o+n(e,t,a[0],s):t?o+(r(e)?i(a)[1]:i(a)[0]):s?o+i(a)[1]:o+(r(e)?i(a)[1]:i(a)[2])}function o(e,t){var a=-1===t.indexOf("dddd HH:mm"),n=l[e.day()];return a?n:n.substring(0,n.length-2)+"į"}var d={m:"minutė_minutės_minutę",mm:"minutės_minučių_minutes",h:"valanda_valandos_valandą",hh:"valandos_valandų_valandas",d:"diena_dienos_dieną",dd:"dienos_dienų_dienas",M:"mėnuo_mėnesio_mėnesį",MM:"mėnesiai_mėnesių_mėnesius",y:"metai_metų_metus",yy:"metai_metų_metus"},l="sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split("_");(t.defineLocale||t.lang).call(t,"lt",{months:"sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split("_"),monthsShort:"sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),weekdays:o,weekdaysShort:"Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),weekdaysMin:"S_P_A_T_K_Pn_Š".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"YYYY-MM-DD",LL:"YYYY [m.] MMMM D [d.]",LLL:"YYYY [m.] MMMM D [d.], LT [val.]",LLLL:"YYYY [m.] MMMM D [d.], dddd, LT [val.]",l:"YYYY-MM-DD",ll:"YYYY [m.] MMMM D [d.]",lll:"YYYY [m.] MMMM D [d.], LT [val.]",llll:"YYYY [m.] MMMM D [d.], ddd, LT [val.]"},calendar:{sameDay:"[Šiandien] LT",nextDay:"[Rytoj] LT",nextWeek:"dddd LT",lastDay:"[Vakar] LT",lastWeek:"[Praėjusį] dddd LT",sameElse:"L"},relativeTime:{future:"po %s",past:"prieš %s",s:a,m:n,mm:s,h:n,hh:s,d:n,dd:s,M:n,MM:s,y:n,yy:s},ordinalParse:/\d{1,2}-oji/,ordinal:function(e){return e+"-oji"},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("lt","lt",{closeText:"Uždaryti",prevText:"&#x3C;Atgal",nextText:"Pirmyn&#x3E;",currentText:"Šiandien",monthNames:["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],monthNamesShort:["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],dayNames:["sekmadienis","pirmadienis","antradienis","trečiadienis","ketvirtadienis","penktadienis","šeštadienis"],dayNamesShort:["sek","pir","ant","tre","ket","pen","šeš"],dayNamesMin:["Se","Pr","An","Tr","Ke","Pe","Še"],weekHeader:"SAV",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:""}),e.fullCalendar.lang("lt",{buttonText:{month:"Mėnuo",week:"Savaitė",day:"Diena",list:"Darbotvarkė"},allDayText:"Visą dieną",eventLimitText:"daugiau"})}(),function(){function a(e,t,a){var n=e.split("_");return a?1===t%10&&11!==t?n[2]:n[3]:1===t%10&&11!==t?n[0]:n[1]}function n(e,t,n){return e+" "+a(r[n],e,t)}var r={mm:"minūti_minūtes_minūte_minūtes",hh:"stundu_stundas_stunda_stundas",dd:"dienu_dienas_diena_dienas",MM:"mēnesi_mēnešus_mēnesis_mēneši",yy:"gadu_gadus_gads_gadi"};(t.defineLocale||t.lang).call(t,"lv",{months:"janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split("_"),monthsShort:"jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),weekdays:"svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split("_"),weekdaysShort:"Sv_P_O_T_C_Pk_S".split("_"),weekdaysMin:"Sv_P_O_T_C_Pk_S".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"YYYY. [gada] D. MMMM",LLL:"YYYY. [gada] D. MMMM, LT",LLLL:"YYYY. [gada] D. MMMM, dddd, LT"},calendar:{sameDay:"[Šodien pulksten] LT",nextDay:"[Rīt pulksten] LT",nextWeek:"dddd [pulksten] LT",lastDay:"[Vakar pulksten] LT",lastWeek:"[Pagājušā] dddd [pulksten] LT",sameElse:"L"},relativeTime:{future:"%s vēlāk",past:"%s agrāk",s:"dažas sekundes",m:"minūti",mm:n,h:"stundu",hh:n,d:"dienu",dd:n,M:"mēnesi",MM:n,y:"gadu",yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("lv","lv",{closeText:"Aizvērt",prevText:"Iepr.",nextText:"Nāk.",currentText:"Šodien",monthNames:["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],monthNamesShort:["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],dayNames:["svētdiena","pirmdiena","otrdiena","trešdiena","ceturtdiena","piektdiena","sestdiena"],dayNamesShort:["svt","prm","otr","tre","ctr","pkt","sst"],dayNamesMin:["Sv","Pr","Ot","Tr","Ct","Pk","Ss"],weekHeader:"Ned.",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("lv",{buttonText:{month:"Mēnesis",week:"Nedēļa",day:"Diena",list:"Dienas kārtība"},allDayText:"Visu dienu",eventLimitText:function(e){return"+vēl "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"nb",{months:"januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split("_"),monthsShort:"jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),weekdays:"søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),weekdaysShort:"søn_man_tirs_ons_tors_fre_lør".split("_"),weekdaysMin:"sø_ma_ti_on_to_fr_lø".split("_"),longDateFormat:{LT:"H.mm",LTS:"LT.ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY [kl.] LT",LLLL:"dddd D. MMMM YYYY [kl.] LT"},calendar:{sameDay:"[i dag kl.] LT",nextDay:"[i morgen kl.] LT",nextWeek:"dddd [kl.] LT",lastDay:"[i går kl.] LT",lastWeek:"[forrige] dddd [kl.] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"for %s siden",s:"noen sekunder",m:"ett minutt",mm:"%d minutter",h:"en time",hh:"%d timer",d:"en dag",dd:"%d dager",M:"en måned",MM:"%d måneder",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("nb","nb",{closeText:"Lukk",prevText:"&#xAB;Forrige",nextText:"Neste&#xBB;",currentText:"I dag",monthNames:["januar","februar","mars","april","mai","juni","juli","august","september","oktober","november","desember"],monthNamesShort:["jan","feb","mar","apr","mai","jun","jul","aug","sep","okt","nov","des"],dayNamesShort:["søn","man","tir","ons","tor","fre","lør"],dayNames:["søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag"],dayNamesMin:["sø","ma","ti","on","to","fr","lø"],weekHeader:"Uke",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("nb",{buttonText:{month:"Måned",week:"Uke",day:"Dag",list:"Agenda"},allDayText:"Hele dagen",eventLimitText:"til"})}(),function(){var a="jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split("_"),n="jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_");(t.defineLocale||t.lang).call(t,"nl",{months:"januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split("_"),monthsShort:function(e,t){return/-MMM-/.test(t)?n[e.month()]:a[e.month()]},weekdays:"zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split("_"),weekdaysShort:"zo._ma._di._wo._do._vr._za.".split("_"),weekdaysMin:"Zo_Ma_Di_Wo_Do_Vr_Za".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD-MM-YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[vandaag om] LT",nextDay:"[morgen om] LT",nextWeek:"dddd [om] LT",lastDay:"[gisteren om] LT",lastWeek:"[afgelopen] dddd [om] LT",sameElse:"L"},relativeTime:{future:"over %s",past:"%s geleden",s:"een paar seconden",m:"één minuut",mm:"%d minuten",h:"één uur",hh:"%d uur",d:"één dag",dd:"%d dagen",M:"één maand",MM:"%d maanden",y:"één jaar",yy:"%d jaar"},ordinalParse:/\d{1,2}(ste|de)/,ordinal:function(e){return e+(1===e||8===e||e>=20?"ste":"de")},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("nl","nl",{closeText:"Sluiten",prevText:"←",nextText:"→",currentText:"Vandaag",monthNames:["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],monthNamesShort:["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],dayNames:["zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag"],dayNamesShort:["zon","maa","din","woe","don","vri","zat"],dayNamesMin:["zo","ma","di","wo","do","vr","za"],weekHeader:"Wk",dateFormat:"dd-mm-yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("nl",{buttonText:{month:"Maand",week:"Week",day:"Dag",list:"Agenda"},allDayText:"Hele dag",eventLimitText:"extra"})
}(),function(){function a(e){return 5>e%10&&e%10>1&&1!==~~(e/10)%10}function n(e,t,n){var r=e+" ";switch(n){case"m":return t?"minuta":"minutę";case"mm":return r+(a(e)?"minuty":"minut");case"h":return t?"godzina":"godzinę";case"hh":return r+(a(e)?"godziny":"godzin");case"MM":return r+(a(e)?"miesiące":"miesięcy");case"yy":return r+(a(e)?"lata":"lat")}}var r="styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split("_"),i="stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split("_");(t.defineLocale||t.lang).call(t,"pl",{months:function(e,t){return/D MMMM/.test(t)?i[e.month()]:r[e.month()]},monthsShort:"sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),weekdays:"niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split("_"),weekdaysShort:"nie_pon_wt_śr_czw_pt_sb".split("_"),weekdaysMin:"N_Pn_Wt_Śr_Cz_Pt_So".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[Dziś o] LT",nextDay:"[Jutro o] LT",nextWeek:"[W] dddd [o] LT",lastDay:"[Wczoraj o] LT",lastWeek:function(){switch(this.day()){case 0:return"[W zeszłą niedzielę o] LT";case 3:return"[W zeszłą środę o] LT";case 6:return"[W zeszłą sobotę o] LT";default:return"[W zeszły] dddd [o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"%s temu",s:"kilka sekund",m:n,mm:n,h:n,hh:n,d:"1 dzień",dd:"%d dni",M:"miesiąc",MM:n,y:"rok",yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("pl","pl",{closeText:"Zamknij",prevText:"&#x3C;Poprzedni",nextText:"Następny&#x3E;",currentText:"Dziś",monthNames:["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],monthNamesShort:["Sty","Lu","Mar","Kw","Maj","Cze","Lip","Sie","Wrz","Pa","Lis","Gru"],dayNames:["Niedziela","Poniedziałek","Wtorek","Środa","Czwartek","Piątek","Sobota"],dayNamesShort:["Nie","Pn","Wt","Śr","Czw","Pt","So"],dayNamesMin:["N","Pn","Wt","Śr","Cz","Pt","So"],weekHeader:"Tydz",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("pl",{buttonText:{month:"Miesiąc",week:"Tydzień",day:"Dzień",list:"Plan dnia"},allDayText:"Cały dzień",eventLimitText:"więcej"})}(),function(){(t.defineLocale||t.lang).call(t,"pt-br",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_sáb".split("_"),weekdaysMin:"dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY [às] LT",LLLL:"dddd, D [de] MMMM [de] YYYY [às] LT"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"%s atrás",s:"segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº"}),e.fullCalendar.datepickerLang("pt-br","pt-BR",{closeText:"Fechar",prevText:"&#x3C;Anterior",nextText:"Próximo&#x3E;",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sm",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("pt-br",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Compromissos"},allDayText:"dia inteiro",eventLimitText:function(e){return"mais +"+e}})}(),function(){(t.defineLocale||t.lang).call(t,"pt",{months:"janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split("_"),monthsShort:"jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),weekdays:"domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split("_"),weekdaysShort:"dom_seg_ter_qua_qui_sex_sáb".split("_"),weekdaysMin:"dom_2ª_3ª_4ª_5ª_6ª_sáb".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D [de] MMMM [de] YYYY",LLL:"D [de] MMMM [de] YYYY LT",LLLL:"dddd, D [de] MMMM [de] YYYY LT"},calendar:{sameDay:"[Hoje às] LT",nextDay:"[Amanhã às] LT",nextWeek:"dddd [às] LT",lastDay:"[Ontem às] LT",lastWeek:function(){return 0===this.day()||6===this.day()?"[Último] dddd [às] LT":"[Última] dddd [às] LT"},sameElse:"L"},relativeTime:{future:"em %s",past:"há %s",s:"segundos",m:"um minuto",mm:"%d minutos",h:"uma hora",hh:"%d horas",d:"um dia",dd:"%d dias",M:"um mês",MM:"%d meses",y:"um ano",yy:"%d anos"},ordinalParse:/\d{1,2}º/,ordinal:"%dº",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("pt","pt",{closeText:"Fechar",prevText:"Anterior",nextText:"Seguinte",currentText:"Hoje",monthNames:["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],monthNamesShort:["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],dayNames:["Domingo","Segunda-feira","Terça-feira","Quarta-feira","Quinta-feira","Sexta-feira","Sábado"],dayNamesShort:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],dayNamesMin:["Dom","Seg","Ter","Qua","Qui","Sex","Sáb"],weekHeader:"Sem",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("pt",{buttonText:{month:"Mês",week:"Semana",day:"Dia",list:"Agenda"},allDayText:"Todo o dia",eventLimitText:"mais"})}(),function(){function a(e,t,a){var n={mm:"minute",hh:"ore",dd:"zile",MM:"luni",yy:"ani"},r=" ";return(e%100>=20||e>=100&&0===e%100)&&(r=" de "),e+r+n[a]}(t.defineLocale||t.lang).call(t,"ro",{months:"ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split("_"),monthsShort:"ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split("_"),weekdays:"duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split("_"),weekdaysShort:"Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),weekdaysMin:"Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY H:mm",LLLL:"dddd, D MMMM YYYY H:mm"},calendar:{sameDay:"[azi la] LT",nextDay:"[mâine la] LT",nextWeek:"dddd [la] LT",lastDay:"[ieri la] LT",lastWeek:"[fosta] dddd [la] LT",sameElse:"L"},relativeTime:{future:"peste %s",past:"%s în urmă",s:"câteva secunde",m:"un minut",mm:a,h:"o oră",hh:a,d:"o zi",dd:a,M:"o lună",MM:a,y:"un an",yy:a},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("ro","ro",{closeText:"Închide",prevText:"&#xAB; Luna precedentă",nextText:"Luna următoare &#xBB;",currentText:"Azi",monthNames:["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],monthNamesShort:["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"],dayNames:["Duminică","Luni","Marţi","Miercuri","Joi","Vineri","Sâmbătă"],dayNamesShort:["Dum","Lun","Mar","Mie","Joi","Vin","Sâm"],dayNamesMin:["Du","Lu","Ma","Mi","Jo","Vi","Sâ"],weekHeader:"Săpt",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ro",{buttonText:{prev:"precedentă",next:"următoare",month:"Lună",week:"Săptămână",day:"Zi",list:"Agendă"},allDayText:"Toată ziua",eventLimitText:function(e){return"+alte "+e}})}(),function(){function a(e,t){var a=e.split("_");return 1===t%10&&11!==t%100?a[0]:t%10>=2&&4>=t%10&&(10>t%100||t%100>=20)?a[1]:a[2]}function n(e,t,n){var r={mm:t?"минута_минуты_минут":"минуту_минуты_минут",hh:"час_часа_часов",dd:"день_дня_дней",MM:"месяц_месяца_месяцев",yy:"год_года_лет"};return"m"===n?t?"минута":"минуту":e+" "+a(r[n],+e)}function r(e,t){var a={nominative:"январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split("_"),accusative:"января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split("_")},n=/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(t)?"accusative":"nominative";return a[n][e.month()]}function i(e,t){var a={nominative:"янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),accusative:"янв_фев_мар_апр_мая_июня_июля_авг_сен_окт_ноя_дек".split("_")},n=/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/.test(t)?"accusative":"nominative";return a[n][e.month()]}function s(e,t){var a={nominative:"воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split("_"),accusative:"воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split("_")},n=/\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/.test(t)?"accusative":"nominative";return a[n][e.day()]}(t.defineLocale||t.lang).call(t,"ru",{months:r,monthsShort:i,weekdays:s,weekdaysShort:"вс_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"вс_пн_вт_ср_чт_пт_сб".split("_"),monthsParse:[/^янв/i,/^фев/i,/^мар/i,/^апр/i,/^ма[й|я]/i,/^июн/i,/^июл/i,/^авг/i,/^сен/i,/^окт/i,/^ноя/i,/^дек/i],longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY г.",LLL:"D MMMM YYYY г., LT",LLLL:"dddd, D MMMM YYYY г., LT"},calendar:{sameDay:"[Сегодня в] LT",nextDay:"[Завтра в] LT",lastDay:"[Вчера в] LT",nextWeek:function(){return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT"},lastWeek:function(e){if(e.week()===this.week())return 2===this.day()?"[Во] dddd [в] LT":"[В] dddd [в] LT";switch(this.day()){case 0:return"[В прошлое] dddd [в] LT";case 1:case 2:case 4:return"[В прошлый] dddd [в] LT";case 3:case 5:case 6:return"[В прошлую] dddd [в] LT"}},sameElse:"L"},relativeTime:{future:"через %s",past:"%s назад",s:"несколько секунд",m:n,mm:n,h:"час",hh:n,d:"день",dd:n,M:"месяц",MM:n,y:"год",yy:n},meridiemParse:/ночи|утра|дня|вечера/i,isPM:function(e){return/^(дня|вечера)$/.test(e)},meridiem:function(e){return 4>e?"ночи":12>e?"утра":17>e?"дня":"вечера"},ordinalParse:/\d{1,2}-(й|го|я)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":return e+"-й";case"D":return e+"-го";case"w":case"W":return e+"-я";default:return e}},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("ru","ru",{closeText:"Закрыть",prevText:"&#x3C;Пред",nextText:"След&#x3E;",currentText:"Сегодня",monthNames:["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],monthNamesShort:["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],dayNames:["воскресенье","понедельник","вторник","среда","четверг","пятница","суббота"],dayNamesShort:["вск","пнд","втр","срд","чтв","птн","сбт"],dayNamesMin:["Вс","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Нед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("ru",{buttonText:{month:"Месяц",week:"Неделя",day:"День",list:"Повестка дня"},allDayText:"Весь день",eventLimitText:function(e){return"+ ещё "+e}})}(),function(){function a(e){return e>1&&5>e}function n(e,t,n,r){var i=e+" ";switch(n){case"s":return t||r?"pár sekúnd":"pár sekundami";case"m":return t?"minúta":r?"minútu":"minútou";case"mm":return t||r?i+(a(e)?"minúty":"minút"):i+"minútami";case"h":return t?"hodina":r?"hodinu":"hodinou";case"hh":return t||r?i+(a(e)?"hodiny":"hodín"):i+"hodinami";case"d":return t||r?"deň":"dňom";case"dd":return t||r?i+(a(e)?"dni":"dní"):i+"dňami";case"M":return t||r?"mesiac":"mesiacom";case"MM":return t||r?i+(a(e)?"mesiace":"mesiacov"):i+"mesiacmi";case"y":return t||r?"rok":"rokom";case"yy":return t||r?i+(a(e)?"roky":"rokov"):i+"rokmi"}}var r="január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split("_"),i="jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");(t.defineLocale||t.lang).call(t,"sk",{months:r,monthsShort:i,monthsParse:function(e,t){var a,n=[];for(a=0;12>a;a++)n[a]=RegExp("^"+e[a]+"$|^"+t[a]+"$","i");return n}(r,i),weekdays:"nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),weekdaysShort:"ne_po_ut_st_št_pi_so".split("_"),weekdaysMin:"ne_po_ut_st_št_pi_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd D. MMMM YYYY LT"},calendar:{sameDay:"[dnes o] LT",nextDay:"[zajtra o] LT",nextWeek:function(){switch(this.day()){case 0:return"[v nedeľu o] LT";case 1:case 2:return"[v] dddd [o] LT";case 3:return"[v stredu o] LT";case 4:return"[vo štvrtok o] LT";case 5:return"[v piatok o] LT";case 6:return"[v sobotu o] LT"}},lastDay:"[včera o] LT",lastWeek:function(){switch(this.day()){case 0:return"[minulú nedeľu o] LT";case 1:case 2:return"[minulý] dddd [o] LT";case 3:return"[minulú stredu o] LT";case 4:case 5:return"[minulý] dddd [o] LT";case 6:return"[minulú sobotu o] LT"}},sameElse:"L"},relativeTime:{future:"za %s",past:"pred %s",s:n,m:n,mm:n,h:n,hh:n,d:n,dd:n,M:n,MM:n,y:n,yy:n},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("sk","sk",{closeText:"Zavrieť",prevText:"&#x3C;Predchádzajúci",nextText:"Nasledujúci&#x3E;",currentText:"Dnes",monthNames:["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],monthNamesShort:["Jan","Feb","Mar","Apr","Máj","Jún","Júl","Aug","Sep","Okt","Nov","Dec"],dayNames:["nedeľa","pondelok","utorok","streda","štvrtok","piatok","sobota"],dayNamesShort:["Ned","Pon","Uto","Str","Štv","Pia","Sob"],dayNamesMin:["Ne","Po","Ut","St","Št","Pia","So"],weekHeader:"Ty",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("sk",{buttonText:{month:"Mesiac",week:"Týždeň",day:"Deň",list:"Rozvrh"},allDayText:"Celý deň",eventLimitText:function(e){return"+ďalšie: "+e}})}(),function(){function a(e,t,a){var n=e+" ";switch(a){case"m":return t?"ena minuta":"eno minuto";case"mm":return n+=1===e?"minuta":2===e?"minuti":3===e||4===e?"minute":"minut";case"h":return t?"ena ura":"eno uro";case"hh":return n+=1===e?"ura":2===e?"uri":3===e||4===e?"ure":"ur";case"dd":return n+=1===e?"dan":"dni";case"MM":return n+=1===e?"mesec":2===e?"meseca":3===e||4===e?"mesece":"mesecev";case"yy":return n+=1===e?"leto":2===e?"leti":3===e||4===e?"leta":"let"}}(t.defineLocale||t.lang).call(t,"sl",{months:"januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split("_"),monthsShort:"jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split("_"),weekdays:"nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),weekdaysShort:"ned._pon._tor._sre._čet._pet._sob.".split("_"),weekdaysMin:"ne_po_to_sr_če_pe_so".split("_"),longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[danes ob] LT",nextDay:"[jutri ob] LT",nextWeek:function(){switch(this.day()){case 0:return"[v] [nedeljo] [ob] LT";case 3:return"[v] [sredo] [ob] LT";case 6:return"[v] [soboto] [ob] LT";case 1:case 2:case 4:case 5:return"[v] dddd [ob] LT"}},lastDay:"[včeraj ob] LT",lastWeek:function(){switch(this.day()){case 0:case 3:case 6:return"[prejšnja] dddd [ob] LT";case 1:case 2:case 4:case 5:return"[prejšnji] dddd [ob] LT"}},sameElse:"L"},relativeTime:{future:"čez %s",past:"%s nazaj",s:"nekaj sekund",m:a,mm:a,h:a,hh:a,d:"en dan",dd:a,M:"en mesec",MM:a,y:"eno leto",yy:a},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("sl","sl",{closeText:"Zapri",prevText:"&#x3C;Prejšnji",nextText:"Naslednji&#x3E;",currentText:"Trenutni",monthNames:["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],dayNames:["Nedelja","Ponedeljek","Torek","Sreda","Četrtek","Petek","Sobota"],dayNamesShort:["Ned","Pon","Tor","Sre","Čet","Pet","Sob"],dayNamesMin:["Ne","Po","To","Sr","Če","Pe","So"],weekHeader:"Teden",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("sl",{buttonText:{month:"Mesec",week:"Teden",day:"Dan",list:"Dnevni red"},allDayText:"Ves dan",eventLimitText:"več"})}(),function(){var a={words:{m:["један минут","једне минуте"],mm:["минут","минуте","минута"],h:["један сат","једног сата"],hh:["сат","сата","сати"],dd:["дан","дана","дана"],MM:["месец","месеца","месеци"],yy:["година","године","година"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&4>=e?t[1]:t[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};(t.defineLocale||t.lang).call(t,"sr-cyrl",{months:["јануар","фебруар","март","април","мај","јун","јул","август","септембар","октобар","новембар","децембар"],monthsShort:["јан.","феб.","мар.","апр.","мај","јун","јул","авг.","сеп.","окт.","нов.","дец."],weekdays:["недеља","понедељак","уторак","среда","четвртак","петак","субота"],weekdaysShort:["нед.","пон.","уто.","сре.","чет.","пет.","суб."],weekdaysMin:["не","по","ут","ср","че","пе","су"],longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[данас у] LT",nextDay:"[сутра у] LT",nextWeek:function(){switch(this.day()){case 0:return"[у] [недељу] [у] LT";case 3:return"[у] [среду] [у] LT";case 6:return"[у] [суботу] [у] LT";case 1:case 2:case 4:case 5:return"[у] dddd [у] LT"}},lastDay:"[јуче у] LT",lastWeek:function(){var e=["[прошле] [недеље] [у] LT","[прошлог] [понедељка] [у] LT","[прошлог] [уторка] [у] LT","[прошле] [среде] [у] LT","[прошлог] [четвртка] [у] LT","[прошлог] [петка] [у] LT","[прошле] [суботе] [у] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"за %s",past:"пре %s",s:"неколико секунди",m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"дан",dd:a.translate,M:"месец",MM:a.translate,y:"годину",yy:a.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("sr-cyrl","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("sr-cyrl",{buttonText:{month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e}})}(),function(){var a={words:{m:["jedan minut","jedne minute"],mm:["minut","minute","minuta"],h:["jedan sat","jednog sata"],hh:["sat","sata","sati"],dd:["dan","dana","dana"],MM:["mesec","meseca","meseci"],yy:["godina","godine","godina"]},correctGrammaticalCase:function(e,t){return 1===e?t[0]:e>=2&&4>=e?t[1]:t[2]},translate:function(e,t,n){var r=a.words[n];return 1===n.length?t?r[0]:r[1]:e+" "+a.correctGrammaticalCase(e,r)}};(t.defineLocale||t.lang).call(t,"sr",{months:["januar","februar","mart","april","maj","jun","jul","avgust","septembar","oktobar","novembar","decembar"],monthsShort:["jan.","feb.","mar.","apr.","maj","jun","jul","avg.","sep.","okt.","nov.","dec."],weekdays:["nedelja","ponedeljak","utorak","sreda","četvrtak","petak","subota"],weekdaysShort:["ned.","pon.","uto.","sre.","čet.","pet.","sub."],weekdaysMin:["ne","po","ut","sr","če","pe","su"],longDateFormat:{LT:"H:mm",LTS:"LT:ss",L:"DD. MM. YYYY",LL:"D. MMMM YYYY",LLL:"D. MMMM YYYY LT",LLLL:"dddd, D. MMMM YYYY LT"},calendar:{sameDay:"[danas u] LT",nextDay:"[sutra u] LT",nextWeek:function(){switch(this.day()){case 0:return"[u] [nedelju] [u] LT";case 3:return"[u] [sredu] [u] LT";case 6:return"[u] [subotu] [u] LT";case 1:case 2:case 4:case 5:return"[u] dddd [u] LT"}},lastDay:"[juče u] LT",lastWeek:function(){var e=["[prošle] [nedelje] [u] LT","[prošlog] [ponedeljka] [u] LT","[prošlog] [utorka] [u] LT","[prošle] [srede] [u] LT","[prošlog] [četvrtka] [u] LT","[prošlog] [petka] [u] LT","[prošle] [subote] [u] LT"];return e[this.day()]},sameElse:"L"},relativeTime:{future:"za %s",past:"pre %s",s:"nekoliko sekundi",m:a.translate,mm:a.translate,h:a.translate,hh:a.translate,d:"dan",dd:a.translate,M:"mesec",MM:a.translate,y:"godinu",yy:a.translate},ordinalParse:/\d{1,2}\./,ordinal:"%d.",week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("sr","sr",{closeText:"Затвори",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Данас",monthNames:["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],monthNamesShort:["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],dayNames:["Недеља","Понедељак","Уторак","Среда","Четвртак","Петак","Субота"],dayNamesShort:["Нед","Пон","Уто","Сре","Чет","Пет","Суб"],dayNamesMin:["Не","По","Ут","Ср","Че","Пе","Су"],weekHeader:"Сед",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("sr",{buttonText:{month:"Месец",week:"Недеља",day:"Дан",list:"Планер"},allDayText:"Цео дан",eventLimitText:function(e){return"+ још "+e}})}(),function(){(t.defineLocale||t.lang).call(t,"sv",{months:"januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split("_"),monthsShort:"jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),weekdays:"söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split("_"),weekdaysShort:"sön_mån_tis_ons_tor_fre_lör".split("_"),weekdaysMin:"sö_må_ti_on_to_fr_lö".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"YYYY-MM-DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd D MMMM YYYY LT"},calendar:{sameDay:"[Idag] LT",nextDay:"[Imorgon] LT",lastDay:"[Igår] LT",nextWeek:"dddd LT",lastWeek:"[Förra] dddd[en] LT",sameElse:"L"},relativeTime:{future:"om %s",past:"för %s sedan",s:"några sekunder",m:"en minut",mm:"%d minuter",h:"en timme",hh:"%d timmar",d:"en dag",dd:"%d dagar",M:"en månad",MM:"%d månader",y:"ett år",yy:"%d år"},ordinalParse:/\d{1,2}(e|a)/,ordinal:function(e){var t=e%10,a=1===~~(e%100/10)?"e":1===t?"a":2===t?"a":3===t?"e":"e";return e+a},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("sv","sv",{closeText:"Stäng",prevText:"&#xAB;Förra",nextText:"Nästa&#xBB;",currentText:"Idag",monthNames:["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],monthNamesShort:["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],dayNamesShort:["Sön","Mån","Tis","Ons","Tor","Fre","Lör"],dayNames:["Söndag","Måndag","Tisdag","Onsdag","Torsdag","Fredag","Lördag"],dayNamesMin:["Sö","Må","Ti","On","To","Fr","Lö"],weekHeader:"Ve",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("sv",{buttonText:{month:"Månad",week:"Vecka",day:"Dag",list:"Program"},allDayText:"Heldag",eventLimitText:"till"})}(),function(){(t.defineLocale||t.lang).call(t,"th",{months:"มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split("_"),monthsShort:"มกรา_กุมภา_มีนา_เมษา_พฤษภา_มิถุนา_กรกฎา_สิงหา_กันยา_ตุลา_พฤศจิกา_ธันวา".split("_"),weekdays:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split("_"),weekdaysShort:"อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split("_"),weekdaysMin:"อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),longDateFormat:{LT:"H นาฬิกา m นาที",LTS:"LT s วินาที",L:"YYYY/MM/DD",LL:"D MMMM YYYY",LLL:"D MMMM YYYY เวลา LT",LLLL:"วันddddที่ D MMMM YYYY เวลา LT"},meridiemParse:/ก่อนเที่ยง|หลังเที่ยง/,isPM:function(e){return"หลังเที่ยง"===e},meridiem:function(e){return 12>e?"ก่อนเที่ยง":"หลังเที่ยง"},calendar:{sameDay:"[วันนี้ เวลา] LT",nextDay:"[พรุ่งนี้ เวลา] LT",nextWeek:"dddd[หน้า เวลา] LT",lastDay:"[เมื่อวานนี้ เวลา] LT",lastWeek:"[วัน]dddd[ที่แล้ว เวลา] LT",sameElse:"L"},relativeTime:{future:"อีก %s",past:"%sที่แล้ว",s:"ไม่กี่วินาที",m:"1 นาที",mm:"%d นาที",h:"1 ชั่วโมง",hh:"%d ชั่วโมง",d:"1 วัน",dd:"%d วัน",M:"1 เดือน",MM:"%d เดือน",y:"1 ปี",yy:"%d ปี"}}),e.fullCalendar.datepickerLang("th","th",{closeText:"ปิด",prevText:"&#xAB;&#xA0;ย้อน",nextText:"ถัดไป&#xA0;&#xBB;",currentText:"วันนี้",monthNames:["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],monthNamesShort:["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],dayNames:["อาทิตย์","จันทร์","อังคาร","พุธ","พฤหัสบดี","ศุกร์","เสาร์"],dayNamesShort:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],dayNamesMin:["อา.","จ.","อ.","พ.","พฤ.","ศ.","ส."],weekHeader:"Wk",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("th",{buttonText:{month:"เดือน",week:"สัปดาห์",day:"วัน",list:"แผนงาน"},allDayText:"ตลอดวัน",eventLimitText:"เพิ่มเติม"})}(),function(){var a={1:"'inci",5:"'inci",8:"'inci",70:"'inci",80:"'inci",2:"'nci",7:"'nci",20:"'nci",50:"'nci",3:"'üncü",4:"'üncü",100:"'üncü",6:"'ncı",9:"'uncu",10:"'uncu",30:"'uncu",60:"'ıncı",90:"'ıncı"};(t.defineLocale||t.lang).call(t,"tr",{months:"Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split("_"),monthsShort:"Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),weekdays:"Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split("_"),weekdaysShort:"Paz_Pts_Sal_Çar_Per_Cum_Cts".split("_"),weekdaysMin:"Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY",LLL:"D MMMM YYYY LT",LLLL:"dddd, D MMMM YYYY LT"},calendar:{sameDay:"[bugün saat] LT",nextDay:"[yarın saat] LT",nextWeek:"[haftaya] dddd [saat] LT",lastDay:"[dün] LT",lastWeek:"[geçen hafta] dddd [saat] LT",sameElse:"L"},relativeTime:{future:"%s sonra",past:"%s önce",s:"birkaç saniye",m:"bir dakika",mm:"%d dakika",h:"bir saat",hh:"%d saat",d:"bir gün",dd:"%d gün",M:"bir ay",MM:"%d ay",y:"bir yıl",yy:"%d yıl"},ordinalParse:/\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,ordinal:function(e){if(0===e)return e+"'ıncı";var t=e%10,n=e%100-t,r=e>=100?100:null;return e+(a[t]||a[n]||a[r])},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("tr","tr",{closeText:"kapat",prevText:"&#x3C;geri",nextText:"ileri&#x3e",currentText:"bugün",monthNames:["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],monthNamesShort:["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],dayNames:["Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi"],dayNamesShort:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],dayNamesMin:["Pz","Pt","Sa","Ça","Pe","Cu","Ct"],weekHeader:"Hf",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("tr",{buttonText:{next:"ileri",month:"Ay",week:"Hafta",day:"Gün",list:"Ajanda"},allDayText:"Tüm gün",eventLimitText:"daha fazla"})}(),function(){function a(e,t){var a=e.split("_");return 1===t%10&&11!==t%100?a[0]:t%10>=2&&4>=t%10&&(10>t%100||t%100>=20)?a[1]:a[2]}function n(e,t,n){var r={mm:"хвилина_хвилини_хвилин",hh:"година_години_годин",dd:"день_дні_днів",MM:"місяць_місяці_місяців",yy:"рік_роки_років"};return"m"===n?t?"хвилина":"хвилину":"h"===n?t?"година":"годину":e+" "+a(r[n],+e)}function r(e,t){var a={nominative:"січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split("_"),accusative:"січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split("_")},n=/D[oD]? *MMMM?/.test(t)?"accusative":"nominative";return a[n][e.month()]}function i(e,t){var a={nominative:"неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split("_"),accusative:"неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split("_"),genitive:"неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split("_")},n=/(\[[ВвУу]\]) ?dddd/.test(t)?"accusative":/\[?(?:минулої|наступної)? ?\] ?dddd/.test(t)?"genitive":"nominative";return a[n][e.day()]}function s(e){return function(){return e+"о"+(11===this.hours()?"б":"")+"] LT"}}(t.defineLocale||t.lang).call(t,"uk",{months:r,monthsShort:"січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split("_"),weekdays:i,weekdaysShort:"нд_пн_вт_ср_чт_пт_сб".split("_"),weekdaysMin:"нд_пн_вт_ср_чт_пт_сб".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD.MM.YYYY",LL:"D MMMM YYYY р.",LLL:"D MMMM YYYY р., LT",LLLL:"dddd, D MMMM YYYY р., LT"},calendar:{sameDay:s("[Сьогодні "),nextDay:s("[Завтра "),lastDay:s("[Вчора "),nextWeek:s("[У] dddd ["),lastWeek:function(){switch(this.day()){case 0:case 3:case 5:case 6:return s("[Минулої] dddd [").call(this);case 1:case 2:case 4:return s("[Минулого] dddd [").call(this)}},sameElse:"L"},relativeTime:{future:"за %s",past:"%s тому",s:"декілька секунд",m:n,mm:n,h:"годину",hh:n,d:"день",dd:n,M:"місяць",MM:n,y:"рік",yy:n},meridiemParse:/ночі|ранку|дня|вечора/,isPM:function(e){return/^(дня|вечора)$/.test(e)},meridiem:function(e){return 4>e?"ночі":12>e?"ранку":17>e?"дня":"вечора"},ordinalParse:/\d{1,2}-(й|го)/,ordinal:function(e,t){switch(t){case"M":case"d":case"DDD":case"w":case"W":return e+"-й";case"D":return e+"-го";default:return e}},week:{dow:1,doy:7}}),e.fullCalendar.datepickerLang("uk","uk",{closeText:"Закрити",prevText:"&#x3C;",nextText:"&#x3E;",currentText:"Сьогодні",monthNames:["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],monthNamesShort:["Січ","Лют","Бер","Кві","Тра","Чер","Лип","Сер","Вер","Жов","Лис","Гру"],dayNames:["неділя","понеділок","вівторок","середа","четвер","п’ятниця","субота"],dayNamesShort:["нед","пнд","вів","срд","чтв","птн","сбт"],dayNamesMin:["Нд","Пн","Вт","Ср","Чт","Пт","Сб"],weekHeader:"Тиж",dateFormat:"dd.mm.yy",firstDay:1,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("uk",{buttonText:{month:"Місяць",week:"Тиждень",day:"День",list:"Порядок денний"},allDayText:"Увесь день",eventLimitText:function(e){return"+ще "+e+"..."}})}(),function(){(t.defineLocale||t.lang).call(t,"vi",{months:"tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split("_"),monthsShort:"Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12".split("_"),weekdays:"chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split("_"),weekdaysShort:"CN_T2_T3_T4_T5_T6_T7".split("_"),weekdaysMin:"CN_T2_T3_T4_T5_T6_T7".split("_"),longDateFormat:{LT:"HH:mm",LTS:"LT:ss",L:"DD/MM/YYYY",LL:"D MMMM [năm] YYYY",LLL:"D MMMM [năm] YYYY LT",LLLL:"dddd, D MMMM [năm] YYYY LT",l:"DD/M/YYYY",ll:"D MMM YYYY",lll:"D MMM YYYY LT",llll:"ddd, D MMM YYYY LT"},calendar:{sameDay:"[Hôm nay lúc] LT",nextDay:"[Ngày mai lúc] LT",nextWeek:"dddd [tuần tới lúc] LT",lastDay:"[Hôm qua lúc] LT",lastWeek:"dddd [tuần rồi lúc] LT",sameElse:"L"},relativeTime:{future:"%s tới",past:"%s trước",s:"vài giây",m:"một phút",mm:"%d phút",h:"một giờ",hh:"%d giờ",d:"một ngày",dd:"%d ngày",M:"một tháng",MM:"%d tháng",y:"một năm",yy:"%d năm"},ordinalParse:/\d{1,2}/,ordinal:function(e){return e},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("vi","vi",{closeText:"Đóng",prevText:"&#x3C;Trước",nextText:"Tiếp&#x3E;",currentText:"Hôm nay",monthNames:["Tháng Một","Tháng Hai","Tháng Ba","Tháng Tư","Tháng Năm","Tháng Sáu","Tháng Bảy","Tháng Tám","Tháng Chín","Tháng Mười","Tháng Mười Một","Tháng Mười Hai"],monthNamesShort:["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],dayNames:["Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy"],dayNamesShort:["CN","T2","T3","T4","T5","T6","T7"],dayNamesMin:["CN","T2","T3","T4","T5","T6","T7"],weekHeader:"Tu",dateFormat:"dd/mm/yy",firstDay:0,isRTL:!1,showMonthAfterYear:!1,yearSuffix:""}),e.fullCalendar.lang("vi",{buttonText:{month:"Tháng",week:"Tuần",day:"Ngày",list:"Lịch biểu"},allDayText:"Cả ngày",eventLimitText:function(e){return"+ thêm "+e
}})}(),function(){(t.defineLocale||t.lang).call(t,"zh-cn",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"周日_周一_周二_周三_周四_周五_周六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah点mm",LTS:"Ah点m分s秒",L:"YYYY-MM-DD",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日LT",LLLL:"YYYY年MMMD日ddddLT",l:"YYYY-MM-DD",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日LT",llll:"YYYY年MMMD日ddddLT"},meridiemParse:/凌晨|早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"凌晨"===t||"早上"===t||"上午"===t?e:"下午"===t||"晚上"===t?e+12:e>=11?e:e+12},meridiem:function(e,t){var a=100*e+t;return 600>a?"凌晨":900>a?"早上":1130>a?"上午":1230>a?"中午":1800>a?"下午":"晚上"},calendar:{sameDay:function(){return 0===this.minutes()?"[今天]Ah[点整]":"[今天]LT"},nextDay:function(){return 0===this.minutes()?"[明天]Ah[点整]":"[明天]LT"},lastDay:function(){return 0===this.minutes()?"[昨天]Ah[点整]":"[昨天]LT"},nextWeek:function(){var e,a;return e=t().startOf("week"),a=this.unix()-e.unix()>=604800?"[下]":"[本]",0===this.minutes()?a+"dddAh点整":a+"dddAh点mm"},lastWeek:function(){var e,a;return e=t().startOf("week"),a=this.unix()<e.unix()?"[上]":"[本]",0===this.minutes()?a+"dddAh点整":a+"dddAh点mm"},sameElse:"LL"},ordinalParse:/\d{1,2}(日|月|周)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"周";default:return e}},relativeTime:{future:"%s内",past:"%s前",s:"几秒",m:"1分钟",mm:"%d分钟",h:"1小时",hh:"%d小时",d:"1天",dd:"%d天",M:"1个月",MM:"%d个月",y:"1年",yy:"%d年"},week:{dow:1,doy:4}}),e.fullCalendar.datepickerLang("zh-cn","zh-CN",{closeText:"关闭",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy-mm-dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.lang("zh-cn",{buttonText:{month:"月",week:"周",day:"日",list:"日程"},allDayText:"全天",eventLimitText:function(e){return"另外 "+e+" 个"}})}(),function(){(t.defineLocale||t.lang).call(t,"zh-tw",{months:"一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split("_"),monthsShort:"1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),weekdays:"星期日_星期一_星期二_星期三_星期四_星期五_星期六".split("_"),weekdaysShort:"週日_週一_週二_週三_週四_週五_週六".split("_"),weekdaysMin:"日_一_二_三_四_五_六".split("_"),longDateFormat:{LT:"Ah點mm",LTS:"Ah點m分s秒",L:"YYYY年MMMD日",LL:"YYYY年MMMD日",LLL:"YYYY年MMMD日LT",LLLL:"YYYY年MMMD日ddddLT",l:"YYYY年MMMD日",ll:"YYYY年MMMD日",lll:"YYYY年MMMD日LT",llll:"YYYY年MMMD日ddddLT"},meridiemParse:/早上|上午|中午|下午|晚上/,meridiemHour:function(e,t){return 12===e&&(e=0),"早上"===t||"上午"===t?e:"中午"===t?e>=11?e:e+12:"下午"===t||"晚上"===t?e+12:void 0},meridiem:function(e,t){var a=100*e+t;return 900>a?"早上":1130>a?"上午":1230>a?"中午":1800>a?"下午":"晚上"},calendar:{sameDay:"[今天]LT",nextDay:"[明天]LT",nextWeek:"[下]ddddLT",lastDay:"[昨天]LT",lastWeek:"[上]ddddLT",sameElse:"L"},ordinalParse:/\d{1,2}(日|月|週)/,ordinal:function(e,t){switch(t){case"d":case"D":case"DDD":return e+"日";case"M":return e+"月";case"w":case"W":return e+"週";default:return e}},relativeTime:{future:"%s內",past:"%s前",s:"幾秒",m:"一分鐘",mm:"%d分鐘",h:"一小時",hh:"%d小時",d:"一天",dd:"%d天",M:"一個月",MM:"%d個月",y:"一年",yy:"%d年"}}),e.fullCalendar.datepickerLang("zh-tw","zh-TW",{closeText:"關閉",prevText:"&#x3C;上月",nextText:"下月&#x3E;",currentText:"今天",monthNames:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],monthNamesShort:["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],dayNames:["星期日","星期一","星期二","星期三","星期四","星期五","星期六"],dayNamesShort:["周日","周一","周二","周三","周四","周五","周六"],dayNamesMin:["日","一","二","三","四","五","六"],weekHeader:"周",dateFormat:"yy/mm/dd",firstDay:1,isRTL:!1,showMonthAfterYear:!0,yearSuffix:"年"}),e.fullCalendar.lang("zh-tw",{buttonText:{month:"月",week:"週",day:"天",list:"待辦事項"},allDayText:"全天",eventLimitText:"更多"})}(),(t.locale||t.lang).call(t,"en"),e.fullCalendar.lang("en"),e.datepicker&&e.datepicker.setDefaults(e.datepicker.regional[""])});
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController(msApi, $scope,$rootScope,video,webtv_clients,webtv_client_images, webtv_client_logo_style,$location, webtv_client_header_style, msNavigationService,logo, webTv_msNavigation, $state,webTvGlobal) {
    var vm = this;
    var parameters = webTvGlobal.$constant().webTvParameterBag();
    vm.isFM=false;
    vm.title = window.process.env.CLIENT_TITLE;
    if (logo.text1) {
      vm.isFM = true;
    }

      if (angular.isUndefined(parameters['app.client.name'])) {
          msApi.request('parametersBagLogin.app@get', function (res) {
              if (angular.isDefined(res.bag)) {
                  parameters = res.bag;
                  vm.url_tv_show = parameters.url_tv;
              }
          });
      }else {
          vm.url_tv_show = parameters.url_tv;
      }
    vm.isNavigationNew=false;
    var video_client;
      angular.forEach(webtv_clients, function (value) {
          if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
              video_client = webtv_client_header_style[value];
          }

      });
      if(video_client){
          video = video_client;
      }
    if(video.isNew){
      vm.isNavigationNew=true;
    }
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.openMenu = openMenu;
    vm.goToUrlMedias = goToUrlMedias;

      vm.redirectTv = function(){
          return vm.url_tv_show;
      };

    // Data
    var hasListener = true;
    vm.bodyEl = angular.element('body');
    vm.folded = false;
    // scroll of the left navigation
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    vm.logoToolbar = {
      "logo_image": logo.image,
      "logo_text": logo.text,
        "logo_image_name" : "assets/clients/empreinte.png",  
        "logo_image_style" : {}
    };

    angular.forEach(webtv_clients, function (value) {
      if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
          vm.image = webtv_client_images[value];
      }

  });
  angular.forEach(webtv_clients, function (value) {
    if ($location.absUrl().split('?')[0].indexOf(value) > -1) {
        vm.logo_style = webtv_client_logo_style[value];
    }

});
if(angular.isUndefined(vm.logo_style)){
  vm.logo_style = {"max-width": "70%"};
}
  if (angular.isUndefined(vm.image) && !vm.isFM) {
      vm.image = "assets/clients/webtv.png";
  }else{
      if(angular.isUndefined(vm.image))
      {
        vm.image = "assets/clients/webtv.png";
      }
  }
      if(video_client && video_client.logo_image_path){
          vm.logoToolbar.logo_image_name = video_client.logo_image_path;
      }
      if(video_client && video_client.logo_image_style){
          vm.logoToolbar.logo_image_style.img = video_client.logo_image_style.img;
          vm.logoToolbar.logo_image_style.span = video_client.logo_image_style.span;
      }
    vm.isLogoImg=false;
    if(video.logo_image){
        vm.logoToolbar.logo_image=video.logo_image;
        vm.isLogoImg=true;
    }
    if(video.logo_text){
        vm.logoToolbar.logo_text=video.logo_text;
    }
      var values_object = Object.keys(webTv_msNavigation).map(function(e) {
          return webTv_msNavigation[e]
      });
      var indexPath = values_object.map(function(e) { return e.state; }).indexOf($state.current.name);
      if(indexPath === -1){
          var indexPath = values_object.map(function(e) { return e.stateList; }).indexOf($state.current.name);
      }
      if(indexPath !== -1){
          vm.pathActive = angular.isDefined(Object.keys(webTv_msNavigation)[indexPath]) ? Object.keys(webTv_msNavigation)[indexPath] : null;
          vm.pathActive = angular.isDefined(vm.pathActive.split('.')[0]) ? vm.pathActive.split('.')[0] : vm.pathActive;
      }

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    function toggleHorizontalMobileMenu() {
      angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }
    var originatorEv;

    function openMenu($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    }
    function goToUrlMedias(item,route) {
      var navigationNode = null;
      if ($scope.root) {
        vm.navigation = msNavigationService.getNavigation($scope.root);
      }
      else {
        vm.navigation = msNavigationService.getNavigation();
      }

      if ( vm.navigation) {
        vm.navigation.forEach(function(navigation){
          if(navigation._id.indexOf(item)>-1){
            $state.go(route)
            navigationNode = navigation;
          }
        })

      }
      if(navigationNode){
        setTimeout(function(){
          msNavigationService.setActiveItem({_id : navigationNode._id,
            _path: navigationNode._path}, $scope);
          var externNode=true

          $rootScope.$broadcast('msNavigation::clearActive',externNode);
        },500)

      }


    }
    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded() {
      console.log("ms-navigation-folded");
      if (
        document
          .querySelector("body")
          .classList.contains("ms-navigation-folded")
      ) {
        document.querySelector("body").classList.remove("ms-navigation-folded");
      } else {
        document.querySelector("body").classList.add("ms-navigation-folded");
      }
      vm.folded = !vm.folded;
      eventPostMessage(vm.folded);
      // if(hasListener){
      //   document.querySelector('#vertical-navigation').addEventListener("mouseover", function () {
      //     document.querySelector('body').classList.add('ms-navigation-folded-open');
      //   });
      //   document.querySelector('#vertical-navigation').addEventListener("mouseleave", function () {
      //     document.querySelector('body').classList.remove('ms-navigation-folded-open');
      //   });
      //   hasListener = false;
      // }
    }
    function eventPostMessage(folded) {
      if (document.getElementById("iframe_jitsi")) {
        document.getElementById("iframe_jitsi").contentWindow.postMessage(
          {
            info: "updateWindowDimensions",
            value: folded,
          },
          "*"
        );
      }
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mail', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
       $translatePartialLoaderProvider.addPart('app/mail');

        msApiProvider.register('quickPanel.sendmailtoadmin', [Routing.generate('api_profiles_send_mail_since_contact_form')]);
        msApiProvider.register('connectedUser.sendmailtoadmin', [Routing.generate('api_profiles_get_connected_user_profil')]);


    }
})();

(function () {
    'use strict';
    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController(msApi, $translate, webTvGlobal) {
        var vm = this;
        // Data

        vm.sendToMe = false;
        vm.reply = reply;
        vm.toggle = toggle;

        function reply() {
            webTvGlobal.$toast().showSimple($translate.instant('MAIL.sent'));
            //vm.replyMessage="";
            vm.toggle();
            msApi.request('connectedUser.sendmailtoadmin@get',
                function (res) {
                    if (res.code === 200) {
                        // vm.username = res.data.user.username;

                        if (vm.replyMessage === '') {
                            return;
                        }
                        msApi.request('quickPanel.sendmailtoadmin@save',
                            {
                                "message": vm.replyMessage,
                                'username': res.data.user.username,
                                "sendCopy": vm.sendToMe
                            },
                            function (res) {

                                if (res.code === 200) {
                                    // webTvGlobal.$toast().showSimple($translate.instant('MAIL.sent'));

                                }
                                else {
                                    if (res.code === 400) webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_operation_not_completed'));
                                    else webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_check_form'));


                                }
                              vm.replyMessage="";
                            },
                            function () {
                                webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));

                            }
                        );
                    }
                    else {
                        webTvGlobal.alertDialog($translate.instant('MESSAGES.alert_xhr_error'));
                    }
                });

        }

        var elem = document.getElementById("theme-config");
        if(elem)
          elem.style.height = "42px";

        function toggle() {
            if ($('div').hasClass('showMail')) {
                $('.theme-config-box').removeClass('showMail');
                elem.style.height = "42px";

            }
            else {
                $('.theme-config-box').addClass('showMail');
                elem.style.height = "280px";

            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
angular.module("Webtv.config", [])
.constant("0", "a")
.constant("1", "p")
.constant("2", "p")
.constant("3", "/")
.constant("4", "d")
.constant("5", "a")
.constant("6", "t")
.constant("7", "a")
.constant("8", "/")
.constant("environment", "prod")
.constant("logo", {"image":"empreinte","text":"webtv 4"})
.constant("video", {"isNew":false,"logo_image":"","logo_text":"","isMG":false})
.constant("inscription", false)
.constant("version", "0.1.0");


(function () {
  'use strict';

  angular
    .module("Webtv.config")
    .service('tokenService', tokenService);

  /** @ngInject */
  tokenService.$inject = ['$injector', '$cookies', '$window'];


  function tokenService($injector, $cookies) {

    var authToken = $cookies.get('authToken');
    var refreshPromise;

    this.refreshToken = function () {
      var $http = $injector.get('$http');
      refreshPromise = $http({
        method: 'GET',
        url: window.process.env.CUSTOM_FIELD_API + '/token/refreshToken',
        headers: {
          'Authorization': 'Bearer ' + authToken
        }
      }).then(function (res) {
        if(res.data && res.data.data && res.data.data.token) {
          authToken = res.data.data.token;
          $cookies.put('authToken', authToken);
          return authToken;
        } else {
          $cookies.remove('authToken');
          window.location.replace('/login/');
          return $q.reject(error);
        }
      }, function (error) {
        $cookies.remove('authToken');
        window.location.replace('/login/');
        return $q.reject(error);
      });

      return refreshPromise;
    };

    this.getAuthToken = function () {
      return authToken;
    };

    this.deleteAuthToken = function () {
      authToken = null;
      $cookies.remove('authToken');
      window.location.replace('/login/');
    };

  }

})();

(function () {
    'use strict';

    angular
        .module('WebTv')
        .config(runBlockConfig)
        .run(runBlock);

    function runBlockConfig($mdThemingProvider) {

        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);

        // Get active layout
        var selectedTheme = $cookies.get('WEBTV.selectedTheme') || 'default';
        $mdThemingProvider.enableBrowserColor({
            theme: selectedTheme,
            palette: 'primary',
            hue: '800'
        });
    }

    /** @ngInject */


    function runBlock($injector, DTDefaultOptions, msApi, webTvGlobal, userManager, $mdDialog,$sce) {
        var $rootScope = $injector.get('$rootScope'),
            $timeout = $injector.get('$timeout'),
            $state = $injector.get('$state'),
            $translate = $injector.get('$translate'),
            $cookies = $injector.get('$cookies'),
            $log = $injector.get('$log');
        $rootScope.DTDefaultOptions = DTDefaultOptions;
        if (!userManager.hasUserData()) {
            userManager.setUserDataCallback();
        }
        $rootScope.access = false;
        msApi.request('userManager.getUserIpData@get',
            {},
            function (res) {
                if (!res.allowed) {
                    $rootScope.access = false;
                  if( window.location.search &&  window.location.search.indexOf('email') > -1){
                      const urlParams = new URLSearchParams(window.location.search);
                      $state.go('app.login-v2', {email: urlParams.get('email') });
                  }else{
                      $state.go('app.login-v2');
                  }

                    $mdDialog.show({
                        controller: AlertNotAuthorised,
                        templateUrl: 'app/main/login-v2/alert-not-authorised.html',
                        parent: angular.element(document.body),
                        clickOutsideToClose:false
                    })
                    // $mdDialog.show(
                    // $mdDialog.alert()
                    //         .parent(angular.element(document.querySelector('#popupContainer')))
                    //         .clickOutsideToClose(false)
                    //         .parent(angular.element(document.body))
                    //         .title("Acc\u00e8s non autoris\u00e9")
                    //         .textContent("Veuillez contacter l'administrateur")
                    // );
                    // $timeout( function(){ document.getElementsByTagName("md-dialog-actions")[0].style.display="none"; }, 300);

                }
                else {
                    $rootScope.access = true;
                    var create_password_watch = $rootScope.$on('$stateChangeStart',
                        function (event, toState, toParams, fromState, fromParams) {
                            // $state.go("app.profiles_user_password", ({token: toParams.token}));

                            if (toState.url.indexOf("/profiles/user/create-password") === 0 && toParams.token) {
                                // $state.go("app.profiles_user_password");
                                msApi.request('checkToken@get',
                                    {token: toParams.token},
                                    function (res) {
                                        if (res.link_expired) {
                                            webTvGlobal.alertDialog($translate.instant('MESSAGES.expired_token'));
                                            if( window.location.search &&  window.location.search.indexOf('email') > -1){
                                                const urlParams = new URLSearchParams(window.location.search);
                                                $state.go('app.login-v2', {token: "", email: urlParams.get('email') });
                                            }else{
                                                $state.go("app.login-v2", {token: ""});
                                            }
                                        }

                                    },
                                    function () {
                                        webTvGlobal.alertDialog($translate.instant('MESSAGES.expired_token'));
                                        if( window.location.search &&  window.location.search.indexOf('email') > -1){
                                            const urlParams = new URLSearchParams(window.location.search);
                                            $state.go('app.login-v2', {token: "", email: urlParams.get('email') });
                                        }else{
                                            $state.go("app.login-v2", {token: ""});
                                        }
                                    });
                            }

                            create_password_watch();

                        }
                    );
                }
            });
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {
            if(angular.isDefined(toState.name) && toState.name ==="app.media_video_list" && angular.isDefined(toParams.type)){
                var typeList = toParams.type;
                if (angular.isDefined(toState.actionPermission) && angular.isDefined(toState.actionPermission[typeList])) {
                    userManager.statsAccesAction(toState.actionPermission[typeList]);
                }
            }else {
                if (angular.isDefined(toState.actionPermission))
                    userManager.statsAccesAction(toState.actionPermission);
            }

            $rootScope.loadingProgress = false;

        });

        var createPasswordChangeSuccess = $rootScope.$on('$stateChangeSuccess', function (event, toState, toParams, fromState, fromParams) {


            if (toState.url.indexOf("/login/two-factor-auth") === -1 && angular.isUndefined($cookies.get('authToken')) && toState.url.indexOf("/profiles/user/create-password") === -1 && toState.url.indexOf("/inscription") === -1 && toState.name.indexOf("stats_export_vod_secure_by_id") === -1 && toState.name.indexOf("app.error_404") === -1 && toState.name.indexOf("app.error_403") === -1) {

                if (angular.isUndefined($cookies.get('authToken')) && toState.name.indexOf("stats_export_vod_by_id") === -1 ) {
                    if (angular.isUndefined($cookies.get('authToken')) && toState.name.indexOf("stats_export_event_by_id") === -1) {
                        if( window.location.search &&  window.location.search.indexOf('email') > -1){
                            const urlParams = new URLSearchParams(window.location.search);
                            $state.go('app.login-v2', {token: "", email: urlParams.get('email') });
                        }else{
                            $state.go("app.login-v2", {token: ""});
                        }
                    }
                }

            }
            createPasswordChangeSuccess()
        });

        $rootScope.$on('$stateChangeStart',
            function (event, toState, toParams, fromState, fromParams) {
                if(toState.name.indexOf("stats_export_vod_secure_by_id") !== -1){
                    if(!angular.isDefined($rootScope.showExportSecureStats) || !$rootScope.showExportSecureStats) {
                        call_secure_api(toParams);
                    }
                }else if(toState.name.indexOf("error_404") !== -1 || toState.name.indexOf("error_403") !== -1){
                    $rootScope.show_stats = false;
                }else {
                    $rootScope.show_stats = true;
                }

            });

        function call_secure_api(toParams){
            msApi.request('stats.secureUrl@get', {token: toParams.token, service: "export_vod_secure", signed: toParams.signed},
                function (res) {
                    $rootScope.show_stats = true;
                    console.log('SUCCESS secureUrl');
                    console.log("show_stats", $rootScope.show_stats);
                },
                function () {
                    console.log('ERRROR secureUrl');
                    $rootScope.show_stats = false;
                    console.log("show_stats", $rootScope.show_stats);
                    $rootScope.show_link = true;
                    $state.go('app.error_403');
                });
        }


        // Store state in the root scope for easy access
        $rootScope.state = $state;
        // Cleanup
        $rootScope.$on('$destroy', function () {
            //stateChangeStartEvent();
            stateChangeSuccessEvent();
            // stateStart();
        });
        function AlertNotAuthorised(){

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('WebTv')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider,webTv_msNavigation) {
        $locationProvider.html5Mode(true);


        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
            // Inject $cookies
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies) {
                $cookies = _$cookies;
            }
        ]);
        var default_menu = Object.keys(webTv_msNavigation).filter(function (menu ) { return webTv_msNavigation[menu]["default_menu"]});
        var firstRoute = $cookies.get('authToken') ? (default_menu && default_menu.length>0 && webTv_msNavigation[default_menu[0]]["url_menu"] ? webTv_msNavigation[default_menu[0]]["url_menu"] :  '/dashboard') :
             window.location.search &&  window.location.search.indexOf('email') > -1 ? "/login/"+window.location.search :"/login/";
        $urlRouterProvider.otherwise(firstRoute);
        // Get active layout
 

 
      var layoutStyle = $cookies.get('layoutStyle') || (angular.isDefined(defaultlayout.style) ? defaultlayout.style : "") || 'verticalNavigation';
      if(!!!$cookies.get('selectedTheme') && (angular.isDefined(defaultlayout.theme))) {
        $cookies.put('selectedTheme',defaultlayout.theme)

      }
        //var layoutStyle = "horizontalNavigationNew";

        var layouts = {
            verticalNavigation: {
                main: 'app/core/layouts/vertical-navigation.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2: {
                main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main: 'app/core/layouts/horizontal-navigation.html',
                toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            horizontalNavigationNew: {
              main: 'app/core/layouts/horizontal-navigation-new.html',
              toolbar: 'app/toolbar/layouts/horizontal-navigation-new/toolbar.html',
              navigation: 'app/navigation/layouts/horizontal-navigation-new/navigation.html'
            },
            contentOnly: {
                main: 'app/core/layouts/content-only.html',
                toolbar: '',
                navigation: ''
            },
            contentWithToolbar: {
                main: 'app/core/layouts/content-with-toolbar.html',
                toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views: {
                    'main@': {
                        templateUrl: layouts[layoutStyle].main,
                        controller: 'MainController as vm'
                    },
                    'toolbar@app': {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller: 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller: 'NavigationController as vm'
                    },
                    'mail@app': {
                        templateUrl: 'app/mail/mail.html',
                        controller: 'MailController as vm'
                    },
                    'upload@app': {
                        templateUrl: 'app/main/media/video/upload/upload.template.html',
                        controller: 'mediaVideoUploadController as vm'
                    },
                    'reupload@app': {
                        templateUrl: 'app/main/media/video/reupload/reupload.list.html',
                        controller: 'mediaVideoReuploadController as vm'
                    }
                }
            });
    }

})();

(function () {
    'use strict';

    angular
        .module('WebTv')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming, $rootScope, $scope, userManager,$anchorScroll, $location, $cookies, $state, webTvGlobal,webTv_msNavigation,$translate) {
        var vm = this;
        // if (!userManager.hasUserData()) {
        //     userManager.setUserDataCallback();
        // }

        // Data
        function refreshPageContent() {
            $state.reload();
        }

        $rootScope.userManager = userManager;
        document.onkeydown = function () {
            switch (event.keyCode) {
                case 116 : //F5 button
                    event.returnValue = false;
                    refreshPageContent();
                    return false;
                case 82 : //R button
                    if (event.ctrlKey) {
                        event.returnValue = false;
                        event.keyCode = 0;
                        return false;
                    }
            }
        };
        vm.themes = fuseTheming.themes;
        $scope.translationloadingProgress = 0;
        $scope.showInfoBar = $cookies.get('WEBTV.removeInfoBar') ? 0 : 1;
        $rootScope.$on('$translateChangeStart', function () {
            $scope.translationloadingProgress = 1
        });

        $rootScope.$on('$translateChangeSuccess', function () {
            $scope.translationloadingProgress = 0
        });
        $rootScope.$on('$stateChangeStart',
          function (event, toState, toParams, fromState, fromParams) {
            if ( (fromState.name==="app.media_video_upload" && (toState.name==="app.media_video_add" || toState.name==="app.media_video_add_multi_title" ) ) || ((fromState.name==="app.media_video_add" || fromState.name==="app.media_video_add_multi_title" )  && toState.name==="app.media_video_upload")) {
              $rootScope.delete_all_files_uploaded=false
            }else{
              $rootScope.delete_all_files_uploaded=true
            }
        });
        webTvGlobal.translateDatePicker();
        $rootScope.addDebugMessage = function (data) {
            if (angular.isUndefined($rootScope.debugMessages)) {
                $rootScope.debugMessages = [{
                    "color": "rgb(27, 94, 32)",
                    "title": "WELCOME",
                    "body": ""
                }];
            }
            if (angular.isUndefined(data)) return;
            var activeTheme = fuseTheming.themes.active.theme;
            var colors = {
                "primary": activeTheme.primary.color,
                "accent": activeTheme.accent.color,
                "warn": activeTheme.warn.color
            };
            $rootScope.debugMessages.push({
                "color": colors[data.msColor],
                "title": data.title,
                "body": data.message
            });

        };
        $rootScope.addDebugMessage();

      // $('.ng-scope').on('click', function() {
      //  console.log("fdjsjfdsjhfjffsdjsfdjhsdfjjhsdf456546456",$('.scrollable ul').height())
      //   var div = $('.scrollable');
      //
      //   if($('.scrollable ul').height() >= 864 ){
      //   div.animate({
      //     scrollTop: div[0].scrollHeight
      //   }, 1000);
      //   }
      //
      //
      // });


      eventPostMessage()
      function initHelp(type) {
        /* todo */
        if(type === "segment_edit"){
          if(webTv_msNavigation['display_new_new_template_segment']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";

            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";
          }
          $rootScope.pageRoute = "app.new_template_segment_list";
        }else if(type === "segment_duplicate"){
          if(webTv_msNavigation['display_new_new_template_segment']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_list_menuTitle";
          }
          $rootScope.pageRoute = "app.new_template_segment_list";

        }
        else if(type === "segment_info"){
          if(webTv_msNavigation['display_new_new_template_manager']){
            $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";
          }
          $rootScope.pageRoute = "app.new_template_manager_list_all";

        }
        else if(type === "segment_add"){
          if(webTv_msNavigation['display_new_new_template_segment']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_add_menuTitle";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.display_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_template_segment_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_add_menuTitle";
          }
          $rootScope.pageRoute = "app.new_template_segment_list";

        }
        else if(type === "image_add"){
          if(webTv_msNavigation['media_image']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre2 = "";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre3 = "";
          }
          $rootScope.pageRoute = "app.image";

        }else if(type === "image_edit"){
          if(webTv_msNavigation['media_image']) {
            $rootScope.titre1 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";
            $rootScope.titre3 = "";
          }else {
            $rootScope.titre1 = "PAGESMENUSTITLES.media_menuTitle";
            $rootScope.titre2 = "PAGESMENUSTITLES.images_menuTitle";
            $rootScope.titre3 = "PAGESMENUSTITLES.display_segments_edit_menuTitle";
          }
          $rootScope.pageRoute = "app.image";
        }
        if(document.getElementById('titre2')) {
          document.getElementById('titre2').innerText = $translate.instant($rootScope.titre2);
        }
        if(document.getElementById('titre3')) {
          document.getElementById('titre3').innerText = $translate.instant($rootScope.titre3);
        }
        $rootScope.welcome = "";

      }
      function eventPostMessage() {
        if (angular.isUndefined(window.dataEventPostMessageRouter)) {
          window.dataEventPostMessageRouter = true;
          console.log("eventPostMessage");
          var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
          var eventer = window[eventMethod];
          var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
          //eventer(messageEvent, function (e) <=> window.addEventListener("message", receiveMessage, false): to listen to the dispached event
          //receiveMessage = function(event)
          eventer(messageEvent, function (e) {
            /* todo */
            if (typeof e.data !== "undefined") {
              if (e.data.info === "router_state_go") {

                initHelp(e.data.type)
              }
              if(e.data.info==="showPodcastStat"){
                $state.go('app.stats_podcast_by_id.audience', {id: e.data.value});
              }
            }
          })
        }
      }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('WebTv')
        .config(config);

    /** @ngInject */
    function config($translateProvider)
    {
        var $cookies;

        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);
        // Put your common app configurations here

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.useLoaderCache(true);

        var lang = angular.isUndefined($cookies.get('WEBTV.locale')) ? angular.element("html").attr('lang') : $cookies.get('WEBTV.locale');
        $translateProvider.preferredLanguage(lang);
        if ( angular.isUndefined($cookies.get('WEBTV.locale')))$cookies.put('WEBTV.locale',angular.element("html").attr('lang'));

        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    }

})();

(function () {
    'use strict';

    angular
        .module('WebTv')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource) {
        var api = {};
        api.dataTable = {
            dictionary: $resource('app/data/dataTable/datatable.:lang.json'.replace(/__l/, ':l'), {lang: '@lang'})
        };
        api.plugins = {
            datepicker: $resource('app/data/datePicker/datepicker.:lang.json'.replace(/__l/, ':l'), {lang: '@lang'})
        };

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.display_new.schedule')
        .config(config);

    /** @ngInject */
    function config( msApiProvider)
    {
      
      // msApiProvider.register('schedule.delete', [Routing.generate('api_display_schedule_delete_one') + "/:id", {id: '@id'}]);
      // msApiProvider.register('schedule.edit', [Routing.generate('api_display_schedule_post_edit') + "/:id", {id: '@id'}]);

       


    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('app.media.video.reupload_multilangue', ["flow"])
//         .config(config);
//
//     /** @ngInject */
//     function config($stateProvider, msApiProvider) {
//         // State
//         $stateProvider
//             .state('app.multilangue_video_reupload', {
//                 url: "/multilangue/:id/videos/:lang/reupload",
//                 views: {
//                     'content@app': {
//                         templateUrl: 'app/main/media/video/reupload-multilangue/reupload.list.html',
//                         controller: 'multilangueVideoReuploadController as vm'
//                     }
//                 },
//                 resolve: {
//                     lang: function (msApi, $stateParams) {
//                         return $stateParams.lang;
//                     },
//                     videoData: function (msApi, $stateParams) {
//                         return msApi.resolve('multilangue_video.getData@get', {id: $stateParams.id});
//                     },
//
//                     mediaVideoOnHoldData: function (msApi) {
//                         return msApi.resolve('media_video.getOnHoldVids@get');
//                     }
//                 },
//                 bodyClass: 'e-commerce',
//                 "actionPermission" : "media_video_reupload_no_api_action"
//             });
//         //API
//         msApiProvider.register('multilangue_video.getData', [Routing.generate('api_media_get_video', {id: ':id'}).replace(/%3A/, ":")]);
//         msApiProvider.register('multilangue_video.getAutoGeneratedThumbs', [Routing.generate('api_media_get_video_auto_generated_thumbs', {title: ':title'}).replace(/%3A/, ":")]);
//         msApiProvider.register('multilangue_video.getPreviewLinkByTitle', [Routing.generate('api_media_get_video_preview_link_by_title', {title: ':title'}).replace(/%3A/g, ":")]);
//         msApiProvider.register('multilangue_video.updateSource', [Routing.generate('api_media_post_update_video_source', {id: ':id'}).replace(/%3A/g, ":"), {id: '@id'}]);
//         msApiProvider.register('media_video.getOnHoldVids', [Routing.generate('api_media_on_hold_videos')]);
//
//
//     }
// })();
(function () {
    'use strict';

    angular
        .module('app.specifics.direction', ['app.specifics.direction.list', 'app.specifics.direction.add', 'app.specifics.direction.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('specifics.direction', {
            title: 'Direction',
            translate: 'PAGESMENUSTITLES.specifics_direction_menuTitle',
            icon: 'icon-apps',
            state: 'app.specifics_direction_list',
            permission: 'specifics_directions_list_dtable_direction'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/specifics/direction');
        msApiProvider.register('specifics_direction.getDirection', [Routing.generate('api_direction_get_detail_direction', {id: ':id'}).replace(/%3A/, ":")]);
        msApiProvider.register('direction.getDirectionsNames', [Routing.generate('api_direction_get_list_direction')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*direction).*$",
                name_module: "specifics_directions",
                name_angular_module: "app.specifics.direction",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_direction", "delete_direction", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics.iptv', ['app.specifics.iptv.list', 'app.specifics.iptv.add', 'app.specifics.iptv.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('specifics.iptv', {
            title: 'Iptvs',
            translate: 'PAGESMENUSTITLES.specifics_iptv_menuTitle',
            icon: 'icon-cast',
            state: 'app.specifics_iptv_list',
            permission: 'specifics_iptv_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/specifics/iptv');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*specifics)(?=.*iptv).*$",
                name_module: "specifics_iptv",
                name_angular_module: "app.specifics.iptv",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_iptv", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics.station', ['app.specifics.station.list', 'app.specifics.station.add', 'app.specifics.station.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('specifics.station', {
            title: 'Stations',
            translate: 'PAGESMENUSTITLES.specifics_station_menuTitle',
            icon: 'icon-play-circle',
            state: 'app.specifics_station_list',
            permission: 'specifics_stations_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/specifics/station');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*specifics)(?=.*station).*$",
                name_module: "specifics_stations",
                name_angular_module: "app.specifics.stations",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_station", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.user', ['app.profiles.user.list', 'app.profiles.user.add', 'app.profiles.user.edit','app.profiles.user.profilConnectedV2', 'app.profiles.user.profilconnected', 'app.profiles.user.password','angularjs-gauge'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {

        msNavigationServiceProvider.saveItem('profiles.user', {
            title: 'Users',
            translate: 'PAGESMENUSTITLES.profiles_user_menuTitle',
            icon: 'icon-account',
            state: 'app.profiles_user_list',
            permission: 'profiles_user_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/profiles/user');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*profiles)(?=.*user).*$",
                name_module: "profiles_user",
                name_angular_module: "app.profiles.user",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit_user", "edit_password_no_api"]},
                    {"list": ["list_dtable", "profiles_delete_user", "delete_multi", "put_enable_user", "put_disable_user"]},
                    {"detail": ["get_detail"]},
                    {"profilconnected": ["post_edit_connected_user"]},
                    {"profilConnectedV2": ["post_edit_connected_user"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.ip', ['app.profiles.ip.list', 'app.profiles.ip.add', 'app.profiles.ip.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('profiles.ip', {
            title: 'zone',
            translate: 'PAGESMENUSTITLES.profiles_ip_menuTitle',
            icon: 'icon-security',
            state: 'app.profiles_ip_list',
            permission: 'profiles_ip_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/profiles/ip');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*profiles)(?=.*ip).*$",
                name_module: "profiles_ip",
                name_angular_module: "app.profiles.ip",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_ips", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.profiles.group', ['app.profiles.group.list', 'app.profiles.group.add', 'app.profiles.group.edit', 'app.profiles.group.permission'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('profiles.group', {
            title: 'Groups',
            translate: 'PAGESMENUSTITLES.profiles_group_menuTitle',
            icon: 'icon-account-box',
            state: 'app.profiles_group_list',
            permission: 'profiles_group_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/profiles/group');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*profiles)(?=.*group).*$",
                name_module: "profiles_group",
                name_angular_module: "app.profiles.group",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_group", "delete_multi"]},
                    {"detail": ["get_detail"]},
                    {"permission": ["permission_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.lives', ['app.lives.list', 'app.lives.conf', 'app.interactivity.comments.list', 'app.lives.encodeurlive', 'app.lives.list.calendar', 'app.lives.addLive', 'app.lives.editLive'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('media.lives', {
            title: 'Lives',
            translate: 'PAGESMENUSTITLES.lives_menuTitle',
            icon: 'icon-live-custom',
            state: 'app.lives_list_ongoing',
            //group:true,
            weight: 3,
            permission: 'lives_dtable_lives_endless'
        });

        // msNavigationServiceProvider.saveItem('media.lives.conf', {
        //     title: 'New conf',
        //     translate: 'PAGESMENUSTITLES.live_conf_add_menuTitle',
        //     icon: 'icon-plus-network',
        //     state: 'app.lives_conf',
        //     permission: 'lives_conf_post_add'
        // });

        $translatePartialLoaderProvider.addPart('app/main/media/lives/conf');
        $translatePartialLoaderProvider.addPart('app/main/media/lives/live');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?!.*api_lives)(?=.*api)(?=.*lives)(?!.*comment)(?!.*conf).*$",
                name_module: "lives",
                name_angular_module: "app.lives",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["dtable_lives_endless", "dtable_lives_archived","dtable_lives_upcoming","dtable_lives_all", "delete_live", "multi_delete", "diffuser_no_api", "add_screen_share", "encoder_no_api", "live_info_no_api", "export_link_no_api", "comments_no_api", "live_detail_no_api", "send_mail_no_api"]},
                    {"liveNoModule": ["fo_subscript_no_api", "fo_like_no_api", "fo_comment_no_api", "fo_sondage_no_api", "fo_files_share_no_api", "social_media_no_api", "password_security_no_api", "screen_share_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.playlist', ['app.playlist.list', 'app.playlist.add', 'app.playlist.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
        msNavigationServiceProvider.saveItem('media.playlist', {
            title: 'Playlist',
            translate: 'PAGESMENUSTITLES.playlist_menuTitle',
            icon: 'icon-format-indent-increase',
            state: 'app.playlist_list.simple',

            //group:true,
            permission: 'playlist_list_dtable',
            weight: 2
        });

        $translatePartialLoaderProvider.addPart('app/main/media/playlist');
        msApiProvider.register('playlist.getRmboxes', [Routing.generate('api_configuration_get_rmboxs')]);
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*playlist).*$",
                name_module: "playlist",
                name_angular_module: "app.playlist",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_playlist", "delete_multi", "playlist_link"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.podcast', ['app.podcast.list', 'app.podcast.add', 'app.podcast.edit', 'app.podcast.upload'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('media.podcast', {
            title: 'Podcast',
            translate: 'PAGESMENUSTITLES.podcast_menuTitle',
            icon: 'icon-microphone-outline',
            state: 'app.podcast_list',
            permission: 'stats_podcast_all',
            weight: 5,
        });

        // msNavigationServiceProvider.saveItem('media.lives.conf', {
        //     title: 'New conf',
        //     translate: 'PAGESMENUSTITLES.live_conf_add_menuTitle',
        //     icon: 'icon-plus-network',
        //     state: 'app.lives_conf',
        //     permission: 'lives_conf_post_add'
        // });

        $translatePartialLoaderProvider.addPart('app/main/media/podcast');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*podcast).*$",
                name_module: "podcast",
                name_angular_module: "app.podcast",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"detail": ["get_detail"]},
                    {"list": ["list_dtable", "delete_podcast", "multi_delete", "url_export"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.event', ['app.event.list', 'app.event.add', 'app.event.edit', 'app.event.calendar'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('media.event', {
            title: 'Live event',
            translate: 'PAGESMENUSTITLES.event_menuTitle',
            icon: 'icon-calendar-blank',
            //group:true,
            state: 'app.event_list_ongoing',
            permission: 'event_list_dtable_events_ongoing',
            weight: 4
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/media/event_live');
        msApiProvider.register('direction.getDirectionsNames', [Routing.generate('api_direction_get_list_direction')]);
        msApiProvider.register('eventLive.getNewEvent', [Routing.generate('api_get_detail_event_live', {id: ':id'}).replace(/%3A/, ":")]);
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*event).*$",
                name_module: "event",
                name_angular_module: "app.event",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_events_ongoing", "list_dtable_events_upcoming", "delete_event_live", "delete_multi", "stats_no_api"]},
                    {"detail": ["get_detail"]},
                    {"eventNoModule": ["export_no_api"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.new_template_segment', [ 'app.new_template_segment.list'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        msNavigationServiceProvider.saveItem('display_new.new_template_segment', {
             title: 'Tempate Editor',
             translate: 'PAGESMENUSTITLES.display_programs_menuTitle',
             icon: "icon-view-carousel" ,
             state: 'app.new_template_segment_list',
             permission: "display_template_list_dtable",
             weight: 3
         });

    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*template).*$",
                name_module: "display_new_template_segment",
                name_angular_module: "app.displayNew.template_segment",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "get_templates", "get_template", "delete_many", "delete_one"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('app.interactivity.advertising', ['app.interactivity.advertising.list', 'app.interactivity.advertising.add', 'app.interactivity.advertising.edit'])
//         .config(config)
//         .run(fetchRights);
//
//     /** @ngInject */
//     function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {
//         msNavigationServiceProvider.saveItem('interactivity.advertising', {
//             title: 'Advertisings',
//             translate: 'PAGESMENUSTITLES.advertising_menuTitle',
//             icon: 'icon-file-image-box',
//             state: 'app.advertising_list',
//
//             permission: 'parameters_advertising_list_dtable'
//             // group : true,
//         });
//         $translatePartialLoaderProvider.addPart('app/main/interactivity/advertising');
//     }
//
//     function fetchRights(msRights) {
// if (mod === 'dev') {

//         var permissions = {
//             pattern: "^(?=.*parameters)(?=.*advertising).*$",
//             name_module: "parameters_advertising",
//             name_angular_module: "app.interactivity.advertising",
//             actions: [
//                 {"add": ["post_add"]},
//                 {"edit": ["post_edit"]},
//                 {"list": ["list_dtable", "delete_advertising", "delete_multi"]},
//                 {"detail": ["get_detail"]}]
//         };
//         msRights.setPermissions(permissions);
//     }
// }
// })();

(function () {
    'use strict';

    angular
        .module('app.new_template_manager', [ 'app.new_template_manager.list','app.new_template_manager.editornew'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider) {

        msNavigationServiceProvider.saveItem('display_new.new_template_manager', {
             title: 'Tempate Editor',
             translate: 'PAGESMENUSTITLES.display_programs_menuTitle',
             icon: 'icon-calendar-clock',
             state: 'app.new_template_manager_list',
             permission: "display_template_list_dtable",
             weight: 3
         });

    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*template).*$",
                name_module: "display_new_template",
                name_angular_module: "app.new_template_manager",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "get_templates", "get_template", "delete_many", "delete_one"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.interactivity.comments', ['app.interactivity.comments.list', 'app.interactivity.comments.edit', 'app.lives.comments.edit'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {

        msNavigationServiceProvider.saveItem('interactivity.comments', {
            title: 'Comments',
            translate: 'PAGESMENUSTITLES.media_comments_menuTitle',
            icon: 'icon-comment',
            state: 'app.comments_list.media',
            permission: "comments_list_dtable_lives"
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/interactivity/comments');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.interactivity.sondage', ['app.interactivity.sondage.list', 'app.interactivity.sondage.add', 'app.interactivity.sondage.edit', 'app.interactivity.sondage.vote', 'app.interactivity.sondage.detailVote'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('interactivity.sondage', {
            title: 'sondage',
            translate: 'PAGESMENUSTITLES.sondage_menuTitle',
            icon: 'icon-poll',
            state: 'app.sondage_list',
            weight: 11,
            permission: 'sondage_list_dtable'

        });
        $translatePartialLoaderProvider.addPart('app/main/interactivity/sondage');
    }


    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*survey).*$",
                name_module: "sondage",
                name_angular_module: "app.interactivity.sondage",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_survey", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.classifying.theme', ['app.classifying.theme.list', 'app.classifying.theme.add', 'app.classifying.theme.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('classifying.theme', {
            title: 'Themes',
            translate: 'PAGESMENUSTITLES.parameters_theme_menuTitle',
            icon: 'icon-file-image-box',
            state: 'app.parameters_theme_list',

            permission: 'parameters_theme_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/classifying/theme');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*parameters)(?=.*theme)|(?=.*parameters)(?=.*links).*$",
                name_module: "parameters_theme",
                name_angular_module: "app.classifying.theme",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_theme", "delete_multi", "get_export"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.classifying.canal', ['app.classifying.canal.list', 'app.classifying.canal.add', 'app.classifying.canal.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {

        msNavigationServiceProvider.saveItem('classifying.canal', {
            title: 'Channels',
            translate: 'PAGESMENUSTITLES.parameters_canal_menuTitle',
            icon: 'icon-plus-network',
            state: 'app.parameters_canal_list',
            permission: 'parameters_canal_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/classifying/canal');
        msApiProvider.register('parameters_canal.serverChoices', [Routing.generate('api_configuration_get_server_choices_for_select_input')])
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?!=.*parameters)(?!=.*configuration)(?=.*channel).*$",
                name_module: "parameters_canal",
                name_angular_module: "app.classifying.canal",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_channel", "delete_multi", "get_url_export", "get_storage_servers"]},
                    {"detail": ["get_detail"]},
                    {"canalNoModule": ["configuration_canal_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.player_parameters', ['app.player_parameters.list', 'app.player_parameters.list_intra'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('configuration.player_parameters', {
            title: 'player_parameters',
            translate: 'PAGESMENUSTITLES.player_parameters',
            icon: 'icon-video-switch',
            state: 'app.player_parameters_list',
            permission: 'player_parameters_list_no_api'
            //group:true,
        });

        $translatePartialLoaderProvider.addPart('app/main/configuration/playerParameters');


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*player_parameters).*$",
                name_module: "player_parameters",
                name_angular_module: "app.player_parameters",
                actions: [
                    {"player_parameter_NoModule": ["list_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.server', ['app.configuration.server.list', 'app.configuration.server.add', 'app.configuration.server.edit'])
        .config(config)
        .run(fetchRights);
    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('configuration.server', {
            title: 'servers',
            translate: 'PAGESMENUSTITLES.configuration_server_menuTitle',
            icon: 'icon-server',
            state: 'app.configuration_server_list',
            permission: 'configuration_server_list_dtable'
            // group : true,
        });
        $translatePartialLoaderProvider.addPart('app/main/configuration/server');
        msApiProvider.register('configuration_server.getServer', [Routing.generate('api_configuration_get_detail_server',{id: ':id'}).replace(/%3A/,":")]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*configuration)(?=.*server).*$",
                name_module: "configuration_server",
                name_angular_module: "app.configuration.server",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_server", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration.referrers', ['app.configuration.referrers.list', 'app.configuration.referrers.add', 'app.configuration.referrers.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('configuration.referrers', {
            title: 'Referrers',
            translate: 'PAGESMENUSTITLES.configuration_referrers_menuTitle',
            icon: 'icon-sitemap',
            state: 'app.referrers_list',
            permission: 'referrers_list_dtable'
            //permission: 'configuration_referrers_list_dtable_referrer'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/configuration/referrers');

    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*referrer).*$",
                name_module: "referrers",
                name_angular_module: "app.configuration.referrers",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable"]}]
            };
            msRights.setPermissions(permissions);
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.configuration.presets', ['app.configuration.presets.list', 'app.configuration.presets.add', 'app.configuration.presets.edit'])
        .config(config)
        .run(fetchRights);
    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('configuration.presets', {
            title: 'presets',
            translate: 'PAGESMENUSTITLES.configuration_presets_menuTitle',
            icon: 'icon-cog',
            state: 'app.configuration_presets_list',
            permission: 'configuration_presets_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/configuration/presets');
        msApiProvider.register('configuration_presets.getNewPresetsData', [Routing.generate('api_configuration_get_detail_preset',{id: ':id'}).replace(/%3A/,":")]);
  

    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*configuration)(?=.*preset).*$",
                name_module: "configuration_presets",
                name_angular_module: "app.configuration.presets",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_preset", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.media.home', ['app.media.home.conf','app.media.home.list','app.media.home.push'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider)
    {
        msNavigationServiceProvider.saveItem('configuration.home', {
            title: 'home',
            translate:'PAGESMENUSTITLES.media_home_menuTitle',
            icon : 'icon-home',
            weight: 5
           // group : true,
        });
        msNavigationServiceProvider.saveItem('configuration.home.conf', {
            title: 'Configuration',
            translate:'PAGESMENUSTITLES.media_home_conf_menuTitle',
            icon : 'icon-file-presentation-box',
            state: 'app.media_home_conf'
        });
        msNavigationServiceProvider.saveItem('configuration.home.list', {
            title: 'List',
            translate:'PAGESMENUSTITLES.media_home_list_menuTitle',
            icon : 'icon-view-list',
            state: 'app.media_home_list',
            permission: 'media_home_get_home_conf_videos'
        });
        msNavigationServiceProvider.saveItem('configuration.home.push', {
            title: 'Push',
            translate:'PAGESMENUSTITLES.media_home_push_menuTitle',
            icon : 'icon-arrange-send-backward',
            state: 'app.media_home_push',
            permission: 'media_home_post_disable_push_video'
        });

        // Translation
       $translatePartialLoaderProvider.addPart('app/main/configuration/home');


    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*media)(?=.*home)|(?=.*media_post)(?=.*disable_push_video).*$",
                name_module: "media_home",
                name_angular_module: "app.media.home",
                actions: [
                    {"addConf": ["post_add_home_conf"]},
                    {"list": ["get_home_conf_videos"]},
                    {"disablePushVideo": ["post_disable_push_video"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.configuration_mooc', ['app.configuration_mooc.list','app.configuration.mooc.add'])
        .config(config)
        .run(fetchRights);
    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider)
    {
        msNavigationServiceProvider.saveItem('configuration.configuration_mooc', {
            title: 'configuration_mooc',
            translate:'PAGESMENUSTITLES.configuration_mooc',
            icon : 'icon-book-open',
            state: 'app.configuration_mooc_list',
            permission: 'mooc_list_dtable_params'
            //group:true,
        });

        $translatePartialLoaderProvider.addPart('app/main/configuration/mooc');


    }
    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*mooc).*$",
                name_module: "mooc",
                name_angular_module: "app.configuration_mooc",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_params", "delete_param", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.news', ['app.configuration.news.list', 'app.configuration.news.add', 'app.configuration.news.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('configuration.news', {
            title: 'News',
            translate: 'PAGESMENUSTITLES.configuration_news_menuTitle',
            icon: 'icon-apps',
            state: 'app.configuration_news_list',
            permission: 'configuration_newss_list_dtable_news'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/configuration/news');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*news).*$",
                name_module: "configuration_newss",
                name_angular_module: "app.configuration.news",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_news", "delete_new", "multi_delete"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.configuration.client', ['app.configuration.client.list', 'app.configuration.client.add', 'app.configuration.client.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {

        msNavigationServiceProvider.saveItem('configuration.client', {
            title: 'param',
            translate: 'PAGESMENUSTITLES.param_menuTitle',
            icon: 'icon-account-check',
            state: 'app.param_list',
            permission: 'param_list_dtable'
        });
        $translatePartialLoaderProvider.addPart('app/main/configuration/client');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*params).*$",
                name_module: "param",
                name_angular_module: "app.configuration.client",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable_params", "delete_param", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.zone', ['app.boitier.zone.list', 'app.boitier.zone.add', 'app.boitier.zone.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('boitier.zone', {
            title: 'zone',
            translate: 'PAGESMENUSTITLES.configuration_zone_menuTitle',
            icon: 'icon-map-marker-radius',
            state: 'app.configuration_zone_list',
            permission: "configuration_zone_list_dtable"
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/boitier/zone');
        msApiProvider.register('configuration_zone.getZone', [Routing.generate('api_configuration_get_detail_zone',{id: ':id'}).replace(/%3A/,":")]);
        msApiProvider.register('configuration_zone.getRmboxs', [Routing.generate('api_configuration_get_rmboxs')]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*configuration)(?=.*zone).*$",
                name_module: "configuration_zone",
                name_angular_module: "app.boitier.zone",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_zone", "delete_multi"]},
                    {"detail": ["get_detail"]},
                    {"zoneNoModule": ["stat_zone_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.boitier.rmbox', ['app.boitier.rmbox.list', 'app.boitier.rmbox.add', 'app.boitier.rmbox.edit', 'app.boitier.rmbox.interventions.list', 'app.boitier.rmbox.interventions.add', 'app.boitier.rmbox.interventions.edit'])
        .config(config)
        .run(fetchRights);


    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider, msApiProvider) {
        msNavigationServiceProvider.saveItem('boitier.rmbox', {
            title: 'rmbox',
            translate: 'PAGESMENUSTITLES.configuration_rmbox_menuTitle',
            icon: 'icon-rmbox-custom',
            state: 'app.configuration_rmbox_list',

            permission: 'configuration_rmbox_list_dtable'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/boitier/rmbox');
        msApiProvider.register('configuration_rmbox.getRmbox', [Routing.generate('api_configuration_get_detail_rmbox', {id: ':id'}).replace(/%3A/, ":")]);


    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*configuration)(?=.*rmbox)(?!.*rmboxgroup).*$",
                name_module: "configuration_rmbox",
                name_angular_module: "app.boitier.rmbox",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_rmbox", "delete_multi", "get_reload", "get_reports", "get_detail"]},
                    {"rmboxNoModule": ["show_schedule_no_api", "associate_schedule_no_api", "list_intervention_no_api", "add_intervention_no_api", "delete_intervention_no_api", "edit_intervention_no_api", "activate_playlist_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.abonnement.user', ['app.abonnement.user.list', 'app.abonnement.user.add', 'app.abonnement.user.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('abonnement.user', {
            title: 'user',
            translate: 'PAGESMENUSTITLES.abonnement_user_menuTitle',
            icon: 'icon-account',
            state: 'app.abonnement_user_list',
            permission: 'subscription_user_list_dtable'
        });
        $translatePartialLoaderProvider.addPart('app/main/abonnement/user');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*subscription)(?=.*user).*$",
                name_module: "subscription_user",
                name_angular_module: "app.abonnement.user",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable"]},
                    {"list.NoState": ["delete_user", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.autoriseip', ['app.boitier.autoriseip.list', 'app.boitier.autoriseip.add', 'app.boitier.autoriseip.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('boitier.autoriseip', {
            title: 'autoriseip',
            translate: 'PAGESMENUSTITLES.rmbox_autorise_ip_menuTitle',
            icon: 'icon-security',
            state: 'app.boitier_autoriseip_list',
            permission: 'boitier_autoriseip_list_dtable_action'
            // group : true,
        });

        $translatePartialLoaderProvider.addPart('app/main/boitier/autoriseip');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*profiles)(?=.*ip).*$",
                name_module: "profiles_ip",
                name_angular_module: "app.boitier.autoriseip",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_ips", "delete_multi"]},
                    {"detail": ["get_detail"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier.rmboxgroup', ['app.boitier.rmboxgroup.list', 'app.boitier.rmboxgroup.add', 'app.boitier.rmboxgroup.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('boitier.rmboxgroup', {
            title: 'RmBox groups',
            translate: 'PAGESMENUSTITLES.configuration_rmboxgroup_menuTitle',
            icon: 'icon-group',
            state: 'app.configuration_rmboxgroup_list',

            permission: 'configuration_rmboxgroup_list_dtable'
            // group : true,
        });
        $translatePartialLoaderProvider.addPart('app/main/boitier/rmboxgroup');
        msApiProvider.register('configuration_rmboxgroup.getRmboxgroup', [Routing.generate('api_configuration_get_detail_rmboxgroup',{id: ':id'}).replace(/%3A/,":")]);

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*configuration)(?=.*rmboxgroup).*$",
                name_module: "configuration_rmboxgroup",
                name_angular_module: "app.boitier.rmboxgroup",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable", "delete_rmboxgroup", "delete_multi"]},
                    {"detail": ["get_detail"]},
                    {"rmboxGroupNoModule": ["associate_schedule_no_api"]}]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.abonnement.group', ['app.abonnement.group.list', 'app.abonnement.group.add', 'app.abonnement.group.edit'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config(msNavigationServiceProvider,$translatePartialLoaderProvider) {
        msNavigationServiceProvider.saveItem('abonnement.group', {
            title: 'group',
            translate: 'PAGESMENUSTITLES.abonnement_group_menuTitle',
            icon: 'icon-account-multiple-plus',
            state: 'app.abonnement_group_list',
            permission: 'subscription_group_list_dtable'
        });

        $translatePartialLoaderProvider.addPart('app/main/abonnement/group');
    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*subscription)(?=.*group).*$",
                name_module: "subscription_group",
                name_angular_module: "app.abonnement.group",
                actions: [
                    {"add": ["post_add"]},
                    {"edit": ["post_edit"]},
                    {"list": ["list_dtable"]},
                    {"list.NoState": ["delete_group", "delete_multi"]},
                    {"detail": ["get_detail"]}
                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.stats', ['app.stats.export_vod_live', 'app.stats.vod_live', 'app.stats.dashboard', "app.stats.acces", "app.stats.bande.passante", "app.stats.storage", "app.stats.mooc", "app.stats.list_videos", "app.stats.list_podcasts", "app.stats.podcast", "app.stats.podcasts","app.stats.p2p", "app.stats.users","app.stats.event"])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $translatePartialLoaderProvider, $stateProvider) {
        msNavigationServiceProvider.saveItem('stats', {
            title: 'Statistique',
            translate: 'PAGESMENUSTITLES.stats',
            icon: 'icon-chart-bar',
            weight: 10
        });
        msNavigationServiceProvider.saveItem('stats.dashboard ', {
            title: 'Dashboard',
            translate: 'PAGESMENUSTITLES.stats_dashboard',
            icon: 'icon-view-list',
            state: 'app.stats_dashboard',
            permission: 'stats_dashboard_dashboard_no_api_route'
        });
        msNavigationServiceProvider.saveItem('stats.vod', {
            title: 'vod',
            translate: 'PAGESMENUSTITLES.stats_videos',
            icon: 'icon-video',
            state: 'app.stats_vods.audience',
            permission: 'stats_vod_all'
        });
        msNavigationServiceProvider.saveItem('stats.live', {
            title: 'live',
            icon: 'icon-archive',
            state: 'app.stats_lives.audience',
            permission: 'stats_live_all'
        });
        msNavigationServiceProvider.saveItem('stats.podcast', {
          title: 'podcast',
          translate: 'PAGESMENUSTITLES.stats_podcasts',
          icon: 'icon-video',
          state: 'app.stats_podcast.audience',
           permission: 'stats_podcast_all'
        });
        msNavigationServiceProvider.saveItem('stats.acces', {
            title: "Journal D'audit",
            translate: 'PAGESMENUSTITLES.stats_access',
            icon: 'icon-account-key',
            state: 'app.stats_acces',
            permission: 'stats_acces_list_acces'
        });
        msNavigationServiceProvider.saveItem('stats.consumptions', {
            title: 'consumption',
            translate: 'PAGESMENUSTITLES.stats_consumption_pagetitle',
            icon: 'icon-chart-areaspline',
            state: 'app.stats_bande_passante',
            permission: 'stats_bande_passante_post_bande_passante'
        });
        msNavigationServiceProvider.saveItem('stats.stockage', {
            title: 'stockage',
            translate: 'PAGESMENUSTITLES.stats_storage_pagetitle',
            icon: 'icon-server-network',
            state: 'app.stats_storage',
            permission: 'stats_storage_post_storage'
        });
        msNavigationServiceProvider.saveItem('stats.mooc', {
            title: 'mooc',
            translate: 'PAGESMENUSTITLES.stats_mooc_pagetitle',
            icon: 'icon-server-network',
            state: 'app.stats_mooc.course',
            permission: 'stats_mooc_course_no_api'
        });
        msNavigationServiceProvider.saveItem('stats.list_videos', {
            title: 'list_videos',
            translate: 'PAGESMENUSTITLES.stats_list_videos_pagetitle',
            icon: 'icon-play-box-outline',
            state: 'app.stats_list_videos',
            permission: 'stats_list_videos_list_dtable_videos_stats'
        });
        msNavigationServiceProvider.saveItem('stats.list_podcasts', {
            title: 'list_podcasts',
            translate: 'PAGESMENUSTITLES.stats_list_podcasts_pagetitle',
            icon: 'icon-play-box-outline',
            state: 'app.stats_list_podcasts',
            permission: 'stats_podcasts_list_export'
        });
        
        msNavigationServiceProvider.saveItem('stats.users', {
            title: "Statistiques d'utilisateurs",
            translate: 'PAGESMENUSTITLES.stats_users',
            icon: 'icon-account-key',
            state: 'app.stats_users',
            permission: 'stats_users_list_acces',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('stats.p2p', {
            title: "StatistiqueS P2P",
            translate: 'PAGESMENUSTITLES.stats_p2p',
            icon: 'icon-server',
            state: 'app.stats_p2p',
            permission: 'stats_p2p_acces',
            weight: 1
        });

        $translatePartialLoaderProvider.addPart('app/main/stats');


        $stateProvider.decorator('views', function (state, parent) {
            var result = {},
                views = parent(state);

            // child already has that in parent stats_vod_by_id stats_live_by_id
            if (state.name.indexOf("stats_mooc.") > 0) {
                angular.forEach(views, function (config) {
                    var stateView = state.name.split('.')[1];
                    //Using substr and indexOf
                    var firstName = state.name.substr(state.name.lastIndexOf('.') + 1);
                    result[firstName + "@app." + stateView] = config;
                });
                return result;
            }
            else if (state.name.indexOf("stats_podcast.") > 0 || state.name.indexOf("stats_vods.") > 0 || state.name.indexOf("stats_lives.") > 0
              || state.name.indexOf("stats_event_by_id.") > 0 || state.name.indexOf("stats_live_by_id.") > 0
              || state.name.indexOf("stats_vod_by_id.") > 0 || state.name.indexOf("stats_export_vod_by_id.") > 0
              || state.name.indexOf("stats_export_vod_secure_by_id.") > 0
              || state.name.indexOf("stats_export_event_by_id.") > 0
              || state.name.indexOf("stats_podcast_by_id.") > 0
              || state.name.indexOf("stats_zone_by_id.") > 0) {
                angular.forEach(views, function (config) {
                    var stateView = state.name.split('.')[1];
                    //Using substr and indexOf
                    var firstName = state.name.substr(state.name.lastIndexOf('.') + 1);
                    result[firstName + "@app." + stateView] = config;
                });
                return result;
            }
            else
                return views;

        });

    }
})();

(function () {
  "use strict";

  angular.module("app.metaData", ["app.metaData.list"]).config(config);

  /** @ngInject */
  function config(
    msNavigationServiceProvider,
    $translatePartialLoaderProvider
  ) {
    msNavigationServiceProvider.saveItem("metaData", {
      title: "metaData",
      translate: "PAGESMENUSTITLES.metaData_menuTitle",
      icon: "icon-format-indent-increase",
      state: "app.metaData_list",

      //group:true,
      weight: 5,
    });

    $translatePartialLoaderProvider.addPart("app/main/metaData");
  }
})();

(function () {
    'use strict';

    angular
        .module('app.specifics', ['app.specifics.station', 'app.specifics.iptv', 'app.specifics.direction'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        msNavigationServiceProvider.saveItem('specifics', {
            title: 'Specifics',
            translate: 'PAGESMENUSTITLES.specifics_menuTitle',
            //group : true,
            icon: 'icon-film',
            weight: 10
        });


    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.profiles', ['app.profiles.user','app.profiles.group','app.profiles.ip'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        msNavigationServiceProvider.saveItem('profiles', {
            title : 'Profiles',
            translate:'PAGESMENUSTITLES.profiles_menuTitle',
            icon:'icon icon-account-multiple',
            weight:2
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.export', ['app.export.youtube', 'app.export.dailymotion'])
        .config(config)
        .run(fetchRights);

    /** @ngInject */
    function config($translatePartialLoaderProvider) {
        $translatePartialLoaderProvider.addPart('app/main/export');

    }

    function fetchRights(msRights) {
        if (mod === 'dev') {
            var permissions = {
                pattern: "^(?=.*api)(?=.*export).*$",
                name_module: "export_video",
                name_angular_module: "app.export",
                actions: [
                    {"youtube": ["get_authentication_code"]},
                    {"dailymotion": ["dailymotion_get_login"]}

                ]
            };
            msRights.setPermissions(permissions);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.media',['app.media.video'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        
    	msNavigationServiceProvider.saveItem('media', {
            title: 'Media',
            translate:'PAGESMENUSTITLES.media_menuTitle',
            icon : 'icon-video',
            //group:true,
            weight : 3
        });
        
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.display_new', ['app.display_new.schedule','app.new_template_manager.list','app.new_template_segment.list'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
         msNavigationServiceProvider.saveItem('display_new', {
             title : 'Display New ',
             translate:'PAGESMENUSTITLES.display_new_menuTitle',
             icon:'icon-cube',
             weight:11
        });

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.interactivity', ["app.interactivity.sondage","app.interactivity.comments"])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        msNavigationServiceProvider.saveItem('interactivity', {
            title : 'Interactivity',
            translate:'PAGESMENUSTITLES.interactivity_menuTitle',
            //group : true,
            icon:'icon-newspaper',
            weight:8
        });




    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.error', [
            'app.error.500',
            'app.error.403',
            'app.error.404'
        ]);
    
})();
(function ()
{
    'use strict';

    angular
        .module('app.classifying', ['app.classifying.canal','app.classifying.theme'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        msNavigationServiceProvider.saveItem('classifying', {
            title : 'classifying',
            translate:'PAGESMENUSTITLES.classifying_menuTitle',
            //group : true,
            icon:'icon-classement-custom',
            weight:8
        });

        

        
    }
})();
(function () {
  "use strict";

  angular.module("app.chutier", ["app.chutier.list"]).config(config);

  /** @ngInject */
  function config(
    msNavigationServiceProvider,
    $translatePartialLoaderProvider
  ) {
    msNavigationServiceProvider.saveItem("chutier", {
      title: "Chutier",
      translate: "PAGESMENUSTITLES.chutier_menuTitle",
      icon: "icon-format-indent-increase",
      state: "app.chutier_list",

      //group:true,
      weight: 5,
    });

    $translatePartialLoaderProvider.addPart("app/main/chutier");
  }
})();

(function () {
    'use strict';
  var module_configuration_app = module_configuration;
    angular
        .module('app.configuration',['app.player_parameters', 'app.configuration.server',  'app.configuration.client','app.configuration.skinPlayer'].concat(module_configuration_app))
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        msNavigationServiceProvider.saveItem('configuration', {
            title: 'configuration',
            translate: 'PAGESMENUSTITLES.configuration_menuTitle',
            //group : true,
            icon: 'icon-cog',
            weight: 9
        });


    }
})();

(function () {
    'use strict';

    angular
        .module('app.boitier', ['app.boitier.rmboxgroup','app.boitier.rmbox','app.boitier.zone','app.boitier.autoriseip'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider,msApiProvider) {
        msNavigationServiceProvider.saveItem('boitier', {
            title: 'boitier',
            translate: 'PAGESMENUSTITLES.boitier_menuTitle',
            //group : true,
            icon: 'icon-houzz-box',
            weight: 9
        });
        msApiProvider.register('configuration_rmbox.getRmboxgroups', [Routing.generate('api_configuration_get_rmboxgroups')]);

    }
})();
(function () {
    'use strict';

    angular
        .module('app.abonnement', ['app.abonnement.group', 'app.abonnement.user'])
        .config(config);
        

    /** @ngInject */
    function config(msNavigationServiceProvider) {
        msNavigationServiceProvider.saveItem('abonnement', {
            title: 'abonnement',
            translate: 'PAGESMENUSTITLES.abonnement_menuTitle',
            //group : true,
            icon: 'icon-clipboard-account',
            weight: 2
        });


    }
    
})();
angular.module("WebTv").config(["$translateProvider", function($translateProvider) {
$translateProvider.translations("en", {
  "MESSAGES": {
    "total_records": "Total records:",
    "title_description": "Title, Description",
    "resizeText": "Resize your  <br> chosen image",
    "return": "Return",
    "cancel": "Cancel",
    "save": "Save",
    "choose": "Choose a file",
    "fileSelected": "No file selected",
    "title": "Title",
    "actions": "Actions",
    "action": "Action",
    "identifier": "ID",
    "deselect": "Deselect",
    "select": "Select",
    "search": "Search",
    "share": "Share",
    "dialog_confirm_delete": "Ok",
    "dialog_cancel": "Cancel",
    "dialog_will_be_deleted": " will be deleted.",
    "dialog_list_will_be_deleted": "Selected elements will be deleted",
    "dialog_element_will_be_deleted": "Selected element will be deleted",
    "undeleted_are": "Comments with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Comments withs ids \"{{list}}\" have been deleted",
    "delete_selected_comments_msg": "Delete selected comments",
    "form_add": "Add",
    "form_change": "Change",
    "form_save": "SAVE",
    "form_attr_title": "Title",
    "form_attr_source": "Source file",
    "form_attr_canal": "Channel",
    "form_attr_canals": "Channels",
    "form_attr_description": "Description",
    "form_attr_parentId": "Parent theme",
    "form_attr_parentRubricId": "Parent rubric",
    "form_validate": "Validate",
    "back_to_list": "Return to list",
    "form_is_required": "This field is required",
    "form_is_minlength": "This field is must be over 10 numbers",
    "form_is_maxlength": "This field is must not exceed 10 numbers",
    "form_is_num_positive": "This field must be a positive number",
    "form_is_minlengthpwd": "This field must be at least 8 characters long",
    "form_is_patternpwd": "This field at least an uppercase letter, a lowercase letter and a number one",
    "form_is_patternpwdspecial": "This field at least an uppercase letter, a lowercase letter, a special character and a number one",
    "form_is_patternphone": "Respect the pattern (0##########) or (+33##########) or (0033##########) or (0# - #### - #####) or (+33# - #### - #####) or (0033# - #### - #####)",
    "form_is_pattern_fullname": "Prohibit the input of numbers and special characters",
    "form_is_email": "This field must be a valid email address.",
    "form_is_patternconfirmd": "This  field is not equal !",
    "form_choices_yes": "Yes",
    "form_choices_no": "No",
    "form_choices": "Choice : Votes",
    "form_choices_disable": "Disable",
    "form_choices_enable": "Enable",
    "form_RTMP": "RTMP",
    "form_HDS": "HDS",
    "form_choices_title": "Alphabetical order",
    "form_choices_videodate": "Creation date",
    "form_type_visa": "Visa",
    "form_type_Passport": "Passport",
    "form_attr_visibility": "Visibility",
    "form_attr_classifiedBy": "Order of videos",
    "form_max_length": "This field must be less than {{length}} characters long.",
    "form_cancel": "Cancel",
    "form_retour": "Back",
    "form_add_file": "Add file",
    "alert_error": "Alert !",
    "alert_confirm": "Leave",
    "alert_save": "Save",
    "alert_message": "Are you sure you want to leave this page ?",
    "user_valid": "Are you sure you want to exit before registration?",
    "alert_live": "Leave the live",
    "alert_update_profile": "Exit modification",
    "alert_close": "Close",
    "alert_not_valid_image_message": "The file you've tried to upload is not an image.Please select an image with one of the following extensions: *.JPG *.JPEG *.PNG *.GIF",
    "alert_not_valid_document_message": "The file you've tried to upload is not an document.Please select an document with one of the following extensions: *.DOC *.DOCX *.HTML *.HTM *.ODT *.PDF *.XLS *.XLSX *.ODS *.PPT *.PPTX *.TXT",
    "alert_not_valid_size_image_message": "The size of the image you tried to download is less than the minimum size. Please select an image with a minimum size of",
    "alert_image_too_large_message": "The file you've tried to upload is too large. Allowed maximum size is 1024 ko.",
    "video_source_already_exist": "Video already exists!",
    "video_source_already_exist_video": "This video is a duplicate of the following videos:",
    "video_source_already_exist_video_request": "<br>Add video again?",
    "alert_operation_not_completed": "The operation could not be completed. Please check with your manager. Thank you!",
    "alert_diffusion": "please choose an \"internet or intranet\" distribution mode",
    "alert_check_form": "You have some errors in your form. Please verify it again. Thank you!",
    "alert_xhr_error": "An error have occured. Please try again later. If the problem stil exist, please contact your technical manager. Thank you.",
    "alert_edit_confirm": "Your change has been saved",
    "deselect_all": "Deselect all",
    "select_all": "Select all",
    "form_attr_language": "Language",
    "form_attr_server": "Streaming server(s)",
    "form_attr_sendPushNotification": "Send push notifications",
    "form_attr_activate_permalien": "Activate permalink",
    "form_iscdn": "CDN",
    "form_isvbr": "VBR",
    "form_attr_mbr": "MBR",
    "form_reading_protocol": "Reading protocol",
    "created_at": "Creation date",
    "updated_at": "Modification date ",
    "date": "Date",
    "theme": "Theme",
    "date_hour": "Date And Hour",
    "start_dt": "Start",
    "end_dt": "End",
    "action_detail": "Details",
    "action_duplicate": "Duplicate",
    "action_edit": "Update",
    "action_delete": "Delete",
    "action_diffuse": "Diffuse",
    "action_play": "Pearl encoding",
    "action_questions_quiz": "Questions/Quiz",
    "none": "None",
    "all": "All",
    "nonef": "None",
    "btn_play": "play",
    "btn_pause": "pause",
    "btn_preview": "preview",
    "file_imported": "{{fileName}} was imported successfully.",
    "hide": "Hide",
    "undo": "Undo",
    "field_must_be_numeric": "This field can only contain a numeric value (Ex: #;#.#;-#.#;-.#;+#;+#.#;+.#)",
    "field_must_be_ip": "Please enter a valid IP address",
    "field_must_be_mac": "Please enter a valid Mac address",
    "alert_login_badCredentials": "Bad credentials, check your Login or Password !",
    "alert_login_badCode": "Invalid Code. Try again!",
    "action_refresh_content": "Refresh content",
    "action_new_element": "Add new element",
    "form_is_num": "This field can only contain a numeric value",
    "form_is_entier": "This field can only contain an integer value",
    "form_attr_loop": "Play in loop",
    "form_attr_unique": "Play one time",
    "form_attr_order": "Follow order",
    "form_attr_duration": "Broadcast duration (seconds)",
    "form_choices_use_default_config": "Use default configuration",
    "vid_list_select": "List of selected videos",
    "vid_list": "List of  videos",
    "click_to_add": "Add videos",
    "form_attr_onair": "ON AIR (broadcasting)",
    "start_date": "Start date",
    "start_time": "Start time",
    "end_time": "End time",
    "date_valid": "The entered value is not a date !",
    "date_min": "Impossible, the date has passed !",
    "date_max": "Impossible, the date is too far !",
    "time_min": "Time is too early !",
    "time_max": "Time is too late !",
    "time_format": "Invalid format !",
    "calendar_week": "Week",
    "calendar_day": "Day",
    "calendar_month": "Month",
    "calendar_today": "Today",
    "calendar_allday": "All day",
    "calendar_next": "Next",
    "calendar_pervious": "Previous",
    "basic_info": "Basic info",
    "calendar": "Calendar",
    "drop_to_upload": "Drop to upload",
    "upload": "Upload",
    "video_upload_drop_message": "You can also drop video here to upload. <br>Only flv<\/strong>, m4v<\/strong>, avi<\/strong>, wmv<\/strong>, mp4<\/strong>, mpeg<\/strong>, mpg<\/strong>, mpe<\/strong>, dat<\/strong>, vob<\/strong>, asf<\/strong>, asx<\/strong>, mov<\/strong>, 3gp<\/strong>, 3g2<\/strong>, 3gpp<\/strong>, dv<\/strong>, qt<\/strong>, rm<\/strong>, rmvb<\/strong><\/strong>, webm<\/strong> are authorised",
    "video_upload_max": "Please do not import videos larger than 5 GB.",
    "alert_not_valid_video_message": "The file you've tried to upload is not a video. Please select a video with one of the following extensions : *. flv *.m4v *.avi *.wmv  *.mp4 *.mpeg *.mpg *.mpe *.dat *.vob *.asf *.asx *.mov *.3gp *.3g2 *.3gpp *.dv *.qt *. rm *.rmvb",
    "audio_upload_drop_message": "You can also drop video or audio here to upload. <br>Only mp3<\/strong>, wav<\/strong>, cda<\/strong>, mid<\/strong>, mod<\/strong>, wma<\/strong>, m4a<\/strong>, ogg<\/strong>, aac<\/strong>, flv<\/strong>, m4v<\/strong>, avi<\/strong>, wmv<\/strong>, mp4<\/strong>, mpeg<\/strong>, mpg<\/strong>, mpe<\/strong>, dat<\/strong>, vob<\/strong>, asf<\/strong>, asx<\/strong>, mov<\/strong>, 3gp<\/strong>, 3g2<\/strong>, 3gpp<\/strong>, dv<\/strong>, qt<\/strong>, rm<\/strong>, rmvb<\/strong> are authorised",
    "video_upload_uppy_message": "You can also drop here only video type files",
    "video_upload_uppy_drop": "Drop files here or",
    "video_upload_uppy_browse": "browse",
    "video_upload_uppy_uploading": "Uploading",
    "video_upload_uppy_uploadComplete": "Upload complete",
    "video_upload_uppy_uploadFailed": "Upload failed",
    "video_upload_uppy_pleasePressRetry": "Please press Retry to upload again",
    "video_upload_uppy_paused": "Paused",
    "video_upload_uppy_error": "Error",
    "video_upload_uppy_retry": "Retry",
    "video_upload_uppy_pressToRetry": "Press to retry",
    "video_upload_uppy_retryUpload": "Retry upload",
    "video_upload_uppy_resumeUpload": "Resume upload",
    "video_upload_uppy_cancelUpload": "Cancel upload",
    "video_upload_uppy_pauseUpload": "Pause upload",
    "video_upload_uppy_uploadXFiles_zero": "Upload {{smart_count}} file",
    "video_upload_uppy_uploadXFiles_one": "Upload {{smart_count}} files",
    "video_upload_uppy_uploadXNewFiles_zero": "Upload {{smart_count}} file",
    "video_upload_uppy_uploadXNewFiles_one": "Upload {{smart_count}} files",
    "alert_not_valid_audio_message": "The file you've tried to upload is not a video or audio. Please select a video with one of the following extensions : *.mp3 *.wav *.cda *.mid *.mod *.wma *.m4a *.ogg *.aac *.flv *.m4v *.avi *.wmv *.mp4 *.mpeg *.mpg *.mpe *.dat *.vob *.asf *.asx *.mov *.3gp *.3g2 *.3gpp *.dv *.qt *. rm *.rmvb",
    "choose_a_file": "Choose a file",
    "automatic_add_video": "Automatic upload",
    "form_step_basic_info": "Basic data",
    "form_step_further_info": "More data",
    "form_step_security": "Secure video",
    "form_step_next": "Next",
    "form_step_previous": "Back",
    "form_step_validate": "Submit",
    "form_step_optional": "Optional",
    "video_detail": "Meta-data video",
    "meta_data_of_video": "Metadata of the video : ",
    "meta_data_video_bitrate": "Video bitrate",
    "meta_data_resolution": "Resolution",
    "meta_data_size": "Size",
    "meta_data_duration": "Duration",
    "meta_data_framerate": "Framerate",
    "meta_data_video_codec": "Video codec",
    "meta_data_samplerate": "Samplerate",
    "meta_data_audio_Codec": "Audio codec",
    "meta_data_audio_bitrate": "Audio bitrate",
    "vid_has_no_meta_data": "This video has no metadata",
    "kb_per_s": "Kb\/s",
    "size_bytes": "Bytes",
    "size_kb": "Kb",
    "size_mb": "Mb",
    "size_gb": "Gb",
    "size_tb": "Tb",
    "form_attr_themes": "Theme",
    "form_attr_categories": "Category",
    "form_attr_themes_filter": "Filter by theme",
    "form_attr_contributor": "Contributor",
    "form_attr_contributors": "Contributors",
    "contributor_none": "All",
    "canal_none": "All",
    "type_none": "All",
    "user_none": "All",
    "form_attr_generate_multiple_formats": "Generate multiple formats",
    "end_date": "End date",
    "form_attr_use_theme": "Use the theme",
    "form_attr_send_push_notif": "Send push notifications",
    "form_attr_main_page": "Home video",
    "form_attr_downloadable": "Downloadable video",
    "form_attr_shared": "Shared video",
    "form_attr_vid_offline": "Put the video offline",
    "form_attr_vid_accessible": "Put the video visible on the internet",
    "form_attr_podcast_accessible": "Put the podcast visible on the internet",
    "form_attr_incrusted_logo": "Insert the logo",
    "form_attr_locked_vid": "Secure video with a password",
    "preview": "Preview",
    "seen_total": "Total visits",
    "action_more": "More actions",
    "hide_bottom_sheet": "Drag down or press ESC or click outside to close",
    "set_downloadable": "Downloadable video",
    "set_undownloadable": "Not downloadable video",
    "set_generateMultipleFormats": "Generate multiple formats",
    "set_ungenerateMultipleFormats": "Do not generate multiple formats",
    "set_logoIncrusted": "Insert the logo",
    "set_unlogoIncrusted": "Do not insert the logo",
    "set_offline": "Put the video offline",
    "set_online": "Put the video online",
    "set_secure": "Secure video",
    "set_unsecure": "Do not secure video",
    "set_useTheme": "Use the theme",
    "set_unuseTheme": "Do not use the theme",
    "set_locked": "Secure video with a password",
    "set_unlocked": "Do not secure video with a password",
    "set_mainPage": "Home video",
    "set_unmainPage": "Is not a home video",
    "set_sendPushNotifications": "Send push notifications",
    "set_unsendPushNotifications": "Do not send push notifications",
    "update_success": " was updated successfully",
    "add_success": " was added successfully",
    "vid_is_transcoding": "Video being transcoded",
    "pod_is_transcoding": "Podcast being transcoded",
    "vid_not_transcoded": "Video has not been transcoded or yet to be transcoded.If so please try to change the video file",
    "select_server": "Select a streaming server",
    "action_links": "List of links",
    "generate_vignette": "Generate thumbnail",
    "form_step_vide_images": "Thumbnail of the video",
    "choose_thumb_from_local": "Add a thumbnail",
    "choose_thumb_from_selected_theme": "Choose the thumbnail from the selected theme",
    "choose_thumb_from_generated": "Choose the thumbnail from the generated ones",
    "theme_not_selected": "You have not selected any theme",
    "theme_does_not_have_a_thumb": "No thumbnail for selected themes",
    "waiting_for_thumbs": "Waiting for auto generated thumbnails",
    "video_did_not_generate_thumbs": "No thumbnail was generated for this video",
    "error_on_getting_generated_thumbs": "An error occurred while retrieving the thumbnails of the video",
    "regenerate_new_thumbs": "Regenerate new thumbnails",
    "preview_video": "Preview video",
    "video_preview": "Preview of the video",
    "playlist_preview": "Preview of the playlist",
    "validate_changes": "Validate changes",
    "action_change_video_source": "Change video source file",
    "loading_player": "Loading video player",
    "action_video_caption": "Video captions",
    "caption_upload_drop_message": "You can also drop a caption file here to upload it. Only *.srt *.vtt *.txt files are authorised.",
    "alert_not_valid_caption_message": "The file you've tried to upload is not a caption file.Please select a caption file with one of the following extensions: *.srt *.vtt *.txt",
    "alert_not_valid_csvfile_message": "The file you've tried to upload is not a excel file.Please select a file with extension: *.csv",
    "alert_not_valid_xml_message": "The file you've tried to upload is not an xml file.Please select a file with extension: *.xml",
    "see_file_model": "Formats of different types of subtitles: ",
    "invalid_time_format": "The format of the field must be: XX: XX: XX<\/strong> where X represents a number",
    "download_file": "Download file",
    "preview_file": "File preview : {{fileName}} ",
    "is_superior_to_end_duration": "The start time can not be more superior than the end time",
    "is_superior_to_video_duration": "The end time can not be more superior than the duration of the video",
    "is_inferior_to_start_duration": "The end time can not be lower than the start time",
    "start_recording_subtitle_duration": "Beginning of a subtitle",
    "stop_recording_subtitle_duration": "End of subtitle",
    "you_must_choose_a_thumb": "You must choose a thumbnail",
    "add_caption": "Add caption",
    "action_video_rich_media": "Video rich-media",
    "add_slide": "Add slide",
    "add_slides": "Add slides",
    "add_slides_image": "Add images",
    "add_slides_video": "Add videos",
    "upload_slides_image": "Upload images <br>Only jpg, jpeg, png, gif are authorised.",
    "upload_slides_video": "Upload videos <br>Only mp4 are authorised.",
    "add_chapter": "Add chapter",
    "modify_slide": "Modify slide",
    "modify_chapter": "Modify chapter",
    "modify_survey": "Modify question",
    "push_video_on": "Push ON",
    "push_video_off": "Push OFF",
    "export_youtube": "Export Youtube",
    "export_facebook": "Export Facebook",
    "export_twiter": "Export Twitter",
    "export_linkdin": "Export Linkedin",
    "delete_video": "Delete video",
    "description_audio": "Audio description of the video",
    "export_video": "Video's link and URL",
    "montage_video": "Video editor",
    "chronologie_video": "Video chronology",
    "progressive_download": "Progressive download",
    "permalien": "Permalink",
    "title_modal_url": "Export this video : ",
    "rich_media_presentation": "Rich-Media",
    "internet": "Internet broadcast",
    "send": "Send",
    "reset": "reset",
    "click_to_edit": "Click to edit",
    "expand": "Expand",
    "collapse": "Collapse",
    "action_video_stats": "Statistics",
    "export_canal": "Canal's link and URL",
    "title_channel_url": "Export this canal ",
    "export_theme": "Theme's link and URL",
    "stockage_detail": "Storage by server",
    "export_links_embed": "Embed link",
    "export_links_permalien": "Permalink",
    "form": "Form",
    "form_complementary_info": "Further information",
    "form_organisator_info": "Organizer information",
    "action_export_event": "Event export links",
    "inprogress_montage": "Mounting in progress",
    "alert_check_values": "Start time must be lower than the end time",
    "video_not_exist": "Source video is not available",
    "video_by_mail": "Sending video by email",
    "form_attr_group": "Group",
    "delete_language": "Delete this language",
    "apercu_media": "View media",
    "edit_language": "Update the language",
    "edit_video_file": "Update the video file",
    "embed_code": "Embed code",
    "add_language": "Add language",
    "added_language": "Language added successfully",
    "language_exist": "Language already exists",
    "action_video_language": "Add language",
    "action_video_restart": "Restart live",
    "intranet_broadcast": "Intranet Broadcast",
    "internet_broadcast": "Internet Broadcast",
    "link_copied": "Copied!",
    "subscribers_group": "Subscribers group",
    "no_subscriptionUser_was_found": "No subscriber found!",
    "or": "Speaker",
    "help": "Help",
    "details": "Details",
    "nb_visits": "Visits number",
    "more_details": "More details",
    "next": "Next",
    "previous": "Previous",
    "no_videos": "No video for your choice",
    "no_lives": "No live for your choice",
    "display_modes": "Display mode",
    "success_change": "Display mode changed successfully",
    "display_options": "Display options",
    "take_vignette": "Make a screenshot of the vignette",
    "take_vignette_from_video": "Capture from the video",
    "add_answer": "Add answer",
    "answer": "Answer",
    "multiple_choice": "Multiple choice",
    "simple_choice": "Simple choice",
    "add_survey": "Add question",
    "add_quiz": "Add quiz",
    "add_interactivity": "Add index",
    "question": "Question:",
    "chapter": "Chapter:",
    "quiz": "Quiz:",
    "question_tooltip": "Question",
    "chapter_tooltip": "Chapter",
    "quiz_tooltip": "Quiz",
    "slide_tooltip": "Slide",
    "slide": "Slide:",
    "index": "Index",
    "add": "Add",
    "reduce": "Reduce",
    "show": "Show",
    "elements": "elements",
    "of": "of",
    "first": "First",
    "last": "Last",
    "keywords": "Key words,Id/UID",
    "url_not_valid": "Not valid URL!",
    "alert_url_video_error": "The inserted URL does not match a video",
    "make_vignette": "Set as thumbnail",
    "select_language_caption": "Select caption language",
    "msg_show_date": "Click to show end date",
    "msg_hide_date": "Click to hide end date",
    "join_files": "Attach files",
    "select_color": "Background color",
    "acces_rapide": "Quick access",
    "ou": "or",
    "add_thumb": "Generate a thumbnail",
    "export_podcast": "RSS link",
    "whitelist": "Whitelist",
    "blacklist": "Blacklist",
    "error_read_video": "Preview will be available once transcoding is complete",
    "expired_token": "Expired URL!",
    "success_reload": "the update of the display on the box has been carried out successfully",
    "button_reload_display": "Refresh the display on the box",
    "invalid_mail_delete": "Invalid email address! we removed it.",
    "download_csv": "Download CSV",
    "entity": "Entity",
    "function": "Function",
    "action_edition": "Video edition",
    "reload_transcription": "Transcription with proofreading",
    "auto_transcription": "Automatic transcription",
    "transcription": "Transcription",
    "intervention": "Interventions",
    "not_valid_youtube": "Insert a valid embed URL : https://www.youtube.com/embed/43ngkc2Ejgw",
    "not_valid_dailymotion": "Insert a valid embed URL : https://www.dailymotion.com/embed/video/x5ce0e6",
    "erreur401_title": "Unauthorized access",
    "erreur401_message": "Please contact the administrator",
    "selection_vignettes": "thumbnails selection",
    "selection_channels": "Channels",
    "default": "Define by default",
    "default_channel": "Default channel",
    "list_channels": "List of channels",
    "new":"New",
    "add_video":"Add video",
    "add_videos":"Add videos",
    "add_live":"Make live",
    "create_video":"Create video",
    "create_live":"Create playlist live",
    "empty_dashboard":"No recent videos to display at the moment!",
    "tv_show": "Watch TV",
    "change_file_source":"Do you want to replace the existing video?",
    "action_export_youtube":"Youtube export",
    "list_groups": "Video group",
    "stats": "Stats",
    "rubric": "Rubric",
    "thematic": "Thematic"
  },
  "PAGESMENUSTITLES": {
    "webskin": "web skin",
    "themes": "themes",
    "liveskin": "live skin",
    "playerskin": "player skin",
    "website_menuTitle":"Options",
    "metric_menuTitle": "metric",
    "video_menuTitle": "video",
    "parameters": "Settings",
    "parametersFM": "Settings",
    "form_diffusion_title_menu_title": "Broadcast",
    "dashboard_menuTitle": "Dashboard",
    "media_menuTitle": "Media",
    "media_menuTitleFM": "Media",
    "media_comments_menuTitle": "Comment",
    "support_menuTitle": "Support",
    "documentation_menuTitle": "User Guide ",
    "key_menuTitle": "Api key",
    "comments_list_pagetitle": "List of comments",
    "lives_comments_list_live_pagetitle": "List of comments",
    "media_comments_list_menuTitle": "List",
    "comments_add_pagetitle": "Add new comment",
    "media_comments_add_menuTitle": "New comment",
    "media_comments_edit_pagetitle": "Comment edition",
    "media_comments_detail_pagetitle": "Comment detail",
    "parameters_theme_list_pagetitle": "List of themes",
    "parameters_rubric_list_pagetitle": "List of rubrics",
    "parameters_theme_list_menuTitle": "List",
    "parameters_theme_add_pagetitle": "Add new theme",
    "parameters_theme_add_menuTitle": "New theme",
    "parameters_rubric_add_menuTitle": "New Rubric",
    "parameters_menuTitle": "Parameter",
    "parameters_theme_menuTitle": "Theme",
    "parameters_rubric_menuTitle": "Rubrics",
    "parameters_theme_menuTitleFM": "Theme",
    "parameters_theme_edit_pagetitle": "Edit theme",
    "parameters_rubric_edit_pagetitle": "Edit rubric",
    "parameters_theme_detail_pagetitle": "Theme detail",
    "parameters_rubric_detail_pagetitle": "Rubric detail",
    "parameters_canal_list_pagetitle": "List of channels",
    "parameters_canal_list_menuTitle": "List",
    "parameters_canal_add_pagetitle": "Add new channel",
    "parameters_canal_add_menuTitle": "New channel",
    "parameters_canal_menuTitle": "Channel",
    "parameters_thematic_menuTitle": "Thematic",
    "parameters_canal_edit_pagetitle": "Edit channel",
    "parameters_canal_detail_pagetitle": "Channel detail",
    "parameters_canal_detail_modal_pagetitle": "Channel detail",
    "specifics_station_list_pagetitle": "List of stations",
    "specifics_station_list_menuTitle": "List",
    "specifics_station_add_menuTitle": "New station",
    "specifics_menuTitle": "Encoder",
    "specifics_station_menuTitle": "Station",
    "specifics_station_edit_pagetitle": "Station edition",
    "specifics_station_detail_pagetitle": "Station detail",
    "specifics_direction_list_pagetitle": "List of directions",
    "specifics_direction_list_menuTitle": "List",
    "specifics_direction_add_menuTitle": "New direction",
    "specifics_direction_menuTitle": "Direction",
    "specifics_direction_edit_pagetitle": "Direction edition",
    "specifics_direction_detail_pagetitle": "Direction detail",
    "specifics_iptv_list_pagetitle": "List of IP-TVs",
    "specifics_iptv_list_menuTitle": "List",
    "specifics_iptv_add_menuTitle": "New IP-TV",
    "specifics_iptv_menuTitle": "IP-TV",
    "specifics_iptv_edit_pagetitle": "IP-TV edition",
    "specifics_iptv_detail_pagetitle": "IP-TV detail",
    "configuration_rmboxgroup_list_pagetitle": "List of RmBox group",
    "configuration_rmboxgroup_list_menuTitle": "List",
    "configuration_rmboxgroup_add_menuTitle": "New RmBox group",
    "configuration_menuTitle": "Configuration",
    "configuration_rmboxgroup_menuTitle": "RmBox group",
    "configuration_rmboxgroup_edit_pagetitle": "Edit RmBox group",
    "configuration_rmboxgroup_detail_pagetitle": "RmBox group detail",
    "configuration_server_list_pagetitle": "List of servers",
    "configuration_server_list_menuTitle": "List",
    "configuration_server_add_menuTitle": "New server",
    "configuration_server_menuTitle": "Server",
    "configuration_server_edit_pagetitle": "Server edition",
    "configuration_server_detail_pagetitle": "Server detail",
    "configuration_rmbox_list_pagetitle": "List of RmBox",
    "configuration_rmbox_list_menuTitle": "List",
    "configuration_rmbox_add_menuTitle": "New RmBox",
    "configuration_intervention_add_menuTitle": "New intervention",
    "configuration_intervention_edit_menuTitle": "Intervention edition",
    "configuration_rmbox_menuTitle": "RmBox",
    "rmbox_autorise_ip_menuTitle": "Allowed IP",
    "rmbox_autorise_ip_add_menuTitle": "Add a new IP address",
    "rmbox_autorise_ip_edit_menuTitle": "Allow IP address edition",
    "rmbox_autorise_ip_list_pagetitle": "List of allowed IPs",
    "configuration_rmbox_edit_pagetitle": "RmBox edition",
    "configuration_rmbox_detail_pagetitle": "RmBox detail",
    "configuration_zone_list_pagetitle": "List of zones",
    "configuration_zone_list_menuTitle": "List",
    "configuration_zone_add_menuTitle": "New zone",
    "configuration_zone_menuTitle": "Zone",
    "configuration_zone_edit_pagetitle": "Zone edition",
    "configuration_zone_detail_pagetitle": "Zone detail",
    "configuration_presets_list_pagetitle": "List of presets",
    "configuration_presets_list_menuTitle": "List",
    "configuration_presets_add_menuTitle": "New presets",
    "configuration_presets_menuTitle": "Preset",
    "configuration_presets_edit_pagetitle": "Presets edition",
    "configuration_presets_detail_pagetitle": "Presets detail",
    "configuration_general_list_pagetitle": "List of generals",
    "configuration_general_list_menuTitle": "List",
    "configuration_general_add_menuTitle": "New general",
    "configuration_general_menuTitle": "General",
    "configuration_general_edit_pagetitle": "General edition",
    "configuration_general_detail_pagetitle": "General detail",
    "abonnement_group_list_pagetitle": "List of groups",
    "abonnement_group_list_menuTitle": "List",
    "abonnement_group_add_menuTitle": "New group",
    "abonnement_menuTitle": "Subscription",
    "abonnement_group_menuTitle": "Subscriber groups",
    "abonnement_group_edit_pagetitle": "Group edition",
    "abonnement_group_detail_pagetitle": "Group detail",
    "abonnement_thematic_detail_pagetitle": "Thematic detail",
    "abonnement_user_list_pagetitle": "List of users",
    "abonnement_user_list_menuTitle": "List",
    "abonnement_user_add_menuTitle": "Add new user",
    "abonnement_user_menuTitle": "Subscriber users",
    "abonnement_user_edit_pagetitle": "User edition",
    "abonnement_user_detail_pagetitle": "User details",
    "sondage_list_pagetitle": "List of survey",
    "sondage_list_menuTitle": "List",
    "sondage_add_menuTitle": "New survey",
    "sondage_menuTitle": "Survey",
    "sondage_edit_pagetitle": "Survey edition",
    "sondage_detail_pagetitle": "Survey detail",
    "vote_list_pagetitle": "Detailed survey list",
    "playlist_list_pagetitle": "Playlists",
    "playlist_list_menuTitle": "List",
    "playlist_add_menuTitle": "Add playlist",
    "playlist_menuTitle": "Playlist",
    "playlist_edit_pagetitle": "Edit playlist",
    "playlist_detail_pagetitle": "Playlist detail",
    "playlist_live_list_pagetitle": "Live playlist",
    "playlist_list_simple": "List of playlists",
    "playlist_list_live": "List of playlists direct",
    "playlist_live_list_menuTitle": "List",
    "playlist_live_add_menuTitle": "New live playlist",
    "playlist_live_menuTitle": "Live playlist",
    "playlist_live_edit_pagetitle": "Live playlist edition",
    "playlist_live_detail_pagetitle": "Live playlist detail",
    "playlist_live_calendar_pagetitle": "Live playlists calendar",
    "playlist_live_calendar_menuTitle": "Calendar",
    "chutier_list_pagetitle": "Video bin",
    "chutier_list_menuTitle": "List",
    "chutier_add_menuTitle": "New video trim",
    "chutier_menuTitle": "Video trim",
    "metaData_menuTitle": "metaData",
    "skin":"Skin",
    "chutier_edit_pagetitle": "Video trim edition",
    "chutier_detail_pagetitle": "Video trim detail",
    "advertising_list_pagetitle": "List of advertising",
    "advertising_list_menuTitle": "List",
    "advertising_add_menuTitle": "New advertising",
    "advertising_menuTitle": "Advertising",
    "advertising_edit_pagetitle": "Advertising edition",
    "advertising_detail_pagetitle": "Advertising detail",
    "profiles_user_list_pagetitle": "List of users",
    "profiles_user_list_menuTitle": "List",
    "profiles_user_add_menuTitle": "New user",
    "profiles_menuTitle": "Profile",
    "profiles_user_menuTitle": "User",
    "profiles_user_edit_pagetitle": "User edition",
    "profiles_user_detail_pagetitle": "User detail",
    "profiles_user_edit_pwd_pagetitle": "User password edition",
    "profiles_group_list_pagetitle": "List of groups",
    "profiles_group_list_menuTitle": "List",
    "profiles_group_add_menuTitle": "New group",
    "profiles_group_menuTitle": "Group",
    "profiles_group_edit_pagetitle": "Group edition",
    "profiles_group_detail_pagetitle": "Group detail",
    "profiles_ip_menuTitle": "IP",
    "profiles_ip_list_pagetitle": "List of IPs",
    "profiles_ip_list_menuTitle": "List",
    "profiles_ip_detail_pagetitle": "IP address details",
    "profiles_ip_add_menuTitle": "Add a new IP address",
    "profiles_ip_edit_pagetitle": "IP address edition",
    "media_video_menuTitle": "Video",
    "media_video_upload_menuTitle": "New video",
    "media_audio_upload_menuTitle": "New audio file",
    "media_video_list_menuTitle": "List",
    "media_video_list_ongoing_menuTitle": "Ongoing",
    "media_video_list_upcoming_menuTitle": "Upcoming",
    "media_video_list_offline_menuTitle": "Offline",
    "media_video_list_all_videos_menuTitle": "All",
    "media_video_list_all_menuTitle": "Show all videos",
    "media_video_list_archived_menuTitle": "Archived",
    "media_video_list_archived-exceed_menuTitle": "Trash",
    "media_video_list_archived-exceed_pagetitle": "List of videos from the trash",
    "media_video_edit_pagetitle": "Editing video information",
    "media_video_questions_quiz": "Questions/Quiz",
    "media_video_reupload_pagetitle": "Changing the source file of the video",
    "media_video_caption_pagetitle": "Captioning of the video",
    "media_video_rich_media_pagetitle": "Rich-media for the video",
    "event_list_pagetitle": "Events",
    "event_list_menuTitle": "List",
    "event_add_menuTitle": "Add event",
    "event_add_pagetitle": "Add new event",
    "event_menuTitle": "Event",
    "event_edit_pagetitle": "Event edition",
    "event_detail_pagetitle": "Event detail",
    "event_detail_modal_pagetitle": "Event detail",
    "event_calendar_pagetitle": "Event calendar",
    "event_calendar_menuTitle": "Calendar",
    "event_list_archived_menuTitle": "List of archived events",
    "event_list_ongoing_menuTitle": "Ongoing",
    "event_list_upcoming_menuTitle": "Upcoming",
    "event_list_all_pagetitle": "List of events ",
    "event_list_upcoming_pagetitle": "List of upcoming events",
    "event_list_ongoing_pagetitle": "List of ongoing events",
    "event_list_archived_pagetitle": "List of ended events",
    "event_list_trash_pagetitle": "List of events from the trash",
    "param_list_pagetitle": "List of parameters",
    "param_list_menuTitle": "List",
    "param_add_pagetitle": "Add new parameters",
    "param_add_menuTitle": "New parameters",
    "menuTitle": "Configuration",
    "param_menuTitle": "Client",
    "param_edit_pagetitle": "Edit parameters",
    "param_detail_pagetitle": "Parameter detail",
    "lives_list_pagetitle": "Live",
    "lives_list_menuTitle": "List",
    "lives_add_pagetitle": "Add new live ",
    "lives_add_menuTitle": "New live ",
    "lives_menuTitle": "Live",
    "lives_edit_pagetitle": "Live edition",
    "lives_detail_pagetitle": "Live detail",
    "lives_detail_modal_pagetitle": "Live detail",
    "lives_calendar_pagetitle": "Lives calendar",
    "lives_calendar_menuTitle": "Calendar",
    "lives_list_archived_menuTitle": "Finished",
    "lives_list_ongoing_menuTitle": "On going",
    "lives_list_upcoming_menuTitle": "Upcoming",
    "lives_list": "List of lives",
    "events_list": "List of events",
    "live_conf_add_menuTitle": "Live configuration",
    "live_conf_add_pagetitle": "New configuration",
    "lives_list_ongoing_pagetitle": "List of available lives",
    "lives_list_encodeur_pearl": "Encoder Pearl",
    "lives_list_archived_pagetitle": "List of archived lives",
    "lives_list_upcoming_pagetitle": "List of upcoming lives",
    "lives_list_endless_pagetitle": "List of available lives",
    "lives_list_all_pagetitle": "List of all lives",
    "lives_list_trash_pagetitle": "List lives in trash",
    "lives_list_offline_pagetitle": "List of lives offline",
    "send_invitation_detail_pagetitle": "Send invitation",
    "export_links_pagetitle": "Webinar export link",
    "info_detail_pagetitle": "Webinar information",
    "live_comment_list_pagetitle": "List of comments",
    "home_menuTitle": "Home page",
    "home_conf_add_menuTitle": "Configuration",
    "media_home_menuTitle": "Home page",
    "media_home_conf_menuTitle": "Configuration",
    "media_home_list_pagetitle": "Home page video list",
    "media_home_list_menuTitle": "Home videos",
    "media_home_push_menuTitle": "Push video",
    "media_video_list_ongoing_pagetitle": "Online videos",
    "media_video_list_all_pagetitle": "All videos",
    "media_video_list_upcoming_pagetitle": "Upcoming videos",
    "media_video_list_offline_pagetitle": "Offline videos",
    "media_video_list_archived_pagetitle": "Archived videos",
    "media_video_list_upload_pagetitle": "New video",
    "media_video_list_edit_pagetitle": "Editing video information",
    "media_video_list_caption_pagetitle": "Captioning of the video",
    "media_video_list_rich_media_pagetitle": "Rich-media for the video",
    "media_video_list_montage_pagetitle": "Mounting",
    "core_menuTitle": "Option",
    "core_new_menuTitle": "Module",
    "core_right_menuTitle": "Permission",
    "core_rights_action_menuTitle": "List of permissions actions",
    "core_rights_module_menuTitle": "List of permissions modules",
    "core_rights_group_pagetitle": "Group rights management ",
    "player_parameters_list_intra_menuTitle": "Intranet list",
    "player_parameters": "Play video",
    "player_parametersFM": "Play video",
    "configuration_mooc": "Mooc",
    "config_mooc_list_menuTitle": "Configuration Mooc List",
    "player_parameterslist_pagetitle": "Internet list",
    "player_parameters_list_menuTitle": "Internet list",
    "stats_pagetitle": "Statistic",
    "stats_vod_pagetitle": "Video",
    "stats_live_by_id_pagetitle":"Live statistics",
    "stats_event_by_id_pagetitle":"Event statistics",
    "stats_vod_by_id_pagetitle":"Video statistics",
    "stats_podcast_pagetitle": "Podcast",
    "vote_detail_pagetitle": "Detailed votes list",
    "vote_details_pagetitle": "Detailed votes list",
    "stats": "Statistic",
    "stats_dashboard": "Dashboard",
    "stats_videos": "Video statistics",
    "stats_event_pagetitle": "Event statistics",
    "stats_access": "Audit Log",
    "stats_access_detail": "Traceability",
    "stats_access_pageTitle": "Session list",
    "stats_live_pagetitle": "Live statistics",
    "stats_access_detail_pageTitle": "Access list",
    "stats_consumption_pagetitle": "Consumption",
    "stats_storage_pagetitle": "Storage",
    "stats_users": "Users statistics",
    "export_Live_links_pagetitle": "Live export link :",
    "interactivity_menuTitle": "Interactivity",
    "boitier_menuTitle": "Box",
    "stats_mooc": "Mooc",
    "stats_mooc_pagetitle": "Pass Digital statistics",
    "classifying_menuTitle": "Classification",
    "classifying_thematic_menuTitle": "Thematics",
    "classifying_thematic_add_menuTitle": "New thematic",
    "classifying_thematic_edit_menuTitle": "Edit thematic",
    "classifying_thematic_list_pageTitle": "List of Thematics",
    "live_title_comment_list_pagetitle": "List of comments of the live: ",
    "media_title_comment_list_pagetitle": "List of comments of the video: ",
    "export_links_modal_title": "Export links",
    "display_menuTitle": "Display",
    "display_new_menuTitle": "New Display",
    "display_programs_menuTitle": "Program",
    "display_programs_list_pagetitle": "List of programs",
    "display_programs_list_menuTitle": "List",
    "display_programs_add_pagetitle": "Add a new program",
    "display_programs_add_menuTitle": "New program",
    "display_programs_edit_pagetitle": "Prgram edit",
    "display_programs_edit_menuTitle": "Program edit",
    "display_schedule_menuTitle": "Programs schedule",
    "display_schedule_list_menuTitle": "Calendar",
    "display_schedule_calendar_pagetitle": "Schedules list",
    "display_schedule_calendar_menuTitle": "Calendar",
    "display_schedule_add_pagetitle": "add a new schedule",
    "display_schedule_add_menuTitle": "New schedule",
    "display_schedule_edit_menuTitle": "Update schedule",
    "template_manager_editor_menuTitle": "Editor",
    "template_manager_editor_list_pagetitle": "List of screens",
    "template_manager_editor_list_menuTitle": "List",
    "template_manager_editor_generator_pagetitle": "Generation of a new screen",
    "template_manager_editor_generator_menuTitle": "Generation of a new screen",
    "template_manager_editor_edit_pagetitle": "Screen Editing",
    "template_manager_editor_edit_menuTitle": "Screen Editing",
    "template_manager_menuTitle": "Template",
    "template_manager_list_menuTitle": "Templates list",
    "template_manager_template_menuTitle": "Template",
    "template_manager_template_add_menuTitle": "Add template",
    "template_manager_template_edit_menuTitle": "Update template",
    "template_manager_template_list_menuTitle": "List of templates",
    "template_manager_screen_menuTitle": "Screen",
    "template_manager_screen_list_menuTitle": "List of screens",
    "page_export_dailymotion_title": "Export to Dailymotion",
    "media_video_montage_pagetitle": "Mounting",
    "parameters_podcast_add_menuTitle": "Add podcast",
    "parameters_podcast_edit_menuTitle": "Edit podcast",
    "parameters_podcast_detail_pagetitle": "Podcast detail",
    "parameters_podcast_menuTitle": "Podcast",
    "parameters_podcast_list_pagetitle": "List of podcasts",
    "podcast_menuTitle": "Podcast",
    "images_menuTitle": "Photo Gallery",
    "configuration_referrers_add_menuTitle": "Add referrer",
    "configuration_referrers_edit_menuTitle": "Edit referrer",
    "configuration_referrers_menuTitle": "Referrer",
    "configuration_referrers_detail_pagetitle": "Referrer detail",
    "configuration_referrers_list_pagetitle": "List of referrer",
    "configuration_news_menuTitle": "News",
    "configuration_news_add_menuTitle": "Add news",
    "configuration_news_edit_pagetitle": "Edit news",
    "configuration_news_list_pagetitle": "Liste of news",
    "stats_list_videos_pagetitle": "Export video statistics",
    "stats_list_podcasts_pagetitle": "Export podcast statistics",
    "configuration_rmbox_interventions_pagetitle": "Interventions list",
    "skin_menuTitle": "Skin",
    "skin_player_menuTitle": "Player",
    "scorm_menuTitle":"Scorm",
    "display_template_segment_menuTitle": "Segment",
    "display_segments_list_menuTitle": "Segment List",
    "subscriptions": "My subscriptions",
    "bills": "My bills",
    "display_segments_edit_menuTitle": "Edit",
    "display_segments_add_menuTitle": "Add",
    "stats_podcasts": "Podcast stats ",
    "stats_p2p":"P2P stats"
  },
  "NAVIGATION":{
    "safran_preprod":"SAFRAN",
    "test":"TEST"
  }
}
);

$translateProvider.translations("fr", {
  "MESSAGES": {
    "total_records": "Nombre total d'enregistrements:",
    "title_description": "Titre,Description",
    "resizeText": "Redimensionner <br> votre image choisie",
    "return": "Retour",
    "cancel": "Annuler",
    "save": "Enregistrer",
    "choose": "Choisir un fichier",
    "fileSelected": "Aucun fichier séléctionné",
    "title": "Titre",
    "actions": "Actions",
    "action": "Action",
    "search": "Rechercher...",
    "share": "Partager",
    "identifier": "Identifiant",
    "deselect": "D\u00e9s\u00e9lectionner",
    "select": "S\u00e9lectionner",
    "dialog_confirm_delete": "Supprimer",
    "dialog_cancel": "Annuler",
    "dialog_will_be_deleted": " sera supprim\u00e9.",
    "dialog_list_will_be_deleted": "Les \u00e9l\u00e9ments s\u00e9lectionn\u00e9s seront supprim\u00e9s",
    "dialog_element_will_be_deleted": "L' \u00e9l\u00e9ment s\u00e9lectionn\u00e9 sera supprim\u00e9",
    "undeleted_are": "Les commentaires ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les commentaires ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_selected_comments_msg": "Suppression des commentaires s\u00e9lectionn\u00e9s",
    "form_add": "Ajouter",
    "form_change": "Changer",
    "form_save": "ENREGISTRER",
    "form_attr_title": "Titre",
    "form_attr_source": "Fichier source",
    "form_attr_canal": "Canal",
    "form_attr_canals": "Canaux",
    "form_attr_description": "Description",
    "form_attr_parentId": "Th\u00e8me parent",
    "form_attr_parentRubricId": "Rubrique parent ",
    "form_validate": "Valider",
    "back_to_list": "Retour \u00e0 la liste",
    "form_choices_disable": "D\u00e9sactiver",
    "form_RTMP": "RTMP",
    "form_HDS": "HDS",
    "form_choices_enable": "Activer",
    "form_is_required": "Ce champ est obligatoire",
    "form_is_minlength": "Ce champ doit comporter plus de 10 chiffres",
    "form_is_maxlength": "Ce champ ne doit pas d\u00e9passer 10 chiffres",
    "form_is_minlengthpwd": "Ce champ doit comporter au moins 8 caract\u00e8res",
    "form_is_patternpwd": "Ce champ doit comporter au moins une lettre majuscule, une lettre minuscule et un chiffre",
    "form_is_patternpwdspecial": "Ce champ doit comporter au moins une lettre majuscule, une lettre minuscule, un caractère spécial et un chiffre",
    "form_is_patternphone": "Suivez la forme (0##########) ou (+33##########) ou (0033##########) ou (0# - #### - #####) ou (+33# - #### - #####) ou (0033# - #### - #####)",
    "form_is_pattern_fullname": "Interdire la saisie de chiffres et caract\u00e8res sp\u00e9ciaux",
    "form_is_email": "Ce champ doit \u00eatre une adresse e-mail valide.",
    "form_is_num_positive": "Ce champ doit \u00eatre un nombre positif",
    "form_choices_yes": "Oui",
    "form_choices_no": "Non",
    "form_choices": "Choix : Votes",
    "form_choices_use_default_config": "Utiliser la configuration par d\u00e9faut",
    "form_attr_visibility": "Visibilit\u00e9",
    "form_attr_classifiedBy": "Ordre des vid\u00e9os",
    "form_max_length": "Ce champ doit comporter moins de {{length}} caract\u00e8res.",
    "form_cancel": "Annuler",
    "form_retour": "Retour",
    "form_add_file": "Ajouter un fichier",
    "alert_error": "Alert !",
    "alert_live": "Quitter le direct",
    "alert_update_profile": "Quitter la modification",
    "alert_close": "Fermer",
    "alert_confirm": "Quitter",
    "alert_save": "Enregistrer",
    "alert_message": "Êtes-vous sûr de vouloir quitter la page ?",
    "user_valid": "Êtes-vous sûr de vouloir quitter avant  l'enregistrement?",
    "alert_not_valid_image_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une image. Veuillez s\u00e9lectionner une image avec l'une des extensions suivantes : *.PNG *.JPG *.JPEG *.GIF",
    "alert_not_valid_document_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas un document. Veuillez s\u00e9lectionner un document avec l'une des extensions suivantes : *.DOC *.DOCX *.HTML *.HTM *.ODT *.PDF *.XLS *.XLSX *.ODS *.PPT *.PPTX *.TXT",
    "alert_not_valid_size_image_message": "La taille de l'image que vous avez essay\u00e9e de t\u00e9l\u00e9charger est inf\u00e9rieure à la taille minimale. Veuillez s\u00e9lectionner une image avec une taille minimale de",
    "alert_image_too_large_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger est trop grand. La taille maximale autorisée est 1024 ko.",
    "alert_operation_not_completed": "L'op\u00e9ration n'a pas pu aboutir. Veuillez v\u00e9rifier avec votre responsable. Merci.",
    "alert_diffusion": "veuillez choisir un mode de diffusion \"internet ou intranet\"",
    "alert_check_form": "Il y a des erreurs dans votre formulaire. Veuillez v\u00e9rifier encore une fois. Merci.",
    "alert_xhr_error": "Une erreur s'est produite. Veuillez r\u00e9essayer plus tard. Si le probl\u00e8me persiste veuillez en informer votre responsable technique. Merci.",
    "alert_edit_confirm": "Votre modification a \u00e9t\u00e8 enregistr\u00e8e",
    "deselect_all": "Tout d\u00e9s\u00e9lectionner",
    "select_all": "Tout s\u00e9lectionner",
    "form_attr_language": "Langue",
    "form_attr_server": "Serveur de streaming",
    "form_attr_sendPushNotification": "Envoyer des notifications push",
    "form_attr_activate_permalien": "Activer permalien",
    "form_iscdn": "CDN",
    "form_isvbr": "VBR",
    "form_attr_mbr": "MBR",
    "form_reading_protocol": "Protocole de lecture",
    "created_at": "Date d'ajout ",
    "updated_at": "Date d'\u00e9dition : ",
    "action_detail": "D\u00e9tail",
    "action_duplicate": "Dupliquer",
    "action_edit": "Modifier",
    "action_diffuse": "Diffuser",
    "action_delete": "Supprimer",
    "none": "Aucun",
    "all": "Tous",
    "nonef": "Aucune",
    "file_imported": "{{fileName}} \u00e0 \u00e9t\u00e9 import\u00e9e avec succ\u00e8s.",
    "hide": "Cacher",
    "undo": "Annuler",
    "field_must_be_numeric": "Ce champ ne peut contenir qu'une valeur num\u00e9rique (Ex: #;#.#;-#.#;-.#;+#;+#.#;+.#)",
    "field_must_be_ip": "Entrez une adresse IP valide",
    "field_must_be_mac": "Entrez une MAC adresse valide",
    "alert_login_badCredentials": "Donn\u00e9es incorrectes, veuillez v\u00e9rifier votre login et mot de passe !",
    "alert_login_badCode": "Le code est incorrect, essayez à nouveau",
    "action_refresh_content": "Actualiser le contenu",
    "action_new_element": "Ajouter un nouveau \u00e9l\u00e9ment",
    "action_questions_quiz": "Questions/Quiz",
    "form_is_num": "Ce champ ne peut contenir qu'une valeur num\u00e9rique",
    "form_is_entier": "Ce champ ne peut contenir qu'une valeur entier",
    "form_attr_loop": "Lire en boucle",
    "form_attr_unique": "Lire une seule fois",
    "form_attr_order": "Respecter l'ordre param\u00e9tr\u00e9",
    "form_attr_duration": "Dur\u00e9e de diffusion (en secondes)",
    "form_choices_title": "Ordre alphab\u00e9tique",
    "form_choices_videodate": "Date de cr\u00e9ation",
    "form_type_visa": "Visa",
    "form_type_Passport": "Passeport",
    "vid_list_select": "Liste des vid\u00e9os s\u00e9lectionn\u00e9es",
    "vid_list": "Liste des vid\u00e9os",
    "click_to_add": "Ajouter des vidéos",
    "form_attr_onair": "ON AIR (diffusion en cours)",
    "start_date": "Date de d\u00e9but",
    "date": "Date",
    "theme": "Thème",
    "date_hour": "Date Et Heure",
    "start_dt": "D\u00e9but",
    "end_dt": "Fin",
    "start_time": "Heure de d\u00e9but",
    "end_time": "Heure de fin",
    "date_valid": "La valeur saisie n'est pas une date !",
    "date_min": "Impossible, la date est d\u00e9pass\u00e9e !",
    "date_max": "Impossible, la date est trop lointaine !",
    "time_min": "Le temps est trop t\u00f4t !",
    "time_max": "Le temps est trop tardive !",
    "time_format": "Format invalide !",
    "calendar_week": "Semaine",
    "calendar_day": "Jour",
    "calendar_month": "Mois",
    "calendar_today": "Aujourd'hui",
    "calendar_allday": "Toute la journ\u00e9e",
    "calendar_next": "Suivant",
    "calendar_pervious": "Pr\u00e9c\u00e9dent",
    "basic_info": "Informations basiques",
    "calendar": "Calendrier",
    "drop_to_upload": "D\u00e9poser pour t\u00e9l\u00e9charger",
    "upload": "T\u00e9l\u00e9charger",
    "video_upload_drop_message": "Vous pouvez \u00e9galement d\u00e9poser une vid\u00e9o ici pour la t\u00e9l\u00e9charger.<br>Seulement flv<\/strong>, m4v<\/strong>, avi<\/strong>, wmv<\/strong>, mp4<\/strong>, mpeg<\/strong>, mpg<\/strong>, mpe<\/strong>, dat<\/strong>, vob<\/strong>, asf<\/strong>, asx<\/strong>, mov<\/strong>, 3gp<\/strong>, 3g2<\/strong>, 3gpp<\/strong>, dv<\/strong>, qt<\/strong>, rm<\/strong>, rmvb<\/strong><\/strong>, webm<\/strong> sont autoris\u00e9s.",
    "video_upload_max": "Merci de ne pas importer des vidéos dont la taille est supérieure à 5 Go.",
    "video_upload_uppy_message": "Vous pouvez \u00e9galement d\u00e9poser ici que des fichiers de type vid\u00e9o",
    "video_upload_uppy_drop": "D\u00e9posez des fichiers ici ou",
    "video_upload_uppy_browse": "S\u00e9lectionner",
    "video_upload_uppy_uploading": "T\u00e9l\u00e9chargement",
    "video_upload_uppy_uploadComplete": "T\u00e9l\u00e9chargement termin\u00e9",
    "video_upload_uppy_uploadFailed": "T\u00e9l\u00e9chargement \u00e9chou\u00e9",
    "video_upload_uppy_pleasePressRetry": "Veuillez appuyer sur R\u00e9essayer pour t\u00e9l\u00e9charger \u00e0 nouveau",
    "video_upload_uppy_paused": "En pause",
    "video_upload_uppy_error": "Erreur",
    "video_upload_uppy_retry": "R\u00e9essayer",
    "video_upload_uppy_pressToRetry": "Appuyez pour r\u00e9essayer",
    "video_upload_uppy_retryUpload": "R\u00e9essayer le t\u00e9l\u00e9chargement",
    "video_upload_uppy_resumeUpload": "Reprendre le t\u00e9l\u00e9chargement",
    "video_upload_uppy_cancelUpload": "Annuler",
    "video_upload_uppy_pauseUpload": "Suspendre",
    "video_upload_uppy_uploadXFiles_zero": "T\u00e9l\u00e9charger {{smart_count}} fichier",
    "video_upload_uppy_uploadXFiles_one": "T\u00e9l\u00e9charger {{smart_count}} fichiers",
    "video_upload_uppy_uploadXNewFiles_zero": "T\u00e9l\u00e9charger {{smart_count}} fichier",
    "video_upload_uppy_uploadXNewFiles_one": "T\u00e9l\u00e9charger {{smart_count}} fichiers",
    "alert_not_valid_video_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une vid\u00e9o.<br>Veuillez s\u00e9lectionner une vid\u00e9o avec l'une des extensions suivants: *.flv *.m4v *.avi *.wmv *.mp4 *.mpeg *.mpg *.mpe *.dat *.vob *.asf *.asx *.mov *.3gp *.3g2 *.3gpp *.dv *.qt *. rm *.rmvb",
    "audio_upload_drop_message": "Vous pouvez \u00e9galement d\u00e9poser une vid\u00e9o ou un audio ici pour la t\u00e9l\u00e9charger.<br>Seulement mp3<\/strong>, wav<\/strong>, cda<\/strong>, mid<\/strong>, mod<\/strong>, wma<\/strong>, m4a<\/strong>, ogg<\/strong>, aac<\/strong>, flv<\/strong>, m4v<\/strong>, avi<\/strong>, wmv<\/strong>, mp4<\/strong>, mpeg<\/strong>, mpg<\/strong>, mpe<\/strong>, dat<\/strong>, vob<\/strong>, asf<\/strong>, asx<\/strong>, mov<\/strong>, 3gp<\/strong>, 3g2<\/strong>, 3gpp<\/strong>, dv<\/strong>, qt<\/strong>, rm<\/strong>, rmvb<\/strong> sont autoris\u00e9s.",
    "video_source_already_exist": "Vidéo déja existe!",
    "video_source_already_exist_video": "Cette vidéo est un double des vidéos suivantes:",
    "video_source_already_exist_video_request": "<br>Ajouter la vidéo de nouveau?",
    "alert_not_valid_audio_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une vid\u00e9o ou un audio.<br>Veuillez s\u00e9lectionner une vid\u00e9o ou un audio avec l'une des extensions suivants: *.mp3 *.wav *.cda *.mid *.mod *.wma *.m4a *.ogg *.aac *.flv *.m4v *.avi *.wmv *.mp4 *.mpeg *.mpg *.mpe *.dat *.vob *.asf *.asx *.mov *.3gp *.3g2 *.3gpp *.dv *.qt *. rm *.rmvb",
    "alert_not_valid_xml_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas un fichier *.xml.",
    "choose_a_file": "Choisir un fichier",
    "automatic_add_video": "Ajout automatique",
    "form_step_basic_info": "Informations",
    "form_step_further_info": "Informations suppl\u00e9mentaires",
    "form_step_security": "S\u00e9curiser la vid\u00e9o",
    "form_step_next": "Suivant",
    "form_step_previous": "Pr\u00e9c\u00e9dent",
    "form_step_validate": "Valider",
    "form_step_optional": "Optionnel",
    "video_detail": "M\u00e9ta-data de la vid\u00e9o",
    "meta_data_of_video": "M\u00e9tadonn\u00e9es de la vid\u00e9o : ",
    "meta_data_video_bitrate": "Bitrate de la vid\u00e9o",
    "meta_data_resolution": "R\u00e9solution",
    "meta_data_size": "Taille",
    "meta_data_duration": "Dur\u00e9e",
    "meta_data_framerate": "Taux de trame",
    "meta_data_video_codec": "Codec vid\u00e9o",
    "meta_data_samplerate": "Taux d'\u00e9chantillonnage",
    "meta_data_audio_Codec": "Codec audio",
    "meta_data_audio_bitrate": "Bitrate audio",
    "vid_has_no_meta_data": "Cette vid\u00e9o n'a aucune m\u00e9tadonn\u00e9e",
    "kb_per_s": "Ko\/s",
    "size_bytes": "Octets",
    "size_kb": "Ko",
    "size_mb": "Mo",
    "size_gb": "Go",
    "size_tb": "To",
    "form_attr_themes": "Th\u00e8me",
    "form_attr_categories": "Cat\u00e9gorie",
    "form_attr_themes_filter": "Filtre par th\u00e8me",
    "form_attr_contributor": "Contributeur",
    "form_attr_contributors": "Contributeurs",
    "contributor_none": "Tous",
    "canal_none": "Tous",
    "type_none": "Tous",
    "user_none": "Tous",
    "form_attr_generate_multiple_formats": "G\u00e9n\u00e9rer en formats multiples",
    "end_date": "Date de fin",
    "form_attr_use_theme": "Utiliser le(s) th\u00e8mes",
    "form_attr_send_push_notif": "Envoyer des notifications push",
    "form_attr_main_page": "Vid\u00e9o d'accueil",
    "form_attr_downloadable": "Vid\u00e9o t\u00e9l\u00e9chargeable",
    "form_attr_shared": "Vid\u00e9o partageable",
    "form_attr_vid_offline": "Mettre la vid\u00e9o hors ligne",
    "form_attr_vid_accessible": "Mettre la vid\u00e9o visible en internet",
    "form_attr_podcast_accessible": "Mettre le podcast visible en internet",  
    "form_attr_incrusted_logo": "Incruster le logo",
    "form_attr_locked_vid": "S\u00e9curiser la vid\u00e9o avec un mot de passe",
    "preview": "Aper\u00e7u",
    "seen_total": "Total <br> des visites",
    "action_more": "Plus d'actions",
    "hide_bottom_sheet": "Faites glisser vers le bas ou appuyez sur ESC ou cliquez \u00e0 l'ext\u00e9rieur pour fermer",
    "set_downloadable": "Vid\u00e9o t\u00e9l\u00e9chargeable",
    "set_undownloadable": "Vid\u00e9o non t\u00e9l\u00e9chargeable",
    "set_generateMultipleFormats": "G\u00e9n\u00e9rer multiple formats",
    "set_ungenerateMultipleFormats": "Ne pas G\u00e9n\u00e9rer de multiple formats",
    "set_logoIncrusted": "Incruster le logo",
    "set_unlogoIncrusted": "Ne pas incruster le logo",
    "set_offline": "Mettre la vid\u00e9o hors ligne",
    "set_online": "Mettre la vid\u00e9o en ligne",
    "set_secure": "Vid\u00e9o s\u00e9curis\u00e9e",
    "set_unsecure": "Vid\u00e9o non s\u00e9curis\u00e9e",
    "set_useTheme": "Utiliser le(s) th\u00e8mes",
    "set_unuseTheme": "Ne pas utiliser le(s) th\u00e8mes",
    "set_locked": "S\u00e9curiser la vid\u00e9o avec un mot de passe",
    "set_unlocked": "Ne pas s\u00e9curiser la vid\u00e9o avec un mot de passe",
    "set_mainPage": "Vid\u00e9o d'accueil",
    "set_unmainPage": "N'est pas une vid\u00e9o d'accueil",
    "set_sendPushNotifications": "Envoyer des notifications push",
    "set_unsendPushNotifications": "Ne pas envoyer des notifications push",
    "update_success": " a \u00e9t\u00e9 mis \u00e0 jour avec succ\u00e8s",
    "add_success": " a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
    "vid_is_transcoding": "Vid\u00e9o en cours de transcodage",
    "pod_is_transcoding": "Podcast en cours de transcodage",
    "vid_not_transcoded": "La vid\u00e9o n'a pas \u00e9t\u00e9 transcod\u00e9e ou doit \u00eatre transcod\u00e9e. Si tel est le cas, essayez de modifier le fichier vid\u00e9o",
    "select_server": "S\u00e9lectionnez un serveur de diffusion",
    "action_links": "Liste des liens",
    "form_step_vide_images": "Vignette de la vid\u00e9o",
    "generate_vignette": "G\u00e9n\u00e9ration de vignette",
    "choose_thumb_from_local": "Choisir une vignette",
    "choose_thumb_from_selected_theme": "Choisir la vignette \u00e0 partir du th\u00e8me s\u00e9lectionn\u00e9",
    "choose_thumb_from_generated": "Choisir la vignette \u00E0 partir des celles g\u00e9n\u00e9r\u00e9es",
    "theme_not_selected": "Vous n'avez choisi aucun th\u00e8me",
    "theme_does_not_have_a_thumb": "Aucune vignette pour les thèmes s\u00e9l\u00e9ctionn\u00e9es",
    "waiting_for_thumbs": "En attente des vignettes g\u00e9n\u00e9r\u00e9s automatiquement",
    "video_did_not_generate_thumbs": "Aucune vignette n'a \u00e9t\u00e9 g\u00e9n\u00e9r\u00e9 pour cette vid\u00e9o",
    "error_on_getting_generated_thumbs": "Une erreur s'est produite lors de la r\u00e9cup\u00e9ration des vignettes de la vid\u00e9o.",
    "regenerate_new_thumbs": "Reg\u00e9n\u00e9rer des nouvelles vignettes",
    "preview_video": "Visualiser",
    "video_preview": "Aperçu de la vid\u00e9o",
    "playlist_preview": "Aperçu de la playlist",
    "validate_changes": "Valider les modifications",
    "action_change_video_source": "Changer le fichier source de la vid\u00e9o",
    "loading_player": "Chargement du lecteur vid\u00e9o",
    "action_video_caption": "Sous-titrages",
    "caption_upload_drop_message": "Vous pouvez d\u00e9poser un fichier de sous-titrage ici pour le t\u00e9l\u00e9charger. Attention, seuls les fichiers *.srt *.vtt *.txt sont autoris\u00e9s.",
    "alert_not_valid_caption_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas un fichier de sous-titrage. Veuillez s\u00e9lectionner un fichier avec l'une des extensions suivantes : *.srt *, .vtt *, .txt",
    "alert_not_valid_csvfile_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas un fichier Excel. Veuillez s\u00e9lectionner un fichier avec l'extension : *.csv",
    "see_file_model": "Les Formats des diff\u00e9rents types de sous-titrage: ",
    "invalid_time_format": "Le format du champs doit avoir la forme suivante : XX:XX:XX<\/strong> ou X repr\u00e9sente un nombre",
    "download_file": "T\u00e9l\u00e9charger le fichier",
    "preview_file": "Aperçu du fichier",
    "is_superior_to_end_duration": "L'heure de d\u00e9but ne peut pas \u00eatre sup\u00e9rieur \u00e0 celle de fin",
    "is_superior_to_video_duration": "L'heure de fin ne peut pas \u00eatre sup\u00e9rieure \u00e0 la dur\u00e9e de la vid\u00e9o",
    "is_inferior_to_start_duration": "L'heure de fin ne peut pas \u00eatre inf\u00e9rieure \u00e0 celle de d\u00e9but",
    "start_recording_subtitle_duration": "D\u00e9but d'un sous-titre",
    "stop_recording_subtitle_duration": "Fin du sous-titre",
    "you_must_choose_a_thumb": "Vous devez choisir une vignette",
    "add_caption": "Ajouter un sous-titre",
    "action_video_rich_media": "Rich-m\u00e9dia",
    "add_slide": "Ajouter un slide",
    "add_slides": "Ajouter des slides",
    "add_slides_image": "Ajouter des images",
    "add_slides_video": "Ajouter des vid\u00e9os",
    "upload_slides_image": "Glisser et déposer des images ici<br>Seulement jpg, jpeg, png, gif sont autoris\u00e9s.",
    "upload_slides_video": "Glisser et déposer des vid\u00e9os ici <br>Seulement mp4 sont autoris\u00e9s.",
    "add_chapter": "Ajouter un chapitre",
    "modify_slide": "Modifier un slide",
    "modify_chapter": "Modifier un chapitre",
    "modify_survey": "Modifier une question",
    "push_video_on": "Mettre en avant",
    "push_video_off": "Mettre en arri\u00e8re",
    "export_youtube": "Export Youtube",
    "export_facebook": "Export Facebook",
    "export_twiter": "Export Twitter",
    "export_linkdin": "Export Linkedin",
    "delete_video": "Supprimer",
    "description_audio": "Description audio de la vid\u00e9o",
    "export_video": "Lien et URL de la vid\u00e9o",
    "montage_video": "Montage",
    "chronologie_video": "Chronologie",
    "progressive_download": "T\u00e9l\u00e9chargement progressif",
    "permalien": "Permalien",
    "title_modal_url": "Exporter la vid\u00e9o : ",
    "rich_media_presentation": "Rich-m\u00e9dia",
    "internet": "Diffusion internet",
    "send": "Envoyer",
    "reset": "restaurer",
    "click_to_edit": "Cliquer pour modifier",
    "expand": "\u00c9largir",
    "collapse": "Replier",
    "action_video_stats": "Statistiques",
    "export_canal": "Lien et URL du canal",
    "export_theme": "Lien et URL du th\u00e8me",
    "title_channel_url": "Exporter le canal ",
    "stockage_detail": "Stockage par serveur ",
    "export_links_embed": "Lien d'int\u00e9gration",
    "export_links_permalien": "Permalien",
    "form": "Formulaire",
    "form_complementary_info": "Informations compl\u00e9mentaires",
    "form_organisator_info": "Informations de l'organisateur",
    "action_export_event": "Liens d'export de l'\u00e9v\u00e9nement",
    "inprogress_montage": "En cours de montage",
    "alert_check_values": "Le temps de début doit \u00eatre inf\u00e9rieur au celui de fin",
    "video_not_exist": "La vid\u00e9o source est non disponible",
    "form_attr_group": "Groupe",
    "video_by_mail": "Envoyer par mail ",
    "delete_language": "Supprimer la langue",
    "apercu_media": "Aperçu media",
    "edit_language": "Modifier la langue",
    "edit_video_file": "Modifier le fichier vid\u00e9o",
    "embed_code": "Embed code",
    "add_language": "Ajouter une langue",
    "added_language": "Langue ajout\u00e9e avec succ\u00e8s",
    "language_exist": "Langue existe d\u00e9ja",
    "action_video_language": "Ajouter langue",
    "action_video_restart": "Lancer direct de nouveau",
    "action_play": "Encodage Pearl",
    "btn_play": "d\u00e9marrer",
    "btn_pause": "arrêter",
    "btn_preview": "Aperçu",
    "intranet_broadcast": "Diffusion intranet",
    "internet_broadcast": "Diffusion Internet",
    "link_copied": "Copi\u00e9!",
    "subscribers_group": "Groupe des abonn\u00e9s",
    "no_subscriptionUser_was_found": "Aucun abonn\u00e9 trouv\u00e9!",
    "or": "Orateur",
    "help": "Aide",
    "details": "D\u00e9tails",
    "nb_visits": "Nombre de visites",
    "more_details": "Plus de d\u00e9tails",
    "next": "Suivant",
    "previous": "Pr\u00e9c\u00e9dent",
    "no_videos": "Aucune vid\u00e9o pour votre choix",
    "no_lives": "Aucune direct pour votre choix",
    "display_modes": "Mode d'affichage",
    "success_change": "Mode d'affichage chang\u00e9 avec succ\u00e9s",
    "display_options": "Options d'affichage",
    "take_vignette": "Faire une capture de la vignette",
    "take_vignette_from_video": "Capturer à partir de la vidéo",
    "add_answer": "Ajouter une r\u00e9ponse",
    "answer": "R\u00e9ponse",
    "multiple_choice": "Choix multiple",
    "simple_choice": "Choix simple",
    "add_survey": "Ajouter une question",
    "add_quiz": "Ajouter un quiz",
    "add_interactivity": "Ajouter un index",
    "question": "Question:",
    "chapter": "Chapitre:",
    "quiz": "Quiz:",
    "question_tooltip": "Question",
    "chapter_tooltip": "Chapitre",
    "quiz_tooltip": "Quiz",
    "slide_tooltip": "Diapositive",
    "slide": "Diapositive:",
    "index": "Index",
    "add": "Ajouter",
    "reduce": "R\u00e9duire",
    "show": "Afficher",
    "elements": "éléments",
    "of": "sur",
    "first": "Premier",
    "last": "Dernier",
    "keywords": "Mots cl\u00e9s,Id/UID",
    "url_not_valid": "Lien non valide !",
    "alert_url_video_error": "L'URL ins\u00e9r\u00e9e ne correspond pas \u00E0 une vid\u00e9o",
    "make_vignette": "D\u00e9finir comme miniature ",
    "select_language_caption": "S\u00e9lectionnez la langue du sous-titrage",
    "msg_show_date": "Cliquez pour afficher la date de fin",
    "msg_hide_date": "Cliquez pour cacher la date de fin",
    "join_files": "Joindre des fichiers",
    "select_color": "Couleur de fond",
    "acces_rapide": "Accès rapide",
    "ou": "ou",
    "add_thumb": "Générer une vignette",
    "export_podcast": "Lien du fichier RSS",
    "whitelist": "Liste blanche",
    "blacklist": "Liste noire",
    "error_read_video": "L' aperçu sera disponible une fois que le transcodage sera terminé",
    "expired_token": "URL expirée!",
    "success_reload": "la mise à jour de l'affichage sur le boitier a été effectuée avec succès",
    "button_reload_display": "Actualiser l'affichage sur le boitier",
    "invalid_mail_delete": "Mail supprimé :Format invalide",
    "download_csv": "Télécharger CSV",
    "entity": "Entité",
    "function": "Société",
    "action_edition": "Edition vidéo",
    "reload_transcription": "Transcription avec relecture",
    "auto_transcription": "Transcription automatique",
    "transcription": "Transcription",
    "intervention": "Interventions",
    "not_valid_youtube": "Insérez une URL embed valide : https://www.youtube.com/embed/43ngkc2Ejgw",
    "not_valid_dailymotion": "Insérez une URL embed valide : https://www.dailymotion.com/embed/video/x5ce0e6",
    "error_title": "Acc\u00e8s non autoris\u00e9",
    "error_message": "Veuillez contacter l'administrateur",
    "erreur401_title": "Access non autorisé",
    "erreur401_message": "Veuillez contactr l'administrateur",
    "selection_vignettes": "S\u00e9lection de vignettes",
    "selection_channels": "Cha\u00eenes",
    "default": "D\u00e9finir par d\u00e9faut",
    "default_channel": "Cha\u00eene par d\u00e9faut",
    "list_channels": "Liste des cha\u00eenes",
    "new":"Nouveau",
    "add_video":"Ajouter une vidéo",
    "add_videos":"Ajouter des vidéos",
    "add_live":"Faire un live",
    "create_video":"Créer une vidéo",
    "create_live":"Créer une playlist live",
    "empty_dashboard":"Pas de vidéos récentes à afficher pour le moment !",
    "tv_show": "Voir la TV",
    "change_file_source":"Voulez-vous remplacer la vidéo existante ?",
    "action_export_youtube":"Export youtube",
    "list_groups": "Groupe Vidéo",
    "stats": "Statistiques",
    "rubric": "Rubrique",
    "thematic": "Th\u00e9matique"
  },
  "PAGESMENUSTITLES": {
    "webskin": "web skin",
    "themes": "themes",
    "liveskin": "live skin",
    "playerskin": "player skin",
    "website_menuTitle":"Options",
    "metric_menuTitle": "metrique",
    "video_menuTitle": "video",
    "parameters": "Paramètres",
    "parametersFM": "parameters",
    "form_diffusion_title_menu_title": "Diffusion",
    "dashboard_menuTitle": "Dashboard",
    "media_menuTitle": "M\u00e9dia",
    "media_menuTitleFM": "Media",
    "media_comments_menuTitle": "Commentaire",
    "support_menuTitle": "Support",
    "documentation_menuTitle": "Guide utilisateur",
    "key_menuTitle": "Cl\u00e9 de l'api",
    "comments_list_pagetitle": "Liste des commentaires",
    "media_comments_list_menuTitle": "Liste",
    "comments_add_pagetitle": "Ajouter un nouveau commentaire",
    "media_comments_add_menuTitle": "Ajout commentaire",
    "media_comments_edit_pagetitle": "Modification commentaire",
    "media_comments_detail_pagetitle": "D\u00e9tail du commentaire",
    "parameters_theme_list_pagetitle": "Liste des th\u00e8mes",
    "parameters_rubric_list_pagetitle": "Liste des rubriques",
    "parameters_theme_list_menuTitle": "Liste",
    "parameters_theme_add_menuTitle": "Ajout th\u00e8me",
    "parameters_rubric_add_menuTitle": "Ajout rubrique",
    "media_video_questions_quiz": "Questions/Quiz",
    "parameters_menuTitle": "Param\u00e8tre",
    "parameters_theme_menuTitle": "Th\u00e8me",
    "parameters_rubric_menuTitle": "Rubriques",
    "parameters_theme_menuTitleFM": "Theme",
    "parameters_theme_edit_pagetitle": "Modification du th\u00e8me",
    "parameters_rubric_edit_pagetitle": "Modification du rubrique",
    "parameters_theme_detail_pagetitle": "D\u00e9tail du th\u00e8me",
    "parameters_rubric_detail_pagetitle": "D\u00e9tail du rubrique",
    "parameters_canal_list_pagetitle": "Liste des canaux",
    "parameters_canal_list_menuTitle": "Liste",
    "parameters_canal_add_menuTitle": "Ajout canal",
    "parameters_canal_menuTitle": "Canal",
    "parameters_thematic_menuTitle": "Th\u00e9matiques",
    "parameters_canal_edit_pagetitle": "Modification du canal",
    "parameters_canal_detail_pagetitle": "D\u00e9tail du canal",
    "specifics_station_list_pagetitle": "Liste des stations",
    "specifics_station_list_menuTitle": "Liste",
    "specifics_station_add_menuTitle": "Ajouter une station",
    "specifics_direction_list_pagetitle": "Liste des directions",
    "specifics_direction_list_menuTitle": "Liste",
    "specifics_direction_add_menuTitle": "Ajouter une nouvelle direction",
    "specifics_menuTitle": "Encodeur",
    "specifics_station_menuTitle": "Station",
    "specifics_station_edit_pagetitle": "Modification de la station",
    "specifics_station_detail_pagetitle": "D\u00e9tail de la station",
    "specifics_direction_menuTitle": "Direction",
    "specifics_direction_edit_pagetitle": "Modification de la direction",
    "specifics_direction_detail_pagetitle": "D\u00e9tail de la direction",
    "specifics_iptv_list_pagetitle": "Liste des IP-TV",
    "specifics_iptv_list_menuTitle": "Liste",
    "specifics_iptv_add_menuTitle": "Nouvel IP-TV",
    "specifics_iptv_menuTitle": "IP-TVs",
    "specifics_iptv_edit_pagetitle": "Modification du IP-TV",
    "specifics_iptv_detail_pagetitle": "D\u00e9tail du IP-TV",
    "configuration_rmboxgroup_list_pagetitle": "Liste des groupes RmBox",
    "configuration_rmboxgroup_list_menuTitle": "Liste",
    "configuration_rmboxgroup_add_menuTitle": "Ajout groupe RmBox",
    "configuration_menuTitle": "Configuration",
    "configuration_rmboxgroup_menuTitle": "Groupe RmBox",
    "configuration_rmboxgroup_edit_pagetitle": "Modification du groupe RmBox ",
    "configuration_rmboxgroup_detail_pagetitle": "D\u00e9tail du groupe RmBox",
    "configuration_server_list_pagetitle": "Liste des serveurs",
    "configuration_server_list_menuTitle": "Liste",
    "configuration_server_add_menuTitle": "Ajout serveur",
    "configuration_server_menuTitle": "Serveur",
    "configuration_server_edit_pagetitle": "Modification du serveur",
    "configuration_server_detail_pagetitle": "D\u00e9tail du serveur",
    "configuration_rmbox_list_pagetitle": "Liste des RmBoxs",
    "configuration_rmbox_list_menuTitle": "Liste",
    "configuration_rmbox_add_menuTitle": "Ajout RmBox",
    "configuration_intervention_add_menuTitle": "Ajout intervention",
    "configuration_intervention_edit_menuTitle": "Modification d'intervention",
    "configuration_rmbox_menuTitle": "RmBox",
    "rmbox_autorise_ip_menuTitle": "IP autorisée",
    "rmbox_autorise_ip_add_menuTitle": "Nouvelle adresse IP autorisée",
    "rmbox_autorise_ip_edit_menuTitle": "Modification de l'adresse IP autorisée",
    "rmbox_autorise_ip_list_pagetitle": "Liste des ips autorisées",
    "configuration_rmbox_edit_pagetitle": "Modification du RmBox",
    "configuration_rmbox_detail_pagetitle": "D\u00e9tail du RmBox",
    "configuration_zone_list_pagetitle": "Liste des zones",
    "configuration_zone_list_menuTitle": "Liste",
    "configuration_zone_add_menuTitle": "Nouvelle zone",
    "configuration_zone_menuTitle": "Zone",
    "configuration_zone_edit_pagetitle": "Modification de la zone",
    "configuration_zone_detail_pagetitle": "D\u00e9tail de la zone",
    "configuration_presets_list_pagetitle": "Liste des presets",
    "configuration_presets_list_menuTitle": "Liste",
    "configuration_presets_add_menuTitle": "Ajout preset",
    "configuration_presets_menuTitle": "Preset",
    "configuration_presets_edit_pagetitle": "Modification du preset",
    "configuration_presets_detail_pagetitle": "D\u00e9tail du preset",
    "configuration_general_list_pagetitle": "Liste des g\u00e9n\u00e9rals",
    "configuration_general_list_menuTitle": "Liste",
    "configuration_general_add_menuTitle": "Ajout g\u00e9n\u00e9ral",
    "configuration_general_menuTitle": "G\u00e9n\u00e9rals",
    "configuration_general_edit_pagetitle": "Modification du g\u00e9n\u00e9ral",
    "configuration_general_detail_pagetitle": "D\u00e9tail du g\u00e9n\u00e9ral",
    "abonnement_group_list_pagetitle": "Liste des groupes",
    "abonnement_group_list_menuTitle": "Liste des groupes",
    "abonnement_group_add_menuTitle": "Ajout d'un groupe",
    "abonnement_menuTitle": "Abonnement",
    "abonnement_group_menuTitle": "Groupe",
    "abonnement_group_edit_pagetitle": "Modification du groupe",
    "abonnement_group_detail_pagetitle": "D\u00e9tail du groupe",
    "abonnement_thematic_detail_pagetitle": "D\u00e9tail du th\u00e9matique",
    "abonnement_user_list_pagetitle": "Liste des utilisateurs",
    "abonnement_user_list_menuTitle": "Liste des utilisateurs",
    "abonnement_user_add_menuTitle": "Ajout d'utilisateur",
    "abonnement_user_menuTitle": "Utilisateur",
    "abonnement_user_edit_pagetitle": "Modification de l'utilisateur",
    "abonnement_user_detail_pagetitle": "D\u00e9tail de l'utilisateur",
    "abonnement_user_detail_modal_pagetitle": "D\u00e9tail de l'utilisateur",
    "sondage_list_pagetitle": "Liste des sondages",
    "sondage_list_menuTitle": "Liste",
    "sondage_add_menuTitle": "Ajout sondage",
    "sondage_menuTitle": "Sondage",
    "sondage_edit_pagetitle": "Modification du sondage",
    "sondage_detail_pagetitle": "D\u00e9tail du sondage",
    "vote_list_pagetitle": "Liste d\u00e9taill\u00e9e de sondage",
    "playlist_list_pagetitle": "Playlists",
    "playlist_list_menuTitle": "Liste",
    "playlist_add_menuTitle": "Ajout playlist",
    "playlist_menuTitle": "Playlist",
    "playlist_list_simple": "Liste des playlists",
    "playlist_list_live": "Liste des playlists direct",
    "playlist_edit_pagetitle": "Modification de la playlist",
    "playlist_detail_pagetitle": "D\u00e9tail de la playlist",
    "playlist_live_list_pagetitle": "Playlist direct",
    "playlist_live_list_menuTitle": "Liste",
    "playlist_live_add_menuTitle": "Nouvelle playlist direct",
    "playlist_live_menuTitle": "Playlist direct",
    "playlist_live_edit_pagetitle": "Modification de la playlist direct",
    "playlist_live_detail_pagetitle": "D\u00e9tail de la playlist direct",
    "playlist_live_calendar_pagetitle": "Calendrier des playlists direct",
    "playlist_live_calendar_menuTitle": "Calendrier",
    "chutier_list_pagetitle": "Vid\u00e9o bin",
    "chutier_list_menuTitle": "Liste",
    "chutier_add_menuTitle": "Ajout chutier vid\u00e9o",
    "chutier_menuTitle": "Chutier",
    "metaData_menuTitle": "metadonnée",
    "skin":"Skin",
    "chutier_edit_pagetitle": "Modification du chutier vid\u00e9o",
    "chutier_detail_pagetitle": "D\u00e9tail du chutier vid\u00e9o",
    "advertising_list_pagetitle": "Liste des publicit\u00e9s",
    "advertising_list_menuTitle": "Liste",
    "advertising_add_menuTitle": "Nouvelle publicit\u00e9",
    "advertising_menuTitle": "Publicit\u00e9",
    "advertising_edit_pagetitle": "Modification de la publicit\u00e9",
    "advertising_detail_pagetitle": "D\u00e9tail de la publicit\u00e9",
    "profiles_user_list_pagetitle": "Liste des utilisateurs",
    "profiles_user_list_menuTitle": "Liste",
    "profiles_user_add_menuTitle": "Ajout utilisateur",
    "profiles_menuTitle": "Profil",
    "profiles_user_menuTitle": "Utilisateur",
    "profiles_user_edit_pagetitle": "Modification de l'utilisateur",
    "profiles_user_edit_pwd_pagetitle": "Modification du mot de passe de l'utilisateur",
    "profiles_user_detail_pagetitle": "D\u00e9tail de l'utilisateur",
    "profiles_group_list_pagetitle": "Liste des groupes",
    "profiles_group_list_menuTitle": "Liste",
    "profiles_group_add_menuTitle": "Ajout groupe",
    "profiles_group_menuTitle": "Groupe",
    "profiles_group_edit_pagetitle": "Modification du groupe",
    "profiles_group_detail_pagetitle": "D\u00e9tail du groupe",
    "profiles_ip_menuTitle": "IP",
    "profiles_ip_list_pagetitle": "Liste des ips",
    "profiles_ip_list_menuTitle": "Liste",
    "profiles_ip_detail_pagetitle": "D\u00e9tail du l'adresse IP",
    "profiles_ip_add_menuTitle": "Nouvelle adresse IP",
    "profiles_ip_edit_pagetitle": "Modification de l'adresse IP",
    "media_video_menuTitle": "Vid\u00e9o",
    "media_video_upload_menuTitle": "Ajout vid\u00e9o",
    "media_video_list_menuTitle": "Liste",
    "media_audio_upload_menuTitle": "Ajout fichier audio",
    "media_video_list_ongoing_menuTitle": "En cours de diffusion",
    "media_video_list_upcoming_menuTitle": "\u00C0 venir",
    "media_video_list_offline_menuTitle": "Hors ligne",
    "media_video_list_all_videos_menuTitle": "Tout",
    "media_video_list_all_menuTitle": "Afficher toutes les vid\u00e9os",
    "media_video_list_archived_menuTitle": "Archiv\u00e9e",
    "media_video_list_archived-exceed_menuTitle": "Corbeille",
    "media_video_list_archived-exceed_pagetitle": "Liste des vid\u00e9os de la corbeille",
    "media_video_edit_pagetitle": "Modification des informations de la vid\u00e9o",
    "media_video_reupload_pagetitle": "Changement du fichier source de la vid\u00e9o",
    "media_video_caption_pagetitle": "Sous-titrage de la vid\u00e9o",
    "media_video_rich_media_pagetitle": "Rich-m\u00e9dia pour la vid\u00e9o",
    "media_video_list_ongoing_pagetitle": "Liste des vid\u00e9os en cours de diffusion",
    "media_video_list_upload_pagetitle": "Ajout vid\u00e9o",
    "media_video_list_edit_pagetitle": "Modification des informations de la vid\u00e9o",
    "media_video_list_caption_pagetitle": "Sous-titrage de la vid\u00e9o",
    "media_video_list_rich_media_pagetitle": "Rich-média pour la vid\u00e9o",
    "media_video_list_montage_pagetitle": "Montage",
    "media_video_list_all_pagetitle": "Liste de toutes les vid\u00e9os",
    "event_list_pagetitle": "\u00C9v\u00e9nements",
    "event_list_menuTitle": "Liste",
    "event_add_menuTitle": "Ajout \u00e9v\u00e9nement",
    "event_menuTitle": "\u00C9v\u00e9nement",
    "event_edit_pagetitle": "Modification de l'\u00e9v\u00e9nement",
    "event_detail_pagetitle": "D\u00e9tail de l'\u00e9v\u00e9nement",
    "event_detail_modal_pagetitle": "D\u00e9tail de l'\u00e9v\u00e9nement",
    "event_calendar_pagetitle": "Calendrier des \u00e9v\u00e9nements",
    "event_calendar_menuTitle": "Calendrier",
    "event_list_archived_menuTitle": "Archiv\u00e9es",
    "event_list_ongoing_menuTitle": "En cours de diffusion",
    "event_list_upcoming_menuTitle": "A venir",
    "event_add_pagetitle": "Ajout un nouveau \u00e9v\u00e9nement",
    "event_list_all_pagetitle": "Liste de tous les \u00e9v\u00e9nements",
    "event_list_archived_pagetitle": "Liste des \u00e9v\u00e9nements termin\u00e9s",
    "event_list_ongoing_pagetitle": "Liste des \u00e9v\u00e9nements en cours de diffusion",
    "event_list_upcoming_pagetitle": "Liste des \u00e9v\u00e9nements \u00E0 venir prochainement",
    "event_list_trash_pagetitle": "Liste des \u00e9v\u00e9nements de la corbeille",
    "param_list_pagetitle": "Liste des param\u00e9tres",
    "param_list_menuTitle": "Liste",
    "param_add_pagetitle": "Ajouter un nouveau param\u00e9tre",
    "param_add_menuTitle": "Ajout param\u00e9tre",
    "menuTitle": "Configuration",
    "param_menuTitle": "Client",
    "param_edit_pagetitle": "Modification des param\u00e9tres",
    "param_detail_pagetitle": "D\u00e9tail des param\u00e9tres",
    "player_parameterslist_pagetitle": "Liste internet",
    "player_parameters_list_menuTitle": "Liste internet",
    "config_mooc_list_menuTitle": "Liste des configurations Mooc",
    "player_parameters": "Lecteur vid\u00e9o",
    "player_parametersFM": "Lecteur video",
    "configuration_mooc": "Mooc",
    "lives_list_pagetitle": "Direct",
    "lives_list_menuTitle": "Liste",
    "lives_add_pagetitle": "Ajouter un nouveau direct",
    "lives_add_menuTitle": "Ajout direct",
    "lives_menuTitle": "Direct",
    "lives_edit_pagetitle": "Modification du direct",
    "lives_detail_pagetitle": "D\u00e9tail du direct",
    "lives_detail_modal_pagetitle": "D\u00e9tail du direct",
    "lives_calendar_pagetitle": "Calendrier des directs",
    "lives_calendar_menuTitle": "Calendrier",
    "lives_list_ongoing_menuTitle": "En attente",
    "lives_list_archived_menuTitle": "Termin\u00e9",
    "lives_list_upcoming_menuTitle": "A venir",
    "lives_list": "Liste des directs",
    "events_list": "Liste des \u00e9v\u00e9nements en direct",
    "live_conf_add_menuTitle": "Configuration du direct",
    "live_conf_add_pagetitle": "Ajouter configuration",
    "send_invitation_detail_pagetitle": "Envoyer des invitations",
    "export_links_pagetitle": "Liens d'export du webinar",
    "info_detail_pagetitle": "Information du webinar",
    "lives_comments_menuTitle": "Liste des commentaires",
    "lives_comments_list_menuTitle": "List",
    "live_comment_list_pagetitle": "Liste des commentaires",
    "lives_list_archived_pagetitle": "Liste des directs archiv\u00e9s",
    "lives_comments_list_live_pagetitle": "Liste des commentaires",
    "lives_list_ongoing_pagetitle": "Liste des directs en cours",
    "lives_list_endless_pagetitle": "Liste des directs en cours",
    "lives_list_all_pagetitle": "Liste tous les directs",
    "lives_list_trash_pagetitle": "Liste des directs en corbeille",
    "lives_list_encodeur_pearl": "Encodeur Pearl",
    "lives_list_upcoming_pagetitle": "Liste des directs \u00e0 venir prochainement",
    "home_menuTitle": "Page d'accueil",
    "home_conf_add_menuTitle": "Configuration",
    "media_home_menuTitle": "Page d'accueil",
    "media_home_conf_menuTitle": "Configuration",
    "media_home_list_pagetitle": "Liste des vid\u00e9os de la page d'accueil",
    "media_home_list_menuTitle": "Vid\u00e9os d'accueil",
    "media_home_push_menuTitle": "Vid\u00e9o push",
    "media_video_list_offline_pagetitle": "Liste des vid\u00e9os hors ligne",
    "media_video_list_upcoming_pagetitle": "Liste des vid\u00e9os \u00e0 venir prochainement",
    "media_video_list_archived_pagetitle": "Liste des vid\u00e9os archiv\u00e9es",
    "core_menuTitle": "Option",
    "core_new_menuTitle": "Module",
    "core_right_menuTitle": "Permission",
    "core_rights_action_menuTitle": "Liste des actions de permission",
    "core_rights_module_menuTitle": "Liste des modules de permission",
    "core_rights_group_pagetitle": "Gestion des droits du groupe",
    "player_parameters_list_intra_menuTitle": "Liste intranet",
    "stats_pagetitle": "Statistique",
    "stats_live_by_id_pagetitle":"Statistique du live",
    "stats_event_by_id_pagetitle":"Statistique d'événement",
    "stats_vod_by_id_pagetitle":"Statistique du video",
    "stats_vod_pagetitle": "VODs",
    "stats_podcast_pagetitle": "Podcast",
    "vote_details_pagetitle": "Liste d\u00e9taill\u00e9e des votes",
    "vote_detail_pagetitle": "Liste des votes",
    "stats": "Statistique",
    "stats_dashboard": "Dashboard",
    "stats_videos": "Statistique des vid\u00e9os",
    "stats_access": "Journal D'audit",
    "stats_access_detail": "Traçabilit\u00e9",
    "stats_live_pagetitle": "Statistiques des directs",
    "stats_access_pageTitle": "Liste des sessions",
    "stats_access_detail_pageTitle": "Liste d'acc\u00e8s",
    "stats_consumption_pagetitle": "Consommation",
    "stats_storage_pagetitle": "Stockage",
    "stats_event_pagetitle": "Statistiques des événements",
    "export_Live_links_pagetitle": "Liens d'export du direct : ",
    "interactivity_menuTitle": "Interactivit\u00e9",
    "boitier_menuTitle": "Boitier",
    "stats_mooc": "Mooc",
    "stats_mooc_pagetitle": "Statistique Pass Digital",
    "stats_users": "Statistiques d'utilisateurs",
    "classifying_menuTitle": "Classement",
    "classifying_thematic_menuTitle": "Th\u00e9matiques",
    "classifying_thematic_add_menuTitle": "Ajout d'un Th\u00e9matique",
    "classifying_thematic_edit_menuTitle": "Modification d'un Th\u00e9matique",
    "classifying_thematic_list_pageTitle": "Liste des Th\u00e9matiques",
    "live_title_comment_list_pagetitle": "Liste des commentaires du direct: ",
    "media_title_comment_list_pagetitle": "Liste des commentaires du vid\u00e9o: ",
    "export_links_modal_title": "Liens Embed",
    "display_menuTitle": "Display",
    "display_new_menuTitle": "New Display",
    "display_programs_menuTitle": "Programme",
    "display_programs_list_pagetitle": "Liste des programmes",
    "display_programs_list_menuTitle": "Liste",
    "display_programs_add_pagetitle": "Ajouter un nouveau programme",
    "display_programs_add_menuTitle": "Ajout programme",
    "display_programs_edit_pagetitle": "Modification du programme",
    "display_programs_edit_menuTitle": "Modification du programme",
    "display_schedule_menuTitle": "Grille des programmes",
    "display_schedule_list_menuTitle": "Calendrier",
    "display_schedule_calendar_pagetitle": "Liste des grilles des programmes",
    "display_schedule_calendar_menuTitle": "Calendrier",
    "display_schedule_add_pagetitle": "Ajouter une nouvelle grille",
    "display_schedule_add_menuTitle": "Nouvelle grille",
    "display_schedule_edit_menuTitle": "Modifier grille",
    "template_manager_menuTitle": "Template",
    "template_manager_editor_menuTitle": "Editeur",
    "template_manager_editor_list_pagetitle": "Liste des \u00e9crans",
    "template_manager_editor_list_menuTitle": "Liste",
    "template_manager_editor_generator_creator_pagetitle": "Cr\u00e9ation d'un nouveau template",
    "template_manager_editor_generator_creator_menuTitle": "Cr\u00e9ation d'un nouveau template",
    "template_manager_editor_generator_edit_pagetitle": "Edition d'une template",
    "template_manager_editor_generator_edit_menuTitle": "Edition d'une template",
    "template_manager_editor_edit_pagetitle": "Modification du l'\u00e9cran",
    "template_manager_editor_edit_menuTitle": "Modification du l'\u00e9cran",
    "template_manager_template_menuTitle": "Template",
    "template_manager_template_add_menuTitle": "Ajouter template",
    "template_manager_template_edit_menuTitle": "Modifier template",
    "template_manager_list_menuTitle": "Liste des templates",
    "template_manager_list_pagetitle": "Liste des templates",
    "template_manager_screen_menuTitle": "&Eacute;cran",
    "template_manager_screen_list_menuTitle": "Liste des &Eacute;crans",
    "page_export_dailymotion_title": "Export vers Dailymotion",
    "media_video_montage_pagetitle": "Montage",
    "parameters_podcast_add_menuTitle": "Ajout podcast",
    "parameters_podcast_edit_menuTitle": "Modification des informations du podcast",
    "podcast_menuTitle": "Podcast",
    "images_menuTitle": "Photothèque",
    "parameters_podcast_detail_pagetitle": "D\u00e9tail du podcast",
    "parameters_podcast_menuTitle": "Podcast",
    "parameters_podcast_list_pagetitle": "Liste des podcasts",
    "configuration_referrers_add_menuTitle": "Ajout référent",
    "configuration_referrers_edit_menuTitle": "Modification des informations du référent",
    "configuration_referrers_menuTitle": "Référent",
    "configuration_referrers_detail_pagetitle": "D\u00e9tail du référent",
    "configuration_referrers_list_pagetitle": "Liste des référents",
    "configuration_news_menuTitle": "Actualités",
    "configuration_news_add_menuTitle": "Ajout actualité",
    "configuration_news_edit_pagetitle": "Modification des informations d'actualité",
    "configuration_news_list_pagetitle": "Liste d'actualités",
    "stats_list_videos_pagetitle": "Export statistiques des vidéos",
    "stats_list_podcasts_pagetitle": "Export statistiques des podcasts",
    "configuration_rmbox_interventions_pagetitle": "Liste des interventions",
    "skin_menuTitle": "Skin",
    "skin_player_menuTitle": "Player",
    "scorm_menuTitle":"Scorm",
    "display_template_segment_menuTitle": "Segment",
    "display_segments_list_menuTitle": "Liste des segments",
    "subscriptions": "Mes abonnements",
    "bills": "Mes factures",
    "display_segments_edit_menuTitle": "Modification",
    "display_segments_add_menuTitle": "Ajout",
    "stats_podcasts": "Statistiques des podcasts",
    "stats_p2p":"Statistiques P2P"
  },
  "NAVIGATION":{
    "safran_preprod":"SAFRAN",
    "test":"TEST"
  }
}


);

$translateProvider.translations("en", {
  "MAIL": {
    "send_copy": "Receive a copy",
    "sent": "Your message has been sent"
  }
}
);

$translateProvider.translations("fr", {
  "MAIL": {
    "send_copy": "Recevoir une copie",
    "sent":"Votre message a été bien envoyé"
  }
}
);

$translateProvider.translations("en", {
  "LANGUAGES": {
    "Version": "2.1.24.18",
    "Names": {
      "Null": "None",
      "null": "None",
      "aa": "Afar",
      "ab": "Abkhazian",
      "ace": "Achinese",
      "ach": "Acoli",
      "ada": "Adangme",
      "ady": "Adyghe",
      "ae": "Avestan",
      "aeb": "Tunisian Arabic",
      "af": "Afrikaans",
      "afh": "Afrihili",
      "agq": "Aghem",
      "ain": "Ainu",
      "ak": "Akan",
      "akk": "Akkadian",
      "akz": "Alabama",
      "ale": "Aleut",
      "aln": "Gheg Albanian",
      "alt": "Southern Altai",
      "am": "Amharic",
      "an": "Aragonese",
      "ang": "Old English",
      "anp": "Angika",
      "ar": "Arabic",
      "ar_001": "Modern Standard Arabic",
      "arc": "Aramaic",
      "arn": "Mapuche",
      "aro": "Araona",
      "arp": "Arapaho",
      "arq": "Algerian Arabic",
      "arw": "Arawak",
      "ary": "Moroccan Arabic",
      "arz": "Egyptian Arabic",
      "as": "Assamese",
      "asa": "Asu",
      "ase": "American Sign Language",
      "ast": "Asturian",
      "av": "Avaric",
      "avk": "Kotava",
      "awa": "Awadhi",
      "ay": "Aymara",
      "az": "Azerbaijani",
      "ba": "Bashkir",
      "bal": "Baluchi",
      "ban": "Balinese",
      "bar": "Bavarian",
      "bas": "Basaa",
      "bax": "Bamun",
      "bbc": "Batak Toba",
      "bbj": "Ghomala",
      "be": "Belarusian",
      "bej": "Beja",
      "bem": "Bemba",
      "bew": "Betawi",
      "bez": "Bena",
      "bfd": "Bafut",
      "bfq": "Badaga",
      "bg": "Bulgarian",
      "bgn": "Western Balochi",
      "bho": "Bhojpuri",
      "bi": "Bislama",
      "bik": "Bikol",
      "bin": "Bini",
      "bjn": "Banjar",
      "bkm": "Kom",
      "bla": "Siksika",
      "bm": "Bambara",
      "bn": "Bengali",
      "bo": "Tibetan",
      "bpy": "Bishnupriya",
      "bqi": "Bakhtiari",
      "br": "Breton",
      "bra": "Braj",
      "brh": "Brahui",
      "brx": "Bodo",
      "bs": "Bosnian",
      "bss": "Akoose",
      "bua": "Buriat",
      "bug": "Buginese",
      "bum": "Bulu",
      "byn": "Blin",
      "byv": "Medumba",
      "ca": "Catalan",
      "cad": "Caddo",
      "car": "Carib",
      "cay": "Cayuga",
      "cch": "Atsam",
      "ce": "Chechen",
      "ceb": "Cebuano",
      "cgg": "Chiga",
      "ch": "Chamorro",
      "chb": "Chibcha",
      "chg": "Chagatai",
      "chk": "Chuukese",
      "chm": "Mari",
      "chn": "Chinook Jargon",
      "cho": "Choctaw",
      "chp": "Chipewyan",
      "chr": "Cherokee",
      "chy": "Cheyenne",
      "ckb": "Central Kurdish",
      "co": "Corsican",
      "cop": "Coptic",
      "cps": "Capiznon",
      "cr": "Cree",
      "crh": "Crimean Turkish",
      "cs": "Czech",
      "csb": "Kashubian",
      "cu": "Church Slavic",
      "cv": "Chuvash",
      "cy": "Welsh",
      "da": "Danish",
      "dak": "Dakota",
      "dar": "Dargwa",
      "dav": "Taita",
      "de": "German",
      "de_AT": "Austrian German",
      "de_CH": "Swiss High German",
      "del": "Delaware",
      "den": "Slave",
      "dgr": "Dogrib",
      "din": "Dinka",
      "dje": "Zarma",
      "doi": "Dogri",
      "dsb": "Lower Sorbian",
      "dtp": "Central Dusun",
      "dua": "Duala",
      "dum": "Middle Dutch",
      "dv": "Divehi",
      "dyo": "Jola-Fonyi",
      "dyu": "Dyula",
      "dz": "Dzongkha",
      "dzg": "Dazaga",
      "ebu": "Embu",
      "ee": "Ewe",
      "efi": "Efik",
      "egl": "Emilian",
      "egy": "Ancient Egyptian",
      "eka": "Ekajuk",
      "el": "Greek",
      "elx": "Elamite",
      "en": "English",
      "en_AU": "Australian English",
      "en_CA": "Canadian English",
      "en_GB": "British English",
      "en_US": "American English",
      "enm": "Middle English",
      "eo": "Esperanto",
      "es": "Spanish",
      "es_419": "Latin American Spanish",
      "es_ES": "European Spanish",
      "es_MX": "Mexican Spanish",
      "esu": "Central Yupik",
      "et": "Estonian",
      "eu": "Basque",
      "ewo": "Ewondo",
      "ext": "Extremaduran",
      "fa": "Persian",
      "fa_AF": "Dari",
      "fan": "Fang",
      "fat": "Fanti",
      "ff": "Fulah",
      "fi": "Finnish",
      "fil": "Filipino",
      "fit": "Tornedalen Finnish",
      "fj": "Fijian",
      "fo": "Faroese",
      "fon": "Fon",
      "fr": "French",
      "fr_CA": "Canadian French",
      "fr_CH": "Swiss French",
      "frc": "Cajun French",
      "frm": "Middle French",
      "fro": "Old French",
      "frp": "Arpitan",
      "frr": "Northern Frisian",
      "frs": "Eastern Frisian",
      "fur": "Friulian",
      "fy": "Western Frisian",
      "ga": "Irish",
      "gaa": "Ga",
      "gag": "Gagauz",
      "gan": "Gan Chinese",
      "gay": "Gayo",
      "gba": "Gbaya",
      "gbz": "Zoroastrian Dari",
      "gd": "Scottish Gaelic",
      "gez": "Geez",
      "gil": "Gilbertese",
      "gl": "Galician",
      "glk": "Gilaki",
      "gmh": "Middle High German",
      "gn": "Guarani",
      "goh": "Old High German",
      "gom": "Goan Konkani",
      "gon": "Gondi",
      "gor": "Gorontalo",
      "got": "Gothic",
      "grb": "Grebo",
      "grc": "Ancient Greek",
      "gsw": "Swiss German",
      "gu": "Gujarati",
      "guc": "Wayuu",
      "gur": "Frafra",
      "guz": "Gusii",
      "gv": "Manx",
      "gwi": "Gwich\u02bcin",
      "ha": "Hausa",
      "hai": "Haida",
      "hak": "Hakka Chinese",
      "haw": "Hawaiian",
      "he": "Hebrew",
      "hi": "Hindi",
      "hif": "Fiji Hindi",
      "hil": "Hiligaynon",
      "hit": "Hittite",
      "hmn": "Hmong",
      "ho": "Hiri Motu",
      "hr": "Croatian",
      "hsb": "Upper Sorbian",
      "hsn": "Xiang Chinese",
      "ht": "Haitian Creole",
      "hu": "Hungarian",
      "hup": "Hupa",
      "hy": "Armenian",
      "hz": "Herero",
      "ia": "Interlingua",
      "iba": "Iban",
      "ibb": "Ibibio",
      "id": "Indonesian",
      "ie": "Interlingue",
      "ig": "Igbo",
      "ii": "Sichuan Yi",
      "ik": "Inupiaq",
      "ilo": "Iloko",
      "inh": "Ingush",
      "io": "Ido",
      "is": "Icelandic",
      "it": "Italian",
      "iu": "Inuktitut",
      "izh": "Ingrian",
      "ja": "Japanese",
      "jam": "Jamaican Creole English",
      "jbo": "Lojban",
      "jgo": "Ngomba",
      "jmc": "Machame",
      "jpr": "Judeo-Persian",
      "jrb": "Judeo-Arabic",
      "jut": "Jutish",
      "jv": "Javanese",
      "ka": "Georgian",
      "kaa": "Kara-Kalpak",
      "kab": "Kabyle",
      "kac": "Kachin",
      "kaj": "Jju",
      "kam": "Kamba",
      "kaw": "Kawi",
      "kbd": "Kabardian",
      "kbl": "Kanembu",
      "kcg": "Tyap",
      "kde": "Makonde",
      "kea": "Kabuverdianu",
      "ken": "Kenyang",
      "kfo": "Koro",
      "kg": "Kongo",
      "kgp": "Kaingang",
      "kha": "Khasi",
      "kho": "Khotanese",
      "khq": "Koyra Chiini",
      "khw": "Khowar",
      "ki": "Kikuyu",
      "kiu": "Kirmanjki",
      "kj": "Kuanyama",
      "kk": "Kazakh",
      "kkj": "Kako",
      "kl": "Kalaallisut",
      "kln": "Kalenjin",
      "km": "Khmer",
      "kmb": "Kimbundu",
      "kn": "Kannada",
      "ko": "Korean",
      "koi": "Komi-Permyak",
      "kok": "Konkani",
      "kos": "Kosraean",
      "kpe": "Kpelle",
      "kr": "Kanuri",
      "krc": "Karachay-Balkar",
      "kri": "Krio",
      "krj": "Kinaray-a",
      "krl": "Karelian",
      "kru": "Kurukh",
      "ks": "Kashmiri",
      "ksb": "Shambala",
      "ksf": "Bafia",
      "ksh": "Colognian",
      "ku": "Kurdish",
      "kum": "Kumyk",
      "kut": "Kutenai",
      "kv": "Komi",
      "kw": "Cornish",
      "ky": "Kyrgyz",
      "la": "Latin",
      "lad": "Ladino",
      "lag": "Langi",
      "lah": "Lahnda",
      "lam": "Lamba",
      "lb": "Luxembourgish",
      "lez": "Lezghian",
      "lfn": "Lingua Franca Nova",
      "lg": "Ganda",
      "li": "Limburgish",
      "lij": "Ligurian",
      "liv": "Livonian",
      "lkt": "Lakota",
      "lmo": "Lombard",
      "ln": "Lingala",
      "lo": "Lao",
      "lol": "Mongo",
      "loz": "Lozi",
      "lrc": "Northern Luri",
      "lt": "Lithuanian",
      "ltg": "Latgalian",
      "lu": "Luba-Katanga",
      "lua": "Luba-Lulua",
      "lui": "Luiseno",
      "lun": "Lunda",
      "luo": "Luo",
      "lus": "Mizo",
      "luy": "Luyia",
      "lv": "Latvian",
      "lzh": "Literary Chinese",
      "lzz": "Laz",
      "mad": "Madurese",
      "maf": "Mafa",
      "mag": "Magahi",
      "mai": "Maithili",
      "mak": "Makasar",
      "man": "Mandingo",
      "mas": "Masai",
      "mde": "Maba",
      "mdf": "Moksha",
      "mdr": "Mandar",
      "men": "Mende",
      "mer": "Meru",
      "mfe": "Morisyen",
      "mg": "Malagasy",
      "mga": "Middle Irish",
      "mgh": "Makhuwa-Meetto",
      "mgo": "Meta\u02bc",
      "mh": "Marshallese",
      "mi": "Maori",
      "mic": "Micmac",
      "min": "Minangkabau",
      "mk": "Macedonian",
      "ml": "Malayalam",
      "mn": "Mongolian",
      "mnc": "Manchu",
      "mni": "Manipuri",
      "moh": "Mohawk",
      "mos": "Mossi",
      "mr": "Marathi",
      "mrj": "Western Mari",
      "ms": "Malay",
      "mt": "Maltese",
      "mua": "Mundang",
      "mul": "Multiple Languages",
      "mus": "Creek",
      "mwl": "Mirandese",
      "mwr": "Marwari",
      "mwv": "Mentawai",
      "my": "Burmese",
      "mye": "Myene",
      "myv": "Erzya",
      "mzn": "Mazanderani",
      "na": "Nauru",
      "nan": "Min Nan Chinese",
      "nap": "Neapolitan",
      "naq": "Nama",
      "nb": "Norwegian Bokm\u00e5l",
      "nd": "North Ndebele",
      "nds": "Low German",
      "nds_NL": "Low Saxon",
      "ne": "Nepali",
      "new": "Newari",
      "ng": "Ndonga",
      "nia": "Nias",
      "niu": "Niuean",
      "njo": "Ao Naga",
      "nl": "Dutch",
      "nl_BE": "Flemish",
      "nmg": "Kwasio",
      "nn": "Norwegian Nynorsk",
      "nnh": "Ngiemboon",
      "no": "Norwegian",
      "nog": "Nogai",
      "non": "Old Norse",
      "nov": "Novial",
      "nqo": "N\u2019Ko",
      "nr": "South Ndebele",
      "nso": "Northern Sotho",
      "nus": "Nuer",
      "nv": "Navajo",
      "nwc": "Classical Newari",
      "ny": "Nyanja",
      "nym": "Nyamwezi",
      "nyn": "Nyankole",
      "nyo": "Nyoro",
      "nzi": "Nzima",
      "oc": "Occitan",
      "oj": "Ojibwa",
      "om": "Oromo",
      "os": "Ossetic",
      "osa": "Osage",
      "ota": "Ottoman Turkish",
      "pa": "Punjabi",
      "pag": "Pangasinan",
      "pal": "Pahlavi",
      "pam": "Pampanga",
      "pap": "Papiamento",
      "pau": "Palauan",
      "pcd": "Picard",
      "pdc": "Pennsylvania German",
      "pdt": "Plautdietsch",
      "peo": "Old Persian",
      "pfl": "Palatine German",
      "phn": "Phoenician",
      "pi": "Pali",
      "pl": "Polish",
      "pms": "Piedmontese",
      "pnt": "Pontic",
      "pon": "Pohnpeian",
      "prg": "Prussian",
      "pro": "Old Proven\u00e7al",
      "ps": "Pashto",
      "pt": "Portuguese",
      "pt_BR": "Brazilian Portuguese",
      "pt_PT": "European Portuguese",
      "qu": "Quechua",
      "quc": "K\u02bciche\u02bc",
      "qug": "Chimborazo Highland Quichua",
      "raj": "Rajasthani",
      "rap": "Rapanui",
      "rar": "Rarotongan",
      "rgn": "Romagnol",
      "rif": "Riffian",
      "rm": "Romansh",
      "rn": "Rundi",
      "ro": "Romanian",
      "ro_MD": "Moldavian",
      "rof": "Rombo",
      "rom": "Romany",
      "root": "Root",
      "rtm": "Rotuman",
      "ru": "Russian",
      "rue": "Rusyn",
      "rug": "Roviana",
      "rup": "Aromanian",
      "rw": "Kinyarwanda",
      "rwk": "Rwa",
      "sa": "Sanskrit",
      "sad": "Sandawe",
      "sah": "Sakha",
      "sam": "Samaritan Aramaic",
      "saq": "Samburu",
      "sas": "Sasak",
      "sat": "Santali",
      "saz": "Saurashtra",
      "sba": "Ngambay",
      "sbp": "Sangu",
      "sc": "Sardinian",
      "scn": "Sicilian",
      "sco": "Scots",
      "sd": "Sindhi",
      "sdc": "Sassarese Sardinian",
      "sdh": "Southern Kurdish",
      "se": "Northern Sami",
      "see": "Seneca",
      "seh": "Sena",
      "sei": "Seri",
      "sel": "Selkup",
      "ses": "Koyraboro Senni",
      "sg": "Sango",
      "sga": "Old Irish",
      "sgs": "Samogitian",
      "sh": "Serbo-Croatian",
      "shi": "Tachelhit",
      "shn": "Shan",
      "shu": "Chadian Arabic",
      "si": "Sinhala",
      "sid": "Sidamo",
      "sk": "Slovak",
      "sl": "Slovenian",
      "sli": "Lower Silesian",
      "sly": "Selayar",
      "sm": "Samoan",
      "sma": "Southern Sami",
      "smj": "Lule Sami",
      "smn": "Inari Sami",
      "sms": "Skolt Sami",
      "sn": "Shona",
      "snk": "Soninke",
      "so": "Somali",
      "sog": "Sogdien",
      "sq": "Albanian",
      "sr": "Serbian",
      "srn": "Sranan Tongo",
      "srr": "Serer",
      "ss": "Swati",
      "ssy": "Saho",
      "st": "Southern Sotho",
      "stq": "Saterland Frisian",
      "su": "Sundanese",
      "suk": "Sukuma",
      "sus": "Susu",
      "sux": "Sumerian",
      "sv": "Swedish",
      "sw": "Swahili",
      "sw_CD": "Congo Swahili",
      "swb": "Comorian",
      "syc": "Classical Syriac",
      "syr": "Syriac",
      "szl": "Silesian",
      "ta": "Tamil",
      "tcy": "Tulu",
      "te": "Telugu",
      "tem": "Timne",
      "teo": "Teso",
      "ter": "Tereno",
      "tet": "Tetum",
      "tg": "Tajik",
      "th": "Thai",
      "ti": "Tigrinya",
      "tig": "Tigre",
      "tiv": "Tiv",
      "tk": "Turkmen",
      "tkl": "Tokelau",
      "tkr": "Tsakhur",
      "tl": "Tagalog",
      "tlh": "Klingon",
      "tli": "Tlingit",
      "tly": "Talysh",
      "tmh": "Tamashek",
      "tn": "Tswana",
      "to": "Tongan",
      "tog": "Nyasa Tonga",
      "tpi": "Tok Pisin",
      "tr": "Turkish",
      "tru": "Turoyo",
      "trv": "Taroko",
      "ts": "Tsonga",
      "tsd": "Tsakonian",
      "tsi": "Tsimshian",
      "tt": "Tatar",
      "ttt": "Muslim Tat",
      "tum": "Tumbuka",
      "tvl": "Tuvalu",
      "tw": "Twi",
      "twq": "Tasawaq",
      "ty": "Tahitian",
      "tyv": "Tuvinian",
      "tzm": "Central Atlas Tamazight",
      "udm": "Udmurt",
      "ug": "Uyghur",
      "uga": "Ugaritic",
      "uk": "Ukrainian",
      "umb": "Umbundu",
      "und": "Unknown Language",
      "ur": "Urdu",
      "uz": "Uzbek",
      "vai": "Vai",
      "ve": "Venda",
      "vec": "Venetian",
      "vep": "Veps",
      "vi": "Vietnamese",
      "vls": "West Flemish",
      "vmf": "Main-Franconian",
      "vo": "Volap\u00fck",
      "vot": "Votic",
      "vro": "V\u00f5ro",
      "vun": "Vunjo",
      "wa": "Walloon",
      "wae": "Walser",
      "wal": "Wolaytta",
      "war": "Waray",
      "was": "Washo",
      "wbp": "Warlpiri",
      "wo": "Wolof",
      "wuu": "Wu Chinese",
      "xal": "Kalmyk",
      "xh": "Xhosa",
      "xmf": "Mingrelian",
      "xog": "Soga",
      "yao": "Yao",
      "yap": "Yapese",
      "yav": "Yangben",
      "ybb": "Yemba",
      "yi": "Yiddish",
      "yo": "Yoruba",
      "yrl": "Nheengatu",
      "yue": "Cantonese",
      "za": "Zhuang",
      "zap": "Zapotec",
      "zbl": "Blissymbols",
      "zea": "Zeelandic",
      "zen": "Zenaga",
      "zgh": "Standard Moroccan Tamazight",
      "zh": "Chinese",
      "zh_Hans": "Simplified Chinese",
      "zh_Hant": "Traditional Chinese",
      "zu": "Zulu",
      "zun": "Zuni",
      "zxx": "No linguistic content",
      "zza": "Zaza"
    }
  }
}
);

$translateProvider.translations("fr", {
  "LANGUAGES": {
    "Version": "2.1.23.79",
    "Names": {
      "Null": "Aucun",
      "null": "Aucun",
      "aa": "afar",
      "ab": "abkhaze",
      "ace": "aceh",
      "ach": "acoli",
      "ada": "adangme",
      "ady": "adygh\u00e9en",
      "ae": "avestique",
      "af": "afrikaans",
      "afh": "afrihili",
      "agq": "aghem",
      "ain": "a\u00efnou",
      "ak": "akan",
      "akk": "akkadien",
      "ale": "al\u00e9oute",
      "alt": "alta\u00ef du Sud",
      "am": "amharique",
      "an": "aragonais",
      "ang": "ancien anglais",
      "anp": "angika",
      "ar": "arabe",
      "ar_001": "arabe standard moderne",
      "arc": "aram\u00e9en",
      "arn": "mapuche",
      "arp": "arapaho",
      "arw": "arawak",
      "as": "assamais",
      "asa": "assou",
      "ast": "asturien",
      "av": "avar",
      "awa": "awadhi",
      "ay": "aymara",
      "az": "az\u00e9ri",
      "ba": "bachkir",
      "bal": "baloutchi",
      "ban": "balinais",
      "bas": "bassa",
      "bax": "bamoun",
      "bbj": "ghomala",
      "be": "bi\u00e9lorusse",
      "bej": "bedja",
      "bem": "bemba",
      "bez": "b\u00e9na",
      "bfd": "bafut",
      "bg": "bulgare",
      "bgn": "baloutchi occidental",
      "bho": "bhojpuri",
      "bi": "bichelamar",
      "bik": "bikol",
      "bin": "bini",
      "bkm": "kom",
      "bla": "siksika",
      "bm": "bambara",
      "bn": "bengali",
      "bo": "tib\u00e9tain",
      "br": "breton",
      "bra": "braj",
      "brx": "bodo",
      "bs": "bosniaque",
      "bss": "akoose",
      "bua": "bouriate",
      "bug": "bugi",
      "bum": "boulou",
      "byn": "blin",
      "byv": "medumba",
      "ca": "catalan",
      "cad": "caddo",
      "car": "caribe",
      "cay": "cayuga",
      "cch": "atsam",
      "ce": "tch\u00e9tch\u00e8ne",
      "ceb": "cebuano",
      "cgg": "kiga",
      "ch": "chamorro",
      "chb": "chibcha",
      "chg": "tchaghata\u00ef",
      "chk": "chuuk",
      "chm": "mari",
      "chn": "jargon chinook",
      "cho": "choctaw",
      "chp": "chipewyan",
      "chr": "cherokee",
      "chy": "cheyenne",
      "ckb": "sorani",
      "co": "corse",
      "cop": "copte",
      "cr": "cree",
      "crh": "turc de Crim\u00e9e",
      "cs": "tch\u00e8que",
      "csb": "kachoube",
      "cu": "slavon d\u2019\u00e9glise",
      "cv": "tchouvache",
      "cy": "gallois",
      "da": "danois",
      "dak": "dakota",
      "dar": "dargwa",
      "dav": "taita",
      "de": "allemand",
      "de_AT": "allemand autrichien",
      "de_CH": "allemand suisse",
      "del": "delaware",
      "den": "slavey",
      "dgr": "dogrib",
      "din": "dinka",
      "dje": "zarma",
      "doi": "dogri",
      "dsb": "bas-sorabe",
      "dua": "douala",
      "dum": "moyen n\u00e9erlandais",
      "dv": "maldivien",
      "dyo": "diola-fogny",
      "dyu": "dioula",
      "dz": "dzongkha",
      "dzg": "dazaga",
      "ebu": "embou",
      "ee": "\u00e9w\u00e9",
      "efi": "efik",
      "egy": "\u00e9gyptien ancien",
      "eka": "ekajuk",
      "el": "grec",
      "elx": "\u00e9lamite",
      "en": "anglais",
      "en_AU": "anglais australien",
      "en_CA": "anglais canadien",
      "en_GB": "anglais britannique",
      "en_US": "anglais am\u00e9ricain",
      "enm": "moyen anglais",
      "eo": "esp\u00e9ranto",
      "es": "espagnol",
      "es_419": "espagnol latino-am\u00e9ricain",
      "es_ES": "espagnol europ\u00e9en",
      "es_MX": "espagnol mexicain",
      "et": "estonien",
      "eu": "basque",
      "ewo": "\u00e9wondo",
      "fa": "persan",
      "fan": "fang",
      "fat": "fanti",
      "ff": "peul",
      "fi": "finnois",
      "fil": "filipino",
      "fj": "fidjien",
      "fo": "f\u00e9ro\u00efen",
      "fon": "fon",
      "fr": "fran\u00e7ais",
      "fr_CA": "fran\u00e7ais canadien",
      "fr_CH": "fran\u00e7ais suisse",
      "frm": "moyen fran\u00e7ais",
      "fro": "ancien fran\u00e7ais",
      "frp": "franco-proven\u00e7al",
      "frr": "frison du Nord",
      "frs": "frison oriental",
      "fur": "frioulan",
      "fy": "frison occidental",
      "ga": "irlandais",
      "gaa": "ga",
      "gag": "gagaouze",
      "gay": "gayo",
      "gba": "gbaya",
      "gd": "ga\u00e9lique \u00e9cossais",
      "gez": "gu\u00e8ze",
      "gil": "gilbertais",
      "gl": "galicien",
      "gmh": "moyen haut-allemand",
      "gn": "guarani",
      "goh": "ancien haut allemand",
      "gon": "gondi",
      "gor": "gorontalo",
      "got": "gotique",
      "grb": "grebo",
      "grc": "grec ancien",
      "gsw": "suisse allemand",
      "gu": "gujarati",
      "guz": "gusii",
      "gv": "manx",
      "gwi": "gwich\u02bcin",
      "ha": "haoussa",
      "hai": "haida",
      "haw": "hawa\u00efen",
      "he": "h\u00e9breu",
      "hi": "hindi",
      "hil": "hiligaynon",
      "hit": "hittite",
      "hmn": "hmong",
      "ho": "hiri motu",
      "hr": "croate",
      "hsb": "haut-sorabe",
      "ht": "cr\u00e9ole ha\u00eftien",
      "hu": "hongrois",
      "hup": "hupa",
      "hy": "arm\u00e9nien",
      "hz": "h\u00e9r\u00e9ro",
      "ia": "interlingua",
      "iba": "iban",
      "ibb": "ibibio",
      "id": "indon\u00e9sien",
      "ie": "interlingue",
      "ig": "igbo",
      "ii": "yi du Sichuan",
      "ik": "inupiaq",
      "ilo": "ilokano",
      "inh": "ingouche",
      "io": "ido",
      "is": "islandais",
      "it": "italien",
      "iu": "inuktitut",
      "ja": "japonais",
      "jbo": "lojban",
      "jgo": "ngomba",
      "jmc": "machame",
      "jpr": "jud\u00e9o-persan",
      "jrb": "jud\u00e9o-arabe",
      "jv": "javanais",
      "ka": "g\u00e9orgien",
      "kaa": "karakalpak",
      "kab": "kabyle",
      "kac": "kachin",
      "kaj": "jju",
      "kam": "kamba",
      "kaw": "kawi",
      "kbd": "kabardin",
      "kbl": "kanembou",
      "kcg": "tyap",
      "kde": "makonde",
      "kea": "capverdien",
      "kfo": "koro",
      "kg": "kongo",
      "kha": "khasi",
      "kho": "khotanais",
      "khq": "koyra chiini",
      "ki": "kikuyu",
      "kj": "kuanyama",
      "kk": "kazakh",
      "kkj": "kako",
      "kl": "groenlandais",
      "kln": "kalenjin",
      "km": "khmer",
      "kmb": "kiMboundou",
      "kn": "kannada",
      "ko": "cor\u00e9en",
      "koi": "komi-permiak",
      "kok": "konkani",
      "kos": "kusaien",
      "kpe": "kpell\u00e9",
      "kr": "kanouri",
      "krc": "karatcha\u00ef balkar",
      "krl": "car\u00e9lien",
      "kru": "kurukh",
      "ks": "kashmiri",
      "ksb": "chambala",
      "ksf": "bafia",
      "ksh": "francique ripuaire",
      "ku": "kurde",
      "kum": "koumyk",
      "kut": "kutenai",
      "kv": "komi",
      "kw": "cornique",
      "ky": "kirghize",
      "la": "latin",
      "lad": "ladino",
      "lag": "langi",
      "lah": "lahnda",
      "lam": "lamba",
      "lb": "luxembourgeois",
      "lez": "lezghien",
      "lg": "ganda",
      "li": "limbourgeois",
      "lkt": "lakota",
      "ln": "lingala",
      "lo": "lao",
      "lol": "mongo",
      "loz": "lozi",
      "lrc": "lori du Nord",
      "lt": "lituanien",
      "lu": "luba-katanga",
      "lua": "luba-lulua",
      "lui": "luiseno",
      "lun": "lunda",
      "luo": "luo",
      "lus": "lushai",
      "luy": "oluluyia",
      "lv": "letton",
      "mad": "madurais",
      "maf": "mafa",
      "mag": "magahi",
      "mai": "maithili",
      "mak": "makassar",
      "man": "mandingue",
      "mas": "masai",
      "mde": "maba",
      "mdf": "moksa",
      "mdr": "mandar",
      "men": "mend\u00e9",
      "mer": "merou",
      "mfe": "cr\u00e9ole mauricien",
      "mg": "malgache",
      "mga": "moyen irlandais",
      "mgh": "makhuwa-meetto",
      "mgo": "m\u00e9ta\u2019",
      "mh": "marshall",
      "mi": "maori",
      "mic": "micmac",
      "min": "minangkabau",
      "mk": "mac\u00e9donien",
      "ml": "malayalam",
      "mn": "mongol",
      "mnc": "mandchou",
      "mni": "manipuri",
      "moh": "mohawk",
      "mos": "mor\u00e9",
      "mr": "marathe",
      "ms": "malais",
      "mt": "maltais",
      "mua": "mundang",
      "mul": "multilingue",
      "mus": "creek",
      "mwl": "mirandais",
      "mwr": "marwar\u00ee",
      "my": "birman",
      "mye": "my\u00e8n\u00e8",
      "myv": "erzya",
      "mzn": "mazand\u00e9rani",
      "na": "nauruan",
      "nap": "napolitain",
      "naq": "nama",
      "nb": "norv\u00e9gien bokm\u00e5l",
      "nd": "nd\u00e9b\u00e9l\u00e9 du Nord",
      "nds": "bas-allemand",
      "nds_NL": "bas-saxon n\u00e9erlandais",
      "ne": "n\u00e9palais",
      "new": "newari",
      "ng": "ndonga",
      "nia": "nias",
      "niu": "niu\u00e9",
      "nl": "n\u00e9erlandais",
      "nl_BE": "flamand",
      "nmg": "kwasio",
      "nn": "norv\u00e9gien nynorsk",
      "nnh": "ngiemboon",
      "no": "norv\u00e9gien",
      "nog": "noga\u00ef",
      "non": "vieux norrois",
      "nqo": "n\u2019ko",
      "nr": "nd\u00e9b\u00e9l\u00e9 du Sud",
      "nso": "sotho du Nord",
      "nus": "nuer",
      "nv": "navaho",
      "nwc": "newar\u00ee classique",
      "ny": "nyanja",
      "nym": "nyamwezi",
      "nyn": "nyankol\u00e9",
      "nyo": "nyoro",
      "nzi": "nzema",
      "oc": "occitan",
      "oj": "ojibwa",
      "om": "oromo",
      "os": "oss\u00e8te",
      "osa": "osage",
      "ota": "turc ottoman",
      "pa": "pendjabi",
      "pag": "pangasinan",
      "pal": "pahlavi",
      "pam": "pampangan",
      "pap": "papiamento",
      "pau": "palau",
      "peo": "persan ancien",
      "phn": "ph\u00e9nicien",
      "pi": "pali",
      "pl": "polonais",
      "pon": "pohnpei",
      "pro": "proven\u00e7al ancien",
      "ps": "pachto",
      "pt": "portugais",
      "pt_BR": "portugais br\u00e9silien",
      "pt_PT": "portugais europ\u00e9en",
      "qu": "quechua",
      "quc": "k\u2019iche\u2019",
      "raj": "rajasthani",
      "rap": "rapanui",
      "rar": "rarotongien",
      "rm": "romanche",
      "rn": "roundi",
      "ro": "roumain",
      "ro_MD": "moldave",
      "rof": "rombo",
      "rom": "tzigane",
      "root": "racine",
      "ru": "russe",
      "rup": "valaque",
      "rw": "rwanda",
      "rwk": "rwa",
      "sa": "sanskrit",
      "sad": "sandawe",
      "sah": "iakoute",
      "sam": "aram\u00e9en samaritain",
      "saq": "samburu",
      "sas": "sasak",
      "sat": "santal",
      "sba": "ngambay",
      "sbp": "sangu",
      "sc": "sarde",
      "scn": "sicilien",
      "sco": "\u00e9cossais",
      "sd": "sindhi",
      "sdh": "kurde du Sud",
      "se": "sami du Nord",
      "see": "seneca",
      "seh": "sena",
      "sel": "selkoupe",
      "ses": "koyraboro senni",
      "sg": "sangho",
      "sga": "ancien irlandais",
      "sh": "serbo-croate",
      "shi": "chleuh",
      "shn": "shan",
      "shu": "arabe tchadien",
      "si": "cinghalais",
      "sid": "sidamo",
      "sk": "slovaque",
      "sl": "slov\u00e8ne",
      "sm": "samoan",
      "sma": "sami du Sud",
      "smj": "sami de Lule",
      "smn": "sami d\u2019Inari",
      "sms": "sami skolt",
      "sn": "shona",
      "snk": "sonink\u00e9",
      "so": "somali",
      "sog": "sogdien",
      "sq": "albanais",
      "sr": "serbe",
      "srn": "sranan tongo",
      "srr": "s\u00e9r\u00e8re",
      "ss": "swati",
      "ssy": "saho",
      "st": "sesotho",
      "su": "soundanais",
      "suk": "sukuma",
      "sus": "soussou",
      "sux": "sum\u00e9rien",
      "sv": "su\u00e9dois",
      "sw": "swahili",
      "sw_CD": "swahili du Congo",
      "swb": "comorien",
      "syc": "syriaque classique",
      "syr": "syriaque",
      "ta": "tamoul",
      "te": "t\u00e9lougou",
      "tem": "temne",
      "teo": "teso",
      "ter": "tereno",
      "tet": "tetum",
      "tg": "tadjik",
      "th": "tha\u00ef",
      "ti": "tigrigna",
      "tig": "tigr\u00e9",
      "tiv": "tiv",
      "tk": "turkm\u00e8ne",
      "tkl": "tokelau",
      "tl": "tagalog",
      "tlh": "klingon",
      "tli": "tlingit",
      "tmh": "tamacheq",
      "tn": "tswana",
      "to": "tonguien",
      "tog": "tonga nyasa",
      "tpi": "tok pisin",
      "tr": "turc",
      "trv": "taroko",
      "ts": "tsonga",
      "tsi": "tsimshian",
      "tt": "tatar",
      "tum": "tumbuka",
      "tvl": "tuvalu",
      "tw": "twi",
      "twq": "tasawaq",
      "ty": "tahitien",
      "tyv": "touva",
      "tzm": "tamazight",
      "udm": "oudmourte",
      "ug": "ou\u00efghour",
      "uga": "ougaritique",
      "uk": "ukrainien",
      "umb": "umbundu",
      "und": "langue ind\u00e9termin\u00e9e",
      "ur": "ourdou",
      "uz": "ouzbek",
      "vai": "va\u00ef",
      "ve": "venda",
      "vi": "vietnamien",
      "vo": "volapuk",
      "vot": "vote",
      "vun": "vunjo",
      "wa": "wallon",
      "wae": "walser",
      "wal": "walamo",
      "war": "waray",
      "was": "washo",
      "wbp": "warlpiri",
      "wo": "wolof",
      "xal": "kalmouk",
      "xh": "xhosa",
      "xog": "soga",
      "yao": "yao",
      "yap": "yapois",
      "yav": "yangben",
      "ybb": "yemba",
      "yi": "yiddish",
      "yo": "yoruba",
      "yue": "cantonais",
      "za": "zhuang",
      "zap": "zapot\u00e8que",
      "zbl": "symboles Bliss",
      "zen": "zenaga",
      "zgh": "amazighe standard marocain",
      "zh": "chinois",
      "zh_Hans": "chinois simplifi\u00e9",
      "zh_Hant": "chinois traditionnel",
      "zu": "zoulou",
      "zun": "zuni",
      "zxx": "sans contenu linguistique",
      "zza": "zazaki"
    }
  }
}
);

$translateProvider.translations("en", {
  "TOOLBAR": {
    "TOGGLE_NAVIGATION": "Toggle navigation",
    "TOGGLE_NAVIGATION_FOLD": "Enable \/ Disable navigation",
    "USER_SETTINGS": "User settings",
    "TOGGLE_QUICK_PANEL": "Toggle quick panel",
    "FRENCH": "FRENCH",
    "ENGLISH": "ENGLISH",
    "account": "Compte",
    "my_profile": "My profile",
    "inbox": "Inbox",
    "logout": "Logout",
    "help" : "Help",
    "language": "Language",
    "TOGGLE_MOBILE_NAVIGATION": "Toggle mobile navigation",
    "ASK_FOR_SUPPORT": "Contact the technical support",
    "fr": "French",
    "us": "English"
  }
}
);

$translateProvider.translations("fr", {
  "TOOLBAR": {
    "TOGGLE_NAVIGATION": "Basculer la navigation",
    "TOGGLE_NAVIGATION_FOLD": "Activer \/ D\u00e9sactiver la navigation",
    "USER_SETTINGS": "Param\u00e8tres utilisateur",
    "TOGGLE_QUICK_PANEL": "Basculer le panneau rapide",
    "FRENCH": "FRANCAIS",
    "ENGLISH": "ANGLAIS",
    "my_profile": "Profil",
    "account": "Compte",
    "inbox": "Bo\u00eete de r\u00e9ception",
    "logout": "Se d\u00e9connecter",
    "help" : "Aide",
    "language": "Langue",
    "TOGGLE_MOBILE_NAVIGATION": "Basculer la navigation mobile",
    "ASK_FOR_SUPPORT": "Contacter le support technique",
    "fr": "Français",
    "us": "Anglais"
  }
}
);

$translateProvider.translations("en", {
  "CHUTIERLIST": {
    "added": "Video trim added successfully.",
    "edited": "Video trim edited successfully.",
    "delete_chutier_msg": "Do you want to delete the video trim ?",
    "delete_chutier_aria_label": "Delete video trim",
    "isLoop": "Play in loop",
    "duration": "Broadcast duration (s)",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element" : "Add new video trim"
  },
  "CHUTIERDETAIL": {
    "chutier_detail_title": "Video trim detail",
    "id": "ID : ",
    "title": "Title : ",
    "channel": "Channel : ",
    "isLoop": "Repeat  : ",
    "order": "Respect parametrized order : ",
    "duration": "Broadcast duration (seconds) : "
  },
  "CHUTIERADD": {
    "form_new_title": "Add video trim form",
    "form_title": "Video trim information",
    "form_attr_title": "Title",
    "form_attr_canal": "Channel"
  },
  "CHUTIEREDIT": {
    "form_edit_title": "Edit video trim form",
    "form_title": "Video trim information"
  }
}
);

$translateProvider.translations("fr", {
  "CHUTIERLIST": {
    "added": "Chutier vid\u00e9o ajout\u00e9 avec succ\u00e8s.",
    "edited": "Chutier modifi\u00e9e avec succ\u00e8s.",
    "delete_chutier_msg": "Voulez-vous supprimer le chutier vid\u00e9o ?",
    "delete_chutier_aria_label": "Supprimer le chutier vid\u00e9o",
    "isLoop": "Lire en boucle",
    "duration": "Dur\u00e9e de diffusion (s)",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "action_new_element" : "Ajouter un nouveau chutier"
  },
  "CHUTIERDETAIL": {
    "chutier_detail_title": "D\u00e9tail du chutier vid\u00e9o",
    "id": "Identifiant : ",
    "title": "Titre : ",
    "channel": "Canal : ",
    "isLoop": "Lire en boucle : ",
    "order": "Respecter l'ordre param\u00e9tr\u00e9 : ",
    "duration": "Dur\u00e9e de diffusion (secondes) : "
  },
  "CHUTIERADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau chutier vid\u00e9o",
    "form_title": "Information du chutier vid\u00e9o",
    "form_attr_title": "Titre",
    "form_attr_canal": "Canal"
  },
  "CHUTIEREDIT": {
    "form_edit_title": "Formulaire de modification du chutier vid\u00e9o :",
    "form_title": "Information du chutier vid\u00e9o"
  }
});

$translateProvider.translations("en", {
  "RIGHTS": {
    "upper_case_replace_message": "All words will be seperated by underscores.Exemple: CoreAddUser will be: core_add_user.",
    "name_must_not_end_with_action": "The name of the action must not end with the keyword \"_action\"._ nl_ This prefix is used when creating the action.",
    "two_actions_cannot_have_the_same_name": "Two actions must not have the same name.",
    "actions_list": "List of actions",
    "add_new_action": "Add a new action",
    "action_already_exist": "This action already exists.",
    "form_must_not_end_with_action": "The name of the action must not end with the keyword \"_action\"",
    "delete_action_msg": "Do you want to delete this action?",
    "delete_action_aria_label": "Delete Action",
    "name_must_not_end_with_module": "The name of the module must not end with the keyword \"_module\"._ nl_ This prefix is used when creating the action.",
    "two_modules_cannot_have_the_same_name": "Two Modules must not have the same name.",
    "modules_list": "List of modules",
    "add_new_module": "Add a new module",
    "module_already_exist": "This module already exists.",
    "form_must_not_end_with_module": "The name of the module must not end with the keyword \"_module\".",
    "delete_module_msg": "Do you want want to delete this module?",
    "delete_module_aria_label": "Delete Module",
    "module_contents_info_msg": "A module must contain at least one action. An action can have an API route and an angular module Or one of them or none of them.",
    "action_already_defined_in_module": "This action is already used in this module",
    "ang_module_already_defined_in_module": "This angular module is already used in this module",
    "route_already_defined_in_module": "This APi route is already used in this module",
    "add_an_action": "Add a new action",
    "group_rights_title": "Group rights management :",
    "this_action": "This action"
  },
  "ACTIONSLIST": {
    "metaData_list_dtable": "metaData list using datatable",
    "metaData_form_is_accessible":"metaData form is accessible",
    "core_group_add_action": "Add users group",
    "core_group_delete_action": "Delete users group",
    "core_group_edit_action": "Edit users group",
    "core_group_manage_rights_action": "Manage group permissions",
    "core_group_view_action": "View users group information",
    "core_user_add_action": "Add user",
    "core_user_delete_action": "Delete user",
    "core_user_edit_action": "Edit user",
    "core_user_view_action": "View user information",
    "live_add_action": "Add live",
    "live_add_config_action": "Add live configuration",
    "live_calendar_action": "View live calendar",
    "live_delete_action": "Delete live",
    "live_edit_action": "Edit live",
    "live_view_action": "View live information",
    "live_view_archived_action": "View archived lives",
    "live_view_offline_action": "View offline lives",
    "live_view_on_going_action": "View on-going lives",
    "live_view_to_come_action": "View to come lives",
    "media_comments_un_validate_action": "Unvalidate comment",
    "media_comments_validate_action": "Validate comment",
    "media_video_add_action": "Add video",
    "media_video_captions_action": "Manage captions",
    "media_video_delete_action": "Delete video",
    "media_video_edit_action": "Edit video",
    "media_video_list_comments": "See comment list",
    "comment_post_select_file": "Choose a file",
    "media_video_export_daily_motion_action": "Export video to DAILYMOTION",
    "media_video_export_links_action": "View video export links",
    "media_video_export_youtube_action": "Export video to YOUTUBE",
    "media_video_push_action": "Push video",
    "media_video_re_upload_action": "Reupload video",
    "media_video_rich_media_action": "Manage video rich-media",
    "media_video_toggle_choices_action": "Toggle video parameters",
    "media_video_un_push_action": "Unpush video",
    "media_video_upload_action": "Upload video",
    "media_video_upload_flash_option_action": "Upload video : Flash option",
    "media_video_upload_ftp_option_action": "Upload video : Ftp option",
    "media_video_upload_html_option_action": "Upload video : HTML5 option",
    "media_video_upload_on_hold_option_action": "Upload video : On hold option",
    "media_video_view_archived_action": "View archived videos",
    "media_video_view_informations_action": "View video information",
    "media_video_view_meta_action": "View video metaData",
    "media_video_view_offline_action": "View offline videos",
    "media_video_view_on_going_action": "View on-going videos",
    "media_video_view_to_come_action": "View to-come videos",
    "parametres_theme_ajout_action": "Add theme",
    "playlist_add_action": "Add playlist",
    "playlist_live_add_action": "Add live playlist",
    "subscription_group_add_action": "Add subscribers group",
    "subscription_group_delete_action": "Delete subscribers group",
    "subscription_group_edit_action": "Edit subscribers group",
    "subscription_group_view_action": "View subscribers group",
    "subscription_user_add_action": "Add subscriber",
    "subscription_user_delete_action": "Delete subscriber",
    "subscription_user_edit_action": "Edit subscriber",
    "subscription_user_view_action": "View subscriber information",
    "boitier_autoriseip_post_add": "Add allowed IP",
    "boitier_autoriseip_post_edit": "Edit allowed IP",
    "boitier_autoriseip_list_dtable": "List of  ",
    "boitier_autoriseip_delete_ips": "Delete allowed IP",
    "boitier_autoriseip_delete_multi": "Multiple deletion of allowed IP",
    "boitier_autoriseip_get_detail": "Detail of allowed IP"
  },
  "MODULESLIST": {
    "core_group_module": "User group module",
    "media_video_module": "Video module",
    "parametres_theme_module": "Theme module",
    "configuration_autorise_ip": "IP autorisée"
  }
}
);

$translateProvider.translations("fr", {
  "RIGHTS": {
    "upper_case_replace_message": "Tous les mots seront sp\u00e9rar\u00e9s par des tirets bas.Exp: CoreAddUser sera : core_add_user .",
    "name_must_not_end_with_action": "Le nom de l'action ne doit pas terminer par le mot cl\u00e9 \"_action\". On utilise ce pr\u00e9fix lors de la cr\u00e9ation de l'action.",
    "two_actions_cannot_have_the_same_name": "Deux actions ne doivent pas avoir le m\u00eame nom.",
    "actions_list": "Liste des actions",
    "add_new_action": "Ajout d'une nouvelle action",
    "action_already_exist": "Cette action existe d\u00e9ja.",
    "form_must_not_end_with_action": "Le nom de l'action ne doit pas terminer par le mot cl\u00e9 \"_action\".",
    "delete_action_msg": "Voulez-vous vraiment supprimer cette action ?",
    "delete_action_aria_label": "Supprimer l'action",
    "name_must_not_end_with_module": "Le nom du module ne doit pas terminer par le mot cl\u00e9 \"_module\". On utilise ce pr\u00e9fix lors de la cr\u00e9ation du module.",
    "two_modules_cannot_have_the_same_name": "Deux modules ne doivent pas avoir le m\u00eame nom.",
    "modules_list": "Liste des modules",
    "add_new_module": "Ajout d'un nouveau module",
    "module_already_exist": "Ce module existe d\u00e9ja.",
    "form_must_not_end_with_module": "Le nom du module ne doit pas terminer par le mot cl\u00e9 \"_module\".",
    "delete_module_msg": "Voulez-vous vraiment supprimer ce module ?",
    "delete_module_aria_label": "Supprimer le module",
    "module_contents_info_msg": "Un module doit contenir au moins une action. Une action peut avoir une route API et un module angular Ou l'une des deux ou aucune.",
    "action_already_defined_in_module": "Cette action est d\u00e9ja utilis\u00e9e dans ce module",
    "ang_module_already_defined_in_module": "Ce module angular est d\u00e9ja utilis\u00e9 dans ce module",
    "route_already_defined_in_module": "Cette route est d\u00e9ja utilis\u00e9e dans ce module",
    "add_an_action": "Ajouter une nouvelle action",
    "group_rights_title": "Gestion des droits du groupe :",
    "this_action": "Cette action"
  },
  "ACTIONSLIST": {
    "metaData_list_dtable": "Liste des metadonnées en utilisant datatable",
    "metaData_form_is_accessible":"formulaire du metadonnée est accessible",
    "core_group_add_action": "Ajout d'un groupe d'utilisateur",
    "core_group_delete_action": "Suppression d'un groupe d'utilisateur",
    "core_group_edit_action": "Modification d'un groupe d'utilisateur",
    "core_group_manage_rights_action": "G\u00e9rer les permissions du groupe d'utilisateur",
    "core_group_view_action": "Voir les informations du groupe d'utilisateur",
    "core_user_add_action": "Ajout d'un utilisateur",
    "core_user_delete_action": "Suppression d'un utilisateur",
    "core_user_edit_action": "Modification d'un utilisateur",
    "core_user_view_action": "Voir les informations de l'utilisateur",
    "live_add_action": "Ajout d'un direct",
    "live_add_config_action": "Configurer un direct",
    "live_calendar_action": "Voir le calendrier des directs",
    "live_delete_action": "Suppression d'un direct",
    "live_edit_action": "Modification d'un direct",
    "live_view_action": "Voir les informations d'un direct",
    "live_view_archived_action": "Voir les directs termin\u00e9s",
    "live_view_offline_action": "Voir les directs hors ligne",
    "live_view_on_going_action": "Voir les direct en cours",
    "live_view_to_come_action": "Voir les directs \u00e0 venir",
    "media_comments_un_validate_action": "Ne pas valider les commentaires",
    "media_comments_validate_action": "Valider les commentaires",
    "media_video_add_action": "Ajout d'une vid\u00e9o",
    "media_video_captions_action": "Sous-titrage d'une vid\u00e9o",
    "media_video_delete_action": "Suppression d'une vid\u00e9o",
    "media_video_edit_action": "Modification d'une vid\u00e9o",
    "media_video_list_comments": "Voir liste des commentaires",
    "comment_post_select_file": "Choissir un fichier",
    "media_video_export_daily_motion_action": "Exporter une vid\u00e9o vers DAILYMOTION",
    "media_video_export_links_action": "Voir les liens d'export d'une vid\u00e9o",
    "media_video_export_youtube_action": "Exporter une vid\u00e9o vers YOUTUBE",
    "media_video_push_action": "Mettre en avant une vid\u00e9o",
    "media_video_re_upload_action": "Changer la source d'une vid\u00e9o",
    "media_video_rich_media_action": "Rich-media d'une vid\u00e9o",
    "media_video_toggle_choices_action": "Basculer les param\u00e8tres d'une vid\u00e9o",
    "media_video_un_push_action": "Mettre en arri\u00e8re une vid\u00e9o",
    "media_video_upload_action": "Importer une vid\u00e9o",
    "media_video_upload_flash_option_action": "Import vid\u00e9o (flash)",
    "media_video_upload_ftp_option_action": "Import vid\u00e9o (FTP)",
    "media_video_upload_html_option_action": "Import vid\u00e9o (HTML5)",
    "media_video_upload_on_hold_option_action": "Import vid\u00e9o (vid\u00e9os en attente)",
    "media_video_view_archived_action": "Voir les vid\u00e9os archiv\u00e9es",
    "media_video_view_informations_action": "Voir les informations d'une vid\u00e9o",
    "media_video_view_meta_action": "Voir mes m\u00e9tadonn\u00e9es d'une vid\u00e9o",
    "media_video_view_offline_action": "Voir les vid\u00e9os hors ligne",
    "media_video_view_on_going_action": "Voir les vid\u00e9os en cours",
    "media_video_view_to_come_action": "Voir les vid\u00e9os \u00e0 venir",
    "parametres_theme_ajout_action": "Ajout d'un th\u00e8me",
    "playlist_add_action": "Ajout d'une playlist",
    "playlist_live_add_action": "Ajout d'une playlist direct",
    "subscription_group_add_action": "Ajout d'un groupe d'abonn\u00e9es",
    "subscription_group_delete_action": "Suppression d'un groupe d'abonn\u00e9s",
    "subscription_group_edit_action": "Modification d'un groupe d'abonn\u00e9s",
    "subscription_group_view_action": "Voir les informations d'un groupe d'abonn\u00e9s",
    "subscription_user_add_action": "Ajout d'un abonn\u00e9",
    "subscription_user_delete_action": "Suppression d'un abonn\u00e9",
    "subscription_user_edit_action": "Modification d'un abonn\u00e9",
    "subscription_user_view_action": "Voir les informations d'un abonn\u00e9",
    "boitier_autoriseip_post_add": "Ajout d'une adresse IP autorisée",
    "boitier_autoriseip_post_edit": "Modification d'une adresse IP autorisée",
    "boitier_autoriseip_list_dtable": "Liste des adresses IP autorisées",
    "boitier_autoriseip_delete_ips": "Suppression d'une adresse IP autorisée",
    "boitier_autoriseip_delete_multi": "Suppression multiple des adresses IP autorisées",
    "boitier_autoriseip_get_detail": "Détail d'une adresse IP autorisée"
  },
  "MODULESLIST": {
    "core_group_module": "Module groupe utilisateur",
    "media_video_module": "Module vid\u00e9o",
    "parametres_theme_module": "Module th\u00e8me",
    "configuration_autorise_ip": "IP autorisée"
  }
});

$translateProvider.translations("en", {
  "RIGHTS": {
    "add_new": "Add a new module"
  },
  "ACTIONSLIST": {
    "display_schedule_post_add": "Add schedule",
    "display_schedule_get_one": "Display a schedule",
    "display_schedule_post_edit": "Edit schedule",
    "display_schedule_post_edit_order": "Edit order of schedule",
    "display_schedule_get_all": "Display all schedule",
    "display_schedule_delete_many": "Multi-delete schedules",
    "display_schedule_list_dtable": "Datatable schedules",
    "display_schedule_post_disable": "Schedule disable",
    "display_schedule_post_enable": "Schedule enable",
    "display_schedule_delete_one": "Delete one schedule",
    "display_template_post_add": "Add template",
    "display_template_post_edit": "Edit template",
    "display_template_get_templates": "Display templates",
    "display_template_delete_many": "Multidelete templates",
    "display_template_list_dtable": "Datatable templates",
    "display_template_get_template": "Display one template",
    "display_template_delete_one": "Delete one template",
    "none": "No action to show",
    "core_group_add": "Add users group",
    "core_group_delete": "Delete users group",
    "core_group_edit": "Edit users group",
    "core_group_manage_rights": "Manage group permissions",
    "core_group_view": "View users group information",
    "core_user_add": "Add user",
    "core_user_delete": "Delete user",
    "core_user_edit": "Edit user",
    "core_user_view": "View user information",
    "lives_post_add": "Add Live",
    "live_add_config": "Add live configuration",
    "live_calendar": "View live calendar",
    "live_delete": "Delete live",
    "live_edit": "Edit live",
    "live_view": "View live information",
    "live_view_archived": "View archived lives",
    "live_view_offline": "View offline lives",
    "live_view_on_going": "View on-going lives",
    "live_view_to_come": "View to come lives",
    "media_comments_un_validate": "Unvalidate comment",
    "media_comments_validate": "Validate comment",
    "media_video_add": "Add video",
    "media_video_captions": "Manage captions",
    "media_video_delete": "Delete video",
    "media_video_edit": "Edit video",
    "media_video_export_daily_motion": "Export video to DAILYMOTION",
    "media_video_export_links": "View video export links",
    "media_video_export_youtube": "Export video to YOUTUBE",
    "media_video_push": "Push video",
    "media_video_re_upload": "Reupload video",
    "media_video_rich_media": "Manage video rich-media",
    "media_video_toggle_choices": "Toggle video parameters",
    "media_video_un_push": "Unpush video",
    "media_video_upload": "Upload video",
    "media_video_upload_flash_option": "Upload video : Flash option",
    "media_video_upload_ftp_option": "Upload video : Ftp option",
    "media_video_upload_html_option": "Upload video : HTML5 option",
    "media_video_upload_on_hold_option": "Upload video : On hold option",
    "media_video_view_archived": "View archived videos",
    "media_video_view_informations": "View video information",
    "media_video_view_meta": "View video metaData",
    "media_video_view_offline": "View offline videos",
    "media_video_view_on_going": "View on-going videos",
    "media_video_view_to_come": "View to-come videos",
    "parametres_theme_ajout": "Add theme",
    "playlist_add": "Add playlist",
    "playlist_live_add": "Add live playlist",
    "subscription_group_add": "Add subscribers group",
    "subscription_group_delete": "Delete subscribers group",
    "subscription_group_edit": "Edit subscribers group",
    "subscription_group_view": "View subscribers group",
    "subscription_user_add": "Add subscriber",
    "subscription_user_delete": "Delete subscriber",
    "subscription_user_edit": "Edit subscriber",
    "subscription_user_view": "View subscriber information",
    "configuration_server_add_add_server": "Add server",
    "configuration_server_list_list": "Server list",
    "configuration_server_list_delete_servers": "Delete servers",
    "configuration_server_list_mdelete": "Delete server",
    "configuration_server_edit_edit_server": "Modify server",
    "configuration_server_detail_get_server": "Server details",
    "parameters_theme_add_add_theme": "Add theme",
    "parameters_theme_list_list": "Theme list",
    "parameters_theme_list_delete_themes": "Delete themes",
    "parameters_theme_list_mdelete": "Delete theme",
    "parameters_theme_edit_edit_theme": "Modify theme",
    "parameters_theme_detail_get_theme": "Theme details",
    "parameters_canal_add_add_canal": "Add channel",
    "parameters_canal_list_list": "Channel list",
    "parameters_canal_list_delete_canals": "Delete channels",
    "parameters_canal_list_mdelete": "Delete channel",
    "parameters_canal_edit_edit_canal": "Modify channel",
    "parameters_canal_detail_get_canal": "Channel details",
    "parameters_canal_get_url_export": "Export links",
    "parameters_canal_get_storage_servers": "Storage by server",
    "parameters_canal_bitrate_pc_no_api": "Bitrate for PC",
    "parameters_canal_bitrate_mobile_no_api": "Bitrate for mobile",
    "parameters_canal_bitrate_tablet_no_api": "Bitrate for tablet",
    "parameters_canal_reading_protocol_no_api": "Reading protocol",
    "parameters_canal_mbr_no_api": "MBR",
    "parameters_canal_cdn_no_api": "CDN",
    "profiles_user_add_add_user": "Add user",
    "profiles_user_list_list": "User list",
    "profiles_user_list_delete_users": "Delete users",
    "profiles_user_list_mdelete": "Delete user",
    "profiles_user_edit_edit_user": "Modify user",
    "profiles_user_detail_get_user": "User details",
    "profiles_user_enable_user": "Enable user",
    "profiles_user_disable_user": "Disable user",
    "profiles_user_edit_connected_user": "Modify connected user",
    "profiles_group_add_add_group": "Add group",
    "profiles_group_list_list": "Group list",
    "profiles_group_list_delete_groups": "Delete groups",
    "profiles_group_list_mdelete": "Delete group",
    "profiles_group_edit_edit_group": "Modify group",
    "profiles_group_detail_get_group": "Group details",
    "profiles_ip_add_add_ip": "Add IP",
    "profiles_ip_list_list": "IPs list",
    "profiles_ip_list_delete_ips": "Delete IPs",
    "profiles_ip_list_mdelete": "Delete IP",
    "profiles_ip_edit_edit_ip": "Modify IP",
    "profiles_ip_detail_get_ip": "IP details",
    "subscription_group_post_add": "Add subscription group",
    "subscription_group_post_edit": "Modify subscription group",
    "subscription_group_list_dtable": "List subscription group using datatable",
    "subscription_group_delete_group": "Delete subscription group",
    "subscription_group_delete_multi": "Delete subscription groups",
    "subscription_group_get_detail": "Subscription group details",
    "subscription_user_post_add": "Add subscriber",
    "subscription_user_post_edit": "Modify subscriber",
    "subscription_user_list_dtable": "List subscription user using datatable",
    "subscription_user_delete_user": "Delete subscriber",
    "subscription_user_delete_multi": "Delete subscriber",
    "subscription_user_get_detail": "Subscriber details",
    "media_video_caption_post_generate_caption": "Generate caption",
    "rich_media_video_preview_link_by_title": "Preview",
    "media_video_post_add": "Add video",
    "media_video_post_edit": "Edit video",
    "media_video_list_dtable_videos_ongoing": "On going media video list using datatable",
    "media_video_list_dtable_videos_upcoming": "Up coming media video list using datatable",
    "media_video_list_dtable_videos_archived": "Archived media video list using datatable",
    "media_video_list_dtable_videos_offline": "Offline media video list using datatable",
    "media_video_list_dtable_videos_all": "All media video list using datatable",
    "media_video_download_video": "Download video",
    "media_video_delete_video": "Delete video",
    "media_video_multi_delete": "Delete videos",
    "media_video_post_enable_push": "Push video",
    "media_video_post_disable_push": "Unpush video",
    "media_video_get_video_url": "View video information",
    "media_video_get_video_meta_data": "View video metaData",
    "media_video_get_list_steps": "Video chronology",
    "media_video_add_home_page": "Add to home page",
    "media_video_delete_home_page": "Delete from home page",
    "media_video_reupload_no_api": "Edit video source",
    "media_video_preview_no_api": "Preview video",
    "media_video_subscribers_no_api": "Manage subscribers",
    "media_video_audio_no_api": "Audio description",
    "media_video_send_mail_no_api": "Send by mail",
    "media_video_comment_no_api": "Comments",
    "media_video_social_network_embed_no_api": "Social network",
    "media_video_progressif_download_embed_no_api": "Progressive download",
    "media_video_uid_embed_no_api": "UID/ID",
    "media_video_permalien_embed_no_api": "Permalien",
    "media_video_mp4_embed_no_api": "MP4",
    "media_video_embed_no_api": "Embed",
    "media_video_options_embed_no_api": "Options",
    "media_video_contributor_form_no_api": "Contributors",
    "media_video_password_form_no_api": "Secure by password",
    "media_video_secure_form_no_api": "Secure video",
    "media_video_join_files_form_no_api": "Join files",
    "media_video_pasword_form_no_api": "Secure by password",
    "media_video_downloadable_vid_form_no_api": "Downloadable video",
    "media_video_list_by_contributor_no_api": "Video list by contributor",
    "media_video_get_date_last_montage": "Video editor",
    "media_video_post_toggle": "Change video type(online/offline)",
    "media_comments_post_add": "Add media comment",
    "comments_post_edit": "Modify media comment",
    "comments_list_dtable": "Media comments list using datatable",
    "comments_delete_comments": "Delete media comment",
    "comments_delete_multi": "Delete media comments",
    "comments_post_enable": "Enable media comment",
    "comments_post_disable": "Disable media comment",
    "comments_get_detail": "Media comment details",
    "comments_lives_post_edit": "Modify live comment",
    "comments_list_dtable_lives": "Live comments list using datatable",
    "comments_lives_delete": "Delete live comment",
    "comments_delete_multi_lives": "Delete live comments",
    "comments_lives_post_enable": "Enable live comment",
    "comments_lives_post_disable": "Disable live comment",
    "comments_lives_get_detail": "Live comment details",
    "media_home_post_add_home_conf": "Add configuration",
    "media_home_get_home_conf_videos": " Home videos list",
    "media_home_post_disable_push_video": "Put video forward/back ",
    "lives_conf_post_add": "Add live configuration",
    "lives_comments_post_edit": "Modify comment",
    "lives_type_no_api": "Type direct",
    "lives_private_no_api": "Private",
    "lives_active_no_api": "Active",
    "lives_autopub_no_api": "Publish automatically",
    "lives_webinar_no_api": "Webinar",
    "lives_comments_list_dtable": " Comments list using datatable",
    "lives_comments_delete_comments": "Delete comment",
    "lives_comments_delete_multi": "Delete comments",
    "lives_comments_get_detail": "Comment details",
    "lives_post_edit": "Modify live",
    "lives_dtable_lives_endless": "On going live list using datatable",
    "lives_list_dtable_up_coming": "Up coming live list using datatable",
    "lives_dtable_lives_archived": "Archived live list using datatable",
    "lives_dtable_lives_all": "All lives list using datatable",
    "lives_dtable_lives_trash": "List lives in Trash using datatable",
    "lives_delete_live": "Delete live",
    "lives_multi_delete": "Delete lives",
    "lives_get_detail": "Live details",
    "lives_stats_no_api": "Live statistics",
    "lives_diffuser_no_api": "Broadcast webinar",
    "lives_add_screen_share": "Screen share list",
    "lives_conf_no_api": "Configuration before live",
    "lives_fo_subscript_no_api": "Subscribers registration",
    "lives_fo_like_no_api": "Like",
    "lives_fo_sondage_no_api": "Survey",
    "lives_fo_comment_no_api": "Comment",
    "lives_fo_files_share_no_api": "Shared documents",
    "lives_social_media_no_api": "Social networks",
    "lives_password_security_no_api": "Secure live by password",
    "lives_screen_share_no_api": "Screen sharing",
    "lives_fo_chat_no_api": "Chat",
    "lives_rich_media_no_api": "Rich media",
    "lives_associate_files_no_api": "Join files",
    "lives_associate_users_no_api": "Contributors",
    "lives_encoder_no_api": "Encoder",
    "lives_live_info_no_api": "Live information",
    "lives_export_link_no_api": "Export links",
    "lives_comments_no_api": "Live comments",
    "lives_live_detail_no_api": "Live details",
    "lives_send_mail_no_api": "Send invitations",
    "playlist_post_add": "Add playlist",
    "playlist_post_edit": "Modify playlist",
    "playlist_list_dtable": "Playlist list using datatable",
    "playlist_delete_playlist": "Delete playlist",
    "playlist_delete_multi": "Delete playlists",
    "playlist_get_detail": "Playlist details",
    "profiles_user_post_add": "Add user",
    "profiles_user_post_edit_user": "Modify user",
    "profiles_user_list_dtable": "Users list using datatable",
    "profiles_user_profiles_delete_user": "Delete user",
    "profiles_user_delete_multi": "Delete users",
    "profiles_user_put_enable_user": "Enable user",
    "profiles_user_put_disable_user": "Disable user",
    "profiles_user_get_detail": "User details",
    "activate_code_validation_no_api": "Use Authentication with validation code",
    "profiles_user_post_edit_connected_user": "Modify connected user",
    "profiles_group_post_add": "Add group",
    "profiles_group_post_edit": "Modify group",
    "profiles_group_list_dtable": "Group list using datatable",
    "profiles_group_delete_group": "Delete group",
    "profiles_group_delete_multi": "Delete groups",
    "profiles_group_get_detail": "Group details",
    "profiles_ip_post_add": "Add IP",
    "profiles_ip_post_edit": "Modify IP",
    "profiles_ip_list_dtable": "IPS list using datatable",
    "profiles_ip_delete_ips": "Delete IP",
    "profiles_ip_delete_multi": "Delete IPS",
    "profiles_ip_get_detail": "IP details",
    "event_post_add": "Add event live",
    "event_post_edit": "Modify event live",
    "event_list_dtable_events_ongoing": "On going events list using datatable",
    "event_list_dtable_events_upcoming": "Up coming events list using datatable",
    "event_list_dtable_archived": "Archived events list using datatable",
    "event_delete_event_live": "Delete event live",
    "event_delete_multi": "Delete events",
    "event_get_detail": "Event details",
    "configuration_server_post_add": "Add server",
    "configuration_server_post_edit": "Modify server",
    "configuration_server_list_dtable": "Servers list using datatable",
    "configuration_server_delete_server": "Delete server",
    "configuration_server_delete_multi": "Delete servers",
    "configuration_server_get_detail": "Server details",
    "configuration_rmboxgroup_post_add": "Add RmBox group",
    "configuration_rmboxgroup_post_edit": "Modify RmBox group",
    "configuration_rmboxgroup_list_dtable": "RmBox group list using datatable",
    "configuration_rmboxgroup_delete_rmboxgroup": "Delete RmBox group",
    "configuration_rmboxgroup_delete_multi": "Delete RmBox groups",
    "configuration_rmboxgroup_get_detail": "RmBox group details",
    "configuration_rmbox_post_add": "Add RmBox",
    "configuration_rmbox_post_edit": "Modify RmBox",
    "configuration_rmbox_list_dtable": "RmBox list using datatable",
    "configuration_rmbox_delete_rmbox": "Delete RmBox",
    "configuration_rmbox_delete_multi": "Delete RmBoxs",
    "configuration_rmbox_get_detail": "RmBox details",
    "configuration_rmbox_get_reports": "Reports history",
    "configuration_rmbox_show_schedule_no_api": "Show schedule",
    "configuration_rmbox_associate_schedule_no_api": "Associate schedule",
    "configuration_rmboxgroup_associate_schedule_no_api": "Associate schedule",
    "configuration_zone_post_add": "Add zone",
    "configuration_zone_post_edit": "Modify zone",
    "configuration_zone_list_dtable": "Zone list using datatable",
    "configuration_zone_delete_zone": "Delete zone",
    "configuration_zone_delete_multi": "Delete zones",
    "configuration_zone_get_detail": "Zone details",
    "configuration_presets_post_add": "Add preset",
    "configuration_presets_post_edit": "Modify preset",
    "configuration_presets_list_dtable": "Presets list using datatable",
    "configuration_presets_delete_preset": "Delete preset",
    "configuration_presets_delete_multi": "Delete presets",
    "configuration_presets_get_detail": "Preset details",
    "configuration_general_post_add": "Add general",
    "configuration_general_post_edit": "Modify general",
    "configuration_general_list_dtable": "General list using datatable",
    "configuration_general_delete_general": "Delete general",
    "configuration_general_get_detail": "General details",
    "parameters_canal_post_add": "Add channel",
    "parameters_canal_post_edit": "Modify channel",
    "parameters_canal_list_dtable": "Channels list using datatable",
    "parameters_canal_delete_channel": "Delete channel",
    "parameters_canal_delete_multi": "Delete channels",
    "parameters_canal_get_detail": "Channel details",
    "parameters_theme_post_add": "Add theme",
    "parameters_theme_post_edit": "Modify theme",
    "parameters_theme_list_dtable": "Themes list using datatable",
    "parameters_theme_delete_theme": "Delete theme",
    "parameters_theme_delete_multi": "Delete themes",
    "parameters_theme_get_detail": "Theme details",
    "parameters_theme_get_export": "Export links",
    "parameters_advertising_post_add": "Add advertising",
    "parameters_advertising_post_edit": "Modify advertising",
    "parameters_advertising_list_dtable": "Advertising list using datatable",
    "parameters_advertising_delete_advertising": "Delete advertising",
    "parameters_advertising_delete_multi": "Delete advertisings",
    "parameters_advertising_get_detail": "Advertising details",
    "specifics_stations_post_add": "Add station",
    "specifics_stations_post_edit": "Station details",
    "specifics_stations_list_dtable": "Stations list using datatable",
    "specifics_stations_delete_station": "Modify station",
    "specifics_stations_delete_multi": "Delete stations",
    "specifics_stations_get_detail": "Station details",
    "specifics_iptv_post_add": "Add IP-TV",
    "specifics_iptv_post_edit": "Modify IP-TV",
    "specifics_iptv_list_dtable": "IP-TV list using datatable",
    "specifics_iptv_delete_iptv": "Delete IP-TV",
    "specifics_iptv_delete_multi": "Delete IP-TV",
    "specifics_iptv_get_detail": "IP-TV details",
    "sondage_post_add": "Add survey",
    "sondage_post_edit": "Modify survey",
    "sondage_list_dtable": "Surveys list using datatable",
    "sondage_delete_survey": "Delete survey",
    "sondage_delete_multi": "Delete surveys",
    "sondage_get_detail": "Survey details",
    "export_video_get_authentication_code": "Export video to YOUTUBE",
    "export_video_dailymotion_get_login": "Export video to DAILYMOTION",
    "chutier_post_add": "Add chutier",
    "chutier_post_edit": "Modify chutier",
    "chutier_list_dtable": "Chutier list using datatable",
    "metaData_list_dtable": "metaData list using datatable",
    "configuration_list_metaData":"Configuration metaData",
    "chutier_delete_chutier": "Delete chutier",
    "chutier_delete_multi": "Delete chutiers",
    "chutier_get_detail": "Chutier details",
    "param_post_add": "Add param",
    "param_post_edit": "Modify param",
    "param_list_dtable_params": "Param list using datatable",
    "param_delete_param": "Delete param",
    "param_delete_multi": "Delete params",
    "param_get_detail": "Param details",
    "stats_temps_reel_vod_stats_now_all": "Stats vod on real time :Type All",
    "stats_temps_reel_vod_stats_now_internet": "Stats vod on real time :Type Internet",
    "stats_temps_reel_vod_stats_now_intranet": "Stats vod on real time :Type  Intranet",
    "stats_temps_reel_vod_stats_now_internet_mobile": "Stats vod on real time :Type Internet mobile",
    "stats_temps_reel_vod_stats_now_intranet_mobile": "Stats vod on real time :Type Intranet mobile",
    "stats_temps_reel_live_stats_now_all": "Stats lives on real time :Type All",
    "stats_temps_reel_live_stats_now_internet": "Stats lives on real time :Type Internet",
    "stats_temps_reel_live_stats_now_intranet": "Stats lives on real time :Type Intranet",
    "stats_temps_reel_live_stats_now_internet_mobile": "Stats lives on real time :Type Internet mobile",
    "stats_temps_reel_live_stats_now_intranet_mobile": "Stats lives on real time :Type Intranet mobile",


    "stats_temps_reel_podcast_stats_now_all": "Stats podcast on real time :Type All",
    "stats_temps_reel_podcast_stats_now_internet": "Stats podcast on real time :Type Internet",
    "stats_temps_reel_podcast_stats_now_internet_mobile": "Stats podcast on real time :Type Internet mobile",


    "stats_temps_reel_vod_now_hours_all": "Stats vods on real time per hour :Type All",
    "stats_temps_reel_vod_now_hours_internet": "Stats vods on real time per hour :Type Internet",
    "stats_temps_reel_vod_now_hours_intranet": "Stats vods on real time per hour :Type Intranet",
    "stats_temps_reel_vod_now_hours_internet_mobile": "Stats vods on real time per hour :Type Internet mobile",
    "stats_temps_reel_vod_now_hours_intranet_mobile": "Stats vods on real time per hour :Type Intranet mobile",
    "stats_temps_reel_live_now_hours_all": "Stats lives on real time per hour :Type All",
    "stats_temps_reel_live_now_hours_internet": "Stats lives on real time per hour :Type Internet",
    "stats_temps_reel_live_now_hours_intranet": "Stats lives on real time per hour :Type Intranet",
    "stats_temps_reel_live_now_hours_internet_mobile": "Stats lives on real time per hour :Type Internet mobile",
    "stats_temps_reel_live_now_hours_intranet_mobile": "Stats lives on real time per hour :Type Intranet mobile",

    "stats_temps_reel_podcast_now_hours_all": "Stats podcasts on real time per hour :Type All",
    "stats_temps_reel_podcast_now_hours_internet": "Stats podcasts on real time per hour :Type Internet",
    "stats_temps_reel_podcast_now_hours_internet_mobile": "Stats podcasts on real time per hour :Type Internet mobile",

    "stats_temps_reel_vod_stats_now_minute_all": "Stats vods on real time per minute :Type All",
    "stats_temps_reel_vod_stats_now_minute_internet": "Stats vods on real time per minute :Type Internet",
    "stats_temps_reel_vod_stats_now_minute_intranet": "Stats vods on real time per minute :Type Intranet",
    "stats_temps_reel_vod_stats_now_minute_internet_mobile": "Stats vods on real time per minute :Type Internet mobile",
    "stats_temps_reel_vod_stats_now_minute_intranet_mobile": "Stats vods on real time per minute :Type Intranet mobile",
    "stats_temps_reel_live_stats_now_minute_all": "Stats lives on real time per minute :Type All",
    "stats_temps_reel_live_stats_now_minute_internet": "Stats lives on real time per minute :Type Internet",
    "stats_temps_reel_live_stats_now_minute_intranet": "Stats lives on real time per minute :Type Intranet",
    "stats_temps_reel_live_stats_now_minute_internet_mobile": "Stats lives on real time per minute :Type Internet mobile",
    "stats_temps_reel_live_stats_now_minute_intranet_mobile": "Stats lives on real time per minute :Type Intranet mobile",

    "stats_temps_reel_podcast_stats_now_minute_all": "Stats podcasts on real time per minute :Type All",
    "stats_temps_reel_podcast_stats_now_minute_internet": "Stats podcasts on real time per minute :Type Internet",
    "stats_temps_reel_podcast_stats_now_minute_internet_mobile": "Stats podcasts on real time per minute :Type Internet mobile",


    "stats_technologie_vod_os_all": "Stats vods by OS:Type All",
    "stats_technologie_vod_os_internet": "Stats vods by OS:Type Internet",
    "stats_technologie_vod_os_intranet": "Stats vods by OS:Type Intranet",
    "stats_technologie_vod_os_internet_mobile": "Stats vods by OS:Type Internet mobile",
    "stats_technologie_vod_os_intranet_mobile": "Stats vods by OS:Type Intranet mobile",
    "stats_technologie_live_os_all": "Stats lives by OS:Type All",
    "stats_technologie_live_os_internet": "Stats lives by OS:Type Internet",
    "stats_technologie_live_os_intranet": "Stats lives by OS:Type Intranet",
    "stats_technologie_live_os_internet_mobile": "Stats lives by OS:Type Internet mobile",
    "stats_technologie_live_os_intranet_mobile": "Stats lives by OS:Type Intranet mobile",


    "stats_technologie_podcast_os_all": "Stats podcasts by OS:Type All",
    "stats_technologie_podcast_os_internet": "Stats podcasts by OS:Type Internet",
    "stats_technologie_podcast_os_internet_mobile": "Stats podcasts by OS:Type Internet mobile",

    "stats_technologie_vod_browser_all": "Stats vods by navigator :Type All",
    "stats_technologie_vod_browser_internet": "Stats vods by navigator :Type Internet",
    "stats_technologie_vod_browser_intranet": "Stats vods by navigator :Type Intranet",
    "stats_technologie_vod_browser_internet_mobile": "Stats vods by navigator :Type Internet mobile",
    "stats_technologie_vod_browser_intranet_mobile": "Stats vods by navigator :Type Intranet mobile",
    "stats_technologie_live_browser_all": "Stats lives by navigator :Type All",
    "stats_technologie_live_browser_internet": "Stats lives by navigator :Type Internet",
    "stats_technologie_live_browser_intranet": "Stats lives by navigator :Type Intranet",
    "stats_technologie_live_browser_internet_mobile": "Stats lives by navigator :Type Internet mobile",
    "stats_technologie_live_browser_intranet_mobile": "Stats lives by navigator :Type Intranet mobile",

    "stats_technologie_podcast_browser_all": "Stats podcasts by navigator :Type All",
    "stats_technologie_podcast_browser_internet": "Stats podcasts by navigator :Type Internet",
    "stats_technologie_podcast_browser_internet_mobile": "Stats podcasts by navigator :Type Internet mobile",

    "stats_technologie_vod_referrer_all": "Stats vods by referrer :Type All",
    "stats_technologie_vod_referrer_internet": "Stats vods by referrer :Type Internet",
    "stats_technologie_vod_referrer_intranet": "Stats vods by referrer :Type Intranet",
    "stats_technologie_vod_referrer_internet_mobile": "Stats vods by referrer :Type Internet mobile",
    "stats_technologie_vod_referrer_intranet_mobile": "Stats vods by referrer :Type Intranet mobile",
    "stats_technologie_live_referrer_all": "Stats lives by referrer :Type All",
    "stats_technologie_live_referrer_internet": "Stats lives by referrer :Type Internet",
    "stats_technologie_live_referrer_intranet": "Stats lives by referrer :Type Intranet",
    "stats_technologie_live_referrer_internet_mobile": "Stats lives by referrer :Type Internet mobile",
    "stats_technologie_live_referrer_intranet_mobile": "Stats lives by referrer :Type Intranet mobile",

    "stats_technologie_podcast_referrer_all": "Stats podcasts by referrer :Type All",
    "stats_technologie_podcast_referrer_internet": "Stats podcasts by referrer :Type Internet",
    "stats_technologie_podcast_referrer_internet_mobile": "Stats podcasts by referrer :Type Internet mobile",


    "stats_technologie_vod_device_all": "Stats vods by device :Type All",
    "stats_technologie_vod_device_internet": "Stats vods by device :Type Internet",
    "stats_technologie_vod_device_intranet": "Stats vods by device :Type Intranet",
    "stats_technologie_vod_device_internet_mobile": "Stats vods by device :Type Internet mobile",
    "stats_technologie_vod_device_intranet_mobile": "Stats vods by device :Type Intranet mobile",
    "stats_technologie_live_device_all": "Stats lives by device :Type All",
    "stats_technologie_live_device_internet": "Stats lives by device :Type Internet",
    "stats_technologie_live_device_intranet": "Stats lives by device :Type Intranet",
    "stats_technologie_live_device_internet_mobile": "Stats lives by device :Type Internet mobile",
    "stats_technologie_live_device_intranet_mobile": "Stats lives by device :Type Intranet mobile",

    "stats_technologie_podcast_device_all": "Stats podcasts by device :Type All",
    "stats_technologie_podcast_device_internet": "Stats podcasts by device :Type Internet",
    "stats_technologie_podcast_device_internet_mobile": "Stats podcasts by device :Type Internet mobile",

    "stats_mesure_audience_vod_mesure_all": "Stats vods by audience measurement :Type All",
    "stats_mesure_audience_vod_mesure_internet": "Stats vods by audience measurement :Type Internet",
    "stats_mesure_audience_vod_mesure_intranet": "Stats vods by audience measurement :Type Intranet",
    "stats_mesure_audience_vod_mesure_internet_mobile": "Stats vods by audience measurement :Type Internet mobile",
    "stats_mesure_audience_vod_mesure_intranet_mobile": "Stats vods by audience measurement :Type Intranetmobile",
    "stats_mesure_audience_live_mesure_all": "Stats lives by audience measurement :Type All",
    "stats_mesure_audience_live_mesure_internet": "Stats lives by audience measurement :Type Internet",
    "stats_mesure_audience_live_mesure_intranet": "Stats lives by audience measurement :Type Intranet",
    "stats_mesure_audience_live_mesure_internet_mobile": "Stats lives by audience measurement :Type Internet mobile",
    "stats_mesure_audience_live_mesure_intranet_mobile": "Stats lives by audience measurement :Type Intranet mobile",


    "stats_mesure_audience_podcast_mesure_all": "Stats podcasts by audience measurement :Type All",
    "stats_mesure_audience_podcast_mesure_internet": "Stats podcasts by audience measurement :Type Internet",
    "stats_mesure_audience_podcast_mesure_internet_mobile": "Stats podcasts by audience measurement :Type Internet mobile",

    "stats_mesure_audience_vod_standard_deviation_all": "Stats vods by standard deviation :Type All",
    "stats_mesure_audience_vod_standard_deviation_internet": "Stats vods by standard deviation :Type Internet",
    "stats_mesure_audience_vod_standard_deviation_intranet": "Stats vods by standard deviation :Type Intranet",
    "stats_mesure_audience_vod_standard_deviation_internet_mobile": "Stats vods by standard deviation :Type Internet mobile",
    "stats_mesure_audience_vod_standard_deviation_intranet_mobile": "Stats vods by standard deviation :Type Intranet mobile",
    "stats_mesure_audience_live_standard_deviation_all": "Stats lives by standard deviation :Type All",
    "stats_mesure_audience_live_standard_deviation_internet": "v lives by standard deviation :Type Internet",
    "stats_mesure_audience_live_standard_deviation_intranet": "Stats lives by standard deviation :Type Inrtranet",
    "stats_mesure_audience_live_standard_deviation_internet_mobile": "Stats lives by standard deviation :Type Internet mobile",
    "stats_mesure_audience_live_standard_deviation_intranet_mobile": "Stats lives by standard deviation :Type Intranet mobile",

    "stats_mesure_audience_podcast_standard_deviation_all": "Stats podcasts by standard deviation :Type All",
    "stats_mesure_audience_podcast_standard_deviation_internet": "Stats podcasts by standard deviation :Type Internet",
    "stats_mesure_audience_podcast_standard_deviation_internet_mobile": "Stats podcasts by standard deviation :Type Internet mobile",



    "stats_mesure_engagement_vod_mesure_by_ip_all": "Stats vods by ip :Type All",
    "stats_mesure_engagement_vod_mesure_by_ip_internet": "Stats vods by ip :Type Internet",
    "stats_mesure_engagement_vod_mesure_by_ip_intranet": "Stats vods by ip :Type Intranet",
    "stats_mesure_engagement_vod_mesure_by_ip_internet_mobile": "Stats vods by ip :Type Internet mobile",
    "stats_mesure_engagement_vod_mesure_by_ip_intranet_mobile": "Stats vods by ip :Type Intranet mobile",
    "stats_mesure_engagement_live_mesure_by_ip_all": "Stats lives by ip :Type All",
    "stats_mesure_engagement_live_mesure_by_ip_internet": "Stats lives by ip :Type Internet",
    "stats_mesure_engagement_live_mesure_by_ip_intranet": "Stats lives by ip :Type Intranet",
    "stats_mesure_engagement_live_mesure_by_ip_internet_mobile": "Stats lives by ip :Type Internet mobile",
    "stats_mesure_engagement_live_mesure_by_ip_intranet_mobile": "Stats lives by ip :Type Intranet mobile",


    "stats_mesure_engagement_podcast_mesure_by_ip_all": "Stats podcasts by ip :Type All",
    "stats_mesure_engagement_podcast_mesure_by_ip_internet": "Stats podcasts by ip :Type Internet",
    "stats_mesure_engagement_podcast_mesure_by_ip_internet_mobile": "Stats podcasts by ip :Type Internet mobile",


    "stats_mesure_engagement_vod_taux_rebond_all": "Stats vods by Bounce rate :Type All",
    "stats_mesure_engagement_vod_taux_rebond_internet": "Stats vods by Bounce rate :Type Internet",
    "stats_mesure_engagement_vod_taux_rebond_intranet": "Stats vods by Bounce rate :Type Intranet",
    "stats_mesure_engagement_vod_taux_rebond_internet_mobile": "Stats vods by Bounce rate :Type Internet mobile",
    "stats_mesure_engagement_vod_taux_rebond_intranet_mobile": "Stats vods by Bounce rate :Type Intranet mobile",
    "stats_mesure_engagement_live_taux_rebond_all": "Stats lives by Bounce rate :Type All",
    "stats_mesure_engagement_live_taux_rebond_internet": "Stats lives by Bounce rate :Type Internet",
    "stats_mesure_engagement_live_taux_rebond_intranet": "Stats lives by Bounce rate :Type Intranet",
    "stats_mesure_engagement_live_taux_rebond_internet_mobile": "Stats lives by Bounce rate :Type Internet mobile",
    "stats_mesure_engagement_live_taux_rebond_intranet_mobile": "Stats lives by Bounce rate :Type Intranet mobile",

    "stats_mesure_engagement_podcast_taux_rebond_all": "Stats podcasts by Bounce rate :Type All",
    "stats_mesure_engagement_podcast_taux_rebond_internet": "Stats podcasts by Bounce rate :Type Internet",
    "stats_mesure_engagement_podcast_taux_rebond_internet_mobile": "Stats podcasts by Bounce rate :Type Internet mobile",


    "stats_geo_vod_geo_per_pays_all": "Stats vods by country :Type All",
    "stats_geo_vod_geo_per_pays_internet": "Stats vods by country :Type Internet",
    "stats_geo_vod_geo_per_pays_intranet": "Stats vods by country :Type Intranet",
    "stats_geo_vod_geo_per_pays_internet_mobile": "Stats vods by country :Type Internet mobile",
    "stats_geo_vod_geo_per_pays_intranet_mobile": "Stats vods by country :Type Intranet mobile",
    "stats_geo_live_geo_per_pays_all": "Stats lives by country :Type All",
    "stats_geo_live_geo_per_pays_internet": "Stats lives by country :Type Internet",
    "stats_geo_live_geo_per_pays_intranet": "Stats lives by country :Type Intranet",
    "stats_geo_live_geo_per_pays_internet_mobile": "Stats lives by country :Type Internet mobile",
    "stats_geo_live_geo_per_pays_intranet_mobile": "Stats lives by country :Type Intranet mobile",

    "stats_geo_podcast_geo_per_pays_all": "Stats podcasts by country :Type All",
    "stats_geo_podcast_geo_per_pays_internet": "Stats podcasts by country :Type Internet",
    "stats_geo_podcast_geo_per_pays_internet_mobile": "Stats podcasts by country :Type Internet mobile",


    "stats_engagement_vod_duree_per_visite_all": "Stats vods by duration :Type All",
    "stats_engagement_vod_duree_per_visite_internet": "Stats vods by duration :Type Internet",
    "stats_engagement_vod_duree_per_visite_intranet": "Stats vods by duration :Type Intranet",
    "stats_engagement_vod_duree_per_visite_internet_mobile": "Stats vods by duration :Type Internet mobile",
    "stats_engagement_vod_duree_per_visite_intranet_mobile": "Stats vods by duration :Type Intranet mobile",
    "stats_engagement_live_duree_per_visite_all": "Stats lives by duration :Type All",
    "stats_engagement_live_duree_per_visite_internet": "Stats lives by duration :Type Internet",
    "stats_engagement_live_duree_per_visite_intranet": "Stats lives by duration :Type Intranet",
    "stats_engagement_live_duree_per_visite_internet_mobile": "Stats lives by duration :Type Internet mobile",
    "stats_engagement_live_duree_per_visite_intranet_mobile": "Stats lives by duration :Type Intranet mobile",

    "stats_engagement_podcast_duree_per_visite_all": "Stats podcasts by duration :Type All",
    "stats_engagement_podcast_duree_per_visite_internet": "Stats podcasts by duration :Type Internet",
    "stats_engagement_podcast_duree_per_visite_internet_mobile": "Stats podcasts by duration :Type Internet mobile",


    "stats_engagement_vod_most_popular_all": "Stats vods by popularity :Type All",
    "stats_engagement_vod_most_popular_internet": "Stats vods by popularity :Type Internet",
    "stats_engagement_vod_most_popular_intranet": "Stats vods by popularity :Type Intranet",
    "stats_engagement_vod_most_popular_internet_mobile": "Stats vods by popularity :Type Internet mobile",
    "stats_engagement_vod_most_popular_intranet_mobile": "Stats vods by popularity :Type Intranet mobile",
    "stats_engagement_live_most_popular_all": "Stats lives by popularity :Type All",
    "stats_engagement_live_most_popular_internet": "Stats lives by popularity :Type Internet",
    "stats_engagement_live_most_popular_intranet": "Stats lives by popularity :Type Intranet",
    "stats_engagement_live_most_popular_internet_mobile": "Stats lives by popularity :Type Internet mobile",
    "stats_engagement_live_most_popular_intranet_mobile": "Stats lives by popularity :Type Intranet mobile",

    "stats_engagement_podcast_most_popular_all": "Stats podcasts by popularity :Type All",
    "stats_engagement_podcast_most_popular_internet": "Stats podcasts by popularity :Type Internet",
    "stats_engagement_podcast_most_popular_internet_mobile": "Stats podcasts by popularity :Type Internet mobile",


    "stats_engagement_vod_visits_per_ip_all": "Stats vods by IPs :Type All",
    "stats_engagement_vod_visits_per_ip_internet": "Stats vods by IPs :Type Internet",
    "stats_engagement_vod_visits_per_ip_intranet": "Stats vods by IPs :Type Intranet",
    "stats_engagement_vod_visits_per_ip_internet_mobile": "Stats vods by IPs :Type Internet mobile",
    "stats_engagement_vod_visits_per_ip_intranet_mobile": "Stats vods by IPs :Type Intranet mobile",
    "stats_engagement_live_visits_per_ip_all": "Stats lives by IPs :Type All",
    "stats_engagement_live_visits_per_ip_internet": "Stats lives by IPs :Type Internet",
    "stats_engagement_live_visits_per_ip_intranet": "Stats lives by IPs :Type Intranet",
    "stats_engagement_live_visits_per_ip_internet_mobile": "Stats lives by IPs :Type Internet mobile",
    "stats_engagement_live_visits_per_ip_intranet_mobile": "Stats lives by IPs :Type Intranet mobile",

    "stats_engagement_podcast_visits_per_ip_all": "Stats podcasts by IPs :Type All",
    "stats_engagement_podcast_visits_per_ip_internet": "Stats podcasts by IPs :Type Internet",
    "stats_engagement_podcast_visits_per_ip_internet_mobile": "Stats podcasts by IPs :Type Internet mobile",


    "stats_audience_vod_audience_all": "Stats vods by audience :Type All",
    "stats_audience_vod_audience_internet": "Stats vods by audience :Type Internet",
    "stats_audience_vod_audience_intranet": "Stats vods by audience :Type Intranet",
    "stats_audience_vod_audience_internet_mobile": "Stats vods by audience :Type Internet mobile",
    "stats_audience_vod_audience_intranet_mobile": "Stats vods by audience :Type Intranet mobile",
    "stats_audience_live_audience_all": "Stats lives by audience :Type All",
    "stats_audience_live_audience_internet": "Stats lives by audience :Type Internet",
    "stats_audience_live_audience_intranet": "Stats lives by audience :Type Intranet",
    "stats_audience_live_audience_internet_mobile": "Stats lives by audience :Type Internet mobile",
    "stats_audience_live_audience_intranet_mobile": "Stats lives by audience :Type Intranet mobile",

    "stats_audience_podcast_audience_all": "Stats podcasts by audience :Type All",
    "stats_audience_podcast_audience_internet": "Stats podcasts by audience :Type Internet",
    "stats_audience_podcast_audience_internet_mobile": "Stats podcasts by audience :Type Internet mobile",


    "stats_audience_vod_duree_all": "Stats vods by duration :Type All",
    "stats_audience_vod_duree_internet": "Stats vods by duration :Type Internet",
    "stats_audience_vod_duree_intranet": "Stats vods by duration :Type Intranet",
    "stats_audience_vod_duree_internet_mobile": "Stats vods by duration :Type Internet mobile",
    "stats_audience_vod_duree_intranet_mobile": "Stats vods by duration :Type Intranet mobile",
    "stats_audience_live_duree_all": "Stats lives by duration :Type All",
    "stats_audience_live_duree_internet": "Stats lives by duration :Type Internet",
    "stats_audience_live_duree_intranet": "Stats lives by duration :Type Intranet",
    "stats_audience_live_duree_internet_mobile": "Stats lives by duration :Type Internet mobile",
    "stats_audience_live_duree_intranet_mobile": "Stats lives by duration :Type Intranet mobile",

    "stats_audience_podcast_duree_all": "Stats podcasts by duration :Type All",
    "stats_audience_podcast_duree_internet": "Stats podcasts by duration :Type Internet",
    "stats_audience_podcast_duree_internet_mobile": "Stats podcasts by duration :Type Internet mobile",


    "stats_vod_all": "Stats vods",
    "stats_podcast_all": "Stats podcasts",
    "stats_vod_audience": "Stats vods : Audience",
    "stats_podcast_audience": "Stats podcasts : Audience",
    "stats_vod_technologie": "Stats vods: Technology",
    "stats_podcast_technologie": "Stats podcasts: Technology",
    "stats_vod_engagement": "Stats vods: Engagement",
    "stats_podcast_engagement": "Stats podcasts: Engagement",
    "stats_vod_mobile": "Stats vods: Mobile",
    "stats_podcast_mobile": "Stats podcasts: Mobile",
    "stats_vod_temp_reel": "Stats vods: Real time",
    "stats_podcast_temp_reel": "Stats podcasts: Real time",
    "stats_live_all": "Stats lives",
    "stats_live_audience": "Stats lives: Audience",
    "stats_live_technologie": "Stats lives: Technology",
    "stats_live_engagement": "Stats lives: Engagement",
    "stats_live_mobile": "Stats lives: Mobile",
    "stats_live_temp_reel": "Stats lives: Real time",
    "stats_vod_by_id_all": "Stats vods by id",
    "stats_podcast_by_id_all": "Stats podcasts by id",
    "stats_vod_by_id_audience": "Stats vods by id : Audience",
    "stats_podcast_by_id_audience": "Stats podcasts by id : Audience",
    "stats_vod_by_id_technologie": "Stats vods by id : Technology",
    "stats_podcast_by_id_technologie": "Stats podcasts by id : Technology",
    "stats_vod_by_id_engagement": "Stats vods by id : Engagement",
    "stats_podcast_by_id_engagement": "Stats podcasts by id : Engagement",
    "stats_vod_by_id_mobile": "Stats vods by id : Mobile",
    "stats_podcast_by_id_mobile": "Stats podcasts by id : Mobile",
    "stats_vod_by_id_temp_reel": "Stats vods by id : Real time",
    "stats_podcast_by_id_temp_reel": "Stats podcasts by id : Real time",
    "stats_live_by_id_all": "Stats lives by id",
    "stats_live_by_id_audience": "Stats lives by id:  Audience",
    "stats_live_by_id_technologie": "Stats lives by id : Technology",
    "stats_live_by_id_engagement": "Stats lives by id : Engagement",
    "stats_live_by_id_mobile": "Stats lives by id :  Mobile",
    "stats_live_by_id_temp_reel": "Stats lives by id :  Real time",
    "stats_engagement": "Stats engagements",
    "stats_dashboard_dashboard_no_api_route": "Stats dashboard",
    "stats_acces_list_acces": "Access list",
    "stats_acces_detail": "Access details",
    "stats_bande_passante_post_bande_passante": "Stats bandwidth",
    "stats_storage_post_storage": "Stats storage",
    "dashboard_most_popular": "Most popular",
    "dashboard_page": "Dashboard page",
    "specifics_directions_post_add": "Add direction",
    "specifics_directions_post_edit": "Edit direction",
    "specifics_directions_list_dtable_direction": "Direction list",
    "specifics_directions_delete_direction": "Delete direction",
    "specifics_directions_delete_multi": "Delete directions",
    "specifics_directions_get_detail": "Direction details",
    "parameters_canal_configuration_canal_no_api": "Channel configuration",
    "questions_quiz_get_responses": "List of questions and quiz",
    "podcast_post_add": "Add podcast",
    "podcast_post_edit": "Edit podcast",
    "podcast_list_dtable": "Podcast list",
    "podcast_get_detail": "Podcast details",
    "podcast_delete_podcast": "Delete podcast",
    "podcast_multi_delete": "Delete podcasts",
    "podcast_url_export": "Podcast export",
    "referrers_list_dtable": "Referrer list",
    "referrers_post_add": "Add referrer",
    "referrers_post_edit": "Edit referrer",
    "referrers_delete": "Delete referrer",
    "referrers_delete_multi": "Delete referrers",
    "display_schedule_get_reload": "Refresh the display on the box(Schedule)",
    "configuration_rmbox_get_reload": "Refresh the display on the box(RmBox)",
    "stats_mooc_course_no_api": "Stats course",
    "stats_mooc_performance_no_api": "Stats performance",
    "stats_mooc_video_no_api": "Stats videos",
    "stats_mooc_mooc_total_number_registrations": "Total number of registrations",
    "stats_mooc_mooc_number_on_going_registrations": "Number of ongoing registrations",
    "stats_mooc_mooc_increase_in_registrations_in_the_last_week": "Increase in registrations in the last week",
    "stats_mooc_mooc_number_learners_tried_problem": "Total number of problem tester",
    "stats_mooc_mooc_number_active_learners": "Total number of actif learners",
    "stats_mooc_mooc_watching_videos_learners": "Total number of video watchers",
    "stats_mooc_list_dtable_parameters_themes_mooc": "Stats by theme",
    "stats_mooc_mooc_number_correct_incorrect_responses": "Mooc performance",
    "stats_mooc_participation_of_learners": "Graph of participation of learners",
    "stats_mooc_mooc_number_complete_incomplete_video": "Mooc views",
    "mooc_delete_multi": "Delete  MOOCs",
    "mooc_get_detail": "Detail MOOC",
    "mooc_post_add": " Add MOOC",
    "mooc_post_edit": "Edit MOOC",
    "mooc_list_dtable_params": "List of MOOCs",
    "mooc_delete_param": "Delete  MOOC",
    "configuration_newss_post_add": "Add news",
    "configuration_newss_post_edit": "Edit news",
    "configuration_newss_list_dtable_news": "List of news",
    "configuration_newss_delete_new": "Delete news",
    "configuration_newss_multi_delete": "Multi delete news",
    "configuration_newss_get_detail": "Details news",
    "event_export_no_api": "Export links",
    "stats_list_videos_list_dtable_videos_stats": "Video list datatable",
    "stats_export_export_no_api": "Export stats",
    "configuration_zone_stat_zone_no_api": "Zone stats",
    "profiles_user_edit_password_no_api": "Edit password",
    "profiles_group_permission_no_api": "Manage Permissions",
    "playlist_playlist_link": "Preview playlist",
    "event_stats_no_api": "Event stats",
    "support_documentation_no_api": "User Guide ",
    "support_key_no_api": "Api key",
    "player_parameters_list_no_api": "Parameter player list ",
    "media_video_transcription_auto_no_api": "Automatic transcription",
    "media_video_transcription_reload_no_api": "Transcription with proofreading",
    "configuration_rmbox_list_intervention_no_api": "Intervention list",
    "configuration_rmbox_add_intervention_no_api": "Add intervention",
    "configuration_rmbox_delete_intervention_no_api": "Delete intervention",
    "configuration_rmbox_edit_intervention_no_api": "Edit intervention",

    "media_video_list_comments": "See comment list",
    "media_video_skin": "Change default skin player",
    "media_video_list_show_date": "Show start and end dates",


    "stats_temps_reel_vod_by_id_stats_now_all": "Stats vod on real time and by id :Type All",
    "stats_temps_reel_vod_by_id_stats_now_internet": "Stats vod on real time and by id :Type Internet",
    "stats_temps_reel_vod_by_id_stats_now_intranet": "Stats vod on real time and by id :Type  Intranet",
    "stats_temps_reel_vod_by_id_stats_now_internet_mobile": "Stats vod on real timeand by id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_stats_now_intranet_mobile": "Stats vod on real time and by id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_stats_now_all": "Stats lives on real time and by id :Type All",
    "stats_temps_reel_live_by_id_stats_now_internet": "Stats lives on real time and by id :Type Internet",
    "stats_temps_reel_live_by_id_stats_now_intranet": "Stats lives on real time and by id :Type Intranet",
    "stats_temps_reel_live_by_id_stats_now_internet_mobile": "Stats lives on real time and by id :Type Internet mobile",
    "stats_temps_reel_live_by_id_stats_now_intranet_mobile": "Stats lives on real time and by id :Type Intranet mobile",

    "stats_temps_reel_podcast_by_id_stats_now_all": "Stats podcast on real time and by id :Type All",
    "stats_temps_reel_podcast_by_id_stats_now_internet": "Stats podcast on real time and by id :Type Internet",
    "stats_temps_reel_podcast_by_id_stats_now_internet_mobile": "Stats podcast on real timeand by id :Type Internet mobile",

    "stats_temps_reel_vod_by_id_now_hours_all": "Stats vods on real time per hour and by id :Type All",
    "stats_temps_reel_vod_by_id_now_hours_internet": "Stats vods on real time per hour and by id :Type Internet",
    "stats_temps_reel_vod_by_id_now_hours_intranet": "Stats vods on real time per hour and by id :Type Intranet",
    "stats_temps_reel_vod_by_id_now_hours_internet_mobile": "Stats vods on real time per hour and by id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_now_hours_intranet_mobile": "Stats vods on real time per hour and by id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_now_hours_all": "Stats lives on real time per hour and by id :Type All",
    "stats_temps_reel_live_by_id_now_hours_internet": "Stats lives on real time per hour and by id :Type Internet",
    "stats_temps_reel_live_by_id_now_hours_intranet": "Stats lives on real time per hour and by id :Type Intranet",
    "stats_temps_reel_live_by_id_now_hours_internet_mobile": "Stats lives on real time per hour and by id :Type Internet mobile",
    "stats_temps_reel_live_by_id_now_hours_intranet_mobile": "Stats lives on real time per hour and by id :Type Intranet mobile",

    "stats_temps_reel_podcast_by_id_now_hours_all": "Stats podcasts on real time per hour and by id :Type All",
    "stats_temps_reel_podcast_by_id_now_hours_internet": "Stats podcasts on real time per hour and by id :Type Internet",
    "stats_temps_reel_podcast_by_id_now_hours_internet_mobile": "Stats podcasts on real time per hour and by id :Type Internet mobile",

    "stats_temps_reel_vod_by_id_stats_now_minute_all": "Stats vods on real time per minute and by id :Type All",
    "stats_temps_reel_vod_by_id_stats_now_minute_internet": "Stats vods on real time per minute and by id :Type Internet",
    "stats_temps_reel_vod_by_id_stats_now_minute_intranet": "Stats vods on real time per minute and by id :Type Intranet",
    "stats_temps_reel_vod_by_id_stats_now_minute_internet_mobile": "Stats vods on real time per minute and by id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_stats_now_minute_intranet_mobile": "Stats vods on real time per minute and by id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_stats_now_minute_all": "Stats lives on real time per minute and by id :Type All",
    "stats_temps_reel_live_by_id_stats_now_minute_internet": "Stats lives on real time per minute and by id :Type Internet",
    "stats_temps_reel_live_by_id_stats_now_minute_intranet": "Stats lives on real time per minute and by id :Type Intranet",
    "stats_temps_reel_live_by_id_stats_now_minute_internet_mobile": "Stats lives on real time per minute and by id :Type Internet mobile",
    "stats_temps_reel_live_by_id_stats_now_minute_intranet_mobile": "Stats lives on real time per minute and by id :Type Intranet mobile",

    "stats_temps_reel_podcast_by_id_stats_now_minute_all": "Stats podcasts on real time per minute and by id :Type All",
    "stats_temps_reel_podcast_by_id_stats_now_minute_internet": "Stats podcasts on real time per minute and by id :Type Internet",
    "stats_temps_reel_podcast_by_id_stats_now_minute_internet_mobile": "Stats podcasts on real time per minute and by id :Type Internet mobile",


    "stats_technologie_vod_by_id_os_all": "Stats vods by OS and by id ::Type All",
    "stats_technologie_vod_by_id_os_internet": "Stats vods by OS and by id ::Type Internet",
    "stats_technologie_vod_by_id_os_intranet": "Stats vods by OSand by id : :Type Intranet",
    "stats_technologie_vod_by_id_os_internet_mobile": "Stats vods by OS and by id ::Type Internet mobile",
    "stats_technologie_vod_by_id_os_intranet_mobile": "Stats vods by OS and by id ::Type Intranet mobile",
    "stats_technologie_live_by_id_os_all": "Stats lives by OS and by id ::Type All",
    "stats_technologie_live_by_id_os_internet": "Stats lives by OS and by id ::Type Internet",
    "stats_technologie_live_by_id_os_intranet": "Stats lives by OS and by id ::Type Intranet",
    "stats_technologie_live_by_id_os_internet_mobile": "Stats lives by OS and by id ::Type Internet mobile",
    "stats_technologie_live_by_id_os_intranet_mobile": "Stats lives by OS and by id ::Type Intranet mobile",

    "stats_technologie_podcast_by_id_os_all": "Stats podcasts by OS and by id ::Type All",
    "stats_technologie_podcast_by_id_os_internet": "Stats podcasts by OS and by id ::Type Internet",
    "stats_technologie_podcast_by_id_os_internet_mobile": "Stats podcasts by OS and by id ::Type Internet mobile",


    "stats_technologie_vod_by_id_browser_all": "Stats vods by navigator and by id :Type All",
    "stats_technologie_vod_by_id_browser_internet": "Stats vods by navigator and by id :Type Internet",
    "stats_technologie_vod_by_id_browser_intranet": "Stats vods by navigator and by id :Type Intranet",
    "stats_technologie_vod_by_id_browser_internet_mobile": "Stats vods by navigator and by id :Type Internet mobile",
    "stats_technologie_vod_by_id_browser_intranet_mobile": "Stats vods by navigator and by id :Type Intranet mobile",
    "stats_technologie_live_by_id_browser_all": "Stats lives by navigator and by id :Type All",
    "stats_technologie_live_by_id_browser_internet": "Stats lives by navigator and by id :Type Internet",
    "stats_technologie_live_by_id_browser_intranet": "Stats lives by navigator and by id :Type Intranet",
    "stats_technologie_live_by_id_browser_internet_mobile": "Stats lives by navigator and by id :Type Internet mobile",
    "stats_technologie_live_by_id_browser_intranet_mobile": "Stats lives by navigator and by id :Type Intranet mobile",

    "stats_technologie_podcast_by_id_browser_all": "Stats podcasts by navigator and by id :Type All",
    "stats_technologie_podcast_by_id_browser_internet": "Stats podcasts by navigator and by id :Type Internet",
    "stats_technologie_podcast_by_id_browser_internet_mobile": "Stats podcasts by navigator and by id :Type Internet mobile",

    "stats_technologie_vod_by_id_referrer_all": "Stats vods by referrer and by id :Type All",
    "stats_technologie_vod_by_id_referrer_internet": "Stats vods by referrer and by id :Type Internet",
    "stats_technologie_vod_by_id_referrer_intranet": "Stats vods by referrer and by id :Type Intranet",
    "stats_technologie_vod_by_id_referrer_internet_mobile": "Stats vods by referrer and by id :Type Internet mobile",
    "stats_technologie_vod_by_id_referrer_intranet_mobile": "Stats vods by referrer and by id :Type Intranet mobile",
    "stats_technologie_live_by_id_referrer_all": "Stats lives by referrer and by id :Type All",
    "stats_technologie_live_by_id_referrer_internet": "Stats lives by referrer and by id :Type Internet",
    "stats_technologie_live_by_id_referrer_intranet": "Stats lives by referrer and by id :Type Intranet",
    "stats_technologie_live_by_id_referrer_internet_mobile": "Stats lives by referrer and by id :Type Internet mobile",
    "stats_technologie_live_by_id_referrer_intranet_mobile": "Stats lives by referrer and by id :Type Intranet mobile",

    "stats_technologie_podcast_by_id_referrer_all": "Stats podcasts by referrer and by id :Type All",
    "stats_technologie_podcast_by_id_referrer_internet": "Stats podcasts by referrer and by id :Type Internet",
    "stats_technologie_podcast_by_id_referrer_internet_mobile": "Stats podcasts by referrer and by id :Type Internet mobile",

    "stats_technologie_vod_by_id_device_all": "Stats vods by device and by id :Type All",
    "stats_technologie_vod_by_id_device_internet": "Stats vods by device and by id :Type Internet",
    "stats_technologie_vod_by_id_device_intranet": "Stats vods by device and by id :Type Intranet",
    "stats_technologie_vod_by_id_device_internet_mobile": "Stats vods by device and by id :Type Internet mobile",
    "stats_technologie_vod_by_id_device_intranet_mobile": "Stats vods by device and by id :Type Intranet mobile",
    "stats_technologie_live_by_id_device_all": "Stats lives by device and by id :Type All",
    "stats_technologie_live_by_id_device_internet": "Stats lives by device and by id :Type Internet",
    "stats_technologie_live_by_id_device_intranet": "Stats lives by device and by id :Type Intranet",
    "stats_technologie_live_by_id_device_internet_mobile": "Stats lives by device and by id :Type Internet mobile",
    "stats_technologie_live_by_id_device_intranet_mobile": "Stats lives by device and by id :Type Intranet mobile",

    "stats_technologie_podcast_by_id_device_all": "Stats podcasts by device and by id :Type All",
    "stats_technologie_podcast_by_id_device_internet": "Stats podcasts by device and by id :Type Internet",
    "stats_technologie_podcast_by_id_device_internet_mobile": "Stats podcasts by device and by id :Type Internet mobile",

    "stats_mesure_audience_vod_by_id_mesure_all": "Stats vods by audience measurement and by id :Type All",
    "stats_mesure_audience_vod_by_id_mesure_internet": "Stats vods by audience measurement and by id :Type Internet",
    "stats_mesure_audience_vod_by_id_mesure_intranet": "Stats vods by audience measurement and by id :Type Intranet",
    "stats_mesure_audience_vod_by_id_mesure_internet_mobile": "Stats vods by audience measurement and by id :Type Internet mobile",
    "stats_mesure_audience_vod_by_id_mesure_intranet_mobile": "Stats vods by audience measurement and by id :Type Intranetmobile",
    "stats_mesure_audience_live_by_id_mesure_all": "Stats lives by audience measurement and by id :Type All",
    "stats_mesure_audience_live_by_id_mesure_internet": "Stats lives by audience measurement and by id :Type Internet",
    "stats_mesure_audience_live_by_id_mesure_intranet": "Stats lives by audience measurement and by id :Type Intranet",
    "stats_mesure_audience_live_by_id_mesure_internet_mobile": "Stats lives by audience measurement and by id :Type Internet mobile",
    "stats_mesure_audience_live_by_id_mesure_intranet_mobile": "Stats lives by audience measurement and by id :Type Intranet mobile",

    "stats_mesure_audience_podcast_by_id_mesure_all": "Stats podcasts by audience measurement and by id :Type All",
    "stats_mesure_audience_podcast_by_id_mesure_internet": "Stats podcasts by audience measurement and by id :Type Internet",
    "stats_mesure_audience_podcast_by_id_mesure_internet_mobile": "Stats podcasts by audience measurement and by id :Type Internet mobile",

    "stats_mesure_audience_vod_by_id_standard_deviation_all": "Stats vods by standard deviation and by id :Type All",
    "stats_mesure_audience_vod_by_id_standard_deviation_internet": "Stats vods by standard deviation and by id :Type Internet",
    "stats_mesure_audience_vod_by_id_standard_deviation_intranet": "Stats vods by standard deviation and by id :Type Intranet",
    "stats_mesure_audience_vod_by_id_standard_deviation_internet_mobile": "Stats vods by standard deviation and by id :Type Internet mobile",
    "stats_mesure_audience_vod_by_id_standard_deviation_intranet_mobile": "Stats vods by standard deviation and by id :Type Intranet mobile",
    "stats_mesure_audience_live_by_id_standard_deviation_all": "Stats lives by standard deviation and by id :Type All",
    "stats_mesure_audience_live_by_id_standard_deviation_internet": "v lives by standard deviation and by id :Type Internet",
    "stats_mesure_audience_live_by_id_standard_deviation_intranet": "Stats lives by standard deviation and by id :Type Inrtranet",
    "stats_mesure_audience_live_by_id_standard_deviation_internet_mobile": "Stats lives by standard deviation and by id :Type Internet mobile",
    "stats_mesure_audience_live_by_id_standard_deviation_intranet_mobile": "Stats lives by standard deviation and by id :Type Intranet mobile",

    "stats_mesure_audience_podcast_by_id_standard_deviation_all": "Stats podcasts by standard deviation and by id :Type All",
    "stats_mesure_audience_podcast_by_id_standard_deviation_internet": "Stats podcasts by standard deviation and by id :Type Internet",
    "stats_mesure_audience_podcast_by_id_standard_deviation_internet_mobile": "Stats podcasts by standard deviation and by id :Type Internet mobile",

    "stats_mesure_engagement_vod_by_id_mesure_by_ip_all": "Stats vods by ip and by id :Type All",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_internet": "Stats vods by ip and by id :Type Internet",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_intranet": "Stats vods by ip and by id :Type Intranet",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_internet_mobile": "Stats vods by ip and by id :Type Internet mobile",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_intranet_mobile": "Stats vods by ip and by id :Type Intranet mobile",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_all": "Stats lives by ip and by id :Type All",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_internet": "Stats lives by ip and by id :Type Internet",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_intranet": "Stats lives by ip and by id :Type Intranet",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_internet_mobile": "Stats lives by ip and by id :Type Internet mobile",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_intranet_mobile": "Stats lives by ip and by id :Type Intranet mobile",

    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_all": "Stats podcasts by ip and by id :Type All",
    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_internet": "Stats podcasts by ip and by id :Type Internet",
    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_internet_mobile": "Stats podcasts by ip and by id :Type Internet mobile",

    "stats_mesure_engagement_vod_by_id_taux_rebond_all": "Stats vods by Bounce rate and by id :Type All",
    "stats_mesure_engagement_vod_by_id_taux_rebond_internet": "Stats vods by Bounce rate and by id :Type Internet",
    "stats_mesure_engagement_vod_by_id_taux_rebond_intranet": "Stats vods by Bounce rate and by id :Type Intranet",
    "stats_mesure_engagement_vod_by_id_taux_rebond_internet_mobile": "Stats vods by Bounce rate and by id :Type Internet mobile",
    "stats_mesure_engagement_vod_by_id_taux_rebond_intranet_mobile": "Stats vods by Bounce rate and by id :Type Intranet mobile",
    "stats_mesure_engagement_live_by_id_taux_rebond_all": "Stats lives by Bounce rate and by id :Type All",
    "stats_mesure_engagement_live_by_id_taux_rebond_internet": "Stats lives by Bounce rate and by id :Type Internet",
    "stats_mesure_engagement_live_by_id_taux_rebond_intranet": "Stats lives by Bounce rate and by id :Type Intranet",
    "stats_mesure_engagement_live_by_id_taux_rebond_internet_mobile": "Stats lives by Bounce rate and by id :Type Internet mobile",
    "stats_mesure_engagement_live_by_id_taux_rebond_intranet_mobile": "Stats lives by Bounce rate and by id :Type Intranet mobile",

    "stats_mesure_engagement_podcast_by_id_taux_rebond_all": "Stats podcasts by Bounce rate and by id :Type All",
    "stats_mesure_engagement_podcast_by_id_taux_rebond_internet": "Stats podcasts by Bounce rate and by id :Type Internet",
    "stats_mesure_engagement_podcast_by_id_taux_rebond_internet_mobile": "Stats podcasts by Bounce rate and by id :Type Internet mobile",

    "stats_geo_vod_by_id_geo_per_pays_all": "Stats vods by country and by id :Type All",
    "stats_geo_vod_by_id_geo_per_pays_internet": "Stats vods by country and by id :Type Internet",
    "stats_geo_vod_by_id_geo_per_pays_intranet": "Stats vods by country and by id :Type Intranet",
    "stats_geo_vod_by_id_geo_per_pays_internet_mobile": "Stats vods by country and by id :Type Internet mobile",
    "stats_geo_vod_by_id_geo_per_pays_intranet_mobile": "Stats vods by country and by id :Type Intranet mobile",
    "stats_geo_live_by_id_geo_per_pays_all": "Stats lives by country and by id :Type All",
    "stats_geo_live_by_id_geo_per_pays_internet": "Stats lives by country and by id :Type Internet",
    "stats_geo_live_by_id_geo_per_pays_intranet": "Stats lives by country and by id :Type Intranet",
    "stats_geo_live_by_id_geo_per_pays_internet_mobile": "Stats lives by country and by id :Type Internet mobile",
    "stats_geo_live_by_id_geo_per_pays_intranet_mobile": "Stats lives by country and by id :Type Intranet mobile",

    "stats_geo_podcast_by_id_geo_per_pays_all": "Stats podcasts by country and by id :Type All",
    "stats_geo_podcast_by_id_geo_per_pays_internet": "Stats podcasts by country and by id :Type Internet",
    "stats_geo_podcast_by_id_geo_per_pays_internet_mobile": "Stats podcasts by country and by id :Type Internet mobile",


    "stats_engagement_vod_by_id_duree_per_visite_all": "Stats vods by duration and by id :Type All",
    "stats_engagement_vod_by_id_duree_per_visite_internet": "Stats vods by duration and by id :Type Internet",
    "stats_engagement_vod_by_id_duree_per_visite_intranet": "Stats vods by duration and by id :Type Intranet",
    "stats_engagement_vod_by_id_duree_per_visite_internet_mobile": "Stats vods by duration and by id :Type Internet mobile",
    "stats_engagement_vod_by_id_duree_per_visite_intranet_mobile": "Stats vods by duration and by id :Type Intranet mobile",
    "stats_engagement_live_by_id_duree_per_visite_all": "Stats lives by duration and by id :Type All",
    "stats_engagement_live_by_id_duree_per_visite_internet": "Stats lives by duration and by id :Type Internet",
    "stats_engagement_live_by_id_duree_per_visite_intranet": "Stats lives by duration and by id :Type Intranet",
    "stats_engagement_live_by_id_duree_per_visite_internet_mobile": "Stats lives by duration and by id :Type Internet mobile",
    "stats_engagement_live_by_id_duree_per_visite_intranet_mobile": "Stats lives by duration and by id :Type Intranet mobile",

    "stats_engagement_podcast_by_id_duree_per_visite_all": "Stats podcasts by duration and by id :Type All",
    "stats_engagement_podcast_by_id_duree_per_visite_internet": "Stats podcasts by duration and by id :Type Internet",
    "stats_engagement_podcast_by_id_duree_per_visite_internet_mobile": "Stats podcasts by duration and by id :Type Internet mobile",

    "stats_engagement_vod_by_id_most_popular_all": "Stats vods by popularity and by id :Type All",
    "stats_engagement_vod_by_id_most_popular_internet": "Stats vods by popularity and by id :Type Internet",
    "stats_engagement_vod_by_id_most_popular_intranet": "Stats vods by popularity and by id :Type Intranet",
    "stats_engagement_vod_by_id_most_popular_internet_mobile": "Stats vods by popularity and by id :Type Internet mobile",
    "stats_engagement_vod_by_id_most_popular_intranet_mobile": "Stats vods by popularity and by id :Type Intranet mobile",
    "stats_engagement_live_by_id_most_popular_all": "Stats lives by popularity and by id :Type All",
    "stats_engagement_live_by_id_most_popular_internet": "Stats lives by popularity and by id :Type Internet",
    "stats_engagement_live_by_id_most_popular_intranet": "Stats lives by popularity and by id :Type Intranet",
    "stats_engagement_live_by_id_most_popular_internet_mobile": "Stats lives by popularity and by id :Type Internet mobile",
    "stats_engagement_live_by_id_most_popular_intranet_mobile": "Stats lives by popularity and by id :Type Intranet mobile",

    "stats_engagement_podcast_by_id_most_popular_all": "Stats podcasts by popularity and by id :Type All",
    "stats_engagement_podcast_by_id_most_popular_internet": "Stats podcasts by popularity and by id :Type Internet",
    "stats_engagement_podcast_by_id_most_popular_internet_mobile": "Stats podcasts by popularity and by id :Type Internet mobile",

    "stats_engagement_vod_by_id_visits_per_ip_all": "Stats vods by IPs and by id :Type All",
    "stats_engagement_vod_by_id_visits_per_ip_internet": "Stats vods by IPs and by id :Type Internet",
    "stats_engagement_vod_by_id_visits_per_ip_intranet": "Stats vods by IPs and by id :Type Intranet",
    "stats_engagement_vod_by_id_visits_per_ip_internet_mobile": "Stats vods by IPs and by id :Type Internet mobile",
    "stats_engagement_vod_by_id_visits_per_ip_intranet_mobile": "Stats vods by IPs and by id :Type Intranet mobile",
    "stats_engagement_live_by_id_visits_per_ip_all": "Stats lives by IPs and by id :Type All",
    "stats_engagement_live_by_id_visits_per_ip_internet": "Stats lives by IPs and by id :Type Internet",
    "stats_engagement_live_by_id_visits_per_ip_intranet": "Stats lives by IPs and by id :Type Intranet",
    "stats_engagement_live_by_id_visits_per_ip_internet_mobile": "Stats lives by IPs and by id :Type Internet mobile",
    "stats_engagement_live_by_id_visits_per_ip_intranet_mobile": "Stats lives by IPs and by id :Type Intranet mobile",

    "stats_engagement_podcast_by_id_visits_per_ip_all": "Stats podcasts by IPs and by id :Type All",
    "stats_engagement_podcast_by_id_visits_per_ip_internet": "Stats podcasts by IPs and by id :Type Internet",
    "stats_engagement_podcast_by_id_visits_per_ip_internet_mobile": "Stats podcasts by IPs and by id :Type Internet mobile",

    "stats_audience_vod_by_id_audience_all": "Stats vods by audience and by id :Type All",
    "stats_audience_vod_by_id_audience_internet": "Stats vods by audience and by id :Type Internet",
    "stats_audience_vod_by_id_audience_intranet": "Stats vods by audience and by id :Type Intranet",
    "stats_audience_vod_by_id_audience_internet_mobile": "Stats vods by audience and by id :Type Internet mobile",
    "stats_audience_vod_by_id_audience_intranet_mobile": "Stats vods by audience and by id :Type Intranet mobile",
    "stats_audience_live_by_id_audience_all": "Stats lives by audience and by id :Type All",
    "stats_audience_live_by_id_audience_internet": "Stats lives by audience and by id :Type Internet",
    "stats_audience_live_by_id_audience_intranet": "Stats lives by audience and by id :Type Intranet",
    "stats_audience_live_by_id_audience_internet_mobile": "Stats lives by audience and by id :Type Internet mobile",
    "stats_audience_live_by_id_audience_intranet_mobile": "Stats lives by audience and by id :Type Intranet mobile",

    "stats_audience_podcast_by_id_audience_all": "Stats podcasts by audience and by id :Type All",
    "stats_audience_podcast_by_id_audience_internet": "Stats podcasts by audience and by id :Type Internet",
    "stats_audience_podcast_by_id_audience_internet_mobile": "Stats podcasts by audience and by id :Type Internet mobile",

    "stats_audience_vod_by_id_duree_all": "Stats vods by duration and by id :Type All",
    "stats_audience_vod_by_id_duree_internet": "Stats vods by duration and by id :Type Internet",
    "stats_audience_vod_by_id_duree_intranet": "Stats vods by duration and by id :Type Intranet",
    "stats_audience_vod_by_id_duree_internet_mobile": "Stats vods by duration and by id :Type Internet mobile",
    "stats_audience_vod_by_id_duree_intranet_mobile": "Stats vods by duration and by id :Type Intranet mobile",
    "stats_audience_live_by_id_duree_all": "Stats lives by duration and by id :Type All",
    "stats_audience_live_by_id_duree_internet": "Stats lives by duration and by id :Type Internet",
    "stats_audience_live_by_id_duree_intranet": "Stats lives by duration and by id :Type Intranet",
    "stats_audience_live_by_id_duree_internet_mobile": "Stats lives by duration and by id :Type Internet mobile",
    "stats_audience_live_by_id_duree_intranet_mobile": "Stats lives by duration and by id :Type Intranet mobile",

    "stats_audience_podcast_by_id_duree_all": "Stats podcasts by duration and by id :Type All",
    "stats_audience_podcast_by_id_duree_internet": "Stats podcasts by duration and by id :Type Internet",
    "stats_audience_podcast_by_id_duree_internet_mobile": "Stats podcasts by duration and by id :Type Internet mobile",

    "media_video_add_option_import":"Video Import ",
    "media_video_add_option_extern_link":"Add external link",
    "media_video_add_option_on_hold":"Add on hold video",
    "media_video_add_option_on_hold_sftp":"Add on hold sftp video",
    "media_video_add_option_webcam":"Add webcam",
    "media_video_add_option_presentation":"Add presentation",
    "media_video_add_option_story_board":"Add storyboard",

    "media_video_setting":"Video settings",
    "send_email_validation":"Send email validation",
    "media_video_list_dtable_show_like":"Show video like ",
    "media_video_list_dtable_show_not_like":"Show video dislike",
    "media_video_list_dtable_show_vote":"Show video vote ",

    "lives_conf_configs_before_live":"Before live configuration",
    "lives_conf_message_option":"Before live message configuration",
    "lives_conf_video_option":"Before live video configuration",
    "lives_conf_image_option":"Before live image configuration",
    "lives_conf_counter_option":"Before live counter configuration",
    "lives_conf_pearl_option":"Before live pearl configuration",



    "lives_fo_comment_confirmation_no_api":"Comment confirmation ",


    "pearl_encoder_settings":"Pearl encoder settings",
    "pearl_encoder_interaction":"Pearl encoder interaction",
    "pearl_encoder_vue_web":"Pearl encoder vue-web",
    "pearl_encoder_button_conf":" Pearl encoder configuration",


    "lives_rich_media_slides_no_api":"Slides rich media",
    "lives_rich_media_question_no_api":"Questions rich media",
    "lives_rich_media_chapter_no_api":"Chapters rich media",
    "lives_dtable_show_like":"Like ",
    "lives_dtable_show_not_like":"Dislike",
    "lives_dtable_show_vote":"Vote",
    "lives_dtable_preview_video":"Preview",


    "playlist_playlist_show_media":"Show playlist media",
    "playlist_live_list_dtable":"Datatable List lives",
    "playlist_live_post_add":"Add live",
    "configuration_rmbox_activate_playlist_no_api":"Rmbox configuration ",


    "display_template_get_ten_templates":"Get ten templates",
    "display_template_show_media":"Show template media ",


    "display_new_template_post_add":"Add template",
    "display_new_template_post_edit":"Edit template",
    "display_new_template_list_dtable":"Datatable List of templates",
    "display_new_template_get_templates":"Get all templates",
    "display_new_template_get_ten_templates":"Get ten templates",
    "display_new_template_get_template":"Get template",
    "display_new_template_delete_many":"Multi-delete templates",
    "display_new_template_delete_one":"Delete template",
    "display_new_template_duplicate":"Duplicate template",
    "display_new_template_list_dtable_ongoing":"Datatable List of templates on going",
    "display_new_template_list_dtable_offline":"Datatable List of templates  offline",
    "display_new_template_list_dtable_upcoming":"Datatable List of templates  upcoming",
    "display_new_template_preview_video":"Preview ",
    "display_new_template_show_generic":"Show generic video",
    "display_new_template_edit_duration_segment":"Edit segment duration",
    "display_new_template_show_blank_layout":"Show blank layout",
    "display_new_template_post_add_segment":"Add segment",
    "display_new_template_show_list_block":"Show list block ",
    "display_new_template_show_intro_video":"Show intro video",
    "display_new_template_initialize_duration_template":"Initialize template duration",
    "display_new_template_undo_redo":" Undo-Redo",
    "display_new_template_save_video":"Save video template",
    "display_toolbar_edit":"Edit toolbar",
    "display_toolbar_duplicate":"Duplicate toolbar",
    "display_toolbar_drag":"Drag toolbar",
    "display_toolbar_delete":"Delete toolbar",
    "display_toolbar_parameter":"Toolbar parameter",
    "display_new_template_display_layers":"Display layers",
    "display_new_template_animate_components":"Animate components ",
    "display_new_template_sort_layers":"Sort layers",
    "display_new_template_reclamation":"Reclamation",
    "display_new_template_list_show_ligne": "Show Line column",
    "display_new_template_list_search_by_status": "Search by status",




    "display_new_schedule_post_add":"Add schedule",
    "display_new_schedule_post_edit":"Edit schedule ",
    "display_new_schedule_post_edit_order":"Edit schedules order",
    "display_new_schedule_post_enable":"Schedules enable",
    "display_new_schedule_post_disable":"Schedules disable",
    "display_new_schedule_list_dtable":"Datatable schedules",
    "display_new_schedule_get_all":"Get all schedules",
    "display_new_schedule_delete_many":"Multi-delete schedules",
    "display_new_schedule_delete_one":"Delete schedule",
    "display_new_schedule_get_one":"Get one schedule",
    "display_new_schedule_get_reload":"Get reload schedules",
    "display_new_schedule_form_active":" Schedule active",
    "display_new_schedule_form_attribute":"Schedule attribute",

    "podcast_form_langue":"Podcast language",
    "podcast_form_category":"Podcast category",
    "podcast_form_explicit":"Podcast explicit",

    "scorm_scorm_no_api":"Show scorm",
    "scorm_edit_scorm_no_api":"Edit scorm",
    "scorm_edit_source_scorm_no_api":"Edit scorm source",
    "scorm_delete_scorm_no_api":"Delete scorm",
    "scorm_export_scorm_no_api":"Export scorm",
    "scorm_add_scorm_no_api":"Add scorm",


    "skin_skin_no_api":"Show skin",

    "photoprism_add":"Add",
    "photoprism_edit":"Edit",
    "photoprism_delete":"Delete",
    "photoprism_list_dtable":"Datatable list ",
    "photoprism_list_grid":"Grid list ",
    "photoprism_import_simple":"Simple Import ",
    "photoprism_import_multiple":"Multiple importation ",
    "photoprism_like":"Like",
    "photoprism_download":"Download",
    "photoprism_filter_by_word":"Filter by word",
    "photoprism_filter_by_camera":"Filter by camera",
    "photoprism_filter_by_pays":"Filter by pays",
    "photoprism_filter_by_category":"Filter by category",
    "photoprism_filter_by_type":"Filter by type",
    "photoprism_filter_by_color":"Filter by color",
    "photoprism_sort_by_type":"Sort by type",
    "photoprism_sort_by_date":"Sort by date",
    "photoprism_sort_by_size":"Sort by size",
    "photoprism_detail":"Details",
    "photoprism_form_title":"Titre ",
    "photoprism_form_themes":"Themes of photoprism",
    "photoprism_form_contributor":"Contributors ",
    "photoprism_form_description":"Description ",
    "photoprism_theme_delete":"Delete theme",
    "photoprism_theme_rename":"Rename theme",
    "photoprism_theme_download":"Download theme",
    "photoprism_theme_detail":"Details of theme",
    "photoprism_theme_export_PDF":"Export PDF of theme",
    "photoprism_theme_export_metadata":"Export metadata of theme",
    "photoprism_use":"Use",
    "photoprism_check":"check",
    "photoprism_move":"move",
    "photoprism_date_import":"Import date",
    "photoprism_archive":"Archive",
    "photoprism_list_menu":"List menu",

    "media_video_form_transcription": "Transcription of the video",

    "media_video_post_acceessible": "Put the video visible on the internet",

    "comment_detail":"Details",
    "comment_post_edit":"Edit ",
    "comment_post_delete":"Delete ",
    "comment_post_multi_delete":"Multi-delete",
    "comment_post_activate":"Activate",



    "player_question_redirect_video":"video",
    "player_question_redirect_web_page":" web page",
    "player_question_redirect_download_file":"Download file"
  },
  "MODULESLIST": {
    "none": "No group to show",
    "configuration_rmboxgroup": "Configuration RmBox group module",
    "configuration_rmbox": "Configuration RmBox module",
    "configuration_zone": "Configuration zone module",
    "display_schedule": "Module display schedule",
    "display_template": "Module display template",
    "display_new_template": "Module display template",
    "display_new_schedule":"Module display schedule",
    "configuration_presets": "Module configuration presets",
    "specifics_directions": "Module directions",
    "sondage": "Surveys module",
    "lives": "Lives module",
    "lives_comments": "Lives comments module",
    "event": "Events lives module",
    "media_home": "Media home module",
    "parametres_theme": "Theme module",
    "subscription_group": "Subscription group module",
    "abonnement_user": "Subscriber module",
    "all": "All modules",
    "core_group": "User group module",
    "media_video": "Video module",
    "webinar": "Webinar module",
    "abonnement_group": "Subscription group module",
    "subscription_user": "Subscriber module",
    "configuration_server": "Server module",
    "parameters_theme": "Theme module",
    "parameters_canal": "Channel module",
    "parameters_advertising": "Advertising module",
    "profiles_user": "Profile user module",
    "profiles_group": "Profile group module",
    "profiles_ip": "Profile IP module",
    "specifics_iptv": "IP-TV module",
    "specifics_stations": "Station module",
    "param": "Param module",
    "playlist": "Playlist module",
    "playlist_live": "Playlist live module",
    "player":"Module player",
    "comment":"Module commentaire",
    "photoprisme":"Photoprisme module",
    "skin":"Skin module",
    "scorm":"Scorm module",
    "comments": "Comments module ",
    "configuration_general": "General module",
    "media_video_caption": "Caption module",
    "rich_media_video": "Rich media video module",
    "export_video": "Export video module",
    "chutier": "Chutier module",
    "lives_conf": "Live configuration module ",
    "stats_temps_reel": "Real-time stats module",
    "stats_technologie": "Technology stats module",
    "stats_mesure_audience": "Module stats measure audience",
    "stats_mesure_engagement": "Stats measure commitment module ",
    "stats_geo": "Geo stats module",
    "stats_engagement": "Commitment stats module",
    "stats_audience": "Stats audience module ",
    "statsvod": "Stats vod module ",
    "statslive": "Stats live module",
    "statsvod_by_id": "Stats vod by id module",
    "statslive_by_id": "Stats live by id module",
    "stats_dashboard": "Stats dashboard",
    "stats_acces": "Stats access",
    "stats_bande_passante": "Stats bandwidth",
    "stats_storage": "Stats storage",
    "dashboard": "Dashboard",
    "stats": "Stats",
    "modules_add": "Adding modules",
    "modules_success": "The modules are registered successfully",
    "stats_mooc": "Stats mooc",
    "configuration_newss": "News module",
    "podcast": "Podcast module",
    "stats_list_videos": "Video list stats",
    "stats_export": "Export Stats",
    "support": "Support module",
    "player_parameters": "Player parameters"
  }
}
);

$translateProvider.translations("fr", {
  "RIGHTS": {
    "modules_list": "Liste des modules"
  },
  "ACTIONSLIST": {
    "none": "Aucune action est disponible",
    "core_group_add": "Ajout d'un groupe d'utilisateur",
    "core_group_delete": "Suppression d'un groupe d'utilisateur",
    "core_group_edit": "Modification d'un groupe d'utilisateur",
    "core_group_manage_rights": "G\u00e9rer les permissions du groupe d'utilisateur",
    "core_group_view": "Voir les informations du groupe d'utilisateur",
    "core_user_add": "Ajout d'un utilisateur",
    "core_user_delete": "Suppression d'un utilisateur",
    "core_user_edit": "Modification d'un utilisateur",
    "core_user_view": "Voir les informations de l'utilisateur",
    "lives_post_add": "Ajout d'un direct",
    "display_schedule_post_add": "Ajout d'une grille des programmes",
    "display_schedule_get_one": "Afficher une grille des programmes",
    "display_schedule_post_edit": "Modification d'une grille des programmes",
    "display_schedule_post_edit_order": "Modification de l'ordre d'une grille des programmes",
    "display_schedule_get_all": "Afficher les grilles des programmes",
    "display_schedule_delete_many": "Multi-delete des grilles",
    "display_schedule_list_dtable": "Datatable grille des programmes",
    "display_schedule_post_disable": "Grille des programmes inactive",
    "display_schedule_post_enable": "Grille des programmes active",
    "display_schedule_delete_one": "Effacer grille des programmes",
    "display_template_post_add": "Ajout d'un template",
    "display_template_post_edit": "Modification d'un template",
    "display_template_get_templates": "Afficher les templates",
    "display_template_delete_many": "Multi-delete des templates",
    "display_template_list_dtable": "Datatable des templates",
    "display_template_get_template": "Afficher un template",
    "display_template_delete_one": "Effacer un template",
    "live_calendar": "Voir le calendrier des directs",
    "live_delete": "Suppression d'un direct",
    "live_edit": "Modification d'un direct",
    "live_view": "Voir les informations d'un direct",
    "live_view_archived": "Voir les directs termin\u00e9s",
    "live_view_offline": "Voir les directs hors ligne",
    "live_view_on_going": "Voir les directs en cours",
    "live_view_to_come": "Voir les directs \u00e0 venir",
    "media_comments_un_validate": "Ne pas valider les commentaires",
    "media_comments_validate": "Valider les commentaires",
    "media_video_add": "Ajout d'une vid\u00e9o",
    "media_video_captions": "Sous-titrage d'une vid\u00e9o",
    "media_video_delete": "Suppression d'une vid\u00e9o",
    "media_video_edit": "Modification d'une vid\u00e9o",
    "media_video_export_daily_motion": "Exporter une vid\u00e9o vers DAILYMOTION",
    "media_video_export_links": "Voir les liens d'export d'une vid\u00e9o",
    "media_video_export_youtube": "Exporter une vid\u00e9o vers YOUTUBE",
    "media_video_push": "Mettre en avant une vid\u00e9o",
    "media_video_re_upload": "Changer la source d'une vid\u00e9o",
    "media_video_rich_media": "Rich-media d'une vid\u00e9o",
    "media_video_toggle_choices": "Basculer les param\u00e8tres d'une vid\u00e9o",
    "media_video_un_push": "Mettre en arri\u00e8re une vid\u00e9o",
    "media_video_upload": "Importer une vid\u00e9o",
    "media_video_upload_flash_option": "Import vid\u00e9o : Option flash",
    "media_video_upload_ftp_option": "Import vid\u00e9o : Option FTP",
    "media_video_upload_html_option": "Import vid\u00e9o : Option HTML5",
    "media_video_upload_on_hold_option": "Import vid\u00e9o : Option vid\u00e9os en attene",
    "media_video_view_archived": "Voir les vid\u00e9os archiv\u00e9es",
    "media_video_view_informations": "Voir les informations d'une vid\u00e9o",
    "media_video_view_meta": "Voir mes m\u00e9tadonn\u00e9es d'une vid\u00e9o",
    "media_video_view_offline": "Voir les vid\u00e9os hors ligne",
    "media_video_view_on_going": "Voir les vid\u00e9os en cours",
    "media_video_view_to_come": "Voir les vid\u00e9os \u00e0 venir",
    "parametres_theme_ajout": "Ajout d'un th\u00e8me",
    "playlist_add": "Ajout d'une playlist",
    "playlist_live_add": "Ajout d'une playlist direct",
    "subscription_group_add": "Ajout d'un groupe d'abonn\u00e9es",
    "subscription_group_delete": "Suppression d'un groupe d'abonn\u00e9s",
    "subscription_group_edit": "Modification d'un groupe d'abonn\u00e9s",
    "subscription_group_view": "Voir les informations d'un groupe d'abonn\u00e9s",
    "subscription_user_add": "Ajout d'un abonn\u00e9",
    "subscription_user_delete": "Suppression d'un abonn\u00e9",
    "subscription_user_edit": "Modification d'un abonn\u00e9",
    "subscription_user_view": "Voir les informations d'un abonn\u00e9",
    "subscription_group_get_group": "D\u00e9tails d'abonnement d'un groupe",
    "subscription_group_delete_subscription_groups": "Suppression des abonnements de groupe",
    "subscription_user_get_user": "D\u00e9tail d'un abonnement d'un utilisateur",
    "subscription_user_delete_subscription_users": "Suppression des abonnements d'utilisateurs",
    "subscription_user_list_dtable_subscription_users": "Liste d'abonnement d'un utilisateur en utilisant datatable",
    "configuration_server_add_add_server": "Ajout serveur",
    "configuration_server_list_list": "Liste des serveurs",
    "configuration_server_list_delete_servers": "Supprimer des serveurs",
    "configuration_server_list_mdelete": "Supprime un serveur",
    "configuration_server_edit_edit_server": "Modifier un serveur",
    "configuration_server_detail_get_server": "D\u00e9tails d'un serveur",
    "parameters_theme_add_add_theme": "Ajout th\u00e8me",
    "parameters_theme_list_list": "Liste des th\u00e8mes",
    "parameters_theme_list_delete_themes": "Supprimer des th\u00e8mes",
    "parameters_theme_list_mdelete": "Supprimer un th\u00e8me",
    "parameters_theme_edit_edit_theme": "Modifier un th\u00e8me",
    "parameters_theme_detail_get_theme": "D\u00e9tails d'un th\u00e8me",
    "parameters_canal_add_add_canal": "Ajout canal",
    "parameters_canal_list_list": "Liste des canaux",
    "parameters_canal_list_delete_canals": "Supprimer des canaux",
    "parameters_canal_list_mdelete": "Supprimer un canal",
    "parameters_canal_edit_edit_canal": "Modifier un canal",
    "parameters_canal_detail_get_canal": "D\u00e9tails d'un canal",
    "parameters_canal_get_url_export": "Liens d'export",
    "parameters_canal_get_storage_servers": "Stockage par serveur",
    "parameters_canal_bitrate_pc_no_api": "Bitrate PC",
    "parameters_canal_bitrate_mobile_no_api": "Bitrate mobile",
    "parameters_canal_bitrate_tablet_no_api": "Bitrate tablette",
    "parameters_canal_reading_protocol_no_api": "Protocole de lecture",
    "parameters_canal_mbr_no_api": "MBR",
    "parameters_canal_cdn_no_api": "CDN",
    "profiles_user_add_add_user": "Ajout utilisateur",
    "profiles_user_post_edit": "Modifier un utilisateur",
    "profiles_user_list_list": "Liste des utilisateurs",
    "profiles_user_list_delete_users": "Supprimer des utilisateurs",
    "profiles_user_list_mdelete": "Supprimer un utilisateur",
    "profiles_user_edit_edit_user": "Modifier un utilisateur",
    "profiles_user_detail_get_user": "D\u00e9tails d'un utilisateur",
    "profiles_user_enable_user": "Activer utilisateur",
    "profiles_user_disable_user": "D\u00e9sactiver utilisateur",
    "profiles_user_edit_connected_user": "Modifier utilisateur connect\u00e9",
    "profiles_group_add_add_group": "Ajout groupe",
    "profiles_group_list_list": "Liste des groupes",
    "profiles_group_list_delete_groups": "Supprimer des groupes",
    "profiles_group_list_mdelete": "Supprimer un groupe",
    "profiles_group_edit_edit_group": "Modifier un groupe",
    "profiles_group_detail_get_group": "D\u00e9tails d'un groupe",
    "profiles_ip_add_add_ip": "Ajout IP",
    "profiles_ip_list_list": "Liste des IPs",
    "profiles_ip_list_delete_ips": "Supprimer des IPs",
    "profiles_ip_list_mdelete": "Supprimer un IP",
    "profiles_ip_edit_edit_ip": "Modifier un IP",
    "profiles_ip_detail_get_ip": "D\u00e9tails d'un IP",
    "abonnement_group_add_add_group": "Ajout abonnement d'un groupe",
    "abonnement_group_detail_get_group": "D\u00e9tails d'abonnement d'un groupe",
    "abonnement_group_edit_edit_group": "Modifier un abonnement d'un groupe",
    "abonnement_group_list_list": "Liste des abonnements des groupes",
    "abonnement_group_list_mdelete": "Suppression des abonnements de groupe",
    "abonnement_Group_list_dtable": "Liste des abonnements de groupe en utilisant datatable",
    "abonnement_user_add_add_user": "Ajout un utilisateur pour un abonnement",
    "abonnement_user_detail_get_user": "D\u00e9tail d'un abonnement d'un utilisateur",
    "abonnement_user_edit_edit_user": "Modifier un abonnement d'un utilisateur",
    "abonnement_user_list_list": "Liste d'abonnement d'un utilisateur",
    "abonnement_user_list_mdelete": "Suppression d'abonnement d'un utilisateur",
    "abonnement_user_list_dtable": "Liste d'abonnement d'un utilisateur en utilisant datatable",
    "subscription_group_post_add": "Ajout d'un abonnement d'un groupe",
    "subscription_group_post_edit": "Modification d'un abonnement d'un groupe",
    "subscription_group_list_dtable": "Liste des abonnements de groupe en utilisant datatable",
    "subscription_group_delete_group": "Suppression d'abonnement d'un groupe",
    "subscription_group_delete_multi": "Suppression des abonnements de groupes",
    "subscription_group_get_detail": "D\u00e9tails d'un abonnement de groupe",
    "subscription_user_post_add": "Ajout d'un utilisateur pour un abonnement",
    "subscription_user_post_edit": "Modification d'un abonnement d'un utilisateur",
    "subscription_user_list_dtable": "Liste d'abonnement d'utilisateur en utilisant datatable",
    "subscription_user_delete_user": "Suppression d'abonnement d'un utilisateur",
    "subscription_user_delete_multi": "Suppression des abonnements d'utilisateurs",
    "subscription_user_get_detail": "D\u00e9tails d'abonnement d'un groupe",
    "media_video_caption_post_generate_caption": "G\u00e9n\u00e9ration des sous titres",
    "rich_media_video_preview_link_by_title": "Visualisation",
    "media_video_post_add": "Ajout d'une vid\u00e9o",
    "media_video_list_dtable_videos_all": "Liste des vid\u00e9os en utilisant datatable",
    "media_video_post_edit": "Modification d'une vid\u00e9o",
    "media_video_list_dtable_videos_ongoing": "Liste des vid\u00e9os en cours de diffusuion en utilisant datatable",
    "media_video_list_dtable_videos_upcoming": "Liste des vid\u00e9os \u00e0 venir en utilisant datatable",
    "media_video_list_dtable_videos_archived": "Liste des vid\u00e9os archiv\u00e9es en utilisant datatable",
    "media_video_list_dtable_videos_offline": "Liste des vid\u00e9os hors ligne en utilisant datatable",
    "media_video_download_video": "T\u00e9l\u00e9chargement vid\u00e9o",
    "media_video_delete_video": "Suppression d'une vid\u00e9o",
    "media_video_multi_delete": "Suppression des vid\u00e9os",
    "media_video_post_enable_push": "Mise en avant une vid\u00e9o",
    "media_video_post_disable_push": "Mise en arri\u00e8re une vid\u00e9o",
    "media_video_get_video_url": "Visualisation des informations d'une vid\u00e9o",
    "media_video_get_video_meta_data": "Visualisation les m\u00e9tadonn\u00e9es d'une vid\u00e9o",
    "media_video_get_list_steps": "Chronologie vid\u00e9o",
    "media_video_add_home_page": "Vid\u00e9o d'accueil",
    "media_video_delete_home_page": "Supprimer vid\u00e9o d'accueil",
    "media_video_reupload_no_api": "Modifier fichier source",
    "media_video_preview_no_api": "Aperçu vid\u00e9o",
    "media_video_subscribers_no_api": "Gestion des abonn\u00e9s",
    "media_video_audio_no_api": "Description audio",
    "media_video_send_mail_no_api": "Envoyer par mail",
    "media_video_comment_no_api": "Commentaire vid\u00e9o",
    "media_video_social_network_embed_no_api": "R\u00e9seaux sociaux",
    "media_video_progressif_download_embed_no_api": "T\u00e9l\u00e9chargement progressif",
    "media_video_uid_embed_no_api": "UID/ID",
    "media_video_permalien_embed_no_api": "Permalien",
    "media_video_mp4_embed_no_api": "MP4",
    "media_video_embed_no_api": "Embed",
    "media_video_options_embed_no_api": "Options embed",
    "media_video_contributor_form_no_api": "Contributeur",
    "media_video_password_form_no_api": "S\u00e9curiser par mot de passe",
    "media_video_pasword_form_no_api": "S\u00e9curiser par mot de passe",
    "media_video_secure_form_no_api": "S\u00e9curiser video",
    "media_video_join_files_form_no_api": "Joindre des fichiers",
    "media_video_downloadable_vid_form_no_api": "Vid\u00e9o t\u00e9l\u00e9chargeable",
    "media_video_list_by_contributor_no_api": "Liste des vid\u00e9os par contributeur",
    "media_video_get_date_last_montage": "Montage vid\u00e9o",
    "comments_post_add": "Ajout d'un commentaire m\u00e9dia",
    "comments_post_edit": "Modification d'un commentaire m\u00e9dia",
    "comments_list_dtable": "Liste des commentaires m\u00e9dia en utilisant datatable",
    "comments_delete_comments": "Suppression d'un commentaire m\u00e9dia",
    "comments_delete_multi": "Suppression des commentaires m\u00e9dia",
    "comments_post_enable": "Activation d'un commentaire m\u00e9dia",
    "comments_post_disable": "D\u00e9sactivation d'un commentaire m\u00e9dia",
    "comments_get_detail": "D\u00e9tails d'un commentaire m\u00e9dia",
    "comments_lives_post_edit": "Modification d'un commentaire direct",
    "comments_list_dtable_lives": "Liste des commentaires direct en utilisant datatable",
    "comments_lives_delete": "Suppression d'un commentaire direct",
    "comments_delete_multi_lives": "Suppression des commentaires direct",
    "comments_lives_post_enable": "Activation d'un commentaire direct",
    "comments_lives_post_disable": "D\u00e9sactivation d'un commentaire direct",
    "comments_lives_get_detail": "D\u00e9tails d'un commentaire direct",
    "media_home_post_add_home_conf": "Ajout d'une configuration",
    "media_home_get_home_conf_videos": " Liste des vid\u00e9os",
    "media_home_post_disable_push_video": "Mise en avant/arri\u00e8re d'une vid\u00e9o",
    "media_video_post_toggle": "Mettre la vid\u00e9o (hors ligne/en ligne)",
    "lives_conf_post_add": "Ajout d'une configuration direct",
    "lives_comments_post_edit": "Modification d'un commentaire",
    "lives_comments_list_dtable": " Liste des commentaires en utilisant datatable",
    "lives_comments_delete_comments": "Suppression d'un commentaire",
    "lives_comments_delete_multi": "Suppression des commentaires",
    "lives_comments_get_detail": "D\u00e9tails d'un commentaire",
    "lives_post_edit": "Modification d'un direct",
    "lives_dtable_lives_endless": "Liste des directs en cours",
    "lives_dtable_lives_all": "Liste tous les directs",
    "lives_dtable_lives_trash": "Liste des directs en corbeille",
    "lives_list_dtable_up_coming": "Liste des directs \u00e0 venir",
    "lives_dtable_lives_archived": "Liste des directs archiv\u00e9s",
    "lives_delete_live": "Suppression d'un direct",
    "lives_multi_delete": "Suppression des directs",
    "lives_get_detail": "D\u00e9tails d'un direct",
    "lives_stats_no_api": "Statistiques du direct",
    "lives_diffuser_no_api": "Diffuser webinar",
    "lives_add_screen_share": "Partage d'\u00e9cran liste",
    "lives_conf_no_api": "Configuration avant direct",
    "lives_fo_subscript_no_api": "Inscription des abonn\u00e9s",
    "lives_fo_like_no_api": "Aimer",
    "lives_fo_sondage_no_api": "Sondage",
    "lives_fo_comment_no_api": "Commentaire",
    "lives_fo_files_share_no_api": "Documents partag\u00e9s",
    "lives_social_media_no_api": "R\u00e9seaux sociaux",
    "lives_password_security_no_api": "S\u00e9curiser direct par mot de passe",
    "lives_screen_share_no_api": "Partage d'\u00e9cran",
    "lives_fo_chat_no_api": "Chat",
    "lives_rich_media_no_api": "Rich média",
    "lives_associate_files_no_api": "Joindre des fichiers",
    "lives_associate_users_no_api": "Contributeur",
    "lives_encoder_no_api": "Encodeur",
    "lives_live_info_no_api": "Informations du direct",
    "lives_export_link_no_api": "Liens d'export",
    "lives_comments_no_api": "Commentaires du direct",
    "lives_live_detail_no_api": "Détails d'un direct",
    "lives_send_mail_no_api": "Envoyer invitations",
    "lives_type_no_api": "Type direct",
    "lives_private_no_api": "Priv\u00e9",
    "lives_active_no_api": "Activ\u00e9",
    "lives_autopub_no_api": "Publier automatiquement",
    "lives_webinar_no_api": "Webinar",
    "playlist_post_add": "Ajout d'une playlist",
    "playlist_post_edit": "Modification d'une playlist",
    "playlist_list_dtable": "Liste des playlists en utilisant datatable",
    "playlist_delete_playlist": "Suppression d'une playlist",
    "playlist_delete_multi": "Suppression des playlists",
    "playlist_get_detail": "D\u00e9tails d'une playlist",
    "profiles_user_post_add": "Ajout d'un utilisateur",
    "profiles_user_post_edit_user": "Modification d'un utilisateur",
    "profiles_user_list_dtable": "Liste des utilisateurs en utilisant datatable",
    "profiles_user_profiles_delete_user": "Suppression d'un utilisateur",
    "profiles_user_delete_multi": "Suppression des utilisateurs",
    "profiles_user_put_enable_user": "Activation d'un utilisateur",
    "profiles_user_put_disable_user": "D\u00e9sactivation d'un utilisateur",
    "profiles_user_get_detail": "D\u00e9tails d'un utilisateur",
    "profiles_user_post_edit_connected_user": "Modification d'un utilisateur connect\u00e9",
    "profiles_group_post_add": "Ajout d'un groupe",
    "activate_code_validation_no_api": "Activer l'authentification avec code de validation",
    "profiles_group_post_edit": "Modification d'un groupe",
    "profiles_group_list_dtable": "Liste des groupes en utilisant datatable",
    "profiles_group_delete_group": "Suppression d'un groupe",
    "profiles_group_delete_multi": "Suppression des groupes",
    "profiles_group_get_detail": "D\u00e9tails d'un groupe",
    "profiles_ip_post_add": "Ajout d'un IP",
    "profiles_ip_post_edit": "Modification d'un IP",
    "profiles_ip_list_dtable": "Liste des IPs en utilisant datatable",
    "profiles_ip_delete_ips": "Suppression d'un IP",
    "profiles_ip_delete_multi": "Suppression des IPs",
    "profiles_ip_get_detail": "D\u00e9tails d'un IP",
    "event_post_add": "Ajout d'un \u00e9v\u00e9nement en direct",
    "event_post_edit": "Modification d'un \u00e9v\u00e9nement en direct",
    "event_list_dtable_events_ongoing": "Liste des \u00e9v\u00e9nements en cours en utilisant datatable",
    "event_list_dtable_events_upcoming": "Liste des \u00e9v\u00e9nements \u00e0 venir en utilisant datatable",
    "event_list_dtable_archived": "Liste des \u00e9v\u00e9nements archiv\u00e9s en utilisant datatable",
    "event_delete_event_live": "Suppression d'un \u00e9v\u00e9nement en direct",
    "event_delete_multi": "Suppression des \u00e9v\u00e9nements",
    "event_get_detail": "D\u00e9tails d'un \u00e9v\u00e9nement",
    "configuration_server_post_add": "Ajout d'un serveur",
    "configuration_server_post_edit": "Modification d'un serveur",
    "configuration_server_list_dtable": "Liste des serveurs en utilisant datatable",
    "configuration_server_delete_server": "Suppression d'un serveur",
    "configuration_server_delete_multi": "Suppression des serveurs",
    "configuration_server_get_detail": "D\u00e9tails d'un serveur",
    "configuration_rmboxgroup_post_add": "Ajout d'un groupe RmBox",
    "configuration_rmboxgroup_post_edit": "Modification d'un groupe RmBox",
    "configuration_rmboxgroup_list_dtable": " Liste des groupes RmBox en utilisant datatable",
    "configuration_rmboxgroup_delete_rmboxgroup": "Suppression d'un groupe RmBox",
    "configuration_rmboxgroup_delete_multi": "Suppression des groupes RmBox",
    "configuration_rmboxgroup_get_detail": "D\u00e9tails d'un groupe RmBox",
    "configuration_rmbox_post_add": "Ajout d'un RmBox",
    "configuration_rmbox_post_edit": "Modification d'un RmBox",
    "configuration_rmbox_list_dtable": " Liste des RmBoxs en utilisant datatable",
    "configuration_rmbox_delete_rmbox": "Suppression d'un RmBox",
    "configuration_rmbox_delete_multi": "Suppression des RmBoxs",
    "configuration_rmbox_get_detail": "D\u00e9tails d'un RmBox ",
    "configuration_rmbox_get_reports": "Historique des rapports",
    "configuration_rmbox_show_schedule_no_api": "Voir grille",
    "configuration_rmbox_associate_schedule_no_api": "Associer grille",
    "configuration_rmboxgroup_associate_schedule_no_api": "Associer grille",
    "configuration_zone_post_add": "Ajout d'une zone",
    "configuration_zone_post_edit": "Modification d'une zone",
    "configuration_zone_list_dtable": " Liste des zones en utilisant datatable",
    "configuration_zone_delete_zone": "Suppression d'une zone",
    "configuration_zone_delete_multi": "Suppression des zones",
    "configuration_zone_get_detail": "D\u00e9tails d'une zone",
    "configuration_presets_post_add": "Ajout d'un preset",
    "configuration_presets_post_edit": "Modification un preset",
    "configuration_presets_list_dtable": " Liste des presets en utilisant datatable",
    "configuration_presets_delete_preset": "Suppression d'un preset",
    "configuration_presets_delete_multi": "Suppression des presets",
    "configuration_presets_get_detail": "D\u00e9tails d'un preset",
    "configuration_general_post_add": "Ajout d'un g\u00e9n\u00e9rale",
    "configuration_general_post_edit": "Modification d'un g\u00e9n\u00e9rale",
    "configuration_general_list_dtable": "Liste g\u00e9n\u00e9rale en utilisant datatable",
    "configuration_general_delete_general": "Suppression d'un g\u00e9n\u00e9rale",
    "configuration_general_get_detail": "D\u00e9tails d'un g\u00e9n\u00e9rale",
    "parameters_canal_post_add": "Ajout d'un canal",
    "parameters_canal_post_edit": "Modification d'un canal",
    "parameters_canal_list_dtable": "Liste des canaux en utilisant datatable",
    "parameters_canal_delete_channel": "Suppression d'un canal",
    "parameters_canal_delete_multi": "Suppression des canaux",
    "parameters_canal_get_detail": "D\u00e9tail d'un canal",
    "parameters_theme_post_add": "Ajout d'un th\u00e8me",
    "parameters_theme_post_edit": "Modification d'un th\u00e8me",
    "parameters_theme_list_dtable": "Liste des th\u00e8mes en utilisant datatable",
    "parameters_theme_delete_theme": "Suppression d'un th\u00e8me",
    "parameters_theme_delete_multi": "Suppression des th\u00e8mes",
    "parameters_theme_get_detail": "D\u00e9tails d'un th\u00e8me",
    "parameters_theme_get_export": "Liens d'export",
    "parameters_advertising_post_add": "Ajout d'une publicit\u00e9",
    "parameters_advertising_post_edit": "Modification d'une publicit\u00e9",
    "parameters_advertising_list_dtable": "Liste des publicit\u00e9s en utilisant datatable",
    "parameters_advertising_delete_advertising": "Suppression d'une publicit\u00e9",
    "parameters_advertising_delete_multi": "Suppression des publicit\u00e9s",
    "parameters_advertising_get_detail": "D\u00e9tails d'une publicit\u00e9",
    "specifics_stations_post_add": "Ajout d'une station",
    "specifics_stations_post_edit": "Modification d'une station",
    "specifics_stations_list_dtable": "Liste des stations en utilisant datatable",
    "specifics_stations_delete_station": "Suppression d'une station",
    "specifics_stations_delete_multi": "Suppression des stations",
    "specifics_stations_get_detail": "D\u00e9tails d'une station",
    "specifics_iptv_post_add": "Ajout d'une IP-TV",
    "specifics_iptv_post_edit": "Modification d'une IP-TV",
    "specifics_iptv_list_dtable": "Liste des IP-TV en utilisant datatable",
    "specifics_iptv_delete_iptv": "Suppression d'une IP-TV",
    "specifics_iptv_delete_multi": "Suppression des IP-TV",
    "specifics_iptv_get_detail": "D\u00e9tails d'une IP-TV",
    "sondage_post_add": "Ajout d'un sondage",
    "sondage_post_edit": "Modification d'un sondage",
    "sondage_list_dtable": " Liste des sondages en utilisant datatable",
    "sondage_delete_survey": "Suppression un sondage",
    "sondage_delete_multi": "Suppression des sondages",
    "sondage_get_detail": "D\u00e9tails d'un sondage",
    "export_video_get_authentication_code": "Exportation d'une vid\u00e9o vers YOUTUBE",
    "export_video_dailymotion_get_login": "Exportation d'une vid\u00e9o vers DAILYMOTION",
    "chutier_post_add": "Ajout d'un chutier",
    "chutier_post_edit": "Modification d'un  chutier",
    "chutier_list_dtable": "Liste des chutiers en utilisant datatable",
    "metaData_list_dtable": "Liste des metadonnées en utilisant datatable",
    "configuration_list_metaData":"Configuration metaDonnée",
    "chutier_delete_chutier": "Suppression d'un chutier",
    "chutier_delete_multi": "Suppression des chutiers",
    "chutier_get_detail": "D\u00e9tails d'un chutier",
    "param_post_add": "Ajout d'un paramètre",
    "param_post_edit": "Modification d'un paramètre",
    "param_list_dtable_params": "Liste des paramètres en utilisant datatable",
    "param_delete_param": "Suppression d'un paramètre",
    "param_delete_multi": "Suppression des paramètres",
    "param_get_detail": "D\u00e9tails d'un paramètre",
    "stats_temps_reel_vod_stats_now_all": "Statistiques des vid\u00e9os en temps r\u00e9el :Type tous",
    "stats_temps_reel_vod_stats_now_internet": "Statistiques des vid\u00e9os en temps r\u00e9el :Type Internet",
    "stats_temps_reel_vod_stats_now_intranet": "Statistiques des vid\u00e9os en temps r\u00e9el :Type  Intranet",
    "stats_temps_reel_vod_stats_now_internet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el :Type Internet mobile",
    "stats_temps_reel_vod_stats_now_intranet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el :Type Intranet mobile",
    "stats_temps_reel_live_stats_now_all": "Statistiques des directs en temps r\u00e9el :Type Tous",
    "stats_temps_reel_live_stats_now_internet": "Statistiques des directs en temps r\u00e9el :Type Internet",
    "stats_temps_reel_live_stats_now_intranet": "Statistiques des directs en temps r\u00e9el :Type Intranet",
    "stats_temps_reel_live_stats_now_internet_mobile": "Statistiques des directs en temps r\u00e9el :Type Internet mobile",
    "stats_temps_reel_live_stats_now_intranet_mobile": "Statistiques des directs en temps r\u00e9el :Type Intranet mobile",

    "stats_temps_reel_podcast_stats_now_all": "Statistiques des podcasts en temps r\u00e9el :Type tous",
    "stats_temps_reel_podcast_stats_now_internet": "Statistiques des podcasts en temps r\u00e9el :Type Internet",
    "stats_temps_reel_podcast_stats_now_internet_mobile": "Statistiques des podcasts en temps r\u00e9el :Type Internet mobile",


    "stats_temps_reel_vod_now_hours_all": "Statistiques des vid\u00e9os en temps r\u00e9el par heure :Type Tous",
    "stats_temps_reel_vod_now_hours_internet": "Statistiques des vid\u00e9os en temps r\u00e9el par heure :Type Internet",
    "stats_temps_reel_vod_now_hours_intranet": "Statistiques des vid\u00e9os en temps r\u00e9el par heure :Type Intranet",
    "stats_temps_reel_vod_now_hours_internet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par heure :Type Internet mobile",
    "stats_temps_reel_vod_now_hours_intranet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par heure :Type Intranet mobile",
    "stats_temps_reel_live_now_hours_all": "Statistiques des directs en temps r\u00e9el par heure :Type Tous",
    "stats_temps_reel_live_now_hours_internet": "Statistiques des directs en temps r\u00e9el par heure :Type Internet",
    "stats_temps_reel_live_now_hours_intranet": "Statistiques des directs en temps r\u00e9el par heure :Type Intranet",
    "stats_temps_reel_live_now_hours_internet_mobile": "Statistiques des directs en temps r\u00e9el par heure :Type Internet mobile",
    "stats_temps_reel_live_now_hours_intranet_mobile": "Statistiques des directs en temps r\u00e9el par heure :Type Intranet mobile",


    "stats_temps_reel_podcast_now_hours_all": "Statistiques des podcasts en temps r\u00e9el par heure :Type Tous",
    "stats_temps_reel_podcast_now_hours_internet": "Statistiques des podcasts en temps r\u00e9el par heure :Type Internet",
    "stats_temps_reel_podcastnow_hours_internet_mobile": "Statistiques des podcasts en temps r\u00e9el par heure :Type Internet mobile",



    "stats_temps_reel_vod_stats_now_minute_all": "Statistiques des vid\u00e9os en temps r\u00e9el par minute :Type Tous",
    "stats_temps_reel_vod_stats_now_minute_internet": "Statistiques des vid\u00e9os en temps r\u00e9el par minute :Type Internet",
    "stats_temps_reel_vod_stats_now_minute_intranet": "Statistiques des vid\u00e9os en temps r\u00e9el par minute :Type Intranet",
    "stats_temps_reel_vod_stats_now_minute_internet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par minute :Type Internet mobile",
    "stats_temps_reel_vod_stats_now_minute_intranet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par minute :Type Intranet mobile",
    "stats_temps_reel_live_stats_now_minute_all": "Statistiques des directs en temps r\u00e9el par minute :Type Tous",
    "stats_temps_reel_live_stats_now_minute_internet": "Statistiques des directs en temps r\u00e9el par minute :Type Internet",
    "stats_temps_reel_live_stats_now_minute_intranet": "Statistiques des directs en temps r\u00e9el par minute :Type Intranet",
    "stats_temps_reel_live_stats_now_minute_internet_mobile": "Statistiques des directs en temps r\u00e9el par minute :Type Internet mobile",
    "stats_temps_reel_live_stats_now_minute_intranet_mobile": "Statistiques des directs en temps r\u00e9el par minute :Type Intranet mobile",

    "stats_temps_reel_podcast_stats_now_minute_all": "Statistiques des podcasts en temps r\u00e9el par minute :Type Tous",
    "stats_temps_reel_podcast_stats_now_minute_internet": "Statistiques des podcasts en temps r\u00e9el par minute :Type Internet",
    "stats_temps_reel_podcast_stats_now_minute_internet_mobile": "Statistiques des podcasts en temps r\u00e9el par minute :Type Internet mobile",


    "stats_temps_reel_vod_by_id_stats_now_all":"Statistiques des vid\u00e9os en temps r\u00e9el par id :Type tous ",
    "stats_temps_reel_vod_by_id_stats_now_internet":"Statistiques des vid\u00e9os en temps r\u00e9el par id :Type Internet ",
    "stats_temps_reel_vod_by_id_stats_now_intranet":"Statistiques des vid\u00e9os en temps r\u00e9el par id :Type  Intranet",
    "stats_temps_reel_vod_by_id_stats_now_internet_mobile":"Statistiques des vid\u00e9os en temps r\u00e9el par id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_stats_now_intranet_mobile":"Statistiques des vid\u00e9os en temps r\u00e9el par id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_stats_now_all": "Statistiques des directs en temps r\u00e9el par id :Type Tous",
    "stats_temps_reel_live_by_id_stats_now_internet": "Statistiques des directs en temps r\u00e9el par id :Type Internet",
    "stats_temps_reel_live_by_id_stats_now_intranet": "Statistiques des directs en temps r\u00e9el par id :Type Intranet",
    "stats_temps_reel_live_by_id_stats_now_internet_mobile": "Statistiques des directs en temps r\u00e9el par id :Type Internet mobile",
    "stats_temps_reel_live_by_id_stats_now_intranet_mobile": "Statistiques des directs en temps r\u00e9el par id :Type Intranet mobile",

    "stats_temps_reel_podcast_by_id_stats_now_all":"Statistiques des podcasts en temps r\u00e9el par id :Type tous ",
    "stats_temps_reel_podcast_by_id_stats_now_internet":"Statistiques des podcasts en temps r\u00e9el par id :Type Internet ",
    "stats_temps_reel_podcast_by_id_stats_now_internet_mobile":"Statistiques des podcasts en temps r\u00e9el par id :Type Internet mobile",

    "stats_temps_reel_vod_by_id_now_hours_all": "Statistiques des vid\u00e9os en temps r\u00e9el par heure par id :Type Tous",
    "stats_temps_reel_vod_by_id_now_hours_internet": "Statistiques des vid\u00e9os en temps r\u00e9el par heure et par id :Type Internet",
    "stats_temps_reel_vod_by_id_now_hours_intranet": "Statistiques des vid\u00e9os en temps r\u00e9el par heure et par id :Type Intranet",
    "stats_temps_reel_vod_by_id_now_hours_internet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par heure et par id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_now_hours_intranet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par heure et par id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_now_hours_all": "Statistiques des directs en temps r\u00e9el par heure et par id :Type Tous",
    "stats_temps_reel_live_by_id_now_hours_internet": "Statistiques des directs en temps r\u00e9el par heure et par id :Type Internet",
    "stats_temps_reel_live_by_id_now_hours_intranet": "Statistiques des directs en temps r\u00e9el par heure et par id :Type Intranet",
    "stats_temps_reel_live_by_id_now_hours_internet_mobile": "Statistiques des directs en temps r\u00e9el par heure et par id :Type Internet mobile",
    "stats_temps_reel_live_by_id_now_hours_intranet_mobile": "Statistiques des directs en temps r\u00e9el par heure et par id :Type Intranet mobile",

    "stats_temps_reel_podcast_by_id_now_hours_all": "Statistiques des podcasts en temps r\u00e9el par heure par id :Type Tous",
    "stats_temps_reel_podcast_by_id_now_hours_internet": "Statistiques des podcasts en temps r\u00e9el par heure et par id :Type Internet",
    "stats_temps_reel_podcast_by_id_now_hours_internet_mobile": "Statistiques des podcasts en temps r\u00e9el par heure et par id :Type Internet mobile",


    "stats_temps_reel_vod_by_id_stats_now_minute_all": "Statistiques des vid\u00e9os en temps r\u00e9el par minute  et par id :Type Tous",
    "stats_temps_reel_vod_by_id_stats_now_minute_internet": "Statistiques des vid\u00e9os en temps r\u00e9el par minute et par id :Type Internet",
    "stats_temps_reel_vod_by_id_stats_now_minute_intranet": "Statistiques des vid\u00e9os en temps r\u00e9el par minute et par id :Type Intranet",
    "stats_temps_reel_vod_by_id_stats_now_minute_internet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par minute et par id :Type Internet mobile",
    "stats_temps_reel_vod_by_id_stats_now_minute_intranet_mobile": "Statistiques des vid\u00e9os en temps r\u00e9el par minute et par id :Type Intranet mobile",
    "stats_temps_reel_live_by_id_stats_now_minute_all": "Statistiques des directs en temps r\u00e9el par minute et par id :Type Tous",
    "stats_temps_reel_live_by_id_stats_now_minute_internet": "Statistiques des directs en temps r\u00e9el par minute et par id :Type Internet",
    "stats_temps_reel_live_by_id_stats_now_minute_intranet": "Statistiques des directs en temps r\u00e9el par minute et par id :Type Intranet",
    "stats_temps_reel_live_by_id_stats_now_minute_internet_mobile": "Statistiques des directs en temps r\u00e9el par minute et par id :Type Internet mobile",
    "stats_temps_reel_live_by_id_stats_now_minute_intranet_mobile": "Statistiques des directs en temps r\u00e9el par minute et par id :Type Intranet mobile",



    "stats_temps_reel_podcast_by_id_stats_now_minute_all": "Statistiques des podcasts en temps r\u00e9el par minute  et par id :Type Tous",
    "stats_temps_reel_podcast_by_id_stats_now_minute_internet": "Statistiques des podcasts en temps r\u00e9el par minute et par id :Type Internet",
    "stats_temps_reel_podcast_by_id_stats_now_minute_internet_mobile": "Statistiques des podcasts en temps r\u00e9el par minute et par id :Type Internet mobile",


    "media_video_list_comments": "Voir liste des commentaires",
    "media_video_skin": "Modifier skin player par défaut",
    "media_video_list_show_date": "Afficher les dates de début et fin",




    "stats_technologie_vod_os_all": "Statistiques des vid\u00e9os par OS: Type Tous",
    "stats_technologie_vod_os_internet": "Statistiques des vid\u00e9os par OS: Type Internet",
    "stats_technologie_vod_os_intranet": "Statistiques des vid\u00e9os par OS: Type Intranet",
    "stats_technologie_vod_os_internet_mobile": "Statistiques des vid\u00e9os par OS: Type Internet mobile",
    "stats_technologie_vod_os_intranet_mobile": "Statistiques des vid\u00e9os par OS: Type Intranet mobile",

    "stats_technologie_podcast_os_all": "Statistiques des podcasts par OS: Type Tous",
    "stats_technologie_podcast_os_internet": "Statistiques des podcasts par OS: Type Internet",
    "stats_technologie_podcast_os_internet_mobile": "Statistiques des podcasts par OS: Type Internet mobile",


    "stats_technologie_vod_by_id_os_all": "Statistiques des vid\u00e9os par OS et par id : Type Tous",
    "stats_technologie_vod_by_id_os_internet": "Statistiques des vid\u00e9os par OS et par id : Type Internet",
    "stats_technologie_vod_by_id_os_intranet": "Statistiques des vid\u00e9os par OS et par id : Type Intranet",
    "stats_technologie_vod_by_id_os_internet_mobile": "Statistiques des vid\u00e9os par OS et par id : Type Internet mobile",
    "stats_technologie_vod_by_id_os_intranet_mobile": "Statistiques des vid\u00e9os par OS et par id : Type Intranet mobile",

    "stats_technologie_podcast_by_id_os_all": "Statistiques des podcasts par OS et par id : Type Tous",
    "stats_technologie_podcast_by_id_os_internet": "Statistiques des podcasts par OS et par id : Type Internet",
    "stats_technologie_podcast_by_id_os_internet_mobile": "Statistiques des podcasts par OS et par id : Type Internet mobile",

    "stats_technologie_live_os_all": "Statistiques des directs par OS: Type Tous",
    "stats_technologie_live_os_internet": "Statistiques des directs par OS: Type Internet",
    "stats_technologie_live_os_intranet": "Statistiques des directs par OS: Type Intranet",
    "stats_technologie_live_os_internet_mobile": "Statistiques des directs par OS: Type Internet mobile",
    "stats_technologie_live_os_intranet_mobile": "Statistiques des directs par OS: Type Intranet mobile",

    "stats_technologie_live_by_id_os_all": "Statistiques des directs par OS et par id : Type Tous",
    "stats_technologie_live_by_id_os_internet": "Statistiques des directs par OS et par id : Type Internet",
    "stats_technologie_live_by_id_os_intranet": "Statistiques des directs par OS et par id : Type Intranet",
    "stats_technologie_live_by_id_os_internet_mobile": "Statistiques des directs par OS et par id : Type Internet mobile",
    "stats_technologie_live_by_id_os_intranet_mobile": "Statistiques des directs par OS et par id : Type Intranet mobile",


    "stats_technologie_vod_browser_all": "Statistiques des vid\u00e9os par navigateur :Type Tous",
    "stats_technologie_vod_browser_internet": "Statistiques des vid\u00e9os par navigateur :Type Internet",
    "stats_technologie_vod_browser_intranet": "Statistiques des vid\u00e9os par navigateur :Type Intranet",
    "stats_technologie_vod_browser_internet_mobile": "Statistiques des vid\u00e9os par navigateur :Type Internet mobile",
    "stats_technologie_vod_browser_intranet_mobile": "Statistiques des vid\u00e9os par navigateur :Type Intranet mobile",

    "stats_technologie_podcast_browser_all": "Statistiques des podcasts par navigateur :Type Tous",
    "stats_technologie_podcast_browser_internet": "Statistiques des podcasts par navigateur :Type Internet",
    "stats_technologie_podcast_browser_internet_mobile": "Statistiques des podcasts par navigateur :Type Internet mobile",


    "stats_technologie_vod_by_id_browser_all": "Statistiques des vid\u00e9os par navigateur et par id :Type Tous",
    "stats_technologie_vod_by_id_browser_internet": "Statistiques des vid\u00e9os par navigateur et par id :Type Internet",
    "stats_technologie_vod_by_id_browser_intranet": "Statistiques des vid\u00e9os par navigateur et par id :Type Intranet",
    "stats_technologie_vod_by_id_browser_internet_mobile": "Statistiques des vid\u00e9os par navigateur et par id :Type Internet mobile",
    "stats_technologie_vod_by_id_browser_intranet_mobile": "Statistiques des vid\u00e9os par navigateur et par id :Type Intranet mobile",


    "stats_technologie_podcast_by_id_browser_all": "Statistiques des podcasts par navigateur et par id :Type Tous",
    "stats_technologie_podcast_by_id_browser_internet": "Statistiques des podcasts par navigateur et par id :Type Internet",
    "stats_technologie_podcast_by_id_browser_internet_mobile": "Statistiques des podcasts par navigateur et par id :Type Internet mobile",


    "stats_technologie_live_browser_all": "Statistiques des directs par navigateur :Type Tous",
    "stats_technologie_live_browser_internet": "Statistiques des directs par navigateur :Type Internet",
    "stats_technologie_live_browser_intranet": "Statistiques des directs par navigateur :Type Intranet",
    "stats_technologie_live_browser_internet_mobile": "Statistiques des directs par navigateur :Type Internet mobile",
    "stats_technologie_live_browser_intranet_mobile": "Statistiques des directs par navigateur :Type Intranet mobile",


    "stats_technologie_live_by_id_browser_all": "Statistiques des directs par navigateur et par id :Type Tous",
    "stats_technologie_live_by_id_browser_internet": "Statistiques des directs par navigateur et par id :Type Internet",
    "stats_technologie_live_by_id_browser_intranet": "Statistiques des directs par navigateur et par id :Type Intranet",
    "stats_technologie_live_by_id_browser_internet_mobile": "Statistiques des directs par navigateur et par id :Type Internet mobile",
    "stats_technologie_live_by_id_browser_intranet_mobile": "Statistiques des directs par navigateur et par id :Type Intranet mobile",


    "stats_technologie_vod_referrer_all": "Statistiques des vid\u00e9os par referrer :Type Tous",
    "stats_technologie_vod_referrer_internet": "Statistiques des vid\u00e9os par referrer :Type Internet",
    "stats_technologie_vod_referrer_intranet": "Statistiques des vid\u00e9os par referrer :Type Intranet",
    "stats_technologie_vod_referrer_internet_mobile": "Statistiques des vid\u00e9os par referrer :Type Internet mobile",
    "stats_technologie_vod_referrer_intranet_mobile": "Statistiques des vid\u00e9os par referrer :Type Intranet mobile",

    "stats_technologie_podcast_referrer_all": "Statistiques des podcasts par referrer :Type Tous",
    "stats_technologie_podcast_referrer_internet": "Statistiques des podcasts par referrer :Type Internet",
    "stats_technologie_podcast_referrer_internet_mobile": "Statistiques des podcasts par referrer :Type Internet mobile",



    "stats_technologie_vod_by_id_referrer_all": "Statistiques des vid\u00e9os par referrer et par id :Type Tous",
    "stats_technologie_vod_by_id_referrer_internet": "Statistiques des vid\u00e9os par referrer et par id :Type Internet",
    "stats_technologie_vod_by_id_referrer_intranet": "Statistiques des vid\u00e9os par referrer et par id :Type Intranet",
    "stats_technologie_vod_by_id_referrer_internet_mobile": "Statistiques des vid\u00e9os par referrer et par id :Type Internet mobile",
    "stats_technologie_vod_by_id_referrer_intranet_mobile": "Statistiques des vid\u00e9os par referrer et par id :Type Intranet mobile",

    "stats_technologie_podcast_by_id_referrer_all": "Statistiques des podcasts par referrer et par id :Type Tous",
    "stats_technologie_podcast_by_id_referrer_internet": "Statistiques des podcasts par referrer et par id :Type Internet",
    "stats_technologie_podcast_by_id_referrer_internet_mobile": "Statistiques des podcasts par referrer et par id :Type Internet mobile",



    "stats_technologie_live_referrer_all": "Statistiques des directs par referrer :Type Tous",
    "stats_technologie_live_referrer_internet": "Statistiques des directs par referrer :Type Internet",
    "stats_technologie_live_referrer_intranet": "Statistiques des directs par referrer :Type Intranet",
    "stats_technologie_live_referrer_internet_mobile": "Statistiques des directs par referrer :Type Internet mobile",
    "stats_technologie_live_referrer_intranet_mobile": "Statistiques des directs par referrer :Type Intranet mobile",


    "stats_technologie_live_by_id_referrer_all": "Statistiques des directs par referrer et par id :Type Tous",
    "stats_technologie_live_by_id_referrer_internet": "Statistiques des directs par referrer et par id :Type Internet",
    "stats_technologie_live_by_id_referrer_intranet": "Statistiques des directs par referrer et par id :Type Intranet",
    "stats_technologie_live_by_id_referrer_internet_mobile": "Statistiques des directs par referrer et par id :Type Internet mobile",
    "stats_technologie_live_by_id_referrer_intranet_mobile": "Statistiques des directs par referrer et par id :Type Intranet mobile",

    "stats_technologie_vod_device_all": "Statistiques des vid\u00e9os par dispositif :Type Tous",
    "stats_technologie_vod_device_internet": "Statistiques des vid\u00e9os par dispositif :Type Internet",
    "stats_technologie_vod_device_intranet": "Statistiques des vid\u00e9os par dispositif :Type Intranet",
    "stats_technologie_vod_device_internet_mobile": "Statistiques des vid\u00e9os par dispositif :Type Internet mobile",
    "stats_technologie_vod_device_intranet_mobile": "Statistiques des vid\u00e9os par dispositif :Type Intranet mobile",

    "stats_technologie_podcast_device_all": "Statistiques des podcasts par dispositif :Type Tous",
    "stats_technologie_podcast_device_internet": "Statistiques des podcasts par dispositif :Type Internet",
    "stats_technologie_podcast_device_internet_mobile": "Statistiques des podcasts par dispositif :Type Internet mobile",


    "stats_technologie_vod_by_id_device_all": "Statistiques des vid\u00e9os par dispositif et par id :Type Tous",
    "stats_technologie_vod_by_id_device_internet": "Statistiques des vid\u00e9os par dispositif et par id :Type Internet",
    "stats_technologie_vod_by_id_device_intranet": "Statistiques des vid\u00e9os par dispositif et par id :Type Intranet",
    "stats_technologie_vod_by_id_device_internet_mobile": "Statistiques des vid\u00e9os par dispositif et par id :Type Internet mobile",
    "stats_technologie_vod_by_id_device_intranet_mobile": "Statistiques des vid\u00e9os par dispositif et par id :Type Intranet mobile",


    "stats_technologie_podcast_by_id_device_all": "Statistiques des podcasts par dispositif et par id :Type Tous",
    "stats_technologie_podcast_by_id_device_internet": "Statistiques des podcasts par dispositif et par id :Type Internet",
    "stats_technologie_podcast_by_id_device_internet_mobile": "Statistiques des podcasts par dispositif et par id :Type Internet mobile",


    "stats_technologie_live_device_all": "Statistiques des directs par dispositif :Type Tous",
    "stats_technologie_live_device_internet": "Statistiques des directs par dispositif :Type Internet",
    "stats_technologie_live_device_intranet": "Statistiques des directs par dispositif :Type Intranet",
    "stats_technologie_live_device_internet_mobile": "Statistiques des directs par dispositif :Type Internet mobile",
    "stats_technologie_live_device_intranet_mobile": "Statistiques des directs par dispositif :Type Intranet mobile",


    "stats_technologie_live_by_id_device_all": "Statistiques des directs par dispositif et par id :Type Tous",
    "stats_technologie_live_by_id_device_internet": "Statistiques des directs par dispositif et par id :Type Internet",
    "stats_technologie_live_by_id_device_intranet": "Statistiques des directs par dispositif et par id :Type Intranet",
    "stats_technologie_live_by_id_device_internet_mobile": "Statistiques des directs par dispositif et par id :Type Internet mobile",
    "stats_technologie_live_by_id_device_intranet_mobile": "Statistiques des directs par dispositif et par id :Type Intranet mobile",


    "stats_mesure_audience_vod_mesure_all": "Statistiques des vid\u00e9os par mesure audience :Type Tous",
    "stats_mesure_audience_vod_mesure_internet": "Statistiques des vid\u00e9os par mesure audience :Type Internet",
    "stats_mesure_audience_vod_mesure_intranet": "Statistiques des vid\u00e9os par mesure audience :Type Intranet",
    "stats_mesure_audience_vod_mesure_internet_mobile": "Statistiques des vid\u00e9os par mesure audience :Type Internet mobile",
    "stats_mesure_audience_vod_mesure_intranet_mobile": "Statistiques des vid\u00e9os par mesure audience :Type Intranetmobile",

    "stats_mesure_audience_podcast_mesure_all": "Statistiques des podcasts par mesure audience :Type Tous",
    "stats_mesure_audience_podcast_mesure_internet": "Statistiques des podcasts par mesure audience :Type Internet",
    "stats_mesure_audience_podcast_mesure_internet_mobile": "Statistiques des podcasts par mesure audience :Type Internet mobile",



    "stats_mesure_audience_vod_by_id_mesure_all": "Statistiques des vid\u00e9os par mesure audience et par id :Type Tous",
    "stats_mesure_audience_vod_by_id_mesure_internet": "Statistiques des vid\u00e9os par mesure audience et par id :Type Internet",
    "stats_mesure_audience_vod_by_id_mesure_intranet": "Statistiques des vid\u00e9os par mesure audience et par id :Type Intranet",
    "stats_mesure_audience_vod_by_id_mesure_internet_mobile": "Statistiques des vid\u00e9os par mesure audience et par id :Type Internet mobile",
    "stats_mesure_audience_vod_by_id_mesure_intranet_mobile": "Statistiques des vid\u00e9os par mesure audience et par id :Type Intranetmobile",


    "stats_mesure_audience_podcast_by_id_mesure_all": "Statistiques des podcasts par mesure audience et par id :Type Tous",
    "stats_mesure_audience_podcast_by_id_mesure_internet": "Statistiques des podcasts par mesure audience et par id :Type Internet",
    "stats_mesure_audience_podcast_by_id_mesure_internet_mobile": "Statistiques des podcasts par mesure audience et par id :Type Internet mobile",



    "stats_mesure_audience_live_mesure_all": "Statistiques des directs par mesure audience :Type Tous",
    "stats_mesure_audience_live_mesure_internet": "Statistiques des directs par mesure audience :Type Internet",
    "stats_mesure_audience_live_mesure_intranet": "Statistiques des directs par mesure audience :Type Intranet",
    "stats_mesure_audience_live_mesure_internet_mobile": "Statistiques des directs par mesure audience :Type Internet mobile",
    "stats_mesure_audience_live_mesure_intranet_mobile": "Statistiques des directs par mesure audience :Type Intranet mobile",


    "stats_mesure_audience_live_by_id_mesure_all": "Statistiques des directs par mesure audience et par id :Type Tous",
    "stats_mesure_audience_live_by_id_mesure_internet": "Statistiques des directs par mesure audience et par id :Type Internet",
    "stats_mesure_audience_live_by_id_mesure_intranet": "Statistiques des directs par mesure audience et par id :Type Intranet",
    "stats_mesure_audience_live_by_id_mesure_internet_mobile": "Statistiques des directs par mesure audience et par id :Type Internet mobile",
    "stats_mesure_audience_live_by_id_mesure_intranet_mobile": "Statistiques des directs par mesure audience et par id :Type Intranet mobile",

    "stats_mesure_audience_vod_standard_deviation_all": "Statistiques des vid\u00e9os par d\u00e9viation standard :Type Tous",
    "stats_mesure_audience_vod_standard_deviation_internet": "Statistiques des vid\u00e9os par d\u00e9viation standard :Type Internet",
    "stats_mesure_audience_vod_standard_deviation_intranet": "Statistiques des vid\u00e9os par d\u00e9viation standard :Type Intranet",
    "stats_mesure_audience_vod_standard_deviation_internet_mobile": "Statistiques des vid\u00e9os par d\u00e9viation standard :Type Internet mobile",
    "stats_mesure_audience_vod_standard_deviation_intranet_mobile": "Statistiques des vid\u00e9os par d\u00e9viation standard :Type Intranet mobile",

    "stats_mesure_audience_podcast_standard_deviation_all": "Statistiques des podcasts par d\u00e9viation standard :Type Tous",
    "stats_mesure_audience_podcast_standard_deviation_internet": "Statistiques des podcasts par d\u00e9viation standard :Type Internet",
    "stats_mesure_audience_podcast_standard_deviation_internet_mobile": "Statistiques des podcasts par d\u00e9viation standard :Type Internet mobile",



    "stats_mesure_audience_vod_by_id_standard_deviation_all": "Statistiques des vid\u00e9os par d\u00e9viation standard et par id :Type Tous",
    "stats_mesure_audience_vod_by_id_standard_deviation_internet": "Statistiques des vid\u00e9os par d\u00e9viation standard et par id :Type Internet",
    "stats_mesure_audience_vod_by_id_standard_deviation_intranet": "Statistiques des vid\u00e9os par d\u00e9viation standard et par id :Type Intranet",
    "stats_mesure_audience_vod_by_id_standard_deviation_internet_mobile": "Statistiques des vid\u00e9os par d\u00e9viation standard et par id :Type Internet mobile",
    "stats_mesure_audience_vod_by_id_standard_deviation_intranet_mobile": "Statistiques des vid\u00e9os par d\u00e9viation standard et par id :Type Intranet mobile",


    "stats_mesure_audience_podcast_by_id_standard_deviation_all": "Statistiques des podcasts par d\u00e9viation standard et par id :Type Tous",
    "stats_mesure_audience_podcast_by_id_standard_deviation_internet": "Statistiques des podcasts par d\u00e9viation standard et par id :Type Internet",
    "stats_mesure_audience_podcast_by_id_standard_deviation_internet_mobile": "Statistiques des podcasts par d\u00e9viation standard et par id :Type Internet mobile",


    "stats_mesure_audience_live_standard_deviation_all": "Statistiques des directs par d\u00e9viation standard :Type Tous",
    "stats_mesure_audience_live_standard_deviation_internet": "Statistiques des directs par d\u00e9viation standard :Type Internet",
    "stats_mesure_audience_live_standard_deviation_intranet": "Statistiques des directs par d\u00e9viation standard :Type Inrtranet",
    "stats_mesure_audience_live_standard_deviation_internet_mobile": "Statistiques des directs par d\u00e9viation standard :Type Internet mobile",
    "stats_mesure_audience_live_standard_deviation_intranet_mobile": "Statistiques des directs par d\u00e9viation standard :Type Intranet mobile",


    "stats_mesure_audience_live_by_id_standard_deviation_all": "Statistiques des directs par d\u00e9viation standard et par id :Type Tous",
    "stats_mesure_audience_live_by_id_standard_deviation_internet": "Statistiques des directs par d\u00e9viation standard et par id :Type Internet",
    "stats_mesure_audience_live_by_id_standard_deviation_intranet": "Statistiques des directs par d\u00e9viation standard et par id :Type Inrtranet",
    "stats_mesure_audience_live_by_id_standard_deviation_internet_mobile": "Statistiques des directs par d\u00e9viation standard et par id :Type Internet mobile",
    "stats_mesure_audience_live_by_id_standard_deviation_intranet_mobile": "Statistiques des directs par d\u00e9viation standard et par id :Type Intranet mobile",


    "stats_mesure_engagement_vod_mesure_by_ip_all": "Statistiques des vid\u00e9os par ip :Type Tous",
    "stats_mesure_engagement_vod_mesure_by_ip_internet": "Statistiques des vid\u00e9os par ip :Type Internet",
    "stats_mesure_engagement_vod_mesure_by_ip_intranet": "Statistiques des vid\u00e9os par ip :Type Intranet",
    "stats_mesure_engagement_vod_mesure_by_ip_internet_mobile": "Statistiques des vid\u00e9os par ip :Type Internet mobile",
    "stats_mesure_engagement_vod_mesure_by_ip_intranet_mobile": "Statistiques des vid\u00e9os par ip :Type Intranet mobile",


    "stats_mesure_engagement_podcast_mesure_by_ip_all": "Statistiques des podcasts par ip :Type Tous",
    "stats_mesure_engagement_podcast_mesure_by_ip_internet": "Statistiques des podcasts par ip :Type Internet",
    "stats_mesure_engagement_podcast_mesure_by_ip_internet_mobile": "Statistiques des podcasts par ip :Type Internet mobile",

    "stats_mesure_engagement_vod_by_id_mesure_by_ip_all": "Statistiques des vid\u00e9os par ip et par id :Type Tous",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_internet": "Statistiques des vid\u00e9os par ip et par id :Type Internet",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_intranet": "Statistiques des vid\u00e9os par ip et par id :Type Intranet",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_internet_mobile": "Statistiques des vid\u00e9os par ip et par id :Type Internet mobile",
    "stats_mesure_engagement_vod_by_id_mesure_by_ip_intranet_mobile": "Statistiques des vid\u00e9os par ip et par id :Type Intranet mobile",

    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_all": "Statistiques des podcasts par ip et par id :Type Tous",
    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_internet": "Statistiques des podcasts par ip et par id :Type Internet",
    "stats_mesure_engagement_podcast_by_id_mesure_by_ip_internet_mobile": "Statistiques des podcasts par ip et par id :Type Internet mobile",

    "stats_mesure_engagement_live_mesure_by_ip_all": "Statistiques des directs par ip :Type Tous",
    "stats_mesure_engagement_live_mesure_by_ip_internet": "Statistiques des directs par ip :Type Internet",
    "stats_mesure_engagement_live_mesure_by_ip_intranet": "Statistiques des directs par ip :Type Intranet",
    "stats_mesure_engagement_live_mesure_by_ip_internet_mobile": "Statistiques des directs par ip :Type Internet mobile",
    "stats_mesure_engagement_live_mesure_by_ip_intranet_mobile": "Statistiques des directs par ip :Type Intranet mobile",

    "stats_mesure_engagement_live_by_id_mesure_by_ip_all": "Statistiques des directs par ip et par id :Type Tous",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_internet": "Statistiques des directs par ip et par id :Type Internet",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_intranet": "Statistiques des directs par ip et par id :Type Intranet",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_internet_mobile": "Statistiques des directs par ip et par id :Type Internet mobile",
    "stats_mesure_engagement_live_by_id_mesure_by_ip_intranet_mobile": "Statistiques des directs par ip et par id :Type Intranet mobile",

    "stats_mesure_engagement_vod_taux_rebond_all": "Statistiques des vid\u00e9os par Taux rebond :Type Tous",
    "stats_mesure_engagement_vod_taux_rebond_internet": "Statistiques des vid\u00e9os par Taux rebond :Type Internet",
    "stats_mesure_engagement_vod_taux_rebond_intranet": "Statistiques des vid\u00e9os par Taux rebond :Type Intranet",
    "stats_mesure_engagement_vod_taux_rebond_internet_mobile": "Statistiques des vid\u00e9os par Taux rebond :Type Internet mobile",
    "stats_mesure_engagement_vod_taux_rebond_intranet_mobile": "Statistiques des vid\u00e9os par Taux rebond :Type Intranet mobile",


    "stats_mesure_engagement_podcast_taux_rebond_all": "Statistiques des podcasts par Taux rebond :Type Tous",
    "stats_mesure_engagement_podcast_taux_rebond_internet": "Statistiques des podcasts par Taux rebond :Type Internet",
    "stats_mesure_engagement_podcast_taux_rebond_internet_mobile": "Statistiques des podcasts par Taux rebond :Type Internet mobile",

    "stats_mesure_engagement_vod_by_id_taux_rebond_all": "Statistiques des vid\u00e9os par Taux rebond et par id :Type Tous",
    "stats_mesure_engagement_vod_by_id_taux_rebond_internet": "Statistiques des vid\u00e9os par Taux rebond et par id :Type Internet",
    "stats_mesure_engagement_vod_by_id_taux_rebond_intranet": "Statistiques des vid\u00e9os par Taux rebond et par id :Type Intranet",
    "stats_mesure_engagement_vod_by_id_taux_rebond_internet_mobile": "Statistiques des vid\u00e9os par Taux rebond et par id :Type Internet mobile",
    "stats_mesure_engagement_vod_by_id_taux_rebond_intranet_mobile": "Statistiques des vid\u00e9os par Taux rebond et par id :Type Intranet mobile",


    "stats_mesure_engagement_podcast_by_id_taux_rebond_all": "Statistiques des podcasts par Taux rebond et par id :Type Tous",
    "stats_mesure_engagement_podcast_by_id_taux_rebond_internet": "Statistiques des podcasts par Taux rebond et par id :Type Internet",
    "stats_mesure_engagement_podcast_by_id_taux_rebond_internet_mobile": "Statistiques des podcasts par Taux rebond et par id :Type Internet mobile",


    "stats_mesure_engagement_live_taux_rebond_all": "Statistiques des directs par Taux rebond :Type Tous",
    "stats_mesure_engagement_live_taux_rebond_internet": "Statistiques des directs par Taux rebond :Type Internet",
    "stats_mesure_engagement_live_taux_rebond_intranet": "Statistiques des directs par Taux rebond :Type Intranet",
    "stats_mesure_engagement_live_taux_rebond_internet_mobile": "Statistiques des directs par Taux rebond :Type Internet mobile",
    "stats_mesure_engagement_live_taux_rebond_intranet_mobile": "Statistiques des directs par Taux rebond :Type Intranet mobile",

    "stats_mesure_engagement_live_by_id_taux_rebond_all": "Statistiques des directs par Taux rebond et par id :Type Tous",
    "stats_mesure_engagement_live_by_id_taux_rebond_internet": "Statistiques des directs par Taux rebond et par id :Type Internet",
    "stats_mesure_engagement_live_by_id_taux_rebond_intranet": "Statistiques des directs par Taux rebond et par id :Type Intranet",
    "stats_mesure_engagement_live_by_id_taux_rebond_internet_mobile": "Statistiques des directs par Taux rebond et par id :Type Internet mobile",
    "stats_mesure_engagement_live_by_id_taux_rebond_intranet_mobile": "Statistiques des directs par Taux rebond et par id :Type Intranet mobile",

    "stats_geo_vod_geo_per_pays_all": "Statistiques des vid\u00e9os par pays :Type Tous",
    "stats_geo_vod_geo_per_pays_internet": "Statistiques des vid\u00e9os par pays :Type Internet",
    "stats_geo_vod_geo_per_pays_intranet": "Statistiques des vid\u00e9os par pays :Type Intranet",
    "stats_geo_vod_geo_per_pays_internet_mobile": "Statistiques des vid\u00e9os par pays :Type Internet mobile",
    "stats_geo_vod_geo_per_pays_intranet_mobile": "Statistiques des vid\u00e9os par pays :Type Intranet mobile",
    "stats_geo_live_geo_per_pays_all": "Statistiques des directs par pays :Type Tous",
    "stats_geo_live_geo_per_pays_internet": "Statistiques des directs par pays :Type Internet",
    "stats_geo_live_geo_per_pays_intranet": "Statistiques des directs par pays :Type Intranet",
    "stats_geo_live_geo_per_pays_internet_mobile": "Statistiques des directs par pays :Type Internet mobile",
    "stats_geo_live_geo_per_pays_intranet_mobile": "Statistiques des directs par pays :Type Intranet mobile",

    "stats_geo_podcast_geo_per_pays_all": "Statistiques des podcasts par pays :Type Tous",
    "stats_geo_podcast_geo_per_pays_internet": "Statistiques des podcasts par pays :Type Internet",
    "stats_geo_podcast_geo_per_pays_internet_mobile": "Statistiques des podcasts par pays :Type Internet mobile",


    "stats_geo_vod_by_id_geo_per_pays_all": "Statistiques des vid\u00e9os par pays et par id :Type Tous",
    "stats_geo_vod_by_id_geo_per_pays_internet": "Statistiques des vid\u00e9os par pays et par id :Type Internet",
    "stats_geo_vod_by_id_geo_per_pays_intranet": "Statistiques des vid\u00e9os par pays et par id :Type Intranet",
    "stats_geo_vod_by_id_geo_per_pays_internet_mobile": "Statistiques des vid\u00e9os par pays et par id :Type Internet mobile",
    "stats_geo_vod_by_id_geo_per_pays_intranet_mobile": "Statistiques des vid\u00e9os par pays et par id :Type Intranet mobile",
    "stats_geo_live_by_id_geo_per_pays_all": "Statistiques des directs par pays et par id :Type Tous",
    "stats_geo_live_by_id_geo_per_pays_internet": "Statistiques des directs par pays et par id :Type Internet",
    "stats_geo_live_by_id_geo_per_pays_intranet": "Statistiques des directs par pays et par id :Type Intranet",
    "stats_geo_live_by_id_geo_per_pays_internet_mobile": "Statistiques des directs par pays et par id :Type Internet mobile",
    "stats_geo_live_by_id_geo_per_pays_intranet_mobile": "Statistiques des directs par pays et par id :Type Intranet mobile",

    "stats_geo_podcast_by_id_geo_per_pays_all": "Statistiques des podcasts par pays et par id :Type Tous",
    "stats_geo_podcast_by_id_geo_per_pays_internet": "Statistiques des podcasts par pays et par id :Type Internet",
    "stats_geo_podcast_by_id_geo_per_pays_internet_mobile": "Statistiques des podcasts par pays et par id :Type Internet mobile",


    "stats_engagement_vod_duree_per_visite_all": "Statistiques des vid\u00e9os par dur\u00e9e :Type Tous",
    "stats_engagement_vod_duree_per_visite_internet": "Statistiques des vid\u00e9os par dur\u00e9e :Type Internet",
    "stats_engagement_vod_duree_per_visite_intranet": "Statistiques des vid\u00e9os par dur\u00e9e :Type Intranet",
    "stats_engagement_vod_duree_per_visite_internet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e :Type Internet mobile",
    "stats_engagement_vod_duree_per_visite_intranet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e :Type Intranet mobile",


    "stats_engagement_podcast_duree_per_visite_all": "Statistiques des podcasts par dur\u00e9e :Type Tous",
    "stats_engagement_podcast_duree_per_visite_internet": "Statistiques des podcasts par dur\u00e9e :Type Internet",
    "stats_engagement_podcast_duree_per_visite_internet_mobile": "Statistiques des podcasts par dur\u00e9e :Type Internet mobile",


    "stats_engagement_vod_by_id_duree_per_visite_all": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Tous",
    "stats_engagement_vod_by_id_duree_per_visite_internet": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Internet",
    "stats_engagement_vod_by_id_duree_per_visite_intranet": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Intranet",
    "stats_engagement_vod_by_id_duree_per_visite_internet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Internet mobile",
    "stats_engagement_vod_by_id_duree_per_visite_intranet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Intranet mobile",


    "stats_engagement_podcast_by_id_duree_per_visite_all": "Statistiques des podcasts par dur\u00e9e et par id :Type Tous",
    "stats_engagement_podcast_by_id_duree_per_visite_internet": "Statistiques des podcasts par dur\u00e9e et par id :Type Internet",
    "stats_engagement_podcast_by_id_duree_per_visite_internet_mobile": "Statistiques des podcasts par dur\u00e9e et par id :Type Internet mobile",

    "stats_engagement_live_duree_per_visite_all": "Statistiques des directs par dur\u00e9e :Type Tous",
    "stats_engagement_live_duree_per_visite_internet": "Statistiques des directs par dur\u00e9e :Type Internet",
    "stats_engagement_live_duree_per_visite_intranet": "Statistiques des directs par dur\u00e9e :Type Intranet",
    "stats_engagement_live_duree_per_visite_internet_mobile": "Statistiques des directs par dur\u00e9e :Type Internet mobile",
    "stats_engagement_live_duree_per_visite_intranet_mobile": "Statistiques des directs par dur\u00e9e :Type Intranet mobile",

    "stats_engagement_live_by_id_duree_per_visite_all": "Statistiques des directs par dur\u00e9e et par id :Type Tous",
    "stats_engagement_live_by_id_duree_per_visite_internet": "Statistiques des directs par dur\u00e9e et par id :Type Internet",
    "stats_engagement_live_by_id_duree_per_visite_intranet": "Statistiques des directs par dur\u00e9e et par id :Type Intranet",
    "stats_engagement_live_by_id_duree_per_visite_internet_mobile": "Statistiques des directs par dur\u00e9e et par id :Type Internet mobile",
    "stats_engagement_live_by_id_duree_per_visite_intranet_mobile": "Statistiques des directs par dur\u00e9e et par id :Type Intranet mobile",

    "stats_engagement_vod_most_popular_all": "Statistiques des vid\u00e9os par popularit\u00e9 :Type Tous",
    "stats_engagement_vod_most_popular_internet": "Statistiques des vid\u00e9os par popularit\u00e9 :Type Internet",
    "stats_engagement_vod_most_popular_intranet": "Statistiques des vid\u00e9os par popularit\u00e9 :Type Intranet",
    "stats_engagement_vod_most_popular_internet_mobile": "Statistiques des vid\u00e9os par popularit\u00e9 :Type Internet mobile",
    "stats_engagement_vod_most_popular_intranet_mobile": "Statistiques des vid\u00e9os par popularit\u00e9 :Type Intranet mobile",


    "stats_engagement_podcast_most_popular_all": "Statistiques des podcasts par popularit\u00e9 :Type Tous",
    "stats_engagement_podcast_most_popular_internet": "Statistiques des podcasts par popularit\u00e9 :Type Internet",
    "stats_engagement_podcast_most_popular_internet_mobile": "Statistiques des podcasts par popularit\u00e9 :Type Internet mobile",


    "stats_engagement_vod_by_id_most_popular_all": "Statistiques des vid\u00e9os par popularit\u00e9 et par id :Type Tous",
    "stats_engagement_vod_by_id_most_popular_internet": "Statistiques des vid\u00e9os par popularit\u00e9 et par id :Type Internet",
    "stats_engagement_vod_by_id_most_popular_intranet": "Statistiques des vid\u00e9os par popularit\u00e9 et par id :Type Intranet",
    "stats_engagement_vod_by_id_most_popular_internet_mobile": "Statistiques des vid\u00e9os par popularit\u00e9 et par id :Type Internet mobile",
    "stats_engagement_vod_by_id_most_popular_intranet_mobile": "Statistiques des vid\u00e9os par popularit\u00e9 et par id :Type Intranet mobile",


    "stats_engagement_podcast_by_id_most_popular_all": "Statistiques des podcasts par popularit\u00e9 et par id :Type Tous",
    "stats_engagement_podcast_by_id_most_popular_internet": "Statistiques des podcasts par popularit\u00e9 et par id :Type Internet",
    "stats_engagement_podcast_by_id_most_popular_internet_mobile": "Statistiques des podcasts par popularit\u00e9 et par id :Type Internet mobile",

    "stats_engagement_live_most_popular_all": "Statistiques des directs par popularit\u00e9 :Type Tous",
    "stats_engagement_live_most_popular_internet": "Statistiques des directs par popularit\u00e9 :Type Internet",
    "stats_engagement_live_most_popular_intranet": "Statistiques des directs par popularit\u00e9 :Type Intranet",
    "stats_engagement_live_most_popular_internet_mobile": "Statistiques des directs par popularit\u00e9 :Type Internet mobile",
    "stats_engagement_live_most_popular_intranet_mobile": "Statistiques des directs par popularit\u00e9 :Type Intranet mobile",

    "stats_engagement_live_by_id_most_popular_all": "Statistiques des directs par popularit\u00e9 et par id :Type Tous",
    "stats_engagement_live_by_id_most_popular_internet": "Statistiques des directs par popularit\u00e9 et par id :Type Internet",
    "stats_engagement_live_by_id_most_popular_intranet": "Statistiques des directs par popularit\u00e9 et par id :Type Intranet",
    "stats_engagement_live_by_id_most_popular_internet_mobile": "Statistiques des directs par popularit\u00e9 et par id :Type Internet mobile",
    "stats_engagement_live_by_id_most_popular_intranet_mobile": "Statistiques des directs par popularit\u00e9 et par id :Type Intranet mobile",

    "stats_engagement_vod_visits_per_ip_all": "Statistiques des vid\u00e9os par IPs :Type Tous",
    "stats_engagement_vod_visits_per_ip_internet": "Statistiques des vid\u00e9os par IPs :Type Internet",
    "stats_engagement_vod_visits_per_ip_intranet": "Statistiques des vid\u00e9os par IPs :Type Intranet",
    "stats_engagement_vod_visits_per_ip_internet_mobile": "Statistiques des vid\u00e9os par IPs :Type Internet mobile",
    "stats_engagement_vod_visits_per_ip_intranet_mobile": "Statistiques des vid\u00e9os par IPs :Type Intranet mobile",


    "stats_engagement_podcast_visits_per_ip_all": "Statistiques des podcasts par IPs :Type Tous",
    "stats_engagement_podcast_visits_per_ip_internet": "Statistiques des podcasts par IPs :Type Internet",
    "stats_engagement_podcast_visits_per_ip_internet_mobile": "Statistiques des podcasts par IPs :Type Internet mobile",

    "stats_engagement_vod_by_id_visits_per_ip_all": "Statistiques des vid\u00e9os par IPs et par id :Type Tous",
    "stats_engagement_vod_by_id_visits_per_ip_internet": "Statistiques des vid\u00e9os par IPs et par id :Type Internet",
    "stats_engagement_vod_by_id_visits_per_ip_intranet": "Statistiques des vid\u00e9os par IPs et par id :Type Intranet",
    "stats_engagement_vod_by_id_visits_per_ip_internet_mobile": "Statistiques des vid\u00e9os par IPs et par id :Type Internet mobile",
    "stats_engagement_vod_by_id_visits_per_ip_intranet_mobile": "Statistiques des vid\u00e9os par IPs et par id :Type Intranet mobile",


    "stats_engagement_podcast_by_id_visits_per_ip_all": "Statistiques des podcasts par IPs et par id :Type Tous",
    "stats_engagement_podcast_by_id_visits_per_ip_internet": "Statistiques des podcasts par IPs et par id :Type Internet",
    "stats_engagement_podcast_by_id_visits_per_ip_internet_mobile": "Statistiques des podcasts par IPs et par id :Type Internet mobile",


    "stats_engagement_live_visits_per_ip_all": "Statistiques des directs par IPs :Type Tous",
    "stats_engagement_live_visits_per_ip_internet": "Statistiques des directs par IPs :Type Internet",
    "stats_engagement_live_visits_per_ip_intranet": "Statistiques des directs par IPs :Type Intranet",
    "stats_engagement_live_visits_per_ip_internet_mobile": "Statistiques des directs par IPs :Type Internet mobile",
    "stats_engagement_live_visits_per_ip_intranet_mobile": "Statistiques des directs par IPs :Type Intranet mobile",

    "stats_engagement_live_by_id_visits_per_ip_all": "Statistiques des directs par IPs et par id :Type Tous",
    "stats_engagement_live_by_id_visits_per_ip_internet": "Statistiques des directs par IPs et par id :Type Internet",
    "stats_engagement_live_by_id_visits_per_ip_intranet": "Statistiques des directs par IPs et par id :Type Intranet",
    "stats_engagement_live_by_id_visits_per_ip_internet_mobile": "Statistiques des directs par IPs et par id :Type Internet mobile",
    "stats_engagement_live_by_id_visits_per_ip_intranet_mobile": "Statistiques des directs par IPs et par id :Type Intranet mobile",

    "stats_audience_vod_audience_all": "Statistiques des vid\u00e9os par audience :Type Tous",
    "stats_audience_vod_audience_internet": "Statistiques des vid\u00e9os par audience :Type Internet",
    "stats_audience_vod_audience_intranet": "Statistiques des vid\u00e9os par audience :Type Intranet",
    "stats_audience_vod_audience_internet_mobile": "Statistiques des vid\u00e9os par audience :Type Internet mobile",
    "stats_audience_vod_audience_intranet_mobile": "Statistiques des vid\u00e9os par audience :Type Intranet mobile",

    "stats_audience_podcast_audience_all": "Statistiques des podcasts par audience :Type Tous",
    "stats_audience_podcast_audience_internet": "Statistiques des podcasts par audience :Type Internet",
    "stats_audience_podcast_audience_internet_mobile": "Statistiques des podcasts par audience :Type Internet mobile",

    "stats_audience_vod_by_id_audience_all": "Statistiques des vid\u00e9os par audience et par id :Type Tous",
    "stats_audience_vod_by_id_audience_internet": "Statistiques des vid\u00e9os par audience et par id :Type Internet",
    "stats_audience_vod_by_id_audience_intranet": "Statistiques des vid\u00e9os par audience et par id :Type Intranet",
    "stats_audience_vod_by_id_audience_internet_mobile": "Statistiques des vid\u00e9os par audience et par id :Type Internet mobile",
    "stats_audience_vod_by_id_audience_intranet_mobile": "Statistiques des vid\u00e9os par audience et par id :Type Intranet mobile",


    "stats_audience_podcast_by_id_audience_all": "Statistiques des podcasts par audience et par id :Type Tous",
    "stats_audience_podcast_by_id_audience_internet": "Statistiques des podcasts par audience et par id :Type Internet",
    "stats_audience_podcast_by_id_audience_internet_mobile": "Statistiques des podcasts par audience et par id :Type Internet mobile",

    "stats_audience_live_audience_all": "Statistiques des directs par audience :Type Tous",
    "stats_audience_live_audience_internet": "Statistiques des directs par audience :Type Internet",
    "stats_audience_live_audience_intranet": "Statistiques des directs par audience :Type Intranet",
    "stats_audience_live_audience_internet_mobile": "Statistiques des directs par audience :Type Internet mobile",
    "stats_audience_live_audience_intranet_mobile": "Statistiques des directs par audience :Type Intranet mobile",

    "stats_audience_live_by_id_audience_all": "Statistiques des directs par audience et par id :Type Tous",
    "stats_audience_live_by_id_audience_internet": "Statistiques des directs par audience et par id :Type Internet",
    "stats_audience_live_by_id_audience_intranet": "Statistiques des directs par audience et par id :Type Intranet",
    "stats_audience_live_by_id_audience_internet_mobile": "Statistiques des directs par audience et par id :Type Internet mobile",
    "stats_audience_live_by_id_audience_intranet_mobile": "Statistiques des directs par audience et par id :Type Intranet mobile",

    "stats_audience_vod_duree_all": "Statistiques des vid\u00e9os par dur\u00e9e :Type Tous",
    "stats_audience_vod_duree_internet": "Statistiques des vid\u00e9os par dur\u00e9e :Type Internet",
    "stats_audience_vod_duree_intranet": "Statistiques des vid\u00e9os par dur\u00e9e :Type Intranet",
    "stats_audience_vod_duree_internet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e :Type Internet mobile",
    "stats_audience_vod_duree_intranet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e :Type Intranet mobile",


    "stats_audience_podcast_duree_all": "Statistiques des podcasts par dur\u00e9e :Type Tous",
    "stats_audience_podcast_duree_internet": "Statistiques des podcasts par dur\u00e9e :Type Internet",
    "stats_audience_podcast_duree_internet_mobile": "Statistiques des podcasts par dur\u00e9e :Type Internet mobile",

    "stats_audience_vod_by_id_duree_all": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Tous",
    "stats_audience_vod_by_id_duree_internet": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Internet",
    "stats_audience_vod_by_id_duree_intranet": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Intranet",
    "stats_audience_vod_by_id_duree_internet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Internet mobile",
    "stats_audience_vod_by_id_duree_intranet_mobile": "Statistiques des vid\u00e9os par dur\u00e9e et par id :Type Intranet mobile",

    "stats_audience_podcast_by_id_duree_all": "Statistiques des podcasts par dur\u00e9e et par id :Type Tous",
    "stats_audience_podcast_by_id_duree_internet": "Statistiques des podcasts par dur\u00e9e et par id :Type Internet",
    "stats_audience_podcast_by_id_duree_internet_mobile": "Statistiques des podcasts par dur\u00e9e et par id :Type Internet mobile",


    "stats_audience_live_duree_all": "Statistiques des directs par dur\u00e9e :Type Tous",
    "stats_audience_live_duree_internet": "Statistiques des directs par dur\u00e9e :Type Internet",
    "stats_audience_live_duree_intranet": "Statistiques des directs par dur\u00e9e :Type Intranet",
    "stats_audience_live_duree_internet_mobile": "Statistiques des directs par dur\u00e9e :Type Internet mobile",
    "stats_audience_live_duree_intranet_mobile": "Statistiques des directs par dur\u00e9e :Type Intranet mobile",


    "stats_audience_live_by_id_duree_all": "Statistiques des directs par dur\u00e9e et par id :Type Tous",
    "stats_audience_live_by_id_duree_internet": "Statistiques des directs par dur\u00e9e et par id :Type Internet",
    "stats_audience_live_by_id_duree_intranet": "Statistiques des directs par dur\u00e9e et par id :Type Intranet",
    "stats_audience_live_by_id_duree_internet_mobile": "Statistiques des directs par dur\u00e9e et par id :Type Internet mobile",
    "stats_audience_live_by_id_duree_intranet_mobile": "Statistiques des directs par dur\u00e9e et par id :Type Intranet mobile",



    "stats_vod_all": "Statistiques des vid\u00e9os",
    "stats_podcast_all": "Statistiques des podcasts",
    "stats_vod_audience": "Statistiques des vid\u00e9os : Audience",
    "stats_podcast_audience": "Statistiques des podcasts : Audience",
    "stats_vod_technologie": "Statistiques des vid\u00e9os: Technologie",
    "stats_podcast_technologie": "Statistiques des podcasts: Technologie",
    "stats_vod_engagement": "Statistiques des vid\u00e9os: Engagement",
    "stats_podcast_engagement": "Statistiques des podcasts: Engagement",
    "stats_vod_mobile": "Statistiques des vid\u00e9os: Mobile",
    "stats_podcast_mobile": "Statistiques des vpodcasts: Mobile",
    "stats_vod_temp_reel": "Statistiques des vid\u00e9os: Temps r\u00e9el",
    "stats_podcast_temp_reel": "Statistiques des podcasts: Temps r\u00e9el",
    "stats_live_all": "Statistiques des directs",
    "stats_live_audience": "Statistiques des directs: Audience",
    "stats_live_technologie": "Statistiques des directs: Technologie",
    "stats_live_engagement": "Statistiques des directs: Engagement",
    "stats_live_mobile": "Statistiques des directs: Mobile",
    "stats_live_temp_reel": "Statistiques des directs: Temps r\u00e9el",
    "stats_vod_by_id_all": "Statistiques des vid\u00e9os par id",
    "stats_podcast_by_id_all": "Statistiques des podcasts par id",
    "stats_vod_by_id_audience": "Statistiques des vid\u00e9os par id : Audience",
    "stats_podcast_by_id_audience": "Statistiques des podcasts par id : Audience",
    "stats_vod_by_id_technologie": "Statistiques des vid\u00e9os par id : Technologie",
    "stats_podcast_by_id_technologie": "Statistiques des podcasts par id : Technologie",
    "stats_vod_by_id_engagement": "Statistiques des vid\u00e9os par id : Engagement",
    "stats_podcast_by_id_engagement": "Statistiques des podcasts par id : Engagement",
    "stats_vod_by_id_mobile": "Statistiques des vid\u00e9os par id : Mobile",
    "stats_podcast_by_id_mobile": "Statistiques des podcasts par id : Mobile",
    "stats_vod_by_id_temp_reel": "Statistiques des vid\u00e9os par id : Temps r\u00e9el",
    "stats_podcast_by_id_temp_reel": "Statistiques des podcasts par id : Temps r\u00e9el",
    "stats_live_by_id_all": "Statistiques des directs par id",
    "stats_live_by_id_audience": "Statistiques des directs par id:  Audience",
    "stats_live_by_id_technologie": "Statistiques des directs par id : Technologie",
    "stats_live_by_id_engagement": "Statistiques des directs par id : Engagement",
    "stats_live_by_id_mobile": "Statistiques des directs par id :  Mobile",
    "stats_live_by_id_temp_reel": "Statistiques des directs par id :  Temps r\u00e9el",
    "stats_engagement": "Statistiques des engagements",
    "stats_dashboard_dashboard_no_api_route": "Statistiques tableau de bord",
    "stats_acces_list_acces": "Liste d'acc\u00e9s",
    "stats_acces_detail": "D\u00e9tails d'acc\u00e9s",
    "stats_bande_passante_post_bande_passante": "Statistiques bande passante",
    "stats_storage_post_storage": "Statistiques stockage",
    "dashboard_most_popular": "Les plus populaires",
    "dashboard_page": "Page tableau de bord",
    "specifics_directions_post_add": "Ajout d'une direction",
    "specifics_directions_post_edit": "Modification d'une direction",
    "specifics_directions_list_dtable_direction": "Liste des directions",
    "specifics_directions_delete_direction": "Suppression d'une direction",
    "specifics_directions_delete_multi": "Suppression des directions",
    "specifics_directions_get_detail": "D\u00e9tails d'une direction",
    "parameters_canal_configuration_canal_no_api": "Configuration du canal",
    "questions_quiz_get_responses": "List des questions et quiz",
    "podcast_post_add": "Ajout d'un podcast",
    "podcast_post_edit": "Modification d'un podcast",
    "podcast_list_dtable": "Liste des podcasts",
    "podcast_get_detail": "Détails d'un podcast",
    "podcast_delete_podcast": "Supprimer un podcast",
    "podcast_multi_delete": "Supprimer les podcasts",
    "podcast_url_export": "Export d'un podcast",
    "referrers_list_dtable": "Liste des r\u00e9f\u00e9rent",
    "referrers_post_add": "Ajout d'un r\u00e9f\u00e9rent",
    "referrers_post_edit": "Modification d'un r\u00e9f\u00e9rent",
    "referrers_delete": "Suppression d'un r\u00e9f\u00e9rent",
    "referrers_delete_multi": "Suppression des r\u00e9f\u00e9rent",
    "display_schedule_get_reload": "Actualiser l'affichage sur le boitier(Grille de programme)",
    "configuration_rmbox_get_reload": "Actualiser l'affichage sur le boitier(RmBox)",
    "stats_mooc_course_no_api": "Statistiques des cours",
    "stats_mooc_performance_no_api": "Statistiques performance",
    "stats_mooc_video_no_api": "Statistiques des vidéos",
    "stats_mooc_mooc_total_number_registrations": "Nombre total des inscriptions",
    "stats_mooc_mooc_number_on_going_registrations": "Nombre des inscriptions en cours",
    "stats_mooc_mooc_increase_in_registrations_in_the_last_week": "Augmentation des inscriptions dans la dernière semaine",
    "stats_mooc_mooc_number_learners_tried_problem": "Nombre total de ceux qui ont essayé un problème",
    "stats_mooc_mooc_number_active_learners": "Nombre total d'apprenants actifs",
    "stats_mooc_mooc_watching_videos_learners": "Nombre total de ceux qui ont regardé une vidéo",
    "stats_mooc_list_dtable_parameters_themes_mooc": "Statistique par thème",
    "stats_mooc_mooc_number_correct_incorrect_responses": "Mooc performance",
    "stats_mooc_participation_of_learners": "Graphe de participation des apprenants",
    "stats_mooc_mooc_number_complete_incomplete_video": "Mooc vues",
    "mooc_delete_multi": "Suppression des MOOCs",
    "mooc_get_detail": "D\u00e9tails MOOC",
    "mooc_post_add": " Ajout d'un MOOC",
    "mooc_post_edit": "Modification d'un MOOC",
    "mooc_list_dtable_params": "Liste des MOOCs",
    "mooc_delete_param": "Suppression d'une MOOC",
    "configuration_newss_post_add": "Ajout d'une actualité",
    "configuration_newss_post_edit": "Modification d'une actualité",
    "configuration_newss_list_dtable_news": "Liste des actualités",
    "configuration_newss_delete_new": "Suppression d'une actualité",
    "configuration_newss_multi_delete": "Suppression des actualités",
    "configuration_newss_get_detail": "Détail d'une actualité",
    "event_export_no_api": "Liens d'export",
    "stats_list_videos_list_dtable_videos_stats": "Datatable liste des vidéos",
    "stats_export_export_no_api": "Statistiques d'export",
    "configuration_zone_stat_zone_no_api": "Statistiques zone",
    "profiles_user_edit_password_no_api": "Modifier mot de passe",
    "profiles_group_permission_no_api": "Gérer les permissions",
    "playlist_playlist_link": "Visualiser playlist",
    "event_stats_no_api": "Statistiques \u00e9v\u00e9nement",
    "support_documentation_no_api": "Guide utilisateur",
    "support_key_no_api": "Clé de l'api",
    "player_parameters_list_no_api": "Liste des paramètres player",
    "media_video_transcription_auto_no_api": "Transcription automatique",
    "media_video_transcription_reload_no_api": "Transcription avec relecture",
    "configuration_rmbox_list_intervention_no_api": "Liste des interventions",
    "configuration_rmbox_add_intervention_no_api": "Ajout intervention",
    "configuration_rmbox_delete_intervention_no_api": "Supprimer intervention",
    "configuration_rmbox_edit_intervention_no_api": "Modifier intervention",



    "media_video_add_option_import":"Importer vidéo",
    "media_video_add_option_extern_link":"Ajout d'un lien externe",
    "media_video_add_option_on_hold":"Ajout vidéo en attente",
    "media_video_add_option_on_hold_sftp":"Ajout vidéo sftp en attente",
    "media_video_add_option_webcam":"Ajout d'un webcam",
    "media_video_add_option_presentation":"Ajout d'une presentation",
    "media_video_add_option_story_board":"Ajout d'un storyboard",


    "media_video_setting":"Paramètres vidéo",
    "send_email_validation":"Validation d'envoi mail",
    "media_video_list_dtable_show_like":"Afficher j'aime vidéo",
    "media_video_list_dtable_show_not_like":"Afficher j'aime vidéo",
    "media_video_list_dtable_show_vote":"Afficher vote vidéo",

    "lives_conf_configs_before_live":"Configuration avant direct",
    "lives_conf_message_option":"Configuration message avant direct",
    "lives_conf_video_option":"Configuration vidéo avant direct",
    "lives_conf_image_option":"Configuration image avant direct",
    "lives_conf_counter_option":"Configuration compteur avant direct",
    "lives_conf_pearl_option":"Configuration station des directs",


    "lives_fo_comment_confirmation_no_api":"Confirmation commentaire",


    "pearl_encoder_settings":"Paramètres encodeur pearl",
    "pearl_encoder_interaction":"Intéraction encodeur pearl",
    "pearl_encoder_vue_web":"Encoder face web",
    "pearl_encoder_button_conf":"Configuration encodeur pearl",


    "lives_rich_media_slides_no_api":"Rich média des dispositions",
    "lives_rich_media_question_no_api":"Rich média des questions",
    "lives_rich_media_chapter_no_api":"Rich média des chapitres",
    "lives_dtable_show_like":"Afficher j'aime direct ",
    "lives_dtable_show_not_like":"Afficher j'aime pas direct",
    "lives_dtable_show_vote":"Afficher vote direct",
    "lives_dtable_preview_video":"Aperçu direct",


    "playlist_playlist_show_media":"Afficher médias playlist",


    "playlist_live_list_dtable":"Datatable List des directs",
    "playlist_live_post_add":"Ajout direct ",
    "configuration_rmbox_activate_playlist_no_api":"Configuration rmbox",


    "display_template_get_ten_templates":"Récupérer 10 templates",
    "display_template_show_media":"Afficher média template",


    "display_new_template_post_add":"Ajout template",
    "display_new_template_post_edit":"Modifier template",
    "display_new_template_list_dtable":"Datatable Liste des templates",
    "display_new_template_get_templates":"Récupérer tous les templates",
    "display_new_template_get_ten_templates":"Récupérer 10 templates",
    "display_new_template_get_template":"Récupérer la template",
    "display_new_template_delete_many":"Multi-delete des templates",
    "display_new_template_delete_one":"Effacer une template",
    "display_new_template_duplicate":"Duplication de template",
    "display_new_template_list_dtable_ongoing":"Datatable Liste des templates en cours",
    "display_new_template_list_dtable_offline":"Datatable Liste des templates hors ligne",
    "display_new_template_list_dtable_upcoming":"Datatable Liste des templates à venir",
    "display_new_template_preview_video":"Aperçu",
    "display_new_template_show_generic":"Afficher vidéo générique",
    "display_new_template_edit_duration_segment":"Modifier durée segment",
    "display_new_template_show_blank_layout":"Afficher disposition vierge",
    "display_new_template_post_add_segment":"Ajout segment",
    "display_new_template_show_list_block":"Afficher liste des blocs",
    "display_new_template_show_intro_video":"Afficher vidéo d'introduction",
    "display_new_template_initialize_duration_template":"Initialisation durée de template",
    "display_new_template_undo_redo":" Undo-Redo",
    "display_new_template_save_video":"Enregistrer vidéo de template",
    "display_toolbar_edit":"Modifier barre d'outils",
    "display_toolbar_duplicate":"Dupplication barre d'outils",
    "display_toolbar_drag":"Glisser barre d'outils",
    "display_toolbar_delete":"Effacer barre d'outils",
    "display_toolbar_parameter":"Paramètres de barre d'outils",
    "display_new_template_display_layers":"Afficher les couches",
    "display_new_template_animate_components":"Animations des composants",
    "display_new_template_sort_layers":"Trier les couches",
    "display_new_template_reclamation":"Réclamation",
    "display_new_template_list_show_ligne": "Afficher la colonne Ligne",
    "display_new_template_list_search_by_status": "Recherche par statut",




    "display_new_schedule_post_add":"Ajout d'une grille des programmes",
    "display_new_schedule_post_edit":"Modification d'une grille de programme ",
    "display_new_schedule_post_edit_order":"Modification de l'ordre d'une grille de programmes ",
    "display_new_schedule_post_enable":"Grille des programmes active",
    "display_new_schedule_post_disable":"Grille des programmes inactive",
    "display_new_schedule_list_dtable":"Datatable grille des programmes",
    "display_new_schedule_get_all":"Afficher tous les grille de programmes",
    "display_new_schedule_delete_many":"Multi-delete des grille de programmes",
    "display_new_schedule_delete_one":"Effacer une grille de programme",
    "display_new_schedule_get_one":"Afficher une grille de programmes",
    "display_new_schedule_get_reload":"Actualiser l'affichage de grille de programmes",
    "display_new_schedule_form_active":"Activer d'une grille des programmes ",
    "display_new_schedule_form_attribute":"Attribut d'une grille de programme",

    "podcast_form_langue":"Langue podcast",
    "podcast_form_category":"Catégories podcast",
    "podcast_form_explicit":"Expliciter podcast",

    "scorm_scorm_no_api":"Afficher scorm",
    "scorm_edit_scorm_no_api":"Modifier scorm",
    "scorm_edit_source_scorm_no_api":"Modifier source scorm",
    "scorm_delete_scorm_no_api":"Effacer scorm",
    "scorm_export_scorm_no_api":"Export d'un scorm",
    "scorm_add_scorm_no_api":"Ajouter scorm",


    "skin_skin_no_api":"Afficher skin",

    "photoprism_add":"Ajouter photoprisme",
    "photoprism_edit":"Modifier photoprisme",
    "photoprism_delete":"Effacer photoprisme",
    "photoprism_list_dtable":"Datatable liste des photoprismes",
    "photoprism_list_grid":"Grille de liste des photoprismes",
    "photoprism_import_simple":"Importation simple de photoprisme",
    "photoprism_import_multiple":"Importation multiple de photoprismes",
    "photoprism_like":"Aimer photoprisme",
    "photoprism_download":"Téléchargement",
    "photoprism_filter_by_word":"Filtrer par mot",
    "photoprism_filter_by_camera":"Filtrer par camera",
    "photoprism_filter_by_pays":"Filtrer par pays",
    "photoprism_filter_by_category":"Filtrer par categorie",
    "photoprism_filter_by_type":"Filtrer par type",
    "photoprism_filter_by_color":"Filtrer par couleur",
    "photoprism_sort_by_type":"Trier par type",
    "photoprism_sort_by_date":"Trier par date",
    "photoprism_sort_by_size":"Trier par taille",
    "photoprism_detail":"Détails photoprism",
    "photoprism_form_title":"Titre de photoprism",
    "photoprism_form_themes":"Thèmes de photoprism",
    "photoprism_form_contributor":"Contributeurs de photoprism",
    "photoprism_form_description":"Description de photoprism",
    "photoprism_theme_delete":"Suppression thème",
    "photoprism_theme_rename":"Renommer thème",
    "photoprism_theme_download":"Télécharger thème",
    "photoprism_theme_detail":"Détails thème",
    "photoprism_theme_export_PDF":"Export PDF du thème",
    "photoprism_theme_export_metadata":"Export métadonnées du thème",
    "photoprism_use":"Utiliser",
    "photoprism_check":"Valider",
    "photoprism_move":"Déplacer",
    "photoprism_date_import":"Importer date",
    "photoprism_archive":"Archives",
    "photoprism_list_menu":"Liste des menues",

    "media_video_form_transcription": "Transcription de la vidéo",

    "media_video_post_acceessible": "Mettre la vid\u00e9o visible en internet",

    "comment_detail":"Détails du commentaire",
    "comment_post_edit":"Modification d'un commentaire",
    "comment_post_delete":"Effacer un commentaire",
    "comment_post_multi_delete":"Multi-delete commentaire",
    "comment_post_activate":"Activer commentaire",



    "player_question_redirect_video":"vidéo",
    "player_question_redirect_web_page":"page web",
    "player_question_redirect_download_file":"Télécharger fichier"
  },
  "MODULESLIST": {
    "none": "Aucun module disponible",
    "configuration_rmboxgroup": "Module configuration RmBox group",
    "configuration_rmbox": "Module configuration RmBox",
    "configuration_zone": "Module configuration zone",
    "display_schedule": "Module display grille des programmes",
    "display_template": "Module display programme",
    "display_new_template": "Module display programme",
    "display_new_schedule": "Module display grille des programmes",
    "configuration_presets": "Module configuration presets",
    "sondage": "Module sondage",
    "lives": "Module direct",
    "lives_comments": "Module commentaires en direct",
    "event": "Module \u00e9v\u00e9nement en direct",
    "media_home": "Module media page d'accueil",
    "parametres_theme": "Module th\u00e8me",
    "abonnement_group": "Module abonnement des groupes",
    "abonnement_user": "Module abonnement des utilisateurs",
    "all": "Tout les modules",
    "core_group": "Module groupe utilisateur",
    "media_video": "Module vid\u00e9o",
    "subscription_group": "Module abonnement des groupes",
    "subscription_user": "Module abonnement des utilisateurs",
    "configuration_server": "Module serveur",
    "webinar": "Module webinar",
    "parameters_theme": "Module th\u00e8me",
    "parameters_canal": "Module canal",
    "parameters_advertising": "Module publicit\u00e9",
    "profiles_user": "Module profile utilisateur",
    "profiles_group": "Module profile groupe",
    "profiles_ip": "Module profile IP",
    "specifics_iptv": "Module IP-TV",
    "specifics_stations": "Module station",
    "param": "Module param",
    "playlist": "Module playlist",
    "playlist_live": "Module playlist direct",
    "player":"Module player",
    "comment":"Module commentaire",
    "photoprisme":"Module photoprisme",
    "skin":"Module skin",
    "scorm":"Module scorm",
    "comments": "Module commentaires",
    "configuration_general": "Module g\u00e9n\u00e9rale",
    "media_video_caption": "Module sous titre vid\u00e9o",
    "rich_media_video": "Module rich m\u00e9dia vid\u00e9o",
    "export_video": "Module export vid\u00e9o",
    "chutier": "Module chutier",
    "lives_conf": "Module configuration direct",
    "stats_temps_reel": "Module statistiques temps r\u00e9el ",
    "stats_technologie": "Module statistiques technologie ",
    "stats_mesure_audience": "Module statistiques mesure audience",
    "stats_mesure_engagement": "Module statistiques mesure engagement",
    "stats_geo": "Module statistiques geo",
    "stats_engagement": "Module statistiques engagement",
    "stats_audience": "Module statistiques audience",
    "statsvod": "Module statistiques vod",
    "statslive": "Module statistiques direct",
    "statsvod_by_id": "Module statistiques par identifiant",
    "statslive_by_id": "Module statistiques en direct par identifiant",
    "specifics_directions": "Module directions",
    "stats_dashboard": "Statistiques tableau de bord",
    "stats_acces": "Statistiques acc\u00e9s",
    "stats_bande_passante": "Statistiques bande passante",
    "stats_storage": "Statistiques stockage",
    "dashboard": "Tableau de bord",
    "stats": "Statistiques",
    "modules_add": "Ajout des modules",
    "modules_success": "Les modules sont enregistrés avec succès",
    "stats_mooc": "Statistiques Mooc",
    "configuration_newss": "Module actualités",
    "podcast": "Module podcast",
    "stats_list_videos": "Statistiques liste des vidéos",
    "stats_export": "Statistiques d'export",
    "support": "Module support",
    "player_parameters": "Paramètres player"
  }
}
);

$translateProvider.translations("en", {
  "DASHBOARD": {
    "All_videos": "All videos",
    "Latest_Media_Videos": "Latest added videos",
    "TopFive_Media_Videos": "List of the most viewed videos",
    "nbVisits": "Views",
    "deleted_video": "Deleted video",
    "no_videos": "There are no data for this report",
    "none": "All"
  }
}
);

$translateProvider.translations("fr", {
  "DASHBOARD": {
    "All_videos": "Toutes les vid\u00e9os",
    "Latest_Media_Videos": "Vidéos récentes",
    "TopFive_Media_Videos": "Liste des vid\u00e9os les plus visionn\u00e9es",
    "nbVisits": "Vues",
    "deleted_video": "Vid\u00e9o supprim\u00e9e",
    "no_videos": "Il n'y a pas de donn\u00e9es pour ce rapport",
    "none": "Tous"
  }
}
);

$translateProvider.translations("en", {
  "EXPORT": {
    "page_export_youtube_title": "Export to Youtube",
    "form_label_pub": "This is a private video.",
    "export_submit": "Validate",
    "page_export_dailymotion_title": "Export to Dailymotion",
    "login_submit": "Login"
  }
});

$translateProvider.translations("fr", {
  "EXPORT": {
    "page_export_youtube_title": "Export vers Youtube",
    "form_label_pub": "Ceci est une vid\u00e9o priv\u00e9e.",
    "export_submit": "Valider",
    "page_export_dailymotion_title": "Export vers Dailymotion",
    "login_submit": "Connexion"
  }
});

$translateProvider.translations("en", {
  "LOGINV2": {
    "INTRO_TITLE": "Welcome to the WebTV V4",
    "INTRO_DESCRIPTION": "This application is a new version to manage your videos easily",
    "TITLE": "Administration",
    "DESCRIPTION": "Connect to the platform",
    "PASSWORD": "Password",
    "USERNAME": "Username",
    "REMEMBER_ME": "Remember me",
    "FORGOT_USERNAME": "Username forgotten",
    "NEXT": "Next",
    "licence": "Legal Mentions",
    "reset_password": "Reset password",
    "send_mail_to": "Send an mail to:",
    "email": "Mail",
    "email_sent": "Please check your mailbox",
    "email_not_exist": "Email address does not exist",
    "email_sent_to_empreinte": "",
    "not_authorised": "Access not authorized",
    "contact_admin": "Please contact admin",
    "expired_password": "Your password is expired, please create a new one.",
    "user_not_found": "This user is not found!",
    "not_a_membre": "Not a member yet ?",
    "sign_up":"Sign up",
    "Connexion": "Connection"

  }
}
);

$translateProvider.translations("fr", {
  "LOGINV2": {
    "INTRO_TITLE": "Bienvenue \u00e0 WebTV V4",
    "INTRO_DESCRIPTION": "Espace de gestion des vid\u00e9os",
    "TITLE": "Administration",
    "DESCRIPTION": "Se connecter à la plateforme",
    "PASSWORD": "Mot de passe",
    "USERNAME": "Nom d'utilisateur",
    "REMEMBER_ME": "Se souvenir de moi",
    "FORGOT_USERNAME": "Nom d'utilisateur oubli\u00e9",
    "NEXT": "Suivant",
    "licence": "Mentions Légales",
    "reset_password": "Réinitialiser le mot de passe",
    "send_mail_to": "Envoyer un email à:",
    "email": "Email",
    "email_sent": "Veuillez consulter votre boîte mail",
    "email_not_exist": "Adresse email non existante",
    "email_sent_to_empreinte": "",
    "not_authorised": "Accès non autorisé",
    "contact_admin": "Veuillez contacter l'administrateur",
    "expired_password": "Votre mot de passe est expiré, merci de créer un nouveau.",
    "user_not_found": "Cet utilisateur est introuvable !",
    "not_a_membre": "Pas encore membre ?",
     "sign_up":"Inscrivez vous",
    "Connexion": "Connexion"
  }
}
);

$translateProvider.translations("en", {
  "LOGINV2": {
    "INTRO_TITLE": "Welcome to the WebTV V4",
    "INTRO_DESCRIPTION": "This application is a new version to manage your videos easily",
    "TITLE": "Administration",
    "DESCRIPTION": "Connect to the platform",
    "PASSWORD": "Password",
    "USERNAME": "Username",
    "REMEMBER_ME": "Remember me",
    "FORGOT_PASSWORD": "Password forgotten",
    "LOG_IN": "Log in",
    "licence": "Legal Mentions",
    "reset_password": "Reset password",
    "send_mail_to": "Send an mail to:",
    "previous": "Previous",
    "email": "Mail",
    "email_sent": "Please check your mailbox",
    "email_not_exist": "No account is associated with this email address",
    "email_sent_to_empreinte": "",
    "not_authorised": "Access not authorized",
    "contact_admin": "Please contact admin",
    "expired_password": "Your password is expired, please create a new one.",
    "user_not_found": "This user is not found!"
  }
}
);

$translateProvider.translations("fr", {
  "LOGINV2": {
    "INTRO_TITLE": "Bienvenue \u00e0 WebTV V4",
    "INTRO_DESCRIPTION": "Espace de gestion des vid\u00e9os",
    "TITLE": "Administration",
    "DESCRIPTION": "Se connecter à la plateforme",
    "PASSWORD": "Mot de passe",
    "USERNAME": "Nom d'utilisateur",
    "REMEMBER_ME": "Se souvenir de moi",
    "FORGOT_PASSWORD": "Mot de passe oubli\u00e9",
    "LOG_IN": "Se connecter",
    "licence": "Mentions Légales",
    "reset_password": "Réinitialiser le mot de passe",
    "send_mail_to": "Envoyer un email à:",
    "previous": "Précédent",
    "email": "Email",
    "email_sent": "Veuillez consulter votre boîte mail",
    "email_not_exist": "Aucun compte n'est associé à cette adresse e-mail",
    "email_sent_to_empreinte": "",
    "not_authorised": "Accès non autorisé",
    "contact_admin": "Veuillez contacter l'administrateur",
    "expired_password": "Votre mot de passe est expiré, merci de créer un nouveau.",
    "user_not_found": "Cet utilisateur est introuvable !"
  }
});

$translateProvider.translations("en", {
  "TWO_FACTOR_AUTH": {
    "TITLE": "Account verification",
    "CODE": "An email with a verification code was just sent.\nPlease enter the code to continue",
    "SEND": "Send"
  }
}
);

$translateProvider.translations("fr", {
  "TWO_FACTOR_AUTH": {
    "TITLE": "Vérification de votre compte",
    "CODE": "Nous venons d'envoyer un code de validation par mail.\nVeuillez saisir votre code pour continuer",
    "SEND": "Envoyer"
  }
});

$translateProvider.translations("en", {});

$translateProvider.translations("fr", {});

$translateProvider.translations("en", {
  "KEY": {
    "copied":"key copied",
    "title":"key"
  }
});

$translateProvider.translations("fr", {
  "KEY": {
    "copied":"cl\u00e9 copi\u00e9e",
    "title":"cl\u00e9"
  }
});

$translateProvider.translations("en", {
  "PRICING": {

  }
}
);

$translateProvider.translations("fr", {
  "PRICING": {

  }
}
);

$translateProvider.translations("en", {
  "DASHBOARD": {
    "dashboard_title": "Dashboard",
    "dashboard_chart": "Charts list",
    "dashboard_date_start": "Start date",
    "dashboard_date_end": "End date",
    "dashboard_canal_list": "Canal list",
    "dashboard_theme_list": "Theme list",
    "dashboard_group_list": "Group list",
    "dashboard_reset": "Reset",
    "dashboard_filter": "Filter"
  },
  "SEARCHSTATS": {
    "form_attr_Statistique_audience": "Audience statistics",
    "form_attr_Statistique_duree": "Statistics by duration",
    "form_attr_Statistique_duree_visite": "Statistics by duration of visit",
    "form_attr_Statistique_plus_populaire": "Most popular",
    "form_attr_Statistique_map": "Map",
    "form_attr_Statistique_os": "Operating system statistics",
    "form_attr_Statistique_navigateur": "Browser statistics",
    "form_attr_Statistique_referrer": "Referrer statistique",
    "form_attr_Statistique_device": "Device statistics",
    "form_attr_themes": "Themes",
    "form_attr_canals": "Channels",
    "form_attr_types": "Types",
    "form_attr_groups": "Groups"

  },
  "VISITSMESURESTATS": {
    "stat_different_views_videos": "Different videos views",
    "stat_different_views_podcasts": "Different podcast views",
    "form_attr_filter": "Filter by",
    "stat_views_videos": "Views videos",
    "stat_views_podcasts": "Views podcast",
    "stat_reset_zoom": "Reset zoom",
    "stat_uniq_visits": "Unique visitors",
    "stat_duree_moyenne_par_visiteur_unique": "Average duration per unique visitor",
    "stat_visits": "Visits",
    "stat_visits_unique": "Unique visits",
    "stat_duree_moy": "Average duration",
    "stat_duree_tot": "Total duration",
    "stat_total_duration": "Total duration (HH:MM:ss)",
    "stat_standard_deviation": "Standard deviation",
    "stat_nombre_vue_par_visiteur": "Views by visitor",
    "stat_nombre_vue_par_video": "Number of views by video",
    "stat_nombre_vue_par_podcast": "Number of views by podcast",
    "stat_duree_moyenne_par_visiteur": "Average duration by visitor",
    "stat_duree_video": "Duration video",
    "stat_duree_moyenne_par_visite": "Average duration by visit",
    "stat_duree_moyenne_par_video": "Average duration by video",
    "stat_duree_moyenne_par_poàdcast": "Average duration by podcast",
    "stat_visite_temps_reel": "Total number of views",
    "stat_visite_temps_reel_podcast": "Total number of views",
    "stat_visite_nb_views": "Number of views",
    "stat_video_temps_reel": "Number of videos viewed",
    "stat_podcast_temps_reel": "Number of podcast viewed",
    "nbre_vue_50": "Video 50% seen",
    "nbre_vue_100": "Video 100% seen",
    "nbre_vue_25": "Video 25% seen",
    "nbre_vue_75": "Video 75% seen",
    "stat_nbre_access": "Access number",
    "stat_visite_nb_visiteur": "Visitor number",
    "stat_nbre_vue_50": "Video 50% seen",
    "stat_nbre_vue_100": "Video 100% seen",
    "stat_nbre_vue_25": "Video 25% seen",
    "stat_nbre_vue_75": "Video 75% seen",
    "number_loads": "Number of loads",
    "number_vue_per_autoplay": "Number of views per autoplay"

  },
  "VISITSWIDGETSTATS": {
    "stat_audience": "Audience general",
    "stat_duration": "Viewing time",
    "stat_geolocalisation": "Geolocation",
    "stat_repartition_navigateur": "Browser audience",
    "stat_repartition_os": "OS audience",
    "stat_repartition_referrer": "Statistics by referer",
    "stat_duree_moyenne_visualisation": "Number of views per viewing time",
    "stat_no_data": "There are no data for this report.",
    "stats_visits_per_ip": "Statistics by IP",
    "stats_most_popular_videos": "Most visited videos",
    "stats_most_popular_podcasts": "Most visited podcasts",
    "stat_zoom_message": "Click the left button of the mouse and drag to zoom in.To scroll the graph to the right or left, hold down the Shift key as you drag the mouse."
  },
  "MOOCMESURESTATS": {
    "stat_mooc_total_registrations": "Total number of registrations",
    "stat_mooc_ongoing_registrations": "Number of ongoing registrations",
    "stat_mooc_increase_registrations": "Increase in registrations in the last week",
    "stat_mooc_actif_learners": "Total number of actif learners",
    "stat_mooc_video_watcher": "Total number of video watchers",
    "stat_mooc_podcast_watcher": "Total number of podcast watchers",
    "stat_mooc_problem_tester": "Total number of problem tester",
    "stat_mooc_nbr_visas_person": "Number of visas per person",
    "stat_mooc_nbr_views_persons_passport": "Number of videos seen per person on the passport",
    "stat_mooc_nbr_persons_passport": "Number of persons having their passport"
  },
  "MOOCWIDGETSTATS": {
    "stat_mooc": "Mooc",
    "stat_mooc_view": "Mooc View",
    "stat_mooc_performance": "Mooc Performance",
    "stat_mooc_replayed_segments": "Mooc Replayed Segments",
    "stat_mooc_quiz_theme": "Quiz by theme",
    "stat_mooc_views_voyage": "Video seen per person in a trip"
  },
  "MOOCSTATS": {
    "stat_performance_learners_by_quiz": "Learners performance by quiz",
    "stat_performance_learners_by_question": "Learners performance by question",
    "stat_performance_correct": "Correct",
    "stat_performance_incorrect": "Incorrect",
    "stat_performance_percent_response": "Percentage of response",
    "stat_performance_percentage": "Percentage",
    "stat_participation_learners": "Graph of participation of learners",
    "stat_number_learners": "Number of learners",
    "stat_number_active_learners": "Active learners",
    "stat_learners_watching_video": "Watched a video",
    "stat_learners_tried_problem": "Tried a problem",
    "stat_apprenants": "learners",
    "title": "Graph of participation of learners",
    "hour": "Hour",
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "stat_no_data": "There are no data for this report.",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "subscriber": "Subscriber",
    "response": "Response",
    "date_response": "Date response",
    "correct/incorrect": "Correct/Incorrect",
    "question": "Question"
  },
  "STATSTITLE": {
    "stat_audience": "Audience",
    "stat_engagement": "Engagement",
    "stat_real_time": "Real time",
    "stat_technologie": "Technology",
    "stat_geolocalisation": "Geolocation",
    "stat_mobile": "Mobile",
    "stat_course": "Course",
    "stat_performance": "Performance",
    "stat_video": "Video",
    "stat_voyage_passport": "Visa-Passport",
    "performance_learners": "Learners performance per quiz",
    "video_complete_incomplete": "Number of views complete and incomplete video",
    "nbr_views_per_trip": "Number of view per person on a trip",
    "nbr_expedition_per_trip": "Number of videos seen in an expedition",
    "nbr_correct_incorrect_response": "Number of correct and incorrect responses of quiz for a theme",
    "participation_learners_theme": "Learners participation for a theme",
     "nbr_views_per_excursions": "Number of views by excursions"
  },
  "EXPORT": {
    "export_url": "Export URL stats"
  }
}
);

$translateProvider.translations("fr", {
  "DASHBOARD": {
    "dashboard_title": "Tableau de bord",
    "dashboard_chart": "Liste de graphes",
    "dashboard_date_start": "Date de d\u00e9but",
    "dashboard_date_end": "Date de fin",
    "dashboard_canal_list": "Liste des canaux",
    "dashboard_theme_list": "Liste des th\u00e8mes",
    "dashboard_group_list": "Liste des groupes",
    "dashboard_reset": "Restaurer",
    "dashboard_filter": "Filtrer"
  },
  "SEARCHSTATS": {
    "form_attr_Statistique_audience": "Statistique d'audience",
    "form_attr_Statistique_duree": "Statistique par dur\u00e9e",
    "form_attr_Statistique_duree_visite": "Statistique par dur\u00e9e de visite",
    "form_attr_Statistique_plus_populaire": "Plus populaire",
    "form_attr_Statistique_map": "Carte",
    "form_attr_Statistique_os": "Statistique de syst\u00e8me d'exploitation",
    "form_attr_Statistique_navigateur": "Statistique de navigateur",
    "form_attr_Statistique_referrer": "Referrer statistique",
    "form_attr_Statistique_device": "Statistique de device",
    "form_attr_themes": "Th\u00e8mes",
    "form_attr_canals": "Canaux",
    "form_attr_types": "Types",
    "form_attr_groups": "Groupes"
  },
  "VISITSMESURESTATS": {
    "stat_different_views_videos": "Diff\u00e9rentes vid\u00e9os vues",
    "stat_different_views_podcasts": "Diff\u00e9rentes podcasts vues",
    "stat_views_videos": "Vid\u00e9os vues",
    "form_attr_filter": "Filtrer par",
    "stat_views_podcasts": "Podcasts vues",
    "stat_reset_zoom": "R\u00e9initialiser le zoom",
    "stat_uniq_visits": "Visiteurs uniques",
    "stat_duree_moyenne_par_visiteur_unique": "durée moyenne par visiteur unique",
    "stat_visits": "Visites",
    "stat_visits_unique": "Visites uniques",
    "stat_duree_moy": "Dur\u00e9e moyenne",
    "stat_duree_tot": "Dur\u00e9e totale",
    "stat_total_duration": "Dur\u00e9e totale (HH:MM:ss)",
    "stat_standard_deviation": "\u00C9cart-type",
    "stat_nombre_vue_par_visiteur": "Vues par visiteur",
    "stat_nombre_vue_par_video": "Nombre de vues par vid\u00e9o",
    "stat_nombre_vue_par_podcast": "Nombre de vues par podcast",
    "stat_duree_moyenne_par_visiteur": "Dur\u00e9e moyenne par visiteur",
    "stat_duree_video": "Dur\u00e9e native du vid\u00e9o",
    "stat_duree_moyenne_par_visite": "Dur\u00e9e moyenne par visite",
    "stat_duree_moyenne_par_video": "Dur\u00e9e moyenne par vid\u00e9o",
    "stat_duree_moyenne_par_podcast": "Dur\u00e9e moyenne par podcast",
    "stat_visite_temps_reel": "Nombre total de vues",
    "stat_visite_temps_reel_podcast": "Nombre total de vues",
    "stat_visite_nb_views": "Nombre de vues",
    "stat_video_temps_reel": "Nombre des vid\u00e9os vues",
    "stat_podcast_temps_reel": "Nombre des podcasts vues",
    "stat_nbre_access": "Nombre d'acc\u00e8s",
    "stat_visite_nb_visiteur": "Nombre de visiteurs",
    "stat_nbre_vue_50": "Vid\u00e9o vue à 50%",
    "stat_nbre_vue_100": "Vid\u00e9o vue à 100%",
    "stat_nbre_vue_25": "Vid\u00e9o vue à 25%",
    "stat_nbre_vue_75": "Vid\u00e9o vue à 75%",

    "stat_nbre_vue_50_podcast": "Podcast vue à 50%",
    "stat_nbre_vue_100_podcast": "Podcast vue à 100%",
    "stat_nbre_vue_25_podcast": "Podcast vue à 25%",
    "stat_nbre_vue_75_podcast": "Podcast vue à 75%",
    "number_loads": "Nombre de chargement",
    "number_vue_per_autoplay": "Nombre de vue par lecture automatique"

  },
  "VISITSWIDGETSTATS": {
    "stat_audience": "Audience générale",
    "stat_duration": "Dur\u00e9e de visualisation",
    "stat_geolocalisation": "G\u00e9olocalisation",
    "stat_repartition_navigateur": "Audience par navigateur",
    "stat_repartition_os": "Audience par système d'exploitation",
    "stat_repartition_referrer": "Statistiques par referer",
    "stat_duree_moyenne_visualisation": "Dur\u00e9e de visionnage",
    "stat_no_data": "Il n'y a pas de donn\u00e9es pour ce rapport.",
    "stats_visits_per_ip": "Statistiques par IP",
    "stats_most_popular_videos": "vid\u00e9os les plus visit\u00e9es",
    "stats_most_popular_podcasts": "Podcasts les plus visit\u00e9es",
    "stat_zoom_message": "Cliquez sur le bouton gauche et faites glisser la souris pour effectuer un zoom avant. Pour d\u00e9filer le graphe \u00E0 droite ou \u00E0 gauche, maintenez la touche Shift enfonc\u00e9e pendant que vous faites glisser la souris."
  },
  "STATSTITLE": {
    "stat_audience": "Audience",
    "stat_engagement": "Engagement",
    "stat_real_time": "Temps r\u00e9el",
    "stat_technologie": "Technologie",
    "stat_geolocalisation": "G\u00e9olocalisation",
    "stat_mobile": "Mobile",
    "stat_course": "Cours",
    "stat_performance": "Performance",
    "stat_video": "Vid\u00e9o",
    "stat_voyage_passport": "Visa-Passeport",
    "performance_learners": "Performance des apprenants par quiz",
    "video_complete_incomplete": "Nombre de vues complètes et incomplètes des vidéos d’un cours",
    "nbr_views_per_trip": "Nombre de vidéos vues par personne dans un voyage",
    "nbr_expedition_per_trip": "Nombre de vidéos vues dans une expédition",
    "nbr_correct_incorrect_response": "Nombre des réponses correctes et incorrectes des quiz pour un thème",
    "participation_learners_theme": "Graphe de participation des apprenants d'un thème",
    "nbr_views_per_excursions": "Nombre de vues par excursions"
  },
  "MOOCMESURESTATS": {
    "stat_mooc_total_registrations": "Nombre total des inscriptions",
    "stat_mooc_ongoing_registrations": "Nombre des inscriptions en cours",
    "stat_mooc_increase_registrations": "Augmentation des inscriptions dans la derni\u00e8re semaine",
    "stat_mooc_actif_learners": "Nombre total d'apprenants actifs",
    "stat_mooc_video_watcher": "Nombre total de ceux qui ont regardé une vidéo",
    "stat_mooc_podcast_watcher": "Nombre total de ceux qui ont regardé une podcast",
    "stat_mooc_problem_tester": "Nombre total de ceux qui ont essayé un problème",
    "stat_mooc_nbr_visas_person": "Nombre de visas obtenus par personne",
    "stat_mooc_nbr_views_persons_passport": "Nombre de vidéos vues par personne dans le passeport",
    "stat_mooc_nbr_persons_passport": "Nombre de personnes qui on eu leur passeport"
  },
  "MOOCSTATS": {
    "stat_performance_learners_by_quiz": "Performance des apprenants par quiz",
    "stat_performance_learners_by_question": "Performance des apprenants par question",
    "stat_performance_correct": "Correcte",
    "stat_performance_incorrect": "Incorrecte",
    "stat_performance_percent_response": "Pourcentage de r\u00e9ponse",
    "stat_performance_percentage": "Pourcentage",
    "stat_participation_learners": "Graphe de participation des apprenants",
    "stat_number_learners": "Nombre des apprenants",
    "stat_number_active_learners": "Les apprenants actifs",
    "stat_learners_watching_video": "Regard\u00e9 une vid\u00e9o",
    "stat_learners_tried_problem": "Essay\u00e9 un probl\u00e8me",
    "stat_apprenants": "apprenants",
    "title": "Graphe de participation des apprenants",
    "hour": "Heure",
    "day": "Jour",
    "week": "Semaine",
    "month": "Mois",
    "stat_no_data": "Il n'y a pas de donn\u00e9es pour ce rapport.",
    "correct": "Correcte",
    "incorrect": "Incorrecte",
    "subscriber": "Abonné",
    "response": "Réponse",
    "date_response": "Date réponse",
    "correct/incorrect": "Correcte/Incorrecte",
    "question": "Question"
  },
  "MOOCWIDGETSTATS": {
    "stat_mooc": "Mooc",
    "stat_mooc_view": "Mooc Vues",
    "stat_mooc_performance": "Mooc Performance",
    "stat_mooc_replayed_segments": "Mooc Segments Rejou\u00e9s",
    "stat_mooc_quiz_theme": "Quiz par thèmes",
    "stat_mooc_views_voyage": "Vidéo vue par personne dans un voyage"
  },
  "EXPORT": {
    "export_url": "Exporter l'url des statistiques"
  }
}
);

$translateProvider.translations("en", {
  "ABONNEMENTGROUPLIST": {
    "name": "Name",
    "thematic_name": "Name of Thematic",
    "startDate": "Release date",
    "endDate": "End date",
    "parent": "Parent",
    "delete_group": "Delete",
    "delete_group_aria_label": "Delete group",
    "delete_groups_aria_label": "Delete groups",
    "delete_group_msg": "Do you want to delete the group?",
    "delete_element_groups_msg": "Do you want to delete this group?",
    "delete_list_groups_msg": "Do you want to delete these groups?",
    "undeleted_are": "Groups with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Groups with ids \"{{list}}\" have been deleted",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": "  has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "update_group": "Update",
    "detail_group": "Details",
    "added": "Group added successfully.",
    "edited": "Group edited successfully.",
    "updated_at": "Modification date",
    "action_new_element": "Add new group",
    "dialog_alert_upload_description": " File has been successfully uploaded.",
    "add_group": "Subscriptions groups added successfully",
    "thematic_form_title": "Add new thematic"
  },
  "ABONNEMENTGROUPEDIT": {
    "form_edit_title": "Edit group form :",
    "form_title": "Group edit",
    "thematic_form_title": "Thematic edit"
  },
  "ABONNEMENTGROUPDETAIL": {
    "name": "Name",
    "thematic_name": "Name of thematic",
    "startDate": "Release date",
    "endDate": "Expiration date",
    "parent": "Parent",
    "group_detail_title": "Group detail",
    "thematic_detail_title": "Thematic detail",
    "id": "ID"
  },
  "ABONNEMENTGROUPADD": {
    "form_attr_name": "Group name",
    "form_attr_startDate": "Release date",
    "form_attr_endDate": "Expiration date",
    "form_attr_parent": "Parent",
    "form_new_title": "Add group form",
    "form_title": "Group information",
    "choose_file": "Choose a file",
    "new": "New",
    "exist": "Already exists",
    "errone": "inaccurate",
    "nb_ligne_file": "Number of lines in excel file",
    "select_file": "Select a file .csv *",
    "download_file": "download a sample",
    "no_parent":"No parent",
    "thematic_form_title": "Thematic information"
  },
  "VALIDATIONS": {
    "subscriptionGroup.name.not_blank": "This field is required",
    "subscriptionGroup.startDate.not_blank": "This field is required",
    "subscriptionGroup.endDate.not_blank": "This field is required",
    "SubscriptionGroup.UniqueName": "Group name already used",
    "subscriptionGroup_not_found": "Subscription Group does not exist",
    "not_form_submitted": "Check your input",
    "cannot_delete_suscription_group": "Group with subscribers it can not be deleted"
  }
}
);

$translateProvider.translations("fr", {
  "ABONNEMENTGROUPLIST": {
    "name": "Nom du groupe",
    "thematic_name": "Nom du Th\u00e9matique",
    "startDate": "Date de publication",
    "endDate": "Date de fin",
    "parent": "Parent",
    "delete_group": "Supprimer",
    "delete_group_aria_label": "Supprimer le groupe",
    "delete_groups_aria_label": "Supprimer les groupes",
    "delete_group_msg": "Voulez-vous vraiment supprimer ce groupe ?",
    "delete_element_groups_msg": "Voulez-vous vraiment supprimer ce groupe ?",
    "delete_list_groups_msg": "Voulez-vous vraiment supprimer ces groupes ?",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are": "Les groupes ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les groupes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "update_group": "Modifier",
    "detail_group": "D\u00e9tails",
    "added": "Groupe ajout\u00e9 avec succ\u00e8s.",
    "edited": "Groupe modifi\u00e9 avec succ\u00e8s.",
    "updated_at": "Date d'\u00e9dition",
    "action_new_element" : "Ajouter un nouveau groupe",
    "dialog_alert_upload_description": "Le fichier a \u00e9t\u00e9 import\u00e9 avec succ\u00e8s.",
    "add_group": "Les groupes d'abonnements ont ajout\u00e9s avec succ\u00e8s",
    "thematic_form_add_title": "Formulaire d'ajout du th\u00e9matique : ",
    "thematic_form_title": "Ajout d'un th\u00e9matique"
  },
  "ABONNEMENTGROUPEDIT": {
    "form_edit_title": "Formulaire de modification du groupe : ",
    "form_title": "Modification du groupe",
    "thematic_form_edit_title": "Formulaire de modification du th\u00e9matique : ",
    "thematic_form_title": "Modification du th\u00e9matique"
  },
  "ABONNEMENTGROUPDETAIL": {
    "name": "Nom du groupe",
    "thematic_name": "Nom du th\u00e9matique",
    "startDate": "Date de d\u00e9but",
    "endDate": "Date de fin",
    "parent": "Parent",
    "group_detail_title": "D\u00e9tail de groupe",
    "thematic_detail_title": "D\u00e9tail de th\u00e9matique",
    "id": "ID"
  },
  "ABONNEMENTGROUPADD": {
    "form_attr_name": "Nom du groupe",
    "form_attr_startDate": "Date d\u00e9but",
    "form_attr_endDate": "Date fin",
    "form_attr_parent": "Parent",
    "form_title": "Information du groupe",
    "form_new_title": "Formulaire d'ajout d'un nouveau groupe",
    "choose_file": "Choisir un fichier",
    "new":"Nouveau",
    "exist":"Existe d\u00e9j\u00e0",
    "errone":"Erron\u00e9e",
    "nb_ligne_file":"Nombre de lignes dans le fichier Excel",
    "select_file":"S\u00e9lectionner un fichier .csv *",
    "download_file":"T\u00e9l\u00e9charger un mod\u00e8le",
    "no_parent":"Aucun parent",
    "thematic_form_title": "Information du th\u00e9matique"
  },
  "VALIDATIONS": {
    "subscriptionGroup.name.not_blank"     : "Ce champ est obligatoire",
    "subscriptionGroup.startDate.not_blank"     : "Ce champ est obligatoire",
    "subscriptionGroup.endDate.not_blank"     : "Ce champ est obligatoire",
    "SubscriptionGroup.UniqueName"  : "Nom de groupe d\u00e9j\u00e0 utilis\u00e9 ",
    "subscriptionGroup_not_found"     : "Ce groupe n'existe pas ",
    "not_form_submitted" : "V\u00e9rifiez les valeurs envoy\u00e9es",
    "cannot_delete_suscription_group":"Ce groupe poss\u00e8de des abonn\u00e9s et ne peut pas \u00eatre supprim\u00e9"

  }
}
);

$translateProvider.translations("en", {
  "ABONNEMENTUSEREDIT": {
    "form_edit_title": "Edit user form :",
    "form_title": "User edit"
  },
  "ABONNEMENTUSERLIST": {
    "name": "Name",
    "lastName": "Firstname",
    "email": "Email",
    "login": "Login",
    "delete_user": "Delete",
    "delete_user_msg": "Do you want to delete the user?",
    "delete_element_user_msg": "Do you want to delete this user?",
    "delete_list_users_msg": "Do you want to delete these users?",
    "delete_user_aria_label": "Delete user?",
    "delete_users_aria_label": "Delete users?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_upload_description": " File has been successfully uploaded.",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "update_user": "Update",
    "detail_user": "Details",
    "added": "User added successfully.",
    "edited": "User edited successfully.",
    "protect": "Protected",
    "add_user": "Users has been successfully added",
    "action_new_element": "Add new user",
    "undeleted_are": "Users with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Users with ids \"{{list}}\" have been deleted"
  },
  "ABONNEMENTUSERDETAIL": {
    "name": "Name",
    "lastName": "Last name",
    "email": "Email",
    "login": "Login",
    "user_detail_title": "User detail",
    "id": "ID : "
  },
  "ABONNEMENTUSERADD": {
    "form_attr_name": "Name",
    "form_attr_lastName": "Last name",
    "form_attr_function": "Function",
    "form_attr_entity": "Entity",
    "form_attr_email": "Email",
    "form_attr_login": "Login",
    "form_attr_protect": "Protected",
    "form_attr_pwd": "Password",
    "form_attr_edit_pwd": "Edit password",
    "form_attr_group": "Group",
    "form_new_title": "Add user form",
    "form_title": "User information",
    "choose_file": "Choose a file",
    "new": "New",
    "exist": "Already exists",
    "errone": "inaccurate",
    "nb_ligne_file": "Number of lines in excel file",
    "add_user": "Users have been added successfully",
    "select_file":"Select a file .csv *",
    "download_file":"download a sample",
    "no_group":"No group"
  },
  "USERMESSAGEEROOR": {
    "subscriptionUser.name.not_blank": "This field is empty, enter your name",
    "subscriptionUser.lastName.not_blank": "This lastname field is required",
    "subscriptionUser.login.not_blank": "This login field is required",
    "subscriptionUser.email.not_blank": "This field of mail address is empty, check thank you. ",
    "subscriptionUser.email.not_valid": "Invalid email format",
    "subscriptionUser.pwd.not_blank": "Choose a good password",
    "subscriptionUser_not_found": "Subscription User does not exist",
    "subscriptionUser_success_deleted": "Subscription User was deleted",
    "subscriptionUser_success_add": "Subscription User was added",
    "subscriptionUser_success_edit": "Subscription User was edited",
    "subscriptionUser.email.unique": "Subscription User email unique",
    "subscriptionUser.login.unique": "Subscription User login unique",
    "subscriptionUser.protect.not_blank": "This checkbox protect is required"
  },
  "VALIDATIONS": {
    "subscriptionUser.name.not_blank": "This field is required",
    "subscriptionUser.lastName.not_blank": "This field is required",
    "subscriptionUser.email.uniqueEmail": "This email address is already used",
    "subscriptionUser.login.uniqueLogin": "This identifier is already used",
    "subscriptionUser.pwd.not_blank": "This field is required",
    "subscriptionUser.protect.not_blank": "This checkbox protect is required",
    "not_form_submitted" : "Check your input"
  }
}
);

$translateProvider.translations("fr", {
  "ABONNEMENTUSEREDIT": {
    "form_edit_title": "Formulaire de modification d'utilisateur : ",
    "form_title": "Modification de l'utilisateur"
  },
  "ABONNEMENTUSERLIST": {
    "name": "Nom",
    "lastName": "Pr\u00e9nom",
    "email": "Email",
    "login": "Identifiant",
    "delete_user": "Supprimer",
    "delete_user_msg": "Voulez-vous vraiment supprimer l'utilisateur ?",
    "delete_element_user_msg": "Voulez-vous vraiment supprimer cet utilisateur ?",
    "delete_list_users_msg": "Voulez-vous vraiment supprimer ces utilisateurs ?",
    "delete_user_aria_label": "Supprimer l'utilisateur",
    "delete_users_aria_label": "Supprimer les utilisateurs",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_upload_description": "Le fichier a \u00e9t\u00e9 import\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "FERMER",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_user": "Modifier",
    "detail_user": "D\u00e9tails",
    "added": "Utilisateur ajout\u00e9e avec succ\u00e8s.",
    "edited": "Utilisateur modifi\u00e9e avec succ\u00e8s.",
    "protect": "Prot\u00e9g\u00e9",
    "action_new_element": "Ajouter un nouveau utilisateur",
    "add_user": "Les utilisateurs ont \u00e9t\u00e9 ajout\u00e9 avec succ\u00e8s",
    "undeleted_are": "Les utilisateurs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les utilisateurs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s"
  },
  "ABONNEMENTUSERDETAIL": {
    "name": "Nom",
    "lastName": "Pr\u00e9nom",
    "email": "Email",
    "login": "Identifiant",
    "user_detail_title": "D\u00e9tails d'utilisateur",
    "id": "ID : "
  },
  "ABONNEMENTUSERADD": {
    "form_attr_name": "Nom",
    "form_attr_lastName": "Pr\u00e9nom",
    "form_attr_function": "Fonction",
    "form_attr_entity": "Entit\u00e9",
    "form_attr_email": "Email",
    "form_attr_login": "Identifiant",
    "form_attr_protect": "Prot\u00e9g\u00e9",
    "form_attr_pwd": "Mot de passe",
    "form_attr_edit_pwd": "Modifier le mot de passe",
    "form_attr_group": "Groupe",
    "form_new_title": "Formulaire d'ajout d'un nouveau utilisateur",
    "form_title": "Information d'utilisateur",
    "choose_file": "Choisir un fichier",
    "new": "Nouveau",
    "exist": "Existe d\u00e9j\u00e0",
    "errone": "Erron\u00e9e",
    "nb_ligne_file": "Nombre de lignes dans le fichier excel",
    "add_user": "Les utilisateurs ont \u00e9t\u00e9 ajout\u00e9 avec succ\u00e8s",
    "select_file":"S\u00e9lectionner un fichier .csv *",
    "download_file":"T\u00e9l\u00e9charger un mod\u00e8le",
    "no_group":"Aucun groupe"
  },
  "USERMESSAGEEROOR": {
    "subscriptionUser.name.not_blank": "Ce champ est vide, entrez votre nom",
    "subscriptionUser.lastName.not_blank": "Ce champ de nom de famille est requis",
    "subscriptionUser.login.not_blank": "Ce champ de connexion est requis",
    "subscriptionUser.email.not_blank": "Ce champ d'adresse mail est vide, v\u00e9rifiez merci. ",
    "subscriptionUser.email.not_valid": "Format de messagerie invalide",
    "subscriptionUser.pwd.not_blank": "Choisissez un bon mot de passe",
    "subscriptionUser_not_found": "Abonnement utilisateur n'existe pas",
    "subscriptionUser_success_deleted": "Abonnement utilisateur a \u00e9t\u00e9 supprim\u00e9",
    "subscriptionUser_success_add": "Abonnement utilisateur a \u00e9t\u00e9 ajout\u00e9",
    "subscriptionUser_success_edit": "Abonnement utilisateur a \u00e9t\u00e9 modifi\u00e9",
    "subscriptionUser.email.unique": "Abonnement utilisateur email unique",
    "subscriptionUser.login.unique": "Abonnement utilisateur login unique",
    "subscriptionUser.protect.not_blank": "Cette protection est obligatoire"
  },
  "VALIDATIONS": {
    "subscriptionUser.name.not_blank": "Ce champ est obligatoire",
    "subscriptionUser.lastName.not_blank": "Ce champ est obligatoire",
    "subscriptionUser.email.uniqueEmail": "Cette adresse email est d\u00e9j\u00e0 utilis\u00e9e",
    "subscriptionUser.login.uniqueLogin": "Cet identifiant est d\u00e9j\u00e0 utilis\u00e9",
    "subscriptionUser.pwd.not_blank": "Ce champ est obligatoire",
    "subscriptionUser.protect.not_blank": "Cette protection est obligatoire",
    "not_form_submitted" : "V\u00e9rifiez les valeurs envoy\u00e9es"
  }
}
);

$translateProvider.translations("en", {
  "CANALLIST": {
    "language": "Language",
    "title": "Title",
    "streaming_server": "Streaming server(s)",
    "quota": "Quotas (Mb)",
    "update_canal": "Update",
    "delete_canal_msg": "Do you want to delete the channel?",
    "delete_list_canal_msg": "Do you want to delete these channels?",
    "delete_canal_aria_label": "Delete channel",
    "delete_canals_aria_label": "Delete channels",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "undeleted_are":"Channels with ids \"{{list}}\" could not be deleted",
    "deleted_are":"Channels with ids \"{{list}}\" have been deleted",
    "added": "Channel added successfully.",
    "edited": "Channel edited successfully.",
    "action_new_element" : "Add new channel",
    "export_links_modal_title": "Export links for : ",
    "export_links_embed_link": "Embed link",
    "stockage_modal_title": "Storage by server",
    "server": "Server",
    "espace_utilise": "Used space (Mo)",
    "espace_disponible": "Available space (Mo)",
    "copied":"link copied"
  },
  "CANALDETAIL": {
    "canal_detail_title": "Channel detail",
    "bitrate_pc": "Default bitrate for PC",
    "bitrate_tab": "Default bitrate for tablet",
    "bitrate_mob": "Default bitrate for mobile",
    "reading_protocol": "Reading protocol",
    "iscdn": "CDN",
    "mbr": "MBR",
    "choices_disable": "Disable",
    "choices_enable": "Activate",
    "choices_use_default_config": "Use default configuration",
    "title": "Title",
    "description": "Description",
    "quota": "Quotas",
    "language": "Language",
    "server": "Streaming server(s)",
    "sendPushNotification": "Send push notifications",
    "RTMP": "RTMP",
    "HDS": "HDS",
    "id": "ID"
  },
  "CANALADD": {
    "form_new_title": "Add channel form",
    "form_title": "Channel information",
    "form_bitrate_pc": "Default bitrate for PC",
    "form_bitrate_tab": "Default bitrate for tablet",
    "form_bitrate_mob": "Default bitrate for mobile",
    "form_attr_title": "Title",
    "form_attr_quota": "Quotas"
  },
  "CANALEDIT": {
    "form_edit_title": "Edit channel form :",
    "form_title": "Channel edit"
  },
  "VALIDATION": {
    "channel.title.not_blank" : "Title cannot be empty",
    "channel.language.not_blank" : "The language must be defined",
    "channel_not_found" : "Channel not found",
    "not_authorized_channel" : "You are not authorized to access this channel",
    "cannot_delete_channel_related_themes" : "Cannot delete a channel related to one or many themes",
    "not_authorized_general" : "You are not authorized",
    "invalid_form" : "Invalid form",
    "bad_parameters" : "Please check your parameters",
    "invalid_date" : "Invalid date"
  }
}
);

$translateProvider.translations("fr", {
  "CANALLIST": {
    "language": "Langue",
    "title": "Titre",
    "streaming_server": "Serveur(s) de streaming",
    "quota": "Quotas (Mo)",
    "update_canal": "Modifier",
    "delete_canal_msg": "Voulez-vous vraiment supprimer le canal ?",
    "delete_canal_aria_label": "Supprimer ces canaux",
    "delete_list_canal_msg": "Voulez-vous vraiment supprimer ces canaux ?",
    "delete_canals_aria_label": "Supprimer les canaux",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are":"Les canaux ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are":"Les canaux ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "added": "Canal ajout\u00e9 avec succ\u00e8s.",
    "edited": "Canal modifi\u00e9 avec succ\u00e8s.",
    "action_new_element" : "Ajouter un nouveau canal",
    "export_links_modal_title": "Liens d'export pour : ",
    "export_links_embed_link": "Lien d'int\u00e9gration",
    "stockage_modal_title": "Stockage par serveur",
    "server": "Serveur",
    "espace_utilise": "Espace utilis\u00e9 (Mo)",
    "espace_disponible": "Espace disponible (Mo)",
    "copied":"lien copi\u00e9"
  },
  "CANALDETAIL": {
    "canal_detail_title": "D\u00e9tail du canal",
    "bitrate_pc": "Bitrate PC par d\u00e9faut",
    "bitrate_tab": "Bitrate tablette par d\u00e9faut",
    "bitrate_mob": "Bitrate mobile par d\u00e9faut",
    "reading_protocol": "Protocole de lecture",
    "iscdn": "CDN",
    "mbr": "MBR",
    "choices_disable": "D\u00e9sactiver",
    "choices_enable": "Activer",
    "choices_use_default_config": "Utiliser la configuration par d\u00e9faut",
    "title": "Titre",
    "description": "Description",
    "quota": "Quotas",
    "language": "Langue",
    "server": "Serveur de streaming",
    "sendPushNotification": "Envoyer des notifications",
    "RTMP": "RTMP",
    "HDS": "HDS",
    "id": "Identifiant"
  },
  "CANALADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau canal",
    "form_title": "Information du canal",
    "form_bitrate_pc": "Bitrate PC par d\u00e9faut ",
    "form_bitrate_tab": "Bitrate tablette par d\u00e9faut",
    "form_bitrate_mob": "Bitrate mobile par d\u00e9faut",
    "form_attr_title": "Titre",
    "form_attr_quota": "Quotas"
  },
  "CANALEDIT": {
    "form_edit_title": "Formulaire de modification du canal : ",
    "form_title": "Modification du canal"
  },
  "VALIDATION": {
    "channel.title.not_blank" : "Titre du canal ne peut pas \u00eatre vide",
    "channel.language.not_blank" : "La langue doit \u00eatre d\u00e9finie",
    "channel_not_found" : "Le canal n'existe pas",
    "not_authorized_channel" : "Vous n'avez pas la permission pour acc\u00e9der \u00e0 ce canal",
    "cannot_delete_channel_related_themes" : "Vous ne pouvez pas supprimer un canal reli\u00e9 a un ou plusieurs th\u00e9mes",
    "not_authorized_general" : "Vous n'avez pas la permission pour cette action",
    "invalid_form" : "Formulaire invalide",
    "bad_parameters" : "V\u00e9rifiez vos param\u00e9tres",
    "invalid_date" : "Date invalide"
  }
}
);

$translateProvider.translations("en", {
  "THEMEADD": {
    "form_new_title": "Add theme form",
    "form_title": "Theme information",
    "form_attr_title": "Title",
    "form_attr_canal": "Channel",
    "form_attr_description": "Description",
    "form_attr_parentId": "Parent theme",
    "form_attr_parentRubricId": "Parent rubric",
    "form_attr_visibility": "Visibility",
    "form_attr_type_theme": "Type Of Theme ",
    "form_attr_classifiedBy": "Order of videos",
    "choose_thumb": "Choose a thumbnail"
  },
  "THEMEEDIT": {
    "form_edit_title": "Edit theme form :",
    "form_title": "Theme edit"
  },
  "THEMEDETAIL": {
    "id": "ID : ",
    "parentId": "Parent theme",
    "title": "Title : ",
    "type": "Type : ",
    "alias": "Alias : ",
    "description": "Description : ",
    "channel": "Channel : ",
    "dir": "Directory : ",
    "subDir": "Sub folder : ",
    "url": "Link : ",
    "seen_nbr": "Number of views : ",
    "visibility": "Visibility : ",
    "sortedBy": "Sorted by : ",
    "classifiedBy": "Sorted by",
    "theme_detail_title": "Theme details",
    "parentRubricId": "Parent rubric"
  },
  "THEMELIST": {
    "image": "Picture",
    "title": "Title",
    "startDate": "Start Date",
    "endDate": "End Date",
    "total_registrations": "Total registrations",
    "registrations_ongoing": "Ongoing registrations",
    "augmentation_registrations": "Increase in registrations in the last week",
    "parent": "Parent theme",
    "rubric_parent": "Parent rubric",
    "canal": "Channels",
    "update_theme": "Update",
    "delete_theme_msg": "Do you want to delete the theme?",
    "delete_list_theme_msg": "Do you want to delete these themes?",
    "delete_theme_aria_label": "Delete theme",
    "delete_themes_aria_label": "Delete themes",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_failed_delete_title": "Failed operation",
    "dialog_alert_failed_delete_description": " cannot be deleted !!",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "undeleted_are": "Themes with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Themes with ids \"{{list}}\" have been deleted",
    "added": "Theme added successfully",
    "edited": "Theme edited successfully",
    "export_links_modal_title": "Export links for : ",
    "export_links_embed_link": "Embed link",
    "export_links_perma_link": "Permalink",
    "export_links_embed_code": "Embed code",
    "action_new_element" : "Add new theme",
    "copied":"link copied"
  },
  "VALIDATIONS": {
    "theme_not_found": "Theme selected does not exist!",
    "cannot_delete_theme_related_videos":"Theme related to a video cannot be deleted!",
    "not_authorized_theme":"This theme is unauthorized!",
    "This_theme_is_not_visible" : "This theme is not visible",
    "themes": {
      "channels.not_blank": "Empty field!",
      "title.not_blank": "Empty field!",
      "visible.not_null": "Null field!",
      "classifiedBy.not_blank": "Empty field"
    }
  }
}
);

$translateProvider.translations("fr", {
  "THEMEADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau th\u00e8me",
    "form_title": "Information du th\u00e8me",
    "form_rubric_title": "Information du rubrique",
    "form_attr_title": "Titre",
    "form_attr_canal": "Canal",
    "form_attr_description": "Description",
    "form_attr_parentId": "Th\u00e8me parent",
    "form_attr_parentRubricId": "Rubrique parent",
    "form_attr_type_theme": "Type de Th\u00e8me",
    "form_attr_visibility": "Visibilit\u00e9",
    "form_attr_classifiedBy": "Ordre des vid\u00e9os",
    "choose_thumb": "Choisir une vignette"
  },
  "THEMEEDIT": {
    "form_edit_title": "Formulaire de modification de th\u00e8me : ",
    "form_title": "Modification du th\u00e8me",
    "form_rubric_title": "Modification du rubrique"
  },
  "THEMEDETAIL": {
    "id": "Identifiant : ",
    "parentId": "Th\u00e8me parent : ",
    "title": "Titre : ",
    "type": "Type : ",
    "alias": "Alias : ",
    "description": "Description : ",
    "channel": "Canal : ",
    "dir": "R\u00e9pertoire : ",
    "subDir": "Sous r\u00e9pertoire : ",
    "url": "Lien : ",
    "seen_nbr": "Nombre de vue : ",
    "visibility": "Visibilit\u00e9 : ",
    "sortedBy": "Tri\u00e9 par : ",
    "classifiedBy": "Class\u00e9 par : ",
    "theme_detail_title": "D\u00e9tails du th\u00e8me",
    "parentRubricId": "Rubrique parent "
  },
  "THEMELIST": {
    "image": "Image",
    "title": "Titre",
    "startDate": "Date D\u00e9but",
    "endDate": "Date Fin",
    "total_registrations": "Inscriptions totales",
    "registrations_ongoing": "Inscriptions en cours",
    "augmentation_registrations": "Augmentation des inscriptions dans la derni\u00e8re semaine",
    "parent": "Th\u00e8me parent",
    "rubric_parent": "Rubrique parent",
    "canal": "Canaux",
    "update_theme": "Modifier",
    "delete_theme_msg": "Voulez-vous vraiment supprimer le th\u00e8me ?",
    "delete_list_theme_msg": "Voulez-vous vraiment supprimer ces th\u00e8mes ?",
    "delete_theme_aria_label": "Supprimer le th\u00e8me",
    "delete_themes_aria_label": "Supprimer ces th\u00e8mes",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_failed_delete_title": "Op\u00e9ration avec échec",
    "dialog_alert_failed_delete_description": " ne peut pas être supprim\u00e9 !!",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are": "Les th\u00e8mes ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les th\u00e8mes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "added": "Th\u00e8me ajout\u00e9 avec succ\u00e8s",
    "edited": "Th\u00e8me modifi\u00e9 avec succ\u00e8s",
    "export_links_modal_title": "Liens d'export pour : ",
    "export_links_embed_link": "Lien d'int\u00e9gration",
    "export_links_perma_link": "Permalink",
    "export_links_embed_code": "Code d'int\u00e9gration",
    "action_new_element" : "Ajouter un nouveau th\u00e8me",
    "copied":"lien copi\u00e9"
  },
  "VALIDATIONS": {
    "theme_not_found": "Le th\u00e8me desir\u00e9 est inexistant !",
    "cannot_delete_theme_related_videos": "Ce th\u00e8me reli\u00e9 \u00e0 une vid\u00e9o ne peut pas \u00eatre supprim\u00e9",
    "not_authorized_theme": "Ce th\u00e8me est non autoris\u00e9 !",
    "This_theme_is_not_visible" : "Ce th\u00e8me est non visible !",
    "themes": {
      "channels.not_blank": "Champ vide !",
      "title.not_blank": "Champ vide !",
      "visible.not_null": "Champ null !",
      "classifiedBy.not_blank": "Champ vide"
    }
  }
}
);

$translateProvider.translations("en", {
  "DISPLAY_OPTIONS": {
    "change_style": "Change display style,mode or color",
    "change_layout": "Change layout",
    "display_mode": "Display mode",
    "player_config": "Player configuration",
    "display_mode_message": "Choose display mode of video list",
    "dashboard_block": "Dashboard",
    "dashboard_block_message": "Choose dashboard parts",
    "latest_videos_block": "Latest videos",
    "most_viewed_block": "Most viewed videos",
    "audience_stat_block": "Audience stats",
    "nbr_view_stat_block": "Number of views per viewing time",
    "number_elements_message": "Choose the number of elements on video list"
  }
}


);

$translateProvider.translations("fr", {
  "DISPLAY_OPTIONS": {
    "change_style": "Changer le style, mode ou couleur de l'affichage",
    "change_layout": "Changer layout",
    "display_mode": "Dashboard",
    "player_config": "Configuration du Player",
    "display_autoplay_message": "Choisir le mode de lecture des vid\u00e9os",
    "display_mode_message": "Choisir le mode d'affichage de la liste des vid\u00e9os",
    "dashboard_block": "Tableau de bord",
    "dashboard_block_message": "Choisir les parties \u00e0 afficher dans le tableau de bord",
    "latest_videos_block": "Derni\u00e8res vidéos ajout\u00e9es",
    "most_viewed_block": "Les vid\u00e9os les plus visit\u00e9es",
    "audience_stat_block": "Statistiques audience",
    "nbr_view_stat_block": "Statistiques nombre des vues par dur\u00e9e de visionnage",
    "number_elements_message": "Choisir le nombre des \u00e9l\u00e9ments \u00e0 afficher dans la liste des vid\u00e9os"
  }
}


);

$translateProvider.translations("en", {
  "HOMECONFADD": {
    "form_attr_canal": "Channel",
    "form_attr_firstVid": "Fix the first video",
    "form_attr_alt": "Rondom playback of videos",
    "form_attr_orderAlpha": "Playing by alphabetically order",
    "form_attr_datePub": "Playing by publication date",
    "form_attr_datePubVid": "Playing the selected videos by date of publication",
    "form_attr_orderVid": "Playing in order of the list of selected videos",
    "custom_conf": "Setting up the home page",
    "form_new_title": "Configuration form",
    "form_title": "Configuration information",
    "form_attr_video": "Choose the first video",
    "form_attr_nb_videos": "Videos number",
    "all": "All"
  },
  "HOMECONFLIST": {
    "preview": "Overview",
    "selectbycanal": "Channel",
    "theme": "Themes",
    "canal": "Channel",
    "action": "Action",
    "delete_homeConf": "Delete",
    "delete_video_msg": "Do you want to delete the video?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "dialog_alert_get_list_by_canal": "Channel not found!"
  },
  "HOMECONFPUSH": {
    "id": "ID",
    "title": "Title",
    "startDate": "Release date",
    "endDate": "End date",
    "push_video_off": "Position backward",
    "no_push_video": "No push video"
  }
});

$translateProvider.translations("fr", {
  "HOMECONFADD": {
    "form_attr_canal": "Canal",
    "form_attr_firstVid": "Fixer la premi\u00e8re vid\u00e9o",
    "form_attr_alt": "Lecture al\u00e9atoire des vid\u00e9os",
    "form_attr_orderAlpha": "Lecture par ordre alphab\u00e9tique",
    "form_attr_datePub": "Lecture par date de publication",
    "form_attr_datePubVid": "Lecture par date de publication des vid\u00e9os s\u00e9lectionn\u00e9es",
    "form_attr_orderVid": "Lecture par ordre des vid\u00e9os s\u00e9lectionn\u00e9es",
    "custom_conf": "Configuration de la page d'accueil",
    "form_new_title": "Formulaire configuration ",
    "form_title": "Information du configuration",
    "form_attr_video": "Choisir la premi\u00e8re vid\u00e9o",
    "form_attr_nb_videos": "Nombre de vid\u00e9os",
    "all": "Toutes"
  },
  "HOMECONFLIST": {
    "preview": "Aper\u00e7u",
    "selectbycanal": "Canal",
    "theme": "Th\u00e8mes",
    "canal": "Canal",
    "action": "Action",
    "delete_homeConf": "Supprimer",
    "delete_video_msg": "Voulez-vous supprimer la vid\u00e9o ?",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "dialog_alert_get_list_by_canal": "Canal est introuvable!"
  },
  "HOMECONFPUSH": {
    "id": "ID",
    "title": "Titre",
    "startDate": "Date d\u00e9but",
    "endDate": "Date fin",
    "push_video_off": "Mettre en arri\u00e8re",
    "no_push_video": "Pas de vid\u00e9o push"
  }
});

$translateProvider.translations("en", {
  "PARAMLIST": {
    "cle": "Key",
    "value": "Value",
    "delete_param": "Delete",
    "update_param": "Edit",
    "detail_param": "Details",
    "action_new_element" : "Add new parameter",
    "delete_Param_msg": "Do you want to delete the parameter?",
    "delete_element_Param_msg": "Do you want to delete this parameter?",
    "delete_list_Param_msg": "Do you want to delete these parameters?",
    "delete_Param_aria_label": "Delete parameter",
    "delete_Params_aria_label": "Delete parameters",
    "undeleted_are": "Parameters with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Parameters with ids \"{{list}}\" have been deleted",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "delete_Params_msg": "Do you want to delete the parameter ?",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "Client successfully added.",
    "edited": "Client successfully edited."
  },
  "PARAMDETAIL": {
    "cle": "Key",
    "value": "Value",
    "param_detail_title": "Parameter detail",
    "id": "ID : "
  },
  "PARAMADD": {
    "form_attr_cle": "Key",
    "form_attr_value": "Value",
    "form_new_title": "Add parameter form",
    "form_title": "Parameters information"
  },
  "PARAMEDIT": {
    "form_edit_title": "Edit parameters form",
    "form_title": "Edit parameters"
  }
}
);

$translateProvider.translations("fr", {
  "PARAMLIST": {
    "cle": "Cl\u00e9",
    "value": "Valeur",
    "delete_param": "Supprimer",
    "update_param": "Modifier",
    "detail_param": "D\u00e9tails",
    "action_new_element": "Ajouter un nouveau param\u00e8tre",
    "delete_Param_msg": "Voulez-vous vraiment supprimer le param\u00e8tre ?",
    "delete_element_Param_msg": "Voulez-vous vraiment supprimer ce param\u00e8tre ?",
    "delete_list_Param_msg": "Voulez-vous vraiment supprimer ces param\u00e8tres ?",
    "delete_Param_aria_label": "Supprimer le param\u00e8tre",
    "delete_Params_aria_label": "Supprimer les param\u00e8tres",
    "undeleted_are": "Les param\u00e8tres ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les param\u00e8tres ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "delete_Params_msg": "Voulez-vous vraiment supprimer le param\u00e8tre ?",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s..",
    "dialog_alert_delete_close": "Fermer",
    "added": "Client ajouté avec succ\u00e8s.",
    "edited": "Client modifi\u00e9 avec succ\u00e8s."
  },
  "PARAMDETAIL": {
    "cle": "Cl\u00e9",
    "value": "Valeur",
    "param_detail_title": "D\u00e9tail du param\u00e9tre",
    "id": "Identifiant : "
  },
  "PARAMADD": {
    "form_attr_cle": "Cl\u00e9",
    "form_attr_value": "Valeur",
    "form_new_title": "Formulaire d'ajout d'un nouveau param\u00e9tre",
    "form_title": "Information des param\u00e8tres"
  },
  "PARAMEDIT": {
    "form_edit_title": "Formulaire de modification des param\u00e8tres",
    "form_title": "Modification du param\u00e9tre"
  }
}
);

$translateProvider.translations("en", {
  "NEWSLIST": {
    "news": "News",
    "date": "Date",
    "update_news": "Update",
    "delete_news": "Delete",
    "detail_news": "Details",
    "delete_news_msg": "Do you want to delete the news?",
    "delete_news_aria_label": "Delete news ?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "News added successfully.",
    "edited": "News edited successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element": "Add new news",
    "dialog_will_be_deleted_news": " will be deleted.",
    "delete_element_newss_msg": "Do you want to delete this News?",
    "delete_list_newss_msg": "Do you want to delete these News?",
    "delete_newss_aria_label": "Delete News",
    "undeleted_are": "News with ids \"{{list}}\" could not be deleted",
    "deleted_are": "News with ids \"{{list}}\" have been deleted"
  },
  "NEWSDETAIL": {
    "id": "Id : ",
    "title": "Title : ",
    "parent": "Parent",
    "visible": "Visible",
    "news_detail_title": "News detail"
  },
  "NEWSADD": {
    "form_new_title": "Add news form",
    "form_title": "News information",
    "form_attr_name": "Title"
  },
  "NEWSEDIT": {
    "form_edit_title": "Edit news form :",
    "form_title": "News edit"
  }
}
);

$translateProvider.translations("fr", {
  "NEWSLIST": {
    "news": "Actualité",
    "date": "Date",
    "parent": "Parent",
    "update_news": "Modifier",
    "delete_news": "Supprimer",
    "detail_news": "D\u00e9tails",
    "delete_news_msg": "Voulez-vous vraiment supprimer l'actualité ?",
    "delete_news_aria_label": "Voulez-vous supprimer l'actualité",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "added": "Actualité ajout\u00e9e avec succ\u00e8s.",
    "edited": "Actualité modifi\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_will_be_deleted_news": " sera supprim\u00e9e.",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "description": "Description",
    "action_new_element": "Ajouter une nouvelle l'actualité",
    "delete_newss_aria_label": "Supprimer les actualités",
    "delete_element_newss_msg": "Voulez-vous vraiment supprimer cet actualité?",
    "delete_list_newss_msg": "Voulez-vous vraiment supprimer ces actualités?",
    "undeleted_are": "Les actualités ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les actualités ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es"
  },
  "NEWSDETAIL": {
    "id": "Id : ",
    "title": "Titre : ",
    "parent": "Parent",
    "visible": "Visible",
    "news_detail_title": "D\u00e9tails de l'actualité"
  },
  "NEWSADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle actualité",
    "form_title": "Information de l'actualité",
    "form_attr_name": "Contenu"
  },
  "NEWSEDIT": {
    "form_edit_title": "Formulaire de modification de l'actualité : ",
    "form_title": "Modification de l'actualité"
  }
}
);

$translateProvider.translations("en", {
  "PLAYERPARAMETERSLIST": {
    "type": "Type",
    "value": "Value",
    "dialog_title": " Changing the value of the key : ",
    "action_new_element" : "Add new key",
    "delete_cle_msg": "Do you want to delete the key?",
    "delete_list_cle_msg": "Do you want to delete these keys?",
    "delete_cle_aria_label": "Delete keys",
    "undeleted_are": "Keys with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Keys with ids \"{{list}}\" have been deleted",
    "delete_cle": "Delete",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "update_cle": "Update",
    "detail_cle": "Details",
    "added": "Successfully synchronization",
    "edited": "Key edited successfully.",
    "delete_element_Param_msg": "Do you want to delete this parameter?",
    "delete_list_Param_msg": "Do you want to delete these parameters?",
    "delete_Param_aria_label": "Delete parameter",
    "delete_Params_aria_label": "Delete parameters"
  },
  "code": 200
}
);

$translateProvider.translations("fr", {
  "PLAYERPARAMETERSLIST": {
    "type": "Type",
    "value": "Valeur",
    "dialog_title": "Modification de la valeur de la cl\u00e9 : ",
    "action_new_element" : "Ajouter un nouveau cl\u00e9",
    "delete_cle_msg": "Voulez-vous vraiment supprimer la cl\u00e9 ?",
    "delete_list_cle_msg": "Voulez-vous vraiment supprimer ces cl\u00e9s ?",
    "delete_cle_aria_label": "Supprimer les cl\u00e9s",
    "undeleted_are": "Les cl\u00e9s ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les cl\u00e9s ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_cle": "Supprimer",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_cle": "Modifier",
    "detail_cle": "D\u00e9tails",
    "added": "Synchronisation effectu\u00e9e avec succ\u00e8s.",
    "edited": "Synchronisation modifi\u00e9e avec succ\u00e8s.",
    "delete_element_Param_msg": "Voulez-vous vraiment supprimer ce param\u00e8tre ?",
    "delete_list_Param_msg": "Voulez-vous vraiment supprimer ces param\u00e8tres ?",
    "delete_Param_aria_label": "supprimer param\u00e8tre",
    "delete_Params_aria_label": "supprimer param\u00e8tres"
  },
  "code": 200
});

$translateProvider.translations("en", {
  "PRESETSLIST": {
    "name": "Name",
    "bitrateVideo": "Bitrate video",
    "bitrateAudio": "Audio bitrate",
    "samplerateAudio": "Sample rate audio",
    "framerate": "Frame rate",
    "state": "State",
    "delete_presets": "Delete",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "update_presets": "Update",
    "detail_presets": "Details",
    "added": "Presets added successfully.",
    "edited": "Presets edited successfully.",
    "action_new_element" : "Add new presets",
    "delete_presets_msg": "Do you want to delete the presets?",
    "delete_list_presetss_msg": "Do you want to delete these presets?",
    "delete_preset_msg": "Do you want to delete this preset?",
    "delete_presets_aria_label": "Delete these presets",
    "delete_preset_aria_label": "Delete this preset",
    "undeleted_are": "Presets with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Presets with ids \"{{list}}\" have been deleted"
  },
  "PRESETSDETAIL": {
    "name": "Name",
    "bitrateVideo": "Bitrate video",
    "bitrateAudio": "Audio bitrate",
    "samplerateAudio": "Sample rate audio",
    "framerate": "Frame rate",
    "state": "State",
    "presets_detail_title": "Presets detail",
    "id": "ID : "
  },
  "PRESETSADD": {
    "form_attr_name": "Name",
    "form_attr_bitrateVideo": "Bitrate video",
    "form_attr_bitrateAudio": "Audio bitrate",
    "form_attr_samplerateAudio": "Sample rate audio",
    "form_attr_framerate": "Frame rate",
    "form_attr_state": "State",
    "form_new_title": "Add presets form",
    "form_title": "Presets information"
  },
  "PRESETSEDIT": {
    "form_edit_title": "Edit preset form",
    "form_title": "Preset edit"
  }
});

$translateProvider.translations("fr", {
  "PRESETSLIST": {
    "name": "Nom",
    "bitrateVideo": "Bitrate vid\u00e9o",
    "bitrateAudio": "Bitrate audio",
    "samplerateAudio": "Fr\u00e9quence d'\u00e9chantillonnage audio",
    "framerate": "Fr\u00e9quence d'images",
    "state": "Etat",
    "delete_presets": "Supprimer",
    "delete_presets_msg": "Voulez-vous vraiment supprimer le presets ?",
    "delete_presets_aria_label": "Supprimer presets",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_presets": "Modifier",
    "detail_presets": "D\u00e9tails",
    "added": "Presets ajout\u00e9e avec succ\u00e8s.",
    "edited": "Presets modifi\u00e9e avec succ\u00e8s.",
    "action_new_element" : "Ajouter un nouveau presets",
    "delete_list_presetss_msg": "Voulez-vous vraiment supprimer ces presets ?",
    "delete_preset_msg": "Voulez-vous vraiment supprimer le preset ?",
    "delete_presetss_aria_label": "Supprimer les presets",
    "delete_preset_aria_label": "Supprimer le preset",
    "undeleted_are": "Les Presets ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les Presets ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s"
  },
  "PRESETSDETAIL": {
    "name": "Nom",
    "bitrateVideo": "Bitrate vid\u00e9o",
    "bitrateAudio": "Bitrate audio",
    "samplerateAudio": "Fr\u00e9quence d'\u00e9chantillonnage audio",
    "framerate": "Fr\u00e9quence d'images",
    "state": "Etat",
    "presets_detail_title": "D\u00e9tail du presets",
    "id": "Identifiant : "
  },
  "PRESETSADD": {
    "form_attr_name": "Nom",
    "form_attr_bitrateVideo": "Bitrate vid\u00e9o",
    "form_attr_bitrateAudio": "Bitrate audio",
    "form_attr_samplerateAudio": "Fr\u00e9quence d'\u00e9chantillonnage audio",
    "form_attr_framerate": "Fr\u00e9quence d'images",
    "form_attr_state": "Etat",
    "form_new_title": "Formulaire d'ajout d'un nouveau presets",
    "form_title": "Information du presets"
  },
  "PRESETSEDIT": {
    "form_edit_title": "Formulaire de modification preset",
    "form_title": "Modification du preset"
  }
});

$translateProvider.translations("en", {
  "SERVERLIST": {
    "type": "Type",
    "none": "All",
    "access": "Access",
    "url": "URL",
    "url_mp4": "MP4 URL",
    "delete_server_msg": "Do you want to delete the server?",
    "delete_list_server_msg": "Do you want to delete these servers?",
    "delete_server_aria_label": "Delete server",
    "delete_servers_aria_label": "Delete servers",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "undeleted_are": "Servers with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Servers with ids \"{{list}}\" have been deleted",
    "url_diffusion": "URL diffusion",
    "identifier": "ID",
    "added": "Server added successfully.",
    "edited": "Server edited successfully.",
    "action_new_element": "Add new server"
  },
  "SERVERDETAIL": {
    "id": "ID :",
    "name": "Name :",
    "protocol": "Protocol :",
    "type": "Type :",
    "internet": "Internet :",
    "login": "Identify :",
    "server_detail_title": "Server detail",
    "dir": "Directory:",
    "urlVideo": "URL:",
    "urlMp4": "MP4 URL:",
    "urlDiffusion": "Diffusion URL:",
    "urlVodAndroid": "Video URL on Android:",
    "urlLiveAndroid": "Live URL on Android:",
    "urlCdnAndroid": "CDN URL on Android:",
    "urlVodIos": "Video URL on IOS:",
    "urlLiveIos": "Live URL on IOS:",
    "urlCdnIos": "CDN URL on IOS:",
    "dirLecture": "Playback directory:",
    "urlBackup": "Backup URL:",
    "urlMobile": "Mobile URL:",
    "urlServerFtp": "FTP server URL:",
    "loginLive": "Live login:",
    "bitrate": "The bitrates to be transferred to the streaming server (separated by ','):"
  },
  "SERVERADD": {
    "form_new_title": "Add server form",
    "form_title": "Server information",
    "form_attr_type": "Type",
    "form_attr_server_type": "Server type",
    "form_attr_protocol": "Protocol",
    "form_attr_internet": "Internet",
    "form_attr_record": "Record",
    "form_attr_name": "Name",
    "form_attr_server_name": "Server name",
    "form_attr_login": "Identify",
    "form_attr_pwd": "Password",
    "form_attr_dir": "Directory",
    "form_attr_urlVideo": "URL",
    "form_attr_urlMp4": "MP4 URL",
    "form_attr_urlDiffusion": "Diffusion URL",
    "form_attr_urlVodAndroid": "Video URL on Android",
    "form_attr_urlLiveAndroid": "Live URL on Android",
    "form_attr_urlCdnAndroid": "CDN URL on Android",
    "form_attr_urlVodIos": "Video URL on IOS",
    "form_attr_urlLiveIos": "Live URL on IOS",
    "form_attr_urlCdnIos": "CDN URL on IOS",
    "form_attr_dirLecture": "Playback directory",
    "form_attr_urlBackup": "Backup URL",
    "form_attr_urlMobile": "Mobile URL",
    "form_attr_urlServerFtp": "FTP server URL",
    "form_attr_loginLive": "Live login",
    "form_attr_pwdLive": "Live password",
    "form_attr_bitrate": "The bitrates to be transferred to the streaming server (separated by ',')"
  },
  "SERVEREDIT": {
    "form_edit_title": "Edit server form",
    "form_title": "Server edit"
  },
  "VALIDATION": {
    "server.type.not_blank": "Server type cannot be blank",
    "server.internet.not_blank": "The internet cannot be blank",
    "server.record.not_blank": "The record cannot be blank",
    "server.dir.not_blank": "The directory cannot be blank",
    "server.urlVideo.not_valid": "The video URL is not valid",
    "server.urlMp4.not_valid": "The URL of MP4 video is not valid",
    "server.urlDiffusion.not_valid": "The URL of MP4 video is not valid",
    "server.urlVodAndroid.not_valid": "The video URL on Android is not valid",
    "server.urlLiveAndroid.not_valid": "The URL of live on Android is not valid",
    "server.urlCdnAndroid.not_valid": "The URL of CDN on Android is not valid",
    "server.urlVodIos.not_valid": "The video URL on IOS is not valid",
    "server.urlLiveIos.not_valid": "The URL of live on IOS is not valid",
    "server.urlCdnIos.not_valid": "The URL of CDN on IOS is not valid",
    "server.urlBackup.not_valid": "The URL backup is not valid",
    "server.urlMobile.not_valid": "The mobile URL is not valid",
    "server.urlServerFtp.not_valid": "The FTP server URL is not valid",
    "server.name.not_blank": "The server name cannot be blank",
    "server.login.not_blank": "The live login cannot be blank",
    "server_not_found": "Server not found",
    "not_authorized_server": "You are not authorized to access this server",
    "cannot_delete_server_related_channels": "You cannot delete a server related to one or many channels",
    "not_authorized_general": "You are not authorized",
    "invalid_form": "Invalid form",
    "bad_parameters": "Please check your parameters",
    "invalid_date": "Invalid date"
  }
}
);

$translateProvider.translations("fr", {
  "SERVERLIST": {
    "type": "Type",
    "none": "Tous",
    "access": "Acc\u00e8s",
    "url": "URL",
    "url_mp4": "URL en MP4",
    "delete_server_msg": "Voulez-vous vraiment supprimer le serveur ?",
    "delete_list_server_msg": "Voulez-vous vraiment supprimer ces serveurs ?",
    "delete_server_aria_label": "Supprimer le serveur",
    "delete_servers_aria_label": "Supprimer les serveurs",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "FERMER",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are": "Les serveurs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les serveurs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "url_diffusion": "URL diffusion",
    "identifier": "Identifier",
    "added": "Serveur ajout\u00e9 avec succ\u00e8s.",
    "edited": "Serveur modifi\u00e9 avec succ\u00e8s.",
    "action_new_element": "Ajouter un nouveau serveur"
  },
  "SERVERDETAIL": {
    "id": "Identifiant :",
    "name": "Nom :",
    "protocol": "Protocole :",
    "type": "Type :",
    "internet": "Internet :",
    "login": "Identifier :",
    "server_detail_title": "D\u00e9tails serveur",
    "dir": "R\u00e9pertoire:",
    "urlVideo": "URL:",
    "urlMp4": "URL en MP4:",
    "urlDiffusion": "URL de diffusion:",
    "urlVodAndroid": "URL de la vid\u00e9o sur Android:",
    "urlLiveAndroid": "URL direct sur Android:",
    "urlCdnAndroid": "URL de CDN sur Android:",
    "urlVodIos": "URL de la vid\u00e9o sur IOS:",
    "urlLiveIos": "URL direct sur IOS:",
    "urlCdnIos": "URL de CDN sur IOS:",
    "dirLecture": "Playback birectory:",
    "urlBackup": "URL de restoration:",
    "urlMobile": "URL mobile:",
    "urlServerFtp": "URL du serveur FTP:",
    "loginLive": "Login du direct:",
    "bitrate": "Les bitrates \u00e0 transférer au serveur de streaming (s\u00e9par\u00e9 par ','):"
  },
  "SERVERADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau Serveur",
    "form_title": "Information du serveur",
    "form_attr_type": "Type",
    "form_attr_server_type": "Type serveur",
    "form_attr_protocol": "Protocole",
    "form_attr_internet": "Internet",
    "form_attr_record": "Record",
    "form_attr_name": "Nom",
    "form_attr_server_name": "Nom du serveur",
    "form_attr_login": "Identifiant",
    "form_attr_pwd": "Mot de passe",
    "form_attr_dir": "R\u00e9pertoire",
    "form_attr_urlVideo": "URL",
    "form_attr_urlMp4": "URL en MP4",
    "form_attr_urlDiffusion": "URL de diffusion",
    "form_attr_urlVodAndroid": "URL de la vid\u00e9o sur Android",
    "form_attr_urlLiveAndroid": "URL direct sur Android",
    "form_attr_urlCdnAndroid": "URL de CDN sur Android",
    "form_attr_urlVodIos": "URL de la vid\u00e9o sur IOS",
    "form_attr_urlLiveIos": "URL direct sur IOS",
    "form_attr_urlCdnIos": "Url CDN IOS",
    "form_attr_dirLecture": "R\u00e9pertoire de lecture",
    "form_attr_urlBackup": "URL de restoration",
    "form_attr_urlMobile": "URL mobile",
    "form_attr_urlServerFtp": "URL du serveur FTP",
    "form_attr_loginLive": "Login du direct",
    "form_attr_pwdLive": "Mot de passe du direct",
    "form_attr_bitrate": "Les bitrates \u00e0 transférer au serveur de streaming (s\u00e9par\u00e9 par ',')"
  },
  "SERVEREDIT": {
    "form_edit_title": "Formulaire de modification serveur",
    "form_title": "Information du serveur"
  },
  "VALIDATION": {
    "server.type.not_blank": "Le type du serveur ne doit pas \u00eatre vide",
    "server.internet.not_blank": "L'internet ne doit pas \u00eatre vide",
    "server.record.not_blank": "Le record ne doit pas \u00eatre vide",
    "server.dir.not_blank": "La r\u00e9pertoire ne doit pas \u00eatre ind\u00e9finie",
    "server.urlVideo.not_valid": "L'URL de la vid\u00e9o est invalide",
    "server.urlMp4.not_valid": "L'URL de la vid\u00e9o MP4 est invalide",
    "server.urlDiffusion.not_valid": "L'URL du diffusion de la vid\u00e9o est invalide",
    "server.urlVodAndroid.not_valid": "L'URL de la vid\u00e9o sur Android est invalide",
    "server.urlLiveAndroid.not_valid": "L'URL de la vid\u00e9o en direct sur Android est invalide",
    "server.urlCdnAndroid.not_valid": "L'URL de la vid\u00e9o sur CDN sur Android est invalide",
    "server.urlVodIos.not_valid": "L'URL de la vid\u00e9o sur IOS est invalide",
    "server.urlLiveIos.not_valid": "L'URL de la vid\u00e9o en direct sur IOS est invalide",
    "server.urlCdnIos.not_valid": "L'URL de la vid\u00e9o sur CDN sur IOS est invalide",
    "server.urlBackup.not_valid": "L'URL du backup est invalide",
    "server.urlMobile.not_valid": "L'URL du mobile est invalide",
    "server.urlServerFtp.not_valid": "L'URL du serveur FTP est invalide",
    "server.name.not_blank": "Le nom du serveur ne peut pas \u00eatre null",
    "server.login.not_blank": "Le login du direct ne peut pas \u00eatre null",
    "server_not_found": "Le serveur n'existe pas",
    "not_authorized_server": "Vous n'avez pas la permission pour acc\u00e9der \u00e0 ce serveur",
    "not_authorized_general": "Vous n'avez pas la permission pour cette action",
    "cannot_delete_server_related_channels": "Vous ne pouvez pas supprimer un serveur reli\u00e9 a un ou plusieurs canaux",
    "invalid_form": "Formulaire invalide",
    "bad_parameters": "V\u00e9rifiez vos param\u00e9tres",
    "invalid_date": "Date invalide"
  }
}
);

$translateProvider.translations("en", {
  "SKIN": {

  }
});

$translateProvider.translations("fr", {
  "SKIN": {

  }
});

$translateProvider.translations("en", {
  "REFERRERLIST": {
    "title": "Title",
    "parent": "Parent",
    "update_referrer": "Update",
    "delete_referrer": "Delete",
    "detail_referrer": "Details",
    "delete_referrer_msg": "Do you want to delete the referrer?",
    "delete_referrer_aria_label": "Delete referrer ?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "Referrer added successfully.",
    "edited": "Referrer edited successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element": "Add new referrer",
    "dialog_will_be_deleted_referrer": " will be deleted.",
    "delete_element_referrers_msg": "Do you want to delete this Referrer?",
    "delete_list_referrers_msg": "Do you want to delete these Referrers?",
    "delete_referrers_aria_label": "Delete Referrers",
    "undeleted_are": "Referrers with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Referrers with ids \"{{list}}\" have been deleted",
    "dialog_alert_enable_description": "Referrer added to whitelist",
    "dialog_alert_disable_description": "Referrer added to blacklist"
  },
  "REFERRERDETAIL": {
    "id": "Id : ",
    "title": "Title : ",
    "parent": "Parent",
    "visible": "Visible",
    "referrer_detail_title": "Referrer detail"
  },
  "REFERRERADD": {
    "form_new_title": "Add referrer form",
    "form_title": "Referrer information",
    "form_attr_name": "Title"
  },
  "REFERREREDIT": {
    "form_edit_title": "Edit referrer form :",
    "form_title": "Referrer edit"
  }
});

$translateProvider.translations("fr", {
  "REFERRERLIST": {
    "title": "Titre",
    "parent": "Parent",
    "update_referrer": "Modifier",
    "delete_referrer": "Supprimer",
    "detail_referrer": "D\u00e9tails",
    "delete_referrer_msg": "Voulez-vous vraiment supprimer le référent ?",
    "delete_referrer_aria_label": "Voulez-vous supprimer le référent",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "added": "Référent ajout\u00e9e avec succ\u00e8s.",
    "edited": "Référent modifi\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_will_be_deleted_referrer": " sera supprim\u00e9e.",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "description": "Description",
    "action_new_element": "Ajouter un nouveau référent",
    "delete_referrers_aria_label": "Supprimer les référents",
    "delete_element_referrers_msg": "Voulez-vous vraiment supprimer ce référent?",
    "delete_list_referrers_msg": "Voulez-vous vraiment supprimer ces référents?",
    "undeleted_are": "Les référents ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les référents ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es",
    "dialog_alert_enable_description": "Référent ajouté à la liste blanche",
    "dialog_alert_disable_description": "Référent ajouté à la liste noire"
  },
  "REFERRERDETAIL": {
    "id": "Id : ",
    "title": "Titre : ",
    "parent": "Parent",
    "visible": "Visible",
    "referrer_detail_title": "D\u00e9tails du référent"
  },
  "REFERRERADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau référent",
    "form_title": "Information du référent",
    "form_attr_name": "Titre"
  },
  "REFERREREDIT": {
    "form_edit_title": "Formulaire de modification du référent : ",
    "form_title": "Modification du référent"
  }
});

$translateProvider.translations("en", {
  "MOOCPARAMETERSLIST": {
    "type": "Type",
    "value": "Value",
    "dialog_title": " Changing the value of the key : ",
    "action_new_element" : "Add new key",
    "delete_cle_msg": "Do you want to delete the key?",
    "delete_list_cle_msg": "Do you want to delete these keys?",
    "delete_cle_aria_label": "Delete keys",
    "undeleted_are": "Keys with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Keys with ids \"{{list}}\" have been deleted",
    "delete_cle": "Delete",
    "delete_multi_cle": "Delete Mooc",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "update_cle": "Update",
    "detail_cle": "Details",
    "added": "Successfully synchronization",
    "edited": "Key edited successfully."
  },
  "code": 200
}
);

$translateProvider.translations("fr", {
  "MOOCPARAMETERSLIST": {
    "type": "Type",
    "value": "Valeur",
    "dialog_title": "Modification de la valeur de la cl\u00e9 : ",
    "action_new_element" : "Ajouter un nouveau cl\u00e9",
    "delete_cle_msg": "Voulez-vous vraiment supprimer la cl\u00e9 ?",
    "delete_list_cle_msg": "Voulez-vous vraiment supprimer ces cl\u00e9s ?",
    "delete_cle_aria_label": "Supprimer les cl\u00e9s",
    "undeleted_are": "Les cl\u00e9s ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les cl\u00e9s ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_cle": "Supprimer",
    "delete_multi_cle": "Supprimer les Moocs",

    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_cle": "Modifier",
    "detail_cle": "D\u00e9tails",
    "added": "Synchronisation effectu\u00e9e avec succ\u00e8s.",
    "edited": "Synchronisation modifi\u00e9e avec succ\u00e8s."
  },
  "code": 200
});

$translateProvider.translations("en", {
  "DISPLAYSCHEDULECALENDAR": {
    "CALENDAR": "Calendar",
    "DELETE": "Delete",
    "MONTH": "Month",
    "WEEK": "Week",
    "DAY": "Day",
    "PREVIOUS": "Previous",
    "NEXT": "Next",
    "SAVE": "save",
    "EDIT": "Edit",
    "SEARCH": "Search",
    "TODAY": "To day",
    "ENABLE": "ON",
    "DISABLE": "OFF",
    "END": "End",
    "INPROGRESS": "In progress",
    "COME": "To come up",
    "TITLE": "Title",
    "STARTAT": "Start at",
    "ENDAT": "End at"
  },
  "DISPLAYSCHEDULELIST": {
    "display_menuTitle": "Display",
    "display_schedule_list_menuTitle": "Schedule",
    "display_schedule_menuTitle": "List",
    "display_schedule_add_menuTitle": "List",
    "delete_schedule_aria_label": "Delete",
    "delete_list_schedule_message": "Are you sure you want to delete the programs schedules?",
    "delete_schedule_message": "Are you sure you want to delete the programs schedule?",
    "delete_schedule_label": "Delete the programs schedule",
    "delete_schedules_label": "Delete the programs schedules",
    "dialog_alert_delete_description": " has been deleted successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_close": "Close",
    "no_program": "No program",
    "action_open": "Open Schedule",
    "added": "has been added successfully",
    "edited": "has been modified successfully"
  },
  "VALIDATIONS": {
    "Schedule.uniqueTitle": "This field must be unique"
  }
});

$translateProvider.translations("fr", {
  "DISPLAYSCHEDULECALENDAR": {
    "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9e avec succès.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !!!",
    "dialog_alert_delete_close": "FERMER",
    "CALENDAR": "Calendrier",
    "DELETE": "Supprimer",
    "MONTH": "Mois",
    "WEEK": "Semaine",
    "DAY": "Jour",
    "PREVIOUS": "Pr\u00e9c\u00e9dent",
    "NEXT": "Suivant",
    "SAVE": "Sauvegarder",
    "EDIT": "Modifier",
    "SEARCH": "Recherche",
    "TODAY": "Aujourd'hui",
    "ENABLE": "Activer",
    "DISABLE": "D\u00e9sactiver",
    "END": "Terminé",
    "INPROGRESS": "EN cours",
    "COME": "\u00c0 venir",
    "TITLE": "titre",
    "STARTAT": "D\u00e9but",
    "ENDAT": "Fin"
  },
  "DISPLAYSCHEDULELIST": {
    "delete_schedule_label": "Supprimer la grille des programmes",
    "delete_schedules_label": "Supprimer les grilles des programme",
    "delete_schedule_message": "Voulez-vous vraiment supprimer la grille des programmes?",
    "delete_list_schedule_message": "Voulez-vous vraiment supprimer les grilles des programmes?",
    "display_menuTitle": "Display",
    "display_schedule_list_menuTitle": "Grille",
    "display_schedule_menuTitle": "Liste",
    "display_schedule_add_menuTitle": "Liste",
    "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9e avec succès.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_close": "FERMER",
    "no_program": "Aucun programme trouvé",
    "action_open": "Ouvrir Grille",
    "added": "a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
    "edited": "a \u00e9t\u00e9 modifi\u00e9e avec succ\u00e8s"
  },
  "VALIDATIONS": {
    "Schedule.uniqueTitle": "Ce champ doit être unique"
  }
});

$translateProvider.translations("en", {
  "EDITORDISPO": {
    "copied":"key copied",
    "title":"key"
  }
});

$translateProvider.translations("fr", {
  "EDITORDISPO": {
    "copied":"cl\u00e9 copi\u00e9e",
    "title":"cl\u00e9"
  }
});

$translateProvider.translations("en", {
  "DISPLAYPROGRAMSLIST": {
    "title":"Title",
    "duration":"Duration",
    "delete_programs_aria_label":"Delete",
    "added":"has been added successfully",
    "edited":"has been modified successfully",
    "delete_program_msg":"Are you sure you want to delete the program?",
    "delete_list_programs_msg":"Are you sure you want to delete the programs?",
    "delete_program_label":"Delete program",
    "delete_programs_label":"Delete programs",
    "dialog_alert_delete_description":" has been deleted successfully.",
    "dialog_alert_delete_error_title":"Error",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_error_description":"Operation not performed !!!",
    "dialog_alert_delete_close":"CLOSE",
    "undeleted_are":"Programs with ids \"{{list}}\" could not be deleted",
    "deleted_are":"Programs with ids \"{{list}}\" have been deleted",
    "day":"day",
    "days":"days",
    "hour":"hour",
    "hours":"hours",
    "minute":"minute",
    "minutes":"minutes",
    "second":"second",
    "seconds":"seconds",
    "no_longer":"This program does no longer exist"
  },
  "DISPLAYPROGRAMSADD": {
  	"form_title":"Edit program form",
    "newProgram":"New program",
  	"playlists":"Playlists",
  	"add":"Add",
  	"addNewProgram":"Adding a new program",
  	"add":"Add",
  	"save":"Save",
  	"remove":"Delete",
  	"title":"Title",
  	"description":"Description",
    "playlist_will_be_deleted":"The playlist _st{{title}}_est will bed deleted.",
    "delete_playlist_msg":"Are you sure you want to delete the playlist?",
    "delete_playlist_aria_label":"Delete playlist",
    "continue":"Continue",
    "time_slot_occupied":"Time slot is occupied"
  },
  "DISPLAYPROGRAMSEDIT":{
    "form_title":"Proram edit form",
    "edit":"Edit"
  },
  "DISPLAYPROGRAMSDETAIL":{
    "title":"Program Detail"
  }
}
);

$translateProvider.translations("fr", {
  "DISPLAYPROGRAMSLIST": {
    "title":"Titre",
    "duration":"Dur\u00e9e",
    "delete_programs_aria_label":"Supprimer",
    "added":"a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
    "edited":"a \u00e9t\u00e9 modifi\u00e9e avec succ\u00e8s",
    "delete_program_msg":"Voulez-vous vraiment supprimer le programme?",
    "delete_list_programs_msg":"Voulez-vous vraiment supprimer les programmes?",
    "delete_program_label":"Supprimer le programme",
    "delete_programs_label":"Supprimer les programmes",
    "dialog_alert_delete_description":" \u00e0 \u00e9t\u00e9 supprim\u00e9 avec succès.",
    "dialog_alert_delete_error_title":"Erreur",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_error_description":"Op\u00e9ration non effectu\u00e9e !!!",
    "dialog_alert_delete_close":"FERMER",
    "undeleted_are":"Les programmes ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are":"Les programmes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "day":"jour",
    "days":"jours",
    "hour":"heure",
    "hours":"heures",
    "minute":"minute",
    "minutes":"minutes",
    "second":"seconde",
    "seconds":"secondes",
    "no_longer":"Ce programme n'existe plus"
  },
  "DISPLAYPROGRAMSADD": {
  	"form_title":"Formulaire d'ajout d'un nouveau programme",
    "newProgram":"Nouveau Programme",
  	"playlists":"Playlists",
  	"add":"Ajouter",
  	"addNewProgram":"Ajout d'un nouveau programme",
  	"add":"Ajouter",
  	"save":"Sauvegarder",
  	"remove":"Supprimer",
  	"title":"Titre",
  	"description":"Description",
    "playlist_will_be_deleted":"la playlist _st{{title}}_est va \u00eatre supprimer.",
    "delete_playlist_msg":"Voulez-vous vraiment supprimer la playlist?",
    "delete_playlist_aria_label":"Supprimer la playlist",
    "continue":"Continuer",
    "time_slot_occupied":"Cette plage horaire est occup\u00e9e."
  },
  "DISPLAYPROGRAMSEDIT":{
    "form_title":"Formulaire de modification du programme",
    "edit":"Modifier"
  },
  "DISPLAYPROGRAMSDETAIL":{
    "title":"D\u00e9tails du programme"
  }
}
);

$translateProvider.translations("en", {
  "RMBOXGROUPLIST": {
    "name": "Name",
    "bandwidthLimit": "Bandwidth limit",
    "syncTime": "Sync time",
    "update_rmboxgroup": "Update",
    "delete_rmboxgroup": "Delete",
    "delete_rmboxgroup_msg": "Do you want to delete the RmBox group?",
    "delete_list_rmboxgroup_msg": "Do you want to delete these RmBox groups?",
    "delete_rmboxgroup_aria_label": "Delete RmBox group?",
    "delete_rmboxgroups_aria_label": "Delete RmBox groups",
    "undeleted_are": "RmBox groups with ids \"{{list}}\" could not be deleted",
    "deleted_are": "RmBox groups with ids \"{{list}}\" have been deleted",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "RmBox group added successfully.",
    "edited": "RmBox group edited successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "detail_rmboxgroup": "Details",
    "action_new_element" : "Add new RmBox group",
    "schedule":"Schedule",
    "associate_schedule" : "Associate schedule"
  },
  "RMBOXGROUPDETAIL": {
    "id": "Id : ",
    "name": "Name : ",
    "bandwidthLimit": "Bandwith limit ",
    "syncTime": "Synchronized time",
    "rmboxgroup_detail_title": "Detail of the RmBox group"
  },
  "RMBOXGROUPADD": {
    "form_new_title": "Form for adding a new RmBox group",
    "form_title": "RmBox group information",
    "form_attr_name": "Name",
    "form_attr_bandwidthLimit": "Bandwith limit",
    "form_attr_syncTime": "Synchronized time"
  },
  "RMBOXGROUPEDIT": {
    "form_edit_title": "Edit RmBox group form :",
    "form_title": "RmBox group edit"
  },
  "VALIDATIONS": {
    "rmboxgroup_not_found": "RmBox group does not exist",
    "rmboxgroup.name.not_blank" : "This field is required",
    "rmboxgroup.bandwidthLimit.not_blank" : "This field is required",
    "rmboxgroup.syncTime.not_blank" : "This field is required",
    "All_ids_will_be_deleted" : "RmBox group not found",
    "no_id_deleted" : "RmBox group not found"
  }
}
);

$translateProvider.translations("fr", {
  "RMBOXGROUPLIST": {
    "name": "Nom",
    "bandwidthLimit": "Limite bande passante",
    "syncTime": "Horaire de synchro",
    "update_rmboxgroup": "Modifier",
    "delete_rmboxgroup": "Supprimer",
    "delete_rmboxgroup_msg": "Voulez-vous vraiment supprimer le groupe de RmBox ?",
    "delete_list_rmboxgroup_msg": "Voulez-vous vraiment supprimer ces groupes de RmBox ?",
    "undeleted_are": "Les RmBox groupes ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les RmBox groupes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_rmboxgroup_aria_label": "Supprimer le groupe RmBox",
    "delete_rmboxgroups_aria_label": "Supprimer les groupes RmBox",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "added": "Groupe RmBox ajout\u00e9 avec succ\u00e8s.",
    "edited": "Groupe RmBox modifi\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "detail_rmboxgroup": "D\u00e9tails",
    "action_new_element" : "Ajouter un nouveau groupe RmBox",
    "schedule":"Grille des programmes",
    "associate_schedule" : "Associer une grille des programmes"
  },
  "RMBOXGROUPDETAIL": {
    "id": "ID : ",
    "name": "Name : ",
    "bandwidthLimit": "Limite de la bande passante",
    "syncTime": "Synchronisation temporelle",
    "rmboxgroup_detail_title": "Groupe RmBox d\u00e9tail"
  },
  "RMBOXGROUPADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau groupe de RmBox",
    "form_title": "Information du groupe RmBox",
    "form_attr_name": "Nom",
    "form_attr_bandwidthLimit": "Limite de la bande passante",
    "form_attr_syncTime": "Horaire synchronis\u00e9"
  },
  "RMBOXGROUPEDIT": {
    "form_edit_title": "Formulaire de modification du groupe RmBox : ",
    "form_title": "Edition du  groupe RmBox"
  },
  "VALIDATIONS": {
    "rmboxgroup_not_found": "Groupe RmBox n'existe pas",
    "rmboxgroup.name.not_blank" : "Ce champ est obligatoire",
    "rmboxgroup.bandwidthLimit.not_blank" : "Ce champ est obligatoire",
    "rmboxgroup.syncTime.not_blank" : "Ce champ est obligatoire",
    "All_ids_will_be_deleted" : "Les groupes RmBox sont introuvables",
    "no_id_deleted" : "Les groupes RmBox sont introuvables"
  }
}
);

$translateProvider.translations("en", {
  "RMBOXLIST": {
    "name": "Name",
    "type": "Type",
    "ip": "IP",
    "address": "Address",
    "mac": "Mac",
    "postal": "Postal address",
    "groupid": "RmBox group",
    "storage": "Space left",
    "startSynch": "Start sync",
    "duration": "Sync duration",
    "state": "Status / Modified in",
    "dateadd": "Date add",
    "dateedit": "Date edit",
    "zone": "Assigned areas",
    "list_zone": "Zones list",
    "video": "Videos present on the RmBox",
    "list_video": "Videos list",
    "delete_rmbox": "Delete",
    "associate_schedule": "Associate schedule",
    "activate_playlist" : "Chain change",
    "activate_playlist_modal" : "Activate a playlist",
    "show_schedule": "Show schedule",
    "schedule": "Schedule",
    "delete_rmbox_msg": "Do you want to delete the RmBox?",
    "delete_intervention_msg": "Do you want to delete the intervention?",
    "delete_rmbox_aria_label": "Delete RmBox",
    "delete_intervention_aria_label": "Delete intervention",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "update_rmbox": "Update",
    "detail_rmbox": "Details",
    "added": "RmBox added successfully.",
    "edited": "RmBox edited successfully.",
    "action_new_element": "Add new RmBox",
    "delete_list_RmBoxs_msg": "Do you want to delete these RmBoxs?",
    "delete_RmBoxs_aria_label": "Delete RmBoxs",
    "undeleted_are": "RmBoxs with ids \"{{list}}\" could not be deleted",
    "deleted_are": "RmBoxs with ids \"{{list}}\" have been deleted",
    "state_ok": "Ok",
    "state_warning": "Warning",
    "state_critical": "Critical",
    "state_unknown": "Unknown",
    "state_details": "The box's status",
    "state_label": "Statut label",
    "state_code_error": "Error code",
    "state_error_message": "Error message",
    "pdf_list": "Rapports history",
    "date": "Date",
    "rapports": "Rapports sent",
    "zone_id": "Id",
    "zone_name": "Name",
    "zone_attrebu": " Assigned zones",
    "un_zone_attrebu": "One Assigned zone",
    "zone_attrebu_none": "No assigned zone",
    "video_attrebu_none": "No assigned video",
    "video_attrebu": " Assigned videos",
    "un_video_attrebu": "One Assigned video"
  },
  "RMBOXDETAIL": {
    "id": "ID : ",
    "name": "Name : ",
    "type": "Type :",
    "ip": "IP : ",
    "mac": "Mac : ",
    "postal": "Postal address : ",
    "groupid": "RmBox group : ",
    "created_at": "Created on : ",
    "updated_at": "Date edit : ",
    "rmbox_detail_title": "RmBox detail"
  },
  "RMBOXADD": {
    "form_attr_name": "Name",
    "form_attr_ip": "IP adress",
    "form_attr_mac": "Mac adress",
    "form_attr_postal": "Postal address",
    "form_attr_groupid": "RmBox group",
    "form_new_title": "Add RmBox form",
    "form_title": "RmBox information",
    "form_attr_rmbox_type": "Type"
  },
  "RMBOXASSOCIATESCHEDULE": {
    "form_attr_schedule": "Schedule",
    "form_attr_schedules": "Schedules",
    "form_attr_playlists": "Playlists"
  },
  "RMBOXEDIT": {
    "form_edit_title": "Edit RmBox form",
    "form_title": "RmBox edit"
  },
  "VALIDATIONS": {
    "not_form_submitted": "Check your input",
    "rmbox_not_found": "The RmBox is not found",
    "no_id_deleted": "No RmBox deleted"
  },
  "INTERVENTIONS": {
    "receptionDate": "Reception date",
    "remark": "Notes",
    "sendDate": "Send date",
    "firstStartedDate": "First start date",
    "add": "Add intervention",
    "edit": "Edit intervention",
    "old": "Old Mac",
    "new": "New Mac",
    "added": "Intervention added successfully.",
    "edited": "Intervention edited successfully.",
    "dialog_will_be_deleted": " will be deleted.",
    "dialog_alert_delete_description": " has been successfully deleted."
  }
}
);

$translateProvider.translations("fr", {
  "RMBOXLIST": {
    "name": "Nom",
    "type": "Type",
    "ip": "IP",
    "mac": "Mac",
    "address": "Adresse",
    "postal": "Adresse postale ",
    "groupid": "Groupe RmBox",
    "storage": "Espace restant",
    "startSynch": "D\u00e9but sync",
    "duration": "Dur\u00e9e sync",
    "state": "Statut / Modifi\u00e9 le",
    "dateadd": "Date d'ajout",
    "dateedit": "Date d'\u00e9dition",
    "zone": "Zones attribu\u00e9es",
    "list_zone": "Liste des zones",
    "video": "Vid\u00e9os pr\u00e9sent\u00e9s",
    "list_video": "Liste des vid\u00e9os",
    "delete_rmbox": "Supprimer",
    "associate_schedule": "Associer une grille des programmes",
    "activate_playlist" : "Changement de chaine",
    "activate_playlist_modal" : "Activer une playlist",
    "show_schedule": "Voir grille",
    "schedule": "Grille des programmes",
    "delete_rmbox_msg": "Voulez-vous vraiment supprimer le RmBox ?",
    "delete_intervention_msg": "Voulez-vous vraiment supprimer l'intervention ?",
    "delete_rmbox_aria_label": "Supprimer RmBox",
    "delete_intervention_aria_label": "Supprimer intervention",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_rmbox": "Modifier",
    "detail_rmbox": "D\u00e9tails",
    "added": "RmBox ajout\u00e9 avec succ\u00e8s.",
    "edited": "RmBox modifi\u00e9 avec succ\u00e8s.",
    "action_new_element": "Ajouter un nouveau RmBox",
    "delete_list_RmBoxs_msg": "Voulez-vous vraiment supprimer ces RmBoxs?",
    "delete_RmBoxs_aria_label": "Supprimer les RmBoxs",
    "undeleted_are": "Les RmBoxs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les RmBoxs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "state_ok": "Ok",
    "state_warning": "Avertissement",
    "state_critical": "Critique",
    "state_unknown": "Inconnu",
    "state_details": "Le statut de la RmBox",
    "state_label": "Label du statut",
    "state_code_error": "Code d'erreur",
    "state_error_message": "Message d'erreur",
    "pdf_list": "Historique des rapports envoy\u00e9s",
    "date": "Date",
    "rapports": "Rapports envoy\u00e9s",
    "zone_id": "Identifiant",
    "zone_name": "Nom",
    "zone_attrebu": " Zones attribu\u00e9es ",
    "un_zone_attrebu": "Une Zone attribu\u00e9e ",
    "zone_attrebu_none": "Pas de zone attribu\u00e9e",
    "video_attrebu_none": "Pas de vid\u00e9o attribu\u00e9e",
    "video_attrebu": " Vid\u00e9os attribu\u00e9es",
    "un_video_attrebu": "Une Vid\u00e9o attribu\u00e9e"
  },
  "RMBOXDETAIL": {
    "id": "Identifiant : ",
    "name": "Nom : ",
    "type": "Type :",
    "ip": "IP : ",
    "mac": "Mac : ",
    "postal": "Adresse postale : ",
    "groupid": "Groupe RmBox : ",
    "created_at": "Date d'ajout : ",
    "updated_at": "Date d'\u00e9dition : ",
    "rmbox_detail_title": "D\u00e9tail du RmBox"
  },
  "RMBOXADD": {
    "form_attr_name": "Nom",
    "form_attr_ip": "IP",
    "form_attr_mac": "Mac adresse",
    "form_attr_postal": "Adresse postale ",
    "form_attr_groupid": "Groupe RmBox",
    "form_new_title": "Formulaire d'ajout d'un RmBox",
    "form_title": "Information du RmBox",
    "form_attr_rmbox_type": "Type"
  },
  "RMBOXEDIT": {
    "form_edit_title": "Formulaire de modification du RmBox",
    "form_title": "Modification du RmBox"
  },
  "RMBOXASSOCIATESCHEDULE": {
    "form_attr_schedule": "Grille des programmes",
    "form_attr_schedules": "Grilles des programmes",
    "form_attr_playlists": "Playlists"
  },
  "VALIDATIONS": {
    "not_form_submitted": "V\u00e9rifiez les valeurs envoy\u00e9es",
    "rmbox_not_found": "Le RmBox est introuvable",
    "no_id_deleted": "Aucun RmBox est supprim\u00e9"
  },
  "INTERVENTIONS": {
    "receptionDate": "Date réception",
    "remark": "Remarques",
    "sendDate": "Date d'envoie",
    "firstStartedDate": "Mise en marche",
    "add": "Information de l'intervention",
    "edit": "Modification de l'intervention",
    "old":"Ancienne adresse Mac",
    "new":"Nouvelle adresse Mac",
    "added": "Intervention ajout\u00e9e avec succ\u00e8s.",
    "edited": "Intervention modifi\u00e9e avec succ\u00e8s.",
    "dialog_will_be_deleted": " sera supprim\u00e9e.",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s."

  }
}
);

$translateProvider.translations("en", {
    "IPLIST": {
        "adress": "IP Adress",
        "description": "Description",
        "delete_ip": "Delete",
        "delete_ip_msg": "Are you sure you want to delete this IP address ?",
        "delete_ip_aria_label": "Delete IP address",
        "dialog_alert_delete_title": "Successful operation",
        "dialog_alert_delete_description": " has been successfully deleted.",
        "dialog_alert_delete_close": "Close",
        "dialog_alert_delete_error_title": "Error",
        "dialog_alert_delete_error_description": "Operation not performed!",
        "update_ip": "Edit",
        "detail_ip": "Details",
        "added": "IP address added successfully.",
        "edited": "IP address edited successfully.",
        "action_new_element" : "Add a new IP address",
        "delete_element_ip_msg": "Do you want to delete this IP?",
        "delete_list_ips_msg": "Do you want to delete these IP?",
        "delete_ips_aria_label": "Delete IPs",
        "undeleted_are": "IPs with ids \"{{list}}\" could not be deleted",
        "deleted_are": "IPs with ids \"{{list}}\" have been deleted"
    },
    "IPDETAIL": {
        "adress": "IP address",
        "description": "Description",
        "ip_detail_title": "IP address details",
        "id": "ID : ",
        "update_ip": "Edit"
    },
    "IPADD": {
        "form_attr_ip": "IP address",
        "form_attr_description": "Description",
        "form_new_title": "Add a new IP address form",
        "form_title": "IP address information",
        "ERRORS": {
            "INVALIDFORMAT": "This field must contain a valid IP address.",
            "REQUIRED": "This field is required"
        }
    },
    "IPEDIT": {
        "form_edit_title": "Change IP address",
        "form_title": "Edit IP address"
    },
    "VALIDATIONS": {
        "ips_not_found" : "IPs does not exist",
        "ips.description.not_blank" : "This field is required",
        "ips.ip.not_blank" : "This field is required",
        "ips.ip.not_valid" : "IPs is not valid"

    }
}
);

$translateProvider.translations("fr", {
    "IPLIST": {
        "adress": "Adresse IP",
        "description": "Description",
        "delete_ip": "Supprimer",
        "delete_ip_msg": "Voulez-vous vraiment supprimer cette adresse IP ?",
        "delete_ip_aria_label": "Supprimer l'adresse IP",
        "dialog_alert_delete_title": "Op\u00e9ration réussie",
        "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s..",
        "dialog_alert_delete_close": "Fermer",
        "dialog_alert_delete_error_title": "Erreur",
        "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
        "update_ip": "Modifier",
        "detail_ip": "D\u00e9tails",
        "added": "Adresse IP ajout\u00e9e avec succ\u00e8s.",
        "edited": "Adresse IP modifi\u00e9e avec succ\u00e8s.",
        "action_new_element" : "Ajouter une nouvelle adresse IP",
        "delete_ips_aria_label": "Supprimer les IPs",
        "delete_element_ip_msg": "Voulez-vous vraiment supprimer ce IP?",
        "delete_list_ips_msg": "Voulez-vous vraiment supprimer ces IPs?",
        "undeleted_are": "Les IPs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
        "deleted_are": "Les IPs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s"
    },
    "IPDETAIL": {
        "adress": "Adresse IP",
        "description": "Description",
        "ip_detail_title": "D\u00e9tail de l'IP",
        "id": "Identifiant : ",
        "update_ip": "Modifier"
    },
    "IPADD": {
        "form_attr_ip": "Adresse IP",
        "form_attr_description": "Description",
        "form_new_title": "Formulaire d'ajout d'une nouvelle adresse IP",
        "form_title": "Information de l'adresse ip",
        "ERRORS": {
            "INVALIDFORMAT": "Ce champ doit contenir une adresse IP correcte.",
            "REQUIRED": "Ce champ est obligatoire"
        }
    },
    "IPEDIT": {
        "form_edit_title": "Formulaire de modification de l'adresse IP",
        "form_title": "Editer l'adresse IP"
    },
    "VALIDATIONS": {
        "ips_not_found" : "IP n'existe pas",
        "ips.description.not_blank" : "Ce champ est obligatoire",
        "ips.ip.not_blank" : "Ce champ est obligatoire",
        "ips.ip.not_valid" : "IP n'est pas valide"

    }
}
);

$translateProvider.translations("en", {
  "ZONELIST": {
    "name": "Zone",
    "path": "Path (URL)",
    "ipStart": "IP address at the beginning",
    "ipEnd": "IP address at the end",
    "rmbox": "RmBox",
    "bandwidthLimit": "Limit bandwidth",
    "zonelimit": "Connection limit zone",
    "delete_zone": "Delete",
    "delete_list_zones_msg": "Do you want to delete these zones?",
    "delete_zone_aria_label": "Delete zone",
    "delete_zones_aria_label": "Delete zones",
    "undeleted_are": "Zones with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Zones with ids \"{{list}}\" have been deleted",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "delete_zone_msg" : "Do you want to delete the zone?",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "dialog_will_be_deleted_zone": " will be deleted.",
    "update_zone": "Update",
    "detail_zone": "Details",
    "added": "Zone added successfully.",
    "edited": "Zone edited successfully.",
    "usersimultane": "Number of simultaneous users",
    "bandwidthDisponible": "Available bandwidth",
    "action_new_element" : "Add new zone",
    "dialog_alert_upload_description": " File has been successfully uploaded.",
    "add_zone": "Zones added successfully"
  },
  "ZONEDETAIL": {
    "id": "ID : ",
    "name": "Name",
    "path": "Path (URL)",
    "ipStart": "IP address at the beginning",
    "ipEnd": "IP address at the end",
    "rmbox": "RmBox",
    "bandwidthLimit": "Limit bandwidth",
    "zonelimit": "Connection limit zone",
    "usersimultane": "Number of simultaneous users",
    "bandwidthDisponible": "Available bandwidth",
    "zone_detail_title": "Zone detail"
  },
  "ZONEADD": {
    "form_attr_name": "Name",
    "form_attr_path": "Path (URL)",
    "form_attr_ipStart": "IP address at the beginning",
    "form_attr_ipEnd": "IP address at the end",
    "form_attr_rmbox": "RmBox",
    "entity": "Entity :",
    "form_attr_bandwidthLimit": "Limit bandwidth",
    "form_attr_zonelimit": "Connection limit zone",
    "form_attr_usersimultane": "Number of simultaneous users",
    "form_attr_bandwidthDisponible": "Available bandwidth",
    "form_new_title": "Add zone form",
    "form_title": "Zone information",
    "choose_file": "Choose a file",
    "new":"New",
    "exist":"Already exists",
    "errone":"inaccurate",
    "nb_ligne_file":"Number of lines in excel file",
    "select_file":"Select a file .xlsx *",
    "download_file":"download a sample"
  },
  "ZONEEDIT": {
    "form_edit_title": "Edit zone form",
    "form_title": "Zone edit"
  }
,
  "VALIDATIONS": {
    "zone_not_found": "Zone does not exist",
    "zone.name.not_blank" : "This field is required",
    "zone.path.not_blank" : "This field is required",
    "zone.ipStart.not_blank" : "This field is required",
    "zone.ipEnd.not_blank" : "This field is required",
    "zone.bandwidthLimit.not_blank" : "This field is required",
    "zone.zonelimit.not_blank" : "This field is required",
    "zone.usersimultane.not_blank" : "This field is required",
    "zone.bandwidthDisponible.not_blank" : "This field is required",
    "not_form_submitted" : "Check your input"

  }
}
);

$translateProvider.translations("fr", {
  "ZONELIST": {
    "name": "Zone",
    "path": "Chemin (URL)",
    "ipStart": "Adresse IP de d\u00e9but",
    "ipEnd": "Adresse IP de fin",
    "rmbox": "RmBox",
    "bandwidthLimit": "Limite bande passante",
    "zonelimit": "Limite de connexion de la zone",
    "delete_zone": "Supprimer",
    "delete_list_zones_msg": "Voulez-vous vraiment supprimer ces zones ?",
    "delete_zone_aria_label": "Supprimer la zone",
    "delete_zone_msg" : "Voulez-vous vraiment supprimer la zone ?",
    "delete_zones_aria_label": "Supprimer les zones",
    "undeleted_are": "Les zones ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les zones ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "dialog_will_be_deleted_zone": " sera supprim\u00e9e.",
    "update_zone": "Modifier",
    "detail_zone": "D\u00e9tails",
    "added": "Zone ajout\u00e9e avec succ\u00e8s.",
    "edited": "Zone modifi\u00e9e avec succ\u00e8s.",
    "usersimultane": "Nombre d'utilisateurs simultan\u00e9e",
    "bandwidthDisponible": "Bande passante disponible",
    "action_new_element" : "Ajouter une nouvelle zone",
    "dialog_alert_upload_description": "Le fichier a \u00e9t\u00e9 import\u00e9 avec succ\u00e8s.",
    "add_zone": "Les zones ont ajout\u00e9s avec succ\u00e8s"
  },
  "ZONEDETAIL": {
    "name": "Nom : ",
    "path": "Chemin (URL)",
    "ipStart": "Adresse IP de d\u00e9but",
    "ipEnd": "Adresse IP de fin",
    "rmbox": "RmBox",
    "bandwidthLimit": "Limite bande passante",
    "zonelimit": "Limite de connexion de la zone",
    "usersimultane": "Nombre d'utilisateurs simultan\u00e9e",
    "bandwidthDisponible": "Bande passante disponible",
    "zone_detail_title": "D\u00e9tail de la zone",
    "id": "Identifiant : "
  },
  "ZONEADD": {
    "form_attr_name": "Nom",
    "form_attr_path": "Chemin (URL)",
    "form_attr_ipStart": "Adresse IP de d\u00e9but",
    "form_attr_ipEnd": "Adresse IP de fin",
    "form_attr_rmbox": "RmBox",
    "entity": "Entité :",
    "form_attr_bandwidthLimit": "Limite bande passante",
    "form_attr_zonelimit": "Limite de connexion de la zone",
    "form_attr_usersimultane": "Nombre d'utilisateurs  simultan\u00e9e",
    "form_attr_bandwidthDisponible": "Bande passante disponible",
    "form_new_title": "Formulaire d'ajout d'une nouvelle zone",
    "form_title": "Information d'une zone",
    "choose_file": "Choisir un fichier",
    "new":"Nouveau",
    "exist":"Existe d\u00e9j\u00e0",
    "errone":"Erron\u00e9e",
    "nb_ligne_file":"Nombre de lignes dans le fichier excel",
    "select_file":"S\u00e9lectionner un fichier .xlsx *",
    "download_file":"T\u00e9l\u00e9charger un mod\u00e8le"
  },
  "ZONEEDIT": {
    "form_edit_title": "Formulaire de modification zone",
    "form_title": "Modification de la zone"
  }
,
  "VALIDATIONS": {
    "zone_not_found": "Zone n'existe pas",
    "zone.name.not_blank" : "Ce champ est obligatoire",
    "zone.path.not_blank" : "Ce champ est obligatoire",
    "zone.ipStart.not_blank" : "Ce champ est obligatoire",
    "zone.ipEnd.not_blank" : "Ce champ est obligatoire",
    "zone.bandwidthLimit.not_blank" : "Ce champ est obligatoire",
    "zone.zonelimit.not_blank" : "Ce champ est obligatoire",
    "zone.usersimultane.not_blank" : "Ce champ est obligatoire",
    "zone.bandwidthDisponible.not_blank" : "Ce champ est obligatoire",
    "not_form_submitted" : "V\u00e9rifiez les valeurs envoy\u00e9es"

  }
}
);

$translateProvider.translations("en", {
  "ERROR500": {
    "CODE": "Error 500",
    "MESSAGE": "Well, you broke the internet!",
    "SUBMESSAGE": "Just kidding         looks like we have an internal issue         please try again in couple minutes",
    "REPORT": "Report this problem"
  }
});

$translateProvider.translations("fr", {
  "ERROR500": {
    "CODE": "Erreur 500",
    "MESSAGE": "Eh bien, vous avez bris\u00e9 Internet !",
    "SUBMESSAGE": "Juste une blague         on dirait que nous avons un probl\u00e8me interne         essayez \u00e0 nouveau dans quelques minutes",
    "REPORT": "Signaler ce probl\u00e8me"
  }
});

$translateProvider.translations("en", {
  "ERROR404": {
    "CODE": "Error 404",
    "MESSAGE": "Sorry but we couldn\u2019t find the page you are looking for",
    "SEARCH": "Search for anything",
    "GO_BACK": "Go back to dashboard"
  },
  "code": 200
});

$translateProvider.translations("fr", {
  "ERROR404": {
    "CODE": "Erreur 404",
    "MESSAGE": "D\u00e9sol\u00e9 mais nous n'avons pas pu trouver la page que vous recherchez",
    "SEARCH": "Rechercher quelque chose",
    "GO_BACK": "Retour au tableau de bord"
  }
});

$translateProvider.translations("en", {
  "ERROR403": {
    "CODE": "Error 403",
    "MESSAGE": "Access denied for this ressource !",
    "SEARCH": "Search for anything",
    "GO_BACK": "Go back to dashboard",
    "unauthorize_to_ressource": "Access denied for this ressource : ",
    "unauthorize_toast_msg": "Sadly, you don't have acces to this resource."
  }
});

$translateProvider.translations("fr", {
  "ERROR403": {
    "CODE": "Erreur 403",
    "MESSAGE": "Vous n'\u00eates pas autoris\u00e9 pour accéder \u00e0 ces ressources !",
    "SEARCH": "Rechercher quelque chose",
    "GO_BACK": "Retour au tableau de bord",
    "unauthorize_to_ressource": "Vous n'\u00eates pas autoris\u00e9 pour accéder \u00e0 cette ressource : ",
    "unauthorize_toast_msg": "Malheureusement, vous n'\u00eates pas autoris\u00e9 pour accéder \u00e0 cette ressource."
  }
});

$translateProvider.translations("en", {
  "DISPLAYSCHEDULECALENDAR": {
    "CALENDAR": "Calendar",
    "DELETE": "Delete",
    "MONTH": "Month",
    "WEEK": "Week",
    "DAY": "Day",
    "PREVIOUS": "Previous",
    "NEXT": "Next",
    "SAVE": "save",
    "EDIT": "Edit",
    "SEARCH": "Search",
    "TODAY": "To day",
    "ENABLE": "ON",
    "DISABLE": "OFF",
    "END": "End",
    "INPROGRESS": "In progress",
    "COME": "To come up",
    "TITLE": "Title",
    "STARTAT": "Start at",
    "ENDAT": "End at"
  },
  "DISPLAYSCHEDULELIST": {
    "deleted_are": "Schedules with ids \"{{list}}\" have been deleted",
    "display_menuTitle": "Display",
    "display_schedule_list_menuTitle": "Schedule",
    "display_schedule_menuTitle": "List",
    "display_schedule_add_menuTitle": "List",
    "delete_schedule_aria_label": "Delete",
    "delete_list_schedule_msg": "Are you sure you want to delete the programs?",
    "dialog_alert_delete_description": " has been deleted successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_close": "Close",
    "no_program": "No program",
    "action_open": "Open Schedule",
    "dialog_alert_delete_title": "Successful operation",
    "added": "has been added successfully",
    "edited": "has been modified successfully"
  },
  "VALIDATIONS": {
    "Schedule.uniqueTitle": "This field must be unique"
  }
});

$translateProvider.translations("fr", {
  "DISPLAYSCHEDULECALENDAR": {
    "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9e avec succès.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !!!",
    "dialog_alert_delete_close": "FERMER",
    "CALENDAR": "Calendrier",
    "DELETE": "Supprimer",
    "MONTH": "Mois",
    "WEEK": "Semaine",
    "DAY": "Jour",
    "PREVIOUS": "Pr\u00e9c\u00e9dent",
    "NEXT": "Suivant",
    "SAVE": "Sauvegarder",
    "EDIT": "Modifier",
    "SEARCH": "Recherche",
    "TODAY": "Aujourd'hui",
    "ENABLE": "Activer",
    "DISABLE": "D\u00e9sactiver",
    "END": "Terminé",
    "INPROGRESS": "EN cours",
    "COME": "\u00c0 venir",
    "TITLE": "titre",
    "STARTAT": "D\u00e9but",
    "ENDAT": "Fin"
  },
  "DISPLAYSCHEDULELIST": {
    "deleted_are": "Les grilles des programmes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es",
    "delete_schedule_label": "Supprimer le programme",
    "delete_schedule_msg": "Voulez-vous vraiment supprimer le programme?",
    "display_menuTitle": "Display",
    "display_schedule_list_menuTitle": "Grille",
    "display_schedule_menuTitle": "Liste",
    "display_schedule_add_menuTitle": "Liste",
    "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9e avec succès.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_close": "FERMER",
    "no_program": "Aucun programme trouvé",
    "action_open": "Ouvrir Grille",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "added": "a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
    "edited": "a \u00e9t\u00e9 modifi\u00e9e avec succ\u00e8s"
  },
  "VALIDATIONS": {
    "Schedule.uniqueTitle": "Ce champ doit être unique"
  }
});

$translateProvider.translations("en", {
  "COMMENTSEDIT": {
    "form_edit_title": "Edit comments form :",
    "form_title": "Update comment",
    "form_attr_email": "Email",
    "form_attr_comment": "Comment",
    "\t": "Parent comments",
    "choose_img": "Select a file"
  },
  "COMMENTSDETAIL": {
    "id": "Id",
    "status": "Status",
    "comment": "Comment",
    "ip": "IP",
    "created_at": "Date",
    "media_comments_detail_title": "Comments details"
  },
  "COMMENTSLIST": {
    "image": "Picture",
    "name": "Name",
    "comment": "Comment",
    "date": "Date",
    "update_comments": "Update",
    "delete_comments": "Delete",
    "delete_comments_msg": "Do you want to delete the comments?",
    "delete_comments_aria_label": "Delete comments",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "added": "Comments added successfully.",
    "edited": "Comments edited successfully.",
    "dialog_alert_enable_title": "Successful operation",
    "dialog_alert_enable_description": " has been successfully enabled.",
    "dialog_alert_enable_close": "Close",
    "dialog_alert_enable_error_title": "Error",
    "dialog_alert_enable_error_description": "Operation not performed!",
    "enable_comments": "Enable",
    "disable_comments": "Disable",
    "dialog_alert_disable_title": "Successful operation",
    "dialog_alert_disable_description": " has been successfully disabled.",
    "dialog_alert_disable_close": "Close",
    "dialog_alert_disable_error_title": "Error",
    "dialog_alert_disable_error_description": "Operation not performed!",
    "status": "Status",
    "direct_comments": "Live comments",
    "media_comments": "Media comments",
    "export_excel": "Export excel "
  }
}
);

$translateProvider.translations("fr", {
  "COMMENTSEDIT": {
    "form_edit_title": "Formulaire de modification de commentaire : ",
    "form_title": "Modifier un commentaire",
    "form_attr_email": "Email",
    "form_attr_comment": "Commentaire",
    "choose_img": "S\u00e9lectionner un fichier"
  },
  "COMMENTSDETAIL": {
    "id": "Identifiant",
    "status": "Statut ",
    "comment": "Commentaire",
    "ip": "IP",
    "created_at": "Date",
    "media_comments_detail_title": "D\u00e9tails commentaire"
  },
  "COMMENTSLIST": {
    "image": "Image",
    "name": "Nom",
    "comment": "Commentaire",
    "date": "Date",
    "update_comments": "Modifier",
    "delete_comments": "Supprimer",
    "delete_comments_msg": "Voulez vous confirmer la suppression ?",
    "delete_comments_aria_label": "Supprimer le commentaire",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "added": "Commentaire ajout\u00e9 avec succ\u00e8s.",
    "edited": "Commentaire modifi\u00e9 avec succ\u00e8s.",
    "dialog_alert_enable_title": "Op\u00e9ration réussie",
    "dialog_alert_enable_description": " \u00e0 \u00e9t\u00e9 activer avec succ\u00e8s.",
    "dialog_alert_enable_close": "Fermer",
    "dialog_alert_enable_error_title": "Erreur",
    "dialog_alert_enable_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "enable_comments": "Activer",
    "disable_comments": "D\u00e9sactiver",
    "dialog_alert_disable_title": "Op\u00e9ration réussie",
    "dialog_alert_disable_description": " \u00e0 \u00e9t\u00e9 d\u00e9sactiv\u00e9 avec succ\u00e8s.",
    "dialog_alert_disable_close": "Fermer",
    "dialog_alert_disable_error_title": "Erreur",
    "dialog_alert_disable_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "status": "Statut",
    "direct_comments": "Commentaires direct",
    "media_comments": "Commentaires media",
    "export_excel": "Exporter excel"
  }
}
);

$translateProvider.translations("en", {
  "SONDAGELIST": {
    "detail_vote" : "Survey details",
    "detail_question" : "Question details",
    "name": "Survey",
    "delete_sondage": "Delete",
    "delete_sondage_msg": "Do you want to delete the survey?",
    "delete_sondage_aria_label": "Delete survey",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "undeleted_are": "Surveys with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Surveys with ids \"{{list}}\" have been deleted",
    "delete_sondages_aria_label": "Delete selected surveys",
    "delete_list_sondage_msg": "Do you want to delete the selected surveys ? ",
    "update_sondage": "Update",
    "detail_sondage": "Details",
    "added": "Sondage added successfully.",
    "edited": "Sondage edited successfully.",
    "download_sondage": "Download details",
    "action_new_element" : "Add new survey",
    "mdelete_success": "Successful operation"
  },
  "SONDAGEDETAIL": {
    "name": "Name",
    "question": "Question",
    "response": "Type of reply",
    "sondage_detail_title": "Survey details",
    "id": "ID : "
  },
  "SONDAGEADD": {
    "form_attr_name": "Name",
    "form_attr_question": "Add question",
    "form_attr_onp": "Yes-No-NSP",
    "form_attr_on": "Yes-No",
    "add": "Add question",
    "form_new_title": "Add survey form",
    "form_title": "Survey information"
  },
  "SONDAGEEDIT": {
    "form_edit_title": "Edit survey form",
    "form_title": "Survey edit"
  },
  "VOTELIST": {
    "question": "Question",
    "other": "Other",
    "identifier": "ID",
    "name": "Name",
    "last_name": "Last name",
    "vote": "Vote",
    "yes": "Yes",
    "no": "No"
  },
  "VALIDATIONS": {
    "survey_not_found": "Survey does not exist",
    "survey.name.not_blank": "Empty field",
    "survey_Question.question.not_blank": "Empty field",
    "survey_Question.nsp.not_null": "Empty field"
  }
}
);

$translateProvider.translations("fr", {
  "SONDAGELIST": {
    "detail_vote" : "D\u00e9tails du sondage",
    "detail_question" : "D\u00e9tails du question",
    "name": "Sondage",
    "delete_sondage": "Supprimer",
    "delete_sondage_msg": "Voulez-vous vraiment supprimer le sondage ?",
    "delete_sondage_aria_label": "Supprimer le sondage",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "undeleted_are": "Les sondages ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les sondages ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_sondages_aria_label": "Supprimer les sondages s\u00e9lectionn\u00e9s",
    "delete_list_sondage_msg": "Voulez-vous vraiment supprimer ces sondages ? ",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "update_sondage": "Modifier",
    "detail_sondage": "D\u00e9tails",
    "added": "Sondage ajout\u00e9 avec succ\u00e8s.",
    "edited": "Sondage modifi\u00e9 avec succ\u00e8s.",
    "download_sondage": "T\u00e9l\u00e9charger les d\u00e9tails",
    "action_new_element" : "Ajouter un nouveau sondage",
    "mdelete_success": "Op\u00e9ration termin\u00e9e avec succ\u00e9s"
  },
  "SONDAGEDETAIL": {
    "name": "Nom : ",
    "question": "Question",
    "response": "Type de r\u00e9ponse",
    "sondage_detail_title": "D\u00e9tails du sondage",
    "id": "Identifiant : "
  },
  "SONDAGEADD": {
    "form_attr_name": "Nom",
    "form_attr_question": "Ajouter une question",
    "form_attr_onp": "Oui-Non-NSP",
    "form_attr_on": "Oui-Non",
    "add": "Ajouter une question",
    "form_new_title": "Formulaire d'ajout d'un nouveau sondage",
    "form_title": "Information du sondage"
  },
  "SONDAGEEDIT": {
    "form_edit_title": "Formulaire de modification de sondage",
    "form_title": "Modification du sondage"
  },
  "VOTELIST": {
    "question": "Question",
    "other": "Autre",
    "identifier": "ID",
    "name": "Nom",
    "last_name": "Pr\u00e9nom",
    "vote": "Vote",
    "yes": "Oui",
    "no": "Non"
  },
  "VALIDATIONS": {
    "survey_not_found": "Survey n'existe pas",
    "survey.name.not_blank" : "Ce champ est obligatoire",
    "survey_Question.question.not_blank" : "Ce champ est obligatoire",
    "survey_Question.nsp.not_null" : "Ce champ est obligatoire"
  }
}
);

$translateProvider.translations("en", {
  "ADVERTISINGLIST": {
    "image": "Picture",
    "title": "Title",
    "update_advertising": "Update",
    "delete_advertising": "Delete",
    "delete_list_advertising_msg": "Do you want to delete these advertising?",
    "delete_advertising_msg": "Do you want to delete these advertisements?",
    "delete_advertising_aria_label": "Delete advertising",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "undeleted_are": "Advertising with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Advertising with ids \"{{list}}\" have been deleted",
    "added": "Advertising added successfully.",
    "edited": "Advertising edited successfully.",
    "date_start": "Date start",
    "date_end": "Date end",
    "active": "Active",
    "linkUrl": "Link URL",
    "action_new_element" : "Add new advertising"
  },
  "ADVERTISINGDETAIL": {
    "id": "ID : ",
    "title": "Title : ",
    "link_url": "Link URL",
    "date_start": "Date start : ",
    "date_end": "Date end : ",
    "active": "Active : ",
    "advertising_detail_title": "Advertising details"
  },
  "ADVERTISINGADD": {
    "form_new_title": "Add advertising form",
    "form_title": "Advertising information",
    "form_attr_title": "Title",
    "form_attr_endDate": "End date",
    "form_attr_startDate": "Release date",
    "form_attr_linkUrl": "Link URL",
    "form_attr_visibility": "Visibility",
    "choose_thumb": "Choose an thumbnail"
  },
  "ADVERTISINGEDIT": {
    "form_edit_title": "Edit advertising form :"
  },
  "VALIDATIONS": {
    "advertising.title.not_blank": "This field is required",
    "advertising.link_url.not_valid": "This field is required",
    "advertising.date_start.not_blank": "This field is required",
    "advertising.date_end.not_blank": "This field is required",
    "advertising_not_found":"This value is not a valid URL"
  }
}
);

$translateProvider.translations("fr", {
  "ADVERTISINGLIST": {
    "image": "Image",
    "title": "Titre",
    "linkUrl": "Lien URL",
    "update_advertising": "Modifier",
    "delete_advertising": "Supprimer",
    "delete_advertising_msg": "Voulez-vous vraiment supprimer la publicit\u00e9 ?",
    "delete_list_advertising_msg": "Voulez-vous vraiment supprimer ces publicit\u00e9s ?",
    "delete_advertising_aria_label": "Supprimer la publicit\u00e9",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are": "Les publicit\u00e9s ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les publicit\u00e9s ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "added": "Publicit\u00e9 ajout\u00e9e avec succ\u00e8s.",
    "edited": "Publicit\u00e9 modifi\u00e9e avec succ\u00e8s.",
    "date_start": "Date de d\u00e9but",
    "date_end": "Date de fin",
    "active": "Active",
    "action_new_element" : "Ajouter une nouvelle publicit\u00e9"
  },
  "ADVERTISINGDETAIL": {
    "id": "ID : ",
    "title": "Titre : ",
    "link_url": "Lien URL",
    "date_start": "Date d\u00e9but : ",
    "date_end": "Date fin : ",
    "active": "Active :",
    "advertising_detail_title": "D\u00e9tails publicit\u00e9"
  },
  "ADVERTISINGADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle publicit\u00e9",
    "form_title": "Information de la publicit\u00e9",
    "form_attr_title": "Titre",
    "form_attr_linkUrl": "Lien URL",
    "form_attr_endDate": "Date de fin",
    "form_attr_startDate": "Date d\u00e9but",
    "form_attr_visibility": "Visibilit\u00e9",
    "choose_thumb": "Choisir une vignette"
  },
  "ADVERTISINGEDIT": {
    "form_edit_title": "Formulaire de modification de la publicit\u00e9 : "
  },
  "VALIDATIONS": {
    "advertising.title.not_blank": "Titre de la publicit\u00e9 ne peut pas \u00eatre vide",
    "advertising.link_url.not_valid": "Champ vide !",
    "advertising.date_start.not_blank": "Champ vide !",
    "advertising.date_end.not_blank": "Champ vide !",
    "advertising_not_found":"La publicit\u00e9 desir\u00e9e est inexistante !"
  }
}
);

$translateProvider.translations("en", {
  "IMAGES": {

  }
});

$translateProvider.translations("fr", {
  "IMAGES": {

  }
});

$translateProvider.translations("en", {
  "PODCASTADD": {
    "form_new_title": "Add theme form",
    "form_title": "Theme information",
    "form_attr_title": "Title",
    "form_attr_canal": "Channel",
    "form_attr_description": "Description",
    "form_attr_parentId": "Parent theme",
    "form_attr_visibility": "Visibility",
    "form_attr_classifiedBy": "Order of videos",
    "choose_thumb": "Choose a thumbnail",
    "select_files": "Select files",
    "explicite": "The podcast contains explicit content?",
    "maximumSize": "The maximum size of the thumbnail is 1MB."  
  },
  "PODCASTEDIT": {
    "form_edit_title": "Edit podcast form :",
    "form_title": "Podcast edit"
  },
  "PODCASTDETAIL": {
    "id": "ID : ",
    "parentId": "Parent theme",
    "title": "Title : ",
    "alias": "Alias : ",
    "description": "Description : ",
    "channel": "Channel : ",
    "dir": "Directory : ",
    "category": "Category : ",
    "url": "Link : ",
    "seen_nbr": "Number of views : ",
    "visibility": "Visibility : ",
    "sortedBy": "Sorted by : ",
    "classifiedBy": "classified by",
    "theme_detail_title": "Theme details"
  },
  "PODCASTLIST": {
    "image": "Picture",
    "title": "Title",
    "parent": "Parent podcast",
    "canal": "Channels",
    "update_podcast": "Update",
    "delete_podcast_msg": "Do you want to delete the podcast?",
    "delete_list_podcast_msg": "Do you want to delete these podcasts?",
    "delete_podcast_aria_label": "Delete podcast",
    "delete_podcasts_aria_label": "Delete podcasts",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "undeleted_are": "Podcasts with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Podcasts with ids \"{{list}}\" have been deleted",
    "added": "Podcast added successfully",
    "edited": "Podcast edited successfully",
    "export_links_modal_title": "RSS Link for: ",
    "export_links_embed_link": "Embed link",
    "export_links_perma_link": "Permalink",
    "export_links_embed_code": "Embed code",
    "action_new_element": "Add new podcast",
    "copied": "link copied",
    "category": "Category ",
    "preview": "Preview"
  },
  "VALIDATIONS": {
    "theme_not_found": "Selected theme does not exist!",
    "cannot_delete_theme_related_videos": "Theme related to a video cannot be deleted!",
    "not_authorized_theme": "This theme is unauthorized!",
    "This_theme_is_not_visible": "This theme is not visible",
    "podcast_not_found": "Podcast does not exist !",
    "themes": {
      "channels.not_blank": "Empty field!",
      "title.not_blank": "Empty field!",
      "visible.not_null": "Null field!",
      "classifiedBy.not_blank": "Empty field"
    }
  }
}
);

$translateProvider.translations("fr", {
  "PODCASTADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau podcast",
    "form_title": "Information du podcast",
    "form_attr_title": "Titre",
    "form_attr_canal": "Canal",
    "form_attr_description": "Description",
    "form_attr_parentId": "Th\u00e8me parent",
    "form_attr_visibility": "Visibilit\u00e9",
    "form_attr_classifiedBy": "Ordre des vid\u00e9os",
    "choose_thumb": "Choisir une vignette",
    "select_files": "Sélectionnez des fichiers",
    "explicite":"Le podcast contient du contenu explicite?",
    "maximumSize": "La taille maximale de la vignette est de 1Mo."
  },
  "PODCASTEDIT": {
    "form_edit_title": "Formulaire de modification du podcast : ",
    "form_title": "Modification du podcast"
  },
  "PODCASTDETAIL": {
    "id": "Identifiant : ",
    "parentId": "Th\u00e8me parent : ",
    "title": "Titre : ",
    "alias": "Alias : ",
    "description": "Description : ",
    "channel": "Canal : ",
    "dir": "R\u00e9pertoire : ",
    "category": "Catégorie : ",
    "url": "Lien : ",
    "seen_nbr": "Nombre de vue : ",
    "visibility": "Visibilit\u00e9 : ",
    "sortedBy": "Tri\u00e9 par : ",
    "classifiedBy": "Class\u00e9 par : ",
    "theme_detail_title": "D\u00e9tails du th\u00e8me"
  },
  "PODCASTLIST": {
    "image": "Image",
    "title": "Titre",
    "parent": "Th\u00e8me parent",
    "canal": "Canaux",
    "update_podcast": "Modifier",
    "delete_podcast_msg": "Voulez-vous vraiment supprimer le podcast ?",
    "delete_list_podcast_msg": "Voulez-vous vraiment supprimer ces podcasts ?",
    "delete_podcast_aria_label": "Supprimer le podcast",
    "delete_podcasts_aria_label": "Supprimer ces podcasts",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "undeleted_are": "Les podcasts ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les podcasts ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "added": "Podcast ajout\u00e9 avec succ\u00e8s",
    "edited": "Podcast modifi\u00e9 avec succ\u00e8s",
    "export_links_modal_title": "Lien du fichier RSS de: ",
    "export_links_embed_link": "Lien d'int\u00e9gration",
    "export_links_perma_link": "Permalink",
    "export_links_embed_code": "Code d'int\u00e9gration",
    "action_new_element": "Ajouter un nouveau podcast",
    "copied": "lien copi\u00e9",
    "category": "Catégorie ",
    "preview": "Aperçu"
  },
  "VALIDATIONS": {
    "theme_not_found": "Le th\u00e8me desir\u00e9 est inexistant !",
    "cannot_delete_theme_related_videos": "Ce th\u00e8me reli\u00e9 \u00e0 une vid\u00e9o ne peut pas \u00eatre supprim\u00e9",
    "not_authorized_theme": "Ce th\u00e8me est non autoris\u00e9 !",
    "This_theme_is_not_visible": "Ce th\u00e8me est non visible !",
    "podcast_not_found": "Podcast est inexistant !",
    "themes": {
      "channels.not_blank": "Champ vide !",
      "title.not_blank": "Champ vide !",
      "visible.not_null": "Champ null !",
      "classifiedBy.not_blank": "Champ vide"
    }
  }
}
);

$translateProvider.translations("en", {
  "EVENTADD": {
    "form_new_title": "Add live event form",
    "form_attr_title": "Title",
    "form_attr_conference_key": "Conference key",
    "form_attr_direction": "Direction",
    "form_attr_category": "Category",
    "form_attr_description": "Description",
    "end_time": "End time",
    "form_attr_rich_media_presentation": "Rich-media presentation",
    "form_attr_online_video": "Video online after live",
    "form_attr_downloadable_video": "Downloadable video",
    "choose_thumb": "Choose thumbnail",
    "form_attr_url_title": "URL title",
    "form_attr_url": "URL (https:\/\/)",
    "form_attr_author": "Author",
    "form_attr_copyright": "\u00a9 copyright",
    "form_attr_key_words": "Keywords",
    "form_attr_organizer_name": "Name organizer",
    "form_attr_organizer_email": "Email organizer",
    "form_attr_sms_count": "SMS Number",
    "form_attr_access_type": "Access type",
    "form_attr_comment": "Comment",
    "form_attr_speaker": "Speaker",
    "form_attr_station": "Station",
    "ivalid_URL_format": "Invalid URL",
    "invalid_email_format": "Invalid email",
    "invalid_number": "It is not a number",
    "form_attr_isVisibleOnIntranet": "Intranet broadcast",
    "form_attr_isVisibleOnInternet": "Internet broadcast",
    "form_attr_secureIntranet": "Secure Intranet Broadcast",
    "form_attr_secureInternet": "Secure Internet Broadcast"
  },
  "EVENTEDIT": {
    "form_edit_title": "Edit live event form "
  },
  "EVENTLIST": {
    "added": "Live event added successfully.",
    "edited": "Live event edited successfully.",
    "overview": "Overview",
    "languages": "Languages",
    "action_add_language": "Add a language",
    "date": "Date",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element": "Add new live event",
    "rich_media_presentation": "M",
    "delete_selected_events_msg": "Do you want to delete the selected events lives?",
    "delete_selected_event_msg": "Do you want to delete the selected event live?",
    "delete_selected_events_aria_label": "Delete selected events lives",
    "delete_selected_event_aria_label": "Delete selected event live",
    "undeleted_are": "Events lives with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Events lives withs ids \"{{list}}\" have been deleted",
    "delete_event_msg": "Do you want to delete the event live?",
    "delete_event_aria_label": "Delete event live",
    "show_calendar": "Calendar",
    "show_ongoing": "Event on going",
    "show_upcoming": "Event up coming",
    "export_links_embed_link": "Embed link",
    "export_links_perma_link": "Permalink",
    "export_auto": "Export auto",
    "export_live": "Export live",
    "export_video": "Export video",
    "export_auto_title": "Export code auto mode ",
    "export_Live_title": "Export code live ",
    "export_video_title": "Export code video ",
    "export_links_modal_title": "Export links for : ",
    "delete_language_msg": "Do you want to delete the language?",
    "delete_lang_event_aria_label": "Delete language",
    "delete_speaker": "Speaker",
    "copied": "link copied",
    "export_type": "Export type"
  },
  "EVENTDETAIL": {
    "event_detail_title": "Live event detail",
    "id": "Id : ",
    "title": "Title : ",
    "language": "Languages",
    "conference_key": "Conference key",
    "direction": "Directorate",
    "category": "Category",
    "description": "Description",
    "date": "Date",
    "rich_media_presentation": "Rich-media presentation",
    "online_video": "Video online after live",
    "downloadable_video": "Downloadable video",
    "thumbnail": "Thumbnail",
    "url_title": "URL title",
    "url": "URL (https:\/\/)",
    "author": "Author",
    "copyright": "Copyright",
    "key_words": "Keywords",
    "organizer_name": "Name organizer",
    "organizer_email": "Email organizer",
    "sms_countaccess_type": "SMS number",
    "access_type": "Access type",
    "comment": "Comment"
  },
  "VALIDATIONS": {
    "can_not_add_two_events_in_the_same_station_in_the_same_period": "Cannot add two events at the same station or period",
    "eventOrganizer.conference_key.unique": "Conference key must be unique"
  }
}
);

$translateProvider.translations("fr", {
  "EVENTADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau \u00e9v\u00e9nement direct",
    "form_attr_title": "Titre",
    "form_attr_conference_key": "Cl\u00e9 de conf\u00e9rence",
    "form_attr_direction": "Direction",
    "form_attr_category": "Cat\u00e9gorie",
    "form_attr_description": "Description",
    "end_time": "Heure de fin",
    "form_attr_rich_media_presentation": "Pr\u00e9sentation Rich-m\u00e9dia",
    "form_attr_online_video": "Vid\u00e9o en ligne apr\u00e8s le direct",
    "form_attr_downloadable_video": "Vid\u00e9o t\u00e9l\u00e9chargeable",
    "choose_thumb": "Choisir une vignette",
    "form_attr_url_title": "Titre d'URL",
    "form_attr_url": "URL (https:\/\/)",
    "form_attr_author": "Auteur",
    "form_attr_copyright": "\u00a9 copyright",
    "form_attr_key_words": "Mots cl\u00e9s",
    "form_attr_organizer_name": "Nom de l'organisateur",
    "form_attr_organizer_email": "Email de l'organisateur",
    "form_attr_sms_count": "Nombre de SMS",
    "form_attr_access_type": "Type d'acc\u00e8s",
    "form_attr_comment": "Commentaire",
    "form_attr_speaker": "Orateur",
    "form_attr_station": "Station",
    "ivalid_URL_format": "URL invalide",
    "invalid_email_format": "Email invalide",
    "invalid_number": "Ce n'est pas un nombre",
    "form_attr_isVisibleOnIntranet": "Diffusion Intranet",
    "form_attr_isVisibleOnInternet": "Diffusion Internet",
    "form_attr_secureIntranet": "Diffusion Intranet s\u00e9curis\u00e9",
    "form_attr_secureInternet": "Diffusion Internet s\u00e9curis\u00e9"
  },
  "EVENTEDIT": {
    "form_edit_title": "Formulaire de modification de l'\u00e9v\u00e9nnement direct "
  },
  "EVENTLIST": {
    "added": "Ev\u00e9nnement direct ajout\u00e9 avec succ\u00e8s.",
    "edited": "Ev\u00e9nement direct modifi\u00e9 avec succ\u00e8s.",
    "overview": "Aper\u00e7u",
    "languages": "Langues",
    "action_add_language": "Ajouter une langue",
    "date": "Date",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "action_new_element": "Ajouter un nouveau \u00e9v\u00e9nnement direct",
    "rich_media_presentation": "M",
    "delete_selected_events_msg": "Voulez-vous supprimer cette s\u00e9lection d'\u00e9v\u00e9nnements directs ?",
    "delete_selected_event_msg": "Voulez-vous supprimer cette s\u00e9lection d'\u00e9v\u00e9nnement direct ?",
    "delete_selected_events_aria_label": "Suppression des \u00e9v\u00e9nnements directs s\u00e9lectionn\u00e9es",
    "delete_selected_event_aria_label": "Suppression d' \u00e9v\u00e9nnement direct s\u00e9lectionn\u00e9e",
    "undeleted_are": "Les \u00e9v\u00e9nnements directs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les \u00e9v\u00e9nnements directs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_event_msg": "Voulez-vous supprimer l'\u00e9v\u00e9nnement direct ?",
    "delete_event_aria_label": "Suppression d'\u00e9v\u00e9nnement direct",
    "show_calendar": "Calendrier",
    "show_ongoing": "\u00c9v\u00e9nement en cours",
    "show_upcoming": "\u00c9v\u00e9nement \u00e0 venir",
    "export_links_embed_link": "Lien d'int\u00e9gration",
    "export_links_perma_link": "Permalien",
    "export_auto": "Exporter Auto",
    "export_live": "Exporter direct",
    "export_video": "Exporter vid\u00e9o",
    "export_auto_title": "Exporter code du mode automatique  ",
    "export_Live_title": "Exporter code direct",
    "export_video_title": "Exporter code vid\u00e9o",
    "export_links_modal_title": "Liens d'export pour : ",
    "delete_language_msg": "Voulez-vous supprimer la langue?",
    "delete_lang_event_aria_label": "Suppression de langue",
    "delete_speaker": "Orateur",
    "copied": "lien copi\u00e9",
    "export_type": "Type d'export"
  },
  "EVENTDETAIL": {
    "event_detail_title": "D\u00e9tail de l'\u00e9v\u00e9nnement direct",
    "id": "Identifiant : ",
    "title": "Titre : ",
    "language": "Langues",
    "conference_key": "Cl\u00e9 de conf\u00e9rence",
    "direction": "Direction",
    "category": "Cat\u00e9gorie",
    "description": "Description",
    "date": "Date",
    "rich_media_presentation": "Pr\u00e9sentation Rich-media",
    "online_video": "Vid\u00e9o en ligne apr\u00e8s le direct",
    "downloadable_video": "Vid\u00e9o t\u00e9l\u00e9chargeable",
    "thumbnail": "Vignette",
    "url_title": "Titre d'URL",
    "url": "URL (https:\/\/)",
    "author": "Auteur",
    "copyright": "Copyright",
    "key_words": "Mots cl\u00e9s",
    "organizer_name": "Nom de l'organisateur",
    "organizer_email": "Email de l'organisateur",
    "sms_countaccess_type": "Nombre de SMS",
    "access_type": "Type d'acc\u00e8s",
    "comment": "Commentaire"
  },
  "VALIDATIONS": {
    "can_not_add_two_events_in_the_same_station_in_the_same_period": "Deux évènements ne peuvent pas \u00eatre dans la m\u00eame station ou la m\u00eame p\u00e9riode",
    "eventOrganizer.conference_key.unique": "La cl\u00e9 de conf\u00e9rence doit \u00eatre unique"
  }
}
);

$translateProvider.translations("en", {
  "PLAYLISTADD": {
    "form_new_title": "Add playlist form",
    "form_title": "Playlist information",
    "form_attr_title": "Title",
    "form_attr_live": "Playlist live",
    "add_to_playlist": "Add To Playlist",
    "delete_from__playlist": "Delete From Playlist",
    "on_air_confirmation": "To make this playlist online, please click on this button",
    "on_air_confirmation_title": "Playlist online update"
  },
  "PLAYLISTEDIT": {
    "form_edit_title": "Edit playlist form :",
    "form_title": "Playlist information"
  },
  "PLAYLISTDETAIL": {
    "playlist_detail_title": "Playlist detail",
    "id": "Id : ",
    "title": "Title : ",
    "channel": "Channel : ",
    "loop": "Repeat  : ",
    "order": "Respect parametrized order : ",
    "duration": "Broadcast duration (seconds) : ",
    "url": "Url",
    "url_permalien": "Url Permalien",
    "url_embed": "Url Embed"
  },
  "PLAYLISTLIST": {
    "added": "Playlist added successfully.",
    "edited": "Playlist edited successfully.",
    "delete_playlist_msg": "Do you want to delete this playlist?",
    "delete_playlist_aria_label": "Delete playlist",
    "loop": "Play in loop",
    "duration": "Broadcast duration (s)",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "action_new_element": "Add new playlist",
    "delete_list_playlist_msg": "Do you want to delete these playlists?",
    "delete_playlists_aria_label": "Delete playlists",
    "undeleted_are": "Playlists with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Playlists with ids \"{{list}}\" have been deleted",
    "video_playlist_not_found": "Playlist is empty, please add videos"
  }
}
);

$translateProvider.translations("fr", {
  "PLAYLISTADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle playlist",
    "form_title": "Information de la playlist",
    "form_attr_title": "Titre",
    "form_attr_live": "Playlist direct",
    "add_to_playlist": "Ajouter à la Playlist",
    "delete_from__playlist": " Supprimer de la playlist",
    "on_air_confirmation": "Afin de mettre en ligne cette playlist , Veuillez cliquer sur le button",
    "on_air_confirmation_title": "Mettre la playlist en ligne"
  },
  "PLAYLISTEDIT": {
    "form_edit_title": "Formulaire de modification de playlist :",
    "form_title": "Information du playlist"
  },
  "PLAYLISTDETAIL": {
    "playlist_detail_title": "D\u00e9tail du playlist",
    "id": "Identifiant : ",
    "title": "Titre : ",
    "channel": "Canal : ",
    "loop": "Lire en boucle : ",
    "order": "Respecter l'ordre param\u00e9tr\u00e9 : ",
    "duration": "Dur\u00e9e de diffusion (secondes) : ",
    "url": "Url",
    "url_permalien": "Url Permalien",
    "url_embed": "Url Embed"
  },
  "PLAYLISTLIST": {
    "added": "Playlist ajout\u00e9e avec succ\u00e8s.",
    "edited": "Playlist modifi\u00e9e avec succ\u00e8s.",
    "delete_playlist_msg": "Voulez-vous vraiment supprimer cette playlist?",
    "delete_playlist_aria_label": "Supprimer la playlist",
    "loop": "Lire en boucle",
    "duration": "Dur\u00e9e de diffusion (s)",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "action_new_element": "Ajouter une nouvelle playlist",
    "delete_list_playlist_msg": "Voulez-vous vraiment supprimer ces playlists?",
    "delete_playlists_aria_label": "Supprimer les playlists",
    "undeleted_are": "Les playlists ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les playlists ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "video_playlist_not_found": "Playlist est vide, veuillez ajouter des vidéos"
  }
}
);

$translateProvider.translations("en", {
  "GROUPADD": {
    "form_attr_name": "Group name",
    "form_attr_none": "All",
    "form_attr_parent": "Parent",
    "form_new_title": "Add group form",
    "form_title": "Group information",
    "form_attr_roles": "Roles",
    "form_attr_description": "Description",
    "Administrator": "Administrator",
    "User": "User",
    "Moderator": "Moderator",
    "ROLE_ADMIN": "Administrator",
    "ROLE_USER": "User",
    "ROLE_SUPER_ADMIN": "Super administrator",
    "Super_Administrator": "Super administrator"
  },
  "GROUPEDIT": {
    "form_edit_title": "Edit group form :",
    "form_title": "Group edit"
  },
  "GROUPDETAIL": {
    "name": "Name",
    "startDate": "Release date",
    "endDate": "Expiration date",
    "parent": "Parent",
    "group_detail_title": "Group detail",
    "id": "ID",
    "roles": "Roles",
    "description": "Description"
  },
  "GROUPLIST": {
    "name": "Name",
    "delete_group": "Delete",
    "delete_group_msg": "Do you want to delete the group?",
    "delete_group_aria_label": "Delete group?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "added": "Group added successfully.",
    "edited": "Group edited successfully.",
    "roles": "Roles",
    "description": "Description",
    "permission_group": "Manage permissions",
    "delete_groups": "Delete selected groups",
    "delete_group_aria_label": "Delete selected group",
    "delete_groups_aria_label": "Delete selected groups",
    "delete_list_group_msg": "Do you want to delete the selected groups ? ",
    "delete_group_msg": "Do you want to delete the selected group ? ",
    "undeleted_are": "Groups with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Groups with ids \"{{list}}\" have been deleted",
    "mdelete_success": "Successful operation",
    "action_new_element" : "Add new group"
  },
  "VALIDATIONS": {
    "not_authorized_general": "Not authorized!",
    "cannot_access_ressource": "Cannot access to the ressource!",
    "cannot_delete": "Cannot be deleted!",
    "cannot_modify": "Cannot be modified!",
    "group1_not_found": "Group not found!",
    "group2_not_found": "Group not found!",
    "group_not_found": "This group is not found!",
    "permission_success": "Permissions are changed successfully",
    "permission_edit": "Modification of permissions",
    "group": {
      "name.not_blank": "Empty field!",
      "roles.not_blank": "Empty field!",
      "description.not_blank": "Empty field!"
    }
  }
}
);

$translateProvider.translations("fr", {
  "GROUPADD": {
    "form_attr_name": "Nom du groupe",
    "form_attr_none": "Tous",
    "form_attr_parent": "Parent",
    "form_new_title": "Formulaire d'ajout d'un groupe",
    "form_title": "Information du groupe",
    "form_attr_roles": "R\u00f4les",
    "form_attr_description": "Description",
    "Administrator": "Administrateur",
    "User": "Utilisateur",
    "Moderator": "Mod\u00e9rateur",
    "ROLE_ADMIN": "Administrateur",
    "ROLE_USER": "Utilisateur",
    "ROLE_SUPER_ADMIN": "Super administrateur",
    "Super_Administrator": "Super administrateur"
  },
  "GROUPEDIT": {
    "form_edit_title": "Formulaire de modification du groupe : ",
    "form_title": "Modification du groupe"
  },
  "GROUPDETAIL": {
    "name": "Nom du groupe",
    "startDate": "Date de d\u00e9but",
    "endDate": "Date de fin",
    "parent": "Parent",
    "group_detail_title": "D\u00e9tail de groupe",
    "id": "ID",
    "roles": "R\u00f4les",
    "description": "Description"
  },
  "GROUPLIST": {
    "name": "Nom du groupe",
    "delete_group": "Supprimer",
    "delete_group_msg": "Voulez-vous vraiment supprimer ce groupe ?",
    "delete_group_aria_label": "Voulez-vous supprimer le groupe ?",
    "dialog_alert_delete_title": "Op\u00e9ration r\u00e9ussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "added": "Groupe ajout\u00e9 avec succ\u00e8s.",
    "edited": "Groupe modifi\u00e9 avec succ\u00e8s.",
    "roles": "R\u00f4les",
    "description": "Description",
    "permission_group": "G\u00e9rer les permissions",
    "delete_groups": "Supprimer les groupes s\u00e9lectionn\u00e9s",
    "delete_group_aria_label": "Supprimer le groupe s\u00e9lectionn\u00e9",
    "delete_groups_aria_label": "Supprimer les groupes s\u00e9lectionn\u00e9s",
    "delete_group_msg": "Voulez-vous vraiment supprimer ce groupe ?",
    "delete_list_group_msg": "Voulez-vous vraiment supprimer ces groupes ?",
    "undeleted_are": "Les groupes ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les groupes ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "mdelete_success": "Op\u00e9ration termin\u00e9e avec succ\u00e9s",
    "action_new_element" : "Ajouter un nouveau groupe"
  },
  "VALIDATIONS": {
    "not_authorized_general": "Non autoris\u00e9 !",
    "cannot_access_ressource": "Vous ne pouvez pas accéder \u00e0 la ressource !",
    "cannot_delete": "Suppression impossible !",
    "cannot_modify": "Modification impossible !",
    "group1_not_found": "Groupe introuvable !",
    "group2_not_found": "Groupe introuvable !",
    "group_not_found": "Groupe introuvable !",
    "permission_success": "Les permissions sont modifiées avec succès",
    "permission_edit": "Modification des permissions",
    "group": {
      "name.not_blank": "Champ vide !",
      "roles.not_blank": "Champ vide !",
      "description.not_blank": "Champ vide !"
    }
  }
}
);

$translateProvider.translations("en", {
    "IPLIST": {
        "adress": "IP Adress",
        "description": "Description",
        "delete_ip": "Delete",
        "delete_ip_msg": "Are you sure you want to delete this IP address ?",
        "delete_ip_aria_label": "Delete IP address",
        "dialog_alert_delete_title": "Successful operation",
        "dialog_alert_delete_description": " has been successfully deleted.",
        "dialog_alert_delete_close": "Close",
        "dialog_alert_delete_error_title": "Error",
        "dialog_alert_delete_error_description": "Operation not performed!",
        "update_ip": "Edit",
        "detail_ip": "Details",
        "added": "IP address added successfully.",
        "edited": "IP address edited successfully.",
        "action_new_element" : "Add a new IP address",
        "delete_element_ip_msg": "Do you want to delete this IP?",
        "delete_list_ips_msg": "Do you want to delete these IP?",
        "delete_ips_aria_label": "Delete IPs",
        "undeleted_are": "IPs with ids \"{{list}}\" could not be deleted",
        "deleted_are": "IPs with ids \"{{list}}\" have been deleted"
    },
    "IPDETAIL": {
        "adress": "IP address",
        "description": "Description",
        "ip_detail_title": "IP address details",
        "id": "ID : ",
        "update_ip": "Edit"
    },
    "IPADD": {
        "form_attr_ip": "IP address",
        "form_attr_description": "Description",
        "form_new_title": "Add a new IP address form",
        "form_title": "IP address information",
        "ERRORS": {
            "INVALIDFORMAT": "This field must contain a valid IP address.",
            "REQUIRED": "This field is required"
        }
    },
    "IPEDIT": {
        "form_edit_title": "Change IP address",
        "form_title": "Edit IP address"
    },
    "VALIDATIONS": {
        "ips_not_found" : "IPs does not exist",
        "ips.description.not_blank" : "This field is required",
        "ips.ip.not_blank" : "This field is required",
        "ips.ip.not_valid" : "IPs is not valid"

    }
}
);

$translateProvider.translations("fr", {
    "IPLIST": {
        "adress": "Adresse IP",
        "description": "Description",
        "delete_ip": "Supprimer",
        "delete_ip_msg": "Voulez-vous vraiment supprimer cette adresse IP ?",
        "delete_ip_aria_label": "Supprimer l'adresse IP",
        "dialog_alert_delete_title": "Op\u00e9ration réussie",
        "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s..",
        "dialog_alert_delete_close": "Fermer",
        "dialog_alert_delete_error_title": "Erreur",
        "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
        "update_ip": "Modifier",
        "detail_ip": "D\u00e9tails",
        "added": "Adresse IP ajout\u00e9e avec succ\u00e8s.",
        "edited": "Adresse IP modifi\u00e9e avec succ\u00e8s.",
        "action_new_element" : "Ajouter une nouvelle adresse IP",
        "delete_ips_aria_label": "Supprimer les IPs",
        "delete_element_ip_msg": "Voulez-vous vraiment supprimer ce IP?",
        "delete_list_ips_msg": "Voulez-vous vraiment supprimer ces IPs?",
        "undeleted_are": "Les IPs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
        "deleted_are": "Les IPs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s"
    },
    "IPDETAIL": {
        "adress": "Adresse IP",
        "description": "Description",
        "ip_detail_title": "D\u00e9tail de l'IP",
        "id": "Identifiant : ",
        "update_ip": "Modifier"
    },
    "IPADD": {
        "form_attr_ip": "Adresse IP",
        "form_attr_description": "Description",
        "form_new_title": "Formulaire d'ajout d'une nouvelle adresse IP",
        "form_title": "Information de l'adresse ip",
        "ERRORS": {
            "INVALIDFORMAT": "Ce champ doit contenir une adresse IP correcte.",
            "REQUIRED": "Ce champ est obligatoire"
        }
    },
    "IPEDIT": {
        "form_edit_title": "Formulaire de modification de l'adresse IP",
        "form_title": "Modifier l'adresse IP"
    },
    "VALIDATIONS": {
        "ips_not_found" : "IP n'existe pas",
        "ips.description.not_blank" : "Ce champ est obligatoire",
        "ips.ip.not_blank" : "Ce champ est obligatoire",
        "ips.ip.not_valid" : "IP n'est pas valide"

    }
}
);

$translateProvider.translations("en", {
  "SCORM": {

  }
});

$translateProvider.translations("fr", {
  "SCORM": {

  }
});

$translateProvider.translations("en", {
  "VIDEOADD": {
    "form_new_title": "Add video form",
    "form_attr_title": "Title",
    "form_attr_generate_multiple_formats": "Generate multiple formats",
    "end_date": "End date",
    "form_attr_description": "Description",
    "form_attr_transcription": "Transcription",
    "form_attr_author": "Author",
    "form_attr_copyright": "Copyright",
    "form_attr_key_words": "Keywords",
    "form_attr_unlock_password": "Add a password",
    "choose_thumb": "Browse",
    "choose_File_transcription" : "CHOOSE A FILE",
    "upload_local": "Upload file",
    "on_hold_list": "On hold videos",
    "on_hold_sftp_list": "SFTP server videos",
    "on_hold_empty": "No video on hold",
    "show_more": "Show more...",
    "reduce": "Reduce",
    "video_link": "Video link",
    "add_video_link": "Insert the link of a video (Youtube, DailyMotion)",
    "msg_download_extension": "Please install the Chrome extension",
    "download_extension": "Download extension",
    "msg_use_extension": "Please use the Chrome extension",
    "not_chrome": "You have to use Google chrome to have this functionality ",
    "presentation": "Presentation",
    "form_attr_keyword_label": "Tags",
    "form_attr_keyword": "Enter a tag",
    "files": "Files",
    "upload_files": "Upload files",
    "terms_conditions": "Privacy Policy and Terms of Use",
    "accept": "I Accept",
    "cancel": "Cancel",
    "associate_channel": "Associate channel",
    "set_thumb": "Set as thumbnail",
    "upload_thumb_galery": "Choose the thumbnail from gallery",
    "confidentiality": "Confidentiality",
    "screenshot": "Capture from the video",
    "theme": "Theme"
  },
  "VIDEOCAPTION": {
    "video_caption_title": "Video captioning",
    "download": "Download"
  },
  "VIDEOEXPORT": {
    "interactivity_with_timeline": "Interactivity with timeLine",
    "interactivity_without_timeline": "Interactivity without timeLine"
  },
  "VIDEORICHMEDIA": {
    "video_rich_media_title": "Rich-media for the video",
    "video_rich_media_slide_video": "Upload a video",
    "video_rich_media_slide_image": "Upload an image",
    "video_rich_media_slide_thumb": "Generate a thumbnail",
    "video_rich_media_slide_add": "Add a slide",
    "video_rich_media_chapter_add": "Add a chapter",
    "video_rich_media_chapter_slide_add": "Add a slide and a chapter",
    "video_rich_media_slide": "Slide",
    "video_rich_media_chapter": "Chapter",
    "video_rich_media_submited": "Rich-media added successfully",
    "video_rich_media_chapter_exist": "There is a chapter for that moment!",
    "video_rich_media_slide_exist": "There is a slide for that moment!",
    "preview_file": "Preview",
    "content_chapter": "Text",
    "video_rich_media_chapter_import": "Import chapters",
    "video_rich_media_chapter_file_sample": "Sample",
    "alert_not_valid_slide_video_message": "The file you've tried to upload is not a video. Please select a video with this extension : *.mp4",
    "alert_not_valid_slide_image_message": "The file you've tried to upload is not an image.Please select an image with one of the following extensions: *.JPG *.JPEG *.PNG *.GIF",
    "delete_chapter_title": "Do you want to replace this index?",
    "delete_chapter_text_partie_1": "The index in the instant ",
    "delete_chapter_text_partie_2": " will be deleted.",
    "delete_slide_title": "Do you want to replace this slide?",
    "delete_slide_text_partie_1": "The slide in this instant ",
    "delete_slide_text_partie_2": " will be deleted.",
    "delete_slide_aria_label": "Delete slide",
    "delete_chapter_aria_label": "Delete index"
  },
  "VIDEOLIST": {
    "delete_video_msg": "Do you want to delete the video?",
    "delete_audio_msg": "Do you want to delete video's description?",
    "delete_selected_videos_msg": "Do you want to delete the selected videos?",
    "delete_selected_video_msg": "Do you want to delete the selected video?",
    "delete_video_aria_label": "Delete video",
    "delete_audio_aria_label": "Delete audio description",
    "delete_selected_videos_aria_label": "Delete selected videos",
    "delete_selected_video_aria_label": "Delete selected video",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_all_description": "Selected elements have been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_download_error_title": "Download video",
    "dialog_download_error_text": "Video source does not exist",
    "undeleted_are": "Videos with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Videos withs ids \"{{list}}\" have been deleted",
    "video_not_found": "Can't find this video in the server",
    "dialog_will_be_deleted": "Audio description of this video will be deleted",
    "dialog_will_be_deleted_video": " will be deleted.",
    "add_description": "Add audio description",
    "edit_description": "Edit audio description",
    "delete_description": "Delete audio description",
    "dialog_alert_delete_audio_description": "Audio description deleted successfully",
    "insert_mail": "Insert emails",
    "insert_mail_abonne": "Send to customers",
    "envoyer_mail": "Please insert the emails in the following field",
    "envoyer_mail_video": "Insert email addresses in this field to send tests ( Type \"enter\" after each email inserted )",
    "group_abonne": "Choose a group of subscribers to send to these subscribers, or choose All to send to all subscribers",
    "add_subscribers": "Manage subscribers",
    "list_subscribers": "Subscribers list",
    "list_subscribers_added": "This video subscribers",
    "dialog_alert_send_video_description": "Video sent successfully",
    "copied": "link copied",
    "preview_simple_list": "Average view list",
    "preview_simple_list_big": "Big view list",
    "preview_gallery_list": "Thumbnails",
    "preview_small_list": "Small view list",
    "preview_list_buttons": "List with buttons",
    "preview_list_folders": "Folders",
    "display": "Display",
    "diffusion": "Diffusion",
    "period": "Period",
    "week": "Week",
    "month": "Month",
    "year": "Year",
    "trimester": "Quarter",
    "semester": "Semester",
    "none": "None",
    "form_attr_question": "Add question",
    "form_attr_onp": "Yes-No-NSP",
    "form_attr_on": "Yes-No",
    "video_reset": "Reset",
    "add": "Add question",
    "rm": "Videos type",
    "all": "All videos",
    "isrm": "Richmedia videos",
    "not_rm": "Not richmedia videos"
  },
  "VIDEOUPLOAD": {
    "video_upload_title": "Upload a video",
    "video_reupload_title": "Upload a new video",
    "remove_all": "Remove all",
    "cancel_all": "Cancel all",
    "upload_all": "Upload all",
    "inprogress": "1 Video in progress",
    "ended": "1 Video ended",
    "cancel_confirm": "You are sure to cancel the upload of the video?",
    "close_confirm": "Do you want to close this window?",
    "no": "No",
    "yes": "Yes",
    "still_upload": "There are videos being uploaded",
    "video": "Video",
    "videos": "Videos in progress",
    "cancel_reupload": "You are sure to close this window and loose the video",
    "add_video_automatic": "{{fileName}} has been added automatically",
    "add_video_automatic_multiple": ", you can choose another file to add it",
    "complete_upload_video": "Files successfully imported",
    "complete_multi_upload": ", please choose a file to add it"
  },
  "AUDIOUPLOAD": {
    "audio_upload_title": "Upload an audio file"
  },
  "VIDEOMONTAGE": {
    "startMedia": "Start of media:",
    "endMedia": "End of media:",
    "new_video": "Add new video"
  },
  "VIDEOCHRONOLOGY": {
    "upload": "Video upload",
    "transcodage": "Transcoding video",
    "transfert_buffer": "Video on the buffer server",
    "transfert_serveur_client": "Video on MGEN storage server",
    "transfert_rmbox": "Video on the boxes",
    "in_progress": "Not treated"
  },
  "VALIDATIONS": {
    "DateTime.invalid": "Invalid date!",
    "user.keyWords.not_blank": "Key words cannot be empty!",
    "quota_exceeds": "There is not enough disk space on your channel to add this video !",
    "video": {
      "fileTitle.not_blank": "File title cannot be empty!",
      "title.not_blank": "Title cannot be empty!",
      "stratDate.not_blank": "Start date cannot be empty!",
      "endDate.not_blank": "End date cannot be empty!",
      "duration.not_blank": "Duration cannot be empty!",
      "duration.invalid": "Invalid duration!",
      "startDate.invalid": "Invalid start date!",
      "endDate.invalid": "Invalid end date!"
    }
  },
  "QuestionsQuizLIST": {
    "question": "Question",
    "quiz": "Quiz",
    "other": "Other",
    "vote": "Vote",
    "yes": "Yes",
    "no": "No",
    "percentVotes": "Percentage of votes",
    "listChoices": "Choices",
    "nbVotes": "Number of votes"
  }
}
);

$translateProvider.translations("fr", {
  "VIDEOADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle vid\u00e9o",
    "form_attr_title": "Titre",
    "form_attr_generate_multiple_formats": "G\u00e9n\u00e9rer multiple formats",
    "end_date": "Date de fin",
    "form_attr_description": "Description",
    "form_attr_transcription": "Transcription",
    "form_attr_author": "Auteur",
    "form_attr_copyright": "Copyright",
    "form_attr_key_words": "Mots cl\u00e9s",
    "form_attr_unlock_password": "Ajouter un mot de passe",
    "choose_thumb": "Parcourir",
    "choose_File_transcription" : "CHOISIR UN FICHIER",
    "upload_local": "Importer un fichier",
    "on_hold_list": "Vid\u00e9os en attente",
    "on_hold_sftp_list": "Vid\u00e9os du serveur SFTP",
    "on_hold_empty": "Aucune vid\u00e9o en attente",
    "show_more": "Voir plus...",
    "reduce": "R\u00e9duire",
    "video_link": "Lien vid\u00e9o",
    "add_video_link": "Ins\u00e9rez le lien d’une vid\u00e9o (Youtube, DailyMotion)",
    "msg_download_extension": "Veuillez installer l'extension de Google chrome",
    "download_extension": "T\u00e9l\u00e9charger l'extension",
    "msg_use_extension": "Veuillez utiliser l'extension de Google chrome",
    "not_chrome": "Merci d'utiliser Google chrome pour utiliser cette fonctionnalit\u00e9 ",
    "presentation": "Pr\u00e9sentation",
    "form_attr_keyword_label": "Tags",
    "form_attr_keyword": "Ajouter un tag...",
    "files": "Fichiers",
    "upload_files": "Glisser et déposer des fichiers ici",
    "terms_conditions": "Règles de confidentialité et conditions d'utilisation",
    "accept": "J'accepte",
    "cancel": "Annuler",
    "associate_channel": "Associer un canal",
    "set_thumb": "Définir comme vignette",
    "upload_thumb_galery": "Sélectionner à partir de la galerie",
    "confidentiality": "Confidentialité",
    "screenshot": "Capturer à partir de la vidéo",
    "theme": "Thème"
  },
  "VIDEOCAPTION": {
    "video_caption_title": "Sous-titrage de la vid\u00e9o",
    "download": "Télécharger"
  },
  "VIDEOEXPORT": {
    "interactivity_with_timeline": "Interactivité avec TimeLine",
    "interactivity_without_timeline": "Interactivité sans TimeLine"
  },
  "VIDEORICHMEDIA": {
    "video_rich_media_title": "Rich-m\u00e9dia pour la vid\u00e9o",
    "video_rich_media_slide_video": "T\u00e9l\u00e9charger une vid\u00e9o",
    "video_rich_media_slide_image": "T\u00e9l\u00e9charger une image",
    "video_rich_media_slide_thumb": "G\u00e9n\u00e9rer une vignette",
    "video_rich_media_slide_add": "Ajouter une diapositive",
    "video_rich_media_chapter_add": "Ajouter un chapitre",
    "video_rich_media_chapter_slide_add": "Ajouter une diapositive et un chapitre",
    "video_rich_media_slide": "Diapositive",
    "video_rich_media_chapter": "Chapitre",
    "video_rich_media_submited": "Les donn\u00e9es rich-m\u00e9dia sont ajout\u00e9es avec succ\u00e9s",
    "video_rich_media_chapter_exist": "Vous avez d\u00e9j\u00e0 un chapitre pour cet instant !",
    "video_rich_media_slide_exist": "Vous avez d\u00e9j\u00e0 une diapositive pour cet instant !",
    "preview_file": "Aperçu du fichier",
    "content_chapter": "Texte",
    "video_rich_media_chapter_import": "Importer des chapitres",
    "video_rich_media_chapter_file_sample": "Exemple",
    "alert_not_valid_slide_video_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une vid\u00e9o.Veuillez s\u00e9lectionner une vid\u00e9o avec l'extension suivante: .mp4 *",
    "alert_not_valid_slide_image_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une image. Veuillez s\u00e9lectionner une image avec l'une des extensions suivantes : *.PNG *.JPG *.JPEG *.GIF",
    "delete_chapter_title": "Voulez-vous remplacer l'index ?",
    "delete_chapter_text_partie_1": "L'index \u00e0 l'instant ",
    "delete_chapter_text_partie_2": " sera supprim\u00e9.",
    "delete_slide_title": "Voulez-vous remplacer la diapositive ?",
    "delete_slide_text_partie_1": "La diapositive \u00e0 l'instant ",
    "delete_slide_text_partie_2": " sera supprim\u00e9e.",
    "delete_chapter_aria_label": "Supprimer index",
    "delete_slide_aria_label": "Supprimer diapositive"
  },
  "VIDEOLIST": {
    "delete_video_msg": "Voulez-vous supprimer la vid\u00e9o ?",
    "delete_audio_msg": "Voulez-vous supprimer la description de cette vid\u00e9o ?",
    "delete_selected_videos_msg": "Voulez-vous supprimer cette s\u00e9lection de vid\u00e9os ?",
    "delete_selected_video_msg": "Voulez-vous supprimer la vid\u00e9o supprim\u00e9e ?",
    "delete_video_aria_label": "Suppression vid\u00e9o",
    "delete_audio_aria_label": "Suppression description audio",
    "delete_selected_videos_aria_label": "Suppression des vid\u00e9os s\u00e9lectionn\u00e9es",
    "delete_selected_video_aria_label": "Suppression de vid\u00e9o s\u00e9lectionn\u00e9e",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succès.",
    "dialog_alert_delete_all_description": "Les \u00e9l\u00e9ments s\u00e9lectionn\u00e9s ont \u00e9t\u00e9 supprim\u00e9s avec succès.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_download_error_title": "T\u00e9l\u00e9charger vid\u00e9o",
    "dialog_download_error_text": "Le fichier vid\u00e9o source n'existe pas",
    "undeleted_are": "Les vid\u00e9os ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les vid\u00e9os ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es",
    "video_not_found": "Cette vid\u00e9o n'existe pas sur le serveur",
    "dialog_will_be_deleted": "La description audio de cette vid\u00e9o sera supprim\u00e9e",
    "dialog_will_be_deleted_video": " sera supprim\u00e9e.",
    "add_description": "Ajouter une description audio",
    "edit_description": "Modifier la description audio",
    "delete_description": "Supprimer la description audio",
    "dialog_alert_delete_audio_description": "Description audio supprim\u00e9e avec succ\u00e9s",
    "insert_mail": "Ins\u00e9rer des emails",
    "insert_mail_abonne": "Envoyer aux abonn\u00e9es",
    "group_abonne": "Choisir un groupe d'abonn\u00e9s pour envoyer a ces abonn\u00e9s, ou bien choisir Tous pour envoyer a tous les abonn\u00e9es",
    "envoyer_mail": "Veuillez ins\u00e9rer les emails dans le champs suivant",
    "envoyer_mail_video": "Ins\u00e9rer des adresses mails dans ce champs pour envoyer des tests ( Taper \"entrée\" après chaque email inséré )",
    "add_subscribers": "G\u00e9rer des abonn\u00e9s",
    "list_subscribers": "Liste des abonn\u00e9s",
    "list_subscribers_added": "Liste des abonn\u00e9s pour cette vid\u00e9o",
    "dialog_alert_send_video_description": "Vid\u00e9o envoy\u00e9e avec succ\u00e9s",
    "copied": "lien copi\u00e9",
    "preview_simple_list": "Liste moyenne taille",
    "preview_simple_list_big": "Liste grande taille",
    "preview_gallery_list": "Vignettes",
    "preview_small_list": "Liste petite taille",
    "preview_list_buttons": "Liste avec boutons",
    "preview_list_folders": "R\u00e9pertoires",
    "display": "Affichage",
    "diffusion": "Diffusion",
    "period": "P\u00e9riode",
    "week": "Semaine",
    "month": "Mois",
    "year": "Ann\u00e9e",
    "trimester": "Trimestre",
    "semester": "Semestre",
    "none": "Aucune",
    "form_attr_question": "Ajouter une question",
    "form_attr_onp": "Oui-Non-NSP",
    "form_attr_on": "Oui-Non",
    "video_reset": "Restaurer",
    "add": "Ajouter une question",
    "rm": "Type vidéos",
    "isrm": "Vidéos richmedia",
    "not_rm": "Vidéos non richmedia",
    "all": "Tous les vidéos"
  },
  "VIDEOUPLOAD": {
    "video_upload_title": "T\u00e9l\u00e9chargement d'une vid\u00e9o",
    "video_reupload_title": "T\u00e9l\u00e9chargement d'une nouvelle vid\u00e9o",
    "remove_all": "Supprimer tout",
    "cancel_all": "Annuler tout",
    "upload_all": "Télécharger tout",
    "inprogress": "1 Vidéo en cours",
    "ended": "1 Vidéo terminée",
    "cancel_confirm": "Vous êtes sûr d'annuler le téléchargement de la vidéo?",
    "close_confirm": "Voulez vous fermer cette fenêtre?",
    "no": "Non",
    "yes": "Oui",
    "still_upload": "Il y'a des vidéos en cours de téléchargement",
    "video": "Vidéo",
    "videos": "Les vidéos en cours",
    "cancel_reupload": "Vous êtes sûr de fermer cette fenêtre et perdre ces données",
    "add_video_automatic": "{{fileName}} \u00e0 \u00e9t\u00e9 ajout\u00e9e automatiquement",
    "add_video_automatic_multiple": ", vous pouvez choisir un autre fichier pour l'ajouter",
    "complete_upload_video": "Fichiers import\u00e9s avec succ\u00e8s",
    "complete_multi_upload": ", veuillez choisir un fichier pour l'ajouter"
  },
  "AUDIOUPLOAD": {
    "audio_upload_title": "T\u00e9l\u00e9chargement d'un fichier audio"
  },
  "VIDEOMONTAGE": {
    "startMedia": "D\u00e9but de la m\u00e9dia:",
    "endMedia": "Fin de la m\u00e9dia:",
    "new_video": "Ajouter une nouvelle vid\u00e9o"
  },
  "VIDEOCHRONOLOGY": {
    "upload": "Upload vid\u00e9o",
    "transcodage": "Vid\u00e9o en transcodage",
    "transfert_buffer": "Vid\u00e9o sur le serveur buffer",
    "transfert_serveur_client": "Vid\u00e9o sur le serveur de stockage MGEN",
    "transfert_rmbox": "Vid\u00e9o sur les boitiers",
    "in_progress": "Non trait\u00e9e"
  },
  "VALIDATIONS": {
    "DateTime.invalid": "Date invalide !",
    "user.keyWords.not_blank": "Mots cl\u00e9s ne doit pas \u00eatre vide !",
    "quota_exceeds": "L'espace disque de votre canal est insuffisant pour ajouter cette vidéo !",
    "video": {
      "fileTitle.not_blank": "Le titre de fichier ne doit pas \u00eatre vide !",
      "title.not_blank": "Le titre ne doit pas \u00eatre vide !",
      "stratDate.not_blank": "Date d\u00e9but ne doit pas \u00eatre vide !",
      "endDate.not_blank": "Date fin ne doit pas \u00eatre vide !",
      "duration.not_blank": "La dur\u00e9e ne doit pas \u00eatre vide !",
      "duration.invalid": "La dur\u00e9e est invalide !",
      "startDate.invalid": "Date d\u00e9but invalide !",
      "endDate.invalid": "Date fin invalide !"
    }
  },
  "QuestionsQuizLIST": {
    "question": "Question",
    "quiz": "Quiz",
    "other": "Autre",
    "vote": "Vote",
    "yes": "Oui",
    "no": "Non",
    "percentVotes": "Pourcentage de votes",
    "listChoices": "Choix",
    "nbVotes": "Nombre de votes"
  }
}
);

$translateProvider.translations("en", {
  "SKIN": {

  }
});

$translateProvider.translations("fr", {
  "SKIN": {

  }
});

$translateProvider.translations("en", {
  "USERLIST": {
    "name": "Name",
    "lastName": "Firstname",
    "email": "Email",
    "login": "Login",
    "delete_user": "Delete",
    "delete_user_msg": "Do you want to delete the user?",
    "delete_user_aria_label": "Delete user?",
    "delete_users": "Delete selected users",
    "delete_list_user_msg": "Do you want to delete these users?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "dialog_alert_failed_delete_title": "Failed operation",
    "dialog_alert_failed_delete_description": " cannot be deleted !!",
    "update_user": "Update",
    "update_pwd_user": "Update password",
    "enable_user": "Enable the account user",
    "disable_user": "Disable account user",
    "detail_user": "Details",
    "added": "User added successfully.",
    "edited": "User edited successfully.",
    "username": "Username",
    "last_login": "Last login",
    "firstName": "First name",
    "lasttName": "Last name",
    "groups": "Groups",
    "undeleted_are": "Users with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Users with ids \"{{list}}\" have been deleted",
    "action_new_element": "Add new user"
  },
  "USERADD": {
    "form_attr_name": "Name",
    "form_attr_lastName": "Last name",
    "form_attr_email": "Email",
    "form_attr_login": "Login",
    "form_new_title": "Add user form",
    "form_title": "User information",
    "form_add_user_title" : "Account",
    "form_attr_username": "Username",
    "form_attr_phone": "Phone",
    "form_attr_mobile": "Mobile",
    "form_attr_description": "Description",
    "form_attr_postalCode": "Postal code",
    "form_attr_photo": "Your picture",
    "form_attr_adress": "Adress",
    "form_attr_company": "Company",
    "form_attr_city": "City",
    "form_attr_numberPersons": "Nomber of persons",
    "form_attr_channel": "Select channel(s)",
    "form_attr_firstName": "First name",
    "form_attr_first": "Password",
    "form_attr_second": "Repeat password",
    "form_attr_groups": "Select group(s)",
    "ct_default": "Password entered by the user",
    "ct_random": "Temporary password",
    "ct_email": "Enter password",
    "choose_thumb": "Select profile picture",
    "random_pwd_notif": "Send a temporary password by email, the customer will have to change it at the 1st connection",
    "email_pwd_notif": "Send to the user, a link to create a password.",
    "activate_code_validation": "Use Authentication with validation code",
    "msg_activate_code_validation": "An email with the verification code of your account has just been sent to the address ",
    "label_activate_code_validation": "Please enter this code here",
    "tooltip_activate_code_validation": "Code generation"
  },
  "USEREDIT": {
    "form_edit_title": "Edit user form :",
    "form_title": "User edit",
    "form_pwd_title": "User password edit",
    "choose_thumb": "Edit profile picture"
  },
  "USERCHANGEPASSWORD": {
    "form_title": "Change your password",
    "form_old_password": "Old password",
    "form_new_password": "New password"
  },
  "USERDETAIL": {
    "lastName": "Last name",
    "email": "Email",
    "user_detail_title": "User detail",
    "username": "Username",
    "lastLogin": "Last login",
    "firstName": "First name"
  },
  "USERPROFILE": {
    "edit": "Edit",
    "edit_password": "Edit password",
    "about": "About",
    "general_information": "General information",
    "first_name": "First name",
    "last_name": "Last name",
    "contact": "Contact",
    "tel": "Mobile",
    "email": "Email",
    "joined_groups": "Registred groups",
    "description": "Description",
    "mobile": "Mobile",
    "edit_userconnected": "Edit of user",
    "validate": "Validate",
    "canaux": "Your canals"
  },
  "USERPASSWORD": {
    "message": "Create your password",
    "form_attr_first": "Password",
    "form_attr_second": "Repeat password",
    "sub_button": "Create",
    "password_changed": "Password changed successfully",
    "ERRORS": {
      "PASSWORD_REQUIRED": "Password field is required",
      "PASSWORD_CONFIRM_REQUIRED": "Password (confirm) field is required",
      "PASSWORD_MAX_LENGTH": "This field must contain at most {{length}} characters.",
      "PASSWORD_MIN_LENGTH": "This field must contain at least {{length}} characters.",
      "PASSWORD_PATTERN": "This field must be at the alphanumeric type, contain at least one capital letter and one digit.",
      "PASSWORD_MISSMATCH": "The two passwords are not identical."
    }
  },
  "USERPHONE": {
    "ERRORS": {
      "PHONE_MAX_LENGTH": "This field must contain at most {{length}} numbers.",
      "PHONE_MIN_LENGTH": "This field must contain at least {{length}} numbers.."
    }
  },
  "USERMESSAGEEROOR": {
    "user.firstName.not_blank": "This field is empty, please enter your name",
    "user.lastName.not_blank": "The lastname field is required",
    "user.username.not_blank": "The username field is required",
    "user.email.not_blank": "This field is empty, enter your email address.",
    "user.email.not_valid": "Invalid email format",
    "User.password.length": "Choose a good password",
    "user.group.not_blank": "Select a group."
  },
  "VALIDATIONS": {
    "permission_not_found": "Permission not found!",
    "action_not_found": "Action not found!",
    "module_not_found": "Module not found!",
    "cannot_delete_user": "This user cannot be deleted!",
    "cannot_delete_self": "You cannot delete your account!",
    "cannot_edit_user": "This user cannot be modified!",
    "user_already_disable": "This user is already disabled!",
    "user_not_found": "This user is not found!",
    "password_already_exist": "You have already used this password!",
    "expired_code": "Your code has expired",
    "invalid_code": "Your code is incorrect",
    "user": {
      "uniqueEmail": "This email address is already used",
      "uniqueUsername": "This username is already used",
      "firstName.not_blank": "Empty field!",
      "lastName.not_blank": "Empty field!",
      "username.not_blank": "Empty field!",
      "email.not_blank": "Empty field!",
      "email.not_valid": "Invalidate email address",
      "plainPassword.not_blank": "Empty field!",
      "group.not_blank": "Empty field!"
    }
  },
  "QUOTAS": {
    "Paid" : "Paid",
    "get_more_space": "Get more space",
    "upgrade": "Upgrade",
    "latest_invoice": "Latest invoice",
    "percentage_used": "You used \"{{percent}}\"% of the pack"
  }
}
);

$translateProvider.translations("fr", {
  "USERLIST": {
    "name": "Nom",
    "lastName": "Pr\u00e9nom",
    "email": "Email",
    "login": "Identifiant",
    "delete_user": "Supprimer",
    "delete_user_msg": "Voulez-vous vraiment supprimer l'utilisateur ?",
    "delete_user_aria_label": "Supprimer l'utilisateur",
    "delete_users": "Supprimer les utilisateurs sélectionnés",
    "delete_list_user_msg": "Voulez-vous vraiment supprimer ces utilisateurs ?",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "dialog_alert_failed_delete_title": "Op\u00e9ration avec échec",
    "dialog_alert_failed_delete_description": " ne peut pas être supprim\u00e9 !!",
    "update_user": "Modifier",
    "update_pwd_user": "Modifier le mot de passe",
    "enable_user": "Activer le compte utilisateur",
    "disable_user": "D\u00e9sactiver le compte utilisateur",
    "detail_user": "D\u00e9tails",
    "added": "Utilisateur ajout\u00e9 avec succ\u00e8s.",
    "edited": "Utilisateur modifi\u00e9 avec succ\u00e8s.",
    "username": "Nom d'utilisateur",
    "last_login": "Derni\u00e8re connexion",
    "firstName": "Nom",
    "lasttName": "Pr\u00e9nom",
    "groups": "Groupes",
    "undeleted_are": "Les utilisateurs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les utilisateurs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "action_new_element": "Ajouter un nouveau utilisateur"
  },
  "USERADD": {
    "form_attr_name": "Nom",
    "form_attr_lastName": "Pr\u00e9nom",
    "form_attr_email": "Email",
    "form_attr_login": "Identifiant",
    "form_new_title": "Formulaire d'ajout d'un nouveau utilisateur",
    "form_title": "Information utilisateur",
    "form_add_user_title" : "Compte",
    "form_attr_username": "Nom d'utilisateur",
    "form_attr_phone": "T\u00e9l\u00e9phone",
    "form_attr_mobile": "Mobile",
    "form_attr_description": "Description",
    "form_attr_adress": "Adresse",
    "form_attr_postalCode": "Code postal",
    "form_attr_photo": "Votre photo",
    "form_attr_company": "Societ\u00e9",
    "form_attr_city": "Ville",
    "form_attr_numberPersons": "Nombre de personne",
    "form_attr_channel": "S\u00e9lection d'un ou plusieurs canaux",
    "form_attr_firstName": "Nom",
    "form_attr_first": "Mot de passe",
    "form_attr_second": "R\u00e9p\u00e9ter mot de passe",
    "form_attr_groups": "S\u00e9lection de groupe",
    "ct_default": "Mot de passe saisi par l'utilisateur",
    "ct_random": "Mot de passe temporaire",
    "ct_email": "Saisir un mot de passe",
    "random_pwd_notif": "Envoyer un mot de passe temporaire par mail, le client devra le changer \u00e0 la 1ere connexion",
    "email_pwd_notif": "Envoyer, \u00e0 l'utilisateur,  un lien pour cr\u00e9er son mot de passe.",
    "choose_thumb": "Choisir une photo de profil",
    "activate_code_validation": "Activer l'authentification avec code de validation",
    "msg_activate_code_validation": "Un email comportant le code de validation de votre compte vient d'être envoyé à l'adresse ",
    "label_activate_code_validation": "Veuillez saisir ce code ici",
    "tooltip_activate_code_validation": "Génération de code"
  },
  "USEREDIT": {
    "form_edit_title": "Formulaire de modification d'utilisateur : ",
    "form_title": "Modification de l'utilisateur",
    "form_pwd_title": "Modifier le mot de passe de l'utilisateur",
    "choose_thumb": "Modifier votre photo de profil"
  },
  "USERCHANGEPASSWORD": {
    "form_title": "Changer votre mot de passe",
    "form_old_password": "Ancien mot de passe",
    "form_new_password": "Nouveau mot de passe"
  },
  "USERDETAIL": {
    "lastName": "Pr\u00e9nom",
    "email": "Email",
    "user_detail_title": "D\u00e9tail de l'utilisateur",
    "username": "Nom de l'utilisateur",
    "lastLogin": "Derni\u00e8re connexion",
    "firstName": "Nom"
  },
  "USERPROFILE": {
    "edit": "Modifier",
    "edit_password": "Modifier mot de passe",
    "about": "D\u00e9tail",
    "general_information": "Information g\u00e9n\u00e9rale",
    "first_name": "Nom",
    "last_name": "Pr\u00e9nom",
    "contact": "Contact",
    "tel": "T\u00e9l",
    "email": "Email",
    "joined_groups": "Groupes enregistr\u00e9s",
    "description": "Description",
    "mobile": "Mobile",
    "edit_userconnected": "Modifier utilisateur",
    "validate": "Valider",
    "canaux": "Vos canaux"
  },
  "USERPASSWORD": {
    "message": "Cr\u00e9er votre nouveau mot de passe",
    "form_attr_first": "Mot de passe",
    "form_attr_second": "R\u00e9p\u00e9ter le mot de passe",
    "sub_button": "Cr\u00e9er",
    "password_changed": "Votre mot de passe a été changé avec succés",
    "ERRORS": {
      "PASSWORD_REQUIRED": "Le champ du mot de passe est requis",
      "PASSWORD_CONFIRM_REQUIRED": "Le champ Mot de passe (confirmer) est requis",
      "PASSWORD_MAX_LENGTH": "Ce champ doit comporter au plus {{length}} caract\u00e8res.",
      "PASSWORD_MIN_LENGTH": "Ce champ doit comporter au moins {{length}} caract\u00e8res.",
      "PASSWORD_PATTERN": "Ce champ doit au \u00eatre de type alphanumérique, contenir au moins une lettre majuscule et un chiffre.",
      "PASSWORD_MISSMATCH": "Les deux mots de passe ne sont pas identiques."
    }
  },
  "USERPHONE": {
    "ERRORS": {
      "PHONE_MAX_LENGTH": "Ce champ doit comporter au plus {{length}} chiffres.",
      "PHONE_MIN_LENGTH": "Ce champ doit comporter au moins {{length}} chiffres."
    }
  },
  "USERMESSAGEEROOR": {
    "user.firstName.not_blank": "Ce champ vide, veuillez saisir votre nom",
    "user.lastName.not_blank": "Le champ du pr\u00e9nom est requis",
    "user.username.not_blank": "Le champ du nom d'utilisateur est requis",
    "user.email.not_blank": "Ce champ est vide, veuillez  saisir votre adresse mail. ",
    "user.email.not_valid": "Format d'adresse mail invalide",
    "User.password.length": "Choisissez un bon mot de passe ",
    "user.group.not_blank": "S\u00e9lectionnez un groupe s'il vous plaît."
  },
  "VALIDATIONS": {
    "permission_not_found": "Permission introuvable !",
    "action_not_found": "Action introuvable !",
    "module_not_found": "Module introuvable !",
    "cannot_delete_user": "Cet utilisateur ne peut pas être supprim\u00e9 !",
    "cannot_delete_self": "Vous ne pouvez pas supprimer votre compte !",
    "cannot_edit_user": "Cet utilisateur ne peut pas \u00eatre modifi\u00e9 !",
    "user_already_disable": "Cet utilisateur est d\u00e9j\u00e0 d\u00e9sactiv\u00e9 !",
    "user_not_found": "Cet utilisateur est introuvable !",
    "password_already_exist": "Vous avez déjà utilisé ce mot de passe !",
    "expired_code": "Votre code est expiré",
    "invalid_code": "Votre code est incorrect",
    "user": {
      "uniqueEmail": "Cette adresse email est d\u00e9j\u00e0 utilis\u00e9e",
      "uniqueUsername": "Ce nom d'utilisateur est d\u00e9j\u00e0 utilis\u00e9",
      "firstName.not_blank": "Champ vide !",
      "lastName.not_blank": "Champ vide !",
      "username.not_blank": "Champ vide !",
      "email.not_blank": "Champ vide !",
      "email.not_valid": "Adresse email invalide",
      "plainPassword.not_blank": "Champ vide !",
      "group.not_blank": "Champ vide !"
    }
  },
  "QUOTAS": {
    "paid" : "Pay\u00e9",
    "get_more_space": "Obtenez plus d'espace",
    "upgrade": "Mettre à niveau",
    "latest_invoice": "Dernière facture",
    "percentage_used": "Vous avez utilisé \"{{percentage}}\" % du pack"

  }
}
);

$translateProvider.translations("en", {
  "STATIONLIST": {
    "ip": "IP address",
    "name": "Name",
    "domain": "Domain",
    "intranetStreamFr": "Intranet stream Fr",
    "intranetStreamEn": "Intranet stream En",
    "intranetStreamEs": "Intranet stream Es",
    "intranetStreamOr": "Intranet stream Or",
    "update_station": "Update",
    "delete_station": "Delete",
    "detail_station": "Details",
    "delete_station_msg": "Do you want to delete the station?",
    "delete_station_aria_label": "Delete station ?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "Station added successfully.",
    "edited": "Station edited successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element" : "Add new station",
    "delete_list_stations_msg": "Do you want to delete these stations?",
    "dialog_will_be_deleted_station": " will be deleted.",
    "delete_stations_aria_label": "Delete stations",
    "undeleted_are": "Stations with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Stations with ids \"{{list}}\" have been deleted"
  },
  "STATIONDETAIL": {
    "id": "Id : ",
    "ip": "IP address : ",
    "name": "Name : ",
    "domain": "Domain : ",
    "description": "Description : ",
    "intranetStreamFr": "Intranet stream Fr",
    "intranetStreamEn": "Intranet stream En",
    "intranetStreamEs": "Intranet stream Es",
    "intranetStreamOr": "Intranet stream Or",
    "station_detail_title": "Station detail"
  },
  "STATIONADD": {
    "form_new_title": "Add station form",
    "form_title": "Station information",
    "form_attr_name": "Name",
    "form_attr_domain": "Domain",
    "form_attr_description": "Description",
    "form_attr_ip": "IP address",
    "form_attr_intranetStreamFr": "Intranet stream Fr",
    "form_attr_intranetStreamEn": "Intranet stream En",
    "form_attr_intranetStreamEs": "Intranet stream Es",
    "form_attr_intranetStreamOr": "Intranet stream Or"
  },
  "STATIONEDIT": {
    "form_edit_title": "Edit station form :",
    "form_title": "Station edit"
  }
}
);

$translateProvider.translations("fr", {
  "STATIONLIST": {
    "ip": "Adresse IP",
    "name": "Nom",
    "domain": "Domaine",
    "intranetStreamFr": "Intranet stream Fr",
    "intranetStreamEn": "Intranet stream En",
    "intranetStreamEs": "Intranet stream Es",
    "intranetStreamOr": "Intranet stream Or",
    "update_station": "Modifier",
    "delete_station": "Supprimer",
    "detail_station": "D\u00e9tails",
    "delete_station_msg": "Voulez-vous vraiment supprimer la station ?",
    "delete_station_aria_label": "Voulez-vous supprimer la station",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_will_be_deleted_station": " sera supprim\u00e9e.",
    "dialog_alert_delete_close": "Fermer",
    "added": "Station ajout\u00e9e avec succ\u00e8s.",
    "edited": "Station modifi\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "description": "Description",
    "action_new_element" : "Ajouter une nouvelle station",
    "delete_list_stations_msg": "Voulez-vous vraiment supprimer ces stations?",
    "delete_stations_aria_label": "Supprimer les stations",
    "undeleted_are": "Les stations ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les stations ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es"
  },
  "STATIONDETAIL": {
    "id": "Id : ",
    "ip": "Adresse IP : ",
    "name": "Nom : ",
    "domain": "Domaine : ",
    "description": "Description : ",
    "intranetStreamFr": "Intranet stream Fr",
    "intranetStreamEn": "Intranet stream En",
    "intranetStreamEs": "Intranet stream Es",
    "intranetStreamOr": "Intranet stream Or",
    "station_detail_title": "Station detail"
  },
  "STATIONADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle station",
    "form_title": "Information de la station",
    "form_attr_name": "Nom",
    "form_attr_domain": "Domaine",
    "form_attr_description": "Description",
    "form_attr_ip": "Adresse IP",
    "form_attr_intranetStreamFr": "Intranet stream Fr",
    "form_attr_intranetStreamEn": "Intranet stream En",
    "form_attr_intranetStreamEs": "Intranet stream Es",
    "form_attr_intranetStreamOr": "Intranet stream Or"
  },
  "STATIONEDIT": {
    "form_edit_title": "Formulaire de modification de station : ",
    "form_title": "Modification de la station"
  }
}
);

$translateProvider.translations("en", {
  "DIRECTIONLIST": {
    "title": "Title",
    "parent": "Parent",
    "update_direction": "Update",
    "delete_direction": "Delete",
    "detail_direction": "Details",
    "delete_direction_msg": "Do you want to delete the direction?",
    "delete_direction_aria_label": "Delete direction ?",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "added": "Direction added successfully.",
    "edited": "Direction edited successfully.",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "action_new_element": "Add new direction",
    "dialog_will_be_deleted_direction": " will be deleted.",
    "delete_list_directions_msg": "Do you want to delete these Directions?",
    "delete_directions_aria_label": "Delete Directions",
    "undeleted_are": "Directions with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Directions with ids \"{{list}}\" have been deleted"
  },
  "DIRECTIONDETAIL": {
    "id": "Id : ",
    "title": "Title : ",
    "parent": "Parent",
    "visible": "Visible",
    "direction_detail_title": "Direction detail"
  },
  "DIRECTIONADD": {
    "form_new_title": "Add direction form",
    "form_title": "Direction information",
    "form_attr_name": "Title"
  },
  "DIRECTIONEDIT": {
    "form_edit_title": "Edit direction form :",
    "form_title": "Direction edit"
  }
});

$translateProvider.translations("fr", {
  "DIRECTIONLIST": {
    "title": "Titre",
    "parent": "Parent",
    "update_direction": "Modifier",
    "delete_direction": "Supprimer",
    "detail_direction": "D\u00e9tails",
    "delete_direction_msg": "Voulez-vous vraiment supprimer la direction ?",
    "delete_direction_aria_label": "Voulez-vous supprimer la direction",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "added": "Direction ajout\u00e9e avec succ\u00e8s.",
    "edited": "Direction modifi\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_will_be_deleted_direction": " sera supprim\u00e9e.",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "description": "Description",
    "action_new_element": "Ajouter une nouvelle direction",
    "delete_directions_aria_label": "Supprimer les directions",
    "delete_list_directions_msg": "Voulez-vous vraiment supprimer ces directions?",
    "undeleted_are": "Les directions ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9es",
    "deleted_are": "Les directions ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9es"
  },
  "DIRECTIONDETAIL": {
    "id": "Id : ",
    "title": "Titre : ",
    "parent": "Parent",
    "visible": "Visible",
    "direction_detail_title": "D\u00e9tails de la direction"
  },
  "DIRECTIONADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle direction",
    "form_title": "Information de la direction",
    "form_attr_name": "Titre"
  },
  "DIRECTIONEDIT": {
    "form_edit_title": "Formulaire de modification de direction : ",
    "form_title": "Modification de la direction"
  }
});

$translateProvider.translations("en", {
  "IPTVLIST": {
    "image": "Image",
    "name": "Name",
    "visible": "Visibility",
    "description": "Description",
    "update_iptv": "Update",
    "delete_iptv": "Delete",
    "delete_iptv_msg": "Do you want to delete the IP-TV ?",
    "delete_iptv_aria_label": "Delete IP-TV",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed !",
    "added": "IP-TV added successfully.",
    "edited": "IP-TV edited successfully.",
    "detail_iptv": "Details",
    "linkUrl": "Link URL",
    "action_new_element" : "Add a new IP-TV",
    "delete_list_iptv_msg": "Do you want to delete these IP-TVs?",
    "delete_iptvs_aria_label": "Delete IP-TVs",
    "undeleted_are": "IP-TVs with ids \"{{list}}\" could not be deleted",
    "deleted_are": "IP-TVs with ids \"{{list}}\" have been deleted"
  },
  "IPTVDETAIL": {
    "id": "Id : ",
    "name": "IP-TV name",
    "visible": "Visibility : ",
    "linkUrl": "Link URL : ",
    "iptv_detail_title": "IP-TV details",
    "description": "Description : "
  },
  "IPTVADD": {
    "form_new_title": "Add a new IP-TV",
    "form_title": "IP-TV information",
    "form_attr_name": "IP-TV name",
    "form_attr_visible": "Visible",
    "form_attr_description": "Description",
    "form_attr_linkUrl": "Link URL",
    "choose_thumb": "Choose a thumbnail"
  },
  "IPTVEDIT": {
    "form_edit_title": "Edit IP-TV form",
    "form_title": "IP-TV edit"
  }
});

$translateProvider.translations("fr", {
  "IPTVLIST": {
    "image": "Image",
    "name": "Nom",
    "visible": "Visibilit\u00e9",
    "description": "Description",
    "update_iptv": "Modifier",
    "delete_iptv": "Supprimer",
    "delete_iptv_msg": "Voulez-vous vraiment supprimer l'IP-TV ?",
    "delete_iptv_aria_label": "Supprimer l'IP-TV",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9e avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "added": "IP-TV  ajout\u00e9e avec succ\u00e8s.",
    "edited": "IP-TV modifi\u00e9e avec succ\u00e8s.",
    "detail_iptv": "D\u00e9tails",
    "linkUrl": "Lien URL",
    "action_new_element" : "Ajouter une nouvelle IP-TV",
    "delete_iptvs_aria_label": "Supprimer les IP-TVs",
    "delete_list_iptv_msg": "Voulez-vous vraiment supprimer ces IP-TVs?",
    "undeleted_are": "Les IP-TVs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les IP-TVs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s"
  },
  "IPTVDETAIL": {
    "id": "Id : ",
    "name": "Nom de l'IP-TV : ",
    "visible": "Visibilit\u00e9 : ",
    "linkUrl": "Lien URL : ",
    "iptv_detail_title": "D\u00e9tails de l'IP-TV",
    "description": "Description : "
  },
  "IPTVADD": {
    "form_new_title": "Ajout d'une nouvelle IP-TV",
    "form_title": "Information de l'IP-TV",
    "form_attr_name": "IP-TV nom",
    "form_attr_visible": "Visibilit\u00e9",
    "form_attr_description": "Description",
    "form_attr_linkUrl": "Lien URL",
    "choose_thumb": "Choisir une image"
  },
  "IPTVEDIT": {
    "form_edit_title": "Editer le formulaire IP-TV",
    "form_title": "Edition de l'IP-TV"
  }
});

$translateProvider.translations("en", {
  "STATSCONSUMPTION": {
    "title": "Consumption",
    "hour": "Hour",
    "day": "Day",
    "week": "Week",
    "month": "Month",
    "form_date": "Choose the date...",
    "select_username": "Username",
    "acces_model": "Module",
    "acces_function": "Action",
    "stat_no_data" : "There are no data for this report."
  }
}
);

$translateProvider.translations("fr", {
  "STATSCONSUMPTION": {
    "title": "Consommation",
    "hour": "Heure",
    "day": "Jour",
    "week": "Semaine",
    "month": "Mois",
    "form_date": "Choisissez la date...",
    "select_username": "Nom d'utilisateur",
    "acces_model": "Module",
    "acces_function": "Action",
    "stat_no_data" : "Il n'y a pas de donn\u00e9es pour ce rapport."
  }
}
);

$translateProvider.translations("en", {
  "TRANSSTATSACCES": {
    "acces_session": "Session",
    "acces_ip": "IP",
    "acces_user": "User",
    "acces_date": "Date",
    "acces_list": "Access list",
    "form_date": "Choose the date...",
    "select_username": "Username",
    "acces_model": "Module",
    "acces_function": "Action"
  }
});

$translateProvider.translations("fr", {
  "TRANSSTATSACCES": {
    "acces_session": "Session",
    "acces_ip": "IP",
    "acces_user": "User",
    "acces_date": "Date",
    "acces_list": "Liste d'acc\u00e8s",
    "form_date": "Choisissez la date...",
    "select_username": "Nom d'utilisateur",
    "acces_model": "Module",
    "acces_function": "Action"
  }
});

$translateProvider.translations("en", {
  "STATSSTORAGE": {
    "title": "Storage",
    "hour": "Hour",
    "day": "HDay",
    "week": "Week",
    "month": "Month",
    "form_date": "Choose the date...",
    "select_username": "Username",
    "acces_model": "Module",
    "acces_function": "Action",
    "stat_no_data" : "There are no data for this report."
  }
}
);

$translateProvider.translations("fr", {
  "STATSSTORAGE": {
    "title": "Stockage",
    "hour": "Heure",
    "day": "Jour",
    "week": "Semaine",
    "month": "Mois",
    "form_date": "Choisissez la date...",
    "select_username": "Nom d'utilisateur",
    "acces_model": "Module",
    "acces_function": "Action",
    "stat_no_data" : "Il n'y a pas de donn\u00e9es pour ce rapport."
  }
}
);

$translateProvider.translations("en", {
  "HELP": {
    "welcome_group": "Welcome to 'Group List'",
    "add_button_group_help": " To add a group, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_group_help": "To see the rest of the groups, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_group_help": "To search for a group, type the indexed word in the search box above the table at right.",
    "tri_column_group_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_group_help": "To change the group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_group_help": "To see the group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_group_help": "To remove a group, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_group_add": "Welcome to 'Add Group'",
    "welcome_group_edit": "Welcome to 'Edit Group'",
    "welcome_group_permission": "Welcome to 'permission's list of modules'",
    "add_button_group_permission_help": "To add a permission , check the checkbox <button class='md-fab cursor-initial md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-checkbox-marked-outline' class='ng-scope cursor-initial md-font material-icons icon-checkbox-marked-outline' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>.",
    "parameters_group_add_help": "To edit or to add a group, you must fill in the form.",
    "parameters_group_import_help": "To import a group list, click the button  <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choose a file</span></button> to import a CSV file.",
    "send_button_group_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_group_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_group_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_user": "Welcome to 'User List'",
    "add_button_user_help": " To add a user, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "parameters_user_import_help": "To import a user list, click the button  <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choose a file</span></button> to import a CSV file.",
    "arrow_button_user_help": "To see the rest of users, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_user_help": "To search for a user, type the indexed word in the search box above the table at right.",
    "tri_column_user_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_user_help": "To change user's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_user_help": "To see user's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_user_help": "To remove a user, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_user_add": "Welcome to 'Add user'",
    "welcome_user_edit": "Welcome to 'Edit user'",
    "parameters_user_add_help": "To add or to edit a user, you must fill in the form.",
    "send_button_user_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_user_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_user_add_help": "To return to list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_rmbox": "Welcome to 'RmBox List'",
    "add_button_rmbox_help": " To add an RmBox, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_rmbox_help": "To see the rest of RmBoxs, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_rmbox_help": "To search for an RmBox, type the indexed word in the search box above the table at right.",
    "tri_column_rmbox_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_rmbox_help": "To change the RmBox's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_rmbox_help": "To see the RmBox's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_rmbox_help": "To remove an RmBox, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "pdf_button_rmbox_help": "To see rapports history list, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-file-pdf-box' class='s18 ng-scope md-font material-icons icon-file-pdf-box cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "actions_button_rmbox_help": "<div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Edit Rmbox</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Details Rmbox</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Delete Rmbox</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-file-pdf-box' class='s18 ng-scope md-font material-icons icon-file-pdf-box cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Rapports history list</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-refresh' class='s18 ng-scope md-font material-icons icon-refresh cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Refresh the display on the box</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Show schedule </div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-wifi' class='s18 ng-scope md-font material-icons icon-wifi cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Chain change</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Associate schedule</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon-worker' class='s18 ng-scope md-font material-icons icon-worker cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Interventions list</div></div>",
    "welcome_rmbox_add": "Welcome to 'Add RmBox'",
    "welcome_rmbox_edit": "Welcome to 'Edit RmBox'",
    "parameters_rmbox_add_help": " To add or change an RmBox, you must fill in the fields with a star <b>*</b>.",
    "send_button_rmbox_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_rmbox_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_rmbox_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_rmbox_group": "Welcome to 'RmBox group List'",
    "add_button_rmbox_group_help": " To add an RmBox group, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_rmbox_group_help": "To see the rest of the RmBoxs groups, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_rmbox_group_help": "To search for an RmBox group, type the indexed word in the search box above the table at right.",
    "tri_column_rmbox_group_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_rmbox_group_help": "To change the RmBox group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_rmbox_group_help": "To see the RmBox group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_rmbox_group_help": "To remove an RmBox group, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "associate_schedule_button_rmbox_group_help": "To associate a schedule to an RmBox group, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_rmbox_group_add": "Welcome to 'Add RmBox group'",
    "welcome_rmbox_group_edit": "Welcome to 'Edit RmBox group'",
    "parameters_rmbox_group_add_help": " To add or change an RmBox group, you must fill in the fields with a star <b>*</b>.",
    "send_button_rmbox_group_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_rmbox_group_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_rmbox_group_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_zone": "Welcome to 'Zone  List'",
    "add_button_zone_help": " To add a zone, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_zone_help": "To see the rest of the zones, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_zone_help": "To search for a zone, type the indexed word in the search box above the table at right.",
    "tri_column_zone_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_zone_help": "To change the zone's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_zone_help": "To see the zone's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_zone_help": "To remove a zone, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "stat_button_zone_help": "To view statistics by zone, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_zone_add": "Welcome to 'Add zone'",
    "welcome_zone_edit": "Welcome to 'Edit zone'",
    "parameters_zone_add_help": " To add or change a zone, you must fill in the fields with a star <b>*</b>.",
    "send_button_zone_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_zone_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_zone_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "zone_import_help": "To import a zone list, click the button  <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choose a file</span></button> to import a CSV file.",
    "welcome_canal": "Welcome to 'Channels  List'",
    "add_button_canal_help": " To add a channel, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_canal_help": "To see the rest of the channels, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_canal_help": "To search for a channel, type the indexed word in the search box above the table at right.",
    "tri_column_canal_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_canal_help": "To change the channel's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_canal_help": "To see the channel's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "stockage_button_canal_help": "To see the server storage of a channel, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-floppy' class='s18 ng-scope md-font material-icons icon-floppy cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_canal_help": "To see the channel's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_canal_help": "To remove a channel, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_canal_add": "Welcome to 'Add channel'",
    "welcome_canal_edit": "Welcome to 'Edit channel'",
    "parameters_canal_add_help": " To add or change a channel, you must fill in the fields with a star <b>*</b>.",
    "send_button_canal_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_canal_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_theme": "Welcome to 'Themes  List'",
    "add_button_theme_help": " To add a theme, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_theme_help": "To see the rest of the themes, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_theme_help": "To search for a theme, type the indexed word in the search box above the table at right.",
    "tri_column_theme_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_theme_help": "To change the theme's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_theme_help": "To see the theme's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_theme_help": "To see the theme's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_theme_help": "To remove a theme, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_theme_add": "Welcome to 'Add theme'",
    "welcome_theme_edit": "Welcome to 'Edit theme'",
    "parameters_theme_add_help": " To add or change a theme, you must fill in the fields with a star <b>*</b>.",
    "send_button_theme_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_theme_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_theme_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_client": "Welcome to 'List of client configuration parameters'",
    "add_button_client_help": " To add a client configuration parameter, click the button  <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_client_help": "To see the rest of client configuration parameters, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_client_help": "To search for a client configuration parameter, type the indexed word in the search box above the table at right.",
    "tri_column_client_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_client_help": "To change the information of a client configuration parameter, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_client_help": "To see the information of a client configuration parameter, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_client_help": "To remove a client configuration parameter, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_mooc_config": "Welcome to 'Add client'",
    "add_button_mooc_config_help": " To add or change a client, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "welcome_client_add": "Welcome to 'Add client configuration parameter'",
    "welcome_client_edit": "Welcome to 'Edit client configuration parameter'",
    "parameters_client_add_help": " To add or change a client configuration parameter, you must fill in the fields with a star <b>*</b>.",
    "send_button_client_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_client_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_client_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_player": "Welcome to 'List of player configuration parameters'",
    "add_button_player_help": " To add a player configuration parameter, click the button  <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_player_help": "To see the rest of player configuration parameters, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_player_help": "To search for a player configuration parameter, type the indexed word in the search box above the table at right.",
    "tri_column_player_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_player_help": "To change the information of a player configuration parameter, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_player_help": "To see the information of a player configuration parameter, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_player_help": "To remove a player configuration parameter, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_news": "Welcome to 'News  List'",
    "add_button_news_help": " To add a news, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_news_help": "To see the rest of the news, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_news_help": "To search for a news, type the indexed word in the search box above the table at right.",
    "tri_column_news_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_news_help": "To change a news, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_news_help": "To remove a news, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_news_add": "Welcome to 'Add news'",
    "welcome_news_edit": "Welcome to 'Edit news'",
    "parameters_news_add_help": " To add or change a news, you must fill in the fields with a star <b>*</b>.",
    "send_button_news_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_news_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_news_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",

    "welcome_general": "Welcome to 'General  List'",
    "add_button_general_help": " To add a general, click the black button   <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>that will guide you to the form.",
    "arrow_button_general_help": "To see the rest of the generals, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_general_help": "To search for a general, type the indexed word in the search box above the table at right.",
    "tri_column_general_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_general_help": "To change the general's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_general_help": "To see the general's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_general_help": "To see the general's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_general_help": "To remove a general, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_general_add": "Welcome to 'Add general'",
    "parameters_general_add_help": " To add or change a general, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_general_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_general_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_preset": "Welcome to 'Presets  List'",
    "add_button_preset_help": " To add a preset, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_preset_help": "To see the rest of the presets, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_preset_help": "To search for a preset, type the indexed word in the search box above the table at right.",
    "tri_column_preset_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_preset_help": "To change the preset's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_preset_help": "To see the preset's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_preset_help": "To see the preset's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_preset_help": "To remove a preset, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_preset_add": "Welcome to 'Add preset'",
    "welcome_preset_edit": "Welcome to 'Edit preset'",
    "parameters_preset_add_help": " To add or change a preset, you must fill in the fields with a star <b>*</b>.",
    "send_button_preset_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_preset_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_preset_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_server": "Welcome to 'Servers  List'",
    "add_button_server_help": " To add a server, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_server_help": "To see the rest of the servers, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_server_help": "To search for a server, type the indexed word in the search box above the table at right.",
    "tri_column_server_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_server_help": "To change the server's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_server_help": "To see the server's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_server_help": "To see the server's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_server_help": "To remove a server, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_server_add": "Welcome to 'Add server'",
    "welcome_server_edit": "Welcome to 'Edit server'",
    "parameters_server_add_help": " To add or change a server, you must fill in the fields with a star <b>*</b>.",
    "send_button_server_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_server_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_server_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_direction": "Welcome to 'Direction  List'",
    "add_button_direction_help": " To add a direction, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_direction_help": "To see the rest of the directions, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_direction_help": "To search for a direction, type the indexed word in the search box above the table at right.",
    "tri_column_direction_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_direction_help": "To change the direction's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_direction_help": "To see the direction's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_direction_help": "To see the direction's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_direction_help": "To remove a direction, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_direction_add": "Welcome to 'Add direction'",
    "welcome_direction_edit": "Welcome to 'Edit direction'",
    "parameters_direction_add_help": " To add or change a direction, you must fill in the fields with a star <b>*</b>.",
    "send_button_direction_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_direction_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_direction_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_iptv": "Welcome to 'IP-TV  List'",
    "add_button_iptv_help": " To add an IP-TV, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_iptv_help": "To see the rest of the IP-TV, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_iptv_help": "To search for an IP-TV, type the indexed word in the search box above the table at right.",
    "tri_column_iptv_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_iptv_help": "To change the IP-TV's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_iptv_help": "To see the IP-TV's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_iptv_help": "To see the IP-TV's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_iptv_help": "To remove an IP-TV, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_iptv_add": "Welcome to 'Add IP-TV'",
    "welcome_iptv_edit": "Welcome to 'Edit IP-TV'",
    "parameters_iptv_add_help": " To add or change an IP-TV, you must fill in the fields with a star <b>*</b>.",
    "send_button_iptv_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_iptv_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_iptv_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_station": "Welcome to 'Station  List'",
    "add_button_station_help": " To add a station, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_station_help": "To see the rest of the stations, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_station_help": "To search for a station, type the indexed word in the search box above the table at right.",
    "tri_column_station_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_station_help": "To change the station's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_station_help": "To see the station's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_station_help": "To see the station's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_station_help": "To remove a station, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_station_add": "Welcome to 'Add station'",
    "welcome_station_edit": "Welcome to 'Edit station'",
    "parameters_station_add_help": " To add or change a station, you must fill in the fields with a star <b>*</b>.",
    "send_button_station_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_station_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_station_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_advert": "Welcome to 'Advertising  List'",
    "add_button_advert_help": " To add an advertising, click the black button   <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>that will guide you to the form.",
    "arrow_button_advert_help": "To see the rest of the advertising, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_advert_help": "To search for an advertising, type the indexed word in the search box above the table at right.",
    "tri_column_advert_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_advert_help": "To change the advertising's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_advert_help": "To see the advertising's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_advert_help": "To see the advertising's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_advert_help": "To remove a advertising, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_advert_add": "Welcome to 'Add advertising'",
    "welcome_advert_edit": "Welcome to 'Edit advertising'",
    "parameters_advert_add_help": " To add or change an advertising, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_advert_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_advert_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_comment": "Welcome to 'Comments  List'",
    "arrow_button_comment_help": "To see the rest of the comments, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_comment_help": "To search for a comment, type the indexed word in the search box above the table at right.",
    "tri_column_comment_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_comment_help": "To change the comment's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "activate_button_comment_help": "To activate/desactivate a comment, you should click the button<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-thumb-up' class='s18 ng-scope md-font material-icons icon-thumb-up cursor-initial' aria-hidden='true'></md-icon></button> or the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-thumb-down' class='s18 ng-scope md-font material-icons icon-thumb-down cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_comment_help": "To see the comment's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "export_button_comment_help": "To see the comment's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_comment_help": "To remove a comment, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_comment_add": "Welcome to 'Edit comment'",
    "parameters_comment_add_help": " To change a comment, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_comment_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_comment_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_sondage": "Welcome to 'Survey  List'",
    "add_button_sondage_help": " To add a survey, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_sondage_help": "To see the rest of the surveys, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_sondage_help": "To search for a survey, type the indexed word in the search box above the table at right.",
    "tri_column_sondage_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_sondage_help": "To change the survey's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_sondage_help": "To see the survey's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_sondage_button_help": "To see the survey's details, you must click on the button<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-histogram' class='s18 ng-scope md-font material-icons icon-chart-histogram cursor-initial' aria-hidden='true'></md-icon></button>in the same line (in the Action column)",
    "download_button_sondage_help": "To download the survey's details, you must click on the button<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-download' class='s18 ng-scope md-font material-icons icon-download cursor-initial' aria-hidden='true'></md-icon></button>in the same line (in the Action column)",
    "export_button_sondage_help": "To see the survey's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_sondage_help": "To remove a survey, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_sondage_add": "Welcome to 'Add survey'",
    "welcome_sondage_edit": "Welcome to 'Edit survey'",
    "parameters_sondage_add_help": " To add or change a survey, you must fill in the fields with a star <b>*</b>.",
    "parameters_sondage_add_question_help": "To add a question, you must click the button <button class='md-accent md-raised md-hue-1 md-button ng-scope md-default-theme md-ink-ripple' type='button'><span class='ng-binding ng-scope'>  Add question</span></button> ",
    "parameters_sondage_delete_question_help": "To delete a question,  must click the button <button class='md-raised md-warn md-button ng-scope md-default-theme md-in-ripple' type='button'><span class='ng-binding ng-scope'> Delete</span></button> ",
    "send_button_sondage_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_sondage_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_sondage_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_vote_details": "Welcome to 'Questions list'",
    "stat_zoom_message" : "Click the left button of the mouse and drag to zoom in.To scroll the graph to the right or left, hold down the Shift key as you drag the mouse.",
    "welcome_vote_details_stats": "Welcome to 'Statistic details'",
    "form_attr_Statistique_audience": "This is an overview of the visit evolution.<br><b>Visits: </b>If a visitor comes to your website for the first time or if they visit a page more than 30 minutes after their last page view, this will be recorded as a new visit.<br><b>Unique visitors: </b>The number of unduplicated visitors coming to your website. Every user is only counted once, even if they visit the website multiple times a day.<br><b>Number of views by visitor: </b> Number of views made by your visitors",
    "form_attr_Statistique_duree": "This report shows the visiting times of your visitors",
    "form_attr_Statistique_duree_visite": "This report shows the visiting times of your visitors",
    "form_attr_Statistique_plus_populaire": "This report shows the most popular videos.",
    "form_attr_Statistique_map": "This report shows in what country your visitors were when they accessed your website.",
    "form_attr_Statistique_os": "This report shows the most common <b>operating systems</b> for your visitors.",
    "form_attr_Statistique_navigateur": "This report contains information about what kind of browser your visitors were using. Each browser version is listed separately.",
    "form_attr_Statistique_referrer": "This report shows the most visited websites by your visitors.",
    "form_attr_Statistique_device": "This report shows the types of devices most common to your visitors.",
    "arrow_button_vote_details_help": "To see the rest of the questions, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "tri_column_vote_details_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "welcome_sondage_details": "Welcome to 'Survey details'",
    "arrow_button_sondage_details_help": "To see the rest of the surveys, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "tri_column_sondage_details_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "detail_sondage_details_button_help": "To see the survey's details, you must click on the button<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-histogram' class='s18 ng-scope md-font material-icons icon-chart-histogram cursor-initial' aria-hidden='true'></md-icon></button>in the same line (in the Action column)",
    "welcome_profil_user": "Welcome to 'Users  List'",
    "add_button_profil_user_help": " To add a user, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_profil_user_help": "To see the rest of the users, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_profil_user_help": "To search for a user, type the indexed word in the search box above the table at right.",
    "tri_column_profil_user_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_profil_user_help": "To change the user's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "editpwd_button_profil_user_help": "To change the user's password, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-lock' class='s18 ng-scope md-font material-icons icon-lock cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_profil_user_help": "To see the user's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "activate_button_profil_user_help": "To activate/desactivate a user account, you should click the button<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-check' class='s18 ng-scope md-font material-icons icon-account-check cursor-initial' aria-hidden='true'></md-icon></button> or the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-remove' class='s18 ng-scope md-font material-icons icon-account-remove cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "export_button_profil_user_help": "To see the user's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_user_help": "To remove a user, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_profil_user_add": "Welcome to 'Add user'",
    "welcome_profil_user_edit": "Welcome to 'Edit user'",
    "parameters_profil_user_add_help": " To add or change a user, you must fill in the fields with a star <b>*</b>.",
    "send_button_profil_user_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_profil_user_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_profil_user_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_editpwd_add": "Welcome to 'Edit password'",
    "parameters_editpwd_add_help": " To change a password, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_editpwd_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_editpwd_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_profil_group": "Welcome to 'Group  List'",
    "add_button_profil_group_help": " To add a group, click the black button   <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon></button>that will guide you to the form.",
    "arrow_button_profil_group_help": "To see the rest of the groups, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_profil_group_help": "To search for a group, type the indexed word in the search box above the table at right.",
    "tri_column_profil_group_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "permission_button_profil_group_help": "To manage the permissions, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-lock-unlocked' class='s18 ng-scope md-font material-icons icon-lock-unlocked cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "edit_button_profil_group_help": "To change the group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_profil_group_help": "To see the group's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "export_button_profil_group_help": "To see the group's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_group_help": "To remove a group, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_profil_group_add": "Welcome to 'Add group'",
    "parameters_profil_group_add_help": " To add or change a group, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_profil_group_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "cancel_button_profil_group_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_profil_ip": "Welcome to 'IPs  List'",
    "add_button_profil_ip_help": " To add an IP address, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_profil_ip_help": "To see the rest of the IPs, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_profil_ip_help": "To search for an IP address, type the indexed word in the search box above the table at right.",
    "tri_column_profil_ip_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_profil_ip_help": "To change the IP address's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_profil_ip_help": "To see the IP address's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "export_button_profil_ip_help": "To see the IP address's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_ip_help": "To remove an IP address, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_profil_ip_add": "Welcome to 'Add IP address'",
    "welcome_boitier_autorise_ip_add": "Welcome to 'Add allowed IP address'",
    "welcome_profil_ip_edit": "Welcome to 'Edit IP address'",
    "welcome_boitier_autorise_ip_edit": "Welcome to 'Edit allowed IP address'",
    "welcome_boitier_autorise_ip": "Welcome to 'allowed IPs  List'",
    "parameters_profil_ip_add_help": " To add or change an IP address, you must fill in the fields with a star <b>*</b>.",
    "send_button_profil_ip_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_profil_ip_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_profil_ip_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_playlist": "Welcome to 'Playlist  List'",
    "add_button_playlist_help": " To add a playlist, click the button    <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_playlist_help": "To see the rest of the playlist, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span></a> ",
    "search_area_playlist_help": "To search for a playlist, type the indexed word in the search box above the table at right.",
    "tri_column_playlist_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_playlist_help": "To change the playlist's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_playlist_help": "To see the playlist's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "preview_button_playlist_help": "To see the playlist, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-play' class='s18 ng-scope md-font material-icons icon-play cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_playlist_help": "To delete the playlist, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "welcome_playlist_add": "Welcome to 'Add playlist'",
    "welcome_playlist_edit": "Welcome to 'Edit playlist'",
    "parameters_playlist_add_help": " To add a playlist, you must fill in the fields with a star <b>*</b>.",
    "parameters_playlist_edit_help": " To change a playlist, you must fill in the fields with a star <b>*</b>.",
    "send_button_playlist_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_playlist_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "cancel_button_playlist_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "delete_button_playlist_add_help": "To delete a video from the chosen list, just click on <button class='md-warn md-button' style='min-width: 35px;' type='button'><md-icon md-font-icon='icon-close-circle-outline' class='s18 ng-scope md-default-theme md-font material-icons icon-close-circle-outline'></md-icon></button>",
    "list_video_playlist_add_help": "In the block <b>List of videos</b>, you will find all the videos, just click on one the button <button class='md-button md-ink-ripple md-default-theme' type='button' style='color: #039be5'><md-icon style='color: #039be5' md-font-icon='icon-plus-circle-outline' class='s18 ng-scope md-font material-icons md-default-theme icon-plus-circle-outline'></md-icon><span style='text-transform: initial;'>Add To Playlist</span></button> to be added one by one, and the video will be automatically moved to the right block <b>List of selected videos</b>.",
    "welcome_event": "Welcome to 'Events  List'",
    "add_button_event_help": " To add an event, click the button   <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_event_help": "To see the rest of the events, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_event_help": "Use the functions at the top of the screen to perform multi-criteria searches: <br><br>  <img src='assets/images/help/filter_bare_event.png'>",
    "diffusion_types_event_help": "In the top left, the button <md-icon md-font-icon='icon-calendar-multiple' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-calendar-multiple'></md-icon>  allows you to view list of events in a calendrier <br/>le bouton <md-icon md-font-icon='icon-play' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-play'></md-icon> allows you to view list of events on going <br/>le bouton <md-icon md-font-icon='icon-clock-fast' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-clock-fast'></md-icon> allows you to view list of events up coming",
    "tri_column_event_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_event_help": "To change the event's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Actions column)",
    "detail_button_event_help": "To see the event's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Actions column)",
    "export_button_event_help": "To see the event's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Actions column)",
    "stat_button_event_help": "To see the event's statistic, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Actions column)",
    "delete_button_event_help": "To remove an event, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Actions column)",
    "welcome_event_add": "Welcome to 'Add event'",
    "welcome_event_edit": "Welcome to 'Edit event'",
    "parameters_event_add_help": " To add or change an event, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_event_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "upload_button_event_add_help": " To upload a thumbnail, you must click on<button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choose thumbnail<md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon></button>",
    "cancel_button_event_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_live": "Welcome to 'Live  List'",
    "add_button_live_help": " To add a live, click the black button   <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_live_help": "To see the rest of the lives, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_live_help": "To search for a live, type the indexed word in the search box above the table at right.",
    "tri_column_live_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "buttons_live_help": " In the Action column, several actions can be applied to live: <div layout='row' layout-xs='column'><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> Edit a live <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> Live detail<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> Delete a live</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button>  Export links of a live<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-information' class='s18 ng-scope md-font material-icons icon-information cursor-initial' aria-hidden='true'></md-icon></button>Live data<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pearl-custom' class='s18 ng-scope md-default-theme md-font material-icons icon-pearl-custom'></md-icon></button>  Encoding with Pearl</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-gmail' class='s18 ng-scope md-font material-icons icon-gmail cursor-initial' aria-hidden='true'></md-icon></button> Send invitations<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> Live statistics<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-cast' class='s18 ng-scope md-font material-icons icon-cast cursor-initial' aria-hidden='true'></md-icon></button>  Add a screen share for live</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='s18 ng-scope md-font material-icons icon-comment cursor-initial' aria-hidden='true'></md-icon></button> View list comments of a live<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-camcorder-box' class='s18 ng-scope md-font material-icons icon-camcorder-box cursor-initial' aria-hidden='true'></md-icon></button> Broadcasting a live</div></div>",
    "search_tools_live_help": "Use the functions at the top of the screen to perform multi-criteria searches : <br><br>  <img src='assets/images/help/filter_bare_live.png'>",
    "welcome_live_add": "Welcome to 'Add live'",
    "welcome_live_edit": "Welcome to 'Edit live'",
    "parameters_live_add_help": " To add a live, you must fill in the fields with a star <b>*</b>.",
    "parameters_live_edit_help": " To change a live, you must fill in the fields with a star <b>*</b>.",
    "send_button_live_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_live_edit_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Validate</button> to confirm your choice.",
    "diffusion_types_live_help": "In the top left, the button <button class='md-button md-default-theme md-ink-ripple' type='button'><md-icon style='font-size: 22px;margin-top: -4px;margin-left: -10px' md-font-icon='icon-diffusion-video' class='ng-scope md-default-theme md-font material-icons icon-diffusion-video'></md-icon><span style='text-transform: initial;margin-left: 3px;'>Diffusion</span></button> allows you to view list of archived and on going lives",
    "upload_button_live_add_help": " To upload a thumbnail, you must click on<button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon>Choose thumbnail</button>",
    "upload_doc_button_live_add_help": " To upload a document, you must click on<button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon>Select document</button>",
    "cancel_button_live_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_conf_live_add": "Welcome to 'Add live'",
    "parameters_conf_live_add_help": " To add or change a live, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_conf_live_add_help": " You need to click the button <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "upload_button_conf_live_add_help": " To upload a thumbnail, you must click on<button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choose thumbnail<md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon></button>",
    "cancel_button_conf_live_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_upload_add": "Welcome to 'Media upload'",
    "button_upload_add_help": "To upload a video you must click <button class='md-button md-raised md-primary ng-scope' type='button'>CHOOSE FILE</button><br>To add the video automatically check the box<md-checkbox style = 'margin-left: 10px;' type='checkbox' class='ng-pristine ng-valid md-default-theme ng-empty ng-touched'><div class='md-container md-ink-ripple'><div class='md-icon'></div></div><div class='md-label'><label class='ng-scope'>Automatic upload</label></div></md-checkbox>",
    "welcome_video_add": "Welcome to 'Add video'",
    "parameters_video_add_help": "To add or change a video, you must fill in the fields with a star <b style='color:red'>*</b>.",
    "send_button_video_edit_help": "You need to click the button <button class='md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple md-button' type='submit' aria-label='Validate'>Validate</button> to confirm your choice.",
    "send_button_video_add_help": "You need to click the button <button class='md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple md-button' type='submit' aria-label='Validate'>Add</button> to confirm your choice.",
    "upload_button_video_add_help": "To upload a thumbnail from your PC, you must click on <button class='cta-button md-raised md-accent md-button md-default-theme md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope md-default-theme md-font material-icons icon-plus' aria-hidden='true'></md-icon><span class='ng-scope'>Choose a thumbnail</span></div></button><br>To capture a thumbnail from the video you must click on <button class='cta-button md-raised md-accent md-button ng-scope md-default-theme md-ink-ripple' type='button'><span class='ng-scope'>Make a screenshot of the vignette</span></button> at the desired time of the video.<br>To generate more thumbnails you must click on <button class='md-icon-button md-button md-default-theme md-ink-ripple' style='background-color: rgba(0, 0, 0, 0.6);border-radius: 0;margin-right: 0;width: 50px;' type='button'><md-icon md-font-icon='icon-rotate-3d' style='color:#fff' class='ng-scope md-default-theme md-font material-icons icon-rotate-3d'></md-icon></button>",
    "upload_button_video_external_add_help": "To upload a thumbnail from your PC, you must click on <button class='cta-button md-raised md-accent md-button md-default-theme md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope md-default-theme md-font material-icons icon-plus' aria-hidden='true'></md-icon><span class='ng-scope'>Choose a thumbnail</span></div></button>",
    "cancel_button_video_add_help": "To return to the list page, click the button <button class='md-raised cancel-button md-button ng-scope md-default-theme md-ink-ripple' style='background-color: #707070 !important;color: #ffffff;' type='button' >CANCEL</button>",
    "welcome_video": "Videos managment",
    "add_button_video_help": "ADD VIDEO <br> To do this, click the button at the top right <img src='assets/images/help/btn_add_vod.png' style='margin-top: -15px;'>",
    "search_tools_video_help": "SEARCH TOOLS <br> Use the functions at the top of the screen to perform multi-criteria searches: <br> <br>  <img src='assets/images/help/filter-bar.jpg'>",
    "diffusion_types_video_help": "DIFFUSION <img src='assets/images/help/btn_list.png' style='margin-top: 1px;'> <br> In the top left, the 'DIFFUSION' menu allows you to view videos by type: <br> -On going (visible videos for web users) <br> -Archived &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp(videos that have been released) <br> -Upcoming &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp (videos scheduled for next broadcast) <br> -Offline &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp(manually disabled videos) ",
    "display_types_video_help": "DISPLAY <img src='assets/images/help/btn_design.png' style='margin-top: -10px;'> <br> In the top left, the 'DISPLAY' menu allows viewing videos in 5 modes: <br> Medium List, Large List, Thumbnails, Small List, Directories.",
    "tri_column_video_help": "LISTS SORT <br> Click on the column <b>Id</b> or <b>Titre</b> to sort data.",
    "buttons_video_help": "ACTIONS <br> List of available functions (according to your rights and your profile)    <div class='ligne'><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button' style='margin-left: -33px;'><md-icon aria-hidden='true' class='sb18 ng-scope md-default-theme md-font material-icons icon-chevron-down dropdown_plus' style='font-size: 20px !important; margin-top: 5px;'></md-icon></button> Edit a video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-content-cut' class='s18 ng-scope md-font material-icons icon-content-cut cursor-initial' aria-hidden='true'></md-icon></button> Editing the video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-closed-caption' class='s18 ng-scope md-font material-icons icon-closed-caption cursor-initial' aria-hidden='true'></md-icon></button> Captions</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-rich-media'></md-icon></button>Rich Media</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-filmstrip' class='s18 ng-scope md-font material-icons icon-filmstrip cursor-initial' aria-hidden='true'></md-icon></button> Change the source video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> Video statistics</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-switch' class='s18 ng-scope md-font material-icons icon-account-switch cursor-initial' aria-hidden='true'></md-icon></button> Subscriber management</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='sb18 ng-scope md-default-theme md-font material-icons icon-quizz-custom' aria-hidden='true'></md-icon></button> View questions/quiz</div></div><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-download' class='s18 ng-scope md-font material-icons icon-download cursor-initial' aria-hidden='true'></md-icon></button> Download file</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-meta-custom'></md-icon></button> Meta-data of a video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-arrange-send-backward' class='s18 ng-scope md-font material-icons icon-arrange-send-backward cursor-initial' aria-hidden='true'></md-icon></button> Highlight (home page)</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-timer' class='s18 ng-scope md-font material-icons icon-timer cursor-initial' aria-hidden='true'></md-icon></button> Chronology of the video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> Delete a video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-ad-off-custom'></md-icon></button> Audio description</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-earth' class='s18 ng-scope md-font material-icons icon-earth cursor-initial' aria-hidden='true'></md-icon></button> Go online / offline</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='sb18 ng-scope md-default-theme md-font material-icons icon-home-on' aria-hidden='true'></md-icon></button>Add video to home videos</div></div><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> Links and URL of the video</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height: 50px;' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/youtube.png' class='ng-scope' src='assets/icons/youtube.png'></button> YouTube export</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px;' ng-src='assets/icons/dailymotion.png' class='ng-scope' src='assets/icons/dailymotion.png'></button> DailyMotion Export</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/mail.png' class='ng-scope' src='assets/icons/mail.png'></button> Send video by email</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/fb.png' class='ng-scope' src='assets/icons/fb.png'></button> Export Facebook</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/twitter.png' class='ng-scope' src='assets/icons/twitter.png'></button> Export Twitter</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/in.png' class='ng-scope' src='assets/icons/in.png'></button> Export Linkedin</div></div></div>",
    "navigation_video_help": "NAVIGATION <br> At the bottom, functions are used to adjust the display and access to the pages <br> <img src='assets/images/help/pagination__eng.jpg'>",
    "welcome_caption_add": "Welcome to 'Video caption'",
    "begin_button_caption_add_help": "To create subtitles, you must click the button <button class='md-accent md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-microphone-variant' class='ng-scope cursor-initial md-font material-icons icon-microphone-variant' ></md-icon>Start caption</button> to mark the start time subtitling.Then click <button class='md-warn md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-microphone-variant-off' class='ng-scope cursor-initial md-font material-icons icon-microphone-variant-off'></md-icon>End caption</button> to mark the end of time subtitling.",
    "delete_button_caption_add_help": "To delete a subtitling, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-close' class='s18 ng-scope md-font material-icons icon-close cursor-initial' style='color:red' aria-hidden='true'></md-icon></button> ",
    "valider_button_caption_add_help": "You need to click the button <button class='md-primary md-raised md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-check' class='ng-scope cursor-initial md-font material-icons icon-check'></md-icon> Validate modifications</button> to confirm your choice",
    "upload_button_caption_add_help": "To upload a caption file, you must click on <button class='md-accent md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choose file</button>",
    "cancel_button_caption_add_help": "To return to the list page, click the button <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Cancel</button>",
    "welcome_display": "Welcome to 'Display  List'",
    "add_button_display_help": " To add a display, click the black button   <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>that will guide you to the form.",
    "arrow_button_display_help": "To see the rest of the display, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_display_help": "To search for a display, type the indexed word in the search box above the table at right.",
    "tri_column_display_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_display_help": "To change the display's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_display_help": "To see the display's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_display_help": "To see the display's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_display_help": "To remove a display, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_display_add": "Welcome to 'Add display'",
    "welcome_display_edit": "Welcome to 'Edit display'",
    "welcome_calendar": "Welcome to 'Calendar'",
    "display_calendar_today": " To display the calendar of today, click on   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-today' class='s18 ng-scope md-font material-icons icon-calendar-today cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_day": " To display the calendar of one day, click on  <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-day' class='s18 ng-scope md-font material-icons icon-view-day cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_week": " To display the calendar of one week, click on   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-week' class='s18 ng-scope md-font material-icons icon-view-week cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_month": " To display the calendar of one month, click on  <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-module' class='s18 ng-scope md-font material-icons icon-view-module cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_next_prev": " To go to the next/previous day/week/month, use   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chevron-left' class='s18 ng-scope md-font material-icons icon-chevron-left cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> and <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chevron-right' class='s18 ng-scope md-font material-icons icon-chevron-right cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_list_schedules": " To display schedules in datatable mode, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_edit_schedule": " <div class='ligne'><div class='colonne'> <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-today' class='s18 ng-scope md-font material-icons icon-calendar-today cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>  the calendar of today</div>    <div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-day' class='s18 ng-scope md-font material-icons icon-view-day cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> the calendar of one day</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-week' class='s18 ng-scope md-font material-icons icon-view-week cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> the calendar of one week</div>   <div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-module' class='s18 ng-scope md-font material-icons icon-view-module cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> the calendar of one month</div></div>",
    "welcome_tem_manager": "Welcome to 'Template manager'",
    "add_button_manager_help": " To add a manager, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_manager_help": "To see the rest of the managers, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_manager_help": "To search for a manager, type the indexed word in the search box above the table at right.",
    "tri_column_manager_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_manager_help": "To change the manager's data, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_manager_help": "To open the template, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_manager_help": "To remove a manager, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "export_button_manager_help": "To see the manager's export links, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-export' class='s18 ng-scope md-font material-icons icon-export cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "welcome_manager_add": "Welcome to 'Add manager'",
    "welcome_manager_edit": "Welcome to 'Edit manager'",
    "welcome_schedule": "Welcome to 'Schedules  List'",
    "add_button_schedule_help": " To add a schedule, click the button <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Add</span></div></button>",
    "arrow_button_schedule_help": "To see the rest of the schedules, click  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Next</span><div class='md-ripple-container'></div></a> that you can find below the table to move to the next page.To return to the previous page, click on the  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Previous</span><div class='md-ripple-container'></div></a> ",
    "search_area_schedule_help": "To search for a schedule, type the indexed word in the search box above the table at right.",
    "tri_column_schedule_help": "If you notice, there are arrows <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> to the right of each column, although it's arrows are here to help you sort the list.",
    "edit_button_schedule_help": "To change a schedule, you must click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_schedule_help": "To remove a schedule, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "open_button_schedule_help": "To open a schedule, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "refresh_button_schedule_help": "To refresh the display on the box, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-refresh' class='s18 ng-scope md-font material-icons icon-refresh cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "calendar_button_schedule_help": "To display schedules in calendar mode, simply click the button <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-multiple' class='s18 ng-scope md-font material-icons icon-calendar-multiple cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "welcome_schedule_add": "Welcome to 'Add schedule'",
    "welcome_schedule_edit": "Welcome to 'Edit schedule'",
    "schedule_add_help": " To add or edit a schedule, you must fill in the fields with a star <b>*</b> and move the programs in the calendar.",
    "schedule_associate_help": "To associate a  schedule to an Rmbox or an Rmbox group , simply click the button <button style='text-transform: initial;' class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Attribute</button> and select the element to associate.",
    "send_button_schedule_add_help": " You need to click the button <button style='text-transform: initial;' class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Add</button> to confirm your choice.",
    "send_button_schedule_edit_help": " You need to click the button <button style='text-transform: initial;' class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Update</button> to confirm your choice."

  }
}
);

$translateProvider.translations("fr", {
  "HELP": {
    "welcome_group": "Bienvenue sur 'Liste des groupes'",
    "add_button_group_help": "Pour  ajouter un groupe , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_group_help": "Pour voir le reste des groupes, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_group_help": "Pour chercher un groupe, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_group_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_group_help": "Pour modifier les informations d'un groupe, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_group_help": "Pour visualiser les informations d'un groupe, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_group_help": "Pour supprimer un groupe, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_group_add": "Bienvenue sur 'Ajouter un groupe'",
    "welcome_group_edit": "Bienvenue sur 'Modifier un groupe'",
    "welcome_group_permission": "Bienvenue sur 'Liste des modules de permission'",
    "add_button_group_permission_help": "Pour  ajouter une permmession , cochez la case <button class='md-fab cursor-initial md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-checkbox-marked-outline' class='ng-scope cursor-initial md-font material-icons icon-checkbox-marked-outline' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>.",
    "parameters_group_add_help": "Pour ajouter ou modifier un groupe, vous devez remplir le formulaire.",
    "parameters_group_import_help": "Pour importer une liste de groupe, cliquez sur le bouton <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choisir un fichier</span></button> pour importer un fichier CSV.",
    "send_button_group_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_group_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_group_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_user": "Bienvenue sur 'Liste des utilisateurs'",
    "add_button_user_help": "Pour  ajouter un utilisateur , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "parameters_user_import_help": "Pour importer une liste d'utilisateur, cliquez sur le bouton <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choisir un fichier</span></button> pour importer un fichier CSV.",
    "arrow_button_user_help": "Pour voir le reste des utilisateurs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_user_help": "Pour chercher un utilisateur, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_user_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_user_help": "Pour modifier les informations d'un utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_user_help": "Pour visualiser les informations d'un utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_user_help": "Pour supprimer un utilisateur, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_user_add": "Bienvenue sur 'Ajouter un utilisateur'",
    "welcome_user_edit": "Bienvenue sur 'Modifier un utilisateur'",
    "parameters_user_add_help": "Pour ajouter ou modifier un utilisateur, vous devez remplir le formulaire.",
    "send_button_user_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_user_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_user_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_rmbox": "Bienvenue sur 'RmBox'",
    "add_button_rmbox_help": "Pour  ajouter un RmBox , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_rmbox_help": "Pour voir le reste des RmBoxs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_rmbox_help": "Pour chercher un RmBox, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_rmbox_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_rmbox_help": "Pour modifier les informations d'un RmBox, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_rmbox_help": "Pour visualiser les informations d'un RmBox, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "pdf_button_rmbox_help": "Pour visualiser l'historique des rapports envoy\u00e9s, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-file-pdf-box' class='s18 ng-scope md-font material-icons icon-file-pdf-box cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_rmbox_help": "Pour supprimer un RmBox, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "actions_button_rmbox_help": "<div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Modifier Rmbox</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Visualiser Rmbox</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Supprimer Rmbox</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-file-pdf-box' class='s18 ng-scope md-font material-icons icon-file-pdf-box cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Visualiser l'historique des rapports envoyés</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-refresh' class='s18 ng-scope md-font material-icons icon-refresh cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Actualiser l'affichage sur Rmbox</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Visualiser la grille des programmes associée</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-wifi' class='s18 ng-scope md-font material-icons icon-wifi cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Changer chaine active sur Rmbox</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Associer une grille des programmes</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon-worker' class='s18 ng-scope md-font material-icons icon-worker cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> Visualiser la liste des interventions</div></div>",
    "welcome_rmbox_add": "Bienvenue sur 'Ajouter RmBox'",
    "welcome_rmbox_edit": "Bienvenue sur 'Modifier RmBox'",
    "parameters_rmbox_add_help": "Pour ajouter ou modifier un RmBox, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_rmbox_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_rmbox_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_rmbox_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_rmbox_group": "Bienvenue sur 'Groupe RmBox'",
    "add_button_rmbox_group_help": "Pour  ajouter un groupe RmBox , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_rmbox_group_help": "Pour voir le reste des groupes RmBoxs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_rmbox_group_help": "Pour chercher un groupe RmBox, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_rmbox_group_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_rmbox_group_help": "Pour modifier les informations d'un groupe RmBox, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_rmbox_group_help": "Pour visualiser les informations d'un groupe RmBox, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_rmbox_group_help": "Pour supprimer un groupe RmBox, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "associate_schedule_button_rmbox_group_help": "Pour associer une grille des programmes à un groupe RmBox, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_rmbox_group_add": "Bienvenue sur 'Ajouter groupe RmBox'",
    "welcome_rmbox_group_edit": "Bienvenue sur 'Modifier groupe RmBox'",
    "parameters_rmbox_group_add_help": "Pour ajouter ou modifier un groupe RmBox, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_rmbox_group_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_rmbox_group_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_rmbox_group_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_zone": "Bienvenue sur 'Liste zones'",
    "add_button_zone_help": "Pour  ajouter une zone , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_zone_help": "Pour voir le reste des zones, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_zone_help": "Pour chercher une zone, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_zone_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_zone_help": "Pour modifier les informations d'une zone, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_zone_help": "Pour visualiser les informations d'une zone, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_zone_help": "Pour supprimer une zone, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "stat_button_zone_help": "Pour consulter les statistiques par zone, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_zone_add": "Bienvenue sur 'Ajouter zone'",
    "welcome_zone_edit": "Bienvenue sur 'Modifier zone'",
    "parameters_zone_add_help": "Pour ajouter ou modifier une zone, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_zone_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_zone_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_zone_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "zone_import_help": "Pour importer une liste de zone, cliquez sur le bouton <button class='md-button md-default-theme md-ink-ripple' type='button'><span style='text-transform: initial;font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f;'>Choisir un fichier</span></button> pour importer un fichier CSV.",
    "welcome_canal": "Bienvenue sur 'Liste cannaux'",
    "add_button_canal_help": "Pour ajouter un canal , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_canal_help": "Pour voir le reste des cannaux, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_canal_help": "Pour chercher un canal, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_canal_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_canal_help": "Pour modifier les informations d'un canal, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_canal_help": "Pour visualiser les informations d'un canal, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "stockage_button_canal_help": "Pour visualiser les stockages des serveurs d'un canal, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-floppy' class='s18 ng-scope md-font material-icons icon-floppy cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_canal_help": "Pour visualiser les liens d'export d'un canal, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_canal_help": "Pour supprimer une canal, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_canal_add": "Bienvenue sur 'Ajouter canal'",
    "welcome_canal_edit": "Bienvenue sur 'Modifier canal'",
    "parameters_canal_add_help": "Pour ajouter ou modifier une canal, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_canal_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_canal_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_theme": "Bienvenue sur 'Liste themes'",
    "add_button_theme_help": "Pour ajouter un theme , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_theme_help": "Pour voir le reste des themes, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_theme_help": "Pour chercher un theme, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_theme_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_theme_help": "Pour modifier les informations d'un theme, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_theme_help": "Pour visualiser les informations d'un theme, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_theme_help": "Pour visualiser les liens d'export d'un theme, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_theme_help": "Pour supprimer un theme, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_theme_add": "Bienvenue sur 'Ajouter theme'",
    "welcome_theme_edit": "Bienvenue sur 'Modifier theme'",
    "parameters_theme_add_help": "Pour ajouter ou modifier un theme, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_theme_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_theme_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_theme_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_mooc_config": "Bienvenue sur 'Liste des configurations Mooc'",
    "add_button_mooc_config_help": "Pour ajouter une configuration Mooc , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "welcome_client": "Bienvenue sur 'Liste des paramètres de configuration client'",
    "add_button_client_help": "Pour ajouter un paramètre de configuration client , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_client_help": "Pour voir le reste des paramètres, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_client_help": "Pour chercher un paramètre de configuration client, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_client_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_client_help": "Pour modifier les informations d'un paramètre de configuration client, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_client_help": "Pour visualiser les informations d'un paramètre de configuration client, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_client_help": "Pour supprimer un paramètre de configuration client, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_client_add": "Bienvenue sur 'Ajouter paramètre de configuration client'",
    "welcome_client_edit": "Bienvenue sur 'Modifier paramètre de configuration client'",
    "parameters_client_add_help": "Pour ajouter ou modifier un paramètre de configuration client, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_client_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_client_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_client_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_player": "Bienvenue sur 'Liste des paramètres de configuration player'",
    "add_button_player_help": "Pour ajouter un paramètre de configuration player , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_player_help": "Pour voir le reste des paramètres, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_player_help": "Pour chercher un paramètre de configuration player, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_player_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_player_help": "Pour modifier les informations d'un paramètre de configuration player, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_player_help": "Pour visualiser les informations d'un paramètre de configuration player, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_player_help": "Pour supprimer un paramètre de configuration player, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_news": "Bienvenue sur 'Liste d'actualités'",
    "add_button_news_help": "Pour ajouter une actualité , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_news_help": "Pour voir le reste des actualités, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_news_help": "Pour chercher une actualité, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_news_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_news_help": "Pour modifier une actualité, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_news_help": "Pour supprimer une actualité, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_news_add": "Bienvenue sur 'Ajouter actualité'",
    "welcome_news_edit": "Bienvenue sur 'Modifier actualité'",
    "parameters_news_add_help": "Pour ajouter ou modifier une actualité, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_news_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_news_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_news_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",

    "welcome_general": "Bienvenue sur 'Liste g\u00e9n\u00e9rals'",
    "add_button_general_help": "Pour  ajouter un g\u00e9n\u00e9ral , cliquez sur le bouton noir \u00e0 droite <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>qui va vous orienter au formulaire d'ajout.",
    "arrow_button_general_help": "Pour voir le reste des g\u00e9n\u00e9rals, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_general_help": "Pour chercher un g\u00e9n\u00e9ral, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_general_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_general_help": "Pour modifier les informations d'un g\u00e9n\u00e9ral, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_general_help": "Pour visualiser les informations d'un g\u00e9n\u00e9ral, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_general_help": "Pour visualiser les liens d'export d'un g\u00e9n\u00e9ral, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_general_help": "Pour supprimer un g\u00e9n\u00e9ral, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_general_add": "Bienvenue sur 'Ajouter g\u00e9n\u00e9ral'",
    "parameters_general_add_help": "Pour ajouter ou modifier un g\u00e9n\u00e9ral, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_general_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_general_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_preset": "Bienvenue sur 'Liste presets'",
    "add_button_preset_help": "Pour ajouter un preset , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_preset_help": "Pour voir le reste des presets, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_preset_help": "Pour chercher un preset, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_preset_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_preset_help": "Pour modifier les informations d'un preset, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_preset_help": "Pour visualiser les informations d'un preset, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_preset_help": "Pour visualiser les liens d'export d'un preset, il faut cliquer sur le bouton  <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_preset_help": "Pour supprimer un preset, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_preset_add": "Bienvenue sur 'Ajouter preset'",
    "welcome_preset_edit": "Bienvenue sur 'Modifier preset'",
    "parameters_preset_add_help": "Pour ajouter ou modifier un preset, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_preset_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_preset_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_preset_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_server": "Bienvenue sur 'Liste des serveurs'",
    "add_button_server_help": "Pour  ajouter un serveur , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_server_help": "Pour voir le reste des serveurs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_server_help": "Pour chercher un serveur, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_server_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_server_help": "Pour modifier les informations d'un serveur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_server_help": "Pour visualiser les liens d'export d'un serveur, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_server_help": "Pour visualiser les informations d'un serveur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_server_help": "Pour supprimer un serveur, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_server_add": "Bienvenue sur 'Ajouter serveur'",
    "welcome_server_edit": "Bienvenue sur 'Modifier serveur'",
    "parameters_server_add_help": "Pour ajouter ou modifier un serveur, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_server_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_server_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_server_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_direction": "Bienvenue sur 'Liste directions'",
    "add_button_direction_help": "Pour  ajouter une direction , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_direction_help": "Pour voir le reste des directions, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_direction_help": "Pour chercher une direction, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_direction_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_direction_help": "Pour modifier les informations d'une direction, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_direction_help": "Pour visualiser les liens d'export d'une direction, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "detail_button_direction_help": "Pour visualiser les informations d'une direction, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_direction_help": "Pour supprimer une direction, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_direction_add": "Bienvenue sur 'Ajouter direction'",
    "welcome_direction_edit": "Bienvenue sur 'Modifier direction'",
    "parameters_direction_add_help": "Pour ajouter ou modifier une direction, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_direction_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_direction_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_direction_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_iptv": "Bienvenue sur 'Liste IP-TV'",
    "add_button_iptv_help": "Pour  ajouter une IP-TV , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_iptv_help": "Pour voir le reste des IP-TV, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_iptv_help": "Pour chercher une IP-TV, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_iptv_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "export_button_iptv_help": "Pour visualiser les liens d'export d'une IP-TV, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "edit_button_iptv_help": "Pour modifier les informations d'une IP-TV, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_iptv_help": "Pour visualiser les informations d'une IP-TV, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_iptv_help": "Pour supprimer une IP-TV, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_iptv_add": "Bienvenue sur 'Ajouter IP-TV'",
    "welcome_iptv_edit": "Bienvenue sur 'Modifier IP-TV'",
    "parameters_iptv_add_help": "Pour ajouter ou modifier une IP-TV, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_iptv_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_iptv_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_iptv_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_station": "Bienvenue sur 'Liste stations'",
    "add_button_station_help": "Pour ajouter une station , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_station_help": "Pour voir le reste des station, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_station_help": "Pour chercher une station, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_station_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "export_button_station_help": "Pour visualiser les liens d'export d'une station, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "edit_button_station_help": "Pour modifier les informations d'une station, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_station_help": "Pour visualiser les informations d'une station, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_station_help": "Pour supprimer une station, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_station_add": "Bienvenue sur 'Ajouter station'",
    "welcome_station_edit": "Bienvenue sur 'Modifier station'",
    "parameters_station_add_help": "Pour ajouter ou modifier une station, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_station_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_station_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_station_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_advert": "Bienvenue sur 'Liste des publicit\u00e9s'",
    "add_button_advert_help": "Pour  ajouter une publicit\u00e9 , cliquez sur le bouton noir \u00e0 droite <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>qui va vous orienter au formulaire d'ajout.",
    "arrow_button_advert_help": "Pour voir le reste des publicit\u00e9s, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_advert_help": "Pour chercher une publicit\u00e9, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_advert_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_advert_help": "Pour modifier les informations d'une publicit\u00e9, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_advert_help": "Pour visualiser les informations d'une publicit\u00e9, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_advert_help": "Pour visualiser les liens d'export d'une publicit\u00e9, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_advert_help": "Pour supprimer une publicit\u00e9, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_advert_add": "Bienvenue sur 'Ajouter une publicit\u00e9'",
    "welcome_advert_edit": "Bienvenue sur 'Modifier la publicit\u00e9'",
    "parameters_advert_add_help": "Pour ajouter ou modifier une publicit\u00e9, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_advert_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_advert_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_comment": "Bienvenue sur 'Liste des commentaires'",
    "arrow_button_comment_help": "Pour voir le reste des commentaires, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_comment_help": "Pour chercher un commentaire, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_comment_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_comment_help": "Pour modifier les informations d'un commentaire, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "activate_button_comment_help": "Pour activer/d\u00e9sactiver un commentaire, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-thumb-up' class='s18 ng-scope md-font material-icons icon-thumb-up cursor-initial' aria-hidden='true'></md-icon></button> ou bien sur <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-thumb-down' class='s18 ng-scope md-font material-icons icon-thumb-down cursor-initial' aria-hidden='true'></md-icon></button> situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_comment_help": "Pour visualiser les liens d'export d'un commentaire, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "detail_button_comment_help": "Pour visualiser les informations d'un commentaire, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_comment_help": "Pour supprimer un commentaire, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_comment_add": "Bienvenue sur 'Modifier commentaire'",
    "parameters_comment_add_help": "Pour modifier un commentaire, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_comment_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_comment_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_sondage": "Bienvenue sur 'Liste des sondages'",
    "add_button_sondage_help": "Pour ajouter un sondage , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_sondage_help": "Pour voir le reste des sondages, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_sondage_help": "Pour chercher un sondage, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_sondage_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_sondage_help": "Pour modifier les informations d'un sondage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_sondage_help": "Pour visualiser les informations d'un sondage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_sondage_button_help": "Pour visualiser les d\u00e9tails d'un sondage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-histogram' class='s18 ng-scope md-font material-icons icon-chart-histogram cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "download_button_sondage_help": "Pour t\u00e9l\u00e9charger les d\u00e9tails d'un sondage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-download' class='s18 ng-scope md-font material-icons icon-download cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_sondage_help": "Pour visualiser les liens d'export d'un sondage, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_sondage_help": "Pour supprimer un sondage, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_sondage_add": "Bienvenue sur 'Ajouter un sondage'",
    "welcome_sondage_edit": "Bienvenue sur 'Modifier le sondage'",
    "parameters_sondage_add_help": "Pour ajouter ou modifier un sondage, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "parameters_sondage_add_question_help": "Pour ajouter une question, vous devez cliquer sur le bouton <button class='md-accent md-raised md-hue-1 md-button ng-scope md-default-theme md-ink-ripple' type='button'><span class='ng-binding ng-scope'>  Ajouter une question</span></button> ",
    "parameters_sondage_delete_question_help": "Pour supprimer une question, vous devez cliquer sur le bouton <button class='md-raised md-warn md-button ng-scope md-default-theme md-in-ripple' type='button'><span class='ng-binding ng-scope'> Supprimer</span></button> ",
    "send_button_sondage_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_sondage_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_sondage_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_vote_details": "Bienvenue sur 'D\u00e9tails vote'",
    "stat_zoom_message": "Cliquez sur le bouton gauche et faire glisser la souris pour effectuer un zoom avant.Pour d\u00e9filer le graphe \u00E0 droite ou \u00E0 gauche, maintenez la touche Shift enfonc\u00e9e pendant que vous faites glisser la souris.",
    "welcome_vote_details_stats": "Bienvenue sur 'D\u00e9tails de statistique'",
    "form_attr_Statistique_audience": "Ceci est un aperçu de l'\u00e9volution de la visite.<br><b>Visites: </b>représente le nombre de vues d'une vid\u00e9o sur une p\u00e9riode d\u00e9termin\u00e9e.<br><b>Visiteurs uniques: </b>Le nombre de visiteurs uniques visitant votre site web. Chaque utilisateur n'est comptabilis\u00e9 qu'une seule fois, même s'il visite le site web plusieurs fois dans une journ\u00e9e.<br><b>Nombre de vue par visiteur: </b>Nombre de vue effectu\u00e9es par vos visiteurs.",
    "form_attr_Statistique_duree": "Ce rapport montre les <b>dur\u00e9es de visites</b> de vos visiteurs.",
    "form_attr_Statistique_duree_visite": "Ce rapport montre les <b>dur\u00e9es de visites</b> de vos visiteurs.",
    "form_attr_Statistique_plus_populaire": "Ce rapport montre les <b>vid\u00e9os</b> les plus populaires.",
    "form_attr_Statistique_map": "Ce rapport montre dans quel pays vos visiteurs \u00e9taient quand ils ont acc\u00e9d\u00e9 à votre vid\u00e9os.",
    "form_attr_Statistique_os": "Ce rapport montre les <b>syst\u00e8mes d'exploitation</b> les plus communes de vos visiteurs.",
    "form_attr_Statistique_navigateur": "Ce rapport contient des informations à propos de quel type de navigateur vos visiteurs utilisent. Chaque version du navigateur est list\u00e9e s\u00e9par\u00e9ment.",
    "form_attr_Statistique_referrer": "Ce rapport montre les <b>sites web</b> les plus visit\u00e9s par vos visiteurs.",
    "form_attr_Statistique_device": "Ce rapport montre les <b>types des p\u00e9riph\u00e9riques</b> les plus communes de vos visiteurs.",
    "arrow_button_vote_details_help": "Pour voir le reste des questions, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "tri_column_vote_details_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "welcome_sondage_details": "Bienvenue sur 'D\u00e9tails vote'",
    "arrow_button_sondage_details_help": "Pour voir le reste des questions, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "tri_column_sondage_details_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "detail_sondage_details_button_help": "Pour visualiser les détails de sondage, vous devez cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-histogram' class='s18 ng-scope md-font material-icons icon-chart-histogram cursor-initial' aria-hidden='true'></md-icon></button>in the same line (in the Action column)",
    "welcome_profil_user": "Bienvenue sur 'Liste utilisateurs'",
    "add_button_profil_user_help": "Pour  ajouter un utilisateur , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_profil_user_help": "Pour voir le reste des utilisateurs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_profil_user_help": "Pour chercher un utilisateur, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_profil_user_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_profil_user_help": "Pour modifier les informations d'un utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "editpwd_button_profil_user_help": "Pour modifier le mot de passe d'un utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-lock' class='s18 ng-scope md-font material-icons icon-lock cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_profil_user_help": "Pour visualiser les informations d'un utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "activate_button_profil_user_help": "Pour activer/d\u00e9sactiver un un compte utilisateur, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-check' class='s18 ng-scope md-font material-icons icon-account-check cursor-initial' aria-hidden='true'></md-icon></button> ou bien sur <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-remove' class='s18 ng-scope md-font material-icons icon-account-remove cursor-initial' aria-hidden='true'></md-icon></button> situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_profil_user_help": "Pour visualiser les liens d'export d'un utilisateur, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_user_help": "Pour supprimer un utilisateur, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_profil_user_add": "Bienvenue sur 'Ajouter utilisateur'",
    "welcome_profil_user_edit": "Bienvenue sur 'Modifier utilisateur'",
    "parameters_profil_user_add_help": "Pour ajouter ou modifier un utilisateur, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_profil_user_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_profil_user_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_profil_user_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_editpwd_add": "Bienvenue sur 'Modifier mot de passe'",
    "parameters_editpwd_add_help": "Pour modifier un mot de passe, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_editpwd_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_editpwd_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_profil_group": "Bienvenue sur 'Liste groupes'",
    "add_button_profil_group_help": "Pour  ajouter un groupe , cliquez sur le bouton noir \u00e0 droite <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon></button>qui va vous orienter au formulaire d'ajout.",
    "arrow_button_profil_group_help": "Pour voir le reste des groupes, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_profil_group_help": "Pour chercher un groupe, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_profil_group_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "permission_button_profil_group_help": "Pour g\u00e9rer les permissions, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-lock-unlocked' class='s18 ng-scope md-font material-icons icon-lock-unlocked cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "edit_button_profil_group_help": "Pour modifier les informations d'un groupe, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_profil_group_help": "Pour visualiser les informations d'un groupe, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_profil_group_help": "Pour visualiser les liens d'export d'un groupe, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_group_help": "Pour supprimer un groupe, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_profil_group_add": "Bienvenue sur 'Ajouter groupe'",
    "parameters_profil_group_add_help": "Pour ajouter ou modifier un groupe, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_profil_group_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "cancel_button_profil_group_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_profil_ip": "Bienvenue sur 'Liste IPs'",
    "add_button_profil_ip_help": "Pour  ajouter une adresse IP , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_profil_ip_help": "Pour voir le reste des IPs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_profil_ip_help": "Pour chercher une adresse IP, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_profil_ip_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_profil_ip_help": "Pour modifier les informations d'une adresse IP, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_profil_ip_help": "Pour visualiser les informations d'une adresse IP, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_profil_ip_help": "Pour visualiser les liens d'export d'une adresse IP, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> in the same line (in the Action column)",
    "delete_button_profil_ip_help": "Pour supprimer une adresse IP, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_profil_ip_add": "Bienvenue sur 'Ajouter adresse IP'",
    "welcome_boitier_autorise_ip_add": "Bienvenue sur 'Ajouter adresse IP autorisée'",
    "welcome_profil_ip_edit": "Bienvenue sur 'Modifier adresse IP'",
    "welcome_boitier_autorise_ip_edit": "Bienvenue sur 'Modifier adresse IP autorisée'",
    "welcome_boitier_autorise_ip": "Bienvenue sur 'Liste IPs autorisées'",
    "parameters_profil_ip_add_help": "Pour ajouter ou modifier une adresse IP, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_profil_ip_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_profil_ip_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_profil_ip_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_playlist": "Bienvenue sur 'Liste playlist'",
    "add_button_playlist_help": "Pour ajouter une playlist , cliquez sur le bouton droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_playlist_help": "Pour voir le reste des playlist, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span></a>",
    "search_area_playlist_help": "Pour chercher une playlist, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_playlist_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_playlist_help": "Pour modifier les informations d'une playlist, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "detail_button_playlist_help": "Pour visualiser les informations d'une playlist, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "preview_button_playlist_help": "Pour visualiser une playlist, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-play' class='s18 ng-scope md-font material-icons icon-play cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "delete_button_playlist_help": "Pour supprimer une playlist, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "welcome_playlist_add": "Bienvenue sur 'Ajouter playlist'",
    "welcome_playlist_edit": "Bienvenue sur 'Modifier playlist'",
    "parameters_playlist_add_help": "Pour ajouter une playlist, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "parameters_playlist_edit_help": "Pour modifier une playlist, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_playlist_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_playlist_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "cancel_button_playlist_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "delete_button_playlist_add_help": "Pour supprimer une vid\u00e9o de la liste choisie, il suffit de cliquer sur<button class='md-warn md-button' style='min-width: 35px;' type='button'><md-icon md-font-icon='icon-close-circle-outline' class='s18 ng-scope md-default-theme md-font material-icons icon-close-circle-outline'></md-icon></button>",
    "list_video_playlist_add_help": "Dans le bloc <b>Liste des vid\u00e9os</b> , vous trouvez toutes les vid\u00e9os disponibles. Pour ajouter au playlist, il suffit de cliquer sur le bouton <button class='md-button md-ink-ripple md-default-theme' type='button' style='color: #039be5'><md-icon style='color: #039be5' md-font-icon='icon-plus-circle-outline' class='s18 ng-scope md-font material-icons md-default-theme icon-plus-circle-outline'></md-icon><span style='text-transform: initial;'>Ajouter à la Playlist</span></button> de la vid\u00e9o de votre choix: elle sera automatiquement ajout\u00e9e dans le bloc \u00e0 droite <b>Liste des vid\u00e9os s\u00e9lectionn\u00e9es</b>.",
    "welcome_event": "Bienvenue sur 'Liste \u00e9v\u00e9nements'",
    "add_button_event_help": "Pour  ajouter un \u00e9v\u00e9nement , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_event_help": "Pour voir le reste des \u00e9v\u00e9nements, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_event_help": "Utilisez les fonctions en haut de l'\u00e9cran pour effectuer des recherches multi crit\u00e8res : <br><br>  <img src='assets/images/help/filter_bare_event.png'>",
    "diffusion_types_event_help": "En haut \u00e0 gauche, le bouton <md-icon md-font-icon='icon-calendar-multiple' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-calendar-multiple'></md-icon> permet de visualiser les \u00e9v\u00e9nements en mode calendrier <br/>le bouton <md-icon md-font-icon='icon-play' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-play'></md-icon> permet de visualiser les \u00e9v\u00e9nements en cours <br/>le bouton <md-icon md-font-icon='icon-clock-fast' style='margin: 0 10px;' class='ng-scope md-default-theme md-font material-icons icon-calendar-multiple icon-clock-fast'></md-icon> permet de visualiser les \u00e9v\u00e9nements à venir",
    "tri_column_event_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_event_help": "Pour modifier les informations d'un \u00e9v\u00e9nement, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "detail_button_event_help": "Pour visualiser les informations d'un \u00e9v\u00e9nement, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "export_button_event_help": "Pour visualiser les liens d'export d'un \u00e9v\u00e9nement, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "stat_button_event_help": "Pour visualiser les statistiques d'un \u00e9v\u00e9nement, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "delete_button_event_help": "Pour supprimer un \u00e9v\u00e9nement, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne Actions)",
    "welcome_event_add": "Bienvenue sur 'Ajouter \u00e9v\u00e9nement'",
    "welcome_event_edit": "Bienvenue sur 'Modifier \u00e9v\u00e9nement'",
    "parameters_event_add_help": "Pour ajouter ou modifier un \u00e9v\u00e9nement, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_event_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "upload_button_event_add_help": "Pour t\u00e9l\u00e9charger une vignette vous devez cliquer sur <button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choisir une vignette<md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon></button>",
    "cancel_button_event_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_live": "Bienvenue sur 'Liste directs'",
    "add_button_live_help": "Pour  ajouter un direct , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_live_help": "Pour voir le reste des directs, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_live_help": "Pour chercher un direct, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_live_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "buttons_live_help": "Dans la colonne d'action, plusieurs actions peuvent \u00eatre appliqu\u00e9es au direct <div layout='row' layout-xs='column'><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button> Modifier un direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon></button> D\u00e9tail d'un direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> Supprimer un direct</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> Liens d'export d'un direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-information' class='s18 ng-scope md-font material-icons icon-information cursor-initial' aria-hidden='true'></md-icon></button> Informations du direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pearl-custom' class='s18 ng-scope md-default-theme md-font material-icons icon-pearl-custom'></md-icon></button> Encodage avec Pearl</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-gmail' class='s18 ng-scope md-font material-icons icon-gmail cursor-initial' aria-hidden='true'></md-icon></button> Envoyer des invitations<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> Statistiques d'un direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-cast' class='s18 ng-scope md-font material-icons icon-cast cursor-initial' aria-hidden='true'></md-icon></button> Ajouter un partage d'\u00e9cran pour direct</div><div flex><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='s18 ng-scope md-font material-icons icon-comment cursor-initial' aria-hidden='true'></md-icon></button> Visualiser la liste des commentaires d'un direct<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-camcorder-box' class='s18 ng-scope md-font material-icons icon-camcorder-box cursor-initial' aria-hidden='true'></md-icon></button> Diffusion d'un direct</div></div>",
    "search_tools_live_help": "SEARCH TOOLS <br> Use the functions at the top of the screen to perform multi-criteria searches: <br> <br>  <img src='assets/images/help/filter_bare_live.png'>",
    "welcome_live_add": "Bienvenue sur 'Ajouter direct'",
    "welcome_live_edit": "Bienvenue sur 'Modifier direct'",
    "parameters_live_add_help": "Pour ajouter un direct, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "parameters_live_edit_help": "Pour modifier un direct, vous devez remplir les champs portant une \u00e9toile <b>*</b>.",
    "send_button_live_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_live_edit_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Valider</button> pour valider vos choix.",
    "diffusion_types_live_help": "En haut \u00e0 gauche, le menu <button class='md-button md-default-theme md-ink-ripple' type='button'><md-icon style='font-size: 22px;margin-top: -4px;margin-left: -10px' md-font-icon='icon-diffusion-video' class='ng-scope md-default-theme md-font material-icons icon-diffusion-video'></md-icon><span style='text-transform: initial;margin-left: 3px;'>Diffusion</span></button> permet de visualiser les directs archivés et les direct en cours",
    "upload_button_live_add_help": "Pour t\u00e9l\u00e9charger une vignette vous devez cliquer sur <button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon>Choisir une vignette</button>",
    "upload_doc_button_live_add_help": "Pour t\u00e9l\u00e9charger un document vous devez cliquer sur <button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon>S\u00e9lection document</button>",
    "cancel_button_live_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_conf_live_add": "Bienvenue sur 'Ajouter configuration direct'",
    "parameters_conf_live_add_help": "Pour modifier une configuration direct, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_conf_live_add_help": "Vous devez cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "upload_button_conf_live_add_help": "Pour t\u00e9l\u00e9charger une vignette vous devez cliquer sur <button class='add-file-button md-primary md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choisir une vignette<md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' ></md-icon></button>",
    "cancel_button_conf_live_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_upload_add": "Bienvenue sur 'T\u00e9l\u00e9chargement m\u00e9dia'",
    "button_upload_add_help": "Pour t\u00e9l\u00e9charger une vid\u00e9o vous devez cliquer sur <button class='md-button md-raised md-primary ng-scope' type='button'>Choisir un fichier</button><br>Pour ajouter la vid\u00e9o automatiquement cocher la case <md-checkbox style = 'margin-left: 10px;' type='checkbox' class='ng-pristine ng-valid md-default-theme ng-empty ng-touched'><div class='md-container md-ink-ripple'><div class='md-icon'></div></div><div class='md-label'><label class='ng-scope'>Ajout automatique</label></div></md-checkbox>",
    "welcome_video_add": "Bienvenue sur 'Ajouter vid\u00e9o'",
    "parameters_video_add_help": "Pour modifier une vid\u00e9o, vous devez remplir les champs portant une \u00e9toile <b style='color:red'>*</b>.",
    "send_button_video_edit_help": "Vous devez cliquer sur le bouton <button class='md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple md-button' type='submit' aria-label='Validate'>Valider</button> pour valider vos choix.",
    "send_button_video_add_help": "Vous devez cliquer sur le bouton <button class='md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple md-button' type='submit' aria-label='Validate'>Ajouter</button> pour valider vos choix.",
    "upload_button_video_add_help": "Pour t\u00e9l\u00e9charger une vignette à partir de votre PC vous devez cliquer sur <button class='cta-button md-raised md-accent md-button md-default-theme md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope md-default-theme md-font material-icons icon-plus' aria-hidden='true'></md-icon><span class='ng-scope'>Choisir une vignette</span></div></button><br>Pour capturer une vignette \u00e0 partir de la vid\u00e9o vous devez cliquer sur <button class='cta-button md-raised md-accent md-button ng-scope md-default-theme md-ink-ripple' type='button'><span class='ng-scope'>Faire une capture de la vignette</span></button> \u00e0 l'instant voulu de la vid\u00e9o.<br>Pour g\u00e9n\u00e9rer plus de vignettes vous devez cliquer sur <button class='md-icon-button md-button md-default-theme md-ink-ripple' style='background-color: rgba(0, 0, 0, 0.6);border-radius: 0;margin-right: 0;width: 50px;' type='button'><md-icon md-font-icon='icon-rotate-3d' style='color:#fff' class='ng-scope md-default-theme md-font material-icons icon-rotate-3d'></md-icon></button>",
    "upload_button_video_external_add_help": "Pour t\u00e9l\u00e9charger une vignette à partir de votre PC vous devez cliquer sur <button class='cta-button md-raised md-accent md-button md-default-theme md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope md-default-theme md-font material-icons icon-plus' aria-hidden='true'></md-icon><span class='ng-scope'>Choisir une vignette</span></div></button>",
    "cancel_button_video_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-raised cancel-button md-button ng-scope md-default-theme md-ink-ripple' style='background-color: #707070 !important;color: #ffffff;' type='button' >Annuler</button>",
    "welcome_video": "Gestion des vid\u00e9os",
    "add_button_video_help": "AJOUTER UNE VIDEO <br> Pour cela, cliquez sur le bouton en haut \u00e0 droite <img src='assets/images/help/btn_add_vod.png' style='margin-top: -15px;'>",
    "search_tools_video_help": "Utilisez les fonctions en haut de l'\u00e9cran pour effectuer des recherches multi crit\u00e8res : <br><br>  <img src='assets/images/help/filter-bar.jpg'>",
    "diffusion_types_video_help": "DIFFUSION  <img src='assets/images/help/btn_list.png' style='margin-top: 1px;'> <br> En haut \u00e0 gauche, le menu 'DIFFUSION' permet de visualiser les vid\u00e9os par type : <br> -En cours de diffusion (vid\u00e9os visibles pour les internautes) <br> -Archiv\u00e9es &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp(vid\u00e9os dont la diffusion est termin\u00e9e) <br> -A venir &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp&nbsp (vid\u00e9os programm\u00e9es pour une diffusion prochaine) <br> -Hors ligne &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp(vid\u00e9os d\u00e9sactiv\u00e9es manuellement) ",
    "display_types_video_help": "AFFICHAGE <img src='assets/images/help/btn_design.png' style='margin-top: -10px;'> <br> En haut \u00e0 gauche, le menu 'AFFICHAGE' permet de visualiser les vid\u00e9os selon 5 modes : <br> Liste en taille moyenne, Liste en grande taille, Vignettes, Liste en petite taille, R\u00e9pertoires.",
    "tri_column_video_help": "TRI DES LISTES <br> Cliquez sur la colonne <b>Id</b> ou <b>Titre</b> pour trier les donn\u00e9es.",
    "buttons_video_help": "ACTIONS <br> Liste des fonctions disponibles (selon vos droits et votre profil)     <div class='ligne'><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon></button><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button' style='margin-left: -33px;'><md-icon aria-hidden='true' class='sb18 ng-scope md-default-theme md-font material-icons icon-chevron-down dropdown_plus' style='font-size: 20px !important; margin-top: 5px;'></md-icon></button> Modifier une vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-content-cut' class='s18 ng-scope md-font material-icons icon-content-cut cursor-initial' aria-hidden='true'></md-icon></button> Montage de la vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-closed-caption' class='s18 ng-scope md-font material-icons icon-closed-caption cursor-initial' aria-hidden='true'></md-icon></button> Sous titrage vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-rich-media'></md-icon></button>Rich-m\u00e9dia</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-filmstrip' class='s18 ng-scope md-font material-icons icon-filmstrip cursor-initial' aria-hidden='true'></md-icon></button> Changer la vid\u00e9o source</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chart-bar' class='s18 ng-scope md-font material-icons icon-chart-bar cursor-initial' aria-hidden='true'></md-icon></button> Statistiques de la vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-account-switch' class='s18 ng-scope md-font material-icons icon-account-switch cursor-initial' aria-hidden='true'></md-icon></button> Gestion des abonn\u00e9s</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='sb18 ng-scope md-default-theme md-font material-icons icon-quizz-custom' aria-hidden='true'></md-icon></button> Voir questions/quiz</div></div><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-download' class='s18 ng-scope md-font material-icons icon-download cursor-initial' aria-hidden='true'></md-icon></button> T\u00e9l\u00e9charger le fichier</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-meta-custom'></md-icon></button> M\u00e9ta-data de la vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-arrange-send-backward' class='s18 ng-scope md-font material-icons icon-arrange-send-backward cursor-initial' aria-hidden='true'></md-icon></button> Mettre en avant(home page)</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-timer' class='s18 ng-scope md-font material-icons icon-timer cursor-initial' aria-hidden='true'></md-icon></button> Chronologie de la vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon></button> Supprimer une vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon class='sb18 ng-scope md-default-theme md-font material-icons icon-ad-off-custom'></md-icon></button> D\u00e9scription audio</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-earth' class='s18 ng-scope md-font material-icons icon-earth cursor-initial' aria-hidden='true'></md-icon></button> Mise en ligne/hors ligne</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-comment' class='sb18 ng-scope md-default-theme md-font material-icons icon-home-on' aria-hidden='true'></md-icon></button> Ajouter la vid\u00e9o aux vid\u00e9os d'accueil</div></div><div class='colonne'><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon></button> Liens et URL de la vid\u00e9o</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height: 50px;' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/youtube.png' class='ng-scope' src='assets/icons/youtube.png'></button> Export YouTube</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px;' ng-src='assets/icons/dailymotion.png' class='ng-scope' src='assets/icons/dailymotion.png'></button> Export DailyMotion</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/mail.png' class='ng-scope' src='assets/icons/mail.png'></button> Envoie de la vid\u00e9o par mail</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/fb.png' class='ng-scope' src='assets/icons/fb.png'></button> Export Facebook</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/twitter.png' class='ng-scope' src='assets/icons/twitter.png'></button> Export Twitter</div><div><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' style='height:50px' type='button'><img style='margin-left: -6px;max-width: 155%;margin-top: 1px' ng-src='assets/icons/in.png' class='ng-scope' src='assets/icons/in.png'></button> Export Linkedin</div></div></div>",
    "navigation_video_help": "NAVIGATION <br> En bas, des fonctions permettent de r\u00e9gler l'affichage et acc\u00e9der aux pages <br> <img src='assets/images/help/pagination.jpg'>",
    "welcome_caption_add": "Bienvenue sur 'Sous titrage vid\u00e9o'",
    "begin_button_caption_add_help": "Pour cr\u00e9er des sous-titres, il faut cliquer sur le bouton <button class='md-accent md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-microphone-variant' class='ng-scope cursor-initial md-font material-icons icon-microphone-variant' ></md-icon>D\u00e9but d'un sous titrage</button> pour marquer le temps de d\u00e9but du sous titrage.Puis cliquez sur le bouton <button class='md-warn md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-microphone-variant-off' class='ng-scope cursor-initial md-font material-icons icon-microphone-variant-off'></md-icon>Fin d'un sous titrage</button> pour marquer le temps de fin du sous titrage.",
    "delete_button_caption_add_help": "Pour supprimer un sous titrage, il suffit de cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-close' class='s18 ng-scope md-font material-icons icon-close cursor-initial' style='color:red' aria-hidden='true'></md-icon></button> ",
    "valider_button_caption_add_help": "Vous devez cliquer sur le bouton <button class='md-primary md-raised md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-check' class='ng-scope cursor-initial md-font material-icons icon-check'></md-icon> Valider les modifications</button> pour enregistrer",
    "upload_button_caption_add_help": "Pour t\u00e9l\u00e9charger un fichier de sous titrage vous devez cliquer sur le bouton <button class='md-accent md-raised md-button ng-scope cursor-initial md-ink-ripple' type='button'>Choisir un fichier</button>",
    "cancel_button_caption_add_help": "Pour revenir \u00e0 la page liste, cliquez sur le bouton <button class='md-warn md-button ng-scope cursor-initial md-ink-ripple' type='button' >Annuler</button>",
    "welcome_display": "Bienvenue sur 'Liste des affichages'",
    "add_button_display_help": "Pour  ajouter un affichage , cliquez sur le bouton noir \u00e0 droite <button class='md-fab md-primary md-icon-button md-button cursor-initial md-ink-ripple' type='button'><md-icon md-font-icon='icon-plus' class='ng-scope cursor-initial md-font material-icons icon-plus' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>qui va vous orienter au formulaire d'ajout.",
    "arrow_button_display_help": "Pour voir le reste des affichage, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_display_help": "Pour chercher un affichage, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_display_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_display_help": "Pour modifier les informations d'un affichage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_display_help": "Pour visualiser les informations d'un affichage, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-eye' class='s18 ng-scope md-font material-icons icon-eye cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_display_help": "Pour visualiser les liens d'export d'un affichage, il faut cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-link-variant' class='s18 ng-scope md-font material-icons icon-link-variant cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> in the same line (in the Action column)",
    "delete_button_display_help": "Pour supprimer un affichage, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_display_add": "Bienvenue sur 'Ajouter affichage'",
    "welcome_display_edit": "Bienvenue sur 'Modifier affichage'",
    "welcome_calendar": "Bienvenue sur 'Calendrier'",
    "display_calendar_today": " Pour afficher la calendrier d'aujourd'hui, click sur   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-today' class='s18 ng-scope md-font material-icons icon-calendar-today cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_day": " Pour afficher la calendrier d'un jour, click sur  <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-day' class='s18 ng-scope md-font material-icons icon-view-day cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_week": " Pour afficher la calendrier d'une semaine, click sur   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-week' class='s18 ng-scope md-font material-icons icon-view-week cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_month": " Pour afficher la calendrier d'un mois, click sur  <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-module' class='s18 ng-scope md-font material-icons icon-view-module cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_next_prev": " Pour afficher la prochaine/pr\u00e9c\u00e9dent jour/semaine/mois, utilise   <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chevron-left' class='s18 ng-scope md-font material-icons icon-chevron-left cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> et <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-chevron-right' class='s18 ng-scope md-font material-icons icon-chevron-right cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_list_schedules": " Pour afficher les grilles en mode datatable, il suffit de cliquer sur le bouton <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-text' class='s18 ng-scope md-font material-icons icon-calendar-text cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "display_calendar_edit_schedule": " <div class='ligne'><div class='colonne'> <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-today' class='s18 ng-scope md-font material-icons icon-calendar-today cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> la calendrier d'aujourd'hui</div><div class='colonne'> <button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-day' class='s18 ng-scope md-font material-icons icon-view-day cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> la calendrier d'un jour</div></div><div class='ligne'><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-week' class='s18 ng-scope md-font material-icons icon-view-week cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> la calendrier d'une semaine</div><div class='colonne'><button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-view-module' class='s18 ng-scope md-font material-icons icon-view-module cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button> la calendrier d'un mois</div></div>",
    "welcome_tem_manager": "Bienvenue sur 'Template manager'",
    "add_button_manager_help": "Pour  ajouter un manager , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_manager_help": "Pour voir le reste des managers, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_manager_help": "Pour chercher un manager, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_manager_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_manager_help": "Pour modifier les informations d'un manager, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "detail_button_manager_help": "Pour visualiser les informations d'un manager, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_manager_help": "Pour supprimer un manager, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "export_button_manager_help": "Pour voir les liens d'export d'un manager, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-export' class='s18 ng-scope md-font material-icons icon-export cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "welcome_manager_add": "Bienvenue sur 'Ajouter manager'",
    "welcome_manager_edit": "Bienvenue sur 'Modifier manager'",
    "welcome_schedule": "Bienvenue sur 'Liste d'actualités'",
    "add_button_schedule_help": "Pour ajouter une grille de programmes , cliquez sur le bouton \u00e0 droite <button class='md-fab add-module-button btn-add md-button md-default-theme md-ink-ripple' type='button' style='margin-right: -36px;top: 5px !important; position: relative; right: 0;' id='app-add-element-btn'><md-icon class='icon-btn-add ng-scope md-default-theme md-font material-icons icon-plus' md-font-icon='icon-plus'></md-icon><div class='span-btn-add ng-scope'><span>Ajout</span></div></button>",
    "arrow_button_schedule_help": "Pour voir le reste des grilles, cliquez sur le bouton <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Suivant</span><div class='md-ripple-container'></div></a>que vous pouvez trouvez au dessous du tableau, pour passer \u00e0 la page suivante.Pour revenir \u00e0 la page pr\u00e9cedente, cliquez sur le bouton  <a class='md-raised reference-button md-button cursor-initial md-ink-ripple'><span class='ng-scope'>Pr\u00e9cedent</span><div class='md-ripple-container'></div></a>",
    "search_area_schedule_help": "Pour chercher une grille, tapez le mot index\u00e0 dans la zone de recherche au dessus du tableau \u00e0 droite.",
    "tri_column_schedule_help": "Si vous remarquez, il y a des fl\u00e8ches<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-unfold-more' class='s18 ng-scope md-font material-icons icon-unfold-more cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>\u00e0 droite de chaque colonne, ces fl\u00e8ches sont ici pour vous aider \u00e0 trier la liste.",
    "edit_button_schedule_help": "Pour modifier une grille, il faut cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-pencil' class='s18 ng-scope md-font material-icons icon-pencil cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "delete_button_schedule_help": "Pour supprimer une grille, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-delete' class='s18 ng-scope md-font material-icons icon-delete cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "open_button_schedule_help": "Pour ouvrir une grille, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-open-in-new' class='s18 ng-scope md-font material-icons icon-open-in-new cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "refresh_button_schedule_help": "Pour actualiser l'affichage sur le boitier, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-refresh' class='s18 ng-scope md-font material-icons icon-refresh cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>situ\u00e9 sur la m\u00eame ligne (dans la colonne action)",
    "calendar_button_schedule_help": "Pour afficher les grilles en mode calendrier, il suffit de cliquer sur le bouton<button class='show-button md-icon-button md-button ng-scope md-ink-ripple cursor-initial' type='button'><md-icon md-font-icon='icon-calendar-multiple' class='s18 ng-scope md-font material-icons icon-calendar-multiple cursor-initial' aria-hidden='true'></md-icon><div class='md-ripple-container'></div></button>",
    "welcome_schedule_add": "Bienvenue sur 'Ajouter grille'",
    "welcome_schedule_edit": "Bienvenue sur 'Modifier grille'",
    "schedule_add_help": "Pour ajouter ou modifier une grille, vous devez remplir les champs portant une \u00e9toile <b>*</b> et déplacer les programmes dans la calendrier.",
    "schedule_associate_help": "Pour associer une grille à un Rmbox ou un groupe Rmbox , il suffit de cliquer sur le bouton <button class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button' style='text-transform: initial;'>Attribuer</button> et sélectionner l'élément à associer.",
    "send_button_schedule_add_help": "Vous devez cliquer sur le bouton <button style='text-transform: initial;' class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Ajouter</button> pour valider vos choix.",
    "send_button_schedule_edit_help": "Vous devez cliquer sur le bouton <button style='text-transform: initial;' class='md-raised md-accent md-button ng-scope cursor-initial md-ink-ripple' type='button'>Modifier</button> pour valider vos choix."

  }
}



);

$translateProvider.translations("en", {
    "DISPLAYSCHEDULEADD": {
        "newSchedule": "New schedule",
        "programs": "Programs",
        "yes": "Yes",
        "no": "No",
        "addNewSchedule": "Add new schedule",
        "add": "Add",
        "attribute": "Attribute",
        "save": "Save",
        "remove": "Remove",
        "title": "Title",
        "description": "Description",
        "slot": "Duration slot (minute)",
        "display_schedules_menuTitle": "Schedules",
        "delete_program_msg": "Are you sure to delete this program ?",
        "program_will_be_deleted": "program _st{{title}}_est will be deleted.",
        "time_slot_occupied": "This slot is occupied.",
        "check_to_enbale": "Check to make the schedule active",
        "filter_by":"Filter by"
    }
}
);

$translateProvider.translations("fr", {
    "DISPLAYSCHEDULEADD": {
        "newSchedule": "Nouvelle grille",
        "programs": "Programmes",
        "yes": "Oui",
        "no": "Non",
        "addNewSchedule": "Ajout d'une nouvelle grille",
        "add": "Ajouter",
        "attribute": "Attribuer",
        "save": "Sauvegarder",
        "remove": "Supprimer",
        "title": "Titre",
        "description": "Description",
        "slot": "Intervalle de dur\u00e9e (minute)",
        "display_schedules_menuTitle": "Grilles",
        "delete_program_msg": "Voulez-vous vraiment supprimer le programme ?",
        "program_will_be_deleted": "le program _st{{title}}_est sera supprimé.",
        "time_slot_occupied": "Cette plage horaire est occup\u00e9e par un autre program.",
        "check_to_enbale": "Active",
        "filter_by":"Filtrer par"
    }
}
);

$translateProvider.translations("en", {
    "DISPLAYSCHEDULEEDIT": {
        "editSchedule": "Update schedule",
        "programs": "Programs",
        "yes": "Yes",
        "no": "No",
        "editSchedule": "Update schedule",
        "edit": "Update",
        "save": "Save",
        "remove": "Remove",
        "title": "Title",
        "description": "Description",
        "display_schedules_menuTitle": "Schedules",
        "delete_program_msg": "Are you sure to delete this program ?",
        "program_will_be_deleted": "program _st{{title}}_est will be deleted",
        "time_slot_occupied": "This slot is occupied.",
        "check_to_enbale": "Check to make the schedule active"
    }
}
);

$translateProvider.translations("fr", {
    "DISPLAYSCHEDULEEDIT": {
        "editSchedule": "Modifier grille",
        "programs": "Programmes",
        "yes": "Oui",
        "no": "Non",
        "editSchedule": "Modifier grille",
        "edit": "Modifier",
        "save": "Sauvegarder",
        "remove": "Supprimer",
        "title": "Titre",
        "description": "Description",
        "display_schedules_menuTitle": "Grilles",
        "delete_program_msg": "Voulez-vous vraiment supprimer le programme ?",
        "program_will_be_deleted": "le program _st{{title}}_est sera supprimé.",
        "time_slot_occupied": "Cette plage horaire est occup\u00e9e par un autre program.",
        "check_to_enbale": "Active"
    }
}
);

$translateProvider.translations("en", {
  "TEMPALTEMANAGEREDITOR": {
    "opening_generic": "Opening generic",
    "generic_closing": "Closing generic",
    "opening_generic_added": " selected for opening generic",
    "generic_closing_added": " selected for closing generic",
    "display_responsive": "Responsive display",
    "display_sixteen_nine": "16:9 display",
    "display_four_three": "4:3 display",
    "custom": "other",
    "return_to_blocs_list": "Return",
    "layouts": "Formatting",
    "extension": "Accepted extensions: jpeg, jpg, png",
    "dimension": "Dimensions: 320 x 476 pixels",
    "select_image": "Or select an image :",
    "select_video": "Or select a video :",
    "rss": "Data flow",
    "widgets": "Widgets",
    "logo": "Logo",
    "drag_and_drop_elements_here": "Submit items here",
    "choose_a_layout": "Please choose a layout",
    "choose_a_screen_layout_stored": "Please choose a saved Screen",
    "input_information": "please enter your information",
    "player_goes_in_here": "The reader will be put here !!",
    "builder_layoutTwoColumnsAndToolbar": "Formatting 2C",
    "builder_layoutTwoColumnsAndToolbar_comment": "Formatting containing a header and two columns",
    "builder_el_title": "Playlist",
    "builder_el_title_comment": "Contains a title and a subtitle",
    "builder_el_2_p": "Text",
    "builder_el_2_p_comment": "Text composed of two paragraphs",
    "builder_el_image_text_left": "Text/Image",
    "builder_el_image_text_left_comment": "Text accompanied by an image on the right",
    "builder_el_image_text_right": "Image/Text",
    "builder_el_image_text_right_comment": "Text accompanied by an image on the left",
    "confirm_new_layout_title": "Attention !!",
    "confirm_new_layout_message": "By choosing a new formatting, you will lose all the work you have done._br_Would you really want to continue?",
    "confirm_new_aria_label": "New formatting",
    "confirm_new_screen_title": "Attention !!",
    "confirm_delete_stored_screen_title": "Important !!",
    "confirm_restore_screen_title": "Restoring the screen",
    "confirm_delete_stored_screen_message": "By choosing to remove this screen, all the templates using it will be orphaned from this scale._br_Would you really continue?",
    "confirm_new_screen_message": "By choosing a new layout, you will lose all the work you have done._br_Would you really want to continue?",
    "confirm_restore_screen_message": "By choosing to restore the screen valuers, you will lose all the work you have done. _br_Would you really want to continue?",
    "confirm_delete_screen_message": "By choosing this option, you will lose all the work you have done and the screen you have created. _br_Would you really want to continue?",
    "confirm_delete_screen_title": "Danger !!",
    "confirm_new_screen_aria_label": "New provision",
    "confirm_delete_stored_screen_aria_label": "Screen removal",
    "confirm_new_restore_aria_label": "Restoration",
    "confirm_delete_aria_label": "Restoration",
    "confirm_new_continue": "Yes, choose",
    "confirm_restore": "Yes, restore",
    "confirm_delete": "Yes, delete",
    "confirm_new_cancel": "Cancel",
    "delete_all_elements": "Delete all elements",
    "fontFamily": "Font",
    "fontSize": "Font size",
    "text": "Text",
    "fontWeight": "Font weight",
    "color": "Color",
    "backgroundColor": "Background color",
    "choose_a_color": "Choose a color",
    "image_prop": "Image properties",
    "bg_prop": "Background properties",
    "use_color": "Use a color",
    "use_transitions": "With transitions",
    "use_image": "Use an image",
    "title_prop": "Title properties",
    "txt_prop": "Title properties",
    "width": "width",
    "altTag": "Alternative title",
    "choose_image": "Choose an image",
    "imageUrl": "Image link",
    "confirm_delete_element_message": "Do you really want to delete this item ?",
    "confirm_delete_element_aria_label": "New formatting",
    "confirm_delete_element_continue": "Yes, delete",
    "confirm_delete_element_cancel": "Cancel",
    "delete": "Delete",
    "move": "Move",
    "title_part_prop": "Title properties",
    "subtitle_part_prop": "Subtitle Properties",
    "title": "Title",
    "subTitle": "Subtitle",
    "alignOptions": "Alignment",
    "align_left": "Left",
    "align_right": "Right",
    "align_center": "Center",
    "align_justify": "Justified",
    "align_justify-all": "All justified",
    "align_start": "Start",
    "align_end": "End",
    "align_match-parent": "As a parent",
    "align_inherit": "inherited",
    "align_initial": "initial",
    "align_unset": "disabled",
    "p1_prop": "Properties of the first paragraph",
    "p2_prop": "Properties of the second paragraph",
    "form_title": "Title",
    "form_description": "Description",
    "form_width": "Width",
    "form_height": "Height",
    "form_text_color": "Text Color",
    "duration": "Duration",
    "form_duration": "Duration : {{value}}",
    "calculate_height": "Calculate the height according to the ratio {{ratio}}",
    "screen_duration_must_be_greater_or_equal": "Duration must be greater than or equal to {{value}} seconds",
    "builder_screenOne": "Disposition 1",
    "builder_screenOne_comment": "Disposition 1",
    "builder_screenTwo": "Disposition 2",
    "builder_screenTwo_comment": "Disposition 2",
    "builder_screenThree": "Disposition 3",
    "builder_screenThree_comment": "Disposition 3",
    "builder_screenFour": "Disposition 4",
    "builder_screenFour_comment": "Disposition 4 (Empty)",
    "builder_screenFive": "Disposition 5",
    "builder_screenFive_comment": "Disposition 5 (Program)",
    "builder_screenSix": "Disposition 6",
    "builder_screenSix_comment": "Disposition 6",
    "builder_screenSeven": "Disposition 7",
    "builder_screenSeven_comment": "Disposition 7",
    "builder_screenEight": "Disposition 8",
    "builder_screenEight_comment": "Disposition 8",
    "builder_screenNine": "Disposition 9",
    "builder_screenNine_comment": "Disposition 9",
    "builder_screenTen": "Disposition 10",
    "builder_screenTen_comment": "Disposition 10",
    "builder_screenEleven": "Disposition 11",
    "builder_screenEleven_comment": "Disposition 11",
    "builder_screenTwelve": "Disposition 12",
    "builder_screenTwelve_comment": "Disposition 12",
    "builder_screenTherteen": "Disposition 13",
    "builder_screenTherteen_comment": "Disposition 13",
    "builder_screenFourteen": "Disposition 14",
    "builder_screenFourteen_comment": "Disposition 14",
    "builder_screenFifteen": "Disposition 15",
    "builder_screenFifteen_comment": "Disposition 15",
    "builder_screenTwentyFour": "Disposition 16",
    "builder_screenTwentyFour_comment": "Disposition 16",
    "builder_screenSixteen": "let me introduce",
    "builder_screenTwentyTwo": "Disposition live",
    "builder_screenTwentyThree": "Disposition video",
    "builder_screenTwentyThree_comment": "Disposition video",
    "arrivee_region": "Welcome",
    "food_tech": "Food & tech",
    "data_news": "Data News",
    "revue_press": "Revue de presse",
    "innovation_new": "Innovation News",
    "dispo_personalise": "Personalized layout",
    "builder_screenSixteen_comment": "let me introduce",
    "change_video_link": "Change the video link",
    "change_live_link": "Change the live link",
    "change_video_chaine_link": "Change the YouTube channel link",
    "change_page_twitter_link": "Change the link of the Twitter Page",
    "change_page_facebook_link": "Change the link of the Facebook Page",
    "link_chaine_youtube": "YouTube video embed link",
    "link_must_chaine_youtube": "Youtube video link must be embed",
    "link_page_twitter": "Twitter Page link",
    "link_page_facebook": "Facebook Page link",
    "change_program": "Choose another video",
    "change_weather": "Change weather information",
    "choose_video": "Choose a video",
    "video_link": "Video link",
    "live_link": "Live link",
    "video_autoplay": "Autoplay",
    "video_control_barr": "Do not display the Control Bar",
    "video_Loop": "loop playback",
    "rss_link": "RSS feed link",
    "add_video_link": "Add video link",
    "add_live_link": "Add live link",
    "add_rss_link": "Add RSS feed link",
    "change_Web_link": "Change the link of the Scoop IT",
    "change_Scoop_link": "Changer le lien de la Scoop IT",
    "rss_has_no_data": "the link does not contain an RSS feed, change the link",
    "add_position": "Add a position",
    "weather_on": "Temperature on",
    "current": "Current : ",
    "location": "Position",
    "background_repeat": "Repeat the background image",
    "background_size": "size of the background image",
    "background_image": "Background image",
    "background_images_soreted": "Library of images",
    "background_position": "Position of the background image",
    "screen_conf": "Screen configuration",
    "screen_params": "Screen setting",
    "screen_decl": "Screen triggers",
    "screen_decl_hor": "Schedule",
    "screen_decl_gare": "Approaching a train station",
    "screen_decl_trajet": "On the way",
    "screen_decl_terminus": "Approaching terminus",
    "restore_screen_default_data": "Restore",
    "restore_element_default_data": "Restore",
    "no_link": "No link",
    "no_program": "No program chosen",
    "no_position": "No position",
    "builder_el_video": "Video",
    "builder_el_video_comment": "The video will be placed in an iframe whose only link is editable",
    "builder_el_logo": "Image",
    "builder_el_logo_comment": "Add an image whose link, size and title are editable",
    "builder_el_textEditor": "Text",
    "builder_el_textEditor_comment": "Text editor",
    "builder_el_widget": "Widgets",
    "builder_el_widget_comment": "Different types of components",
    "builder_el_widget_clock": "Clock",
    "builder_el_widget_clock_comment": "Analog clock",
    "builder_el_widget_weather": "weather",
    "builder_el_widget_weather_comment": "Displays the current weather in a selected location",
    "builder_el_program_zone": "program area",
    "builder_el_program_zone_comment": "Display a reading area of a program",
    "add_program": "Add a program",
    "screen_blocks": "Elements",
    "confirm_replace_bloc_title": "Select the block of the screen you want to replace?",
    "confirm_replace_bloc_text": "Choose a block",
    "confirm_replace_label": "block",
    "confirm_replace_aria_label": "replace block",
    "confirm_replace_ok": "Replace",
    "bloc_logo": "Bloc logo",
    "bloc_video": "Bloc video",
    "bloc_widgetWeather": "Meteo widget block",
    "bloc_textEditor": "Text editor block",
    "editorScreenAdd": "The \"{{value}}\" screen has been added successfully.",
    "editorScreenEdit": "The \"{{value}}\" screen has been changed successfully.",
    "editorTemplateAdd": "The program \"{{value}}\" has been added successfully.",
    "editorTemplateEdit": "The program \"{{value}}\" has been modified successfully.",
    "confirm_new_template_title": "Program registration",
    "confirm_new_template_text": "Give a name to your program",
    "confirm_new_template_label": "Template name",
    "preview_template_title": "Overview",
    "preview_template_msg": "Preview the {{value}} program in a new tab / window",
    "preview_template_label": "Overview",
    "see_preview": "see the overview",
    "work_on_this_screen": "Work on this screen",
    "generate_screen_shot": "generation of a new capture",
    "remove_screen_shot": "clear the capture",
    "new_screen": "Add screen",
    "use_link": "Use a link",
    "choose_program": "Choose a program",
    "link": "link",
    "program": "program",
    "action_new_template": "Create a new template",
    "putLogoToTheRightSide": "Put the logo on the right",
    "transition_type": "Type of transition",
    "transition_way": "Transition Branch",
    "transition_way_in": "In",
    "transition_way_out": "Out",
    "has_info_bar": "Info queue",
    "has_no_style": "Without style",
    "time_as_program": "Duration of the program",
    "screen_transitions": "Screen transitions",
    "video_introduction": "Introductory Video",
    "video_introd": "Introductory",
    "add_video_introduction": "Add an introductory video",
    "confirm_duplicate_screen_title": "Duplicate screen",
    "confirm_duplicate_screen_text": "Give the number of duplications you want for this screen",
    "confirm_duplicate_screen_label": "Number of duplications",
    "screen_info_bar_container": "Container of the information queue and clock",
    "screen_info_bar_info_container": "Information file",
    "screen_info_bar_clock_container": "Clock",
    "time_format": "Format",
    "time_zone": "Time zone",
    "addInfomrations": "Add / view information",
    "informations": "Informations",
    "information_urgent": "Urgent information",
    "information_very_urgent": "Very urgent information",
    "information_simple": "Simple information",
    "information": "Information",
    "waiting_for_screen_shot": "Generation of capture",
    "duplicate_screen": "Duplicate the screen",
    "duplicate_screen_many_time": "Duplicate several times",
    "delete_screen": "Delete screen",
    "screen_dispostions": "Screen arrangements",
    "screen_stored": "Saved screens",
    "element_params": "Element param",
    "remove_info": "Delete this information",
    "add_new_info": "Add new information",
    "restore_informations": "Restore",
    "sort_by_priority": "Sort by descending priority",
    "delete_all": "Delete all",
    "hide_bloc_indications": "Hide block codes",
    "show_bloc_indications": "Display block codes",
    "see_screen": "View the screen in full width mode",
    "save_template": "Save program",
    "video_list": "Add video from list ",
    "live_list": "Add live from list ",
    "choose_a_screen_layout": "Please choose a disposition",
    "priority": "priority",
    "infoFile": "Import information file",
    "biblio_playlist": "Add playlist ",
    "no_playlist": "No playlist",
    "use_backgroud": "Use a background",
    "link_video": "Add URL video",
    "link_live": "Add URL live",
    "link_playlist": "Add URL playlist",
    "hls_link": "HLS live link"
  }
}
);

$translateProvider.translations("fr", {
  "TEMPALTEMANAGEREDITOR": {
    "opening_generic": "G\u00e9n\u00e9rique de d\u00e9but",
    "generic_closing": "Générique de fin",
    "opening_generic_added": " est s\u00e9lectionn\u00e9e comme générique de d\u00e9but",
    "generic_closing_added": " est s\u00e9lectionn\u00e9e comme générique de fin",
    "display_responsive": "Affichage responsive",
    "display_sixteen_nine": "Affichage 16:9",
    "display_four_three": "Affichage 4:3",
    "custom": "autre",
    "return_to_blocs_list": "Retour",
    "layouts": "Mise en forme",
    "extension": "Extensions acceptées: jpeg,jpg,png",
    "select_image": "Ou sélectionnez une image :",
    "select_video": "Ou sélectionnez une video :",
    "dimension": "Dimensions: 320 x 476 pixels",
    "rss": "Flux de donn\u00e9es",
    "widgets": "Widgets",
    "logo": "Logo",
    "drag_and_drop_elements_here": "D\u00e9poser des \u00e9lements ici",
    "choose_a_layout": "Veuillez choisir une mise en page",
    "input_information": "Veuillez entrer votre information",
    "choose_a_screen_layout": "Veuillez choisir une disposition",
    "choose_a_screen_layout_stored": "Veuillez choisir un écran enregistr\u00e9",
    "screen_dispostions": "Dispositions d'\u00e9crans",
    "player_goes_in_here": "Le lecteur sera mis Ici !!",
    "builder_layoutTwoColumnsAndToolbar": "Mise en forme 2C",
    "builder_layoutTwoColumnsAndToolbar_comment": "Mise en forme contenant un ent\u00eate et deux colonnes",
    "builder_el_title": "Playlist",
    "builder_el_title_comment": "Contient un titre et un sous-titre",
    "builder_el_2_p": "Texte",
    "builder_el_2_p_comment": "Texte compos\u00e9e de deux paragraphes",
    "builder_el_image_text_left": "Texte/Image",
    "builder_el_image_text_left_comment": "Texte accompagn\u00e9 d'une image a sa droite",
    "builder_el_image_text_right": "Image/Text",
    "builder_el_image_text_right_comment": "Texte accompagn\u00e9 d'une image a sa gauche",
    "confirm_new_layout_title": "Attention !!",
    "confirm_new_layout_message": "En choisissant une nouvelle mise en forme, _st_vous allez perdre tout le travail que vous avez fait._est_ _br_Voulez vous vraiment continuer ?",
    "confirm_new_aria_label": "Nouvelle mise en forme",
    "confirm_new_screen_title": "Attention !!",
    "confirm_delete_stored_screen_title": "Important !!",
    "confirm_restore_screen_title": "Restauration du l'\u00e9cran",
    "confirm_delete_stored_screen_message": "En choisissant de supprimer cet \u00e9cran, _st_tous les templates l'utilisant seront orphelin de cet \u00e9carn._est_ _br_Voulez vous vraiment continuer ?",
    "confirm_new_screen_message": "En choisissant une nouvelle disposition, _st_vous allez perdre tout le travail que vous avez fait._est_ _br_Voulez vous vraiment continuer ?",
    "confirm_restore_screen_message": "En choisissant de restaurer les valuers de l'\u00e9cran, _st_vous allez perdre tout le travail que vous avez fait._est_ _br_Voulez vous vraiment continuer ?",
    "confirm_delete_screen_message": "En choisissant cette option, _st_vous allez perdre tout le travail que vous avez fait ainsi que l'\u00e9cran que vous av\u00e9z cr\u00e9er._est_ _br_Voulez vous vraiment continuer ?",
    "confirm_delete_screen_title": "Danger !!",
    "confirm_new_screen_aria_label": "Nouvelle disposition",
    "confirm_delete_stored_screen_aria_label": "Suppression d'\u00e9cran",
    "confirm_new_restore_aria_label": "Restauration",
    "confirm_delete_aria_label": "Restauration",
    "confirm_new_continue": "Oui, choisir",
    "confirm_restore": "Oui, restaurer",
    "confirm_delete": "Oui, supprimer",
    "confirm_new_cancel": "Annuler",
    "delete_all_elements": "Supprimer tous les \u00e9lements",
    "fontFamily": "Police",
    "fontSize": "Taille de la police",
    "text": "Texte",
    "form_text_color": "Couleur du Text",
    "fontWeight": "Poids du texte",
    "color": "Couleur",
    "backgroundColor": "Couleur de fond",
    "choose_a_color": "Choisissez une couleur",
    "image_prop": "Propri\u00e9t\u00e9s de l'image",
    "bg_prop": "Propri\u00e9t\u00e9s d'arri\u00e8re-plan",
    "use_color": "Utiliser une couleur",
    "use_transitions": "Avec transitions",
    "use_image": "Utiliser une image",
    "title_prop": "Propri\u00e9t\u00e9s du titre",
    "txt_prop": "Propri\u00e9t\u00e9s du titre",
    "width": "Largeur",
    "height": "Hauteur",
    "altTag": "Titre alternative",
    "choose_image": "Choisir une image",
    "imageUrl": "Lien de l'image",
    "confirm_delete_element_message": "Voulez-vous vraiment effacer cet \u00e9lement ?",
    "confirm_delete_element_aria_label": "Nouvelle mise en forme",
    "confirm_delete_element_continue": "Oui, Supprimer",
    "confirm_delete_element_cancel": "Annuler",
    "delete": "Supprimer",
    "move": "D\u00e9placer",
    "title_part_prop": "Propri\u00e9t\u00e9s du titre",
    "subtitle_part_prop": "Propri\u00e9t\u00e9s du sous titre",
    "title": "Titre",
    "subTitle": "Sous titre",
    "alignOptions": "Alignement",
    "align_left": "Gauche",
    "align_right": "Droite",
    "align_center": "Centre",
    "align_justify": "Justifi\u00e9e",
    "align_justify-all": "Tout justifi\u00e9e",
    "align_start": "d\u00e9but",
    "align_end": "fin",
    "align_match-parent": "Comme parent",
    "align_inherit": "herit\u00e9e",
    "align_initial": "initiale",
    "align_unset": "d\u00e9sactiv\u00e9",
    "p1_prop": "Propri\u00e9t\u00e9s du 1er paragraphe",
    "p2_prop": "Propri\u00e9t\u00e9s du 2eme paragraphe",
    "form_title": "Titre",
    "form_description": "Description",
    "form_width": "Largeur",
    "form_height": "Hauteur",
    "duration": "Dur\u00e9e",
    "form_duration": "Dur\u00e9e : {{value}}",
    "calculate_height": "Calculer l'hauteur selon le ratio {{ratio}}",
    "screen_duration_must_be_greater_or_equal": "La dur\u00e9e doit \u00eatre sup\u00e9rieur ou \u00e9gale \u00e0 {{value}} secondes",
    "builder_screenOne": "Disposition 1",
    "builder_screenOne_comment": "Disposition 1",
    "builder_screenTwo": "Disposition 2",
    "builder_screenTwo_comment": "Disposition 2",
    "builder_screenThree": "Disposition 3",
    "builder_screenThree_comment": "Disposition 3",
    "builder_screenFour": "Disposition 4",
    "builder_screenFour_comment": "Disposition 4 (Empty)",
    "builder_screenFive": "Disposition 5",
    "builder_screenFive_comment": "Disposition 5 (Program)",
    "builder_screenSix": "Disposition 6",
    "builder_screenSix_comment": "Disposition 6",
    "builder_screenSeven": "Disposition 7",
    "builder_screenSeven_comment": "Disposition 7",
    "builder_screenEight": "Disposition 8",
    "builder_screenEight_comment": "Disposition 8",
    "builder_screenNine": "Disposition 9",
    "builder_screenNine_comment": "Disposition 9",
    "builder_screenTen": "Disposition 10",
    "builder_screenTen_comment": "Disposition 10",
    "builder_screenEleven": "Disposition 11",
    "builder_screenEleven_comment": "Disposition 11",
    "builder_screenTwelve": "Disposition 12",
    "builder_screenTwelve_comment": "Disposition 12",
    "builder_screenTherteen": "Disposition 13",
    "builder_screenTherteen_comment": "Disposition 13",
    "builder_screenFourteen": "Disposition 14",
    "builder_screenFourteen_comment": "Disposition 14",
    "builder_screenFifteen": "Disposition 15",
    "builder_screenFifteen_comment": "Disposition 15",
    "builder_screenTwentyFour": "Disposition 16",
    "builder_screenTwentyFour_comment": "Disposition 16",
    "builder_screenSixteen": "let me introduce",
    "builder_screenSixteen_comment": "let me introduce",
    "builder_screenTwentyTwo": "Disposition direct",
    "builder_screenTwentyThree": "Disposition video",
    "builder_screenTwentyThree_comment": "Disposition video",
    "arrivee_region": "Welcome",
    "food_tech": "Food & tech",
    "data_news": "Data News",
    "revue_press": "Revue de presse",
    "innovation_new": "Innovation News",
    "dispo_personalise": "Disposition personalisée",
    "change_video_link": "Changer le lien de la vid\u00e9o",
    "change_live_link": "Changer le lien du direct",
    "change_video_chaine_link": "Changer le lien de la chaîne YouTube",
    "change_page_twitter_link": "Changer le lien de la page Twitter",
    "change_page_facebook_link": "Changer le lien de la page Facebook",
    "change_Web_link": "Changer le lien de la page web",
    "change_weather": "Changer les informations de la météo",
    "change_Scoop_link": "Changer le lien de la Scoop IT",
    "link_chaine_youtube": "Lien embed YouTube",
    "link_must_chaine_youtube": "Lien de la vidéo YouTube doit étre embed",
    "link_page_twitter": "Lien de la page Twitter",
    "link_page_facebook": "Lien de la page Facebook",
    "change_program": "Choisir une autre vidéo",
    "choose_video": "Choisir une video",
    "video_link": "Lien de la vid\u00e9o",
    "live_link": "Lien du direct",
    "video_autoplay": "Lecture automatique",
    "video_control_barr": "Ne pas afficher la barre de contrôle",
    "video_Loop": "Lecture En Boucle",
    "rss_link": "Lien du flux RSS",
    "add_video_link": "Ajouter le lien de la vid\u00e9o",
    "add_live_link": "Ajouter le lien du direct",
    "add_rss_link": "Ajouter le lien du flux RSS",
    "rss_has_no_data": "Le lien ne contient pas de flux RSS, changer le lien",
    "add_position": "Ajouter une position",
    "weather_on": "Temp\u00e9rature sur",
    "current": "Courant : ",
    "location": "Position",
    "background_repeat": "R\u00e9p\u00e9t\u00e9r l'image d'arri\u00e8re-plan",
    "background_size": "Taille de l'image d'arri\u00e8re-plan",
    "background_image": "Image d'arri\u00e8re-plan",
    "background_images_soreted": "Biblioth\u00e8que des images",
    "background_position": "Position de l'image d'arri\u00e8re-plan",
    "screen_conf": "Configuration de l'\u00e9cran",
    "screen_params": "Param\u00e8tre de l'\u00e9cran",
    "screen_decl": "D\u00e9clencheurs de l'\u00e9cran",
    "screen_decl_hor": "Horaires",
    "screen_decl_gare": "\u00c0 l'approche d'une gare",
    "screen_decl_trajet": "En cours de trajet",
    "screen_decl_terminus": "\u00c0 l'approche de terminus",
    "element_params": "Param\u00e8tre de l'\u00e9l\u00e9ment",
    "restore_screen_default_data": "Restaurer",
    "restore_element_default_data": "Restaurer",
    "delete_screen": "Supprimer l'\u00e9cran",
    "no_link": "Aucun lien",
    "no_program": "Aucun programme choisi",
    "no_position": "Aucune position",
    "builder_el_video": "Vid\u00e9o",
    "builder_el_video_comment": "La vid\u00e9o sera plac\u00e9e dans une iframe dont seul le lien est modifiable",
    "builder_el_logo": "Image",
    "builder_el_logo_comment": "Ajout d'une image dont le lien, taille et titre sont modifiable",
    "builder_el_textEditor": "Texte",
    "builder_el_textEditor_comment": "Editeur de texte",
    "builder_el_widget": "Widgets",
    "builder_el_widget_comment": "Diff\u00e9rents types de composants",
    "builder_el_widget_clock": "Horloge",
    "builder_el_widget_clock_comment": "Horloge analogique",
    "builder_el_widget_weather": "M\u00e9t\u00e9o",
    "builder_el_widget_weather_comment": "Affiche la m\u00e9t\u00e9o courante dans une localisation choisie",
    "builder_el_program_zone": "zone programme",
    "builder_el_program_zone_comment": "Afficher une zone de lecture d'un programme",
    "add_program": "Ajouter un programme",
    "screen_blocks": "\u00c9l\u00e9ments",
    "screen_stored": "\u00c9carns enregistr\u00e9es",
    "confirm_replace_bloc_title": "S\u00e9l\u00e9ctionner le bloc de l'\u00e9cran que vous voulez remplacer ?",
    "confirm_replace_bloc_text": "Choisissez un bloc",
    "confirm_replace_label": "Bloc",
    "confirm_replace_aria_label": "remplacer le bloc",
    "confirm_replace_ok": "Remplacer",
    "bloc_logo": "Bloc logo",
    "bloc_video": "Bloc vid\u00e9o",
    "bloc_widgetWeather": "Bloc widget-m\u00e9teo",
    "bloc_textEditor": "Bloc \u00e9diteur du texte",
    "editorScreenAdd": "L'\u00e9cran \"{{value}}\" a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s.",
    "editorScreenEdit": "L'\u00e9cran \"{{value}}\" a \u00e9t\u00e9 modifi\u00e9 avec succ\u00e8s.",
    "editorTemplateAdd": "Le programme \"{{value}}\" a \u00e9t\u00e9 ajout\u00e9 avec succ\u00e8s.",
    "editorTemplateEdit": "Le programme \"{{value}}\" a \u00e9t\u00e9 modifi\u00e9 avec succ\u00e8s.",
    "confirm_new_template_title": "Enregistrement du programme",
    "confirm_new_template_text": "Donner un nom \u00e0 votre programme",
    "confirm_new_template_label": "Nom du template",
    "save_template": "Enregistrer programme",
    "hide_bloc_indications": "Cacher les indicatifs des blocs",
    "show_bloc_indications": "Afficher les indicatifs des blocs",
    "see_screen": "Voir l'\u00e9cran en mode plein-\u00e9cran",
    "preview_template_title": "Ap\u00e9rçu",
    "preview_template_msg": "Voir un aperçu du programme {{value}} dans un(e) nouvel onglet/fen\u00eatre",
    "preview_template_label": "Ap\u00e9rcu",
    "see_preview": "Voir l'aperçu",
    "work_on_this_screen": "Travailler sur cet \u00e9cran",
    "waiting_for_screen_shot": "g\u00e9n\u00e9ration de la capture",
    "generate_screen_shot": "g\u00e9n\u00e9ration d'une nouvelle capture",
    "remove_screen_shot": "effacer la capture",
    "duplicate_screen": "Dupliquer l'\u00e9cran",
    "new_screen": "Ajouter \u00e9cran",
    "use_link": "Utiliser un lien",
    "choose_program": "Choisir un program",
    "link": "lien",
    "program": "programme",
    "video_introduction": "Vidéo d'introduction",
    "video_introd": "Introduction",
    "add_video_introduction": "Ajouter une vidéo d'introduction",
    "action_new_template": "Cr\u00e9er un nouveau template",
    "putLogoToTheRightSide": "Mettre le logo \u00e0 droite",
    "transition_type": "Type de transition",
    "transition_way": "Direction de la transition",
    "transition_way_in": "Entr\u00e9e",
    "transition_way_out": "Sortie",
    "has_info_bar": "Fil d'info",
    "has_no_style": "Sans style",
    "time_as_program": "Dur\u00e9e du programme",
    "screen_transitions": "Transitions de l'\u00e9cran",
    "duplicate_screen_many_time": "Dupliquer plusieurs fois",
    "confirm_duplicate_screen_title": "Dupliquer l'\u00e9cran",
    "confirm_duplicate_screen_text": "Donner le nombre de duplications que vous vouliez pour cet \u00e9cran",
    "confirm_duplicate_screen_label": "Nombre de duplications",
    "screen_info_bar_container": "Conteneur du fil d'information et horloge",
    "screen_info_bar_info_container": "Fichier d'information",
    "screen_info_bar_clock_container": "Horloge",
    "time_format": "Format",
    "time_zone": "Fuseau horaire",
    "addInfomrations": "Ajouter/voir des/les informations",
    "informations": "Informations",
    "information_urgent": "Information urgente",
    "information_very_urgent": "Information tr\u00e8s urgente",
    "information_simple": "Information simple",
    "delete_all": "Tout effacer",
    "sort_by_priority": "Trier par priorit\u00e9 descendante",
    "restore_informations": "R\u00e9tablir",
    "add_new_info": "Ajouter une nouvelle information",
    "remove_info": "Effacer cette information",
    "information": "Information",
    "priority": "priorit\u00e9",
    "biblio_video": "Ajouter une vidéo de la bibliothèque ",
    "video_list": "Ajouter une vidéo de la liste ",
    "live_list": "Ajouter un direct de la liste ",
    "biblio_playlist": "Ajouter une playlist de la liste ",
    "link_video": "Ajouter un lien de la vidéo",
    "link_live": "Ajouter un lien du direct",
    "link_playlist": "Ajouter un lien de la playlist",
    "infoFile": "Importer un fil d'information",
    "no_playlist": "Aucune playlist",
    "use_backgroud": "Utiliser un fond",
    "hls_link": "Lien d'un live HLS"
  }
}
);

$translateProvider.translations("en", {
    "TMTEMPLATESLIST": {
        "delete_templates_aria_label": "Delete programs",
        "description": "Description",
        "screens": "Screens",
        "title":"Title",
        "duration": "Duration",
        "delete_template_aria_label": "Delete program",
        "added": "has been added successfully",
        "edited": "has been modified successfully",
        "delete_template_message": "Are you sure you want to delete the program?",
        "delete_list_templates_message": "Are you sure you want to delete the programs?",
        "delete_template_label": "Delete template",
        "delete_templates_label": "Delete templates",
        "dialog_alert_delete_description": " has been deleted successfully.",
        "dialog_alert_delete_error_title": "Error",
        "dialog_alert_delete_title": "Successful operation",
        "dialog_alert_delete_error_description": "Operation not performed !!!",
        "dialog_alert_delete_close": "CLOSE",
        "undeleted_are": "Templates with ids \"{{list}}\" could not be deleted",
        "deleted_are": "Templates with ids \"{{list}}\" have been deleted",
        "day": "day",
        "days": "days",
        "hour": "hour",
        "hours": "hours",
        "minute": "minute",
        "minutes": "minutes",
        "second": "second",
        "seconds": "seconds",
        "no_longer": "This Template does no longer exist",
        "action_open":"Open Program",
        "dialog_confirm_bloc": "Are you sure you want to delete the Bloc?",
        "delete_bloc_label": "Delete  Bloc",
        "template_link":"Link :",
        "template_link_title": "The export link",
        "dialog_alert_edit_title": "Template title has been modified successfully",
        "action_export":"Export Video"

    },

    "TMTEMPLATEDETAILS": {
        "intro": "Details of template",
        "title": "Title",
        "description": "Description",
        "programs": "Programmes"
    },
    "VALIDATION": {
        "cannot_delete_template_related_schedule" : "Cannot delete a program related to one or many Schedules"
    }
}
);

$translateProvider.translations("fr", {
    "TMTEMPLATESLIST": {
        "title": "Titre",
        "duration": "Dur\u00e9e",
        "added": "a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
        "edited": "a \u00e9t\u00e9 modifi\u00e9e avec succ\u00e8s",
        "delete_template_message": "Voulez-vous vraiment supprimer le program?",
        "delete_list_templates_message": "Voulez-vous vraiment supprimer les programmes?",
        "delete_templates_label": "Supprimer les templates",
        "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9 avec succès.",
        "dialog_alert_delete_error_title": "Erreur",
        "dialog_alert_delete_title": "Op\u00e9ration réussie",
        "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !!!",
        "dialog_alert_delete_close": "FERMER",
        "undeleted_are": "Les templates ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
        "deleted_are": "Les templates ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
        "day": "jour",
        "days": "jours",
        "hour": "heure",
        "hours": "heures",
        "minute": "minute",
        "minutes": "minutes",
        "second": "seconde",
        "seconds": "secondes",
        "no_longer": "Ce template n'existe plus",
        "delete_templates_aria_label": "Supprimer les programmes",
        "delete_template_aria_label": "Supprimer le programme",
        "description": "Description",
        "screens": "Screens",
        "delete_template_label": "Template supprim\u00e9",
        "dialog_confirm_delete": "Vous voulez vraiment supprimer cet template",
        "dialog_confirm_bloc": "Vous voulez vraiment supprimer ce Bloc?",
        "delete_bloc_label": "Supprimer le Bloc",
        "template_link":"Lien :",
        "template_link_title":"Le lien d'export",
        "action_open":"Ouvrir Programme",
        "action_export":"Lien d'export",
        "dialog_alert_edit_title": "Titre template a \u00e9t\u00e9 modifi\u00e9 avec succ\u00e8s"
    },

    "TMTEMPLATEDETAILS": {
        "intro": "Details du template",
        "title": "Titre",
        "description": "Description",
        "programs": "Programmes"
    },
    "VALIDATION": {
        "cannot_delete_template_related_schedule" : "Vous ne pouvez pas supprimer un programme reli\u00e9 a un ou plusieurs grilles"
    }
});

$translateProvider.translations("en", {
    "TMTEMPLATESLIST": {
        "none": "All",
        "pending": "Pending",
        "finish": "Published",
        "ligne": "Line",
        "delete_templates_aria_label": "delete template",
        "description": "Description",
        "screens": "Screens",
        "title":"Title",
        "duration": "Duration",
        "startDate": "Generation date",
        "delete_templates_aria_label": "Delete",
        "added": "has been added successfully",
        "edited": "has been modified successfully",
        "delete_template_msg": "Are you sure you want to delete the program?",
        "delete_list_templates_msg": "Are you sure you want to delete the templates?",
        "delete_template_label": "Delete template",
        "delete_templates_label": "Delete templates",
        "dialog_alert_delete_description": " has been deleted successfully.",
        "dialog_alert_delete_error_title": "Error",
        "dialog_alert_delete_title": "Successful operation",
        "dialog_alert_delete_error_description": "Operation not performed !!!",
        "dialog_alert_delete_close": "CLOSE",
        "undeleted_are": "Templates with ids \"{{list}}\" could not be deleted",
        "deleted_are": "Templates with ids \"{{list}}\" have been deleted",
        "day": "day",
        "days": "days",
        "hour": "hour",
        "hours": "hours",
        "minute": "minute",
        "minutes": "minutes",
        "second": "second",
        "seconds": "seconds",
        "no_longer": "This Template does no longer exist",
        "action_open":"Open Program",
        "dialog_confirm_bloc": "Are you sure you want to delete the Bloc?",
        "delete_bloc_label": "Delete  Bloc",
        "template_link":"Link :",
        "template_link_title": "The export link",
        "all":"All",
        "show_archive": "Archived",
        "ongoing": "On going",
        "archived": "Archived",
        "upcoming": "Upcoming",
        "display_programs_list_pagetitle_on_going": "List of on going programs",
        "display_programs_list_pagetitle_upcoming": "List of upcoming programs",
        "display_programs_list_pagetitle_archive": "List of archived programs",
        "video_not_found": "Can't find this video",
        "template_not_found": "Can't find this template",
        "status": "Status",
        "dialog_alert_edit_ligne": "Line has been modified successfully"
    },

    "TMTEMPLATEDETAILS": {
        "intro": "Details of template",
        "title": "Title",
        "description": "Description",
        "programs": "Programmes"
    },
    "VALIDATION": {
        "cannot_delete_template_related_schedule" : "Cannot delete a program related to one or many Schedules"
    }
}
);

$translateProvider.translations("fr", {
    "TMTEMPLATESLIST": {
        "none": "Tout",
        "pending": "En cours",
        "finish": "Publiés",
        "title": "Titre",
        "ligne": "Ligne",
        "duration": "Dur\u00e9e",
        "startDate": "Date de génération",
        "delete_templates_aria_label": "Supprimer",
        "added": "a \u00e9t\u00e9 ajout\u00e9e avec succ\u00e8s",
        "edited": "a \u00e9t\u00e9 modifi\u00e9e avec succ\u00e8s",
        "delete_template_msg": "Voulez-vous vraiment supprimer le template?",
        "delete_list_templates_msg": "Voulez-vous vraiment supprimer les templates?",
        "delete_template_label": "Supprimer le template",
        "delete_templates_label": "Supprimer les templates",
        "dialog_alert_delete_description": " \u00e0 \u00e9t\u00e9 supprim\u00e9 avec succès.",
        "dialog_alert_delete_error_title": "Erreur",
        "dialog_alert_delete_title": "Op\u00e9ration réussie",
        "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !!!",
        "dialog_alert_delete_close": "FERMER",
        "undeleted_are": "Les templates ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
        "deleted_are": "Les templates ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
        "day": "jour",
        "days": "jours",
        "hour": "heure",
        "hours": "heures",
        "minute": "minute",
        "minutes": "minutes",
        "second": "seconde",
        "seconds": "secondes",
        "no_longer": "Ce template n'existe plus",
        "delete_templates_aria_label": "Supprimer template",
        "description": "Description",
        "screens": "Screens",
        "delete_template_msg": "Suppression du programme",
        "delete_template_label": "Template supprim\u00e9",
        "dialog_confirm_delete": "Vous voulez vraiment supprimer cet template",
        "dialog_confirm_bloc": "Vous voulez vraiment supprimer ce Bloc?",
        "delete_bloc_label": "Supprimer le Bloc",
        "delete_list_templates_msg": "Suppression multiple",
        "template_link":"Lien :",
        "template_link_title":"Le lien d'export",
        "action_open":"Ouvrir Programme",
        "action_export":"Lien d'export",
        "all":"Tout",
        "show_archive": "Archiv\u00e9s",
        "ongoing": "En cours",
        "archived": "Archiv\u00e9",
        "upcoming": "A venir",
        "display_programs_list_pagetitle_on_going": "Liste des programmes en cours",
        "display_programs_list_pagetitle_upcoming": "Liste des programmes à venir",
        "display_programs_list_pagetitle_archive": "Liste des programmes archiv\u00e9s",
        "status": "Statut",
        "video_not_found": "Vid\u00e9o n'existe pas",
        "template_not_found": "Template n'existe pas",
        "dialog_alert_edit_ligne": "Ligne a \u00e9t\u00e9 modifi\u00e9 avec succ\u00e8s"

    },

    "TMTEMPLATEDETAILS": {
        "intro": "Details du template",
        "title": "Titre",
        "description": "Description",
        "programs": "Programmes"
    },
    "VALIDATION": {
        "cannot_delete_template_related_schedule" : "Vous ne pouvez pas supprimer un programme reli\u00e9 a un ou plusieurs grilles"
    }
}
);

$translateProvider.translations("en", {
    "DISPLAYSCHEDULEADD": {
        "newSchedule": "New schedule",
        "programs": "Programs",
        "yes": "Yes",
        "no": "No",
        "addNewSchedule": "Add new schedule",
        "add": "Add",
        "save": "Save",
        "remove": "Remove",
        "title": "Title",
        "description": "Description",
        "slot": "Duration slot (minute)",
        "display_schedules_menuTitle": "Schedules",
        "delete_program_msg": "Are you sure to delete this program ?",
        "program_will_be_deleted": "program _st{{title}}_est will be deleted.",
        "time_slot_occupied": "This slot is occupied.",
        "check_to_enbale": "Check to make the schedule active",
        "filter_by":"Filter by",
        "attribute_rmbox": "Attribute",
        "form_attribute_rmbox": "Choose RmBox",
        "form_attribute_rmbox_group": "Choose RmBoxGroup",
        "search": "Search",
        "information": "Information"
    }
}
);

$translateProvider.translations("fr", {
    "DISPLAYSCHEDULEADD": {
        "newSchedule": "Nouvelle grille",
        "programs": "Programmes",
        "yes": "Oui",
        "no": "Non",
        "addNewSchedule": "Ajout d'une nouvelle grille",
        "add": "Ajouter",
        "save": "Sauvegarder",
        "remove": "Supprimer",
        "title": "Titre",
        "description": "Description",
        "slot": "Intervalle de dur\u00e9e (minute)",
        "display_schedules_menuTitle": "Grilles",
        "delete_program_msg": "Voulez-vous vraiment supprimer le programme ?",
        "program_will_be_deleted": "le program _st{{title}}_est sera supprimé.",
        "time_slot_occupied": "Cette plage horaire est occup\u00e9e par un autre program.",
        "check_to_enbale": "Active",
        "filter_by":"Filtrer par",
        "attribute_rmbox": "Attribuer",
        "form_attribute_rmbox": "Choisir RmBox",
        "form_attribute_rmbox_group": "Choisir RmBoxGroup",
        "search": "Rechercher",
        "information": "Informations"
    }
}
);

$translateProvider.translations("en", {
    "DISPLAYSCHEDULEEDIT": {
        "editSchedule": "Update schedule",
        "programs": "Programs",
        "yes": "Yes",
        "no": "No",
        "editSchedule": "Update schedule",
        "edit": "Update",
        "save": "Save",
        "remove": "Remove",
        "title": "Title",
        "description": "Description",
        "display_schedules_menuTitle": "Schedules",
        "delete_program_msg": "Are you sure to delete this program ?",
        "program_will_be_deleted": "program _st{{title}}_est will be deleted",
        "time_slot_occupied": "This slot is occupied.",
        "check_to_enbale": "Check to make the schedule active",
        "search": "Search",
        "information": "Information"
    }
}
);

$translateProvider.translations("fr", {
    "DISPLAYSCHEDULEEDIT": {
        "editSchedule": "Modifier grille",
        "programs": "Programmes",
        "yes": "Oui",
        "no": "Non",
        "editSchedule": "Modifier grille",
        "edit": "Modifier",
        "save": "Sauvegarder",
        "remove": "Supprimer",
        "title": "Titre",
        "description": "Description",
        "display_schedules_menuTitle": "Grilles",
        "delete_program_msg": "Voulez-vous vraiment supprimer le programme ?",
        "program_will_be_deleted": "le program _st{{title}}_est sera supprimé.",
        "time_slot_occupied": "Cette plage horaire est occup\u00e9e par un autre program.",
        "check_to_enbale": "Active",
        "search": "Rechercher",
        "information": "Informations"
    }
}
);

$translateProvider.translations("en", {
  "CONFADD": {
    "form_new_title": "Add configuration form",
    "form_title": "Configuration information",
    "added": "Added successfully"
  }
}
);

$translateProvider.translations("fr", {
  "CONFADD": {
    "form_new_title": "Formulaire d'ajout d'une nouvelle configuration ",
    "form_title": "Information de la configuration",
    "added":"ajout\u00e9 avec succ\u00e9s"
  }
});

$translateProvider.translations("en", {
  "LIVESLIST": {
    "added": "Live added successfully",
    "edited": "Live edited successfully",
    "overview": "Overview",
    "date": "Date",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "delete_selected_live_aria_label": "Delete selected lives",
    "description": "Description",
    "active": "Active",
    "diffusion": "broadcast",
    "enable": "Active",
    "enable_lives": "Enable",
    "disable_lives": "Disable",
    "show_archive": "Archived",
    "show_live": "On going",
    "disable": "Disabled",
    "send_succes": "Send mail success",
    "send_failed": "Send mail failed please try again",
    "send_failed_nb_mail": "Failed to send invitation, you must have at least \"{{nb_mail}}\" emails",
    "send_mail": "Send invitations",
    "action_exportdetail": "Export links",
    "action_livedetail": "Live information",
    "action_livecomment": "List of comments ",
    "delete_lives_msg": "Do you want to delete the live?",
    "delete_lives_aria_label": "Delete live",
    "dialog_alert_disable_description": " has been successfully disabled.",
    "dialog_alert_enable_title": "Successful operation",
    "dialog_alert_enable_description": " has been successfully enabled.",
    "delete_selected_lives_msg": "Do you want to delete the selected lives?",
    "delete_selected_live_message": "Do you want to delete the selected live?",
    "delete_selected_lives_aria_label": "Delete selected lives",
    "undeleted_are": "Lives with ids \"{{list}}\" could not be deleted",
    "deleted_are": "Lives withs ids \"{{list}}\" have been deleted",
    "action_new_element": "Add new live",
    "show_calendar": "Calendar",
    "period": "period",
    "period_week": "Week",
    "period_month": "Month",
    "period_quarter": "Quarter",
    "period_semester": "Semester",
    "period_year": "Year",
    "screen_type": "Choose the output type",
    "output_type": "Output type",
    "screen_share": "Add screen share",
    "screen_share_download": "Donwload the screen share file",
    "live_reset": "Reset",
    "copied": "link copied"
  },
  "LIVESPEARL": {
    "streaming": "CANAL BROADCAST",
    "config_streaming": "Channel configuration",
    "demare_record": "Start the channel",
    "arrete_record": "Stop the channel",
    "config_activetemp": "Template activation",
    "streaming_name": "Name of broadcast ",
    "msg_Active_template": "Do you want to activate this model?",
    "streaming_url": "URL",
    "sources": "Sources Channel",
    "apply": "Apply",
    "channel_start": "Start",
    "channel_stop": "Stop",
    "recording": "Recording Channel",
    "add_streaming": "Add new broadcast",
    "pearl_url": "pearl_url",
    "pearl_api_username": "pearl_api_username",
    "pearl_api_pwd": "pearl_api_pwd",
    "pearl_live_url_preview": "pearl_live_url_preview",
    "pearl_nb_max_channel": "pearl_nb_max_channel",
    "activate_pearl_encoder": "activate_pearl_encoder",
    "pearl_templates_channel": "Template number per channel",
    "pearl_templates_nbr": "Number of templates per channel",
    "streaming_touch": "URL",
    "settings": "Settings",
    "webview": "Web view",
    "publish": "PUBLISH",
    "interact": "INTERACTIVITY",
    "publish_title": "Define sources record and stream live",
    "interact_title": "Please select interactive and social options",
    "prerol_title": "Add pre-roll and post-roll video",
    "live_broadcast": "LIVE BROADCASTING",
    "recording_sources": "RECORDING SOURCES",
    "preview_screen": "PREVIEW SCREEN",
    "sondage": "SURVEY",
    "comments": "COMMENTS",
    "final": "FINAL",
    "preview": "PREVIEW",
    "msg_preview_disabled": "Preview screen disabled",
    "form": "FORM",
    "msg_list_templates_empty": "Templates list is empty",
    "msg_config_pearl": "Please configure PEARL",
    "not_set": "Not set",
    "msg_config_channel": "No channel",
    "source_title": "Please define audio,video and skin parameters ",
    "msg_empty_src": "Sources list is empty",
    "video_source_select": "Select video source",
    "audio_source_select": "Select audio source",
    "image_select": "Select an image"
  },
  "LIVESDETAIL": {
    "lives_detail_title": "Live detail",
    "id": "ID : ",
    "title": "Title : ",
    "tags": "Tags",
    "private": "Private",
    "autoPub": "Publish automatically",
    "active": "Active",
    "description": "Description",
    "date": "Date",
    "foSondage": "Survey",
    "foComment": "Send comments",
    "foFilesShare": "Shared documents",
    "thumbnail": "Thumbnail",
    "screenShare": "Screen sharing",
    "defaultConf": "Default settings",
    "foLike": "Like",
    "foSubscript": "Registration of subscribers",
    "url_diffusion": "Broadcast url",
    "name_flux": "Name of flow",
    "login_live": "Login live",
    "pwd_live": "Password live"
  },
  "LIVESADD": {
    "form_new_title": "Add live form",
    "form_title": "Live information",
    "form_attr_title": "Title",
    "form_attr_tags": "Tags",
    "form_attr_private": "Private",
    "form_attr_autoPub": "Publish automatically",
    "form_attr_active": "Active",
    "form_attr_is_pearl": "Use Pearl encoder",
    "form_attr_type": "Type direct",
    "form_attr_settings": "Advanced settings",
    "form_attr_fo": "Front office settings",
    "form_attr_add_thumbnail": "Add a thumbnail",
    "form_attr_is_rm": "Rich media",
    "form_attr_foLike": "Like",
    "form_attr_foSondage": "Survey",
    "form_attr_description": "Description",
    "end_time": "End time",
    "form_attr_foComment": "Send comments",
    "form_attr_isCommentValidation": "With validation",
    "form_attr_foFilesShare": "Shared documents",
    "form_attr_screenShare": "Screen sharing",
    "choose_thumb": "Choose thumbnail",
    "form_attr_foSubscript": "Subscribers registration",
    "userFile": "Select document",
    "FO_blocs": "Choose the FO blocs to display :",
    "form_attr_default": "Default",
    "form_attr_custom": "Custom",
    "form_attr_Video": "Video",
    "form_attr_Counter": "Counter",
    "form_attr_pearl": "Pearl",
    "form_attr_pearl_tag": "  (Use pre-Rool and post-Rool of the Pearl configuration)",
    "form_attr_Message": "Message",
    "form_attr_Image": "Image",
    "form_attr_descLive": "Add a text before the live",
    "form_attr_titleLive": "Add a title before live",
    "form_attr_imageText": "Add a text before live",
    "form_attr_message": "Message",
    "custom_conf": "Custom configuration",
    "custom_choice": "<span style='color: rgb(213,0,0)'>Choose the option before live *</span>",
    "conf": "Configuration",
    "form_attr_socialMedia": "Social networks",
    "form_attr_passwordSecurity": "Secure live by password",
    "password": "Password",
    "default_conf": "Default configuration",
    "form_screenShare": "Choose output type for live",
    "activate_layout": "Activate layout",
    "success_layout": "Layout activated",
    "form_attr_onp": "Yes-No-NSP",
    "form_attr_on": "Yes-No"
  },
  "LIVESEDIT": {
    "form_edit_title": "Edit live lives form ",
    "form_title": "Live lives information"
  },
  "LIVEDIFFUSION": {
    "form_diffusion_title": "Live broadcast",
    "form_diffusion_title_menu_title": "Broadcast",
    "form_encoder": "Encoder Pearl",
    "video_params": "Video",
    "audio_params": "Audio",
    "resolution_params": "Resolution",
    "volume_params": "Volume",
    "add_slide": "Add slide",
    "add_chapter": "Add chapter",
    "start": "Start",
    "stop": "Stop",
    "activate_video": "Activate video",
    "disable_video": "Disable video",
    "activate_audio": "Activate audio",
    "disable_audio": "Disable audio",
    "stream_check": "You must start the stream before",
    "video_rich_media_slide_image": "Upload an image",
    "alert_not_valid_slide_image_message": "The file you've tried to upload is not an image.Please select an image with one of the following extensions: *.JPG *.JPEG *.PNG *.GIF",
    "alert_flash_not_found": "You don't have flash on your navigator, would you like to install it now?",
    "install_flash": "Install flash",
    "file_import": "The picture was imported successfully.",
    "error_time_null": "The time can't be null",
    "error_time_invalid": "The time is invalid",
    "error_time_exist": "The time already exists",
    "live_slide": "Slide",
    "live_chapter": "Chapter",
    "broadcast_slide": "Broadcast",
    "live_delete_confirm_chapter_title": "Delete chapter",
    "live_delete_confirm_slide_title": "Delete slide",
    "live_delete_confirm_chapter_content": "Do you want to delete this chapter?",
    "live_delete_confirm_slide_content": "Do you want to delete this slide?",
    "live_start_stream": "Broadcast starts now",
    "live_end_stream": "Broadcast is over",
    "live_file_import_canceled": "Upload image is canceled",
    "live_rm_update": "RichMedia data is updated successfully",
    "label_export_live": "Copy the link and share",
    "copy_btn": "Copy",
    "error_diffusion": "An error occurred during the broadcast",
    "error_alert_diffusion": "Please try again later",
    "label_start_live": "Click to start the live"
  },
  "COMMENTSEDIT": {
    "form_edit_title": "Edit comments form :",
    "form_title": "Update comment",
    "form_attr_email": "Email",
    "form_attr_comment": "Comment",
    "\t": "Parent comments",
    "choose_img": "Select a file"
  },
  "COMMENTSDETAIL": {
    "id": "Id",
    "status": "Status",
    "comment": "Comment",
    "ip": "IP",
    "created_at": "Date",
    "media_comments_detail_title": "Comments detail"
  },
  "COMMENTSLIST": {
    "image": "Picture",
    "comment": "Comment",
    "date": "Date",
    "update_comments": "Update",
    "delete_comments": "Delete",
    "delete_comments_msg": "Do you want to delete the comments?",
    "delete_comments_aria_label": "Delete comments",
    "dialog_alert_delete_title": "Successful operation",
    "dialog_alert_delete_description": " has been successfully deleted.",
    "dialog_alert_delete_close": "Close",
    "dialog_alert_delete_error_title": "Error",
    "dialog_alert_delete_error_description": "Operation not performed!",
    "added": "Comments added successfully.",
    "edited": "Comments edited successfully.",
    "dialog_alert_enable_title": "Successful operation",
    "dialog_alert_enable_description": " has been successfully enabled.",
    "dialog_alert_enable_close": "Close",
    "dialog_alert_enable_error_title": "Error",
    "dialog_alert_enable_error_description": "Operation not performed!",
    "enable_comments": "Enable",
    "disable_comments": "Disable",
    "dialog_alert_disable_title": "Successful operation",
    "dialog_alert_disable_description": " has been successfully disabled.",
    "dialog_alert_disable_close": "Close",
    "dialog_alert_disable_error_title": "Error",
    "dialog_alert_disable_error_description": "Operation not performed!",
    "status": "Status",
    "direct_comments": "Direct comments",
    "media_comments": "Media comments"
  },
  "VALIDATIONS": {
    "Lives.start_date_must_be_inferior_to_end_date": "Start Date must be less than end date"
  }
}
);

$translateProvider.translations("fr", {
  "LIVESLIST": {
    "added": "Direct ajout\u00e9 avec succ\u00e8s",
    "edited": "Direct modifi\u00e9 avec succ\u00e8s",
    "overview": "Aper\u00e7u",
    "date": "Date",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "FERMER",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "description": "Description",
    "active": "Active",
    "enable_lives": "Activer",
    "diffusion": "diffusion",
    "disable_lives": "D\u00e9sactiver",
    "disable": "D\u00e9sactiv\u00e9",
    "enable": "Activ\u00e9",
    "send_succes": "Courrier envoy\u00e9 avec succ\u00e8s",
    "send_failed": "Echec de l'envoi du mail. Essayez de nouveau",
    "send_failed_nb_mail": "\u00c9chec d'envoi. Veuillez s\u00e9lectionner au moins \"{{nb_mail}}\" emails",
    "send_mail": "Envoyer des invitations",
    "action_exportdetail": "Liens d'export du direct",
    "action_livedetail": "Information du direct",
    "action_livecomment": "Liste des commentaires",
    "action_new_element": "Ajouter un nouveau direct",
    "delete_lives_msg": "Voulez-vous supprimer le direct ?",
    "delete_lives_aria_label": "Suppression du direct",
    "dialog_alert_disable_description": " a \u00e9t\u00e9 d\u00e9sactiv\u00e9 avec succ\u00e8s.",
    "dialog_alert_enable_title": "Op\u00e9ration réussie",
    "dialog_alert_enable_description": " a \u00e9t\u00e9 activ\u00e9 avec succ\u00e8s.",
    "delete_selected_lives_msg": "Voulez-vous supprimer cette s\u00e9lection de directs ?",
    "delete_selected_live_message": "Voulez-vous supprimer cette s\u00e9lection de direct ?",
    "delete_selected_lives_aria_label": "Suppression des directs s\u00e9lectionn\u00e9s",
    "undeleted_are": "Les directs ayant comme identifiants \"{{list}}\" ne peuvent pas \u00eatre supprim\u00e9s",
    "deleted_are": "Les directs ayant comme identifiants \"{{list}}\" ont \u00e9t\u00e9 supprim\u00e9s",
    "delete_selected_live_aria_label": "Suppression des directs s\u00e9lectionn\u00e9s",
    "show_archive": "Archiv\u00e9s",
    "period": "P\u00e9riode",
    "period_week": "Semaine",
    "period_month": "Mois",
    "period_quarter": "Trimestre",
    "period_semester": "Semestre",
    "period_year": "Ann\u00e9e",
    "show_live": "En cours",
    "show_calendar": "Calendrier",
    "screen_type": "Choisir type de sortie",
    "output_type": "Type de sortie",
    "screen_share": "Ajouter un partage d'écran",
    "screen_share_download": "T\u00e9l\u00e9charger le fichier de partage d'écran",
    "live_reset": "Restaurer",
    "copied": "lien copi\u00e9"
  },
  "LIVESPEARL": {
    "streaming": "DIFFUSION CHANNEL",
    "config_streaming": "Configuration du channel",
    "config_activetemp": "Activation du template",
    "streaming_name": "Nom du diffusion ",
    "msg_Active_template": "Voulez-vous activer ce mod\u00e8le?",
    "streaming_url": "URL",
    "sources": "Sources Channel",
    "demare_record": "D\u00e9marrer le channel",
    "arrete_record": "Arr\u00eater le channel",
    "apply": "Appliquer",
    "channel_start": "D\u00e9marrer",
    "channel_stop": "Arr\u00eater",
    "recording": "Enregistrement Channel",
    "add_streaming": "Ajouter nouveau diffusion",
    "pearl_url": "pearl_url",
    "pearl_api_username": "pearl_api_username",
    "pearl_api_pwd": "pearl_api_pwd",
    "pearl_live_url_preview": "pearl_live_url_preview",
    "pearl_nb_max_channel": "pearl_nb_max_channel",
    "activate_pearl_encoder": "activate_pearl_encoder",
    "pearl_templates_channel": "Num\u00e9ro du template par channel",
    "pearl_templates_nbr": "Nombre de Template par channel",
    "streaming_touch": "URL",
    "activate_layout": "Activer layout",
    "success_layout": "Layout activ\u00e9",
    "settings": "Param\u00e8tres",
    "webview": "Vue web",
    "publish": "PUBLIER",
    "interact": "INTERACTIVITE",
    "publish_title": "D\u00e9finir l'enregistrement des sources et diffuser en direct",
    "interact_title": "Veuillez s\u00e9lectionner des options interactives et sociales",
    "prerol_title": "Ajouter pre-roll vid\u00e9o et post-roll vid\u00e9o",
    "live_broadcast": "DIFFUSION EN DIRECT",
    "recording_sources": "SOURCES D'ENREGISTREMENT",
    "preview_screen": "\u00c9CRAN DE PR\u00c9VISUALISATION",
    "sondage": "SONDAGE",
    "comments": "COMMENTAIRES",
    "final": "FINALE",
    "preview": "VISUALISER",
    "msg_preview_disabled": "Écran de prévisualisation désactivé",
    "form": "FORMULAIRE",
    "msg_list_templates_empty": "La liste des templates est vide",
    "msg_config_pearl": "Veuillez configurer PEARL",
    "not_set": "Pas encore défini",
    "msg_config_channel": "Aucun canal",
    "source_title": "Veuillez définir les paramètres audio, vidéo et fond d'écran ",
    "msg_empty_src": "La liste des sources est vide",
    "video_source_select": "Sélectionner la source vidéo",
    "audio_source_select": "Sélectionner la source audio",
    "image_select": "Sélectionner une image"
  },
  "LIVESDETAIL": {
    "lives_detail_title": "D\u00e9tail du direct",
    "id": "Identifiant : ",
    "title": "Titre : ",
    "tags": "Tags",
    "private": "Priv\u00e9",
    "autoPub": "Publier automatiquement",
    "active": "Actif",
    "description": "Description",
    "date": "Date",
    "foSondage": "Sondage",
    "foComment": "Envoi des commentaires",
    "foFilesShare": "Documents partag\u00e9s",
    "thumbnail": "Vignette",
    "screenShare": "Partage d'\u00e9cran",
    "defaultConf": "Configuration par d\u00e9faut",
    "foLike": "J'aime",
    "foSubscript": "Inscription des abonn\u00e9s",
    "url_diffusion": "Url de diffusion",
    "name_flux": "Nom de flux",
    "login_live": "Login live",
    "pwd_live": "Mot de passe live"
  },
  "LIVESADD": {
    "form_new_title": "Formulaire d'ajout d'un nouveau direct",
    "form_title": "Général",
    "form_attr_title": "Titre",
    "form_attr_tags": "Tags",
    "form_attr_private": "Priv\u00e9",
    "form_attr_autoPub": "Publier automatiquement",
    "form_attr_active": "Activ\u00e9",
    "form_attr_is_pearl": "Utiliser encodeur Pearl",
    "form_attr_type": "Type du direct",
    "form_attr_settings": "Paramètres avancés",
    "form_attr_fo": "Paramètres Front office",
    "form_attr_add_thumbnail": "Ajouter une vignette",
    "form_attr_is_rm": "Rich média",
    "form_attr_foLike": "Mention j'aime",
    "form_attr_foSondage": "Sondage",
    "form_attr_description": "Description",
    "end_time": "Heure de fin",
    "form_attr_foComment": "Activer des commentaires",
    "form_attr_isCommentValidation": "Avec confirmation",
    "form_attr_foFilesShare": "Documents partag\u00e9s",
    "form_attr_screenShare": "Partage d'\u00e9cran",
    "choose_thumb": "Choisir une vignette",
    "form_attr_foSubscript": "Inscription des abonn\u00e9s",
    "userFile": "S\u00e9lection document",
    "FO_blocs": "Choisir les blocs du FO \u00e0 afficher",
    "form_attr_default": "Par d\u00e9faut",
    "form_attr_custom": "Personnalis\u00e9",
    "form_attr_Video": "Vid\u00e9o",
    "form_attr_Counter": "Compte \u00e0 rebours",
    "form_attr_pearl": "PEARL",
    "form_attr_pearl_tag": "  (Utiliser pré-Rool et post-Rool de la configuration Pearl)",
    "form_attr_Message": "Message",
    "form_attr_Image": "Image",
    "form_attr_descLive": "Description avant live",
    "form_attr_titleLive": "Titre avant live",
    "form_attr_imageText": "Ajouter un texte affich\u00e9 avant le direct",
    "form_attr_message": "Message",
    "custom_conf": "Configuration personnalis\u00e9e",
    "custom_choice": "Param\u00e8tres avant le direct",
    "conf": "Configuration Front office",
    "form_attr_socialMedia": "R\u00e9seaux sociaux",
    "form_attr_passwordSecurity": "S\u00e9curis\u00e9 avec mot de passe",
    "password": "Mot de passe",
    "default_conf": "Configuration par d\u00e9faut",
    "form_screenShare": "Choisir type de sortie pour live",
    "form_attr_onp": "Oui-Non-NSP",
    "form_attr_on": "Oui-Non"
  },
  "LIVESEDIT": {
    "form_edit_title": "Formulaire de modification du direct ",
    "form_title": "Général"
  },
  "LIVEDIFFUSION": {
    "form_diffusion_title": "Diffusion du direct",
    "form_diffusion_title_menu_title": "Diffusion",
    "form_encoder": "Encodeur Pearl",
    "video_params": "Vid\u00e9o",
    "audio_params": "Audio",
    "resolution_params": "R\u00e9solution",
    "volume_params": "Volume",
    "add_slide": "Ajouter une diapositive",
    "add_chapter": "Ajouter un chapitre",
    "start": "Commencer",
    "stop": "Arr\u00eater",
    "activate_video": "Activer vid\u00e9o",
    "disable_video": "D\u00e9sactiver vid\u00e9o",
    "activate_audio": "Activer audio",
    "disable_audio": "D\u00e9sactiver audio",
    "stream_check": "Vous devez commencer la direct d'abord",
    "video_rich_media_slide_image": "T\u00e9l\u00e9charger une image",
    "alert_not_valid_slide_image_message": "Le fichier que vous avez essay\u00e9 de t\u00e9l\u00e9charger n'est pas une image. Veuillez s\u00e9lectionner une image avec l'une des extensions suivantes : *.PNG *.JPG *.JPEG *.GIF",
    "alert_flash_not_found": "Vous n'avez pas de flash sur votre navigateur, voulez-vous l'installer maintenant?",
    "install_flash": "Installer flash",
    "file_import": "L'image a \u00e9t\u00e9 t\u00e9l\u00e9charg\u00e9e avec succ\u00e8s.",
    "error_time_null": "Le temps ne doit pas \u00eatre nulle",
    "error_time_invalid": "Le temps est invalide",
    "error_time_exist": "Le temps existe d\u00e9j\u00e0",
    "live_slide": "Diapositive",
    "live_chapter": "Chapitre",
    "broadcast_slide": "Diffusion",
    "live_delete_confirm_chapter_title": "Suppression d'un chapitre",
    "live_delete_confirm_slide_title": "Suppression d'une diapositive",
    "live_delete_confirm_chapter_content": "Voulez-vous supprimer ce chapitre?",
    "live_delete_confirm_slide_content": "Voulez-vous supprimer cette diapositive?",
    "live_start_stream": "La diffusion a bien commenc\u00e9",
    "live_end_stream": "La diffusion est termin\u00e9e",
    "live_file_import_canceled": "T\u00e9l\u00e9chargement de l'image est annul\u00e9",
    "live_rm_update": "Les donn\u00e9es richMedia sont modifi\u00e9s avec succ\u00e8s",
    "label_export_live": "Copier le lien et partager",
    "copy_btn": "Copier",
    "error_diffusion": "Une erreur est survenue lors de la diffusion",
    "error_alert_diffusion": "Veuillez réessayer plus tard",
    "label_start_live": "Cliquer pour commencer le direct"
  },
  "COMMENTSEDIT": {
    "form_edit_title": "Formulaire de modification de commentaire : ",
    "form_title": "Modifier un commentaire",
    "form_attr_email": "Email",
    "form_attr_comment": "Commentaire",
    "choose_img": "S\u00e9lectionner un fichier"
  },
  "COMMENTSDETAIL": {
    "id": "Identifiant",
    "status": "Statut ",
    "comment": "Commentaire",
    "ip": "IP",
    "created_at": "Date",
    "media_comments_detail_title": "D\u00e9tail commentaire"
  },
  "COMMENTSLIST": {
    "image": "Image",
    "comment": "Commentaire",
    "date": "Date",
    "update_comments": "Modifier",
    "delete_comments": "Supprimer",
    "delete_comments_msg": "Voulez vous confirmer la suppression ?",
    "delete_comments_aria_label": "Supprimer le commentaire",
    "dialog_alert_delete_title": "Op\u00e9ration réussie",
    "dialog_alert_delete_description": " a \u00e9t\u00e9 supprim\u00e9 avec succ\u00e8s.",
    "dialog_alert_delete_close": "Fermer",
    "dialog_alert_delete_error_title": "Erreur",
    "dialog_alert_delete_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "added": "Commentaire ajout\u00e9 avec succ\u00e8s.",
    "edited": "Commentaire modifi\u00e9 avec succ\u00e8s.",
    "dialog_alert_enable_title": "Op\u00e9ration réussie",
    "dialog_alert_enable_description": " \u00e0 \u00e9t\u00e9 activer avec succ\u00e8s.",
    "dialog_alert_enable_close": "Fermer",
    "dialog_alert_enable_error_title": "Erreur",
    "dialog_alert_enable_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "enable_comments": "Activer",
    "disable_comments": "D\u00e9sactiver",
    "dialog_alert_disable_title": "Op\u00e9ration réussie",
    "dialog_alert_disable_description": " \u00e0 \u00e9t\u00e9 d\u00e9sactiv\u00e9 avec succ\u00e8s.",
    "dialog_alert_disable_close": "Fermer",
    "dialog_alert_disable_error_title": "Erreur",
    "dialog_alert_disable_error_description": "Op\u00e9ration non effectu\u00e9e !",
    "status": "Statut",
    "direct_comments": "Commentaires direct",
    "media_comments": "Commentaires media"
  },
  "VALIDATIONS": {
    "Lives.start_date_must_be_inferior_to_end_date": "Date de début doit être inférieur à Date de fin"
  }
}
);
}]);

angular.module("WebTv").run(["$templateCache", function($templateCache) {$templateCache.put("app/mail/mail.html","<div id=\"theme-config\" class=\"theme-config\"><div class=\"theme-config-box\"><div class=\"spin-icon\" \nng-click=\"vm.toggle()\" id=\"menu\"><md-icon md-font-icon=\"icon-email\" class=\"icon toogle-mail\"></md-icon></div><div \nclass=\"skin-setttings\"><form><div><div class=\"msgMail\">Message :</div><textarea rows=\"6\" class=\"areaMail\" flex \nng-model=\"vm.replyMessage\"></textarea></div><div style=\"margin-top: 10px\" layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-model=\"vm.sendToMe\"><label translate=\"MAIL.send_copy\">Recevoir une copie</label></md-checkbox></div>\n<div style=\"margin-top: -10px;text-align: right\"><md-button class=\"md-raised md-accent btnMail\" \nng-disabled=\"!vm.replyMessage\" ng-click=\"vm.reply()\" translate=\"MESSAGES.send\">send</md-button></div></form></div>\n</div></div>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex ng-if=\"$root.isLoadingApp\">\n<md-toolbar ng-if=\"$root.webTv_parameterBag\" id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\">\n</md-toolbar><md-content \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" class=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n<div id=\"mail\" ui-view=\"mail\"></div><div style=\"overflow: auto;    height: 100%; z-index: 1000\" \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" ui-view=\"upload\"></div><div \nng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" style=\"overflow: auto\" id=\"reupload\" \nui-view=\"reupload\"></div></div>");
$templateCache.put("app/core/layouts/horizontal-navigation-new.html","<div id=\"layout-horizontal-navigation-new\" class=\"template-layout\" layout=\"column\" flex ng-if=\"$root.isLoadingApp\"><div\n id=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\" \nng-class=\"{\'hidden\': $root.fullScreen}\"><md-toolbar id=\"toolbar\" ng-if=\"$root.webTv_parameterBag\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" \nclass=\"horizontal-navigation-new\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex style=\"width: 100%\" \nng-class=\"{\'background-menu\': $root.isFM }\" ng-if=\"state.current.url!==\'/pricing-v2\'\"></div></div><div \nid=\"content-container\" flex layout=\"column\"><div \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" style=\"overflow: auto\" \nui-view=\"upload\"></div><div ng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" \nstyle=\"overflow: auto\" id=\"reupload\" ui-view=\"reupload\"></div><md-content ms-scroll \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" ng-class=\"{\'fullScreen\': $root.fullScreen}\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><div id=\"mail\" ui-view=\"mail\"></div></div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex ng-if=\"$root.isLoadingApp\"><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\" \nng-class=\"{\'hidden\': $root.fullScreen}\"><md-toolbar id=\"toolbar\" ng-if=\"$root.webTv_parameterBag\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div id=\"horizontal-navigation\" \nui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex style=\"width: 100%\"></div></div><div \nid=\"content-container\" flex layout=\"column\"><div \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" style=\"overflow: auto\" \nui-view=\"upload\"></div><div ng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" \nstyle=\"overflow: auto\" id=\"reupload\" ui-view=\"reupload\"></div><md-content \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" ng-class=\"{\'fullScreen\': $root.fullScreen}\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><div id=\"mail\" ui-view=\"mail\"></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" ng-if=\"$root.isLoadingApp\" \nlayout=\"column\" flex><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" \nng-if=\"$root.webTv_parameterBag\" ui-view=\"toolbar\" ng-class=\"{\'hidden\': $root.fullScreen}\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\" \nng-class=\"{\'hidden\': $root.fullScreen}\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><div \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" \nstyle=\"overflow: auto;    height: 100%; z-index: 1000\" ui-view=\"upload\"></div><div \nng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" style=\"overflow: auto\" id=\"reupload\" \nui-view=\"reupload\"></div><md-content \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" ng-class=\"{\'fullScreen\': $root.fullScreen}\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><div id=\"mail\" ui-view=\"mail\"></div></div>\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" ng-if=\"$root.isLoadingApp\" \nlayout=\"column\" flex><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" \nng-if=\"$root.webTv_parameterBag\" ui-view=\"toolbar\" ng-class=\"{\'hidden\': $root.fullScreen}\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\" \nng-class=\"{\'hidden\': $root.fullScreen}\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><div \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" style=\"overflow: auto\" \nui-view=\"upload\"></div><div ng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" \nstyle=\"overflow: auto\" id=\"reupload\" ui-view=\"reupload\"></div><md-content \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" ng-class=\"{\'fullScreen\': $root.fullScreen}\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><div id=\"mail\" ui-view=\"mail\"></div></div>\n</div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" ng-if=\"$root.isLoadingApp\" flex><md-sidenav \nid=\"vertical-navigation\" class=\"md-primary-bg\" ng-class=\"{\'hidden\': $root.fullScreen}\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" ng-if=\"$root.webTv_parameterBag\" \nng-class=\"{\'hidden\': $root.fullScreen}\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nng-if=\"state.current.url===\'/medias/videos/upload\' || $root.isUploading\" id=\"upload\" style=\"overflow: auto\" \nui-view=\"upload\"></div><div ng-if=\"state.current.name===\'app.media_video_reupload\' || $root.isReuploading\" \nstyle=\"overflow: auto\" id=\"reupload\" ui-view=\"reupload\"></div><md-content \nng-if=\"!(state.current.url ===\'/medias/videos/upload\')&& !(state.current.name===\'app.media_video_reupload\')\" \nid=\"content\" ng-class=\"{\'fullScreen\': $root.fullScreen}\" class=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" \nflex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><ms-theme-options></ms-theme-options><div \nid=\"mail\" ui-view=\"mail\"></div></div>");
$templateCache.put("app/core/theme-options/theme-options.html","<md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><any ng-if=\"$root.showStyleLayout\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\" ng-if=\"vm.layoutModes.length > 0\"><div class=\"option-title\">\nLayout Mode:</div><md-radio-group layout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" \nng-change=\"vm.updateLayoutMode()\"><md-radio-button ng-repeat=\"layoutMode in vm.layoutModes\" \nng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button></md-radio-group></div><md-divider></md-divider><div \nclass=\"theme-option color-palettes\"><div class=\"option-title\">Color Palette:</div><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><md-button ng-repeat=\"(themeName, theme) in vm.themes.list\" \nclass=\"md-raised theme-button\" layout=\"row\" layout-align=\"center center\" aria-label=\"{{themeName}}\" \nng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></any></md-sidenav>");
$templateCache.put("app/main/dashboard/dashboard.template.html","<div class=\"content dashboard-gallery\" id=\"IE-dashboard-content-latest\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget has-permission=\"dashboard_count_all\" flippable=\"true\" layout=\"column\" flex=\"50\" \nflex-gt-xs=\"25\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinnerNbVideos\" class=\"md-accent\"></md-progress-linear><div ng-if=\"vm.spinnerNbVideos\"><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"light-blue-fg font-size-44 line-height-44\" \nng-class=\"{\'md-primary-fg\': vm.isFM}\">{{vm.nbVideos}}</div><div class=\"h3 secondary-text font-weight-500\" \ntranslate=\"DASHBOARD.All_videos\">All videos</div></div></div></ms-widget-front></ms-widget><ms-widget \nhas-permission=\"dashboard_filtre_video\" flippable=\"true\" layout=\"row\" flex=\"50\" flex-gt-xs=\"75\" flex-gt-md=\"75\">\n<ms-widget-front class=\"white-bg\" layout=\"row\"><div layout=\"row\" flex=\"100\" layout-align=\"space-around center\" \nid=\"e-commerce-products\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"100\" has-permission=\"dashboard_search_channel\" \nflex-gt-xs=\"45\" flex-gt-md=\"45\" style=\"margin-left: 15px\"><ms-channels style=\"width:100%\" ng-model=\"vm.canal\" \nng-change=\"vm.searchOnMostViewedVideos(\'canal\',someModelChannel)\"></ms-channels></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"100\" has-permission=\"dashboard_search_theme\" flex-gt-xs=\"45\" flex-gt-md=\"45\"><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" multi=\"false\" ng-model=\"vm.theme\" \nng-change=\"vm.searchOnMostViewedVideos(\'theme\',someModel)\" style=\"width: 98%\"></ms-themes></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" id=\"IE-dashboard-latest-video\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget ng-if=\"(vm.block1===\'true\' || vm.block1 === true) && vm.mode===\'preview_simple_list_big\'\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom dashboard_panel_custom_height\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 bold\" translate=\"DASHBOARD.Latest_Media_Videos\"></div></div><md-list flex=\"100\"><md-progress-linear \nmd-mode=\"query\" ng-hide=\"vm.spinnerLatestVideos\" class=\"md-accent\"></md-progress-linear><div \nng-if=\"vm.spinnerLatestVideos\" flex=\"100\"><div ng-if=\"vm.latestVideos.length!=0\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" layout=\"row\" style=\"width:100%\" \nflex=\"100\"><md-card flex=\"100\" layout=\"row\" style=\"padding-top: 10px;padding-bottom: 10px\"><div flex=\"35\" \nstyle=\"padding-left: 2%\"><div class=\"md-media-sm card-media\" style=\"height: 100%;width: 100%\"><div \nstyle=\"position: relative;text-align: center\"><md-icon \nng-if=\"video.principalLogo === null || video.principalLogo === \'\' || video.principalLogo === false || video.principalLogo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-src=\"{{video.principalLogo }}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \non-error-src=\"assets/images/no-image-custom.svg\" style=\"height: 100%;width: 100%\"> <a href \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div></div></div><div flex=\"55\" style=\"padding-left: 2%\" \nlayout-align=\"start start\"><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span> <span style=\"display: block;font-size: small;color: rgba(0,0,0,0.63)\">{{video.insertDate}}\n</span></div><div flex=\"10\" style=\"padding-left: 2%\" layout=\"column\"><div has-permission=\"media_video_post_edit\"><a \ntooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon \nmd-font-icon=\"icon-pencil\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div style=\"margin-top: -10px\" \nhas-permission=\"media_video_get_video_meta_data\"><a ng-if=\"video.externalLinkVideo === null\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_detail\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\">\n<md-icon md-font-icon=\"icon-meta-custom\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div \nstyle=\"margin-top: -10px\" has-permission=\"media_video_get_video_url\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.export_video\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.exportVideo(video,$index)\" aria-label=\"export\"><md-icon \nmd-font-icon=\"icon-link-variant\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\" \nstyle=\"margin-top: -10px\" has-permission=\"media_video_caption_post_generate_caption\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_video_caption\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" \naria-label=\"caption\"><md-icon md-font-icon=\"icon-closed-caption\" style=\"font-size: 16px\"></md-icon></md-button></a>\n</div></div></md-card></div></div><div ng-if=\"vm.spinnerLatestVideos\"><div ng-if=\"vm.latestVideos.length==0\" \nstyle=\"margin-left: 15px\"><h3 translate=\"DASHBOARD.no_videos\"></h3></div></div></md-list></ms-widget-front></ms-widget>\n<ms-widget \nng-if=\"(vm.block1===\'true\' || vm.block1 === true) && vm.mode===\'simpleList\' || vm.mode===\'folders\' || vm.mode===\'newMode\'\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom dashboard_panel_custom_height\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 bold\" translate=\"DASHBOARD.Latest_Media_Videos\"></div></div><md-list flex=\"100\"><md-progress-linear \nmd-mode=\"query\" ng-hide=\"vm.spinnerLatestVideos\" class=\"md-accent\"></md-progress-linear><div \nng-if=\"vm.spinnerLatestVideos\" flex=\"100\"><div ng-if=\"vm.latestVideos.length!=0\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" layout=\"row\" style=\"width:100%\" \nflex=\"100\"><md-card flex=\"100\" layout=\"row\"><div flex=\"25\" style=\"padding-left: 2%\"><div \nstyle=\"margin-top: 15px;margin-bottom: 15px\" class=\"md-media-sm card-media\" style=\"height: 100%;width: 100%\"><div \nstyle=\"position: relative;text-align: center\"><md-icon \nng-if=\"video.logo === null || video.logo === \'\' || video.logo === false || video.logo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.logo !== null && video.logo !== \'\' && video.logo !== false && video.logo !== \'not_found\'\" \nng-src=\"{{  video.logo }}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \nstyle=\"height: 100%;width: 100%;cursor: pointer\" on-error-src=\"assets/images/no-image-custom.svg\" ng-style=\"style()\" \non-resize-el> <a href \nng-if=\"video.logo !== null && video.logo !== \'\' && video.logo !== false && video.logo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div></div></div><div flex=\"45\" \nstyle=\"padding-left: 2%;margin-top: 15px;margin-bottom: 15px\" layout-align=\"start start\"><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span> <span style=\"display: block;font-size: small;color: rgba(0,0,0,0.63)\">{{video.insertDate}}\n</span></div><div flex=\"30\" layout=\"row\" layout-align=\"center center\"><div has-permission=\"media_video_post_edit\"><a \ntooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon \nmd-font-icon=\"icon-pencil\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div><a \nng-if=\"video.externalLinkVideo === null\" tooltips tooltip-template=\"{{\'MESSAGES.video_detail\'|translate}}\" \nhas-permission=\"media_video_get_video_meta_data\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\">\n<md-icon md-font-icon=\"icon-meta-custom\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div><a tooltips \ntooltip-template=\"{{\'MESSAGES.export_video\'|translate}}\" has-permission=\"media_video_get_video_url\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"show-button md-icon-button md-primary\" \nng-click=\"vm.exportVideo(video,$event,$index)\" aria-label=\"export\"><md-icon md-font-icon=\"icon-link-variant\" \nstyle=\"font-size: 16px\"></md-icon></md-button></a></div><div \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\" \nhas-permission=\"media_video_caption_post_generate_caption\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_video_caption\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" \naria-label=\"caption\"><md-icon md-font-icon=\"icon-closed-caption\" style=\"font-size: 16px\"></md-icon></md-button></a>\n</div></div></md-card></div></div><div ng-if=\"vm.spinnerLatestVideos\"><div ng-if=\"vm.latestVideos.length==0\" \nstyle=\"margin-left: 15px\"><h3 translate=\"DASHBOARD.no_videos\"></h3></div></div></md-list></ms-widget-front></ms-widget>\n<ms-widget ng-if=\"(vm.block1===\'true\' || vm.block1 === true) && vm.mode===\'small\'\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom dashboard_panel_custom_height\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3 bold\" translate=\"DASHBOARD.Latest_Media_Videos\"></div>\n</div><md-list flex=\"100\"><md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinnerLatestVideos\" class=\"md-accent\">\n</md-progress-linear><div ng-if=\"vm.spinnerLatestVideos\" flex=\"100\"><div ng-if=\"vm.latestVideos.length!=0\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" layout=\"row\" style=\"width:100%\" \nflex=\"100\"><md-card style=\"padding-top: 10px;padding-bottom: 10px\" flex=\"100\" layout=\"row\"><div flex=\"20\" \nstyle=\"padding-left: 2%\"><div class=\"md-media-sm card-media\" style=\"height: 100%;width: 100%\"><div \nstyle=\"position: relative;text-align: center\"><md-icon \nng-if=\"video.logo === null || video.logo === \'\' || video.logo === false || video.logo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.logo !== null && video.logo !== \'\' && video.logo !== false && video.logo !== \'not_found\'\" \nng-src=\"{{video.logo }}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \non-error-src=\"assets/images/no-image-custom.svg\" style=\"height: 100%;width: 100%;cursor: pointer\"> <a href \nng-if=\"video.logo !== null && video.logo !== \'\' && video.logo !== false && video.logo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div></div></div><div flex=\"50\" style=\"padding-left: 2%\" \nlayout-align=\"start start\"><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span> <span style=\"display: block;font-size: x-small;color: rgba(0,0,0,0.63)\">{{video.insertDate}}\n</span></div><div flex=\"30\" layout=\"row\" layout-align=\"center center\"><div has-permission=\"media_video_post_edit\"><a \ntooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon \nmd-font-icon=\"icon-pencil\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div style=\"margin-top: -5px\"><a \nng-if=\"video.externalLinkVideo === null\" tooltips tooltip-template=\"{{\'MESSAGES.video_detail\'|translate}}\" \nhas-permission=\"media_video_get_video_meta_data\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\">\n<md-icon md-font-icon=\"icon-meta-custom\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div \nstyle=\"margin-top: -5px\"><a tooltips tooltip-template=\"{{\'MESSAGES.export_video\'|translate}}\" \nhas-permission=\"media_video_get_video_url\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.exportVideo(video,$event,$index)\" aria-label=\"export\">\n<md-icon md-font-icon=\"icon-link-variant\" style=\"font-size: 16px\"></md-icon></md-button></a></div><div \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\" \nstyle=\"margin-top: 2px\" has-permission=\"media_video_caption_post_generate_caption\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_video_caption\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" \naria-label=\"caption\"><md-icon md-font-icon=\"icon-closed-caption\" style=\"font-size: 16px\"></md-icon></md-button></a>\n</div></div></md-card></div></div><div ng-if=\"vm.spinnerLatestVideos\"><div ng-if=\"vm.latestVideos.length==0\" \nstyle=\"margin-left: 15px\"><h3 translate=\"DASHBOARD.no_videos\"></h3></div></div></md-list></ms-widget-front></ms-widget>\n<ms-widget ng-if=\"(vm.block1===\'true\' || vm.block1 === true) && vm.mode===\'gallery\'\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"100\"><div><ms-widget-front class=\"white-bg\"><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinnerLatestVideos\" class=\"md-accent\"></md-progress-linear><div flex layout=\"row\" \nclass=\"ph-16 pv-16 border-bottom dashboard_panel_custom_height\" layout-align=\"space-between center\"><div \nclass=\"md-headline ng-binding\" translate=\"DASHBOARD.Latest_Media_Videos\"></div></div><div class=\"empty_videos\" \nflex=\"100\" layout=\"row\" ng-if=\"vm.latestVideos.length == 0\"><span class=\"empty-text\" \ntranslate=\"MESSAGES.empty_dashboard\">Pas de vidéos récentes à afficher pour le moment !</span><md-button \nstyle=\"margin-left: -5px\" class=\"empty-button md-icon-button\" ng-click=\"vm.goToAddVideo()\" aria-label=\"Add video\" \ntranslate translate=\"MESSAGES.add_videos\"><span class=\"empty-text\">Ajouter des vidéos</span></md-button></div><div \nflex layout=\"row\" ng-if=\"vm.latestVideos.length> 0 && vm.latestVideos.length<=2\"><div ng-if=\"vm.spinnerLatestVideos\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" flex=\"20\" \nng-if=\"vm.latestVideos.length!==0 && $index<2\" layout=\"column\"><md-card><div \nstyle=\"position: relative;max-width: 100%;text-align: center\"><md-icon \nng-if=\"video.principalLogo === null || video.principalLogo === \'\' || video.principalLogo === false || video.principalLogo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-src=\"{{video.principalLogo}}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \nstyle=\"height: 100%;width: 100%;cursor: pointer\"> <a href \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div><div layout=\"row\" has-permission=\"media_video_settings\" \nlayout-align=\"start center\"><div><md-menu><a tooltips tooltip-template=\"{{\'MESSAGES.more_details\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button style=\"margin-left: -5px\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"ASK FOR SUPPORT\" translate \ntranslate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button></a>\n<md-menu-content width=\"6\" style=\"text-align: center\"><md-menu-item has-permission=\"media_video_post_edit\"><md-button \nstyle=\"color: #2d333e\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon><span translate=\"MESSAGES.action_edit\"></span></md-button></md-menu-item><md-menu-item><md-button\n style=\"color: #2d333e\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\"><md-icon \nmd-font-icon=\"icon-meta-custom\" class=\"s16\"></md-icon><span translate=\"MESSAGES.video_detail\"></span></md-button>\n</md-menu-item><md-menu-item><md-button style=\"color: #2d333e\" ng-click=\"vm.exportVideo(video,$event,$index)\" \naria-label=\"export\"><md-icon md-font-icon=\"icon-link-variant\" class=\"s16\"></md-icon><span \ntranslate=\"MESSAGES.export_video\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\">\n<md-button style=\"color: #2d333e\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" aria-label=\"caption\"><md-icon \nmd-font-icon=\"icon-closed-caption\" class=\"s16\"></md-icon><span translate=\"MESSAGES.action_video_caption\"></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span></div></div></md-card></div></div><div flex layout=\"row\" \nng-if=\"vm.latestVideos.length>2 && vm.latestVideos.length<=4 \"><div ng-if=\"vm.spinnerLatestVideos\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" flex=\"20\" \nng-if=\"vm.latestVideos.length!=0 && $index>=2 && $index<4\" layout=\"column\"><md-card><div \nstyle=\"position: relative;max-width: 100%;text-align: center\"><md-icon \nng-if=\"video.principalLogo === null || video.principalLogo === \'\' || video.principalLogo === false || video.principalLogo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-src=\"{{video.principalLogo}}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \nstyle=\"height: 100%;width: 100%;cursor: pointer\"> <a href \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div><div layout=\"row\" has-permission=\"media_video_settings\" \nlayout-align=\"start center\"><div><md-menu><a tooltips tooltip-template=\"{{\'MESSAGES.more_details\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button style=\"margin-left: -5px\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"ASK FOR SUPPORT\" translate \ntranslate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button></a>\n<md-menu-content width=\"6\" style=\"text-align: center\"><md-menu-item has-permission=\"media_video_post_edit\"><md-button \nstyle=\"color: #2d333e\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon><span translate=\"MESSAGES.action_edit\"></span></md-button></md-menu-item><md-menu-item><md-button\n style=\"color: #2d333e\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\"><md-icon \nmd-font-icon=\"icon-meta-custom\" class=\"s16\"></md-icon><span translate=\"MESSAGES.video_detail\"></span></md-button>\n</md-menu-item><md-menu-item><md-button style=\"color: #2d333e\" ng-click=\"vm.exportVideo(video,$event,$index)\" \naria-label=\"export\"><md-icon md-font-icon=\"icon-link-variant\" class=\"s16\"></md-icon><span \ntranslate=\"MESSAGES.export_video\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\">\n<md-button style=\"color: #2d333e\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" aria-label=\"caption\"><md-icon \nmd-font-icon=\"icon-closed-caption\" class=\"s16\"></md-icon><span translate=\"MESSAGES.action_video_caption\"></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span></div></div></md-card></div></div><div flex layout=\"row\" \nng-if=\"vm.latestVideos.length>4 && vm.latestVideos.length<=5\"><div ng-if=\"vm.spinnerLatestVideos\" \nng-repeat=\"video in vm.latestVideos track by video.id\" ng-attr-data-index=\"{{$index}}\" flex=\"20\" \nng-if=\"vm.latestVideos.length!=0 && $index>=4\" layout=\"column\"><md-card><div \nstyle=\"position: relative;max-width: 100%;text-align: center\"><md-icon \nng-if=\"video.principalLogo === null || video.principalLogo === \'\' || video.principalLogo === false || video.principalLogo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-src=\"{{video.principalLogo}}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \nstyle=\"height: 100%;width: 100%;cursor: pointer\"> <a href \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div><div layout=\"row\" layout-align=\"start center\" \nhas-permission=\"media_video_settings\"><div><md-menu><a tooltips \ntooltip-template=\"{{\'MESSAGES.more_details\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nstyle=\"margin-left: -5px\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"ASK FOR SUPPORT\" translate \ntranslate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button></a>\n<md-menu-content width=\"6\" style=\"text-align: center\"><md-menu-item has-permission=\"media_video_post_edit\"><md-button \nstyle=\"color: #2d333e\" ng-click=\"vm.editVideo(video)\" aria-label=\"edit\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s16\"></md-icon><span translate=\"MESSAGES.action_edit\"></span></md-button></md-menu-item><md-menu-item><md-button\n style=\"color: #2d333e\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\"><md-icon \nmd-font-icon=\"icon-meta-custom\" class=\"s16\"></md-icon><span translate=\"MESSAGES.video_detail\"></span></md-button>\n</md-menu-item><md-menu-item><md-button style=\"color: #2d333e\" ng-click=\"vm.exportVideo(video,$event,$index)\" \naria-label=\"export\"><md-icon md-font-icon=\"icon-link-variant\" class=\"s16\"></md-icon><span \ntranslate=\"MESSAGES.export_video\"></span></md-button></md-menu-item><md-menu-item \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\">\n<md-button style=\"color: #2d333e\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" aria-label=\"caption\"><md-icon \nmd-font-icon=\"icon-closed-caption\" class=\"s16\"></md-icon><span translate=\"MESSAGES.action_video_caption\"></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span></div></div></md-card></div></div><div class=\"latest-videos\" ng-if=\"vm.latestVideos.length>5\">\n<div class=\"latest-videos-card\" ng-if=\"vm.spinnerLatestVideos\" ng-repeat=\"video in vm.latestVideos track by video.id\" \nng-attr-data-index=\"{{$index}}\" ng-if=\"vm.latestVideos.length!=0 && $index>=4\" layout=\"column\"><md-card \nclass=\"no-box-shadow\"><div style=\"position: relative;max-width: 100%;text-align: center\"><md-icon \nng-if=\"video.principalLogo === null || video.principalLogo === \'\' || video.principalLogo === false || video.principalLogo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon><img \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-src=\"{{video.principalLogo}}\" ng-click=\"vm.previewVideo(video,$event,$index)\" \nstyle=\"height: 100%;width: 100%;cursor: pointer;border-radius: 10px\"> <a href \nng-if=\"video.principalLogo !== null && video.principalLogo !== \'\' && video.principalLogo !== false && video.principalLogo !== \'not_found\'\" \nng-click=\"vm.previewVideo(video,$event,$index)\" class=\"position-icon-play\"><img \nng-src=\"assets/images/logos/overlay.png\"></a></div><div layout=\"row\" layout-align=\"space-between\" \nstyle=\"margin-top: 20px\"><div><span \nstyle=\"display: block;font-size: medium;color: rgba(0,0,0,0.87);overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 1;\n    -webkit-box-orient: vertical\">\n{{video.title}}</span></div><div layout=\"row\"><md-icon md-font-icon=\"icon-calendar-new\" class=\"icon icon-calendar\">\n</md-icon><span style=\"display: block;font-size: medium;color: rgba(0,0,0,0.87)\">{{video.insertDate}}</span></div>\n</div></md-card></div></div></ms-widget-front></div></ms-widget><ms-widget \nng-if=\"vm.block2===\'true\' || vm.block2===true\" has-permission=\"dashboard_most_popular\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom dashboard_panel_custom_height\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3 bold\" translate=\"DASHBOARD.TopFive_Media_Videos\"></div>\n</div><md-list flex><md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinnerTop5\" class=\"md-accent\">\n</md-progress-linear><div ng-if=\"vm.spinnerTop5\"><div ng-if=\"vm.mostViewd.length!=0\" \nng-repeat=\"video in vm.mostViewd track by video.id\" ng-attr-data-index=\"{{$index}}\" layout=\"row\"><div flex=\"5\" \nstyle=\"padding-left: 2%\"><h2>{{vm.mostViewd.indexOf(video)+1}}</h2></div><div flex=\"95\"><md-card style=\"height: 168px\">\n<md-card-title><md-card-title-text><span class=\"md-headline\" ng-if=\"video.title==\'noVideo\'\" \ntranslate=\"DASHBOARD.deleted_video\"></span> <span class=\"md-headline\" ng-if=\"video.title!=\'noVideo\'\">{{video.title}}\n</span><div style=\"display: inline\"><md-icon md-font-icon=\"icon-meta-custom\" class=\"s18\"></md-icon><span \nclass=\"md-subhead\">{{video.views}}</span> <span class=\"md-subhead\" translate=\"DASHBOARD.nbVisits\"></span></div><div \nstyle=\"display: inline\"><md-icon md-font-icon=\"icon-timelapse\" class=\"s18\"></md-icon><span class=\"md-subhead\">\n{{video.duree}}</span></div></md-card-title-text><md-card-title-media><div ng-if=\"video.logo!=\'\'\" \nclass=\"md-media-sm card-media\" style=\"height: 100%;width: 100%\"><div style=\"max-width: 192px\"><img \nng-src=\"{{ video.logo }}\" on-error-src=\"assets/images/no-image-custom.svg\"></div><div \nstyle=\"height: 30%;width: 30%; margin-left: 65px;margin-top: -85px\"><a href \nng-click=\"vm.previewVideo(video,$event,$index)\"><img ng-src=\"assets/images/logos/overlay.png\" \nstyle=\"width: 36px; margin-left: 15px;margin-top: 15px\"></a></div></div><div ng-if=\"video.logo==\'\'\" \nclass=\"md-media-sm card-media\" style=\"height: 100%;width: 100%\"><div style=\"padding: 20px 50px 0 20px\"><md-icon \nmd-font-icon=\"icon-no-image-custom\" class=\"s62\" style=\"opacity: .6\"></md-icon></div></div></md-card-title-media>\n</md-card-title><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"video.fileTitle!=\'noFile\'\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" has-permission=\"media_video_post_edit\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"show-button md-icon-button md-primary\" ng-click=\"vm.editVideo(video)\" \naria-label=\"edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></a><a \nng-if=\"video.externalLinkVideo === null\" tooltips tooltip-template=\"{{\'MESSAGES.video_detail\'|translate}}\" \nhas-permission=\"media_video_get_video_meta_data\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ng-click=\"vm.showVideoDetail(video,$event,$index)\" aria-label=\"show\">\n<md-icon md-font-icon=\"icon-meta-custom\" class=\"s18\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'MESSAGES.export_video\'|translate}}\" has-permission=\"media_video_get_video_url\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"show-button md-icon-button md-primary\" \nng-click=\"vm.exportVideo(video,$event,$index)\" aria-label=\"export\"><md-icon md-font-icon=\"icon-link-variant\" \nclass=\"s18\"></md-icon></md-button></a><a \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\" \ntooltips tooltip-template=\"{{\'MESSAGES.action_video_caption\'|translate}}\" \nhas-permission=\"media_video_caption_post_generate_caption\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button md-primary\" ui-sref=\"app.media_video_caption_new({ id: video.id})\" \naria-label=\"caption\"><md-icon md-font-icon=\"icon-closed-caption\" class=\"s18\"></md-icon></md-button></a>\n</md-card-actions></md-card></div></div></div><div ng-if=\"vm.spinnerTop5\"><div ng-if=\"vm.mostViewd.length==0\" \nstyle=\"margin-left: 15px\"><h3 translate=\"DASHBOARD.no_videos\"></h3></div></div></md-list></ms-widget-front></ms-widget>\n<ms-widget ng-if=\"vm.block3===\'true\' || vm.block3===true\" has-permission=\"dashboard_most_popular\" layout=\"column\" \nflex=\"100\" flex-gt-sm=\"50\"><md-card style=\"width: 100%;margin: 0\"><audience-stats query=\"vm.query\"></audience-stats>\n</md-card></ms-widget><ms-widget ng-if=\"vm.block4===\'true\' || vm.block4===true\" \nhas-permission=\"dashboard_most_popular\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><md-card \nstyle=\"width: 100%;margin: 0\"><duree-stats query=\"vm.query\"></duree-stats></md-card></ms-widget></div></div>");
$templateCache.put("app/main/login-v2/alert-not-authorised.html","<md-dialog style=\"width: 35%;max-width: 680px;min-width: 500px\" aria-label=\"Alert\"><md-dialog-content><div \nstyle=\"text-align: center\" class=\"md-dialog-content\"><img ng-src=\"assets/images/lock.jpg\"><h1 \ntranslate=\"LOGINV2.not_authorised\" \nstyle=\"font-weight: 700;font-size: 26px;margin-bottom: -15px;margin-top: 50px;color: #2e4e81\">Accés non authorisé</h1>\n<h2 translate=\"LOGINV2.contact_admin\" style=\"font-size: 19px\">Veuillez contacter l\'administrateur</h2></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex show-gt-sm \nng-class=\"[{\'loginBackground\' : vm.isFM && !vm.logo },{\'loginFMBackground\' : vm.isFM && vm.logo }]\"><video \ndata-ng-style=\"!$root.access && {\'right\':\'0\'}\" autoplay muted loop id=\"myVideo\" ng-if=\"!vm.isFM\"><source \nng-src=\"assets/mockup/by.mp4\" type=\"video/mp4\"></video><div class=\"content\" \ndata-ng-style=\"!$root.access && {\'display\':\'none\'}\"><div id=\"login-v2-block-content\"><div id=\"logo\"><img \nng-style=\"{{vm.image_style}}\" ng-src=\"{{vm.image}}\"></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div style=\"padding-top: 50px\" id=\"login-v2-form\"><div \nlayout-align=\"center center\" layout=\"row\"><div flex=\"50\" class=\"title\" translate=\"LOGINV2.Connexion\">Connexion</div>\n<div flex=\"50\"><md-menu id=\"language-menu\" md-offset=\"0 50\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" style=\"border: 1px solid #cfcfcf;border-radius: 0.5rem;float: right\" \naria-label=\"Language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso lang-login\">\n{{vm.selectedLanguage.code}}</span></div><div flex><md-icon class=\"s22 icon_down_lang_login\" \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso lang-login\">\n{{vm.selectedLanguage.code}}</span></div><div flex><md-icon class=\"s22 icon_down_lang_login\" \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></div></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"lang.title\" translate translate-attr-aria-label=\"{{lang.translation}}\">\n<span layout=\"row\" layout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> \n<span ng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">\n{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div><form \nname=\"empLoginForm\" id=\"empLoginForm\" ng-submit=\"empLoginForm.$valid && vm.submitLoginForm()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><span translate=\"LOGINV2.USERNAME\" \nstyle=\"font-size: 20px;color:#818181\">Nom d\'utilisateur</span> <input type=\"text\" name=\"username\" \nng-model=\"vm.empLoginForm.username\" placeholder=\"USERNAME\" translate translate-attr-placeholder=\"LOGINV2.USERNAME\" \nrequired><div ng-messages=\"empLoginForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MESSAGES.form_is_required\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"$root.remember\" aria-label=\"Remember Me\"><span translate=\"LOGINV2.REMEMBER_ME\">\nRemember Me</span></md-checkbox></div><div><div ng-if=\"vm.inscription\" class=\"inscription-text\" layout=\"row\" \nlayout-align=\"left\"><span class=\"ins-text1\" translate=\"LOGINV2.not_a_membre\">not a member yet ?</span> <a \nstyle=\"cursor: pointer\" translate=\"LOGINV2.sign_up\" ng-click=\"vm.goToSingUp()\">Sign up</a></div><md-button \ntype=\"submit\" class=\"md-raised circular-progress-button md-accent submit-button submit-button-mobile\" \naria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\"><span ng-if=\"!vm.showSpinner\" \ntranslate=\"LOGINV2.NEXT\">Next</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" \nng-if=\"vm.showSpinner\"></md-progress-circular></md-button></div></form></div></div></div><div id=\"bottom-block-login\">\n<div id=\"corp\"><span>© {{date| date:\'yyyy\'}} empreinte.com</span></div><div id=\"licence\"><a target=\"_blank\" \nhref=\"https://www.empreinte.com/mentions-legales/\" translate=\"LOGINV2.licence\">Licence du logiciel</a></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/inscription-v2/inscription-v2.html","<div style=\"width: 100%;height: 100%\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div id=\"inscription\" layout=\"row\" \nlayout-align=\"start\"><div id=\"inscription-intro\" flex show-gt-sm ng-class=\"{\'inscriptionBackground\' : vm.isFM }\"><div \nclass=\"content\"><div id=\"inscription-block-content\"><div id=\"logo\"><img ng-style=\"{{vm.image_style}}\" \nng-src=\"{{vm.image}}\"></div><div id=\"inscription-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div\n id=\"inscription-form\"><div layout-align=\"center center\" layout=\"row\" style=\"height: 100%;\n            width: 100%\">\n<iframe id=\"iframe_inscription\" ng-src=\"{{vm.trustLink(vm.urlInscription)}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%\"></iframe></div></div></div><div id=\"bottom-block-inscription\"><div id=\"corp\"><span>\n© {{vm.date| date:\'yyyy\'}} empreinte.com</span></div><div id=\"licence\"><a target=\"_blank\" \nhref=\"https://www.empreinte.com/mentions-legales/\" translate=\"LOGINV2.licence\">Licence du logiciel</a></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/login-step2/forget-password.html","<md-dialog style=\"min-width: 40%\" aria-label=\"abonnement_user_detail_pagetitle}}\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"LOGINV2.reset_password\">reset_password</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><form name=\"myForm\" method=\"post\" ng-submit=\"myForm.$valid && vm.sendEmailReset()\"><div \nclass=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><div class=\"description\" \ntranslate=\"LOGINV2.send_mail_to\">Sed mollis velit facilisis facilisis viverra</div><md-input-container \nclass=\"md-block\" md-no-float><input id=\"forgot-password\" type=\"email\" name=\"email\" ng-model=\"vm.email\" \nplaceholder=\"email\" ng-attr-name=\"email\" translate translate-attr-placeholder=\"LOGINV2.email\" required>\n</md-input-container><md-button type=\"submit\" class=\"md-raised circular-progress-button md-accent submit-button\" \naria-label=\"LOG IN\" ng-disabled=\"myForm.$invalid || myForm.$pristine\"><span>{{\'LOGINV2.reset_password\' | translate}}\n</span></md-button></div></form></md-dialog-content></md-dialog>");
$templateCache.put("app/main/login-step2/login-step2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex show-gt-sm \nng-class=\"[{\'loginBackground\' : vm.isFM && !vm.logo },{\'loginFMBackground\' : vm.isFM && vm.logo }]\"><video \ndata-ng-style=\"!$root.access && {\'right\':\'0\'}\" autoplay muted loop id=\"myVideo\" ng-if=\"!vm.isFM\"><source \nng-src=\"assets/mockup/by.mp4\" type=\"video/mp4\"></video><div class=\"content\" \ndata-ng-style=\"!$root.access && {\'display\':\'none\'}\"><div id=\"login-v2-block-content\"><div id=\"logo\"><img \nng-style=\"{{vm.image_style}}\" ng-src=\"{{vm.image}}\"></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div style=\"padding-top: 50px\" id=\"login-v2-form\"><div \nlayout-align=\"center center\" layout=\"row\"><div flex=\"50\" class=\"title\" translate=\"LOGINV2.TITLE\">Log in to your account\n</div><div flex=\"50\"><md-menu id=\"language-menu\" md-offset=\"0 50\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" style=\"border: 1px solid #cfcfcf;border-radius: 0.5rem;float: right\" \naria-label=\"Language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso lang-login\">\n{{vm.selectedLanguage.code}}</span></div><div flex><md-icon class=\"s22 icon_down_lang_login\" \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso lang-login\">\n{{vm.selectedLanguage.code}}</span></div><div flex><md-icon class=\"s22 icon_down_lang_login\" \nmd-font-icon=\"icon-chevron-down\"></md-icon></div></div></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"lang.title\" translate translate-attr-aria-label=\"{{lang.translation}}\">\n<span layout=\"row\" layout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> \n<span ng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">\n{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nclass=\"description\" translate=\"LOGINV2.DESCRIPTION\">Sed mollis velit facilisis facilisis viverra</div><div><form \nname=\"empLoginForm\" id=\"empLoginForm\" ng-submit=\"empLoginForm.$valid && vm.submitLoginForm()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><span translate=\"LOGINV2.PASSWORD\" \nstyle=\"font-size: 20px;color:#818181\">Mot de passe</span> <input type=\"password\" name=\"password\" \nng-model=\"vm.empLoginForm.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGINV2.PASSWORD\" \nrequired><div ng-messages=\"empLoginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MESSAGES.form_is_required\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"$root.remember\" aria-label=\"Remember Me\"><span translate=\"LOGINV2.REMEMBER_ME\">\nRemember Me</span></md-checkbox><a style=\"cursor: pointer\" ng-click=\"vm.forgetPassword()\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGINV2.FORGOT_PASSWORD\">Forgot Password?</a></div><div \nclass=\"layout-sm-column layout-align-space-between-center layout-row\"><md-button class=\"md-raised cancel-button\" \nng-click=\"vm.returnToStep1()\" aria-label=\"form_cancel\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon><span>\n{{\'LOGINV2.previous\' | translate}}</span></md-button><md-button type=\"submit\" \nclass=\"md-raised circular-progress-button md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\"><span ng-if=\"!vm.showSpinner\">{{\'LOGINV2.LOG_IN\' | translate}}\n</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"20\" ng-if=\"vm.showSpinner\"></md-progress-circular>\n</md-button></div></form></div></div></div><div id=\"bottom-block-login\"><div id=\"corp\"><span>\n© {{date| date:\'yyyy\'}} empreinte.com</span></div><div id=\"licence\"><a target=\"_blank\" \nhref=\"https://www.empreinte.com/mentions-legales/\" translate=\"LOGINV2.licence\">Licence du logiciel</a></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/pricing-v2/pricing-v2.template.html","<div id=\"price-v2-tables\" class=\"page-layout simple fullwidth doc-page w3-white\"><iframe id=\"iframe_pricing\" \nng-src=\"{{vm.urlPricing}}\" iframe-onload=\"iframeLoadedCallBack()\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div>");
$templateCache.put("app/main/pricing/pricing.template.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page w3-white\"><div layout=\"column\" align=\"center\" \nstyle=\"margin-top: 20px\"><span class=\"title-price\">Mettre à niveau de votre forfait</span> <span \nclass=\"description-price\">\nLorem ipsum dolor sit amet,consecteur adipidcing elit. Aenean commodo ligula eget dolor.Aenean massa. Cum sociis</span>\n <span class=\"description-price\">\nnatoque penatibus et magnis dis parturient montes, nascteur ridicul mus. Donec quam felis, ultricies nec</span></div>\n<div class=\"content\"><div class=\"price-tables\" flex layout=\"row\" layout-wrap style=\"justify-content: center\"><div \nstyle=\"margin-top: 79px\" class=\"price-table style-1\" layout=\"column\"><div class=\"package-type\" layout=\"column\" \nalign=\"center\"><span class=\"w3-grey\">FREE</span> <span class=\"w3-summer-sky\">DEPART</span></div><div \nstyle=\"border: 2px solid grey;border-radius: 5px\"><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div \nlayout=\"column\" layout-align=\"center\"><div layout=\"row\"><div class=\"value w3-summer-sky\">0</div><div \nclass=\"currency w3-summer-sky\">€</div></div><div class=\"period w3-summer-sky\">/ mois</div></div></div><md-divider \nclass=\"w3-summer-sky\"></md-divider><div class=\"terms terms-height\" layout=\"column\"><div class=\"term term-margin\">\n<md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>Jusqu\'à 30 min de direct</span></div><div \nclass=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>160 VOD</span>\n</div><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>\n5 GO de diffusion</span></div><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-close1\" \nclass=\"icon icon-close\"></md-icon><span>Pack Secure</span></div><div class=\"term term-margin\"><md-icon \nmd-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>25 Email</span></div></div><md-button \nclass=\"button\">Offre actuel</md-button></div></div><div class=\"price-table style-1 w3-cosmic-latte\" layout=\"column\">\n<div class=\"package-type\" layout=\"column\" align=\"center\"><span class=\"w3-grey\">BASIC</span> <span \nclass=\"w3-summer-sky\">POPULAIRE</span></div><div \nstyle=\"border: 2px solid #4ebbeb;background-color: #e9fced;border-radius: 5px\"><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><div layout=\"column\" layout-align=\"center\"><div style=\"height:55px\"></div><div \nlayout=\"row\"><div class=\"value w3-summer-sky\">50</div><div class=\"currency w3-summer-sky\">€</div></div><div \nclass=\"period w3-summer-sky\">/ mois</div></div></div><md-divider class=\"w3-summer-sky\"></md-divider><div \nclass=\"terms terms-height\" layout=\"column\"><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" \nclass=\"icon icon-check\"></md-icon><span>Jusqu\'à 30 min de direct</span></div><div class=\"term term-margin\"><md-icon \nmd-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>160 VOD</span></div><div class=\"term term-margin\">\n<md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>5 GO de diffusion</span></div><div \nclass=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>Pack Secure</span>\n</div><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>\n25 Email</span></div></div><md-button class=\"button\">Commencer maintenant</md-button></div></div><div \nstyle=\"margin-top: 79px\" class=\"price-table style-1\" layout=\"column\"><div class=\"package-type\" layout=\"column\" \nalign=\"center\"><span class=\"w3-grey\">PRO</span> <span class=\"w3-summer-sky\">TRES POPULAIRE</span></div><div \nstyle=\"border: 2px solid grey;border-radius: 5px\"><div style=\"height: 52px\"></div><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><md-button class=\"w3-summer-sky\">Contacter nous</md-button></div><md-divider \nclass=\"w3-summer-sky\"></md-divider><div class=\"terms terms-height\" layout=\"column\"><div class=\"term term-margin\">\n<md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>Jusqu\'à -- min de direct</span></div><div \nclass=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>-- VOD</span>\n</div><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>\n-- GO de diffusion</span></div><div class=\"term term-margin\"><md-icon md-font-icon=\"icon-check1\" \nclass=\"icon icon-check\"></md-icon><span>Pack Secure</span></div><div class=\"term term-margin\"><md-icon \nmd-font-icon=\"icon-check1\" class=\"icon icon-check\"></md-icon><span>-- Email</span></div><div class=\"term term-margin\">\n<md-icon md-font-icon=\"icon-plus1\" class=\"icon icon-plus\"></md-icon><span>TV</span></div></div><md-button \nclass=\"button\">Contacter nous</md-button></div></div></div></div></div>");
$templateCache.put("app/main/two-factor-auth/two-factor-auth.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex show-gt-sm \nng-class=\"[{\'loginBackground\' : vm.isFM && !vm.logo },{\'loginFMBackground\' : vm.isFM && vm.logo }]\"><video \ndata-ng-style=\"!$root.access && {\'right\':\'0\'}\" autoplay muted loop id=\"myVideo\" ng-if=\"!vm.isFM\"><source \nng-src=\"assets/mockup/by.mp4\" type=\"video/mp4\"></video><div class=\"content\" \ndata-ng-style=\"!$root.access && {\'display\':\'none\'}\"><div id=\"login-v2-block-content\"><div id=\"logo\"><img \nng-style=\"{{vm.image_style}}\" ng-src=\"{{vm.image}}\"></div><div id=\"login-v2-form-wrapper\" \nclass=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div><div flex=\"98\" style=\"padding-top: 13px;padding-right: 20px\">\n<md-menu id=\"language-menu\" md-offset=\"0 50\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" style=\"border: 1px solid #cfcfcf;border-radius: 0.5rem;float: right\" aria-label=\"Language\" \ntranslate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" layout-align=\"center\"><div flex>\n<span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso lang-login\">{{vm.selectedLanguage.code}}</span>\n</div><div flex><md-icon class=\"s22 icon_down_lang_login\" md-font-icon=\"icon-chevron-down\"></md-icon></div></div><div \nng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" layout-align=\"center\"><div flex><span class=\"translate-flag-en\">\n</span></div><div flex><span class=\"iso lang-login\">{{vm.selectedLanguage.code}}</span></div><div flex><md-icon \nclass=\"s22 icon_down_lang_login\" md-font-icon=\"icon-chevron-down\"></md-icon></div></div></div></md-button>\n<md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"lang.title\" translate translate-attr-aria-label=\"{{lang.translation}}\">\n<span layout=\"row\" layout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> \n<span ng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">\n{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nstyle=\"padding-top: 60px\" id=\"login-v2-two-factor-form\"><div layout-align=\"center center\" layout=\"column\"><div \nclass=\"title\" translate=\"TWO_FACTOR_AUTH.TITLE\" style=\"font-size: 25px;padding-top: 10px\">Connexion</div><span \ntranslate=\"TWO_FACTOR_AUTH.CODE\" \nstyle=\"text-align: center;font-size: 16px;color: #606268;font-weight: 400;padding-top: 35px;white-space: pre-wrap\">Code\n</span><div><form style=\"text-align: center;padding-top: 3px\" class=\"md-block\" name=\"codeForm\" id=\"empLoginForm\" \nng-submit=\"codeForm.$valid && vm.submitCodeForm()\" novalidate><md-input-container><input min=\"0\" max=\"9\" \naria-label=\"code1\" style=\"width: 48px;height: 48px\" type=\"number\" name=\"code\" ng-model=\"vm.codeForm.code1\" required>\n</md-input-container><md-input-container><input min=\"0\" max=\"9\" aria-label=\"code2\" style=\"width: 48px;height: 48px\" \ntype=\"number\" name=\"code\" ng-model=\"vm.codeForm.code2\" required></md-input-container><md-input-container><input \nmin=\"0\" max=\"9\" aria-label=\"code3\" style=\"width: 48px;height: 48px\" type=\"number\" name=\"code\" \nng-model=\"vm.codeForm.code3\" required></md-input-container><md-input-container><input min=\"0\" max=\"9\" \naria-label=\"code4\" style=\"width: 48px;height: 48px\" type=\"number\" name=\"code\" ng-model=\"vm.codeForm.code4\" required>\n</md-input-container><md-input-container><input min=\"0\" max=\"9\" aria-label=\"code5\" style=\"width: 48px;height: 48px\" \ntype=\"number\" name=\"code\" ng-model=\"vm.codeForm.code5\" required></md-input-container><md-input-container><input \nmin=\"0\" max=\"9\" aria-label=\"code6\" style=\"width: 48px;height: 48px\" type=\"number\" name=\"code\" \nng-model=\"vm.codeForm.code6\" required></md-input-container><md-button type=\"submit\" \nstyle=\"margin-top: 20px;margin-bottom: 15px;border-radius: 8px 8px 8px 10px;height: 49px;width: 90%\" \nclass=\"md-block md-raised circular-progress-button md-accent submit-button submit-button-mobile\" \naria-label=\"SEND_CODE\" ng-disabled=\"codeForm.$invalid\"><span ng-if=\"!vm.showSpinner\" translate=\"TWO_FACTOR_AUTH.SEND\">\nSend</span><md-progress-circular md-mode=\"indeterminate\" md-diameter=\"21\" ng-if=\"vm.showSpinner\">\n</md-progress-circular></md-button></form></div></div></div></div><div id=\"bottom-block-login\"><div id=\"corp\"><span>\n© {{date| date:\'yyyy\'}} empreinte.com</span></div><div id=\"licence\"><a target=\"_blank\" \nhref=\"https://www.empreinte.com/mentions-legales/\" translate=\"LOGINV2.licence\">Licence du logiciel</a></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/support/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"form-wrapper md-whiteframe-1dp flex-gt-xs-100 flex-gt-md-100 flex-100\" flex=\"100\" \nflex-gt-xs=\"100\"><ms-widget layout=\"column\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom dashboard_panel_custom_height\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 bold\" translate=\"KEY.title\"></div></div><md-card flex=\"100\" layout=\"row\"><div layout=\"row\" \nstyle=\"width:100%\"><div flex=\"90\" layout-align=\"center center\" id=\"fo1\" style=\"padding: 25px\"><textarea rows=\"10\" \nstyle=\"width: 100%\">{{vm.key}}</textarea></div><div flex=\"10\"><md-button style=\"position: relative;top: 50%\" \nclass=\"btn\" ngclipboard data-clipboard-target=\"#fo1\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon><p id=\"test\" ng-if=\"vm.copied ===0\" style=\"color: #00ACC1\"><span\n translate=\"KEY.copied\"></span></p></md-button></div></div></md-card></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/core/components/modal-help-page/modal-help-page.html","<div xmlns=\"https://www.w3.org/1999/html\"><h2 style=\"background: gray;margin-top: 0px;height: 45px;color: white\" \ntranslate=\"HELP.{{vm.welcome}}\"></h2><div ng-repeat=\"value in vm.params track by $index\" ng-value=\"{{$index}}\"><p \nng-class=\"{\'help-style\' : ($index===0&&value.texte!=\'add_button_video_help\')}\" \nstyle=\"margin:14px 0; padding-left: 2%; padding-right: 2%\" data-ng-bind-html=\"vm.trustedHtml(value.texte)\"></p>\n<md-divider style=\"display: flex ; justify-content: center\" class=\"md-default-theme\"></md-divider></div></div>");
$templateCache.put("app/core/components/modal-preview-video/modal-preview-video.html","<div class=\"container-editor\"><div class=\"wrapper-editor\" id=\"wrapper-editor\" \nstyle=\"text-align: center;position: relative;  padding-top:{{vm.scaled}}%\" ng-class=\"{\'editor-st\': vm.isCaptionNew}\">\n<iframe id=\"iframe-editor\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" \nng-if=\"vm.link && vm.diffusion === \'internet\'\" class=\"notMontage isMontage iframe-editor\" \nng-class=\"{\'isNavigationNew\' : vm.isNavigationNew}\" width=\"800\" height=\"400\" \nng-src=\"{{vm.link ? vm.trustLink(vm.link) : \'\'}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen \nallowfullscreen></iframe><any ng-if=\"vm.link === false\">{{\'MESSAGES.video_not_exist\' | translate}}</any><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" \nng-if=\"vm.link_intranet && vm.diffusion === \'intranet\'\" \nstyle=\"position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\" width=\"800\" height=\"400\" \nng-src=\"{{vm.link_intranet ? vm.trustLink(vm.link_intranet) : \'\'}}\" frameborder=\"0\" webkitallowfullscreen \nmozallowfullscreen allowfullscreen></iframe><any ng-if=\"vm.link_intranet === false\">\n{{\'MESSAGES.video_not_exist\' | translate}}</any></div></div>");
$templateCache.put("app/core/directives/ms-block-component-display/ms-block-component-display.html","<div id=\"bloc{{index}}\"><span class=\"blocNumber\" ms-block-display=\"index\">@@0@@</span><md-icon \nclass=\"closebtn actions link s24 deleteBloc\" style=\"color:#FFFFFF\" md-font-icon=\"icon-close\" \nng-click=\"vm.RemoveElement($event,0)\"></md-icon><ng-include class=\"editable\" \nng-repeat=\"item in vm.screens[vm.currentScreenIndex].screenBlocsTemplates[index].repeatFrom\" \nsrc=\"vm.screens[vm.currentScreenIndex].screenBlocsTemplates[index].templateBlock\" \nng-click=\" vm.screens[vm.currentScreenIndex].screenBlocsTemplates[index].isClickable ? vm.screens[vm.currentScreenIndex].screenBlocsTemplates[index].clickableFunction(item,$event) : \'\'\">\n</ng-include></div>");
$templateCache.put("app/core/directives/ms-channels/ms-channels.html","<md-card-content class=\"md-block\" flex-gt-xs><md-select ng-model=\"ngModel\" \nplaceholder=\"{{ \'MESSAGES.form_attr_canal\' | translate }}\" ng-change=\"ngChange({someModelChannel: ngModel})\"><md-option\n value=\"\" translate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"canal in vm.canals track by canal.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"canal.val\" ng-attr-translate=\"{{canal.val==0 ? \'MESSAGES.canal_none\':\'\'}}\">\n{{canal.option}}</md-option></md-select></md-card-content>");
$templateCache.put("app/core/directives/ms-contributors/ms-contributors.html","<md-card-content class=\"md-block\" flex-gt-xs><md-select ng-model=\"ngModel\" \nplaceholder=\"{{ \'MESSAGES.form_attr_contributor\' | translate }}\" name=\"empMediaVideoForm[contributor]\" \nid=\"empMediaVideoForm_contributor\" ng-change=\"ngChange({someModelContributor: ngModel})\"><md-option \nng-if=\"name.val!=0\" ng-repeat=\"contributor in vm.contributors track by contributor.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"contributor.val\" \nng-attr-translate=\"{{contributor.val==0 ? \'MESSAGES.contributor_none\':\'\'}}\">{{contributor.option}}</md-option>\n</md-select></md-card-content>");
$templateCache.put("app/core/directives/ms-delete-menu/embed.modal.html","<md-dialog class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span align=\"center\" \ntranslate=\"PAGESMENUSTITLES.export_links_modal_title\"></span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-radio-group ng-model=\"vm.searchFlight.exportLink\" layout=\"row\">\n<md-radio-button value=\"Auto\" aria-label=\"Auto\"><p translate=\"EVENTLIST.export_auto\"></p></md-radio-button>\n<md-radio-button value=\"Live\" aria-label=\"Live\"><p translate=\"EVENTLIST.export_live\"></p></md-radio-button>\n<md-radio-button value=\"Video\" aria-label=\"Video\"><p translate=\"EVENTLIST.export_video\"></p></md-radio-button>\n</md-radio-group><div ng-switch=\"vm.searchFlight.exportLink\"><div ng-switch-when=\"Auto\"><div layout=\"row\"><div \nflex=\"80\" align=\"center\"><strong translate=\"EVENTLIST.export_auto_title\"></strong></div></div><div layout=\"row\" \nclass=\"row_url\" layout-xs=\"column\" ng-if=\"vm.url_permalien_auto\"><div flex=\"20\"><strong \ntranslate=\"EVENTLIST.export_links_perma_link\"></strong></div><div flex=\"80\" id=\"fo1\">{{vm.url_permalien_auto}}</div>\n<md-button class=\"btn\" ngclipboard data-clipboard-target=\"#fo1\" aria-label=\"url_copy\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon></md-button></div><div layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.url_embed_auto\"><div flex=\"20\"><strong translate=\"EVENTLIST.export_links_embed_link\">\n</strong></div><div flex=\"80\" id=\"fo\">{{vm.url_embed_auto}}</div><md-button class=\"btn\" ngclipboard \ndata-clipboard-target=\"#fo\" aria-label=\"url_copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon>\n</md-button></div></div></div><div ng-switch=\"vm.searchFlight.exportLink\"><div ng-switch-when=\"Live\"><div layout=\"row\">\n<div flex=\"80\" align=\"center\"><strong translate=\"EVENTLIST.export_Live_title\"></strong></div></div><div \nclass=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.url_permalien\"><div flex=\"20\"><strong \ntranslate=\"EVENTLIST.export_links_perma_link\"></strong></div><div flex=\"80\" id=\"foo\">{{vm.url_permalien}}</div>\n<md-button class=\"btn\" ngclipboard data-clipboard-target=\"#foo\" aria-label=\"copy\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon></md-button></div><div class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.url_permalien\"><div flex=\"20\"><strong translate=\"EVENTLIST.export_links_embed_link\">\n</strong></div><div flex=\"80\" id=\"foo1\">{{vm.url_embed}}</div><md-button class=\"btn\" ngclipboard \ndata-clipboard-target=\"#foo1\" aria-label=\"copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon>\n</md-button></div></div></div><div ng-switch=\"vm.searchFlight.exportLink\"><div ng-switch-when=\"Video\"><div \nlayout=\"row\"><div flex=\"80\" align=\"center\"><strong translate=\"EVENTLIST.export_video_title\"></strong></div></div><div \nclass=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.url_permalien_video\"><div flex=\"20\"><strong \ntranslate=\"EVENTLIST.export_links_perma_link\"></strong></div><div flex=\"80\" id=\"foo2\">{{vm.url_permalien_video}}</div>\n<md-button class=\"btn\" ngclipboard data-clipboard-target=\"#foo2\" aria-label=\"copy\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon></md-button></div><div class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.url_embed_video\"><div flex=\"20\"><strong translate=\"EVENTLIST.export_links_embed_link\">\n</strong></div><div flex=\"80\" id=\"foo3\">{{vm.url_embed_video}}</div><md-button class=\"btn\" ngclipboard \ndata-clipboard-target=\"#foo3\" aria-label=\"copy\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\"></md-icon>\n</md-button></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<span flex></span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-delete-menu/ms-delete-menu.html","<md-menu><md-button style=\"width: auto\" class=\"\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" \naria-label=\"description_audio\"><md-icon md-font-icon=\"{{vm.icon}}\"></md-icon><any ng-if=\"vm.text\" \nstyle=\"text-transform: capitalize\" translate=\"LANGUAGES.Names.{{vm.text}}\">Language</any></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.deleteLanguageConfirm($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><any\n translate=\"MESSAGES.delete_language\">Delete Langue</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.showEmbed($event)\"><md-icon md-font-icon=\"icon-link-variant\"></md-icon><any \ntranslate=\"MESSAGES.embed_code\">embed_code</any></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-if=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-if=\"!vm.selectedColor.palette\"><span translate=\"MESSAGES.select_color\">select_color</span></span></md-button>\n</ms-color-picker-button></div><md-menu-content class=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\"><span \ntranslate=\"MESSAGES.select_color\"></span></span><md-button class=\"remove-color-button md-icon-button\" \nng-click=\"vm.removeColor()\" aria-label=\"Remove Color\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon>\n</md-button></header><div class=\"colors\" ms-scroll><div ng-if=\"!vm.selectedPalette || vm.selectedPalette == \'custom\' \" \nlayout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div><div \nclass=\"color\" layout=\"row\" layout-align=\"start end\" md-prevent-menu-close md-ink-ripple \nstyle=\"border: 1px solid rgb(44, 50, 62)\" ng-click=\"vm.selectColor(\'custom\',0)\"><span class=\"label\">White </span><i \nng-if=\"\'custom\' == vm.selectedColor.palette && \'0\' == vm.selectedColor.hue\" class=\"s16 icon-check\"></i></div></div><div\n ng-if=\"vm.selectedPalette && vm.selectedPalette !=\'custom\'\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-info-bar-display/ms-info-bar-display.html","<div style=\"position: absolute;width: 100%;bottom: 0\" ng-if=\"vm.screens[vm.currentScreenIndex].hasInfoBar\" \nclass=\"screen-info-bar editable\"><div ng-repeat=\"item in [vm.screens[vm.currentScreenIndex].infoBarOptions]\" \nng-click=\"vm.showElementConfigTab(item,\'   infobar\',$event)\" \nid=\"screen-info-bar-{{vm.screens[vm.currentScreenIndex].rid}}\" layout=\"row\" layout-align=\"start center\" \nclass=\"screen-info-bar\" ng-style=\"vm.editorConstants.infoBar.style(vm,item.infoBarContainer)\" \nstyle=\"position: relative\" ng-class=\"item.infoBarContainer.options.msColor\"><div ng-if=\"!item.data.informations.image\" \nflex=\"85\" class=\"info-container\" ng-style=\"vm.editorConstants.infoBar.style(vm,item.infoContainer)\" \nng-class=\"item.infoContainer.options.msColor\"><div ng-if=\"item.data.informations && item.data.informations.length\" \nstyle=\"height:inherit\"><div layout=\"row\" layout-align=\"start center\" layout-padding flex=\"100\" \nng-if=\"item.data.informations[item.data.currentInformationIndex].priority == 1\" style=\"height:100%\"><strong \nclass=\"animated md-headline fadeInLeftBig\" id=\"animated-info\" \nstyle=\"word-wrap: break-word;font-size: 16px;line-height: 22px\">\n{{item.data.informations[item.data.currentInformationIndex].content}}\',</strong></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\" ng-if=\"item.data.informations[item.data.currentInformationIndex].priority == 2\" \nstyle=\"height:100%\"><div flex=\"10\" layout-padding style=\"background-color: #D50000 !important;height:100%\"></div><div \nflex=\"90\" layout-padding style=\"background-color: #FFF !important;height:100%\"><strong \nclass=\"animated md-headline fadeInLeftBig\" id=\"animated-info\" \nstyle=\"color:#D50000;word-wrap: break-word;font-size: 16px;line-height: 22px\">\n{{item.data.informations[item.data.currentInformationIndex].content}}\',</strong></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"100\" ng-if=\"item.data.informations[item.data.currentInformationIndex].priority == 3\" \nstyle=\"height:100%;background-color: #D50000 !important;color: #FFF !important\"><div flex=\"20\" layout-padding \nstyle=\"height:100%\"><strong class=\"md-title\" style=\"word-wrap: break-word\" \ntranslate=\"TEMPALTEMANAGEREDITOR.information_urgent\">information_urgent\',</strong></div><div flex=\"80\" layout-padding \nstyle=\"height:100%\"><strong class=\"animated md-headline fadeInLeftBig\" id=\"animated-info\" \nstyle=\"word-wrap: break-word;font-size: 16px;line-height: 22px\">\n{{item.data.informations[item.data.currentInformationIndex].content}}\',</strong></div></div></div></div><div \nng-if=\"!item.data.informations.image\" ng-init=\"vm.editorConstants.infoBar.initialize(item,vm,true);\" flex=\"15\" \nlayout=\"row\" layout-align=\"center center\" class=\"clock-container\" \nstyle=\"border-style: solid; border-radius: 10%;     margin-right: 2%\" \nng-style=\"vm.editorConstants.infoBar.style(vm,item.clockContainer)\" ng-class=\"item.clockContainer.options.msColor\">\n<strong ng-if=\"item.data.date.numerical\" ng-class=\"item.clockContainer.options.fontClass\" \nstyle=\"color:{{item.clockContainer.options.clockColor}}\">{{item.data.date.numerical}}</strong></div><div \nng-if=\"item.data.informations.image\" class=\"info-container\" \nng-style=\"vm.editorConstants.infoBar.style(vm,item.infoContainer)\" ng-class=\"item.infoContainer.options.msColor\"><img \nclass=\"image-absolute\" style=\"{{item.data.informations.position}}\" ng-src=\"{{item.data.informations.image}}\"></div>\n</div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index === MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-show-element-config-display/ms-show-element-config-display.html","<md-list class=\"icons-actions md-accent-bg md-dense ms-show-element-config-display\" flex><md-list-item><div \nng-click=\"vm.showElementConfigTab(componentItem,componentKey,$event)\"><img \nsrc=\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAwCAYAAACFUvPfAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo4QzcwRTAzNDZFMjkxMUU4QkE3MkJGNzYzMjc0MjM0QiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo4QzcwRTAzNTZFMjkxMUU4QkE3MkJGNzYzMjc0MjM0QiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjhDNzBFMDMyNkUyOTExRThCQTcyQkY3NjMyNzQyMzRCIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjhDNzBFMDMzNkUyOTExRThCQTcyQkY3NjMyNzQyMzRCIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+dlbGAgAAAaVJREFUeNrsmbtKA0EUhnfFEBIN2ogWSsDCNKm0CtqLT2Avaay0sRMb0+obKFjkFVIIYuGtEnwAmyVpgoWXeIsW6z/wLwyHNUIkO4megY85M7OT/ZjdOZkQPwxDb9DKkDeARaVVWqVVWqVVWqVVWqV7KF0ET6Qsxmrsr4n+sjWn2O2Nh38hPQFyjAtiLM+xvOiftObkXEifgg0wAg7F2KOoo/JqxZ8upEvgDJifPnPgjY+9Uxm34rQL6UvRXgbHP8w5ACnQAhcupDt91oyoTRkFU6DK9gK4Tlr6mSJRebHibbAoVrMU8yT8pKUL3FgmbWbAHfunwTk44Xtr2g2+Fs7z9APYA/tMfx/sr4BbUGddickcHjdu4u/0PFhjHIAbxhlxXdS+ArPMML6rPP0uVv27FYzabZAFW2xv9kP2sDfhLiXTrKOyCtYZV7tNe704MJlNtwR2WDessXsrbvfTSkeb0WSNFXA0KEfTuqj1PP3vpO1vuKwYGxN13HUpFxuxRUxpirGAh6VA9DetOa1ub+zrPwEqrdIqrdIqrdIqrdJ/UPpLgAEACCxPCVcMa6gAAAAASUVORK5CYII=\">\n<md-tooltip md-direction=\"left\">{{\"TEMPALTEMANAGEREDITOR.\"+keyTranslate|translate}}</md-tooltip></div></md-list-item>\n</md-list>");
$templateCache.put("app/core/directives/ms-multilangue-menu/edit-language.modal.html","<md-dialog style=\"width: 500px\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s24\"></md-icon><span translate=\"MESSAGES.edit_language\"></span> </span><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-card-content style=\"width: 100%\" flex><md-select translate \ntranslate=\"MESSAGES.form_attr_language\" name=\"empEventForm[language][]\" id=\"empEventForm_language\" \nng-model=\"vm.language\" required=\"required\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'\n                            |translate}}\"><md-option \nng-repeat=\"languageChoice in vm.languageChoices\" ng-value=\"languageChoice.val\"><any \ntranslate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option}}</any></md-option></md-select>\n</md-card-content></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-around center\"><div>\n<md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button \nng-disabled=\"vm.language==\'\' \" class=\"md-accent\" ng-click=\"vm.sendLanguage($event)\" translate=\"MESSAGES.send\">send\n</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-multilangue-menu/embed.modal.html","<md-dialog class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"MESSAGES.title_modal_url\"></span> <span>\n{{vm.title | json}}</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><div class=\"export_btn\"><a target=\"_blank\" \nhref=\"{{vm.export_facebook}}\"><md-button class=\"md-fab md-mini\" aria-label=\"Facebook\"><md-icon \nmd-font-icon=\"icon-facebook\" class=\"s18\"></md-icon></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter}}\">\n<md-button class=\"md-fab md-mini\" aria-label=\"Twitter\"><md-icon md-font-icon=\"icon-twitter-circle\" class=\"s18\">\n</md-icon></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin}}\"><md-button class=\"md-fab md-mini\" \naria-label=\"Linkedin\"><md-icon md-font-icon=\"icon-linkedin\" class=\"s18\"></md-icon></md-button></a></div>\n<md-dialog-content ms-scroll><div ng-if=\"vm.spinner\"><md-checkbox ng-model=\"vm.autoplay\" \nng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" aria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox \nng-model=\"vm.sendMail\" ng-change=\"vm.checkOptionFunction(vm.sendMail, \'mail\')\" aria-label=\"Send mail\">Send mail\n</md-checkbox><md-checkbox ng-model=\"vm.facebook\" ng-change=\"vm.checkOptionFunction(vm.facebook, \'fb\')\" \naria-label=\"Facebook\">Facebook</md-checkbox><md-checkbox ng-model=\"vm.twitter\" \nng-change=\"vm.checkOptionFunction(vm.twitter, \'tw\')\" aria-label=\"Twitter\">Twitter</md-checkbox><md-checkbox \nng-model=\"vm.linkedin\" ng-change=\"vm.checkOptionFunction(vm.linkedin, \'lk\')\" aria-label=\"Linkedin\">Linkedin\n</md-checkbox><md-checkbox ng-if=\"vm.show_cdn_url !== null\" ng-model=\"vm.cdn_web\" \nng-change=\"vm.checkOptionCDNFunction()\" aria-label=\"CDN Web\">Cdn Web</md-checkbox><div class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\"><div flex=\"20\"><strong>{{vm.video.id_title}}</strong></div><div flex=\"80\">{{vm.video.id}}</div>\n</div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.videos_mp4.length\" \nng-repeat=\"mp4 in ::vm.video.videos_mp4\"><div flex=\"20\"><strong ng-if=\"$first\">mp4</strong></div><div flex=\"80\">\n{{mp4.src}}</div></div><div class=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.video.link_progressive_download\">\n<div flex=\"20\"><strong translate=\"MESSAGES.progressive_download\"></strong></div><div flex=\"80\">\n{{vm.video.link_progressive_download}}</div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.video.link_ogg\"><div flex=\"20\"><strong>OGV</strong></div><div flex=\"80\">{{vm.video.link_ogg}}</div></div><div\n layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.link_webm\"><div flex=\"20\"><strong>Webm</strong></div>\n<div flex=\"80\">{{vm.video.link_webm}}</div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.link_permalien\"><div flex=\"20\"><strong translate=\"MESSAGES.permalien\"></strong></div><div flex=\"80\">\n{{vm.link_permalien}}</div></div><div class=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.link_embed\"><div \nflex=\"20\"><strong>Embed</strong></div><div flex=\"80\">{{vm.link_embed}}</div></div><div class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.link_embed\"><div flex=\"20\"><strong>Code Embed</strong></div><div flex=\"80\">\n<md-input-container><textarea aria-label=\"Code Embed\">\n        <iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" style=\"width:100%;min-height:360px\" \nsrc=\"{{vm.link_embed}}\" allowfullscreen mozallowfullscreen webkitallowfullscreen frameborder=\"0\"></iframe>\n      \n</textarea></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" \ntranslate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-multilangue-menu/ms-multilangue-menu.html","<md-menu><md-button style=\"width: auto\" class=\"\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" \naria-label=\"description_audio\"><md-icon md-font-icon=\"icon-unfold-more\"></md-icon><any \nstyle=\"text-transform: capitalize\" translate=\"LANGUAGES.Names.{{vm.text}}\">Language</any></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"vm.viewMedia()\"><md-icon md-font-icon=\"icon-play\"></md-icon><any \ntranslate=\"MESSAGES.apercu_media\">apercu_media</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteLanguageConfirm($event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><any \ntranslate=\"MESSAGES.delete_language\">Delete Langue</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.editLanguage($event)\"><md-icon md-font-icon=\"icon-pencil\"></md-icon><any \ntranslate=\"MESSAGES.edit_language\">edit_language</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.editVideoFile($event)\"><md-icon md-font-icon=\"icon-filmstrip\"></md-icon><any \ntranslate=\"MESSAGES.edit_video_file\">edit_video_file</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.showEmbed($event)\"><md-icon md-font-icon=\"icon-link-variant\"></md-icon><any \ntranslate=\"MESSAGES.embed_code\">embed_code</any></md-button></md-menu-item></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts | filterByShortcutIds:MsShortcuts.shortcuts track by shortcut.___id\" \nlayout=\"row\" layout-align=\"center center\"><a tooltips tooltip-template=\"{{shortcut.title}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button shortcut\" ng-if=\"shortcut.uisref\" \naria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon ng-if=\"shortcut.icon\" \nmd-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" class=\"first-letter\">\n{{shortcut.title.charAt(0)}}</div></md-button></a></div></div><md-menu md-offset=\"8 56\" \nclass=\"shortcut-menu hide show-gt-xs\"><a tooltips tooltip-template=\"Click to add/remove shortcut\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button add-shortcut-button\" \naria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\"></md-icon></md-button></a><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results | filterByShortcutIds:MsShortcuts.results track by result.___id\" \nng-click=\"MsShortcuts.handleResultClick(result)\" ng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" \nng-mousedown=\"MsShortcuts.absorbEvent($event)\" ng-class=\"{\'selected\': $index === MsShortcuts.selectedResultIndex}\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" md-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div \nlayout=\"row\" layout-align=\"start center\" flex><div class=\"icon icon-container\" layout=\"row\" \nlayout-align=\"center center\"><i ng-if=\"result.icon\" class=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" \nclass=\"square md-accent-bg\"></div></div><div><div class=\"title\">{{result.title}}</div></div></div><md-icon \nmd-font-icon=\"icon-pin\" class=\"icon s18\" ng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div>\n</div></md-menu-content></md-menu></div><md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" \naria-label=\"Add shortcut\" ng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-themes/ms-themes.html","<div translate=\"MESSAGES.theme\" ng-if=\"vm.showLabel && !vm.hide\" style=\"margin-bottom: -10px;margin-top: 10px\">Theme\n</div><md-card-content class=\"md-block\" flex-gt-xs ng-if=\"!vm.hide\"><md-select class=\"test\" ng-model=\"ngModel\" \nng-if=\"vm.multi===false\" placeholder=\"{{ \'MESSAGES.form_attr_themes\' | translate }}\" \nng-change=\"ngChange({someModel: ngModel})\" ng-disabled=\"disabled\"><md-option value=\"\" translate=\"DASHBOARD.none\">\n</md-option><md-optgroup label=\"{{canal.title}}\" ng-repeat=\"canal in themes track by canal.id\" \nng-attr-data-index=\"{{$index}}\"><ms-option canal=\"canal.id\" collection=\"canal.themes\"></ms-option></md-optgroup>\n</md-select></md-card-content><md-card-content class=\"md-block\" flex-gt-xs ng-if=\"!vm.hide\"><md-select \nmd-container-class=\"class-none-options\" ng-model=\"ngModel\" ng-if=\"vm.multi===true\" \nplaceholder=\"{{ \'MESSAGES.form_attr_themes\' | translate }}\" multiple=\"1\" ng-change=\"ngChange({someModel: ngModel})\" \nng-disabled=\"disabled\"><md-button id=\"closeSelectTheme\" ng-click=\"vm.closeSelect()\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button><md-button layout-fill value=\"all\" class=\"themes_aucun\" \nstyle=\"font-size: 17px;color: #2d333e;background: rgba(4, 155, 229, 0.17)\" \nng-click=\"ngChange({someModel: []});vm.selectAllTest()\">{{ \'VIDEOLIST.none\' | translate }}</md-button><md-optgroup \nlabel=\"{{canal.title}}\" ng-repeat=\"canal in themes track by canal.id\" ng-attr-data-index=\"{{$index}}\"><ms-option \ncanal=\"canal.id\" collection=\"canal.themes\"></ms-option></md-optgroup></md-select></md-card-content>");
$templateCache.put("app/core/directives/ms-themes-bootstrap/ms-themes-bootstrap.html","<div><div translate=\"{{!vm.isGV ? \'MESSAGES.theme\' : \'MESSAGES.rubric\' }}\" \nng-if=\"vm.showLabel && !vm.hide && !vm.hasCategories\" class=\"theme-label\" \nstyle=\"margin-bottom: -10px;margin-top: 10px\"></div><md-card-content class=\"md-block\" flex-gt-xs \nng-if=\"!vm.hide && !vm.hasCategories \"><ui-select theme=\"bootstrap\" ng-model=\"ngModel[0]\" style=\"width:100%\" \nng-if=\"vm.multi===false\" ng-required=\"{{vm.required}}\" ng-change=\"ngChange({someModel: ngModel)})\"><ui-select-match \nplaceholder=\"{{ (!vm.isGV ? \'MESSAGES.form_attr_themes\' : \'MESSAGES.rubric\') |translate }}\">{{$select.selected.title}}\n</ui-select-match><ui-select-choices repeat=\"canal.id as canal in vm.themes | filter: {title:$select.search}\" \ngroup-by=\"\'group\'\"><div ng-bind-html=\"canal.title | highlight: $select.search\"></div></ui-select-choices></ui-select>\n</md-card-content><md-card-content class=\"md-block row\" flex-gt-xs ng-if=\"!vm.hide && !vm.hasCategories\"><ui-select \ntheme=\"bootstrap\" ng-model=\"vm.selectedtheme\" style=\"width:100%\" multiple=\"multiple\" ng-if=\"vm.multi===true\" \nng-required=\"{{vm.required}}\" ng-change=\"ngChange({someModel: vm.selectedtheme})\"><ui-select-match \nplaceholder=\"{{ (!vm.isGV ? \'MESSAGES.form_attr_themes\' : \'MESSAGES.rubric\') |translate }}\">{{$item.title}}\n</ui-select-match><ui-select-choices repeat=\"canal.id as canal in vm.themes | filter: {title:$select.search}\" \ngroup-by=\"\'group\'\"><div ng-bind-html=\"canal.title | highlight: $select.search\"></div></ui-select-choices></ui-select>\n</md-card-content><md-card-content class=\"md-block row\" flex-gt-xs ng-if=\"!vm.hide && vm.hasCategories\"><ui-select \ntheme=\"bootstrap\" ng-model=\"ngModel\" style=\"width:100%\" ng-if=\"vm.multi===false && vm.hasCategories\" \nng-required=\"{{vm.required}}\" ng-change=\"ngChange({someModel: ngModel})\"><ui-select-match \nplaceholder=\"{{ (!vm.isGV ? \'MESSAGES.form_attr_themes\' : \'MESSAGES.rubric\') |translate }}\">{{$select.selected.title}}\n</ui-select-match><ui-select-choices repeat=\"canal.id as canal in vm.themes | filter: {title:$select.search}\" \ngroup-by=\"\'group\'\"><div ng-bind-html=\"canal.title | highlight: $select.search\"></div></ui-select-choices></ui-select>\n</md-card-content></div>");
$templateCache.put("app/core/services/videoService/preview-video.modal.html","<md-dialog id=\"dialog-video-preview\" class=\"event-form-dialog preview-video-modal\" aria-label=\"ariaLabelTitle\" \nstyle=\"width: 60%;height: max-content; max-height: none\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s24\"></md-icon><span translate=\"MESSAGES.video_preview\">Preview of the video</span> </span><span flex></span> \n<span style=\"font-size: 16px\" data-ng-style=\"vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" \nng-if=\"vm.isIntranet_Internet===\'1\'\">Intranet</span><md-switch ng-if=\"vm.isIntranet_Internet===\'1\'\" \nid=\"switch-intra-inter\" ng-disabled=\"!vm.isVisibleOnInternet || !vm.isVisibleOnIntranet \" \ndata-ng-style=\"!vm.isVisibleOnInternet || !vm.isVisibleOnIntranet && {\'opacity\':\'0.6\'}\" \nstyle=\"margin-left: 16px;margin-right: 5px\" class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"vm.intranet\" ng-change=\"vm.changeIntraInter()\"></md-switch><span style=\"font-size: 16px\" \ndata-ng-style=\"!vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.isIntranet_Internet===\'1\'\">Internet\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ng-if=\"vm.isIntranet_Internet===\'1\'\" style=\"height: 100%;width: 100%\" ms-scroll \nclass=\"no-padding\"><preview-video ng-if=\"!vm.intranet\" event=\"vm.event\" params=\"vm.params\" diffusion=\"\'intranet\'\" \nhandler=\"vm\"></preview-video><preview-video ng-if=\"vm.intranet\" event=\"vm.event\" params=\"vm.params\" \ndiffusion=\"\'internet\'\" handler=\"vm\"></preview-video></md-dialog-content><md-dialog-content \nng-if=\"vm.isIntranet_Internet===\'0\'\" style=\"height: 100%;width: 100%\" ms-scroll class=\"no-padding\"><preview-video \nevent=\"vm.event\" params=\"vm.params\" diffusion=\"\'internet\'\" handler=\"vm\"></preview-video></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/core/services/helpService/help.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" \nstyle=\"overflow: hidden;max-height: 80%;max-width: 800px;width: 75%\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.help\">Aide</span> </span><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"no-padding\"><help-page params=\"vm.text\" welcome=\"vm.welcome\">\n</help-page></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-around center\"><md-button \nclass=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal style=\"width: 100%\" \npath-active=\"{{vm.pathActive}}\"></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span ng-if=\"!vm.folded\"><img class=\"image\" \nng-src=\"{{vm.image}}\" ng-style=\"{{vm.logo_style}}\" alt=\"{{vm.logoToolbar.logo_image}}\"></span></div><md-icon \nclass=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" ng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar>\n<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation-new/navigation.html","<div layout=\"row\" flex style=\"width: 100%\"><div hide-gt-md flex layout=\"row\" layout-align=\"space-between center\" \nng-if=\"vm.isFM\" class=\"mobile-navigation\"><div class=\"navigation-toggle\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><div class=\"buttons-mobile-align\"><md-menu md-position-mode=\"target-right bottom\" \nng-class=\"{\'menu-align\' : vm.isNavigationNew}\"><md-button \nclass=\"btn-add-video md-accent md-raised btn-add-in-mobile md-warn\" aria-label=\"Add video\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-font-icon=\"icon-add-video\"></md-icon></md-button>\n<md-menu-content><md-menu-item ng-click=\"vm.goToUrlMedias(\'media_video\',\'app.media_video_upload\')\"><md-button><md-icon \nmd-font-icon=\"icon-add\" style=\"font-size: 1em\"></md-icon><any><span translate=\"MESSAGES.add_video\">Ajouter une vidéo\n</span></any></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"true\"><md-icon \nmd-font-icon=\"icon-noun_live\" style=\"font-size: 0.8em\"></md-icon><any><span translate=\"MESSAGES.create_video\">\nCréer une vidéo</span></any></md-button></md-menu-item><md-menu-item \nng-click=\"vm.goToUrlMedias(\'media_lives\',\'app.lives_addLive\')\"><md-button><md-icon md-font-icon=\"icon-start-live\" \nstyle=\"font-size:1.5em\"></md-icon><any><span translate=\"MESSAGES.add_live\">Faire un live</span></any></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"true\"><md-icon md-font-icon=\"icon-media\" style=\"font-size:1.2em\">\n</md-icon><any><span translate=\"MESSAGES.create_live\">Créer une playlist live</span></any></md-button></md-menu-item>\n</md-menu-content></md-menu><md-menu md-position-mode=\"target-right bottom\" ng-if=\"vm.isNavigationNew\"><a \ntarget=\"_blank\" class=\"navigation-tv-btn\" ng-href=\"{{vm.redirectTv()}}\"><md-button class=\"tv-btn\" \naria-label=\"Voir la TV\" ng-class=\"{\'mobile\':vm.isNavigationNew}\"><md-icon md-font-icon=\"icon-web\" style=\"margin: 0\">\n</md-icon></md-button></a></md-menu></div></div><ms-navigation-horizontal style=\"width: 100%\" \npath-active=\"{{vm.pathActive}}\" ng-class=\"{\'navigation-horizontal-mobile\' : vm.isNavigationNew }\">\n</ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/main/chutier/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px;    position: relative\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 100%;\n    position: absolute;\n    width: 100%\" layout=\"row\" layout-wrap><iframe \nsrc=\"{{ChutierIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/core/action/action.template.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-pagee\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.core_menuTitle\">core_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" translate=\"PAGESMENUSTITLES.core_right_menuTitle\">\ncore_right_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span \nclass=\"parent\" translate=\"PAGESMENUSTITLES.core_rights_action_menuTitle\">core_right_action_menuTitle</span></div><div \nclass=\"title\" translate=\"RIGHTS.actions_list\">actions_list</div></div></div><div class=\"content\"><div \nclass=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"md-whiteframe-1dp price-table\" layout=\"column\" \nflex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak><md-toolbar md-colors=\"{background: \'accent\'}\"><h2 \nclass=\"md-toolbar-tools\"><span translate=\"RIGHTS.add_new_action\">add_new_action</span></h2></md-toolbar><md-content \nflex><div layout-align=\"start center\" layout=\"row\" class=\"mv-10 p-24\"><form name=\"rightActionForm\" \nclass=\"md-inline-form\" novalidate flex><div layout=\"row\" flex><blockquote><p \ntranslate=\"RIGHTS.upper_case_replace_message\">upper_case_replace_message</p><p \ntranslate=\"RIGHTS.name_must_not_end_with_action\">name_must_not_end_with_action</p><p \ntranslate=\"RIGHTS.two_actions_cannot_have_the_same_name\">two_actions_cannot_have_the_same_name</p></blockquote></div>\n<div layout=\"row\" flex><md-input-container flex><label class=\"md-no-float\">Action</label><input type=\"text\" \nname=\"action\" ng-model=\"vm.rightActionForm.action\" placeholder=\"Action\" required is-unique-action \nmust-not-end-with-action><div ng-messages=\"rightActionForm.action.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">form_is_required</span></div><div \nng-message=\"mustNotEndWithAction\"><span translate=\"RIGHTS.form_must_not_end_with_action\">form_must_not_end_with_action\n</span></div><div ng-message=\"isUniqueAction\"><span translate=\"RIGHTS.action_already_exist\">action_already_exist</span>\n</div></div></md-input-container></div></form></div></md-content><md-actions class=\"bt\" layout-align=\"center center\" \nlayout=\"row\"><div class=\"pv-10\"><md-button ng-click=\"vm.rightActionForm = {}\" class=\"cta-button md-flat md-warn\" \ntranslate=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button class=\"cta-button md-raised md-accent\" \nng-click=\"vm.submitAddNewAction($event)\" translate=\"MESSAGES.form_validate\" aria-label=\"Submit\" \nng-disabled=\"rightActionForm.$invalid || rightActionForm.$pristine\">form_validate</md-button></div></md-actions></div>\n<div class=\"md-whiteframe-1dp price-table\" layout=\"column\" flex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak>\n<md-toolbar md-colors=\"{background: \'accent\'}\"><div class=\"md-toolbar-tools\"><h2 translate=\"RIGHTS.actions_list\">\nactions_list</h2><span flex></span><md-input-container flex><label class=\"md-no-float\" \nstyle=\"color:#FFF!important;border-color:#FFF!important\" translate=\"MESSAGES.search\">search</label><input \nstyle=\"color:#FFF!important;border-color:#FFF!important\" type=\"text\" name=\"searchTerm\" ng-model=\"vm.searchTerm\">\n</md-input-container></div></md-toolbar><md-content flex md-scroll-shrink><md-list><md-list-item class=\"md-3-line\" \nng-repeat=\"action in vm.actions | filter: vm.searchTerm track by action.id\" ng-attr-data-index=\"{{$index}}\"><div \nng-init=\"vm.nameLoading[action.id] = 0\" class=\"md-list-item-text\"><h3><span ng-if=\"! vm.nameLoading[action.id]\" \nng-attr-translate=\"{{vm.getTranslatedAction(action.name)}}\">{{action.name}}</span></h3><h4 layout=\"column\" \nlayout-align=\"center center\"><md-progress-circular ng-if=\"vm.nameLoading[action.id]\" md-mode=\"indeterminate\" \nclass=\"md-accent mh-10\" md-diameter=\"18\"></md-progress-circular></h4><p ng-if=\"! vm.nameLoading[action.id]\" \ntranslate-attr-title=\"MESSAGES.click_to_edit\" title=\"click_to_edit\" editable-text=\"vm.setEditable(action)\" e-required \nng-attr-e-aria-label=\"action.name\" onbeforesave=\"vm.updateAction($data,action)\">{{action.name}}</p></div><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-if=\"! vm.nameLoading[action.id]\" class=\"md-secondary md-icon-button\" \nng-click=\"vm.deleteActionConfirm(action,$event)\"><md-icon md-font-icon=\"icon-trash\" class=\"s24\"></md-icon></md-button>\n</a><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></md-content></div></div><div \nclass=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"md-whiteframe-1dp price-table\" layout=\"column\" flex \nlex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak><md-toolbar class=\"md-accent-bg\"><h2 class=\"md-toolbar-tools\">\n<span translate=\"\">Translations</span></h2></md-toolbar><md-content flex ms-scroll-shrink><table flex \nclass=\"simple trad\" ms-responsive-table><thead><tr><th class=\"text-right\">Key</th><th class=\"text-left\">Value</th></tr>\n</thead><tbody><tr ng-repeat=\"action in vm.actions track by action.id\" ng-attr-data-index=\"{{$index}}\"><td flex \nclass=\"text-right\"><md-input-container flex style=\"width:100%\"><input type=\"text\" class=\"iKey\" name=\"key\" \nng-value=\"action.name\" readonly=\"readonly\" aria-label=\"key\"></md-input-container></td><td flex class=\"text-left\">\n<md-input-container flex style=\"width:100%\"><label class=\"md-no-float\">trans</label><input type=\"text\" class=\"iVal\" \nname=\"val\" ng-value=\"vm.getTranslatedAction(action.name)\" md-select-on-focus></md-input-container></td></tr></tbody>\n</table></md-content><md-actions class=\"bt\" layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"vm.generateXml()\">Generate Xml</md-button></md-actions></div><div \nclass=\"md-whiteframe-1dp price-table\" layout=\"column\" flex lex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak>\n<md-toolbar class=\"md-accent-bg md-hue-1\"><h2 class=\"md-toolbar-tools\"><span>XML</span></h2></md-toolbar><md-content \nflex><md-input-container class=\"md-block\"><label class=\"md-no-float\">translationFile</label><textarea \nng-model=\"vm.translationFile\" md-select-on-focus></textarea></md-input-container></md-content></div></div></div></div>");
$templateCache.put("app/main/core/module/module.template.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-pagee\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.core_menuTitle\">core_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" translate=\"PAGESMENUSTITLES.core_right_menuTitle\">\ncore_right_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span \nclass=\"parent\" translate=\"PAGESMENUSTITLES.core_rights_module_menuTitle\">core_rights_module_menuTitle</span></div><div \nclass=\"title\" translate=\"RIGHTS.modules_list\">modules_list</div></div></div><div class=\"content\"><div \nclass=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"md-whiteframe price-table\" layout=\"column\" flex=\"65\" \nng-cloak><md-toolbar md-colors=\"{background: \'accent\'}\"><h2 class=\"md-toolbar-tools\"><span \ntranslate=\"RIGHTS.add_new_module\">add_new_module</span></h2></md-toolbar><md-content flex><div \nlayout-align=\"start center\" layout=\"row\" class=\"mv-10 p-24\"><div ng-if=\"vm.loadingDataForm\" \nlayout-align=\"center center\" layout=\"row\" flex><md-progress-circular md-mode=\"indeterminate\" class=\"md-accent mh-10\" \nmd-diameter=\"64\"></md-progress-circular></div><form ng-if=\"! vm.loadingDataForm\" name=\"rightModuleForm\" \nclass=\"md-inline-form\" novalidate flex><div layout=\"row\" flex><blockquote><p \ntranslate=\"RIGHTS.upper_case_replace_message\">upper_case_replace_message</p><p \ntranslate=\"RIGHTS.name_must_not_end_with_module\">name_must_not_end_with_module</p><p \ntranslate=\"RIGHTS.two_modules_cannot_have_the_same_name\">two_module_cannot_have_the_same_name</p><p \ntranslate=\"RIGHTS.module_contents_info_msg\">module_contents_info_msg</p></blockquote></div><div layout=\"row\" flex>\n<md-input-container flex><label>Module</label><input type=\"text\" name=\"name\" ng-model=\"vm.rightModuleForm.name\" \nplaceholder=\"Module\" required is-unique-module must-not-end-with-module><div ng-messages=\"rightModuleForm.name.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">\nform_is_required</span></div><div ng-message=\"mustNotEndWithModule\"><span \ntranslate=\"RIGHTS.form_must_not_end_with_module\">form_must_not_end_with_module</span></div><div \nng-message=\"isUniqueModule\"><span translate=\"RIGHTS.module_already_exist\">module_already_exist</span></div></div>\n</md-input-container></div><div layout=\"row\" flex><md-button class=\"md-raised md-primary\" \nng-click=\"vm.addNewModuleContent()\" ng-disabled=\" ! vm.hasNoActions() &&rightModuleForm.$invalid\" \ntranslate=\"RIGHTS.add_an_action\">add_an_action</md-button></div><div layout=\"row\" flex \nng-repeat=\"content in vm.contentModules track by content.gid\"><md-input-container flex-gt-md=\"30\" flex-xs=\"100\"><label>\nAction</label><md-select ng-model=\"content.action\" ng-change=\"vm.isActionAlreadySelected($index,$event)\" \nmd-on-open=\"vm.removeAleradySelectedAction($index)\" md-on-close=\"vm.clearSerachTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" aria-label=\"Actions\" name=\"action\" required><md-select-header \nng-attr-class=\"vm.getRandomClass(\'demo-select-header\')\"><input ng-model=\"vm.serachTerm\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"Actions\"><md-option \nng-repeat=\"_action  in vm.actions |\n                                              filter:vm.serachTerm track by _action.id\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"_action.id\" ng-attr-translate=\"{{vm.getTranslatedAction(_action.name)}}\">\n{{_action.name}}</md-option></md-optgroup></md-select><div ng-messages=\"rightModuleForm.action.$error\"><div \nng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">form_is_required</span></div></div>\n</md-input-container><md-input-container flex-gt-md=\"30\" flex-xs=\"100\"><label>Api Route</label><md-select \nng-model=\"content.route\" ng-change=\"vm.isRouteAlreadySelected($index,$event)\" \nmd-on-open=\"vm.removeAleradySelectedRoute($index)\" md-on-close=\"vm.clearSerachTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" aria-label=\"Api Routes\" name=\"route\"><md-select-header \nng-attr-class=\"vm.getRandomClass(\'demo-select-header\')\"><input ng-model=\"vm.serachTerm\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"Api Routes\"><md-option ng-repeat=\"route  in vm.routes | filter:vm.serachTerm\" ng-value=\"route\">\n<span ng-if=\"route === \'\'\" translate=\"MESSAGES.none\"></span> <span ng-if=\"route\">{{route}}</span></md-option>\n</md-optgroup></md-select></md-input-container><md-input-container flex-gt-md=\"30\" flex-xs=\"100\"><label>Angular Module\n</label><md-select ng-model=\"content.module\" ng-change=\"vm.isAngModuleAlreadySelected($index,$event)\" \nmd-on-open=\"vm.removeAleradySelectedAngModule($index)\" md-on-close=\"vm.clearSerachTerm()\" \ndata-md-container-class=\"selectdemoSelectHeader\" aria-label=\"Angular Modules\" name=\"module\"><md-select-header \nng-attr-class=\"vm.getRandomClass(\'demo-select-header\')\"><input ng-model=\"vm.serachTerm\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\" class=\"demo-header-searchbox md-text\"></md-select-header>\n<md-optgroup label=\"Angular Modules\"><md-option ng-repeat=\"module  in vm.angModules | filter:vm.serachTerm\" \nng-value=\"module\"><span ng-if=\"module === \'\'\" translate=\"MESSAGES.none\"></span> <span ng-if=\"module\">{{module}}</span>\n</md-option></md-optgroup></md-select></md-input-container><div flex-gt-md=\"10\" flex-xs=\"100\"><md-button \nclass=\"md-warn md-flat\" ng-click=\"vm.deleteModuleContentByIndex($index,$event)\" translate=\"MESSAGES.action_delete\">\naction_delete</md-button></div></div></form></div></md-content><md-actions class=\"bt\" layout-align=\"center center\" \nlayout=\"row\"><div class=\"pv-10\"><md-button ng-click=\"vm.intializeRightModuleFormAndData()\" \nclass=\"cta-button md-flat md-warn\" translate=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"vm.submitAddNewModule($event)\" translate=\"MESSAGES.form_validate\" \naria-label=\"Submit\" ng-disabled=\"rightModuleForm.$invalid ||  vm.hasNoActions()\">form_validate</md-button></div>\n</md-actions></div><div class=\"md-whiteframe price-table\" layout=\"column\" flex=\"30\" ng-cloak><md-toolbar \nmd-colors=\"{background: \'accent-hue-1\',color:\'background\'}\"><h2 class=\"md-toolbar-tools\"><span \ntranslate=\"RIGHTS.modules_list\">modules_list</span></h2></md-toolbar><md-content><div layout-align=\"start center\" \nlayout=\"row\" class=\"mv-10 p-24\"><div layout-align=\"center center\" layout=\"row\" flex ng-if=\"vm.loadingDataForm\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent mh-10\" md-diameter=\"64\"></md-progress-circular></div>\n<md-list flex ng-if=\"! vm.loadingDataForm\"><md-list-item class=\"md-1-line\" \nng-click=\"vm.intializeRightModuleFormWithExistedData($index)\" ng-repeat=\"module in vm.modules track by module.id\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"MODULESLIST.{{module.name}}\" aria-label=\"module.name\">{{module.name}}\n</strong></h3></div><span flex></span> <a tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-secondary md-icon-button\" \nng-click=\"vm.intializeRightModuleFormWithExistedData($index)\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\">\n</md-icon></md-button></a><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div></md-content></div>\n</div><div class=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"md-whiteframe-1dp price-table\" \nlayout=\"column\" flex lex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak><md-toolbar class=\"md-accent-bg\"><h2 \nclass=\"md-toolbar-tools\"><span translate=\"\">Translations</span></h2></md-toolbar><md-content flex ms-scroll-shrink>\n<table flex class=\"simple trad\" ms-responsive-table><thead><tr><th class=\"text-right\">Key</th><th class=\"text-left\">\nValue</th></tr></thead><tbody><tr ng-repeat=\"module in vm.modules track by module.id\" ng-attr-data-index=\"{{$index}}\">\n<td flex class=\"text-right\"><md-input-container flex style=\"width:100%\"><input type=\"text\" class=\"iKey\" name=\"key\" \nng-value=\"module.name\" readonly=\"readonly\" aria-label=\"key\"></md-input-container></td><td flex class=\"text-left\">\n<md-input-container flex style=\"width:100%\"><label>trans</label><input type=\"text\" class=\"iVal\" name=\"val\" \nng-value=\"vm.getTranslatedModule(module.name)\" md-select-on-focus></md-input-container></td></tr></tbody></table>\n</md-content><md-actions class=\"bt\" layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"vm.generateXml()\">Generate Xml</md-button></md-actions></div><div \nclass=\"md-whiteframe-1dp price-table\" layout=\"column\" flex lex=\"45\" flex-xs=\"100\" style=\"height:600px\" ng-cloak>\n<md-toolbar class=\"md-accent-bg md-hue-1\"><h2 class=\"md-toolbar-tools\"><span>XML</span></h2></md-toolbar><md-content \nflex><md-input-container class=\"md-block\"><label>translationFile</label><textarea ng-model=\"vm.translationFile\" \nmd-select-on-focus></textarea></md-input-container></md-content></div></div></div></div>");
$templateCache.put("app/main/core_new/module/json.generate.html","<md-dialog style=\"min-width: 50%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"\">Translations</span></h2><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"changeLang(\'fr\')\">Français</md-button><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"changeLang(\'en\')\">English</md-button></div></md-toolbar><div \nlayout=\"column\"><md-content flex ms-scroll flex><table flex class=\"simple trad\" ms-responsive-table><thead><tr><th \nclass=\"text-right\">Key</th><th class=\"text-left\">Value</th></tr></thead><tbody><tr \nng-repeat=\"module in data.content[0]\" id=\"translateList\"><td flex class=\"text-right\"><md-input-container flex \nstyle=\"width:100%\"><input type=\"text\" class=\"iKey\" name=\"key\" ng-value=\"module\" readonly=\"readonly\" aria-label=\"key\">\n</md-input-container></td><td flex class=\"text-left\" id=\"translation\"><md-input-container flex style=\"width:100%\" \nid=\"element\"><label>translation</label><input type=\"text\" class=\"iVal\" name=\"val\" md-select-on-focus \nng-model=\"translatedValue[module]\"><div class=\"hint emptyStyling\" ng-if=\"!translatedValue[module]\">\nAjouter cette valeur SVP</div></md-input-container></td></tr></tbody></table></md-content><md-action class=\"bt\" \nflex=\"40\" layout-align=\"center center\"><div layout-align=\"center center\" layout=\"row\"></div><div \nng-if=\"!verifyGeneration\"><div layout-align=\"center center\" layout=\"column\"><span class=\"emptyStyling\" flex>\nIl reste encore des champs sans traduction!!</span><div layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"continueGenerating()\">Continuer</md-button><md-button class=\"cta-button md-raised\" \nng-click=\"cancelGenerating()\">Annuler</md-button></div></div></div><div ng-if=\"verifyGeneration\"><div \nlayout-align=\"center center\" layout=\"column\"><md-button class=\"cta-button md-raised md-accent\" \nng-click=\"generateJson()\">Generate JSON</md-button></div></div></md-action></div></md-dialog>");
$templateCache.put("app/main/core_new/module/module.list.html","<div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex></div><div \nclass=\"labels\"></div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"thread\" md-ink-ripple ng-repeat=\"module in vm.rights.modules | filter:vm.searchModule\" \nng-click=\"vm.permissionList(module)\" ng-class=\"unread\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" \nflex layout=\"column\" translate=\"MODULESLIST.{{module | deletestring : \'_module\'}}\">{{module}}</div></div></div>");
$templateCache.put("app/main/core_new/module/module.template.html","<div id=\"price-tables\" class=\"page-layout carded left-sidenav\" layout=\"column\"><div class=\"top-bg md-accent-bg\"></div>\n<div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" \nui-sref=\"app.dashboard\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span \nclass=\"parent\" translate=\"PAGESMENUSTITLES.core_menuTitle\">core_menuTitle</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.core_right_menuTitle\">core_right_menuTitle</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.core_rights_module_menuTitle\">core_rights_module_menuTitle</span></div><span \nclass=\"h1 margin-left-10\" style=\"color: white\" translate=\"RIGHTS.modules_list\">modules_list</span></div></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"40\"><div layout=\"row\" layout-align=\"centre center\"><div flex=\"80\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.searchModule\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" lass=\"demo-header-searchbox md-text\"></div>\n<div flex=\"20\"><md-button class=\"md-icon-button\" aria-label=\"Translate file\" ng-click=\"vm.jsonGenerater(\'module\')\">\n<md-icon md-font-icon=\"icon-code-braces\" class=\"icon s30\"></md-icon></md-button></div></div></div><div flex=\"60\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex=\"85\"><div \nclass=\"divider-vertical\"></div><md-checkbox class=\"no-label\" ng-checked=\"vm.selectedModules.length > 0\" \nng-click=\"vm.toggleSelectModules()\" aria-label=\"-\"></md-checkbox><div class=\"divider-vertical\"></div><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.selectPermission(true)\"><md-icon md-font-icon=\"icon-server\" class=\"icon s20\" style=\"color:#1B5E20\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.selectPermission(false)\">\n<md-icon md-font-icon=\"icon-server-off\" class=\"icon s20\" style=\"color:#B71C1C\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Translate file\" ng-click=\"vm.jsonGenerater(\'action\')\"><md-icon \nmd-font-icon=\"icon-code-braces\" class=\"icon s22\"></md-icon></md-button></div><div><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s22\"></md-icon><input ng-model=\"vm.searchPermission\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" class=\"demo-header-searchbox md-text\">\n</div></div><div flex=\"15\" style=\"margin-right: 20px\"><md-button class=\"md-raised\" \nng-click=\"vm.saveModules(vm.selectedModules)\">Apply</md-button></div></div></div></div><div class=\"content-wrapper\" \nlayout=\"row\" flex><div class=\"content thread-module\" ng-include=\"\'app/main/core_new/module/module.list.html\'\" \nms-scroll flex=\"40\"></div><div class=\"content thread-permission\" \nng-include=\"\'app/main/core_new/module/permission.html\'\" ms-scroll flex=\"60\"></div></div></div></div></div>");
$templateCache.put("app/main/core_new/module/permission.html","<div ng-repeat=\"right in vm.rights.content\" ng-if=\"vm.showContent(right.module)\"><md-subheader class=\"md-no-sticky\" \ntranslate=\"MODULESLIST.{{right.module | deletestring : \'_module\'}}\" ng-if=\"vm.searchPermission === \'\' \" \nstyle=\"margin : 20px\">{{right.module}}</md-subheader><div class=\"thread\" md-ink-ripple \nng-repeat=\"permission in right.contents  | filter:vm.searchPermission\" ng-class=\"unread\" ng-disabled=\"true\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex=\"90\"><md-checkbox \nclass=\"no-label\" ng-checked=\"vm.isSelected(permission)\" ng-click=\"vm.toggleSelectModule(permission, $event)\" \naria-label=\"-\"></md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-truncate\" \ntranslate=\"ACTIONSLIST.{{permission.action.name | deletestring : \'_action\'}}\">{{permission.action.name}}</span></div>\n<div class=\"name\" layout=\"row\" layout-align=\"start center\"><span class=\"text-truncate\">{{permission.action.name}}\n</span></div><div class=\"subject text-truncate\">{{permission.route}}</div><div class=\"message\">\n{{permission.angular_module}}</div></div></div><div flex=\"10\"><md-button class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.saveModule([permission])\"><md-icon md-font-icon=\"icon-server\" ng-if=\"permission.saved\" \nstyle=\"color:#1B5E20\" class=\"icon s24\"></md-icon><md-icon md-font-icon=\"icon-server-off\" ng-if=\"!permission.saved\" \nstyle=\"color:#B71C1C\" class=\"icon s24\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/configuration/display_options/display_options.template.html","<div class=\"price-tables\" flex layout-align=\"center center\" layout=\"row\" layout-wrap><div style=\"width: 45%\" \nclass=\"price-table style-1 md-whiteframe-1dp display_option\" layout=\"column\"><div class=\"package-type md-primary-bg\">\n<span>Layout</span></div><div layout=\"row\" layout-xs=\"column\" style=\"padding: 10px\"><div flex><h3 \ntranslate=\"DISPLAY_OPTIONS.change_style\">Changer le style,mode ou couleur de l\'affichage</h3></div><div flex><md-button\n ng-click=\"vm.toggleOptionsSidenav(\'fuse-theme-options\')\" class=\"cta-button md-raised md-accent\"><span \ntranslate=\"DISPLAY_OPTIONS.change_layout\">Changer layout</span></md-button></div></div><div \nclass=\"package-type md-primary-bg\"><span translate=\"DISPLAY_OPTIONS.display_mode\">Dashboard</span></div><h3 \ntranslate=\"DISPLAY_OPTIONS.display_mode_message\" style=\"padding-left: 10px\">\nChoisir le mode d\'affichage de la liste des videos</h3><form style=\"margin-left: 2%;padding-left: 10px\" \nng-submit=\"submit()\" ng-cloak><md-radio-group ng-model=\"vm.mode\" ng-change=\"vm.change(vm.mode)\"><md-radio-button \nvalue=\"preview_simple_list_big\" aria-label=\"Checkbox 1\"><span translate=\"VIDEOLIST.preview_simple_list_big\"></span>\n</md-radio-button><md-radio-button value=\"simpleList\" aria-label=\"Checkbox 1\"><span \ntranslate=\"VIDEOLIST.preview_simple_list\"></span></md-radio-button><md-radio-button value=\"gallery\" \naria-label=\"Checkbox 1\"><span translate=\"VIDEOLIST.preview_gallery_list\"></span></md-radio-button><md-radio-button \nvalue=\"small\" aria-label=\"Checkbox 1\"><span translate=\"VIDEOLIST.preview_small_list\"></span></md-radio-button>\n<md-radio-button value=\"folders\" aria-label=\"Checkbox 1\"><span translate=\"VIDEOLIST.preview_list_folders\"></span>\n</md-radio-button></md-radio-group></form><h3 translate=\"DISPLAY_OPTIONS.number_elements_message\" \nstyle=\"padding-left: 10px\">Choisir le nombre des éléments à afficher dans la liste des vidéos</h3><form \nstyle=\"margin-left: 2%;padding-bottom: 15px\" ng-submit=\"submit()\" ng-cloak><md-radio-group ng-model=\"vm.lengthTable\" \nng-change=\"vm.changeLength(vm.lengthTable)\" layout=\"row\" layout-xs=\"column\"><div flex><md-radio-button value=\"5\" \naria-label=\"Checkbox 1\"><span>5</span></md-radio-button></div><div flex><md-radio-button value=\"10\" \naria-label=\"Checkbox 1\"><span>10</span></md-radio-button></div><div flex><md-radio-button value=\"20\" \naria-label=\"Checkbox 1\"><span>20</span></md-radio-button></div><div flex><md-radio-button value=\"30\" \naria-label=\"Checkbox 1\"><span>30</span></md-radio-button></div><div flex><md-radio-button value=\"50\" \naria-label=\"Checkbox 1\"><span>50</span></md-radio-button></div><div flex><md-radio-button value=\"100\" \naria-label=\"Checkbox 1\"><span>100</span></md-radio-button></div></md-radio-group></form><h3 \ntranslate=\"DISPLAY_OPTIONS.dashboard_block_message\" style=\"padding-left: 10px\">\nChoisir les blocks à afficher dans le tableau de bord</h3><md-checkbox style=\"margin-left: 2%\" ng-model=\"vm.block1\" \nng-change=\"vm.changeCheckBox()\" aria-label=\"Checkbox 1\"><span translate=\"DISPLAY_OPTIONS.latest_videos_block\">\nBlock dernieres videos ajoutées</span></md-checkbox><md-checkbox style=\"margin-left: 2%\" ng-model=\"vm.block2\" \nng-change=\"vm.changeCheckBox()\" aria-label=\"Checkbox 1\"><span translate=\"DISPLAY_OPTIONS.most_viewed_block\">\nBlock les vidéos les plus visitées</span></md-checkbox><md-checkbox style=\"margin-left: 2%\" ng-model=\"vm.block3\" \nng-change=\"vm.changeCheckBox()\" aria-label=\"Checkbox 1\"><span translate=\"DISPLAY_OPTIONS.audience_stat_block\">\nBlock stat 1</span></md-checkbox><md-checkbox style=\"margin-left: 2%\" ng-model=\"vm.block4\" \nng-change=\"vm.changeCheckBox()\" aria-label=\"Checkbox 1\"><span translate=\"DISPLAY_OPTIONS.nbr_view_stat_block\">\nBlock stat 2</span></md-checkbox></div></div>");
$templateCache.put("app/main/configuration/skinPlayer/skin.template.html","<div ng-if=\"!vm.isSkinPlayer\" id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><img ng-src=\"assets/images/notfound.png\" \nalt=\"Image not found\" style=\"width: 100%;height: 100%;max-height:100%\"></div></div><div ng-if=\"vm.isSkinPlayer\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \niframe-onload=\"iframeLoadedCallBack()\" ng-src=\"{{vm.skinPlayerIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/display/blockComponent/facebook.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent fb-widget-{{item._id}} video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><script>\n(function (d, s, id) {\n        var js, fjs = d.getElementsByTagName(s)[0];\n        if (d.getElementById(id)) return;\n        js = d.createElement(s);\n        js.id = id;\n        js.src = \'https://connect.facebook.net/fr_FR/sdk.js#xfbml=1&version=v3.0\';\n        fjs.parentNode.insertBefore(js, fjs);\n    }(document, \'script\', \"facebook-jssdk\"))\n</script><div class=\"fb_widget\" style=\"height: 100%\"><div class=\"fb-page fb_iframe_widget\" \nstyle=\"width: 100% !important; height: 100%  !important\" data-width=\"319\" data-height=\"380\" \ndata-href=\"{{vm.trustLink(item.options.url)}}\" data-tabs=\"timeline,events\" data-small-header=\"false\" \ndata-adapt-container-width=\"true\" data-hide-cover=\"false\" data-show-facepile=\"true\" fb-xfbml-state=\"rendered\" \nfb-iframe-plugin-query=\"adapt_container_width=true&amp;app_id=&amp;container_width=319&amp;height=380&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Ffacebook%2F&amp;locale=fr_FR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;tabs=timeline%2Cevents&amp;width=319\">\n<span style=\"vertical-align: bottom; width: 100% !important; height: 100% !important\"><iframe name=\"fd4cce6f25101c\" \nwidth=\"100%\" height=\"100%\" frameborder=\"0\" allowtransparency=\"true\" allowfullscreen=\"true\" scrolling=\"no\" \nallow=\"encrypted-media\" title=\"fb:page Facebook Social Plugin\" \nsrc=\"https://www.facebook.com/v2.12/plugins/page.php?adapt_container_width=true&amp;app_id=&amp;channel=http%3A%2F%2Fstaticxx.facebook.com%2Fconnect%2Fxd_arbiter%2Fr%2FoVjM2wVZ10b.js%3Fversion%3D42%23cb%3Df8db61542ee1d%26domain%252Ff39357439511ac%26relation%3Dparent.parent&amp;container_width=319&amp;height=380&amp;hide_cover=false&amp;href=https%3A%2F%2Fwww.facebook.com%2Ffacebook%2F&amp;locale=fr_FR&amp;sdk=joey&amp;show_facepile=true&amp;small_header=false&amp;tabs=timeline%2Cevents&amp;width=319\" \nstyle=\"border: none; visibility: visible; width: 100% !important; height: 100% !important\"></iframe></span></div></div>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"facebook\" \nkey-translate=\"change_page_facebook_link\"></div>");
$templateCache.put("app/main/display/blockComponent/feed.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><iframe src=\"{{vm.trustLink(item.options.url)}}\" \nheight=\"200\" frameborder=\"0\" scrolling=\"no\"></iframe><ms-show-element-config-display component-item=\"item\" vm=\"vm\" \ncomponent-key=\"feed\" key-translate=\"add_rss_link\"></div>");
$templateCache.put("app/main/display/blockComponent/image.html","<img id=\"{{item.eid}}\" data-type=\"image\" class=\"image\" alt=\"{{item.options.altTag}}\" border=\"0\" \nng-src=\"{{item.options.image}}\" width=\"{{item.options.width}}\" height=\"{{item.options.height}}\" \nstyle=\"height:{{item.options.height}}px;{{item.options.attr_style}}\">");
$templateCache.put("app/main/display/blockComponent/live.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><h1 ng-if=\"!item.options.url\" \ntranslate=\"TEMPALTEMANAGEREDITOR.add_live_link\" class=\"editable\"></h1><iframe allow=\"autoplay\" allowfullscreen \nautoplay id=\"{{item.eid}}\" data-type=\"video\" ng-if=\"item.options.url\" src=\"{{vm.trustLink(item.options.url)}}\">\n</iframe><ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"live\" \nkey-translate=\"change_live_link\"></div>");
$templateCache.put("app/main/display/blockComponent/logo.html","<img id=\"{{item.eid}}\" data-type=\"image\" class=\"image\" alt=\"{{item.options.altTag}}\" border=\"0\" \nng-src=\"{{item.options.image}}\" width=\"{{item.options.width}}\" height=\"{{item.options.height}}\" \nstyle=\"height:{{item.options.height}}px\">");
$templateCache.put("app/main/display/blockComponent/program_zone.html","<div layout=\"row\" layout-align=\"center center\" data-type=\"programZone\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><h1 \nng-if=\"(item.options.useSub==\'no\' && !item.options.program) || (item.options.useSub==\'yes\' && !item.options.subLink)\" \ntranslate=\"TEMPALTEMANAGEREDITOR.add_program\" class=\"editable\"></h1><iframe allow=\"autoplay\" id=\"{{item.eid}}\" \ndata-type=\"programZone\" \nng-if=\"(item.options.useSub==\'no\' && item.options.program) || (item.options.useSub==\'yes\' && item.options.subLink)\" \nsrc=\"{{vm.getProgramLink(item.options)}}\" frameborder=\"0\" allowfullscreen style=\"height: 100%;width: 100%\"></iframe>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"programZone\" \nkey-translate=\"change_program\"></div>");
$templateCache.put("app/main/display/blockComponent/scoop.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><a href=\"{{vm.trustLinktwitter(item.options.url)}}\" \nclass=\"scoopit-button\" scit-position=\"vertical\">Scoop.it</a><script type=\"text/javascript\" \nsrc=\"https://www.scoop.it/button/scit.js\"></script><br><a border=\"0\" alt=\"\" target=\"_blank\" \nhref=\"{{item.options.url}}\"><br><img border=\"0\" \nsrc=\"https://www.scoop.it/resources/img/V4/goodies/myscoopitprofile_black.png\" style=\"width:100%\"><br></a><br>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"scoop\" key-translate=\"change_Scoop_link\">\n</div>");
$templateCache.put("app/main/display/blockComponent/text_editor.html","<div ms-scroll ng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\" eid=\"{{item.eid}}\" \ndata-type=\"textEditor\" class=\"editable\" ui-tinymce ng-model=\"item.options.content\" \nstyle=\"height:{{vm.setSize(item.options.height)}};width:inherit\"></div>");
$templateCache.put("app/main/display/blockComponent/twitter.html","<div layout=\"row\" layout-align=\"center center\" \nclass=\"ms-show-element-parent twitter-widget-{{item._id}} video-container\" ng-style=\"item.style(vm,item);\" \nng-class=\"item.options.msColor\" style=\"height: 100%;width: 100%\"><div class=\"timelineTwitter\" style=\"height: 100%\"><a \nclass=\"twitter-timeline\" height=\"100%\" width=\"100%\" href=\"{{vm.trustLinktwitter(item.options.url)}}\">A Twitter List</a>\n<script async src=\"https://platform.twitter.com/widgets.js\" charset=\"utf-8\"></script></div>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"twitter\" \nkey-translate=\"change_page_twitter_link\"></div>");
$templateCache.put("app/main/display/blockComponent/video.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nstyle=\"padding-bottom: 56.25%\" ng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><h1 \nng-if=\"!item.options.url\" translate=\"TEMPALTEMANAGEREDITOR.add_video_link\" class=\"editable\"></h1><iframe \nstyle=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \nid=\"{{item.eid}}\" data-type=\"video\" ng-if=\"item.options.url\" src=\"{{vm.trustLink(item.options.url)}}\"></iframe>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"video\" key-translate=\"change_video_link\">\n</div>");
$templateCache.put("app/main/display/blockComponent/video_intro.html","<div layout=\"row\" style=\"left: 0; top: 0\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><h1 ng-if=\"!item.options.url\" \ntranslate=\"TEMPALTEMANAGEREDITOR.add_video_link\" class=\"editable\"></h1><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \nid=\"{{item.eid}}\" data-type=\"video\" ng-if=\"item.options.url\" src=\"{{vm.trustLink(item.options.url)}}\"></iframe>\n<ms-show-element-config-display component-item=\"item\" vm=\"vm\" component-key=\"video\" key-translate=\"change_video_link\">\n</div>");
$templateCache.put("app/main/display/blockComponent/weather.html","<div id=\"{{item.eid}}\" ng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\" data-type=\"widget-weather\" \nclass=\"ms-show-element-parent bloc widget-bloc box-shadow overflow layout-row layout-align-start-start isPs4 ps ps--active-y\" \nlayout=\"row\" layout-align=\"start start\"><div ng-if=\"!item.options.location\" layout=\"row\" flex \nlayout-align=\"center center\" style=\"height:100%\"><h1 translate=\"TEMPALTEMANAGEREDITOR.add_position\"></h1></div>\n<weather-component location=\"item.options.location\"></weather-component><ms-show-element-config-display \ncomponent-item=\"item\" vm=\"vm\" component-key=\"weather\" key-translate=\"change_weather\"></div>");
$templateCache.put("app/main/display/blockComponent/web.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><iframe src=\"{{vm.trustLink(item.options.url)}}\" \nframeborder=\"0\" style=\"width: 100%;height: 100%\"></iframe><ms-show-element-config-display component-item=\"item\" \nvm=\"vm\" component-key=\"web\" key-translate=\"change_Web_link\"></div>");
$templateCache.put("app/main/display/blockComponent/youtube.html","<div layout=\"row\" layout-align=\"center center\" class=\"ms-show-element-parent video-container\" \nng-style=\"item.style(vm,item)\" ng-class=\"item.options.msColor\"><iframe id=\"ytplayer\" type=\"text/html\" \nsrc=\"{{vm.trustLink(item.options.url)}}\" style=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"autoplay\" autoplay frameborder=\"0\" allowfullscreen></iframe><ms-show-element-config-display \ncomponent-item=\"item\" vm=\"vm\" component-key=\"youtube\" key-translate=\"change_video_chaine_link\"></div>");
$templateCache.put("app/main/export/dailymotion/export.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"column\" layout-align=\"space-between\" flex><div \nng-include=\"\'app/main/export/dailymotion/form-export.template.html\'\"></div></div></div></div>");
$templateCache.put("app/main/export/dailymotion/form-export.template.html","<form name=\"empExportDailymotionForm\" method=\"post\" id=\"empExportDailymotionForm\" novalidate=\"novalidate\" \nng-submit=\"empExportDailymotionForm.$valid && vm.submitExportDailymotionForm()\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" for=\"empExportDailymotionForm_title\">\nTitre de la vidéo</label><input type=\"text\" id=\"empExportDailymotionForm_title\" name=\"empExportDailymotionForm[title]\" \nng-attr-name=\"title\" ng-model=\"vm.empExportDailymotionForm.title\" aria-invalid=\"false\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\">Description de la vidéo</label>\n<div class=\"md-resize-wrapper\"><textarea id=\"empExportDailymotionForm_description\" \nname=\"empExportDailymotionForm[description]\" ng-attr-name=\"description\" \nng-model=\"vm.empExportDailymotionForm.description\" rows=\"1\" aria-invalid=\"false\" style=\"height: 30px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\">Mots-clefs de la vidéo</label><input \ntype=\"text\" id=\"empExportDailymotionForm_keyWords\" name=\"empExportDailymotionForm[keyWords]\" ng-attr-name=\"keyWords\" \nng-model=\"vm.empExportDailymotionForm.keyWords\" aria-invalid=\"false\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\">Canaux</label><md-select \nng-model=\"vm.empExportDailymotionForm.canal\" ng-required=\"true\"><md-option ng-repeat=\"canal in vm.canaux\" \nng-value=\"canal.option\">{{ canal.val }}</md-option></md-select><div \nng-messages=\"empExportDailymotionForm.canal.$error\" ng-if=\"empExportDailymotionForm.canal.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div\n layout=\"row\" flex><md-button class=\"md-warn\" ui-sref=\"app.media_video_list({type: \'ongoing\'})\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"export_submit\" \ntranslate=\"EXPORT.export_submit\" translate-attr-aria-label=\"EXPORT.export_submit\">export_submit</md-button></div>\n</form>");
$templateCache.put("app/main/export/dailymotion/form.template.html","<form name=\"empExportCompteForm\" method=\"post\" id=\"empExportCompteForm\" novalidate=\"novalidate\" \nng-submit=\"empExportCompteForm.$valid && vm.submitLoginDailymotionForm()\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label for=\"empExportCompteForm_login\">Dailymotion Login</label><input type=\"text\" \nid=\"empExportCompteForm_login\" name=\"empExportCompteForm[login]\" required=\"required\" ng-attr-name=\"login\" \nng-model=\"vm.empExportCompteForm.login\" aria-invalid=\"false\"><div ng-messages=\"empExportCompteForm.login.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nfor=\"empExportCompteForm_password\">Dailymotion Mot de passe</label><input type=\"password\" \nid=\"empExportCompteForm_password\" name=\"empExportCompteForm[password]\" required=\"required\" ng-attr-name=\"password\" \nng-model=\"vm.empExportCompteForm.password\" aria-invalid=\"false\"><div ng-messages=\"empExportCompteForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"row\" flex><md-button class=\"md-warn\" \nui-sref=\"app.media_video_list({type: \'ongoing\'})\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"login_submit\" translate=\"EXPORT.login_submit\" \ntranslate-attr-aria-label=\"EXPORT.login_submit\">login_submit</md-button></div></form>");
$templateCache.put("app/main/export/dailymotion/login.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"column\" layout-align=\"space-between\" flex><span \nclass=\"error_msg md-red-300-bg\" ng-if=\"vm.error_message\">{{vm.error_message}}</span><div \nng-include=\"\'app/main/export/dailymotion/form.template.html\'\"></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/arrivee_regions.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\">\n<ms-block-component-display index=\"1\" block=\"B\" vm=\"vm\"></div><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"display: flex\"><div id=\"c\" flex=\"30\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"\"><ms-block-component-display index=\"2\" block=\"C\" vm=\"vm\"></div><div id=\"d\" flex=\"70\" \nlayout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"3\" \nblock=\"C\" vm=\"vm\"></div></div><div layout=\"row\" layout-align=\"space-between center\" style=\"display: flex\"><div id=\"e\" \nflex=\"30\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display \nindex=\"4\" block=\"C\" vm=\"vm\"></div><div id=\"f\" flex=\"70\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"5\" block=\"C\" vm=\"vm\"></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/data_news.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" flex=\"20\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\">\n<ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div><div id=\"c\" flex=\"40\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"margin: 0 auto;align-items: center;justify-content: center;text-align: center;width: 50%\">\n<ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div id=\"d\" flex=\"20\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\"><ms-block-component-display index=\"3\" block=\"A\" \nvm=\"vm\"></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_1.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: hidden;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"box-shadow toolbar containBlocNumber editable\" \nlayout=\"row\" layout-align=\"start start\" flex ng-style=\"vm.toolbarStyle(vm.screens[vm.currentScreenIndex].toolbar)\" \nng-class=\"vm.screens[vm.currentScreenIndex].toolbar.msColor\" \nng-click=\"vm.showElementConfigTab(vm.screens[vm.currentScreenIndex].toolbar,\'toolbar\',$event)\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div style=\"height: 100%; overflow: hidden\"><div \nlayout=\"row\" layout-align=\"space-around center\" \nclass=\"video-widget-container parent-container layout-align-space-around-center layout-row\"><div id=\"a\" \nlayout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout=\"column\" layout-xs=\"row\" layout-align=\"start start\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div></div>\n<div layout=\"row\" layout-align=\"space-around center\" \nclass=\"texts-widget-container layout-align-space-around-center layout-row\"><div id=\"c\" layout=\"column\" layout-xs=\"row\" \nclass=\"bloc-container containBlocNumber\" layout-align=\"start start\" style=\"width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div id=\"d\" layout=\"column\" layout-xs=\"row\" \nclass=\"bloc-container containBlocNumber\" style=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display\n index=\"4\" block=\"A\" vm=\"vm\"></div></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_10.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"toolbar containBlocNumber editable layout-row layout-align-start-start\" layout=\"row\" layout-align=\"start start\" \nflex ng-style=\"vm.toolbarStyle(vm.screens[vm.currentScreenIndex].toolbar)\" \nng-class=\"vm.screens[vm.currentScreenIndex].toolbar.msColor\" \nng-click=\"vm.showElementConfigTab(vm.screens[vm.currentScreenIndex].toolbar,\'toolbar\',$event)\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div id=\"layout-content\" \nstyle=\"height: 100%; overflow: hidden;position:relative;width:{{vm.screens[vm.currentScreenIndex].width}}px;border: 1px solid #e4e4e4;margin: 0 auto\">\n<div layout=\"row\" layout-align=\"space-around center\" \nclass=\"layout-row layout-align-space-around-center video-widget-container parent-container\" style=\"height: 500px\"><div \nid=\"a\" calss=\"layout-align-center-stretch\" layout-align=\"center stretch\" flex flex-xs=\"100\" height=\"100%\" \nclass=\"video-container-wrapper box-shadow containBlocNumber bloc-container md-deep-purple-50-bg\" \nstyle=\"position: absolute;top: 10px;left: 10px; background: transparent\"><ms-block-component-display index=\"1\" \nblock=\"A\" vm=\"vm\"></div><div id=\"b\" layout=\"column\" layout-xs=\"row\" flex-xs=\"100\" layout-align=\"start start\" flex=\"30\" \nclass=\"widget-container bloc-container container containBlocNumber\" \nstyle=\"max-width: 340px;max-height: 440px;position: absolute;top: 10px;left: 360px\"><ms-block-component-display \nindex=\"2\" block=\"A\" vm=\"vm\"></div></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_11.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"toolbar containBlocNumber editable\" layout=\"row\" \nlayout-align=\"start start\" flex ng-style=\"vm.toolbarStyle(vm.screens[vm.currentScreenIndex].toolbar)\" \nng-class=\"vm.screens[vm.currentScreenIndex].toolbar.msColor\" \nng-click=\"vm.showElementConfigTab(vm.screens[vm.currentScreenIndex].toolbar,\'toolbar\',$event)\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div class=\"first-container\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div id=\"a\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_12.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"toolbar containBlocNumber editable\" layout=\"row\" \nlayout-align=\"start start\" flex ng-style=\"vm.toolbarStyle(vm.screens[vm.currentScreenIndex].toolbar)\" \nng-class=\"vm.screens[vm.currentScreenIndex].toolbar.msColor\" \nng-click=\"vm.showElementConfigTab(vm.screens[vm.currentScreenIndex].toolbar,\'toolbar\',$event)\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div id=\"layout-content\" \nstyle=\"height: 100%; overflow: hidden;position:relative;width:{{vm.screens[vm.currentScreenIndex].width}}px;margin: 0 auto;border:1px solid #e4e4e4\">\n<div layout=\"row\" layout-align=\"space-around center\" class=\"video-widget-container parent-container\" \nstyle=\"height: 500px\"><div id=\"a\" layout-align=\"center stretch\" flex flex-xs=\"100\" height=\"100%\" \nclass=\"video-container-wrapper box-shadow containBlocNumber bloc-container md-deep-purple-50-bg\" \nstyle=\"position: absolute;top: 10px;left: 210px; background: transparent\"><ms-block-component-display index=\"1\" \nblock=\"A\" vm=\"vm\"></div></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_13.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container layout-row\" layout=\"row\" \nstyle=\"margin: 0px;justify-content: center\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\">\n</div><div id=\"b\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\">\n</div><div id=\"c\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\">\n</div></div><div class=\"last-container layout-row\" layout=\"row\" style=\"margin: 0px;justify-content: center\"><div \nid=\"d\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\">\n</div><div id=\"e\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\">\n</div><div id=\"f\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\">\n</div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_14.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-row layout-margin layout-align-space-around-center\" layout-align=\"space-around center\" \nlayout=\"row\" layout-margin><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_15.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-align-space-around-center layout-column layout-margin\" \nlayout-align=\"space-around center\" layout=\"column\" layout-margin><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_16.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"width:100%;height: 100%;position:relative\"><div class=\"screen-content\" style=\"height: 100%\"><div \nid=\"{{vm.screens[vm.currentScreenIndex].rid}}\" class=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\" \nstyle=\"width: 100%;height: 100%\"><div style=\"width: 100%;height: 100%\" \nclass=\"first-container layout-row layout-align-space-around-center\" layout-align=\"space-around center\" layout=\"row\">\n<div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch bloc-fullscreen\" style=\"width: 100%;height: 100%\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_2.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-align-space-around-center layout-row layout-margin\" layout-align=\"space-around center\" \nlayout=\"row\" layout-margin><div id=\"a\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center center\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n<div class=\"first-container layout-align-space-around-center layout-row layout-margin\" \nlayout-align=\"space-around center\" layout=\"row\" layout-margin><div id=\"c\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div \nlayout=\"column\" hide-xs class=\"layout-column\"><div id=\"d\" class=\"layout-align-center-center\" \nlayout-align=\"center center\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div \nid=\"e\" class=\"layout-align-center-center\" layout-align=\"center center\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_3.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-align-space-around-center layout-row layout-margin\" layout-align=\"space-around center\" \nlayout=\"row\" layout-margin><div id=\"a\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center center\" class=\"layout-align-center-center bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n<div class=\"last-container layout-align-space-around-center layout-row layout-margin\" \nlayout-align=\"space-around center\" layout=\"row\" layout-margin><div id=\"c\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div \nid=\"d\" layout-align=\"center center\" class=\"layout-align-center-center bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_4.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_5.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:absolute\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container layout-margin layout-row\" \nlayout=\"row\" layout-margin><div id=\"a\" layout-align=\"center center\" layout=\"row\" \nclass=\"layout-align-center-center layout-row bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_6.html","<div class=\"screen-wrapper\" ng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container layout-row\" layout=\"row\" \nstyle=\"margin: 0px;justify-content: center\"><div layout=\"column\" style=\"margin: 0px\" class=\"layout-column\"><div id=\"a\" \nlayout-align=\"center center\" class=\"layout-align-center-center bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center center\" class=\"layout-align-center-center bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n<div id=\"c\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\">\n</div><div layout=\"column\" style=\"margin: 0px\" class=\"layout-column\"><div id=\"d\" layout-align=\"center center\" \nclass=\"layout-align-center-center bloc-container containBlocNumber\" style=\"width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div id=\"e\" layout-align=\"center center\" \nclass=\"layout-align-center-center bloc-container containBlocNumber\" style=\"width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div></div></div><div class=\"last-container layout-row\" \nlayout=\"row\" layout-margin style=\"margin: 0px;justify-content: center\"><div id=\"f\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\">\n</div><div id=\"g\" layout-align=\"center center\" class=\"layout-align-center-center bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"6\" block=\"A\" vm=\"vm\">\n</div><div id=\"h\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content;margin: 0px\"><ms-block-component-display index=\"7\" block=\"A\" vm=\"vm\">\n</div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_7.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-row layout-margin layout-align-space-around-center\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nlayout=\"column\" hide-xs class=\"layout-column\"><div id=\"b\" layout-align=\"center center\" \nclass=\"bloc-container containBlocNumber\" style=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display\n index=\"1\" block=\"A\" vm=\"vm\"></div><div id=\"c\" layout-align=\"center center\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div></div>\n</div><div class=\"last-container layout-align-space-around-center layout-row\" layout=\"row\" \nlayout-align=\"space-around center\"><div id=\"d\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div \nid=\"e\" layout-align=\"center center\" class=\"bloc-container containBlocNumber layout-align-center-center\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div><div \nid=\"f\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_8.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow-y: auto;overflow-x: hidden;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-align-space-around-center layout-row layout-margin\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div layout=\"column\" hide-xs class=\"layout-column\"><div id=\"a\" \nlayout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n<div id=\"c\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div \nlayout=\"column\" hide-xs class=\"layout-column\"><div id=\"d\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div></div>\n</div><div class=\"last-container layout-row layout-margin layout-align-space-around-center\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div id=\"e\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div><div \nid=\"f\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\"></div><div \nid=\"g\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"6\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_9.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-align-space-around-center layout-row layout-margin\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div></div>\n<div class=\"last-container layout-align-space-around-center layout-row layout-margin\" layout=\"row\" layout-margin \nlayout-align=\"space-around center\"><div id=\"c\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div \nlayout=\"column\" flex hide-xs class=\"layout-column\"><div id=\"d\" layout-align=\"center stretch\" \nclass=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div \nclass=\"last-container layout-align-space-around-center\" layout=\"row\" layout-margin layout-align=\"space-around center\">\n<div id=\"e\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div><div \nid=\"f\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\"></div><div \nid=\"g\" layout-align=\"center stretch\" class=\"layout-align-center-stretch bloc-container containBlocNumber\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"6\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_live.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"width:100%;height: 100%;position:relative\"><div class=\"screen-content\" style=\"height: 100%\"><div \nid=\"{{vm.screens[vm.currentScreenIndex].rid}}\" class=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\" \nstyle=\"width: 100%;height: 100%\"><div style=\"width: 100%;height: 100%\" \nclass=\"first-container layout-row layout-align-space-around-center\" layout-align=\"space-around center\" layout=\"row\">\n<div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber layout-align-center-stretch bloc-fullscreen\" style=\"width: 100%;height: 100%\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/disposition_video_full_screen.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: hidden;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div \nclass=\"first-container layout-row layout-align-space-around-center\" layout-align=\"space-around center\" layout=\"row\">\n<div id=\"a\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber layout-align-center-stretch\" \nstyle=\"width: fit-content;width: -moz-fit-content\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/food_tech.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\"><span \nclass=\"blocNumber\" ms-block-display=\"F\">E</span><ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div><div \nid=\"c\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\">\n<ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\"></div><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"display: flex;  margin: 0 20px\"><div id=\"d\" flex=\"50\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div \nid=\"e\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"\">\n<ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/innovation_new.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\"><div id=\"a\" flex=\"20\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" flex=\"20\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\">\n<ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div><div id=\"c\" flex=\"20\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"padding: 0 10%\"><ms-block-component-display index=\"2\" block=\"A\" \nvm=\"vm\"></div><div layout=\"row\" flex=\"40\" layout-align=\"space-between center\" style=\"display: flex;  margin: 0 20px\">\n<div id=\"d\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" style=\"\">\n<ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div id=\"e\" flex=\"50\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\"></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/let_me.html","<div id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" class=\"screen-wrapper\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative;overflow:hidden\"><div \nclass=\"screen-content\" style=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\" layout-margin><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"margin: 0 !important; right:0; left:0%; top: 0px ; position: absolute;width: fit-content;width: 100%\">\n<ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div layout=\"row\" layout-align=\"space-between center\" \nstyle=\"display: flex\"><div id=\"b\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"left:15%; top: 245px ; position: absolute; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"1\" block=\"B\" vm=\"vm\"></div><div id=\"c\" flex=\"30\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"left:60%;top: 325px  ;   position: absolute; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"2\" block=\"C\" vm=\"vm\"></div><div id=\"d\" flex=\"30\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"position: absolute;  top:227px;  right: 0; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"3\" block=\"D\" vm=\"vm\"></div><div id=\"e\" flex=\"30\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"display:none;position: absolute;  top:284px;  right: 13%; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"4\" block=\"E\" vm=\"vm\"></div></div></div><div layout=\"column\" \nlayout-align=\"space-between center\" style=\"display: flex\"><div id=\"f\" flex=\"50\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"left:10%; bottom: -80px ; position: absolute; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"5\" block=\"F\" vm=\"vm\"></div><div id=\"g\" flex=\"30\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"left:60%; bottom: -20px ; position: absolute; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"6\" block=\"G\" vm=\"vm\"></div><div id=\"h\" flex layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"position: absolute;    top: 65%; right: 0; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"7\" block=\"H\" vm=\"vm\"></div><div id=\"k\" flex layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" \nstyle=\"display:none; position: absolute;    top: 69%; right: 13%; width: fit-content;width: -moz-fit-content\">\n<ms-block-component-display index=\"6\" block=\"G\" vm=\"vm\"></div></div></div></div></div>");
$templateCache.put("app/main/display/dispositionComponent/revue_press.html","<div class=\"screen-wrapper\" id=\"{{vm.screens[vm.currentScreenIndex].screenId}}\" \nng-class=\"{\'has-info-bar on-editor\':vm.screens[vm.currentScreenIndex].hasInfoBar}\" \nng-if=\"vm.isDefined(vm.currentScreenIndex)\" fullscreen=\"vm.isFullScreen\" \nstyle=\"{{vm.getBackgroundStyle(vm.screens[vm.currentScreenIndex],1)}};position:relative\"><div class=\"screen-content\" \nstyle=\"overflow: auto;height: 100%\"><div id=\"{{vm.screens[vm.currentScreenIndex].rid}}\" \nclass=\"{{vm.screens[vm.currentScreenIndex].screenClass}}\"><div class=\"first-container\" \nlayout-align=\"space-around stretch\" layout=\"column\"><div id=\"a\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"\"><ms-block-component-display index=\"0\" block=\"A\" vm=\"vm\"></div><div \nid=\"b\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"padding: 1% 2%;background-image: linear-gradient(to right, #4e4e4e 50%, rgba(255, 255, 255, 0.15) 0), linear-gradient(to left, #c3b07400 0px, #5161b700 0px);background-position: bottom;background-size: 96% 5px;background-repeat: no-repeat\">\n<ms-block-component-display index=\"1\" block=\"A\" vm=\"vm\"></div><div id=\"c\" flex=\"50\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"padding: 0 2%\"><ms-block-component-display index=\"2\" block=\"A\" vm=\"vm\">\n</div><div id=\"d\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"padding: 1% 2%;background-image: linear-gradient(to right, #4e4e4e 50%, rgba(255, 255, 255, 0.15) 0), linear-gradient(to left, #c3b07400 0px, #5161b700 0px);background-position: bottom;background-size: 96% 5px;background-repeat: no-repeat\">\n<ms-block-component-display index=\"3\" block=\"A\" vm=\"vm\"></div><div id=\"e\" flex=\"50\" layout-align=\"center stretch\" \nclass=\"bloc-container containBlocNumber\" style=\"padding: 0 2%\"><ms-block-component-display index=\"4\" block=\"A\" vm=\"vm\">\n</div><div id=\"f\" flex=\"50\" layout-align=\"center stretch\" class=\"bloc-container containBlocNumber\" \nstyle=\"padding: 0 2%\"><ms-block-component-display index=\"5\" block=\"A\" vm=\"vm\"></div></div></div></div></div>");
$templateCache.put("app/main/export/youtube/export.template.html","<div id=\"e-commerce-product\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content fullpage\" \nlayout=\"column\"><div layout=\"column\" layout-align=\"space-between\" flex><div \nng-include=\"\'app/main/export/youtube/form.template.html\'\"></div></div></div></div>");
$templateCache.put("app/main/export/youtube/form.template.html","<form name=\"empExportYoutubeForm\" method=\"post\" class=\"md-inline-form ng-pristine ng-valid\" id=\"empExportForm\" \nnovalidate=\"novalidate\" ng-submit=\"vm.submitExportYoutubeForm()\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label for=\"empExportYoutubeForm_title\">Titre de la vidéo</label><input type=\"text\" \nid=\"empExportYoutubeForm_title\" name=\"empExportYoutubeForm[title]\" ng-attr-name=\"title\" \nng-model=\"vm.empExportYoutubeForm.title\" aria-invalid=\"false\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label for=\"empExportYoutubeForm_description\">Description de la vidéo\n</label><div class=\"md-resize-wrapper\"><textarea id=\"empExportYoutubeForm_description\" \nname=\"empExportYoutubeForm[description]\" ng-attr-name=\"description\" ng-model=\"vm.empExportYoutubeForm.description\" \nrows=\"1\" aria-invalid=\"false\" style=\"height: 30px\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label for=\"empExportYoutubeForm_keyWords\">Mots-clefs de la vidéo</label><input type=\"text\" \nid=\"empExportYoutubeForm_keyWords\" name=\"empExportYoutubeForm[keyWords]\" ng-attr-name=\"keyWords\" \nng-model=\"vm.empExportYoutubeForm.keyWords\" aria-invalid=\"false\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label>Catégorie de la vidéo</label><md-select \nng-model=\"vm.empExportYoutubeForm.categories\" ng-init=\"vm.empExportYoutubeForm.categories = vm.youtube_categories[0]\">\n<md-option ng-repeat=\"categ in vm.youtube_categories track by categ.id\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"categ.id\">{{categ.title}}</md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" ng-model=\"vm.empExportYoutubeForm.pub\"><label \ntranslate=\"EXPORT.form_label_pub\" class=\"ng-scope\">Ceci est une vidéo privée.</label></md-checkbox></div><div \nlayout=\"row\" flex><md-button class=\"md-warn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"export_submit\" translate=\"EXPORT.export_submit\" \ntranslate-attr-aria-label=\"EXPORT.export_submit\">export_submit</md-button></div></form>");
$templateCache.put("app/main/error/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nng-if=\"!$root.show_link\" class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"Search for anything\" translate translate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a \nng-if=\"!$root.show_link\" class=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR404.GO_BACK\">Go back to dashboard\n</a></div></div>");
$templateCache.put("app/main/error/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/main/error/403/error-403.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR403.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR403.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div class=\"message\" \nng-if=\"!$root.show_link\"><p translate=\"ERROR403.unauthorize_to_ressource\">\nSorry but we couldn’t find the page you are looking for</p><p><strong>{{vm.nonAuhtorizedState()}}</strong></p></div>\n<div class=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\" ng-if=\"!$root.show_link\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"Search for anything\" translate translate-attr-placeholder=\"ERROR403.SEARCH\" flex></div><a \nclass=\"back-link md-accent-color\" href=\"/\" translate=\"ERROR403.GO_BACK\" ng-if=\"!$root.show_link\">Go back to dashboard\n</a></div></div>");
$templateCache.put("app/main/media/images/image.template.html","<div id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_image\" \nng-src=\"{{vm.urlImageList}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\">\n</iframe></div></div></div></div>");
$templateCache.put("app/main/media/scorms/scorm.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px;    position: relative\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 100%;\n    position: absolute;\n    width: 100%\" layout=\"row\" layout-wrap><iframe \nng-src=\"{{vm.urlScormList}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\">\n</iframe></div></div></div></div>");
$templateCache.put("app/main/media/video/add_edit.template.html","<div class=\"e-commerce-product page-layout simple fullwidth page-add-edit\" layout=\"column\" \nng-class=\"{\'p-10\': vm.isNew}\"><div layout=\"column\" style=\"overflow: auto\"><div ng-if=\"vm.playerIsLoading\" \nlayout-align=\"center center\" layout=\"row\" class=\"m-8\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\">\n</md-progress-circular><md-tooltip md-autohide=\"true\" md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}\n</md-tooltip></div><div layout-align=\"center center\" layout=\"row\" class=\"m-8\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-16 centerdiiv\" flex=\"100\" flex-xs=\"100\"><div class=\"md-title text-left\">\n{{\'MESSAGES.selection_vignettes\'|translate}}</div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" \nlayout-xs=\"column\" id=\"IE-div-player\"><div ng-if=\"vm.showPlayer && !vm.isMultiUpload\" id=\"div1\" \nng-class=\"{\'hidePlayer\': !vm.showPlayer}\" flex class=\"layout-video-wrapper\" layout=\"row\" layout-align=\"center start\">\n<div class=\"player_ie-exception-3\" layout=\"column\" style=\"width: 100%\"><div class=\"ie-exception-3\" \nstyle=\"display: flex; position: relative\" flex><div ms-scroll \nclass=\"no-padding video-container video-add-edit hide-xs\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"position: relative;padding: 54% 1em 1em\"><iframe id=\"player_add\" width=\"600\" height=\"307\" \nng-src=\"{{vm.playerLink}}\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\" \nstyle=\"position: absolute;\n                                                top: 0px;\n                                                left: 0px;\n                                                width: 100%;\n                                                border: none;\n                                                height: 100%\">\n</iframe></div></div><div class=\"thumbnails-container hide-xs\" \nng-class=\"{\'layout-align-center-center\': !vm.showPlayer && !vm.isMultiUpload}\" layout=\"row\" layout-xs=\"column\" \nms-scroll><div><div layout=\"row\" layout-align=\"left left\" style=\"width: 260px; height: 100%\"><md-radio-group \nng-model=\"vm.empMediaVideoForm.logo\" ng-click=\"vm.clickVignette()\"><md-radio-button id=\"radiobtn-vignette\" \nng-repeat=\"thumb in vm.generatedThumbs\" ng-value=\"thumb\" aria-label=\"thumb\" ng-click=\"vm.setAndPreviewThumb(thumb)\" \nstyle=\"height:auto\"><img class=\"IE-img-vignettes\" id=\"img-hover\" ng-click=\"vm.setAndPreviewThumb(thumb)\" \nng-class=\"{\'filter\': thumb===vm.empMediaVideoForm.logo}\" ng-src=\"{{thumb}}\" style=\"cursor: pointer\"><any \nclass=\"middle\"><any class=\"text\" translate=\"MESSAGES.make_vignette\">make_vignette</any></any></md-radio-button>\n</md-radio-group></div></div></div></div><div flex id=\"IE-div-metadata\" class=\"hide-xs\" \nhas-permission=\"media_video_get_video_meta_data\" ng-if=\"vm.videoMetaData\"><md-button \nstyle=\"margin-left: 0px;padding-left: 10px;padding-top: 0px;float: left;margin-top: 5px;padding-right: 10px;margin-top: 10px\" \nclass=\"hide-xs\" ng-click=\"vm.showVideoDetail($event)\" aria-label=\"video_detail\" translate md-ink-ripple=\"false\" \ntranslate-attr-aria-label=\"MESSAGES.video_detail\"><md-icon style=\"opacity: .8\" md-font-icon=\"icon-meta-custom\">\n</md-icon><span translate=\"MESSAGES.video_detail\">video_detail</span></md-button></div></div></div><div \nng-if=\"!vm.showPlayer && !vm.isMultiUpload && !vm.playerIsLoading\" \nstyle=\"width: 100%; max-height: none;margin: 0 auto;color: #5c5c5c;font-size: large;border: 1px solid #d8d8d8;background: #f4f4f4\" \nflex layout=\"column\" layout-align=\"center center\"><img \nsrc=\"data:image/svg+xml;base64,\nPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDg4LjQ1MSA0ODguNDUxIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0ODguNDUxIDQ4OC40NTE7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgY2xhc3M9IiI+PGc+PGc+Cgk8cGF0aCBkPSJNNDg0LjEyNSw0MTIuMDEzbC0yMTIuMi0zNjcuNmMtMTIuMy0yMS4zLTQzLjEtMjEuMy01NS40LDBsLTIxMi4yLDM2Ny42Yy0xMi4zLDIxLjMsMy4xLDQ4LDI3LjcsNDhoNDI0LjQgICBDNDgxLjAyNSw0NjAuMDEzLDQ5Ni40MjUsNDMzLjMxMyw0ODQuMTI1LDQxMi4wMTN6IE0yNDQuNTI1LDE1Ny42MTNjMTMuNiwwLDI0LjYsMTEuMywyNC4yLDI0LjlsLTQsMTM5LjYgICBjLTAuMywxMS05LjMsMTkuNy0yMC4zLDE5LjdzLTIwLTguOC0yMC4zLTE5LjdsLTMuOS0xMzkuNkMyMTkuOTI1LDE2OC45MTMsMjMwLjgyNSwxNTcuNjEzLDI0NC41MjUsMTU3LjYxM3ogTTI0NC4yMjUsNDEwLjExMyAgIGMtMTMuOSwwLTI1LjItMTEuMy0yNS4yLTI1LjJjMC0xMy45LDExLjMtMjUuMiwyNS4yLTI1LjJzMjUuMiwxMS4zLDI1LjIsMjUuMlMyNTguMTI1LDQxMC4xMTMsMjQ0LjIyNSw0MTAuMTEzeiIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9ImFjdGl2ZS1wYXRoIiBkYXRhLW9sZF9jb2xvcj0iIzAwMDAwMCIgc3R5bGU9ImZpbGw6I0JCQkJCQiI+PC9wYXRoPgo8L2c+PC9nPiA8L3N2Zz4=\" \nstyle=\"width: 100px\"><div style=\"width: 100%; max-height: 50px;margin: 0 auto;font-size: large\" flex layout=\"row\" \nlayout-align=\"center center\" translate=\"MESSAGES.error_read_video\">la vidéo ne peut pas etre lu</div></div><div \nng-if=\"vm.isMultiUpload\" layout=\"column\" layout-align=\"end center\"><div layout=\"row\" style=\"max-width: 1000px\"><div \nstyle=\"position: relative\" ng-repeat=\"(key,item) in $root.files\" layout=\"column\"><md-card id=\"mdcard\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);!important;width: 154px\">\n<img ng-src=\"assets/images/vignette.jpg\"><md-card-actions style=\"height: 30px\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span \ntitle=\"{{item.file.name}}\" \nstyle=\"font-size: 0.87em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div></div><div hide-xs class=\"hide-xs\" flex \nstyle=\"margin: 0 auto; flex-grow: .5\"><div \nng-class=\"{\'layout-align-center-center\': !vm.showPlayer && !vm.isMultiUpload}\" layout=\"row\" layout-xs=\"column\" \nstyle=\"height:100%\"><div id=\"IE-div-vignettes\" layout=\"column\" style=\"width: 100%\"><div class=\"img-wrapper\"><md-icon \nng-if=\"vm.videoThumb === null || vm.videoThumb === \'\' || vm.videoThumb === false || vm.videoThumb === \'not_found\'\" \nmd-font-icon=\"icon-picture\" class=\"s72\"></md-icon><img ng-if=\"vm.videoThumb && vm.videoThumb!== \'not_found\'\" \nclass=\"media\" on-error-src=\"assets/images/no-image-custom.svg\" style=\"height: 100%;width: 100%;cursor: pointer\" \nng-style=\"style()\" on-resize-el \nng-src=\"{{ videoThumb ? ( videoThumb + \'?v=\' + vm.randomValue) : (  vm.videoThumb  +\'?v=\' + vm.randomValue) }}\"><div \nclass=\"vignette-button-container\"><md-button class=\"md-icon-button hide-xs\" \nng-if=\"vm.isNew || (!vm.isNew && vm.hasSourceVideo)\" ng-click=\"vm.regenerateThumbs()\" \ntitle=\"{{ \'MESSAGES.generate_vignette\'|translate}}\"><md-progress-circular ng-if=\"vm.generatingMultiThumbs\" \nclass=\"md-primary mh-10 circular-progress-button\" md-diameter=\"20\"></md-progress-circular><md-icon \nmd-font-icon=\"icon-rotate-3d\" ng-if=\"!vm.generatingMultiThumbs\"></md-icon></md-button></div></div><div \nclass=\"mt-20 checkdown-menu\"><md-radio-group ng-model=\"vm.imageFrom\" class=\"hide-xs\" ng-switch=\"vm.imageFrom\"><div \nclass=\"mb-15 text-left\"><md-radio-button flex value=\"local\" aria-label=\"choose_thumb_from_local\" \ntranslate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"><span translate=\"MESSAGES.choose_thumb_from_local\">\nchoose_thumb_from_local</span></md-radio-button><div ng-switch-when=\"local\" flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-file-error=\"vm.fileError($file,$message)\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" \nflow-btn ng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_thumb\">choose_thumb</span></md-button><md-progress-circular ng-if=\"vm.uploadingInPogress\" \nclass=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div><div ng-if=\"vm.dropping\" \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><p ng-if=\"vm.imageName\" class=\"text-truncate mh-10\">{{vm.imageName}}</p></div></div></div>\n<md-divider ng-if=\"vm.empMediaVideoForm.useTheme\" md-inset></md-divider><div class=\"mb-15\" \nng-if=\"vm.isNew || (!vm.isNew && vm.hasSourceVideo)\"><md-radio-button flex value=\"top\" \naria-label=\"choose_thumb_from_local\" translate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"><span \ntranslate=\"MESSAGES.take_vignette_from_video\">Capturer à partir de la vidéo</span></md-radio-button><md-button \nng-if=\"vm.imageFrom===\'top\'\" ng-click=\"vm.takeVignette()\" class=\"cta-button md-raised md-accent generating-thumbnail\">\n<md-progress-circular ng-if=\"generatingThumbnail\" class=\"md-primary mh-10 circular-progress-button\" md-diameter=\"20\">\n</md-progress-circular><span translate=\"MESSAGES.take_vignette\">Faire une capture de la vignette</span></md-button>\n</div><div class=\"mb-15\"><md-radio-button flex value=\"theme\" ng-click=\"vm.testVignette()\" \naria-label=\"choose_thumb_from_selected_theme\" translate-attr-aria-label=\"MESSAGES.choose_thumb_from_selected_theme\">\n<span translate=\"MESSAGES.choose_thumb_from_selected_theme\">choose_thumb_from_selected_theme</span></md-radio-button>\n<div ng-switch-when=\"theme\"><span style=\"color: red\" ng-if=\"vm.empMediaVideoForm.themes.length===0\" \ntranslate=\"MESSAGES.theme_not_selected\">Aucun theme</span><div ng-if=\"vm.empMediaVideoForm.themes.length>0\"><span \nstyle=\"color: red\" ng-if=\"vm.selectedThumbs.length===0\" translate=\"MESSAGES.theme_does_not_have_a_thumb\">\nAucune vignette pour les themes selectionnés</span></div></div></div></md-radio-group></div></div></div></div><div \nclass=\"mobile-container show-xs hide-gt-sm hide-sm\" layout=\" column \" layout=\" row \"><img class=\"IE-img-vignettes\" \nng-src=\"{{vm.videoThumb}}\" on-error-src=\"assets/images/no-image-custom.svg\" \nstyle=\"height: 100%;width: 100%;cursor: pointer\" ng-style=\"style()\" on-resize-el><div \nclass=\"vignette-button-container show-xs hide-gt-sm\" layout=\" row \"><div class=\"product-image-uploader\" flex=\"80\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" \nflow-file-error=\"vm.fileError($file,$message)\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><md-button \nclass=\"md-raised md-primary btn-generate md-icon-button show-xs hide-gt-xs\" flow-btn \nstyle=\"color: rgba(0, 0, 0, 0.67);\n    margin: 0 !important;padding: 5px 10px !important;    width: 100%\"><span \ntranslate=\"VIDEOADD.upload_thumb_galery\">upload_thumb_galery</span></md-button></div><md-button \nng-if=\"vm.isNew || (!vm.isNew && vm.hasSourceVideo)\" \nclass=\"md-raised md-primary btn-generate md-icon-button show-xs hide-gt-xs\" flex=\"20\" aria-label=\"generate-thumb\" \nng-click=\"vm.regenerateThumbs()\" title=\"{{ \'MESSAGES.generate_vignette\'|translate}}\"><md-icon \nmd-font-icon=\"icon-rotate-3d\"></md-icon></md-button></div><div \nclass=\"vignette-button-container show-xs hide-gt-sm center\" layout=\" row \" layout-align=\"center center\"><md-button \nclass=\"md-raised md-primary btn-thumb show-xs hide-gt-xs\" flex=\"100\" ng-click=\"vm.setAndPreviewThumb(vm.lastThumb)\">\n<span translate=\"VIDEOADD.set_thumb\">set_thumb</span></md-button></div></div></div></div></div><div \nclass=\"ie-exception-1\" layout=\" row \" layout-wrap><form layout=\"row\" flex=\"100\" layout-wrap name=\"empMediaVideoForm\" \nmethod=\"post\" ng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" novalidate=\"novalidate\" \nclass=\"button-hidden ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"p-16 ie-exception-2\" style=\"overflow: visible\"><md-content style=\"overflow: visible\"><md-nav-bar \nmd-no-ink-bar=\"disableInkBar\" md-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item \nmd-nav-click=\"goto(\'page1\')\" name=\"page1\"><div layout=\"row\" flex><md-icon style=\"color: rgba(0,0,0,0.54)\" \nmd-font-icon=\"icon-pencil-box\"></md-icon><div translate=\"MESSAGES.form_step_basic_info\" class=\"hide-xs\">form title\n</div></div></md-nav-item><md-nav-item md-nav-click=\"goto(\'page2\')\" name=\"page2\"><div layout=\"row\" flex><md-icon \nstyle=\"color: rgba(0,0,0,0.54)\" md-font-icon=\"icon-cog\"></md-icon><div translate=\"MESSAGES.form_step_further_info\" \nclass=\"hide-xs\">form title</div></div><md-content></md-content></md-nav-item></md-nav-bar><div id=\"page1\" \nng-show=\"currentNavItem ===\'page1\'\" style=\"margin-top: 3em\"><div class=\"md-inline-form\"><md-input-container \nclass=\"md-block\"><label class=\"md-no-float\" translate=\"VIDEOADD.form_attr_title\" for=\"empMediaVideoForm_title\">Titre\n</label><input type=\"text\" id=\"empMediaVideoForm_title\" name=\"empMediaVideoForm[title]\" required=\"required\" \nng-model=\"vm.empMediaVideoForm.title\" ng-attr-name=\"title\" aria-invalid=\"true\" class=\"form-control\" \nplaceholder=\"{{ \'VIDEOADD.form_attr_title\'|translate}}\" maxlength=\"200\"><div \nng-messages=\"horizontalStep1.title.$error\" ng-if=\"horizontalStep1.title.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.title && vm.empMediaVideoForm.title === vm.empMediaVideoError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-card-content ng-if=\"!$root.state.params.id && vm.testMultiLangue ===\'1\'\" style=\"width: 100%\" \nflex><md-select translate translate=\"MESSAGES.form_attr_language\" name=\"empMediaVideoForm[language][]\" \nid=\"empMediaVideoForm_language\" ng-model=\"vm.language\" required=\"required\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'|translate}}\"><md-option ng-repeat=\"languageChoice in vm.languageChoices\" \nng-value=\"languageChoice.val\"><any translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{languageChoice.option}}\n</any></md-option></md-select></md-card-content><div ng-if=\"vm.testIntranetInternet ===\'1\'\" layout=\"column\" \nlayout-gt-sm=\"row\" flex><div layout=\"row\" layout-gt-sm=\"row\" flex=\"40\"><md-checkbox aria-label=\"isVisibleOnInternet\" \nng-model=\"vm.empMediaVideoForm.isVisibleOnInternet\"><label translate=\"EVENTADD.form_attr_isVisibleOnInternet\"></label>\n</md-checkbox></div><div layout=\"row\" layout-gt-sm=\"row\" flex=\"40\"><md-checkbox aria-label=\"isVisibleOnIntranet\" \nng-model=\"vm.empMediaVideoForm.isVisibleOnIntranet\"><label translate=\"EVENTADD.form_attr_isVisibleOnIntranet\"></label>\n</md-checkbox></div></div><div ng-if=\"vm.testMultiFormat === \'1\'\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[generateMultipleFormats]\" \nid=\"empMediaVideoForm_generateMultipleFormats\" ng-model=\"vm.empMediaVideoForm.generateMultipleFormats\"><label \ntranslate=\"MESSAGES.form_attr_generate_multiple_formats\">Générer multiple formats</label></md-checkbox></div><div \nclass=\"date-container\" layout=\"column\" layout-gt-xs=\"row\" flex has-permission=\"media_video_list_show_date\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.start_date\">start_date</label><md-datepicker required ng-model=\"vm.empMediaVideoForm.mdTime.start\" \nng-change=\"vm.changeDate(\'start\',\'startDate\')\" ng-attr-name=\"mdstart\" md-open-on-focus></md-datepicker><div \nng-messages=\"horizontalStep1.mdstart.$error\" ng-if=\"horizontalStep1.mdstart.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdstart && vm.empMediaVideoForm.mdstart === vm.empMediaVideoError.mdstart.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdstart.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\">end_date</label><md-datepicker required ng-model=\"vm.empMediaVideoForm.mdTime.end\" \nng-change=\"vm.changeDate(\'end\',\'endDate\')\" ng-attr-name=\"mdEnd\" md-min-date=\"vm.empMediaVideoForm.mdTime.start\" \nmd-open-on-focus></md-datepicker><div ng-messages=\"horizontalStep1.mdEnd.$error\" \nng-if=\"horizontalStep1.mdEnd.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">date_valid</div><div \nng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" \ntranslate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdEnd && vm.empMediaVideoForm.mdEnd === vm.empMediaVideoError.mdEnd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdEnd.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div class=\"list-container\" layout=\"column\" layout-gt-xs=\"row\" flex><div \nclass=\"mt-5 list-themes\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\"><ms-themes-bootstrap all-themes=\"vm.allThemes\" \ntype=\"\'theme\'\" show-label=\"true\" multi=\"true\" required=\"vm.requredTheme\" ng-model=\"vm.theme\" \nng-change=\"vm.selectThemes(\'theme\',someModel)\" ng-class=\"{\'theme-required\':vm.requredTheme}\" \nstyle=\"width: 100%; margin-top: -15px;padding-right: 15px\"></ms-themes-bootstrap></div><div class=\"mt-5 list-groups\" \nlayout=\"column\" flex=\"50\" flex-gt-xs=\"50\" has-permission=\"media_video_list_group_subscribers_list\"><span \nclass=\"group-label\" translate=\"{{!vm.isGV ? \'MESSAGES.list_groups\' : \'MESSAGES.thematic\' }}\"></span><md-select \ntranslate translate=\"MESSAGES.list_groups\" name=\"empMediaVideoForm[subscriptionGroups]\" \nid=\"empMediaVideoForm_subscriptionGroups\" ng-model=\"vm.empMediaVideoForm.subscriptionGroups\" multiple=\"multiple\" \nplaceholder=\"{{ (!vm.isGV ? \'MESSAGES.list_groups\' : \'MESSAGES.thematic\') |translate }}\" ng-class=\"group-select\">\n<md-option ng-repeat=\"(key,group) in vm.groups\" ng-click=\"vm.changeGroup(group)\" ng-attr-data-index=\"{{key}}\" \nng-value=\"group.id\">{{ group.name }}</md-option></md-select></div></div><div class=\"md-title text-left\" \ntranslate=\"VIDEOADD.confidentiality\" \nng-if=\"vm.testNotificationClient === \'1\' || !vm.isMultiUpload || (!vm.isMultiUpload && vm.empMediaVideoForm.themes.length>0)\" \nhas-permission=\"media_video_secure_form_no_api,media_home_post_disable_push_video,media_video_downloadable_vid_form_no_api,media_video_post_toggle,media_video_password_form_no_api\">\nconfidentiality</div><div layout=\"row\" layout-wrap><div ng-if=\"vm.testNotificationClient === \'1\'\" flex=\"50\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"sendPushNotifications\" \nid=\"sendPushNotifications\" ng-model=\"vm.sendPushNotifications\"><span translate=\"MESSAGES.form_attr_send_push_notif\">\nform_step_further_info</span></md-checkbox></div><div ng-if=\"!vm.isMultiUpload\" flex=\"50\" layout=\"column\" \nlayout-gt-sm=\"row\" has-permission=\"media_video_secure_form_no_api\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nname=\"empMediaVideoForm[secure]\" id=\"empMediaVideoForm_secure\" ng-model=\"vm.empMediaVideoForm.secure\"><label \ntranslate=\"MESSAGES.set_secure\">Video sécurisé</label></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload && vm.empMediaVideoForm.themes.length>0\" flex=\"50\" \nhas-permission=\"media_home_post_disable_push_video\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-false-value=\"0\" name=\"empMediaVideoForm[mainPage]\" id=\"empMediaVideoForm_mainPage\" \nng-model=\"vm.empMediaVideoForm.mainPage\"><label translate=\"MESSAGES.form_attr_main_page\">Vidéo d\'accueil</label>\n</md-checkbox></div><div ng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_shared_vid_form_no_api\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[shared]\" \nid=\"empMediaVideoForm_shared\" ng-model=\"vm.empMediaVideoForm.shared\"><label translate=\"MESSAGES.form_attr_shared\">\nVidéo partageable</label></md-checkbox></div><div ng-if=\"!vm.isMultiUpload\" flex=\"50\" \nhas-permission=\"media_video_downloadable_vid_form_no_api\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[downloadable]\" id=\"empMediaVideoForm_downloadable\" \nng-model=\"vm.empMediaVideoForm.downloadable\"><label translate=\"MESSAGES.form_attr_downloadable\">Vidéo téléchargeable\n</label></md-checkbox></div><div ng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_post_toggle\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[offline]\" \nid=\"empMediaVideoForm_offline\" ng-model=\"vm.empMediaVideoForm.offline\"><label \ntranslate=\"MESSAGES.form_attr_vid_offline\">Mettre la video Hors ligne</label></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_password_form_no_api\" class=\"md-inline-form\" \nstyle=\"position: relative\"><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-change=\"vm.setEmptyPassword()\" ng-false-value=\"0\" name=\"empMediaVideoForm[locked]\" id=\"empMediaVideoForm_locked\" \nng-model=\"vm.empMediaVideoForm.isSecuredOnInternet\"><label translate=\"MESSAGES.form_attr_locked_vid\">\nSécuriser vidéo avec un mot de passe</label></md-checkbox></div><md-input-container \nng-if=\"vm.empMediaVideoForm.isSecuredOnInternet\" style=\"width: 97%; padding-left: 30px\" aria-hidden=\"true\"><label \ntranslate=\"VIDEOADD.form_attr_unlock_password\" for=\"empMediaVideoForm_unlockPassword\" \nclass=\"md-no-float lock-video-label\">Ajouter un mot de passe</label><input type=\"password\" \nid=\"empMediaVideoForm_unlockPassword\" name=\"empMediaVideoForm[unlockPassword]\" \nng-model=\"vm.empMediaVideoForm.passwordInternet\" ng-attr-name=\"unlockPassword\" \nng-required=\"vm.empMediaVideoForm.isSecuredOnInternet\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"horizontalStep1.passwordInternet.$error\" ng-if=\"horizontalStep1.passwordInternet.$touched\" role=\"alert\">\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.passwordInternet && vm.empMediaVideoForm.passwordInternet === vm.empMediaVideoError.passwordInternet.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.passwordInternet.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_post_acceessible\" \nlayout=\"column\" layout-gt-sm=\"row\"><div><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nname=\"empMediaVideoForm[is_accessible]\" id=\"empMediaVideoForm_is_accessible\" \nng-model=\"vm.empMediaVideoForm.is_accessible\"><label translate=\"MESSAGES.form_attr_vid_accessible\">\nMettre la video visible en internet</label></md-checkbox></div></div></div></div></div><div id=\"page2\" \nng-show=\"currentNavItem ===\'page2\'\" style=\"margin-top: 3em;    overflow: hidden\"><div><div class=\"md-inline-form\">\n<md-input-container class=\"md-block\"><label translate=\"VIDEOADD.form_attr_description\" class=\"md-no-float\" \nfor=\"empMediaVideoForm_description\">Description</label><textarea ng-model=\"vm.empMediaVideoForm.description\" \nclass=\"form-control\" id=\"empMediaVideoForm_description\" aria-invalid=\"true\" name=\"empMediaVideoForm[description]\" \nng-attr-name=\"description\" rows=\"5\"></textarea><div ng-messages=\"horizontalStep1.description.$error\" \nng-if=\"horizontalStep1.description.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.description && vm.empMediaVideoForm.description === vm.empMediaVideoError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex class=\"md-block\" has-permission=\"media_video_form_transcription\"><label \ntranslate=\"VIDEOADD.form_attr_transcription\" class=\"md-no-float\" for=\"empMediaVideoForm_transcription\">Transcription\n</label><div class=\"md-resize-wrapper\"><textarea id=\"empMediaVideoForm_transcription\" \nname=\"empMediaVideoForm[transcription]\" ng-attr-name=\"transcription\" rows=\"5\" md-maxlength=\"2000\" md-select-on-focus \nng-model=\"vm.empMediaVideoForm.transcription\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 123px\"></textarea>\n<div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"horizontalStep2.transcription.$error\" ng-if=\"horizontalStep2.transcription.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"2000\">form_max_length</div><div \nng-if=\"vm.empMediaVideoError.transcription && vm.empMediaVideoForm.transcription === vm.empMediaVideoError.transcription.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.transcription.message}}\" class=\"validation_api\"></div></div><div flex \nlayout=\"row\" layout-align=\"start center\" class=\"uploadFileTranscription\"><div \nclass=\"product-image-uploader uploadFileTranscriptionDIV\" flow-init=\"vm.ngFlowOptionsFileTranscription\" \nflow-name=\"vm.ngFlowFileTranscripton.flow\" flow-files-submitted=\"vm.uploadFileTranscription()\" \nflow-file-added=\"vm.fileAddedTranscription($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccessTranscription($file, $message)\" flow-complete=\"vm.uploadCompleteTranscription()\" \nflow-file-error=\"vm.fileErrorTranscription($file,$message)\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" flow-btn \nng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_File_transcription\" class=\"spn-choose-file\">choose_thumb</span></md-button></div><div \nng-if=\"vm.dropping\" class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"download-file\" \nng-if=\"vm.imageNameTranscription\"><div class=\"file-blog\"><div style=\"margin-left:9px\"><md-icon \nclass=\"sb18 ng-scope md-default-theme md-font material-icons icon-download\"></md-icon></div><div class=\"title-file\">\n<md-progress-circular ng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular><p\n class=\"text-truncate mh-10\">{{vm.imageNameTranscription}}</p></div></div><div style=\"margin-right: 1%\"><md-button \naria-label=\"menu\" ng-click=\"vm.download()\"><md-icon \nclass=\"sb18 ng-scope md-default-theme md-font material-icons icon-download\"></md-icon></md-button></div></div></div>\n</div></md-input-container><div layout=\"row\" layout-wrap><div flex=\"50\"><div \nhas-permission=\"media_video_contributor_form_no_api\" layout=\"column\" layout-gt-xs=\"row\" class=\"pr-15\" flex>\n<md-card-content flex><md-input-container class=\"md-block\"><label translate=\"MESSAGES.form_attr_contributor\" \nclass=\"md-no-float\" for=\"empMediaVideoForm_contributor\">Contributor</label><md-select translate \ntranslate=\"MESSAGES.form_attr_contributor\" name=\"empMediaVideoForm[contributor]\" id=\"empMediaVideoForm_contributor\" \nng-model=\"vm.empMediaVideoForm.contributor\" placeholder=\"{{ \'MESSAGES.form_attr_contributor\'|translate}}\"><md-option \nng-if=\"name.val!=0\" ng-repeat=\"contributor in vm.contributors track by contributor.val\" \nnb-attr-data-index=\"{{$index}}\" ng-value=\"contributor.val\" \nng-attr-translate=\"{{contributor.val==0 ? \'MESSAGES.none\':\'\'}}\">{{contributor.option}}</md-option></md-select>\n</md-input-container></md-card-content></div></div><div flex=\"50\"><md-input-container class=\"md-block\"><label \ntranslate=\"VIDEOADD.form_attr_author\" class=\"md-no-float\" for=\"empMediaVideoForm_author\">Auteur</label><input \ntype=\"text\" id=\"empMediaVideoForm_author\" name=\"empMediaVideoForm[author]\" ng-model=\"vm.empMediaVideoForm.author\" \naria-invalid=\"false\"><div class=\"md-errors-spacer\"></div></md-input-container></div><div flex=\"50\" class=\"pr-15\">\n<md-input-container class=\"md-block\"><label translate=\"VIDEOADD.form_attr_copyright\" class=\"md-no-float\" \nfor=\"empMediaVideoForm_copyright\">Copyright</label><input type=\"text\" id=\"empMediaVideoForm_copyright\" \nname=\"empMediaVideoForm[copyright]\" ng-model=\"vm.empMediaVideoForm.copyright\" aria-invalid=\"false\"><div \nclass=\"md-errors-spacer\"></div></md-input-container></div><div flex=\"50\"><md-input-container \nclass=\"md-block md-input-has-placeholder md-default-theme md-no-float chips-container\"><label class=\"md-no-float\" \ntranslate=\"VIDEOADD.form_attr_key_words\">Mots clés</label><md-chips id=\"empMediaVideoForm_keyWords\" \nname=\"empMediaVideoForm[keyWords]\" ng-model=\"vm.empMediaVideoForm.keyWords\" md-removable=\"1\" aria-hidden=\"true\" \ntabindex=\"-1\" aria-invalid=\"false\" placeholder=\"{{ \'VIDEOADD.form_attr_keyword\' | translate }}\" \nsecondary-placeholder=\"+Tag\" md-separator-keys=\"vm.customKeys\"><md-chips-wrap \nng-keydown=\"$mdChipsCtrl.chipKeydown($event)\" \nng-class=\"{ \'md-focused\': $mdChipsCtrl.hasFocus(),                       \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,                      \'md-removable\': $mdChipsCtrl.isRemovable() }\" \nclass=\"md-chips md-removable\"><md-chip ng-repeat=\"$chip in $mdChipsCtrl.items\" index=\"0\" \nng-class=\"{\'md-focused\': $mdChipsCtrl.selectedChip === $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}\" \nclass=\"ng-scope md-default-theme\"><div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" \nng-click=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.focusChip($index)\" \nng-focus=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.selectChip($index)\" \nmd-chip-transclude=\"$mdChipsCtrl.chipContentsTemplate\" role=\"button\"><span class=\"ng-binding ng-scope\"></span></div>\n<div ng-if=\"$mdChipsCtrl.isRemovable()\" class=\"md-chip-remove-container ng-scope\" \nmd-chip-transclude=\"$mdChipsCtrl.chipRemoveTemplate\"><button class=\"md-chip-remove ng-scope\" \nng-if=\"$mdChipsCtrl.isRemovable()\" ng-click=\"$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)\" \ntype=\"button\" aria-hidden=\"true\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=\" \nclass=\"md-default-theme\" aria-hidden=\"true\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" \nxmlns=\"http://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveAspectRatio=\"xMidYMid meet\" \nfocusable=\"false\"><g><path \nd=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\">\n</path></g></svg></md-icon><span class=\"md-visually-hidden ng-binding\">Remove</span></button></div><span \nng-if=\"!$mdChipsCtrl.readonly\" class=\"md-visually-hidden ng-binding ng-scope\">Press delete to remove this chip.</span>\n</md-chip><div class=\"md-chip-input-container ng-scope\" \nng-if=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.ngModelCtrl\"><div \nmd-chip-transclude=\"$mdChipsCtrl.chipInputTemplate\"><input style=\"height: 32px\" \nclass=\"md-input ng-pristine ng-untouched ng-valid ng-scope ng-empty\" tabindex=\"0\" aria-label=\"Mots clés\" \nng-model=\"$mdChipsCtrl.chipBuffer\" ng-focus=\"$mdChipsCtrl.onInputFocus()\" ng-blur=\"$mdChipsCtrl.onInputBlur()\" \nng-keydown=\"$mdChipsCtrl.inputKeydown($event)\" id=\"input_43\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</div></div></md-chips-wrap></md-chips></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nhas-permission=\"media_video_join_files_form_no_api\"><md-checkbox name=\"empMediaVideoForm[mainPage]\" \nid=\"empMediaVideoForm_mainPage\" ng-model=\"vm.joinFile\"><label translate=\"MESSAGES.join_files\">Joindre des fichiers\n</label></md-checkbox></div><div class=\"md-padding\" layout-wrap layout=\"row\" \nhas-permission=\"media_video_join_files_form_no_api\"><div style=\"position: relative\" \nng-repeat=\"(key,item) in vm.filesChips\" layout=\"column\"><md-button style=\"position: absolute;left: 97px;top: -13px\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.deleteAddedChip(item)\"><svg aria-hidden=\"true\" class=\"UppyIcon\" \nwidth=\"20\" height=\"30\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" \nfill-rule=\"nonzero\" vector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\">\n</path><path fill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card title=\"{{item}}\" id=\"mdcard\" ng-click=\"vm.selectChip(item)\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)!important;height: 97px\">\n<md-icon ng-if=\"vm.testExtension(item)===\'video\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-video\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'audio\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-music\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'excel\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-excel\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'word\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-word\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'image\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-image\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'pdf\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-pdf\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'other\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file\"></md-icon><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\"><div \nstyle=\"text-align: center\" layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item}}\" \nstyle=\"font-size: 0.75em;width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div><div ng-if=\"vm.joinFile\"><div layout-padding \nlayout-margin class=\"product-detail-form-container dnd-file-upload\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptionsFile\" flow-name=\"vm.ngFlowFile.flow\" flow-files-submitted=\"vm.uploadFilef()\" \nflow-file-added=\"vm.filefAdded($file)\" flow-file-progress=\"vm.filefProgress($file)\" \nflow-file-success=\"vm.filefSuccess($file, $message)\" flow-complete=\"vm.uploadfComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressf\"><span \nstyle=\"font-size: 16px; color:#b0b0b0\" translate=\"VIDEOADD.upload_files\">choose_a_file</span></md-button><md-button \nclass=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUploadf()\" ng-if=\"vm.inProgressf\">\nform_cancel</md-button></div><div layout=\"row\" layout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressf\">\n<div><p class=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFilePre.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressf\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></div></div></div></div></md-content></ms-widget-front>\n</ms-widget><div ng-if=\"vm.isNew\" class=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap \nstyle=\"height: 50px\"><md-button class=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised md-button ng-scope md-ink-ripple\" aria-label=\"Submit\" \nng-disabled=\"empMediaVideoForm.$invalid || !vm.videoThumb \" ng-click=\"MsStepper.resetForm()\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button></div><div ng-if=\"!vm.isNew\" \nclass=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap style=\"height: 50px\"><md-button \nclass=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-click=\"MsStepper.resetForm()\" \ntype=\"submit\" class=\"md-accent md-raised md-button ng-scope md-ink-ripple\" aria-label=\"Submit\" ng-transclude=\"\" \nng-disabled=\"(empMediaVideoForm.$invalid || empMediaVideoForm.$pristine || !vm.videoThumb) && $rootScope.notCapture\" \nstyle=\"\" translate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate\n</md-button></div></form></div></div></div>");
$templateCache.put("app/main/media/video/add_edit_external.template.html","<div class=\"e-commerce-product page-layout simple fullwidth page-add-edit\" layout=\"column\"><div layout=\"column\" \nng-class=\"vm.isNew ? \'content\' : \'\' \"><div ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" \nclass=\"mv-24\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip \nmd-autohide=\"true\" md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div \nng-if=\"vm.showPlayer\" layout-align=\"center center\" layout=\"row\" class=\"mb-24\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24 centerdiiv\" flex=\"100\" flex-xs=\"100\"><div class=\"md-title text-left\">\n{{\'MESSAGES.selection_vignettes\'|translate}}</div><div layout=\"row\" layout-md=\"column\" layout-sm=\"column\" \nlayout-xs=\"column\" id=\"IE-div-player\"><div id=\"div1\" style=\"width: 100%; max-height: none;margin: 0 auto\" flex \nlayout=\"row\" layout-align=\"center start\"><div layout=\"column\" style=\"width: 80%;margin: 0 auto\"><div flex><div \nms-scroll class=\"no-padding video-add-edit hide-xs\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"position: relative;padding: 56% 1em 1em\"><iframe id=\"player_add\" width=\"700\" height=\"397\" \nng-src=\"{{vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" \nstyle=\"position: absolute;\n\n                                                top: 0px;\n                                                left: 0px;\n                                                width: 100%;\n                                                height: 100%\">\n</iframe></div></div></div></div></div><div flex style=\"margin: 0 auto\"><div layout=\"row\" layout-xs=\"column\"><div \nid=\"IE-div-vignettes\" layout=\"column\" class=\"hide-xs\" style=\"width: 264px;border-left: 1px solid #ededed\"><div \nstyle=\"height: 125px;margin-left: 2%\" layout=\"row\" layout-align=\"left left\"><md-icon \nng-if=\"vm.videoThumb === null || vm.videoThumb === \'\' || vm.videoThumb === false || vm.videoThumb === \'not_found\'\" \nmd-font-icon=\"icon-picture\" class=\"s72\"></md-icon><img \nstyle=\"width: 212px;border: 1px solid gray;box-shadow: 0px 0px 6px 1px rgba(0,0,0,0.22)\" \nng-if=\"vm.videoThumb && vm.videoThumb!== \'not_found\'\" class=\"media\" ng-src=\"{{vm.videoThumb}}\"></div><div \nclass=\"mt-20 checkdown-menu\"><md-radio-group ng-model=\"vm.imageFrom\" ng-switch=\"vm.imageFrom\" class=\"hide-xs\"><div \nstyle=\"margin-left: 2%\" class=\"mv-24\"><md-radio-button style=\"text-align: start\" flex value=\"local\" \naria-label=\"choose_thumb_from_local\" translate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"><span \ntranslate=\"MESSAGES.choose_thumb_from_local\">choose_thumb_from_local</span></md-radio-button><div \nng-switch-when=\"local\" flex layout=\"row\" layout-align=\"start center\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" \nflow-file-error=\"vm.fileError($file,$message)\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div style=\"padding-left: 18px\" \nclass=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" \nflow-btn ng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_thumb\">choose_thumb</span></md-button><md-progress-circular ng-if=\"vm.uploadingInPogress\" \nclass=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div><div ng-if=\"vm.dropping\" \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><p ng-if=\"vm.imageName\" class=\"text-truncate mh-10\">{{vm.imageName}}</p></div></div></div>\n<div style=\"margin-left: 2%\" class=\"mv-24\"><md-radio-button style=\"text-align: start\" flex value=\"theme\" \nng-click=\"vm.testVignette()\" aria-label=\"choose_thumb_from_selected_theme\" \ntranslate-attr-aria-label=\"MESSAGES.choose_thumb_from_selected_theme\"><span \ntranslate=\"MESSAGES.choose_thumb_from_selected_theme\">choose_thumb_from_selected_theme</span></md-radio-button><div \nng-switch-when=\"theme\"><span style=\"color: red\" ng-if=\"vm.empMediaVideoForm.themes.length===0\" \ntranslate=\"MESSAGES.theme_not_selected\">Aucun theme</span><div ng-if=\"vm.empMediaVideoForm.themes.length>0\"><span \nstyle=\"color: red\" ng-if=\"vm.selectedThumbs.length===0\" translate=\"MESSAGES.theme_does_not_have_a_thumb\">\nAucune vignette pour les themes selectionnés</span></div></div></div></md-radio-group></div></div></div></div><div \nclass=\"mobile-container show-xs hide-gt-sm hide-sm\" layout=\" column \" layout=\" row \"><img class=\"IE-img-vignettes\" \nng-src=\"{{vm.lastThumb}}\"><div class=\"vignette-button-container show-xs hide-gt-sm\" layout=\" row \"><md-button \nclass=\"md-raised md-primary btn-thumb show-xs hide-gt-xs\" flex=\"70\" ng-click=\"vm.setAndPreviewThumb(vm.lastThumb)\">\n<span translate=\"VIDEOADD.set_thumb\">set_thumb</span></md-button><md-button \nclass=\"md-raised md-primary btn-generate md-icon-button show-xs hide-gt-xs\" aria-label=\"generate-thumb\" flex=\"30\" \nng-click=\"vm.regenerateThumbs()\" title=\"{{ \'MESSAGES.generate_vignette\'|translate}}\"><md-icon \nmd-font-icon=\"icon-rotate-3d\"></md-icon></md-button></div><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" \nflow-file-error=\"vm.fileError($file,$message)\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><md-button flow-btn \nstyle=\"color: rgba(0, 0, 0, 0.67)\"><span translate=\"VIDEOADD.upload_thumb_galery\">upload_thumb_galery</span>\n</md-button></div></div></div></div></div><div class=\"ie-exception-1\" layout=\"row\" layout-wrap><form layout=\"row\" \nflex=\"100\" layout-wrap name=\"empMediaVideoForm\" method=\"post\" \nng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" novalidate=\"novalidate\" \nclass=\"button-hidden ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front \nclass=\"p-16 ie-exception-2\"><div><md-content><md-nav-bar md-no-ink-bar=\"disableInkBar\" \nmd-selected-nav-item=\"currentNavItem\" nav-bar-aria-label=\"navigation links\"><md-nav-item md-nav-click=\"goto(\'page1\')\" \nname=\"page1\"><div layout=\"row\" flex><md-icon style=\"color: rgba(0,0,0,0.54)\" md-font-icon=\"icon-pencil-box\"></md-icon>\n<div translate=\"MESSAGES.form_step_basic_info\" class=\"hide-xs\">form title</div></div></md-nav-item><md-nav-item \nmd-nav-click=\"goto(\'page2\')\" name=\"page2\"><div layout=\"row\" flex><md-icon style=\"color: rgba(0,0,0,0.54)\" \nmd-font-icon=\"icon-cog\"></md-icon><div translate=\"MESSAGES.form_step_further_info\" class=\"hide-xs\">form title</div>\n</div><md-content></md-content></md-nav-item></md-nav-bar><div id=\"page1\" ng-show=\"currentNavItem ===\'page1\'\" \nstyle=\"margin-top: 3em;    overflow: hidden\"><div class=\"md-inline-form\"><md-input-container class=\"md-block\"><label \nclass=\"md-no-float\" translate=\"VIDEOADD.form_attr_title\" for=\"empMediaVideoForm_title\">Titre</label><input type=\"text\" \nid=\"empMediaVideoForm_title\" name=\"empMediaVideoForm[title]\" required=\"required\" class=\"form-control\" \nng-model=\"vm.empMediaVideoForm.title\" ng-attr-name=\"title\" aria-invalid=\"true\"><div \nng-messages=\"horizontalStep1.title.$error\" ng-if=\"horizontalStep1.title.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.title && vm.empMediaVideoForm.title === vm.empMediaVideoError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container ng-if=\"!$root.state.params.id && vm.testMultiLangue ===\'1\'\" \nstyle=\"width: 100%\" flex><label translate=\"MESSAGES.form_attr_language\">Langue</label><md-select translate \ntranslate=\"MESSAGES.form_attr_language\" name=\"empMediaVideoForm[language][]\" id=\"empMediaVideoForm_language\" \nng-model=\"vm.language\" required=\"required\"><md-option ng-repeat=\"languageChoice in vm.languageChoices\" \nng-value=\"languageChoice.val\"><any translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option}}\n</any></md-option></md-select></md-input-container><div ng-if=\"vm.testIntranetInternet ===\'1\'\" layout=\"column\" \nlayout-gt-sm=\"row\" flex><div layout=\"row\" layout-gt-sm=\"row\" flex=\"40\"><md-checkbox aria-label=\"isVisibleOnInternet\" \nng-model=\"vm.empMediaVideoForm.isVisibleOnInternet\"><label translate=\"EVENTADD.form_attr_isVisibleOnInternet\"></label>\n</md-checkbox></div><div layout=\"row\" layout-gt-sm=\"row\" flex=\"40\"><md-checkbox aria-label=\"isVisibleOnIntranet\" \nng-model=\"vm.empMediaVideoForm.isVisibleOnIntranet\"><label translate=\"EVENTADD.form_attr_isVisibleOnIntranet\"></label>\n</md-checkbox></div></div><div ng-if=\"vm.testMultiFormat === \'1\'\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[generateMultipleFormats]\" \nid=\"empMediaVideoForm_generateMultipleFormats\" ng-model=\"vm.empMediaVideoForm.generateMultipleFormats\"><label \ntranslate=\"MESSAGES.form_attr_generate_multiple_formats\">Générer multiple formats</label></md-checkbox></div><div \nclass=\"date-container\" layout=\"column\" layout-gt-xs=\"row\" flex has-permission=\"media_video_list_show_date\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.start_date\">start_date</label><md-datepicker required ng-model=\"vm.empMediaVideoForm.mdTime.start\" \nng-change=\"vm.changeDate(\'start\',\'startDate\')\" ng-attr-name=\"mdstart\" md-open-on-focus id=\"datepicker\"></md-datepicker>\n<div ng-messages=\"horizontalStep1.mdstart.$error\" ng-if=\"horizontalStep1.mdstart.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdstart && vm.empMediaVideoForm.mdstart === vm.empMediaVideoError.mdstart.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdstart.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\">end_date</label><md-datepicker required ng-model=\"vm.empMediaVideoForm.mdTime.end\" \nng-change=\"vm.changeDate(\'end\',\'endDate\')\" ng-attr-name=\"mdEnd\" md-min-date=\"vm.empMediaVideoForm.mdTime.start\" \nmd-open-on-focus id=\"datepicker\"></md-datepicker><div ng-messages=\"horizontalStep1.mdEnd.$error\" \nng-if=\"horizontalStep1.mdEnd.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">date_valid</div><div \nng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" \ntranslate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdEnd && vm.empMediaVideoForm.mdEnd === vm.empMediaVideoError.mdEnd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdEnd.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div class=\"mt-5\" layout=\"column\" flex=\"50\" flex-gt-xs=\"50\"><ms-themes-bootstrap \nall-themes=\"vm.allThemes\" type=\"\'theme\'\" show-label=\"true\" multi=\"true\" ng-model=\"vm.theme\" \nng-change=\"vm.selectThemes(\'theme\',someModel)\" style=\"width: 100%; margin-top: -15px;padding-right: 15px\">\n</ms-themes-bootstrap></div><div class=\"md-title text-left\" translate=\"VIDEOADD.confidentiality\" \nng-if=\"vm.testNotificationClient === \'1\' || vm.empMediaVideoForm.themes.length>0\" \nhas-permission=\"media_video_secure_form_no_api,media_home_post_disable_push_video,media_video_downloadable_vid_form_no_api,media_video_post_toggle,media_video_password_form_no_api\">\nconfidentiality</div><div layout=\"row\" layout-wrap><div ng-if=\"vm.testNotificationClient === \'1\'\" flex=\"50\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"sendPushNotifications\" \nid=\"sendPushNotifications\" ng-model=\"vm.sendPushNotifications\"><span translate=\"MESSAGES.form_attr_send_push_notif\">\nform_step_further_info</span></md-checkbox></div><div flex=\"50\" layout=\"column\" layout-gt-sm=\"row\" \nhas-permission=\"media_video_secure_form_no_api\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nname=\"empMediaVideoForm[secure]\" id=\"empMediaVideoForm_secure\" ng-model=\"vm.empMediaVideoForm.secure\"><label \ntranslate=\"MESSAGES.set_secure\">Video sécurisé</label></md-checkbox></div><div \nng-if=\"vm.empMediaVideoForm.themes.length>0\" has-permission=\"media_home_post_disable_push_video\" flex=\"50\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" \nname=\"empMediaVideoForm[mainPage]\" id=\"empMediaVideoForm_mainPage\" ng-model=\"vm.empMediaVideoForm.mainPage\"><label \ntranslate=\"MESSAGES.form_attr_main_page\">Vidéo d\'accueil</label></md-checkbox></div><div \nhas-permission=\"media_video_post_toggle\" flex=\"50\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-false-value=\"0\" name=\"empMediaVideoForm[offline]\" id=\"empMediaVideoForm_offline\" \nng-model=\"vm.empMediaVideoForm.offline\"><label translate=\"MESSAGES.form_attr_vid_offline\">Mettre la video Hors ligne\n</label></md-checkbox></div><div><div has-permission=\"media_video_password_form_no_api\" class=\"md-inline-form\" \nstyle=\"position: relative\"><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-change=\"vm.setEmptyPassword()\" ng-false-value=\"0\" name=\"empMediaVideoForm[locked]\" id=\"empMediaVideoForm_locked\" \nng-model=\"vm.empMediaVideoForm.isSecuredOnInternet\"><label translate=\"MESSAGES.form_attr_locked_vid\">\nSécuriser vidéo avec un mot de passe</label></md-checkbox></div><md-input-container \nng-if=\"vm.empMediaVideoForm.isSecuredOnInternet\" style=\"width: 100%\" aria-hidden=\"true\"><label \ntranslate=\"VIDEOADD.form_attr_unlock_password\" for=\"empMediaVideoForm_unlockPassword\" \nclass=\"md-no-float lock-video-label\">Mot de passe vidéo</label><input type=\"password\" \nid=\"empMediaVideoForm_unlockPassword\" name=\"empMediaVideoForm[unlockPassword]\" \nng-model=\"vm.empMediaVideoForm.passwordInternet\" ng-attr-name=\"unlockPassword\" \nng-required=\"vm.empMediaVideoForm.isSecuredOnInternet\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div><div \nng-messages=\"horizontalStep1.passwordInternet.$error\" ng-if=\"horizontalStep1.passwordInternet.$touched\" role=\"alert\">\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.passwordInternet && vm.empMediaVideoForm.passwordInternet === vm.empMediaVideoError.passwordInternet.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.passwordInternet.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div></div></div></div><div id=\"page2\" ng-show=\"currentNavItem ===\'page2\'\" \nstyle=\"margin-top: 3em;    overflow: hidden\"><div><div class=\"md-inline-form\"><md-input-container class=\"md-block\">\n<label translate=\"VIDEOADD.form_attr_description\" class=\"md-no-float\" for=\"empMediaVideoForm_description\">Description\n</label><textarea ng-model=\"vm.empMediaVideoForm.description\" class=\"form-control\" id=\"empMediaVideoForm_description\" \naria-invalid=\"true\" name=\"empMediaVideoForm[description]\" ng-attr-name=\"description\" rows=\"5\"></textarea><div \nng-messages=\"horizontalStep2.description.$error\" ng-if=\"horizontalStep2.description.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"2000\">form_max_length</div><div \nng-if=\"vm.empMediaVideoError.description && vm.empMediaVideoForm.description === vm.empMediaVideoError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex class=\"md-block\" has-permission=\"media_video_form_transcription\"><label \ntranslate=\"VIDEOADD.form_attr_transcription\" class=\"md-no-float\" for=\"empMediaVideoForm_transcription\">Transcription\n</label><div class=\"md-resize-wrapper\"><textarea id=\"empMediaVideoForm_transcription\" \nname=\"empMediaVideoForm[transcription]\" ng-attr-name=\"transcription\" rows=\"5\" md-maxlength=\"2000\" md-select-on-focus \nng-model=\"vm.empMediaVideoForm.transcription\" aria-invalid=\"false\" ng-trim=\"false\" class=\"form-control\" \nstyle=\"height: 123px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"horizontalStep2.transcription.$error\" ng-if=\"horizontalStep2.transcription.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"2000\">form_max_length</div><div \nng-if=\"vm.empMediaVideoError.transcription && vm.empMediaVideoForm.transcription === vm.empMediaVideoError.transcription.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.transcription.message}}\" class=\"validation_api\"></div></div><div flex \nlayout=\"row\" layout-align=\"start center\" class=\"uploadFileTranscription\"><div \nclass=\"product-image-uploader uploadFileTranscriptionDIV\" flow-init=\"vm.ngFlowOptionsFileTranscription\" \nflow-name=\"vm.ngFlowFileTranscripton.flow\" flow-files-submitted=\"vm.uploadFileTranscription()\" \nflow-file-added=\"vm.fileAddedTranscription($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccessTranscription($file, $message)\" flow-complete=\"vm.uploadCompleteTranscription()\" \nflow-file-error=\"vm.fileErrorTranscription($file,$message)\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" flow-btn \nng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_File_transcription\" class=\"spn-choose-file\">choose_thumb</span></md-button></div><div \nng-if=\"vm.dropping\" class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"download-file\" \nng-if=\"vm.imageNameTranscription\"><div class=\"file-blog\"><div style=\"margin-left:9px\"><md-icon \nclass=\"sb18 ng-scope md-default-theme md-font material-icons icon-download\"></md-icon></div><div class=\"title-file\">\n<md-progress-circular ng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular><p\n class=\"text-truncate mh-10\">{{vm.imageNameTranscription}}</p></div></div><div style=\"margin-right: 1%\"><md-button \naria-label=\"menu\" ng-click=\"vm.download()\"><md-icon \nclass=\"sb18 ng-scope md-default-theme md-font material-icons icon-download\"></md-icon></md-button></div></div></div>\n</div></md-input-container><div layout=\"row\" layout-wrap><div flex=\"50\"><div \nhas-permission=\"media_video_contributor_form_no_api\" layout=\"column\" layout-gt-xs=\"row\" class=\"pr-15\" flex>\n<md-card-content flex><md-input-container class=\"md-block\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.form_attr_contributor\">Contributeur</label><md-select translate \ntranslate=\"MESSAGES.form_attr_contributor\" name=\"empMediaVideoForm[contributor]\" id=\"empMediaVideoForm_contributor\" \nng-model=\"vm.empMediaVideoForm.contributor\"><md-option ng-if=\"name.val!=0\" \nng-repeat=\"contributor in vm.contributors track by contributor.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"contributor.val\" ng-attr-translate=\"{{contributor.val==0 ? \'MESSAGES.none\':\'\'}}\">{{contributor.option}}\n</md-option></md-select></md-input-container></md-card-content></div></div><div flex=\"50\"><md-input-container \nclass=\"md-block\"><label translate=\"VIDEOADD.form_attr_author\" class=\"md-no-float\" for=\"empMediaVideoForm_author\">Auteur\n</label><input type=\"text\" id=\"empMediaVideoForm_author\" name=\"empMediaVideoForm[author]\" \nng-model=\"vm.empMediaVideoForm.author\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div></md-input-container>\n</div><div flex=\"50\" class=\"pr-15\"><md-input-container class=\"md-block\"><label \ntranslate=\"VIDEOADD.form_attr_copyright\" class=\"md-no-float\" for=\"empMediaVideoForm_copyright\">Copyright</label><input \ntype=\"text\" id=\"empMediaVideoForm_copyright\" name=\"empMediaVideoForm[copyright]\" \nng-model=\"vm.empMediaVideoForm.copyright\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</md-input-container></div><div flex=\"50\"><md-input-container \nclass=\"md-block md-input-has-placeholder md-default-theme md-no-float chips-container\"><label class=\"md-no-float\" \ntranslate=\"VIDEOADD.form_attr_key_words\">Mots clés</label><md-chips id=\"empMediaVideoForm_keyWords\" \nname=\"empMediaVideoForm[keyWords]\" ng-model=\"vm.empMediaVideoForm.keyWords\" md-removable=\"1\" \nmd-separator-keys=\"vm.customKeys\" aria-hidden=\"true\" tabindex=\"-1\" aria-invalid=\"false\"><md-chips-wrap \nng-keydown=\"$mdChipsCtrl.chipKeydown($event)\" \nng-class=\"{ \'md-focused\': $mdChipsCtrl.hasFocus(),                       \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,                      \'md-removable\': $mdChipsCtrl.isRemovable() }\" \nclass=\"md-chips md-removable\"><md-chip ng-repeat=\"$chip in $mdChipsCtrl.items\" index=\"0\" \nng-class=\"{\'md-focused\': $mdChipsCtrl.selectedChip === $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}\" \nclass=\"ng-scope md-default-theme\"><div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" \nng-click=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.focusChip($index)\" \nng-focus=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.selectChip($index)\" \nmd-chip-transclude=\"$mdChipsCtrl.chipContentsTemplate\" role=\"button\"><span class=\"ng-binding ng-scope\"></span></div>\n<div ng-if=\"$mdChipsCtrl.isRemovable()\" class=\"md-chip-remove-container ng-scope\" \nmd-chip-transclude=\"$mdChipsCtrl.chipRemoveTemplate\"><button class=\"md-chip-remove ng-scope\" \nng-if=\"$mdChipsCtrl.isRemovable()\" ng-click=\"$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)\" \ntype=\"button\" aria-hidden=\"true\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=\" \nclass=\"md-default-theme\" aria-hidden=\"true\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" \nxmlns=\"https://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveAspectRatio=\"xMidYMid meet\" \nfocusable=\"false\"><g><path \nd=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\">\n</path></g></svg></md-icon><span class=\"md-visually-hidden ng-binding\">Remove</span></button></div><span \nng-if=\"!$mdChipsCtrl.readonly\" class=\"md-visually-hidden ng-binding ng-scope\">Press delete to remove this chip. </span>\n</md-chip><div class=\"md-chip-input-container ng-scope\" \nng-if=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.ngModelCtrl\"><div \nmd-chip-transclude=\"$mdChipsCtrl.chipInputTemplate\"><input \nclass=\"md-input ng-pristine ng-untouched ng-valid ng-scope ng-empty\" tabindex=\"0\" aria-label=\"Mots clés\" \nng-model=\"$mdChipsCtrl.chipBuffer\" ng-focus=\"$mdChipsCtrl.onInputFocus()\" ng-blur=\"$mdChipsCtrl.onInputBlur()\" \nng-keydown=\"$mdChipsCtrl.inputKeydown($event)\" id=\"input_43\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</div></div></md-chips-wrap></md-chips></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nhas-permission=\"media_video_join_files_form_no_api\"><md-checkbox name=\"empMediaVideoForm[mainPage]\" \nid=\"empMediaVideoForm_mainPage\" ng-model=\"vm.joinFile\"><label translate=\"MESSAGES.join_files\">Joindre des fichiers\n</label></md-checkbox></div><div class=\"md-padding\" layout-wrap layout=\"row\" \nhas-permission=\"media_video_join_files_form_no_api\"><div style=\"position: relative\" \nng-repeat=\"(key,item) in vm.filesChips\" layout=\"column\"><md-button style=\"position: absolute;left: 97px;top: -13px\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.deleteAddedChip(item)\"><svg aria-hidden=\"true\" class=\"UppyIcon\" \nwidth=\"20\" height=\"30\" viewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" \nfill-rule=\"nonzero\" vector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\">\n</path><path fill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card title=\"{{item}}\" id=\"mdcard\" ng-click=\"vm.selectChip(item)\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)!important;height: 97px\">\n<md-icon ng-if=\"vm.testExtension(item)===\'video\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-video\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'audio\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-music\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'excel\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-excel\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'word\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-word\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'image\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-image\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'pdf\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-pdf\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'other\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file\"></md-icon><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\"><div \nstyle=\"text-align: center\" layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item}}\" \nstyle=\"font-size: 0.75em;width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div><div ng-if=\"vm.joinFile\"><div layout-padding \nlayout-margin class=\"product-detail-form-container dnd-file-upload\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptionsFile\" flow-name=\"vm.ngFlowFile.flow\" flow-files-submitted=\"vm.uploadFilef()\" \nflow-file-added=\"vm.filefAdded($file)\" flow-file-progress=\"vm.filefProgress($file)\" \nflow-file-success=\"vm.filefSuccess($file, $message)\" flow-complete=\"vm.uploadfComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressf\"><span \nstyle=\"font-size: 16px; color:#b0b0b0\" translate=\"VIDEOADD.upload_files\">choose_a_file</span></md-button><md-button \nclass=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUploadf()\" ng-if=\"vm.inProgressf\">\nform_cancel</md-button></div><div layout=\"row\" layout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressf\">\n<div><p class=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFilePre.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressf\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></div></div></div></div></md-content></div></ms-widget-front>\n</ms-widget><div ng-if=\"vm.isNew\" class=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap \nstyle=\"height: 50px\"><md-button class=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" \nstyle=\"margin:6px 8px\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" style=\"margin:6px 8px\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-disabled=\"empMediaVideoForm.$invalid \" ng-click=\"MsStepper.resetForm()\" translate=\"MESSAGES.form_add\">form_add\n</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" style=\"margin:6px 8px\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" ng-transclude=\"\" \nng-click=\"MsStepper.resetForm()\" ng-disabled=\"empMediaVideoForm.$invalid || empMediaVideoForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div>\n<div ng-if=\"!vm.isNew\" class=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap \nstyle=\"height: 50px\"><md-button class=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" \nstyle=\"margin:6px 8px\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" style=\"margin:6px 8px\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-disabled=\"empMediaVideoForm.$invalid \" ng-click=\"MsStepper.resetForm()\" translate=\"MESSAGES.form_add\">form_add\n</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" style=\"margin:6px 8px\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" ng-transclude=\"\" \nng-click=\"MsStepper.resetForm()\" ng-disabled=\"empMediaVideoForm.$invalid || empMediaVideoForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div>\n</form></div></div></div>");
$templateCache.put("app/main/media/video/add_edit_multi_title.template.html","<div class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\" ng-class=\"{\'p-10\': vm.isNew}\"><div \nlayout=\"column\" style=\"overflow: auto\"><div ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" \nclass=\"m-8\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip \nmd-autohide=\"true\" md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div \nlayout-align=\"center center\" layout=\"row\" class=\"m-8\"><div class=\"md-whiteframe-1dp md-background-bg p-16 centerdiiv\" \nflex=\"100\" flex-xs=\"100\"><div class=\"md-title text-left\">{{\'MESSAGES.selection_vignettes\'|translate}}</div><div \nlayout=\"row\" layout-md=\"column\" layout-sm=\"column\" layout-xs=\"column\" id=\"IE-div-player\"><div \nng-if=\"vm.showPlayer && !vm.isMultiUpload\" id=\"div1\" ng-class=\"{\'hidePlayer\': !vm.showPlayer}\" flex \nclass=\"layout-video-wrapper\" layout=\"row\" layout-align=\"center start\"><div class=\"player_ie-exception-3\" \nlayout=\"column\" style=\"width: 100%\"><div class=\"ie-exception-3\" style=\"display: flex; position: relative\" flex><div \nms-scroll class=\"no-padding video-container\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"position: relative;padding: 54% 1em 1em\"><iframe id=\"player_add\" width=\"700\" height=\"397\" \nng-src=\"{{vm.playerLink}}\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\" \nstyle=\"position: absolute;\n                                                top: 0px;\n                                                left: 0px;\n                                                width: 100%;\n                                                border: none;\n                                                height: 100%\">\n</iframe></div></div><div class=\"thumbnails-container\" \nng-class=\"{\'layout-align-center-center\': !vm.showPlayer && !vm.isMultiUpload}\" layout=\"row\" layout-xs=\"column\" \nms-scroll><div><div layout=\"row\" layout-align=\"left left\" style=\"width: 180px; height: 100%\"><md-radio-group \nng-model=\"$root.empMediaVideoForm.logo\" ng-click=\"vm.clickVignette()\"><md-radio-button id=\"radiobtn-vignette\" \nng-repeat=\"thumb in vm.generatedThumbs\" ng-value=\"thumb\" aria-label=\"thumb\" ng-click=\"vm.setAndPreviewThumb(thumb)\" \nstyle=\"height:auto\"><img class=\"IE-img-vignettes\" id=\"img-hover\" ng-click=\"vm.setAndPreviewThumb(thumb)\" \nng-class=\"{\'filter\': thumb=== $root.empMediaVideoForm.logo}\" ng-src=\"{{thumb}}\" style=\"cursor: pointer\"><any \nclass=\"middle\"><any class=\"text\" translate=\"MESSAGES.make_vignette\">make_vignette</any></any></md-radio-button>\n</md-radio-group></div></div></div></div><div flex id=\"IE-div-metadata\" \nhas-permission=\"media_video_get_video_meta_data\" ng-if=\"vm.videoMetaData\"><md-button \nstyle=\"margin-left: 0px;padding-left: 10px;padding-top: 0px;float: left;margin-top: 5px;padding-right: 10px;margin-top: 10px\" \nclass=\"\" ng-click=\"vm.showVideoDetail($event)\" aria-label=\"video_detail\" translate md-ink-ripple=\"false\" \ntranslate-attr-aria-label=\"MESSAGES.video_detail\"><md-icon style=\"opacity: .8\" md-font-icon=\"icon-meta-custom\">\n</md-icon><span translate=\"MESSAGES.video_detail\">video_detail</span></md-button></div></div></div><div \nng-if=\"!vm.showPlayer && !vm.isMultiUpload\" ng-class=\"{\'hidePlayer\': !vm.showPlayer && !vm.isMultiUpload}\" \nstyle=\"width: 100%; max-height: none;margin: 0 auto;color: red;font-size: large\" flex layout=\"row\" \nlayout-align=\"center center\" translate=\"MESSAGES.error_read_video\">la vidéo ne peut pas etre lu</div><div \nng-if=\"vm.isMultiUpload\" layout=\"column\" layout-align=\"end center\"><div layout=\"row\" style=\"max-width: 1000px\"><div \nstyle=\"position: relative\" ng-repeat=\"(key,item) in $root.files\" layout=\"column\"><md-card id=\"mdcard\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);!important;width: 154px\">\n<img ng-src=\"assets/images/vignette.jpg\"><md-card-actions style=\"height: 30px\" layout=\"row\" \nlayout-align=\"start center\"><div layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span \ntitle=\"{{item.file.name}}\" \nstyle=\"font-size: 0.87em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div></div><div flex \nstyle=\"margin: 0 auto; flex-grow: .5\"><div \nng-class=\"{\'layout-align-center-center\': !vm.showPlayer && !vm.isMultiUpload}\" layout=\"row\" layout-xs=\"column\" \nstyle=\"height:100%\"><div id=\"IE-div-vignettes\" layout=\"column\" style=\"width: 100%\"><div class=\"img-wrapper\"><md-icon \nng-if=\"vm.videoThumb === null || vm.videoThumb === \'\' || vm.videoThumb === false || vm.videoThumb === \'not_found\'\" \nmd-font-icon=\"icon-picture\" class=\"s72\"></md-icon><img ng-if=\"vm.videoThumb && vm.videoThumb!== \'not_found\'\" \nclass=\"media\" ng-src=\"{{vm.videoThumb}}\"><div class=\"vignette-button-container\"><md-button class=\"md-icon-button\" \nng-click=\"vm.regenerateThumbs()\" ng-if=\"vm.isNew || (!vm.isNew && vm.hasSourceVideo)\" \ntitle=\"{{ \'MESSAGES.generate_vignette\'|translate}}\"><md-icon md-font-icon=\"icon-rotate-3d\"></md-icon></md-button></div>\n</div><div class=\"mt-20\"><md-radio-group ng-model=\"vm.imageFrom\" ng-switch=\"vm.imageFrom\"><div class=\"mb-15 text-left\">\n<md-radio-button flex value=\"local\" aria-label=\"choose_thumb_from_local\" \ntranslate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"><span translate=\"MESSAGES.choose_thumb_from_local\">\nchoose_thumb_from_local</span></md-radio-button><div ng-switch-when=\"local\" flex layout=\"row\" \nlayout-align=\"start center\"><div class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-file-error=\"vm.fileError($file,$message)\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" \nflow-btn ng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_thumb\">choose_thumb</span></md-button><md-progress-circular ng-if=\"vm.uploadingInPogress\" \nclass=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div><div ng-if=\"vm.dropping\" \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><p ng-if=\"vm.imageName\" class=\"text-truncate mh-10\">{{vm.imageName}}</p></div></div></div>\n<md-divider ng-if=\"$root.empMediaVideoForm.useTheme\" md-inset></md-divider><div class=\"mb-15\" \nng-if=\"vm.isNew || (!vm.isNew && vm.hasSourceVideo)\"><md-radio-button flex value=\"top\" \naria-label=\"choose_thumb_from_local\" translate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"><span \ntranslate=\"MESSAGES.take_vignette_from_video\">Capturer à partir de la vidéo</span></md-radio-button><md-button \nng-if=\"vm.imageFrom===\'top\'\" ng-click=\"vm.takeVignette()\" class=\"cta-button md-raised md-accent\"><span \ntranslate=\"MESSAGES.take_vignette\">Faire une capture de la vignette</span></md-button></div><div class=\"mb-15\">\n<md-radio-button flex value=\"theme\" ng-click=\"vm.testVignette()\" aria-label=\"choose_thumb_from_selected_theme\" \ntranslate-attr-aria-label=\"MESSAGES.choose_thumb_from_selected_theme\"><span \ntranslate=\"MESSAGES.choose_thumb_from_selected_theme\">choose_thumb_from_selected_theme</span></md-radio-button><div \nng-switch-when=\"theme\"><span style=\"color: red\" ng-if=\"$root.empMediaVideoForm.themes.length===0\" \ntranslate=\"MESSAGES.theme_not_selected\">Aucun theme</span><div ng-if=\"$root.empMediaVideoForm.themes.length>0\"><span \nstyle=\"color: red\" ng-if=\"vm.selectedThumbs.length===0\" translate=\"MESSAGES.theme_does_not_have_a_thumb\">\nAucune vignette pour les themes selectionnés</span></div></div></div></md-radio-group></div></div></div></div></div>\n</div></div><div layout-align=\"center center\" layout=\"row\" class=\"m-8\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-16\" flex=\"100\" flex-xs=\"100\"><div class=\"md-title text-left\">\n{{\'MESSAGES.selection_channels\'|translate}}</div><md-card-actions ng-if=\"videoSelectedChannels.length === 0\" \nstyle=\"padding-bottom: 20px\" layout=\"row\" layout-align=\"center\"><md-button style=\"color: #039be5\" \nng-click=\"vm.selectChannels()\"><md-icon style=\"color: #039be5\" md-font-icon=\"icon-plus-circle-outline\" class=\"s18\">\n</md-icon><span translate=\"VIDEOADD.associate_channel\">associate_channel</span></md-button></md-card-actions><div \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" ng-if=\"videoSelectedChannels.length > 0\"><div layout=\"column\" flex=\"90\" \nflex-xs=\"100\" ng-if=\"vm.channels.length\"><md-input-container layout=\"row\" flex=\"100\"><md-select flex=\"100\" \nflex-gt-md=\"100\" flex-gt-xs=\"100\" flex-xs=\"100\" translate translate=\"MESSAGES.form_attr_canal\" \nname=\"empMediaVideoForm[channels][]\" id=\"empMediaVideoForm_channels\" ng-model=\"$root.idChannel\" \nng-attr-name=\"channels\" placeholder=\"{{ \'THEMEADD.form_attr_canal\'|translate}}\"><md-option \nng-repeat=\"channel in videoSelectedChannels track by channel.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"channel.val\">{{ channel.option }} <span style=\"color: #968f8f;font-size: small\" \nng-if=\"$root.empMediaVideoForm.channels[channel.val].defaut\">-- {{\'MESSAGES.default_channel\'|translate}} -- </span><svg\n xmlns=\"https://www.w3.org/2000/svg\" height=\"20px\" width=\"20px\" viewBox=\"0 0 66.728 70\" \nng-if=\"$root.empMediaVideoForm.channels[channel.val].changedTitle\"><g id=\"check-mark\" transform=\"translate(-1.635 0)\">\n<g id=\"Groupe_2\" data-name=\"Groupe 2\"><g id=\"Groupe_1\" data-name=\"Groupe 1\"><path id=\"Tracé_1\" data-name=\"Tracé 1\" \nd=\"M26.474,70a6.972,6.972,0,0,1-5.557-2.764L3.049,43.639a6.971,6.971,0,0,1,11.116-8.414L25.917,50.743,55.474,3.285a6.971,6.971,0,1,1,11.834,7.37L32.392,66.715a6.967,6.967,0,0,1-5.6,3.279C26.685,70,26.58,70,26.474,70Z\" \nfill=\"#4CAF50\"/></g></g></g></svg></md-option></md-select></md-input-container><md-card-actions layout=\"row\" \nflex=\"100\" layout-align=\"end\" layout-align-xs=\"center\"><md-button layout-align=\"right\" \nstyle=\"color: #039be5;margin:0px\" ng-click=\"vm.selectChannels()\"><md-icon style=\"color: #039be5\" \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s18\"></md-icon><span translate=\"VIDEOADD.associate_channel\">\n&nbsp;associate_channel</span></md-button></md-card-actions></div><md-switch layout-align=\"center\" ng-cloak \nng-if=\"videoSelectedChannels.length > 0\" ng-model=\"$root.empMediaVideoForm.channels[$root.idChannel].defaut\" \naria-label=\"default_channel\" ng-change=\"vm.changeDefaultChannel($root.idChannel)\" ng-disabled=\"$root.idChannel == \'\'\" \nstyle=\"padding-left: 15px\">{{\'MESSAGES.default\'|translate}}</md-switch></div></div></div><div class=\"ie-exception-1\" \nlayout=\" row \" layout-wrap><form layout=\"row\" flex=\"100\" layout-wrap name=\"empMediaVideoForm\" method=\"post\" \nng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" novalidate=\"novalidate\" \nclass=\"button-hidden ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 ie-exception-2\"><div><div class=\"md-title\" translate=\"MESSAGES.form_step_basic_info\">form title</div><div \nclass=\"md-inline-form\"><md-input-container class=\"md-block\"><label class=\"md-no-float\" \ntranslate=\"VIDEOADD.form_attr_title\" for=\"empMediaVideoForm_title\" \nng-style=\"{\'opacity\' : $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? 0.4 : 1,\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\nTitre</label><input type=\"text\" id=\"empMediaVideoForm_title\" name=\"empMediaVideoForm[title]\" required=\"required\" \nng-model=\"$root.empMediaVideoForm.title\" ng-attr-name=\"title\" aria-invalid=\"true\" class=\"form-control md-input\" \nplaceholder=\"{{ \'VIDEOADD.form_attr_title\'|translate}}\" \nng-style=\"{\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \nng-disabled=\"$root.idChannel == \'\' && videoSelectedChannels.length > 0\" ng-if=\"videoSelectedChannels.length == 0\"> \n<input type=\"text\" id=\"empMediaVideoForm_title\" name=\"empMediaVideoForm[title]\" required=\"required\" \nng-model=\"$root.empMediaVideoForm.channels[$root.idChannel].title\" ng-attr-name=\"title\" aria-invalid=\"true\" \nclass=\"form-control\" placeholder=\"{{ \'VIDEOADD.form_attr_title\'|translate}}\" \nng-style=\"{\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \nng-disabled=\"$root.idChannel == \'\' && videoSelectedChannels.length > 0\" ng-if=\"videoSelectedChannels.length > 0\" \nng-change=\"vm.changeTitle($root.idChannel)\"><div ng-messages=\"horizontalStep1.title.$error\" \nng-if=\"horizontalStep1.title.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empMediaVideoError.title && $root.empMediaVideoForm.title === vm.empMediaVideoError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-card-content ng-if=\"!$root.state.params.id && vm.testMultiLangue ===\'1\'\" style=\"width: 100%\" \nflex><md-select translate translate=\"MESSAGES.form_attr_language\" name=\"empMediaVideoForm[language][]\" \nid=\"empMediaVideoForm_language\" ng-model=\"vm.language\" required=\"required\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'|translate}}\"><md-option ng-repeat=\"languageChoice in vm.languageChoices\" \nng-value=\"languageChoice.val\"><any translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{languageChoice.option}}\n</any></md-option></md-select></md-card-content><div ng-if=\"vm.testIntranetInternet ===\'1\'\" layout=\"column\" \nlayout-gt-sm=\"row\" flex><div layout=\"row\" layout-gt-sm=\"row\" flex=\"40\"><md-checkbox aria-label=\"isVisibleOnInternet\" \nng-model=\"$root.empMediaVideoForm.isVisibleOnInternet\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\"><label \ntranslate=\"EVENTADD.form_attr_isVisibleOnInternet\"></label></md-checkbox></div><div layout=\"row\" layout-gt-sm=\"row\" \nflex=\"40\"><md-checkbox aria-label=\"isVisibleOnIntranet\" ng-model=\"$root.empMediaVideoForm.isVisibleOnIntranet\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\"><label \ntranslate=\"EVENTADD.form_attr_isVisibleOnIntranet\"></label></md-checkbox></div></div><div \nng-if=\"vm.testMultiFormat === \'1\'\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-false-value=\"0\" name=\"empMediaVideoForm[generateMultipleFormats]\" id=\"empMediaVideoForm_generateMultipleFormats\" \nng-model=\"$root.empMediaVideoForm.generateMultipleFormats\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\"><label \ntranslate=\"MESSAGES.form_attr_generate_multiple_formats\">Générer multiple formats</label></md-checkbox></div><div \nclass=\"date-container\" layout=\"column\" has-permission=\"media_video_list_show_date\" layout-gt-xs=\"row\" flex \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<md-input-container flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.start_date\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\nstart_date</label><md-datepicker required ng-model=\"$root.empMediaVideoForm.mdTime.start\" \nng-change=\"vm.changeDate(\'start\',\'startDate\')\" ng-attr-name=\"mdstart\" md-min-date=\"vm.minDate\" \nmd-max-date=\"$root.empMediaVideoForm.mdTime.end\" md-open-on-focus \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n</md-datepicker><div ng-messages=\"horizontalStep1.mdstart.$error\" ng-if=\"horizontalStep1.mdstart.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-message=\"valid\" translate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" \ntranslate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdstart && $root.empMediaVideoForm.mdstart === vm.empMediaVideoError.mdstart.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdstart.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\nend_date</label><md-datepicker required ng-model=\"$root.empMediaVideoForm.mdTime.end\" \nng-change=\"vm.changeDate(\'end\',\'endDate\')\" ng-attr-name=\"mdEnd\" md-min-date=\"$root.empMediaVideoForm.mdTime.start\" \nmd-open-on-focus \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n</md-datepicker><div ng-messages=\"horizontalStep1.mdEnd.$error\" ng-if=\"horizontalStep1.mdEnd.$touched\" role=\"alert\">\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empMediaVideoError.mdEnd && $root.empMediaVideoForm.mdEnd === vm.empMediaVideoError.mdEnd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdEnd.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div class=\"mt-5\" layout=\"column\" flex><ms-themes theme=\"vm.theme\" \nall-themes=\"vm.allThemes\" type=\"\'theme\'\" show-label=\"true\" multi=\"true\" multi-title=\"videoSelectedChannels.length > 0\" \ncanal=\"$root.idChannel\" ng-model=\"vm.theme\" ng-change=\"vm.selectThemes(\'theme\',someModel)\" \nstyle=\"width: 100%; margin-top: -15px\"></ms-themes></div><div class=\"md-title text-left\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \ntranslate=\"VIDEOADD.confidentiality\" \nng-if=\"vm.testNotificationClient === \'1\' || !vm.isMultiUpload || (!vm.isMultiUpload && vm.empMediaVideoForm.themes.length>0)\" \nhas-permission=\"media_video_secure_form_no_api,media_home_post_disable_push_video,media_video_downloadable_vid_form_no_api,media_video_post_toggle,media_video_password_form_no_api\">\nconfidentiality</div><div layout=\"row\" layout-wrap><div ng-if=\"vm.testNotificationClient === \'1\'\" flex=\"50\" \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"sendPushNotifications\" \nid=\"sendPushNotifications\" ng-model=\"vm.sendPushNotifications\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<span translate=\"MESSAGES.form_attr_send_push_notif\">form_step_further_info</span></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload\" flex=\"50\" layout=\"column\" layout-gt-sm=\"row\" has-permission=\"media_video_secure_form_no_api\">\n<md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[secure]\" id=\"empMediaVideoForm_secure\" \nng-model=\"$root.empMediaVideoForm.secure\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label translate=\"MESSAGES.set_secure\">Video sécurisé</label></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload && $root.empMediaVideoForm.themes.length>0\" flex=\"50\" \nhas-permission=\"media_home_post_disable_push_video\" layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-false-value=\"0\" name=\"empMediaVideoForm[mainPage]\" id=\"empMediaVideoForm_mainPage\" \nng-model=\"$root.empMediaVideoForm.mainPage\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label translate=\"MESSAGES.form_attr_main_page\">Vidéo d\'accueil</label></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_downloadable_vid_form_no_api\" layout=\"column\" \nlayout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[downloadable]\" \nid=\"empMediaVideoForm_downloadable\" ng-model=\"$root.empMediaVideoForm.downloadable\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label translate=\"MESSAGES.form_attr_downloadable\">Vidéo téléchargeable</label></md-checkbox></div><div \nng-if=\"!vm.isMultiUpload\" flex=\"50\" has-permission=\"media_video_post_toggle\" layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-true-value=\"1\" ng-false-value=\"0\" name=\"empMediaVideoForm[offline]\" id=\"empMediaVideoForm_offline\" \nng-model=\"$root.empMediaVideoForm.offline\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label translate=\"MESSAGES.form_attr_vid_offline\">Mettre la video Hors ligne</label></md-checkbox></div><div><div \nng-if=\"!vm.isMultiUpload\" has-permission=\"media_video_password_form_no_api\" class=\"md-inline-form\" \nstyle=\"position: relative\"><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"1\" \nng-change=\"vm.setEmptyPassword()\" ng-false-value=\"0\" name=\"empMediaVideoForm[locked]\" id=\"empMediaVideoForm_locked\" \nng-model=\"$root.empMediaVideoForm.isSecuredOnInternet\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label translate=\"MESSAGES.form_attr_locked_vid\">Sécuriser vidéo avec un mot de passe</label></md-checkbox></div>\n<md-input-container ng-if=\"$root.empMediaVideoForm.isSecuredOnInternet\" style=\"width: 100%; padding-left: 30px\" \naria-hidden=\"true\"><label translate=\"VIDEOADD.form_attr_unlock_password\" for=\"empMediaVideoForm_unlockPassword\" \nclass=\"md-no-float lock-video-label\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\nAjouter un mot de passe</label><input type=\"password\" id=\"empMediaVideoForm_unlockPassword\" \nname=\"empMediaVideoForm[unlockPassword]\" ng-model=\"$root.empMediaVideoForm.passwordInternet\" \nng-attr-name=\"unlockPassword\" ng-required=\"$root.empMediaVideoForm.isSecuredOnInternet\" aria-invalid=\"false\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'background-color\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'#F0F0F0\' : \'transparent\',\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\' }\">\n<div class=\"md-errors-spacer\"></div><div ng-messages=\"horizontalStep1.passwordInternet.$error\" \nng-if=\"horizontalStep1.passwordInternet.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.passwordInternet && $root.empMediaVideoForm.passwordInternet === vm.empMediaVideoError.passwordInternet.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.passwordInternet.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div></div></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><div><div class=\"md-title\" \ntranslate=\"MESSAGES.form_step_further_info\">form title</div><div class=\"md-inline-form\"><md-input-container \nclass=\"md-block\"><label translate=\"VIDEOADD.form_attr_description\" class=\"md-no-float\" \nfor=\"empMediaVideoForm_description\" \nng-style=\"{\'opacity\' : $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? 0.4 : 1,\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\nDescription</label><textarea ng-model=\"$root.empMediaVideoForm.description\" class=\"form-control md-input\" \nid=\"empMediaVideoForm_description\" aria-invalid=\"true\" name=\"empMediaVideoForm[description]\" \nng-attr-name=\"description\" rows=\"5\" \nng-style=\"{\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \nng-disabled=\"$root.idChannel == \'\' && videoSelectedChannels.length > 0\" ng-if=\"!videoSelectedChannels.length\">\n</textarea><textarea ng-model=\"$root.empMediaVideoForm.description\" class=\"form-control md-input\" \nid=\"empMediaVideoForm_description\" aria-invalid=\"true\" name=\"empMediaVideoForm[description]\" \nng-attr-name=\"description\" rows=\"5\" \nng-style=\"{\'cursor\': $root.idChannel == \'\' && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \nng-disabled=\"$root.idChannel == \'\' && videoSelectedChannels.length > 0\" ng-if=\"videoSelectedChannels.length > 0\">\n</textarea><div ng-messages=\"horizontalStep1.description.$error\" ng-if=\"horizontalStep1.description.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empMediaVideoError.description && $root.empMediaVideoForm.description === vm.empMediaVideoError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex class=\"md-block\" has-permission=\"media_video_form_transcription\"><label \ntranslate=\"VIDEOADD.form_attr_transcription\" class=\"md-no-float\" for=\"empMediaVideoForm_transcription\" \nng-style=\"{\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1}\">\nTranscription</label><div class=\"md-resize-wrapper\"><textarea id=\"empMediaVideoForm_transcription\" \nname=\"empMediaVideoForm[transcription]\" ng-attr-name=\"transcription\" rows=\"5\" md-maxlength=\"2000\" md-select-on-focus \nng-model=\"$root.empMediaVideoForm.transcription\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 123px\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'background-color\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'#F0F0F0\' : \'transparent\' ,\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n</textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"horizontalStep2.transcription.$error\" ng-if=\"horizontalStep2.transcription.$touched\" role=\"alert\"><div \nng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"2000\">form_max_length</div><div \nng-if=\"vm.empMediaVideoError.transcription && $root.empMediaVideoForm.transcription === vm.empMediaVideoError.transcription.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.transcription.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><div layout=\"row\" layout-wrap><div flex=\"50\"><div \nhas-permission=\"media_video_contributor_form_no_api\" layout=\"column\" layout-gt-xs=\"row\" class=\"pr-15\" flex>\n<md-card-content flex><md-input-container class=\"md-block\"><label translate=\"MESSAGES.form_attr_contributor\" \nclass=\"md-no-float\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1}\">\nContributor</label><md-select translate translate=\"MESSAGES.form_attr_contributor\" \nname=\"empMediaVideoForm[contributor]\" id=\"empMediaVideoForm_contributor\" \nng-model=\"$root.empMediaVideoForm.contributor\" placeholder=\"{{ \'MESSAGES.form_attr_contributor\'|translate}}\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<md-option ng-if=\"name.val!=0\" ng-repeat=\"contributor in vm.contributors track by contributor.val\" \nnb-attr-data-index=\"{{$index}}\" ng-value=\"contributor.val\" \nng-attr-translate=\"{{contributor.val==0 ? \'MESSAGES.none\':\'\'}}\">{{contributor.option}}</md-option></md-select>\n</md-input-container></md-card-content></div></div><div flex=\"50\"><md-input-container class=\"md-block\"><label \ntranslate=\"VIDEOADD.form_attr_author\" class=\"md-no-float\" for=\"empMediaVideoForm_author\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1}\">\nAuteur</label><input type=\"text\" id=\"empMediaVideoForm_author\" name=\"empMediaVideoForm[author]\" \nng-model=\"$root.empMediaVideoForm.author\" aria-invalid=\"false\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'background-color\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'#F0F0F0\' : \'transparent\' }\">\n<div class=\"md-errors-spacer\"></div></md-input-container></div><div flex=\"50\" class=\"pr-15\"><md-input-container \nclass=\"md-block\"><label translate=\"VIDEOADD.form_attr_copyright\" class=\"md-no-float\" for=\"empMediaVideoForm_copyright\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1}\">\nCopyright</label><input type=\"text\" id=\"empMediaVideoForm_copyright\" name=\"empMediaVideoForm[copyright]\" \nng-model=\"$root.empMediaVideoForm.copyright\" aria-invalid=\"false\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'background-color\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'#F0F0F0\' : \'transparent\' }\">\n<div class=\"md-errors-spacer\"></div></md-input-container></div><div flex=\"50\"><md-input-container \nclass=\"md-block md-input-has-placeholder md-default-theme md-no-float chips-container\"><label class=\"md-no-float\" \ntranslate=\"VIDEOADD.form_attr_key_words\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\',\'opacity\' : !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0? 0.4 : 1}\">\nMots clés</label><md-chips id=\"empMediaVideoForm_keyWords\" name=\"empMediaVideoForm[keyWords]\" \nng-model=\"$root.empMediaVideoForm.keyWords\" \nmd-removable=\"$root.empMediaVideoForm.channels[idChannel].defaut || videoSelectedChannels.length <= 0\" \naria-hidden=\"true\" tabindex=\"-1\" aria-invalid=\"false\" placeholder=\"{{ \'VIDEOADD.form_attr_keyword\' | translate }}\" \nsecondary-placeholder=\"+Tag\" md-separator-keys=\"vm.customKeys\" \nreadonly=\"!$root.empMediaVideoForm.channels[idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<md-chips-wrap ng-keydown=\"$mdChipsCtrl.chipKeydown($event)\" \nng-class=\"{ \'md-focused\': $mdChipsCtrl.hasFocus(),                       \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,                      \'md-removable\': $mdChipsCtrl.isRemovable() }\" \nclass=\"md-chips md-removable\"><md-chip ng-repeat=\"$chip in $mdChipsCtrl.items\" index=\"0\" \nng-class=\"{\'md-focused\': $mdChipsCtrl.selectedChip === $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}\" \nclass=\"ng-scope md-default-theme\"><div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" \nng-click=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.focusChip($index)\" \nng-focus=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.selectChip($index)\" \nmd-chip-transclude=\"$mdChipsCtrl.chipContentsTemplate\" role=\"button\"><span class=\"ng-binding ng-scope\"></span></div>\n<div ng-if=\"$mdChipsCtrl.isRemovable()\" class=\"md-chip-remove-container ng-scope\" \nmd-chip-transclude=\"$mdChipsCtrl.chipRemoveTemplate\"><button class=\"md-chip-remove ng-scope\" \nng-if=\"$mdChipsCtrl.isRemovable()\" ng-click=\"$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)\" \ntype=\"button\" aria-hidden=\"true\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=\" \nclass=\"md-default-theme\" aria-hidden=\"true\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" \nxmlns=\"https://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveAspectRatio=\"xMidYMid meet\" \nfocusable=\"false\"><g><path \nd=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\">\n</path></g></svg></md-icon><span class=\"md-visually-hidden ng-binding\">Remove</span></button></div><span \nng-if=\"!$mdChipsCtrl.readonly\" class=\"md-visually-hidden ng-binding ng-scope\">Press delete to remove this chip.</span>\n</md-chip><div class=\"md-chip-input-container ng-scope\" \nng-if=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.ngModelCtrl\"><div \nmd-chip-transclude=\"$mdChipsCtrl.chipInputTemplate\"><input style=\"height: 32px\" \nclass=\"md-input ng-pristine ng-untouched ng-valid ng-scope ng-empty\" tabindex=\"0\" aria-label=\"Mots clés\" \nng-model=\"$mdChipsCtrl.chipBuffer\" ng-focus=\"$mdChipsCtrl.onInputFocus()\" ng-blur=\"$mdChipsCtrl.onInputBlur()\" \nng-keydown=\"$mdChipsCtrl.inputKeydown($event)\" id=\"input_43\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</div></div></md-chips-wrap></md-chips></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nhas-permission=\"media_video_join_files_form_no_api\"><md-checkbox name=\"empMediaVideoForm[mainPage]\" \nid=\"empMediaVideoForm_mainPage\" ng-model=\"vm.joinFile\" \nng-disabled=\"!$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0\" \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\">\n<label \nng-style=\"{\'cursor\': !$root.empMediaVideoForm.channels[$root.idChannel].defaut && videoSelectedChannels.length > 0 ? \'not-allowed\' : \'default\'}\" \ntranslate=\"MESSAGES.join_files\">Joindre des fichiers</label></md-checkbox></div><div class=\"md-padding\" layout-wrap \nlayout=\"row\" has-permission=\"media_video_join_files_form_no_api\"><div style=\"position: relative\" \nng-repeat=\"(key,item) in vm.filesChips\" layout=\"column\"><md-button style=\"position: absolute;left: 97px;top: -13px\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.deleteAddedChip(item)\"><svg aria-hidden=\"true\" class=\"UppyIcon\" \nwidth=\"20\" height=\"30\" viewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" \nfill-rule=\"nonzero\" vector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\">\n</path><path fill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card title=\"{{item}}\" id=\"mdcard\" ng-click=\"vm.selectChip(item)\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)!important;height: 97px\">\n<md-icon ng-if=\"vm.testExtension(item)===\'video\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-video\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'audio\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-music\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'excel\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-excel\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'word\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-word\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'image\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-image\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'pdf\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-pdf\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'other\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file\"></md-icon><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\"><div \nstyle=\"text-align: center\" layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item}}\" \nstyle=\"font-size: 0.75em;width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div><div ng-if=\"vm.joinFile\"><div layout-padding \nlayout-margin class=\"product-detail-form-container dnd-file-upload\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptionsFile\" flow-name=\"vm.ngFlowFile.flow\" flow-files-submitted=\"vm.uploadFilef()\" \nflow-file-added=\"vm.filefAdded($file)\" flow-file-progress=\"vm.filefProgress($file)\" \nflow-file-success=\"vm.filefSuccess($file, $message)\" flow-complete=\"vm.uploadfComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressf\"><span \nstyle=\"font-size: 16px; color:#b0b0b0\" translate=\"VIDEOADD.upload_files\">choose_a_file</span></md-button><md-button \nclass=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUploadf()\" ng-if=\"vm.inProgressf\">\nform_cancel</md-button></div><div layout=\"row\" layout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressf\">\n<div><p class=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFilePre.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressf\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></div></div></div></ms-widget-front></ms-widget><div \nng-if=\"vm.isNew\" class=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap style=\"height: 50px\">\n<md-button class=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \ntype=\"submit\" class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-disabled=\"empMediaVideoForm.$invalid || !vm.videoThumb || !vm.existDefault && videoSelectedChannels.length > 0\" \nng-click=\"MsStepper.resetForm()\" translate=\"MESSAGES.form_add\">form_add</md-button></div><div ng-if=\"!vm.isNew\" \nclass=\"flex-xs-100 flex-100 buttons-container flex\" layout=\"row\" layout-wrap style=\"height: 50px\"><md-button \nclass=\"md-raised cancel-button\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-click=\"MsStepper.resetForm()\" \ntype=\"submit\" class=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-transclude=\"\" \nng-disabled=\"empMediaVideoForm.$invalid || empMediaVideoForm.$pristine || !vm.videoThumb || !vm.existDefault && videoSelectedChannels.length > 0\" \nstyle=\"\" translate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate\n</md-button></div></form></div></div></div>");
$templateCache.put("app/main/media/video/channel.template.html","<md-dialog style=\"width: 30%\" class=\"video-url-dialog\" aria-label=\"list_channels\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"MESSAGES.list_channels\">list_channels</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content class=\"no-padding\" \naria-label=\"a\"><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-card \nstyle=\"margin: 0;border: none;border: 0;border-bottom: 1px solid #fdfdfd\"><md-content-card \nstyle=\"height: 500px;padding:5px 10px; overflow-y: auto\"><md-list ng-cloak><md-list-item \nng-style=\"{\'background-color\' : !channel.add ? \'#F2F2F2\' : \'white\'}\" \nng-repeat=\"channel in vm.allChannels track by channel.val\"><p style=\"padding: 10px\">{{ channel.option }}</p><a \nng-if=\"!channel.add\" style=\"text-decoration : none\" tooltips tooltip-template=\"{{\'MESSAGES.undo\'|translate}}\" \ntooltip-side=\"left\" tooltip-speed=\"fast\"><md-button ng-if=\"!channel.add\" ng-click=\"vm.removeChannel(channel)\" \nclass=\"md-icon-button md-warn\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\" class=\"s18\"></md-icon></md-button></a><a ng-if=\"channel.add\" \nstyle=\"text-decoration : none\" tooltips tooltip-template=\"{{\'MESSAGES.add\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button ng-if=\"channel.add\" ng-click=\"vm.selectChannels()\" class=\"md-icon-button md-warn\" \nlayout=\"row\" layout-align=\"start center\"><md-icon style=\"color: #039be5\" md-font-icon=\"icon-plus-circle-outline\" \nng-click=\"vm.addChannel(channel)\" class=\"s18\"></md-icon></md-button></a></md-list-item></md-list></md-content-card>\n</md-card></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button>\n<md-button class=\"md-raised md-accent\" ng-click=\"vm.validate()\" translate=\"MESSAGES.form_validate\">form_validate\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/condition-terms.modal.html","<md-dialog aria-label=\"conditions\" style=\"width: 600px\"><form ng-cloak><md-dialog-content><div \nclass=\"md-dialog-content\"><h1 style=\"color: #039be5;text-align: center;font-size: 3.2rem\" \ntranslate=\"VIDEOADD.terms_conditions\">Règles de confidentialité et conditions d\'utilisation</h1><p>{{text}}</p></div>\n</md-dialog-content><md-dialog-actions style=\"border-top: 1px solid #ededed\" layout=\"row\"><span flex></span><md-button \nng-click=\"cancel()\"><span translate=\"VIDEOADD.cancel\">Annuler</span></md-button><md-button \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" ng-click=\"accept()\"><span \ntranslate=\"VIDEOADD.accept\">J\'accepte</span></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/skin/player/player.template.html","<div id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_skin\" \niframe-onload=\"iframeLoadedCallBack()\" ng-src=\"{{vm.urlSkinPlayerList}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/metaData/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px;    position: relative\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 100%;\n    position: absolute;\n    width: 100%\" layout=\"row\" layout-wrap><iframe \nsrc=\"{{metaDataIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation-new/toolbar.html","<div class=\"horizontal-menu-new top-row md-gradient-bg\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\" ng-if=\"vm.logoToolbar.logo_image\">{{vm.logoToolbar.logo_image}}</span> <span class=\"logo-text\" \nng-if=\"!vm.logoToolbar.logo_text1\">{{vm.logoToolbar.logo_text}}</span><div ng-if=\"vm.logoToolbar.logo_text1\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-part1\">{{vm.logoToolbar.logo_text}} </span><span \nclass=\"logo-part2\">{{vm.logoToolbar.logo_text1}}</span></div></div></div><div layout=\"row\" layout-align=\"start center\">\n<div show-gt-sm hide-gt-xs hide-sm hide-xs><md-button has-permission=\"upgarde_payement\" class=\"upgrade-button\" \nng-class=\"{ \'button-color hidden-profile-menu\' : vm.isFM}\" ui-sref=\"app.pricing-v2\">Mettre à niveau<span class=\"dot\" \nng-if=\"!vm.isFM\"></span></md-button></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\" ng-if=\"!vm.isFM\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span>\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span>\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"USER SETTINGS\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\" \nng-class=\"{\'button-profil\': vm.isNotBo , \'profile-menu-button\' : vm.isFM}\"><div layout=\"row\" \nlayout-align=\"space-between center\" ng-class=\"{\'profile-menu\': vm.isFM}\"><div class=\"avatar-wrapper\"><img \nmd-menu-align-target class=\"avatar\" on-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon ng-if=\"!vm.isNotBo\" style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon>\n</div><div layout=\"column\" ng-class=\"{\'hidden-profile-menu\' : vm.isFM}\"><span class=\"username\" hide-sm \nng-class=\"{\'span-username\': vm.isNotBo}\" ng-if=\"vm.isFM\">{{vm.getFullName}}</span> <span \nng-if=\"vm.isNotBo && !vm.isFM\" class=\"groupname\">{{vm.user.group.name}}</span></div><md-icon \nmd-font-icon=\"icon-chevron-down\" \nng-class=\"{\'icon-color\': vm.isNotBo && !vm.isFM , \'profile-menu-button hidden-profile-menu\' : vm.isFM}\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\" class=\"toolbar-new\" \nng-class=\"{\'md-menu-content\': vm.isNotBo }\"><any ng-if=\"vm.isFM\" class=\"flags\"><md-menu-item \nclass=\"md-indent current-flag\" ng-if=\"vm.selectedLanguage.flag==\'fr\'\"><md-icon \nclass=\"flag-size icon icon-new icon-size translate-flag-fr\" ng-class=\"{\'position-flag\' : vm.isFM}\"></md-icon><md-button\n class=\"selected-flag\" translate=\"TOOLBAR.fr\">fr</md-button><md-button aria-label=\"FLAG\" class=\"not-selected-flag\" \nng-click=\"vm.changeLanguage({code: \'en\',\n                        flag: \'us\',\n                        title: \'English\',\n                        translation: \'TOOLBAR.ENGLISH\'})\">\n<span class=\"dropdown-flags\"><md-icon class=\"icon-play play-left\"></md-icon><md-icon class=\"icon-play play-right\">\n</md-icon></span><md-icon class=\"flag-size icon icon-new icon-size translate-flag-en not-selected-flag--en\" \nng-class=\"{\'position-flag\' : vm.isFM}\"></md-icon></md-button></md-menu-item><md-menu-item \nclass=\"md-indent current-flag\" ng-if=\"vm.selectedLanguage.flag==\'us\'\"><md-icon \nclass=\"flag-size icon icon-new icon-size translate-flag-en\" ng-class=\"{\'position-flag\' : vm.isFM}\"></md-icon><md-button\n class=\"selected-flag\" translate=\"TOOLBAR.us\">us</md-button><md-button aria-label=\"FLAG\" class=\"not-selected-flag\" \nng-click=\"vm.changeLanguage({\n                        code: \'fr\',\n                        flag: \'fr\',\n                        title: \'Francais\',\n                        translation: \'TOOLBAR.FRENCH\'})\">\n<span class=\"dropdown-flags\"><md-icon class=\"icon-play play-left\"></md-icon><md-icon class=\"icon-play play-right\">\n</md-icon></span><md-icon class=\"flag-size icon icon-new icon-size translate-flag-fr not-selected-flag--fr\" \nng-class=\"{\'position-flag\' : vm.isFM}\"></md-icon></md-button></md-menu-item></any><md-menu-item \nhas-permission=\"profiles_user_get_detail\" class=\"md-indent\" ui-sref=\"app.profiles_user_profilConnectedV2\"><md-icon \nng-if=\"!vm.isNotBo\" md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button ng-if=\"!vm.isNotBo\" \ntranslate=\"TOOLBAR.my_profile\">My profile</md-button><md-icon ng-if=\"vm.isNotBo\" md-font-icon=\"icon-user\" \nclass=\"icon icon-new icon-size\"></md-icon><md-button ng-if=\"vm.isNotBo\" translate=\"TOOLBAR.account\">Account</md-button>\n</md-menu-item><md-menu-divider ng-if=\"!vm.isNotBo\" has-permission=\"profiles_user_get_detail\"></md-menu-divider><any \nhas-permission=\"options_theme_key_no_api\" ng-if=\"!vm.isFM\"><md-menu-item class=\"md-indent\"><md-icon \nng-if=\"!vm.isNotBo\" md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-icon ng-if=\"vm.isNotBo\" \nmd-font-icon=\"icon-gear\" class=\"icon icon-new icon-size\"></md-icon><md-button ng-click=\"vm.goToConf()\" \ntranslate=\"MESSAGES.display_options\">Changer layout</md-button></md-menu-item><md-menu-divider ng-if=\"!vm.isNotBo\">\n</md-menu-divider></any><any has-permission=\"support_key_no_api\" ng-if=\"!vm.isFM\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.support_key_list\"><md-icon ng-if=\"!vm.isNotBo\" md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-icon \nng-if=\"vm.isNotBo\" md-font-icon=\"icon-key1\" class=\"icon icon-new icon-size\"></md-icon><md-button \ntranslate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nng-if=\"!vm.isNotBo\" style=\"display: block\"></md-menu-divider></any><any ng-if=\"vm.isFM\"><md-menu-item \nclass=\"md-indent\" ng-disabled=\"true\"><md-icon ng-disabled=\"true\" ng-class=\"{\'disabled-icons\': vm.isFM}\" \nmd-font-icon=\"icon-Factures\" class=\"icon icon-new icon-size\"></md-icon><md-button ng-disabled=\"true\" \ntranslate=\"PAGESMENUSTITLES.bills\">Mes factures</md-button></md-menu-item><md-menu-divider ng-if=\"!vm.isNotBo\" \nstyle=\"display: block\"></md-menu-divider></any><any ng-if=\"vm.isFM\"><md-menu-item class=\"md-indent\" ng-disabled=\"true\">\n<md-icon ng-disabled=\"true\" ng-class=\"{\'disabled-icons\': vm.isFM}\" md-font-icon=\"icon-abonnement\" \nclass=\"icon icon-new icon-size\"></md-icon><md-button ng-disabled=\"true\" translate=\"PAGESMENUSTITLES.subscriptions\">\nMes abonnements</md-button></md-menu-item><md-menu-divider ng-if=\"!vm.isNotBo\" style=\"display: block\">\n</md-menu-divider></any><any has-permission=\"support_documentation_no_api\"><md-menu-item class=\"md-indent\"><md-icon \nng-if=\"!vm.isNotBo\" md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button ng-if=\"!vm.isNotBo\" \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button><md-icon ng-if=\"vm.isNotBo\" \nmd-font-icon=\"icon-help1\" class=\"icon icon-new icon-size\"></md-icon><md-button ng-if=\"vm.isNotBo\" \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" translate=\"TOOLBAR.help\">Aide</md-button>\n</md-menu-item><md-menu-divider ng-if=\"!vm.isNotBo\" style=\"display: block\"></md-menu-divider></any><md-menu-item \nclass=\"md-indent\"><md-icon ng-if=\"!vm.isNotBo\" md-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-icon \nng-if=\"vm.isNotBo\" md-font-icon=\"icon-logout1\" class=\"icon icon-new icon-size\" \nng-class=\"{\'profile-menu-button\': vm.isFM}\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\" \nng-class=\"{\'item-button\': vm.isNotBo, \'profile-menu-button\': vm.isFM}\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\" class=\"md-primary-bg\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\" \nng-if=\"vm.logoToolbar.logo_image\">{{vm.logoToolbar.logo_image}}</span> <span class=\"logo-text\">\n{{vm.logoToolbar.logo_text}}</span></div><div class=\"toolbar-separator\"></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon style=\"margin-left: 5px\" md-font-icon=\"icon-home\" \nclass=\"s16 black-fg cursor-pointer white-opacity\" ui-sref=\"app.dashboard\"></md-icon><md-icon style=\"margin-left: -2px\" \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon><span \nclass=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon><span \nclass=\"parent white-opacity\" translate=\"{{$root.titre2}}\">media_video_menuTitle</span><md-icon \nng-if=\"$root.titre3!==\'\'\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon>\n<span ng-if=\"$root.titre3!==\'\'\" id=\"titre3\" class=\"parent white-opacity\" translate=\"{{$root.titre3}}\">\nmedia_video_menuTitle</span></div></div><div layout=\"row\" layout-align=\"start center\"><div class=\"toolbar-separator\">\n</div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \non-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon></div><span \nclass=\"username\" hide-sm>{{vm.getFullName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item has-permission=\"profiles_user_get_detail\" \nclass=\"md-indent\" ui-sref=\"app.profiles_user_profilconnected\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.my_profile\">My profile</md-button></md-menu-item><md-menu-divider \nhas-permission=\"profiles_user_get_detail\"></md-menu-divider><any has-permission=\"options_theme_key_no_api\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button \nng-click=\"goToConf()\" translate=\"MESSAGES.display_options\">Changer layout</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider></any><any has-permission=\"support_key_no_api\"><md-menu-item class=\"md-indent\" class=\"md-indent\" \nui-sref=\"app.support_key_list\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button \ntranslate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><any has-permission=\"support_documentation_no_api\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\">logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\" \nng-if=\"vm.app.environment === \'dev\'\"></div><md-button class=\"md-icon-button hide-xs\" \nng-click=\"vm.refreshPageContent()\" ng-if=\"vm.app.environment === \'dev\'\" aria-label=\"action_refresh_content\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_refresh_content\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon white\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><div class=\"toolbar-tooltip\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.help\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.showHelp()\" aria-label=\"ASK FOR SUPPORT\" translate \ntranslate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon md-font-icon=\"icon-help-circle\" class=\"icon white\">\n</md-icon></md-button></a></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","aaaaaaaaaaaaaaaaaerearaer<div class=\"md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\" flex><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"TOGGLE NAVIGATION\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon white\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\" show-gt-sm show-sm hide-xs><md-icon style=\"margin-left: 5px\" \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer white-opacity\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nstyle=\"margin-left: -2px\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon><a \nng-if=\"$root.titre2!==\'\' && $root.titre3===\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle\n</span> </a><span \nng-if=\"($root.titre2!==\'\' && $root.titre3!==\'\') || ($root.titre2===\'\' && $root.titre3===\'\') || ($root.titre2!==\'\' && $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle</span><md-icon ng-if=\"$root.titre2!==\'\'\" \nmd-font-icon=\"icon-chevron-right\" id=\"title2-icon-chevron-right\" class=\"s16 black-fg separator white-opacity\">\n</md-icon><a ng-if=\"$root.titre2!==\'\' && $root.titre3!==\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" translate=\"{{$root.titre2}}\">\nmedia_video_menuTitle</span> </a><span ng-if=\"$root.titre2!==\'\' && ($root.titre3===\'\' || $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre2}}\">media_video_menuTitle</span><md-icon \nng-if=\"$root.titre3!==\'\'\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon>\n<span ng-if=\"$root.titre3!==\'\'\" id=\"titre3\" class=\"parent white-opacity\" translate=\"{{$root.titre3}}\">\nmedia_video_menuTitle</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"USER SETTINGS}}\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\" \nstyle=\"background: rgba(0, 0, 0, 0)\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\">\n<img md-menu-align-target class=\"avatar\" on-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon></div><span \nclass=\"username\" hide-sm hide-xs style=\"color: #fff\">{{vm.getFullName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item has-permission=\"profiles_user_get_detail\" class=\"md-indent\" ui-sref=\"app.profiles_user_profilconnected\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button translate=\"TOOLBAR.my_profile\">My profile\n</md-button></md-menu-item><md-menu-divider has-permission=\"profiles_user_get_detail\"></md-menu-divider><any \nhas-permission=\"options_theme_key_no_api\"><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.goToConf()\" translate=\"MESSAGES.display_options\">Changer layout\n</md-button></md-menu-item><md-menu-divider></md-menu-divider></any><any has-permission=\"support_key_no_api\">\n<md-menu-item class=\"md-indent\" class=\"md-indent\" ui-sref=\"app.support_key_list\"><md-icon md-font-icon=\"icon-key\" \nclass=\"icon\"></md-icon><md-button translate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item>\n<md-menu-divider style=\"display: block\"></md-menu-divider></any><any has-permission=\"support_documentation_no_api\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\">logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\" \nng-if=\"vm.app.environment === \'dev\'\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.refreshPageContent()\" \nng-if=\"vm.app.environment === \'dev\'\" aria-label=\"action_refresh_content\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_refresh_content\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon white\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><div class=\"toolbar-tooltip\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.help\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nng-if=\"$root.welcome!==\'\'\" id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.showHelp()\" \naria-label=\"ASK FOR SUPPORT\" translate translate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"icon white\"></md-icon></md-button></a></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div class=\"md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\" show-gt-sm show-sm hide-xs><span class=\"logo-image\" \nng-if=\"vm.logoToolbar.logo_image\">{{vm.logoToolbar.logo_image}}</span> <span class=\"logo-text\" style=\"color: #fff\">\n{{vm.logoToolbar.logo_text}}</span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"TOGGLE NAVIGATION\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon white\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"TOGGLE NAVIGATION FOLD\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button><div\n layout=\"row\" layout-align=\"start center\" show-gt-sm hide-sm hide-xs><md-icon style=\"margin-left: 5px\" \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer white-opacity\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nstyle=\"margin-left: -2px\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon><a \nng-if=\"$root.titre2!==\'\' && $root.titre3===\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle\n</span> </a><span \nng-if=\"($root.titre2!==\'\' && $root.titre3!==\'\') || ($root.titre2===\'\' && $root.titre3===\'\') || ($root.titre2!==\'\' && $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle</span><md-icon ng-if=\"$root.titre2!==\'\'\" \nmd-font-icon=\"icon-chevron-right\" id=\"title2-icon-chevron-right\" class=\"s16 black-fg separator white-opacity\">\n</md-icon><a ng-if=\"$root.titre2!==\'\' && $root.titre3!==\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" translate=\"{{$root.titre2}}\">\nmedia_video_menuTitle</span> </a><span ng-if=\"$root.titre2!==\'\' && ($root.titre3===\'\' || $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre2}}\">media_video_menuTitle</span><md-icon \nng-if=\"$root.titre3!==\'\'\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon>\n<span ng-if=\"$root.titre3!==\'\'\" id=\"titre3\" class=\"parent white-opacity\" translate=\"{{$root.titre3}}\">\nmedia_video_menuTitle</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"USER SETTINGS\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\" \nstyle=\"background: rgba(0, 0, 0, 0)\"><div layout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\">\n<img md-menu-align-target class=\"avatar\" on-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon></div><span \nclass=\"username\" hide-sm hide-xs style=\"color: #fff\">{{vm.getFullName}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item has-permission=\"profiles_user_get_detail\" class=\"md-indent\" ui-sref=\"app.profiles_user_profilconnected\">\n<md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button translate=\"TOOLBAR.my_profile\">My profile\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><any has-permission=\"options_theme_key_no_api\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.goToConf()\" translate=\"MESSAGES.display_options\">Changer layout</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider></any><any has-permission=\"support_key_no_api\"><md-menu-item class=\"md-indent\" \nclass=\"md-indent\" ui-sref=\"app.support_key_list\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button \ntranslate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><any has-permission=\"support_documentation_no_api\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\">logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\" \nng-if=\"vm.app.environment === \'dev\'\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.refreshPageContent()\" \nng-if=\"vm.app.environment === \'dev\'\" aria-label=\"action_refresh_content\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_refresh_content\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon white\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><div class=\"toolbar-tooltip\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.help\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.showHelp()\" aria-label=\"ASK FOR SUPPORT\" translate \ntranslate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon md-font-icon=\"icon-help-circle\" class=\"icon white\">\n</md-icon></md-button></a></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div class=\"md-primary-bg\" layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex>\n<md-button id=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"TOGGLE_NAVIGATION\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon white\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" \nshow-gt-sm hide-sm hide-xs><md-icon style=\"margin-left: 5px\" md-font-icon=\"icon-home\" \nclass=\"s16 black-fg cursor-pointer white-opacity\"></md-icon><md-icon style=\"margin-left: -2px\" \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon><a \nng-if=\"$root.titre2!==\'\' && $root.titre3===\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle\n</span> </a><span \nng-if=\"($root.titre2!==\'\' && $root.titre3!==\'\') || ($root.titre2===\'\' && $root.titre3===\'\') || ($root.titre2!==\'\' && $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre1}}\">media_menuTitle</span><md-icon ng-if=\"$root.titre2!==\'\'\" \nmd-font-icon=\"icon-chevron-right\" id=\"title2-icon-chevron-right\" class=\"s16 black-fg separator white-opacity\">\n</md-icon><a ng-if=\"$root.titre2!==\'\' && $root.titre3!==\'\' && $root.pageRoute!==\'\' \" style=\"margin-top: -2px\" href \nng-click=\"vm.goTo($root.pageRoute)\"><span class=\"parent white-opacity\" id=\"titre2\" translate=\"{{$root.titre2}}\">\nmedia_video_menuTitle</span> </a><span ng-if=\"$root.titre2!==\'\' && ($root.titre3===\'\' || $root.pageRoute===\'\')\" \nclass=\"parent white-opacity\" translate=\"{{$root.titre2}}\" id=\"titre2\">media_video_menuTitle</span><md-icon \nng-if=\"$root.titre3!==\'\'\" md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator white-opacity\"></md-icon>\n<span ng-if=\"$root.titre3!==\'\' \" id=\"titre3\" class=\"parent white-opacity\" translate=\"{{$root.titre3}}\">\nmedia_video_menuTitle</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar id=\"user-menu\">\n<md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"USER_SETTINGS\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \non-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon></div><span \nclass=\"username\" hide show-gt-sm>{{vm.getFullName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" \nhide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item has-permission=\"profiles_user_get_detail\" \nclass=\"md-indent\" ui-sref=\"app.profiles_user_profilconnected\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.my_profile\">My profile</md-button></md-menu-item><md-menu-divider \nhas-permission=\"profiles_user_get_detail\"></md-menu-divider><any has-permission=\"options_theme_key_no_api\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.goToConf()\" translate=\"MESSAGES.display_options\">Changer layout</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider></any><any has-permission=\"support_key_no_api\"><md-menu-item class=\"md-indent\" \nclass=\"md-indent\" ui-sref=\"app.support_key_list\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button \ntranslate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><any has-permission=\"support_documentation_no_api\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" \nmd-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span class=\"iso white\">\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"lang.title\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\" \nng-if=\"vm.app.environment === \'dev\'\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.refreshPageContent()\" \nng-if=\"vm.app.environment === \'dev\'\" aria-label=\"action refresh content\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_refresh_content\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon white\">\n</md-icon></md-button><div class=\"toolbar-separator\"></div><div class=\"toolbar-tooltip\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.help\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-if=\"$root.welcome!==\'\'\" id=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.showHelp()\" \naria-label=\"ASK FOR SUPPORT\" translate translate-attr-aria-label=\"TOOLBAR.ASK_FOR_SUPPORT\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"icon white\"></md-icon></md-button></a></div></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"TOGGLE MOBILE NAVIGATION\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_MOBILE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"logo-image\" ng-if=\"vm.logoToolbar.logo_image\">{{vm.logoToolbar.logo_image}}</span> <span class=\"logo-text\">\n{{vm.logoToolbar.logo_text}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-menu-bar \nid=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"USER SETTINGS\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \non-error-src=\"assets/images/no-image-custom.svg\" \nng-src=\"{{vm.user && vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><md-icon \nmd-font-icon style=\"color: #4CAF50\" class=\"icon status s16 icon-checkbox-marked-circle\"></md-icon></div><span \nclass=\"username\" hide-sm>{{vm.getFullName}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item has-permission=\"profiles_user_get_detail\" \nclass=\"md-indent\" ui-sref=\"app.profiles_user_profilconnected\"><md-icon md-font-icon=\"icon-account\" class=\"icon\">\n</md-icon><md-button translate=\"TOOLBAR.my_profile\">My profile</md-button></md-menu-item><md-menu-divider \nhas-permission=\"profiles_user_get_detail\"></md-menu-divider><any has-permission=\"options_theme_key_no_api\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.goToConf()\" translate=\"MESSAGES.display_options\">Changer layout</md-button></md-menu-item>\n<md-menu-divider></md-menu-divider></any><any has-permission=\"support_key_no_api\"><md-menu-item class=\"md-indent\" \nclass=\"md-indent\" ui-sref=\"app.support_key_list\"><md-icon md-font-icon=\"icon-key\" class=\"icon\"></md-icon><md-button \ntranslate=\"PAGESMENUSTITLES.key_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><any has-permission=\"support_documentation_no_api\"><md-menu-item \nclass=\"md-indent\"><md-icon md-font-icon=\"icon-file-document\" class=\"icon\"></md-icon><md-button \nhref=\"{{vm.url_documentation}}\" target=\"_blank\" style=\"color: inherit\" \ntranslate=\"PAGESMENUSTITLES.documentation_menuTitle\">Changer layout</md-button></md-menu-item><md-menu-divider \nstyle=\"display: block\"></md-menu-divider></any><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\" translate=\"TOOLBAR.logout\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" translate translate-attr-aria-label=\"TOOLBAR.language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><div ng-if=\"vm.selectedLanguage.flag==\'fr\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-fr\"></span></div><div flex><span>\n{{vm.selectedLanguage.code}}</span></div></div><div ng-if=\"vm.selectedLanguage.flag==\'us\'\" layout=\"row\" \nlayout-align=\"center\"><div flex><span class=\"translate-flag-en\"></span></div><div flex><span>\n{{vm.selectedLanguage.code}}</span></div></div></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.translation}}\"><span layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"lang.flag==\'fr\'\" class=\"translate-flag-menu-fr\"></span> <span \nng-if=\"lang.flag==\'us\'\" class=\"translate-flag-menu-en\"></span> <span translate=\"{{lang.translation}}\">{{lang.title}}\n</span></span></md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\" \nng-if=\"vm.app.environment === \'dev\'\"></div><md-button class=\"md-icon-button\" ng-click=\"vm.refreshPageContent()\" \nng-if=\"vm.app.environment === \'dev\'\" aria-label=\"Action refresh content\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_refresh_content\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/stats/acces/stat.acces.detail.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" \ndt-instance=\"vm.dtInstance\" class=\"row-border hover\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_model\">acces_session</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_user\">\nacces_ip</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSSTATSACCES.acces_function\">acces_user</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_date\">acces_date</span></div></th>\n</tr></thead></table></div></div></div>");
$templateCache.put("app/main/stats/acces/stat.acces.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nng-if=\"!vm.isNewAccessStatistics\" class=\"content-card fullpage\" layout=\"column\" flex><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"40\" layout=\"row\">\n<md-card-content flex ng-if=\"vm.empStatsAcces.users\"><md-select translate translate=\"MESSAGES.form_attr_themes\" \nng-model=\"vm.empStatsAcces.user\" ng-attr-name=\"users\" translate translate=\"TRANSSTATSACCES.select_username\" \nng-change=\"vm.FiltrechangeData()\" placeholder=\"{{ \'TRANSSTATSACCES.select_username\'|translate}}\"><md-option \nng-repeat=\"user in vm.empStatsAcces.users track by user.val\" ng-attr-data-index=\"{{$index}}\" ng-if=\"theme.val !== 0\" \nng-value=\"user.val\" ng-attr-translate=\"{{user.val==0 ? \'MESSAGES.user_none\':\'\'}}\">{{ user.option }}</md-option>\n</md-select></md-card-content></div><div class=\"date-filter-stats\"><label class=\"md-no-float date-label-stats\" \ntranslate=\"TRANSSTATSACCES.form_date\">form_date</label><md-datepicker ng-model=\"vm.empStatsAcces.date\" \nng-change=\"vm.FiltrechangeData()\" ng-attr-name=\"date\" md-min-date=\"vm.minDate\"></md-datepicker></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" dt-instance=\"vm.dtInstance\" class=\"row-border hover\"><thead><tr><th\n class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_session\">\nacces_session</span></div></th><th class=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TRANSSTATSACCES.acces_ip\">acces_ip</span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_user\">acces_user</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TRANSSTATSACCES.acces_date\">\nacces_date</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TRANSSTATSACCES.acces_list\">acces_list</span></div></th></tr></thead></table></div>\n</div><div ng-if=\"vm.isNewAccessStatistics\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div style=\"overflow: hidden; height: 900px\" \nlayout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" ng-src=\"{{vm.newAccessStatsIframe}}\" allowfullscreen \nframeborder=\"0\" style=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/stats/bandePassante/stat.bande.passante.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px; position: relative\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden; height: 100%; position: absolute; width: 100%\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_stat_bandpassant\" src=\"{{vm.newBandPassant}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/stats/event/event.template.html","<div ng-if=\"vm.eventsStatsIframe\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe title=\"eventStat\" \nid=\"iframe_segment_display\" ng-src=\"{{vm.eventsStatsIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/list-podcasts/list_podcasts.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" layout=\"column\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.newStatListIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/list-videos/list_videos.template.html","<div id=\"e-commerce-products\" ng-if=\"!vm.isNewListStat\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex><div layout=\"row\" layout-align=\"start center\" style=\"width: 100%\"><div \nstyle=\"width: 20%; margin-left:8px ;margin-top:0px;margin-bottom: 17px\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"videos-ssearch\" type=\"text\" style=\"padding-left: 15px\" placeholder=\"{{ \'MESSAGES.keywords\' | translate }}\" \nng-model=\"vm.word\" ng-keydown=\"$event.keyCode === 13 && vm.searchVideos()\"></md-input-container></div><div \nstyle=\"width: 15%;margin: 0 15px\"><md-card-content class=\"md-block\" flex-gt-xs><md-select ng-model=\"vm.filter\" \nng-change=\"vm.searchVideos(\'access\',vm.filter)\"><md-option style=\"color:#000;font-weight:bold\" disabled=\"true\" \nvalue=\"\" translate=\"VISITSMESURESTATS.form_attr_filter\"></md-option><md-option ng-repeat=\"filter in vm.filters \" \nng-value=\"filter.value\">{{filter.value}}</md-option></md-select></md-card-content></div><div style=\"width: 25%\"><div \nflex-gt-sm><label class=\"md-no-float\" translate=\"MESSAGES.start_date\"></label><md-datepicker ng-model=\"vm.startDate\" \nng-change=\"vm.searchVideos(\'access\',vm.filter)\" md-placeholder=\"Date\" md-max-date=\"vm.endDate\"></md-datepicker></div>\n</div><div style=\"width: 25%\"><div flex-gt-sm><label class=\"md-no-float\" translate=\"MESSAGES.end_date\"></label>\n<md-datepicker ng-model=\"vm.endDate\" ng-change=\"vm.searchVideos(\'access\',vm.filter)\" md-placeholder=\"Date\" \nmd-min-date=\"vm.startDate\"></md-datepicker></div></div><div style=\"width: 15%;margin-right: 5px\"><ms-channels \nng-model=\"vm.canal\" ng-change=\"vm.searchVideos(\'canal\',someModelChannel)\"></ms-channels></div><div \nstyle=\"width: 15%;margin-right: 5px\"><ms-themes theme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" \nmulti=\"false\" ng-change=\"vm.searchVideos(\'theme\',someModel)\"></ms-themes></div><div \nstyle=\"width: 20%;text-align: center\"><md-button aria-label=\"menu\" ng-click=\"vm.exportExcel()\"><md-icon \nstyle=\"font-size: 22px;margin-top: -4px;color: #039be5\" md-font-icon=\"icon-file-excel\"></md-icon><span \nstyle=\"color: #039be5\">Export Excel</span></md-button></div></div></div></div><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" ng-if=\"vm.isGV\" flex><table \nalign=\"center\" id=\"tableVod\" class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" style=\"padding-right: 0px\"><thead><tr><th class=\"secondary-text\" \ndata-priority=\"2\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.form_attr_title\">form_attr_title</span></div></th><th class=\"secondary-text\" data-priority=\"8\"><div\n class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"{{\'MESSAGES.rubric\' }}\">\nform_attr_themes</span></div></th><th class=\"secondary-text\" data-priority=\"8\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"MESSAGES.thematic\">form_attr_themes</span></div></th><th \nclass=\"secondary-text\" data-priority=\"8\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\">\nCanal</span></div></th><th class=\"secondary-text\" data-priority=\"9\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" data-ng-bind-html=\"vm.trustedHtml(\'seen_total\')\">seen_total</span></div></th><th \nclass=\"secondary-text\" data-priority=\"10\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\">\nVisites uniques</span></div></th><th class=\"secondary-text\" data-priority=\"11\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\">Date</span></div></th><th class=\"secondary-text\" data-priority=\"12\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"{{\'MESSAGES.meta_data_duration\'}}\">\nDurée</span></div></th></tr></thead></table></div><div class=\"content fullpage-datatable\" layout=\"column\" \nng-if=\"!vm.isGV\" flex><table align=\"center\" id=\"tableVod\" class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\" style=\"padding-right: 0px\"><thead><tr>\n<th class=\"secondary-text\" data-priority=\"2\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.form_attr_title\">form_attr_title</span></div></th><th \nclass=\"secondary-text\" data-priority=\"8\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"{{\'MESSAGES.form_attr_themes\'}}\">form_attr_themes</span></div></th><th class=\"secondary-text\" \ndata-priority=\"8\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\">Canal</span></div></th>\n<th class=\"secondary-text\" data-priority=\"9\"><div class=\"table-header centerdiiv th-sort\"><span \nclass=\"column-title center-span\" data-ng-bind-html=\"vm.trustedHtml(\'seen_total\')\">seen_total</span><div><md-icon \nmd-font-icon=\"icon-arrow-up\" ng-click=\"vm.sortData(\'nbVisits\',1)\" class=\"sort-icon\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" ng-click=\"vm.sortData(\'nbVisits\',-1)\" class=\"sort-icon\"></md-icon></div></div></th><th \nclass=\"secondary-text\" data-priority=\"10\"><div class=\"table-header centerdiiv th-sort\"><span \nclass=\"column-title center-span\">Visites uniques</span><div><md-icon md-font-icon=\"icon-arrow-up\" \nng-click=\"vm.sortData(\'nbUniqueVisits\',1)\" class=\"sort-icon\"></md-icon><md-icon md-font-icon=\"icon-arrow-down\" \nng-click=\"vm.sortData(\'nbUniqueVisits\',-1)\" class=\"sort-icon\"></md-icon></div></div></th><th class=\"secondary-text\" \ndata-priority=\"11\"><div class=\"table-header centerdiiv th-sort\"><span class=\"column-title center-span\">Date</span><div>\n<md-icon md-font-icon=\"icon-arrow-up\" ng-click=\"vm.sortData(\'startDate\',1)\" class=\"sort-icon\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" ng-click=\"vm.sortData(\'startDate\',-1)\" class=\"sort-icon\"></md-icon></div></div></th><th \nclass=\"secondary-text\" data-priority=\"12\"><div class=\"table-header centerdiiv th-sort\"><span \nclass=\"column-title center-span\" translate=\"{{\'MESSAGES.meta_data_duration\'}}\">Durée</span><div><md-icon \nmd-font-icon=\"icon-arrow-up\" ng-click=\"vm.sortData(\'duration\',1)\" class=\"sort-icon\"></md-icon><md-icon \nmd-font-icon=\"icon-arrow-down\" ng-click=\"vm.sortData(\'duration\',-1)\" class=\"sort-icon\"></md-icon></div></div></th></tr>\n</thead></table></div></div></div></div><div ng-if=\"vm.isNewListStat\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth full-height\" layout=\"column\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap>\n<iframe id=\"iframe_segment_display\" ng-src=\"{{vm.newStatListIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/dashboard/stats.dashboard.html","<div ng-if=\"!vm.isNewStats\" id=\"dashboard\" class=\"page-layout simple fullwidth content-dashboard-stats\" \nlayout=\"column\"><div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"column\" ng-class=\"vm.isFM\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" \nflex-order-xs=\"2\"></div><div class=\"header-board-name\" layout=\"row\" layout-align=\" center center\"><div \nng-if=\"vm.hasPermissionCalendar\" class=\"div-calendar\"><md-button class=\"md-icon-button btn-delete\" \nng-click=\"vm.showCalendar()\" aria-label=\"show_calendar\" translate translate-attr-aria-label=\"EVENTLIST.show_calendar\">\n<md-icon md-font-icon=\"icon-calendar-today\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-today\" id=\"id-icon-calendar\" aria-hidden=\"true\">\n</md-icon></md-button><span translate=\"MESSAGES.calendar\" id=\"calandarSpan\" style=\"cursor: pointer\" \nng-click=\"vm.showCalendar()\">Calendar</span></div><div ng-if=\"!vm.hasPermissionCalendar\"><md-icon \nmd-font-icon=\"icon-chart-bar\" style=\"color: white;margin: 10px !important\"></md-icon><span \ntranslate=\"DASHBOARD.dashboard_title\">dashboard_title</span></div></div><md-card ng-if=\"vm.showCalendarRange\" \nid=\"id-calendar-range\" class=\"calendar-range\" style=\"height:auto !important\"><md-card-header><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div>Période</div><div layout=\"row\" layout-align=\"end center\" flex><span \nstyle=\"cursor: pointer\" ng-click=\"vm.initDate()\">Rénialiser</span><div class=\"startDate\" \nng-class=\"{\'change-date\':vm.changedDate===\'start\'}\"><md-icon md-font-icon=\"icon-calendar-today\" class=\"s24 separator\" \naria-hidden=\"true\"></md-icon><span>{{vm.startDate | date:shortDate}}</span><md-button class=\"md-fab md-mini\" \naria-label=\"chevron left\" ng-click=\"vm.previewDate(\'start\')\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"s16 separator\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"chevron right\" \nng-click=\"vm.nextDate(\'start\')\"><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon></md-button>\n</div><div class=\"endDate\" ng-class=\"{\'change-date\':vm.changedDate===\'end\'}\"><md-icon \nmd-font-icon=\"icon-calendar-today\" class=\"s24 separator\" aria-hidden=\"true\"></md-icon><span>\n{{vm.endDate | date:shortDate}}</span><md-button class=\"md-fab md-mini\" aria-label=\"chevron left\" \nng-click=\"vm.previewDate(\'end\')\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"s16 separator\"></md-icon></md-button>\n<md-button class=\"md-fab md-mini\" aria-label=\"chevron right\" ng-click=\"vm.nextDate(\'end\')\"><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon></md-button></div></div></div></md-card-header>\n<md-card-content><div layout=\"column\" layout-gt-sm=\"row\" ng-cloak><md-date-range-picker first-day-of-week=\"1\" \nselected-template=\"\'Today\'\" show-template=\"false\" date-start=\"vm.startDate\" date-end=\"vm.endDate\">\n</md-date-range-picker></div></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"confirm_date\" ng-click=\"vm.confirmDate()\">Confirmer</md-button>\n</md-card-actions></md-card><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\" flex-order=\"3\" \ntooltip-side=\"left\"><a tooltips tooltip-template=\"{{\'DASHBOARD.dashboard_filter\'|translate}}\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filter-sidenav\')\" aria-label=\"Calendar\" translate \ntranslate-attr-aria-label=\"Calander\"><md-icon style=\"color: white\" md-font-icon=\"icon-filter\"></md-icon></md-button>\n</a></div></div></div><md-content flex layout=\"column\" class=\"container\" ms-scroll><div class=\"floatleft\" layout=\"row\">\n<div ui-sortable=\"vm.sortableOptions\" class=\"apps-container screen floatleft\" layout=\"column\" flex=\"50\" \nng-model=\"vm.left\"><md-card ng-repeat=\"element in vm.left\" ng-if=\"element.showed\" \nhas-permission=\"{{element.permission}}\"><md-card-header style=\"position: relative;padding: 5px; cursor:all-scroll\">\n<md-icon style=\"position: absolute;margin-left:4px;margin-top: 6px\" class=\"s28\" md-font-icon=\"icon-drag\"></md-icon>\n<md-button style=\"position: absolute;right: 0\" class=\"md-icon-button\" ng-click=\"vm.showHelp(element.id)\" \naria-label=\"help\"><md-icon md-font-icon=\"icon-help-circle\" class=\"s18\"></md-icon></md-button></md-card-header>\n<md-card-content data-ng-bind-html=\"vm.trustedHtml(element.html)\" compile-template></md-card-content></md-card></div>\n<div ui-sortable=\"vm.sortableOptions\" class=\"apps-container screen floatleft\" layout=\"column\" flex=\"50\" \nng-model=\"vm.right\"><md-card ng-repeat=\"element in vm.right\" ng-if=\"element.showed\" \nhas-permission=\"{{element.permission}}\"><md-card-header style=\"position: relative;padding: 5px; cursor:all-scroll\">\n<md-icon style=\"position: absolute;margin-left:4px;margin-top: 6px\" class=\"s28\" md-font-icon=\"icon-drag\"></md-icon>\n<md-button style=\"position: absolute;right: 0\" class=\"md-icon-button\" ng-click=\"vm.showHelp(element.id)\" \naria-label=\"help\"><md-icon md-font-icon=\"icon-help-circle\" class=\"s18\"></md-icon></md-button></md-card-header>\n<md-card-content data-ng-bind-html=\"vm.trustedHtml(element.html)\" compile-template></md-card-content></md-card></div>\n</div></md-content><md-sidenav class=\"settings-sidenav md-sidenav-right\" md-component-id=\"filter-sidenav\" \nms-sidenav-helper><md-toolbar class=\"header md-accent\"><div layout=\"row\" layout-align=\"space-between center\"><h1 \nclass=\"md-toolbar-tools\" translate=\"DASHBOARD.dashboard_filter\">dashboard_filter</h1><md-button class=\"md-icon-button\" \naria-label=\"Close\" ng-click=\"vm.toggleSidenav(\'filter-sidenav\')\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-content layout-margin><h4>{{\'DASHBOARD.dashboard_date_start\'|translate}}</h4>\n<md-datepicker ng-model=\"vm.dateIn\" ng-change=\"vm.changeDateIn()\" md-placeholder=\"Date in\"></md-datepicker><h4>\n{{\'DASHBOARD.dashboard_date_end\'|translate}}</h4><md-datepicker ng-model=\"vm.dateOut\" ng-change=\"vm.changeDateOut()\" \nmd-placeholder=\"Date out\"></md-datepicker><div has-permission=\"stats_filter_canal\"><h4 style=\"margin:0\">\n{{\'DASHBOARD.dashboard_canal_list\'|translate}}</h4><ms-channels ng-model=\"vm.canal\" \nng-change=\"vm.themeListByChannel(\'canal\',someModelChannel)\"></ms-channels></div><div \nhas-permission=\"stats_filter_theme\"><h4 style=\"margin:0\">{{\'DASHBOARD.dashboard_theme_list\'|translate}}</h4><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.changeTheme(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div><div \nhas-permission=\"stats_filter_groups\" ng-if=\"vm.groups.length>0\"><h4 style=\"margin:0\">\n{{\'DASHBOARD.dashboard_group_list\'|translate}}</h4><md-card-content flex><md-select ng-model=\"vm.groups_query\" \nng-attr-name=\"groups\" translate translate=\"SEARCHSTATS.form_attr_groups\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_groups\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_groups\'|translate}}\" style=\"margin: 0px\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.uid\" \nng-attr-translate=\"{{ group.option==\'none\' ? \'MESSAGES.none\':\'\' }}\">{{ group.name }}</md-option></md-select>\n</md-card-content></div><div style=\"border-top:1px solid #ced4da\"><h4>{{\'DASHBOARD.dashboard_chart\'|translate}}</h4>\n</div><div class=\"demo-select-all-checkboxes\" flex=\"100\" \nng-repeat=\"item in vm.htmlContents | orderBy : \'+name\'  | filter:vm.searchGraph\"><md-checkbox \nhas-permission=\"{{item.permission}}\" ng-checked=\"item.showed\" ng-click=\"vm.toggle(item)\">{{ item.name | translate }}\n</md-checkbox></div><div layout-align=\"center end\" layout=\"row\"><md-button \nng-click=\"vm.restoreFilter(\'filter-sidenav\')\" class=\"restored-btn\">{{\'DASHBOARD.dashboard_reset\'|translate}}\n</md-button><md-button ng-click=\"vm.toggleLeft(\'filter-sidenav\')\" class=\"md-raised md-primary md-accent\">\n{{\'DASHBOARD.dashboard_filter\'|translate}}</md-button></div></md-content></md-sidenav></div></div><iframe \nng-if=\"vm.isNewStats\" style=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" allow-scripts \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{StatFrame}}\"></iframe>");
$templateCache.put("app/main/stats/podcast/stat.vod.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div id=\"e-commerce-products\" class=\"stat_content content page-layout simple fullwidth\" layout=\"column\"><md-tabs \nmd-dynamic-height md-selected=\"vm.md_selected_index\"><a-transclusion-directive><md-tab \nng-repeat=\"tab_value in vm.tabs_title \" ng-if=\"tab_value.permission===true\" ui-sref=\"{{ tab_value.ui_sref }}\" \nlabel=\"{{ tab_value.title |translate}}\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\"><div flex=\"100\" layout=\"row\"><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" \nng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\"></label>\n<md-datepicker ng-model=\"vm.currentDateIn\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker></div><div \nflex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\">Date fin</label><md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate()\" \nng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\"></md-datepicker></div><div layout=\"column\" \nng-if=\"vm.isHiddenFilter(tab_value,\'theme\')\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.changeQuery(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" ng-if=\"vm.isHiddenFilter(tab_value,\'type\')\">\n<md-card-content flex><md-select ng-model=\"vm.types_query\" ng-attr-name=\"types\" translate \ntranslate=\"SEARCHSTATS.form_attr_types\" translate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" \nng-change=\"vm.changeQuery()\" placeholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\"><md-option \nng-repeat=\"type in types\" ng-value=\"type.val!=0 ? type.val : \'\'\" \nng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">{{ type.option }}</md-option></md-select>\n</md-card-content></div></div></md-card-content></md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab>\n</a-transclusion-directive></md-tabs></div></div></div>");
$templateCache.put("app/main/stats/podcast/stat.vod_by_id.html","<div ng-if=\"!vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div id=\"e-commerce-products\" class=\"content page-layout simple fullwidth\" \nlayout=\"column\"><md-card has-permission=\"stats_export_export_no_api\" ng-if=\"vm.urlExport\" \nstyle=\"justify-content: center;height: 80px\"><div style=\"text-align: center\" layout=\"row\"><div flex=\"20\"><span \nstyle=\"font-size: 20px\" translate=\"EXPORT.export_url\">Exporter l\'url des statistiques</span></div><div \nstyle=\"margin-top: 7px\" flex=\"80\" layout=\"row\"><div id=\"fo28\">{{vm.urlExport}}</div><md-button \nstyle=\"margin-top: -10px\" class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo28\" aria-label=\"url_copy\" \nng-click=\"vm.copied =55\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===55}\"></md-icon></md-button></div></div></md-card><md-tabs md-dynamic-height \nmd-selected=\"vm.md_selected_index\"><md-tab ng-repeat=\"tab_value in vm.tabs_title\" ui-sref=\"{{ tab_value.ui_sref }}\" \nlabel=\"{{ tab_value.title |translate}}\"><md-card style=\"height: 96px\"><md-card-title \nstyle=\"padding: 5px 16px;max-height: 42px\"><md-card-title-text><span class=\"md-headline\">\n{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\" style=\"padding: 4px 16px 8px 16px;max-height: 42px\"><div class=\"pb-32\" flex=\"100\" \nlayout=\"row\"><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.start_date\"></label><md-datepicker ng-model=\"vm.currentDateIn\" \nng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker></div><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\" \nng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\">Date fin</label><md-datepicker \nng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\">\n</md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.isHiddenFilter(tab_value,\'type\') && types.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex><md-select ng-model=\"vm.types_query\" \nng-attr-name=\"types\" translate translate=\"SEARCHSTATS.form_attr_types\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\" style=\"margin: 0px\"><md-option ng-repeat=\"type in types\" \nng-value=\"type.val!=0 ? type.val : \'\' \" ng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">\n{{ type.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" \nhas-permission=\"stats_filter_groups\" ng-if=\"vm.groups.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding:0\" flex><md-select ng-model=\"vm.groups_query\" \nng-attr-name=\"groups\" translate translate=\"SEARCHSTATS.form_attr_groups\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_groups\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_groups\'|translate}}\" style=\"margin: 0px\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.uid\" \nng-attr-translate=\"{{ group.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">{{ group.name }}</md-option></md-select>\n</md-card-content></div></div></md-card-content></md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab>\n</md-tabs></div></div></div><div ng-if=\"vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><iframe style=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{PodcaststatByIdFrame}}\"></iframe></div>");
$templateCache.put("app/main/stats/p2p/p2p.template.html","<div ng-if=\"vm.p2pStatsIframe\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe title=\"p2pStat\" \nid=\"iframe_segment_display\" ng-src=\"{{vm.p2pStatsIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/podcasts/podcasts.template.html","<div ng-if=\"vm.podcastsStatsIframe\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe title=\"podcastStat\" \nid=\"iframe_segment_display\" ng-src=\"{{vm.podcastsStatsIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/storage/stat.storage.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px; position: relative\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden; height: 100%; position: absolute; width: 100%\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_stat_stockage\" src=\"{{vm.newStatStockage}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/stats/mooc/stats.mooc.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\"><md-tabs md-dynamic-height md-selected=\"vm.md_selected_index\"><a-transclusion-directive><md-tab \nng-repeat=\"tab_value in vm.tabs_title_mooc\" has-permission=\"stats_mooc_{{tab_value.ui_view}}_no_api\" \nui-sref=\"{{ tab_value.ui_sref }}\" label=\"{{ tab_value.title |translate}}\"><md-card><md-card-title><md-card-title-text>\n<span class=\"md-headline\">{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content\n layout-align=\"space-between\"><div flex=\"100\" layout=\"row\"><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.start_date\"></label><md-datepicker ng-model=\"vm.currentDateIn\" \nng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker></div><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<label class=\"md-no-float\" translate=\"MESSAGES.end_date\">Date fin</label><md-datepicker ng-model=\"vm.currentDateOut\" \nng-change=\"vm.changeDate()\" ng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\"></md-datepicker></div><div flex=\"100\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"></div><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"></div><div \nstyle=\"text-align: center;margin-top: -25px\" ng-if=\"tab_value.ui_view===\'voyage\'\" layout-align=\"end center\" flex=\"100\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\"><md-button aria-label=\"menu\" ng-click=\"vm.exportcsv()\"><md-icon \nstyle=\"font-size: 22px;margin-top: -4px;color: #039be5\" md-font-icon=\"icon-file-excel\"></md-icon><span \nstyle=\"color: #039be5\" translate=\"MESSAGES.download_csv\">Export csv</span></md-button></div></div></md-card-content>\n</md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab></a-transclusion-directive></md-tabs></div></div></div>");
$templateCache.put("app/main/stats/mooc/stats.mooc.theme.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\"><div layout=\"row\"><md-card style=\"background-color: #ffffff;width: 7%;height: 60px\">\n<md-card-content layout-align=\"space-between\"><md-button ng-if=\"$root.pageRetour\" \nstyle=\"color: #000; font-weight: bold; position: absolute;display: flex; left:0  ;height: 60px; width: 7%; top:0\" \nclass=\"md-warn\" ui-sref=\"{{$root.pageRetour}}\"><md-icon style=\"color: #000; position: absolute; left:20px\" \nmd-font-icon=\"icon-chevron-left\" class=\"s24\"></md-icon><span translate=\"MESSAGES.form_retour\" \nstyle=\"position: absolute; left:40px\"></span></md-button><md-button ng-if=\"!$root.pageRetour\" \nstyle=\"color: #000; font-weight: bold; position: absolute;display: flex; left:0  ;height: 60px; width: 7%; top:0\" \nclass=\"md-warn\" ui-sref=\"app.stats_mooc.course\"><md-icon style=\"color: #000; position: absolute; left:20px\" \nmd-font-icon=\"icon-chevron-left\" class=\"s24\"></md-icon><span translate=\"MESSAGES.form_retour\" \nstyle=\"position: absolute; left:40px\"></span></md-button></md-card-content></md-card><md-card \nstyle=\"width: 93%;height: 60px\"><md-card-content layout-align=\"space-between\"><div flex=\"100\" layout=\"row\" \nstyle=\"margin-left: 2%\"><span class=\"md-headline\">{{ \"MESSAGES.search\" |translate}}</span><div flex=\"100\" \nflex-gt-xs=\"20\" flex-gt-md=\"20\" style=\"margin-left: 100px\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">\n</label><md-datepicker ng-model=\"vm.currentDateIn\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker>\n</div><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><label class=\"md-no-float\" translate=\"MESSAGES.end_date\">Date fin\n</label><md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\" \nmd-min-date=\"vm.currentDateIn\"></md-datepicker></div></div></md-card-content></md-card></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><mesure-mooc-stats has-permission=\"stats_mooc_mooc_total_number_registrations\" \ntype=\"total_registrations\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n</mesure-mooc-stats><mesure-mooc-stats has-permission=\"stats_mooc_mooc_number_on_going_registrations\" \ntype=\"ongoing_registrations\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n</mesure-mooc-stats></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_number_active_learners\" type=\"actif_learners\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_watching_videos_learners\" type=\"video_watcher\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_number_learners_tried_problem\" type=\"problem_tester\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats></div><md-card \nhas-permission=\"stats_mooc_participation_of_learners\"><div style=\"padding-left: 24px;height: 60px\" \nclass=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{ \"STATSTITLE.participation_learners_theme\" |translate }}</div></div><mooc-stats \nhas-permission=\"stats_mooc_participation_of_learners\" query=\"vm.query\"></mooc-stats></md-card></div><md-card><div \nstyle=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{ \"STATSTITLE.nbr_correct_incorrect_response\" |translate }}</div></div><quiz-by-theme query=\"vm.query\">\n</quiz-by-theme></md-card></div></div>");
$templateCache.put("app/main/stats/vod_live/event_by_id.template.html","<div ng-if=\"vm.eventsStatsIframe\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe title=\"eventStat\" \nid=\"iframe_segment_display\" ng-src=\"{{vm.eventsStatsIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/stats/vod_live/stat.live_by_id.html","<div ng-if=\"!vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div id=\"e-commerce-products\" class=\"content page-layout simple fullwidth\" \nlayout=\"column\"><md-card has-permission=\"stats_export_export_no_api\" ng-if=\"vm.urlExport\" \nstyle=\"justify-content: center;height: 80px\"><div style=\"text-align: center\" layout=\"row\"><div flex=\"20\"><span \nstyle=\"font-size: 20px\" translate=\"EXPORT.export_url\">Exporter l\'url des statistiques</span></div><div \nstyle=\"margin-top: 7px\" flex=\"80\" layout=\"row\"><div id=\"fo28\">{{vm.urlExport}}</div><md-button \nstyle=\"margin-top: -10px\" class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo28\" aria-label=\"url_copy\" \nng-click=\"vm.copied =55\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===55}\"></md-icon></md-button></div></div></md-card><md-tabs md-dynamic-height \nmd-selected=\"vm.md_selected_index\"><md-tab ng-repeat=\"tab_value in vm.tabs_title\" ui-sref=\"{{ tab_value.ui_sref }}\" \nlabel=\"{{ tab_value.title |translate}}\" ng-if=\"tab_value.permission==true\"><md-card style=\"height: 96px\"><md-card-title\n style=\"padding: 5px 16px;max-height: 42px\"><md-card-title-text><span class=\"md-headline\">\n{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\" style=\"padding: 4px 16px 8px 16px;max-height: 42px\"><div class=\"pb-32\" flex=\"100\" \nlayout=\"row\"><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"30\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex>\n<md-select ng-model=\"vm.filter\" ng-change=\"vm.changeDate(\'\',vm.filter)\"><md-option style=\"color:#000;font-weight:bold\" \ndisabled=\"true\" value=\"\" translate=\"VISITSMESURESTATS.form_attr_filter\"></md-option><md-option \nng-repeat=\"filter in vm.filters \" ng-value=\"filter.value\">{{filter.value}}</md-option></md-select></md-card-content>\n</div><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.start_date\">Date debut</label><md-datepicker ng-model=\"vm.currentDateIn\" \nng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\"></md-datepicker></div><div flex=\"100\" flex-gt-xs=\"35\" \nflex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\">Date fin</label>\n<md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\" \nmd-min-date=\"vm.currentDateIn\"></md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.isHiddenFilter(tab_value,\'type\') && types.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex><md-select ng-model=\"vm.types_query\" \nng-attr-name=\"types\" translate translate=\"SEARCHSTATS.form_attr_types\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\" style=\"margin: 0px\"><md-option ng-repeat=\"type in types\" \nng-value=\"type.val!=0 ? type.val : \'\' \" ng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">\n{{ type.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" \nhas-permission=\"stats_filter_groups\" ng-if=\"vm.groups.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding:0\" flex><md-select ng-model=\"vm.groups_query\" \nng-attr-name=\"groups\" translate translate=\"SEARCHSTATS.form_attr_groups\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_groups\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_groups\'|translate}}\" style=\"margin: 0px\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.uid\" \nng-attr-translate=\"{{ group.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">{{ group.name }}</md-option></md-select>\n</md-card-content></div></div></md-card-content></md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab>\n</md-tabs></div></div></div><div ng-if=\"vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><iframe style=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{statLiveByIdFrame}}\"></iframe></div>");
$templateCache.put("app/main/stats/vod_live/stat.videos.html","<div ng-if=\"vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><iframe \nstyle=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{detailFrame}}\"></iframe></div>");
$templateCache.put("app/main/stats/vod_live/stat.vod.html","<div ng-if=\"!vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div id=\"e-commerce-products\" class=\"stat_content content page-layout simple fullwidth\" \nlayout=\"column\"><md-tabs md-dynamic-height md-selected=\"vm.md_selected_index\"><a-transclusion-directive><md-tab \nng-repeat=\"tab_value in vm.tabs_title \" ng-if=\"tab_value.permission==true\" ui-sref=\"{{ tab_value.ui_sref }}\" \nlabel=\"{{ tab_value.title |translate}}\"><md-card><md-card-title><md-card-title-text><span class=\"md-headline\">\n{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\"><div flex=\"100\" layout=\"row\"><div ng-if=\"vm.typeStatsFilter===\'vod\'\" \nstyle=\"width: 20%;margin-right: 15px\"><md-card-content class=\"md-block\" flex-gt-xs><md-select ng-model=\"vm.filter\" \nng-change=\"vm.changeDate(\'\',vm.filter)\"><md-option style=\"color:#000;font-weight:bold\" disabled=\"true\" value=\"\" \ntranslate=\"VISITSMESURESTATS.form_attr_filter\"></md-option><md-option ng-repeat=\"filter in vm.filters \" \nng-value=\"filter.value\">{{filter.value}}</md-option></md-select></md-card-content></div><div flex=\"100\" \nflex-gt-xs=\"30\" flex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.start_date\"></label><md-datepicker ng-model=\"vm.currentDateIn\" \nng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\"></md-datepicker></div><div flex=\"100\" flex-gt-xs=\"30\" \nflex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\">Date fin</label><md-datepicker ng-model=\"vm.currentDateOut\" \nng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\"></md-datepicker></div><div \nlayout=\"column\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><ms-channels ng-model=\"vm.canal\" \nng-if=\"vm.isHiddenFilter(tab_value,\'canal\')\" style=\"width: 100%\" \nng-change=\"vm.changeQuery(\'accessCanal\',someModelChannel)\"></ms-channels></div><div layout=\"column\" \nng-if=\"vm.isHiddenFilter(tab_value,\'theme\')\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.changeQuery(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div><div layout=\"column\" \nlayout-gt-xs=\"row\" has-permission=\"stats_filter_groups\" ng-if=\"vm.groups.length>0\" flex=\"100\" flex-gt-xs=\"30\" \nflex-gt-md=\"30\" style=\"max-height: 42px\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex><md-select \nng-model=\"vm.groups_query\" ng-attr-name=\"groups\" translate translate=\"SEARCHSTATS.form_attr_groups\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_groups\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_groups\'|translate}}\" style=\"margin: 0px\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.uid\" \nng-attr-translate=\"{{ group.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">{{ group.name }}</md-option></md-select>\n</md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"types.length\" flex=\"100\" flex-gt-xs=\"20\" \nflex-gt-md=\"20\" ng-if=\"vm.isHiddenFilter(tab_value,\'type\')\"><md-card-content flex><md-select ng-model=\"vm.types_query\" \nng-attr-name=\"types\" translate translate=\"SEARCHSTATS.form_attr_types\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\"><md-option ng-repeat=\"type in types\" \nng-value=\"type.val!=0 ? type.val : \'\' \" ng-attr-translate=\"{{  type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">\n{{ type.option }}</md-option></md-select></md-card-content></div></div></md-card-content></md-card><div \nui-view=\"{{ tab_value.ui_view }}\"></div></md-tab></a-transclusion-directive></md-tabs></div></div></div><div \nng-if=\"vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><iframe \nstyle=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{detailFrameDirect}}\"></iframe></div>");
$templateCache.put("app/main/stats/vod_live/stat.vod_by_id.html","<div ng-if=\"!vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div id=\"e-commerce-products\" class=\"content page-layout simple fullwidth\" \nlayout=\"column\"><md-card has-permission=\"stats_export_export_no_api\" ng-if=\"vm.urlExport\" \nstyle=\"justify-content: center;height: 80px\"><div style=\"text-align: center\" layout=\"row\"><div flex=\"20\"><span \nstyle=\"font-size: 20px\" translate=\"EXPORT.export_url\">Exporter l\'url des statistiques</span></div><div \nstyle=\"margin-top: 7px\" flex=\"80\" layout=\"row\"><div id=\"fo28\">{{vm.urlExport}}</div><md-button \nstyle=\"margin-top: -10px\" class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo28\" aria-label=\"url_copy\" \nng-click=\"vm.copied =55\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===55}\"></md-icon></md-button></div></div></md-card><md-tabs md-dynamic-height \nmd-selected=\"vm.md_selected_index\"><md-tab ng-repeat=\"tab_value in vm.tabs_title\" ui-sref=\"{{ tab_value.ui_sref }}\" \nlabel=\"{{ tab_value.title |translate}}\" ng-if=\"tab_value.permission==true\"><md-card style=\"height: 96px\"><md-card-title\n style=\"padding: 5px 16px;max-height: 42px\"><md-card-title-text><span class=\"md-headline\">\n{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\" style=\"padding: 4px 16px 8px 16px;max-height: 42px\"><div class=\"pb-32\" flex=\"100\" \nlayout=\"row\"><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"30\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex>\n<md-select ng-model=\"vm.filter\" ng-change=\"vm.changeDate(\'\',vm.filter)\"><md-option style=\"color:#000;font-weight:bold\" \ndisabled=\"true\" value=\"\" translate=\"VISITSMESURESTATS.form_attr_filter\"></md-option><md-option \nng-repeat=\"filter in vm.filters \" ng-value=\"filter.value\">{{filter.value}}</md-option></md-select></md-card-content>\n</div><div flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.start_date\">Date debut</label><md-datepicker ng-model=\"vm.currentDateIn\" \nng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\"></md-datepicker></div><div flex=\"100\" flex-gt-xs=\"35\" \nflex-gt-md=\"30\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\">Date fin</label>\n<md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate(\'\',vm.filter)\" ng-attr-name=\"date\" \nmd-min-date=\"vm.currentDateIn\"></md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.isHiddenFilter(tab_value,\'type\') && types.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding: 4px 16px 8px 16px\" flex><md-select ng-model=\"vm.types_query\" \nng-attr-name=\"types\" translate translate=\"SEARCHSTATS.form_attr_types\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\" style=\"margin: 0px\"><md-option ng-repeat=\"type in types\" \nng-value=\"type.val!=0 ? type.val : \'\' \" ng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">\n{{ type.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" \nhas-permission=\"stats_filter_groups\" ng-if=\"vm.groups.length\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\" \nstyle=\"max-height: 42px\"><md-card-content style=\"padding:0\" flex><md-select ng-model=\"vm.groups_query\" \nng-attr-name=\"groups\" translate translate=\"SEARCHSTATS.form_attr_groups\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_groups\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_groups\'|translate}}\" style=\"margin: 0px\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"group in vm.groups\" ng-value=\"group.uid\" \nng-attr-translate=\"{{ group.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">{{ group.name }}</md-option></md-select>\n</md-card-content></div></div></md-card-content></md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab>\n</md-tabs></div></div></div><div ng-if=\"vm.isNewStats\" id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" \nlayout=\"row\"><iframe style=\"position: absolute;top: 0;left: 0;width: 100%;height: 100%\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen autoplay \ndata-type=\"video\" src=\"{{statByIdFrame}}\"></iframe></div>");
$templateCache.put("app/main/stats/users/users.template.html","<div ng-if=\"vm.usersStatsIframe\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.usersStatsIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div layout=\"row\" layout-align=\"space-between  center\" flex ng-class=\"{\'menu-align\': vm.isNavigationNew }\"><div \nlayout=\"row\" layout-align=\"flex-start center\" flex ng-class=\"{\'menu-buttons\': vm.isNavigationNew}\"><div \nclass=\"navigation-toggle\" hide-gt-sm hide-gt-xs hide-xs><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleHorizontalMobileMenu()\" aria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\">\n</md-icon></md-button></div><ul class=\"horizontal\" ng-class=\"{\'menu-align\': vm.isNavigationNew }\"><li \nng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed,\'has-children\': node.children.length > 0, \'right\': node.position===\'right\'}\" \nng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script type=\"text/ng-template\" \nid=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\">\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive || vm.pathActive===node.title.toLowerCase()}\">\n          <i class=\"icon s18 {{node.icon}}\"></i>\n          <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n          <i class=\"icon-chevron-right s18 arrow\" ng-if=\"node.children.length > 0\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" id=\"{{node.stateList}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n          <i class=\"icon s18 {{node.icon}}\"></i>\n          <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n          <i class=\"icon-chevron-right s18 arrow\" ng-if=\"node.children.length > 0\"></i>\n        </a>\n\n      </div>\n\n      <ul ng-if=\"node.children.length > 0\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': node.children.length > 0}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n      </ul>\n</script><md-menu md-position-mode=\"target-right bottom\" show-gt-md hide-md hide-gt-sm hide-gt-xs hide-xs \nng-class=\"{\'menu-align\' : vm.isNavigationNew}\"><md-button class=\"btn-add-video md-accent md-raised md-warn\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-font-icon=\"icon-add-video\"></md-icon><span \ntranslate=\"MESSAGES.new\">Nouveau</span></md-button><md-menu-content><md-menu-item \nng-click=\"vm.goToUrlMedias(\'media_video\',\'app.media_video_upload\')\"><md-button><md-icon md-font-icon=\"icon-add\" \nstyle=\"font-size: 1em\"></md-icon><any><span translate=\"MESSAGES.add_video\">Ajouter une vidéo</span></any></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"true\"><md-icon md-font-icon=\"icon-noun_live\" \nstyle=\"font-size: 0.8em\"></md-icon><any><span translate=\"MESSAGES.create_video\">Créer une vidéo</span></any>\n</md-button></md-menu-item><md-menu-item ng-click=\"vm.goToUrlMedias(\'media_lives\',\'app.lives_addLive\')\"><md-button>\n<md-icon md-font-icon=\"icon-start-live\" style=\"font-size:1.5em\"></md-icon><any><span translate=\"MESSAGES.add_live\">\nFaire un live</span></any></md-button></md-menu-item><md-menu-item><md-button ng-disabled=\"true\"><md-icon \nmd-font-icon=\"icon-media\" style=\"font-size:1.2em\"></md-icon><any><span translate=\"MESSAGES.create_live\">\nCréer une playlist live</span></any></md-button></md-menu-item></md-menu-content></md-menu><md-menu \nmd-position-mode=\"target-right bottom\" show-gt-md hide-md hide-gt-sm hide-gt-xs hide-xs ng-if=\"vm.isNavigationNew\"><a \ntarget=\"_blank\" class=\"navigation-tv-btn\" ng-href=\"{{vm.redirectTv()}}\"><md-button class=\"tv-btn\" \naria-label=\"Voir la TV\"><md-icon md-font-icon=\"icon-web\" style=\"margin: 0 8px 0 0\"></md-icon><span \ntranslate=\"MESSAGES.tv_show\">Voir la TV</span></md-button></a></md-menu></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': node.children.length > 0}\" ng-include=\"\'navigation-nested.html\'\">\n</li></ul><script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div id=\"IDnav\"  ng-model-options=\"{ debounce:  { \'default\': 1000000 } }\" ms-navigation-item layout=\"row\" has-permission=\"{{node.permission}}\" has-stat=\"{{node.uisref ? \'stat\' : \'global\'}}\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref\">\n            <i class=\"icon s16 {{node.icon}}\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>-</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\" node.children.length > 0\"></i>\n        </div>\n        <a  class=\"ms-navigation-button\" id=\"{{node.stateList}}\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref\" ng-click=\"vm.returnHomePage()\" >\n            <i class=\"icon s16 {{node.icon}}\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>-</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\" node.children.length > 0\"></i>\n        </a>\n\n    </div>\n\n    <ul id=\"ulID\" ng-if=\"node.children.length > 0\">\n            <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': node.children.length > 0}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/abonnement/group/detail/detail.modal.html","<md-dialog style=\"min-width: 50%\" \naria-label=\"{{vm.isGV ? \'PAGESMENUSTITLES.abonnement_thematic_detail_pagetitle\' : \'PAGESMENUSTITLES.abonnement_group_detail_pagetitle\'}}\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"{{vm.isGV ? \'PAGESMENUSTITLES.abonnement_thematic_detail_pagetitle\' : \'PAGESMENUSTITLES.abonnement_group_detail_pagetitle\'}}\">\nabonnement_group_detail_pagetitle</span> <span>{{vm.group.name }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTGROUPDETAIL.id\">id</strong></h3>\n</div><div class=\"md-secondary\">{{vm.group.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"{{vm.isGV ? \'ABONNEMENTGROUPDETAIL.thematic_name\' : \'ABONNEMENTGROUPDETAIL.name\'}}\">name</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.group.name}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\" ng-if=\"!vm.isGV\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ABONNEMENTGROUPDETAIL.startDate\">startDate</strong></h3></div><div class=\"md-secondary\">\n{{ vm.group.startDate | date : $rootScope.defaultDateFormat : \'+0200\'}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\" ng-if=\"!vm.isGV\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ABONNEMENTGROUPDETAIL.endDate\">endDate</strong></h3></div><div class=\"md-secondary\">\n{{ vm.group.endDate | date : $rootScope.defaultDateFormat : \'+0200\'}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\" ng-if=\"!vm.isGV\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ABONNEMENTGROUPDETAIL.parent\">parent</strong></h3></div><div class=\"md-secondary\">{{ vm.group.parent.name }}\n</div><md-divider></md-divider></md-list-item></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/abonnement/group/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedGroups.length\" \nhas-permission=\"subscription_group_delete_multi_action\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'ABONNEMENTGROUPLIST.delete_groups_aria_label\'|translate}}\" tooltip-side=\"right\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedGroupsConfirm($event)\" \naria-label=\"delete_groups_aria_label\" translate \ntranslate-attr-aria-label=\"ABONNEMENTGROUPLIST.delete_groups_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"abonnement-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_abonnement\" \nng-keydown=\"$event.keyCode === 13 && vm.searchAbonnement()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewGroup($event)\" \naria-label=\"action_new_element\" has-permission=\"subscription_group_post_add_action\"><div class=\"span-btn-add\" \nlayout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-if=\"!vm.isGV\"><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedGroups.length === vm.groups.length) && (vm.selectedGroups.length > 0)\" \nmd-indeterminate=\"vm.selectedGroups.length !== 0 && vm.selectedGroups.length !== vm.groups.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" \ntranslate=\"{{vm.isGV ? \'ABONNEMENTGROUPLIST.thematic_name\' : \'ABONNEMENTGROUPLIST.name\'}}\">name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ABONNEMENTGROUPLIST.parent\">parent</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ABONNEMENTGROUPLIST.startDate\">\nstartDate</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ABONNEMENTGROUPLIST.endDate\">endDate</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ABONNEMENTGROUPLIST.updated_at\">updated_at</span></div></th><th class=\"secondary-text\" data-priority=\"1\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span>\n</div></th></tr></thead></table></div><div class=\"content fullpage-datatable\" layout=\"column\" flex ng-if=\"vm.isGV\">\n<table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedGroups.length === vm.groups.length) && (vm.selectedGroups.length > 0)\" \nmd-indeterminate=\"vm.selectedGroups.length !== 0 && vm.selectedGroups.length !== vm.groups.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" \ntranslate=\"{{vm.isGV ? \'ABONNEMENTGROUPLIST.thematic_name\' : \'ABONNEMENTGROUPLIST.name\'}}\">name</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/abonnement/group/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/abonnement/group/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/abonnement/group/add_edit_view/form.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><form name=\"empAbonnementGroupForm\" method=\"post\" \nclass=\"md-inline-form ng-pristine ng-valid ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-valid-required\" \nid=\"empAbonnementGroupForm\" novalidate=\"novalidate\" \nng-submit=\"empAbonnementGroupForm.$valid && vm.submitAddGroupForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\" ng-if=\"vm.isNew\"></md-icon><span \ntranslate=\"{{ vm.isGV ? \'ABONNEMENTGROUPADD.thematic_form_title\' : \'ABONNEMENTGROUPADD.form_title\'}}\" ng-if=\"vm.isNew\">\nform title</span><md-icon md-font-icon=\"icon-pen\" class=\"s18\" ng-if=\"!vm.isNew\"></md-icon><span \ntranslate=\"{{ vm.isGV ? \'ABONNEMENTGROUPEDIT.thematic_form_title\' : \'ABONNEMENTGROUPEDIT.form_title\'}}\" \nng-if=\"!vm.isNew\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\" style=\"padding: 1.2em 0 0 0\">\n<md-input-container flex><label \ntranslate=\"{{ vm.isGV ? \'ABONNEMENTGROUPLIST.thematic_name\' : \'ABONNEMENTGROUPADD.form_attr_name\'}}\" \nfor=\"empAbonnementGroupForm_name\" class=\"required ng-scope md-required\">Nom du groupe</label><input type=\"text\" \nid=\"empAbonnementGroupForm_name\" name=\"empAbonnementGroupForm[name]\" required ng-attr-name=\"name\" ng-name=\"name\" \nng-model=\"vm.empAbonnementGroupForm.name\" aria-invalid=\"true\"><div ng-messages=\"empAbonnementGroupForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementGroupError.name && vm.empAbonnementGroupForm.name === vm.empAbonnementGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementGroupError.name.message}}\" class=\"validation_api\">empAbonnementGroupError_name\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.isGV\"><md-input-container \nflex><label translate=\"ABONNEMENTGROUPADD.form_attr_startDate\">form attr startDate</label><md-datepicker \nng-model=\"vm.empAbonnementGroupForm.startDate\" ng-attr-name=\"startDate\" \nmd-max-date=\"vm.empAbonnementGroupForm.endDate\" md-open-on-focus name=\"startDate\" id=\"startDate\"></md-datepicker><div \nng-messages=\"empAbonnementGroupForm.startDate.$error\" role=\"alert\"><div ng-message=\"format\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div>\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.isGV\"><md-input-container flex><label \ntranslate=\"ABONNEMENTGROUPADD.form_attr_endDate\">form attr endDate</label><md-datepicker \nng-model=\"vm.empAbonnementGroupForm.endDate\" ng-attr-name=\"endDate\" md-min-date=\"vm.empAbonnementGroupForm.startDate\" \nmd-open-on-focus name=\"endDate\" id=\"endDate\" md-format=\"DD/MM/YYYY\"></md-datepicker><div \nng-messages=\"empAbonnementGroupForm.endDate.$error\" role=\"alert\"><div ng-message=\"format\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.parents.length >0 && !vm.isGV\"><md-card-content flex><md-select\n translate translate=\"MESSAGES.form_attr_parent\" ng-model=\"vm.empAbonnementGroupForm.parent\" name=\"parent\" ng-focus \nid=\"parent\" placeholder=\"{{ \'ABONNEMENTGROUPADD.form_attr_parent\'\n                            |translate}}\"><md-option \nvalue=\"\" translate=\"ABONNEMENTGROUPADD.no_parent\"></md-option><md-option \nng-repeat=\"parent in vm.parents track by parent.val.id\" ng-value=\"parent.val.id\" ng-attr-data-index=\"{{$index}}\">\n{{parent.val.name}}</md-option></md-select></md-card-content></div><div><md-button class=\"md-warn\" \nui-sref=\"app.abonnement_group_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAbonnementGroupForm.$invalid || empAbonnementGroupForm.$pristine\" translate=\"MESSAGES.form_add\" \nng-if=\"vm.isNew\">form add</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAbonnementGroupForm.$invalid || empAbonnementGroupForm.$pristine\" translate=\"MESSAGES.form_validate\" \nng-if=\"!vm.isNew\">form validate</md-button></div></form></ms-widget-front></ms-widget><ms-widget flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\" ng-if=\"!vm.isGV\"><ms-widget-front class=\"p-16\"><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 100%\"><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);width: 100%;padding: 0px;margin-top: -13px\" \nclass=\"product-detail-form-container\"><div class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgress\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><span flex><p translate=\"ABONNEMENTGROUPADD.select_file\"></p>( <a \nng-href=\"{{vm.downloadfile()}}\" target=\"_blank\" translate=\"ABONNEMENTGROUPADD.download_file\"></a> )</span></div></div>\n</div><div style=\"width: 100%;border: solid 1px rgba(0,0,0,0.15);padding-left: 10px; position: relative\" \nng-if=\"vm.inProgress\" layout=\"row\"><md-button style=\"position: absolute;right: -17px;top: -20px\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.inProgress=false\"><svg aria-hidden=\"true\" class=\"UppyIcon\" \nwidth=\"20\" height=\"30\" viewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" \nfill-rule=\"nonzero\" vector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\">\n</path><path fill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.nb_ligne_file\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.total\" aria-label=\"Readonly field\"></md-input-container></div><div style=\"margin-top: -10px\" \nlayout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.new\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex \ntype=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_new\" aria-label=\"Readonly field\"></md-input-container></div>\n</div><div style=\"margin-left: 5%\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.exist\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.ligne_exist\" aria-label=\"Readonly field\"></md-input-container></div><div \nstyle=\"margin-top: -10px\" layout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.errone\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input \nflex type=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_erronee\" aria-label=\"Readonly field\">\n</md-input-container></div></div></div><div style=\"width: 100%;margin-top: 15px\"><md-button ng-if=\"vm.inProgress\" \nclass=\"md-warn\" ui-sref=\"app.abonnement_group_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" value=\"Upload\" aria-label=\"Submit\" ng-if=\"vm.inProgress\" ng-click=\"vm.uploadAddFile()\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></div></div></md-content></ms-widget-front></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/abonnement/user/detail/detail.modal.html","<md-dialog style=\"min-width: 50%\" aria-label=\"abonnement_user_detail_pagetitle}}\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.abonnement_user_detail_pagetitle\">\nabonnement_user_detail_pagetitle</span> <span>{{vm.user.login}}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTUSERDETAIL.id\">id\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.Id}}</div><md-divider></md-divider></md-list-item><md-list-item\n class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTUSERDETAIL.lastName\">lastName\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.LastName}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTUSERDETAIL.name\">name\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.Name}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTUSERDETAIL.email\">email\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.Email}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ABONNEMENTUSERDETAIL.login\">login\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.Login}}</div><md-divider></md-divider></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/abonnement/user/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/abonnement/user/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/abonnement/user/add_edit_view/form.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><form name=\"empAbonnementUserForm\" method=\"post\" \nclass=\"md-inline-form\" id=\"empAbonnementUserForm\" novalidate=\"novalidate\" \nng-submit=\"empAbonnementUserForm.$valid && vm.submitAddUserForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\" ng-if=\"vm.isNew\"></md-icon><span \ntranslate=\"ABONNEMENTUSERADD.form_title\" ng-if=\"vm.isNew\">form_title</span><md-icon md-font-icon=\"icon-pen\" \nclass=\"s18\" ng-if=\"!vm.isNew\"></md-icon><span translate=\"ABONNEMENTUSEREDIT.form_title\" ng-if=\"!vm.isNew\">form_title\n</span></div><div layout=\"row\" style=\"padding: 1.2em 0 0 0\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\">\n<md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_name\" for=\"empAbonnementUserForm_name\" \nclass=\"required ng-scope md-required\">Nom</label><input type=\"text\" id=\"empAbonnementUserForm_name\" \nname=\"empAbonnementUserForm[name]\" required ng-attr-name=\"name\" ng-name=\"name\" \nng-model=\"vm.empAbonnementUserForm.name\" aria-invalid=\"true\"><div ng-messages=\"empAbonnementUserForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.name && vm.empAbonnementUserForm.name === vm.empAbonnementUserError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.name.message}}\" class=\"validation_api\">empAbonnementUserError_name\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\"><md-input-container flex>\n<label translate=\"ABONNEMENTUSERADD.form_attr_lastName\" for=\"empAbonnementUserForm_lastName\">Prénom</label><input \ntype=\"text\" id=\"empAbonnementUserForm_lastName\" name=\"empAbonnementUserForm[lastName]\" required=\"required\" \nng-attr-name=\"lastName\" ng-name=\"lastName\" ng-model=\"vm.empAbonnementUserForm.lastName\" aria-invalid=\"true\"><div \nng-messages=\"empAbonnementUserForm.lastName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.lastName && vm.empAbonnementUserForm.lastName === vm.empAbonnementUserError.lastName.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.lastName.message}}\" class=\"validation_api\">\nempAbonnementUserError_lastname</div></div></md-input-container></div></div><div layout=\"row\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_function\" \nfor=\"empAbonnementUserForm_function\">Fonction</label><input type=\"text\" id=\"empAbonnementUserForm_function\" \nname=\"empAbonnementUserForm[function]\" ng-attr-name=\"function\" ng-name=\"function\" \nng-model=\"vm.empAbonnementUserForm.function\" aria-invalid=\"true\"></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_entity\" \nfor=\"empAbonnementUserForm_entity\">Entité</label><input type=\"text\" id=\"empAbonnementUserForm_entity\" \nname=\"empAbonnementUserForm[entity]\" ng-attr-name=\"entity\" ng-name=\"entity\" ng-model=\"vm.empAbonnementUserForm.entity\" \naria-invalid=\"true\"></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"ABONNEMENTUSERADD.form_attr_email\">Email</label><input type=\"email\" id=\"empAbonnementUserForm_email\" \nname=\"empAbonnementUserForm[email]\" required=\"required\" ng-attr-name=\"email\" ng-name=\"email\" \nng-model=\"vm.empAbonnementUserForm.email\" ng-change=\"vm.checkMail(vm.empAbonnementUserForm.email)\" \nng-click=\"vm.checkMail(vm.empAbonnementUserForm.email)\" aria-invalid=\"true\"><div \nstyle=\"color: rgb(213,0,0);font-size: smaller\" ng-if=\"!vm.testMail\" translate=\"MESSAGES.form_is_email\">form_is_email\n</div></md-input-container></div><div layout=\"row\" ng-if=\"vm.isNew\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\">\n<md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_login\" for=\"empAbonnementUserForm_login\" \nng-repat=\"id in Ids \">Identifiant</label><input type=\"text\" id=\"empAbonnementUserForm_login\" \nname=\"empAbonnementUserForm[login]\" ng-attr-name=\"login\" name=\"login\" ng-model=\"vm.empAbonnementUserForm.login\" \naria-invalid=\"false\" required><div ng-messages=\"empAbonnementUserForm.login.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.login  && vm.empAbonnementUserForm.login === vm.empAbonnementUserError.login.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.login.message}}\" class=\"validation_api\">empAbonnementUserError_login\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"vm.isNew\" flex=\"50\">\n<md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_pwd\" for=\"empAbonnementUserForm_pwd\">\nMot de passe</label><input type=\"password\" id=\"empAbonnementUserForm_pwd\" name=\"empAbonnementUserForm[pwd]\" \nng-attr-name=\"pwd\" name=\"pwd\" ng-model=\"vm.empAbonnementUserForm.pwd\" aria-invalid=\"false\" required><div \nng-messages=\"empAbonnementUserForm.pwd.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.pwd  && vm.empAbonnementUserForm.pwd === vm.empAbonnementUserError.pwd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.pwd.message}}\" class=\"validation_api\">empAbonnementUserError_pwd\n</div></div></md-input-container></div></div><div layout=\"column\" flex ng-if=\"!vm.isNew\"><div flex=\"100\"><md-checkbox \nng-model=\"vm.empAbonnementUserSubForm.pwd\" checked=\"unchecked\"><label translate=\"ABONNEMENTUSERADD.form_attr_edit_pwd\">\nModifier le mot de passe</label></md-checkbox></div><div layout=\"row\"><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"ABONNEMENTUSERADD.form_attr_login\" \nfor=\"empAbonnementUserForm_login\" ng-repat=\"id in Ids \">Identifiant</label><input type=\"text\" \nid=\"empAbonnementUserForm_login\" name=\"empAbonnementUserForm[login]\" ng-attr-name=\"login\" name=\"login\" \nng-model=\"vm.empAbonnementUserForm.login\" aria-invalid=\"false\" required><div \nng-messages=\"empAbonnementUserForm.login.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.login  && vm.empAbonnementUserForm.login === vm.empAbonnementUserError.login.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.login.message}}\" class=\"validation_api\">empAbonnementUserError_login\n</div></div></md-input-container></div><div ng-if=\"vm.empAbonnementUserSubForm.pwd\" flex=\"50\"><md-card-content flex>\n<md-input-container flex=\"100\" style=\"width: 100%\"><input type=\"password\" \nplaceholder=\"{{ \'ABONNEMENTUSERADD.form_attr_pwd\' |translate}}\" name=\"empAbonnementUserForm[pwd]\" ng-attr-name=\"pwd\" \nname=\"pwd\" ng-model=\"vm.empAbonnementUserForm.pwd\" aria-invalid=\"false\" required><div \nng-messages=\"empAbonnementUserForm.pwd.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementUserError.pwd  && vm.empAbonnementUserForm.pwd === vm.empAbonnementUserError.pwd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementUserError.pwd.message}}\" class=\"validation_api\">empAbonnementUserError_pwd\n</div></div></md-input-container></md-card-content></div></div></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-model=\"vm.empAbonnementUserForm.protect\"><label translate=\"ABONNEMENTUSERADD.form_attr_protect\" \nclass=\"ng-scope\">Protégé</label></md-checkbox></div><div layout=\"column\" layout-gt-sm=\"row\"><md-card-content flex>\n<md-select translate translate=\"MESSAGES.form_attr_parent\" name=\"empAbonnementUserForm[group]\" aria-label=\"protege\" \nid=\"empAbonnementUserForm_group\" ng-model=\"vm.empAbonnementUserForm.group\" \nplaceholder=\"{{ \'ABONNEMENTUSERADD.form_attr_group\'\n                            |translate}}\"><md-option value=\"\" \ntranslate=\"ABONNEMENTUSERADD.no_group\"></md-option><md-option ng-repeat=\"group in vm.groups track by group.val.id\" \nng-value=\"group.val.id\" ng-attr-data-index=\"{{$index}}\">{{group.val.name}}</md-option><div \nng-messages=\"empAbonnementUserForm.group.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-select></md-card-content></div><md-button \nclass=\"md-warn\" ui-sref=\"app.abonnement_user_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" ng-if=\"vm.isNew\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAbonnementUserForm.$invalid || empAbonnementUserForm.$pristine || !vm.testMail\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAbonnementUserForm.$invalid || empAbonnementUserForm.$pristine || !vm.testMail\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><md-content \nclass=\"md-padding\" layout-xs=\"column\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 100%\"><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);width: 100%;padding-top: 40px;height: 260px\" \nclass=\"product-detail-form-container\"><div class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgress\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><span flex><p translate=\"ABONNEMENTGROUPADD.select_file\"></p>( <a \nng-href=\"{{vm.downloadfile()}}\" target=\"_blank\" translate=\"ABONNEMENTGROUPADD.download_file\"></a> )</span></div></div>\n</div><div style=\"width: 100%;border: solid 1px rgba(0,0,0,0.15);padding-left: 10px; position: relative\" \nng-if=\"vm.inProgress\" layout=\"row\"><md-button style=\"position: absolute;right: -17px;top: -20px\" \nclass=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.inProgress=false\"><svg aria-hidden=\"true\" class=\"UppyIcon\" \nwidth=\"20\" height=\"30\" viewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" \nfill-rule=\"nonzero\" vector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\">\n</path><path fill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.nb_ligne_file\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.total\" aria-label=\"Readonly field\"></md-input-container></div><div style=\"margin-top: -10px\" \nlayout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.new\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex \ntype=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_new\" aria-label=\"Readonly field\"></md-input-container></div>\n</div><div style=\"margin-left: 5%\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.exist\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.ligne_exist\" aria-label=\"Readonly field\"></md-input-container></div><div \nstyle=\"margin-top: -10px\" layout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.errone\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input \nflex type=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_erronee\" aria-label=\"Readonly field\">\n</md-input-container></div></div></div><div style=\"width: 100%;margin-top: 30px\"><md-button ng-if=\"vm.inProgress\" \nclass=\"md-warn\" ui-sref=\"app.abonnement_group_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" value=\"Upload\" aria-label=\"Submit\" ng-if=\"vm.inProgress\" ng-click=\"vm.uploadAddFile()\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></div></div></md-content></ms-widget-front></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/abonnement/user/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex has-permission=\"subscription_user_delete_multi_action\" \nng-if=\"vm.selectedUsers.length\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'ABONNEMENTUSERLIST.delete_user\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedUsersConfirm($event)\" \naria-label=\"delete_users_aria_label\" translate translate-attr-aria-label=\"ABONNEMENTUSERLIST.delete_user_aria_label\">\n<md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"abonnement-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_users\" ng-keydown=\"$event.keyCode === 13 && vm.searchUsers()\"></md-input-container></div><md-button\n class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewUser($event)\" \naria-label=\"action_new_element\" has-permission=\"subscription_user_post_add_action\"><div class=\"span-btn-add\" \nlayout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedUsers.length === vm.users.length) && (vm.selectedUsers.length > 0)\" \nmd-indeterminate=\"vm.selectedUsers.length !== 0 && vm.selectedUsers.length !== vm.users.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ABONNEMENTUSERLIST.lastName\">lastName</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ABONNEMENTUSERLIST.name\">name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ABONNEMENTUSERLIST.email\">email\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ABONNEMENTUSERLIST.login\">login</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ABONNEMENTUSERADD.form_attr_group\">group</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ABONNEMENTUSERLIST.protect\">protect\n</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div>\n</div>");
$templateCache.put("app/main/classifying/theme/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-theme\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/classifying/theme/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/classifying/theme/add_edit_view/form.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-theme\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div><form name=\"empParametersThemeForm\" method=\"post\" id=\"empParametersThemeForm\" \nnovalidate=\"novalidate\" ng-submit=\"empParametersThemeForm.$valid && vm.submitAddThemeForm()\"><div class=\"form-title\" \nng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"{{ vm.isGV ? \'THEMEADD.form_rubric_title\' : \'THEMEADD.form_title\'}}\">form_title</span></div><div \nclass=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"{{ vm.isGV ? \'THEMEEDIT.form_rubric_title\' : \'THEMEEDIT.form_title\'}}\">form_title</span></div><input \ntype=\"hidden\" id=\"empParametersThemeForm_logo\" name=\"empParametersThemeForm[logo]\" \nng-model=\"vm.empParametersThemeForm.logo\" aria-invalid=\"false\"><div ng-if=\"vm.urlVignette==\'\' && vm.theme.logo==null\" \nlayout-align=\"left left\" layout=\"row\" class=\"s18\"><md-icon md-font-icon=\"icon-picture\" \nstyle=\"margin-left: 60px;  padding-top: 20px\" class=\"s72\" width=\"100\" height=\"100\"></md-icon></div><div \nng-if=\"vm.urlVignette==\'\' && vm.theme.logo\" layout=\"row\" class=\"s18\"><img \nstyle=\"height: 60px;width: 80px; margin-left: 60px; padding-top: 20px\" ng-src=\"{{vm.theme.logo}}\" \non-error-src=\"assets/images/no-image-custom.svg\"></div><div ng-if=\"vm.urlVignette\" layout=\"row\" class=\"s18\"><img \nstyle=\"height: 100px;width: 80px; margin-left: 60px; padding-top: 20px\" ng-src=\"{{vm.urlVignette}}\" \non-error-src=\"assets/images/no-image-custom.svg\"></div><div class=\"mv-24\" id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><md-button ng-click=\"clicked()\" flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"THEMEADD.choose_thumb\">choose_thumb</any></md-button></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"THEMEADD.form_attr_title\">Titre</label><input \ntype=\"text\" id=\"empParametersThemeForm_title\" name=\"empParametersThemeForm[title]\" required=\"required\" \nng-attr-name=\"title\" ng-model=\"vm.empParametersThemeForm.title\" aria-invalid=\"false\" maxlength=\"200\"><div \nng-messages=\"empParametersThemeForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersThemeError.title && vm.empParametersThemeForm.title === vm.empParametersThemeError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersThemeError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.has_mooc==true\"><md-input-container flex>\n<label class=\"md-no-float\" translate=\"THEMEADD.form_attr_type_theme\">Type de thème</label><md-select \nng-attr-name=\"type\" translate translate=\"MESSAGES.form_attr_type_theme\" name=\"empParametersThemeForm[type]\" \nid=\"empParametersThemeForm_type\" ng-model=\"vm.empParametersThemeForm.type\" required><md-option \nng-repeat=\"typetheme in vm.typethemes\" ng-value=\"typetheme.val\" translate=\"MESSAGES.{{ typetheme.options }}\">\n{{ typetheme.options }}</md-option></md-select><div ng-messages=\"empParametersThemeForm.type.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersThemeError.type && vm.empParametersThemeForm.type === vm.empParametersThemeError.type.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersThemeError.type.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.channels.length\"><md-input-container flex>\n<label class=\"md-no-float required ng-scope\" translate=\"THEMEADD.form_attr_canal\">Canal</label><md-select translate \ntranslate=\"MESSAGES.form_attr_canal\" name=\"empParametersThemeForm[channels][]\" id=\"empParametersThemeForm_channels\" \nng-model=\"vm.empParametersThemeForm.channels\" multiple=\"1\" required ng-attr-name=\"channels\" \nng-change=\"vm.changeCanal()\"><md-option ng-repeat=\"channel in vm.channels track by channel.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"channel.val\">{{ channel.option }}</md-option></md-select><div \nng-messages=\"empParametersThemeForm.channels.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersThemeError.channels && vm.empParametersThemeForm.channels === vm.empParametersThemeError.channels.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersThemeError.channels.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"{{vm.isGV ? \'THEMEADD.form_attr_parentRubricId\': \'THEMEADD.form_attr_parentId\'}}\" \nclass=\"md-no-float required ng-scope\">Thème parent</label><md-select translate \ntranslate=\"{{vm.isGV ? \'MESSAGES.form_attr_parentRubricId\': \'MESSAGES.form_attr_parentId\'}}\" \nname=\"empParametersThemeForm[parent]\" id=\"empParametersThemeForm_parent\" ng-model=\"vm.empParametersThemeForm.parent\">\n<md-option ng-repeat=\"theme in vm.themesList track by theme.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"theme.val!=0 ? theme.val : \'\'\" ng-attr-translate=\"{{ theme.val==0 ? \'MESSAGES.none\':\'\' }}\">{{ theme.option }}\n</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\"><label class=\"md-no-float\" \ntranslate=\"THEMEADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empParametersThemeForm_description\" name=\"empParametersThemeForm[description]\" ng-attr-name=\"description\" rows=\"5\" \nmax-rows=\"8\" md-maxlength=\"450\" ng-model=\"vm.empParametersThemeForm.description\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empParametersThemeForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empParametersThemeError.description && vm.empParametersThemeForm.description === vm.empParametersThemeError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersThemeError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"THEMEADD.form_attr_visibility\">Visibilité</label><md-select translate \ntranslate=\"MESSAGES.form_attr_visibility\" name=\"empParametersThemeForm[visible]\" id=\"empParametersThemeForm_visible\" \nng-model=\"vm.empParametersThemeForm.visible\"><md-option ng-repeat=\"visibilityChoice in vm.visibilityChoices\" \nng-value=\"visibilityChoice.val\" translate=\"MESSAGES.{{ visibilityChoice.options }}\">{{ visibilityChoice.options }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex>\n<label class=\"md-no-float\" translate=\"THEMEADD.form_attr_classifiedBy\">Ordre des vidéo</label><md-select \nng-attr-name=\"classifiedBy\" translate translate=\"MESSAGES.form_attr_classifiedBy\" \nname=\"empParametersThemeForm[classifiedBy]\" id=\"empParametersThemeForm_classifiedBy\" \nng-model=\"vm.empParametersThemeForm.classifiedBy\" required><md-option ng-repeat=\"orderChoice in vm.orderChoices\" \nng-value=\"orderChoice.val\" translate=\"MESSAGES.{{ orderChoice.options }}\">{{ orderChoice.options }}</md-option>\n</md-select><div ng-messages=\"empParametersThemeForm.classifiedBy.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersThemeError.classifiedBy && vm.empParametersThemeForm.classifiedBy === vm.empParametersThemeError.classifiedBy.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersThemeError.classifiedBy.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.parameters_theme_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empParametersThemeForm.$invalid || empParametersThemeForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empParametersThemeForm.$invalid || empParametersThemeForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form></div></div></div></div></div>");
$templateCache.put("app/main/classifying/canal/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-canal\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/classifying/canal/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/classifying/canal/add_edit_view/form.template.html","<form name=\"empParametersCanalForm\" method=\"post\" id=\"empParametersCanalForm\" novalidate=\"novalidate\" \nng-submit=\"empParametersCanalForm.$valid && vm.submitAddCanalForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"CANALADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"CANALEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"CANALADD.form_attr_title\">title</label><input type=\"text\" \nid=\"empParametersCanalForm_title\" name=\"title\" ng-attr-name=\"title\" ng-model=\"vm.empParametersCanalForm.title\" \naria-invalid=\"true\" required=\"required\"><div ng-messages=\"empParametersCanalForm.title.$error\" maxlength=\"50\" \nrole=\"alert\"><div \nng-if=\"vm.empParametersCanalError.title && vm.empParametersCanalForm.title === vm.empParametersCanalError.title.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empParametersCanalError.title.message}}\">ParametersCanalError_title\n</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.form_attr_description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empParametersCanalForm_description\" name=\"empParametersCanalForm[description]\" ng-attr-name=\"description\" rows=\"5\" \nmax-rows=\"8\" md-maxlength=\"450\" ng-model=\"vm.empParametersCanalForm.description\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empParametersCanalForm.description.$error\" role=\"alert\"><div \nng-if=\"vm.empParametersCanalError.description && vm.empParametersCanalForm.description === vm.empParametersCanalError.description.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empParametersCanalError.description}}\">\nParametersCanalError_description</div><div ng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" \ntranslate-value-length=\"450\">form_max_length</div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"MESSAGES.form_attr_language\">Langue</label><md-select \ntranslate translate=\"MESSAGES.form_attr_language\" name=\"empParametersCanalForm[language]\" \nid=\"empParametersCanalForm_language\" ng-model=\"vm.empParametersCanalForm.language\"><md-option \nng-repeat=\"languageChoice in vm.languageChoices track by languageChoice.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"languageChoice.val\" translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.serverChoices.length>0\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"MESSAGES.form_attr_server\">Serveur de streaming</label><md-select translate \ntranslate=\"MESSAGES.form_attr_server\" name=\"empParametersCanalForm[servers][]\" id=\"empParametersCanalForm_servers\" \nng-model=\"vm.empParametersCanalForm.servers\" multiple=\"1\" ng-attr-name=\"servers\"><md-option \nng-repeat=\"serverChoice in vm.serverChoices track by serverChoice.option\" ng-attr-data-index=\"{{serverChoice.val}}\" \nng-value=\"serverChoice.option\"><span ng-attr-translate=\"{{ serverChoice.option==0 ? \'MESSAGES.select_server\':\'\' }}\">\n{{ serverChoice.val }}</span></md-option></md-select></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"CANALADD.form_attr_quota\">Quotas\n</label><input type=\"text\" id=\"empParametersCanalForm_quota\" name=\"empParametersCanalForm[quota]\" ng-attr-name=\"quota\" \nng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" ng-model=\"vm.empParametersCanalForm.quota\" aria-invalid=\"false\" required>\n<div ng-messages=\"empParametersCanalForm.quota.$error\" role=\"alert\"><div \nng-if=\"vm.empParametersCanalError.quota && vm.empParametersCanalForm.quota === vm.empParametersCanalError.quota.value_old\" \nstyle=\"font-size: 12px\" translate=\"CANALADD.{{vm.empParametersCanalError.quota}}\">ParametersCanalError_quota</div><div \nng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">field_must_be_numeric</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div \nhas-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"CANALADD.form_bitrate_pc\">Bitrate par défaut pour PC</label><input \ntype=\"text\" id=\"empParametersCanalForm_channelConfig_defaultBitrateComputer\" \nname=\"empParametersCanalForm[channelConfig][defaultBitrateComputer]\" ng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" \nng-attr-name=\"defaultBitrateComputer\" ng-model=\"vm.empParametersCanalForm.channelConfig.defaultBitrateComputer\" \naria-invalid=\"false\"><div ng-messages=\"empParametersCanalForm.defaultBitrateComputer.$error\" role=\"alert\"><div \nng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">field_must_be_numeric</div></div></md-input-container>\n</div><div has-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"CANALADD.form_bitrate_mob\">\nBitrate par défaut pour mobile</label><input type=\"text\" \nid=\"empParametersCanalForm_channelConfig_defaultBitrateMobile\" \nname=\"empParametersCanalForm[channelConfig][defaultBitrateMobile]\" ng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" \nng-attr-name=\"defaultBitrateMobile\" ng-model=\"vm.empParametersCanalForm.channelConfig.defaultBitrateMobile\" \naria-invalid=\"false\"><div ng-messages=\"empParametersCanalForm.defaultBitrateMobile.$error\" role=\"alert\"><div \nng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">field_must_be_numeric</div></div></md-input-container>\n</div><div has-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"CANALADD.form_bitrate_tab\">\nBitrate par défaut pour tablette</label><input type=\"text\" \nid=\"empParametersCanalForm_channelConfig_defaultBitrateTablet\" \nname=\"empParametersCanalForm[channelConfig][defaultBitrateTablet]\" ng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" \nng-attr-name=\"defaultBitrateTablet\" ng-model=\"vm.empParametersCanalForm.channelConfig.defaultBitrateTablet\" \naria-invalid=\"false\"><div ng-messages=\"empParametersCanalForm.defaultBitrateTablet.$error\" role=\"alert\"><div \nng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">field_must_be_numeric</div></div></md-input-container>\n</div><div has-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"MESSAGES.form_reading_protocol\">Protocole de lecture\n</label><md-select translate translate=\"MESSAGES.form_reading_protocol\" \nname=\"empParametersCanalForm[channelConfig][readingProtocol]\" \nid=\"empParametersCanalForm_channelConfig_readingProtocol\" \nng-model=\"vm.empParametersCanalForm.channelConfig.readingProtocol\"><md-option \nng-repeat=\"readingProtocolChoice in vm.readingProtocolChoices\" ng-value=\"readingProtocolChoice.val\" \ntranslate=\"MESSAGES.{{ readingProtocolChoice.option }}\">{{ readingProtocolChoice.option }}</md-option></md-select><div \nng-messages=\"readingProtocol.$error\" role=\"alert\"><div ng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">\nfield_must_be_numeric</div></div></md-input-container></div><div \nhas-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"MESSAGES.form_attr_mbr\">MBR</label><md-select translate \ntranslate=\"MESSAGES.form_reading_protocol\" name=\"empParametersCanalForm[channelConfig][showMbr]\" \nid=\"empParametersCanalForm_channelConfig_showMbr\" ng-model=\"vm.empParametersCanalForm.channelConfig.showMbr\"><md-option\n ng-repeat=\"mbrChoice in vm.mbrChoices\" ng-value=\"mbrChoice.val\" translate=\"MESSAGES.{{ mbrChoice.option }}\">\n{{ mbrChoice.option }}</md-option></md-select></md-input-container></div><div \nhas-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"MESSAGES.form_iscdn\">CDN</label><md-select translate \ntranslate=\"MESSAGES.form_iscdn\" name=\"empParametersCanalForm[channelConfig][isCdn]\" \nid=\"empParametersCanalForm_channelConfig_isCdn\" ng-model=\"vm.empParametersCanalForm.channelConfig.isCdn\"><md-option \nng-repeat=\"yesNoChoice in vm.yesNoChoices\" ng-value=\"yesNoChoice.val\" translate=\"MESSAGES.{{ yesNoChoice.option }}\">\n{{ yesNoChoice.option }}</md-option></md-select></md-input-container></div><div \nhas-permission=\"parameters_canal_configuration_canal_no_api\" layout=\"column\" layout-gt-xs=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"MESSAGES.form_isvbr\">VBR</label><md-select translate \ntranslate=\"MESSAGES.form_isvbr\" name=\"empParametersCanalForm[isVBR]\" id=\"empParametersCanalForm_isVBR\" \nng-model=\"vm.empParametersCanalForm.isVBR\"><md-option ng-repeat=\"yesNoChoice in vm.yesNoChoices\" \nng-value=\"yesNoChoice.val\" translate=\"MESSAGES.{{ yesNoChoice.option }}\">{{ yesNoChoice.option }}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"MESSAGES.form_attr_sendPushNotification\">Envoyer des notifications push</label>\n<md-select translate translate=\"MESSAGES.form_attr_sendPushNotification\" \nname=\"empParametersCanalForm[sendPushNotification]\" id=\"empParametersCanalForm_sendPushNotification\" \nng-model=\"vm.empParametersCanalForm.sendPushNotification\"><md-option ng-repeat=\"yesNoChoice in vm.yesNoChoices\" \nng-value=\"yesNoChoice.val\" translate=\"MESSAGES.{{ yesNoChoice.option }}\">{{ yesNoChoice.option }}</md-option>\n</md-select></md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.parameters_canal_list\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empParametersCanalForm.$invalid || empParametersCanalForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empParametersCanalForm.$invalid || empParametersCanalForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/classifying/canal/list/list.template.html","<div ng-if=\"!vm.isNewCanal\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nhas-permission=\"parameters_canal_delete_multi\" ng-if=\"vm.selectedCanals.length\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'CANALLIST.delete_canals_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedCanalsConfirm($event)\" \naria-label=\"video_upload_title\" translate translate-attr-aria-label=\"CANALLIST.delete_canals_aria_label\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"canals-search\" class=\"search-input ng-scope flex\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_canals\" \nng-keydown=\"$event.keyCode === 13 && vm.searchCanals()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewCanal($event)\" \naria-label=\"action_new_element\" has-permission=\"parameters_canal_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox ng-model=\"vm.modelCheckAll\" aria-label=\"-\" \nng-checked=\"(vm.selectedCanals.length === vm.canals.length) && (vm.selectedCanals.length > 0)\" \nmd-indeterminate=\"vm.selectedCanals.length !== 0 && vm.selectedCanals.length !== vm.canals.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"CANALLIST.title\">title</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"CANALLIST.language\">language\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"CANALLIST.streaming_server\">streaming_server</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"CANALLIST.quota\">quota</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead></table></div></div></div><div ng-if=\"vm.isNewCanal\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"fullpage\" layout=\"column\" flex><iframe \nid=\"iframe_segment_display\" ng-src=\"{{CanalIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden;position: absolute;padding: 10px\"></iframe></div></div>");
$templateCache.put("app/main/classifying/canal/list/serverDetail.modale.template.html","<md-dialog class=\"video-url-dialog\" aria-label=\"canal Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-floppy\" class=\"s24\"></md-icon><span translate=\"CANALLIST.stockage_modal_title\"></span> <span>\n{{ vm.canal.title | json}}</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><md-dialog-content><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\" ng-if=\"vm.spinner\"><table \nclass=\"simple\" ms-responsive-table=\"\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"CANALLIST.server\">server</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"CANALLIST.espace_utilise\">\nespace_utilise</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"CANALLIST.espace_disponible\">espace_disponible</span></div></th></tr>\n</thead><tbody><tr class=\"ng-scope\" ng-repeat=\"server in vm.servers\"><td class=\"name ng-binding\"><div><span>\n{{server.server}}</span></div><div ng-if=\"server.server==null\"><span>-</span></div></td><td \nclass=\"position ng-binding\"><div><span>{{server.used_space }}</span></div><div ng-if=\"server.used_space==null\"><span>-\n</span></div></td><td class=\"office ng-binding\"><div><span>{{server.available_space}}</span></div><div \nng-if=\"server.available_space==null\"><span>-</span></div></td></tr></tbody></table></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/classifying/canal/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"canal Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"CANALLIST.export_links_modal_title\"></span> \n<span>{{ vm.canal.title}}</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><md-dialog-content \nstyle=\"padding-top: 0;padding-bottom: 0\"><div ng-if=\"vm.spinner\"><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.links.code_integration\"><div flex=\"20\"><strong translate=\"CANALLIST.export_links_embed_link\"></strong></div>\n<div flex=\"80\" id=\"fo\"><md-input-container style=\"margin: 0\"><textarea style=\"border: 1px solid #EDEDED\" id=\"bar\" \nclass=\"fs-14\">{{vm.links.code_integration}}</textarea></md-input-container></div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo\" aria-label=\"url_copy\" ng-click=\"vm.copied =1\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===1}\"></md-icon></md-button></div>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span>\n<md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/classifying/theme/list/list.template.html","<div ng-if=\"!vm.isNewTheme\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedThemes.length\" has-permission=\"parameters_theme_delete_multi\"><a ng-style=\"myObj\" tooltips \ntooltip-template=\"{{\'THEMELIST.delete_themes_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedThemesConfirm($event)\" \naria-label=\"delete_themes_aria_label\" translate translate-attr-aria-label=\"THEMELIST.delete_themes_aria_label\"><md-icon\n md-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"themes-search\" class=\"search-input ng-scope flex\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_themes\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewTheme($event)\" aria-label=\"action_new_element\" has-permission=\"parameters_theme_post_add\"><div \nclass=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" \nwidth=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nstyle=\"cursor: default\"><div class=\"table-header centerdiiv\"></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"THEMELIST.image\">image</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"THEMELIST.title\">title</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"{{vm.isGV ? \'THEMELIST.rubric_parent\' : \'THEMELIST.parent\' }}\">parent\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"THEMELIST.canal\">canal</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead><tbody ui-sortable=\"vm.sortableOptions\"><tr \nng-repeat=\"theme in ::vm.themes | dataFilter: vm.search_themes track by theme.id\" data-index=\"{{theme.id}}\"><td \nclass=\"myHandleCursor\" id=\"myHandle\"><md-icon md-font-icon=\"icon-drag\" class=\"s20\"></md-icon></td><td><img \nng-if=\"theme.logo\" width=\"100\" height=\"100\" class=\"product-image\" ng-src=\"{{theme.logo}}\" \non-error-src=\"assets/images/no-image-custom.svg\"> <span \nng-if=\"theme.logo == null || theme.logo == \'\' || theme.logo === false \">-</span></td><td>{{theme.title}}</td><td \nng-if=\"!theme.parent\"><span style=\"font-weight: bold\">-</span></td><td ng-if=\"theme.parent\"><span>\n{{theme.parent.title}}</span></td><td ng-if=\"theme.channels.length === 0\"><span style=\"font-weight: bold\">-</span></td>\n<td ng-if=\"theme.channels.length\"><div ng-repeat=\"channel in ::theme.channels\"><span>-{{channel.title}}</span><br>\n</div></td><td><a ng-if=\"theme.visible\" has-permission=\"parameters_theme_get_export\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_theme\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.getExportLinks(theme)\" aria-label=\"export_theme\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_theme\"><md-icon md-font-icon=\"icon-link-variant\" class=\"s18\"></md-icon>\n</md-button></a><a has-permission=\"parameters_theme_get_detail\" tooltips \ntooltip-template=\"{{\'MESSAGES.action_detail\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button\" ng-click=\"vm.showThemeDetail(theme,$event)\" aria-label=\"action_detail\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_detail\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon></md-button>\n</a><a has-permission=\"parameters_theme_post_edit\" tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button style=\"display: inline-flex\" class=\"edit-button md-icon-button\" \nui-sref=\"app.parameters_theme_edit({id: theme.id})\" aria-label=\"action_edit\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a has-permission=\"parameters_theme_export_youtube\" tooltips \ntooltip-template=\"{{\'MESSAGES.action_export_youtube\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"m16 export-button md-icon-button\" ng-click=\"vm.exportYoutube(theme,ev)\" aria-label=\"action_export\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_export\"><md-icon md-font-icon=\"icon-export\" class=\"s18\"></md-icon>\n</md-button></a><a has-permission=\"parameters_theme_delete_theme\" tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteThemeConfirm(theme,ev)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></td></tr></tbody></table></div></div></div><div ng-if=\"vm.isNewTheme\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"fullpage\" layout=\"column\" flex><iframe \nid=\"iframe_segment_display\" ng-src=\"{{ThemeIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden;position: absolute;padding: 10px\"></iframe></div></div>");
$templateCache.put("app/main/classifying/theme/list/theme.export.modal.html","<md-dialog class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"THEMELIST.export_links_modal_title\"></span> \n<span>{{ vm.theme.title | json}}</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.links.url_permalien\"><div flex=\"20\"><strong \ntranslate=\"THEMELIST.export_links_perma_link\"></strong></div><div flex=\"80\">{{vm.links.url_permalien}}</div></div><div \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.links.url_embed\"><div flex=\"20\"><strong \ntranslate=\"THEMELIST.export_links_embed_link\"></strong></div><div flex=\"80\">{{vm.links.url_embed}}</div></div><div \nclass=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.links.code_embed\"><div flex=\"20\"><strong \ntranslate=\"THEMELIST.export_links_embed_code\"></strong></div><div flex=\"80\"><p>{{vm.links.code_embed}}</p></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/classifying/theme/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"THEMELIST.export_links_modal_title\"></span> \n<span>{{ vm.theme.title | json}}</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"padding-bottom: 0;padding-top: 0\"><div style=\"padding-bottom: 0\" layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.links.url_permalien\"><div flex=\"20\"><strong translate=\"THEMELIST.export_links_perma_link\">\n</strong></div><div flex=\"80\" id=\"fo1\">{{vm.links.url_permalien}}</div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo1\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div>\n<div style=\"padding-bottom: 0\" layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.links.url_embed\"><div \nflex=\"20\"><strong translate=\"THEMELIST.export_links_embed_link\"></strong></div><div flex=\"80\" id=\"fo\">\n{{vm.links.url_embed}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo\" \naria-label=\"url_copy\" ng-click=\"vm.copied =1\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===1}\"></md-icon></md-button></div><div style=\"padding-top: 15px\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.links.code_embed\"><div flex=\"20\"><strong translate=\"THEMELIST.export_links_embed_code\">\n</strong></div><div flex=\"80\" id=\"foo\"><md-input-container style=\"margin: 0\"><textarea \nstyle=\"border: 1px solid #EDEDED\" id=\"bar\" class=\"fs-14\">{{vm.links.code_embed}}</textarea></md-input-container></div>\n<md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#foo\" aria-label=\"url_copy\" \nng-click=\"vm.copied =2\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===2}\"></md-icon></md-button></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/classifying/canal/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"parameters_canal_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.parameters_canal_detail_pagetitle\">\nparameters_canal_detail_pagetitle</span> <span>{{ vm.canal.title |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.id\">id</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.canal.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.title\">title</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.canal.title }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.description\">description</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.canal.description }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.language\">language\n</strong></h3></div><div class=\"md-secondary\" style=\"text-transform: capitalize\" ng-if=\"vm.canal.language\" \ntranslate=\"LANGUAGES.Names.{{ vm.canal.language }}\">{{ vm.canal.language }}</div><div class=\"md-secondary\" \nstyle=\"text-transform: capitalize\" ng-if=\"vm.canal.language === \'\'\" translate=\"LANGUAGES.Names.Null\">\nLANGUAGES.Names.Null</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.server\">server</strong></h3></div><div \nclass=\"md-secondary\"><h4 ng-if=\"vm.canal.servers.length === 0\" translate=\"MESSAGES.none\" \nmd-colors=\"{color: \'#000000\'}\"></h4><ul ng-if=\"vm.canal.servers.length\" \nng-repeat=\"server in vm.canal.servers track by server.id\" ng-attr-data-index=\"{{$index}}\"><li>{{ server.name }}</li>\n</ul></div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"CANALDETAIL.quota\">quota</strong></h3></div><div class=\"md-secondary\" \nng-attr-md-colors=\"!vm.canal.quota && {color: \'warn\'}\">{{ vm.canal.quota ? vm.canal.quota : \"~\" }}</div><md-divider>\n</md-divider></md-list-item><md-list-item has-permission=\"parameters_canal_configuration_canal_no_api\" \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.bitrate_pc\">bitrate_pc</strong>\n</h3></div><div class=\"md-secondary\" \nng-attr-md-colors=\"!vm.canal.channelConfig.defaultBitrateComputer && {color: \'warn\'}\">\n{{ vm.canal.channelConfig.defaultBitrateComputer ? vm.canal.channelConfig.defaultBitrateComputer : \"~\" }}</div>\n<md-divider></md-divider></md-list-item><md-list-item has-permission=\"parameters_canal_configuration_canal_no_api\" \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.bitrate_mob\">bitrate_mob</strong>\n</h3></div><div class=\"md-secondary\" \nng-attr-md-colors=\"!vm.canal.channelConfig.defaultBitrateMobile && {color: \'warn\'}\">\n{{ vm.canal.channelConfig.defaultBitrateMobile ? vm.canal.channelConfig.defaultBitrateMobile : \"~\" }}</div><md-divider>\n</md-divider></md-list-item><md-list-item has-permission=\"parameters_canal_configuration_canal_no_api\" \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.bitrate_tab\">bitrate_tab</strong>\n</h3></div><div class=\"md-secondary\" \nng-attr-md-colors=\"!vm.canal.channelConfig.defaultBitrateTablet && {color: \'warn\'}\">\n{{ vm.canal.channelConfig.defaultBitrateTablet ? vm.canal.channelConfig.defaultBitrateTablet : \"~\" }}</div><md-divider>\n</md-divider></md-list-item><md-list-item has-permission=\"parameters_canal_configuration_canal_no_api\" \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"CANALDETAIL.reading_protocol\">reading_protocol\n</strong></h3></div><div class=\"md-secondary\" ng-if=\"vm.canal.channelConfig.readingProtocol==-1\" \ntranslate=\"CANALDETAIL.choices_use_default_config\">{{ vm.canal.channelConfig.readingProtocol }}</div><div \nclass=\"md-secondary\" ng-if=\"vm.canal.channelConfig.readingProtocol==\'RTMP\'\" translate=\"CANALDETAIL.RTMP\">\n{{ vm.canal.channelConfig.readingProtocol }}</div><div class=\"md-secondary\" \nng-if=\"vm.canal.channelConfig.readingProtocol === \'HDS\'\" translate=\"CANALDETAIL.HDS\">\n{{ vm.canal.channelConfig.readingProtocol }}</div><md-divider></md-divider></md-list-item><md-list-item \nhas-permission=\"parameters_canal_configuration_canal_no_api\" class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"CANALDETAIL.mbr\">mbr</strong></h3></div><div class=\"md-secondary\" \nng-if=\"vm.canal.channelConfig.showMbr==-1\" translate=\"CANALDETAIL.choices_use_default_config\">\n{{ vm.canal.channelConfig.showMbr }}</div><div class=\"md-secondary\" ng-if=\"vm.canal.channelConfig.showMbr==1\" \ntranslate=\"CANALDETAIL.choices_enable\">{{ vm.canal.channelConfig.showMbr }}</div><div class=\"md-secondary\" \nng-if=\"vm.canal.channelConfig.showMbr === 0\" translate=\"CANALDETAIL.choices_disable\">\n{{ vm.canal.channelConfig.showMbr }}</div><md-divider></md-divider></md-list-item><md-list-item \nhas-permission=\"parameters_canal_configuration_canal_no_api\" class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"CANALDETAIL.iscdn\">iscdn</strong></h3></div><div class=\"md-secondary\" \nng-attr-translate=\"{{ vm.canal.channelConfig.isCdn==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\' }}\">\n{{ vm.canal.channelConfig.isCdn }}</div></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\">\n<h3><strong translate=\"CANALDETAIL.sendPushNotification\">sendPushNotification</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{ vm.canal.sendPushNotification==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\' }}\">\n{{ vm.canal.sendPushNotification }}</div></md-list-item></md-list></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">\nalert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/classifying/theme/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" \naria-label=\"{{ vm.isGV ? \'PAGESMENUSTITLES.parameters_rubric_detail_pagetitle\' : \'PAGESMENUSTITLES.parameters_theme_detail_pagetitle\'}}\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"{{ vm.isGV ? \'PAGESMENUSTITLES.parameters_rubric_detail_pagetitle\' : \'PAGESMENUSTITLES.parameters_theme_detail_pagetitle\'}}\">\nparameters_theme_detail_pagetitle</span> <span>{{ vm.theme.title |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><img \nstyle=\"margin: auto\" ng-if=\"vm.theme.logo\" width=\"100\" height=\"100\" class=\"product-image\" ng-src=\"{{ vm.theme.logo }}\">\n<md-list flex><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.id\">id\n</strong></h3></div><div class=\"md-secondary\">{{ vm.theme.id }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"{{ vm.isGV ? \'THEMEDETAIL.parentRubricId\' : \'THEMEDETAIL.parentId\'}}\">parentId</strong></h3></div><div \nclass=\"md-secondary\"><h4 ng-if=\"!vm.theme.parent\" translate=\"MESSAGES.none\" md-colors=\"{color: \'#000000\'}\"></h4>\n{{ vm.theme.parent.title }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.title\">title</strong></h3></div><div class=\"md-secondary\">\n{{ vm.theme.title }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\" \nng-if=\"vm.has_mooc==true\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.type\">type</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.theme.type }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.alias\">alias</strong></h3></div>\n<div class=\"md-secondary\" ng-if=\"vm.theme.alias \">{{ vm.theme.alias }}</div><div class=\"md-secondary\" \nmd-colors=\"{color: \'#000000\'}\" ng-if=\"!vm.theme.alias\" translate=\"MESSAGES.none\"></div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"THEMEDETAIL.description\">description</strong></h3></div><div class=\"md-secondary\">{{ vm.theme.description }}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"THEMEDETAIL.channel\">channel</strong></h3></div><div class=\"md-secondary\"><h4 \nng-if=\"vm.theme.channels.length === 0\" translate=\"MESSAGES.none\" md-colors=\"{color: \'#000000\'}\"></h4><ul \nng-if=\"vm.theme.channels.length\" ng-repeat=\"channel in vm.theme.channels track by channel.id\" \nng-attr-data-index=\"{{$index}}\"><li>{{ channel.title }}</li></ul></div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.dir\">dir</strong>\n</h3></div><div class=\"md-secondary\" ng-if=\"vm.theme.directory \">{{ vm.theme.directory }}</div><div \nclass=\"md-secondary\" md-colors=\"{color: \'#000000\'}\" ng-if=\"!vm.theme.directory\" translate=\"MESSAGES.none\"></div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"THEMEDETAIL.subDir\">subDir</strong></h3></div><div class=\"md-secondary\" ng-if=\"vm.theme.subDirectory \">\n{{ vm.theme.subDirectory }}</div><div class=\"md-secondary\" md-colors=\"{color: \'#000000\'}\" \nng-if=\"!vm.theme.subDirectory\" translate=\"MESSAGES.none\"></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.url\">url</strong></h3></div><div \nclass=\"md-secondary\" ng-if=\"vm.theme.urlName \">{{ vm.theme.urlName }}</div><div class=\"md-secondary\" \nmd-colors=\"{color: \'#000000\'}\" ng-if=\"!vm.theme.urlName\" translate=\"MESSAGES.none\">{{ vm.theme.urlName }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"THEMEDETAIL.seen_nbr\">seen_nbr</strong></h3></div><div class=\"md-secondary\">{{ vm.theme.occurrences }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"THEMEDETAIL.visibility\">visibility</strong></h3></div><div class=\"md-secondary\" \nng-attr-translate=\"{{ vm.theme.visible==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\' }}\">\n{{ vm.theme.visible }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.sortedBy\">sortedBy</strong></h3></div><div \nng-if=\"!vm.theme.orderr\" md-colors=\"{color: \'#000000\'}\" class=\"md-secondary\" translate=\"MESSAGES.none\"></div><div \nng-if=\"vm.theme.orderr\" class=\"md-secondary\">{{ vm.theme.orderr }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"THEMEDETAIL.classifiedBy\">\nclassifiedBy</strong></h3></div><div class=\"md-secondary\">{{ vm.theme.classifiedBy }}</div></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/client/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/configuration/client/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/configuration/client/add_edit_view/form.template.html","<form name=\"empParamForm\" method=\"post\" id=\"empParamForm\" novalidate=\"novalidate\" \nng-submit=\"empParamForm.$valid && vm.submitAddParamForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"PARAMADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"PARAMEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"PARAMADD.form_attr_cle\">clé</label><input type=\"text\" id=\"empParamForm_cle\" \nname=\"empParamForm[cle]\" required=\"required\" ng-attr-name=\"cle\" ng-name=\"cle\" ng-model=\"vm.empParamForm.cle\" \naria-invalid=\"true\"><div ng-messages=\"empParamForm.cle.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"PARAMADD.form_attr_value\">valeur\n</label><input type=\"text\" id=\"empParamForm_value\" name=\"empParamForm[value]\" ng-attr-name=\"value\" ng-name=\"value\" \nng-model=\"vm.empParamForm.value\"></md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.param_list\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empParamForm.$invalid || empParamForm.$pristine\" translate=\"MESSAGES.form_add\">form_add</md-button>\n<md-button ng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empParamForm.$invalid || empParamForm.$pristine\" translate=\"MESSAGES.form_validate\">form_validate\n</md-button></form>");
$templateCache.put("app/main/configuration/client/list/list.template.html","<div ng-if=\"!vm.isNewClient\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedParamss.length\" has-permission=\"param_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'PARAMLIST.delete_Param_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" has-permission=\"param_delete_multi\" \nng-click=\"vm.deleteSelectedParamsConfirm($event)\" aria-label=\"delete_Param_aria_label\" translate \ntranslate-attr-aria-label=\"PARAMLIST.delete_Param_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"params-search\" class=\"search-input\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" has-permission=\"param_post_add\" \nng-click=\"vm.addNewParams($event)\" aria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedParamss.length === vm.params.length) && (vm.selectedParamss.length > 0)\" \nmd-indeterminate=\"vm.selectedParamss.length !== 0 && vm.selectedParamss.length !== vm.params.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"PARAMLIST.cle\">cle</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"PARAMLIST.value\">value</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"param in vm.params track by param.id\" ng-attr-data-index=\"{{$index}}\"><td><md-checkbox \nng-checked=\"param.checked\" ng-click=\"vm.toggle(param)\" aria-label=\"-\"></md-checkbox></td><td>{{ param.cle }}</td><td>\n{{ param.value }}</td><td><a tooltips tooltip-template=\"{{\'PARAMLIST.detail_param\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"show-button md-icon-button\" ng-click=\"vm.showParamsDetail(param,ev)\" \nhas-permission=\"param_get_detail\" aria-label=\"detail_param\" translate \ntranslate-attr-aria-label=\"PARAMLIST.detail_param\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'PARAMLIST.update_param\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"edit-button md-icon-button\" ui-sref=\"app.param_edit({id: param.id})\" \nhas-permission=\"param_post_edit\" aria-label=\"update_param\" translate \ntranslate-attr-aria-label=\"PARAMLIST.update_param\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'PARAMLIST.delete_param\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteParamsConfirm(param,ev)\" \nhas-permission=\"param_delete_param\" aria-label=\"delete_param\" translate \ntranslate-attr-aria-label=\"PARAMLIST.delete_param\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></td></tr></tbody></table></div></div><div ng-if=\"vm.isNewClient\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth full-height\" layout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" \nflex><div style=\"overflow: hidden;min-height: 100%\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \nng-src=\"{{vm.newClientIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%; height: 100%; overflow: hidden\">\n</iframe></div></div></div>");
$templateCache.put("app/main/configuration/client/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"param_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.param_detail_pagetitle\">param_detail_pagetitle</span> \n<span>{{ vm.param.cle |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PARAMDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{ vm.param.id }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PARAMDETAIL.cle\">cle</strong></h3></div><div class=\"md-secondary\">\n{{ vm.param.cle }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PARAMDETAIL.value\">value</strong></h3></div><div class=\"md-secondary\">\n{{ vm.param.value }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.created_at\">created_at</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.param.created_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"MESSAGES.updated_at\">updated_at</strong></h3></div><div class=\"md-secondary\">\n{{ vm.param.updated_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/news/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/configuration/news/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/configuration/news/add_edit_view/form.template.html","<form name=\"empConfigurationNewsForm\" method=\"post\" id=\"empConfigurationNewsForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationNewsForm.$valid && vm.submitAddNewsForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon\n md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"NEWSADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"NEWSEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"NEWSADD.form_attr_name\">content</label><div class=\"md-resize-wrapper\"><textarea \nname=\"empConfigurationNewsForm[content]\" required=\"required\" ng-attr-name=\"content\" \nng-model=\"vm.empConfigurationNewsForm.content\" rows=\"1\" aria-invalid=\"true\" style=\"height: 30px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empConfigurationNewsForm.content.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\"><md-datepicker required \nng-model=\"vm.empConfigurationNewsForm.startDate\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\" md-open-on-focus>\n</md-datepicker><div ng-messages=\"empConfigurationNewsForm.startDate.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">\ndate_valid</div></div></md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.configuration_news_list\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empConfigurationNewsForm.$invalid || empConfigurationNewsForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empConfigurationNewsForm.$invalid || empConfigurationNewsForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/configuration/home/list/list.template.html","<div ng-if=\"!vm.isNewHomeVid\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex></div><div flex=\"40\" \nlayout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"abonnement-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_homeVideo\"></md-input-container></div></div><div class=\"content-card fullpage\" layout=\"row\" flex>\n<div class=\"card\" layout=\"column\" layout-gt-xs=\"row\" flex \nstyle=\"max-width: 200px; max-height: 100%;box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);\n                transition: 0.3s; width: 20%\">\n<md-content ms-scroll=\"\" class=\"content ms-scroll ng-scope _md md-default-theme flex ps-container ps-theme-default\">\n<div class=\"navigation-simple layout-column\" layout=\"column\"><div class=\"demo-sidenav\"><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"HOMECONFLIST.selectbycanal\">selectbycanal</span></md-subheader><md-list-item \nng-click=\"vm.selectChanged(0)\"><p>{{\'MESSAGES.all\'|translate}}</p></md-list-item><md-list-item \nng-repeat=\"channel in vm.channels track by channel.val\" ng-attr-data-index=\"{{$index}}\" \nng-click=\"vm.selectChanged(channel.val)\" ng-model=\"vm.canal\" ng-value=\"channel\"><p>{{channel.option}}</p>\n</md-list-item></md-list></div></div></md-content></div><div class=\"content fullpage-datatable\" layout=\"column\" flex \nstyle=\"margin-left: 30px\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\" id=\"test\" \ndt-instance=\"vm.dtInstance\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"HOMECONFLIST.preview\">preview</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.form_attr_title\">title</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"HOMECONFLIST.theme\">theme</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"HOMECONFLIST.canal\">canal</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"HOMECONFLIST.action\">action</span></div></th></tr></thead><tbody \nui-sortable=\"vm.sortableOptions\"><tr \nng-repeat=\"media in vm.mediaList | dataFilter: vm.search_homeVideo track by media.id\" ng-attr-data-index=\"{{$index}}\">\n<td class=\"myHandleCursor\" id=\"myHandle\"><md-icon md-font-icon=\"icon-drag\" class=\"s20\"></md-icon></td><td id=\"id\">\n{{media.id}}</td><td layout-align=\"center center\"><div ng-if=\"media.logo\" \nstyle=\"position: relative;max-width: 105px;max-height: 60px;cursor: pointer\"><img \nstyle=\"height: 100%;width: 100%;min-width: 70px\" ng-src=\"{{media.logo}}\" \non-error-src=\"assets/images/no-image-custom.svg\"><div><img ng-if=\"media.logo\" \nng-click=\"vm.previewHomeVideo(media.id,$event,media.id)\" \nstyle=\"position: absolute;width: 34px;height: 34px;left: 50%;top: 50%;margin-left: -17px;margin-top: -17px\" \nng-src=\"assets/images/logos/overlay.png\"></div></div><div class=\"parentVideoImg\" ng-if=\"!media.logo\"><div \nstyle=\"position: relative;max-width: 105px;max-height: 60px\"><md-icon md-font-icon=\"icon-no-image-custom\" class=\"s56\" \nstyle=\"opacity: .6;position: absolute;top: 0;bottom: 0;right: 0;left: 0\" ng-hide=\"media.logo\"></md-icon></div></div>\n</td><td style=\"text-align: left\">{{media.title}}</td><td><any style=\"text-transform: capitalize\" \ntranslate=\"MESSAGES.none\" md-colors=\"{color: \'#000000\'}\" ng-if=\"media.themes.length < 1\"></any><ul><li \nng-repeat=\"theme in media.themes\">{{theme}}</li></ul></td><td><any style=\"text-transform: capitalize\" \ntranslate=\"MESSAGES.none\" md-colors=\"{color: \'#000000\'}\" ng-if=\"media.themes.length < 1\"></any><ul><li \nng-repeat=\"canal in media.canals\">{{canal}}</li></ul></td><td><a tooltips \ntooltip-template=\"{{\'HOMECONFLIST.delete_homeConf\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"show-button md-icon-button\" ng-click=\"vm.deleteHomeVideoConfirm(media,$event)\" aria-label=\"delete homeConf\" \ntranslate translate-attr-aria-label=\"HOMECONFLIST.delete_homeConf\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\">\n</md-icon></md-button></a></td></tr></tbody></table></div></div></div></div><div ng-if=\"vm.isNewHomeVid\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.newHomeVideoIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/configuration/home/list/preview.modale.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.video_preview\">\nPreview of the video</span> <span>:{{vm.video.title | json}}</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div layout=\"row\" layout-align=\"center center\" class=\"mv-24\"><iframe\n allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" width=\"800\" height=\"500\" \nng-src=\"{{vm.trustLink(vm.link)}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\">\n</iframe></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/news/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"configuration_news_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.configuration_news_detail_pagetitle\">\nconfiguration_news_detail_pagetitle</span> <span>{{ vm.news.title |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"NEWSDETAIL.id\">id</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.news.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"NEWSDETAIL.title\">title</strong></h3></div><div\n class=\"md-secondary\">{{ vm.news.title }}</div><md-divider></md-divider></md-list-item><md-list-item \nng-if=\"vm.news.parent\" class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"NEWSDETAIL.parent\">\nparent</strong></h3></div><div class=\"md-secondary\">{{ vm.news.parent.title }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"NEWSDETAIL.visible\">visible</strong></h3></div><div class=\"md-secondary\">{{ vm.news.visible }}</div>\n<md-divider></md-divider></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/home/conf/add_edit.template.html","<div ng-if=\"!vm.isNewConf\" id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div \nng-include=\"\'app/main/configuration/home/conf/form.template.html\'\"></div></div></div></div></div><div \nng-if=\"vm.isNewConf\" ng-include=\"\'app/main/configuration/home/conf/form.template.html\'\" style=\"height: 100%\"></div>");
$templateCache.put("app/main/configuration/home/conf/form.template.html","<form ng-if=\"!vm.isNewConf\" name=\"empHomeConfForm\" method=\"post\" id=\"empHomeConfForm\" novalidate=\"novalidate\" \nng-submit=\"empHomeConfForm.$valid && vm.submitAddConfForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"HOMECONFADD.custom_conf\">form_title\n</span></div><div layout=\"column\" layout-align=\" start\" class=\"ng-scope layout-column layout-align-start-start\"><div \nlayout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.channels.length\"><md-card-content flex><md-select translate \ntranslate=\"MESSAGES.form_attr_canal\" name=\"empHomeConfForm[channel]\" id=\"empHomeConfForm_canal\" \nng-model=\"vm.empHomeConfForm.channel\" multiple=\"0\" required=\"1\" ng-attr-name=\"canal\" \nng-change=\"vm.selectChanged(vm.empHomeConfForm.channel)\" placeholder=\"{{ \'HOMECONFADD.form_attr_canal\'|translate}}\">\n<md-option ng-repeat=\"channel in vm.channels track by channel.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"channel.val\">{{ channel.option }}</md-option></md-select><div ng-messages=\"empHomeConfForm.channel.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-card-content></div><md-radio-group ng-model=\"vm.empHomeConfForm.pageOption\" required><md-radio-button value=\"1\">\n<label translate=\"HOMECONFADD.form_attr_alt\" class=\"required ng-scope md-required\">form_attr_alt</label>\n</md-radio-button><div><md-radio-button value=\"2\"><label translate=\"HOMECONFADD.form_attr_orderAlpha\" \nclass=\"required ng-scope md-required\">form_attr_orderAlpha</label></md-radio-button></div><div><md-radio-button \nvalue=\"3\"><label translate=\"HOMECONFADD.form_attr_datePub\" class=\"required ng-scope md-required\">form_attr_datePub\n</label></md-radio-button></div><div><md-radio-button value=\"4\"><label translate=\"HOMECONFADD.form_attr_datePubVid\" \nclass=\"required ng-scope md-required\">form_attr_datePubVid</label></md-radio-button></div><div><md-radio-button \nvalue=\"5\"><label translate=\"HOMECONFADD.form_attr_orderVid\" class=\"required ng-scope md-required\">form_attr_orderVid\n</label></md-radio-button></div></md-radio-group></div><div layout=\"column\" layout-gt-sm=\"row\"><md-card-content flex>\n<md-select name=\"vm.empHomeConfForm.nbVid\" ng-model=\"vm.empHomeConfForm.nbVid\" aria-label=\"nbVid\" required=\"required\" \nplaceholder=\"{{ \'HOMECONFADD.form_attr_nb_videos\'|translate}}\"><md-option value=\"0\" selected=\"selected\"><span \ntranslate=\"HOMECONFADD.all\">Tous</span></md-option><md-option value=\"5\">5</md-option><md-option value=\"10\">10\n</md-option><md-option value=\"15\">15</md-option><md-option value=\"20\">20</md-option></md-select><div \nng-messages=\"empHomeConfForm.nbVid.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-card-content></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"vm.channels.length && vm.empHomeConfForm.channel\"><md-card-content flex><md-select translate \ntranslate=\"MESSAGES.form_attr_video\" name=\"empHomeConfForm[video]\" id=\"empHomeConfForm_video\" \nng-model=\"vm.empHomeConfForm.video\" multiple=\"0\" ng-attr-name=\"video\" aria-label=\"form_attr_video\" \nplaceholder=\"{{ \'HOMECONFADD.form_attr_video\'|translate}}\"><md-option value=\"-1\" \nstyle=\"font-weight: bold;border-bottom: 1px solid #e1dcdc\"><span translate=\"MESSAGES.none\"></span></md-option>\n<md-option ng-repeat=\"video in vm.videos track by video.val.id\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"video.val.id\">{{ video.val.title }}</md-option></md-select><div ng-messages=\"empHomeConfForm.video.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-card-content></div><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empHomeConfForm.$invalid || empHomeConfForm.$pristine\" translate=\"MESSAGES.form_add\">form_add</md-button>\n</form><div ng-if=\"vm.isNewConf\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div \nstyle=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.newConfIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height:100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/configuration/playerParameters/list_intra/list_intra.controller_template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"key\" ng-attr-aria-label=\"{{vm.pair.key}}\"><form name=\"ppForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon><span\n translate=\"PLAYERPARAMETERSLIST.dialog_title\"></span> <span>{{vm.pair.key}}</span> </span><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>{{vm.pair.key}}</label><input \nname=\"key\" ng-model=\"vm.listController.playerParameters[vm.pair.key]\" md-autofocus md-select></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.editPPKey($event)\" class=\"save-button md-accent md-raised\" \nng-disabled=\"ppForm.$invalid || ppForm.$pristine\" translate=\"MESSAGES.form_validate\" aria-label=\"validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\"></md-button><md-button class=\"md-warn md-flat\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.dialog_cancel\">CLOSE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/configuration/playerParameters/list_intra/list_intra.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedCles.length\"><a tooltips \ntooltip-template=\"{{\'PLAYERPARAMETERSLIST.delete_cle_aria_label\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ng-click=\"\" aria-label=\"delete_cle_aria_label\" \ntranslate translate-attr-aria-label=\"PLAYERPARAMETERSLIST.delete_cle_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"pp-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"\" aria-label=\"action_new_element\"><div \nclass=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" \nwidth=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th><md-checkbox ng-click=\"vm.toogleSelection($event)\" aria-label=\"-\">\n</md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"PLAYERPARAMETERSLIST.type\">type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PLAYERPARAMETERSLIST.value\">value</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"param in ::vm.playerParametersArray track by param.key\" \nng-attr-data-index=\"{{$index}}\"><td><md-checkbox ng-checked=\"\" ng-click=\"\" aria-label=\"-\"></md-checkbox></td><td>\n<strong>{{param.key}}</strong></td><td>{{param.value}}</td><td><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openPPEditDialog(param,$index,$event)\" aria-label=\"translate\" \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'PLAYERPARAMETERSLIST.delete_cle\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button\" ng-click=\"\" aria-label=\"delete_cle\" translate \ntranslate-attr-aria-label=\"PLAYERPARAMETERSLIST.delete_cle\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/configuration/home/push/push_video.template.html","<div ng-if=\"!vm.isNewPush\" id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div ng-if=\"vm.hasPushVideo\" \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout-align=\"center center\" \nlayout=\"row\" class=\"mv-24\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"vm.showPlayer\"><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" width=\"600\" height=\"340\" \nng-src=\"{{ vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe>\n</div><div layout=\"row\" layout-align=\"center center\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"HOMECONFPUSH.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{vm.PushVideoData.id}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"HOMECONFPUSH.title\">title</strong></h3></div><div \nclass=\"md-secondary\">{{vm.PushVideoData.title}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"HOMECONFPUSH.startDate\">startDate</strong></h3>\n</div><div class=\"md-secondary\">{{vm.startDate| date:\'dd/MM/yyyy\'}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"HOMECONFPUSH.endDate\">endDate\n</strong></h3></div><div class=\"md-secondary\">{{vm.endDate| date:\'dd/MM/yyyy\'}}</div><md-divider></md-divider>\n</md-list-item></md-list></div><div layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent md-raised\" \nng-click=\"vm.disablePushVideo(vm.PushVideoData,$event,$index)\"><span class=\"md-inline-list-icon-label\" \ntranslate=\"HOMECONFPUSH.push_video_off\">push_video_off</span></md-button></div></div></div></div><div \nng-if=\"!vm.hasPushVideo\" class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div \nlayout-align=\"center center\" layout=\"row\" class=\"mv-24\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" \nflex-xs=\"100\"><span class=\"md-inline-list-icon-label\" translate=\"HOMECONFPUSH.no_push_video\">no_push_video</span></div>\n</div></div></div></div></div><div ng-if=\"vm.isNewPush\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth full-height\" layout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" \nflex><div style=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.newPushIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/configuration/playerParameters/list/list.controller_template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"key\" ng-attr-aria-label=\"{{vm.pair.key}}\"><form name=\"ppForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon><span\n translate=\"PLAYERPARAMETERSLIST.dialog_title\"></span> <span>{{vm.pair.key}}</span> </span><span flex></span><md-button\n class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>{{vm.pair.key}}</label><input \nname=\"key\" ng-model=\"vm.pair.value\" md-autofocus md-select></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.editPPKey($event)\" \nclass=\"save-button md-accent md-raised\" ng-disabled=\"ppForm.$invalid || ppForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" aria-label=\"validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">\n</md-button><md-button class=\"md-warn md-flat\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.dialog_cancel\">CLOSE\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/configuration/playerParameters/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedParamss.length\" \nhas-permission=\"playlist_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'PLAYLISTLIST.delete_playlists_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedParamsConfirm($event)\" \naria-label=\"delete_param\" translate translate-attr-aria-label=\"PARAMLIST.delete_param\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"pp-search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex></md-input-container>\n</div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"\" \naria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg \nxmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedParamss.length === vm.paramss.length) && (vm.selectedParamss.length > 0)\" \nmd-indeterminate=\"vm.selectedParamss.length !== 0 && vm.selectedParamss.length !== vm.paramss.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"PLAYERPARAMETERSLIST.type\">type</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PLAYERPARAMETERSLIST.value\">value</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead><tbody><tr ng-repeat=\"param in vm.playerParametersArray track by param.key\" \nng-attr-data-index=\"{{$index}}\"><td><md-checkbox ng-checked=\"param.checked\" ng-click=\"vm.toggle(param)\" aria-label=\"-\">\n</md-checkbox></td><td><strong>{{param.key}}</strong></td><td>{{param.value}}</td><td><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"edit-button md-icon-button\" ng-click=\"vm.openPPEditDialog(param,$index,$event)\" aria-label=\"translate\" \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'PARAMLIST.delete_param\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteParamsConfirm(param,ev)\" \naria-label=\"delete_param\" translate translate-attr-aria-label=\"PARAMLIST.delete_param\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/configuration/news/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedNewss.length\" \nhas-permission=\"configuration_newss_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'NEWSLIST.delete_newss_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedNewssConfirm($event)\" \naria-label=\"delete_newss_aria_label\" translate translate-attr-aria-label=\"NEWSLIST.delete_newss_aria_label\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"newss-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_newss\" \nng-keydown=\"$event.keyCode === 13 && vm.searchNewss()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewNews($event)\" \naria-label=\"action_new_element\" has-permission=\"configuration_newss_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedNewss.length === vm.newss.length) && (vm.selectedNewss.length > 0)\" \nmd-indeterminate=\"vm.selectedNewss.length !== 0 && vm.selectedNewss.length !== vm.newss.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"NEWSLIST.news\">news</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"NEWSLIST.date\">date</span></div></th>\n<th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div>\n</div></div>");
$templateCache.put("app/main/configuration/presets/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"configuration_presets_detail_pagetitle\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.configuration_presets_detail_pagetitle\">\nconfiguration_presets_detail_pagetitle</span> <span>{{ vm.preset.name |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.preset.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.name\">name</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.preset.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.bitrateVideo\">bitrateVideo\n</strong></h3></div><div class=\"md-secondary\">{{ vm.preset.bitrateVideo }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"PRESETSDETAIL.bitrateAudio\">bitrateAudio</strong></h3></div><div class=\"md-secondary\">\n{{ vm.preset.bitrateAudio }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.samplerateAudio\">samplerateAudio</strong></h3></div><div\n class=\"md-secondary\">{{ vm.preset.samplerateAudio }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.framerate\">framerate</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.preset.framerate }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PRESETSDETAIL.state\">state\n</strong></h3></div><div class=\"md-secondary\"><i ng-if=\"vm.preset.state==true\" class=\"icon icon-check\"></i><i \nng-if=\"vm.preset.state==false\" class=\"icon icon-close\"></i></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.created_at\">created_at</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.preset.created_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"MESSAGES.updated_at\">updated_at</strong></h3></div><div class=\"md-secondary\">\n{{ vm.preset.updated_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/presets/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedPresetss.length\"><a ng-style=\"myObjStyle\" \ntooltips tooltip-template=\"{{\'PRESETSLIST.delete_presets_aria_label\'|translate}}\" tooltip-side=\"right\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedPresetsConfirm($event)\" \naria-label=\"delete_presets_aria_label\" translate translate-attr-aria-label=\"PRESETSLIST.delete_presets_aria_label\">\n<md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"Presetss-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_Presets\" \nng-keydown=\"$event.keyCode === 13 && vm.searchPresetss()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewPresets($event)\" \naria-label=\"action_new_element\" has-permission=\"configuration_presets_delete_multi\"><div class=\"span-btn-add\" \nlayout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedPresetss.length === vm.presetss.length) && (vm.selectedPresetss.length > 0)\" \nmd-indeterminate=\"vm.selectedPresetss.length !== 0 && vm.selectedPresetss.length !== vm.presetss.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"PRESETSLIST.state\">state</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"PRESETSLIST.name\">name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PRESETSLIST.bitrateVideo\">bitrateVideo</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"PRESETSLIST.bitrateAudio\">\nbitrateAudio</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"PRESETSLIST.samplerateAudio\">samplerateAudio</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PRESETSLIST.framerate\">framerate</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div>\n</th></tr></thead></table></div></div>");
$templateCache.put("app/main/configuration/server/add_edit_view/add_edit.template.html","<div id=\"forms\" class=\"e-commerce-product page-layout simple fullwidth IE-add-server\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/configuration/server/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/configuration/server/add_edit_view/form.template.html","<form name=\"empConfigurationServerForm\" method=\"post\" ismodif=\"1\" id=\"empConfigurationServerForm\" \nnovalidate=\"novalidate\" ng-submit=\"empConfigurationServerForm.$valid && vm.submitAddServerForm()\" style=\"\"><div \nclass=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"SERVERADD.form_title\">form_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon \nmd-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"SERVEREDIT.form_title\">form_title</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-card-content flex><md-select translate translate=\"SERVERADD.form_attr_type\" \nname=\"type\" id=\"empConfigurationServerForm_type\" ng-model=\"vm.empConfigurationServerForm.type\" required=\"required\" \naria-invalid=\"true\" placeholder=\"{{ \'SERVERADD.form_attr_type\'|translate}}\"><md-option ng-repeat=\"type in vm.types\" \nng-value=\"type.val\">{{ type.option }}</md-option></md-select><div ng-messages=\"empConfigurationServerForm.type.$error\" \nrole=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.type && vm.empConfigurationServerForm.title === vm.empConfigurationServerError.title.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.type}}\">ConfigurationServerError_type\n</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-card-content>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-card-content flex><md-select translate \ntranslate=\"SERVERADD.form_attr_server_type\" name=\"type\" id=\"empConfigurationServerForm_serverType\" \nng-model=\"vm.empConfigurationServerForm.serverType\" aria-invalid=\"true\" \nplaceholder=\"{{ \'SERVERADD.form_attr_server_type\'|translate}}\"><md-option ng-repeat=\"type in vm.typesServer\" \nng-value=\"type.val\">{{ type.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_server_name\">Nom\n</label><input type=\"text\" name=\"empConfigurationServerForm[serverName]\" required=\"required\" ng-name=\"name\" \nng-attr-name=\"serverName\" ng-model=\"vm.empConfigurationServerForm.serverName\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationServerForm.serverName.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.serverName && vm.empConfigurationServerForm.serverName === vm.empConfigurationServerError.serverName.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.serverName}}\">\nConfigurationServerError_name</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-card-content flex><md-select \ntranslate translate=\"SERVERADD.form_attr_protocol\" name=\"protocol\" id=\"empConfigurationServerForm_protocol\" \nng-model=\"vm.empConfigurationServerForm.protocol\" required=\"required\" aria-invalid=\"true\" \nplaceholder=\"{{ \'SERVERADD.form_attr_protocol\'|translate}}\"><md-option ng-repeat=\"protocol in vm.protocols\" \nng-value=\"protocol.val\">{{ protocol.option }}</md-option></md-select><div \nng-messages=\"empConfigurationServerForm.protocol.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.protocol && vm.empConfigurationServerForm.protocol === vm.empConfigurationServerError.protocol.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.protocol}}\">\nConfigurationServerError_protocol</div></div></md-card-content></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-model=\"vm.empConfigurationServerForm.internet\"><label translate=\"SERVERADD.form_attr_internet\">Internet\n</label></md-checkbox><div ng-messages=\"empConfigurationServerForm.internet.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.internet && vm.empConfigurationServerForm.internet === vm.empConfigurationServerError.internet.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.internet}}\">\nConfigurationServerError_internet</div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-model=\"vm.empConfigurationServerForm.record\"><label translate=\"SERVERADD.form_attr_record\">Record</label>\n</md-checkbox><div ng-messages=\"empConfigurationServerForm.record.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.record && vm.empConfigurationServerForm.record === vm.empConfigurationServerError.record.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.record}}\">\nConfigurationServerError_record</div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label class=\"md-no-float\" translate=\"SERVERADD.form_attr_name\">Nom</label><input type=\"text\" \nid=\"empConfigurationServerForm_name\" name=\"empConfigurationServerForm[name]\" required=\"required\" ng-name=\"name\" \nng-attr-name=\"name\" ng-model=\"vm.empConfigurationServerForm.name\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationServerForm.name.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.name && vm.empConfigurationServerForm.name === vm.empConfigurationServerError.name.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.name}}\">ConfigurationServerError_name\n</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"SERVERADD.form_attr_login\">identifiant</label><input type=\"text\" id=\"empConfigurationServerForm_login\" \nname=\"empConfigurationServerForm[login]\" required=\"required\" ng-name=\"login\" ng-attr-name=\"login\" \nng-model=\"vm.empConfigurationServerForm.login\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationServerForm.login.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.login && vm.empConfigurationServerForm.login === vm.empConfigurationServerError.login.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.login}}\">ConfigurationServerError_login\n</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"SERVERADD.form_attr_pwd\">Mot de passe</label><input type=\"text\" id=\"empConfigurationServerForm_pwd\" \nname=\"empConfigurationServerForm[pwd]\" ng-name=\"pwd\" ng-attr-name=\"pwd\" ng-model=\"vm.empConfigurationServerForm.pwd\" \naria-invalid=\"true\"><div ng-messages=\"empConfigurationServerForm.pwd.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.pwd && vm.empConfigurationServerForm.pwd === vm.empConfigurationServerError.pwd.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.pwd}}\">ConfigurationServerError_pwd\n</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"SERVERADD.form_attr_dir\">Répertoire</label><input type=\"text\" \nid=\"empConfigurationServerForm_dir\" name=\"empConfigurationServerForm[dir]\" required=\"required\" ng-name=\"dir\" \nng-attr-name=\"dir\" ng-model=\"vm.empConfigurationServerForm.dir\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationServerForm.dir.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.dir && vm.empConfigurationServerForm.dir === vm.empConfigurationServerError.dir.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.dir}}\">ConfigurationServerError_dir\n</div><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"SERVERADD.form_attr_urlVideo\">URL</label><input type=\"text\" id=\"empConfigurationServerForm_urlVideo\" \nname=\"empConfigurationServerForm[urlVideo]\" ng-name=\"urlVideo\" ng-model=\"vm.empConfigurationServerForm.urlVideo\" \naria-invalid=\"false\"><div ng-messages=\"empConfigurationServerForm.urlVideo.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlVideo && vm.empConfigurationServerForm.urlVideo === vm.empConfigurationServerError.urlVideo.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlVideo.message}}\">\nConfigurationServerError_urlVideo</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlMp4\">url Mp4</label><input \ntype=\"text\" id=\"empConfigurationServerForm_urlMp4\" name=\"empConfigurationServerForm[urlMp4]\" ng-name=\"urlMp4\" \nng-model=\"vm.empConfigurationServerForm.urlMp4\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlMp4.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlMp4 && vm.empConfigurationServerForm.urlMp4 === vm.empConfigurationServerError.urlMp4.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlMp4.message}}\">\nConfigurationServerError_urlMp4</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlDiffusion\">URL Diffusion</label>\n<input type=\"text\" id=\"empConfigurationServerForm_urlDiffusion\" name=\"empConfigurationServerForm[urlDiffusion]\" \nng-name=\"urlDiffusion\" ng-model=\"vm.empConfigurationServerForm.urlDiffusion\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlDiffusion.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlDiffusion && vm.empConfigurationServerForm.urlDiffusion === vm.empConfigurationServerError.urlDiffusion.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlDiffusion.message}}\">\nConfigurationServerError_urlDiffusion</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlVodAndroid\">URL Vod Android\n</label><input type=\"text\" id=\"empConfigurationServerForm_urlVodAndroid\" \nname=\"empConfigurationServerForm[urlVodAndroid]\" ng-name=\"urlVodAndroid\" \nng-model=\"vm.empConfigurationServerForm.urlVodAndroid\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlDiffusion.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlVodAndroid && vm.empConfigurationServerForm.urlVodAndroid === vm.empConfigurationServerError.urlVodAndroid.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlVodAndroid.message}}\">\nConfigurationServerError_urlVodAndroid</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlLiveAndroid\">URL Live Android\n</label><input type=\"text\" id=\"empConfigurationServerForm_urlLiveAndroid\" \nname=\"empConfigurationServerForm[urlLiveAndroid]\" ng-name=\"urlLiveAndroid\" \nng-model=\"vm.empConfigurationServerForm.urlLiveAndroid\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlLiveAndroid.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlLiveAndroid && vm.empConfigurationServerForm.urlLiveAndroid === vm.empConfigurationServerError.urlLiveAndroid.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlLiveAndroid.message}}\">\nConfigurationServerError_urlLiveAndroid</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlCdnAndroid\">URL CDN Android\n</label><input type=\"text\" id=\"empConfigurationServerForm_urlCdnAndroid\" \nname=\"empConfigurationServerForm[urlCdnAndroid]\" ng-name=\"urlCdnAndroid\" \nng-model=\"vm.empConfigurationServerForm.urlCdnAndroid\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlLiveAndroid.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlCdnAndroid && vm.empConfigurationServerForm.urlCdnAndroid === vm.empConfigurationServerError.urlCdnAndroid.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlCdnAndroid.message}}\">\nConfigurationServerError_urlCdnAndroid</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlVodIos\">Url VOD IOS</label><input\n type=\"text\" id=\"empConfigurationServerForm_urlVodIos\" name=\"empConfigurationServerForm[urlVodIos]\" \nng-name=\"urlVodIos\" ng-model=\"vm.empConfigurationServerForm.urlVodIos\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlVodIos.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlVodIos && vm.empConfigurationServerForm.urlVodIos === vm.empConfigurationServerError.urlVodIos.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlVodIos.message}}\">\nConfigurationServerError_urlVodIos</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlLiveIos\">Url Live IOS</label>\n<input type=\"text\" id=\"empConfigurationServerForm_urlLiveIos\" name=\"empConfigurationServerForm[urlLiveIos]\" \nng-name=\"urlLiveIos\" ng-model=\"vm.empConfigurationServerForm.urlLiveIos\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlLiveIos.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlLiveIos && vm.empConfigurationServerForm.urlLiveIos === vm.empConfigurationServerError.urlLiveIos.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlLiveIos.message}}\">\nConfigurationServerError_urlLiveIos</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlCdnIos\">Url CDN IOS</label><input\n type=\"text\" id=\"empConfigurationServerForm_urlCdnIos\" name=\"empConfigurationServerForm[urlCdnIos]\" \nng-name=\"urlCdnIos\" ng-model=\"vm.empConfigurationServerForm.urlCdnIos\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlCdnIos.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlCdnIos && vm.empConfigurationServerForm.urlCdnIos === vm.empConfigurationServerError.urlCdnIos.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlCdnIos.message}}\">\nConfigurationServerError_urlCdnIos</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_dirLecture\">Répertoire de lecture\n</label><input type=\"text\" id=\"empConfigurationServerForm_dirLecture\" name=\"empConfigurationServerForm[dirLecture]\" \nng-name=\"dirLecture\" ng-model=\"vm.empConfigurationServerForm.dirLecture\" aria-invalid=\"false\"></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"SERVERADD.form_attr_urlBackup\">Url Backup</label><input type=\"text\" \nid=\"empConfigurationServerForm_urlBackup\" name=\"empConfigurationServerForm[urlBackup]\" ng-name=\"urlBackup\" \nng-model=\"vm.empConfigurationServerForm.urlBackup\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlBackup.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlBackup && vm.empConfigurationServerForm.urlBackup === vm.empConfigurationServerError.urlBackup.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlBackup.message}}\">\nConfigurationServerError_urlBackup</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlMobile\">Url Mobile</label><input \ntype=\"text\" id=\"empConfigurationServerForm_urlMobile\" name=\"empConfigurationServerForm[urlMobile]\" ng-name=\"urlMobile\" \nng-model=\"vm.empConfigurationServerForm.urlMobile\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlMobile.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlMobile && vm.empConfigurationServerForm.urlMobile === vm.empConfigurationServerError.urlMobile.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlMobile.message}}\">\nConfigurationServerError_urlMobile</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_urlServerFtp\">URL du serveur FTP\n</label><input type=\"text\" id=\"empConfigurationServerForm_urlServerFtp\" \nname=\"empConfigurationServerForm[urlServerFtp]\" ng-name=\"urlServerFtp\" \nng-model=\"vm.empConfigurationServerForm.urlServerFtp\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.urlServerFtp.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.urlServerFtp && vm.empConfigurationServerForm.urlServerFtp === vm.empConfigurationServerError.urlServerFtp.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.urlServerFtp.message}}\">\nConfigurationServerError_urlServerFtp</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_loginLive\" \nfor=\"empConfigurationServerForm_loginLive\" class=\"ng-scope\">Login du live</label><input type=\"text\" \nid=\"empConfigurationServerForm_loginLive\" name=\"empConfigurationServerForm[loginLive]\" ng-name=\"loginLive\" \nng-model=\"vm.empConfigurationServerForm.loginLive\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.loginLive.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.loginLive && vm.empConfigurationServerForm.loginLive === vm.empConfigurationServerError.loginLive.value_old\" \ntranslate=\"VALIDATION.{{vm.empConfigurationServerError.loginLive}}\">ConfigurationServerError_loginLive</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"SERVERADD.form_attr_pwdLive\">Mot de passe du live</label><input type=\"text\" \nid=\"empConfigurationServerForm_pwdLive\" name=\"empConfigurationServerForm[pwdLive]\" ng-name=\"type\" \nng-attr-name=\"pwdLive\" ng-model=\"vm.empConfigurationServerForm.pwdLive\" aria-invalid=\"false\"><div \nng-messages=\"empConfigurationServerForm.pwdLive.$error\" role=\"alert\"><div \nng-if=\"vm.empConfigurationServerError.pwdLive && vm.empConfigurationServerForm.pwdLive === vm.empConfigurationServerError.pwdLive.value_old\" \nstyle=\"font-size: 12px\" translate=\"VALIDATION.{{vm.empConfigurationServerError.pwdLive}}\">\nConfigurationServerError_pwdLive</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"SERVERADD.form_attr_bitrate\" \nfor=\"empConfigurationServerForm_bitrate\" class=\"ng-scope\">\nLes bitrates à transferer au serveur de streaming (séparé par \',\')</label><input type=\"text\" \nid=\"empConfigurationServerForm_bitrate\" name=\"empConfigurationServerForm[bitrate]\" ng-name=\"bitrate\" \nng-model=\"vm.empConfigurationServerForm.bitrate\" aria-invalid=\"false\"></md-input-container></div><md-button \nclass=\"md-warn\" ui-sref=\"app.configuration_server_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationServerForm.$invalid || empConfigurationServerForm.$pristine\" \ntranslate=\"MESSAGES.form_add\" ng-if=\"vm.isNew\">form_add</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationServerForm.$invalid || empConfigurationServerForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" ng-if=\"!vm.isNew\">form_validate</md-button></form>");
$templateCache.put("app/main/configuration/server/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.configuration_server_detail_pagetitle\">\nconfiguration_server_detail_pagetitle</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.id\">id</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.server.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.protocol\">protocol</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.server.protocol }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.type\">type</strong></h3></div><div\n class=\"md-secondary\">{{ vm.server.type }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.internet\">internet</strong></h3>\n</div><div class=\"md-secondary\"><i ng-if=\"vm.server.internet === true\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"><span class=\"hide\">1</span></i> <i \nng-if=\"vm.server.internet === false\" class=\"icon-cancel red-500-fg\"><span class=\"hide\">1</span></i></div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.name\">name</strong></h3></div><div class=\"md-secondary\">{{ vm.server.name }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.login\">login</strong></h3></div><div class=\"md-secondary\">{{ vm.server.login }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.dir\">dir</strong></h3></div><div class=\"md-secondary\">{{ vm.server.dir }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.urlVideo\">urlVideo</strong></h3></div><div class=\"md-secondary\">{{ vm.server.urlVideo }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.urlMp4\">urlMp4</strong></h3></div><div class=\"md-secondary\">{{ vm.server.urlMp4 }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.urlDiffusion\">urlDiffusion</strong></h3></div><div class=\"md-secondary\">\n{{ vm.server.urlDiffusion }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlVodAndroid\">urlVodAndroid</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.server.urlVodAndroid }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlLiveAndroid\">urlLiveAndroid\n</strong></h3></div><div class=\"md-secondary\">{{ vm.server.urlLiveAndroid }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.urlCdnAndroid\">urlCdnAndroid</strong></h3></div><div class=\"md-secondary\">\n{{ vm.server.urlCdnAndroid }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlVodIos\">urlVodIos</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.server.urlVodIos }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlLiveIos\">urlLiveIos</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.server.urlLiveIos }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlCdnIos\">urlCdnIos\n</strong></h3></div><div class=\"md-secondary\">{{ vm.server.urlCdnIos }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.dirLecture\">\ndirLecture</strong></h3></div><div class=\"md-secondary\">{{ vm.server.dirLecture }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"SERVERDETAIL.urlBackup\">urlBackup</strong></h3></div><div class=\"md-secondary\">{{ vm.server.urlBackup }}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"SERVERDETAIL.urlMobile\">urlMobile</strong></h3></div><div class=\"md-secondary\">\n{{ vm.server.urlMobile }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.urlServerFtp\">urlServerFtp</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.server.urlServerFtp }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.loginLive\">loginLive</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.server.loginLive }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SERVERDETAIL.bitrate\">bitrate</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.server.bitrate }}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/presets/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/configuration/presets/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/configuration/presets/add_edit_view/form.template.html","<form name=\"empConfigurationPresetsForm\" method=\"post\" id=\"empConfigurationPresetsForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationPresetsForm.$valid && vm.submitAddPresetsForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"PRESETSADD.form_title\">\nform_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\">\n</md-icon><span translate=\"PRESETSEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\" translate=\"PRESETSADD.form_attr_name\">Nom</label><input \ntype=\"text\" id=\"empConfigurationPresetsForm_name\" name=\"empConfigurationPresetsForm[name]\" required=\"required\" \nng-attr-name=\"name\" ng-name=\"name\" ng-model=\"vm.empConfigurationPresetsForm.name\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationPresetsForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"PRESETSADD.form_attr_bitrateVideo\">\nBitrate vidéo</label><input type=\"text\" id=\"empConfigurationPresetsForm_bitrateVideo\" \nname=\"empConfigurationPresetsForm[bitrateVideo]\" required=\"required\" ng-attr-name=\"bitrateVideo\" \nng-name=\"bitrateVideo\" ng-model=\"vm.empConfigurationPresetsForm.bitrateVideo\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationPresetsForm.bitrateVideo.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"PRESETSADD.form_attr_bitrateAudio\">\nBitrate audio</label><input type=\"text\" id=\"empConfigurationPresetsForm_bitrateAudio\" \nname=\"empConfigurationPresetsForm[bitrateAudio]\" required=\"required\" ng-attr-name=\"bitrateAudio\" \nng-name=\"bitrateAudio\" ng-model=\"vm.empConfigurationPresetsForm.bitrateAudio\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationPresetsForm.bitrateAudio.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"PRESETSADD.form_attr_samplerateAudio\">Fréquence d\'échantillonnage audio</label><input type=\"text\" \nid=\"empConfigurationPresetsForm_samplerateAudio\" name=\"empConfigurationPresetsForm[samplerateAudio]\" \nrequired=\"required\" ng-attr-name=\"samplerateAudio\" ng-name=\"samplerateAudio\" \nng-model=\"vm.empConfigurationPresetsForm.samplerateAudio\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationPresetsForm.samplerateAudio.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"PRESETSADD.form_attr_framerate\">\nFréquence d\'images</label><input type=\"number\" id=\"empConfigurationPresetsForm_framerate\" \nname=\"empConfigurationPresetsForm[framerate]\" required=\"required\" ng-attr-name=\"framerate\" ng-pattern=\"/^[0-9]*$/\" \nng-name=\"framerate\" ng-model=\"vm.empConfigurationPresetsForm.framerate\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationPresetsForm.framerate.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_entier\">Ce champ ne peut contenir qu\'une valeur entier</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-checkbox ng-model=\"vm.empConfigurationPresetsForm.state\"><label class=\"md-no-float\" \ntranslate=\"PRESETSADD.form_attr_state\" class=\"ng-scope\">Etat</label></md-checkbox></div><md-button class=\"md-warn\" \nui-sref=\"app.configuration_presets_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationPresetsForm.$invalid || empConfigurationPresetsForm.$pristine\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationPresetsForm.$invalid || empConfigurationPresetsForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/configuration/server/list/list.template.html","<md-content ng-if=\"!vm.isNewServer\" id=\"modal\" autoscroll=\"false\" ui-view=\"modal\"></md-content><div \nng-if=\"!vm.isNewServer\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedServers.length\"><a tooltips tooltip-template=\"{{\'SERVERLIST.delete_servers_aria_label\'|translate}}\" \ntooltip-side=\"right\" tooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedServerConfirm($event)\" aria-label=\"delete_servers_aria_label\" translate \ntranslate-attr-aria-label=\"SERVERLIST.delete_servers_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><md-input-container flex=\"\" style=\"margin-left: 18px\"><label \ntranslate=\"SERVERADD.form_attr_type\">Type</label><md-select translate \ntranslate-attr-aria-label=\"SERVERADD.form_attr_type\" ng-model=\"vm.empServerList.type\" ng-change=\"vm.searchServers()\" \nplaceholder=\"Type\" class=\"black-text\" translate translate-attr-placeholder=\"MESSAGES.search\"><md-option value=\"\" \ntranslate=\"SERVERLIST.none\"></md-option><md-option ng-repeat=\"type in vm.types\" ng-value=\"type.val\">{{ type.option }}\n</md-option></md-select><div ng-messages=\"empConfigurationServerForm.type.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container><div \nflex=\"\" layout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"canals-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_servers\" \nng-keydown=\"$event.keyCode === 13 && vm.searchServers()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewServer($event)\" \naria-label=\"action_new_element\" has-permission=\"configuration_server_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedServers.length === vm.servers.length) && (vm.selectedServers.length > 0)\" \nmd-indeterminate=\"vm.selectedServers.length !== 0 && vm.selectedServers.length !== vm.servers.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"SERVERLIST.type\">type</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"SERVERLIST.access\">access</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"SERVERLIST.identifier\">identifier</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"SERVERLIST.url\">url</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"SERVERLIST.url_mp4\">url_mp4</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"SERVERLIST.url_diffusion\">\nurl_diffusion</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div>\n</div></div></div><div ng-if=\"vm.isNewServer\" id=\"e-commerce-products\" \nclass=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \nng-src=\"{{ServerIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/configuration/referrers/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"referrer_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.configuration_referrer_detail_pagetitle\">\nconfiguration_referrer_detail_pagetitle</span> <span>{{ vm.referrer.title |json }}</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"REFERRERDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.referrer.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"REFERRERDETAIL.title\">title</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.referrer.title }}</div><md-divider></md-divider></md-list-item><md-list-item \nng-if=\"vm.referrer.parent\" class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"REFERRERDETAIL.parent\">parent</strong></h3></div><div class=\"md-secondary\">{{ vm.referrer.parent.title }}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"REFERRERDETAIL.visible\">visible</strong></h3></div><div class=\"md-secondary\">\n{{ vm.referrer.visible }}</div><md-divider></md-divider></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" \ntranslate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/configuration/referrers/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div \nng-include=\"\'app/main/configuration/referrers/add_edit_view/form.template.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/configuration/referrers/add_edit_view/form.template.html","<form name=\"empConfigurationReferrerForm\" method=\"post\" id=\"empConfigurationReferrerForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationReferrerForm.$valid && vm.submitAddReferrerForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"REFERRERADD.form_title\">\nform_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\">\n</md-icon><span translate=\"REFERREREDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label class=\"md-no-float\">URL</label><input type=\"url\" id=\"empConfigurationReferrerForm_url\" \nname=\"empConfigurationReferrerForm[url]\" required=\"required\" ng-attr-name=\"url\" \nng-model=\"vm.empConfigurationReferrerForm.url\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationReferrerForm.url.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"url\" \ntranslate=\"EVENTADD.ivalid_URL_format\">ivalid_URL_format</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-card-content flex><md-select translate translate=\"MESSAGES.form_attr_mode\" \nname=\"empConfigurationReferrerForm[mode]\" id=\"empConfigurationReferrerForm_mode\" \nng-model=\"vm.empConfigurationReferrerForm.mode\" required=\"required\" placeholder=\"Mode\"><md-option \nng-repeat=\"visibilityChoice in vm.visibilityChoices\" ng-value=\"visibilityChoice.val\" \ntranslate=\"MESSAGES.{{ visibilityChoice.options }}\">{{ visibilityChoice.options }}</md-option></md-select><div \nng-messages=\"empConfigurationReferrerForm.visible.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-card-content></div><md-button class=\"md-warn\" \nui-sref=\"app.referrers_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empConfigurationReferrerForm.$invalid || empConfigurationReferrerForm.$pristine\" \ntranslate=\"MESSAGES.form_add\" translate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button \nng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empConfigurationReferrerForm.$invalid || empConfigurationReferrerForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/configuration/mooc/list/list.controller_template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"key\"><form name=\"ppForm\" class=\"md-inline-form\" novalidate><md-toolbar\n class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon><span translate=\"MOOCPARAMETERSLIST.dialog_title\"></span> \n<span>{{vm.pair.key}}</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label>{{vm.pair.key}}</label><input name=\"key\" ng-model=\"vm.pair.value\" md-autofocus md-select>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"vm.editPPKey($event)\" class=\"save-button md-accent md-raised\" \nng-disabled=\"ppForm.$invalid || ppForm.$pristine\" translate=\"MESSAGES.form_validate\" aria-label=\"validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\"></md-button><md-button class=\"md-warn md-flat\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.dialog_cancel\">CLOSE</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/configuration/mooc/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div style=\"margin-left: 8%\" layout=\"row\" layout-align=\"start center\" flex has-permission=\"playlist_delete_multi\" \nng-if=\"vm.selectedParamss.length\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'MOOCPARAMETERSLIST.delete_multi_cle\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedParamsConfirm($event)\" \naria-label=\"delete_param\" translate translate-attr-aria-label=\"MOOCPARAMETERSLIST.delete_multi_cle\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"pp-search\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex></md-input-container>\n</div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewMooc($event)\" \naria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg \nxmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedParamss.length === vm.moocParametersArray.length) && (vm.selectedParamss.length > 0)\" \nmd-indeterminate=\"vm.selectedParamss.length !== 0 && vm.selectedParamss.length !== vm.moocParametersArray.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MOOCPARAMETERSLIST.type\">type</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MOOCPARAMETERSLIST.value\">value\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead><tbody><tr \nng-repeat=\"param in vm.moocParametersArray track by param.key\" ng-attr-data-index=\"{{$index}}\"><td><md-checkbox \nng-checked=\"param.checked\" ng-click=\"vm.toggle(param)\" aria-label=\"-\"></md-checkbox></td><td><strong>{{param.key}}\n</strong></td><td>{{param.value}}</td><td><a tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"edit-button md-icon-button\" \nng-click=\"vm.openPPEditDialog(param,$index,$event)\" aria-label=\"translate\" \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'PARAMLIST.delete_param\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteParamsConfirm(param,ev)\" \naria-label=\"delete_param\" translate translate-attr-aria-label=\"PARAMLIST.delete_param\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></a></td></tr></tbody></table></div></div>");
$templateCache.put("app/main/configuration/referrers/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedReferrers.length\" \nhas-permission=\"configuration_referrers_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'REFERRERLIST.delete_referrers_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedReferrersConfirm($event)\" \naria-label=\"delete_referrers_aria_label\" translate \ntranslate-attr-aria-label=\"REFERRERLIST.delete_referrers_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\" style=\"margin-left:18px\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"referrers-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_referrers\" ng-keydown=\"$event.keyCode === 13 && vm.searchReferrers()\"></md-input-container></div>\n<md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewReferrer($event)\" \naria-label=\"action_new_element\" has-permission=\"referrers_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedReferrers.length === vm.referrers.length) && (vm.selectedReferrers.length > 0)\" \nmd-indeterminate=\"vm.selectedReferrers.length !== 0 && vm.selectedReferrers.length !== vm.referrers.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\">URL</span></div></th><th class=\"secondary-text\" data-priority=\"2\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\">Mode</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/configuration/mooc/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/configuration/client/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/configuration/mooc/add_edit_view/form.template.html","<form name=\"empParamForm\" method=\"post\" id=\"empParamForm\" novalidate=\"novalidate\" \nng-submit=\"empParamForm.$valid && vm.submitAddParamForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"PARAMADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"PARAMEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"PARAMADD.form_attr_cle\">clé</label><input type=\"text\" id=\"empParamForm_cle\" \nname=\"empParamForm[cle]\" required=\"required\" ng-attr-name=\"cle\" ng-name=\"cle\" ng-model=\"vm.empParamForm.cle\" \naria-invalid=\"true\"><div ng-messages=\"empParamForm.cle.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" translate=\"PARAMADD.form_attr_value\">valeur\n</label><input type=\"text\" id=\"empParamForm_value\" name=\"empParamForm[value]\" required=\"required\" ng-attr-name=\"value\" \nng-name=\"value\" ng-model=\"vm.empParamForm.value\" aria-invalid=\"true\"><div ng-messages=\"empParamForm.value.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.param_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empParamForm.$invalid || empParamForm.$pristine\" translate=\"MESSAGES.form_add\">form_add</md-button>\n<md-button ng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empParamForm.$invalid || empParamForm.$pristine\" translate=\"MESSAGES.form_validate\">form_validate\n</md-button></form>");
$templateCache.put("app/main/display/blockComponent/weather_component/weather.html","<div ng-if=\"$ctrl.location\" style=\"width:100%\"><h2><span translate=\"TEMPALTEMANAGEREDITOR.weather_on\"></span> <strong>\n{{$ctrl.options.location}}</strong></h2><div ng-if=\"$ctrl.weather.tempImg\" style=\"float:left\"><img \nng-src=\"{{$ctrl.weather.tempImg}}\"></div><h3><span translate=\"TEMPALTEMANAGEREDITOR.current\"></span> <span>\n{{$ctrl.weather.temp.current | temp:2}}</span></h3><span>\nmin: {{$ctrl.weather.temp.min | temp}}, max: {{$ctrl.weather.temp.max | temp}}</span></div>");
$templateCache.put("app/main/display/schedule/add/add.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><div flex><div class=\"price-tables\" flex layout=\"row\"><md-content flex><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\"><md-truncate><span class=\"logo-text\" translate=\"DISPLAYSCHEDULEADD.newSchedule\">\nNew Schedule</span> <strong ng-if=\"vm.schedule.title\">: {{vm.schedule.title}}</strong></md-truncate><span flex></span> \n<a tooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'form\'] = 0\" ng-if=\"vm.expanded[\'form\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'form\'] = 1\" ng-if=\"!vm.expanded[\'form\']\" class=\"md-icon-button\" \naria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\">\n</md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" layout=\"row\" class=\"p-10\" \nng-hide=\"!vm.expanded[\'form\']\"><form name=\"programForm\" ng-submit=\"vm.addNewSchedule()\" class=\"flex\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 46px\"><label \ntranslate=\"DISPLAYSCHEDULEADD.title\">Title</label><input name=\"title\" ng-model=\"vm.schedule.title\" required \nmd-autofocus style=\"height: 26px\"><div ng-messages=\"programForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empScheduleError.title && vm.schedule.title === vm.empScheduleError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empScheduleError.title.message}}\" class=\"validation_api\">empScheduleError_name</div></div>\n</md-input-container><md-input-container flex><label translate=\"DISPLAYSCHEDULEADD.description\">Description</label><div\n class=\"md-resize-wrapper\"><textarea name=\"description\" ng-model=\"vm.schedule.description\" md-maxlength=\"450\" rows=\"2\" \nmax-rows=\"8\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 20px !important\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between\"><md-checkbox ng-model=\"vm.schedule.enable\" aria-label=\"Enable\" \nstyle=\"position: relative;top: 50%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%);margin-top: 10px\">\n<label translate=\"DISPLAYSCHEDULEADD.check_to_enbale\">check_to_enbale</label></md-checkbox><md-button type=\"submit\" \nclass=\"md-accent md-raised\" \nng-disabled=\"(programForm.$invalid || vm.events.length == 0) || (programForm.$pristine || vm.events.length == 0)\" \naria-label=\"vm.isNew ? Save : Edit\"><span translate=\"DISPLAYSCHEDULEADD.add\">add</span></md-button></div></form></div>\n</md-content></div><div class=\"price-tables\" flex layout=\"row\" style=\"margin-top:20px\"><div flex=\"79\"><md-content \nng-cloack><md-toolbar><div class=\"md-toolbar-tools pv-5\" style=\"font-size: 13px\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.PREVIOUS\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev();vm.calendar.rerenderEvents()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><md-truncate><span style=\"font-size: 17px\"><strong>\n{{vm.calendarView.title}}</strong></span></md-truncate><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.NEXT\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next();vm.calendar.rerenderEvents()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></a><span flex></span> <a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today();vm.calendar.rerenderEvents();vm.click(\'today\')\" aria-label=\"Today\"><md-icon \ndata-ng-style=\"vm.type===\'today\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-calendar-today\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\');vm.calendar.rerenderEvents();vm.click(\'agendaDay\')\" aria-label=\"Day\">\n<md-icon data-ng-style=\"vm.type===\'agendaDay\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\');vm.calendar.rerenderEvents();vm.click(\'agendaWeek\')\" aria-label=\"Week\">\n<md-icon data-ng-style=\"vm.type===\'agendaWeek\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-week\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'month\');vm.calendar.rerenderEvents();vm.click(\'month\')\" aria-label=\"Month\"><md-icon \ndata-ng-style=\"vm.type===\'month\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-module\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'calendar\'] = 0\" ng-if=\"vm.expanded[\'calendar\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'calendar\'] = 1\" ng-if=\"!vm.expanded[\'calendar\']\" \nclass=\"md-icon-button\" aria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s24\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULEADD.programs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'programs-sidenav\')\" hide-gt-md aria-label=\"programs\" \ntranslate translate-attr-aria-label=\"DISPLAYSCHEDULEADD.programs\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\">\n</md-icon></md-button></a></div></md-toolbar><div ng-if=\"vm.type!=\'month\'\" flex=\"100\" layout=\"column\" \nstyle=\"text-align: right;padding-right: 24px\"><div><br><span translate=\"DISPLAYSCHEDULEADD.slot\" \nstyle=\"color: #2D323E !important;font-size: 13px\">slot</span></div><div><md-input-container style=\"margin: 8px 0\">\n<input type=\"number\" min=\"1\" ng-model=\"vm.slot\" ng-change=\"vm.changeSlot()\" \nstyle=\"background: #F9F9F9;border: 1px solid;width:50px\"></md-input-container></div></div><div \ndata-ng-style=\"vm.type===\'month\' && {\'margin-top\':\'100px\'}\" layout-align=\"start center\" layout=\"row\" \nclass=\"mv-10 p-24 h-700\" ng-hide=\"!vm.expanded[\'calendar\']\" ms-scroll style=\"padding-top: 0px;margin-top: 0px\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div>\n</md-content></div><div flex=\"20\"><md-sidenav class=\"sidenav settings-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"programs-sidenav\" ms-scroll ms-sidenav-helper \nstyle=\"padding: 0px 0px 0px;padding-left: 5px\"><md-toolbar><div class=\"md-toolbar-tools\"><md-truncate><span \nclass=\"logo-text\" translate=\"DISPLAYSCHEDULEEDIT.programs\">Programs</span></md-truncate></div></md-toolbar><md-content \nflex style=\"background: transparent\"><md-input-container class=\"md-block\"><input ng-model=\"vm.templateName\" \nng-change=\"vm.searchTenTemplates()\" placeholder=\"{{\'DISPLAYSCHEDULEADD.filter_by\'|translate}}\"></md-input-container>\n<div class=\"programs-sidenav\"><md-list style=\"overflow: hidden; padding-top: 0px; margin-top: -10px\" \nng-if=\"vm.programsss.length\" ng-model=\"vm.programsss\" ui-sortable=\"vm.dragOptions\"><md-list-item \ndir-paginate=\"program in vm.programsss| filter:vm.templateName | itemsPerPage:10\" total-items=\"vm.totalPrograms\" \ncurrent-page=\"vm.pagination.current\" ng-attr-data-index=\"{{$index}}\"><div class=\"myHandle md-primary-bg\"></div><strong>\n{{program}}</strong><md-divider></md-divider></md-list-item></md-list><div \nstyle=\"margin-left: -43px;margin-top: -16px\"><dir-pagination-controls ng-if=\"vm.programs.length\" class=\"paginationDir\" \nboundary-links=\"true\" on-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div><div \nclass=\"text-center\" ng-if=\"!vm.programs.length\"><label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label>\n</div></div></md-content></md-sidenav></div></div></div></div></div>");
$templateCache.put("app/main/display/schedule/add/programs-sidenav.html","<div class=\"programs-sidenav\"><md-list style=\"overflow: hidden\" ng-if=\"vm.programsss.length\" ng-model=\"vm.programsss\" \nui-sortable=\"vm.dragOptions\"><md-list-item \nng-repeat=\"program in vm.programsss | filter:vm.templateName | orderBy:\'title\' \" ng-attr-data-index=\"{{$index}}\">\n<md-divider></md-divider><div class=\"myHandle md-primary-bg\"></div><strong>{{program}}</strong><md-divider>\n</md-divider></md-list-item></md-list><div class=\"text-center\" ng-if=\"!vm.programs.length\"><label \ntranslate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>");
$templateCache.put("app/main/display/schedule/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\" \nstyle=\"min-height: 200px!important;max-height: 200px!important;height: 200px!important\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><md-button style=\"position: absolute; z-index: 10\" class=\"md-icon-button\" \nng-click=\"vm.showListe()\" aria-label=\"Today\"><md-tooltip md-autohide=\"true\" md-direction=\"top\"><span \ntranslate=\"PAGESMENUSTITLES.display_schedule_calendar_pagetitle\">display_schedule_calendar_pagetitle</span>\n</md-tooltip><md-icon md-font-icon=\"icon-calendar-text\"></md-icon></md-button><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" style=\"top:30%\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"DISPLAYSCHEDULECALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" \naria-label=\"Today\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" \naria-label=\"Week\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.WEEK\"><md-icon \nmd-font-icon=\"icon-view-week\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n</md-button></a></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/display/schedule/list/list.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div style=\"margin-left: 3%\" layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedschedules.length\"><a \ntooltips tooltip-template=\"{{\'ABONNEMENTUSERLIST.delete_user\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedschedulesConfirm($event)\" aria-label=\"delete_user\" \ntranslate translate-attr-aria-label=\"ABONNEMENTUSERLIST.delete_user\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><md-button class=\"md-icon-button btn-delete\" \nng-click=\"vm.showCalendar()\" aria-label=\"show_calendar\" translate translate-attr-aria-label=\"EVENTLIST.show_calendar\">\n<md-tooltip md-autohide=\"true\" md-direction=\"top\"><span translate=\"EVENTLIST.show_calendar\">show_calendar</span>\n</md-tooltip><md-icon md-font-icon=\"icon-calendar-multiple\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-multiple\" aria-hidden=\"true\"></md-icon>\n</md-button><div flex=\"\" layout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"abonnement-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_Schedule\" ng-change=\"vm.searchSchedule()\">\n</md-input-container></div><div layout=\"row\" layout-align=\"end end\"><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewSchedule($event)\" \naria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg \nxmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th><md-checkbox style=\"margin-left: 40%\" aria-label=\"-\" \nng-checked=\"(vm.selectedschedules.length === vm.schedules.length) && (vm.selectedschedules.length > 0)\" \nmd-indeterminate=\"vm.selectedschedules.length !== 0 && vm.selectedschedules.length !== vm.schedules.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"DISPLAYSCHEDULECALENDAR.TITLE\">title</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"DISPLAYSCHEDULECALENDAR.STARTAT\">debut</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"DISPLAYSCHEDULECALENDAR.ENDAT\">fin\n</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div>\n</div>");
$templateCache.put("app/main/display/schedule/edit/edit.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><div flex><div class=\"price-tables\" flex layout=\"row\"><md-content flex><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\"><md-truncate><span class=\"logo-text\" translate=\"DISPLAYSCHEDULEEDIT.editSchedule\">\nModifier Schedule</span> <strong ng-if=\"vm.schedule.title\">: {{vm.schedule.title}}</strong></md-truncate><span flex>\n</span> <a tooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button ng-click=\"vm.expanded[\'form\'] = 0\" ng-if=\"vm.expanded[\'form\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'form\'] = 1\" ng-if=\"!vm.expanded[\'form\']\" class=\"md-icon-button\" \naria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\">\n</md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" layout=\"row\" class=\"p-10\" \nng-hide=\"!vm.expanded[\'form\']\"><form name=\"programForm\" ng-submit=\"vm.updateSchedule()\" class=\"flex\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex style=\"margin-top: 46px\"><label \ntranslate=\"DISPLAYSCHEDULEEDIT.title\">Title</label><input name=\"title\" ng-model=\"vm.schedule.title\" required \nmd-autofocus style=\"height: 26px\"><div ng-messages=\"programForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empScheduleError.title && vm.schedule.title === vm.empScheduleError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empScheduleError.title.message}}\" class=\"validation_api\">empScheduleError_name</div></div>\n</md-input-container><md-input-container flex><label translate=\"DISPLAYSCHEDULEEDIT.description\">Description</label>\n<div class=\"md-resize-wrapper\"><textarea name=\"description\" ng-model=\"vm.schedule.description\" md-maxlength=\"450\" \nrows=\"2\" max-rows=\"8\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 20px !important\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-between\"><md-checkbox ng-model=\"vm.schedule.enable\" aria-label=\"Enable\" \nstyle=\"position: relative;top: 50%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%);margin-top: 10px\">\n<label translate=\"DISPLAYSCHEDULEEDIT.check_to_enbale\">check_to_enbale</label></md-checkbox><md-button type=\"submit\" \nclass=\"md-accent md-raised\" \nng-disabled=\"(programForm.$invalid || vm.events.length == 0) || (programForm.$pristine || vm.events.length == 0)\" \naria-label=\"vm.isNew ? Save : Edit\"><span translate=\"DISPLAYSCHEDULEEDIT.edit\">edit</span></md-button></div></form>\n</div></md-content></div><div class=\"price-tables\" flex layout=\"row\" style=\"margin-top:20px\"><div flex=\"79\"><md-content\n ng-cloack><md-toolbar><div class=\"md-toolbar-tools pv-5\" style=\"font-size: 13px\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.PREVIOUS\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev();vm.calendar.rerenderEvents()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><md-truncate><span style=\"font-size: 17px\"><strong>\n{{vm.calendarView.title}}</strong></span></md-truncate><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.NEXT\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next();vm.calendar.rerenderEvents()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></a><span flex></span> <a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today();vm.calendar.rerenderEvents();vm.click(\'today\')\" aria-label=\"Today\"><md-icon \ndata-ng-style=\"vm.type===\'today\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-calendar-today\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\');vm.calendar.rerenderEvents();vm.click(\'agendaDay\')\" aria-label=\"Day\">\n<md-icon data-ng-style=\"vm.type===\'agendaDay\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\');vm.calendar.rerenderEvents();vm.click(\'agendaWeek\')\" aria-label=\"Week\">\n<md-icon data-ng-style=\"vm.type===\'agendaWeek\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-week\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'month\');vm.calendar.rerenderEvents();vm.click(\'month\')\" aria-label=\"Month\"><md-icon \ndata-ng-style=\"vm.type===\'month\' && {\'opacity\':\'.4\'}\" md-font-icon=\"icon-view-module\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'calendar\'] = 0\" ng-if=\"vm.expanded[\'calendar\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'calendar\'] = 1\" ng-if=\"!vm.expanded[\'calendar\']\" \nclass=\"md-icon-button\" aria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s24\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULEEDIT.programs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'programs-sidenav\')\" hide-gt-md aria-label=\"programs\" \ntranslate translate-attr-aria-label=\"DISPLAYSCHEDULEEDIT.programs\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\">\n</md-icon></md-button></a></div></md-toolbar><div ng-if=\"vm.type!=\'month\'\" flex=\"100\" layout=\"column\" \nstyle=\"text-align: right;padding-right: 24px\"><div><br><span translate=\"DISPLAYSCHEDULEADD.slot\" \nstyle=\"color: #2D323E !important;font-size: 13px\">slot</span></div><div><md-input-container style=\"margin: 8px 0\">\n<input type=\"number\" min=\"1\" ng-model=\"vm.slot\" ng-change=\"vm.changeSlot()\" \nstyle=\"background: #F9F9F9;border: 1px solid;width:50px\"></md-input-container></div></div><div \ndata-ng-style=\"vm.type===\'month\' && {\'margin-top\':\'100px\'}\" layout-align=\"start center\" layout=\"row\" \nclass=\"mv-10 p-24 h-700\" ng-hide=\"!vm.expanded[\'calendar\']\" ms-scroll style=\"padding-top: 0px;margin-top: 0px\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div>\n</md-content></div><div flex=\"20\"><md-sidenav class=\"sidenav settings-sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"programs-sidenav\" ms-scroll ms-sidenav-helper \nstyle=\"padding: 0px 0px 0px;padding-left: 5px\"><md-toolbar><div class=\"md-toolbar-tools\"><md-truncate><span \nclass=\"logo-text\" translate=\"DISPLAYSCHEDULEEDIT.programs\">Programs</span></md-truncate></div></md-toolbar><md-content \nflex style=\"background: transparent\"><md-input-container class=\"md-block\"><input ng-model=\"vm.templateName\" \nng-change=\"vm.searchTenTemplates()\" placeholder=\"{{\'DISPLAYSCHEDULEADD.filter_by\'|translate}}\"></md-input-container>\n<div class=\"programs-sidenav\"><md-list style=\"overflow: hidden; padding-top: 0px; margin-top: -10px\" \nng-if=\"vm.programsss.length\" ng-model=\"vm.programsss\" ui-sortable=\"vm.dragOptions\"><md-list-item \ndir-paginate=\"program in vm.programsss| filter:vm.templateName | itemsPerPage:10\" total-items=\"vm.totalPrograms\" \ncurrent-page=\"vm.pagination.current\" ng-attr-data-index=\"{{$index}}\"><div class=\"myHandle md-primary-bg\"></div><strong>\n{{program}}</strong><md-divider></md-divider></md-list-item></md-list><div \nstyle=\"margin-left: -43px;margin-top: -16px\"><dir-pagination-controls ng-if=\"vm.programs.length\" class=\"paginationDir\" \nboundary-links=\"true\" on-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div><div \nclass=\"text-center\" ng-if=\"!vm.programs.length\"><label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label>\n</div></div></md-content></md-sidenav></div></div></div></div></div>");
$templateCache.put("app/main/display/schedule/edit/programs-sidenav.html","<div class=\"programs-sidenav\"><md-list ms-scroll ng-if=\"vm.templates.length\" ng-model=\"vm.templates\" \nui-sortable=\"vm.dragOptions\"><md-list-item ng-repeat=\"template in ::vm.templates track by template.id\" \nng-attr-data-index=\"{{$index}}\"><div class=\"myHandle md-primary-bg\"></div><strong>{{template.title}}</strong>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div class=\"text-center\" ng-if=\"!vm.templates.length\">\n<label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>");
$templateCache.put("app/main/display/disposition/add/add.html","<div id=\"editor-page\" layout=\"row\" style=\"height:100%; background-color: #1c1f28\"><div class=\"center\" flex ms-scroll \nstyle=\"height: 100%\"><div layout=\"column\" layout-align=\"space-between stretch\" id=\"contenteditor\" \nstyle=\"background-color: #2e3440;width: 98%; left:1%; top:10px;   height: 80%;padding: 20px !important; overflow-x:auto;position: relative\">\n<div gridster=\"gridsterOptions\" style=\"width: 100%;margin: 0 !important\"><ul><li gridster-item=\"widget\" \nstyle=\"background: white\" ng-repeat=\"widget in customItems\"><div style=\"margin-top: -16px\" class=\"box\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"box-header\"><h3 style=\"height: 100%;width: 100%\">\n{{widget.name}}</h3><md-button style=\"margin-right: -18px\" class=\"md-icon-button\" ng-click=\"vm.deleteWidget(widget)\" \naria-label=\"Favorite\"><md-icon style=\"color: #0000008a !important\" md-font-icon=\"icon-delete\"></md-icon></md-button>\n</div><div><div style=\"display: table;margin: 0 auto\"><md-icon style=\"margin-top: 10%\" md-font-icon=\"{{widget.icon}}\" \nclass=\"black-text icon s48\"></md-icon></div><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" \nflex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><h3><strong>Height</strong></h3><div \nclass=\"md-secondary\">{{widget.h}}</div></md-list-item><md-list-item class=\"md-1-line\"><h3><strong>Width</strong></h3>\n<div class=\"md-secondary\">{{widget.w}}</div></md-list-item></md-list></div></div></div></li></ul></div><div \nclass=\"save-disp-area\"><div style=\"text-align: right\"><md-icon id=\"icon-down-save\" md-font-icon=\"icon-menu-down\" \nng-click=\"vm.changeBtnSave()\" class=\"save-btn-down\" class=\"s22\"></md-icon></div><div ng-if=\"vm.btnSave\" \nclass=\"save-disp-button-area\"><md-icon md-font-icon=\"icon-sync\" style=\"cursor: pointer;color: #969696\" class=\"s24\" \nng-click=\"vm.clear()\"></md-icon><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"save-disp-button\" \naria-label=\"Submit\" translate=\"MESSAGES.form_save\">form_save</md-button></div></div></div><div id=\"listbtn\" \nlayout=\"column\" layout-align=\"space-around center\" id=\"block\" \nstyle=\"overflow-x:hidden;position: absolute; width: 100%; height: 17%; top: 80.5%;  background-color: #282c36\"><div \nlayout=\"row\" style=\"top:10%\"><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"obj in vm.listSelect\" \nstyle=\"height: 85%; width: 100%; overflow-x: auto\"><ms-widget id=\"blockfacebook\" layout=\"column\" \nng-click=\"vm.changeWidget(obj)\" \nstyle=\"height: 50%;min-width: 110px;position: relative;padding:0px;margin-right: 15px;background-color: transparent;cursor: pointer\">\n<ms-widget-front layout=\"column\" class=\"widget-card elemnt-dispo\" id=\"elemntadd\"><span class=\"md-subhead\">{{obj.type}}\n</span><div layout=\"row\" layout-align=\"space-around center\" id=\"draggable-5\" class=\"block-dispo\" \nstyle=\"cursor: pointer!important\"><md-icon style=\"margin-top: 10%; margin-left: 10%  ;   color: #8f99b2 !important\" \nmd-font-icon=\"{{obj.icon}}\" class=\"black-text icon s48\"></md-icon></div></ms-widget-front></ms-widget></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/disposition/add/config-modal.html","<md-dialog style=\"min-width: 50%\" aria-label=\"abonnement_group_detail_pagetitle\"><md-dialog-content>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/display/disposition/edit/edit.html","<div id=\"editor-page\" layout=\"row\" style=\"height:100%; background-color: #1c1f28\"><div class=\"center\" flex ms-scroll \nstyle=\"height: 100%\"><div layout=\"column\" layout-align=\"space-between stretch\" id=\"contenteditor\" \nstyle=\"background-color: #2e3440;width: 98%; left:1%; top:10px;   height: 80%;padding: 20px !important; overflow-x:auto;position: relative\">\n<div gridster=\"gridsterOptions\" style=\"width: 100%;margin: 0 !important\"><ul><li gridster-item=\"widget\" \nstyle=\"background: white\" ng-repeat=\"widget in customItems\"><div style=\"margin-top: -16px\" class=\"box\"><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"box-header\"><h3 style=\"height: 100%;width: 100%\">\n{{widget.name}}</h3><md-button style=\"margin-right: -18px\" class=\"md-icon-button\" ng-click=\"vm.deleteWidget(widget)\" \naria-label=\"Favorite\"><md-icon style=\"color: #0000008a !important\" md-font-icon=\"icon-delete\"></md-icon></md-button>\n</div><div><div style=\"display: table;margin: 0 auto\"><md-icon style=\"margin-top: 10%\" md-font-icon=\"{{widget.icon}}\" \nclass=\"black-text icon s48\"></md-icon></div><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" \nflex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><h3><strong>Height</strong></h3><div \nclass=\"md-secondary\">{{widget.sizeY}}</div></md-list-item><md-list-item class=\"md-1-line\"><h3><strong>Width</strong>\n</h3><div class=\"md-secondary\">{{widget.sizeX}}</div></md-list-item></md-list></div></div></div></li></ul></div><div \nclass=\"save-disp-area\"><div style=\"text-align: right\"><md-icon id=\"icon-down-save\" md-font-icon=\"icon-menu-down\" \nng-click=\"vm.changeBtnSave()\" class=\"save-btn-down\" class=\"s22\"></md-icon></div><div ng-if=\"vm.btnSave\" \nclass=\"save-disp-button-area\"><md-icon md-font-icon=\"icon-sync\" style=\"cursor: pointer;color: #969696\" class=\"s24\" \nng-click=\"vm.clear()\"></md-icon><md-button type=\"submit\" ng-click=\"vm.save()\" class=\"save-disp-button\" \naria-label=\"Submit\" translate=\"MESSAGES.form_save\">form_save</md-button></div></div></div><div id=\"listbtn\" \nlayout=\"column\" layout-align=\"space-around center\" id=\"block\" \nstyle=\"overflow-x:hidden;position: absolute; width: 100%; height: 17%; top: 80.5%;  background-color: #282c36\"><div \nlayout=\"row\" style=\"top:10%\"><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"obj in vm.listSelect\" \nstyle=\"height: 85%; width: 100%; overflow-x: auto\"><ms-widget id=\"blockfacebook\" layout=\"column\" \nng-click=\"vm.changeWidget(obj)\" \nstyle=\"height: 50%;min-width: 110px;position: relative;padding:0px;margin-right: 15px;background-color: transparent;cursor: pointer\">\n<ms-widget-front layout=\"column\" class=\"widget-card elemnt-dispo\" id=\"elemntadd\"><span class=\"md-subhead\">{{obj.type}}\n</span><div layout=\"row\" layout-align=\"space-around center\" id=\"draggable-5\" class=\"block-dispo\" \nstyle=\"cursor: pointer!important\"><md-icon style=\"margin-top: 10%; margin-left: 10%  ;   color: #8f99b2 !important\" \nmd-font-icon=\"{{obj.icon}}\" class=\"black-text icon s48\"></md-icon></div></ms-widget-front></ms-widget></div></div>\n</div></div></div>");
$templateCache.put("app/main/display/programs/details/modal.html","<md-dialog style=\"min-width: 70%\" class=\"event-form-dialog\" aria-label=\"Progam Detail Modal\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span md-truncate \nclass=\"title\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span \ntranslate=\"DISPLAYPROGRAMSDETAIL.title\">Details of the program </span><span>: {{ vm.program.title }}</span> </span>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaThreeDays\')\" \naria-label=\"3 Days\"><md-icon md-font-icon=\"icon-numeric-3-box-outline\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaSixDays\')\" aria-label=\"6 Days\"><md-icon \nmd-font-icon=\"icon-numeric-6-box-outline\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaNineDays\')\" aria-label=\"9 Days\"><md-icon \nmd-font-icon=\"icon-numeric-9-box-outline\"></md-icon></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"DISPLAYPROGRAMSADD.title\">Title\n</strong></h3></div><div class=\"md-secondary\">{{ vm.program.title }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\" ng-if=\"vm.program.description\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"DISPLAYPROGRAMSADD.description\">description</strong></h3></div><div class=\"md-secondary\">\n{{ vm.program.description }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"DISPLAYPROGRAMSLIST.duration\">duration</strong></h3></div><div \nclass=\"md-secondary\" data-ng-bind-html=\"vm.convertToTime(vm.program.duration)\">{{vm.program.duration }}</div>\n<md-divider></md-divider></md-list-item></md-list><div layout=\"row\" class=\"mv-20\" layout-align=\"start-center\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/display/programs/add_edit/add_edit.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"content\" md-background-bg layout=\"row\" \nms-scroll><div flex><div class=\"price-tables\" flex layout=\"row\"><md-content flex><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\"><a tooltips tooltip-template=\"{{\'MESSAGES.back_to_list\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.goToList()\" \naria-label=\"back_to_list\" translate translate-attr-aria-label=\"MESSAGES.back_to_list\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><md-truncate><span \ntranslate=\"DISPLAYPROGRAMSADD.form_title\" ng-if=\"vm.isNew\">form_title</span> <span \ntranslate=\"DISPLAYPROGRAMSEDIT.form_title\" ng-if=\"!vm.isNew\">form_title</span> <strong ng-if=\"vm.program.title\">\n: {{vm.program.title}}</strong></md-truncate><span flex></span> <a tooltips \ntooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'form\'] = 0\" ng-if=\"vm.expanded[\'form\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'form\'] = 1\" ng-if=\"!vm.expanded[\'form\']\" class=\"md-icon-button\" \naria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\">\n</md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" layout=\"row\" class=\"p-10\" \nng-hide=\"!vm.expanded[\'form\']\"><form name=\"programForm\" ng-submit=\"vm.submitProgram()\" class=\"flex\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"DISPLAYPROGRAMSADD.title\">Title</label>\n<input name=\"title\" ng-model=\"vm.program.title\" required md-autofocus style=\"height: 60px\"><div \nng-messages=\"programForm.title.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div></div></md-input-container><md-input-container flex><label \ntranslate=\"DISPLAYPROGRAMSADD.description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nname=\"description\" ng-model=\"vm.program.description\" md-maxlength=\"450\" rows=\"2\" max-rows=\"8\" aria-invalid=\"false\" \nng-trim=\"false\" style=\"min-height: 60px!important;max-height: 60px!important\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"space-between\"><span flex></span><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"(programForm.$invalid || vm.events.length == 0)|| (programForm.$pristine || vm.events.length == 0)\" \naria-label=\"vm.isNew ? Save : Edit\"><span ng-if=\"vm.isNew\" translate=\"DISPLAYPROGRAMSADD.add\">add</span> <span \nng-if=\"!vm.isNew\" translate=\"DISPLAYPROGRAMSEDIT.edit\">edit</span></md-button></div></form></div></md-content></div>\n<div class=\"price-tables\" flex layout=\"row\" style=\"margin-top:20px\"><md-content layout-padding flex ng-cloack>\n<md-toolbar><div class=\"md-toolbar-tools pv-5\"><md-truncate><strong>{{vm.calendarView.title}}</strong></md-truncate>\n<span flex></span><div style=\"height: 65px; margin-top: -20px;padding-top: 7px\"><md-select aria-label=\"nombreJ\" \nng-model=\"vm.nombreJ\" ng-change=\"vm.changeView()\" \nstyle=\"border-bottom-color: rgb(234, 235, 236) !important;color: rgba(247, 240, 240, 0.87)!important\"><md-option \nng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</md-option></md-select></div><a tooltips \ntooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'calendar\'] = 0\" ng-if=\"vm.expanded[\'calendar\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'calendar\'] = 1\" ng-if=\"!vm.expanded[\'calendar\']\" \nclass=\"md-icon-button\" aria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"s24\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYPROGRAMSADD.programs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'playlists-sidenav\')\" hide-gt-md \naria-label=\"playlists\" translate translate-attr-aria-label=\"DISPLAYPROGRAMSADD.programs\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" \nlayout=\"row\" class=\"mv-10 p-24 h-500\" ng-hide=\"!vm.expanded[\'calendar\']\" ms-scroll><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></md-content></div></div>\n<md-sidenav class=\"sidenav settings-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"playlists-sidenav\" ms-scroll ms-sidenav-helper><div class=\"header ph-20\"><h2 flex md-truncate><span \nclass=\"parent\" translate=\"DISPLAYPROGRAMSADD.playlists\">playlists</span></h2></div><md-content class=\"content\" \nms-scroll-y flex style=\"background: transparent\"><div \nng-include=\"\'app/main/display/programs/add_edit/playlists-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/display/programs/add_edit/playlists-sidenav.html","<div class=\"playlists-sidenav\"><md-list ms-scroll-y ng-if=\"vm.playlists.length\" class=\"_playlists list\" \nid=\"playlists_md_list\" ng-model=\"vm.playlists\" ui-sortable=\"vm.dragOptions\"><md-list-item \nng-repeat=\"playlist in ::vm.playlists track by playlist.id\" class=\"_playlist item\" ng-class=\"\'playlist_\'+$index\" \nng-attr-data-index=\"{{$index}}\"><div style=\"cursor: all-scroll\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.plcollaps\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><strong>\n{{playlist.title}}</strong></a></div><md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list></div>");
$templateCache.put("app/main/display/programs/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedPrograms.length\"><a tooltips \ntooltip-template=\"{{\'DISPLAYPROGRAMSLIST.delete_programs_aria_label\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedProgramsConfirm($event)\" \naria-label=\"delete_programs_aria_label\" translate \ntranslate-attr-aria-label=\"DISPLAYPROGRAMSLIST.delete_programs_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"abonnement-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_program\" ng-change=\"vm.searchProgram()\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewProgram($event)\" aria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" ng-checked=\"vm.isChecked()\" \nmd-indeterminate=\"vm.isIndeterminate()\" ng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"DISPLAYPROGRAMSLIST.title\">title\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"DISPLAYPROGRAMSLIST.duration\">duration</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/display/template_manager/list/list.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div ng-if=\"vm.selectedTemplates.length\" layout=\"row\" layout-align=\"start center\" flex \nng-class=\"{\'hide\':vm.selectedTemplates.length <=0}\"><md-button class=\"md-icon-button\" style=\"margin-left: 8%\" \nng-click=\"vm.deleteSelectedTemplatesConfirm($event)\" aria-label=\"delete_templates_aria_label\" translate \ntranslate-attr-aria-label=\"TMTEMPLATESLIST.delete_templates_aria_label\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"TMTEMPLATESLIST.delete_templates_aria_label\">delete_templates</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"abonnement-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_template\" ng-change=\"vm.searchTemplate()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewTemplate($event)\" \naria-label=\"action_new_element\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg \nxmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th style=\"text-align: center\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedTemplates.length === vm.templates.length) && (vm.selectedTemplates.length > 0)\" \nmd-indeterminate=\"vm.selectedTemplates.length !== 0 && vm.selectedTemplates.length !== vm.templates.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"TMTEMPLATESLIST.title\">title</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/display/template_manager/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"TMTEMPLATESLIST.template_link_title\"></span> \n</span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-bottom: 0;padding-top: 0\"><div style=\"padding-bottom: 0\" \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong translate=\"TMTEMPLATESLIST.template_link\">\n</strong></div><div flex=\"80\" id=\"fo1\">{{vm.link}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo1\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmboxgroup/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/boitier/rmboxgroup/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/boitier/rmboxgroup/add_edit_view/form.template.html","<form name=\"empConfigurationRmboxgroupForm\" method=\"post\" id=\"empConfigurationRmboxgroupForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationRmboxgroupForm.$valid && vm.submitAddRmboxgroupForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\" ng-if=\"vm.isNew\"></md-icon><span \ntranslate=\"RMBOXGROUPADD.form_title\" ng-if=\"vm.isNew\">form_title</span><md-icon md-font-icon=\"icon-pen\" class=\"s18\" \nng-if=\"!vm.isNew\"></md-icon><span translate=\"RMBOXGROUPEDIT.form_title\" ng-if=\"!vm.isNew\">form_title</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"RMBOXGROUPADD.form_attr_name\" \nfor=\"empConfigurationRmboxgroupForm\" class=\"required ng-scope md-required\">Nom</label><input type=\"text\" \nid=\"empConfigurationRmboxgroupForm_name\" name=\"empConfigurationRmboxgroupForm[name]\" required ng-attr-name=\"name\" \nng-name=\"name\" ng-model=\"vm.empConfigurationRmboxgroupForm.name\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationRmboxgroupForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationRmboxgroupError.name && vm.empConfigurationRmboxgroupForm.name === vm.empConfigurationRmboxgroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationRmboxgroupError.name.message}}\" class=\"validation_api\">\nempConfigurationRmboxgroupError_name</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"RMBOXGROUPADD.form_attr_bandwidthLimit\" \nfor=\"empConfigurationRmboxgroupForm_bandwidthLimit\">Limite de la bande passante</label><input type=\"text\" \nid=\"empConfigurationRmboxgroupForm_bandwidthLimit\" ng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" \nname=\"empConfigurationRmboxgroupForm[bandwidthLimit]\" required=\"required\" ng-attr-name=\"bandwidthLimit\" \nname=\"bandwidthLimit\" ng-model=\"vm.empConfigurationRmboxgroupForm.bandwidthLimit\" aria-invalid=\"true\"><div \nclass=\"hint\"># ; #.# ; -#.# ; -.# ; +# ; +#.# ; +.#</div><div \nng-messages=\"empConfigurationRmboxgroupForm.bandwidthLimit.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationRmboxgroupError.bandwidthLimit && vm.empConfigurationRmboxgroupForm.bandwidthLimit === vm.empConfigurationRmboxgroupError.bandwidthLimit.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationRmboxgroupError.bandwidthLimit.message}}\" class=\"validation_api\">\nempConfigurationRmboxgroupError_name</div><div ng-message=\"pattern\" translate=\"MESSAGES.field_must_be_numeric\">\nfield_must_be_numeric</div></div></md-input-container></div><div layout=\"column\"><label \ntranslate=\"RMBOXGROUPADD.form_attr_syncTime\">Horaire synchro</label><mdp-time-picker \nid=\"empConfigurationRmboxgroupForm_syncTime\" ng-name=\"empConfigurationRmboxgroupForm[syncTime]\" \nng-model=\"vm.empConfigurationRmboxgroupForm.syncTime\" ng-attr-name=\"syncTime\" mdp-format=\"HH:mm:ss\" \nmdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" required><div \nng-messages=\"empConfigurationRmboxgroupForm.syncTime.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.time_format\">\ntime_format</div></div></mdp-time-picker></div><md-button class=\"md-warn\" ui-sref=\"app.configuration_rmboxgroup_list\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empConfigurationRmboxgroupForm.$invalid || empConfigurationRmboxgroupForm.$pristine\" \ntranslate=\"MESSAGES.form_add\" translate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button \nng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empConfigurationRmboxgroupForm.$invalid || empConfigurationRmboxgroupForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/boitier/rmboxgroup/detail/detail.modal.html","<md-dialog style=\"min-width: 50%;min-height: 50%\" aria-label=\"configuration_rmboxgroup_detail_pagetitle\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAGESMENUSTITLES.configuration_rmboxgroup_detail_pagetitle\">configuration_rmboxgroup_detail_pagetitle</span>\n <span>{{ vm.rmboxgroup.name |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"RMBOXGROUPDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.rmboxgroup.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"RMBOXGROUPDETAIL.name\">name</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.rmboxgroup.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"RMBOXGROUPDETAIL.bandwidthLimit\">bandwidthLimit\n</strong></h3></div><div class=\"md-secondary\">{{ vm.rmboxgroup.bandwidthLimit }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"RMBOXGROUPDETAIL.syncTime\">syncTime</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmboxgroup.syncTime }}</div><md-divider></md-divider></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" \ntranslate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/detail/detail.modal.html","<md-dialog style=\"min-width: 50%;min-height: 50%\" aria-label=\"configuration_rmbox_detail_pagetitle\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAGESMENUSTITLES.configuration_rmbox_detail_pagetitle\">configuration_rmbox_detail_pagetitle</span> <span>\n{{ vm.rmbox.name |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.id }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.name\">name</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.name }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.type\">type</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.type }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.ip\">ip</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.ip }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.mac\">mac</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.mac }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.postal\">postal</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.rmbox.postal }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.groupid\">groupid</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.rmbox.group.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"RMBOXDETAIL.created_at\">created_at</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.rmbox.created_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"RMBOXDETAIL.updated_at\">updated_at</strong></h3></div><div class=\"md-secondary\">\n{{ vm.rmbox.updated_at| date:\'yyyy-MM-dd hh:mm:ss\' }}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/boitier/rmbox/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/boitier/rmbox/add_edit_view/form.template.html","<form name=\"empConfigurationRmboxForm\" method=\"post\" class=\"md-inline-form ng-pristine ng-invalid ng-invalid-required\" \nid=\"empConfigurationRmboxForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationRmboxForm.$valid && vm.submitAddRmboxForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"RMBOXADD.form_title\">form_title\n</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"RMBOXEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"RMBOXADD.form_attr_name\">Nom</label><input type=\"text\" id=\"empConfigurationRmboxForm_name\" \nname=\"empConfigurationRmboxForm[name]\" required=\"required\" ng-attr-name=\"name\" ng-name=\"name\" \nng-model=\"vm.empConfigurationRmboxForm.name\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationRmboxForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"RMBOXADD.form_attr_rmbox_type\">type</label><md-select \nid=\"empConfigurationRmboxForm_type\" ng-model=\"vm.empConfigurationRmboxForm.type\" required=\"required\" \naria-invalid=\"true\"><md-option ng-repeat=\"type in vm.types\" ng-value=\"type.val\">{{ type.option }}</md-option>\n</md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"RMBOXADD.form_attr_ip\">IP</label><input type=\"text\" id=\"empConfigurationRmboxForm_ip\" \nname=\"empConfigurationRmboxForm[ip]\" required=\"required\" ng-attr-name=\"ip\" ng-name=\"ip\" \nng-model=\"vm.empConfigurationRmboxForm.ip\" ng-pattern=\"/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/\" \naria-invalid=\"true\"><div ng-messages=\"empConfigurationRmboxForm.ip.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_ip\">field_must_be_ip</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"RMBOXADD.form_attr_mac\">Mac</label><input type=\"text\" \nid=\"empConfigurationRmboxForm_mac\" name=\"empConfigurationRmboxForm[mac]\" required=\"required\" ng-attr-name=\"mac\" \nng-name=\"mac\" ng-model=\"vm.empConfigurationRmboxForm.mac\" ng-pattern=\"/^([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]{1,2})$/\" \naria-invalid=\"true\"><div ng-messages=\"empConfigurationRmboxForm.mac.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_mac\">field_must_be_mac</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex ng-class=\"textarea-input\" class=\"textarea-input\"><label \ntranslate=\"RMBOXADD.form_attr_postal\">Adressé Postal</label><textarea id=\"empConfigurationRmboxForm_postal\" \nname=\"empConfigurationRmboxForm[postal]\" ng-attr-name=\"postal\" ng-name=\"postal\" \nng-model=\"vm.empConfigurationRmboxForm.postal\" aria-invalid=\"false\" ng-class=\"textarea-height\" class=\"textarea-height\">\n          </textarea><div ng-messages=\"empConfigurationRmboxForm.postal.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div\n ng-if=\"vm.groups.length>0\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"RMBOXADD.form_attr_groupid\">groupe</label><md-select translate translate=\"MESSAGES.form_attr_group\" \nname=\"empConfigurationRmboxForm[group]\" id=\"empConfigurationRmboxForm_group\" \nng-model=\"vm.empConfigurationRmboxForm.group\" placeholder=\"{{ \'RMBOXADD.form_attr_groupid\'|translate}}\"><md-option \nng-repeat=\"group in vm.groups track by group.val.id\" ng-value=\"group.val.id\" ng-attr-data-index=\"{{$index}}\">\n{{ group.val.name }}</md-option></md-select></md-input-container><div \nng-messages=\"empConfigurationRmboxForm.group.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></div><md-button class=\"md-warn\" \nui-sref=\"app.configuration_rmbox_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationRmboxForm.$invalid || empConfigurationRmboxForm.$pristine\" translate=\"MESSAGES.form_add\">\nform_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationRmboxForm.$invalid || empConfigurationRmboxForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/boitier/rmboxgroup/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedRmboxgroups.length\" \nhas-permission=\"configuration_rmboxgroup_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'RMBOXGROUPLIST.delete_rmboxgroups_aria_label\'|translate}}\" tooltip-side=\"right\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedRmboxgroupsConfirm($event)\" aria-label=\"delete_rmboxgroups_aria_label\" translate \ntranslate-attr-aria-label=\"RMBOXGROUPLIST.delete_rmboxgroups_aria_label\" \nhas-permission=\"configuration_rmboxgroup_delete_multi\"><md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\">\n</md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"rmboxgroup-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_rmboxgroups\" \nng-keydown=\"$event.keyCode === 13 && vm.searchRmboxgroups()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewRmboxgroup($event)\" \naria-label=\"action_new_element\" has-permission=\"configuration_rmboxgroup_post_add\"><div class=\"span-btn-add\" \nlayout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedRmboxgroups.length === vm.rmboxgroups.length) && (vm.selectedRmboxgroups.length > 0)\" \nmd-indeterminate=\"vm.selectedRmboxgroups.length !== 0 && vm.selectedRmboxgroups.length !== vm.rmboxgroups.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"RMBOXGROUPLIST.name\">name</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"RMBOXGROUPLIST.bandwidthLimit\">bandwidthLimit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"RMBOXGROUPLIST.syncTime\">syncTime\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"RMBOXGROUPLIST.schedule\">schedule</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/boitier/rmbox/list/activate.playlist.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-wifi\" class=\"s24\"></md-icon><span translate=\"RMBOXLIST.activate_playlist_modal\"></span> </span><span\n flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-card-content flex><md-select ng-model=\"vm.playlist\" \nplaceholder=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_playlists\'|translate}}\"><md-option value=\"\" \ntranslate=\"MESSAGES.nonef\"></md-option><md-optgroup \nlabel=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_playlists\'|translate}}\"><md-option \nng-repeat=\"playlist in vm.playlists track by playlist.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"playlist.val\">\n{{playlist.option}}</md-option></md-optgroup></md-select></md-card-content></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.validate()\" translate=\"MESSAGES.form_validate\">form_validate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/list/associate.schedule.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-calendar-text\" class=\"s24\"></md-icon><span translate=\"RMBOXLIST.associate_schedule\"></span> </span>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-card-content flex><md-select ng-if=\"vm.displayNew\" ng-model=\"vm.schedule\" \nmultiple=\"true\" placeholder=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_schedules\'|translate}}\"><md-option value=\"\" \ntranslate=\"MESSAGES.nonef\"></md-option><md-optgroup \nlabel=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_schedules\'|translate}}\"><md-option \nng-repeat=\"program in vm.schedules track by program.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"program.val\">\n{{program.option}}</md-option></md-optgroup></md-select><md-select ng-if=\"!vm.displayNew\" ng-model=\"vm.schedule\" \nplaceholder=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_schedules\'|translate}}\"><md-option value=\"\" \ntranslate=\"MESSAGES.nonef\"></md-option><md-optgroup \nlabel=\"{{ \'RMBOXASSOCIATESCHEDULE.form_attr_schedules\'|translate}}\"><md-option \nng-repeat=\"schedule in vm.schedules track by schedule.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"schedule.val\">\n{{schedule.option}}</md-option></md-optgroup></md-select></md-card-content></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.validate()\" translate=\"MESSAGES.form_validate\">form_validate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedRmboxs.length\" \nhas-permission=\"configuration_rmbox_delete_multi_action\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'RMBOXLIST.delete_RmBoxs_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedRmboxsConfirm($event)\" \naria-label=\"delete_RmBoxs_aria_label\" translate translate-attr-aria-label=\"RMBOXLIST.delete_RmBoxs_aria_label\" \nhas-permission=\"configuration_rmbox_delete_multi_action\"><md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\">\n</md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"stations-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_rmboxs\" ng-enter=\"vm.searchRmboxs()\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewRmbox($event)\" aria-label=\"action_new_element\" has-permission=\"configuration_rmbox_post_add_action\">\n<div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" \nclass=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedRmboxs.length === vm.rmboxs.length) && (vm.selectedRmboxs.length > 0)\" \nmd-indeterminate=\"vm.selectedRmboxs.length !== 0 && vm.selectedRmboxs.length !== vm.rmboxs.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"RMBOXLIST.name\">name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"RMBOXLIST.address\">adresse</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"RMBOXLIST.groupid\">groupid</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"RMBOXLIST.schedule\">schedule</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"RMBOXLIST.state\">state</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"RMBOXLIST.zone\">zone</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"RMBOXLIST.video\">video</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"RMBOXLIST.storage\">storage</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div>\n</th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/boitier/rmbox/list/preview.pdf.history.html","<md-dialog style=\"min-width: 50%;min-height : 30%\" aria-label=\"configuration_server_detail_pagetitle\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"RMBOXLIST.pdf_list\">RMBOXLIST.pdf_list</span>\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-content ms-scroll flex class=\"content-card fullpage layout-column flex\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th translate=\"RMBOXLIST.date\">RMBOXLIST.date</th><th translate=\"RMBOXLIST.rapports\">\nRMBOXLIST.rapports</th></tr></thead><tbody><tr ng-repeat=\"report in vm.reports\"><td class=\"name ng-binding\">\n{{report.date}}</td><td class=\"position ng-binding\"><div ng-repeat=\"file in report.file\"><a ng-href=\"{{file}}\" \ntarget=\"_blank\">{{file}}</a></div></td></tr></tbody></table></div></div></md-content></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/list/preview.state.details.html","<md-dialog style=\"min-width: 50%;min-height : 30%\" aria-label=\"configuration_server_detail_pagetitle\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"RMBOXLIST.state_details\">RMBOXLIST.state_details\n</span></h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div>\n</md-toolbar><md-content ms-scroll flex class=\"content-card fullpage layout-column flex\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"ms-responsive-table-wrapper\"><table class=\"simple\" \nms-responsive-table=\"\"><thead><tr><th translate=\"RMBOXLIST.state_label\">RMBOXLIST.state_label</th><th>\n{{vm.detail.label}}</th></tr><tr><th translate=\"RMBOXLIST.state_code_error\">RMBOXLIST.state_code_error</th><th>\n{{vm.detail.error_code}}</th></tr><tr><th translate=\"RMBOXLIST.state_error_message\">RMBOXLIST.state_error_message</th>\n<th>{{vm.detail.error_message}}</th></tr></thead></table></div></div></md-content></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/list/preview.video.liste.html","<md-dialog style=\"min-width: 50%;min-height : 90%\" aria-label=\"configuration_server_detail_pagetitle\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"RMBOXLIST.list_zone\">RMBOXLIST.list_zone</span>\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-content ms-scroll flex class=\"content-card fullpage layout-column flex\"><div class=\"content-card\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout-align=\"none center\"><div class=\"content-card\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"height: 100%\"><div class=\"product-count secondary-text\"><span \ntranslate=\"MESSAGES.total_records\">total_records</span> <strong>{{vm.recordsTotal}}</strong></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" width=\"70%\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\">\n</md-icon><input id=\"zones-search\" ng-model=\"vm.search_videos\" ng-enter=\"vm.searchVideos()\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex></div></div></div></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\">Id</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.form_attr_title\">form_attr_title</span></div></th></tr></thead></table></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/boitier/rmbox/list/preview.zone.liste.html","<md-dialog style=\"min-width: 50%;min-height : 90%\" aria-label=\"configuration_server_detail_pagetitle\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"RMBOXLIST.list_zone\">RMBOXLIST.list_zone</span>\n</h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-content ms-scroll flex class=\"content-card fullpage layout-column flex\"><div class=\"content-card\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout-align=\"none center\"><div class=\"content-card\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"height: 100%\"><div class=\"product-count secondary-text\"><span \ntranslate=\"MESSAGES.total_records\">total_records</span> <strong>{{vm.zones.length}}</strong></div><div class=\"search\" \nlayout=\"row\" layout-align=\"start center\" width=\"70%\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon search-icon\">\n</md-icon><input id=\"zones-search\" ng-model=\"vm.search_zones\" ng-change=\"vm.searchZones()\" class=\"search-input\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex></div></div></div></div>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"RMBOXLIST.zone_id\">id</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"RMBOXLIST.zone_name\">name</span></div></th></tr></thead></table></div></md-content></md-dialog>");
$templateCache.put("app/main/boitier/autoriseip/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/boitier/autoriseip/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/boitier/autoriseip/add_edit_view/form.template.html","<form name=\"empAutoriseIpForm\" method=\"post\" id=\"empAutoriseIpForm\" novalidate=\"novalidate\" \nng-submit=\"empAutoriseIpForm.$valid && vm.submitIpForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"IPADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"IPEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"IPADD.form_attr_ip\">IP adress</label><input type=\"text\" id=\"empAutoriseIpForm_ip\" \nname=\"empAutoriseIpForm[ip]\" required=\"required\" ng-attr-name=\"ip\" ng-name=\"ip\" ng-model=\"vm.empAutoriseIpForm.ip\" \naria-invalid=\"true\" \nng-pattern=\"/^(([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))$/\"><div \nng-messages=\"empAutoriseIpForm.ip.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"IPADD.ERRORS.REQUIRED\">\nCe champ est obligatoire</div><div ng-message=\"pattern\" translate=\"IPADD.ERRORS.INVALIDFORMAT\">\nCe champ doit contenir une adresse ip correcte</div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"IPADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\">\n<textarea id=\"empAutoriseIpForm_description\" name=\"empAutoriseIpForm[description]\" ng-attr-name=\"description\" rows=\"5\" \nmax-rows=\"8\" md-maxlength=\"450\" ng-model=\"vm.empAutoriseIpForm.description\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empAutoriseIpForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div></div></md-input-container>\n<md-button class=\"md-warn\" ui-sref=\"app.boitier_autoriseip_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAutoriseIpForm.$invalid || empAutoriseIpForm.$pristine\" translate=\"MESSAGES.form_add\" ng-if=\"vm.isNew\">\nform_add</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empAutoriseIpForm.$invalid || empAutoriseIpForm.$pristine\" translate=\"MESSAGES.form_validate\" \nng-if=\"!vm.isNew\">form_validate</md-button></form>");
$templateCache.put("app/main/boitier/autoriseip/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"profiles_ip_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.profiles_ip_detail_pagetitle\">IP Adress details</span> \n<span>{{ vm.ip.ip |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong>Id</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.id }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"IPDETAIL.adress\">IP Adress</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.ip }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"IPDETAIL.description\">Description</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.description }}</div>\n</md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/boitier/zone/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"configuration_zone_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.configuration_zone_detail_pagetitle\">\nconfiguration_zone_detail_pagetitle</span> <span>{{ vm.zone.name |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.id\">id</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.zone.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.name\">name</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.zone.name }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.path\">path</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.zone.path }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.ipStart\">ipStart</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.zone.ipStart }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.ipEnd\">ipEnd</strong></h3></div><div\n class=\"md-secondary\">{{ vm.zone.ipEnd }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.rmbox\">rmbox</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.zone.rmbox.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.bandwidthLimit\">bandwidthLimit\n</strong></h3></div><div class=\"md-secondary\">{{ vm.zone.bandwidthLimit }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ZONEDETAIL.zonelimit\">zonelimit</strong></h3></div><div class=\"md-secondary\">{{ vm.zone.zonelimit }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ZONEDETAIL.usersimultane\">usersimultane</strong></h3></div><div class=\"md-secondary\">\n{{ vm.zone.usersimultane }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"ZONEDETAIL.bandwidthDisponible\">bandwidthDisponible</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.zone.bandwidthDisponible }}</div><md-divider></md-divider></md-list-item>\n</md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/zone/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-zone\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/boitier/zone/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/boitier/zone/add_edit_view/form.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><form name=\"empConfigurationZoneForm\" method=\"post\" \nismodif=\"\" id=\"empConfigurationZoneForm\" novalidate=\"novalidate\" \nng-submit=\"empConfigurationZoneForm.$valid && vm.submitAddZoneForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\" ng-if=\"vm.isNew\"></md-icon><span translate=\"ZONEADD.form_title\" \nng-if=\"vm.isNew\">form_title</span><md-icon md-font-icon=\"icon-pen\" class=\"s18\" ng-if=\"!vm.isNew\"></md-icon><span \ntranslate=\"ZONEEDIT.form_title\" ng-if=\"!vm.isNew\">form_title</span></div><div layout=\"row\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_name\" \nfor=\"empConfigurationZoneForm\" class=\"required ng-scope md-required\">Nom</label><input type=\"text\" \nid=\"empConfigurationZoneForm_name\" name=\"empConfigurationZoneForm[name]\" required ng-attr-name=\"name\" ng-name=\"name\" \nng-model=\"vm.empConfigurationZoneForm.name\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationZoneForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationZoneError.name && vm.empConfigurationZoneForm.name === vm.empConfigurationZoneError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.name.message}}\" class=\"validation_api\">\nempConfigurationZoneError_name</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\">\n<md-input-container flex><label translate=\"ZONEADD.form_attr_path\" for=\"empConfigurationZoneForm_path\">Path</label>\n<input type=\"text\" id=\"empConfigurationZoneForm_path\" name=\"empConfigurationZoneForm[path]\" ng-attr-name=\"path\" \nng-name=\"path\" ng-model=\"vm.empConfigurationZoneForm.path\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationZoneForm.path.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationZoneError.path && vm.empConfigurationZoneForm.path === vm.empConfigurationZoneError.path.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.path.message}}\" class=\"validation_api\">\nempConfigurationZoneError_path</div></div></md-input-container></div></div><div layout=\"row\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_ipStart\" \nfor=\"empConfigurationZoneForm_ipStart\">Adresse IP Début</label><input type=\"text\" \nid=\"empConfigurationZoneForm_ipStart\" name=\"empConfigurationZoneForm[ipStart]\" required=\"required\" \nng-attr-name=\"ipStart\" ng-name=\"ipStart\" ng-model=\"vm.empConfigurationZoneForm.ipStart\" aria-invalid=\"true\" \nng-pattern=\"/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/\"><div \nng-messages=\"empConfigurationZoneForm.ipStart.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_ip\">field_must_be_ip</div><div \nng-if=\"vm.empConfigurationZoneError.ipStart && vm.empConfigurationZoneForm.ipStart === vm.empConfigurationZoneError.ipStart.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.ipStart.message}}\" class=\"validation_api\">\nempConfigurationZoneError_ipStart</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_ipEnd\" for=\"empConfigurationZoneForm_ipEnd\">\nAdresse IP Fin</label><input type=\"text\" id=\"empConfigurationZoneForm_ipEnd\" name=\"empConfigurationZoneForm[ipEnd]\" \nrequired=\"required\" ng-attr-name=\"ipEnd\" ng-name=\"ipEnd\" ng-model=\"vm.empConfigurationZoneForm.ipEnd\" \naria-invalid=\"true\" ng-pattern=\"/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/\"><div \nng-messages=\"empConfigurationZoneForm.ipEnd.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_ip\">field_must_be_ip</div><div \nng-if=\"vm.empConfigurationZoneError.ipEnd && vm.empConfigurationZoneForm.ipEnd === vm.empConfigurationZoneError.ipEnd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.ipEnd.message}}\" class=\"validation_api\">\nempConfigurationZoneError_ipStart</div></div></md-input-container></div></div><div layout=\"row\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_bandwidthLimit\" \nfor=\"empConfigurationZoneForm_bandwidthLimit\">Limite Bande passante</label><input type=\"text\" \nid=\"empConfigurationZoneForm_bandwidthLimit\" name=\"empConfigurationZoneForm[bandwidthLimit]\" required=\"required\" \nng-attr-name=\"bandwidthLimit\" ng-name=\"bandwidthLimit\" ng-model=\"vm.empConfigurationZoneForm.bandwidthLimit\" \nng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationZoneForm.bandwidthLimit.$error\" role=\"alert\"><div ng-message=\"pattern\">\nCe champ ne peut contenir qu\'une valeur numérique</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationZoneError.bandwidthLimit && vm.empConfigurationZoneForm.bandwidthLimit === vm.empConfigurationZoneError.bandwidthLimit.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.bandwidthLimit.message}}\" class=\"validation_api\">\nempConfigurationZoneError_bandwidthLimit</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_zonelimit\" \nfor=\"empConfigurationZoneForm_zonelimit\">Zone Connect Limit</label><input type=\"number\" \nid=\"empConfigurationZoneForm_zonelimit\" name=\"empConfigurationZoneForm[zonelimit]\" required=\"required\" \nng-attr-name=\"zonelimit\" ng-name=\"zonelimit\" ng-model=\"vm.empConfigurationZoneForm.zonelimit\" aria-invalid=\"true\" \nng-min=\"0\"><div ng-messages=\"empConfigurationZoneForm.zonelimit.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"min\" \ntranslate=\"MESSAGES.form_is_num_positive\">form_is_num_positive</div><div \nng-if=\"vm.empConfigurationZoneError.zonelimit && vm.empConfigurationZoneForm.zonelimit === vm.empConfigurationZoneError.zonelimit.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.zonelimit.message}}\" class=\"validation_api\">\nempConfigurationZoneError_zonelimit</div></div></md-input-container></div></div><div layout=\"row\"><div layout=\"column\" \nlayout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_usersimultane\" \nfor=\"empConfigurationZoneForm_usersimultane\">Nb user simultanée</label><input type=\"number\" \nid=\"empConfigurationZoneForm_usersimultane\" name=\"empConfigurationZoneForm[usersimultane]\" required=\"required\" \nng-attr-name=\"usersimultane\" ng-name=\"usersimultane\" ng-model=\"vm.empConfigurationZoneForm.usersimultane\" \naria-invalid=\"true\" ng-min=\"0\"><div ng-messages=\"empConfigurationZoneForm.usersimultane.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"min\" \ntranslate=\"MESSAGES.form_is_num_positive\">form_is_num_positive</div><div \nng-if=\"vm.empConfigurationZoneError.usersimultane && vm.empConfigurationZoneForm.usersimultane === vm.empConfigurationZoneError.usersimultane.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.usersimultane.message}}\" class=\"validation_api\">\nempConfigurationZoneError_usersimultane</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"50\"><md-input-container flex><label translate=\"ZONEADD.form_attr_bandwidthDisponible\" \nfor=\"empConfigurationZoneForm_bandwidthDisponible\">Bande passante disponible</label><input type=\"text\" \nid=\"empConfigurationZoneForm_bandwidthDisponible\" name=\"empConfigurationZoneForm[bandwidthDisponible]\" \nrequired=\"required\" ng-attr-name=\"bandwidthDisponible\" ng-name=\"bandwidthDisponible\" \nng-model=\"vm.empConfigurationZoneForm.bandwidthDisponible\" ng-pattern=\"/^[+-]?((\\.\\d+)|(\\d+(\\.\\d+)?))$/\" \naria-invalid=\"true\"><div ng-messages=\"empConfigurationZoneForm.bandwidthDisponible.$error\" role=\"alert\"><div \nng-message=\"pattern\" translate=\"MESSAGES.form_is_num\">form_is_num</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empConfigurationZoneError.bandwidthDisponible && vm.empConfigurationZoneForm.bandwidthDisponible === vm.empConfigurationZoneError.bandwidthDisponible.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empConfigurationZoneError.bandwidthDisponible.message}}\" class=\"validation_api\">\nempConfigurationZoneError_bandwidthDisponible</div></div></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-card-content flex><md-select translate translate=\"MESSAGES.entity\" \nname=\"empConfigurationZoneForm[rmbox]\" id=\"empConfigurationZoneForm_rmbox\" \nng-model=\"vm.empConfigurationZoneForm.rmbox\" ng-attr-name=\"rmbox\" ng-name=\"rmbox\" \nplaceholder=\"{{ \'ZONEADD.form_attr_rmbox\'|translate}}\"><md-option ng-repeat=\"rmbox in vm.rmboxs track by rmbox.val.id\" \nng-value=\"rmbox.val.id\" ng-attr-data-index=\"{{$index}}\">{{ rmbox.val.name }}</md-option></md-select></md-card-content>\n</div><md-button class=\"md-warn\" ui-sref=\"app.configuration_zone_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationZoneForm.$invalid || empConfigurationZoneForm.$pristine\" translate=\"MESSAGES.form_add\" \nng-if=\"vm.isNew\">form_add</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationZoneForm.$invalid || empConfigurationZoneForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" ng-if=\"!vm.isNew\">form_validate</md-button></form></ms-widget-front></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\">\n<md-content class=\"md-padding\" layout-xs=\"column\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 100%\"><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);width: 100%\" class=\"product-detail-form-container\"><div \nclass=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgress\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><span flex><p translate=\"ZONEADD.select_file\"></p>( <a ng-href=\"{{vm.downloadfile()}}\" \ntarget=\"_blank\" translate=\"ABONNEMENTGROUPADD.download_file\"></a> )</span></div></div></div><div \nstyle=\"width: 100%;border: solid 1px rgba(0,0,0,0.15);padding-left: 10px; position: relative\" ng-if=\"vm.inProgress\" \nlayout=\"row\"><md-button style=\"position: absolute;right: -17px;top: -20px\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.inProgress=false\"><svg aria-hidden=\"true\" class=\"UppyIcon\" width=\"20\" height=\"30\" viewBox=\"0 0 60 60\" \nxmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" fill-rule=\"nonzero\" \nvector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\"></path><path \nfill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><div layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.nb_ligne_file\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.total\" aria-label=\"Readonly field\"></md-input-container></div><div style=\"margin-top: -10px\" \nlayout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.new\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex \ntype=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_new\" aria-label=\"Readonly field\"></md-input-container></div>\n</div><div style=\"margin-left: 5%\" layout=\"column\"><div layout=\"row\" layout-align=\"start center\"><div \nstyle=\"padding-top: 15px\" flex=\"80\"><p translate=\"ABONNEMENTGROUPADD.exist\"></p></div>\n&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input flex type=\"text\" ng-readonly=\"true\" \nng-value=\"vm.response.ligne_exist\" aria-label=\"Readonly field\"></md-input-container></div><div \nstyle=\"margin-top: -10px\" layout=\"row\" layout-align=\"start center\"><div style=\"padding-top: 15px\" flex=\"80\"><p \ntranslate=\"ABONNEMENTGROUPADD.errone\"></p></div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<md-input-container><input \nflex type=\"text\" ng-readonly=\"true\" ng-value=\"vm.response.ligne_erronee\" aria-label=\"Readonly field\">\n</md-input-container></div></div></div><div style=\"width: 100%;margin-top: 30px\"><md-button ng-if=\"vm.inProgress\" \nclass=\"md-warn\" ui-sref=\"app.abonnement_group_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" value=\"Upload\" aria-label=\"Submit\" ng-if=\"vm.inProgress\" ng-click=\"vm.uploadAddFile()\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></div></div></md-content></ms-widget-front></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/boitier/zone/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedZones.length\" \nhas-permission=\"configuration_zone_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'ZONELIST.delete_zones_aria_label\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button ng-if=\"vm.selectedZones.length\" class=\"md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedZonesConfirm($event)\" aria-label=\"delete_zones_aria_label\" translate \ntranslate-attr-aria-label=\"ZONELIST.delete_zones_aria_label\" has-permission=\"configuration_zone_delete_multi\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"zones-search\" class=\"search-input ng-scope flex\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_zones\" \nng-keydown=\"$event.keyCode === 13 && vm.searchZones()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewZone($event)\" \naria-label=\"action_new_element\" has-permission=\"configuration_zone_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedZones.length === vm.zones.length) && (vm.selectedZones.length > 0)\" \nmd-indeterminate=\"vm.selectedZones.length !== 0 && vm.selectedZones.length !== vm.zones.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ZONELIST.name\">name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ZONELIST.path\">path</span></div></th>\n<th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ZONELIST.ipStart\">ipStart</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"ZONELIST.ipEnd\">ipEnd</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ZONELIST.rmbox\">rmbox</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ZONELIST.bandwidthLimit\">bandwidthLimit</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ZONELIST.zonelimit\">zonelimit</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ZONELIST.usersimultane\">usersimultane</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ZONELIST.bandwidthDisponible\">\nbandwidthDisponible</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div>\n</div></div>");
$templateCache.put("app/main/boitier/autoriseip/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex has-permission=\"boitier_autoriseip_delete_multi\" \nng-if=\"vm.selectedIps.length\"><a ng-style=\"myObjStyle\" tooltips tooltip-template=\"{{\'IPLIST.delete_ip\'|translate}}\" \ntooltip-side=\"right\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedIpsConfirm($event)\" aria-label=\"delete_themes_aria_label\" translate \ntranslate-attr-aria-label=\"THEMELIST.delete_themes_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"ips-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_ips\" \nng-keydown=\"$event.keyCode === 13 && vm.searchIps()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewIp($event)\" \naria-label=\"action_new_element\" has-permission=\"boitier_autoriseip_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox \nng-if=\"vm.ips.length>0 && vm.boitier_autoriseip_delete_multi\" aria-label=\"-\" \nng-checked=\"(vm.selectedIps.length === vm.ips.length) && (vm.selectedIps.length > 0)\" \nmd-indeterminate=\"vm.selectedIps.length !== 0 && vm.selectedIps.length !== vm.ips.length\" ng-click=\"vm.toggleAll()\">\n</md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"IPLIST.adress\">IP Adresse</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"IPLIST.description\">Description</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div>\n</th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/displayNew/template_segment/list/list.html","<div id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \nng-src=\"{{vm.trustLink(vm.urlSegmentList)}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/displayNew/template_manager/editorNew/editornew.html","<div style=\"width: 100%;height: 100%\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><iframe id=\"iframe_display\" \nsrc=\"{{vm.trustLink(vm.urldisplay)}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%; display:block\">\n</iframe></div>");
$templateCache.put("app/main/displayNew/template_manager/list/list.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"space-between center\"><div ng-if=\"vm.nb_list_diffusion>0\" \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\" style=\"width: 100%\"><div \nshow-gt-md hide-md hide-sm hide-xs flex=\"15\"><div layout=\"row\" layout-align=\"space-between center\"><div \nlayout-align=\"start center\" style=\"width: 100%\" layout=\"row\"><div flex=\"40\" layout=\"row\" \nng-if=\"vm.selectedTemplates.length\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedTemplatesConfirm($event)\" aria-label=\"delete_templates_aria_label\" translate \ntranslate-attr-aria-label=\"TMTEMPLATESLIST.delete_templates_aria_label\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"TMTEMPLATESLIST.delete_templates_aria_label\">delete_templates</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></div><div flex=\"60\" layout=\"row\" \nng-if=\"vm.nb_list>1\" style=\"position: relative\"><md-menu \nhas-permission=\"display_new_template_list_dtable,display_new_template_list_dtable_ongoing,display_new_template_list_dtable_offline,display_new_template_list_dtable_upcoming\" \nclass=\"tooltipSize menu_diffusion_template\"><md-button aria-label=\"menu\" class=\"diffusion_template\" \nng-click=\"$mdOpenMenu()\" translate translate-attr-aria-label=\"VIDEOLIST.diffusion\"><md-icon \nstyle=\"font-size: 22px;margin-top: -4px;margin-left: -10px;color:#2096f8\" md-font-icon=\"icon-video\"></md-icon><span \nclass=\"bold\" translate=\"VIDEOLIST.diffusion\" style=\"color: #2096f8;font-size: 16px\"></span><md-icon \nstyle=\"font-size: 28px;margin-top: -4px;margin-left: -5px;color:#2096f8\" md-font-icon=\"icon-menu-down\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-menu-bar-menu md-dense\"><md-menu-item \nhas-permission=\"display_new_template_list_dtable\" \ndata-ng-style=\"$root.state.current.url===\'/all\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_all\"><md-icon md-font-icon=\"icon-tile-four\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.all\">all</md-button></md-menu-item>\n<md-menu-item has-permission=\"display_new_template_list_dtable_ongoing\" \ndata-ng-style=\"$root.state.current.url===\'/on-going\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_on_going\"><md-icon md-font-icon=\"icon-play\"></md-icon><md-button \ntranslate=\"TMTEMPLATESLIST.ongoing\" class=\"md-button md-default-theme md-ink-ripple\">ongoing</md-button></md-menu-item>\n<md-menu-item has-permission=\"display_new_template_list_dtable_offline\" \ndata-ng-style=\"$root.state.current.url===\'/archived\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_archived\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.show_archive\">show_archive</md-button>\n</md-menu-item><md-menu-item has-permission=\"display_new_template_list_dtable_upcoming\" \ndata-ng-style=\"$root.state.current.url===\'/up-coming\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_upcoming\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.upcoming\">upcoming</md-button>\n</md-menu-item></md-menu-content></md-menu><span \nstyle=\"position: absolute;top: 32px;left: 30px;color: #a2b3c1;font-size: 12px;width: fit-content\">\n-- {{vm.labelDiffusion|translate}} --</span></div></div></div></div><div show-md show-sm show-xs hide-gt-md flex=\"15\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout-align=\"start center\" style=\"width: 100%\"><div \nclass=\"half-div\"><md-button ng-if=\"vm.selectedTemplates.length\" class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedTemplatesConfirm($event)\" aria-label=\"delete_templates_aria_label\" translate \ntranslate-attr-aria-label=\"TMTEMPLATESLIST.delete_templates_aria_label\" style=\"margin:0;padding: 0\"><md-tooltip \nmd-direction=\"top\"><span translate=\"TMTEMPLATESLIST.delete_templates_aria_label\">delete_templates</span></md-tooltip>\n<md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\" style=\"margin:0\"></md-icon></md-button></div><div \nclass=\"half-div\" style=\"margin-left: 5px\" \ndata-ng-style=\"vm.selectedTemplates.length && {\'margin-left\': \'-7px\', \'margin-top\': \'5px\'}\"><md-menu \nhas-permission=\"display_new_template_list_dtable,display_new_template_list_dtable_ongoing,display_new_template_list_dtable_offline,display_new_template_list_dtable_upcoming\" \nclass=\"tooltipSize menu_diffusion_template\"><md-button aria-label=\"menu\" class=\"diffusion_template\" \nstyle=\"min-width: auto!important;margin:0;padding: 0\" ng-click=\"$mdOpenMenu()\" translate \ntranslate-attr-aria-label=\"VIDEOLIST.diffusion\"><md-icon style=\"font-size: 22px;margin-top: -4px;color:#2096f8\" \nmd-font-icon=\"icon-video\"></md-icon><md-icon style=\"font-size: 25px;margin-top: -7px;margin-left: -10px;color:#2096f8\" \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\" class=\"md-menu-bar-menu md-dense\">\n<md-menu-item has-permission=\"display_new_template_list_dtable\" \ndata-ng-style=\"$root.state.current.url===\'/all\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_all\"><md-icon md-font-icon=\"icon-tile-four\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.all\">all</md-button></md-menu-item>\n<md-menu-item has-permission=\"display_new_template_list_dtable_ongoing\" \ndata-ng-style=\"$root.state.current.url===\'/on-going\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_on_going\"><md-icon md-font-icon=\"icon-play\"></md-icon><md-button \ntranslate=\"TMTEMPLATESLIST.ongoing\" class=\"md-button md-default-theme md-ink-ripple\">ongoing</md-button></md-menu-item>\n<md-menu-item has-permission=\"display_new_template_list_dtable_offline\" \ndata-ng-style=\"$root.state.current.url===\'/archived\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_archived\"><md-icon md-font-icon=\"icon-archive\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.show_archive\">show_archive</md-button>\n</md-menu-item><md-menu-item has-permission=\"display_new_template_list_dtable_upcoming\" \ndata-ng-style=\"$root.state.current.url===\'/up-coming\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nui-sref=\"app.new_template_manager_list_upcoming\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-button \nclass=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.upcoming\">upcoming</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div></div></div><div flex=\"20\" layout=\"row\" \nstyle=\"position: relative\" has-permission=\"display_new_template_list_search_by_status\"><md-menu><md-button \naria-label=\"menu\" class=\"diffusion_template\" ng-click=\"$mdOpenMenu()\" translate \ntranslate-attr-aria-label=\"VIDEOLIST.diffusion\"><md-icon \nstyle=\"font-size: 22px;margin-top: -4px;margin-left: -10px;color:#2096f8\" md-font-icon=\"icon-video\"></md-icon><span \nclass=\"bold\" translate=\"VIDEOLIST.diffusion\" style=\"color: #2096f8;font-size: 16px\"></span><md-icon \nstyle=\"font-size: 28px;margin-top: -4px;margin-left: -5px;color:#2096f8\" md-font-icon=\"icon-menu-down\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-menu-bar-menu md-dense\"><md-menu-item \ndata-ng-style=\"$root.state.current.url===\'/all\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><md-button class=\"md-button md-default-theme md-ink-ripple\" \ntranslate=\"TMTEMPLATESLIST.none\" ng-click=\"vm.searchTemplate(\'all\')\">all</md-button></md-menu-item><md-menu-item \ndata-ng-style=\"$root.state.current.url===\'/on-going\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nng-click=\"vm.searchTemplate(\'pending\')\"><md-icon md-font-icon=\"icon-play\"></md-icon><md-button \ntranslate=\"TMTEMPLATESLIST.pending\" class=\"md-button md-default-theme md-ink-ripple\">ongoing</md-button></md-menu-item>\n<md-menu-item data-ng-style=\"$root.state.current.url===\'/archived\' && {\'background\':\'#f8f9fa\'}\" \nclass=\"md-indent item-menu\" ng-click=\"vm.searchTemplate(\'finish\')\"><md-icon md-font-icon=\"icon-archive\"></md-icon>\n<md-button class=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.finish\">show_archive</md-button>\n</md-menu-item></md-menu-content></md-menu><span \nstyle=\"position: absolute;top: 32px;left: 30px;color: #a2b3c1;font-size: 12px;width: fit-content\">\n-- {{vm.labelDiffusion|translate}} --</span></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"abonnement-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_template\" ng-change=\"vm.searchTemplate()\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewTemplateNew($event)\" aria-label=\"action_new_element\" has-permission=\"display_new_template_post_add\">\n<div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" \nclass=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div ng-if=\"vm.nb_list_diffusion===0\" class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\" style=\"width: 100%\"><div flex=\"5\" layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedTemplates.length\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedTemplatesConfirm($event)\" aria-label=\"delete_templates_aria_label\" translate \ntranslate-attr-aria-label=\"TMTEMPLATESLIST.delete_templates_aria_label\"><md-tooltip md-direction=\"top\"><span \ntranslate=\"TMTEMPLATESLIST.delete_templates_aria_label\">delete_templates</span></md-tooltip><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></div><div flex=\"10\" layout=\"row\" \nstyle=\"position: relative\" has-permission=\"display_new_template_list_search_by_status\"><md-menu><md-button \naria-label=\"menu\" class=\"diffusion_template\" ng-click=\"$mdOpenMenu()\" translate \ntranslate-attr-aria-label=\"VIDEOLIST.diffusion\"><md-icon \nstyle=\"font-size: 22px;margin-top: -4px;margin-left: -10px;color:#2096f8\" md-font-icon=\"icon-video\"></md-icon><span \nclass=\"bold\" translate=\"VIDEOLIST.diffusion\" style=\"color: #2096f8;font-size: 16px\"></span><md-icon \nstyle=\"font-size: 28px;margin-top: -4px;margin-left: -5px;color:#2096f8\" md-font-icon=\"icon-menu-down\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-menu-bar-menu md-dense\"><md-menu-item \ndata-ng-style=\"$root.state.current.url===\'/all\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\"><md-icon \nmd-font-icon=\"icon-tile-four\"></md-icon><md-button class=\"md-button md-default-theme md-ink-ripple\" \ntranslate=\"TMTEMPLATESLIST.none\" ng-click=\"vm.searchTemplate(\'all\')\">all</md-button></md-menu-item><md-menu-item \ndata-ng-style=\"$root.state.current.url===\'/on-going\' && {\'background\':\'#f8f9fa\'}\" class=\"md-indent item-menu\" \nng-click=\"vm.searchTemplate(\'pending\')\"><md-icon md-font-icon=\"icon-play\"></md-icon><md-button \ntranslate=\"TMTEMPLATESLIST.pending\" class=\"md-button md-default-theme md-ink-ripple\">ongoing</md-button></md-menu-item>\n<md-menu-item data-ng-style=\"$root.state.current.url===\'/archived\' && {\'background\':\'#f8f9fa\'}\" \nclass=\"md-indent item-menu\" ng-click=\"vm.searchTemplate(\'finish\')\"><md-icon md-font-icon=\"icon-archive\"></md-icon>\n<md-button class=\"md-button md-default-theme md-ink-ripple\" translate=\"TMTEMPLATESLIST.finish\">show_archive</md-button>\n</md-menu-item></md-menu-content></md-menu><span \nstyle=\"position: absolute;top: 32px;left: 30px;color: #a2b3c1;font-size: 12px;width: fit-content\">\n-- {{vm.labelDiffusion|translate}} --</span></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"abonnement-search-box\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_template\" ng-change=\"vm.searchTemplate()\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewTemplateNew($event)\" aria-label=\"action_new_element\" has-permission=\"display_new_template_post_add\">\n<div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" \nclass=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th style=\"text-align: center\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedTemplates.length === vm.templates.length) && (vm.selectedTemplates.length > 0)\" \nmd-indeterminate=\"vm.selectedTemplates.length !== 0 && vm.selectedTemplates.length !== vm.templates.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\" style=\"width: 250px\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"TMTEMPLATESLIST.title\">title</span>\n</div></th><th class=\"secondary-text\" style=\"width: 250px\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"TMTEMPLATESLIST.ligne\">ligne</span></div></th><th class=\"secondary-text\" \nstyle=\"width: 100px\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"TMTEMPLATESLIST.duration\">duration</span></div></th><th class=\"secondary-text\" style=\"width: 100px\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"TMTEMPLATESLIST.startDate\">startDate\n</span></div></th><th class=\"secondary-text\" style=\"width: 250px\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"LOGINV2.USERNAME\">username</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"TMTEMPLATESLIST.status\">status\n</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div>\n</div>");
$templateCache.put("app/main/displayNew/template_manager/list/preview.modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" style=\"width:40%\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span>{{vm.title}}</span>\n </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content class=\"no-padding\"><div \nstyle=\"position: relative; overflow: hidden; padding-top:{{vm.scaled}}%\" layout=\"row\" layout-align=\"center center\">\n<iframe style=\"position:absolute;top:0;left:0;width:100%;height:100%\" ng-src=\"{{vm.trustLink(vm.url_video)}}\" \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/displayNew/template_manager/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"TMTEMPLATESLIST.template_link_title\"></span> \n</span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content style=\"padding-bottom: 0;padding-top: 0\"><div style=\"padding-bottom: 0\" \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong translate=\"TMTEMPLATESLIST.template_link\">\n</strong></div><div flex=\"80\" id=\"fo1\">{{vm.link}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo1\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/displayNew/schedule/add/add.html","<div class=\"page-layout simple right-sidenav inner-sidenav calendar_display_new\"><div class=\"content\" md-background-bg \nlayout=\"row\" ms-scroll><div flex><div class=\"price-tables\" flex layout=\"row\"><md-content flex><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\"><md-truncate><span class=\"logo-text\" translate=\"DISPLAYSCHEDULEADD.information\">\nInformation</span> <strong ng-if=\"vm.schedule.title\">: {{vm.schedule.title}}</strong></md-truncate><span flex></span> \n<a tooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.expanded[\'form\'] = 0\" ng-if=\"vm.expanded[\'form\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'form\'] = 1\" ng-if=\"!vm.expanded[\'form\']\" class=\"md-icon-button\" \naria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\">\n</md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" layout=\"row\" class=\"p-10\" \nng-hide=\"!vm.expanded[\'form\']\"><form name=\"programForm\" ng-submit=\"vm.addNewSchedule()\" class=\"flex\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex class=\"pr-10\"><label translate=\"DISPLAYSCHEDULEADD.title\" \nclass=\"md-no-float\">Title</label><input name=\"title\" ng-model=\"vm.schedule.title\" required md-autofocus \nstyle=\"height: 26px\"><div ng-messages=\"programForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empScheduleError.title && vm.schedule.title === vm.empScheduleError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empScheduleError.title.message}}\" class=\"validation_api\">empScheduleError_name</div></div>\n</md-input-container><md-input-container flex class=\"pl-10\"><label translate=\"DISPLAYSCHEDULEADD.description\" \nclass=\"md-no-float\">Description</label><div class=\"md-resize-wrapper\"><textarea name=\"description\" \nng-model=\"vm.schedule.description\" md-maxlength=\"450\" rows=\"2\" max-rows=\"8\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 20px !important\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between\"><div \nstyle=\"width: 50%\"><md-checkbox ng-model=\"vm.schedule.enable\" aria-label=\"Enable\" \nstyle=\"position: relative;top: 50%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%)\" \nhas-permission=\"display_new_schedule_form_active\"><label translate=\"DISPLAYSCHEDULEADD.check_to_enbale\">check_to_enbale\n</label></md-checkbox></div><div style=\"width: 50%\"><md-button type=\"submit\" class=\"md-accent md-raised mr-0\" \nstyle=\"float: right\" \nng-disabled=\"(programForm.$invalid || vm.events.length == 0) || (programForm.$pristine || vm.events.length == 0)\" \naria-label=\"vm.isNew ? Save : Edit\"><span translate=\"DISPLAYSCHEDULEADD.add\">add</span></md-button><md-button \nclass=\"md-accent md-raised\" style=\"float: right\" ng-click=\"vm.attributeRmbox(vm.schedule)\" \nhas-permission=\"display_new_schedule_form_attribute\" aria-label=\"Attribute\"><span \ntranslate=\"DISPLAYSCHEDULEADD.attribute\">add</span></md-button></div></div></form></div></md-content></div><div \nclass=\"price-tables\" flex layout=\"row\" style=\"margin-top:20px\"><div flex=\"79\"><md-content ng-cloack><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\" layout=\"row\" layout-align=\"space-between center\"><div flex=\"grow\" \nclass=\"text-center calendar-title\" layout-align=\"center\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.PREVIOUS\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev();vm.calendar.rerenderEvents()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><md-truncate><span><strong>{{vm.calendarView.title}}\n</strong></span></md-truncate><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.NEXT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next();vm.calendar.rerenderEvents()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></a></div><md-select ng-model=\"display\" placeholder=\"Afficher par\" \nclass=\"md-no-underline font-size-14 margin-0\" flex=\"nogrow\"><md-option value=\"today\" \nng-click=\"vm.calendar.today();vm.calendar.rerenderEvents();vm.click(\'today\')\">\n{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}</md-option><md-option value=\"day\" \nng-click=\"vm.calendar.changeView(\'agendaDay\');vm.calendar.rerenderEvents();vm.click(\'agendaDay\')\">\n{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}</md-option><md-option value=\"week\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\');vm.calendar.rerenderEvents();vm.click(\'agendaWeek\')\">\n{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}</md-option><md-option value=\"month\" \nng-click=\"vm.calendar.changeView(\'month\');vm.calendar.rerenderEvents();vm.click(\'month\')\">\n{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}</md-option></md-select><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULEADD.programs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'programs-sidenav\')\" hide-gt-md aria-label=\"programs\" \ntranslate translate-attr-aria-label=\"DISPLAYSCHEDULEADD.programs\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\">\n</md-icon></md-button></a></div></md-toolbar><div ng-if=\"vm.type!=\'month\'\" flex=\"100\" layout=\"column\" \nstyle=\"text-align: right;padding-right: 24px\"><div><br><span translate=\"DISPLAYSCHEDULEADD.slot\" \nstyle=\"color: #2D323E !important;font-size: 13px\">slot</span></div><div><md-input-container style=\"margin: 8px 0\">\n<input type=\"number\" min=\"1\" ng-model=\"vm.slot\" ng-change=\"vm.changeSlot()\" \nstyle=\"background: #F9F9F9;border: 1px solid;width:50px\"></md-input-container></div></div><div \nstyle=\"margin:0; padding:0\" layout-align=\"start center\" layout=\"row\" class=\"mv-10 p-24 h-700 material-calendar\" \nng-hide=\"!vm.expanded[\'calendar\']\" ms-scroll><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></md-content></div><div flex=\"20\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"programs-sidenav\" ms-scroll ms-sidenav-helper style=\"padding: 0px 0px 0px;padding-left: 5px\">\n<md-toolbar><div class=\"md-toolbar-tools\"><md-truncate><span class=\"logo-text font-size-14 font-weight-600\" \ntranslate=\"DISPLAYSCHEDULEEDIT.programs\">Programs</span></md-truncate></div></md-toolbar><md-content flex \nclass=\"ph-10\"><md-input-container class=\"md-block mb-40\" md-no-float><input ng-model=\"vm.templateName\" \nng-change=\"vm.searchTenTemplates()\" placeholder=\"{{\'DISPLAYSCHEDULEADD.search\'|translate}}\"></md-input-container><div \nclass=\"programs-sidenav\"><md-list style=\"overflow: hidden; padding-top: 0px; margin-top: -10px\" \nng-if=\"vm.programColors.length\" ng-model=\"vm.programColors\" ui-sortable=\"vm.dragOptions\"><md-list-item \ndir-paginate=\"program in vm.programColors| filter: {title: vm.templateName} | itemsPerPage:10\" \ntotal-items=\"vm.totalPrograms\" current-page=\"vm.pagination.current\" ng-attr-data-index=\"{{$index}}\" \nng-attr-data-color=\"{{program.color}}\" ng-style=\"{\'border-color\': program.color}\"><div class=\"color-overlay\" \nng-style=\"{\'background-color\': program.color}\"></div><span class=\"name\" ng-style=\"{\'color\': program.color}\">\n{{program.title}}</span><md-button aria-label=\"menu\" class=\"md-secondary md-icon-button\" \nstyle=\"width: 20px;height: 20px;min-height: 20px;padding: 0px\" ng-click=\"vm.alert(program)\"><img width=\"16\" \nsrc=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDg4Ljg1IDQ4OC44NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg4Ljg1IDQ4OC44NTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48Zz4KCTxwYXRoIGQ9Ik0yNDQuNDI1LDk4LjcyNWMtOTMuNCwwLTE3OC4xLDUxLjEtMjQwLjYsMTM0LjFjLTUuMSw2LjgtNS4xLDE2LjMsMCwyMy4xYzYyLjUsODMuMSwxNDcuMiwxMzQuMiwyNDAuNiwxMzQuMiAgIHMxNzguMS01MS4xLDI0MC42LTEzNC4xYzUuMS02LjgsNS4xLTE2LjMsMC0yMy4xQzQyMi41MjUsMTQ5LjgyNSwzMzcuODI1LDk4LjcyNSwyNDQuNDI1LDk4LjcyNXogTTI1MS4xMjUsMzQ3LjAyNSAgIGMtNjIsMy45LTExMy4yLTQ3LjItMTA5LjMtMTA5LjNjMy4yLTUxLjIsNDQuNy05Mi43LDk1LjktOTUuOWM2Mi0zLjksMTEzLjIsNDcuMiwxMDkuMywxMDkuMyAgIEMzNDMuNzI1LDMwMi4yMjUsMzAyLjIyNSwzNDMuNzI1LDI1MS4xMjUsMzQ3LjAyNXogTTI0OC4wMjUsMjk5LjYyNWMtMzMuNCwyLjEtNjEtMjUuNC01OC44LTU4LjhjMS43LTI3LjYsMjQuMS00OS45LDUxLjctNTEuNyAgIGMzMy40LTIuMSw2MSwyNS40LDU4LjgsNTguOEMyOTcuOTI1LDI3NS42MjUsMjc1LjUyNSwyOTcuOTI1LDI0OC4wMjUsMjk5LjYyNXoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0ZGRkZGRiIgZGF0YS1vbGRfY29sb3I9IiNmZmZmZmYiPjwvcGF0aD4KPC9nPjwvZz4gPC9zdmc+\">\n</md-button></md-list-item></md-list><div style=\"margin-top: -16px\" class=\"display-new-paginate\">\n<dir-pagination-controls ng-if=\"vm.programs.length\" class=\"paginationDir\" boundary-links=\"true\" \non-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div><div class=\"text-center\" \nng-if=\"!vm.programs.length\"><label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>\n</md-content></md-sidenav></div></div></div></div></div>");
$templateCache.put("app/main/displayNew/schedule/add/associate.rmbox.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><span \ntranslate=\"DISPLAYSCHEDULEADD.attribute_rmbox\"></span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-card-content flex><md-radio-group ng-model=\"vm.attributeFrom\" ng-switch=\"vm.attributeFrom\"><div class=\"mb-15\">\n<md-radio-button flex value=\"rmbox\" aria-label=\"form_attribute_rmbox\" \ntranslate-attr-aria-label=\"DISPLAYSCHEDULEADD.form_attribute_rmbox\"><span><span \ntranslate=\"DISPLAYSCHEDULEADD.form_attribute_rmbox\"></span></span></md-radio-button><md-select \nng-if=\"vm.attributeFrom===\'rmbox\'\" multiple=\"true\" ng-model=\"vm.schedule.rmbox\" \nplaceholder=\"{{ \'DISPLAYSCHEDULEADD.form_attribute_rmbox\'|translate}}\"><md-option value=\"\" translate=\"MESSAGES.nonef\">\n</md-option><md-optgroup label=\"{{ \'DISPLAYSCHEDULEADD.form_attribute_rmbox\'|translate}}\"><md-option \nng-repeat=\"rmbox in vm.rmboxs track by rmbox.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"rmbox.val\">{{rmbox.option}}\n</md-option></md-optgroup></md-select></div><div class=\"mb-15\"><md-radio-button flex value=\"rmboxgroup\" \naria-label=\"form_attribute_rmbox_group\" translate-attr-aria-label=\"DISPLAYSCHEDULEADD.form_attribute_rmbox_group\">\n<span><span translate=\"DISPLAYSCHEDULEADD.form_attribute_rmbox_group\"></span></span></md-radio-button><md-select \nng-if=\"vm.attributeFrom===\'rmboxgroup\'\" multiple=\"true\" ng-model=\"vm.schedule.rmboxgroup\" \nplaceholder=\"{{ \'DISPLAYSCHEDULEADD.form_attribute_rmbox_group\'|translate}}\"><md-option value=\"\" \ntranslate=\"MESSAGES.nonef\"></md-option><md-optgroup \nlabel=\"{{ \'DISPLAYSCHEDULEADD.form_attribute_rmbox_group\'|translate}}\"><md-option \nng-repeat=\"rmboxgroup in vm.rmboxgroups track by rmboxgroup.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"rmboxgroup.val\">{{rmboxgroup.option}}</md-option></md-optgroup></md-select></div></md-radio-group>\n</md-card-content></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<span flex></span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE\n</md-button><md-button class=\"md-raised md-accent\" ng-click=\"vm.validate()\" translate=\"MESSAGES.form_validate\">\nform_validate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/displayNew/schedule/add/programs-sidenav.html","<div class=\"programs-sidenav\"><md-list style=\"overflow: hidden\" ng-if=\"vm.programsss.length\" ng-model=\"vm.programsss\" \nui-sortable=\"vm.dragOptions\"><md-list-item \nng-repeat=\"program in vm.programsss | filter:vm.templateName | orderBy:\'title\' \" ng-attr-data-index=\"{{$index}}\">\n<md-divider></md-divider><div class=\"myHandle md-primary-bg\"></div><strong>{{program}}</strong><md-divider>\n</md-divider></md-list-item></md-list><div class=\"text-center\" ng-if=\"!vm.programs.length\"><label \ntranslate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>");
$templateCache.put("app/main/displayNew/schedule/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\" \nstyle=\"min-height: 200px!important;max-height: 200px!important;height: 200px!important\"><div class=\"header-content\" \nlayout=\"column\" layout-align=\"space-between\"><md-button style=\"position: absolute; z-index: 10;margin: 0\" \nclass=\"md-icon-button\" ng-click=\"vm.showListe()\" aria-label=\"Today\"><md-tooltip md-autohide=\"true\" md-direction=\"top\">\n<span translate=\"PAGESMENUSTITLES.display_schedule_calendar_pagetitle\">display_schedule_calendar_pagetitle</span>\n</md-tooltip><md-icon md-font-icon=\"icon-calendar-text\"></md-icon></md-button><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" style=\"top:30%\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"DISPLAYSCHEDULECALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" \naria-label=\"Today\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" \naria-label=\"Week\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.WEEK\"><md-icon \nmd-font-icon=\"icon-view-week\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n</md-button></a></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div><div class=\"content\"><div \nid=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/displayNew/schedule/details-modal/details-modal.html","<md-dialog aria-label=\"playlist_detail_pagetitle\" class=\"program-details-modal\" style=\"max-width: 450px\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span>{{vm.program.title}}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"column\"><img src=\"{{vm.screenshot}}\" alt=\"\"><div layout=\"row\"><md-input-container \nclass=\"mb-0\" flex=\"\"><div flex=\"\" class=\"date-container\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">\nstart_date</label><div layout=\"row\"><div flex=\"auto\"><md-datepicker ng-model=\"vm.startDate\"></md-datepicker></div><div \nflex=\"nogrow\"><inline-time-input model=\"vm.startDate\" time-mode=\"24\"></inline-time-input></div></div></div>\n</md-input-container><md-input-container class=\"mb-0\" flex=\"\"><div flex=\"\" class=\"date-container pl-10\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.end_date\">end_date</label><div layout=\"row\"><div flex=\"auto\"><md-datepicker \nng-model=\"vm.endDate\"></md-datepicker></div><div flex=\"nogrow\"><inline-time-input model=\"vm.endDate\" time-mode=\"24\">\n</inline-time-input></div></div></div></md-input-container></div><md-input-container flex=\"100\" class=\"mb-0\" \nhas-permission=\"display_new_loop\"><label class=\"md-no-float md-container-ignore\">Répeter le programme</label><md-select\n ng-model=\"vm.periodLoop\" placeholder=\"Répéter le programme\" class=\"md-no-underline select-container\"><md-option \nvalue=\"\">Jamais</md-option><md-option value=\"day\">Tous les jours</md-option><md-option value=\"week\">Toutes les semaines\n</md-option><md-option value=\"month\">Tous les mois</md-option><md-option value=\"year\">Toutes les années</md-option>\n</md-select></md-input-container><md-input-container layout=\"row\" class=\"mb-0\" ng-if=\"vm.periodLoop\"><div flex=\"\" \nclass=\"date-container\"><label class=\"md-no-float\">Se termine a</label><div layout=\"row\"><div flex=\"auto\"><md-datepicker\n ng-model=\"vm.repeatEndDate\"></md-datepicker></div><div flex=\"nogrow\"><inline-time-input model=\"vm.repeatEndDate\" \ntime-mode=\"24\"></inline-time-input></div></div></div></md-input-container><div class=\"error-message-container\" \nng-if=\"vm.errorMessage\">{{vm.errorMessage}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nclass=\"md-raised md-primary\" ng-click=\"vm.save()\" translate=\"MESSAGES.form_save\">form_save</md-button><span flex>\n</span><md-button class=\"md-icon-button launch\" ng-click=\"vm.remove()\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/interactivity/comments/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"media_comments_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.media_comments_detail_pagetitle\">\nmedia_comments_detail_pagetitle</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><img style=\"margin: auto\" ng-if=\"vm.comments.img\" width=\"100\" \nheight=\"100\" class=\"product-image\" ng-src=\"{{vm.comments.img}}\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"COMMENTSDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{vm.comments.id}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"COMMENTSDETAIL.status\">status</strong></h3></div><div \nclass=\"md-secondary\"><i ng-if=\"vm.comments.status==true\" md-colors=\"{color: \'green\'}\" class=\"icon icon-check\"></i> <i \nng-if=\"vm.comments.status==false\" md-colors=\"{color: \'red\'}\" class=\"icon icon-alert\"></i></div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"COMMENTSDETAIL.comment\">comment</strong></h3><div ng-if=\"vm.comments.comment.length<99\" \nclass=\"md-secondary\">{{vm.comments.comment}}</div><div ng-if=\"vm.comments.comment.length>=99\">{{vm.comments.comment}}\n</div></div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"COMMENTSDETAIL.ip\">ip</strong></h3></div><div class=\"md-secondary\">{{vm.comments.userip}}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"COMMENTSDETAIL.created_at\">created_at</strong></h3></div><div class=\"md-secondary\">\n{{vm.comments.created_at| date:\'yyyy-MM-dd hh:mm:ss\'}}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/interactivity/comments/edit/edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/interactivity/comments/edit/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/interactivity/comments/edit/form.template.html","<form name=\"empMediaCommentsForm\" method=\"post\" class=\"md-inline-form\" id=\"empMediaCommentsForm\" \nnovalidate=\"novalidate\" ng-submit=\"empMediaCommentsForm.$valid && vm.submitAddCommentsForm()\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"COMMENTSEDIT.form_title\">form_title</span>\n</div><input type=\"hidden\" ng-model=\"vm.empMediaCommentsForm.img\" id=\"empMediaCommentsForm_img\" \nname=\"empMediaCommentsForm[img]\" class=\"btn btn-default\"><div class=\"mv-24\" id=\"file-uploader\" \nhas-permission=\"comment_post_select_file\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"COMMENTSEDIT.choose_img\">choose_img</any></md-button></div><md-input-container class=\"md-block\"><label \ntranslate=\"COMMENTSEDIT.form_attr_comment\" for=\"empMediaCommentsForm_comment\">COMMENTSEDIT.form_attr_comment</label>\n<div class=\"md-resize-wrapper\"><textarea id=\"empMediaCommentsForm_comment\" name=\"empMediaCommentsForm[comment]\" \nng-attr-name=\"comment\" ng-model=\"vm.empMediaCommentsForm.comment\" \nclass=\"ng-pristine ng-valid md-input ng-not-empty ng-touched\" rows=\"1\" aria-invalid=\"false\" style=\"height: 30px\" \nrequired></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empMediaCommentsForm.comment.$error\" role=\"alert\"><div ng-message=\"comment\" \ntranslate=\"MESSAGES.form_is_required\">form_is_mail</div></div></md-input-container><md-button class=\"md-warn\" \nng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empMediaCommentsForm.$invalid || (empMediaCommentsForm.$pristine && !vm.is_image_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/displayNew/schedule/edit/edit.html","<div class=\"page-layout simple right-sidenav inner-sidenav calendar_display_new\"><div class=\"content\" md-background-bg \nlayout=\"row\" ms-scroll><div flex><div class=\"price-tables\" flex layout=\"row\"><md-content flex><md-toolbar><div \nclass=\"md-toolbar-tools pv-5\"><md-truncate><span class=\"logo-text\" translate=\"DISPLAYSCHEDULEEDIT.editSchedule\">\nModifier Schedule</span> <strong ng-if=\"vm.schedule.title\">: {{vm.schedule.title}}</strong></md-truncate><span flex>\n</span> <a tooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button ng-click=\"vm.expanded[\'form\'] = 0\" ng-if=\"vm.expanded[\'form\']\" class=\"md-icon-button\" aria-label=\"collapse\" \ntranslate-attr-aria-label=\"MESSAGES.collapse\"><md-icon md-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.expanded[\'form\'] = 1\" ng-if=\"!vm.expanded[\'form\']\" class=\"md-icon-button\" \naria-label=\"expand\" translate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\">\n</md-icon></md-button></a></div></md-toolbar><div layout-align=\"start center\" layout=\"row\" class=\"p-10\" \nng-hide=\"!vm.expanded[\'form\']\"><form name=\"programForm\" ng-submit=\"vm.updateSchedule()\" class=\"flex\" novalidate><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex class=\"pr-10\"><label translate=\"DISPLAYSCHEDULEEDIT.title\" \nclass=\"md-no-float\">Title</label><input name=\"title\" ng-model=\"vm.schedule.title\" required md-autofocus \nstyle=\"height: 26px\"><div ng-messages=\"programForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empScheduleError.title && vm.schedule.title === vm.empScheduleError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empScheduleError.title.message}}\" class=\"validation_api\">empScheduleError_name</div></div>\n</md-input-container><md-input-container flex class=\"pl-10\"><label translate=\"DISPLAYSCHEDULEEDIT.description\" \nclass=\"md-no-float\">Description</label><div class=\"md-resize-wrapper\"><textarea name=\"description\" \nng-model=\"vm.schedule.description\" md-maxlength=\"450\" rows=\"2\" max-rows=\"8\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 20px !important\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-between\"><div \nstyle=\"width: 50%\"><md-checkbox ng-model=\"vm.schedule.enable\" aria-label=\"Enable\" \nstyle=\"position: relative;top: 50%;-webkit-transform: translateY(-50%);-ms-transform: translateY(-50%);transform: translateY(-50%)\" \nhas-permission=\"display_new_schedule_form_active\"><label translate=\"DISPLAYSCHEDULEEDIT.check_to_enbale\">\ncheck_to_enbale</label></md-checkbox></div><div style=\"width: 50%\"><md-button type=\"submit\" \nclass=\"md-accent md-raised mr-0\" style=\"float: right\" \nng-disabled=\"(programForm.$invalid ) || (programForm.$pristine )\" aria-label=\"vm.isNew ? Save : Edit\"><span \ntranslate=\"DISPLAYSCHEDULEEDIT.edit\">edit</span></md-button><md-button class=\"md-accent md-raised\" \nstyle=\"float: right\" ng-click=\"vm.attributeRmbox(vm.schedule)\" has-permission=\"display_new_schedule_form_attribute\" \naria-label=\"Attribute\"><span translate=\"DISPLAYSCHEDULEADD.attribute\">add</span></md-button></div></div></form></div>\n</md-content></div><div class=\"price-tables\" flex layout=\"row\" style=\"margin-top:20px\"><div flex=\"79\"><md-content \nng-cloack><md-toolbar><div class=\"md-toolbar-tools pv-5\" layout=\"row\" layout-align=\"space-between center\"><div \nflex=\"grow\" class=\"text-center calendar-title\" layout-align=\"center\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.PREVIOUS\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev();vm.calendar.rerenderEvents()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><md-truncate><span><strong>{{vm.calendarView.title}}\n</strong></span></md-truncate><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.NEXT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next();vm.calendar.rerenderEvents()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></a></div><md-select ng-model=\"display\" placeholder=\"Afficher par\" \nclass=\"md-no-underline font-size-14 margin-0\" flex=\"nogrow\"><md-option value=\"today\" \nng-click=\"vm.calendar.today();vm.calendar.rerenderEvents();vm.click(\'today\')\">\n{{\'DISPLAYSCHEDULECALENDAR.TODAY\'|translate}}</md-option><md-option value=\"day\" \nng-click=\"vm.calendar.changeView(\'agendaDay\');vm.calendar.rerenderEvents();vm.click(\'agendaDay\')\">\n{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}</md-option><md-option value=\"week\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\');vm.calendar.rerenderEvents();vm.click(\'agendaWeek\')\">\n{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}</md-option><md-option value=\"month\" \nng-click=\"vm.calendar.changeView(\'month\');vm.calendar.rerenderEvents();vm.click(\'month\')\">\n{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}</md-option></md-select><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULEEDIT.programs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'programs-sidenav\')\" hide-gt-md aria-label=\"programs\" \ntranslate translate-attr-aria-label=\"DISPLAYSCHEDULEEDIT.programs\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\">\n</md-icon></md-button></a></div></md-toolbar><div ng-if=\"vm.type!=\'month\'\" flex=\"100\" layout=\"column\" \nstyle=\"text-align: right;padding-right: 24px\"><div><br><span translate=\"DISPLAYSCHEDULEADD.slot\" \nstyle=\"color: #2D323E !important;font-size: 13px\">slot</span></div><div><md-input-container style=\"margin: 8px 0\">\n<input type=\"number\" min=\"1\" ng-model=\"vm.slot\" ng-change=\"vm.changeSlot()\" \nstyle=\"background: #F9F9F9;border: 1px solid;width:50px\"></md-input-container></div></div><div \nstyle=\"margin:0; padding:0\" layout-align=\"start center\" layout=\"row\" class=\"mv-10 p-24 h-700 material-calendar\" \nng-hide=\"!vm.expanded[\'calendar\']\" ms-scroll><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.events\" calendar=\"main\"></div></div></md-content></div><div flex=\"20\"><md-sidenav \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nmd-component-id=\"programs-sidenav\" ms-scroll ms-sidenav-helper style=\"padding: 0px 0px 0px;padding-left: 5px\">\n<md-toolbar><div class=\"md-toolbar-tools\"><md-truncate><span class=\"logo-text font-size-14 font-weight-600\" \ntranslate=\"DISPLAYSCHEDULEEDIT.programs\">Programs</span></md-truncate></div></md-toolbar><md-content flex \nclass=\"ph-10\"><md-input-container class=\"md-block mb-40\" md-no-float><input ng-model=\"vm.templateName\" \nng-change=\"vm.searchTenTemplates()\" placeholder=\"{{\'DISPLAYSCHEDULEADD.search\'|translate}}\"></md-input-container><div \nclass=\"programs-sidenav\"><md-list style=\"overflow: hidden; padding-top: 0px; margin-top: -10px\" \nng-if=\"vm.programColors.length\" ng-model=\"vm.programColors\" ui-sortable=\"vm.dragOptions\"><md-list-item \ndir-paginate=\"program in vm.programColors| filter: {title: vm.templateName} | itemsPerPage:10\" \ntotal-items=\"vm.totalPrograms\" current-page=\"vm.pagination.current\" ng-attr-data-index=\"{{$index}}\" \nng-attr-data-color=\"{{program.color}}\" ng-style=\"{\'border-color\': program.color}\"><div class=\"color-overlay\" \nng-style=\"{\'background-color\': program.color}\"></div><span class=\"name\" ng-style=\"{\'color\': program.color}\">\n{{program.title}}</span><md-button aria-label=\"menu\" class=\"md-secondary md-icon-button\" \nstyle=\"width: 20px;height: 20px;min-height: 20px;padding: 0px\" ng-click=\"vm.alert(program)\"><img width=\"16\" \nsrc=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB2ZXJzaW9uPSIxLjEiIGlkPSJDYXBhXzEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgNDg4Ljg1IDQ4OC44NSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDg4Ljg1IDQ4OC44NTsiIHhtbDpzcGFjZT0icHJlc2VydmUiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiBjbGFzcz0iIj48Zz48Zz4KCTxwYXRoIGQ9Ik0yNDQuNDI1LDk4LjcyNWMtOTMuNCwwLTE3OC4xLDUxLjEtMjQwLjYsMTM0LjFjLTUuMSw2LjgtNS4xLDE2LjMsMCwyMy4xYzYyLjUsODMuMSwxNDcuMiwxMzQuMiwyNDAuNiwxMzQuMiAgIHMxNzguMS01MS4xLDI0MC42LTEzNC4xYzUuMS02LjgsNS4xLTE2LjMsMC0yMy4xQzQyMi41MjUsMTQ5LjgyNSwzMzcuODI1LDk4LjcyNSwyNDQuNDI1LDk4LjcyNXogTTI1MS4xMjUsMzQ3LjAyNSAgIGMtNjIsMy45LTExMy4yLTQ3LjItMTA5LjMtMTA5LjNjMy4yLTUxLjIsNDQuNy05Mi43LDk1LjktOTUuOWM2Mi0zLjksMTEzLjIsNDcuMiwxMDkuMywxMDkuMyAgIEMzNDMuNzI1LDMwMi4yMjUsMzAyLjIyNSwzNDMuNzI1LDI1MS4xMjUsMzQ3LjAyNXogTTI0OC4wMjUsMjk5LjYyNWMtMzMuNCwyLjEtNjEtMjUuNC01OC44LTU4LjhjMS43LTI3LjYsMjQuMS00OS45LDUxLjctNTEuNyAgIGMzMy40LTIuMSw2MSwyNS40LDU4LjgsNTguOEMyOTcuOTI1LDI3NS42MjUsMjc1LjUyNSwyOTcuOTI1LDI0OC4wMjUsMjk5LjYyNXoiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgc3R5bGU9ImZpbGw6I0ZGRkZGRiIgZGF0YS1vbGRfY29sb3I9IiNmZmZmZmYiPjwvcGF0aD4KPC9nPjwvZz4gPC9zdmc+\">\n</md-button></md-list-item></md-list><div style=\"margin-top: -16px\" class=\"display-new-paginate\">\n<dir-pagination-controls ng-if=\"vm.programs.length\" class=\"paginationDir\" boundary-links=\"true\" \non-page-change=\"vm.pageChanged(newPageNumber)\"></dir-pagination-controls></div><div class=\"text-center\" \nng-if=\"!vm.programs.length\"><label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>\n</md-content></md-sidenav></div></div></div></div></div>");
$templateCache.put("app/main/displayNew/schedule/edit/programs-sidenav.html","<div class=\"programs-sidenav\"><md-list ms-scroll ng-if=\"vm.templates.length\" ng-model=\"vm.templates\" \nui-sortable=\"vm.dragOptions\"><md-list-item ng-repeat=\"template in ::vm.templates track by template.id\" \nng-attr-data-index=\"{{$index}}\"><div class=\"myHandle md-primary-bg\"></div><strong>{{template.title}}</strong>\n<md-divider ng-if=\"!$last\"></md-divider></md-list-item></md-list><div class=\"text-center\" ng-if=\"!vm.templates.length\">\n<label translate=\"DISPLAYSCHEDULELIST.no_program\">no_program</label></div></div>");
$templateCache.put("app/main/interactivity/comments/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-tabs id=\"comments\" \nclass=\"md-border-bottom\" layout-fill md-selected=\"$root.selectedIndex\" \nstyle=\"background-color: white;min-height: 100%\" md-stretch-tabs=\"yes\" flex><md-tab \nng-if=\"vm.testInLiveMedia !=\'media\'\" data-ui-sref=\"app.comments_list.live\"><md-tab-label><span \ntranslate=\"COMMENTSLIST.direct_comments\">Commentaires direct</span></md-tab-label><md-tab-body layout-fill flex><div \nlayout-fill data-ui-view=\"live\" flex></div></md-tab-body></md-tab><md-tab ng-if=\"vm.testInLiveMedia !=\'live\'\" \ndata-ui-sref=\"app.comments_list.media\"><md-tab-label flex><span translate=\"COMMENTSLIST.media_comments\">\nCommentaires media</span></md-tab-label><md-tab-body layout-fill flex><div layout-fill data-ui-view=\"live\" flex></div>\n</md-tab-body></md-tab></md-tabs></div>");
$templateCache.put("app/main/interactivity/comments/list/list_dataTable.html","<any id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" style=\"width:100%\"><a tooltips \ntooltip-template=\"{{\'COMMENTSLIST.delete_comments\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nng-if=\"vm.selectedCommentss.length\" class=\"md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedCommentsConfirm($event)\" has-permission=\"comment_post_multi_delete\" \naria-label=\"delete_groups_aria_label\" translate translate-attr-aria-label=\"COMMENTSLIST.delete_comments\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div layout=\"row\" \nng-if=\"state.params.id && vm.hasExportExcelApi\"><md-button class=\"m16 md-icon-thumb-down md-icon-button\" \nhas-permission=\"comment_post_export\" ng-click=\"vm.exportExcelComments($event)\" aria-label=\"export_excel\" translate \ntranslate-attr-aria-label=\"COMMENTSLIST.export_excel\"><md-icon md-font-icon=\"icon-file-excel\" class=\"s18\"></md-icon>\n<md-tooltip md-autohide=\"true\" md-direction=\"bottom\">{{\'COMMENTSLIST.export_excel\'|translate}}</md-tooltip></md-button>\n</div><div flex=\"60\" layout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"comments-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" ng-model=\"vm.search_Comments\" \nng-keydown=\"$event.keyCode === 13 && vm.searchComments()\"></md-input-container></div></div><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th><md-checkbox \nng-if=\"vm.commentss.length>0 && vm.pemission.comment_post_multi_delete\" \nng-checked=\"(vm.selectedCommentss.length === vm.commentss.length) && (vm.selectedCommentss.length > 0)\" \nmd-indeterminate=\"vm.selectedCommentss.length !== 0 && vm.selectedCommentss.length !== vm.commentss.length\" \nng-click=\"vm.toogleSelection($event)\" aria-label=\"-\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"COMMENTSLIST.status\">status</span>\n</div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"COMMENTSLIST.image\">image</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"COMMENTSLIST.comment\">comment</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"COMMENTSLIST.name\">Name</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"COMMENTSLIST.date\">date</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead></table></div></div></any>");
$templateCache.put("app/main/interactivity/sondage/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-survey\" layout=\"column\"><div\n class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/interactivity/sondage/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/interactivity/sondage/add_edit_view/form.template.html","<form name=\"empSondageForm\" method=\"post\" id=\"empSondageForm\" novalidate=\"novalidate\" \nng-submit=\"empSondageForm.$valid && vm.submitAddSondageForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\" ng-if=\"vm.isNew\"></md-icon><span translate=\"SONDAGEADD.form_title\" \nng-if=\"vm.isNew\">form_title</span><md-icon md-font-icon=\"icon-pen\" class=\"s18\" ng-if=\"!vm.isNew\"></md-icon><span \ntranslate=\"SONDAGEEDIT.form_title\" ng-if=\"!vm.isNew\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SONDAGEADD.form_attr_name\" for=\"empSondageForm_name\" \nclass=\"required ng-scope md-required\">Nom</label><input type=\"text\" id=\"empSondageForm_name\" \nname=\"empSondageForm[name]\" required ng-name=\"name\" ng-attr-name=\"name\" ng-model=\"vm.empSondageForm.name\" \naria-invalid=\"true\"><div ng-messages=\"empSondageForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empSondageError.name && vm.empSondageForm.name === vm.empSondageError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empSondageError.name.message}}\" class=\"validation_api\">empAbonnementGroupError_name</div>\n</div></md-input-container></div><div id=\"collection-items\" class=\"collection-items\"><div><div \nng-repeat=\"elemnt in vm.questionelemnt\"><div><div style=\"display:inline\"><div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"SONDAGEADD.form_attr_question\" for=\"empSondageForm_question\" \nclass=\"required ng-scope md-required\">form_attr_question</label><input type=\"text\" id=\"empSondageForm_question\" \nname=\"empSondageForm[question]\" ng-model=\"elemnt.question\" ng-name=\"question\" ng-attr-name=\"question\" required><div \nng-messages=\"empSondageForm.question.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empSondageError.question && vm.empSondageForm.question === vm.empSondageError.question.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empSondageError.question.message}}\" class=\"validation_api\">empAbonnementGroupError_name\n</div></div></md-input-container></div></div></div><div style=\"display:inline\"><md-radio-group ng-model=\"elemnt.nsp\">\n<md-radio-button value=\"1\" class=\"md-primary\"><label translate=\"SONDAGEADD.form_attr_on\">form_attr_on</label>\n</md-radio-button><md-radio-button value=\"0\"><label translate=\"SONDAGEADD.form_attr_onp\">form_attr_onp</label>\n</md-radio-button></md-radio-group></div><span ng-hide=\"vm.questionelemnt.length === 1\"><md-button \nng-click=\"vm.deleteQuestion($index)\" aria-label=\"delete_sondage\" translate \ntranslate-attr-aria-label=\"SONDAGELIST.delete_sondage\" class=\"md-raised md-warn\">\n{{ \'SONDAGELIST.delete_sondage\'|translate }}</md-button></span></div><hr></div><div><md-button \nng-click=\"vm.addFormField($event)\" aria-label=\"add\" translate translate-attr-aria-label=\"SONDAGEADD.add\" \nclass=\"md-accent md-raised md-hue-1\">{{ \'SONDAGEADD.add\'|translate }}</md-button></div></div></div><md-button \nclass=\"md-warn\" ui-sref=\"app.sondage_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"empSondageForm.$invalid || empSondageForm.$pristine\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empSondageForm.$invalid || (empSondageForm.$pristine && !vm.delete_question_is_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/interactivity/sondage/detailVote/detailVote.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" layout-align=\"space-between center\"><div \nclass=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.interactivity_menuTitle\">interactivity_menuTitle</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.sondage_menuTitle\">abonnement_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 black-fg separator\"></md-icon><span class=\"parent\" translate=\"PAGESMENUSTITLES.sondage_detail_pagetitle\">\nabonnement_group_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon>\n<span class=\"parent\" translate=\"PAGESMENUSTITLES.vote_detail_pagetitle\">abonnement_group_list_pagetitle</span></div>\n</div><div style=\"margin-top: -10px\" layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><a tooltips tooltip-template=\"{{\'MESSAGES.help\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.showHelp()\" \naria-label=\"show_calendar\" translate translate-attr-aria-label=\"EVENTLIST.show_calendar\"><md-icon \nmd-font-icon=\"icon-help-circle\" class=\"ng-scope md-default-theme md-font material-icons icon-calendar\" \naria-hidden=\"true\"></md-icon></md-button></a></div></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"ng\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"VOTELIST.name\">form_choices_yes\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"VOTELIST.last_name\">form_choices_no</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"VOTELIST.vote\">other</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.created_at\">action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"vote in vm.votes track by vote.id\" ng-attr-data-index=\"{{$index}}\"><td class=\"secondary-text\"><div><span>\n{{vote.abonne.name}}</span></div></td><td class=\"secondary-text\"><div><span>{{vote.abonne.lastName}}</span></div></td>\n<td class=\"secondary-text\"><div ng-if=\"vote.vote === 1\"><span translate=\"VOTELIST.yes\">yes</span></div><div \nng-if=\"vote.vote === 0\"><span translate=\"VOTELIST.no\">no</span></div><div ng-if=\"vote.vote !== 1 && vote.vote !== 0\">\n<span translate=\"VOTELIST.other\">other</span></div></td><td class=\"secondary-text\"><div><span>\n{{ vote.created_at | amTimezone:\'Europe/Paris\' | amDateFormat : defaultTimeFormat }}</span></div></td></tr></tbody>\n</table></div></div></div>");
$templateCache.put("app/main/displayNew/schedule/list/list.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.showCalendar()\" aria-label=\"show_calendar\" translate \ntranslate-attr-aria-label=\"EVENTLIST.show_calendar\"><md-tooltip md-autohide=\"true\"><span \ntranslate=\"EVENTLIST.show_calendar\">show_calendar</span></md-tooltip><md-icon md-font-icon=\"icon-calendar-multiple\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-multiple\" aria-hidden=\"true\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedschedules.length\"><a tooltips \ntooltip-template=\"{{\'ABONNEMENTUSERLIST.delete_user\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nng-if=\"vm.selectedschedules.length\" class=\"md-icon-button\" ng-click=\"vm.deleteSelectedschedulesConfirm($event)\" \naria-label=\"delete_user\" translate translate-attr-aria-label=\"ABONNEMENTUSERLIST.delete_user\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"abonnement-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_Schedule\" ng-change=\"vm.searchSchedule()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewSchedule($event)\" \naria-label=\"action_new_element\" has-permission=\"display_new_schedule_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button>{{console.log(\"vmmm\", vm.addNewSchedule($event))}}</div><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex><table class=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" \ndt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th><md-checkbox style=\"margin-left: 40%\" \naria-label=\"-\" ng-checked=\"(vm.selectedschedules.length === vm.schedules.length) && (vm.selectedschedules.length > 0)\" \nmd-indeterminate=\"vm.selectedschedules.length !== 0 && vm.selectedschedules.length !== vm.schedules.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"DISPLAYSCHEDULECALENDAR.TITLE\">title</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"DISPLAYSCHEDULECALENDAR.STARTAT\">debut</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"DISPLAYSCHEDULECALENDAR.ENDAT\">fin\n</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div>\n</div>");
$templateCache.put("app/main/interactivity/sondage/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"sondage_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.sondage_detail_pagetitle\">sondage_detail_pagetitle\n</span> <span>{{ vm.sondage.name |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SONDAGEDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.sondage.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SONDAGEDETAIL.name\">name</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.sondage.name }}</div><md-divider></md-divider></md-list-item><div \nng-repeat=\"question in vm.sondage.questions track by question.id\" ng-attr-data-index=\"{{$index}}\"><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"SONDAGEDETAIL.question\">question</strong></h3>\n<h3><strong translate=\"SONDAGEDETAIL.response\">response</strong></h3></div><div class=\"md-secondary\"><div \nlayout=\"column\"><div flex>{{ question.question }}</div><div flex><label ng-if=\"question.nsp\" \ntranslate=\"SONDAGEADD.form_attr_on\">form_attr_on</label><label ng-if=\"!question.nsp\" \ntranslate=\"SONDAGEADD.form_attr_onp\">form_attr_onp</label></div></div></div><md-divider></md-divider></md-list-item>\n</div></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/interactivity/advertising/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div \nng-include=\"\'app/main/interactivity/advertising/add_edit_view/form.template.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/interactivity/advertising/add_edit_view/form.template.html","<form name=\"empAdvertisingForm\" method=\"post\" \nclass=\"md-inline-form ng-pristine ng-valid ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-valid-required\" \nid=\"empAdvertisingForm\" novalidate=\"novalidate\" ng-submit=\"empAdvertisingForm.$valid && vm.submitAddAdvertisingForm()\">\n<div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"ADVERTISINGADD.form_title\">form_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"ADVERTISINGADD.form_title\">form_title\n</span></div><any><input type=\"hidden\" id=\"empAdvertisingForm_logo\" name=\"empAdvertisingForm[logo]\" \nng-model=\"vm.empAdvertisingForm.logo\" aria-invalid=\"false\"><div \nng-if=\"vm.urlVignette==\'\' && vm.advertising.logo==null\" layout-align=\"left left\" layout=\"row\" class=\"s18\"><md-icon \nmd-font-icon=\"icon-picture\" style=\"margin-left: 60px\" class=\"s72\" width=\"100\" height=\"100\"></md-icon></div><div \nng-if=\"vm.urlVignette==\'\' && vm.advertising.logo\" layout=\"row\" class=\"s18\"><img \nstyle=\"height: 60px;width: 80px; margin-left: 60px\" ng-src=\"{{vm.advertising.logo}}\"></div><div ng-if=\"vm.urlVignette\" \nlayout=\"row\" class=\"s18\"><img style=\"height: 60px;width: 80px; margin-left: 60px\" ng-src=\"{{vm.urlVignette}}\"></div>\n<div class=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"ADVERTISINGADD.choose_thumb\">choose_thumb</any></md-button></div></any><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"ADVERTISINGADD.form_attr_title\">Titre</label><input \ntype=\"text\" id=\"empAdvertisingForm_title\" name=\"empAdvertisingForm[title]\" ng-model=\"vm.empAdvertisingForm.title\" \nrequired ng-attr-name=\"title\" ng-name=\"title\" aria-invalid=\"true\"><div ng-messages=\"empAdvertisingForm.title.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empAbonnementGroupError.title && vm.empAbonnementGroupForm.title === vm.empAbonnementGroupError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empAbonnementGroupError.title.message}}\" class=\"validation_api\">\nempAbonnementGroupError_name</div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"ADVERTISINGADD.form_attr_linkUrl\">Lien URL</label><input type=\"text\" \nid=\"empAdvertisingForm_linkUrl\" name=\"empAdvertisingForm[linkUrl]\" ng-model=\"vm.empAdvertisingForm.link_url\" \naria-invalid=\"false\"></md-input-container></div><md-input-container style=\"width:100%\" flex><label \ntranslate=\"ADVERTISINGADD.form_attr_startDate\">form attr endDate</label><md-datepicker required \nng-model=\"vm.empAdvertisingForm.date_start\" ng-attr-name=\"start_date\" md-max-date=\"vm.empAdvertisingForm.date_end\" \nmd-open-on-focus name=\"empAdvertisingForm[start_date]\" id=\"empAdvertisingForm_start_date\" md-format=\"DD/MM/YYYY\"><label\n class=\"md-no-float\" translate=\"MESSAGES.start_date\">start_date</label><div \nng-messages=\"empAdvertisingForm.start_date.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.date_valid\">\ndate_valid</div><div ng-message=\"maxDate\" translate=\"MESSAGES.date_max\">date_max</div></div></md-datepicker>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container style=\"width:100%\" flex><label \ntranslate=\"ADVERTISINGADD.form_attr_endDate\">form attr endDate</label><md-datepicker required \nng-model=\"vm.empAdvertisingForm.date_end\" ng-attr-name=\"end_date\" md-min-date=\"vm.empAdvertisingForm.date_start\" \nmd-open-on-focus name=\"empAdvertisingForm[end_date]\" id=\"empAdvertisingForm_end_date\" md-format=\"DD/MM/YYYY\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.end_date\">end_date</label><div \nng-messages=\"empAdvertisingForm.end_date.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.date_valid\">\ndate_valid</div><div ng-message=\"minDate\" translate=\"MESSAGES.date_min\">date_min</div></div></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-card-content flex><md-select translate \ntranslate=\"MESSAGES.form_attr_active\" name=\"empAdvertisingForm[active]\" id=\"empAdvertisingForm_active\" \nng-model=\"vm.empAdvertisingForm.active\" placeholder=\"{{ \'ADVERTISINGADD.form_attr_visibility\'|translate}}\"><md-option \nng-repeat=\"visibilityChoice in vm.visibilityChoices\" ng-value=\"visibilityChoice.val\" \ntranslate=\"MESSAGES.{{ visibilityChoice.options }}\">{{ visibilityChoice.options }}</md-option></md-select>\n</md-card-content></div><md-button class=\"md-warn\" ui-sref=\"app.advertising_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empAdvertisingForm.$invalid || empAdvertisingForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empAdvertisingForm.$invalid || empAdvertisingForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/interactivity/advertising/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"advertising_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.advertising_detail_pagetitle\">\nadvertising_detail_pagetitle</span> <span>{{ vm.advertising.title |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><img \nstyle=\"margin: auto\" ng-if=\"vm.advertising.logo\" width=\"100\" height=\"100\" class=\"product-image\" \nng-src=\"{{ vm.advertising.logo }}\"><md-list flex><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"ADVERTISINGDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">{{ vm.advertising.id }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ADVERTISINGDETAIL.title\">title</strong></h3></div><div class=\"md-secondary\">{{ vm.advertising.title }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ADVERTISINGDETAIL.link_url\">link_url</strong></h3></div><div class=\"md-secondary\">\n{{ vm.advertising.link_url }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"ADVERTISINGDETAIL.date_start\">date_start</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.advertising.date_start | date:\"dd/MM/yyyy\" }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"ADVERTISINGDETAIL.date_end\">\ndate_end</strong></h3></div><div class=\"md-secondary\">{{ vm.advertising.date_end | date:\"dd/MM/yyyy\" }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ADVERTISINGDETAIL.active\">active</strong></h3></div><div class=\"md-secondary\"><i \nng-if=\"vm.advertising.active === true\" class=\"icon-checkbox-marked-circle green-500-fg\"><span class=\"hide\">1</span></i>\n <i ng-if=\"vm.advertising.active === false\" class=\"icon-cancel red-500-fg\"><span class=\"hide\">1</span></i></div>\n<md-divider></md-divider></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/interactivity/sondage/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedSondages.length\" \nhas-permission=\"sondage_delete_multi\"><a tooltips \ntooltip-template=\"{{\'SONDAGELIST.delete_sondages_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteSondagesConfirm($event)\" \naria-label=\"Delete Sondages\" translate translate-attr-aria-label=\"SONDAGELIST.delete_sondages_aria_label\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"sondags-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_sondage\" ng-keydown=\"$event.keyCode === 13 && vm.searchSondages()\"></md-input-container></div>\n<md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewSondage($event)\" \naria-label=\"add_sondage\" translate translate-attr-aria-label=\"MESSAGES.add_sondage\" has-permission=\"sondage_post_add\">\n<div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" \nclass=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><md-checkbox \nng-if=\"vm.sondages.length>0\" \nng-checked=\"(vm.selectedSondages.length === vm.sondages.length) && (vm.selectedSondages.length > 0)\" \nmd-indeterminate=\"vm.selectedSondages.length !== 0 && vm.selectedSondages.length !== vm.sondages.length\" \nng-click=\"vm.toogleSelection()\" aria-label=\"-\"></md-checkbox></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"SONDAGELIST.name\">name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">action</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/interactivity/sondage/vote/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"VOTELIST.question\">question</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.form_choices_yes\">\nform_choices_yes</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.form_choices_no\">form_choices_no</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"VOTELIST.other\">other</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span\n class=\"column-title center-span\" translate=\"MESSAGES.action\">action</span></div></th></tr></thead><tbody><tr \nng-repeat=\"question in vm.questions track by question.id\" ng-attr-data-index=\"{{$index}}\"><td class=\"secondary-text\">\n<div>{{question.question}}</div></td><td class=\"secondary-text\"><div ng-if=\"question.votes.yes !== null\"><span>\n{{question.votes.yes}}</span></div><div ng-if=\"question.votes.yes === null\"><span>0</span></div></td><td \nclass=\"secondary-text\"><div ng-if=\"question.votes.no !== null\"><span>{{question.votes.no}}</span></div><div \nng-if=\"question.votes.no === null\"><span>0</span></div></td><td class=\"secondary-text\"><div \nng-if=\"question.votes.other !== null\"><span>{{question.votes.other}}</span></div><div \nng-if=\"question.votes.other === null\"><span>0</span></div></td><td class=\"secondary-text\"><a \nng-if=\"question.votes.yes !== null || question.votes.no !== null || question.votes.other !== null \" tooltips \ntooltip-template=\"{{\'SONDAGELIST.detail_question\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 delete-button md-icon-button\" ng-click=\"vm.sondageDetailVoteList(question)\" aria-label=\"Détails vote\" \ntranslate translate-attr-aria-label=\"SONDAGELIST.detail_question\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon></md-button></a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/interactivity/advertising/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedAdvertisings.length\" \nhas-permission=\"parameters_advertising_delete_multi\"><a tooltips \ntooltip-template=\"{{\'ADVERTISINGLIST.delete_advertising\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedAdvertisingsConfirm($event)\" \naria-label=\"delete_advertising_aria_label\" translate \ntranslate-attr-aria-label=\"ADVERTISINGLIST.delete_advertising_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"advertisings-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_advertisings\" \nng-keydown=\"$event.keyCode === 13 && vm.searchAdvertisings()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewAdvertising($event)\" \naria-label=\"action_new_element\" has-permission=\"parameters_advertising_post_add\"><div class=\"span-btn-add\" \nlayout=\"row\" layout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th><md-checkbox ng-model=\"vm.modelCheckAll\" ng-if=\"vm.advertisings.length>0\" \nng-checked=\"(vm.selectedAdvertisings.length === vm.advertisings.length) && (vm.selectedAdvertisings.length > 0)\" \nmd-indeterminate=\"vm.selectedAdvertisings.length !== 0 && vm.selectedAdvertisings.length !== vm.advertisings.length\" \nng-click=\"vm.toogleSelection()\" aria-label=\"-\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ADVERTISINGLIST.image\">image\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ADVERTISINGLIST.title\">title</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ADVERTISINGLIST.linkUrl\">linkUrl\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"ADVERTISINGLIST.date_start\">date_start</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"ADVERTISINGLIST.date_end\">date_end</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"ADVERTISINGLIST.active\">active</span>\n</div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div>\n</div></div>");
$templateCache.put("app/main/media/podcast/add_edit_view/form.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-theme\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div><form name=\"empParametersPodcastForm\" method=\"post\" \nid=\"empParametersPodcastForm\" novalidate=\"novalidate\" \nng-submit=\"empParametersPodcastForm.$valid && vm.submitAddPodcastForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"PODCASTADD.form_title\">\nform_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\">\n</md-icon><span translate=\"PODCASTEDIT.form_title\">form_title</span></div><input type=\"hidden\" \nid=\"empParametersPodcastForm_logo\" name=\"empParametersPodcastForm[logo]\" \nng-model=\"vm.empParametersPodcastForm.vignette\" aria-invalid=\"false\"><div \nng-if=\"vm.urlVignette==\'\' && vm.podcast.vignette==null\" layout=\"row\" class=\"s18\"><img \nsrc=\"data:image/jpeg;base64,/9j/4QAYRXhpZgAASUkqAAgAAAAAAAAAAAAAAP/sABFEdWNreQABAAQAAABQAAD/4QMqaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLwA8P3hwYWNrZXQgYmVnaW49Iu+7vyIgaWQ9Ilc1TTBNcENlaGlIenJlU3pOVGN6a2M5ZCI/PiA8eDp4bXBtZXRhIHhtbG5zOng9ImFkb2JlOm5zOm1ldGEvIiB4OnhtcHRrPSJBZG9iZSBYTVAgQ29yZSA1LjUtYzAxNCA3OS4xNTE0ODEsIDIwMTMvMDMvMTMtMTI6MDk6MTUgICAgICAgICI+IDxyZGY6UkRGIHhtbG5zOnJkZj0iaHR0cDovL3d3dy53My5vcmcvMTk5OS8wMi8yMi1yZGYtc3ludGF4LW5zIyI+IDxyZGY6RGVzY3JpcHRpb24gcmRmOmFib3V0PSIiIHhtbG5zOnhtcD0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wLyIgeG1sbnM6eG1wTU09Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9tbS8iIHhtbG5zOnN0UmVmPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvc1R5cGUvUmVzb3VyY2VSZWYjIiB4bXA6Q3JlYXRvclRvb2w9IkFkb2JlIFBob3Rvc2hvcCBDQyAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6QzQ4NkE4NUVCRENBMTFFOTlDOEVCMzU4OTc3MThEN0IiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6QzQ4NkE4NUZCRENBMTFFOTlDOEVCMzU4OTc3MThEN0IiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpDNDg2QTg1Q0JEQ0ExMUU5OUM4RUIzNTg5NzcxOEQ3QiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpDNDg2QTg1REJEQ0ExMUU5OUM4RUIzNTg5NzcxOEQ3QiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/Pv/uACZBZG9iZQBkwAAAAAEDABUEAwYKDQAAwAIAARCeAAK9PAAGM/z/2wCEAAICAgICAgICAgIDAgICAwQDAgIDBAUEBAQEBAUGBQUFBQUFBgYHBwgHBwYJCQoKCQkMDAwMDAwMDAwMDAwMDAwBAwMDBQQFCQYGCQ0LCQsNDw4ODg4PDwwMDAwMDw8MDAwMDAwPDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDAwMDP/CABEIBDgHgAMBEQACEQEDEQH/xAERAAEBAQEAAgMBAAAAAAAAAAABAAIDBwgEBgkFAQEBAQADAQEAAAAAAAAAAAAAAQIEBQYDBxAAAQIEBQIFAwQCAgICAwAAAAERECAxAjBBAwQFEgZAIRMUB1BwMmAiFhcVNYA2oMCQM7AjJREAAAQFAQMFCA0ICAUEAgMAAAERAhAgYQMEITBxBUAxQVESgZGhscEiMhNQQlJiksLSI5PTFDQ10XKCM0OjJBWislNjc4Ozw2BUdJR18ESEJeEGcOLjEgAABgIDAAEFAQEBAAAAAAAAIAERITEwQBBgcFCQ0GECEkGAIhMAAgICAgIBBAICAwEBAQAAAAERITFBUWEQcYEgkaGxMMFA0fDh8VBgcP/aAAwDAQACEQMRAAAB8Wez/P8AQruyhVNmVTaEqQ1Q1mUSXBGFozRGTKhJlRMrVkJcgBmKiMrWEpRAsCChHOazLGQlySxqEbBQ0gRFYSlEsSZUKWIJdWAgsREBQ20lbQ2EsukVSAVEysRkpWyIFUJRVKqUFBUiIbCUXSEoSopKiaIVkAMrAEBLVQEsREUVRCpEQgsJEUqQiaIQMqQAEtZKRW0jVLCQCtGqAGJUISpIYlbGVRplSVRVEoRIFiAigqAwUfYO082xqk1EujSKwiJSwLpAqJQkFyBGAMrmWsDKkZIyBhYgMS1hLGSMqEgsEtYLRGVTEpLkjMuazLCgrRGrIbCUJZKWsloqIFUliIiWQlRqKGqFYgKUqICIiCVSUKmIqzKo0SwKokCoQ1CUNMNtERLkgAglqiQlQJQUFRAQKWIiKWpIjUSogJEZMywERLRVQ1RFaqREIxFbJSpEKqSowiQiqlGlqSiIQMqBFQAGYj+/2nmlWE0aVTQqmiEoiVEkFKTMsmFjIGZazEpQC5gMqEgoZirJLGYrCBRSiUSCKqWMrpMqgZlAMS5MTQC5iEUabFYiklqogVSWICVRBUCGJWylqgCK0ihqIiCJaoTMIkBEsQgICCogMaJawlSAgMqkBBLEVMBVRVRAqUS1USyIKiQkMIK2ZWMywBDVLWUQlK2xRW0QkNUEKwjVCRohllUlTRCUAkQABAuQUTMFEf2+083s0aNiMujSIguiFUI0QEokJkFAAyuYrMTVZmUAAAqzKAQRlaswLEgoAmFoaogJckCiCqZljKkZlyuTMuVihqEbGNVIkskSwEqIRENUsVQQqCmVjSZWhoWRIIqpWoiioiWIlQIRAYapayWAoCWICICWFJSIlklSAlSKStoFSSWhpKIFkllkFIhqKG0kll0lFbQCIKiUSyKqUtSKyaiqljQCKwlGSXIACChkDMBmv7vaea0Mu00aXaS6KNKkaCGpWRtIaIiMqEQGAVTnNSFZlkysFEZUIzEolQuZYkJSoFpK3IxkQJQCMwLGSBYUJSpcwKRiaAAYFbKXdmqo1ZERLBDTFUJGVISASqlgIhBSNWUVoJBKgqkAqCksBoiJYoBoipgIgWBaQtRIigFYklSJYoBJYQEiCWSWKiBdAUQrJLQktVCICJLEMZVRJUQl0ksqmgVIhgoMytnOWTIAuUDIRm3+v2nmuomo6GzQmjS6CNCKgw1BKiiZtzKCRkDKiALmAqICUCqMqBAoRABUSwEBlaAaIlgogBYICKiBQYqJUyRLRlQIFypEoJpEa0jUJQK1EMBAsKC0VICgsaBYBlrCVAhAQtYiAhIilrEjMqsgSwCBEErURQkVpKzNbKkUCqSxEURAqNmZQ0CxFEqiDVDRDTAaCqWFVAolSFBdEUNUqQCsAERmM0mFjKZjILgEyv8AW7TzXRNLs6Iy9BNGjSsaBY2SSwiZl1WSlkgUMkRzUQlytZBKEBAQKBEChVRUQKCBQAoSgEEtYShARLIKBLEokSxCQSyShLmMrmUIhE1UaRESspayUhKiIlSIgWCVsoFQESqMy6CqIUFSEgEFIhJYgIgFYgiVSJYbCUGVAhBVBUCiBWqGwCWVISKJUlUFiKEiWAiiEgFY0UVUNUtVKVQABQUQGQrK4gTJlRMr/V7TzOq3LtNS7NmjRoTa6RKWNAqkqCyKkJURlYDNZiAyCgkZFcykasyJlUAKBYiAlIqAliALaAgCWABIFgKUqiqgWAYFSICWEzECxkzLBKEarSS6TVkaEysIES1MkpLWIKQkVJQEsAigpGqFUoaFCiVKiBZIiVSUKGoJZVJYiiIhWASIIlrCGiWWJJaGqJZYSiqKEyVMS5iqhqKISXQAqSyUohKVAZiojJGDNEYMgZMn9PtPNbNV0jVal6JpdRo2RpUYRslhIJUhIlUFEyuVDMZGiBZJUDMrZApLJKgQFEVtBRKoLEAS1UZVACiogVQUlqIqlJVIqpQgFYoBoilKJdWRQLGVgCUMwrCI2JqlESBVCVsFhIpSlCBUqilkiWISElCiqCWAiEgWASECWhWSWIQiJYUFBCKgpaiJVJYUpaqEy0oSyVUsAKgZEaQiiNKpARKKRLJlQCgrIRHNc2ZjJkyBg/q9p5xTVmzUbFeho0ajRoSVhsliJVKGqVIBUQXJkAACKWCmUEFkpYaCiVsJYFSCEgUECBYIglBqgtpBUFCKKiWqholCIQliBVJSWsgCVIiBVMytZlCMywCS6RrSIlSRSthLWQStUNBRVSpERS1iBLLSRULRAarJSqCwiRBLLIqGjMQ2kBRVmXVgQQKkArJFKCVEtaRQVRKWC0QEREMrYlLCZIAmoEysRkTAGTARkzWJcpgyf2Oz85Lq5TdmxVjoaNGjUaql0kSxIKiRKxERlYKxJKUQAqktEKhEQS6oNJmaiIRKUqjVhLKLIkZWgFZJQiApaooFgiBUqJYUjKstZmWWSWKKoJYqoFIFSKwliIglyqABGq0RuxGkkFYSoiWFAVhAiEFoaAliqgEqJVJYhIQmoSQWUiIgAiMxqswUStURAS0BKCFUEFpEpYSwJKEqiRopVAllAQgUIgWMgZgM1kwZjFYgMH9nsvOqqNmrNGkV2aNpLs0UqasogVAlUTMurJYIAXIWEoVUFUurCVIiKWISJZSESJdEENQSqCpmVoRliBaqJZJSKiFQQAJUUy0pAqZlQASJQgJYIlIqigWEjJBNNgrJlVBSWEyImrE1SNlLqyliIhICElCJZJZJSIQWRWECWiVQWICJSBJYyRmWsBCJQiAFUzLBbQWkUBAFECoCNUMJUhKEALGYFUFgIyAGDBmMVmM1iM1/d7HzwaJKt2aRNWUvQRXRo1IWqUsFJRAu0iAlyRlQAIQCVsolBIlSKGoVohIpWqJdAkqZl1RAK6QUiWIgJUzLqwIzLVRAsRQLDRLJEpEsgtVAaAlCCWCGhQQKWCGgilCCBUCWSUI0ibrViqiQkoIgIEILQVQ0Sw1RChK0LRLEAEuUpYySChAZWiIyIEoRmWQUUqgIKzCBKQiQmgjQVQACgLLSRLkqDEZAyYMGTEZMV9g7Hz8UjSRqzdgasTZoo0ukJdWSgxAI1S6sJQiojIECwBLFYkCxQgaMqw1Q1DLCJS6szNI2EsRoAlVklQKUqiFRBdJlohFMrCChRWkQCJlSKkzEsEVCwlEBFLVmWGyzRQqilElBIystCgsQgUQ0mhrSbpIJWyVQUGStoqigVISBYYyoasJZcoLJmUJMqgEZUIgAQMqgZCWAqIjM1JWyS0kqIiUSyQAZakgUhrMoQGTKZXBkxGawYKPsXY+fgNFSiasRshNXOhWhVRJVJUCVSitoqoCojK1mZUFkiJQJd2ZlbIilQla0gtKpCsJCkrApLqxIJWiJYiEytLEAKpBK1GZYhrMqBEZiVTKpEZVM5tYhLEQKgUrYRKAoJAS5hCVsJWiBYQCWNUERSqRojVaNWIpK2Zl1QQSxRLqyUIIqQMqBAQBKAAStgoQBEogChQUxlYgBVBYilhESEIazApRGZpuZSGsy1kYjNBiMmFyYBMrk+y9h0AaSWrSAokNaSs0NlGqoRtkYiWERBSEKIAVAgCVsiBYFZBYodEoJWkohqiGiVIiWJWSWEilkliIlCEypCRLkVkhlzRCskCkBGViJZJYQUghIaglCCUIiWMwWsktVEoRQLVQFK2SgLQpLQ0S1JIjSKaNWRUiEpK2RLISylEBABkJYCICCUKiIjIStmSKXNrCZpjM1WJJLKxFDUUQAZWMxLWEtRJm6YymTJhRMS5rJkAPs3P6CqVkqbJSNWQkmiNXNSJCiRKiIStIpmabkWiUsJUKIgVTMrUAhCsAkKgpLQ0CEoaQUitRNWUsC0VUsREQSoStksmZUliUIgMy6QWACCWIyukFoFbGMqgIBNSATQKCthLEEVtAsSSwSxFRCBKCUsREpFYSwgNZjStmhs0asSIlIFrCUAgJZCBQCBaQtSgAiAlCBYolCJKVoiVEBICMyhJloSMiASlZgrKZlyZMqAZAD7Rz+giUTRBSRGkqSFGlJZNVJCJIisJLAIStgES1kpEtZQLEC0JFVEREqAkQLRLJFSEqisRCASpLCRKFASyUtUEoJFKWSgRAoQEqRFKIrBKCQSwEokASoLEAgsURARKBLECwkSgxGVUQBYCgWSWIhohXSNmqhSWIDJQEVSyUZWIIitIgVBAGkiBSRWqIlYiiICCIzWVjMRkCTK5UXIJGTKkmVACqPtPP6EAihGoqUiECFNVEKNaQEaUjQEqktFVLWQFLBUUCwCRFFRK0hKpFRLBK2RLRUmSCWESEoraJYhQWFSIiJQSIJYCBYIFUFkFiUKJZIloliICVTKkQKREVESwgEsQLEBBCoRCCwxlWqMiChFAoAgJmJZYkiGkk1TYxEJlUBsJQlkFhCAlFkiWKAiWIlkJUklAIAMyhkEDC0ubIjKiC5UADJQAfaef0LASyNENIENENQpoyasoaaZIqjViQorWRQKrWUBShWUsVZzWyWKUpiGooiIlhsJYlAEzKgIgaApWgSlBIlUlEVoFhqgJQigIzK2EoSxUQgtEsktFUUoQBFaRGVhQVMkUtREpFVAtFQUVsURKgRBLEZlrJQCiBWiMythLAsiEtUZKKk1YrpGxEiIzK2RmUNWE1AhLK0JSxEskoErVEAAEAVmM0QW5QlDJAChSFE0GRszLJ9q53RZUEkaJWylqoE1USyKNC6QFG1SlbGxIhpSAlSSIJQaJZKpaFBYlhAYq0ZliFBYgWQWiKiVISEFRIJVBZVIlUFIVqJFYJQaICpMythKEtFRLEiUoSoEEsFEoQQLVRAqhKFVGVSAoCWsJYhBYYFiBQUzLDWYCWIAUiIlgIpYyMBGVkSWAa0ashNJFVGTQKEqgsUBEsBLESEShkjJmCswVlSIyBUQApFQgoKiEfaOd0dFVEVImRIiEirSQCBqwXSNUNkJDZEICVRBKDYqREQ1mVspZJdILEUVRSgkZVAglbCVGwlRJUCiplQIiWJaSWspQUy0CQQ0DAuRqlkliiqKUIoliMy1UAKpmUtUloKJYBgMqmRAIliIhUSUlhogICWCIysRGRlAEgCUVAiCIqoiXJEBSyRWqRpWxsUmlIysEUVslaRLEhKARmMhWQIzKWEsZIFCQgtklIKpA+0c3pYbARgKooFhsSA1YqEmiURGgUSGxWSEqSAQhoioVAUlTIkAkEurAQIpQSMqSqK1iEqjRLGglbJYpYgEBAVFUjMqgsQFLAKiarMtVAsiEqRAsJAsZgliqiolqoFBQUiUCAliATIrSCoESwRLkTIgKhGYlCEzEVEssQKJS1lLARAsUASVpEFpAQgJUmkbUk1RBbFBKFShBaSZUAyAAECyBGVjJEskBAsn2jmdLEREQoKkBpCqGoFhSGkBRKoRpkBqKDRiIiIiIlkFUlhKiGyUiGqAQGiIliIISJY0ArJS1JEEsioJlYoqoFgEBUKCqJYipjIksEKxERULRkYiMrBLEQCsmVpRJQiCUIiWJCaklgBUzCAESyBSgDQplWxRlYiATEqQEBEJlZaBIytILARAQKxDZWxqkiRlqzJKWZUgojIARQERlYBoiMqpklj7TzOkgETJCBEqiAgasiBVJZASGohRKoSISIKoQpiKiGqCpaGyJZJZIlUxLqpCWBWyiqCXVlKCJESkJLEREBEpDUEtVAQhLWSwREoNEQqFERAqRKBCVUCgpKQWoRUZtQQSwEES1ERLJLBEoILIBLUREsBBAsQCCkBESkVBS1EJkTKwQ0RlYiCKsw1QEoRBLAQlVGrAagADJABFKIWsACBEBAon2rmdKCZlUqQJVASIFUhsVEliSlarGMrqyISpCKlAYLdICSggICACIQ0RUmZUBslIqoqiKIqRAiVQlahgUIiBVAJWpZCWIiAYFaCJYkFoQWgJVMroglrApWozLDZSwEpCZVSXISyCySxECxTQkSSwRKEQLBEtYRGVgiUVQCWqiBYAEgCWGsyyZWIzLElLVQUSyVsEBKJRm3QQVRAZJYhsBSFQLKK0KIiIgJRI+1czpMqkREAStkQkQ0FEIENUVQkkobsBAQECIhqCWNJVBEqZECNVSZVIiqgWKooiAQISohpCIQqlTK6sIlEVIqCKUEgBdJAShFLAQkCsFUVUoUNBRWsBUSwKoLSNpEBKEZl1YEEsREpAoJBFagCUoSgQLJlUCKUIiIJaiGsyxEECtCDQlKJGZUgtpJQCJSIqJKUKhVMqRVQSlQAgpCVaRKoaoqIQEABftfN6MlbKXIwUwVLpMkIkVEQLpKqKqKoUFUaiISICIiVJIFUFhASMytkJlYQIhCA0ZJYgGiIiGoSKKoiIiWAiCJaylCIjKpRUgRBKgRES5iGiFcmkJa2SWiBYgWQaUILVKXJCQLERBAqQLJSgEK5KIABQgCWIFiiogVSWCWSKqAlysERAShAUSwJAsCkREENFERACkVEtYS1lLmIazDUUNRqyEhMn2vm9JmVQVABiqGiKqGgRTMurIlgIQRIlrNAJEVEQCKyShpAFhMiShEURAasFIaIiBYlkzLqygVoFEFkaiWCGoiCIlEQUEgCWIqiIilCqKBYoazEIUKwSxDRENpCAEoRARmVIiIFoayMQFbKRFAREZlaDMBEoUZVUSWAoCWIgjVBRVmUIorQIiIFiAoCakFgioEIiAqpcxUAUAKpGVoqoaAhIiGo+283oykIiIgWIakJdWRDREsgqSAksNkQ1RUDDRFTBTEREVQRLEBLIS1MVQQgJlQiKXNUJFRLJDUIQ0CQEIS1REBFFaREQCRVQVFFbRACqSkVUVUCg1RFKVCEoREQLAIRKEQCALRUgUsksArQUERmWMkASxECkNRRlZZIglQIIiWAglqpK0ECiMyy1kuYaoAWIpBYCtggIEFigIiAliKIiqgPt/P6MIiAQiWSWqkaiWSBZNVFAJVERGislBQVIoyNJCRIKgRRAoUVEtUUJVAUAKEMZWIlBSWRoEQIazKikZVAglaIqiKICGiUErCUVJCWKiKqVoklqIiEIFqJZJWylqIiIFkGqKylBMiZlqorpkCqgETKwEZlgICWAoiJSAQWAgGK1kKJWqAJagI1RFKWUsCyAKgsRQFRLJSgVQKVBAREBJKQgSxARFH27n9FKIgsUBDQJERDURERCBRUkRWMVQkRESyILJCBS1BBKgRASySyJmWqhrMsBAEsQ0DEVErZKDFQRCgsRFBbFFRERLIKkkoQgQLEEVRRW0VEVQhBK0EQSxEBKERQLEkoRECxQ1mWIiqlgIzFURmVBVAiWgWSqlghWSolBKBaiCK0RXMJEsgsUBAtYSxLJKRASiIAoEVCwRAUFmlBkLaJBa2Sj7ZzujlkglqiIjMurEispalJRFRFZAVbEzDWkFSIiIgEhAhATJLBFRLDRENUBEQLGZYiogJVBaIqSAiIFUQJQhgolgpKAiWQVAiITIrJmVqCECqWirMJCBAsUCyQKmVhSCWqCJYKYAIpa2QiJYFUFiAjMNSgQgQqSgo0SxAMVEqREChRUQLpMqgURVmBYCKKiVSBoiqACgJcgIFFQtEFEJFVEQAfbeb0cQEUtUQCZNVJLESaICtUiNGUViSElaEYCWRWStkSAQCWK2QlglDVhLJKo1kloAMzSkQKEsksQ2EsiFtARStgsAgSgoSwERLJEslaFFVKCgqASwoFVEuTVEIEooktEIVRAsBBCBAqAEIEsS0VRRkiJYAWIJGoIpW0gVKqIhWBFYiiICBSUFBYiACiMkQE1AktAVpFRAQARQULFEKiErQQgUB9t5/RZligtUJWyCWGyASEiEyJVCZNENlCVQkREksREREQKoKQgShDRAJDWYSMyyiSwEIBKmRKqBYbCWICIhBYiAoFiIgEgIaytDQMALBK2EsjQtBSUQCZUEClqijK6QEAWgWSUIgJVCWqIpYiABBYgCVAiGqUiqAViGAQlhsQUiIiApQSBQgCKgorSEysCSkRAQGVBMw0SkNkShEskAxmhftvN6LK0NARqiKoQIBFGooqlUgIiNVRVCksksRAJCQCSIWkSyC5lUiILaNWCkIEQKRUSkNRECyUShUS1MgsQgVUQKoLARS5EiqiIqTCsjQtARLkoaoqiBaIoqrRKUhoKIGqqSWICCKiJYCJZIpS1JIlCiIJqsAhIGpIlUAlaJZJWmAhJZIFiKIClbKjNqiApSwgWMw1QXVMixAZVgogIFiTMtUURUQhbAURH2vndEgRlWCkglBJFSqNWAgqkA1Q1RWUVukTI0RLIqERqwiqVSWQKUBYIqYqiEyrIWqRmWBQiCVsQlBStzCuRCKpZIQlrCWIbQIhAAVAQEiICIgUhrMqAkktARFaQgShEEsA2EspClbBFRKCSZWVWSWBFQoqIliSWCGsythKgVUDUiQSxCSyICZl1YS1QCRQWkREQShVIQEsUFEsoVSZzWzKgRURAsKBLZGiBRm1is+2c7o5KBUAWIyaIgEiIQpSWFBYUQI1WTUViuZQ1YQGgWKzQCQKRURECkNNUAgREZlQqlCIBAhCWKgJYAl1ZAJEChpBQglgEiAlhQtogIiAFQiWIDSQNSRSgCCwEqgUsCkNkoREZlF1YQCBLCAgoUIAKggC0RVQKpAsRQLCJERECsgoNQQlRKEIBBSEA1SyAKSyFSkQASlEksEFRLFJAsQER9s53RNUBARLAISqBVGiARTKxpK0JESIiBVJQijIkC6shAiIzLEQEqRWEukAWIzK0RAqBVpCUIgWKIAWECEBIqCXMIBK2EqFUIEVAhKEIEpJLAqksRERKWWQqoSiRFLANtARGYqigqWgEFQVAogsJpsCiWICIlBgFBZaKoSiWSUIliASQJWQaiAgACCIqogFYARXJKLAQFBQUSChRFVES1ZPt/P6ClgECBUIqIaJZNUCQCQpAtTIgtYkAgoMBVQS1REJEBEoUCxmGoiFJYBMy1UVZlhAbCWIiBaKiIqYyurCWqIUlCMyxEBEslK2ZWKBWzMqRBK2CxEEqAkCoRUREShLEURECwEQEoRQVRLJLAJKISwVREsQCErZKFESxAJDEoREBEREsktBVBbSSgAQEQSqS1lKAmZrVmViJaSrMVpFYS0VSCyCxAfcuf0EQEUoVQS1hLCA1Q2RERKCkJANIEILRkzKgIEoJChaSyCyMoZFZGiK1QUkbaAiXMBLENUACQLBDQUoNlLWJEQS1QSyRmV0oiCWohqAF0mZYiAZSlIJWiWSUWIiUSGBQSWKQakQlKiIDMsRVRAqQAsUBEVUBKplUiCWqiJZBUoaiKUIiGiABIlIagCWBBQCgKmCiVQWEAIlkCUSagSKCwlraQIFCPunYefCEBAjMuqIhoIoipARAiIbCWGyWgBWzMsCkshLVmVJFckCqQShLJLEAklVDbmEzEsVECqSgKoCASw0SyVRKCkJEoIAUsksBGZWylBoGKsyxERBK2E02RRW0kpFRLUStSUoIKhERAChQ0BFUsUBEtREEVCkIAqRAJBKpWhEUCsQ1QDUoURARFLWUsVhLARlQkysUVRRlWpCK2klgUhqQUSWgpAEZosAiAj7v2PnwQIoqoAXSBW0VRAMA1EKCogMVRShIKVGZYzKApERKCA0ZCghayC1kMQWx/Z+f0+6/DkfMzr+H9Pn9H+/G+ORAsgqYVisoqFSIiIBIiEFUlAICiUECqlghrIkRAS0RLAIFKCAhLWEtVLCAiBLAASwERkQWKICqlBACBRGUIQWIQJZJSIiVJIJWiG2gSJYiAoqQBUzKIAAAsRAQkES1UlbQEQAkoQRVEsZJaQJfvPZecJYiIQAlgEiASIiISJYk0pI2xFFRGGiyMy5CXMtRKplaxlgCWGwlgWSWFNV7Adb2vtD1HdeUOJzNLEfzdY8Fdh1vqX3PR/QuRxsyyVtBLJLWSyUrZAqUlbJWwRLpIiJclLWSkREBK2EsAhVERTVVEEJm1gpjKqUQLEsJERAUtQCyCkZEiBaIBMrJKEAKoArEoQkQEQCQTUIFCRVSxAJARERBGVbAyuVoAKiIBIIiKmAqBgBZICAFVyjADUhAffez86FAoIAIKpldAKZXQEQiBCS0JEqkqkAW5MmTGaLVmUKWMiREuYQK1klrCP7nz+vvr570/mXg9hERERHx7PTnu+g9VO26YICISIaBIoiqGJayViIlkiUAQWiIjMrUAkArBFVBK0ECqUK5IilKYqCVQliIJagozaoRKAQLILQVBLAJkzLWRKQgqgsREErUSTVJEsRRVQ1kpZBUCEgioIyC5iCsxECxEQRUwFUS0kA1mBYJZBYQApRST772nnMSpACqRGVQEiASIiISIlZJWxViE0YVsxLmsGQlxLmVUQWECIzLqwlgED+3j6fo15j1vkHjcuIiIiIiPUnuOk9PO66CUpSVSEgESFYBhtobCWEQqlgIlogIgXVmZYiAVoCIhMyxDRDRLEBKCRAUsSiRLmCoIqJYCICUJCUWsoAXKyZAVzERK2UsBERKDERFLVEQFLVRWUoQgRGQXIBAChILJLEQoS1EVUaM1SgCBQLBECxApJ987TzmZQF0mJWhVMqwFTAC6soKYqoK0hLVRuxWE0IxAZXNc5cEYlFIlDQEZlbKUsliioj9BPN+q85cDsoiIiIiIgPQH0XmPA3Y9ZENlK1pJWESqlhSVUNBERLIkuRIQIJUCIiWCKoTM0pECxS1SS0VRFKGYVbCJYqIySyZUAoAolhAAVQlqCMqRkyBmWJLVzmqAkoEVsUSTTZRVRKQ1AtFZFLJLAREBkzLkKjMCtERBERDUEVAlLJlYiCBQpRIJZVMr987PzmSCaETKy5KIyqQEKCoCALpAa0iVibXSaVhogMnMzWJrMZliJRJYiUCIhBfNXA7D9DPN+riIiIiIiIj6p9vh+XXq/HcN4pdWJqNVStaiqiVEhCFYbCVohAQWEiIFiiJWylBqiWQVgKWIisJqpTM02USkC6syUoBGVAAAlEirMsBKEkpFZS5ojILkyYUQUSWiohMqxVFEFtFTECwoS1ENESyC6AiAjCgGQiAzLVSxIEsSRAsICkoJmWBSJApYFCPvnaecIypLklICUCMqgsAQgSyRWwpCasU1WrNp0NwgZtxGKwE1iBSVQWICCUNILAon6Cec9T5z6/s4iIiIiIiIj0A9H5fwP2PWaNGjYy6sVYSqhWI0kRKlFSpCCqKxERSw0FEpTENUBSoESkJVAoJZVQFNCVC0gZtzAuYqAAzDWZQiIIqlkFDJmXAWYlzWIyoBREALCRJLCE1EgsRAJFKERERABlaTNZBcxEsERW5iEoCIajMtYhAqBQLAUQBLV997PzeGgJcy1mZYy0RGZQytLkhCUErCVAjVkb1OjOtTpc9Bl2lUc1wBiXEqYlgWIFUzKgIEaP1g8d7n+pncRERERERER6w9r03pP3/ndG7NxqXVaFdJmXVjKkqkqksUqQkIKiksRoJYBEiA1RLES0QKpKJKlFbFILFRKEEpZmUMgZUADIGYiUITJLIEZWOcuTBk5mDKiCgQgRLAREJBK2UoJVmVCGgglUlqggMkBlZMShSgSxAQKpAIKpEoREEBCCkQLAffe083iakzNAS5WTKkoYzqrMuZSUBYAiIFUhrSNnXWems7s63PQ0KiZMLgzLlcy5lUiXKkNlKmSID+/8/r+ovkvaREfJl+VNREREfB1nkkR4Y5/X+gfo/L7s2al2aNCKsNlLqiVRVEJWiE0RCJStJmXSStZzdWIEqAkRSxESoQ0FLERAUoVRkzKAZMgZMqGQCAlCICIAUTLWTMczmZOZkEw1RVAURASySwkokrAsgqBERRVLISwURGQMmVoFIFoAWKICKkIqSkrYoKolCKAFIj792vmsTQpGVCCXK5lDE1mUlxLlcwrmUCWslJJWxNWKddZ6az11nrrHQ2IAuDnKGVJcy5jVgpDbmIgVSlKQIij5DXv3530/nTr+yiIj0/7nofUfuujzCVJqzdm43TGl2JohElo0AqlCurKWNEqiSstYxKpLCREsRLJRpQiUhCkoliIiAjMtRLkCsxKHMFwguQgAFgIBAFggtzHMwYORkyYMksBIDKEpDQqkISgo2hSxILFFVLWJmWogAAADObUS5CWCWsJSVslEiWRA1oZRVRLkTJQKhH3/ALXzWJZQytGVgMzWJcy4lzNc5cSkuVoFyJmWGqEbN3PTU66z11jvvHRnTWkjJk5riaIyoEsQREsQApDUEVRSye4HS997cdP3sREfnp6Py3hHn9cKkmrGtWajdbNQmlSElZK1hVIY1TLGhGqNEtBbpGWISEJayaUSiWJJZYoqQhK0ispYjMpUZCUAyZTC4MqJhYzGFklkFgIiMy1ZjmpZylwYMmDCyKkVAgQSoCRLSNBSiyRLVREkqAEEtQEFUFZglFzBKRKBLmqWQEqSSitUBAQlKoCIJfIPa+bwRmUEAUjDWJcy4muc1jNxLmXK5lglzLVEQpqtprWe+8ddZ7a+fW56GzK4lzZzazGZolEyqRBKEQLEEf28fX296XvYqo/o517B9b2vzJqIiPrf1+Pgjn9bysiPpPI4/q723TauVdG02NMuklRWRWhqlU0qaFWRXVjLCCpoClQERAViKWGylhIJYaBiolbCVTKwKAEuayEYMmTBlcmDMFEtZRVKQEQEYUXBiMGDBkyBLARCACRSyRLQ2CykqgsAkRAIKEEVERGSMFLiUlxLGVoTJEJWIgMOhASwQCpRFHkPtfNZMrAQBKGFJec1jOuWdc5rEuJoMyksEZWA0VKbs6az21jrvPfXz62dLNRloTmZXEouZcyxBLWEtVAqAFL9v+P2/UnyftIiIiIiIiIiPEHM4H5zen8pGrE0mhXVlGlRqglVUaZVNkujQqw1QrCQlKgJDRKkILpITMqQrBDUQLQ0RAZWBSTNC4gsxLzUTK4TMuazBRFVKAsksgQKGDMuDJzUTJKJAsIEBEtCAjYS0CtkpEoiShCQECpJApABkzLiUlxKShRULCgJDUiSSwmQlAWhqPIfaebzIWyEotZmWsxLiaxNc5eed85cZ1iXKkuZYDMsRld2Kbs66z11jvvPbXz7XOjRGF5AuZcy5UlBMStERAqmJYl+3/H7/qV5P2cRERERERERHiDmcH84/S+U1Y0jZo1YxCqQrGiFWNJpU2QrqEhBUSEpZK1gWEhASJYSKJUkiUJUIgAFyAAYMy5CucuEwuUysYlbIzBamYQIFlzJGLcxlOahBWZZEFiAQliKqFFQBBZKWqCNUQ1BLEgqJBDWVzGTC5jGdZlzAuZYQEipSGwl1ZAREEoAkeRO083mUsloAoXMFmJrnnWGuedc865TWc3C5lAlFICKGmzrZ01nprPffz7az1ueqRKWcpebRKRiUUiqUiAilAtIT7D8vr71dB6SIj+hnflvh83axER8DWfEvM4PFJY8ecni+m3ddDJqg1ZqyNWUNUuqJdSNtCK6ETRoSl1SUJEqIQlbFFTFUtEK0A12l42MSgkBEpCAKWEtGayEuEyuTFYl5wVkkFyUdV4FYSxAsksZXKZlymVyVEBEsBERFESxIKhLrWSWlispQiElBIklREAlwFc5cnPGsrnNDMsRERqyEiSGoIqoFFkgXyL2fmqsy1kUpWYjnaRymsZ1ym+ebia5y5msxlSUIJYlU1ZvWd2dtY77x11jrc7VIDFc5czWJSBYBBcxKBEsBCBStkVe6XReh9p+p7mIiPQX0PmfX7sOsysEVrJVobIbNWUtZKpohVEpdCaNWMqIqw0nsj1Xb+wHWdp1WID4Vz9b+vx8V83heBOx63+bvEEsJHz869gut7Tzn1/Y+ROLyv7GPpws+mffj+E+f1/rF23UfxPpiiAo9r+o7ryxwuZVEC8GfqH3+Ph/mcLwbz+B8azJiMLkwpZiXyxxOV7Idb2fl7icv7f8ft2X+Bv5+KeXxfWjsut8E83gg0RLGZZPY3r+w9kuu7HaxHi/k8b0k7jqJAilqI+Svsp1/YexnX8/ydx+R/Zxv4Vz485Hw9e+dwfVfsuu/maxL97+P293un7f+lnUUsRJLER4T5nE9QO06xRWNARkxWI551zzrMuZcxLmVSqEbErGKoiBYIgJaSXyL2nmihcwkSZtjmZXnnXPOubXLGuc3iXEpKBEouYQEbOlnTWe2sdd47ax1s6CkuTmZMzWJcyyhkVIFICJYCIlghqj3p6H0fsj1nbRER6M97531p7TqYJZKhVEhKxErEaUiXSS6FWN2MS6IVUj5Odfqp4/2vy5qIiIiPrn1+PoF6PzXjzlcQlbCXzFwuf7t9B6D7P8vtERER9b+vx/P30fmvofI4+kyv2j4/b9OvK+tiIiIiPpX3+Hob3/AJ/xvyeLlecZM2/3fnv3l6LvfO/B58REREev3P6/0E73ovjWCoEn3n4cj9RvM+l7rEQH5Beq8r/P1mWQUj7Tj6fov0HfeUONyYiIiPo/2+P5peh8/wDVfr8/erpe49pet7KIiIiIiPCnL4n5ud/0SSaqlgA5nNcS883OdZlzEoRCQ2RorA0ALJEpAErZHkXs/OFgCqCqC4MmFxLzzvnm8s75zWJcTWVIJYDEqQ2J0ud6nfWO28dtY6WdEVbMy8jK4XOaLmUKUoiWOudeceB2P1H7fHxnyeHEfZ/l9/0S856mgGvn419z+PIiIiOafRORx+aRHjDlcT0T7/ztI295fOXA7D6n9/h405PEbEqUhqGGmGmXSaVphIVk8i8XmfpL5b1sRERERH0Xkcb80/VeShPYHrO093+g9D1WIiIiI+kffj/mx6jyvC5jzhwOw99fPekiIiIiI/hb+f5o+n8v9X+vzyZk+z/P7fo35v0n3X4/eIiIiIj1R7TqvSbuemiWJPf/AKHvvYjgdhEREflt6TzXjrkfAlBrpL+m3nfQ+VeNyYiIiI5p+YvovP8Ai7k8b9M/Peg8ucXlRERERER6idp1npZ23VNjCQqGDC4MS886xm5lAlIaBErEakhAiCUKKgiPI/aeaxKVRUkZXMYrMuF451ib551zl551mXKkpAoZlQI1ZqztrPXeO2sdtY7az0KIyuKxLzmiBcy5lQBQj3p8/wCl9j+s7bmn50+l8r4e5nBD7h8fv+pnlPZREREREREREeHuZwfzh9J5aI97uh9F7I9b2vNPzo9J5bw7zeFpKxGoUaoaZU0as1LEqipHsZ1na+8PQejiPpP34/rT2vUfLzrzv1/Y+SuLzIiPzC9Z5D6l9vj5O4nL/RTzPqfkSxH0n78f177LrPi6z7EdZ2n3zj8mIj0L9D5zwXz+vK9t+m7r2y6fuYj6R9+P4t5fE+Rm+WuJzPs/y+0RHq/2nVelXd9Jk7R+knmvTeTeNyojCeA+fwfEXL4f9rH09mut7L7R8vrEeunYdf6A970MRL5J4/I/T3zXpNrEREfnV33Q+BedwiIjz9wed+iXRd7Efy9Z9Fe56bxvyPh5O43I9yuq7X+VrPon3XS+HuVxZfY7gc/zVw+Xoj2N4HP+TLEeB+bwv4O8R/F3n1A7TrPr+/miNaMwLkyc4xNYmsZuZQoAVJIaRsQhrMaqMSwkZiGvI3aeawpArYLRWZlzWF5y8875y8s7550LzzcqSgSgS1hLHTWdHTWeusdt476x11ncaqjmuTC85czRGVazmhBKH6keT9n9x+PIj0/7jo/ULuejo+4fH7fqb5X2URERERERERHh/l8H83/SeXir9T/K+v8AuPx+8en3cdH6hdx0jSmqkaUhI1RLqzQywkqkvul0PoPZ3qu4iPWntOo9KO+8+H2v4/b9Q/J+xiI/Mr1XkfpfI4/6TeW9Z5D43KiPC3O4HoR6HzfxNZl/r43+m3lfWf3vn9Yj1i7TqfTLvehzm+/3nvR+buD2ER6d9z0nqn2/UUfNmv0N856TytxOZEfTvt8Py69T5XK+1PU9t7n9N3UR8G5/PL0Pn/C3M4TWMvtPz+v6N+d9F/J3j1X7PrPX3sOB8dISP0S8/wCg878LnRHiflcXyxxeVEej3cdP6odn1gqge9fS917Tdd2MR4I5nC/OXv8AoiVsiECpgE/u43+uXl/TpAfkX6jzP8XfzJWqKlKaUSBcmDJiXljWZoXMEsRDZFDZLWIxVApEAQ0EeR+z83mzLUhCtZmWrCYXnN8865y8865zWM6yuZRcwShBKDWk6azu57bz218+2s9dY6KxlQ51iXM1iWMygSxlSBf1K8n7P7h8fvHqB2/R+oHc9HHzc68ucTmkrUfPxr3O6bvvvHw5EREeFubwPVXtOo5WQn8PePGHK4cR+qXlvX/cPj949P8AuOk9P+46TSNiaslrGKk1ZEMurKVWRFf0a8x6vytw+bEekXfee9be16mjyTxuV+k3lvWxHxLn8pvX+M8ycLn/AKAec9NEfyN/P8wvVeS/ifT5kKte83Qeh9iOt7OI8A9h1vof6HzxJ+o/lPXfaPl9oj88vR+a8M8zhVEeduB2Hv8Aef8ARRHNPyL9f4/vL+p3lfV/Y/n9Yj0h7vpPVns+rgAAlyRAIHlni8r9MfOekSPFvJ43rT2PXe9HS91EeqvZdb6Mdx08kofoL0fd+xvB58RyT1I7PrfVPs+t+q/T5RFSEsVjHmri8v8ASfz/AH8R9K+vx/KT03m9WE0CJFDVDWTMBzmsS4lzLmXMEsStlLWJWJEREQRLBANR5H7TzXNoSASWTK4s5y5muc1jOuOdYl553lSXEuRjKgqQ2NdLnes9tY7bz21jtc6jQGTFc5rMuJojKksZlytGV/UzynsvuHx+8en/AHHR+n/b9IlRCBEvtn1Pc+5vTd7ERH5uej8v4g5nBJUqzCRV+qXlvXfcfj949Pu36T1A7npEU1VYhGqkajVUmrVBVGWXcfq94/2v9LO4j82vT+T8Y8vif3fn9PfPz3pPMfC58R4O5/Xfn96PzXvl570fsB13ZxHq72vUel3edDCJL7pdH3vs/wBV28R689l1nop3/nv7/wAvp+qXk/YRAflT6zyH8HeCwl8q8Xl/pF5r08R8ez8jPXeP818Lnfoh530cR/A38/yk9X5X4qFAQEZlClKoD9KPPeh8y8TmRH53d90O5f0O6LvYjwVzOF+cPfdEmZY9vus7P3W6ntoiI5p4a5fF9Wux6/175vBCKkUF9uOs7P3a6jtoj1953B/PHvejSJYQhpIAjK5My4lxm5azBKRAQjUNkICQEUtWYgEjyN2nm8ggsQKplcJlec1jOuU1zzrE1ymsSkoZlowstENib1nrrPXWO2s9946XPQQjJhcLmXnKTWQlAlypLmP1N8r7L7h8fvHp/wBv0fp92/SVfLzryzxeYS1Uf0s690um77718ORERHhLm8D1R7TqOVkR/F1jxnyeM2J+qnlvW/cPl949Pe36X0/7jpFNWJUmkFbGyVREqYiJfvPH5H6e+U9hER9V+3xo+yfL69liPj2fm36fynjblcX9U/I+x+xfP6xH55ek8x4X5vAliE9+vPek89df2MR6ldx0vqD3PS+ZuDz/ANDfOeliPqX2+P5a+q8kBKV586/sPf7z/ooj6T9/h+XPqPK+5fS917Y9V28R68dh13oD33QClEQBKBKCZXzXw+X+kfn/AEMR46+/H/Lb0fnPLPG5X6a+e9DEeP8A7fD8q/R+eklD+rjX6ddB3/kb4feIiIjwnyuJ+dHe9J/N1mEkq/QfpO79jeBzoj0v7fqfT/tOrhspYiVSWKAzWJcy5lxnXOWCUiqIhRqISIghUSUIAE8j9p5vmApAsQGDC85rnLjO+U1jOueblrEZlyrKARCNm7Oms9tY77x21jdzuXVEZMGWucuZczQEuTM1mBcy/qL5b2H3n4ciPUntem9Mu56Mj7Dj6frH5X2MRERERERERHgvm8D86+/82jZ+sPlvX/Zfn9Y9M+46T1I7bpWkbIRRpsRA0lSJUQnsD1vae+3nvSxERERHxbn0W7/zvr12XW/2/n9P1d8j7KIj8svV+Q+p/f40Im5f1P8AKev+y/L6xH57+i814S5/X+13Ud17j9L3cR4I5/X/AJ++h84GVT3W6TvPaXqu2iPXTset9DO+6D9C/Pei858HnxHp32/T+nnb9QDWYjMsEoEsB+nXnfR+VeNyYj8+u76T1x53A+7fH7fq75z0kR8Oz8ePT+YwSgp/Wxv3J6vtPaHgc/8ArZ1EREeovZdb6Rdt1UKJV+qvnPReQPj9oj84u/6HwZzeESogJENhNQAYlzLnNxLlSXMsBCRI0gI2SkRmGqBQQA8jdp5sBBYhTKhleZia5TXPOuc1nNxNYlzLlcyxmWCKkTprPXWeusdtY67z1uNy7szLkxWZrlNZlJcSkoEvNaXEv6Uea9V5Y4vNj1w7Dq/QnvfPRS/rV5b2H9vH0iIiIiIiIiPVLs+p9I+46OPkr+vXlPYdlj0U7voPWXsuq1TYkNiQ2I2IjUkRS1nuX0ff+13Ud1ERER8O58Hc/r/UPuej8f8AJ42V+7/DkfqJ5T10RH5Wes8f9W+vyKZdp5u4PYfoX5z0sR/I3j8rPWeQ+DrPvz570Xn/AK/soj087jpfUfuOmgr+j89/qZ5b1n9/5/SI/Pf0PnfA/O4H6U+a9N5X4vLiPT3t+n9Ou36cUgWBcwxhaBfPnC536KdF3sQHhPl8TknyZfNPF5cRH5Kej859S+nzlAhQt+dm+c+Jy/aPgc/zrxOWkR4s5HH/AC57/oYhs/pZ1+wXmfSdFiPyT9P5n639fmRqiSWGylIaFIqxLjNzLmUXEspAJJDUQkRWUsEBAsUVR5H7TzeCTKoCmWhMrgxNc5rnNcsaxLzmsTRAuJQJQYlrNVu56az11nvv59bnrrPRGXIGLcS5l551lQxnUc5SaxKR749D6P2Q6/tI8ccji/mB6TyoR+gPRei9huB2URERERERER+cnf8Am/B/M4Snkzj8r9PvOeoiPzb9D5nw7zOFJqtWQlZqqGxGlFBWokpf0U836nzNwefEervbdP4d5vAwfWvr8vH/ACON8DeSUA+y/L6/qz5L2MRH58+i834G5/XyJ/Wzv9LvMep+9cfkxHqn2/T+mPc9G1+oXlfWfd/hyIj88PReb8Ic/gEbX3w6Dv8A2M67s4j6H9+P+X/qPLcj9F/O+j81cLnRHiXlcT80fSebzLAf2cfT2q6vs/HHI4/gLm8LnFa5v6led9H5F+H3iIiIiIj8yu96Lw1yeNLJBLVBFXvx1Hbe0nA58R4c5PG/Mfvejklk8v8AH5P6edD3sR9X+nz/ACU9N5rVlFUNktEREZakxnWZcxmXKikskENQgKVISxBFUEsEBCeSO181zXIplUBMrkwYmua8sb5zWM3nNEuJRcy0ZWMlLqxs3Z01ntrHbee2vn1s2mpcmawuZeU0S5jE0RlcTWZcZovs91nb+8nSd/GU/KT0/kvqn1+UeWOJzP0v896dIiIiIiIiPH/34/5cej8tyqj2/wCr7f3N6nuo4p+SXqfI/wAreNWaRqsRGxGyNUpQ6URlVP1e8j7T+78/pEfmr6jyfi7lcSAFCgWKX9XfJ+v+xfP6xH077fD0F77z/jvlcXyfxeV7r9J3vknjcqI+tfX5fmF6nyf8beP6mN/rL5H2GliPz49D5v659fn9w+H39oOr7Xy1xOZEc0/OP0fm/D3N4VL7o9L3fth1XbREerHZ9X6kdr1X8u58y8Tme6nT9x95+P3jxVyeN+ZvoPPfEPZDgc/9Aul7uIiIiIiI/P8A7fqPWPncBX778fr76dT23lT4cj0T7XqvWnm8Hiv9CX9KOl7rzNxuTEenXY9d6T9p1igrZ7Xdfz/e7qe2iPBPM4f5w970TWrIDQEQlREZXOaRiaypkKAsUNkCpCA0RJEpAoMZNUR5G7XzWSBQBBRKuUuJrnNc5eedc86xNYXOaLmBSMyxUm7NWdNZ66x8jeO2sdLncSxmzK85rEuZcTRLkxnWJcrjNzL9x+PI/VLzHrkj067bpfTrtenUj3w6Xv8A2Z67tIiIiIiIjkn5s9/5zw9y+GHU/VHzfqfu/wAfvHhzl8L82PQeaTVmrGmlFGtWJGkBpICX7Z8ft+p/k/YxHGz8lvX+L+HrOJWiCUCXKx7qdL3ntf1XbxEREREfDufzr9J5nxHzOFHlvh839IfNeoiIiIiID0f7zovV3s+qaI8i8blfp35n0+1iIiIiI+gfb4flp6PzuY/VTzno/vHy+0R4M5XE+sfT5ygnnPicr7Pj6RHpr2XW+lvZ9Z9/+P2/U3oe9/oTUR9c3j6n9Pn93+X1/sZ1EfydZ/KLvuh+p7+bUVe//Udt7P8AB50R6ddp1nph2vVNiIWQkQgRBLkzLmazKRmUVQqlERqKWsoqIaJSIFkJYQPI/a+ayZWAhAyomF5zXOXnNc86xNc86xKS5UgUjKxENnWzprHTU+Rv59dY62bRCXNYMS85rM1mXMuZcy4lxLmaxKL+kvnfT+YeJzY/ib+f5X+l8p/A381fmy/ov0HpPMvE5sRERERGT0W7novVzsOslk9muv7P306bvYj0I7rofWzsesU1ZrTSVaZRsq0NMlZK1FAvnXgdj+g3nPTRHjzk8X8xfUeSazKBKBKKGZf62N/pn5v0/wB9+HIiIiIj+B9Pn6A+g854d5vB0C+0vU9v7s9J3sRERER9f+nz9GO86HwFz+vaglD3J6fufbzqO4iIiIiPDXL4n58d30f1nePaHrux98en7mI+q/T5/k16Dz3wrCWI/Rrpu59g+JzIj1s5vC/PTt+n+5fP6/qR0Xe/ZMbiIiIj+fc/nP3HUeB+XxUkhP1O6LvfKHw+8R+dXd9J6/c7haRpIrGKgSIIFxLS4lytAsBRWREaMkqQEEshKLASUrXkbtPNZXKCqSxGTC5OcuJrnNcs65zWZrEuZcy5iXMoAiNm7OusddZ7bx11jrZ1RA5riXEuZcTQvOUlxLmXM1zlJcS+cOF2H6L9B6SI9eed135+d756A+ZnXvL0/e+zHXdmkRERH8XWPRDuui9e+b14J9q+X2/Ubz3pv7uPpH1L6fH8qvS+W+NrOrNI1qzSa1NWKaIdKRoKWoiPYrre198fP+jiPUDuek9QO46SIzLLmMqmJSXJ9g+f193+l7v2F4HYdViI/k6x64dn1nqL2/S/Xvr85NAe3fT917idN3cRER8azxpyeL6+8/r/AFm7LrP5O8VQ1QEeznWdp7idP3H2X5/WIgPF/I43qd2fWeunP4HMJf0R6PvfYHhc2MHoH2/T+sfO4OZYCj3R63s/c3ruyiPUnn9f6Ldr1an275fX3j6ztPYbh8vusRHBPAXL4vpN2XWePPt8oiEq/WfoO++8fL6x9e3j8p/Ree/g7xqzVkKVUrZERBKGZSXEsYliJZIhoSlaoCJSUsJYozKklRL5H7XzeDJpMqgJlcAc5ec1zmuedc86yuM6zLzWXMUC5ERs3Z11nrrHbeO2sdbNigonNczXOXE1mUlxLiXE1jNyuJRc5v6Oef8AS+beJzoj0v7bpfUXtenhQXyzxeZ7U9Z2vm3ic7+3jcB9E+3H9e+d1/qn2XV/Xt/Ooj+pnX6U9B6Tyjx+VEfn73fQeunP67VmqWdWb1No2bsTVjSkQKBKCZl+1fH79DgfVfr8ZYgXMRlSUMS0uVU+wfP6eVuNy/snz38PU+m/b4eM+XxPj6yjZJK2bzftfy+zEoB8c+t7x8ewlBpJIQpgXrL5O43K+7fD7/Lzr69v5+MeRx/qX1+eZYyUvzca+w/P6kfzdT63rOZYCircfbvn9UyfUfp88EBH9zG/K/w+/wBnx9BPq30x4p+/w/iazEqkAlX9jN/u53pP4P1+f83WNWapGwjVSNEqVkEpWc0lIwsASo0EUiOlGZaoJckGbASDSkUvkftfNYMrAaSBQwYXC4zrnNcprGdYl5zWZcwShlcysNRqzVnbWOms9947ax1uegoLheZma5y4msy5lxLmXEpNc5cy5lJftvy+/wCoPnPU/wBrG4D0x7fpPUXtOoCIil+wY+nzM6/h7+f83WRVIl/u43+inQ+i8t8blxHgDm8D88e889UpvUbN2bs0m9Z3WrndmjImVjMZUmgJQzLJLJEouYlzKBGVJRaKxE1Y02aRpsSSVQlCMyikuYLTNhshqSVSCUWMxLhSJQJQzKS5lDEuZSWAoFhGwiWAiIgIlQIgISGyE1Y2arVmkbGkBIiSJZMrShmXMsAKokViREtJlZcwKRUQqSCxCeRu083gysksQmTCicprDXOa551zzcTXOazLmUCXJSgLpGzpZ11jrvPbWO2sdbnYgZMLymiXnNYlzLmXM1mOc1mXMpLmUrzdwud+inQek7rEevPP630a7jo/4H0+cASoERER5g4vM9+ek7/7n8vtEeO/vx/zM9B5r+TvEasU1Z01N2bud6zuzdmkV1YSlmFzLmXEpLlSUIolEVAUgUMyi0AStSNas0jTZpIq0QEZiUlxLGZRSASpTQEJGVJQFoDMoRLmXK5yypLjNgWMyxCSS1EIEZXSRLkSJJYiCNWQ02bsa1Y2NakiKoUiWAglyEoEoI2Q0pBK2QRlaXK5yKpRZKBqQNJ5F7TzmFkCWFJcgczC4zrlN85rEvPNxNZlxNUZXMCxCbs1rPS57az23jrrHa53DWQOa5lxNc5rMuZecuZczWZeeblSWBSPYngdl79dH6DssR/E38/VTs+q9Zew6z6p9fihKAR0PLnF5ntZ1na+f+F2GiI+i/b4fmt3/m/qv1+RK2asTVz01N2buemsddTadLJdBLisJiaxLiazGJogWIiIgUiUMy0BlU0lSRqtXLVYkJILQSigS4lzLAsgqKBqmSBoBJYypLIShGZrEuZQzmikoQEpEKVAhLAREJEQKoLESS6shs1W7JNaiKI1k0kqmV0mVClDEtErZRUpqyqGqAzm1ZlxLS5WCAIQWFPJHaeb5KEoQimVyZOa85rnNcs6551iaJcS4lFzLmWIhs1Zuzpc9t47ax21npc7NGTJzXE1iXGdYXMuZSXnNZjM1iXMsZliPOPD5/6AdF6H+xncRGU8dffj+NOTxvq30+Xxk/qzX3X4/fytxuV9k+f1iIjxDyuH+eHedB9e38qoRsTdnTWd3O9Z63PTU63O1ZdWEFvKOZzmuedYmsxmWCWtUBFBRYAlgISNWQ2I2RUxVCEEpVGZRcy5UgWEiCRpBZJcxKgQLJmakJrEZmgxmigShKRGrCVsAlULaC2klUiSWWQEiWRqTVVbsbNI0pGqCSVSUIIFglAEUa1Y2aqiIDEsZlzLiUlAlIiWJJfI3Z+bxQuTQpAsYCucuF453ia551zlxnWJcy5UlAlCFN6m067z11jvvHW56XOxI5mV5zWZeedYXOblSXnm5axLmXMoC0RH3H5ff3t6XvvNfD50REREREREfCufULtOp9Qu06jhYSxqwN2JqzdzvU6XPXWems9bOpuiVTBzl5VyzrlnXPOsTVGViRWRqIgWIIqoq0asjVkNkskpCBAEopKGZcqwGVQgEKYFiJBYiWiBZMy5lzLiXMsuYyqAStSRREFtERAQkRFVEVEqlSasbNWapRpFIbJZBUCCBQJWqGxGzVm7NDLAAJzXMuM3K5lJSUIIlkjyL2fnc2QEJLRWZXNnKXLXLOuOd4l551mXEuGsykpAoRqzVnSzprPXWO+8dLnrc9AEwc1xLiaxnXNaXMuJcS5msS4lzNKYlSJQU828Pn+2nV9t5l4nN2sRERER/H1j1v7DrfUns+p+n/T5RVQKo0o1qzVnTWelz01nrrPW57G1SMnM4rxzeOPpzzrE1koFRsSRK3MNUA0kNmkabNJEVpEZWiBWMKRAEtRLmWMwqGVgiEiUrUlVBTLkzEuZcy5lxKKQLEQEslLJVShEAkREVUCqSwDZqxGzVKas1UiQlZKJLRUQLBAsnSxrVzs3W41SEpZg5xzXEuJc51lcxQCuIaJfI/aebyZIF0SKyZUTnbzl5zXHOuWd5lxnWFxnWVIytGVSTWp0s66z21jtvHa46XOl0Bg5rmXE1zmiMTWJcTWc3EuVzKSgGZpRMqpBL9q+f283cPm+VOLy/LXG5fkT4cmI8EczgeO/vx/EHK4fhnl8P4NkREQKo0mrJN6m7npZ01nrvHWzqnRdCZOS8U4Y3yzvlnWM6wsIRqypEqghKkk0NmrGzQ1JAsZlFIgWTM0gRBLmWADMpLmUBYhJGqK1SIzLmUMy5lFzLmUgWBVBZII1QsQSSgkQ0RUhFUERqmxFNamhsU1VUKREILmIzLEQ1qzpc6rqnU2uhBcpg4xzXBzzczWZcmJSWARs8idl53JlZEhFZBQ5Wc5ec3xzrlNc86xNZzcriaAlIFhs1Z0uemp21jtvHW462aEjFYl5zWJcy85ojM1zlzNYlzLmUCWBSIBBYoBr2T67s/ffpe/iPxy9V45UiStBCBYhSGk1Zq53Zqt6z33jrcdbOypoyczgcc7443yzvnm5XMtDY0ijUJFUaSpNWaudI00wEmZrKikRRhrSAlVAS5iXEuZcrjNAliWRrSVRLAktGZcy5XMuc0XMCwEtFYgJkVIgEgI0VERERENKNas1ZVtKxEkrVIiWJMyiwRGrN6nTWep1jqdF6IqGDmnI4rzOMvPOuedEAjQaGzyB2HnsLkhqlRFAzLztwnOa4zfHOsy8s7zLzmiMSikCxuzVinbee2sdt47ax1Z0qCc2smJec1mXnNZzcrmXEuM6yuZSUMyggJEQKSyeynX9n779L38R+OfqvHRRGVbIJRYSSpErNWbs2m9TtvHXWOtz2NLtOa84428ca453yzvnnRAoIgasRshIqURs1W7nViKSyC5lypAotEFJRrUCiUMxjOsrjOsrnNFCJERs1UAqRkJcyi4lxmi5iWICUhSqIJYgIhIiIiIipSWrTLZulNaiRqzMurIiJQgiBSE3rO7OlnaXvZ2XsnQ0Eua4nx4+OvCOK4jMqQ0GrNJL9653Q4MqpLGjSRlZMHKuc1xm+Wdc875ZvPO6sZuJZcxLDZ0s1c9dZ7bz21jrcdLOiS5MmFxNYl5zXPNlzGJrM1iXEuZQJSJcqpDWZYgiPZPr+z9+Ol7+I/HL1Xj1IgVQCWIBIqRRrVm7N2dNY7bx11nqnQVDnZyzrjnXHO+Wd886IzKUkJGrFEqjVSI2JuzVmrIhszKS5UlyUoQ0pVpEBMy5XGdc5cS5ms5uVoipNWNSKKgBLmXMoYzcqTRGSWIFkhIFghogEiIbIJYhAqUaTVzqmzQ2KVaASspcrIhKAtDZ01Olz0PkHY+QdzqaUOMfGl4HA5HOsJkRqFIbFfuXL6QMiQiaApSzmvOzlNcc75TXLOsZ1iazGJrMosICmrOmp11jrrPXWOus9bll0mTK4XnNZlxLiazGWs5vOazGZrEoZlgla+8/D7+6HUd5/dxuKCqI+y/P6/fvjyIjw5yuFLAJGTxVyeJ6Ydt0/JIgVsSNWNmk6am7OusddZ66xs0BxmsS8c65Z3zzrnNEpFVEasqjSSxFZoabNI2bsRslggXMC5iUGqNWRuxoiolxm4l5zWM6xKSiiCo2aGyEhTK0uJcyhnOsKQShEuSIoaCIJYazCRClUpEVQxVCmrNWNasUa0lSREkCtEShmE1ZrU6p3rvHyT5VdY3LS5MnOuBxTgcqymQrSVak1TQn2vk9PgyqkJoYaAOa8ji1zl4Z3jOuedc5rMuJoIolrNGrndnTWeus9tY6az0udQguDJia5zWJojE1iUl5y5msSi5jMsEsfo70HpfNnD50RERERERERERH5+d30HrrzuuysNiQpGqbN2bueus9dY3qbsQMS8s75Z1nN5TeJSJQhARsihqEhs1TZpI3ZUpmWJcwKQW0NSapTVijWVJcZuJrGbiaxKSxiVGxGm5VkQWMqRmXObhojMoUoCxCgoSqRmVohqkiWKyWiBJUrEaU1Y1qxsU1UJERWMQKEEtWrOlz0O9fIj5EvZfkHWOhqzJzThXA5VyTFZIU3YjRGF+ycnpucFRGhGVsjJzXnZxmuOd85rjnfPOsS4mozBGlLFWzVnS56az11npc9dZ3c6jRkwuFxNYzcNZlzLiUlxLzmsykCkuQVP0M6H0fnzg9hERERERERERER+dneee8C83gVRRANI2as3Zq56am7ndm7FAxNYl5Z3jOsy4lFgIiNEksVMmV3YGrI1SjSgqjRGZQFSIhs1ZobIFzGJczWJrGaS5lAlQGzVjSKCwBKGZcTRBKS5UiUSIlAISAQWSEBA0AFEVsNiaR1NI2aqNWJElakgKyC0oNmmd10l6neX5Z82vkp8g2bsyYrinA41zTFA2QlBQZP7PI6bm02Eku0SVMS1nJeVcpeU3xxvlnWJrMuJSUWSGlN2NdLnes7s7axu52mhCsxza5zRLiXE1jNFxLmazGGsxRmXKytn2H5fX246vuP7fz+kQCBERERAJAeKuTxfV7serCUIQRJWxsTpc9NZ0Opu5ilyYzrnNZlzLlSWisgVIDSZWEiEbEakRqRBYjMNESxWaGxRqgtJcy4lxm5mgJQlBRGxpIkljMEuVzKShmaoySkRAsgqgsBCQQ1CgsRAICVmhs1SmrGlNVCkBqpIgWCK0gNp3X5KfMr5tnyz5td5OptM24TlXAxc81zWEzK1BABmz53I6fAGV3ZSpoDIHI5W8c65zfLOuOd4lxmiihQ2RpOmjZu53Z01nrcbrdyw0GI5tYms5uVzLzms5ouZcS5XMuZQJYCEBMyplYiCEKQhpMiRAsksZlUSslbNG7lN6yjYkYmsxmaAMZ1AJDWYliIBiKqqNVIjYkNUFEIAsQkNkNENEuYxNZlJSzOdQGiKxh0URogXJSkuQyyopEuRMTShLFREsAmShqIhQVIjIlWkq0jW7JGmzSQkVQoguYFxAqdNZ7HyE+XXzbPmr80+YfIme6K1YsxWE51yMGQBaKzMuTFZ5HThEKCppBcnM5ryXnLxzvlN88ayuJrnmtEI2Jq56akdLnWp1ud3PTU0jEBlec1lcZuFznWFzmhiazLlc5ooZliqgEFgiMrpBYBErISIglaIgBZNGVbGGzVasUjQUpmUMzQUuQVIkiUioliIBISslTVygSwgksAgC6SGgiIznWTMpKEohKkNkasSqCCWoiXMCksmZRVSSrM1JmVoljMRESwCVhKpVLSC1aSI1Y2as1SjSkJDZEYlzLlaGzVas6J3r5Vz8tfnH9C5+bL8w+VHU3YmU525s5GU5tFhFaSFuUyYP53I6jJERoSQXBg5VymuWdcpvjneM3nNZljMqNjSmrN2as3ZqzrrG7NJqzUJkyuF551lcTWcstYlIzNYUlzGVpQFggCWIFUFUiIqRGylbASAhjKwCRAbshpSNWRShmUIlAKKpVBaIAWBSIiEbEakiWSEjKoERCVKQLBLmXMoBSgGgGtoDYkRlSJQglICBSUJSAlgjKkCxRGVQFIrYpGgSGlEbNWNKI2IDWM3K0Q2NSJqt3PSzufLs+cf0D+hZ8+PlzXyk7SJGQM2ZMKAFAGQMGK/g8nqMgJIqRBWTldck5zXHOuc1yzvnm5msS0uSE1qaTVzqt3O7N6mmeuo3OzURmsy4XE1zzcTQuJSXMZazGJqMyikAShLBERBLUpUiSas1SjYkUpRAsQFDUIGrIQNWC0VEEosgtBSKCtZzYCBQpYDSRVQWqJVFFSEQEsVMlUJAtGVDMsEoI0SNJqhISKXJLGI1RkLKUyCkCkuTMVpLmCXIKwESxFSgI1EiKa0kaU2lQuYJciKNasjSVaGzdnazufMs+ef0a/pp8+X5mZ3jpLqEDKlSZWUAErAyuDFn1Pl9PkFUjRlYyZORzXkvDP0551yzrM1zlzLEoQpqzpY2dLGzpc71ndnS50MVZMy4XE1zlznWJcqSkZXMuVJchLGJYzNKCkNEIENIo1u5a3ctaSFG3MCkCxEKCqFSqErYkQEUoALCREJWEopGVzCC0NkrRAJASyStkUCwlRJupKkFIzLVnNFgEkVrESJK2iKqBSSWqICgUgUXMuZcxmXMuZRSBaKiIhqIhqTRVJqtJVJmXMsKNKNNaRGxGzQ2dNTqnyk+dX9BP6Nf0JfnZfLj5ObvN3NJAUsREVBJkLMWYs+kc3psKLFCrchleZk4Vzm/j53jOuWdYmsS4lpaiFGtWas3ZuzVmrOlz0ud6mk0QGJecuZrlNZlyGdZXMoZljMuJRQJclKFKEAlSKVbTVm9TTO9TdmrFEqoypKEEtSkErYS1ENQkEjbmJYCBdIGrBaBYzLkFoFiIoqggWIiGgoiEqjVim7BQoyuZoQllBRKkESWFIFaoBQtJSGlBQJojJmUlxLiazLiXObmXK0AKilUIpVCVm7My5CUGtJqxs0lWiNUpqxKtWas66z3j5NfOT+gf0D+hHzs35eXyM66Z0y6iXS6hiVJZMkFZQs51497DoyqKqGqM0HMwcF5TXHO+M1zzrM1zmswSwkNSas3Zu53WrnrrO7ndm01VGazLzXM1zzcy5msShjOqgzKS5XMoEsZlFogBVGkbnRuzVm9Z63OrOms71NIpKQGVzKLQ6iRQVShEBoiGiAjMrRKo1StgEpWZSMrShVQCBmUUiUEiIbAZalNWJoRIjFEoZIiVhqgKmKqJVCXRWCgSySxEBlRcmIxLzzrGdc86xLmXMpLBTFRGqkQpIDMoNKbs1ZG7FGkbE1YkmqbNWbs6Wdj5R85Pnr/SPn5fNzfl5fIzvpm7lF3LqVNSoypkVCTIWYs8cdp0GFyahKyMy5XFnI5VxzvlN8c65Z1maxm4moyIjRGtTSas6XO9TprPa41ZtNVQVk5zXOaxNYlxmkoEuVAlzKAuZSXISwQK1RWI1pN6mrnpc9NTrrPS53Z0TYkZBQyZlbElYqEjMosQmhAzFQoKS0qKKhGFIwAWE0CksZXMZlFIKoaiEBGxNmzZS6CiAzQuSiIVUiCBUJdWNMRKABERLRILkwc15nPOuWdc8a5zWc6yuJYoiKo1YRhcyw0pqxrbLWrEa1ZpFGkbI1ZpGtWas2nyF+VXzZP6Fv8ARj5+Xzs35eXfG9TW5dQrqXcrKxtaVQWCgymLPGva+eyChoQKzmuDkvE5Ncc7453zzcTWJcS0uZYqU0NlW7ndm7nrrPTWetzuzcVZMxzaxNcs6zLiXMtWZSWMSy5lyUZUlAlClLGVs0Nzqums9Lnes9tZ66ztOp0NCS5IyBRVKxEBkqiIZVJYFkFyUisaqlaJZMmVyCZUIIlATNYmsyCixESJKppWOlaNnQQUMxkKzKVohSlqIoyqVMqiSpkAAQVSlgA5mDivKXlLyxvnnWJrEuc2CUIyZlzLUpqzVKNjWrNVpNWNNaTVkmgTVKaIbKulzs+QfJX55/RT+if0MvmZvysXvne5rUupWNLuVlZdwqlBbRWYTGp4y7Xz4iuTSCpkzXI5nBeS8c75Z1yzvM1zlzNEBAIhW01Zuzes9dZ7ax1ud2MaTFuYw1yzrEuZrEuZQzKLQLiWBcShRiagGXJqxrdzqzdnS56az01nrrPdOtm5eialSADIW0g0iIAAEC6RWTQSxVmMqpLVqXaCqZXC4MmIqkFJZJSsRgwZMyw1JNMkK6N2dI2vU2SyEuKyZiqKFdWSkBiVoSl0IjVBWc0oMqimjMtWTmczlHFeMvLOuWdYzrE1iUywvLOszWY1Y1qzVim7Go1ZpNVq5aTVmrE1ZI0pLQ2Vas0drOx8yPnHzz+kf0M35eXysa7Z1vOtLqNS6XUupdSsqMIrkEzXPWfGna+eysVMIBZheRzOFvGXlnfHO+OdZmsy4lCUhICrSbs3qdLntrHTWelz0TYAmGucuGsZvOayuZSMygS1ZzrJLmMzQASiyI2bs3Z01npc9NZ6XPXWeqdV6R0NmylSsDIAqMKqChkCqgXaC6iqAFyJGhNBLAZMLmzEuQJWwirMpZiXmYCUpSWGGo3G66HVdxqFWhMmVyZitURlUypBQCowiqgVZlyBFENSkFmJeVnKXicV4nLG+edcc64Y+nHGszREa1FNVq5TVjWrNGrnVRqxNWNm7ErEQKGpGtWaTtZ3X5cfOt/oyf0D5+L8uPlY11zrcu5aXcupehqVmtQrS6AAM3PLU8a9r54WFEyukyc151yXjZymuGd8c7551zmsy5lAKUpipRN6m7nprPbWetx1ud2MsBisS8pvEuJrGblSUCUMykCikZlAaICNWbsU66z13nprHW56WdU7W9JOkbXcaqliAKIhESUQUAgWNQiSwVmASs1KkuojNBhcpmsyhCgosmK5y4MLlIlklRE0dJeh0Ny7GyirEZtzAQ1S6QWAwqgSow0wVmUTKhEQqyFZlwYrjHKuOXBfiZ3w+e+OfpiXEpkKEbRs1TqbGzSNm6rNJux1KNVpKmAqUzLuyKtWbs6nyD5cfOr+if0I+dh8vN+TNdsa1LuXQy7mtxqXctNaGVQWMpmzlqeNe18+CKShBZiXnZyX49cZrnnXCb543iXKkZmqwlUyu7ERs6az0ue28dbnpZ1SlArBzl5zXOaxnWTM1mBSBcxLmUUMykoC0jTZ0s3rPa57bx01jsnaukbXpJtdxo0ILJlUyIkMoRGTI0Sxo0isRlZBRdIiMqQAYM0GVIqiAFymFwYAyRLRqk0MvSzcvQ1HQQMrkyZAhplhBADK0NUqJEZAyoQCslLUJhcHDN+LNfGzrhGDnZzzrnNc86zKS5lbEbE3Y2as1SmrEbNWaqFGohJISojVjXSzofJPlx82v6NfPy+dl8vN+Tl1zvcupdRqa3LuXcrLqXSsILGUzqctZ8bdp58WISJMLzM2cF5VwmuWd8s65zXPOsrRAqjURqxTVb1npc99Z6XPRNRoyuTBzXlNc5rMuFM3EsCkZWlzLhQJQgljVmrOlz23jvrHXeesnc6nQ3GzUaFUiMy1KEsNMJApVAZElRTS5WisgUl1YwjK2MuaAXKQAoArkkzXOXNZMgQiSqsmjUu66SaVEgMmFEFSElCBMylJFKiVUZADKgihLVLyy+PNfGzrnKVispyOcnOucvHGsN882jLSm7Kto2as1SjZupNURqyCtImVUaiI0mrNanWX5B8o+afPj+gfNj5Wb8iO+a5u5rcupeku5dTW5dS7iVhAxWLOWseN+06GFJQQMJhednM4W8c65TfKa550S4WiGlGlEbE6XLXS57ax0NxpYDJzOVZmuedcpqMy4lFoFzLmBcyi4lCJZOlnS56az338/kbx2TtL1OsbNS6RXSJKRFQqgtDTCQLWEZWBdIkMsRlVAlRNEKoEmZqsCUiSUChcplcBWYCpiNEqMbrUuhipCKshKWAStErZAuRMhGqolUiBcgZWspQo+PnfDOswU1lIyYswuLOEc7OM1zzrlneM2BdWRpGzVmxsqUahSGtJENkZl1ZENaTVnU7nyz5h8635mXzY+XHfN6R1ja6zrpL0mumb0l1nWl3FLolTCYs47z467PoMKkSBlc2ZOZzrhNcpeU3ymsTWYJY3ZVpI0jY1pNWaTdnVOlbjUVC4TmuDkuJcTWZcrmXKwS4lIzNZMykoQ1HXWelz8jfz7ax2r5MnY6y9EZpGRpURlqgEFiiVSEyqSBLAagXVgsUoAkukhEoaloBqCVAqzGQrJiUsysIisMImhJZJSIDKiFqAoLCZUSUIpZK2hSWTJKHKXhnfGaIo1qUGjDYFZiXJzuea8dThLzOON4lxmipGrEbISpTVkNmiEbIqoCIajdynU7nyT5R80+YfLl+THyI6R0jpL0Ny9M66zXTN3NdMma0rGlAMXPDefHXZ9DmKqJSzMpZgwvM4rzmuUvObxmiwG7GxN3MqmrGzaaTdbjqaGJasRzrBisRlrMuVIxNZUjEuJolxLiXKsVaTVnbeeusd9Y73PyJe6do6S7EoqVChohAlbMyxohAliAgVRCVIiolhSWVSEhlhESJYgMmQMmVApipiNCtCRVBKFRBQERUSwFUEsVEVURCCtmZecvDOuGdZVRGtCgNI2RVmKzBzs4LyueC8Jeedc83M1RlUbIRshrSNiBqxFBWyKKhVFNUnSu0dz5R8k+UfLO8fIOkvSOkdI6r0k7TXTN6TW863NajcqtBWGeG8+O+y6PMtYEQGTC5TNcV5zfOXE1iUlCNWbTViNm0rNGk1Zqa2nQVYQUsyBgwZCsmFJcy85rGdYl5zWJrObkF1Ztnep21jvvHyLn5Cd5e8vSNmhgKoglkllkiWISITMtSgtFVLUGpBYhQWWFFYoqYVhNjErWQAyBhckBCIlKiJVRkCM1mWqTE02RKDJlULZBUCkhtI5y/HzvlNYlk1UMjbqyNJqyVpRNIUBZyOdnA4J8c4zXLO+WbmaIFhsTVkaTVkNJWQilUEukKhGzS9JOp0XufJOx8he6dl6R1OsnSXqdJe0nSXpHWa3Lua3m6l0BizlrPjvn9MWZlrJZBQkzXOXFYmsy81551KENmk1W2ZdWKI2ajYmzZqVEQBMrgqwZMGaxLya551zzrnnXOaIyqNaZ7bz11j5OsfIO8fIjodZdlLJBRAsRCVEqgqQGiIysKCwxVRAsKCw1RESwxW6k0qaGNAtYS5rBmCsmVSEhhWRVJMrGFqDMVkoEVRQK2RKSCitlHKa4zXx86JWzQlTFSmkVaU0VmjVmhGyCsWcTkfHPjnxpeC8sa551iaoirRqzVzGrNVJCVNUiAkVRoTRqOlvQ6R2Ox1Oh1OppeqdTrl0XrHU6xuOsuzpLuaYZc2c7n6BzuowRAqlYSwVzmi5xLlcTQuIFiEUa0lWkRRrcbrcbNS7NorCZADBhcWYORya4zXPOuWd85SXEuk1p0ue28d9fP5B3j5B2jpL0EIaoKCBaIBIl1ZmWEQICWQlaSgVQqWKIFUFiEpVNKmjZqESMrmsphcgZWISEYVgIACsLARBFUQStEAVoyc86+PnXKazK2aIRrSQ0oibRpNWaEbNWUurErM1yjhXx1+Mnx5fjnHOuWdYmsykNNmjVmrNWKQ0kksJEaITQjGl6JpdHQ0bNmzZ0Ohs6nU6R1Okal7G46HSNwgc6+k8zqsQUQkI1QAYWrmEuVxLGVIljViNiRpGzcbNm16m46pqXRoIKyYrByOZxrkcJvnNcs65Z1mUFd6z11ntrHyLntHyDtHWXpZqJYJWwIAWiqGKqGqWAQECBUBAiKWqKECEqJZEl1GjS7NxoiUsyYlzZlcguSEhIYKFgAjKgEREQCZXSZlwvx87+PjRTGqUjVIojWkl1Y2ImkTVJqzSNuiTRkE5W/HOUfGr48vxzhHKa550S4Vhs0mtTaa1CNVUlKoiNahtYTRoRXUKQroTVjKmjZo6GzqbOh0l0dU3L1jYyqZr6nyuq5y5pRNQiurCIysFmFwZlyuZcqKQ2IpVsU1csuzodJe6dTpHQ3KkBiuZzOdcTlXxzi1wzvlneM3MtSm7O+8ddY7naOx3k2u41VKIKkmViJYiJVIiJYkJqSJaylCEANAsJESSikRo0aNS7OiM0omaDC5AyZBZIyrREsgoBBRLJVS1hLERHKa4Z1xzrKwmkjVmirSaIhpNWJpNDSmrFdDY2aIpawMS5s5S8bPjzXBPjr8c5y8865Z0EJvWU3qKaGxFY2airUbFdpqXVasc2GiIKIgVSWE2Jo2bNVvLS9bNxtehuKg+v8AI6rmBoTUuhNpEokuQM1hMLmXK5lFDRJLu52jXSNnQ6x1jqvU6Rs0QGK4nE5VxX49ck4tcc7451ma5zSnS53qdtY63PU7nSOkbNKpCsBlVEiBWSBYSUlbmBYiAQKUGqIDQAsQLpAlhGXabNnSFdCBkJcUJm3IAZUBIyCxASiTWRRIil5S8M7450CQ0kiasl0asRNI02JojViNmjVlK2IpUSxGVjBg5HCOVnGX45xOed85ec1pEa1c7s1YiKpuNVo6Ro6HStRo6UZurEFDKc5SgIysAkQiI2MujYnQ6GjQL/M+/VZCVSXZtNiS6SUQAwuTFYMzWZasxorOljHSzUvQ3HU3HVekdk2uyIwczhXI4VxOVfHrjnfLOuc1maITes7s66x01nrHUZehsZK1lkBAlhICJVBdGTQESgxWZlQWA0gsCqCoEQEQiJs1L0jZs1KmSMqJm3JkyBmshLmwUMrCgQLpBaOWdcM65zYQiKQkasq2kuk1YmqRsYa1YmkjVasoBqAogWAAMS4OVcTlHKuJyzrGaLhUU0m9TWowml0bjddI610jqnS3cdDcuqkFDKYMGDKiZMzQhRKEFhLARoTRo0aI5ffq8Sg2aNjLo2iaMqgAJzXJisrkJUU3ZqXZ0NR0Oh0Ny9TcaXcm6E5rzOdcTjbyThXI4rxzvnNYmsywprU2nXWOlzo2aNKwkQgILCAkQLDENZlUlCIgEDK0asgWEzK0gkSkQiqaNRteqbGVpgMqJkKjC5MmDJlRMLGRISXlnXHGuU1mXVKJGrJSNGrGyNGrFVNWaGtI2JqqGtWNlECpmKoIdCCJckZXCZXmnJeUcznLiazLlaKt2asU1Zspdx0s6W9k6S9a7nSOx1jdaJCUrC4OZlOa4gojNCZXMYUMJi2kyoSK6E0ku/v1mZYk3Zo0Mu7KXSJKACC4rIAAy7TS9DadY0vU3G12mpdIroE5rg51yONcjjXI51xzvEuJrEuZY1YmtTdzpN2JqylSSWWRAlUiUISiJZBUiIgUECIpazMsJAqSQ1mVSUIZdibOom4RAFAC0QXBiXNmIzWYysBHLOuON85qERGyE1ZCS6TVhK2arTMuk1SasjVmhshGsjAoksAmSEyQS1EFZjBg5rgxm5mswKEbsRs1Zo1ZvN3XZNtdo7p3ruvWOqdF1CsgZOa5sxHO3MZrIJlcGTnGTJyXCZrEZqiplbCX5H262ARNWaRNhLohIBQqMqEaGNHQ6S9DcdDobNQqoEomFxZyXnZyXkcq5mK5rzzcTWVzKRWqasoaSRqIgholrISIiGiISIlklCiqAQiUqKBVBZBaGgSAiJYY1W0ZdmxESBcw2YmqwlzWYyYrEtZzl551xzrlncmlLNkIokNRqyhrVI2MKNJqxN2IjYpWwQ0RVFAsZjWpmUiIFiSltCMmTIS5XEpApK2KNaRrQ1uOps7J1XvZ2l7y906S9rOkrEVZMylmFymVzZlZcphMS865RmzivOOZzMmQolbml7fXgAiKasU3Ygu0JdlVFQQxDWo1L0Oh0O0m11GzSqAGawYOa8qycjFczBlOa5tIypLmKpcxFKAoCxBERlUDQEIEQkBEIVqACWIiAIQUEBAoqFhSBYRSrVmjSIjSQRKARlQDMYl453wx9OWbmVrSCqNKaqErERTVFMmrK1TViJqxTVQ2IkBVQAsskAmVYFkzKlVDZFENBGZogolSSWTSVaETVal6JuXtXaO1d47nY6nSXoUaAirMZWMpW5MpkwuE5HOuS8k4y865mYzWIlE39OCKpoqUU1UmhsTRCkukpdIro6HSNnRdx2TUuyEDC8zNmK5HJcVgwZTChJGbYzLAAAuTM1jNwuZczQEC0C1URAICA0QjRERFRKoK2UCg0RQK2SkVEsiVEoEurASsTVKQmrKqIBMrQVQS8c6453xzvMSxCNkI0okQjZDSjWkSrSI02KJqxMkErUEQUS6QWApSqIqISNWRvUpNaRIgUsVMQiNjKCsiIy9LNL1O51Ox8iOx0Okuo6IqwiQVRlawMmFxZzOS8jmnE5LzTFcpQwBj6cLMqKNaRpRNJUojZpFdJpdxo2dI6m13HVNmpYjClnNeac65nI5mKyAVRLoREiAyuTKc15rzmuedYmueblSWAzLKRAqgsSUrYLCkSxEktTILANRQAqEIVBEsgqktZSxDZCVUNgsKErZlaXnLxzvlnVAsKEtURqyNENiAjZGiNWI2JDZqtI2C0VIRAShRFWYVjJQ1AtEVRqzRq51ZuzWs6EhIRNCaXSEqAFWCgVTRs6HVep3Ox2jqdDrGxXcbGIQJYJMWhizkcredck5RzrlHMwuTnXxLw4ak1UNMmrIUa0jWk1GzobTa9I2vQ3JtdmhTKhg5mDjXM5GKzWAIY0ujqajRoSBcphednI5W8c65TXPOsTWZecpLmWMLQLEshK2ErYKpEsgqkaARslJK2QliqglqCKVsJQSoKKmKpIpSkiAJecvLOsZ1kVUholbIUFTVlFSNkaojSOkismirSNiI2EsRAEsQBKEsgsQmSIglqRTVmrOms9LOms7udGrWNIqmjUu9TUaVQAzLzOZgzWYDRo6L1Oydl611y7p1XodI6HSXRqNDCsVhLmzBleVmK5nI5HM5rzsxGD+XviRI1CKQ0ppGtJqzZuTovRNS9TobNxo0sJkyYOZiuZyrmc1wmQtpGuhuOsvVOi9I0saQOa4OVcbOK8TjNcs7xNc83EuJrMuZcqBKColLWRS1SJKJLIiNlWorEFoCIgUEIFUlCASolUFUFiAjlnXLOuedCqENI2KqVaKyhGmyEhRqFGkhGzRI0pLFUQRFGVFzm1EZVIgiUECAlkjdmrN7z1ueus9tY6L0N0mkY2K9DS7NIgonM5rwjmcTnWYBNm16x1rqnU6S/IrrHReydI7S6OhqNGoVkAMViXGpiOdYrlbiTmYrlL/D3wpWxBNCRuyRs0aTddJNL1TcvU0vRNRsiBcmTnWDkYrmczAHNQhNJ1Oi9o7nWOp0hIDmuLOC8a4WcTgvKb5Z1yzrM1zlxm5azKRlSWEBoGAiEKUljSNiasiIJWiIqCiMqgUQ0FFQukzLEZl451zmuedAkRENIo1qyNoGqDViiI0DWkhRpFEhoipIiCAlJQFzGZRcythEsCkVEVMVAm7NXPbWems9t476z2OkbrZo0dDUaa6Js0MVc15pwl4nE+PZxXnBKUwnSzpLuux0Tsdl6R8izrL1jqdI2vSXSajYCBGDFYMGbOa8znXOvru+FJWrOipNJqzMbGzcuzobjodTaal2RLJkwuLOa4OVmDBztJBc1iWUNpo7J2O8veO51jZsDJg5VxPj1wXjXA5Ncc6551zzrnLiazLzmiXMsBEsiREoRpARs1WkrNoFSUtREZJYQCJYkiWJJYyc864Y3iXMtSQFK1BGrE1ZqmxTViNkaKlNWSw2aEUaiJJZJYiIQAJQxKTWYzLlSUIIliAgEFRs1Z0uems99477x3uey9ja7jZ0s0upN29Y0biBcpwXinCvinBfjxzXGblVI1ZuzRs6HVekdq7HY7HWO5uXrHQ6SaXcuhQJcmaDBizBzOZ9a+/XwpqyWNpFGq1KmjpGzobNm5FYjK5s5rzMWczkc1wkuaIqzKLAJtO52j5B8iO8djYyiFc14pxrjXxzjXFeRyzvlNcs7xLjOuU1mXMuJYQKWshICJVIjdjWkbNWJEQCRmUIgWKAaiiql4y8s7xmgmVIaiCVKiETWopuzVimqbEbEak3UiKNQjRASxEKCxEBBLmXMuVxm4lFzLQUS6QWMqkmZWobN2bs7ax23jtvHyLPkJ2Oi7l2m61Z0zdnRdwqkmDicLfjp8WOB8auOdc5cyyqQ02bRradDqvU7R3rsndesdjrHWNr0jaal0SxAgYs5rgzX1r79akK7soil1ZS6pjoml2aNpoJYKxLmzmvIxXNOdcpcGVSWSIzLLk1Z0s7Sd5fkHyY7x2TUqFc451yrgvCzgvE51yOed85rnnXLOuc3iMTWJSWAFo1ZEAgRCKNbsq0kbsakhAJcqoKRENEJiXE1zl550CAriJWygVSUKGmoU3c6rVmrN2NiI2aSpFNUpVSgLFFUSSpkRQUJSMy4lxnWZcS5lysERAsRlaGqKxN2b1Ousdt477x3ue52XqdDZo1HQ6GzasqguU5nCvjHx6+NHxpeRzzczQErZLQDZuxs6HWuqdjtL2O9dpOy9o7G5esdDpGiNgBkwZrmfwOR1qJSppGqJURNJS7spUUzbmM2YXkc65nExXKaDMsC7QGiBQDdnRnsdztL8mPkJ0l0sgcF52cTlXFeVnE5rzmuc1yzrE1zzcTXOaxKS5lglrKKkCJZIpZGtWNaTVjSmkgtpJYBAJYFI5y8s7xLDYSxERAsJAJEBGjVm7nVaud2RvUrNGrNEiNRAqhKAqkQEqRIgRmaDK5zeedYUzec0BK2EskoBLBCNkbs3Z01nrvHbWO289zqdk6Ls0bNnQZeqK6jNRyOBwPjnxz48crcZuJcyksRlcy0a1KNWdNZ6WdbOx3Oq/ITtHS3vHaOx1jpHQ3LohCM25TFfyPv1sIkqiUVtFTDYSxILmsHM5nI51zOdcpolwuZRVI3ZEgpAsbs3c9k7neX5B2jpEC5Thbzs4LzrinJcHKbxLjOucuZrnLiaxm5lzKKoSlUNRECkRFVLu5bNWJqyN3IsQLRFZLmXnm8c7DMuiAbCVsJYgXSZVIiqiGqRrVnS5a3c6s1Smq1ZEIpVmXVgqhLAISwEJUpKEZlDObmaxGJrEuJpTMssBARBKlRGrNWaTpudLjrrPbeOtnXU6Rtekm63KnStmzcaBRMHJeBwOBwOS4lzmgSi5jMuZRcyo3O7OmpvWeqd0612Xqdo7Wdl7x1jsnXOuibNS6QWM1mPhffrYRJVJYAEwAJkxbhMHOuK8jmYrlNYlypLmXCo2aGxiQWXIG066z1ue8dZfkHWNBLmsHKuKca5LyXnNYlxm4msy4lyuM6zLmXCpiVAoipIzLEREVaTVkurFGlARAjMvHOsTWJUBIiAhIlkiVSBVBVC1JI6WRu53Y2bGzVmrIlUgJWyKBYgIFSIiIUFjMpGVzLzzrEpLklzKkBEC0BENiJu51p0udaz2uem87ud1s6JsV6JtdmjZqEjC4TivKuMcTnGJcqS5lDMuVxnWM2MrqxN3O9Z66nW56WdJeqda7HaO1vaOx2k6r0jpGhJZI5/Xr41YSxKs5UMkYs5nNcHOuJzriYTiuGuc1iaAXEtAIpVpNUISyhqxOlz1ufkJ1l6nQoqycTjXI4LzzvjNZzcLmaowuZcyikZlzLAZXUFIQ1mFcjACqNJWJqyI1ZorMZ1iXlnWVoqhIBARASAgVIDSSyCqVJG7GxOlzqzViaohoFJSGpJQhBQYkFhSGhVBaMrmUMS5lJcyigSwEQBKgQ1RqyGzSb1NWbs1rPS51p0Z1Y2bl3Zpdxo6Vo1CFYjlLmzivOsRiUCUlzGZrC4zcrmWXIyarVzvU6XPTU6anSTR0l7HY7HY7Hc6HSNxumGI+T9eulSIDAGU524Oac65HJeJys5LxOU3zlxNZUgUlbCEFbGzRERAaJOmp2uO1nWOkuhMHM52cF5TfHOuWd4lxLLmBSBSXJS5MyyySxmWRqgWAJUKijVkNJqyAzLyzrJFLqzIkQlFbJKIqpACoGgGxipAhSXVmrNWaRpFIiGqIqglbKC0jSAkoNSRAtEBGZrIS5lzKKAEsIAIFLFQRpEhs0jW7nVjW7NaztGzdkb1NG00vQ1GirMpZg5y5s5y5M5tbmCXMuJcy85qlzASydNRTepu51ZqtpuzcdTrXVe0drO0vU2dI0aNH9XXXtgUubMrgxZiOVcjlXI4rwricl4y8pvEuZrnKStEI2QgNjLWaKiIBrabuems9U7Iy7sDJyXivHOuWd85rGdZXOaEAKShmWCUBYkFJYiQWIFIQNFYrIGFznWYhpSolUqRMy6sJdWAgC6QVQElkaiFIlbKNWI02URVokhIgEFSsojK6spZIqloipCAFozKGVlzGZaiJQSIIlESVsBEgNWI2bsbE3ctNmkTVmrNWarabrcukqIyYMULmCMTUZljE1mOc1mUlBI1Y2aRs0VaRs1XS56V0jqdjqdTcvU6GzcfYN9fGYq5mDmcznZwXicq41wOJxa5Z3zmuebiazKBLGrlrSaoEBpRIBATpY2dbjpc7OhGV5nJrlnXGaxnWJrnmwS1UZVMSxmUIzNBFEVZlhCKqUsJUgJcxzmsxUmrFEgVA1ZCRCQLJK2URENQkgu0CKmGwWFNUCgqkI0RUKxILqwiK2hKpIliASKAypLGJYJQFiSWCVsjMrYS6sAEhIjSNmq1Y2asRGyFGtWaTepu56Gq0hKVkzLJkFAzQyuM6yuZcy5iWIbEbFBUgN2R0udWdDrZ0Osda3L1Otbk+1XgFCc15GbORwXic7ONfGXkcV5Z1ym+WdYmsTWIJYhrVzqlNprUoAVGyBdJFSnW51ZuzozpZMLheWdcZvnnWJaXIKlANZlxLRlcSktVGVQIJYgCVMiZXEvPOsxVtIahRpSEaCNCBEQGiohojVkC6SIagNJGYl1ZAqiVICBEksRERCRERCAhVEqBmJQIyspBLUCAkRkSIlkQEhsRTQ6iasUbI1RERqtXO7NWb1ndaFBZBcwWyEsZyFxNZXJjOqBZGkQRBQzLFENmrOmppOlz0rqdDodTofcrwMmDFnM4Lxs4Lys4nBeC8prlnXPO+Wdc1xNZlzKGjVim7NWbuWt2BRUKyNZlbEao1c9dZ1ZpN2UZXnNcprnnWJrEsJFYhKGZReeaLiaAjMsShFASxmMzXOXE1mISqN2BCaSpSVs0REIURqxlbMw2yRCNhKlYrI2MCxmVsoLaGyIlrIpYgRBUqohoipiohsJYbJSJZBcw2kRmWCWoiqAYagECEBErERs0mq1ctKasiIytDUauelnTWdWaI1VAZICrMqZlDObhSUCWGyVRMrmUMy5lCirRGrndm7npqbOiddOuX3nXX8zkvKznXA4nCuJ8drlLym+Wdc865zWJec0SkSgpqzVdLndnTWGtWENES5lklhsTVm0dTozqxGsxzmuc1zmsywomqkTK5lxKLyzcZ1iaFxmxGVogJcLjNxLiakQVSEKSNpUkNiRpBWyipIhGwlkiGkiErEoqTMsEVZl1ZKCVlKCQoLAJINaQIFUkliIhsJWiBYJQiMygShDVCFisRERCkVRpGtJqzdm9Z1ZqxEAgXMtUKdLN6y2aEhqisJYColAjE0RlSVshELKUMTWJcy5lJcxVStlDZqzpZvWd2bs62fftcDicbOK8k4VwOK8V5Z3xzvnnXOaxLzzrMuVglis0asU6az01npc7s1ZEZlAlFQsYaU3Z01nSas0hRLlcy4mskJqzaVQRia5zXOXnneZeedYlxKLEEvOXGdc5SWIiIBqISNI1I1qKqxIhJNVAJCkQ1QGqISpIClrKWTKwQ2kQ2CgiSREsgqkpFSQEJERAJERlaWAIFggUIUVqklkSIiKo0iNmrOms7s6XO9TdzqoAM51lSATdjZpGxGqWIiqjImQlyEoSwpFUBnOsLjOsS5lIzKKRERqlNamk6bzuz799Ot41yTjXA41wl453ym+OdYzvmuM6zGZRcywCI2as1Z0ueus71npZpKmMmVzKSgkNmk1Z01Ns6sqYABSWFNUpogMriXnNcprljWJrlneJcy5XMc86xNYliIiAlihqA0iVbSsSIaUSKqNUoEQ0kKCooEREqgsQGZYClUFaiQlbIFUlgECJZISICEBJRJVMrGYlglCCJZJUisSGsw1RUkmq0mrGzprPXWd2dNZ3c6FZMrmMqRmXVSaqIjSCpESKhkCMqQgI0khLkzNc86xGJrMuZcTUZlCKGpGk3c7s//9oACAEBAAEFAqQzpLWDmUuc2QstCk1UloUikrHSMKkziKdQ45lLRZK+Hp4bL6DTwqSL9ceWpWak9ceuLXC6RhhhhpHHHH8LXxdcav1qv1F4v4tvobDDDDDSuOP9o3eFYVjTArgUnr4OhSZZfKFJciowwwwww0rjj+Gpi0+l0/SCxpgVxawUUWOePSZorgthsMdJ0nSNHzHHHH+y1I0igkcsorDPFznykzXy8NlFcVhhjpOkYaRxx5aDeAYTxFPoKS5Yy/TPNIUEg45UrB8N3g+JXGrhtGvjGGGGOkYY8yg448ayP4iuNXGr42v1epX9At4xjpGGlcccfwDfVm+upM48XwnbBrI8aYlPG0wK+BaDDDDSOOOOP4KkGmr+pngkEElrI44+PQeTLGr9MbDYYYYaLiKOIo48tfq+VfrNI0kSDjmUHg+C/lB8F4PF4Z0kSOU1MBvqjTOdQ455eIX6s/jHw6lYPBx4u0rlSsXkeLzvg1KxeekalcavjK41cRxxxx538HX6C48KTuVi+K8Hwn8C48rjzvB/1c451HUOOP8AVXHHi8rj4r4jzvCs9MBx3i+A+BTxlMB5H8BSFPoz4TjjjnUdR1MOP414vF8Bxx4PI48HxHxng8Hxc6YTwzeesVkpCkEwM4UEkyykeGY+C8M8VymJnj50xM8Nx4Ug44451HUPJngvB8J8B8F/qSY6GWWLlFZc5csFP0Vl4HqOo6jqHHHi+A87jy5wz+jPi0KFJKwrPQpKnmJ5j4lcasz+ApNX6xUrM/hHHHHOoc6hxx8Cs1J6xfDr4B/pVfq1foD/AFpxzqOo6jqOoeFfqL+Ad5qQp4Cni6YtPAU/Tbwc6jqOo6hx0+u1KlZaFJMp6FCmKhTGpi0KYlJ8o5+Ppi0+m0i4444448tPGU+lpDLLL6Fn4PL9UudQ44/1GmLSDss1Z6GclfolMahn9Wp9Cr4JxzqHHHH+uV+nVwq+Df8AVLjnUOdQ4/3wccccc6h/GqVnpgVKxoUgk1Z6YFZaFJ6z0xaYFZ6YFfCUxaY9MCuNXwWcKeEcc6jqHHH8UtaLh5xzjlBZc4pJlBfAZ5/Vn+h5fUc/BOOOP4KkM6LFIVQywqlZs/B1ws4pHL7PuP4HMqVxa41cCk9cWpUr9Cp9hnHHwa46fR6wr9tHKlSstCmBWamLQpi0KT1npjUxaY1CnjKYtPpdPq2cEkyynzEjlPn4PKbOCSZS5wz8amFnNli5T0ny/S9J64VIIJJllLRfA1xkK+Hz8DXGTAzx6LiZyV/R649Ja41Ss1PDVxa+FpjUwK4tfrNf1rTFp9oayLGhSapWWhQpi0wK49YLGk9ZqFCnhaxd5KeFr49/o9fpiiwXHz8HlDLErBYKLj5/Q6yrj5+Gyw8jL6hn4ZUaGZRYJCplBZM4JJllJSVPMrHKWmBlJnIkKmWLllg1K/TMssGsmXi8v0FUrPSauDSFJK41cVPMri1K41cauNXxlcav/D+s9Ith0xqYFZ6FMSmNSNMOmPTFpjUwKzUwK/oavg1inlBjJvIrPnBBhjKqS5y5YSCRyyw8sbKqS5/QMsfKqS5zV/TCoUKTsVi0lMDKWmLnFMKmBWemLmZ+Ip+j6/UF8pGhUqVKxoUwK4LSVKzUnqVnWfbcfyG+NPs3ufWF7F7qQ1+1u4tumppaujfTAqVxalZqFJqwr4KmBUrjV8NTxdPDV8HT6+iLcvCfHvKcinG9m9v8YIiWpHc7Pab2zlfjniN4nNdt8twN/wBqqlSsKxoUwqjxpi0wKwrJQpg8fx285Xd9t9m7DgrcDV0tLX0+6+wF26TUxqfS6YtMangKfX184LDOhRYoVSfOCYtJqzZ50wdhsN1ye87e7e2nb+zw++uzUutjnnQSRpGlpJkVGGGnYYYaRZWkqNFpM5GGGx6jDYtfodPC18Ascx4pDKXPOfKeky0FFw8o59kdtpwuwxe++2/8NvsFhpWKSt5ZTtFpGkYYaDDQYYYYYYaDDDDDDQYYYaKwaRoZZfTqYOWLlJSOeeFQpLUrF4uPLWLjmWDXGrgdicL/AJXmcbm+L0uZ4zV0tTb60UK4rPPSDDDQYZ4sMMNBhhhhhioww0GGgowwwwzjDRaDStBio0rRaDRb9NPK8j/Rfj7jk2XAY/yHxybLnsJoNgtBoNK0rQYYYYaDDDDDDQYYYaDDDQYaDDDDDQaDDSsNBpGG/SS+cKlZKFCk9So7yPB4pCvi0Rbl2W2t2ezx/lDa9fG18U2A0Giw07NBoNBhhoNFhhhoNM36Kp4VRfOTOeszxpg55xTykynzpPxdtt/J+92Z73Znvdme92Zp6+jq4F2522mvvdme92Z73Znf2rttftrw6Qr4lothsMNBcVoVwF8BXwmfgaRy8CosM85cjJYLGiwTDzzEjlllh5GUuelramhqdjdx63ObKX5B7o3ejuazZmYn6Fr9AyxcsvFZQWZI5SLBZqzL5FByklY1kpFPKCQrIouDUTzK4nxfsda1JfkDYa207i8BT63kKLBfF1x649fA5YFSs1PoCCeI43a273kf6u40/q7jT+ruNP6u4023xnwulqbfb6O10ZeU4nYcxtrvi/iur+ruNP6u40/q7jTuLsPZcLw0XikMhx56/oZaFRRf0uv0vt//AH3gO/P+qY2WLX6EvjF+nrg08IvnPSLFUhVFKwzzoUnrPSeuN2//AL7wHfn/AFTDrB5KYFYv4vLDfCdsJ4U+oLgUhlGpXFqLJnnKotFFFM884JJlJnmIJLllgJPxO409pyv9hdsH9hdsH9hdsH9hdsG2767Z3Ooipcku53W32ejf8gdr23f2H2wf2H2wf2H2wd195cFyvASUkeFcaviLbL7/AKBdZfZirLni5+CSdcLKXPDpCkM4VjkLBRfLCyjQoJFJcqRpPXApJ8Zctr7jby/InLa+85r6D2p2RZye2t7L7ZsT+G9tH8N7aP4b20fw3toXsbthU3Hxzweoch8ccnoJu9nu9hrTbbb7jd6vF/HO/wBc2XY/buzTR4/YbaF+np6ibvtngd6cr8b6apv+P3vGa8Hj252Doau1/g/a5/B+1z+D9rn8H7XP4P2sanYnbF6bn414rUOR+Pub2aamnqaN8MshY8P2XznMHH/GfEaCbbtzgdmWadmmhuOK4zdJyHx527vDmuwOZ4lMDtPsO/mtFPj/ALTRP4B2kfwDtI/gHaR3N8dcfbsZ9LS1dfU4b4y5LdpsOwe2Nimhx3H7WGrt9vuE3vZnbW/TmPi3V07d3s91sNxDt7gd13FyG1+Oe19DS/r/ALRP6/7RP6/7RP6/7RP6/wC0T+Adon9f9on9f9on9f8AaJ/X/aJ3n2Lx3HcbhLNXFrCvhVlqVmSKSVwKT1xfjrgtxx2zl+ReB3G35KhQpjUmrhaOndrauho2bbQwOT4nYcvt+4+3tx29vJO2+0N7zpxfD8fw+hPynFbLmNr3BwW67f3tI8JtU3vL4PM9v8Zzml3F23vu39xLx3Gb3ld1272JxvDpgd19j7XmLdbR1dtqy9ucNqc9y+np2aOnJU3ej7bdS8PxG95zfdudqcb27oz872/x3cG15ridxwnJHxXs00+Lw/kHcpt+1vF1wneFYVwFisK4dSokE8Fp6Wpram1+Ou49zp8v2lznCWR4TS09fmf4n22fxTts/ifbZ/FO2zb9u8FtNWa622+27tbty+7+J9tn8T7bP4n22d5dvcJsu246elq6+ptfjnuPdafMdpc5wtmDlh9p7X3fcWF3HxNnM8TSPZvaK8tdZZZp2YPcHDaXOcbqaV+jqQ+Ptt7juHC5Ljttyuz5jjNfhuQjw/Ebvm99wfBbHgNnhfJPb2nq7WX464L/AB3FTd26Ht+5ZLLbr7u0e3NLt3jMC662y3vLl9HmueOxdGzQ7Vw/lbfWpoeCp4NRfOahSaovnDOGdCkuVYpNSSsKz/Hvb+js+OLrbb7e9eC0+D5aHb/++8B37/1PKHx52/o7Pji622+3vbgtPg+XSfKTOSpWHxrtvV5mPcPLf4Tif7P3xpfKGul3Bd1cXz0vO6Nu35o7V4C/uDkdLS09DTjy/cPFcHZu/k+/q2/yduku4TuPjOesk+QeOTZ85D4w23lHnee2fb+2/szgjS+Se377uO5ni+Wtk+S+Kt1dlDS09TX1O1u3dHt7jo3XW228r8i8Hx92r8qcit2y+VP38VzPHc1oR+Reb2u04eTtThLue5lES1Jvknb+j3RJ8ccUm/5+O93m34/a8x8l8zutT+Y9zvxPyby+1u4nnOL5vQ5vujh+B0+4+9OV7gWHanf13A7RPlTgD+0+3z+0+3zR1PW0o8n8h8JxW+/tPt8/tPt83fytsEs5TlN5zG+wlw64FCk6xUzzkyyWgsVM5qplKgkEmWCxzj28jcBD5WQyO3/9/wCA79/6nHt3y4CHyszxqVndsH4x23Rx0fk3denxcOD3Ors+Yk7l1PV7gttW9e2OFt4Pio9391W8Dt9fca251YbDfbnjd3xe/wBLlOPj8n7fq494fH229DtyPyhu33ENtudxs9ftHuH+QcdHuHapveDh8bcF62tHc7nQ2eh3V3jvOf1Y8Py+84TfcT3Rw3L7blu9e3+JTmPkjmd8amrqa+pJ2BwX+J4aPCc/by/Nx+V9Dp38nxVtUs4mPyPp7i/tfD4va+/5GNDkt173kMRYL4uhmUkrHJRRRRfIoslSpVMpc4JJWC0jQoZxqdvf6CHytHb7jV2e5/sHuk/sHuk/sHuk/sDuk23yN3Jo6vAc7te4NhL3b3fpduWXfIfdFy/2D3Uf2D3Sf2D3Scj3jz/KbSPb3+gh8reF7J2vte2o/Ju69TlYdo7G7kO4Y6+tZt9HX1rtfX7B4r/I83Hf73R47Z8jyG45TfSfGu5XV4SPyR/1+HCbX2XER793Xue5Y/HW8u2/cUbrUvty0tPU19TieO0+J42PyR3DduN1idmcH/nOZj3hzf8AguE+K9b/APrR+VtB+Mk+L1Re3I32WalnP/GNmrfyXCctw989YfH21913RHuPd+x4HwtfAZYdcBcSkUihWRZaT9v/AOgh8r4PxWur7iXvz1f5SUn7e/0EPleNIUnrJmUhaiquz26bTaR7x3Xu+5TY8bv+T1e0e17e39vHv/lk4/gz4549Nrwcfk3kvS2cvxei/wCPj8laiW8CcVtve8nJym699yUeyXXuiOrqelpZfH+wTfdxx5TfWcZx2vram418LI7H4L/C8LH5D5teT5r411ejuePyNoet2tJ8Vcpbbqy3W2328p2D25yZzfxzzPGIqLas3xRterdx+S917ftrEpBfGLirhUwU8F29/oIfK8dvoau61/4B3WfwDus/gPdZ/Ae6zbfHXc2tqdvcDte3thL3d2fp9xW3/H3dVl/8A7sP4B3YfwDus5DtDuDi9nHt7/QQ+V4Z4Twzk7Z2vvOfkv4LhNS+3g+EsWyyzTtjq6unoafdPO3c9ypxO09jxce/92u67kl+Odt6PbsflHc/sOwdr7nuWPPbr2XCyfHG39fuOPcm59pwB8WbRE28fkveLt+38TsTgv8ANc1HurmU4LhLrluu7F1fR7rj3Voe57ck2O93HG7vtvuTZdx7KfunsrYdwae92m54/dS/GG19Ht6Pyxun1fpS+ZWFcFYVKiy0KTVKwSWmN2zd19vQ+VrH0IcVq+jyngPkXU6O1o8NZ6fDw+Vr/wD9xmngKnxttfX5/B1tbS2+l3j3mvNKcXo+65KTn9VdXnIOZoi3XcPsf8ZxcfkDfe87jPi3bPrx+Rd37ftyT4w470tlH5L36bfgz470fS7Yj8rannPWSp2dwScDwsfknm/f8udtavodwx3Gkm426ott0KFDY7/d8ZueC+UNrqps99suQ0pvlLhbL9tL2rtPZdux+Rd17nuiahTGp4VY0wlgootc885cvAKLCknY+t63a0Pk/brq8DBzjd2m/wCPx/lTedGwho6d2tq6diadkPlLW6uZjXwHxbtW20+tuNDbWct8h8JsDm+5uV5++HbSJd3DJztt2lzUnYfDLynNx3+80uP2W43Gputc+N9r6Pb0flPdfvjs9rr7/d8Xx+lxXHR+QuV/yHOnY9qW9qx+V9C5sP494H/K8xJf8e9r6l39ddqGj8f9saGrJz2h7XnJtvudztdTi/knuHYnCfIPBcusne1lup2tJstuu83dtqWWx5rd++5f6UvkLDONZVgsFrJWFTKWhmkalcGklT4x3Xq8FDu7Ze/7cj8b8mm84PH+QOUTke4odnbJd93LHv3de57o8H2Dtfbdsx707v5PheU/sXuUX5E7mVNx3n3NuU19zud3fJw2smhy8nyHxd2x56Oy2W65Hddu8Ho8Bxsfkvmk09CHbe19nwEfkPde57lhbbdfd2N2ivD6ce5OZs4LiLr7tS4+PtVNTtaPevD381wMmx2G85Tc7L4qfS5z485nikVOlYW23X3drcJbwHDYff8Aoeh3Xg/F3L7vfbCPf24Tb9qSdh7X3ndMeb3fseH+mUHlqVmpPXCQSFSuLWHxdvvS5OColyc7x13EctDsznE4Lm8bubmtPgeIuuuvuh8V8Yq6kNS+3S099urt9vfAUKKcXtfZcbHvPde87ljWVFY4nfW8lxkec4TZ89seW7M5/itRNnvLr+L7H7g5O7t7tfj+3dGPL8ptuG2HIb/ccnvDZbZd5vERLUjy/avdG/5X+E90qbH4157cXcB2bxHAyXXW2W959yfyDkYfFm+S7ayd1/H3+Q1d5wXM7G7S43kNyvE/HXO8hdwfbvGdv6EO4e0OJ5/S19K/b6x8b8D/AJHlcT5V0OjnocF23yvcOt292Nw/BW7zY7PkdDuf4533H6l1t2ncbba7jea3ZHbd/bnFx+V+TtTSk+J9r6nKR+R937btf6utBYKVmpMmGuF2/wAj/iearH5Q4eT497oTkNriX32adnenci9w8kZWWXal3bvEpwnDQ775L/Hdtxr4Dgtr73mo6l9ulZuNa7c7jB+Muat1Ntha+vo7XR7t7n1O4d7Dsba+67mwqHe/env5O1eZ/wAHzaKlyYXcXcG07d2Gtq362rpaWpr6vbvD6fBcRHmPkHg+F5D+1e3j+1u3j+1u3j+1u3jh+V2/N8dH5b272na/Df57m9rtdtsdvHe8RxXIn8M7WRdpx+x4+yO+3u243ac5y2tzfKSfFe09Lg4/LO7/AGfS18ys1ChSVYLGkKFMBPOShQpHKVYLGh2Py/8AleAhyOw0OU2PKcduOJ3xU2+41trr9pd27fuLb4SqiJ3z3onJSfG/b3vt/H5M5f3nLV8H8dbT3Hcke7N17PtyNCk2x3+543d9vdwbPuHY4HJcnseJ23dPd+77h1Y/Fu16uQweS5TYcTt+6e+t3zaS9hd32dGD3N3pxvb9nK8tv+Z3h8Z8D7vfx5vlNLhuL3G41d3ryfGWr6na8flLQ9Tt07f5jV4HluK5bY81s8Ddbrb7Lb96d5avcWvJQ7L2nsu14/Je79z3NPQp9DXCyyyWKi4GU+aS5RWTPOHYPOf4jmY9/dr/AOY2cdvuNbaa/a/yFteQTA3/ACGy4zb91997nnJOE4jdc5yPG8dtuK2MOc5XS4Ti9fW1N1rRpFMOkPjXe7fa8zH5H7h2+rpYCx4zlN9xG64H5F4rkbbL7NS2Td77ZbDT5n5M2WinI8ryHL7gzh8W77bWLNqaulo277vTtvYHLfKG51E3u/3vI603mh238i7nYW8dzHGctpy8r3l2/wAQnO/JHK8gXKqrD4119tf21BVS1PkPurR5fWl+KuY29mnH5R5va27GHDc5yXA7rgvknhuRt09TT1rJNTV09GzmvkfguNt57uflu4tWbtvfbbkeEhyfKbLh9nyvIanK8jh5QUUXxa+RQzkqVhlksc8zPDpPWKwWGclY9jdxJznFR797NXSuoZw4LvPm+DOM+SuC3htOS4/fpChvu5+A445b5SsOS5XkeX147PZbnkNz2r2zt+29jH5E7iTlOQwE84VloUkStvPc5Yn8h58v53mtazG2PLcnxt23+Ru59Es+UucL/k/uG9N13x3PvE1dfW3N9ZrbltVO4OeRP5Dz5/IefP5Dz5/IefNTnOa1DU1dTVuw7L9TTv2ne3c+zSz5P7itS/5T5w1/kfufVTfc7zPIzbfdbrZ6n8j7hP5H3Cbnl+W3mnMiraqdxdwWp/JO4i7uHn7kVVVZNlyfI8cu2+Ru69uifK3cSJd8q9xLbuvkTuvcJvOS5DkLp6m13++2K/yTuI/kncJud7vN7d4esi4qyLPWZfKfOpXCSNSslCkKS1hWHBczueC5Hj9/teU2ce8uw7tMpK6vpcvyuiL3Bz1xrbzd7mbjuN3vLbrtXtPadt7ePffdKcJssGv6FXwtZKFMCuPXFr4ZcPJYLDPGTw3Zndd3b+609TT1tOPdHYOz5leR4vf8TucPt3szlefu4XgeN4DbR7l7i2vbmw32+3PJ7uWv0GvgaeLzmy/RC+eKuPWCFcJZK4PZXed3C36epZq2R3/HbHk9Dmfi7z5HguX4m6WgiKq8V2P3Fyhwfx3w/FiIiJHn+4Nj29s+Z5je85vo1loIIJMosFkzxayZwp9Fzly/RSyLDOk6+cKwWNJMjKpWVJsoqKZwoUky7T703XAXbHf7Pk9tIqJcm97R7b366/xfwOot3xPoCfEyPpfFOwQ2vxv2ztzZcPxfGzdz937Dt3T5Tld9zG7wkEgkMhRRRYZ5yZS1wc4JgL4PLFrgVxa/Q0kbBpgLiLRRRY555yZZZRzEmyWXPOKQyqkOH57kuB3Hb3fHFc4mNuNxobXS7k+SnNTV1de+eipBBPMQQQygosF8imHUriVwKfS8/BJ4RY5wSCSsMNjUKC+UtYVgoopQXyM5az0KCRSNcWstI8J37zXDnE9+dv8AKCKlyYO83+y4/T5j5P2OgctzvK85q4aRSdfKC+UFlf6Hn4yniK41cDOWsWgww3gFkrMpQUWastMGuDnGpXD4/nOX4pdj8oczom1+U+H1Th+6eE53WjuPkftfRN38raCG/wDkPuXemvudxu9TwaSr9Er+iaz0wElYYbEaFY1kpCkqii+cK4aQrJTCXz8F8W/9gxco1lQoJ5CCSKL5iiwzoZ+LqVjl46uNT6OgkGGGGGGGGGmaRoL5lSstJVF8xYKLJQpPWFSsaYK+ctJcoVKy/Fv/AGCOUc8XNBBBIZQUUUUXw6S1/RtIUw0EggiDDDDDCoKKLFhhhhhoMLMkuS0FFFFkQSGWWLllFYLPlPQofFv/AGCSiwzw6SIIJ5yqKKL4HMpjU8DXGr9JzwFmQQQRBEGGFFFFQVBUGgwwwww3kwwpQosUhWRRRRTOklYZQyjRUrLVDIUpBcDKHAdv77uHebL437c2+n/Ae0j+A9pH8B7SP4B2kfwDtI/gHaRxfbHB8LuI/wAA7SP4B2kfwDtI/gHaJ/AO0T+AdpC/H/aRz3xlt/R1LL9K+NJ0EEElVcShSXPBrgJ9drjVwkEEEE8xEMoMKgqCoKgwwwwwwwww09YPKsaT1wkK4ay1m+P+P0tl234P5M4/T2nPGWWWAkEg8VgviHw8sdPpdfEJBBBxBhhhhhbTpFQY6RhhjpOkaDDC4iwWNcVIJ4f475TS3vAeD+ReV0uS57CSCD+UVF8XQp+n0ELREEQYRBhjpOk6RjpOk6TpOkY6RhhipWFZE8p18xRfOWhSLSNjL5wrLSXi+V33DbvZfKmyXT/tLt8/tHt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLt8/tLgDnfkvd77Rx0XxVMHLL6jSeuBTGoUncdYIIgiFqCWiIIh0jDDHSdJ0nQdJ0nSdJ0nSdIwzixzhmJItFgoopnnFMHOesmcaS5Y2Xg8xJqwWanhMvAL4lsDP6E48zFqFqFqCIJaJaMMdJ0i2nSdJ0+fSdJ0nSdJ0i2nS4tsaFI5wyFFFFFF8o5iQyykpCklZVFwa4WeNnHLKakUK4ecuXhs51wK+By8QngXHHmYQtQtLS1C1BBjpOk6RhhjpOk6TpOk6TpOk6TpOnArOpSas1J6zUwa41cCngqlSvjK4FPB18Q01fGdQ74SCIWoWoWoWoJaIgwzDDHSMdIx0nSdJ0nSdIwx04axXxai+NYbGbwDfWGwW+h9Q+IghaWlqFqCIIgiDDDQYYYYYYY6TpOk6Rhis9CkqilRZaFIpg0KYVZKY1MCsWGGGYoMMMMMMNKzFJmgw07DDQbApgVmoUGgwww09PANFotgUKS1wKTv4BBC0tQtQtRhBBotFoMMMMwzDDHSMKgovnJnJkLRfMWRaxTwWUFFhmUxc8JoN5sMMNFhoMMNBUgzQYYYaDRUYzYYYaDDQabOTKVpWEg0rRYYZhBoMZDRWLDRQYaDDQYYVMbPAcfwLCJ5oW1tLC0tLZ2gwwwwww3kwwqQWFJamVUWgooovkucEleXPOCRqVTJZKGcayZCyUlqJSLDDDeYww0Gg3kNI3m3mwwgwhUqmTDDDMtBvMYYYYYYVPJhUg0GGGgwzyZRziiQqMNBosN5t5sMIgwwzlZWKDebDDDDDDDDDDDDRYabKTOZx3nzihWVZEELSwtLRKJhtKwo09SpWCwUoKL5S1KlYVjQp4as9JqwSCQpFhhhhnKjONBhhmGYZoMMMMMM4w0WGgwwwwwwzjDRYaLSVxalZWGGYZoNFhp2i0GgwzwaVoMMNGuK7lSuJWWkaRQQtLS0t8xBMOuG2GvgE+hpBEEEGg0GlaRhhp2Giww0GGkYYaDDSMNBsVotBhhhhhhp2GGgww0GGGlaVhhorBZKTOh1eMQQtLS0tEExqS1KlZqFBRRRRRZqFChSWonnLQpi0KFJqzp5FJWGGGixSDDDQYYZyow0aDMMMMMNBhpGgwwww0GGGeLRadoNFosww0GgzjDDDDDMMMMMMNFpGgzDNFhhhnGgsFmaCqLdgUxaFCk6eYhaWlpaW+QgnglxclosFFhnSXKfMpJUWk2eMgiCIIgiCIMN5DTsMMMNBoMMNBpEpUbyaDDQaLDDDDDDDDDDDDDDDDDDDDTMIIgiDDDeTQaDDDDDDQYaLQYaZhhpWgqCwYaDDC0VSuE3iELS0tLRBPBKLCkc5MloooosFM41hlLmlUkrDJaKLFYZzZLJSGeaCCIIZN5YTTUFg0+WQsWGgk6xYaDGbDDQYbyg0GGGgiCCINKwsjTZDSMNiLFhhhzqF8xsXIyylzjlXAStpaWFpaIJgpPkLgVKwUWCiiy1KzsUiiQTzKlYZQWFJq4qCIM4iDRaSklcNoJ5lSs9MRoNBhosM40jQYYYYYYrhtBPMrjVnoUkVTqFdSow0GGGlYaFZ6QzlrgIIIWlpaIJJSKRTAUXCWCwWC4bDTJ4poIggiCIMIg301hoMMNFhhosMMMN9JdBbzzWDDDDDDDCoN9AQtELVLRBFjlirGsmcywWClZqFJGGVRvHoIIIgiCIJiUKeKp4JhoMMMNBo0KTN4rqQW5x1gwwwwwwwwwwwqDYFJ646CCCFpaIoiiKOPBx8RRRYrWNJaiixWVosN5T0mWmVRRZaYbDCCIwiCIMNMvgaTZZVnpiNI0GGGGi0G8LkVwfI6jrFVVKpBpGGGGGGGFQVBhpkgmMkMsqyIIIpb5FqiKIoijjjjwcccfAUUXCyFoLHOi5wYaGUmYk2TDCwYYzaDYTCIIgiCIIgiSZeJymz8A0mWXgs/BdaHWOsGl8xhhhhhhhhhUFtFQVBUFlTwOVZk8hBBC0RRFHHHHHHHEUcRRFEUeVRSg7S1KzNgVKy0hQzEjUrK0GGGGjUrPSKIIgnmJ541Ss9J64tSuJWdsCpWemJSSh1IdZ1KpUadpWcYZxhhhUFQVGFQVBUlrJSNMGuCggiiKIolx1HUx1HUOOdQlx1DuOdTjjjjjiqKuIsioNBipWWmIwww0Gg0Gw2ESCCCCfpvyOtELrx1XAaRotBosMMKgwqCoN4tpEgg44ijjjiXDjiXHUdQ51HUdQ444444qvGslCkzY9cBhhhhhhpGFKFJvOCCeYggkKfQa4NPpvkdaC3qo6rK07DQYbAYVIKgoqCoLBcNsFoMMMM5UaSg444451DnUJcdR1HUdQlx1HUOdR1HUOLFYZyNHIqKKKZxTBzzE8hBhjpGG8mgooopQoUlqVlSonliZ49JqwrLQoUlr9EoOx1oguoOqjPgU8BSVRaKKKLDOkKYrDQYYZyoww0GhSFJHHHHHHOo6jqOphLhLhLjqHHFucWOcUhUqjRaDY+eaCCCI8GiooooosM8LOCCQr4fOZ4Lgp4p4Phuh1oeoOq4yeDUUUUUWuO0WGGcYY6RhhvNvNvNpapI44/minUJcOdR1HUdR1HUdUKQpGpWakKRaFYVnpBEGEERxBJlKQWNcGkKQRYPBxx5HHi8ajjyuw8lR4PB/Jxxx2HHi48HHg8aSPgvBx4PI48tDqQ62F1DqXHrhUkeFR4PBVFFF8GggiOMMMMMdIwwwwxUqVislIOOOOO51OdR1HUdR1DiyVwmnrgMMIkETBWCqKLFfPFcccccceDjjjweDjjjjjjjxceDjjjjjweDjjjjjjjjjjjjjjjwd4PI8rjjjjjjjjjjjnUiC6iILqHU87+GcceDjjwcdh4qLBfCMIgwwwwwwwzjDSNguOOOOOdQ4+A7Qph0KRZoMIgww0EGEQQpKqiiwXzKxXCeDjjjjsPBx4uPBxxx4OOOOOOOOO8XHYccccccccdyo451DjjjjjjjjnUOPBxx2i448HHHHHHHh1IguoLqHUsXHHHi7SOPO8rxcdxxxxxxxxzqHHHHF8AkUElYYYYYYYYYYYZosNBnwKDsOOOdQ4vmVlQTyKRykUWNBPKDCIMMMMNBjMoUKFIuOKooqiiwoUwKxccdhFYeDj+TjjjjjjjjsOw7Dwcfyccc6hxxx2HYccRRxxxxxxxx4Owijj+TjjjjuOOOOOw48HHHHHHHHHg7HUx6jHqKdSwceLwceDtFIuPBxx40EWGTjjjuOOOP5uOOOOOPBysVhnCk1Z0qnkIJOw0GGGGOkYYYVBhUFQbzUaFMBZM8xI1nzikUQYYaLQzzkccfyVfIWCimbDSVmeDwRYu48HHHHHH83HHHHHg8HHHHHH8xxxx4P5P5CjjwzeDjjjjjjjjnUOdQ4ijjjjjiqKo4451Mq3sdZ1LBx5XHg48HHHHneGcHHHH8nHHHHHH83HHHHHHHceCrh5ToIIIIJgMMMMMMMMMMMMKgqebDDDDDTUkpFPOLzUlqIgmJUccccVR5W8xoVgw09IoOOOOOOOOO0HHHKwcccccceDjjwqO44444447DjmbjjjuO4448HHHHHYccdxxxxxxxVFuF1GOseDyPI48HxHaVxx3HceDjjlBxxx4OO44444+FXEQQTzEHg+AwwwwwwwwwwwwwwxUYad/DpBikrjjjjjiqOPMwxUYbGeLzPBx4uOPF5HHHHi448jjxdx4OOOOOOOOOOOOOOOOOOwt4t4/h3ncccccccccceDjjjjwcfwDQYYYZpawcRRxFHHHHEUeasGiwwwwwwtowwwwww3iWw3FUccfCYYYYYYbEfAeLj4z4b4DyOOOOPHqQ6hbx1X6C48HHwni8j4jDDDDDDDDToo44451HUOOPhMMMMMKgwwqDDDDDDDFceo0lCkUQyg8FUUcVRx2HmrIwwwwwx0jDCio4osc8ah5pjUKTrLSFMNzqOpjr8XTHpM8HwUkrBhosMMwwwwwwwwwqRzoOOIo/kinUOJcOOIoiiFMFhYMMMMMdIqHSKgwuAkcosNHMSCUyyyHFUVRxVFWbKLQaDeaIIgww3kqCioKKKLgZSZwzkyyywEnWXNBI5TKp1MdU2U+cuWCiDTrhZVTwLDQaDCIMMMMN5MKgqDCp5qkqDj+T+TnUdQ/n1efUOIoijmWEwwwwwwqDDFIZlIIVEMspmGYYSFYZZCqOKKKo8HxEQRIsMZKKKKLBUKLCscps5K4NJEnWepWZRbmOrHaWsMpGM2GGgk6z1wKDz1lYaLDDCIIgwwwwwwwqCii4DjsOOx1HUIoiiKJc4iiKOPhNBoKgwqCpI0KlSsGhSDSNJWRxxxxx4KOVKyUgnlBBINOsKCiixrNTBqVxalZKQpiOgtw+BWSmFWZhot4mk1SsiSJOkyoNBRRRY1i8jjjjnUJcJc4lwijjjwfEYYYrCo0GGkYaDCJGokXi4444489JUEEEEnUUUUXwNfoLsdTC3fXq4KCCCYCTqKKKKKLCk7jjiXDjiXCXCKdQlw445UfBaRnGGcYYYYZhmGGGGGGKzUHYcdhxx4r5y0KSIJgUKYC+YslCk1Ss9MCstMSh1sdUWmrNSZsKk1ZaY1MahQpBIJhUmUUUUUUWFMFxxxFEURRFEUcccccceSmAtoww3m3mw3mwiCIMMN5ZSKPF4ZCr5O8FwspEg/nm/mO0FUVfJ/LJRRRRfJTOXLLCyMq42UHFuFu85sspczOCSZYWRlXEyylzmynzzggggiyPF4IOIIsjwVRRRRcFZnEURRFEURTqHHHOoccfzfAUZhUYYZhhhhnGcqmUtCkXHHcfyfycVR5M4p5lSqRSdxxxxVFUVRR2FUUpJUqVTKWk1YZSUhnFPMqVkoLcLdMmAsKSVKmWUtCktYZSUmqVK4lZcsBIJ5zOOOOw44ijjjuOOOOOKKZ5xrKsyQRRFHEU6vJxFOo6hxFEURRFHEUcceRhmGGGGGeDS0gqjwcVRxxxRx40nrgJ5DjjjjiqOKo444qiqOw8HhWFZaQWas9J6xc6zqPOFJc8estMek9cCg8mc9J6lSsiLB2HHHHHHHcccccccccWCyVwFmRXHEUccccRRxLhLhFEUdx3HHHHjWDDDDYLiqOdQ7jjjjjyPGpWR5UmccccVR4OOOKo/ga4lZeoW4f6LXEqV8PTwLweDjiKOOOOOOPBx4KL4FxIUEUcccccS4cS4S4cccccccrBnmoUkdxRR3FUVRxxyhTArJTBqOOOOOw7DjxeNcHIrGs1CmBUc6jqwqlZKeCyKxqVKxcoUwKyUkeWpWSk1cKmC4444444444448iwoUmXGeDiKJcJcJcIoinUOOOOPNnRZXFUVRVFUWqqKo7SVTKqS55zZZSqo7YSxzzlymWtJqpBxbhV8RlLnnSWqTZ0kyx8vF5YDiDjjlYOOP45xFEURRFEuEURTqHHHKQzzi444qqKvkqiqKoqj+eb+b+ecKmTmUKLnIkKoZYrxWGciYOZnM451Cqs6Qqhll4HORJMso5555yuZYCQrOsM5cpaTpNQpOnnB8WsqwzmqZTOOOOIoiiKOdR1DjsUmcdxVHFuFuYW4VWHHHYceDuVKy0KY1JlK41ZKS0kqVg51DxpgVmpPXGrJSWklSs1Mek9ZqQpiU8RXGrLQpK4451DjnUOOdQqwcVRVFUcccccVRxxVg/1xVHH+zTjjjjjjjjuOKri3CqOOOOKo448HccVXloJBI1guNWKmawpFhhhhhnFkpPWLjj4dfCUwKzUmrPTBr4uuNWDTUiwmDQpgVmoNLXCccccdxRVFUVRVFUfzcccVTJV8ngsFhmJ5CQQynotIJJlPQZigwww3kww0FGhnDzmVR/PwNJsp6CeUGjllLnnJllBZM6FJMsCk2RWTMoUw88DIaVosMMZeGp4PLJxxfIVRbhbh2HHHHHccceKxzgkEKwyhQWbJPOGUucrDDDDDCii4CqdQ8tMOhQzkyrgZ4azJCuDnPlChQzkyrDKOZngZS08E0GwkwFw2ivgP//aAAgBAgABBQL/ANGQf/1g9bkQ9ew9xYJq2r9679yiF2vddKiqhZubkLNVL/vNdclpq6634WluH+8l13SmrqLeuHoa33j19XqXF0NXqT7wbi/ptxrL+lfvBubnux9tc9v3fVXXH2i+f3euoyjKMoyjYDDKMoym3/P7ybjS6Fl2+l5fendXTbe57fvHcrJ7tT3anu1PdqLurhVea29bT3Snu1Pdqe7U09wt133e1Px8Bt/z+72p+PgNv+f3evR09tee2vPb3ntrxdC9J0Rz2957e89vee3vNLRutu+8m6tm21jW/QdbcdJ6956956956956957i8Tc3Fu6RRFedVYu3KILuL1FuVYpq3IW7otuS6bU3B6956956956956957i8TcqW7i1cK/WttLtyoupcsUuVC3cXIWa6Lg6ut0nr3nr3nr3nr3mnrq+BduEQXWuU6lg4mrchZuBFeN9/Si69x695695615695615615615615615615payqv6j3Oo6y7bU8voKq+DbetppanWkmrrJYXXrdgWXraaep1pG9WtwbNRbTT1EvmuuS01NdbsHS1ukSbUu6UmSa65LU1NRb8Cy9bS27qQ3K+eHofl+l6C7m1CzWtukv8Ax9W89W49W49a8XUuXA9W49W49W49W40dS5bpF3NpZrW3eG1lazC0r+m6OtrdOHp39Cx3K/swrbulbbupI33Jal963Lhbe+bcXus2l+Murf1Lg6VvTaa35Ye2T9MbjUdYaF/WkNT8fAaH5x3Go6w0NTqTwm6X9sdOzqX2iC7Q1NFbJdNXtNbU6Eks01uE2ou0L9NbJdvc9sN0slmmt57W49tcXWLbLtrvOOrqdayW7e5T2qC7UusW2Tb2Osmrf0pPt/xk17mtiiOW7dEPStLtuhdYtpZprcaeklsdXR6j21x7a49tdLboKqe2uPbXCbZS23p/TGp+UNpHU/HwGh+cdT8obXwu7XzjtU84aiPbJpfiat/WsdHS6xPKK2uXW9Kx2q+cNwr3R2qRVHNbT6Fjpq10NzfIiOaWj0SXWJcl2mtpbo3XFu3RJte91jfZ0pHbL5SblfOOh+WHcrJIiMn6b1PyhtYr5nt7D29h7ew9vYLt7TUs6Fl0tHrPb2Ht7D0LD29gmjbasdT8obXwuur3x2qeUNa5rYoJ5G4va2NqOttvSkm5T90dt+UL1dY7dGsjuEe2a67qWO308XVv6UjpWdS7mkdsvnJuPyks3Al6Lha6/tjYj3fpzU/KG1wd1Nofhgan5Q2vhVV1joo1hdclpravXJt7XuNzd+6O1t85d1WO1/IuVkktRkjr/hLuLmtjajrTF1r+pY6FjJuPxjoflJuEnt1rkLNdFwNysm3T936c1PyhtYqrHr2Hr2Hr2Hr2C7i01L+tZdLV6D17D17D17D17BNW26TU/KG18Jqq1snqXHqXTaWn0IXq6x26NZLuV/dHapDcK1kdNHuk3K/tjpo9xulk2yfuxNa/pSOnb1Ka34x01/dIqOX2dOBp6q2iK824X90dsn6d1PyhtY3U8BoflG+sNr4Tcr+3BZzQ0OmFy+Umn+Mt9zrHb2tabpZNun7pN1d5x2yfuNx+Udri6t/UsdC1kL/xwVRy/QFRp9vdNqK90dBP2/pzW/OG2/KNyMuPtk85ttTwe7XARHLNtcpZpJZHV/GSz8ZNxf02xtR1SG5X90dqkiqxdd1LHb2taa35x2uJr3sknrXHr3HrXS2L5TVF0bVLtFUl0vykpLajJ+nNyn7oaStdHcWtdj6FrWw1Va2Ogn7fB7hXvjoaKXJ7aw9tYJo2CI0t9JNvc9sVVjUv61jtbI6ivdHbo1kdfV6pNOzqWG4/OOjf03SKqILuSzXRZdS7qXD0l/bg69rSaX5Saq/tjajr+ndynlG250hrWdSY2nb1LHc3SIjeEuV1joo1mDcjLGy9bVt1rbhy7XtQ1NVb5LLepbbWQVWSSzVsRPXsF3Npqay3y6On0pDdJLpa7CXoo6F+4tQvvW6Nmqtsde9kxNCkLr0tL9VbhFYs1njQ1b+pY7dJdwvlHQT936d1LXtjtrpNfTbG0tPpSN93UsNG17vB6itbInlhbmzDRHNHS6Ehrq1mHo6LSatnVbh2WdSwvu6ljboqp7dT0FPQU9BS63pWO3hfd0oqvIlyoepcKryIjltvSkmuvnHbJ+n9a3puharLbc6QVHNXS6cTR0mk172SO3tZPB7lWsjoo92FcjpfZ0LgW2rcaWj0SbpfLBttW40tDpm19LC09Jbi21LYbi9pLUdUl1vyjoVL7epFtbBRHNPT6ZtRf3R0E/b+ntezqSOjqdMio5qaDYKI5paPTJdd0pcrrCy3qVPCbpHtjttPEutS4v0FSZEVSzbKW2pbLukwE0blLdsIiJgam3cusW2a3SuUs0ESTX/KOjY02vbJoWxutS4u0VSe3RVS2xLZ70ZYW2uWoyfp/Ws6Vjo6st+klxdoXILaqSJp3KW7cttRJFVjUv6pNCxk8L6dp6dp0W462op7e09tae2tE0bUETA9O09O09O09O09O06LcZdG1T21p7a09vaJYiTKjnQh0WnSiYHQh0IdKTKjno2noIegh6NozYKo50IdFoiN+ob7epFRpNLXn6UOi0aZbkQ1NTqk0dPq+7Grp9UunrdJbci4l+qlpdet0mnZ1KiN92dXS6pUuVC3clt6LgXa1qF+uqy2WLcW29KfdrU0uoVGmTVuQTcXHuT3J7lRde4W5Vm09Jbi23p+7t9iXF+ituOzmnofeG/RRS7RuTDRFUt26ltiW/eRbEUXboLt1LtNbZPQuE2wmhagn3p3P4/e/cfj979z+P3nvv6EXcXHr3nr3nr3nr3nrXnrXl2ot0nrXnrXnrXnrXnrXnrXnrXFm4+7uur3eD26+X3b17Wu8HoWsn3butS4XbKe2uPbXHtrj21x7a49tce2uPbXHtrj21x7a49tce2uPbXHtrj29x7a4s27f+Us3/j/AD/e1/vY8H+9j/exx/vY4/3scf8A5tP97X+9r/e1/vY4/wB7HH+9jj/exx/vM8zj/etxx/vY4/3sf/5tH+9rj/ex/va4/wDzZf8A8UR/+cf/2gAIAQMAAQUC/wDQmm++zf8ArB6Wqom3vPbagujen3r09rdcWbey2VURS/aWqamldZ95rbFuXR26WYWttm+8ltq3LpaSaaYe40PvHt9LoTF3Gl0L94Ntp9V2NqWdaL94NrY1mPurWu+79qMmPvE8vu9ZXqQ6kOpDqQfAc6kOpDqQ3LLZ95Ntq9aS7nWV/vTs7Ztza1/3jtTqX2aHs0PZoezQTZ2iI019iXHs7T2aHs0PZoau2S237vaX5+A3P/1/d7S/PwG5/wDr+71itd7qw91Ye6sPdWCbixZ1Vj3Nh7qw9zYe5sNbXtut+8m0vebdXvd9B0dv1Ht7D0LD0LD0LD0LD29gu1tLtopdaqTojlm1VS3b2IJaiRXStUu2pdats2nt3Pb2Ht7D29h7ew9Cw9vYLtULtvcmFZo3XFu2RBNO1Irail23tUv0FTB0tDqPQsPQsPQsPQsNTQRsC3bqomjagyQYXStUu24qNGyzqVNC09G09G09G09G09G09G09G09G09G09G01dFET9R7XT6Ul3Wn5/QURsG+xLjV0uhZNLQW8ssS3AvsS5NTT6Fjpo92Dfppcamktk1tq3GnoJbg6uj1T6dnUsyzW29S2aaW4F9iXF1vSptk8sPW/H9LoJtb1L9C62TTT93o2Ho2Ho2Ho2CaVqYHo2Ho2Ho2Ho2Gvp2pZIm1vL9G6zw2ij34WrZ12x0NDqw9SzrSO2T9+Fdb1Jdb0rGyxblssS3D3GnNt7GSbV8rpdOzpTB1buq40fxw9wv6Y2umyQ3Gn0XQ0vy8BuPwjttNkhuNPou8JtE/dHUv6LfeKJvDT1kvl1Ea40dPrWS/USwXdibtTT1Uvl3NrXQ2iSamolh7q09zaW3pdLubPKDGlp9CSXbi1D3SibotvS6TcXskmlZ1LPr/lJoWvdFVYu11PVuLdwpbelxdqJaX6q3R09bpPcWnuLT3Fst2uiL7i09xaLuELrur9MaX4w3kdL8vAbj8I6f4w3nhdmnlHdr5Q01a6TV/M0tPotjra3QKrxtu6Sy7qSO7TyhtkayO6WKKxo6nWkdRHthtrJFVjV1uuS29bVt1EuLta20u3CrNoWdKRsv6ljuaybdPKOv8Ajh2o6yKrr+m9L8YbyKKx7m89zee5vPc3ibq809RL0l1tboPc3nubz3N57m8u1rrkjp/jDeeF26NZHdr+6Gha98VVhVc21nVdG67pS67qWTar+2O6/GFiNbHcL++O2X901lvSkdxqYujZ1LHVv6U21Y7lPKTb/jJftxbFTC0U/dG9WT9OaX4w3mDs5tx+eBp/jDeeFRGSOur3ltq3Gho9CR3N7Wm1ta2O7u8pdpSO6/EsR1kuV1jofnLt7XujcrI74ujZ0pHXvddv+Udf8ZNus92japdoKmBtkk11/b+nNP8AGG8iiOe3vPbXntrz294m2vNPT6El1tHrPb3nt7z2957e8u0brZNP8Ybvwmkj3SenaenbNranWpYjJHcK98u1T9kd2sNuj3x1Fa2TbJ+6OorWm1STcr+3E0bOpY6l3Sho/lHU/GRFYsv6sDU0kuFRptun7Y7lf07pfhDeRsr4Dc/hGz8Ybvwm1T9+Cqsa+v1QtTzk1PO6Wy3pSO5ue42iSblf2ybW3yjuV/abdP2R3WLpWdKR17nU0/ywUVizXEV59e2bTRrY66/u/Tm3X9kN0n7Y2q6Y+6Xym3f5eD2aYCqxfubUNTVW+Ol+Ul/5SbezqujcrIqvDap+2O7WREctt6UjuLnuND8I7rE0LHWT0bT0LT0bZbk85qCa1yFusiy6v4yIjy3K6/pzar+2Gsj2x21z24+4ue6Gij3R3C/v8HtkayOvrrYvurz3V4uveKqrLZ+Um5sa6NqOaWn0JHdXx0ka2O4X98dDR6ZNS/pSG3/COtZ1WyJa4m2L9BUl07OlMPWT92DoXPJq/jJpJ+6Nysn6d2i+cb7elYaN/Tdjal/SkdrbJcrr4OxGSOur34NlzpG+xL0v0LrRlLNC5TT0kskvv6Uuu6lER1kv0r1X0LxNtcaeilkutqdaw2qy6ug4tioJapZt7lLLEtjfpJdHQsdcTXrC2xbizSS0VHL9FpNKzpSOusu3Tzjrr+39O6d3TdHdWSbfVfG1tTrWOnb0pDXua3wemj3SKr4W1vw1VjW1etYaCPfh6+u8mlf03Yd9/SkLLelI3ayIe4Q9dD10PXQtu6kjuIWW9SojSLainp2iI0iqxdc6yaCeUdwv6f0L+q2FyOl1vSsEVjS1evE19Z5NvY6x3Nzr4Pao98dZWswrVZdPUS9MC65LTV1uuTaJ54N1yWmrr9U231sLU1UtLrluht7HkuVkl0Pxjr0LbulbbnwtTU6ptNP2x11/d+ntC/pujr6XVIisaW4fBW5ENXX6pLLOpbbelIX3dKKvhNpc10d1q4lty2lm4RZluRC/dIXXLdLtFTAXWtQu3QqquBp7hi29LprtW1C/XVZND8Y62o82hdJr3RtuW0t1kWe7WRC69bp7FdILcxcrr+n9DU6kjr6MtmtdaW7m1RLkWRdS1C7dF1y3SIjmlp9CR3Gp1L4X1Lj1Lj1LsdLlQ9xce6uPc3C696j4HqXHqXHqXHqXHqXHXdjJrXIe5uPc3HuLhb1WZFY67jruOpcDrU61OpZkVj1rj11PXU9W4d8FFY61OtRVf9Q2X9C23Okdbbz9aoepcO81tq3GlpdEmvqdKfdfR1ehZNXb9RdatuJp6K3lliWyamp0Jcrr92NHW6ZbrUuL9qXWLbgW6F1xZt0SW/USxL71uX7taWt0FtyLMulaou1tPantD2qCba0SxEm1NVLC65bl+7ll62mnrpdjqrGpuPvDp691pZr23Ya3IhfuULr1u+8lt62ibq4TdWlmrbdIu4sF3Qu4uUVfvTtfy+9+1/L737X8vvPp6a3qm2tQ9vYe3sPb2Ht7D29h7ewt0rbZPb2HoWHoWHoWHoWHoWHoWF+2+7u3ta3we5ta77t7a97fB7i57vu3bctqpu0PdWnurT3Vp7q091ae6tPdWnurT3Vp7q091ae6tPdWnurT3Vp7q091aX7l/wD8ko33tb72sN962G+9jDfexhvvYw33sYb72t97GG+9rfexhvvYw33sYb72MN9u2mb6Uww33sYb71sMN97GG+9jDf8ANlvvaw33sYb72MN97GG+9jDfexvva3/Npv8AwoW+1n//2gAIAQICBj8C+zz8ixYv2uDyI9mdcbft7I+Vl9xb3B/ref0vtTe7QVvX10U9fXRT3B/ZXM/wTILFixYvmRGCC2JEGb9RYsWLF5oF5mQs4YNOgy9kYzfFwecEZ40ZO+V8T9sUWLFixeCxYsXurnZNpw5HyMZjpvP1hjLooRtxhYsyHgSovCh5K2OBJH15FCBJXwP1xeV5XVXlfgUN+CMGxrgTltZO9Lyuo5F5X4Zg225H+AkR2teVwpnXldlOJOxH1VxNuP3FeV2F5XUUti9Zc6cIm2myvXV5XbXfdbOhnMiYWxLovwuOMDdnX5JEyqVMLHUrmUi+huvNGXE5H5XAyEbJIjwdyPrNuJibI2BnF4nKy4m05wP2tiPpP8M+267jd9fRdSMR9hNWM8BzOmVvCGLGKSORtl8kiDyIK+GRGCBJ5wOZyP3tlySIwvrUKFZ5y0KFChQrZoV8BQrs7Lgr2mRGk3rLoaRGdvZKFe8T7dIj2efrgTjn6XrCNKfttN//2gAIAQMCBj8C+zz8ChQr2uTSIE+zMg/OJ/19kZMv9J7G/wDuZ/8APcG/7RbQRfX092k38p7Uq+1MLFixeCeLFiw/r6aK+vpor6+mi3srGb4J1FChQoUK4gTgktCBJn/YUKFChWaRWZ1LGGTQRsjp2R1M/wAXJvwIwTnnRg7a7dokiChQoUKwUKFCg7biY2I61jbOwbQcznXebrH9GTRUj7jihRlPIhBQjApJ5gr45EEbXgWJEFbA3XE5TlNFSJymqp0KpvyRw5EOiYF5fWXvScphfGykTlNVDpicPkTOxG+AgT2tOUwqZcKcpsrxB3IxlzpifcbuKcoShQoVw2GhQcicpqIWhWshlwrwq7a92TlNhOU32SjqZjKuF8SaLcJjnA/Z01221XDAnlCrhc6IRgxkIniCkbTTcZObMmFkDE/nlMDqR8s+DsRtZ9hiLicjYHDndhWJiumJ9OMDdncn9EbSbXRM7bbJuP31gxPzkZCORthcb4pK+KQxmXHPD+EOWcMiCMG5fZ/lMkCTwJK2GBOCRB4wMZiN3t0yQJwtrWLF54y2LFixYvZsX8BYvsbkdMF5G9dgTlgr+sspZECcMmf1v8CDVxYsXxB39djR/wDPtsiBPskCeILCfW1oUKFChQglChQoUK4j6XroJ0o+203/2gAIAQEBBj8CkSCTqFlSZemRZEmXpChdqoXkiTV2CbBdsvKq8gX/AIX1ggTvBDCBIqFChZ06ZFChQsU64JtUCBIbpFCxpFIpIoXYVmWZNukN3IlChdmoULyVJl5Mns5XZa7Gk/Vs05br7A6cjpPX/jFYLMkyzoECSqFCyIECBJFCwWVAk6hZkgki7FNmgSZYKFlQJtkmWZAkE2aBJlChQsqQSVQuwSdfZFJNNggQJIvJ0lWK8jSCSLyCk6cgT2IT2DX2X0BS6y1gstNgux12dNhXbr7E1/8A4C1ik3UFChZEikqhZN8EHXMoULtFgsKRSdYLIk6hduu3WFNksF2ihdsu1XYpKuwT2QWfWbSHkHWQoKR1jUVk8YpCkusKw0kpLrCorNSTWbSSgpNWam3ptqci1jWOg0hSFNrTb09nq7WorFSloECBBuFRUVgoWNIJJUVgo0gsKRQJKs1IJOoWZAkKyKFlTYLJTlySV2SSVhULsE2lOQpMvsuuwSZQoWdNsm1SZdssF9iF2qhfYROQJMvstoNI0FNgoUaRpIkaioWSkEnXpC9MxwQ+5GorFZabBZaT15Auw1GsK8nSKRryjWNeT0ggTlmvJ94QIEgkVChQsiQSdSmQJOoWRJd0NwULJvCBAkqhQsqQTky7VZ05WgTYLt1lQJOoWVJ15Km2TaayVhWK7KorNSTXZUFJNdhSesK7SvJ6ewNRXk1OUrGk1fYqvIFHjhSCQQIKwrBduoWVJ1Cy0CbBZ0CckUL7BJyVZkCbVOTL7LboKFlQIElULMgQJszCBAkqhdqoULMgSVdimzMJBJV2KbRAkyzpBOVJsV2yhfZmktYVFeQr35aBNqktZ6cpXl9P+A19mesb4IECTKFCyIE54JKoUL4JEgkyhZUCTLBZkCTKFCyIE26TqFkQJMsF2yzJBNqm0TYLBdqoWVAk6hZU9glm1lrFQoWNIpBDFZNAsKQpBNgsKclrKuwrMsybOnKV5InsWnszWKhYUFIpCsq9+XfBI1iuwSZQs6QSFZqCkUmULLvgkawrsUmULyxZ02ycvSZfZTdFZkCBJFgoWVAgSRYKN8qTKFCzpJuCxWVAgSRQoULKgQJIoWG+VJ1C8kTbJyVeQLtFChQu1XkqcjWFIUmrFQpRpHUaxrIsKT1kWWm0oKCkdY1ioXY6iu1ry2sVCltl9jqezCBAkqhQo3jyDfBNgoWVJ1CzJBJlCyoECSqFj5IoE2qTrsUnWZAnJFlQJ7Gp7KocNRqKx0ChY0FI6iorL4wvQKbGsiigoKQQ4IE6ZNAsKCk9Z6SaioqKyKF2yikKbJY021JqyqFFNtT/AIbqKw0koKBAgr0DWFYqUaCgpBNpSWsdIaQoKQpJUVjpsdY1moKbWgoEkryvXY0FPYqgpyOu3ry1QoULIgQJKsV6JUCCsN0FGk6TrOgQJIoUKFkQIE2qbZJ12CTrKgTbJMuwT2LTkq8qWFBQdUdYVFZPHGk9Y+ObWWorHSNBSasiwoKDqjrCorJ440jrJXbVnoKbSkOqWorsTGu11lrJpGnLKey++KBAkixWRAgQJKsnXFAkyhZU2ChZkgklYrKgTaoE2ibdNisqTryRNgvJ09lNYIEGoqN0FgoWFIoECdIrJoFmSSorsUCBBWRQsKSpOslJayaclQIEmXli+wiBOSL7I1FZ6Cg1CTV2dZNJKQQJOoWFBSCbbUJytNgvLqQpBAm1TkCclWdI19jVChYp1hAgSRQoWTyxSTcFChQsN8UCBAkV8AUKFmQJDdIsFigQIEmWZAk6hZkCSrBZN8EnWZAkqwWZAgSVQoWG+RAk6zIEnULOk67RdssFmTkZJsU6RWWg05pkhWRSC7VZtZaxLYp0ivsNrLXaJ0istAW002KcnpsdPZzeECBJlChRvkQIElULKkECSqFCyoECbBYb4psFlQIElXYIEmULMgSZZ02yBJV2CBJVCzoE9hF9jNYINQgSVQopIgQazKFCyJBDhWRZd4QJLoFgsqDUIElULKmwUKFmTaoEnXbLKmwUKFmSZYrFAnJ12qhdsvsB4o1mpIgSFRWakKRSNZNJKS1FZ6R1Hi2NJECQry2vJKSp7D0/4N3BQoWTUIECBIboqFCyoECCsVChZkCR3QWChRSKBAgSO4LBZNQgQIEmULKkyhQu2WVAgSVZ0CBAkyhZUmUKFmSZZ0CQSNYLBZknXkqBPYDSbUIECdIrKooKSahJlC7BOkJIpRoKSIKhOmTQePY1npHXkKS6bGu3rtEgkihdrptKxX/gpOuCSqF2B7WkEmWZJ1Cyp17BdgfK0nWZOvYLsDhrKvJE2S+wCew/XFIeIVhUKFChegL0DeKBJ16QoUKKTJHSCkFFJEgkyhY0ikaxWCwoN4oE2K7BJVCheiFIJsFCxpFJlkpslgu1UKKQpBJd0V7+wQJMu2ULKm3TbJOuw1FRWGg070KCkfFGoqKw0GgoKCgpHXuCorCorJQUFBrzTVGg0kpPWOg0hSesKw0jQU2FYaS0FNpTZabSsNI0FJaxrDSWg15paisNJKT1FdrUV2teWV2tYKFChe+FjqECRqPJFShSRAkyy0igSFYL1DQKFhQ4oYSNYqFCyoEhWKwWZAkyhZKRQJCsixpIg3CsVCwWVAkKxXYIEmULJSKBIVgsF9h68iXlGkFFIUkSFRWZdkUFnQIKzUnTpCdMqzpyVZkCCortU6ZlnTlaBIV2qctT2ToKBIayVk3wToCdE6hQoWNI6xrCsdIbwgQa8w1jWC9IULJQUCTVmToCbBQslNisqBBrJWC9IULOktZkCbBQuyrsECewqyU5CnKUCBIJ1RUKFChRvgkElUKFlQJMoULMg1mULKgQIECdQ/hMK/lf4Vtz/EQVnCLpfnmxn9ZxBf5Uf01n5YM7nB8nTn7DPWf1FBtu23WnlzseSH4QoWKQSZQsqBJ1C7VQsyRTqisFlSCTKFmTbJOoXYJyVZUCBJlCypOvJtZKjSFIUFIaxqKwrLQU2OklJ6yaSUk1gREXnHzEQZf4g7+WYx69lxLed+j0d3vAjt4Lcm8X/uMn5x3ePzS7hAiaSEXMRSeqy8a1lW/cXWk4vCHP4e53DL/Q0vPtfBPUu4YTNsLYM0t5lvzrR93o7s9YeSSkPKPLNpy6kKbJZKCkPL7BV5XXltZ6SVgoULJQ4IECQqKisFmQJKoULKgQwkqhQslAnQECBIVhbxMGyd6/c6Ogi6zPoINyLpFmcT9tkuLRlLZdG/n2L7N6227auEly28laZVIxc4hwNhvst869w/nc2tvrKgqKkKwULKgSVQuwSdZk2yBJ1mQJKoULOk6yUCBJ1CheVqF2i7BJ12qhQsqBAgSKhdgkm6CzIECBJVChRvlSazhYdv1l++aNLq6zOhArNkiuZNxDy8tNXn+Qugtpd43wq0j2+fxDEb0l03Gl4++F5MkyhZ0mWdAgSVY7+UqF2q7BAk67VdqsF5Ik2kqSVhUKF6QsiBAhjWSsVlSGoSNdik6xLLyWf/ZZzSO6vPbZzkz8v/42xZuIzs8Oz3GjS5rdznNu4+coIE2ybHfyNJqhQvTyDT/gqgSdeRbwkECBJFCyoE5wgSRQsyQQIPLKsF8EUCBAkqhZG3bze1icOS/eI+Y3e0b39e5t8rh939s35p/uXlq13fF3HvN7N2y42XGH0OaaGQSNYrFeiVAg8sqzIEmUKFnSVZ0CBI7tigQJMoWVOTryVNqgSdQsKRTaayVFRWGg8g8goKCkNR5Y1k0jQU5UslvIMkvcRed5x+99FngJe7yA8hhdm1xG2V79MvNf4l7sKz0FOS1j5I02FYaRoKbagptKcp0GmwT2MqK7SoUKQXvhRSFDFIIECdI3CpRUKFhSKBAgrs0CSqFCyoEMICaWpnzEMTEb6ONZZaL9Bqcg4dmJ52PkHb7lxq/EjpMkE2iSVgoULKgQJyxI1goXYJMuwSZQs6BAkq7ZQu1WNIJBAkKxULOgSGg3RUUlQIEkWChZUCBJF2CQSZZUCBAkOHMdo12TaJ5n1G8h97s/DaPvdn4bR97s/DaPvdn4bR81eZcTn7LiPYdl+RbY4udpuIh97s/DaPvdn4bR97s/DaMrsX7dx9u5ac1rXEZ+mReXbLBZkCTLMgQJyOoryFIoECbdNmmwWdNgvJUmXa6QpPUVio0jQUmqKx0jQUnrPSBlJUVjpCkG3bNx1m4zVlxh9lxbjIXrGa7tZ2AbSfd/tGO9F2/TWY+CcPvOxyttI866w0cZuJSYvQSBenp5EpBYUimwXkChZUmULtUCcipLXa1FYLyY+QVFdtWKxQIElWChQo3xQJzhI+WKhYbwnWE2KhY74pMs6BIcT4i9pts3OzYsn7oy1d3tJsjIcR+pzybdsP60aTXF3DKRQopOgSakEjUVnpyivIqiorLWRSCwXaJFJ1gs6SKFChZUCTrOmy3xQJMsFjrLUVjoPHCgpFBqKisqhRQUggQaiorCslIUggSXQaS0HD8J7jazMybVlzy5yK48m+UfieT3mD8Tye8z8g/EsnvMH4nk95ga+/k5OU1v7JWsI96Eot4+NabZsWi7Nu0wkIimPF4hYK9b52HzOafW0+gGdviGUxvuT7B+Qh+J5PeYPxPJ7zB+J5PeYMziVnOv3rmN6vs23k1D7dxrOjft0lULOgTYLKnIEkrsVgvKdeQ12NJ9JabCsi7Gors6ioUKUNIUFBSSorFRp3Y0FIIEhUVGgWOkKQoECQrLpJSKDgn/AF+N/qt5DxX/ACP9e2ECQrBYKFCy12tRUV5GoWdNjXZJta7Tx8ipsVClsqivKUkUKFCzpIsFCyIEgki+AKFl3hAgQJFQs6BAkOB/9fjf6reQ8V/yP9e2KyLs1nSZQvJKbJeSIECciWZAkyhZkCTKFmTkyypFJqCgpHWcjFI0jrCorHSNJdY1FdrUVhwvLvGlnGy7N284tfNY8jMferv0L/yD71d+hf8AkH3q79C/8g+9XfoX/kDbRcQ9S53oneY5jfhGSECc0+012pGUz8jLvsx7Fv07tw0IG0s1709s209PEPvV36F/5B96u/Qv/IPvV36F/wCQZ+DhX7j8m/6r1bTtub6N1rj1OhBQo3gooEmWFNlps67TzGG9OdCXYLtN8ECbEu2xzDPmUk2FNlTltORa8qSVQoULDfBAgQJIoUKFjvgk6w8kqBJVChZkCDN4VfedxuF2bmKZ9DXKRt3LM/h3bMsXhpNJtvoN7mk5zvCkywoKR1FY6SU2lBQM4jxR72Yt37tjM0c8vdOPoIdkuFtPfcuH43D8KZ8J/wAofhTPhP8AlD8KZ8J/yh+FM+Fc+UNOHG0/dFeveV4M7N3JxndCPJxf0i8oc/h+VbziL9k75p/hUvCDsZmO/GvFz27hIc7cfGsvyLz/AELdslMNucTyG4LD/YM+cufJLwglxDzHl+0yHG7+iSN8ATHwrFj/AA7bW+Iodm4xtwupxKD9fwuwp+3tt9W7vsQOucHyzY7oxsjUu48ubukDxs7HdjXi6Hcxl1kfMc1rN4ybzO+3t28Fp9lGnzds+daD8M/fXvlj8M/fXvlj8M/fXvlj8M/fXvlj8L/fXvljTAdaq29d8rjB/Zc3JxndT+zcb3kafhDn43q+JWi/s/NufAd5DMPtXrbrV1ho+28kMt5HGszblvH+yYrtSysjzSMvelzmGu4jkXuIXOlpfNW/B53hBfZ+EYrTLme62T3fCcpjs22NY3qaSQTJ4djX/wDEtNd4yBusWrnDrp+3sO83utcpd5A+/jF/NMRupvsl840q2/yLsWcR4ncfjYDv1Fpn6y6RdKnzECI+Fm8y9sd+95Hj8J/f3/rB+E/v7/1g/Cf39/6wZGbwQn49/GYdw8Q3G9j2t1Mi7SuI+7BJmWrNt129cNLdthK4zoRBt7it8uGWj19QXn3j8jf/AFoCXB+23C/aZLjf/R0b4ARY2Dj45FzFatNZ4igl+xbvFzI9pO8Yd6zhVqy4/wBpj/Mnv8xCDrvBMz7Qn/s8hCd3Hkhd8iD8XNsPxsi36Vu4SHFuDjn6tpF28jJMlK2wun8gay/i3M24XpXrl17T71s2kPwn9/f+sH4T+/v/AFg/Cf39/wCsH4T+/v8A1g/Cf39/6wfhP7+/9YPwn9/f+sH4T+/v/WD8J/f3/rB+E/v7/wBYLvFeE9rHLG7P2jEc43tNrj7KtNynosqhZ0mUKFlQJMoWTXYKQULBRQa8wQIEFZVgooKQQJHdKsKSIEnXZZPEMy2dm7xDslYtO0MrbV1P85ZncatWzfh5hN+0PL9ncaXZ1oabLUVgsyBAkd0FChZbdlvp3XExm89BZx7ZJbsMbbtlRpIWxPGzrBXWe0f7Zh9bXdA9U8/W4t/XEyU9Iuo6lKV+6Z4fDiPXIMvOfS2XlBWMDHK0Xt7nO9/5ztg7FzrJXGH6D/bMPrafQDx73zli5ri5PQ9v5S6ZOG4ji7TL2Qwrhe9VXeDZerzbBesIvmspmlxm4/IY7N4vW4t0/wCGzG8zqH1HBYLBmHgWDv3n8/U0utx9BBmRmE3iPEOftuL5u2fvGn4z8Gxu5vDmtxeK+kfQy/R3Ude+LuPftnZvWnGy7bdoZOLnKbFwG6WjPt5b/c2m+kfk3hlq00mW7TSZbYXMRFoRSoepGMnGPnx7r7fwTSa3g4LO1cfq95+ixvS5x9QL1LPX5zi+fz3l5x9ZN9yX/o9h9nzrXnt+75Tf1ls6H5Bk8NyTJ1ywfm3G8z2nq10OIZxtR2VkerI/e2m/lce0zy9tkutWWd15O8RbRI7uVVChQvfCikU6AkElULHQUhQJCoqNwUKFLuyUCBAkaisdINtWGOu3bh9llphK4zoRArjyx8PtFpbv3D7X9Brgd3KxfWYpc+TZPtsLf0l3SgkOEY95hXLV7NsMusPmc11wiMh+DY3wR+DY3wR+DY3wR+DY3wQV7H4TjW7rdW3PVkpblnNj2k5riRzT1IyBuPg2Kp86WyLwEPwbG+CPwbG+CPwbG+COJZOJw2xj5Fv1Pq7zGoZLeYR+AwgSDLNm267eeaW7TCVzjoRBtx5Y+GupW79w+1/Qa4euysX1mM3nybJ9thb+ku6Uacj4TaMl7N71p/5Res8mzysTsreJvrMQ+q630e/zBDLXqi3iPEWG3h1s/m7XN64y+KG27bSt22F2WMaSERF0EWyvYb0K96eJdP2twub/APIuWbrTt3LTjZcYfQZaGUbdxFLDs3Lq7/m/jbO9g5bO3ZvElWn0OKpDIwMj0rLvNf0PYfouLfCkLWDhtVz9bl0/Rtt6XOBYuGxXmn2jJP07jus/ybP+f47ezfx+yzOIvbsM+y128j03bpv5jfYmXxTziXnbZL0C7vP3p+NM5lyn3PpPP+NK1ltpve8+yxhc5mYZbc0jz8kifn3ffe4Kjdi573ExjCV7z0IiLpMZWXi64zCbZsP90TPbd04cKJmvrGPuOOrnuPacL4aTvPc92TcZRpdhvjOfXlyQ3BQoUKN8ieEIECSqFk3hAgSFYLBQsqBAkd0Fgo3wZxi8wnZucRnZcf7O1zEn53PBzHtJzXEjmnqRkYNmMXZws1vrsZvuNfOZ3AkOB/8AX43+q3kPFf8AI/17cjOM3mdrNzyM7Lj/AGdrmJPzueDmPaTmuJHNPUjIx2cZvZws1vrsdvudUczuBAg1mWdBrJk5Rlpi4xofvnuIi8CyZPESYV19rsFbtO5nG5xEPwyx8Nw+f4Qx7feXTb42mDt4znWcppK7Eu6OTrLoOXi1hmjLeXdJm7tGkCtuVuFjI/NuF1dDSq4W7NlhW7VppNt228xEXRIR52Qlx36vGZ51x3c/KDLB4W0m9D771/ot/KC+1cLtXGdPqnmw/D2gZ4d3s3mEt3EuaXG1TpLdKeQwkt8Rtle/TLzX/l7seK5pl/Z2WH33O8klrJzWXbjb1z1TGWSI3KhmvnG3qH3TP+Ba+tHZfazLBe7fban9F7jHa4fm28lNXMLR5b2mhlLjcXY35zEd6nIP+7fzd53jggt2LTDuXbriZaYXObj0IiDbWj82+js6/wBbvclRshucZNa0lc4+YiDrWL2+KXm6H6rS38M/IRj5jhePbZ1Pc5598uyCbxHhSM6buO/Uv0XflH2jh2SV9pfrGcz2H1OaepSXeFE8n53EOz80XOy2Ticbj7yFBY4+IZfwtv53NP8Aum85d3mBNaXZa3QiKe9c/wCasWbveLsfEChYlk3C7VjhbPX/AOZzW/y9yS/m5dz1WPjN7d19A9vCybw3GX5s+yT7plU3KRdwu6O1/OshepSTvBreK22cRx/bvIit3S3IjT73dDb/AA/Kbd08+zzXGUc3nIOPMySdf9phW/Ouu7nR3Q612vsfDl83Ctnz/wCI723iiXDc3Fdl4dszPHfbNHs7RqZIehkoJcPiBH0+Za+tH3PiH0dr60fc+IfR2vrRavE1zCusJ/Yd6RKSocmTw+/j5l29iO7Fx9pls2rRbhD7nxD6O19aPufEPo7X1od9g4Zfu3PaevNrC7vZN4vcQzrnrL97q0a0i5mtLqLZqF2CBJlCypBNgcNYIN0qikKHCkU6gkKwULtln4J/0GP/AKbY8CPp/if9qPA/+vxv9VvIeK/5H+vbCwUcDT/kMb/TbHgPWf2r/aCTKFkSCQrLxHMT7xfba7lpq/HkwcRdcrI7Z1bbb+VxQQcNv2jMnsyLfN0kZoZd0peMvVUy7rV/Nd2fIGtYRuc40JpdJizimRfabnzma/ruH0dzmkLHxkfxPJL5oj1K233bvIH38m66/eumr7rzUzOCCzmYr/V38d3aYfkOhjE4hZ0ZlWyd2eo+Zze4eknDcvps5DrS/wCI1fiQUWbnMeZeuXj7/Y+JJwrCI/Qt3Lz2/nGTS/qnFmRjXXWL9o1t3WGhkO3dRudimTMxpdPU8vzpOK4xkpvxrhs/OaXab4SCBBc45kMVmOZ2sIj937Z/cLSS7lZNwrNiw033bjuYiIPsWHOxuFNP5vHLQ7ie2ufkkt52Fc7L2aXLftbjOlrgzIs5tq09PnsW68m3GH1GR+MGT8wsy+XNjYqXHd0/RLumHW+HNbwuwfS3z7pl+efN3CD712469duGty481cZ1M5W5V5qZnFEvXV522/2be9r3ZP8A9hxbTlxeG+otY/vj+c9Y7v6ScJyv7bHfaX/Dcvx5eI5aI7IyvVr720wjL+ucmR6gjNrL1p2SRf2ZH+VJ98uBhf8ANZFu0e5ziI5FPQi5zGdmqv2q/cur+e4z9jUCbBQo3xQIECQ3SKFjviktQoULIgQJHgf/AEGN/pNjwH/5X+0Fhj5Vg+zex7jbtp3OjmGpD78z6G38kffmfQ2/kj7+z6G38kff2fQ2/kgnXrtnLtl6Vp9trfCxA3NxvMcR9jIxz57b+qZlizbLJ4lfb2rdp3osb7p35Abiy7dsj9oVliF3yMffmfQ2/kj78z6G38kff2fQ2/ki7gZuW27i5HZ9ZbK0xvouJxakXWQpHgf/AI/G/wBJseA//K/2pNIU2FZ+GkfpXmuvO/zHGZeBJMLEI1LGxu0dHXHH5GlHhtsmq2xdLIu/m2vO8ekl7IuGluwx1y4dGkpi9kP9K+91x+9xqGX7je1j8NL17+rt/sy7+vckyc7INLOMw3v7nR3RkZ2U5buQ/tUIuhpUItJciw41+y5Tuz+a9pH41kZ/1dv+q+PDMXps41sn/ndnXwyZbVVuK23YZ3G9o/C44VgzHXzM6zctuKrS9YX9WRzT5nEhiot2bTe3duuJltnW5xoRDD4fa9HFtk1zvdO53O7p6yFwPGufw2Ijs4y9td6G/o+PcKbSzauMXCxPn83qNpczf0jkyMhjky8j5jCL37vbfolqOJWf7TE7fwHkXxpOF5Kfqsp1pf8AEYZ/ECSXaZtwj+CyR1u40n23kbXscSkZHzkZB+VwC82wZ6nw+8vY/Qfqm4++OzxHBu43R6wyVh7nl5pyJBJMBx+jilcvu/RaZF4TKTi+SvZdbxbnqz984uy3wnIgSZQs6cmWKDUIEhWGgUL3wsKDXpihhBUVFYaBSC+CROsJDWNYqFhSGvNFJOCf9Bjf6TY8B/8Alf7QpJqEjxhP1Pq7Xb/OVyeWbifrf7v1f5vq2okyBIcD/wDH43+k2PAf/lf7U6BAkqwWRrW6m40IYuI30cayy0X6DUk4q8ua1d9SX+URM8ZQKzgYlzJfzeYWhbz5i7ofdvmVziWUReveXMxvuG+WR+M138RxM/UsL3n7Q+9p3YOzDL5ziN03r7y35jfCsmFwpjtct/rr5e8t+iXdPxTcTd0HkNQ/0ZLDOm5mMLvMecOH4fOWTkW7Z7nOJZc/M/5nIuXW7nOMyk4SRao959626S5dPmttNx9wgox7jiW3gMdkuKpea3+k4jkzeIXNSxLTrnZ6zLmLumLt+871l2+47l159LnGpmECBNlbO61M3iCX8tecvcM7heFZHYdpy4nClslW7+0PydwNb/b4t1nid8WTKf8A8tds3f6fY+MKycQ4RcNDvJk4xVb5ry7yTGx7Sex2jmnqRhzixP5ffP8AbYvmf0PR8Afewk4rit1+aJLxF/h9PcUG1xI4uco1k4vnJ+qtW7DT/wAQ+0f9QpHWV++5Fq0lC+c+JyJOTUkrJpMkEjWTQaRoKBDhqE6RUVgo8ctIJGsiw4H/AOPxv9JseA9X8V/tRsYtlvav5Fxtqy3mVzzQiUx+GF9PZ+WPwwvp7Pyx+GF9PZ+WPwwvp7Pyw1t3HtYbPbXbl1jvAw3GCw8c/WPcfbycg9DuP6/yTW8nHuNxuJWG9ltx3oXG+5cnjDiLAZcLoe29aTwuIx+GF9PZ+WPwwvp7Pyx+GF9PZ+WLudnYPqcaynrLnrbTk7Rk0tGuM+cxWPA//H43+k2PAP8A5X+1Km34TjmSkeQx7y97b893gKV1y5wfBe959p73Y9szMz5zM+yFZwfCYfWWPbL4oJlthW2lzNaSFJcvXnlbtWmm65cdoREXOZi5ktUsS0Xq8Jh+4LpOp841HD8NE+zY9tjvzibr4ZMphGrcNluwzuF2j8Ljm9cn3zJuXSOhJb+LJwjDL2x3br+52Wt8ZwxDMlbiMuXndxvZLwuKTimURo61jXPVn74yRvhjqKgrqfc8e5cXf5nxpOL3+Y24txrT988uyXhOHFc9P1lxlhh/mF2nf1ikZjNPXOyGMcXvWK/xkW1t3LzO1hcOS/krzGftGd0/AUmXmtMiyDL1WGX96/m73P3AbjNTM1c4+kcJP3T7jPh23Nk41a5z+yXHkVbZdsvFLj52I/1eRjPJ9pwbfsOK3ksJMvDM/OY7yl1HsH37LW4fFSLzMoi0fS4nPv5xew8u0dnJxndi7bPrloH5Blrm5T3k73rCJnjI5OD4JH6Lbt95fnI1viPZ05ckd3QN0VlQIECDdFQsFhvggQIEhUoLFZECBI7oKFk4IfVhWW/BaRR4Lc9y+834RM/IEhwy8enqcqy8/wBF5HyHKb/bXbLC+H2vihY8Kt/2eHYb3rZR4Iz3LL5982fkgmwWVOgJI6+ZaYWM95H75yM8Rnsn379xtmzaLtXLrzRpFUwfDuHG63wxh/OXOY75l8WHD8c9fX5Nq2n5zyKXi90/bZt/vds0lJrS7Ru0IqjAwOnGstbc/PTzj78l+001Zg22Y7d/pO8LocWzTL9Wy3YY788zc7+qUj7RGh5t+3a7hfOfFlz+Jvah5dwrNk/e2+c+6Z+CS1hkfn8QvkRl7y15x+Hswx3/APM3rtzvO7HxZOCWej595/0CKHUNNjpzixZe1MzJ+fzevtuL0f0S0kLhtl64vC/NcnMd4/T73N34cEuKiZtgnHRzyI5L9h3o37brZ/pEgMjJDaaGUtvLwch2NkW/Qus8R9ZBmPx6z9lu8326yRutnVzOcu4oK/g5VrLtH7e04nd9J8bjtpqXbDisZadLHegZ7j07s3BsdOyZYzHvb76557vC6TKYRqWFatWC73bPwu5CoWdAm1STQKQWFBQajUaxTpioUKFhSGoQJ0hOkVFYqFFJkCCorNSThR9LGvtn+hccUbF4ufGy2Ge5zXF40j2i5y6Rg5rebKsW7vwmryDhmCR63r7rzipbb2fjheiFq0z0rziY0quNAy230WNJpdyODY/ssMnd173fkhWFZFjQIECBJeK5qfrLluw0/wAwjcf9Ytgd3IvMx7Rc9y44mt75g2YXa4pkdVvzbZb3n5FH8Ze7NhpraxLelsu50nvhUcFI/wDnbJ955HLxdji1bmXyP6Q5beRcYuLwtL913R2/2be/r3JMrNvfq8W0646qFzd0X8q8a3ci467cP3zjU4evTXNyLlxaNRnjacnCMIj5iuXrhb0a3xHFRYw8ZnrL+S8mW21MYfD7PoYtsmdrrP2zu6esj8ZjlscMb6gvz+e4ff07kOEEXuLh9+685OC5BeiXr7bu72DLyhQoXYlmXmdrC4Wl168zrv7NvlldcuYd173mbnvO/cUzPn9sPuNz6a5+UWr9rDuNu2Xk+2711zRzTUumXi9jmbazLxN3ds0FJivYmRcxr7fRu2nGxxd0gTMl9vilkucr5I/uPanhUMs3XnwzLdoVnIMuwZ+9uc3fSXjLX6kVknd1ricXilxcNvp5V5llm97kDWNJGtJGlQpOJ5pH2m5GTde0/em4+z4NsvIqbdAgSZQs6BIqFCwWRIJDdIuwSGRjmfnYmU7T3r2kZeFY8WsESvKyd1hVtfOfFChYHhOd89wy4bE/u3+c3ylyDIYx3as8OaWKz85ur/6RoKQ4TaTtMt3vXv3WfP8AJJxBDVuP6uy39FhL4VFeR4bkR2U65ed3XIXgIpLODw51sm/ZyuXu2ztec5x+Qh+tx/oiCevst98VpvlBk/i91n+ETbX9QiHrMrIuZFz3d1xvPwy8Kvu9GzmWHu/RuEcr8om/w/FG+tY735aPLy92Szh4lo72ReNLbCFrCto+6fn5d/3dw+fudBSWOB2H/OX0vZqdDC9BvdPXuBYcJx+Y24zHPL3zy7TvCcmQwtW4dq3YLvds/C6JNY03OeaNaWpmZj+Z8RZ/9lfalmyf7Fh/GP8A9dMmTnGZeuT1eGw/bXXej3ucOfccb7jz7T3HzmZwwWqp2H3mO+kc7yyZFmw3tZWKZZGM0udzmKre60zlt4mDYdkZNz0bbfGfUQJ3EOK9i+Zfq7DFa39J3P3g6/if/bYpc7rTUulvt6+BQZHoZc5RJjCNz3mjWlzmZjGwk/iHfO5ruu67n73NtOKEnm3vV3W/pW2r4V2WfgZNw7zeGOtfZrjtTJl3teZuLsScU1868Vu039N7V8EvCyMvNsOdfd/ltMy8KScTzFQ8fFuvZ+d2T7PhlTapyrWGvck3RUKFFIUOOoQ4bhWGgXvhQooKQQIcKx0FZaR1hUVhn4Dj0zLBXG/nWj/I44mRkpHoZDPwDLzce6ZW6sPVh94xQUFm5dd2cPL+Yy6NdzO/RPwbfJzjMvXp6vDYftrrvR73OHOefac81c4+czMIEHEeLvbowixcc6n5z/JF9159lltpue7qIhl5r/Tyrz7ri/PNZk22Bh9OLj27R72tIjk4q9dLN31Jf5REw/CUyxUu+MDPaa/arLHu/OTzi7hyPwcsk9tYvl6Vt/Q4g9cN+bjl6GVjEbyMqkWpd0dgsS8dwvaExyhpniHgWPbX8rzO8z0j7wMscvX5dwkv5ry851C6ipJf4hlH5lkvNZ0vd7VpbxkZ+U7tX8l/af5CKhFpDDxG8+VeZaL9NxNBNLQi0IpOI5hcKuOZk5Fy5bPt2/RN3m+26gn8of8ADt/KBfbHWOH2/bdp3rH9wmKXhDb1th5ecX/vL3OX5hczfHWRz3uJjGEr3noREXSYSwZ/y7CVmIXuj9tc7seJcNM/Os3G5FsqPLsn/VKW5xHgpss5NzzsjCd5rHn1tPoM+8Dbl8MybPZ9sdszb3HFoYIsfByL7vc27TnH4CDX5jS4VjdLrutzuWy8qD1ODa+cf+vyn63Lm8/JG6dyw3HzzL5rPYSOXo7SekW8XrFwkuWHut3Cq00OB8VvsXE4XrbXmdfP0fg8/e2uJfItMjDap++Y9xeJI+rwLHzTTS9mP0tM3n5CDbj7ZcQ4h7bLvNI0P+7b7Xx1DsbOxreVYfz27hL3uoXMvgrHZ+Aau+zFretUT2xbtQ5r2mxzdHNdoZHBmPiWH5N65oy1bI3OPvBzMlDz81xXcpNSaheaxaScN4Ox3nuceXfKhKxnfU5eJ5vRjYzbXduuX4kmTb5jzbtqwXf7Z+Bm2pFJKzU2iy6wrCsfJCgoKS1FY6d0ad4aDeKCgpDUeIVFRWGg0ClCgpLWFYaDQcOz1Rlm8Xrv8N3mv8BhS1I+Y44nG7TdPu+Z47bvGXejqG8Fzbn8dht/hXH+1tF5W+Lu7V1y44mMYRue89CIi5zMJYM/5dhqzDb7rrud3xQqGW2NN9x5k1jS5zMxhcP/AGltnayXddx2rvDHNRyXc5MW1/mel/RWSsVnSbheKml7Jtlc/N7Su8Ej7j9G22m5x0IZGRc9LIuOuO3uNdlf4Hef87jmd7DI+ljvTaW49e7s7uRkXCtWLLTfduO5iIh80tvhuLpiWD5z63uqfgCw4cSeZYN1936DTTwps1PQiFzg/Cbn8ERpmZbf2qe1b73x7udY4ua4/wCGd8zm/wCG/nPuGh9wE5pk5riVri6dm/KyHE6+4jLDxum4/wDJ1mLl+4a3Lrjfcd1mepi3ZssO5cvOJlphc5ucaEQxeHMQ3sLtZNwvbXXekcl7huRayr9/HT1rrDWG0jMlRXPaPufEfo7X1o+58R+jtfWj7nxH6O19aPufEfo7X1ox+J4jLjLGT2uwy6RE/wAxxsNUMy6JOCZRe1O/ace/sGXiOGHw9zuxZeZvyXFz9hhKab+YWsXEstx8eyXZtWmEhFJ/H8Ox8s/dXbbXO7/OF/kuP4U7yj1eDh2cNh87bLGsXekmRnZdz1WPjN7dx35N4y+J3vNdkO+bt+5YWjW9wgsNIZeWfpZmUZF+bbaRF4TOTg+CXtju339xGt8ZxqK7avK6lsUCBI1goXvhY+WCBAgQbhUoLBZd4QJIoWChY4vbcuTg/wANkfoeifdakcrAySWzlMNjqdRluPUZPD8pqXsZ/Zo4uhxbyhUWsrGunZyLDidauN5yMh6q6bbPFbDf4jH9179lPFszMzQi5zFzg/Crn8A00y8pv7Yy9q33vj3SfznJZ/C8OP8Ah15nX/8A+vP3pLXDLTls8Mb87/i3NT7xJ4ZV2e6S1dRSw7N294PV/Hk4ve5jPHO0W+7838aCbHHzsN/q8jGd2mH5DoYblY59i8xCy8VfOtv/ACdR7F2Xn5DbFlvMvO4+ppdJj1TFxuF2z+axul3vrlfEFjxPMMvu9htov81y/E2R5XEMlmNaLm7XO4+ppc5mH4eCTsLhfM4v2l4vfpzFQLLa4DxO72XN83huS7mMui0Z/wBXvbJ1lplmcS9phsP0a3D6PGH5vEL3rrr9Gl7VjfctLoIbxd4zfYuPw/zcZem+fT+iXjKTN4ldT+Gtmdth+2eejG90xeyb7/WXr73XLtw+lzjU5EDGf8vk3WeJ/wAaSzd6cbMtu7hte3yhRi8TtN9YVkzK9a90xxI4hbzuH3vXWX8/umn0tcXQexu5WXebj49ku1duvNCIh9lxFtcIx3LaZzHdcXt3eQgsvBrSIb7Hrnf5xnc+NI+wR/cce1a7p/OfHlULtVC7RQu0WbWRJFhQUhrInSE6RWHliooKTVFdhQawbYvP7OHxNLN3qa/9m7v6d2T+Y4VteJYLfQLnu2uc27y5yG6Ci3k4111i/ZPtW7rDQyMW8PjLm4edzMyua1d+Sfg8WxflZ+QzGsM53v8AERdJi5g8P7WHwvmf/aXvzuoqd+ChRYwMQvOumt270W2F6Tj3DH4fiN7NjGb2W9Zn0uOpnHL4jd19Q35q37u4ejW98Xcm8/t3r7zuXXn0ucanLSOux0hQZFi+4rbs2x2Md7ulxOI+z3ZG8Cw7pXXlcK5nvbqTez6LN/SYrsKxt5uBfOzebz9Ti6nF0kGWeJpwvM5jc79Q46O9r3e+G3LbyuMeSte01Iy3y+uzcq1i2/dXXE3vKH2eC2TzLvRlXSNtotzfSPwD7TxDJdkXeheZpdTS5iFIJDifD3uJmTdNl2yR872kRkabp+3euttMLne8yaXhBk/ibL7y/Z4/zp99unhDrfBsMsZp82Vkec/uMLzS7qh2TnZL8q87nfcNe4XVNSFvC401+bjN0t5ZfrmF75fS8e8es4fm28kvbNafnt/OaepTOK/ntv32/wDtcf5x69Wmhd0w+xw1v8rxHaesaa33F+f7Xud8G5x9o3amZxtWbLi9fYvXPtbOntOcpH8FIm5x9lrdTMxa4Vw6763Bw3du/fb6N27zeb1k2ChY53Bbtwrd5937TitP26tJryLd2Sks8EtXCuZd2627ksI19WxpadrqMzOP2rh1/wBWZ/rbR627hdT29IZa4kf8pzOY+3rZcdH9H6XfDbtq427bfqy4w1I9xlK65euNtW2+lceaEXdMPt4T/wCbZRei2z+qWtzm+CoJ+deTHYa2cK3paZ3Ok6nPw3IxXNNhY9tj2N9o9rSJzT3Ru52feKzZtl3XH0NaXSZjM4jdJH5d11zs+5I+ZvcLTkVJ0lXkaBAkdwWCyoDLoCTKFBQ6wkE6IJKvSFC7Jtq+9eI8PIreSvO9vtbnd6ayXuO8KtfNu8/iWK32vXcaXV19+RA2zbvfa8Jv/tL/AJxEXvT52gmZpXOF3untl27fce3ykQ7WFnWMov7q413iip6ED+1cVsNeXPaY71j/AILFMOtcEwjc7/m8nm7jG+U+4PtHEct+Td9r2vRbRrS0LuSWcPDsnfyMh3Zt2yHqiS7nX0PNyes/ctoUhcNxbnaweGuMnmXM+9zGf6PN350lUKFhvG+KDcCYzjWcxjdCIsi4Rf1h+OcQ/wC5u/KB27vGM24w+drsi4ZH3FioWRYLL/AZ9/EXU223mTT3lzGOy/Is5SdN20XxOyD7eDgu6uy24X+4Y7JWMG0fum23/GuGDa7ij7DT9rYa21/SaXa8IO7kXn37p89y443H3zkQVgTmuNr26k4ugacbzyIuj7Td+UPxziH/AHN35Q/HOIf9zd+UF/nnEP8Aubvyh+OcQ/7m78ofOcYzrhdTsi4fxh2rtx113unGp+GFBTYtuWnut3G6te00Mu6CK3xW5eaXtb5Fd8LyM/CEOxg3ffOtv+LcIF6vBwS61bcP/cIeZfsYy9Nq0Xx+0DLN4nkZDHc9o3n2PgFpHWPrsTJu4t7+1tPNju+0fjvEf+6u/KH47xH/ALq78oery+KZeXb/ALO9ee8u8452uaaObqTiBNbx3iBNLmIsm78ofj3Ef+6u/KBtfxziDmu52nk3TL+sD7RqbtTccvawM6/hu6fVPNq705wROzWZRF0XrTPG0mmPunD3H1nbu/WjTF4e0+srdzy3QZFntxmnzlZtMLwmRmO3nZ1/Md0euuOem5ZUkc7Czb+G53pHYuOtmfwTIfj3Ef8Aurvyh+PcR/7q78oFdzMu9l3C5n3nueffcfK15AsUCBAgSRQoULIgQJJugoWNIpBJFChQo3xQJMoscRxvaaX7PRctn6TRYzsO56zHyG9ph+MjqUl3inArPatH52Vw5nO3rdbLqp3ggQJFS0MukfM8Ty7KdDLz2+Iwh8bz06vtN35Q/icq9f8A8R7neOa3hYFg79670FzEXW4+ggumRxG8X8Tl/EZ1F45PsOJc/wDs81vmmXPat8xv39QUUFI6xqKxWFI026xoKQ12Sy02CBAm1SVQs6SIECbBZUCTLBZUCSrsECSrsECbBY6yVFRWGg8caS6iorDSPjFJdY1FYaRoKCkdRrN44eoyDN/Csp3z7f7N39o3yhl208rlq4ROt3GmpGR8xlI/N4f2cHiR6u/srp++IuY6kDxeIYz8a8XN2uZxdbT5jFRUVjpBZG3Sb9i4d7bNuFzl/dt9t4h9n4fZ7Pa/XZDtblw+txyOybyXMi55uHi9L3fkLpF/NzbnrcjJd2rj/IVCCdASZQstAktYLNQJJSCBI1FRXbLMnJFC7euy8XIa8trNSas9BQUCRqQrFYaQoKBOgJ0BAgrCoULBYUhQIE2aCgbw3iLjfwq4fzdznOwZ/F6wy7aeVy3cLtW7jTUjI+kjkPGz8VmVZP2ry5qkfOXcDr3A8uv2PJ+LcLyl3QZcQwL2ORaetMlYe55K2OkFgRNJTdp2SDXFhnhY5/t8r5vvN9I+8G3s3/7XKLX50ktEdLfT3VBERIRcxSHlZbu1cdpjYpencdSnWYuZ2c9Xv0tsL0WM6GtIIEhuioUKFkSXdBYLKgSVIpIsFG/Y7pvLsdIU2dJE9hEmX2HUKFChYb4IECRXwBYKFCxQIECR3BQoULIkUjUKFChZUCQLFye1lcKcetn21tem3+QMy8G+3Ix7nM9viPqOUyMlI+cjBuv8JsE8+e5aL1R/u0BnYyMvGPqJ7XN8LV8I+b43cb+dYJ3xyH49p/03/wDqPnuLX7hdTGNZ4+0C9Zav5qf210/9vsD+A4fYxT92xhE74XPMdtSyuJPL5nCafN764fQQuZvELx3b9zmL2rS6GtLoIVFZNJtdnTbVFZKS67esV5NWRZ12CbVAnJF2yhZ02Wo8UlZNIJ0R1krFZ9Y1hWRRQUmqKx+0cPv9ntfrrDtbdwvfNDLFxxYHED0+zXD0cf8Adu6d3Pt35GTeZYsWyV924fZaXdMXMP8A/XtOh/E3l/ptPxn3g+7ee65cefauXXGrjPrM4KFChZkCSLBZkCBJVChZFChQsUgkyyb+Rrs6zacwpNQU2FeR05UuzrOgQJKpQWVJeoKFChfBIgQwgSRQoWCxQIEmULBYMs3X/wAywy/YXz84i97c5++oax+R/Lsk/wBjk+aXcf6IJzT7TT1Iy2Xrs7LtYlv3V1xNXd1h9ng2Oebd6Mm6rLXcL0j8A9ZxHLde7P6u1zW27mlpFSivRFJqwWCik9ZV78ywoKSJCsqzoEnQJ0bSmyXaJOsyBOSLtlCyptNYJOpBQo3ikECGECCpSLGkKQQwgQxUVFYqFhQUigSZQvQF6IoECGC+wcQvYxf2TXKzusNW+AE3NxcfOIvbEtp590lLwAiysHKxXdPZ7NxvfVp+APx+HZR3Mi2z1j7Lrb2mTSMiVTJOmQ+xkXspP7Ky74/ZBlgcJe/quX7hN/ot7XjDm28i3w9h+1x2Ifwndowd/Jv3Mi87nuXHG53fOChShSCdG0pyFNssdIUgkm6dAgSVdluguwSZPYJdinJF2NYLJvFBQIECSrLQUCBIeWRZqCklYrLQ5EjWTM/8fc/1bUiBIrIgSCTKFlQIEju5Ckd0F2CBJ1CyVj5PYFdins35AoWZAgQboVC+CChQsUCBIJHcFisiBAkihQsqQQJKoWOZ/wCPuf6trYUihhAkyxoNYIEl02qhQsi7DWKbBYUFJFguyWCyoE2qhZU2CwWZAkq7ZQoWZJlChZEgkmgULNrCoqKx8YoFhQUjWFZCCigoNeaWoqKxWFJNYIEhXY5n/j7n+ranQJMsu+KBJVnQIE2NNigSZYLGkdeaNY02izIEm0mXlFfZJAgSVQsNIoECBJVChZ0lULDfIgSZQoLFxC7LGedk5LvRttr5CBFlW7vELntrly45hLQrZtH4T+/v/WD8J/f3/rB+E/v7/wBYPwn9/f8ArB+E/v7/ANYPwn9/f+sD8rhmF9mvvtnac/1lx/mGZGiPcfVJ+E/v7/1g/Cf39/6wfhP7+/8AWD8J/f3/AKwfhP7+/wDWD8J/f3/rB+FJX19/6wPyOA3HsvsJfsV13aa+jXc5HvD7dxhsuWzNty27QyMuckCxoKRQ41FYKF78+sKwrDSZJE5GgQJ7ApOm1TYKF5WvIdY6wqN0dILCgoECBAhisNIqFIUFIIElrLQUFIINZ1CwxLrS+dzzdfvv69Ub4C5JbybRE0uIWCuXW/3jTNpn3SSesug0FBQUFNpSagQJBNlSKS12VdlTkaBIVk0gvIaQSfQLGkibZIVk0gsuoqKisdI0mrCsNApDQUFBQUCDWFRUVloKQoECHCsKw0ClGgpC1hdovtPDDO3cZ09hxm5jvJ3OSHax3du1w239nNxcxvUzf3lTuRUUmXZ02WkiTabJJlC8j12a7GorPSWorPTaaQoKTVFY6bKortN0VChY0CBAgQbh5AvgChQoWRAgSO4L1BQpBZkCBJVChZUCBmbgXvVX2aGXO1zelri6SBfzHht+3eL0jx+y9p/DNqD7pxD6O19aPunEPo7X1o+58Q+jtfWj7nxD6O19aPunEPo7X1o+58Q+jtfWj7nxD6O19aPunEPo7X1o+58Q+jtfWj7nxD6O19aPufEPo7X1o+58Q+jtfWj7nxD6O19aPufEPo7X1o+58Q+jtfWj7nxD6O19aPufEPgWvrQ/F4Rjnw+3c0flPNbqe9TRoXvxpslkSRAmwpGkyhdnUV2NAnJF26hQsqQSVQs6BJVChZ0ju2aSrOgQJIs2slRWKhYUFJEG4VisKRoY1GslRWKhYUFJaiuy1gcKivIqRoNRqNY1FYrGgpLUV2WslRXldZV2NZ6Sa7OmwrJQUFJElryKkmu0TYLsNdgsqCkm4KFlQJsF2y8lTaIE2C7ZfYJJliuwTlSQTlibJAgQJDcKwUKFCikECBDFZVgopGkEGsnjChY0FAgQJMsyBIJDcKwUKFlQJMoWWkEGsawULJSVJFCzJBJVChZU2tNgoWSmxXYpKsVkSCBNmgQJGsV5aoWTUeIa88Kw0moE6B5Rr3Dj1GUKjQeSPWQoNQkKisKw0hSFIJ4R5Y9RisFGmxrJpsdYVHVPQUGoSFRWTSWgSSorHSSkus/k5DSSorJpMklZNJaCk1ZaSeUJJXY68irsacg8sihQsfKPKECBAkqhY7xqKBAgQVhugs3lCBIVFYqFlQIEmULKgQIEG6RYaR8ooECBJFChZkCQqKyrIgQJMs6BJlnQJCu0SZYLst0FCzoElUKFmQJtkjWCzJNWC7BJqTIEhWZdooUKKSpOoXYV2aBIV5EoXYJMvJUhXka7BJ12Wm0SZQsyckULMnIE2aSqFChRpFAZQSO6C9IWVAkyhQsN8iTKFgs6SKFChZTIGEjUoL0hZUhSZZ05ckd0FCypsF2CSboLBZU26BNqgSfTaLBZU2iQQIElUKPIPIPJBIIEhugoUgoUUG8UCBIbpVCwpBIIEk3RUKN8UCBAkVgoWdAkihQoWG+CRSVQsiBAgSdQsyTKFnSZQoWRNgsF2yzIEmUKFkQIElUKF5GgQJKsVlQJMoULHUIYTphWagpFPCE8Meo4LDTvQoKRTwhAnSKz0HWU/UKyLGkU2NBSKeEJ3oVFZNI0igQVFZ6Cm3pNWakieEJCsukaSIKiuwpyzr5BSCT+QLyXXb1ioWVAkU6SFSgoUKQWFIoECDdBekKFCyoECBBWRQoWZAkqhZUCBIJ0jdIoWVAgQboqFCyoECBBWNQoULMgSVQsqBI1mWVAkq7BAgSZQsqBNhpMk6hQsiBAkihQoULHfIkN0VC7RQs6SrLrFIIKw8Y0CwXoFJUCdIrsN8lQgrJSdAgSRZdYpBJPHFZkCCsyzoKyUnQJtU2KzIE29ZKToEhXbV2euwULCmyUKKBZ67auxSas6BOgJLUL0hQsqbBdgajWSsdORIElqF6QoWVNgu1ryZJaisF2q+w2sqyptqQ15SgQIE55VCw8kN4QJMoUKFhvG+CBJlChRSG+CBAg3SqFhSCBAgTnj5YKFk3hAkyhQsd43wQJMoULMgrOsqBDCSrMgSdZ0CTqFmTZ0kTaoEmULCkUCBJVChY74IE2dIptNY684rDSSgoKQ8slYac8lBQUh5QnhhWFZqCktRWGg0koKS1noKR8sKiorCsNI0kSFYVmoKS1FY6SUFNpSTyyVhWWm2pNUVnpGnIfEKiorsvLGsmklBqNY1FZqQoKT1mpJuk8Y0hQUFAgQwgqNwrBQpR3igQIEggqUFCkFFAopKgqKwrBe+FjQUgkd0ukKCgpLUVgoWVAgSZSChYUnrFQoWNNrTZLsEjWRY0nrFdghhJlkpMgqKxWNIUCHJUVgoWbUJGsFCjSZJ1GkaRSXQLJvkQJOopKkyhdjWRQoWZIJ0x0kWVJlgvJq8qT2NrKvJUFdpqECSFFdqu00koKCklRUVChQpCkE6AnRNUL0zUhqEjUVFQoWSgToCQ1krNSFJais6bLxxpCklRUVgslBQJtKCkteR+ONIpJUVisaCnJqwWNIpLUL0y0ig1hrIoUaQoKT1gu3WG8IECSbgoUKFjvCBAhwSRQsm+CBAkyhY7wmxXmCw3jfBAkm6ChZUCBJ1k3xQJMoWO8IECbBdooWVAgSdZ0CQ3SrImxULMgSO6ffFAgSZY7xvgkEkWChZUCBJVChZECBNnrLUVk8goKCg8sEGvOKjqOGg0CxpsKwUKUaCktRWGg0jSFJ6yLsa7JIaxrBZKCkNY1FRUaTU5JXb1moKbDTktIIEhUVmpCkmsug02NRWanJK7DWCBI1hoFClJQIECTKFjSCBAkaxUKFhQwnWKdYSBCuxpNWTSVNgoWNIIEGsqhQsicgSSsiypLWK7ZZUnrBZ05AmypsVCheRpKoWChZEgkm4KFCzIECQKKx3xQJMoULMgQINBu2KQSTcFCzIECBNmk6hZ0CBNqkq7BAm0SdRpydAm0TYLOkqhQsqBAgSVQs6TaSpGorFR4xSFI6y1gsaCkdZKisFCyHBDkqKwKGmwqKxWSk9YrGgpFDjUVFdpu29YrtlkpPXlGstZaCk+6TTuxpsKwrBYUik1YrCm23hAgSVQoUL4JEggSVQoUb4IECBJVChQsiQTwhI7goUKPJHeEgkqhQo8kiQQJKoULFAgQJMoWVAgSHlioULOkqhQs6bNIIEmXYJKsVCyJOoULMkyhZN4SHlnULBYJJ5ZVChZECBIbpF2uneChYUik2gUKFFBTZrKklZlFBTbUggSdQoXarKklZFjTb0kSXQKFhTaLsa7CgoECeGNRWTTYJy+s1IJ0BAkyjTYVgpDxhY0igQeIVkWNBSCHBNlSCBAkayLJQIECBJFlpFAg8QrIslIIcU2iBI1kWSgoEgkiy0kSFZFkpyldhrJWCy0GoSNZFCwpslCheVrLTYLLrBAkd0qyoElULBQsiBAgrFYLKgQJMs6BNgsqBJVCzoElWCyoECCu0STdskCbVAkq7BAgSVQoWZJ1C7BJFCwWRIpKoWdJVChZkl0BHMhhI1FYKFhSFIayVk8caR1jWRRSFIUig1jUeOBSUG8ayVFYLGkKQ1CQqKz0lSFYqKCgpJqEGsKio8c1IIclRWChYUhTa05Brs6CkUhrCorIopyCnI67CkKBAg1hWOkqBJVChQo8kUgk6hZkCSqFCypFJVCyoEmUKFHkikEnULDfIkyhQsqQQJIoULKgSZQoWRNks6SqFmSCBJFChZ0lWC7VZ0CbVAgTapKsFCx1hrGorFY0FIJBBUVFSk0hQUigQwh88KjQKFCwpHWNYVKRS7sF6BSOsaisVkpBB4ghioqKyqKCgpBAgTpG4VgoULCgpDWOvPCsdApd2FBSaorFdjUV2FIptdZayKUaCkU2VIa8w1CQqKisdNhUVFRWWkKRSNRXlFRUVgo8Y0hQxSGvNGorCsNI0FBQJJWChe+FIaQoKR1krHQaQoKCkEjUVj4xpGkNRrGsKw0jQUFIpCsVkoKR1Gsax0GndGgoKCkEjUVjp3ZtZKyaSU2mgoKSazaDSFBSTxRqKy0hSesdI0hSWorJQUFBSaorHTZVmoKCgTYLzwWKBAkEkULGkPLBAgSHkHkChQsyBNgsiBNisUCBIJFQoWNJECBB5B5IqFG8dcUCBJ1CyIECTLBZ0lWdAkfJDcFCjfMk6zIECBJFgvXKgSCSKU6TKF8AWZNgsyRSZZUCBJFjSFBrCoqKio0goXoFJNRrGsvjFIUhrGoqKwULsais9IUGsaioqNIqKSajWNZqQpDWNYVgoXY1FRXY6yVFZKCmwrNSTWSorBQuxqKzUFBSOo1FRXYUmrHTuyUFJNYVjWKik9dhTYVGkd8Eikq9IULKgQJHdBQs6TKFlSCTKFjvggSdQoWZAkyzpMoWSgQIEmULHTZqFmSddqoWVAgSZQs6TLBZkCcrSeu3WVIVFRuioUUhQUgktYLDSfUa843QrBfAFlQIEhWKwWVDCCoqN0NAoULCgoN4SO6FZqSaw1541goWVAgSFYaBQoWVJ1CxoKQSWuy1hrKoWVAkaw0lpFAgQVhWPjGk6CsKz0ghhAnIK7JAnIllpBAkaioqFGndCz6wqQqKwUgoWFB1xQVFRWegoECTKFGkaQSaoUKQWZBrCoqKw0koOuSsKx0kpFJllpNWKhSmSSuwpPWekqbbWFdt1QWTyQpJ5eXboKFChY7+kIECTKFlQIECdMNw8gUKFmQJHyQUKFCw3hAgQJDcN0FChQsiBAkqwWVAgQJ0xWChZkCSqFCyIECBI7oKFCyoECTrKgQIE6ZVCzIEjWChQoWKBAkElUKFmQJMoULKnMEjugoULOkyhZkCTLOkqigpDfBIGoTpFYrBRptqCkNZKyFJQU2Syb4INYJ0io0gsFGk2uxpNWekKQ1nKfWWsijSbUV21Z6Cgps1kpDXkVeRabOsCCyUhrsSggQIEhukULHrggQIElUKFhvCBAkdeiG4KFCyJBAZSqFlQIECTKFlQJBJVC9MiBAkDGvRDdBQsyA5VCzoEmULKgQIElUKFigSTdFQoWVIGUqhQoWG+CBAkyhZkCR3SLMgQJtUmULMgTaIEnUKFFBQbwkEOXSChYUMbwkECCorBQvfChYUlrIoUKFkQJMoULCgoN4SCBJlCzIEG4VgoXvhQuzUKFCyIEjWRQoUUhvCBAk6hZEggSRYKF2egUKFjSCQSVYLJSCTqFjSPlmWCyUgk6hZUgkqwWRIVFRWTyCkaTdRx02/khSPih4oVFYrLQahPDCoqKyeQU2FR1GUdB5IUk12VJ67CkNQkazUm8Ua8rrHTY+KNZ6SaxrsUCbHQUhTYrs67NJlCyoECQ8kFCwWVAkNw3BQoUKFkQIECSKFCyp1wQJMsyQSHkgoULMkm6KhZkCBAkVChdgkiwWZAgSRQs6BIVIboLBZUCBAkqhZd4SCSLskCDdIoWZJN0VnQIN0ihQuzWSk6SLCkdYJ0hBWakKDfAwnSE6RUVGnPBSChegUjqECCorFQpBYUjqNQgTphWKhYUlTpCCs1BQUlrCo0gpBQopHUJMoUgsKR1GoQIKiuzTpCCs1BSG+RIVGkFKNI6hI1is+o1CBBWddpoFFBSVIVnpImwXoFBSKQ1CTryCgSdQsqdASZQoWVAku4KFCxpFAkdwqKwWWgTo2ChZECTr0zJNugoWZNgsqdATohrMoWROgJLWChZUm3QULMk1dvWagptaQTbJyneECBAgrDSagQIECBBuioULCgoYQIECHLuChQsKGKGE2KhZECBIJ0w0gsFhSCBAgSRQoWO+KDWTSChQsd4QJN44KFlQIEjoFk8goYQIECBBWKhQsaHFAhzqFhvG8JsVjSG8IECCsKwUL35aBAgQVkULGgpBAkEhWChQsyQrtECCsq9+XUajUVFRWGg070KCgoKDxGNe4YqKioqNJKCgoE6Ia9+NRWGkaCgoPEY8UNYVFRUaDSFBQUjrGorDQad6FBQUFIa9wxrzwqKy0FBSasdI9cKSawqKisNIUFBSOsaisNO6NIUFBQUhrGoqNJKCgoKQ1jUVhpGkKSaxrHSFBQUFI6wqKisNI0FJaisKx0hQUFIayVFZaCktRUVjpJQUlqKx0hQUFBSTcNwUKFkpBDCQqKwUKFCwoKHBAgSFRUguwQINw3DcKhekKFILGgTwhAkKjcNwUKFkoECGEhWFYLLvggSNRXYoEjuFQsPGFjQUCBIVFYKFCyUghhAgrIoWSkECRqKydciBAklRWChYUigQIElWFJU2CyJBAhzLMnQEGsaxWdAgSVZ0k0jSdBWQgsm+KGKhBWRY0OVOkVFZFC9ApMk9BSRIJMsaTVFZFjQ5U6dskayUnQVlWCx1lrIsaHKgqKyKKTpsKQptFnrMoXbLtqciMgklQvSFCyUgktRUKFkToBkECRqKhQoXZVgoqFkSBhJahQsyTVChZkkqKxWY5KwUVChZUCHHdCoULJSCTVChRvjSCSr0wULsqxqFmQJDWG4LFZKSaxWBHMnRDXY0gmwrBZUCQ1huCyf/aAAgBAQMBPyFwygmGnyYTvJMo0JxInK0J/ATppkwguPWCyjaOWxup2YhNjdoYaa2YfsiITTMSjb0FlozTwhJNOfg1esGeywZUsDBPY1SY6hjqORh+xqUSZQbejOVozTwRNPRDi9F2aGq4MEVyGojYf7HTrY7KNjUs1yYcciUSpotKZGhRDREr0RKl/YdJHSGR/Mxqh85Gmn2yIfvJhxotStCeVNC01oySWosvWCy9Idy2PE7MQx6Y6agiGQ6MMxKMN6HKOnoUSnR7+DK70al4aHisnDMQzF8kQzDMVychbRmj2a9CtXoeJ3o1OzHY7MOt5MOtn4GHByK5WDNC2jK9GVJqTvZwLp/cenyYa7MPo6OVoXGhLMmVBlesGu0RlseJMWbkahqNmGRD6ZihZa0LaOmK1YryK0udGp0Hidn/ABkRDHUPnJujDgw45NwcozTwZpkNq9GV6GqnawanZgRvkdOtkQ1BkYcHKFdCusCVQRPwZUs1JqR6Y9MxfJswYcHK0LjQuBbFa9CSjKNTseJNGOnJhrvJhj45IUwRrQtrR0/g0aNGp4Ox8mIZGHyRDMURfRGhcaImU8CUr1givRE3wNUmPnZGxrDIho2RDMfIloS0xGfgSlXojw1sejvn6OUfoXBz+BWjUkyjQx8oeRyuSZiFplI0ezsP/QWZfBPDGxfh4J1yFShT2agY/od64H8k9E60zFaLmH8G4+zIn9hlw9bP0M9QZof+jHUa0HV6eiI9PQ4XTQw4ex8rI1tYI1tET7RE+0csQOWm1lHeDtUd6Hzp6MRwylWmWuUkXKyFPQalxtYIl9j8jN7WzNqoPsOh3jlHejHsNJQtPBCUJ3OzkXozh/BnD+Ccib+C3wRUowJcQ+Sln4cFPnRw0yYrR0zr8jWvuOvyRPwf0do7+5imDsx6eiPzodVp6OmfcRr7Ga2tiv2hX7RH2HaO8HZ3o71wY9M/TMVybhlT0MuHoy+6GfZn2tk7R3+Ds7+/h/hkRRiFzs6+x0zcM642IZMqfDQxTBrrgx3OjrkiK0RojT+GRNbWzNcbP0M3wZ8iN6LV6ejHp6HCrTMOOTpqSNbM1tbIn2jPtGfgza8do7Ii9PRj0zHpmKzJFwyp/AzT0RL7Rn2Z6a2TtaPs5RqUYtfJizF6Zj0zHox8kaI0JaIn2jPwJSZ6MWq5J3EERZH2HXoainstVmfDrZmvyZ+CJ+CPQ1KI3gxf3IjGCI+SI1TI08HTI0zojXB++RX7LZm+DtGpREX+CIj9EJfJ1ojCI5Omdfnxn42RJkuKEo/swpI3ox6Z+j+/HR0ZM/BkmTvgmLHVmPR+i2fg6b9MXGzSaZM1hoTb6fBm8bITzGeD18o7T+Cs5XB+nox65E4X9nT+GajemKXVHpmawfho9Z4E51a0evsfHwescFLtcCpcsflHT+CIp/DIqHT0ykp50RLujPYzimskb+52vsRx9jHaI+UyI1KZELoxWtEVD+52+DrfJ1s/DR+GiNrO0evk9KVs7/A1FxKIjtaNXaMU7Rq/hkc/DIgbxp6M9Ml+nwZva0cxkaWvlHNfYgr1wNc64Kzw9lf9k9/DGtb0y3VHplkv5R+R+Z0+xJK1jgr2hV2n46+xit6ZGn8Mjn4PwzPTM4p78dr7Hr7GPR+UzjaIhdGK1pnTOjremdC+zPw+BcrPB38kdpTyd5XBEalD/AsWYp2f8TI0/udbPdMyKfTIm8M5j5H/AOoj/wAI3k/RESMd9kc/DGtb0xJunnT8RPTXgvysno+K4PWOCr30LHTP0dHX5I0/hkZ/DZnpjvpmcU/Ha+xHH2MeiPmT4lER6OtGr+50ZrZ1sX5Pw+D1naO18kcKvGNSj9H5RHye8H/EyNfkjmuGfs/ZB/yDtEbXyhcq0flH6L3a5Ojp/c9nv4ZxpjI4p8Hf4Fdr7HpH6MXo/RH2Pf3On9zr7MjnJn2R9yN74O/wcv8ABG/ujHyfox6Z+iCNfkjn7kT70fs/ZH/hH/h6+ULZ+uD9H68Yz4X/ABnX5P2fvx/yDNo7X2JJ+xJPOOfNi0Z3a0TSKZlzknATtWfchbLeWKFPD2KvTwYrnZ064ZNS+B3CxBM1tH5LRMxyjtaJsbkw5WNmMYZj5IhGE9mK08MipfB/4I+Q19x2u1g5PKHbn7on2Olz4QlfOSI9MiK0yNsPZ2I28M1tES+0O72tGaZWjLh8nLzyUnAUBZbTIhdPZFRpkb/BAia4EuNkT8EYZE2iU7RwXydLNmrnJETwzHzhlqudnTrhk5DNcFdiGrcbWi/tHUc3AzlFHKsksYLXotfInrTJqGcT7iPy4MrtGc5REueNHeSNqyIlkJP2RHp4IitEbYeGQI1JE0ZraM+0d7R+mjNr5OQkkFUvk/4Zj09moeGdvghDNcDzBE+0PREuUZclZR2jpvIqnsiPRiuSJp1wYUjNYgp1san2tGfaIxBsLMo3OVsiMb2Y+THyfg8EVI6PyM+zPtGfgzfGjvJ2rOzHyY9Mx6Z2w8PwjR1wZraIn2jva0O6aEpcC/7CqgqvkX2MiPT2RrQ6X7EaI9DUbM1s/fBn4OE+wrEbXyYs/TEo9cmPkxXJFRg7HWyJhbRlof5R3s7zyR/sRtER6ZEemYXsjRGmRpkVG/GffBE/BCzsja+TsiLXyY9MiCIrkxXJGmRpkSo2ZraLfwRPvg7Nz+DsVWRHpkR8kQNEckURog/fBkjZ2dnZj0THpn9lY5HiDsaHftEza1kzD+RyWNk4ejfQnKYpmHInDexcbFtjmREqWTKhW0YV8mYjVjwsIyVT1snaxwOJnRhzyYbneDGRV84Onk01JqNmEbMqvksvRo18iYawPM6HTlYHUuTD9kNCqUdQLexlRszWyJ+CHEodxhGSL6Hp6H9j4MPmSIbfJCaHsiG5vgjKLwRUb5IlRwSaqmNNpdEbXyaPWx5nRF9GHMUzD6FvZGhLLEaHJaMyo2jKo9aGtKjI1vWzsi50YfvREO94ISpoUPk3UWQj0OdbL1s9bGsDnI8HolMijlYKOfsKD6ZIhLX2FvYiVGyJ8RwcPEeHp6Kzpm/ZhvsiKeyId2RlF4IqN8kSoZREqq5NLrI1hoa3rZGHow+ilcUyIYqbEs8nKeSHEENqDKjaMqiJxoeJVRkjetnHBFzow/ZhudiqnYlFCWtnRGtoifZlesjwPTHp6HmcIw5WCIcmH7IgVSiNc4F9xlRsyo2QRUrJ39yPtsdQzvRCTIhvsiKexKGJaOiNbIlRsiVGyKrRH/Zw/udm50RcmHeCIfsjXJEUJa2RUfkiVGyJXfiJhr5HycaHeiLnXBFzpkWR+RKKYlFPOiKa2RoiVRFLnY9NETDOyJvRGyLIhnsXDIiiCHED/JqjN8HZFpj5ijh68YI5Fwz96OtkSuyNGqOGNj5N+MMx6Z/YoVHKOtn7Mrvw+jT7iYE3WNieGuTdYFtG6Y2QuHoVo7ZWkZ6DSeydM7G8M0f3HTUbyTHQw/0NtaFxoVyvsJSnJmedEV2ftYI+SHyh6eys45HTUYZDXQ2+BZa0zlPAotfAiU50ZXrBrs5bQ7U7HhNZHodNRvI1FPks6Ihxsba+wuHjRE0/giZRqOCJXaLhvY4hMPnY6hreRq0bquSI9G40dCWUxLJGmZV5Hi88H5DVJkaZ2PkTDIh18kQ+iL64ItrRFxoVyiMyROTXZP3I3sipGmR2n7juowxwfRR9MWujZP7CWmX/AKJbRj2YztGM7JpPeyVNDyo3khJ18jUuijjRAlzQlNM6NdkV2Q4nY8SND5XyNWjdfJEeiLEso2kTKI50Z+B47Ndoip+5GzhjW/uOmo2bIvoi2ooSuNCsSyJSv0RPs12RvY1Uoa3s/wCMi1GGNS6EobWiMrRGVFC4ZE5Ik12RKnaGt8DWHseZXyPX5GodDUPoi40yBLkSzJEqz+iPvoiVLyRUxY+skRaI2YhkWRD6IiuTlaI5wJlCUyZ9oyjK7Hg1kfI+VQ8qF7IuiLjRFkXGiMo6ZE5IrtGVZ+z1kTDXydmzD/sw4wiFjQlcHK+wtnT/ACZXrBrs1Ox4T2d/c4a8bN9GHGjFC4EucGcmc/Bn2jQ/z4Zjxh+zZ1o9nTOT9oeDKG6G9k8EsUpT0THp6JwzNwNHKROHD+GcMtbFKtrZPo1sT0yJ7WGTDQnHLQ3HtobiOHoxqnoxWmdtmHDvgXDs/LkzW0JpcrYnNrKHJSso65MUrknapcHenof2T0Y7Qw4dnax1X3Ga2S3O2hR7LZkneIFwHw+TAjfJj0YfKejFZkeYdkZWXydPPIrrfJtytmV2jKnezj7huLPSuDF64MOfsIj5ISrPREcpITD+GNZXGzPtbPsfJnBEqVUZNQUQPT5Go6GI4ZEenoa1pkCLh2JaZmt8kTXGy3PJm+DKEfI7VHf3I3pkfEkNdpmHB0yIrIlrZE+yL1a2XOWIyc0N1T5K2ikPkp6J9pK0zhmTh+Sah55Jmt8iy5WzK7RFTs7xyOFnoYvHREOfsIh+xqKOiNP4Onoz75Inp8mZaO8Rk1AenyYGPTIj1wYrkjTIimLhnX5OuNm37EpvZmyND7Bra+SNkQRHckXHJGjrIlrZ1mNiS9lsifgyp4I2hqKfJG19iN86IjVGO09GHD2RcOyNfkjTEpr7Mh+y2ZXaNTh7H/2IdNUtj5REKfwRv8ERHeiI7TOFyRp/BAjW+RKfjZn4Fd4g1A7VcmpRi/wRHrg309GPnREVyb4EaImnnkSn2j8jJmz8MipkfJj/AERHrggxRTcO2RoXH5In2RPtGfZm+D0dmLMXrgx8mM7Fk6NtfkV088mZ8ZO+B8r5HyYsfmTpm4Ot8mf9k/gzfBInZO0YP0TfXBPKicCbx8GTp50xPTzyTzkT+zQnpT2ieF7RNyvlC3AxYSvYnkTGcclP+mYrDkb086ZOE88kyL5gT9zOPlHa+xWvgTF54E7eGauw/wAaZ7w9nCfwzp50z8tEzOmT9mjtU9oTv9DOMi6xsnjBPzwNXg92hvn4Z1+Tqj0zrD0fhDP7Ha0brPB6+URtY4NTEneeBq8GM40zp/DLx8GdPPJHOeSL7In4M4zwRw9o9fYjj5REdofqdjGR+uSE/WmdvuPjemdPKPwPwzuLInHyiNohLHyRF/YJbeCt4PeNM94eyOc6ZGnnRHOdCvNM/fB6zs9fYzgj7bPWD/hEc4IW7XJHRHH5Ho88nHeib9oh/JczwS5r7EvRT1wJfZDOeBCOivjRWPyRp/DI1vkj7kfcifgXWeD0j18ojj5Ii8oj7H6I5xyQj9MaisNM6edM4TyfgR8M7i+D/wBIjfyRC18mLzwFy8eH5Wmfp7I0/hkaedEc50Lsz74I4yejVCXHyesbPyI5we7XJ/xHRHOdMS08kfc/ZFyjdEcGMfY10R8oj5DrtERnBHJmjrHB+yPuNT0yPvtD6ztC6+Ud6K+Cnopdo17OnjRHPwz3kz7I+GR9yNr5M6PR6xwd5IjtHvB7wdPHjPT0ccn4ZD+T1k9GcfY9YP0Y+T3gr45Pfwzp/B1snk/Z+xX/AKM4+UTx9jXR+UflDrtHvB7+DonWCRP3P2f8aG+PsevsNn62fomF0NjevsxuY/A0+gnO6aJm1nYnNrQn/YhPf3EivKEivTE49PAnp0wqSrsnbBNSyS3Tp4E/YTN6aMqRm1ZOnyTFPk2LDyxONymTHse8aKywTpkzTzomaedIznDCG9Bm9omex2KWt5FVDHowc5FY0dPGjt8Hb4M06awftDc3tHexuf2O1jZudCjB0z9MxnB7ywKMP4LywO1DMmfaM+0ZtZ2ZtaI0+SNPkxLyjF6Zj52YXTFxjsjb4I2ydPKwO/Qze1oib2Rhqzp8mKfJi1h5PwZj0yPtojYa5OE8kTTzwRPtaI0yRN7RmyNDF8mLREeiITnIhKtMiFHOCNP4I0/g6w9EGfgzex3ZyWNkKZ0QWMM6YZ+Jj1ojTIeHgmofwS2JvlH5os5WUKVnaI2vkxeiI9MiPnZH2Z2rsjQlpmaiGhqfQze1ozezho7XyYtfJi0qeSJdMx6Z+GiNhrR1siaedEc4EfIib0In9iNoxZCViUeiITnBCVPDI0/gjb4I1vRmnnRH3R3tHex8kbRuTHpmPTFXoXeWDlEa08EaZE1xg/ZE++CJvZG9naOy8/cpPFMx6ZEejFc7OmRtRE19hqa3wZ9oze0d78O0dr5MGDHydPB08aOn8HT+Drgz7P2jNnZufuJ7WDHox6ZXwTDjTPZ0Zobn4M+0ZG9rJO0SLrGyY9bMYwTHon7HTJ0ydfYn7kz74M+ySSdk7G4fsmPkwTFcjemahkjZWidr5RKw+SVnTyZYJh9DfZmJ7GiZ+BolPeBY5GVGyajZMqsmnRMw1rI/s4G7Wmx2hgq50KDe0xOM7MTJNQJ5TyTK0fJNRsz7JpdZJmGhvaG7r5JmxuHybvDwJ7CyknX2JqNlxyJw2ZJlJrQ8T+BvDz0N7Hnkw50zDnTFXcipQ9i4fwJ/I1GzKjZhThozA7h/geemSnDQ8uqJh9MWeiInsVUxbRqCJUbNQZxTQ1PwRN8DU/0HlP7jykwYvTFTciUZ2QagjTNRh8kVG+RqfZH4M2PTQ8yjs7yRfWhKPHRqNlutlR2ZQ1Nq4yWUj0/wPkwYc8mH0RGRVnZ0zoiVEWWUbGjVaGHwH9jJG9FzSJJ9EHopPZDkWaZCIJlQaM9ET8EYND/DQ8p62bnRKXpipudirOyOTUHKZqN8mo2RPTIr1kdw18j0zco7MOcm+ngSj5F2LEGo2Q4gyuyJ1gzjQ1SY+YO4PzJueTcvGiI+RVT2JQ4I+RFRF6IlRsiV2Z+B6gembki5WBZk2YIIgXB0ZESo4HdKHT0djzJvgOM6Nk/YwxVM3wdNHX2M0TKjY9cj/XjvW0d6JudGzAnE9icU/jxqNmo2TRMr0Ts/onDJlzom50TDJj5MCqmTlb8u45JG8HBOzs3JNjcEmCTo6G5G5wNz8ZIp9xi/kKvTyTKsPYnDa2E4cbCeU6RssCc09YQmdMso3wS/ZEzeydMvJSNh05+Rl1yNw+mYrYT1oW1pnKZO3wTKh50iZT21gtLQmpE6Z2PB55Y21axsbvrbG4cLLYtrTJ+GicozTE5TnK0W9kysWP7ka/AN/AQys7HqPkfDDKwwz1SE7T9k6Y0zQE6h/CM+1gty0waFu9mLWScfcdr5P08nTHJMN8GJQW06EplOjp6FaszW0Ydoh52R8jh7Hyvk30OsYF+R1o6wdMjTOjK5HjoPE7O1kfP3O18jWOOSI9ERPAqrWhbQlNM05ytCtdmsWftHe+B62WTtfJw18jzWGUsYIU8Iw2joV1TgW0In2iHH4Gu0XnZ2vk7O0fpmHWORZrDEknGhLKYtCCJV+LjtEvOWLZZHtyatfJGSfgKPh8iieAtrR0xcvgyo4MrloyuhqVk4azsb3nlmLXyNX1sxjHjFa0Lg6ZlXlYNdmV2P8ne+Dls7WRrEY2bXBjFI/CLTaE9PBmVTgVynrAlPtGUEpXaP2d72PlZOGvkfK+TajBvoxWmbjR1ojJ09Gfa0TPtGVO0SPlZO18jcXzk3WDHowxuNCzw4J2+BXnRM+1gmuxuux2p2TUo2TF/cbsn7E3GtE6JtyTp/BM5omVedFl2T9ya7ROzsmIZMP2T9jcaZ1o6YmJkz7J+6J+5OxvjJOI+Sdr5Nn6J1yTcaJ0c+Jn2tD5DcqdkjeztEtd8obiIwJh8GYtaN7E5XGxfYwyXnTQnK7QqaMTrkjAQwqdExHehuI70WJc6G4fB6MO7JcyJtp/BaU9bJh2sMuzytie/uSolGH4DCn8Exenox6eijS09ExTwx8rRyX2TbTvsma42TO8bE5+NmbJcSqaMR/wAInenomH0yY9E/AmHDs3GRS3D1hihoeUflsTPxsneHscFE0LzMclLG9DeIxwNxEYDp8Hky2Rhys6OD1s4vK2ZXonQmhLwomLnOjFrZiOHobSaXOh09k9EXBY3D+DMp62flyZvEbO/uLkmpREKZMXzodRwzD96J07Nw7QuHZys8Et0Z+Nmfg7LiR0pIr9B1ejD6Y3Ho60zDMOGbh6wzLjaPyRk74J3vwuE19ikN/wDg3GNk65KVP4PuM1wZrjZhxBlejs1JO8IrPOjGBqI/RShcjpxzow4JcwJpsvM62XV/DFO8NHP7kqJQnUrJqUfpkRHBMVycHs3wOxuDNGf9iv4I3wdqiYsf/g4emYfTHXplY5Nwbh6MuHrDKbjg/JbMiu8QTs1KHiV9iYX6Fq+clK+dGKMVz5M0KyZ+CZU4jZ2anA3C0HXtof7Jj5MeuCbjkm9kZp/B1wK/ZM+0TN4J3wahTHCySsbi+dE/B6Jvp6JiidE6yTo/Zb/ZgOfsTteCex1f4Jj0yfs9E65J+GiXgnRJM/BM9E/c5E1KHBJ/gxZ3p6Mf6J1ySOifwTJM/BadQTsneBuFI3hjcDcemS+h08PDOn8E80xPkTN4aE5CfGSdr5Qow+RQ9bPuRMeiY9PAnefTN38M4POmSw86gn4ZIn4E8Z4J2s7RO18lIvJMXrZQTrXJOn8ErfwydUeiecjunk500Tva0Txngna+TtfKJqV9id5WyYH/AAz8rTJmn9ybh1wzr7iXvIn8MmcZWRPe+CePkn/smLRKz9hO9Mw+ngxU1pnT3hk6Jq8kjPTQnInjOydr7FZXyT9mTxaMejHp4KxPpkc/DOnnTJ5yTPQ/ZmYpnrPBPH2O18mMM/KP0foxTwSv9HTp6PfwZp5PwyfutEzj7E7Xydp+ztfYneUY9F/7H65M0/hnWOGdM32fsmcE8C6+SfDa+Cvgx6ez9cnT3hnX2J5pmfZ+Gj9nrJ390VlfJ3pk/KMeh12ng/4j39ydPOj3nk+PB+z19j18on/sqVvQn+Ge1ci1bIf6ODp6J5p6M0xflE/daJ4+x2vkng7X2Ji8rY39ifke8cmafwybh1wzplzeRfZ8EzjIud8E8Z2T/wCE8GPWyY7RS9Ek840Tp/BOn8HvOiZ9mX2T9yeDtfKJ0xsn7bQ/uhuBPNonn7k6fwbsn7jfwJ+6J+/BO5sngnj5Jj0T9j8OSmcH4aZNx+SdP7n2Mn7kzuzvZL/6HsjoTwT9jHon5RJPPwTrZJPOSfuiSfvs5Inf3J+xP2JXwJ8zBP2J0ySeckyH+T8idr7Eje18jf8A4N/KJj0MTz8E+pn2sEy+0ZvZM2vsdPlCcOUE8lh5E4/sJ05wyUrYZOngkTVrWGJzqhbLtDkWtCZtZRM0z2ZSs7Ji1fJMWsMmPQq3TPeNGkn9ydP7j0esE62iZ6gbm9omb2hZbOm8iqm8k5LZjGHkmK08M61yfgzp4G9PRP3WCfujNvK0S3e0Z7bJmnyTFr5JSsmHOmTHaZOhPKuSsM901g64wTPtYJl8NCc3sneyYp8o3K+Tpgx6FSc2mSlT2dPHI3/3JnsiZyrQ5ZdomY5M+ydjtK+Sdq+TtYeTHoVemP8ABin9ydMb09YJ1tGfgneyZvYsydPkVShOXJusM4aezDjT2daZ08DeidE62iZznglu9oze+Cd/cnaJjsmLmjHpn6J1NHR7M0ftYJn2iZsmb+52vsTcr5MYwfon7EpU9nTwSJ1wTqLRPOUNzHJP3Fz+zKV8k7+5MXyTHox6Z7wVCTJ0Tp/BOtosctk2K8nF8iha3khhsivRStPZ1OTthnYbqGN6fwTPsznK0S3e0TN/cna+Sdr5JXsmHOiY9MnWmT8CsPD2TpkzUkjv2icckzayTc/cm50SlejtYeSYxhlK0ydPGidMen2J0T90P7tEzeyd7R0J2id/cmFJMeino4PDOA3qS0JjdxwTL7RM3tHLZaydlLJ2Y3RMeifsTp4J08E64P6wT+CfuTstZO18k8Ex8mBv7E57OmTr7E6JG59k/cne9nT5J2OFk8YKemTHyTpjengb0STJb9DxP2DuH+BtPgPK0JuefwY9ti+U7E4bQnkLf5CvKBWow0TK9E0nwJyp4G5jgPQNqZycuSCc8icXkVfJidhYbGtDKgtI4Jpcodx1os09IbuRu5yTDnMmU5kVO97PyCGzfBpjUImVCqMmUutGVPBn0PwJy0jcq54MOeTL2UoTyvsxWoeRWmtmYDtETOjU8aG1Qn0HaWCb9kx7bE477FBtCeUyc/kJzwMqNomV6JTXaJm+B36DtI3cmJckpP2JpPmT5ycoWGmSo0JlQW1HBNeiZh8aG5h8De9DdyUc5kynMmHe9ir2J9J2KbTE5XIvBM0qjI3X9GpG/sob3onLSJueSYc8mO5E0q5J19mah5FaGo2TUHwN740NrP4JmycN4G75kx7bE/YmG0LYW/yOpgzXBn4M/BM3wNz6E3I3sWxMMxeZFVck5CxBrQyo2TJP4G5/0N7HtI9iYc5JlOROGSU9idUJ7TFWDCCDUYgi1n4JTUzgbm1om5yjkTvkw55Jj5E0pRP+jFiNkvGzNYJleiDUcDcqtFof4G8PJN/oNuZJhyTD9kw/eyYr8kxX5J0WomVHBNEyv2N4jQ3sm/0JGUkwyYnsTiiWqJpomowNyoG5RZInY+Sdm50TF8mH0YZJ1sUxB0ZomV60Oyfwdk7JuSY+Sb9kx6JiiconROsEpr0NpqETROxvDyTsbhyTZMMbh5yTyTob0TNDuifwNyOogjD+7KTlYMPrZsYcYTMNycHjSFdP7CuU8Ca5JroTKoTh7G9r5Ji1jbG4c6eTDUOtmHGhU32KLnGhbnejCH8Ccsn8EzbKwZU5aMqdk0mhvZtJQnjGzD6NuKQvwXMMLbYFw/gyod8GeTWCHHZ+zvZo/uxxTW8nrBh1jkmH0z8Cbl8HvAuH8IyuyfujITPtDjOxvaOONmLRh9bZsYrTJhtM4PHArpiem7RLjkmuya7Jw9k7+7JuVjkm51sw1dbMVo/QvxoWXInUMTomV2ZU5aJlTsbqVkm5/JNw+Sb62YfROVoVPoveBbTdaOmS4j7E12i/kmpHiUPT/I4yvk2PPC5JvrZsnWOCeRXTJqNkz7Mrsn7jeydn/JNqDfWzYw+JJtyJ6YrozWyajgn7k12TU7J/7G7lfJvrZhrgx6Fn2LYstMV09CcpyZXawfkZXY8Vkbi/ybTXyT9tmH0TfTE/sdPAuG84OmS4gmuzXZLg72ThnQ6H4mfRnmuCOPsQ3gTX+kTKibPyJrNkz7G6J3sb4+WTv7jcMyrBN9E3GtE5X4JqydfZE5ksu0OSomVKyN1KdsdCVlEx0Jh9Dd9MTw0TlaE9MT19iZRLj0O/awTubGxvZPY81hm+jFaMTwdHM/B7yTOTKMrs9DeOdk4f5HyTB+ib6J+xOmJ8/bx+yezQ8Hexvj5HyvkeBPwNw/ZP20ckk6fwe/gb+6G/uPBqUPkjlY+5B2hYZh7C3+R+my5J1GxX0fZGyZU/dk72iaGEp/BijzomGu9E+06OGRZlc2TDfxMXHArnhsa3Wxn7LZh6uSanjJNQroba/oTHRid6JiO9HWUzA20z7o2K5Wzg6a2ZXEGpwzU48Hr8B5T/AAYfvRh4omHHJh7Ts3suRbX5FcrjZsm8Cuetmb2jKGFJj+g4Xzo7WyY9Mw4WGYrMifL5OeGxXKetismbxGyZU4fJNTxkkYifwTGVPRv+hvBWnoxWTHKSYby4FLoVyuNidr+RS/gmvWyamcZJ2qjRLVkxD50TsmPk60zFHRPtGxXK3yTNYM9Gb2TvBLyPX4Dz+hiO9GH0TecmH+x/wxbX5Fcp/czl/IpfxszfB9hhSh1/QmPnRj5Jj5JhwdZE9T8nX5JmnrZkz0ZU/knZNSTEfgYtbJiOxuPnRMVmTFExyFOBN9I2KZfsT+zZMr1s1MjdT+BtqyYh/jwmPnR1pnWTlE/9hOaJlX9yZXEGVOzvA3snf4HlMmPnRSJh+yfuOsief2Sx+RO8sT/bZz2jlPi5EcDlyU+dH5klzGjZOvyTlZjDJ0TPwTlwTN8DcqSYE/8AQmL5qB2nKeib6Zh+ybsXOx1nsVzccCpxGyWyW1OGOWNEh/8AZGLWGY9Ex6ZNxowOvydcbF/xk/YZXEDtfs1OIG9kxZizHcmGbJ0dZOi3XBOf2TKng5E7J2NxaJiySfyTFO0SN6/JOvyTon/0mfgytGidk7O+Tv8ABj5P2G4rM4HpP4Onk6dMnTwM+8QZxlZR0+xOnyjpjZMXlbMXlF6DqtPAqUPGmSnb4ZuH9zPIiZ9CZ6aJm1T2csPg70yvCUr1wTAx2mdMTo+zhnTtk6eTNYgmemjOKaM4O/wTW3R3o7E/Y/T2dPB1+Tp/DOnkmemi37RnGVrx2rJi9bJi9GLWCYXQu8MdV9ht0ucHTydYZOnhwZ9rRnGVo7Xyidr5R0wTF5WzF5Q2160TrTwYpk6+zNx+Tp4GfaJ+SJ4qDN4O18p+CcXox6Zj0zFPBOFyT/oz3bHw8kyTOKaM4G+Pk7RO88o70yY9Dcdifs9mKeGdPeGdP4ZeHkz8Dl4PWUI7WjksbJ+x+j9HvBMUPjnB0fsbuHlGfZn3tHr7Ha+UdDF6O8oc/B1ydMnX5OvsZraM+0Z9ombVGbVHa+UdkxZMejHo60ThfY7fDOnknTyTNEz00ZtGTsnf3R6J+Ufox2nsxWmdP7k6+zJJn2iZ9kzjJJO0TtY2TtYKYJpdEtn4FaeHstTODyWrZM+yfkj0Zs7XyTv7mL0Sl6PymYp/B19mTt9ydb0yZrfJ+zPtGb4J2jtfJi0SkY9M92tGM4OuTp/DOtl/J+zPs/ZJPHyTGPkxejHon7H6On8MnX5Onkn7k/fgn7obn2ZtE7+52T9ifsMTyTzjRJOt6P2Z9jc+0TJlmcHf3Meifsfo9/A0pjgznJm9BXe0ZtZ2LLSjgJi1jZOWx6yMKMpienhkrLBuH8E6+BPOTPsz7RMuVlGQUZXyYtY2Y9Mx2TRaFbwysvg3D+CdbWD/AIZnOdGfaJnssnaKyvkVWjGMbRj08GFGmLjk7HR09Gf9mffJ+GjOR0+x2vkxMPJg9qP0ylTwRtfA3p/BOGyU/ejPpgXO0ZtHLVGHKZMWsbOQxh2HSjKYnp4JnodMnW9EyryZ9mfaM0yT6PZWV8nZj0YJwiUKw8G5P0dP4OtoyM+zPoO7Wdna0VlfIqKWMbMengxWj+x8jNcHT0f8kd9M/ZkTp8ona+T0zHyYXTI+zMKHg6fwN6fwThOmZzlH7FftGbR2YtGLWNkxej9M/R08HXhvW9E85MmfaM2tHP3C5XjHaMdlKtMj7D5HTOtoz7M+zOclO+DtHaFRjGDHpmO0ydM7HTOiZf8AZn2fs7kmLX2O18k8EwTHpn6JitE6+w3p45M0P9H7Wy3smcZJ5Qmyvk5IUD8CC9cHJhk84JTo6+zM9uTNb0fsz7R390dz8eHZj0Y9MxnDPZ7On8HWzJ+1472d/crKFyY9Mx6Zj0ydHTOmZqcGfZM+z9l5J39ydo/Rj0z9Ex6J08E6ZNwyfwZ/2TOyfuTtDe18k7J34/R+me/HTOtj/Aao/kjksLQ9NHAeZ5E7nMmVqZxBNk97FxiaTFP+xlas+4ZXD4P2Zh8ZQ7aTWhuXJPwFT4MVp0/wK12mL8tiqV+TVM7FP/YmtOxuVCpomUo1kzfGjj7kbn8DzwNzkJxbhjRMiy72dP7i3+xprD5OtrZlRsbn4Mw1octw0NS0f2JhzoxL09ir52dt4Pf3OUa0ZqNmfgyuIHcP5Iz6aHdo2nNG+xudMy5nArNPexbWJwzvnkytGalkyuHwfszD4yO6a0O3An4GHtJlOmY7TFVZkVVzs1P7iT2+5MrTszBZRmI1k1PGh6/AzsXBuVjg7CpyKmxVM72Lh/cWHtpmow+TUbMqBuY6Mw18jmZREsf+jDkw3w9irudmM7wdP7nRlRg62Z9oz0NTDWtGbWh3aOzc8nZlyYlPexfvDO2eTUYZqDKqmR9x6fBmHxoduTvRi9Mynkw+UzBij0yLj9nX5MrtFv4M2d/g3J2d8iqxVJj52KqYsQaa2ajZldj/ACZhoc5Wh2xw/ubkxPYq7nZjN8Hv7idNGoNRszRqDJn4OGd/g3wHmTHaZg2/Ynol7FkiyjZeOj9SLvgg2uGi39CpgbGLiZLRssi2iajZmmZXaHcDuOjN8aN/0Tcmx2YZgxm58dGVBbUDuuMmfgknZuc9D50d6ZMMknb7nX5JNCdYG58P9E7OH+BveiVkx2n4x/s/5J7OiZUGfDqI1kc4Y2PKa3sbiHjYw6pMThtbCptPGhbTxoWLzoW1lmV3omZ2cqsjxKVrZwnyy6B001jY6dYeTDEw40xZh44FvLhFq+CE6vKMsnnRnkhnsh4lZ2TSa+WTp8m09bG4crI30YbU0Km08MXDE8p/BbUPOhYjOhlVnZM+0PErOx6TeTa42N3Kxsx0h54TKT/BG7xoW0/sLadvSE9P4Rldotrlo4eWO4/JxHyxzTWNj5RMP8j9hOGQw7VaFufgX/QW1l8GV3ok5VZNSsrLHw+WcIx5TWNmzD6FTjTFlp4FWfhC7Jq8oVp7aRnkhqsoeE1nY3S/LG9o3Otjp9MdO8cGN1oWbwLh/AptMVqHk1AyqyTPtD52PTXyPNG5XyP8DzwmRD64N3hnKYuMvSJ0/hGuy2uXoyp2O4/Jwx6axsatNGPWz9GH0xK7+Bbn4PeVg5RmpvRlPaD/ACPmLWx6T5Y7j5B5TWNm+jD6Zh9M2+OBLM40hcM1DysGU5yZXLNdoeJXyN4f3HwNp6HT6MPNGJ4FTvB7On8GafwLEbMrvYnPs72PlG5W8j6wPPR+Efo3eNHKZ0/sJ6fwjXZNPnRn2h37RNVk1KHUR8j5WDfRvo3/AF4m4fwe18C42ZXLM+zXZo7Oxtpkw+jMZdCv0JMC0eSU/ZNdkz7RlUPlfJeTh/c70fomH0foVO/g5Wzp+NDddk/ck7X3J392N/Y30TfRMPhH/IJ0zKh54JcXk0P8obldk12tkypQ3iPkfOjfRvom/wCiT38Hvxn2Z9o12PXJ6Hh2OU0tPJhxoqZfk/4YnMt8MVyn9xXKx2K5sUZwa5IwuRj+ho/sHEp6bGBrQm4ymdrKVZFtbE262ti2t8mymI2JyuGiZU4ZNaMdJJ8jqHyPUYeUTJLTJiGU7gw+BMSswLMZ7E5lcbF9yM+0TK9GtCa0fBpP7oxD50f2YrMmHHOjD7EazwzYuYz2ZlcGcV2ZUxDRTU4aJrSB6w6Jix1DWxuHEUzDjRWX58JyFtCv42Z9i5wz8l4YsxfOh5T0xlHOjrTN7H3cC2tlutrYrr8mdxGzK4g1JNTseJHUP8D1w9Gi5MQynow+DMdwb57E5rgV/BneNk/dbNCanD4O/uh4n8H62jHpmHBiuTrPBvgW3HGzMmfjZlSqMqcQaleExY9GH0x040SsPwmf0FdGf9mZFGcEb4NSYsxfI8rjgx8n6OhRj9nKLdYfIuONmeoMr0ZTY8aDxI6h8j09PR+xh8DD4GKzB/yTNcCv4M+0ZXo1JqcM74Hp8mPk/Jijrk6z2bg2coz12ZU4ZTU7HiR4nZ39yv8AoxgmK5NnWjcSbj8n/DFfwZs7HanB3gnfI6/0UjY3cQbh2dCWZfIlo/oTbXZNTsnE7OeDVocYfJCrIf8ARCYOpOpOsiv4JmvyTPs0+jXB2djqz/kH9jldnROjr8ma/JNEyiSakbqR88k/nRj0THyTZuDo/aMn9EyZvgdrgdWdmL50Y+Tp3JS4NE6fwdfAV0kPQtrQ9ZM3wZvTJlQ+UdMQKlKwYvTMROQ+Hlg6e8ExT3g6yN2qHB0E5raM4p7M2so7Wsk7QrD2RLXY940TFa0YpvIuH9yecjemr0dbM+0TNrA7SvZO18k7WNlLo8kx7E3+x1sdaeD/AKDpmcr6M9Bn2j0TxlZJ38kdPkmLytmLWRfBnTwyYp/B094Z0/gT06ejnlEiZ9o7Wso5I7WDClYMXpmPYf4eCda0To/LR7wOAX4FvGVkzjKO1rJKw+UdMbJjtM/RyjFM6dyexvTVkzW9H7RM2sk8U1kna+SGVgddNk+hMPo/YnWngnT+Dp7M1NmaeTNbR6JnGsmbRx9xO9GL0XwP08GKfwdP4OmK809HW0fsydrWTN/cnaNTo70zgVjWjrWjp/B7N3lGaCv2jOMmbWUdpDemNn4bRj2HWcPB1rR0zrMnTyPMNXo62jPtEzjJ6zs7J2vkxemSJvovDwdaJ0zpmaM1hoz7PWT1rJ2js71wYvR+j9HWuTFP4PZ0dbJmtn7Rn3smbWjtfJWdbMYwd6P0e8aJ0/gXDOt6Otl/JP3M4yid/c7Xyd6Oz9eJjOCYrWiWDi8nB5L+z8kQdnT5J4vk7RjGNkx6Z+idExk68dbJ+5n2TxlE7Wsje0vZJj0THo/R+jd+OjrZM+z+jPs74NSvk7XyY9GPR+h/hjjdcGc50zPvRmx3oTN72Wr+SNyvklLGOClemLuxSzkdscjjLGinE4ZH5LB+9Dv0Lysk5aysoT/skVOt5RMWsbRj2MZFYeROnjTJ/wBCZp50z96M5prBn2esna+SVTXyidomMY2YmLTFSjR7csOMO0Tp/DJnOdHWzvTBnprZPw9izNOSbpQ9lfDKKWMbRgY7YpU8M6fodP4PeeTKt3pmf0M2O9omcZ2d/JGLWNkrRSvTFHwPvDOtHT+CnnKwfksH7J+68J3vaJ2vkVOVvJMWsH6fh08ida0zr7EzW1s/ZK3T0Znk9HafslZWdno9Y2arDMLkKsudB8sHRmt6J+538CZ6Y38MzarkkrXyT/4Y9Cr0zFaZ08aJ0/hnvPJ7zoz70ZvaO9k/9naMWiVopXpn6PeGdPBqGU85WGfksE/fQ33aLzsne9k7Rh0Skfp+EaY6arQ+PsTrfPivTWDM8nrJ2vkrK+T0j9bMTGGa6PblDiIeB/8AhM+z9nezPTPwz0Sevk/XBj0Y9M/QuNHTwdP4Z0/hk/fTP3yZ9j5Oz0evk7WDHplY2On4e/g+SZzkmfaO9neztfY9HaxsxjGzHpkxTHw8HvBOn8H7M+xteH7J2sl5+5O0/aPwKejvg7kdkHn4O33Jn2N/c/Yn7k7+5O18je9bR6wfon7E60daPfwzon76fiZ9j/O/HZ39z1hmPRWNM94H3Z0/g1H2Og4h+h6fGjL6M3C1seY2tmG9Hsxutm04eGYXTwxYbbIUTpmtGsGenwZ6a0O1PGicuNH/AIG5QnbeZMnkxPwMTNp7G1FclqVzs/4ZlaGUloTK4aH/ANA3LX6H+Ampkdp5Nt5MPlPZ22YrHZqHXZFSo62TKjDRnGVoz7Q/wHzxkm4YJizD/s23OxZd7F+CXEPHJrThjtc+ScYND1zwP/wPKa1olN7QTcL5HmFrYnHRmN0dt7MLpmpVOyK5C5UzrD4M5ytGVO1ozfGjMM3KJhzkxLyn4KvTE9Y7MV4ZUY4MpLaG56gn7BuWnxonfGSdow5WxZb/ACTGcPYntsxXOzUY7NSo62iZUYfBnH2M/Gh/gN74yN3DBMWYsxO52Kq52TrWmS8P7k1GOB2J1taHjvgd/wCh6jWiZhm5VrZuGNmL0zD6Np3sl/c5wNfsTUEz10T+NDc/GjN8GbNyibkx2n4KvT2LjHZ0fsPEYMpcomaw0O/jI7dfY/Q7Q8zybf7MZxyfsYrC5OnXZ9h1hoblJYfjP+hjvgeZRizsx2YNdHTo1H2OsGo/BmjOMrQ/uWiZvjKO0zvJNysHeiEvTFXrk9/c6OsGoM1iB/lGb40d/g7FmdE/AdOcmPnw5ROudkjUGaJT9od3wWPnPR3o75Jh8n/JKVP7kxPZ0dM1BqC3tHM5GUkRy+5T0Sl3JMdmKe9moJqDUYM1wO8ZWh37WiZvjR2dnZ/Zj5MfOzo/5J1gyoM1wP8AI+UojI9B5T1saEa9jgyPwFw94QstMUYT0iaaeeDK/AyhcSsmUms7ZqVfLGtjCPXI8ysG6yMOHgVMnh4Qsw/hC3OsIXG9EzbKMrnQpqsll2cNfI4axsczOiIfTKXTQqb4eBU2sHgW5+w2U/hHW+DTnPBlfgvA3KlZ2Xlfc0dOWbrCyx/jZMe+CpjYVOHjQtpivPwhWvWEW12jQ1WTSazsbbh/dj0lG01h5G4SMsmKZE3GBuH8IW0ysfBE0088GVAyo0NTsdpPfJqU55Y9NBuHKxyN3KwTfYw+hO2nh6Fn8EJ6f2FxsmV2iZQbrsn7k4a+WdrGx5nRh9MpPomG+BU3OBbkT5+Edb4NXkmV+hrs/wCMb4+49R8n62P8EipgLMP4OUxOZn7Cc0TKG6jLHisk1WRvY3sbtPWx2TXsTfTJ+AuGJ5TJW/hE6eSdDK6GpyanfJ2r5Zw9bG4fXI2plYJ+zN3SJtPsLP4C3OODreiZXaMrseOx47O18sfK+R8rBEOdMqehU2LejFuTmfg1DzwRtkyq+Brs4azsb2vlj19xjGFlj+yMew+NMXDIymLsT1xgyuzXZrseOxuqyicNfI3/ANswTD6N9H4R0/g9/Au/sJynOT9muz0N8E4gc5/I6jjZsb6N9E5T+CdGr+ETR+zPscxR3vY9M2oNzof2E30foXeDrHBzPwa7P2TXZ+z1k9fJKyvkr4Z+jZvol4J0/BVh2ziQa7JlLkbqsj5Xyfjsx6MMw+hfZE6+x78czkzPJErtGh3g7+4/ktjqIUoaJYfJUGmVL/M2+Arn8i0p62K81HGy2TUFtaND23wYUzY9J8jprvQ6a7Ihxzkef2MOVrk2/wAjNscium/QqOagUp6NTs1yNTsfK+R6fOhukKDyYZhxrJUsbbX2ZbQrlfk96wK12imu0agaSfJw0Yh8jqHybjKZjkmYca5NtETT1hiyT+GZ+DN4MqXon1ej8nUGL+5iHpjeI3kdNJYeTENG2NtcCuW+5sm8bFa9GVLpmZaDxOzSc2PSDyo3odR2YcaZijDljk2/yM1rkTnIrTmoLfwak1OzSY+R88jcNbTHTMONOzYXK1yTMoVyn9zPxgyvWyZ9o72an78HaOH9x1HZUxyY6G40co96Fcyf1474J3gnZiydj12PKSwYcGwnozQnlfkTn4JlNsltTsne+DhnEib/AKMR2bjR0Jw+HJltfkzTxyZz8CczNQZ3g7JrkPkfI/2N2tzkwzccm4Nw/uTMoVyvyavWDKMrtHayPE7G8NHD5yM37MdGbjRtoUb0Zmfg/o7HzwX/AKDdSh4nZiGYjsxgmzDg3GuRPRmiZz8CMr0anBO9j5P7MXyOogx8mHGhO41o5HXBmSZMo16JqV9jQ+R1Bh8jejDMVoXB14yZXo/oeJHyOr50Y+Rj45NwdeOj+jJldmp2NuJNTJj2THyUa7MibgnX5FxozQrmdC+xlGpNSdodfJfuSGqwfBipzgxbZgQ6MK5Twwy/YLJ7RmmTtZWULgTpjYqtY34YrKex8aeBch6Y7YYImnhgyzaM9tDvqDsbhiLRi4otXFHrBSrTJ08PDOx1vRmnkfEWsH4C36GbWVk73sVWl7OzF62WvTMI0zFPDMWedna9yds6M5wwLja2dKaLdrKyZ9NHKbydnY10e8MxU5wdP7izIuXLMzysMn5I5bRLsso7WVlEidr5MYxsf4Zj2HxrROn8D0mdPOjOcMGX2jPtDc4OxuSd62Wr0T9ilWngmK08GKZ0Zp5OtrBn2jPsnaysie97Ji18kxZi9bLXpjfwY3Ch4Zi33O1nbJvtH7RnFMt4Ozodn6Mej9MxU5wTpnRc3Zn2iZ9omZ5RbtZJm/ujsb2vkTj0P8GPTHxzgnTG8J7OnnR7yjPtcEz7Q3J2h54bJjVbJi8Ib4wUq0ydPDwTFM6+xmnk/ejPtGcZR3vZP32YtE7O9bMejFaZ08GK/JinfZ0/gm7yj9rZn4L1rJ3s7Ri0YvRi9GPQ5XrgeYeCdGbGR086M/BM+zvZ2YtHax4we8M6eDo6fwPg/Zb9o9GbWifuf+kY9bJi9MwYyYrR0zp5Otn7P2W/Z3s7XyYtfJ2jF6Y67TP0x8aeD+8HR1s6/Rn2jJnHz4vJ3ox6MDX24NwdfYjTOi37JLC22ckSskr4Jj0Nwj9Mzn7maedMznDBlOEwOHeHs7WeDvHRul7Ri0YtY2fliI7Y/Arb5M0/hnWHpnunpmemWvDWUZtfA7WdopWvlH6eieMbRisox2mdPHJ0/gzn4Il3lYKeaQd3hoV3hnaV8E7+SMS1Z6xtHxKKXbGKyh4lh7O3wzp50Ny4+zM5ysC/K2TN4aO1ngxT7Dqnyhx8cH5bRitj3gx00dM4T+52ysMz7Ryw0ZU4fB2s8HcQ+D18kxg7MdplLtM/DR2+47p/BM1hoXdNYZMvsTn2drPB2s7RhyvlH6J4xwY7R+Uzp45On8Gc/Bu8rDPeTPTM3hk72TtfYxaPRjtFL0zHrkeOxwn8M9k3H2Zn2j+iZ6ayd74On2MWvlH/ACD9Mx6ZP2Z1rROjr8jvOdMz7Rm8NGbwyfvwfh8HpExgxaxs/KIitM94OprkzT+CdbF3TRm9ic9Pgnazs9Z2UnK+Ucx8CYxa4MVkYrKZ2+/hnPwO3eVhmadNGbw0ZvDG974J2vlGLNV8o/KMdpn6HfJPZ0/hnvOjcfYznJ+yZ6a0ctfY7X2MWvlFa+x+mOvTNdHTwYrWjsdP4Z/WD39z9kn7OztfY/RWsMwoyYo3Dxyf8km4/J7P3o/Zm1kpYp8HT5R/yD+yI9M60Ph4OjtjTOnrZmnkz6DuOTN7P3wdr7HaPWGKvTP0Y7TOmdHT+GZP2Z9n7PWUdr5PR2vkx6Z+hrTwdaOj/k+Px2fss/Z2RtfY9YfB+jC5RjOD3gnRlH5G/s0YSsrQ9ptLB3taMuPyiIcLKT2Pwezth4Yq4aGp1OGJVP7mVIyoiGtGY01oa3taNNloy/0KmHyjcq5yWnKdcmO09lejERX5EolP7+OowZUcYRErhoicu8EO2tlo+58HKfJ02YtfJl0Erd0RFaEqlU7IW8EJ8DPoNSu1hGfjQ77IO2uGjext5mHOULk5TP22Y+cMhYZX9DPBHXBnrgcllaHdza0ZvjRl/oQk5WyEnsKu09n7bMe2Ga1nZFDK0MqNrQ7jngze0Zh7Mufwb/Qm0+TFreWY7nZXo9mK52ct9/DUYMqODK7WjO7Wh5T/AAdk6c2TpsxaPwZjsxT2LEc78aa0gma4HfxozHK0O740O2uGjc5NtNipzMi5OZP22Y/QjTKVvgzR1wZ+NDu1laM3taO/wZf6GHKsqZmRV6ezBiuT7Z2aGowaj8GY54Hd7WjMbIy5/B+2jDnMmLT9mO52V6PZivyYmXyTX4GtDKMrtGfa0O2n+B/+CdOT7pMWr5MuhgxXIsNc78MoZod+1oz8HfGh3D40Tc5FmGzHcmNzJMfOz+yNeGhqHTOmZ+DMcrQ7/wBHf4N7cn/oxLymRD5nZiV+RVK5NRgioZlDNET7Q7tZWhmbyVk+4i55K+RgXB0RpsaqODNGX6M/GjN7GOGPnkVOeTHzsx8mK5IOjKh6Hagd/GjMcrQ7v8G7fB3nw/sxPBijHzs6/JoZpnWzPwPQ+fwdnejFmJZj5MSudmJRqMEaZlQZrgj4aHcRjY5t8hu50ssdNNYZSlplTwngWXOGbJ7whLKedC4dszb0OHyM9jKrI+eMj01j8j5+Q8p5EOnKwYcvDFWFPQqbnYmU/gX3ESo2Z6DK7NJrKyZtaGnWBZMtJ8jynow+mY6cG7wzlP7CzDVi44waghx2jKrJcSjh8ZM0xsa2NJOdG+ik3wxZ9m4+CFtCxGWZUHDI1KoZQ7j8jmy+R5lYWR009MpS0zD9izeDZPeiHa3oXGX4OHyMoyqyd8DaofOtjwjDHTTWDDnTMdBU3Itz8C4eTraMrtGUcNfJ2tDTpr5MuTaejD6Zh9PR+mcr8CzDyLjjB1s16MqsjtScNfI+V8j5KTnRhmG+GbFwNkLDWzKg1yPFDQ9fkemjc62bTOXJh8Jiy5wxbn4LtP4FxszYcBld8mTtDaHzjYeYYZhzow5eGYb7FTYtp/B0RKjaMw2jKO18naGsPBZNysbHmdGH0zKNcG+mXaf2EtP4IyuMeGjPZGVKOGvkfKwP8GL0TfRhvs37FmGLa2LEGoNRNltOMmV2O1I9McZNp6Hnoi+xh3h4MZ+DmfgW5NQagyuzKrKHiQ1VZ2d6Rwzc4Rvo3+kV9z2KpRytn7IlVkyu0Memh8o7Hnpn6Gr6Mf6IFtCx2afJqNkUQcfsen4/Rvow+jYlEz9j2LjjxEp8mfaHalD0zs30b6N9EX7MZwRz8C2dHRrsijVeI+8biOGbDp7IpNjn8hKZWkLLgiVujKZlJqoyO1yHjkjjZ6HUPlgcJp/Jh+zKFgX5eCFszMzozT0JSpeUZlwPktURX5D0+dGGmOmmvkpPpkUMGK1yxR/sZbkJTK4FaZlLRr0N0HhJngdduB/vKHKiDa7MOMoxOgmp48m23wcHQrnoUv4NNjxPA8SPkx7Dprsww6cZFTaOQllaRaZP0NNjtJ8DxOx4naOOQ6h5l4GoaMMw+j9hBbGZkzT1gyp2tmVPA8B4n7nD50bTHTT8REFs60c/kZCuVODK9Eyro0TUjwth1/Qf7HqDD9mHGUYrQv8A0ct8C0ZmehXnVmpHieB4QfP4MXyVKN+9mHAqbXgrlcFpFfwaM3wPE7RqeDhjcQ+RpJHyYfsw45OUILYzT0Zp/BEq8o1I8B4nY9P8Ew01sbiH9x0/eSKFs60bYy2FcrjZlGVZr1wN10OPwG4sdfOi1EDG+TEoTz+ROWOD+5n4FL+DUmb4G6kfJgxDMOtm45ybjJuDrRmjORKVDMr0PE8DtSOITHVnZh+zD9kXBitMjWiMoSlQJSrzoz8Gp4HiR6Y1S2MXyYaeSIIhxyRcHKZ0ZoymZU4aM2aHOTBh+yY+TEcHXJFwdCWTKgyvRk748dkRDHVmGYfsi4IuBLRmjNMVqGZXo16GpU7OGPk7KNZGHDwzH6Dqvgy5ksYZlyydbWzPwZtZ7O8GKL2T8C1cDF6ejHpjjLDMWw8D5HWXRbcbRw2tmV2sscu1k7IP47QqXDgdemRFaYqp4Zi2Dp72fi2RL70zJ8Dpkz0zN4g/9IXKLyQrclL0yIqaG/28OVlnK2tmfawZ9meyPyeTtfKHOHyjvRi9DSUVWjd4ZgOq+DNyWMGXLOjNbWz9DNo7wYpnY38DF6O9PQ69MxWmP8sDUUzp5M1tEYbR/WWO7XyZsjQmOmzC4PRj0x1WmYoxTMU/g7aIvvkz7RmeTN4Zm8Qd/cnaMWcuTHpkRWng3Hh9zM1tGfaM+xXjOyd72dr5RcQfwd6PwHCjjRh3hmKOmbh/BlwyZrg/QzaOzFpeyaGL0Y9PQ6+TGdjr2wdMnTyZ9rB+SP6HdombXhL/ANBUuHA69MdVpmK0OqZ0ztojPPJl9ozgzeHs1OIP/SJ2l7MSykMemYrTwb8HWXo62jPtGfZm1lHe9naNTo7X2HV6Z+j8pmKeDFcnR1vksj7omb2K1Kydr5R2YEQpWHkiEYzhnXJ0yNfY6yz9kfIt9QZv7mbWjX5GBi1hmPRjtMawiNM6Lx+SNfkhv2jPsz7M3wdnQx6MfJj5I52dM6ZuNj7yjPsz8FuyNlRK+TtGLP0fpnvBiuTo63yXjZH3M+0ZtHfB2dmL0RHox6ZPKvYznPJ086ZnpNlvp8n74Kd72isr7G5Vp5R3ngYXKZ07R07Wujt9zu75FtPOmRsZ6S5M9PY+Vo7WTve0drHBi/sJqrWylWWN3jR1+TtrZWHnk3f3Mj8NaNztaOHvg7+w7yto+JTyjnaMD3fB08aZ19mLh50z8aMzmhxprJlysrJm1XKGtr5R2sMr2jF5Y/Rvrkp1ZcnW9it55OnnTInpot9HrJ+9o7X2PWOB1eeB9yZ1o6ytH/DO2dM6edMjYz7F9mbk9ZO18o7X2NtraJ4wz8oj/o61ydfk6/Ju/uZ9kffgy+1oja+x2vsdq+T9PKOdrg/RjtM61pnX5OnnTPedGc0Pw9mcU1ovK+x2vlHaPyjvKZ+mfop0zr7M95OnnR+GZ68Z/tHa+x2sbRjvgYnaejrRfwdP4M9uTlPOmd7HftbM9Pz6+T19jEvWyflFLteOvydcbJ0/uf8AEzPs/D4P6OH+DtfY/K2Y7T0fo/R7s6eOTp/AuHnTP3ozmmfhmcZWjNqoHyl7O0flHeUz4HsdZwdHWez/AJJ7zpkfDM+9nqns7X2PWzGMcH64MZ3gx6I5+D2e/hnX5Mxyfjs/ZFz9ztfY7+6I4xwY7MdyY8dP4ZGvszr8kckY0xr78Ef+Ef8Anj1jgx6eT9M/KPeDp40z/knW9M63yZ9ori0fvg9ayfHj9cEJej3aHWcH/Ez/AJPn9mfaPR3+PER/ox6MZ2e8Ecj4Z0/uN0j7H7TwO7fSDLSfYs9jcMbMOcrbPuTE7cPZEdHSZqVJ4ZCz+4xngz8kX7aDu94gibWVUCcv2NxsU8qeRRJ6ez8HsiKeHgxTFGVSdqPyM+miJ9rRmXtaM0+xl7vg6L2YvT2ck65FWcMwoxOzp4I2xozwRE1NrkzW0NfLQzc2tGfQmXKyc6Mw9kRE7YUJO6YqrT2LbL0f+WaDtaNaMwuNEfg7fAy0n2MpIuHyYc5R+DFU8PZEdGYUqnZ3HrAzwPyRb9rRE++CJta0Zcm4fItGHkW2nsn4OpI58dqk1Do62Z9rRn2jN/gzTJnmz0zkxfJieBd/cwo5Ong6LdYHdYaImto/JaM7xozfBZKMdHsxeSI9PYsuGYrT2dvg/wCH4ZSWGh3W1o/oz8aMtJ9h3eTcr5MOcmCY/wBkRnezClU7Ow9DIz7RfstH7M2jNwcpfIpVMPJiXyY+dmoZo7VJ1g62Z9rRE+1ozf4Ohl7M9M5MXpmPQtyjFfk6eCP+xmiJqbRn2jPtGfjRn00WtZO9PZht6KUvKFU3T2Kq0xcvg7fDI09juBmsQO640ZS4aH19jP8AQ3Kvk3wMOdcmPTMfOzFcka8I0RNbM1wRPtGb2tGXP48OzBiz9MwdfY6ZGsETXBGD0Z9o740dm5OzH9mMYZaHVckaZH3EDhcHXBm9ozZlz90bkxZhzp7MemY+TErnZEKCNMzWD8Qf1oz7R/R3+Ds70YlrBj5MIxXJGjoj8D4OhxT4JOH8jJNfI6aaxso50Yd4ZEZw8CUMKpb4Ets6RDgMyjldrZlVlZbHcNa2cPHJ0xsdOdtGPYx04Fm8MVOGqIz9hG2TNbEqjfI7UbNVlGlGVkc0mNlzwR3oi5wibdVoXeGJNOGqMU/gjKfwIIltkOGoWSJVZWRxB8ZOMCIw/uPMrA6cjbby0Km5w8GHe9C4O2dCmGhEqnsZVZ2yIcNbIw+CTh/IeU1gNajBRzow7w8ER6YlDtCqn8CWnkhxGzNfcZWbWymqysju+B6arkfKxsfOjF7GOnB7wxKHCUyOSNHWyHjfI1XZlVo0mvkc01jZ3o3MUb6NvgVZwxJpw8GKfwRoSrkRKjZEqNkSPE8ZLzgRh/ceZWB0+jc6ehVnDMOH9hHWxTDGa3yW1WdmHED54HLhr5HprGx5UYKOdGH08ERnDwJQ3Iqp/BeHnRFRszQiV2VFazI7tYPwdrGx86Y69GOhu9ipw8Mjn4PyOtkVyHajZqtGk18j0nyPMMG50NfY2+D3hiUOGYz8HQsRsyo2RNLJlDuRw8ERhjzKwb6O9cG3OGYcPehcHWxKmm70ZrZmmdDtRodModqThMbI3oaudG+mbvDwRcPGjGfgjTOVvRqNmjOMmcaydrWThrB3o70fox68YzsxQuDT5NdmfZleODcj50Or0f2JQ7Ih3sjkjRytmaRn2O8ZNfs4g7WDsaRvrgS2wz3fAuNnKeSNDtdjtdo1Q7RwyN6Gt6N9M94Mf0e94IimLjZqDo12ZiPFCN5Hld5MQ5zwRDXBk0EQ4f5FtvgSZTInOhUc5X3L9kZXIikivZy2PKfOR5UYeTDjTI+BWNG2hE4MV0xKZnRlXTWDNtYHttGp2YUrO0PlUYh6eTL2bjTIhxNGJkK60Nb8iFlo16NTtHLgfMGIDq1Rh/sj8mUaMVoVTpqTLawtCuUzK9CxedGV2PbfhiOQ+V8jpqDFNlJ1hip8BGmLaLSmROdYIg50X7DtTs0th6ex5T+48rh5MPoiH0bjQlbQlMBdiuU9GVdNYM+hy2d7NT90ejjsdP2YcckQ4OZwK6E2zXGxctGvRp8mp4HycMdWh1/Z/ZhxoxWiPgKW4xwRNMyvR7yZU7Q8Tsig1hj55ycGGYfQqfALh4FtfYVzJmuDKfWBKux87NQV7HzhjqPyPK42YfTIvoqY12JW0K4di4fwK52RlesGfQmZbNTtYNfkPMqi1fOR01wzDjREODEzgXDwLT8ih51s0zT5My4HycMdYMP9mPkw40YrREdBcYOUzJ+zKNTtGux6Z3sdP8j9GHWDcaIuNFTGhLK+xmmL8oynOjPJjxKydnrxs2jDjRuNcnWhW2hccCsz7NFxI8SdjW0cG6MOOSL4G48K5P6Fgd3s/Z2QdmL5H+zfRGjd4OjT6MmVPBn+iK7HhM72NRfjHo3GjcaIuBLKM0/uRkyr0aHiT0RwMcrNHopNLT0dO+B17WRp29C2nlBKTWheOUZVew+FM1CuTFBzSeyHKhPgZdaG0osRuYp/AksOzp5WCMNiU+0W5ayRKWCFYfJ0xwY6bQqGHEU9EbYeiNZODvgSuHbM2yK62hWdkS9NtmbVckpp6MmuGy05+w7mEzD6eiYca4NpjFOztb0dPK2K5W+T8lszimsk1PBqFcnT5HRH24JjVtGK0zcPY6EadvRGnnRkWmy8MozjOxvSman7n4DmmsbHUNZaMPFaHWx2On8ELDuDrYv/AEdMoib2RMPDWxtZXyYoYv7mPTMPp6MVlPR0zFOxLTs7WK62LIzj7mVK1klNQ+TpgtB3pmPY3B+BinZ0/gXD1sVynnk/JbM4yd7Rr8vB0fofqW0YrTOngdex07ejp50K21tH5I9Z2TpTO18nZdPWx1H4GH0zFaZimYp/BWHZmtma2tkT00K7WeTMYNE7Xyahjgxf3REemYeKejHaeiHjkxTsS07I1loia3o6MhvFcsypWdmVDWfDFr4H6Z+xuD8NHTsjX2OnoVynnkj5DKrKNTwagO18mFODvRj1wYzaZS9PRuHvHh2zozTzyK/fJn2i2qyZVfJwlQdox8mPR+mY9HXJ0zcPWDNPWz9ozimZvZ39x8PDv8GPXBH50Yrk3wNxwPjZ1szW0Z+DODNnf3PWDHyY9H6Zj0zcZ4I2MV9jrfIlM8mfaHd7O1XJqV8mpO9Dq9PR7wyIfRuH8eHTzozTzyK/fJn2jVZMqvnw7XyYvTMej+y9r0yMTnTI088kS+WmZfCZIl8J+TbaprIuU9o7+QpLlcGLyxS7HTtHTxplYfyHpPOmRfemROaGeuBm9NEcU9oScctoje2jF/YRHfA6yFi17HTwR/0zrLY/TBnI3wzfHA9KNj19jtfKPWOBKO+Bj2F3bH/Qy8a0yefhmc50zOaej9meuBK9tnae0Lr5R6xsaXtPPhEVrkhYfwzHfDOJzpnvOmZzky+NjfaNuM7E+HtHfyRK+B/cYXKJ1lHTxyVh/DHw/hmX3pmcjPTM3oeqfB+Wz0YU62RvPA/I9qj3g/5J086Z+z9mX3wYf6HqmR/0MWvlD5WCI9PRH2Pyx79GXS1ye/hmc50yJzT0fsz0+CeD0vYuvsesbI+2/DrXJ7+Ge/ue/hnvI79m+GZffBtxlC/7Ha+UTB+UY9H6OJ+CsP4Z7rsi7zye8mens700eqfB/wCj18lL1wY7H5HtUTzhn/Ezp50/DOcmX3tHquA3xnZ+XB2vsesCUeiF8Hu2P+hnC1pnv4M086I5zrwy/wBD18np7PS+D1jZH22X7HvB7xo945Oj/iZ++TYz0h+Hwdr5R2vsTwesMx6HjoirtHTOvsZp/DM9PT8P0P3s9Hr5RzComDXR7we8aPfwPj7Mff3P3o/A/DP2dr5O0ej1jZ6s/R+j3g/5J7P2fs32fs/5B6+Uej9PJjGD9Hu1oY+Psf8AJHpb58M9M/fB6+Udr7Ho/Rj0fo1yj3g6Y491oz6aIntjulvaM0+TFLkxykJShh5IS9PZEStPYoVg8Eb4ZG5E06ZqMNET6aIm9oU72so3Ktjz9wiLV8i2+4VemRErWmUk08PZXScMSf8AQjUQyPutETHKwj9oiXO+Br5Havk7+5+DMdpkR0Oork6+xqVGVL7Goi1o/Bo2nvgd0yMuUs6XyzDha2Kr0ZBFuHsimnSJrk2dscjunUYM1hrRn00fszDXyiZp8k/cYpaeRKUrDyY9PZitPYllPDPw5NTKdYZldDPtaEpvjQ2nS2jtWPMPkxavk5a2zvTMSorRg1pn2cEMRrBH3Wh374P2jN74HwydL5Nyvkn4PZ+mY6E6iuTp/BqRlSM40O44aMuVkd2srJM2jcL5Z2rWxVZl2IieHsirwdOuzt9zNOtBqawmj98H5Y3NPkzQ75MfsLJrDyY9PZitPYlp4Z2wRsZrDNdDPtETe1odvZrKO1bHyvkjfOTlNcn65Es8EJKNMroQEljBGtrQ/uWEO/aNz+B8Mm4WYv7n7H6ZEdDqK5On8GpUZUqMr0acNHazwO+yM2sm9uWblYeTF6MPpkR65PeDUOjUP4OmZrgzW0f0Zva0ZtZ4M2dnejGNmPTMVyYpmoZmsGa4Jn2tGuyJvZm9oza+Tc/ciHJSvkx6ezH+zp45NQ6OvsZp1A79rRmOGjPvgvP3OztfJ2rMejHpmPk6OmNadGa2Tzkz7WjNrPB2Pn7m4Ha+5iXrkxjDOtPZ1rR0z2ZrawcNo/oze+CJvZ2bk7Tow+nkpemdYTIymRpkTTozTzoz8aGt6DUw/uRcMbGrlexRzpkJZ7ERLeNCbbwJQ2mvRC9i5JZRYIlBqC52PTWsjuGtZGrlYI3rY1dKEocrDwRFt4I08MSymI7RatipG+zpkwRlZgiVDKyXT4yNYTA6vWB050YlpiSnpiUZ3gSyn8EL20Q2nto4DKjZr0cDl4+5tPWzDlfAqZ0VfBh9PBjPwdr4KSnl4OQdoKUNoeEZQ7taHcR8jzDGzcrGx1eilnBiXp4FWdiqVHo52LiNkTDZlOMkSlGjUpYyO4a1keZWDv7m5ijDnTMO8MxM4YuH9hbRlRs1G+z8jgp7MxysnDWjPTY+dDpzoxLRSfsSjPwLbH/gioGoESuzXo7HeDh6NzNbKmYof4KT6eDEyLu+BVKeXjwajZFRseK0O/gdw/uNY+43OtjpzplLODGdirOxU4I+RdNkV2ZXY7iB9LGR3DVIeU9DMOdGN08G/ZWHgXApwZUbMqNn5GCKZmI1k2nwdofOh5nR+Bh+yIzsW2ORcRs1AwjZn4MjseU9G50Yc6P0zHp4MTIu7ekKqeWfkajDNRsiu0es7HcNHZ2sbNzo3KwbvYqoW5Eco1GzUbMrz2cM3Jvpm/K2J5WzT2IqDPwO1WjKTNIemPM6MOdMx8ir0KpkvDOvHWzPtHr5M/2Ozs30fow50Yd7wY/oVSmLfJqDKjZFeh/nY8Jo/wCM7RudG09H9mKFuTFHR1s1GzK9H7Q9fkgiK7Mk8zkyUYeWUnCxsw4gLMbHLY0JTTImvgWT5MOzXaIpP7B4Pex8r5MNNYHTUYyYlLo3ybMT9wSynhYImU8EJq9YIlXlClqdrBEy2a5Ia0yz/wBDWPugw+jKNMVOBFtPGiMp4EplU4EpTX2Mq8rCHaxQaqdjmE8h6eW8nDWxyofyZj2ybrGxiUxyJ5Z/IktoFMxRaMqHTMrvRlXhgcxO0aB62HpPuKvnJkow8mHGtmKCzDy5OWxoV0zNP4Ip8ow7NJ7NJhrayN7Q6ajBMYw8mXRvk2b4C2nhYFcpitWZXotqeMGVOzU7Q+GfB6/JjoYfTMQEW08aIymK5TpaFah5WBYvKHanaNTtDxOz7uR1DQ6hr5MNJY2b65MSmBZbMSltYCWU8GVDpmc/BlXganZqA42GNO8mGow8lJ1jZh9G40xcPGhXajp/BldmV2a7HyGsPY+V8mGnrY9Rh5Ih1g3wez8Dp40K5TMqzK7Wi2p4Mqdmp2j8iQ9P7mGYfTMONG2jlMV0/gVpp/BnOVgdrFDvZqdjxO3kxEGIj5MP3ki+mYC3+Qtp44Fw8GaeUZ/oyryjKk7zBqdnex8r5J2vkw+nk30YcaIUxo6FuRYsya7RlSsonex8j5Rj5N9PJvorB1oXGjMyLv4PyRldoyp2aQw+VseVwyIfRtIYfRhxo6M5M5+DR+zU7G8PY9Mxa3kw/Y6fW2b6Nxo60dsaLYrmdGc6M/Hh4lZHrk9GIj5MPp5Nxow40LjR0ezmTKs/aNTsfKyRsfK+TQ7TLVPDIacsPA0eS4wRp5WxL2YM25wRpTWxaNZOUL6EYNjpsnojD1oNRWno4yTIhxng7XwdPKIlNPIlyhrBTjkXDJ+SOPuO1Rj09GPT0RFaY9nsjhnZ1lma42XTa2X7LZm8NbI+WZPyNQ+TCkcJOnodenow+now45N7HWmDLh6Lpxhnta2ZvaFiVlDxGmah8jxMwYvTKenotU1TMWtMgR7Rg7Z5M/sM50xKj7uEi4DKfYiJPzU38Ity1ZnByB91XxBnBswtk9HHD0Oq0yfZMw45MWvgXeUcBLlEFP2jNo/JGkO8IxawzHp6MVpjWx90nWWdbWy6bR+S2Z6a2W73yf8AowvyIhT+B7LA/sejDvD0RFcnWTp/B09Fs1xhmc5WzDtGpWUajT2a/I1MwYtYeh16ZiuTFPDIEa4wRNPPJn8DMyZxlCljlovp0RktjpTmdHHD0YrTP2Ihx9jcrFxxg2WxL0awVT2hXayfkVA7wYvTMenoxXOiNPw6OtozXB+S2ZvDWyG73yd/c1P3MX+DF6Menow+no658On8HXBmU9YZn2jPwd7R+RNDUoxemYPwejGcGK0zrjw62jPsz8bM2XngncRyd/cmLMf6MfOvOKOnfjPtGfgz12do1Phi+T0MemYp3JsL/odvudZM/GzPszZ3s6D/AOyOzHyYfR1pk2tDpnRuPyZyrQvuRk/QnZ3hFq1sxfJj0zFPB09l40dF2tmfaM/GzN7Rm+CZlxHJ3onL7jq9PRj0yOURcP4Z9nDI5zot9Mv52ab+Q7v7DtfKMY0tGO0PHIx3yOtci4+DKmH9zcOuGe8MCh3gfhnarYhZ3wdq+jv8H5WxUPyOng1H2Z0/uRrHDPdPR+0NfdaIn2sofOR63lHenoipyno7+Q/uh/jk6f3HpP4ZuH8MuXNcDusDNbRM4ytcmZ52jX5Ixavnowuil2mY7ExWtMjm+GdN+mfZwz3XA5I2RabbwikNUiT7fvyFeYWBz5SJPQLiLwlCS6X0OLY/0crHx5chz7b+AXBtDYGdKqk+ETJ0/uVh/cnT+Ge3aPwz8M7VbHe+DtWO/wAGO1sx6MdjrRqPsOmOj3TM+yHrK0Z6ayZvI9byjHYlvTO9GPR+mRp/cfH5I0XLmuBqZ0yPuZxngif9EQq+x2r6MevEfKMVp7I/9IuH9yOaPxwZ6L+TvZ2vsXr5PXshV2h/cda5I+3IuGRcM6fwRzkj7n4ZHFPZHy4F19hc/g/K2R4N9EQo+w6+zI0/g/DM+0NcZWj8NZR2j1sx6ZH2Z+tn68dfk6/J0/ubc0O+nyZ9kzj7GeujVaO+dGPR+h12j3aOOOSdfZnX2Z086M7hn7R+B3+D19jGPsevk/Q4+Cl6P0ez/knv4M5P2Z9o/fB6+T0Tx8mJjB+THrk948dP4Yu6emftbPeAvydr7D6+x2vkngxeR0uUa6HlLXJ7+Dr7MnX5PZ+z9ne+CVlfY7V9GL/BG8rY69GM4HfrknX2Y8x+Tp1wfsz7Q/sO19j/AJBPHyjv7mPQ4+GUu2I+x09D+7R+DQ7TtaG7/IVofY5TeRVc5OaFTp7MdhhRoXxTwd/uZtTRH3WDMDLnCVBM2vgTkvk+Tk7VoVXyTo8mKmnsxWjUsHauDMJnTysDtrky+0Z5PgzT5HmHyjDbzORJYY5Go9Dr09jXweGR0I7Vwzp5HajawdsrQ7vjR9xaLf7HQVXnk2eZMLwY/AipZbKz+GdsMik2h6W1gz0mjPtaHLkwpLOMjbY+VFMo/bX+x0q/haCYqOsqgySt1tXL2fcLU4TXwMuQmbimi25XyT7cn3SftkxjZEVNPBFRhckVLBG3wRhP4Fw8odwbzaM9uDIfK+xhzyJLDHJEeiIrkjWnhkaZE/oRo/aInOeCJvjRDd8aOyNBKLyRHyRBH2IqNckbY0yNMjT0RhbWCJ9rQ1PvgzZmyNkRckQJQhKO0yKjQl8HggRNMj8ETHJEudqjLnfBm/uf+iN5Ij5I+4SiuSKjRFSwRsQnT+xGnlYQ/VkX2iJ7cGf6Dyk3lG5iZFwIj0zGdka08MjT8I0PjaIn3wRN8aM3wdkaERZyzJj0z/oR8DC4HT+Do6KdbRxyjLmbR/whZY5T5MWjFr5OmGYrT2YrkfDM0/uTp/Bmto/a0Zs7X2OzsxZiezHpmPXJj0x8GoZmuDNbQ79ozD2VM7fknawY5gx6Zj0zCh4NQzomVBLdbRn2jN7P00Xn8Hr5FVreTHpmPRhPhk1Gjt8Duh8YM+0Z9rRly88HYssdnZhyvkxjDJitPY+NM6Zmn8MmadQO62sHFoen+BvhwN2tB1AZTmS+SdmHGuRVWDnmYPaBewjKlkmVWUZUqoyh3T7D+0cSnhDdpp0x1LkVOTD97Ginli2vsLD2MqNms2ZXombGb4P/AENpuvDUPmSIdumLKdnbf2H9x6WRKe3LNRwYV8jUw1oamHxkd+mja0RvgYloY5SLlsVSti4fwaexFRlmo2TPszHWR3D4HqtbUmW9ItsXmBhBfS4/5Dl/yIVSENZk21ld9pl60HlMeU9MdS5FTMSl72UzlkZQlTWyJUbLLsalLozHRE3waMdsj7EQ12RDvYlwI1yRrZ+RFlvs1BEFGhyjotf3HL00RfA3OjDvDIh+xKHexKJTKVvRgxKIMI2RNbIlLrI1h8eBqYehq5Ia7kiGUd7EolEZCVcuRKHIsoIlVlESp40PZfYa+A1cjVp6IyEQ55EofvYlFNZEsrYtNllEWWUcDUpdGfgibGrkdsjZEP2Q07uSI7IiuSHg1BFR+zUcEUHKOhyh8ET6aIvgbnRh+zD9iUZ2QRo1BGtmoNEw/Y7ho44aHNP8DzJudGH7FTvYqbXIqrk5CtPBmVE2ZUbRlGV2h4THp+G50b9mGYEtP4Ojr7HRlD/PjSYx2Pkx8nYVP2YlC2tmoIqNkTWIHfwO4Gw9MczwJueTfTFTMCoxX2NNbNRwa7RMPRpdDuGOcj09GH0YfsVMThtcmKZyFiMMyoktriB2kP8ARSMORymmvuOnS9spDbWmUc8MWXONCunQ0ynrBmQnKcrA2on7D7mSH/obtMmkfI66bMNpg3YVzgFcpqFdP4JlesEyu0W5OxLidmk97JiEJ2mPKjZhwsPLNwnCL5EVLn4FxQif0HLp6HjtGxWHiVk0e9mjWXljymvljp1jbMONMw40zDfAstqWidPBmn8GV2jXaJy2anZpJkfKHMII4MZLNPh771/MTL5EOG+P2C0YfWyIfDwXDEplPAlNMyu1giV2iJXLJRI8HvZGH9ztDUNQRDhYeTKE4RD5BK4fwJaYlNP4I0z7iHN8sik9jWHvY1tfIi018siyL6ZEONH4EZTpaI0zg/gia4IrtEVOzCdkbWdjWGhpyoxyUePbIT7MumKnK0Ll8CbDEplPWC08lkpzof2D5GseByHgRaj5MutlG1o4ClKYncp4FSH8ESrWMFl2sFlLtolEjwe9jW/uRvDkSGow9kQ6VPI4UnCZDTiJIUtP4EtMtRGiPkh/JkVOxrH5GtrexrEfLItcG4WGRDjTIieBLK0Rp4Imn8Gfgih47HjtDmJyx8nDQ3DnWzfRvrkmHGjd4eBbTwah/BE5MpzrBn2h4k1Ox6ex5TW8n9mH0YfTIitHWjo5TIM5Ndozg1OztZHz9zlnx+jFcmKNtMWHIryav4PyQ3XLHhRbHifuOoaHz+SYfTyYfRXyMDlaFwK8itPodhzHaPuY9PZw0NynWzfRh9GIaOGjlPB0/gzktq9YM+0PH6G67HzsdNRvI5Th3JkllaDmyzDh2uTt8Mv2WGK52WycN8iye+SW1OGssmtIPg5HUNY2iYvXA4Pp6HCuSWvYmHLImJe+GSr25Jsm7WBOZu+SZ+Nllo1kUloTEpJi8IxenonjHBMQtPRMWtPAncH3cM5ljZmnlD7Gh3apod3tZHyqex405HiVgx7CY9PQ6haejHKTDWRFuUmX0FdTjZw2tmeo2ZUqoMrR7Rr9DU64O/wccPQiOcgTLu9p7Jl/PD8p5/8ArrLqUP2ZmkwPTQlEtfDKxvkhutrAk/2I+w1OGskShEKZMXoj5NERi1wRFaeilTucEXBEciHfDZGnlCWGURNrKIqdj5VMitOSKkiL09EZaeiIaWnopWZKPYybXwyJccClK2irtbEpnUbI2qgslD34J4YOX4GvsykcMpTKOM7ODvg+9yKVcbI+Qpy/yWU47MNII2aNY2inrgiHjOhIpHDko5XwUtZ9wyLgUpW+S2BFTgiVJRSNQpwaPREYvoiK50NJU7nBFj5OyHey2Wp5WyH0a2W9oiVO1kfKprI1Wg1X6FL09ERqmREcFK5IhyOGSNRgiaei3xsieo2d4galJpDxI+fwOr1wOr50fpmO0zDjknK+xmnZ1xsVq9bJn42ZU7Wzsb2jHAtKfwWr09GL09GPk60dP4OjqPTM+M2jN8HaO8GLP09GPnRj5Nw7OiNvuK62tk63yW/a2ZvgzfA+VRNSqMWOr50YjvRiuS5jXBv8D/hnX5FcrjYr+NmfZMriB8/cv/Qdf0O+dH7ZRjtMw4dnI2k7ZeOMMzRM/wCzOKfPhvaoxeOS0p/A5UPnRi+dD422dP4Z09j4avRM06FvpD9B8rWUiZTeW0d55HenkZYkyMd8idPGmTFbYZw+UJ5rhk6wyZy6FumhObWSdquSYW3KJw1fRKUPK2ieRMCah45JqH8M1D+GJ6f3P2jPTRTwdrPA3tL2hxlfKHmVZi9PJj0RHaex4jnY4w8LZ19mZ98n4aM+0Z9o7X2JnBNyscGL1tGOmzvTFXoxC1ySuy7MXB6of4CM6c1jEfMGEawyJ6Gfa0JbWeCNr5NVfJG1jghK8rZHIiBweOSNP4ZZQ/hnTI+5E9NESesnaI2vkjawL7CI9FK52RrT2cHjkjX2I6sj4ZE+ywj8aI4RFyr5EbyctEBfJMgoWtM4fZkMM7qyJrDLdNeLl9y1/YLb7o5aeUR1PgU9cnZHB/cjX5O1Pk47L+0ROoa0bRk5IiqvlHJEFeV5DCNckafwx0h/DOnnk+xocumiJwesjzKRG18lLNnsRHplPT2NVGnsa5xyR/0zhvk+xoan2RPtEbX2PR2vlDqx1emY7Q1F6P0YzjR1+Tp/B1vk62fMM9Z4J+WzQ5a+wvVbP0T8oxnHJ+uTp/B/wz3UH7R3NmffBn3wdr5R6+T1jZjtH6Mej/knR1vk62SZ9mfaMueDtfJ2YTas11sn7H54On9zr8nT+GdEvix/Zomb2ZsmZa+xufuTlq1smPRjtH65J08aHw8aZGmZp5EPwM++D18nr5R2hevZ+j8o9qVyP97OH4P2jk8CcGtGaL2XgPw4Jy2yT8GbfcNQ1Y6wnszY+x6G5t6Gc5HJMJy2sjyJ2Yo/ZMU+SYp8lLynkmPbBRQ6T2TEJ3wxvH2nI70SnbKwhP0QmfaE272hOZayLmSlaO0Nx2nQ1HpjpRydPeDt8H5Id08odmb2jvZLbgbjnaOUvkxawOsYeSI+Tp4eztjR/wBHglOVCttkRKhfhH9f8BK2Ta+H2/KHJC5XyKr+QqtfYVTsVKsMShRp4I0zIS07ZE2ImNNGfYlN7R2skYf3Ii1siPk/TqSNaI1o60Qsvgj/AKMpckT7LQ9CLnZE9uCLjnaI0voiLWxqMYZCXyPTT2RjRnIRUhqYTo/8Fr2hqXJCmUrI2vki5WOCP+yI9HBh7I1pmBFRow/saq/uWzlYNOUOXtES+xcPkja+SI9H3SL7ClaODGqhnJnQ1K7Whqfa0NT0I3tDQcOREOVsx6Zj5IhRoiumda5I0z9MD4eUNTnKIm9oib2Zc7IuGeCLn7mMEZawR9hrWjojQ/sHqSqn4Z+x37M2skp0rw7V8+MemYrTMKHg6fhmx+SwR9zN7M3s7R0+ULb0VnRj0yIzhmK5Ojp/BmmZ9o/ZT9mTv8eGKGL+5S9MxK0zFPDHVP4KiB8EzXA76aM+0d7HysisdrHZhVh+CUp4Z+xins7fB+hmotYM+hmOUO7WSVhk3+hPF8mLWDHpmK0zCh4On8FDt8HXHgSCa9kO3JbcrA8wdbOWxh3h7FTc3IqlO+GXae9ix+xp76MrkaaayPFPGhvfGR3CfYbtNfY3wITsnwTDbdpibT5TE7SJ1D3hidHVrJlclsyoxAnKT4OGnj7ky+G0J5a4Jy0xRPKYlDu5FUzvYll9jlfk0/sZprD5H8hrtDxK+TOEd62h5TWDcMcGHOmUm7Fy+5h3vAq/t4ZWjNchjlVX4SQOWz/gX9n/AAL+z/gX9n/Av7GbTHBE/Z/wPOVBy+Gz/gX9n/Av7P8AgX9i4zzxhhJ8CbmCs8iq8yLM5QnDvezGdiVRs1GzUbFiNmVWeT1Zm8DtdCanDH/4MXyY+dCF3vAlbTRAz6bLVrkVz1sVH0ZXoyp4OISRDnkw50yIfvZEQUnBEPgyI5dkSIqCPlkSu0dn6ZEYwNcZIpD0xrgjHBH20RFc7FCvyRCgioYglmc6NfoRUhqV2RU7Goh/ciGmsbGoxh5GlMZQllP4MGi2cj+7ka2hMfs9lKng6Z0yLkdfY6/JH+jIrQ/Lk12RK7HJdkT7PsaP6OzHoi50x56MemOslEvwdbZV7ckSvQ7UbQ7Hp6Nzo3OuDDkVN9mBVT3g5beDp5LiNnDZmjMdDiusonf4Hw+x3o3OhU+iI2KpRivDo12h3HQ+tHED5Nzo+wYfsw/ZgVZucCxDNdnWyKjDHj0O/genwPk3Oh5nKMOdMw/Yqzs2neyK7FiNmW2MqNomVCMrI7hr5Hpm0mDc64MOdCq8yYdiqnvB0/g6NRsyoWUO0Q2vQsWl7NH8mPMqltmEjIahlyba0zbTxoXDwRlO+EOY71JnoGpR5bVGjWdj0n3JU/kNw5WNjzWNjcC2JhtbE21hPBsnjgTmn8EyodvRMp86MpXKEyhNJrO2N4afsnD+TJhprGzDrDFHRhUywOU8aRsn9jp/Bld8H5LCOW0ck5DxOx6e9jymn7LmdPgdYxtmHwmYbWxF3g5D3ZlOcrAnPBmUHsHhNZ2OIn7j0/kPMrGzdDDQOp1JWOYDRVYoEnLkS0bL4Pf1UjC/NRLQ6bjMxjOjXsZnrszeDKnHZNfsT3hCroKm1oWmEKnDxpDZTFWd7JuH8M9/c6P2ZtfJ2iezkx0MXodK8jGbnBivt4bvOinWzPtC/J6K1lHa+RfYYli/DMejorDKw/uRp5OnnR1szjKM3FkTa1k9fY1KNSjEBrH4FTP4MR+iIfsdNLk3wFwrMqNiU+0Z+DN4gyoVBoalV0NGI/Q1+dGKHTh7OvyW1dNGpP7MfJEUfkNSnsRKj7EVG0PT4Htwa/RNQZXLRrs/Z+GZfDWieDKcZ4O18o7WNo9Y2ivgn/QdZwPiK0xj33hjtdMDtdj/AOM30YfRvo30zqIQuGRz8C2n8SZXejKvOvB8jUrI6p8nDXyzvWzfRuNG4eBZgW0/g5n4NXk12j7mO05HiUcNfLHqPljr0fhGPR1ojPYu/gSlIac5Mq86Mrscv4NSrezv7j00R/6On0RD6P1wYbQuGLDnWETKfOhYGaB2lydrOzRr7jcQ/ubTRh9EXwjcYTODI0/gW0/gz2MrseBldo12Up8j7spCVLgdRCUx52TIh7QJS2pvkzK42RbTQpafWx2mmS4na4HiI8foQhpwdMaDhqnlD01pDp7mLehO1xgWnBnOVsz1AwlU0TU4JrRIl/6F209GI/AmGtAzs2KnDvZlGRZhvAtNoSn4M/Gz1rZhOyih9h0tOhwr50Ou09DrAxWZOnhjV/sZp3GzZb5PgfJ+mzU4Y3VME0mdmMfYxHD0PjRMQtM3smY5QRLaJiB1hlvXyT78fVUTOqsJzgcNGfa0ZxrR2vlC4fKOmODHexrlclr0daeDifuShbTFhhOU9i2oWeTJOWjC6YqrTJ0xOn8HZHW9ClqHkV+mCZEziif+z0do7WBV6ZgezrnHj9mfZn2d7R2vknazsna+TtYP09GPRjtMxk70Y9Mx6Y+OcD0nsjTOtojW0ZwFd7L0dow09PQ69DwowY9cnWnhjTmNMjWOD3lYP2hd0zlM6a9GcnK2O0xE8hNV8jR/c0a+WPlDcfc1Iz7P2TN7RPs2N/Zkm5TrLMDHpir0Ls6eB8fYmaeUe8od+0PnfBM9Mb/JOx0zDjnw3GTNcbFZcuUTP+zvEErCidwahvJi+dGPT0Y9M37OjcfY9vk642Z98n6FvgahowoFrpwOr50PXHA8rhjpxoi/Jn42ZkVy+DltHZ+hi4zodXzoddyRFZkxRuMwbHX5JmvyTOcotmpLzjkeKowjMWt6MetCjDjTP+GLOxmuMMR+nh3jwl5R0+TF86Pweh17bGtP4Y1p/B06fJu6ZuNDPQie2tGqzsaeRFSrXI1OVsddh1m2K+NMfD3hnb4ZmqM3eB+Bmaho5ayTTazsp2vknCH4bRi8sWs5bFxrTFTlU4Z2zobWXJlYV+gvs9nawO1nZi18jq1jZZf4MCdPHJ22dvg3DyZd5Rn2esob3Zn3PZqVfKO062YiMH6MdsRV9LbQNTtCiP8AjevCz/b/APUf8G/oaXiZ9Dap6aEfFwhtJL6pMr+0O23/AB0PuMcqXXz/AFHyP/LAkf8AG/B6H/lor8ARMEwmlMT08FOtCzH2OGyZV5RmjCODK9YG/ka7NOdlPnYqr8nXOCZ4Eyu0TNbRM/BNLxoyNoZcmLFT5mzHyKs7OvBVOmjrZlQesrRn4O+NEzf4J2T7SVkTVyKv6YoUp/cQ1B0ydEzTye8rBnpnvJMvgneOSdr5J4MemT9hVnDwdaKHXGB3T0Z+MD/AzeztfPhOZXBMz0TP+x4nZqdoboPk/DgeenobjudDp/0P9ZHeNZHyhu5WCbnKG7kmPkn7HRMbg6Oj7hldofDRDWi1oeZH/wAY/wA8mc50TrLR0y8Ygz7XB+/Ho7+5WVc5MejHpmM40dP4Z7+5uH9zfoX5M+hrtFvGtGbXydrBjHyYvK2Y7TMZxoffodaeDp5Ot6M5zo/ZnGTNj0evnx+h0+xj0Ph45On8HTH+TOcmfaM2q4Haysk7Q+V8mP2R3pmrxsx2tH60zr7E6fwdMX5M+nAhz1k9Ha+UStY2fox6Jvo6eNMd5p6P3oz6DU2hmmdn/YblfJFz8jC6eZMVAaUw8hwlD9Dp/Bap/wBD42sMdjPQbm9rRm9jhvlsmwpWlWzGMMxSyOn6nTwYtjRbt8HWxXT9BW+gr7Cl8HtCmZSFyvlGJbZMenkdLtoepwPhrodsaZ2+D3nRNXhgj76Rm9k3KyydrOyd/Ixj5JjGGYxhmKYrDw9lYfxBO3wY/EX+EYK1oyalkprh8GfQmYfGSZprRMuU4JmnyTpjaLS4MTUi2ma7JbUbLplB2uxuk1k7+5N0ccGMYZtPC4JU8Jipw8PAuz/iJpzrAm2uhMKwJcSrHY3h/k7N1S2zBMPomHwmTHonk5T+EJ1DyK1G1gmV2iZUE/EE40x3aytGYfGhvS4OhiWLlP2Kn72KpXOzcb5KtYNciU1GGTSjQ7Sf4G5vjQ7aekNaeh5kZ+hM4VjfGdobgb4Jw8rY3HobxwT9tMmKf3J/0Za9jdpquRuHWGTGMEx6J1oXDxonKfwJzTJldkyu0a7HhPIbw8Mbf3HEyh0/ZjsdOB9jz2h3ex3HK8eh6MYxsXWPHWmdM6fwTp/czTM1tH7O9ne0YtZ2TtY2esGMYZ1sRHo6eCsP4OtltQ8rDL+UW+mdrJfsc/Id62esGPTyY9MhY0dPBE5M0xK7WB36DHezvZm0YtfJuVgpemKPRkLeGdPBOn8HT+Dp5Rn2j9mfYvyTFr5O0YtY2fo6MdpnTOn8Hb7maesHwQO7xGiJp8od9OD7iL4EX74F8lyUqe9kZT+49GyKMDSjRodpqLHwRGhHUawh/YyPM8aH7Fs+RMynKZs+RVM72Y9jX7Eam9GpZFaS2fktGYa1lCugXD5RvZcCpzmRU552L5Cr5MU/RnLb2PGj0OWtGO1yRhxA7xlZQ7a+xDtwwOE5jJucorPJMfOxV/sWGnvAoS/AihIdpcosrEf4MXMJ9ScqsmpWVlj018s4R0N2mvkm6wVlfYn7bFxoTn4FKPoyp4E0TgmpwyY/oTh8mSfOhuI7JhwsMThxyLhicy3wxOanArE7dCfJNSSjkNhuLJ/8HmBuO5MP2bgW0LInMyK0TPtE1M2huk1TG6k12Tx9xvDWNk7Ri9E2MO8G+hPKYtyS2vWDPbg1OxvHI3vezcPkbWV8j/A3D6Jh1glpvjRNyvkmLXyiCmB16JW8Mf4G9aG9P4G9OoHftGfZI5EtPRuNH4MWXlwdvhieUTPtbJb/ALJnqMk1OzlPwNxZyG49PQ3HyPh7wPgfD+GOXWzNbR/RuZJsVKZ/ZgSSnvZ19hbgRQyomx3CHccodw1ng7/HhuhueRVZjdMVZMSuTsa0ZmnR/RnGjMdaHp/g2N8DDnXRhzlMx8ir5Eop7ORFQNSoxBErtH6DuGvsPnjR3+DvJhzlGJemYb72YRyLDX2OD+4lKhma2jNbR+mh/hlGbWtG5yTfY70NfkVOOdiSWd7P/DOURUYMrkO1A+GtCRDSwNYeeTcrA6dZDUJrYqnwIhtPDwhbTRE18D3kyuXwI2u0JRrKIRKztkqavlmSLTyPZew6ph5MNpGHGGMTONHZV2ZrDgmVDVrRlOb4D+wXBcJrKOHlsw018sWyFw9mKnWGZNTCO2BcOp0zn7DUfZDtctDlw0wfcHrnkemvljdpr5HTlKtm+mYfQomNHKwjacaOn8ITpp6wflrCMoOIGVWR3Zdhsneks0vpgQIFCTu4Y59/cTQuygm0pp4af1I6JKFfy+SVros3qV8IJSG0hTVR48WIVphDH9DFr4Dy2nomUc6JuNMm9hfYcGTNbWCdMk7WRPa+Tpg71sx+xj0L8PBinvBNwyXadPTFw8ic1tCczyicsNeE7RNSidrB3pmPRMZwNxnBPJOnnRmnlFiZ9omZ5R6O1nZWUSsrGyd6O9DeOyYgm6HTgtlCfRhxo6OiZJm9kypVRsmpVEhvf4MXhvRMVzlEx86Jsm4yKqJ1kmJbecExvJiVrkmK+46f3JlaGngTKjgz74HcRlDeHwTd4Y3p72Yp/BbcNXoi2JDpfczPPBPCtEzL+6J2s8E7V8k7z0Nr4Mf2J07XPh9/DL38MbketDv2Zj8jpp62Ok5G4wmYrWjlOui/+hYvOj9lw9xgdqraHaUZHprKHpr5Y+V8mHOtsWUYNxhCd9CFtP7eMq86Mp8odqdnEZH1nY9NZ2za7Nrjk34bjQtrQtp4O3wLFkfceO9DUpPY+d7H18lGn+R5rDyzD6P0YcaZ7xwbh/B+WkLEb0ZXejPY0oyPlZQ8JrO2Or+7HlPRjoz8JipxrRyvwa/oWGnnRlRtYNPb0O12h2lGR6ex6a+4/lPJiOGO0RMmHGTEPyLLkK5XGyLLaM51sdp86NsGPHJZKLVvQ67cCR6eUYEsB1SwPI3t2bl9zNtYYrlcbFc6Fabw0ZXQxBng0j03kxD50Ze9CsuBBOMpimdkLgtWRXTMr0OWp4G9qmMHSZsbhp85GI70adkxC0zDjRh7ETb7nT+4rp62LKaaMqcRgtrkhuhj+h3zodRwzEdjtETI6o3+xvgSMCpLf9ERNe39STIR3bBXKo9Vlna+UctfY7XyZtHawYpgmL08kxHI6eWCVh40Tpn5aL3gTv7kxa3lH/omMYZKXaeidaJ5E6eNE6J/GCdb0zPsmfaLdrOxObWdomHK+RPLQnGN5J/2MexKmZtRdbLNJW8ylmOgzLv7t+lcuXPHZaRJL7iE/wDs+qmti0LiTL0pN+ULDtsYuVOU+VROYE4wTHpk6yjrROnhDXY2r/hcbEdtTg9Laf5PQ7B6L7CLknrC/TnjrbMX7MRQef51fEdTdp6RnpJ7LTMpXChyjtM9Z2TtfKOX4MXon7MTrsxZ1k5FpEbul9D7778w8IdQ7xlWM4YgQBuNkk9HL/QwT9lEf4gNM1DyW12h2DfyP3sylfI+vljyoxtiONilHm4XPppR2LAi3/ih2KzQML8P5Do5UT7LwzLLUfonQKZsnJbP4d0CuCDbUhu5/d2MVBMejp45OtHTwZpjtRMDunrQ+a7rphFRqfpt6hQxVAIcq+3Cvx4W2jbxkc3X6SrQOLJ4i5W40Y5I6f3FdcGaM29Gb2hKOTo6wpDbMOySlO0nd221sNFkCZx7QaDBoEvteHh9KSdHFGXR3CGhvhIftMg1ElSvpZr/AOwUCYeq4d5T01TNxrkzXGxbm+QqHCpbbhJt8KWkgcUvHujfb+I444464447Qcu93AQsgS2SZblfn/iFL98iuXJlTMQTQj/oPkdWh1fOh18lKymbjKZvgcrXJmvyJtz0fZAnKnEfk0PyHSC550Y+TD9mHHJsfcTrXIrp/BsuMGeo2csNGtGaHf3Ri/wY+dDnGx1NPB0/g1DzlGYTyRpqzpK1o73iD5OTp8jpNN5G4tY3I6fDgdew6pPYpbeGPTmLfB1jQfeUekNF2WVot3szTKycv7mOmydii7CrOHg1LGjl+GKcfMiv2K/eQvgxKcZMqVrKJ2t5G9MbO9HYdemVlaZ09n/DO3wdbLecoz7WD8kd7O0Yn7iYuJRj0Y9M4WjrnBOnnQ8Q6eSZp5NxshyFK3kp4lg9JPf1KnaoyluPCUafMricpzJlymfg9mPQvwPvDOng6fwU4nKwfksH/gmfaPueyblWYc5kxvJ+wqzvZQWBO1HsnhDQ1N70M2T9hNws3D5JhzlMxeiY+di4/JZCnOWw/Z1zvFZX2X8LFenR8xN+9yiT6dVQZ4JrXp7MbyTFa5Jyvyaga8YTHLGeJUu2oIMEU9rllv8AS0l/BLERqr7/AL94colDmLKPSlxof00yfgz9HWjs+/Kr+C/4mNtEhfvK9i6LFsiRHcGta+0omVMQxutDClMchvHeiz9KKlcu0jl/sWTEW3EyofZwv4S2mlKUrhw3X/clVrClsMXRNNCxBrsyoMqiQWDvDfueHZCprBwngLhJfS0kaEhDT2NlEgnN/wDQz7Rnpoz7Rn2jJwj9i7S0iT8ulbIGoNRO/uHS+T/gbqE6Ka3xPbU/sLjAeMcD2njToz7RCUXfajUdfhfyOraRfLD8pn2iZ97PWsnaO/wd6MemOvTHVPDHxofD+B8i8bP6M9MZta0ZtfJOWjtfJi1jZj0zGcaE4pn9nRuGZ9ofwaM+0K7WR2dr5LV/cdWsbMKdMx6PZyZ0cJ50y8qaM3ocGS5aZOgpUwxwsZVBELlPQ4TvDGllkfY5M1xsefwei3TQ7d5Q/uM2qa0N3CnswoXyjFrG0UrWHox0ZhQ8jFPDOmMxotnB01gWmmy26Cvpj4ORcPk1k4FK1a4MKecodemOqyPwHyw9nZ+mZp/DLxtbP0wTLGbWdnf3OxhyvkVJ20OsKw2XgQSLcqD8ig3+h1r2oR03kxa1yVEP7lnJm2COmnHkc9lp3Dcu+G162yOH6+t4hyNMMpp5JxdmE/gX0D+fjbqByfbERXI1KmdYa0KQCcHGFIbY2vpshyovpjYt/odK9qEZhm+mYfYWbw8C4fwc/hHTyZ9mu1g9JZNTknEP2Nuo+WdrBh9Ew+jfTMU9i4eBcP4FxPwKjGteodb+O9qPNtFuH5OmOzAdbJqHksSFpb+seXvC2IUzTEyEhSSX8S/kE9Brzw8dGZthYvyPTR0TUYZM/U8miT+PZfM/kHTLX+i2bG4sPQfbBMXlHew3GcPBhygnBylhL8ukRiCytLbwprBfdv8Aiilb0BmO0vYP2ZXaNLk1J3sQ+LlG/RH50+H1rjZQP/uO1TyztUd/gxa+RP4aGWEJJLLbEHGLbpTOyFy5e/4X9gOUgS2OkkhlyxSx4fpI11Apz9xoi7Tvk+sfH8kxpPNSF+6/TO/ujtGDHpmPTPytHQb0/gd086HPyO/Y+dju1k/e0dr5O9GMWmKF6KppmM48bh/Bmtoz/sz7KbnaKyqeWdo7/Bi+cmFWDpXyY7THw8HTOiPTgRPuNDfLQd+mhw2k+Tpsw9jF5QiXTG9sPZabWtMin9gaptXZqT9DtaNDlOGtCL2Whw3PGh4PPI8xvkeVlJiWULtT2XLaYqkY/sc8tlx1sVw2tCp90CUw9rREhk3K1lCakKntIlDmaZEfOGKpX5MI5qTnDsir/I/uMIdQO12tDw/AzY7aQc5yYfbJixSyKRqJcrRxcJPiFz4YAcvwBpp5TOujIaiumtdNEytGZSWIL9VX+EcZls1OzSazyKtrBy5Wji4SfELnwwA5fgDTTymNfQdvJL2tdNFHwN8CdYaJkVqzKMqeDlswsp4O18oxDJtRvJiCwyYca2LjXJ+AnNfBk2T0SMrtF1a/g/GD6L3HbY1B2Vwm38Dp3igJkdt4l9yUIn5QstTafTnlL6aiGi1KT4Qn+BF+Kdna6I9S9C6vGQmhIuvoXHWlH4y4XcF2QQnOs/aFH3ieeHZUXxkMtQyJT2NdjNc/TAxwjGI+YTBWo2jKfJv036+L+fop2FyDKSULttH+0IhsHe/8xoc4wkmjyn8pfTUSqO3Ob+0j07Q8W+RNz85awHLbIhqknwM7oXNvf0MXucwhbbbxBPWTora+97UOok/54eDKEi7+DU/aUeWsgf8AEIep+iIfFOlCHqczMzpkyp48J2vk71wWQDrtVnLtJ7nQuggk0JJYSX10DHzAzftOjfBm+UYLXYZUpu4vhyv0EWGrOk0ltt0lt0JdeDeXlJXFHLJRo/2mkE5xJJy5b4h24EoPk1prl/6HptEBXuanPV17ihhZVmrrA2+3Q3Ji+RN9P6bM0TNq1F51BlhUTkn7h419aNKRRJShoCbUqbv6JTkUGKbk7Uxjwr3i5Ofkv9yj9fkQCYVJgVhCMfmXZi+RU32Y77FwcoyoM1wO1CytDv40O/a0W9NDDzOjc5MY2Y+TFfkxXOyFg7UZVsGEYZn2jMMzfBFpob9ujfBm+UR9xstCqudi/wDRFQ/uVGkGv6HccrQiVoa2sbGsNY2zLhclLKmRHALMPDwhU+HBHPwalbRFlvAd9i1ModpNfJgmnPLHEwfsahzsZKMbY4QIh3gW08tG4arSFhp50L/QjXI4Mo7DSe+ThPll0mNid0JQ1rUiJMa3wzEp2uDg8C2uMEZTyZT5RrsmVWUQhNZHcNEqT5HlRS2yk50fYjD6N3hihTPxIpFKFL93PyqhWjPo/czKlZ2Zvu/wR4bwBP4M7Q9fgIkkhTR7c/KIzQjfr/uThsmXHGDLjaJ+SOSdrJ2snTeTHTZhSY9MxWmbGGYcH/gW08kzTwwZ9kz00TP9k8fJOUGk7/sG+iE4Mp5KV90Y9PBeRWYG0f5419KFH5iQI4kWS2UkkQ+VEuDctpafff0O1mqykYaP0280rf7u8d42Tp/BNhp9BovlG0U1wdqCLeH1v4fQiCrHQ90kkS+vsEh/H0PuGSTF+g6ymTcOyUfsDHtCWLqy0zVTSg65T19CRCMPm/hjQ1aBcHMTLr81Dtva+hhuooCtqP3CNWeVgu3Z/Z1snToestJ2HKW0/wAZVjmTSg3bBSuEpmSzSlcJf2R9GHRvvoiPhNcj4cHF1lsNtneVwfrg/R3oVBO4gfsS7hr6EMZsVpLTjtUnKSf0VtH2Jn+mYfTwLMaehbQ5cW7vyB9B9zZTDHCn/I+snD3sfOjc45P0b6ZhjAuBbkWHPwUtPqzY+ExJJJJQlheW0jYkJZhIbOLeqktfJ3om8QiIfRvrRuBZsrBpzkyuz9oeKzyPnfJpH3HyvlnIcJ9M/TMdIxXJuH8C4f2OeUa7Rn2jVZH19x1A9NG51s3wj9GH1o21oW0LDWy4jaIztjtdmbXyPFZOGvkcQ3I6Tsw45LbZMShjlO1yK6/JsjK9GVOGh3LA1SYcuDg+xRr8Czp6PkT0YfBmHshbb4ZmRsm8YF8HsfgJmUYJpNU0O1H7HH3GLW9CcNR8ipPyEocSKnBCf2Fcr8iuvyK5mowObcDxMj7Ac1+A6j8BuHPOh4dj0zJS2Sb4HOUGZQqNP7/QI3cC1SnB3zonC9ySJXw6drZai1kFoXEhr4DNPNSjW4Q6f/IF4ObWVFLZ7TTlPa4cpfTLPxTU2FHblpwmYdofTinvQpn3Zu+I3GW30Gud0ieJNqkdUMR+zr8/RkW+eBze0K1KpoV34dq+T1Yn5RMU8HvGjp/B0/udPOme36J5oTvBbsnazwSrf3Ri1jgxfJA6O0v2v9CBiGuyIE855J+4zQ0OUn59NF8vo6OWi8z7IvU90BvyxWVBMpx7PoXZRvPRO2pdky7G+F6iQ62c88mfaJnqCboQXhDX0GVwY3vPJNTooSPjYf5n9EbSMehJLw/gnT9CdMRt1rC5Z7Ul8/RmD3qaglg8YvjMAPbZFM0QqX8rfy+i18NPc3pb9uQ8jD6Z/wARM9D6o7RhyjF6O9GPTMVydfYbPFTHkf1ijiXr6EJpTkRv9j2SWyKfao3fw30apP1AmgrlP7i2hY9CWTlqvDn/AE/oQp2YnQwppon0u0s3kdENdEPKpMJa934GYfRhwbjw6EwmnKMDK7RDiVz/AMSvo0AxHwu/hjEbkw0bjRvgZ/sdPQrUb5FaMqeDU8DDpB6Y6fsdP2XMPDNxo614Lj7MzT1siGYM3xs1PA+R1Zi+RrZwVJhxnsXByvyK5QrUcGZ1BlcHLA9MfP4HCgOr5yOsnP2D4w0djsvTMuNrgd9IcllGb0yPhrJOiDpQxwOr0OrD+zApTxpm4Y/9DO2R3Whn8DNLA7VvZm9Do9i4YGL1wJ7YZitPAq/4Mpa+BThm4yWC1OmhS3aM9Id72ZtbycHyX6bHV6HSxIdZwz7gauHh4MU9bLyysM3G1s/aMy9/RYpLWRdKRMejjaJ0/gdVbjw3DzpnW0OplHpf636ltJ3fj/nPcmLzJ90irOGYrnZ064fhrQ64+jpt4Hcr5MOVg5ZQqvk/BmK/JP8A2NfsZQ4XB+1ow7Rm9ky+h2j7BMOeRWe5MemJ6hk8tuEiLyl8Qhf19E1JUXxO/lJn2tDnHaZNfbje2QtnpdUtO3dtt+l9EGrkWN+gScensiJ8uzNH2P8AP0NhJxL0M6bIl0owZ3aOHtGXK+xM2r5KCruxXX5+h3rTlOmT/B+USyumsRL0vpgB/gjHwmTPs3EG4yKmpfBNv8fQqKW9ShzyT/oEi3dYp+VfAfQthJRtb9YhsnKycfIbIsdjnhsTbsm55Ji9Mxm+Dd4FWTrZst8mo2L690LX5K1y+hWjNTpz/C0v+4vuKPmPo1bS1nyg9DNbJn2jOM7E/VWFSqFy3L6T+peoYNIPTTyKtGWpZ7i/eEfY2/ajsLfdbpDgjrTVDTWmidPJn2TIz00ZxRO18i2MO0JYfX0GETe8mtvyh/xD4On8M/Zn2jPszjJM4yjv7nejFrA3hrHB+DJjtMpTwx04fwPhn5H7Rn2ZxTIm0Lo7+5jGPFL0Y7TOns6ZmmdbM1sz7Wz9mbOzvSyYUrA6h7Dr0zGcMac1wynT9GZp50W9XyZ97K6M7XyUsY2j1jgdYtPQ67THjgN6eDkvhnvOmNa2tjuZ9CZ6aHd7Jm1TWR85bO/sOWscHLT0Yzb8HTcsVVi0Lu+BYinDKpvRivoL7aFr2syKXTJuV8DtVyjFrGzHaMemOMO+R07R2c8M950zNPOj/hmfaM9NZO1rJmnyjFrefoCYS7DK3jk6etiUU0Sgk4SUt7JMyaY5ck/fcjnyTc2bphLcNQ05H/KKKXCSUJr3Lf0wYRY7LavNQ24RPLp6THboTevzCFYTV0u8PmmV93QQRGjUCmuyaX7+hI8P7h3OEYthiqZVC/eDsLaNRsiVGzUfdjhpRlDuGvk4aHaUPlYG49jD6YnD9iqUxVKLpLHDZB936WSXsl0sJNtk61y1fgYcFIj0l9DKPGQ+WHpI0+I5p2Llt8LR0FKpUOIoTfuT+lccFj0/uS8onEYG7kqZIpvlR/aP9CkwtK4h9wC4KlQ3sb8fRL+Ndl/JQ7vjRMvg6y0daGk7rg1S/h/osrQ1DP4wwpGOlP6xKpPv8X0QAee6mndU8nTyO/a2ZvZnBJuMI2zpiun8GVZldodJPiqbu5ilrk+idCb7oeNxl1wGQ3zSWzy22Kl4TFacN+X9D1yg5NAPuZ++ztHa+xiWjbRILWmtpqmtoTGN2hNcv/Byv4JMlo56VLwPGjtUNONy6Th7TVpqmrVHeIJ2vlHaxtGE+H4U+71NTXx9CTAj5ykTzXGDMcmfZ+ztZ2Tv7o9fYxjBieHo94OmPfwdP7j43pl/Jmtod6hk32bn7na+UdrG0V8H6ZjtHTtHWuTrR19iF8n7O9n4Z2vk/wCQYwYPymY9H9nvGjt9zNcYIYD4BmHvQnJDtyr5Pukw50YngwuE9mJT3hmpVOz7Sy0Y7jdDmC3oPDTWjnvgdwHmFobuYkVWUyc5pn4jFfZixKpwdq7JlaGeEGHa0aP4DMPjJZ/oK3KvkU29ChBV2dt7LUrXJ+2z7exvfI7ra0OWlprQ7h/YO7V9D4eoLb2NyrTKV5Ri1c7Fpf8AgL9vPCn3cHj8CZUb4FMEGr/jY/wVu3D94SF/wh6ex1f4HOqbBej5U91n8UYcZRt9jGTbWOBXKxArp6JrsWFOSanY8J+GL5LTXZhmH0b25G3poW1pCcymfpgsV4HtSvn+JN1xSFW2UiQcF8vFNrKTKTt5ekpmmsCEKDbKVE65+lktxFwi0+EN4fInEFHW8kxDkcGaSdttSSFwyUfYdnzO39CZJMLEE/tMXwTXaMsfpAH0Dq9TWZGxeZWNj6Jm4hrI9P7jpQCONtXUP6EC3lXd/BYrKFo1E2+foN+UocVv9Sy3moOxmxU0vaPX2NxnsVynrZw42TNbR8XyTN7Lg0s8bZQHrXghH2ntL39FLNa+xvjHVrkOq0xtCWooxF0/ojisXhjfsnXJwmqZMXlGG3p7PbOyfu2OiXLEPtGGbTp7Hukx6ERL/g9GkiVV1JT6f1qNt2m9K/5k4J3oVOdckw/eyYn9mK09kmdVRMX3Poll4w1GXppnGj+jN5NyWmmjF5Puk7YOudnKMqDUcDvpjv4HftaHz9zp9jY7MeiDbvZiV+RbXJXQ+wzW0a7Rn40Zs7Nyd5XjHzsx/sVJzs1DLyrhmo4M0a/o56ZOPkHwxs0awOnOGIu8sGHweEKpW2Dr4HTysDxDyPHANSu0SarO2OcHgTCYWTgwU4NocKmHo2nLBhk8aQlr4I02zoUtSGVLDBlRlTPQalW0K4a+ThMbYvs2LMoKn08CpxpirO8IW094OU7M2s/IdqEHarA4e9jxPGTRr5GtNY2PNYeR27DaXp4MO8FzD+Cy5RnED+EvKD7J4f8A8hmIyZjlbJVSyeQyhOkcqZfDf+Ar7E5En2/w8DcXrYmqejwT9lHCR6SF5TPzM9I/0ouNmaETW0XhgO8Z2yePkk6UYsxD0Y9iY9j9jtfB2I1tFv2hOfYtxnZIf455X8Fipzy9tSEjyVK9dO/iOe1H37N9jPqCZnnkmfQxqr5Sj8r6YQyMHjh6G4cPZhxyYp/BNIW8K/uR+DfQwaFnjKSdtSO5jktfmZMqSSeKpzjfoH96rBH/AJBM2tEzQaL7P2JfCWW9IuCryN7Fy9t7+hWHn8N38ijjUCIYT+Qw/L+hhM23gp/k4G/0HfJbOjoThzpi7rgzWGfFozjJ6zs7XyjtGLtFLn3Ian6vP0s8HCspZt5N+I6OGMrBnq19P/Kw23o/YmPQqnvB0/saadvRlRNo/CohYamcTSor23yojbPID0i33HpfSnyEV/xxoKs4ZiU8GKfwLh/BLY0Iswl/YqEuVwkQl9H2IzYnxBHf3MXrZudGH0z9PREfIqlP4OnnR08o5WzK7HisjxKzsfAfP3HprGx050x56HT6MZ+EdM5TI0ZrYrnlH7RlTvZmGjh/c/Rhzrfh+mY9Cr5OmXDWXoiVDyjKjfJlVlDxKyss4ap7EkrohrY6cGIaN8OxZemjP6MyaetlPOVgdx0PHaHidiVywNR/RGjWx5rZTo8kJdp8m40crQrc9YIs2sMVpt6LTMNDvkRlLYcLsYvbMQnyKmmt5FascCqCwyjCy1rkSz+QlZMWSD/I5ieCanDHiFD5Q6h/cdbyPMaQ1KOR1WuTrRMy2sHb7iqkJcPIwyHrbLekS90HjkPX4D1w8k5zlGVv+/2v8CgIgxI2/c+Bh8j3gYmBO0kO/tqvn6FLRFr3F+8fgTfBetHa+UTwVnXBMXmdHeUfo1D+Dp/BnOdM/fJ+GT9zbeztZ2isr7HrGyZoGvd9/wCjTKe6HgUrdUP5NT6H/wBw9K28T37ITCnyX3fP/cD2u2TPTJrhmMZ2TtfKGfJSFiGX6+lm5IayWvfmCnX2Zmn8EznKwfsT3tt6SVtvCGd0UWJb0+wuZ+hIBsSbJs9H2OTlCdr5JqXSxCvu/RK6SmtRemoenrZuVSEHmL2wQkkstkEqygefPG3hVv6HqEIG4RtWbpMddGzlhLbfZlQlYl/yRxPwv0PgY1wIjloEuYHT6WTfCZt8PCP2essoSyx0jbdDXtfLuexP7BuBDpH3M179oGIDYh9NNaJ3hGMYYoahdNAkkuR8Eji6KjO0qS9L+TDh/fmMXX5OUK8/BlXoyu0TM8o1I6U7KyScqDCM3LT3GEvoYNEHVtLL3ZOtciumK5nKJ50WuOvj9b/QyV4dInzBGL5NowzcaMMdHKF2K/fJn2ZXZqfwPFb0OoY+Uf2Omlpm+BFxo2145FaZlXo1JqTCofK+Uf2Ya4Z/ZuDo6/PhXn4M5zoiemTnlGp2PT2d/cxjY/kP7GcNh09nTzo5nOjKjY25WzlFrY+GsnUbqGNodKfsGovTHDfYHVPDOVzgjK+4+5qB8PJE1sJ24bMqVTM3ltjpBarvKHXTYq9tCqnloVOGqYq/QkCXDzpiaw/QnDaJ0yb05HyvY7S9jq1hmFOmYXTH+WCllZMU7TwPj4GXDytmZTwwyXLgZxlCoRQPOOvnfHlQZdtWmnlDCil3P5cUzvYr5EC9TvDin+Fv2E00mnKeH/NO7OGN4bVm6THp2jqWEtt9kbFQm+CAE+O4Y/SX3vymW2TCct/Yy+LNNsfiSdmHPIqfsVOBVK50LaZ2LEL5MqtaF+ODXR3FGO1yY7WiYd/BPO8GK28GV5FZsSuFl6JOUezWPlr6M5FFrUY+4Z9mTOrRyWUO7ROl8icX9yYvQx5GmnKTKFMKL037Cvoc6k9CVH3FraFo0+tY5XfCOG8mNZJqXqJH+9hOK7Piw7Q6BDMSsx3fp8t/Rpd3d37tvtl0iRzkWEsekE6Rz+ior2d/cCyYa4CX0O+jLJIXpAT2y6cf7LdpVVS9t+VGCAIiTbv/AIjH0H9gOUgS2OkkisbTMzsXrU4UbbMwZwWu6Prfp/c+lbS9sJO3jbydsytzrVbljhP4mTR5FjemDvduO5diZ9w401VGl1qFwkJceWFP1zxYLU8ow0Q1HHT35EPTz0YC5E4L8Pi+38tPPfDF+QzW0Z9ob4Vofirl+x9EN/JrjuZSd3+AXJBpCt7bLcNWh2bGSrfcVp+xbb4rQzQaaeCY9Dvt/Y4SGkIJfBEpTi3L5biVH0VlGbwuT7fZJ1sz/smb2iZU7EwNJ+Gf2f6LMlX/AM1sMPomHDwTrkxQ/wA8nvOmc8ot3szL2hco7Xyd6R2scGPYdembSeGb/A6Z0/g62Z9ODOMmVKyd/c7XyNbMWMXox6PeNHKezo6Z1sz7Rn2ZtGbP/R2sGHOj9GPR9nEmXedGaYy+H2aYiXKp7O18omJgRFrG0Nxi2yRE1ce18GaHjkfDxycH8MaWHrDLdch8qQducM7Wdob2l6GL+QdXZbR+Gg/+xjsa7C4eNM6+DODWMhf9BW+Nhc4C5w9oXOW0Tv5IheB0OpFPTHwRznTJmnrZu65E3wzc4He+Cf8AZG2/kWCXXX/AmE0iYkJRhry+cMUaxlj8j9CVU3wzdv0zNaYMADt3hrtddwev5TFLypGlh4SQ2Ins67S5jXENyajZmARiCaWEJJdlUnGHb52k0LpLytSrPbt+s7oz7Qr96OQzj5O1nZhpL5Ri1gVXp5P0YrTOtCaw/ghu3wZp00dYejPtaHeMo7kyUVvVPwH9DTukZMsvi9jt/wAsx/Q+UTtfJj0THpk6eGYV4ZOngnT+CI43jK+4/ucfxvKaFCaW2LylDoG4T+xwrMtyJi8k3SYvE7+PNpGzIbehe/CM8n98snCE8D00IdSa4OpclQl/wMJSO001/Gu4L3XVKNLXAu2k+zzcOT5bNVgu0DttnzqPieqaXSX0QCcpeVpSk7r6cbNmzr+NqUxnni8fRE6HtJwTCeM7QhjYZyJ9oQ9lYe5F/tu28t2/otcHSo9OofcVznVNPTtAdIcRbDcKn5+hZJq3wsJNtqS2yzUf+HSF7dn2co7R/wCkLlfYipDJ5+jCoT60niP3w9P7nTzpmxIp5zwbZ2vk5g7Xya6Z+jFO0Pu1of8Axj71gznOmP8AI/sP2RvfB6UHMfKPWNn5T4P0zhaPeNHT+5u/gzR+GfhmbwztZWUdr5R6+UcwYXXB+UzHpnTxo6eOSNcbPkjA/wDQHcPa0O7zGTNr7E3OezDlYeTZ6ez8GYNPHJp4J4Y1TauGPEh3WC3taMxwLXtaHfLoblwsZQxtnadbZl0xdqYiKeHhmv2EtqnB2yxWumhXW9DP6DZvgV/shO08izA6b2fsfgYrQ1lP0HsrhjmNexqVGx301oaT+NDvk1ot24Nznkb4HS0zDnWzbvDMWbdlwX945nz3R9LO+1EnaJD1M/Z6kTRn4wj8GhkqSowzQu8BGlVX5ba26hv+JCZeX0kltjRneCJmTi9/9mVm0ZXaHa7GOmRVTClNer+X0E6Js6al7Y06YwXWTJv1klN0P7DfvRhzkUpy97FTEon9iTxvTI1t7NRgzSVodriDKUfAt/A+Up6Hzok3J3lon5+hATkr2pBiV+ROofcwfg9kWn7lKUaafwx4j4NRseIw0OIr9d6aNolNbQhug3k0sPEt8ntNL+Cl0mTiW2cIiHO1u9Yip8Fjs7blPgxU+vF9ib+Hg/H8WX2V1S4PwkhwwNy47j7D8t6nQbjG8mL08mOxuI7I6o7mMBltfh0U/wALVLUUDtUnj1lxFpgXjGZKw0f9uXY6f5CtNXUrMPfPtmvokYJyI/eCkMnZdjhny2ZXZldomck7aLS/t39Ai3JX2xfdDYsGyETk3Th13AiDTTCfZo/7VX/C3JeCJ/vSy8IkRPxpkevwZd4HatbMfIqvK5Pw5E0O+Zu5+PoKYEPVqFv+h/WjPxo72tG5yb/I6fc70LLg/YjT3s6/J1g6Hah0Z9of6M2taGto+5bPwO8pirtPYvwYlPBFRhHTrgyoZmjMLgzHPA+d8EXA3sYc85MWsPJj09mK/J1+Tp12cp0dY4Zmto/aLYwsj4aHysbKmdMdOdMw+mQk7xoUKV8CrT+Drg4DttkO+xZVlDVd7Y3NMLJKU9Gaa+RuRh9PBESrJ4FuRbT+CXaedGUCvgcmV0FisrJw+Mjh6OHFck3DAsoY7CmfsKs4Z0RnlFw08odwDUqqGqt7HaT4yaNXyPlY2PKY6fRjoyEm5aMSvgdP7G/Yd5FvppdM9fQxUipTS+Rb8i2h31sO7WsnTGxH8MMbhlFbOQ928P7tpoJppNOU8P8AgytWGX8pnCUkEpljhPr9m/Z4Sv2joTUK5MuEBT9qf5OFlkSuZO07tht+Y48mf+ysuFL0PsZ6zhj9tna+5w1gw5XyJSnEmBayqMoarQsxhoXH2EplPK0ah5WjKxaIrlozjOyKlfI8ysbY6vDbLbhFSJbsESpi3tJ+3MfQ3xYMjdVOT6IS5MrlDXZ8izDxoznWjKc6wi3W0ZXZhyg7SeyqayU8lje47TOH7VjkKDB6V/4VXIhZUQ0w0lP6XtN6q41Jb6RGjcdsjI+X7h5a0rHxDCekiYf5M4aF9gtkAG+EhHldOO/f1v8AiYI+WSF+K6dz4tX5QWlRqB77B7L0UtKlSXBhOlRi1aJhdMx6Yqp40aj8jrK6H/QxSBld6CkSVdtdsBXjaYT4F8y+rdYxXeSn9Qp/bQAovy9hvFltpbby22YrkeYeGMw08lWHlmG0H0/S8LsoNtCSWW2L7s2UxWklhNw9tuKSbmbWdmYTWS/7H9kyhRKzFL3ENGRxL0/oTU6lImkMEaXCb2hU/YqZPnHVOPQ6PK00SZi1+0/10chdIoAtzIT+lXT5UrcuBIfpWaZrpPZBmrwjmJUn7Bv4N1gw+jD9ip3hiqU94EtMbbQxVSlhso/OPNQCSf55aC/okkazmRU+IvgdofP3O9G5WN+N8IUpw8C3IsQ86Fw8mmtmeTRqs7Hg0f3NGjJMdMNfZkX1wJW094FtP4EolZehYaeTnYiVGzPtGh/oY71s/Rh9ChM2LfYto01sS/4zUbHLVGVyz1o4TKecjSUl8kx6Z0tim9BTLb4Ysm1g4PRNQ6awO5PKUPkvEGCexzh9h1HY3CNYY65SNQ40zHARD2MHLC4ZmnomVejKT2iaTxA/u4NctiqXOSYdbyZQqPIqcMCpta5FsFtaM2rsWHOjD0ZU7Q3U74E/0DdQzs/JodRGx6aeR04zJhuzlaOU8CyTozKesCxO1ZCnytwO6CjofK+iQPMhyyk2110mMk+RxBr5MPpk3CyF+gp+Gn+JOOhW6tSpujIkFhKbFe0za8tpGxItti//AM0s18oUWNCpTt6X1AGi57KHwCekPVM7Xyi864FVMZOdtvSStt0lYiwynWPElqeucvP0SjCD+2lh/ox1aMRGHlGO5MOMzoVOHYlcOxfZyLh6wzR+RX7WxKE7I+SNaMwhhSqnQ/8AoH/0GHHOh5jPJvYZ4PKmLoRD56SC9BslUm/fYzoyn+zU4g+w1DxmeVsz7RM8GialZQ3UDF8j55Menow/ZKlDSjPb9xC9Qth39zSaf8ocg2cse/wfwS6jhiXpAMyKkftjYvuRmRXTF9xysoZ9rYz8ktDZYaaE1JWEiEkuBJaQTE/YD+sAaroInSiLSyLOQyOLLf3pGumYGPYnWtHTwdP4Fi3YsXkV08mV2injKGpRkj3KS0ZnhztdkUrDUp3+D+Bqj/8AFoH5cyNo0+L+34n4nvGhxh/B18GdPOmZznkiIChQt7Ez3XAvdcCjWjm7/ZR6+xqrnKMdrg/KMf0aUZG53EwhprDTQo1kLSS6QaGsTGnK0OwuGmG+xxsJbbttsxWuRWo1oVpoyv0MLicx9+jJfIxApdfdg+WI6abMw/siHxNXPr7i/BlZaz8LfwxRlSWQeh2l8GGmvkw+mYfRuNH/ABJyjKh0L8D8+LlhyBMUk6dglcmhGk+GGYhrL0YiDGNmHRitPkShxrk6FwK8mcmV6MrtGp2N0mvkdWhpKx5nMm/Zhxo3GjoWY0Lgw9CtcQZU7RrkhJvZ2h1aLVreTHaZhxpm41yYrXIrpmU1wZVmVw0anZhOzh7GtM7Ri+SkTaY3HRkx0Z2+DtbWD8lhma2jJrDRM/2x2uS5Jftsbj9kOuh9h6Go9PQ6rKY4V9mHIcuGzpltxtDvtyRHtEWew7tZyzUKJwe1h6LWHTFULYVVpiqnhi5Y0xMLg7fDFdbR+SOSzyZlMofDOx0WD21oOs4Y9OcDpywzt8D4zBmtoastoyu0ct8jdQyslrkpzhhb7iU9NJizirZWktMprny0mmmpTppjW8S7tRZ5a9KVtPBY7ZWDMra2ZraFYGzKTIiSWYI34S23CUArv+Kt2dcDwqsc01ozD+6HmVgcUqvYsRG2y3o7HhZstP3yekvLjCeTFv4DY+b0fcnmSkf22Vh40LMP4IuPuOmLvKEp9BcFTKEuCNr5OmNkLMUQMeh/hj4eWGda0y3TqNnTp6ZOsND/ACa74PWT97PXyd/cxeUejKrKM2s7HwvlExaWTvQ4Q9+hiJwTcfA6+x086F+TPsze0ZtZReVfJ2vk4as1ouTtZJ/7R2vsZxjaJ4+BhV9jU/g1OR1A6geejfsmHwFvQT+AtozMmVM4wZU7Q3U8DdJonY+djppodfOTr7GoZWTMqMQWraHftaKdrPA+3wO2NyYvJMOrkx87MVzhmKwuS4t6LTn8G1+jHydtjppj8jNGfgz8HJHZ3jkxa+fB+D0Y9HCeB6TOxA6edMXHAvwM2qZ2qZ/6MWYp9iYtYeTHyY9M65wdvDNPOjNPKM/ByMidlKyYtbKXpn6MVpj4Zi3h1tCueUfkZtIS0ycvHJi0YtH6ZinhlY0zp4Hy+H4Zpmfgr5M2qO18nZi18mOjMenox68DzDxybU/DN3T8Ll+BbjJr8kPEr4DVTrY9ooxD1ONMhKnGmOon4Y7t8G4o3hnukMt6Uzq1o/It4+UcwalWhqVnmTC5RqNPDNKVWhaT+GL/AKGkq9C7piz0E1eh6zwflsbr3kqJVrY8c7DxOQ9T6D4eNMeb+GbgP4PRu6ZzNM9ZR2smqidlLGxHGOCP+0dvEkfqsrtIWO2gnSwqaa+hwswuI+6Fwe08kgp2qVNGntM/4gu/BE4yK73s3PyRlys7HiCl7HNNfLNyvlj6wNOsamo3YG3f3F5iDqB/4UqWl9FlRSo7fGZv7aHwXDmFwjSKS0vB2+Gah6wZicrBM+0fkJzexRMM7EtPlCUYFCtbEo9MjWURoRsqHw/gfGHpjhuHlYHb7WB54HaydFeydo7+6MXyY9FfDOtic/YTHZjFpmPR1ts6eGdsaP8Awzp/B+zgIX+hO9DaaztEbWdoVWhdWhUumY3TGvlaHiBU0bfZij0drGydPkeyxwY+dGPTMemdPDOx19mTcPK2L8kt+1smbWUTIntfJ2sPJj0yhtr08DqtPZitM5RlRsynyjPxkza+TtDqnyfgckb6ZvJENzsxKYlFP4OsnDaNFfBing9/Blqcn78Ndi2TUpHqI2fo70P8GM4OtaZtJ7yOvyfs/Z+znky6ytCxQt/kxPGzvTyfo/RxODj8E3fwfs9jmciv3wXrPAuvk9Y2THaP0P7o/RwtcjzeOT/iPZvs55F1ngX5I4+TUr5K/wBn6GvlEfY6fwe2PN/Bl38HvJ+NBY7OTtfJrrZUdDq8j9DqOD3jTPuaPeUZ6TBmXtZMy1naFuM7MXN7MTGyItEfcczkOIgPlgtX5HdPKwO/wDt9B3e0PMq+UOcflHaztM7b2Qlgde2yIrYjb4EWmCjLWGKbK4Yk8aYLPtF2kK2pWsnX5QqtfKMUxs9fI6nkRHpjiIYn4H/Qzp50O85WB3bysDluGO73sfXyYdY2YtYMOVhqyl6Z+A+Bt15Ga2lls8NZW00cOoSdKQpp/Raqu424VvbJjoVDdrHSH2XsDFKZNeyfDMXvYqx9jv5I3MzydNl250N+vwsbb0kPcwMiRyxP4odjKZBRp9sNfL6IQgQhFJJfRZbbVQ9cE9C9wnsU4o3pkvzl2LAWPYyoMOGMqcRoX5NjD4CsKCjnnZR/2JRX5Es/kRUGowRUQQccoRuPwHd8ZRlt0PM5HCYw5JjlJh+8CqnswnyNaGVAnQq/2Yr7HLfcyo+xqHRlLAdpcoa+wzHWiJ/oPKf3OAw5yIh9C052REp/cXHJ1+TUGVGzKXRmOdBub/Bj0zHo6do9/ceYfwG3MPWzPT5M+yfud72jve0cv8Ha3lHeG0erXBP3E54LwydbMq86Lfs9ZH1kfI+V8j5WNmHIdPoxDTLlrRDl6EaYuHkSnJlujKng1J7+50/hnT+Ge8ne+DvZ39yOMbMY+TVYZSrR1o6eDp/Bmn8H7L9NCc26Z3tHe/EbXyYx8mMYMemY9GKeGdMzT+DNsmfawZvfBn2h9ZO18nQ/vJSxhmPRj0dPB0yZpr0dfYf5I2sm5Wdmb2dmLW8kcCX22RrTI+xGng6eDrejraN9kc5O9ogjf3PWEevk9YZj0dPB08HT+B8P4I+5F/A7irWhqY4D0nyZQKkQuSTbcmN9GWq1yR92yK/cdp8DKjjRxa0PHQPRrQ+Rr25Hnc3bIstzsxU52KpbexKtOGZbDs1oZ4NGC60YJzegrwwZexwlrgw9kxIvKYqngVf0znlsjKwaadH3B2ow0O12jK6FuUaLOD+Bhh7SYb2mZcyKz7wJJSudmtDQyFrSGeX5TfdvT6Ysft/D2jKNp2vpSGXhKU12ixWbJ75bab9joswpvgya4l6/UCnJu+CiWPdP24JI+4RT6QKkkSpd9wl8v6rai7BhD/c9cqpQmL4ZHHy7sVqBroZXZqsj5RmH8jtbybrBh3hiietFHDpHDDQuH9hFDT+BKnP2I+SGq7LQ1o5LJLK+SjlY2N3WBuJDacMtStE5Trg96wLF50fkjUb0arKJQhYgw7Wh374NToZscNZ2x8/cemvk3+xEPpmOjFUrWhbT3gSmvgJU08nX4NRvg12anZqVkbx+WckesGujKjHA8WZra0Z9oy/0M3s7X2OnyTcreTDq0THpmJX5JyucHWjUYNeiZksk1J3semsnex1D3wYj8j1wbiKMONHR1lrBeJtbMzOB+RMriC2pWjNCtD4wO/jRn2tD+UaNyT8C5nMmPkw+ZMV+RbRprBE1glPg0ZHjtaOXBm+NG5ybkVOTDfDFT97FQtr8nWDM4GYgZS6MrtGb40ZtfY3JudE3OTD6ezD/ALFU8ci4exbTFw36MqGZUYjQ7+NDuOtDzPGUd/g3wNzmTD/sSjudiCUV+RKogioLKHQ1KgaldoanORqca0bn4GMPsd8n3SYrkxRyiKjBT4NGoMojr7jbpr5HTT08jUNRSIh9ERK0zDjQt6PCImU/gXaetDtQ86HirayWkMFFvZZJr5Kw18scKGg6c6Y6ogbLT0KoPDMStsQRlNehWnNsymnnR1wNIzs0ezpo4a+RZlY2KkjDFE5hFJ4YuNClV8DlGVbtYMqMpod9kWQcZ3sca+R5lY3A88OR0n3Mx2FS9IUy08C2ngg5nOpMp/hGYaYPsC2qyO72LLCwxI1/coa0yPU7L+8wvZHR5/nh9Kah3QR0GrmJv/mw+thhNzE7tsW2zKng1y2fkh/+DELvJhzp6MOtkpCzJSnciptZMv2GtwLV9mW9osvR+A7VRoeOXBS/uUtb0OnVp6LPejKJk/8ABOW+5n0M0n8mVHBNS6LanEGoE1D7HCfYXKo2foS2p2jXIeOQ0MQhaa3OUYajZEPsRojISmnojAzPWzPUFuW6g/QmFJ2vsNxfJkqrQx8mG+DFaOn8DmKyO4gemtHD+4+R05jJhy8G/wBCqmYlMVJpqzTWxY7P2jpnZ3oomLRaXvZj0zHyRFPA9JnX2OnnRn0Jn2sGcZR3vg7X2O9bR37Eesso9WjS55Hr9j1+x05LgN0MOMLR1o5Qrp60af4NRsuOzKkPknDW8sdNRQ6cmH0fFMWXxo3DxwLaNpF+jK7M+9Ez7NSsnezc/nxhyN+xZh4ehZh7wLaYu16OnlYNdms2O/Y8SsmjXyNrXyxymmsH4FT0bjQmngSyn8CPDEqvK0RRFdkV2OSlV2PBj0fcai/uQ5nWyL6OsI3DwzlC4eVo0xYjZrsypHY3hreRqS7Hb2WJZkw4yKm8iLbOYM2+5ssRsyn0YTwO1O0SjYJU46E+7Q7TMzlFi4ehpr2sxTMNtjk21+TMrjkVrtbNp+5ldC4E0IiE+xxLIxHYrLvRMozJR7SbBTMtbLT9jM5Zn42P7h2uSHgN6fYdQ+dDr20Ya2mOnHI+VyYbyIzoK5TeBKZOGI2O0+UTU4HjSNH57Q3lzoeVy0Y3kg8jpMda5PsLSMYpTjc/vupafQuijLSmntP+J/0DVGpOW6RFn6XQfNPy/MtG0p/Fye88smu0ZvZ/2HaVGL8H6MKHaFC6PBOvsdP7ls5E5rEE6w0W9BNu9ixo9ie/wfgYuLGO0xPgx1Tw9mh7Hwy1RLHx9xmtkz7R2soUrWdi4fAmLWNoncUYWKZb+MGb+5/wh8pVswFQw1wz3hmK0zhvhnTzogKXnKF9mjNrKJ3vZX9jtWtnxkwY1Twe8aJ5PsnDFjkRrZ+x5n7jprsi/ZiBh8CHLwHX5M0zKvQpav7GV6HLRP8A4TxjZ+i/hlfB7vQ/R7+5+OGO6mGX88ne+DN4ayjN/gxaMOF8mL0xVjDIitPBhRzgsOvTMOedGzFcm4OtCv8AsZp6OeUK812a4gd3tGp/Ax3+DD9jyjccm4N/sLf5H57Mz+xU4FamYg1JqSdmIfOh0+mYxaZh9Px1+ToiaesMVkjN8GYfA7XIdWdmHPOjfswi0yLjRuBcC4f3FdYjYl9glvgypxHgahB4PnQ4OfwOD6ehqK0NWIuNGa/JGmc9YYrV55NTwdzY8TgfP4L/AOiGvkcqttnWUzkucM6edG0noz7QpwUMV+zNrOyv2DxD5G4pjZyytD7mKPlMp0eGP7mBq5G5ZWGZcN8Bmtoa+wza0bh8naeTF5W0LYKs4Z+5wnjQor4hZlT0xKeQznAz6HTAzjOx8rQ6ovaH9g6xgcK9h8bDqtPDHUGvTHbkXlnRP4PyOSyjOM7O19iv7E5DHZkx6ZitPDJjox8t4PuaI6+5sL9k+QlybfMguYMZRwB6bLgkYN7VU/oQy/RCfxl8Pile0yC2jONB8b8NGbknr21s73tH/pE9s5E9lZWQqV4Z7WMOHg/PB0/hlN9rZb6aLb7FzhoTi9i53wJw5S9oVXomI5EMaMRwy4hj4f3Hw77Ow7zlYHLnTHmUTv7je0TFmLyuDFrD0fplcUz8B8P4MKylPZhcyKlDwdO1o6eNMfD1sV088i/Ir9kTe0dqmdFexbj5RizHJMlL0x95GITxo7OtHT1srD+5EqHkwvIyu0W1Wh4naNTzk/TIuHvBuXwbbfcf4bOt6Zn2tmeuTN7PYngVemfrk61ydcnTKwzKjgz8GfdIHb7Py2jvJ2rnI6c5Rj0UvQqp7FUp7wdvg1G9GM4Jj0fo9/B/wzcP4P2fhoz7Rn2jN/c7XyPkwpRjtbP0zFO08HT2dM6Z0dbR+z9na+Ts7Rj1swumYicMxTwzrR0/gXDzo6eUdbM+0cjNDNr5J2vkxetneUOvTwfgzFaJ19jt7OnlCU/Bn2Z+BJtZQlsS39xKLyiIvXBT0OnQ+Q1oauGNa4wNfcz7P2id4gnT5O19jFr5IjOGQ+HsiPTJTx+R3nKwyPudgpfs6OOUdr5RyWHlDq0fhwGkGooPlgiLfBa2VhmF5PuLBEvhoq20dKeztZ2Sla+TF6MYw9ExnIw7sVlh7O2NMXDzotWHoK2pyhbbFd4fYgoyvlEZLHBjGGY9M92uB1TtsDqn8hzMPGhxMPOmO85WGZzgfAx3e+DUMna+UTFr5NSsPRCzpn5CFjTOtHK/JTctbOnlbI++jIt3s7xymdr5RGj6J1LJpYRgeU9rRuedFJ9sihOcir0zGq5FgYR4cmpZM1iB2ksNGE4jJMtRrKMufwb2Kbf4DRc5E5TyS7J7G1p4Y2/wa5aNUNRhlq3wcAu5WtFr/A5yPYynMiqWU/wYnsj/ANFxjsXBqODPtGfjRy/wZ67OU97MrQykjKS4OOdDLlGf6HZuTb2Yb3JSnaezEr8moiOyJQ10HiNmVHB+mzkZUjxPA6TDo9smLVzo/wCQNfcz0P2P7M9UH1XRN19vGO0zEyvQuxbk1GxY7LajZlQvkzjR/wAY9M2uB5nQ6d4ZCTnRh+8E5kiKZ0xUc/BpzlYMqdns64wZ9memjPtHayjvZ/wvFLHyY+T8GflM1do6eDp0f8M/awzPs32ZtHayS8r5R2jGPsY9H6Z01RGtcmaOn9zPxs/DI2qZednez0YtY2jtYMYxsr4NRo6eND4f3I1xhiv4M+zPTFd7QrtfKOS1kRZQkL7ClZkrUUcGdscj0H8HyOXse2x8j5+6HyvlHoj7Mp6ZGspiXNiU08HYjXB2YNHxoe3AzH4GWHmUKnOZOUzIqrnZEJrnZqddjWGrhiStBMNib1EaHeKTQk/gLQ19h5hjgedxU3kmJW72LTnZEW3SZqf3EpyjsyowzKXAV4prQpRPa0K7XwFaHyK055FTnQq5Jis9zswhbXJhS+4+f3HiBmFiBwx3DetGhrQ70rQ/kh85TKT5kVm8yYTnZi33NRjszeu/BlRhoz8Gj40PbjRlobG5XyYc5kWOz6BzBfJpdZY6vCN1gSaactGHeBVX2RX9ApvJ6FaeyMqNmVVtDtTtFtJ7HysbHrQ3ODD6Zi2WCj4DQ7xoq5fCGVtlaE6jYtNmV2O8fJgvuZpGss00jKdFHWGb6NuaTFlyLhimI2ajaMxR3xocV+A2nGA3fA37P2tGbWVo3Y1KO18nDWOR050d6MO6TP0JErbCPZqDKlktqMtbMOWjPtD01rJnBy1nYuTXDJhJ6eTHsYHTxpnRm9rQ+HydrI6pjZi1c5ZjGzmdnKFLzjgV50W1wZXaKaNbM72fkdrZwcdmHHJF8CLehyuCJlCuejPsmbWdmV+2W1KqMkSv2ZXEGUuV47414b7G5W9mL52RHp7FSic7IHX5OmRKjBqMQZ9oz8aM3xoef0Nzk3wMP2YdbMZ+5iVydfkUtNjPDgzW0Zrg/oy5Wso2vwOxZk5aZjuT/wAMxK5OjUSZUYHdYM+1omca0cP8Dz+hsZdiEv8AYq7T2hUu+zRzgVIEFqwWUcDkfeE/GvAwasRD97KTw9ih/spbYtPyciLKHTInpn6aOiIHcQ9m4Y2YaemYfCYqd4Eh8p4Qld/CFtfBHMlNNZ0Inkh9hsdqVnk6fLJ08LYyTQy4Dp9PRh9sGHDywUcPeEbJ/Bmn6ENwy9kYIahZ5IlJrK2ZSa1liUyWFlmITAqcrIVOshV2ChO8PAqd40LhitNbWC4jTBkHdMB47WWO1K1keRkmqWzDnYo+mOn+hZjkShv7EdP4MzkzTyaMw2ZSj5DUw1nY9NfLM2vk2mvkw50b9itDwxKXTwicT+i+5tj5JnRhxzow39gn2RsV19jMp6Ffsyu0anaNckPnZ3EdGL0x6/Q6cCJRkuY0LMrQnNi8p/Bb42UCbangyuRWZvgbqY9oeI70VKdyUcDp7cMqfwNhXK4FiDRqdnDRxxyUmmjfTyzYxWEbnQ+dG50aPRh+8eGK5MPYWXkJzKE5nrYrrgyp4Mrs/QfK8OO9Exenk+5j9M6eDoFiH8HX2ImtMELG0Rh/A8tvLA89Mw+mYfsxX2On9zNbWzPtGE4aM4yjUr5NSTHTaMWsGL0zHpmITwx0458In0wdb5HftHSmssmbNSvk/wDSPX2O1jY67Q+jtfI1H7G5WB60mb6MM3Ytp/YXD+Dp5OeTKrKMozjQ+V8s4a+R862bnRvpj7wY+cCrOxVm2JZWzrLFaGVWVsmVKzs4aO18nDWNj50Yc6ZwapizD2LMMW086FtPOjMrZldmV2dr7nQ7Hz9yL6Er6YqfTEhw9ixTESlMojeiRcsUqy0X9oSjqclgulYLeiB9DgyNPBvP2FlPwKVPJttkmu0WF1Ry/IkQO3sjZmzDjRSC39jJuRmfwJQ9GeoNThjpQob5FL/BRztlGS4Y6gsMblsmYdJOWMyzrTEoQ9bLe8GZTa2K1O0a6aRp+BEU+xx3lCprh6FR3kpDTFVZQstTXJn0FahmfjY/R2PE4gbB4h9jlPwOGTXsPT0ynpjqtH4cnP2MStozKnArXoz04ycto1DJrkJBKJI5++Tfyepah2VdwlIXtv39MU0S2kbSNngseY4HldT/ABLLLXXbM4ZtJIg2xkxw244EmnyhEBZG3wxsNMzX5RiGsbRO/wADcv0HWcsGIlU8G7+D/oFw8imYeS3SZLSlgM3FXsaoayJ6CdrGydrBMejRobhw9jqn8D4DzDydRQ/aM+hM2smVNIJ/7MWt6OGmcDFZF2+TFfsm1+ScNM/AWY0LMPGhW4boT0/g6edMnW0ZpZ0K5SyidMrI3tfJ2vkbi9bR2sMx6OOGUp2UqcnX2PSGzI1yRlXozexy2nxof4Y69PA+NM21zgfD+DEp5MDyc/kw5z0dzXBjtMx6MLo/KZB038mc50ZrjZ+Gfsz/AKH1ngeZXyOsY4KV/cx6ZitcmK5HyMWPn7odQ1aejD9m40LLR/wxb/Yr+DPxsyp4HanaG67HprI6v7mL50YaqmTDjk21kv0OhcfkzQstR4yp2jU+DqPuMY2Y+T8yLMGHAtr7CxHGxXM/AqetmVk1O0ak7MWb9mHzJENdkXAlxk4MXP4YsiwJlO0KLEwp4HNINskNkL9kDgtM2h3j8l5/Z+aLfGzkXvZPOysNDhf3GouKY69h1Tw8HT+BZj4CUtp50K0PAVzzsSerXB6zs7+Q+UTC25PxLXuOvYey0zsPbZ0zPIsEaeGzMraM9kYVlZM2qezpUZMcGzFjF7aFC9PAqtjkUr2Eozk4POmLllCv2tmcYHa+TtfMjxKHV62f+h125jNsNtVpmUt4I18BzvKH3TWDPtYMKtrJm1nZdNfJPx2fgTtYEEeYknVPCV8zz/iIniJRPwCPlL8bxozJ6szI93wxXnOjPphmc5I7hrIudk3K+Rc/Iopw4E67aGqN8olKh9wb07WhtYf3G51sb2ctD5/I8pjp8Hr7CjKwL8cHpegvwaMp9E16JxwexNyxom5Y0dPJPyM1wZ9rYnPtFt97J2s7O/ujkq5ROYwNxjD0Nx7H5R7wzt8MnQqmfgvEXwLiLFcMoZ9o1WT/AIztHY4HpNjzD+GPvK2O3wPa+Tr8n7NuhVSNkaNGp0djHoreNG1Pwx5vOh87O/uPbXyYvkxLWDHoW+zEz8GKeSKh5Mp8lpSOr09H6ejYliec6ZTGfaL+xM4+Th/Jna+TFMGPTMejGcMiKZimdfY6edH7Rmt8mcZRaSvk7Wsna+UzF64Ji9HvBgLh7MWOmdbP2hX7M3tFu0an5HTGyYtYMKdMx+g1rWjpqmL8MWZZ0cHkSn2i3tF8CljKGeULb7ijawL7Cvpjupxo0NVodoexmQ/u0PT7hz6Z+hfRPKezkvkq4YIj0OPopnDG5+GOMZaZ79DPoXnA7WVk7Xyid/adrG0YxaZgNrDtFKdoeIfwcH8PQ+G70x5ug56PZTxSG5VRns7pyjo9o7w4MdtoUrtslJXkXhhL7MMSwstMSWHnTIPrkZ1TngsuArtU1lE7X2O18ojMYevCl3wH+B8B8sPB2emPh514O+no3xsU3KV7HmU9mPyGHSzlH5WyveyOfyJWIlMzor9kQXEP5N/iIqo7KiT7J7sRNrJm0a4cHaGp0drB3o70YafJhijFUwNmPkUOmxOF08kwumTrKGwuTC7G+VQ3xYlbtHWtHv4M5zpn75Pwz9+FyjsK73sxa+ZPeDt8MlPOT9i/Oy3e0TNrK0TsTtG5V8idzkw5ytmzVp5J+DJytPZhQdYk1OmRrA7UbFedGZe0ak10JrkztEw5mUTF5XJi8pmKHfwO940O3PA3JmuDPxR/WiOKeziKjRyKdfY/R08F4w0e/hnTzpmfawRPtYP2f8aHyNpWvlFZ5O9bNQwfoa5wP8H/ACTp40e8aOn8Mz0142/2Fyvk7RMY+TtfJ+no54MZFbxovH2ZWH9zPvnwyM9NZP8AjLyvsblfJzGBV6eUfkVu0Vh4OnfAu88nW9M/aPwzc4ZG18na+TNr7GOXJhcoiPYpZsRzjR7+57+GO4TzpjU+xL4EqmE9rPA218oQJ88i/jgo6F9p9k4u+Dv8Mcs55HL2PoG71GyHsvlFsL4MsezlFCh6PxKK8D540xvEfZkcPPI+FxhDVOdCJva0coMuGDpaFU5ITLTMenstU8sDxKp2OI04Halod2yjQ64FmnMQG+ANp1vUGaG9kYnR5Yvsezbh7FVa0xYlvYqNnnBlSzozUWhXCi0Wf6CuE9kZpbN5BPT5FTnK2Y/2YfvZinh7HSh4ezNqWh8vgd8HwO/a0cGVodudrQ27LPA7f5H3SYcNipt6Ztw9mJ1OyIUPeyP+x9nA4xzQXsD/ALVwK9PWWnKTfpL9/QRoiZFKE7Jg1T/EmTRkyYMmTJkzCa3DHpEU6hrLWyk+4lvhobtzzkalYeT9cEL2xj0e8Mj7HXJ08HX2Mo3PGibngnTZMXyQfInFfkxLfcmoZOmdMdLQeNODp5HLcbQ1MdFu+NHaO18mMfIq9jFaezHpjwNJa0agf5RM3vgm5/BNwFwFwwY9Cpzow5eGJtZ2Y1TFtM1G9HWzNsmaYGUmsMnDXyeqZ6+TtCq9bMMVG4eGYbW2BO5fBdp50dQftDu+B2O8U0PTXyPlfJi18lz+zHYqrkWI5NQZUbQ7UfgyvRbwRvaHbobkxeUUpeuTHzsjWvHT2dP4Ot6LdPKM+0ZrZn2jPtaMvoVh8lpwtGL0z9jErT2YrnZ9k7GtY7Ha5Ga2adGfjRlp8aNws6XybnK2Jx6FV6Z+D2dPeGLEckVoZ4NGa2O/a0Z9rR++PDY3C5MXkpYw8s/A24eGYUP7mowalTM1iNGc5Q4/0HaVlaJHO0JXORFk3fki7TISKtM1tQaXUioLwoHOtrQ54ytDk+1obN0HvA2TlY2U1TK+nsUJWnspXOyXSdjeNOy0Ydl64H/1HT5gaxwyzvWx8MEQ6xotO8PAqth4Fx8TZPOkLD5LiNjUrkNNBZJ7WRvDTpZNUXtmaTAimdbMYWHCk8sGJ0ngWWms4Qpw/sbMvRDxNhWhErs1WVkzCfI1hr5ItNVsbrAvsFTesAsvTSEs6aFtP4Lhp50i2o3wXHOg6YDwmsjwmvkek+R4JS2OJTVIeU/gOJ4YSk08PB7xwLaZ08rB0ImA12W4aHj9kYa1keZWNm6wYfWiWneHgw4eHgW1tgXDFaTYsRsiVyHYZU7WTtD5S9seU1ghTOjfTKm8MVTpHv4Fw8i2mr0Q37QrXZErsqKysnDQ7iPki00NysbFlwKm+WDJrDQqrDSFtfATcNPPBLaiLNchuAeuTprI9J8jzKxyblYGrkb7YFkm6eBLkXHJ09YNRAyoGuzMdZHhfk4fGTc62brBh9EtO8Cp3h4QtoJ6eeBTa2KWuyK5DB2p+52mPTXyx5TWDvRvplJ3h4FVaYqdr0KcP7CeU16P2iZXZldjxWdjmmjkvkaw1geZWNm2Yb4eBZc40JRn4QllP4Li88F42LexnV8mqyan7jWGvkeUmNj6xs30b6eBKJneBL/w3DI1xg62ZQsnyRxlDXGSMR8jlQ1jY+VjZuRSfTwdsCmTlfAVUxWmtmVG+DK5Y7VZMpQcRjkcRKxsbuVg3OjcjDxTOhdiWhcb0ZrZldkVXsVHZwbTXyPKa+RsYfbRu8aN9G7wLbfAsNMyo2O/Y6djWK9hucfI/wD0i09EX0JX0KDvDIM7wc3waWVxs+4Udip2PGPkx/Y9oo2rGx3Dg+EfYMzj8BQlNXoVWtiko3wWWLJF2OKTBCwOmoH+8jUq3kiVWmYcMG2hZLjAryK5nKwZblYHana0hqnfRhyOU28opD5yjKVh5LFGNjpxpmKWNyRda0RoWp62Zp1wLllCl9tGk9rg1KyNYayREcsoyUbMNJYZlHIlDjQotsC4dCMHgmZnQ1KT2jN4YeNGjDRlL2+B6a+Tcr5G4aWnkwxMPhsi2taNw/gzKbxgVOGto1eUZUomp2PEMmLRNrk/vJh1sw6tM4LHZytCz+hXKehd/BEp8mVO1pGp2P7jv7oiIfOj+yIajBEPoiHGiMPsJaYlNPB7+Dtoy3JpPaNSsj52Rh85Q6ajY6aSwZRyKnGhRlgyh4FoJzM6wZU7Rm9o72anY8J7fA9fkeZXyOmuNmGMcBGVrQsw/gifjAlKvK2jXozJZNTs1yMKVkxD2f3kw62YdWjcK0crXIsx9hXkV+0ZTMqdrRqYsY7n2RF86P1sahqMbMMxSxsjDWhbTFefg6Zq3aJlTs0nsfKyclkxfOR01G9jpwYfsxRyngXDwRgLc6wRK7Qrva0RU7Rqd6Hzsevz4demYcGHwI0bv4InOsESr1tGu0Zgyak72hrCZGmr2Ooe+BqIf3HTXBuNG40bgzb4FxwZX9GVOxre0esoaqVk4Z2tj1+TD6ZuNGK0LLWnybLQlKcitQ8mVeUJSp2h87NSYhna2YfvJh1hnSwYfAVytGbfDIkXZCJMexy9jnKycPkdXyRf7IuNCtGhdaNE1yxJlCzT0Tq8kqnYm9inezlsW2xwh74HGPyPDgd40O0aM40c3wbL/wBLq/sXXaHvsf3DrKyPBocbWWOsl+jLywRFvgz2Qlp5WDL72PwGW2srJ0G/R7HVPkdUw9DcXtopWno+wxuP0H9zEFumM5yi242hZLawxXaysiuUyalfJ0pbMKV7I5aZuNPRhpPPEHT3g7EasK8r0fkhS55Rm9jpT2h1WuSYuITJyMXsOvbRjo8D+Q6tezbT+BzMO2sMd+0N/IvKyjNM7O1jZi0PnQ1C64KRfoy8sGK+xnsLvKwZfewvsGb2hbQ6U9mKfJi1h6MXpkR6Ylhp4Ii28EbbwQ3TyROdYIb9oiS3ayRKaZIqC9naxsiFKwY9MiH0zDh5YOn8EbEasxcs6Mo2XhgZtZ2dMnSuTvkxfJi9Mf5aMVpka5OnbItp50XMlLWz9ot+xTlayNafJGmDFr7HawNR6MaOuckOmwRr5RExsJc5WDL7WxfctmbWUdPk6U9mP2MWsPR3p0RHpnDTMW2dP4LdPIu8oz7FfxgzayZtfJqUq2dr5MWsbHV6N9Dpw/Q6+xFwyNOzPs4bFLxlGcZ2dMo6VyLmMmLIi9M/YiK08EaMU7IuP0Xgz7Rn2Q9aI0zsjeiEOrRDS9kR6Y1HyUp44GsJm/wI086MvtGcq1g/JbM0yjNonZj2yNxenomPRarTwdsDzB2Odlg3G0ZnlGcZIm1kzaO/uOrWNlfBj0RHpnZUTt8C/wBkXh5WCsPKJT9Bs742bi3Qja+SItGPkiPTIxODHaehJYfwLgWaZNnKwS+0TWsrY53spn7lEwQ2hOl0xfAxitPA9GZw/genGD80W1jZe98mzWUcksZOApgON6Y+tHDWjPA6edj/AKGZmaej4hNHeHtFOXlwWrS+CYtXyjFq09H3Ib5wPvLDOT0Y1p/Aa1kD7p8kzeHomc9Ambw9oW2vZE5f2Cayt5CpVjaKUcMx2CcUwtLDTKn9hRh/DLdfcKcugr9oX2ygzaOw6UreR8jHaY2hotPYzlaDp/At0/udReiNsHfSaO/wdKfA+U9o9fKMYxs3uBVnBvlcnX2Z0/ue/hnse8i52d4e0U7y2hVhfYxi+UYvKej8o94N3jTI01WmcPszhlpkc0+TPWhE27LRG/uRxnaOWl7R63oiMY2iI9MiO2MUxGsNMi5fDO3wyG/TZHwP2iPh7RE3wd5bRhStn6PymR9hrWW2OmtOTNP4ZDxwR1Z2oR8Id/gS3jlDVShEY+xfw8oi+UKsiL5R19mRp/DI5zpn5aZHw9H4Z3h8EJ2vlFnq+UYvMj9H6N3hl4eNEaxwyOc6Zq6Znp6M9NaM2fvaO19j18oiMYeURxgj5RgdPGmPMP4ZGn8Mt19xE9D9oiqztETaI2MKVc5Ii9C+6Z+hrTw9lyslyZp/c6fx4t0I+GiN74I2vsRv5Iha+xHGNkfYh/DICIzejI+xGn9yJ64Y1NYZD+eTv7DN4ayj/keH0q2OsK2T9Ec2jrWmdaHauGZrjDN3nRPwyd4HeGctZ2dr7Hr5PyivhkfY940KcfA3D+57rhmc5JXNn5Ene9o7/B6+Uer6MKrPymYrKIjP3I5+GRr7MjnWxKXGHpiBfhibWVoTEfYitY2cClCl62fIhC9HYdsHB/DInrhls0z0+R774L3hrRfXwdV7R1VbHDCp5PuTGm7TODxpnHXI9X8BiPuhw4ezI6W9nTeTFrByW9nDTGK0GolsPZ9k7Ha1Hw2hp9rQ/vWi17Wh5la0NS430YcLWzDlXOWK+ZTFwtbGKwdSKqkcmymp1wZUtCU18DMcrRm8vQmbVGafJudvJyV8+GMVOzFaZ1hB8vuOIlXA+NjuFphET6Gb2h2na0TNM7MOFzkbhyrnJ7UxV6ezFaezFsPZG1GbUiE+mi3XB+0O/Zmzpk/9C5WNn7bMensVU8ckbYexL0kiVIeuBE+9CIdrREw9rREtNfYtT7FLWCjnbLPkTI0tPZTOxSgtmCDv8FlLRdRsco54GpvLWjPAa0Nwt7LJVzkSyymYkiPTI1hckVL4I2OGxqY4YRbpC1za0RN7RE2skQ01fJinyRFzT2RHzs4aPsc+CJtSLe0Q3UYInpoaT98Gb3wRp8nfOTEtY2Rkt7MVp7IitaYlp4eyNqkyg9LEGfawfktDu9rQ8pq+hqREWr5Ii1c5Yu0yJaWnspTw6kjWmL0LQ6SzosoeUWoNY5Whqb2tGbwNbRFzmckQ5VzkSl0RBH2EtOlyRpnaiJrZExysIifaIm9oam9rRmlkXKvkdU+SI+diUemfhyRFYXJGuTCGNLDIlRwOXtEfekDUuVlDXy4PuHVq5yNQ5yiIvRstPY6RpixGjsaD4w+B6bWiPutGb2tG7e0dbe0fcYtYexKH08lej2JRWjFaIqVGbGaxBKftD+9aG5va0W7O/udr5fhKO09ir0yEvTIqHS5I0/ggZp5M08oicYaO98Fu3AtpiXKIrynki9PZ8Bir00xdaYtHRCw/giV6Le0RPpoal1k+5wRvJySnkq5VrZFWatPZU1zsxjTwy9vgwhjrER0S+1oTa0JlpD50O8Lgc50fg+BU3OGYbneCrYjO2h5LY7UC0E7GhEXts1fGR3DVD00N2vuKTmmYc6eDDvDEobXOCSlMW08iw1suI2OWqyjPtZMpPEZFNDccbNpMbQ6aewqc64EofTFWTFP4LvY01symuMDvsNYaUvY7Se0xphlafgv0H9hENzhkS6eDEyhRci3JFRvREqBldodpfkqE0O70PT0jc4RLmdaO32FTc4FTveBRbCWdhYjYlKgRKhZInVrLY1h8ETDRo0RacVscJaejLplH0xRlcihKEsoSpreiURtDZrtESu0WU8GvAyhS2hq01ggc6IhyWdMSiZFCnnQsk8io9tGHZErsdFCvZEpPjI1vgTREs6I4UKDvDKPFMpMr0Ll8CVOVZhGyyjZDapWuRyXrJFJrQ1N62NTeiLnC2iHMkf8AgStyqIh3vAkrTIrkcCJUCJUbM6vsaw+MmYaORufuRczTIafTEofsUBIpiWUKjnOiHEbGm1CyiOMjUqeMjbOhrT5IudDg09FHOhO2KYgtHfBGmYPYiYESux4RnZEpcjX4E3BD9CLnRRucMo8CUTK9CXOdCZlWYRvksuyG1CyjCMtjljQ1iByh/wDo7J6IHOhqHeGNJPoiJ7OZIg6eeSKexldjVdj/ACh2k1o7Xyb4EBh+zYqfQi8MXLJ0ZVMc62hs/aHLUkTZGGjfBudGH0xKH0JaEszYllNXoVpoioIleiG/gzFeyMaC0GRFEZmKK9BL96EimL/oJUbETUbEpUbIlQjKrRxGhqYIx+TR6ISd4ZBOdMUDsylEsNWY8i3Yc0OvaJIa0NJQ0xIhpZyYdbyZQsMSitckW1o2wrlOkRCHrB20qHk2J7EPCTOinIy4PRSMEyhGByoLDyYfBizoMmtfsVzhwK1DFczrCGpSnOCFTho4R+hMRtsnD5JwxUkf9GIxT2Knahb0L1oVzIrTnWDD0OxvQ9GjTfgekyPT5yOmg2mHKinC2Yca5OWwcp6Fy+EZp6IbXEGu0OwYTDHpMjqIWcmH+z8GJQ40crQrbQlMsxKDWIwcmhQ1O1oiuQlS2NB9jgpEYZRIwQ0408lG1oVtAro8CUzhwWUMiVfwOcvQjXaHo+A1EbEYfJENPkokFIxT2UblRstCTIUpnCwJKc6wRD1gix6Iy40OSReDQ8GOB2RL9klBYeSIrXJlwFoJnn7Fqeiy4gw9YMj9DomYH9xrDQ4Q0s5Ih0UrTFCtM2WiMoUpWCjtFxejKnZFTs5bMWRvXA1iNjUINQ4WGRFaEra0WNPAlM4cCWD+BSz8FlO8CHGLQ9GeBqA1vkeBShSEUyjehstEk8ClM4FJOaKBqDnRFTwRSEYY1cjg12RIkoKlsSKtcmy0bMKWfsKVcE2vRZC6kdORyPuD2Wx4dkRHY1DjTKPgZNaOVwRNCuejI7XBVtkUnsc01k75yYdbyRCRhkw40LMPBvgJTLY5Fw16JTUN4wXXaKJ8RsemYafJhqBK6OGuRZjQlnQS2wJlCo+hKV6IrtDxJhJmjyZEQ97Ii+RKHWGVcKkZxpiPAmmLNMWVYtOhFH6FjZo4ezHY7Wzhr5MNGHGmJQ+AlbWhbQkdfYSmSJXrREohQ3sdExIhrI9h1m5G4th4LVPDKVr4MW+GLMsrBwm1s9LRyVRlmpVQfcWTpS4KXph4OaFH0xoynsdWtMdVmcHbPJm2VhnCLWxN03sJ5bRnhGSfSE4UfkwkJhOW0KE60MVsJ3wYqcr4Fw/hi4a6Cv2Zxkz7Rm1k1qOuEj5+45X9B0+nomOjHVNUyIH3cETW+R3W1sz7Q1CcMZtZ2an7kxSuUP7B16GI4ejg8PBi2GdrHy+5l8lgzW0L7kW+EZE40RpnZw0uCIvXAlR6eiI9PREVFMpCdplKOb7lrZWDRtbIw2tmzZb0ImUWCih8lA4OU9eA8GmRfBji4dnCL5LWVoUmKcxk+4iylZWRUgRCDWynpjg+iI9ijls+Q+Tgu42tlq2tlva2bsNFvex0lfYiofKGsYIcMbKRVMainhkRTwcHckCNPKImvyRwtETaqMkbVQRplZFwpcERaxwREPT0Y9PRiooxTuSCNvuRp5Iwi0JP2WxKbImyJpUCUKHyUDguno+wx4NEXwZVw7I0Rpq1gsLhkifaIqVQlQiFJAiPRl0yIqKIhw9lKI1ngyjZE1vkt7Rsw0ROMnJfKI2NR02iItYZEXp6KemNRCeGODjkez2OXpgamt8jU5ytnTK2O7RqVXI+FDrkTHR6MXp6MenoxTwyfafCtpaJWOBrTfJL9kXbZ/6Eq/U6bMER6ZjVcGK0yIdkaOjra2JfYZvgV/BG1XJ39zlkxejF8n4PR+nhGIbZyCzb7kKW1SFn2tl/fJJK+5xZMJMX+BVTDO9PRj0zFPDNxzg7n/g63yZrawfY1szaoVy1XJ0rnsdDHR6GovXA1Hpj/I/6GdvkWXD0z9COKayZtHrO0el8HO1wPPIi288B8PGh8NVplLXI7fAfDzyO+mQ3+QzfGisM7RcT+DF/IanTyhUq+BMdsYzaZwna0yPuwEql8M5K0ZmnQz1GTN4Z6yevsblL2jtbyh1eW0Ugx6Y/xofDvhnumdPOme6Z+S/JnrYm6p8HLX2MX+DFHXA5WpTye7RisjpmITecMfLOmdPJE9Pk/ZG8NZM2si6ztC6VcCP2uBKO9j5G0J1QmnjkWHIJLL5Fq3yRP6EvQibxBCys7I3+CItJ5Rh+0RHrgiM2xEfJweCOXwzGXwyNP0ZE060InqCJ6ZHHyRtfYylfKOS+SIvLaEo7FPnwejvgjnKO2eT8tEfDI+GRfHRt+jp9it6GmlVpkfaOGRHPwyIhP7jWn8M4OmfY+SPsOW0RtEcfKPSraIiXoiOwkl2no3eBLM45Ijox2+GRznk/At0yN4Eln7iZqfwRw9oxn7oUMY4O1sfgyWHgenOGYy+GRp1oyJyI+CJ6I4I2s8HRfByXycsrgiLyP2Pw0dr4InKvQuWdM209Mt0yOoZHxGiMkRa+xS9cEfKIj0RC6ZEdp4P+WcH9y2c6Gpr8jXwxPuNT/oTazwNbXyNcKuB5q0PZDHaZ+Uz/AJJeH8M6H8hbomfYpd4Ykdr5R2scH9kQuUJR2iIoYp40yNvhnX5Ot8n7In2R8Mje1lG5Xz4I+T3aFw1R7tHvHIv+MWL+Ge6emaC7Em8NaJ5X2Of4EqVjg64KXoXOj3h4Os9i4/Ir7aFdb5F9mfsUv40XlZ4Ilyvk9KuDfK2PZWjHaY+8MfDxpkafwxv1a0fgIy2qO1oV8oFUjF/cxaeT8B6LDKS2GJUtlpTrg0W0SYEnrQO72jNDLg/aZzYKqbycspnLY9oTODw8M70uSalXBmOBnOQsHtYP9AK3DJmZC4WKrVzk5aOWmOq09j5YeCIth4HXfRng0TMLTCM+1ozaytEzaytD4X0dL5Pu5Nmz9tnBqns609lYdTg71wx32Rmto/JaM3tHa+xlwvkVU+RVYqtPInwYlgsMiOjEqkRt8CUwtot0F450FL2i1ojaxtEZSyn7EZaeyIvTKbyUrT2cnwyP9C0cMFs5H3FojLfBZ/oW/YjQSi1vJEp0z7DKens5sMrbDwQP3ENTWELe1ovc2tETaQjS+RLS/BES2inzspUUx6aZwex7KGpytFs5Rb2jZtEbWiJpcCgIiX9yIxsp6GorQ1thkVIiafwRMLaIbrCDk+0R90Wsi5T9ojasUP2EovTEovTyL0JihT2cnwyKlXA5VtYIn2j7iwWc74LPkh5s5L5FC1vJs0U9McPnZSnhlbYeCK/Qt6ETWyPutFrWURN7I2vkjSygiLij7D2aNcka0yP+xyfBwfwZQaNjm+0NTexJvY1v7iZYaixqJa+CI9EQo0yNPY6SIWGxGNokxlEzjKIm9rR2dBBfLkiL0xRTT2YUaeBct4M2wRtoia4ImptaEp9oWeWIOms+EBKOjyRksPJH3FU+BSp45OnszTrg7fBn2hX70Nm0I5Tg4Cjhc5KWsbIL+xPg9lVE08FKeHsXDrgzTOjNbMvtGXP4P+F4dr5FV8iqYw8GK0KlGmdcjVSojTHdbPa0PlXBmE+TvWzhrBhzpmL08GGIinh4MSn9yHeXBEqBqntyO4YFqZRJw1r5Du5Rsy4cHLXA80sYlsZXsVOHvAlEpka+wk/lsSBEr8jK7WSJhrWTMcIjDWFkXKxwRtnJqmYd4w8MT2RTT+DKjTB8DRaC+TGvvsenxs4Y7c6D01j8mHOuDEtMw80y1m5Iie9mLZIr8TK5IyoWVljxWsmbWh3CaybnSyd6KTnRj08CQ+xA4eyCmZfyJaKOXIpKFlCkkZRDprWRStYEYeuB6axwb4MiHOmYd4YlcPeCkycNiYKnIg0GpXaycl8kcaHg+MnJYHaX4IuWslG52JQRHyJU0/gSYPKIhS0NnBYcnLexqYY8HwcvkRvRRyRD6Ih9MTLIoT3hnJk2+wclGxyUbQ6UsZG2hyhrWTlpDbKwUuKKfJR3so4eylM2y4LUYRvkwhZLKsrJDprWSJtY2RvCGsPCIvgKDnTEh+yCnvBBTFSNiYfMLLsartEMoax0PB62clgdpf2MuhQd4eBQzZET2YNP4FJRsiVEWhqq+4t7I2jR8GUiNrBEOdEQ+mRDvDIjNybJ7OQwEa2RNRQiuyJxkf3bGtr5NrwJtYGmnOh26Y4NkQ3UjhMlE08jRCb5JaQbdMdjUr0ROsETDWjhm50yLnQudCTT/oShud4FCstCVNbEpUbIqFkiVWTOMrJEoj7IjTCIvgzvXBh2Flp4eDDh73oSiU8sh7zo1GzNGUksjtUaT+5x+grhMC5C2vwKZwyr6YsVkpT3gVY3osoFdaGfZqtZPWdna1k70cNYZi/wYfTMNip8iqU9iw1suImzNB2uIyx4rPJbGslMDqI2ZLh5N1S2bjRa4GLLTwcpoznQ8XlYHLZpWSaMWUrJeHnk5L5OlTkeVGNiXWGY4DbBLLUlgSmU/sJQadcCtXlGbawXAeOA45ERCXJhqNkQkbyJFMMRptPAlE6MS1pC4/ZUp1g1dsd9lolbLMJ2YpM7OGPPWymLnJENRhqzEORQm1oWWL/QZ/Qdq8oprseDm0YSHp72PTHQyXAs9bEohpiTUNMW2tCaaJM6ElehJ+xJo9iUw9kTYltfJxFcshSoxsausMiHGjnQSzwxIlp/YUk5+CJzo1esEOJ+BFcBFLkRRL5NOxqGuyj9kRRGdBKa0sCU0K8/BHOSPkiHbLGnCexKSZIdMauVgcMfJR+yIYkStCV4EspiU5+CJXZTXY1K7EqQ1hjWHzkcMFIIusbKONENQ0zZaOEHYiv0Sh8jo5Iw1kamzkvkaxG8mSj5MqwzKMoSytGxjQmmSJzUYFL4Nfoig1U6DWGOH7CQ1A1DIh9MiHGjg8CVxwJa/YknnWBLm2NV2NPsxqpHRJkjDIv9jUY+Snyij9kR6ErYlmfgic/BEq8oprNoip2iKkip2cNZGoh85YsQ0NQ12NX0O0aG09FG5HRpjo0Mw2+Rqp2NV3sa4+SIvk2tEQ+nsixK40Ja0La0LvAlKa+Ar9CJU7Wjls0eyBGzFreSIcckQ+j7GzbU0cr8Cm0/hMUuxheUW0ZXZqVkipix6fOTDTn2LJi0jKBw1ohj4FpT+DG9YLq/gw9CxO9Gp3snjJiHzljq0YajZj0LMaOGhZYpaafwLh5Rldj/ACiaxaH9zHpopD5yOolyh1WVwblc2jDlsw5W+R3b5Ga2tsuV2sDpVNZY7UrRhD5GqH2G4v7lb0xTUJ6KVlYGHK5MOWNG4ds6y9Gy2sM44aM4prYlUKMqHyR/sRHTgwp1wKD60EpRlBU4yJO23hkFrjAlNPRk5Wz8kP4RkfOBzRXI3X5DxweUJF7aHXp6HytaHTH8pwdnLWGW7Z5LdbG2mjOMrLFiVUZY4iVXJqFcmA1F6eiq/AxWU9G03wRDlvAsyt8kT+wSa2tjHPOhMnDWRIp42LR8i4CW9bKXp6PiE9ENVrAShyuTKWCMp50RrLMytrDP12Z6a2JVo+ToR/sREPXA6tY4Ij0IisoOnGZIdt8FPQiZT1hmSr0yPkiNKa2ZU4ZqGsnTGxx6PI1EPT0Ql6eh8rkXDuSNZkjZy9EaeAk37RE+xKSKqoyRUquRrY1HQcL1tEKuHop2uCLjnBRy3gyyPkj2ZE1xst7G3SNllP5I0+Rra+xGx7a4I6plK08FHLZQZQ8i0yxSlbWxL7BKfaEt4ayRUCNkb1wOl0RHp6GorKY6cZIdt8FOUETT0ZFtbI+S2RPUZZ3jsipXyPEMEaYeSI9cER6MZudC4eyNEbXsjWxX7R+RE+1sS+OSFEquSKn7kRa+UYUxWxrLT0NU22h1WZ0RFPY1piLb4Y5Slb5PkIafsX98jfK+41uIjY9vuOF8jhfI1Hoj7Mw0oz4L2dik++TPtEfJCU2qjZ39yJ4ER/Qxf4LUPbRGXJ1pmmg8ztHb4OncbFfvkUueVs6ZREqHyLgahgneuDF/gVZdaCqnaeCUy+BtjOHnRnG9Mv7Rf2tlxptUJ1+zFomIeuDlp6JjttCrudFK50LQ6edM4ZfIr98ic9NGb3yZUr5O4js7Xyh1D1wUvnRT0ysJHA+H8Mek6emRL+wzPoV6fB+XBmXF7Q+vsQtrHA1tCl7DxalilaeGOqd8Dg/hjzedM/YrrAzqyP7EJXKUckbXyQlaUzkjMZEQpye2R+BGvsFy3gJadPkSnNCPhiTiuBusrJpxngxa+UPlY2h4lY2Y/qN82XWbWmP7rTHNT9zDa3pmuNDp1yL9NEOZo9omZ2WUar5RjGCeMbPyh7HvGmVh7wx9/DHpOnplmp9GJT7RwU+BOFfCJriHtHD8oWyxwIyFC9hKuUyMLWmRp3wIjPwyLv0fgrrAf5PXsiLqoyf+ila3k9WmYU52PeD9aI1+WfthnW+S3WNGRPTEpfGyPVNZEqbX2I2vlHa+xFSrTyiI/oe7HE4PytM4kxK3yQI0xHwxTNZ2f8IS4+TGLPVrZHyGvkRzg7fcej+GNc09M750y3tC+DI4+xE2lfBbH2GnwQiUpDX2ZFWpRotaZwY7fDMrzpn5ISnoR1Ylx7ISulEZEuPkrKWdH6Md7EfYa+Voa1+R8P4Y1r8kP50RO4YlOKfBHGUes8CW18ofKxtDxWNkR/Q94MRwfnhnsSieeSJzQjTEfDIes7PWSOPkiMWerW/CEvQ6VqVyRV22BpKnEaGjOdMk6fI27h8jTec8EdUy+FayNNayjaBxVKtocO0OPaOTA+V8Ec1wyOfuNc0xD2vYSEfYes7RD0LrG0evkSrkxm0YXK0e8HT+Gbh/A950bvJH+hnFNC3GeDtVyTvDgWJWODXK2foegvs0Y98MWl+RTXOhsIS9DntHBngbEU9oelHyjixtCazkSkuiYtYmrywdP4bPdcMT1vkVu6Zmti+zFDx7HaysoTzHyYtKtox2mY7RgPfwN6fwyfnrRnKvAze1oy52hOZInLQlK8GYtWtlL2yYrbZ0IZY0y/0GEs6GpzSYRb3octB3ezNMrJ0ezDlT2RF65I0xsRtlsiHxeGRs/Qls/RwedCsMrBF56DPsSnsiPZs/LZEOVeTHC5LY1HsRE8PDOU94GtPGSKh7wztlDtQ8MDUroRN7Wi3D+w7izoNQ+TFq08lL0z/hmmnlg1GD/sah5M1sznOAlN7WhKXO0JLbQmWvkRK9skFq1tiF7EFbbE0IiE8aEtM63oSmnT0h36GbDu9maLB0Xsw5WNnZ0w9kbYezfDk7bO2NHTzot09YGp7a0Z9oze8G9mxrT5MUtbISvK2Y9hKPXIqp7KWcGoa9HTyRPtESumCJva0W72W6Z2bhvJ+xyyjHpkWNNaIqMIjT+CNNETW0R90RMPZEudkS8EZa+SItERa+SEvYiPT2RrTIKng4P4IqC2aekfki17LeyOFoVpS9kXK+RLa2LhsjbDOtcnT2dsD4fwW6dND+xgz7I3tEbXyP/sYcq1spXrZj2Ij0LvZC2dP4Z086Onkid0Fd7WjN7M0ydrGyd/c70YMejqKEtOkyI4BqQxuBuhfkabebRDMWi0NZMoZ2ckvZR18jjevE4TwyeHSHq/gcqZoehywtET6DUiJvYlv7kDFrDyKt0e1hKPReNsMhB064M064M+1g7YGbQzexcPkWYXybnREYw8mJ2jD6eBcPGjlNTI2+GTp1GBS6eUW+lLdNH3Bw+/kNDUY2NGN7IvTIK0aNC2ClWOCdcGi2WfaE072hOYayTNM7E1m3InFr5JS9PInHsYnhi4eOR4l8Gaejg9FqeUWxocu9B3CfI2WlkdOcyYbfJucoTKJySlKZ09mntyNN2zpjpCzslFZLJRT2O4f3gzeloRNp8cG+BEOQqcvDwJQ7VMUJW+RJYf3Eq0ZZRicGhK0RK72RMNZWSJiNZIwmiNFKMOVaIUzpmXTwYbnBEZ3g6I1siU1vRpQieyyNU6yIq60I3TA1f2DzDA8y8EQ7w7kyvD2WqzJEStwa58mVG+TQZVZRmIpoiYemURhr5NzpC2yhWfIWHOZPckUplGh3OBU5ci0eSJULOxqqyPUVyd8GeiETaejfYai9Hbw8CV3h7OTp/c1GGJVBqFkiV2O4jQ7iNZHdrQ8ysDy3keZ0zL2Kn0JRnYqojK3oiVGx8BnssjVOhxWoHOVrJClM3KwbnRh9MXLey/lnK3BFQ8ixG+TUbIrtDWNQNN2taGsNfI1c6Grko2yIvKeyIrMkZk4PeCBJ0/gsoJND4fJG+CJv7mSeiFnTKOdERbwJcqmJZ/Z0zrZ0ahZHa72PUaHeNZHzwPnRvki/Zj0zDFXyRFbIynk1A+GTK7Q1pocV0OW5XybT+DcrZtvRSdmM7I+ZITORolGx1jYkhZIdmA1VZIkcofBG+NEf9CLkgnOinyUfRWVl/geaMex5rZLWGTrsf4fccoa+Rqb0iLnKIU9GM2Y9PDEiRV8myedGuRcQIlRtGV2O4a+xEw+DtfJuVs3OjFnb2KnDFUpmDWWiK5EewzBZ8MxGVod/sbTMk1aMoWiJpvb0NLNPBBkizc4MyeSmN8imo2KSjaLJLZdTxoTmHxkyTWtGS/AyT0JE50JpPplp3jkTissVSn8MWOyZUbJmlnssv2P+CkP7h001jbMOVh5JjGHkw4QuYfodY4C2n8GZ6MprawNz0YQ7U6CZB4SOyjSbyxqGsGxqHWWYMQWHkS7AX9AUKU8PCEtP4FJQ8ilT+EJSu1giZO0NfYIw0r2RCTXyRaaUckQkYeWYdUig61oXGGjMt8EZT1giVeVgiegckGzU5CQklMax9w1lNDg6w8saiip5ZBNpUxFtsjZlC0ZlNUK60wj3rA5ftGu0O4a+Bw9vJw98mIa+RQdKnkgxhkDhB0w8FsRAzSvRIJU08rBErtaIlToRkhpObHpx7IuV8mHWHkw4WNiUONGHw0Uqe8EadcI1DI5+CG/a0ZUu2jU7O1nZiGvk3KQdPp5N1gVUP0Lh5YFcpi2mZUbVoz0Gg5hPIensek+RxMow6w8swkYeSFLSphK2thcsCuU1Qrz8I96LftGu1k9ZI3vY9NfLGotfJEYxsiPTyNQ4WRFwxwiEJZn4Iz0ZTT+D8GiJlvRFVkik0zhpeyLTWNkRjDyRDrDEocaZEONaMZ3gjT+CKvJHPwjPtDx2PE7O1nYzhr5DqmHkw6pMVSh1oXDxoVyFtPRldoyu0aFxORpNUx1f3ItJ8sw6xsw+nlkW9MbaeRWHSHYmOcr7InyQ38GHZFdkbWSFlZKyvka0xtmVfLM+iGDKNCyTwKUpoVXOdF050Oa5aJ1KyiqUNuyFw3kgvnLEi9bIvgRD6IuHSN8NCZTxoV50K1edETPJlUqYY1SDhrOzcr5OHrbIadY2YfYVOFhm2srgSttjQv8AoJafwZXJGe2hqE7I2sjxC2cJnbMNcssw6w8lkJCjgVcaH1obKfwLiyRXlYFXsxkXvexasnNZeSatfIrKN7LOiExosjTMqeCSmKUznQnTu0TKu2hubWUN7WdjYex4cPkek5ME2tCYeyeiblgw9lol2swTZTaE7KbRMy97GYwgcQkpoeC+HyhwxvQ6jjgcqvsMB05bN/kMuOMMSbbbK2LJPKwxKHDWxXe+T/0Nf7ohRKNOGYjhkyS0OGvDYdrjDMyt6Y/uWyBE2qg7wz/hDUcJIq0REVT0ODDZdCjh2tGUZ7IynfDMyn9x8NbI+SMqcQdrOzK2ENfsLnEkRjAWCiVoJQ4ynoStNgu4cjJjMC4TaF+S2K/7CUw8QVEKaFgdr7DUWt6KXrgdVzox/Qw5XODtg3GYwyJbTzydvhn2NCc2dn/o9ExHDHQ3JLWg8wdci2O2tiuVvkz01sU2WjN/c1OGiYGPYxa2Yiqeh0w5T4FzK1oUTsLazGzNP7k6fc/JGVO0dozeC1w5OyIxsx6Zhxno6eC5h2tHRw4MzyjPUbM3iDpUeGpX2KfOiMccH9n7GGO33M1nhkT7Wz8uT7GiZvD5O18jwHj2Y9eG5JaejcaI0LY7awzNGfexbtFvo1OzF/gx+xCsYjh6MayQ9h2h2hrrI8kvuSGm/k/5YkdxaIpPg7WT0gwNTjoaj5KRFp5RERwyLjnRFyI9uxJJY7LVwIFp0zngdGUSiH5Iksi1QQqymQQtMavYjb4Z+mzPxgj5LYrsW3JqVQ6QNJ8kR6eiJfoY7QxC0OArrfJHyEtP7mX6M3tFBqR9DChsiIfOUUn70RDXD0LMaENm+5v+Rom1ga5WOxn2JL42L5Bf6AoQjzopHYo4w8oWvOhYfgQO0il+jFin5FKptbF9jYp9NCpMwxV4MZKfJBfJB86F8Ox8P4ZOU/vs6w9Ey7po7wgp/sLr7F5S+DtfKHTT0xy2Gq/Yx7bH3h4DJSeDkccEYXoLTpMCUOASs9rRntwLnLaFwxtHeeScopmI5HWnsXDw9nTxpiqvsS8POmK/Znp8HpUMy/ujp9j2OUcsjT4Pv5Ead8h060yFh/cejGtOnofwDXxwGsxTWUO7yWjl5Gqvk7ih62O8oiP7CSm8aYtH8MyJ5Ep6awJzTWBPhrAnVMicZ4FOV8o7+6KTX4D/AAfrk/XJjOHs6eDp1we8mfawK1whn2bo9fJ2scHZi4lM/TOtPZ1p7O2OTFfYvGWmTOrM+1o9YHLSvaOh2r5FyOPjZEdj3fIeP0yVj7jozTp6I+A79NHquBvlwdrOxPa+UKriUfo/TMf2IvrTIwmvTIyn9yJp50RzTPw9H7PWeDtfJy18odNPK4H+DS4P1ye97IeHgjT+Ge86In2sGVwM+zOPknjOztfYnaJj0ccM/XJ+ns6f3Mf0dPOjPsz7PSpo/fB2vsRtfJGxx8Ex2I5DaK3WmOg/uS0h1nT0ROckfcSWskT24I4ztHa+RLcGkYI+URjgj7PZweOSNa5Eufgs4wyHjZb2iJU46I2vlFlWTpfI9ljY/VocfTIqdhOND2UtMa2GtYZGsB36aP3wdrOzlr5R2vkxf3MdtkiPT0e7Y6fwRNOuyNP7i4oyOogifaIn40f8gS/2R3hsjjGxVeUfoj7cnB/DI0/hiSw86Z7pkvSCfOAwqOPsKkrRBa3lGrWNn3irXBArdcnF45Fq3WmM38Ck+GLTYp5pospmGtClaFShbqzno6OUU9McMuh6P7jGQ7cbR3oU0rPBMuU72jtZ2LlfJOlpn3Jjqprk6weGRp4HiTiRrbWByp6Ib6awNb1Im9mYaYMU+TFntCcXzkpOdOilWuSYp5HbGmK7YO2sHvKwLk7Rn2hOb2tCu1nYs/kbhaFUtXOSIxhlBx08MhljkhlgvYvX2JPOVga6poa3sayxphnYn+w1KGB5cMw/gI+AdU8tD8NC4YlRUoSlxhBMPaEyWdoSXKd7Qm18nJfIqxgX2MmK1yKqeWGdTR0zp6wZp6M9PSP0Jm9mbWiYv7kxbe0Vnkw+mUq1ydPB2xyahlYesD/KM5yftGXOzNrJuBvbow+ZyY9Mx2OtaZWWDtjJwwM09YLftHeztZ8Oudn/AKMOUL7GY9M/BnWnsnTOn8F0uD9o/aMuVngy5Ts7WTv7mMGPTMets6eHhnWjsdcYM1wZ64XlO0Tv7mKExfI69M/XJPOCfhpnWjrjB1tYM+/DN7O1nZv8jF/dFKYw8mMYZjGBLTxpjaU8McccYKTWh1n8FvOUb74Ld7OyHts4etmLQlHpkR6ZELg9kQoOD2LR/BE0/g4Yej8hL7CN7Ev9kQsoShzlbK1hkR6ZT09lDWmNVojQ/gSaZJWyb2hJubHd7QmztXyOU5WCYtYeRKHWGRHp7I08C4eyNP4IqWrIT9knHKGp9o4e0drOyNrIuYlbIghLGyNLIpWuSIp4ZomWplq+x95YI+SLQ1lEX+Z0+RVynInkr5FDFpih6ZJLpnB7wLRlqZqph6FLdnZYtt7FtPwLixQua3InKdCVboUKmnsxammYaI4P4LU2PXZe1rI5cJodx9yG3+hxNJ6JCIc84FXzsVVyYfJ7LSnT5NcuRqVGGQ8NDUpPge2OAkvghHK04MuBSR5kUpt6Yq+TEp32bJ/cwpehKtTRppLaHa6aMw+CZh8D0hdudiWWZyKU+gknO9iRURIssJ2Kjh8iSI2WUYHKG1ocl6GpvjQl9NCaCWspEhzpj+SZl7wRabI0/jwiUFfoWmkckQX3CTcNYQlMPjRwzcxPRsEoc8lnvYqbXIq7PZCtYeia5EpqMMmlGh2l+h3f2Dt8EPK04HmdFJHmROGzfKexQpQt/Ya7EVoTXQcNJcDtJ8aJm+BuWPTRNzzspOcyJw+mTJzciquRbwnYsNCVQZUEwgePRMJ40O/SoJwhtMeZ0yfaTLORZbOvsIZ/sJjCqgyvWS88HfGUO7HEznoeZIhzyY+dmG0db5IysPk1y5NQarRlLrRlStGeiG8MfOiYfMkw50T+TFCqV9jUt0aE1A3KjY7jrRmyfwPTNzzUmHJLn2bT9yHSRyMJ2MhpfcxD4DKjg1WjN8aIvodi5nJFzpn3SKn7Eo7EtHQlKgioRlRsiV6MpdaInojD40Q6ZuTDlkXe9iy72KqfwxbRlNY7Ha0YrahrIswWiy9IXf4Flpoyn8DW8yRHRkSYlD97EnJfkUQ1yJSmFiDUESvRlLcaI3wNbWtEWnybgqIhp5nYlD9ig7FCvyJaFkhUFSWIISdrRZetDonxo+TojAytJFzp+Cr5F+YnE7cimOXInUCy5Isq0RaXReNQWhz8CxFGpFHL3wK39iWWyCn8MyqSloUkLpLjI5rODkEVDRw/uN3+Rjo9jcOsYMOHh4FlpuFwcnwJVfwWjXB9gYT6DVLbGt72NpQa2g4Og1D6ZCToRDaeBZh0ngW8FpC2mZURgWOWjK5aMpNDN7P/AGRhoi5XyxKAXAopjTwJp40hNfYWE9YIq8rBZdkSsBpUEiHF7E0EiE+WJdKOSjqk8lH0x0+Bsngc38ArTTWMGVeTK5g1WGiKlCISatvJGX3FUP7iyvuFVMMVN8CpxpjXGFwNlP4FEQ9EtGtrBMoakTS5G9rOx5SfJKyvkf4G4fTKmhhtPAnd0ngTyn9hPT+xMr0LHMEyuhO9oneyfuyPMp1sfK+WTDn5E6U5Uxp4Fx9hME06fwTV6x4WQmug2Hsemvkcq18+Jh1jZKnomG+GLMOkS7TGmU9YE59xQnKE12tE1OzCTWWcOfZOCblfJMOsMbusDz0biaejNM6ZlGV2dh4XI9NW9k3AlZXyTxgmPTJh06JzONCtDpPAnmTg/gmia5gmV2N0mTvY3jkXlDcf2yb6N9iBucMdyG2Dc+DKvWD9mh+WPkvKOGvk3+zdY2L8GG+OBK4eBbTLJpr0hKuxKV6ElHaP3o12d72cRnLOGvkxGls30JJONMWY0J5WmBd/BNOfsTKvOkO1m0OxyWdnNZ5OS+TV6eSj6ZYn+wdPpkZEsr8C2hLK2K85RE+9DNrJxtnDXyzhhSh/cj4WzDEKY1wUp4Ykv9IStp/AqQ/gwdS1gUHZdToKaxZo0Of3HdfcVTscOwUIaYsppEW2ElawJTleiMt5WEcjs12NylAmk9jeGr2a6bKtRS2KPYQONMVo0QSn8C1dcCpf2FS9YJNZsup2cl8jwaGlNP2Omt8jaZcMdONDKR9wnLf5C0y+Rf8AoSlTMPkypVRsioUy/wDUa/6EOHKg6jvQ17Tow4eDD24KUZl/uJW4YYrlTa2Q+kbNTs7xRpYNaIhaERAiL1oZRpiUPZMg5C9gn2bMDa2JMqb5E+I2Z9oSbWkDxDPA6UByvbRS1vQ3/sYcaY0N8hqHGR22DduA7rfJn/Zm1QV8R/8Akx/Qxa3kLXD0UyqmYrQWDWLMZJP7Cc1lilX5E5+NllKqDCFHw9Df/QmIfImI3OiCfM6MobyTe3AnFZbNm+4rnhhiuptYZPpGx07HIn0a0N0HoTF86NHJlwZMcuCb2Jzw2ThtbFKVN8ic9FlVQTKnB/0CSUCl86HDG9FnsUHGmUYVPYmX+xaVwKVCZ/2WvDQvSTj8D/wJi1vROO8omS7HTjTMUzcZLT+Rntma42Z+NkypVRk1Cht/6Df/AEJiH+CnzolJ8zoo7OGRPWy0s/kTypxsmam+SZ6jZhXhO8RobixvDJi9MmSWmQ2wxrROUMvIk/sK6E5qb5M9E/g1JNCdr7GLMY2Jx8icemTDjkVVk/4YtOBX/sUs1OIE54GpG4Uk0kMLgzHzomSROskwJ19jhvkTmVtbJhHBbcdkypxA6aMb+zR6HQ0Q+dFHJSOxwnGZ0NQ4bGn2OVxs/wCSRM6Mr0ZXo1CoNCYtbMXzotfOjEfgYfYVOGJQ4C2s9iN1xsSZ5RkQJneGiynBh4DjD50U9tFY3JRysq4yZRk4cbIlHAahnBhOIMqVlFxOGUQ1Awu2h186JlGmTDjJJBbLF/3ClK2tiiyKMxGxM7xBjP4F9o546IKHzod55G5i9jjD+Dp/DOnnTNk6axBE9NCc9NGcZRnGdnaewnXbKMOFp6MdpkR2w9OcDquTNhp4ddjUwsNYHL1aIbmMrBGSpoty/kdNZRwnyR8BLYShdhKKyjg94ZSnk0POhLUWWvkX2Yrwr4M2tC55yhV0Ji+dD5yiY9MaKeGNxbGjR9htPORpzTG8rCDf3WTYsrQ+Ur2ZtHa+fBV2Eo9sGK08MUYfwLh/AuHnkmadNYJnpl+mi2KZbGdnJfY586KOVjg7YZMdtycOSntgsLU6G5rZ+XRLfvRa9otg4NaPk5PsHLRh0ylO1olY5wydPeDg86J42J55OuS+FfBa0cvwU6FL/BLXaPwJ08Mp00zicHnJbNPRhA/JFsZWjks7Ramjkvk5aFHsKHpnDT2cDg/hk6edGROmsDvplvaJnFMmcfJO19jlzomHOUTHaZMdsNx84HCucHAl/sPTawO3ZJ7xgte0XEcPsLRZyRANDpmwlGn7MbZUdN2LjZN9k/clPGUS3a1klmL4J9kTtbME/YrDtMVU8aJ0/gnTzkmfejVj9rJM2srQntfJO+DtfJO1jYnCnRgT8iYcsMn/AEHB/DLVvk4CdYE3qH0WtaLWid/Ie33Hk+5XOBuK0N01pmiMoHyzo4bHah5M+1oz7WjOBco750KM6FV6MejHrRGJ+5uH9zp5LfTF+URL9Cu9oS39xLf3FssENq0xQ9C+zCKZwLVrOD89HDZ62h4ItF8YFvaGtreSNr5Gt62UU6Y1HYiutD5CP9GTFjrZP3J+6LdNFoa0Xp8nL5HPRW9CjnZX09laeGNp1h6PeVgzdQJ+4r0NCc2tWFw+UbF8iq9M/IYUO0zFaJSht4G9nHeh3T1kNJ08MDv2iZ9ohu1krD5Nmvk5LGyEpayyRGMsiwPDwJKNDFo3TwyiS9CtG9Clq0W9oS3hiNuYhikq+RCtfJRtonhM/cdLluB0o0yVHBjamX3PsMDTTp6LVsbn0Gs8Mby+43Nr7E5T7DNWsbHSrZj0xUoeRG2DHTkTbSwjZw2dC7yjL7Ry2hOaVGi0tVFsWy+StrZS9H3B2wyYp4I028DxZ/6Jlw8rIma+BZdrApvtEzaZwfJS1vJS18lJjDJiIyKVNMj0cntnZwfwZWvRb2tjl7RzmGTtgblNqiYtfIoNtHzSU9MpWmcNEMjXhgvU3ot7Lf2LuyctnJfY3T5RS1jZTeSnpiirtjgxzfDFNQzTYt7RZ9n5FnDKL3xbJ2vkraxspemP2MT9iUqeBwp7HyQWp/DG+cC3tF5e0SdpxyQw+Stq5yVwUmMMmI5ZRgTQhU8cjGo0yRQ/gm82T91scvaPsZNucFk4rkTjAnDbR+Qn7MmPQmsaIYZoskzTzpkrGyZjlEz7RTU77J390LJPsTFr5KRj0xOPTwUp4J03XQ3pksaYNGHyWra2W9ohlC9rWTifs5opaIpN6Y4Lplc2w0VWWh/BoeCfwM37HG8B5naHOVkeZVND2mdkRT5MOdPR6GO0YrTOmpk1DOvyThcbM+0J9zae/C37ITT7ChWt5FCiqYlHpiWnhihmxaP4Fo1g4b5OHBZ8NbHK4tFr2c0bNfKHDGHk4sERK09kQrwzg8D0ZDw/hmjD5ImE88jU+1RG9mb+50+UTUrBuUSknTKumUhTLEFTxoWpwZf2MvgaPjRw/iBy2k1ow5z0Tc6Y0NvKZknDF7E8Mwowa/Y+AppLfI3KS4Zldh3ELGUZT+BJtDzOSL4MiU5nYmWZEolcihRRPPIqcxSUCko2i8VEaLR1oicKGjgRlmRU5WnwU1pkWc7Fb3Ukwa52J0+WxuvxY5cOxo1E0PuDS540SU1UDzf4GDzK2ZS7kUNymKpIy2yHD20zXLsiV2XH7Mr0ctLROH+Bttw1o5ZMp0KRvTJF7FCZw9kxXJt+R6BZRvRdJbRJx0NKa+w7zPwOVrBlOTLhssnIsmZFcs8ChWCcs/khGjLw2cJtDl8DljWi3RDR/wBDOeTOckbZTFduRQfvZRNT8lD5bMP2LKPsy6ibReOeCDc/gerVQOTlfY/1GUp5E4cvZDO5IZ7FCW2S9mGL5EWQm16yQa9GJrWjnxoc3PGjOc9Gc8imbzIo5clG5eSdSfcMYddjko2Oajgcl2HhGtDtM+0PZGU5JuVgUkzM7IWdyQkaCSwsciyg4LKJn40Nz8aLWTNjtOmUc5Ji5FZsTh/2TCh72YPlsToTNfYsoTtFvZMufwWpqoHJyZT+CXMrYnDl7E7bkgkTiU9kvseGKsvuYadllGIHBCowXKHP4HJrhocv0Dvw2ZT+SnyKHaZBTspKFT9iajZZRgbhA390Nze1lDXPGhuWG9FM23yY9MSXyFUqSIp7NQZUfkX4GEYNLrQ7vgzljQs9jaeULOyZSWZLPZSilnnAqp/cSTUEThGxKUlsiVxA1OMnPMDsGlIdp5KyUmdnF/BJKPsYw1HZxV2XURBKh/E2caLFw0P0BL4DTKIj5I9p2YlZMShY/Bmo2TXBldk/gjn5E4MbY25lVyTDWkzlpifw0LLnDwZP4Bbb4TMpp50hU7WDKaGVIcwmrHiGsnCY2xu5WNjwjLJh8LRjOQk03ONITSekJadiUpp6GNOcrAmawFTFiqRh8ZZFprGxRzrZEOVgw34GLOFwbc4eBPXwROU/gmadtFlGmB07WxypbGOSztjwvuZq17MbtccjQ0/kJfTI9GwjJp/AtGqYllvgSyrPRntip2RQems7Dwmvlk5L7k7wUa0mTDnTFZy40E7c4wLGsNCeU/sTKabvSFBG1gsmtCZVMNolXBgk+R4NY2zPrky7DhwWikzlgpn7C0+CFsuDBqcCZpp4YJbXIw7JrseD+7G1NY2zKdMo6wUf6HI4XBN3h4Fq/hGyedCpK2YxtEyumy3JjlTPJMRttjYa9ijQcWntkm+ifRPQoOH8CeV8BZN8Ca8oLrlwKaGJllW9h4tfLNWvuTzpjg1pMq+uDJ3bBk5w8Fr+A3T+xam70iyjawOSfAdJTDIlZMKP2PBPkbz0O35DToEezQ3/AOhMp7FdNmETaEzT50TK7JrFomp3yS8/djwa+TLp5Jh9FGMrpcE3eBaP4OH2FSMsw7JUdomuyZVZ5JpP8je1jZMNcFGuNk30T6J6E4cYPAmsP4Fkn8G6dwX7cF+TWCy7Hx1sdZ+7HNJr5Zrxsd0xXK5R9MhOaYviOD+BUa0wJoh20KS6FFYDry0N1KzswR8sbwmNk7WRvodPp6NxyLMPBGn8C2miCNZaM0yd7R6+R6j5NJ4Wx5TWNip8IVPsUbnDwilOhtM3T+DdPOhJV29CtVlCxVk1WSnDXydquWNWnoavoaJ4hGXTwiEw/scGjv8ABg/sLJ7aLrtD32Ok8ZY5w18jxf3LU9EPZkcX0xqm0PsFLfCJWvgSiNoymMrtGqtjmOWx6a+WP5TobhqN6JuHhipzxoXsWhXW0JzKeFsbB6wxOd2tk1o9EI05JdKTQbi1sNpRw9DcOFsmWyOspkXaTp6Fba42Q0jemSLFrYk3sipEqEUIhJq50Yh6ejDXDuCIcZkw40bkblfBltfY/TZZPlDaJw0OnJDrp0aH2Hg/wN/PI3D6eh04NyWTRkaeM8MUpbKwRNcbIyxGxKU3iDCcdjpD7EOFg9jUJPl2Oo4eh01udEw7wzDlc4J7ODNbRMyuMDTM6wxSm7WyWdmOnJKIfJiHCGthwjvQ4QuS6Fpk6ymZWkyh6LyvyTZbWGJz8bF95ZSYaGFhwUrehxh60KtLT0TcZko40dhlGeBNttcYJ+wVnKJROGjCGrMA6Q+xSHzrw+w9DslyZUzsxDJt9jFKWuNinPWz4I2K58GEKKISjlsmEnyOEcPQ4RudFXD2UcrnB7hai9cC3a2X3jY53tYHUTiBiHC1vRDHehC2YDA2mMpjduG5MZ0KTj8ma2sMyu+SfuSgmpwTWnRMJNXOhwjh6KNccG+ZKOCbhk3+Am3K+zM/AnPtEuJxBNQyia05G9r7E7/BMdliunom4yTdMipxkn/RilLaFPeNmzEbFA3how0fJNQ+w6adEonQ4Xp6JlPOj8GUrJlGijsTrgU85Wxc2BO/gtwaMZwYClreid/dGIvOjD6dk65MOHckW07Z1+TIlPwR9myJTfBrSDUjWGvsRGNmI70RHp6IhpaZFhZtgXD+5an6kefjYyT1seVmGhbCazjoVEyYhxRx2THp6E4fM+Gf0Zvbs4b5LTytiZp9YLS+MGE/cdJ/A69DhenocbW9D6UyrjMnDQ7h6/ksrytkWjKwW+B06DVTgaoOqb0Rv7oaiOyWuSYuWNMnVOCXhu9MbmnnkzKmmCZrCEzjKJm0rWUS8PsTtXyTCnRO9sktR9g4WcPDFyOn8C5fB0/Q60EpeOQSnGRLa+RKLXyfY2JbWBU7ZEvYY9GIqng7fBn8BZwUHJxtHQOfZZHKlNaHKnyiHKtoe2iilCfsyYzjRSjlg6fwQ7Tzo7BSXZEoxRJalT2jCVlZGtpe0R6NGYvWxoHQdVlM940NvHwHw3ehuaeSZlBuVCwJnGS2FayiWJ2vkop0TF6eSWuw2lnD2TFvgnnOx/oE6fofgLapkmVWUTtfJhK+TksbMGmCa5bJMd6lO9CfsydiZt8FnLAtWxJ4EnjKyTNMrJM0+SCpjZy0UsTHsTHp4JSjlg4P4JWnnRIJyuxM0KkLUqeyalfJy+SPgcitrBy8Zw9C540cX8HBu9DnWy0oX6QvjJfGdnAzkvkqp0RtpkHa0z7DwxvhjfPwJvDOn6Ev4Ey8WiZxlCfHydoTWVjZO1g11smP0Jj0T+SdjNP4JmnkmfayS37JnGVkTm97Rm18lL1smPRMemTHpkxnBKULbBNwx5J50YQ6ZZbkUnGhalkwlZ4Oa+Uf7ByWD8dlP7Ex7FF0ykJlLT0zhstTyS300W9i2WiZtZJ2vlE71smLVp+GPRjswxV7YZOyzhkaeSHh4EfZoyxE4yJT/ZW/kiNr5Ry1sUPkp6ZoeHgawvsRp5Lw8hXTwwcAnxgWwcGRbL5ILyti3CWnoUPYUM40WWcm8E6edHW0TOoGcUh6zsjJfJFSvkcLXyR1WyI9FPRweNDSk/gpT+GcGPTehj9of3jy60OWB7r5Q988jhawxw9DTXpjUZw8Dvp6ZMxfsTPoPkd72dK6O18CYliYc64J+Qx2JXwS8eiCefhnTt6ZM08MCv0N8PYlvQSlyvk5YSjHyLhh5Egl94kojYrLAuH9zUP4Y3UPOhubDbd7G/kPRkf2iHG8NopacraP/A/LE6eNHs6+B08rDMuHlbIly8rBHwhEuVlZOazsheD2csNlcY4OQpn0HSNiIUZQ1tjQ1remO/awOH6YGHzh7J2vlD5T9CYEw51tIp2mfkSsaJ1hon/RnTzpkzTysGY4YPsZ3oTLn7lJbWUx8nrDyTEyJ1kzoSsPBOmV/RjdRvRmxM+ydk6U9yTtZ2UtYeTFrD0T/wBCt2xOngnTJ18DrJYZMuHrDM28rBItaysm5TvZMcOUTsO8CdsTHbk1GxhFwTtjR1vTJmLtYLdJgYWvezkvlHL4CYmPsSlf3RB2mNV6LOtGJhqCeSNP4G5rawf+Gfhne0Zco7Y9fJ6w8mPQuMsdaOng6Z19mavKwd7Lfs7O18k7XyTFrGzF2XB/wj3kdPGhcMnT+DrJYZMuHrZnOVg/LRa1nZNyneyGfkjl8idr5J/2Jj/UmF0TpuSVh/BPOhNXnTJn3yW60Jx9w3N7Oa+Udr5RO/uiWsZZF9h+R08CXONC4f3Imn8ETC2R90KXYhuWqZH/AGRv5Ipa+RRx8kV7Efh8C1dtsuoeNQTdMtT0W9rBE/2MqcIZtU9k7Vck7XyhOMfAgmAoBc8tCjWUzg8ci0eNClCm9Cluz/0LBObWROfgXPyFGV8iqYwY9MhfBGngjT+Dg9YLK1emW98jl1oPDnbJPY9l9h8flGxY2husBg/mHswYw0PV/DHOn8MffBmKhrRlprVGWmtZRvk0TcmG+Rh87kVT3sVW3hiGoUzNbREqWeBWkllaIcI1oVp40ZdMaIv9BLenkSy0JNglGcciWtMZFicC/wCwURozXJDku1obmORJHO0Gl9B2eRyPZS8pjsm08sp87J1+SaafwyfThnY1BHyWjMcrQlMdaIlzxo5JT0LbnJXlOylqymdlE5w9mDb7mH7DpGBJUbR6EHpa0WcrWR25V8oeZycjHsY7RMT3sxbeGSJrTsnW0ZX6GUktFvGVoz2WiZdMGX+hudM5aJZ2PbrkW1lPYtpuJwa/YXwZlciZXaDuORmP0O3PGh/IwFV5QlT0exP7ti4n5FhsaGbfY1H4Ha74GxpozD40VLa1ofKvo/Y+SROLWxUvLFSfD2RUvua/Y1aCZUYaHLS00TMVa0S25Wsky5WsobuFkJn8EE3yH7jZcktU38l4bNQTNYgyv0MqFrQ3+NGYfGh5lLGjLCzOtkRei0+iOfuL79i4xOCK/Y+xka2a7WuTMcocPfA1LlDe3J+wqcq0FZ7W2KvnYuOdiVNOjSRqQ8QZ98DeNQZh8aJttfKO19ifu0YvMktWticL2Jx6ezUfZmv2NfsNyuQ5LR8Dc+1ocuo0Zh8aG/bom5Jh7IJw+iY+dicU97FUrkgpwk+wSlQ6MrkjRcEbSwWtfJoEbzORJZViheuRQnciun7iio52LPDhirGDGHQ5qBz1gcrSxoaP00YMhWGCbnkmOnImFD52KE8MoljsUIYJVBosMRk6jQpw+NC3X2LZYLZGXw3kTtw9icf7FShvOxWNR9mZrZntwNT7Whqeo0OTT4E3E9EbHB8GU/2OOvkfPeyskFwkp5DlaiRRGByXopaUcjtpMbY1ajHJhrhmHVDDfDwLaa6IXGDML+EK1D9BYu9BS4NVIo6Ty2Rhr5NBkk9mRx7EQ6dPAl6J4EobWFqRNUnAlE/YjImrWEfc9GaCdFLWxt01nY5Yd7ZBDXyWKMB2qhY+CBw8sE21rQv+qOnq0TKaeSZUaaMwGVzsZUr5OE+Tg+SLr7kE5VLbIU9PBSyotvD0ZU1HRi0/gljcUhyhJkSCSqVkiT3sXD+4lprG2LailyQTrDMOg6bqng5n0R1gLDn4RmnmKJrkZg8BiZSY4a+R8j0Y2N3XyMOnWisqTwcrWpE9U4Jz9gsRFrCNts6DPbk4aztmbXyOoa+Taa+S5qhvpmHeQsta0Jr7SNO4wah5RqMpotqNjtcpk1KyaJ8juE+WTdfLHVqltkw+ngx0EiZw9GTn4EsydbSpFuAylwJlYDtJrOxvDXyPTWNjiVpciE+mObod3wS3KeNIXAWLRmnk13oVwdoZQ1Kycfk4Y1cr2Y+hF5rTIXRG4+wlp/BzPwLER6RFcsiQiVWeSHTXyZ/tmIa+SLlY2RdUIvow7wyLa0avihaPWDUPKNNZa0ZVDK5TI8Sh6T5OD5Y6dfLHVqk8sbU9Mw7wKm5wxbTrhHMk6y4pFtRNCZ5DgyN1Wdk42dr5JwybUVsS05G2Ju6WhZafwJ3GDwLEfBCuUFgK16IlKMrIsSrZGGr5NH92UtY5Ij0ZBK3wxcq6Mia9C1dsVcSzh8EY8scqZHXkMDRBaXsdk1jYyWmIG+R1oxneCcz9idZaGprehSQUuyE/Zl1KGjT9mjytiwHC5FR+QknoUXwmZU64MifwLVicsnnQnKgTK5aJrs1Ksaw18j0/ubpQts3iiLYau6UlJTNk94MYfwjFrY/vHNeiRV7D+TY91fLGqRZEOsZIhLoRD7CUoyuTNPBlKehL0ElXk7ZWCJlhoioYZI0zsiIERDWyIa0hKHCwxRf7FJ2Mn+QkttgSmn8Co7iMGVdMS3LDQ37ENulGKGt5HC+coZStjQ/ZBU0ylZQxZtcCczP3JbT12Nypw0TKnDNaPgUJQzwcP8HHYk1HD0RFa2JXsslsGTQSTcP4Epp12WT68GstoT0YlQF3gXDyJDrGQ0k+UWdtkdDk5TwZcP4ItJlOdGu1gzLDRqGVkfDI6jlkbiOx00YcLDIiGjDjJsK22Fw9YFyeDPTRMpvaNTwehahr5MXzlEKUYfT0NSjKOsoifQzKf3LTOtmVxGx2uINTs1o+DChkdXyadmMYZhxtkw9kJWFl6Ch0/gWmINusCUo1PA/gy4DxIypnyGRtPQ5mBKHDdHKgXH2Ikic6NesGVJFSskaZMRyyYvkdNEQ40yjjREOCL4cizD0JTTI+wSn4My2iKngh4Iaahoi0+coo12Q/kUrRwycODMrjAkzNRsyn+zKMqdmtHwRoOofOjQxjD0NaWNm9kyLY50Jlw36E8DK9GfjJqdo1oa0aHifwPn8DsnyZdPI3D6NxoUzwOU8CuUK5TFTtCtS8oTldBYnEiwkNHzkpf4IiOyIhLDKONCsEElfkkkUlxApKdrgspw0XU7MZQ43+Bws/IJEJ2hLh4EhtZQ9p/c5XGzM/sz7RMqcDdCdT94JK9sxMo55ErLsUHGhWjRbwLYmfZrMB62Skq9FlM4MJWBNTzlErP4MReSYeKZvoi40RojK1yRNfktKedESvWDCXlDUqeCiR4IQ3+BKtDUZudkRC0RtUksP4ImnhhiSo8CJUrC+7AknjKybfiJafIlltkhzMVsXycS1tgiK0yIhti0fwJPDysH7QrxlE6YHDWUN6fI2laxtGEpWxxvQ4emUqaehwlaHCnvBOU3ehtWZbgmCZdh/cZtYUTtfKNfmJhpORc6ZKG0xV60UhaYkWWRLb2hbM6I1tYIn0InFMjaysjWg+V8ifAfOhpWymKl6ZCloToTGn/QfDVMMqmg7wrGfZnssnPHR0+TgwYc634zFbYJitB1bZ19i8N2h/kLhkm0YGcZR2vkxa+UalYJi9GPYVVplKU8GKZFw0vQ+HbRnghl2j8jNrAzaztGv0JhomYU6ZEOUx16eOTFNUyl0ZH+hG2dEa2sGfQz7R3lszT5JSp8kH7CInQ4+ht/DGrSeDtUl4ImnnRmtoy8Wj8jOMrPguHyJZa2bnWyPuP2wRrTP2IePsQ8PKwR90JTjJ0wInGURtfJG1jg1KVdn6HCOGKDjT0REp4I0ZRZ6GtO30Z4NGX2jPszayjN72jX6GFoiN6ZERtDr1rkxWmYDW3wRp50RPtGXGhnFM7y2PlE7XyOrG6lbJjoQ/RnTwzth4OBOx0xlG0fgM2srRbiBcoZSnsVWvkVKdMS+xJZwxcfYUTB2+5GmIn2hKRaYV7MiU2vkS2vkhKyN6NjDhnHA+CFo/JgXbQk0/g7ZHfwZvaJyWhba+Sdr5KXomLE49PQnGcMpT2LVv0LV5FrvQpU8OCT2vAkwbV8o5r5KqeRfaJtehaPDE9sPBOGJ0zp5HftGX2iNrPA1LpWRtfJFyvkai0NEp0xw5hjhTw8EIROaawyNs8lnwyJtKGi+0rKFsvsQla3oShuFW0QlatPQoQIfDI2UzsX2MGh/DIq8rYks/AXwQtLwL/wBCYlhwLOhuMfYbS7TPuQ6XgdIY7Q/hjpGWmcHb0yZ62Ez/AGJm5jgTNxayjs9obin2JlC08neU9FJXbaHxgKqyi1P4ZyawxOfRnZdC3QVy4hozazs7WdoeJXykdq+UOrynk+9jtbHNg+xpnDfI7zT0xw85Q76Y7tU1kaXsso6fYdXtkxPHA4Vq09GID/DNS3s64On8MfeUVnemJ8IaFcvGx+S0T8GScp9jGDvTP0xd4Kw9m5fc6+DFxl6ZnLhNmf7Gb+wp3F8HfyQ6tfKMOVhqxqLyhws2w1rDRhQ7RmnjTOnrDI59GZmVawZYzcWO8U9ndOUNVK+xCyc8oadk8nBYvmUdMpf2HxwZd/DKftGfepM2skJ9to7X2MWtin44MXlPQlgfpnTVPYlr7Eafwx95WxcjPTQrl4ZHy4MT8gpyvsY/shROmR9uBKrRCy/B0/hkaf3I07emZ6Qy++TN4a0U7i1lHa+UOrXyYcrEWiPlMaS9tDU1lGFGiJr7M6esMa5zpnxejL4HeGh8/c7Xyh8r7Ha+THaeR/djXR01KOnfB08cmf0ZGDcNbFfTRWdouU1TM3tZRy1vJ6+UJxatCr5KPlHa0QefuNaTxpiylphilsV/oK32jN4YrtZWRcr5XgoV6Ncp6MdoXuUdPDH3cYOGOyDp50xJ7H5lu0lrXycvuj1jg6D9MxWWMZtHCdonT+CZpjtnQrd6ZL5PucCxc2tCza+UbF8ogw6IbVzkVOhGHaEuGLV40xSonB09MUqxAn9yZaapne1lGm18jjP3RhTlEJY2NR2h8rWiE6eNDVw/hjVw/ga+yL+9DZhrRbscH2OC+SjejF7JFk0xa4DHScMXPD5PvH2Mt7WiMuNETD40Zc/gbf8AYeYY2TFpzJOU0ZNp7KKHU7PgcjZ5Qhy4NDZpaMDcrvgbTvD0JInwJmmtG1KeRuHtOejFq52LbKZTRpmK09iptPDFvHgauhZRiMCUrhrCFccoK740K3B/An/ujcLTFXRky5T2SmYbhvksjxKlpjfouRv07LwO450HfvQ2Ya0WDug3lL5MN6HLJtw9nWE9mtJwyFvfJxsPHDI+S0cuNDuHxodv9Bt5HmGClafsw50bbTJSV0nsVdOS3GCPsaMpMM1vghNTNrQ6JHa0Zv8AA7e3JhwufwYtb2LZWmYfTMVp7Itp0hXOBNDKjEaGpXDWEZjngd3taMv9D7iU0LkhZXJLWOSYeZkw5YexIrKuSPRclP8AsRr7EY5REx+By2tDsdDpfJhyRHci/wDR1zsj0nDEvR8kYH4Le0RN8aMw+NDtz+DckXAiHK+RKHOiInsVKGoT2RkxyR6IzwgykEV2tFO5xoeD2tGb2tH3DztP4Ii1vYttPJhxpoxWnsi2nSFvDg1I1GOhqu1hDuOGh3e1odv9B/IdOFzkxTD8KXyYfbZELhoj4aIqOTPAd1wZUbRxytGYaytDt/ZAs/kbhZyVrk9pnAuX3FVP7lqe9i+HZhITmFiBN44FccoXO1omXJtZCdvRiqmGJxMY5FpzsVSnaeBd/AuQyrQah1BJ/Bq/sLXtaPuLQ4pSzOTDrD2bJ72YrXJGnU7NQ64NSodqMQTPxomYe1onayjKfwRkVjRkF5nJDi0xK7khcaZkT+BUlQp8BTp5WhTXaF960Wh8aLXPwJ/7CeyYvK2zs5nBjvsxX5IlR+RqeHY1UDUwsDT9QYmtE6+4d017DjRCsppkU+uAoMngUXLZDKZgfYKnARgWpk/LY8JPkeml7OA6h0Mm9FHeyYmcMnT+D/wTKaeRueTG21B8hE0r55G6lZWWNhr5gb2nWzafoTDb+wTvhMVNrB4MZ+D38Cw+RYCuCyZS5WRYT2K0y0LTRkmsbYqc6KdgnFjRpxo5T2aHnROm/RRGzA2OXZDfyGpNZQ2PuG2sbGusDWTQ6fWEGGT2YtsxK2wLafwjXBoihnkQ79Mjwk1kbdNfJx9w9MOn0S5vYqmcPAuH8C+3BlNWgXyZbUD+4Tacc8mk1lZZw18wN4adbNp6wYv7BfaRU2me94IzPwLHejUDUb2ZXaMo9jtJrQ8SNE09bLZHwGS5vIWbw8CWUKVPJGjUbOG0ZplGu5GqZaOH9x5TWNjp1gxLTMPpmGXOxU42wKpTNk/sLEbQlXZlVgf+ioTXycNfJERD2yIch56FWdiUTOGJc/AtzXAlKizRTDKgfDPJLTtDwmsrLHpr5HysbNp6MNvXBvhMUptP4F38EKb+BYjZofkfkaT3sdpNaHdjynrZsNwGHeZtzh4OUzDh/BGmzUb0jZbRld6MqsoeFGeRrDWsj/AenodOdGJaZgFCd1OBL/ocNkrTyWXZIuxWu0JypWROlfyJs6JtPQnD6MuhO4eGMpaeBZIaE0zKs8CcqMsTlcia7HLA3iPubFoZzOmZ9GU6ZRvjQ8ucHveCMp5FudYMpo1GzVZHqNZGw1XLG8PDY3aaxsm50Sk+hPuhQohzsjlM5fgo7JV+hSVMKqjOzcn7F8W2aPQoudFHM0KAJE7cTgQT1sTynnQsdkyux2u0O1WTBc7ZiMBcsq40yLJNlHQVmLSFYuMMSJYiTlCVOTU7Q1XIawmx00x062W0TbkmUZRMO1E5lRaReWZyaLt0OTOYaG7UvWChbcDhG20Nw1LOiWn7JhxoJxBjkTh8BZt8i40NZcCr9g/ATKnYmV0NLFmnITac8ioThxyJw0E4cZQnE6HscCkoY5ShzXDRTOGUcijRjYY8nJE1GxodPJKaDmRuHSibZzI2XGDbomS70ctobqdoeEHUJsw5gw1Gy2iZnkw45MPgR8BXK4FdnQtHoTlTwZlholtS1EDdLbgxH2DhznKJkuzDjkVQYJhsrcvkTmhqOBU+wTD0ZU7DdTwPHMlQELlbGyNvC2RDgUJxlMW9CMC1MzXBlXlGpwx45Dwth1DMXyUajZh1g4GHEGwlISw4wxKHoVtysC22ang0eE3ow0/wYiNkNozJlHIlfAjOgsv9hXLC5a2TKvRMyw0S3cYG8bcDqNuB5SPOiZe8mHGmTD4GGFtT8iupoTsuBVv0ML0TKnaJrkh45mI5DbV8jodOtjpxyYfDk21o/BgWhmiZV00akyg9GVouFsY7Mbi0s6Jhp6DppcmH2ybKieBsn9xXK4wUejKnaE5U4gTE4lPRMWUh85FFrsUGlyWRIrdhWenJpFr3kUldCqW8YgupmGjGdmC+4cbVjhfI0PNMZpxI3gPLUYp/2M1wYPUGVPB3wOc/gmpKXyNRDHTT5yYfTE4caMOBoCeUSKyROdCaJ4KU+D5C0KqlZDc2yl86FBrhii/ZbHJbYTk6RmT0LQkXotL2iykwkdXI3FjeHzkpm5HQmpTM9pwK0jJpr0y8p5WD7iwyJ6fJadNELOII0IimODHtob+Ybj20QU8YDhbHI3p/A/c0aG7WGOdbQ2ftYHLFMapo0cl9htWmxuFw4G4vKeh/LQNxC0MOWGYp/BuWVhoTt5NGZuEJ0wJ2vk6ZJrkE3HDYnS04FXp6FUcixLKexaZ4KQnnKFKU8o4PDBZ1lDXMZWxu+mMw0OrT5Q40wOHQQreGQenoeB2mODlZMOXwxtLT+GZlPKwfktmemtm2nySujWToWq42hVfOh/c0YzloaKeMDFrRhpP4O2dHbKwzMraPyRnFM7VQTtey6TGzAxD5PuTJiFpmHD2TFO+DLllYJltra2ZrD2E/gJ2s7J0+SKVrDSIDaODH2ojE4ZVMpkrGeC8O2Lh5KdPKwX7EtzGUK7w1k6aJ0+xMUwfgOr0zHyOoTwzcrk3L4ZctP4ZmU8oz6bM9NFy6JWcQLEDrjgX2PKPyaMemNxTwMWwzFvg7Z0dPKwyZraLftGTtVBO4wTiHsxTDJi9MfyTG4jhmH22dP4Hyzpky3k0Z3a2bconj5J0+Tub2TXAmFwY69MdRwzRO0xpjI+HnRM08nTtrA5fYzMZRm8Fu9Mo6fKPwMfsYvT0fgxyo5HF0xxl8HTLkRp55FHsjplbFthonT5J2vlCcKGNogtWmJxehfAdrY4ci3C0YpVN8il7M0ZQp2hTs4vlGOUFVOuCnpmHYcGk7nA2n8DenfA4bQ7fLQ7fawZxlHLjJlQ+SKlfKHVL5HCx9h1bxwf3odO8jh9jsJvDzydbWxXnJM+zIm0KSnWyiAoILfXAoeiajhmFPYt1mhlg0vPJP7R95CzYg/wC45r7FaY2UUreSUlOiYzhkdEjUQnb0zh8GfZyJP9jlBG1naI2vkibXyHUwKjrY2lWUx8SG9P7nB50zkzpjTDzyP7lgebBkc7w9jleGsoe1OUPZX0PbK2iflMmKyiUq0cH8M6fwzNPKwyVllbJ2p6YrdU0TNpQ9obnC9oVq+UTtfKCcetox22iYV4f4Gq7XIpw8BcP7i4dchOrzyTPQfCg5Ws7Q91naN0+xw/KH2lDaXof2MeuRw+DJLB0h50xv/sT8Jslt/kXkl5WeB8r5M2vkOrQ/WysZR+j3jTOnnTOm70zp5Wz9MHLsGbw9mbw9nfyRi1aD+62jHbGKmUKK4YnNP4Z03pkzTzpnta2ZzT5MvhoWZw9ja49oo6+UW18ob+1wWKSvDNQ8cnWtHT+5mn8Mpq88meg+qaM2s7PX2O19j18o/TIS9PwzWUdYaZ2+46hPOmfvk1+xbvezvjR2s8GLQrx8owFHtGM2j9HT+4uHnk6bvYrDzyT9zR4TJM3h7Jnp7O18oni1wTHa2j8omKyhP7Ezn7nTfpnTysMn5ck7U+WXPEEzaomcL2hNzX2JuV8omPW0flMmFeGJ1GVyXh/B0/uPh/DNKc8jchv4aG5tU9neXBm19hvj5R+U9EJemY9PBhdoWOtHu+GXh6yM1vk/awZE/DPXyLlHaOWvlC+62Ku9BPnAnGXKeBOK1yWqnDE9bWGWremJ/Ak92Sd74Nq+wtl9jmvk/F6KdrYk3aOZ1o5saZOvsx/ctjlW0N/DLdM5D5Ri19kTl2R6yIj14cp2h8a0x8P4ZmnlYZ+HyZfDQ38Mv/orDOztC4DQuuBOPTE4XaEReNC5XwxPh/DOG+RfehFJ0xbrOzgNiEuV8oVcyKPa0Lng7OU8H4clrfDI+S0NSqytGxZRCmfwRLnMmKXJC9GY9PJSPvY2kaeOSah7wN1b5G6D6kDam0NK7Qfoa0S0trRJ02O05nJRvJPJVvgmxL9HsxTrsnOCezWhMqHlYMxOdDLT3oO+yySqNaJlwtE6vOSYcLk5ZTyJRPD2Kqe6TO3wJ1Oma0E8bL8iuFtaFccrQnlhot/QzhfI4UuSjmfY0vpj+J7HCphPDHsE6b9DfoW4NEzW1obn2tD22iZc56MuVcmKXyYtYZMWt5KU8PY6TTtcmoeHg+DhlRBhpBmFtESu0Py4MvdrRl/kbhaZhtq1sVN8G3ey/RmKZzy2dYJmtrBmJytGY50Hd8Eqy1UGcB6r5MpWyWu0yI9PYnGd4Z0SNaHGxE9loylytHLaJCbh8mKXORVehNX0xOPnZinh4Z094On8EawZ4NGaiGtDv3wNTe0Zf6GXKuTHIiJa2YVYMLp7MU7T2Lh1IsMOxRA+A4W0RXa0T8lol8jWh2FzOZE4c5TFAm3ey6PDMU8ck/6E1oTKjZMwn6BuYe9BubWVknBnaJ2sE6XOSYc8nLTMensnndJ+HJs1oTMcB3W1omY5Whv5InIblwvkfykxeiVfTMXzsxnD2ah+guTOn8GEjNPQ7jrRn2tDh9jcrIsz9yd5FysCqeGLtnZMVp7Iipzs6YsSoz6WS3GnoTONaJdNa0ZJ7FbYl8zkKF5nLFD52KNCioe8GEvgsoxwRdbRotrQ5Yd6Dcw+NDcufuhuaHLK2OrWGTthn7GE1zsxU5PsM2Ohatod3taIm19j/wBGaE3w2YvK5MbpmPT2KqeHsXHOzlCtQ/gnTyi0crRP3Wiz5I27Nn3NmfEh9EOxa87MInItGxTUOi2WNE38aGphrREw1rI+GBpJprA3D7D5YZGj0TDaSZwidP4JqViaew7UabHJZtFda2UTxk3LH5Nuhsl7ED6GJ9ixzgWnDfomIPeBNw2vQ+AOA0abG5XBknD+47a1ZN8B01+AmJbEpWw9G2KpS08C5fB+WhXX3GVAV9lkV0zyK6aE5jAsk3DGxu01SG4c7EDl4Y5L3gb18ETEr4E5biiZX2C2o2httVaGUntDlw+MmYTWT7GxxM6HTERbDIjo9GG01KZ03nAtsFvYio0M9kO0v2anjI9NY3yPT0Rcr2MOvgSXYZXsh7foxKfwKlDt6MqBcRsn0CZXLY8JoaVoyWQwN2obudjd4Yv/AAVfoLl8Ea3oyo2ajZErsiV2RprJmMCybhSO1SHTnbBhzplJ3vAlr4CUSvgdvgVrkZUaENroRKPaMw+Msdw1rI9PRFysGH0yIthiUYVpCs01T0Lj7C2wW9uxKo0PuIdpfs1PGSdrBOHoqZXsTDlBt+jMrGKfwS1Ka9CdQ7ZM8iMqNkyoDdclknDRlrRkeZ0PM6G4c7YJU3h6MMVSvgLl8HWzKjfJTUDPYyu+R3TWWThrCybnC2N7wjDnTMOXhjp3vB18BKK+By3wZXLQrTQyo2ZVZRlVlZHpr5HcNY2NWmsDzwO9Cp3h4MO96Flp7wLaZpoUw1sV0yi2qyjKlZOI+Rtwn8jEDciWnITh3h4QrQ94GjIoSn8CgpZ0KS7RMI0JlRtZMK+SyTWsmj+439hzM6ZKTkOs4MZMZ+Bf9CMr7ETW0ZULK5HZlVlbHp8ZHp6GDX3EQIh9MVSnhiTTl8CWn8CWVkK1yNRs1WjKlZJ2vkmbWCcNYJp8CG8IhdvOCF39iGU9mhspaG42KS7LqtHXJrGdjwi+R1enkdexKUNGG0nYlzwJysrRbOeCw5ez5Q95WuBscjlEdrLIXP3GqSNjcQ08lG2YMmuhNST+BOZTE5TvGCds6Fs8olGjWzMGTjZjymvkdBimHkiHGjD4CV/gLaeC0yK/g6LWBWow8D7iNQycbbJw18mIunkbhpfImHCwx5iaROQ9hvM6wZmSZT5wHal4EmpDxLyNY2wNENbyXT0x10ZhwiLaQUp/kOeBpz9hXToifgbfyO1O1kuE9nR2PSZY6tfJhI2YcaeTbR7NtsaFmGLc6FafWDOc6NXkwnaGsA8WskqV8jyu8kQ6wyLKT4CVxoW0WmTM/g/AZXDwHttD+QjG2ziPkiN08jpxrZhxpm+kbEZQsWJSK0+UW1LyiW1Ox4nY9J9h1DW8jqOCITsw4/ZENgs/cNx9iwVqHREkv5HLltGj2Yox6TL+w3DT+5SSNmIaeTDbCbaaFlyLaeBWneMGVeTQbRPBmDJiNhvEfI3DUGHWGYcGGEra0J6eBplMz/Rh6wZXY1O0PHIeth6a+R1F0xoca2YccntSFti7TOZ+BKRWnyjMsNZMqfgTKnY8Jobw9seU1kc4bHmCbh0jfRFx+S4j7ClymSac/BnOUZU7RqRNSPT2Oya+TJRh5NrgwwsxsLMMS08EvH2GhehOVeUWXZNTsnDWSd85JiI3knHeSYfRN0Nxo2/yOnQlMpitdowfRldoaqdjpJrI6hoTEbyOhprkiIcaIuvyRfASmV9jlPQrVkQfRy2i2pWR4TG8PbHmVsmMbJhmcOkK0aFaBPj7Dd/A5pzo+6hTubRhO0QiUavZia3kdlL+BuK0MWtDcW3gnf4J2ytl5WmzJdoa4eSyOdquSiV8kCUQQ9MyNPQ0UcsIcHwY5u+DKXwO8r4ZNtrawaN7CfyJ0zyZoXhRinyTv8E0e2mcvgMQ1pmHLD0bnexfLydZaFftUTK4emKXjKM3hjNK5NR+UJ1ouDFrD0KwTGQw5Y0S8O+B3T0W5TzpksZaL9lszjK2ZUqnsvKrk6KhprpwRCmK4ItPT0NNVpkRbBES28Eb3OGRp5Wy3OjZtdjl9lkzarkeIbyTkh1GCZi9PRS9tEw40zKdybl8G5XGzbbOjhtbPy5K1nbGuA9FDbD5J3+DF6K9Bhw7TMU8HazrQV1loz7WzPvk/AZvDQ1NKNQ+Ua4bRi9PQrdPRitDDlg7fBE1tClynnTM1loX3IyqzyRUqmh3iMnRUQ10O9EJQ9MdUsMxTtGLfBtPfAltlbFLlbWGLLlFvssn2cjxJKsvsTEPCZi8pilGtBh8GZTczg3L4JuVxs22ysHDTZh2tkzjPJM0J9Do/ZO/wT8HplILVO0zDh4Nyck+zknWWhX7WyZ6emKXio2TN7Q7tUTUflE1w2jF6ehW6ExWsB5lgvBTp5LdPKwzNZZfsjOMoSlSqjJ2qjJqFEwpXycuTFjllPRitYIw5WmblrB+WhcPDZn2tnL+4mVKrkzR+ysFA1K2ctPRiHpmPT0YicsGLbO3wY5NGa0M1tGd2iZ9nt7JlQ1knaxtExaJi5sTGctCetPB2J2+51vTM2zyZ9oV7psW2GsmafI/+w6pjaHVrDMemPh7I1oauH8EbfBGs8ES4foyNbWyJ9rLIeGhS7+5FStGFK+S1fOUctHLKejHpkw4dpk3InlehNhhfchbb5FJSqgW6YlwoUSZWHNPRWOGU9PRJVJ2N/6M7L0xG65Em4FkhycrK0PJ/JD3+QebVrY9sjDzHW7D5XozQwbwsgfINzmtBuetiZtUM9sNCxXyhdfZCjKUraK1lo1Yjn5Hb0Zwn8M3pGBu8l7zpkz0NzMDOKexfF8E71snjDyjC54CpBYtSFlJ4CsP5C7zpmayOnT0P7bdj6fZD69jKf3IzeG0ctfJ3nchLGRFw75Ea1yRp/DIwvgz270xrmnpjU9CLnCDUuVng22ntEb+Q5atbRi8j9zV2L36M6fwxrWXgPeUfgTvAS7TvDRFKvsS19kdq1tH7aKixHPyOnjR0/hm7rhm7zoXdPTJkL3D2ZxTF93B390esPKIjoY9PRqxwnjTOn8MzE50xqayI+5E9bHr2QuvYWKzszeO0dr5RXvYhIb55HTxyVh/DOF8GbvOmNc0+T8Dc4QzimtHLT0P/SO1jaO88D9z38z36M6fwzhZaZ7ye6ej8CZtDKmj2LFfKF19kalKVtHe2jV2PfyHVfA6fwyb04Zu8mfemTPoenGx6pi/8Ha+UTtYeUY74GPXBq7G4eNM9/DMxPwx3WR+Ho/DPXsicxnYuvkX2bRy18olZyKXsY7H/g/K0z3jTImvgzNPPI8rSbM9D8DLr5R/6QusbR6tbMdjTm2PdrRFXjR7+GZp/DImn6MS59CJ1BGY+B6URlHMfKI3hsxjGzQx2x/4N9GK+DPfwfvkm++SX8CZtD/kHaro9L2jVKtjj2IqBqHjQ1FaI5+GNan0Rz6GXwI0sMkfD4F1naEllPZ2vlEcWio5REdh9jXWme/hj7+Ge6fJxUIfgfh8Ey6+Uf8AYLh8i4+xTsLlYXNzoLngWM/A19tDl7CIMaH2JXD5G+3scZczOWOLb0OPp7IHeVDimnh4HsROxy4rkb0x4MJhDl6aMjfBM9lTRMveDcN5MOFp5KtlPYyU/kJx+w4aeGK74IUTFSWsGa2hJQiYeNB+Q7vPJtPM2xQpatGLMLp5Yqp4eDFPDNSrsS2ozn0QryoeB9j0Mw/sHdBanyTgTyJcPljhWrW2JWjDIivuElbYeBzY0zGVGEOowWhaYGz9h5N6HBod0zsvAxeZyz8DHp7HTvLZiWpPDPybHzpclYdHD7Bufa0NzYaTO1oc3CxtMr5NyrWyErzIoU8cmPWwuNaZE2wd/gV09GaGm10ME9NHezsi01c5MWrQqlmF08spetG45O1cM7URNPWiJyoawRPvQiYYzTI7tfJNyr/QjTWzF5W2L7GKlH3C2nlshO1LTI2I1xgzWhb9BpW2huVDRmmS5gYvM5YqvR+D2Yb5bMJp4eD4J2d6XJ2MI+CHftaG5vfAszxo3sbh8mHKc8lWynkVeuTHtsxK1pmbYZqehWoesGa2hy1WGjR6aO5sb2cNYZiWqGLMens6eGdsM/8ADO1EadRhGc5WEO45WEO/6D5QfP3JuF89H/plK8rbMYyMVNPYuHjkxbGmdsPBlSMrofktGfY8ztaNybh8j01fLFVr2ZiXoxi09kRWuRQqwng1KuDKh6wJTWOiMONET7Wi17WiFnLWiLlfJGlkXOU8kR/ZC9WRD4ERXJyfAkrA9HTqMGY60ZXa0ene0ZMjtfI6vKPweT8HsiKmmfkwx8qNR8CJUPOjNPKH6pofS1ozatizD5Ii1sVOc8kJYw8kfApUUzCaeORrbHI7Uj9DDtDn5Q8ztaN+DeGr5YqcrGxOL0yYxh7E4+di0eNHJ8Cmo4FKsdGrjRz0MD4yWysbFNyvZCE51ghbehxtscJT+B5J3+jFp/BJ3MwHyB0UZHePl7LSWh5SY2ZJodOdGOjFTl+hY52bJrOBUnsMICvkEqgaS2O0mtZHpr5GnMMDWHrZEPpnIEyupwKm5KJp7wJRTzoVoEpUBaBWlVoyvROHpDnDGxg8zsVL4ZEnNoUkc4ErJqeBav4Zg3yWURa2fcJRWR0Ti1keDWsjVyjKV0gaSHEzopWuSIlP4Iy1iUGn8GexEqNlR2OIXI3xXLJoa0NnAO3I1DnTN9hU72Kne8Cqn8GE0xcbFaaEVCGkt7HhNayPTXyRcMEb0RD60YdhldSKm0xKJT2Jc50RQQ4jZGGzKVWhqV6Hp6O1jZFzoi50yp9is5tCSfZiZWTh9jU8mVES1s/Ih4YGk0rWTh8ZNyvkduV0IUzoqT0KvbBESn8CqU1IptfY/MjBD8pNKMkTj5Ew+MjzAeU1Q6fAx0fArXsVo2wLaa9GE0xYjYrhsioQeFyO0o1keEzcMbHzrZh9aMOwyveDDaf3FSc7I5zo1yIqPAysWsjouh6eEPhgcZDqWip9mV4YlL2YmTqPRrkZUbMrsd+x2qyrZGI9sf8A6OKehrL5IiHymbwMfIlEz8C2nkWLXoidXoiVGyJRXKIlLnkwng4a+SLT0iL4Eb0Uc6Ykv9EQ2mLl8FE5MIETDaIlKMojeyN/cemsLJjobWj2YckfZmM7wKpkSiZFiGvRlNbNRtcmVWh2qzsapRrI9MaudDVwwOnMUR1TFa8PBESsyJc/AllMiU5Vmo2P8jtVnY0tfI+tD09bHmdjD6Zh9CcZ2KpTE4TTyJ13onnOjLLZMoptFl2ss5cDZIitEDrG2ROMp5HM1NDg2tOh/wBAtcsobKoeVoclM2tDZqVhoclwDcJJb2NxC5ZJWt5HKdYeWYa4MMthZawhcsFpToTmU6gtnWBUtWsCxPwMy0FjmdPkiSa3kp2mRD6aIhsEr0GZZVoS20ZtUYRJLuMFtXhhF2imjiFnCExT5HTTS9m6pPJimGUqwuyLaeNEW08aEplOhKU09CknysFlihZTtaGkcjBNXsOy+4SLXyUajDyJD6eTE6Mw2nh0Rh9i3YiVDfomU01gp3ONFNZWh0nQbRy2PSbGmrRh9PLIhqMESa0zcaPwFcp0K5TqMCvOsGcq9GpedIdqdBUuXI6p8kSTWHkdqtMiILDyRca5FxozLKtCWnoSm1JClJdxgt+mEal4aHhPaOHsxTeR01G8s30yI6spVrsi2njQlaPGhKU19hQ009aMp8rBlYoalZWkNVyIpPOw6aR5yUhPkw6xsdPpmHGmYbWmRlvgsESobwJwhrBlTN6DtTtaJqdDCSW9jppN5HKtbyQ06xtmH0zDLbki40KbbArlOhQ006jAu9YMq1ejUvOh7aGuRMUMk1jIfC0yIhpqyIr7hbWjMsq0Lh6MsnUYFS9YMrtYPsNGpix6QdQg8GvkefZa6Mx6NtPGi7WtCuVgzMmnysGuhEqdod5Wan5D4bMWt5HlNfc3WC26Ziprkw+H7M8BcY4FdZCtN8YMqXkZXLghwmsn/GyMJ8kWo3ngiHWxKHGuRKK22RcaI01XJwdIjK+BaZ0RN7IlckPEoj2MiLWzD9mHWHkiKVJiy1hcmTDp4FcrDRlOV6MrtGV2h2p2PCayJhrI6tfJw06dsdNRls2JQwlcaYllNehKZWOBWr0RKv4Q2a7WB2ux4mByRh9sjymvuPPTMPp7KUrT2TD4HtHAnKh0JzWQrl8YJlXkW1yJcSrZPHyyYhr5P//aAAgBAgMBPyHH8z/gX0P6sfy48rwvMEDQ/wCCZ+h+H/Fny/px/Jj6F9M+H9S+t/Rj/Ax4X8D848rwvpY/4V9eP58fUv8A8bj+BfwwR5j65J+rP+dn+TJn+XP+Lj/Gz9E/Tj6s/wA2fqf/AOKj/Fggggj6pJ8z/mv68/8A5WP/AI+f/pL+XHnH0wQQQR9c/wCQv5cCowY/kwY/gz9WP8zH82DH1ZM/Tgx/8N/y58P6sf8AxWP+LPh/VgRBBBH0z4kn+N/Uvrf0Y8L6c+H9WP4X/mMf1rzn/wCpH1xH/wANfW/G/oX8D84+lfUx/UhC+l+YI8rzPifE/Uhec/Q/qgX8D8Y/zMfQv51/hsf/AOzf1L+bJHiCPokmPEk+c/TP8GTP1Y+vP8OPpz/nZ/myZ/y8/wD7mCPrnxPn3/m+/wD+KY/+RP8AHn6oI+qSSfowY/8Ak4/hz9eDH+Hn/wCkv/hu/wCTP8K/hf0x9efqx/OvogfhkfUhMn6n/hqv51/i5/8AzSryvpf+JjwvGfEfVj+N/Uv8V/WiPGfokkkn/CX1v+FfzR4z/Kv8tf8A5XP/ANFj+mDP1Y84+iSfE+Y84/zcfVkz/JHjPiPE/wAGfGTP/wCSz/8AmJJJJJ8T/wDos/8A6rH8uP8AIkRImT/gY/gz/LP/AOeX8i+uB/y58Mf1L6X9OPoX1Z/hS+hjGP6V9WfD+tfW/OPMkk/Tn6l/C/8ACXhC+nPh/RgwY/w8+X/iL/Gf0L/Mx4X1sY/EfSv8N/ysY/qXjP1PzH+SySSf8hj+pCF/iv8AxF/hT/hP/Fz/AA4/w8i+pmP5H/Bn6p8Y+vP14+heFZn/AA3/ABz/ADZ+nH8OSfOP4M/z5/8AwmTJn+F/ze/8LP8Aj4+nJn/6Ekkkkk//AITP/wAzP1Y/yvXjHjH+JH82fqx9c/xR/hx/gyST4T/Pj/Fz/lv/AOXnw19OP5cGBfxLyhV/iuxr6cfWzPh+cGBfVkZn6VX8i+hfyY/wp8SSSZJ+nH1Z+vBj/wCDnw/L/wANf4C+h+PX1L6WvD+lL6Mk/S/oXhfUx+H9a/kX0vy/pR7/AIGP6V/JHhf/AAM/XJJIhP6mP6MGP/nL/KX+Bkz9D+peF9ePqRn6mOvpVi/hx9WfpYx/SvGfrx/KzH/ysfUheZJJJ/8Ays/42f5M+MmfHr6cf5vv6c//AF8/5UkkkmSfrx/+Kn+TP0evOPq9/wDwvXnBj/C9/wDxcf4ufrx/LPiSSSf/AMhj/LwY+t2P+Z39S+t2P6sfwZ+nH8Dv/Nf1YMfy4+qPGfrx9cySSST/APNXhfW/ox4X1v60Iz9L8P8Awl4X1v6l9b+leEIz9L8P/Mj6V9b/AIF9L/zEvD/xpJ8v/Bf/AMJfzZ/lX8L/AJGP+V/wZ/gYzHlCM/S/Dr68/wD08fwv+PP8EfyST/8Afz/8PH1Z/gx9ef4MfTkz9ePqz/jY/mx/kT/8ifE/VP8A9TH+Kyf8Z/8AwX/Pn/8APz/kx/NH15/+4vrz9eDH8Gf4I+p//CwY/hj6MGBfRnxn6seMEfy4+l/zvy//ALi8L6M+H5f0L62v8VeM/wAaEL62PzjwhfU/px/E/wCVjH9S+p/Tj6o8sf8AMx/zv6V9TMfzP6l/C/5X/ir+RC/jx56F/lrxkn6WR5gQv4X4x/8AAz5z5Y/OPqz5f8K+t+MGP/yb/wDwc+cGPoz/AD5M/wCbM/z5/wAzP8uf4Y/+dn/+WP8Axc//ADp/y8/4a/lX8b+jH15/mz9a/in6F/Ngx9U+M/4mP5cfXn68GPra+h+Y/wAzHlfW/pX05+hj/hz/AAY/mjxH86/gf8GTPl/Tgj63/Cv8N/y5+rH0L+aPof0P/Kj/ABs/wPxHheF9T/nfnH8TH4j/AAl9b/hX0tD8Y8oXjP0sZj6V4n639C/gf1r/ADF9T8R9SF/MvGf8B/8AxI/ix/Pj6V9b/wAZX/mZM/SzH+Ln/Hx9OTP82TP/AMjJn/78f5Mf/H9Hr63/AInr/wCX6/lj/wCK7/lj+NV/mz5fnP0Y/wDsLzH158wY84+rP04/gz/g5+nH82PryZ8x9GPrz/8AGj/Ij+dC+t/wx9L+tf5aF9OR+ceULzHljv6ceV/IqF/loX+Jn6sCF/Ov5F4X1x/DH+a/535f1x4j6X/jL+SP4H4x9K8R9LGN/Qvoz/kL+PH1x9WPoXhCM/S/ox/JH15M/XH8M/8Axc/4z+vMIGgf8UmmCc4+jH8C/wDgv68/Vjxj6X4n+XP+bnxn6Mfw5+nH8Gf5s/Vjxj+DP/3o8e/NfZ/g3UevpwjOUL/Gpn+af4I//FRP/wCgf+CkCgwv4U2rR/ePrx/I/Cr62Z8Z/jf14Mfy4MGPqf14/wAXP+Lj+DP1YMGPoyT9ePGP8R//ACnf1r68+FSCVPH8n9f/AK8v6F9Eec+H9GPqz/PkyP6MGBC/gY/OBeF9b+jH1u/qwY/gz4f1r6WMf0Y8R9L+rBgx9EeMmfD+jHhfTkd+H/hT/wDCePof89UsL+a6ZX0pec/zv+TP0sZgjxPleX9L/gz9T/wl5z5Yx+HX8r/jkfnH1r+VC+p/ysf8k+J+qf8AIf8ANhsv+dy0E5VfQvOTH04+nP8Ag5/iRn+DBgx9Gf4cfTnzP+Jj68/S68Y+lC+vBj6F/OvGTJP04/z5/kn/ABZ+un4/wK3j+KPqyZJ+nH+JP1z/AA5/lyZ+uP8A48cf/Fn/AD5+ifE/5D+uYf8AgWV1/K/8p/4T/wDoY+qDP8GP5cfTn/Ix/lz/AIj+vH15/R1HUdR1DZfwJmdR1HUK0n/w8f5b8L/Cf8Tr6n/Kx/UvpyMf048L+B/yv+Z/ySPw/wDI14Yx/wAc/XCdMRIsP6lv7D6l/g4/+a//AJK/mX0Py/rX+I/pQv4H/wDNx9GRGfpx5x5gVX1FJXH/AO0x/iLxn/Dx/wDOXYv58/wzb6OlHSjpR0oawkhjS/qcyFxo6UdKOlClD6s//r8//Sz/APNz/BHn8J/4P7X6+rP8r/gX/wBTH0L+B/8Awc/xR/8ABf1r/IX8eR/Vj6/xn/g/tfon6X9Wfrf87/lf1r/IwP8AyYj6n/Nkz9aMfTnw/wDEx9b/AJWMf1L+FfyyP6V9bGrlM6DoOo6DSfWxoQuI6jqOoWWx9OPqz/8AEx4bjzn/AAl9T+mZ/lf+Ax/yMY/qQvM/S/8ACn/Hf+Av5cfzY+lKaTf1I5D/AMZ/ySNv1QADs/QnmDBI/Iu/1kJZXJJuIMg/CcGKDtfsIJ+o9P8AIf8AJB/yQf8AJB/yQf8AJAuQTykZyhOf4ewYzwMgw3PjDNmSsy9P+GVsHyfo7P0dn6Oz9FJ/BbiznBvoGzL8Jlg3wnCibLyqZje4Oz9HZ+ju/R2fo7v0d36O79Hd+ju/R3fr6IC/zc//ABEL/PQpNfUhy5X8Xv8Amj+FuFJIn+FzITJv6aTLH8t/AxkKkQvM8+v4mYSVn6kksoFS/hbTD9DJqV9UuG5+ppU/RnxOA06/gayhUTxKq/kSV/8Apv8AwUL/AA21ZjbbKFP6HiDhncO8d47BlG/gSdjvHeO8KKb/AOR9DaSsV5ZgXf8AL6/h/wCI3/HBP6O8fobn+J8orXmCHP8AGyALQn0SoTp/x3z+Pqo2F+/rafV9OD038UYnnw0v/Ja/LBj/AC8fW/5mMY/8Rfwv6HQ8Lzlcrz+M/wDB/wCT19DoOF5Zflfy4+peKy5f0RfgEaGSx9Mg68exG5cv6MO8IjQfX9NRx5xPocQjsX/Pga+DBPpjbn5bjIzo19OZoWxnMHMfQZwl9Nn/AANP06rn6HNCOaeE7wHEIYctcvzKg7OxHYjsQ1D+jBh2I7EbDEJC8Kv/AKL/AMhfU/r/ADn5/o/vz+M/8HF/zX0flPz/AFf3/A/ox/DTX0TO+vMonx9Kfa8XuvolSwiSPKlbDmNr6Li8/G/RU3lNGekf0SDvzCo/P0MaEIs8/REGPog1BnrEksfTR6X0Srb+i4vpor6GS/ioRIvj6YhfxZ8Mfh/Uv51/8Rfxvy/pR+U/P9X9j8Ikh7Og6DoOgbxQ2B/U6zwLgOg6joIgX0fkPz/V/f8AAv4M/TOfRE778zf0JLgSEFVz9DVILga8syVH19H6/My+/ogPovePqbhSTP0IlP6X9cnv/oq9C19/RYX0/o+mCjm38UD/AERC7/gz9eP439SF/jsf+Av8T8p+f6v7H/BGOX1Qh/D+Q/P9X9+cfUvOfpwY8zD+j/mNmS0aCfWF9F9x4m6Polbh9WP19Cfj4m319Mav4AlL8fI/RHBLBfy+hX0Xe2JP0Wj6c6X1trJROv4KUvoknx/NgY//AJD/AJ1/jfkPz/V/flCSzu/Z3fs7v2d37E8WNkf1YzwLmO79nd+zu/Y8hO/o/Ifn+r+/8SVdfSkbfcbNvuNz9CUuEVO/Eu+/ohO/qm9V9GZ4kO/ogF39MEfoiHfi36CWXC/l96/ojV4SX+iD2fSpIY94f8HoRCSvqkhx9GZ/8t3/AID/AMt/Wv3vOXksuuv8Fa/Q0v784f4ZEceX/EmaEf8AAI8QO+vpSPR9Lok/ofM+KvoJp8fQyRPoTy48PP0V/T+Wz19HvXhZ9H0Jw5+pCQxqLcvrt+pIP6Ivr4Mfyx5X+Dn/AAGMY/5l/Gxj+pY8jYdeXZIL/AsPy3Fj8rf3/iW/wDMDI0Yrz+F9L/YXjHmg2/oapNiQo48S+q+jM+haS8Ew30W3P1RsP5KNZf0peztG/f0yK+vraWRjKO7X0tX6W4N/TEr6H4x/9F+H4f8AlP8AgyOvMK/ovOf8D5LzL/RAv8M/xznX0dnBkgSCMF9KSrr6azj6FrLH/QpX5zDv6Izvy3BK0fv6IsJRXhIb6PQfStkX0MvT+m3/AJJl/gfhTJrf0LK+V4if6IlfxZ/++vCF/hTrw+iL8vY/z0/0YPJKSIl/hLxNvv8AmxP/AEJkjeQR5N3Poc3jj6GxBES14mHx9KX4Atizol9OWy/Nq+lD0mDY1ZZgLGsvz6sTlT4qG/5Xx785w6BDGlCqZeW1ZmAx9GX6VBfRJ/gcfxz/AA5/+Ov8OSX0Zfoz44/myWfLJ3yi+v4V/HKPr6EpEhH8V38djQhHZ5nP5O/fRJLf8j4kRA3Fl79COTtR3o70d6GSPobK8XKGNL+jAM7huX0MaEVH0zR+jI//AJj/AIV/ir+OB+X9XznlsQRMvMCGMfr+Ttn0VDL/AF9HtX8SF/D8h9EK/jTEx8D/AIWkBF8v6IEX8TSEEXW/q/vv4vSiGF4gQ39EchIX8M34+KAc8P8AhY0IiS8/VM30Rf45f4ef8Jj/AMbX0Mf1+xX0TJYf0ISGOvj/AAveEItl9C5A2Z+YAJChfWv4n5bItfQ1Ofx/Iggc+X5Go+nGoeuoshPpfX1km8GqFrMWwn8CrVf4ME+rQlvb6Ff0H3Z+p1fQbPkkhmIsaj6UpMlRiPrY1Pyx4RBL+JfW/wD47GP/AAl/A/D+jH1elf0f130+2MJZkF9GJRzxLH0FJLGv19Fsy/4V/LJp9jpfYStPt/PjQ2ncxdpphCx9C85Oh9jofY6X2HwPsdL7EWn2FX0v62pNcPsOxiSY9fUjI632Oh9hYC/g6UdKOtfUnJDZo9p7RI0JcF/CjI6R0BGH/wAVfQ/8Z/yr/FTEx7w/o/3Jj6m/SOh9hKsfUpljX6+iRLwv/rT9L+pfwP8Ay8//AIx/4S/if8keVkaj6H0shDP8j3o5l/Q2IWkMfWv4df8A0Z//ACL/AIF9b8Z/lf8Agr+V/Q/r7x+xqPocyjimTfXg2MmDpfSxhC4H0Z+nAv8A6T/wX/8Am3/Gx39a/wAV/wAa7rI94f1YhiXAmH/KR8A2Z1/V6EQkL+RfVnyx/wDzp/hf+G/8Vf4r+lC/zV9bPX+Y/wCRDDLvK/nTNCNv2iUfwrwhfwPw/wD5TH/gv/4i/wAN/WkL/NX1v/4Wf4Gdezvf48ah7gKKfyLyvo7+jHhj/wA9/wD5zP0Y/wDv5/kzaH8ODTaF0/QTxm2dwIlj/CRj+DP/AMZ/xz/Pj/5ef/wKF/8ABwe/4kY/kX0v6MjH/wDSX8L/AP0TGMf/AMJfVn6sXv8AgS/if0oQv4GMf0L/AA1/iPw/pz/mr/5S/hnzBBBBHiCCP8BjH/lv/Cwfs+nH+EhC+pjoY/HXlf8AyMfy4+nP+evC/kX1P+Zv+CPEEeY/nY/GP/jLkY5ijs/R2fo7P0dn6O79Hd+hFDfR3fo7v0d36O79Hd+ju/R3/oZgp7/iXheEd/U/48f4U/yP/wCov5l/Ivoz4nw/5mOv8HH/AMeSV6/xJY8fzIX0t+H4f/x2P+d//gZJ/wDhP/5Nxz/iM9v8iF9L/wAeSf8A9HJP/wAZj/hj/MjXhJI3h2I7EdiOxHYjsR2I7EdiOxHYjsR2I7EdiO5HYhDTb/8Ahk//ACGMf+Yx/wCGvMfQx/4S+ifL+vH+cvrY/qX8D/ys/wAK/gf8c+Y+lf8Axn/kv/Cx/wDDz5f/AMRfwv8Ajf8ADH0vw/8A40k/wr/6mP8AKf8A8TP1Y/gz/jY/+FnxH0x4gfmP86Sf8qf/AKLH/nR4z/mQR59f/Jj639EEf/Kkkn/JkknxPmfonxn+V+X/AJT/AJY/k6+uCPEeIIII8QQR9EfwR4gz/BHiPEf48eYI+qP4YIM/XHiCCPoj/Dx9ck/y5/wJ8SSSSSSSSSSP+ZjGP6UL/EY/5WP619EeII+iCCPEEfRHlkER9EEeI8Mj6II8wR5giR/4cCI8R4z5gZBBAkR4SEjPjPh/RHhL6III8QMjw1/iyT5j+aP8OfEkkkkkmP5mP/KYzHi/4Hjw/D8Y+hfSiCPEeEheII+hHhrxBBBAhLxn6WNR9KEZM+H4aGR4ggjxBH1R9EeEL6F4f0x9CsyZ8PwxmPoQjJn+KCPEfU/4pJ/wo+pf40/zsf8A9fBj68+Ozv8Aiz9eCfpyZM/Vjxj6o/nz/GhWZ+rBj6cmTP14MeYIM/zT4z/Nn+SP/iP/AAF/nR9S8R4j/wCdH/xMGP58fwMgfh/XP8CF/gr/APE5/if8i8sf/wAh+c/wY+vP8mf4cGPqz9WPqz/HHiSTP+JEfw5+l+X/AIS/mY/DH9OP/lJQJCX0Py//AJuPGBfSzOPD+nH0R/Dgx/C/GPGPCF/Hggjwxv8AjXiPoz/iY+h/4SH/ACMfhj/yGPy/8JCQkL6n/mv+R/xv+JfwP68/wP6F/Cx/VJIyBrwyPrQv5V9S8v8Agf8A8B+H9Wf/AI8eEheZ/wDzGDH15+lmPpb8s/RH8Efwx9S/hx9T/wAVf5cfzv8Awo8JeF/+j9fwsW/EePX0NDX+d7/zEZ/lfh/VH8EfwL/HX/6SfGPqNj+tj6YGiCPEf5ef8pD/AJWPxA1/lP8Awl/I/wD8jkf8M+E/wr6UZIkjxH1IX+FH+FBH8S/lYxj8r/AX8keI/jS//UFmfEfTBH0IQjP0MZHiPrz9OPpX8GP4I8R9MDRBBBBBHiP8J+cf/Ix4S/8A0omZII8d+X/Dkjzgx4Y0R/Hj+fH1Z8Z+mCPMEEEEEEEEf4T/APhP+FL/APRk/wAD/if1JR9L/hx9UfRH+VHiCCCCCCDP/wDGJJJn6Y/gj+LBj6oMmfpwY8wR4j68fXn6sGDBj6c/xx4j/wDIL+B//en+Nj+HPiJ+nAhfTnwxjXmDAvrf0Y8r6cj8P6cfRnxkyO/rj+B//Vx5f/xF/Kv/AI8+Ez/IvC8Z+l/RHhfRn6WP6F9GfoY/qXnP0sZj6EJSIz5Y/D//AHj8P/OkYn/AX0R4f8CMmTP1YMfUvrwY+lGTP1OvogmfGfL+jH0rxnxP0Y/+i/8A85P8yCPqz9UEfwZ+jHjBj+RfTP0Z+jA/pz4z4z/Nn6Mf4L//AE8fyZ/gx4P+Jj+HP04MGDH0Z8Z+rHjH0Z/ix9UD+jBgwY/kwSY+jP8AFj6X/wDgY/wOv414S/kQv5o+nPl+cEwU/mLwvpgyZ8oiBC+nPh3439GBfQzPjP1Y/gz9WPGP5F5Xl34Y/D8YMC/+xH8U+J8J+Z+iRskknzPlE/Q2T9K+mfL8T9SMmfDGP6l9GfofmYHDwnyvpf1IX1R5f0IQjP1MZgwQLwuyDJnwx/S/oj6H4f0Y8L/DyMfhj8rx78ZM+GP/AOy/4JJJJJJJJJ+ifEkk+JJJJJ8ST5nxPiSSSfonxPhOSSfox4x4jwhfVI3A/FP1T9Ek+JJ+mf5JJkknxJPiSTBJPhMmSZJJ8T/DAiPqwMjyhWZ8Py/8XJkz/wDh58z9U+ZnxPiSfE+J8ySST5nxJP0T5nxJJJJJPiSSSSSZ8JJJJJgcBif4Z+qfokknzP8AAmSSSSSST4kknxJPifpn6ff1+vowY+nPif5p/wASzH/4Kf4p8ST/AA5+if458Sev4pJJJ+kYn/4Mk+J8yT4n6ZJJJ/ljx684MfTn/wCBP8T/APsMf+Ov48f4zfmfEj/+WT9U/wAa8QZ85H9GDH15MnZPnBj6X4z4z/iry/8ACf8A8lj/AMVfyL62P/AkoN/zQQL+aP8AFfh/wrxnw+vD8oQhfSxj8RfnHhC8Z+h/5OfMfUiP/hv/ACM/wY+jP8OP439efrY3BP0Ij+KPEeYI+qPMEfwv+fH1IXlC8MdDMfSjJn68EeEL6J+nBj/CX+S//wAFP0x5z9eP5JJJ/hX8MEfyx5z/ABx/Hj+NeF4x9WTP88+Z84+rJnxH/wCRa/8Ag4/lkn/GX+HH+avKJPfnP8+fqx5knzn6sf8A7KP4ZKE+Y+iP5oI/nf8AI/D/AMZfRn/AyZ+hjHX8Mkk+MGP8h/yP/wCY/wDCX1K/qn+HIxj/AMIx9Efw4EIXjPjP14/jY/8ADQhCF/ioX0Ly/rkQvOTIx/z4/wDor+Bv/wCAvqnxPhPnH8b8Y+hfzL+ZC8z/ABZ/mXhX5XifowR4XjPjPl+ceUIRn6n9KEITkz4Y/GP/AI8/58//AB5/wzH+LPifpf1z9eP8qSSfpjzn6ceH9Ofqkx4wP6pn6nX1Z/8AgT/nSST4n/Nz9Mkk/wA8f5b+vP8A8mSfE/VP+bP+Hn/Fkn+HP+LPmf8A4MjE/wA+P8XP1L65/ix4n/OX0ySSST4x/Jj/ABc+M/wR/jz9E/Xnw/8ALf8AmSN/Qhf4j8P+N+H9K/zY/wAuSRCYn4mf4MfTH0sf1IX1T9UeV9OP55GyfE+V5n/Mn/Cf8GfEkkjf+GvK/ij6F/IvC8z5Y/5WMZj/AOFM+J8T4fjH0oyZ+hj+tC/hkn6EZMjH4dfztjZJJJJP+fH+ZJJP+Dj/AC8f4OP/AKU/yIz9D/gj+aSTP0OhmP5ZJG/D/wDjx4j/AA5JJ/zfX+H7/ln/AO1P+a/qnxJP05+tfS39D/8AiwQR9D/mkn/4C/8AiZ+jH/xI/hj+HP04/wAuSSSSfLI/oj6ZG/pYx/SvCF9T8Y8oj+eCPpjxH8bfh/4aI/xH9Ufzr+F/SiP48f5MeYgjxH1Lwx/ShecmR/VHhfUxj+pC+iSSI/hnxJPl/UvC/hj/AOHJP1Y/mj/CX1v6l/A/GPoXhfyL+B/5sfxZ+qPC85/nX0P+SfE+P//aAAgBAwMBPyHPjX0P6IjwvC85+l14wdC+rP1RH158vw/Ekkki8a+hoZEEER4Xhec+GPw68Y8L6s/VjyvrY/rX8i+nP0v+LPh+cGP439SF/lr+J/8Aw1/i4+jonyuf5c+Z/mkknxP0x4gj+DHjr/En+XP+Hj+XHjH1Z8Z+uPqz/gZ+rHif/rr6c+fX80/S/wDIX0okkkmTJPjGPEeIII8R/wDyDH0Y85/nz/gd/wAGPD48P+XPjJn6UyYJJJ+l+I848Y+vv+DHh/4Wfqx9Ef4Of4MfQzP+DH8uf5M+M/Tj+DPhf4aMCF/BP8b+tC/lXhfTn65EL6H4f0YMCF4n6JJJJgknyiCCCP4J8r6Z/gX1Mf0Y8IX05/hX86/ix9C/zV/iT/iKxeMk+X/CvGfpfiPCF419L+peEIV+X9GDflec/Q/rQvrY/oQvMkk+H5jxH0L6X5x9K+mR+MfUv8bH0oXjP0P6l/mr+Vf5+fGTPl/TAv4WvryZ+rH158Z+h19MfVn+CPoR39L/AIM/VgnxJJP0QQQR4f0R/Dgx/Bn/ABMeI/kx/wDFn68fxv8A+dPjI/q9Dr6Z/ix/iL+L39D+r0PzH8M+J+qCCPPr/N9f/TX8M/8Axkv8Tr6Z3/Jn+Fec+M/Qv8Nf/Bkn6YI8R/iT/FHjJn/9Fkf1YMeEL+RfTkf04MCoX1Mz9GPCF9MjH9K8IX8q+nP8GP5ZExeY8sj6ceELxHjP+Y7H/wDZf+Y/GP8ADXheXfiR/SuPHs0ZJ+rf158Z8PxjxPifOfDv+JeF5dj+tf5ceIIIM/yL+ReF4z9LJ8ryv5Z/y1/lR9UfVj619eP5sfy4MGPPXlecnfnH15M/Vj68kfxL6F9ePqQr+rH1pmfpgggj6c+I/lz9WP8AAx/gwR4z/Bj+XBj/AObH+Rj6V/JPiPGfE8fxZ+r14f8APj/BnznzP8MeII8x9GP8J/8A4zH8z/gz/Dj6M/xY/wACfL8Z+rH0e/rX0YH4f+Bn+XP8K/niCCCCCDP8GP8A5OP/ALODH1PxvzjxgX0Z+h/x5H5f0r62PxjzgXheMj+rAjAhec/Q/qx/BI39K+nPl+J84MfzL6M+MkEEeI/gyP6cGPK/ws/xL/Ff8mf4F/hZ+l9GP4X4f0T5QvC+l+d+V9OfD+peEI0ZMkjJH5x4QvonwyfqQvrf1L62P+KR/wCTBBHiPqnyv5p/jX0r/JX+Bn/Gf0Iz/A/5WYH/ACvxgjyuPGTPl+MD+nIjP0uvrX8DH/hrxn6sD/lwY+lfxwMj/Bz4z9eCPOf8iPqn/Dj+eP8AI9Hrxjxj/EX034x4x/i5+jH15/hx/l4/xoI8II84/wDsY/hiP8iP4MfTkz9ODH1Z+lfw5+uPOPoyZFf+Xn6F/Dn/AAZ/w5/woI8I/wDh4/zEY+uP52dj+rXl+WP6VQhP6H/AjAvoz4fjv6EKjH0syTsfjHlfTkf14EJx9OSfqQq+rI/rwY+p/wAj8v8A+BHiPEfTn6l/99/4T+hePf1Mjxjwq8J+Evrx9PsXfjJkZ6H14w68Y8L6M+JGevD/AI/Q/pVeEIjy/D+peELy/D/mf+Ov8GCBjX0r63/9p/Wvqx/g4MfQvqfjAzr6EZ+hmBmPoXhCv6cD+pfxYMfQv4H9SF9T+tGfpY/qX+Bkz/ivxHiCP87P/wBOP8h+MeMfwevGPGPPv6c/VjzAv5o/hwY/kx4wY/8AwUeIIMEf/h4/yvfnPjP0ev8AAx9eTP8AD7PfnJnz6/hz9Xr/APJQR/nL6ev5MfU/8VV/F39fX09/Vj6Jny/qVC/xGT9WBfVkz9ePpz/Aq/inxjyq/mRj6s/zZ/xYII/y1/mr/NSNfxr+LHheV9DGP6kL62Mx9KELy/4ELwvofnH8T8P614X8a/wV/hT4f88EeV/gZF9T/gX+dn6HX8C+pjr6V4X8iF/OvGfox/AhWZ8sZj6UIX14MfQvC/gx/Jj614z9D/x1/mR4j+Wf8zP/ANjP82frx/Bn6sGPoyT9C84Mfy4/gz/FP/55/wDws/4zUfVn6Mf4UfVn+bP14H/8lf8Aw8//ADO/8RfwN/xvzP8AN3/iL/4Of4cfVn68C+nP14+vJkz9ePrz/l5M/Tj+HP8A+Hf87/gQvGfL/wAt/wA7+peEZ8Z8MfnH8T+tC8ob8P60L6M+X/gz9C/kn/MXjP8A8Fnf1r/Gf1r6n/Cv/hPzj6F4yZ8MfnH8uP4F9OPGP5seV/gT/Dgx5X/8Wx/Cv5F/BjzH0Z+nH8WTP04+rP8ADj+WP8zH/wBP19OP8/P+Rj/4Gf8A9Tj/ACe/439eDHiPpf8A8l/xR9D/APlMz9WDHiPod/Xjxj6cmTP/AMGP4M/4q+hf4Of5nf8AEvrf8C/kX05/mn/GXhC/wc/zZ8v61/hZ/wDgv+F/48z9Gfpx/G/4l/8ADx/G/p35X/w34dfQhC+pj/kY/ofleJ+l/wAz/mf8cf4T/wA3H1L/AA5/wGY/xF/hz/nP+DP14/zMGP5sfzY/mx/Nj/Jn/Dn/AOS//jT/AIXv+Bf5kf4cf/Mf+Nj+Of8AIz/Pn/HX15+ifrz4z/lMfifpwY/gz9OP8XP1Y/gyZ/8AiY+rP82fD+lMwT/DP0Y/hn/Kf1Y+heX/AImP5cfxMf1L6n9E/QqF9GfL/gX8eBfWx/ysf+Mv8PPh/wAbH/AnP8M/VnxP+Xr/ABsfQvOf8pfyoyZ+mfOPoQvGfCH9GPrz/IjPlk/4D/xF4XnP8WfE/Xj+R/THlfRP8nf8efoz9GP8RC+rBjjYyP8Agg2gaap/VnwzA/5cGPpz/gLxkn+HJnxnxPnH8+DH15+nBgx/Nj6s/wDxMfVkz9WDH1Z/+L7PfjP0r/CvKL8mgn3f041JxJ/gwr51/wDIz/F7Pf8ALP8A+rX8c/xr619C8P8Amz/FuAWbv/jH8LSahn9Y/wBfzr6F4d+M/SjHjH8aMfVn+BV9WTP1rxj6M/wY8Y85M/wY/gz5X/15+lIQv8HXl+H9a+jP1Y/gf8O8BGFnf8n97/vyvoZPmfOPCF4yZ+rH8L/gXhecj8P6l4X0Pw/E+cfVn6sCr6smfrwKv4M+H9S/ws/TP+Bgx/OhfRH8cfT6+teF/BvyvC/nvWX81Yy/D+mfGPoXlfQ/rQvC+vH0rxknxHhj8YF9K+lvzjyvqz9S8oXnP8C8Lxn+DBjyheM/y5+t/wDzY15jxBHmCPMEeIn+HH8r/hs3hfzoawkOGPzJXnP05+nHmP4nX8zMGDH05EvGfrwZ+mP8JmDH15+p+Mfxvw/58f48fxZ8L+OPpj6I8QQQQR4j6sf491z/AIF/z5x49nv/AAc/4Xr6MfzY/lwY/wDw0f5GP8KPEfRHiP8AIX1w3D/A+efv6WZ+tfVH/wCWyZ+mf/sIQvrz/NH0vy/pf87+lfvHYdh2HYJHj+BqtnYdh2Ds39WSfpXhfxP+FfR3/Cv50L/EQ/4Vf1L6c/Tjyvpf/wAZfyoQv414XiCP4I+iPpf0b+hf4SbVobHkvqU+4+p/Rof/AMBfxr6H/Ev/AI7+jH0Lwvof/wBReF4n+NfXj634fl/zMx4j6V478vX1L2Pn/Bz/AJmf5H/jL/4mf4Mfz4/+FnH+ex+Meff8kfXG8md47x3jvCrttiEhY+pPCD5Gd47x3hqVuvpgx52b/hx9Wf8A4q/xc/Uv/wAdjHnH1r/Ef15+ufpz9f5K/f8Ag/ofv6UKv414X8WP8LH86I/xH4f1L/Hn6M/z5/8AhIRj6XfmfoVCF/M/pdjMmfox9C/i/IX7/wAH9D9/x4MGPqQv8tfWzBj+SPrx5z/lN/UjH1SO/wCfP0Y/zkLwjXl9fQhCEIX0v+F+GPwx/Sv4H9amHpo7TtO07TffWtZY17O07zvHdHb/AN/Tn/CwMx/Bn+bPhKfqx/Jkz/Lj+Nfyv6UL+RfW/wD4iF4Sn+FeUL+Lr6mPw/OCPK/wl5cjfX1N4S/xkL+DPmPrF/xP6dtv+ZsbxIrlP4GMJ9b3hZLZ4NLPswiXhqTPIL3+41j6i0/Af8TZ/wATZ/xSf8Un/JJ0DOGzGWNNP+HpEcsMAglHjLJGCow9r+GBoOj9nR+zo/Z0fstPr4EpOIGukSsLw0eTXD9xtH5ZEETr/Z1/s6/2df7Ov9nX+zp/Z1/s6/2dP7/+OIz/ADoX8b8vw/GDHiP8l7Nn1PUeH/F6/mn6s+UpdECP4U8IOg19NxgJ4T+CBB8D+Pohl3/EjDi8fU1hFo7f8KbZfsaacP6xJR9SQ4+p8CFvf8CWGOmeLD/keH/hz/mxHjHjHm/8djH9EfQv4kboWaRdp9CHJto6h1DqHULpJ/A2aHUOodQakt/39CUuEOcITWq/kXhfWyMf8r+Oc+z39H/CJEo/iWJ04fmaXH8apA97fREkLYX8cyj9Vmy/19afK+lWe+/itFjwkL/JWv8A4xGDAq+jP8C8L6n9L8sf0u/HZ39S+hMrL/XnCYfn8pf4P637+hc/L/XlNGGP+LJkz9D+iV3wvomB0hmxj88fTEO/FbrYkkoX0ZZ4TeCP6V3z5yPoQSOt/wDPkT+TPPpmTj5UnQjs39OJsehHEFE/QRyn9NX/AALH07rj6FJLH+HhK8hBYzZ63zGlg6mdTOpic/Rkw6mdTNJDGl+M/Vj/ADkLwvGRno9eNiF4XhfW/wCPI/rXhec+fw15/v8A68/lL/B/W/f0fjLyn7/19OPrz/DC7v8A5+/ojVcvzKFz9L/c8VG9/REhBjS8+WMkEJTf0WHf/P15+U+i7yMaUe/X0QDrzK5/H0ISWMosfRMkLpk3BjqG28/Te7f0QrS+haP6bj+hHj/JALn6Zh/zr/M14yT5x52IQv44/gY/LMeULyr+ln4a/Xn+/wDry5pWjv8Awdv4O38HeIZsiT6l1VsfKdp2/g7SWH0fjLz/AG/1/kqnRcLz+Wfb6IEkiSxeF/xfQhjaHyN/RgmZcP6P2+Yh19ErfRDHn6kpcIgfoTOP8vp/ou9j3XX0UH9P7Ppks4t/FMv0TL/gx9ef/huvrX+Axj/hz/D+Gv15/v8A6/hlPD6pXfw/jLz/AG/19Ofrx/BkiFx9H/Ea8PoSTJZf0Ue3/wAfj2L6IU5/QvH530P+fiDXf0zr5f0L9A3C8fA39E9wHk/l9y/oq9IaPorP045+t0Ji7/gsb+iL2/gx/wDDSL8Y/gX+C/L8+/GfGf5Pxl5/t/ryxoR/zNH/ABNH/E0f8zQ87UCon1Lusj4jr/R/zNH/ADNCKSr6Pxl5/u/ry/L+uPpd+I939Lbp9hJ0+wlH0NpKWWevEOuvonOvqg9n9GJ4jPolnX0yT4X0TLrxX9BBHn+X1K+idfhoX6En0fS5pQta/g9iMaH9UEvoxLxj6n4n/wCCjHhC/iXhC/mf058Z8d/xPPo84fLy0K+/8Fob6Fj0Lzn8vof87J5cL+JCSz/jE+JFXf0t8oX0KyJ+h8D4t+ggjyLyiJvoRw58RfQf9v5aPf0eveGj2fQ1Kj6ntKEspw+uv6WSAX0SfXyZ/wDhrwjPnPj19KEIQv5n/GhC8Z+iTzZvflUQT/wK3klNCUeWp68sf82PFP8AAIszlR0zjz+UvpX7j8Z83ml9CXNokTz4hny/4Ae0MikJr6K7j6guXlfw2bwvp6zpEvX0xOu/rTeBnLOr+lLfQyRH0zL+rP8A8VX4VmfD8P614X+A/OB+Y+hfXNHh+YcLwj1j/A+Hr63SN5f+DC9/R1UPUMGf+EZBz9LwztfTZ8/Q1wR9GjUPnzCuvonbrzB3D9fRNh3fhpT6PYfS54RXYw9r6Eij/kgfy/rYjT19Dw30yL9Ey/4sfyP/AB8+PX80/wAj8Mf0+/5YX5f19Ez5Xzx/PNv6LH8fLcEg+fof+BD8F9H/ABWv4oP6E4GglHUaePYtrPP0ImDpG/EUvpe+Txn80W2X9OEwvNb+lLHLoYwjIUJa8+7GoceLhr9/yrn15xh2DEUY62HlKcGQz9GP6Vh/RB/8z6/gb5+heF4X8zH/ADr6Iz6GBPoizyv5W4PSLyskP5Tfdfwu/wCKD2x9DcEif4pVP+NCSxtWPMZ1/J0b9/RFPX8i5mTIlNIjV9DODpZ1s951sRA+hMPxUiEhfRkEdQnD6EJLLL6Yp/RiX/zFRj+B39SF/DJ39DH9c+V4nwvqieq8pcw5jeWNKFp/I6f+/ovOF+/o9KMfwZ8P+H4D/wA+icdfv+NsTJIF/CskPeMIXmRun8SSWGVUv39VH2v9fxUuxpPhIlr6J5jcu/pb6Cfn4iGIWV/C2kpZMhY+qJPom/8AmF39frw/oXhCF/Bv+J+J8b+hC+us0/oiQyvobZCK1f8ACpkOph9DIAiB5W8Mbl/Wxj+tfQiB7X0Ia+5/CheHkiro/wACc/TctilXHst5fhKdvrbSyb8c8YHst/A+l1+TJPq2pT0/f0OvoYLH1Kv6CI8mlGYoTn6W4MFZnPpfhCWvKllkg/8AAQvrf0L+B+Z+lX9THXnHhCF4X+A/of0IQhCF9GPOTyvo/vvGvPeoyFGJf0Z1nFGkt9D3hZE9n0UHC/f8Lrw/44dvud77sfI+/wDPnQlnQh9ZuBs8+X9Co7X3O99ztfc733O99ybLfcbn+RODbC6zqQ2mff1MwO59zufcbMt/wdrO1ne/qbgxI2LpPSN2xvk/4WYM7R2hmX8yF/lL6M+M/Tj+VfT19LGPzgwY+lL+J0qERPo/1f8Ar6sCwmzsfcb5P6mEIQnf0UjL/hn6Ov8A5y+mP/lz/wDIz/gL+NCF/hPw/PvyvC8L+KseGJz9CLUf7GkJ/Avo6JCWPoIkGzM/yP6F/wDRj/8ARY+jA/GSfpX+BI/4M+V5X8XWP0Jz9CCEOSYZ9WRWaqPZZ2f0zBkifRj6WPzn6Ni/y5/nX/4DH/yFQheF/EhGPC/kY/qf1r65+htGEM/Uz4YxI1H/AAj/ALFuCPZi31LOycPpX1Mfh/Tjwhf/AAV/9B/zP/EX1sf04MC/lQvC85H0PxjyhCPf+C/D+hfSvGf4n8ijw/50JLNf3Dc39WfL8MdeMDo34gXlfVj/AAJ/xV/9Rj/lf8z+qSf5smRX4fnAzHheF4Qv539WP4c/ydojpvf8amWEuY/t/I/L+jr6MiEL/wCOv4Mf/Ox/mY/gz/Lnx2evOP4EL/IXhf4eWCmEm0mMYb6EhYdUMef8B+GZ/wD1ef8A4ePrnxEecfVknwvCF/M/D/mQv8HL6/1/hY+l+Hfh+O/OBCF4z/8AZX/4BfyyST9CMC+nPh34nwheEL+B/wAj/gQv48fVl9f6/gf87GMfjfjHlCFf0P8Aw2//AMS/8nP1Y+uRkkkk+JEL6WNnr6kIX8O/5H9a+mf5snr/AF9OfMeX/Bn6WMf0IQhC/wDm5/xF/wDRX1Z+rHiPrkb8T4kkkmTJnxnw/Dr6UIX+I/oXhCEL+OAIzVn/ABNn/E2f8TZ/xNn/ABSf8TY5lPo/4pP+ST/kk/5JP+ST/kk6v2KiS1FP+RjGdHR19C/jz/E/8lf/ACF/A/5n/G/qjwvqfhkmPokQvrZjx78R5Qr8L+Rj/jX8fXlCe/8AERJz43/DHlj+hCXhCF/8dfQv/uv/AAI/xMiR6+n2L6I8IXlf4MfUv50R7X+Jhtfxsf1LzH+LHiP8Vf8A4Wfrgj/Hx9b8Z+lCF/DPl/4OP4J350RKfY63/wA+Trf/AD5Ot/8APk63/wA+Trf/AD5Ot/8APk6X/wA+Tpf/AD5Ot/8APk6X/wA+Tpf/AD5Ol/8APk6X/wA+Tpf/AD5Ol/8APk6X/wA+Tof/AD5HJFP8CPoj/wCkv/u5/hj6cmfrx5nzkz9GPCJ+l4J48PxIhCEL6mP+N/WvKF/jT/isf0QR4x9C+jP8uf8ACf1IX1Mf+DPhE/8AyYF4b+mSfM+ZJ+hfxZ858vw6HXlC8IQv8F9eH9KF/mT4nxP87H4fjHlfVPnHjHjr+J/4y+h/Rj+OfqnzP8M/5kEfXP0Y8R4kn+HHif5MfWvpf+JH/wAWf4c/5S/zs/4M/wAUk/TP+dBH8mDHifOTJkn6sfwevHr6Pf1r6Mfw5/mQvon/ACJJJJ/lkn+JC+iSfEnv+H1/H6/zF9Ek/VP0z/8AAgj/AAl9MeII/ijxjwpX15JOxCF4Qv4H/l5/nn6ME+JJ8SSSSSSSST9MyZ+qSSSSfE+ZJJkkknxIv4Z+lfwySSSJ/RJPjP8ABJP0SSST4nxJPifonzn/ABII/wATJP1x4ggggggggggwITF9D8P6F4QhC+l+H/Fn+FC/jXhfzySJkkkjZJJJJJJJPhEkjJJGT4knwmT4kkknxJJPlMX0ST4n6Z+qRsb8Nkkkk+J8JkkjZJI2SST5T8ySTJPmSSfKEJ/48Ef478P6kIjzHiPEEEECciMmTPhjHQzHlCEL+GPpePof0L6EL+LYhfwz4x5kkknxPhvxJJPifomiSSRvwzBh+USJz9E+GYJ8J2SJkif0T4knxj6J+ifofmPCF9EkjH4wY8oQrM+M+WYJ/inzP1L+KCP8TP0Pxgx/NjxH0ZI+rBjzGheF/Fijr6H/AJS/gwYH9Ez4yZM/Rgx4jRmvoz9TrxjxHnJEmfMmPEwY8dCF9cmCSf4Z+rozX0Z+vH1x9ODH0x5z9SfhfyR4x/mY8r/CS4PXifqfleF9E/xv/On6GMYxsZP+Hj+DP0rxH8XrxJH1yST/APKz/Aif4o/+Iv8ACwYMeX9OTsQhC+rP0x5wOvoz/nT5b35QvGPoz9HfhecGPHRnxnzM/XHifOfoXjBjy/OfGTv6F4x9GfOfK8Y/gz4z9cfTn6sfWvrgx9ef/oryvpyPyhCFWRC+nP8AK/8AMbGxsbG/GBHsQvoZnzv+J34fQ/oX8LH9GBeF9Lv6kYELw/DM/wAufox/I3/JM/SkL+Jv6J/yM/4qMivznyzBvwhCEL+Sf4MeF4QvCF/GvrY2NjZsXhCF39L/AIV9L8OvGPCEIQvGR+X0Y+hCM+cmfLMeULx7+pmPrX0vw6+hC8r6GM9eMfShX4z9EEC8T4n62PzP+U/rX8yEIz9GDH0oQvqx9E/wv/LkbGyf5cfwZ+l/w5GL6MGPrXjP04+iP4cfwZ+l/wAOfGfodGPqViM+Y8seJJJJ/wACf4Mf4a/wkevp9/Sv4J+mSfD+mPqQv8KfDZI3/B6+v39K8R/ieyeTJ785LEI9fwx/n+vr9/xMfT78yJk//Kn6V/EzHnH05M/QiReMfTP0T4bJ8+/8xjH9aJ8YMePZ78ZM/VPjB7Ovodj/AMXH8PrxIvGPpz9c/wAL/ij64EF9L2ezPjJPlMkn/Nx9WfpnxJP8jFQvC8Z8ZGMfjAhC8L6Z8yT9K858P6FnxImJ/wCBI3Ix34Y/GPCF4X0Z/gVeF9LM+J8MVeFX05M/UqEIXlmR/RjwvGBfRkf8zv6seF9OTP0CX8Lvw/pTJJ8T5z4f87+tfRkZkf1T5nzP1sXf0ySMY/GBCF9D+qf4Hfh9eH5wSSInwif5JGx+J+jBjwhGr8Id+M/Rj6tfQ/ox4kQvOV9D6H9EeEL6X9a8IXh39E/yvzjyv4ijHifoRJJPljGzBjymJk+JJ8P+V/w+/Gfrx9PsnkkkkknxPifoyZ+nAzHjrymLzny/GP8AFnxP1T9bG/OPODrzkz5V/Rgx9efPf04/ifjBgn6cmfpx9PXiRec/Tj+fH0Z+sgwTBPjryvrnxj6c+JJ+nH+Bj+THjH0q/pkkkkkkkknx6+nH1r6J8T/mSLwv4JJ/lr6cGPoz/Bj/AAfZ7+jPj19GP4q8z5x9Gf4MfxkI+n39E/T6+heJ8z9K/hf/AMiRMkkkkVeceWZM/UmSSY85/hx/Jj6p/jb+rP8ADjzn6e/ox4x9Wfox5x5n6c/Xj+THjH+cT/BPiSfryZM+ceMGDAv4Z8T9efrwY+nPjJn6cfXkz9S8YF/IvK+l/XEC+jI/Lf8Agz5QvOR+JH5wYJgXjXnI/rVC+p8+H4x4wdfRkyZ+nAvCoX0v68eF415yP+BfTkjflMecfTkz/BgwJ+c+X9C8KhCF9ORj8z5XmDP0P6ELwvOfGR/Tjwq+tj+lPwvGfLH0Y+hCET/MvqdfSv48eJ8T4X0v6kLzn6PQ/OBC8T4z4z4f1Lwvq9D8Y85F4X8a+jP0eh+ceV/ARH1r634wYMeV4XifD+jH0oX8iL8Z8z49eMfQheMmvLG4+heF4Rnyyf4FYr8Z8Mx5x4685/wZ+jH0dfRn+Ho6+jIjP0Y8Y8dfVkfl+II8IX0Z+h/WjPmfLrz0deFYhWIz9WPHXnP0Pw/GCPKF4yRJEi+t1/E68skX0Z+l+Zj6smfC/jyZ8x4Zgx9CEZM+ZMGPGPC+jP0swYMfUr+jGPOPHv6ZM+UL/Ax/DH0r6X9WPOPHv6s+V/gxBS+rP14+rIvox5x/Bn6F/BEi8EfyZG/qx9c/wY+rPif519GPoyZ8x9OPGP5cGPoz4z4Sj6vZE+M+ci/hn+Bfz48R/iZM/TjznPjPjP8AE+xmf4cGPqz9E+MeMHs9nv6ci8Lxjx7Pf0RPghH1ST4z4n68fR7MkmTJPnHjH1Z8z5x/gSL6cmTP14+nJkz5XnH158T9CF9LH4n6MC8IX0P6O/GPC8Y+jIzI+fpnwqF9U+J+lfQ/E/WhfQxj8d+ULxgj6H4f1IVeZnw/px4RgVfQ7+rBjwhec+LfQnyvGPpfh/TPhV5bkmRj8P6VX05Mj8Pzjwq8R9Wfqx4686M+MmfOPC+nI78vzjwq+nJkY/onwvoyP6JMeMC8oRny+vL8z4X1P+JfzQQQQNEEEQR4ggggggggjgjw/ogRHiPLXmPEEeF4jxryxmDHleEL6H0eiTHjHldi8JSKXhA/pnwvqf1z5RJJPh9DMGDHhC8IRnyz14wY8r+ZCF5z5fiTH0Lzkz4Y/D+lC+h+PRJgx4Qu/pz5f1oRn6n/AC4H/FP0TBj+RogggggggSIIIIIIGvCCCCCPCPEEeYIII8QQQR5ggggagggjyvonwx19KIEFPwj6Y8R4ggj+GP4oIMEQR5ggiSCJII8QRBEEEeI+qfM/RJIhCsQn5Y6MGPoQjP1YGOvoRnxn6MGDH1x4j6Y+iPGRHr6cGPrz5n+S/wCOf4o8x9EfRBBBBBBHiCPogggjzHiCPEEEeGQR4gggggggggggggiCCCCJFMQj+GP4YIII+iPpggggggggggggjzBHiP8AGz9OP4Mnr6cGCPHv6M+fX+JHiPqx/ie/5vf+BHiD1/BH88eI/hj6Y+iPMEEEEfSIR/8ABgjxBHiCPMfRHmPEEfyez34z9WPp9/RnwvOPq9/V6/gv6Z8r/BVfW/qx9T/xExf47/wl/PH0wKX+Cf1L63/hwIjxHiPpf8efL8zHjH1ZMmfoXjHjH0OxmSfOBeMfVnw/KoX1vy/rX0s9DX1L6n1/K/rwITEL/Ej+R/ysY/rXiC3hHh/wT9Ej8P8Akb4J+tf4cfQx/QvCvzEjGP60L6H5f8j6+jHheF9Xo9fRg9iE58z5ZI/pQheMmfodeMeELwhGf419E+X9aEL/ABMf4i/mQlJH0P8AjnxPmSfqnxMkk+H9a/nV/wATH4QhGfoZjzgQn5z4nwx/RH0Iz9WDBj6EZI8vwx/UhE+J2SST4nxPjPnIhfTEfTHjPjJ6Eev8lP8AzZF4x/LP1R4R4n6sfwz/AByTPmfOP45/xmMf8GP4M/TBj+fBj6s/Vj6PZ78ZM+cEmCfLI/gdfx+v8LH8i8In+V//AAI8F/AwT/K/qnxP/wAh+GMj6MfVn+HBj+CPEeMfR7/gn+DP0+hV4x46I858Ts78z5x/B3/M+fGPoX0v6WT4X+Nn+af4Y+kn+afokn6J8PzP1Y/gkf0oX+MxjMeMfXkz9GPGCYH/ACwQR5yZ8zv6l4jzn614QjX0MfifEfSvGR+H4x4iCPpgz/JH8S8IQv41/I1/gwL6CfrXlfU/Df8ADkf1Y8IX0Z8v+GPr3/IxjGPwvqfhj+ufof1oX0wNDQ/ox4XlEz9D8P6civxkz47MDowMj6c/S/ogSI/gZj6l9bryvKIEheI/iX+Kx0Y8R4gQX1H/ABZ/+JH+Evqfh/TH1vwzBgQvoyZ8v60L6mNDRj68/Qxjr6UIQr8evowY89eM+EZ8+vpjxBH8y/lgSEJEeI+vr/Lj6bP+Ljz19Of4o/mgXmCP8ePMEfRPnBj6kp+nH+BBH0ZFf1Y/gyIX+FggggS/kj/CSIIIII8R/nQR4R/nz9WP5cf/ABo8R4jxj+Kf8aBr6fX82MGBCr6c+M/Rj6UvEEfxY/g78Mx5x9GSBISI/wDhYI8I8x/iz/hx4z9aMfRn6I/wl9b+l/TBBBBHiPox5X8i/wADH1O/Ek/QjAheW5M+H4ZgXhCEQR5gf0x/I/E//Ff1pCX0Z/zn/hR/8h/wwQMY14iPOCBfS/M/ShfQyRj/AJMj+pGReZ8uh+IQvoSEiPEeX/jIz/hY/gRr+GCPBL/4b8x9KF9T+pfyLyhGfpf87/jflqPMeUIz9DH9E+V/A/4YI+hmDHlGRWIz4784+jPiCCCCCPER/jZ+peF9a89/4cEEfzdfyT/Jj+HP0RH1x/Pn/wCLHjr+TH8uP44IIIMfQrEZPR6+r2e/KQkJCRAl/mL+OfE/4aRH+DP/AM/15j/8vBBBBH0qvGBKPoZkyQQR4gQq+pry+fpn+deevMjZJJJPiY/gz9cEeZ/y+vofif5M/Rjwq+nP8M/zr/Mn6pn6H9OP8KSfqx/DBBBHhUL6J+iCCPEEeF4X0vwx/UvpZP0P658yT4kkkkQifpfifKEQL+ZfSyf48+Z/mfifoQvC/wADPh2T9S+rP1YMfVnxPh+J8z4nzJPiSZJJ/izj6sC/gn619bH5gggmReXZnxBBHiCPCF9T8Mf0dfRP0P8AhyvonxPleV4X8EeEfxP/ABF4mvL+peV9T/kkfl19a8v+JeM/xrwvoz5f+Pnw/D/ndD+heF9Gfof1f//aAAwDAQACEQMRAAAQ/R+gkC3jC+7iL6zzYKiL/RcYnDIiqsj1kfyLgBtH2fekmvjGdTOfXhFxJh25E9AwJjXmYQWDegvaFuAhdtCHeqJixqAM2a485Xbo4EuWxhem5TlEfvsltUguGNcPUBKcXglGAtmJmzbkp15T0/CgwgyKVjaCNpou4UsshlF6Ad637gl9p3TCYnssh0GkGrJ5EArQl7KlABdX3qsteyrSLb5jjO9EkjcspsMCS/36kzy+vpJyY9+/gEH+aeIDoPZZIz04nFA9fUF7uwMWx+pg7TpAjk+rAXnQBnxxF8zNtvTy7ItiIouSV7VsVboZOyq99fkVHFeJtvYNA19V9rMoQCJ+AFJJWu7fW0NdIIjC6kEyZMFAybFvuOYR1z1PoFDxYj1qhmSBQsMZyyIjBFY/X41kSFmZPEeiGkpPugLP/sGoV/VEm4Q/lgITTSRADmy5/P8AuMQ8Iw5AxrTgGvGqQXN3zC11pKh59RF7DTwpWRxzm5cpadyn3KKfuZA3cGps6oB+rpCoLIBK3bhmyYaWaWb39dj/AKaOW3PFtS00mgYhlFtEeBQP5Hsmbra3klj2gRecd6ZPtglT+Db7NbYKlHP0Xnii/Jkyf9RkoNnUAGUzstvR7sLZOgQEbyhRWAc16Ip0xKsAiRuO3/CRdiObY+l4VHJ94yBe2EErt9L714Af+ZnHdNI//tF9gx7OpIvueRDIA1hBuPK/l0gF9W5OE4NmNIpyFcRdjY+faHJ/ug97zByqtvqWL5f/AD1zEk2NXRDOsNgnSxxBdJxZ8mrS/UBUGsSMJn+0SNsA6eTJuWb3CP8ABjaNAEkDl32wA+zxJr7qqt6y1yMWmFRdkubud2mhOMgwrOazTKAjfBS8X/Hji3MdMvYUKgzZC88uEt67J+w8321BTIQ6ZtoM0kHOcfJOmfLaOJ51AJNt1iMmjzwvtMx2k0nWPWT2QtTCrvJ5ojXaSfqzCNgUEjLL5YYBTAvNmEGSNwsi+FI4TTGECx29m7JnUTRFjdYS95JDwEhpaTDjaWje3aDdqaRNZtzUgKALMvBXnkxA5dPjsVG89/u+pbCf82abgdBnW1ffywqX8hNySrDZfc/UUbC6W4KA3gPibIGnDjIP/wCOfkYso4JGnbhBWXP5w+yhekafuyo53RiOpCXU2RsjOmz7HAe1FbhTVSh4Ph95kiKdWYQG3UrLOpb5VWStnP8AuKAlCg5zeJpNj64E6CZIbTTuEqEp6mPUrcXHX5qlYz+YWbqPVgdikQ4Qswj0AmORoBrQaxpuvpnBSmuoKFMJSeGmXk3TvmZ8WWBP/RgrUNp38FPnbwMypitTqXecx5o2v+HhPsm6dejiICHTbcCS8A8hcHl/+AxJNWUvTndWTzKAuPDh42FukddWVS/CoqSTatchFBC7VWZniGtsTyhVo4dHh/jgfWvyhDbpUlsk+3FrNcR5RTNKPxwjhzp/Db6+gIgCPXpYDlCxvvysHj88a2fwxp0vEvmkthzd9bjMjksqnRLvcdTUn6MMLXbQlIR5UC3YnwCIqWqAR1NbAGb0mU7y8tp/pLRsdXlmAD2Bg/i4xANC9EWfICOAPYCSpsjdMedu2OOUvoPXLqnu+cyfbdYb7w0Hwbkzf7F/a2q8p9mIRdftQ4Q1H0YRrCJejgNDh0+Sbf37YEvUkOYYMNN47fZA90SpGGJpP6BeBypH3oYVl44frNpHtkgRthUcGwSvv2b7PT192ajqNmNAotNumg1eLMESaJiRH6+jOR2AlB/2/TfYky/ogZFEdNUlTGh65x1PbMIHWxFrLsuM4hOgf7LUBegl2AoLLYLevJjUtxSyNYkaPIaAbTc2yWDyKXa/Jpn+XFrhzOzOhXAcldJXO/Y3ncs1enbQEn2KgMg+ftIxorQUJNRoTew/TzvdJrTfsF2jrZH514WTxzMNRGFAoDe9p3b2xwBXuVyHcaZo6XLV8Zv1/wDLADHMLbady70hAJGQJMtCEY8K6HVkjqeDBcUkKrIVogK8eeIu+O51UQTCxpo4Oy22iZUJWGAtNQ9xdQcPSfc1tM126DmQFCOCaP8AWyUo36j49BTJB++Ki0JPU5jGgt7IiPym1d1ETeU3IFU1bFLjm9RzmBt9o7GQQRuVuCEfAIAMjfI+buyuk/zbJ2HGXQCING3syBWG2SCn9cuSVtaEhbcDat8Lrz71F1OD5UNMsjP3+WxRW26Es5K/VJfrtlv3Rxp9CYX3JAMOVh9n/K5cZE9ZNkPBUinhBRcgNsTyv95K6gywBwFn34JGj6UkpZualAGSWp6PrjkTzQFY+Bq2SNWsosr2uvwq5m9/7HkC3K7VfanR2GEfEZgDt/8AeNp3DitXz8TMZFstLuzFcBeUkyW8t7YeP0rQg9lCpSRRP9gfwu5llgQOjZdYs01kZQw1cu51U3dCZjvgWpmGVkJOdTsT30BcWKealrZkqLgwf2tqPQ6aQJhkXisnr+xeRMno2iXDu1f1tpka/kPcvhRnvwlSDbFIxmZkEfYoOy5QogNAQLLJaWPF0sIjnv8ASiTHlEq8Yxjvmy7rLrZoEcRYyr6d3oGQdr8wLqkkQQ1RmJBzWrBwGCtWkNMwTLFBonll+svR5sF3wCzAKty68ll3exg4uw6kGE7u1w4moE8ZYinmgfKHG5jYXa/jdaBSuxOfV8ykI3yMCEQttjTbutN1TmZUiCE6IaIDm0al1yo9b2iMyAfjypgLDi/lorP0+J1NbQD1Cs8UgLqyW5FuOwtlkLwqfDlo3HBBZfu3rJbCZc0pl9hnHKAVBC5BGyXc6d32DOsgrJgssLcAe3CCvoSZxzKy6MaAz8tBbD0l9IsIeczbDR1qd6QamUQMl+nc8QgFEiRkvLacgfHuus+3zwBQOLCJVa+2khrPYMaBaLx1ljTCOTxP3plkFIa3PXRgQQaDxetfbTqGfPskIrZw8BSVTOxxuJ3/ALQJonHr0MNQ4wfj3Vj/ALCODYQzGfIfrnN0Rph4GiiMn/ZDWyneAyUBtTi2ehglVO5NEIzz9FgqVeNSg09YdoEkmFqa5PWqU5t75R4yuQ3TzvIO2zrWvAI3i8/TVuAsLsDSa6e+lIihv7WrgavdLYx03w0lq0CfKxQc3oGUcCzLuk8fWrA2SAY59OPF1tDwi6rjkTBWbZetskTD+VZ8fb1cEjD2NJcG7uUjFDsqo1hfNue/1cN04/Ld1jDXf0GtO54+i/AlbGS9LbRzTHJynwIq9rc5uxzPRGpuaC3n+bBCERR0morqoRryneUQ8pH7LXaP43ec4yWJMgZI/XC3l782KGSxAEmVR1MnAxuW54tNXbBgbg1CcKkhXEC2Mqx4vW8ws5EY8oibL6gZZAE63tUaTXLLs911Xw9nWkmVG5EqEBmkj3aEC/auqfH9K4TcCtQga1J5/wCSD38J3v7BxAO92q2dlBGUdOIh6rVlieEnQB6aPn9hEvZJv+MB+xlVxIvn9yWdexGedJH1wuae2CtfB4zNMh23wER/35ELiyGnAfRiZHKgSy1uYWCsDgpMvtiVS2FfIsp8aNAgaxl0Xy7fE3HsfiMC0KBm2CKWth3Zoa73UhSYpIipMT5rbBD+lDoxCS/iOH5B/wDgLRzbTogRrZsCQ0tND4gkclNw3FcSyDawgWilsF3CZQR82rcgnc2ekwF0W6YQZ71bWYHKe4NAkP8APfKurM4VzdOji8faxhywok/MWfSNYd4RZthVSD+AoDMb/cEGQUs56wgO4J1f4qu3wBICjCWrFZN6uFzylMWws6p0wylt/NbGIi0kMsLk0/upTR47xHtYEsoKUh3C41jQ53pgY+/gHHpMQdss9A6Z1jw3XHbTmeCrKaZKqMnWCUXxYXAKq523F2WqBBFB+h9eSSSTfWSJ+nqwOiOP2009Bj8CJhhlViKxm/Hmk+XF4mfITPWZC+7+A7YngjJqt7+hkBvIkfp21WVd03QGlyoL5sNrsRSwPXG4jJStHvQlzJK2eVhknLIBos3/AEC3umC/Zd4cljumeE6G2qKtjjwqUQySJcj+v1xNBHGFn71QSwrEkG0KW24TQICXababYByfh0okwOBEk2BKKaa3+2zIdEHCf+ZF1UOB3ZB5cXmTX8kuwBVr2aABQIXkbPPmsYbLK21wpRcuy8DsKbTBGW88u82ZpEQUF/NAzRLSjDB2Y91v8KwqmO61TducQwLBH3sTDtn10xMPaxloQ86/uvF6xCIarENp0slfTyfYX++eRRVALAsV2NHE+/MQ1856OljL1jp+8tH84LVlos4Z6I7p63HN2hX1+5OABse15HVASaCUj2xrn9B+Fb4zJMotdLIqcuMJe3G+CsXy5awbIWza7SiupjWL+SVXCvHvoCOYQajPz7zAxTSJaiUieDsQSd0+gg4YJIggdTNRoGFv630O1tfs7mHi6CQajh5vk1h1qwQcd0dTzgKY5bKFgG5WNuB2rzfM/NB3FQW29gRL/FlCIdO/hVQIP3lVM053T6EZqW1QPqbykTldhf8AKN24/P3DhPG+2bSVkFrU8kGj/tG27Rd+FUiV/jAzKEMy37Bla2feCs6QbwLdNnOTI7Twu8zuTRvDU8iQ5+1LN/MSkwmxrR//AGK9pq/rAMd0eOeFjU5ESY2aTSFGf1SmWZJSxo/c6ybYv5CpufiQPsdirI2iVjvWU1FENLFLTlqSktjQGhsm8/616iAgiNN3/v6ErXJMjDC4uE2b071UpEXLZsiCvEa3ks6VCiGi1ALMQLqx004I2ztHTEadzeZJm3xyYfKMESbwAZUCn3gpF5r8EpRE3SFlaRZ9tooVc6FooO6qT3EYYcFmDj50T3a0Kuy5Rk4QeT4FoC/ffUAYBlS894I8xK92ERpImFW6qPbIzfirS4Bh24qzfMpiKFv1IDTa2KCWnvTmiy8XjpN02RhZ502wJpo4ByMEVqu8i3oJGAlX0cEihq8dwfFn1FiR+pVi+PIRYq6VBO4YSm9YL+28YodN+CMslvooNTSR1XBZ+vXxRJBHOGENMjd/P6XMivUkZGbi2ms4knn4fsoStqIHZrMc3xel4uf4TkQAqh//AAAT43nwqJcxIZFNit3TnufeGpHuwha3JCZUmvhFWaCBDTTfGtbfjtEOP6bYeoBFjWrzsbzcTdLNTJ35ghCLvvljRRsIC+fF/wDZ31GBf22WmUXaMISmin2gUfy0ElmiQUnIOk5SjmRl4lda5mp1CvjpM3MANUj5ppy4tJjyetlirhJryzZHsgINxVTt3qawGr+OGymJNZqIx+NbJr7VHU3tnZZJ77L83xBXaEd8vWsxskw1mH8lqyd60axQeg3hLr7PiAfG0CnkReNH6AAAAArS292EVuVqxPr8Gkds+DB8FV8Wy9fF1Gi69qFw9OGWOTaLb8bJ4kzAcFgFxsr5Qpu0md0l4AhT2udUsXc9+iO7Nwu6aSUeb5ah6zdrVC13o2nwztd90AAAAAB6FHJftoU7d9q4lhZ/4Lk2PU4/c8hLrSGrD9C7yDZUS/VtZ2j/AKKFBIjP6HwqyulB4okbWI4GR2lym1XfWWBDm8PkMUj+CKDLx6Rlv/w2fhWQGKsDNwAAAAAEJ2umiSqvIw2y7V23OWdaf8UyAilCkKWgb4dB1u91XsOMFyzyYG7S4ieHlGQGtTSMyR3ocER39F+pT/Zeot1M3aZan+ypc1bmwKuBGnyZl/4pPE073AAAAAAAuuLa8M8oJ6X05J1sJk/FJJFiaTVwsNGyq+cllTbS+nmrn6TlFiNcYDY0T3zPPBiiAciiRdAtiv8ApOXT+I6mKYbrJQPPAe3H4CYPpI85rAakk9NmnLQAAAAAAArNAjEr8KfTfR3uobUxGJsTcsU0DsmTcbO7RhJedM56CBVrj8I2/jlwml8YqOsltkNHbP4FgCV+2dS4plIicNIleYnuVSUkasg46VnTKD3fiZ2277gAAAAAAAwJ3oBanDHrll9twYU287yrQvPLKwKWJbiXTGDpfs1Z6YNqns4M29j7+/X+LmiV0Iscw90WsfCa4+IkP6RnAVCEoaSjhsAG9O56bMoKQkbP1J0rDVtswAAAFlICJ2YrxXgcPU7y5M2Mh0Kge2YOLsm7nEd2SyDC+kmybLJvkV4kC2/vMRo54vDmgUoBnzx46pttZiGQq0ASE6gtap6MvOllQ1ReTnP6AnCO6xvgVAZ2AAAPf6IUd01yYT2fgsR7FWnsSVpL0yOvehiHTyt3kV8E2ktFYGFurn/hDXT0OX5wEltgqVMy+Cy7zK2R7KfXrpBfB7+Z9Ce/jXGq8wkuFhgRXM9RD+svMK7d+AAO8udGA6liHflOVtoSPKlm8vCWlzBqWxKkdjdhn2DAl09jMXHDHlYQpTblsZ3XO0NDkzdI7j8PmkivEAWPd6ouyxckoHCQH+YUpAKFBP8AuJjpeElLuCGZRdAAC9tnXbaFkih2cUDu14wXb/8A8h2PjOwvOu9YXUm+f3DorIfpJora5tgl5ppT5TwTAmC2kk003XbNMWp4qR5Zm1EvNkgOdJLT1OeyKHZcepk74G0F0eCq4AAAAAAAHIo/x7wP3upptUoioS+tyhix2sDmMKiEYZDJPXUd9X1htJryH45kFtsyzN+4+7EoJsls0z1M0ZE9PHHOV9mAHFeGPS6qZSRTkCoyzdeqzGyw9cdsAAAAAAAAC7CiL+/kBg6R0Sb2BKZa0etsstAfdg5NMrdzGoJWA8AZkHYT7dHYQpRUvXtn1PMZyZSPA2Dy9FSWh3S1PKNNqsWo1LAU29IVPPSxCXxsj8/Gd6cmyTU4AAA6STWBJJonG4Q0N0t/2LYvrIUy0E4ieo62oR6+UXE6jmLInIEn3H5Gw0L6x11yxX/eqXNYiw0UQhO1pafk5e1s5VKncPa6o5tPazobblqEU4Vc4PA8lTcAAAJ28dR1qs7KBSeP1CAqAEzpJVXYBELAALDJMd5J+aOabHgbPpyvkSn/AMGpCGSu2aUl0klGSaTDslznoi6y9oDrPnRnfRZ2eBNeg3l0Fmxcl3+jQ4/8+SgkoAAPimYWVYv07LIGX5Za2AAAAUcSEAAAKs5wAAAAFR3BgAAADxBauAAHwxrQAABDCAAAAAOlzLBZDlzbVrlerCZvrVaKCLYQ+qpUjsr2W23CvLoqpQMl/wABYMAADzN4cQhFC+VZ0dROgoAAAABQlMAAAAJdsAAAADMDjgAAAAdNA8AAB3cJAAAAPKgAAAAAIt8kwGHVczYociHqeW2sslz1HwHuk85n7KXwfoCUbJCCD3eAAAAAAAAUv0dxXSHapKDhpsARbgACEAAooACCAAWegAYQsAMeEADuicAAAy/oAR5DNo5kAA+ibsng/wCG1Zu/IJY4OwfZp+MxzN3GHiqyOxQ/58/Ys8OJZ4Cm4AAAAAAADSKArmGR7ahq/wDTgB1uAAjAAG4CAFHwB8ygATMAGKP2ePm8AIAM5agBXq/vElQAAdHft2oIfhABCN9am4mWaWRegh7MecACqRIid1YspRDLtPIA4adJoAAAphPaQBFWRfM4ZfLzABgiAPkADn8gAGOQAcPwB1OABFLckafYBIABvvQB9W/alXAB6RQghxe8CRf0Rebb+TwH1DKbU5aQuVAq3RrAbAPm77PWdFIBMh1/sAAJehdZQPh1N97RwbdmwA9+AHiAEfrGAJOAIkeAALAAohAz6qiwBEALTvQAA7P3A1AAcmSVCb9lWCm/2sb8magrQ4LD8hyHuJJYzNjiSgRG8XRVUNwB2fdMwAAFq6xAwBP3Y8jNkO++AANgBH+AC3yQALcABjqQAGwB/pddfXKAHwAOoBoAAAPYJ6ABF6grSG7gFrkJJya0t01RSUbWU7vaisP6lCVZGXcO+CQVRxgBggAAAAAAABPqgIwj19Wq6WM+AAAAP5wAPK2wALYAC9kQAvQAsh/brFYAJuABBgRoAAB5m7gBrmavTpAAmRiIk6KiEPXiAqecXfKK7yWSNOajM7UWipV0FVuAyeQAAAAAAAdhwMwEkhZTgb10AAAPmsAAGpGABFCAKkGAAKgAeniI6/ABJ2AAHBmf5ABUtLwBRxdy9olH0aJN3JNlUXfMyQGFfKiwG7GLdWmGIdLuxC9UKt2AV+gAAAAAAA4yAKOCt5qxPoKwABWVBKQABGSQAMSAPaGAEVQA7tR7OSAAAAAAIkkDxQBAV8ABC5bFntEs9JBeIN6Vk7QNdwL9qQorp4tEsbmTXCKmAoOHQOIAaNgAAAAAAIz2Alt1SmrQ/EpQACGxeCqADpkAAMGAPNgA6lgAPumAKmAAAAAAOuxXkAAgRKAB4X1+WC634t5Hnttouz5Ex7SFYOSESzNOX+btOD3gbKUitP0ADPyAAAAAA8sQAf8AsAclR+tdAABDTppaAAAAAdF8AAAAADX7gAAAAcfAB0QMAQRgCCAANtzAAa5WlZPFGgPBUT4o48roXZanInGZYnTNDh411OSgxE2x7N9aUC3gQAAAAAFpoAYNgCv0R2S5AAHvnWAz0AAAAKuIAAAASsHQgAAAAPYAR3bIACyAAAAfQEuAC0xas1s/dOOSMi9Xdk4qSVCL7jbg9I0ADjC3RdmwEzd4dVo7QAIqKQAAAYZtkD0FCOWtTm4HgACn8eA7zsABBD/0AACXtyw6xgATB9QCcon4AKHhgAOMFJQAC2Weok2InRW1f0XhdlSTJMsi4CzJNNNJURq0HhkgWMqyJ6eWfgBAcTwAN7C/gCMD+EtMNtfIenfZD2o1Q8fYQSyotrnZsD+VpaV3ZXPe7SusXJb3cM2wCXyzH0adc5Mq5PmzATsJGizf+EaGCPo+TaAwV01jDPFkcCqwS7o7KAAIaaIYkEgsAJn22KipZjXiI6z0CiX2hU7iOEeP++r0JwXFrXq0XCIm3StZFpnSm8AESgkv+RcArJ9Gw3GijWGh4caUNHoskGIpeAMiQ6qbXMJKTM8Scr3ZKvACoChGb2hACMw/hM/NR0wfTWddeMXwFjwPRu4seKBD/wBb+ey0b38w9n+KbTQi7hInn0ub77BMe1x+WOqvyPhmAZ09ULAro7ycq5aUOOQ8sQP2pRvPcOtA8xjqAFEpXt80AAUWOYTpapUqst8yCMnBT/rLy4JiM6REzFUdBO1hgvdklZUJGztI/prKKeoaOqWg7EaeeoNaLH5oR4nQCjejdIUiJej/AMnglkyYz8IKoSrSp1cc/EAAVIoKAALPbDNPfGdeN/k/WBm3kVBGj6j6sLlThh5EB+9xySEQ14WaCEwjcypxr2l203zFOPxLOoPSjYwbFNcabrvwnmRN3FyjICu6rpfGPVrl3ArgurvYX5AAAAAAAOjRjDkYhFhDVbfmt15P5B76jijqOs64pIjHvqxl6SEgal/vTcLX3Hy7A243Y/laPA+R5uLLQjpaVlXL6WmMP9y/5jrxtz/QnrSQjPxczwqDKrYO+I4+AAAAMTtXuWbK7KxdbLmq8grxwvGi8b+M5jFFviXmlL2T4h6m2u9LizcU6g8UcCNk1jTZkP0uKEPK53v64MZxTh31yK8YKcOCf2iso6PcGWykayPCEpUiOoypXQB/3v32OEOa2R8S4ejoX3Wpe4OmfxTCYlDBMQkiTqJDzoCnrcJtiCKeQA1msGA7NyVzt1Ie+xt/2I4SBJTwGkYENSQT+OFeHTHQU1qSBPoREK7VZSSSM+QNiwBQuDNtv0l2IPxAzREzPYvZkYwpf4p1ki4qg2uG772jWSZQU4OGhYiSbsulahps/wALexV74/zGgf8ABvJsgpJNz7EVdtAktQ3DMEdnlJ0kLAeHJnhuHRxlfJgaAFbe9+CYKtKApfescmYhW2/zp3luY60aCUS9wNx0QkPxKLd2A0uG4ztqW/6W2V3vVfTIh0lsgJH37RjPQzhja40OFDGhorvJHk3H2m7A6QiAk6uSFuakwEBfAAIYd3P7peIHpvmKJgepv87lBf6y2NSVSccS7JFsUaiAjSpWPoXUMpNAQVy5pPy80VFQ9FF283yqXV9IF97PaC+qpOFpuNtZrDbAQbBdID6EznmVWt7GhLv+AHSyW+78IDvMe/32vU3GbpKWokdKIDBPVJe8wyd1wtlVgzi2alXYuvftSGO3o2lQW7w9ciX/AD0bbCHxffwGpnHehy54y5CnLeT1I1M2wRf1m5GMmMLTsAAAAAAAAABEgQW1Fk5MLMxOrhNb4WqI9pcRc5hxayI71cdi1RfFLXDa3DiDi0DG8qEvl2H5KxHv626XI1Jpbym8GBj+Fg8frnGrm5rJ+vpPRhemtGAorJypAAAAAAAAAAAsYkwhBR4sYclgtpQ0o80ePNEa7C3rc+HbIkUs7EspoZchl31rXyRa6wmXxDNfxID4TcaoX3cl13U0ngZeAOA62Q+R6fGWv4XAcX/5/MY1k5S7JgsoobSSaTYetBWjdioeqZpE3oFPKcscPx3gPeldffIL8UROqIuFcQYN5nl4xaSfI9tofqqOxxNvHrJwp06eH2G94LhFsX/SwgX5xouRd7xihxeD7GeGloIdrTW2JF3D262VQZ9ZQ2U+E0LE2x8BK2o8Xy2p35ItfKZZkdK1eH0xSJ/fOYEpxooxdHklFDWA9TchLls7oGLdP2KcPJgokZFvixqs+UZhtszXT5G2kPUH9plEY+QK54KBaz+gt5XI+J+sSZ04A+PQdKCrFSRh4JvEzCSoc4cFbXLdKOR/QziZg+2FtRzHoxtTOLEiTWPwGuU+GgORnihweCQIEhHfjPeWrPZhDfeu7yOA1M7uAj9QZ+/ZqlgCXl2n1seWs9wjzFEvTObkUqd+nAJCoTSAJS69E6mz4LH/AHYKkaeDMDNyfw6BJ547RhZz4bq93aG2svZE/rkBLjuOUWjhLbRcf3mzIor8CMWVg3GTQFR3LubkqfYV7JlrGaVLlUsjacVLBFzsl1t+aN5cIVQzDni1lNLl7RJrJ0XWe1ZQljHcWd2dWcG+olq6AtXt42bLQtGgOmCvqRYEECerAe0nSKirxM4ikwwzj5sJJgQ5jDoAEGj6ibdIw4RIoGUxGQUm76HgacO0fXZRdWIeJRB6E2lkAW/z13rwkCqUIX7MMg47rTdM50NEVbfglM30jI2dURdG6X4UjJoEAJrWoaVPo6+pkmQ3ae01lkEqWp4YSLj5AQ0zq6xYksFjvMXkuSd6vq+FqLlYvFMjbNFINMItbbBwBy61XEOV1YZoQRSo1eDvBNJS6d7BBzUZZ80T5JDnddXYuOh9MuSqSsuJeeC9KvEDpP3ayKqb9Nj98JpH4RNOuM2dYZK3BfXnqoWyIbkDj5MHNZfTCkpPjGg4d6YpjLZNY4ro3YRpNsN2Iy40Q98SZU9bnQkfalhzEyMIKGxT4tUYhqzfZVpC+RZN/hYczS35ntT003QyaLv7fIbDVw1W2mpqF0ZWycP7MNiSs2Z5aE15DTNAF0QaB4oROqyfadByUBzewLnPYTZtdLGwL5PSFKFPGf0xCOgLczkkSz31VBfV3j7EyIF2Jl8mRekYXrxiPZPAsb2ejQV5jiQmFs6fPStgrvI5077VTZE+LHZUsdx+0MiKce1ax/zcmdmSmSMnxHhNbx6V5/pSPG9VleRBOMPor/NbDFzVbQ2O2Iyp/PjySWnJJU337mZgybNMDqL252jfavICqX0/GLYfPGmrDDnwwkQ1AO0Yy2kQterXBkxO3av/AIuuHQkKPZ31QsSBkYuXCULSN5kYmW64bMfvq4e1U+tMR7ezs2p9J6fzY3ddJmUBF+2O3x8xRbhFZrJCeh6nFp15Ul0/Igj/AJq6kqNRwsfKXKGmtrASih5X756qvXtrYzh7nfKzX8BU8otDoxUCQ1XkGAFFFB0G2Fti8LvxXsdhg1yRZAzGksF3TIlaOdc+UUhbrKLZRleXE/a4hCZFHAZNKDUgh/WpG+33UPVSr44tHm9JDrr/ABfmyt4oxd6UGS1HXOrxqj8naIuHYSSoiir5A5aNUxC4WevppBHCLd/nfEQyDAhIdciYG2enP2YMIgEnCmzwANu8puP9BQXSiLYokvJEku0Ev/BmAVufzRKSPFEvGH8JwKBwAB5nnplxtMPBy0CdwraSP8eray1cnTj4zH9q3TbRsmJPo3RRkhXFkjNr8TlwW0kj/TGkEywNqr8346OggG6x29CT5OvwuM0OjBNz7SXBKrQZXV/pegRhvAejohfdjoxR7GNlPcx47apZmxgcpC0ULcxzXOVj8wjloq/+O1dr+vKAAo0P72RIfl9w8qaniLVjGhK+PNtPiSsX2Vaof4jGCL1aeTuFM318brlzUrerDHQcgNBBJM0kpmgzGadhvph+g5b7jSBNHvcQJ+OggMi4iiRa0yP4fY0pYrGzkHCZCYk53SQP8oUfPOCGQDklMbp9q6Tj3GeroYAvWFP6Z3o4gc3ware86DtyqedDgpwuNHGrZeNDO5je/wB5HQZ08UShJW9YeFlV/Z9B07eNqAoAxlLWwSfFpujo4UBr+xc5Ib5twVLZy9uQ8bzBkDnYRoxMyRjBFDiM1013tOL9m5UbPq5B/BnPXAM9K9sN3NFUE5TWVTqom2kALNpNRIThc7ZIgL9N3a332JzhCykfT+RaHrnpSEKJNc902KCf94MtEf4sA/v+EY7wjJkruPJfA8O1pT7gN3NzvXneQ+M0/MuYMXNodVhYdwSrQ18aCU29q3Wb8b9Vy+dc8qHdwWd/27O/H7YmpuDafXDX00aw/tQ+Xq2zXyeWgVE9rRo+1eNXarxanVNzrQrUUviwRuwrYDT2MFvgrTbUld8NRAqWv6TvZR/Q/wC27i1owStx7ZPreJBZ3AIOIlPPCAl2sLsubL4GmRMYzbV9ZH2/PSxDLfsVnKJh7TgtRUjulgEKa0iU7quVBURwOKhB2lRIIKCXGAjdptSEXxDW7wyn+H/xVua9hLBKsgIVg3rK78U/xJl20dYsDR5WecsuiWALbpPv3FWW9k+qU3VcqYrBapNNSeY2R742D3Hjb/xqZLMxUVvS6uyz9RrjWKS+F+sht5T1yoQrsQoS9h3kRckBiPRi/MY7subk1zBnHlRi4yPwz+ISJbZau0VMPTIQK5uydHuyYU+m8WvB9UyqcWZXKvq4etrb3LUhSE/jDmI1t9cKrxMJzHpW53m856rNI0NsgJbClmVRcLbaaCqo1W1NZAD6okCJFCoH4LADICY3/gicza6uE+vttEpE1XSDUXJTJ36j1xOTV8k2B6ZCs9blNQFOzqoNt6t04SqT/K5H2Dzv2XYHJnjWLSrTLBU1mnIL3WKcHsdQMOn5SDq71eyGjnSbR6n21kur6KLRFe9swpoBHTS7ZrUm95NdaqhiDYa+wDB297dqwTtY/g/Xf81jlKgYTY6yKcphOumLYz+H46gLhIJJZVvSMEVBE6hIkypOicHGKaCnW9JA5u2bE/8AdzD4GRM7q9qv3PiDYXxtJDxjBPP0BH9MiHkJngrUda1Efves/Apwe3i9VDpzLybQLNZ+NUYsi8ARr6CjweWbyBgIcqaQkRdEAXPCubC7g8u6q4Zp5FC8oYNDLgtSFte3k/XWlElcZmbq/rY1ldJBAZK7KAogZeQmBFWecvP48mufCO10ycOmHrq8rFFvnVgUeHFF24EyfIMe2gx2jR01TaukSB20+ycHro610AfyscsrzI/q0llyVthysGn6TTwzCmS0jw/h7NP4qdgC56qinvzHsCv/ABkyTp49LW5TrW7Dt6l5h/8ApMp2anyXRcVtYDVIKfixC5YMeTLkEJEp0pHP0byboEC346vQ6uuCfzNUSCatL1UaFFB2iOq3JDrmSM8QetWYXZPs4zxBTmp3CTizLkCW5CaZAZhqfxSGImm/twLytjTZ/jP9wHF/QPI1THGpPNjAKb3ZF5C9O9yfIA8+4Tt+KGTJ40Fv0XS6O+4nq/TXqGUWR8K7wtgsi4r39PBkbgI8vpYWElLqvaB3c9ioiM8gXBbc5ktdl1kd0o9Y3f2z+b8f/dvaGrFwxUhXGIMb0BiosQqay1X1BDbIdbxjATM88LiJShuo1uS/BlD1/wBFNEsYg3GqyLB/DGpfTWpFFbh2aB/wNz5fkhYSJ9UgAmCz/wCoqTwszj9dlrssjqf0LH+GXPIjpt8jy4wHlFgWX/AhvGGvzBR80QE2d/4yO8ZBlqaa4vZOl6KCEsUNQENlr+7CBdxeRo3Bl0NvuW3yZOz0KttUD2aTcmByhBpf1n15RE7ZYQ5a1R6pLz1bh5sPl91Hz5N5kEC4UkejJqecpJQoxQfDZvw6NU4ln7NVMTLIp+6lvkMMxpN2fqoeA7R6zO9O1Trykhrs09EGWSXH5x94Q17pg/lo60dpi1PO16oZ+edwZIfW+wrWTqw8vYvZ5Si4O6xu7GFH9aIFLDqv0czTkR+Vsm/PPwSl7ov5vsKJPuuNmpJkfWPSWk3MLU0T0fCQOmPBCGrNg72k9Foc0tIv6I6q3UVI7bfinfeTP/2FTnZiHVyGyefHauVLrVcjSKw0JJKvCET/APThLPthJmmFH6UEbgD8v0ulT/ozdN+mATj1LwKEgQZxAsodaP7uWgy64CH4HNIiDUHk91RUo/8At8aLfCcOpehAYhcJkBZ1Lf2hrIWYlzo8kCTDVm3eh88poiqEXSr+G0TZRGwDYlf+ZeRgWJuOE5TtBMNbVA4jzM+7DMPaFLTfZ3NAC4CiKbPlNV0YRvit3HhoRi9T4pgMveyyq7D/AOGe2DZBIxGswU3pEJ6km1SLY7+t+qSYIqxmCN95LZH2Bprhu5PVRJfH1/8Ar8F35HUo5vnVxIBcLnqE/l+P7zLHHTkzK3uJ86JVmsOD2dwlTRP1i3hFkKQDhoSki9IbzmomLD7Lzng0fWzeUCoeUeoMOYYMiy/ZauyNIWd0ia2G1sQm3ZNqD/cmO+KYCwpAvJXcF12nHopEV1aBGCUq5C0pIo4oDuRwb8SZy3teYHJ4vxqGEfaZbxork0Br5yVODUnW2OyQHkxIKXI6LO2S5i2o34kfLuSQ3aPSUtSVDXYCHg9HDRwJozbCcWlsgxmJ1zZelffcxsePvpY2nZCR3tMZGSD+MuwEyJrBqrc8BsioRINs3LLLwPSoqK3hKzTRTog6gI9tdlBJH7JuYtDQMJQqd5ANkT9xSS805LQOytjQf8TyhbEABHEGb+6dlLIt1XmFVPNDeRT/AOeJFu5X0Py5kAL8uaeVFitY4x7fV5DifxIDMxzhvYh4oDgmO4eh6iFd+sBn4Nvp1m6orKaGDqsm32E1rj3ReEmjSULe0gRfV9whTG/tFL1nLYJK+VWhurpcxmdPRc1NB0i+W8B3/ZZGe19iQKLyM8Prv6mI9y24J3OAFwbHprcO86r+MDevD5SbaBDAWoEmFgyzvwFSooT7CcBfQLECuR9rannTFUtyGBGm4CRrD53A7nWUVubwEXipXRP7lomId+KpR+zGohV9loff0VCIwG7IZUJRH2kXroJtl3ZaQ3KO2xqqrGpvO70nHMmwzlrwR8XFk80dlMtYt47+xIDcJfB+mUQ/f41hAqi5i/NmaJVv2SwZAy7hAuqPC214za4RgD8noB3B4lblqOSbdxLd98deie6PDHW47a+TlXF8NOyfvKWxl4cQvMBGIkowcTz9h2L4/wAyn4AsCdy7XkoOJ1ZNtiT8FoRngx6j5gfJzOAnERFdSrz4ZYhH5Y9c7M9fIF7Ns7P8xsancLH0w1VAWATB80FmkuVIAcWCa/8AJQjnuhhjYYBN7/6O8IzbKdbaSX83LEviyO7QTJbCDrsS0QHeW+idZLKHIi2pU1yVyLC2bU4TTYTCrKRN0jbLAzvBWYwSAuZb8s1olbjhzIQxS2w106pAZkeoEYpalx5cdqLWFnwrXrcBfcJxqhv9Q9xxllhhKwShXoiVcjP2zMd8bqFu/YXXa3LEhJLTcvGd4x2xeXND1bXp/FrJ6WO9ElHcPXJvxttpfBs9lxDZTOfJGBqR1eTZin3YcLHWk32YiiF0MOEgM6Yt2HqsiD9x1XlCg+a52pTFGnJUTtgrnqJ0wjVriJAOUd+mswLNeq8hVwBqAvf32y0qx2W/SSDcHS0bAiYBqjkgsRQIx41SSuTTG/XT2RKsnbxlVanfCGPUL21t2T6kPD1/0COn37S/7WCEapbEd6Utguqj7k2aUVc3G30zpBOcex1ZeSslZPKFF7Vtr3N5f7k1XTGbyJpecSWTIgL9F23b3OH/AOBOJ/lpgO21PBFlwgwkiVTauMeuXk7Hrpbul3EWB2nD/Oe/5gaMLOo+Kc/gd9b++ECkWTr/2gAIAQEDAT8QTKE3fwOAW7MylUchwUtsvdlgxhwJG5mli+iaZQ7oU6RL70KI2FLRLXt3Rcj6ZlIbbSUY/B3+BGgdHwMSES8sawSVvQ1Ck+TgdYzTYrJtOLfeRKJWsLFCNyabpE3pCxLgRMkcykskuRqFYDW0QlC4ZgE7QksjEjbbhoRoluU7GmhysuEQ0pOIS32MTJDy/Y7J06IehgktutJyROKFU9kkbIUoJOJZU5kTYdHZDObQHTzXAuDlmOBGmmsNgRqdmssRps4y9jIE0s+w1OjlZP2MZcpQI5iEtCkm9XQjMqItIbXRSUOfoVCVGabWEiRKJwQxKaHHRAKlglNKbP6GyY+YbcL2fsTsWsKGKKFL/ZJM4d2EuFEr9wUylLQ3sbmyEYtzKCSJcCMVcwgaSJy3DJSiOywbOxtAnm2UDSi+BWRLT30xWz6oUu2iZmhWvoiWcBOnskLlwioW8qiGYZgfRCGnFkt38DTRDczLHZI+3Qko2pb7ISlNPLHDtH1EnOBafIjbkhJ/IllpJT/4JSoolwQ2kvCbyM56PBFt6jRa2gcIkUtmOCHKSWnocqyeAVVoy9mUW2y/YsK09iUNE5T5LmU4YqPCcEIZWWOUTWSHLW0qHKRsrCQ5aS/aNRZLdPgcGzLtPQzTR2IkJ8mx4E55exU3OOfQlcml9Fpkkzpkl0JcCsbGfsS2zeSLJM9CRtBHwsqqW8EQSq20mxykSHOSQU24HSsp5JRzOQSk7tP9MWG2opRyJL0zgUuaErkRO4YEg9lMEmnSYDTciT0LMFVSbRCIbSbt6DZEuXMv4Gmh1mWhUibN/I4VKuRxdqiZENOE6TYpbohc5oScmQin/wAFRsShSmaBCSuRS+XaUUX9AaiF6jUFCXscHl+gkLyyGyGDmR0KW09+xRCuakSaeRYUmZlS0JB8ghs9NWSRXiNPZJUkNe5YQ7TZVAsqG1SkSEjL2RJJ7GEh28jUlDmct6EoflL7JSaLw7KTO2xoUqlwI2lbiMCtkuLOCVe1aLS+EoY4dEBqTl4EhJeygm/2NNiYtcdEYasRp8KGwcISZZM4ESEm26Ur7CUtNRYk205WJEm250i3A5eg1Kau8CNK0tjwXM5RRpb5MmhJqXmcCTbactihCewnbaOm4sRtt60FsCC3yoYKcnbw5Gy6NLE5kqkkK4BskrtvQhPI9ok0s7Qk0lRy9WKUlVCSaHigy0w2MbeBMSmqX7EmrT0oZyrKSTUtYwNSk9ooTZRRMsvYlDXyFJpK5yJXTmcsShxMrn2SpTaEplTDbIJSVNkNtGogXJpqXAlqtWNkPaG5lvkxTmX1opDt/AiSNO3ldjRpNhE+6RyhSsvDwJUxpzbCcPdlJiRnNOKdF3kdOgyZtU8n6JVsNK/SJIKRS4IWUEo/6JmteTBLh0IpNTO/7koS5ELcUJfpXBE01thDykp2iGnbbWAaPSMFw7FyToIu0odZ6RyTotvZaOBNKX2aSZiREGlQvsghkrEcyI0SVR/uW2ppuLC3qdEOClJXRC1QyvZlNUByTe8b4Ek1jG/QoW7XOQ2bPgYjCiy9kKIKUS3yN1mJS/0Q0sei2LCtFD6DWq6Guh5DbxtEW6XUEVJg1S7Mzbw4LDf7BYt40lihJs98+hLVGXpwJwaGyX2PEYRKWnsaUJETlcjUVpjkGoUFEogaqmp0FAJ4GyZSPXAaS0G3mVh3suWS56plyOqUtbEw6uj+BtOITyJSkTSvsU0SnFoziOCJJGGotGEupYHbWOxRt/RwWJ7a0iZc07UDUubmMJoQ3KIUglLvLVMK1pXSehS7TiFv0Q3ORW+zUaqROBDK+yIW645kacWgOLUptbCEH4UnRDToc4HcsoRK9iZOstL4MizXi4CTa+Y2tNaGKxzDtJDadTWZG6hbLJqMKpYk1+bsahKEtT6Cx9UDpxMhcc8lBDUiZUwRYt2T4IWSeDIkhyiC0JN4SnYzbiEX6CZtoaay+RusUkpbbHDSXHHJEKFaT2amKbhCtQomhowNh45K3Vg2hqHNTOaFmuZqORTjcJoy4qXToSZ4TVN+j81/RCgq1khKUcPaFLga7GoLIqEQ7TauQ1vSi2Qmlf4lk+yFaazaRZ7FaNSZnSWIxKbv9AlFuIwnoWhxD9UWjSml9xUtKlmFFJJq1yUSVyyiORJKRTQ9iJpOeQJA94UuiHIUrCNGG4hqiVRpgat62ykXYt/IldxDhJu3hhymJrLex4lU4lkwlRyhKLqtrkaIsKn0IrCTdEEKmShtqwjQ4yJnQlahtZDUsjomSZFpoSc9hbLkBM00Q8jlHBKWEYVO2hJSqTwHSN8o6JyIa3U/oGnHb9DbgolJRKU6nckHaJWxDb2TpiV3MplMWbqcCBOGskwbXt30JcIrRlHGJ65GyQw6fyNksw1NbEaJO3qNoVsLAiF3sS4IbdZqU+xzKfamK2zWAk0aahtRtWcmZGnTPwQ3QTWSbrgNJYqEFAnl17NkStOiEJtYGyeRsLgSvNOHtehNOKMEN39SKT54MhOZwroJ8DpkStU9vgSaNK29iw6ot+zCbMooa2nXJklZ0nlh9haDVJ7bCQ4tu3KSFBwk8RyRoTemhqXs0EpSUJNbIi2onIJISoa3ybNKGlLIs4WQG0oQjIlbQoQyvkjf/oGohbkxWVYSTcPOUNJ/oKL2WBNM5ytjc3DsKUlO9v0bFXY8Qxkns0KXHJRB08r2NuEO1QNxm2zyURm6Z6FrQ7Sik7YnaLQp2nuiMW2OZ4LCYPu4JwuCkbYxqWitP7G00orBpRlL7SkQ6WhNK2puG826+BSNSnguIWV/+g3EhmTFGK2KSxyzMO2huZckvyYxpUKmmxO3VRkZvAREu2/AmVxJb4Fh8yOBtxale9DVNEp5dikV7xxjnljCxhyyY6DSV+x0zwsag3+2DgoSmlTkVzTyKtvJ56GUqzK0iKl4FrgcKhEL6GsDUv8Agiz3C3sbJbk6QhKKIyGk7ONOhE2UJh9ClzMfkLSImHyGuSzdCYMs7WIwIacyDDUNopRZCBuVwOB3LpyQ1cmbXJaNnAyFS2uAWKYNG9N8D6N/uDl4agueRNlppH3HDVTTZngZSMpSaZJRbiz24CUwvYb3Wqk0NtJTVFqSwB0SiGQSVByIng001vbKk1KZSexTw2t0xK5qEyuRLLqmgliYp00QS2nZNCaJvJbRBHeVHA5hNqp2Q4kpTyEpJ4bBjQnIKMpryzIlpNwKfY4S3BjsizaH7iItOGsrkSmYbCTUv5BbJy1NcEJXgWuENRRTZXRhNNv+JKk6nY7FEaMJlZpQsDu9ZdApblT0+S04R92O3KUH3CTKKU02LLyIGmm4R4GKT9iNrQZlcCtLl8RyI1gae+zBsg98DSShuX9gTNyRwIi0vJN8DhwuQuWOKYauWSS04MLkwI4aa5FMbFghFTSifsHJOUILg4Ekral9CglbKuhSkYPAaUqvHYbDJQKS/KU6iGvuPIhROKQthRgciTtwUZQk3aspoKFLsmeAoJohEijTdy6FjEs9ipSVaIhrKcGyaEpYKDk3IModF+xoPRg5UMvka2pT2lsVzsEpnfOiMpTl9LRRNqiS1whpJKJGf9FEO3x0RvcKfY0qWTpCs1CWCJSrR9ENtsoTD5JOsJrkqqaM8hJttpCYMv2LeBYEpmRsrgVNtS1tD27HQoXef/Qk0pyfggs0/swmk9iZSTUzQSbnUYyGzpJKyVxLjQtq6V12WvDWUiJ9/kJXBEZMoA27CsEKJal/AoSu9OhQcJJ9hEWucNjUyxxpuRJOqvTGnMZBDmi5OSTbqHt8ig1DY+RCmFPYsdGn/c3MCWRJq4lskZFL64FU7YUWnMiNMoeBC6AlMNkJbOeGJS4TJJuYgNsMMpsWUmUElCLewotoqBLJKU1rgiFVtYl+wiEliWwKEJ2nslKbeA4VTgKRJ0mWxqWlFN8jU2lUlEpQ1nZknaSp/I5bejg2RT0+BKGmnIUu2yuBUpmWISzLTVexODSKOSVu9IlSwtB25U1gS5SmNOxv7B8zDWh4bWVnkSmSIjKGlMFbEE5VraGlypCgrhpk1KSWxwJinc4Y4tP4YoSZKa5sr/qRJmZIpfBLUtsMUjRjM9EW4oU2uBtJwlrvpjWtWR2OlnDpfAgjTU1M38idmpJPoNSk/EqLmEpNrCS+cSGmyhozSaXgoluGcGnwizK5Tyn0J2S07ZKkm2EKUoyMTU2paSJEyGhGEKR+gbHlYm/QaThsqw5q6S2SSm6YQ0GsLktkxPAhYl1QvQoceiI0LNcDUTpskpHKtIytt6H7IK24E0NFqVSEbIWmN4khO4yNNuShq1ZGVRkRwofC7EctiE2BpMnchhuXikLpcpptLoUpkxb6kZjalzbfs2Gth6ksJvVAozqiJ6EihkL8hq5eFciV0zh2SQ5pimuRxxMPQbOCmqggyuaz8DZimMySzghMpwOJSGjz0O9E1n2K03OV+yItU1RH9mVkoT0gd24k0aUPT5GpJ4TSY5ZgZcUCkkLGIRczQxzadmnc8ITlludFWwO2xvgG5MxrW3BCW1LZQUw6Ww1KaWhk00am0WSeotEXFFYOVOGmAlujAiJJsnQh0DvINXCipoUeRbFU2timl2vvgdzb5BBW1tVdkEsCqBQs42mcsNmyrVoyjQJS4dCIbwWCBptwUugTnmc/gJui3MvpDBo2+Z7IRL2+SbS00/sGkkNrgEJfKOUQklQgrGSTV0RRvgtknJTSx+SO3RoVuSUNVBJFkZ+C4KpZLblMtcDUOJNTLNnaVn2IpnayFG1CTUn7IV0KMT0PNR25HKPhjZFH5EcqmBcVP7Q0oy3ghY+45SyThp8CScLlOmmJbBltkJQps2KG8MoEJW7aSJEksOlVSJQuBZGwipoWFi1gik0JHKGoQ7TSGoxjAW0tpvQd0i7Bu2ihiC43LYlmcrLITSnVnI1ZvoZCVrKIlERFCKCIUsPDMZvNkTenZH/A5LOIiJmOhBJbMlyckTaMGjlzKcIVM2TOfkgzSXK+pMibnZxIomm/9gSxNS1JiNGCbpOB73E4LKVsp8jUyWl9EUjSiE0tLTDUatpgSU2GvsgSShLzBnkTEekSj9xHcuXwISNYVU9jSveGx0O7YYnTbfREq7SWp5JXNb4HLKyqhCS5V6BqXHAShqVLgJrRU/8AiijTE01Yr2/YKFrNBCcn1QmydPAorAnslmrRJ6ckNai1lCWSUJQld26QTOPSPRf7XwEkm1tPKIUJTftZF4sFY5cOpKOGxEproNFHsTHLkiaFCwS12Q2WCK+RJjW0hLlkGT/5IcNq08ehTCVbCTdXPMCKSWnkSycpZJ5IN1sLEnTwOSSiJ2KDhok0UtotbK0QcKLWhw1VJQeDWVr0Qe08G6S80PKRSssdezKS8nbITucDKSjCwY2ks6CZXE4JUNkbSIwTcq1L2NRNxlQ2gxReHA3GEksNjTGLSrJmnOoQoSOGmiEJa0GQoE3IhJ4guFdLVlZrw4+Ruy8Tj4FMMRNYn+iVQkpEydDfRSYWrlkcpSpNoySaFdmx2TjpkaJpGiX7CIyqWcJL9QTC0PVLXJUzKSqJSwkp2lwWQ5fBhSJQ3cyaTeCFsFV8sabgcrieiEhVE84wOFJLV8iCY9kstCUw40WSDWtJxn5GqtY1/ZBq5ZxAiQirFLHyZ27W+YJGmnMPJCQ54eUJQ26ThPUiaeFkSKq4b0Q1tAaIkpTy5Y5mROW2I4CpoOhrSyrSuDSIS0tVbfIkpcG0JXiUYJWUC3q/YohIRRYkUpVbVTiRKDjeP/BWPg72jogxXdk2OwwZYwE1F2OUVoQcOLhFkSm2q/scZPKIjoidrFJETt00xAkNGlLEYJKaJ/gZgS8cfBi3yh0xJHPQ0oF/gIieatyW0oQ7MkS7AyRpWEQ0icTCQ4RS2pIiFtJrBNIU7NYERXKm0Jkmp0jFlZUeCbFMW/7DJJhSkoSUlySaiyW+YHxBTFtCKkjcb5MTSZgakSoQ45FMyHEEESp/D5EMbv5EKDUw09kLTfa3kQrw264T2IoQvkOhtNvQmSHmLYkmklKadp5Y2huEzbHdNFjiU0qix4cLfQmUVGhZFCnlfcQnGpVoRZY1dfIpkMKFJQ5VexKFbwK5vTZEGchPMDbYK2Y1LE/2E2BGSaEwpFkcX6ML+yFI6bBY2tVBkSof6FbDhp4SwQJNvt8i0bYk9CqHqrWBpQL+4JJTTDlvdDgTS2liSkSWkNG0sNqgNJNkmpQkUactUIi1uVVLhIvILES6GjwjKbxwNUtcGlx8CVNnDVXyyTW1V9EFSVJf2IghJP5CDSojKKJFpZjIrcKjCEShow4yNSZDih0WHjhbszuJWb0J2Uw08MSxf/YoXV0bQiacG9GO5YacilmCZfA5JJU05c5Y2eQlyNNwtQsDJNKysyxGMNIhYq1whSGU3oUo1WC5LoHGD0S0puqQxzdtqn2Q4rD2xM01tqIMRKNSxvCxtzwhSXkvkaQmlCVhpKBUlIaThcbGk0n6CoZJJ4gi3JhLAmsjZRg2ZJ5TkUNiRN8MTglKKlUhNkITfogqLTLwyE1SxkcGhfIeUsEsp7GnMvaBqHFf3ODAYGvAkUecO01wJE2m5WBCeT/Y1HE0pmKwpuScNJbWmOUqNW5JzLC26IPZSlsaIhRGY/si0tpZQ5GkCjSKnwbGpT4FkKngShxk8fIkN5tEJNMvDeBO6y4hN6EyRQ06ZZVco+xDtR7FRJTyGlUsFEcLJDMGoaMtCzMQm/wQ2aq8cElynEipOSZxJEU7BTDRhUEqbGzUIlWZSFp3yNykVGSxNYSsaWoVyTnMrhf2TcxCeEh7MPECcr+DBiVCSweSC3edErsWC4eTVJlNRTb6JwOUzyNqK1bZBw/khw7Sc4MmzJwm5caKrgzhOWMaEyV9haQok2xra60izaNZSGlN06ktLWsrHbE4bWGNp0TiCd0YENSipTPJCFSzhPWyR05mV/YlotZ4MaEkpPsIKSzVImdLKLdilPq9Kf6INtnC/cjMsIQTFkQlSL2JPSH3G5xWoOilHAK0k63mCjTcrax8jsoWy18C2/PI2STc4mSIVu5T9iRslSU2lbTHbSWD6EijckRNLhJ9w7S3GklkdoluhxT+RlAhpoWyV79DpNkvbX7HkWbegqR4TV1gRWtt4h9sgxKyISUBpL/hiZp4BLJsBMjHEWo2K2Zy9htJopbIaZxSEbV0JWUMtcEYGXg0QNWMtrTGoRUOfkTaFmrfbIaih4Sy02+9DZZrKknSPWJEzToixKbRgg1g2mEImUwuESIK075HJJkYII01Gm7aLUKU3a0xwYTKp0NFVDIUHSt1mSTySfEik0qiNGL0KqZJSvgTI9kqInCn3HJTFcQNmuIdSxLdlBEpeWJgianLRHInIV6zyWEvYMTcrObE7aUJ4bZJnhYXBg03hSE4nWPYpJdKrJBol0OM/I0aaP8AljSBH9A1I5N7ggm2XwDUtoT+Aljue+2QgSn3v4E6lJ0sLoZLVCw0Il8Ik2m2sLbKbLTfA2ctMCbuXCQiaaKHFptZYkQiZ+BBBh5fDGoRUTf3E2SVsrfZJQURFtmxzgTNpKNSNati4LKOxClWmpeAidsMLY1LvGJMckRXPsQaS5wxpp0ROR8rK5RbMEmFjhIocNWKDQr6E863DLTtpRbJw+ChGrmiYTyrE06IculLiCyS4ZKGRu4EJpfsGkmncsOHuQyFZ8nIDYrZGxIptvoexU5wK0uBQNNi0UuXjHshtInWh1FsjsmSTNBkIjn6EhP9CORGmyThv0LGUPPArdLHtlHSsgrNTX9DG2qXQlwrGBMxN65EqaedmNmmwTtwaSGzioqhKT+RcEkVzbv0PRvJDaRXmCayp5QpK2XwKThQSvIFKUCLKWhqo7adNiSRzVqGmxqG1yNOVXhQqSCriBqSqLsS1kZFaY6GGyTCXZSK9hRi1TwbO1yOzLWmxKtGhQtZLEiZtiCiLMkqgalTDaYgcwm1HZQ05jAaaaS5y0NQjW8kQQoTyEkiHInixocRBwCSUjhZCykecpPIoagtXAyTp9w22jcwWhy30RECzYW8DVKVPL0VyGrY1DX5YqTaeWNL3bIklbYnJtstLUnsY6wYQkkaWItCcNmGoT0In5D0mn/0LSTVtsba3kbcHNb4MOZp5MiWEE2oPDQnDewnKwE1dC0OGkedMlNNPoGbZU2kN9lU0QK0rTGpR+UOyeTyJgXSaE3h3gEGTKDegktnsXQjJ/gZZt5wG12Km3/LIkaJwn6kBtoTL6JF7xyhYSpnsglo+4xiJXCp7kmC0tOyKSK5Reqv6MNyOExx0XAWVOGM5jk7XUjcy1pjiKj+b6MYjB6UQG6ETIhyotbFa4FrkpEhUy22NlqKfKR0ktvwGSpWIfAbmk3KxwYcjXBScksp8FjZyn7noSszaRKG9DYR6ErRIbS5+vAm1bVNb5LprDJY1YduMskpR/YaoiiKjluxomtckOWVKbwNpCUBZzULR2I1Cm8PiRorYMbJkU0JovhIl5QkQYcEpKr0FNEJjlrYqYwitzwXCKay5FJGk9csdJLBqfKR0mkmoOUNE6RckNSrpcDZTK19CyT2roggS/kTZI224JcOxXazgESzD+CIi20NZfRJHdOUTgNnY0KGFp2QFg1R2PMlqaGiKVcIIlGBDg5S5UxxBSBZUuBqcczhcESmpTHsK7fEL0kw/Q1BpTTPIlUqFLZRQ0tPZEQpUwOVC0tOTBIrLQ4JxSkElJ9HiBpobDuBpzNM2uiTNn1nlksthh8E5LKUnwJltf0pBG8Nb5ItNUgN2po245EEETgSyqprsbtp0HJi+hOyWGCEzzSnaQo26HwPPJ6TTEraCGeHYknKMEcCUsASiaSU0tbEjSMIrfoapLHIIVYoahJKPT2QrFB/sOAysoRcBRKxXBJTWnZDV7m10K0GMuGyMql7f2JTamUpBIzhw/giI0Gt+hJtQXM5OBHYyShrD2Y6J012NSVaGhwYvgNNElLEdnNawJ2yJqkxWnmeTMvlY4CUp7gpaGVa9CHBwit8xkhJHKUtlFdLX3EoSSKY7GSsWE5Kxo3EGjCdQTdJ00FBNLRwQTnbdroiJZy03yS2wEm28lOgwbSj8MocO9uRKTB5CSHUsuMkJULTkaJRYxykcWtMhJlSWUNKEcAJbDRFIFsPgaw3t6TTEsQy1v8AsZOTlMbCT4HEnXCocCTekVueBISSmGxNrIgih1IdComuxSqhOmXM2Vl0NHTXBGVVgNE8jX5MTSmtrDOuRsKLF0bjuxYQUrMdsiGnZDaasPkRCJhYaGmqyTcBMqcZejGmkbA7YlBBk1rBDlIylHT9im27tYfYrGSldBC/CmJK0QjzykQ8ab36IdEJpS3yRClKC5KQwW0JCSUsDVHp0HIpct9nZluHhLZDa8zaQ0guTByaLtvErASNE0qWcPuEv7BwrweQ5ykcjaSjUZQ8NXlDUFGzEJpalYLgUtSU1LZSDlptwuC1DOZFMm28Cx2JjgKUhlb4E212tiaWVTW+SW6KMm+RpWDbDUkpbQ4hGE9cjQ01aiGh009NWuhtKFlPCEsxzhcDa5IVe2UrLSoyCVJbRum5urY3GDh2fwOSaZQ5UUVZROhYY3CXSxHI3F8ogcJRakNFrmfIg1e3jErbnnn4JmqUVPxpCWXgt+yZLUPDZs4VNI2cYtLHYnaIlacRsaW1qtuOUKY24XoiSaSZbT0yKUtbfDMCtrxYmpJunXdyNq1LYbImqHXxkm6SX/RDsTpMClLUD8inaULlLYmrPa+yK7ZW+AmjTWU/QkZUXKokSapzLglW/wBFkqcJ/ajTSatUt0OErL/CTePLq4Jbei4CaZ0YJZXoZfspt9CbGSaWlhj5JaOVla4EhTbLhRBQ7PbWkNM+0NZWnnhihR6L7MCSU3ATur1xIlqw+wKG21NtyNTM0JUbfAk0VJJp+hS3Ik6NIbTkvBoRK10ElMLdWUnoNrgjK2q35GoSk98FQWU2knBTFpKJbFqW6dH4FZLCq5cDaU0qmeejLKtJS22LdEsGmxwiKfgghzN1teDNu6/AbV6eBErUjbCHRZNh8McKE054DUSbtXA+RwlPTxsJhlDAk5SYZKfI3LYNN2qcxshuUgmUhSJ1ejZFuGtokJpKarpIdiKdgmGqXzOvQkipP9xppKCf2o1USaK2XaIJJX/AOBGzothC4MS2BiC8qI5TfsSm6SosMUttrjKY+RJq3m8oUbU7M8Ebs2VoiLywa5SXdexfiHYeE7UzgXoIbSI06G7JpLbkcx4RKfIn5iNCUSQnRx/ZBPJU0FFmuUJ0lJOFhpS1DjSFhwxZDhpq++Cap22XZEE2G65EklbLoGktsnTieUnjhmV0qlMaXavBcsSdFi02NKkrvgi5t+gSuW0rR6Q8SeHgaKIU5udMiLdvvgglS2OBIieMf2GUS3sIShFghODCOfZmZoxJNqZ5UJK0pymRKby+4WobXwEDpM48HUDZV9MUQ5vZjTUSlsdDTShqaEXRWOAXIWTdCZt2SYF25Q9Gz102TVpCZXIobcbiGiJ5NrghtKViItLYaGtx0Demkzrpkfodi0lKmXDEQ5fDHKFWAS6EtN7G0uUkqpiTawkU2AmqaIyW4hr9iaNOURZwaixEyanZcEFaXL0Ut+jgRWabcdDwJLYY0UQla/2UibC2QpwbYajKvhiZpa35JC065JZWHyCJy1wBXErINQoKdkQzcS8muB5E5bKehQY4fY1EGpWHRCrEyFKqMHbjBh8kYWkwXaSlOY37GlOIV0uTKGGEpyocoSUt4xaFEUnYRo4LKeiCN5dChYS/7Eoheljbn4DHw3HD38EbKBWNyULbfPBLbadPOxKb4aIWUaTMCucKtDVngl/2MKGlla6JhOL4f0TBNqV+BMKkvvgo4alvsIahJUgrT5LEt2hJc7geCaGrXYruIEOocK7GbPn8jR0a+QtLStiVZXt0xtK1Zn0TFz0jKDa/oG3cJak+B6WGBMyzpVI0UtZYIJYttDZrg5aiuHLG6lZQIbnJK+gnlpC30IJatcDa5nJB1cy2nohI719lN2nghtiLDPZmmpZsO2EmUm5NiGBI18KQvexI9buQQqzd8xg0syyRRSmE99oRJTRDDUsBFNqGgmcVNa/oU0wn+ROxaR7LJJucaY3dYU9hOhhlMbcMS29o1sm5myTT3FJA38BJLb4PoU6TehsqIS4bZTw1qB1TI2oIwqyR/gbcDg2N0TR6A6BKniCeuprlIog5Ry10NtS5TMtvQ3RKrJ2QdsyobOW9SuRNIs3gYoXcNhrLFCTdbLoTTSTCz/QTTsSalosEWUJEvS+CyBLigptLjldIckah062KHOYpb2KFRTI7m5EW9p9ChJxgyJwaZqOV+RNw1wHGtUmIZJiWSgZYOMcDok8qktCV7itGjm/BEsiUj4E5PBlIm0u6aocLabEKBZlkKpPmyJXWErSYacDUIpFlNQeA2dELLdlloOYEnMSWByJTLwJjTdS1diEkwyxs3sLfA05fwBqbwPYh0JyOBKVvVO0RKOpvZeE8y1jCnag0NCWEhpNQkuNkuBwmycJ6w/Q7HoNVNcpEKlS9ro5sN250TgXZkSe5WxQdlbFtGB5FcJpVNZFId0Cxq2IcTyiEm3NQ+xZrEoco3ukELgTXAkI1z8EHikpgRMifL2S5tY+SKvgSRVRDKEVZNXplwVTqWo4GmIlkhtox7FCWWloapt4FJa5uEsgsDkRJFayKHendogp2fISU0sJLJJ0SK5aSEEyUOFgFFohyHKHULKJJzLByaBciIXZXA9y1SGkkMM/A03Cm5fUDvfdGNRraETuZnApFzVPBCa/cQiHJRaVCyoGKGccQU4ZJJgmiZXBCZxhgQ2lCjEbUyqGuUhIrS3p0KNsN229DdUUzlEyGGrEtO2RIpJu6YkIo2CVLU8tmKbG5CS2rJEQ5KhchziWgd/YIhOipldCN1qNei3E7YkqFKWe2QrpzkjIkrK6BJNNw6iRHEcBikmSl1wKVqByqeDA+bCG3Gcz7FSuQuBFQQbSWmZwNKWpNrJEtKqyxKUcTY7TYQlccElkYekxrMoWAhXSmqFJe0nyLIpoMR5I6Qh0xiRolahy3FUymW2kztMc+q2Q3KJTEa4dMheg2qawZaliT4Enw7B5SIjQzZDVtwyW3Kmpy0whPbvYifcs9JEy4ZyzhtBC5VMUTat6fsTSSuAcE+ShGQU4mQ0kmjgV2cLKKsrgwMMJxq6TJZbWXwImamU+DPYraHsr22NDbb/YyLSnDZdjbRySahYHlTZCIb4KCb0NSuBtkipRBwztWHNxHUbS4Y5E5RVDk005e5Gktq2smUFuWUlHWxFCrJlDadUbJsm6ex5ChYMyMyN5URaIOnnQxprL0htmnrLf3HKIqJoaRCSw0xTJboZCe6mk0n6Er3DbfoQm5csq/2Jt0cbJ5FImbVkdBMhkna223S9Eu5TElFllbY6VEzy10NtG9msMTvhYNjNtLDRQ+w+A4gkvQjIb20siRlpQMZasUVU9WU0hNNBnHAoSQpw3yPim2GXJQYcU701ct9ImqiA5MWXD1JLJM06Eqa2ISuXR7HNdJNrGoFtbUXpcGGyR6D2iydogafCMS+RQTb0z5FJppwhN1Am18aSQclo9jcOIuNuB5Reawxm04ZGMUFkW1lOoQ0I5U9LQs67K4QmmMnFKISbhElMmxlpPKspLqagIhslFUtfBEuyhsciUmHYbSUhnasfZKUswGsiNKhJUhjFPKKOskUNHNy/0CpMnLZ1/2f7zQtsrVMWZFnE8jUM6t7klAfQaaSFzbei1hMhzl+hipxDvwzAtwvkYyoklHsJKLhYQRQDnlISTNJ4BJCSn+BFMbLj5IqZUyq+SEmhbpNiaHkiEyLK+Bxo6kCaYQckms5DokURkSWhSzyQqNrae+hqXwb10OnS3GhMmlSynoMeGpmxZafx7FiU9NlypweBJCdxo+eiGi7TKGrkoi42xiKxgKFKyhKglLKGUEmnUL+zJXLeIEpGTayjgixpytCscHKrj7kkaySuBSnyKkU04qYpEJMGVEWQgRCCbiWk4tW0iVJpjKEpwUpA7pMqY2kpFhwSSabbgY1uWcoTXS8kx0lvMMRkWq4kXYPLehJYvUlNFl7bHWFZW5zHQ4VNZdikWhfIktNpDC1XGCdIcKlzylwJiVLYM2FqyQir2J6GibhnD0JWaJiFOBJxCTijLTS0chNc0eRokRB9xyRzDsKKSWWxG4HSyiuIsp76Gpc3CbiFqBxKo+NIi02iehJh2rIo2pYpexLYPUmdjbZ7HTY4hig4NMm9jUE7bIa8iMlISSWUNWlksQiIacp6QtCUSKVohJKxK2YkZt3CoEg4JSuCQbahCkm0QXx8CZs8AWDhPyUqhXfohLSvTYjVEu5EdCXaImCYiGhxTqOBIkUp6ISlp5Ek0xM6FCVOdCdHNvQyyidcfA1KfPbEoQysSNtB/oK0KxMoNZyHaSSmsoaV4mKIwaQjNJtgVS02KDl2z0TJUp4JOkZIRWA8CVNvuJg9liR0EJMjtqGGRm45Sx4VzGVuRuWkXBhhwy0OyFuCVZTD4wJpnKlP7DGla20IkyRKaiMYnUk2x0noTbZvSS8FCa/oqRTs0OVmktrZLaTVLJIjKaSpjgVChobEGRNNyWXhiUzlUxthTafsgpMiah50xuVFJodIipNEWqyhDgq5Q24ZKI0WcMNQ0Nqlxgm2hs1+DIfwjaXnAm0c50bp5eGxtw2czgmU1prkYiWIY5Io0QqcsHIzPP2DlkiVlnyNKn+NJab4k00KTVVL53ZPO5ZS/7NcZhf9knJMsSxkuxgFLbi0tpisLRR0FAhvQiqNrTn/RCmN4j4GsJ2dwNAymu/wAiZJGWck/YhyTfdz0JpoVzCU3dPhDtNsLBORNuW4bwJYemWnYngU0sM09AhticK0hq1WNK6GrSZDv4GJ7Kx8jRJs8LyQI1Kz7H2QUmD2GaeKi98ihLU8Q5FBspTSfApZ0qKX6GYFFHkUwpcCSFywUaZQnITRLkoQmhW3kgaPlNr5GVsct2O0mhd7LNMk8mG1ZqXsYrrTcJ4fDKzNDeygIf0wMbLiG38RjDtIlyE1Cby6a7JRvi44G6Y2WqG0Iy3+FDcQuZtmTDlPnaKaznTQSIKnq+diUmOzqRoqI8f+jrCWJMzZotyM4mxhbkmErRgk6uNA2KNpX2GlI23yvQ5UeWRYabWmSWkq+XoVNGT9iQ2sUORQno2ExJy4JHzkSlOS3gso6VoiVJS1aQrLklS4JOfwdCSqR6dFOM3L4NEvlpexyoRUhCdu/YaNCmSz2KhENz+RJN1DUglsrrokNFaQlKEjB6CZFKKSE7S0HhMHiPVIYoc0QG1VDDUZCyxRXgX7IckkNXy8iQySkVPn5FKRU6uvsyYbfEk5fElkhEYQkW8VEjvKV6FK75kWSlKVXA1SyJiXW7djlNfKxJpzPJwNKxwaCJMuFL52NjOXdCcSHiBLlpXGyLTTcxaXDE0D4wuyG1DtpQRiBKw/6DBc2ZxAlNTl5MUWxCYSlSw95kaG0s1KU7GRtY/cIGSsEmJDpTYkVq3NCJpp7CVhXgjJLWAhttcKDC4IlYtYXQ8JtOxYk7IHgmm7KxCSJTZdkJ4lLLEobUQnTkSsyhwltsPQlLdK0hWW0BXa9EKII6pcjQlMNRqkuLhIJSVOGYP9oiklnIcqKZK/ZTxY529kJNpKTZNgacRwIUqs62KYK2ItD0FibwehyxxKUiQbtWxptSnKluEwqBBNQvJjd5GRRplNUEoZRssais/oRKT9g5wR2FU2k5SYsDqcCxssQlczoDRHPQjQKWUpe2iiXueiUmkuc8BLJJhrDbSsFLRts1bZQoTQhhszj8gpSyBQ00PAUDTmCg3drTAxo1oM0JOjHBJHzsbyWczwWJMO2yQSVJlHwwoM0psuTNtOYQoootTwKjo2nRHgK09snCn7RRJxwxs03M4mBp8nopTLz6G4aS3tqxyKuZb4JyRCQTJ0lPYq+4Dbl7moE/RlMY05cwZE3i0TCcJiSTV9A54tNE2oZWYEOHbYim1nnYcWsDwG6RS2YdT2JKzrkONkf0Htw3JGD3aG1h5WiEm+kKalpawikOmhvlW9kUJnZKT2b4HASlG/gHxXZEPQ3Wl5Vx2K7ZJDS7Y4TPKO0uHySaa5bQuHY9mt1FKNSop8ko24xv1VkkCgzGTBSrK2xMmVwnbTGhJlkbyKNlio21ZRIIIjNuOhqskSJUFGU9GgONsVgnHoKwQ93AmdLuGZGRkEqu52WzIoa3yJrClU22S0TqbDepamG3GHzLvodA2o3J82RwPDcjbXT0KDmo/ZEpKSpcCbOSn8BPODwKJtU7MptGrhpDVzgKGBN6zI20knz7Di0rshhuhpaWhzQnfK4Es7Mq6Y0RQeZ0NxLRYfEjMNkLSSaZE5tOvxEJnlOIWFJUyOwoJ2Es8mZaq12TBLwIuxtKcoaxG9jPQpLMiHr0MlI5wOCmNZa6eBpMnnHwTMs5hxPBNs1EU2jS1h9BxI3D/Ig1QmswcpyrGpSQy0xwJYNvlJLVYKxwNtpXkMLFG7gkiiEoQUlzafsaRpofDFbWPDLQp2E7cCTRpumBc2ckv9BNvZNaCJJrUWzJVFNFCpcDWDFOwnRkX9EwKKxFHUj1xA6lbFHI0S6S3wcjpTCYcrWxaugUSqHZvmBN2jhpWhOjTyxlRtrHMkYS4CSSu1QOUNJbkSUt8opNPGRDSQspjckzUKPkSbaz7CSFMekVo+Uhu2spW+RdIe34G9qoRZ5ZNPaLXZRlE0w2hNWm4aEVCp5FVWTxA4NK5WhZJKz7DSTlljpmzOXtwc2aI5k7U+xTHN/1E5TSE1baJ+HJJKNmUOCU4bR2GkqwT0Kkdp5UtRWccCJWiSH3OH7EuW4wTytOHwKplgFnIaYIVs+QJWo0+GyPCaz2JbRwpkQjlHBLSb6IITLLKyNGUKzXAoOhr8CVY5a01yJq2TwxZNbWGS2clK+8Ce7hrASb07N8wKUq4aTBLjMVsaJWJ1yJST5DhNdUNF1JOpoaSUamuBpIjVoGoVrnk2mahDfYk2Wpo4B2jhlZJ0KJTENVPI1oS2exIk1UNb7JawnsaGqat8ijRN6bIglwTohChVPQarKnoUtO0LmdrQkk21rX7E03JYMieuSTtqnSSDGcgTlZprLexuyumXyJ/wDAkaCTo+RRJvGSG0GrWvA3JS0DRI6lJXRZmdBbZkshu3Jt0RB+mGRZy4wNitZpkvuTaSZyY2m2AyMTTUcmxhPRhMUfRlyiwOKTdgclqenySycyKblbT4LODhrDJbbWUqSUpdqvgJzNU1nkZlKpiySkmsjZKVT2uRKhXnKNLDDZlDbyL4KNLOQNFDusCUytr9h0O5c0Nm5/fgTtw3jZzu2/RNW5TLfJe28MjSElNZHFqmra5GJMsS4SzkmLf2ETCNO0JJprWnA3lvMRTQnDk54kg3DzgZNwN5fBjgZuWw5ylRl8jmnLs+RUGuSFIw6gVBu08ob+gNCaWDw1lCeF7CUWiHtuuCMObRaffY1zOIU1xoUFoWhiPUNbERM2tOBTW3AtJpmFTXwQJVvacChLSn/5AnW3zvRF4abyu9iYJyTp2UhtKCWLZfM6BM0ZsHOmmnj8SZxLUIcCZptOCo5EzvAFeWn/AKkmmiZUIKKCRSOCFENrEtG25MbXdcBKnI2nTDU4ldbB63byOUqqJR2NOCFylvgTbaTwENppGJd9l1Kzsn5E05eHBOWzXwDgli2wotQlVuPQ5E1LbLJacO2+S9E6duTJZrmmIwcBtRic1y4JmlKJ0w5S2JZz4HJPV8App7rDRFKVc4ehQJCaeZwvQ07NLfYiuTrbJkTa3tiaRs1O0m0igrJlaw9iWTZpLEzmayUbE1Jt8JDaKtIFk74wL8mGYRxuvhHQoQ1eborLSfJLXM7zolUtosKyaSahmUNE4yYOV8hhKWpLJNCRIh5EbjGNFpLDrQm23qXp2JLbS96inFM0nAmsCHlPolK6bbkmLtvmdehtREzq9opkyWpPYkOGs02/gbVJQ5uKMTKCP24E25Tp0iTbapWGyhNbWUHbgpFoTuwmqcIbhKzlhwhOxvQnlb2Y3KMtjsPENyzpiU0dbBZmwNdb09vgeCapieRO3NLlCScrWRJM0eI5GmW8PQaK1aeUSlavmdehFJ3C2il5bDJk02tGw2kob6NklTqAnCkoexg28FpsmF1+/AnKt9AltOHHFCdTbBpCc0CFbXcenwSlS8yKqrBONxsp0MqAJQ4blPLaIScJbwG00TtiW212JCnTh0HdOkzAlTabWLIb7oKW22t+gkrVvCCZVdPQnVZZskTe6TCJTxshKiQnSe7OdzphJUH3IkcpgTLA+trQ0ypjQizlKFUmyyUb2n9kuYcYcEpbaatdDcJQPsJGVPtEQNQm3yKDh2beR04bpsSm0tBsrewpqG9PngloJRf+DTMppymxJOUJlcj6dBaW9MBxtOZzwJRKStzgTVk08+g8il2Z7JgqWxJGYcxg3VlFuHZ5HZfI2bafmw2a6XEDSuVcR/Za1hTXI3mbNZQnLaAaRk0PRFQ1bZBlTf8AoKDd6FXs4ZSFg8bFErLtsbuqNWmLVuNGtmluLEbHLUXUTUtOODZNwksGN3emUeqHh/oa2mWtjVKVeTIJNvPDEtk8MbKmgURmkngNqZFyth2h+zlaHKE6XXI3g1BXgmZRtI7NyiVrgkW1ZQ3d/NMwmy2mNUqUtmRtR22xLN2YbKVbTwxWaSOQptM4bDLOHTRdrDQnc1gFLFPhY+Ro09JguCDlExUDTG1yFunO0lXOdhoypbE8n6Ay+b0Y5djp7KtTrDLtpuaJUdIQbmK8D2VJlaY57HsPNpROUJ5FyEJzrbC4U/6B7rfQxO7TpMbzwww6E5ZWpMIa/GYkmdfagmd1DXSLG699BKG5Vyb4IGVOJPIbvkZCUt9kkCLVH5qLIkSwOqayhs0ncJ2n/stI2VWDGcG17GmUsS0SCkVPfMnEKr4QmkxrZcNQOrRq8EqFr9jdN0PmTbvl7Gyk6yUpVm+QmkylOxCMU4T+yj5lbb0WhuVJcjSKdsH2IgzirobPps1CGbRbbdw+ibd7ajGm2SsDyn0RlI1RrabE08yaI+RTZ4UZRMNO7UuiFCTarJ2JuE+jqP7JNCwa7GjSTyFu2k6xcDaeTgFF+CF0TRKyR9CmaL1YpMsqegqpzJWZ6p9itU6b6G+ThqTIZNG/+xNKk7nQnLS4AJprV5NSOqelqRLIl+ES7KFR6IttIhldEmdPJySkuZqVE0k5s8y+BNSUJth7GgM6FmXwuGSYUUNhMopTOspCiT2J9k4UYoIGDCkTmxiiW00krqhSlXe0xkGWlXskpyMBOHI8HsSr75e+xlg54iC3Oj2iYJtPHAUsyWmhqUESsho7dCJT3Tw4GjhnCUkNn0SuoXBo28x6E8obbeBaxTzOZ6IzRzg+ZYoWxENiaS7wLY2G/wBAq3fA+RPD2pUyVSURwNGk2VgbtpqwcFqeCpDs4wL4JnGktt0SbjnKMo8qeSCpp2LU1pL2nF6Jaqb4expWJZShq2mSpWDWBuCdxGGSnnsaItx9osg1KcGg1OnRMN1TltlNiJUTU3Zs8yxNLClt7kUE03LUdAwJpUaNaGzUn3KLq92Xsu5doaOEzWBE5qSUi9qElP4GmUyORmKCZSilMJaLVH0xInLZexNScyLpNNhRKWC0xplvDG66MlyXt0ex0y4awSbk3CkJicNV9h8kt5+wrQS26CHbqwPPwKc7YP2yVWShiRFN4kJSc2jboUKXRgZcLBNQJ0I2iVJktfAkyTpccDaZNERwa6INHOUFfdMoxJME/oRNOexGY7VJo/8AIbTbUnsUFJzy6MG6cCEMEcQORMlWnyyzSbhrC5ZYmpW4buVtXCNh3T6LwqXoSUF5NMcxbbImkmiXW2Vt2qXJBbTSNVXLZGFiTxAiJulkQaTZzOizhvs0Mi8MORs3Bolg4yLobqRN7kau61lMjhaeBYR06gq5YeDLZe0POjA+h0m4WhMTblNEoBJZTXI1pZsN7MFE3UowJjlEoTkwb7TGstZc2xokG2n+yKcLTVtkuUSffBRG2GKCabsKMothok0qYV8FrQlZITmnTyZJOph4F70oazJ2tDoRusjnZS25G6v5CgcOdhtTatOpEKVNsMpDPInZKe0OqarwLOTVWObSdNYJCiUv2HKHo6OIHaaP+hnaZ5EK1tbIQ3kzyOBxLo7MyeKjhNieGcougmGzpYY5U6eiVJhrHA5FVJm5INFfYOoOAxVtHGaHlhPCOyU0tWfAmdu1aOibO/wFI5y8rPsUpKbqXsamqJUJhmjkfvDgZe++0YSUMtWlTnK/oSqfdbJqIkIlMpRKIiSlEfA3Ds5V5WhMpSgh2zcsdSNNqVFm3i+BNIiG1JvA9bEuLE1FsHCbE5nprE9D6LREGjba2PYstDLJDwRwRQOlGULpcJWB9gTWht738BF8guDFZMvB6saIZQ2oT0vQjWK8M9itDKxIpb1NXLG1Q1pcDbY2Dmx/YdErnBra7G23ByySGzgbdBMYB7Cf7gTklpwGTt4Sa+CCmG0GBf7DyLS0kmzTnY2waJImqRY2mkwiIdcDVwjaKmVES0Uuh3vKt0hPilWhoku4PGhILmVT7FPeayKjKTUIsRybLE7E+Jk7RgKi0DVIsUNu6GTJIFCVbKj3MJfBla1atCmsqxIpFNqV2SS1hl0m8DOCiacjYvJTexM1oTWJG0mDRpdta2PEcCprIyXAyYukTQtWynCrXsymSaG6X9Sk/YLgxndmifsglRslaCM6DeHz6JHBMSJsnOIuWNkmlaQ1ym0JbsxrYxpI5yLjskcXLpLsbUNv8jGigtZNaFglAbm02tEEg8JoQU7tdEiUtUJMbOhtt40sclwjQ23DUElYhpfIGIVyvyGsFcRULI1m1LAi+Fp0iXJErVokO7bFIItZ9kLMtRJsVpBWnM3eyYaPkTCIjLsbgmq/ISrlyEQSA6pVss2xBS6U8iWZRD2Jp2z9GhlkXYTJZG8MZtmqeSZkfRslWqYkoS44GsJJxw2UHFqjK1osjpSUUCJtKekeycD5I9jbHm0+xQc3SfYkrbVNmOlOP+h7ad9iZwOGsyNIj2EI8kIpPRsTB3AbNF4fTG20ySMuGUCeg01sVstcGTA8y+rEilsx8gzesqIE0jnP9lhJxlL/AKNgWUshbNZTkcCNUhoFDKMEm1+HsSRWobtDRLWnaM6JTWOZDrD2FY3wNn7jBtT1Jk+0fahu4rKHF6EydglRPGUNHZS0yObg7e+BwRMva0JrFXOhUorbRa1dz7LDsgmXDe+B7ks3sYhKZCJZWUOkdpY2xs0pYwtjy0+tDlDemuhuFTTK0bmGybXbXImnKadz7E6bXwn7JanBlE6JGdpf2JzM49ir9xQink2xqR8otDy9NjbcbrkdksEOh8EGnKtRkTdMSdJq1Jkmk6eH2KHYSUwgsnLkiQWwkZFaHNNxki0k1SXI5KCmkNFR/HA9FGmOKt7HA2m5KCXBrscG18GhwyXtiGntyzNO9DR6aHJdiAutMWTWu4GkqcpXwdMhG1vsmxxCndQ2vkShVEftIodOhngTSSQnLS5KTU1hGTIi120NBqUMTOLclSW0yybwdDiOTS21pEoQ3Ny44QptbrYsT3KwRApVvY67E6jtIoU+YyQ1RN8DSTI8uirT5GxpZaTTlDcC4E0SaqT/AGS5T0kiYUTavI5Opc6GJpebY5+ZOUODtLK3swpOIobhVhxjLHhu4al72JoybOp4EyYa1ZZPRbfoTeTKfkPZ+UTEjKd+fhDbhNYZHaS72NhtrBoZGhVmHMykNsbokm/LaHISqKRU6TjdcmahO5CbxVLSGTTR2CdDdLSLJ24qFLIbaa2iCJqXU2NBJMMvhFCZM72NWybaW3A2mVqe9SSoE7Bqmo5CcnKIMixQnaGiaGtchr6MLsQ05CqQ3QbkqS2i1LXCY5pEtbbWkOqM3a6Q1pabsHVNsw4Ijvl7HKiZPXyKds+gnDaeVfBGWnUsh6cHpkzUtYQhtOVMLskmXCKuSW1norgcFFXBIjcrjocUWnsOijT9DimOQbSIcNDY7IcNWC4m3KvbFBxadFcosJynolpidI7j7hyjM4uZE4Jpt7DmqZWWMmjLeyFLxlBka2Ww3RpZ32MkqUs+E8FIKE2A2lFOFxyZt6PYliqQyl8CLMzoqQ4ttUT25QRdrrIlpJlZfA5wjmbbGlKabayw4TGlPPA4TNZIJ1TUcuSmJ0YSJGDwZKE7SISZxClLsTszqqQm5HguxyXKjmkNtcwOiV3foaU1fL8ECOcbDbSNU2XsapNpqY4eHlRVlqiGtG61I+QjhjwaIcmkRDJYRLtcCmZZUm2KbLI2mVwMZLvIbmiuw4OnLZDcHJZGigqonsgbTdqE2m8j9DZrAnKejBJI9VzJa7lMEtJc7DdlLWXgbTSlbY427tkFDwdsTymkJ/sbJxabep2JFBOGyJJpQ/IKZvCm5CZTwlwN0wsNRZZO3FVBbdwJJKtqgSkatrKQ5pLtjoaoewNVC4w2hKHp79lJUwHjmGr4KSuzoUbHX5CuSVpGLa2CZpLNYnkwHdBYylU4OrKfwSJGZkxI5WWQNYHbGki0l/JBMVh0QOuJEEkJqQs1xmvgY5bWUiRSURgOQnTSooPL5ZGinlH3DZqCNITWyhNOWxFI2msuBsmmpJ23EDNI7ItibUpvQ4ZpbClkdtgUW2HaRDyBNpNW0QoOSwJts20NpDWFQS2k0coQky9iKJGRCUjhvLHOoxtkuXyy9CRMvm0KDadCCUlTRJKbmG2TUNOrSYmmmnMLgaNOJNZJlrvaGVk5ayioSOxTPycDJRVKsITbC2xRtUeSMSdUHFw3DMNw0bpjlKeNIdXk0E5TWS25JFDsFNJptpwM4NZ2xuZFvLKQtzsm6pgZLZLKsZwU2WJrUO5eE2Nckw8tCUts03g1iaE5YZYIs1PZt8CeUrQmXCJJRJPKc/JdRcIvslQo3HJLQJbsTNVKy0OQd/ZG9EoZ8BtwrNSun0TSMlZOpLQ8LMoZuXmYJN67GbNSWpYqzdPgIMxLLdCRyw0lyGrvSaSnJ3FZ5CGNtwmmx0JGxBxaRW0OWiau+g4Tn6OiZScprZLTKZpPjsT26Ay1EwxOD4h6GzLbmDNsClvkcwXG32NuFDolRUU9fYjSsx9pLU7f4kSkLI54Q0QzrEm43+AbPZa7EG8rxMsbcq2E0kA2pjNcF+hGCRRsE2xHEL5kmjKfHLG6O4mmox02PiG0mkKNeIoU8Z0De6ZPolPqtJa7IeWjNk6NYzi4eCXRwOIy3wKFyTfcgbQqJlc1yTcDh/cJRCo1pktEZZ5DR0kMobhG7kNaDYDbVKr2p0+hNtK1n0NnE1s9MfZlUnw9sZtSlgWRQlV8B004ebfReUQ1mknFJ2Tkbwu45DQjt45kwOMjVpE4eiTLDVmuhtJyvhG5KLa77E2m2cvCfGpOWyQi0mTCgoWykt+uCY5kt8wS00S2OizK32OJLkZqBQsPUmkRON6Ettk/wG0tQ20uENEibRy0OZLlO0+iYcrTx2ITs5DOQlp0Zi1ZpOhkPCf4BvAof3CbacoR8yNqwXHbYzhKJpqN2lquImSbSa0HgSlMOhw7aJSdLbeFJk+80ZbVzGMhNNEaZCiVxGW+hTJzTD5G3AUNW0y4LrSFb5Ksv25GyJdN3yG0ydwgcjNzxJNKv2DpTkXTE5Ttu3PZY2mlN6kdpfVJ8DEs4YBkI3DWA5HpuIMbVpPYbThRNKWuRkFp7CCNzUDaDh5DZNNKnociw1ZhtJyt1QNpOfaWJw2W28+9iya4wbDZWGKUktY9CVzlZdk8RbJdSpbfIxJLE8DalrkNQTja0ORN4+yWRcPghE3XIo9lZMm29Kh9jJSb/Ambd2nQQtQMf3D/AACmkkqyRO04lC+7EsQprPY0VXcYHwDcJrkgla6QNGzKy4Ew4npIEe+Q3EJYmx99C7yKApyzvnYr1ae3oTI0cNqHDFw8xCGqMjRIKHtGLTeQ2ac6Oo3yKUySt6Q248rONHaLR/RN/wBDdtrTWyGgmCmGkWVEnRkza59C0cv2MSUh5DgoVGhmqUnXsG8R8A22T20WLbZS4IKS2wuBOUlKymRbb44Cacs+gZtOrWAmRzb2L5mDW4JTqmtCcPoWxGCt5Q0SFdEpEktPKJpcMkUipT/BLUG0019iScnTLTvDT4Y7l7fPBLOzIpSdNfgiUisk+YGzUHCX5LKEJrK5G+FQsEpVSr+R0I81A42nnQ4tJueHA3ZIX6BQcT6Gt2TSE3OTWOBaWd4T2i0xMr2KW04YboPkaY5Kb9jgklPY20tFSBtqz69BuvGnBDTSRxRCL1AGdrNpsbtVrc88Epy5JuVyzNJhsKMNkt21i6MMdk0So0QiZbQ21b1FlNS6IFTlsqPQpEv6VihE8McPobRpweCbXI2iU+3YyU23sSMwhJyNtXQ1aTY2nkjM1t6KIxRKFPMqj0/YrlJVJhOCYR7EwJudWTj4FiEdr+hRVtsh6Gm+2TJVoMTSW5sjT5dJvMEuW9nai1ZwsaNSRqJ5LYRcs4U8pLYok+YXJaN25XEGVG3tjIldvgwoOGy3oTaaS2pz/oo4y9SOoWXexMNZGP8AY1CnF2jehcB6EjlNbLbWi0PTCwd9C2SKHChOXKppQym9RYIU5Y8EGSQ9/wDo0RLzklYpd4fLIKOgpGhJJp/IQTGDdp0ZS98EpqTSbrbeB48J2JtHFDY7qCWTkS5elUiy1L4TFksrUUhSL5rCkTpLS5LBXzfkaJSVNmKFTa03pEXDasG21aU1aTc6ZKbx2Stky4vQ8mKVw/Zdtomy0ibJZZSOul0CXEPbX9CGxb5TG2tNPMN0hNopsdLprI1SoejeYQmmcJuwvHRf9DSqOJZDcNYMIai1WtcjHdowxBMpImcz0KKaJLtE4TTsQoZy9OSUqbKTHCFM/NQ9iSdTAsuAluhKQaZxJJaa2S3xD41JL0a3/QpblIoaGbdK4tagXBLs1pFLp0LRF2r2Ji0p2G4TUJv+xOElKWBwJrTwM1DbW2N2mcPKKahuOnZyCqtiblGFQhuUKEiCLlJhS1wTDupWFTpatPRkkvYpOQIrlNPWTCljDkShSVp8IaZPcoOW5KGrZdjhpOMT5HpjATnilRsTSQmWexTuFlCbvCs2CVEflCTkTzI27PyaKJfDHVrdZPuMnmCXLgTdqJfJo3+jFsjQU0nDX5EkoQE1QSayuSbNXVr0NrBy3kTJRtK2k1LQnbkkmnl2xvEy3yyaLgchtwZ8ByztB7HASdOmnMllprYiWsLhraINKUpqMik5VNTK1Bk2TCwVuXA8IW5OTkeSy3JOuYammRpSp0m9CiobTakzA3gFiZCynshGJsMhoScDV0lSsaWThmhuVOUw16G0zTCyhttPC8F0J0uLwJtk+V7E5mWV9DbSS4SayhtImynltFJJwd7OeXwY1paM/JsQk+4zVx3yZ6WD/ZbQaTo16GzX30NyoJWplqeUWYtTvklxbU1N+xysuB/Ynh6oyNtJNjBk8yYTNqTfI21aYRKtNwmhOUKk0Jy5ShKfBJurazwOsynKITSdk7R6G8DtlDatl6KanYlqnDfDG3iTQNnZZwJcKjRoejUJwOTjTTY2eK1IRZeyQ32MNehybTEU0SrROFkcFKtsyOCbxsmcrlOlJFLBp0OCSZSyQ7pP42OdqYNtwsINvClZQimaG2DubQ3ZHbQ3CWhbQ21OmAqN5bKGiqZ2HSSy2BuKweQwTS22pKajS0m8G7JKhPQiV7cX0KJO5I+hpYQSTc5b6E5PK3LW2ZHOWOydHwZ+RNKG1eENtkIFR0QpKlUqP0SJIS06M2mkHhoF1qlL2Jp0sJiSW2Y5+ENkYjZMIO1aDI750eX6E1JXSJxbV1KdCapMGqjPyRRqnC0Rg04mhyaZWW0hPKSjJcjo3v4orSn0QWjVqVEu7UO2OxGpIR7QpacUqyWzJ/cNifHMia7lIyNq0rBy7HDGbeaCCUm4wOxXhrHyO4d4wyXWbDgblG1gPWYTYUae03tITls4Yq5ctv6G4SzTTbJs7i2hPOU01FZMHtUQUklbKia/A0iW1sjBY1r2QeClprE5JyJxobNqKGeB052NivJHM9CeVSG5E5O41yRlc3yJcky4z8ieVBhDNkIH2GJZ2Uyv0NETL4CtySkqHjpEKMJSRMklhSklvKq++ES2SIRS52OSaUWrE2bpjB5foVSm6aYqTLbV6JUlMpqiCL0IhIyMNDh7LLgUt4kslyOYm5xNYkaSJROCZwbbWk3/AEXKZ5ORksyhg9oSpsuzJlI0+Q2SUzlcmRtwhm+RpIpawdORwrlLrKz0KlDcrgJEMroagncaNdkVu20Np1KlYE6roYmrhwu3tIWty8w/6FBwTtmb4HCrLoiYluvK2hTaZSQ0TNbwQQw7zISUhL8aIVPmXMDBkWuJMG+F6FDaVIy22oxU4KJXyCVmRLtPoeWlRbkVnstrYmpZGGxM2za2OohqLWRqJUSyoxuZT/0OHDYFdNzw+DgVwINJ1SiVTDWCcph+yZxXyFDgUNWoymH2nsTiXCjaYsmm2a4Jspg/uOFQnhHSG7Ygyk7T0iW6vTQ5iV2J9lU13waZjgmVIV5VDdGnknsSdstW5Kd17TyM0b5K/IS/slbTQuibrA+fkVJKeCdmeBuYZjD1JLiWVvQ2g4wHKQqSpKahOF54MuNlcMXJPbZ+Bulmmg4Nt85T0LLlPPJS90EpJJ5cEVkm2xHBB2lrLIsiWyCcpZeOBpbTbTwgzCkEmTmEUE4Nq89HJSspjDmtPIkpwbG2im8f2RUwm2oaEK2EErqCWIrpwJJs6eGRU3X2GOklTGhEE1LXZEp0lUuySWRIlNtXathMqO1uNxKLDtGVDG0UmZbXI8F8nA0qW0IlYxeP6JappWkOXwB2k7STDehWS3riRw8+gm5yym4VsOLR4wexQl2cpkE+DzI2lbTspfs4S9EFyWeAcIa0So+wJKZLymJ0binQ3ypXQ25JFRMw5jhySzth3I2mDiMBdjnkmFKjkhwjaepolJQ7bjPyO6cv0NJyZJocnkWULgNrgcsu8OBvDDXwJQeSUJjladRzeCMp7JZdDTVh6FKeRMpTDcNDcTCrY0lh20OEoYTMqi0SojQ7ckcFNTtKT0M6KNklvoci3DhANpldQ9h5elTXoy0OFtGSLab7EDURpTX6FLXAzaSJGblK49tEUuBwBoN1cVoKZ1mP+iZZoSOXOykpOFy22O4hpLcMbjJTwzL9DqwqrKuOiE3lswNovDA2DNsoNJJJ/syKZVOg7drV4Y2duE/0Kyc445ehSpo4kUJpp7JOUdkeWNtEjabXsO2h0qGarLSzwGiNWeF0NxTC3oUzkNPSnkQ77b4kaCO4+qEonaoRxYkm8PATbZ4JY+B2lHZIpGCOYYiCVOzQ8Uks1s4ByQhZaSpLT3JlpIjJLhDkLEopFsjlgJOWm+DUiaaLLIuWJKGrZgJ0x+pwy3BZhjVMeXI1BNU9XscqqWhhGlobHFSUfIMoXRTQ0mi1oaHCbJNowzOeD9Cl7ahmWhlgSUIpZCxoE2lB01EpXS0tkupCOW+ehwhJwuW2WNTFwtwx05NHsZMkcGEWgSv4HZK5b8CcjUvQnM6nC+BWctClPBSeJJO3+QwyHdJiA5EsdjKLoG4EJa+SWmDkyS3kTybJBuRQqZbhSj7BtQU5foTDWa4aIueG+Voea970pJKjT+ISJ2KikUE1sLbPwJsfA9uG+R0JTVwyBo7QxrEJLB5ZIkVa2NFqpWkuVyOW0kNN0Q2m5Kq4IkTFnQi9roiSeLYMQlNj0VMNqWmyGyrPDY9PXIacdWQxpqlEuNklCN+R1I02YNFQPKk4mIMUzLRhvJNzQrG1B4+RNREpIXtoomsNY0Cm0RCtDLPZiTnppy29jUCZouHsaNK4W4ZJrkWnscOno9hEicxyNpuLlsis3bfAJyOpWy0JyTGQJzazOBWbQ52yofyBG05wsISmtYDdCrkJQo7OclosGsrY7amlFBuY5a2kPMVTG4ayWgyZtb5Wh5Pz+JE2jTcsE7DWeSUsW8McvF0evgieHc8kQLCXYyajCW0xzQqMrkmdFMCJFGtLsbmDE0RMNCU3rQ5ZtbCzv0BNO1koNJKLCSTFQmZlUOIMtVfgUixazJM6GsSNtMw1nkbo8wxyOHBFZWxxKVStiYTJnELQyoUpuWxS7bnB6FDXSe/YpZG849iBSp4TIk00TSemNhjacVJHgLHGm7NCVpQ+y/I3Ej4NbGgLWQg0H7EwYHr8DUQWngmTeDLoSa4bSd/cUszJTOii5diZM/pOCWjdHf8AohQpxYMkROIyPCGchuidOw4aNpJa2HJcuiXLJdDd7puYQmpahibdp3MxGBODXRjsThNPdJ6MS1PTG5khPllDFyVpstlwTCFTwWx4Q8ZQ5NLhZJmTAMp5srpEqdtHBBkOUxQnh4bKHOeEwpG4U3kThrmp0TLYPQ5UsrciESVPI7WYaGlT8hyhNZQ3hUxkQtVthaGh0lTbJbOVoCcNzh70bJvKcISoabhukJSUN0nr4G205XpjSFCauBwiWGsobWFrRcyxZsuCKGp7fYrWCSHoJZCkphqltJFCRi4ESQpWhm621qSbJaS1YzaY4FMPQm4KejYmRLS8rjoaaHBzztDVgOvkhy4Er78aGmlNLa1PZLImmJHpoj07G1VTY4FZZMDqU03XIq0oUizlmgLS6SYk7quHBLg6EZUkqBcbZNrw5bSHNI1F9A1aVqUhSseFtIQuBbVsbas0nppYaFcW4TEdARSexXLw5SGSnUNoJsYyy0xk2ehfcW1WWgkTHcQaQc3SJp3FkQ5TE7KeEkCVsranY2mTVtPhsojnEffIlZpvkE4jnco8fBSxGUGTSWxhJMbhfIJSKZwcjkqNJotpDhqehYssp2G00zYBElzsEhrA6b59jiNKGoOmkoWREgKHwKGKRrQWYOmngyyayToyyY0hTLQnXM6tiknClakcIgnuxtQTDPgLJI/svBDdMtw5S9oeKHgxI2lBUmr4Y4Zp18GW9BByM3S0WNXSThHmVnFIhJdBexGs0r8A5YloLlDudlWxW/ibgsFlfYENK9bgwnFbtjJLVRS/ZK0k2Uw0JSad6lCjJIZTHIlvC7DS9pJkmaG/wJy+SL8ktqtgxQNq6GyEQS5t8FHaTyRJK2pqxumB1wkZJp4enw2SSdRrlEEKYfHISSZOkykJQkW1NIZOXUClgpTBjskiYZDk1CHQjnEkjK2rYeh9tkk2RYsA1bG06aUPTaGknCcPlCcqiMRAyWnacmhpWgrTSbOgsOctKUnyKlH5pE4kShJSr34NEsXtBBpCk55BHIVo8fJJSHRyOVRpMlPY4bUKXoVifIkKIGs60ZA0SUC85UqRNugCULBhEUqmh3XgZgybFCE6Vuhk0k1lnBiFvsghqmpsadiLitmSTZUI9BsLki2rbgWWrUoWjycj2F/ZLalaUIERSpHDSRLk+hoau02hykoWAa02jZjJI4jF9jbTbyV8CSTh02FyTg1nQVKwspMTTTsatBjwTHYK2UymBM5LWmHSnqJJK7CTklLb6G6bcsazDZFGsimVBzHA2Tzw9E0Tw3CEtNptRIoQe0Fh5OXYmWUoqHYsG3oho0pgW5K02tIcuSdzbQ5pHHLRLUJS2JLVLbJoapsoUeDPAoMnTYEtk88LkvNjSYpJtthCUacQwKbp3yfJBIVg20ZNP8DSlkWQ20I0k8tZHKaXTG0nyHTWm2OBFNQm04dMQZo3QTtnohO2jsynKtYJmW1olRp0cMckmnXMcDkpWctk1gi2HCE38hA5TwsmEimRBQdM6MRwx72Sk4eHgSl2LgTkfS1+g6OG0iZZPKpIZtU5JkiwyPMlyB2C9sgkmMhlK2U2TGcbocSTUP8AYUIadCjabUEw4tOBOYKVhMynKlxS4G2nK86HSFWST7l30OoZew8J5S5FbRuUP0RYk9oxwTeWlwxN0RKz0kabb10mhkBMKGE9gq5DJWOmPUpaUrEbgVk1s1M7fsdw0ikssTpuNoG1FHHVclQHO2kECb+0DgUTPQoidLhkw8B5nXYkxrCwonllpFOCGLXglouktQd7ibRiPdRv7linkNvLFIWjfI4qj0PsaAU8OR1Hw0QNDZJp0wNEDbZa0hOznnsJwyludDko5HkZdBW2uy6PKFtXBOSdSWs0KJpvsWfkSSNXZPkluCWSrsm3ShQ0/ZMo6rkG4YJQGoi3GaWh4SaaPSE6qlWXYcsyyjgo5tPs1IobO5WJZDXUqWvQpRVtJT9aE87Epfpomdeg2UV9BxY4IilkkMkk5V8hwJ2odQhmyiaq0uBiE5CZMEJZSpE2obWfkZcrTwxSkUw4TZeTWGNdOtApV3THwRadYJb2xuVeiksslpRcPY3RXnQsUJUknZYbhlWrBLlZcnJMSKDWHohJrAsHySbYpRRLLXWSJaESOSlZMNWrUlbFoeVpeWKWyqGtjaCtps9koJSeSCoVOg8NkpoepKaRtfgJ0dhsYMrL7Mmpk0Jiap9zRIeSaJEunTwfoUSVnozRBpzsb5Daa4NKoJNloqG+xQ0l1XIUgqXAbiMpvgHNMgmtxO4G2z914XoSy3sfYm2zOUpN/wBESEPRsr0KUTLVzz0KsxDS9vRbUSS2OEJLcHkbiBDWhwkkqaaGizqahCQ3SUOmlpDlKS5JGihLKUnpiY0qdwx25Y5MjKY2Mjaz0J3TqMBbHDyo6EZPNEvn5GjWrTC2YZflj1vOUiEqR+uhUnp9tRtOlhaopOIlv2KE5pNO2IjjD7ysXBLThEyrQ4loSU5XlsYtTKye2Rbh2be4JgYTSyNCpbDfIkIiiaaFqqoKBIaFNDfA3JKW01rgctRS1tEchrn2OzbgUitxntqRO2jQn6MqbvYUSTbXAJpjebSTRaaRLbK4Kj+ymkvsuRISKlgeDitDDhUapEzpTyNw3nkjDlZxDakmbcUn6LbJuY3/AKLdFq0zBxgpfLoToKDD6GkUpOC0Chq17GaRa2HSiol/aNo24zQdtk1icCkUJWQqRaejD3bY0loaE3Jraww9Hp03RyZw5KVM4ZKai4jgaSUksrY3CS4RLWzCGaPgbJb+BsynrRKSJqnaRAlydrgUprDVdEXN09ssZLhiSWdrYphy7snwNzymxO3lCKWVUbSXQ4pKm3A2Ui3UCYtOjWvkgdDTtJlk5n4DZtUS1wSpyJ89jhXlwN236FDTvRisaoxyjQkksJfwZZMJCaNWQ3Ch8omKVNMaiYdQS1lymG4w5WS4JCWD08Ew5WZU/wCuyZbygN2egpMnMrb6HKe1v0WUzEWOTJEr9joIoazA0JUUrQ0T4VE2GNyqJZQ5IyskUth4gba2Jm7Sl/ZEuHwScHhYbE5mZbwIJMw1smFglicllrZReMWhtxB+0PRjIOGmey0KtKkq4E+YZZYoJ3TbjTtkVLDSbC9RE0wE5bWFUYpITyQlCqcDquhxqk5xV0Nu6cidSUF1tztmD1bkbhgiV2Ik0ydjPwSlQ0qM81wJGwQ9vklpqjRr8EtwmoTW/kTsiFRRBhCNbpDSf2WuHMXhmE8fgjGtWj46E02Nk/ocimzLdZGoi06tLEzTVsssUwpSsaErm7XQ2T0dCc7kG25alpQJvBRTC2JWlijolOYSeg53YtIoaqL2uWENNgtssDglNKpt5QlUGuglzJp8WSUmml0Nl1yJpURNshTWF4/7Jimo/wDAnmcaFv2TCMfMKbncw0QabTQmvgUupWdE0sWVXbE9KX4Q3CCdDJRqbqTbuSCfRLbWhK0cJu2yYmJybByrbdsSNpfEEpSMlKknDC18s2qFkQmmq5A6P5liEiXecrE4FV2+SYP2ZG6TVBBNJudzPwQyycM8kE5ZalQKoSdy/BbcL6uybNSrQ0qFCpG2zSj/AGMJ7XHyO6P0CQqIVgmoyPg7HBK5TfY6SbUvQpUmHh7FNinh7E3VhqYnlUadCJkSwxtLQsBNt8UwtnCQpog7XAQdM0YcEEKlspkGgrXIhEyj1DIQNTqxynDh0N7KOS0MUrhO9hS1I+A98E2uNCbsQulsmFuL0LNrmGQlk6I8Ew58rVEwkUralUlt8zobolvTTJSvQ5uSk2n+Q0JqxTdtjcUTORanK8MaTSwBNORJp0l1SHwSTWTNN4B1jjlwjbHFp7E1BFK2+ZHSfsyOlLJR2NI02fyKlsDdtESqIulnqCG2STco40TdlCKKKIxXJaykJTQ040ZOBtxCcKXx8CI9qfAqUPcJdkpySJKlQTeWWWy1DZTm9iqG9n6JmdqhrNci/sblNlRUdkvomBNbBTJmXVMRvR4yiKauT2HDJexMcFMqXORRhExpkpsf7kw5W1JkIjiMckVI4z2WlrWIGsz0CHhge1ngbTTaX8XwNylJ2JwkvtotQrnZiU2zq5G4hpy9NMhp271A3DTK2AoZ7BScbYgbbtTVpivgv5HK4QmuWJyoTssTcow+ECsodGtE08AmEH0MlSaTCXP9EpRK2fkmJbt8cjeEktkODjp2xBd1pky5qltz0JzL1obJ2pB0qWuhzelT4JuEU6TVDc6FlCYhFbM4E4dq4E0pavCO2NtROGsDiWylyTg2TCRZZtRn5JwmQmGScI6tDejcLwJGpV5lyNWKtfAkd56cjWE8zpwNxbTymNqDtyGSU+R9ktNx0aZRSw8M0NTw9krJ5wNw3LhwTsuhNpqkn2ZLVyoSiWbaC6aYeDQxykYU0q2mNppy2ZGkGrYbeXnRMNJq+GcMNE3D38mVLKwyZ4JiBtV4YJbxTG0Lt6E21ALgCUlkXIcYdnI2oPlfySptWdFKanByM0JJq2QnBTSVvjFLJtRjKh7JS7fBLdJWRcrRBmjjDm/QmyOEq3MlKDTxyNhvJoK1WooaWuxEoaN2WNUSeOCHGR8CBSymXehqFwUckTEksxDtp75PQ0rfK/1Q20Mb3FDCwFsZFi4chrME7e4HG02+AlJyi0hJQeTS4HBQTco0OEK5owvZBpNq20JGSqeiSZanGhKZLkmhNTwl2tie6o7kTdulpym36GhouWFG2Qm65GlpNqTPuRNIjQIcDTwl9LgTSrTmtCMu8TNHVn/sLEvY0N1SdfRKmSjMxRM/aTYjocnKSRbPaGbkSWBmcQYyk1bsY3YktXsySrq3QoeHQ1pE2l8JrRw2di5G+7msSNqEsWAnFivoa7JbS0klf9CMlLt7Rbi61Pa0bqaXz0JpOGF94lNHbDMDU9k9GXSho5E3sxklDalZlJ75uyVGdLL9DpSaWfJbpgSm093TehydvmG22mnOxSjcMGyS1Tg6saRlYBpLIVrglKNqlwKFE5cDjksUDen7aPkbqedhK0+jQbTdvguCSqLtoTV1JtGk2hrMkxN5WjV/BBFbYMmLglONyNxybDYmkyi0Q/7FiiTS4KInMlog00zmmSlZucpjdMFy0OkNTr62SpkqfgWz2rhotTSgt+hPJkrTojNJp7E0ucLDtkFMWohhNYZ6IZXn6RKST4GtEtWdiH7HxDacKq45CbaU6O3JMpdJUimlXNwNtxguuUJHLw1vyJvDSyuSUztTyiJuVPKJkR0Q1wKEpanl0OEvhGs3IcKXMY9jTFC7oHLsCznL5Mkfyn+htoRypBNphghNONPKfInZg8rY5LSp5Q4Xar9EKpctlLgaJNF8E0pjWwkpO7WWiDh1TAcNqXeFwNtCalX0J3O1y0K1kkcuSWpdLTo9+htIQ026ChS4FI3ClW1IKIGlFiqDUvroSSqRw+BNlmhoST9sYE/R6G1SalcEpN4Lj0Tn2dNIblz3P0JtuatZRCZSh7FHPpyNpWujDjs4ku34ilKdth8DK2cxzwO1BW0zctfkMyBJtJ0n2DMJUuw8Hhc+jgprKFDhKatrkdubL+xuJeC/LZMcjQ4WrzQTGV4FwKfwIHEObSxwN6pNhtunhhGiiYk+Dm4JbjCWyVh7EprA5sVlouyUn6Qm0JfQlI4Ug0oSniBIs5JIlJRkw0NKshWJUpP0YnJKaYkYtzDaHblKXFt8HadLEk8i0Jo2ianTMk1pDNKsqaFHCy4FWGluCq2TwTUtK1HOjA+RckaUJVLsPFhMMgSTvVjc84PgllUmb4MIU9B3S/QRLT9gmps+RtJQrfKIJXlSfBaWc8uBy7OlyO6jAZUnEYZZpPD4DLrPLGlnS5TG2q0EWmqatrkpuFpjhOFJYITStuRFV2OS9BLiG6sa9CwztzcDMjdYFobS1rkgbNa5LtFuj4rkmJnNCN85DbXoVLv8NCcA51NCtOTJChUshw4sTbE0oI9mxFMNQp89kkyDD57EpkeU3I3ROjHIdFKhythmi05lsyWJWg5ZWTw/UauuVlwQTVQnGUJfIXiRI8u2Up+xOqhld2IUtBlng0MNFbD9FRMObUtSOPaHLHCSu2uehqNVg2GMJuUoDLC0kMYRFO2uEOE1MVo4E2mGkzK0JxSsyGmJuetU9FyojWBNopKEbSJaa2PDi0i3saJdNiY2JJFsTyfSHZNdiGkmsJFZkalOZpfAaNGSzscj1dv0KJJlO0JkyaTPgMoIUJl2QSaeSpvkSGgTLMUNWs8mxmjGUhyWUTD2O2pWueV4GSKnKp/6Dykl0fXkgNikWwcyKr6xr2IlKdi0SmmzZa7E1OjSVqiZk7RTf7QlLMcFf2HKRwmH/Y1KgtdkqmofyHKRBLlB1SbHLdIlXAd0uIpr/Y3+1Apk1LK4ImjucCaaW5TQymnLTKb7EXCEegsuay9oqHhK+YG21XKMh8BkkQqStmh0NVuiAOgaPOgStpMraJWS2SGaoNcNDlUJ0NNjJelPVibngkgJ2Z2UINTuMPkmU8UV2OGyaFPoKloaYdpSvIPRrbWZMCOmiHQmEDZ2hyOsO2U0HM3PsTuTWwOlcFQKKbVCzb6FE1Qopxs0f2PYzSMzpseC/wBgZtFowyRbYu2SXR9CDZIcIb+GNtehtJLsof2J2nOxaJsmWz8ifU+wJCaikhMSpjclT/sqxw1hiyO447GiJOy+4colQ7pNmTLl79huSS2mEOyumsoeTK2UeSaf4Gpt9glNLcpqU/ZGc3sdjRLKDw+C1fLVN7G1DfTPKJO+WmNwPkHAshgerTjUUHpTDhwjlZCabjp59IgkW5S0tClOpr8C3WTaYT0S2ctQ0SsIWWRQWHowjEqTlp8jah2seyXE0ZXRCcJZTmH+huUpWsjYnMVROJ5Qxk0cmpsbbPRirLO9Cd3SPL4E1WFaifYtPg3yS0nQjLJl3zHyE5UnLjkaTmUb7DcE1QrQ4isALBR2CEE6bB2/kIbhxpsXIbNaE0m2puBSVM7CDtZbHAbymhaFtSiHhvZEps+k7JlJw5wNwla6LQlGxbG2y2ybY4bS6yKlLibQ3a2UtELJS2WhKEI8RyJ5uH0wJwa07n2Kkxy3gwb08A2atD55G5th/wCilk0mtEKl0csRQtOg5NNX0xn+zoNuY2mibSJNNcErKPL4KU4aYXsAoEcrRi2z9Njxg/sbnQ1yS1C7VqRsiadFom4RRHA2bU5WGmOSLErRZROfwJZaKptqCyUk9mXLSZMijW1IxfoaFpmqccGxTHdEsolwammBqLAE1Udg0PYNy4P4MNLa2Spa2psUJzoJJ2na/AWSmgiJauGdOk8MZTfLT2NQYtfkbyU7L9FojAkmoSwdqClNtciQprjyQEl6daG3wK47Mtp24QrTihWZsRKXtY/Q0Gw39p6E2TVSgpcocaR5Qm2pqqp9cD5RMLa9D4EvgGpRz2YIbSqmrIbSinV6DJJLOJehuHdKE+SHAQ+1sgiNIswxWoOcg0JMcjsSU4torcMUhemUiKA4DZtXnglIsMsbW1Fg8pK11j5IER9nrJBzT3N+xqlTwgypxSj2XBZT0QTSy5EkHGbk03ctjsJSp5XATcGoS5OE1f2QhGB+I2yWVW1JXLAm4ODo7CbhpJf8mQZtJUJtdigzKHUuUQZmHKDGUVNTUSwaBOW6MFJTc6nn0S3GmmEtDtG7a56MoJV2fBCKlrANbFHbXLHKxFhyTq9TrQ2+JYRdsl0lsWjCds2RmepUkwgb/FwKwzmmE8KlKS2t0eht1WmFsoOOdkPBjZhBvCCU5CsISZMXrso0VQOYJhogQnjWDRk0y4WfgoeFKm5LJwbVV7N11WQRtMCGkJtcvgbNSo0Y0se4bxFa3+xmoHG0DhzT5n3sblzDqEJNhnSeGO0HhnRWCVlInla5Nslw2c6dhWysiolRaIN5O1eOhuUmsz9gxpOXYZ2eORLTrDIbFQ2Sjbi0Jf2NpJTYT2iCZlcvwJtTKykyElFoQG0tqUkxNBMtaYyzpQ0o7bdDRo4NHbfAyUilrLXBFC0m7fZAhl+RAstQklxigVrljhLkZzgTwvQhNa4FFCTyaYmh2ZJa+BTTZUpcktifQOXBZOltDcontwG1CZSwaTg7OhCmslZSTL3qSjpxiZLTJJI+RImG0ng8MmmSN8GNEGphu+BOnGYfBkr3raG4ItccjJpcq6fBNo087ayTEMmLcWiBKZZbJSsC20QjP/lY2rYT0hlwG6nBVpkUmKk0k1NSJzBcYPkiNjh+STZY8InIpgOWrVrkeGKfgOhATcmiXYTbNgNYXKUzxQqEScupMo3ieBMpNO0hZqquFsU1K9D5JkWmjhnnwNy3D7jSjTlc+jMvcNGst22yVpqVUtEpJ6y37HA5DaTSmthOG4UuEJw2hw7YUpwtNBKa/wCwYgkphCtNTKUlwZhTXEDaSTs0xDU2adwOUs1lkEI6cyGk98g5SvbbKg5h9aKlls8ITJtQnaCo2fqRRJZAmo8pUJyrtcIlpCw2SSs1lmYRylQ4IQjGWNqRpWWNuKuNxkkayzwQSJUW0m59Cjao2EKLbLQSw4UJlk7TCJbTlSmBs8KkuotrG21PyImFKYyHBBE5Dg1C5B05TsSpLCeXyS06mwkNs4TwJ1LKeEJ0mnM6JmoMIthLXA+hfccwnR36EQdkyMmk24sN2mpSLENpTtTbG0nS0xtMUOf5GSdqXCYktlWQpThaeBTh/Ce/QrSJKYQk1k5SkiEC4EOINW0xkidmncDdQygk003bb2PJEWGtKB00m1r+g4KdjfYkj1qmEuWrTu+BnMUalpIWLj4P0VNo2xeTCbCy0/pGSlLC2xpSMY8PkwrRTjBFNzLhNEGEv0mOxmnieholFWR4norA5X4SKc8YbQrsQotpCUm7KtiEmGk7cNE8gd2NImGszyRMqShhDhKihaUDhIuThrRKkOW6LCESwNNfoMSdALCGmhZTshNnL29slGLWmxUohp9CczhOE9mRv+qFatF5PNEJ8IlPsmRMWytsuDLmGtDUUDTcNQNqGXnGmOWQ3GS0QbNy40UoPYxPQodNsf8AhDatuokJTJp1O46IM5I9iCcrSwf2KEtQ8GtjULSzCGmx8QlJGLyoScjcJpTFBrsdEuXC4QNt0diImiJq/QaSTZIbS1Vrc9iiTapyyeSrT7GeIWJZgafWGLUym9RtibfQS0JuzCNcjSsYxhFpCjjA6Sc3DWhoYnbWCyERnI5SnY+xuV5W2tSS4SeYlthuNcEJym6Y2YiSZuHT7G3AJpmcXZbpU7glQWkwSoLuYaGbSTbtMRKKNZLgoSeQlhDODKye3saJUmUpYbGabpHRUmSHCGhKdsKkN7Nt0JuTDSVsOCdFDbhLEMjTSK7BvGzWmOmjDUIsDJ3V/gNpuSb/AKMlkwm0yfeZbcPkSTcJWDMJqWI4FDVepm24jgctNn1SMW9oSQ6QduoQ24Jl0xwaS08jWihq7IKwa3I44/PslJmxlMscZSwJ2epqXkmkblbEBzTw7YnkEq7FY2lWFyNmqNbCXEl7SwN4ILDWhwSN50G5QhrJMbiBWzxI2k3eHlrQyYm2w2htsaWU2ERBuyrYTUkzaTtwxipZsTFOU7LY3TemswOlIjSGUJXLTuCbhNu1ohTq2FggUpTBpDp2NJSuVZzolSdzdN9mGuUwirC4cIZyVImYNs+UicTuUpX/AGSpPVBLhYmUhGoa24jsoYzlcjlP0E0Mk01c74HFc7Tj4KZZbBNpkeOx2w5T5EaV6BTE0JZIV3h4cjlqVRYzabOISkiWTRQ4UJsfylUjQquMI0OYmXkbTMrWY2mWU/Yoi0+RbUpkxJbbEjbykqU/sTs2E6aFA1KU/YsnNRwOG3DtI3MDkuNjolSSaQ7SSZbuOCYi/QuCWskSbk1octGUlz/Q0rDcBlturE3JTwxS5b0exQiPVigcu1Y3Y6awc17QNkqH6bJcHHwIlCO3TGlDD0NQPBrC0ITSOnZDgdp4REm2WmWbe5pSSrb4FDlO2rRaNtWuDJdplFtNunwFTbgUS24JRT2QcomvYaGu+cFHwFJEdEJN6PbOVNKkxKcq52K6ahbejCcRhiljeFqBy+BgUZMqoG2sBuoJaJ7Ddk8rJGMxyKoop8iVXSnyJJnaxIZNtm9E2KJM6TplCZ4PYjac2XBDdLcqxxwPlDeDMYQ6SQmymU52ISGvQaXydCJzRqrej4Nk/YkmmpbtCkSOILGtqMDbYhOp8DQRWslzS45QpbVyZ6hoWrLXA0TkllR8sVLBD7jUJOkziNrsUTbSTZZRTSeRtDQlbxGRlKNtyoGpTssKpa0JyhcCsfIk1bWg3qBoSrZcQKluWU8fA070ZATgkg+UyKKSpp7Ji5NnDkSbKXjT0QSkinYTEbcPj2NxdcoDSaaU4JZ/hyG00kVx2QltQEtnAkelCawbTWjH0SbbEtKClO2KESuHpGJJw9bemN2lNXZMfV8nRNJXBCpp8oh7ESoHB2X9jskk0MsfJJqauj9hKU9ouibBWWxGzgzZ6NITpighqUtRbYpUwloV8ktZQ9KRSqpiM50zPQ21HvQaGyO0JNdPRLZHLeEsON8CdkqmPRYVVfBMx+IBNhu2OD1tUfImotI5iSWlVefYmpq3RLyM0p5fMUEt9ttDRDduV/2O5uNS0OwNvNFCgTaVdD4MiCazxAnSyZfHwOYK6atMTJJFGhiwUk1WOCrKnIpcnYj/ACNElODkTLmtHfLtNEUdKWoG27LkGc1iTG3ZOpbAvgfAjBxkj4Fh6tihLaaueSYQp6+QoPiT4IEZoIBXETkZtcCYauZTHDWBHTQ7RPjTWL5E21DVkSKeI2TdCVmSW3HKtvoTUNkp5/RaT022JtXl6U8ktM2qy1T/APAnMJwhHomHLLcoVk+gm2abbwMTPCvMkKVl6PRKHQmZFQtteoTjOdiUnYo/IRZKN/khE4bHyKKOcV5ILkgo1stIRKXIamycmE5p2sUbJnEkolWy+DIUKMrXyTW3L4+CVDwCZE1Y8hNhTKc5EpbNTJbKXiTIpdByHRchve3mBFLkuidRTMbbTUUf+ktZYm21AFsm1yCboU7ZJUUp5nkmEtgSfCdLpjaSSmgmElXwOEm4m1w4LZOlkU1iacwGjRJwR3yS3TpkC+joNs5a9hMuFJniCobpTRDgyVuR4K+w3DZsjcU54DMXINTJG2dt4LbA+UW2zWBNttkLoJtnUOlD9Ca9CbdMs+iW5VRVtifI25G42NkmF0xuMxT2iUkulBjQ2Bvb/sUuydiycIeoFa6YjEjSVrI9EtttLWWXUSeQ0dqIZWvgcJZXQN3aw2KEl/sG/ZP9jslg9DwZW0O4iiZRL/EaG27YuhN7dKQ5bbSUeCZHHCBS5SkyukZbVKCcHs2JhQVlpkqjNjhkLNyIgUKU5WAok16GeTDaaTVhDdqeUyHtOg1NrawIk/TBDZtK07MpyX4HLVRbJRcBpJpL2Rydt/Y4adOhkqwaozlPCGmrOZEm9moIbabKxBobhHUCZ3hqoE9lTVfYkcfYsuTLYkUc8pkClZK5EiCQeogSiJVUQNuCleGoaTywrhagmqlLDRkzcCj3BBjXackpyxJ1ebYlNFJZ5mWdSwbM3gaiFZomXpeBJJXOAuBI8NQJ6UExk2tp6UjTJNSZLUkqYzYFbkoaZj2KGm6PyId5wbe+BowUpybgcaWzCr/tRLE7pP7JSmLychw3bUngcczdaHS+8hpNOasrRCVKZrLF1aYpuB0F5LwyxqWA3tdCQs8adpEJq4ra5HGomcpLcy+6YYRWuJyQkk7sgdJUa4a4SJoUcDRKRs5NrA0ypwIJ0sKBabSmIB6apuCppmndCTctbEwkVsnaa54NupFLbZLoOXnOWZNqgEgmnLZUxalCOnsdZdCRLiEl9kOxy9w0xuYujDG3NpaxGlSrIRQ4i3M0LstnkoU9E1E0W22SmnRG8mVHsG2TLbWlhyJ5ZJrC42TFLTylwNwvpcENhqFLnQnEqyXDCnkaTSY4mmNFMK2hST4TYyacPuhDtYTfJFlUtNcwNzo3E2IlZDQJ04tqgguTU+JKo+T0OIsUpq5aIZXFbHFpim47GphJUamSnKRpf0PZ047gUJF7GPQqZXJaJe+w3ayFa4KSmTTyhuChJrvpDwKH+IbSNPPTRNyWsBOsJKwy4yVJobOSmqZj4KZzkrQrc0ng2Rk7wnPBLtXhLbkbih3nOWN2voHEJqYeVKV5VDX+xtVmqoFCne4xa2v2HKGuMMmYa4xgQeKpgo0mZITM2jkQp6JSQ5GmQtqtt2Jp3HJyJTuhZRkeDqBOljUnBKStS64EjKE3PhExTzo9WNKEzWptDcoJpyeC0M4VUxpl8U+UTJYJh8jllUNzygg9Eacm5foMo69htrNTD0ZKfE0ZbPRCh7TgcOZIytFwNNJMpSUp4JompV07KCeEQzDKqaT5HK/8BE4XuEYYROTY5XywTUlvlcSNJSsn+QbhSkmZnQ2vuRKShtt9rXsZopZCCqHY9BbcYKZDbcqtZCh2qJ/RbfCbZld5HIhvCaUvkS1FWnybHKO+hagmzaeVyKEpUtUNf7KY1aE2oRLbG1gl1LgpJy4TLsesCtPQr5lQSnCbh5OSZcJHDEzCS5FHKp79ic2sLYm4aLGRwqo6dm6bnpc7G0l+iUjA+NDeRStQK5M6cGNp09YEmzZSoTKijWHyZzRTNttLbJkmQmWN7CM8huoM0KaiUv8AQTSmE0slwJJQ5yENTIJEXZzwUoZJp4ZFLA+4NTyUQhJoYYmumASTOtkLLBcobdtKmRNQexU8mUSkm2mhr/YjVrOaBpKpl7odEn+gQpkqNEWmvhseVIgSktNOmW5blJvpGCeFf3My5j9iN8hp7HC1fkLbSU8ojoTpDgr0DqobbS0QWTGaGlDZzCUyLTquRW2mrwuRClTUYbGm8qmJF1C9jRxDWS84S42XEFjKIYnPAi4bRH3DSScWyh9CUCyZgbbQlsEuYaeXZnL7ikzKGsBCynGfabHKqK0dWmTDSpLoadFLkbdM0kJMIeVwNMM7KW+JErNOcnCRPCTwIymzaJYUr/gHJZsetGPLJNWlqUSkPJTLY6Im2KjkkaZ1/MiSKyFzcmHHxHC00/wjcLUsnA21aZhgam3MC+JNGmF7CZno0kijDS6GqNN4fMD3uDcy2LKdsDgK2JS9mByMho8UtBbnSj1gVtJS3KdDmbmrONCSeeZvh6FMzdGdJskScpLcyJbKZQoFJqGHUTFCj8kCdlaG4qEdxiEqu5GOYVf5jAkYOTKE5f4yZZIxrhFJTPPRE05LniRZN5ChRnfXyTOI4/sYmTNDpPlDSJPU5EwTNbJ2JJqdPlsdUBpomQNE6wEBxBbdPgad8sJi5PJ9FkdlLXAim5gS+EkqCctYoJp5UlBKJOBFWO54fJMLOSwiYXUMliSJMJgNJlo4HiYaG3sRUBwoLmmXBW1kuCW89fAGp04JLEojKIQUtLCQilEiJwG6nT0/Q3M7aNzbJsPKUh0LDKGrc20HT2FQbb5tRK4FZ2NUdIcHJKs3wJTe62S2cuU50mxZ25KJfYqNkJIEcnpUQSTVoj8kSE5FA4FGOwjRJZsuQ27kJsLU0FCy99CW+U8cQKMlt1Baqu2+CTNwbL5Jlyl15OEdmu5El4HSY4Fo0JhNwlt7KaUYysbhwDNVRT2G8WCGHDhLa/QbUS3sJJuZb6HDaKX0Mp7yexKo1Tw0KGbuEsJkNKVMClfnvk5XJYQ3KsoavsOUg4QpJDNzU4ZEDbsbgwk2rlUfoOlXDJcFtgPYhO4pl7GiaIXsJS4OlyFEmC0eDDdtifQ93ZyyaHlWkOtKrEvyKItucJdIcqizdLhqeAmcolu3UDbmHI+hZ5F/LRNjcIzwxZy5TUJ+xVbSklIRSaUEiodHWJ5JWhFpIloo4uGSSFyLuNuDavTsbmFzR7FiWTlTljiBrMnboTk3MLTwJTcwWXyJHe/wEpVFYsg22pYTEoU6TwzLYcPmCJl7Ex2pLz7HVLD/APQ0mbAIQbcwKlK5eOkDmSU04G0nRwwrQ8jgUq4fYErlJ2vchJqEJ8iUM1NMbtHxx2Kxqi0OUTVF9saQyrY5KVQGTtU0sENEttrgUJW+RRSKDKbkIkeVk1oSU+6TEhNmmnsjLUJmnETVE03y5Fg1QqXIsEQ0/Y91n7xFVwwicrhTSGpaXKeeijvWQkiJNCJu+wauorJidozyNk6TotKS/wDDUJKyYlxxHBJEtp8hqbQJGyyeA1OQsMNWl6OuBtTBStizLxl0R3Ns4MPYlBqZQJZxkK2w4fJgnQyJUqTA1BLD1EmSytCTDOWqFNpX1HEG3nsNpuOxLYadyJTluVvwLqLD3ElMWdlJmo8MssV12OGNTWBposHYcofIgdNDCOQvAJ4mBSVSuWXdov8AJRwoJS/JCwq+DtGUWANSeVK/6JxiVUio7oZckKEpVQhgmIYfA0ltJTL6GbSVxu6GT9gw6ULKRU3Y0RGQxmqSddfI4wkCSRBycrNhIFUkxMwUQm4lH2K3LWiiHpiSTMaRChUtlc/A00pJNHZnNGHA3TNkxyZFnMlShJKhRXOm0Rbh8QZ1Lm18RJqMk2iGngZWYitqSmI3LKX+QhtlUvjhjkQuRrJaXZXLXSHJLHsctIbsGpLCzFSktbRAdVTJh6huMMiSUYRGnppaPECTUJJ5QLlzbQikzgpSQ3VbShERI26hQ9EwkbS0/wChUbacvpjNo6dheBmPlsZ1ElX3JT3NL9j4ClFW0qoWGSpthcjQ0E1gEiRqlBHE6VsctN7hUkLJCINwznniBq5KZY24SPsyQydRfJCpREPDMa3wPtGo0/Y0pVQpISTJUthDQKJqlwK6QdT7ErdMIa4FDVpoIcKyUOYEk4djtMWn9g2nHsSONuEroOELSixtpDOnBkeKoHEF1BU2nTKIabPa5CWQ0ilcWJba3+wWHCeHDGnKFeUEtLsjmOigltZG1DGGLRYllyIpSY4GoFQ1OSdEJ44G0g6wJClNTh6eBnNSbcpIkkzNxPY0sOUVSWxlLScfIpSp2mBJa0P+QJyjStWxpprYldhJ2N2RQqt2OkLTGkuCkeiVZwCqIaH0PDSEPASSZbEkm9qt9ibkyUUIiLaZLS3g/gNJJSmMvobbXBl8ImJp0rY0QrooPDnqieBuNKao18jV5gSItKsUSQdp2kTUCXlO2KZb5VNcCS1NEkcjEOVJJNrI1KVDTiHA3KWZbHWoZPJlNXQl8hoVc6bQraiqBuVJk0E2nTlMEkeI7WUiG3NKU8LFJsUsFMOEuaXDIcqlp2xtzK2X6HTY1kbTTERkQhYWXyQUNL0HDQiWZGk26bHDsqRSakhJq6hcuD+hSEyqGTicEGzW0qRlqSlQm09iUNIpOGhtoUTCW+kYDKyKmsDVtokSXCyxqEGns+BImoW6GynhFrkSewyhKnq3QShpWXQlSDSUwKGzQ2uBJtkhtY9jTg0y2cFyWQayNp7yOaOULhkabSxyDSleFkepaIIUHtRi+H8hCNp1kkJKWsGqEaMSmKbI4IKhWoeGxs5dI1Anktssk1lCThQnL5FhqqVcb9j4KoskkcwgShqVD0ooWoRYiUP45H3PKkaZKaVLsRuGmiJQImC0GjTnY1aTWVbMyWItBFOFLLHMppVtjVy4TUoKW0kskJieTEoZNU2SkbuWCFHJ4XsVpNs0GqaWcIcAvQcoklub6F6C2RawxbHFabGoRqOT4G4WElt7IiU30JlZymo2WR0hQbVbkShHexQ08uPYrVL/ALHDb7my0lMrLKg7tO5HdrOWWqGm2iH9hDNFlp9DULDhWTEWNsfsTRGodKRKHBKw21yIsxs2RRWoTD3QkdLtlRkpptJq0xzYiy3PsgxGopKF7ETR6oSRMes4QhpwzQ9BOSOSHGFNXbeDhGyl+mSTbKFVTn2QUvammySuuhKpOCfQnB0QlNdYGRSVqaz8jbgJUtcitosESQ6UtqkEhRpShtodLvK0MnKmw3LTsvi+RraSUue+BKTdxiCSc5mLESLRjv4HK9xLO6EcimtbobuKSxGfkwrVQkY22S12MlQK0o4geiKZWpVJwpazgaxTn7eiElRSTemxQxblLbEk0nsyQg0kJOJzIxNmJKbqYfogqzAgw3DuvgiZrlY/7LUwME74Fwst4jXyOyRqXhp9UMqFVY1Ak6wfYmPB5+eCC1ynSkStlrEvgQ7eARKiQufQkkctzYTmZatSTUwmt+i0MQUF1jogc9lI1Q7i2u0EsqpctcDim07ckOJQ2t/IlDbKqKcixL32yLbGJTTSlHAnDgYdEOREFJkvCTEnE4aUQI0i5VIOcEYPhA20gs5WhoB03a0Nw5WG7Y+FJLkT2fCWJpvJWQlJs5X59o49y9ClmnZ80UHYlT3kmUaUNWNnyrjswCiUQSjCXNoUhwpyTxBJSsn9vQ5hSwmOGJcoVyUzfLkZS0TSUQwrciNuBE7q4e6KVJaEkaZLiFnOGnKElcXsWkSxUoVyw5ZLnNLqhtGabKVMfaHmqU+RIF06UkW8liWJkQhBJL0xEjt9BKWbcNWNwSq8mWhfIhw0enghv3ukuCbklDQoW1jiJYu2aUQlsVSqniR0m2tcsdNseCL9BNcEpGzGgmU0ixNZJl8WpFxNppRBKC4U0iUQ26baHk7BocyXCnAZIatMMgcIS02zjCXuRNSbUKzIOVoqkj7lCbsTTX3obSnJNY/7Mq1WwY5M0G4SFeBRW3tLDHSS0pz0gbYzzPGBIRJZU+mRDJQjSl+xNNLCxL7ETakoSbZkzTw3oTnUox6FK03CLIcuHZcmXwY6KMRjomohrLIQl9NcDlU1beR2RTeUNwO2UCpUcElGos/JCVuxJS5P2FCNLadMVIa06ZIUw5UEpj5ymuRpshrKj+xFPUOIRAhbUKBKI1LppDpqEJ/YqdXweCEmHXIaLYnZTON0SJm3npyKT4dskpYcpjHLBbEQbw7oamKU7QhZRaaGpCsiQmTtDUkk8pKQO0kmS01Lkkn4p7JK2eG+yYhOFsSmf/QqywvvQlMahq0Q5Wwhyjf49jWSprSKEyt010NODVzhDUDEGW7TwOdklY5TUKEFa47EreC0yRo24SEmxli0JST8hJJL1otqUJh84aGk0kWKY2TJLwImSSptodDVt/oiBLGQsJSlllHvBM3KlsSSNbc0xKElqYEkoi0JLg07HbNqI0kIZVcB0kTKoSGkiXow0mNiSEhcNDhFq6W0OYOplyGbTprKP7Iyh4WpGuA0miZbdWwtPkUzcpP7IRtSgltw0ucUWtZvbDsklSGcNDw7NcsSgpTXyQ7JNaUtpCMSRNtTmB2XMenAiTol4j8DzM3p2KGdSIc6r7SBNohpUN4QyI6ZfSE25VQ9rUIUE01cMTaUKbJn4IMhZ37Eknra2NkprX/Yk1G8A0mgTa1/2WnOowTS0U20XbgJLJaVoMBOG51Apk4JFFbFN5ipzsiDXl9iSUpiJcMrU0lkUJVQoh/JAT4oQ2Ynn0hwyliGoncyqTPoSttXoahpcEJP+xqU1cYSiknOYU8qpw36EpN5Fz0NKYAcLjduEVTJfkLiOVNEVkk+tmgnwIiFkUnkmjbtJDpnFFQdiTnJeVDXAMkZN8sQItaTzjg2pazOyZlMFLbwTZOjlv0NSeDUyHUp48lJQc18kYJ4FzA0nTX+kpD4smxDTpt4a/A8zymILZRmhNkppColFtZSeRwSgi1XohNyRQ1bXRJKTFwySwcNgxewew5i41xslswwcyTTGlhQ7X/Y3kq7biSZbs0YkcG5wQlO4cbeRO5YVIpngU52kOjVS/IVKKaUSgpTii0KZZpoqC4qkU8u8w2SVimEd5Wd+hQ5aU+SM9Bf7IaN8FMVEk5rTM26S1K2Stif4DTBWcfAdLQ7BpcBtBylF2yhponKlrYmJZ0Iosik8jmD7tIcpr4WtSXTmMkN8lqCxtmsrRfBPKOBTKFNZkmXpUvjgnnNHsyYJ1wNuCXumJwlOapZQyZTiqGlFWX3wQZNi3/YaSdTbtR+DJNoqSMoSnIY4kpWCeBOVTU8twSgi1T9ITI0Q1cdDWVcxbn+hJUcbY2FnewzZNKdexIKGpRoW5S2BFSUO6G2r05wZbsdkyDcrSk2LGpLgknKVrYm+IpntDtltjOxQpSVUt2KjiJC4KqCIdHop22p09EQlL1soxI25VMhuyztf2Q+9TDuXw0xUSTnEymet2JOVLLnD9EpuFNUuuBqFA0nbTGokVsjpJCibYSyLRBaSlW16G2ohcPY1gWwtkxmm1ZfBLbVeVHJH9GhaE8pxQ5N/A1oTLBJJk/IjFbdDSnkGoVKy55IVGGrT7GmCqEFNxDGoQyWKBpJytWRDTqc2hMrw9sv7Hemhrkt01CUn2OaMJTJtVt1sSm1ppUGmjXDyTHKglbR/wBCTWFraeRpQ4hoahMpvohok1piJZa0hwa2YGm2mhvQ0znlWuA2b5fYKBbwJ6G23CV9iG6ef9CMtOzM11lENcEWjBPZ42ZWqwGpS7WhSsLCSUs3SI+F00NZMMNCTpoFSsKIi2nDwZlwaz6JNNXayOTIlh0lg2mNQo4dDlLFsodRU6tjqkthbRFHtWRDTk1yo5ImHiGOBfoeUNpbimGtCm0LI2hTyNiulbJ7GolVWb5IST63JhCU1MaIm7YwU+jocqif0SJKKSME+DOhWFvl3F04G2fNyfQlcqElvZsyIkk9rJT85TVGBQNRo3IzN70LVULKuVLQpSyOT2HiSWsJiWTLUhVT4Q0wa5hI7TGkZJxIs2JKUJZ0eyTaXDzW2yHLlXBZlipwpPkFPayuRO+TL4Coay4cIoTL9Ah0SfsIbecNa4kJwy8Sm2hJhv2W0smsPseKcKWXhpcETcyJfNaMwKMnIaWCEd8hqJVX/DIiEuwaIiHouFcippLbpaQk0tT+gnCSpeWhylmfDyTKk4acaJGbThSOBdppoK10MPkS0i12G1icZ7IcGyXyMwKlY/cyUlDoaWSZPYpa4GtHAWvZCptX1wNRZTiuwoWqDHAqmh4HaFTHgQqbw5CWzameUP2Vc7Zy8FvlsUQ2kvvRwuPZUTKS6tCTJmm5Ubg3jWuCLT3GWmalZtpltJnLWExI4cMncEpmWBWt1XwNJk3S2myDmlnbexuiU1n2LLaRw7FC0NYNj+B01yJWRL8EEGk0TzLhEJKGpfsUam19iGsNenAhO7lrBpqWVg3khrBbTw6nl7SLOZhMttaHkiMwVlkWeQ1Er9iEoQ0dJwRFpTRwrkVNJkymkKlcPP8A0aTwGXE4bYuSU7O9dhS06JC02mqbuSGtIMPkSdNNJ+4lPPJNshrYaym2NQ0uVhT/ACfCnTRCrLLa9EQ4KJhZ9EKm1sjg3drhissSw9SOKa2cJtKmMialYWQ5biWi62httyzPIszUq2tscSap/cK61kzcEuqBtwaaZkSl0XwNy0kwSd6dDnY4yWBNMmdcCcBwCF6cEGTwyUxMrWxyN2mqjK5EobaWMkXKRGHJhThtBdx1RaFRNW5XCKIal/A1DUuVpjmU+PwGk4dy2ow7NBtyk20xagliWeSG3MwO+S0Ny5iHkuSqMp3yItpyGocpNmHBEpjAfAVSpltdEwoak4SVDwzW7S7EqJHKy7LKlSBqZT9/JaRJOJ2W4iFZ7G5zTM2xTsMl2QcTNJ/ZMKGE5UIUKdilriB06QsLKJStya31JGYSs1oSTTJtsa2crT70XE7YnojTab05Ca0BB1Ef5LsqVh8qtBiji0w3uiaGiITbBjHbaaRKWGlYOPZbJO2GjrBBpRC1hMSuEvGkaq1rAjIo0foht3YRMNUm+TQprDklOaWs6SRogaNzkyIeFHrgaww04HDNO1yRCxK5HjQwb5OFo5ITSweuQ1cqCf7IPgjHeEfyJNSlazyIJypXPIiJaXshqX7EGpNpTgcISSlZ0CUO4gyQk4toxJ8jfARlOE9B3DUBy7Ugahfu5XBa6WDU2uj5DVJp0ETahyuSOFK2kSpjLZQwFb56IVrkISENe0RlN016JGnCTt4kRpuXhNjvOVhkJ9IaPDLHOYJ7QlcKjPIfKqXDQtFp5EWeW0tIdIasOiGoVm/A0pWSwbIzghdipFdRSn8iG4hPCbclrQpb4fZDiVOH0QjgOUqYqENJZTHRSeCSlay+pKBWmOkiRWqJ/wBgSi1QaeydoyhO4i0uRtRwLXfRChqtLfwL0OrkImji5Fy8Y3BLYyIlKg/SGmmbfK0vQsiPInqRIFzY21JKlqle44JIRbkSi5Emq7IEshTyNJpYTp8jimUJaf6KRKuFsSKm0kzPY08Xg9C223y1Alw3PQTbcRp4cCh43a+AkmaD3bszQSoT5kadhJgKUuh6T5FSaNnJaJqMdwOlYXtBqSoigQoRNUlS2zBb0nCOEiMXya6GoaHMEvgScSz8SJJuQ29NiyqYE1QjVPSQyVI3l0OlKpBrLlWpESkasduh6qT/AOUEnCStoSGpTlRchLYlTXhCNwubVKoQ4PcmJppOyxJScp5PkarKaEFaoiE2KylRCnq2mJNlLjkcRzK12OESxUkTTGtBo8zSmHI8yJPRQRNGGnfEDTTOlMI2mm2fZCaXY+EkpPCfuDgoaE1CfJEKGoTVEpJUMNyNJo6jprY8J/QcJEfsEKLizHI5mmUF6DXEES/4IJcwSP0CcoOU1vg3Jp7NrkeJhCaoQ0ShUTHV0NSZFTcLT5HAnohHU8mH2OCTgoSKaFnKtR9DKsvXpCSAl76SHZyVEpozc4foSTduyWmLC3Z7FtqhBVKonLkc51OEHDUsvE9DWBsQYIRg5GWoV0jkaby4mi5EPIFT6oRs1eSmNIizq2EuCeWJJ2200/wJGaimq9rILFUsIJS0qJvuO4q2n0M4ZW0uRwiamr9jhFHCufgmhrhDhufQalmaSTXombWDm/SMNts9CzzMxRclZN6knPCovYajAqnyREHh4FEJEGoapO+nY8L4mOKRzcjDUM+Q1eENV8S2tnHBHJNEtuFAnE+R8CibTnkyalQ6TLSTSTpMcstUoVJNpa5EuD1FyNkhCyxpUbWahpbxpQpunLo32OWaXh6ISPFOy4WTEq8HoQpmWp8oSsJdseKNmqEmCXRUxkpre3Q6Tor2GDU00QjZlKJexqMLXQjjKGnyZAFaGibWREoQmshNLCPDgeUArEltfQq8zRPsxamqBtK26JmE8ZTexTlvA0cNTVoeTSWhyydXT5HTDjQJNo1QIotNrPoZlL24IlQcp74EoTpvJMnBtPZCS/IJJXNp4ElDepEJzVGGWvhaPRf5FiYk8UhrRdPI1LhbBqWktvK4Gm6Ji/tQ1ccENpynkQ2cuR8ESJWnliQk40ZJL7LIRIUs4i4Gm6eS9jcpPTpA04w6BpokcxocIVXEaBQovlLRMo4bsb5AHWYXsEo5lbCVitPYsNvfJtRKHKJ1RSNSoXIhptK0ofJjTRcWBqYcS9BW0tNCp3Er7JZCZBtrkhLOVsNTKYTpMpZdJIQ3xqRSrfA5KG4dkIn2ylyW3JYX5FZpUJ5cdiOlpJdJEbp0qVD7RqGCC2p9IUto10uY6E78eYIoEhO0tNPBUjLU2xL4YxpwxVmnyJjspTYl6LLIT4c1PaFkhJSuSaDa65H0Cy2Y5aTg+jY6aW4VpkSCcUB7tREkkKyVe4cDJMovEtQWJTWpxAkojhKU1eCTqtixJtg0UKeRjbNM4CKEu/oaTVpy6GpcqdnPJM0KC0EYG8TJCTSqMXH+hpolUNfkSROGIo2kupIsSaYh0WzRLdI8fDEz2kolz7ETTm3gnx8iaAjcL7BccCRL7DcIkQUzfZotqBxYbbHBpcJVBWY4sU4EelwQlCi70G0LPSGRAoPTQgm2zpPAm7ROx89CyDlHEvCKCUfbA01UvZmBstxtbQOSyvfZIwEIeiQIHZacEFO4aoRb6RT/AOBKznkUDGRXhafsRSujB85oY01SuFw+RMd8bshK4f6hqWmzaiUlmWdP4ZJkihbbZJrABIaxKDJNYuohfkbUdiEkZJytBOG1fBwkZAWKcdSJbS+uOhtT50Q23oUKeRMTjTIkgl29IdLS7MdoZayGbSGW2qwp/I0oUYOBpWVUE1E10FlGRRAhSwiG7ZLeDJuzvU8iJI28Z4JMWl2NIDhbfwQRNZWeSDVFTPk4EmSijlbHB4ViBLAxTjmRGlqp0kRDN/cLHv1uhS6CHgLDae8CVN0uAsBvgm9DUFCVLSaxO3Q1A4lt0JKWWb5OoQrbQ4BodRqaRBD1skKWtwlT/wCCzW5EMgEuBIOztyJMmlOFOGTc+GJ/oUT1bY0qcpvgUlSuWlqOOmShgZ5ZNJpQWeRqEnNJ+xCbpajC3m4oSVitaSFCZXWCEUTNinHyJbSzw0NNpNbdwJTMqKLJuBym3oTpM+h2ryyH3F1yK9lIM6FK+RrTDUxCc4koROatBJS1aSOBkBTxwiJNQbeDIbTbMRZGStvFENi4bGiTUtwQpFTWXsRQNW+RqVC2cklC4WH+xXF1oV/kahHhnhEQ2yU32E4gRg2JPQAltvicF6zo9L0NtGLMhI3UcvQ6lthhHKuz4Q7TCxlRKi29jxsolRZpalGChB9ykjxkgUJtqnKJJqGvgRKFywoTFLFCeRthpts0Vt6FLZLKgShsuxtqnR/gMrRkGuFsYhPYcJpF8CFPfgfyfCEmolVlCTaLaCo2+BJTbOEJUepDcFjkcpCdLniDBCvbGk1S98jcU4tjUQUotCNOCh4lIs0fRF8LAQ+zTtLQpC9BFSmt0jfZYEq/IEoux7kaadLQkFSFsabRqmlYaltRJW+RpUiN/Y1DWnXIg02qb0NNWUs8MDEyxJXBEKEtYRpN/QSbVrRio2lswFtkwN0/BFXksiwNVGRxThUx2j0ZYgiJY0Fp0s6XKEnJPDEJOFkEkmKXcCK3vSSLbLkabTyawyJo5SxqDUjLNNrCUsbJOGiRRCfQOIibSSzrgNVFbKW2JNi+FvIlZYphMJLkdn/RBrxiRWpnGE5lCWjeCAlE/Rz8jdaYqBJMFijESSxdx/xCwmk1o6Fh8nc2i1ymx8fI4Ipl7h4vgSR+tWJTfSmpx8DNSuyKQOsJ9Co5ptS59Et8oFNiVzQ8Sy32MnndFf2XKdaXZSJrf8ETTUErlEtoHL2UDoSVfqJpMlc3ZHrOSUyokim0blzlN0xjMbhXp8CkQecOTP3o2QppKR+yZyJ5rfyWUNMrjYqK3XwNJPlN8DiRS272Q2TUKEmVyRgTDPbJcdlNzIjeVyj+wtjQEsYnD2JSpu5JP0IqNS/gJJ7miwh2kfHCWyHC5Uo/0NJEZyExs/Q5AnmBpRJKWW9EJKDRbffBJ7PUm8iRTephNiW2WlgwnGBIjVtHehWRzjBCSVphbGqppFEMiglo0eq7gohtir1LsYtCblrY6sznfZSsy2SQmlOXgUzMd9CJpqmkhFcp4LmCZUzkQ2JZqaUllsbT2JVf2S0rUodImW/gHMpwU2WmyUpr2SWsrKBpQMbPs3NLkxohs2LWmxwW0rSEUobtNn5SfY1LlUaJlbTktlqK+RykuW3TQ0lRzwJJNW9tWQ1jGxGJLLM7Zb0XP5FCUb4Nkg1FkJpURhiTYpjkxQ01ZLRCZLo7Ghbw0tjaCU3iP7IFteRIhAdOGHkahSmHbIgSytiN/oNiW3TgmxHLZa2FcGuOaErNeiErzc6M/IyHD5JNQXE/AEMF0ehrKh6l4JbWyLsc/AUimm1w++Cki4T/AENiSTUTj4FTOTjJsg5Q4ToxKpLAv9DummlFn5Ert4JGDtaovLq9BqE2mgz5DI5UioJRBqBlt98DzNdidFHWy8WcmPJu4i5ZElhzTChs2k2NKa4JfkwWnL/sSUkTmMoaaSZnBhdLvghSJzvgNNqpJk2LRZ7ZzXuKxG5YnIjbbOCwxJtUOGKkTjfommm6EJjbuMDUp6A6RrArDLeIQ0lCZZgmhLmuA0k05lrjRSFktolpWVrKQwm/5QlJP0Y3dHIWg6cpiSmnyIhNKk0lDTQ8BGCOEDTSg+mNYbZyh1EfI8ImH9iEkfdkUqyc4GktUKChN4zpsXQLkSU2fRFF1E0xUl4KhvKIjeD2GlkaIs8FJJcvKIoZnPBiSw8wTdWTyngbcOYDyLahJJkxhCht0/ZgP8mVEPRCS01F2Ik4OBqVOm0NSoXdjgk8ubXQ01RTP9ckOCKkuRGmlrYhpEKN5IiINbAocy9CVDpWQkllrE+xKw8KkaazNhspIJCMzMQhqKxLKQ5lHORq1cp2+B2UZaQpSYMRDY9hJKajhmEwsSJWoi0EztlWmQ2QjQhueWsFnRXj0NNJNuoHg2jlCJRCzkStXSew5Qpw7jVxQd9BWyd3Q+CDmtUhLvZnEimCjfzBZhr+CHI1PuQyaSI8t7P6DyNQdSatdkKqNXJIrFE3cLvshUJTR6EtUUsJ6FBKybUFs0tp/Y8DDqZYa5LbzagmaDaTeiS0qsl3MCSYCTL9C5QG3z0NpTEKVgVKGMnyEoQSl+URLKcM9jpwYhBWsRcWncHaS0W0U3fSdkbt4n2OzsW0cpLFArYVlT+CTpSXQrRSTyVvzAu0BORNwSmjs+h0L7BpppNAiNCdbYUBlb8B1gHaS/Q5Z3m5XQlE0H5M3IuRoVu/HCcG6UutYSJxaTZcpGRVDlLE0lxldbG4iJTSMZWSpq1ook5l3/wh5LfNG0ydbUtwNJQG1ZLj2JNO82hI9ZbCk3i59iJhWGUf1jbRtq/cIwQU28MnDQdKNf2GRZWlJMkm6PcjUbr9BtpqEYUzG7cItNrbT+xvkUmZg+xy3K0wI6KU0EpabuYEyRpcsaIl2p5dHAklUtMKy1zJhBJp4IShKpmB44qwIappsItNNOmcLgc0pa6bwyFtklspyiSwQR6KRYyeKn1khveGrf8AQizh2ZEhpuWy4UCbMb6HJB2poaaaRxRBDZqE6IZMIyp66GoabK0jJ3spLUi2uXn2Y1tl/YEdg1pLwQ5Zxy2JNXgmRy00rI9FJEcRnySlCUnTIWVJq0REXLNQv9FHcF7DhkyppbgauCWtL5LJPKUU9TbcGZRCW/BzjeXKHokt21RB6bM7JUYoDqtLjscIaYI2ZJNnHsNJzhN8NDtSNTEtpp2hOUVP8hJpRNYY5stVQk6m1kC09rkodSZ9CEiMhzzA0SiipKbTLjJ8iEjVKHgEyU4B1pyUGsXwC0QzlWSG2+Y8dELbJ6fbGjl+BwKGVKEmzcjVTxBIc2yU6TZ0++CUzDZHstqFJ55LdZmX2NNNNOKUiIcdMMVI0tPXQ5TTTt/oOnka6kTTO3sJ+zF8SI8glIUUuJiTdCMnFDTcKhpbXRUaIy54GnGvkTAihuR0qPp7HCp4ahKRJpkJDTEmp/AMLd+Ebct16YpyUy7PRXByqa4QSjOG55LbqjtjljyS+Y04QoljbVcctjtM1oQ4OJ4FKJ9HA1i8sFpy9IGoeZq5WpEppN5vZg81FwJWF1M3dCnxQnGiS/kptrTSFEkexqKSltDpJFCddhp39ArJt1hwHDStaGJFa0xptZ1YS1mlJoSblrWkxNSz2EuWntwObNEZfI5oprI+GQ3FwXDsbaJpQqMeLalqgVNU+B6G5JO8HQ+SGi5HB5JxAk2mrQiZdNo64HouG9Qck+w0F2gUtNyygK4MRaP+h1AoTzI6pl/YkUlUdhJKFaoawPL9DULYmXMtrehTM1Py0QtBA0OEwIjKpmRttngZcjJNKTGEUNKxtqiFUhqVowIacX9nshUsrQcE5u3TE1M4t1DIVyn4GrrJb5FpDUqazuT4JIfIaewpgGlTlkVtPH+SIoV0odxJsp8RtIocTiRwubrfC4kmFkbfEjSaSc5TyJJfMv0PkRtstI7eBs0TSSW4clYLXY1K1EpYagoRk5Cmpn8qyQaRoCingSGmuSEsLwesELKH5TSKTejMEoLqcCVLsfD47GkpNyme1mipcp8zvfot4RJrvI5aLDlbfBCVHZbZZdu4EZebp/uJJJpxh42NJKbtnQZsm2+BCyT2RrgSE2mA2S0sNOETZpkm3/FFHGa9vwcEc38CIbX5W2hvCiFczz0NSuNAWg0mC5JbmxgJJNrKQKreXVFoaT4UNIahNOHn6ZRJ3vqx1NlJzokdIaafGhJOGbOQ8NCuWcDSZqtWu+CZFEFoOXJVc1yJ2LCKiwyBSqXiMSoWpTlsrgZJJ5NcDhiaWW8J9jRJNb9pHcUyldyl8pu7THlpsNP4RqBOksGsEjK98DUodNscQjGZckJqexyYlWkqIjLunTSGlAh6v2OCgpM9GUk07PwKlDHOmSsZXTeuxpYd6RbUp8Ctym64fJM06MtGlp7PghUOJW2zKrA7MG8t/sLK1LDxshGVsrgWRuftCCtpz+wlEzoJktLHRehNtjYfkbilte0wiUn8BNrQ5bZ8Qv56IkpjTyIdXv2SnbpwgzhxxngYuzqnA0jlsNJGrh69PRFSc/bkaVKyT+QbhJI41oiMJbeQjTZym+BJXVGmNzDBbLRpLfIUtiNItLZFTC3gvyJR2i0SYlPK4HCSaUuuBtI04b38k0k3LZ4GqTCbdnJ36GO2k0k4QbQUEmBndLcPfA4ZzQpQSlKEWPkRNy2chJpPB8CKnF0i1yUNqIU+mxJI2oZpYSMJppQyKYh09ognCTsGk2pv8EjVSwBJ4bph8kYIkbRpPk4MO3I2xmlQ8Np25cicLJynG5GsNJ26PYfXBBMpzzwJJS9B0XEQ/AE26OyNpOFlrLYpTA7twhycNC/chy0qhHXZUDSWnIUW1aa05Jbtk4QUw3gdhVOTqnA1iraPRFJcSaRG0njwNNTKWXpI1hWwSaY6hp6Y8JN2Dyk1GocNm6X8kSlcBcnLiDPI00R+QUUuNNyib2qFlclJNpqccFSc2z6IKE2QqPQZFSQtMaSUp4YSVOGgyiP6ESluoTBDbzyLkSy8ZoK7VTtclqGuaBVpMjTBVFoqycvbXBSU2cpOGl8y8ImnTMop1Bpejar0JmmsVJCScTKM9kTGnJKcwoXK2JNtsjhyPNlZgi5nCylotWkthwNxODaHSSakN83qdW0b5MKHfAcukjhspVEJaG5fC3JnC5uVSZI2lf5MShTFrBJRLunlcIaSVOcBcChKTsVEu21wNXDSK3DEhJO06kSEmvkNUk3eglsUaDLlqE/I9sP5GplxC55FNSsNfKJT2U1/JMJvbXEGE2lLZ6FCcvn0NwodupkcQTjQx4hJTDGqwLTGgSuxINU+yHMraf6slGgd2khQsM3PRIVmiVm/0QnaKCz0fBPW43EmSrrXBsSTapf9zIGkw39izZVTItLAnKGi4vXI04stJDSDhwwk2J887A5EsulHA7Z7ZriCiWTcjYNXbf0Iszlb4EGlJzU/YsFYolLhCUJNrYEoZxtnsSQ6BzC2SdOr1yGzs3FYtS00pypFBLlbcEjg5TSGnKUky+0Qk4uW/sFLylLIn2Qma4TZCrfatyTDbwdwg0028pQLgltlEJL4eVyITRNhaDiGdbDtTCmozZZK0+ORNWDbrsiHcueIUSct9C2Dlsv2Vl7PYkZFSq1JJjKs89iRIyFRcuBuk6JUKEhs9VscqmWWl+46KfSGph20G3m2s3CFD+dwhMm0UvJ+jJogT/qTV+BxJCm1dHSRXbwqP9hqlRQmt7kSUt6bHIicCHKfI0htTjsil1hQ1WVC65GyvIsVoLXRMuZs8rgwMzbMhSc0dt/QmqG52ChOjxT7PYMmJSE8iFDUna2ILOJcrsVHCU6INJPmXIROpbS4UblppdBElR7NwWn4C4LTUNPYUKXLf2EmlKy/YpNrNDfTEsZg+5S8HpG1NSihNJE8ohSENWlyNJIS/wByDsRyhlFEaGcFX05Q0aG9xqNjSX+kBU55Aiqcp5G1k0fcVLGISTJodVJNJ8HS5DxgWg0lSGzY7ZATZLSFNqqhpPlH/oyLJ4PSRKqe0xU2ql2b/oyaWmploVOxONxIok1dHQSnKv2CByxUn/ZCl5GHyKSijaQ0kbuPCGm4tRgRFG8dLkViPkLKBb+AduZuylqCzTrdyIJtHOTChI2ZDcacmkEKEdH7Eyb2CTKTtafIqScTafIwnGScmCws7CNk3VXJI0k0poZEoqTaCO4GnHA5oLktopmuxLslKa37HCqJzfJS1Ois/JOXg9FJ3NaCbhO2iIHNspciSgi8F2OPyDA1LWDUCUETnhySmae3RCSI4fYMSp+wFE0ctk2el9ikaVMIaTTQ6p89icYZqnyKmrEKLJ0i054LkTjlrQ7ctXqarwCEyVRw/QblG3tEw4oShxc5N/0OGlpTWLX5SFa4WDEoPA8MicJPDIbSwx2VB6dkhwLWDkO5OlwWLJaGk0boaJklNqLeiKIpT+wSQd5MiOmtkavk9hJNEZVciEk2Q1INSzYafI4iefyMcjBCTh0j7iINnY2O00lwg8FcuBMwtt5RETty4G0oRB2x2lW2RO/3DZNwqSQlLf8Ao7WPgo0MEtNYSi0KCQahzgE1w8httpcrKGmFfYapYnljlcGwnkTgE47bhpKWTgkJQpU1NtkVBHBGthvTsTkmGfGNKU4l4IabQw+4aulxqDLSW1lDlQqU89EQ7mzX6HQ03oexJrSxwQkpvQYoJCnhiksCeGOSaax2NJMSWg3Bc4CaJNnGSqJpL5/I1SNUKCE7lKIdyI2rTrawiU2jlFhysWc/0Es41dhmQF+RRLjsaZFNSboUVOkdPAkak3B/rgYylS22kI2keTbZg8Jv+YHNJpLXPZRpXDUiEJ4OLRJMtysbSJVoY+RIppkrQtLIiuCxJKFCSFDZpKsQ2m4hqyRteP6GoEk6UygeEWPnA0zSohQkdBKaXIkktyTJdCOlLvHHJCkcwg7fQImroIIecu2QS6b2akTkcRiRDUdxtsucoXbKdVDu3yiW0yUJXWfkaFpi2mRy0VEIgRA56NiUrSVYG0bXN4QogeKW4FM9GpCK1Y1M8T2I6N2e3QoaZgtiOFQaQTNvIicCyXyUqZOzRQyQlzsWjIQOErIf/iS6MS4FJKTmyZM/QgVO4ViK2ZpLexpNcITZ1tcSKwaaPKKSkkuBs7lk9jbhyDbHa0kE2nuRyOoXDpENw8V4/wBkpyNzVNkOXqCiDEwLmqFSYZOxYUfIrJwiEm2k+QeiTaDcCo3HMDrF5PZcDlukkv0OyTKuUjQ1PROMlGEs6j8jdh3wJMt4MlrB7Ek7MqmhJQ3lvbUk2zuyhEY8NvoTRRHN9GcYeb5JlQwrcZJQfCW1n5GpaKhDQ1RJLSDg2ohkpbt7foWVS5dCnQWURiLHaCvJ4PZEps/R/wBDTcNYuSChlq9iyqyaXooTUp2ZUiUvuLEYgcETEoHs4LnttCdnhZcCp26LHgkxllU/ZBtsw7EvkY1mdMlNSTj/AEJHA1be0ScOR2foeKMDUjtoUy1yUh4TUOBts5VEGTaaTIUqbxhGPkSSW2yhEpbWJMzY0uxKxK4ESfdY3opQbUBbfI1GS7eg5aFLIalpkJZjkq+qGlyUVFLYJSk8sCSa4rAUmMYSJEBWqjBCSyNqn2WZ4UYQpfGxI5ayhOTBad2y0T4uESi1CattaJNFUp8iUQvi0SkqjUtrsRT3VzcClpIlSilWFLME5YiUU02iKqSnsVEDlxRClI5JDnYO0m1fwKtAmYRPhoptIaXQUQ/ENpQJYcKSQsBJUmcfIuHCiCbT2oFayPCTEu3BPgyyKOY5QlbWTKnaMxCxbHbhUKx404cDWCltCiyrFBaXh2/SFTae7QlDhuZwLCR3LJE9RoRac6NknHlO5HRrDyb64EyLtecDTWW0rWx21amUyMowsiaZMupJOHbimMEuzoSSWTxxYoSqxJqXy3KM1l4G3EFSlyNNFHI2NTDa8hwlLAZWWlZShMTDHNllQ3ct5YLQ9NhEpiomFSTS5bQmwbVPQiSSEmUImXemsDmEq4ZaCzaxJSjD8BJ0GScPig2pWBZK/Kj+xtwIlkdO3CwQstHoR1XOBJNJy4lGE2tqkmLDVToNtsirtjlEZa+YIlOPZsWVC4ttiGbZbMSgHKctfcaUBNrMJvgtJnF3yyJmZcHsSGesM0xL2cKxqupaXSEzNzq1XQkYalVS2NS1VQluRpxj1c9DRo2n2GBTtRYgdJpUt/AabBLW12JQfgJoTS6qGzDLO9uxJt6Uidutbgo2aWntiYOuSYfRpHY4VMSWcoolssNa0kPGDmhpcEiUyZFcLolqFoLUSbTtg21pUyl/JCwoLaEnXsn7FOe0foz21dpEpiGuCacqWgk4H4AZyKVqGNFlprgRqKHFcdiUmxCaSQ6TstrJsSG/UNxJOUksNJMmqh8BKbVohsSROUTpsM6ASexWaoXtIk3rgcrTGqm6LDMkuV08JZnsmR2ouBqVW9n0IqejXHwRbYhbwxRhczeWvljVByHhSQmpDeEzHZwa5D2i04C21aJ/0I0dMV8Cs4acmDY1xf6G8KoqSzPY+ouhxso8LgVW5cC1CJbzwSds2V2NGSTkaWhLC43eiYgnb7DpkyqfQttx94UN0rTIM4KUPA5lG0lkTlG20osm0pSkhtwi3VHQkxImdxwuht0lJ5FaklM2w24lMlLb0JKNYLgTbMv9hSWUKtRU16EbNwYoWRr5HQzbeghqSmOBpvK6IWiUFhzj4GoSSz9KEsZbd8E3Rp242pxK4DSom5r8hJOxEMsrIF3sfQMUnsc3Jgq5Em9UFrRDSGcpTzkhzQyqP7Gm5Woa2Qo2Jl9DSyvSOi8JU1M0JSaZ3f8AY18wOB0ETeFwscMTTQThnrUxJn1HYkHJAVy11r0JJlUTyNvBVQkspjmLWOf9CJpLaVCMDtcDRFr+wdU5YNDTAtwJJmiFvQqgne3Zhu2ksSltkL+BRQSsUM4KUiM2CUmRKQcvBJY9kStcognS3RXA9ImsHHCHglciJQbyQ6VpqSo5lAvyP3EpYTSVJ4IyePsInbWktDISauQqYgZyKWH5GnGyVQ8Ehr+iiZfAgasbP2gam2LdhuFayDhBOqGyJNHCayyjY5TVf6CtuCsU2xG21QkwnkVWiLEv0OUaeV8p7Llsqoz8jTQylpEQrywHEFU6IbShVL8FIRnJYRSEQm8h6XCAlEMNhoe5bM9itJ4SKpelns0ST0QbLLS5ISXTSqMkp/YQPIRkQ6NFKaEwlt5ekNESTNjuo7MtJHYOCd99iSN6PMlOWrBMkpakdJislEsISVCRDkYOU1h5L3aGyOgwNwxW5hkVCZTHhp/b4Gw3nHCuWTvgayGmyyKXnyJSM3wkbyyrSFKQkNYRg/khl28rC7Gqb00hp1Q40ijJRGhnZE1Y2oWpzOwjTDh7YNRBK+WUmhdQmKVLOXcPmOhJ3kP2E5E1CTpMSO3BGLWVklsdLzwNTMtYIUp0XIyhk5e2tDqHtkmyidSwcT/EJagywxyySb1O7EU26MTiWpK+/gTpqj0K0lHpGRo01hLPyNyr6Ev7HLWfoNUEpkeCZdt8DREkv4CuGWK6wRCpK9LMIotO5iVyczaJTJLJixyc01LgSJehGmktoPiCTNuskM0VDsy2JJqg8vshJWkWnv0QhTuhmxZqswSUocaDNS0GkmyxKY3Q6tfQShwSmW7Yk5fQIkpU44MBQMMyENFMtdCSnalkS4OLGKITS/Itajp9jTi1OKX+xqCcaEXFm9PAhRsotjRNNLJQw+yHLdQQ0/ZDaVvARI64eEEWq231RDdwifahs00cJY4TSkUvsw1CaDhaqnTXMjIIpZDEMVLsdENU2eObmp0JQzu2JqxJuVT+whQV4MUza3ThErTDD0Q6wmyHyM21V7l5KMlZWTXipGZGxQTDXsaqsOqP+xkqVP8A4rFItxjhEtoMhMe1yna6HaT5HY7cspS4SK/LAvGsaLGqcoV8j6i1+0mK+REI4knL+SykMAhJZbbU7Klje45SPlEKpWrG3EToFpJQV/w2JRonpbGiafYRETqdLwS2eBbdkm2ugWjZJtfeCBCkSExwJtRRPoTaPMnYuDiRvglaK32J1FaGv9DbijRDHVStAaSbZVJBGB3A1DTrYmtCTmsGH7FLe/2UkSMuFktKt99BO7wPtRRrkxcQaTjDZoVX5ElLjfIgiRZw0xlgv0CGp2xCDUmcpcCUNvQ3lSx7FbitqZYLdOASbxTCIkcdnIk5K5uCpYGWVyarxRrI5UCI3EexpuoHQKks5Fo0eliiHSTsHjlNpcFr26NwzI+U+yRKUssC9jmE+CGjcUhqfQyFKGrcESqTy0UooPPIacOkDbqUZiFBQqGWpSib7DhNPaxKLqZvoKpFLT7YjbbZwdkNGKV+8bMBOBHSCy6CeYESPEtihyjhJbMEIUX2LEZTjkeKcDQ940hpK5yubA4RusahprnDGnLza37IlyuhMu5Q9xSi/wDEXOGR2SGg0wUi4SuGl8hTTSYdIqn9w2lSOWcNMb92YaIap6uAkk5XklwJQ5WvsLMM69im26FvYfxBO0uMD6OcXgyaaqMg4VE1CWaTrYqZSSdNjmKcDQ4thOmJKk/0hqCVmwuBNQe8PQ005uUkwRMUbW/Zbl7oTWhKUaUmS4VbGPahNpVw0likmrMg6UKUZCRIOnlDSg4ph2TaoNpRT30TDhqngSlOk7b7ISm5sUNxtKENSh/AJ322z6E7xZV8BWnk2ybLUWzCSV1yRBwhacyNJJk06hIcQTU4EXQhpwN5VKeBLb5CVwTx2GpbaypClI3gLm8JsuSuGrkblNaTMkzpbyuSUQcJfIOoXGGOWT1khtwRfI2k0y4BskctDmU6tEy5uYw+BJtmVrA/EUx7TdSeMCbdtOKsSbUHGTfI6a8olpQSZllOijS7HRI6o0OVieVdD7rWlwOlmWA4OTlFS70Q21myW2pgTlHokbdMM4l8zsTclcbJbEyJlQdJLULKIYeHsRQRf7A8W+GOiOHKcN2OCOjfTwNWmkk5RwKTmq263wKW4Xb/AKFKZVbTbEpQrTyK4Mwoa88iTw3FXG5KaX2Clkr1LXAik2m5/YujbgqGGYSbPD8kHVTrZ7Iq5Tpf2JSZUkjabt4yORJG7Ghpty5X8yW00w4P8kzS45ciG4WeePIlSioeVwJRaUzcOCjGFLSFSU+wpxZq2RDNibdDScKrTmjSivY+iJlNNgW1xgGNOI/MZsSSwBJ6EUQsPmRqk5uUaE0NRhOQKDJsvgNwlKdBR4bMNc+jRZbDclrUngtDahz8BcKHPwEtklltmZm+YWFkq+xJhj4IwZKIQn9jbTRpKATyJNU0g2pFFbXA3DEDdMSbfI0aVv8AA/RFNJ7f8YGoawHLOBpdkz0ClzGSt1taEVnIG0QhK228IiheW1tQ7RXiUJmSIzpOCnCghptCCvFhJSSISS+hNOmmupy0gT7Vi7cNuz3FjOqeTgnJkLauQRqetJqxSo6QaksOuBBOKHEg1NwXLslPNOf6HLbdp1yxKVhMCE3FOGUG8plthJpQUzoYSlJhwYTEvzhCUFs2ypTXq2RDShOmakiYVK0zsiIaVGHtkS2mkx2WkYXHY4JTi5MwlLSDmC4whYfMjVJ3bRoUGziDykQJpdjXBdQnYdsS2H2RSW6n2ODwJ4KXPMqOplKFcp9EMhGyyexsTff+hVStIrjYmpYJ9xQ4STVP+xgYxYxZJq9EtlImrbK4KXDTQ0SxJlvREm3QxBU7TwxRGdpuCnNNPoau1JXHZbc8kSbSpbXJEylPlcjTcWNK1Nmnw42RDTtCRRwhSX6Eq5Y9aIa2caTTODyx3E1VhMaQt0mVghrIvbRq+SDt0uSHnD+xs7XhEG4KUyEy4vngJKSRGGgkkpX9AUNbU8ItJUmKaJ3CmxzGdP4BqUntNDoiGstsal22zCGnLWIkWGbsyJtLQNjeKXwju0oa4g5RORFFKuyOBVDiSddsOvTwyNsMPKlc10ErXJXQtoSSw+RLJ4xFFDSrIk4Gs8vkhI4Uoh/2Ihs4WhNYOWnwE0k5bK0iFG3sJBtNtyuBqoSVZfJVKePQlMsYYW4aHpmhKXBCBZKCH9xN1UfebHiU3JaFbg7x2HabSlkJwTSU3Yu3ZfoSk4VvbINyxgSUvsian24Kxhpk6fwFD7bEQSyWzMPCaWxS3HAZdWn3HaRwRebcrRCNk3TSNlmyhNRxeW9EJIy22iYyphs3DtPDNSQ2EnRBtOVi4S3MmrGuSUJ42XJl4mq7Erhew3CVnAclNuekNQWB/gbZIvyJNJLlv2NgTtxHaj5BUmzkHaTaehMuEh5T2xU6rNieW3CPC2xTw5Jsg/MhMyiT+CJoilb4EE4W4cCpKbb64Y6RJ8xqKEylMlWGErL4Yy8gW0lhHIm2UqA0aodwJS92HyJbxrITJSsqQmE0crTob9nt/wChESefwDcK9gtTfV9jePQY6hmH5FNLlUrkNAl1PShjRNOnoZMRLmX6ENNl9miMlm6tvRKaRtOpfZB8NLKmpEsW4ESsyRO7h9rLWhWk2m03I06oStbCnvBNYfRNtJ1lLscJaJQiKnLNpE3gos8VwSaK+XRJUVHlr0OpuLa2M4payT0NGdmC57EoS4IiE3DYaIlWc1BEqbkGkzcNWktiTbcWhyM0GqUOi4XCRE4P/isUtuTp0VR2WDoJRLexy8sm2pEP3qexGrTcUr9iBNqXXn5EkZDD5M6iwESpoTHbHgaVjakqGH3pt4r945aF0JsUN0lFxLrgSbb+dPQiqyctxJkhwrL70UyV6ZUrl1bYkpJULYaRKlZRmhqbIwD2B2UFpXwOynl6K0Y5dNXS9OTn6w3KeyNiMLLSaFP5QqodFiayZI/wVO9q7JDQ+GhKdlTs7dysrbt7iApwnQ4SIxYoS5JPCHwKJpU66UEk40bo9DUNpWzW0JOyvmGt04Lm8iZZabDhK5E6ZgUlZe01v2YYNoNW2WmsFsRttS0JbHbJFqkNSmCMckShax8EKWhp2uijTrbsZEtJZUSbZbsVj2oTLJ1VMfPVGwqoGk6TJJKkshs1OE9dsacJOsHEjo0/cOCWafeOhttQabrzDJS/kTKCRK38itcym32UO6dNkFO3USsm7CehBRUByuhPEDxudlA2cnQJPLUVdhjSrSnpQ7R5tCSZpmbnoo2rmbYrklOXwQeU6exLow8P2QlOVZFM1NU9EKkmiQUNSWH/ALOiatNYHKnnAa2UjhI0EVE9wQ4CjH4CU4pdCIcLTeWjNrlbE1le09jSUOsObIcm4omPNptikrLKmjR0PKWhxKmsJsTN1fcCbaSklDkjmEjRt0iei2Q2a3YqwiX2BqGSBLEStJK2/Y0t0fJDVpoVE/2PmqgMcadJ8kN2rh+i186ErTEuyEU6/MNOyn3DTdrmkDl0zuehycl7TwJHgp2xKTSlJISubyELCctR7+DCWeDYcaehWsay62O1Nw8qBy0sGrRPAR+xqaPTBsy0eiKaOWraDSjmqFMsS06GbbKefbFDORp5jo1fKybN0plDTSeNiibYjBFKtoOVERkhzYowlutMSNNllG9ywHbupeUJtZruNCeBynli0OU0t8ELFxsGoQ3bQejaWJlE2WcEThJsaVwnoGSU4VRLSGmiNnYukNpuDl5foTto5TKbpS50Uzdm37HdpXsFVpucDHDmWwyeGtPngytamRNZiLXZoOAWEVk4HlqqC21IJZxjmBNp3eUY0nYgSStqHkZ1eFPYosTtGikdv0K0qE1LFSdw1agsqSWhwyWEUvY04Q4RAbsKB3GTyYBzGi02tuZaKlpSf7E8006cxi2RigbcaTKEavewcQ6UlKIgpoVo/sbUpWTW5GbSqkMkWGTgaarTvZ+hSjVUO+RToqKpD0Dh4S/slsZvTGhZFFlpoSTmtlPAqbZKmJpciW3+GZCMTb2OnVXIY2QjmxtSW9MbjdK/IO4WpZYZNrQoa4HRVpCwIzwuOhoUiMRpWpNyn0J52quP0GM0TgeijbEwHS3mBS1F1KcJaDaQk43KUkTkhtxVd+RpNpIcNdiYqnFNIdNOJUpVoQltQfWkiTbG4RaiTo0Qk2zZrsI0nCYfF8GppSJE0o4Ogd3Q9hpIeavkRUIVnzIlEAlINKifbHeDQ0uRtKRzWEhNyKZUdCbc5SXRNnnko5YyZlN9hEnjbXrIk36BNEnDktvoct2tOetChhTC2nodaRknyIuVptiFKl6TYYhtYS+BX8ZSV2NxtIdZcsz+NEd4tWnCFyOEpQbu2ChohApJE2o8CcdCU4axgkww7RkbjXARu0s4BZMNxRZXyhknrhif2Qglx2ygNrsRFklOY2RIo2XI5NFpZkVSpUoTQ4XFnFDVhqVSVwibJSsUiQ05TiMCi5NThwJ4cZhTEqpwsU2blnb0RMVNXJYdjeyJBf8AYaIkVr7ihCME3JZNFQsz2QlynUEOTIwhM901YbiNShCdg/7EjN3hYTPcapiZtaZJvBbf0UQVLc6HQLZiWp8kJETURDXBIhUlBEqpw3KjF8idmGnEmucO2+BUEqUPghMUU4EmC2t97GtuDIQ3RyQk01h8jiQ5UN0JTy5DGldDsehCGhFOEsFAdswOKJjBITspDSiWmEpekj5yGIZVhRAm8iWGSrEtixCE4eXZEU1nNDgSKIySotxlMjMlKw0NJSJQ6odlqVSuBRTJGoUrTywKSbl4cESdW42JOEbdWKT3nTDUphk2QRllZeyLDH3SQEKXlyOZQhU7MdD4VHZSkdlrkUyNQmpoSb8NYDHvNoFCU94KS2YrgiWxeExUbucLGpaPqR2iw1Zowmnl7IIg5WYyOW5HTA7G4Eki2sNISSdYlsbvtypr9GGitK4QyaPpwI3buqJ8CTSgUu03sl9wCKEP2FKIQyxpIh2nY3YmvyCyhbWWI29CVjVpMYZLVMtEDcSdoLe60LJPexClkMJJJ7PYoh0nkZVLGlBtcjKElSaNUsWO4HtMRykdJWh00tplHqmO801gJycM2JIn2QrM26ZB7cFI1bdVfApNKlKdEkitjfJSkqdnzA1iwsokSSkl8jNtP5PsSEOnFcBypPsgbVT4Em7Uy2qRa0+P2J2aZdcBTJUNV/0OG8ukmYqrINWOUjabEnyjIzsutDUzuCUp6DaS1csjzRWH+hJJUy5XQhy1wEnNiupWhVQp1JJs9A+Ia1yOGok0uOhlCcNOx00mnf3CtmSjduDExNX2KSkWdTkagK04kTia1v4FLTLIRJpeEwHbOsnM8owy1ZdicFblFKRaKmgsjiI6x0fscpajUIlCXPK6G5hXcy/AxI7tvQ4JxyzxfAyiT/7BRWHx7ZcqVod0FpT7Jt6xv4GyISwm6JMTzdhs1zXUDcggxBgEknA3KDUnZaHIxMu30cU08vgZKVC27E1iauzY6trDFJBN1KctbFJGKxEmXNNJitdxFwyWLNORJdtPVGbHaWRUL0hE1ZOMEEkzDThGz2g0MW18RJLSno+RwlO9mmuSRJIOmqXwNMJLZ7FJt8dhJTTMX/UUOTdEwOXd8BJwWuBpZ5VyNtwEnD+CUplu2WKQnTfbE1XbxPKWyvVaYP8AlaTTTUp00xEyEYjtEqQlOlGoWaTy+FkHpWolblTxIszWtNYGvHcKSzQxIIStLGBJulTaW7LphE0OYVom5Vx/ZQi9i0ODSpl2/Q03bKbt8CUWhPL7HUeR3scLApNbkmUg3DnaEyhXBkrdPE5ghOJJWmybTshVyOUHOqMipBx+hq1cMoUli2LSRiy5IPgLwaG6WLWZGiigc1cqYkUrGHwKTSeyhI5r9iRqHFp2RVtm0Dd36B4ktcDhvVjVpRScB85G3rglSQ2ew2VEpsGh0vYmoWqJEbbB0xjbTwtBhOhTRKgbJuipXipgSQjyghDUqoI4jsilkA2aULX1A3cJmbekOllnLaHHUyz/AKGqiswlUK37ZOW8RoZBQk6Mg0wtjYIpYbHuDt7DZvB9xNMGFA6BKUTJTysQxGW3boc7sr4CZKPyCcP9k2SNQJrhmSkdS8xsWIEsCV4E8Cy4UWibTa4+452T1RkVqSUeuBq1ToxCTTDzDgwZshYzwgbSLs3/ALGkk9iXEXMxTJhoU8okbalXZJ6UddkejgOjTzYbSl2qgSdmiFbRpTs6E+CfAiqEscqx2RUpYXCKdWNRTL7BMngyx1FooQgsVCtGP6Cjs4WutCmI/uZc5dFJbJN8moSgdql4RpC4Laq6ESRdg3DTThZFxZZX6HKEnGaRo8KbkUJuNsyLk4WhJuRU0uRM051gtHK1giW3gG9ktLA/ZsOFFmwySSU3kQ6G52x003SeR0+2x24bkStTYooIeEUyNpPJFHg5pChvg4+4lNm72kmfDAzmaTMFEXOA2wbyxIaRxthwGlyB2RkslHC4JE03B0kKU2UItNtWiaPhoaI84juTatJEitQ8kaQ8JOJdDqEh1oRDZQrZU9jwimyXTlUjo302xpJmbWCkU3ITgcQ2NIJUTutClINpborsk5zLUKHIyyvGtFEk0sVMJaWHWbCSjXFibYTQbcMZkkG64RO6rbUlPApltn8U7gtLxxJN2Pj9RvBHCU34RYlwlzzQ2cfvTgapMiX23sdIUSpyM5aGXsFP8EuGQSSmlYqPY6uIwWkVGh5ytCZ74JK6kUzEPsSRYGjhciaQlTao4Ji1E04iVjkSSmT7CISlt7KyIpeHkxJZmxuSV6mGyVpZiLyxYxHAuIQI9p2uE9Cpy/7HAk22yapLgQndlaMNWk+U9pCXoMTyIkhWRyO3NBfYTA/RkThM8DWbDRItmLYZZMi32Wk1ml/RErCZXKMizZT4ZLY1uqbFu6TSQkkexnwhTPZ65E2Ell9jbXGC0bNFURT5GIVEobEqkxMBuHTh0UclaoxAjnJzmTUMGf51ivaRl1ltRKmdBmdlvQO8YQxmMPQJWjlCKkyW4W1MAmSVE4v0RKxsewqGqt7YotUvDyNOEGmzI4tJwNsfI3TYYi1IsfQimhOJRHXyKaThMSu+BTMcui4Cn6BegkGmS2cpF+BETyJXCoRW+SyhgiZ2O5HXBZHFEah5IwjZExSUuhlqgt19RzZpb0TQzSO+1InTBt9guOpeL9lkadElhS5PsQ2aOHkJ2shJGy2DWC2OiVRGVyNCgjZGi2nTKE1KcNLRJkttpPRJ5pTtPgboers9WJ03iZexSTaGlIym9NBUlNHDfKRJRlWvQbNjJfcQSZEsnCjEZ7kmpUNXIWNxYNFJSVZ4gbGKHhcDZNZxqNCdzLqegnds6P2JJksoTJyXDwZDkjEVNwTan6JNHUlMwJYajnlkr+cJ5IRZR5THBpyocFIN4DVqwrPoRKIWUmka5/BJNs+m1m4mlcDJwCMWE9DkSuqRb5IMVQiG5NkwJbkbQ3yjfshRFU3szBuwLeREDqRLO0NOVXXQ4tk36Mm7bO0+CbbeTxYsgm9hwtXODZJSlSx5DUyqkkzyUaNZXIrSKoW0ikrXTZKGLI4FvDoOU0/csQZQ1kJcEuRawgo5ZcT7MhMrioltt1OnAaZZNgK2MtQzI4ZD9BOUsWrfwIWr1tjcFC2VoTwMOobHKmctSDUkn9YbWSlJPocpp3Yw0yYyHnF3TFLTey+QTk08rYpluYjE8oTaSXyi0g1NmJzZDi0TCpLDG0sXTpolpJqqA2mTmV+gmSWVeODGAdro3enh8EuR/gIkbXg4DlZUcLgKFpuA0jSU8myIXjMa4qKWlsyXGrHCJU7pophaycamzdbSZp7WJRHtsaI2ZzXohSmntaTTJTb3Tgs1dloRpawwu6UJl6IMhyyfI9QUR+3A4Jo0lFcmM44J5DlJITUNMC2iraXBLwB46G42VkhOiK+5Em6T+wFVtTmmUOHLTr0HVtoMhzTilbfooXUrb7G4JUmeCJwLXDAjGuqsxJaTDtNJjFcDDmpm1Dcc4diPASWnK0LJQuZJkWZSVyRLbTihsg1gf/YCziijQJ5R4RqcEpQtquxAoMsCWuBooqW29NjcEslNuyKhVqDgG6ZISJNplLbgcEm2kk8ufQ5OVLpr8ENRmFtkptJZKVyWIqWkObrkoTQ3Q2/qDjLg7eiNB3OpKqWl8N6FQnE9lEYp4mJ1AUtXicpS3aBNZ8pvsRMKEnShtu2qlrklK2WUsMlOhJVDQZKexHBAzPRnoILDZfAqOEzeg3wl1TfJRDnA4MojKVXr2JBWYN6JmyifYyJNOEtcjKabyuZ+RpvMxoW2Q7Qk644G55FUNkmlY01ylkrKlsltUXZjKSFuqaQm6kosdiJHNvU9kqRLbDkRMeRNT9yPc/wEm0SYVrV5bdsGlNRj2JM5Q8cimbiNIY+FkZNcUEmkb9XRSHy1vgJhNRacSOClJbCZFEnejRRJl5gpkoFLLAEnlBbUEt2n/sU4VJbUDdk1yFtkLqmspbITtEkpwReDlfsSuMOmoyKLiTa3wQJuJd2KaItieRQNk2vsMdU6n5K7GkKxMblsL22y+kcPZeseOy6VSaW2JsEoU/Q3abSl5IKbTg5+C+Cj/giqjR20UUVLK0TUP7OBKUtcr2OYJtqYRTTZfwEXM8cjaIYkwv0JWn29iaS+Es+y0ukmi6aJJrBYfI4HY4vBCFRTCjD2JaRSiX4gSpvRxwUiVLZ6KsS1JhIoUidIrTbxlCLwy7XUyaSTG3oeGCHKo4tk5Oxw2QckmGB0hUvPA3Uqs9A4RYsxwTE0bk8KRwUuG+J0VUOG41g0TwrG6UanbwSxYatI1jIUoO0JZS7GRh7i5Gq6NZSuSE1KUqBHCxFoi4+N0NGjay5EiTLsYsDSeLo0OX9gyGRaOQhJJOmxams+x+hyckuok1Hucjby0lQuSaSklmGzTRayg021CP8AoeUyUMEhaeVxAiRqpzLiRpQeXPRQyfBEU1fD7JwS1MOZlh4MbJezIlydNP0Jp9NtFuE0S67EplySOFyHBpIrQi2Pal2iIyOdCCU5L4IdOXD49jRLuj0xzBJMPgNJZdqQSlTwmrEuUySUVuRLizAmdJbjTT0GEqlzyHCTMYcGZUNIKtrnTgqG7fgE1LbyJ5mG32JSXeCIUQ1TwLd3DwmKMsMClaskxyrauSpRS8DWWHQ0i4Cl5DhTh0GtZfKWkUgQyk9GOTWj0QShKdpIinR5MxoTxwHcO446EzV7CZcoTVyN1U5jNxe0uTQpdCmimngTMj7GYJq0wQVhmHBBFctnobbS3LiRqKaafHYpyKYa1Uwtm0y1abIbSUw+ehk4VwdR/ZbduB0ibRU/R+xuGmuXXkcW1B4dq2hklsshpK3b64G0ly1HA6aQBElbrAMnSZyrkOHCxPHDY4jAtHocuz9I5ZoLm6IgnxFo/wCjDauYXAaMldEezLZXHCyRdKdD2Q3lND2NwpxoBuEecQS2qw2+pQxFUvwnscLaKlNKRuFqisEI/wDjCZRODyJxtJPLPwRZ4Xt2JVbG1FClJRhun0JFaUNOGTL9RCGBPANaY42wzm0ttpySZlnRhsozowJkmlV1HJExU0JcpDEtbToZJq5rM/oTkfTtrgUJO6c8iLrZcoQsTO5ZJofGD9DVTwtA2o4LbUkzZ7U9CQr0cEKtQ1S/2OHWNKnY3NcXa5gWSHlz0K2T9kJrAR7iaXYzzIzvWrlZgbVJEjpWauA5VC5ETCTMuYDacNpymsDjCfMMQkvciEkY4QJr3/gV6YjbZJ9R/bJuq9rZFW/IRbUiErFDnsQRsHTT7EWwr5U8jJNZSYkw1poagmhbRDD9iehwLIsLQ0snAXI1KXSU3GEManQ9oidmy4Fsy8IxI2jJFkq01tISSba4HYUVO3yyCTasJWTUlfaPUbDaEnmfkNQGoTCI1imENGYoRBeBQufgcjS1eX9EaDf5wlU5GWuDtFktmXSp8/cmKVSUxiSa8CDaxLQ0YK1PDWBrCBQ6aGyElh6ZZKaav/YaRhzFBmolDcylL+BRc0PK8ehTZ6bKwnTlKsIKyFHBCkeSL2RjJeg0JKHtDVq1ttDWCeFayGtFSLWo5lKEfIat6KhCXX2mN8ENiSBzKU8hRboTGZrLLFCagl+hqTSVqngTpOmqRUSp4ZJhLCfAoQ2l8bFwtThDUTVKDVnAoSfA2bT1mXRkhl54Qx1KE7IOS1shrJZBqbi1/chMzqiiJpNVNZ+SKTZ4TQ/6TIdNSa2pElJUYDpNAqYRUkxyQwz8EUfZMi9nlijJLnB2JJG8HbRhklcjRXllElEssPoapvS0QtlTqR0k2tLTHpGiLW5HJIkNdg74SbEcGnCZrgfSV2ulk5Ay5GpaTObE+BOQoSlJQLaQ3hoFLrXx67IlPE8NcaEk5Z3lNCpJatQU7VkdiljHnHwKGSTHPwZQfqJuXmThovAldhRpVslE0cs8LI4WY4GWWlGF2QklEBqFOk7Q06R2xsjFprkTkk/QZmXTRZKdMtFSaykfc1bFWkXlMm1ieZybShPIapzlHExN7URD0DX9iJncsweyGlfajktLZWBsqhaV7Ekk+FwNtk3WJciadVCZGl/OkoSLDuRuG1zsuQnE0mpvckwdS1PkgQcphRn5E0k2dbIpW6eS4Kc4NkJpu0P8pHCL9Wkl0xgehpsycOusjKtCO10hsjEtyOWifLCZS0g9icC3IqK06KKmymqRS7I2uOxqps236IZNnbtRkabSbY4engKnEMWyiilKMsdIVSllLKG0ERg4yI0mjgswOmS2TQ4a5SSkwhHiD11JhNpFQSSSSijX2UG3IUPk8Ez4Lab3HBLRE5ftAzcrGnkOaSw802MoulT2cklGlQbdSloTXoaGyn/gS7kklr2JThYEErJMw1heyFs2R2MbsobpN4EmmllUPHwU0S2NwiWhe2Mi1Ft75E25DpyKCYIJreENbKpWTCHRnkTC0ImoafgVut0laKcDEZl5exKE1y8cUO2Gpwz+hy2WsKYSfky9pDajHpElMitNji6qdrkamISlJGmCaU0OlyKadFNRS1UtEoW4nNFzmmmEkyjSQ3bxBQ2y1TClpyl4siWSQs8LkUQR0uXtCJwknKtr0N+xmmjaCSTufpWrVq1ArJZCcuaP4H3+hmXaLX0LVq1vmvqc03bhs1gVq24QnKa4QtEnm42rQ8RKRzPAqRJUoCV01YtYsh2Nh6ErbnkhuJ0uWWiVnLLSko72jZbU2LL2KEhhlCNdk80qkS4WjK5EaSVpRkuY1ShRKs6WLaESp2m6T5EiVRNQdQG6S/RPOmxKDZJwoI3bOhSh0n9hEzjmQ1NVk3yRA64NclKCDrRBT27dL2Q35WSsISSRKJypV4GtgnkbQkn+CdkZM1wCieDWy7OsYQkajBSXoaQJSy3xA1hJfMDUNOGskG6zYERT1GqYle40JSKh20UJ0W2OEt6YkTiWmwyKOnTQQz1fwIMdKeRK2qcpr/okUPK0SpLIpCSbtqU0LV0wuBKWm2uWuBxVHZ2xEBTOQ3yhkSFDqG0dnI256MSODadCdIaUxOhkJTCO9hajQrexKnLcsOJpnaHBja0xpVJ0x1GZccCRNQswNQ29ZfEShNlHDcscPZUik2TDb2KGpKExygSllGdN6HamUeehyEnOzFXDzyQ6QmciSbbSvJcjSSgm1+URCVbfgptr+wsTiXdQNJnPSJbJN0iaD3oRbZ0U+Bqw4ZVyG0HKLOgDA1hZY2CWlOP7Hgt4Nf7MLRvpoTkhUypLRw0+FgbnDUpp2ZLdmkKk4k6N/oVSxqGxSai0ISNK5Pfobg0prPwNNYNTkSUh6I5NJhU936GngQ2nUbJaJsylzIalvsTaXlddiRZbfGBSjrLOZJvREqTh9jhosOkkiJxsSaVNnyU5fJciJymMNDmGa6X9mGybRbW7ySWiZ5SaSX0JThw07koabJ0so1TeGNJsmqKE2U1FQuyT1FmhU7MSCimhkhWlpjKU9LAuWduiyrkmSVus+xLdLqyIVSW9RgUQN04FGTTWj9mRlGCZchE4Tf8AQ6cdA2Qi1bjNDTU1BrWySMS0o5D4JjDQ5kK6Q33PlNEtsVLHyWuiWLdCU1klhPgwWk6m8jFncGZK0FxGx7LSUpq3PQ0EK7QIRQFN1wVdVaBWldTVyRIoq3pubEJHCjHrhfAoUbQlyiGsidHwI5aJySf4EkTGmQRnVQtQm2Jrg9j3tY1K0N07RvI7ShtHck3kLPIikLvr5LDbglDEjNLOHr22Qg+ElARBCeGuijMfchlLbSXLYiSJiWnAkYhxSm1ZKQ3BU2iZWgXI1XG8T0hq9olGkJdM1khw1HaxokRvW5E4nTM0PQpgT2hW2fAlstNKWYM3kp7aEnbLV/AhsTlpMchpuGnsnY1LZX+kOWlwt9EWqb2yLa7BGoIlgsDoVxQ/7CTSaHFPNwuxLALQK1NGi5Em5Kt0hUmnphMhaAnkmMYohdTyPJTRbGcHSabWhps5fYOiIvY9TshmkoVWWzCtrJSxxIU4pcCuhVqeGTC5TFtIxiFSKZyUPkb6mFwSL5vqQeTuUaDl2G1t2m5tt9is3MlluBSrlTD5guEpKZXNClLj7iJpFL+zBw6tEHChsLUCtI8NcpagsplnOQYnyK/oaspVJclEoWBUyltgOVhDymJy4XeNC6MYao4+Qg8iJ1boUJC42n2JUSZW5GwODbkhIsGR5GsuHltCcw2HhkKmiw5JPq1/bE1BYrfZaUlCYjAlM7rX7FJTXItFYrSpoRJNPZMUIjDtpiRL9gk0mFIhppqTwKGGcpsalDbVDL4LWyFSuUdshtylZ/8AGNSeDrQliaOSUIZwYQ0m3i1ngQ0yJW5/oaSmUNQ2aQhcrhNBwSGc6DSaClNymHATuE+uhFnVZPhiUMytc9kGniOm9CWKnsxElMYGzFuIjnkSgsyT7ElASRt+xVXnKGkkfB0wlYdOoHGyHXsMTh4Bpunva4Kfcjsacy0pX9BKWByLGWRDb1ZESadQ/LEqPGd9lQ2VsPSEIGuLZaXKcSHJJcjey6wOzWxIJFdoHcGpavoNGsJenwJzKeVj8kyiVLljysrTsSyko6Ym2RpN3kVm6NO0JyP+DJrC89Q7o5aB0ptmjQoNX1HBtYbLsgySROhEmrGJmmk8LHJNNHTtkJ2roGZFMMZppu0w6ZJ2Ut98DoayyOqZENK8UJCpu40x4ppzECRyl9BNltWGWXKiG/JcCG5K0xH9ilpRJLaQ3KIfPmOya7FkbrLQNtNJWwwrThtv+ik8r6JhkXpIzMoWkyyZjgJ0mq/Iw6w4/Q3MW5qS2Q2zVL+RGxlXYlFS1kbUUGKw3omFiayVvkmGq5FyO0bCpydsCg0aiVehJbWc16Jg06XDEpyVwNKFqFp1unGRkSs5QNUuMnxgtQkRsJDh3l6+Rya0nnsJGtixLh8IUTDyoJpqqeH/AKLKSbqRqVqwKCctbEm7alCUhpP5IZsJyuxuUmyuRC9bmU2yRugOqBPI172jC3LeDZPYMmmniBZJrRGDktXLR8iYLutMCNzVphkQQ080dDlo1XfgaCYEaaTxehXQMcvgTdmR6EhnoSpwp4EjnUN+OxLiSYQSuym0IZTb2fQkpTvzfQrSHFKXyhwrSsQdqRC3HLEyQtPRiIghqDdFZ08PTGIolkP0M2pL37DJNyUvqTJ42XAsmSybLHOcbE1VsqTZMXukrZ9GyyZ38kqFNK+xq6NxcsSEkULDbc8ConZDXHySpkqo1FtGpYQwhTXDCWianXUlxOxFZilE6Itpjam9SSZu3hn0TXeMJ7Jcm1DWOxLdpDSexBtOIEktSjPKeTogSBaWXIZMmuAYMoSslwOYuoW9EQ5pZMcMZJ1Kym0xJSufaE5SUxsSRp0OPgW7dKEyyKHTBbfJYSDSXGyiOXbT7IqThpjcZSE/uOBEdqEpraHIxTZ6G1bQlToSTJqYMSMHcSmLqIvtSrGU0hVLTLfVIvfWm12k28kztFyiZohsdqKcwpbaMKU4G0YVvAlHKVsqQoSciywp4E9oaw8icvhsThJsFtkpQrx0FgaVYf6Gc0nEp5VjWHawzKC1bG0cF3tBLRrDWXJFITJQ0hvA41DJXAkiW1iP7JQ7U1QbmMDDmLHmenpPsgpY0mNKMVI8DpeE1zBdKdvYpOUorLYmk5yasTh5FEMUJwS2Vv2QsrojjkjBqWWEKFV1lPow5KcxLiGsYHaU4YglWahNC5YfomU5RzYjomeXMjgYVZko1wf9E02NM4YnDluqOUkKblTV8jcEmmlTWhLNJSUwNpSinWSYqZdEDaZJrQQSTzaYlW1LamiEr3JluXe5EMlZlCd8Ew1/ZKdI5SwyWtI5WoFtTjDXQ0krlFidsvlcCRkTmdlUy+39FKz5DKZAM9Cex7cstjSbSdwXGk05cYi33CE5aFPCOfQMahGScoVyOUv5EwlC1A2op2h0cliyS72Q2VT/AAFGqVNiHdKEysoR0yYO66FDjXB4GzR7F0Nm7OB9CJhmzlO0D5JTOEp5+RuH2ho2odQnkZJw9PHopWckxt0lMyKG7g7G5UQVyIIk+ok5xWuxJk/gfBdiskODyThIhJwTNwOl5pTIvZZkUr5UkKTXKg7lKShtLkToOKJ9Ctc2rEJrZaRMTuLPZg1g43sTiAlgg3BaURa3c5HJlGdBiH2P+hpTO07s5VOmeuxW28msN/QlKcbFO6iEKlHCh2b5GkNLJay/Y9CHwz8jbgo5XsmBEpRPsSZLgYKTydlGkNzhS0UJuVpGBvcvRuSnh8Deom4T4FEk7YJJEThp52I1ZTbPMDSSNUkJppTWRpRBQ9BpyWlICUSIoUcIUMl0OVNTThDhk+Hp6LTuoWTfY5wT2JK3UxgSq04RpboyEZZqVn0K4ZTX59kwaYaDRKxrPIm/vKJrYqP8xpOoux8BqSTxxwb7bRb0Qs3TwEadqdkSb20sJuZUNUntCbRqYeD9Cbk9q5KaaWVvsmVCmskEohrDHKSRE0g6KFNBads5uBakjisra9DlDqbkkLOpy/18jbbjgwn4Gm4VeN8DlyKNSM4ShytMrcJZSDuUNF1C5MjSUWngWRgsEkkS15aZNJWS+iTtu6S6+B3U274I7Hp1Ju2iY2X2EqU09NZ6HcG7OXqRxNuzC2xJu6kk62S29xFYINDSkeIKM6yi6HBIynLaehTCRy/wMcR9hwyaIPYGhpnfJY8PMPv4E22kRkwx9+k/Ak0tJ/xElSajAltkm6oVMITlNM0UNyoqY6RKSWnaPCXQyaKc5d8DSdtlPYqVpXUWNplN4JvQ1TSLUmFPCmhPa9MThulzYU00tXzwWzDG1sbbRELwKG6dS2NiDS4JqkFoVSk7cOkpDzB6RKkS+RwnOXy3yS8tBN3YjozCAfRqBmpob+QlO4tyh9DuQbkpmXaLfcD20VAMjQy7Xd7sRB0ZiHIO28t27+rKwsteoUOqqcOGqRyQ5/ZIkems0BLbaRsVs4geipcwhsou+IgYYTYpG0RrMymv0ShPlwWlcpIPB8cQJZK0ITTqFpQk/wChpdlc4Qmmpvo2SJSaVO0Ju6w4GkMsdtCll2loNDadhOFOnk0KCdspvZCDGCRxJFsyRVTM5qRXEyYJzSYVRslNTCyhyxIab1oq1zH4GSG3DMtToTTvDWwzZypKaJiWecPQk4bOJpPkoaoZ2e/Rps+iLQtNW5G00lsQG6NU0st/kEGjcINFW1tEE4KH6FHOGn+BBwU6Mk3KhlKBk2k8MNht4fonKmuNEpRotNciZ2SdU+xQP1HolvBYCoZTRgmXOxR6EzW1JfkTttLLDkSUiOH/AEJE28XT+RPe8jGipOXWUNCHW5ljah5NglFJxOGQnDysmI2LslyNuMuHROxm7mGEtrUqCU4E0m5ThtWJea6CoZ0bGiPTQa61Cnz7G20erK2Nop77HSUVCeR6QGa+wQa6UQatBnGrkPLUZ+90h6OqSV/2NLTk1tCIXbIcY+CEIXA8/wDY1aW6w4QmTaatdicJtvHAsFjUdEqG2YpkyuQ2CdXUkwwoy8j0eFmtjNDSNksjNta4FlJxCgfX2FJTUTr+g02imTcjwR2CTmS3gVmylhsXCE63sKW3froTmYyspC9Y2kQ3V0sByUCSyv8Ao0j2kXaciY2mpZWZShjaeQek0TjYhNFW8bDmCebw8jTCdXajAkpKlwGWhRQJpTo/uGDuaw62S3TLKGtIThLSuWPgbjs7EwSfCaE2kQb/ACEpJJbLZ2XI2Xg6PoV2wC1ouxMuZhaS0/Ynkia0xptBjKEk1Ke0QlL2wG0oaUp5TMNtW/JSbtNeyGluXpf2I6dLYUaiMTy2NJPZp8DRMqlpITskjNIuVNVJMWUiM6FOREGll2hmnPKWM19ikhjKNDcJrarFSZPkJqjUuQ26Ty+AbhSw8tj0fYhtzWSlpwlxsbaUoZYRtxPBLRuFuiLAnNxrSIeasg4JSWw4KWFLZT0LbLcjhFzNU2OKZLZNCVg0/wDoalXSCG8Q8ynEdDHVCafCITOhbR8EJuC5lHshK45v2GqZjSa22NKBJYAbU8lRKEGYmjCzArTLaDTiKm7IRWwatPYSbuLtRck00lJ4Q4ZNJpfpQiTmn1yHLPFHLXoRJcLTY0SOabtBKSU1o7gaUm7VV57HCuxWhOE72eFjW66pr/YlRvNl+CmWItlyJNw2OLhexaphM4HTm37CCJ0/1EoQiJuENBE2yXQwUzKEhp3kmURKvaSCnmbCWQSsnfwYJCVsh4ke3GxxGB5bUjSaii5RUjlbNAtbcqENOGrqkNIOnMtfA4ca5Dg9HPM9CibSU7+QkZtZoaZCs0oguFrbWRJJctSDmniSluXZBJSzlkqEU6U2eGT/AAUlOJEkjxpb2LhEct89FBJ2zLLKRXFkMbJ8E9jnSKo9i1U57EyLIrdjbH/sUSgi0OBmDqVKRT5KTE02TUwpJ/YTDPFdMkCghzKxPRJgGX0VjvIwNF2y5bOzTJbNwbpoUyG37CRB6Uc+iwiCM0motTjoThNOegmaKNKdljc4EJILZeh0RIdvZLbi2ntiKV7HCxKy+SWpJL9wblWMN8mQ4nSXbEkLfCRY088ITSktu0hN2Lywkyk0N7KNm65FEnauRo0lUkwhySNwa5GbpkbY2nw4MMbwKtInFim+kSoONvgZJucnkyDodZaWNOSWkrQTSthlWgkybbT04E8NZT6HIKMyWVKLWPkk18iCkrfY+E0IY0XR2tjNwOnhLgyhO3aHalfASSZF0OiUbl0CElWnTQqOEWSSQ+E/6EK3E8N2QcHG6lN39hG1N1sbM5bYNoU4OWNgrZkDoWyLNUap5kUjU3pMdm2eBolN3RilxlLcoej0KYE0DwUok9u8S2S3N3quBnoGfQhJLlyQQvy1BU3W/WhpnlaDvDywigl7T4YsvpSEtcYO4IQhC6ETMqZfol21lPZMWsSKUOEN37HFvY72QWCb45HCrTEkrKaE1/ZrNxH+x3TqyexyiqqXkd+BFLJ8XA4rS0owU2tNNckJuFZP/BfKe5SUW+Ykkpu2RK77D4RMUj/YJEhy2x/6TC28McIdOxKtsFT9iSFHyA2y52kMTwm8C5R9g7XQ3wIwaFENKauXwKlKy1P2KGe6PYUK90KCO1viCLbU3tGho4ISfaRBx/YKIdYRpVY/oy2iryNqYUltMqCrTljmTsuiKVOWeZFoup/I0lTVKV/JA4Z6GRH5o06HTLkmVvWWpKlVYnr5FFXOp6Q4cNzGkkXBqY5XQ2WrS2WJNu0Kp0Ju1uRw7sb5iqWlL/cbSyhPH/ZCSHpSh4zLUDeh4shuYZEYDU8DS3I8lDTNKjfQqRK5ZdhoyyIEbQtMpmim+TKWkQSwb0S/sqz0mcEWNNpi+Mm0cYN2QT2qXQToJKnyPAymFJSnI+/wLWo62xYFKBzuMSZJ5hJkrULCGFbipTImFyYLRhljJjQnk5Ta0ZQSrLgRrrutE2LNrhM+xQmnH4ikm8tjwx4KhLbJKcHL5YsJUNvqLNpr3CLKCUr/ALDpvIqgyJyiWNUsZNWlGlod7it0Ei21B2nqWSo3C3HKud2hwOqCVExBz9h4YvyfO0JDCL2nwYErPjYivD5Rk0FNKOxDQWQSaWux8iTVF5EobsONEI3ksIMsaNiDWplVpY0IKowkhTwzFJpQ5y9jSIRPZRTZJZnJv3r/AMFWks4ExpxB2OENFzfA2oJsjoGmF/Z0OXTbQ5SfYhUK4cjhoZXGGSjaXEXwQoKZl/sHcPLNIczTqFcjWjTWpE2hqaZRQrJU+WSpUC1tjRE7hxeg4rTmiXIyqLQkpMprSKbNjWhkC0Gaf2GxjWV8qGTuW+xoNZa/RAtHIY03mlKj8DswqazI0KijoQJIolWhiK1012KDTwt6DNI2GUFhZoTiVtaPkxeoxfPI1tta/wBjSycpLn9mTUsMZumoVcskkzFhBwwBklyQIUdPDQ2mj+b6HNJtjIQocpl2OEKrfs4Ke2+9lJKnpoUy58IUq8JsLkmVJN0QaS0KkxQTuEoTNLlcCaJ1gRELXL4KEtz+wbaR01TQg1t+A0OrZY7GcDJWQY8tfI6hGzkmmshx2HJa0/vDyRp5HULxwmNGE4Fsjv7SSHdrTJE6ntomSdLB6G3rFwPJvH9DhDbp00SBLaG4V+0DamTnB0MpHZuydMtCltszhehq7iVWl4XIkZWVkTVNNNgKwNJbKcz2EJHDcNPljagmHTRQlfhCHScRSCCnA1h2rbw/QzeKYnYZKpDSRYZENS04l5oxFKcrgguynwOCMNT8T2Qk59mxQzS3sgTfTQUJyavIpIi4nZ6CGnLRJidiQkSe564FiyrlOsM7DuttU9iZcG2lk2wbSx8kpQOULWlzklM5lsWhb0aeIFCS3KJIpZGqfI1ZKOTGiOJ2O1Cp6DlU6PJEKZKHkGlpTcUw08srDjg4FODRkVzwERYCb7FEtrbQlk1WDFK7HRN7FsqVTexq9L1JY1LIbKSqyBE1MTC1sTqPmKnTo2HCcb0xl2hOicLkgUMy7X0aGErgLMhvYZplzKClYSf2DMM1shLBxia2WqSsnY3pW3MoTSj5HwOy/siYVXbXECRQuslwOJS27lj03Dppb4IshKBS036BJJySv5PQlTVDeG9ku1mSHYSTJQRqVbSFgoQ8tmK5kbgma9pZDSSWZNr+xYHHC2QBQ2k5FClpvj2JJRJHRyI08RhPZh4K7kltNJKqEuBuuIaFRaerYx2GZCskMbXlDKnpTPGhkpNq2YFaWFNkuSM7RUyGmxlp8QNTy/bE5rV1IsodwWwm0bGkx20JrBQk1wKgjVSYsjzQuUNsrlSvv9hpl85G6/A20lk2KSwR4NDQiUk6bKI4p67Nit6gqo5QynJKsYbKSqtaT2h6dJ+hrohUTCoZZspBvrQRJQckckh4NQpxK4HplLd3wXYzUKLoHbRuXQsd4rIcKjcX5EmxNQ2GtkDtTa6ITseVPlCy9LbgiU21/wCZyngfLLaabhfIKWNJwpp6EaSUpTa0tjiTBTeoEy1Fi0TbJ7SVspTT09oDTvW2gNKTcbw6A0uH0gXwQPkHFP7FhaaJi/KCU005TX1XSKE2km9JtqSVt0k2SaGZu5Zk613AmTFYljCE9QhibBItNZW1GBi3eCWxaeyVFG70E1ECCQdhbJlXxCZJlyclJFBq09DQ3Ky1kTQ+akswyEotZywxO0RSKy0MorT4RBKrSywiVkllglppWU5K2VHmydnOvIzTt8RicpJwfggkdO0J0KD7QzdsoqfY521bORbw45wKSClxC2hNNrBpy1qCMY2szgUclZbEqSyFZOUc1Ndk1UudKeSEZS4ntOha5t1zA6ciRLsJ3SiWTWEwuxP+YUw9GBOZbWsoTUcDIlOaLkgU08hRpxLTWD1BA4e0DnhabsgnTSmpb0JiOKxomDiYeRS2VlXsTtyngTbnJrEid2k8b9CgbUmX0jOZWabMSpJ3GxtSVCwOSS1V8iXB3Ij/ANjV0lgg05WWg4Inc3HA4Nuw2NbOXN8iu2w2Keib0Re5kmyJzY5bDa/2PJ6JxSk6pw2yTXcprsbsKQ0tQ7KdjbfbRZFDS2LZNA7yQ1cPY7IGrlhsTKTOTE1HG+uXwPJkHUDMQU5HmwsdGOTdBVIUPSJO4oaGTzsPQsKyt6IgNq2zOhOEO220QVkuOA6UZU0x1hlCC0ZR8pI7Q1gu9iz2Tk0oS36Jgy25boqNMp7FBa2Mcpm0p5QknT04Th0GVyRGDcTabYjbKyBWmmlqk9CkjLBwM6W0ibUXs9ojDEWMu920ckk1RyG2lXLk0syU2y0yW8EDLfXJBOHh4RghG16CmIx7EmxQabCdrqRkrUbTTW5vQzaVd/Q9mwEwzFp/2YYnhfJjam1SjOpItKpZ/sVIjh3XY1vUNhFYEZJPkSmrbR8kmys06T0OScWmOhm3eVWBEilIElJE7BGmmkp5cEEjjT4Eb4kcA0kpPu9NjptKnyKHYORFw0O65Ctlv9BJQ0lPYRbNehiTasphsbbo6QNS5K/cwU7zc/IzoEzlGhlBb4CKVbTZaMDSa3MactNSofAi+TkSpZU2uSEnJNxMw3om9QoKJCnELam4MOB8V5+iTFtnwQhLpb5om7N2/wDYVsspJNCqnLfzwNEkD4GonUHDU6kaTM1htqSEiSUpNlrH+30Kwb5FpClXhptQyYaaS25IbwBU1yKoEMnpocGRoTk4eoiENOjTZYpORPCFnuOV7JKyU1Lb0Ur4YW6Epa5pxySFM4paEaSEaobTafUVKisrnbEbRuW0+RTatL7G9En3djhKKW3DXJDUQRg0SojqCaCzJtprbCKjNi6YrPadNkTPRXaIp1lJU9j3bB0+CU4Fm90KXPDxfMDJQhybfJMnIhaEdDSbpiU2SNen0QDcfgHMytO56EJkVqba4HIi7mOUxlrn2PIosMSM7IxxJTbmjCFDseCZrkeDVFRmEJtzuiW5G6KEaGJWTT4Q9Lcuo7G2lSMOC9jOZXkWiZwcp8a9DNfoSysrN6khJ5Vy0KG0p0bEjZbysNtykh1FiF9TizlFu4SlmwmpZiccWZb6E5tRFhWq5WHQ68WViEiXeYrFRYO3ySRthyGySqpcjaTVlDPPwLAWcO8kE3kdqCWqSN36JZ/KGktKawJs33RmRNJtyjCsoepHJQuE/QUU0iaqBMklkyy7UgNIkpSdMbyk4byPQpWVb0FN/wA0Tk4h0XtGySTYsZzuyJGUvRlElzoReyajylsdU1bYbJhCtH2Q4FEvQcomyTipOoC7JUn64SmSWMKuhtiXxg7bEvjB22JfGD2zasMr4qiQROaVti0MQROaO9QuXCT2K9W3nipblzL40IiamwO2lGh5OGNtMipX01mxizg88ovhy9HBFcr7pFPLGXA0jLgaIfrnupS2ltwls6St0Q68SsLaQ18ruDCsGcWnJSpjUIhJQ/tF4ZmbKd+qHS1Yl0FUvcQmY9rtsSo5u5tuG1Ukl5UT+JojQblrNrKXZM3RMNEoaZhdAqUhPIlNHJYySUtucXQvJywUUCTCcutnINRdUYjmUYnmLcRPC0dKWCMkRDrStV7kmmm+paSNJduOGa2dCzgE3/SBgfyv3KpBw0JtoiUmE89DbXHCLG4VA5ySpiMjmJSlGJJWach4h0TwDKRrfIIcNl34oJJcj2pBgeTNXLUPaX0hewIo0MQTKiSiK/SSpSpKPDHHmlkuxbLTTlCUCIYziXA/2i8ZYxJvONK21EpcEO7kScpp5T7HTHRwKpyMcSVbO20SmtS0NuwqwNZotISEAMaLIOw0haNJuJbsK1QEW9aJN9IhscuwZntDbtC+BpZfAybc2CqE0rZeiJbO2SXmypeJUhFm2Ep+hVbaw2JpHQ6yJpW05VGyockfZKYaSRH6qXS04UxHlsoEITkrGO3tT/oR8ZqIhqFDiF9vE8D5layUi3Qul2yE6IN3lZu2mMjNGq5TbGcQkOS2KiRCeBJGVIRabQlZ7wXAUzZ5UHFGvyobVwxBSW0AVUKt/wAknm3SlCi25bbGm7LAbJUHyO2ch2zkG2ckNKmMshjnlkaRjLI5VDpwGvRwN6OZFBn4WRKSIaCVQ01DhhEuW4bdCuQycZRMNjB8loFDSwuRwwhuPYqoXNNcSLBSXlaFSJMZDFClZoRRg7D6KUPSeSbN6NictOFS0JO10nQQI008HswbbbXnYxiJtkLcFNXBUNXCK0hoIy4wM0k6h0YcMnE7LSHQk6s0JQZq0PXocYKfOxU2yaK5fZCW7cKXAZNBjLZuO8goRt21C2LIlbgdxdhCUFP8DUKNTQTBcnHAb5J7cEMsIlNnghK7PIeV2T3MOdLUJoHC1HJBuRCqFLbgUww/ZLcpMHRqNjlpobadbHlNvCPEDKxpqPQhEq//AAQiRZ7uSTtqcjQbkqXMoshILNmHEp9YHEEQ5l+Sm2ygtlstCSHQkhubUKaXJLJEq2mxXLDTWoE2kFtNCmtKGra9IWK2aVSimN/Jabh4JEVOw2JKWdkUeep2lTZQ18gzVJysl84kuU1Wi2xIOFpr+xiOUJ9iou6MxQ0bapyR4oiamS3/AKjaSarunpjaVXLU55EdVDpTeSmGdNPaHC3LCR4TxCdbIbbow5ZGbYYjsstGFrfs3jqLHyS2cJJWNdiTahaZWqMwqW9aUCcE4bpobUyM9EqTWSuSYc4G9MmExXdN5XJSu21k2vQpJkSXSUZFUtpLUETRTj7CM9tSlJm8pIn6kNHvRQUklJppzIYJpCNJaXhClrT2H7ITNTNnAqb2UCqm1O7IKuErLhOnm7JURyt1yOVOG75LdNGVwSm03tDPQ5LfMS6wBCs0eeiY07GJuy9mvQnFrWD9mRRpC0JS6ipTGmZw3jsTNKCDpv8AQlKSo06TEyJdCySpRo0/sTRFDWiTaRcIG2gbxwNpSv8ASCzS83iOiU8nLb9lkaT5SPEtSahchO+wWHT90FE0eKEtBdIX8KiSNEnmosZTFYJIhaXxfC+o6lQSU7TRUEmkadNnQmZStgcOE6SCcQOJ27mGRurycuI0sZXXMLY/QtEq107dxWgV/AncUCeqFEbT9kpY02goY31qW0kjSa6cNSwc0O80ZUkpU7bEEpYcuhTtl6lJC1x/EGWDrGbmHG4G5gbuUMUok3qSZZ7B3dt0SXKjK5HSzRFEpNycDJCSnNp7G2SgJujXYEoxKKWcJSyTQKvSVbSQ2BeCdhfwoZIqlKloQyVOXSOUbaEw2A5YbKBWKiaEWS+WTMFX+hNC4dsftJ52ZItSm4gaThLWu1Qm72hbpVJAkuPpfZAmlI6aaeUxX/J4beewsVPFBDy4fsiUp/qE7NLmG6NOGsoQ/StUccnVabYkNCccv3ooUO+E+Wokqf4ED5VLbTTlyVyqVKZIACo0rqW20lpk7GcoTo33QKZN/Vqzahvfp/IppYUGLVFp9djbWUoyIWRPhwFbnPByj5ll8fAlDvm2KxtsplLWTZKmcXJTBH3STu7b2i3E9M/JKVS08oalL0galNPOaW5EpJrgJExivLkTJJt4GFiMp4JhNEp/ApJG9CJTOXwCy21ys2CMJjSUJqsH6NqGbTWRSsB5XZxn0COE8NLAk7pxxYGsipVKp74J1xFLoboKU74L0MkcryDcDZSIpu+ZSaVk8Mg8SXINptiq6CGU0PgUzeJPwhOzIR4E2QQmZ2NtN0KJGfsFyNYz0HORqxqabXoiE0qxwKbLFAjiTtZbq7r4BE0ZOUp2G7Eom5dPQymeKL4LLUYQ+EPOWHL7RI0qFM8lexMzJhO02YjKbk0OZJ1/ykcxDaKaKVzOyENxGZaa0Jzg2LSRJ9pPpPlju2mQm2InbbYFwRtDSlvlDJpI5ZnllnHDWD2JtNQBOgbFL79DcSY9wVIoc5F/sVQazCWV7HCcs7ngxgcgpNPOLZpjvNDXonscmmWpPSHDTbUfcCTiRHCaTYlpwaS02JxNU63Y8FC02OfiL3hKbDwkiM/KgUkqGu1pk1tIpLPlxExRNtJNDcJyNRoY8DpBs4Dk0TTiCngCUL322ZDZE1Yr/sbrbo6/7LPlIz+y7I5j/sWMJhCT4VzB/WjxxkGE5pGnDTQtPeRJXwlPwhLTVT1H/ZRFHEf9lcUcR/2dvMBI1Ug6ZZWpMPnsV4Ba7MpM5HyHAcv5wlMNJIUTWhIpKjL9ia2kykNGTcSyRNtJNDcJyPFcNU0TljXyZljBwNZUA9tVO+AlSNy9mBWm+ipaE4YlaciuCvcY9lAdvZZEcpU8od2mhGQ0rsJcqiF+2NpD3SmPyL2VVsaiPpFdorBDW0YbGpot4MZxJG8JuXwe5I/BaQ2qh5xv+N3s27SGlfudwSYEG02VprKjQnMtpS7E07FUlJyfZ9pOoWhTlk8TJccESRIpASSShL+JRvIrdSwbU9St0XAhiQ0O6XTYTJhOcN7f9GV3Bc9ITLsrZCby5ml1Ov40en6UJW3SdEz4abNNX1UlqAV01OJcpa0zMi5f+iUmoTk/6HK205hPXcwP1EnahbYrGhexE9DupMMaJwupb/jCykrSSgjZazi7HCCcp7RYE5H/AEDadFdIbiBQ5iP7G3CS9ox8koxoxNG0J7W3jYX9ZZ0QCcOlpvT/AKLBKd0FHXQolukrh5ZhQcXfKSVsJ0nsfFV2vk82wSSWWRlIeY8lOtonGBov4Hqf5nGkkBttuEiM0oOWzYm3msgUIaeCHyhDNNoky2rX8kh2/Mpfou6wTFcPMKFGF6feRO7SlMUJKl5FwNqCbb4NIaap2XAcaGuUIbVS2IM5GmSLNLBpkGnCLJJ9PIiaRpMmU3LSfIWowt5DqVrZI5pxRENK2yuBRPJutEJIaXNpOY0y3Sj7pE5t3GAdkmrWA00T1dSJQDit/BNnQfIhJOHNPvsShQpTfIqh1RPZkd2qOCYTdBh0SjkISJzlTRhJ1ZRKfRYfbEjcrbakQynJp7CFlPsDNUtuh2AUJF0Spuaa/gbcBpHbfCIXsDgVvKviyQkk2dZFKcsm5MhEv0QhMnbDdDltAl2ZG9npckReQ32uiIarJzFQVNsHUG2nAynShU0iFy2ZWo5ITMy518jJ2pOxPpscquEZkdIkQqJis3m9sCSiGFsIZ2rBQ0qJ5BJimi7Bkd8+xoNJqE0hLvVP7TYHLitE0zi9RoknlY3wbU21gEIltqU2JfAmmPT/ADCFFaOpkJtF6YVQnbWnDMDJM6Ga4yfIzLTS2Eu2Kh5ES03ChpaQ6KO9paS5JUBSsHA4dzlXb4FK1BprL7EzjDOxBtEMvVkL4OhRGnmkG001DQsi8vthnDtprhXltNj4Ycy9xoVyps2u+hVrv/B7eG8ak2o66c/I23FaYW0OHgtvZCVHiLCBZJLL1ZC+DoURp5pBtNNQ0SeottpgO2lrgXltNjSPeSfsTs7+QkcsgE0ppLHLJMdGrFseLXJLYtPAblHw4JcCEogSklZNBL2JeCKYjh66Ji5FrgUhXLKzHabd8ExKbbOmG/6LmJUCSUjR+hNKdKn6Jd3IoHxFDrdZ9rfRIT66i1qGk3B2zo/RpXw+GEuyzlT1km6dOhJJqW7cCrC+mCBF6McexIkTbcNMz+xZxJM02SXDmThL6NDJSKyWqSRQvocDfFAk2m8pohOnqwyys4U9NHfpewgNSeyi0lWV1KnlCXFnIMJwSBpRBtKDcfTDaeLCNaHLbvgzc0tFPY21FiizLh/VcB2fRLE+PTUBKLaZzREtNbUwusIMwZDV3tfbDlPWpEJOTdJpT19KX8T1uj/DV7A2knJ0EngJ2tPQ8oQJVpltAkhqVOuaZbXY5VKcF5QvAYotmJIilt4FiOwfLSa2lmI7AOTfG2pyaUJtSVcv+tyy0p3khdPOrvI+t1DNWbSJMcOG1RLJf0Q/FRRS2LoiDZklEmZKHZsTlQ+RwWoTKU+zdjVKUUlUNTDRaehhCmJi/CCEkkoSX1sT5khqD596EDhSgboj5HwWmdMyW72nv2Jku6BNnhvY5+ja1z3RyGyStiS2NTOUKyp5ku1iCqoVFjJWef7YrAs5sWawbCVw3DsI8fbWtlImmph5LgT3sR1ThO4NRNrlujLjxSQ02hVNTDSHDU7E3N8LI22Vg7GRSQaVYK2dkaQkyaVULSZzSe4Xovhr4AnuH7AFeBXIoSqoiZTt/RFZDLip7yklbT9icpXoBTBixQI2ZaYs1SoA9Gp4TVywhI1uwhJby2Y2UMktWb4NpKKTVpto3hiySTeln7iw1wopjUD12NWuuwqxTZG/hPZjQTjSMEXLwITtOuCmCWeiXkhsiUtWT4kiTTUrJiic52tFIld1wSigbuJqeRQ1maIeAdhpSKLjYnFOKR8BtUlyKIbylDlyVpETgrB0qPkfApUoTPwxSObVp9itJMLZCTvqWp4TSOSpukGrFsI37G5XrHIaMK+4GqoSy0OlV7EWehBKwpYpsTZXCqySCp6c4oVpmUyw2HTqKTag1b6iUtAhn2WeaehoetKX+5JUObmqJtkPfhCJMjJ/lJkaa2WhyVcV/JBOdNPg5IJKEqJ5HhLOEuUKk23ZDZEoyy2fgSZGClPYtSzbsEpeE/qW12rhiahLKmJJqWrtMoWhhztg9Kc1EQb01LfsQwk1YcDlQ0iBTp0JIUurN+Akz8Tog5HMKCo5a0nyREyivY7dV2GjEjbrbGbYba1AsqjTltDUENOw7mWT5GNII2sG1tscJtP5InUKWBymTxiHYiwkp2WItMeS5aPlufMtZEzZpmSfqWTLRTrgahZMvYwE3Ofr/wAH2YlCqb+h0k+iKSHuHoJouguXj5bnzEFJActTJfEiUsRkn/2NwbLY3FxsUj0nWCXgMjpCaepFMcktNdhB4LlgOUI882JxU/Z2aMuZDkTFLXI20TrKZNyvYedJaLFgLE2TwqRyStLpkpNJ/wDQTOGsBbMflrka6he19FXUblG9HyCRTQ+gNpQnO9idzcjTc3ENp9U2n9LQyraQ0mSjKVEx1l1jaky222kkh7itFsmjVKm50tm+hyn1+cK1LblOUIbsIPaCbNtpvpLCVKhQbcodpsxM8irBHmFVXSDeyzQgzIKSpQMtifP0Em1OUy6zIQr2mv2TaSU8PsoxbNQ4S/5Q17+hyFhLf6bGvbG7bN8zRCTqRE9kEm0WcZE1TTpqU00yFwpDba3C6CqovoZwVRJTk28JNlyapdMczaWZTYjVR/LYE82XH0Jj++MJLb228JK24STbRAgvGBlIXNtWXXgm1DbynldRyYtTYY2pEuRtBEyRjD01nLRAiYzkGy0jZ1DcSdTyklbTkAmlwOJXCMSOc5KtE4OfNg3MwIh2ThbbbYoiMMqGhPatM8DUzLZWjFlLadoe1bBIknfatU0mmNh9CSQtrT/NTBiJ0zf0NrRjFXCqYlxpO8Lbbbq6GuRYG7KCJO0fkD5rjEimjO2+IiWXc/QzJiZbmSyZbZwlLBZJxeVjhQQFkk7v2KkRwaDaTlU+eBUk1igUMWqChmms4Q0N4uJSHagscFkA+XLDc9EiabYhMkkhQklhJeX2QMEkFLbbwkO9Q0k0BLCSilrA6aXSxUtSM8EIFk7MPLiUJpiea03QqkrcCaS1t4E6EoqXIrV8BttOpwDNr8nBCtr/AIEOnNGuQipFIEiVcLZANNg4TmboHDObHQmmlSahJyfEOROHQ7htitI3xISmOQaioCJlZXfMCUmktZ2Qlic8sVz94XBKR25HKknLl8mWmremuSKHlgLMptcmbrc0JbXJCTM/Qn/QqWacLghU5UaaJ0NBE0yyY8ZCE1FM0X1QyiKpylgypKVlOBtHkm3yyVyb29SUmxBXQRO5Q1tbjoxfhK3lsTseEisz7GlLUDK/s1MlDoZCNpUkM0iYUzWEOZSeo05NR8CMFKy9RyhPY6PRE6JPJOpIb3iCpJJqrMM0K8lJw3sSviTQ26Eg05QrauRpMbUNJrI1iweesjRwGiqXyVKHMSWyklVNIsDbdYM0EXNumkPEVrLgIesm1vsil2uE2JLCYrqK5cKPwKJQox0JRs8nKuREJmlm2s1hMu1SXVZGUIJ8VtkSTCTppsdbrdcSAZcOBFkdp7S0OnS0skzIUSW3qeCItThsTwQzRZSP0s7kSUJRj6A9IU8OpcyeIDtIm41smBA5uSOdbQluEaexqs08xCWvd4bG0N0pkcVj2xqRQUyukNmG20uWB3Py0tkRJLCaUmEfUHELz0yZpSxxOQ0JS52Bo45IVdjE2j0s2S55YU2sJ+wUDTSTCrDFzlO8OhmlrKlwNNEVr7B03OVCCJJTlKB+dTthJi1FyjMnsbcC09jWWnwYmE1jsThbChFolJpwYsLRRW0zC4IbD2SlCSWtiYi6LbRlzS3gNptL4AnbUjVMSbUIN8ilS2bG0NKaipyODthb5IcCJS0ZE1kJlH+xVDlZJaGTuuiIM32n0Z8QTartu/JBwn4Lgy1NwmxxZPqGJf7rL9E5ogjepwxlEHCZ337BPBepZQnM0mnv9FT4w0oWfTfStskRveKbcJIXaQR4SmWNzDKUcpk3OkcLr6JcXPs2J2bmUqf6GiWnt4zH3f5+ikZSwm9UCEoaSn+iiNlomf2FTWNS59Fcgk9fEChLNe9lmhyTTDab4EyeGcsZUFrczbWIFHwy39Cam0anDlND9MkTjheiFxJcY7RBIUWoZhIgPDbvoQFqIb1Iqm4mU5JUBBZQxWCHQkOm5cPZ7QmduJK2hJTdjyKEskZFdJ/6LJXdkwoZkJYV4GUjlC2ySoTWnTZH+lGZR5dNzsprBJJJJQlSS15eJJOqmaLhc7USAW4eavs5vpyu639FviZRNEVzfTX3o3KVOWIraJptCJyaGbbaCya+HLYqnw4H8/Q8epJUoWwNNNQ1TG8NtNS0Wk3yQ9JLflNHNJNTIw1jbTVl8E5GVKnAnCI6dsShuTamn7Fcu57eiSWVp5Yga4hynzAnIsNKZFLW3FtC3Gx9TLY51KfEfRE4yTG3CC3JoDAiU8LhnyMYVPdvvghy4UthJNSVg9kmSlPwGmaUNY7JTJQ1l9kykWoTRhDUUtjKBl5Q0VwnUcGUvdaHUVPOBwoPIRa7b7EW1ttom3GViRJlnP4CItj2X+xJicixBSKUPFMv2N5FDtQ1JKjgammxzW5bJNCJTK3XRaaZTtrgVCWHicJ9DcG7bsSJnU5eRQ21OFhhIM1houtcqE2srNQqm1JNxGxttMyyls1VE8bJJJaWHyRIQob10LJIlGDQrglldEtNihN22UeZrZZ9E7rdp8dCTTXaV/ZWAsbwbG+0KNizQlW+C3oSR9ZQ0zB3YGziEso8P0Qc2cvZmSM4vmXwJmtsckUlKXQu5JMly3sQ/feHuNCZdeV8jawwlp8t4ETJk3RQ9Umkol+yU8kU9DcxUOi4JclJPKeBOVAjP/QZJtFtueRuqu9S22NZKDrSeZeRQsknqZRKLKVi3oKoOg7b/ZclJuaYmnD2OuWSZIhUSCmEwxTjFCXj5HaioR0XQ9NpWV8DVC3sNo4RxcsaEVDU5NrgTtiQSg8PI7JJOhZQxS20XWjZ62/oOTh4gdzqEVoyW1Dzffo1HR2tfI8t5f52aVQ/0SaEpna5kklO1JDaS2tihKqbtsZsqmW36J2abdpr9FpF0wdlNv1uJFELu/43P1bLGySko+tRmY+5InZWtnQnq+xdjXTcDZMHNQKeUpHE/wCzTZyuYJlJyeJMpPTeY5NjNnnnUpY5TS/aGC5raehNs1ci+wynKv3FZ3CYlcsUS0dQFRskpZTTZ3HDCnoOhQ02m7aXI3MN9IUocpaBpokiLtIpq1SGhN5JbcuRNyS4XOhWFq08DJmkt6E1JaKfbG9VC5hh7bgaYzR4tsVH0XLGQGUySuLD7bKW2tPYlrGILbjmIOy3xk75Wk0WBUSqHfQh6/SdYou5E3qMnLtr2EsVsyhmBXCS8rj9DgLzdtyQ7g/ZbFmNaT+xMlGw0xOdORDaRqyGzSck4EnW4GNN/Al+/wBClVD2TUEdpQXyhuFeWhaxUt4MvKmtvr6G0k23CVtsRJE9bbhRJ0gl0Sa2lsxtp7GlkltlhFUsbxqbTP8AhG/ozWqNgZ0ULI0yS39wlqAkw7eIA9+PofILWExvq3p7ZYq2JiZ8sNjgzOZdDht+pPYpxTChcVjM9Dg7qVohSQc0CU80bkRDJLWhmzW2HoTiWtsN4LkqGwEpasYvXwOVrNJFj6TV5mNKPombuSlSpbTfZrIjmO5NSqwqe1/uPoguFBS2pNqHpNPQ7nBOCZJvkN5pLQmiLOCWodD3J6UqQyCUrl6r6XvYp5UNM0jWU0X+q1ThCkbU3JOGRIpm8Kpbb28KV5mIZzy03Q2IaadNMlbKKiXBRAWxJpTjHySnTXIemTlYspdEs1CdQfy083yva+haaDE7baOEg/aFhLX6EpTuJtMUy5pyDUuG6KnyfhRJhCtKE3wcuIFC2mxidRw8OhOmsJMpjbTBlG4KMq79jb7HA6EwdhgeYEbGU1LcCS0y9NFN2URqW1jA0NLKkpx9zGaH2EiY3clFLJJW5FSeS0ZNGllZLSnKdOSbE70l/Zjj8opRgwayvY2uJaFZKl5T/UjTcUi6aMpY3I22aSmpJgibTS2joTqitZfSM1xlpjalpKJok3tpjKQp0cMhm9XZVLYORqYsvuDb1gElOCF+5DkTwutKFLuU1+ghrSDKeWKE8brtI8iqXsHCbeSmmzicJr2JZOE9aQsJJNrUfoozNtaPuXSOGkoRyY+CSGUYdEI7CWzUEMlnpvaGjGluyDRQaPcmUDSY7JSSxb2fIm5QbxhnswheZeHyKIRWJwEomAqa0OCQ2N3olipZ8MWYE9nIpYDDQk00OF2ibcYNsMk0XFyYfAkFC5njQqR0V7GRUkPuD1LJpPY6Sk25S4G0kTN8cLsdE5m5TXQ4SzOHwRtIvWmQqT5dEjbmirtoabXvCbEExen1Oyc0m5KPZbl3JHmehtdH2NjfAWH/AGRrxR56MScjvETqtpwZTi3JJiRhZFr1oBNSySy2kNJKEAaAawwNtxpgB3kHsCC+b19mQjChTysjN4EFCMyuGEW4Zbb6g9y1+Is1JeOCgaGgyGtIzW0jn0i0HG8AQSSWAJKdrik4BHj+p1oy/QVNEy6JlU+7geFjmdQOTplrhr2TtTTsTz56A8V9OtfA5WCWElspE5ugdNAbfgaHDX5EKJdrykuS/IsJ8sy7xop5E0LHEkzHkGYdh7IJKr5DtJJRmCRKFtokmoVRLtjGNUsVqSWmb+wNanicfBNtnDHbZZlqRCxjdOWydOd9LEJKUThMDbbctj0jkNgpmG0PKFk7hUnTSX2+hZRS7MiJJBttlaGrkZ8Bt7EnK4sThuybSM/VYGlW05jt/RKIBNykkqS1CgzaQ6WWxyJFJW9scm3sQpIjaThSv7G0oaT4GrpOA0nD1OWlH7b+id7K3Bwa3s6jsZpTcTtiJJ1lK/MgLtfQxgoolNX2sCsU5eYaKcQaaE4hlA3c6bT0x72UHU0m0vDeBcTqfoXkaFYDPRpgjW0TkWAD3AWtdPo5wFw8Px90NZWjTWfRNQROU0O4KvzhucHWnBc5Q0rRBPp0y07WY7NDlrSIzQnhDWwrDZkWSwhvZGJCQjAob61HKswoaLyvoSMFAuO1WpFbxiGgfIPcyRttuW2OXPibUHHGaWtTH0Ul9uWzUUO2mO+MjlapcNwTKsT2tsmI+QSpCnTXA4UlVQnvGbN6mNOmIRGucZJDLdoUNU4VH1uOArhidgJFTpiCaR0arKpolPk2bCY2TG5qm2XIpcHzkwxUzE50exVSjkhK4hI4QWIX2/oaqkFqS2uvyFtLKW5ZDSVK88IuycLhkTcQltcmXgBUjT2ckrNpyFFpclwKaJeZNDST24omHJLKRpYss+w386noSp5WGgaZxool8dD9Gx8ErKC67MrTjiXBcpUexwqsew28qgpMXsuClWcUaIsm03MZQojIcfg4bPCaY5V1OjO2gkOMaP8A0NJu8cN8D4VzZTtSi2agh8hVa9sKJOiefkTvFzpZML7BaFknDe6Gkqarhga1Hp5G7g6WqKSdujdjpStFtciJeeTGbY3JiBoyjfHwRaqEyhScWkZNvgSybO2tEWPLYlijA4FzCSSNMkWoJENjShs6KU+RtFlrseGCyx0IW6W30Ut222M20sQUcKL0w40tPZCFRbXBCyWW1wNJwF2+BQzZHt0p4Kl6J1ZDVs1agUa0i3IoUunEy2kUWU3id8ClFFtZCUCuX3YlpOhBOzmqfOi8imK+GzIoctIghTejQzGlzl8Cp28NP2KWii+L0SxrSfDFKfhcaTTWYWipJMh8MoXLjkMlaTDkLOqfyDzVxUzZwTFlGtEbuNLsmH571BLaybWmNtcDPhI9iVJdtPz5yZKl3aVCk54y1yE8uEjccmI1cFSY/b/BR4AfMK+zM1DOAySyNUDQWTbteBK0jmm7/XlI3RT4R/uKHpbUuxRIpIGBpiW0h2jKNXIyR0wmVllnqEUp/wCxm8xFKY5JgmpGoK3pf2NuqT0Wyz4FgtvgcJjLzwJuOb2+L4E4dLNuWJXnfkQcuSnsQjKUcuxcnd2T4FbiSVPVz9nf8Wa2wPZykLtkJ0jyWcw2STJkJTQEyvIzOMFEcjcgoSzlc19LVE4+MyKSThSmBicynJLA1oYeUOAmTWAgjRPyLo1y2VIFltuEKowc8wi0TXzr6JkHQvGa5bXn4IUr2qEux8Z88YV9Tv2vouNH14Z2lVN9xsRtWJMrLktKSGsdiaFgo/2Wach1hGW20nsff0XBJH4SXuQ076G0iZtuI0LSsmlk2WXpVhYxt+Y5aKapD1JlF95e3Zh2hupOStp7Jkqot9jocTyDam0J5CaTPRY4DTa4IJ23ogknPjb4Qmm26JnmJES0mRWzASRSxuEluysMnK3F8KgmIq+hfxfph26HcV6mAEmTPZCKRHFyD3k1PK3j6EpMgUlX0uIE9hGhy4K4aJNuO3wJv/QAlNsnvgQldYcDBgqEeQlDSbRSNCgdNYNVY8s2HLhaEooVqnOQaoacDTpr61fyapzSTaLO2lYQTTswzZyfAWRaago002U0rZC7dfqcnamd/QtxgbcpDwiTvuR4Q7JcjtpuW2w+imvwjiBtqFV1obYCc5JTxyz0JppjTPsTm5S1SKEm7qyEuII4fI25ec3wO5HDFERBcDNEotJjcsxR6X9lqJSsOhtNuyPiXgt4JzknkybiWyQVN07TGoNMUgTJjhNKAkJlaCUNj3yJSpYY7ZKTQGpRYwfI1RzwMSSRShmWktLKQlgw8ilPYdiSTbynl8ETp098BRO6eBQelmGdmkyyyAeDuJShuOEqR2i2vuEpKjMO0lG3QsUXX3DSSR6bezCYFaIYYZPwFZBr5QokfcJduTnFiWUcQjK7FLhsSVhNBgI1PgZFo2vTCFZK7k1j5GNuRY/IjlPh6bXPoShUUkPL3RNOkSgREFaBLQ76KgtcUPM5+wk84l8RGLUUJCTQjQu0NJla16Q0olmt8JCiCs5voklaHPOBX/2QNDSVxMWEU5QmM6KdEONmwjV0KniqfkngSNPAi0rBYQ1B2IpCUpophSehpcGkX4p53l0OGkOFyki4PYSzYmWGZlokuR4k10QeGMuGjkYS1clApqVN8ITRl07TlCGPIygd/O+fMpuMv9ogOFdJWRKDLNL4IhcxUiOEadNPkmqvdGO4bCa01/gK2JfXadgcMxy+hLTisMdlBX1bNzh7bqH2gk/omWV9l5RCFJWwE+5RWcskuGJznhSaFDC8bFA+Apf5JJOL0DrKWIRKqpYnCTILK5G2jRQnH5GrDhtF5dAkZNauhNKzlXRDSglwLSgl6a7FLGZYbE0118DHdpKRs8JkxT7lgqlIyNzP0v4Ln8+p1D5YmqTlVOnKTcpdoV0iJtuph2Qk3eKWoKHClJXQkzUwiJKtJanH9Cn008lB5palKU1acWhtJoldewhTKaUTdxdJihl74DpDwE5U5lUqLpoPP0LbsIaaU6eglbbSJtGHN2Ll2wlah5oVOcnqJLpfKb+hzgKn3MjjqD5KblYVtORK+Z6cFjZKehc4DSk0JKThy1SG3SGQrNIUswhBOW+hrCIWmKRaRgU04qSJkeKlu8bnLH9HAOYyUVZTM9VscNLVoNOEcjocNqzcuBkC0zJBppJZZ5HKPBtdkqLhm7HskJbS2NumvR/Q23FbkG1DsW0IzKYmjpdSCLUKsP0NSmk4b2tfceYUzqdhthttjblpWtxemidPUP6Y9ST/AJVrW2UunDbKThrgIM5cNfwMoGqt+gqTi6YTlhHhwKWNwEa8qkTTpK1ySQAlCzEpSSuz9Q5PygUldc0klcpgmmk0001Kaw19GEiIZdvhwk0NLKJkjbXImrMpqj/odJNdvbsbyqxmg65lYMPFdEIdJKPoV7wUsR1CdIxCN9mRJTwsUkwfY5y8S5E4anJ8hI8OpYGlkZT2LNfAKWmxLApFaglFkcti0pIZtYSkDNoynygqlJ2x06YSlj2BB2tKqfsRJHMStCKVqG0QqLMhabVM4RFWXpCyZS3iRyji2lJvRQkRVPBlJq3Q2QoFbOjBBprJwYdQyNQ01KXMD5ExMOaTckJOGuIcSmtBFJNVZCWVKXhMyFGHBJjG/ufA1Plj0Ibk3JoSVZHQMcNIQOW2ysSaZn2QNKyq1wPGqbTWNTgTwG3W+RJqR9lwZNvLJpvQ7NnEMEn94UEopMktySRm2neFl+y09Fcz2O71C047KqY4ImpHqHqHSkJN7Wq6HaR2V3VDUN0SmY9CYi0KdhJLfGm8jTnaw3mxUyVrIJkyfwCExTTWa5JkUEp8jbiTNZHQpJUMhLTuI0NtEishrUGWBjgNIKaiO8a37COoaJh8sVKeZjfYrceZRLQuGTE1t8CFYiJSe2QRij9iDm4hUCMk7vWX7GylUGHzIqoybhxvkWFunOiUKHf2EGUSna0hMd2P2IZSElv2WJVLRbQ6b1OL4LFKzE2SWk4lZIc5lto1P4/LOaFk9zr82YIpUpdLYzSkt1wHhvjAFdptOZ6+po4S/wCArvKlaFnKbPaUbzORTAm7UJYZOXmlPxhdpcPo695M/ghYtpJUPPJKTSltcicm6P8AIVuGGl7CamOcrXY8FU7J1yKiMMuCGkk7QfYUUm5jKYngU6Z8jaSTcZCSSGpkFGGs6FcQ4Za8Z2JUHyaYnimQNzUyh3sOW01mVCSp56jLu5L5+ipFkg0tEEIjlBOGAwUOkSQ7hZXaKIxqOKZhfN5ky6NqKG5e/PNkLY7S5LM4ttbG1Zo4LGmKFoyO4slUcT6i30ralpRM83Cz1HRtTCoWPYSQSPYFGHqM7wy5wyQ23CHWEkSaZJlJpKSHhU2Z+ZTgmHLrp5edO0m4M3oZF25m+Ce186hpPiKfQ26cvT5Y7tMgmlRig3ESVW+WKOy1GJ5thpJJS2PjiVSRE0kqVR+ej6L/AA1EpAmaCf30DdTJHc/W2zbbG8k3ZO4LS206JyqiNGo+hIPb5QSK0UsnJLwyE3PaG4VxKGqq/VDtQlCYQ6bMKLlWSm20m2J4icYSYcGvMe1iiUi1qSlv2o2miDMJkLYIbJ2mnkTNwUl9yNpmqIvmWNtAucFLDbZwkjE8h3PEJTAdpeW/5MmoDTSRNSrolcclQ1bSbhMJ0y2sTwh4NafMVyysiLm4s9jjaYRUkuErVUM0K4lDjgeC3drXwNfuuUtTNbYObbSjoLy9qO3aNSlBzGEprWVJu/BNoaDsjDY0EZ6G1YpKXtKZLQjlTYz9qfP0JijAXExg+YTtkyT4118mIFM208ELa09cejG3mxQ27TVvghS2pL7kNplw6GblI454ghN4S0IStvBEWvHEDayQ0vkPSUv7iEVRN4sjaJlXxQ00k17DUM5JJyLlf9CteZYbKk47FLbUR+RQ1LKwxFIcNWWxtD4DTbYNcDaUEStcjUDlL/skoRb9EENQ1jTQ8K0S4G4cZDlLNtMiG3tdkO5QnhhOU01uFPCEc1SAqPBMhwTMDmRyTYRsuEvRDtJLiUOBpOElqYTQ0mTtK08fAzTih0Ra1ZXoTJpdWhkdPO7KNeyIuTSExmD0wFKIXZnA5Rk4RiJ4YVPSEbTyhcRtasgRzTdzfowCWjkOa2pL/sSE4dCZHnYmUlmOhxLYl6PI4ynPDHQ4byLE6WWTuXEUOWDU1cGCUUvodWVLw0iVQhFLONQho54tv0ZEzvYsSipcWRLuO5ljSSG8LaIq0lbonY5T/EugnaYhvTmocbkhUNmJZTqa/skywTLG3BwbR7ghLqs/UlpLMuYrnE0S09saa7plrsbs3Q1+xElEcTpENlkadDy3DoUUTc/bxInJ0iaZks/hCBJQyJ5G3OEUSTjJR06SVy2HXmm8EaQIYnTTTH+sbMp0/wC9EtQ3DDz7JSE1NC5IAyNIcWkoGomlZEJkk0OU08NP+aUgUE4AktBP76BgjfDMbrbZttsomyolMoyvJYxSIlNPSw1MrSvOfEygX+kjYs5q6xuf0pRKUu7vQokN7rf2JvlWXbpQ8smynD2DbKTDnkkmilwkLevcGlJpRsMyVzwNxYVg4nroOG5EpPshYl7EE5W8g7NqyBJUIFw7PXsdJDbohdvSQxWQFUS4nbDff0NQo9ZKVCe3322NtYwlpafotZw1hdi2XIWiUzVofpEqFp54Iy2UxfRYVTOBhVS2XwIiqGzTFaaatQQADEUl6jVSh8bX0JYsGpvEjTpk+mNVTT643kHo7eEiUeBZEf5ugUdqLyXof29PsBQkauCNuaRAQM+AmRaRE0xzCbqT+iOw9BKXUuZrzEJNgyX4VlOhK22kkZpCFhlemXFNv1lKjXyUSUZYQhJekvoUB5IaawSxCSfAsx4E5CW6baUl7Y6CHI8GW0yuEuyV48xxNR1C02pUwbZl9DBNczjSSA223CQ5LpMphCYpNNkS2TRAmDLK1smEwTVdjb8tCbaMPKT5rE82/pt/B6cnpsMBMdmQ/EOVwiWiyjL0MruFqcE2myHwuGPNX6fJwQO0cJGoIF2jaak234gcFGrVnJBQSSUyxY586UkSlKYYRbTbfAvg2KBKJzc8cuv5SVAgoUNvXCUwrd/ghxlxMcZ56HZUdp0NpdC00hquksjooYVQ108lkmFFpsthpExQdtMtNMVpoRocxWVjiRCqydBnRSGmTZbTQ0ZNyuxLAq1HmFNCy3hK3QuNY9HZgwiozIb6Jg6wkqwquGMOqu9QfKedCblLlrAphVKE0BQmV0TrNEPCWU7j/L+hKJZOoesvSvpsdE54II0JT4IZqsJJaSvhkpSpLhjNNXAKW2ialwaFLT4gSaIrJ6GdshpWJ0lqNBxMUwlLmfcPbGgTBrgQ1Ei7kvgl3Wol8ky0qW7kai+eg7lnXAqtYwMatpSvsZkdhOU0UNbfomoO0eBCrSjBLhCWUMbwW1EbOW10JYTWwErwMBVD3uUJy3E2rTQ1LWh5IXVhLRtQkFMqHvsbaQqMjSShq/UcKiG5JSGTXYiInLSG6p56GpcJbLkZE8JTPY1JJhMPoWRtpdLaBWyIRy5FArMORpt4mvukJEuLS2+RJJNoh/LEYMaGuTCUtnCIJIcsp4BWksz6MopemqbIQrlr5GM87sP4EonCXTcFkdo9pDQOoF7bWiXLoT5iy0i7ZFLOZ8X5JbA6bYowt0dBEtzmg8nmWtdCbSJqbPQyhWfHTEk93/GjSE8gdN5hXZ7JobcG20XcFBd76LuKScFyxIbu+WSxS8JyOex1DXHJNPh5RCcuXV9IcJKzNf0JKHeLiS6laSp6HKE0bWOqGjJLTwf+hw4JBafgbOb5E+R20JMp8aHUpW7bZBNtHKvsJjAOl3ItloYkte3X7F2QMJYtNNZT8vtrmVTJwrmWhNCSaJ9Ms4fq5fApZsuj8ibywVvCW8FJZyEn8rxllyTiSQNttwkJ0qw0dtJ/DTUg1KEhWKZa8SWxKTLb0NZECRC9bbNJJC4pVgWn6zIH+ZFgKBxA9tXuYHCZs1Vd+xNIl9jDNmEw0K3BnVDs3KUpR7XRTSkaKZCUAt94SUmS0uNyK13+QKFh2xyhJSbjkmFq2GhhNTSblkPRWnLLhGEkjIkmkzhwextxjNCDNvsOTDfL6I0RwOmLG2nPowVWixfcYSY8KHEy1eNTaOWT1sM8U3YkXC+Q2rrJX8iSz6H/ALGinBQJqDpehq0pXl8FqFDt0LVJGFHtHmly5sN/HN/WYs2zSWFbwrHQKtZlQRtNdJilYiRO1NX0RlJI7ngjSdddhpe/8ZdlBtoSK223hInJb0WmUGiU5UiiYO7fQ5PKss1FPPJEfVrbb2CSbVFW6bF0HJLdmJppymv48lZSkVo5ZbYuYoxO4em/Y9hiDDlynL9pkuyXSyeFFVbSbTLuJr6FoLstqjLYKKdTKaSc2rlouRWLRa52wytCTcDwy62mwXHUvQeybh0vKUyhKKJrmuDY5XRb5R3jkYdnkOFoyHDRukJPeRkbbcJZYbEsNjbb+idgxImJQp+iqQfFe49TbUMrm4V7mELk9IQws/uT+iEtOTeGUUolrYksiGG1SSlo7w4RtLJsJ3CyXsJm23kXOgNKaIWytLoI5GP0o/39GQO02DG9rUdkp7Ghl4E+Qdo26YLPEJcDpaNLbCyTDVxyS0lkkJ5PF2jE2LQShkrZaRSUNz10NrKdhohS7Ds1TvSCJtRjYOOBBaWpUatbRaHg54JTcxC3BKbxsG7mQsrkSy/2DClYbBaIhOJyFpBKdpzmX+x02Z3JCVLL5djtyNLWpEUKlDclImprD0NN1hw+UbTcIeRJNSF3yN2AYaTn7hSc7kqTWTprhCwK9hST9zohJDl/oKSychhf6RGCbGCDNFLk0p2I04wchKr1HCtmhFpIbbtUv8OxUqo74D5BEutCSZMpF+4kkdyjL7FDRavfZFgXYVPlGw4hSoyx4J1Ja5GSKVGLsNqTFCXLMSuKW4jrQxM6fgNpjZa+AdO41/0kyOediTattCadlQUmek8Gp965FENTWCNjJW35dCNVRXLm2JNZbgiNpOlLvmSTwUtV0clBXqtITKTTtxoTTTZZ8BOzVrJ98CaRtzO57eh5wh8tlLbijehKOvYSWJpn0EIekcwtk0iHY7CW4nbkanAIulhMK+BlF2lOBKba8m/Qmk5FZbIkRy+QnQ3X5IqNLEtLlnTbnZtleL811/aTzjUlGdIIYjymmsvbc6TuxqCTy3qZacY+RJ8i1iWP2nTVNNCPCIHT2Q0sRnbIct/GH9gOUgS2OkkrbZe8BmiDSl7cUTMN+GHkm+a5UbRJzWKpDvKvFElMpRuH4P6FDmbSZMzivYQnI1QUZJsiUpY0W5JzgiLDTKRRwtqrSJu1jDp2KxnDnQvsBZF6VM2noUjbe2x6HUbGGSWKeL/QUqmW29ihU4n7MiFLLU2yJiRyZHQ4TlEOmybaiMJOSza2IH3ZopRmm1IvU6+ilFPcNMNPlNGWjaT+4myG8Nsls5Wac6FLNtrRoJOA/wAtCUpU3LxfBoommDSz024fBFnVORm0nIxss+h9wSnNSctY1sXKolJDqaO2pQvH8IE5lbXo21KRlIfLhJsV2w21rLulKeJWFdnOBIalxLWhZadTMLQxZsjUpqzluRStPv8AigUCeVJlzC2nvFjpEhSQiXmmre0+qg4bU8ooPDAtEySCeNtG8DJlDla6K3QJZtMynOGdPQ0/xGbGobnkgS5TzkUIxLQ1DlW0ucs4StuWMbQgypQ4JlZS5pmklP4RRf0GFtoSZBV3trCbejJa8SzxyGNxTSYjobmbpP3HBCa/8GlZbVyMdyo6qqq/n+o+hCYk7GWst7b+BOyXNtrQlGyGFUUHI5u1CVocQTHrcW5A7W08qGNk38Ct41KJbdts0kJsaQ20hccgjcqXKRJubB5MCpg5nK4gtPNCUzerPog9pfsklQmZYEDFJokpvKQrwklr6HkSyvOVKYmFN9RomlV7NsacWqdGKisgV2y30Zgf/TklS7E/sErzaZfsVYJbYskmno32UUlJAiE4tTSCSanT9mU3cRaIZhoiMTwIuk1mkDiLJbx0JnuWSk/iOCWm0U5PoUJxe0+y1w9jgOkmnlUkLYFT5E0mu/IlWI8iLKGrXZDSeVaXI5ow5r30Q0RqU+wtCWlByRDbWeiJgcE7EpFUq3QVsgI5z9gJWyTwVCThC0FCToPATUUjwxqVJyyF5oyLkltJRGgSjqyYZFmMLS32JePRtDSLKjWX7GuLgSHlajGl+Rcg4rZI2rRkMk5jDgqHm0myFLB4U5nFCesE10RgV7N8CR4WPkklLaNtxMVPyvgkpraP7INE9GmnsaUEctU6jsqKIdnwKXZQq0XOE8fBKlLmQmLCKJcsScqYKEJGhGkpJTme0iDaMWtuBuY09ujgtpKor5FLdZchKoGKTaIKDLCFifSWOEJ46EHctiTwKpZTOJ7G7aNtKpEtVYmM3pL0TIFLLmcwNNq0aMn0TRO2n0FVVpNirTMfaR4Sw4Tb/JB8KHxA9l/ZjsU1fBoxKSWchJJ5GrWliEVKMU3wFJY3CYfQz/dQ7aKVtNFW5jbgRokrM1zyYMT27GobZbBZQ3XHrGmj7NYalOUMXdNOHJujaKxkNBCZBNDlNPDT/gRHHCuNtKTGU82kKnYZiFj2dp2mJzQCU3Ox+l0OUsTVtEE25IYLuIaFKUQh0pUiaDFxwGw2oJSRxluIVeW2zKinQcXepL0A+7e7oTmGPS5nKDy3bLMFaefZIpTJkN2lTY7EmtSNSgRLMXQWGVOhiTL5yEp/tAS2HiEJik3Quhs5zK+w07WVwMSJuWEaShLJE2Fu6zIVmGiUo4ETL8HTMSyU21Vsn0LWoJTHlqELNy2iTpbwF7JtUrhLQmmrlORk27SMhtD/APChQpd+wUTcppDlsY12iytcxoWFTa55gdHnyjRa2ti/fzzEU8CJptvpnGXaU5ZcOCUVwpflG1oemn9KUeNp2ckIfEht6RIzJwV4rPwi7nAUNCTTZzH9Cpy5djbUmr/QTECbdQmLDlEHvIrbR0tNjRflsV55NYTDtKEy+r86rjJQ+5Pi9JoGYT2iNmwUsnh40u0CXuSRW21SRmlpNITsxs0ys81epE3kooU9jScDbMhKSp02URI2uUxNiTcTaMrgYmc1LFCFBrQKdAjTHFQ9Svev6W0k23CVtvQjFLUpIMCzC82lxtCkwnCJcRD1dyH+WBttty2zGdrHkgkSoKe0K6G9aQSkSLE2hOU/ItNExflhCSSUtsigBjBGw0jEuHEg2mhPhRLSi8GmYQraFXcqDGyE6jKHXPNrPu4pNbbZChn0Oq9ip6Rtsq5iFIiYsJqRBn94FyD4mxOJqQpcETNuWJCrJiwkFUcS0i4JtlqrZfxIISsp/T3RRY8iHbYjEJJQ5ZJ9hOLjSnLFC0Jo6yBtZQ0mmg1dHol9rXI3EtNIzYmslPSP/KxRlekNs80ODETaDSlQlk/L+Jm4nEblZZQj24RtRGCiFrIZQQ+EJlKpzZRJcCLSLgaMjBCVMrDNJlmBmMjEjJNGeKESZNMvYmUSmOPgUvhYSGpEqQ7WUJ+A0u1lMwWpgQeks8/IlGluNiJDStmBCczGJIVsqHwIMDYIk0HeRgkmxH1JJiUpEe40arlOehqCju9DUo07TudCSk1aye/gm0kUJZexqWkcbik5mHoqHbXJoKbpFJpwZI8YFEy2uRKxPCSBNNtvCQcyUZApWWPRRlvI2mk7uzFdsG7Ia1dPKCDYmsCDJLBKb7Jhu5UbfOxZNidSyTAKgk1B5Nv0JtGhpyxmhpmsNqtkchQfgxpJECtQbaWIIknZcNeC2Fyt6oiY3leUVoUFtiYrm+eJFEVPWX2KQNtkM9MSbbFRCnK7RdOu6e3Am50aRnoUqSTnjM9ne8A2c2TQkhJWrU06HDgdqpUEotqkscUKBCU2eF6EoOAnYk0clLb1PY6mYxYe2yuTz8CzK3JqPQk0kgrW1CtoRrKtjeVw7VkbT2cIlJZ+SRVpaSb9iIWaUtCo6zhNDWlmaPQdO1s3P9DQlGrLTIwa7NyQlpNNWKJtbXLIlvtLwNCg03msEtGIaYZ+RlkapNCBOBYjtXaHIcL6B0J6ZW/5MGrPkOGhlq7WhEmIakKIEqcvspAhiXzspwl4qaSQKYsbbkSsZRvpiq7UXJghaScNwtppNeV0RbaEkstt4EMmXAqa07U6UCI1hca9iS5ZaFtsClGgi0ylpOkC3kmJwKa5KTaZeMA7NFO4SoYezWwpc2iQbNJDQMIQDbSKSJHDaVJwXmxAtl9NqkJbzJNoHSYNNI3tFIyoOIYCqlCyCTQyVogd0YTU6Ft/AKWASE3awUaNpsDsCFtimr7Ky0NTE1ka5Y1JhqByhFjqbEnAs2TdqwcKVzmJJlx2wh07KDx7EkT00NLhpq009Cg0kyVhJEl6Gm0+RkRwUQtaaWIdifaJbGGk+zaFaLyVlslxGz0NNUEphobbhRL0xPNREkje62iqC2HyPIxkaHJUxOextwVtbf6GSlFGyG1B7L0HRNpbHKJE4sR/dRSqRRJNTZaVS/m7F0isH5mz+C61VEMppNKlmf8AQZNKFC9VdqWKuCKDTbhsW3lmxVo9EtGiGimOeOhnng6fAnMDwJQm0Swr0Fyjtz1LAmmnhoUOhHAEkiikkNdIWZQ2tI9yN+i0JJFhs/7FMr7KY35QgSlFIk6mlZXmiC2czDaXL8Q3S5bYokln+SChrfIUUhN7TE22s24ll0J/oSUyhRKViYbFFinEhuDMo0zlCqVTPTHRAUlI0gfhBSTiRoWlDcWGX9g+ZCTi+fEUY+RKdRRzc036JVzO+2Yav4L2knINBolbcMacQJRQdsI/gEpPJcdCc7ydMoUX+R8IuQXHMSO5FFO+cQ+uVcExL9mIs0g3acla8MwOqTlwuBp2W7bgaclthxXbT/MAaaalNCUCFHyhJCpJcIR0uTUGxDPEssKa6Y4pkhukEttt22ZtnDqxYb2bIYKLgUubUR+QvtCPxVeKiEaIWfJwwoqWXLX2LPCkhdj/AByRDmmHMTTrLYsIzC1CRzoROUstiLAHKoSk4SRJDlopqQ5VDmwuJ3DL7JahdqTYsuUqbfAhNPcpYFLMAoU5uLr6kmVTCdMnkYJLWl+YNslSwgvEyjLEpFJxdmCUMh6DU2g27fCJknZZtiWQ4233wJSdgMbZsq4Cav4psROWpLkgjVIwRFp4jnrAnJKh4JbJbm6wx/Y7h+wcslNNNEUzTlDBLU60MkiLJPA1CxSSyZEvd+zHLpMUS2w3CgbI+k5oaZeVdNmRPPASR5YJclyPQQ2iVRC2QElyiEOFVLWfRdBLdshqRKwaQ7pLYY6Yeww0XLAp20yyII8TwxJWClKgt0Ii1zIm2NvILfC0NgwiYHhNpo9gFtOkl7cE4HkYEI8mYGzJ1vj/AEOU2zF/IlN2sYUKXa2gpeVY2TEUqfMElTVNUzgSZasn/QUDjRS2qEI0jE8jZQkaTKGmSSVX3gqCdYM37LVROkhmqzOEWy9RKS0OzYSrHyOQy1qP2InN4qOAmgbiuVuBNBqifQimiis2NrIeLRRIVRfyRCSozBNKdhDXRN2KcKMLW/HA84ptlZQjTa7qUcsyLlYvsVu2Vg5GeC+J6KRvO0ctJCK/QtKN7bHle/L+how3T+eCSQw8pvIkKN3ch1BUwqNDKGSag0l1xCX3G9kXObGORy06pT4GPJFa4Jd2KJ1RaSpfwENkyik8YJgna8IqTcQSA6Q4FrghCfgTcW9ZGvKEy7TSmnTTTHlGZxZeTDKVOcjtsIc8raaE0bdztP2JptyOCS5Icm2UEp0itCipGbRJRDTRQVxdPSAlgNQbQ4hiZc25eZWJG1LwTw7JO3a5zkkzHkuRqSaWAVxxYTRCY8nCbU7l7SSxlpNxiO7GRqDYkpeRUx9DUWy+Qtxdnu6bbfyORy+zQ1Z02XjZTC6ErciYFBI4FvTPQpbyNcCtuLXEuelIaiueiyiUvaWBN1zTRWhtgyZRpdr/AEPKLZ22NJkkqP7SUbTvFyUhU0A8yqHYORULQyNttpSXR/Y2ctFqFssoWKxyNvDFOdBRM4IldbFESrZvqTClKbKawlp7aJarJ0XLWt2W5pyCa5LH0MlZBW7A4MSznTG2lB2y2YDtsP2OuTZFQZsMo9Cc/GMihuVN5ciluCNQiahzF12KydpNeiHVC0CTVwLRqBNlGm0REzicQfRiFCLXDG1BMl9hJOVXueS1qnHuFEaEW3Jop9Jg3CGP6Etrss7omWS5cBuFSk2ngaD5bdLKSGTQlt5jA0JDcrjRSonGXBKRT69kJ0qvJK2/zETk+I6E+E9PdCzLZNClDtLcsMcr5dHBgKXT5sdUuezXNqcYLjmagSkOYfmYTauTwxdbhjpIT12Ncljwz5bPsqTXamyKJwph7yNZUwWXTXQ3DKq30S8cHbY5zSKZ4Ys+MErIspUtIok7kxyKSUeRkMYGGafxGraWnBSSsWA+QN4fBcyvRmc7a2KWhu2hQSmnDpIpSSGrfwZq1O3yTT93YiGuaextWUnUDcp2xyY6Om21wQ1ktaX9C4G6LbeDKY5NNe0xpOzKAtMGnWRocts+hOL7B+iW5ZRPtktKFYiyYNa5QnRCax8hNFE0JtChYTrNcIbUJU4hVfAP2yqJULZYFbMmQm0dmDgwvO3oU0ynlsU0QmskEmtLae2SmNJ59jaKoVGQhvFDHChO21whxBlOBFGnSmpQpsztfIlcvghOZcTGizUYX/0LaaZEkrgPL+CSiMmKIQuSMrUTyNtdDqPY6fwD2KKghLYKRiuWwyjVkv0ly8npkJ4k2qnsujzRQS1ukqfRLX7gypoay5NO6W+yEs0LQqcNEDunsjsOjTUtgdtpIlMxE89iUtbG3wO1e6sjSryVGHwKXM0vHJLZIRS2xSm2t4aWxG2+OoX5OVnPR2MoUKLsJCoo29M7IqCfF8jRZJstk1CL+cMiMlRWiTI8qewVItKt0OJod4Mt9JG3oVRppS4wx5YM9H7E5y7LRS4pRk2iKaMRDXolKdR9gost4Gj0NwzbXoTrlVsFhidtNtdiqUIWd/wM242V1mOy0IsocaJuUz1xz2Va2kKUhijBOZ/1hOU9nwo0Hdl1BZmtmDwvQ8SS2q9DODJNw3lE6NLuzzIzlKmQzUHaXzDbghS04fWhJdILRfgct1UutvRvA6032KW3KOIamWQlQhTJpwOhtCS9HCIQ5JxvRDNePjuFWW4SSsJTUpNCGZy5xNgTTTv6GSjlz221G2rbkuZzg4XEiMIvmXtLWRNuZpH8mTK1IULbJctxlELBJnRLb4GhCtT4RCaZFfUOGegHUORFo/8ADQ6VGugyTy5Y8/IrJOjPRGkuVdNaVntS9UNSlLhKZwS58tDTrYuswuStNQlUdUSLJIVwlCWpCSwNYfJ1A4j5dBCaNaeUrVyNEop8C9CaaVXF8IdJVSmmRSJa0Ioe25Ky5ucknAqNbHUiVWtlcp1XSKpPD0a0OEWLmexXCRMOWEdPR6BEmw+umWvmFkjJfA7slLa6G1N4oRJLWVuRtqswwcUKVRvY3CVnrfYmiSt5nwKlNp4jctTLaGzuMtoTg22wuyawpaZHCW2hoaizmG42cRUSwr0SRN2LdindJhvBDstKTeIFAopKCZxsX2h37o5E1MlrcQZ4Hnkgk4y5/snRxNCaq0brYiGnZFOhm00SodoNqlnViUKmAolKGy0nhFv0N1zJXkgm0ZpH3wNDixLlkwtV7CUi9NjTWHdqHbVyq56JahhlJ2pVoJQuZH/YtKymGsCcv0cFGxsbO2s5fAyMUfD4Gkk1f7Y6t/EylxvffAhaVUI8RyI0U7sskWtoLa2rHyJTo5VkREuJjbVubb2HVUw6bHDohKnBFsCS+Q4lUkNJZSehwsgiFloetCguzoUZBvnBAyNqjwhptTSyiRy6JYJwjeMMlPahW2cdE4S9v6LwOhabmlxBM1hHUCtocbL9kIZLGRSoFMNMlw3JOv8AobSU5ycjpPJlciJpT941JOTXDHMpsrHkYlBkeZzMUgmk0nSYguWohN8iTmIUboWUThHhdkyT5tI7KM2nlDZJYwFSF5SEklCwTChX/cmE5V4UvkWlNH8CUQbcbkaNDEy7fTn5E7iCTECfIlw+Rk1OumH7LS676MeU3piS410PgcCSXJ0OknHedDQry0NZTUZpjmytOA7SL/oky4edkRLaq1agSeTwr2YdIXEckM0fPITLUQykKUusBTwdWRBtWtXoahSrbMkC5cjhE9E9jSnJGWxpylkxy4LJjNwz8iowYacuULrkdyogeAks1CR4QowURlCtQVoLJqOIeRW2UyhpDMp5Gk0pl7jSZpvFM3AjpotJNvZbSVMS0Sot6yEOJ1HwilyNs4I2d0zz8GSToN7Em0lJa3I6ZGoy/wAjRKW5ohZgahstEKOEZi2xAqaTXK5X4KE9w5Wj6GsmMrUvsRI/Q2Ex3ckviUFsJ3N8CSyJLIOkw5ltsTUNUNdobh7ChMuWJGGbTzGUyFJoiHOxIi0Kj+yFtclKQg0PJPU6kbl5aBkJEl65GFJ8nCJocwqpx8ISoQTnFdCuYKxBN4O2beibRTPuTFLJstQcp5NOuUdDpUyiKyUxnYsx2Lkm1poaNJm3mnx7LKXpH3IThMI7LE9iy9JMIZYCrlSJhxCsvZJr0tGK3aTuVilzWMpOXPQ23eb+yLjUcMlLw0Q+YG0plLrK0iSh37I5A790mlmlNtK5CvvbBU0WgaaacP6GdsaTjUUyKwocjMtZHFDM4ngJuy8WciPjlonRHOhiSl52/YpzU0GI7cFwtjUNslcNCgnSaFzE5EJnXEhbbekNJonb/EkCtOVwEVM0YK5qTlTaYIDOXpAhJJUkl9C2CC/JMTm4mxQ8sCUZ59Hjbhu37ZtjZsRJm3h8iSzOGqMhIemnPwS0qJGHljSVKX5uBpSbdMoblEvpCUMk20xVtJuUuhJww7XQkGSL2/xkTLmFJaH8S2O9stzKSeOSTdoQ5l/0QUmNGxA+VmFTpOqBLLtELHUo5Q0uBkFtPK4Hj2na4+5K6n4kp05W3sRs3dHoT4DBvZC1tFNjaRi1938CHjEN1ihZtNynj2JyU2obTEoSFRWg02Rt5PA4eUT1l+hygwv3BBDGBPLHJERshpIyXB7DkS3FLgMk3jRCWTMwnIm1KotcaFZmykWMnXwSxNIRtchVDZVgxKljE2M6WnT5K00fyyGtNzbWx1EZBKaoNwSV5uhtdnw0Sq5BPgbWGUaHTbJrEWH9iUsNwY5QW9/H1wWtKOPIlOEKc1CkJNxk5KhZI/BHiCWBNKWzkiWhMnEyjI0o5esYvBy54IXZphcEuCyCjpiR2loyxsScswM3G0J1/ZSq3kUadbQc6TVH+yCFthvBLut6nj4HwLYfvBkCpncmU9rDElP5BE6OvgSsW7L2bdPQzfDT0QlWLx2KUWWE5Vb9BGZQmPRlpMduBqcpyaZb0bnDPwSTTxP7htM9H8xU3Q77EkNLZQkKkmVuBRmlsNaG9NbIdFmXwGpST6JDkkk1gCKjTSfI4bWDsPgi3eXJi17a2JFO75/BkmySbhORpI4SzhlLETRQskrfgSyZ4BJpd8yvwcr2WC0kUMQYRMZX7FMEhLgZSs1jb7bFwXEhbwbW5E4TadUTaE5ZaGYvbZFCNNWv4IpMviBtOa0h8ADmJu18CUdMEm4JnfEDbeg2/o0Rwjlzs6K5lyVsJqbKJtnG0JSlO2Gyig26IGiTTcNwKCeVhrZE6Mk1samHaWXyITaZxg9jVFLjicfA5W0JhjtpGuAcrtubTLSmVgv6IhpqpJfySlLwfyMKbVdkpGlLZR6MRkf0KMktvgl9GyGmLm/zHKnWCEXKV2rfRFXTL7gksUP9yDaE8EJKNtxS1BMKS5dtYrkgphaeBNSOiTOht1svQUlLdWUS7G14pPT4JNmfphm9p2XNEKU4lImi0u438CqCNpZ7fA6i+XR7/JZpVMU1wOS4KSIZqiDcta+RQs5O5a1IqjdGc8G+xK6WpxFhoIerGNmfDR7FYSzcJNk5nRxPIqlktxzAlJhJ3rciUG0mOx28oPViUCZQmksIStPU0FGZZSWhj02U9IROm+HqyU06TTXsKUmEoNnK22E9MabZJ2oTfRLeBTmXuBnfykiulX7SGq9jRFlBNUskSGlBi2VtzTXHY1Cjhwx8mQ/6pClbgldEEG0tzHHCiWGOmlek3smGhaUv0KIE3OYMhFasl90obcomWm5tznQTEKTbxMwmti+l1eCwwUNMlNMlLqyV/ddKdkkbbRLymDj3FMij3+uOUqUq0e236Fmc5k+HB+wydinakuWgfp1yK4pJIXWd859VPmCzHmHOl60STGqU2rbcq1LpMuWNmyNjTBR6YrveFG9KV2Nto7I7/wCy6T7VtrgTSLS/+JHTVQUkdEqexpMhxdEUJ4DAZXQilbFOiK5Fa5DGT0IUNawLSmWQl0SSzOnwhINS3l+hJwQyzAqtkRgIbJcilOnLskJRguGUsBlLQpGZOVxApNC2BLtaA0qpwcoK2TtUJEzMpVwFLmt1EiUW5l+hHEO+FyTbMpamFwJ0qf2OSqnK4DU5Ho4gcIkXYcNJQr7BVMM76ESeFsJJK1lnQhTWwUQNrV/YqZmTlBUoqSsGLQYFGSmP+iG2oNxhhy2S5iJo5TLHEVlo87hGURTIyyCSupZfI4anRLHcKbqZIUh3y5EmCWsJdcjaurCHDfeQ6HFEITQlJkjDrdP0JUyS9eBJhPYJrAbvZfTmlvgl2HDCgmUsgrU1D4ZLcuFp8kzmpWY2KJFD7mxlDba3TSK5Sa0OUkltldDQQrBxJGVZaIJphnLnZhslU2OGvb0pMtxrTY3CktoQznwg3Qk4muBSjaxqRMxpSzbwNsQLJ3klo0KEr7GmVoin7LKdsiSSdO5bhrOEo0pUYpot1EehycHamkSiRsl9Cs2rlLevkSbractCu2w/sFjTO+SG0XJ7exRO7rfMEGLViHswh05GbSFs5MeCTQcOhwu8ojiCqXMuktCQ5S8rQl8oZcTtW6iuamZufZz6YVpv0TexKDG259CmRBLDHU9o5ZgirGhNxWU8+REomo+4aUVWcpExCpa2yCXcyEiMkwEppahv8i6ybOV7EFdwTEq03SfQjhxIoNaJ5+w4U17CEU3Dv2MyZejPyI2i5A0pWrdhpJIQ2tIhQ7noVjTV54CpzkrRMilOo/sQzZNSoErOiWn/AGRbOo7ey0RKEysc0IpUadioQbRRCyhMYTi2GlTOKcQcLrDXobdCd+i02lr7fkSbNzDL5E5t8bfgSTNqmk+SG0lw3V7EryMvzAmlyViHstyU05gc4IauCxWrKaFUljIeAtVl2Zkh1uSDYcOkkSdFMWdoSnxd1JNNa5L8CkoRYSygNrTciNtiKDN1wITaEr3g+UhNyWW4SMBqHMSyU05cBJSJNW0ol9jJUEm37eSDLCIfJSlwynEkRFiWmJykQ1EFSChSnLKptiXBCanFQnBMtCaCE2JW24FLRiDuOCZar2fIm1DxqPKUvFvyWDxQ2sCJXlFqOmUuTNsrMWXE2FsUtYXshuTHPAbb2qU3LFoiaknoRrqUcV0SQvu6JEm1zIwOoSJKj4v25L5KyBtMhxR7J2JYS5IlqniRVMeWJGiLCT/QJQmpdyDiZghOGRAndFdGTBq87jYkEltl+h3rYttNTEnClJ0pwSxQEEAfraLx0CF/OYxwsz24knCuxF4YCLDasqdTOBwXfHx6yK2jltuRStnDv3WCXnr9xMpYZFyNCTU1pgbUBVEG+I+OhLmg1osCYD2pPBJMazKn8nolJn64MZsSiWLg052KBEtysD3BYcQ7STLMoeSKjMTYakEpQ1wJCKhSoIhwoz6DxPkHpGCnK2YQ03Pbd0NpvhyJNpTCE2lVEyb3FhxOZom07INWUE0c2L2xTkTMtDgjL2G1GQ6Y0WMMHd34wNgjixpbLaKoTgxJSQmlsgSRxOiJIZpownInCJgJKu08IUmMq/SE6c3KeJ0Snhw/ZS9RiXBMOmQ0vl/4Jg5ckp8lLUEqNjbaUoeEbHAXLppd8jcTmwVR+RDaYUsQctEyllLgrkUlPJSyblhDTivliaFEwxIMtrLeRLRwt9jSr0sDJLhaJISnEtSLOkiYaVCboKmaYn88CwGdjSE0whNdCoGl009Jf9EtpQ42MzKOzoxT2Rs4hZh4G00QtcOTQdZNoSWMugcUeMDBY1wKnDp4km5ueCGpaxHhyOWhqNuuRzWodDLApZumTtjUuDhM8j4eRKda+4E0pRlINVwghpPJ/A4aFhkYNPsbVSdvmVFpNQ2NIz5PRCeKTtlsZpj+SE3LbJ/+CTnY8JjtGiHgEsjlq09iUtguB6McEKAqPJKEitZfQ8EBpDQ2yCFVOm0OJlHqLOCZl8GE+qCUYDOgsN1zaQkpMposmmlSvZqaoJtMyv6FKhSuWPGxMtHCRLLIhFdRYbhysNWJNiZKzCLQs1BKM4KNGNoxa9BcsioO5yK2T6DUwUkEcWsL+xislfoZJ6zliQmzxIQIh87GoSFDZNO+xJJtmGtkDaYbC5PzNRKeCl2Mpb9gqydtaEzaFKbNmUdlASefQRCnLy2xya2Z4DnSrVtSNC8NtWNEmnd9jlOTldehU2QwJexuk/6Lpo4GEsjlzS7El9OBy3alpohQFRjxS1bfQhQm9nAp9S5RAtEyjQVC6TwRZyUpvTYshlCb7YpQRg3oSTZIpbCVh/6OhTIbXL0W2CTunzBFGCtDQsjFpFHMonVjk0kJtERUjMegZ5D0hRUtpITohunT32JOxJtm9iSnuVCSbYku+z/QRuU8HISaYGr+JLS5rmVl+xNoE5SmVsc0hCi1pyNkhNUjLUCTTgNQZb2nhehqCmfoJkyg1qMDK3NE08RIk5KmHCfsipNJC2RKVVdnwJ4MUU/jZi06/JAkG5pLrooNS6gequGsokWrE8MdslKckwkNJq/6hwwqMvgZ8C/Q6Tigsy9ehLVHF+zJlo6nQjacVExiptOvihSzlJPwJXoRKY0aZliNjNw204Y00ng0JOBkIyqQGS3qhy6Vp/YvvF+nwIaSSSJUkV3IE61CG1t1JyvVNOXJSEpprDX8Se1TiNklpVwEtvgjAJ6i6q+k6MXBCzU+s4RTg3WQtKEs8j14ZWhOeTCPhEtzGjh4FDJMKxuFScIeZGoSl3wuxuKxqNjQshK08bbJa1XXQZO1VFKjfsY6lJYSEzaVr8olB1I1Kw0VDCnwKqao6E0wTWwnCikticNiGuxw8AYjTupIWcXFwIfLInKZEWnySZvAw0Pab05HsSPOmzLChdv0TNWxvk6E+A0WSCRGpTBMqQlfY2lJSZU6Ikazg1ROFQ1afgiaYi/QaIubRnJW2U+xozMNVjyFNyIiElkJ9ChJqLE/QvZYJX77Ik8YaETCw6xJbSoRH9jo0czVEMcKoNaJQpNLlwZalwjQmWJ0x7vlBpwk0NkikrCKObMlmGScjjCYLJ4bMhxCpNMSIc4QSYvaRwoo3ZFG08wSm7Kn2KzpNPkUXq6QUI6OESoLNnEEg2lrHATcrdwrkspiIULNkG5y4hiSabWwJU7cLSJSn0LoUGpcvsdU0ltwxXCfp7KmPgW5UPAYanhrNCcrUZMN2tPyY7QeVykwaKOeQ7LRkaTFQdCLo+T2yCOU7n2KB+w9iyGuQlCm5cMg6arQRA1rDQtQap4XBmsklp69FJM1E2KU7tpcvsgzs1hNopOZT2K0noeySuzLASlXltyIpSjAkN0WoiU2M4SYdNDTUNbddkOUNWtXiOEIlsm44HEJyrdCUbU8Fza4+yTQap/EVypcHEhNwRDWPURyJyTbT5JIs2aWzNkNLW5EoSMPQ4JLukiYcqOxNFSiI9ClUkVhpioS5HI6cTUzYnE5p4Cltu6wnsVjqYEum4aw/RQ7hq5Q20kohSWxy2BpLXIygOEqF/YzZKktMmEspqBpKTrwHKV/JaHUPZBTflnkaaR/SYrUu50mRabMMI5s/wB3oekundRuBrUOzIU1NnmjCD+CGSbp/JAmKW0RxBDZTjgRG8oS8bbnQhJ+2p4MyttNjUm01QSNNW6Y7SNw/YEc0kk/+hJtaJ7cjUpvBMJDSiKC0tjwkrhOmG0U816IbCatXjga9SVUJah+A9wUXINGoJTSXS0X9j4J2hEKacp8yhpaHHHsaDb6vij+iahEZDXDRPs2jwMRo6RElJ8gW0cBPYiQuF3BQv2RQQTTJVm3IhyIeUxttrbtHyRNERRYc8jbdQ4oxXIiTw1vg4Cm32E5bKsPRalyLNFMlnJ7hpQU4P5IXbVHE7Ekmk7+4JYabu2xpIW3ZGhgaaRUmUdRyJzhIxtF4vibx8lonDY9fA5k1/0IeXHdmngsmOUMUlLsnqSEXZ8p6EhlZF5kgrw8L2Qgz08AsEqVRlexXARG9w8D25XX+xtc5pQ3KlKU4GuAbibStJ0KKUp2IRwpZR4Q6ImF3/QpptFHkbg2rREbsbayax7EUJoeB9FVmyZZUEppYGmROXCiYmU2fYRtxj8lQ/hRVDUk2e5lF6NICvyWgI5rvET9DslDOy0mv5hS15LgsfwMl9kwYmYOljXZsIgu2ZtL7iylUPL4uCUm0ykDgkhaDEJtbW0YOjdwIrXq0KbsvlC5Lno1DtltSU2p21YJWHxaEQqtrQnKeOyyhStc+jqUytj4zRzykhpkqnnY+CU1PmRIm0M9DJa30RBH6OPY2jWKc6FqaWnPEVxPJWuwkuLNYehJuUUT4FbJw5nDGbdENZRZtKaVHt9EjfzrcixFNQ12JwSuTOyGprs5WhNJJZV9vYoKHL76G7UJa01hEImmbbUktSaGtrYmpkqo1siJtQlSyMmKbjEcFLc2y0K2lU+4ShMjTQSjJRytBJd8on+hGs6VYkZY6Hv0NuW5ZGvQk1MqFOREpXn7hKV6bQ8YbBkROJCU8rE0OEs5Nozlyll/ZMWQsdBOjLWOSJPU3krwWxNOBDsqUUsDSGTS2hJgvI9oaSSDcC01tPEl+jIyVo0ZZDzLDXJZQSXJy0wxfJbe+CMDUmryNME3hSWXMGEVCZGpSWDWUyGaLY3wInsVVFqYThXhsG0k6SWw1UkTiBtlwKiUiHOOZGk2YaUuyYL/AHBQaSaZHFpafYG9XfL4Q3DxGpwJEtzuNDSdtS2eX2OVqZbZkwNK9Cp8hgk4eXjyJuTrgwm22anzI0hKlqXI8pN2Vc9DbainLZNplLyhDUiYsKHUUxHJTcMFrMt1CeWN6G4NXDWApVah4DRKZzDJTETyn2WszJg9IcJc0IaroUMr2OE06Fg0NxHxNGYzK5RE6vsy1jgLbzCUROHT+jNEN4ehNOusrklR91MmErLBkqaJqckxgmpCtkVCY0kp5YfAtOnQk92UCHPYLiyJSZUqv7Iu8aS5QhrXMChJL3wQ5KhrHpEISpX9ilaLkGoSyX8mJJTTLkhyTnUtiTSWVr9kHpOeQlKgvCDo4BUk1DwEl0ShWSSvLgaksMtPAhtrErKIaqU7RlpIZzyRSSTam3ZCSal6XNkEHTYexOLSqZYnXplj3IY6Z0ckjc0uIGp9fsQ3MJcw5KLlkiCf2A36nbYdGieD/oUEtOSSCPg2Uid0ndSjI1Dpp3DDUVPspJu2kjpvEdCyhCOk9pEhtNJbvobl2G3Ym1Kc+wVqWyNhkRTqso9E6v8AsRkm5bSFSRywuUStpoaWc3xljuwpOiSDZJV09CZNOKE0+0NMkLL2ZErmHDqhwe+ByvtTz8CnNbqm2SkgpZYWb5HN4PJtAmZQnUtEJiaRTRKRZYk0KYViYyynTR30KmbL/iULYNYnzB6Cu/SHlFcnIm5RXl8ljrqHbJNKk6hrmeiYNywNcDaSm2i1v5HClSlmHA/tCGhHalrfAZkctnJEd/Y5EkpwM3OaYO0Le4ojuCSPBM7EyzO3PwYTXfyDWa3GqySk12ZP7IKOdaySkkn0Fr2QS92QNOU75poamV+tExpS5pXccOKMXQU25cI7PEFTlJI6T2kLApMp76G5q22QTT3ewVH4P6CiUqRtruRy6DXCSupQeB2kPgbCYx0ESnB5gjHDTKekTNp2JxpLEU2cJ70xKdlEqnoWE0ng3/QrwoXOxpPaVkufRQGrMcnwOm2NHOjkJoLVhOYnBOI4FBFMBLJ5SuNEA96NExaNS5Ik3uRAiIFLyeCYeUNlmRxNLJ7G5V1gfuSm8JYk00SWufRSi05Sa7mKgKjc5TzA0JOU8Pj2SmqoW9EnPGWuQm3g8csTJQ1nBgpdwdIM2m7hvYnLNTwWmKMVENaJcYaSb8CZaM7CSRq0eGISVJ4ciIcqvmYEuVWuSKG0w3ljTaZvk5CcCMVHYrJFCTgW3vGUiIjUqMCcWWutCiA4WbQk2XK0kUL0UG4Z4HhsDR7OB8cSpjNotJccjoanmntiSRqI/oE1KyafqURWhNK2MoqoaWlsaBiWfYaaWJNaHLJUKzGocLf2CqUSuGNcNH2EpiaXL5QtSqXaWxy7wUuXI02jhk7KVZlRKdN2iEz+BwJykNZTkdKUkNptD0iOdTj4Em7ITDehJdZwTZgcKsiV9p0eY3BhDRyHaTTpW2yy4PuOmKmUNMVJElLpDJDyKQ+THSEk5PDSnBCUbdDRGxvj5Fu6MFBycN0KZOoWZ7E59OtjtJ/8Mcuz5NodIwjodlOgu4JpoHLu6mZSXC3JNNE5WdvgTlSnE5WzY8BPNWsipNcUIbiVSGtISiEdEGUlPav0ZS2Ka0Sm5ZWBCbhoDKXCTH/RKaXHF8CctydyfEmnyPARBNJ2QtrZUmsp1y7E3JKW2uBJJOXOhZ+RRKkZStGEm3KVoiMtxh6FpGMaSWySzQU2pUGxs8KMvlChSkuBRa9mmTbcknn2N/Ym87Ihb9QhtpDJsGkhNyy0NRJb4Y8r3HZaNWPwFg3TkLImHRNiloahdvfoTlKnt2PN4ZFsRNgaybEyh8Ly/QhonKGqIw8oiaSthLBqPccCSDya0zGSVFNcjVtKyKuw3JQ1hjnToxoOtheMNF0KUROih5cm65XsGUOj8g3Et4nMlLV0MhJ3icCjOAqNECip4aEpE7TW+jBKj09Ii4b5aNyVu0LsbUSnVtlitnjGFsW0ihKOdDdC0omMkG91ptvRanDgtkN2/Ffsg7aGt/dipcJMeSIbIp8ytmSfsXYifMHKfJCpFyQiYg13s+kPq0eQqGyUhoU4fUeMrB8IGSgUHDha9jXisTwIdtTXBTySm1pGvmJkblC+yLJkTXEiNETC5QJNtWuX3AkpCG0tPL9GRI7C5sgJJZfYnGKaMO8gkkk4gZMRuT/8DqBbq4qIIM2x46kRS3s6Dsaw9kobWrGmxkzSCJrY1TYEls03O0uBuK7ScMZFU1nmTIG24RsmTg/9y1NJ0a8Ii3Cy2uILVf6Imi1yStCTmDPsS3CxfsUK6E1Qy6NI6TY+B5NdZjsaT0N4fJEE5Mtc9DTVLDtGyVAp1bZYr4ceZ2EVDHLiiMV0NS8bTh9BQ6cLPodLcyp+iUTNpuTyNt0QgQfHhQ4tlqVsmBFKCSdu/IiZtSdsE2m5uY0sgTcDiWy6o3Ik5GChLgbcqSrf/Y3LZKextNVLncCSlUi+BRoilx/Y2ki0ayiVI16DFD8JljB3PsW5ZLlwQ2Dl6ehRf0MXWU/qh10cTlDlcYu2xFJrim3A6kaYctN2IIpsuV+xaJ0bXI1uXSHKdu50tMUJ1BjUGAtO1dD9nBNI+aWTLNdSRaZklyNqErjcTLEv2IAmDiP9ioN6QO2at2jgUttqGpT/ANymSngbDuDCmhtNLoctiShSdyVNBtCSFUbCzCnKY7BJCpxFsDHYqxJJSklvApsysSU61bXTG2I6QqVWq5otZzl5gk0rlcwcpe0hWkMKmEdW08L4IiBrZ/0SmC7lmjidg1s5bD2bghgaacleUxwzRJoh+gnbw9EtuK2U9DyVmX+w+h+AOJuy2ISgkKslKXCxyXU1MCSNUs/syOmWNmyKYQ0g27WI5GpioqFswlxRRjK1PiBqNj4dDpssu3Jh27MdEk1lOBIma22yki7pP+hNNt2qRQMqHKXZsKJY5aFRuKUySwwlNwNWLKB7Gy8xgcNqlnsx4YsmNjclVo5GpbcS1lbRlpHOXyGpcHSqOIJcJNrQdQk1o0KXlf4Bsjlz9oznEIfsRSbYdTyQ0njNJiaSov7jtbJy+x2yWsOUUdi5HEdvITJJE5FZZLVJp0WocnMcFqxNnLE05u1ahJRMnk3xIlNqySrSWJNWOXRPXwKFapUdyhCc16FKysrl0Oqx1EyUmnkiMQr0G4LEkBCsSpNNtbjKGafVkNrTYKLumDXYrNJ66JYlBtPJ6G0rNTp9dFtmgs2Nc1mORGmLLQ6JJxkMOzMQqHhx0EolpQEpdMYa9EFRTXAiQOVvQWiyI4hK1MDEm1YNyRs9J0m9kib09N7G6KKht7gbyayRGSSiNCWk1aSoYrKcujFm5UtLKGTC5/oYoFMv7IvPK+yNUR3d0ZFamU/3KnQqJjUm0JukwqUJw+RRKhyuxqjWCy6SWbPkKpTRkbQ9GCWY1KI4WGnCRUu3wyEzQijGz1HIxybkdIlMlU7BGnAbhvsEnCtLax3I0yUBoxrSUZQraJZPZJFdVHewlJtLUtGckiSoMGRVbcmtiNQQsEkVah6kuHp1ha7Gk4zYfhDBFKctbciUndCFenyNxFJoJ5xtP0U7j22S9kGCUXsYG3Jt+iwuCKf2aWyghJCmORUx0oXZZtgXokNiUEk3S0FjY4bSdqxKJRNSIZ2vA2OXKJRxZJSoy2uCTmnLBZI2Zhn5Eoi1LYiskBqNWlQ+Bk2EqlXBKiGnh/RJTQ00pf0NQlLbesUqUS7h2WjFApXtsUPpJPTIkS129DhZnb4QQMNl+y20rQPBURmhqqhYaRyuFq79EJM3CSRCIYCpdjmJ2zo+R0fPJH0DTUJBmFodIWDL0bLQ1pJkTAJQl/whEnwZ8lj/AO+BWwKJrLRFbhJvcItTbhkkSlkqo2+xui1l7EpLTU/Q3ChgiGBzH4BJNlhsOlZasUVXDKXAnRh8mSbXNSKZqlLDfAjeAlLl0sDpYdabUSc6UYe/kUMWkSv7E1Lco7SG0WB6ClDZuEcCEbKb8DC25T+3yRik1BMCT5VPyImShsFJ9U7GWa430QZlLB/6EUseF6FLVvTprInKY7Lj2N0xM02bZYW/9h5ATy9FKCpUElVRCY7JTtLLghKCaKUskJU4XMEqG9TIlYiTx0Jyz2ToVklSbloUtariciO+E+yUilU/9jpKVUn10LdHSxDtW1O0+huRqeiyNyNKEsctJHck0hlCzYhDaUJUuGuRwpJd9B2soqREtpSwUlm+RpJ+uHwJ/wBRaRFZGWeCiYnoNYZRy5JKmYKKPQxwcqSeAmi0CFrxqLfyPc05IjAnKnMSjgizOZWGBJqqXAypFC5IVXqlP0Rkuy+KE1JtCJbWxJ6XB7E1JVCWfY9KIewl6TVDwVk0NFrPwDwHtEgaGsBqGnU7TGyc7N2Zcpf2EIqu2QmX6B0ockVfrMDuTDmg4SlPR+xvDWU1fDkusrHgakJ7ehZSee2roxFn6CII6dBqEqhcCWzVLA01pPFUNNOlpdEqSSnhCLsYYRJP4HYlKaJ/QS2c4xwW7IGsMt7kiHyNmCo5BwlQW3JRpVfIcKBw5MX9WiCbWV0uhSzTjZRZtJco9vBNGpy4dimmOUtJ6Faa00uhG1KWjxwQvkWwoCYT5UQm0oeWPKZUfIUUIxCWkzhWO3B0JciUPsiEabBguSSbNlIpA/2MRuVKKnYlCVV2RBFo4GkhJUyNTDLWRo8lbZcpaTyn+yaaRJJuE57HQ22nqnkgRtRUYrUMpE73I5JzsnCFnIrgnZ7XYa1NaZ4IdNBjgcKdjEpHEtW30QaTwyK0/cb4GZyZXBMjahuCkaSelwOtUKaXRGWmGbhCSU+DESRP+xAapXAnhJ0pPRIpJ4JI0W9vgoQtZY3jSMh7Wy9uRWhpqHvgbQWWwSbMmtTyxJrlmJb0JkcqbORpBQ09ilFbaay2TC39/wAlq21K8raHjRGFyiDJGe1uCBKENSXI9VuXDXHyVNnpGirY08F50rlt4+BSbbWbY3hE5ZUoVKSYoxxkFORDw3opdKU9uBpKaF4ZPStnPsbdNP5Q7RcNuCmg3NPQVN0lD9NDSE5l6C4Eq8v6Ec1bZylOzMvBL7Y7oklSEpNnDxY82RbMGsu3wwJJKknLWvuPO6kVv2SUQ1pfslCia4OSScZN01x8kQYwSKhaGagcyVoRQTadrn+iDOcspvllW1YNxW2RGG5EdPe/gUqyiU9lvMs4fJCTglDYocFWe/Y6dlMpYG8UKEQiRtgZEVW+mkW04QF9XgxFaeWk2uQlzEJcsqXPJywpf5FSsZhoyrIaNIdCW39uuX5WCJhufMxLeocwt6hk1JYLAbJy5C2w3dYYULlaat5tSy+6FvVCySTFslg6QmmxhDqaBSJoGmnaYoRNhFhfA2SgqpPb4QxDmXr2Y1UmlNyN1SamRrHfMddlsizepJM2LiCSRCo8PuSkqsaJAqa40SI1W+YyFhd8hQjuKJYavV/0NbbuBClnLukWFKEZ43gM+bcdE2zphUf7Gm22TAn2S3KiKupEnCFEkv8AZBNBqSfmBsULXrgZJFfaiiZL2UxttHDuDKcSU3hDW29G16G3FHMOmJJiVPJ4scER1cSLLa3wLdsqXQ62Zw2/uXEEjpbHcEMJtta8oHKWvN8kwqS5cNjQoZ3piaThgbQh1tRn0Kkq1F3n7Da7+ZPobhZsyfY90pdWuxtKXWuUJslR4Mj9D9iSTb7VkJ0mgKb4I6WsyK1RRd70Jw4PJbZSpZhSUXBEjhU/7DpNN8DETObxEQT+DA1DNp5QgtT2/wBkJoHBotkm8kkkU1NckpplTmhCgUav+4lFUbK+BaSuR0OlQ9vQnZl9CpNPhPhmyalNQn2JQncigkoJYxYcwbOAczdOB5xC23yWyacRltksvG3IWUdEUn+xsljZDKrhPIm0KdnsVW2eEyUslTZIWyFoaaQqKgwS04oLeVinSlSTIpStbc8lslPEsiXNQpreRZa0kvkhFbL2E2rbnaY7HpplbGSFUYo2Mg8JTjsaFlKaWChKpnBDhEilZtj5JkWyFNIas5IwYO5YkkSnt2JTLuVhMg5dy1+gs2qJh7Y0EbbJMiUqnDVltek62SkiU1mBpJJFfAjZCzX+g4dO7zWlHIphHZzhDiYmG2iSlhp7Io2xG21TpkJLO8qFXBl6Lmn8o5kkmsd+xpOnhaG8FNaWxzEM4owSPLtaHCklPLUGKK2vC9DRLOk6JUunlsYnnDDfBlBUwmKbR21XAWk3EYjLH2U088kg06GuidkuM8kEI74f2PBjNOBpq8YaEsuWeIEouVoxrEVRTGJFEqJbY5s2tSJw7rgxSI0heanahOlhNqVNXKyyiKheBwUjBpDqcPFEOtuoDYJLTr5JNEWqV+R0q+OCuZ7yKbSzEpd4lqdCNi426MBcS0FZpQm33Jm6pm8NdEp0qUs8NIhG6LnnonAUHSf9Frpa89jTW4ipGmJpXIinLZUWxtRMrw1r2K1IhMBEHgrr8EH6CD2UjElUoHKaVXh+xqxEt3ELgiCfwXtCtaR2HCJ2GYk4Tl9CU5KdTIkCvnZHSpss6S2hoGScq/8ASYldsEoeBatSJZWrn+zRWNGb6HwU1DDW7+8HVCz/AKDgkssZQXLDkbabbt1bgvTSVBvY4Vrgp0XCHi9EMNpJgxs0r3ll+C2HnAo5GTlalsTJEGsVMTN7twKrwtFChDbYcWjGiTSFGjE6UI3RGYIxfsUrrUlJutTVhM23+IqGvpEapUpN8yLYotKpyhRoOyXoU4hpbkhSsMqEsH3BoOMbTskshoU2aFros01kuwzVHC2xKkS00vmPLdU0uxn6g0yKg0tDCME/ZBLz9l/2SVO10xqc2SXYkoUrUdiFPKFCZLNabHiHdlbKtLSbrkUwW3UWxIHEna7Jac0exkRao2MlMZZCdxYyIOXlBOYRK5E3rZS8ikzdO08mx2+++iX7McjqysMQKtyeUKtm29ww0KTlhSYraNqfDFdutSdDpv8A8SZEQn4ClRCYbG05Rb7BIpTStvsWRYnaHI+swiDV5FwNw7abLUfgcKuzBMKCs6hpCZ0sPAygnCxQmzbyRVwJObMPRK7gIUpCc55Gk0bW3wKGpScqpDeGxGVsbUqvaHZS8aHcwEOnAqdhNWghCwoQZSNQZY1nJoPDdqdbQKklptirMbpi9h0mQaQq2JSySlbRSkrSUtEwmzKIaW20/wBDTg8tvaGke7ZDSgTIUR5AktaNDTdXMunRSXmxMVOmsnENnT3LFx7NsRZqU1PQk4GzlqCEjZwTFbcmGSklac9DgPEN2hlFlqYiM3iCSUzlO0kOSSVWmKUqgLIvRNcjo080OMFm2reA2RNIYh9C+Af2sGRLI2ZE0zdcG7IrUvj2KWi765OxTx6Gk2h2hJZpzkJzPsCG5TfExWpVVyEoNtvYrBa/At6dhKmJ0BQsXLZYUDW3/bEnKaRhAlKMsZTSmlJcEWQmnaJVKl6aEm22ULiBJtu+J6Fcow2Wjw2DbFY0rQ+A2rkKtDYscDSk/wCxwhs1wJOU21cuxiyvgslKOIPiBE3GbEzYTkhJ0dR0lEbtC0jsITaQ1li4NOT0hq6nlDmoYygxoofPyLUbbS5Pfmgxlt6/7EDzGopZ2iRKgVb4J6ajg5ETSZUmmYTSS4bWIE7mLd1obImoPclCqLL/AKEiUGLmbxKJRFm4UtbNlXx0TaFl0rkU2krTdO0x0X/aR0lCEyexTNNOSZe0JvKKFze+jKaouTckKMLaknBJMtK+2ycon7HkUSbbS4Q2pOG9k9ISbscdEEgl2tCNS5SyWJEbSe5mnbse0lorEjqSamm9pDstpCtyhv2JD2jLInZOxSeYqQOlSh93cFSly1P9hLJJ4CCUOGnDhCVrNSXDEoJEyp6FKWxbUmzkTUnXZQb3ehlw3bTcClsFent0ISJXWnsSUWwVIkmFpt33G4hOfaUSQ3KOE3Cbhsbsc8DRFpptvOBISdSzmRZfvupKTdh07CfRCU5czGk2pwxPA2He3MaJlIUDn0GmKlyr2K2jXsOGXpVZkcMboT5NyTDqGY8FJThthCo9ZhogSbNJrA0CIROwEXz/AEP8RplM0rdK00fgCkgqrGkiVDVtPk4KTLmqOS2UoMNDc7tkx6XDI3DShzAToKnKaaGUizpDtmRpu2MStbWDyTDSy9rKGZyEJWJ8c7GqSnbTEqRysGtDLhZEJzI/4REoSa30NDixhdvEjeWtMlyNNVnuNRiC+4MuHiqC4X+wuHCpr/YpdLK0M8FpOU8QK7IcS08EkjcKRSQqR0scCE0nktPSbFXKvvDYiqYaMuIiFNZIPcLkJoWDpa5ElCLvYWd2mKmi5E3ZktjrU2N8myFH9GXQlTPIxIlJwoTI1J0nyKk3pg30SmzJLT6IVKSuOSSsFwlwUtUwrIouvQJN2RGWticsihpUGk4yoWkfAnYsp/aS9rZkcfEjs2bDwyOTl6LY7spNKLRb0a5FM5V6GmylD15Ju4uhGU2nLUWuhhuRqWzSy5CyyqcoolIU2vHJCjEzxwKJyNhoXA6Buo9tBE2yynQNwSbgDovmMt5aWz5E4crII1KXLtCBrmApCKVkt2OZhaYshQyMoxb2g4Eth8GC2zpjUOHgc5WQ06TzsN6QyfpPkp4wFQ2oTDkR5IawHbwNa7GrJpTpFyJVFKeHAlDbXcmhwlk340iIQ0tY0nN8uxtopG3kUE2Q9Nieh2Sb4L8yE6dJafKHlCiGXsmsLSDbppQ5KUnBC25IiREWqFUptlZCGQHU7rSQkiWR+BRqlsMilW20WcLCKFqNS0yDVJprZyTNqnb2W4FyvkdoHM0ErdPDYoowsP8AYag3Q6hwNNUKXK4IRl9CKHkYGlJrZdjVRQPhLwSJsD6BiQlXD6ENYSblnWbCZwc22SNZMA6VCFhrhkNromyI2lDrIjZtS2fRAlKnnwhLVqXwZwQavqexunCTCjQmRYouBxIXD5JpikWTQ9DGaE1h2yLSzvkxokao8BKq2ZRYhXykOKdX0jtHtCVzb4BhGi8vJAnAkx36I3RtbkKjdMuRyqc/ZDUmrQor0OIuUprtZEoeRt8odMhSZ5ESZc4kprXXuQ9xxQyzJ6IhdRLPs5KElqjDJ4qtS5nAjgjk5sRpE+6ZM5VfI3IVug3JxNOmlocqCxTfKE17ojQ93nNrYnJHjpexFY5ZG15EClAs25FwTfcRDdTHIjVkPyt6FAcWldxLm/8AsiSfAJT0kK5Frc6gY5seeCMA01X4bFvKsKHS00sfImLVCoQeSJIj1GkqdyuRlij9ihNS5XIqh07LYjh8gNBks4ChT4QQSizt0bxRpbWhyxja0eL5OcZ3pEJmalEIOERqiEUshC+4NokoTx0Mqa6BZJWyqK27iCpTtOGJGSM6UrurTc+UPITG0p1lWhOTivKEmJtQLIk8YJZFRBbbVI2glkWFtCeGJpU18oTSpo0JphuzArYyiaXDRwJNcWCz6NCTW1A0tiWNJwJzy7lXL9zFCMulwiprVNdp2xjdZt5Zme5FEmgiJi3rp7Ipl7PI9ITfSFCq2tEKTrRIhJTpYCTp6aKmiHTuWlDfkSaFFrK5GoRXOBSvlS0KDVy/ASs1hrnggYrLgS0HDeNLE4MZwYy3LJVNWaTJtup1IiQmWHyLkjZtyaVXDksCjT+S4VNsDbHm6Iu4Vapr0KIkmduRQjc2tu2N96n0Za/gC1c7oESs5wrjsww5ZBt25TpaslWFp0ORLMfQcGWZdP1G1im7SWCjky5bMzSWt3glMolvwImM3NUJwM4EyZVlglgTbOdhEU0cqloSaZohaPAmobLBw2SnJJxSGpGk1XkagK2HmBtuRe24JmXBOWJunZ5OVN74Go1sxLdcp4eh5w3TQnDwLExNNKZ6kTULTXRsvYJxLonlD1EyRA8ng8Ei2U/jomirkPox1V8mSUfcESzTbMUJK1MsJKcNyy55ILJ01v2VacLY4VD72TA6iz2ZdYsKEJU9ByrBrT5HJqc5ENAlFod7U6ZU8i44EmbQqPH5WOCbW2ykoitdDVOxYNYRi+plisqBJUcYOxrF1o7MKUyi1h1oFDJzyhJR1GDIlDKmnHY0w1ZXImqFP4BJM23K2E1NbdKQW11RC0pdBpU5M0JwlzyUqxS0iIJCTTG5IcYzRjAKXmInIOoeoG7VB10gcSyL6kltW1piSu8Db7E4NVgChJkGaZ1GjLM2TUvkhI2eQu0hQqbB0hKKf2CWyUzgQdw05V/aVMHKWuCmkk1ucqD0DWxOTWEb+xMktCdSJJatssSgjqgIUlEqg0nK5aIcGQOuxzbay5MbgkvX7GaIiQkR3QILPIlwSQym1wTkt3ZfaVvgPm0tT5IqUU/+MQ6ZxSnzwJSmJrspeIpFJqiBsuUiMlXLyIVNLMQwPKQ0yRpZLa4goG+Q32ZbIO27BsDpXEUc8Y7UJSbLg9Rr/wBAaI2ywHCoJPUhJJJNfJipqtL2EEUQBq0pQozTpYISpxbslpU0uNjtvpVsWG3TNo8DR2jYWTHq+xyfNVCRUY/64HNhTKXCK6m6U6JrX5AzbZQhhMpLmOWIIymCQpjcMC5gZDlEE0yNqwmoKTJJPJwRN5Xhse0S2S3JlYkYZKNVhefgSthSu9iiOT5fhEOUaj8NEiktK4G9w4clRfHMfkimcROkjJWPSjHSHbehiFC2gR7O170YDMXLyNyKjBdhpnTUOAyQlJab4L2C0x5kJVsKk8FZrsd4FVx/aV8vYqSiVv8AsQchT1HRIFuS3Ak1VJTLfonKWVNiSeTAmpG1Dj09ksh4NdENolEH80OgREyyTRpXf5DSNbYhsA4bJmmUNjSqUY+4mCpqCbyl0ehYdnJCamCbhfo+wCTEbbSqRLSrX+haEqfoajSXgdEUnTGSTapLAdYq/Y0Iy0TgaSdtRq5gcFabkuhE0rLS6EobSympTkmpTbC18CvKJ+w1ImE0iXDjDMBKU5yUTsNwOXKaati2XLgha2jkcLBilDZChRSOOyMqsTQ0Vk3BYfsRM5JWwnNhtSowglVC7HxFS7HLZYMEDCpl8DNqFlpSeWViLNhZLgnCuFhxBMbvvZAqQ2dMpSVMCykMBjFxVtEpbqYSk+xKc00XsbWUx3mn6Gm4LDZcijKRJsUzxyRhjkHNHuHEpNPCcFQJVwVCQ2IGcNsVsmnYlylwZoH+Tgdk74MqKa4XA2ccWZGmFtM+hoETbX3ImYrLJJtKUsg60RWOE55KHBSdxFS+BtF0UGTNmlYo4GkUiapzwMnI8aDNlH3Mt1LSbQ2Sl0Q22RDTIyexXIklOpbYkwyeQqaG8cjKhgqC4oUiyqmgYypPjpi5K6YOTsSqLnQpQ6V2E2VKUl2SaR0YJSqKc8B4fINJouVkIWmh9omIynXcNQjSTd0/2OsIYJCNtBjFluJbXIUpkTLlT3wJLaZBw1CY67Iot9ikiuGxs0vYFVhK2NUmyds+BmISSOU7gGmtDKIQ0zhVcPkSiNGVCIycQ8IShwJeGhYNEZhPmBJTDHsSbEcJkS4EoRI1hdjSYyTscWWEt/gVMDIRB7WDfY3ROraG4kUNSS2XajVFDTTdkngmk18JGZZ4ZCG3qIaNG40mRIk5xS7JtdDsYI9h22S9sfBJK5RRbIaSVqmzBhaiaEmxSmVHwE2mTUNj0RDLIpSGiDLWHJLINYkSbGwwIlaWOPYpola5Y4ismXRFTs1mWhpYCdTY3QrWqZJPgclq1dFYkaOhDqP+gfaRqcB6WzU9j2z2uOR1p3pySOkp1ka0jDJkLeyHJGpby70h6aXsGKHZBSm1eoQt7STUo7GiaobAmTppQ7ROWiW8NfJCgMk7Y5sqUdLvglUpQ3alJDCLJT8ECitZkTaLJv8AA0DJ83go1ENZtDG6plZKDCNz32O1k7TcDSUOE2rey7FKiPPwVtLEYeyEGA5LPyJNl0iYc9iTs2l+z2V4QiS/7EmiQ8IWisLL8BQkkqn6KG2U2miGUz+Q6jPga5ZE2pJvyFm1Skeu0JJcULDfoRu5IZxgxQuVLks1yScnawvfySbwoSbXdWMPsLerUaJodnfDjQsQ59Bei5GVs8EPkQ5EklJjLmyT4obZM7cqnJKXHonIoHYjlcwULTR7+SRXErUdiyjCwvsJMHJjBBLCyksMiiu2WHUzIbltVQ4UDOA1Ylm2HDUVNTL77KO7bQobDfPcChtgiGeSIsFsEbJcCV1Dt21M4tktOZXZJsjcSV5RqHsdFQ3laJJidtjlNNKVk0NXQayGnBQXI1ZktvTkaSe04TeWuizp4VI8/BGJjJclp2VwyJn3SWo5EpJNKnk9kuhfERtJLSoQ0lCuWwcyIjJiMNSllwNJzm/kaQJuVz7E0HJw57Jz1VS/YhtwQsNkixI6e2QmmqRNM/Ik3Y5wjPyW5SXEENqdiQ5cqgqhLb5+NDdQ59RIRuNWTz9xXkC22JKFMZPORJ10Sl5LnYrqRnKrNciOTOErXMEDVZt/JiZxYmtilXivC7GnGqVCHEcZUlhkUzbLQipLYhBFvAZqKmuRC4TUuexUbFb4FFiJLYkoYyJt8jGOTQiVuLauYcyWjE5LbLgOYo1CmhqJkNngbkhqWRppprGZYGnuLJkNSaXPyRD3HOhpJopmlyaGl2wqR5+CtqsY5ISnkXIk5icq1zJbJOLDZLhgcf2SaSW1VGISTeA0ZaZBq01KbDQic5iFCpaf9iloFPbsUn9CMRN4OmxYtYJ2wxOU5FEw1kTl3sVz8iZtEmBzEdVaLLAgkpWrngacEmcCwkT0WzHwI0ph22xpKUQsvkibTG2yFNqVSSlqS15E0mdJyl0iyoSyLKfYoDexqORIcW03IrJaIQ0lplRbKJWbO0h8k2pw0OJTSvYzZJVYyExFTUueyamW+BIm2w8CUwwShtk1aZ8n+xNcSbSugabm3KJ7JgQoffgzLlDTa30IrwGVoQJbbKXAkEK0yEUsqy0IkMM5ciUNCyyyEne3pSJS0KwmxKzGk3b0YNlMqbyRmyrWxDUzaTC/2SqyXAO1KRmgcsBsjpJztDlQtTlIsN1Sd8CIEuycDTTpLZLOvQ4ZvcKYqTMwStvgaW29GOQ0daFsITGvuZozggbJrAlsRxHDSG2kSG3wNQ2txPoxF2UPAkqMLR4GoksZG8fBltl1E9iUEO059oRI1zgn0JTwJeyick64eyyc4am9qBwWeFXJF1mGIIcqk4HhFGHQ+K6PijCitsEUjWGEyTZbkZU3LQ1PbCdjLeWCB9CYq0Tlk4EkqJaY5jUmGh8KFNj0ipTCXYoJKqaQ1VtsogIUNnkKZkk5mXHoSoRDXY1syhtvsSndS1KeT2MJM3IlPsThimG4YlElq1sZTlWJf7GtNUkmUtkqlKEy0RQJbItJC1lDmg5CLKKupSgcFLvTuuUOEMypzngk0je489jUk8dWfkkbtrbghXKcWECo74HouhqnhCJbmdN2/YlUuU8PgqxqKPY0dlDbYpGl0NsuTDKK1k4HZspxubHNO5uAzTSHORscDTHiY9ilmuCvbIawpTFaf9CjuLtTdIrYXL4KUeEriLVJctiqdZ2diWCG79iSUjf3iEkhJsplPYonJs4Epall2miVubK1A7dKxZFPD+YZLJRUn6GmrStHSG5hMKsGhB1vZOU2hz8DRIJQ9D1LlWx6LNfIazZp5QIlLODcpjcgkkY0kyTbuHMjNC0jQ1l1qBkIVacLQpOSEZ1A1ZGFtQuCIV0lRktGqFtPDJJNMlDXbGI2+W5HRKlPbyNwl6eFyNUZGSfJGXLv5DTZNhtfo2TNxU1I4dMasIGtDnbpEN2nZ6RJ4Ldv2SqRR6iXATCUUpJlsRCKuh8jpUxjXRImn3L+CyKeAlKS28i00LiTAmdrKvsJ1qYoQnmsNYfoSsKU36JMEytHQsmKVaZMzCzteyM81EEJy8SY1GiXUXI0pgzYs7bScr8Erc0WoGbJJTIbUx1xKFA4RSn6odXifqTMKhVMPA1CjpaicKKhSbXIteKQNOacTQkQtkPYh2u6uYGiTe1ZcjUcQmv+yOQa2XZEWgk0NTKXwjpjrQjOSHXhBI2hyl6QQUoiF8Fo1KNth+hpqUWUNcNjUT3ynljSRTJNQpz9xyktcG46Gj2Ce/RS88K0+xszfeCxq1TLQkr0tOEEpWS2gjJGIXInMralT7aJVYDPAqQqdjD3DGFTc5HQpjAtim2dF2O1j0ascppTl5LTI4DgRtvoL2WzWEpMRzWHk/YnRlabFR3NXLZCwyXHBpVJXIaaz9BRBJtyNJIm230ygiXdOxq5W2L7DxH9jZTOytQKXhqmCE0sXCTLMI/qIg3/ANBCuERof9CULCyrGa1LTkUUUnTTJTS6I2NQkndDWySzye33HCXhpuU9jmF5Q093yZGtvDFnNS1hrRCklZNtt6CZLo8uCLlHZ0Uoo2RQ3ELMPHwI5ohPC5b5MA6yb1PBfKl1MRVqVjyKi9rWzFuHTdJkOxylgh2WJpyNURxsbT7CGGsk41jejI+ROyLSlodI0tzyNt4KeR/oQqtskNrNS9R7G/uIxSmsi0xHB7TtCTTTJTyJW1yCJkc4hLQlVK2JxeC7Ymm6Fp/AqQTyaS0tBGlclV7RKJNTNYeSIKcnCMKcupLYnEdDI0SUkZgSbkqVnbP2Nw2KSiabnmDqKhNDBouAlhhow0NZklDdD5CuqTVrsq6tZIUTc6YZBSyVGxzBNaWwokq3fIZ5K9DWVTyoWyalbQ5HOnusY6QCFVRK/SHNkpt0K3thmBQmqWm+yhcDfBldTRAmmqdIdVjXG2KddO0jNiehcmV6C7iNcjwu7Ug8KlYvCjNwKVBO3AdMCeU+RzpJJ5TYnB1ESmTxj2NlZWyY7wlMNoibISgmKwP2ISbM6Tl0K1MnPktDbfDdFyNSKlNLkTwDUHMjSUqP4Fsb4xj1MNsdLgQnt+IyThZo4RmnpYuyaGRFMEWyNzZZXi/BDfFyuUNnb2HdaFg0v2MbIo5FNSbezAcsUQiUzS3sSNBP8S9ihIc5UaEI0OeG6GiVLeswM/RTgNuDSsYOE1UhGXoZ2OptJq5LlrRGJScktnJtAmsrZPv2hmxEqiEVCXtA2qestIxKf6EJZL+KnoQdjcOHNSxo+CxZML+w1eBbbkc5RC67XBKT5noW25Q/zIVsanD5iJptJ45iUtox2DmDZTUItDiWUbXA0HR5xwi1BqVVoSnLzHwyd0pYbZVpoeHDbpYnTe0W220Lhvg2hC65Why6VvkkiR1KRcjOVGoYmTc0fwizR4HU0qbNcFJ0n8PkSUc3oEyajLi7FJpnCVDDoClav1OEJQTdD+SLXQ/kWhaaw54EkN4cGyOW+X5ElDa1kqE6S8t8CGqJLq69jRIa3I0Qk2MMTVc3xjXoWKRNKjbCwtlNwKVujCexKW2pViXL4FJNpNN7WUtYT/YhwYcwEqjSyuxqEmrfMCUVeUlpDRRN6sQmmX4Fk2l/ZGlpRWkkhrdEy1UTD5INt0MLom7XIXQlLe6XyJJRtscolswnSa5IWn2w0kNOauAgmUOG03gTBZa44GkE02qU9SVbzHwyVcspfK2JMVwKHSlH7Ba24MmJU3EOuSHPy8jI7VI2KFpRqEYbc0fwETjSnQeFUtrgpRN8NfIoilmpMo465I5HBA1dVQYTpgw+US7PocpGTb3ewtGVlcvQttWvzCw1S1kpwpRxwCgtPsEhwStPXHscEk7cjSSGpbY5q9hRNNHyEZwNg0xt6N1wbH/sEplxGjl8FpSS5MsoiSaytyKmZrK55EnAQoi0QSkvmNCJJL0loaW4YRKsxapjg4tiNS+Aw3DFKpnsjUQ1h8lktRa5RNy10uhM25Qiw2KeRNU+Q6tEMNknGXGyabS1BpO3G0iCn0Igd21yN2aaS+wtCfo+xo3wYLajwFFzhw90JjxGT2+w1a0fJjUkjyuUym4jnkRGPmBohyalosTkt5IhKYltmdDSWml/Allr+1YmpmpTHYbbazhTVrhgTThTEWaynHZZ6D4yK20cGuWJQkITHb9CpZ3sKFayngJwpSlylr5HBKHP4CCSm2WRpJpWZChYFkiE0mn9CJnJhpUElNvgqeC7GzlxXK54Gg0ByjxnkxJRpyDhKVhsPqHlcCUR7HRHY2hQQkp/YTbhVH5RI7VrkEzhUewTIkhL1CWnzJYpbTb7HvTk5Er2TabHt6Cci1D0DS0RkKWwWkKURZrggE7fZRwybWnwxYYavsg2oKyjuTUoFrVobTJzgmre32JISl0WR4li32QRtN2hFJ7Qa05HwWihZ9oNIaSeROhKk5SHGf6Kxy5pjuSuOJB26UKrS5eho1LcayShNrUDskyqh6Ial/A4Qmpuasj0K7Um6v2RkVnwbFLOU/eSZN7dQg5pEcItKG9Up+h7FNPbMuhtj+mMW4S21oyaJtdAaqKaH0Hlb3R9UMVAzd8EJQJlcpwQn1vhEGNcm+y9t50dJElOSH+0obsm3v2haboWDHkLZluMCqod0uyDJQtoTlqldxNLbbUVaqQmnkUWN09Equ4p8CUomjCtKhp22tDammhsHKKCW72Sob30k2JCacYTYze09iLh1GvfRCQ4aLltNYeBzk1xyOoN5+g0ZQOUJwNwQpJ9RGKbNFtKZolvtkHbyiH3Zk4QqG2xJI2Ri6jRxIjtdocwpLTQ0EnwOyhMknghqVLcYEMmTilQtjaZb4jgiG2Tt6E1hadyGhtUtMkQmTTlfYYpeM0dpItFLppLpsTpuRIhFMTwSmxMmpLD2xIkbTbH+ySaU0ciSqiiGxvUml9BxRLVPqhz5288EKRKlraWhoy75SFK2noC+J+pB2ppLH3FDdtNUrPsrblwa2NC1P8AoUKHY1lcFi6Sl2E7stNkTgmlKH0JbbLm16IlENn2CkKfI0NeC2GtDxKk9sTJERVJB3upHMitkQawbQ0cOo1EQOpO0vw0Pg0NIOZK5ioaMonK1wYhR2vA1Oxp7aE7pGaL4NiV6tJDElhDqG3/AEJE5U2C0aTUtNcDidZcjWCdYkVKHghzKeGhgnD0+A1RenQe7LynSI1tYBJMjLr7jAyvtTkSm8grJt59o1NzQUErWozyRA9IbK5aIcpb3JrkiPH3gtYTQ+hZBwfqMeClvK4QpEqDU9CDOt8AWbahw6MjTdCx4X+0mlJt1Tv2ZHfI5EPDybkcCqxIklIRUSdCF2O21hrGnCE0+iWcjf8A2QrUwVb5A2RQ2y1oSSSpNZYmSjDUmxMOypHHUsNZITi1lDRk6jNIaQNRMEXShoppB6Y5ENG83QcMoGm+hokWkZSdjnB5QppTlJPQ+AZ7FCotkJUeZgt0ppJbD4lagYWxKURoRnHMiYXRS7LLBEIhPIIcphnoNQ4WeXwhJYjU4I5bHcaGjtJbPLIUC8rFi2hlpG5YfInMoSWnyQrKi0iy0LXJiNE1fdFocauw4ginEHMFk0MqcAD5qEz6Fst2Ph0WSBCGnf7hBeLUmJWdWwxNNkJlEQkhPCJVqbXckRKVpFNKeFBtPQLUtvaIUpE5by6EnLsn0IxLSlO2yxD2BCrUUSJC7ZCZRrh1yIOFu8kWUnFShKCbCYHCKBYEUJw0chKY05COqUlPgUly01K4RDAmXLYh0rkL0YhpTkDkhcUrsWUncXJbYHyKr0vQmLgy6EiFjJLksmYRS7ZjaWl6CUNE0yho6KUyONz2+BwaiG/gOIuR/ATrRNpum+xNJLyOPgjUErk6DZQ0JJ5cjZ8LCF7BWuTGqk1w8mKpKUpZQXFLFmFagvt9mWpwU02MjhlENdDSm3yRhHYiSyJXHyRAvBviKTzWoS18EFS2GxTRZZB2aRH/AEK7BnfQyBRfQINLiK8hbuCUti2xPJEoqbSgNBVr52S25Ry6Em5NDW0kKcOJSw6EoatTv0PgRlD7Hl11pf8AQpRYf0QcUszE0ijm5JDcDaTbcCQRhZW2zKIhFCMTTsKBkno57FUjJx20STanSZE0zpiVoXNstDgmQ0W9kOSrKEmOUitPaSgkquW30TJgly2xkndht7EMqZWUNBLwo5DhDQmSVf2NZxEc/IpJFLnlELFIImjnNpETRLacLgbBJepxfBKc5XJlm0MMbcKSbIbfRCFFO+xyuWpmM5FokRzyWaWlm9jmiMDS2NDI4ZpJ6Ktg3MMR2LCWWba/7EkVoUFlkNVwLsTbKoFuzoqkU2U6NlRkrtklSX3AJEmlkcQSVn90OCNkIWV6mJqUKep/sTuTq1QSWOMkxyNUcJ92RyJJxstuVCaAIElGwrRjucocBVG3LQ2hGNNsdSoFHIT+yIYhKeo18iWRhuGJ2tKQfAzSfJcvZBnCKb2MmLCjEzdRCYHFhSj2S2EpbY+YM3yJISsmlkhihiEQRHSWvZWVH2SMOD0JdjB6E7ynNpyRUjTacGNhoKuM6Jyl1b0Tby1I4FDZDYgIVZd/A5reTaHskiCtsWyRwqv32Xg0JGGND2SdL4ZuuHDjD5IVSM27wKQrPBoQee8CWTJyVMScniYqRI2U6SNkpa85Iaxgtvp4AaeBSQ7JHMZkdIqpuA4LRU16IBwp6GsTpYJC3abUO00NkiIwn2ZTMFUhN0OB84AatLRnmCMSsG3A1XBYeZGylQkoRjoVWpoUgbTuIIMaU2iYenwQtp2uCKUyfwFVwJqfzwK09E9CeBTWHuRRUlKvLJEySltsvNHL5yTQ1UpYxQvRxkamoRSYz8j0oaBSS9nQkdNHj0S0c1lORalI0ybRmCzg3j4JNJ0wwpKamcJscRaHI56x0eY3AxPybolTaW3sicEyIEtIciEJXFCENOAlWzpEXR4aUnoqUbLoypv18kNJql6XA0iSf8lGhPg3skhMphkmlwTJOoPIbbh8pYDTgiSSmOjTECTa4hQtbMTahN5LMwmEanvAoJot4n+jBp+Qkmm6tYbG5lA1v0R0ihkzoS04ycMgEqMmCVZkcXhbEslTgiJlL6WxJs1YuiRlW1yRtslDdf8ARDCbakokMEEbFQ4hJjR69SyjV8s0JFNK8mx0dM4yHdGGXwIlWJ5EJE9nAukkv0IkSnPCWPkidPGHIfkubQxNtba9CapapMaU6EEsQzIllFKzP9EQKC5DTaZphLfsgN8dkU3SlRCDRNHvA1GGgioWRBKaapukJE3geBXbPCEiZmCfBCUFDA0gShH8m0lrbHNKnYNSg0setk+ySqi3AanUGrNojMQy2/6GOllvluxQRpoTYlMhwWvQY5+CTKHLsJNtK5k22MpLTRWtiGyOdHK4LOFonC2K4MoNxC0hWkRzkTEEGkbIjlLZfZNxRT8yJ0wbM69UlutoRT60kNdT2b0InNiLXcFMrTSrZImVz5vY1q2oShrEjcqUWFDA451J4EE2uXmtCRNCbTcOSSyQnbfYViss3+hfmm5b4M5lWExJNm8vdFyUStdlK0JpDlMt1lLfyWFDSkjYWtJFkikpoJgXd8C2nYXyvJsiOU1LercFFmqeFiiK5ahCT6VFONKaktk2adpL2Fq0JJZ+w2fBMbMzalNG4cqlGZJNJsqoX9iPfmCKbH9ELO8nsPAoc5aGk0J8rfYxSS2yyIa3FE2JIuE6MUEsPfwTBaXaRG4Wayltss0OSdi8Voo+BbU2iOiSUEy4rhDaVK2UxA8FDfZOYtn2TKYMhRFWW+y4dEaqsvZaMMvQkdTFrsTsjDWDGTGthhkNo2oVCjBQnTVRwQqZU4Gq5HlrXyNUClB0inl6vkc6pV/6C28w3lCg3xOk2PgbaSZ5+CalMBbHKTiTkJ0zKayhNlLSkh1LlMNkZU8QVJW3fwTOG25YpDObY0tw1LcDk5JX5CVozKp9iWTezKG6lJ0idUkljZ+iStEQoncqJjY5K2rCRnblYeQ9sy3Cr/YjA4egtNpJ7ehzyScN4EzbGjw5ZYxoJvN8lGjgpErenAyS4LHNcCRidIcTmhJnyaSlyzfiC3kco1RfgSotYJdDTROm5cOOBtKWeWjRDkSbGhKCdbGPwFyKSOSUt9jpbzhf7JvkD36LRhbckZ0tXyGI9kg3S0ZkW/YmScEVBIlg50IyR5yRtbZoQmyuaGqklZb0NWpCCW2JVjlnclHTJQmMZHKWZnPwTFRJMRsdZIrSfQmkbajA1qmkDrXK0kN3gtaHDlbGwVW8tFU9oGiUsO3PZIRNUt7KHLapCW3KiLgSljkfNYLAZNoWX2Hs1lG+ChVpCGiGctYgliUoohFEqpxFDhGDU+IGqbXw6IHBXZt+hzW7MhKbW8EWtbbf3Gyk2eH6ITbNtkUbUk5SYmRRlHLQ00balrXYzmTbLffZZkqFwNko5kiJWpFKEdsHTpYNmew+CFaW2QTulqnp2KE0oMFiHxt8Dwozh29IVQHKmWN7eVDeW4jBlSvsNoSK3oVKFS3loaifZDUiyeRii2ct4EkkS9gl0VM/JZYsP/BjllF8iWuB/IkB1p2SLeULT9AiSvbWh0OXSQjh5SQ/gU0rbYLCFIkxd/IhSw7gSH5oRqPoY42tVCkjUW8+iJgSmhy0zhTHJLyaf7GFeGtOexG4lwuRKFBDKB0h1fEERv6CUNC3chUk6diUNNjeLEsyak3/AEPUmGaiRE21QliRQ2yr9iNJRF/Inc4/ZI3mUpra5HFVCK2QKOXUsYm2EJrZuxZpUSTJKRb8C13bGJMTLKekjwuenXsRPJztCTZvwA86LG+RptNPEImBLfkZS1UKlOU6G2lNBkq0axs5SVZGmn9jRQ9a0XbGlNPKDUZkLoSU21Sy02PmlLXDsS+Ag03fVmpOMnONCEacj+KJhCwTRoSbXOzRfB7YqGuU+x+hMeSC2yJaE6x2RwSpKb09/Am1RPQZNpU/gkZt5yWJM1PJNaEpP5BtK4pefQ3F1IrfKWhNyTDKGjF9A9Rw6QgppqVJ89mBNVcEOWk7Ohm7nIprvksU5hTWhuGmXcuSbJ5aP0Qk3j+KQ1rrZQXnPuCU0kKpboautRhyVuslDNjtNKmnyuZJKmlyJ5gaSUmr0G1SbwsQS3yKqdMhJyWtfJSLGnSChjdzXyJN27ToTEvUbdUJNSNPRuiRSjTtLyxI3BCKewkKjfykTq0aln3IU2qJatUrh7FWzO6ULk5a6EtrmVKfslDfL1wFZwDcjlceIJ3aKMvqZUTaZeqHA0p5FSZNrb2KhpRSPbEqQhLafJJOMMxRbVIZQhN3obwlRM7+BDH8kxo3OWnGRM3QWNcnKaw0OfBs+jJChc+zgapZ7Q6lEWxyEqcolqlDUNDeLzVHAhW3VIc8lUHPQ2cmUtMrDPCU0ODlj9kmZyYYQ5Yr+mKPEYA2VpzH6MjVIphhjVCiM8hqqCSpmx6cHJ8kRaVgaLDSj9mDN4FtE4qlrllcWRfI42t6aIN5sLE7t3apB34VyNq0ppiTolaeRpaoRKCRiRnlI2RwKd8pGyoep72NN0lWB9dsabyZtbY02VS3ocG03MqvkT5LVoKdVKT5E/oKZiHGQ30VrL5ihYqhrIomuWbe/QmC9Ht9E0gonKZdRNPzGqJZpS4EItt+hu0a7ENGVIroi4ZTw+JE7dTKFM1vTEOUkJc8JEcVFr+C2USt8wYVRtoi6MTbNUVNQ0N4uVOoKWwQlssnJsMxCUlMdDudyhR6NORzRrTa0XUpS6EFxwMapeT9yKN0RS2tieMX5CMRShZ9miiEcho9EPF8EfhGHC3GiBLAdYawRA4pijGSzd2Es2l/ZQulmQg05YUPqi2hNba4Em2ji5hswckM8v0SRopNQ0hIkJwMPBFND4ETl3g4CS2MA4usMBSnO5xGpMpJwDNvixq1SgqCuTFcrECUuCUvgScQcb9SZkqL+REKBLJrklqmotw0Wp50ELkYQ7VN6EyFg9FGmt6Ylvl4YlMtdC4D2a20TyJX2pJTO2/RJqZNmWxptJeQphGDz7GoKMs7QkleSrAku2QJRCd4HIlKwvwYtwSnhjrcwq9hZPcukQ5nbxBVBRC7dFg0NU/UaUkQmeyLjUNWxNxVQt8iVTkTwKIvoEJXKnWJpEycMkQjuUgSUpE7TEm8LVsJTLXgUlcpyhLTQfoRnJufQjSFG+w04kcNshIQUzlIahC6GwmMG2ofoCHhpJGCY9stjEwyElyWhMhYXLHM9FtJqUzD2QdtlDJ0Na5ITlxhQttJurDQhqUqC0WESSQ3sXA0TFnw+R3ME7IwJm0fyiUVBi3Cb5h+pEW1IktdBpw8NPnhDQluD8ETLVp8mNouV2Nlm2dRJawTpX7IsjjA6RBjScnwIZrSXDE8aH7MUpQmvoIJpnEGn4n1sekW23TBlLpK6hNwa04fK0JuTd/kfoVpOiPaFcuqU1yJzeSyGtpUcC5H1x9jyQZo4F6EobVt5pPgaqoTbLbwh2lDt8hZStfmJlQsNIt2xP4Rw01JLpraG5UrYaeWG3ZLYnI5o5Ky2xtNIQ9/2G00HKav+40pSI2gyU0i3wGkoaT56GpJrMP9E1BK0xtNRU4WNtto4JmKlw3tDZIVLlMNtw1ixJDTa7C1IRWuRN6o5yqexeHsQbejSK2OZQ9qcfIpNtrQDU0nLRlLQpY7DE2KUK2yGELMLUhPk4h8uhMzVY5nk+6Rq1I6bbG7UFDeU/scTcbCRpaITwaQlRtKXyHEn0i0Rq1KqtoTKpN8PA0NYHXaJtuaCMtEJ9hDqkQ78jyu+S2y6ZojtoS26PCc+xJglrIbUpTUAqNFOk4SItoJYQjcbuk+BT4UZvgklDVYTQhqCW5dKEVJik9NBCGnSOYbQ3aqq2ntiZxCaeNjlRTWW2WklHP9hwc2TX/scEXLK0hIaLMXA4Iakz0ONlJh9mEJKgGsjmlh/wAgar5bK0Khw3cobtJbKax0TWSEQaaVcxzbyKo5JxNmhaaTf2AhO0ibK0lEITMo5GnoaNtCJNQSdeCmG2A2ZMpwBKJtaYuThqWuiIbe4KemJrOu20KT2L7yJUzpyQAomgopuRxSLoJ4NCZNJfIUPsHA4JpqUUOqF6MSmnWEcLJQlbFq21QL4B1KiOnyhzbbujc3KN7ErdIaylsXd2Cdw5JlPgVwxpwiCpYEqOEyfpdFGllb6XRRQ1OwdEklsKLAtMNxt+AaNSlLlGxOihNXO2N3CTJylsbNppSy5EWmVXaGrOxNX/ceC02V8BskmlJnocE08n6ISO9Qooa2nbMGmpTULsUTdcBpRYwYymVgXw6cdllKFt8jGTTiMvlsbdOwneDSL+yDkZQSGaUX0LCKD1wRO3sLgcJOZoL2dN0sBK3oBw7uY2WlLSqn0SusMPklJ4zXL6ILarK5L5WdiWUY+YVVCpUtJRkiKHCY5axBKbdvBB0ylrnswbZdCmpGrOCHCZ1NFJTJ8kEpcRH7E4KIRy++hSlqE/sk4SsBsStlwh/kaUtFSqEKctUeVwRTyMrjgSFgbQp7OOmVjJjiybTSrScbDKYFXCoMbtHTVzyKcI0mn97mBEEue7JFHL5CSlBSv/QpImWp6JFYhOy0iiF5PoZJScuqFCUWq6sSUNqNR7CQpuXFBKJIwcaUqR16lndP5Jc0o3jYjJVPJtsjJhs8hwGRGEjpzdyhiSUq+CEg0Ta4I3fB4ESlSeD2JUlAbXBwVClgZTJDZNVRA0aXKSErxPUgzSzWIoOG7QnCNoRuI5Y1s5dQ37Jo+IT95IJgFfYZB6iz5hYGaSkWC5LzJ6ktt8iQpVkdiHV7Oj9lj0RpOsyppjdCa/CHS7Zp69CLeVlehOyv9El13Q3uxUh4FN8FJUq0f2Q6sHSbIOmyz5G2rEk7L2JpYrYkNclYpBk0pHCbcC31Ha5REESnKYiSnTLKeUW4Fm4ZTc2fY7NnNM8ScZ4CiWNZT2h20a1iJHK17DSi+xA0aFoFtNDSNEZNT0jI3eJvUxAzlSPv0E3z3aPQ1DhCP7BWQlOpEoJ6ovcqRIlF98dUQydTINJpMpaB5TaV0DWSNK52OycLGhE23BAstdoKMgVhbIXISDzTtip7EM+zacrifYz0NMUTa1aHpK07bXGhO8irEjNTgqORMihFqXZC5pfEZIlTBgUiilU0KbT00pnRRIr/AGEk1ub6mSU/YdGldDNLRLfoSLPpGGJPAQiUJr7hwsSTv7FEJsgdLtYxuypQm6HT5TFrRy25R6GtwNrM6JaZKs3DYlgXk9imbbT/ALjXDw9BIoqwN7QmRwIzRLTOURcPCsjspx0ENmSaUbyMK6bE2oIojUDlCJYQtzMvorRTOfkS4g1E+yucJKDhnSyQQ64WNYxLB8i4mpafJOTpkSG1E4VyWTEaxoz6DXRolzpoi8HQQGizkxNrIcstMM+x7XZRPsasMqQhJ4DRg9ra40Nkc66jsE4KjljUS2JS7EKcxq0KbnOASNF4pr/RNpMWGdChrO/RiLTsXEchhrVASiUrY6OBLFjalQnaBo6TfkRppZPYcUNJG6nG5Ck8pHC9CcTs9ElmXaFHdGD6E7is3ApIZb7YndtucHyJpcA1RVYJ2SlQSA2bl2HS1O0GKMLhCVwnEfaRUcA1oTtBVwtDmsj09HuXlcEGaJPkubWKGyiqoSdmR1fY5lwehYsoTwFpJTbcloVDVt2OTXTW+xpB8dMkK/RRKhaaRhcMj3Ocv7CB7WRiqdN2MiE037SxpTfMDkNOjn5HBOhYnEZxBSrWhnhoE0aL/gbupRpEzp6q4P2JJyttZXHYlPIrYjmONiJSlOBKaKc7IErRMtDj0FhIvUUb0JcJKldFsiV03uRwrFpK96LFQuOwmmbI0xJZLV/CRMZPwETTCyuDCCb5gRRyNxJNq9zYktNUEkNqVG2OFrhschtquJV2hKGYrgNzCIacstsTaQ60olmuIo4NVEDGAx9hJcWLjgnBAi2f8DFhadPLtiEzNKEJi4WFgnLAvQSouXYiSqeUKG00p/2avDXCYlE4jDwJUFa+4UOjl74CTdHMtN/BMN3hmqfaxrLMpudijM5ZaITJbJT3HY0kpUqJmQ2w1l+zTVafoRTwQeU0oWtCtwxZG1TGtCk67ntDtpMMNsabaUYtLPyKEKuZDUnlanAklyTT4x8iZmxfIyQ6pzjgJE+Ss+eiWCn3yOakdmfQtFQYnoVqTQ+2sl51i29Cp1ER35EbgcLXJ7GmFUPlMjpLkLQknIuBCcul16L/AGOBJZmVKelIoJxTbUN2MTKWkS0+RjZX1b/ojFlWkz6HS0rPsFBSyTbRbMpSG2/YuW+QI5qk/wDhkZU6TaUIVdIIScyJ5AlJp3LmBKhqXhOJJK3cT7iUrtOhmOUcHhNiORowktKueXA0w3tshpNSpQ84bbEcGqmtyQmRGEHEVyzpP7G1MbbsLBmblhgipLJXCFIreErJJsUo8RU9WJpM7Ve3RbYS6JY61choRNIJO7vMDolSrNYZsKTY8+hw0R0ew020qh6fPyJIKr5S52JSbV6XAhcp0Sx8jXYMHkZJSfDehyktNU12MSql1fPsldEtJfqTS2L4GIUdb9E1SLq8v0UFtJkXcsJXbYlpRsnRCSQiKhKxpuhcCSfB6JEprVYWo+b6sUE4JsoTY0uTVN4Q1xw9X6KmJRw5IVpJM+wukhQrRbG7h0WTGOGGvkHZ7lohTA3SsVxD18CoijGB7tO50K5NS8OBu1yJR2pN8ikUbmUBTMiyaKEyIiHjL+ShNJs4Y5NLCRRykaqirCcZ+ShJNNwl/sSLbls9YFMm8C0MUklN0pwMZHDjklJ9CjOh7E0NSTwGMjKYbIBVyNimkCeTY4k0lLWykWk1Vn5HJpOzkYhEYtb+RoyTtgmzaUrBI7fgsfJNmDBklaE08PiROk5JosJ0dZa2SlFQ2IOA0uBsnB0huyFheX6I5KTMd4uCvZM0LQ16GigTlEoU2FlIlpmOQp2icuhKbFDTwQtCyhN/0RGjtqE3hPoUmRqOG/6GiFErlsW1qGX6G5bFke2ywlz2PoUprkeW1j/ZWU4nApJq2FgY6FAY7SWcwKZHmy4Qm2/2ySLOVw++jeluY1x3ZQaaUy8mKwKm+DCWs9ZGz0whvsgok0cZIoR5Ukv2Zdt1RgvSnAkTdJLKFB0LOZpCRUS4mdWJGz5VIU01tOdtFbSGx/0N2iTfJvQ2StMtiGpShMtiW1QkIGnR0HJpanTK2TaoHqT9JXMNypwN5is79FAuXMrF4IMU5L5GMWnDEBocF9hdFtllhkCbnJjgTUHkcD2gdPCsMqEdFCjZ8BIcobMyKU36D1G5cLOZSfQhZuFQNl0EwiaJvR0NUwRbkrTUfDHJJpNIvk07BDeEOBCSler/AMCULSxWwkadChim1ho4OAiv6ExQ8pl8CUtkkZEkrlaVSQ4jC23wIuTlzkhtFuEqMbmCoV7DyYhMp5FcuNoSS57HLSiGnG6Fmm0srQk6fKSJSjtcCtGq8GiJJJ48B3BzhN8kkzSKbMEk6bZlEt2ZmUmlMticxUENQ7jgskWksTX/AEKWWSf/ABQpQ8stCTkVOBJk0mdrhTUiJYM4NCuTeSfsanWnDZjlp6EcCcreii0Upb5DwlIeYROnRN2+hWjPeTePkcwY2FyKlVl2YklPTulyWWfu/SElErbFLbSNERc2nKFyNLpmrBYguEzUKZSyPA6jhwJUs3h0QTT5lzwQ7UNGmXSIrMyEFzaV6GpGUvhEJtOGhQ8fA9NKRlsc1GE4DkSSwKSapwJwShp7T2QyukihQJgSa4X9kOF5o5IvJ2PSQ5yTs3r5FlCSYDIrZp/2IAt+mOZimqCZt29EiJy9XKWwoE9nvREsnhTa5IseUTyGZUcP/LJdfgTnGCwNNQKId8ex6NW18CLJJRKEHkiAGpWpUkSQS9LgSppJaXRaEktGJQaaIVOyTUyin4G8qqoWZCbCGlVWUQeywfBU5YjRNs5eh2Vll9kopZuJiJLh1Lk0Hm9CWykHttyNEdzatC5JGW07L4HmaUKqTFAsK7j+yInCnAolk9xoSotv4DTVDR4CKdUIUpRfBYZzouRJNzOaSU4+DI1sDG3Akk4DFKNJwEyckcCTauCh7T2Nk3SGRxoTwj7KjkatKk/SBIbJcnx8lCTSyHBSTayJs2wxMmxXwxLNpWELZySy1IiVqUK/cTtPNFKHKWUYGxElOGPQaZgTkGppDU4fZLmZN6JEXlSiEi4UJYbIw4ToS2RucF6US0hFF9SQ2nwqd6GzE4irIku1QhLlxxBRWsIK9k2v9mETWwainby3gk8MPPbK6n/IsNTuI5JhySORWJNtma0SacnScIbN0200p6EjkqqhjYlCxgbNJSlMbBFLeY6LNbnLaQxNkaWRYGqY1Kw2WZwS9CRO64ESts4wo5IW6EeVksppYQxROARFLtKEpWXaUQzPZO7rBGhTwtDYTEun0Iiktt0WIkmNp+xAwoTyydKTyfoTzMsQJk2q+BLZpSokxLTapv0ELslZuyVOyFKgS3qVUpIhmm9P/Y1pG0rg3Bg0iaaFHPBsVoTElmVKEGTShWGDhUErNZYSpFWpE1nHITo6rh2WEySqIkOSqQ5XVCkyNysQThV7xwNQrEZb1BMRWQMgKeRzCVJYpQSfIcnstWNMnKwRBDDCfIpwiiY+BzZysJ7ETTtrCHE3NFSGyRV2JuobsTpOTaYdKVshqGqjdijx26CdQVJ7IHhfZC5vKUK5ZSPfAtNQej2ZQQ5+Akzat6RGbMFcmO8mkEYFGNqTKpidNLh5ghskSggmTSzIQ2sJfImlI7acChMWukK2xKG4XImTGJAsKrWEJS20rZsTK/5Y5S1hwNJJkuEhMkuR3whIaaygRCS2glYSSZBKb5WIlA4b7Cw07U2kGhMokKkldCElOks8jN7o0pQeZ7g7Gl1bf4i1enOy0h0TrDI5gOIBKD6eRPgMm8fBMlCcjJhzKN7HCYsoeMJkIUn/AEHbTkVik5LTCElbipDay4Uf2LMk+QqpjacP7DNEONAjZJJ2Wppe5gOUq4eghqF0uyYrOcXCShoksJoVfiAlAoqwrkZe4tEGqh0be4GSnwvyZmMLfJ8k3NLR7koSU6Wm/Q7tbx6iuPNJpDWkJSGrick4Y1bGU+BKbtogQ2ev60Uu5NCJ9EObob5paLCpq29tehJIXFdJG9LSSoSRJWL5T4jAN/6BmMj7QIluoNz61JNhvJAxkyGR8k1+u+CxWtCDTZykn0/QkKtk/oZtVkt8qCTRW3I1IqhcBVTxI2IVJOD3IXd/aDqMNBCUoum0uBGlJ2T0Y05qKeBjSHQuAlLRVKehSqXsMSm3RDg2JKIkns6G2DLDa035DUlGnUeyQuo+Q0jTZ/AcMmU7AaSxDtOBbM7+wsNzi4MUDdSx0Ep8Q1p0yJQn94JGBQ/uEaToS/IRtNkJZXYlQqjRzJKCZr5iTVyYjjBMWeBo0oTHBDgOS6kVrcLCZuTckIhu9T8KJSiYdH6EK6ofaqLSJJt7NEJpV1Y8UpaDZEqGyILBL0LF8C2kNK3Ij1BQZNGJcubZdidpWsH2KRsiSWiUz+hO9pJ29wKT2AUsVQb5EnKnJuSYSRYIyaKKkExFFQaKbtmYs0kaYoo1yCT0Ok+RMU3QolqRO11CaJVRpfwSnlJtlppWlb5FKViS3I1oSy3IiI0pt8kpIuH3EMt1C54KMXAaQTuchupVKsnA4eazdig3ILhI1abJqpPgollqEp8MPiBRKcsn4GkCo+6BrGFL8ijGt9iKei2uRihKbK7K8KGuicEv7ITZBJgUqZUrXyKLImFDJs0OkMmrhcvqYaZ9GvSM9IrarIbcFkVFX2VaWklaHBJcs8iMkS2tDmUpLQJUXJwIlNMvsKk5tl2JmlOh9sV3psSVioXwE+SSwDeob7AhtNUmXyaJX0oEkiIhY1joEGqJpNNXsbW7aehxFq0wCQ1ZklwOClc2nwchsqP2NnOOKfAjkvkGrLCbIM2lCLTZIk0pK256HKXINHDKxDkcHSDqyaRdkBbUPgiQzeChlhHAq5FYLgWmnJrXQtkP7LJrUH5DSJPs4Rsab5Q1SXWnoOJxKMhsQ5HIiTVVpyQ0qhNgxyqrQhk25fCGiaV6EJSMlrwRDTu5lCE21k64MZC4hS4MSStZfCYoJWTJCdhr9BKU0URfYTJH2NPiw1BTlPPKS9C0exOGSeWuhSms8a4G1NlwldFmgYpTIjmy3siapYdhnNLGlwIMFOf0E4zJWsgxEPLCQsEKxtUoTQ+GHruYcHRWtlC4CO5oFlCojpm2HJpD6jArg6UyWbMkJSuA5FxMbBMjxTy1l+iKrisW0aUcOROCbCi0QRKvTQdF1HwRhbeCiyeHXAtZsfYJSx0KbuT4ODNu4BkSdfwMBPkcoTjCk/Ql4hrLZLpKM8mNtLU/mZJcLO/YTFSqw9G+pDsrLI1ZDNmn2UuhwFgc7i5JwmfLEkxKbfInLommG+xOjDDSImk7JO00SJJvB6QhSSVL21wKkaQ8nQ8QRsLRKDKam6IwrP2oo1lfsguiko90DxDTjt5ZsSu/Y1KoLpbZJ2kY6fY12RY8lk5VOC6E0nGwPSE8STkWhOhu5EqaJ4G9DZKGm3ahidRknk0JagnIGNwdDPwMZpIMPlCm7cNtckh4W2WymzksQSbZCVf9yINbnf1RZVNL6SuY+PCGllbByVZKUc6HaJJK0uAu0mpF8qLEilps/BklDWzPwQ2ia5HI4edF9uhybfWS5JUgTXYNqEVN2JNI1W4tDeVmctPEdlJjLWrwkOG3haWu2NpTCUVN8ipJWf4GRJJ5BBQmhkkNH5ShOhunZ8DckpqW30Kpcl8iWXEvyMYzXQ09iG1CUrRpC2nK99IEkkUtb4RAaQ0W9L2RImtogpFL1wihFZ1wGBb/AGC0MqozBEVEoqbyyyVFtFm3ELpZbIlt1w/tEzkqfDzyU03KHh0smJTeh6REJ9l0RA1FIRuz4fA1CUptnYbK1p41Dpyp5I7clH6DIyg+RDe8tcNpb4HMcchsSTbfEBjQKXUtih/5qEm1AmssuxC+yhIybtg00qJjhDUJEf8AUaUw1IvlHlMdNkSZTWmyJmknWrLUtJc89CZtxKcLliNKi0hDbbRSqfLkhUuktERkrRtytERaPRel0NG8Q20UuVBab5KJZPh9kaUnOBggTJ9JAHJpY72DbKM3Yi8qtpD3zX3MTM4iZ0GmCFtNDCbVwtcJDUmwPhCUm0pVfA1pyLQ4US/wCgkiU6Qgqy/COSqkaMtHZcTeWiRDUVtPZd6cFlsa3Kxhy9k8pmBbMjndIJI1I24ISzFuQkTfQ7HCNtgiSy12Ge2m0aZnlJHKnrYkcOly6Js38DZMcIc7Mg3MlkQlKbWG2yQfc6kYQTl0lJ2bDhEGVNtgNNKEl/2RCSlsDWFEPyjTlSST28khGkskwmSIaWiDipLlb6JOYpVLsck0TEmW40prkUUmqa0WiyUaN2tCqY2SrwkQlLiU/EkTMvngTYdwItO4MtemzFt0sARROB4ZI26LXJaGrTfub6GqEkCv2Rk+CLY1axoDZyWbtDGOUN5q62uBCNtS88kWEz3yQJpoPJ6Y4OFaMHBJJ66EjhHscoTHEAScQINWrKT2xLdVBOlvayhJUr/wSJQm7qKcESNKDynj5HWZOzwhKBOGZdihQrvSfZcJl4C9J7v6IlpU3bJTRSS7exNPC/cXVsL2NMkhafJlvaWJsjC/3GSg9xOSVleEOUqh9uCjZqYQvfo9T2ClLSqcAkS0njihGafPyhybKzRY5yEpSTFcFiaNfmGtZClC6Kj8QqJ6ehHeGtCcbda0L7QMSPbQzE2rlEAUKISdAqU1fcgdqSNGHyNybVx2+C0JUq45LDWlJyJpwlJgUZVoSkcpgmErea4HFnytjKE2zpvkdVNp5PRFpBojSx4fIzUiXCcmalq9GejRCqhLKGs/BZ4TwekUe4klM7TIdzTWxsbSU1wehtJN3er4HSKLMG2SZqYE3IlHMNviSyvsC32O0uFiFNG8i5QmC3cR0hqUeiXCEpcxrf3wNJEpZCqWU2W5ejO+A8onoTo5zS8qMgqpBLCjJuWQicbL9iSMenRAU4i2JmUnA7EqtUtdEhJdECZuDoeo2NKErhHM8kPdirTYlCzJ9iHy3heRUocUMISbNVRcIQlO9D3A8FGSONFNNOZrhiQQL4BBJuMc39zTT/PG2wRt0HLUctzwNuVang8/BMZEuIZnof4gDgeUrJEOJc6hlPsaiiojliStpE1kjZxFENpwoS1H4IjuuFjshNKQiE5KPC9kQj0yEuiLENU56LkpTdXoYJErYTX3EJZSWx7IlIElJvTV8CWDe39DE+ZtQQ4T4OfZ6klQw4MN9iOza0pCSguGVyhFCUu4jpDeGl7Lb3s3/Q6JXyCUODhPL/oaUnwXlHwKB1daEQzS3Ur/AGEqTVaU0KHblLYGlGBMJoWIh6NvQlpaeH2Gk8xqSGmiW1dPXA03A6GSc2XYlKWW5ZlmDsyZC27VZNtS1JhVJrjD0RIu5PYl2FuhOeJjhjghuMQ0VLaZ6C5eKWyYbJddIUEGWXCG4S1bc/AoiG0PkWSNOySuWCDArlUrI05NPhrLFmKS5WX7LLFFoXVJq01yOPDV8kW7ThrsukcNPgXEo8LgstMmqvog2l6shBNPM8stcrTyHM+QapCUbhGJOKpHAV0gTNJsyph+BvDNpyl+kJuF9M9jZx9sSwRV/RhaibiOsjV0hkkZCZ2IpEOBDZVm/wChIN2WbzBKlKJGoc5kpQqE6Fg0KMk6CJwyHNCJEaC5Et2pwtEKD1LSvAyTcd6ehNHavmJezZcsaopvZ7Glg3gldiSaack0mJEp6w9FEO4yuYIpUJ30CSa0dtiUpULhlKWRQlovdyJcIQmnwi4IVrXQ8p88v9FE1kRFLbI0kfDocNFt6lCbabwZwoy/YlKLQGqSWczwOzr0SklaexzI5QQl0ESU5SHJa3Xocv8AoBBZV1GrGsp24pGilrb9lG2uhGtqXQ8RJhrLH3V0FphapG0iMpdkGSQSvY2ion7AxJSlNHehlf2WRt4+AmTgpm2NqFjI6CKbyES2RDEZZ4YkjbANyV04ElEVLRfghpkK+3yNVTq9vY1BJIpSIUcCmniFwQlUaZWqGTSZnBdCLJR23A6RnGb9iRm2nMMmSlqf2KHJ8TPSIQ0X0KiEwPoTNStR9jRJ+oZ7Z9iImiuBPA05w4Lwjlcp8CsE08NFa2XInF82eSQ21bc2VUtilkZbKTQnJ2wYMLaciEn/ANgpXpWnsi25NpvQoC9RKJWZaEta4+hIyASbVbAQ2VOwrKvMLDT0dk0TqRLhfCbMmB6DhcLwGWSIV7GjEstjKDimw8SqyT5GbUFS5fBQVTiDODRim9ppQnDI1saQpTI1adKSQrKiJXI0lLphCnnlDuZCKE2PgQycOSBaRqUM3dcDMqSFcwXCQXIlspez0Q2itTTUiS0sFy7FDRrbMY+SLpuWEuhIL3zDkmVNI0+zIrY0EpTbVNiWPbNTV7jgU2CZshSe5TD3AosYOUfA50eE9p8Dd3nF198l3gUaRkmEQmv2aSTS0uxqmh6swjm5gk1LMpbMihSg1Es4eFx8Dq3ww2NrSLyFeQktSRVCWelxuBawTSsg0mVZvb2MliKH+xDXgkwkQLvCEXOXK0JGwsgmF7FDIKCuEmZIbBsTM3KnF7RDTtgqbfoTTJpYoKXUkjt8ohJTJMlzljSSjInL9DZ0q6kjm6yVCHjmKUiBqKY9EblrGMGkJtpEiHHolEAU06rkSuBiWnySPgihNga9Wje4FWIlDN3XAxrCFcxsSZImVyG5hL2gScE4Glm+RBG4YS0U9ia4xHZIdk+EhU1Yz7hCZJKHHBiSTR03h6T7IjQ2qlQptoqeREqprEjTaqUXMPZ8A5afBoHznYr4F+fyJJYqQhFBUpCa/wBiQpRxKXAiTMugWR+nA0id5PgajWWHAikzh4U4+BSTWCZkPmLjhxJCQktzCEhOzWxWTK2S3YjNYKBs1Ukmh0qrPCJU3Utaa0JJs8ia0NJqySkFCVTRTeBJqSmpOL4KO6ipsROB9WEpZ1CuW+ho0SpkuciGmVpZyRCZWQndJYQY4sIlIZRaeOiDCWmqYkZ0wOBbL+hEFBKx9yC2JMsT0YtsxF4FOybMVEocw2+iAhWna2UJpDVoy8JjKP0KaMwqT3yNYX2CkWWhY+RSEbnagUyTLWvZC82BkDRO5haEexqE9NiVShf8YIrR6LcVRc2IkbRyjLNpJ5T+hWybNLD/ALEbaWIpCIzFTRNDlM5hwtIaJm4aYid9AlInh3LEck6aOOLMErVePgVPQN/0RLQvU/0SiqZEJcczEIva+RGTJxlBAYlCQaTmKBChYmwtEpOcHKFMhKd9IUu0ihHD9k8UyU3gkuUQqcXwP800UJkjJ/wh8dGjFqtlkqKyWxQJxEZQz7gjVI5CjSRDpoJUmS3HA4BvhEGaaq6G7E+06ssYoMPsMSYlMUxvVrrJMtDkYkVBfYipNbcimoUp3aGMFGBSS8iGyRVLTXA0SWWYEpzQ3bXBCdrsCQjSh22LZOG0hMRwjw4FT2OnwQzLlSbJImsj5odXG2t0UKRDvYeAjgNJRiVIRR0qgk1fTEEJmzhTMrHyKnQ1gxJNlp6FjcnBZFb8CTb0Qxom9FiT1S5fVDUEnlWxpI2RfwGs0qgaKlKmlkSFUOuPY9GJjUJdIchRoE5NkSWnpumToei+kLSYSekSTfIMhuO5+1RNI+TQkUnsJUs6BK2CewUJNOoChmMICPO0PSfKiWkybfZJIbpQU9DNOEDOr1hN4LkqcjgmhLYjDLTEihNp1hZIRGHeVD3Js5mqRtKQ3Y2VLLYaLWeLJVMnUJyJyxJseSHLSzDbIajewqo7aYwKXVplNz0OkakGdfiXHtCGiW2fSFbsWvgoBt/CSGJEPbQREXtchrINCTasmIOSmJDsobB4foRiLAY264tXVjGJpaXIhHLKXoY18qK0WRwEUVX9kKCKMIP+iy4K+hNcnNkSoRu5ZJBCVFlW+ZETtSrwmQpb54TEr2K04pfAjjLfw4EzVFJKdjoImmW4Y3c25wLvodtjwKCODKXBtA2+CKBYduDYp23oROzfdKSOoqFyMcUt79E0sipTsSN2RR0JOfpMJ1QlmQkxwxqnJSk803oROKIrI02rSnNogkhw/AabWWKC0hpylTtwGk85puWmVIhDc7mypZLvGZ9vIyuT02zSz4XJmug+RcpkwexaNPKwTqJRP/UTXqcQ1bSISWvY1aSc4Q04qWiUK00s28tWOC0p22YGoGj3FyNJkkkpasc/a8/sSnamweGWNFAmc1MsoSlsqtLbFOsladiRcrj2+Bppgwhr2aUGkivwgbaWLstDwiS7aEhhcjgbhlV3EkGcuCIUtPPCbifkVqUywImXcanYreAlNOrErlqkxbEnM3ODVjTc3LXjQjI0cEUkuJ2NGxN9ISHfbY0p2fvFI46gb/RA8cCW8MQmVoT5FTlMSqaJzZJiaFclivYK0014ohE6ITIbVkdpOy6LJZy+AnIac8AhlI07bsc8o5W2VJdCcfCskOIQmT1MqRk7HE7MJYfISODV4aEoBLSn26ImTSaPkNqEKqQNYv2+iGSN2NQ5RvImpmVs7gasmnIXJgcBvRPOoxPliSSof7imhXGAsnQso6sk2S0tLkSOVw+Qai5XEln5MLcNYNHqo/sdpI7NCNJNXdvgacoxYLA15JFHJPliS9BMhS2ywsUuxWptZ0EsKtMRvQSUsQ9CmBqUSn2JN7bnEuxpudtcRoaZEopjhMOUamdy3Q0SjN6IIgbNvlqR0wtAQSE3kTv0JNUVSfJvSOliShoS54H3IS/6BptO2laNuZSFIlbypVRBdWrWq0hzSme6XHoxTc46Gki1sINOjhJI1iRgkqOWhKeieBImbKrFprR2E4KnKTqSRFk0JoZSj2TLa0oHxGpyMSXJlrREkqc3L/7HoRIz0ihYWvZKSK4lZKWlP+xOxNw9JojkMr2hJSqiol8DESQlWQ8iRtXKITSTRSkPNIgHNa0amCuVENK2eY0pQ7EpBSpKUrRr5EbanW3wJKnI4XT2OlafgK4awWPI1ptbatXmRKWEYh2PKqAhOS0OidK5S4MadkDSmTNToIbqVJ6hKGDgln2UXJb1JLTa23/THyL5klpbYI5MtWpEp70icnGATZymEXWUoohZ+RIiW4RDgwdCuiqTVJMMCcTITELMcjIrfyEi+GxAlTPVH/ZZS0ILVCTlLkUiX4PwPclCvYnlZ4EEPBUx6SuX8BcJls7jgYixPIxJJZrpDpI/hDdRJXAklve70JuXQpbhjc2Oin+BM7aNdFs0k/Q4cCG3yHCpbibaeyajLYzpWVaWxqlhOtDkYibV+UupYqxMpQuXrO0tJjRX5JdsiIUpX0FMm1BP0OQUlNkWcCKPSIc5eem0hlXSKVygScQUPLckCS/7JGiRDdRBEHmXQ/Yl7K0OZpt2NEUe2sSSc7TtLhiNT3cr2zNdsCm5Ko44ILJUquHHBJG1Eq29uK/obJAmyIhNf9w01Ms5ECCaUa0NnEnUDWyzYQpRWi0MLWuGN5aRTDQ0TO60uDE8tUvgkabZSwEeaXRtwhwtutq3A00RleXyN1Okqnsx0Mv7GNGNXG1MSIWjRCwJIrsIS5shGu4MrgRZlp6kbZaY4McZsPyNdtRhdCJKdISLbVp8uikuaunsSgXBbGaRalTRhKpYejkhJlZGGLbM2J7X2iJK7WV2G1qCfYw1iXPA7kplaEzFCY6CUmktL7IlFtuHLfKEaE0qfIm2oqHlkQoVGHMjpJtGiiWSGIocN4GwLbPQSruUyFM7WC7Ehtc3K9suWqXgWk3CkG503goIiibN8mMITQTTg7HImaDva18jcHZKj4ITxQrQNrYyholFNSEmM7fY0i2l9GSMzgsPhi217FwkVnqpcBNktV8BUbcKdVuCGqEWy9sT3Wpb7ZaJ03/sohR12EopU1CGiJYZoiqabyoh2YNT0GoeZudSQmEGG28oIk5Xg+BYp0SPNxS/YSgldTnshRDJZYm0qxKEsuFh8pGiJp1QQT22DTTjK14GoayyXA62ubXtiUOGVnoQmlhXAxMzTrAGraTHqQ0d5M8iwKF8uhttRQwmH1HIkI070G4J7OGOoeU8oayTba0GqN2IJzw8CRJdyn2zizAVZtlUn6J5NaBS4JWXsWVRCZgVaE3yJya03nQdEkw6T2NxK4T0OLFLBCZLBz1DuGQe9MVdMaTdcdMfLExjgPpCXCBts5cxXoJXQjPoTOBGRrBCfkVqxlpbEkrTWSki0bjtIyLWKQNGawFtBM5VwKCO3DUFFGSnaLOaaPHAyiycFLJ8tE8khuLaExrMpQ5lDkml1bfItMSacS42RrV7ILaULRdj0KhOo6GrKlUkUvkLgkZMA5I9X+B2bnGeBsa3ufwIbYl5ilzWHhAyli1sRtaFsX7R8lhDXMf2NQmoUU0VpqoExVbtJHohpVa01wNJpJa0hEadTN1onypjhImcwSTDJNkUuA6pcTp89HHKtldEIS01libbrUZ7ESUIUNNUqXHQ3itNNCMDSVysuokSmftBGkjLWlwPDi5cyv2JL0oa2UkHM+kFPkYYmRUf2jylO0hP0VZQ7eyEJRcLljE5/kQoBNfKRsjJwmiNEtSltJC4OvsFzHlyGIeB2iRZucGhUplDgrm8GQuQ53LzgW2nsPpYGtuQb5IGcyy+x0LS0hqsxC0Q1VgmtdDkmJRM5l7Y9v8AstCE7ksnpbcpNBtuGcd90SgeFKjZLeWquZxIzTCpgv7LS3UrPL2Nt8JpgbifULpK5yaE02jb0djUjTnZtMjBqdnMiLHD2IZs2cJ7gaRsLbrAkbYp95BNi3DfRaNdIoC6my5OCRQ/2GTWRIWuuCzTU2zaE0k0fJNIhJJKl++BSjV2aZhKU4m5IpySFNSly1Be3uc2JjjSRSvNcjVTULaS5Iu24Yjky+DRz0RBCtRD+SLgvD1gaYFK/QQTxZ2+kOWlL5nXoolKlptyNVQm4bJBCYZ3cjVS7d7ImfyKdoa6Gu238jHMqDjfA5pzRlNiXJV8oFbQLdqNNNBLZaS2SpOcnXhLZiVk2U+BYTKxy0NJNIpabYqV9zQo0o3OB0JCzJWZhyntIfBPa7k7idplvRKpdqi2+xkSuAWzO4tMqSJIxQJK0uK0DSY2086ISFKbnrsaaSiOfBlKol9syQqNFCfQ000yzhPcDWau26wZaWPA0kc1ZDfQlzuVAs2lC6XRnDKUNCcy7vC6hCuI22WwiYo01mHobjgUvpkwk60PhilWc4G5IhpnNHsOE1a1JMoSm2e7GSRCWggkOC3Q1k6dSbZLuMaHt8CcqgYRfLhrhEJQvoYmtzb69EibzyaKFtqXyylCsYEEymm++RIUFP5ky01PKfK0Nv3/AJM20cb4GeTihpuRJXBIzoyZklM69ieYU2Gl7ExY2/UuxrJ0B6at8p6ISuJRF/0Q48ttCSSc/mEZQW52DRO48wzA4EyEU9jKJItNDtcOC3PI5ilXKWPkSbltTKbHOCIw0TEL9IiRuTOokWs8rsaaYlOzfIopNS+3JCVM0qJixWNU9Fpq+4JJtLHkNE4shsWZ0PCFRtKlRoeU0mlCGzsmDwlsTnetthDRWStrgcMxLpt++CWk2cD4ZhRMthuSFKTc/kDp506Q2T3kS5hSS2J2TSWoGraTC7G3mL7gTlNpUVqSlyBoovWhpnNtPCEzid50zAoky3yQUJpbbEpWnbmSesTDY1PMraL1ky38idm6axvgi5lQuUtkKUSXK5FmwZ0Fk0/AFGxtun9kEpJPK6HbJm0QSbVqvoq5Q4CVKHWJhQ5WFL3cab0NbjLfbEyGc+tidMIXjYkyUcWxrAsnabJtKloJNby2eIG+U6eEJWz8AgpeW/kUq2i2+RKyyPL56HJbPD4GS1h38Fp8keClmB7KOBG7SrLox25VJoKYjlHCdEtpOIfwClLInhpCTgjlaaXoajKixL+iDp3uDlNJJEJiXYsNsyUFgwlIvXUduEZY7WhI4TkafkaW3UjK2obRDY4abS6ehDeE/BsShQS2BSW0w9BMkaP+iFFZ4fYmVNXqXImlYBWzH3igiGBJOEyTjv2JJSlhQXtJGhEzTVNEjqtUxMqLs0N2UBK2xLY6Qt5kUNPQrxqkCIIGpNkTpJrlSUQ8CnJRKhr32OsfDI59OIHspdI+QFNjUTbStdE0mlvK4Rj9hPCXQkTi5S30SSbkLbfJWnlGXyLRJrcU24korgRBCh2MrEKkmYZ6bxHY7BC5frDRYYS24bc58pDwm6Z2EiN8w3yLKXsDKSNNYZLSbIVGxexok3S9KBFlllH4JEkNO7LDExqbyo2xxZcqEGOeguIJWNQUNdIyhOxKZULKsubjqWciIKpW7Ms5TOfYnLKXro9iaVVE7gTSVyfAMke1TIVUO0dtjbxw05ZNI4Ijk9XoQ/rJtwI5NjISmuElB8iTXsC3IqeQiVEuCao7ZCKSnBxmBNmiXZY/yJFoWoG2LGUNmbKGs1yNFpJr4E7lUMPY1ytrQzhatiE51q/wQNIml95YMtT5Ec1t8Pn4GqphEBwTaOTpEJKi3ggalJpwcNiSktyr66GsJmV3YtXUEqdxdfIllgUzrYrBNu2XZotHyIomlvBjpW7tTb5ZCW0ZIJB2V7QNB8KjImkps9P+yVE0LKKaUifwyxpQZDaVG2NtrcINtpudEdEpZIvwhOS7UMg0faPZlce2CaJJc/mWOENcC9iciOWoTE0O4ncCazNPhP7FL0prgUEqso8lqfUQ1tCYInd1DjVWoe4KsJSlkNOyWkpTJago3e0iac1KYuBRjaojh7Kx4KykJRLq/tRg7GuRNNSVpHOpL4S01shs6tK2UNNalwZcFCKEhS5ROCG25SmkmyErW5yjyNy0lL9hNz0rfPY1pbb7FZw64T/ZhSc4n0iUlNPNHRhdGVBMq6VfAW8pyjsy4mNXs4b4IHxC7dbKwRbTGrdiW5MJo5nbkpW5tPL7ItLkGrJOyoyhSk+GRlChJyltolNSJTaE6TU7N7GoJ6bSo54HLKXJUEp3NK6glu5TaV+kWjKraZBNLjRjcm2atP8Ao0LV+5GTzM0L2yUpUy9exJSqPvcEJbOG/wCDFcvk6HCu1t7De1AwhtpMDU7o/wAEp1rq8VwQnbDWhck0kkezJraBStJ4DPZB+8jVMsXHAz8A0JW7/oFGdqLQJR42DhyKPuFHE8CnAklJKVQihYSbnB5oSKPCZGH8pv4EpSpoRK22Cka60zMdAUhIaeGOCVWKZQ3dsQVMhrJYZkm4eA2b5SktMlcvoWoRBuFpbTxAx0cwFincu1wMYi4bEkabTkEl1wEEiJycCFlwiJ6I0am0VP3suR6SQ05QrZByTr6+BbpGS1GhJtlyEii8Z9IaUq47GwWtyJLjY5BM4rkhNYpYUOSqFqpLASwntc+yySt5BMRpSgbCN3U3j5MlZb9EJuVrIiE8znXlIhDjlbT/AKEaUJHyRBqcp20xUMHhzkpiwPkwxvnghO0TilMwQja7FIqIwhSSURQSWc4OArq1p9bEkw5LXoTOJuYo/wChU1LWLHbNKfYLCWr01ItZZ5L2RYbbxc/JKJNUQKKw4MNSmmLT9CRZ4enyJHKyRQyWktMY3LppIWm1l6tQWxadiJTkdoezSSVsErDbJcqyhSWPIglTUNnQsh0TK/BBpPrLLklhHldk6hg8ogs1TcM3ageQUmNyMnRELLka2llqUmsqHSK1qn9kkjOm5jSXYsimmltIk7TcL9gjdu+aevk5MIhRoikTS2HA0nHWSCWuoMztDgLGbclbxk1yKlSduzGqSlpV/YwrFoaZhCTA5Z4WiMMWa4Juc2ehng5Wy0KIqDVewsQrShNi+BQyiaPn0SvkW3sluLCdt79EsFMmGWiUN72+BPJvQbPoS4z8kpehKE4E4FtU6QQIsIgWXM5BiDJrDlPI14Qb8kC5WExP/hLUVCEhO1X0QdCXL6PkJ2FJaUZtLItUqrPYlhcuj6GC1LXBYKYQcw4B003mxodCmrN/Q5JlKXKxY24uWrIy9akk10o5IJ81iUNpXfIUxMQrsaRkjG5FRV2CUtKcUmllQKFtGqCQjum6SJpWnKU+CTJaSyTuy8O0p+yDNnFC0JE2jLkSvRKZGzZQZb4HJSU8wx0wqiJ5SMl0WWz9DRUSoj52O4Lo4aZgsiuWcUSgVs1wSZuU5foT5cBr2MxilRT9kVJxDaE0maVguGJG2T9luJt5+BtkaYGWwbLI4VJTohiGlEK4z8jzKlKE4/saTW08dBtNXDIhXM5ehQDJNmNNwS0bG2UVpIyqxUSIlNturJTcIpv0PJOVbXI0q04zcZHATGWw0ouWkuo5S5WI4G7LlN4WoGiaHkjQpJaa5dexNwpFCU/6HbScmqaxZc6xksWM7dw8LgTaY/8ATgkSljZLSmW2cmJ4j7DkkjUJS2OHCqF8hlyVOJScZHoy7YeL/sORKZSnpDlmm6+AWQtqmKE3OGVQItP6NHBnRkg4bwh7caE21UtrG5GJBtKonjfwNplKEQ4/sY2lqFCaXAzbU5ZxXQ0S1S0LQnY0NrrRRtzK2RKkymbT1ZkVqzxY2k7IWQSTaaTGz408sQnBHMbGg62vYbojtPGxzctQ8kPLS3Chf+jeO1YmoHGA5QrKaa/EUtImn+wmmmuzTFCIZK7f+DCN4hC0zfyJEabbLnoinkW1hGbjI6r5NmQcFwiOBxV3RED5McJOyBJclCVSotP9Fm1K5XZJPDDEpl64ehllJ6ehM1dh5Zeil/YcBJXYhNtOUyyySLgqWxu7LSGhA5ZmmlqDCu5TdQQoCU3Nag3WWjQiZInBaWKthsYJKbl1dKeh2ibYFqcmG+jahp+A5jIdoeZFaodWJ5FwpttUMQlhoi2W9CJq6NFf2NJkrJoaMadiHPKuuMjFDlv4Cozpl/0TpULL2JKRiNMtpg5y8llJubOcjsU1w5JSl6Dm06weVlZL0NLINtCkv9BEvNppkWx5O/uIZsr1pYlTjNJ8le1imzU1cvoghlrQKISjJyG07fESKqdtiCcG4fYPVhNw09diglBqIQ2opltaihKUO09oyrPIayVus8SLgtLBBmZ2pOoV8DXIiHl/0LiLG+RrBRpNiZm4em2Z08C2OZjUof8AsNTkmajgUgZpuKEqmSmimBSk3KevZEG7UuEZ9L+EWmhpdLj4JJDTxJKM4eJ9E1LyFYoNq7ICwaVrYjaMP4+RtpojLoMi2pfkxPE9TTkQ6MO0zIlCNkjKT7ElNDQVJPifkKQW0lPl8DUkqiEuByguEl0SQp4W+EitLbv7BRVtra7FqNjFjCSviezFUqHHP/hJt4dwxwU08NNbHU0zfnArbWxfIYYCUpbkuU0pT9iVTq03kU6cJcF2BBSiVpzh8whpykdvLgTyzTy+OyiYqhGTYbLTmSSVVbM/kQfCL7CVtln7C9qhdMlgJwlI2JawdqcMUzLXCfI3hVFNcDyhaDklaMhihsy5bXIydmSUkcR/kIn6qfsg24qFaTyqOiIgk/P4EZKJQ5l+BuSrTAlIpRUJETptNVc+iEpwwIxcCJWxTnIstCwW5mwrhRM2RJOlC/JkVSohtc7GUDq2Ta3QhiZnLSbYh2lMy+R2ZtpQpkmz/Qk+bRQlwO+AojoeIp59FSdM/sGadN8NDo3O/saHVvwhk6hIhv8AaE0Z5FDJVIe0W0smvKWB7xVNcjNoUrsNmqLSY4kaEVthZLPODcDZpZah4V1h5gcIVy8nBJJAbLjsaHJS/IOilNlMyShPY/slXavhUZNnTdFsRLoXEE6xOFKcMg3VndFyJynDbRY1I2hilPoatGnLIkaktN2lq9jxb/42NA/NstjcNNYdN9jSHJTEDXepJLxNEdDJO7gkTKah1JBQacmkbFJDbjRwZBy6Q+xRVysSQUoF3YnMJZLfA3EVnloTqSVS5HW1w/hJH5Q1zsUmwklOJKQatgbhmhQgpk2FoUOW4mCW5N2lK/0O9aqkOWuBRHQ3Z/UZWP0kOCMffA1Rg10ODnTfsbO3MIhkdgpjg0SGiXImaJP4Fq12ktiSGylaLkc4OZSnuxcjbcnJMrglQUtZXBGFLt6RgHOzehwabCm3wIaU8f8AGSk1T5cyJtPDSVZDWSxL0IuRxpclx3T0XU0wPZdk4YlnLVUmJt0wp9DaaUUjwlG5uMjdPmY002LdtyYRpU8iEl2ZCJPhxJp5aEuSFTZFsiNqGotTYmgLgyySDbpSGNlpvUYr6l0Q2m8okHaQHMJMPxHGCf6BLSxmG5Mm25PYlEVlcnKEUZcnHwM4TbZRC1WHIWBmHQaWJVepk1NstSHhKwwTaVn4CkQwd8EKnDbVsI6byBUtpf2A9KlQpJFMj2h2SKbpclzHMz0NmGtJehkMpHSZJGqYF2KFS5A1axdESmw56IcIS+TA5e3sQxbii4NQ5ciMahlTIHVqX3CkaND9D0JppTHMNh3mV5FNsuhNzJoNGBlrWBS0cohDJbLsaQjOxRJM5YhWpbFglWT18jIIUGXyYAsVKLIGiWULgDtLoQkhJlCkauUlUtA3oGFwS2zTmCix7DT14G6RdcxwLWSdn8CZJWWA3caQyC9jQiQ7qkannZ645JGGntkmUtG2g6Ss5oytK0oQLkl0hUDqXSZaFLNp29wNZJWJxGlbhBSNSyWuB45zYuiUiybniSW3KvJOLtWtkJfAdNonRPH6DnNAlNuEb5ZobGjWRDl9jhCOIUe72OhLWnykcwp/8kiJ0UNNeYhlpjqhp0Da0tIalajtnz0JGcZbw3yRKw19glFU6AjWAv0BoU012uaJbRISa5GqUPRl+yFF6OpGyEyaULFjbAiYaQqWc0SwJJCLlQjQExGCSsDtPj4HJvDt8SJvPRy5eWvUunY/QhpwuZtkNU1WRrY0st1OZKOpQyn7Fa0JtuvkmQVUeqEaKC8cPkmQ3M4aQ25l2pcMU4cwqdSKe7fd6kzG1gWJ3SRrvSY3oaau7WfQcJNP8hoODdO0tklEkmvmykXN/ezV8pYCabpLZwJROVjQnNdwg2QtMbLXTyIZ7LDZXwWcR02MqcR+hDbbhylsQU+Tb5ghZkrcbG2DVPkxqhcYfInoyj/0NYE4NZgopMSSSE0pcFWZ2tmKkrkSm8SKTsRXQpkujBnN0WQ6GyU5Wa9DXJOERAmIhayyEJOJhkakRxLiFyPHA8omqlVQ0ZaWSIqTljgUzRxdt2+hOm+VvU8CROmcG0Jpeo+iyf3IoTKMcvkbIdlm1sm17q2kVhaT2n7HACbbVey3jTghkGytegqkzk1pehipN2w9DR05lSo1JC02dS8L0bl9epKa020TtGTpqltQoHcNBQW/ZJk9Dtcj3Uo0KQjyJwfVGU6b1EOgaoNSmmBopTaNp802n7G3Y4cikY7WGyiZtQkPJLdu+nATi3MNp+A/bNuRtNMC32SotYrmxySS9PRjbRmo/wCxpFJ1kGqigSQmlO10ODc7WmxKblOU+xSSmuhLDDTgJ1dCYElcOVnvQ3aNoa52NGk1SXGx0U5aKkhJXb0jSKE7HRLTHA5gwbMmRujJQtP2NNDhhsbDk4WG0I7HawxDS7PQTSOMHnmCTvDtPInLvTVskoFa0tjZJITbYl5KeVolonsxpElJucn16GPDc2qTIuYT9xE2Wk6RbdrTovJs5e3A0Gm4axtQiHDwsic7CY5FI1l07XI23C4ekfAYZXEYaMeVDXA5RNOVToQZUnrEEE5Uaxon/QKLm5X7Ck2rlK6CZDmjmJ7EN8+iatuRY6IbOdbvYmSuDQuErh5e5AtDpr/Yhkw1TgJI21joZsjVXS4Fo4XD4I1bniS9R06fE8DTSa5dA7UOnMDEfy5gSbHhpl7Qk5XlZFaMgkOBNKGsSQi7g1yQni5VG4k1NOf6hKclVzEjOUrpaMimMdSJZm19gjcr6RwOW1YJSmfS90NRxJp76FijkMTMzR/yRQRlDwktksFGE1yWVThDY0dJL+0OVISLjgrOspv+jKUzHEk1K4aHd4tpXAc98uJZQSbMcEOQqJoa11kCk8YOdiQQiIlDcIqFhoxZKowtOVQKI66HosPRrAmbSuPYxNyQw2SN5NUuJeHJWoVG0zzAmY7Gr0EM3u5kU2Vw4+QhKErBpFK0f7jiLbVGIZHdI1CGQ1VSGhkaXMq2xZh3LsjUtNjJHYqWPCdCS8aH2Orh/cUTawhStYFk16dQS9xJQzFcCFIqt/oOqVsQ0ltU54Et09ieeRCalWQVunUTocI1Q26Y4s1MXG1MNki4cD5E9JH3RZAqTIgC4+BEwiWoKaMuJlhCVSisrn+hXaF/7MspoTMp1vDQkhYmBTPMtPk0FLYdMoJciKG94WxZhKl/cRQcK1/sQ3UKeS9GTRRlpglJbzhaY4EqTWTDxMpVEdjgtarzIpG9uqSBBe2eRqTZylp/ZLqwNaRChdqa3wMaZ6XexTahUWWxrIe/T5G6jDUEpmqItp4+CGpTTuQklhKi57L7UC32XU+BtiiTcWxEEWTCfZSKbltlobZyk/sV+uotwJk41EbYsCUCOJEknUzwbEjTqCdp1etcCVKtWYii5lYklLLH6IXTwLbIJpmow57HRhIJUlTbobbVYfPohJ4UpTQ2bdJJUhTIcLXp2Rqqp8E5OPfwQe1pegnpLO0eERSaKWVz/RGPulLdTHAmfkIblJ0y5iKncluRJcELGwolIlu3OORI4VEGrp0afQbsmxDtehTeCnKcCsS8oIpGHOWG43MuE+RRSlXq9NjVXN1J7FSylsmR7GumQdkYHwux1JtseS7NSaXY5Um4LSN+BhspxMnArEcmtCZThyolVbhc9imc/wBki+9XdlVK0VshQhrlUyjtW2ZNG5SyHkTVEM4aK9jjhUjmJGtqmeB6EP7BvhxnSEY/eQdSpVaJwba2imZwL5EtEprZkrOsxFqaht0xucnD/IkU8kstmU1CVQmHCTo/sm8IVDJScKpx0NmxpS9CPby5wvQ1SzJ5TFkfRv2MCnUmJI6XPwOytNgyc2zxJLfsExmrLOUKxJNCDdOhIlIogqbVOxMmr7FChKdiEiSQoyQ3KZlPCf8ARBJJq2WSiTNGBoRKWWz4n3Ck2yig99SVJOs4bZLcKJx2J2kvQNpRakEIvR47LKOMloTaUFZFFuBGxPBKtEtT6JJXZCT2O6tKpio2lXOwVlY2xi029kg5dGGuxPMF2afsVxwA2i6G9olaiKa9FpuatHiBCUcPb+iA0UqMv6GkElll9kRQtSfsUmHOBjQmWtMk0ZuH9/gVvsSyJTjGZaE4K6gd3FUJNiTWYihpgfoez2k8/BhJXKeWwyUWFp6IRyZbEqTbYE2zlSyhiEydLgVJnoJqEqEtPkSRFQ0I2lKhWVv2J11eXAqxRQvglpXBYM6KfwgSs0raWBNZ5SYmEJSpyQqHlk5EtEWqbyiBwEkvsaRDQNWpprTv5GzpwB2hsX9jklKIofvZa1RI6ZwehzcEJhilIeUv6IbDJaJT2K+hsmnOmEh2SVNCTKYyzR7DKfJTaZRo/wDZJ00oYaLUlDsr+xOzlYEIhMNNsCZmxLSehI23S8o3UCVKLUsp0RWzbK5FOoSkHWs4PyIo2zSmRsJd8T2NttJtXAanCFE9dE2pa4/CFkorjT2Mk6H8hCZRKd7CHFeLGUkTdUPQ4WG5y82SugUZXspm7stEBOVeAhNSCcr+wgzjTaU4kYJuZNySVNLWoJM2qzTwhuN0SlpkI4Ybm5Ds3IScES1wyvZJoYSyShHWiykQm6VhLIuTWiRdQMHME4YJ0d0muJ7K6dunpmNtRi4JaNo53AxWWU+BjHBP9BRwbiqc4uc/ArGoK1oYT0YyQiY7pyspLkapJ1JfskEyopRuSnauSU2R56bGTyeN/wCxcJhshPTS5JaHBt9ERq7TmXRIxPbbgcnTqG22xClzpeSEjSvuvJCRNN8SyI0WYVss706lQQ0TRSUGAs1aMWYSXPU5JN21LgWSkqJZeGl1fCJSams22J5JbDgsdyeDyyHFyTyJZonOr0czT+6RSSScUZRG5a1BBoWgImAhzXLkuPSZRhjVpOihuRWrWIhDmnFznoTs4DWU+iC0t3MUTlYLkE2EkjxmG/YZSyimcsQkJsvaQUZTisEwSai3gSclKssT2YE6ZWhNVxcm8MSvQc7gTEJd5Q1gTPIlSRtKpF+MbLW7R87h5HE940soaI2dFw7hCWHNtsRrsU0TdU0binJuxs7eC5aItDeEL3yQRbRxwjssNOFqXuOCKQdLc9Fro5bexS/2RsbJW2weZIpKktN9iilNtTpZGIXApZRFw+yqCiTEkgaipp09M3Ijh6YplL0LgnMmo1fHRJw3j+kTU2LGnv0UNW0CrzThzI05rDZFITghkCG8HsapQ5njn5HzDcoTC5WUFqai1wORvhp/MLbSaiE+SaynGLjI2aSLrJzkFcuhXUt3MWwyfITWk1tISu3aSMxPLBlIgzk6qBE3WtJohl8DRFa8EWg6piMfIpwmuASFNYBSuYOdiZIpNWSYsaCUmUbbFPDlrZfKl4VmGOKlr0ZIJDz4/sSTvLEa7JHE2oyQiGlpoUk0JYNjTOIZ/sSwW6p1AldtOKE3uBNqVHLXQU6uG8mxFmOdmxqlaX3SJolNNPKi7yJ5S9yRHSdqohrG18MpCGyCHEb2msIcUyaSYYl4IpqULkzhUL0Ls6Jf9DzEIrRGDrSU5NKywZDJW0NWTFDcG6WQ1tiKqwxn5MCZIW9iCaW/+xJLYWy7GPKf2DRS6UnosWVCY3LiUDs2qIWiyKhWtl1gnTk2FMNzJdD27KS32jPyJNntWsv2Vc8GMjTTcA1NGYVLECu2saEnAo05CnKJqZDM3rOCJTTg7WqJlp4TVtehIQ9syzByXtIrbGmp/QiZM2Y4FLCU6xChEajAaGmuOBCWZZREkcxOrFNywx+Ap4JOqbx8DiqOS46GSo5uOhRPFMpjR6Gsji0ZS9jIiaWRyshOEu95ROhOpoaoUHsQ4pPviBLhcpWowNSpjKNMeQocdhu2ApcCSq5HoaNtVCq0NulNNKg27fMZNiSSp2W2NwilDcMmMnQxyM4VH9iukQuCBLL2xI29pf8AomcZ1jgbNDdMPQgdQrNPL9DSiUlvdjctahJjqRT+7JhVxdQ6FSt2QsL2WY5LfQ7ZnTbT18jpmmwNEjUkrZemJpPi3tj4JbZ7cvaQ4YlaUxBmZHPA25kosa5ESPBhsETVX73+BLJahO+VAkR1eZ44HWkPVwJm1RK4IlN1liOxk5VZfJFnSxOpZKzIwTYXotSSfE9EWsSvsRCuGffog8JMuRFWSrPkJIYFR6GKYaTULaMGJsLoR2jHwE2qGC1PZ3CwfEjpk3CGqkuLVIXHtDE7Mzl8NDXd16BitkmVpiNYWtPYmEsJlPYhSOGltkY74ISYKYST9BM3qYhf2O5vp5caIl5iVoRhuNnRG6G3sUEgpxa+5ErCaF+wSl5wtroKnDS6LIkkmnR8GFQk7tcyJ0Sk3sxThUJOHuITG00f2MkjaYhagUFS2c1oW3c2t8Eg2TWDXZLR5pWkisRxy0xUY4b+BNs1uXwiKeaWY0mZY254IrQk80tolKWqYQ1TCm5IwplImudn1wNEspbDhCsGkeHwTm3S0MkK1tqxiycOdSxTyDpafBYVpuG9+jAPLfRFrFZO30IdPDS1yJVP28h0YaBykcpRAcFzTYXRSej0tCYc8BLXogyo0zxIp0uWkLjIncZJw4ybnbtClglUvQvPCasIQUVzX+hqiYW3sxoFblU+RI/9wKaqk16IzFynguuRvOg0uNexLonlKEw2yT+4q5qmdIgQE0poSG3gmEqauOQTQWk0JIklLZcFU6hJRIWL3ZeHUKjLIOKBxWUIw0VVcaLHyIlYX9E1tCPHyVkyom8WVTonZg5Q23scmdJf8QJTPKU3sikdtvgboTJaW5Jm6cHtYyGignawJjdaWxxVybZXCGMaDDhIp8Ghop3cqn7GiZwop6vkaLY5ahPXwNMjjsJGo7TEjU0M+/Q0ZOIaWEInjYYFpKofQ5VNRKhEC5YFwKxo+NCV8ieI0yybg9+yYvKhcZEzmTow1hTyDHyYT9CjnTWRFEC1oaolEJcckEI8L5FmQDGKpSSUcC2amH6GRuLVodVPKv7FMzhNtCVk5njBGpOcMamRxQz8iJOvTEXA8g5mazb2PTNC2+eh7kWNGQlD02xqRtuj5exsBqKTTNcjJI4bBEKXE/YKZuZ5DXafAfbEgrcHXyJUltquPggZoTahCM8MvcDyElcC+QrYxpQ+gipKZ7CRFtaOexbaNKJSGQzER6JfyVDUnLmysfIxc4tPsWTUb1HZC5hE8DWVWnT5EpFp/wBBm1SHZkpEqZXwTgX/AHDOGULSyJpkmCxZbxRLiBQ6rnhagkonImOC+7erhCSNpNWh6kWaZKHKbIygOjIijinTCzJpzT5EiJJF+hBChJbQoiiVoExcILHJZp3ohi39h9QNbpIJUmmqCTtEp74E+48eB1e12W2xMI25k8N9CskGvwItNGVsOUtFtvZDpJpq2MaSbksrkkSROfkGxldHyHPBRJpZRYT2SJGKcNaFK5vkSZpxBK7MSSMfDqRKMqcqLwM0zVXyGXhCXPI3aKZq/Y3AlSZY2aV3oIigiHbEIcHglAIIpJoNXlpzpjpsIoREzbS1/sdJVcJ4aHdC09x9GMgTTxKWTNqalGX6E3cRWC1o5Rw/SGyNyv7Ho9qWI223IyV/Y5xI2aZTAqbQ1LTbXAhO0l8JdCAWH/8AUuc2bCd0QddD3K2qOxBQdUsjw7JXwKatUu+h7Rp2nMrQnaWpkM7eGAghadBKmiigakL/AGDSYmPSjVoiFJxORKbquz+hxTWcXyJ0n/WHMnoQQ2V6+2ywkl53AoYLo0ux4QhtfbGlp/2iKBYXyZGDhqhyxCn6nz0Nkif2D8kEraT+EEbc5kpMhakt7aGRSF7Co0k0quhXTjjmiy/e+iUXZUaSItEm8dEjg8PYbppFB5X9jRpac8jqniha7EqIZSehK9A6gcmcjCk1CTaYSuB5IJFk2iz54KZiVcDdb7C6IC9RtDeQdW6GS30v7G0GlG/IcFaqh8EhTbC4Tsg6dAJmaqnhuB6bVTv9BI5JNRJtWaY/Q0lOjkTLVFQtIvjV5Widk5llDWlXD9BOnwxdjgqPmQkS2jjochp2+HwNVBzccirIRSl9TYKjU2i/wMcHX6LSvUkNWJcvR7EsipeehiXKLtdIcSnR28DXLsrLnQ3gLCW+yDXFEOyuV8PnomoN6XIkXtSL0pTETsN4PQ8kaWHJNiSaaDl3KY5oUkaeWdwOJMso0hTSUvHUOLfrDDU0qjJAlpaD7HZTh6WnYoTIqEF8wpyMVymFRiYtf6CibDi+QTzpaLPngapLiUEi0EV0kQly5aENYDQuYhK3XIwjStl6EJGmkyw2OGVr3ySyngFtRTx0GjtTUiT2mp+BWOmiBANTjyE7NrUdEMLUeiTgho7TRMkmn9kY2m42RRGqArqp1EaGjGrwa1kaKLNvwZR4S+OxMtsJ4P8AoTQ2idXySSV64FKE1whOanyCVq1avPQ3S8LtOBIqDaz1GyoFGwplLC32NGlM6YgpJ3/PQnVnpcydo2MQSnh0YpNp9BUZktRocTymnoS8SpuRzYtfwMalJChur4CQWLR/Y7OoSX+oqM4TLXI3U1LKjUcahqZNFVCIHJSzpdcijnhtw5Gpls/6DHyF2Ncm4oXKG9qyPsMaQtiOhrRq3cyUdqVEPsG5GyivI+ZG2pKZ04GTcwUxiSktCtMxN5aE0uNpWgvJPC2TcrcUtoTNPAfYae4vA02klZGNSk0h7IW2e89kPBbdpsRKw2DJqTbcDqVOEfEDNCDd7kMmdR4QhuCW8Drdej5GlKSi9kxzJRfYynlUMoNJSpFKV0tlDU8uxp1TGCxNJNCVNJzUWIMyNElFkNDIlSFliOkxUaW1uN2hqUVeyoahUuGKTCl19DGkiplilCpfwCNpWxchJLYoirngYhxOAjEqKoHEpqomm2TtSf7HNpn2GaWpf3mYvEiGo8FvI041aonY28DRTaKDw5jxBzf+4aSto0NmRSy+IcFheFcDSWNbZiRkzedh5l8Embwqk3wxGWoWyjgcj0FyKBKtMBs4KHgNUzkhMsluGN1BTmGtFB0YsOIRJHBClWJ4aWoMEpLvQk5+AeiDmhXJFtDtCYkzeCbQnGvJmhzo5G1FyCWTa2J2qpp5cDIo4io/sTJMeuRxkka1wRQU08JXJhq0SEdKspLRSlvJTyxuHZXLJWAipnolsnEZDdm6bfgKUmENp8wPOkIzKp/Ima1b7YpLm2mxEKvnkQJLzTCE1Dg3ThCanIWSISnaXA1D0bXiSjO+UsYl8K4BmRyHn4KW0p25UTxTvzhFEy22xs3SyUtMsgRjXCbfY1MpSUX9jKlYmoHmyUsudQPU6dBstXwRomRyS3yEjN3DZ8sUyrJvgSo91RtobEy4AqBxsYbFFwjrsaTSy037JkzzCIkoZmYaRwxV6CaISb4CXRae0OgQG3OiabduxL16IXQLE67M0sPCfsUssxSbQnRLj8QR3CvJOhDTawtsdBONDeCNssf7HGktNLfsg4HOIjID0PUdmm16DRTU1WiaM+3Y7NpLhilLhTPQ0DrIK+72jggNNVfFDZ3AaTqaW5bPXjKQiDI55FCXVGUiiHMu10NWUOfhCVmZL2KDtyJuRNMdwzPbHkW1XCMyDDb4GKjbT/ASSe/nCImB4NZYmeQStrY0SrhrCW32JCzSbBGopta6Es0TyaJ6Lo0Kdiw6FqS0tTwLJry+STTyqszPikjkabpwgUDTtsGpBRZATPBrPLHEyTDG69kD2TKrxEXUmjoM0rp5ENka4H2k9ngkUTNibZpm5QmSUZipaE2rXECmRYZKVp8FLfI2SSxmCUFbZZW/kkknwhhj3EehYZocaHEZYNpQ7qKGazHsyatsSORzFM9DhriATWedt0JVvXTfQnMlklPkg4EIn22VWMtEIhf9wUUpQmoaiSEZO09LohAZszIpdlriRMmbkl4noa24cvljnLOWq4SExLwf+iA02nIJl23lwicloPkbUdiZG6ejlNiIo6ZDUrqNkS0vG9RrFcrPSOirSSixeybyalbQmSrbXD5ZBrSWEObbusHwQWqyfAsRbFkC3TsmOKD5nJkqyUvscVR3wuxoiqweo4O0J0EpYNH6huiKMP8ARFQlq0DiShpw2Jl/6QVM0m1S4CVksqkNRpyuXPQmRt0wUBppfYk26KWUDTSK4l4QlKlLhrseVIWS0NSZON9DColl6MbLHzLglZe02bslRSO5cTuEIzsadmkrI7qHRclI4XD+SiUayM8immtNLCElB1iUEaM00hMzJNULgTSbJpqkagsSiUyIBOmKf9Ew2zrSZEnBv8DEsqpSfTQpS1o46kFk4yJkYjSUrvLRNGRKWWW/Y5RKGlRPImlfDYhI4jh7F4cKYS8DjPSBUpchdMdrGRxgcXWW/b4FKaeB0trSxshSIR8iB7x2+iGyNxaTJNBTyfPstulBT7EKL7IXuUejGyhHCxoRJROtdDpQocskpUm/FWSdOs5ZZfogpJr/ANg1Ko2vYUPSVENlLShmMigTrEnGxTWqHYFcyotholiRKvC9CdSqWzuxMksqGZIlbUz0YHCaQTUkN08jSUWPeZnolKpi2XPZEyqJ054sUxKtS22VSjQmBq5pahVgnbyaaIkKeYaSESUo+0ra42mxVomr2ZImJaXTEk6TluoQ8FqG2kSlmrLcEWyJy63whojYKx0MYne+xs+CNIc7h9mNkjAeFCGsn9AmCwfMQON5tcyNEItTnkcF8abzI8Mm9NsciXVHeYIUpcT84HkDyNk0sZKBLFaTEdieBQ6PkVsacG42dzQmU12NfEU4FBHE2y9L0NJkibjRr9DkuX7itkmpfb5YreipLbE9IpZ8R2IQ6Jcwz8DNOEmthmElwy2SFSSipZKSJFvTKk6YOBpZTo9BY0dRa0vQ0SdiiZYFATLK7JJtmMcBtSVLIDpLYiyrTcsNFTy07J6EzaybLKY81Rr5Ezpv1csUsKFKYXyXm7VVUJ2228JqilNzg8CW5OF/0JlQbTdjRy7XcknxZHJMhW2ZDg0uhCVWOJpjadrmWW+jAdn+hOzT/uYugOBstLHqCf8A8AIPbOk00h3S+w4UTo5T7EqpOjnJFOKU3yJVhrR7ExLKnMVt7vmPYoTyE7TSQl0IYnKXAkPacTr5Fwyqc9l0vapOkXqmFONQKedMqf6EGUjjLXA2SU7feSSaWX2+Skqb/cXSgmz4JJYZtxumoTbDLWo4YngOEULtlMKchwOJOicURtdMNQTuhFodYJUTLC9DgStkaEnqciMXL7EPw+IGGnNJ3PRBCeXchiMrw1r2TlFHZciih1gS5FjabHBmtCJradcKJyrOUyBZwP8AolGDaStJehpiceSMSctsEk0nawWxQeyafQm5c0hTRUx/QnZpLX7CwKVxBOaX7IYkVCfYE6K+4aIl9BZKuFyJUTSipzyL0VS+RKlJekxMxGqFKoXrkYsrISknaoFIVNENiUnQr2JIrS2OhspT0Gz3wpxKCORw1V6+Bxt7J4FBylOnORvNzhtLRVLfYYjaeAgzrhtwWStNo0LJ7S5HUhtbX/Y4l8BEJNPjGidOh6Cy9MpkkqX/AOQlhKpyR/0RsYXOSUk27Yl+3HorEAllRfYCwsNKtpGyoyRYuQT9jZvnS5EpITjxgk9K54GpKysehYGobds0Q0mTa0XsEWapLTLIyqB0L1JyNTareXBKV3PtgWCuxDNseR2TKUpOP7JE5Rl4+RQzlz6JbWMm3j4PXLPUDZJbYUlN6NyIQu633wSk3wIe0Kkzh1kQmSNcMinuaYZFFyqTst8IVtu3mSmLEiJUHCjkXFLvS+RpOXSYloxtx0TcGe3BAoh4f6OnaY3RvZRL7G6S86TY4KhtlsS0G7Dmdzds0OM2NXJPZNrciAqGYRJNZx0NckoeQbJq5QyGhNbNiIqkyr0JnNNDgSly3yiUqcT6JXGtsZJvcLZCB0OEmxI6lw+k+Bncnem+huVBRnPZLhJks5N8DbUPac88sUiMLDW22YRulpzuRKmkuQuEJpIcyUuEaM6pOhIb9LyEmHhL0yKXFp6vgdEknoLTWJv/AEJSzcbHItuKjkujkBXMShNKdyRJTVFmSBb4G12JUt9SKon7kCyPdi5+SIQS+GqsRJY4xpL7IWVPwkjUrnMDIVWFcIyCFwuhLbk0mVsibgTbCI2feFQdDVkHK5wv9o4WspnaOyVh0taQ6uFupbhaklwldajkluLoyWE+SE9r+hiUXQa/BO4VUtoTPnAngTzUZjuuhNLe1mrEqXUvbZFNowhdjilUmUPKOyKhlanH5G82ib4LgXJlwDs05IQjpZLE+ymThNEyIoJvkaZiykyhNptNxdN9DJponllkdEtprJbGahpOeaeTM0qYa3L4GkVzAEIJabW0iYTmdHSLJXGoYnX4MStRRL0SS3u2MT0N4cFw+SVY4bdik3LWy8kp8LHPAqGmrFFoprsTo2jxVc9EtJSnA2JNhqgUdGU+kKlpa0VZmxHIkSniMPUsllJufhJGbHNuJG2yilhXCGzzhMLoaNvdQnz0ZUMJ1n/aOiuhcuxNM2zU952KF/DaDo0EUTgeaWkJolrTWJGzjR8ZJnd6A7R/yIcvJFbPaE7uITnApG+M1ibdJkr2JGbum7ciROGtN3wNxg1aeuxQhk7QJpN8CMwQg06oKTpmpPgS03sWJG6TOmjIokek3JCKbkZEibTdpl6SGqJFGUjFTyslyNqoc8k8lzLW+TGxK1FBJrlLhCZ3M66RaSt1gzKahsnrTINJkvbXwMtn7EdpaTITMy1sfIomkZp4E7DFsmE7jr5E2lKNwqb+CGkpTgbFlN4ueBksP6Au17ocRmbELZKS4cOaMqefhG24Q2JyOXGlQo4HkwkQuujM4PDTyJw5ob34HSuUYQrakyxQzsae9icQ1lPeIElStgT0LDXLX/2JRTGuJ0SrRfCRNOyW9BC4nDX4G5zTKe0JneFtmKWaF3JpntkIJpe7clHgUQu74IpUxhCOXloSm202VLgNULfDIw4x2msmZ/sOVO2k9JFiSFrkIJCpdsEkulW/6NyrJuhqZKRDM01TNkpvS18w0UJS1Z+CQmn5ghREt/uJ9yYjQnC2FNCoizfCdEpULapcBIyVSttSOVmFIhK+MVksnXpGoHT6E6aanlOyacMz94WIiaT9iLYPBcCkwv8AhsSG8sEVHAa9mA0cty0QH8L7HMs+zwNIP2MIaI5cJgJKAshseDobltDZ2yW2+BJ6H7yTOamGclxxsakTbjMEShpwpr2Ig+l6Fg6trRPRdBLZakkNkuGiEm4rSEramsVoJYYtnk4QttcjWlQnZjJtQQtuRrJlPF5ZDNbW0KEnGZcSJUp2+IEkNstcrKIdLvgWWWGGJ0SggWmYZQ1EJtj4IDlUX5LWSh/sGU6lUFbQ5WW2zZhHsYlUWxZHFLZ5EqknLMf2czkxH9kM5CbodlJ2nroZNFfALaHHqbEcGkTuknMzY22g1Fr+zUm7FyS2KcejkbTRKN9gkirqccIToZW3sUKyj9CY6eTlJXGTn3DpJw2qVTeGLJFGXslJOVfHI0WijlbCLckpqCHmGNJy8+XwUhHayFoIa2gpNqp0OBeGX4Jyolt9iZJmmtaCkmzTRQoY6IZ7KSuIo7Hbexw0SroEJmrWuyMyiGGJTRWtDsTATcRVDt0QbE3bgaO15PUiXZniGiStulRJhyRSbPpKTw6wzaIQncmgdqa1rkabRplOUiSQ6wbDppTyJTbaGUrUUwhlxbjMw5Q2YqckWhK7gks0wp5E86jWViexR1tM6sSopCi0dRKpdjdO1N4bY5W5yp2WlQyUtsYim2rz9hJaahQ0/ZJSk3RNjQwIqdpIdOGretIbWWnrombW1vxI2ntSXPYkdG5SR0kTm7of2io2qal7LMluWxo1NNYFyOFtlWthNJEOzWxtqovlDclKcvIcJGayXA22Vaw06E0mW7GlomU7fEdikVDyP2TFRNgMkpNAu4lCwz2J3dw0okMoXYvY6sFuxwVSfMMv0SWDUA3dcqmoiQqkoJ07rgb2ym76LWsWHGiQz5XCRknFLC9hle6kWcpGk+eyYR6nD5G2jclF9hqUdtNOUMK4fIkTZcQiZozRltrhpZaJqPKdCcNLeyWhQzSEs2MVunJPUsaTNGdDQHSPRkLkSqCp3cThjGYymSk7ELZJPQ2N2gyo5MaqDRNjjxPD07E6F6NjuQ8koKaJSO54ZJPIliTM1qgmyeYJqUUny9kVWbKf6Go2pq1sxUIu4Y4iU8uRFB3kbJMWQ9iKaRBMitgtIteTcCUhW6trsgp00KSpg1RRw2dMM9iynFZCVS5G3scksUtJjtZqxrm2ENNEUZOQ1LgpTX9kAqf09jhMiUsPQ1DU6s+hO4DjRBx33wCNW3jD2MXLgjJRMJv9lWY4fI3OAlrbElLJzKXodYuGNhzWykImSJmj5EHYQDbSjlbToWnGSakp3XI3wJBsmFPUjWbpnRAadK9CFN3r2FxnHDjbwQ1a5EFBJbhkBKC+5DV8oVCv2BufyxK4ZVESwq1tcQOZmrXBKNO2+JEjc6GE2dEGaMpUTexUQNhcKUnsZJS0REiiwiFC2WyLaQmjWxMyREWjySbQvafRd6sXECTli8paJHZL4E9nCPKfsVsS4XGRDG6INhkSpBK0es7G9RMrSWxNW8tCIS01SEougDBJmkcliX26bHJpKafiBww2l/I2yS1tNdFp5Tcz7IsTWz+hCJLSIl98EEiGUJh8nsm9wJSzh5XYkbU4FgmiHDWVsiy1L52SG2/+EkrTE2sppDJ7GEUFUqbEnKczOhMZObOhqNw238kPkiSEcjQly/2RDOu9jGoqqW0mNKGGfYQiXtCoVL7hUE7IlcWtDTgd0qlb6gmIS21wOVvTEh0vHAgTSJaoNIGoTpT/AEQHCWzGyhDfkckktGunkuRaqS4EIUj+wloIblmnWHI4SVUNrYlO0khIiA006G5QrUgmXvJqV0Sk/wAEm0ZaTg2SZKoUZJxSCoaZJIPA1gtLPBcIUOSaMJZZ3JTJobcu3wxtiGUK5IJpvDKy/IqmCkLbJyxTlInBSOmApt0Gr/oQiypOTnRZlf3AUNlGW2mYEkL+IL9hbfA40Z2ECaGD+xM3M5dlojnkhqniJddiVFM3CYl8kscOyKed8R2lDYlgnCS29kigSmEi7GUVuJtyWuOUOFwoaRcIUpklXDI0osxbiZtMcbcCaDxiXpMkBYWrnZHNUpQQkc7OGRMqNy2tEDcJMr9CySZw7G6XtZOxPQxuAoSGwLXI6CVcMcgnVukVJys+hzv4Vf2ITJOVrzIqK4TfL2NXJDQl62Ik3B1OhSoq0y7n6FKrspSf4HwU3cQm0bHqMtF0UktMTbrOLA0rE7dJDSwNO4MSeWZSlbp2+BIRkRhuyCTYX22NpigeJGiTmG0hNp4GcphAqXQeCFCCOlR/geWdn9wMoaadcGVSdXwS6FK52gcuDKBMJLVtwMm93lI5gGk1iOt6K9vgcJ6ugdiRyQuBMKGwHpOjLX6ChmaTkK2RwL2JS60KCUFjgTGvuiSHa4Vt7+SEIWrYXIwgbRcVXRJBspi52NJE8SgJySofD/Y99hKba0YKwtHsW0lm8CTabuXJMG0qoSIa2cw2gUkwxXgX8B8ZCt+i7twsiBilytORGhpUNiKMqnrZMtpp8ejMCdXCO8MSpHtA3cJbE2lijSFLi5a1DktIWEQkRe3oalGyjuBKGyffuNWlPviSFamUI5ESujK33NjRQVsAkNMsx2JQzQlNHgVcqTeBEQWtGK2zNK+4WdQ0YXDKCS9uDQSmdvgmaMvYiEp2gal8gOhEQx7JJXYhP5yNFGHNwhpNUp4XGRKm1DYQ1T2P9BAkmXJ/ISTazAt2LAUKmEnCgcUrQMsuRW46MbDVsI217QZphUJ6JINR9wbFGioki3whsditBofKXWhsDL2Gks4oTO7h+Q8DbK0qSFQbgURwxtoyV2MjlOy4HBMm2W2PCR2w4NCp5fZkK9nRQFDUJwpKGShfsqyRtdeRosU7TlDEyuCPDaHJRTQVIs0zDBJTuQmiZdPoImtI7exIpfIpEkUvsDmWQrE2bpOraKpyVSPiiMT5LXCDddSOic0/RmXZS44Gt1Rwt/AlabpQVhBbp54LJKtQ16KDSJSz4MItK2UGKWApIIbT+xBlQoZg8NhJjpt61SFZpITUEyaLEz/oKCblsuywUtexKLSkYZ6kQkNJcV/YoEDXL62JIQNK2QsHsfofCgQtJ2QaGzyFFn04EsTcmksQRNmD0HQzbZqytYRjAl+7HtyTHsmuLVkIwm5W+sEpJIyeWchdtizghPLsdI2S/MNOyg/JVCSUNFlI20XJdZTlpbglKNYdjRMm1fYNXoVKW/gc06riR9UzkkNRCUdtwSpOyZdGLcYTmZ2tPokrcu0QShttvT6GsJykmWSruTLZFZoaTDexJkILScssP/Y16silNdESlFM+T6Ym1RMLkSxr/YG0L/riMVw3TWi1CUt8DfNY5fHyUZvc4l8Co4lNUKgpVFJBP4ytjQFSeydoUwWasvJAUzcg9smOojsaoGoIaKgaqI0y5U4FgWyVyjIPlI8oahOloSXcib5bHbnW2/sO27QlHscpTloTFXoaw3RkjZPDog2cia37E6ZwKktibqUGm/ZAKvTQUpoi89RppstrWoGkaf6CnS29t/oWlRS2bEqmm5sS3DKYeyUdL5C3gcJaTcaJzM2UdFk3tW3z0XlUIwiRLpLh8mYQ08IoWZ4WiGLJ40iG9BwRuJLl6EV2kmWvQ5DOd2JlpPg3n4FDHNdyTpJNYfoSamSNproblZiJtll9M5MDC5HCxPxBnC99dDJ0dE0MZkpWcYHoNpTPQ2oymW+yFCWUtaU8CxU5UpIUmxUPY2QJOE9lm8AQVtitHcCnJrZWX7LKowRv2TjdpDLpITUD2B6LBkliKIwNT1aeUNNaVJv/AEKC5ErfIklnI5bfY2bRNQrpOVSCJ5YeHCC3TZpXoU23Lhst2wmlv2cag02RAq1OCTJI5L0PDhhpa1BDdPIxpDwVsb/QmoVlyxCZVUzL7ISLR52SG+UvkZmlMH6EmlobYDbMq2+ehtzVXoSaXRQ3wIcdD0em9aFY3M21qhcJKHoaicr0Myq252xDJmzYnbKLDZBuTaXIWN5W/wDYoWmU2Qrk4Tk23Ik5ThxMLMlFqTQ2aUvJDS5lE0NSSKVlwJQcJuevkwWGWLDTC+hvBTaeGRkzwUcBJa5UT2OZ4FjkSq5f/gakzDuQ2Y4GjGrvJHENQZATlIqi5XojSBayjREiUpByuabbfLFCao4bb74LTOFBLkSTsTmjCbkvwIvQj9Da3DVyssiCcJ+SNUGeQ4JIt1RJpFyCtOG3LXQ03T7DYQxNZlt/oxFQlyJFA7l9iSnLy3Qkk0JBEmpKYa6Im02lNdCo3l2Z76JTdasgcPc0NxBFKNDUzbymB0kkczT0JoHMMaGySE4vQQhTbM/0OVylTZAzWyieBK/nOB20iUUmIphtrDZNkysb5aJTkcfRikvgI3DOxrQqSSXh8EKVbKn9iSN7zqXPEqrT0JHsIlp/0QQitlvskvaS37LWzrCb0SHqsCAjdofUpNb/ANkxCMX+woU3hf8AY1bjRuBwREL8ERJc50gSzTeVqCBKKX/FE9J5GyFLM1OpIhbRhk2mMOBlMdNQTkjysGVNvojo7ohrmqcRAxKtNQkyYkEsYK/sSQHLbhrQqBKaw8EIWsk/6IBnbItKr6/InNOC/wCiJugnoSS+tDEbEhjtNpNLPJkPkhUUHwOKSL4KJm6aBqhXbrgZspQtaFEhHyjaSJNyyPBtsCg29p4nJGX+myJzZpQ4huiMBKZGM85OxyoLG/ROKrygvrKnMFCEuIbEw3b+QwSM5WhrpUUfAaM1S1qOBzShS6azGpMMSay38mu4AqSKeEKZwU6QkpWNGhI2sUJqsiZtKpK2/Yurad/6GxVyhKWhKapdtyRXwLz3BEoKX238CofjXIlsIwe6JndLyRlfOQ1UtTt1fJkcty6JO4tJxp+yZo7lruDpXq8QJHWgRSXODoTklskaU23R36GjuSemz8C5jcqXI7aVuSKOWa14Y1ZF2o50NMyxHbG0CrMM2lKVqdUNuFzJcUNWmq2rsVwTgXbP6IYSYHyI0kuLHb2Ijg13LyJtb4bEclTjWxEFIt2PSgtv7hNc1nATtpk1kLEvkVimaR24uliuRycsWLqNwTZU98fJBTfweBSTgmuU+xaaK+mPMqSnQwSSfI9IVG1ttcLMEiTJEprKWpFW3trLfyKnMzBPZlavhRa3JV0O7a6pr8jaR4UpqOjaE6X/AGJUTqGnMbdyXSTTLZBL80iaUvLUk8z0Ucn2+B0NdS5IQZWEZguZuXwFlKvUDTGegZI3RddE2hppcicpXmkb90VfHRg5YV/6BNKG09tsWxLZSGqNTLHYid2b4S38G0NuclwslymJU28deBGk0zJrklOlHAXZDgT1jTalWi4X0PihuUHYxXA9KpW2GjY7CfI04GLPYmR91kyzZDxmYlsasJJsomlO3Mt7FWWU05G7aZRZDE9kNo66OtYloabshMHx0Q4STpogfYvA0JJNcikZ05GNKltUMQhXi+BKsGtQNJqTg5ghYfWORtQlMhJTavtGRqhEi2VpVdCSk64HQkm2ipZQkqhzkMkrbeEjEmtC/cJFL6FP5EoUJchlIda+xqEnxg1kU07nJf2Jjnm8OTUqQTailyjCaFQ4blr4H7UVeIKJowlsJUe5hQoankhiNlkpbJBva0QZCw2UMpTtCizJLXjggULVfsdGl7dkOJdg1OUqEOE7qfFFM0WFmK4GlBbSthtV5Mp8jaEuDYoWiSryKsrcHdOm8HJCsw3MGXJlh/lHXI2ZJqMEcjTZ0XA+CDSxRLbkhMNR0NzprPAkXfiySNZazD/oQtLLkoeynPLFQTnmG4pnByJpOOAOLVO0OXTYnLwaNDTS/t0+hOTj0rHyKWmjNyJayW8/A0uWYvh8jJYLR4HhJSuQ6cqWySJLLdUt2JQ81pbQkw1p0grI3w/QobicvCc6E+JLRoUSThY45NKkdvtCKaiwlkoTWUJV1QokQw5paafsxmHcvclUkXCCxMhqggOEvSTgVQ5Dk8whVCps36JKJeDIjzK0XPY0qEheBZtQk+G5JsijI+hMjfKaxnDTp0ePgdFUtGKCKhspiVYqE1vJl3HCYbFN0ITJZGD3BgYtf8M4NaNf2TWbS5Lb0ORMhmROie4Zak8dC5urVuMCG07FowxIk19oxKhMZJkalU9XmRSocttkEW6NiU0A7DaQ8FWrT2KG1Rr/ANiJ4+T+iE5+tLHyN23Mlzoxyncy+IHPBKtRomTCeLGI7Itz2QLPB2ITbNI9mzjbJGIem7ErpJjNoStRpaTdFJtcM3QnbkKeUNWSpLPYKh5t7Mmx5Q8h7H3I/gSjZbT4FIra3BYpbeJLC9lYgMUIIgksmrEKX2vTJCCpi/tA1ZuFM+PRc6dhThrgSUMFuetCWBw1kwsqwi36FlKSY57kQk2UXCfyJE04cPr5GyTuXCE7dKFJLk3KgfB9Z7DekjqG0SWm65cjLEFyfKm4G7uZFdksEHqzM5MzAhZ7bE0XCynPZLAKi1JCVoSiGV7Y+gUoRakpcRUfJNE74ehG7qURLSFmG392SQmyuEbbdHJ9FiuHT2ib7ah79E5EJavPQstbW9sSy2nPKG0lhYRlTyMnaOBCcDQk1GRGEQiGViXoZpSJymV2UznLSh02mtMIMmhEiU2vsO1ulUvaRfLctKdrKGbwaZ8oacW/2I3TbD3uxlC7BNktmSvT9hkNjpPgRhc2cL9DqUnLwJYQ6RMqyQUZY27Yll9r0yQSSeMT97E2cpS0zaySnLWr2tDbKNi8HyciCTU525+BNQlNWmfkbUYe1F2Ukkuhx/slqYvEuBlELIoliaoNMKx2Y3SzJwEok7YFKtjmWIKafg3BbZJNtpYJ0y22zJDzYXbPQyitvg5E91ARaMBDFhZUciI4FwtCmpKX7CGjMVwNfZNMltp8Mei3QzBDk5JyKVS4XXSE5OldPY1n0LEtUlkuRilpS72XoaFA6Rlexo4oQi0h0JMmZjSG3SVnb0NQnZOyELJK0xZwzg/Yk9B4ZRZLUOizKX/cgUu0QnJuWksEpTzb5DhEvg0IjbS7bDSkraUPgQRzlX6KlZ4ERiYDdhJfkKEsj7E+hFCXQ0+widpSUpqhXcp2lO4EdCHnfQmwcJ8xQlhrfPwQJrlOuY4stqj0JSJdT/YoKVbCSEykgSRTtCG2sWdCY5JUtOjKFmI4CMG1gvVEQN1nLgyy+6cDWiuZyJb4hWZkZLf0XJoJYEFdIY2hBdwOGhaTXHGhpoe510bLhctSRLTrb7oiUmq4ZgabbbpyY1Bf9iVjctolajkdtxhPRji1tNZLkkltbsNpKWVhFleyJty0IThEklD2mtEpQyxKT5imxxxFbaG7khMdhtNLOcCcjSTFJJQyaOAm9jbSy33wNtyQ5KaDi7kE5VFtCIcRMoXt+CBkKjdkYQoWXoSKXLlLSEVTlw1XwREpNJysEiZG01aUy9U/kCwm4jcZIsqrsUmqzTuBODZT5UZII6sKLPRjJsycJxtFxFamWkhcBwTZO1TQkJtybS0iJ9wo5EUQ62NEnZ0iOwqGn+iLoqXXa6INTDS720h2qSUmBXVKcpyIlK1wbkcQ2ssnMbFRwhPLOSXUKciWiKM8h9DSkmbVK4Uck2hRKehtGFSp6TJstWNJL1RKCGmUvoE5zhFl7HObaW+T9EzS00tDKVM28kCkxhIEyNrgQkjTE9CEids9aIEWydIY3J2noTTITByJadvT0QaSCkFTJRN7EOW1X9InUC3P+iU6Np08glOQbpsRpSawZGpEWiNqSA9MvQlrlmUtIREWbZDWUjlLYvQpqun6ZK2vLkiGrwL8kGTiLFyJsr4YbMlhpCb4jJBuKZeHBCWm7twJlKlUv5GtONp98iVfyPehSTdNElBNbKUScY1UFJJ6yU7gUqag12Kt98rlmrT90jSHE1/2Gplcwo/3GGpTah0hm7LZyiqBo7jGtrQmZtJ8MbNNxJXsNW0K/IcE5T/iLFdOU8yLRyyE8zA0DyNoHLUJrbepEcXAssguW6nkhoydDFtqiNx/URDnPDhsdpllaUkWtHCt9ibDWvPsxn1fmLK0kQm/2TaY4TbkQ0ZtO3sZ17pTkoG8jkfBNWTnOxGCOXmaEyI+0kas236BNKI8noZNBzknkuNPI6Md4lZNcsS4xEiyTOkB0N3JgLhvO3wG2TZxGFyVo6mOJxs7DNvUhppGm1Ta1A/IvC6IHkXZVBMYphdY6Gm0KO51fJUzUor2KSbqDKLTlONeWBMTSD4fHwOWm0l+4JUb61yNYP51z8DXQ6bSQauXh7+y2jlpQ11Gxl7uVPpCPMbOXFQSxpNN2WhS7J9+9ClrQKcYJFJgr2EjJtN+JRLI6fJTT5ROMibwBa76Ihg1uTEiSCLKuwGH0EkyWmoj0GaJWYbTZMr9NjU25PJpSRc6Bb9kpyyvIk1mZQhWKE/7GaS2ddkHLTWOy5KTNK2YvLkcjH7F3Emlc0yGoFacU/TsbU3ytLSG9RCz6JDqZ+xqltb7GSdMG65YoayP/QJKjYKo2swIRNOXfxEzTxi0LKkaxwtF/cIbVjB0ElC3SfUDUuKbwh03BNzpAnMtp36EzSqWn2JZ5TVBJQ3UJaCZKbgVDmcu2DgQ1a7Em1DvpdikT9q5IrSH7CJQqWjZ+xJllwoa9bY03Sm21McDwDablzQkk5TduJJJctink5SU4nNiKUcByJUxNgyaU5nT5ISOEsHGSHoEtaGzhCdzkNIhB5lYJfJyIklfAHMpnOb6gq6J7f7DySeTQSULRYzN2CIzwlMkMiif7FbTcvuFDwGsdwW5EmTlbMQ4zFnYI+exnBPkGJhxQs/vLiBE1DS3QyknKuyUzaczvgtaTrf2UxqSR6isa2Do2UbCzPSo/Q1BMoa+CSThu6XI9za4G5gsZbb8IbEoDlO3qJTTCcCakqLcNrQrPseE0JJ0nYsuySNNKeE1JOVCVLkIkm6dC98MBk6iav2R3uVvfQ4qQ8UM1g64aHmJJqEkK55X/ZMoOEw1OII0FNjfodbVrY1JLZ4Nj5fsbHasYNCSTTQ8MQacDTrY3J6DKa2PyGRTtKQyagl/KypLdBVtwc5OCQpvZt2vRNsBuX0JCIpTcv8A0OH+wMmax9jJokmUGilgkPoJNN0O41KWFccwNFKd4yVpYeHIaRE8Ju057ULFd70FkU3j4QpUWyWIdpS7CHtsMb2+BjbDwSPeEnTE8i1EZP8AIrum0V00XHY9tLXHIUyVdGEzJZa6QW7NYcCW4qVNvgWFQ54JE02A9hKDlwYjJXHIdy4nCEDCAS5ac13BFe0ytd9DCS9CfLEUWnJuOB4jGnBP8GIahwNE8D1jEkKzmiFsRoaa1XJIIpJQjNypSeJ1A9JK9BMqRQk9CmTeCHex036IbR00cv0QiVVyJOuSWDGorlRD0PJiDST/ALHSQzhQtwJtFPhYggycxJCjOFqmvkdWnTiQ5zlFjsSxNxqESs7Wn0YidmVkcujTmGfAe0Zs6yzBi4WksDDLMjac+KM+x0SMIbGLDDsV/qAgVoxb+wStpIhOL/AzSnLjCT16Glk3KKEnosIlcsVpRuDprWjv0OrG7TsamMZe0Upo9kjZCbq4EkicUJcvY3AlDRBCCd/NkqjySGjNE/2DzmVCcMa300kyRlcpT5FoSvJPAtpEuTl7gnlNjG1ZWnBO071EStI3NBPiMDKdqIIbE25JG1wKWeFG0xQzUtJR86GfN/aQpJgptEHdzih5LZmySGnbX3BZTyYYiwlLdUOo1Kaht2JDYhOF32SkTvVdCRBYWCQkkzKImpwvAhDT0+8Sygm8SQcXSqEkZX+hlBLB5WRIaUk7PgOWw5DgbpJRFghLgvsNppSlhve5G0zg0lJNjNO1Cl8E4i08ehU3o1ORImkVCb+RJMnLtDglNmeEJCSbpaZDhLXY+iYDDL6EWYWb2YEarL2mIS0lV3yIUTlqGqjipLkS4tBQkmSAlQJTtISbBLKvkUpdzUJGWjWkmNJwuamKFpuZvgprFyS9wKclOTRnpyQksp4CKYQ6U8DSvQ6FBU7mmEtitJS4MCSKwlhZ2ZVTyS5MUEmPFSEtpvUhLzyMyjTlrLojCouQ5ejD4DoGaiGZHAqTSTYuUwFnE0skuCciLQkQSkqGElI0oc+yQqFLsSYTtCHCzw+iMZOLsKYSihvY7cRsOBcCowHVacexTQcVTfexxANThchNqEYHwLhFijaamwmMkiE4EpNNaJTg3KKuRWyS99jtIiOWNp0IacEbBsypI1WXuRGko5ntjpn8jcWpLnkbpZaBOFQRISfw0hRm3FBM25FUhuWjWmcYGk82idotidp8hufDIRmvK0Jk0lkyIOEtZPY8NaclFDQLbwiFeadCX7HS8M6gkJQcJTfCWhCG3ZL2PZKGF30RYsqMhSlXA8kWzDpfDFQlMsY25bCiUIRW1lio33YmRZ5QkXH/AKjUzZx+hRspOUkOWBJuk9mwEVI50ySsyVlBjpjWWkO2Xo5Vy0+BCOblOXPBNNqiWGOUVZvkURcVpciOTVQc+xFLgFk5Tv0JQPDOUiIbVrQRJr0gkpETeDsjaOISLdigoh6Q03uV23x0O2mYEQzSwen7SJVvvJqy9Dmt3SGtp0Z4J8qTtdk1podkjmJ2uB0NMpS+7oS3TlvQ2F21XIZHUyXnsCkoCAhwjlPYKDVM6bRCTlmkxImhqS1JCXDOuzEA1GMpabDlJCmm2EtL2MwGihOxpZZ/uNokpnCf7Ek2xO6QikSliNsmkPoJu0ty4sa0ELlpDZKQpG/kVgoCnztOInK5IIsrCe4F1MxO4EzKwQNFk8vghIcSRGRLY1CqUkNTeuAgRJSU0xKiZWhHAxytNDRNqfeENooiWYb2JM/PA1akmWxq2+E8vPwXzwk8seAk8T0UNNSuG8scw2l+5HvIIRFNNYbTMhhaehIS5f7A1BwN8DVtJqUtDp+SdSIYqXUtuWIarlqbYrbO1OF0GbbdwjiWQHusXtxwMmtok3DolTNw8OZ0NUrCyLmaFmIa6E6nB0UaHbWhIilPGh5q05uRiEuMy/6EMG3MO8CJdlpvUiWc5ZqJ0WkdK+AlzIjHNF01L+2hL5o0kLegxG2NdlFoqN8A1OWW3+BjKUpsDHbJ7KOhLkdACWiCZ21X2Zi06XMD9BuO4KkOMGFSzW6fQ0lQRTDImnqur7ElqVEIbitZQiZR6NDcFTm0sNDdw4fDwhrBF2J5it6kTllZbLNvg6bzXBYupU2NbKO2JDIkp7+CzQu3Q3IjiZQ1Exg+WcBxfIblkbIbhpydCFIJQmtaHhKlkaRUsrb5EkpKeW+SUsZX9gybuFMSyA3GD5geZ7HTodtuIVyNxq40PYl22sJLZBKjhmO4W3fA5UVpgUgnMuZ0ONMwmWNUu5m5ZZV2OyCb2m1KRI9sOEI1bIjHIld6hPuNCc7oiks/I2nU0KmuSTxQWjkVhCJtLLbozSOeBatnfQ1UykrYoZK5TUv5E8201FihM/pcx0SHpz0IRvKJIK1mQUbiyAso1JwTN98B4pmYaISiZQxoYl2mGh3kp8PCKU0tm3gTsQ1Z/PBA6O8Q2KbY1J5EnSWxUzWp6Eg1ZLW2RWYLEaMlEyhoJ4NKfLIEl4pP2GTIctnQZwByt8DsJOLIx46WX5LKW0Nt8spspTq9COWtT+2BnJ4I6fIpJKxY6Y5qTp0TK2jT2NI7Spaey93oGojhqZoW2hoYJIUoQ0vdtjQK0JbZBN3yG8KWuWpMNuapSVZLwbZQ2bUf0NRbTV+40JK0GUlkblMGlTXI5RKGlaHcsQHQuGhMcPa6H8E25m0wP8oOSgXlD5FyISegqgdZTfZA74KJZGZLScJihr5Cwm7anyJy/Y9GCUU1yUrgrXImSyATulSvWhKy9gxxNPaf6ErbjbYtwTyNUDlMPUjoEO8Lhjmm8tJjPy3Lv2JsoFJaZCtjalRCuB4mXShokqw8rSRNWT00MQpQTC0yJpSrbIrZTUt8Dtsa2/Y0zKlSfocjf4EwbOHt6NiWdtfBDmZWo2OWoJKGUUJ4mMP6GiXNuhIp8tECnRc5+CiOkpocJS5H/wBGFvs++BtyXWG32ekmE2Lcicckgmw6fRohWXNDiSbtCGORDTBZkw3yHwIPCaE5SZDEzxU5tNk4XI1wyEh4TD5EJHtWc98EGk8N9izeoKRNqU1PYlyziMcktbTtPIkTsKyPARVNc9jTDaVrkZpFm3UDoLb40ITQ5JvXgIkaZpFJE1snBCqLdpobaNCRp8iwHAxFmoarQKSKS4TbEysl2NpZGhRhrNxlEI47Y2pKFvkxJJDGXuSE/hWjCbn5CI/RCjI3tCJp0zcBDead0SNymR7dFx28CWqIVV+oQ5aCZZKztjsilEk1b5EZKjQyGS3cPsxqqCoQyNGEnicCyNvEln5LRbge0Jycz5LI22lzup7JXJhWsKRupIzE6rkUjwRT0yyghr9SZlXZ+hMrYyXUCELhMCGzKn7CNE5lyXJdmA7+4PITjhaadRd+3AmRtt6OPYlmpsTWhI23zkrA2hkqG1hexDM08WPsbxC5Gppdo5ESctWDpMh8yKSLl8plgakvYxVcoaXAfDqqIhrR2kteyGxdo0KI6UQafJNisDDtDqpFu6prLotGVDiXQ4oRcpomVPi2WRr7xs9FZFpp3h+Q28jfzEQVwTbE6zNtP/ZEilvQmHrOxCblmn26G9nEhNok0v8AUSuIyyJWZZ9oUE1YsuRtIUNg+xSkIh1Ba5FSFobhET6XA7xt4Ui0XrB8FnyHY20XMsuRSF9mG7o1S4UIZtKEU9Mk/gJ6IXmVh1RtwNYS7RWJVDXsaE2eo4HCFvvIhiZcoi3T9uBtEspK6ETbdTD4EpLsxEMiUpFFY+SCjNbxtWQzw4ymNtyiNlpkEndDlizAylpkxR2poZQa6Ea8USGqE8CRMWEslwKkRO0aKIsQkc9iTaBpYknqqEJ6tQm9xyKwoTpJAouWUYEhPcxSqK2+TKqCj8iTRzNK4EtlN82iCuCQm4om5NlMpW8w7JtWyvwRc8/kdEJZURoTpa4vgmsU1kdrKy7FFR5GuRtCIJ7DcMlDkbKkU0JbGgonHXBTOXhS0NtDWsOBMbnsv7JToYNNiZi39kNuSUCJyZUqnpiZ3RoKU5Mt6oTaS7nuTUDjYcSEVNciQTTnAtjTTV8olNkOxCbo7QzUWtYhKxOCU29rZYEQUNJVY+RtrI1vQpRIpLLePkdlTtyEpJqlq+QhqUhQmOx1hh4DcEs4n7j2a1eh2pnRwiUmjljE5KdsTh0wqbJaTimuWdBrSDopzQmuhzGi2uEOsOA/gwmiPuFhWvuFINIEFXG5Eo6yqNlKWp45FBpNBlLiBRadtqyOAh49m3hosNJTWTxqeROmCmeYLrLSsYkYUW5FGZlXtFFUaStMkhcmN09Q2STdKW0TQhgWfkhh0J3DQttblHIzmXUx1FD2ESZL0Q4Jv7DJaNM5ulkiRtZR76KPqtxS0PCHA6U0lOn7iQgh6/3HCaTxhsyEF8CWfkSIg4bwG4ixxKYxsS1zkUuEh1LT5GnatKdieLShKfwYBlkekIZo/QQ4CSiRtCFsSklmVFKptS1WJ1coh+i2wroRMEHafBYnalNjHI5qmsCbYmtBKuHNHwhUNNKht8FZFKi7ghEKi05L8W22KDQwEiLk35DsFnDRQvSQ1SSfYREQYOzjBmYMHcOGEwm60+hM21hGe2ZNKUoQNU4/TsgjROv7BFNwSlyKLOm+CLAoX/EUUJNc6TJLZWtJGyWl/wCglqGhvvDSb5V2w5zq6W1whTKWieWhCRcHzb1A9kk4RsYpdJ+34GJ4kQ912RJJdXCNUonaS0OqU1xoTCa3v5EziyJ4Uxpu+U/UmNpOiNIw2pehwkuwkh0UtvYmZsfcBDTh+4MUoxHYn0Ub4YAibctlT/ZhKj8DohFJ5o2GQXRYZbJ2Id068J8DSpQLapoR0xXcIah8rgY+FlcobZj7wUnpZB8hz+4tTLP/ABY9XBqhpaQlpy+UuB6y+IY1zM8DRJslfAiAmXrToiSVyXAhLSTaWC6DlKmFT7WiCbpFQlm0Tla5Y7kcGGhwytOyUkFOv7hsi2UJpKmm+CJSylv0NVCbb2npMzCvDokWBLaeBidNTy7MbbmosZ7XA8L4DkpIOLfLHZIoMFsUzZ+X4JclLYmuxohq6uBCSSJ2I0TBIn4F7GRpbmwcoS9I5eYaREquUUK1JOr0E06wLTCbo3G3slJLMHsfUpK+RkJuPoZBJ5UQEp3JkzC7bQ08rKzwxKEROjEPJ9hmyIpB0lUok0MFdNwNwxA6fK4GnLOa6G3o6HsndGshOZvnJdTowhq5ToaWl2aL5oIh3bYMKWfYwpLP0DU8mg6Sz8BEp04Wrf0ZyhcMRahf1CTbgv7GS3KYwfYiSXPK7GSNpkdmvaCpPLmBNUSX8CTiE280+GJSlataSM4y6aDcpcCKkncry2SeZS2p3A3gPFPa0Qpo+9kmlUYLfsTjSMlbaHx7HQ1ZTCUlEy8aKlJZGtfIhNLLzjTE8lBpUl0OWlMWOBkyk1EUNS44boomSsAm0lezb2JmgltcjyQR8jEJfPsQlYojtEjO5ZfCOlCatJcDSKyrjXYyDS3DDeRW428nSLNpth6CU0UR03Bbmkw+VwTKnnNdDPhBjfoZ5CdrkLHp+MtKVyuCFQXM10TeVPxPkpiaW0uBlBP0FKng36mOUttvYNSTYbCvKhHyHtEJroUnEQ37EnlUmvxHTbglZUEpV1tCiaKdAzSayaaRZyYLQlJq2/RIhyGGhKJvTSRMjuY0k6TuEDZp8kbpwbexcAlud9ECkJbPQPZhTZW1EtstxDoq2lcUpn5FmbldFpCSaaX8cCSVIbAo4ZT0GrO8NwiZpNxgMSSX7hrwhaShpVtbGlwcNMu3EuV2bKiM/kFBWB2uByreaGuCVJbbQ00rhtlkL4Q9EIlaLpTEaSbDajtLRMh1mH6GsJ5Q27pyeyS5h1yKVqE1b2bFJ6WG56JxDWUuSxq1WuBnM+UF8GSGyluOCE2fBPsgaTQfoRkKr5kJm1glh9TKwN7HuG1HDonL4VyX4EC25eGspFKZW0SsMqAaqQPK6FNGUIStP6ii8A9BIkk2tFonyOG1X0kHhVYuRCNGmX7jxE1pDci21T6IasVwyW1BE0yNGNDaNOyFyJwbXsIlhNJHWRQEsqDhDhJboy8E7XoJsbTbrsgbrJ98DW1Asa250KatuApk5hQ+aViXeofEa6Rzo4GplpBwqkTSOR8E+icBzp8k+BNQn7Eg1KaQ2klSP8RJEDgNciZlvMrsaqqZQbiiRYuY3MVUlHolYByd0fqJoBbOhwbSa24SQkxm8PQmpS2j5ZZKN5gzTC9mRCkpq3Il0mYYpvarKjnkmTXCJXsZVx9wOly19l2QoJNQ0i2FuY+A0aJhMdS8xrkuB0kk8BK0+4WG2lyNMejYEiTTCSE/Q2qIghps5ZXY0SVCUuSUYRh5EZPZH/QlSk64KC2VPohuR0UtLXY3JNc9iE7cnmXYkRsSWxEpaaI+ZCxqoJ8NEBKju1+gUpXDmnyS6LayfY05DSxrbnQ5iS5Q9ohUk+iHMRYPqhupa02i00kCekJtikfxQ0xO39kwZqkj5Cgad7RqOBPfKQohqaUGhFTh25S2xoiZQ6g3FEi9CZs6qhv4MC5o0SppdnqNbKa30XNsHg8DZTJVr1IpLnbbEk3QkNCwqFMXcTh8jo3pt0xzmWya5E20yk/Mjob+0QkK1ikgkmw0vuWQ9fYaOOmsJtQOGbP0BG1pbKJLD+4QsuIoE4SRSDSSaojDetiWHf7EIbvktyUkthdiTZUCVyEyWDh6EtKpoSRCQltU+iHY6KX1BTJG5K0JaprKBSxwlmRQ5zoFI0QKGCVBK9CWXlK/QZpqc0+ROCuytdshtsaWnbnQ0bKLS5E24iXoTYrA9UM4GHlcQJpp5dJDHK5kvqSQ3Nf7FgKEkW5E0NlESNxoTL5Iwdknbcm05Z9jiUS4XyOChZ2GOzqQoO4BzrSvQTbmTTKejKeGDSgSORyr+hNTlOdsTu6GoUteyMWccMk1Ung2Nu9qlPUk0Y4a0NBT/aGibYsxCzhsNbqxo0Xio9C0oX6Bkm0cMk9SKXcpbIkHhsE7tEfsLRpopQiGXEIb0SSUBOkxqoohS3JECEuBqCzXS7G9xRkmwo1SqoaE50Bo3GCIJRo3Y6Uozki7K7fuQknRI6ChrNIkjeCagkuJvfI7elcrslImcOpcsaqJfmSUHln3JGwpS+5dR9lpQMaJSb+BJbRyslwKCunueGJaFKI1Jd0khCDPD2MZWqtyXwlntArmyU/ASqdxfGrJtIjbykYywGG5FOly6NOiAXK+CBDVOLaGuu1uDYUZ4HK/R9imWIa3uxJuHKejDRvBYMhJNqO+ZGlQSaUrsbmJw7V2QRQnAnsSmhZbPND/AKDSbhkJ2VXPok4IeTCtNbPkJW7TQoi24/ZGVDR8+h4UqTQlE6YoevgeOJPKCklRalgdRPR2FNJpzaUi5a2tpCW2jcMVoW3FzGCEqJwbsWrTyyLZtOW3w2JnMk9ik8oWEFGRFo3+y/Iay9iuTShRJrWh/Y0Uoh/uFuilOXDgfAtHZpRi4FFNPmMnQsSUdciRLIpLgUhujw5X9EogJOgcE2Q2ppKHBmKEbQHLqFPIzbeQVaRsuaGNXKWhpkbBd7rMErXuPkXJWpuHcWJVtNAS1pzO0KMOMqIQvClwJspXeyjgTwU5IrzgUY1ZYUisVzQk/wAwW2XClrHYm0Ukl8EXEpLdIckuaydM4Q9Mj0LG1/0ZBl/wxoqPFBWWdQUqhKcNYSKKgnYaU8jU9EJRLN17IkmDapPAkocQcC4lH4iKDwu+EEkwZNrPZQDWC1D+wmS0/uPSS/exM5QlJf8AgjEa9fYXZrEqUCGna7f4kOxJwqvsbpa7fIeMpUuSWJTjeBgpkLoiMVzbmnBRc3ZOGPgFoGiErCAiKtPTayxrYhoSjA4DeyElwhSG9kaNMUqBCUhUncturEhQGqoRwm4wm9Posyrif7MSTTZsnScplzBN7bLNqEywJSmJuGNIodg4laWaCIXDcehKRrWq47EhtKc3t6E3Cpzgrt4ZJjqbPsidXKVDx8ClCpVQvgwIsmeENJcF8oGmGhZeGPtrr5G9TDj+yUmyaIVTREciaTbGFsRJvEMRmrp2JOWZU9BJbtyXoJKC1Pb0NJwYvJJsY5XRBLTpvgbOiMmTuCUkhWK6G6I2P2xu1UU/7ITtP2FMbrXR6e9KjsQ+xyMQOVkJNJpThek9EPtrYk3SkcCk7PgiqzNvTGnzLqyI8Ugd0404yNIZlODY6qodjKpL+yQmz0MRyEiVoJCbO3pyxaAWdjqFw9E8Puf5FgTTZc5GcJOU8Mjbiu99wOTTOz2OyYm4d2OCyyZd0drkURpw60JprStFwJNm1NO9/QtysFfyMTPpr5LCQ6kJuDa6fQumOW+ES+6bcDpoZex2KEbKC1FL7jQk4R0v9ikpgVBKeUs9BNMuJw+ENQU1OyGmWW1Kou5utcCbgKXroTA4fmBt0KFz6HTGF9BH0FDihyUtXJEfgbdK2fIvSU5HEvrG5KMRBev4BJNclp+ixZVH2KlBx6T0L423YjiU0cZgSbNW30PB7GxpKfIb0ShDFsI5GvyJ0EbPlkkiU9NEqXCOpQbpuoJT6WWgjXY+hRtrFJ9kRBTaXwI3B1I33g2UMky5Y0kSxy9wNzJnKWRgVGRNjCyyaq0mpdMaHBuB6GzTf/QQmZFnAarVG3MDoO4he2SGCs+XwOam5qsxL4HwJ1pTPlBJzbAaNHLmRcLaQRKahZVz2MiulibX+hwDKklssdmzqMDVlB7SIUk95ZdiZbOwpJtt10ZNXlRfIlJ3TCtVCtbzga+QPkkLKTa9DIuBQitiqlwpxyImXVELkUycNM8Dw6f+BU3QFyMFqdpock3S3h+hzS2FL/sRt0YTfAk214Ybc4G24WdnBKRgWxwSwK2G0GUyO0jkJAmSiBLZN0jYKegx0qeNGOZiXgjNEaWNWaY3FdDycphUk5DplvUCa0k0lzkg0nOOX1seTVkKnZbfgM3SLqEltQ0tua+RxBN7Ti82OORCSDdu30N22UT2+BRNVQSRpqGm/wADEbbaRVy2NQ4qohCC1L/kkgYLm0x6ULN4/wChqJ63JYYtSS0/ZFxWvkUttXltJxYz7KNOX3GJFa9CI64WGNWaKfsxMmiSxaRqUbGyJYFrrobaJli112jCRVTXQ8IpnbTIMpQmreiHZbsZ49Ios3K03qclMSnpPgTNlCWXJm9GS9DQSqynyhErlNNHDQnMmyysNnKJUi/ZKSJHOhwlu6ilJbtgsIhdTbeFV6LeEn1/QlJDZGGeVMvFju6TSbbHClDttzm6nhC2knFG38GKNCymy/don2GeM0LI6XSoRKDIxhcGLTWRagoOXg6wODQuSBGtqHT0OIao3i8lGUM7nupEo52ZkWkSicTn4GTVWsN0JBokm2khMj00p8jMNKqwtCOE5qgNUuVlpPIQ0yqgb+B5pDv4ySkLK3JCenOLWDcm2JtfMQibycIRNJVNTIqN2zfYSa0hNqEpRtXEDsdRQQaVg+Y9CIptTTGEh7cMZp3+g2Tdjbx6RRFlPHzkVBTUmIkyUMMZSx0scwNFKrK9ISyJppBQxNQ8JcCwNwtBoQGBbwSWBskrpDH2G1Zk29Bo6aeemh0hLYRCibQnfY1jMsYpbNSURImbfabpvgRNkrhY5+CE1MJWpOwRrnsSRozJEBBpaUGB3So6FhTpw+g2zeHoZsyVswOUppY6fspKKovSxQJ5b5YjSqp2Poi2SSyz8EFao1hPIsiJK1AoHMppVO2N9w0iuNDQF5oJdHP7fBLTNYzS7OEIE2npyNpLZc2QmK8FTArgbFBnIImqXCLKijpsdpZW7Cb4pOJoSmbdFSWRimGkOMjbRQ9Nbj0NwQ7OIZYySnk9MVy2VoVMpyP+kNJEm07U9icmCdCEzhhkDfqEFmFn2kKjlQ0sBOdNWu0MTpmFQqG3Fa+AaI+sIlCuka+w8NiW39iFnCzZAo5dYDcaKkTl9jTkrN/YzbYhJ1P9EM2pup4FDSJj5Dkabja9jKV0lyVpFmSXPUJghshUknBKyp3GvYpJCeyBmmSlngRibzvwIkibzOBMjKyUQ9J7HQ9qctImTtcgUXwLQZXyFs0YEKxnM8QNto+GliO0Qiqh4axRRJmVfA1mc/YNyOy9jhI9nBLhVsrTGh5URL0SlNDxJY2UdPAppqlbNiWYvH2MZ2PknJhRtW6cf2N2muyWF7HRSenAzrZMOzTKyFRLLI2Uehe2NKQJyxMPYSSeI3TZAQlqYIOl9Ak2modlGfkakbfEln5HSVwiiiyJamJDKdQPUGhahJJLGG3j5FBJyK+JIIZX5/oUo0WAkscsMZtJZClwIjKeycrxGBbKbJ9kzRxzyNxZJMiODMzj/ZBCtDgaEbdHxXI2vd5FRJ1Fr/QoTOxljBqT5LDYWyE2dT8htNPDWGysE4TkY7mAekrVL/Ymgzu1iBQVXhoaJKc4P0WPSCZAnKYfBXdjobnmMLgSzb2exomrG1bhjlYngDZ2rgLilyHwkMWIoblIuOklluBVqJTchFzDynsdBcZESnKfxzvzArlLjRcnKs3A2TTuVLFi0vgeC9CrmV3VRYkUl2VVhM6QhNXIaVvlEsmDCZ9XtjRUptWhCQ+TUUya6lwGm/APRFxOLgx0jZ4Ja4MsiY4MmZjOr5ETfEZaTocI6GkdaW+eilishvQ9nt/RMRcVzMgVeFv+RKlVRjZbKXECV4aW0uCWhstfKqOyO2Gu67US2x9ghmTTSTHK+GHwG2jxVer9iSaiDPmBts0FL8kRiNlclHzpZSxvIRv+Y1wMDTggEUvhJ6HJBLYXA0Zmcm9ji0hukcDJvE1wkqBTsSVKKTsoufRTdM3pCeVJZPcDKVLSexBEmE7aeGM7nAHKwv8A9pSop8IOzUYUTYQxfBEMuZXwZOBwcWK7hVfgTi2x0E2sTC5Euqwq4KQzYk0r7gY02SgjJlacjllEqxCdM7ZTLE+pIlo/qZnNL64HCc8naS0tChPM8HwxrPar5Ek7UxWgm1ahJHCQSdmh5vkSSdy3yISWWW+xuLVVyMmiqHphoiioQgduoSnTW6EhynItQKbRLywkvc20I3A1wEWhhSI2amEw3wObFMhSgbDkUtRmC7w/Qqwmz2PKKdR7GmlNJPqcMbE2pr9kkVzsdCUkqS10iF21PyIhFJ0y5GuxPEmiY1fEiWT2YhIdb4XoJTWyUsM6W1KlvkSEEJ222NoNnBLxCp1k2IQeV0ITdAWbgczvTVuyUuk4NibzChN2w0E3FKRI46qHpCyQ5kX8DZqLktkwqEhphKhWg6G3zA5ZdUJDcHE1wLNS9pcDcI9K1H4FBu1LSakUpjIhMy6qXoTmnQ4BrVlny6IQVJWt6IJnbfY48X5WatNkG6ItBZQO3UuIGryt9OBmksa1GRtJdS8o2zaXQpX0RobaOENCkjpngcprmenBsBbuNt5oJfTGrUszyxyK5XyY5RaZLkbUd2iVzv7C2kk7gloRkKNDTuTl8h4aOmXYjfKfA2vg4CXQnwEzomQvANZcicHQ3IcJFQrDivQWnnTWlY8VE524HDJbCE0yRKeuhJpu1bexKTZaEcvkjK7afBb07CGrb4DKuE3yTKgyapHuBRIoyiivnGzYQnlEYPCmBJGHAuY2JTtKqCabWF2lwNk3Ys9RT3eweWFgNJY60yhq2TqM0ac09owwxbciJNLSQeGBFPMVp0Z1uxzCFNUMRK6qJbG6h88EDMmb+A27HaFHOyy4YpiKfAJni26EVLKRrcb7GIhqGjkRl8jb6unLZSldfIG128obSOUsWzTU3pcDgKyFGikxOLXyTvAz4Y5GJsa+HgfAq0b1adDHOlkx7xIz2XrCUiCFwnb+RVvICeZZr+RYM5OCEUMiXYSklKYj+4azEGGyBhQ0FpuNDGcwL7ZgpSZ7QuwTr5MvWmfWzEyYwCtkxYlJzeZrhDEmlOyODc25WhstOmVxsZGVumYkrwLsHuFjw1tF6yUvZaJDlQqU2/Q29QfLY3FtoWlljpSW8f7RHDeO9AqJRR+tGjSVf+BQkV3z10JEknvjgNpUJ4ewa0Wll56GpRI8jCMGaa03tCTNpoy2RpCVnNOU99CUsjbE+hUbSCk5YyVULab5KJolwrRBJO8yZmCFJE2UISNS2tIduLmPPBGz/cE+DfyknE6O4cOkRr6HmSH8NF26iwCNttqUWbnUqbktijx+9kQ0qKFktRCrSKSaOZU4QlpSc14JKA9OiZFS16az0NHC4ocJHH9xClqLDoFtWhyZ6GNxfdjlU8hcrQqwSOWu3yRKddL32QUMpMISaEpJQazna4Q3h08C4KVNsprQsk8t6UxysN0/CbEQsMHLjRh9Dty7Vi7WiJbbUClrbIOkIyttiBwk9gmIXh7fJOm2regtqCCeghU4lApBZf8AHQ0hLJjgNtJIT2C1Z+wyixZRZJ2sme0Sb9jZHBmmtlyI5bXBcidoQU+yPVLab5G4hIj7BKhZ/YBokxta4EkrlTdwQpxtygqUHzSmocuO8SbS5fAhDpEaejKHS4XWizgw5IbbbtIUrj08its6tSehUkkSSuVp0rSJRNpzqnCElKUvzohyTT/HZFSN6ayOSScoUqyFXH2LR4T2QSQmhw3GhJzxX2RzZXZCeUymm3yzeWUcnIkqbYY4lE/jiUJwed6IdQ6ejgwtpVxE3MW+xY20klcPwmOIwGcl1FJdraG5dnl7LRUuVBbW2tQcAsGttjaZImlRBSW5hmX7JQ2ieejkUbAnr2NpKClF6DhbXMfoSSULbHEZJKGkS7OLUv8A1HJFKCGVOTWSb2uhJs03Ge6OCLOaoh76EnLfAP6JbmMCvtjXDQ1bTfI3CSUkSRLLR07HCT7g2skp2uHsnS2OPQ3MJxz8jahLnHeQ2R7Tu/oROqNG9pDyk6aQd/n74Ittmky7E04fzMaU3V4R/kspunzciaVhrCtIcDR6mhRNrs6Ii1lv0Umpc/iY3Kabl9SeyKSaP+OB0SE0oSJMdeCyEstdBWlpbuWRcxAsPYlZJPGhkym0hqiRrWkKJx1U4FCNw9yWhJr0FpcCTShpchNBSlTEKkkRThLgNZOOhImBPdBG+C2exSTBnlLLFNwNIrbZEqbj2kRJa/4MUFk1f2VazYdCuStspaHKJR0NEQ1Lb2cMTompek3ieUJ0vHLTaGs0J6anQwUHT0/0NjhaOSEqEyuSFEpw3lDoej5E5cij4ClkPjwQTwS1wjI15f6GkoE/uEwbPD7LUmRkaaD35HZL2WRKmobTexysh09i7VQ202zSyV2bGG4DUwGnSW066tjRNOWxLQoM8tNjRWnZc/0UrsXsbVHLeuBjVJMkvsCYU5RNp1wF0Hb6G+hOVd7+5MtNU55CeRmorS2Jmm6RhyPpwawpsvp4F1M1whsOUutLgclDGZmFO+DF09Gf9FQnCYPbHQTni56HO3QmTuhpPoIkZbw4RIaSywiBD8LoRMS/OLJrWPyWMYpLIWyacVPyQqowDmlLbXqJhzJq0iBfKCIp/tMoIqqGE7QtCA2hOyY4JShysD0VI5CPCE2RTyOIws5KuLYqqWh7lE3axCsFS8w1uBMWqFKFbaXdiGqwsS/oZOk0tJDVVIFxUpR2uEhkzVWWWkhtNCiSPSGSxvc6Jul7fyQmYfzkiKVGcNJs1MrUbFtQdrkiRROsprYkkSaPgySVbkmnJDh0FpI4RGLjg9kcSGVpQYLHqsDkkB+JgGMmia7FWZsgSQuF7Yo0rSaub5FoEVI4Ej1Ctglajfsi0Umug4GJLA5bsiKf7uhSKPFp2JKzNko6QnJZ06GptmZbGptafA6JTNq2+1kJ3lVT7EkSaEm//BQsFr3EQpIWASYZBaDpcytIdLwmBQbrDyYhFClNckotwJ+g2Uo5a4JC9O04HNqS+hNhKZMm5Tr3YolWp8BITd2VhBFkYaElEkRYaNayRjJw1aX9FQT1ISSBQmy4ecyhr0NpuKmba4XI5UBAkp9k+DpVEyNJlqt7HIkiHTUw0lKnCwvXIlKstPQQmmpytNbHBLCuuwmXmiacjaOsGhQjeEkNJsi5RJFc8quiyr5A7RTk20VJGoLNTYsHEa/bEmRw1J9ip4dC6lIgck2xGOxK0nSTsGopqZSeyMielaZAx6SEubJNdDhsrO1wkLmG7foWUofEIO6NszgUM5r9wdRqKUmxN1d1hRE0MehbjmEmyobGmrXY3BOFBmilcYbGFa7FuWjNtVdLjgiMtO04IVGO5EsjNFvY6dw5ek/ItellJJKpKwwUSxNEJyWskNNVl2GmsqsX+i6tsDSRFZS2n3Ia6Qhvdu2uEtjtsTYypjY+ids1JSXdrCSWihMahqTAn1yNSm7hMGpntJ8xockmvMMOqx6R7EfF6iShOZVxw5ItzKGS1W2+BdUw3DhOKlq26G5Fw2ZsVXKn8sSjCFT5kEnn0uRKRoShcK00NIllgpy4axAowU1lJcicEmoxdxy2aVBJpNustJqmdxj5GsGVpxoRqkmeBEGWd8AoZNsWvUtdTkSWNzpOZF4jckNNSeXIlJmsKDpMrSZfslCVpXMSwaWvsNIo9XEmddrhBCCpeU4Q4NwwzBBQvRcDncWnTexTEvf7EjmiagUF4VExUcsJWWyVVcvYS20UE0nLATJFthdhJOGzXSJppWnDXoTwW1UMSjYnYdJBpl9zwJJG1g+5kQSfB0kqcyzPnkhWyihIsrA01uCE8CA0RGlsOuDGkMoStg5CqDUitVo3DXECWRcy4pnE3Zt6FaEq7bhkzbIFFCd9+xJOqieSFAE2AyIIa0gicn/sbTnBrKXY3AnWBElzgok7J/4WPFp3vj5G7SKZz1BBKaO0aGizLZ6EzR8zFHvS+EiFhtxSWRKUkNTCeJY5clgrJFZrZSZYmhKGLpwhWlwSNM8DEOR0CE7ghQchYp/Ylo7OkicyV1AxnFDteGNWXalN7DaiTSltSxiNnhl/0NtquExPCsS6ujJVI2ltM2QTyoO0tJrexpdwiSTsyKFjqdyN20JxgbTJt1JdFpMJuygaBfTjoo5bYsDLNLKMORZZYgoUl6FaTFON9vSGqznaMwVzO/ccDLSS0yRC8In/AKLkQ3LRba4EuhqR3xJGHQ9BGtBSpTymuxEpcuFjNpVDCLASYGNdxKpEbgco6nIjecM05gaSoTU5f3LNcrIt/YgulAibpLJJ8ixvoownK4OBsxcpLokWwrg8P2Ma6K2rNFaUsxPCEjqF3wUbbF6ClRpTG6aQrw8jWnDQyNcZ7SyKdiFlCJp3AUmlopEl58IaYUEm0KaLDtV+CSgThtN8lAE4ltSYN8Nv+hO1KnU8cDWGXKEhkUsXciHcGVqz8kLeW1l+xYbCSSKkoWH7IBZoTjBEXtkqOhJmiSet12WlJr4DIqZyWBRm7xC+wkpwxqSUbCYZ7Jl9DUqXL7BJQ183oemqWCz8obNVY3/4UaSJU+Sg3bUizRE7To9iawJIQlAU2nlQKSxZri2QppJjHATPAkwJju+rZ9x+SG9TNzApTU7MtA6ZW5HMzKGA0wy8Tz8jhNxV0KDK104FeQKjoQs7SylroWJzhT7FtU1MuWRL0KiPWDcSmChTy8kiNI+4NJ/kBGpaMZB9hIMkd8tyQKieK+w3IuHdJEHSpV0E7YDuGmJRmapvE9kCZTStqyG020pv+ib0j3tDaaJTHAbTUjg5c5GjJ0at0MaWsgsrOklDnkzFIsxyI1bIlLBTJSmlehYaJJ69DSWL4CSspy0JpzhvECS2DqBm2MLhkHMcsvolEn2fQ8p5zf8AodQXSypsuKZhDe+ikJb0ISG8qRZUGd/E7FEFExSbxE2tGhUgnRa6KJpJjDasV6V/5RJu/o2NTFOj+SGrDG20LIU7MaYZRlbk0ZKZSFZwU0bEfJ0kTKr4JcCsy0dCGJy1iljolsqpyqaEsPZKXeJZl3pVYrYzgmyG9Y0T64EgknCZRCJo/EdkGmS1/oHThp0lQsTaKHJQVJNWwTTW1CXQk1CGVLQm2zKb4JKb37MSEzCJ2tiQ2RmqGj5sk25orkUYaNTlmwpnoKSbZx6EpS1RHMVTSbZgbXCKNQlkqQ5bQsSgkRpuQnRJTUohnNxjyzKpek+RbdqTFIw1Poccksl6JNQajcGCRVwz8CPSwCVBFC5gcwPU0JJruU4mPsQTbeYUS0YK20PEFRusNiuXuCJHo/8AoiWXseyGmpND5CRODTbjovKZiGGOxsFb9haWhnDQrTc/ArTkw08QImKgVgIhSlIGtIXqcfAnT4ikabeDSYTwLKSWGSgmhb7EZNLVyFTaehyQTyooCNKqSoa2XM7qS6FLVF3rXsY7o5VwLOxOJxLJouHBAyassiTSpOLZJchKLYoEyZb9ElXs2JdEmkjltNf2IdNa5lzQ9k+ZzGCyo+TkdGcOz7JBk7hORbKsyLM1SdBO702mnDGjnk021O40XOo4EGrWpb/B1OEKRwNI3aaPgSys0Nq18jNkUNLRKRBy3LwKEFTPL3OSFMvFeBUuqpvjolas8skiMNLYpMIlE5SlpjkuUqw2I3O6KICcEW640kSSJtb1AnCg3IwFDyyuxm8qxftjr60t95JoOkvfyIkJzcXn4EueIl+ySU0jUYpCUiWE2jL4Hl3WVZ6kysFtHLE2TFQhcQEjzx8EzembawQixttxLBBMObZWOaIsI8SJNcnFDl7HJS2E+TyJp68J1xsTw0LbvaINhlLYmQ8FzAxJpu5feBZNKuSaU9YY241UdjkyeCHHI5IOW8somKf9BFG8x4ljos5j7GpyXQm7GlVvuPkcm2lEMJMePT9DSjQ57NaE9xM4XA2hSJ1jv0SK+kJ4aoFFSXLLgeGlLo2sfJAslNy3pDULXIDTCPt7kVk1WJQ2GreY6FMtsHllVEnjcDJeQBIttegpZiVUWyG5ijSBodrWlyJR2tuPQySGL9BZCb2slJyHtl7AKT74YmTK84bb+RUm3lT2JcwZfsmTuwh8FBkWlvo3KSeZCG3aZRy9CTcbV0EbgpMzwOXDMnbnjobpM2wWQk5IsaagklkT2xNEpaoamLJlapJezyKDq9MMVAmXJJFCwGy2oVJy7E9lbSIRbXs+D0KcVu4rXZZV2RDS5FcqbNcYJNJvRQiYnV8niSUeY5b59iue3QnPIoZuIlMZIPETpyTOJJKU8TAkk6bSlz0SmcpcENSQo5v0ShcSDRwpuiCLVLlpDJDltDIVqZTWikNDg9/6hJISrM32QpnAKvK9J9dCtCieWSROCwtjCYsnO9A4xCr5DTcxRUQGlIObHRiHbPQ3TusSwJktmx20ysP3gcqVaT7JM1bWD5EU2yndSJQkpRLPwJM4kx0JKgklIt8DWtL/ACaklyPFRc9lujVAbbSJJlDTYbdOOuhpSJbtMqgnbZOFQsvY1DTlUOXslNDUSi+XkiGCWPoJSYoT7ihltLYmkSVVHJDaGm7JcMibKUa/scDSpIyJcUiXFU4V6E4TZdHF4FLJz4NDqQlO22hxDJ7bf9FFKG3L74ZCdvBqTCaq3VSEkzZxzIzab0VpyNBrayQrcNylBRGVTHBDRCUqBJZY1oShSreOKBxbufgRTOxmE0lllOPgllpll2IchXPcy8zHdBM26i4wxSUrlVyK9d6Ys4VVCgbwVrfoRtMyyvQ2aSk2X0huygmz3+NDUDUvJsbhhKrPF8CkSNISEEmUGycoh5FN0TrknEQgUqWL0kTcLvDFOx5G3DUDQok0pIZtEoVPWxqT+V3UFy3ZahDlNJZAJSTY+wklGKdEg2P6EKtqpLRNTKRCbD6qrEUWc45+BMzJpTu9Ehc6H+xYXLa8D0WUrjgnCdLdOLHKEmElCKwjsQStKbGxypZZlqRps7VUhS2Xyy6MtySthjMa18EBocLSJq6ZwjWdJsjsbRSIaX+htTiKFBJs5eTCgczTv4H/2gAIAQIDAT8QaEwx0OjFCEJSZ8TI8DGtjDodMdMwbgXC8WyZJlULlmA1UjMWYMEygXAhXRlQW0TKHyakdWOrHWCYagyMMSjwXAk0WzKKD2NmxIswxqGTFClUJiehCgJklNDdSzkNbG2NwRDMMwxU4FmCBXktjcBS7Y4gSpGvGDBOAuBcCuhKUWyZHd+HVmLHXg6ZMMiGMLgV0KWjKMJM2ctjcWTDMMbgVUMLgSFagalDcoblISpHyNwOjIdMw4EobRECUisfJMo7G6GMYqMMygS0cBXREmSZHiR8j5KWOjBEh0JR4I4EUaNeXIdX4dEQxnQnrwkoXJk7Ox8jZAwx8FzBEE6EpG6F4nZ2dnY2Ox0dC4E9CUliJsmRkHZ2Z8vJInoTERPhDHRPiY8NiJ8LHjR34fI6ckNZMDqj2eyDoyOzR2TN+cGDFeYmvGTJM34xfiSI9DoxR0dDU0KxWNSTNnZ2dj50J/AmC0RZNwU3Akm6M+yxMkzY+R8mTHopGKIYZwZFwRNFhqTR2TsmpJkoUMCY3oami34ZG5sXI3F+JIgdGKHVeIkUMVkSZvxJ2P8ABgwWqEtHRmjLFfsiciY7HiTsZMGMGCIpnTFmCNeRYk7M2NbIkwTBGiNHRGjrwmTs7OzsmCIHREeYFYrIkyp8Ts7GyfgYMURFGHBEuCJZkySdjWzsmLJgtGPRg6OhKyJEEpJkdWKBEWR4diHR0ZoiSJGFyRsdWJbJ8TBGjo6ImvET4aIOzFjooYHwPjw+CJMnZnzMCMGDH0ZY7FZMkeI8tydDXjJLZMlnogjzJHJ7LeSJ+ifCG4Fjz7IEoMkyTOMmBOS9Ex6HXoxgShHR0J68QMmSODOCItEjcDoWCTUHXhsbklvx6GuCF4chxGOw+y3kwT9yfuLwSShw8pj4ZGmJQQRJP3I8LonxgwLwnrxgz4jg9EcCsbgRCxBBoXBEDfgn5fR2vNlEFRZL2R4/fm/EwLHnogiPogXjBA6MeevoZHHiL8NwJMfiSZIgyRA5+iDPhE2R4gYhiGIfjA0JEHQ+BD/JJ5JgXhrfhkx4Q39DJJNC/jjzH0SR4kRI7Ik7H4iBOBKDA1ydGaM0UzJnBTs34wOhUYIOiNESZFY7snZ2YswRBitEJULg6ImjNEJkSZszZ2KE5FQ0EQjCOiIojQ1odjU2O3JOx+ICoiPB8MWIImjNFiw5YHJyK0kQ5IgwJwiYJijgTrxkyZsb2LkjZgiDFIiK85omaFZkamxOb8LkTgaDCJSVC4OjoamiJMnZuTs78IeQ1pkwoFdEzRn2WyJM2ZZgx5OhnRqCBKTLOQ3s7I2YIg4ERXnoma4MjszZmzsjYnBMDojROiNEaOiJoiR2di5GtkbJEE4OhoVUfsabyO/MHZMCoXgiDo6OiNeTs7OyY8jowdEQZomaMmbMufD58YIg6MEC48sz9MwKhV4aI0RA1Ikju0MfiR0KhC8RPiA7LDux+JsSgfIVCUURBEoyjIxjJ+xhyRDkVMiBcC4OinRmjJYx5kbNySKmYYlDELg6EpoakyqGptDb0ctG5RMMwKmLgXB0RNeIgOzkNbGRZhiUOxchIFqPQuXRDY1KGNvJ+A3DkcGKDJjwuPDujKjxEk7JkaCsiYqZjIlDGI0RoSmiBqUNbF2QTI3DGEr8ExYgiaNR4ZOQ1NjyPJMMajwSgjRiiJRlGUN0hiDcipyOnJjxPhFOjXix+HR2iRKGzAlDEx8eFY7VkyvDQcvLpmCIIjyanwyNSPk7LyZMMajxOjoiBYNDwNSO1I+Ts7JJgwQQR5kz4aHyRsmDHjBHl2hY8u78MwzBgp5yZ8NSPQNDZEED4IEJSZNeIGMdjcGDAsiUCEhWZJEMZsdDp9CzGhcCU0NyIVomhqUNz7GhhuCIDp2foXXguGRKgTGpRqR4kb2NsaGyBGhcCQuBKMoZoeDvwsOiYIh9G+hITyTRI1sa2JsgagcGLTQlpCRwYpE5Xg2mi/sn7j5DZEMiGR9hIY7ESZHQuJNSPkaLHkeRIds6F4FgVobo0PEj5HyWMMyIIsgXhCwSLkY+R5HREP6Ykz4eD9jkY6GoZkRHheCGzJ2TI2MdmCLN+JEo8okmTQ1Q+SZH4kahmx+IkpmUJ+CGfDceJ0dCQvESiRjVD+h5H4QhCwa8T5mPGPKQhiUmTQxsZayYMCojQ+DJkyZJkbhSYMDodYI0e/KUisVjuyNonfjF+Zg6OhImTJEk7OztHZiyYJgwYo6JihWKWZXZMqdnY3sWJJizHomDFEQRDgfBM0ZMmSZsbizFjr0NR6KYMOCtlnR0NIrM2dkj5OzBgmB1R0QKyELGfDkiOCIssoaCdHA4CE5MOxYnZeSaNSSVkx6MGBOBqCRX5HyJ1I3smLMeExgxRECHwdDYibNSdi58dmDHg+CPGfDJPi9C8SSYMUdHREilmV2LEi5HyPk7Jgx56OiCZG5FSRvZMoWBOCIJhmDBhwbgd0RJM+D8IOySPPQ+CYMjsyZM+MX4x568JGTJI7Hyh8+J8P6UyZMk0Z8YIjxM5UEc+I+4zJ6PR6PX0MoiMnsvfiJ8eiOCtH6Fd+YqzVi7L2LPiGdoyJR5a+xUEkaIWGJaH+SJyLI80eiKovfj9Ex6FGCOT9mPZ+zJnB6I48R4QzJEZPZbyTJ+xJinQ0j0OvR3oz68+yOS9+bE/CT8x9iBkDFqIIbETZL0TFimSvgaMTgrfhfiTJLeD0KB+H0L8D/AoeSIyfvzEnZ6IKGd6J+3n34XvzeiV9MeYRfj9i8rxZH2Jn0R5n6YgmcfQ0THj2LsZ+z9n7IejLoz5WPO/o/Zvw+iOPpcfQx/kfiJx9CGIfjrw+/oQ/p9jZBbMickcEbFJEGPPvxE0Ox2RJ2LoxaMGCII0VjzE1syZIk7H0TBiyIIgVUJRTPZ0yG3DIk7Mj5ZG/GPDHo/RReDpjxBE0ZY1InJHBG0Jx6MGBqPHR0NTQ7LZEnZ2huLRixODHogjTIa8RNbIkyQ2dnooRFkQYFRqGdM6M0ZMnI7YlsiyIGoPwPwKLwdMl4YnJJnIsdohZMeRqF46FwRNDhjsydnZizBgx6II0RBkzRElMz47G4MGDBS+jNeYOyJFkdeER6P0SsHR0dHREkbHZ2dmSYMD8EUIwRJEkSZs7OyTBECcIwSRoXBHhOzNjey8o7JgtGMGPCx4d0Z8QSR4wY8odC4NwQZEPnwyYMGPHvzEjsbnwuRuxioiBBKfMQRJkSkamxmzDkWRUR4QoggiSJHyMeZI2YIgVC4FwaNEGR2hIDHyZZixUxUKhVQuDogdBofIxKbJsbgiCIEgR0RRgyjIlI3syHkw5MGPJGoNQQZHsN7HmSN+GoEFwJeYoyO0NSNeEYsVMSg4HROjoUkJI1PkjZlkwYYnDGjw8CagmEJSjKEpLWMfJMicMwQdC4OiKMmTNjHnxI/AheIrxEmTKH5w5FTFQkEnRBoifDY+SJZEEufDcHRECHwLgiR2vKDvxPiYEvEQSRUDaZ7GosZFmzfhOBIXA+Ppa8PkyMx4SFwLBoyheI8R42Ojoa8sgdoyRweiTAnAlBQkQZ8QZI2PnwmNQYIFM+PZBkyLAix9DQ6FQgSgjkSUa8SdiHoa4O9EQNCmTpi7EppmfZcCx2RsZeUPox6MPoSh9CUuhQI/J+HZE2OrZ6J+w/sMeisCTkyQsMhsiTKNdneyR6Gh1gSEIexKTXlRkY+vEtMpECmYJ0LhiumRPs/Z+xJ5ZyOx9GPRh9CpiUeSJ8GZJqRbDhfgokpGCsIgR0RKMmTR3s9l6GhrwvBCUidfUZMMpECdmBNPJLBEoyJV2P8+Oxsw5NjVj8dCCUjDcoyhzsdC5G4IgZKWB+FwxDJknwkTJMEX4/XhDyZMiGPBBkZgg30OBKM+CnxkbF4ZsmWR5Yl4iTI3PiBcmMjomCY8deFZkyPw6U+HQ3BgiDoSkVmTJMkbJnAl4iCYJgfDFwIgyKyJvxMWNVI6swY9EEwYcES4MjUmTJOzs7HY6HQ6HTgi4ImhKRL7B2d+XSkwOhuB0yIcM6IhisyKxuRKjJBgwYJgYnrxEmRX5kSmxqLHTMC4N+M0ZMmfDezNkbNDQUJgxREOBrXkyTI1s78nRhnAjQ3FCcCkxSJkU/EyLYswSE4HVHQyJMiU+GSRsaizBj6M0NSKzInJOzsbqSYUmLIjw6J0dEGRjA7HyTsnYkY89HXixkjw5EbKDpGCB8HR0RPgnPk7GtiYh146OjoiDJksjxoXJixiUV4nRijNCUmRkeGdmTBZKJgnkn7mSRdHohaHGjBgwQRyeyfojjzMGDHjocbJ5PY5Eh2eiOCJGhcjcH6IPZ7PfmRBnHj0NEwRBEehGCVsvZE+I4yeiOPDowY9CUEXY+yefH78+hkwKr8fonSG+SZyRz4S87rxHjBHj2RyRyX4akXJ6HEC8NwQP8AAuiIJ+h9ZLeCLrw3Bgx6EkNLZOvLX3IfiPFBCR+JQlbOD8wZ89j5ExuCGVonkv6Mi58rwxODHolE+f2Qn7GTB2dkkEEx52M9+MHZP0MX4J1oXh/k9/WxkeZMeH/BPhfREkknfhED8IkZJkyxuREvQqwYMFIjXjIrGOyJM2TwevGDBA/DZmiJGpMiydoUZG4FRhGDo6Ojrxn2ZsyZcjq0UjHox6Hxrw+CCNESZ9mbG5IMYEoMCoUIiK8RNGTI78dk3R6JMGBrgR0PjxkiSWxHaFTkmDBgxREV5gyZ9mbOxGB14Y9H6FGBqiJEtESZMuSZIhnaOhEGCkJaHVETRE+y2ZJ2dkzgobjxgaEdDeiZotlssNYtkITlFSYJgmBcEecmTNnfh0OhUUOtC4Ojoia8RIx2Xlm5HGSYMGDoVE+MkC9+e/MwY8TNHR0RBkSlk7HydjFRAo8PJMnRknz2djcmPOCPHXjPiDsbscEmDA6E5Xljcjhj5G9j5HbJgTgkQjJkyRJkakdjHmRUKjBgRFGaInw7GN2bkkdMSgVCOAuBcDujKMjuzNm5MOTBEFCIoSoS0ZUGV4ci1jiZGbMCoVCWhETREoiSJGHZyMpGrkVGBVQloSjUETREjLDHkdmBqQqIgRw85oyRPhmyLkxZgSgVUJaIqDQRUDUodiTZazkZSPJgSgTiilC4OiJoyRK8HdjTY3IlYmYMGKOBEqDUEEyjI+Rh2x0OxMCcC0FoLQTJklMmV4O7IuSSIIg4C4FiCIFY7MomUTKORuTckwzDHR0dER4iaNGhoiCNm5GyjFRwOBAxISlEh8nI3I8yTH0DogZArH4Y+TskiGRAlAhGTKJGUPw3J2SYY68dEGx3Ro0NjMMwW2YMHAV0ZEJk+GN7NkQRBECVnsVisyZMjGJcox4fgnyLhiU5NE0RA3Q1NjHyK2bJgiGMgQ1JoiTQ1Q2NEQyIfhjceCU0K6Rog/ZAmyllGNQ+hwfQlDEhCU+GjKOx4kfI1tDp0RYxIsXDIbUeNCUe/oR4RgROhCIkkiRYKF0IRBEMSY1A8+C2JYD78a7I2Pk5DdkQUYkJWJCELBEomSB8kbRMeHkWfC8RCNCGxjext+SjJsn6deexj8IeTY15ZlEyPAmxNkXJMs2bFnyMRQ1I7Gx8jN+JhmH42QLw1JoQxliY+lCQzRHhodkeNmzf0tGTsS2NbIgmDDMHQyZMmSZssIkwyYJJgmCdCYhORWTJPjFmBoMDoiKNwbgVisz47Ox8jVyMwTBMUNaFwLwyO7JlSTsmLG4GotEwcDFGHA7ozQrRkdk7JqSdjUWYIgtEQYoXAhCxMompNSYsdWUfhEMaijZ0JSKzPjRqfCS5GQTBhwRFC4FwYCsyhcnZ2UISsyHRiiIodCuiJMDskipJizFkx4OiNEa8F4EJlE0ak7HVmGYIgiK8ToSkVmfoZkYIG4MUJRQuBPRMkyTJzE9k7J2LkmCIEtEQSLgmDJk5EzZB2TBAmCYY1cG4GJSTI7s5GAuRqReGDo6HwJGfDI7Ox8+MCcGDDOjofBBkmBJMjR34mCDojwuDBkyZsmfMmBSsjobkZ0T4z4kz4kcki7JZJWBEyTJMnrxJgx6IjxOmfsk2TJkmfPYiY9Ex6KVMiD2Q/oGcEE7JnxMIiDBInXjBkdnZ2NbMll6wTBEZOh0xw3GzJMk7M2RGCskwYMeiPsTwTyRzkb58on6GKz9Ex6MURB78ZMmfEHYh0OhJLAw00M6JjPk7OyNjWy/gf4JgiDo3A1NET7LfiJIg7MWYMYIjxePOTJnxAvMfYwYojy7MmSZ8diY6MBeBG5wMmTJ2Z8IglfTOjNH78Kjv6MeMHQuCIJmiIMkz9b8Pg6IGRJPjsnwxeJJkXiJHZ34YvomCRktmfEiEyY8yT4mCTJkmSSeBmPEwKzp+YkyZG5PXhUYMDoSgxR0QZGhTJm2dmcDrHhMeiDGSNMbSpkvDP2OxWTNiYlckyOrFXoagT0dG4G4JWzI7Mne/CljwwSEjo6HwRJn2ZJmyDJgiCIHQqGooRjw5CsmbZ2dolGDA1RMIjQ3FGaHDHyEpsV2ZZFkyTkSkNQhMmRoyWMmTs78TBgwY8OhcD8fsz4jzgiDBBGvE+LEHZ2ZMGDBBMeH4ZBknfgvBTwkkRM0dGaIkkvfjs7MmPCIIOjo68RPiDsjYiYHSFgfnNGfKB8kz4a8Jx/DM+J+vNFh2TI3IxkipicEx4ny7HY3JlkkwTHhUJkCU0STIrREjN+HViUMWRUJCxAsQYoiRuRrIakkcmbHTMMSgaDULwuB4IlDtDszY7sfI+SR2Ew0ERQ+DoSoifY03Y7sy5M2UcmHIqGijQYozRlQRKFaGpG5sbuTY6sVMVCoSFiBYg6IkdjsTIkcmbG4Y6Eo8IgZ0JQhqTKEk5DciD5JgyJkcDo6NQRHsifY5CSO0juzFjqzHgwNRRBhQRJkfI+R5keTFmQqYqFwcPGoIkmR2NSO78YHREECI8dEURNETREjteGtj58YFQlHifCdFqFItZORazsfJMER4YE6MESh2hjJGzs7NmH4IJQaNQRCGpoiRuR8nZ2ZMGDB0Lg14agz9HZswYEIYmRPhE+D6G1kbwmJQxdkci7ET59D68zHhPkXY3IqyW1ZMkyN8Db0TscyTDMGBIXYuxCGTOR8nIczJlj9GPREGXYlyM8MT0JJoyRskQ8SSyh8jcM/QnD6IGJLZHIlOTDst7IrsSaUj5Q1NoyNmHQkZWLs7CrJDasyZQ5iRqlEITR2NdGDD6ErElsXAuDgRXZk7HOWM34wRA7dkR4dEDsaoSbG5GtoVZJa9EQKcCVs7eCTeR2hMiSKkfI08rwyMCVizAlySKSIbMoyNbGPka2NxgiDBkQJ4gifZnwx+GR43YhHRjxkeDAnIxoasackDZjJL2QRPhcWaEPkbslmXXhZjJGgoTqzKExqjkcjLIsw6GFDC4Z0Kh2TK8PAjsfljVi8RoiBj8sYx+ffhESZ8a8OhuB0TIxXQrFZn6SodDcE+J8KxWZMk7GPkmBsdEwyY8IVjSZJkmpJ8PkwTBijFGKOiJMmTCTkTUj5HVlB0NQ/HQlNCSK0WFyPk7JizFjUDDOjoSgUuhJMCJROx4keJHViFg6IhwMV+Cxkz9DpSRBg4ERR0dESK/DsiRPY3FlLKCQOvD4EprwSlGAlsfJ2YsxY6MjofB0JQZoREmiIUjxI1UjqxI8MMiKH4QlJkmTvwiCIIgwRo6OiLIkydmpOx4GiYMCcG4NwbgizJkiTsbkijJjwShkwJR9CxMoVmHg42OFkkkm4OiIEpFZkTFjx2TAkYI8dC4EvESSdmpGNkQYIgeTZsyZMkzfiBmDBgxTFwz2LxkyZwZJbK0YHXiSUYyZ9kyZFeTOD0TwJ7MEQTB0Jk2TpGSZJTLJ4J2iYJOGvEkrDEZKZk7RMk7NSJxZMehKPRMYJSpkvBC2KRIySM4HdovQlwTFjr0P8ABK2YyQlkan2fkZV+HQ7Q2O0TBH2JjH0HwRNGTJE4M2jODHifsfopFbEoMmaMnZM4J2dkxZ+j9GMHTOhHPiIM+HY1vxGzFjr0NR6OkRpkRkh7yW6Inw1J2ieBxleMejoary+CJJkyevOL8T9h+MkEkESJz4g78YIjxvrw/ET4ZMnZnwvorZ0dHQ14ydmfpbgTJ8FAQsSFLA2teZaGdeTEOzPm9eX5a89GaMmf4H2ZJM+fR6JMEk+PZnJnPjPiSZETHhEE60O6E5rxkp5Ez0SngTWhuBULAnzgnkmCZJgkz4TwVo9EwYJj0TAuCseFas/In7kRkngQ9DaXlSz4fDImmZH7Hfszeydkt4PQ3AxL7H6JQ7oTGRJnI40XorQomh0JQKkJR6KgtE+IM+PRWvCkYPwKFYZ0xyiJMlP2d7PYuilgmfLydHRCdMsP8kT7LZgmfEx4j7H6JOhcDUESZ8RweijA6LSI+3jH0ZH4fXnB+Bj14jw0IgffiNmxmB0dEeGLBE+GSfL6MY8OiPEyRBn6XyJ2SQn9AtQ3XiTPhTo7QxD8SP6KH9DMeJI+huR2OyUehrZ2MwKhfRkdmTvxJEEwJwL6W5Q3I3I4FyYsVMwYMGiKKQ7UGR2NyNm5JizYlAhAnoWIJgXA8Dsdk78PMk7E4Jgbggg68OzJMmbIsmxqPBBcD4Oh8EDcpeCw4ybMOROGYFQ/EGB2oMkT4GzcmLMGGUEoXjo6ImhqVfgSbNybNyTFkwSMEURUC4GRI7Q1kRNm5JhjUEBULgjRGjoiUNz4GQhDQsmDHmCIQ7UESZGpJM2Pw6FQkMmoIGqM0RIkmTs78JQQIER51AlNeYm/HY3LHXgqIjx0dGBElh2NXJ2RvxjwXAlo6OiNEz4Li2MhyJMGCI8syZHYrO/LcEQY+jo6IgagY5Gx5G58rsx9MDXHiZ9Ex4lJ2JGfCCcoyMZeifDBgVMT2wIbkfGyK7Mrsmp2PEsb4E4PQyY9DcehQqF4NNGAh4M+xvY2x8saGMknTEeyWhOUI7J2N7HLwTDJklJ0YYmpEuxPRwEpRNH7HgvQ+SxEejDoVMVMXlEoz4eKGdDYzD6MeiCcMU7MCxgIxZqTUnMeZ0NfQ1D6JnwlEiemYVkyiHAkPk7HbHKZMuh0zBuxZsUiSfioIrsaogiRrweROBSmJR4R50Q9+J68MwNC7IEWQxYFgeDoPlDh48YY1HrwhER4gaoaoY/Ox/grXhDNfRRI0jkbkmX49CR7F4R+xDI48NwRZFjH4kQYmRuV4Mfhjf1wNQPw1BQaMOBokViUmfGUTIh8+GoMDo68ZFeRWK/HYuRjQ3AqMOCbFTFfhBkmTUjGYsbgdMxRWBOxqRDJJFE7M2J7G4G4HQ6cGBPRwFZkyTsdqx0PkbKeOiRMV0K8isVo7HhMfJyE2N2NQzoasThici4IlGUZ8PnwdWOiIMUbhCVkCQyTKIlC5OzsmLGgoO0GHAqGkTwiUakeBLZyG9+Bq4HwJaEraIminkUhWdmpFyMfI2RZ0RcEWJ6IIkyO/HY78OiIZEV4aIFYvDUic340OrHQ6NwbgeYFwJaFYiJFfh+MWYIHRuB8EESIZowIGzBgnRsgQnoiSPBEVIxVfhrwfAh+MjsipI2Pw/ChJI3YmK6FYrInyx0RBDWTDMDRfhuTJE+W+BKPCryxxgh7HZEkyJcDW/GCfsYE4yLxElGTJ2eiODsmjHomDGTFMjT8dEt5JGTsfIqOxtIVGMHR0KjJMmTJO/DfAnBEGCTofY7piv2OxOST0PkyYsn7HQmKZ0Pgia8SMk+ESTBgn4EwYoiKM0O6Ff0MWRFkTY8CopiYHVEQzLJ8HZ2djcsTgiCg1BOjo6IuBjPiOBra8YsmPQ1BMEaOjNESZFZPiPGCGvDBEV5p0RJnxHjJEE+DTQydHR0QZGyNmSPEkwKvPR0QiJyOyJLFZ8TBggiCTogRFjsydkbMWYswYIjw+CBqTI2IYhiH5jRGjohkz4yMSTJMGBV4RyTJkyZI+jBg6GNTXhKTInP0Mx4wQRB7I5MsiRc+J4PQhuDHiRcPxNmTJMnbFyjtFGB8C0RrROhvR7JkzZOzsmcjJJMDrw+EPgkVDeE8nrxP2JgwKhswj2RyZMmRtZJ4K8YMeGFGH4nRE+Jk7OztEyYKWBOMiUDeiJoanJn2RInNjaeMizf0TA1BZM0jox7LLC5G5L0RwTJgj6YkyZMjsvRWvqUYfhvRBHiCNnorw0JeOjo6HXmX5jfjBggggm4+mfCYzB0R56Hg/ZHJnxGyZHRggdD4EhvREmTI8CwNDF4eBKSNHR0R5gmRYGvDFXmSlGTI7MkTZiykYMfRmiRmTJmzFkw5HKwRBgwLQxXhWjI7GpZ347IizDMGBQoXBGhXQ1KJkbkexuRU5FQqFRggajxBModmSJM2NbKmR0YFR0KqFagmaMjsdod34mGYJaJjAlBGhuKNE0QZHY7vxizFmBODQkKjJMjsmTI7sbmzsVFBUYOjBMkeDsyTJmzDkpMSXgxREULEHQsQNSO7HsPk3JMWTBgwOhaGoNQaggyjkPk7HVkRZgVCXh8GaJmh2TJ2Ox3ZizBEGDBBGjo0QK6GpHdiux8mLMCCEQaggRE0RI7Hycjs78NBjgR4aleGfDsjZ2OGRHhgnAdBcETRlQJSZOzsfJ2Kx0TBA6OjoSLDsbkSHyPkkVCoXnKJI8GuBspZhjpiUMXYkxcGo2RCEK/EDG+BwsGBUxUIRFQIyevDTePDmTBhipkMQuDoagSnw8SPlDsaguRUxJyIXAuBIiEZFaGOdeHTkwzYo2dhJnDY+NkR7Jn6Bj/BRyTDFTFXgvGUNyPAnIx48J2RA6YqFwJEa8QRPjQ+hqX0NWZJhipiYwiIGjKFY3I+hxodOR05JhiUNljgcDUEV2LAlKG5GIQbHkmGKwvDgQK0SNUvCTglN0bHTMOvBqBeWZ8QPksxqGZJgSvwuBKDKIhGieR/QHkaIgdOxJ7NkLgflxAg+R8mzDHYiBcC4GhIcvZDfhDl9EX5RqCCJ9mSKQ2IWH+DdG/GyBDGSMfhmQ0YMCUeC4GvDHECCDoiGdCcCWhISkz4d+GvFLGosdGPC4GkSkmTRMjRoaHRQmzDI14iaFZEmjCOzsdWUHKMMmDFEk6FbgV0RJqR4keJGYswJQOhUxKKEixnw7szY8SPkbGkmOjFCUV4cCJHZEmhI7Ox1Y6seSAxESLGV5wdjGxyjfnoTFdCUmRDUjexmLG4HRuBUxcCCvw5DuydidSLkaBwJhkwzJo4DXAlJkVjcjVIeJHybkYwzIfB0PgSFfiPDHyNyOhonxNkisVmUakXI2MdWOrMEWZcHQ1BwM0JSIOx2p8EG4MDsPg6OiIEpMBYGpMJOx1Y0YMERQswJxXhEmTKMiWx34OvIqY6oShkSRJEmTInPjBGzBBBGhLxE0ZM+Ox4kfI2OjBEUeyHgiaM0ZMkyYwJzY6E9mB0NxQ0lTLwyJM+MmSIJ2YswQkJRRHjoyOzJk7I2T4xZgiCB8HRGhKTJE4yPk78KSIEgbgxRWGWRNGTJEkyOrROyIJWjA6HQ+DplujNCQ3NkyRFnZizBECojRMHRkyOWZGRvxgx4wb8SpggyZFZM2/D5J2YGJjWj2LgamjJk7Ex0/CI9Caz5HwPgbijgRJMmbJm/GLFVlowYOjo6I8jvwmTPjFmDH0QK/GfHY1sRi/FIwYOidDIkQdmSB8mEYI8dEeJMkz4akyIkiCYOjo6OhqTJkyQdkTY6MGPC4FwNaI8NT4dkLIh0Q0MwdHR0IalkjvxB2MVEEznwgSkvwo8ujAvPR78Z8MQsDMeJgjxBPjIr8Qh8nZPjXnorDP2RJE2OBZHHnHh5J5MZIn2QRPhDjfnBSx4rHn2bHfsz7M+I8WSJec0SYMlsyQvE/V7EejJEkyWyELzA/GBHsd+/NEEz4whZg6HwTomDvY79k/cc78QZMeiZ8R46FwPxbJn6MfRJj6cnorX1sXBEeMjNURtecDoSY42Xs6Ij6I2T9GCI8xHmj3/ABRBOjoS+o+CPED4I+qPC8YI8MjQ2EpMk7GNbJMCoiBV56MmSJHfh0YwKmYI8T4RAlJEmbFydolGBUYHwdHQ0nREmTJE2WMOTGTDoSgwRo6I0NSoMkSZFyPka2SYMEQrEtDGPgyWyJ8MjUGCIsbggiiTROhqTJkydjJ8NBgZ14iaIkyZIkTIsUqzoJQYOjrxmiSNESK78OyYMCEwdHR0Zoz4dkTZNyPkmLJgwRXhPR0QOxDJM2dnZMCQ0CofHmJoyZRkyWIuSIsVFBV4nXmDJkbkizs7JWfJMURoxR0Qn7LESZSZcnZE+HQlBgiDJGiJozRkzZ2bkfPjHh0dHR0RNE6IkiTNjzJ2Nx4YHQlHh3RE+GRuRIb2TsnyTFHR0dC8jnKHyhlLMEJCC7EZoyO1YrwOxjXhvwmhKCOfEEeIkeKGb8bFkXYkHwI4CUqCJIlDtSW7IgyHkxZMOzBShQJDUsz7IYyht5Q+UNJSzA0kJNMXDF+SJoiaHaEGQND5MeiBO6EpELfhLRGiIEpQ+UPk7NjyJWKs+DoQXBEqCJ8OII8MckCpmBCKIiTJEkSO7Q+UMaDDI5MMXB0j2R4IOx4Xg5nomPRF9GMCC5HTIEoGLA8eG/G6E5fiIcDEcDoiUakaTM2QPJHhUzAhcCRnxoePB8kbIuSk5MMiDpi4Ig1YiJGJGMjZE+hwMGCILURREoTkWBjZsauR8kSYYqIivDoSn2dsavCxQ0tC7NmBKyYEooSIhC/I8CwRFjIIsiLNiR0zojy1JlEbHAdGGRAqcHRArEpEpFjwh9jGzBAxZEJTkSCsVo0JeGYGgwU8ldCSa8W141JSzBEGDFERRDbgSnwhqbG6k7HyNTZQwyIFYiKFmBKaEpIlGjsXI/BpFQ7dEKRKxCsVjtGUa8PkfIxqGOqIjwrGkyZI8wWGJQQOiIoWRIXgrQ3UnY6vwUMPwwJQbFqFYkFiR2hIfJyGizIiGZcDUC8EpFQVoz4jxgqTFEQxvwV0Z8RXl48MEeJgxR0IT4iTKNDOxuLHQsk2bg6EvESZJrwkPkfnZuCDgJQLHleT2EPJMMi4GvDYREj5JnxGzs75INk6EoEUQlJgKxYGjsdWNwRDNjzB0JeFgeBY8EPw5WTHjFeEhKTJnHhogaHPwRHiI8UdGSJMjhjfHjF+MEQRowUImhCcshvBnBkTmzFkR6PwMF4OmWN6MmTI2TUkxY6ENx6J0MnR0Lg4GSZwN7O/DGMejGDFHRHB0ZoakifZTyTtFZMWYMGDowQOxX4M4InBm0dkP48Y9GCI89CFZk7LyhRkbghobj0UjBijofAlfknZmzsfI32H9hikQ1Q0K6HdcGTJEkp2PoomDBhkQdGCIHdESKxkiVRM2dl58TB0PjzgVmTPjReUdrxizBQWYOh8HQvBk1R68YIjxMHQ+DoiaJnydj5I34xZA3Bih5gfBE0xOaM5ImyZsh5Q40TBgTgiCR8C4IgSkVjwJEOKElkyOrEYI0dCQ78jco0RsRgS8eyOSPuRPiPuJM9HrzHmORjXiJ8XB6GuDBA/C8Vs/fj9iL0eiIwN+P0fonnApZjJ78SeyeD0LohaIMCv0dB9i7P2fs/Zci6E+BvaJ4LWSYJk6I5H5Z+yKs9EcGPCBE+H2fs/Zs/ZZHB2ifob58TyX4RR6PQuj0R4X4M0QlkXZ+xX7Jl9li6EtjsTwS16IWiROSEskqnw8ij5HO/CnQ0WfoYibjx7P2KZsZJL14UaP0P8HrwujHmj34U6F0Lz+vLUD8Ufsl+IJ86NHRHnY/yQ8slvHhWifpY/H7P2exWkfi9Fa8dEQSI/Z+xeGqFOivpiRqPP7P2Lvw1skRgahCXllh4gzgzZizGBKGKjBEEeHIijIlI7OzJEGPECeEEDQ1Jkggi58YHQlAvCdFOiE8FP2ZG5wTJeiUrE4MChEVeBDod0y1bL2RJyR2YsdYFwKQ6IivETRmh2uzIlJTs7M4IMGCY9GCDoggdjcnfmSYMeiI8PxE0KzJEkyTI0hVZhjlCUYIhCevDSdMma2Z9kTkmbQmnaJhyOrKOTBMCgVg1BEqBdjUiUsexNyOzkLYbazgrHh0Pg6Ikz4dj5FyTBIdEfYkY3ozQrI+XmZvxMGB0Y89EGaM0RJkWxmzsiTHhECUV46ImhqROSNkGRkEjER9LU+TsTMpJgiCY8Igkgd0TIlNGRuR8kTfiWmUiBHREGaM0RJEnZ2dkSzBgmBKPD4ImhqR2NTgaI8R4VEeHiCW/DQ1wO7HdmyDswYyQ0JeIIgVoiVY0NDQ14iCgkdEER7IkyRKG58JHaG4FTEi2fDoa5ISHaMjsR5Qlslq9G6HQqF4eKFJWPA7Q7wNyJ5mDDG4Fx4TKIgmiKHaHydj5HkdswxKMi48dGiJyTJlDc+Nm/DoSLZEaERVkJIalDCSPkY7S8HobgobI6GqgUkaHhCT4HyLk3OiYZkNxQlHhmiagmjI7Q+TsfI8yTLFTEHD6Ljy/OzJggTEoJL8RQ3I1JKZ2dk2NwJAgiagiESR4ak7GPIhkmBC4NQJQRP0GMlaGEgSBC4IgYl4ehkHYnIjAnFCQJCxBqCJQjQuTs3JsbgSBLwmaIhGoIoWBj8MYGrGIXYkVsQRFEDGpwOhkR4iBVkS8QZ8whjUkwYNm/ETkVi8Gtj5IGx1gbgYlFCehLkSjJbyQmrFa7MJZ2Rtlr8KsG4NwLMaFGBSJ5MDI8DHySeB1aGzBZsUbFZlDtGUaFSOxjsbhmPCV0JQJTkRtQZRMixI4gZI6wOEzAlFC4FywLhkSoZEmUTQ8SPkTZMD4EWMTzAowxOSZ8W5NCwPkaRLnwRDgm+h8ISBKTJEowMmDs7GtkwzDGrEpZECjYroRlGiKOx1Y6wUnQ1BEUhCKbF4iTJlEQd+W4HYWYGrEjoSFgciTUkyNbJawUIgyPg4CXgk+CcjsdHZyGp8ZZl4fXnXjQ+RmLMMdiL6E7cCoTEpFZgYHYuSZ8IloVqHx4nQlArHaMIXk2NQYIgagf0R4a8RBjxEeIivEGRkSLyh0NwYI89ECmK/MxZhEwTBgwRFEaZE0S3QrMi5I2J1LFZgaEJwYojR14jRh32aRmk/L/AEhM/wCn+hhvmcfsSstKMGBV4YMD4HZkVmRpvyiYJgiCIrzmjJkz47MKSIUmDBgwRFHRmhXQ7HYuTsmVIjFjQiYIiiNEaGpoV+ESZs7JkxY3kKvDBFwNxRstQrGOzseJ8TBgiCIrw3JEkz4ZOzs1JhSYMGDBEEkGTPlnYuSTBEGDB0dGaInwamyciZs0JwRkTBEE6Oh8EaMkySM2dmRuPCI89HXiJ8OzsnZmySYIjxJ0PgiTIhJA+Rck7HQSjwwdHRE1wKzJk5EyQSYJgjkZ7I5M+GR/BWyS9+fRC+h/RP02N7QnI6IgY/LGIZEoyTOS0qKRgwQTHhW/CxxBO/8ACc7+PuSUxcU/7+7G5z9DmXJ9OClh9p/f/aE1r4ef+eidD4JWC9jGz0Qp8ZNCP0foSGNeKIn2XgPlCJgiBsf4KeCIofHloiUJCJyJCwYMEGPBD7ENSXsWBolvBKWDHi94FGvG4MDZXyOdn7I2zs78/on7DQrEo8UKdmLQ+UTx5n7D89fRGiSERRJMED/iYvGxx/iD/J+xEfToQzXhPROiI8wT4zfn9CawRHlfn6H42MZJI2ngyJSOydj8OvGDHnNeHZkkyTHjA6FRA68RydDsyZsmbGMVCowPoghYfjgZyOyJM2WrRjw5Rj0RFCjB7HgfBn2ZY4shL/ldjtp6eff+sfwvUyGhUHQ9aP3/ALHZCeCZO/KQagiCNEHRC2RNDsmXJmyZcnImPBgtHWiEdHRw2VkRJyM2RsxYqMIj7EVGhRhnTHx4ZyRLJkV2dj58MBKPQ6rQlFHRE0RI3I1PslsmbJuR88iQaCDWjUHRGiJrymbOzsTgULwtEaOjo6GZIkzZM34wYHSIj0STUeJ0Z8MmTsWZOzsmGYMEQPxOjNGSZNj5OyRBUQYGhGaMjDIuTs7Jj6BEeIFocCJ9kPL8dk8ExgYx4RCJOiIERokgWZOx8kjomCBkmKMlh2NjsefGCYEIXjPjI7H9CFQqOhHREjsyZHY7fjZEGCYMUdEDVEyKGpHZefE2KUyhMHQkRoSjxgOxsbCRhAmFx/3y/wCRkp1bf2/r7D5GZSOnIqYqEgSihLQsQWRlCc+DU2NL8OiIEOh8GjQ8CcB2h2ZsmbOybFKYqFwYELAhWh0GGHyPJMOTIVjgcBYgSlQZoyjKHY3NmUmUjcOTDMmNAlFHA1BFDUoyZOywxqCIYh0dD4OiYoViQIkzfmYZbCsKhKKJFiCIMmUOg+Tl47JhipioVUUoXA+CKHaRp4IPk3OjcisxVQoC4FiB8eGrw8IaOxuPIghDWhQInyPk5G5JsbgQSgSCZo1BECUoXgdnI3I+RuzDFTE4owM1BFDdeGoGY+khXnxND8yT5SjyuyDJkkYyT0Oh5MFoWbEdDZpjtB2kOh8+DkmGRoYnyS8GaZE0aNFxfhjnI6f/ALnz/r/v+a4f7lz/AE/+y5GoojQksMkoSkyYGrGqQ+Sdic4HWCYY6cFqhO7F2RNeaIipG6Hz42TZiiINkGR6CFg1Y+Tl4ZGQslGJJOxTcjLDEpyJyvCN7O2djsyHTIhwPgXAuBESvCZIeR8j5JkoNw4I0WhZsXZE0PBoboaodD5GPJJEOBmXjJw8aMBDl4aUjMPw42KdmrEm8mTI7XhoaLMGGYfREUdD4EoEMyiHyYDUDbQthlyNpYIihZYjA0aNeW4IgmBk6OjHkVk0PC8O/BuH4eRuWMXhKTJPnQpZgwTBHlMkyST4NjEwNwS0TBPhLYmS2TRM2SSTsTgwNpUyPGfFsiTJM+HdmLLQ0EQRFeHdCujIrMk7Oxci5JgYxNpXrb/r5/n1JO+1tC0NqalfIlopURKssZMomEmEjkbi9GMExQ3gzcMfBE0Z8IkzZJq/C5MDhDUERQxXQroyZG5E8iZUi5JkbgVGDorDImhtEhQ7JbVixIhrY3AnFHA4GUERQ0JT4ZMod2RR2YvXiYJwOjoiaHfhkmp8HyRsxZgwNQRFHQ7oSkyZMjcqTs7Ox1ZaEMMdUZZeBKSZMDsnY3CkVWbBuPDog6FwWcceCZknxixuB+CI8dCSSZJnxJO/EQRA68M68Woz9AZMWQTvwmGYo6ImhCsnxBMWKhqDHn2MmTI34mcHoZJJJPJ7J8JMkySJjfBJJO/EoQrYiDJkkk7R2SOhoeI8deIkdlsnZlRNk7G9miY9D6JlMLHzl/6+P8CyZePjK/18DIn2WzsmR1gcZKyfo/AqIMKz2SyC/Ic5R2hxkmD8CF4XmI9kT7M+JlkXPh8kir0RB7Ifh6ETkmSJJnAlwdmXR+itfSyJ9ljsY21g7Q+TsiPRWxuoFgRE+SRs7HySTHg6/gnw3vzZHHiSPErHh2yeCvE/Q/E6+iJMnoWw9eZ8To6IgnxEidjRE/wvJJkdkkkiY39iSSZI+lPA/Gfo0O/OfHokdGB0T4bGdeJkmSZJ4KWJwJwTBQXBwE9CadCsVivxRgwYMCogfBE0ZMkSSsnbJeUNxaE4KEQdHSFwydDx6Hudtv7v/Ah5cvs/+x8kCodYE4E4wJwrMIyhDUmfZbw8iQqsxZJgVeOiToaI87kXKJgwYMeZgwGZM2NXJO0K7EyYwY8OkTog1BA7HZkIwNxZgTjAnUEQPjwx2NyZGyBIdeFQqQuB8eHiBoyN7Mm584MeV4kyZMmTNkbPRjBaKGBcHR0dDHImbJM2LkyTCEofRVDFHRE0ZMkbMkbOyYFRjwgfhqSRn2W8nZJHiYMGPozRkyTPnsXiYMeEaIivD8QOxkWNmDAqyYEtDOjI3I3I7sb2NkxZMMmCgn4RMkyJyKyZcidmBUYEoFQvHRFEVAidsmWOx3Y8yN2YYgqFVeFwdDodpqym/R3PszufZnc+zO59mZBNfwWyT+x3PszufZnc+zJcTSaeuhPgpGLOyhfsjT8aEN0NzgiR2iR8jfjH0dCFYrGZ8TBj0YHQ6G5QRFDVR4yO0N+WRQ7Q+hoVGBKBURIuyTKIk0JUNsaspg34JiRowYGJwjA/EmMkaOvOSyEhLn+BvKDPl2bkmGYY6FR0QMV14yhjkPk78KmRBShKKOiBKUMNXhGzs3JNyOxEMoRHhkCMjKE2SYcjcGCY8IdmDQ/B+HmTI3DMGDFec14akTx68NCEoEJLY5MoiSR0GNtD6JJgThjYmSSTJkkmht6J4JgwYEmn5QiKol+w58OXg+SIJgoSsSEkskSLBFDpOxttUMfKN0THo2NFoTT5EH03D4+qCEtumq39yJMkyZJ2Ns2LI1Zh2ITgfiBdCXArtDfBgwYOw68NXAjJZnwhE+FRI35T8Pr6V47JHQ3obhwbgfhIyRJ2TszZok0YopQ0TJJjJEZIjPjNGaIkVmcGfoZgZkkx4fl+H34iSRs35a8ISTyJGTQlJ6M+xdjx4fh5GIT0cCIXhYMEdj68GIfjYvKJM+IhHfiJHXlC8LBrw8IevBufDIIDTRGmKqJo0aIkvfhayOEOhjEhKSCJINDWxrY6smB0Oh8DExXRkyZ8SSLkVCcUJtCqhGaFYlIrEUOIFgdWOrGcDofB0Ji2SB2NkzZE+EwNxQ3gN6R0Kw415Ut/19SCZkn95Rkyd+M2JiL+BsfYuxKWZoWIHagmaMYHWBJIwYKwNTk6IHYx+EYGLwq8QRIvonxgixv6WMa58IQjGBDIEIiByO2RyWIQhCQ0NUNj5Q7sfQ2a8T47GNRga8KheULsiTI2SSYMERQuCPGTJkmbJOxuEY8JhkaI0deIkyRNnYuSYvRSsgwPgjQ+CIEpIMSm2TA7OyYvkdEQOh8HR0YMmSfEyaETHhBMERXh2J0OxkSTNkjJgwYydHsnzkiRrxCGMwND8SSMyT49eJiyY8Ji7F2NoMZM+IYuvP6H+CUzpnTP2Z8MjbJqj0d6FyNkx6IbuGa+FJ/wmf8ACZ/ymf8ACYohhzb/AOh6bLeX9U1of79ieXP5/wBn/CYv/SP+Ex4VSc86Tf8AQmJ6NwNwTz4RRlGh4G4xkwKqZhQx8GaHdDsdjsefGBUKjBjJjy1K8vomR+IFREHXhceGqMkckcjRsk9E8CoijFeFwJEckzkeBk734Svwr8T4nw6HQ8j8PMjzQ80YZgVfSxKUOxjZHhkTnxGiI8vxH0TBHmIEfsakQ784smCD9HrzkySej0RsnxMEcD8tn7Pf0rkkQuvLZ0Kh+GIaJ8IefEjJMmT0ej0PyxpD8NDsz7Jkdjuxvgrxjz7OmIVih+xKRecGDAlRCgrfhwj9kffwb2Ock8ER6JIgxRQaWzoWn/lD/wAH/gdiToWDPsabtj2M2LkfKHV+ElsmrMqzUbGh0pInwY1wOZFEnsXfiysV5Mkeb+hU7PZjIlyKxCQjoY1Jmx3a8NRYhKCCdDXPh2jQ7HZuR8oamz0RIlOCeBtQaEn5boVeIHVmXhU/HYQuxeNDPQw0YMeGp+i9l6+mI8zozRkTnw0RBnAh/glIiK8PgwhaeYOxzlErxgx4eyOTodESMh7OyfGfDcC+iJMivxexoTH4fidHXjNDSO0ZJOyJJKER4aGhwNDsdjseZHyN3PjAlAqFQjojQhKRWNsRgwYFRiiNeM+JCSOxvZhyQOnI2EJwKqOjFDtRsk/+NT/wf+B2LeyPuKkTtD5RCRzI1OBi7wJyfYZFSJ2dk7GohlB0Q143Ardi7MkDXiaHS8MaBKDZHJnIryKxWhodo7IeT14Rwej9CUMixdieMojfhjWx3jxh0bHkdmcExgj6EMd+WE0dHR0zORmfL8RHh0YHx5z4i/LoVCBVQuDozQ7LDs7OxcjcWYsdCo6OjoiaIka8HZ2bkbizFiooJBcHREoVjGV4MyPJgdGBCcowhKTJkyZN+YE4F4IdIVjsdiQOyLMeJFWRcETkV+Gh4EJHIeR0yLMMxnB2PYn4Y/HoRkKWKhOxeF2IyjKFgeB9DhgoyYZhiiRHYT5E6gVoyuys7OxTsoL5TR0vujpfdDXp90PhfdCib+mn+MjTTh/UvJbb0hlYfdHU+6E7T7o6n3QjVQna4aOydiodDYbExPQnozg6eFydjWxkwLsjkdCnAuxWK2ZMkjGMxkwOsiGIyhSzOBITHRkRfwNxgbGBD2xU40bsaYmTI1KI2XkfKO0YMDUUOFSEtE6MGBUy1QkKxMQrFZnBa0SMQnyQwHYzJj6MDQx3kzkb6GhtyRrREE+FjxEmUNyho5EtG+iZYz145NGiJRNDZLRDQ3Ph5I+xsm2cBINGUYDUqSZsgbT8NjFnw2RyKh2T57G4GoG3I+NCOAxGhDUmhjsdDUDceWJTQlJkbGhjqxqLEgagdeGZFYrFZkgnfHhVZgShlBCUUYMisyZJGvGL8m4ZhnRmhu4FixOVYrROxujsnZMeDcE2dDUC2owfvn6uxX7Yj+zskicE7J48TsmBkrZMZFCye/ExYqwYwYJg0PgTQ6oZkf5HbMvwhOBmBj4mmW9dLsbf+i/0Nu32X+jvfZf6G3b7L/R2vsv9Cl/1/wBBpRviP0/6GikbnD+n+GJpk0+DGDCFQpQuDonzpJbZnE5dL/f6OJOEv7t/kyy/bb8MsnBlT5c/uTG+b+y/89CW5NHZ2iZJixc6GOCFtf20f8S/0P8AiX+g3/8AT/Q/5l/of8S/0EHc/hf0jPT7r/f6KOb94+6/uBaSrT4JcGc+MoY1wPo2S6b6F/yEV6JPu/8AX4P78R+EMs3PjAL02ZAk7/2v7kfxa5x8P/cGMeF9D4IkXASmXpf7Y05/X/Q/5V/of8q/0P8AnX+g8kTTcThr+o8dE6FZMjsmRCScJFUsucL/AG/+WcKdV+c/kzI/bb8Zk16MK793+xrA7X+v/RXKmuiIZmh/u0lyx/KROEl/cjZ/1/0P+Ff6H/Kv9D/hX+h/yr/Q/wCVf6H/ACr/AEP+Vf6H/Kv9D/lX+gtXzhmBWczsTkgnY3FmB0OjoeYKdGaEZQvC8KxUYJNwPggSkyK/CfMwOiyvDQhmST0eh9DQ7HQ3rQ6HwR4ZkyXnzBMCoVEcnDwRkyZMk7ENkpDUGDo6OjNGTJkiTNkxZi/Ex6P0J8eGPwzOVKX2/wDX1SW4O1n8GDBgx4pZFwdMzTMifuNyTskwJwKhVkdUN1Arod+xXktY2nZ2PkfJEER4QlzYSkYxstz9/wCGe0P8P2iPMMrj/piI0IXAkj6ePf8AouA60vS/gl9D/D6Zhi9rh/64ZQ6IIi0331+f4p01bWn/AM+5MaJlcf7QrsYqLySOb4R/36v2/wCl+f4X6u/P066+wlMlPD8Lxmh2L2mF71/zgYzby/qj+STMmSJGwx6bX7fCLZWi/wB8v+CbvtaYs7CZOoVP3/8AP5JVxL/BnxejtHZOzBgwdD4Hx4akyZJnxBMmBIn6KZkiSZ8zB2T5mSZM+J2dnoowRHhjOAxomR34cuztHZgwYEiRWKxWWJMR6PR2TBgmCNeJ0/EGSZ9nex8nY3wKGyEiKL4F/todUnw6f+n8DIijoa40NMX2Z/7B/wC4f+4f+kK4YXv602nKE0L7h/7h/wC4f+4MftOa+RGjo6HBtCQzhfAv9tDWIuDp/wDfwZsQmtCoTgkV5E5Ehqjsd4G2w8jyOmRYqyKvCJp1H6f3/G3U4fp5+2ReMoUu/l/8ZGNLct/xIC4w1yv+YGSGnKdoT0Rye2Ev7/r+Ncba/wCQYmn+HtHZGx0NWHS5fBKv0tL+N61nfR5j5/fvwsGvGC0P+Cftj7/XLOi+1f0TP0NpJeBr3pj/AH8/wpNuEM7Afz4e++l9kv5HelH9v+vEwMIRHiSUqZDdPwxj8PxMGDHmIMmTJXiN+MD8GTr6EG5HY/EmBKGYoXhjHdCSJJl4NjogwYYq8QLgQrFZkTkViqzFmBUUEjUDRlDtDsyO7ORMOR05MDg7k7f/AF4Tacob6Q++GOyZRb/jU/8AB/e/Yyjs7GtnJ2/+vCbTlZPQ4++H/wA34WYFYrEhWNyTRk0YHVrY7GKF4TnPk8EH/kEv/PosyE5l+kPlfZGwfK/7Lu/JY/6+lzTLT9GRMizpL+/SHuZLf0M9HLx9/wDQtL9C/t/6It09qf8ARGlrTWPpv2Xj4yv9fBks/Ot/pf39DnGoU3/0mP8A7VjENvTf9pD2GL9ffH0yhiy9r/a/XlKttSJTph/ft/Qk24RaRXvP2/3Bitb9Jf7IOXtf2v8ARBCH+H6f0JnzOXiCZIizsQlu7pe/+sjc/XCLhtf3/Y2NxZgwNgZaPjf+vn6EtUtiabvshOUQFs3fdf7KcO9P0xhWuXj/AJ6E/wBw/wCuDsmxNabM4Y0f7H/oX/ev/Qmf7H/omFx9CYjRPlv/AEf+6/8AR/6D/wBDzrS6v9wK66IgsMC4FwLEETQ1I7MjsfI+SR0RAqoxXnNGRWZ8NbG4J2QOh0KjrxGhsdjGtjSGYZhijYuz2IgY7RZDVDGoYx0xqBJI9/RkTNDPR6IFRgdCF34ImiZG5yOjp42ZJhjcehRg/wCG5fmxNDVSf8Fw/wDB/b/YTrw+R5/41vy5JhmWK2ZFdmTvwfhDayNkaFwZoVjsyIk4an7v/r6Ot4fd/wDTMZHVCObP1X2+mNfT9DdS6ga3VS9f95+h2lZ7fC/sTkUJYJgXArmU/wDn4M7Df+P5X0Qc9T9n/wBjdF5JFcEv7/v6IOS0vtf9oSNwKGuUyrXMv9fH0evH2w/x5hHW79NL5+hQRLeBErOfHr/e/C8OS/8Ap8okpmtNKUzDQXLr/su7/svt/sUQkJaF5RXuH52/6+PokbY3+IX2+iThNP7r/rxMeJJOCp+7/wCvoUJ4ce//ACRsY78MX4JS8J+TpE39PUKS+yOyYNjyTcCUeUpRgNyjTwfPk6GiYOhIEK/LwMYjsyYMCFwYCHZ2N0NDUeMGCPCUsyZMmSR4kY6HQ6ZhjUCFdGfDUkySPkxZgmBhUIQkKxWRIhvYxoswNwUowdCehXRZH/Lcv6MTZOx5wI0/Toj3+7/2NLz+7/2NLiX3f+zufd/7F0I25n/cmW3D5X1OWyF3t9IgZfdn/A3/ALHz/u/9nY+7/wBipCaxb4g/RIqP+O5flSOzNmRuDBMCdDCNCKbvwrG18jE1PjHiS8Qvsv8Af0dr/ov+2VsYht5ahfNf9/Q1SZbj7i0JpR9iXTNfjf8Ar5+jKg3AiYfyGk8inZbwi5n5JtfqPoy+37QxOjt9v39HaHL/AOfCE3grHiY5E/vX9/QnDk0Ic2FY5ht/jS+F9FXW8dLn5/Xs2JeJl+GMCp0J/RhBMtZUv9/H0QLYW/S/3gkbxD7r/r6Iucp+z/7MEiFZh9P2/oTacrI9IJ7WflCmUP8Af2yOmTBiiSRPQhORWj26F+f9fR6if9jcDoiHBuDoVCsVDKM2NbJhSTBEDDcCqjoYkZGpInzyG4sgjxiileCRNGR2dnYxuLHVmBE68T4lsVmcEnoaGxIG5wOfDGNGSZJPR6MOjBgUIVCRQhPnxkz49eW+DBgdEI6fh24JM2f8ty/oxCY9GPHTOmdCGbsP7V/19UUPc+5YqFQqGTpi4JqPH/Hcv6MXKJgWwjDMCejrwXBM0YDux3Z2YZlOhQMDcKyedtv7v6IB1P7f2MIoCd/8sYlUxd9v+voel1V/nX+/gmCjOl/Lt/19vonnSF7efx+xyNSNTZ6JuT/ld/RIz4b9og6zZ/j6ZL0kvsjJuCLgaEPhftfRELk1JJ8tH+/wvoas24FosCUHRgyJyLkVGDZgbHx4n44F/b+f1H0WPk+Nf7+S44a/1/f0Ri5TX4n+h8EDcmR6HVP+v7+pNpyiio4d/nJC2u8ff/Yn4k/ZM58Se7tv7V/f0egG/wCv7EoHOBcDRRDeSZIk7Oy86JTJjwp4OzoY7MjUi8YMGDHidCNwR4iSZI2OyBswYJKZnxHPhnryxj48GNDsmfL68MdeawLs7Ca+RWJiUl+H0QSYGVhHs9nsf5HfsyZJ2Po/47l/Qk+GDAlL9Kz/AJ1/oN3/AF/0P+df6HL+P+grlm3CT/uDDZaXC+p7tEv90+UNX+j/ANCR/wBf9D/lX+gv/D/oKs5sU/fBNEk0f8Vy/oRuMCgQmIXjRAxvxkY3ZhikVGD3Y/NL9/SihLS7f7Ml91/sY0ty/oepEtkW+Vv3/wBCOw2f5+icbZv8x+kNT4y5Q3Fo3RT8C/v+/ovb0v2/9CwRjkl+Z/S+jttPtsiR5Ij2Q5O0Npf3/X0elH4s0TcBN/ev6f0TbbH8uv8AZgx4XQrJNk34Vkkkik9C/t/839HDuX6X+8GMHxNftfRNun5omSSfDXiZr5p8/wDf8DyHfHj1/oW2Sn4ng9Eso9aL/f0V+lf2/wChpsyTIyRD6E0sEQRHorX0NSZGSMgnxgiPHQuDoiPrkmPonRkbyb2MmyDBhCogYx8DtGSw7G9kyY8Ohr6FYrFZkT2LxIqMCoULw3BA7RYb2Px2OhuCL2P35ejpf2dE6Hd4/X+DM7hP9R/Z2TsnZI+W/flYZ2v7FQhMmxDNEk0IxYxmBU/MiSerC+Ff9L+JQRLekI3dF/xkTbydFM/svpp3D9DwTQ3GBZjQy9Du5v7a/H0QLeWb/pfo/ZDzG39qX7f0R/A3/X9jU2NGTkLRaUv2/wDpfn6JR8J+XX6kiCVXCS/E/wB/Rkf8ZIkfJkeaJ4JuBCJkVjY3Nk6mFL1z8/RbM/rr75+w3BEO36+iI4MmbJkkwJwPyZTLRpXDz9x3CtPv63Jnw7Xvf/OjskmCYMHuJ/ivoi+23/X9eGJzZuTckw5GJCHJqCJUCwZHY7G5vwyY8MCo4HRE0TNDwNSZJm/GHIzA6MD4OiBUMjUYPRTIJiyLsVGMiXPhjwOxiHQTaKOVgdMdZHWSIyWLs6IkyuxY7Fg9C58FRgxkXfmDI7O2YHQbgeawOrJgw7FVMjnaf3S8xtyb8NGRIoo6ZbX+B62o+7/6G9j5Fq9Bpc+Ync/okImSJE5G5JEIR2NxkVCqjHlWJiJuIm/u4/r+BhCNvqxlNfeft/uCrW9t5/6+BCGaj5fr6ZWLf6ENwO1mHBEE4r0r1t/avn6MqDQLWuEhfBlFVwL+/wC19FPpX9v+jJMs7HLEUjMob/8AF8fRcs3+Nf7+RDz7F+l9H4h/sbGx8icYFG/EkyTwTwYLY0fG/wDX0pISR6X+jpfZChppD6X09hJ+hkwJwIRkWQia7N6brH2/1AnlfB/r/wB+ly9v9EwTBjInyL4RNjcuX9HXSS/AjsV+jIVeHTFxsgWDQ8dmuxyMY6ZvodMjkk6IHdCsydiInzMeHkVEeMmSmO1Y+R0OmOjBgTEpEhWZJ8INbGIgoRA+PCU0JSIyZ8OR8kCdiUFoXAhIVivxDG6JGt+DYx14b0ToVkCcv0b/AOvPuqPvQxsbOir+VT/r/AiW82/1+BZETHlR96+js7l/n/R+xMTvxI6Ji/FhUPjykSImChs9CJfj/b+h6S9FDioQhp/cSyn92Y9PmX+2JoUl0oGJ+JHLNsvw/pWt81+Nf6+CYHeS27G18JD02MJcL/mfoYx9Uve39q+RcoXJ78fivokHJv8Ar+h9DV0Js8C5quXy/wBf+8fQ3WZfr/lCEXAfB7Qk/wAJfQpTeVP5/wCySYJgZOaEjlK7f9DOPnY+/wDsngRI3CsezXC9f8v+T1GV+fORWTJJPlTVafiL/P0esy/wSK68E5RLea+7+juJr9jcWNwyIZFwbjzJkaCUkzYxjZA6OvCYhCFfjQ1CHySYG4Ihx9ESKxX5fhEyYF2RJBmhWZM+GxnYzAz2dMfZbpmTJknxO0YEoFRTAuDsdheMk8FCkdWOiY9DodGD2dFGS2M5hH3/APPKcCueX53+SSfsS6WFr/Xz/O9GuX6/5QkkoXidESX7f9f35YySyxSzSS+wm8mxUxUxV4QsCxI8eXXhQ/GCnjvNn939EQ5U/ezJPibH4nZMGjrhtf6+hK+dcoWYNw6/6fwOOWn3Qt2cW/ODTCY0/wC39Cblf4W2KVa8OnTf2sbn6IlKSWHxeuSHT7P/AEK829Qvz/opn6F/fP66+hJtwsiPen118fsibM2iNfah/F/3+PphJGmHte+ULq38/wBZF8oXtoyOXWPv/qSfNaWl5YKHPB/1wKUmGp8W5f6b++Pv/LO3D+i8ZFUvfG2NoT6F/b2T5aYmVPLT/wBCaalEiySEJ4yl/v6LfgX7f9eZkmbPbHP2/wDfoinwm/6/vxKJF5yZszYuSW8DW0SOhuDgRFHQ1AhmSJJkQ0KH1bgakz5QRH0YF2Zz59+HeD0Rx4wNDwMfA1yNSWxsh6PR6G4MeMehC7F2LsRYRI+j0QIdHXhiG5cMcmxo7Y29HoQr2q9rH5+ilvtf3/v7j7N2TdlC2z0/9P8Af8qTbhZO7c/6+BcGiCUvQ7UPHrXnqFn8Y/MDMozZkzgyqFTkVYKOxcGMnX0u0O7Ectpv1X0MZJbFo1SS+xAxMmLOxsXlqVVTp+9fivj+NARLeCRO3z/pdfsVDcWUXcL7v/U/yRknouO33+veIG6G+CMey9r/AHgaacP+PVjb4X/MCRElhCEbYQxz41619CmrST5n/TP/AFH/AKP/AHH/AKP/AHH/AKP/AHH/AKHCCVx6n6L/AFP9l6JTN/YwMlv6MzL0ymJjKWb9v6FpFsQhdCJ8SRHBfv8A4vos9a/5+CTNeJ+5CfsWS9FeGiCdeH5f0MXiCfCH9MfcZ6GIRgjwvFhWOxuSdiGzAqKEcDGPgZkdmR5lDrxgwYGoEilQrFYrLCexEeMCoVDXlyRYakdjbOxvZ2YZglYxZfOfz5SsiYp4n/z8EDsVESnkkSt8P+n/AMv+NKTC+i4/7/XvxoZbXJ1/2/39Ew2f0RkybHk7XhUJQKnZRCaI1syjI3JkyxnZMLkl/f8AX0ezJ+1/0YVkmBUIx5d0iZoZlyma4afK/wCZ/hiNL/5kVJrcvjpf8sY4EtHe7n7L/v8AisAf/M8EV/Sr1334dWh9EQTA9Nrzaf3/AL+/8Tacc/8AX/IIw1/zPiBzZev+/oat2/xsSpLCwZFflYlyl/r6I3XLf0diGPsi7D/hQES2JzD/AI68zAlBgk/cfavoteW3/X9EmReNnZkVGDAlFEHQ7oyNyZH5bRHgkaF4amjJEjGdm5GzBj6IEw1I7GtkWQSYIR7ELxBEjUocjE8HRKWTGRdi8LECtQRIrM+ESJmPCoQhOR2w8EfcYgkDY6Y6ZEMUYYpLVLYvW1/zj6L1/qf/ADJlUMixgRKZLXcNr/a/P8MMZZtr8V6/2ZHZ2Pn/AKPgasz8tSb/AFsSihKvDUY8KhU+hUJyKsixDFdEUaIoal0NDfHhgwxMsTX6jP0OC4UR8t/68T5Y8eIJrsd48Rmlf8wNJ/4nG/j7DGh5+lpDm+kWLDhW/wDS/JR4v+Z5LQsiQsjcWFKfX/v1tISWY10u6/dkI5OlS++f0RIJEwTHjCJJjI6yNX6jb/X69DiGL9ffH1X6guXS/wC/giLH4+2/n7EJIwOxJ28NKP8AnvylIkabYXC/7MnY7JGxhpVRD/r6JF1UQuxOGIgD/tDZur8/b/QxoefpY0K2XNHeft/uBbT52T5TgVEQc6D8o65YlDpR4ZP0bExceCwM0aGPkTYzJFiXiBeIEpGNDGvDJjwnAlAhLxry1BjxgdCFQrIk9mcj8nIbGoY1BuBCF4dmR4nyqFRECUUZECEJGTJIkWN7OQ6sbHVCUhcCRkyZL5LYuuV/zX0SQ29v6/19iIsiLMEwS7ajkv75Gjqn2f2f+ypcva+jKP6X3Y1ufgX+/wDogRCF5b20id4TC/5v6KY/oX/efsPFEwYQqFWRKxcC4ElCUiVETZGzRqh0YHTJhGHArrQ2r+w/0f8Alv8AQwlIfp/omTs7MWOyZoQyRvYx14Zgh+0OqTXp/wC5Ho/B/oS23yv9HPX3L/DoQwkLqhOSReCY1I0khjbf43+hv/1v9Gz8b/Rl/jf6Gr/W/wBDYr7D/QiWEjBg9eOxPjArRkbFJDUlm1Xqv1Q3hp8r/RFn8H+jMJv2/wDUGC18X98nsk9nvxSIn7s9p6f6P/If6H0qT6SQz14b8RQ1obf9SI/9S/0Jb/qREUMTEp8J4Q/ZxT02Pn+5f6I9/cv9Fnb22K6l6owY8TBHnInon7Ui/wCkX+hf9Av9CaiS6UGLET4k2SdCoyZMnY/DJgiH4jxskyZIk7Gt+HRgwYNx5QmiJJGHyNbHVmCYJjzmjJkyZ8ShjoaaHQ6JivCB2RIr8rEiqxUKhUKilCM+MmTJ7GNRY6G4HVGDFDuh3Q1OBttWZJ2OO7D4fI+rhr6JknXr/b/f3JwOibgzRkbkyP2kXf0P9GDJekZGyPD6HN8I4smF/b7/AF9Fb/3Pj/Zgx4gQlORCyJSTKoSFVjezQ1RgaOjoyNyNyO/EiwKkSYRuvD5OzHhjMkwyD2IgaE68R5gnYhIwFgmpGyZKEyMTgkV+Cx4ibG5H5p5RJAx+H0bofX0KhV4ThmCBOTo6M0ZMnI789+MCQ0QdeEjJkV2JiESKsGBeOhXXjJkV2dnZJgdGDry0KzJEmb8QTBgwY+h3RkyZJm/EGLMGBlbH35ZIpMYJnHh0hrwcDk9j7H3kV+PR6GWVokWDCF2LvwQiSyeCePD8puB9j7H2fsTE/CwJ8DiKOPOO+v8AQxodNfRDf3K9f6JUJi/JvsbLYrPQx8jsfijzwX98E4fS0vogyksvj/vgU0Qh141Z7JFZZysiWxCUCUYF+BKK0daOteGVY7syxuR8jeyYteMYPQnoVKCagmDGPpY7yQOyBVYuvKQlAq8aF9HZIzBgnTOjoydC6EJ4JmySIHyYsbZimNRXhX4mR+HQx1ejY/HRgzQyTBaPZY/GhC+hsfj39EePQhWLwvCEIf0ehdHolDtdD/H0MZsrykQQQJ9iPPsvYx+C8sgd+VYCUmSJJ2LxSIIEh9D8HdDUjtmRry+vDYlB68KqYpwxJ7LCsVno9ePRJED8MxksZMkXIj0RGBuDHowdeFpgX/j5GNDUNfRMFpmr5F/r/X2MCN/n7Z8JWejZBgdJEcWcK/8AopPiZ+/+vp1k29IVkV+X2IXBE58HYjZ2JDIVCUFRArUEVAnKhiwO0NDvA1cj5Ji0TDJjJMZE4z46JE5sRjw8QdPxkd+I4IEuDDLQq8QRUDVQPBI+SeBuPHsY8jWZyZPRB2JymKEN8eZPY/CUknLw6HR2MbsY0xrzkWPFHs6fhDl2RPnH1QRIvogwYMGBKBEmaMiM+F5kx9E+Wj9keJIgRBAkR4ga8QRsgjw68Y8STrw7HY1IzoUdiowYIGNGhqUJs2Dex8+GKhUcBGoJ0IViUoViEY8KhUIQ1BNDU0zI7LeHkbhyRBgVUJR4nRoX4OfPv/Y2Lhr6U4Mm/N/syib4f+xLKff/AKP+H/g0l+7f+itTS9L/AHJkp/P1MZxu/wDQmrhf8yZJMobGTNo2bNiyKnZbwhI0NUYUK3KHPg0Dd0YZNiYieRE0ZVGvoga8NEEECVm/CEJV4l+GPkb2NbXl2MyZM4ImxLZ2dioYmKMUTpnRMomp84HY3CMDG7HkaHXh+EZsySRrxksdj5MX4SgwJR4Skz4yZHfnF+MMVHARmhCEjIrvxuSYMEQKmIXh3RkdjvwdEXIlswJAgkQdETQ1Jkakaki/GLGoIgmBKPEEyIbkY+h0NGGYHWBPkTkyZ8MYyY4VjA8m4FkTgQhKTQlRrxPBTFXhUQLxBkyZ8PAyw6Y6YhT4XZFGURK7JrxHH09r0Vj2LXtf8X86giW+DD/zdv8A19xSQlCJkbkWJJqSYsbhmHRhjQKhNFkLgyrFavI3KnZ3smp2PlGFDrBTBaZME6J0ZwK8jM2aknfjJkfh8kcEIx4iDcMggiiK8tSOkYUjcEwOmYGagypMqR8ozZkUYvCIhwYoWBOSaI2diextilZGoMUQ0Q0dD4Gi34Zgd/QxjGNyyPDELwrXheJGPI/KIgRgRIrRPhfTN+EL6Wq8mMvwhGxGhYGaFg0RUjHVjQ0PyhCx4SIG4MGBuPCEhCsSTJ2MYx0UGmh1XjZEmRWZ8TQ1snZoVCcGBV4z4yZMj5OzFmLHTHREUJQ4FwJSJDI3JNHZE2NxY6sSBnKXYv7X/g1pQ5X+sjUZ/iaQ5vouHhwrf+l+SDQfv7+JN0d+O9eMUzFCOiwrZMuN+GbFyanwT3oxWh1THaHgdUxNDaHmNiJJJl0LkQvGDsXJgdGPoQuxCvw0OY+jA/JpiU0Na8PIxqx0zFESdC4E6gWDNjuyfofQh9C7GZJs7GpG58NDGQYNecDo6IGyDJlESjNnY+TskY/qyK/oVWOjAqMULzkmfEDc2T4iCB1RFwbgS0JESZInw7OxM5DoxREUNeIGpMoz5fm0YI0/EkCsXJ39OBjodUxoY8wOx2ZG9+MWYFQkInkQrM+M+PXhjodDZgiB3Q1FD8GpH4fI+TFmMGCYISpi4MZP9/fJl78l/v8AIlkfdf7IMQpiZX0ZhJe3/qR7+tf7gySbdv8ApQhLCpdKidmB9eVSOtC48LvxnJMmhODvYnwdB6HR+h/ga0aszkcuxhzMjd9nYsCMYE4JJ0deX9DsV+yBCQyIsS2YwOZIHg0O6MZHY0aFgUsYnhKKJ0RojQ3oS2O7M2RvwwTB0dDo0ZFZkfJeTseR8kCIPYlGRGPoYuPHRBn2ZJ84MEQYGSdeIkmSJJn6FQq8RFHTL8ZInyjyx0YMeEISEpJkzZM+JMCrz0bgaGpHfsd5JGdnYiIIgTnzkydiMYHRgjwx9jbHQ7HZkfPiSR0YI+3hC4EGFYnPmzBjw6yRA2dEcmRqXYzs7Q3tErJ2THo6OjoiaH4z7MnZIn2H6f0RUF4Nz42YZTJkagWINC4ImnkdmTLE5wLPhtioTgWBPTyUUbOtjHfhYs6Hzow50KnOjDnRjwnoVqCZMmfC8ZoyMjwiJwLxgiDFGKHaHgak68KzNmbOyIsagSGhojwySfEmPBCxBoVoiEJSSPweRuGOhKBC8Jz4z9DM+O/LJgwY+mJ8tz4vRRgVeULxkXidkz4ZBjxHhkGfEiEhecGCI+jPiCRoY/EEEECRBkyZOzY0JmBOBUTofh2JI0lrG2PkxZgwKiNHXlLQrFasVisRjwqFQl4YyK8NDuzI3sfJJhiooTIzozRkQiRcjzI1cicMWPQ/T+jKNDq9DakYnYlYhcCTxsRodoyiZOQ8yPomGKmUyPZxFxs12aEm1WTOBqqH0dCBl0TZsT8FxvwrHfjskfnI2JSIXjGRnbxFGaJF4fQ1PjRFCx4dGxohuxraJ2cvJMTihWZ8E6Io1OzUj5Ox8kmGRcCoTEhWZ8xP0o7OzFmBqClEaOjogmSDJkzfnBgwY+heF5mfGDAqFjzkyZM+HmRCq/DcFBURFE+IGpH45E7HyMOAoGECgQXXgi6GPw0SKURz4QrIlGR4MEskMoSbGOiYyKqYk8CNQJCFg1RHBgTFXhQhUJQJ+MqymMaM34QOjDLloSuxCFwK0OH7Gm1Q2sj5GtjyMVCTCOHp+n9GESNk6E7gTmmK3ZkyjsfIydDH0OjDFmBZgZOmWUDSKzNmp2Ss7HiUYV4Ong6cGx0K6YgsCYxox42IZ2Jx5wSJ+FdEzQrMjGMfiTAkLgjQlCgQ1I0PJE5HkdPwwYoyZImxX47ETsmDHg+CZojREjGWPkyR4jw/EEDTN9GxOBLQuz34yaMjGPnxseROBKBIF4ZFYnJHhPw39HDzkd+OXhkCQqFTFREURBEisyTskNjU2NSRfR68JSKBHhYiUJSMNQYMeMPwrIkSkyLBB2Mo6GHTG8BrR0ZEpMmTK8RNjTyYsVCoVCWvKFYrGPAxmLG4HREDFmBZMitGTRAnRySwuRnZJ0p/cn/Cv9D/AIV/of8ACv8AQSP+v+h/yr/Q/wCVf6F+CTnCX6X0f8q/0P8AlX+h/wAq/wBD/lX+h/yr/Q/5V/of86/0JECjla9r/QhqGzNo14wOsmBqzFMTJTAslp5E2xpVE/AY+TFaJSrQ6yNDG7sbuNjGZJoVuiSYJjA+BEUTofhvRgkT0InzM1sTkTnA34cB4kdIYqEJ6J0Lgd+EhN+HTsaGMwOjfhEQK/EwKiCYo9l+G2bH0RY0YMCJ+mYZECUnXiJMnZWfDHVjowYZFwdC48FYrMiF47MGCYEorykicivw1RM+WzBEECX4QrEFyYEjGSBMaIEJCQlJE+Y5EGyG4LRSPZ7H2W8iLZJ6GhOPDGNaD4H2Zpn7HZkz4jgxa8KhUJwKUJQLxnw+vLoY3BjOBuB9kckQNzRkdjsl5Jo78Goaov7/AD/iNe234OjRlGUIRkmc+J+4nDkXQnwYDUJ1GjFaG9DcZJh8jbG5GhyOvC5FRIvORV4wbjwmTIheJJExZJ+hMz4nwrXZfyPxPkg+GMbH5TEIXRImLA/BjyTsfI+RuLMER4gwQIkdH6MDb82OyZRej0MkwYILOjrxkyZ8ZMGBfT0RAlIrPR6F40YI8IQiJJkbkfkjwkR9jZHiCCHsyZIehQQTHjHozkfZjJknz6Jkx4mDoYi2Mbgdjjw1wejPmkJPYksC7F2JJisUkEyYwR5Yx9nsfY1znw2U8ZGuD0SY8frw9mtvnf8Av5/xJ28tPxr/AGIaoWDKIGdj5JhybkT8GE6gTihMbGoY3A3RnI7PY+yZ+hESLAn9OTJkUmdCbkmHPhUTHidHQ4H4Vis7E5sT34TJjw2Ox3Y3Jkakd4MivxgXiBcEcmTOSJz4x49CGYF4fl/XPlrj6Eh+MmffhD8Jx4QoFH1QV4wRAl4fl8DX3EiV8jEtE+EvKRBC2IhEfcRBnwhZGi/olPw7M+UxKDBa8qx2Oyw8jezsfhUKhEihRiiNCUiQrsV/RgVeGM6M0MdmR3Z34dWYMDox4OhzTK/5gkUtdyv1J/7r/wBH/uv/AEJ/+1/6P/Qf+j/3H/o/9B/6P/Qf+j/0H/o/9B/6Gj/a/wDR/wCg/wDR/wCg/wDR/wCg/wDR/wCg/wDR/wCi/wDR/wCw/wDR/wCg/wDQqMkta/7PR6MeiPsY8R4jQlp+HkTuROLFQmxOCTonQx9DWmZGpHY8j5MYMY8YMD4+h+MiceJ8IVCYu/E1ZleHgz4WBMT8IkwybJ8MdsdjGdmLI2YMCEO6Gpz4bnw8jWyR0NQaIIOvFuvoyO3J2WSQkKqFRiho6E5oyZMnfmYFRgwIgjQroyK/D8YvxMEQY+jodmRuRSvzBEEQR4aII0ZIkyLnxDJgwOhKBsgWIM0ZH0RwNEeJgVC7ExCEjKGNs6eDVjY3AqF34RAhKhEETgjwiYEuSORd+YMjH0Po6DLQ8jMZEhPw3oyuzJcDwNbGR9hkwKn0JcnAXAlXY5eyJXZEqR8kteDV+HXoSEuRC4InxFGvDU4Gr68bE4dDXDF2LslwPQdmfZ+Q5GuB9DiaHkYkI8dDZEoySx9D6HfmYMCrIpExGUZQ7G9jfAzfiUhQsCjfgn4kTJob2WwJwVoeRULhiXJ2FIiDJrvw+jkjYyYMEQLg6GiPuRKGqGqI2MfI+SbMPxAhYgSkyO/JmxjyYGhCeFZNECx5yGrn6K2P6G0MNuPCbJF0YIMCaEiPGfKF9KIWxLkWCD9mvCFQ6MGPKEpyKxWKxMY6sZJQbhj4Nx4SnxFCtGpII2RsVDoVCEJkCsyTIx+DGNjWhuPCGiJRoypJ2djpSTA6Ih+G/CyKxWZREkyQdkbIGoHRGjcCQlJ7LFZFEbGRFjodGKOhcCoUMTkzZI0PnwY0MiHBgShiEhWZRqfD5GYHREeNmxCuhKTJkkga8IagdeG9C48EzKMob2SOGNQOhoHTGtC4FRCYmZFZ2IQkZgeYGrgSEiJLGURKkggSiNlENQNDyNWQMVCteIEND5G4sZMH68IQkJSvCUkDVSMdWYZhkEeYnw35H4agiCPHQloSaEJSRJM/TMEkkiZImZJ8sk78SyPMGTJnx68OjAzA6o9jIHYrFYrsWKF0KhUJNeFbEY8TJnxIx1ZMDobgx6MUvEIl78OzJm14xfihglojR0dEDsVmTs7RizFir0RHoSgxRGmQ3REmRKSJHyiKlHohKzBEDUZwdCWh0TI3Pg1Jmx8mLMED9GK0RoxQkZodjkRI1NkbI2YIgiC0RrxmhWZFLMkz4xZgwRAtDFHvxBkVismbHOUIdGPDrODojRECUmTJEkTZ2YsxZgxWiFg6OiDY1JDEbORGyNjkhrI4ERRJMgRoa14OWRJkmTRizFmC8eeiJMmS2Lnwx9FCowLjx0PxMjmNnfiJEoswJQQIR0IiSJInw/MmCSSSSSSxJMkkkkwTBJPJ7J584M48TwY8uxyMfY7RMlsbJ4J4JFSMCoQuBC7Emxec/WbQ+xrRA0R4jgfQjBBZ+j0dM9j7yXvxjJnGRGMExflQQ8MjQoZI8IbM2JcEcHodEQRBgS08DWiFshv2KdkEESZtGCGiPsNfYaHwRpkaZB+Rb2JbI2QIIggSI+w+iNMjkjnJD2QXorQiTF+fXiBrkiSZMmS9EceIMEFGc4GtEckfcaoggsRNoxZBDIGhtHTOiPufkWFYkhrgggggaIGuCOSCJNkbGmx35x4jxPjH1tEmBLwo2X4iRyLDZ/QnCFRHhJb8QJSZIIII8MbGSSST9AnwknwmCSfCSWHY2mPk78SYMGCDoYwx2WG7kfIh9CoVGPCIWxKaEpMlMV+YMGB+H4YkjsdmTsvQ2YEoOjBGiNFi3Rkbkbmzs7JMGDBGhILgfA0JN5GpNyOVi2HOhQEoHDwWg0wyBTHIsRsgiWOFkQRAkeiNEaIHIan2WIETZG0NRZECUEaIXg1FFqImiw0mZsjZGxoiCIMURBEED4IkiSJ8RsREWjHohIiDASgaLKBSIkhMibI2JWUsiCIEj0RojRGiFgt7LEZEbEtjcCUEQQ16OBGh2HQsRJEjXhA1cjWyIIgmPEnQjIrMmb8RsXkqojR0RojRJYciZsjYhoVGCPEckQZRkSGSZs78KhqB0MY2NjZJJPhP1BXloWEgakfjfhdicCEYJGNSYT4cjkNw5MCUCUHA4E6EhuRWPHhC84FQvLUDUjtDc+R8mzY1BgQp8RRMomURQknLw3LIsWRUJaE0LArEqFLJGyww0RDkiCjFAWgloQUhqSJREmA0NCFGJglAkJa8FAjwiRBhLZEsixxEUhIsoHJESRRgPIIQQNCEheckESPHhoaHTkiCIFASKEIKCUoiBBGxBBhCjIBaMS0ygkIgRJAaEEtmyIZRkQQCWhKoIFQcEKQ7GEHBjyQCUCEvEGvGR4knx34WRZL8LgVElhyG5RA9iLNmBKBIRrxFESRJA1ZyIcyUITgXmRsnxJI2NkkkiCf0BBBBoNQYHXhIQhWIyMYxPBqGOhLQhZFYrFasdomSoHVjqzAnDgSh+UhCsyNEjW/I7DUMo6KVHQuBSxWNSZRsGJsdWJBh+GGbNsSaEpoSEpRqRK8HKyIFAiGQMyYlYpUKSsgg0JC2Gos2DWxwY4McKFYQkEpEoESLA1UjWxCQRDIaZEOBLRahZEhEBKUJsaqTYJFjgRDHDwVhIUqFIVoyaEtkDDQ1A1DFBiQliSJSKxw1Q1WOMo5DqzBEMahlKEhISkoFQwFiTkPksUZkPMEw4EocDRQkiDQWCJRqdmpHydj5JsahmcFH5KzKM+GqOQ3FjpjUGDo6EtComUORYQ0NbMGBK/EaEhcCQrREo0QPCHViCMeNi4EMjcjYxj8ST4nxJPiSSRMkkQiCYMeJMmTJEmSjsZgoUMUNaGZoyNyZJkmbQnCkwTAqMCnwvCsz5Y2Kx0OhtJjrx14dkDU+GidnY3BgmCYZ0dETQlJkiRciSyJCEo9CXwJVCYMV4zRkmfB2ToSkhEXyTAoQybG9HRmhW/CZOzUnYnJMGXRBOENwYobiiJ8kZCciWxvZbsb+w4Dqh6ERR0RNESyJHIgaI8RBgwRBEEaEpozRkyciZsxZEWOikYNx4fBmizLPDs1J2TJLXoyJlBgiKJihKR+CMiZIizsnY3F8kx5OidDlQ5DQaljWyBmLMeMGCYI0MlYGjolsjISEtkbE4GoMGBIiWRo6MmfDsjYqsjYjBEHR0O6J0WGNyMY7GYMeGMf0T4kkkTExuck8+IJMkyXolCEJeLDG9DQ/yZGYJMYJ8JwYE/ENiXIvyJz9Hrw7JMeH34Q/Ek+I8SR5fY+GdFvCUkyeheCQhAg+CYoySZJnwmMz4mCkdHohYZjJn2S2TJBkjg7JiyYMGitmu/DFgkm/DpydkwRB+iVgrDOmXgcvZP3O9jk1RKEpZBBBEkaOiJKIkkwTOT0Tx4mCkdDVCSwyEslvOROfofJMWNw+jp4RBr6ZJsfiNkz4bjwjRij2S8CS1kljsTgdhCLKGBqPHR0NrHjJexIS48KjAkCHsXAuBIggggi6O14jyvDDflKTsbkfQxjHQxj8Mf1T5TEZ8Z+hUJwYJgxkQ+x9juhyyJHdjezs7IgwYMUYokd0IVisyIgx4x4wNQRFDuhuaMmSQztDQ6IgdeIOi1GTJkyZs78JQJQKEYoQSWz2WoSfGSd+cGCYMGPDuiTJknxBMX5xgiEYFVIyNzRM5KZMuyZvx2NiowfopnQ2tkN1wQmWNydnZMWYMeiYwTgzp+OhqaIbIk5EzfjFmLMEwYoxXh2oJnwibMuSNjWxUYIgiCMCMEJRQ1KglOi2Qn7E20jc2LkfInBEH4ERgnR0dEL5LozLIlyTNj5Ox8jTXoajA1A6HCiIGjHMkQ2RsgjZizAqMCWhISmjNGRKRI7I2JbO/AqMUNRXhE6IE58HyRs7MlB0Pwfh+cjH4f0T4wLwiR8oYzHjBgVUIQuCJEkm8EzgSfQ2xu5MGGKhBCQiF8mUJSJyJCyIwRAqFQvDsd+WPkZgwYMCQlFC4MqDNESZHyh8+FRaEoyJQYho8SUIgdo6DvAxiTGBUxOBUIXjI7Q7Gxk34kdCoVFbFwZHZEk+WYMMmCYFQqoTFagyoITMqR8mWMw5Q3AoyFVC0EihKoEqg1A1Qk4OQbm9DbGzAqYqEEJCpQW9jmCPK5IuSYZECsIJQhQ1BmnoiRTljcjRDb6Mh05Mp5FT8EoE0YQLECU14Yls7GtjSyTFkQyJFDgJaMCUbboyNSNDHk7MiViUCC4EIIoiSBBAlsi5MsVuCYFVMh+EpM4NCQ+Ts7EpcizJkOhjXgx+WMgYx+F9K8KD6HXiYMUKhISkyhOhp78j5GjAljpjUGxCQlJlEmiCKnxECoSgwPwhXkQ0MoJvw2UIgauPEHsyrMmRqUN7HyNjlYHRsVEOYEvwSCiUKhy1ZO/DY0YGPJBsQkKzKJ8PAzsdGDBjwroVivPjJIxrxMjcGBuxZJEZyZMjsb2MYbawNpD8dCzAqEpFZMoRtWdnZ2NvQx5IhmxcCQIyiSRjG4saDDIgx4V0IT2LiyJQzsamzsd+EQNQbYlsXYp2RImi4IqTUsbk5DRZMM2N3AkLYqwWGbQx9waoTyiCCJI0KvBJEpQlJkaI2PkxZgiyTAo14JShX40RQ2/D5LMasm+h8ITih+Hfg14Yx+WPzH0oSMGB0zDsxQ7EKzIlIuTvxQdCRgahwRFD4IsifCJI2dkbI2ISgSgVUJFqiBWZMkno0djUDoaggfh3RkViUiH4bizHhuDDgVOBaCWjQJIlIr8pnxJjAqIGIRkydk78tmDBg6MUQKzJkb8SLkwYJgmPLvwrJlEmPHZjw2YMEwNiFZkyJ7Ozs7JgdYMGKOhCZMmRconzIqFQ3AloVV4TkyZJJlCZE2PrwbCehuCNFOi2Z8E5RAnJEDUMYMUJRRMOBKoWg22SOxqbGh0GosaixogwdCWjIiSJEpI2JbIEi0KAnBijo6JgSRNsyRUiO/GBV4dD4NwJQ/FhjUjGhkQMagYxj8PxH0Lw9j7H2RyW8kJeF0ZJF1jw2RA2ONjH+RWNnrIlOCOCERJHhAl4gRkn6mhsYfQxsyMg9Ho14fXj9eKG+R9lsiTeRCEoE2zsb5P0Nk149nvwxKfH7InHiiTX0Nj8OySRHo9E+G/C6GbJH49E8C68ST4/RKG+R9jU5L2MRPnH0dHvyrGz1k9eKJ+mfOSSST0UTIpP0foQ/CZ0QRwTLoWPCT9FaLgSn0VglI4Mkg22KBD14JcEGCFFA1yNcjUELZD+RL7kckEcHogSMeejoiD9kQ+/MRaJ4KgXhi7F9ghwN/c/Y05kksY0NDQ0QNEDQxoZH1rwkZIkyK2TNomLFKKRjwx9jDUkmOzNlvAuUYwUwRAlBHhLkS0xLTEMmSeCFo9FIdFCBj7LwNSRJE+zJm0PlHZgx5SWCNDZmiJEpEpMpI4EoG4HRjw4PZOvDsyTtmcE8HrxgwN+F2PstkJ+zJ2eiFolIwYF4mrOjoiTJkmSZPRjxjyuDokmTJkyTsm6JMGDHij35djsnbMk8E+GKifNFvJEsz49EceKyTAvLJivGRX7JFyXrwx4Y9Cc4FwYogqJaGMakibEtkLJG0SkQEo9DhYEqgiEWNA5UORE+xSsjYsyMSghIgUojR0RNESZIkV2dkbN+MCV+PZ7E9CuiE8HY7Oz14aGoGhrxBA0NDQ0NcjQyBofhCEINI5eB8jGhOL8KhUJC8OzAQbkUvBkwzAlBBHiKIhEUQZGMfjAmYJMDGiJyNSJI0NKSBjUMiCI8IWD2QOxpvB2RLEoYkOfGBUdeNEyPAx+UyUsDcCr6IMGRWO8DHkeZNjoXh+cCtDsdjkfhuR0YLQhPwvDsd4G9j8SMVCowJ+JkeB2PwyZ8SLy/GBDUjvHhrwjAmJR9EQKWrGgkjIUydjHRgtCoapQOg5iTahjUoyh8+ErFbk2UIgS0RAlQlDWA4hyI2PYS2PIkKhKBI8FwNJEShWvDGtm5I2ZIgS0JC4NQJCwcDI3I1s7HyLInB0NQQQNESNSNSNSNDDDRBA0QQJECEGuB9DUEQYEhK6EhKRWTKM+RNiOUx16HRRmKH2XshwJTkSnw14gd4HWDHrz2F2K6MmTJA0Ma2NQQ06IaIsgZFeSB2JSNyhoY6sSggEoEorQqwIyITlESN+HVoxgdDcCoZ7PfhXkz9DmDOB0zAqYhdi7EjJkz4YxrY2tFpkLQhQxWIii34Yx9DZEGDBBHBAlIrMogY2MfI6G4MD8Tz4zkz9HozgbgcIwMXZ7ERJkTGMZCyTBgixCjAtGWJamOQlXZYypEtjq0OnQwvsNwRYhE6YgsmA+dnbGqkWLQsYHD0NfY/AeSRKBKV4iL8GZEuCYEHXoSj0OBcCcimBKRqbHaFiR4Q7HOA1D6MONEQ40bomaEjRYa8IIGoGh+Aww/oCPCBISkwYHTGofiBWZMkSanxA1Ag6MUcDDgiaEpEpMkeIFjxgbgaOhU4MismTNkz5wYGOvEDRE0RI7HY1IxEQYMCCUMgL8TImTJlE+YGxswTBgyK2KzPmCfGBuPECMiUmTJJgySYHQ1HloSsVsyZMkkyYJgwOiYZ0IwZFZMmRvwnA1HhswOiTIrMmfqwNwNeEZ8ZM/TgbgdCRMUNMFqGvwshSJF+BGyYsoOEQIizoiaIkVkfIspYiBLIayHXoWMEA4UNaM0RJk0JHZMWRSIgiRECojRGiNER4ibIm/EExY1FjrHg8wdHQlojXBOBE+Gp8NSMfgaIGGGGGH5CECQu/ER4gd+IJnBA3sY0MoRsjkiMkSKzJkngnxJjz0RyMkyT9OReJJ58sganBbA1wMgZBECSEpICkZHZI7PXhsY8eKReyEj34VmTOCeCiYMGPLPZJP15F5T5+hGWNs9E+Gx14ok2ZMmSRi68PkY/FD8R4yZ8Yx5mDHlnsvxEk/ToT8SoIbGw2YkJEEMjwvCOCPMISErFBDYkmUIggajwIa9FPBSpjWhNGPY1PsibJ2d+VK8En8EnREZL8Ep9mfC2RRBPiY9EJUvFTQ/wAn7G+RWNyLBDyiteHRBA0QQNDQw1Pg/C/Egg2xkaHZ2exdeMeFQiCJGpGpIkibJkdGDBaMeJ8wJSRJnzjwq8T4zkzkmc+E/MbQ1sdDodHRWBPQlpkN0JSJDskckxgwYGjB68syZO/L5RgwKvEkeIkiSJLZGyDHjBjz78QZM+Y34VGDHiV40O6MkSZF4xgwY8TB6GZoyZM+cGMeMGPMeGjPjJHiBCrzMEUXoYRPmNnJEbMWYIgghiooIiaITLIII2WzBASEC4ISyTplYWSTrghBoNbGtjvBjHghECUi0ZamQORknZ2dkyY8LXopUjoiPGSF7FvIlI3NnYnHkU+h0OmIkgQyNEDRA0NQRBBHhAg7HY7Hyb8QYYqfhCOmZMjsakZEsdeMEwxeZ8OxjsZsdeMCoRPiSZ8Ox2Lw2Oh0YIOiBcGSJEpMjfnswKiPC4IUCZEjsakY0NwzBgVHAZBBlDsdjc+GL8MVCoQhIzRmh2Ox+IHRgdCr6M0Wx2ZMjN+NioVEa8LzkdjUjIlkQKjBGheIOjI0Ox2N+MEGCUiKGJZAlKgiSJIuRLwyBECUCWiNHRGhKURJEBqRhsxZgiBIUEgVqBYgiVHA1KQ6DwmcizNhsiGKAkMIFiBYgmFBEjsfJyNzocTKJhmQ1DFVHAWIFiBoz4YSPk5G5GpZgmPBcCxBlRwcB2Ogwg2YsdDUDUCXg0QNcEESNLQyzowx0yB9CXIuy2Z8MY5N14wNQRyLsXYuDQjPnsjgdvw/E8kwK/GSTQ/D6JPXhUMzQrQrM+EhIQQS0PJh+UhItmSBjHJnBBgwQVIuxcGiKM+EdjXA1LMEWboXYqFfkh4GRNjXAz0YMMXhLQkoifEGCBofRhmH5SEi2ZIGMc+INmBogXfhkGfMDXiPDZEkJvBqRCVEDH0MixKBKGIJCaEpFQiRJ5HaGhNmR0yIYgujgRyWRI6EyhKSIQ+R5JT0PPQ19hrwRFCUmAk2NURUjTghoWSWn0bhCUeIYZDSsyYESuyW7Y1CkfJyGhyO3RUwiLgShteQSSYEjiBOTVjc+EwyIYstIXBBBA1KIka5GiB0OhmBiFZLZkmfNieyYMEwQIyRJEmSREDGSTBJgdGfCsRP0YGYMGBIRJI0OzNjHViowOhuCBnRElsiTJrxAuTBgx4WRWKxKRX5YxkmDBGvCU0JSJT9ECowWh0YHREGRKREGRWNDqxIGJA6ZgjQqogtmTPmDswYMECEpFYlIlPmBk78YG4GqrwSdESKxWZFdmjswYMCoiBKDIrEmhIiRXZyHiTCR1Y6ZMOCLg3BuBZaE0IYHIV2dnZMWYZOAtDDgfA+CCJZZCtC5JJ2KrG4EhlBFwbgfAlNCSRkPYdqSdi5G4c8jUXz4G4ojQ1cHDgckGUKhEkzYlIfInFjr5ExEj4NwLaEkyOglNnI7OyfB0Mk9mTJMmSWQTBgwRBEGCfLIIL0QR5TgZPPh+ZJkz9aUfSw7GzvwlsVCUGPHsxkdkSZMnodCOzBEGPoiaIIY1JeV4S484I48wMS8SROTJHnA6Eo8YPRHjPjI0RsaMDoaPY/yZInxk9FeVRgiCI8tTXiGyJLyaI48twOI+JLZBAkKyfMCIMHAUPCR0JaYlogLAlNkbI2Kr5F9gvsJj0RFImKKxs62RNbJnJyM2RNkD2MeGBEIT0dFY2NSOxS/HYuSZMBDdkSTApD4ImuBqbJyJmxDcESGvxOik7GcDJIr5IeR2PkeJJnxH2G0sGKOjrZ+z9ls5GbImyDkYMGCfGSSBkbRPBgwRCoiDBQzkpmSZM34x4QlBgfh+W58TI+iDBgwQkVrx7Inznw34dYGNQKiOceJ0JiKZJEnojZLWDBgwQYoZ7IkiTJGyBcmDBEEQRydeYMmSZGuCDDJgwRHiit+I8ZIk7EieCkOjA1zggaIIIkksRsjxgiDBBMDo3Y19xSJkzZHBMWvCr0JR6G0Gm8DMEt0QQZMicjQkJQxWMER6EtCWjoiRC8EpM2JbMYIQgJPIlUEoHdExRKoRORid7J2OXaE1odECYQ6DSWSW6ZMURgU/Y1NkzZ2NzgdWjBBgQQuBOCZOjISGN3IuR2ivInAdUYJOjNGTPsnZ2blE7RSSilGBBOiYPyLZkney8l5RPBGyYvkdfIhSyS8MmKHwWMmR+G4sQqFX0ZGZJGiCB8mBOBUdeHXjobMkyNyN78qhV4SERPmDI7sdjMEQKiCGiJoiRNwIVmR258YZhiUCr6EDUjUjIGtkERYlFioVEVBmiAiJoakakibImyJsdWOhUJBiiiBcETRM0TyRLImx3ZlybEociUWUEIaoiaIleIkyNSNTZHiIYqMeCFwQNSjAbkw5ORuR88i2EgiJYG2yKjy0RJOzsyyIswJQJAqEihLRE0ZoZZkSkayM2RLkSGIKCaIeBKoFwNTQ6JDU+B5k5D50RsmBDgLgWIGoElDUDKHQalyTLk7JixqBhcC8LAlNGaHaGGpJuRW5OxO2IJwoOA6ojRA3ImNk2I2TDklplBbQhtHRE1waOB48Ekm5MpM+CHAXAsQNQhqRw/Y02PrzPhMUC78RJkhMiUMY+vDodMwKBPk6GK/oY+iRk+FGxdi7F4jxFEDGvDHRSFAXYkZRn2fscwPocDY4EiSaJ5NDE2TKFL2TJMkuDkcBl0IODJjAmxchMpqBpIE0RI3s4CCFTJvom+hQNpiemJ6G6jxAbrswkNJPI4eiUsGCVMMQoVMbkmBh2ZXYjijCUchmGRArdCXInIuGRKFaPyMrshoeJE2OZ6MPoaN0IwwdRTyJclNQWFaIEhologVmGRY+zsJpiWn4gRFGA0NFH0RDMCVtMTkSKZLBMBOUJJmcjxI+RrFG5dDt0ZM4ijDE0MIejAwG5glEojEovKKmUTDnRh9HAXAkLYglBECXg515X8DaQglDZgJ6EiJGpRNDrA3QxkEx4ngTFGzQ3RnwapMJG5EsoxqH0Qpg4CjDEtCKhi8DwJtEITG4G48Y8QJyKxWIeBeOxjobgRijZkRkyN+Wx0NwRDGiCBJisViv6IF4wR4aMkESJSQQQOrGgbgdMmKG4oV0TNCZY5eHLwcLHEcCrJJ0TZZwTKLeSaMBwUjgOA4MmKMoMoJckyWJlFrJo5FL8HAmyZowx6CZYmfA5eE1JMWOhjDIwMUWoiaFksdk7FyTsmLHASIRuxs3BhicicicifhInCkbHt4On5JE5ZMkydiRPZJMkicEwLgXBKwJ6LEApeEmA9iYsoNBNUKUcRuPoQ5HITqSl+HQ1BMHRNwbgXApCSWUkbEOx1ZMDCQxwoVOBKGJPkJyZEbGUGoHREeGSJiJb8yTsmLJiyCYI0bgamhBeBqVJlSLEjcWPI1EDkTRPJ7J8TJJLKnxJgdDSQkPsvY/Gcjs9HobHyW/GDBHJHJMky4MmSJ8Y8YMGBwj34vZkTnz6PXl2OimPvxPiZJkQkb2YEwNx6HCJeCeRNsb+5OhBMksona8ORM5KeiYKCemTNMtWyTZcsTNsTmylklPRQmCYyJ6Y2mNjb2JyixM5OQuByRDJNi+wn7CXBwYmQy9BvkIdTI5mI9h8I4RtgfZLGxMmSZJ4G+BcPKcEwSLkZpkyTLLFjk/E+CcGBOCYyTpk6ZLWSRCnWyxyOhyQpGZPgwoZG4pi1OOyZEG5JkmCdlBKrE49FHvwvDIgifZ+yJ9lvBGxWSZJgaY4aISo6KxshuuCBFClZGzs7HGWSlgwNDs3ZPmZJeJ48SNkwSLsskrBE5HYqsnZ2NSpE2vQ1GCU9FZDZkmfCPRPHiiSST2e/MT4gmSOCeDAiToaR0MiRKTPj0RweiPPsk9kckyMmSeD0StE8Ekk+ENcjQ1I7Hzs7PR6JgwfgSSidMnkskiSTJYngtgoJkkkieidDFySOydonaOhSJ+3hsknkzTLZMktliyGiQ4E5Jj0TpCeieSSZJnyUwdCSdlBjShs8k8kDfiRKSdnZ6IESY9DfBPmZMkk+JjAqE5F4lbJ0yZomSUxyEjG3o6DfBIpFPRPhOmTyJiZb2ch7HQlCZLE/sTAuBLkgSkmSE62XshnZeUTLDjRMF5YOglAsEzRE1x4Sn7J3szeyZyQ9FaL3g/R+iVhHRgmaInxHiB+JMEx9WRck+GSj9H6KWBqEJDFgSR2RLMnfhGBV9OhWhyzI7MuSYGxVjwheehodjsy/GCDBgQvodjcjsmfEwTBLRgmPKMiSJI1I7HdjFyYFR0STrxToVobbHZM2O7JJgloYmWFSgk6ModjZEkzZMWYJEwLgXBJOh4MjcmSfM7E2jAnBAsR4yoMkhMuSZLWTcjVWQE0To6JJ0RIhtsyO7GpsTMCrBAhCxB0RNbGpHYxozZixKLJgwIXnoTkmSZG7GTFmLJaFBCcE0agT0O6GGxuR2TNiY3DkkmCYE4o4F4FLwamhrZGRJ2h2RFkw5FYQiBKG0LEGoIlRwJT8DEZeGUkyNwx+BKBcEQhOoKQNT7FyImyMjN+IEoFRgdeW4JG5MiYiSSYE4MUYQOcCVQJrgdjUYH0MmDAlYlyLsXfiDR7FOvHoQbjzECfJ78a8RJ6PQxyxpGGRHhLkS5JJ8Ux4GPofQ6fRMEirwmJpmRWK/DkTgWxoZAuz2LFic1smjK7J5G68PkauRuPRjxsT5F2NRoWOzIuUO8DG28G+jBaZQnJDwTJMUR9yn7NHISbH0OnJgwJCFwRNGa2ZJn2Z9j5Y5yhsaIYcJLF2Lvx+xX4eBoa2hrY69EGQhDDEuREUQoII4EuCByxpTWCPsRHohSLkJNeNEUU0aHyNbH0NKRtTRgSEJk6JNdkz7G6MBjbJsmBU+htTYpE+Rdi8IkiApijAPAlyNuej9EJo2OxLfiWRrgmUSivCWUNpY2P4BqH0VgUZCTwyGGdhKUUnZM+xrbG5SE2O3JFmx0JaYuxIjxHh4H4TJgWT0JifIuxMTHY1AfQ40OA1BgiCIJ8FISMiUmR9jHQ6G4HRgw4FmCRKRKRuUQX4fI0bIiiLggVsSnzHl1Yw6GT4T8JyKxX4YheHQ1DGoGookakakyTK8ux1Y6HTJhmGZQYcCcuBORDKJlDwNN2MdWNDodoIiiBWxKTJEqTUmpOx8jDUHRg6FwJaEEpFfh+GMl4TdDliQn4IK0ZMkHZix0OiIZRwRFFHAqcCQpCkRNjVSQ8jWxqLHYiGRFChQ5CUiUmTJoiiNjWyxEERRgaijoXYrMkjO/DwhuhiSYYxO4EMIKxWWstYuRNmwqK0HRNwRFCuixgKhkzY1EDcWTBEHAUKHwcBNCckyZsUhYkbi+RuERDFYblGjDgfAlDFZkiSJ8JDGOvEkCzAhhGTIn5d2TFjUECXJDIIRBEisgXKMYPZMEwNnAZbpjsyTJM5PQ+hck+FRjBjIlyez2ZMmRvxMeMGDBjHh+MmcmcE+ciMCGuRpjRT9jtjszg7M2jFokmPR+iYIihl4Y3JkmROR8o7QuSgq9ChGDFGUMx7M58MlZJY7smFJAhj0Y9EQRFHRBkyRODNk7Gg6jGMEDS2XghihmR2NJ2JbRi0Jci/BH2IGoo6eGURJE+I2hrgS2WiI9ER6EowRFFXZBT8MkcZ8dicKSBKBqDBEUcCIogyZH4knZOy0dCYOiSdFDsVmRORdeCWxqkwX6DUITTrZKwxcPJH3H9x+RMWTs78Tvx+hP7Dikh8FYZeGRNcCcjlZgnYoWTFmCBEEJ5HOGRGMkT7J28MnLzEEEfVkyJnoXiYESZMkSQTJQuh0Jk+JJjx0yYJJkXieCiTF+F9ECXmT0SY8okZ78ZJknx6PXjHheF4TkdjQ7EOyZwOvDZEDE6MUdMdEicvs72Pk9EpWST4TFwTpnsSIk/Z3szkjaJizFjUDXwIowNzk9kfcd+zPs7GQ8ocZJgcbH9pnx0PgtlPxEjSyejBA6EvKWiOT2KNCv2W9iR6FfiIUkMjxGmRpiX3In2PnZEmckcDaREHLxAlBkiKZBH3M+x2MY/DcDGSPjxOiEymZ9k7ZkmbQmKigqFEUYmUM3AjklPBMuxtzLE5Xhtz0SkYGj0ezozRmin7MrsuzJkhxQ7VCpDceEcns7CbBMEpn5Ez7IY3IsEwhBo2QNGCCJGRz4ngRMCJJ8JmcjsyZJknY2TsTgwT4knxEmR2O2exLgkVMVGEJec+ckyN+GYMGCLERPhjcmRjFRgRjxEebIMjHZI2SOjB0NFY8tSZM2Zs7IlyNwYMGBUSRNCtRsyKx2J7HyNw5IizBMUYoUGLgyo8NUOyJG9j5GiseTxlowKkGK8dFhWRJnyqFRg6IEtECRYtY1NmXJ2JbMCUEQzCI0Q8ETRmtmRKSx2Mw5IizBgVUJQIzXhJQ7Ekbl+HVmDBgwdHRBGh3QrokyTNnZJgwKvBC4FiB0jgyZITFdj5ExOL5LRgxkjQ7oyJSZIgQI2PkmL5EbfQyVCBUJGoFiDNGRuSZFeTkOFkQ55H4IhjQkdETRBkydkDMEQY+jI7MjhYHI7wQ0NwyYE4FQoWRPxHI4ZlDx4MZJIlGRKBQJN0xKTJlCcjfBPAyRkm/Hs0T4yMdjGMwYFCEuSBLxGhKfEDH0N9h05G4ZMGCIE/EcjiDQ0N+GOSRKCguxXQrRkyhoDfA4GNjySFTJgS5F2TKElBldjwNeBoLBsn0NwxJJiXJ0R4yoMoyRQxyVNGLMMVC0EoEagXIzgeBqh4Gh8jJhiCeFlArRAyhMPlDYxsZLFYwJLZrzbGOxsYxR9Dr0UmRyRHhkGcmUPHYxj5GzDMPoVCXJw34WHGlEpjmLG2vQ1LnR+hZNiSVHQlCE3gRrxezQsm50TY056MnBkJECqiyg0IwG4Q28obsmyY9Ca0KA8HESiSJQhgNKEqRjQyIMEQQISF4ViYvBuDBiiYE4YrFYrMoVobM2NxZgwRBgiKEJCEhWjI2NjZOyYJh+EIVkiaeTIrE9iMDofh0OiLggsQZH4gZMeBsmKG4om4JkyKzKFaJMjcWYMCowdCFdCZBMoyiakb2PkmLG4Jhm4OvCBOUJyhWjJaydkMjgOLJIhnAVUJSK0ZMomRYGqkZMWUMHAXAswK6LCsyhKUJ7FyYvxhmDBEOPCU14QTKMonY3UjbyTFjcDcM3HhcCuiyGnInKMmEjZI2NwNwOnA1A1FCExkz4XhmLHRgdHXifBMaAnInI2ydihY3FmCYcGUFHAnFFq4JlCcCnbMLOxuLGgbgiH4bgWWilHA4eCUjtDtSakbixosdMdHR0NFDQNJAMBXZZSYSTFj2Jh+x0QPPiBGTIrEO/D5MEwJwdDdwLJkyTJKEMktEwOvRjAkRyRNGTJkb8G4JhDcEwNwYOmW6JkyOyRs7E5sTMDomB+F4iTJE+YJQ4EwNwNkjbmPDsmfY7JRM2MmCYMDowYo6M0TJkbIoTM2JxZgdDcUYo6M0TNEyKySdjipGo2HPwYME6RIrImvEyZJmzvzJEDeA+PEuYEh2K/YrJR34XJMGB0Yo6OmW6MkyYCcKRbE7JhSS0huBoG9DeidE6MmffhOydk7JHXobitFYE68SSNWNyZ+jsmDBgmPooVmTIhMTFsKAoEx6E0jFHQkfsV5JkWxmx8idSNxY4sTA0UOqKmGXsanwTkmUZUkRg7RTwdDkIdG4M0KWTIgTE9nZMWNwOGlorDLwdDWvCJIkaI4IMCowTIxmfZPj14kjxjx7IPYkSZ8STwNyOBI2STyPstkyZFZOxsngcCGjAvD8RPmz0LxEGBhjsNjEjckz4b4PRI/GCEexSO8kGfZkT+4y9ecGiSTpmfCWxOT0No6DLj4wI68PsV+yfuN/cl6J4Ox+KDnwo2ex14/ZHJB68wIdCSE+Sytib2SNz7J+5JeUTsbZgkTGyVsmSfkZMsm5G5E3oZMFpEwTobJH2WyRsl6JOxswRBMDEe/GPESSRVCa8QJCE/sJwJwLkLQTgSCY8CRM+HA70xQqKwdDJ0PgagcfJ2yJIgTkdGCPE6Y+zXZBn2N/cQ1sTESUJFgcbG2RHiEy9kGRogaGiBkeJDsaknZ2N7RgwYPZIiagzRE0QRJkmxkwVYoEwNwTrxOh4HY+SZSdkxaFTJMCaWR1ROhOBHRkifogiB0NwOBJgfg3I7G9jdyTBiyYMDr6M0NSOzJkzfhOLFTMGDAuDo1BkyNJkzZzILQy3AqsTgnRNQagXBmjKMiex5kxYqEJgwYEtDRJE0NSRJ34xYqFQqHQnKFwLgzXkrJmyZs7GhyJwyYJgmCdE1BhBlDbY7JmydjcWTBMDrAoyG3gwgmoM0TJkyN7JG4sVCowY+nNeMmbO/GPCoVGCIEMTNDc0JyJz4rYWwtvFOBvw6IlQK62hqfY7yOxubImzckobGDBgfA+Dod+xqTsfJ2dkwYFRMC4JgkRIiSMibk7HyS/gUIVGBwIEtEESMdj5GtmGRHoShirwhCREjwNUMYyg20TDJ5EyyJvDM0Z9isbqh2hzgbk5ExZKRMCcZFwSToSE5FZE4+jswOsnsfY3A3NDcjcoalDsbkZ5HyPxEMVeUQZHgYxm5NlyRAlyJtZFOGZUGfZk1Q6G5wO8oZI3cmGJDRkljwvESZREi8dkw5JhjUZI5EtM6M0ZHaIlFhqTkeiSIIhmPC4FwJGUNQxtjtjVidjlMoJCcCxAro/ZMobqhuhvaJuRvZMOSUhOBNLInonw4MkyZJGxu5G4sbhjrJ2EtM68RoyZJGMa8qsmGKhcCIExWjIx4onY8yJi+wpgaDQzQJyrEgdoyNypGMuSVNDCUCcZEtMSLURI02Ox8ibOREkRY6FTEopksCaEqgV0ZG6G4GHybkkmCIYoNi4EoLmURI1I0NaDowx0xK4Oj0JyQZJfhKhEwMQFGNtODKBOxMsiZFa8ND5GYaMMiydCyJwJSKxKRWMfiRqB0YGoEYJMkyZQ2Yx8je0OjBhkXB0WJyQZJZoWL8PkgjBhm4JuBKxCtCoJSjCRpEj3GjcEQRo6FmBUKxWZQrHiR8jGNQx04MOCLgS4MeEkVoVqyZQ1Q+RvaGYZgyIuBJCclhWSy4FOxPY3FobhmGYZihNTA1iZZEyjKORNSPkYaDDOjFCzAhCsVoyN7Gx8+CQyjMoGoYsizAhKRWZRM35Y+UOiCb8MhrwkKzPjRGzGBuB+E7J8JiBOUINlhrZSx0NSLmClSExcCaEFTxFDVeCSOhqCIGrErgXAj8EpRlCcqR8jY7G4JM4FYmWWhFheDCTkOr5Ng01kdYMGKZGmZoyZInB34wYG4ICAcRh6CkWomSZFdiexcicjcGCIMOERo6ZmjJbFeDJPAnwLwq8RBPiZHY3I3wWO0NEMS2NDUYIgiMkRTImvGR3gQxuCTBgmCYcG4ZhwTomaFeSZOQy9iZMCcEwKjpnTFdGTJkiTs1QufC+wwQ1XjNGaMisdkTk7R2Q8keHWCNePZE0ZMjvB2NicEx4SkTDJhnQ+BUTJkmTNkzZ2SNwYJgTwQ6picUy3RkyZMjc2TwJ7HOTHobgdUydMyK6MmTJE+cCowYIgw/HRmjJIrJ2djhWjBgwWhLg6IiiJoiTJPgnwTFicDcIVeikYo6KwZpjuhp9ipZkV34aLHCHQlFeHwRoSEIkhsRFGDA6HXiYZNwToTmhDmITNnaJSwbBoHAzkjk9jGQWej0R4bGH9hyDfIxI2TNmcCNC8LHQl9iiOT2JWZJP2KRPgfQqI8IR7PY1PhsY2z0PojjxEEeEcnYjkaGiBkcD6H9HvB7H2PxBMj4eD+hBIuz2RA/EfcsXRPHiPNHs9jU+yI9i/I89ikS4PRAx6MHQ0eyOSOR/kf5IJWz0eitHZ+j9eJC7EUP8kkcC8yfoj7EMFbJuzHsuT9n7E2J8HaJgjzQ+xdnsaj2P8jQusno9Hon7GPX0ex9+M+fQ+hdHr6Y5EhIS8NEcEcEcDoSgQhCTYuydMpexTskjZ2J/YUa8Ofg10JDIWyBL7+I+5Ykso9CQ5RED/B68Q2ToyJiZN0dBPgU8GAn9it4149krAyOGN+UUMGCUhvwNjc1sbkeSZG5c+MWikJwJx68KxKoEpIkakiR9j5JMEwYFwdCxHj2K/GR2MbGhkQRAkJPBSUESNDUnIa2NCMGBqGUiI858Oxh7DexzlEJCF4akjQroiR2KxPZ2OzBgiCI8LEHRHIrIkakfOztifBFyOhIIhCIRFQJRQlNESOGN7HydiYqMEQ+ikdHQjNGTIlJ2ZcjqzAnAqFwRo6ImjI7I+Xjsz4TBjw7OjoiclvJkdje9l5Juh3Y3AqMehfjzkmaFfns78YswYMHvwhBWJSRIuSCCJIgoRFERQ42JCRlCIk5GbFyTBgciI9CaI0VhjU0ZUDsdnZGyN+IghIwe/DU0ZUGRjs7J2doTiygoFBQyJkrMBOfIyCPJZFGyeRjSNwN0N14Ytfg6HTFTFRQVeGAkaHeBtESINR4UjA0eXQhGfpwYYlAlBBwLEEESMcMEDDyYElvxDOmQQPBPgbbssNQOhUKhGBCVEDGpwM7HZEMwKjAkFPEaIFaHaGNES5MWYEoEoYqEiIoiaFg0PCNBrY2Rco2KhchHR0YRoeERsyO7GYswxUxUITFCjBlQQPA7Q2PksRZgw6MMSCg4JqCDKHaHyOckbH+BvwVEwRo6M+fQ0hjIeSYfiYEoEoEJEEJoQkZEI2JQNrPwiBGBISqBqRGA01g5GUm5ITKWRJoSBjoiUYEBJG5GMjwoCWhIEiCJ8PoSfI1ckx6G4ZMCooN4mjUFiy8DrAqMCpwJQSTobkuTI5DkPEjexmhynZj0YcCUUI4C4ZJisXIhIVGB0PI4VoSuCtiFeRWrM+O/LMGB0xEcESIS8t+GNRjw6I0NEciU0NSJyU0WHMbcSN7GmRfhIQdCFwKzIuSRGLFQ6Is4CVwRyJaIlCUqzPsiuxp5HyOrGTDIhm4IuBKyJLCVGSJQ4dj52OrKYMMwzFaEkmKxJoiUTKIkyTJEWN7KDUM/Ax6PRijgJTQkmTs1IuTFjqxuGYY01QswLjwyrFasz7O9j5OxuL8JhmGOnQzZkTkijJEmUZvYxVY0MwYwTFEeEKxORc+EhraGglBFkx6GMSE1sSkakjIibI2SYHQoULjRlGisCSeS0syZG5UkyMZnxFlyKJgUYYpFZYyhqUK7ORixjMFInRPhdic2TIg3s5De0f/2gAIAQMDAT8QTCsmWkSm2NTY1vZyG4IgSsUgswIToTQrMicB2O7HjxwGGNSscKmxLgThwLMETRFGURCRqVI4yNxaMOhQmOQVUKnGhQ6RlQK1ZDaZKQdobnwfJRyTDFbwV4YtdDJ0JyTIVjh2NfcZkQuFBkgsmUCehNCsyhNIRJZJksvxZRF0Q2ocYQlicOBZIkbkyiMh2pHA6stOUVI1IXHi1Cc0KxKRWpEpsiRI8HVlJmGJCWhcaIOiJMmR3Y+R8jY6cmGRAswZQLgSFaIlCoZQ3Kk7GNBBgrCF4WYIkyZREJHychuLJgy8FmBceYkyZJGPwbE4NjyPI2vBWiTJPmPDyN+YgQh2aF4ka2NwYY8isgoJnRE0TPljWxjQTDIgkfB151414kSkheJsgQjP0R4fhjIH4TMEHgzYlNlxKO0RQlFjcGDcE3BimZcEistk+U4GtjDoiKHwZHAyTPsk/QicCeyXkmL0OvQ3FaMUYogi4HwLjYvuEmxQ7FSTsVKR0jHodUiIo6FVCujIr9kt2Jt2SyjmjCROFI4EwTcFYIWGWoiCxayJsjYuROLGNwYFodESG5OiZEpsypFydkxY3BgmDFPxA+Bfkd+/FMsakwpMDr0RBECUULgjREESZFsJt2jtGpMWYMCpkzREUdEw4MkSTNk1IuSYsx4R56JMlMViuyZs7J34Yx4RDJ0Ro6EiBkqxM2akmFInBgx4dHRmjJGvDJk7J2NkwOiYIgkgyTPhDY7MmDBgTDOApdDyKxOfoRIhr6cmRWPk7OzsamxODB0JGxuSIMmSSJ8TsmTAqMEQT5fhKDsmRISgaSFXoaR2JJ8ZGhPAs0OnImPGPQ4GSNkNmfY1A8j5RNyh8BODBW8CfIg+xL7kz7Jl9ky+zsk7R3on7FLHh9nsnkXYroUseZ+lBKCEh1QoG5E8QcDg/FOx0F0UFIQah9Edjbwa+5Jj/JvxeUSTKE4IgiM4EpyNNZPY19xX7LZMst34jaIGSIb5PZOmRNFMTHny+SZ8KV4v4K2WSTog/ZBMGfRSMn6P0P8AgknY3IvORqBuaIkTkyZ8dkb/AJFgaEoM+V/AqH2IYvokagX0Ji8TP1yRPjP8KN/VBH8EkEDQkPwwqFQqUHAiFAuDsNNjsyJ8GXIqIixUKVgxk1A6ozRkQyzJNyN3JLyTBEDpCcURo6YrrZbJkzeydMoiLJmxVZEWYXRMYJih0gfDJMOxJHbM+y3Zm0NxYqsTgTjBijAlFeJDlk+BN5Q1comLLVkHrwVyKKhjpAnInJkhMSSJszkiHJEDQdC0IijomaMoTkdjfyIeSZsxZEWYMGKHSB1RahqRqRqWRLOzsxYqsbgVGFAqUHRM0ZHZnwXKNyTDkaixV4YIiiKgUjJkifHZGzNkkwYMEaOjBkyRkdnZOyYsxY6MULQxR0N6EkgZJ2LkTlEXJ2TFmDD8dC8ZHZktZOx8+MEQR4k6EOxuRBsXJ2dkSImBcHR0R4Z8J8TJMeGDBGiNHXhX4LksRsVufox9LEpJETcjeyTA0ZE8GcdnDZqCJRM0NSTNj5Oyl+MCpiE9GiaMobbVDvA04G5sfI3DJhmHQqZwNkRT5HLUMmVA7RMjux3Y+TDkcIwxNYIYQqIGo2QTKLalDoPkcTJ2NxYmlkTh2KGRcrZw2ZoyjJax3ZyOyYs2ZCHBjaF0YQyKG28GcDlY9xzLirkhNCcMXAqwL7hyUFlA5IiR8j5GYcjST8NEIQheCDKFeByHyPMnZMOSbE4YuGcBE0QK0O0MIbkmLNz4YMoOHhYIE58G5G5vzMGBIQ2j9maM0JSiZHyPkfInBSZj6LER4doyPCIizsmWNwIJX4QkCwSRJkmSZvxIqMEeELxqBV5jZ2TZs2LL8J6FwYQRBEiteF9WPEi4OiJMicjU+U+N+JOiK+jBMiH9CG2JCVDYVBsb4OQ3BguR/gTsvAhCSZRMOx47G5H2NyMYPwG9eHA1DErcmV2N1Ox4kdWJFobgdMwyYfQlHo4CU0WyNKsooz7H2dBuLQ3BgyJUEKZ6EWpiYlRKCdWMb2NNjY6YqY8idi4eDgUEpyJSuzK7Hidj/I05GhlDBFjehhtCdQJ0xSXY69jpI+jkhwNJeEORR9CQkJDShOUJ/cbGdB1aIhmQ2pgWYFmBKaGEZEx8jHIbMho2LJ0LgaBWjJNDwSMdjcGCPC8qxNNeX4bjwWSYZgTsQSSZQoQz4fgyPE2NR4TNEESJ/SxmPKd+ULBqREULwqIgXhZYwl4ydil2PT8PzBsyEdeHg19CFk2b8IkS86+hj+piawF2LYexM2hciQYMEw7IuGLQtQlInIryZQrwN1PmAw4IiidMtUdHRfgzkTmxLY3GRqBt+hMEaHwK6Y3NPYnNcEQEm8jWQrUieylZsG0h0+hqHGhRMClR0ZoV+zJmzkS3gVWNQYMExkhzAtDNGfYnPstkn7BKcEp2Kr5JgSB0RFFYZGjozRnwiRciGx1gbfoUMeEcPwmaITGpLWKRyOQ0JBDTHmNCWhSom4HdGfYnJmzNmVIufJgwRoVURNESTIoyFySMXI3A6JgSijo6OvOTJM2T4TjwmDI6Jijo6K0RJEkz4kmBh0yLg6FwLgT0RoTkydk7OxOTAlA6I15VjcmTJMiWx1YnBgx5TmjoVDUic+UEz5mPDHnP09jfgxIwKvMiUeM+eyZMCRj6H40ROHJM4I4F1gS+xKRCWRXk9nsn7iTXhfkcmcEbRMWsH6Jj0NIxk7F7F9xw2P8AJP3JZuUdobEBaJQ1yezhsnkxnIn9y5oSMqSeBuL0Jx6H9hoSqxdjY4klfJsd4ydo7RqUesCpdChYMZPZ7J5Jn34RJn2S0TOD0TFrBH2FXorDMBPTL2L8nDZ+zfZ6yPongbjoQWCCjCyYdkyR9z9kl6MEsQmLFD0Y9FEKLI5GpHHA2dbJP2Z9l+HokSMEFbJ58oZ+yWsEzg/X0Jj7F3562RHldeFeU1sadEwxwxLxPh+dC/A/oV0Yfh/kU78wd/wpjkflfRP0YfSseP0KNeCfhfwoX48L6l39HZn+SAlpjoTgaimPhk6ZDZbyZF4vXjAm0KiYFShC7EpsWx2Z9k/cl8BdEGL0TGBSiUjo6Yk3RkmSdMjvBMuUblHaJSUomDGCYEihOKG0lQ18jPsa+Q+sj6KyNFoVMmDAoWRqBvknTHLozkyKx8snaJuTsVCr0TA0UTpiumZrZn2Z9k8ZJ2hRlC5Ji9Ex6FXomPRWDpkTTM0TJkyTLlHaPRKVrxgwYonXiW6JkSH5eKyRtEJjgQREDgPhieinRnJMkjOx8mLLREGBVR7FwyJoyZ9/SmLMFomMGKOixnyS9nZ34xf0dGCaMmfH7IZ2KyNkyTBjBMnXnJkz9E+JgwdHR0YJkmfCHkVCMEDQuCIJOhIdsVkz9EwOvEmPMSKxM39OCl4n6In6Z8JQJcik1AlREkySOSG1k3PjLJgTlWyMBcEEoOGxS1A7RkmS8j5Q8yYc6JgThmClCVQTFGVAnQ+RyHyTckw5MMQVhpUILgwhWoHLQ3JazkN7OybFYVDRk4CqhKERJMlhpGgm5JuTLJhjQTFGEDKIYsQ8luh2htvAmdj5Ozc6JE4cGKOAsQTCgVqBWMPkfJuTFlpioVCchC48ZUDtDcjszY+Tck2JtORQIBtE1AkJGNSiJFkcBq5NmWTD8G4opRhApiCw7GEyLkZvxMGPC4NQaMmRuRufDVyLk2YMMwxWJR4zQ78DSRs3I3LFkmH435nXhUhEeezFmBUYIgWINQLw4jst5G5MWNyRs2LLF5yKl5akd+Z+hPxJo0RI3Iw+fMwyCBeE9fwyLPjOSOSCJHa7Jn2WMiYIEWTZGidCWkJ8jv2Jz7G59jl2OIJjA+UTdGCYfQ8xofGiGBLkauxKRubGdkO1I4YILBsbh9EX0LjR9hlbE9DZMdJeRNBTRm0PobhyiY9CiHBN9E6E9FKhdnWyfkO12N6ZHyhuD0RoIyOjgK6QnOR7bE59lHY5iWOMknaJgwJR6NxofGiGBLkauxXY3NjQkbY3tDcDyTfhHA9iYlKJbJohNDux9Dq0Nw+j9H6KwLgXA4wyPuZ9jUrsbn2ORsmCYMEnAa0LiWHMSfsW/ZeWTPh8kwYMFnWiPBOhWZHyNjHRFjmehI6OHkrR2J8tcHIp4flOhIkXBgkXhDY3BgwRHheECGROfEbG5HQ6EhZFkb0Id0LyhiJgx5y8Y+j9l7H5eRiETrxHifMySMdC+koYpCU2ZUnZEWOifvE4OhZhErAkOywlNitE1R2h4odeEwYofA1FPZLZArEpImxTlDSyOlJECDonRsSmhMV0K0K/ZMqSJRKakmFKJ+DJj0/BURFH7CcOGKXTEkSbQrUicJJroYvkmB78icM3GibhHWxS3DMiCWQrRNSiE1I3Q6LYmCIZMuCEsjZEiYUh3YnKlDSdmLKRgdE6NlnBOhOaMoSfZJlGVJhCcIx6ExgS0dE6EpLeDKMqRPZMWYGJgxR0dFtwZJBKEismSFkdooNEygomzBJkkRJY7O/EwYME6OiNGKJmjKEgxcmpJhSYXhHjJ0LgVuCZNwTJEkzZ2LkmBKPoQRNCYrJnx2diHSIMHR0IWFYwr8R4TkmCI8MeI+ns7OyTHkSNiz4kgTIOyZ8zHifC4IjxEkLRDKEuBr7EQQPvBEZJez9iv2Z9mfY2xPgicEI/R+j9FHsXZYma8fszYuiOD0KrG4FRHJ0ydMTGprZklF6PR2jtHobgf2D4On4bWzhsgyTPsvR+iOCtYJj0VonnB7E0WT9xS9mfZ+ReRBG0Qsk/YX48VsnkfY03kcUFfsney8sXRHHgmlY0GCOT2dM6M0OxQSxdE7R2iZJjw6PYpG+RcMyZ9k/cvKKbkh6P0Nx6ETzgrZwZezPgr9j58Inz+hDEbLESQ8WnBD15QSIKh4ETcDUISkrJ78d/RMGoFGxZsy8JSNyJSJfTLQuvpn6Vj6I+pKRyLkmULH0r6IkmSf5Fjw14X0Nnon+FgiDBEDdWQ9jU5GpyRJbJeSsk3JS9eFREGKEucHsvHg79ib0LnwlsdWKiY8GoUFOmNyoZDDc+zLM2S5lDc2LkT4FXoVVo4ExRCVDumQ2ZXZn2KM7Oxckk7Jgx6MEQYQyW1DHecknnJn2XYltyjsnemYvRSwIJwdCS2ToQ9ih+x37E2SplHYmzFicCcFDCBpOmWozkbbyZZmyZvwlvx2YrRijFDhULstmHZn2d7OxOWYJiyYIj0YMCcoiVY2MmS2dnZMWTAlBQgnQkt+IkyOxOfK5IIgiPAxwY2aguW8E5OyTsVkwTBwIivOTJk72Xk7FyTF+J8ToVeJfiJM/TgSF46ET5ixnZMiqyYUlhuBVR14SgiSfOyDskj6OvoWB58I7EY8peL8RJnzHlUKVXIpwRFCVEVBEoakakfJ2OiIZgWR6CeAsQLAnUGR2WG5tjdIJhyYck5CyIYQLAsQRKFQdjcobmzkdkw5MOTBgxRhQLBmiZRItZLyNrKGizDkVMVColgVUIyhWh2OzkNNkxZMibFTG8CjgVUYQJyoIgWHZM2N2bkbhyTIykQ4GAsQRKgVB2NyPMnIZslKxUx0xaGKNQTomUTI7G9mRsJhyJw/COAqoWBUjKGHY3NnInZQwyIZOAngLECxBNQRJkdkzY34w5MX4VCCRgyhUMkDkPY5EFLIcmDAqo1BOvCHIfI3ckyNw/DIwxU2MagXBEisySd+cWbN+EdCIkQdj5OyRVZMs2RLE9HAS8QZM+IE/Ex4XiSdEiUjcjtD8nk2TBgYuDoXBEkz5LxBJsWfCTJleMmh9DrA1A1Y0QMSImmLHZLaJDdDfhu6KMZdDrA6oShwLgT0yJJ+4iyHGVkbgb2hwmJQxyfQlYpVDJUjgVBhZTQ3SGqTQ+joTZBhDAs+CYrJlEjESpOQ3FjqxxJMCz0NbFOCygaVRMtyTCdkwHQfA7SiCZaZMUO0CpwcBqhiTeRNQJSOg+iWUNFY8yKZkmX0LgQywhjBoyIQ3J0Jh0YJhipibnwTFYnRglsZ08HVjHkj7CzCFwLEEShORS8GxjGTDJgmKFwIT1415XIzsmWb8pi4EiHkivpI2MK2O6EFx9Kc/RAh5E/KaNGh4GPxMjGgiPKx4OxMYxDGjDEvC8T9TGIYhjaEh5FgYsCwLH19E6JESjKkzY8SOMjoZEeIIM0RNESRJCY1Njuxoa2MSCIIuBK4LULTgSlCsVic2aHVjTVlDDLVHoWYFwJ1AoZbMoypOx8nIiRBGDDgiaM0JTQnNMyW7M2PEjex1ZQdGUGR0ZcDSgno5FWJmyZs5De+RihEMShkRRmhPAshBORNu2akxZsG0jB0dCyLwRNESZUic2MbKFBUbg6EpoSkTmh2K1JmzsmL5HVmBUYIsfBE0NNGfDJOxXY+R8jFCIZ0bgzQyDIrJmzRGx0ZeHROjoXBwIJIkzZM2RsfJEEQJQOLOBLBEURNESTJOySBc+JgwYoiPDIkkZEOzUi8NwJwPQQfAnFeEyJSdi5JnxBgwxeFx4iTJMmV9CcD4MeD8dDoSkgdkkbG/MwYoiCbOjQrJTwRNiu0ZteLWYKRHJHJGvDgpexWO7RHBiyGiIKEQRFM9lmaMmfZM+yNnaE59EGFJgtCSVLxWGJTRCZE+zN7LdonY7FZQhS8OjoiaIkmcickyZEkJb8RPox6KWTpj4ZOiZM1sh8iUjc4yQ8oURJKKdEx6KCorM6ZOjNChmb2Jz7LO0L8CSIizBMUJQSN6YuPCv2ZvZdkTOC9eVIx4kjRGiRnBLeRWKJEdmSY8OisMl4J8Jr5EpJnx2TFkwY8Kitk6IkyT9yfHaJkgx4YETrwnfifv5nxJgwYIJOiBIavyOQonLxj6kkeMknZE35mDo6IjxEkSTPhEEz6F4bgx9C/hmPPRgVkQx+EheW48Eo8b8r6DBMeh0dDGpUMiTPlogaI2R4wNQRoeL8RJEil4vKHydkw+huPRSOBEUyXhlMp4PyEg7JmxTNeICYl/A1FDjDMUyJrwz7In2W3InNoTaIStGBV6G4HVD4HiGQ2L7iJ9itjSd7NyPlCq9HQtFIuhEU8F7JkofkIx2dorKE2rMPobj0UhVWisCejJkmfYnOR2JzZJOyBOC16IijoXDIFfgpZbwJzYjyxKLMEx6G0h1XiRUiEIn2SxrZ2dishGDBMGKXmJMmfDs7FyNsmPRgiKJ8ZLZkmWYsXJ2RvxQlox9GTJkifEbE/PRBE+S3hBHiIOzFkx5XB0LgwKxufoVExYxOBKCTo68ZJnwiCZJjwx9EeFZNj+hDMDFwNCx9E+UOrKCYiKEtGBYGjKHIdmXJufKoSgSiiIRB0O0RI1JbwgPMkQyIZgSihhYHdFkO0OxjKTcnY6YlA2DGimQUOqEpRlDSi3gmXRFnZMkwKmNBwKUJ6E/DoNSpGkd2S56G5R+hOPQ0GgwgjQ1KgdqB2JNj2PwDbNyZDlMmMCaNQLECuh2OhYdjcuTckxZhyKUJ4DQYBiiJFY3JIlJFybkmWTAnDGhmgSgTFwRIrRASSJsfI8yTzgmPQmkycDgYoiaFdGR2WJ2Tvxgx4XAsQagV0Oyw7HycjcmXJMOSYE4oTijCjyrHZkmR1ZNyTcj5OyTfhCIgiTJPmCIsQaKEQUofAuCJJkbDtjVz4mGJGXiYRFQLECcGRWZ8omxOH4j6MfTIqHyTY8+ZOhqhWZH5jZMCQ3AryJci4YlPsQ0Ntno9DMEQKjBEZE+ReIkdiMfQ1wNbRMOhqBqBJbwJciXhKRKUO0NvY3wONDamjKSb6HWBOKOCFEQLECIXZldjclxQ7tFLQ00TDFZQJtUNghUxGGLskXYvyNSuxtvA3wTwNpOjIa+xj0ZYowxPXgRK7MLHQlEofgZwTAMPoy6FmHghMMWYFgScChOx2h0GehhxklMk/YwLMC4FGDUMX5MrsmRNrBMhNjWyYZgmHA+CFmDg/BI0J12NSuxpG+DoMbafQ69CyNy4MoE1hkjAiUNzBKKG5x4OyYMGBZsSuBKBQKWiZQpY2NnIb2N/Y/QyRcCwLHjJLYmMjZG/DE4JhmWLIsjE0LHn15wY+nRCgjwcBG8eCIZEswMY6FwRCJrsWLFg6CXBM+MEWWLzR7ERXhjMDciyNWPI8+Xg14Q+hZGJwY8MQrFYnPhD5HQ6HQzrk3BA7FYlJBGzIxwkUMGCIIFmBKfBWRKOyPDQdEQJQRcECQlIsmTNmSdjuxOh1gwZQK0CUULgV0WFYm2rIiyZsdWNA1AxwMPsRLgzQ7oaTASk7HdjDQaDIwzoWYGuBXRYoFaJqRLY3Aw0GDAsx4nRahWZMic347JSRgmGO0CtBFwLgV0WJlCc+FyPkbgdeDYjoia4M0MJKFg7OxuR1Y0GB0ydCE7gXggrRNSIfgw6Ig6FVE6LUZZJEic2T4nxMeGSbG9ET5JoVKRcmTBMeV5yZ86EN+G4EhjVx4RYgpDRAlCk7FyJjcGCPK8yZJ8vkfJkx5iyfCvwbkihcjcmDB0dComR+YIm0RwZwMfjA6yKskcjnZ0ZEQxqcCvBj0RBBjODGT2RyNaIkyNSRJka4I3oxZBEZMZOxGmZogifENmbQ7wRD6MERaPZEZI0/DU0Z9jf3IkjaO0ZwNDRZgjQxkWjFVMczDImhKfYvyQ8oicEz0MYwfgY9H4FIXDIsQ3RTJn2W7ZMhuSK6EpvRhyYO2BOMmKY5UyTpkSRIudnZeUTODBi9GGSRBGh8FqIn2T9yJM2jtEj5G4vwQlYZLwYybM0L8i/JDyy8olvAml6PwJj0Vh4dCjZGvE+J8aF4mDHiToiaK+RL7mPfiCfExZMfQ+DHj3414WCNkyYsRMEfxdmSDBj+CBBqRUKEYFC/CHYvL8eiYMHREfVr6cX5Q8+J8fvx6MGCYII5PZD2RyTJJnGfHoxaMY8YGQiIyVsSbz4fiDFjWxIdDogojkciQcvI1LInBD0evET6OtER6F+CPsQ4H2Q2ZMilno9C6HWCCTFaIj0ZC4ZEjYbPyLmS5lExaMCI9GPR1o94FwzNMicisb+5P3O1kVWNRfPjB0L2VsvZeyExuRtMMLlZHeCvEmCDpi8GclM/IvI7WRLa8KTIglojREDjYuGJHAknxNyS1aJgL8Ex68T40RImSj9nsRG/EwY8SWPHiJY3dCnY+ROfEyS8FeV5yZJ8Ys7JFg/R+hQT4Rkyd/VgiCReYkyT5jfiYMEifjogSRBBH0C8Weif8ACiTvyh5KCoVFo6YsDNDUjUjUsnYzLnzEEQcPGhuRoakSfHfiRKBUKhSqGooiaGpRkdjGrO+DFihOTAoXgSk1BE0aMjUnZGz2KmIixUxKBUQ0RpimA1NESRI1JhibkduTIqFTOAqoWIIlCggd5HZYbmzs3InDEox4KCnAxKaGpRkpkiJOxKG2YKQqIOjNGRuRp8Ozckw5MWJpOhBooiFBUQyXEEa4Gp8EG9k7NjMCoTwMUJ6NCciDs7OzsRMCrwYE2N6FdDwZLZIqsyJlitJMEwIIMV4gdjsnxGybkmxuC0ND8FwLjxkbkbCZPnFiESTofAlQjPg2QdmTDGoE4HRk6OhGSZ8M7E9jsx9AgaEvET9aoiPHREGSZJn6exic+CjDEpVix2RGR4ofJ6Ik2NijynyJT78Q/FxQ+iOB8jI8KD2IoZUENodjtUPoa48TfRhjWtCSkWYYqyexfkiTPsctSPoeaGoswQjZgS0LgUEisSm2SB9DO0NfYiH0TD6IsiyDCGJSuyPuRPs12NOKG6oa4G/sRDIbCUPohorYnoYmVGy2h2i0RkbgTg70Nx6HT6OtCzeDsdvCMrs7HiUPoyEizl4duEbgXCG0YdiSuxWuxJpWch8l5RkubJSdG4NwNoYyuxIXZDaJ+48WSihjceG/CzRIhMmSZQ7RBobnPhMk2Nueh56FGhEd+MD9+G68Mx4ZMMSstkXDFgYsCwT9ySfpTli8T4aF+TQ/rnQpFgWBOEO0LA4Cfksi8vsskkmjQiCPJBBkInyvrTMsSjwmLGRWZUjswNA6G4Y6ZCQ8iYrLGUK7HY0YsmMDodP6ELgSoyjNnZlUNQNQSRBg30VhiTVCuhWZRVin7Hgna8GPEjQloQlNCNiUitDuxqLGosSI8GGYZEOB8CaEpLGUJTY7sipHVjrA6MPx0dHAbQlKFaMqTUjtSYHVmGYZEHQnoXAuCwrRyMqX4b2NjBEEwyNHQuBKaEnwKkkypNSNFjR4TBEOBqBvRwElDyTUnZqRckxY5WBxgMdG4FwcBUWRMoypNSTSGNyJwZCpky4HwdC4FwJyiZsmpJpEwNjfhOB1QqYsjaEpENSakWPBuB58THleE5oyZJleOyRuCINk2LPiSxIlRMrw+SZHRggWSfCsnxPleMGDBPleET4QRQ0MfiYH4QjNEHgyjOCd6HEGBKB0KvK7HZMjtiH0LoVWhuPQqMEQPsnXiNEfcliJOzsmPEwSdMZ7FdGWZ9iUst4HeDsbeUY9GDBjJEUx8D8O8mTJ6Ox4IgiB0RBGjoS5Misz7FyPlCXBi0Y9EQOiIPYiJM0R9z8iGzNnZMX4iPQqI08DXJE5MmTJHyIbwZOzsxeh0SJSMUTo6JiiJJnw7FyTKIIg4C0IijoSkY/Iz7Lyzs5EtWSl5FgbWGJxT8SvkgmSJwTNrxMX5Y8p6FkiWUyJWRLJmxckz4yTBEeOBMEyYFdH7FVsSmzs7JJgS8IkS8Z+lMZMeJjxIkRJkmfHZ2T4T0OhYJOhIyZ+mZJgx/AifE/REDWiPEfREEsaj0YRiiNGMeMmTJk9eEzA68JHj2eyIIkyOyeCbIjBMYMeiYHQkyOSfCsz4VM7R6IhSJwOhKCsHsV0yzPhEkyJECbWDGMGDBijpEckESZMnoXIqtERY6IjwEo9FbLIInwyImDoYwYMGKEtEc+IMmc+WeiDBEFCNHs6ZDRE+yPkNT7JkjZ2JtYGo9GKMUQ0ONeEiJ8LZ3svJ2RNkp0hBIFgrZLMYyROSUXvwhkwqMLoTgiK8RGSWY8OfC5OxMjZMHQkT4wIyTIyYHydnY3Jh4jzPjInP8MC48JST4T8di5JJ8oeRYMsYT8zJGzBj+FE+HyT9Uk/RBBBEGBUYJijNEtodmTPh2RDIgVCYqMUTKgyZyTJkbkbJJsdOSYMDQKqHVC4JkyZHfgfJOxKLE0iIMUJxRhQN1BkaTJnwzZ2TswYE4IgVKCdEtodmR34Pkw5IhyKhUKiNHRGjKsUszkdjezs2YcmDBQSHwdDcmUO/E7OydkQKERAqFREE6HY3JkySRNm5MWYFRgTgVKDKgtoYyZE5s3J2RNicMTgWhEUagiVArRM+DsmbEtkmLMMX0kz4OxsVD5E4sdX4RB0JxREKDUGfoCeybkm5G7kblkwJiYMULgzRkmRhvxJhz4kTgR19GRufoTkmDBgfAno6FwNC8ETYnL8THg3BhC48I6MGfDJB2dkkwJic/RBkbkb8x4mBCfIloVitGSeBqcErKHmdHZM+G48ZEJLYrQnNDsdj6GTFmPRgWYYsia2NQoMomTKHY2sjfA+fKcMTSyJaFWRMyZRlDtD6OQ+RuLGJwx0xKBRsSFagyhWPFDU4G0Ns7JlmxOPCQjCyTUMmUOg7H0ch8mPRgXYlyJ6ZhQJCcitDslD58owxOBIXYiZMmUOGPo5DHyO2TBhiQuzXYjKgSkdjUjezkd6G76KmhOBqBGLjYkKzCDKHQbpFDkTDMPwTtoQmt+cqiW0IiDkNyRsTl+Niz4NQrQqElCIOzkPxJsdYFlop4ISlEwjAVj8k58qZE78J+Ea8MbF4TIdYF4YXhkuL86keRY8LJRkQJiFj6GSSI2bF4QzXhisbGPzI1iZISZlGUZGxsbgwdCrxIhKRXQinZkbmxjcYHVobgwLgQuBWK6EiZQ2chuA6MGH4XB0JoVihitSTI5djWx2pQ3Fjobg2JwxZgT0dCsmSmO1I3NjZQdEWKhcCzArotQm3RlGUNzY3NlLHWBqMEpM2LIuBCuhJIoyjseBuLHRgwQJCFdCsUMyjJmyCNjqzA6ZsThiqhCuhKTJmx2h8jfg2OmLQiHAswdCSJyhU8HhM5HITMMyFTOjcC4FwJTRFEyvGpMWOjIdDybgW0LgVCuRpFSFyRKkRyG4Hbw6IihmaFdCUjcoipFiROfEwIYMMo4ELgSkyZXjskbkdDp+Nk2YFoIyZNSLkifCcEjIVMjwWPGSSJJlSTUjZMMw/D8Ik6I8QLzs2TB0Y8SQKfCuyeDRiyNmDGRKDORqSRoVisS3wS3Z2jFlowYyYJk6LYrE5M2TNozg7MCocIwTA+CIM0Zrxn2T47J2NwYJjIqovDFmGdEyTJRmxcomiYtGLJgVZIgzTI0TJ+xWZEpsluztGLJglCqmNQTohOjNGTJmxXaFdoxZgiBwjBga0RBmjNeM+dSTFjoVDrJGvHXhORORKSdnaOzF+UwRHiNeIFZMlrJ2RsmDBAuPC4Ohw62ZyWMkzZ2RvwnBS8Oh8DCwOzPhNSLkXImMRBIqJJ0NQZJkhiEDsV+JjwXBjxJEjFC7JJ84Ijw6ESb8RIns7OzsmROPDo6OiYoiRsSkT8dkz5w/EikfmJMkyPzJAiPoifKXBJnBSxgpeL80xX49+II4G5MDpCGMYlJkyT4mCNkUTBjx7J0/EE+In2Jt2doYnglK0SJRknYXD8fsTmtjcCZatEcHo9Ex6+iefCsz49nYuT0T9jHodehYGT5RPsyT4VX40YMCwN8iemSZM+Ik7R6O0TwVryonnznwhyKWT9vGBLxfnJkfIzsfJBeGeh0Y+iB+yGxPx2Z868L642RNir6a2Xv6YJkgmfpUbJ0yI858L65I8SSKxPzP8ciwQNyJbJkWfE/TP0STP1z4yT9CQwKkYoXiDJkmcGSdiQjA3AqMDRmh8MbkySZOhgd34mKFRMUdHTM0OyxnzIm1YnBP3eHRSmJyoJmhufY3JY7QuSZsVOTBMEwOhYgmoNEyZJnBnB2J7FVmB0JwTFGKE5UDawx2RJJJ3wLk7JgmCYJijFERTM0ZLGReEJxZMGDHimTNGTJYdmbO/CcORUOjB0LgXBEmRqSZwNza84swYwdEwNQhPRE0O6GpJs347OybKRgwagiKIkZYYXI+TsTasmMeTA6GoEpod+BiI34gkQbhiHQ+BRjY15IyFydnYnPiYMERX0ZJ+jsTizFkwdE6MC8TJMiHkS2dkxYtiYsdCqjoWIEjLGMkz5TETHhs6JgyZJkakmb8T5YULIoiGKdjSZVCc4Jkc6N0THowJw6HWRULsXfhIiR2qG9CeCSRuzBhlTDFwdExR0NQh3gbQzgbHyNw5JgbhilOBQhOfBYM1sabRlDZ2MtGDDE4YnAoWRVTEmNKMqsjc4G5G27Q+dEw50WvQnY6yJwLvwV0K/YrXY1I3CieCdkjcCoVMWYYjQ3omhqhvgcsGbQ2N7JiyYJgUplITFSE6M0OWZGx8jMGGJwI4MXhYyiWyUxvaGyYclq9CcMdMVeNsXAkJjUokTwehCciybFmxNmheHgkwOxvZyJhybKboShjaE5MBOo8RInJHhvy40LP/OBC4J1sTj2S4I8Fdobmyfpk6F4kXjJM+ceGLwiagXjKJkmSRmXhCz4WBOoHSFY0omCZMEyxSVo34kkkkXi9E8CJ+hi2ClitEyYSTIx0TA7Dab8Ni4FwKzJJA8Gg6wMdDpm4HkYhWJJBMrw5Q1A3HiZZMNiqjoSMkyK0K7HdkpWNwTDMGGKJg6FdCehCtEyO1PA+R8jcWNwTLzOhcCuhWO0TK7IoeDQdYG4IhjpiCOjgIVitEyvDoagbjxvxIhIVkyKzPsmcjgbMGC0JWdCuhMQrRkzZmySljcDSHkwzNGUI4FSJQnK7IasblIZ0GSwOmYZEMmzrw1IrFaE5RHhSyY+ltmHhhESdj5+snrwrUCHgipFyPkafEwKn5kVC8M0LE+MJGx+EPJsYnrxospOyZGM2PP0To6OiZFVk+I2NPiYZvwmJQK6+hcj5JJ8vxInAmJp4ImyZwK7PQ3FjcfJQlIROiSUWp5Mi7JkvR+jsbgwTGBSmLsdGSZMjck7MjEx4bgxTMUyIpmKK8TJbM2hXgbm0OMjeGGdHTI0JSZIIkzgTmyeBsdFISjJGjp+FDotWzKEpydnaLyhRlGDBMehOKQlyVhmTJlCciZkYxY0NwYyYpnR0dEmTJm0RODI1sbHRMeN2ZoV+FfsVmROb8PwwYI0bg6FGGJTTyLTZDeTNnZ2JxZjwmCGqFwy8CrxkmSsmSaFV8jcDpGEKsjVwdHRECUj5FydnZEjr6CbOh8CFdET7LZ2Lk7ImyIEFT8N3AlBknwhnZ2dnfhjwuDowTJMGTs1IuTs7+pkmSOfEVInsnZInHgqZInZOiIMuPoXJMiGY8Mb8ZJ8UsE8ElPRImtGrG+RvkUjsTI8NsXRJPi/gb5wN8nYtk/fw39zXYmxST9jHo/Xij2Tz4bkn7mPZ6yQhLg9H6IPRHJ7G+TOcksk72SyW2Po/RMGBV6IR2OmJM/fiN+HORdeP0Y9GPRjOD2TyZ9k/cT+5vsj7ibPXjBhC/BRPJPInGSfPrJQrweiGvMcnseb8T4m+xuRLg9H68IQ+xsdMhoyZyRBs7RDInPhT8CjRNjfJZ+xfkXY/yRz49C/B+j9Cx0KN+Uo+hLjI4FIVfRC2MfifpQvF/BMejIfhLys/Wvx49nvxH1L6Z/igs1XhMyFj+L9C6+t+byE4JglKjFGaE5yOx34mRStkwTBMEwTGDFck6J5JnJMjcjcjcjdjeyWSJpCob0TUE1YvBX7Jn347RUkw5Jglr0KiEhqBMzTLZ+g3I7tEbIFKtFL0TBgVUxKKM0ZpjcqB2OydnZMWTBMPoVehuBIMUJTTJmjNDv2O/Y2MOSdkjGDB0dHTOiBEk/I7H14tOSWsmDAqpkQLsammORWOxsa5I2JtWhVehuPRMERTIimZUCh0yyhiSRJYRuSWrexOH0L7BtUREUdCSWS8CU0ZJ34dnZ2JlBKDrzgiRKSZ9nvwqJhyNwYJgiKGoUCeiJoakUeEj5O/HIxfJgmDFeM0THk7JkxZ2YvwySYIivEkGSSfomDHidfTkySQZHREE+HR0TrwkmOQuTsmfGLMX5bkVEkET4T5STFkx4J2FyJoV0TwIbkkklDtQ3AnDE4z4JkicIb0JmcDexsoSSJwxOGTAuBMV0ZG5Q3OB8kzZP2MudGLRMMwRBJn2a7EvuOWOzoO7MWYY5mROxIKsiemLAkqPGSwzsrI2k6MCcMXYqpiqmLgWIIlQTKHeB8jjJG/E2RImGJwKqFwK1AlKG5Q3OB8nZOybkYmDAlAmJ12fsX5HLGUwckbknZLbE4YqKCehcCtQaFZZD0zsWZHBmxOGKhBwOjUCU1wMLkfPhgmSLLTFCYuBcHAWI8ZRMnZ2TsyzYq8KCZMqNmoEoRkbmDkN4si5Jh+F4kfBEISkbkY5G5E5ZFkj8oWBi8saHz4wKjDFnwRmhWTI3Pifr68aJqCJrwbkyNkQ5Jhi+hvQlCGpGGJI2JyzflZfhZE08imLJGNsbiyYwUJgTE3JMUJpiYUMk8mSakbjBMDcEwyYJg2J6FwJ6EpLakbUSN1WRucDcYG49EwxULgWToV0KHkiQsDuxrY2tZHyiUnKMFLGBcCdwLgVV4V5NeGvuOR1Z6J8ErFkT0JORWuyKs/Iyp2hcjc4yOh06MMpGGRcC4FwJ6ITRlGVI24GxtrA6vQ6Yk0xcaFmNC4E9EHkUtGRtux8jdVkfRMWYwOnWDpDzB0V8FyFiTPsarsvKHDA09EpYMiLFw8CjCEgtRnwpospY04HCwbJhmRuCLOhCZlCY0PE+HOhtZHnxJuDoSgtkVCZG5s5D4ZG+DFmHRjBgn6UpOyZ9jbHz4PImbOiBPREmfqY2YMGBHAXAgjBaE14Zs35RPhkw7HMHYyNjG48ESdDUCwPIiYJWsk8nY0+NkE3A0J0RI0mSZJ2cvExfInA3AySSdGaJJkn7BOSRuCYG4JgfBmjoglCngtk7IyOyYsxfJYmCdCE5oltlsyZMjuxvgrJhDowyLgT08GHAskHRYyZE9kzZizlyfhUTf6ME/zC/bIP+3+xkviU/qR7BD7M0RNeFZE2ciJvwgNBaGtMnRuCNGRWJkzZ34xZ+3g6OhPRuCcCJMmSWyZs7RhSUh0YOjoahwQZoSTNnI5Cezs7MEwYo6MC0IlBmj8jJyOyYvkiQ3AlBOjo3HjNGTJM2di5JizHguHnoy4MmT8iG8nZ2THkQ6Fwbg6IkTkbkmSJJmzs7MeExQ3A1AhqSREickHYmMmDBgZBEGTPns7OxMbgwdHR0dHRBPiNnZ2TInHg1BM0RY8ivyNkSTNk7O+R+BPR0JR4ifCJMEzgXRMYMeG+T2exWTPifDZeiG7RK15reCXjxhx5/Z+zI0Z8ImPRj0JRQdDPsT28KxeOXjVCMEQRB7GpyKyJyZMk8Ezg9HoSej/AIDPWvn7GBm5s/19kJJUvoSQhO1JJN3977P9P4Gmjhf/AB7IL0Q8onggonnBLwI68fv6J2TPmY9EJCqn4zRmuCiJ9nbFyIk9CY3ZAqwexy8mRyJIknZMl6K0X8CHGxcCICTefCa+RfksZcSiHlFaLHgX4OCOmJQ/K/JEEkbJ+jAlyPxmvog7GzQskwyPsJ8G/GySSi9kfTP1LH1TH0+/4v0Pwvpf0RsQvwONfTP0KiZ+pDz5WB58o1kwuhUiIIjyrHZMiv2PbgjZiyRUTCIhCUUiDodlh2J3OxttyMTatDqxIswqMUOqLUZRYyZE77LyVoxehV6LXomDFCWmdMma8MuifuTvZeSdiexUY9EwKypb/kvoQL2HH/G8/r+F6RKemMkuVvZf29ZFRj0RHopKCJoTmjInI7E9k3I+iYtDhWhPGKGootRMkhnw32TFsvKJ3oSPRDwMHASijNMlsdmWTvZ3svwsz4JfApKhKBqKFwdCGWNyK72TN7JbsxZjwJx6IikRFEUJxXgg7FmTcnZOyYsSBKELQ6FwIYyZ8T47EMYOB0THkTTP2YyZc+O/HLkmBInQ+B8eIlCETZM2YDqxLZMWYIjwuDrw7HZJnziyIsVEQTR0dEEmTIn5mLFVkwdHR0RA7HZJE+Iix8kyJxZMEGR8DVeIlGSJ8khLZiyApImhKKEqsiTJModnY7HTk7IEoYqEtCEiJgNykNyWG5s5DpyiYFTIgVCcISELArQnKGM2Zs7JixDCcCcCoiKJoyimiw1I+RvZlyTY6FTFQpKljJZsuX/rhfyIhpvKL9P7+4uBcDVBlQPA3KLD2HyTDkkmKmRAgqEhGArRMBiJsV2RcjcOR0yQnAnDgmCIUGoMqBpNDssTNjY+SZJgUJicUJoSiiygcNGUMWHychuLMWTDFTE4opWxTEMwgSlQRI7LDc2cjclBUyI8FQlAhWiZGO/HZuTc+DBcE6OjoiVHgw+SSDZBMPws8LgT0dCVGUO0jkO7ORNmGYZsWWMJxXiBqUdk+e/Eeeh+M+DtDcjEyxizBBBo1HmJ+qYMhWOhcGPCUmTKJnxBkwxK/DTkwcisTcDvJa0RwNDlYHQ1ZFiuhohCXJROfGVIhrgdWLWCIIgasrxahKMiSQmrLdtFOx4lD5RMWVkynAs9CdwdBLTOwsdkSjNkyRVEJ2ieB16IlkWTLg6FwKIYuBovpaX++/X8yoX/AIEetr7aLgmVLOxvaHCxuDIVCV9CaOAuCElZZdkSryJtqWU7MJQ+UOrQoyJ30K30Km1oSzgxdmHYlVmVJMjxR2ieDoLPidHRwFgVBUKLIb8KWNtDhhGn4vDwVhCUeCtGVLFyPkgvnxMM/AiBso4OjArE5QiVYfQxuL8pLFmGJaOBgaREowkblEVJI3BgWTZkJiQ/CQWPEUaGTY3HkiGLPg2hKTATldic34f0THifCUjflBMjH4PJs2LwhfShjRgga8JQQRK8xXh48SZ8IQhFMiSJ8RwYsdEQOjBYRAiBAkZB2RKkd+EEYIjJDQ4ESII0RI1Ik3aOzsbhSOhwMG4I+3hCuimJNkyZsyYsoYMGBKHBGjo6IFqRtfvS+9/H8+8pV09MeyhptP2qG2dkpWOHocBUzDg4ChnW0ZyZEnZHY+RVY6HAwYogs4JuBO4M1sz7FdickypNSOrNhMEQRAlDg6HwdCUjsiTKk1KMWhIIkNumimNx4T8JQEOxKbMJJmzsmL5G4MGGK0HATuBXR7EWOxckRfJgwY8R46M0QmQ2Zsd34VFPJihVRuPETQrEMkSK78RKkaCIMhqBWdHRCdGaZEi5FydjDoaCIMeYlwZFZnz34gwT5R4SkyZ89+MGCPM+EiRKR+GETJgiCPKsjwzRbAuj0KxKLMELxEZx4gQSEhp6El4wQQUI5EEm/CQ9PEhrg9DRLRjwjQksM6YuBtOjImxWJzgjg7J+xj0YII5PZDImjJkUiFbvPxhf7+f8BMfCz84f+/kkmPXh0xcBcCJrgl6In2J/cvKKmUXogbFRggjTOmLhjUj+4T+5nJkajAn9ifsY9GPRBEFRZDdPzn2TJ6OxP2Ii9GCRMERkc1JOiFBH3PZehRrxBMkx6Oh0JQOMMXB0JR7E/ueyLFnxMeSPM+Mmfo7GxODB0NQhYI0LjxkT8p+I2evCXJ7J+ivkU+I2Jz9Psli/imB0Lwh/RBkRHhBgjzBBj6YM+Pf8CQghr0KiYpnsjQr9kSZIIPRGxLeiCIIJIjktTIkiWNSXZE+DRGxqCIGoGtDnA03Q3NCsyx2di6JizBMGDBCOmRplssZJ2XkjaI2LNbFJNEvso/wJOJD7P+jBM5JmmO8ibOxkzYuSTFmPRQQnonQ+DNeDsakfKI2LMipyKvCUKBCtQ8HTIkyNyKzvxmxZEYwYo0LhnRBE5Inz2bFTJgUoxgS8wNyNSNSxsXI+RZFQlDEKqFfhqvDsdkCGKrEYIgkmoNQZEzJJF+FyImDBgmCIo6PZZE+xT4Ozs7O/B1QuCNHQ+PGWTJmzs7Jgx9PR0QZMkz9GBODHhIfAkRJkz9GLMeMHR19Knyl5qNGSglAnXZlQZVmR3gYeZEiLkiGRAqMCRGiBqSJIkYauR2RFkQJA1A1oQiVA7RLeBuSw3NnYuSYZhioSjInAkLECVDtDsdlrOzsmLE4ENTw0/aOl90dL7o6X3R0vujIk/wCBlDRfJ0vujpfdHS+6IwRtNb7gjTLwZoeIGpR+nhuSb6HTFkpkwyjgYuGKzotmRsrJ2iljodEwYYiJHdbMjJisUNSTsmGEYFTEL8iZgThlGxdibgyZwZNnY+vCpip+GJDUJyTQxkwbE5E5LHePC2SZM/RJgaHYxPA6IrxEogjyZ8Sb8MagqIEqJlCDs785SMTjyT0dC4EkTkakmbOyRZFQqF46NQRKM+GP6EJwIQxIyJSRJknxBl+N+fREeIkySQZ8YF4acnBlMmVeRWiZRI+htCcGH0JxQ0cHgTWzsLsQUhqRKR2QRsgwOxCkjkjKZgRI1KG00uTVEND5JuRNN2J6YFTjQsi4OwhWZJTXY3wPofRjA6ZgWRK7FkXZ7IrsVoapjTW0MHs+Vp++fqnXCSss3r7ZJHQ3A6ZAkjcoWBOUO0g6DvAuR8iaYyYpjcZEtOjNCujODOBXZ2TKMIdWMwrHWR5Hx4sdiI2ZUo7Gtko7GMmMmCp8PgbmhIV5FiSykypFY68MGBKHBuDDgT8KGZstfiBkj6Gdm5JhyTD8JwzHjZN+cIY0ZyJ8idkk0SIXiYKRAvoXhMYG08EwzIwyYFTG0dCE0aEtjT5342KEzcCExeF4Yx+cGBecCsnxHh+N+PXhWyI8rwyeBm/CH4QoeDkKGNUk7KIxZMMbgXmRWRIlJBixIuiBqDH0IGh8eIkSRqbOQ6sdKRoHR0XgSuGbM0ZJkydiqxqCIKEhM4HRC0RJnwSkTgZsbgQMw4S75/r6nYxFp/EMwUjpj4Z0ZGhR8iUi6GnobiB05HmdCpy8eOwrdjctNkSRPsTi1kTizFol/Akl6EhIyO8mcicmfGRc+MGMHR0RoSkV58JlCsmRL7+FOhIS2hPa8N7PwG4KVHQnViFfjInROyeDAx+XQmNwR9hVRTIkLw3HjoR0ZyLvw7OxZHmhqLHmjZiiNCRGyZIkmb8JwMmCCYMUQdEeESPk1J2LkmR14JxRNwdHRE0T4RInPl0OifKfCcmfoyYEvLQvDRMk7JkjwqEjAjPiPEDsoFOUJ8H6J+xgagmBNbE+SdPwrE5F4S4EjFin4HSOhKMj7EjoakbGmxqcHaOhb0THo6FbNwyJoZdmRfkifZDZ2hLjxj0JEwJEbs9i4Zbp+IkU2cQJ/Lg/5iP+Yj/mI/4iJEg4pfpSL60kwl9Vjy/K9MaxF8f6P+Iht/6D/iIdxOFONtL+xqbI2PEoSi9HQsTDkwxeBJzeDI7wbo7MORKLMC+QnFCdQJxRmh2MZwZVDe1ZmxuBU5FkQnFERk6FwJvA1JMsd2Pkb2TsngxaE+BVjAqIogjkzkiSJsdsfJi/CcYMYEjAq8zQ6QxcM6EtCeifCcisQqyJQoYsWaNFhw/EEkjWYYq8IxXhWV47/lSixufKowToiPESZH4gn6fZ7JI8ZF+ReUfrzHheIH9CJ8X4XiRfTAYIhCYjTOmXhibWSSJ9jb2JtiYhMVeEoMClHsl7P2ZH1kkfRi0Mb4EjGBj4Q4wz2O8mfZ+RN9irJ2LleIKGCNMxkjk7FkyZJ2TwdmR/yh/g/wDI6G5Grnwq9FDQYUD4eRPTM0xzobejDodOUJqehOHeDZCGgQojgTrsabJnA7wOVgcLA6deCzeDFCK8K8jY7VZMnofQ6sbJgeZLyJbE18iIoVUxVTJ0xjsdjbJ4NyRZsVCG4FBQTAiUh1k9ikQ/O6HePGRcMVrw34acD68GIeRcHQ3ImzKMiFWPER4RPixKPogjZixVYvCEyQlkbfhmxOT9iTE5KVrzJ0deYnwn6JkQhPxH0RJPiPEmB+a2PyvogkoNAtBcHRMUdCZETZIrCoTmxMsGRQShQJ6FwZMjcjsY+fDlWTGCYKD4GZMoYJI9hbIV3oWZN+CcCqhKEWUFMyjJbGpHkbsibFTnRX/jU/wf+B0GvsY9GyNMXDEuRWuxNrJ7yPlDemxsP5DVnRGtCU0TNFixKY4yiakdYMYMHoXYsizAnLhkyIVkyTQ2YwOsDoSFmBVQswzfR7KZJ5F2ZV5G5RNeJFDInwhPQqySJ8jtEjwLsk8isTkT8diq19BJ4CJHMSShCodD8dEDcuB2zJIiPGBeOiCR2SeGTckxYnBQQ6OjUETXBnyHyLkWZJixULJMC4OjozR0ZHY2OzskYVCpiJ8oTkz5ZgwYE4+jAmMyd+ceENI2itll2K+w1KXI5akspExa8KhowUY4iLUzCxS1fimuyJwdB9DXjYmez2dGFjfJbOTCRt68G4G0rLTIh9CdmQowxVkTlQKzI5ggkYwNTaHXowy8aNmNJh+k0zvfZne+zFyPsxcz7MaRX2ml98CaalfUyPSS2x9E38P/AEPkfZjVt9mNW32Y284Ip6RkS4M0RNCsiBEkbHyRsVW9jrJMOx8F4YnInNCQ7IlSKyErHGSQ0ZOxjIswbEfsmfZnB08I7FkxkwOmbFfhjgzkQypYzBGV34lIiBuCJGxcCWmdETkbkizKHLEpwZGvsHKDe0Poi5EbMeE4yIQyCHkvLYrp+HwKhMXOxeDhCQvOURKE0TOSNi8pgwKmLg4HAUYGoFHyOYvwzZseRZF+CGxThiXjXnRj5GzZMECflCELwvGRmCB+OhCNE+V9GBZFYhYVkD0JzYsSakdWNwYZEMWS1cisTbGksK7E5FyPkwNwOjHhWwlcGaMjtDsshpsSmyljodPySpgTEmhWKxKTIrseDGB9DQ6cFISuDojQlIrEpORqR8jaJUGvTyv+c/U7Tw/dqW/zBnPjGTFM6ZcwyJoifZ+xpkcGcEfYgamh3kicjtjcjvB2cxCKMGPQoHSEpyO8j5CZn2JTKmwlvt9Cf/b/AGEpzD7v/Ylafd/7ErT7v/Z1Pu/9jev+D8iayfM/tf2J5V0y/wBflEiia5PZljsakkV2QVbbSsoB0Vv/AEvycgctP4pfgwW9JLwmjUn6MKP1Befxf0f+59jKpp9/1ydMfYx2fsWcj0qu9/B/wf7D/g/2H/A/9j/gf+wl/wDb/Yb1Ufl/2zHT7P8A1+y/ivWfs/6bI01DWZGk2KnRswyRMXYm4INpdjr7bZdM2+y/3+T+vE/liKJR4yC9pC2jbr/T/wChfNDjPyv9SezI+R5FyJEk2OkIbC2/9ISl/v8A7H/C/wDY/wCV/wCx/wAL/wBhRqmlMZT/ALk1J2JjcDodEBrQlLZfPDjL/wBL/lHKnd/9fgxovSXjAkzIqvVfoUuTp/7/APB3C0+GdkwLlHL4Qthpt8tv+oEn/v8A7H/O/wDY/wCN/wCx/wAb/wBj/jf+w2/9/wDY/wCd/wCx/wAb/wBj/jf+x/zv/YcK4ysmRuB8G/E+FbgV0ZFYvLGoMEEj8P68GDBggYyBWVgSy9C6wPkkbhDohKmTpivIrExKRWSZDIrx4RgwUPy1JYdkxa0JsfZEdE+CYySiBcC4Ql9xWZJOyDFmDBgwRozRE14iSJ9lsjgS+xEeERQ4wul/v6oNYJ6ePz+zI7Q7HY2Z9nZ6MWjAj7ER6I0RUGUNSOx3gXI8jqxOPRhigKqFiBKVAuDKMODOB3gglk3ApKYSS+38Njy/K9Mn62w+evaMk7OxvYzn7OfX+8FCHe37f8EOpX5XaM3Vtz/zaGpNknHbSfW/x/FGkvT2v+fYg9mw+f8AsaihKBuaMV4iPL/5ki/6Vel/b/H8K91fj7d9/cekQ1odkkmLMZHK030t/wDORCJLC+qf4Nr7GDBjyjLv9LllWvZ/64X8EFfT2ho0DUEPNcfb/wB/k9ohfkwRHiTrxEmfCRCEIkwRH8eDH0od/R9+Ex6OGjpCjDLUJT7G5EpE3IvCdSKhKBUYFCo9maYkZMjckDlWOh0U9FPB8MjTIbpliZZmzs5HaE4vRMGCIFx49maY1SKW8JEsfyP/AEmJbC5Vr/r5RkzZeRDpKSfqUj/xhL/1H/nH/nDeEa6+tpNQ8DCX9o/8Y/8AGP8AxhWpJENeiJuR5kY9CG29IWy/kd/hMnU3JWvnj5FVEUZ9kD8ehqMGGLIuCucCS2JXYsGUJyuxucGT0S0K1kz+39fxo2mfRj74+fD5Gr6Jmthf8Y/8EIklCX8T22cp8P8A5kRuRDTh/A8ydoargb/r+/425NP/AJJmDX5WmR4ViEu98JckLb29v+NW2We1p/H69eHTEIVs/wCIOn3z9vrgHZ/eyNC48ZEbwhce2f8AXx/C2kpYpnQXwN8C4/b+7f8AIr2p/pf34yZM/RGxeEIQvpz9GL8Y+rPmfoeBfmJYGgxREqBWNwIkcZ8J7EJwKiaExIoSoXBkbkyWHyTslZHTKPobgdZEgpQ7olOjJklYfJNhOBhipiowKq8NEzREi8ji6/7Z9eGk1DwI49K65Xx+iIcjpyV/51r/AAf+J0MOCLIsSFcXX/b9eGk1DwexRdcr4/RZSakvQ0h9DoiCIYswRY2qC5CoTI7KyJGDA3Bs4w/I4/qfojFS1EL2xM/2M1n4f/RVzSbZ+OfpQkwm/ZgbMxv/AE9v/sWkQlj6F2zhW/t/uhz/ALH/AEv9kir4bX7kljXtPK/519NIVLPzh/7+ShH4VL9v+voS5nLis/lo/wDBQzyT2l/TYjlT/f2z9MQZo/T/ANP9+WKVm9EJ2y/r0v8Av6G0lLKyb9Y+/wDqRvCvbb/0W6en/T/2SYlfle19Db8ThcjVwTIswdEDqrfr/vAlH1znaT/r+hKURoVmS0Yv86/38fQ1uhIatUfd/wCjdIYwsPs/9E2k62vaFl74Wf8AnsqscF/fPiJHQspjlCd/oX+z/wAhf7Gr/Qv9kRPn6GRkzXCX+z/yF/s/8Bf7Fs7fcL9SOr7ZEjoZOyZ8TAlKSYMCoSgXmZHZkb2dkmB0YIgkQ7okVmfMmfCcDSNUMT+41dmVZgjAeA6Dh2hMUZJMVMyFWRpExWhMbPXhtkCcD6wPx7GoyNjsanGTA5D5Q2OrEKhU4Q0UKMPwVitDGRqbQn/K0vNGDDFTgav/AJSv8FZ/5MBrXhcCx/zqXmaQdnY6VDUeDOjNEGcGcHQWJE9j5MWhyhKDHjsGH2X0In5Psv8AtCciux2ZQ/cP7/TK3t+xS3CuRSt1+3/WPoVvWOly/wChuc22ZHakSmxlcNf8/JhST/1fD+iTisvupCVlYIh8m/6/r6JuIm/vS/T8RUiw+Gtlo+J/7+fo78b75X5Nk2TmJV7bfx9DAyEsjJ0ceff+tHXlQ/8AdcMRURPabtGek+Ff/RNqv7v7/wCvuOJaWx+ESWLl+NL+/n6IG0JfmX9EPKTX2f8A2IyMaIua4+y/7+hxuyn1/wCx4XYuPER4yZGhjOxSX09ktv7sfBEomUJ0akfjZPliF4IQjJkf1okXjPhof058JSZYiVIqSWQhuEYDcMtCpBPIkKzKETKkgdDowYZRkWKMGTJEjQ7RyMDCkbgoJyFwJS45OAk0RKFYmRkzY1sdX4f8Vw86ATmiNCDmZNe1YmrH7P8ARXj9n+idY/Z/oox+y/0PU2ScNJfqBJp01w/qSpEutJcv/Q08F8I6v2X+jo/Z/o6v2X+hqkJ5pac8CFfj/luF5eAYGoowex9kcjREkSJbFVoVWhioVVoTSQuPCuhM7o5f3dfiPo/4GNv/AKRawYGILCcvVv3X0IY2Ep+w5jZbb+5CI2/P/E/H0YgEkZM7fbr4FKwP8GBj/ggmk/3P0YfT9MQ7OuU/V/RXNJL8T+2xjnI+UQaYRr7X/X0NSoNjFZGJUaX52/l/Q6fpZ7fHx+/Qh4ERCENjvzkgggU8Lf8Ar5+iRTKl7f8ArJBypfZ/9/RNxnH3X/R2PkdmDP7fpfQ0moeBViOnj4Y4hi/X3wZF9DWx8kQYPXpf4/39HoZiUkipSakXJMWYGE4cERRNwdHQuBBCexcjGYMfTkyT4Xl+MC+hC8NCW0Qsk78JR6OApZEmiIyLjkVihknjIrwJzgXQhMwRBBjJimZoyOxyx2PPgnA3AoRMHTHiGKcMSQkJBSyE8CbgnghZQuSIEmj/AIrh9AJ32RPsiRxkS2iNkTZ2Ikei+9/9/VN6EeoRkakd4FY1tHZEWYs/4bhfQERTI0x3Q1Iw7IFKswYYqExMCcUxThmUTKgcvoyJNqFqdEvso+iZcOPsj+jBKA3X98fIhztm66X9/RNK9Px/xHyRODvD/hUv7+/0Q1tL9LH5/QsicGKGimagR/A/X0RIuV/THZ2ui/P0wXsf3YhYkbok9j/T+iYfBuCLnCf9Py/oS80kYzfLskS2SOjUDsmRGfG/EPPI/wCl8fufoofB87/18FRyn/v+volHw0/zH9iwTAqMCWbu1/f9fU0moZppdV+ME46us/b/AENRnxBgiPPp6S+9/wBfRU8kv7/obllHYn5mPCI8dCqjJkViEjsRgx4fjJJkyT9EwYMER9MSSRFLRMehfYRwey9ns/Z+xX7GEhdCExUJR49i7N34yZJEm7J4Og5eB0INx6FCpmgu/CE32R8hSJNuxTlHoVWj9GPRgxkiKPZ/z3C+iGhciXkbSXtkeP8Ag9kGP+D2JP8Awfsi/wCD9kKQnLa/qTLR5b5f/MfUlTIX7NcP/YnSV9yv9j/9P+xwf8Hs/wCD/YPcJM2t1pjV+Nn/AA3C8qmT2RKEII8MDcevCFs6FSxWrMqyJQ40UUOzgaD+Fb/X0tG29vp/owi/h/oQkJQvoemQlke1cKS6/wCz0dTovxf0RqaRL8T+2xOBUQK6FMFtyP8Ar+vop9r/AEv9jySDhN/iP2/o6lb76/JMUyGqYrtYJqTrTH/X9/R7wfmjZB3Evtf9r6HwNl9lf+hXg2IiB9keI8YIEQra2P8Apf8ANfRDucL2/wDkmXLJn7/Kf0R7t+LIGrEiJEmpon+W1x/1/AklVz59j0qGvEc+InxaNt/6+i33v/X9iaXg1BOiCdCXhnwXiNi5EYEv415YvpX1U8MYEhQYQRKgzRkbljsT2IXPAlFlPQq8aCQkO1A1JkT+jAx0TBShjEmO/B2jkLkUhOBUKhULgXAuBXgSbySHr+vKW9/0/wBGU2NWdPJ+1/gwjlpfmf6HwQJEA4/QvLSnr+g7UmpGqKDN+Ergjx0Z8RKHaE6G9odYKOia5D+XC/t/xMDISy2O19n/AMY6+5jArn0X3f0zl8v2WyZFY8CP2Ohkvvv8/RIpYRL+3+WesHxRJfNv9L6JfkS/v+hqhiYqOA1ntwvS/wC3+Poj1y34V/uDJEPlt/mP6+h9f+MeJIgS5EQOjBEEECWiNbK374+PopDr99/6+5Ekg6fv6JjkhqKImhYIkiREbDQghIfKx9v/AEVy6a6+tTRcqn/X/OyBqSJGpGPQS/N/RNLhJf3/AH4TgfBqBqhX4R4JbErk3InZgVC4FwJaFXnI7N+e/DrxPlV4yZF4ZF+GjIqpmUMTeQrUE1WRzgO8Dc2OxciYqMrGGjJSmSxsV5J4MqhvaJWhtJysDq9GDD6N9DgffjgNSi2S3gfKO0Ysb2YYqzgTjIkHY7CUrsgJNoiVQ8SiSdNfZteZETSflNf6MDosO9Un91/gQcpt/Zf9i4Eh7pMyQElrzKnj9m/9DsiLGgoeyLGhrKFYrInA1JGxrY7vxEMaDrJHzml9lP8Aa/gTSpLluBdt6pff/UjeW6Jhf7+TF8mBZn/5P6XpbqP2MiUYGVKE5HJflfvS+9/H0Y2EbHNfLS/kwz2Yf9f0/oTPsf8AS/vxEUxKFAp2M4MRCR/t/L+ihOq/O/8AXwOhI9D/AG/o/IL9CQvB35gjkXfhFNbPnX+/pbnLafbOx92ME00rt/T1E37NCwNSdiMDyWafRwJ3n7/+jKHbv/f/AJ9Mnr/vxEkbQmxyU20hKFH0d9N/saP2Nfc9mfBjnKG1oRsWTZ0JCyLAp+mZMDcGPOPpXjAnIqMGBULwJyvBhI8SYSTFlFJawYYkITuBPQmhWWRMi8NxgdDocJmBcCU0jJkY3I4ZyG4Q3sbFLP0SvBOHAmK6LCdCsXiKkwTn/kaT/wB+eVIn7X/RwEtCTRdsvHw7X9/b/Amksf8Ap+TI0Qrhy/i/o6aoX2X+xUYQlHsiciI0K3HiBciGMiBsfYryJcndWb/P+kvoVWqLOVNts7fsGcNL4RnX+I/RIeS72ckR6MeiBKCaNM/K+lzFxf5w/wDfyJCrBgTUS2ICW8t8v/mPohcjv00vl38I6I0z0Q/N/RDuCX9/2LsTqGJnCVsgx3wuH+3/ANc/QveYXt4/2M27C5PWm1+W/wC/oc9LC18f9ECQsECquWyXZ6X9ln8LP2/0Rz5Y3CFI3y/f/K/k9gh/gjYrKDUDoSjwhIuqpHzNfj6PaoX5IGRBEHrl/b6OokyJoyZOyKkkVECcCYeReJF4iTNidCx5Oh0LJskVGR2J+ETPlUTHlMSjxTwJsRtHYX4H0OiYoxQklTE7gXAhCsVil4FLB6KViY6MGCJrkcOmZcDHYzY4Og/A0/gSi9ERaIqxcDNMVic0Z9iv2ZFYrtGLRj0RGBUcVJPz/wBG/LU0Svp/jX4P2RPsjMin/v4/U/zr3uF7/wCWNtud+I2Tten7f9eUI28Ia52b+7k6HgalCShqR1kYlDGbgXG/GURQ+jhjsdjs6CF9l9E04cfZAkJQQKhISIIk9COaSfzv8/Q4/C+HyN8uRX/2hTQm+zG+jmn4z+DdDZbP/S6+h3wr8vSHDK3/AD7YGd6tL7uBKK+iXS2atYmt8CZt91/se4p7l/j/AGUz2v8Arj99/Q2kpeB3pS77+f0JmCXjuV80/wBfn6ZSBN5Wn64f4HUPXx/eCjY/hnA/eft/uCPLe3t+UDlRy/3yPc2VQkUZX/D7Z+38sacv7MwRA6ha50hNLXY/6WhNCmhtl4bX+xqHDIHvCSxvOW/9fRUj2/6/vwx1REEvEUff/wA+iSXLS/v+j9kMiPGRmEYJijoagnRAlJnwqR2SITgdGPDEyPpjxJgx5kwZG/DGFKFXoiPQn9hvWhNLIrz4GfYmLwXgnFooKvFYEuT2JGSTLGOUO8DXAhQdD7wPhjUZJ0MQvyLli6PREWhfgQ1FfAkK1ZMWn+HT/H0X+g/6f9fYV4IqjGBCW8Ha/wBr9fP8qEl4RheJf7+R8oqRG4LYtJlZ9vPnt1Hzn8SaHRgwYyTDs1DM5GwGTJO9jqyYtYESKhUvB+gafab/AB9CEbeEOfu239xHsaIkz4gggU3MrXrf2d/P8bA6ErbIlRcL+33+hqRXR83P7L/cfyWG93+i6/frKd+F2Sj0fp/6z8Caalfx7saXL/5kbM28sYysbEbnfvf0ObptriP9o/8AEX+z/wAxf7Ov7F/s/wDMX+xQkh8+4+ir3L9eIR8f0ICIS+jEz9otmIihEvS+h6wIc59iIjxBIcn+v+P6Kve/+fn6I+xa9fVPlC8I/R+iUJUPIs+H4bf0SSSRIiBjNk+OxOfIVehJKhUoOhLQ7HZZJPInYqsVCKFDFCUKGRORXRBMmTse3Hg1FjayP8FBIoY3FGaHY7IkWyE7k7GixOLFAwUojQkdCtGcCeZZ8Y/HnGg0ZeU/+P5JMC02GsMj7pMrntf8r+NuDMOz/wCMfv0OiIfRgpzg7/6fuPojEx+7/wCo/PhMZFg0ZpmrG5wOx0obljLKJ34xYiYVmMixAnrZCvg3/wAfP0fBT9P7FdjEpMjkz4XJixIVmwhsFtcP/mH/AAy+hf8AMckGU4XPb/5X5GlDdHYnhkX3f/X8UACX/Mck9/a+3XXjQjOSJEQfim/4+32/iT7cf98fsmdf/KXiRxYe/wDr6EvdL86HueTMGBGySPDf+/onV8J/fhyHX6JPyv4XpkJDcQv57OjogyZIL1P3v6KHhJf3/fjHhmo8YHY7JJljySKjAqMHR0VgiRsfPm9GLMWYcjceJ0dExRBkyJ+I2LJiyYKhPTJcQLECtQJSuxttVkbbDbWCzkmxVZMDQxCDeKZbJnA7wNeG7G4kTA6MFDgiuxjljLD5GHTkVBOyZFEj+CUitCtDtUZwN7I5uF+9P+vn6Kv/ALlx7WjDsXDJqBwmQ1hkd7nT/wBP8fr+GZySNHfm/fXQzoh4EfNzwuRUwrywGsdvSGGxty/C4eRjcoyh2YUYDDcWPJvomzFMTvwT5JTIbXYyUOBe5x8/QoMm5+GF/vgjxY8GDHhHYaHYiT0P/mRYv+M518/cQkq19KCEl2ytZcul9sv8Ftj/AOYWiJXjAdI1k0Nd8/b60ktCM0rfV/qvySy9h2/tj9k6DZEiU0OCJ8RODOBGvcaf7/fsUyh/v7Z+qrcnwrf/AF8kpQ/4zr4+5M5z4Q8qWU3P/PXluBTJspl8v/ox4x5QTXcyv7+iFV3MvrzKHj9P2Jkrvx9/9iElY+lCSyps6x9/9SObfGj9iEpGdB3ZwoL/AM8u74Q1ztjXjrxEeWh+H9COA1QI0TA8HY2ch8jfhiZ8J+ENSN+DGhhEwzfhhMqBOVAlKIkbTsgrMDRSstYIlQsxyP4JoSlGAnKMqSZU+GYEYIswIamkQtmRttFhzkb2NxZQiDFCRwE0JosJRZGUPEkwMYsbhlM2p98P/ff0RSusp/a/v7kyoE5ZGSNiRJPof9bX6F2b92vuv9ITSp+nP0L6/i39kLSj5H/r/v4JYG/18a+hXXLEAy2X/XpfRan9n/TH3FwzLMmR2pQ8Sh8j5GyGNDJJuDNIjTFaFaOxWpM2NQp2JSo/b/Y0/wDM/Iyob123+yLHmB8C4ZBEeMCyJSxLwvGTF6Yrtp+1/qBbvyf7GlST4f8As3FLqF+Vf5HMs2+xkCNYH4VZGbShKr87/Ykf73+xf92/2Jn+9/sX/Zv9m4Pl/sZZsiRH7Gh2R4kwYvw9pTgr0793+7FMpvh/7GzH5P8AZXJpel/uSic/mvtgwJeWWTNPpwL/ALB/s/8AQf7F8OLtt+PfhC8JtMSf9zJV/c/9jev7n/smb8NDMMZ3L0c29pHD+x/7J6j7H/srqekjNz9sVoSkVkVJ34wOmNrF6cD/AO0Z/wCo/wDY+s2+3I7rxBkyZ8uiYIgx4Qy8R4Sr6IJgdEwx8CySRJkyjKE6kQxuPEwNeKJ0LjwSmyMjNkbMWYIhJEMxREOBKRIVicisV2IUElCUiYFRBEuRMjHY5ZY5DbMWhqPR+xwODwKqZE0JzQrJPYrFZ2LkVCqxfgwJaYqatcrgRmyn9EDaa3/b/T7EJlZMWYJggIqXpscN/ff7M0P22T4RihPTFlcsl2Xy/wCl1+/otn+pc/6MluzMm5HgdKvDHAiM4GydMj5F42K2TImJ5ZOxKLEoEoFQjY8EaIGpFefEfQheI2jHhjofBuBkmTLMEHQyB5gaEp8kiCKk0ch3A0JxRMUJaI0QITmhX9CpyKhZ8I19OfoakX0YswRBgxQqG5ImjJnwXJ2dnZI6HwLg6OjojRbIn6MKRUYMUYrwzNEisyJ7OzskwOiYOvOSRknx2dnZMComDoaEZoyZ8FOhLgX4P0fo/Q4+DOSOSbMvDLsXQuhVg1R+jC8Rdi7PYux178PJEsbbH14Pwj7ELZsQXNnASPyIolo9C6KihofhwiG8nsd7m67/ANiETTlP6JOP8Ptw+/uTSL/n5P0R9j9E/YdEiwcBCERjjtf9c/oj57e37+iaLbwuX/rkbGyx2dk8GMeHQ1ob0N6G28jln5EzbyK7WR87LOhc6FSlYEoFQuBKoIk6M0K0ND52Rv6lyIxjxjBvoyahjdQOWNDGKjDGifEi4IEJT4zaM2Rs78P8HQjkxR0dbFZBArtEzf1p+NCwSaM+V4jx68LwxjH5wIWBzoXPj9eGexjH9UeP159+Pf0fv6F5ZJPIySRP6l9GxiGOReEnkOsFrJih+DPovIUiUn2O/YmxHMXIqEoFQsCS2Xhi7M5FDG5Jm9k7HOUOMoaTRQbgdYHGGO6Y3yexKfZLCLyckYtCcFBKBOBVknkSn2TPsz78Ie+V/wDj45+4hE05T+iEBo3/ABP+n/v7lW9d6++CJJnJ78ToaQsgYzRzT8Z/BH/JY+3+5Eo+jcHS2/8AnIwNv8JcIbuR8kxZAxQzod0NKGkdjcoUtKGrki5GocoayRR9CalipQxOoFiNnW/GUOx3aOxZkSaIhmTPhZkzjxgQnUE1DETozQ5UOz0bJhiyT4QlBkXXlKBKPXj2T4YxLnIyJwI9ECRjwlJPhCVCNSLEmSfLz/BOvEnsz5gjZAzA1Ajrw2KzJkyT4gdWOjH0J0RJkyTP1aP19EjZJI2T4nZMrwhMwSSK/C8Qd+ag0ULg4MhpQZodmSnZO2JxZEWJwUGhwLQXguDobbMjux+HyNjolplBtDM0NyNyO7LWSdi5FTFTFQ0CWhOFArRomR2ORGzNjyP8za2vX+hDdKf0tSY4+K/UGaJ8p/0NYb7f9+EXyP0kv9juWn7P/UGJV6X9/VHs6r/fBImX+ul0PI8mGKmUyYz50OYLYKKjcoo6GzDvAnYqp4EoWLjwSUJSjKrw1A8m4Q1ZsdG/DFXlIxkTjwxs0NjG+B+J8IVZ8o8YEYF34xQ+DpkDIImzNnfhZIiiI8J34SJEJVIsSdmTAiRiMeOzswKvCM14z4aUMbIi/GDAqNQLgd0Kx2h2ch8nY+fGGOhrRqPEUSMakakfPhOLMMVFBeZrw3Iw2xuzsmLE4MhNhoJoTOhWO/Dc+JgVeE4EIbEp9j12TKJmyYWMGjA1FnIQqrQ0s7HcV0M+xGUNtjsnxMM2M3Hh9j7HYyw4GnA19huH0KijFQuBC7OGxKV2RDvw4isj1A50TZh9Ew+ikzBOj2tP2R7el79P/j/naGpJbY3+5/S/t/Yc0nLfJg3A+BW4ImhLAiUO/B3ZyLhuLJlRo0KoGxJMaODFbhitXksjJqSNoaiyYQ7CyYo3AuDowJCzZsXAuGSZJJocsEjcYJ8RHhGRiujNGUZRMjzJsRM5E0qF4ZVCwTwTJmx5GofjFPx0QZZLZMiYjsXImRA8CPYvEnvwvC8LyxjY8/QhCtCcjHjw3PkdDog30UPzAx8j+ohCELHlje0NI8+GMmGZHDwmiasXhsZP0SIQVBcjswkbizAxQdiWijhiOArLjJickzYnKHQ6HRjxEE6EtGR2RJZD5Rmx1Zgwyx0KyIcCU0ZoiRWK7MJOx1Y3BgSggjROhKRKRWJIbi08/D/9EluXH+2BNO1/FAAl2JYSXLpf7f4JhIuNfbz0yNeOtn7FbkibQ+SNlENQhrevDrROh8eDc1sXImnjIqSslrRyFFV6MK/CQ1GToauBmfDJihIQ7J8yTtEmPCfhGSB2LjzI2KvCwJyoGoTlSK1JUSZs7Gh5IChURBEiGPsXj0IwQvHQqETrzJkyJ+Vfl+JMGPKfiBGDs1I+TJhmQ6IsfBGiNCtDsz47OyTBggkSihIiSZJkyTUnYxsbjw68rgwN6Fx4J7ExCYnHiYJjwnryksBqRPTRGxCyTA49BwsEJUzpm4ZbcCsVlvZYXKE/sK1IuRKBUTHmB2NSNlrB2tDQ6tGPRj0YOmdMSZYV+ywr9lsT2hVaJm0IwJwWORPREGaMsiSJE9rR2iyeutfbBjRPs/8AX4GMT7P/AF+i1BpTENV+t/RhG36T/uDYH7cfhT+zHtJ0v7csYy7fbtnR0JcjWixuWPkd3vx2WhtIagfA1Jw0NSrLULbZm0fsSl9nejc6MYFWMCoVI0JaY1odmVY1JsS2LkiRoXiRCpjdkjG9GSdMb0dCssTs3KFV+VRsm/CZPjNkbOxPyqoxR0QOzJmyJG5GTDkwYE4OjojQnInIrvxkY/rwYMeIjyrHZMmREeOyfMyjo9mx2xiZJ34fJ2STBEHXmRKBWZM+JJ2NjJgmKIjxAlJPmDUiYnAhggRgyTPg7GK5J8HQlFELZmmQ3nwkXlnImbQ8WUFQqMCKEmZJkySMY/B0UGexNolNRsyW2divBMiQpyhdCr0NHobwuz2Yo62Z+jFkwYRgwYojkduTn+/oYclKzCNQdEyh2O0Ny6MuTLHyTFirwiMmFA1oh4EkdkBlyjksCtzoWREPoVXogVVlMjLAlUGEbHajZkkd4HmTBgdImPMwx1YqskYzA34bJk78Jw5FkREDUDaRaoxQuCZonwmyfC8JCXiZMjGjZvxMvxAhQdhKhOVZMj848ryqMeOvogz4Xh+J89eI5JZkd+Hjw+RswQSjI+BLx+zPiYOxckkwYIHQ/OSZEkn6p8JiEZLFvCRskSBBoEooWIE6gblQceB2bDcihYqcjQx0KhooSKEK6JkdjsmR3Y2x5HyMdMdDpDRkblDcmR/CcWJRYnZgVCopRwFwOx2iZHLseTFm5G4sTEE4HVGFBNQPEDz7P7+hN+Fdb8MmqHeBjnKHyOr0bMOxZMMXAsQKzKMotgWcHPRyJvoexSd4E4WJw7F4Y2JA0O0PwfOjZAqyJaOhLQvKwQTA/OcCcCHaM48Yc6FBsTsXZ0PxZs/ZM+JkxR0zoS0KxPw1NjIglIwOhqKHwM6EZMjY+TsbHXj34wYF9C8LgySOyTPiYvwzA6MKDozRlGUZM+E2Pkbizvy3ryrMmTsz4mLMWYZjwsQaHdeEpGMkzZGzFkx5ZIIEprgmRSGn6BUTGXkygTijQmNTexpJMD5DaHVjbTsVPoWfB0M8MTFDEpLZE2hx4TQ4yJJgxkdU/DQ3JEqh3gd4G5tFHI6FTMMUIxkXHgnKgVoyimhywMY6swxSmJpOxTgVCcUK0TI7Q3JF+7+/oTIgsEVJhI+UYspgw2bFwJ60LIrYhINyRUjVSNOJRXAkFDFaE4caLxos4LOyxcshOVOyHEnZixmzDgXBJbySV8jYsCwR9x4jwxmcDHVkRZAkYYhWK6Ynogdkk7Oxu5JswJmRPSEK/BWJyKjBgiBtT4iaM0TIrMmRObMGhODHhg9nvwnPiSfCoWBeGPzggmPCMfQ0NyMbGNwOhqB+GTRNGpJoeB8jfiYNiYnhCdDZlCDY3suZJnA6fhBQijUCcCdeXAkG4sYkyKPwQJhUMjpI3NlLG4GkNwzY3NERRai9MT7iloSlCI2YG4MCodM6JiiTNDsbkdofI+R1ZSx0YYjKBPXjahJLC5FyPkbowOh0bjxuDQtZel/zSF0K27bX6g/5P9h/wf7D/g/2DZ/wfs/4H/sf8H+wZIzajLdfLfH0f8D/ANj/AJn/ALH/ADP/AGP+Z/7H/M/9j/mf+x/zv/YnGueHv0/9kp0NDqjp5EprZEoViUkwqM2hocJSOmUhvAgl2NfIX3CDc3sSb9iUoSVQqEqkVXoSG4zgxkwNGRXk7GbIqRWRIlK7HyMa34TwkOrIgjkXHhKaFdCuiDI7MqTtD5MGDAsCvArVCYiwnIrEMnxBI7HZLLfiCZP0aoXYnyIVk+InwxeMkyPw34wY8q6LUK68ZJOxj5GHRgeRjFdGTJkfJqTsbhyUHQskkR5yOyZJqRqkyMbgdHRkRoTREEzQ7JlEyUUk7GHAnwsbWhC1FvEN4H0O7Q3SgcK0SyRoQlkljotRMCssMwltHJCq1gx6FWC0TGR5snkicjuh3Qy2BExsZMGBKMm4Z0LwixnGRKRTkngT4IjBSFWTGSNMiR0QOZZs/wCvx/iKK6S/ar/XlhmH4a4MDrBIzgx1ka0JYl9kN3sifYlNiN4LBcC68LUKz34bGhvw1A0R4jZ2djGPAxqF4SGoyQJC8LwkehjyOn0P8C78LyUIXIudCULxMjUjY0N+GZ8IQqI8LgSmhX9GTYyhORyaITvyvEQe/GfGSZJJ+jBgweyzNGSR+Ox8kyIoY8bs6ZFmRv7i/PmdjJgwRAiksGCTI3InPsT2yZElEkk+JgwNrDL2SRIrKEGBJ5F6MYwRohLIxbIlHsd+xX7JMXJlKOguUK0ULJjJ7PZgyNyS2OJG2N8DG4HQyUslCJyTPsmfYhPwXR2hdCf2F+CPsJ/YXZmmKzJPB+yGxAnpfrT/AK+P8RUOCR87/wBfBJMURcFz9CMqBqoJFsjV2NSx5GiNiCEhcvEHoXX1YyPI7ZgaO/GPRga5I14NaHSCBqSCIO0diUWvCocj6HQ6oa0R4iRTjwqEgVUKhUJQYMGDXhk+MeMYJ4ELwl4QvK8zHj9H6P0UYI8z4v6cfR78ZJGPo7Qx2R4Yhi8NSzInPgnP0Nx6EhCGxdkc+Nk2Sdkz4kkkbMfRPi9ELJMiTzE49CcCcKCIUHQ1NDTQ7HATiyZsdORUVMRYEooSihHRkdk+HKydjexoskbgdeGZMjsyKydmRVYqwKUKhaCxA8QK6HaMjcky68i4yH++mZbT9H+2j/yUP/JQ/wDJQ/8ABQ/8lD/wUP8AyUP/ACUP/BQ/8lD/AMlD/wAlD/yUP/JQ/wDJQ/8AJQ/81B+XB738ceN34mfZnxPh8o7ME1DIod0NTQ5DUkbI4LWjtC5E9naFCE4z4T0NckzkZkyJnYh+OjodjsVjteGpsY+vEWJQxZEheI8MggjxFSRUiEvsKkIVeCen4mTIxkC5F4VZJghqhCQxWTY2SdrxSsTjwn4iKOiVhkSZHZ34TE9mLJgwTBEULxEmTI34bMWYMDoR0Pg6OiBsZJFVj5JizBgiClC4J0TBMkiQ+RPY3s7J2NwYExROhIqHZMnI5GbE5HTnkew3B3FaGJ/c12TIlKLdhg0skpHEzoUPQllGJo4vwUrwpaHLVjfHkkeRsbHwYyN8l7HgalVkwlZG+BxorRAnBg4aEkLs4M/ITqNiwZVDYyYsgmPRPipoT5F5iUNShvgd2MbR+AnDFTFwLhiJqDKgVjljfAxk+JMlYFWRPkvZgJKrI7VZG5wNcDtRyFT6FboSvooT0zgxdidEyjoNzgfiNkw+iYNiiaE+RV78TREBWPoaGQpkn7GGYEhdiRLjxEjtD6GvDZBMECWimRuS9iwZQ8UN8HTybgtCp9CyLsXYpi/CMkmpJ2Lkn7FBDC0ELgWDKJokngbkdWNwYFkkQhYNeMiYxsZMGCR58dCNE0a8OdDQx5E4IaEEEaCfuaJoVjFiSRwNiyOBYT0Y9jmLMCYQnQ3MEXJMEQxOGYEQEpE5QxcSxYEodOj7BZRh9CUShNCaE/BpLeE6OxuD0bMPwydE6MmSZOx9CVIbgSBUzB6Fx4cBIVi5EtkyeieCYZsiKIihU4FdESKxOUZFZlSPA6wOvQ6wYIsXBOvBMUhOUWsmpJG4PRhkwxOyRMmcCsVmUPk5ITaG4EgwxoLgXBwFwIyTUkSpHJD6G4wNyNmRGhZCujIrJlDsiULkdodFB0OmR46J8JyK0Zs14bI4MMwxZgSFQnNIVljJO/GEkjodPw6HwLIkISE6kSkmUMUCYYnZijBIrQToQgmYQsSdnfiY8LwTFwdCsnyxjY3HhskYzNDsyvE+NST4SGHYXB0KyaG6NSYDcjcKRuBhuK14YFaB6CFgRhSakb2Tsp34JQPQSE7gXAlNceEkydnZMWNwWkfgYwVhkRTImnoVist7FYrtCq0KFZSxUh0Nwx8MfZ7HY7HZE4yMc6G5wNRZgaj0KFkjTFw/BKaM0IzeyyNikUZQqMCoVUxMzRkTkVigTO0Kr0YMIwTGTo6ZOmTJn2TPsmbJm0TwSlY3A4DcDcGKZNwz2TNEyTPsT0yTtE8E8DUCUER6KVGKZ0yJrZmmZM+yZvZLyTsl5RUSjBgwJxTJZmhQxp9icjgnZOzFjcGCIMFYZiiJyZMiv2TORXZ6JMWTA6G4HGGez2WZJkwrJPBInIxUYJgdUdGTJMmfZkTm2SS0VEokwTBMUySdCJl0WLEyLk7Fz4YJgxREGSJozRkickzYjs7J2NwOiYOhifPiSZIGPxJDQolDFEkyZJkkyNkbGyYJEh0KBMjv6QXJ2PkkwcCNHR0RKgSkmfZ7IgdrBnoVrB0Qt4MUGpElsiaYhxIk2WtCexNsUaIEQQZyNcjQ1LMmSw+jscjaQ40OvExkxTImmLwhPuJUi6OyRaGPR14XfjInPhePR6I4wVokhbJ0xoS5M0bGz1kwlD4FsENDomPRMEifJLRKeSZzkmTNrJO0TskQQ34kmDpmaZP3J+5P3G2chPglZJPwPwHwcGJiRORMkT+52TtE8EiSTJgdns68UWyakSTOCmRBjx7H2YZljf3FZ2TxkT2TwSSJ0NieieSZolDf3JEcieCeCfCnob0NifJJMiEjbEyToJkwUJ6J19GSSRfkjf0QR5nkjTIMjck/TDPxIfRkbknx68SNwORsnXhuiRqHnwl9xrwgWw5EMiaEiCBoaexUhdj2OyEZawJQRFHRCVMhmRqUPYhkT+w5CzfglBBCaFwZM5HfsdmSTkJvKHVkwYHI1AyYyTNGSJF4R2KhV6E49GBUdHTFZEmTJyE9kxYm0YMClEaOh8MgyOx3Y3Noew+SZskbChQnoUKZwJWyw5CZ+D2JZRnJUUBNobiidE8+CRkmSdie0N7KCh6KeihQlqhUhismSxA2C2KWSRKVigM0YonRKVMRMmTJMnLgXIrvxgaBIT0STyNyTJMk+CbRyFEgEzonRQsTJIknkTGySY9Ex6KElROkSosTLDkWLWTJYnZRyUJgUCdE6M0KRMisQ347EKrG4MHR0ToyOxWO8k+GdkQKAoERRI/GTJnxPBMkwTA2SOqG9E1BmuCZ8EOzIkbIgiDgRoehQg6LZLFxyfi9hiA8iFRJZMKDRMIk1Q4eCWUO7IliUMaH0YHgSPBJoVqCJyZG5OQ+SA4QqHRHjoiBXRobDUjc2vMkQxOGJQxPBGjRMkyMfJMEwyEmSTFkaBURoiSaHih2OR8jY3FjcehuBOCYEFoSKBSyWHM2DDDWRIihlBwOAnA0mBBjSPZD2GuR3G4YrdChQnHg4CdDkhSyOY5DZSypQTh2J3BANomoJhCcjlgckN7HKzfifsTAoMTgTExYgmSxIbBvyFAoIJ6EEygchyJB7DFkj8GRKToT8CehNwWJvwMNk3JkIKTJExhkcgoYnJMjJESRZIqMC4FwTUeNDx5Y2YEaCSRJPljcobGxsZJMDcEE6J0N6NDwjI3s5D5LCQrHRECQggpESNT4NDDUjsMUFp4DSYSJ5HIblSchosbIayJCpi48OI0lkxQ8kt5HgeB0OsDp0Jwx+CU0RNESWYdozZG/B1kdYMYKNEWJ3AvCwlIoast2/HaHCwOFgmGYF5CuhOTKkV2TNjdSMbixwY8jsNwxuHBwFoWLpkypGzUjdJjIsbixwwUdCg+jBwE5oTmhOSwsi1j28DcDQxtMJwG4E8obQhAJbQmmpY23bHKxzlDJYHFkODJgwBamoUqJCZUic2NzYpokew4GGTIm4G7JFoJkyTJYbGxuLGawOmJwxonQnotRahWJyhOUWUlhxoHQ7EhZgXBwOAwVBJNTswkb2PkaB7CRMwyYoiHA+Do6FRkTlGCZM2TvwbgmBUbJs4ETREoTIlGpOxvY7IEFB+JExXXhvxI2N7Gx0NwzYncHQnobmkNz4dmpGxpHRkKxhiRB0dECUoiTseBobGoIkRAw8iQkIWHZm0QnZi9DSSP3JwHQqpn3Cxkv7EpyKxWLkmLFVjRgiKIybGpYbkyOxJGiZvxix0h0RAqEooSmhKDIrREiszZ2TAqJgmKGJoia5FdFjJE2iJ8zFkwT9xOA0E6Y3rY3IwmfZyHschckxfJi9Mq3JGBiiltmUiW3D0JSO/YvuNSyZEtjq0OkUDUHAeYLVwRBE+y0s2HIV2JbKCpJMGhD+wlTDIm2xJraLexSxKTNkzaM2iWrZQkKFFBTgnXJM0NzQmKyZsmSw3Flq9GDBiiPuIkJlxwZHYkISUkydmL5HSMeC4HmCLIMmUWUis7I2TAvBghobUwvFqImiZ8MkyTNicWJ0QCceEi4OiJokyOyJG9+I2J0QkSqEjejNGSZM5JkkkkmLG4JgdE+MkmTI3J2diezNkwWvREqNkQxJFdGTJkT2diq/CoiBLxBFjU0QNSQBLYWZQmTP0S1jBEDjZDEP2N/fwwchLaE48KGBIXjOTHsZCZkZY3A7wNR6Go+j2IV0ZFfhdH684I4IoRmhWZJbE5OxJ6F14oNEx6MDckhqG+/gYex2RvBLR+iUsEQZ9EJGckxWxkSZOxN5Q3tGcERjB0MEECjDHwxKa2O/CZZ6H+BxrwmDLohQJHRE1wZZLZM+y9iTyhcisklk6F4Ig9jXI3BP38F4JmxzlE/Y/RKREeJSE5yS1QzJbKE3lDe0TODGMEcGvMkQKHQ03kyK2XoflkEeEdETRkiR/cJvLLfiCWfomqG5FyExMyKzJgknYk/GChsnk68TY3I3JPA2sk7G/DZJI2tkjZP0MYl5mDryhFhWSTP0Lwuy15Skd+GhvwsToWNRQ2jNESZITyckTI6DxZUeBOBUJQoEdeEGTNk7RyIixqBsJgOjFEzXI9GK6Micicic4yTNioxZEFoiBLR0y3QrJkVnZLLyKr8YMDoaihvQ3NDcjkNp3sbnHgNvQudDRehoJgnArDIboma8IkzkzZP2EbRS0YLVD0MIMUJ/cPQyIZJlybNlu2TFiUWQkYrREKBaDWuBaDSeBuWUO9l5OylicXo/AnQSlDqhtDujPhEi2RKw0IQqvQ0EwTh5maEKZkWxM2RspZjwmBUoJiidDUisTTJYmbJVtkzbJixqL0yEi1REKDgdExQ1I3IlKvEHZ2TBGRhGCNHR0K6GkTkTkmRMfIk8iiJCUqJ0TobJJGwrJ2dkxZMWYsbgb0dE6JG9EzRMjsVkz47MDox4nXlWZEpE5sTnwjBgToXHlXREmfESSOzFjoeMiqmLjYn3MqDJM4G07HschvY8yNZR9DpEvARiVQNzTHY7wNoMbRNyS16MMbgwTyMb0aJksOz0OrMCcCaWBIQmIyjKM4KeBuSZsdWYswyWjAuH4/Y7JkbnBQSWTWXEjJsVuhkqFVCijYumRKgmVA7QkqRh8jaJhHoTj0KnRMUJQKNixDyJ1BEobnBDAdnIUc6MOTDG4oSGJ6JqNiFagpqC2qJTG5GlyZSTDkw5Jhis0IlTFxsr7FajYlOSW1Q2mbBvY3sy5JhihMgsi0ZStnASToaVDHYkkhjY3cktehUyYoSgRUQTUEShuRsOx8obhzoexgrAlDJ0JrGxGVBlQZJkbkksd2Nw5MCUMwTFCqhPQnpkTRMigE5JJmxKbPsCImCYYnB0agnxMobk2DexvZOx2JJhkjejRPhqUZHyN+JgxkwNi4FwVjY3o0TKMj2JmxCq/C8oTFdGRWiZHyPkqZHz4Y3A0i5CQ7NSZRSTsblSNyNA7DwTE0m0ilHE4sScjCskxbG5sbG4wTHmZomaLUZHY2OyU7HKsdDWnhoYlfhw8ULZJkWJG6Jod4MOhUYYqYuPBITTyKyaJoblSNUnARETG4SRknQlFHA4MSaCbYrRlSOUkxpUjb0NpGGRfhOxZhCc0JJlEyZslNSUUjoTQmC2FEtEJaRRwcBoRfI5eRKA0oeEOdFBTFp9ClN8CVxoS4RahRkK/Yk2hUkwkdqRuUig7DTnoThlHA2jpiQWBWiZMKx8jDYwyLNimRCU0WMkyjNk7JJSOhHgVNEtM3BlA1wdCoWSZQnI8DUdBuAoWC26EodF/BuERBajUZRh2J12NjkzKuSCE48E3IhMmRuUTI3Q3NjeDcYG4Y4GGTYnonRkmUTRry4G4Y6YxZ8ToXhGvCHz4knRjAhPxgTLCvxAiRjZH0SNjCSiylCcJQ4akVWOhwJWRMMjREUJFyxbIrJm/EyTHz4zBOiSg2bG5G5G5G9jc2TwVS4HRgSFmGIXAnNbFYr8J7OxUOh0YKkXB0K6E5pCf3EpM2iZUob2UsgIBwyNwyLgiKM0K6In2KH7MqSZUi5JlGEQG4G9MiKZOihJy0SmiWglNkrI2nZFTyURhFoSs3DIuNl42hOa2ZEgknIvOiYvRj0MNhxMMXDHwyJolOuBfkSRKVJOSMqRVY6sdeEwx8CWvCE6In2K8kypJlSakY6Gg3A+DFHROiJJksRKG1kbTsmkSRSMHRuGQ5hkxSFdbFLIEScjsxbHWPA2HmjNG4NwJWzQIn7FIyW7E7Q9mQl4Nw6EFYQWgnJJMmSdjc2TCJglIbjw3FE6J0OGWGpFiTvxMGCI8JihvR14yOzJM2dnfnBgwJQJiyNJkVmSZsR2SY+hmR2MvQlwckTC4ChYJbMj4Y3AtUxtvORPTEoLC5QnwJ8E/YwJE84HDIqyS2SSPwNnQbH+BP7Dr0JN4H2Ps6YlyK85LeCkXR+vF/BJPJEZN2ZK2fsR6yehdC5Q4YG0sDGNtiMDrJMOGNveTrZEPsc5LyjI10foai9CX2K3jQ3GRKBbo/Yhfk/IXZhKP0foVeh46K2MbWGdMVez9iU+zPsvQklaP0OvQpysEz6JTREB2H5ED9i/I/uJyRyRLKJhcBVjBLeC9jhUjFMw7HLzkTeGZEzbO0ehfg/Rj0JfY940NpZEoyX9UVPmY9GBUM9nTEoP2RPs/ZesiGujF6LzokrY1yTfhHI/wAiKkmPZeUJSIJJOhOMDcjaWRVkdBtli8RCeBOyXon7Df2J4JJW/LZkkvXhk+P0TA6PZHJ7+h9GcGT2VrA/wKNEFbFO/KYnYvBMTEyhIu/ojwxnQh5EpYJijCBqEQlTIboaTyX7Dt2d7FORdEcih6KCo6ExTHVMT5JLEyTsngfAnaEZJ/BMHRURgJ60W6YpdGR3kyTLoXQuiYxgTgmDBSoXZ0KzJP38S8k7EtmBuBuBuB4Q8KGM3Q0nkt+xKXOxub2KR8o5aKLoSSwXQ4IcKmYoLgdPwoJbLmh8oV4KVokvRitFUISrAUZbJ5M0K/BZCvBuiN6Jh9Cr0THoiPRCVMjkiaejNcETg/Y19xsmLI2YvQ3Bg4EQoFGGRNDh5LfsznI+dinKHyFzocPQkYMHAxTIimLyyLnx2jtFK0SS6MGDUMTeGW6ZboSkdli5ow6HzomPRh9Ex6IihqKZGmcGZMmRqL2O8kzZN2QXyIVkwS16MUSsMnXgl0MqhMPYbkmDYKNigTHolIb0Trw3JM+xuSEydo7JiyYMEwYoxROvDMmV49HZGxswUOjohbL2TJP0J2IIQUBNKhMnnwnJkTkkmRjGFEFTEoowgXA9BuRsWGmzKROxWMvBtCcFMmCZHLwOGjmTsnwsNwyYE0si8EqgWPCJGk7OxMaUJh0KBAIRMKEJk0NyNzgpkzY+R5JsmxUxNKmTokclHgWKB2Nsykm6MhRLGhiRKMIqYUETXBlDE7Ozs3JMswxUQyFwYQagWIMjUjSPYbmx2kVsknQ0hOCFBppQjUGjK8KD50NXKHMm50J2WEFkpQigTcQTNFkMWJ2OXZI3IWaGgVUYdlMmFCLasiUPweheJbZh0KhVkQiogWBWOxhkbkeRZHTEwqGiiWlA3UEQjK8JQcsTNyLcQrY2k6E4MMTg1HiYUGoGgSmhpUjcjdkjcMgYioicEGhYsdkhuRpGbP0NwzDIEyZHwaOvDxJM+Ek2NwzBgSjwboXBEjFhsNJsxY3DFkmBaCdCYgmNyhSJJJJJJgYaQlNMTnJKZlSxpCaGjVjDRY0MiGTLoygzgtTE5UMV5E28jSpJ2S2NrQ3JMYKCY3I3Ymm7FWRWrLecn3CXkaRi0UJaMPobl0KwhBi1E2MmmWXY2S1ZjA3wTwKEYYlHonQnyTNMciQafY3U7HJWNjcWPMjUiZRoWY0ZQi1MTlkFDySeSCSTU7IeBWUNrKG3lE/AThiqiIzjQs2KskyyZbzkeOyYXY04yOrQ6tEw+huXRN9CtQ2hNCbVMyuymTkbbVjaiRtq+SlhNobjAoRhigJ6OxamTOSU8ilqXkblJ7GqxsbixuGRD6MONCUONEMCU0xpp5JNXkVqyiSZUivBKyiGhuMGPQsxoXGj9FbE4yK1ZM5yN12NDc4ydBvgwzI/QmpgygXCE6hltWZRNDxOxzlFLRUhLKE30OxMOBvQrpjTkwMKJbJqRvYzVrY3BEOwpCetE3GiqCYUhP7n5GAuRiY8NwYE7gkbWzBJrsmUPk5DfA3GDDowxOBC4E9MVhOV2JwnZMqdi/JG2NyPNEpeEwzo6FdMTkKgX3ifYp+FLJHAmBQJJHdCCU/RlSRKklNSTA9+RIIGKIafYUYQpRYMIV2JwkzZMWNCG4G/B9E6E7FYnIlNidSJ7MqSIsagiDDhEQQJaM0ZoVikJpiEjeyYRgmGKB0YZMjckyOxpRsHETs1I0HREGUEX2IuEbgTkIJSK7EhI1NipSNwhjI6OhPQsisTkSyE6kV2Nyh3yNQRAqwQIMUZoyoEpJlChqRw7Q+WUsahISkTIoyNFYImjIgkIkVqS4k7GGoEoZhmKIXwHwKRYVmVIlkZsmLG4Q6G/uIijoT0IViciU2TyJ7HiTFjoiDHhGiNGaOAlInImssiVKEzspZFLyHBkaP2G9GaGmkKXkVjtGVPiYscPRjAw3cEk2TNChoFfsTMUkJzZOzsmPB0Nj4ImjLJkmSZMmbHyTsbMExROBgnQ7oTmhWTJlSdk7Ji+SYEhMEDogV0KygVodGVIqFCxRFAQV/I5FhuRwZgmUR9iakQdDcFKmdCU0KxrE/uKRNHQnaKkwxuDGRrkc+MkSfseBXglPAktEEwYzgiPFbOmKhm/DTZBDQgwm94Ox7IZOhUTPsbkbY4YHIvRK0Y9EcDY0lksSmhNMTl9n7LFA7LyiY9Dr0dDsRcMjRE0JINT7O9+FLwTKoxgiPQhEHR15TjA39z9kyyOCERGCZ9HolpXgS5GGhmti/Jn2fkS4oT2JlGLeCUixRMCUZ8JTQrJl9j/JeimCdo7Qoeh16KR2I5MKBLwa+5n2TNi5PQkYEMER4XBImNST9yGKQlZEqJJJfwStiYXY4E/v4SSNl6JE10frw0DUOyU2NrY3yKA3JM+y1kvKG2J7E/sTHrxk68SWJk/ZDyTsngZJMEx4nkfZJBfj2XorRe8H6I4GhDyNzTEmiRDFBesiiK8folLBMMwxO/ou5fwRBVej9C00YUPBWGJOR8vDI1OMnYuSdkFigUySsDozTFoxpmR2NSZsiDNomPQ2hMFIVUao1DHeTIpZ2d7JatE5IUK0UsGDrR0LRibwToViv34z7G3knaG0rG48ClVohYeNErDIbyO8lDtmcZOxcje+RODBg4IhKmQ2oYooxpsV4HLydkPDRCVlu0L8DfwJj0YQYp4JqDKgtod+yx2d7JasnQVWikL7BxgXBweCYoamuBqSZ9i22ZvZG2doTSsTj0TFaOGiEqeDpjU5HZkVlM7I2TsVCGKOBEURKgzTInJnA5eTsjZiyZsRMEx6MUYp48ZodmTORtCTd7EzsULEkrJjxgnRweBOKM0ZJknZNyzI2eBRMopZTxkfBOiVhl4ZPgWw3NinRVlsmPR0JYTDaOhGR2ZJHyTtFL8JCYOhcHRBnwibJbIOyZJgnwTAuDojRAdlewuQ1NkyRFjcF+hEEnSME0RPkXI+SW8HomfRUVC0EhQLEGoJqB2h2pM2N7HMyYcodMTgoJwJtUYEyhuSDJaxDoiLMMVMTihBwIlQZUFNeCSh3Y6skMWKnJhioVVyMnQroVisTkTOyRvZKRQbgVCVBhAsCdRwOhZEzY4WchOHKHTFYSkJBKIE6giWHaRMjpJexckw5IhyJw2Jw4FTgSBSjKgVqCmh2OxvsGNJMMiQnDEpCf3ERQsQJeCDE7HyTcnYkmGgTgbApQsQagTqDJaxubG9j50Jw5Q6YqYgnFGECdQK4DtQQN5DTZs7FyKmJQxUJQJozRmimNpjTE/h4tLwTFk2KxJ0JxQrQ2JgNyidk7G7kmHI3DkmGTJiYgoXArUcE4cEjsbY3I1cjzIyTbYpTZYcDCCiQmK0JyNyhschrkfJOx2E4YswYQLECxBbwblHY9M5DzJhzyNteimBYZMmTRqBceGfDkbk3I6swxWFQw1AlKgySRI3PhkPMiqxUKmxzyKMMorIldioTJFSNtDXIpjD6J1oWY0cNDKIGhWKgnK7JkTlUOdDxQybGzA/HQnOSUCtFNdjtDb0OxhstG+jfRfAloXYqyJSrM+yZRcULo7H4N+Dcj+wbWyqsiV2ZR+yHo5Ib4KRh9E60IZ4GUQxKFZldip2ZQnVZGqoeJCTYsyNwzIyg4CuhI8iwPQpq8mCHyiDHXjA6fQlfQkicUQdMkqLLeR2h4lDcWIK0NwTIeSfsUG14SFZErsVqyZNWPkbjBSZh9E60LjRw0SkoE4yJyuxU7MicqsjmFA0IZQuSYZkXMC4Q0UToWDNEz7LaJaIEBJMDV9Ew+hPQnFFqZJNGRuUN0N7GixuGNyJkNhU+hPQ1wK6LIyhz9jiJZyGx5MMVvCyJyLg4DTjIsdiv2SN0MfJI6MD/BJDYngYXZEOy4ljcjgOcobkJxjZkOU40QlSE7IYRxEpUCp2OYMmpHakafAb0YZEEpE9I4C2hNGBKZcSzl4bJhipkE8CzAuBvAVnIXJSxhpIxREjbRH3CjA7ogZHYnKG9kxY3DG4JSEQSToV0ZInJE2WsnY3FjcDDoSSHCdEfcU3HBToUMjwV2NzZqRKCIFRuBqArFtwRI7EoCSjAXI6UjcDgNw4MoFmCPuFGB8IyZIkwktY6sbixoJhwZCsIyaMoIREqWRNk5GbG9jooRAlGSk4REOCE6FZBiWg1IrsujCkiFImQ3AqY194rETQioJIkCyMJE5sdWOikYICzBE+xUitwIOzJM2ch1Y0WNwSMvEnDwoSyJBONhCSkbgdDrwz9jNEyKGRI7MjexOLHVmwbgVFKOA1wJ3AroVjCcKSZUnY8JjQOjBoOjo6M1wTKORORMqRhXYmTBMDofA+B3RmjJIjIzZMoWw3F8lBscDFEaOhJoaa4IyORMqSak5cmAhMODhoiBrgSmuB3RkiEmVJ2dj5GixhWJwOjo6ImjK8V6NUTx4Jj0NJY8K2ZDWmRoifZM+yxA7OxoswolITSI0yWN8k68NJix2NPRWfORqBIJLDPfjNeI+4rsbnwa35SgoJHR7G9Fh2NSPlHaE4wVgY9GMFitihjoiaIkmfZLefD14ZqxEpImBJYZuCsMvBS9kT7E59jnRWSZ9CjQ2PnR9g0MiK8ZoyZ9i22OXZBBHBWV5RomKJWyXhiUj+4tkTnBHAnGChj0QkfgKETpjTdMV0QmJz7JnIthqDsTizAbSJghKmJ6HwxPTMH3Bj9iKRKiSRmC0YMUT4kd+xPLZJ4gwNrJO/KdE6YpdDdjtn5GfZM2yJs70d6J+xEHAxRKwy9iuhqfCZLOSUdi5YnwKUYFRJ0NDvzNGA1s7HV8+GCIoagWnBw4Ivw9i9C6MWTF8+F/BKwHwdCV+P2L8kT7Jm2RNjW9Ch4Jj0QsDgRFFYZMZFoNSIRIzISgmCB1RSomoCwMa+4vuMvsmbYlkJsxaE2sYMeiEsExTE2yU8mcjl7G5cDls7WTtFZMWYKGCIomMksdpESTIm2Xll5IeUYslox6OCIihDViS2KyZHfsnjI7IizsZhQRomKKwxPTImmZ9mfZMvsTy2JZMS2JtKUKV6HRHwKVMzTOAzkfLJl9mR2si5OxckioiCIpCd2MJNWQMktlu2XkSeUKrXiyMDgYoeIZGmOW7Jn2P7idrIlNkQ5E2eSYQnCBJRBODOhOhE0IbyUzNsmbE8iykUpShmvQ69DXwHCpk6ETQifZn2TPskwpWsiZkgiSRUzBEUKGR8httKSIFFvY3s7LyiYtEjcEiYHwN6fg22LMb+RDssnIm5Rl0NO2jGPCHjRWCFhj4MF0EpyNJ3sk3KydojZORLRKSgiK8LhmaFZJkydnYyNipjkYQJTQ6onQlPhAX4HZPBG0NkxZaQtNERSOjoSWGXkQIkN7E8sSbHKslLwjWiIpCjDOmJ6IkiQ0n7JZWSsjWydiNFBUKlBqCJUFkkWGpLCNyOnIpaSCYuCUQNo0K6G5LDsbmx8if2GHPI9hUUIgWgqUEJqBSxhpMhvsGTFkRZHBQVFECaEZUGTI3JlI3clDY5GoIgpRoVqBuVBZDskzcmzFicMVYENQ0UaFdcDc0WLWNNjeyfsMOeR05GgaBJKhOECkoKagzkdjSZsabGTFkRYlwJtCQoKIMKBRA4IG5osNySnY3DnRMPoppE2nRQWg8IMKCJUESvA1Nk7G7k7JuRWfBWAuDCDgTUHQw03ROxDJCVic2ZDcWJwNDMC0FSgpqByxuRpG5Y02NkxZacinRShuKGhBhQSojwGDSNJMuSUyPkTi+RU5E4fgThGFAsQTFeDFrG5s5icicMlhQnXgVUKkCxAlNCcjcjuyR2PMj5IgwIJxRhBKJQsQRIdEO7ORyMMm5IkTAj3gTSmBUoE6g1A/AnZKYmx8kw5FZsTjwLEFRGxThkwMMJJax8iciyyj6FCJbEnsQlXZgJQ5aUDdSh8opge2hV6Jl0QmBcMT0zCxpzkVOy3gcPByDjI3F6IJmGPPQ4C4EjJlRs12a7NdkuDkh8ocZR2SYfQqfRKF2ISV2ITTVk1KGxt5G1owTA8ihsS5EtCQpCkh07JM2IfAgvFQSh9CSYZ2FyEVJdikuxSxkcsDB7DTViQyGmQYFoJpllBFdll2KYIejgIehpK0SIKPoUH4RCT3kUl2RK7Gk25HMSh8oR5Qi0R8B26N9ChuDKGLaMIErsmV2Q0qyOWqMJDzIgmO0kx6JlGhRMPAuGcBRdiv2MTsbkXGqtDcFzI6ZMMm+hwFwzgzKjZNdmV2TKPR0Hyhskn7Ew+iYfRlQmSWXYqdlkOSob4LWORDYyoduhwjKDKBJLI1djSuxOHY24lj5OSG7kTc6KwMhKxRLTJYZWGXhkJoV+zI2sksbQ2TBMeWWxMm5UENqzDsbbSkfg6scGJhZaElhkxKZwE1jYpahkhQnZeWYSM9H6Og3D6EkJyxbRj4JJoTldibiWWUl5Q3sZSvBORshNlnAViUkSZsayGxqBIHR0JS4Goo6FdFixEJJ2ZUmh1ZhjQNR6JWDoiXArbQroSpicqSZUmpNSSkhsNDOjohpwToy4MisVmbLiZOyY8DYknQ3FCc0KxKRKURNkTZixqLIBwFaBWgehShToUiQU78MJ8KDgQMcPDiOwpuBToVGWRE2cjkRQ1BQocDKBK4L+CkKaIkiVIkyPYcSnhPQ4Dg4I0JSWQrRmyZspY6saPB0LMHXhJoUhjMoSiTJEkQNQNQMxodhrQpUKQpCtEbIogdIagaaGoKUQQRNDQ1JEo7NCWxwsYiQw4EXAkLQUqNBY2DpJjIlFjj5BaHAjQpUK6JkpiU5FdllJ2TscBuCYHT8FoWot4LIkUk7HZSPBkMRBIlDYsjShCJsypOx3Y3A3IoNgNXAnDg2y1C0IlHIdqSKkThDsPwLg3A8wRNcCMtiTRDOhkiCI9GPQ4ERk6I8HYl8hmx8hPgaWULnR3o/A6HTFwxrk6KRn2fkZyTNopaMXoiF0QlgiM4MUzChkTnxmimZ9ilg7QuUJp4wNwNR6MWyeRdkxTJ0cBfkTksS4PREeiIsiCIKZEQXZEiUiTY5WhLaGloS+wxT0UOxwZwZw2Q0y3st7IkibREWil6KKdFCmSIpkRTLCQypeyJJPByQtkNLQkFb0QRGmcGcGfmLTZ+Za9jc6i4FbKjj6KnMJseWY2M+GOUJcDXAkQRBEELZHI+RGiIIkiSJIm0RFoiLKEEUycGOSJILURI1PshvBHAtkJNDgOIoeD5nB+W5b2WIm0RNo5aOWiI8GhqKZHJDVETRH3In2Zxknjx2T9iY9GuiY9DhZJ0y8eMiaZy2TNs7LzolK1sW3PhKKJOjorGyPv4T8iKEtoWJRLRHwI+BTBjJHg1CIk/IiRt5Q7sdoXJKVrY1Ax0TJMURI3JErsl6zsS8RHoj7ED7I0zsXg/PxDyiNojgxgS+BMPrxMHSEpp4InJPJ+yJ9jc3sU5O0di5OilRhQdMvDIkTPifuWbo7Ri0RClEx68RCvAnpkPYl4NQRPs72XsT4JJgVejrQuCOTpkCwfkfskQI4KREWYGvEQoZwZE58NEfcjeyHJG0NPJgjRgS0RpkaZbJZDwlwNcCW0YtERgVEQUV4PZD2Rye/CJ9kb2RseyIkagofgcDgymRoSLCl7OUgsHa8RFir0QYIike8ELZI/yNfc/ZZuUd+I0YIIWx8Mjkzkz49DI4MWiIFRQpnB7Ox2IKFvZFkHQjgiyIKeiPsRrwjTJDl7I+5EjWxvgcZGxDlehxgSglYZEeCJ9n5Et5Jkg7JjwiBqPREVoSSzjQ2L2URPsX3ESNNinKMXpn4ER6P0forRKwzAabyOHjJLIgvKNhjlPoj7DutHSIZPPh+x/klnZLR2iZGgVCoiERo6OjI1JE2NDJi2Nw6G4ciaQ3CNAqoiRQyn7P2MaGPMnZMOdCpioQThCUURNEzQrEkeZHmR8i5E7FQlBgSaRM0RobmhwxqWOxu5HyZZhyQFBOBVkwoJoeIEpGpsibGiNkWLModMSSIgSihUoIlQRI1KK0NCWPMjTyYcihMVCUCoXBmh2RJEj5HybkjYqclBKCI8K6I0O6Gkx2xqRu5JuTLkw5FTFAiKIhWRCgjQndeFyIWR8kEGHKHTkUIwKhVQ7ozQ4fskZRjdyTsnehODHhNGEZomTJnwbH4RECUEQR4iaIkhMakiTZs7FVihYkCgJQLQa0WUESiJGpHZexxkbixVYnDFwTFCSVMThRszQlUDDsyxps3JuSyTD8JhHREURCIlC8CYd2J345CbXorAbgWhEVsvDHx4GkexyOxuL5FsPDEoFoKqHwK1BkV+DcjTZWTFoskaGK8iqmIyjI7G2N8D6KWb6HTk9G7ExPTGqGJTnJP3Jo0I1gmQiZRc9G+huH0Vhj7LCSWS4vIsdmfY8J7HE7REEbMFr0LMC4YnpixYpaLeS2qGkdjfA6vQqc6MPoiPQnKCmTQx6L+zKE6Geh9ECMPwldi7EhQJT7MrsyjORrg9DtJsiH0OmRpj7EpFGzXZEoyh4TG4G9ohIw5HTLXo2Lhiej2KWiJyZVDJloGMXow+jD6Ij0Jw40JIpTF+RM0KLsVOxwG+DKh1Zswz0KJsnkl4EmD9kkscjoTwQkmyb6G4ZMZHWRNirJNdmfZMrsb34DTzP2LT6FkXA2mLsUwJGRsfh1ZEOSIYqYkR4SIIn2PHg+hqcDvAkXrwbgbSdjzY1wxKDQa7F+RsljSS0QLkhaLmdMhITWGJPY3Ik0ya7E5XY8Sy2BrY5mV4TDFK9EQ6E7h4EksCZhQVFZFgSkc5Q2w3sbhkQzIiGNcC4OHhKUPC5Gtsc6GtjYf4K0KiZWJCU34CckyYDcoZSxwGgwx5gbsktXBaiDQpaJhJhInKkeJGoGEwZQLMEMHBiU0NRZC2JkVKR0pHQlBEEWMYrosJpiv2W7HJSPkdWtlBuB0bg3A+PJpGlCcomVJA1smB0KmYcG4FwKXQkKxWiZMqTKkdKRqBjDNwRYoFGBXQnRMozY+ROLHSkbgwYZuCbjwrosJyK7M2NypHyOrQ6sbgbg6OjoXAjfhJYFY3I0UtEwNwYZhwN6KTgzQnIrJlWWRMmEjcKRuBwY4E3A3olCehOVAgnRsHKxB1Y0GDDJsm4JFdFhORMyN1I3U+GoG4HRcnR0JC8ESRKE9j5HyOrHQ6Y6KUcBvQ2i1DSYSZUkVInsTfIw6JhmUFHBIxXQ1PhE2NM7E21JyGgdDUEQxQYyJcCtwNPhEqUW1LNSLEjcfQGoZOtC4RshMKREonZyHoTYxhjoiKOjcDRQk0JHgnYoUIZPwGy9Ewig3GR6DdwxaMlaI+5+Qk+yWRPZKVrDFQ1HohljQ0KMMXDIeGWJn2fkJTk5ImpFsENdCIwJQKFnBGjoamjI79iv2Z9mSdonaJ2YMExkxTIEb7Jn2K/Yk4kgtaFAmKUKhURGTo6ZmmUZIn2JSJvIlwVlCUDUEQNJHTPYyJJn2O/ZkySaotgxjHgqJjOCNC4IklNjcisyTNkzZIhgwSlkxTLwSwIJGJSIS8orJMWNx6IhCDSWTobimNzTJ4Mjc+xORNknglK0SNwYG4J5E9Mb5MlvZQTJM2XwLoxjHgqJjODFHRlwTY3Ir9iszZyE9iZgVHsXZAkQZM5MnaO/EGDA69DUD7Ox2EMih+yZGhJ5R2sExaFyGo9ELCEtHRGhKaJI+RDysijIuSXoh4RA1FEaI0NTQ1PiZJktYKdovOid6IhC8E68ZccGSZyciZs7Ox8sTgsKsEQVvwgQ3kQQTgbgn4FCWJKkNRkV0xORNsbTL2RLozbO0K8DnYkOhqPQ2JcjTdMgy4KMWPkXKFyH+CY9HWjBEUjpiU5FaMivxkxg7QpeBVjBEehxRCUHsfDIgzQlPsvJkd34agoIoJlQlGRXRQk9kiIlj5PQuvDUejho6I5HwQR4YztHaG/sNx6OtGPRikeyJyZoTmjPsT+5my9HaE+BV6MejFCqmTpk3ZJil5Oxt5ETBMGPBMqMUzNDdFvI34Y3snaJnA2OvRwJPY28Pxnwkexej0T9iY9Ex6Jj0dInkiaZmiZJn2Jk7J4J2hPgmMYFQqFwexd+FYvyX9EbJaLRj0QogwRFPw1JYd+R7IwpRSEo9EfAUYGo8KPkhvPgn47RWS8olKyWvQq9D00VQTTyKjJkpksjg6DUX4OUL7CI9C4R7+BiGx2JyNC5O/CgNwTAlUC4Kw8ERkhP2WG5FA+yHEoxYYJwLQVURCHAalQO14OxfYHQrJMlBOKFVCpBEKBNRDLdMpoyiJcobbtij4Cq9MdOdCrBEMSiiIEtESoFdDsSkyN14MXyZCoVCo4CUUZUGaHZYamxuXJM2dkMlPQnBQVCUCRE0ZMmRPZOzsRMCcUJxQqojROmJSOzJE2PY74MWOnJMEwyYodKBcCtQJzQ7EpM2YDWx5kxYnDFQqE4oSiiygUvCmRUlrJExwJwJwKhVR0LscuiR2OzkN7JixscClCcCcKDUGFkyNKG5G5Y5WSidmHOiYJgTwJihVQsQJzQ7Miux0ORMOTFicMVFDgLgVqBXREmSJNz4mLMWKrMOSIFQqUE6I0ZJkdjKDRZRyK0icCCceiElCOhqaHdcESch7Dc2TsT2PYmBWFgKULgia4E0KXkyMb8RZixqBKClHE4ETXA3NGAhKaJ2fgNyYvkxZgSgSFA3o4CckyhB34nZOxU5MDt5FGGNpmHZmGyJVjtIbbtDTaIZRudEtYFTEkizAlyJ62KcCJIakb0GkaehotEw+iZUKZHMLkJciWhKD2MMZJ48QPPRhizAnDgVCZqNll2TK7LaQ3tHaG/GHI5TPXgkIkLXYkoSkiUZtHog7J4FKYlYswJyIXAogaQ3I3I1wOrHkdMVMQmQsMXYloXAuNjXI7wO8DfAyL6JFTFTgThiQpFAkghNDmKHLBkbOzDkx4YXYuyUWK1BkdobnA3ODkPMjPgmGbJtiibJE9CGht4DSPQ6sbhmBTI0ErsbTOAqE5IQ6DcjfHhsm+jD6NwKhCYsCkhWuyG0TwZx5VIzDMMWRCFdCtEyuzK7HLG+BPKkPoSBqGQmhPSyTUbNdnsWOxm1I2sjSxNjHkeRRIssiEQiDrZj2PFktDgbG4sw58TBkJORLTEtEQiJ9jgSkg02NyYZgy6EofQ3AuBcCUKAyuxy/Y3wNA4yNzgiMEwQLI2F+wTmychKEjVSNwGGl7GpFHArQiNCuhXQlKMCmpJcSzsbixNjcDUClMSIgoWglIlJEo1I1sbhSYEiB2oiCIGjFEyoEQrIlGVJmzNjceDA6EFxoT0jgKRJkSRKRSsipIixkQOmOmJRRFiui1CsyjJNSPkdWPoY1DMMhYErg9CuiJRlDtSRsfI6EgsoiQlDOAswKVEqJEJImUOx8jZQwYEhCehMyKzJyImxqpG4sbgdMdMbhiVwdGaFdCsUNDtE1JOxuLGNjUMwxJYEtaFxoSmhKRWjKk1I3SHVjUDUYHTIgygVUZoSkVkShS1IrsypJHTMGGJEa8LMGaLESZMqTUj5MBiQx0xqBrQ0WoSmhWZFDUkvLHyUshKGUdGQxwElwJSKxOUYSYSPCex3ZSx0YZMCoXBuBtFjKFY8SLA1sQgIBqQ3DgVULLRE0K6MomBE2Tsd2WGjwYMHQno4FqGkT5ENqjNhJRKKVotH4DehDkfDLdtnXBAifYk3se2yW7R2iYsY9GMCUMS0ywloUqINiUiU5Ikd2hUNQhQh0R4cTA1FDSdeCc+zJDeCngagdWYREGCsMfDI+5wGMSSUUsEcCpIhKCIMCTHwKxmhKSJEpHZ2jtChWiIMYIg3BB0O6MmfZEmTNoxZEKRKB16I0JPAp0JsMSYFHyJyNiGyFkcox4iClgjTPfiNClisSkiUdmpJgwY9EiGPjwfHBEjv2K/Y9tjl2jtFK0RBCRg6GiNFqEpEpEpEps7FVkQpMEQQJaIsjRwLexWRIthBoS2KkJQYo6Z0dHXhWJT7GTNo7K8OhUOhrTGtMcqGpGpochy9kbZ2djgh1gSg4HAjTHMwJS4FdCU+xiC5O0RtEx4QkYE9HTM0JSSJcisXIufDqykOhwHoNXBEuDIoH3h8inKKyjs78MGDo6YpwzNGSQkEng/RMejGCZR7PZjIrrY8kSS9ib0OxJrBMYwRHoVVoWmhLsXITY8CsSTIZEYI48RGSIHRGmJHYS5ITMmR9jjJ2J8DcejHoSgpZM5G4piMiU58KMtCCl4KCGvCXJZArodisnk9DYkyeMEGPR+iFsnksVmSJMkcHaPRjJjBgrDEw+YuQlIXyTI5yUdnowYEoKRE5GtC8TPntCYrwQT9iUiaPZM0Osk/cZEjR5HWB3ZDRPGCI9EfAjWiERyQRJkiSCOCNo3REELwiKEhrkgiSfuRORoSWSNinRgSj0JQJJUZyRoSMkyZIkg9FaJWjBHieRz5iRjRbGRqR8BqL8XRASgk68qHg72RszYh2LkbfwL8E8EwNzkYrMmSZL0J8H6J+xj0JR6G0SxrkYkGpGhovRGxKarxa9ERgnQxYJJXyRPslvJBehbCDQbQmFBEKBJOmOXQ0MiWg4mTcjVyciYsTgmDFEFCRdQXRBEiUkbIsjZj0YERgyNETTGpQ7HdEcGbIDQkWLYwzA9BKFAuBuTsKRIbFogJERZECUCogWIEpoyZZkS4HTNjWzDkmLExUOhUoJ0NSoHaHZkyM7HVmPRgXBEIJ4EjpimQnQ7ocsHZGyDswzD8YPYrodmSJMmb4J2STswJwKB0agzRM0OzJbwPMjzIx1ZMWKjA1CgwoNQNSoHIyNBKSNkWRFiUehKBNEYEaEppjU+ESROBcnIjZEWJRZhiowoEqhiWhuTJkpmR8mSYswUJgmK85odlh2NSTIxLkagiCIIgWpwIeRqRys7NyYcjTs9iq9Cr0cEagXBURsjkiR2ZMkzZ2TFjQJwTCgnRhQdEDcomRqR3ZsdORqLEoZgnAioFwRND/I1PgyKQrHZMWYcjQKKMSK2NUCSaJldkBDDnKI5WB86Gh9Dt0UYndnATQlCoJIIlD6GjwInaMOSkyk6Ih2KwoVPZLERNbIbIlDvA0QPw0MmGQVMhqmKMMU7MqDKhiU4EuBLgSEosiBUYYnAqEtCdQK0JyhuUZJHyP8E2YYlYsi4E9E0RKE00Nzgb4Gk8EMomLKTGkmJQ7EJaeymCFdiVRsyhuUPgNbOzvRNmGKmTFMiK8dCUqDKszgb4G9ofI6ckx6JvomH0JwKqFwJ6NEz7G5Q3I2ZD50N30OmJWbI0JGoIoSTQ7VDvA1NoamyIckR6Ihig7EtCqnsWI2LjZEqNkSuzKHeBojZGzHow+jDJjJGiNCWhKVAlKFeCeBvaHyOnJMPoxZhicC7E9CehQId4Modqh8jGGoZgWbwQLs6NQRQ6DZlhJtG0ajBsE4dCcUKGhibBhAsQQ2oYnI3J0HGhsULJFQqFwcBlgThdkz7FfssPY5IYbuTDkwJQQJQISEnsanAnKG4FrI2NwRDJgThjLYuQjeTKEm0OkjjOyoTEDQyWq14GSZCmEPgSmmPeRzyKSEpUmEjRAkEQxqGQsEXAhCsTlGV2ZseB3gdDodMdOSbNshaIE5RZSKkicoaYkJGDAqEoYhMUYFYnKFaEzvw0sDBghChMrQ+BcMtkyMmpNSNjHQ6ZMGUITzAgkVpkyiZOx4M4HQ6G4Y6YsiFkQnIrMidDxI8Db0NwOjDMOBRgT0JTQrJlGSak1JJQdMmKZAUJlYQ+BJYYk5ElGUZUjTakeB6KMwzDI0LMCWhORKU5JlE1JEobqR2NQNQYY6sUSIxJTAuCxb2JQkTlDVD5GNA6Zh9GKMOPC4FwxOREUa7EymYGSHRgSOhXQryJT4oaowH0NeA1A1BkJCqi1FhDUkuJY+TCRtjodPwgswK6GFaE5JkThDdSN7G1kox0zDIhwLgS0JESJUOg6SRshO2NJDw58MhcC4LULQZYCTbOQrtDc1Ji+R0MUsmK8NBKaFIU/YpCmjkhbIarxQkJRkaaofiIEkyzJbNSjNoxY6KRjJMHTHwxrR+xsRxklNSiFlClWzBQSgpkmMijZJKwJiY05E5J2hPQmLMDcUKFT8IiaEpMkSRKIlSdo7MKRqCkIrQo0IJQKzJE+y3ZO0RtEbMGDGSWjpmbD42ZJktkrKKyiYsdEwYFWRwzg6Z0SnRIhXbJkzaJm0Nxeh0MKqZeBESRNETWyJ9kSiISalEKJREKR5DDIgwJRRCwxIsRJE+y3ZqURKlEJWYMGDAlFMjkia2fvwSkzaEllCqx1Zh9FIxkbgrDE9GaM0ZozRE5MicqTsxZSMGKMUexThisQlPsVmbJmyfEwYKeGttjUkSRI1JEkzZ2akxYqGo9DgTBij2QKy3kmbE5NF5G9jeyRKRg6M0ZoVkT7MkSRUnJjRWhwHqRgRFF4Yk3TNAiZHyIgNi9C6wL8Ez6MeiYUDoKcMfHg4cidZNiFajgwR9hL7FIiMjXJ7H+RoY39y8k8EcHo9YI8OBrkhbIeyfDyOR9E8DcEyqwIToUM6YuyefDcknYng6E8CYmSJk6Z7F4weslayei3gf4P0T9jBBkVyEsk/ckkb+5DyPo9eMEQfooa5PZD2LwZZ6PQm1aJJJq8DfOBvkxknnw3JqST0TwTwJ/bxNFYJqGexD/JH3P2R9xcofR6wfomPRSpmMjzYuyfuRHsX5J+4keiB6MYwYdC/A0hrkcbIbySmbHkvR6H0KsHrAn9iecHvA+z2eyJ9lsX58Xo9C6EYMeJQuz2VsveSRvjI3dZG+B9DY2SSeyeSeSZoYvyIjkjaH0R9j9EIglYPY0lkfeT2YJ+5MkxgT4E/sSJ/Yn7Dgl7E+STOBP7kSWehPgjxBH2Gh2GmxxzkbPI7JnGfDnQjyIgTdOTAFVHod0JJ+Qqdl8ZFK0LcSkULEhiCEiKgqIYrVluiQan2MaPQmL5G4JgTgp46EOzJkcGjsZ6HCMCopQklQuxMKyRyfgbeL3FAkTBUJiJG5FZkeyyM7MmBUKUILUSSpmoZJ0Ox2PkbiydmDAnA3BHHhDuh3RTGImbOxPgbgmCYFVaKVHs7GR2O32NvZL8G9icOTApQloXB0O6HZlCtdjmw+Udk7OWjAgwYolOmTNMug1I79j5HyTsiLMCcFPR0hIUbFLyRJMmbFZ2dib0UhUKilaEkqZGmJxTEh2RPsd3s7Z2iYsXI6slIwYUExRPJmtmfZkyO8E7OxsmBuBQJjA3pifJM0Jj2EyJzY3wNtDZgdGDgRFDJmjJkn7jnIuTtEw5RhikwSTUE6GSZb2TInteE4swQKRg6IOmNTREjUjkOeB7D2HQmRQTSyLEMTazksuyJQ7SgfKOSOYryLkSSZFIWJFSgQV0JSqyOxy8Fx3fjkNm6FWRCcKBiZE5RbRktgfhI3I0GBCjYu8mRFhuRufFwsmDIhIgoDIb7iCtCcqhPjwyO0cvGxORWsiRKCgnJbQ7Q3I2ZtDHkky6E4yWJ68JlCcomR2NOCwuRu6JlkwxUxcC4E9bFa7HgbgOzJyRKyTHhOGIQo2Y9kuDKG5Q3wOMo5HZlJhjJGsooE6gsoMododqhucDscyOnJNiSbFTsSFSgRMkyjsZRsLEMm6JaY6FRwFGxOoeRWo2NSrG5GMom5JuR05JgQUCbEJk1BldmFmRywNz4SUMNjceijhE8nAmuyZ9il78J4LYGHIyJhjJ0KNiFxsWI2TojgbBtPA0TZOzAnIaHYqE0JtKBOoJG5G5HLA3wNkwIVWxPwRqCDQlI3OCwg14oyjKMW8tTIlWK12UTscwIejkKGCpEMTor6FEwJogxNNUZXZMobmx8lLGotFMFB5geehuXA1ITkQnIthupG+Bso6HTox6NjcC4OhGTIZVjiCarI4DcDgTBMehLjQvwJpqODsJyNInImTwN7E4GoLTEVESSLgUMmUTOcjc2NzY+R8jq0UMDyLI3NHTHLFZMk7G6kb4G9jcOhuHRj0NicC4FdFkJyhyGb2N1OxqrI3A6HTMMVPopWhfgTTplqZEmUZvZMocrA2zA1BgwRBMuBLQoE00Nz7JlTsclJyHVjUYOAx6NwKZJWCNMmaZZEyianZyH0Njp0OmYNxoVCUUK6LCUoTgJNoTqSWx0NQxuGYJgwzDggW6LCsypMqRqE7HyPo6DodHWiVME6J0yeSZMqRWp2TKllZHyNxaJgmBOKFwTomaZbFY2Hzs5bHyNGDGDDMCUOGIQhWKzKJ2N1I3tDfBBihMMTgVVo6CtFqFZlGVI1Cd+GtofQkDUEEXAkQsM/9k=\" \nwidth=\"400\" class=\"brad-3\" style=\"width: 200px;;margin-left: 60px\"></div><div \nng-if=\"vm.urlVignette==\'\' && vm.podcast.vignette\" layout=\"row\" class=\"s18\"><img style=\"width: 200px;margin-left: 60px\" \nng-src=\"{{vm.podcast.vignette}}\" on-error-src=\"assets/images/no-image-custom.svg\"></div><div ng-if=\"vm.urlVignette\" \nlayout=\"row\" class=\"s18\"><img style=\"width: 200px;margin-left: 60px\" ng-src=\"{{vm.urlVignette}}\" \non-error-src=\"assets/images/no-image-custom.svg\"></div><div class=\"mv-24\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" layout=\"row\"><md-button ng-click=\"clicked()\" flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"PODCASTADD.choose_thumb\">choose_thumb</any></md-button><md-progress-circular style=\"margin-top: 5px\" \nng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div></div><div \nstyle=\"margin-top: 15px\" layout-align=\"start start\" flex=\"65\"><span class=\"secondary-text mt-8\" \ntranslate=\"PODCASTADD.maximumSize\">maximum size</span><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label translate=\"PODCASTADD.form_attr_title\">Titre</label><input type=\"text\" id=\"empParametersPodcastForm_title\" \nname=\"empParametersPodcastForm[title]\" required=\"required\" ng-attr-name=\"title\" \nng-model=\"vm.empParametersPodcastForm.title\" aria-invalid=\"false\"><div \nng-messages=\"empParametersPodcastForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersPodcastError.title && vm.empParametersPodcastForm.title === vm.empParametersPodcastError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersPodcastError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label translate=\"PODCASTADD.form_attr_description\">\nDescription</label><div class=\"md-resize-wrapper\"><textarea id=\"empParametersPodcastForm_description\" \nname=\"empParametersPodcastForm[description]\" ng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" \nng-model=\"vm.empParametersPodcastForm.description\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 135px\">\n</textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empParametersPodcastForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empParametersPodcastError.description && vm.empParametersPodcastForm.description === vm.empParametersPodcastError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersPodcastError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><div class=\"date-container\" layout=\"column\" layout-gt-xs=\"row\" flex \nhas-permission=\"podcast_form_date\"><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" \nstyle=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">start_date</label><md-datepicker\n ng-model=\"vm.empParametersPodcastForm.startDate\" ng-attr-name=\"mdstart\" md-open-on-focus ng-change=\"vm.changeDate()\">\n</md-datepicker><div ng-messages=\"empParametersPodcastForm.endDate.$error\" \nng-if=\"empParametersPodcastForm.endDate.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">\ndate_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" \ntranslate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empParametersPodcastForm.mdstart && vm.empParametersPodcastForm.mdstart === vm.empParametersPodcastError.mdstart.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdstart.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label\n class=\"md-no-float\" translate=\"MESSAGES.end_date\">end_date</label><md-datepicker \nng-model=\"vm.empParametersPodcastForm.endDate\" ng-attr-name=\"mdEnd\" md-open-on-focus \nmd-min-date=\"vm.empParametersPodcastForm.startDate\" ng-change=\"vm.changeDate()\"></md-datepicker><div \nng-messages=\"empParametersPodcastForm.endDate.$error\" ng-if=\"empParametersPodcastForm.endDate.$touched\" role=\"alert\">\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-message=\"maxdate\" translate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empParametersPodcastForm.mdEnd && vm.empParametersPodcastForm.mdEnd === vm.empParametersPodcastError.mdEnd.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empMediaVideoError.mdEnd.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" has-permission=\"podcast_form_langue\">\n<md-input-container flex><label translate=\"MESSAGES.form_attr_language\">Langue</label><md-select translate \ntranslate=\"MESSAGES.form_attr_language\" name=\"empParametersPodcastForm[lang]\" id=\"empParametersCanalForm_language\" \nng-model=\"vm.empParametersPodcastForm.lang\"><md-option \nng-repeat=\"languageChoice in vm.languageChoices track by languageChoice.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"languageChoice.val\" translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option }}\n</md-option></md-select></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" \nhas-permission=\"podcast_form_is_accessible\"><div flex=\"50\" layout=\"column\" layout-gt-sm=\"row\"><div><md-checkbox \nng-true-value=\"true\" ng-false-value=\"false\" name=\"empParametersPodcastForm[is_accessible]\" \nid=\"empParametersPodcastForm_is_accessible\" ng-model=\"vm.empParametersPodcastForm.is_accessible\"><label \nclass=\"md-no-float\" translate=\"MESSAGES.form_attr_podcast_accessible\" \nstyle=\"font-size: 0.9em;\n    color: #7d7d7d !important;\n    position: relative;\n    margin-bottom: 5px;\n    display: block;\n    bottom: 0\">\nMettre podcast visible en internet</label></md-checkbox></div></div></div><div layout=\"row\" layout-xs=\"column\" \nhas-permission=\"podcast_form_explicit\"><label flex=\"30\" translate=\"PODCASTADD.explicite\">\nLe podcast contient du contenu explicite?</label><md-radio-group flex=\"70\" \nng-model=\"vm.empParametersPodcastForm.explicite\"><md-radio-button value=\"1\"><span \ntranslate=\"MESSAGES.form_choices_yes\"></span></md-radio-button><md-radio-button value=\"0\"><span \ntranslate=\"MESSAGES.form_choices_no\"></span></md-radio-button></md-radio-group></div><div layout=\"column\" \nlayout-gt-xs=\"row\" has-permission=\"podcast_form_category\"><md-input-container flex><label>Catégorie</label>\n<ms-themes-bootstrap all-themes=\"vm.category\" type=\"\'category\'\" name=\"empParametersPodcastForm[classifiedBy]\" \nshow-label=\"true\" multi=\"false\" has-categories=\"true\" ng-model=\"vm.empParametersPodcastForm.podcastCategory\" \nng-change=\"vm.selectCategory(\'category\',someModel)\" style=\"width: 100%; margin-top: -15px;padding-right: 15px\">\n</ms-themes-bootstrap><div ng-messages=\"empParametersPodcastForm.classifiedBy.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersPodcastError.classifiedBy && vm.empParametersPodcastForm.classifiedBy === vm.empParametersPodcastError.classifiedBy.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersPodcastError.classifiedBy.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div id=\"accordeon\" ng-repeat=\"x in vm.array\"><button ng-click=\"vm.click($index)\" \nclass=\"accordion\" type=\"button\">Podcast {{vm.array.indexOf(x)+1}}: {{x.audio}}</button><div class=\"panel\"><input \ntype=\"hidden\" name=\"empParametersPodcastForm[logo]\" ng-model=\"vm.array[vm.array.indexOf(x)].vignette\" \naria-invalid=\"false\"><div ng-if=\"!vm.array[vm.array.indexOf(x)].vignette\" layout-align=\"center center\" layout=\"row\" \nclass=\"s18\"><md-icon md-font-icon=\"icon-picture\" style=\"margin-left: 80px;  padding-top: 20px\" class=\"s72\" width=\"100\" \nheight=\"100\"></md-icon></div><div layout=\"row\" class=\"s18\"><img ng-if=\"vm.array[vm.array.indexOf(x)].vignette\" \nstyle=\"height: 70px;width: 92px;margin-left: 60px; padding-top: 10px\" \nng-src=\"{{vm.array[vm.array.indexOf(x)].vignette}}\"></div><div class=\"mv-24\" id=\"file-uploader\" \nflow-init=\"x.ngFlowPodcastOptions\" flow-name=\"x.ngFlowPodcast.flow\" flow-files-submitted=\"vm.uploadPodcastFile(x)\" \nflow-file-added=\"vm.filePodcastAdded($file,x)\" flow-file-success=\"vm.filePodcastSuccess(x, $message)\" \nflow-complete=\"vm.uploadPodcastComplete()\"><md-button flow-btn ng-click=\"vm.chooseThumb($index)\" \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"PODCASTADD.choose_thumb\">choose_thumb</any></md-button></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"PODCASTADD.form_attr_title\">Titre</label><input type=\"text\" \nname=\"empParametersPodcastForm[title]\" ng-attr-name=\"title\" \nng-model=\"vm.empParametersPodcastForm.podcastItems[vm.array.indexOf(x)].title\" aria-invalid=\"false\"><div \nng-messages=\"empParametersPodcastForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empParametersPodcastError.title && vm.empParametersPodcastForm.title === vm.empParametersPodcastError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersPodcastError.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label translate=\"PODCASTADD.form_attr_description\">\nDescription</label><div class=\"md-resize-wrapper\"><textarea name=\"empParametersPodcastForm[description]\" \nng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" \nng-model=\"vm.empParametersPodcastForm.podcastItems[vm.array.indexOf(x)].description\" aria-invalid=\"false\" \nng-trim=\"false\" style=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div>\n<div ng-messages=\"empParametersPodcastForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empParametersPodcastError.description && vm.empParametersPodcastForm.description === vm.empParametersPodcastError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empParametersPodcastError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div><md-button class=\"md-warn\" ui-sref=\"app.podcast_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empParametersPodcastForm.$invalid || empParametersPodcastForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empParametersPodcastForm.$invalid || empParametersPodcastForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div>\n</form></div></div></div></div></div>");
$templateCache.put("app/main/media/lives/conf/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/media/lives/conf/form.template.html\'\"></div></div></div>\n</div></div>");
$templateCache.put("app/main/media/lives/conf/form.template.html","<form name=\"empLivesConfForm\" method=\"post\" id=\"empLivesConfForm\" novalidate=\"novalidate\" \nng-submit=\"empLivesConfForm.$valid && vm.submitAddConfForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"CONFADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"CONFEDIT.form_title\">form_title</span></div><md-subheader class=\"md-no-sticky md-primary\"><span \ntranslate=\"LIVESADD.custom_choice\">custom_choice</span></md-subheader><div style=\"padding-top: 20px\" layout=\"column\" \nlayout-align=\" start\" class=\"ng-scope layout-column layout-align-start-start\"><md-radio-group \nng-model=\"vm.empLivesConfForm.type\"><div><md-radio-button value=\"Video\"><label translate=\"LIVESADD.form_attr_Video\" \nclass=\"required ng-scope md-required\">form_attr_Video</label></md-radio-button><md-card-content \nng-if=\"vm.empLivesConfForm.type === \'Video\'\"><md-select ng-model=\"vm.empLivesConfForm.video\" \nmd-on-close=\"vm.clearSearchTerm()\" placeholder=\"{{ \'LIVESADD.form_attr_Video\'|translate}}\"><md-select-header><input \nng-model=\"vm.searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\"></md-select-header><md-option value=\"\" translate=\"DASHBOARD.none\">\n</md-option><md-optgroup label=\"videos\"><md-option \nng-repeat=\"video in vm.videos | filter: vm.searchTerm track by video.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"video.val\" ng-attr-translate=\"{{video.val==0 ? \'MESSAGES.none\':\'\'}}\">{{video.option}}</md-option>\n</md-optgroup></md-select></md-card-content></div><div><md-radio-button value=\"Counter\"><label \ntranslate=\"LIVESADD.form_attr_Counter\" class=\"required ng-scope md-required\">form_attr_Counter</label>\n</md-radio-button></div><div><md-radio-button value=\"Message\"><label translate=\"LIVESADD.form_attr_Message\" \nclass=\"required ng-scope md-required\">form_attr_Message</label></md-radio-button><div \nng-if=\"vm.empLivesConfForm.type==\'Message\'\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESADD.form_attr_message\">Message</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empLivesConfForm_message\" name=\"empLivesConfForm[message]\" ng-attr-name=\"message\" \nng-model=\"vm.empLivesConfForm.message\" rows=\"1\" required=\"required\" aria-invalid=\"false\" style=\"height: 30px\">\n</textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empLivesConfForm.message.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div></div></div><div>\n<md-radio-button value=\"Image\"><label translate=\"LIVESADD.form_attr_Image\" class=\"required ng-scope md-required\">\nform_attr_Image</label></md-radio-button><div ng-if=\"vm.empLivesConfForm.type==\'Image\'\"><div \nng-if=\"vm.urlVignette==\'\' && vm.conf.image==null\" layout-align=\"left left\" layout=\"row\" class=\"s18\"><md-icon \nmd-font-icon=\"icon-picture\" style=\"margin-left: 70px;padding-top: 15px\" class=\"s72\" width=\"100\" height=\"100\"></md-icon>\n</div><div ng-if=\"vm.urlVignette==\'\' && vm.conf.image\" layout=\"row\" class=\"s18\"><img \nstyle=\"height: 60px;width: 80px; margin-left: 60px\" ng-src=\"{{vm.conf.image}}\"></div><div ng-if=\"vm.urlVignette\" \nlayout=\"row\" class=\"s18\"><img style=\"height: 60px;width: 80px; margin-left: 60px; padding-top: 10px\" \nng-src=\"{{vm.urlVignette}}\"></div><div layout=\"column\"><md-input-container flex><div class=\"mv-24\" \nid=\"filef2-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow[2]\" \nflow-files-submitted=\"vm.uploadFile(2)\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"LIVESADD.choose_thumb\">choose_thumb</any></md-button></div></md-input-container><md-input-container flex>\n<label translate=\"LIVESADD.form_attr_imageText\">Ajoutez un texte pour l\'afficher sur l\'image choisie</label><textarea \nid=\"empLivesConfForm_imageText\" name=\"empLivesConfForm[imageText]\" ng-attr-name=\"imageText\" required=\"required\" \nng-model=\"vm.empLivesConfForm.imageText\" rows=\"1\" aria-invalid=\"false\" style=\"height: 30px\"></textarea><div \nng-messages=\"empLivesConfForm.imageText.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div></div></div>\n</md-radio-group></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESADD.form_attr_titleLive\">Ajoutez un titre avant live</label><input type=\"text\" \nid=\"empLivesConfForm_titleLive\" name=\"empLivesConfForm[titleLive]\" ng-attr-name=\"titleLive\" aria-invalid=\"false\"><div \nng-messages=\"empLivesConfForm.titleLive.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"LIVESADD.form_attr_descLive\">Ajoutez un texte avant live\n</label><div class=\"md-resize-wrapper\"><textarea id=\"empLivesConfForm_descLive\" name=\"empLivesConfForm[descLive]\" \nng-attr-name=\"descLive\" ng-model=\"vm.empLivesConfForm.descLive\" rows=\"1\" aria-invalid=\"false\" style=\"height: 30px\">\n</textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div><div \nng-messages=\"empLivesConfForm.descLive.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></div></md-input-container></div><md-button \nclass=\"md-warn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"empLivesConfForm.$invalid || empLivesConfForm.$pristine\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" ng-disabled=\"empLivesConfForm.$invalid || empLivesConfForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/media/podcast/list/list.template.html","<div ng-if=\"!vm.isNewPodcast\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedPodcasts.length\" has-permission=\"podcast_multi_delete\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'PODCASTLIST.delete_podcasts_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedPodcastsConfirm($event)\" \naria-label=\"delete_podcasts_aria_label\" translate translate-attr-aria-label=\"PODCASTLIST.delete_podcasts_aria_label\">\n<md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"podcasts-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_podcasts\" ng-keydown=\"$event.keyCode === 13 && vm.searchPodcasts()\"></md-input-container></div>\n<md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewPodcast($event)\" \naria-label=\"action_new_element\" has-permission=\"podcast_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedPodcasts.length === vm.podcasts.length) && (vm.selectedPodcasts.length > 0)\" \nmd-indeterminate=\"vm.selectedPodcasts.length !== 0 && vm.selectedPodcasts.length !== vm.podcasts.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"PODCASTLIST.preview\">Apérçu</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PODCASTLIST.title\">title</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"PODCASTLIST.category\">Catégorie</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></div><div \nng-if=\"vm.isNewPodcast\" id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_podcast\" \nng-src=\"{{PodcastIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/media/podcast/list/preview.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" \nstyle=\"width: 70%;height: max-content; max-height: none\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s24\"></md-icon><span translate=\"MESSAGES.preview\">Preview</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"height: 100%;width: 100%\" ms-scroll class=\"no-padding\"><div \nng-style=\"{\'text-align\': \'center\',\'padding\': \'1em\',\'box-sizing\': \'border-box\',\'position\': \'relative\',\'padding-top\': \'56%\',\'overflow\': \'hidden\'}\">\n<div><iframe ng-if=\"vm.link\" style=\"position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\" \nwidth=\"800\" height=\"400\" ng-src=\"{{vm.link ? vm.trustLink(vm.link) : \'\'}}\" frameborder=\"0\" webkitallowfullscreen \nmozallowfullscreen allowfullscreen></iframe><any ng-if=\"vm.link === false\">{{\'MESSAGES.video_not_exist\' | translate}}\n</any></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/media/podcast/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"PODCASTLIST.export_links_modal_title\"></span> \n<span>{{ vm.podcast.title | json}}</span> </span><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"padding-bottom: 0;padding-top: 0\" ng-if=\"vm.links.url_export_channel\"><div style=\"padding-bottom: 0\" \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong translate=\"PODCASTLIST.export_links_perma_link\">\n</strong></div><div flex=\"80\" id=\"fo1\">{{vm.links.url_export_channel}}</div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo1\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div>\n</md-dialog-content><md-dialog-content style=\"padding-bottom: 0;padding-top: 0\" ng-if=\"vm.links.url_export_podcast\">\n<div style=\"padding-bottom: 0\" layout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong \ntranslate=\"PODCASTLIST.export_links_embed_link\"></strong></div><div flex=\"80\" id=\"fo3\">{{vm.links.url_export_podcast}}\n</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo3\" aria-label=\"url_copy\" \nng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div><div style=\"margin: 0\" \nclass=\"row_url socialNetwork\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>Code Embed</strong></div><div \nflex=\"100\" style=\"padding-top: 1px\" id=\"fo8\"><md-input-container><textarea aria-label=\"Code Embed\"><iframe \nstyle=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed}}\" allowfullscreen frameborder=\"0\"></iframe>\n                           </textarea>\n</md-input-container></div><br></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/media/podcast/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"parameters_podcast_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.parameters_podcast_detail_pagetitle\">\nparameters_podcast_detail_pagetitle</span> <span>{{ vm.podcast.title |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><img \nstyle=\"margin: auto\" ng-if=\"vm.podcast.vignette\" width=\"100\" height=\"100\" class=\"product-image\" \nng-src=\"{{ vm.podcast.vignette }}\"><md-list flex><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"PODCASTDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">{{ vm.podcast.id }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"PODCASTDETAIL.title\">title</strong></h3></div><div class=\"md-secondary\">{{ vm.podcast.title }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"PODCASTDETAIL.description\">description</strong></h3></div><div class=\"md-secondary\">\n{{ vm.podcast.description }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PODCASTDETAIL.category\">Catégorie</strong></h3></div><div \nclass=\"md-secondary\" ng-if=\"vm.podcast.podcastCategory \">{{ vm.podcast.podcastCategory }}</div><div \nclass=\"md-secondary\" md-colors=\"{color: \'#000000\'}\" ng-if=\"!vm.podcast.podcastCategory\" translate=\"MESSAGES.none\">\n</div><md-divider></md-divider></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span\n flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/podcast/upload/upload.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div ng-if=\"vm.uploadMetaDataError\" layout=\"row\" layout-align=\"center center\">\n<div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div layout=\"row\" \nlayout-align=\"center center\"><span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.alert_xhr_error\">alert_xhr_error</span></div></div></div><div class=\"mv-24\" \nng-if=\"vm.uploadMetaDataError\"></div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div\n class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-icon \nstyle=\"font-size: 60px !important;opacity: .25;margin-bottom: 20px;margin-top: 20px\" md-font-icon=\"icon-cloud-upload\" \nclass=\"s24 md-default-theme md-font material-icons icon-cloud-upload\" aria-hidden=\"true\"></md-icon><md-button \nstyle=\"margin-left: 38px\" class=\"md-accent md-raised\" flow-btn translate=\"PODCASTADD.select_files\" \nng-disabled=\"vm.inProgress\">choose_a_file</md-button><md-button class=\"md-warn md-flat\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel</md-button><span \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.audio_upload_drop_message\">\naudio_upload_drop_message</span></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>\n{{vm.videoFile.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" value=\"{{vm.progressBarValue}}\">\n</md-progress-circular></div></div></div></div></div></div></div>");
$templateCache.put("app/main/media/event_live/add_edit_view/add_edit.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth IE-add-event\" layout=\"column\"><div class=\"content fullpage\" \nlayout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" \nflex-gt-md=\"100\"><div ng-include=\"\'app/main/media/event_live/add_edit_view/form.template.html\'\"></div></div></div>\n</div></div>");
$templateCache.put("app/main/media/event_live/add_edit_view/form.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth IE-add-event\" layout=\"column\"><div class=\"content fullpage\" \nlayout=\"column\"><form style=\"margin-bottom: 60px\" name=\"empEventForm\" method=\"post\" ms-vertical-stepper=\"1\" \nid=\"empEventForm\" novalidate=\"novalidate\" ng-submit=\"empEventForm.$valid && vm.submitAddEventForm()\" flex=\"100\" \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-minTime ng-valid-format ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple ng-invalid-format\">\n<ms-vertical-stepper-step ng-form=\"horizontalStep1\" step=\"1\" step-title-translate=\"\'MESSAGES.form\'\" step-title=\"form\">\n<div><div class=\"md-inline-form\"><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox \nng-model=\"vm.empEventForm.speaker\"><label translate=\"EVENTADD.form_attr_speaker\">Orateur</label></md-checkbox>\n<md-checkbox style=\"margin-left: 4%\" ng-change=\"vm.change()\" ng-model=\"vm.external_link\"><label>Lien externe</label>\n</md-checkbox></div><div layout=\"row\"><div ng-if=\"!vm.external_link\" layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">\n<md-card-content flex><md-select translate translate=\"EVENTADD.form_attr_station\" name=\"empEventForm[station]\" \nid=\"empEventForm_station\" ng-model=\"vm.empEventForm.station\" required=\"required\" \nplaceholder=\"{{ \'EVENTADD.form_attr_station\'|translate}}\"><md-option value=\"\" translate=\"DASHBOARD.none\"></md-option>\n<md-option ng-repeat=\"station in vm.stations track by station.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"station.val\">{{ station.option }}</md-option></md-select><div ng-messages=\"horizontalStep1.station.$error\" \nng-if=\"horizontalStep1.station.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div></div></md-card-content></div><div ng-if=\"vm.external_link\" flex=\"50\"><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"EVENTADD.form_attr_url\">URL (https://)</label><input \ntype=\"text\" name=\"empEventForm[externalUrl]\" ng-attr-name=\"externalUrl\" ng-model=\"vm.empEventForm.externalUrl\" \nng-pattern=\"/((http|https)\\:\\/\\/)?[a-zA-Z0-9\\.\\/\\?\\:@\\-_=#]+\\.([a-zA-Z0-9\\&\\.\\/\\?\\:@\\-_=#])*/\" aria-invalid=\"false\" \nrequired><div class=\"md-errors-spacer\"></div><div ng-messages=\"horizontalStep1.externalUrl.$error\" \nng-if=\"horizontalStep1.externalUrl.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"EVENTADD.ivalid_URL_format\">ivalid_URL_format</div><div \nng-if=\"vm.empEventError.externalUrl && vm.empEventForm.externalUrl === vm.empEventError.externalUrl.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.externalUrl.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div><div style=\"margin-left: 2%\" layout=\"column\" layout-gt-xs=\"row\" flex=\"50\">\n<md-card-content flex><md-select translate translate=\"MESSAGES.form_attr_language\" name=\"empEventForm[language][]\" \nid=\"empEventForm_language\" ng-model=\"vm.empEventForm.language\" required=\"required\" multiple=\"1\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'|translate}}\"><md-option \nng-repeat=\"languageChoice in vm.languageChoices track by languageChoice.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"languageChoice.val\"><any translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option }}\n</any></md-option></md-select>{{horizontalStep1.language.$error}}<div ng-messages=\"horizontalStep1.language.$error\" \nng-if=\"horizontalStep1.language.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.language && vm.empEventForm.language === vm.empEventError.language.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.language.message}}\" class=\"validation_api\"></div></div></md-card-content>\n</div></div><div layout=\"row\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_conference_key\">Clé de conférence</label><input type=\"text\" \nid=\"empEventForm_conference_key\" name=\"empEventForm[conference_key]\" required=\"required\" ng-attr-name=\"conference_key\" \nng-model=\"vm.empEventForm.conference_key\" aria-invalid=\"true\"><div ng-messages=\"horizontalStep1.conference_key.$error\" \nng-if=\"horizontalStep1.conference_key.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.conference_key && vm.empEventForm.conference_key === vm.empEventError.conference_key.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.conference_key.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div style=\"margin-left: 2%\" layout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><md-card-content \nflex><md-select translate translate=\"EVENTADD.form_attr_direction\" name=\"empEventForm[video.direction]\" \nid=\"empEventForm_video.direction\" ng-model=\"vm.empEventForm.video.direction\" required=\"required\" \nplaceholder=\"{{ \'EVENTADD.form_attr_direction\'|translate}}\"><md-option \nng-repeat=\"theme in vm.themesNames track by theme.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"theme.val\">\n{{ theme.option }}</md-option></md-select><div ng-messages=\"horizontalStep1.video.direction.$error\" \nng-if=\"horizontalStep1.video.direction.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.video.direction && vm.empEventForm.video.direction === vm.empEventError.video.direction.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.video.direction.message}}\" class=\"validation_api\"></div></div>\n</md-card-content></div></div><div layout=\"row\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"50\"><md-card-content \nflex><md-select translate translate=\"EVENTADD.form_attr_direction\" name=\"empEventForm[category]\" \nid=\"empEventForm_category\" ng-model=\"vm.empEventForm.category\" required=\"required\" \nplaceholder=\"{{ \'EVENTADD.form_attr_category\'|translate}}\"><md-option \nng-repeat=\"category in vm.categoryChoices track by category.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"category.val\">{{ category.option }}</md-option></md-select><div \nng-messages=\"horizontalStep1.category.$error\" ng-if=\"horizontalStep1.category.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.category && vm.empEventForm.category === vm.empEventError.category.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.category.message}}\" class=\"validation_api\"></div></div></md-card-content>\n</div><div style=\"margin-left: 2%\" layout=\"column\" layout-gt-sm=\"row\" flex=\"50\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_title\">Titre</label><input type=\"text\" id=\"empEventForm_title\" \nname=\"empEventForm[title]\" required=\"required\" ng-attr-name=\"title\" ng-model=\"vm.empEventForm.video.title\" \naria-invalid=\"true\"><div ng-messages=\"horizontalStep1.title.$error\" ng-if=\"horizontalStep1.title.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.video.title && vm.empEventForm.video.title === vm.empEventError.video.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.video.title.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empEventForm_description\" name=\"empEventForm[description]\" required=\"required\" ng-attr-name=\"description\" \nng-model=\"vm.empEventForm.video.description\" rows=\"1\" aria-invalid=\"true\" style=\"height: 30px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div ng-messages=\"horizontalStep1.description.$error\" \nng-if=\"horizontalStep1.description.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.video.description && vm.empEventForm.video.description === vm.empEventError.video.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.video.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" flex=\"25\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">\nstart_date</label><md-datepicker id=\"datepicker-event\" required=\"required\" ng-model=\"vm.empEventForm.mdTime.date\" \nng-change=\"vm.changeDate()\" ng-attr-name=\"date_start\" md-min-date=\"vm.minDate\" md-open-on-focus name=\"date_start\" \nid=\"date_start\"></md-datepicker><div ng-messages=\"horizontalStep1.date_start.$error\" \nng-if=\"horizontalStep1.date_start.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">\ndate_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" \ntranslate=\"MESSAGES.date_max\">date_max</div><div \nng-if=\"vm.empEventError.date_start && vm.empEventForm.date_start === vm.empEventError.date_start.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.date_start.message}}\" class=\"validation_api\"></div></div></div><div \nstyle=\"margin-top: 2%\" layout=\"row\"><div layout=\"column\" flex=\"25\"><label translate=\"MESSAGES.start_time\">start_time\n</label><mdp-time-picker ng-change=\"vm.changeTime()\" ng-model=\"vm.empEventForm.mdTime.time\" ng-attr-name=\"time\" \nmdp-format=\"HH:mm:ss\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" md-open-on-focus \nrequired=\"required\"><div ng-messages=\"horizontalStep1.time.$error\" ng-if=\"horizontalStep1.time.$touched\" role=\"alert\">\n<div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.time_format\">time_format</div><div \nng-if=\"vm.empEventError.time && vm.empEventForm.time === vm.empEventError.time.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.time.message}}\" class=\"validation_api\"></div></div></mdp-time-picker></div>\n<div layout=\"column\" flex=\"25\"><label translate=\"EVENTADD.end_time\">end_time</label><mdp-time-picker \nng-change=\"vm.changeEndtime()\" ng-model=\"vm.empEventForm.endtime\" ng-attr-name=\"endtime\" mdp-format=\"HH:mm:ss\" \nrequired=\"required\" mdp-min-time=\"vm.empEventForm.mdTime.timeMin\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" \nmdp-clear-on-cancel=\"false\" md-open-on-focus><div ng-messages=\"horizontalStep1.endtime.$error\" \nng-if=\"horizontalStep1.endtime.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.time_format\">time_format</div><div \nng-message=\"minTime\" translate=\"MESSAGES.time_min\">time_min</div><div \nng-if=\"vm.empEventError.endtime && vm.empEventForm.endtime === vm.empEventError.endtime.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.endtime.message}}\" class=\"validation_api\"></div></div></mdp-time-picker>\n</div></div><div layout=\"row\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"25\"><md-checkbox \nng-model=\"vm.empEventForm.rich_media_presentation\"><label translate=\"EVENTADD.form_attr_rich_media_presentation\">\nPrésentation RichMédia</label></md-checkbox><div ng-messages=\"horizontalStep1.rich_media_presentation.$error\" \nng-if=\"horizontalStep1.rich_media_presentation.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"25\"><md-checkbox ng-model=\"vm.empEventForm.video.offline\"><label translate=\"EVENTADD.form_attr_online_video\">\nVOD en ligne après le LIVE</label></md-checkbox><div ng-messages=\"horizontalStep1.online_video.$error\" \nng-if=\"horizontalStep1.online_video.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nflex=\"25\"><md-checkbox ng-model=\"vm.empEventForm.video.downloadable\"><label \ntranslate=\"EVENTADD.form_attr_downloadable_video\">Vidéo téléchargeable</label></md-checkbox><div \nng-messages=\"horizontalStep1.downloadable_video.$error\" ng-if=\"horizontalStep1.downloadable_video.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></div></div>\n<div layout=\"row\" layout-gt-sm=\"row\"><md-checkbox aria-label=\"isVisibleOnInternet\" \nng-model=\"vm.empEventForm.video.isVisibleOnInternet\"><label translate=\"EVENTADD.form_attr_isVisibleOnInternet\"></label>\n</md-checkbox></div><div style=\"height: 25px;border-left: solid 1px #e0e0e0; margin-left: 32px;margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isVisibleOnInternet\"></div><div style=\"margin-left :28px;margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isVisibleOnInternet\" layout=\"row\" flex><div flex=\"25\"><md-checkbox \naria-label=\"isSecuredOnInternet\" ng-model=\"vm.empEventForm.video.isSecuredOnInternet\"><label \ntranslate=\"EVENTADD.form_attr_secureInternet\"></label></md-checkbox></div><div style=\"margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isSecuredOnInternet\" flex=\"25\"><div layout-align=\"center center\"><md-input-container flex>\n<label translate=\"LIVESADD.password\">Mot de passe</label><input type=\"password\" id=\"password\" required=\"required\" \nng-attr-name=\"title\" ng-model=\"vm.empEventForm.video.passwordInternet\" aria-invalid=\"true\"></md-input-container></div>\n</div></div><div layout=\"row\" layout-gt-sm=\"row\"><md-checkbox ng-if=\"vm.isIntranet_Internet\" \naria-label=\"isVisibleOnIntranet\" ng-model=\"vm.empEventForm.video.isVisibleOnIntranet\"><label \ntranslate=\"EVENTADD.form_attr_isVisibleOnIntranet\"></label></md-checkbox></div><div \nstyle=\"height: 25px;border-left: solid 1px #e0e0e0; margin-left: 32px;margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isVisibleOnIntranet && vm.isIntranet_Internet\"></div><div \nstyle=\"margin-left: 28px;margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isVisibleOnIntranet && vm.isIntranet_Internet\" layout=\"row\" flex><div flex=\"25\">\n<md-checkbox aria-label=\"isSecuredOnIntranet\" ng-model=\"vm.empEventForm.video.isSecuredOnIntranet\"><label \ntranslate=\"EVENTADD.form_attr_secureIntranet\"></label></md-checkbox></div><div style=\"margin-top: -10px\" \nng-if=\"vm.empEventForm.video.isSecuredOnIntranet\" flex=\"25\"><div layout-align=\"center center\"><md-input-container flex>\n<label translate=\"LIVESADD.password\">Mot de passe</label><input type=\"password\" id=\"password2\" required=\"required\" \nng-attr-name=\"title\" ng-model=\"vm.empEventForm.video.passwordIntranet\" aria-invalid=\"true\"></md-input-container></div>\n</div></div></div></div></ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"horizontalStep2\" step=\"2\" \nstep-title-translate=\"\'MESSAGES.form_complementary_info\'\" step-title=\"form_complementary_info\"><input type=\"hidden\" \nid=\"empEventForm_thumbnail\" name=\"empEventForm[video.logo]\" ng-model=\"vm.empEventForm.video.logo\" aria-invalid=\"false\">\n<div ng-if=\"vm.urlVignette===\'\' && vm.empEventForm.video.logo===\'\'\" layout-align=\"left left\" layout=\"row\" class=\"s18\">\n<md-icon md-font-icon=\"icon-picture\" style=\"margin-left: 70px\" class=\"s72\" width=\"100\" height=\"100\"></md-icon></div>\n<div ng-if=\"vm.urlVignette===\'\' && vm.event.video.logo\" layout=\"row\" class=\"s18\"><img \nstyle=\"height: 60px;width: 80px; margin-left: 70px\" ng-src=\"{{vm.event.video.logo}}\"></div><div ng-if=\"vm.urlVignette\" \nlayout=\"row\" class=\"s18\"><img style=\"height: 60px;width: 80px; margin-left: 70px\" ng-src=\"{{vm.urlVignette}}\"></div>\n<div class=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"EVENTADD.choose_thumb\">choose_thumb</any></md-button></div><div ng-if=\"!vm.external_link\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"EVENTADD.form_attr_url_title\">Titre d\'URL\n</label><input type=\"text\" id=\"empEventForm_url_title\" name=\"empEventForm[url_title]\" ng-attr-name=\"url_title\" \nng-model=\"vm.empEventForm.url_title\" aria-invalid=\"false\"><div ng-messages=\"horizontalStep2.url_title.$error\" \nng-if=\"horizontalStep2.url_title.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"EVENTADD.ivalid_URL_format\">ivalid_URL_format</div><div \nng-if=\"vm.empEventError.station && vm.empEventForm.station === vm.empEventError.station.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.station.message}}\" class=\"validation_api\"></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"EVENTADD.form_attr_url\">\nURL (https://)</label><input type=\"text\" name=\"empEventForm[url]\" ng-attr-name=\"url\" ng-model=\"vm.empEventForm.url\" \nng-pattern=\"/((http|https)\\:\\/\\/)?[a-zA-Z0-9\\.\\/\\?\\:@\\-_=#]+\\.([a-zA-Z0-9\\&\\.\\/\\?\\:@\\-_=#])*/\" aria-invalid=\"false\">\n<div class=\"md-errors-spacer\"></div><div ng-messages=\"horizontalStep2.url.$error\" ng-if=\"horizontalStep2.url.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-message=\"pattern\" translate=\"EVENTADD.ivalid_URL_format\">ivalid_URL_format</div><div \nng-if=\"vm.empEventError.url && vm.empEventForm.url === vm.empEventError.url.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.url.message}}\" class=\"validation_api\"></div></div></md-input-container></div>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"EVENTADD.form_attr_author\">\nAuteur</label><input type=\"text\" id=\"empEventForm_author\" name=\"empEventForm[author]\" ng-attr-name=\"author\" \nng-model=\"vm.empEventForm.video.author\" aria-invalid=\"false\"><div ng-messages=\"horizontalStep2.author.$error\" \nng-if=\"horizontalStep2.author.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label translate=\"EVENTADD.form_attr_copyright\">Copyright</label><input type=\"text\" id=\"empEventForm_copyright\" \nname=\"empEventForm[copyright]\" ng-attr-name=\"copyright\" ng-model=\"vm.empEventForm.video.copyright\" \naria-invalid=\"false\"><div ng-messages=\"horizontalStep2.copyright.$error\" ng-if=\"horizontalStep2.copyright.$touched\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\"><div><md-input-container \nclass=\"md-block md-input-has-placeholder md-default-theme\"><label translate=\"VIDEOADD.form_attr_key_words\">Mots clés\n</label><md-chips id=\"empMediaVideoForm_keyWords\" name=\"vm.empEventForm[video.keyWords]\" \nng-model=\"vm.empEventForm.video.keyWords\" md-removable=\"1\" aria-hidden=\"true\" tabindex=\"-1\" aria-invalid=\"false\">\n<md-chips-wrap ng-keydown=\"$mdChipsCtrl.chipKeydown($event)\" \nng-class=\"{ \'md-focused\': $mdChipsCtrl.hasFocus(),                       \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,                      \'md-removable\': $mdChipsCtrl.isRemovable() }\" \nclass=\"md-chips md-removable\"><md-chip ng-repeat=\"$chip in $mdChipsCtrl.items\" index=\"0\" \nng-class=\"{\'md-focused\': $mdChipsCtrl.selectedChip === $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}\" \nclass=\"ng-scope md-default-theme\"><div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" \nng-click=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.focusChip($index)\" \nng-focus=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.selectChip($index)\" \nmd-chip-transclude=\"$mdChipsCtrl.chipContentsTemplate\" role=\"button\"><span class=\"ng-binding ng-scope\"></span></div>\n<div ng-if=\"$mdChipsCtrl.isRemovable()\" class=\"md-chip-remove-container ng-scope\" \nmd-chip-transclude=\"$mdChipsCtrl.chipRemoveTemplate\"><button class=\"md-chip-remove ng-scope\" \nng-if=\"$mdChipsCtrl.isRemovable()\" ng-click=\"$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)\" \ntype=\"button\" aria-hidden=\"true\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=\" \nclass=\"md-default-theme\" aria-hidden=\"true\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" \nxmlns=\"https://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveAspectRatio=\"xMidYMid meet\" \nfocusable=\"false\"><g><path \nd=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\">\n</path></g></svg></md-icon><span class=\"md-visually-hidden ng-binding\">Remove</span></button></div><span \nng-if=\"!$mdChipsCtrl.readonly\" class=\"md-visually-hidden ng-binding ng-scope\">Press delete to remove this chip. </span>\n</md-chip><div class=\"md-chip-input-container ng-scope\" \nng-if=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.ngModelCtrl\"><div \nmd-chip-transclude=\"$mdChipsCtrl.chipInputTemplate\"><input \nclass=\"md-input ng-pristine ng-untouched ng-valid ng-scope ng-empty\" tabindex=\"0\" aria-label=\"Mots clés\" \nng-model=\"$mdChipsCtrl.chipBuffer\" ng-focus=\"$mdChipsCtrl.onInputFocus()\" ng-blur=\"$mdChipsCtrl.onInputBlur()\" \nng-keydown=\"$mdChipsCtrl.inputKeydown($event)\" id=\"input_43\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</div></div></md-chips-wrap></md-chips></md-input-container></div></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title-translate=\"\'MESSAGES.form_organisator_info\'\" \nstep-title=\"form_organisator_info\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_organizer_name\">Nom de l\'organisateur</label><input type=\"text\" \nid=\"empEventForm_organizer_name\" name=\"empEventForm[organizer_name]\" ng-attr-name=\"organizer_name\" translate=\"\" \nng-model=\"vm.empEventForm.organizer_name\" aria-invalid=\"false\"><div \nng-messages=\"horizontalStep3.organizer_name.$error\" ng-if=\"horizontalStep3.organizer_name.$touched\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empEventError.organizer_name && vm.empEventForm.organizer_name === vm.empEventError.organizer_name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.organizer_name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_organizer_email\">Email de l\'organisateur</label><input type=\"text\" \nid=\"empEventForm_organizer_email\" name=\"empEventForm[organizer_email]\" ng-attr-name=\"organizer_email\" \nng-model=\"vm.empEventForm.organizer_email\" aria-invalid=\"false\" \nng-pattern=\"/^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$/\"><div ng-messages=\"horizontalStep3.organizer_email.$error\" \nng-if=\"horizontalStep3.organizer_email.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"EVENTADD.invalid_email_format\">invalid_email_format</div><div \nng-if=\"vm.empEventError.organizer_email && vm.empEventForm.organizer_email === vm.empEventError.organizer_email.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.organizer_email.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_sms_count\">Nombre de SMS</label><input type=\"text\" id=\"empEventForm_sms_count\" \nname=\"empEventForm[sms_count]\" ng-attr-name=\"sms_count\" ng-model=\"vm.empEventForm.sms_count\" aria-invalid=\"false\" \nng-pattern=\"/^(0|[1-9][0-9]*)$/\"><div ng-messages=\"horizontalStep3.sms_count.$error\" \nng-if=\"horizontalStep3.sms_count.$touched\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"EVENTADD.invalid_number\">invalid_number</div><div \nng-if=\"vm.empEventError.sms_count && vm.empEventForm.sms_count === vm.empEventError.sms_count.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.sms_count.message}}\" class=\"validation_api\"></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-xs=\"row\"><md-card-content flex><md-select translate \ntranslate=\"EVENTADD.form_attr_access_type\" name=\"empEventForm[access_type]\" id=\"empEventForm_access_type\" \nng-model=\"vm.empEventForm.access_type\" placeholder=\"{{ \'EVENTADD.form_attr_access_type\'|translate}}\"><md-option \nng-repeat=\"accessChoice in vm.accessChoices\" ng-value=\"accessChoice.val\">{{ accessChoice.option }}</md-option>\n</md-select></md-card-content></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"EVENTADD.form_attr_comment\">Commentaire</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empEventForm_comment\" name=\"empEventForm[comment]\" ng-attr-name=\"comment\" ng-model=\"vm.empEventForm.comment\" \nrows=\"1\" aria-invalid=\"false\" style=\"height: 30px\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div><div ng-messages=\"horizontalStep3.comment.$error\" \nng-if=\"horizontalStep3.comment.$touched\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empEventError.comment && vm.empEventForm.comment === vm.empEventError.comment.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empEventError.comment.message}}\" class=\"validation_api\"></div></div></div>\n</md-input-container></div></ms-vertical-stepper-step><div \nclass=\"md-whiteframe-1dp md-background-bg p-24 centerdiiv flex-xs-100 flex-100\" \nstyle=\"padding-right: 280px;padding-top: 5px; margin-left: -15px;width: 100%;position: fixed;bottom: 0;background: white;box-shadow: 0px -2px 5px 0px rgba(0,0,0,0.22);height: 60px\">\n<md-button class=\"md-warn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-disabled=\"empEventForm.$invalid || empEventForm.$pristine \" ng-click=\"MsStepper.resetForm()\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" ng-transclude=\"\" \nng-click=\"MsStepper.resetForm()\" ng-disabled=\"empEventForm.$invalid || empEventForm.$pristine\" style=\"\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div>\n</form></div></div>");
$templateCache.put("app/main/media/event_live/calendar/calendar.template.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\" id=\"IE-header-calendar\"><div class=\"header-content\" layout=\"column\" \nlayout-align=\"space-between\"><div class=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" \nui-sref=\"app.dashboard\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon>\n<span class=\"parent\" translate=\"PAGESMENUSTITLES.event_list_pagetitle\">media_menuTitle</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.event_calendar_menuTitle\">event_calendar_menuTitle</span></div><div class=\"header-top\" \nlayout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"PAGESMENUSTITLES.event_calendar_pagetitle\">event__calendar_pagetitle</span></div><div \nclass=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.calendar_pervious\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"calendar_pervious\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_pervious\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n</a><div class=\"title\">{{vm.calendarView.title}}</div><a tooltips \ntooltip-template=\"{{\'MESSAGES.calendar_next\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"calendar_next\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_next\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</a></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><a tooltips \ntooltip-template=\"{{\'PAGESMENUSTITLES.events_list\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.returnToList()\" aria-label=\"events_list\" translate \ntranslate-attr-aria-label=\"PAGESMENUSTITLES.events_list\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-list\" aria-hidden=\"true\"></md-icon></md-button></a><a\n tooltips tooltip-template=\"{{\'MESSAGES.calendar_today\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"calendar_today\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_today\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'MESSAGES.calendar_day\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"calendar_day\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_day\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.calendar_week\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"calendar_week\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_week\"><md-icon md-font-icon=\"icon-view-week\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.calendar_month\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"calendar_month\" translate \ntranslate-attr-aria-label=\"\"><md-icon md-font-icon=\"icon-view-module\"></md-icon></md-button></a></div></div></div>\n</div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></div>");
$templateCache.put("app/main/media/event_live/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"event_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.event_detail_pagetitle\">event_detail_pagetitle</span> \n<span>{{ vm.event.title |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.id }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.title\">title</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.video.title }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.language\">language</strong></h3></div><div \nlayout=\"column\" layout-align=\"center center\" class=\"md-secondary\" ng-repeat=\"l in vm.event.video.medias\" \nstyle=\"margin-right: 10%\"><div ng-if=\"l.lang!==\'or\'\" style=\"text-transform: capitalize\" \ntranslate=\"LANGUAGES.Names.{{l.lang}}\">{{ l.lang }}</div><div ng-if=\"l.lang===\'or\'\" translate=\"MESSAGES.{{l.lang}}\">\n{{ l.lang }}</div></div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.conference_key\">conference_key</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.event.conference_key }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.direction\">direction</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.event.video.themes[0].title }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.category\">category\n</strong></h3></div><div class=\"md-secondary\">{{ vm.event.category.title }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.description\">description</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.video.description }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.date\">date</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.video.startDate | date:\"dd/MM/yyyy\" }} ({{ vm.event.video.startDate | date:\"HH:mm\" }} -{{ vm.event.video.endDate| date : \"HH:mm\" }})\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"EVENTDETAIL.rich_media_presentation\">rich_media_presentation</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{ vm.event.rich_media_presentation==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{ vm.event.rich_media_presentation }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.online_video\">online_video</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{ vm.event.online_video==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{ vm.event.online_video }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.downloadable_video\">downloadable_video</strong></h3></div>\n<div class=\"md-secondary\" \nng-attr-translate=\"{{ vm.event.downloadable_video==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{ vm.event.downloadable_video }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.thumbnail\">thumbnail</strong></h3></div><div \nclass=\"md-secondary\"><img ng-if=\"vm.event.video.logo\" width=\"100\" height=\"100\" class=\"product-image\" \nng-src=\"{{ vm.event.video.logo }}\"> <span \nng-if=\"vm.event.video.logo === null || vm.event.video.logo === \'\' || vm.event.video.logo === false \">-</span></div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.url_title\">url_title</strong></h3></div><div class=\"md-secondary\">{{ vm.event.url_title }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.url\">url</strong></h3></div><div class=\"md-secondary\">{{ vm.event.url }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.author\">author</strong></h3></div><div class=\"md-secondary\">{{ vm.event.video.author }}</div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.copyright\">copyright</strong></h3></div><div class=\"md-secondary\">{{ vm.event.video.copyright }}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"EVENTDETAIL.key_words\">key_words</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.video.keyWords }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.organizer_name\">organizer_name</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.event.organizer_name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.organizer_email\">organizer_email\n</strong></h3></div><div class=\"md-secondary\">{{ vm.event.organizer_email }}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"EVENTDETAIL.sms_countaccess_type\">sms_countaccess_type</strong></h3></div><div class=\"md-secondary\">\n{{ vm.event.sms_count }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.access_type\">access_type</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.event.access_type }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"EVENTDETAIL.comment\">comment</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.event.comment }}</div><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/event_live/language/language.html","<md-menu><a tooltips tooltip-template=\"{{\'MESSAGES.add_language\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" \naria-label=\"description_audio\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></a><md-menu-content><div>\n<md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\" placeholder=\"Language\"></md-icon><input \nid=\"event-search\" class=\"search-input ng-scope flex\" type=\"text\" ng-model=\"vm.language\"></div><md-menu-item \nng-repeat=\"languageChoice in vm.languageChoices | translateFilter:vm.language \" ng-value=\"languageChoice.val\">\n<md-button ng-click=\"vm.sendLanguage(languageChoice.val,event)\"><any \ntranslate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option }}</any></md-button></md-menu-item>\n</md-menu-content></md-menu>");
$templateCache.put("app/main/media/event_live/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div ng-if=\"!vm.isNewEvent\" \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"\" layout=\"row\" flex ng-if=\"vm.selectedEvents.length\" \nhas-permission=\"event_delete_multi\"><a tooltips \ntooltip-template=\"{{\'EVENTLIST.delete_selected_events_aria_label\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedEventsConfirm($event)\" \naria-label=\"delete_selected_lives_aria_label\" translate \ntranslate-attr-aria-label=\"EVENTLIST.delete_selected_events_aria_label\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'EVENTLIST.show_calendar\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ui-sref=\"app.event_calendar\" \naria-label=\"show_calendar\" translate translate-attr-aria-label=\"EVENTLIST.show_calendar\"><md-icon \nmd-font-icon=\"icon-calendar-multiple\" class=\"ng-scope md-default-theme md-font material-icons icon-calendar-multiple\" \naria-hidden=\"true\"></md-icon></md-button></a><a tooltips tooltip-template=\"{{\'EVENTLIST.show_ongoing\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" \nui-sref=\"app.event_list_ongoing\" ng-if=\"$root.state.current.url!==\'/on-going\'\" aria-label=\"show_ongoing\" translate \ntranslate-attr-aria-label=\"EVENTLIST.show_ongoing\"><md-icon md-font-icon=\"icon-play\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-multiple\" aria-hidden=\"true\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'EVENTLIST.show_upcoming\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" ui-sref=\"app.event_list_upcoming\" \nng-if=\"$root.state.current.url!==\'/up-coming\'\" aria-label=\"show_upcoming\" translate \ntranslate-attr-aria-label=\"EVENTLIST.show_upcoming\"><md-icon md-font-icon=\"icon-clock-fast\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-calendar-multiple\" aria-hidden=\"true\"></md-icon>\n</md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"event-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Title\" translate \ntranslate-attr-placeholder=\"MESSAGES.title\" flex ng-model=\"vm.search_event\" ng-change=\"vm.searchEventsLives()\">\n</md-input-container></div><div flex=\"\"><ms-channels ng-model=\"vm.canal\" \nng-change=\"vm.searchEventsLives(\'canal\',someModelChannel)\"></ms-channels></div><div flex=\"\"><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.searchEventsLives(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"videos-search2\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Id\" ng-model=\"vm.search_events\" ng-change=\"vm.searchEventsLives()\"></md-input-container></div>\n<div><md-datepicker ng-model=\"vm.startDate\" ng-change=\"vm.searchEventsLives()\" md-placeholder=\"Date\"></md-datepicker>\n</div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewEvent($event)\" \naria-label=\"action_new_element\" has-permission=\"event_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox ng-if=\"vm.events.length>0\" \nng-checked=\"(vm.selectedEvents.length === vm.events.length) && (vm.selectedEvents.length > 0)\" \nmd-indeterminate=\"vm.selectedEvents.length !== 0 && vm.selectedEvents.length !== vm.events.length\" \nng-click=\"vm.toogleSelection()\" aria-label=\"-\"></md-checkbox></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"EVENTLIST.overview\">overview\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.form_attr_title\">form_attr_title</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"EVENTLIST.languages\">languages</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"EVENTLIST.date\">date</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div><div ng-if=\"vm.isNewEvent\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"overflow: hidden; height: 900px\" layout=\"row\" layout-wrap><iframe id=\"iframe_event\" \nng-src=\"{{vm.newEventIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%; height: 100%; overflow: hidden\">\n</iframe></div></div></div></div>");
$templateCache.put("app/main/media/event_live/list/url.modale.template.html","<md-dialog style=\"width: 60%\" class=\"video-url-dialog\" id=\"embed_modal\" aria-label=\"Video Detail\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<md-icon md-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"EVENTLIST.export_links_modal_title\">\n</span> <span>{{ vm.title | json}}</span> </span><span flex></span> <span style=\"font-size: 16px\" \ndata-ng-style=\"vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.links.data.url.length===2\">Intranet\n</span> <span style=\"font-size: 16px\" data-ng-style=\"vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" \nng-if=\"vm.links.data.url.length===1\">Internet</span><md-switch ng-if=\"vm.links.data.url.length>=1\" \nid=\"switch-intra-inter\" ng-disabled=\"vm.links.data.url.length===1\" \ndata-ng-style=\"vm.links.data.url.length===1 && {\'opacity\':\'0.6\'}\" style=\"margin-left: 16px;margin-right: 5px\" \nclass=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" ng-model=\"vm.intranet\" ng-change=\"vm.changeIntraInter()\">\n</md-switch><span style=\"font-size: 16px\" data-ng-style=\"!vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" \nng-if=\"vm.links.data.url.length===2\">Internet</span> <span style=\"font-size: 16px\" \ndata-ng-style=\"!vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.links.data.url.length===1\">Intranet\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"padding-bottom: 0;padding-top: 0\"><md-content ng-if=\"vm.intranet\" \nstyle=\"padding-top: 0 !important\" class=\"md-padding\"><div style=\"padding-top: 30px\" align=\"left\"><strong \ntranslate=\"EVENTLIST.export_type\"></strong></div><md-radio-group style=\"padding-bottom: 10px\" ng-model=\"vm.searchLink\" \nlayout=\"row\" ng-change=\"vm.changeIntraInter()\"><md-radio-button value=\"auto\" aria-label=\"Auto\"><p \ntranslate=\"EVENTLIST.export_auto\"></p></md-radio-button><md-radio-button value=\"event\" aria-label=\"Live\"><p \ntranslate=\"EVENTLIST.export_live\"></p></md-radio-button><md-radio-button value=\"vod\" aria-label=\"Video\"><p \ntranslate=\"EVENTLIST.export_video\"></p></md-radio-button></md-radio-group><div style=\"padding-top: 20px\" \nlayout=\"column\"><div style=\"padding-bottom: 15px\" align=\"left\"><strong translate=\"EVENTLIST.export_auto_title\">\n</strong></div><div><md-checkbox ng-model=\"vm.autoplay\" ng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" \naria-label=\"autoplay\">autoplay</md-checkbox></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.urlPermalien\"><div flex=\"20\"><strong translate=\"EVENTLIST.export_links_perma_link\"></strong></div><div \nflex=\"80\" id=\"fo11\">{{vm.urlPermalien[\'intranet\']}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo11\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div><div layout=\"row\" \nclass=\"row_url\" layout-xs=\"column\" ng-if=\"vm.urlEmbed\"><div flex=\"20\"><strong \ntranslate=\"EVENTLIST.export_links_embed_link\"></strong></div><div flex=\"80\" id=\"fo12\"><md-input-container \nstyle=\"margin: 0\"><textarea aria-label=\"url-embed\" style=\"border: 1px solid #EDEDED\" id=\"bar1\" class=\"fs-14\"><iframe \nsrc=\"{{vm.urlEmbed[\'intranet\']}}\"></iframe></textarea></md-input-container></div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo12\" aria-label=\"url_copy\" ng-click=\"vm.copied =1\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===1}\"></md-icon></md-button></div>\n</md-content><md-content ng-if=\"!vm.intranet\" style=\"padding-top: 0 !important\" class=\"md-padding\"><div \nstyle=\"padding-top: 30px\" align=\"left\"><strong translate=\"EVENTLIST.export_type\"></strong></div><md-radio-group \nstyle=\"padding-bottom: 10px\" ng-model=\"vm.searchLink\" layout=\"row\" ng-change=\"vm.changeIntraInter()\"><md-radio-button \nvalue=\"auto\" aria-label=\"Auto\"><p translate=\"EVENTLIST.export_auto\"></p></md-radio-button><md-radio-button \nvalue=\"event\" aria-label=\"Live\"><p translate=\"EVENTLIST.export_live\"></p></md-radio-button><md-radio-button \nvalue=\"vod\" aria-label=\"Video\"><p translate=\"EVENTLIST.export_video\"></p></md-radio-button></md-radio-group><div \nstyle=\"padding-top: 20px\" layout=\"column\"><div style=\"padding-bottom: 15px\" align=\"left\"><strong \ntranslate=\"EVENTLIST.export_auto_title\"></strong></div><div><md-checkbox ng-model=\"vm.autoplay\" \nng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" aria-label=\"autoplay\">autoplay</md-checkbox></div></div><div \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.urlPermalien\"><div flex=\"20\"><strong \ntranslate=\"EVENTLIST.export_links_perma_link\"></strong></div><div flex=\"80\" id=\"fo1\">{{vm.urlPermalien[\'internet\']}}\n</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo1\" aria-label=\"url_copy\" \nng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div><div layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.urlEmbed\"><div flex=\"20\"><strong translate=\"EVENTLIST.export_links_embed_link\"></strong>\n</div><div flex=\"80\" id=\"fo\"><md-input-container style=\"margin: 0\"><textarea aria-label=\"url-embed\" \nstyle=\"border: 1px solid #EDEDED\" id=\"bar\" class=\"fs-14\"><iframe src=\"{{vm.urlEmbed[\'internet\']}}\"></iframe></textarea>\n</md-input-container></div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo\" \naria-label=\"url_copy\" ng-click=\"vm.copied =1\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===1}\"></md-icon></md-button></div></md-content></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/playlist/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"playlist_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.playlist_detail_pagetitle\">playlist_detail_pagetitle\n</span> <span>{{vm.playlist.title}}</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{vm.playlist.id}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.title\">title</strong></h3></div>\n<div class=\"md-secondary\">{{vm.playlist.title}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.loop\">loop</strong></h3></div>\n<div class=\"md-secondary\" \nng-attr-translate=\"{{vm.playlist.loopp==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.playlist.loopp}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.order\">order</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.playlist.autoSort==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.playlist.autoSort}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.duration\">duration</strong></h3></div><div \nclass=\"md-secondary\">{{vm.playlist.maxDuration}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"PLAYLISTDETAIL.url_permalien\">url_permalien\n</strong></h3></div><div class=\"md-secondary\">{{vm.url_playlist_permalien}}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"PLAYLISTDETAIL.url_embed\">url_embed</strong></h3></div><div class=\"md-secondary\">{{vm.url_playlist_embed}}\n</div></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/media/playlist/list/embed.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" \nstyle=\"width: 70%;height: max-content; max-height: none\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s24\"></md-icon><span translate=\"MESSAGES.playlist_preview\">Preview of the playlist</span> </span><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"height: 100%;width: 100%\" ms-scroll class=\"no-padding\"><div \nng-style=\"{\'text-align\': \'center\',\'padding\': \'1em\',\'box-sizing\': \'border-box\',\'position\': \'relative\',\'padding-top\': \'56%\',\'overflow\': \'hidden\'}\">\n<div><iframe ng-if=\"vm.link\" style=\"position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\" \nwidth=\"800\" height=\"400\" ng-src=\"{{vm.link ? vm.trustLink(vm.link) : \'\'}}\" frameborder=\"0\" webkitallowfullscreen \nmozallowfullscreen allowfullscreen></iframe><any ng-if=\"vm.link === false\">{{\'MESSAGES.video_not_exist\' | translate}}\n</any></div></div></md-dialog-content><md-dialog-actions style=\"height: 90px\" layout=\"row\" \nlayout-align=\"space-between center\"><div style=\"width: 70%\" class=\"row_url embed-ie\" layout=\"row\" layout-xs=\"column\">\n<div style=\"padding-top: 2%\" flex=\"20\"><strong>Embed</strong></div><div flex=\"80\" style=\"border: 1px solid #EDEDED\" \nlayout=\"row\" layout-xs=\"column\"><textarea \nstyle=\"width: 100%;\n                         padding: 10px;\n                         border-right: none;\n                        resize: none\" \nid=\"fo16\">{{vm.embed}}</textarea><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo16\" \naria-label=\"url_copy\" ng-click=\"vm.copied = 0\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon></md-button></div></div><md-button id=\"modalPlaylist\" \nclass=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/media/playlist/list/list.template.html","<any id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedPlaylists.length\"><a ng-style=\"myObjStyle\" \nhas-permission=\"playlist_delete_multi\" tooltips \ntooltip-template=\"{{\'PLAYLISTLIST.delete_playlists_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedPlaylistsConfirm($event)\" \naria-label=\"delete_playlists_aria_label\" translate \ntranslate-attr-aria-label=\"PLAYLISTLIST.delete_playlists_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"playlist-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_playlist\" \nng-keydown=\"$event.keyCode === 13 && vm.searchPlaylist()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewPlaylist($event)\" \naria-label=\"action_new_element\" has-permission=\"playlist_post_add\">><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div id=\"tablePlaylist\" class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedPlaylists.length === vm.playlists.length) && (vm.selectedPlaylists.length > 0)\" \nmd-indeterminate=\"vm.selectedPlaylists.length !== 0 && vm.selectedPlaylists.length !== vm.playlists.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"MESSAGES.form_attr_title\">form_attr_title</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"PLAYLISTLIST.duration\">duration</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"PLAYLISTLIST.loop\">loop</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></any>");
$templateCache.put("app/main/media/playlist/list/list_tab.html","<div ng-if=\"!vm.isNewPlaylist\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-tabs \nid=\"playlist\" class=\"md-border-bottom\" md-selected=\"$root.selectedIndex\" \nstyle=\"background-color: white;min-height: 100%\" layout-fill flex><md-tab ng-if=\"vm.permission.playlist_list_dtable\" \nng-click=\"vm.chageTitle(\'simple\')\"><md-tab-label>Playlist</md-tab-label><md-tab-body layout-fill flex><div \ndata-ui-view=\"media\" layout-fill flex></div></md-tab-body></md-tab><md-tab \nng-if=\"vm.permission.playlist_live_list_dtable\" ng-click=\"vm.chageTitle(\'live\')\"><md-tab-label \ntranslate=\"PLAYLISTADD.form_attr_live\">Playlist direct</md-tab-label><md-tab-body layout-fill flex><div layout-fill \ndata-ui-view=\"live\" flex></div></md-tab-body></md-tab></md-tabs></div><div ng-if=\"vm.isNewPlaylist\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth full-height\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div style=\"overflow: hidden;min-height: 100%\" layout=\"row\" \nlayout-wrap><iframe id=\"iframe_playlist\" ng-src=\"{{vm.newPlayListIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/media/playlist/view_add_edit_playlist/add_edit.template.html","<div id=\"forms\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\"><div layout=\"row\" layout-align=\"space-between center\">\n<div class=\"pb-8\" layout=\"row\" layout-align=\"start center\"><div class=\"h2 font-weight-600\"><md-icon \nmd-font-icon=\"icon-movie\" class=\"s18\"></md-icon><span translate=\"MESSAGES.vid_list\">vid_list</span></div></div></div>\n<ms-themes id=\"test\" theme=\"vm.theme\" canal=\"\'\'\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.onChange(someModel)\" style=\"width: 100%\"></ms-themes><div id=\"todo\" \nclass=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content\" layout=\"row\" flex><md-content class=\"todo-list-pane\" flex><div ng-if=\"vm.videos.length>0\" \nclass=\"todo-items h-500\" id=\"IE-playlist\" when-scrolled-playlist=\"loadMore()\"><div class=\"todo-item md-padding\" \nlayout-wrap layout=\"row\"><md-card style=\"margin: 0; padding: 8px\" flex=\"50\" \nmd-theme=\"{{ showDarkTheme ? \'dark-blue\' : \'default\' }}\" md-theme-watch ng-repeat=\"(key , video) in vm.videos\"><img \nng-if=\"video.logo\" ng-src=\"{{ video.logo }}\" class=\"md-card-image\" on-error-src=\"assets/images/no-image-custom.svg\" \nalt=\"Washed Out\"><md-card-title style=\"padding: 5px\"><md-card-title-text><span class=\"md-headline\" \nstyle=\"font-size: 1.5em\" ng-class=\"{\'video-play\':video.isInPlayList}\">{{ vm.subTitle(video.title )}}</span>\n</md-card-title-text></md-card-title><md-card-content style=\"padding: 0\"><p><md-icon md-font-icon=\"icon-clock\" \nclass=\"s18\"></md-icon>{{vm.convertDuration(video.duration)}}</p></md-card-content><md-card-actions layout=\"row\" \nlayout-align=\"end center\"><md-button style=\"color: #039be5\" \nng-click=\"vm.addVideoToPlayList(video,key,$event,$data,$index)\"><md-icon style=\"color: #039be5\" \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s18\"></md-icon><span translate=\"PLAYLISTADD.add_to_playlist\">\nadd_to_playlist</span></md-button></md-card-actions></md-card></div></div><div ng-if=\"vm.videos.length===0\"><span \ntranslate=\"MESSAGES.no_videos\">no_videos</span></div></md-content></div></div></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16\">\n<div layout=\"row\" layout-align=\"space-between center\"><div class=\"pb-8\" layout=\"row\" layout-align=\"end center\"><div \nclass=\"h2 font-weight-600\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon>\n<span translate=\"PLAYLISTADD.form_title\">form_title</span></div><div class=\"h2 font-weight-600\" ng-if=\"!vm.isNew\">\n<md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"PLAYLISTEDIT.form_title\">form_title</span>\n</div></div></div><div layout=\"column\" layout-align=\"space-between\" flex><div \nng-include=\"\'app/main/media/playlist/view_add_edit_playlist/form.template.html\'\"></div></div></ms-widget-front>\n</ms-widget></div></div></div>");
$templateCache.put("app/main/media/playlist/view_add_edit_playlist/form.template.html","<form name=\"empPlaylistForm\" method=\"post\" id=\"empPlaylistForm\" novalidate=\"novalidate\" \nng-submit=\"empPlaylistForm.$valid && vm.submitAddPlaylistForm()\"><div layout=\"row\" style=\"margin-top: 10px\"><div \nflex=\"50\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"PLAYLISTADD.form_attr_title\">\nTitre</label><input type=\"text\" id=\"empPlaylistForm_title\" name=\"empPlaylistForm[title]\" required=\"required\" \nng-attr-name=\"title\" ng-model=\"vm.empPlaylistForm.title\" aria-invalid=\"true\" maxlength=\"30\"><div \nng-messages=\"empPlaylistForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div flex layout=\"column\" \nlayout-gt-xs=\"row\"><md-input-container flex><label translate=\"MESSAGES.form_attr_loop\">Lire en boucle</label><md-select\n translate translate=\"MESSAGES.form_attr_loop\" name=\"empPlaylistForm[loopp]\" id=\"empPlaylistForm_loopp\" \nng-model=\"vm.empPlaylistForm.loopp\"><md-option ng-repeat=\"yesNoChoice in vm.yesNoChoices\" ng-value=\"yesNoChoice.val\" \ntranslate=\"MESSAGES.{{ yesNoChoice.option}}\">{{ yesNoChoice.option }}</md-option></md-select></md-input-container>\n</div></div><div layout=\"row\" style=\"margin-top: 10px\"><div flex=\"50\" layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex><label translate=\"MESSAGES.form_attr_order\">Respecter l\'ordre paramétré</label><md-select \ntranslate translate=\"MESSAGES.form_attr_order\" name=\"empPlaylistForm[autoSort]\" id=\"empPlaylistForm_autoSort\" \nng-model=\"vm.empPlaylistForm.autoSort\"><md-option ng-repeat=\"yesNoChoice in vm.yesNoChoices\" \nvalue=\"{{yesNoChoice.val }}\" translate=\"MESSAGES.{{yesNoChoice.option }}\">{{ yesNoChoice.option}}</md-option>\n</md-select></md-input-container></div><div flex layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label \ntranslate=\"MESSAGES.form_attr_duration\">Durée de diffusion</label><input type=\"number\" \nid=\"empPlaylistForm_maxDuration\" name=\"empPlaylistForm[maxDuration]\" ng-model=\"vm.empPlaylistForm.maxDuration\" \nng-disabled=\"vm.loopNot\" readonly=\"readonly\"></md-input-container></div></div><div layout=\"row\" \nstyle=\"margin-top: 10px\"><div flex=\"100\" layout=\"column\" layout-gt-xs=\"row\"><md-select translate \ntranslate=\"MESSAGES.form_attr_rmbox\" name=\"empPlaylistForm[rmboxes]\" \nhas-permission=\"configuration_rmbox_activate_playlist_no_api\" multiple=\"1\" style=\"width: 100%\" \nid=\"empPlaylistForm_rmboxes\" ng-model=\"vm.empPlaylistForm.rmboxes\" ng-attr-name=\"rmbox\" ng-name=\"rmbox\" \nplaceholder=\"{{ \'ZONEADD.form_attr_rmbox\'|translate}}\"><md-option ng-repeat=\"rmbox in vm.rmboxs track by rmbox.val.id\" \nng-value=\"rmbox.val.id\" ng-attr-data-index=\"{{$index}}\">{{ rmbox.val.name }}</md-option></md-select></div></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-model=\"vm.empPlaylistForm.isLive\" \nhas-permission=\"playlist_live_post_add\"><label translate=\"PLAYLISTADD.form_attr_live\">Live</label></md-checkbox></div>\n<fieldset ng-if=\"vm.empPlaylistForm.isLive\"><div layout=\"row\"><div flex=\"50\" layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container style=\"width: 100%; display: flex;align-items: center\" flex><label class=\"md-no-float\" \ntranslate=\"MESSAGES.start_date\">start_date</label><md-datepicker required ng-model=\"vm.empPlaylistForm.mdTime.date\" \nng-change=\"vm.changeDate()\" ng-attr-name=\"date\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div \nng-messages=\"empPlaylistForm.date.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" translate=\"MESSAGES.date_valid\">\ndate_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div><div ng-message=\"maxdate\" \ntranslate=\"MESSAGES.date_max\">date_max</div></div></md-input-container></div><div flex=\"50\" layout=\"column\" \nlayout-gt-xs=\"row\" class=\"start-time-playlist\"><md-input-container \nstyle=\"width: 100%; display: flex;align-items: center\" flex><label class=\"md-no-float\" translate=\"MESSAGES.start_time\">\nstart_time</label><mdp-time-picker ng-change=\"vm.changeTime()\" ng-model=\"vm.empPlaylistForm.mdTime.time\" \nng-attr-name=\"time\" mdp-format=\"HH:mm:ss\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" required>\n<div ng-messages=\"empPlaylistForm.time.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.time_format\">\ntime_format</div></div></mdp-time-picker></md-input-container></div></div><div layout=\"column\" layout-gt-xs=\"row\">\n<md-checkbox ng-model=\"vm.empPlaylistForm.onAir\"><label translate=\"MESSAGES.form_attr_onair\">Live</label></md-checkbox>\n</div></fieldset><div layout=\"row\" layout-align=\"space-between center\" style=\"margin-top: 10px\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2 font-weight-600\"><md-icon md-font-icon=\"icon-movie\" \nclass=\"s18\"></md-icon><span translate=\"MESSAGES.vid_list_select\">vid_list_select</span></div></div></div><div \nclass=\"h-100 b p-25\" layout=\"row\" layout-align=\"center center\" ng-if=\"!vm.videos_of_playList.length\"><div \nclass=\"drop-text\"><span translate=\"MESSAGES.click_to_add\">click_to_add</span></div></div><div id=\"todo\" \nclass=\"h-380 page-layout carded left-sidenav\" layout=\"row\" \nstyle=\"max-height: 380px; min-height: 100px ; overflow-y: auto\"><div layout=\"column\" flex><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content\" layout=\"row\" flex><md-content flex ms-scroll=\"vm.msScrollOptions\"><ul \nui-sortable=\"vm.sortableOptions\" ng-model=\"vm.videos_of_playList\"><li \nstyle=\"border-bottom: 1px solid #ededed;margin-left: -15px\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"video in vm.videos_of_playList track by $index\" data-id-video=\"{{video.id}}\" \nng-attr-data-index=\"{{$index}}\"><div class=\"myHandleCursor\" id=\"myHandle\"><md-icon md-font-icon=\"icon-drag-vertical\" \nclass=\"icon\"></md-icon></div><div class=\"no-label\" style=\"margin-right: 10px\"><img ng-if=\"video.logo\" width=\"100\" \nng-src=\"{{ video.logo }}\"><md-icon class=\"s70\" style=\"width: 100px !important\" ng-if=\"!video.logo\" \nmd-font-icon=\"icon-no-image-custom\"></md-icon></div><div layout=\"row\" layout-align=\"start center\" flex><div \nclass=\"info\" flex><div class=\"title\">{{ video.title }}</div><div class=\"tags\" layout=\"row\" layout-align=\"start center\" \nlayout-wrap><div class=\"tag\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-clock\" class=\"s18\">\n</md-icon><div style=\"margin-left: 5px\" class=\"tag-label\">{{ vm.showDuration(video)}}</div></div></div></div><a \nstyle=\"text-decoration : none\" tooltips tooltip-template=\"{{\'MESSAGES.undo\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.removeVideofromPlayList2(video,$index)\" class=\"md-icon-button md-warn\" \nlayout=\"row\" layout-align=\"start center\" aria-label=\"delete_video\"><md-icon md-font-icon=\"icon-close-circle-outline\" \nclass=\"s18\"></md-icon></md-button></a></div></li></ul></md-content></div></div></div></div><div layout=\"row\" \nlayout-align=\"space-around center\" flex style=\"margin:20px\"><md-button class=\"md-warn\" ng-click=\"vm.returnToList()\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" ng-if=\"vm.videos_of_playList.length\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" ng-if=\"vm.isNew  && vm.videos_of_playList.length\" aria-label=\"form_add\" \nng-disabled=\"empPlaylistForm.$invalid || empPlaylistForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \nng-if=\"!vm.isNew && vm.videos_of_playList.length\" aria-label=\"form_validate\" \nng-disabled=\"empPlaylistForm.$invalid && vm.videos_of_playList.length\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div></form>");
$templateCache.put("app/main/media/playlist/view_add_edit_playlist/on.air.confirm.html","<md-dialog style=\"min-width: 50%;min-height: 20%;max-height : 70%\" aria-label=\"configuration_server_detail_pagetitle\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"PLAYLISTADD.on_air_confirmation_title\">\nPLAYLISTADD.on_air_confirmation_title</span></h2><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-content ms-scroll flex \nclass=\"content-card fullpage layout-column flex\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"col-md-7\"><label translate=\"PLAYLISTADD.on_air_confirmation\">on_air_confirmation</label></div><div \nclass=\"col-md-3\" ng-click=\"vm.confirm()\"><span class=\"btn_update\"><object width=\"180\" height=\"50\" \ntype=\"application/x-shockwave-flash\" data=\"app/swf/update_playlist.swf\"><param name=\"movie\" \nvalue=\"app/swf/update_playlist.swf\"><param name=\"type\" value=\"application/x-shockwave-flash\"><param name=\"flashvars\" \nng-value=\"vm.sendFiles\"></object></span></div></div></md-content></md-dialog>");
$templateCache.put("app/main/profiles/group/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"profiles_group_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.profiles_group_detail_pagetitle\">\nprofiles_group_detail_pagetitle</span> <span>{{ vm.group.name |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"GROUPDETAIL.name\">name</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.group.name}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"GROUPDETAIL.roles\">roles</strong></h3></div>\n<div class=\"md-secondary\"><strong ng-if=\"vm.group.roles.length === 1\" translate=\"GROUPADD.{{vm.group.roles[0]}}\">\n{{vm.group.roles[0]}}</strong><ul ng-if=\"vm.group.roles.length > 1\"><li ng-repeat=\"role in vm.group.roles\"><strong \ntranslate=\"GROUPADD.{{role}}\">{{role}}</strong></li></ul></div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"GROUPDETAIL.description\">description</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.group.description }}</div><md-divider></md-divider></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/profiles/group/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth testyoussef\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/profiles/group/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/profiles/group/add_edit_view/form.template.html","<form name=\"empProfilesGroupForm\" method=\"post\" id=\"empProfilesGroupForm\" class=\"testyoussef\" novalidate=\"novalidate\" \nng-submit=\"empProfilesGroupForm.$valid && vm.submitAddGroupForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"GROUPADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"GROUPEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"GROUPADD.form_attr_name\">Nom du groupe</label><input type=\"text\" \nid=\"empProfilesGroupForm_name\" name=\"empProfilesGroupForm[name]\" required=\"required\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.empProfilesGroupForm.name\" value=\"Default\" maxlength=\"40\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesGroupForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.empProfilesGroupForm.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"$root.userManager\"><md-input-container flex>\n<label class=\"md-no-float\" translate=\"GROUPADD.form_attr_roles\">Roles</label><md-select multiple=\"multiple\" \nng-attr-name=\"roles\" translate translate=\"MESSAGES.form_attr_roles\" name=\"empProfilesGroupForm[roles][]\" \nid=\"empProfilesGroupForm_roles\" ng-model=\"vm.empProfilesGroupForm.roles\" required><md-option \nng-repeat=\"groupRole in vm.groupsRoles\" ng-value=\"groupRole.val\"><span translate=\"GROUPADD.{{ groupRole.options}}\">\n</span></md-option></md-select><div ng-messages=\"empProfilesGroupForm.roles.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.roles && vm.empProfilesGroupForm.roles === vm.empProfilesGroupError.roles.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.roles.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"GROUPADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empProfilesGroupForm_description\" name=\"empProfilesGroupForm[description]\" ng-attr-name=\"description\" translate=\"\" \nng-model=\"vm.empProfilesGroupForm.description\" rows=\"1\" aria-invalid=\"true\" style=\"height: 30px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empProfilesGroupForm.description.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.description && vm.empProfilesGroupForm.description === vm.empProfilesGroupError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-button class=\"md-warn\" ui-sref=\"app.profiles_group_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empProfilesGroupForm.$invalid || empProfilesGroupForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empProfilesGroupForm.$invalid || empProfilesGroupForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/profiles/group/list/list.template.html","<div ng-if=\"!vm.isNewGroup\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nng-if=\"vm.selectedGroups.length\" has-permission=\"profiles_group_delete_multi_action\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'GROUPLIST.delete_groups\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 delete-button md-icon-button btn-delete\" ng-click=\"vm.deleteGroupsConfirm($event)\" \naria-label=\"Delete Groups\" translate translate-attr-aria-label=\"GROUPLIST.delete_groups_aria_label\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"groups-search\" class=\"search-input ng-scope flex\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.dataTableSearchWord\" \nng-keydown=\"$event.keyCode === 13 && vm.searchGroups()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewGroup($event)\" \naria-label=\"Add new element\" translate translate-attr-aria-label=\"GROUPLIST.action_new_element\" \nhas-permission=\"profiles_group_post_add_action\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\">\n<svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedGroups.length === vm.groups.length) && (vm.selectedGroups.length > 0)\" \nmd-indeterminate=\"vm.selectedGroups.length !== 0 && vm.selectedGroups.length !== vm.groups.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"GROUPLIST.name\">name</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"GROUPLIST.roles\">roles</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"GROUPLIST.description\">description</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead></table></div></div></div><div ng-if=\"vm.isNewGroup\" id=\"e-commerce-products\" \nclass=\"page-layout simple fullwidth full-height\" layout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" \nflex><div style=\"overflow: hidden;min-height: 100%;background-color: white\" layout=\"row\" layout-wrap><iframe \nid=\"iframe_segment_display\" ng-src=\"{{vm.newGroupIframe}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%; height: 100%; overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/profiles/group/permission/json.generate.html","<md-dialog style=\"min-width: 50%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"\">Translations {{data.type}}</span></h2>\n<md-button class=\"cta-button md-raised md-accent\" ng-click=\"changeLang(\'fr\')\">Français</md-button><md-button \nclass=\"cta-button md-raised md-accent\" ng-click=\"changeLang(\'en\')\">English</md-button></div></md-toolbar><div \nlayout=\"column\"><md-content flex ms-scroll flex><table flex class=\"simple trad\" ms-responsive-table><thead><tr><th \nclass=\"text-right\">Key</th><th class=\"text-left\">Value</th></tr></thead><tbody><tr \nng-repeat=\"module in data.content[0]\" id=\"translateList\"><td flex class=\"text-right\"><md-input-container flex \nstyle=\"width:100%\"><input type=\"text\" class=\"iKey\" name=\"key\" ng-value=\"module\" readonly=\"readonly\" aria-label=\"key\">\n</md-input-container></td><td flex class=\"text-left\" id=\"translation\"><md-input-container flex style=\"width:100%\" \nid=\"element\"><label>translation</label><input type=\"text\" class=\"iVal\" name=\"val\" md-select-on-focus \nng-model=\"translatedValue[module]\"><div class=\"hint emptyStyling\" ng-if=\"!translatedValue[module]\">\nAjouter cette valeur SVP</div></md-input-container></td></tr></tbody></table></md-content><md-action class=\"bt\" \nflex=\"40\" layout-align=\"center center\"><div layout-align=\"center center\" layout=\"row\"></div><div \nng-if=\"!verifyGeneration\"><div layout-align=\"center center\" layout=\"column\"><span class=\"emptyStyling\" flex>\nIl reste encore des champs sans traduction!!</span><div layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-raised md-warn\" ng-click=\"continueGenerating()\">Continuer</md-button><md-button class=\"cta-button md-raised\" \nng-click=\"cancelGenerating()\">Annuler</md-button></div></div></div><div ng-if=\"verifyGeneration\"><div \nlayout-align=\"center center\" layout=\"column\"><md-button class=\"cta-button md-raised md-accent\" \nng-click=\"generateJson()\">Generate JSON</md-button></div></div></md-action></div></md-dialog>");
$templateCache.put("app/main/profiles/group/permission/module.list.html","<div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex></div><div \nclass=\"labels\"></div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"></div></div><div \nclass=\"thread\" md-ink-ripple ng-class=\"unread\" ng-if=\"vm.modules.length === 0\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"column\" translate=\"MODULESLIST.none\">\n{{MODULESLIST.none | translate}}</div></div></div><div class=\"thread\" md-ink-ripple \nng-repeat=\"module in vm.modules | filter:vm.searchModule\" ng-click=\"vm.permissionList(module.module)\" \nng-class=\"unread\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex layout=\"column\" \ntranslate=\"MODULESLIST.{{module.module | deletestring : \'_module\'}}\">{{module.module}}</div></div></div>");
$templateCache.put("app/main/profiles/group/permission/permission.html","<div class=\"thread\" md-ink-ripple ng-class=\"unread\" ng-if=\"vm.modules.length === 0\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"info\" flex layout=\"column\" translate=\"ACTIONSLIST.none\">\n{{ACTIONSLIST.none | translate}}</div></div></div><div ng-repeat=\"module in vm.modules\" \nng-if=\"vm.showContent(module.module)\"><md-subheader class=\"md-no-sticky\" style=\"margin : 20px\" \ntranslate=\"MODULESLIST.{{module.module | deletestring : \'_module\'}}\" ng-if=\"vm.searchPermission === \'\'\">\n{{module.module}}</md-subheader><div class=\"thread\" md-ink-ripple ng-class=\"unread\" \nng-if=\"module.contents.length === 0\"><div layout=\"row\" layout-align=\"start center\"><div class=\"info\" flex \nlayout=\"column\" translate=\"ACTIONSLIST.none\">{{ACTIONSLIST.none | translate}}</div></div></div><div class=\"thread\" \nmd-ink-ripple ng-repeat=\"right in module.contents  | filter:vm.searchPermission\" ng-class=\"unread\" ng-disabled=\"true\">\n<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex=\"90\">\n<md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(right)\" ng-click=\"vm.toggleSelectModule(right, $event)\" \naria-label=\"-\"></md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"text-truncate\" \ntranslate=\"ACTIONSLIST.{{right.name | deletestring : \'_action\'}}\">{{right.name}}</span></div></div></div><div \nflex=\"10\"><md-button class=\"md-icon-button\" aria-label=\"More\" ng-click=\"vm.updatePermission(right)\"><md-icon \nmd-font-icon=\"icon-check-circle\" ng-if=\"right.authorized\" style=\"color:#1B5E20\" class=\"icon s24\"></md-icon><md-icon \nmd-font-icon=\"icon-minus-circle-outline\" ng-if=\"!right.authorized\" style=\"color:#B71C1C\" class=\"icon s24\"></md-icon>\n</md-button></div></div></div></div>");
$templateCache.put("app/main/profiles/group/permission/permission.template.html","<div id=\"price-tables\" class=\"page-layout carded left-sidenav\" layout=\"column\"><div class=\"center\" layout=\"column\" \nflex><div class=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"40\"><div layout=\"row\" layout-align=\"centre center\"><div><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.searchModule\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" \nlass=\"demo-header-searchbox md-text\"></div></div></div><div flex=\"60\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div flex=\"5\"><div class=\"divider-vertical\"></div></div><div layout=\"row\" \nlayout-align=\"start center\" flex=\"80\"><md-checkbox class=\"no-label\" ng-checked=\"vm.selectedModules.length > 0\" \nng-click=\"vm.toggleSelectModules()\" aria-label=\"-\"></md-checkbox><div class=\"divider-vertical\"></div><div><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input ng-model=\"vm.searchPermission\" type=\"search\" \nng-keydown=\"$event.stopPropagation()\" translate translate-attr-placeholder=\"MESSAGES.search\" placeholder=\"Search\" \nclass=\"search-input md-text\"></div></div><div flex=\"15\" style=\"margin-right: 20px\"><md-button class=\"md-raised\" \nng-click=\"vm.updatePermissions()\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">Valider</md-button></div></div></div></div><div \nclass=\"content-wrapper\" layout=\"row\" flex><div class=\"content thread-module\" \nng-include=\"\'app/main/profiles/group/permission/module.list.html\'\" ms-scroll flex=\"40\"></div><div \nclass=\"content thread-permission\" ng-include=\"\'app/main/profiles/group/permission/permission.html\'\" ms-scroll \nflex=\"60\"></div></div></div></div></div>");
$templateCache.put("app/main/profiles/group/permission/toast-template.html","<md-toast><div layout-align=\"center center\" layout=\"column\"><span class=\"md-toast-text\" flex>\nIl reste encore des champs sans traduction!!</span><div layout-align=\"center center\" layout=\"row\"><md-button \nclass=\"md-highlight\" ng-click=\"continueGenerating()\">Continuer</md-button><md-button ng-click=\"cancelGenerating()\">\nAnnuler</md-button></div></div></md-toast>");
$templateCache.put("app/main/profiles/group/rights/rigths.template.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-pagee\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div \nclass=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.core_menuTitle\">core_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\" translate=\"PAGESMENUSTITLES.core_right_menuTitle\">\ncore_right_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span \nclass=\"parent\" translate=\"PAGESMENUSTITLES.core_rights_group_pagetitle\">core_rights_group_pagetitle</span></div><div \nclass=\"white-fg\" layout=\"row\" layout-align=\"start center\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.back_to_list\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"goto-products-button md-icon-button\" aria-label=\"back_to_list\" ui-sref=\"app.profiles_group_list\" translate \ntranslate-attr-aria-label=\"MESSAGES.back_to_list\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon></md-button></a>\n<div layout=\"column\" layout-align=\"start start\"><div class=\"h2\" translate=\"RIGHTS.group_rights_title\">\ngroup_rights_title</div><div class=\"subtitle secondary-text\" hide-xs><span>{{vm.group.name | json}}</span></div></div>\n</div></div></div><div class=\"content\"><div class=\"price-tables\" flex layout=\"row\" layout-wrap><div \nng-repeat=\"module in vm.modules track by module.id\" class=\"md-whiteframe-2dp price-table\" layout=\"column\" flex=\"30\" \nflex-xs=\"100\" flex-sm=\"100\"><md-toolbar md-colors=\"{background: \'accent-hue-1\',color:\'background\'}\"><div \nclass=\"md-toolbar-tools\" ng-init=\"vm.collapsed[module.id] = 1\"><md-truncate translate=\"MODULESLIST.{{module.name}}\">\n</md-truncate><span flex></span><a tooltips tooltip-template=\"{{\'MESSAGES.collapse\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.collapsed[module.id] = 0\" ng-if=\"vm.collapsed[module.id]\" \nclass=\"md-icon-button\" aria-label=\"collapse\" translate-attr-aria-label=\"MESSAGES.collapse\"><md-icon \nmd-font-icon=\"icon-chevron-up\" class=\"s24\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'MESSAGES.expand\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nng-click=\"vm.collapsed[module.id] = 1\" ng-if=\"!vm.collapsed[module.id]\" class=\"md-icon-button\" aria-label=\"expand\" \ntranslate-attr-aria-label=\"MESSAGES.expand\"><md-icon md-font-icon=\"icon-chevron-down\" class=\"s24\"></md-icon>\n</md-button></a></div></md-toolbar><md-content flex ng-hide=\"!vm.collapsed[module.id]\"><div \nlayout-align=\"start center\" layout=\"row\" class=\"mv-10 p-24\"><md-list flex><md-list-item class=\"md-1-line\" \nng-repeat=\"action in module.contents track by action.actionId\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"ACTIONSLIST.{{action.name}}\" aria-label=\"action.name\">{{action.name}}</strong></h3></div><span flex></span>\n<md-switch ng-change=\"vm.toggleActionRight($parent.$index,$index,action,$event)\" ng-model=\"action.authorized\" \nng-attr-aria-label=\"{{action.name}}\"><span class=\"hide\">{{action.name}}</span></md-switch><md-divider ng-if=\"!$last\">\n</md-divider></md-list-item></md-list></div></md-content></div></div></div></div>");
$templateCache.put("app/main/profiles/ip/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/profiles/ip/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/profiles/ip/add_edit_view/form.template.html","<form name=\"empProfilesIpForm\" method=\"post\" id=\"empProfilesIpForm\" novalidate=\"novalidate\" \nng-submit=\"empProfilesIpForm.$valid && vm.submitIpForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"IPADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"IPEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex>\n<label class=\"md-no-float\" translate=\"IPADD.form_attr_ip\">IP adress</label><input type=\"text\" \nid=\"empProfilesIpForm_ip\" name=\"empProfilesIpForm[ip]\" required=\"required\" ng-attr-name=\"ip\" ng-name=\"ip\" \nng-model=\"vm.empProfilesIpForm.ip\" aria-invalid=\"true\" \nng-pattern=\"/^(([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))[.](([0-9]{1,3}|[*]{1}))$/\"><div \nng-messages=\"empProfilesIpForm.ip.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"IPADD.ERRORS.REQUIRED\">\nCe champ est obligatoire</div><div ng-message=\"pattern\" translate=\"IPADD.ERRORS.INVALIDFORMAT\">\nCe champ doit contenir une adresse ip correcte</div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label class=\"md-no-float\" translate=\"IPADD.form_attr_description\">Description</label><div \nclass=\"md-resize-wrapper\"><textarea id=\"empProfilesIpForm_description\" required=\"required\" \nname=\"empProfilesIpForm[description]\" ng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" \nng-model=\"vm.empProfilesIpForm.description\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 135px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empProfilesIpForm.description.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"IPADD.ERRORS.REQUIRED\">Ce champ est obligatoire</div><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div></div></md-input-container>\n<md-button class=\"md-warn\" ui-sref=\"app.profiles_ip_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empProfilesIpForm.$invalid || empProfilesIpForm.$pristine\" translate=\"MESSAGES.form_add\" ng-if=\"vm.isNew\">\nform_add</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empProfilesIpForm.$invalid || empProfilesIpForm.$pristine\" translate=\"MESSAGES.form_validate\" \nng-if=\"!vm.isNew\">form_validate</md-button></form>");
$templateCache.put("app/main/profiles/ip/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"profiles_ip_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.profiles_ip_detail_pagetitle\">IP Adress details</span> \n<span>{{ vm.ip.ip |json }}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong>Id</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.id }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"IPDETAIL.adress\">IP Adress</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.ip }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"IPDETAIL.description\">Description</strong></h3></div><div class=\"md-secondary\">{{ vm.ip.description }}</div>\n</md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/profiles/ip/list/list.template.html","<div ng-if=\"!vm.isNewProfileIP\" id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" flex \nhas-permission=\"profiles_ip_delete_multi\" ng-if=\"vm.selectedIps.length\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'IPLIST.delete_ip\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedIpsConfirm($event)\" aria-label=\"delete_themes_aria_label\" \ntranslate translate-attr-aria-label=\"THEMELIST.delete_themes_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"ips-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_ips\" \nng-keydown=\"$event.keyCode === 13 && vm.searchIps()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewIp($event)\" \naria-label=\"action_new_element\" has-permission=\"profiles_ip_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedIps.length === vm.ips.length) && (vm.selectedIps.length > 0)\" \nmd-indeterminate=\"vm.selectedIps.length !== 0 && vm.selectedIps.length !== vm.ips.length\" ng-click=\"vm.toggleAll()\">\n</md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"IPLIST.adress\">IP Adresse</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"IPLIST.description\">Description</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">action</span></div>\n</th></tr></thead></table></div></div></div><div ng-if=\"vm.isNewProfileIP\" id=\"e-commerce-products\" \nclass=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \nng-src=\"{{ProfileIPIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\">\n</iframe></div></div></div></div>");
$templateCache.put("app/main/media/video/abonnement/add.remove.subscribers.html","<md-dialog aria-label=\"configuration_server_detail_pagetitle\" style=\"max-height: 70%\" id=\"IE-add-video-subscribers\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"VIDEOLIST.add_subscribers\">\nadd_subscribers</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-content style=\"height: 80%\"><div \nclass=\"content fullpage\" layout=\"column\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nlayout=\"row\" flex-gt-md=\"45\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><ms-widget-front class=\"white-bg\"><md-toolbar \nlayout=\"row\" class=\"md-hue-3\" style=\"background-color: #E0E0E0\"><div class=\"md-toolbar-tools\" style=\"color: #424242\">\n<span><md-icon md-font-icon=\"icon-account\" style=\"color: #424242\" class=\"s18\"></md-icon><span \ntranslate=\"VIDEOLIST.list_subscribers\">list_subscribers</span></span></div></md-toolbar><md-content><md-content>\n<md-list ng-repeat=\"sub in vm.subscribers track by sub.id\" ng-attr-data-index=\"{{$index}}\" flex \nng-if=\"vm.notSubscribed(sub)\"><md-list-item><md-checkbox aria-label=\"checkAddElement\" \nng-click=\"vm.checkAddElement(sub)\"></md-checkbox><span>{{sub.name}} {{sub.lastName}}</span></md-list-item></md-list>\n</md-content></md-content></ms-widget-front></ms-widget><div layout=\"column\" layout-align=\"center center\" \nflex-gt-md=\"10\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-button class=\"md-icon-button\" ng-click=\"vm.addSub()\"><md-icon \nmd-font-icon=\"icon-account-plus\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button><md-button class=\"md-icon-button\" ng-click=\"vm.removeSub()\"><md-icon \nmd-font-icon=\"icon-account-minus\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div><ms-widget layout=\"row\" flex-gt-md=\"45\" flex-gt-sm=\"100\" \nflex-gt-xs=\"100\"><ms-widget-front class=\"white-bg\"><md-toolbar layout=\"row\" class=\"md-hue-3\" \nstyle=\"background-color: #E0E0E0\"><div class=\"md-toolbar-tools\" style=\"color: #424242\"><span><md-icon \nmd-font-icon=\"icon-account-check\" style=\"color: #424242\" class=\"s18\"></md-icon><span \ntranslate=\"VIDEOLIST.list_subscribers_added\">list_subscribers_added</span></span></div></md-toolbar><md-content>\n<md-list ng-repeat=\"sub in vm.videoSubscribers track by sub.id\" ng-attr-data-index=\"{{$index}}\" flex><md-list-item>\n<md-checkbox aria-label=\"checkRemoveElement\" ng-click=\"vm.checkRemoveElement(sub)\"></md-checkbox><span>\n{{sub.name}} {{sub.lastName}}</span></md-list-item></md-list></md-content></ms-widget-front></ms-widget></div></div>\n</md-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.submit()\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/accessView/template.html","<div class=\"page-layout simple fullwidth\" layout=\"column\" id=\"IE-add-edit-video-page\" \nng-class=\"{\'isNavigationNew\' : state.current.url === \'/captions-new\' || state.current.url === \'/rich-media-new\' || state.current.url ===\'/montage-new\' }\">\n<div class=\"content\"><acces-button-video ng-if=\"!vm.hold\" handler=\"vm\" video=\"vm.video\"></acces-button-video>\n<md-content id=\"acces\" class=\"animate-slide-up md-hue-2\" ui-view=\"acces\" flex></md-content></div></div>");
$templateCache.put("app/main/media/video/access_button/actions_button.html","<div \nhas-permission=\"media_video_post_edit,media_video_caption_post_generate_caption,media_video_get_date_last_montage,media_video_preview_no_api,media_video_download_video,media_video_get_video_meta_data,configuration_rmbox_list_dtable,media_video_get_video_url,rich_media_video_preview_link_by_title\" \nclass=\"acces_button m-8 md-whiteframe-1dp\" layout=\"row\" layout-xs=\"column\"><div flex-gt-sm=\"100\" flex-sm=\"100\" \nflex-xs=\"100\" class=\"menu-buttons-align\" layout-align=\"start start\" style=\"text-align: left\"><div \nclass=\"menu-express-access\"><md-button ng-if=\"video.externalLinkVideo\" style=\"margin: 0 auto\" \nhas-permission=\"media_video_post_edit\" class=\"md-raised md-button-tab\" aria-label=\"action_edit\" translate \nui-sref=\"app.media_video_edit_external({ id: video.id})\" ui-sref-active=\"active md-accent-bg\" \nng-class=\"{active: $state.includes(\'edit\')}\" translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"sb24\"></md-icon><div hide-xs ng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\">\n{{\"MESSAGES.action_edit\"|translate}}</div></md-button><md-button ng-if=\"!video.externalLinkVideo\" \nstyle=\"margin: 0 auto\" has-permission=\"media_video_post_edit\" class=\"md-raised md-button-tab\" aria-label=\"action_edit\" \ntranslate ui-sref=\"app.media_video_edit({ id: video.id})\" ui-sref-active=\"active md-accent-bg show-export-button\" \nng-class=\"{active: $state.includes(\'edit\')}\" translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"sb24\"></md-icon><div hide-xs ng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\">\n{{\"MESSAGES.action_edit\"|translate}}</div></md-button><md-button style=\"margin: 0 auto\" \nng-if=\"!video.refTranscription || video.refTranscription===\'\' || video.refTranscription===\'Finished\' || video.refTranscription===\'Visited\'\" \nhas-permission=\"media_video_caption_post_generate_caption\" class=\"md-raised md-button-tab\" \nui-sref=\"app.media_video_caption_new({ id: video.id})\" ui-sref-active=\"active md-accent-bg show-export-button\" \nng-class=\"{active: $state.includes(\'caption\')}\" aria-label=\"action_change_video_source\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_video_caption\"><md-icon md-font-icon=\"icon-closed-caption\" class=\"sb24\">\n</md-icon><div hide-xs ng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\">\n{{\"MESSAGES.action_video_caption\"|translate}} <a style=\"margin: 0 0;width: 2em; z-index: 10;display: none\" \nng-click=\"vm.redirectToCaption(video)\"><md-icon><svg xmlns=\"https://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" \nviewBox=\"0 0 81.6 81.3\"><g id=\"noun_pop_out_1406946\" data-name=\"noun_pop out_1406946\" transform=\"translate(-9.2 -9.5)\">\n<g id=\"Group\"><path id=\"Path\" \nd=\"M90.7,12.5v-.7l-.2-.4-.2-.3-.5-.6h0L89,9.9l-.3-.2-.4-.2H65.1a4,4,0,0,0,0,8h12L41.2,53.1a4.031,4.031,0,1,0,5.7,5.7L82.8,22.9v12a4,4,0,0,0,8,0V13.2h0a4,4,0,0,0-.1-.7Z\"/>\n<path id=\"Path-2\" data-name=\"Path\" \nd=\"M21.2,90.8H68.6a12,12,0,0,0,12-12V50.5a4,4,0,0,0-8,0V78.8a4,4,0,0,1-4,4H21.2a4,4,0,0,1-4-4V31.4a4,4,0,0,1,4-4H49.5a4,4,0,0,0,0-8H21.2a12,12,0,0,0-12,12V78.8A12,12,0,0,0,21.2,90.8Z\"/>\n</g></g></svg></md-icon></a></div></md-button><md-button style=\"margin: 0 auto\" \nhas-permission=\"rich_media_video_preview_link_by_title\" class=\"md-raised md-button-tab\" \nng-class=\"{active: $state.includes(\'rich_media\')}\" ui-sref=\"app.media_video_rich_media_new({ id: video.id})\" \nui-sref-active=\"active md-accent-bg show-export-button\" aria-label=\"rich-media\" translate \ntranslate-attr-aria-label=\"MESSAGES.rich_media_presentation\"><md-icon md-font-icon=\"icon-rich-media\" class=\"sb24\">\n</md-icon><div hide-xs ng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\">\n{{\"MESSAGES.rich_media_presentation\"|translate}} <a style=\"margin: 0 0;width: 2em; z-index: 10;display: none\" \nng-click=\"vm.redirectToRichMedia(video)\"><md-icon><svg xmlns=\"https://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" \nviewBox=\"0 0 81.6 81.3\"><g id=\"noun_pop_out_1406946\" data-name=\"noun_pop out_1406946\" transform=\"translate(-9.2 -9.5)\">\n<g id=\"Group\"><path id=\"Path\" \nd=\"M90.7,12.5v-.7l-.2-.4-.2-.3-.5-.6h0L89,9.9l-.3-.2-.4-.2H65.1a4,4,0,0,0,0,8h12L41.2,53.1a4.031,4.031,0,1,0,5.7,5.7L82.8,22.9v12a4,4,0,0,0,8,0V13.2h0a4,4,0,0,0-.1-.7Z\"/>\n<path id=\"Path-2\" data-name=\"Path\" \nd=\"M21.2,90.8H68.6a12,12,0,0,0,12-12V50.5a4,4,0,0,0-8,0V78.8a4,4,0,0,1-4,4H21.2a4,4,0,0,1-4-4V31.4a4,4,0,0,1,4-4H49.5a4,4,0,0,0,0-8H21.2a12,12,0,0,0-12,12V78.8A12,12,0,0,0,21.2,90.8Z\"/>\n</g></g></svg></md-icon></a></div></md-button><md-button style=\"margin: 0 auto\" \nhas-permission=\"media_video_get_date_last_montage\" class=\"md-raised md-button-tab\" \nng-class=\"{active: $state.includes(\'montage\')}\" ui-sref=\"app.media_video_montage_new({ id: video.id})\" \nui-sref-active=\"active md-accent-bg show-export-button\" aria-label=\"montage_video\" translate \ntranslate-attr-aria-label=\"MESSAGES.montage_video\" ng-if=\"!video.externalLinkVideo\"><md-icon \nmd-font-icon=\"icon-content-cut\" class=\"sb24\"></md-icon><div hide-xs \nng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\">{{\"MESSAGES.montage_video\"|translate}} <a \nstyle=\"margin: 0 0;width: 2em; z-index: 10;display: none\" ng-click=\"vm.redirectToMontage(video)\"><md-icon><svg \nxmlns=\"https://www.w3.org/2000/svg\" width=\"1em\" height=\"1em\" viewBox=\"0 0 81.6 81.3\"><g id=\"noun_pop_out_1406946\" \ndata-name=\"noun_pop out_1406946\" transform=\"translate(-9.2 -9.5)\"><g id=\"Group\"><path id=\"Path\" \nd=\"M90.7,12.5v-.7l-.2-.4-.2-.3-.5-.6h0L89,9.9l-.3-.2-.4-.2H65.1a4,4,0,0,0,0,8h12L41.2,53.1a4.031,4.031,0,1,0,5.7,5.7L82.8,22.9v12a4,4,0,0,0,8,0V13.2h0a4,4,0,0,0-.1-.7Z\"/>\n<path id=\"Path-2\" data-name=\"Path\" \nd=\"M21.2,90.8H68.6a12,12,0,0,0,12-12V50.5a4,4,0,0,0-8,0V78.8a4,4,0,0,1-4,4H21.2a4,4,0,0,1-4-4V31.4a4,4,0,0,1,4-4H49.5a4,4,0,0,0,0-8H21.2a12,12,0,0,0-12,12V78.8A12,12,0,0,0,21.2,90.8Z\"/>\n</g></g></svg></md-icon></a></div></md-button></div><md-button id=\"goBack\" class=\"md-icon-button arrow go-back-bo\" \nng-click=\"vm.goBackBo()\" aria-label=\"form_retour\" translate translate-attr-aria-label=\"MESSAGES.form_retour\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s24\"></md-icon><any style=\"float: left\">{{\"MESSAGES.form_retour\"|translate}}\n</any></md-button></div><div hide-xs ng-class=\"{ \'isNavigationNew\' : vm.isNavigationNew}\" flex-gt-sm=\"30\" flex-sm=\"30\" \nflex-xs=\"100\" style=\"position: relative;min-height: 40px\"><md-menu md-offset=\"0 -7\" \nhas-permission=\"media_video_preview_no_api,media_video_download_video,media_video_get_video_meta_data,configuration_rmbox_list_dtable,media_video_get_video_url\">\n<md-button style=\"margin: 0 auto\" class=\"md-access-button\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" \naria-label=\"access_rapide\" translate translate-attr-aria-label=\"MESSAGES.access_repide\"><any style=\"float: left\">\n{{\"MESSAGES.acces_rapide\"|translate}}</any><md-icon md-font-icon=\"icon-chevron-down\" class=\"arrow-encoder\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item has-permission=\"media_video_preview_no_api\"><md-button \nng-click=\"vm.previewVideo(video)\" aria-label=\"preview_video\" translate \ntranslate-attr-aria-label=\"MESSAGES.preview_video\"><md-icon md-font-icon=\"icon-play\" class=\"sb24\"></md-icon><any>\n{{\"MESSAGES.preview_video\"|translate}}</any></md-button></md-menu-item><md-menu-item ng-if=\"!video.externalLinkVideo\" \nhas-permission=\"media_video_download_video\"><md-button ng-click=\"vm.downloadVideo(video)\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon><any>{{\"MESSAGES.download_file\"|translate}}</any></md-button></md-menu-item>\n<md-menu-item ng-if=\"!video.externalLinkVideo\" has-permission=\"media_video_get_video_meta_data\"><md-button \nng-click=\"vm.showVideoDetail(video)\" aria-label=\"video_detail\" translate \ntranslate-attr-aria-label=\"MESSAGES.video_detail\"><md-icon md-font-icon=\"icon-meta-custom\"></md-icon><any>\n{{\"MESSAGES.video_detail\"|translate}}</any></md-button></md-menu-item><md-menu-item ng-if=\"!video.externalLinkVideo\" \nhas-permission=\"configuration_rmbox_list_dtable\"><md-button ng-click=\"vm.chronologieVideo(video,$event)\" \naria-label=\"chronologie_video\" translate translate-attr-aria-label=\"MESSAGES.chronologie_video\"><md-icon \nmd-font-icon=\"icon-timer\"></md-icon><any>{{\"MESSAGES.chronologie_video\"|translate}}</any></md-button></md-menu-item>\n<md-menu-item has-permission=\"media_video_get_video_url\"><md-button ng-click=\"vm.exportVideo(video)\" \naria-label=\"export_video\" translate translate-attr-aria-label=\"MESSAGES.export_video\"><md-icon \nmd-font-icon=\"icon-link-variant\"></md-icon><any>{{\"MESSAGES.export_video\"|translate}}</any></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div>");
$templateCache.put("app/main/media/video/action_button/actions_button.html","<span><a has-permission=\"media_video_post_edit\" tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"btn-edit-hover md-icon-button\" \nng-click=\"editVideo(video)\" aria-label=\"action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"sb18\"></md-icon>\n</md-button></a><md-menu style=\"margin-left: -20px\" \nhas-permission=\"media_video_post_edit,rich_media_video_preview_link_by_title,media_video_caption_post_generate_caption,media_video_get_date_last_montage\" \nmd-offset=\"0 -7\"><a tooltips tooltip-template=\"{{\'MESSAGES.action_edition\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" \naria-label=\"description_audio\"><md-icon style=\"font-size: 20px!important\" has-permission=\"media_video_post_edit\" \nmd-font-icon=\"icon-chevron-down\" class=\"sb18\"></md-icon><md-icon has-permission=\"btn_menu_edition\" \nmd-font-icon=\"icon-pencil\" class=\"sb18\"></md-icon></md-button></a><md-menu-content width=\"2\"><md-menu-item \nhas-permission=\"media_video_post_edit\"><md-button ng-click=\"editVideo(video)\" aria-label=\"action_edit\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" \ntranslate=\"MESSAGES.action_edit\">action_edit</any></md-button></md-menu-item><md-menu-item \nhas-permission=\"media_video_get_date_last_montage\" ng-if=\"!video.externalLinkVideo\"><md-button \nui-sref=\"app.media_video_montage_new({ id: video.id})\" aria-label=\"montage_video\"><md-icon \nmd-font-icon=\"icon-content-cut\" class=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" \ntranslate=\"MESSAGES.montage_video\">montage_video</any></md-button></md-menu-item><md-menu-item \nng-if=\"!video.refTranscription || video.refTranscription===\'\'\" \nhas-permission=\"media_video_caption_post_generate_caption\"><md-button \nui-sref=\"app.media_video_caption_new({ id: video.id})\" aria-label=\"action_change_video_source\"><md-icon \nmd-font-icon=\"icon-closed-caption\" class=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" \ntranslate=\"MESSAGES.action_video_caption\">action_video_caption</any></md-button></md-menu-item><md-menu-item \nhas-permission=\"rich_media_video_preview_link_by_title\"><md-button \nui-sref=\"app.media_video_rich_media_new({id: video.id})\" aria-label=\"rich-media\"><md-icon \nmd-font-icon=\"icon-rich-media\" class=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" \ntranslate=\"MESSAGES.rich_media_presentation\">rich_media_presentation</any></md-button></md-menu-item></md-menu-content>\n</md-menu></span><a has-permission=\"media_video_reupload_no_api\" class=\"not_visible_small\" \nng-if=\" !video.externalLinkVideo\" tooltips tooltip-template=\"{{\'MESSAGES.action_change_video_source\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nui-sref=\"app.media_video_reupload({ id: video.id})\" aria-label=\"action_change_video_source\"><md-icon \nmd-font-icon=\"icon-filmstrip\" class=\"sb18\"></md-icon></md-button></a><a has-permission=\"stats_vod_all\" tooltips \ntooltip-template=\"{{\'MESSAGES.action_video_stats\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"statsPerVideo(video,$event)\" aria-label=\"action_video_stats\"><md-icon \nmd-font-icon=\"icon-chart-bar\" class=\"sb18\"></md-icon></md-button></a><a has-permission=\"subscription_user_list_dtable\" \nclass=\"not_visible_small\" tooltips tooltip-template=\"{{\'VIDEOLIST.add_subscribers\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"addSubscribers(video)\" aria-label=\"add_subscribers\">\n<md-icon md-font-icon=\"icon-account-switch\" class=\"sb18\"></md-icon></md-button></a><a \nhas-permission=\"media_video_download_video\" class=\"not_visible_small\" ng-if=\"!video.externalLinkVideo \" tooltips \ntooltip-template=\"{{\'MESSAGES.download_file\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"downloadVideo(video.id)\" aria-label=\"download_video\"><md-icon \nmd-font-icon=\"icon-download\" class=\"sb18\"></md-icon></md-button></a><a \nhas-permission=\"media_video_get_video_meta_data\" class=\"not_visible_small\" ng-if=\"!video.externalLinkVideo\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_detail\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"showVideoDetail(video)\" aria-label=\"video_detail\"><md-icon \nmd-font-icon=\"icon-meta-custom\" class=\"sb18\"></md-icon></md-button></a><a \nhas-permission=\"media_home_post_disable_push_video\" class=\"not_visible_small\" tooltips \ntooltip-template=\"{{(video.isPush===false) ? \'MESSAGES.push_video_on\' :\'MESSAGES.push_video_off\' |translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button ng-if=\"video.isPush===false\" class=\"md-icon-button\" \nng-click=\"handler.enableAndDisablePushVideo(video,\'enable\')\" aria-label=\"push_video_on\"><md-icon \nmd-font-icon=\"icon-arrange-send-backward\" class=\"sb18\"></md-icon></md-button><md-button ng-if=\"video.isPush===true\" \nclass=\"md-icon-button\" ng-click=\"handler.enableAndDisablePushVideo(video,\'disable\')\" aria-label=\"push_video_off\">\n<md-icon md-font-icon=\"icon-arrange-bring-to-front\" class=\"sb18\"></md-icon></md-button></a><a \nhas-permission=\"configuration_rmbox_list_dtable\" class=\"not_visible_small\" ng-if=\"!video.externalLinkVideo\" tooltips \ntooltip-template=\"{{\'MESSAGES.chronologie_video\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"chronologieVideo(video,$event)\" aria-label=\"chronologie_video\"><md-icon \nmd-font-icon=\"icon-timer\" class=\"sb18\"></md-icon></md-button></a><a has-permission=\"media_video_get_video_url\" \ntooltips tooltip-template=\"{{\'MESSAGES.export_video\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"exportVideo(video)\" aria-label=\"export_video\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"sb18\"></md-icon></md-button></a><a has-permission=\"media_video_delete_video\" \nclass=\"not_visible_small\" tooltips tooltip-template=\"{{\'MESSAGES.delete_video\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"handler.deleteVideoConfirm(video)\" \naria-label=\"delete_video\"><md-icon md-font-icon=\"icon-delete\" class=\"sb18\"></md-icon></md-button></a><md-menu \nclass=\"not_visible_small\" has-permission=\"media_video_audio_no_api\" md-offset=\"0 -7\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.description_audio\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" aria-label=\"description_audio\"><img \nng-if=\"video.audioDescription === 1\" ng-src=\"assets/icons/spinner.gif\"><md-icon ng-if=\" video.audioDescription === 0\" \nmd-font-icon=\"icon-ad-off-custom\" class=\"sb18\"></md-icon><md-icon ng-if=\" video.audioDescription === 2\" \nmd-font-icon=\"icon-ad-on-custom\" class=\"sb18\"></md-icon></md-button></a><md-menu-content width=\"2\"><any \nng-if=\"video.audioDescription === 0 || video.audioDescription === 2 \"><md-menu-item><md-button \nng-disabled=\"video.audioDescription === 2\" ui-sref=\"app.media_video_uploadAudio({videoId:video.id})\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><any translate=\"VIDEOLIST.add_description\">add_description</any></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"video.audioDescription === 0\" \nng-click=\"handler.deleteAudioDescriptionConfirm( video.id ,$event)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><any \ntranslate=\"VIDEOLIST.delete_description\">delete_description</any></md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"video.audioDescription === 0\" ui-sref=\"app.media_video_uploadAudio({videoId:video.id})\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon><any translate=\"VIDEOLIST.edit_description\">edit_description</any></md-button>\n</md-menu-item></any></md-menu-content></md-menu><a has-permission=\"media_video_post_toggle\" class=\"not_visible_small\" \ntooltips tooltip-template=\"{{video.offline ? \'MESSAGES.set_online\' : \'MESSAGES.set_offline\' |translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" \nng-click=\"handler.toogleChoice(\'offline\',video)\" aria-label=\"x\"><md-icon ng-if=\"video.offline\" \nmd-font-icon=\"icon-earth-off\" class=\"sb18\"></md-icon><md-icon ng-if=\"!video.offline\" md-font-icon=\"icon-earth\" \nclass=\"sb18\"></md-icon></md-button></a><a has-permission=\"media_video_add_home_page\" class=\"not_visible_small\" \nng-if=\"video.themes.length > 0\" tooltips \ntooltip-template=\"{{!video.mainPage ? \'MESSAGES.set_mainPage\' :\'MESSAGES.set_unmainPage\' |translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"home\" \nng-click=\"handler.toogleHomePage(\'mainPage\',video)\"><md-icon ng-if=\"!video.mainPage\" md-font-icon=\"icon-home-on\" \nclass=\"sb18\"></md-icon><md-icon ng-if=\"video.mainPage\" md-font-icon=\" icon-home-off\" class=\"sb18\"></md-icon>\n</md-button></a><a tooltips has-permission=\"questions_quiz_get_responses\" class=\"not_visible_small\" \ntooltip-template=\"{{\'MESSAGES.action_questions_quiz\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"responsesVideo(video)\" aria-label=\"action_questions_quiz\"><md-icon \nmd-font-icon=\"icon-quizz-custom\" class=\"sb18\"></md-icon></md-button></a><a tooltips \nhas-permission=\"media_video_transcription_auto_no_api,media_video_transcription_reload_no_api\" \nclass=\"not_visible_small\" \nng-if=\"(video.refTranscription === \'Finished\' || video.refTranscription === \'Visited\') && !testTranscription\" \ntooltip-template=\"{{\'MESSAGES.transcription\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nui-sref=\"app.media_video_caption_new({ id: video.id})\" class=\"md-icon-button not_visible_small\" \naria-label=\"description_audio\"><md-icon style=\"font-size: 22px !important\" md-font-icon=\"icon-custom-transcription\" \nclass=\"sb18\"></md-icon></md-button></a><a tooltips \nhas-permission=\"media_video_transcription_auto_no_api,media_video_transcription_reload_no_api\" \nclass=\"not_visible_small\" \nng-if=\"video.refTranscription && video.refTranscription !== \'Finished\' && video.refTranscription !== \'Visited\' || testTranscription===\'1\'\" \ntooltip-template=\"{{\'MESSAGES.transcription\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button not_visible_small\" aria-label=\"description_audio\"><md-icon \nstyle=\"font-size: 22px !important;color: rgba(0,0,0,0.30) !important; cursor: auto\" \nmd-font-icon=\"icon-custom-transcription-dis\" class=\"sb18\"></md-icon></md-button></a><md-menu class=\"not_visible_small\" \nng-if=\"(!video.refTranscription || video.refTranscription===\'\')&& !testTranscription\" \nhas-permission=\"media_video_transcription_auto_no_api,media_video_transcription_reload_no_api\" md-offset=\"0 -7\"><a \ntooltips tooltip-template=\"{{\'MESSAGES.transcription\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"openMenu($mdOpenMenu, $event)\" aria-label=\"description_audio\"><md-icon \nstyle=\"font-size: 22px !important\" md-font-icon=\"icon-custom-transcription\" class=\"sb18\"></md-icon></md-button></a>\n<md-menu-content width=\"2\"><md-menu-item has-permission=\"media_video_transcription_auto_no_api\"><md-button \nng-click=\"transcription(false,video.id)\" aria-label=\"action_edit\"><md-icon style=\"font-size: 22px !important\" \nmd-font-icon=\"icon-custom-transcription-auto\" class=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" \ntranslate=\"MESSAGES.auto_transcription\">auto_transcription</any></md-button></md-menu-item><md-menu-item \nhas-permission=\"media_video_transcription_reload_no_api\"><md-button ng-click=\"transcription(true,video.id)\" \naria-label=\"montage_video\"><md-icon style=\"font-size: 22px !important\" md-font-icon=\"icon-custom-transcription-reload\" \nclass=\"sb18\"></md-icon><any style=\"color: black;opacity: 0.8\" translate=\"MESSAGES.reload_transcription\">\nreload_transcription</any></md-button></md-menu-item></md-menu-content></md-menu><a tooltips \nng-if=\"handler.mode===\'small\'\" tooltip-template=\"{{\'VIDEOADD.show_more\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\" class=\"button-visible-in-small\"><md-button class=\"m16 show-button md-icon-button\" \nng-click=\"showMore(video.id)\" aria-label=\"action_livecomment\"><md-icon md-font-icon=\"icon-chevron-double-right\" \nclass=\"sb18\"></md-icon></md-button></a><div ng-show=\"handler.mode===\'small\'\" style=\"width: 100%;text-align: right\" \nclass=\"show_less button-visible-in-small\"><a tooltips tooltip-hide-trigger=\"mouseleave click\" \ntooltip-template=\"{{\'VIDEOADD.reduce\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 show-button-less md-icon-button\" ng-click=\"showLess()\" aria-label=\"action_livecomment\" translate \ntranslate-attr-aria-label=\"LIVESLIST.action_livecomment\"><md-icon md-font-icon=\"icon-chevron-double-left\" class=\"s18\">\n</md-icon></md-button></a></div>");
$templateCache.put("app/main/media/video/email/email.template.html","<form style=\"width: 50%\" name=\"emailForm\" method=\"post\" \nclass=\"md-inline-form ng-pristine ng-valid ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-valid-required\" \nid=\"emailForm\" novalidate=\"novalidate\" ng-submit=\"emailForm.$valid\"><md-dialog class=\"video-url-dialog\" \naria-label=\"send mail\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\"><md-icon md-font-icon=\"icon-camcorder\" class=\"s24\"></md-icon>\n<span translate=\"MESSAGES.video_by_mail\">video_by_mail</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-radio-group ng-model=\"vm.searchFlight.email\" layout=\"row\">\n<md-radio-button value=\"Auto\" aria-label=\"Label 1\"><p translate=\"VIDEOLIST.insert_mail\" style=\"margin-top: 3px\"></p>\n</md-radio-button><md-radio-button ng-if=\"vm.subscriptionGroups.length\" value=\"Video\" aria-label=\"Label 2\"><p \ntranslate=\"VIDEOLIST.insert_mail_abonne\" style=\"margin-top: 3px\"></p></md-radio-button></md-radio-group><div \nng-switch=\"vm.searchFlight.email\"><div ng-switch-when=\"Auto\"><strong><p translate=\"{{vm.labelEmails}}\">insert mail</p>\n</strong><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"width: 100%\" \nclass=\"md-block md-input-has-placeholder md-default-theme\"><label>Emails</label><md-chips \nid=\"empMediaVideoForm_keyWords\" name=\"email\" ng-model=\"vm.email\" md-removable=\"1\" aria-hidden=\"true\" tabindex=\"-1\" \naria-invalid=\"false\" placeholder=\"Emails\" type=\"email\" ng-required=\"true\" ng-enter=\"vm.validateEmail(vm.email)\" \nclass=\"custum-input-chips\" secondary-placeholder=\"+Email\"><md-chips-wrap ng-keydown=\"$mdChipsCtrl.chipKeydown($event)\" \nng-class=\"{ \'md-focused\': $mdChipsCtrl.hasFocus(),                       \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly,                      \'md-removable\': $mdChipsCtrl.isRemovable() }\" \nclass=\"md-chips md-removable\"><md-chip ng-repeat=\"$chip in $mdChipsCtrl.items\" index=\"0\" \nng-class=\"{\'md-focused\': $mdChipsCtrl.selectedChip === $index, \'md-readonly\': !$mdChipsCtrl.ngModelCtrl || $mdChipsCtrl.readonly}\" \nclass=\"ng-scope md-default-theme\"><div class=\"md-chip-content\" tabindex=\"-1\" aria-hidden=\"true\" \nng-click=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.focusChip($index)\" \nng-focus=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.selectChip($index)\" \nmd-chip-transclude=\"$mdChipsCtrl.chipContentsTemplate\" role=\"button\"><span class=\"ng-binding ng-scope\"></span></div>\n<div ng-if=\"$mdChipsCtrl.isRemovable()\" class=\"md-chip-remove-container ng-scope\" \nmd-chip-transclude=\"$mdChipsCtrl.chipRemoveTemplate\"><button class=\"md-chip-remove ng-scope\" \nng-if=\"$mdChipsCtrl.isRemovable()\" ng-click=\"$mdChipsCtrl.removeChipAndFocusInput($$replacedScope.$index)\" \ntype=\"button\" aria-hidden=\"true\" tabindex=\"-1\"><md-icon \nmd-svg-src=\"data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHg9IjBweCIgeT0iMHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxnPjxwYXRoIGQ9Ik0xOSA2LjQxbC0xLjQxLTEuNDEtNS41OSA1LjU5LTUuNTktNS41OS0xLjQxIDEuNDEgNS41OSA1LjU5LTUuNTkgNS41OSAxLjQxIDEuNDEgNS41OS01LjU5IDUuNTkgNS41OSAxLjQxLTEuNDEtNS41OS01LjU5eiIvPjwvZz48L3N2Zz4=\" \nclass=\"md-default-theme\" aria-hidden=\"true\"><svg version=\"1.1\" x=\"0px\" y=\"0px\" viewBox=\"0 0 24 24\" \nxmlns=\"https://www.w3.org/2000/svg\" fit=\"\" height=\"100%\" width=\"100%\" preserveAspectRatio=\"xMidYMid meet\" \nfocusable=\"false\"><g><path \nd=\"M19 6.41l-1.41-1.41-5.59 5.59-5.59-5.59-1.41 1.41 5.59 5.59-5.59 5.59 1.41 1.41 5.59-5.59 5.59 5.59 1.41-1.41-5.59-5.59z\">\n</path></g></svg></md-icon><span class=\"md-visually-hidden ng-binding\">Remove</span></button></div><span \nng-if=\"!$mdChipsCtrl.readonly\" class=\"md-visually-hidden ng-binding ng-scope\">Press delete to remove this chip.</span>\n</md-chip><div class=\"md-chip-input-container ng-scope\" \nng-if=\"!$mdChipsCtrl.readonly &amp;&amp; $mdChipsCtrl.ngModelCtrl\"><div \nmd-chip-transclude=\"$mdChipsCtrl.chipInputTemplate\"><input \nclass=\"md-input ng-pristine ng-untouched ng-valid ng-scope ng-empty\" tabindex=\"0\" aria-label=\"Mots clés\" \nng-model=\"$mdChipsCtrl.chipBuffer\" ng-focus=\"$mdChipsCtrl.onInputFocus()\" ng-blur=\"$mdChipsCtrl.onInputBlur()\" \nng-keydown=\"$mdChipsCtrl.inputKeydown($event)\" id=\"input_43\" aria-invalid=\"false\"><div class=\"md-errors-spacer\"></div>\n</div></div></md-chips-wrap></md-chips><div ng-messages=\"emailForm.email.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div style=\"font-size: 12px\" \nng-if=\"vm.invalidEmail\" translate=\"MESSAGES.invalid_mail_delete\">Invalid email address! we removed it.</div></div>\n</md-input-container></div></div></div><div ng-switch=\"vm.searchFlight.email\"><div ng-switch-when=\"Video\"><strong><p \ntranslate=\"VIDEOLIST.group_abonne\">group_abonne</p></strong><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container\n flex><md-select ng-model=\"vm.groupId\" ng-attr-name=\"collection\" required=\"1\" \nplaceholder=\"{{ \'MESSAGES.subscribers_group\'|translate}}\" ng-change=\"vm.enableSubmitButton()\"><collection \ncollection=\"vm.subscriptionGroups\"></collection></md-select><div ng-messages=\"emailForm.collection.$error\" \nrole=\"alert\" md-auto-hide=\"false\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required\n</div></div></md-input-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><span flex></span><md-button ng-click=\"vm.closeDialog()\" \ntranslate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" \naria-label=\"Submit\" ng-click=\"vm.sendVideoByMail(vm.video_id,vm.email.mail)\" \nng-disabled=\"emailForm.$invalid || emailForm.$pristine || vm.invalidEmailBtn\" translate=\"MESSAGES.send\">Send\n</md-button></md-dialog-actions></md-dialog></form>");
$templateCache.put("app/main/media/video/caption-new/template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple\" \nng-class=\"{\'isNavigationNew\' : vm.isNavigationNew}\" style=\"padding:0 8%;background: white\" layout=\"column\"><div \nclass=\"fullpage\" layout=\"column\"><preview-video event=\"vm.event\" params=\"vm.params\" diffusion=\"\'internet\'\" \nhandler=\"vm\"></preview-video></div></div>");
$templateCache.put("app/main/media/video/questions-quiz/questions.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card\" \nlayout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"VOTELIST.question\">question</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.form_choices_yes\">\nform_choices_yes</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.form_choices_no\">form_choices_no</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"VOTELIST.other\">other</span></div></th></tr></thead><tbody><tr \nng-repeat=\"question in vm.questions track by question.id\" ng-attr-data-index=\"{{$index}}\"><td class=\"secondary-text\">\n<div>{{question.question}}</div></td><td class=\"secondary-text\"><div ng-if=\"question.votes.yes !== null\"><span>\n{{question.votes.yes}}</span></div><div ng-if=\"question.votes.yes === null\"><span>0</span></div></td><td \nclass=\"secondary-text\"><div ng-if=\"question.votes.no !== null\"><span>{{question.votes.no}}</span></div><div \nng-if=\"question.votes.no === null\"><span>0</span></div></td><td class=\"secondary-text\"><div \nng-if=\"question.votes.other !== null\"><span>{{question.votes.other}}</span></div><div \nng-if=\"question.votes.other === null\"><span>0</span></div></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/media/video/questions-quiz/questions_quiz.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"export-csv-container\" \nstyle=\"left:77%;right: 2%; z-index: 1; position: absolute; text-align: center\"><md-button title=\"Export CSV\" \naria-label=\"menu\" ng-click=\"vm.exportCsv()\"><md-icon style=\"font-size: 22px; margin-top: -4px; color: #039be5\" \nmd-font-icon=\"icon-file-excel\"></md-icon><span class=\"export-csv-text\" style=\"color: #039be5\">Export CSV</span>\n</md-button></div><md-tabs id=\"question_quiz\" class=\"md-border-bottom\" layout-fill md-selected=\"$root.selectedIndex\" \nstyle=\"background-color: white\" md-stretch-tabs=\"yes\" flex><md-tab \ndata-ui-sref=\"app.media_video_questions_quiz.questions\"><md-tab-label translate=\"COMMENTSLIST.direct_comments\">\nQuestions</md-tab-label><md-tab-body layout-fill flex><div layout-fill data-ui-view=\"questions\" flex></div>\n</md-tab-body></md-tab><md-tab data-ui-sref=\"app.media_video_questions_quiz.quiz\"><md-tab-label \ntranslate=\"COMMENTSLIST.media_comments\" flex>Quiz</md-tab-label><md-tab-body layout-fill flex><div layout-fill \ndata-ui-view=\"quiz\" flex></div></md-tab-body></md-tab></md-tabs></div><style>\n@media (max-width: 581px) {\n        .export-csv-text {\n            display: none;\n        }\n    }</style>");
$templateCache.put("app/main/media/video/questions-quiz/quiz.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth table_quiz\" layout=\"column\"><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border\" datatable=\"ng\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\"><thead><tr><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"QuestionsQuizLIST.quiz\">quiz</span></div></th><th class=\"secondary-text\" data-priority=\"1\" \ndata-sorter=\"false\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.form_choices\">form_choices</span></div></th></tr></thead><tbody><tr \nng-repeat=\"quiz in vm.quiz track by quiz.id\" ng-attr-data-index=\"{{$index}}\"><td><div><p>{{quiz.title}}</p></div></td>\n<td><hc-pie-chart class=\"pie_chart\" title=\"\" data=\"quiz.votes\">Placeholder for pie chart</hc-pie-chart><table \nclass=\"table_choices\"><thead><tr><th><span class=\"column-title center-span\" translate=\"QuestionsQuizLIST.listChoices\">\nlist_choices</span></th><th><span class=\"column-title center-span\" translate=\"QuestionsQuizLIST.nbVotes\">nb_votes\n</span></th><th><span class=\"column-title center-span\" translate=\"QuestionsQuizLIST.percentVotes\">percent_votes</span>\n</th></tr></thead><tbody><tr ng-repeat=\"vote in quiz.votes\" ng-attr-data-index=\"{{$index}}\"><td><p>{{vote.name}}</p>\n</td><td>{{vote.nbVotes}}</td><td>{{vote.y * 100}}%</td></tr></tbody></table></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/media/video/reupload/choose-thumb.template.html","<div><div class=\"mv-24\"></div><div ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" class=\"mv-24\">\n<md-progress-circular class=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip md-autohide=\"true\" \nmd-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div ng-if=\"vm.playerLink\" \nlayout-align=\"center center\" layout=\"row\" class=\"mv-24\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" \nflex-xs=\"100\"><div layout=\"row\" layout-align=\"center center\"><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; width=\"600\" height=\"340\" \nng-src=\"{{vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe>\n</div></div></div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div \nng-if=\"vm.videoThumb\" layout-align=\"center center\" layout=\"row\" class=\"p-25 mv-25\"><div ng-style=\"vm.innerThumbStyle\" \nlayout=\"row\" layout-align=\"center center\"><img class=\"media\" ng-src=\"{{vm.videoThumb}}\"></div></div><md-divider \nmd-inset></md-divider><div><div ng-if=\"!vm.loadingGeneratedThumbs\" layout-align=\"center start\" layout=\"row\"><a \ntooltips tooltip-template=\"{{\'MESSAGES.regenerate_new_thumbs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.getGeneratedThumbs()\" aria-label=\"regenerate_new_thumbs\" translate \ntranslate-attr-aria-label=\"MESSAGES.regenerate_new_thumbs\"><md-icon md-font-icon=\"icon-refresh\" class=\"s18\"></md-icon>\n</md-button></a></div><div flex layout=\"row\" layout-padding layout-align=\"center center\"><div \nng-if=\"vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><md-progress-circular class=\"md-primary\"></md-progress-circular><md-tooltip md-autohide=\"true\" \nmd-direction=\"bottom\">{{\'MESSAGES.waiting_for_thumbs\'|translate}}</md-tooltip></div><p \nng-if=\"vm.errorOnGettingGeneratedThumbs\" class=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.error_on_getting_generated_thumbs\" \ntranslate-attr-title=\"MESSAGES.error_on_getting_generated_thumbs\" title=\"error_on_getting_generated_thumbs\">\nerror_on_getting_generated_thumbs</p><p \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && !vm.thumbs.length\" \nclass=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.video_did_not_generate_thumbs\" \ntranslate-attr-title=\"MESSAGES.video_did_not_generate_thumbs\" title=\"video_did_not_generate_thumbs\">\nvideo_did_not_generate_thumbs</p><div \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && vm.thumbs.length\"><div \nclass=\"product-image-uploader\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"thumb in vm.thumbs\"><div \nstyle=\"position: relative;width: 200px;height: 200px;border: 1px solid rgba(0, 0, 0, 0.12);margin: 8px\" \nclass=\"product-image uploading\" layout=\"row\" layout-align=\"center center\"><img ng-click=\"vm.setAndPreviewThumb(thumb)\" \nclass=\"media\" ng-src=\"{{thumb}}\" ng-style=\"vm.productImageMediaStyle\"></div></div></div></div></div></div></div>\n<md-divider md-inset></md-divider></div><div ng-hide=\"vm.inProgress\" class=\"md-background-bg md-whiteframe-1dp pv-15\">\n<div layout-align=\"center start mv-10\" layout=\"row\"><md-button class=\"md-warn md-flat\" ng-disabled=\"vm.inProgress\" \nng-click=\"vm.returnToList()\" translate=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-check\"></md-icon><any \ntranslate=\"MESSAGES.form_validate\">form_validate</any></md-button></div></div></div>");
$templateCache.put("app/main/media/video/reupload/reupload.list.html","<div ng-show=\"state.current.name===\'app.media_video_reupload\'\" id=\"e-commerce-product\" \nclass=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content fullpage\" layout=\"column\"><md-tabs \nid=\"tab-upload\" ng-if=\"vm.uploadStep === 1\" md-dynamic-height md-border-bottom><md-tab><md-tab-label><md-icon \nstyle=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-upload-custom\"></md-icon><div \nstyle=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"VIDEOADD.upload_local\"></span></div>\n</md-tab-label><md-tab-body><md-content class=\"md-padding\" style=\"height: 100%\"><div ng-if=\"vm.uploadMetaDataError\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\">\n<div layout=\"row\" layout-align=\"center center\"><span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.alert_xhr_error\">alert_xhr_error</span></div></div></div><div class=\"mv-24\" \nng-if=\"vm.uploadMetaDataError\"></div><div \nng-style=\"vm.ngFlowOptions.target===0 && {border: \'2px dashed rgba(0,0,0,0.15)\',     background: \'rgb(245,245,245)\'}\" \nclass=\"product-detail-form-container\"><iframe ng-if=\"vm.urlUpload\" \nstyle=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%\" width=\"800\" height=\"400\" \nng-src=\"{{vm.urlUpload}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe><div \nng-if=\"vm.ngFlowOptions.target && !vm.urlUpload\" class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-icon style=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" \nmd-font-icon=\"icon-cloud-upload\" class=\"s24\"></md-icon><md-button \nstyle=\"margin-top: 15px;background-color: rgb(45,50,62)\" flow-btn ng-disabled=\"vm.inProgress\"><span \nstyle=\"color: rgba(255,255,255,0.87);text-transform: uppercase;font-weight: 500;font-size: 14px\" \ntranslate=\"MESSAGES.choose_a_file\">choose_a_file</span></md-button><label \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.change_file_source\" \nng-if=\"state.current.url=\'/change-video-source\'\">change_file_source</label><md-button class=\"md-warn md-flat\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel</md-button><span \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.video_upload_drop_message\">\nvideo_upload_drop_message</span></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>\n{{vm.videoFile.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" value=\"{{vm.progressBarValue}}\">\n</md-progress-circular></div></div></div></div></div></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.permission.media_video_add_option_extern_link\"><md-tab-label><md-icon style=\"color: #0000008a !important\" \nclass=\"tab-upload-icon\" md-font-icon=\"icon-link-custom\"></md-icon><div style=\"margin-top: -50px\"><span \nstyle=\"text-transform: none\" translate=\"VIDEOADD.video_link\"></span></div></md-tab-label><md-tab-body><md-content \nclass=\"md-padding\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\"><span \ntranslate=\"VIDEOADD.add_video_link\"></span><md-input-container style=\"width: 100%\" md-no-float class=\"md-block\"><input \nng-model=\"vm.video_link\" placeholder=\"Ex:https://youtu.be/7a9m5h8qqy0\"></md-input-container><div layout=\"row\" \nlayout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent md-raised\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.form_validate\">Validate</md-button></div></div></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_on_hold\" md-on-select=\"vm.getVideoOnHold()\">\n<md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-waiting-custom\">\n</md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"VIDEOADD.on_hold_list\"></span>\n</div></md-tab-label><md-tab-body><div class=\"content fullpage-datatable\" layout=\"column\" flex \nid=\"tab_on_hold_content\"><div style=\"width: 100%;margin-top:-6px;margin-left: -15px;margin-right: 5px\"><div \nstyle=\"width: 15%;float: left;margin: 18px;margin-left: 43px\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nng-if=\"vm.selectedVods.length\" class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteOnHoldVideosConfirm($event)\" \naria-label=\"MESSAGES.action_delete\" translate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></a></div><div style=\"float: right;  width: 25%\"><form layout-wrap \nmethod=\"post\" ng-submit=\"vm.searchVods()\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"videos-search\" type=\"text\" \naria-label=\"title\" translate translate-attr-placeholder=\"MESSAGES.form_attr_source\" flex ng-model=\"vm.search_videos\">\n</md-input-container></form></div></div><table class=\"dataTable row-border hover\" datatable=\"\" \ndt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\" \ndata-priority=\"1\" style=\"width: 30px\"><md-checkbox aria-label=\"-\" ng-click=\"vm.toggleAll()\"></md-checkbox></th><th \nclass=\"secondary-text\" style=\"width: 40px\"><div class=\"table-header centerdiiv\" data-priority=\"7\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\" data-priority=\"2\" style=\"width: 150px\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.form_attr_source\">\nform_attr_source</span></div></th><th class=\"secondary-text\" data-priority=\"8\" style=\"width: 150px\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.created_at\">date</span>\n</div></th><th class=\"secondary-text\" data-priority=\"8\" style=\"width: 150px\"><div class=\"table-header centerdiiv\"><span\n class=\"column-title center-span\" translate=\"MESSAGES.form_attr_contributor\">form_attr_contributor</span></div></th><th\n class=\"secondary-text\" data-priority=\"3\" style=\"width: 300px\"><div class=\"table-header centerdiiv\"><span \nstyle=\"text-align: center\" class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr>\n</thead></table></div></md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_on_hold_sftp\" \nmd-on-select=\"vm.getVideoOnHoldSFTP()\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important;font-size: 40px!important\" class=\"tab-upload-icon\" md-font-icon=\"icon-video-server\">\n</md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"VIDEOADD.on_hold_sftp_list\">\n</span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.tree.length === 0\">\n<span class=\"title\" style=\"padding:1%\" translate=\"VIDEOADD.on_hold_empty\">on_hold_empty</span></div><div \nng-if=\"vm.tree.length > 0\" js-tree=\"treeConfig\" ng-model=\"vm.tree\" tree=\"vm.treeInstance\" class=\"tree_sftp\" \nstyle=\"padding-bottom: 60px\" tree-events-obj=\"treeEventsObj\"></div><md-button ng-if=\"vm.testData\" \nclass=\"show-more-button md-raised\" translate=\"VIDEOADD.show_more\" ng-click=\"vm.showMore()\">show_more</md-button>\n</md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_webcam\" \nng-click=\"vm.onWebcamSelected()\"><md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-webcam-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\">Webcam\n</span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div ng-if=\"vm.isChrome\" \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\"><div><img ng-src=\"assets/icons/delete.png\"></div><span style=\"padding-left: 2%\" \ntranslate=\"VIDEOADD.msg_download_extension\">Veuiller installer l\'extension chrome</span></div><div><md-button \nclass=\"md-warn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-click=\"vm.redirect()\" translate=\"VIDEOADD.download_extension\">form_add</md-button></div></div><div \nng-if=\"!vm.isChrome\" class=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\" layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"center center\"><div><img ng-src=\"assets/icons/delete.png\"></div><span \nstyle=\"padding-left: 2%\" translate=\"VIDEOADD.not_chrome\">not_chrome</span></div></div></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_story_board\" ui-sref=\"app.new_template_manager_editornew\">\n<md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-storyboard-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\">\nStoryboard</span></div></md-tab-label></md-tab></md-tabs><div ng-if=\"vm.uploadStep === 2\"><div class=\"mv-24\"></div><div\n ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" class=\"mv-24\"><md-progress-circular \nclass=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip md-autohide=\"true\" md-direction=\"bottom\">\n{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div ng-if=\"vm.playerLink\" layout-align=\"center center\" \nlayout=\"row\" class=\"mv-24\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"center center\"><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; width=\"600\" height=\"340\" \nng-src=\"{{vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe>\n</div></div></div><div ng-if=\"vm.uploadStep\" class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<div ng-if=\"vm.videoThumb && !vm.is_on_hold\" layout-align=\"center center\" layout=\"row\" class=\"p-25 mv-25\"><div \nng-style=\"vm.innerThumbStyle\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" ng-src=\"{{vm.videoThumb}}\" \nstyle=\"width: 100%\"></div></div><md-divider md-inset></md-divider><div ng-if=\"!vm.is_on_hold\"><div \nng-if=\"!vm.loadingGeneratedThumbs\" layout-align=\"center start\" layout=\"row\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.regenerate_new_thumbs\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.getGeneratedThumbs()\" aria-label=\"regenerate_new_thumbs\" translate \ntranslate-attr-aria-label=\"MESSAGES.regenerate_new_thumbs\"><md-icon md-font-icon=\"icon-refresh\" class=\"s18\"></md-icon>\n</md-button></a></div><div flex layout=\"row\" layout-padding layout-align=\"center center\"><div \nng-if=\"vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs\" layout=\"row\" layout-align=\"start start\" \nlayout-wrap><md-progress-circular class=\"md-primary\"></md-progress-circular><md-tooltip md-autohide=\"true\" \nmd-direction=\"bottom\">{{\'MESSAGES.waiting_for_thumbs\'|translate}}</md-tooltip></div><p \nng-if=\"vm.errorOnGettingGeneratedThumbs\" class=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.error_on_getting_generated_thumbs\" \ntranslate-attr-title=\"MESSAGES.error_on_getting_generated_thumbs\" title=\"error_on_getting_generated_thumbs\">\nerror_on_getting_generated_thumbs</p><p \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && !vm.thumbs.length\" \nclass=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.video_did_not_generate_thumbs\" \ntranslate-attr-title=\"MESSAGES.video_did_not_generate_thumbs\" title=\"video_did_not_generate_thumbs\">\nvideo_did_not_generate_thumbs</p><div \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && vm.thumbs.length\" style=\"width: 100%\"><div \nclass=\"product-image-uploader\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"thumb in vm.thumbs\"><div class=\"product-image uploading\" layout=\"row\" layout-align=\"center center\"><img \nng-click=\"vm.setAndPreviewThumb(thumb)\" class=\"media\" style=\"width: 100%\" ng-src=\"{{thumb}}\" \nng-style=\"vm.productImageMediaStyle\"></div></div></div></div></div></div></div><md-divider md-inset></md-divider><div \nng-if=\"vm.is_on_hold\" style=\"text-align: center;padding: 30px\"><span flex aria-label=\"choose_thumb_from_local\" \ntranslate=\"MESSAGES.choose_thumb_from_local\" translate-attr-aria-label=\"MESSAGES.choose_thumb_from_local\"></span><div \nlayout-align=\"center start mv-10\" layout=\"row\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptionsVignette\" flow-name=\"vm.ngFlowVignette.flow\" flow-files-submitted=\"vm.uploadFileVignette()\" \nflow-file-added=\"vm.fileAddedVignette($file)\" flow-file-progress=\"vm.uploadingInPogressVignette = 1\" \nflow-file-success=\"vm.fileSuccessVignette($file, $message)\" flow-complete=\"vm.uploadCompleteVignette()\" \nflow-file-error=\"vm.fileErrorVignette($file,$message)\" flow-drop flow-drag-enter=\"vm.droppingVignette=true\" \nflow-drag-leave=\"vm.droppingVignette=false\" ng-class=\"{\'dropping\':vm.droppingVignette}\"><div class=\"upload-button\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"cta-button md-raised md-accent\" flow-btn \nng-disabled=\"vm.uploadingInPogressVignette\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"VIDEOADD.choose_thumb\">choose_thumb</span></md-button><md-progress-circular \nng-if=\"vm.uploadingInPogressVignette\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div><div \nng-if=\"vm.droppingVignette\" class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><p ng-if=\"vm.imageNameVignette\" \nclass=\"text-truncate mh-10\">{{vm.imageNameVignette}}</p></div></div><div ng-if=\"vm.videoThumb\" style=\"width: 100%\"><div\n class=\"product-image-uploader\"><div layout-align=\"center start mv-10\" layout=\"row\"><div \nclass=\"product-image uploading\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" style=\"width: 100%\" \nng-src=\"{{vm.videoThumb}}\"></div></div></div></div></div><md-divider md-inset></md-divider></div><div \nng-hide=\"vm.inProgress\" class=\"md-background-bg md-whiteframe-1dp pv-15\"><div layout-align=\"center start mv-10\" \nlayout=\"row\"><md-button class=\"md-warn md-flat\" ng-disabled=\"vm.inProgress\" ng-click=\"vm.returnToList()\" \ntranslate=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button class=\"md-primary md-raised\" \nng-click=\"vm.save(vm.videoOnHoldId)\"><md-icon md-font-icon=\"icon-check\"></md-icon><any \ntranslate=\"MESSAGES.form_validate\">form_validate</any></md-button></div></div></div></div></div><div \nng-show=\"state.current.name !==\'app.media_video_reupload\' && $root.isReuploading\" class=\"theme-config-upload\"><div \nclass=\"theme-config-box-upload\"><div style=\"height: 170px\" class=\"skin-setttings-upload\"><md-toolbar \nstyle=\"width: 360px;margin-left: -17px;height: 45px;min-height: 45px;margin-top: -10px;background-color: rgb(45,50,62)\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<span ng-if=\"vm.progressBarValue\" style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.inprogress\">1 vidéo en cours </span>\n<span ng-if=\"vm.inProgress===false\" style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.ended\">1 Vidéo terminée </span>\n</span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeUpload($event)\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div class=\"spin-icon-upload\" ng-click=\"vm.click()\" id=\"menu\"><md-icon ng-if=\"!vm.icon\" \nmd-font-icon=\"icon-upload\" class=\"icon toogle-upload\"></md-icon><md-icon ng-if=\"vm.icon\" \nmd-font-icon=\"icon-chevron-right\" class=\"icon toogle-upload\"></md-icon></div><form><div></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"text-align: right;padding-top: 10px\"><div ng-if=\"vm.inProgress===true\"><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"secondary-text mt-8 text-center\" title=\"{{vm.videoFile.name}}\"><strong style=\"font-size: 14px\">\n{{vm.videoFile.name}}</strong></p></div><div style=\"cursor: pointer\" ng-if=\"vm.inProgress===false\" \nng-click=\"vm.goToReuploadPage()\"><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"mt-8 text-center\" title=\"{{vm.videoFile.name}}\"><strong style=\"font-size: 14px\">{{vm.videoFile.name}}</strong>\n</p></div><div><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p><md-icon \nstyle=\"color: rgb(76, 175, 80)!important;cursor: pointer;margin-top: -10px\" ng-if=\"vm.inProgress===false\" \nng-click=\"vm.goToReuploadPage()\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"icon toogle-upload\"></md-icon></div>\n</div></form></div></div></div>");
$templateCache.put("app/main/media/video/montage/montage.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple\" style=\"padding:0 8%;background: white\" \nlayout=\"column\"><div class=\"fullpage\" layout=\"column\"><preview-video event=\"vm.event\" params=\"vm.params\" \ndiffusion=\"\'internet\'\" handler=\"vm\"></preview-video></div></div>");
$templateCache.put("app/main/media/video/montage-new/montage.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple montageZone\" style=\"background: white\" \nlayout=\"column\"><div class=\"fullpage\" layout=\"column\"><preview-video event=\"vm.event\" params=\"vm.params\" \ndiffusion=\"\'internet\'\" handler=\"vm\"></preview-video></div></div>");
$templateCache.put("app/main/media/video/reupload-multilangue/reupload.list.html","<md-dialog aria-label=\"configuration_server_detail_pagetitle\" style=\"width: 100%;height: 75%\" \nid=\"IE-add-video-subscribers\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAGESMENUSTITLES.media_video_reupload_pagetitle\">add_subscribers</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-content style=\"height: 100%\"><div class=\"content fullpage\" layout=\"column\"><div ng-if=\"vm.uploadStep === 1\">\n<md-tabs id=\"tab-upload\" md-dynamic-height md-border-bottom><md-tab><md-tab-label><md-icon \nstyle=\"color: #0000008a !important;margin-top: -2px!important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-upload-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" \ntranslate=\"VIDEOADD.upload_local\"></span></div></md-tab-label><md-tab-body><md-content style=\"margin-top: 5%\" \nclass=\"md-padding\"><div ng-if=\"vm.uploadMetaDataError\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"center center\">\n<span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.alert_xhr_error\">alert_xhr_error\n</span></div></div></div><div class=\"mv-24\" ng-if=\"vm.uploadMetaDataError\"></div><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15)\" class=\"product-detail-form-container\"><div ng-if=\"vm.ngFlowOptions.target\" \nclass=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div style=\"margin-bottom: 15px\" class=\"drop-text hint-text\" layout=\"row\" \nlayout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div \nclass=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgress\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><md-button class=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" \nng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel</md-button><span \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.video_upload_drop_message\">\nvideo_upload_drop_message</span></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>\n{{vm.videoFile.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" value=\"{{vm.progressBarValue}}\">\n</md-progress-circular></div></div></div></div></div></md-content></md-tab-body></md-tab><md-tab><md-tab-label><md-icon\n style=\"color: #0000008a !important;margin-top: -2px!important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-waiting-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" \ntranslate=\"VIDEOADD.on_hold_list\"></span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.tree.length === 0\">\n<span class=\"title\" style=\"padding:1%\" translate=\"VIDEOADD.on_hold_empty\">on_hold_empty</span></div><div \nng-if=\"vm.tree.length > 0\" js-tree=\"treeConfig\" ng-model=\"vm.tree\" tree=\"vm.treeInstance\" style=\"padding-bottom: 60px\" \ntree-events-obj=\"treeEventsObj\"></div><md-button ng-if=\"vm.testData\" class=\"show-more-button md-raised\" \ntranslate=\"VIDEOADD.show_more\" ng-click=\"vm.showMore()\">show_more</md-button></md-content></md-tab-body></md-tab>\n</md-tabs></div><div ng-if=\"vm.uploadStep === 2\"><div class=\"mv-24\"></div><div ng-if=\"vm.playerIsLoading\" \nlayout-align=\"center center\" layout=\"row\" class=\"mv-24\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\">\n</md-progress-circular><md-tooltip md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div\n ng-if=\"vm.playerLink\" layout-align=\"center center\" layout=\"row\" class=\"mv-24\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"center center\">\n<iframe allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; width=\"600\" height=\"340\" \nng-src=\"{{vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe>\n</div></div></div><div ng-if=\"vm.uploadStep\" class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\">\n<div ng-if=\"vm.videoThumb\" layout-align=\"center center\" layout=\"row\" class=\"p-25 mv-25\"><div \nng-style=\"vm.innerThumbStyle\" layout=\"row\" layout-align=\"center center\"><img class=\"media\" ng-src=\"{{vm.videoThumb}}\">\n</div></div><md-divider md-inset></md-divider><div><div ng-if=\"!vm.loadingGeneratedThumbs\" layout-align=\"center start\" \nlayout=\"row\"><a tooltips tooltip-template=\"{{\'MESSAGES.regenerate_new_thumbs\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.getGeneratedThumbs()\" \naria-label=\"regenerate_new_thumbs\" translate translate-attr-aria-label=\"MESSAGES.regenerate_new_thumbs\"><md-icon \nmd-font-icon=\"icon-refresh\" class=\"s18\"></md-icon></md-button></a></div><div flex layout=\"row\" layout-padding \nlayout-align=\"center center\"><div ng-if=\"vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap><md-progress-circular class=\"md-primary\"></md-progress-circular><md-tooltip \nmd-direction=\"bottom\">{{\'MESSAGES.waiting_for_thumbs\'|translate}}</md-tooltip></div><p \nng-if=\"vm.errorOnGettingGeneratedThumbs\" class=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.error_on_getting_generated_thumbs\" \ntranslate-attr-title=\"MESSAGES.error_on_getting_generated_thumbs\" title=\"error_on_getting_generated_thumbs\">\nerror_on_getting_generated_thumbs</p><p \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && !vm.thumbs.length\" \nclass=\"text-truncate md-display-1\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.video_did_not_generate_thumbs\" \ntranslate-attr-title=\"MESSAGES.video_did_not_generate_thumbs\" title=\"video_did_not_generate_thumbs\">\nvideo_did_not_generate_thumbs</p><div \nng-if=\"!vm.loadingGeneratedThumbs && !vm.errorOnGettingGeneratedThumbs && vm.thumbs.length\"><div \nclass=\"product-image-uploader\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"thumb in vm.thumbs\"><div class=\"product-image uploading\" layout=\"row\" layout-align=\"center center\"><img \nng-click=\"vm.setAndPreviewThumb(thumb)\" class=\"media\" ng-src=\"{{thumb}}\" ng-style=\"vm.productImageMediaStyle\"></div>\n</div></div></div></div></div><div ng-hide=\"vm.inProgress\" class=\"md-background-bg md-whiteframe-1dp pv-15\"><div \nlayout-align=\"center start mv-10\" layout=\"row\"><md-button class=\"md-warn md-flat\" ng-disabled=\"vm.inProgress\" \nng-click=\"vm.returnToList()\" translate=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-check\"></md-icon><any \ntranslate=\"MESSAGES.form_validate\">form_validate</any></md-button></div></div></div><md-divider md-inset></md-divider>\n</div></div></div></md-content></md-dialog>");
$templateCache.put("app/main/media/video/rich-media/preview.dialog.html","<md-dialog style=\"min-width: 50%;max-height:80%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s24\"></md-icon><span style=\"padding-left: 10px\" translate=\"MESSAGES.preview\">Preview\n</span></span></h2><span flex></span> <a tooltips tooltip-template=\"{{\'MESSAGES.alert_close\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"CLOSE\" \nng-click=\"closeDialog()\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></a></div></md-toolbar><div layout=\"column\"><md-content layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"center center\" style=\"padding: 50px;padding-top: 15px\"><iframe \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; style=\"margin : 5px\" id=\"player\" \nwidth=\"600\" height=\"340\" ng-src=\"{{link}}\" allowfullscreen=\"true\" ng-if=\"isVideo()\" webkitallowfullscreen=\"true\" \nmozallowfullscreen=\"true\"></iframe><img ng-src=\"{{link}}\" ng-hide=\"isVideo()\"></div><div layout=\"row\" \nlayout-align=\"center center\" ng-hide=\"file\" style=\"padding: 50px\"><md-button class=\"md-raised md-warn\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"closeDialog()\">cancel</md-button><md-button class=\"md-accent md-raised\" \ntranslate=\"MESSAGES.form_step_validate\" ng-click=\"submit()\">submit</md-button></div></md-content></div></md-dialog>");
$templateCache.put("app/main/media/video/rich-media/preview.sample.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" style=\"width:50%;height: 60%\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span \ntranslate=\"VIDEORICHMEDIA.video_rich_media_chapter_file_sample\">File preview</span> </span><span flex></span> <a \ntooltips tooltip-template=\"{{\'MESSAGES.alert_close\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"CLOSE\" ng-click=\"vm.cancel()\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></a></div>\n</md-toolbar><md-dialog-content class=\"no-padding\" style=\"height: 80%\"><md-tabs class=\"md-dynamic-height\"><md-tab \nng-click=\"vm.getXmlPreview()\"><md-tab-label>xml</md-tab-label><md-tab-body style=\"width: fit-content\"><div><pre>\n{{vm.xmlPreview}}</pre></div></md-tab-body></md-tab><md-tab ng-click=\"vm.getRtcPreview()\"><md-tab-label>rtc\n</md-tab-label><md-tab-body><div style=\"width: 100%\"><pre>{{vm.rtcPreview}}</pre></div></md-tab-body></md-tab>\n</md-tabs></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"save-button md-accent md-raised\" ng-href=\"{{vm.downloadSample()}}\" target=\"_blank\" aria-label=\"download_file\" \ntranslate=\"MESSAGES.download_file\" translate translate-attr-aria-label=\"MESSAGES.download_file\"><md-icon \nmd-font-icon=\"icon-download\"></md-icon></md-button><md-button ng-click=\"vm.cancel()\" \nclass=\"save-button md-accent md-raised\" aria-label=\"CLOSE\" translate=\"MESSAGES.alert_close\" \ntranslate-attr-aria-label=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/rich-media/template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"fullpage\" layout=\"column\"><div><div ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" \nclass=\"mv-24\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip \nmd-autohide=\"true\" md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div \nng-if=\"vm.playerLink\"><div layout-align=\"center center\" layout=\"row\"><div style=\"height: 450px;width: 100%\" \nclass=\"md-whiteframe-1dp md-background-bg\"><div style=\"margin-top: 1%\" layout=\"row\" layout-align=\"center center\">\n<iframe allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; id=\"iframe_player\" \nwidth=\"600\" height=\"340\" ng-src=\"{{vm.playerLink}}\" allowfullscreen=\"true\" webkitallowfullscreen=\"true\" \nmozallowfullscreen=\"true\"></iframe></div><div><div \nstyle=\"margin-top: 10px !important;background:#f4f4f4;height: 85px;border-top: 1px solid #ededed\" layout=\"column\" \nlayout-align=\"center center\" class=\"mv-24 p-12\"><div style=\"width: 610px\" layout=\"row\" layout-align=\"center center\" \nclass=\"mv-24 p-12\"><md-menu style=\"width: 100%\"><md-button style=\"width: 95%\" class=\"md-accent md-raised\" \ntranslate=\"MESSAGES.add_interactivity\" ng-click=\"vm.addTimeSlot($mdOpenMenu)\">add_chapter</md-button><md-menu-content \nwidth=\"3\" class=\"md-menu-bar-menu md-dense md-default-theme\"><md-menu-item class=\"md-indent\" \nng-click=\"vm.addChapter()\"><md-icon md-font-icon=\"icon-compare\"></md-icon><md-button \ntranslate=\"VIDEORICHMEDIA.video_rich_media_chapter_add\">Add chapter</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.addSurvey()\"><md-icon md-font-icon=\"icon-poll\">\n</md-icon><md-button translate=\"MESSAGES.add_survey\">Add survey</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.addQuiz()\"><md-icon md-font-icon=\"icon-poll-box\">\n</md-icon><md-button translate=\"MESSAGES.add_quiz\">Add Quiz</md-button></md-menu-item><md-menu-divider>\n</md-menu-divider><md-menu-item class=\"md-indent\" ng-click=\"vm.exitMenu2()\"><md-icon \nmd-font-icon=\"icon-file-excel-box\"></md-icon><md-button translate=\"MESSAGES.form_cancel\">Cancel</md-button>\n</md-menu-item></md-menu-content></md-menu><md-menu style=\"width: 100%\"><md-button style=\"width: 95%\" \nclass=\"md-accent md-raised\" translate=\"VIDEORICHMEDIA.video_rich_media_slide_add\" ng-click=\"vm.addSlide($mdOpenMenu)\">\nadd_slide</md-button><md-menu-content width=\"3\" class=\"md-menu-bar-menu md-dense md-default-theme\"><md-menu-item \nclass=\"md-indent\"><div class=\"product-image-uploader\" flow-init=\"vm.ngFlowImageOptions\" \nflow-name=\"vm.ngFlowImage.flow\" flow-files-submitted=\"vm.uploadFileImage()\" flow-file-added=\"vm.fileImgAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\"><md-button style=\"width: 116%;margin-left: -18px\" \nflow-btn ng-click=\"vm.listItemClick(\'image\')\" class=\"md-list-item-content\"><md-icon style=\"margin-left: 20px\" \nmd-font-icon=\"icon-image-area\"></md-icon><span style=\"margin-left: 16px\" class=\"md-inline-list-icon-label\" \ntranslate=\"VIDEORICHMEDIA.video_rich_media_slide_image\">Upload image</span></md-button></div></div></md-menu-item>\n<md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><div id=\"product-video-uploader\" \nflow-init=\"vm.ngFlowVideoOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileVideoAdded($file)\" flow-file-progress=\"vm.fileProgress($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\">\n<md-button style=\"width: 116%;margin-left: -18px\" flow-btn ng-click=\"vm.listItemClick(\'video\')\" \nclass=\"md-list-item-content\"><md-icon style=\"margin-left: 20px\" md-font-icon=\"icon-camcorder-box\"></md-icon><span \nstyle=\"margin-left: 16px\" class=\"md-inline-list-icon-label\" translate=\"VIDEORICHMEDIA.video_rich_media_slide_video\">\nUpload video</span></md-button></div></div></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass=\"md-indent\" ng-click=\"vm.listItemClick(\'thumb\')\"><md-icon md-font-icon=\"icon-compare\"></md-icon><md-button \ntranslate=\"VIDEORICHMEDIA.video_rich_media_slide_thumb\">Generate thumbnail</md-button></md-menu-item></md-menu-content>\n</md-menu></div></div></div></div><div class=\"mv-24\"></div></div></div></div></div><div \nng-if=\"vm.timelineChapter.length|| $root.timelineQuestion.length ||$root.timelineQuiz.length||vm.timelineSlide.length\" \nstyle=\"padding-left: 23px;padding-right: 23px\"><horizontal-timeline ng-if=\"vm.timelineChapter.length\" \nstart-date=\"00:00:00\" end-date=\"{{vm.duree}}\" events=\"vm.timelineChapter\" type=\"chapter\"></horizontal-timeline><br \nng-if=\"vm.timelineChapter.length\"><horizontal-timeline ng-if=\"$root.timelineQuestion.length\" start-date=\"00:00:00\" \nend-date=\"{{vm.duree}}\" events=\"$root.timelineQuestion\" type=\"question\"></horizontal-timeline><br \nng-if=\"$root.timelineQuestion.length\"><horizontal-timeline ng-if=\"$root.timelineQuiz.length\" start-date=\"00:00:00\" \nend-date=\"{{vm.duree}}\" events=\"$root.timelineQuiz\" type=\"quiz\"></horizontal-timeline><br \nng-if=\"$root.timelineQuiz.length\"><horizontal-timeline ng-if=\"vm.timelineSlide.length\" start-date=\"00:00:00\" \nend-date=\"{{vm.duree}}\" events=\"vm.timelineSlide\" type=\"slide\"></horizontal-timeline></div><div \nstyle=\"padding-left: 12px;padding-right: 12px\" ng-if=\"vm.chapters.length||vm.slides.length\" class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget data-ng-style=\"vm.slides.length===0 && {\'max-width\': \'100%\'}\" \nng-class=\"{height: vm.showIndex === false}\" ng-if=\"vm.chapters.length\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom dashboard_panel_custom_height\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3 bold\" translate=\"MESSAGES.index\"></div><div><a ng-if=\"vm.showIndex\" \ntooltips tooltip-template=\"{{\'MESSAGES.reduce\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.reduceIndex(false)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"s18\">\n</md-icon></md-button></a><a ng-if=\"!vm.showIndex\" tooltips tooltip-template=\"{{\'MESSAGES.show\'|translate}}\" \ntooltip-side=\"left\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.reduceIndex(true)\" \naria-label=\"action_delete\" translate translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\" class=\"s18\"></md-icon></md-button></a></div></div><md-list \nng-if=\"vm.showIndex\" flex><div><form ng-model=\"vm.chapters\" name=\"vm.chaptersForm\" id=\"chaptersForm\" class=\"flex\" \nng-submit=\"chaptersForm.$valid && vm.save()\" novalidate=\"novalidate\"><ng-form ng-repeat=\"chapter in vm.chapters\" \nlayout=\"row\" ng-attr-name=\"vm.chaptersForm[$index]\" ng-class=\"chapter.theme\" style=\"cursor : pointer\" \nng-click=\"vm.updatePlayerTime(chapter.start)\"><div style=\"border-bottom: 1px solid #ededed\" class=\"pt-20\" \nlayout=\"column\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\" id=\"chapter-{{chapter.start.toSeconds()}}\">\n<div ng-if=\"chapter.type===\'quiz\'\" style=\"height: 88px;width: 5px;background: #f47bcb;margin-top: -18px\" \nlayout-align=\"center center\" layout=\"row\"></div><div ng-if=\"chapter.type===\'question\'\" \nstyle=\"height: 88px;width: 5px;background: #308dc2;margin-top: -18px\" layout-align=\"center center\" layout=\"row\"></div>\n<div ng-if=\"chapter.type===\'chapter\'\" style=\"height: 88px;width: 5px;background: #e93030;margin-top: -18px\" \nlayout-align=\"center center\" layout=\"row\"></div><span style=\"margin-left: 10px\" \ndata-ng-style=\"chapter.type===\'quiz\'&&  {\'width\': \'64px\'}\" translate=\"MESSAGES.{{chapter.type}}\"></span>\n<md-input-container style=\"max-width: 100%;padding-right: 3%\" flex=\"100\" flex-gt-xs=\"30\"><label \ntranslate=\"MESSAGES.start_time\">start_time</label><input class=\"md-light-green-50-bg\" name=\"start\" \nng-model=\"chapter.start\" ng-attr-data-duration=\"{{vm.vidDuration}}\" required ui-mask=\"99:99:99\" \nng-change=\"vm.detectChapterStartError(chapter)\"><div ng-messages=\"chaptersForm[$index].start.$error\" role=\"alert\"><div \nng-message=\"required\" ng-style=\"vm.chaptersFieldForm[$index].start.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \nng-style=\"vm.chaptersFieldForm[$index].start.$invalid?vm.errorStyle:{}\" translate=\"MESSAGES.invalid_time_format\">\ninvalid_time_format</div></div></md-input-container><a ng-if=\"chapter.type===\'question\'\" tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.editQuestion(chapter.start)\" aria-label=\"action_edit\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a ng-if=\"chapter.type===\'quiz\'\" tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" \ntooltip-side=\"left\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.editQuiz(chapter.start)\" \naria-label=\"action_edit\" translate translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></a><md-input-container \nstyle=\"max-width: 100%;padding-right: 3%\" ng-if=\"chapter.type===\'chapter\'\" flex=\"100\" flex-gt-xs=\"30\"><label \ntranslate=\"VIDEORICHMEDIA.content_chapter\">Content</label><textarea required ng-model=\"chapter.title\" \nmd-maxlength=\"650\" rows=\"1\" max-rows=\"2\" name=\"text\"></textarea></md-input-container><div layout-align=\"center center\" \nlayout=\"row\" class=\"ml-20 mr-20\"><a tooltips tooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" \ntooltip-side=\"left\" tooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button\" \nng-click=\"vm.deleteChapter(chapter)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></div></div></ng-form></form></div></md-list></ms-widget-front></ms-widget><ms-widget \ndata-ng-style=\"vm.chapters.length===0 && {\'max-width\': \'100%\'}\" ng-class=\"{height: vm.showSlide === false}\" \nng-if=\"vm.slides.length\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom dashboard_panel_custom_height\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3 bold\" translate=\"VIDEORICHMEDIA.video_rich_media_slide\"></div><div><a ng-if=\"vm.showSlide\" \nclass=\"md-icon-button\" tooltips tooltip-template=\"{{\'MESSAGES.reduce\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.reduceSlide(false)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-minus-circle-outline\" \nclass=\"s18\"></md-icon></md-button></a><a ng-if=\"!vm.showSlide\" tooltips \ntooltip-template=\"{{\'MESSAGES.show\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.reduceSlide(true)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-plus-circle-outline\" class=\"s18\">\n</md-icon></md-button></a></div></div><md-list ng-if=\"vm.showSlide\" flex><div><form ng-model=\"vm.slides\" \nname=\"vm.slidesForm\" id=\"slidesForm\" class=\"flex\" ng-submit=\"vm.save()\"><ng-form ng-repeat=\"slide in vm.slides\" \nlayout=\"row\" ng-attr-name=\"vm.slidesFieldForm[$index]\" ng-class=\"slide.theme\" style=\"cursor : pointer\" \nng-click=\"vm.updatePlayerTime(slide.start)\"><div style=\"border-bottom:  1px solid #ededed\" class=\"pt-10 pb-10\" \nlayout=\"column\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\" id=\"slide-{{slide.start.toSeconds()}}\"><div\n style=\"height: 116%;width: 5px;background: #32ba55;margin-top: 3px\" layout-align=\"center center\" layout=\"row\"></div>\n<div style=\"margin-left: -25px\" layout-align=\"start center\" layout=\"row\"><div ng-hide=\"slide.content.type === \'video\'\" \nstyle=\"padding-bottom: 13px\"><md-icon md-font-icon=\"icon-file-image\" class=\"s48\"></md-icon></div><div \nng-if=\"slide.content.type === \'video\'\" style=\"padding-bottom: 13px\"><md-icon md-font-icon=\"icon-file-video\" \nclass=\"s48\"></md-icon></div></div><md-input-container flex-gt-xs=\"30\" style=\"margin-top: 40px;padding-bottom: 0px\">\n<label translate=\"MESSAGES.start_time\">start_time</label><input class=\"md-light-green-50-bg\" name=\"slide\" \nng-model=\"slide.start\" ng-attr-data-duration=\"{{vm.vidDuration}}\" required ui-mask=\"99:99:99\" \nng-change=\"vm.detectSlideStartError(slide,$index)\"><div ng-messages=\"vm.slidesFieldForm[$index].start.$error\" \nrole=\"alert\"><div ng-message=\"required\" ng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \nng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" translate=\"MESSAGES.invalid_time_format\">\ninvalid_time_format</div></div></md-input-container><md-input-container><div ng-if=\"slide.content.thumbnail\" \nclass=\"media ml-16\" hide-xs layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{slide.content.thumbnail}}\" \nstyle=\"width: 100%;max-width:120px;height: 100%;max-height:80px\"></div></md-input-container><div \nlayout-align=\"end center\" layout=\"column\"><div layout-align=\"end center\" layout=\"row\"><div id=\"edit-image-uploader\" \nng-hide=\"slide.content.type === \'video\'\" flow-init=\"slide.ngFlowImageEditOptions\" \nflow-name=\"slide.ngFlowImageEdit.flow\" flow-files-submitted=\"vm.uploadFileEditImage(slide)\" \nflow-file-added=\"vm.fileImgEdit($file,slide)\" flow-file-progress=\"vm.fileEditProgress($file)\" \nflow-file-success=\"vm.fileEditSuccess(slide, $message)\" flow-complete=\"vm.uploadEditComplete()\"><div flow-btn \nclass=\"upload-button\"><a tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.editSlide($index)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button></a></div></div><div id=\"edit-video-uploader\" ng-if=\"slide.content.type === \'video\'\" \nflow-init=\"vm.ngFlowVideoEditOptions\" flow-name=\"vm.ngFlowEdit.flow\" flow-files-submitted=\"vm.uploadEditFile()\" \nflow-file-added=\"vm.fileVideoEdit($file)\" flow-file-progress=\"vm.fileEditProgress($file)\" \nflow-file-success=\"vm.fileEditSuccess(slide, $message)\" flow-complete=\"vm.uploadEditComplete()\"><div flow-btn \nclass=\"upload-button\"><a tooltips tooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button ng-click=\"vm.editSlide($index)\" class=\"md-icon-button\" aria-label=\"action_edit\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button></a></div></div><a tooltips tooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteSlide(slide)\" \naria-label=\"action_delete\" translate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></a></div><div layout-align=\"end center\" layout=\"row\"><a \nng-if=\"slide.content.type === \'video\' && slide.loop\" tooltips \ntooltip-template=\"{{\'MESSAGES.form_attr_unique\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.updateLoop(slide)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_attr_loop\"><md-icon md-font-icon=\"icon-repeat\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'MESSAGES.form_attr_loop\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button ng-if=\"slide.content.type === \'video\' && !slide.loop\" class=\"md-icon-button\" \nng-click=\"vm.updateLoop(slide)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_attr_loop\"><md-icon md-font-icon=\"icon-repeat-once\" class=\"s24\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'VIDEORICHMEDIA.preview_file\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.previewFile(slide)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.preview_file\"><md-icon md-font-icon=\"icon-eye\" class=\"s18\"></md-icon>\n</md-button></a></div></div></div></ng-form></form></div></md-list></ms-widget-front></ms-widget></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-warn\" translate=\"MESSAGES.form_cancel\" \nng-click=\"vm.returnToList()\">cancel</md-button><md-menu ng-if=\"vm.chapters.length|| vm.slides.length\"><md-button \nclass=\"md-raised md-warn\" ng-disabled=\"vm.chaptersForm.$invalid\" translate=\"MESSAGES.preview\" \nng-click=\"vm.previewRichMedia($mdOpenMenu,$event)\">previewRichMedia</md-button><md-menu-content width=\"3\" \nclass=\"md-menu-bar-menu md-dense md-default-theme\"><md-menu-item class=\"md-indent\" \nng-click=\"vm.chooseSkin(\'navigation\',$event)\"><md-icon md-font-icon=\"icon-palette\"></md-icon><md-button>Navigation\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" \nng-click=\"vm.chooseSkin(\'interactivity\',$event)\"><md-icon md-font-icon=\"icon-palette\"></md-icon><md-button>\nInteractivité</md-button></md-menu-item></md-menu-content></md-menu><md-button \nng-if=\"vm.chapters.length|| vm.slides.length\" type=\"submit\" class=\"md-accent md-raised\" \ntranslate=\"MESSAGES.form_step_validate\" ng-click=\"vm.submit()\" \nng-disabled=\"vm.chaptersForm.$invalid || vm.chaptersForm.$pristine\">submit</md-button></div></div>");
$templateCache.put("app/main/media/video/caption/caption.preview.simple.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.preview_file\" \ntranslate-values=\"{fileName: vm.fileName}\">File preview</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"no-padding\"><text-angular ta-disabled=\"true\" \nta-toolbar=\"vm.taToolbar\" ng-model=\"vm.fileContent\" class=\"pb-32\" md-colors=\"{background:\'primary\'}\"></text-angular>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.closeDialog()\" class=\"save-button md-accent md-raised\" aria-label=\"CLOSE\" \ntranslate=\"MESSAGES.alert_close\" translate-attr-aria-label=\"MESSAGES.alert_close\">CLOSE</md-button><md-button \nclass=\"md-raised\" ng-href=\"{{vm.getDownloadLink()}}\" target=\"_blank\" aria-label=\"Download File\" translate \ntranslate-attr-aria-label=\"MESSAGES.download_file\"><md-icon md-font-icon=\"icon-download\"></md-icon><span \ntranslate=\"VIDEOCAPTION.download\">Télécharger</span></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/caption/template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"fullpage\" layout=\"column\"><div ng-if=\"vm.playerIsLoading\" layout-align=\"center center\" layout=\"row\" \nclass=\"mv-24\"><md-progress-circular class=\"md-primary\" md-diameter=\"50\"></md-progress-circular><md-tooltip \nmd-autohide=\"true\" md-direction=\"bottom\">{{\'MESSAGES.loading_player\'|translate}}</md-tooltip></div><div \nng-if=\"vm.playerLink\"><div layout-align=\"center center\" layout=\"row\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" flex flex-xs=\"100\"><div layout=\"row\" layout-xs=\"column\"><div flex=\"45\" \nlayout=\"column\" layout-align=\"center center\"><iframe id=\"player\" width=\"600\" height=\"340\" ng-src=\"{{vm.playerLink}}\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; allowfullscreen=\"true\" \nwebkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe><div layout=\"row\" layout-align=\"center center\" \nlayout-xs=\"column\"><div flex=\"35\" layout-align=\"end end\" class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-file-error=\"vm.fileError($file, $message)\" flow-complete=\"vm.uploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"upload-button\" layout=\"column\" layout-align=\"end end\"><md-button class=\"md-accent md-raised\" flow-btn \ntranslate=\"MESSAGES.choose_a_file\" ng-disabled=\"vm.inProgress\">choose_a_file</md-button><md-button \nclass=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel\n</md-button></div></div><div style=\"margin-top: 15px\" layout-align=\"start start\" flex=\"65\"><span \nclass=\"secondary-text mt-8\" translate=\"MESSAGES.caption_upload_drop_message\">video_upload_drop_message</span><div \nlayout=\"row\" layout-align=\"start start\"><strong translate=\"MESSAGES.see_file_model\">see_file_model</strong></div><div \nclass=\"text-center\" layout=\"row\" layout-align=\"start start\"><ul ng-repeat=\"caption in ::vm.captionsModel\"><li><a \nng-click=\"vm.showCaptionSampleDialog(caption.name,$event)\" href=\"{{caption.link}}\" target=\"_blank\">{{caption.name}}</a>\n</li></ul></div></div></div><div layout=\"row\" layout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgress\"><div \nng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFile.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div><div flex=\"55\" layout=\"column\" layout-align=\"start start\"><div>\n<md-card-content flex><label translate=\"MESSAGES.select_language_caption\">Selectionnez la langue du sous-titrage\n</label><md-select style=\"margin-top: 5px\" ng-change=\"vm.getCaptionsByLanguage()\" translate \ntranslate=\"MESSAGES.form_attr_language\" name=\"language\" id=\"language\" ng-model=\"vm.selectedLanguage\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'|translate}}\"><md-option ng-repeat=\"languageChoice in vm.languageChoices\" \nng-value=\"languageChoice.val\" translate=\"LANGUAGES.Names.{{languageChoice.option}}\">{{languageChoice.option}}\n</md-option></md-select></md-card-content></div><div style=\"width: 100%;margin-top: -27px\" layout=\"row\" \nlayout-xs=\"column\"><div flex=\"90\"><md-input-container class=\"md-block\"><label \ntranslate=\"MESSAGES.form_attr_description\">Description</label><input id=\"myDIV\" ng-enter=\"vm.stopRecording($event)\" \nng-change=\"vm.change($event)\" ng-model=\"vm.description\"></md-input-container></div><div flex=\"10\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.add_caption\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nstyle=\"margin-top: 20px\" class=\"md-icon-button\" ng-click=\"vm.stopRecording($event)\"><md-icon style=\"color: #039be5\" \nmd-font-icon=\"icon-plus\"></md-icon></md-button></a></div></div><div id=\"my_div\" \nstyle=\"height: 288px;overflow: auto;width: 95%\" ng-if=\"vm.captions.length && !vm.populatingCaptions\"><form \nstyle=\"height: 288px;width: 95%\" ng-model=\"vm.captions\" name=\"vm.captionsForm\" id=\"captionsForm\" class=\"flex\" \nng-submit=\"vm.save()\"><ng-form ng-repeat=\"caption in vm.captions\" layout=\"row\" \nng-attr-name=\"vm.captionsFieldForm[$index]\" ng-style=\"{\'background-color\': caption.style}\"><div class=\"pt-20\" \nlayout=\"column\" layout-gt-xs=\"row\" flex><div layout-align=\"center center\" layout=\"row\" class=\"ml-20 mr-20\"><strong>\n{{caption.number}}</strong></div><md-input-container flex=\"100\" flex-gt-xs=\"30\" \nng-class=\"vm.captionsFieldForm[$index].start.$invalid ? \'md-input-invalid\':\'\'\"><label translate=\"MESSAGES.start_time\">\nstart_time</label><input class=\"md-light-green-50-bg\" name=\"start\" ng-model=\"caption.start\" \nng-pattern=\"/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/\" ng-attr-data-duration=\"{{vm.vidDuration}}\" \nis-superior-to-vid-duration is-superior-to-end-duration required ng-change=\"vm.detectCaptionDurationError()\"><div \nng-messages=\"vm.captionsFieldForm[$index].start.$error\" role=\"alert\"><div ng-message=\"required\" \nng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"pattern\" \nng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" translate=\"MESSAGES.invalid_time_format\">\ninvalid_time_format</div><div ng-message=\"isSuperiorToEndDuration\" \nng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.is_superior_to_end_duration\">is_superior_to_end_duration</div><div \nng-message=\"isSuperiorToVidDuration\" ng-style=\"vm.captionsFieldForm[$index].start.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.is_superior_to_video_duration\">is_superior_to_video_duration</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" \nng-class=\"vm.captionsFieldForm[$index].end.$invalid ? \'md-input-invalid\':\'\'\"><label translate=\"MESSAGES.end_time\">\nend_time</label><input class=\"md-red-50-bg\" name=\"end\" ng-model=\"caption.end\" \nng-pattern=\"/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/\" ng-attr-data-duration=\"{{vm.vidDuration}}\" \nis-superior-to-vid-duration is-inferior-to-start-duration required ng-change=\"vm.detectCaptionDurationError()\"><div \nng-messages=\"vm.captionsFieldForm[$index].end.$error\" role=\"alert\"><div ng-message=\"required\" \nng-style=\"vm.captionsFieldForm[$index].end.$invalid?vm.errorStyle:{}\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"pattern\" ng-style=\"vm.captionsFieldForm[$index].end.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.invalid_time_format\">invalid_time_format</div><div ng-message=\"isInferiorToStartDuration\" \nng-style=\"vm.captionsFieldForm[$index].end.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.is_inferior_to_start_duration\">is_inferior_to_start_duration</div><div \nng-message=\"isSuperiorToVidDuration\" ng-style=\"vm.captionsFieldForm[$index].end.$invalid?vm.errorStyle:{}\" \ntranslate=\"MESSAGES.is_superior_to_video_duration\">is_superior_to_video_duration</div></div></md-input-container>\n<md-input-container flex=\"100\" flex-gt-xs=\"30\" \nng-class=\"vm.captionsFieldForm[$index].text.$invalid ? \'md-input-invalid\':\'\'\"><label \ntranslate=\"VIDEOADD.form_attr_description\">form_attr_description</label><textarea ng-model=\"caption.text\" required \nmd-maxlength=\"650\" rows=\"1\" max-rows=\"2\" name=\"text\"></textarea><div \nng-messages=\"vm.captionsFieldForm[$index].text.$error\" role=\"alert\"><div \nng-style=\"vm.captionsFieldForm[$index].text.$invalid?vm.errorStyle:{}\" ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-style=\"vm.captionsFieldForm[$index].text.$invalid?vm.errorStyle:{}\" ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"650\">form_max_length</div></div></md-input-container><div \nlayout-align=\"center center\" layout=\"row\" class=\"ml-20 mr-20\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteCaption($index)\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-colors=\"{color:\'warn\'}\" md-font-icon=\"icon-close\" \nclass=\"s18\"></md-icon></md-button></a></div></div></ng-form></form></div></div></div></div></div></div></div><div \nlayout-align=\"center start mv-10\" layout=\"row\" ng-hide=\"vm.inProgress\"><md-button class=\"md-warn md-flat\" \nng-disabled=\"vm.inProgress\" ng-click=\"vm.returnToList()\" translate=\"MESSAGES.form_cancel\">form_cancel</md-button>\n<md-button class=\"md-primary md-hue-3 md-flat\" ng-click=\"vm.previewVideo(vm.video,$event,$index)\" \ntranslate=\"MESSAGES.preview_video\">preview_video</md-button><md-button class=\"md-accent md-raised\" \nng-disabled=\"vm.dropping ||  vm.captionsForm.$invalid \" ng-click=\"vm.save()\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><any translate=\"MESSAGES.form_validate\">form_validate</any></md-button></div></div>");
$templateCache.put("app/main/media/video/uploadAudio/uploadAudio.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"{{ \'VIDEOADD.upload_local\' |translate}}\" style=\"text-transform: none\"><md-content class=\"md-padding\"><div \nng-if=\"vm.uploadMetaDataError\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"center center\">\n<span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.alert_xhr_error\">alert_xhr_error\n</span></div></div></div><div class=\"mv-24\" ng-if=\"vm.uploadMetaDataError\"></div><div \nclass=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-progress=\"vm.fileProgress($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-button \nclass=\"md-accent md-raised\" flow-btn translate=\"MESSAGES.choose_a_file\" ng-disabled=\"vm.inProgress\">choose_a_file\n</md-button><md-button class=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" \nng-if=\"vm.inProgress\">form_cancel</md-button><span class=\"secondary-text mt-8 text-center text-truncate\" \ntranslate=\"MESSAGES.audio_upload_drop_message\">audio_upload_drop_message</span></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p \nclass=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFile.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></md-content></md-tab><md-tab \nlabel=\"{{ \'VIDEOADD.on_hold_list\' |translate}}\" style=\"text-transform: none\"><md-content class=\"md-padding\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"row\" layout-align=\"center center\" ng-if=\"vm.tree.length === 0\">\n<span class=\"title\" style=\"padding:1%\" translate=\"VIDEOADD.on_hold_empty\">on_hold_empty</span></div><div \nng-if=\"vm.tree.length > 0\" js-tree=\"treeConfig\" ng-model=\"vm.tree\" tree=\"vm.treeInstance\" style=\"padding-bottom: 60px\" \ntree-events-obj=\"treeEventsObj\"></div><md-button ng-if=\"vm.testData\" class=\"show-more-button md-raised\" \ntranslate=\"VIDEOADD.show_more\" ng-click=\"vm.showMore()\">show_more</md-button></md-content></md-tab></md-tabs></div>\n</div>");
$templateCache.put("app/main/media/video/list/add-language.modal.html","<md-dialog style=\"width: 600px\" class=\"video-url-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s24\"></md-icon><span translate=\"MESSAGES.add_language\"></span> </span><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div ng-if=\"vm.uploadMetaDataError\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"center center\"><span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.alert_xhr_error\">alert_xhr_error</span></div></div></div><div class=\"mv-24\" \nng-if=\"vm.uploadMetaDataError\"></div><div class=\"product-detail-form-container md-background-bg md-whiteframe-1dp\"><div\n class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn translate=\"MESSAGES.choose_a_file\" \nng-disabled=\"vm.inProgress\">choose_a_file</md-button><md-button class=\"md-warn md-flat\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel</md-button><span \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.video_upload_drop_message\">\nvideo_upload_drop_message</span></div><div layout=\"row\" layout-align=\"center center\" layout-wrap \nng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>\n{{vm.videoFile.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div><div ng-if=\"vm.videoKeyName\"><span style=\"margin-left: 25%\">\n{{vm.videoKeyName}}</span></div></div></md-dialog-content><md-dialog-content ms-scroll><md-card-content \nstyle=\"width: 100%\" flex><md-select translate translate=\"MESSAGES.form_attr_language\" name=\"empEventForm[language][]\" \nid=\"empEventForm_language\" ng-model=\"vm.language\" ng-change=\"vm.selectLang()\" required=\"required\" \nplaceholder=\"{{ \'MESSAGES.form_attr_language\'|translate}}\"><md-option ng-repeat=\"languageChoice in vm.languageChoices\" \nng-value=\"languageChoice.val\"><any translate=\"LANGUAGES.Names.{{ languageChoice.option }}\">{{ languageChoice.option}}\n</any></md-option></md-select></md-card-content></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-around center\"><div><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" \ntranslate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button \nng-disabled=\"vm.language==\'\' || vm.videoKeyName==\'\' || vm.testLang  \" class=\"md-accent\" ng-click=\"vm.sendLanguage()\" \ntranslate=\"MESSAGES.send\">send</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/list/chronologie.modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.chronologie_video\">\nchronologie_video</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><md-dialog-content class=\"no-padding\" aria-label=\"a\"><div \nng-if=\"vm.spinner\"><section id=\"Steps\" class=\"steps-section\"><div class=\"steps-timeline\"><div \nng-repeat=\"etape in vm.jsonList\" class=\"steps\"><img ng-if=\"etape.date\" class=\"steps-img\" \nsrc=\"assets/images/logos/blue.png\" alt=\"\"> <img ng-if=\"!etape.date\" class=\"steps-img\" \nsrc=\"assets/images/logos/gray.png\" ng-disabled=\"true\" alt=\"\"><h2 style=\"margin-top: -37px;color: white\">\n{{vm.jsonList.indexOf(etape)+1}}</h2><h6 ng-if=\"!etape.date\" class=\"steps-name\" \ntranslate=\"VIDEOCHRONOLOGY.{{etape.title}}\" style=\"font-size: large\" ng-disabled=\"true\">{{etape.title}}</h6><h6 \nng-if=\"etape.date\" class=\"steps-name\" translate=\"VIDEOCHRONOLOGY.{{etape.title}}\" style=\"font-size: large\">\n{{etape.title}}</h6><p ng-if=\"etape.date\" class=\"steps-description\">{{ etape.date }}</p><p ng-if=\"!etape.date\" \nclass=\"steps-description\" translate=\"VIDEOCHRONOLOGY.in_progress\" ng-disabled=\"true\">in_progress</p><p \nclass=\"steps-description\">{{etape.description}}</p></div></div></section></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" style=\"padding-top: 50px\"><span flex></span><md-button \nclass=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/media/video/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div ng-style=\"vm.myStyles\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column md-whiteframe-4dp flex\"><div \nng-style=\"vm.myStyles\" style=\"overflow: hidden\" layout=\"row\" layout-wrap><iframe id=\"iframe_list\" \nng-src=\"{{vm.urlVideoList}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\">\n</iframe><md-card-actions style=\"height: 40px\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" class=\"title\" \nlayout-align=\"start center\" flex><md-sidenav style=\"z-index: 11111\" md-component-id=\"right\" class=\"md-sidenav-right\" \nng-include=\"\'app/main/media/video/list/sidenav/details-sidenav.html\'\"></md-sidenav></div></md-card-actions></div></div>\n</div></div>");
$templateCache.put("app/main/media/video/list/modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"Video Detail\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools md-toolbar-tools--metadata\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title title--metadata\" style=\"white-space: nowrap\" title=\"{{vm.title | json}}\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.meta_data_of_video\">\nMetadata of the video : </span><span>{{vm.title | json}}</span></span><md-button \nclass=\"md-icon-button md-icon-button--metadata\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear>\n<md-dialog-content><div ng-if=\"vm.spinner\"><md-list flex ng-if=\"vm.hasMetaData()\"><md-list-item ng-if=\"vm.other()\" \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong>Id</strong></h3></div><div class=\"md-secondary\">\n{{vm.metaData.other.id}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_video_bitrate\"></strong></h3></div><div \nclass=\"md-secondary\">{{vm.detailMetaData.video.bitrate}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_resolution\"></strong></h3>\n</div><div class=\"md-secondary\">{{vm.detailMetaData.video.resolution}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_size\">\n</strong></h3></div><div class=\"md-secondary\">{{vm.detailMetaData.video.size}}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"MESSAGES.meta_data_duration\"></strong></h3></div><div class=\"md-secondary\">\n{{vm.detailMetaData.video.duration}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_framerate\"></strong></h3></div><div \nclass=\"md-secondary\">{{vm.detailMetaData.video.framerate}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_video_codec\"></strong></h3>\n</div><div class=\"md-secondary\">{{vm.detailMetaData.video.codec}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"MESSAGES.meta_data_samplerate\">\n</strong></h3></div><div class=\"md-secondary\">\n{{vm.detailMetaData.audio.samplerate?vm.detailMetaData.audio.samplerate:\'-\'}}</div><md-divider></md-divider>\n</md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"MESSAGES.meta_data_audio_Codec\"></strong></h3></div><div class=\"md-secondary\">\n{{vm.detailMetaData.audio.codec?vm.detailMetaData.audio.codec:\'-\'}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"MESSAGES.meta_data_audio_bitrate\"></strong></h3></div><div class=\"md-secondary\">\n{{vm.detailMetaData.audio.bitrate?vm.detailMetaData.audio.bitrate:\'-\'}}</div></md-list-item></md-list><h2 \nng-if=\"!vm.hasMetaData()\" layout=\"row\" layout-align=\"center center\" translate=\"MESSAGES.vid_has_no_meta_data\"></h2>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><span flex></span>\n<md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/list/montage.modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" style=\"height: 100%;width: 40%\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.video_preview\">\nPreview of the video</span> <span>:{{vm.video.title | json}}</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear>\n<md-dialog-content style=\"height: 100%;width: 100%\" class=\"no-padding\"><div \nstyle=\"text-align: center;\n    padding: 1em;\n    box-sizing: border-box;\n     position: relative;\n    height: 100%;\n    width: 100%;\n    padding-top: 56.25%;\n    overflow: hidden\">\n<div ng-if=\"vm.spinner\"><preview-video id=\"fid\" event=\"vm.event\" params=\"vm.params\" diffusion=\"\'internet\'\" \nhandler=\"vm\"></preview-video></div></div></md-dialog-content><md-dialog-actions style=\"padding-top: 20px\"><div \nmulti-slider floor=\"0\" ceiling=\"{{vm.duree}}\" step=\"1\" precision=\"2\" bubbles=\"false\" ng-model=\"vm.addSlider\"></div>\n</md-dialog-actions><md-dialog-actions layout=\"column\" style=\"padding-top: 20px\"><div layout=\"row\" \nlayout-align=\"space-around center\" flex><md-input-container flex=\"35\"><label translate=\"VIDEOMONTAGE.startMedia\">\nstartMedia</label><input type=\"text\" required=\"required\" ng-attr-name=\"title\" translate=\"\" ng-model=\"vm.start\" \naria-invalid=\"true\" ui-mask=\"99:99:99\" ng-keypress=\"vm.clickStartInput($event)\"></md-input-container>\n<md-input-container flex=\"35\"><label translate=\"VIDEOMONTAGE.endMedia\">endMedia</label><input type=\"text\" \nrequired=\"required\" ng-attr-name=\"title\" translate=\"\" ng-model=\"vm.end\" aria-invalid=\"true\" ui-mask=\"99:99:99\" \nng-keypress=\"vm.clickEndInput($event)\"></md-input-container></div><div ng-if=\"vm.testStartEndMedia==false\"><span \nstyle=\"color: red\" translate=\"MESSAGES.alert_check_values\">alert_check_values</span></div></md-dialog-actions>\n<md-dialog-actions layout=\"row\" layout-align=\"center center\" flex><md-checkbox ng-model=\"vm.newVideo\"><label \ntranslate=\"VIDEOMONTAGE.new_video\">new_video</label></md-checkbox></md-dialog-actions><md-dialog-actions layout=\"row\" \nlayout-align=\"space-around center\"><div><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" \ntranslate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button \nng-disabled=\"vm.testStartEndMedia==false || vm.link_exist === false\" class=\"md-accent\" ng-click=\"vm.sendMontage()\" \ntranslate=\"MESSAGES.send\">send</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/list/montage.player.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" style=\"height: max-content;width: 80%\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.video_preview\">\nPreview of the video</span> <span>:{{vm.video.title | json}}</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"height: max-content;width: 100%\" ms-scroll class=\"no-padding\"><preview-video \nid=\"fid\" event=\"vm.event\" params=\"vm.params\" diffusion=\"\'internet\'\" handler=\"vm\"></preview-video></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/media/video/list/preview.modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"MESSAGES.video_preview\">\nPreview of the video</span> <span>:{{vm.video.title | json}}</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content class=\"no-padding\"><div style=\"\" layout=\"row\" layout-align=\"center center\" \nclass=\"mv-24\"><iframe width=\"800\" height=\"500\" ng-src=\"{{vm.trustLink(vm.link)}}\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; allowfullscreen=\"true\" \nwebkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/video/list/url.modale.template.html","<md-dialog class=\"video-url-dialog video-link-export-dialog\" aria-label=\"Video Detail\" \nstyle=\"overflow: hidden;width: 70%; max-height: 100%\"><md-toolbar class=\"md-accent socialNetwork\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"MESSAGES.title_modal_url\"></span> <span>\n{{vm.title | json}}</span> </span><span flex></span> <span class=\"fontSize\" \ndata-ng-style=\"vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.isIntranet_Internet===\'1\'\">Intranet\n</span><md-switch ng-if=\"vm.isIntranet_Internet===\'1\'\" id=\"switch-intra-inter\" \nng-disabled=\"!vm.video.isVisibleOnInternet || !vm.video.isVisibleOnIntranet \" \ndata-ng-style=\"!vm.video.isVisibleOnInternet || !vm.video.isVisibleOnIntranet && {\'opacity\':\'0.6\'}\" \nstyle=\"margin-left: 16px;margin-right: 5px\" class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"vm.intranet\" ng-change=\"vm.changeIntraInter()\"></md-switch><span class=\"fontSize\" \ndata-ng-style=\"!vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.isIntranet_Internet===\'1\'\">Internet\n</span><md-button style=\"margin-right: 10px\" class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-toolbar class=\"md-accent socialNetworkMobile\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-link-variant\" class=\"s24\"></md-icon><span translate=\"MESSAGES.title_modal_url\"></span> <span>\n{{vm.title | json}}</span> </span><span flex></span><md-button style=\"margin-right: 10px\" class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><md-dialog-content style=\"padding-top: 0!important\" \nng-if=\"vm.isIntranet_Internet===\'1\'\" layout=\"column\" ms-scroll><div class=\"socialNetworkMobile\" \nstyle=\"margin-bottom: 9px; justify-content: flex-end\" layout-align=\"space-between center flex \"><span class=\"fontSize\" \ndata-ng-style=\"vm.intranet && {\'color\':\'rgba(0, 0, 0, 0.3)\'}\" ng-if=\"vm.isIntranet_Internet===\'1\'\">Intranet</span>\n<md-switch ng-if=\"vm.isIntranet_Internet===\'1\'\" id=\"switch-intra-inter\" \nng-disabled=\"!vm.video.isVisibleOnInternet || !vm.video.isVisibleOnIntranet \" \ndata-ng-style=\"!vm.video.isVisibleOnInternet || !vm.video.isVisibleOnIntranet && {\'opacity\':\'0.6\'}\" \nstyle=\"margin-left: 16px;margin-right: 5px\" class=\"md-primary\" md-no-ink aria-label=\"Switch No Ink\" \nng-model=\"vm.intranet\" ng-change=\"vm.changeIntraInter()\"></md-switch><span class=\"fontSize\" \ndata-ng-style=\"!vm.intranet && {\'color\':\'rgba(255, 255, 255, 0.3)\'}\" ng-if=\"vm.isIntranet_Internet===\'1\'\">Internet\n</span></div><div ng-if=\"!vm.intranet && !vm.isChannelExport\" style=\"width: 100%\" layout=\"row\"><div \nstyle=\"padding-top: 15px\" ng-if=\"vm.spinner\" flex=\"95\"><div has-permission=\"media_video_options_embed_no_api\">\n<md-checkbox class=\"check-item\" ng-model=\"vm.autoplay\" ng-change=\"vm.checkOptionIntranetFunction(vm.autoplay, \'a\')\" \naria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.sendMail\" \nng-change=\"vm.checkOptionIntranetFunction(vm.sendMail, \'mail\')\" aria-label=\"Send mail\">Send mail</md-checkbox>\n<md-checkbox class=\"check-item\" ng-model=\"vm.facebook\" ng-change=\"vm.checkOptionIntranetFunction(vm.facebook, \'fb\')\" \naria-label=\"Facebook\">Facebook</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.twitter\" \nng-change=\"vm.checkOptionIntranetFunction(vm.twitter, \'tw\')\" aria-label=\"Twitter\">Twitter</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.linkedin\" ng-change=\"vm.checkOptionIntranetFunction(vm.linkedin, \'lk\')\" \naria-label=\"Linkedin\">Linkedin</md-checkbox><md-checkbox class=\"check-item\" ng-if=\"vm.intranet\" ng-model=\"vm.cdn_web\" \nng-change=\"vm.checkOptionCDNIntranetFunction()\" aria-label=\"CDN Web\">Cdn Web</md-checkbox></div><div \nhas-permission=\"media_video_uid_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>\n{{vm.video.id_title}}</strong></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo1\">\n{{vm.video.id}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo1\" \naria-label=\"url_copy\" ng-click=\"vm.copied =0\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==0\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===0\" ng-class=\"{\'md-icon-copied\': vm.copied ===0}\" ng-if=\"vm.copied ===0\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_mp4_embed_no_api\" layout=\"row\" \nclass=\"row_url layout-column-specific\" layout-xs=\"column\" \nng-if=\"vm.video.videos_mp4.length && ($first || vm.show_more_mp4===\'max\')\" ng-repeat=\"mp4 in ::vm.video.videos_mp4\">\n<div flex=\"30\"><strong ng-if=\"$first\">mp4</strong><md-icon md-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'min\'\" ng-click=\"vm.show_more_mp4=\'max\'\">\n</md-icon><md-icon md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'max\'\" ng-click=\"vm.show_more_mp4=\'min\'\">\n</md-icon></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo28_{{$index}}\">{{mp4.src}}</div>\n<md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo28_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =55+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==55+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===55+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===55+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===55+$index}\" \nng-if=\"vm.copied ===55+$index\" style=\"top: 7px\"></md-checkbox></md-button></div></div><div \nhas-permission=\"media_video_progressif_download_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.video.link_progressive_download\"><div flex=\"30\"><strong translate=\"MESSAGES.progressive_download\"></strong>\n</div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo3\">\n{{vm.video.link_progressive_download_intranet}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo3\" aria-label=\"url_copy\" ng-click=\"vm.copied =156\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==156\" ng-class=\"{\'md-icon-copied\': vm.copied ===156}\"></md-icon><md-checkbox \nclass=\"s18\" ng-checked=\"vm.copied ===156\" ng-class=\"{\'md-icon-copied\': vm.copied ===156}\" ng-if=\"vm.copied ===156\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.video.link_ogg\"><div flex=\"30\"><strong>OGV</strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo4\">{{vm.video.link_ogg_intranet}}</div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo4\" aria-label=\"url_copy\" ng-click=\"vm.copied =54\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==54\" ng-class=\"{\'md-icon-copied\': vm.copied ===54}\">\n</md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===54\" ng-class=\"{\'md-icon-copied\': vm.copied ===54}\" \nng-if=\"vm.copied ===54\" style=\"top: 7px\"></md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.video.link_webm\"><div flex=\"30\"><strong>Webm</strong></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo5\">{{vm.video.link_webm_intranet}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo5\" aria-label=\"url_copy\" ng-click=\"vm.copied =53\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==53\" \nng-class=\"{\'md-icon-copied\': vm.copied ===53}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===53\" \nng-class=\"{\'md-icon-copied\': vm.copied ===53}\" ng-if=\"vm.copied ===53\" style=\"top: 7px\"></md-checkbox></md-button>\n</div></div><div has-permission=\"media_video_permalien_embed_no_api\" layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.link_permalien\"><div flex=\"30\"><strong translate=\"MESSAGES.permalien\"></strong></div><div layout=\"row\" flex>\n<div flex=\"100\" style=\"padding-top: 14px\" id=\"fo6\">{{vm.link_permalien_intranet}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo6\" aria-label=\"url_copy\" ng-click=\"vm.copied =3\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==3\" \nng-class=\"{\'md-icon-copied\': vm.copied ===3}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===3\" \nng-class=\"{\'md-icon-copied\': vm.copied ===3}\" ng-if=\"vm.copied ===3\" style=\"top: 7px\"></md-checkbox></md-button></div>\n</div><div has-permission=\"media_video_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.link_embed_intranet\" style=\"margin: 0\"><div flex=\"30\"><strong>Embed</strong></div><div layout=\"row\" flex><div\n flex=\"100\" style=\"padding-top: 14px\" id=\"fo7\">{{vm.link_embed_intranet}}</div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo7\" aria-label=\"url_copy\" ng-click=\"vm.copied =7\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==7\" ng-class=\"{\'md-icon-copied\': vm.copied ===7}\">\n</md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===7\" ng-class=\"{\'md-icon-copied\': vm.copied ===7}\" \nng-if=\"vm.copied ===7\" style=\"top: 7px\"></md-checkbox></md-button></div></div><div style=\"margin: 0\" \nclass=\"row_url socialNetwork\" layout=\"row\" layout-xs=\"column\" has-permission=\"media_video_embed_code_no_api\" \nng-if=\"vm.link_embed_intranet\"><div flex=\"30\"><strong>Code Embed</strong></div><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo8\"><md-input-container><textarea aria-label=\"Code Embed\"><iframe \nstyle=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed_intanet}}\" allowfullscreen frameborder=\"0\"></iframe>\n                                </textarea>\n</md-input-container></div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo8\" \naria-label=\"url_copy\" ng-click=\"vm.copied =8\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==8\" ng-class=\"{\'md-icon-copied\': vm.copied ===8}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===8\" ng-class=\"{\'md-icon-copied\': vm.copied ===8}\" ng-if=\"vm.copied ===8\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetworkMobile\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\">\n<md-fab-speed-dial md-open=\"vm.socialNetwork\" md-direction=\"up\" class=\"md-scale menuIcon\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-warn menuButton\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a>\n</md-fab-actions></md-fab-speed-dial></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetwork\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\"><div \nstyle=\"text-align: right\"><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a></div></div>\n</div><div ng-if=\"!vm.intranet && vm.isChannelExport\" style=\"width: 100%\" layout=\"row\" class=\"export_vod\"><md-tabs \nmd-dynamic-height md-border-bottom md-no-ink md-selected=\"$root.index\" style=\"width: 100%\"><md-tab \nng-repeat=\"(key,item) in vm.link_permalien_intranet\" ng-click=\"vm.getCopie()\"><md-tab-label><div><span \nstyle=\"text-transform: none\">{{key}}</span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\" \nlayout=\"row\" layout-xs=\"column\"><div style=\"padding-top: 15px\" ng-if=\"vm.spinner\" flex=\"95\"><div \nhas-permission=\"media_video_options_embed_no_api\"><md-checkbox class=\"check-item\" ng-model=\"vm.autoplay\" \nng-change=\"vm.checkOptionIntranetFunction(vm.autoplay, \'a\')\" aria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.sendMail\" ng-change=\"vm.checkOptionIntranetFunction(vm.sendMail, \'mail\')\" \naria-label=\"Send mail\">Send mail</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.facebook\" \nng-change=\"vm.checkOptionIntranetFunction(vm.facebook, \'fb\')\" aria-label=\"Facebook\">Facebook</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.twitter\" ng-change=\"vm.checkOptionIntranetFunction(vm.twitter, \'tw\')\" \naria-label=\"Twitter\">Twitter</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.linkedin\" \nng-change=\"vm.checkOptionIntranetFunction(vm.linkedin, \'lk\')\" aria-label=\"Linkedin\">Linkedin</md-checkbox><md-checkbox \nclass=\"check-item\" ng-if=\"vm.intranet\" ng-model=\"vm.cdn_web\" ng-change=\"vm.checkOptionCDNIntranetFunction()\" \naria-label=\"CDN Web\">Cdn Web</md-checkbox></div><div has-permission=\"media_video_uid_embed_no_api\" class=\"row_url\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>{{vm.video.id_title}}</strong></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo1_{{$index}}\">{{vm.video.id}}</div><md-button class=\"btn md-icon-button\" \nngclipboard data-clipboard-target=\"#fo1_{{$index}}\" aria-label=\"url_copy\" ng-click=\"vm.copied =0+$index\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==0+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===0+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===0+$index}\" ng-if=\"vm.copied ===0+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div has-permission=\"media_video_mp4_embed_no_api\" layout=\"row\" \nclass=\"row_url layout-column-specific\" layout-xs=\"column\" \nng-if=\"vm.video.videos_mp4.length && ($first || vm.show_more_mp4===\'max\')\" ng-repeat=\"mp4 in ::vm.video.videos_mp4\">\n<div flex=\"30\"><strong ng-if=\"$first\">mp4</strong><md-icon md-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'min\'\" ng-click=\"vm.show_more_mp4=\'max\'\">\n</md-icon><md-icon md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'max\'\" ng-click=\"vm.show_more_mp4=\'min\'\">\n</md-icon></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" \nid=\"fo28_{{$index+\'_\'+$parent.$parent.$index}}\">{{mp4.src}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo28_{{$index+\'_\'+$parent.$parent.$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied = 55+$parent.$parent.$index+$index*2\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===55+$parent.$parent.$parent.$index+$index*2}\"></md-icon></md-button></div>\n</div><div has-permission=\"media_video_progressif_download_embed_no_api\" class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.video.link_progressive_download\"><div flex=\"30\"><strong \ntranslate=\"MESSAGES.progressive_download\"></strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo3_{{$index}}\">{{vm.video.link_progressive_download_intranet}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo3_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =76+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===76+$index}\"></md-icon></md-button></div></div><div layout=\"row\" \nclass=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.link_ogg\"><div flex=\"30\"><strong>OGV</strong></div><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo4_{{$index}}\">{{vm.video.link_ogg_intranet}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo4_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =54+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===54+$index}\"></md-icon></md-button></div><div layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.video.link_webm\"><div flex=\"30\"><strong>Webm</strong></div><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo5_{{$index}}\">{{vm.video.link_webm_intranet}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo5_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =53+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===53+$index}\"></md-icon></md-button></div><div \nhas-permission=\"media_video_permalien_embed_no_api\" layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.link_permalien\"><div flex=\"30\"><strong translate=\"MESSAGES.permalien\"></strong><br><span class=\"canal_span\">\n{{key}}</span></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo6_{{$index}}\" class=\"title\">\n{{item}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo6_{{$index}}\" \naria-label=\"url_copy\" ng-click=\"vm.copied =3+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===3+$index}\"></md-icon></md-button></div></div><div \nhas-permission=\"media_video_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\" ng-if=\"vm.link_embed\" \nstyle=\"margin: 0\"><div flex=\"30\"><strong>Embed</strong><br><span class=\"canal_span\">{{key}}</span></div><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo7_{{$index}}\">{{vm.link_embed_intranet[key]}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo7_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =93+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===93+$index}\"></md-icon></md-button></div><div style=\"margin: 0\" \nclass=\"row_url\" layout=\"row\" layout-xs=\"column\" has-permission=\"media_video_embed_no_api\" ng-if=\"vm.link_embed\" \nclass=\"socialNetwork\"><div flex=\"30\"><strong>Code Embed</strong><br><span class=\"canal_span\">{{key}}</span></div><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo8_{{$index}}\"><md-input-container><textarea aria-label=\"Code Embed\"><iframe \nstyle=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed_intranet[key]}}\" allowfullscreen frameborder=\"0\"></iframe>\n      </textarea></md-input-container>\n</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo8_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =84+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied ===84+$index}\"></md-icon></md-button></div></div><div \nhas-permission=\"media_video_social_network_embed_no_api\" class=\"social_network_export socialNetworkMobile\" \nlayout=\"column\" flex=\"5\" layout-align=\"space-around center\"><md-fab-speed-dial md-open=\"vm.socialNetwork\" \nmd-direction=\"up\" class=\"md-scale menuIcon\"><md-fab-trigger><md-button aria-label=\"menu\" \nclass=\"md-fab md-warn menuButton\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18\"></md-icon></md-button>\n</md-fab-trigger><md-fab-actions><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a>\n</md-fab-actions></md-fab-speed-dial></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetwork\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\"><div \nstyle=\"text-align: right\"><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a></div></div>\n</md-content></md-tab-body></md-tab></md-tabs></div><div ng-if=\"vm.intranet && !vm.isChannelExport\" \nstyle=\"width: 100%\" layout=\"row\"><div style=\"padding-top: 15px\" ng-if=\"vm.spinner\" flex=\"95\"><div \nhas-permission=\"media_video_options_embed_no_api\"><md-checkbox class=\"check-item\" ng-model=\"vm.autoplay\" \nng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" aria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.sendMail\" ng-change=\"vm.checkOptionFunction(vm.sendMail, \'mail\')\" \naria-label=\"Send mail\">Send mail</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.facebook\" \nng-change=\"vm.checkOptionFunction(vm.facebook, \'fb\')\" aria-label=\"Facebook\">Facebook</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.twitter\" ng-change=\"vm.checkOptionFunction(vm.twitter, \'tw\')\" aria-label=\"Twitter\">\nTwitter</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.linkedin\" \nng-change=\"vm.checkOptionFunction(vm.linkedin, \'lk\')\" aria-label=\"Linkedin\">Linkedin</md-checkbox><md-checkbox \nclass=\"check-item\" ng-if=\"vm.intranet\" ng-model=\"vm.cdn_web\" ng-change=\"vm.checkOptionCDNFunction()\" \naria-label=\"CDN Web\">Cdn Web</md-checkbox></div><div has-permission=\"media_video_uid_embed_no_api\" class=\"row_url\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>{{vm.video.id_title}}</strong></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo9\">{{vm.video.id}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo9\" aria-label=\"url_copy\" ng-click=\"vm.copied =777\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==777\" ng-class=\"{\'md-icon-copied\': vm.copied ===777}\"></md-icon><md-checkbox \nclass=\"s18\" ng-checked=\"vm.copied ===777\" ng-class=\"{\'md-icon-copied\': vm.copied ===777}\" ng-if=\"vm.copied ===777\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div has-permission=\"media_video_mp4_embed_no_api\" layout=\"row\" \nclass=\"row_url layout-column-specific\" layout-xs=\"column\" \nng-if=\"vm.video.videos_mp4.length && ($first || vm.show_more_mp4===\'max\')\" ng-repeat=\"mp4 in ::vm.video.videos_mp4\">\n<div flex=\"30\"><strong ng-if=\"$first\">mp4</strong><md-icon md-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'min\'\" ng-click=\"vm.show_more_mp4=\'max\'\">\n</md-icon><md-icon md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'max\'\" ng-click=\"vm.show_more_mp4=\'min\'\">\n</md-icon></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" id=\"{{\'fo105\'+$index}}\">{{mp4.src}}</div>\n<md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"{{\'#fo105\'+$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied = 6+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-class=\"{\'md-icon-copied\': vm.copied === 6+$index}\"></md-icon></md-button></div></div><div \nhas-permission=\"media_video_progressif_download_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.video.link_progressive_download\"><div flex=\"30\"><strong translate=\"MESSAGES.progressive_download\"></strong>\n</div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo11\" class=\"title\">\n{{vm.video.link_progressive_download}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo11\" aria-label=\"url_copy\" ng-click=\"vm.copied =5\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==5\" ng-class=\"{\'md-icon-copied\': vm.copied ===5}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===5\" ng-class=\"{\'md-icon-copied\': vm.copied ===5}\" ng-if=\"vm.copied ===5\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.link_ogg\">\n<div flex=\"30\"><strong>OGV</strong></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo12\" \nclass=\"title\">{{vm.video.link_ogg}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo12\" aria-label=\"url_copy\" ng-click=\"vm.copied =4\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==4\" ng-class=\"{\'md-icon-copied\': vm.copied ===4}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===4\" ng-class=\"{\'md-icon-copied\': vm.copied ===4}\" ng-if=\"vm.copied ===4\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.link_webm\">\n<div flex=\"30\"><strong>Webm</strong></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo13\" \nclass=\"title\">{{vm.video.link_webm}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo13\" aria-label=\"url_copy\" ng-click=\"vm.copied =3\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==4\" ng-class=\"{\'md-icon-copied\': vm.copied ===4}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===4\" ng-class=\"{\'md-icon-copied\': vm.copied ===4}\" ng-if=\"vm.copied ===4\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_permalien_embed_no_api\" layout=\"row\" \nclass=\"row_url\" layout-xs=\"column\" ng-if=\"vm.link_permalien\"><div flex=\"30\"><strong translate=\"MESSAGES.permalien\">\n</strong></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo14\" class=\"title\">\n{{vm.link_permalien}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo14\" \naria-label=\"url_copy\" ng-click=\"vm.copied =2\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==2\" ng-class=\"{\'md-icon-copied\': vm.copied ===2}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===2\" ng-class=\"{\'md-icon-copied\': vm.copied ===2}\" ng-if=\"vm.copied ===2\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_embed_no_api\" layout=\"column\" \nlayout-xs=\"column\" ng-class=\"{\'row_url\' : vm.show_more_embed ===\'min\' }\" ng-if=\"vm.link_embed\"><div flex=\"30\" \nng-if=\"!vm.link_embed_simple\"><strong>Embed</strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo40\" ng-if=\"!vm.link_embed_simple\" class=\"title\">{{vm.link_embed}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo40\" aria-label=\"url_copy\" ng-click=\"vm.copied =40\" \nng-if=\"!vm.link_embed_simple\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==40\" \nng-class=\"{\'md-icon-copied\': vm.copied ===40}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===40\" \nng-class=\"{\'md-icon-copied\': vm.copied ===40}\" ng-if=\"vm.copied ===40\" style=\"top: 7px\"></md-checkbox></md-button>\n</div><div layout=\"column\" layout-xs=\"column\" flex=\"15\" ng-if=\"vm.link_embed_simple\"><div layout=\"row\"><strong>Embed\n</strong><md-icon style=\"margin: 0\" md-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"vm.link_embed_simple && vm.show_more_embed ===\'min\'\" ng-click=\"vm.show_more_embed=\'max\'\"></md-icon><md-icon \nstyle=\"margin: 0\" md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"vm.link_embed_simple && vm.show_more_embed ===\'max\'\" ng-click=\"vm.show_more_embed=\'min\'\"></md-icon></div></div>\n<div layout=\"row\" layout-xs=\"column\" flex=\"100\" ng-if=\"vm.link_embed_simple\" class=\"title\" style=\"margin: 0\"><div \nflex=\"30\"><label style=\"font-weight: bold;font-size: 13px\">Simple</label></div><div layout=\"row\" flex><div flex=\"100\" \nid=\"fo41\" class=\"title\">{{vm.link_embed_simple}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo41\" aria-label=\"url_copy\" ng-click=\"vm.copied =41\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==41\" ng-class=\"{\'md-icon-copied\': vm.copied ===41}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===41\" ng-class=\"{\'md-icon-copied\': vm.copied ===41}\" ng-if=\"vm.copied ===41\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div></div><div has-permission=\"media_video_embed_no_api\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.link_embed && vm.show_more_embed ===\'max\'\"><div layout=\"column\" layout-xs=\"column\" \nflex=\"15\" ng-if=\"vm.link_embed_simple\"></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\" \nng-if=\"vm.link_embed_richmedia\"><div flex=\"30\"><label style=\"font-weight: bold;font-size: 13px\">Richmedia</label></div>\n<div layout=\"row\" flex><div flex=\"100\" id=\"fo42\" class=\"title\">{{vm.link_embed_richmedia}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo42\" aria-label=\"url_copy\" ng-click=\"vm.copied =42\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==42\" \nng-class=\"{\'md-icon-copied\': vm.copied ===42}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===42\" \nng-class=\"{\'md-icon-copied\': vm.copied ===42}\" ng-if=\"vm.copied ===42\" style=\"top: 7px\"></md-checkbox></md-button>\n</div></div></div><div style=\"margin: 0\" class=\"row_url title socialNetwork\" layout=\"row\" layout-xs=\"column\" \nhas-permission=\"media_video_embed_no_api\" ng-if=\"vm.link_embed\"><div flex=\"30\"><strong>Code Embed</strong></div><div \nlayout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo16\"><md-input-container><textarea \naria-label=\"Code Embed\"><iframe style=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed}}\" allowfullscreen frameborder=\"0\"></iframe></textarea></md-input-container></div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo16\" aria-label=\"url_copy\" ng-click=\"vm.copied =0\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==0\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===0\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0}\" ng-if=\"vm.copied ===0\" style=\"top: 7px\"></md-checkbox></md-button></div>\n</div></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetworkMobile\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\">\n<md-fab-speed-dial md-open=\"vm.socialNetwork\" md-direction=\"up\" class=\"md-scale menuIcon\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-warn menuButton\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a>\n</md-fab-actions></md-fab-speed-dial></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetwork\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\"><div \nstyle=\"text-align: right\"><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a></div></div>\n</div><div ng-if=\"vm.intranet && vm.isChannelExport\" style=\"width: 100%\" layout=\"row\" class=\"export_vod\"><md-tabs \nmd-dynamic-height md-border-bottom md-no-ink md-selected=\"$root.index\" style=\"width: 100%\"><md-tab \nng-repeat=\"(key,item) in vm.link_permalien\"><md-tab-label><div><span style=\"text-transform: none\">{{key}}</span></div>\n</md-tab-label><md-tab-body><md-content class=\"md-padding\" layout=\"row\" layout-xs=\"column\"><div \nstyle=\"padding-top: 15px\" ng-if=\"vm.spinner\" flex=\"95\"><div has-permission=\"media_video_options_embed_no_api\">\n<md-checkbox class=\"check-item\" ng-model=\"vm.autoplay\" ng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" \naria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.sendMail\" \nng-change=\"vm.checkOptionFunction(vm.sendMail, \'mail\')\" aria-label=\"Send mail\">Send mail</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.facebook\" ng-change=\"vm.checkOptionFunction(vm.facebook, \'fb\')\" aria-label=\"Facebook\">\nFacebook</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.twitter\" \nng-change=\"vm.checkOptionFunction(vm.twitter, \'tw\')\" aria-label=\"Twitter\">Twitter</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.linkedin\" ng-change=\"vm.checkOptionFunction(vm.linkedin, \'lk\')\" aria-label=\"Linkedin\">\nLinkedin</md-checkbox><md-checkbox class=\"check-item\" ng-if=\"vm.intranet\" ng-model=\"vm.cdn_web\" \nng-change=\"vm.checkOptionCDNFunction()\" aria-label=\"CDN Web\">Cdn Web</md-checkbox></div><div \nhas-permission=\"media_video_uid_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>\n{{vm.video.id_title}}</strong></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" \nid=\"fo9_{{$index}}\" class=\"title\">{{vm.video.id}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo9_{{$index}}\" aria-label=\"url_copy\" ng-click=\"vm.copied =7+$index\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==7+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===7+$index}\"></md-icon></md-button><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===7+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===7+$index}\" ng-if=\"vm.copied ===7+$index\" \nstyle=\"top: 7px\"></md-checkbox></div></div><div has-permission=\"media_video_mp4_embed_no_api\" layout=\"row\" \nclass=\"row_url layout-column-specific\" layout-xs=\"column\" \nng-if=\"vm.video.videos_mp4.length && ($first || vm.show_more_mp4===\'max\')\" ng-repeat=\"mp4 in ::vm.video.videos_mp4\">\n<div flex=\"30\"><strong ng-if=\"$first\">mp4</strong><md-icon md-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'min\'\" ng-click=\"vm.show_more_mp4=\'max\'\">\n</md-icon><md-icon md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"$first && vm.video.videos_mp4.length>1 && vm.show_more_mp4 ===\'max\'\" ng-click=\"vm.show_more_mp4=\'min\'\">\n</md-icon></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" \nid=\"{{\'fo105\'+$index+\'_\'+$parent.$parent.$index}}\" class=\"title\">{{mp4.src}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"{{\'#fo105\'+$index+\'_\'+$parent.$parent.$index}}\" \naria-label=\"url_copy\" ng-click=\"vm.copied = 116+$parent.$parent.$index+$index*2\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==116+$parent.$parent.$parent.$index+$index*2\" \nng-class=\"{\'md-icon-copied\': vm.copied === 116+$parent.$parent.$parent.$index+$index*2}\"></md-icon><md-checkbox \nclass=\"s18\" ng-checked=\"vm.copied ===116+$parent.$parent.$parent.$index+$index*2\" \nng-class=\"{\'md-icon-copied\': vm.copied ===116+$parent.$parent.$parent.$index+$index*2}\" \nng-if=\"vm.copied ===116+$parent.$parent.$parent.$index+$index*2\" style=\"top: 7px\"></md-checkbox></md-button></div>\n</div><div has-permission=\"media_video_progressif_download_embed_no_api\" class=\"row_url\" layout=\"row\" \nlayout-xs=\"column\" ng-if=\"vm.video.link_progressive_download\"><div flex=\"30\"><strong \ntranslate=\"MESSAGES.progressive_download\"></strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo11_{{$index}}\" class=\"title\">{{vm.video.link_progressive_download}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo11_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =5+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==5+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===5+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===5+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===5+$index}\" ng-if=\"vm.copied ===5+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.video.link_ogg\"><div flex=\"30\"><strong>OGV</strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo12_{{$index}}\" class=\"title\">{{vm.video.link_ogg}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo12_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =4+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==4+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===4+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===4+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===4+$index}\" ng-if=\"vm.copied ===4+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" \nng-if=\"vm.video.link_webm\"><div flex=\"30\"><strong>Webm</strong></div><div layout=\"row\" flex><div flex=\"100\" \nstyle=\"padding-top: 14px\" id=\"fo13_{{$index}}\" class=\"title\">{{vm.video.link_webm}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo13_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =3+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==3+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===3+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===3+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===3+$index}\" ng-if=\"vm.copied ===3+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div has-permission=\"media_video_permalien_embed_no_api\" \nlayout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.link_permalien\"><div flex=\"30\"><strong \ntranslate=\"MESSAGES.permalien\"></strong><br><span class=\"canal_span\">{{key}}</span></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo14_{{$index}}\" class=\"title\">{{item}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo14_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =2+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied!==2+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===2+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===2+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===2+$index}\" ng-if=\"vm.copied ===2+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div has-permission=\"media_video_embed_no_api\" layout=\"row\" \nlayout-xs=\"column\" ng-class=\"{\'row_url\' : vm.show_more_embed ===\'min\' }\" ng-if=\"vm.link_embed\" \nstyle=\"margin-top: 25px\" ng-style=\"vm.link_embed_simple\"><div flex=\"30\" ng-if=\"!vm.link_embed_simple\"><strong>Embed\n</strong><br><span class=\"canal_span\">{{key}}</span></div><div flex=\"100\" style=\"padding-top: 14px\" \nid=\"fo40_{{$index}}\" ng-if=\"!vm.link_embed_simple\" class=\"title\">{{vm.link_embed[key]}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo40_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =40+$index\" ng-if=\"!vm.link_embed_simple\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==40+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===40+$index}\"></md-icon><md-checkbox \nclass=\"s18\" ng-checked=\"vm.copied ===40+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===40+$index}\" \nng-if=\"vm.copied ===40+$index\" style=\"top: 7px\"></md-checkbox></md-button><div style=\"margin: 0\" layout=\"column\" \nlayout-xs=\"column\" flex=\"15\" ng-if=\"vm.link_embed_simple\"><div><strong>Embed</strong><md-icon style=\"margin: 0\" \nmd-font-icon=\"icon-menu-down\" class=\"s22 icon_down_export\" \nng-if=\"vm.link_embed_simple[key] && vm.show_more_embed ===\'min\'\" ng-click=\"vm.show_more_embed=\'max\'\"></md-icon><md-icon\n style=\"margin: 0\" md-font-icon=\"icon-menu-up\" class=\"s22 icon_down_export\" \nng-if=\"vm.link_embed_simple[key] && vm.show_more_embed ===\'max\'\" ng-click=\"vm.show_more_embed=\'min\'\"></md-icon><br>\n<span class=\"canal_span\">{{key}}</span></div></div><div layout=\"row\" layout-xs=\"column\" flex=\"95\" \nng-if=\"vm.link_embed_simple\" style=\"margin: 0\"><div flex=\"30\"><label style=\"font-weight: bold;font-size: 13px\">Simple\n</label></div><div layout=\"row\" flex><div flex=\"100\" id=\"fo41_{{$index}}\" class=\"title\">{{vm.link_embed_simple[key]}}\n</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo41_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =141+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==141+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===141+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===141+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===141+$index}\" \nng-if=\"vm.copied ===141+$index\" style=\"top: 7px\"></md-checkbox></md-button></div></div></div><div \nhas-permission=\"media_video_embed_no_api\" layout=\"row\" layout-xs=\"row\" \nng-if=\"vm.link_embed && vm.show_more_embed ===\'max\'\"><div layout=\"column\" layout-xs=\"column\" flex=\"15\" \nng-if=\"vm.link_embed_simple\"></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\" ng-if=\"vm.link_embed_richmedia\"><div\n flex=\"30\"><label style=\"font-weight: bold;font-size: 13px\">Richmedia</label></div><div layout=\"row\" flex><div \nflex=\"100\" id=\"fo42_{{$index}}\" class=\"title\">{{vm.link_embed_richmedia[key]}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo42_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =242+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==242+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===242+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===242+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===242+$index}\" \nng-if=\"vm.copied ===242+$index\" style=\"top: 7px\"></md-checkbox></md-button></div></div></div><div style=\"margin: 0\" \nclass=\"row_url socialNetwork\" layout=\"row\" layout-xs=\"column\" has-permission=\"media_video_embed_code_no_api\" \nng-if=\"vm.link_embed\"><div flex=\"30\"><strong>Code Embed</strong><br><span class=\"canal_span\">{{key}}</span></div><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo16_{{$index}}\"><md-input-container><textarea aria-label=\"Code Embed\"><iframe\n style=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed[key]}}\" allowfullscreen frameborder=\"0\"></iframe></textarea></md-input-container></div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo16_{{$index}}\" aria-label=\"url_copy\" \nng-click=\"vm.copied =0+$index\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==0+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===0+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===0+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===0+$index}\" ng-if=\"vm.copied ===0+$index\" \nstyle=\"top: 7px\"></md-checkbox></md-button></div></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetworkMobile\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\">\n<md-fab-speed-dial md-open=\"vm.socialNetwork\" md-direction=\"up\" class=\"md-scale menuIcon\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-warn menuButton\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a>\n</md-fab-actions></md-fab-speed-dial></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetwork\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\"><div \nstyle=\"text-align: right\"><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a></div></div>\n</md-content></md-tab-body></md-tab></md-tabs></div></md-dialog-content><md-dialog-content \nstyle=\"padding-top: 0!important\" ng-if=\"vm.isIntranet_Internet===\'0\'\" layout=\"row\" ms-scroll><div \nstyle=\"padding-right: 20px;padding-top: 15px\" ng-if=\"vm.spinner\" flex=\"95\"><div \nhas-permission=\"media_video_options_embed_no_api\"><md-checkbox class=\"check-item\" ng-model=\"vm.autoplay\" \nng-change=\"vm.checkOptionFunction(vm.autoplay, \'a\')\" aria-label=\"autoplay\">autoplay</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.sendMail\" ng-change=\"vm.checkOptionFunction(vm.sendMail, \'mail\')\" \naria-label=\"Send mail\">Send mail</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.facebook\" \nng-change=\"vm.checkOptionFunction(vm.facebook, \'fb\')\" aria-label=\"Facebook\">Facebook</md-checkbox><md-checkbox \nclass=\"check-item\" ng-model=\"vm.twitter\" ng-change=\"vm.checkOptionFunction(vm.twitter, \'tw\')\" aria-label=\"Twitter\">\nTwitter</md-checkbox><md-checkbox class=\"check-item\" ng-model=\"vm.linkedin\" \nng-change=\"vm.checkOptionFunction(vm.linkedin, \'lk\')\" aria-label=\"Linkedin\">Linkedin</md-checkbox><md-checkbox \nclass=\"check-item\" ng-if=\"vm.intranet\" ng-model=\"vm.cdn_web\" ng-change=\"vm.checkOptionCDNFunction()\" \naria-label=\"CDN Web\">Cdn Web</md-checkbox></div><div has-permission=\"media_video_uid_embed_no_api\" class=\"row_url\" \nlayout=\"row\" layout-xs=\"column\"><div flex=\"30\"><strong>{{vm.video.id_title}}</strong></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo17\" class=\"title\">{{vm.video.id}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo17\" aria-label=\"url_copy\" ng-click=\"vm.copied =16\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==16\" \nng-class=\"{\'md-icon-copied\': vm.copied ===16}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===16\" \nng-class=\"{\'md-icon-copied\': vm.copied ===16}\" ng-if=\"vm.copied ===16\" style=\"top: 7px\"></md-checkbox></md-button>\n</div></div><div has-permission=\"media_video_mp4_embed_no_api\" layout=\"row\" class=\"row_url layout-column-specific\" \nlayout-xs=\"column\" ng-if=\"vm.video.videos_mp4.length\" ng-repeat=\"mp4 in ::vm.video.videos_mp4\"><div flex=\"30\"><strong \nng-if=\"$first\">mp4</strong></div><div layout=\"row\"><div flex=\"100\" style=\"padding-top: 14px\" id=\"{{\'fo108\'+$index}}\" \nclass=\"title\">{{mp4.src}}</div><md-button class=\"btn md-icon-button\" ngclipboard \nng-attr-data-clipboard-target=\"{{\'#fo108\'+$index}}\" aria-label=\"url_copy\" ng-click=\"vm.copied =176+$index\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==176+$index\" \nng-class=\"{\'md-icon-copied\': vm.copied ===176+$index}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===176+$index\" ng-class=\"{\'md-icon-copied\': vm.copied ===176+$index}\" \nng-if=\"vm.copied ===176+$index\" style=\"top: 7px\"></md-checkbox></md-button></div></div><div \nhas-permission=\"media_video_progressif_download_embed_no_api\" class=\"row_url\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.video.link_progressive_download\"><div flex=\"30\"><strong translate=\"MESSAGES.progressive_download\"></strong>\n</div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo012\" class=\"title\">\n{{vm.video.link_progressive_download}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo012\" aria-label=\"url_copy\" ng-click=\"vm.copied =18\"><md-icon \nmd-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==18\" ng-class=\"{\'md-icon-copied\': vm.copied ===18}\">\n</md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===18\" ng-class=\"{\'md-icon-copied\': vm.copied ===18}\" \nng-if=\"vm.copied ===18\" style=\"top: 7px\"></md-checkbox></md-button></div></div><div layout=\"row\" class=\"row_url\" \nlayout-xs=\"column\" ng-if=\"vm.video.link_ogg\"><div flex=\"30\"><strong>OGV</strong></div><div layout=\"row\" flex><div \nflex=\"100\" style=\"padding-top: 14px\" id=\"fo19\" class=\"title\">{{vm.video.link_ogg}}</div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo19\" aria-label=\"url_copy\" ng-click=\"vm.copied =19\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==19\" \nng-class=\"{\'md-icon-copied\': vm.copied ===19}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===19\" \nng-class=\"{\'md-icon-copied\': vm.copied ===19}\" ng-if=\"vm.copied ===19\" style=\"top: 7px\"></md-checkbox></md-button>\n</div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\" ng-if=\"vm.video.link_webm\"><div flex=\"30\"><strong>Webm\n</strong></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo20\" class=\"title\">\n{{vm.video.link_webm}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo20\" \naria-label=\"url_copy\" ng-click=\"vm.copied =20\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==20\" ng-class=\"{\'md-icon-copied\': vm.copied ===20}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===20\" ng-class=\"{\'md-icon-copied\': vm.copied ===20}\" ng-if=\"vm.copied ===20\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_permalien_embed_no_api\" layout=\"row\" \nclass=\"row_url\" layout-xs=\"column\" ng-if=\"vm.link_permalien\"><div flex=\"30\"><strong translate=\"MESSAGES.permalien\">\n</strong></div><div layout=\"row\" flex><div flex=\"100\" style=\"padding-top: 14px\" id=\"fo21\" class=\"title\">\n{{vm.link_permalien}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo21\" \naria-label=\"url_copy\" ng-click=\"vm.copied =21\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==21\" ng-class=\"{\'md-icon-copied\': vm.copied ===21}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===21\" ng-class=\"{\'md-icon-copied\': vm.copied ===21}\" ng-if=\"vm.copied ===21\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_embed_no_api\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.link_embed\"><div flex=\"30\" ng-if=\"!vm.link_embed_simple\"><strong>Embed</strong></div><div layout=\"row\" flex>\n<div flex=\"100\" style=\"padding-top: 14px\" id=\"fo29\" ng-if=\"!vm.link_embed_simple\" class=\"title\">{{vm.link_embed}}</div>\n<md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo29\" aria-label=\"url_copy\" \nng-click=\"vm.copied =29\" ng-if=\"!vm.link_embed_simple\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==29\" ng-class=\"{\'md-icon-copied\': vm.copied ===29}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===29\" ng-class=\"{\'md-icon-copied\': vm.copied ===29}\" ng-if=\"vm.copied ===29\" style=\"top: 7px\">\n</md-checkbox></md-button></div><div layout=\"column\" layout-xs=\"column\" flex=\"15\" ng-if=\"vm.link_embed_simple\"><div>\n<strong>Embed</strong></div></div><div layout=\"row\" layout-xs=\"column\" flex=\"100\" ng-if=\"vm.link_embed_simple\" \nstyle=\"margin: 0\"><div flex=\"30\"><label style=\"font-weight: bold;font-size: 13px\">Simple</label></div><div flex=\"100\" \nid=\"fo22\" class=\"title\">{{vm.link_embed_simple}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"#fo22\" aria-label=\"url_copy\" ng-click=\"vm.copied =22\"><md-icon md-font-icon=\"icon-content-copy\" \nclass=\"s18\" ng-if=\"vm.copied !==22\" ng-class=\"{\'md-icon-copied\': vm.copied ===22}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===22\" ng-class=\"{\'md-icon-copied\': vm.copied ===22}\" ng-if=\"vm.copied ===22\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div has-permission=\"media_video_embed_no_api\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.link_embed\"><div layout=\"column\" layout-xs=\"column\" flex=\"15\" ng-if=\"vm.link_embed_simple\"></div><div \nlayout=\"row\" layout-xs=\"column\" flex=\"100\" ng-if=\"vm.link_embed_richmedia\"><div flex=\"30\"><label \nstyle=\"font-weight: bold;font-size: 13px\">Richmedia</label></div><div flex=\"100\" id=\"fo30\" class=\"title\">\n{{vm.link_embed_richmedia}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo30\" \naria-label=\"url_copy\" ng-click=\"vm.copied =30\"><md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" \nng-if=\"vm.copied !==30\" ng-class=\"{\'md-icon-copied\': vm.copied ===30}\"></md-icon><md-checkbox class=\"s18\" \nng-checked=\"vm.copied ===30\" ng-class=\"{\'md-icon-copied\': vm.copied ===30}\" ng-if=\"vm.copied ===30\" style=\"top: 7px\">\n</md-checkbox></md-button></div></div><div class=\"row_url socialNetwork\" layout=\"row\" layout-xs=\"column\" \nng-if=\"vm.link_embed\" has-permission=\"media_video_embed_code_no_api\"><div flex=\"30\"><strong>Code Embed</strong></div>\n<div flex=\"100\" style=\"padding-top: 14px\" id=\"fo23\"><md-input-container class=\"textarea_embed\"><textarea \naria-label=\"Code Embed\" style=\"min-height: 100px; overflow:auto\">\n                        <iframe \nstyle=\"width:100%;height:100%\" \nallow=\"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture\" \nsrc=\"{{vm.link_embed}}\" allowfullscreen frameborder=\"0\"></iframe></textarea></md-input-container></div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo23\" aria-label=\"url_copy\" ng-click=\"vm.copied =23\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-if=\"vm.copied !==23\" \nng-class=\"{\'md-icon-copied\': vm.copied ===23}\"></md-icon><md-checkbox class=\"s18\" ng-checked=\"vm.copied ===23\" \nng-class=\"{\'md-icon-copied\': vm.copied ===23}\" ng-if=\"vm.copied ===23\" style=\"top: 7px\"></md-checkbox></md-button>\n</div></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetworkMobile\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\">\n<md-fab-speed-dial md-open=\"vm.socialNetwork\" md-direction=\"up\" class=\"md-scale menuIcon\"><md-fab-trigger><md-button \naria-label=\"menu\" class=\"md-fab md-warn menuButton\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s18\"></md-icon>\n</md-button></md-fab-trigger><md-fab-actions><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a>\n</md-fab-actions></md-fab-speed-dial></div><div has-permission=\"media_video_social_network_embed_no_api\" \nclass=\"social_network_export socialNetwork\" layout=\"column\" flex=\"5\" layout-align=\"space-around center\"><div \nstyle=\"text-align: right\"><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'MESSAGES.export_youtube\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportYoutube(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%\" \nng-src=\"assets/icons/youtube.png\"></md-button></a><a has-permission=\"export_video_dailymotion_get_login\" tooltips \ntooltip-template=\"{{\'Export Dailymotion\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.exportDailymotion(video)\" aria-label=\"export_youtube\" translate \ntranslate-attr-aria-label=\"MESSAGES.export_youtube\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/dailymotion.png\"></md-button></a><a has-permission=\"media_video_send_mail_no_api\" tooltips \ntooltip-template=\"{{\'MESSAGES.video_by_mail\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" \nng-click=\"vm.listSubscriptionGroup(vm.video_id,$event)\" aria-label=\"send_mail\" translate \ntranslate-attr-aria-label=\"LIVESLIST.send_mail\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/mail.png\"></md-button></a><a target=\"_blank\" \nhref=\"{{vm.export_facebook + vm.video.link_to_player}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_facebook\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Facebook\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/fb.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_twitter + vm.link_embed}}\" tooltips \nhas-permission=\"media_video_social_network_embed_no_api\" tooltip-template=\"{{\'MESSAGES.export_twiter\'|translate}}\" \ntooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button style=\"background-color: transparent;width: 35px;height: 35px\" \nclass=\"md-fab md-mini\" aria-label=\"Twitter\"><img style=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" \nng-src=\"assets/icons/twitter.png\"></md-button></a><a target=\"_blank\" href=\"{{vm.export_linkedin + vm.link_embed}}\" \ntooltips has-permission=\"media_video_social_network_embed_no_api\" \ntooltip-template=\"{{\'MESSAGES.export_linkdin\'|translate}}\" tooltip-side=\"top left\" tooltip-speed=\"fast\"><md-button \nstyle=\"background-color: transparent;width: 35px;height: 35px\" class=\"md-fab md-mini\" aria-label=\"Linkedin\"><img \nstyle=\"margin-left: -6px;max-width: 155%;margin-top: 1px\" ng-src=\"assets/icons/in.png\"></md-button></a></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/media/video/rich-media-new/template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple\" \nng-class=\"{\'isNavigationNew\' : vm.isNavigationNew}\" style=\"padding:0 8%;background: white\" layout=\"column\"><div \nclass=\"fullpage\" layout=\"column\"><preview-video event=\"vm.event\" params=\"vm.params\" diffusion=\"\'internet\'\" \nhandler=\"vm\"></preview-video></div></div>");
$templateCache.put("app/main/profiles/user/detail/detail.modal.html","<md-dialog flex-gt-md=\"30\" aria-label=\"profiles_user_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.profiles_user_detail_pagetitle\">\nprofiles_user_detail_pagetitle</span> <span>{{vm.user.username | json}}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"USERDETAIL.firstName\">firstName\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.firstName}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"USERDETAIL.lastName\">lastName\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.lastName}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"USERDETAIL.username\">username\n</strong></h3></div><div class=\"md-secondary\">{{vm.user.username}}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"USERDETAIL.email\">email</strong>\n</h3></div><div class=\"md-secondary\">{{vm.user.email}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"USERDETAIL.lastLogin\">lastLogin</strong></h3>\n</div><div class=\"md-secondary\">{{vm.user.lastLogin | date : $rootScope.defaultDateFormat : \'+0200\'}}</div><md-divider>\n</md-divider></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/profiles/user/add_edit_view/activate.code.validation.html","<md-dialog style=\"min-width: 70%\" aria-label=\"-\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"USERADD.activate_code_validation\">activate_code_validation</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" ng-click=\"vm.closeDialog()\" aria-label=\"alert_close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content class=\"md-dialog-content\"><div \nclass=\"md-dialog-content-body ng-binding ng-scope\" ng-if=\"vm.show_loading\" style=\"padding: 20px; padding-right: 0\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent mh-10\" md-diameter=\"64\" style=\"margin: 0 auto\">\n</md-progress-circular><md-tooltip md-autohide=\"true\" md-direction=\"bottom\">\n{{\'USERADD.tooltip_activate_code_validation\'|translate}}</md-tooltip></div><div \nclass=\"md-dialog-content-body ng-binding ng-scope\" ng-if=\"vm.show_msg\"><span \ntranslate=\"USERADD.msg_activate_code_validation\"></span> \"<span>{{vm.data.email}}</span>\"<br><br><span \ntranslate=\"USERADD.label_activate_code_validation\"></span></div><form ng-submit=\"vm.check_code_validation()\" \nname=\"empUserCodeForm\" id=\"empUserCodeForm\" ng-if=\"vm.show_msg\"><md-input-container class=\"md-block\"><label><span \ntranslate=\"Code\">code</span></label><input type=\"text\" name=\"code\" ng-model=\"vm.empUserCodeForm.code\" \nrequired=\"required\" ng-change=\"vm.change_code()\"><div ng-messages=\"empUserCodeForm.code.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">code field is required</span></div><div \nng-if=\"vm.msg_error\" style=\"color: rgb(213,0,0);font-size: 12px;line-height: 14px;margin-top: 5px\"><span \ntranslate=\"{{vm.msg_error}}\"></span></div></div></md-input-container><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">alert_close</md-button><md-button \nclass=\"md-raised md-accent block\" ng-click=\"vm.check_code_validation()\" translate=\"MESSAGES.form_validate\" \nng-disabled=\"empUserCodeForm.$invalid\">form_validate</md-button></md-dialog-actions></form></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/profiles/user/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-user\" layout=\"column\" \nng-if=\"!vm.isNotBo\"><div class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" \nlayout-align=\"space-between\" flex><div ng-include=\"\'app/main/profiles/user/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div></div>");
$templateCache.put("app/main/profiles/user/add_edit_view/form.pwd.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><form name=\"empProfilesUserForm\" novalidate \nng-submit=\"empProfilesUserForm.$valid && vm.submitEditPwdUserForm()\"><div class=\"form-title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"PAGESMENUSTITLES.profiles_user_edit_pwd_pagetitle\">form_title</span></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"USERADD.form_attr_first\">Mot de passe</label><input \ntype=\"password\" name=\"first\" ng-minlength=\"8\" md-maxlength=\"20\" pattern=\"{{vm.patern}}\" required \nng-model=\"vm.empProfilesUserForm.plainPassword.first\" class=\"first\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesUserForm.first.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_REQUIRED\">Le champ Mot de passe (Confirmer) est requis</span></div><div \nng-message=\"md-maxlength\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"USERPASSWORD.form_attr_second\">Repeat Password</label><input type=\"password\" required=\"required\" \nname=\"second\" ng-model=\"vm.empProfilesUserForm.plainPassword.second\" confirm-password=\"true\" ng-minlength=\"8\" \nmd-maxlength=\"20\" pattern=\"{{vm.patern}}\" aria-invalid=\"true\"><div ng-messages=\"empProfilesUserForm.second.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nLe champ Mot de passe (Confirmer) est requis</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div><div \nng-message=\"confirmPassword\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">\nLes deux mots de passe ne sont pas identiques.</span></div></div></md-input-container></div><md-button class=\"md-warn\" \nui-sref=\"app.profiles_user_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empProfilesUserForm.$invalid || empProfilesUserForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form></div></div></div></div>");
$templateCache.put("app/main/profiles/user/add_edit_view/form.template.html","<form name=\"forms.empProfilesUserForm\" method=\"post\" id=\"empProfilesUserForm\" novalidate=\"novalidate\" \nng-submit=\"forms.empProfilesUserForm.$valid && vm.submitAddUserForm()\" ng-class=\"{\'e-commerce-product\': vm.isNotBo }\">\n<div ng-if=\"!vm.isNotBo\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" \nclass=\"s18\"></md-icon><span translate=\"USERADD.form_title\">form_title</span></div><div class=\"form-title\" \nng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"USEREDIT.form_title\">\nform_title</span></div><input type=\"hidden\" id=\"empProfilesUserForm_vignette\" name=\"empProfilesUserForm[vignette]\" \nng-model=\"vm.empProfilesUserForm.vignette\" aria-invalid=\"false\"><div ng-if=\"vm.urlVignette==\'\'\" \nlayout-align=\"left left\" layout=\"row\" class=\"s18\"><img class=\"profile-image avatar huge\" style=\"margin-left: 70px\" \nng-src=\"{{vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\" \non-error-src=\"assets/images/no-image-custom.svg\"></div><div ng-if=\"vm.urlVignette\" layout=\"row\" class=\"s18\"><img \nclass=\"profile-image avatar huge\" style=\"margin-left: 70px\" ng-src=\"{{vm.urlVignette}}\" \non-error-src=\"assets/images/no-image-custom.svg\"></div><div class=\"mv-24\" id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"add-file-button md-primary md-raised\" \naria-label=\"form_add_file\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><any ng-if=\"vm.empProfilesUserForm.connectionType === 0\" \ntranslate=\"USERADD.choose_thumb\">choose_thumb</any><any ng-hide=\"vm.empProfilesUserForm.connectionType === 0\" \ntranslate=\"USEREDIT.choose_thumb\">choose_thumb</any></md-button></div></div><div ng-if=\"vm.isNotBo\"><div \nclass=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-compte\" class=\"s18\"></md-icon><span \ntranslate=\"USERADD.form_add_user_title\" style=\"padding: 5px;color: #7d7d7d;font-size: large;font-weight: bold\">\nform_add_user_title</span></div></div><div ng-if=\"!vm.isNotBo\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nflex><label class=\"md-no-float\" translate=\"USERADD.form_attr_firstName\">Nom</label><input type=\"text\" \nid=\"empProfilesUserForm_firstName\" name=\"empProfilesUserForm[firstName]\" required=\"required\" ng-attr-name=\"firstName\" \ntranslate=\"\" ng-model=\"vm.empProfilesUserForm.firstName\" aria-invalid=\"true\" maxlength=\"50\"><div \nng-messages=\"empProfilesUserForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.firstName && vm.empProfilesUserForm.firstname === vm.empProfilesUsersError.firstname.value_old&&vm.empProfilesUsersError.firstName.length>5\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.firstName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"!vm.isNotBo\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"USERADD.form_attr_lastName\">Prénom</label><input type=\"text\" \nid=\"empProfilesUserForm_lastName\" name=\"empProfilesUserForm[lastName]\" required=\"required\" ng-attr-name=\"lastName\" \ntranslate=\"\" ng-model=\"vm.empProfilesUserForm.lastName\" aria-invalid=\"true\" maxlength=\"50\"><div \nng-messages=\"empProfilesUserForm.lastName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.lastName && vm.empProfilesUserForm.lastName === vm.empProfilesUsersError.lastName.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.lastName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"vm.isNotBo\" layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_firstName\">Nom</label><input type=\"text\" id=\"empProfilesUserForm_firstName\" \nname=\"empProfilesUserForm[firstName]\" required=\"required\" ng-attr-name=\"firstName\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.firstName\" aria-invalid=\"true\" maxlength=\"50\" \nplaceholder=\"{{\'USERADD.form_attr_firstName\'|translate}}\"><div ng-messages=\"empProfilesUserForm.firstName.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.firstName && vm.empProfilesUserForm.firstname === vm.empProfilesUsersError.firstname.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.firstName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_lastName\">Prénom</label><input type=\"text\" id=\"empProfilesUserForm_lastName\" \nname=\"empProfilesUserForm[lastName]\" required=\"required\" ng-attr-name=\"lastName\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.lastName\" aria-invalid=\"true\" maxlength=\"50\" \nplaceholder=\"{{\'USERADD.form_attr_lastName\'|translate}}\"><div ng-messages=\"empProfilesUserForm.lastName.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.lastName && vm.empProfilesUserForm.lastName === vm.empProfilesUsersError.lastName.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.lastName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.isNotBo\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"USERADD.form_attr_username\">Nom d\'utilisateur</label><input type=\"text\" \nid=\"empProfilesUserForm_username\" name=\"empProfilesUserForm[username]\" required=\"required\" ng-attr-name=\"username\" \ntranslate=\"\" ng-model=\"vm.empProfilesUserForm.username\" aria-invalid=\"true\" maxlength=\"50\"><div \nng-messages=\"empProfilesUserForm.username.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.username && vm.empProfilesUserForm.username === vm.empProfilesUsersError.username.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.username.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"!vm.isNotBo\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"USERADD.form_attr_email\">Email</label><input type=\"email\" \nid=\"empProfilesUserForm_email\" name=\"empProfilesUserForm[email]\" required=\"required\" ng-attr-name=\"email\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.email\" aria-invalid=\"true\" maxlength=\"80\"><div \nng-messages=\"empProfilesUserForm.email.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"email\" translate=\"MESSAGES.form_is_email\">\nform_is_email</div><div \nng-if=\"vm.empProfilesUsersError.email && vm.empProfilesUserForm.email === vm.empProfilesUsersError.email.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.email.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"!vm.isNotBo\" layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"USERADD.form_attr_phone\">Phone</label><input type=\"text\" id=\"empProfilesUserForm_phone\" \nname=\"empProfilesUserForm[phone]\" ng-attr-name=\"phone\" translate=\"\" \nng-pattern=\"^(0|(\\+33)|(0033))(([0-9]{10})|([0-9]{1}-[0-9]{4}-[0-9]{5}))$\" ng-minlength=\"10\" ng-maxlength=\"16\" \nng-model=\"vm.empProfilesUserForm.phone\" maxlength=\"50\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesUserForm.phone.$error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_patternphone\"></div><div ng-message=\"minlength\" translate=\"MESSAGES.form_is_minlength\">\nform_is_minlength</div><div ng-message=\"maxlength\" translate=\"MESSAGES.form_is_maxlength\">form_is_maxlength</div><div \nng-if=\"vm.empProfilesUsersError.phone && vm.empProfilesUserForm.phone === vm.empProfilesUsersError.phone.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.phone.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"vm.isNotBo\" layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_phone\">\nPhone</label><input type=\"text\" id=\"empProfilesUserForm_phone\" name=\"empProfilesUserForm[phone]\" ng-attr-name=\"phone\" \ntranslate=\"\" ng-pattern=\"^(0|(\\+33)|(0033))(([0-9]{10})|([0-9]{1}-[0-9]{4}-[0-9]{5}))$\" ng-minlength=\"10\" \nng-maxlength=\"16\" ng-model=\"vm.empProfilesUserForm.phone\" aria-invalid=\"true\" required=\"required\" maxlength=\"50\" \nplaceholder=\"{{\'USERADD.form_attr_phone\'|translate}}\"><div ng-messages=\"empProfilesUserForm.phone.$error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"pattern\" translate=\"MESSAGES.form_is_patternphone\"></div><div \nng-message=\"minlength\" translate=\"MESSAGES.form_is_minlength\">form_is_minlength</div><div ng-message=\"maxlength\" \ntranslate=\"MESSAGES.form_is_maxlength\">form_is_maxlength</div><div \nng-if=\"vm.empProfilesUsersError.phone && vm.empProfilesUserForm.phone === vm.empProfilesUsersError.phone.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.phone.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_email\">Email</label><input type=\"email\" id=\"empProfilesUserForm_email\" \nname=\"empProfilesUserForm[email]\" required=\"required\" ng-attr-name=\"email\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.email\" aria-invalid=\"true\" placeholder=\"{{\'USERADD.form_attr_email\'|translate}}\"><div \nng-messages=\"empProfilesUserForm.email.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"email\" translate=\"MESSAGES.form_is_email\">\nform_is_email</div><div \nng-if=\"vm.empProfilesUsersError.email && vm.empProfilesUserForm.email === vm.empProfilesUsersError.email.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.email.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.isNotBo\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"USERADD.form_attr_mobile\">Mobile</label><input type=\"text\" \nid=\"empProfilesUserForm_mobile\" name=\"empProfilesUserForm[mobile]\" \npattern=\"^(?:0|\\(?\\+33\\)?\\s?|0033\\s?)[1-79](?:[\\-\\s]?\\d\\d){4}$\" ng-attr-name=\"mobile\" translate=\"\" ng-minlength=\"10\" \nng-maxlength=\"15\" ng-model=\"vm.empProfilesUserForm.mobile\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesUserForm.mobile.$error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_patternphone\">form_is_patternphone</div><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlength\">form_is_minlength</div><div ng-message=\"maxlength\" \ntranslate=\"MESSAGES.form_is_maxlength\">form_is_maxlength</div><div \nng-if=\"vm.empProfilesUsersError.mobile && vm.empProfilesUserForm.mobile === vm.empProfilesUsersError.mobile.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.mobile.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-input-container class=\"md-block\" ng-if=\"!vm.isNotBo\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empProfilesUserForm_description\" name=\"empProfilesUserForm[description]\" ng-attr-name=\"description\" rows=\"5\" \nmax-rows=\"8\" md-maxlength=\"450\" ng-model=\"vm.empProfilesUserForm.description\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empProfilesUserForm.description.$error\" role=\"alert\"><div ng-message=\"maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empProfilesUsersError.description && vm.empProfilesUserForm.description === vm.empProfilesUsersError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container class=\"md-block\" ng-if=\"vm.isNotBo\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_adress\">Adresse</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empProfilesUserForm_adress\" name=\"empProfilesUserForm[adress]\" ng-attr-name=\"adress\" rows=\"5\" max-rows=\"8\" \nmd-maxlength=\"450\" ng-model=\"vm.empProfilesUserForm.adress\" aria-invalid=\"false\" ng-trim=\"false\" style=\"height: 135px\" \nplaceholder=\"{{\'USERADD.form_attr_adress\'|translate}}\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"empProfilesUserForm.adress.$error\" role=\"alert\"><div \nng-message=\"maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empProfilesUsersError.adressem.empProfilesUsersError.adress && vm.empProfilesUserForm.adress === vm.empProfilesUsersError.adress.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.adress.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><div ng-if=\"vm.isNotBo\" layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_city\">Ville</label><md-select name=\"empProfilesUserForm[city][]\" \nid=\"empProfilesUserForm_city\" ng-model=\"vm.empProfilesUserForm.city\" required=\"required\" ng-attr-name=\"city\" \nplaceholder=\"{{ \'USERADD.form_attr_city\'|translate}}\"><md-option ng-repeat=\"city in vm.cities track by city.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"city.val\">{{city.option}}</md-option></md-select><div \nng-messages=\"empProfilesUserForm.group.$error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.city && vm.empProfilesUserForm.city === vm.empProfilesUsersError.city.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.city.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_postalCode\">Code postale</label><input type=\"text\" id=\"empProfilesUserForm_postalCode\" \nname=\"empProfilesUserForm[postalCode]\" required=\"required\" ng-attr-name=\"postalCode\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.postalCode\" aria-invalid=\"true\" \nplaceholder=\"{{\'USERADD.form_attr_postalCode\'|translate}}\"><div ng-messages=\"empProfilesUserForm.postalCode.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.postalCode && vm.empProfilesUserForm.postalCode === vm.empProfilesUsersError.postalCode.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.postalCode.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"vm.isNotBo\" layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container \nflex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_company\">Société</label><input type=\"text\" id=\"empProfilesUserForm_company\" \nname=\"empProfilesUserForm[company]\" ng-attr-name=\"company\" translate=\"\" ng-model=\"vm.empProfilesUserForm.company\" \naria-invalid=\"true\" placeholder=\"{{\'USERADD.form_attr_company\'|translate}}\"><div \nng-messages=\"empProfilesUserForm.company.$error\" role=\"alert\"><div \nng-if=\"vm.empProfilesUsersError.company && vm.empProfilesUserForm.company === vm.empProfilesUsersError.company.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.company.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_numberPersons\">Nombre de personne</label><input type=\"number\" \nid=\"empProfilesUserForm_numberPersons\" name=\"empProfilesUserForm[numberPersons]\" ng-attr-name=\"numberPersons\" \ntranslate=\"\" ng-model=\"vm.empProfilesUserForm.numberPersons\" aria-invalid=\"true\" min=\"1\" max=\"5\" \nplaceholder=\"Entre 5-10\"></md-input-container></div><div flex=\"100\" layout-align=\"space-around center\" \nstyle=\"padding: 2px 0;margin: 10px 0\"><label class=\"md-no-float passwordType\" translate=\"USERADD.form_attr_first\">\nMot de passe</label><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-around center\" \nng-if=\"vm.isNew && !vm.isNotBo\" style=\"min-height: 144px;border: 1px solid #ced4da !important;border-radius: 0.25rem\">\n<md-input-container flex=\"100\" flex-gt-sm=\"40\" style=\"width:90%\"><label class=\"md-no-float\">Type</label><md-select \ntranslate translate=\"MESSAGES.form_attr_active\" name=\"connectionType\" id=\"connectionType\" \nng-model=\"vm.empProfilesUserForm.connectionType\"><md-option \nng-repeat=\"connectionTypeChoice in vm.connectionTypeChoices\" ng-value=\"connectionTypeChoice.val\" \ntranslate=\"USERADD.{{connectionTypeChoice.option}}\">{{connectionTypeChoice.option}}</md-option></md-select>\n</md-input-container><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-around center\" style=\"width:100%\" \nflex-gt-sm=\"50\"><div \nng-if=\"vm.empProfilesUserForm.connectionType === \'0\' || vm.empProfilesUserForm.connectionType === 0 \" layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"space-around center\" style=\"width:90%\"><md-input-container flex-gt-sm=\"40\" \nstyle=\"width:100%\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_first\">Mot de passe</label><input \ntype=\"password\" id=\"empProfilesUserForm_plainPassword_first\" id=\"pw1\" name=\"empProfilesUserForm[plainPassword][first]\" \nrequired=\"required\" pattern=\"{{vm.patern}}\" ng-minlength=\"8\" ng-attr-name=\"plainPasswordfirst\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.plainPassword.first\" class=\"first\"><div \nng-messages=\"empProfilesUserForm.plainPasswordfirst.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div \nng-if=\"vm.empProfilesUsersError.plainPasswordfirst && vm.empProfilesUserForm.plainPasswordfirst === vm.empProfilesUsersError.plainPasswordfirst.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordfirst.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex-gt-sm=\"40\" style=\"width:100%\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_second\">Repeat Password</label><input type=\"password\" \nid=\"empProfilesUserForm_plainPassword_second\" id=\"pw2\" name=\"empProfilesUserForm[plainPassword][second]\" \nrequired=\"required\" pattern=\"{{vm.patern}}\" ng-minlength=\"8\" ng-attr-name=\"plainPasswordsecond\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.plainPassword.second\" confirm-password=\"true\"><div \nng-messages=\"empProfilesUserForm.plainPasswordsecond.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div ng-message=\"confirmPassword\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">Les deux mots de passe ne sont pas identiques.</span></div><div \nng-if=\"vm.empProfilesUsersError.plainPasswordsecond  && vm.empProfilesUserForm.plainPasswordsecond === vm.empProfilesUsersError.plainPasswordsecond.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordsecond.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"vm.empProfilesUserForm.connectionType === 1\"><strong \ntranslate=\"USERADD.random_pwd_notif\"></strong></div><div ng-if=\"vm.empProfilesUserForm.connectionType === 2\"><strong \ntranslate=\"USERADD.email_pwd_notif\"></strong></div></div></div></div><div \nhas-permission=\"activate_code_validation_no_api\" layout=\"column\" layout-gt-sm=\"row\" ng-if=\"!vm.isNotBo\"><md-checkbox \nng-click=\"vm.activate_code_validation()\" ng-checked=\"$root.activateCodeValidation\" \nname=\"empProfilesUserForm[activateCodeValidation]\" ng-model=\"vm.empProfilesUserForm.activateCodeValidation\" \nclass=\"userCheckbox\"><label translate=\"USERADD.activate_code_validation\">code validation</label></md-checkbox></div>\n<div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.channels.length && !vm.isNotBo\"><md-card-content flex><md-select \ntranslate translate=\"MESSAGES.form_attr_canal\" name=\"empProfilesUserForm[channels][]\" \nid=\"empProfilesUserForm_channels\" ng-model=\"vm.empProfilesUserForm.channels\" multiple=\"1\" ng-attr-name=\"channels\" \nplaceholder=\"{{ \'USERADD.form_attr_channel\'|translate}}\"><md-option \nng-repeat=\"channel in vm.channels track by channel.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"channel.val\">\n{{ channel.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.groups.length && !vm.isNotBo\"><md-input-container flex><md-select translate \ntranslate=\"MESSAGES.form_attr_canal\" name=\"empProfilesUserForm[group][]\" id=\"empProfilesUserForm_group\" \nng-model=\"vm.empProfilesUserForm.group\" required=\"1\" ng-attr-name=\"group\" \nplaceholder=\"{{ \'USERADD.form_attr_groups\'|translate}}\"><md-option ng-repeat=\"group in vm.groups track by group.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"group.val\">{{group.option}}</md-option></md-select><div \nng-messages=\"empProfilesUserForm.group.$error\" role=\"alert\" md-auto-hide=\"false\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.group && vm.empProfilesUserForm.group === vm.empProfilesUsersError.group.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.group.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div ng-if=\"vm.isNotBo\" style=\"margin-top: 20px\"><label \nstyle=\"font-size: 1em;color: #444444 !important;position: relative;margin-bottom: 5px\" \ntranslate=\"USERADD.form_attr_photo\">form_attr_photo</label><div style=\"border: dashed 2px lightgray;margin-top: 20px\">\n<div id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" style=\"margin: 10px\"><md-button flow-btn \nstyle=\"border-radius:5px;background: #ecedf0;color: #7d7d7d;padding: 0 3em 0 3em;font-size:x-small\" \naria-label=\"form_add_file\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><any \nng-if=\"vm.empProfilesUserForm.connectionType === 0\">Choisir un fichier</any></md-button><label \nstyle=\"font-size:small; color: #7d7d7d\">Aucun fichier séléctionné</label></div></div></div><div ng-if=\"!vm.isNotBo\" \nlayout=\"row\" flex><md-input-container flex><md-button class=\"md-warn\" ui-sref=\"app.profiles_user_list\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button type=\"submit\" ng-if=\"vm.isNew\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"forms.empProfilesUserForm.$invalid || (forms.empProfilesUserForm.$pristine && !vm.profile_pic_not_pristine)\" \ntranslate=\"MESSAGES.form_add\" translate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button \ntype=\"submit\" ng-if=\"!vm.isNew\" class=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"forms.empProfilesUserForm.$invalid || (forms.empProfilesUserForm.$pristine && !vm.profile_pic_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button>\n</md-input-container></div><div ng-if=\"vm.isNotBo\" layout=\"row\" style=\"margin-top: 10px\" flex layout-align=\"end\">\n<md-button aria-label=\"form_cancel\" \nstyle=\"border-radius: 5px; background: #ecedf0;color: #7d7d7d;padding: 0 4em 0 4em;font-size: 1.25rem\"><span>Annuler\n</span></md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nstyle=\"border-radius: 5px;padding: 0 3em 0 3em;font-size: 1.25rem\"><span>Enregistrer</span></md-button></div></form>");
$templateCache.put("app/main/profiles/user/add_edit_view/form_edit_password.html","<form name=\"empProfilesUserFormChangePassword\" method=\"post\" id=\"empProfilesUserFormChangePassword\" \nnovalidate=\"novalidate\" ng-submit=\"\" class=\"e-commerce-product\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-pwd\" class=\"s18\"></md-icon><span translate=\"USERCHANGEPASSWORD.form_title\" \nstyle=\"padding: 5px;color: #7d7d7d;font-size: large;font-weight: bold\">form_title</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label \nclass=\"md-no-float\" translate=\"USERCHANGEPASSWORD.form_old_password\">Ancien mot de passe</label><input type=\"password\" \nid=\"empProfilesUserForm_plainPassword_first\" id=\"pw1\" name=\"empProfilesUserForm[plainPassword][first]\" \nrequired=\"required\" pattern=\"{{vm.patern}}\" ng-minlength=\"8\" ng-attr-name=\"plainPasswordfirst\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.plainPassword.first\" class=\"first\" \nplaceholder=\"{{\'USERCHANGEPASSWORD.form_old_password\'|translate}}\"><div \nng-messages=\"empProfilesUserForm.plainPasswordfirst.$error\" role=\"alert\"><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div \nng-if=\"vm.empProfilesUsersError.plainPasswordfirst && vm.empProfilesUserForm.plainPasswordfirst === vm.empProfilesUsersError.plainPasswordfirst.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordfirst.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERCHANGEPASSWORD.form_new_password\">Nouveau mot de passe</label><input type=\"password\" \nid=\"empProfilesUserForm_plainPassword_second\" id=\"pw2\" name=\"empProfilesUserForm[plainPassword][second]\" \nrequired=\"required\" pattern=\"{{vm.patern}}\" ng-minlength=\"8\" ng-attr-name=\"plainPasswordsecond\" translate=\"\" \nng-model=\"vm.empProfilesUserForm.plainPassword.second\" confirm-password=\"true\" \nplaceholder=\"{{\'USERCHANGEPASSWORD.form_new_password\'|translate}}\"><div \nng-messages=\"empProfilesUserForm.plainPasswordsecond.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div ng-message=\"confirmPassword\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">Les deux mots de passe ne sont pas identiques.</span></div><div \nng-if=\"vm.empProfilesUsersError.plainPasswordsecond  && vm.empProfilesUserForm.plainPasswordsecond === vm.empProfilesUsersError.plainPasswordsecond.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordsecond.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"end\"><md-button type=\"submit\" \nclass=\"md-accent md-raised\" style=\"border-radius: 5px;padding: 0 3em 0 3em;font-size: 1.25rem\" ng-click=\"\"><span>\nEnregistrer</span></md-button></div></form>");
$templateCache.put("app/main/profiles/user/add_edit_view/modalUser.html","<md-dialog id=\"modal_confirm\" style=\"min-width: 30%;min-height: 20%\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" style=\"height: 58px\"><h2><span translate=\"MESSAGES.alert_update_profile\"></span></h2></div>\n</md-toolbar><md-dialog-content style=\"text-align: center\"><div class=\"md-dialog-content\"><span \ntranslate=\"MESSAGES.user_valid\"></span></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span>\n<md-button class=\"md-raised md-primary md-accent\" ng-click=\"confirm()\" translate=\"MESSAGES.alert_confirm\">confirmer\n</md-button><md-button class=\"restored-btn\" ng-click=\"cancel()\" translate=\"MESSAGES.form_cancel\">alert_close\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/profiles/user/add_edit_view/quotas_facturation.html","<form name=\"empProfilesUserFormChangePassword\" method=\"post\" id=\"empProfilesUserFormChangePassword\" \nnovalidate=\"novalidate\" ng-submit=\"\" class=\"e-commerce-product\"><div layout=\"column\" flex><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-quotas\" class=\"s18\"></md-icon><span \nstyle=\"padding: 5px;color: #7d7d7d;font-size: large;font-weight: bold\">Quotas et facturation</span></div><div \nlayout=\"row\" align=\"center\" style=\"margin-top: 20px;margin-bottom: 20px\"><div layout=\"column\"><ng-gauge size=\"150\" \ntype=\"full\" thick=\"20\" min=\"0\" max=\"120\" value=\"40\" cap=\"round\" append=\"%\" foreground-color=\"#f5b159\" \nbackground-color=\"#EEE\"></ng-gauge><span style=\"color: #7d7d7d;font-size: medium\">40MO/1GO</span></div><div \nlayout=\"column\" style=\"margin: 20px\"><span style=\"color: #7d7d7d;font-size: small\" translate=\"QUOTAS.percentage_used\">\npercentage_used</span> <span style=\"color: #7d7d7d;font-size: medium;font-weight: bold\" \ntranslate=\"QUOTAS.get_more_space\">Obtenez plus d\'espace</span><md-button ui-sref=\"app.pricing\" \nstyle=\"border: 1px solid #7d7d7d !important;color:#7d7d7d\" translate=\"QUOTAS.upgrade\">Mettre à niveau</md-button></div>\n</div><hr style=\"height: 2px;background-color: #ecedf0;border: 0\" width=\"100%\"><div layout=\"column\" \nstyle=\"margin-top: 20px\"><span flex style=\"color: #7d7d7d;font-weight: bold\" translate=\"QUOTAS.latest_invoice\">\nDernière facture</span><div layout=\"row\" flex \nstyle=\"justify-content: space-between;margin-top: 20px;margin-bottom: 20px\"><span style=\"color: #7d7d7d\">05/12/2019\n</span> <span style=\"color: #7d7d7d;font-weight: bold\">150 Euro</span> <span style=\"color: #90c7a6\" \ntranslate=\"QUOTAS.paid\">Payé</span></div></div></div></form>");
$templateCache.put("app/main/profiles/user/form_new/add_edit.template.html","<form name=\"empProfilesUserForm\" method=\"post\" id=\"empProfilesUserForm\" novalidate=\"novalidate\" \nng-submit=\"empProfilesUserForm.$valid && vm.submitAddUserForm()\" class=\"e-commerce-product\"><div><div \nclass=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-compte\" class=\"s18\"></md-icon><span \ntranslate=\"USERADD.form_add_user_title\" style=\"padding: 5px;color: #7d7d7d;font-size: large;font-weight: bold\">\nform_add_user_title</span></div></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\" style=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_firstName\">Nom\n</label><input type=\"text\" id=\"empProfilesUserForm_firstName\" name=\"empProfilesUserForm[firstName]\" \nrequired=\"required\" ng-attr-name=\"firstName\" translate=\"\" ng-model=\"vm.empProfilesUserEditForm.firstName\" \naria-invalid=\"true\" placeholder=\"{{\'USERADD.form_attr_firstName\'|translate}}\"><div \nng-messages=\"empProfilesUserForm.firstName.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.firstName && vm.empProfilesUserEditForm.firstname === vm.empProfilesUsersError.firstname.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.firstName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_lastName\">Prénom</label><input type=\"text\" id=\"empProfilesUserForm_lastName\" \nname=\"empProfilesUserForm[lastName]\" required=\"required\" ng-attr-name=\"lastName\" translate=\"\" \nng-model=\"vm.empProfilesUserEditForm.lastName\" aria-invalid=\"true\" \nplaceholder=\"{{\'USERADD.form_attr_lastName\'|translate}}\"><div ng-messages=\"empProfilesUserForm.lastName.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.lastName && vm.empProfilesUserEditForm.lastName === vm.empProfilesUsersError.lastName.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.lastName.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nstyle=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_phone\">Phone</label><input \ntype=\"text\" id=\"empProfilesUserForm_phone\" name=\"empProfilesUserForm[phone]\" ng-attr-name=\"phone\" translate=\"\" \nng-pattern=\"^(0|(\\+33)|(0033))(([0-9]{10})|([0-9]{1}-[0-9]{4}-[0-9]{5}))$\" ng-minlength=\"10\" ng-maxlength=\"16\" \nng-model=\"vm.empProfilesUserEditForm.phone\" aria-invalid=\"true\" required \nplaceholder=\"{{\'USERADD.form_attr_phone\'|translate}}\"><div ng-messages=\"empProfilesUserForm.phone.$error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"pattern\" translate=\"MESSAGES.form_is_patternphone\"></div><div \nng-message=\"minlength\" translate=\"MESSAGES.form_is_minlength\">form_is_minlength</div><div ng-message=\"maxlength\" \ntranslate=\"MESSAGES.form_is_maxlength\">form_is_maxlength</div><div \nng-if=\"vm.empProfilesUsersError.phone && vm.empProfilesUserEditForm.phone === vm.empProfilesUsersError.phone.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.phone.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_email\">Email</label><input type=\"email\" id=\"empProfilesUserForm_email\" \nname=\"empProfilesUserForm[email]\" required=\"required\" ng-attr-name=\"email\" translate=\"\" \nng-model=\"vm.empProfilesUserEditForm.email\" aria-invalid=\"true\" placeholder=\"{{\'USERADD.form_attr_email\'|translate}}\">\n<div ng-messages=\"empProfilesUserForm.email.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"email\" translate=\"MESSAGES.form_is_email\">\nform_is_email</div><div \nng-if=\"vm.empProfilesUsersError.email && vm.empProfilesUserEditForm.email === vm.empProfilesUsersError.email.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.email.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><md-input-container class=\"md-block\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_adress\">Adresse</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empProfilesUserForm_adress\" name=\"empProfilesUserForm[adresse]\" ng-attr-name=\"adresse\" rows=\"5\" max-rows=\"8\" \nmd-maxlength=\"450\" ng-model=\"vm.empProfilesUserEditForm.adresse\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\" placeholder=\"{{\'USERADD.form_attr_adress\'|translate}}\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"empProfilesUserForm.adresse.$error\" role=\"alert\"><div \nng-message=\"maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div><div \nng-if=\"vm.empProfilesUsersError.adresse && vm.empProfilesUserEditForm.adresse === vm.empProfilesUsersError.adresse.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.adress.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nstyle=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_city\">Ville</label><input \ntype=\"text\" id=\"empProfilesUserForm_city\" name=\"empProfilesUserForm[city]\" required=\"required\" \nng-attr-name=\"postalCode\" translate=\"\" ng-model=\"vm.empProfilesUserEditForm.city\" aria-invalid=\"true\" \nplaceholder=\"{{\'USERADD.form_attr_city\'|translate}}\"><div ng-messages=\"empProfilesUserForm.group.$error\" role=\"alert\" \nmd-auto-hide=\"false\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.city && vm.empProfilesUserEditForm.city === vm.empProfilesUsersError.city.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.city.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_postalCode\">Code postal</label><input type=\"text\" id=\"empProfilesUserForm_postalCode\" \nname=\"empProfilesUserForm[postalCode]\" required=\"required\" ng-attr-name=\"postalCode\" translate=\"\" \nng-model=\"vm.empProfilesUserEditForm.postalCode\" aria-invalid=\"true\" \nplaceholder=\"{{\'USERADD.form_attr_postalCode\'|translate}}\"><div ng-messages=\"empProfilesUserForm.postalCode.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesUsersError.postalCode && vm.empProfilesUserEditForm.postalCode === vm.empProfilesUsersError.postalCode.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.postalCode.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" \nstyle=\"padding-right: 15px\"><label class=\"md-no-float\" translate=\"USERADD.form_attr_company\">Société</label><input \ntype=\"text\" id=\"empProfilesUserForm_company\" name=\"empProfilesUserForm[society]\" ng-attr-name=\"society\" translate=\"\" \nng-model=\"vm.empProfilesUserEditForm.society\" aria-invalid=\"true\" \nplaceholder=\"{{\'USERADD.form_attr_company\'|translate}}\"><div ng-messages=\"empProfilesUserForm.society.$error\" \nrole=\"alert\"><div \nng-if=\"vm.empProfilesUsersError.society && vm.empProfilesUserEditForm.society === vm.empProfilesUsersError.society.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.company.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERADD.form_attr_numberPersons\">Nombre de personne</label><input type=\"number\" \nid=\"empProfilesUserForm_numberPerson\" name=\"empProfilesUserForm[numberPerson]\" ng-attr-name=\"numberPerson\" \ntranslate=\"\" ng-model=\"vm.empProfilesUserEditForm.numberPerson\" aria-invalid=\"true\" min=\"1\" max=\"5\" \nplaceholder=\"Entre 5-10\"></md-input-container></div><div style=\"margin-top: 20px\"><label \nstyle=\"font-size: 1em;color: #444444 !important;position: relative;margin-bottom: 5px\" \ntranslate=\"USERADD.form_attr_photo\">form_attr_photo</label><div style=\"border: dashed 2px lightgray;margin-top: 20px\" \nlayout=\"column\" layout-gt-xs=\"row\" class=\"resize\" layout-align=\"space-around p-5\"><div layout=\"column\" flex=\"100\" \nlayout-gt-xs=\"row\" layout-align=\"start center\" ng-show=\"vm.cropped.source===\'\'\"><md-button \nstyle=\"border-radius:5px;background: #ecedf0;color: #7d7d7d;padding: 0 3em 0 3em;font-size:x-small\" \naria-label=\"form_add_file\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><any \ntranslate=\"MESSAGES.choose\">Choisir un fichier</any><input type=\"file\" id=\"upload\" accept=\"image/*\" \nfile-on-change=\"vm.uploadUserAvatar\"></md-button><label translate=\"MESSAGES.fileSelected\" \nstyle=\"font-size:small; color: #7d7d7d\">\n{{vm.empProfilesUserEditForm.vignette ? vm.empProfilesUserEditForm.vignette : \'Aucun fichier séléctionné\'}}</label>\n</div><div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"space-around p-5\" ng-show=\"vm.cropped.source\" \nstyle=\"width: 80%\"><div layout=\"column\" layout-align=\"space-around\"><div layout=\"column\" layout-align=\"space-around\">\n<img ng-src=\"assets/icons/shape.svg\" class=\"shape\"> <span class=\"resizeText mt-15\" translate=\"MESSAGES.resizeText\">\nRedimentionner votre image choisie</span></div><md-button class=\"returnUpload\" aria-label=\"returnUpload\" translate \nng-click=\"vm.returnToUpload()\"><span translate=\"MESSAGES.return\">Retour</span></md-button></div><croppie \nng-model=\"vm.cropped.image\" src=\"vm.cropped.source\" options=\"{boundary:{width:234,height:180}}\" zoom=\"vm.cropped.zoom\">\n</croppie><div class=\"preview\"><div class=\"previewImg\"><img ng-src=\"{{vm.cropped.image}}\"></div><span \ntranslate=\"MESSAGES.preview\">Aperçu</span><md-button class=\"returnUpload\" aria-label=\"returnUpload\" translate \nng-click=\"vm.uploadFile()\"><span translate=\"MESSAGES.form_validate\">Valider</span></md-button></div></div></div></div>\n<div layout=\"row\" style=\"margin-top: 10px\" flex layout-align=\"end\"><md-button aria-label=\"form_cancel\" \nstyle=\"border-radius: 5px; background: #ecedf0;color: #7d7d7d;padding: 0 4em 0 4em;font-size: 1.25rem\" \nng-click=\"vm.goBack()\"><span translate=\"MESSAGES.cancel\">Annuler</span></md-button><md-button type=\"submit\" \nclass=\"md-warn md-raised\" style=\"border-radius: 5px;padding: 0 3em 0 3em;font-size: 1.25rem\"><span \ntranslate=\"MESSAGES.save\">Enregistrer</span></md-button></div></form>");
$templateCache.put("app/main/profiles/user/form_new/password_edit.html","<form name=\"empProfilesUserFormChangePassword\" method=\"post\" id=\"empProfilesUserFormChangePassword\" \nnovalidate=\"novalidate\" ng-submit=\"empProfilesUserFormChangePassword.$valid && vm.submitEditPasswordUserForm()\" \nclass=\"e-commerce-product\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-pwd\" class=\"s18\">\n</md-icon><span translate=\"USERCHANGEPASSWORD.form_title\" \nstyle=\"padding: 5px;color: #7d7d7d;font-size: large;font-weight: bold\">form_title</span></div><div layout=\"column\" \nlayout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\" style=\"padding-right: 15px\"><label \nclass=\"md-no-float\" translate=\"USERCHANGEPASSWORD.form_new_password\">Nouveau mot de passe</label><input \ntype=\"password\" id=\"empProfilesUserForm_plainPassword_first\" id=\"pw1\" \nname=\"empProfilesUserFormChangePassword[plainPassword][first]\" required=\"required\" pattern=\"{{vm.patern}}\" \nng-minlength=\"8\" ng-attr-name=\"plainPasswordfirst\" translate=\"\" \nng-model=\"vm.empProfilesUserEditPasswordForm.plainPassword.first\" class=\"first\" \nplaceholder=\"{{\'USERCHANGEPASSWORD.form_new_password\'|translate}}\"><div \nng-messages=\"empProfilesUserFormChangePassword.plainPasswordfirst.$error\" role=\"alert\"><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div \nng-if=\"vm.empProfilesUsersError.plainPassword.first && vm.empProfilesUserEditPasswordForm.plainPassword.first === vm.empProfilesUsersError.plainPassword.first.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordfirst.message}}\" class=\"validation_api\"></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><label class=\"md-no-float\" \ntranslate=\"USERPASSWORD.form_attr_second\">Repeter le mot de passe</label><input type=\"password\" \nid=\"empProfilesUserForm_plainPassword_second\" id=\"pw2\" name=\"empProfilesUserFormChangePassword[plainPassword][second]\" \nrequired=\"required\" pattern=\"{{vm.patern}}\" ng-minlength=\"8\" ng-attr-name=\"plainPasswordsecond\" translate=\"\" \nng-model=\"vm.empProfilesUserEditPasswordForm.plainPassword.second\" confirm-password=\"true\" \nplaceholder=\"{{\'USERPASSWORD.form_attr_second\'|translate}}\"><div \nng-messages=\"empProfilesUserFormChangePassword.plainPasswordsecond.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"minlength\" \ntranslate=\"MESSAGES.form_is_minlengthpwd\">form_is_minlengthpwd</div><div ng-message=\"pattern\" \ntranslate=\"{{vm.msgErrorPatern}}\">form_is_patternpwd</div><div ng-message=\"confirmPassword\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">Les deux mots de passe ne sont pas identiques.</span></div><div \nng-if=\"vm.empProfilesUsersError.plainPassword.second  && vm.empProfilesUserEditPasswordForm.plainPassword.second === vm.empProfilesUsersError.plainPassword.second.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesUsersError.plainPasswordsecond.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"row\" flex layout-align=\"end\"><md-button type=\"submit\" \nclass=\"md-warn md-raised\" \nng-disabled=\"empProfilesUserFormChangePassword.$invalid || empProfilesUserFormChangePassword.$pristine\" \nstyle=\"border-radius: 5px;padding: 0 3em 0 3em;font-size: 1.25rem\" ng-click=\"\"><span translate=\"MESSAGES.save\">\nEnregistrer</span></md-button></div></form>");
$templateCache.put("app/main/profiles/user/list/list.template.html","<md-content id=\"modal\" autoscroll=\"false\" ui-view=\"modal\"></md-content><div ng-if=\"!vm.isNew_User\" \nid=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div layout=\"row\" layout-align=\"end end\" has-permission=\"profiles_user_post_add\"></div><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\" flex=\"20\" has-permission=\"profiles_user_delete_multi\" ng-if=\"vm.selectedUsers.length\"><a \nng-style=\"myObjStyle\" tooltips tooltip-template=\"{{\'USERLIST.delete_users\'|translate}}\" tooltip-side=\"right\" \ntooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedUserConfirm($event)\" aria-label=\"delete_user_aria_label\" translate \ntranslate-attr-aria-label=\"USERLIST.delete_user_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div layout=\"column\" ng-if=\"vm.groups.length\" flex=\"\">\n<md-card-content style=\"margin-left: 18px\"><md-select id=\"filtreGroupSelect\" ng-model=\"vm.filtreGroupSelect\" \nng-attr-name=\"group\" ng-change=\"vm.groupFiltreSelected()\" placeholder=\"{{ \'GROUPADD.form_attr_name\'|translate}}\">\n<md-option ng-repeat=\"group in vm.groups track by group.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"group.option\">\n{{group.option}}</md-option></md-select></md-card-content></div><div layout=\"row\" flex=\"\"><md-input-container \nmd-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\">\n</md-icon><input id=\"users-search\" class=\"search-input\" type=\"text\" placeholder=\"Search\" \nng-model=\"vm.dataTableSearchWord\" ng-keydown=\"$event.keyCode === 13 && vm.searchUsers()\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex></md-input-container></div><md-button id=\"app-add-element-btn\" \nclass=\"add-module-button btn-add md-accent md-raised\" ng-click=\"vm.addNewUser($event)\" aria-label=\"action_new_element\" \nhas-permission=\"profiles_user_post_add\"><div class=\"span-btn-add\" layout=\"row\" layout-align=\"center center\"><svg \nxmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" viewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedUsers.length === vm.users.length) && (vm.selectedUsers.length > 0)\" \nmd-indeterminate=\"vm.selectedUsers.length !== 0 && vm.selectedUsers.length !== vm.users.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"USERLIST.username\">username</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"USERLIST.email\">name</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"USERLIST.groups\">groups</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"USERADD.form_attr_lastName\">lastName\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"USERLIST.firstName\">firstName</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"USERLIST.last_login\">last_login\n</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div>\n</div></div><div ng-if=\"vm.isNew_User\" id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" \nlayout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" flex><div style=\"margin-bottom: 2px\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden;height: 1000px\" layout=\"row\" layout-wrap><iframe id=\"iframe_segment_display\" \nng-src=\"{{vm.UserIframe}}\" allowfullscreen frameborder=\"0\" style=\"width: 100%;height: 100%;overflow: hidden\"></iframe>\n</div></div></div></div>");
$templateCache.put("app/main/profiles/user/profilConnectedV2/profile-connected-v2.html","<div id=\"e-commerce-products\" class=\"page-layout-video page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex style=\"height: 100%;padding: 0!important\"><div \nstyle=\"margin-bottom: 2px; height: 100%\" \nclass=\"new-list-videos ng-scope content-card fullpage layout-column search-wrapper md-whiteframe-4dp flex\"><div \nstyle=\"overflow: hidden; height: 100%\" layout=\"row\" layout-wrap><iframe id=\"iframe_profile\" \niframe-onload=\"iframeLoadedCallBack()\" ng-src=\"{{vm.urlProfileList}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div></div>");
$templateCache.put("app/main/profiles/user/profilconnected/edit.modal.template.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\" name=\"empProfilesUserEditForm\" \nmethod=\"post\" id=\"empProfilesUserEditForm\" novalidate=\"novalidate\" \nng-submit=\"empProfilesUserEditForm.$valid && vm.submitAddUserForm()\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"USERPROFILE.edit_userconnected\">Modifier Utilisateur</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"form-title\" \nng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"USERADD.form_title\">form_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon \nmd-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"USEREDIT.form_title\">form_title</span></div><input \ntype=\"hidden\" id=\"empProfilesUserForm_vignette\" name=\"empProfilesUserForm[vignette]\" \nng-model=\"vm.empProfilesUserForm.vignette\" aria-invalid=\"false\"><div ng-if=\"vm.urlVignette==\'\'\" \nlayout-align=\"left left\" layout=\"row\" class=\"s18\"><img class=\"profile-image avatar huge\" style=\"margin-left: 70px\" \nng-src=\"{{vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"></div><div \nng-if=\"vm.urlVignette\" layout=\"row\" class=\"s18\"><img class=\"profile-image avatar huge\" style=\"margin-left: 70px\" \nng-src=\"{{vm.urlVignette}}\"></div><div class=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \nng-if=\"vm.empProfilesUserForm.connectionType === 0\" translate=\"USERADD.choose_thumb\">choose_thumb</any><any \nng-hide=\"vm.empProfilesUserForm.connectionType === 0\" translate=\"USEREDIT.choose_thumb\">choose_thumb</any></md-button>\n</div><md-input-container class=\"md-block to\"><label translate=\"USERPROFILE.first_name\">Nom</label><input type=\"text\" \nmd-autofocus required=\"required\" id=\"empProfilesUserEditForm_firstName\" name=\"empProfilesUserEditForm[firstName]\" \nng-model=\"vm.empProfilesUserEditForm.firstName\" \nng-pattern=\"/^([a-zA-Z \\u00C0-\\u00FF]+[\'-]?[a-zA-Z \\u00C0-\\u00FF]+){1,30}$/\" ng-attr-name=\"firstName\"><div \nng-messages=\"empProfilesUserEditForm.firstName.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_pattern_fullname\">form_is_pattern_fullname</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USERPROFILE.last_name\">prénom</label><input type=\"text\" required=\"required\" \nid=\"empProfilesUserEditForm_lastName\" name=\"empProfilesUserEditForm[lastName]\" \nng-model=\"vm.empProfilesUserEditForm.lastName\" \nng-pattern=\"/^([a-zA-Z \\u00C0-\\u00FF]+[\'-]?[a-zA-Z \\u00C0-\\u00FF]+){1,30}$/\" ng-attr-name=\"lastName\"><div \nng-messages=\"empProfilesUserEditForm.lastName.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_pattern_fullname\">form_is_pattern_fullname</div><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USERPROFILE.mobile\">Mobile</label><input type=\"text\" \nid=\"empProfilesUserEditForm_mobile\" name=\"empProfilesUserEditForm[mobile]\" \nng-model=\"vm.empProfilesUserEditForm.mobile\" ng-pattern=\"/^\\d+$/\" ng-minlength=\"10\" md-maxlength=\"10\" \nng-attr-name=\"mobile\"><div ng-messages=\"empProfilesUserEditForm.mobile.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.form_is_patternphone\">form_is_patternphone</div><div ng-message=\"md-maxlength\"><span \ntranslate=\"USERPHONE.ERRORS.PHONE_MAX_LENGTH\" translate-value-length=\"10\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPHONE.ERRORS.PHONE_MIN_LENGTH\" translate-value-length=\"10\">\nCe champ doit comporter au moins {{length}} caractères.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USERPROFILE.tel\">Tél</label><input ng-model=\"vm.empProfilesUserEditForm.phone\" \nng-pattern=\"/^\\d+$/\" ng-minlength=\"10\" md-maxlength=\"10\" ng-attr-name=\"phone\" id=\"empProfilesUserEditForm_phone\" \nname=\"phone\" type=\"text\"><div ng-messages=\"empProfilesUserEditForm.phone.$error\" role=\"alert\"><div \nng-message=\"pattern\" translate=\"MESSAGES.form_is_patternphone\">form_is_patternphone</div><div \nng-message=\"md-maxlength\"><span translate=\"USERPHONE.ERRORS.PHONE_MAX_LENGTH\" translate-value-length=\"10\">\nCe champ doit comporter au plus {{length}} chiffres.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPHONE.ERRORS.PHONE_MIN_LENGTH\" translate-value-length=\"10\">\nCe champ doit comporter au moins {{length}} chiffr.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"USERPROFILE.description\">Description</label><div class=\"md-resize-wrapper\"><textarea\n irequired=\"required\" id=\"empProfilesUserEditForm_description\" name=\"empProfilesUserEditForm[descrption]\" \nng-model=\"vm.empProfilesUserEditForm.description\" name=\"empProfilesUserEditForm[description]\" \nng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\">\n        </textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empProfilesUserEditForm.description.$error\" role=\"alert\"><div ng-message=\"maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div></div></md-input-container><div \nlayout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.channels.length\"><md-card-content flex><md-select translate \ntranslate=\"MESSAGES.form_attr_canal\" name=\"empProfilesUserEditForm[channels][]\" id=\"empProfilesUserEditForm_channels\" \nng-model=\"vm.empProfilesUserEditForm.channels\" multiple=\"1\" ng-attr-name=\"channels\" \nplaceholder=\"{{ \'USERADD.form_attr_channel\'|translate}}\"><md-option \nng-repeat=\"channel in vm.channels track by channel.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"channel.val\">\n{{ channel.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" layout-gt-xs=\"row\" \nng-if=\"vm.groups.length\" has-permission=\"profiles_group_list_dtable\"><md-card-content flex><md-select translate \ntranslate=\"MESSAGES.form_attr_canal\" name=\"empProfilesUserEditForm[group][]\" id=\"empProfilesUserEditForm_group\" \nng-model=\"vm.empProfilesUserEditForm.group\" required=\"1\" ng-attr-name=\"group\" \nplaceholder=\"{{ \'USERADD.form_attr_groups\'|translate}}\"><md-option ng-repeat=\"group in vm.groups track by group.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"group.val\">{{group.option}}</md-option></md-select><div \nng-messages=\"empProfilesUserEditForm.group.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-card-content></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" ng-if=\"!vm.isNew\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empProfilesUserEditForm.$invalid || (empProfilesUserEditForm.$pristine && !vm.profile_pic_not_pristine)\" \ntranslate=\"USERPROFILE.validate\" translate-attr-aria-label=\"USERPROFILE.validate\">form_validate</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/profiles/user/profilconnected/edit.password.modal.template.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\" \nname=\"empProfilesUserEditPasswordForm\" method=\"post\" id=\"empProfilesUserEditPasswordForm\" novalidate=\"novalidate\" \nng-submit=\"empProfilesUserEditPasswordForm.$valid && vm.submitEditPasswordUserForm()\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"USERLIST.update_pwd_user\">Modifier le mot de passe</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"USERADD.form_attr_first\">Mot de passe</label><input \ntype=\"password\" name=\"first\" ng-minlength=\"8\" md-maxlength=\"20\" pattern=\"{{vm.patern}}\" required \nng-model=\"vm.empProfilesUserEditPasswordForm.plainPassword.first\" class=\"first\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesUserEditPasswordForm.first.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_REQUIRED\">Le champ Mot de passe (Confirmer) est requis</span></div><div \nng-message=\"md-maxlength\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"USERPASSWORD.form_attr_second\">Repeat Password</label><input type=\"password\" required=\"required\" \nname=\"second\" ng-model=\"vm.empProfilesUserEditPasswordForm.plainPassword.second\" confirm-password=\"true\" \nng-minlength=\"8\" md-maxlength=\"20\" pattern=\"{{vm.patern}}\" aria-invalid=\"true\"><div \nng-messages=\"empProfilesUserEditPasswordForm.second.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Le champ Mot de passe (Confirmer) est requis</span></div><div\n ng-message=\"md-maxlength\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div><div \nng-message=\"confirmPassword\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">\nLes deux mots de passe ne sont pas identiques.</span></div></div></md-input-container></div><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\" style=\"border:none\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" class=\"md-raised md-accent\" \naria-label=\"form_validate\" \nng-disabled=\"empProfilesUserEditPasswordForm.$invalid || (empProfilesUserEditPasswordForm.$pristine && !vm.profile_pic_not_pristine)\" \ntranslate=\"USERPROFILE.validate\" translate-attr-aria-label=\"USERPROFILE.validate\">form_validate</md-button></div>\n</md-dialog-actions></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/profiles/user/profilconnected/profilconnected.template.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" \nng-src=\"{{vm.user.vignette ? vm.user.vignette : \'assets/images/avatars/profile.jpg\' }}\"><div class=\"name\">\n{{vm.getFullName}}</div></div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.editDialog($event)\" aria-label=\"Follow\" translate=\"USERPROFILE.edit\" \nhas-permission=\"profiles_user_post_edit_connected_user\">Modifier</md-button><md-button class=\"md-raised md-accent\" \nng-click=\"vm.editPasswordDialog($event)\" aria-label=\"Follow\" translate=\"USERPROFILE.edit_password\" \nhas-permission=\"profiles_user_post_edit_connected_user\">Modifier mot de passe</md-button></div></div><div \nclass=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span translate=\"USERPROFILE.about\">Detail</span>\n</md-tab-label><md-tab-body><md-content class=\"about-tab\"><div layout=\"row\" layout-wrap><div class=\"about\" \nlayout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div class=\"profile-box info-box general md-whiteframe-1dp\" \nlayout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" translate=\"USERPROFILE.general_information\">\nInformation Generale</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERPROFILE.first_name\">Nom</div><div class=\"info\">{{vm.user.firstName}}</div></div><div class=\"info-line\">\n<div class=\"title\" translate=\"USERPROFILE.last_name\">Prenom</div><div class=\"info\">{{vm.user.lastName}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"USERPROFILE.description\">Description</div><div \nng-if=\"!vm.user.description\" md-colors=\"{color:\'#000000\'}\" translate=\"MESSAGES.none\">none</div><div \nng-if=\"vm.user.description\"><div class=\"info\"><span>{{vm.user.description}}</span></div></div></div></div></div><div \nclass=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"USERPROFILE.contact\">Contact</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERPROFILE.tel\">Tel.</div><div ng-if=\"!vm.user.phone\" md-colors=\"{color:\'#000000\'}\" \ntranslate=\"MESSAGES.none\">none</div><div ng-if=\"vm.user.phone\"><div class=\"info\"><span>{{vm.user.phone}}</span></div>\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"USERPROFILE.mobile\">Mobile.</div><div \nng-if=\"!vm.user.mobile\" md-colors=\"{color:\'#000000\'}\" translate=\"MESSAGES.none\">none</div><div ng-if=\"vm.user.mobile\">\n<div class=\"info\"><span>{{vm.user.mobile}}</span></div></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"USERPROFILE.email\">Email</div><div ng-if=\"!vm.user.email\" md-colors=\"{color:\'#000000\'}\" \ntranslate=\"MESSAGES.none\">none</div><div ng-if=\"vm.user.email\"><div class=\"info\"><span>{{vm.user.email}}</span></div>\n</div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\">\n<div class=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"USERPROFILE.joined_groups\">Groupes enregistrés</div>\n</header><div class=\"content\"><div class=\"group\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"!vm.user.group\" md-colors=\"{color:\'#000000\'}\" translate=\"MESSAGES.none\">none\n</div><div ng-if=\"vm.user.group\"><div class=\"info\"><span>{{vm.user.group.name}}</span></div></div></div></div></div>\n</div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"35\"><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"USERPROFILE.canaux\">Vos canaux</div></header><div \nclass=\"content\"><div class=\"group\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div ng-if=\"!vm.user.channels\" md-colors=\"{color:\'#000000\'}\" translate=\"MESSAGES.none\">none\n</div><div ng-if=\"vm.user.channels\"><div class=\"info\" ng-repeat=\"channel in vm.user.channels\"><span>{{channel.title}}\n</span></div></div></div></div></div></div></div></div></md-content></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/profiles/user/profilconnected/profile-conceted-v2.html","<div layout=\"column\" layout-xs=\"column\" layout-gt-md=\"row\" style=\"margin: 43px\"><div id=\"e-commerce-product\" \nclass=\"e-commerce-product page-layout simple fullwidth IE-add-user\" layout=\"column\" flex=\"100\" flex-gt-md=\"60\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" layout-align=\"space-between\" flex><div \nng-include=\"\'app/main/profiles/user/form_new/add_edit.template.html\'\"></div></div></div></div></div><div \nclass=\"content fullpage\" ng-if=\"vm.quotasPermission\" layout=\"column\" \nng-controller=\"EditPasswordUserConnectedController as vm\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" \nlayout-align=\"space-between\" flex><div ng-include=\"\'app/main/profiles/user/form_new/password_edit.html\'\"></div></div>\n</div></div></div></div><div ng-if=\"!vm.quotasPermission\" class=\"page-layout simple fullwidth IE-add-user\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"40\"><div class=\"content fullpage\" layout=\"column\" \nng-controller=\"EditPasswordUserConnectedController as vm\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" \nlayout-align=\"space-between\" flex><div ng-include=\"\'app/main/profiles/user/form_new/password_edit.html\'\"></div></div>\n</div></div></div></div><div ng-if=\"vm.quotasPermission\" class=\"page-layout simple fullwidth IE-add-user\" \nlayout=\"column\" flex=\"100\" flex-gt-md=\"30\"><div class=\"content fullpage\" layout=\"column\" \nhas-permission=\"profiles_user_quotas\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" layout-align=\"space-between\" flex><div \nng-include=\"\'app/main/profiles/user/add_edit_view/quotas_facturation.html\'\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/media/video/upload/preview-modal.template.html","<md-dialog class=\"event-form-dialog\" aria-label=\"ariaLabelTitle\" style=\"width: 69%;\n    height: max-content\">\n<md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span \ntranslate=\"MESSAGES.video_preview\">Preview of the video</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"height: 100%;width: 100%; overflow: hidden\" class=\"no-padding content-video\">\n<div \nng-style=\"{\n    \'text-align\': \'center\',\n    \'padding\': \'1em 1em\',\n    \'box-sizing\': \'border-box\',\n     \'position\': \'relative\',\n    \'padding-top\': \'48%\',\n    \'overflow\': \'hidden\'}\">\n<iframe id=\"iframe-player\" style=\"position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%\" \nwidth=\"800\" height=\"400\" ng-src=\"{{vm.playerLink}}\" frameborder=\"0\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" ; webkitallowfullscreen \nmozallowfullscreen allowfullscreen></iframe></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.closeDialog()\" \ntranslate=\"MESSAGES.alert_close\">CLOSE</md-button><md-button ng-if=\"!vm.reupload\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" ng-click=\"vm.add()\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"vm.reupload\" \nclass=\"md-accent md-raised md-button ng-scope md-default-theme md-ink-ripple\" aria-label=\"Submit\" \nng-click=\"vm.change_video_source()\" translate=\"MESSAGES.form_step_validate\">form_add</md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/media/video/upload/upload.template.html","<div ng-show=\"state.current.url===\'/medias/videos/upload\'\" id=\"e-commerce-product\" \nclass=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><style>\n.my-drop-zone {\n            border: dotted 3px lightgray;\n        }\n\n        .nv-file-over {\n            border: dotted 3px red;\n        }\n\n        /* Default class applied to drop zones on over */\n        .another-file-over-class {\n            border: dotted 3px green;\n        }\n\n        html, body {\n            height: 100%;\n        }\n</style><div class=\"content fullpage\" layout=\"column\"><md-tabs id=\"tab-upload\" md-dynamic-height md-border-bottom \nmd-selected=\"$root.index\"><md-tab><md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-upload-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" \ntranslate=\"VIDEOADD.upload_local\"></span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\" \nstyle=\"height: 100%\"><div ng-if=\"vm.uploadMetaDataError\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"center center\">\n<span class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.alert_xhr_error\">alert_xhr_error\n</span></div></div></div><div class=\"mv-24\" ng-if=\"vm.uploadMetaDataError\"></div><div ng-if=\"!vm.isMultiUpload\" \nlayout-padding layout-margin \nng-style=\"vm.ngFlowOptions.target===0 && {border: \'2px dashed rgba(0,0,0,0.15)\',     background: \'rgb(245,245,245)\'}\" \nclass=\"product-detail-form-container\"><iframe ng-if=\"vm.urlUpload\" \nstyle=\"position: absolute;top: 0;left: 0;width: 99%;height: 93%\" width=\"800\" height=\"500\" ng-src=\"{{vm.urlUpload}}\" \nframeborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe><div \nng-if=\"vm.ngFlowOptions.target && !vm.urlUpload\" class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.fileProgress($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-icon style=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" \nmd-font-icon=\"icon-cloud-upload\" class=\"s24\"></md-icon><md-button style=\"margin-top: 15px\" flow-btn \nng-disabled=\"vm.inProgress\"><span style=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" \ntranslate=\"MESSAGES.choose_a_file\">choose_a_file</span></md-button><md-button class=\"md-warn md-flat\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUpload()\" ng-if=\"vm.inProgress\">form_cancel</md-button><div \nstyle=\"padding-top: 10px\"><md-checkbox ng-model=\"vm.automatic_addition\" aria-label=\"isVisibleOnInternet\"><label \ntranslate=\"MESSAGES.automatic_add_video\"></label></md-checkbox></div><span \nclass=\"secondary-text mt-8 text-center text-truncate\" translate=\"MESSAGES.video_upload_drop_message\">\nvideo_upload_drop_message</span><br><span class=\"secondary-text mt-8 text-center text-truncate\" style=\"color:red\" \ntranslate=\"MESSAGES.video_upload_max\">video_upload_max</span></div><div layout=\"row\" layout-align=\"center center\" \nlayout-wrap ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\"><p class=\"secondary-text mt-8 text-center\"><strong>\n{{vm.videoFile.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgress\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" value=\"{{vm.progressBarValue}}\">\n</md-progress-circular></div></div></div></div></div><div><div ng-if=\"vm.isMultiUpload && uploader.url\" \nnv-file-drop=\"\" uploader=\"uploader\"><iframe ng-if=\"vm.urlUpload\" \nstyle=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%\" width=\"800\" height=\"600\" \nng-src=\"{{vm.urlUpload}}\" frameborder=\"0\" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe><div \nstyle=\"height: 280px;text-align: center;padding-bottom: 5px;padding-top: 15px\" \nng-if=\"vm.ngFlowOptions.target && !vm.urlUpload\" layout=\"column\" nv-file-over=\"\" uploader=\"uploader\" \nover-class=\"another-file-over-class\" class=\"well my-drop-zone\"><md-icon \nstyle=\"padding-right: 65px; font-size: 65px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><div><input class=\"ng-hide\" id=\"input-file-id\" type=\"file\" nv-file-select=\"\" uploader=\"uploader\" \nmultiple=\"multiple\"><label for=\"input-file-id\" class=\"md-button md-raised md-primary\" \ntranslate=\"MESSAGES.choose_a_file\">Choose Files</label></div><div style=\"padding-top: 25px\"><md-checkbox \nng-model=\"vm.automatic_addition\" aria-label=\"isVisibleOnInternet\"><label translate=\"MESSAGES.automatic_add_video\">\n</label></md-checkbox><span class=\"secondary-text mt-8 text-center text-truncate\" \ntranslate=\"MESSAGES.video_upload_drop_message\">video_upload_drop_message</span> <span \nclass=\"secondary-text mt-8 text-center text-truncate\" style=\"color:red\" translate=\"MESSAGES.video_upload_max\">\nvideo_upload_max</span></div></div></div></div><div ng-if=\"uploader.queue && vm.isMultiUpload\" class=\"todo-items\"><div \nclass=\"md-padding\" layout-wrap layout=\"row\"><div style=\"position: relative\" ng-repeat=\"(key,item) in uploader.queue\" \nlayout=\"column\"><md-button style=\"position: absolute;left: 136px;top: -13px\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"item.remove()\"><svg aria-hidden=\"true\" class=\"UppyIcon\" width=\"20\" height=\"30\" viewBox=\"0 0 60 60\" \nxmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" fill-rule=\"nonzero\" \nvector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\"></path><path \nfill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card ng-click=\"vm.goToAddPageMulti(item.file.name,item, true)\" id=\"mdcard\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);!important;width: 154px\">\n<div ng-class=\"{ \'image-resize md-accent-bg\' : vm.isFM}\"><img ng-class=\"{ \'upload-image \' : vm.isFM}\" \nng-src=\"assets/images/upload.svg\"></div><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\">\n<div layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item.file.name}}\" \nstyle=\"font-size: 0.87em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item.file.name}}</span> <span title=\"{{item.file.name}}\" \nstyle=\"font-size: 0.75em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis\" class=\"name\">\n{{item.file.size/1024/1024|number:2}} MB</span></div></md-card-actions></md-card></div></div></div><div \nng-if=\"$root.addedMultiUpload && $root.uploader_queue && vm.isMultiUpload && !$root.uploadedFiles\" class=\"todo-items\">\n<div class=\"md-padding\" layout-wrap layout=\"row\"><div style=\"position: relative\" \nng-repeat=\"(key,item) in $root.uploader_queue\" layout=\"column\"><md-button \nstyle=\"position: absolute;left: 136px;top: -13px\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.removeItemUpload(item)\"><svg aria-hidden=\"true\" class=\"UppyIcon\" width=\"20\" height=\"30\" \nviewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" fill-rule=\"nonzero\" \nvector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\"></path><path \nfill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card ng-click=\"vm.goToAddPageMulti(item.file.name,item, true)\" id=\"mdcard\" \nstyle=\"background: #0000000a;;  cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);!important;width: 154px\">\n<div ng-class=\"{ \'image-resize md-accent-bg\' : vm.isFM}\"><img ng-class=\"{ \'upload-image \' : vm.isFM}\" \nng-src=\"assets/images/upload.svg\"></div><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\">\n<div layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item.file.name}}\" \nstyle=\"font-size: 0.87em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item.file.name}}</span> <span title=\"{{item.file.name}}\" \nstyle=\"font-size: 0.75em;width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis\" class=\"name\">\n{{item.file.size/1024/1024|number:2}} MB</span></div></md-card-actions></md-card></div></div></div></md-content><div \nstyle=\"text-align: right\" ng-if=\"uploader.queue.length\"><span ng-if=\"uploader.progress>0\" \nng-class=\"{\'md-primary-fg\': vm.isFM}\" style=\"color: #039BE5;font-weight: bold;font-size: 16px\">{{uploader.progress}}%\n</span><div ng-if=\"uploader.progress>0 && uploader.isUploading\" style=\"width: 96%;text-align: center;margin-left: 1%\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{uploader.progress}}\"></md-progress-linear></div><md-button \nclass=\"md-warn\" ng-click=\"vm.clearUpload()\" ng-disabled=\"!uploader.queue.length\" translate=\"MESSAGES.dialog_cancel\">\nRemove all</md-button></div></md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_extern_link\">\n<md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-link-custom\">\n</md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"VIDEOADD.video_link\"></span>\n</div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div ng-if=\"vm.uploadMetaDataExternalError\" \nlayout=\"row\" layout-align=\"center center\"><div class=\"md-whiteframe-1dp md-background-bg p-24\" flex=\"50\" flex-xs=\"100\">\n<div layout=\"row\" layout-align=\"center center\"><span \nng-if=\"vm.uploadMetaDataExternalError && vm.uploadMetaDataExternalError!==\'dailymotion\' && vm.uploadMetaDataExternalError!==\'youtube\' \" \nclass=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.alert_url_video_error\">alert_xhr_error\n</span> <span ng-if=\"vm.uploadMetaDataExternalError ===\'youtube\'\" class=\"md-title text-center\" \nmd-colors=\"{color:\'warn\'}\" translate=\"MESSAGES.not_valid_youtube\">youtube</span> <span \nng-if=\"vm.uploadMetaDataExternalError===\'dailymotion\'\" class=\"md-title text-center\" md-colors=\"{color:\'warn\'}\" \ntranslate=\"MESSAGES.not_valid_dailymotion\">dailymotion</span></div></div></div><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\"><form name=\"myForm\" method=\"post\" \nng-submit=\"myForm.$valid && vm.uploadExternel()\"><span translate=\"VIDEOADD.add_video_link\"></span><md-input-container \nstyle=\"width: 100%\" md-no-float class=\"md-block\"><input type=\"url\" name=\"input\" ng-model=\"vm.video_link\" \nplaceholder=\"Ex:https://www.youtube.com/embed/YumjOdD7b9U\" required><div role=\"alert\"><span \nstyle=\"color: red;font-size: smaller\" class=\"error\" ng-if=\"myForm.input.$error.url\" translate=\"MESSAGES.url_not_valid\">\nNot valid url!</span></div></md-input-container><div layout=\"row\" layout-align=\"space-between center\"><span flex>\n</span><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"myForm.$invalid || myForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" ng-disabled=\"myForm.$invalid || myForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></div>\n</form></div></md-content></md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_on_hold\" \nmd-on-select=\"vm.getVideoOnHold()\"><md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-waiting-custom\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" \ntranslate=\"VIDEOADD.on_hold_list\"></span></div></md-tab-label><md-tab-body><div class=\"content fullpage-datatable\" \nlayout=\"column\" flex id=\"tab_on_hold_content\"><div \nstyle=\"width: 100%;margin-top:-6px;margin-left: -15px;margin-right: 5px\"><div \nstyle=\"width: 15%;float: left;margin: 18px;margin-left: 43px\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nng-if=\"vm.selectedVods.length > \'0\'\" class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteOnHoldVideosConfirm($event)\" \naria-label=\"MESSAGES.action_delete\" translate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></a></div><div style=\"float: right;  width: 25%\"><form layout-wrap \nmethod=\"post\" ng-submit=\"vm.searchVods()\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon \nmd-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"videos-search\" type=\"text\" \naria-label=\"title\" translate translate-attr-placeholder=\"MESSAGES.form_attr_source\" flex ng-model=\"vm.search_videos\" \nstyle=\"padding-left: 30px\"></md-input-container></form></div></div><table class=\"dataTable row-border hover\" \ndatatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" dt-columns=\"vm.dtColumns\"><thead><tr><th \nclass=\"centerdiiv\" data-priority=\"1\" style=\"width: 30px\"><md-checkbox ng-model=\"vm.modelCheckAll\" \nng-checked=\"(vm.selectedVods.length === vm.vods.length) && (vm.selectedVods.length > 0)\" \nmd-indeterminate=\"vm.selectedVods.length !== 0 && vm.selectedVods.length !== vm.vods.length\" aria-label=\"-\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\" style=\"width: 40px\"><div \nclass=\"table-header centerdiiv\" data-priority=\"7\"><span class=\"column-title center-span\">Id</span></div></th><th \nclass=\"secondary-text\" data-priority=\"2\" style=\"width: 150px\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.form_attr_source\">form_attr_source</span></div></th><th \nclass=\"secondary-text\" data-priority=\"8\" style=\"width: 150px\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MESSAGES.created_at\">date</span></div></th><th class=\"secondary-text\" \ndata-priority=\"8\" style=\"width: 150px\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.form_attr_contributor\">form_attr_contributor</span></div></th><th class=\"secondary-text\" \ndata-priority=\"3\" style=\"width: 300px\"><div class=\"table-header centerdiiv\"><span style=\"text-align: center\" \nclass=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.permission.media_video_add_option_on_hold_sftp\" \nmd-on-select=\"vm.getVideoOnHoldSFTP()\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important;font-size: 40px!important\" class=\"tab-upload-icon\" md-font-icon=\"icon-video-server\">\n</md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"VIDEOADD.on_hold_sftp_list\">\n</span></div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"row\" layout-align=\"center center\" \nng-if=\"vm.tree.length === 0 || vm.hide\"><span class=\"title\" style=\"padding:1%\" translate=\"VIDEOADD.on_hold_empty\">\non_hold_empty</span></div><div ng-if=\"vm.selectedNodes.length > 0 && vm.tree.length > 0\" class=\"action_sftp_list\">\n<md-button class=\"edit-button md-icon-button\" style=\"display: inline-flex\" ng-click=\"vm.addSelectedNodes()\" \ntitle=\"{{\'MESSAGES.form_add\'|translate}}\" aria-label=\"form_add\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add\"><md-icon md-font-icon=\"icon-upload-custom\" class=\"s22\"></md-icon>\n</md-button><md-button class=\"edit-button md-icon-button\" style=\"display: inline-flex\" \nng-click=\"vm.deleteNodesConfirm()\" title=\"{{\'MESSAGES.action_delete\'|translate}}\" aria-label=\"action_delete\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s22\"></md-icon>\n</md-button></div><div ng-if=\"vm.tree.length > 0\" js-tree=\"treeConfig\" ng-model=\"vm.tree\" tree=\"vm.treeInstance\" \nid=\"tree-sftp\" style=\"padding-bottom: 40px; padding-right: 30px\" tree-events-obj=\"treeEventsObj\" class=\"tree_sftp\">\n</div><md-button ng-if=\"vm.testData\" class=\"show-more-button md-raised\" translate=\"VIDEOADD.show_more\" \nng-click=\"vm.fillData()\">show_more</md-button></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.permission.media_video_add_option_webcam\" ng-click=\"vm.onWebcamSelected()\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-webcam-custom\"></md-icon><div \nstyle=\"margin-top: -50px\"><span style=\"text-transform: none\">Webcam</span></div></md-tab-label><md-tab-body><md-content\n class=\"md-padding\"><div ng-if=\"vm.isChrome\" class=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\" \nlayout-align=\"center center\"><div ng-if=\"!vm.isInstalledExtension\"><div layout=\"row\" layout-align=\"center center\"><div>\n<img ng-src=\"assets/icons/delete.png\"></div><span style=\"padding-left: 2%\" translate=\"VIDEOADD.msg_download_extension\">\nVeuiller installer l\'extension chrome</span></div><div><md-button class=\"md-warn\" \nui-sref=\"app.media_video_list({type: \'ongoing\'})\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nclass=\"md-accent md-raised md-button ng-scope md-ink-ripple\" \nng-class=\"{\'md-accent\' : vm.isFM, \'md-default-theme\': !vm.isFM}\" aria-label=\"Submit\" ng-click=\"vm.redirect()\" \ntranslate=\"VIDEOADD.download_extension\">form_add</md-button></div></div><div ng-if=\"vm.isInstalledExtension\"><div \nlayout=\"row\" layout-align=\"center center\"><span style=\"padding-left: 2%\" translate=\"VIDEOADD.msg_use_extension\">\nVeuiller utiliser l\'extension chrome</span></div></div></div><div ng-if=\"!vm.isChrome\" \nclass=\"md-whiteframe-1dp md-background-bg p-24\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\"><div><img ng-src=\"assets/icons/delete.png\"></div><span style=\"padding-left: 2%\" \ntranslate=\"VIDEOADD.not_chrome\">not_chrome</span></div></div></md-content></md-tab-body></md-tab><md-tab \nng-if=\"vm.permission.media_video_add_option_story_board\" ui-sref=\"app.new_template_manager_editornew\"><md-tab-label>\n<md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-storyboard-custom\"></md-icon>\n<div style=\"margin-top: -50px\"><span style=\"text-transform: none\">Storyboard</span></div></md-tab-label></md-tab>\n</md-tabs></div></div><div \nng-show=\"state.current.url !==\'/medias/videos/upload\' && $root.isUploading && !vm.isMultiUpload\" \nclass=\"theme-config-upload\"><div class=\"theme-config-box-upload\"><div style=\"height: 170px\" \nclass=\"skin-setttings-upload\"><md-toolbar \nstyle=\"width: 360px;margin-left: -17px;height: 45px;min-height: 45px;margin-top: -10px;background-color: rgb(45,50,62)\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n<span ng-if=\"vm.progressBarValue\" style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.inprogress\">1 vidéo en cours </span>\n<span ng-if=\"vm.inProgress===false\" style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.ended\">1 Vidéo terminée </span>\n</span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeUpload($event)\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div class=\"spin-icon-upload\" ng-click=\"vm.click()\" id=\"menu\"><md-icon ng-if=\"!vm.icon\" \nmd-font-icon=\"icon-upload\" class=\"icon toogle-upload\"></md-icon><md-icon ng-if=\"vm.icon\" \nmd-font-icon=\"icon-chevron-right\" class=\"icon toogle-upload\"></md-icon></div><form><div></div><div layout=\"row\" \nlayout-align=\"space-between center\" style=\"text-align: right;padding-top: 10px\"><div ng-if=\"vm.inProgress===true\"><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"secondary-text mt-8 text-center\" title=\"{{vm.videoFile.name}}\"><strong style=\"font-size: 14px\">\n{{vm.videoFile.name}}</strong></p></div><div style=\"cursor: pointer\" ng-if=\"vm.inProgress===false\" \nng-click=\"vm.goToAddPage()\"><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"mt-8 text-center\" title=\"{{vm.videoFile.name}}\"><strong style=\"font-size: 14px\">{{vm.videoFile.name}}</strong>\n</p></div><div><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p><md-icon \nstyle=\"color: rgb(76, 175, 80)!important;cursor: pointer;margin-top: -10px\" ng-if=\"vm.inProgress===false\" \nng-click=\"vm.goToAddPage()\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"icon toogle-upload\"></md-icon></div>\n</div></form></div></div></div><div \nng-show=\"state.current.url !==\'/medias/videos/upload\' && $root.isUploading && vm.isMultiUpload\" \nclass=\"theme-config-upload\"><div ng-hide=\"$root.endUpload && state.current.name ===\'app.media_video_add\'\" \nclass=\"theme-config-box-upload\"><div class=\"skin-setttings-upload\"><md-toolbar \nstyle=\"width: 360px;margin-left: -17px;height: 45px;min-height: 45px;margin-top: -10px;background-color: rgb(45,50,62)\" \nclass=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nng-if=\"uploader.queue.length>1\" class=\"title\"><span style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.videos\">videos \n</span></span><span ng-if=\"uploader.queue.length===1\" class=\"title\"><span style=\"font-size: 15px\">\n{{uploader.queue.length}}</span> <span style=\"font-size: 15px\" translate=\"VIDEOUPLOAD.video\">video </span></span><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeUploadMulti($event)\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><div class=\"spin-icon-upload\" ng-click=\"vm.click()\" id=\"menu\"><md-icon ng-if=\"!vm.icon\" \nmd-font-icon=\"icon-upload\" class=\"icon toogle-upload\"></md-icon><md-icon ng-if=\"vm.icon\" \nmd-font-icon=\"icon-chevron-right\" class=\"icon toogle-upload\"></md-icon></div><form \nstyle=\"height: 143px;overflow: auto;padding-top: 5px;width: 103%\"><div></div><div ng-repeat=\"item in uploader.queue\" \nlayout=\"row\" layout-align=\"space-between center\" style=\"text-align: right\"><div layout=\"row\" \nng-if=\"item.isSuccess && state.current.name !==\'app.media_video_add\'\" style=\"cursor: pointer\" \nng-click=\"vm.goToAddPageMulti(item.file.name,item, false)\"><md-icon style=\"margin-top: 5px;margin-right: 5px\" \nmd-font-icon=\"icon-file-video\" class=\"icon toogle-upload\"></md-icon><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"mt-8 text-center\" title=\"{{item.file.name}}\"><strong style=\"font-size: 14px\">{{item.file.name}}</strong></p>\n</div><div layout=\"row\" ng-if=\"item.isUploading || item.isReady\"><md-icon style=\"margin-top: 5px;margin-right: 5px\" \nmd-font-icon=\"icon-file-video\" class=\"icon toogle-upload\"></md-icon><p></p><p \nstyle=\"display: block;width: 220px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;text-align: left\" \nclass=\"secondary-text mt-8 text-center\" title=\"{{item.file.name}}\"><strong style=\"font-size: 14px\">{{item.file.name}}\n</strong></p></div><div style=\"margin-right: 17px\"><p ng-if=\"item.isUploading || item.isReady\" \nclass=\"secondary-text mt-8 text-center\"><strong>{{item.progress}}%</strong></p><md-icon \nstyle=\"color: rgb(76, 175, 80)!important;cursor: pointer;margin-top: -10px\" \nng-if=\"item.isSuccess && state.current.name !==\'app.media_video_add\'\" \nng-click=\"vm.goToAddPageMulti(item.file.name,item, false)\" md-font-icon=\"icon-checkbox-marked-circle\" \nclass=\"icon toogle-upload\"></md-icon></div></div></form></div></div></div>");
$templateCache.put("app/main/specifics/station/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"specifics_station_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.specifics_station_detail_pagetitle\">\nspecifics_station_detail_pagetitle</span> <span>{{ vm.station.name |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.station.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.ip\">ip</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.station.ip }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.name\">name</strong></h3></div><div \nclass=\"md-secondary\">{{ vm.station.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.domain\">domain</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.station.domain }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.intranetStreamFr\">\nintranetStreamFr</strong></h3></div><div class=\"md-secondary\">{{ vm.station.intranetStreamFr }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"STATIONDETAIL.intranetStreamEn\">intranetStreamEn</strong></h3></div><div class=\"md-secondary\">\n{{ vm.station.intranetStreamEn }}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.intranetStreamEs\">intranetStreamEs</strong></h3></div>\n<div class=\"md-secondary\">{{ vm.station.intranetStreamEs }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"STATIONDETAIL.intranetStreamOr\">\nintranetStreamOr</strong></h3></div><div class=\"md-secondary\">{{ vm.station.intranetStreamOr }}</div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"STATIONDETAIL.description\">description</strong></h3></div><div class=\"md-secondary\">\n{{ vm.station.description }}</div><md-divider></md-divider></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" \ntranslate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/profiles/user/password/password.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div ng-if=\"!vm.logo\" \nclass=\"logo md-accent-bg\"><span>V4</span></div><div class=\"logo-custom\" layout=\"row\" layout-align=\"center\"><span \nclass=\"logo-image\" ng-if=\"vm.logo.logo_image\">{{ vm.logo.logo_image }}</span> <span class=\"logo-text\" \nng-if=\"!vm.logo.logo_text1\">{{vm.logo.logo_text}}</span><div ng-if=\"vm.logo.logo_text1\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-part1\">{{ vm.logo.logo_text }} </span><span class=\"logo-part2\">\n{{ vm.logo.logo_text1 }}</span></div></div><div class=\"title\" translate=\"USERPASSWORD.message\">\nCréer votre nouveau mot de passe</div><form name=\"empProfilesUserPasswordForm\" novalidate \nng-submit=\"empProfilesUserPasswordForm.$valid && vm.submitAddUserPasswordForm()\"><md-input-container class=\"md-block\" \nmd-no-float><label translate=\"USERPASSWORD.form_attr_first\">Repeat Password</label><input type=\"password\" name=\"first\" \nng-model=\"vm.empProfilesUserPasswordForm.plainPassword.first\" ng-minlength=\"8\" md-maxlength=\"20\" \npattern=\"{{vm.patern}}\" required class=\"first\"><div ng-messages=\"empProfilesUserPasswordForm.first.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_REQUIRED\">\nLe champ du mot de passe est requis</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><label translate=\"USERPASSWORD.form_attr_second\">\nConfirmer votre mot de passe</label><input type=\"password\" name=\"second\" \nng-model=\"vm.empProfilesUserPasswordForm.plainPassword.second\" ng-minlength=\"8\" md-maxlength=\"20\" \npattern=\"{{vm.patern}}\" confirm-password=\"true\" required><div ng-messages=\"empProfilesUserPasswordForm.second.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nLe champ Mot de passe (Confirmer) est requis</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MAX_LENGTH\" translate-value-length=\"20\">\nCe champ doit comporter au plus {{length}} caractères.</span></div><div ng-message=\"minlength\"><span \ntranslate=\"USERPASSWORD.ERRORS.PASSWORD_MIN_LENGTH\" translate-value-length=\"8\">\nCe champ doit comporter au moins {{length}} caractères.</span></div><div ng-message=\"pattern\"><span \ntranslate=\"{{vm.msgErrorPatern}}\">\nCe champ doit au être de type alphanumeric, contenir au moins une lettre majiscule et un chiffre</span></div><div \nng-message=\"confirmPassword\"><span translate=\"USERPASSWORD.ERRORS.PASSWORD_MISSMATCH\">\nLes deux mots de passe ne sont pas identiques.</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Créer\" \nng-disabled=\"empProfilesUserPasswordForm.$invalid || empProfilesUserPasswordForm.$pristine\" \ntranslate=\"USERPASSWORD.sub_button\" translate-attr-aria-label=\"USERPASSWORD.sub_button\">Créer</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/specifics/station/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-station\" layout=\"column\">\n<div class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/specifics/station/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/specifics/station/add_edit_view/form.template.html","<form name=\"empSpecificsStationForm\" method=\"post\" id=\"empSpecificsStationForm\" novalidate=\"novalidate\" \nng-submit=\"empSpecificsStationForm.$valid && vm.submitAddStationForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"STATIONADD.form_title\">\nform_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\">\n</md-icon><span translate=\"STATIONEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"STATIONADD.form_attr_ip\">Adresse IP</label><input type=\"text\" \nid=\"empSpecificsStationForm_ip\" name=\"empSpecificsStationForm[ip]\" required=\"required\" ng-attr-name=\"ip\" \nng-model=\"vm.empSpecificsStationForm.ip\" ng-pattern=\"/^([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})[.]([0-9]{1,3})$/\" \naria-invalid=\"true\"><div ng-messages=\"empSpecificsStationForm.ip.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_ip\">field_must_be_ip</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"STATIONADD.form_attr_name\">Nom</label><input type=\"text\" \nid=\"empSpecificsStationForm_name\" name=\"empSpecificsStationForm[name]\" required=\"required\" ng-attr-name=\"name\" \nng-model=\"vm.empSpecificsStationForm.name\" aria-invalid=\"true\"><div ng-messages=\"empSpecificsStationForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"STATIONADD.form_attr_domain\">Domaine</label><input type=\"text\" id=\"empSpecificsStationForm_domain\" \nname=\"empSpecificsStationForm[domain]\" required=\"required\" ng-attr-name=\"domain\" \nng-model=\"vm.empSpecificsStationForm.domain\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsStationForm.domain.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"STATIONADD.form_attr_intranetStreamFr\">intranetStreamFr\n</label><input type=\"text\" id=\"empSpecificsStationForm_intranetStreamFr\" \nname=\"empSpecificsStationForm[intranetStreamFr]\" required=\"required\" ng-attr-name=\"intranetStreamFr\" \nng-model=\"vm.empSpecificsStationForm.intranetStreamFr\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsStationForm.intranetStreamFr.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"STATIONADD.form_attr_intranetStreamEn\">intranetStreamEn\n</label><input type=\"text\" id=\"empSpecificsStationForm_intranetStreamEn\" \nname=\"empSpecificsStationForm[intranetStreamEn]\" required=\"required\" ng-attr-name=\"intranetStreamEn\" \nng-model=\"vm.empSpecificsStationForm.intranetStreamEn\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsStationForm.intranetStreamEn.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"STATIONADD.form_attr_intranetStreamEs\">intranetStreamEs\n</label><input type=\"text\" id=\"empSpecificsStationForm_intranetStreamEs\" \nname=\"empSpecificsStationForm[intranetStreamEs]\" required=\"required\" ng-attr-name=\"intranetStreamEs\" \nng-model=\"vm.empSpecificsStationForm.intranetStreamEs\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsStationForm.intranetStreamEs.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"STATIONADD.form_attr_intranetStreamOr\">intranetStreamOr\n</label><input type=\"text\" id=\"empSpecificsStationForm_intranetStreamOr\" \nname=\"empSpecificsStationForm[intranetStreamOr]\" required=\"required\" ng-attr-name=\"intranetStreamOr\" \nng-model=\"vm.empSpecificsStationForm.intranetStreamOr\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsStationForm.intranetStreamOr.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label translate=\"STATIONADD.form_attr_description\">Description</label><div class=\"md-resize-wrapper\">\n<textarea id=\"empSpecificsStationForm_description\" name=\"empSpecificsStationForm[description]\" required=\"required\" \nng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" ng-model=\"vm.empSpecificsStationForm.description\" \naria-invalid=\"true\" ng-trim=\"false\" style=\"height: 135px\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"empSpecificsStationForm.description.$error\" role=\"alert\"><div\n ng-message=\"md-maxlength\" translate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div>\n</div></md-input-container><md-button class=\"md-warn\" ui-sref=\"app.specifics_station_list\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empSpecificsStationForm.$invalid || empSpecificsStationForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empSpecificsStationForm.$invalid || empSpecificsStationForm.$pristine\" translate=\"MESSAGES.form_validate\" \ntranslate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/specifics/station/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedStations.length\" \nhas-permission=\"specifics_stations_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'STATIONLIST.delete_stations_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedStationsConfirm($event)\" \naria-label=\"delete_stations_aria_label\" translate translate-attr-aria-label=\"STATIONLIST.delete_stations_aria_label\">\n<md-icon md-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"stations-search\" class=\"search-input ng-scope flex\" \ntype=\"text\" placeholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex \nng-model=\"vm.search_stations\" ng-keydown=\"$event.keyCode === 13 && vm.searchStations()\"></md-input-container></div>\n<md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewStation($event)\" \naria-label=\"action_new_element\" has-permission=\"specifics_stations_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedStations.length === vm.stations.length) && (vm.selectedStations.length > 0)\" \nmd-indeterminate=\"vm.selectedStations.length !== 0 && vm.selectedStations.length !== vm.stations.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"STATIONLIST.ip\">ip</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"STATIONLIST.name\">name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"STATIONLIST.domain\">domain</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"STATIONLIST.intranetStreamFr\">intranetStreamFr</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"STATIONLIST.intranetStreamEn\">intranetStreamEn</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"STATIONLIST.intranetStreamEs\">\nintranetStreamEs</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"STATIONLIST.intranetStreamOr\">intranetStreamOr</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"STATIONLIST.description\">description</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/specifics/direction/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"specifics_direction_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.specifics_direction_detail_pagetitle\">\nspecifics_direction_detail_pagetitle</span> <span>{{ vm.direction.title |json }}</span></h2><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"DIRECTIONDETAIL.id\">id</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.direction.id }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"DIRECTIONDETAIL.title\">title</strong></h3>\n</div><div class=\"md-secondary\">{{ vm.direction.title }}</div><md-divider></md-divider></md-list-item><md-list-item \nng-if=\"vm.direction.parent\" class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"DIRECTIONDETAIL.parent\">parent</strong></h3></div><div class=\"md-secondary\">{{ vm.direction.parent.title }}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"DIRECTIONDETAIL.visible\">visible</strong></h3></div><div class=\"md-secondary\">\n{{ vm.direction.visible }}</div><md-divider></md-divider></md-list-item></md-list></div></md-dialog-content>\n<md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" \ntranslate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/specifics/direction/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedDirections.length\" \nhas-permission=\"specifics_directions_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'DIRECTIONLIST.delete_directions_aria_label\'|translate}}\" tooltip-side=\"right\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button btn-delete\" \nng-click=\"vm.deleteSelectedDirectionsConfirm($event)\" aria-label=\"delete_directions_aria_label\" translate \ntranslate-attr-aria-label=\"DIRECTIONLIST.delete_directions_aria_label\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\"><md-input-container md-no-float \nclass=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon>\n<input id=\"directions-search\" class=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_directions\" \nng-keydown=\"$event.keyCode === 13 && vm.searchDirections()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewDirection($event)\" \naria-label=\"action_new_element\" has-permission=\"specifics_directions_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedDirections.length === vm.directions.length) && (vm.selectedDirections.length > 0)\" \nmd-indeterminate=\"vm.selectedDirections.length !== 0 && vm.selectedDirections.length !== vm.directions.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"DIRECTIONLIST.title\">name</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/specifics/direction/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/specifics/direction/add_edit_view/form.template.html\'\">\n</div></div></div></div></div>");
$templateCache.put("app/main/specifics/direction/add_edit_view/form.template.html","<form name=\"empSpecificsDirectionForm\" method=\"post\" id=\"empSpecificsDirectionForm\" novalidate=\"novalidate\" \nng-submit=\"empSpecificsDirectionForm.$valid && vm.submitAddDirectionForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\">\n<md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"DIRECTIONADD.form_title\">\nform_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\">\n</md-icon><span translate=\"DIRECTIONEDIT.form_title\">form_title</span></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-card-content flex><md-select translate translate=\"DIRECTIONADD.form_attr_direction\" \nname=\"empSpecificsDirectionForm[parent]\" id=\"empSpecificsDirectionForm_parent\" \nng-model=\"vm.empSpecificsDirectionForm.parent\" placeholder=\"{{ \'DIRECTIONLIST.parent\'|translate}}\"><md-option \nng-repeat=\"category in vm.directionChoices track by category.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"category.val\">{{ category.option }}</md-option></md-select></md-card-content></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"DIRECTIONADD.form_attr_name\">Nom</label><input \ntype=\"text\" id=\"empSpecificsDirectionForm_title\" name=\"empSpecificsDirectionForm[title]\" required=\"required\" \nng-attr-name=\"title\" ng-model=\"vm.empSpecificsDirectionForm.title\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsDirectionForm.title.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-card-content flex><md-select translate translate=\"MESSAGES.form_attr_visible\" \nname=\"empSpecificsDirectionForm[visible]\" id=\"empSpecificsDirectionForm_visible\" \nng-model=\"vm.empSpecificsDirectionForm.visible\" required=\"required\" \nplaceholder=\"{{ \'IPTVADD.form_attr_visible\'|translate}}\"><md-option \nng-repeat=\"visibilityChoice in vm.visibilityChoices\" ng-value=\"visibilityChoice.val\" \ntranslate=\"MESSAGES.{{ visibilityChoice.options }}\">{{ visibilityChoice.options }}</md-option></md-select><div \nng-messages=\"empSpecificsDirectionForm.visible.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-card-content></div><md-button class=\"md-warn\" \nui-sref=\"app.specifics_direction_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empSpecificsDirectionForm.$invalid || empSpecificsDirectionForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empSpecificsDirectionForm.$invalid || empSpecificsDirectionForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/specifics/iptv/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\" flex ng-if=\"vm.selectedIptvs.length\" \nhas-permission=\"specifics_iptv_delete_multi\"><a ng-style=\"myObjStyle\" tooltips \ntooltip-template=\"{{\'IPTVLIST.delete_iptvs_aria_label\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button btn-delete\" ng-click=\"vm.deleteSelectedIpTvsConfirm($event)\" \naria-label=\"video_upload_title\" translate translate-attr-aria-label=\"IPTVLIST.delete_iptvs_aria_label\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"black-text icon\"></md-icon></md-button></a></div><div flex=\"\" layout=\"row\">\n<md-input-container md-no-float class=\"md-block inputContainer\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"black-text icon search-icon\"></md-icon><input id=\"iptvs-search\" class=\"search-input ng-scope flex\" type=\"text\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.search_iptvs\" \nng-keydown=\" $event.keyCode === 13 && vm.searchIpTvs()\"></md-input-container></div><md-button \nclass=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" ng-click=\"vm.addNewIptv($event)\" \naria-label=\"action_new_element\" has-permission=\"specifics_iptv_post_add\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"centerdiiv\"><md-checkbox aria-label=\"-\" \nng-checked=\"(vm.selectedIptvs.length === vm.iptvs.length) && (vm.selectedIptvs.length > 0)\" \nmd-indeterminate=\"vm.selectedIptvs.length !== 0 && vm.selectedIptvs.length !== vm.iptvs.length\" \nng-click=\"vm.toggleAll()\"></md-checkbox></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"IPTVLIST.image\">image</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"IPTVLIST.name\">name</span></div>\n</th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"IPTVLIST.visible\">visible</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"IPTVLIST.description\">description</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"IPTVLIST.linkUrl\">linkUrl</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span>\n</div></th></tr></thead></table></div></div></div>");
$templateCache.put("app/main/specifics/iptv/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div ng-include=\"\'app/main/specifics/iptv/add_edit_view/form.template.html\'\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/specifics/iptv/add_edit_view/form.template.html","<form name=\"empSpecificsIptvForm\" method=\"post\" id=\"empSpecificsIptvForm\" novalidate=\"novalidate\" \nng-submit=\"empSpecificsIptvForm.$valid && vm.submitAddIptvForm()\"><div class=\"form-title\" ng-if=\"vm.isNew\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span translate=\"IPTVADD.form_title\">form_title</span>\n</div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span \ntranslate=\"IPTVEDIT.form_title\">form_title</span></div><input type=\"hidden\" id=\"empSpecificsIptvForm_image\" \nname=\"empSpecificsIptvForm[image]\" ng-model=\"vm.empSpecificsIptvForm.image\" aria-invalid=\"false\"><div \nng-if=\"!vm.iptv.image\" layout-align=\"left left\" layout=\"row\" class=\"s18\"><md-icon md-font-icon=\"icon-picture\" \nstyle=\"margin-left: 60px;  padding-top: 20px\" class=\"s72\" width=\"100\" height=\"100\"></md-icon></div><div \nclass=\"product-image\" hide-xs ng-if=\"vm.iptv.image\"><img \nstyle=\"height: 100px;width: 80px; margin-left: 60px; padding-top: 20px\" ng-src=\"{{ vm.iptv.image }}\"></div><div \nclass=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" \nflow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-success=\"vm.fileSuccess($file, $message)\" flow-complete=\"vm.uploadComplete()\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised\" aria-label=\"form_add_file\" translate \ntranslate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon md-font-icon=\"icon-plus\"></md-icon><any \ntranslate=\"IPTVADD.choose_thumb\">choose_thumb</any></md-button></div><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"IPTVADD.form_attr_name\">IP-TV Nom</label><input type=\"text\" \nid=\"empSpecificsIptvForm_name\" name=\"empSpecificsIptvForm[name]\" required=\"required\" ng-attr-name=\"name\" \nng-model=\"vm.empSpecificsIptvForm.name\" aria-invalid=\"true\" style=\"\"><div \nng-messages=\"empSpecificsIptvForm.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-xs=\"row\"><md-card-content flex><md-select translate translate=\"MESSAGES.form_attr_visible\" \nname=\"empSpecificsIptvForm[visible]\" id=\"empSpecificsIptvForm_visible\" ng-model=\"vm.empSpecificsIptvForm.visible\" \nplaceholder=\"{{ \'IPTVADD.form_attr_visible\'|translate}}\"><md-option \nng-repeat=\"visibilityChoice in vm.visibilityChoices\" ng-value=\"visibilityChoice.val\" \ntranslate=\"MESSAGES.{{ visibilityChoice.options }}\">{{ visibilityChoice.options }}</md-option></md-select>\n</md-card-content></div><md-input-container class=\"md-block\"><label translate=\"IPTVADD.form_attr_description\">\nDescription</label><div class=\"md-resize-wrapper\"><textarea id=\"empSpecificsIptvForm_description\" \nname=\"empSpecificsIptvForm[description]\" required=\"required\" ng-attr-name=\"description\" rows=\"5\" max-rows=\"8\" \nmd-maxlength=\"450\" ng-model=\"vm.empSpecificsIptvForm.description\" aria-invalid=\"false\" ng-trim=\"false\" \nstyle=\"height: 135px\"></textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empSpecificsIptvForm.description.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div></div></md-input-container><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"IPTVADD.form_attr_linkUrl\">Lien URL\n</label><input type=\"text\" id=\"empSpecificsIptvForm_linkUrl\" name=\"empSpecificsIptvForm[linkUrl]\" required=\"required\" \nng-attr-name=\"linkUrl\" ng-model=\"vm.empSpecificsIptvForm.linkUrl\" aria-invalid=\"true\"><div \nng-messages=\"empSpecificsIptvForm.linkUrl.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><md-button \nclass=\"md-warn\" ui-sref=\"app.specifics_iptv_list\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_add\" \nng-disabled=\"empSpecificsIptvForm.$invalid || empSpecificsIptvForm.$pristine\" translate=\"MESSAGES.form_add\" \ntranslate-attr-aria-label=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"empSpecificsIptvForm.$invalid || (empSpecificsIptvForm.$pristine && !vm.is_image_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/specifics/iptv/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"specifics_iptv_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.specifics_iptv_detail_pagetitle\">\nspecifics_iptv_detail_pagetitle</span> <span>{{ vm.iptv.name |json }}</span></h2><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"md-dialog-content\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><img \nstyle=\"margin: auto\" ng-if=\"vm.iptv.image\" width=\"100\" height=\"100\" class=\"product-image\" ng-src=\"{{ vm.iptv.image }}\">\n<md-list flex><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"IPTVDETAIL.id\">id\n</strong></h3></div><div class=\"md-secondary\">{{ vm.iptv.id }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"IPTVDETAIL.name\">name</strong>\n</h3></div><div class=\"md-secondary\">{{ vm.iptv.name }}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-2-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"IPTVDETAIL.description\">description</strong>\n</h3><h4></h4></div><div class=\"md-secondary\">{{ vm.iptv.description }}</div><md-divider></md-divider></md-list-item>\n<md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"IPTVDETAIL.visible\">visible\n</strong></h3></div><div class=\"md-secondary\"><i ng-if=\"vm.iptv.visible === true\" \nclass=\"icon-checkbox-marked-circle green-500-fg\"><span class=\"hide\">1</span></i> <i ng-if=\"vm.iptv.visible === false\" \nclass=\"icon-cancel red-500-fg\"><span class=\"hide\">1</span></i></div><md-divider></md-divider></md-list-item></md-list>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.audience.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats type=\"nombre_video\" \nstat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats type=\"visite_total\" \nstat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats type=\"visite_unique\" \nstat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_visiteur\" stat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_video\" stat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats-player \ntype=\"number_loads\" stat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_access\"></mesure-stats-player><mesure-stats-player \ntype=\"number_vue_per_autoplay\" stat=\"podcast\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \n-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_autoplay\"></mesure-stats-player></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-percentage-stats type=\"NumberOfViewsFourthQuarter\" \nstat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_fourth_quarter\"></mesure-percentage-stats>\n<mesure-percentage-stats type=\"NumberOfViewsFirstQuarter\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_first_quarter\"></mesure-percentage-stats>\n<mesure-percentage-stats type=\"NumberOfViewsSecondQuarter\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_second_quarter\"></mesure-percentage-stats>\n<mesure-percentage-stats type=\"NumberOfViewsThirdQuarter\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_third_quarter\"></mesure-percentage-stats></div><md-card \nhas-permission=\"stats_audience_{{vm.permission}}_audience_all\"><audience-stats stat=\"podcast\" query=\"vm.query\">\n</audience-stats></md-card><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats \ntype=\"duree_total\" query=\"vm.query\" stat=\"podcast\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"duree_moyenne_par_visite\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_visiteur\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\">\n</mesure-stats><mesure-stats type=\"duree_moyenne_par_video\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-standard-deviation-stats \nquery=\"vm.query\" stat=\"podcast\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_standard_deviation_all\"></mesure-standard-deviation-stats>\n</div><md-card has-permission=\"stats_audience_{{vm.permission}}_duree_all\"><duree-stats stat=\"podcast\" \nquery=\"vm.query\"></duree-stats></md-card></div></any>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.engagement.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-by-ip-stats type=\"nombre_video\" \nstat=\"podcast\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"visite_total\" stat=\"podcast\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"visite_unique\" stat=\"podcast\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"duree_total\" stat=\"podcast\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats></div><md-card \nhas-permission=\"stats_engagement_{{vm.permission}}_ip_all\"><visits-ip-stats stat=\"podcast\" query=\"vm.query\">\n</visits-ip-stats></md-card><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats \ntype=\"nombre_vue_par_visiteur\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"nombre_vue_par_video\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_visite\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_visiteur\" stat=\"podcast\" query=\"vm.query\" class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\">\n</mesure-stats><mesure-taux-rebond-stats query=\"vm.query\" stat=\"podcast\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_engagement_{{vm.permission}}_taux_rebond_all\">\n</mesure-taux-rebond-stats></div><md-card has-permission=\"stats_engagement_{{vm.permission}}_duree_per_visite_all\">\n<duree-visite-stats stat=\"podcast\" query=\"vm.query\"></duree-visite-stats></md-card><md-card \nhas-permission=\"stats_engagement_{{vm.permission}}_most_popular_all\"><most-popular-stats stat=\"podcast\" \nquery=\"vm.query\"></most-popular-stats></md-card></div></any>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.geo.html","<any><div><md-card has-permission=\"stats_geo_{{vm.permission}}_geo_per_pays_all\"><map-geo-stats query=\"vm.query\">\n</map-geo-stats></md-card></div></any>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.mobile.html","<any><div><md-card has-permission=\"stats_technologie_{{vm.permission}}_os_all\"><os-stats query=\"vm.query\"></os-stats>\n</md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_browser_all\"><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_referrer_all\"><referrer-stats \nquery=\"vm.query\"></referrer-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_device_all\" \nng-if=\"vm.list_right_mobile.referrer\"><device-stats query=\"vm.query\"></device-stats></md-card></div></any>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.technologie.html","<any><div><md-card has-permission=\"stats_technologie_{{vm.permission}}_os_all\"><os-stats query=\"vm.query\"></os-stats>\n</md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_browser_all\"><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_referrer_all\"><referrer-stats \nquery=\"vm.query\"></referrer-stats></md-card></div></any>");
$templateCache.put("app/main/stats/podcast/tabStats/stat.vod.temp_reel.html","<md-content><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><time-reel-now-stats \ntype=\"visite_temps_reel\" query=\"vm.query\" stat=\"podcast\" class=\"h-140\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"50\" has-permission=\"stats_temps_reel_{{vm.permission}}_stats_now_all\"></time-reel-now-stats></div><md-card \nhas-permission=\"stats_temps_reel_{{vm.permission}}_now_hours_all\"><time-reel-heure-stats stat=\"podcast\" \nquery=\"vm.query\"></time-reel-heure-stats></md-card><md-card \nhas-permission=\"stats_temps_reel_{{vm.permission}}_stats_now_minute_all\"><time-reel-minute-stats stat=\"podcast\" \nquery=\"vm.query\"></time-reel-minute-stats></md-card></div></md-content>");
$templateCache.put("app/main/stats/export/vod_live/stat.vod.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content stat_content\"><md-tabs md-dynamic-height md-selected=\"vm.md_selected_index\">\n<a-transclusion-directive><md-tab ng-repeat=\"tab_value in vm.tabs_title \" ng-if=\"tab_value.permission==true\" \nui-sref=\"{{ tab_value.ui_sref }}\" label=\"{{ tab_value.title |translate}}\"><md-card><md-card-title><md-card-title-text>\n<span class=\"md-headline\">{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content\n layout-align=\"space-between\"><div flex=\"100\" layout=\"row\"><div flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" \nng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\"></label>\n<md-datepicker ng-model=\"vm.currentDateIn\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker></div><div \nflex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" ng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_date\">Date fin</label><md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate()\" \nng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\"></md-datepicker></div><div layout=\"column\" layout-gt-xs=\"row\" \nflex=\"100\" ng-if=\"vm.isHiddenFilter(tab_value,\'canal\') && vm.canals.length\" flex-gt-xs=\"20\" flex-gt-md=\"20\">\n<md-card-content flex><md-select translate translate=\"MESSAGES.form_attr_canal\" ng-model=\"vm.canal\" translate \ntranslate=\"MESSAGES.form_attr_canal\" translate-attr-aria-label=\"MESSAGES.form_attr_canal\" \nng-change=\"vm.changeQuery(\'canal\')\" placeholder=\"{{ \'MESSAGES.form_attr_canal\'|translate}}\"><md-option value=\"\" \ntranslate=\"DASHBOARD.none\"></md-option><md-option ng-repeat=\"canal in vm.canals track by canal.val\" \nng-attr-data-index=\"{{$index}}\" ng-value=\"canal.val\" ng-attr-translate=\"{{canal.val==0 ? \'MESSAGES.none\':\'\'}}\">\n{{canal.option}}</md-option></md-select></md-card-content></div><div layout=\"column\" \nng-if=\"vm.isHiddenFilter(tab_value,\'theme\')\" layout-gt-xs=\"row\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\"><ms-themes \ntheme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" ng-model=\"vm.theme\" multi=\"false\" \nng-change=\"vm.changeQuery(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div><div layout=\"column\" \nlayout-gt-xs=\"row\" ng-if=\"types.length\" flex=\"100\" flex-gt-xs=\"20\" flex-gt-md=\"20\" \nng-if=\"vm.isHiddenFilter(tab_value,\'type\')\"><md-card-content flex><md-select ng-model=\"vm.types_query\" \nng-attr-name=\"types\" translate translate=\"SEARCHSTATS.form_attr_types\" \ntranslate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" ng-change=\"vm.changeQuery()\" \nplaceholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\"><md-option ng-repeat=\"type in types\" ng-value=\"type.val\" \nng-value=\"type.val!=0 ? type.val : \'\'\" ng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.type_none\':\'\' }}\">\n{{ type.option }}</md-option></md-select></md-card-content></div></div></md-card-content></md-card><div \nui-view=\"{{ tab_value.ui_view }}\"></div></md-tab></a-transclusion-directive></md-tabs></div></div></div>");
$templateCache.put("app/main/stats/export/vod_live/stat.vod_by_id.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"content\"><md-tabs md-dynamic-height md-selected=\"vm.md_selected_index\"><md-tab \nng-repeat=\"tab_value in vm.tabs_title\" ui-sref=\"{{ tab_value.ui_sref }}\" label=\"{{ tab_value.title |translate}}\">\n<md-card style=\"height: 96px\"><md-card-title style=\"padding: 5px 16px;max-height: 42px\"><md-card-title-text><span \nclass=\"md-headline\">{{ \"MESSAGES.search\" |translate}}</span></md-card-title-text></md-card-title><md-card-content \nlayout-align=\"space-between\" style=\"padding: 4px 16px 8px 16px;max-height: 42px\"><div class=\"pb-32\" flex=\"100\" \nlayout=\"row\"><div flex=\"100\" flex-gt-xs=\"{{vm.isTheme ? \'25\' : \'30\'}}\" flex-gt-md=\"{{vm.isTheme ? \'25\' : \'30\'}}\" \nng-if=\"vm.isHiddenFilter(tab_value,\'dateIn\')\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\"></label>\n<md-datepicker ng-model=\"vm.currentDateIn\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\"></md-datepicker></div><div \nflex=\"100\" flex-gt-xs=\"{{vm.isTheme ? \'25\' : \'30\'}}\" flex-gt-md=\"{{vm.isTheme ? \'25\' : \'30\'}}\" \nng-if=\"vm.isHiddenFilter(tab_value,\'dateOut\')\"><label class=\"md-no-float\">Date fin</label><md-datepicker \nng-model=\"vm.currentDateOut\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\" md-min-date=\"vm.currentDateIn\">\n</md-datepicker></div><div flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\" class=\"themes-list\" \nng-if=\"vm.isHiddenFilter(tab_value,\'theme\') && vm.isTheme\"><ms-themes theme=\"vm.theme\" canal=\"vm.canal\" type=\"\'theme\'\" \nng-model=\"vm.theme\" multi=\"false\" ng-change=\"vm.changeQuery(\'theme\',someModel)\" style=\"width: 100%\"></ms-themes></div>\n<div layout=\"column\" layout-gt-xs=\"row\" ng-if=\"vm.isHiddenFilter(tab_value,\'type\') && types.length\" flex=\"100\" \nflex-gt-xs=\"{{vm.isTheme ? \'25\' : \'35\'}}\" flex-gt-md=\"{{vm.isTheme ? \'25\' : \'35\'}}\" style=\"max-height: 42px\">\n<md-card-content style=\"padding: 4px 16px 8px 16px\" flex><md-select ng-model=\"vm.types_query\" ng-attr-name=\"types\" \ntranslate translate=\"SEARCHSTATS.form_attr_types\" translate-attr-aria-label=\"SEARCHSTATS.form_attr_types\" \nng-change=\"vm.changeQuery()\" placeholder=\"{{ \'SEARCHSTATS.form_attr_types\'|translate}}\" style=\"margin: 0px\"><md-option \nng-repeat=\"type in types\" ng-value=\"type.val!=0 ? type.val : \'\' \" \nng-attr-translate=\"{{ type.option==\'none\' ? \'MESSAGES.none\':\'\' }}\">{{ type.option }}</md-option></md-select>\n</md-card-content></div></div></md-card-content></md-card><div ui-view=\"{{ tab_value.ui_view }}\"></div></md-tab>\n</md-tabs></div></div></div>");
$templateCache.put("app/main/stats/mooc/list-persons/list-persons.template.html","<div style=\"height: 99%\" id=\"e-commerce-products\" class=\"\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div layout=\"row\"><md-card style=\"background-color: #ffffff;width: 7%;height: 60px\">\n<md-card-content layout-align=\"space-between\"><md-button \nstyle=\"color: #000; font-weight: bold; position: absolute;display: flex; left:0  ;height: 60px; width: 7%; top:0\" \nng-click=\"vm.returnPage()\" class=\"md-warn\"><md-icon style=\"color: #000; position: absolute; left:20px\" \nmd-font-icon=\"icon-chevron-left\" class=\"s24\"></md-icon><span translate=\"MESSAGES.form_retour\" \nstyle=\"position: absolute; left:40px\"></span></md-button></md-card-content></md-card><md-card \nstyle=\"width: 93%;height: 60px\"><md-card-content layout-align=\"space-between\"><div flex=\"100\" layout=\"row\" \nstyle=\"margin-left: 2%\"><span class=\"md-headline\">{{ \"MESSAGES.search\" |translate}}</span><div flex=\"100\" \nflex-gt-xs=\"25\" flex-gt-md=\"25\" style=\"margin-left: 100px\"><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">\n</label><md-datepicker ng-model=\"vm.currentDateIn\" ng-change=\"vm.searchPersons()\" ng-attr-name=\"date\"></md-datepicker>\n</div><div flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><label class=\"md-no-float\" translate=\"MESSAGES.end_date\">Date fin\n</label><md-datepicker ng-model=\"vm.currentDateOut\" ng-change=\"vm.searchPersons()\" ng-attr-name=\"date\" \nmd-min-date=\"vm.currentDateIn\"></md-datepicker></div><div style=\"margin-top: -17px\" flex=\"100\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><md-select translate translate=\"MESSAGES.form_attr_contributor\" \nplaceholder=\"{{ \'MESSAGES.entity\' | translate }}\" id=\"empMediaVideoForm_contributor\" ng-change=\"vm.searchPersons()\" \nng-model=\"vm.entity\"><md-option value=\"\" translate=\"DASHBOARD.none\"></md-option><md-option \nng-repeat=\"ent in vm.entities track by ent.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"ent.option\">{{ent.options}}\n</md-option></md-select></div><div style=\"margin-top: -17px;    margin-left: 8px\" flex=\"100\" flex-gt-xs=\"25\" \nflex-gt-md=\"25\"><md-select translate translate=\"MESSAGES.form_attr_contributor\" \nplaceholder=\"{{ \'MESSAGES.function\' | translate }}\" id=\"empMediaVideoForm_contributor\" ng-change=\"vm.searchPersons()\" \nng-model=\"vm.function\"><md-option value=\"\" translate=\"DASHBOARD.none\"></md-option><md-option \nng-repeat=\"f in vm.functions track by f.val\" ng-attr-data-index=\"{{$index}}\" ng-value=\"f.option\">{{f.options}}\n</md-option></md-select></div></div></md-card-content></md-card></div><div \nstyle=\"padding-left: 9px;padding-right: 8px\" class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"MOOCSTATS.subscriber\">User</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MOOCSTATS.date_response\">date_response</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"MOOCSTATS.response\">Réponse</span>\n</div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"MOOCSTATS.correct/incorrect\">Correcte/Incorrecte</span></div></th></tr>\n</thead></table></div></div></div>");
$templateCache.put("app/main/stats/mooc/tabStats/stat.mooc.course.html","<any><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_total_number_registrations\" type=\"total_registrations\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"></mesure-mooc-stats><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_number_on_going_registrations\" type=\"ongoing_registrations\" query=\"vm.query\" \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"></mesure-mooc-stats></div><datatable-themes \nhas-permission=\"stats_mooc_list_dtable_parameters_themes_mooc\" query=\"vm.query\"></datatable-themes><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_number_active_learners\" type=\"actif_learners\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_watching_videos_learners\" type=\"video_watcher\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats><mesure-mooc-stats \nhas-permission=\"stats_mooc_mooc_number_learners_tried_problem\" type=\"problem_tester\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats></div><md-card \nhas-permission=\"stats_mooc_participation_of_learners\"><div style=\"padding-left: 24px\" class=\"border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{ vm.widget_mooc.title |translate }}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget_mooc.ranges\" ng-click=\"vm.widget_mooc.changeRange(key)\" \nng-disabled=\"vm.widget_mooc.currentRange === key\">{{ range |translate }}</md-button></div></div><mooc-stats \nhas-permission=\"stats_mooc_participation_of_learners\" query=\"vm.query\"></mooc-stats></md-card></any>");
$templateCache.put("app/main/stats/mooc/tabStats/stat.mooc.performance.html","<any><md-card><div style=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{ \"STATSTITLE.performance_learners\" |translate }}</div></div>\n<mooc-performance-stats has-permission=\"stats_mooc_mooc_number_correct_incorrect_responses\" query=\"vm.query\">\n</mooc-performance-stats></md-card></any>");
$templateCache.put("app/main/stats/mooc/tabStats/stat.mooc.video.html","<any><md-card><div style=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{ \"STATSTITLE.video_complete_incomplete\" |translate }}</div></div>\n<mooc-views-stats has-permission=\"stats_mooc_mooc_number_complete_incomplete_video\" query=\"vm.query\">\n</mooc-views-stats></md-card></any>");
$templateCache.put("app/main/stats/mooc/tabStats/stat.mooc.voyage.html","<any><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-mooc-stats type=\"persons_passport\" \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats>\n<mesure-mooc-stats type=\"views_passport\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"33\"></mesure-mooc-stats><mesure-mooc-stats type=\"visas_persons\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"33\"></mesure-mooc-stats></div><md-card><div \nstyle=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{ \"STATSTITLE.nbr_views_per_trip\" |translate }}</div></div><mooc-stats-view-voayge query=\"vm.query\">\n</mooc-stats-view-voayge></md-card><md-card><div style=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{ \"STATSTITLE.nbr_expedition_per_trip\" |translate }}\n</div></div><mooc-stats-expedition-voayge query=\"vm.query\"></mooc-stats-expedition-voayge></md-card><md-card><div \nstyle=\"padding-left: 24px;height: 60px\" class=\"border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h3\">{{ \"STATSTITLE.nbr_views_per_excursions\" |translate }}</div></div><mooc-stats-excursion-voayge \nquery=\"vm.query\"></mooc-stats-excursion-voayge></md-card></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.audience.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats type=\"nombre_video\" \nquery=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats type=\"visite_total\" \nquery=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats type=\"visite_unique\" \nquery=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_visiteur\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_video\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats-player \ntype=\"number_loads\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_access\"></mesure-stats-player><mesure-stats-player \ntype=\"number_vue_per_autoplay\" query=\"vm.query\" class=\"h-140 cards-flex\" layout=\"column\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_autoplay\"></mesure-stats-player></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-percentage-stats type=\"NumberOfViewsFourthQuarter\" \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_fourth_quarter\"></mesure-percentage-stats>\n<mesure-percentage-stats type=\"NumberOfViewsFirstQuarter\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_first_quarter\">\n</mesure-percentage-stats><mesure-percentage-stats type=\"NumberOfViewsSecondQuarter\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_second_quarter\"></mesure-percentage-stats>\n<mesure-percentage-stats type=\"NumberOfViewsThirdQuarter\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_third_quarter\">\n</mesure-percentage-stats></div><md-card has-permission=\"stats_audience_{{vm.permission}}_audience_all\"><audience-stats\n query=\"vm.query\" permission=\"vm.permission\"></audience-stats></md-card><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><mesure-stats type=\"duree_total\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_visite\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_visiteur\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-stats type=\"duree_moyenne_par_video\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \nng-if=\"vm.query.vod_id && vm.infoVideo && vm.infoVideo.duration\" type=\"duree_video\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-standard-deviation-stats \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_standard_deviation_all\"></mesure-standard-deviation-stats>\n</div><md-card has-permission=\"stats_audience_{{vm.permission}}_duree_all\"><duree-stats query=\"vm.query\"></duree-stats>\n</md-card></div></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.engagement.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-by-ip-stats type=\"nombre_video\" \nquery=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"visite_total\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"visite_unique\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"duree_total\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_mesure_by_ip_all\"></mesure-by-ip-stats></div><md-card \nhas-permission=\"stats_engagement_{{vm.permission}}_ip_all\"><visits-ip-stats query=\"vm.query\"></visits-ip-stats>\n</md-card><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats type=\"nombre_vue_par_visiteur\" \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_video\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"duree_moyenne_par_visite\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \ntype=\"duree_moyenne_par_visiteur\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats><mesure-stats \nng-if=\"vm.query.vod_id\" type=\"duree_video\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\" has-permission=\"stats_mesure_audience_{{vm.permission}}_mesure_all\"></mesure-stats>\n<mesure-taux-rebond-stats query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\" \nhas-permission=\"stats_mesure_engagement_{{vm.permission}}_taux_rebond_all\"></mesure-taux-rebond-stats></div><md-card \nhas-permission=\"stats_engagement_{{vm.permission}}_duree_per_visite_all\"><duree-visite-stats query=\"vm.query\">\n</duree-visite-stats></md-card><md-card has-permission=\"stats_engagement_{{vm.permission}}_most_popular_all\">\n<most-popular-stats query=\"vm.query\"></most-popular-stats></md-card></div></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.geo.html","<any><div><md-card has-permission=\"stats_geo_{{vm.permission}}_geo_per_pays_all\"><map-geo-stats query=\"vm.query\">\n</map-geo-stats></md-card></div></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.mobile.html","<any><div><md-card has-permission=\"stats_technologie_{{vm.permission}}_os_all\"><os-stats query=\"vm.query\"></os-stats>\n</md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_browser_all\"><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_referrer_all\"><referrer-stats \nquery=\"vm.query\"></referrer-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_device_all\" \nng-if=\"vm.list_right_mobile.referrer\"><device-stats query=\"vm.query\"></device-stats></md-card></div></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.technologie.html","<any><div><md-card has-permission=\"stats_technologie_{{vm.permission}}_os_all\"><os-stats query=\"vm.query\"></os-stats>\n</md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_browser_all\"><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card has-permission=\"stats_technologie_{{vm.permission}}_referrer_all\"><referrer-stats \nquery=\"vm.query\"></referrer-stats></md-card></div></any>");
$templateCache.put("app/main/stats/vod_live/tabStats/stat.vod.temp_reel.html","<md-content><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><time-reel-now-stats \ntype=\"visite_temps_reel\" query=\"vm.query\" class=\"h-140\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\" \nhas-permission=\"stats_temps_reel_{{vm.permission}}_stats_now_all\"></time-reel-now-stats></div><md-card \nhas-permission=\"stats_temps_reel_{{vm.permission}}_now_hours_all\"><time-reel-heure-stats query=\"vm.query\">\n</time-reel-heure-stats></md-card><md-card has-permission=\"stats_temps_reel_{{vm.permission}}_stats_now_minute_all\">\n<time-reel-minute-stats query=\"vm.query\"></time-reel-minute-stats></md-card></div></md-content>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-if=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" aria-label=\"Favorite\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-if=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-if=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\" translate=\"MESSAGES.form_step_optional\">Optional</div></div>\n</md-button></div></div><div class=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-warn md-flat\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\" translate=\"MESSAGES.form_step_previous\">Back</md-button><div \nclass=\"ms-stepper-dots\"><span ng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\" \ntranslate=\"MESSAGES.form_step_next\">Next</md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" ng-disabled=\"!MsStepper.isFormValid()\" \ntranslate=\"MESSAGES.form_step_validate\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/display/schedule/calendar/detail/detail.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span flex=\"30\" class=\"title\">{{vm.calendarEvent.title}}</span> <span flex=\"70\"></span><div \nlayout=\"row\" ng-if=\"vm.calendarEvent.enable==true\" style=\"margin-right: 20px\"><md-icon class=\"s20\" \nstyle=\"margin-right: 5px\" md-font-icon=\"icon-check-circle\"></md-icon><span translate=\"DISPLAYSCHEDULECALENDAR.ENABLE\">\nEnable</span></div><div layout=\"row\" ng-if=\"vm.calendarEvent.enable==false\" style=\"margin-right: 20px\"><md-icon \nclass=\"s20\" style=\"margin-right: 5px\" md-font-icon=\"icon-block-helper\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.DISABLE\">Enable</span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-top: 30px\"><div layout=\"row\" style=\"margin-left: 20px\" \nlayout-align=\"start center\"><div ng-if=\"vm.status==-1\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nstyle=\"color: red\"></md-icon><span translate=\"DISPLAYSCHEDULECALENDAR.END\">Status</span></div><div \nng-if=\"vm.status==0\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" style=\"color: green\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.INPROGRESS\">Status</span></div><div ng-if=\"vm.status==1\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" style=\"color: orange\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.COME\">Status</span></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" \naria-label=\"Week\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.WEEK\"><md-icon \nmd-font-icon=\"icon-view-week\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n</md-button></a></div></div><div ng-if=\"vm.paramschedule==\'none\'\" style=\"margin-right: 50px\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Edit\" ng-click=\"vm.editSchedule()\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></a></div><div ng-if=\"vm.paramschedule==\'date\'\" \nstyle=\"margin-right: 50px\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" \nng-click=\"vm.editSchedule()\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\" \nng-hide=\"vm.testDate()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\" ng-hide=\"vm.testDate()\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></a></div><div ng-if=\"(vm.paramschedule==\'actif\') && (vm.calendarEvent.enable===false)\" \nstyle=\"margin-right: 50px\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" \nng-click=\"vm.editSchedule()\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</a></div></div><md-dialog-content ms-scroll><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"></md-dialog-actions></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/display/template_manager/editor/generator/generator.html","<div id=\"content_editor\" class=\"page-layout simple right-sidenav\" id=\"editor-page\" layout=\"row\"><div class=\"center\" \nflex ms-scroll><div class=\"content md-whiteframe-8dp editor-wrapper\" ng-class=\"vm.loading ? \'layout-row\':\'\'\" \nlayout-align=\"start center\"><div layout=\"row\" layout-align=\"center center\" \nng-if=\"!vm.isDefined(vm.currentScreenIndex) && !vm.loading\" style=\"min-height:inherit\"><div \nclass=\"md-display-2 cWhite-fg\" translate=\"TEMPALTEMANAGEREDITOR.choose_a_screen_layout\"></div></div><div \nng-if=\"!vm.isDefined(vm.currentScreenIndex) && !vm.loading\" style=\"min-height:inherit\" ms-scroll \nng-controller=\"dispositionsSelectorController as disCtrlscr\"><div \nng-init=\"disCtrlscr.screenPartitions = disCtrlscr.partition(disCtrlscr.screens,5)\"><div layout=\"row\" \nstyle=\"height: 200px;max-height: 200px\" layout-align=\"start center\" \nng-repeat=\"screensPartition in disCtrlscr.screenPartitions | limitTo : disCtrlscr.limit:disCtrlscr.begin\" \nlayout-margin><ms-widget flippable=\"false\" \nstyle=\"height: 100%;;width: 100%;padding:0px;cursor: pointer;background: white\" \nng-click=\"disCtrlscr.setScreen(screen.type,$event)\" flex=\"20\" ng-repeat=\"screen in screensPartition\"><ms-widget-front \nclass=\"white-bg\"><div \nstyle=\"width: 100%;height: 150px;background: url(\'{{screen.thumb}}\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\">\n</div><div class=\"border-top\" layout=\"row\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 50px;background: #039be5\" layout-padding><strong \nclass=\"cWhite-fg text-truncate md-display-1\" translate=\"TEMPALTEMANAGEREDITOR.{{screen.primary_head}}\">\n{{screen.primary_head}}</strong></div></ms-widget-front></ms-widget></div><div layout=\"row\" \nlayout-align=\"center center\" flex ng-if=\"disCtrlscr.screens.length && disCtrlscr.screens.length>10\"><div \nclass=\"simple-pagination\"><md-button class=\"pagination-item\" md-no-ink \nng-click=\"disCtrlscr.previousPaginationDisp($index)\" \nng-if=\"disCtrlscr.screens.length && (disCtrlscr.screens.length/10)>3\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button ng-if=\"disCtrlscr.screens.length && disCtrlscr.screens.length>10\" \nng-repeat=\"nb in disCtrlscr.screens | limitTo: disCtrlscr.limitPaginationDisp : vm.beginPaginationDisp \" \nng-click=\"disCtrlscr.paginationDisp($index)\" class=\"pagination-item active\" aria-label=\"Go to page {{$index}}+1\"><span>\n{{$index + disCtrlscr.beginPagination+1}}</span></md-button><md-button class=\"pagination-item\" \nng-if=\"disCtrlscr.screens.length && (disCtrlscr.screens.length/10)>3\" \nng-click=\"disCtrlscr.nextPaginationDisp($index,disCtrlscr.screens.length)\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div></div></div><div ng-if=\"!vm.isDefined(vm.currentScreenIndex) && !vm.loading\" style=\"min-height:inherit\" \nms-scroll ng-controller=\"dispositionsSelectorController as disCtrl\"><div layout=\"row\" layout-align=\"center center\" \nstyle=\"min-height:inherit\" ng-if=\"vm.storedScreens.length\"><div class=\"md-display-2 cWhite-fg\" \ntranslate=\"TEMPALTEMANAGEREDITOR.choose_a_screen_layout_stored\"></div></div><div \nng-init=\"vm.storedscreenPartitions = vm.partition(vm.storedScreens,5)\"><div layout=\"row\" \nstyle=\"height: 200px;max-height: 200px\" layout-align=\"start center\" \nng-repeat=\"storedscreensPartition in vm.storedscreenPartitions| limitTo : 2:0\" layout-margin><ms-widget \nflippable=\"false\" style=\"height: 100%;;width: 100%;padding:0px;cursor: pointer;background: white\" \nng-click=\"vm.useStoredScreenConfirm(screen,$event)\" flex=\"20\" ng-repeat=\"screen in storedscreensPartition\">\n<ms-widget-front class=\"white-bg\"><div ng-if=\"screen.background.allowedToUseBackgroundImage\" \nstyle=\"width: 100%;height: 150px;background: url(\'{{screen.background.url}}\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\">\n</div><div class=\"border-top\" layout=\"row\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 50px;background: #039be5\" layout-padding><strong \nclass=\"cWhite-fg text-truncate md-display-1\">{{screen.title}}</strong></div></ms-widget-front></ms-widget></div></div>\n<div style=\"display: inline-block;color: #fff;width: 100%;text-align: center\"><span ng-if=\"vm.vLength>(vm.start+10)\">\n{{vm.start+1}}-{{vm.start -- 10 }} <span translate=\"MESSAGES.of\">sur</span> {{vm.vLength}}</span> <span \nng-if=\"vm.vLength<=(vm.start+10)\">{{vm.start+1}}-{{vm.vLength }} <span translate=\"MESSAGES.of\">sur</span>\n {{vm.vLength}}</span><md-button class=\"btn-pagination btn-pagination-display\" ng-disabled=\"vm.currentPage === 0\" \nng-click=\"vm.firstPage()\" translate=\"MESSAGES.first\">Premier</md-button><md-button \nclass=\"btn-pagination btn-pagination-display\" ng-disabled=\"vm.currentPage === 0\" ng-click=\"vm.previousPage()\" \ntranslate=\"MESSAGES.previous\">previous</md-button><span ng-if=\"vm.currentPage+1>1\">...</span><md-button \nclass=\"btn-pagination btn-pagination-display\" ng-disabled=\"vm.currentPage+1===vm.currentPage+1\" \nstyle=\"min-width: 33px !important;width: 33px !important\">{{vm.currentPage+1}}</md-button><md-button \nng-click=\"vm.click2(vm.currentPage+2)\" ng-if=\"vm.vLength/10>1 && vm.currentPage+2<=vm.numberOfPages()  \" \nclass=\"btn-pagination\" style=\"min-width: 33px !important;width: 33px !important\">{{vm.currentPage+2}}</md-button>\n<md-button ng-click=\"vm.click3(vm.currentPage+3)\" ng-if=\"vm.vLength/10>2 && vm.currentPage+3<=vm.numberOfPages()\" \nclass=\"btn-pagination\" style=\"min-width: 33px !important;width: 33px !important\">{{vm.currentPage+3}}</md-button><span \nng-if=\"vm.vLength/10>3 && vm.currentPage+3<=vm.numberOfPages()\">...</span><md-button \nclass=\"btn-pagination btn-pagination-display\" ng-disabled=\"vm.currentPage >= vm.vLength/10 - 1\" \nng-click=\"vm.nextPage()\" translate=\"MESSAGES.next\">previous</md-button><md-button \nclass=\"btn-pagination btn-pagination-display\" ng-disabled=\"vm.currentPage >= vm.vLength/10 - 1\" \nng-click=\"vm.lastPage()\" translate=\"MESSAGES.last\">Dernier</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"vm.loading\" style=\"min-height:100;min-width: 100%\" class=\"cWhite-fg\">\n<md-progress-circular md-mode=\"indeterminate\" class=\"md-accent mh-10\" md-diameter=\"64\"></md-progress-circular></div>\n<ng-include ng-if=\"vm.isDefined(vm.currentScreenIndex) && !vm.loading\" only-watched-property class=\"editor-content\" \nid=\"editor-content\" src=\"vm.disposition.templateName\" onload=\"vm.onloadScreen()\"></ng-include></div></div><md-sidenav \nng-include=\"\'app/main/display/template_manager/editor/side-nav/side-nav.html\'\" \nng-controller=\"editorSideNavController as vm\" ng-if=\"vm.showParams\" \nclass=\"bloc-params-side-nav sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper style=\"padding: 0!important\"></md-sidenav></div><ms-editor-time-line></ms-editor-time-line>");
$templateCache.put("app/main/display/template_manager/editor/ms-editor-time-line/generic.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"addElementParams\" style=\"width:850px\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span ng-if=\"vm.typeGen==\'opening\'\" \ntranslate=\"TEMPALTEMANAGEREDITOR.opening_generic\">{{\'TEMPALTEMANAGEREDITOR.opening_generic\'|translate}}</span> <span \nng-if=\"vm.typeGen==\'closing\'\" translate=\"TEMPALTEMANAGEREDITOR.generic_closing\">\n{{\'TEMPALTEMANAGEREDITOR.generic_closing\'|translate}}</span> </span><span flex></span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll class=\"flex-scrollable\" layout=\"column\"><div layout=\"row\" flex=\"100\" \nmd-no-float><div style=\"padding: 15px;background-color: #FBFBFB;border-radius: 10px;width: 100%\" \nng-if=\"vm.typeGen==\'opening\'\"><div layout=\"row\" flex=\"100\"><div style=\"width: 100%\" layout=\"row\" \nlayout-align=\"center center\"><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);    padding-top: 0;margin-top: 0;    width: 100%;height: 220px;border-radius: 5px\" \nclass=\"product-detail-form-container\"><div layout=\"column\" layout-align=\"center center\" style=\"height: 100%\" \nflow-init=\"vm.ngFlowOptionsGenericDeb\" flow-name=\"vm.ngFlowDeb.flow\" flow-files-submitted=\"vm.uploadFileGenericDeb()\" \nflow-file-added=\"vm.fileAddedGenericDeb($file)\" flow-file-progress=\"vm.uploadingInPogressDeb = 1\" \nflow-file-success=\"vm.fileSuccessDeb($message)\" flow-complete=\"vm.uploadCompleteGenericDeb()\" \nflow-file-error=\"vm.fileErrorDeb($file,$message)\"><div style=\"padding-bottom: 20px\" class=\"drop-text hint-text\" \nlayout=\"column\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">drop_to_upload</span> <span \ntranslate=\"MESSAGES.ou\">ou</span></div><div class=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"cWhite-br\" style=\";border:1px solid\" flow-btn><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"TEMPALTEMANAGEREDITOR.choose_video\"></span></md-button></div><md-progress-circular \nng-if=\"vm.uploadingInPogressDeb\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"start start\" style=\"padding: 5px\" \nng-if=\"vm.videosGeneric.urls.length>0\"><span>{{\'TEMPALTEMANAGEREDITOR.select_video\' | translate}}</span></div><div \nlayout=\"row\" flex=\"100\" style=\"padding: 5px\" ng-if=\"vm.videosGeneric.urls.length>0\"><div layout=\"column\" flex=\"20\" \nng-repeat=\"video in vm.videosGeneric.relative_path\" ng-click=\"vm.selectVideoGenericOpening($index)\" \nstyle=\"cursor: pointer\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"icon_generic_modal s70\"></md-icon><p \nclass=\"description_generic_modal\">{{video}}</p></div></div></div></div><div \nstyle=\"padding: 15px;background-color: #FBFBFB;border-radius: 10px;width: 100%\" ng-if=\"vm.typeGen==\'closing\'\"><div \nlayout=\"row\" flex=\"100\"><div style=\"width: 100%\" layout=\"row\" layout-align=\"center center\"><div layout-padding \nlayout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);padding-top: 0;margin-top: 0; width: 100%;height: 220px;border-radius: 5px\" \nclass=\"product-detail-form-container\"><div layout=\"column\" layout-align=\"center center\" style=\"height: 100%\" \nflow-init=\"vm.ngFlowOptionsGenericFin\" flow-name=\"vm.ngFlowFin.flow\" flow-files-submitted=\"vm.uploadFileGenericFin()\" \nflow-file-added=\"vm.fileAddedGenericFin($file)\" flow-file-progress=\"vm.uploadingInPogressFin = 1\" \nflow-file-success=\"vm.fileSuccessFin($message)\" flow-complete=\"vm.uploadCompleteGenericFin()\" \nflow-file-error=\"vm.fileErrorFin($file,$message)\"><div style=\"padding-bottom: 20px\" class=\"drop-text hint-text\" \nlayout=\"column\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">drop_to_upload</span> <span \ntranslate=\"MESSAGES.ou\">ou</span></div><div class=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"cWhite-br\" style=\";border:1px solid\" flow-btn><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"TEMPALTEMANAGEREDITOR.choose_video\"></span></md-button></div><md-progress-circular \nng-if=\"vm.uploadingInPogressFin\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div></div></div>\n</div><div layout=\"row\" flex=\"100\" layout-align=\"start start\" style=\"padding: 5px\" \nng-if=\"vm.videosGeneric.urls.length>0\"><span>{{\'TEMPALTEMANAGEREDITOR.select_video\' | translate}}</span></div><div \nlayout=\"row\" flex=\"100\" style=\"padding: 5px\" ng-if=\"vm.videosGeneric.urls.length>0\"><div layout=\"column\" \nng-repeat=\"video in vm.videosGeneric.relative_path\" flex=\"20\" ng-click=\"vm.selectVideoGenericClose($index)\" \nstyle=\"cursor: pointer\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"icon_generic_modal s70\"></md-icon><p \nclass=\"description_generic_modal\">{{video}}</p></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/display/template_manager/editor/ms-editor-time-line/ms-editor-time-line.html","<div id=\"ms-editor-time-line\" layout=\"row\" llayout-align=\"start center\"><any \nng-if=\"toggleMsEditorTimeLine($root.screenEditorCtrl)\" style=\"max-height: 0px;max-width:0px\"></any><div \nng-if=\"isExpanded\" id=\"ms-editor-time-line-message\" style=\"overflow-x: scroll !important\"><div layout=\"row\" \nlayout-align=\"start center\" flex class=\"ms-editor-time-line-content\" style=\"position: relative;display: ruby\"><div \nlayout=\"row\" llayout-align=\"center center\" style=\"height: 100%\" ng-if=\"vm.generic\"><ms-widget flippable=\"true\" \nlayout=\"column\" style=\"height: 125px;min-width: 120px;position: relative;padding:0px;margin-right: 15px\">\n<ms-widget-front class=\"widget-card\" id=\"generic\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 100%;text-align: center\"><md-button class=\"md-icon-button\" \nstyle=\"margin:0px;padding:0px;width: 52px;height: 52px\" aria-label=\"add generic\" \nng-click=\"vm.manageGeneric(\'opening\')\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s48\"></md-icon></md-button><span \nclass=\"font-weight-500 cWhite-fg\" style=\"font-size: 1.2rem\" translate=\"TEMPALTEMANAGEREDITOR.opening_generic\">\n{{\'TEMPALTEMANAGEREDITOR.opening_generic\'|translate}}</span></div></ms-widget-front></ms-widget></div><any \nclass=\"ms-editor-time-line-active-dragula\" dragula=\'\"ms-editor-time-line\"\' \ndragula-model=\"$root.screenEditorCtrl.screens\" style=\"display: flex\"><div \nng-repeat=\"screen in $root.screenEditorCtrl.screens\" class=\"mh-10 time-line-sortable\" layout=\"row\" \nlayout-align=\"start center\"><div ng-class=\"$root.screenEditorCtrl.currentScreenIndex == $index ? \'selected\':\'\'\" \nclass=\"time-line-sortable widget-group\" data-screen-id=\"{{screen.rid}}\" layout=\"row\" flex=\"100\" layout-wrap \nstyle=\"margin-right: 15px; display: -webkit-box; background-color: transparent !important\"><ms-widget flippable=\"true\" \nlayout=\"column\" class=\"arrow_box\" draggable=\"false\" ng-if=\"vm.intro\" \nstyle=\"left: 0; right:15px;height: 180px;width: 140px;padding:0px;position: relative;border-radius: 4%\">\n<ms-widget-front style=\"border-radius: 4%\"><div ng-if=\"!screen.vignette && !screen.timevideo\" layout=\"column\" \nlayout-align=\"space-between center\" \nstyle=\"width: 140px;height: 180px;max-height: 180px;background-size:contain;background-color: #505050;background-position: center\">\n<div ng-if=\"!screen.vignette && !screen.timevideo\" layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 140px;height: 180px;max-height: 180px;background-size:contain;background-color: #505050;background-position: center\" \nflow-init=\"vm.ngFlowOptionsGeneric\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFileGeneric()\" \nflow-file-added=\"vm.fileAddedGeneric($file)\" flow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.fileSuccess($message)\" flow-complete=\"vm.uploadCompleteGeneric()\" \nflow-file-error=\"vm.fileError($file,$message)\"><md-button class=\"md-icon-button\" flow-btn \nng-click=\"$root.screenEditorCtrl.workOnScreen($index)\" style=\"margin:10px;padding:5px;width: 52px;height: 52px\" \naria-label=\"add screen\"><md-icon md-font-icon=\"icon-plus\" class=\"s48\"></md-icon></md-button><div \nclass=\"h3 secondary-text font-weight-500 text-truncate white-fg\" style=\"z-index:10;margin-top: 10%\">\n{{\'TEMPALTEMANAGEREDITOR.video_introd\'|translate}}</div><md-progress-circular ng-if=\"vm.uploadingInPogress\" \nstyle=\"bottom: 5%;color: white\" class=\"md-primary mh-10\" md-diameter=\"25\"></md-progress-circular></div></div><div \nng-if=\"!screen.vignette && screen.timevideo\" layout=\"column\" layout-align=\"end stretch\" \nstyle=\"width: 140px;height: 180px;max-height: 180px;cursor: pointer;background: url(\'\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\">\n<span class=\"md-subhead\" \nstyle=\"color: #ffffff ; background: #2e3440;height: 40px !important; min-height: 40px !important; max-height: 40px !important;padding-top: 10% ;padding-left: 10%\">\n</span><md-icon \nstyle=\"width: 140px;height: 180px;max-height: 180px;background-position: center; color:#505050 !important\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s70\"></md-icon><span class=\"md-subhead\" \nstyle=\"color: #ffffff ;     background: #2e3440;height: 40px !important; min-height: 40px !important; max-height: 40px !important;padding-top: 10% ;padding-left: 10%\">\n<md-icon style=\"color:#ffffff !important\" md-font-icon=\"icon-clock\" class=\"s18\"></md-icon>{{ screen.timevideo }}</span>\n</div><div ng-if=\"screen.vignette\" layout=\"column\" layout-align=\"end stretch\" \nstyle=\"width: 140px;height: 180px;max-height: 180px;cursor: pointer;background: url(\'{{screen.vignette}}\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\">\n<span class=\"md-subhead\" \nstyle=\"color: #ffffff ; background: #2e3440;height: 40px !important; min-height: 40px !important; max-height: 40px !important;padding-top: 10% ;padding-left: 10%\">\n</span> <span class=\"md-subhead\" \nstyle=\"color: #ffffff ;     background: #2e3440;height: 40px !important; min-height: 40px !important; max-height: 40px !important;padding-top: 10%; padding-left: 10%\">\n<md-icon style=\"color:#ffffff !important\" md-font-icon=\"icon-clock\" class=\"s18\"></md-icon>{{ screen.timevideo }}</span>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nstyle=\"height: 180px;width: 190px;padding:0px;position: relative\" ng-class=\"{\'leftwidgt\':vm.intro}\"><ms-widget-front \nstyle=\"border-radius: 4%\" ng-class=\"{\'widthwidgt\':vm.intro}\"><div ng-if=\"!screen.canvasImage\" \nstyle=\"display: block;height: 140px;width: 100%;background-color:rgba(0, 0, 0, 0.55);position: absolute;z-index: 5\">\n</div><div ng-if=\"!screen.canvasImage\" ng-click=\"$root.screenEditorCtrl.workOnScreen($index)\" layout=\"column\" \nlayout-align=\"center center\" \nstyle=\"width: 190px;height: 140px;max-height: 140px;cursor: pointer;background: url(\'{{vm.getScreenCapture(screen)}}\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\">\n<div class=\"font-size-72 line-height-72\" style=\"z-index:10;color:#039be5\">{{$index + 1}}</div><div \nclass=\"h3 secondary-text font-weight-500 text-truncate white-fg\" style=\"z-index:10\">{{screen.title}}</div></div><img \nng-if=\"screen.canvasImage\" ng-click=\"$root.screenEditorCtrl.workOnScreen($index)\" layout=\"column\" \nllayout-align=\"center center\" ng-src=\"{{ screen.canvasImage }}\" alt=\"SS\" aria-label=\"SS\" width=\"200\" height=\"140\" \nstyle=\"width: 190px;height: 140px;max-height: 140px;cursor: pointer\"><div \nclass=\"border-top screen-actions-content ph-10\" layout=\"row\" layout-align=\"space-between center\"><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.waiting_for_screen_shot\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><span ng-if=\"screen.loadingScreenShot\"><md-progress-circular class=\"cWhite-fg\" \nmd-mode=\"indeterminate\" md-diameter=\"18\"></md-progress-circular></span></a><md-menu><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.duplicate_screen\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-content-duplicate\" class=\"s18 actions\"></md-icon></md-button></a><md-menu-content width=\"3\">\n<md-menu-item><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.duplicate_screen_many_time\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button ng-click=\"$root.screenEditorCtrl.duplicateMany(screen,$event)\" \naria-label=\"Flip widget\">{{\'TEMPALTEMANAGEREDITOR.duplicate_screen_many_time\'|translate}}</md-button></a>\n</md-menu-item><md-menu-item><md-button ng-click=\"$root.screenEditorCtrl.duplicate(screen,true)\" \naria-label=\"Refresh widget\">{{\'TEMPALTEMANAGEREDITOR.duplicate_screen\'|translate}}</md-button></md-menu-item>\n</md-menu-content></md-menu><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.delete_screen\'|translate}}\" \ntooltip-side=\"left\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" data-index=\"{{$index}}\" \nng-click=\"vm.removeScreen($index,$event)\" aria-label=\"delete_screen\"><md-icon md-font-icon=\"icon-trash\" \nclass=\"s18 actions\"></md-icon></md-button></a></div></ms-widget-front></ms-widget></div></div></any><div \nng-if=\"$root.screenEditorCtrl.currentScreenIndex == $root.screenEditorCtrl.screens.length\" layout=\"row\" \nllayout-align=\"center center\" style=\"height: 100%\"><ms-widget flippable=\"true\" layout=\"column\" \nstyle=\"height: 180px;width: 200px;position: relative;padding:0px;margin-right: 15px\"><ms-widget-front \nclass=\"widget-card\" style=\"border-radius: 4%\"><div layout=\"row\" layout-align=\"center center\" flex style=\"height: 100%\">\n<img style=\"border-radius: 25px;width:50px;height:50px\" class=\"media\" ng-src=\"assets/images/display/logos/loading.png\" \naria-label=\"new screen\"></div></ms-widget-front></ms-widget></div><div flex></div><div \nng-if=\"$root.screenEditorCtrl.screens.length\" layout=\"row\" llayout-align=\"center center\" style=\"height: 100%\">\n<ms-widget flippable=\"true\" layout=\"column\" \nstyle=\"height: 180px;width: 200px;position: relative;padding:0px;margin-right: 15px\"><ms-widget-front \nclass=\"widget-card\" style=\"border-radius: 4%\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 200px;height: 200px\"><md-button class=\"md-icon-button\" \nng-click=\"$root.screenEditorCtrl.setCurrentIndex( $root.screenEditorCtrl.screens.length)\" \nstyle=\"margin:0px;padding:0px;width: 52px;height: 52px\" aria-label=\"add screen\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s48\"></md-icon></md-button><div class=\"h3 font-weight-500 cWhite-fg\" \ntranslate=\"TEMPALTEMANAGEREDITOR.new_screen\">new_screen</div></div></ms-widget-front></ms-widget></div><div \nlayout=\"row\" llayout-align=\"center center\" style=\"height: 100%\" ng-if=\"vm.intro\"><ms-widget flippable=\"true\" \nlayout=\"column\" style=\"height: 125px;min-width: 120px;position: relative;padding:0px;margin-right: 15px\">\n<ms-widget-front class=\"widget-card\" id=\"generic\"><div layout=\"column\" layout-align=\"center center\" \nstyle=\"width: 100%;height: 100%;text-align: center\"><md-button class=\"md-icon-button\" \nstyle=\"margin:0px;padding:0px;width: 52px;height: 52px\" aria-label=\"add generic\" \nng-click=\"vm.manageGeneric(\'closing\')\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s48\"></md-icon></md-button><span \nclass=\"font-weight-500 cWhite-fg\" style=\"font-size: 1.2rem\" translate=\"TEMPALTEMANAGEREDITOR.generic_closing\">\n{{\'TEMPALTEMANAGEREDITOR.generic_closing\'|translate}}</span></div></ms-widget-front></ms-widget></div></div></div>\n<md-button ng-if=\"isExpanded\" id=\"ms-editor-time-line-close\" class=\"md-icon-button\" aria-label=\"Collapse\" \nng-click=\"collapseMsEditorTimeLine()\"><md-icon md-font-icon=\"icon-chevron-down s24\"></md-icon></md-button><md-button \nng-if=\"!isExpanded\" id=\"ms-editor-time-line-close\" class=\"md-icon-button\" aria-label=\"Expand\" \nng-click=\"expandMsEditorTimeLine()\"><md-icon md-font-icon=\"icon-chevron-up s24\"></md-icon></md-button></div>");
$templateCache.put("app/main/display/template_manager/editor/toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\" classs=\"md-primary-bg\"><div \nng-if=\"$root.screenEditorCtrl.screens.length\" layout=\"row\" layout-align=\"center-center\"><a tooltips \ntooltip-template=\"{{(vm.blocsLetterAreShown ? \'TEMPALTEMANAGEREDITOR.hide_bloc_indications\' : \'TEMPALTEMANAGEREDITOR.show_bloc_indications\' ) | translate}}\" \ntooltip-side=\"right\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\" vm.toggleblocsLetter() \" \naria-label=\"toogle show blocks letter\"><md-icon \nmd-font-icon=\"{{vm.blocsLetterAreShown ? \'icon-eye-off\' : \'icon-eye\' }}\" class=\"icon\"></md-icon></md-button></a><div \nclass=\"toolbar-separator\"></div><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.see_screen\'|translate}}\" \ntooltip-side=\"right\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.setFullScreen()\" \naria-label=\"see_screen\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.see_screen\"><md-icon \nmd-font-icon=\"icon-fullscreen\" class=\"icon\"></md-icon></md-button></a><div class=\"toolbar-separator\"></div><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.save_template\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.save($event)\" aria-label=\"save_template\" translate \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.save_template\"><i class=\"icon-content-save\" \nstyle=\"color: rgba(255, 255, 255, 1) !important\"></i></md-button></a><div \nng-if=\"$root.screenEditorCtrl.currentTemplate.id\" class=\"toolbar-separator\"></div><a tooltips \ntooltip-template=\"{{\'TMTEMPLATESLIST.action_open\'|translate}}\" tooltip-side=\"right\" tooltip-speed=\"fast\"><md-button \nng-if=\"$root.screenEditorCtrl.currentTemplate.id\" target=\"blank\" \nng-href=\"{{vm.urlFoDisplay+\'show-template/\'+$root.screenEditorCtrl.currentTemplate.id}}\" class=\"md-icon-button\" \nng-click=\"vm.openTemplate($event)\" aria-label=\"action_open\" translate \ntranslate-attr-aria-label=\"TMTEMPLATESLIST.action_open\"><md-icon md-font-icon=\"icon-open-in-new\" class=\"icon\">\n</md-icon></md-button></a><div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/main/display/template_manager/editor/side-nav/modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"addInfomrations\" style=\"width:850px\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"TEMPALTEMANAGEREDITOR.addInfomrations\">\naddInfomrations</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nflex=\"100\" md-no-float ng-if=\"vm.infoBar.data.informations\" \nng-repeat=\"info in vm.infoBar.data.informations track by $index\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"60\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.information\">information</label><input type=\"text\" name=\"content\" \nng-model=\"info.content\" autocomplete=\"off\" md-autofocus=\"!info.content\"></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\" style=\"height:58px\"><label translate=\"TEMPALTEMANAGEREDITOR.priority\">priority</label>\n<md-select ng-model=\"info.priority\" aria-label=\"background repeat\"><md-option \nng-repeat=\"informationLevel in vm.informationsLevel\" ng-value=\"informationLevel.val\">\n{{\'TEMPALTEMANAGEREDITOR.\'+informationLevel.option|translate}}</md-option></md-select></md-input-container><div \nflex=\"5\"><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.remove_info\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button md-warn\" style=\"margin-top:-18px\" \nng-click=\"vm.removeInfo($index)\" aria-label=\"remove_info\" translate \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.remove_info\"><md-icon md-font-icon=\"icon-trash\"></md-icon></md-button>\n</a></div><div flex=\"5\"><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.add_new_info\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button md-primary\" style=\"margin-top:-18px\" \nng-click=\"vm.addNewInfo()\" aria-label=\"add_new_info\" translate \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.add_new_info\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</a></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><a \ntooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.restore_informations\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.reInitialiszeInfoArray()\" \naria-label=\"restore_informations\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.restore_informations\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.sort_by_priority\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-if=\"vm.infoBar.data.informations && vm.infoBar.data.informations.length > 1\" \nng-click=\"vm.sortByPriority()\" aria-label=\"sort_by_priority\" translate \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.sort_by_priority\"><md-icon md-font-icon=\"icon-sort-descending\">\n</md-icon></md-button></a><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.delete_all\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.clearAllInformations()\" \naria-label=\"delete_all\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.delete_all\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon></md-button></a><span flex></span><md-button class=\"md-accent\" \nng-click=\"vm.closeDialog()\" translate=\"MESSAGES.alert_close\">CLOSE</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/display/template_manager/editor/side-nav/side-nav.html","<md-content class=\"editor-content\" id=\"parametre-content\" ms-scroll-y flex style=\"background: transparent\"><div \nstyle=\"background-color: #098dcd\" ng-include=\"\'app/main/display/template_manager/editor/toolbar/toolbar.html\'\" \nng-controller=\"templateManagerToolbarController as vm\"></div><md-tabs md-selected=\"vm.selectedTabIndex\" \nmd-border-bottom md-autoselect id=\"screen-tabs-display\"><md-tab id=\"screen_params\"><md-tab-label>\n{{\'TEMPALTEMANAGEREDITOR.screen_conf\'|translate}}</md-tab-label><md-tab-body><div style=\"padding: 24px\"><div \nflex=\"100\"><form name=\"screenForm\" id=\"screenForm\" ng-submit=\"vm.submitScreenForm($event)\" novalidate><div \nng-if=\"vm.loading\" layout-align=\"center center\" layout=\"row\" flex style=\"margin-top:30px\"><md-progress-circular \nmd-mode=\"indeterminate\" class=\"md-accent mh-10\" md-diameter=\"64\"></md-progress-circular></div><div ng-if=\"!vm.loading\">\n<div layout=\"row\" flex><md-input-container class=\"md-block\" md-no-float flex><label class=\"md-no-float\" \ntranslate=\"TEMPALTEMANAGEREDITOR.form_title\">form_title</label><input type=\"text\" name=\"title\" \nng-model=\"vm.screen.title\" required autocomplete=\"off\"><div ng-messages=\"screenForm.title.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">field is required</span></div></div>\n</md-input-container></div><any ng-if=\"!!vm.show_date_display\"><label class=\"md-no-float\" style=\"margin-bottom: 5px\" \ntranslate=\"MESSAGES.date_hour\">date_hour</label><div layout=\"row\" style=\"margin-top: 10px\"><div layout=\"column\" \nflex=\"50\"><md-input-container style=\"width:100%\" flex><label class=\"md-no-float\" translate=\"MESSAGES.start_dt\" \nstyle=\"font-size: 12px\">start_dt</label><md-datepicker id=\"icondatetime\" required \nng-model=\"vm.screenForm.mdTime.dateStart\" ng-change=\"vm.changeStartDate()\" style=\"position: absolute;left: -10px\" \nng-attr-name=\"datestart\" md-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker></md-input-container></div><div \nlayout=\"column\" flex><md-input-container style=\"width:100%\" flex><label class=\"md-no-float\" \ntranslate=\"MESSAGES.end_dt\" style=\"font-size: 12px\">end_dt</label><md-datepicker id=\"icondatetime2\" required \nng-model=\"vm.screenForm.mdTime.dateEnd\" ng-change=\"vm.changeEndDate()\" style=\"position: absolute;left: -10px\" \nng-attr-name=\"dateend\" md-min-date=\"vm.screenForm.mdTime.dateStart\" md-open-on-focus></md-datepicker>\n</md-input-container></div></div><div layout=\"row\" style=\"margin-top: 10%\"><div layout=\"column\" flex=\"50\">\n<mdp-time-picker style=\"margin-right: -34%\" ng-change=\"vm.changeStartTime()\" ng-model=\"vm.screenForm.mdTime.timeStart\" \nng-attr-name=\"starttime\" mdp-format=\"HH:mm:ss\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" \nrequired><label translate=\"MESSAGES.start_dt\" style=\"font-size: 16px;left: -25%\">start_dt</label></mdp-time-picker>\n</div><div layout=\"column\" flex><mdp-time-picker style=\"margin-right: -14%\" ng-change=\"vm.changeEndTime()\" \nng-model=\"vm.screenForm.mdTime.timeEnd\" ng-attr-name=\"endtime\" mdp-format=\"HH:mm:ss\" \nmdp-min-time=\"vm.screenForm.mdTime.timeStart\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" \nrequired><label translate=\"MESSAGES.end_dt\" style=\"font-size: 16px;left: -25%\">end_dt</label></mdp-time-picker></div>\n</div></any><div layout=\"row\" flex><div layout=\"column\" layout-gt-sm=\"row\"><md-checkbox ng-true-value=\"true\" \nng-false-value=\"false\" ng-change=\"vm.setResponsiveDisplay()\" ng-model=\"vm.responsive\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.display_responsive\">display_responsive</label></md-checkbox></div></div><div \nlayout=\"row\" flex ng-class=\"{\'responsive-disabled\': vm.responsive}\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container md-no-float flex><label translate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input \nng-disabled=\"vm.responsive\" type=\"text\" name=\"width\" ng-model=\"vm.screen.width\" required autocomplete=\"off\" \nng-pattern=\"/^(1|2|3)?\\d{3}$/\"><div ng-messages=\"screenForm.width.$error\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"MESSAGES.form_is_required\">field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"MESSAGES.form_is_patternphone\">form_is_patternphone</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"10\">Ce champ doit comporter au plus {{length}} caractères.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container md-no-float \nflex><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input ng-disabled=\"vm.responsive\" \ntype=\"text\" name=\"height\" ng-model=\"vm.screen.height\" required autocomplete=\"off\" ng-pattern=\"/^(1|2|3)?\\d{3}$/\">\n<md-icon md-font-icon=\"icon-calculator\" ng-hide=\"vm.responsive\" ng-click=\"vm.calculateHeight()\" class=\"name\">\n<md-tooltip>{{\"TEMPALTEMANAGEREDITOR.calculate_height\" | translate:\'{ratio:\"16:9\"}\' }}</md-tooltip></md-icon><div \nng-messages=\"screenForm.height.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"MESSAGES.form_is_required\">field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"MESSAGES.form_is_patternphone\">form_is_patternphone</span></div><div ng-message=\"md-maxlength\"><span \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"10\">Ce champ doit comporter au plus {{length}} caractères.\n</span></div></div></md-input-container></div></div><div layout=\"row\" flex><md-input-container class=\"md-block\" \nmd-no-float flex style=\"margin-bottom: 30px\"><label translate=\"TEMPALTEMANAGEREDITOR.form_duration\" \ntranslate-value-value=\"{{vm.screen.duration}}\">form_duration</label><input name=\"duration\" class=\"md-input\" \nng-model=\"vm.screen.duration_time\" placeholder=\"--:--:--\" ng-pattern=\"/^([0-1][0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/\" \nng-attr-data-duration=\"{{vm.screen.duration}}\"><div ng-messages=\"screenForm.duration.$error\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"MESSAGES.form_is_required\">field is required</span></div><div \nng-message=\"pattern\"><span translate=\"MESSAGES.invalid_time_format\">invalid_time_format</span></div><div \nng-message=\"greaterThanOrEqual\"><span translate=\"TEMPALTEMANAGEREDITOR.screen_duration_must_be_greater_or_equal\" \ntranslate-value-value=\"5\">value_must_be_greater_or_equal</span></div></div></md-input-container></div><div \nlayout=\"row\" ng-if=\"vm.element.options.useSub==\'no\'\"><md-checkbox ng-model=\"vm.screen.timeAsProgram\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.time_as_program\">time_as_program</label></md-checkbox></div></div></form></div><form \nid=\"formDisplayFilInfo1\" name=\"stepper\" ms-vertical-stepper method=\"post\" \nng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" ng-model=\"vm.stepper\" novalidate \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<div ng-if=\"vm.trigger\"><ms-vertical-stepper-step id=\"buttonstep4\" ng-form=\"step4\" step=\"4\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.screen_decl\'\"><div layout=\"row\" flex=\"100\" class=\"mt-32\" md-no-float \nstyle=\"background: transparent !important\"><md-radio-group ng-model=\"vm.screen.declencheur\" ng-change=\"vm.changeDec()\" \nstyle=\"left: 0px; position: relative\"><md-radio-button value=\"screen_decl_hor\">\n{{\'TEMPALTEMANAGEREDITOR.screen_decl_hor\'|translate}}</md-radio-button><md-radio-button value=\"screen_decl_gare\">\n{{\'TEMPALTEMANAGEREDITOR.screen_decl_gare\'|translate}}</md-radio-button><md-radio-button value=\"screen_decl_trajet\">\n{{\'TEMPALTEMANAGEREDITOR.screen_decl_trajet\'|translate}}</md-radio-button><md-radio-button \nvalue=\"screen_decl_terminus\">{{\'TEMPALTEMANAGEREDITOR.screen_decl_terminus\'|translate}}</md-radio-button>\n</md-radio-group></div></ms-vertical-stepper-step></div><ms-vertical-stepper-step id=\"buttonstep2\" ng-form=\"step2\" \nstep=\"2\" step-title-translate=\"\'TEMPALTEMANAGEREDITOR.screen_params\'\"><div layout=\"row\" flex=\"100\" class=\"mt-32\" \nstyle=\"margin-left: 0%\" md-no-float><md-checkbox ng-true-value=\"true\" ng-false-value=\"false\" \nng-change=\"vm.setScreenInfoBar()\" ng-model=\"vm.screen.hasInfoBar\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.has_info_bar\">has_info_bar</label></md-checkbox></div><div layout=\"row\" flex=\"100\" \nclass=\"mt-32\" style=\"margin-left: 0%\" md-no-float \nng-hide=\"$root.screenEditorCtrl.disposition.element.type==\'screenDispositionNumberFour\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step id=\"buttonstep3\" ng-form=\"step3\" step=\"3\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.screen_transitions\'\"><md-checkbox ng-change=\"vm.setUseTrans()\" \nng-model=\"vm.screen.useTrans\" style=\"margin-left: 0%\"><label translate=\"TEMPALTEMANAGEREDITOR.use_transitions\">\nuse_transitions</label></md-checkbox><div ng-if=\"vm.screen.useTrans\" layout=\"row\" flex class=\"\" layout-wrap><div \nlayout=\"column\" layout-gt-sm=\"row\" layout-align=\"center center\" flex=\"100\" class=\"mb-16\"><div id=\"animation-box\" \nclass=\"animated ms-custom-white-bg\" \nstyle=\"width:100px;height: 100px;background: url(\'{{vm.getScreenCapture()}}\');background-size:contain;background-color: #e1e1e1b3;background-repeat: no-repeat;background-position: center\" \nng-class=\"vm.screen.transitions[vm.transitionWay]\"></div></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\">\n<md-input-container md-no-float flex><label translate=\"TEMPALTEMANAGEREDITOR.transition_type\">transition_type</label>\n<md-select ng-model=\"vm.screen.transitions[vm.transitionWay]\" aria-label=\"Transition type\"><md-optgroup \nng-repeat=\"animation in vm.screenOptions.animations\" label=\"{{animation.type}}\"><md-option \nng-repeat=\"animationChoice in animation.choices\" ng-value=\"animationChoice\">{{animationChoice}}</md-option>\n</md-optgroup></md-select></md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"50\">\n<md-input-container md-no-float flex><label translate=\"TEMPALTEMANAGEREDITOR.transition_way\">transition_way</label>\n<md-select ng-model=\"vm.transitionWay\" aria-label=\"Transition way\"><md-option value=\"in\">\n{{\'TEMPALTEMANAGEREDITOR.transition_way_in\'|translate}}</md-option><md-option value=\"out\">\n{{\'TEMPALTEMANAGEREDITOR.transition_way_out\'|translate}}</md-option></md-select></md-input-container></div></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step id=\"buttonstep1\" ng-form=\"step1\" step=\"1\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.bg_prop\'\"><div layout=\"row\" flex=\"100\" class=\"mt-32\" \nstyle=\"margin-left: 0%\" md-no-float><md-checkbox ng-change=\"vm.setScreenNoStyle()\" ng-model=\"vm.useBackgroud\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.use_backgroud\">use_backgroud</label></md-checkbox></div><md-radio-group \nng-if=\"vm.useBackgroud\" class=\"\" ng-model=\"vm.screen.background.useBackgroundImage\" \nng-switch=\"vm.screen.background.useBackgroundImage\"><md-radio-button \nng-hide=\"!vm.screen.background.allowedToUseBackgroundImage\" flex value=\"yes\" aria-label=\"use_image\" \nstyle=\"margin-left: 0px\" translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.use_image\"><span \ntranslate=\"TEMPALTEMANAGEREDITOR.use_image\">use_image</span></md-radio-button><div ng-switch-when=\"yes\" \nng-hide=\"!vm.screen.background.allowedToUseBackgroundImage\"><div layout=\"row\" flex><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.background_repeat\">background_repeat</label>\n<md-select ng-model=\"vm.screen.background.repeat\" aria-label=\"background repeat\"><md-option \nng-repeat=\"repeatChoice in vm.screenOptions.background.repeatChoices\" ng-value=\"repeatChoice\">{{repeatChoice}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" flex><md-input-container flex class=\"md-block\" \nmd-no-float><label translate=\"TEMPALTEMANAGEREDITOR.background_size\">background_size</label><md-select \nng-model=\"vm.screen.background.size\" aria-label=\"background size\"><md-option \nng-repeat=\"sizeChoice in vm.screenOptions.background.sizeChoices\" ng-value=\"sizeChoice\">{{sizeChoice}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\" flex><md-input-container flex class=\"md-block\" md-no-float>\n<label translate=\"TEMPALTEMANAGEREDITOR.background_position\">background_position</label><md-select \nng-model=\"vm.screen.background.position\" aria-label=\"background position\"><md-option \nng-repeat=\"positionChoice in vm.screenOptions.background.positionChoices\" ng-value=\"positionChoice\">{{positionChoice}}\n</md-option></md-select></md-input-container></div><div layout=\"row\" flex style=\"height: 70px\"><md-input-container \nflex md-no-float><div md-color-picker=\"vm.mdColorPickerOptions\" ng-model=\"vm.screen.background.bgColor\"></div>\n</md-input-container></div><div layout=\"row\" flex md-no-float><p translate=\"TEMPALTEMANAGEREDITOR.background_image\">\nbackground_image</p></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"image in vm.screenOptions.background.choices\"><div class=\"product-image uploading\" layout=\"row\" \nlayout-align=\"start center\" style=\"width: 50px;height: 50px;margin: 0 10px 10px 0; cursor:pointer\"><img \nstyle=\"border-radius: 25px;width:50px;height:50px\" class=\"media\" ng-src=\"{{image}}\" \nng-click=\"vm.screen.background.url = image\" aria-label=\"select background\"></div></div><any><div \nlayout-align=\"start center\" style=\"width: 50px;height: 50px;margin: 0 10px 10px 0\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" flow-file-success=\"vm.screenBackGroundUploadSuccess($file, $message)\" \nflow-file-error=\"vm.fileError($file,$message)\"><md-button class=\"cWhite-br\" flow-btn \nstyle=\"border-radius: 25px;max-width:50px;max-height:50px;min-width:50px;min-height:50px;width:50px;height:50px;margin:0px;border:1px solid\" \naria-label=\"add background\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon></md-button></div></any></div><div \nng-if=\"vm.imagesBack &&  vm.imagesBack.length>0\" layout=\"row\" flex md-no-float><p \ntranslate=\"TEMPALTEMANAGEREDITOR.background_images_soreted\">background_images_soreted</p></div><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div ng-repeat=\"image in vm.imagesBack| limitTo : vm.limit:vm.begin\"><div \nclass=\"product-image uploading\" layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 50px;height: 50px;margin: 0 10px 10px 0; cursor:pointer\"><img \nstyle=\"border-radius: 25px;width:50px;height:50px\" class=\"media\" ng-src=\"{{image}}\" \nng-click=\"vm.screen.background.url = image\" aria-label=\"select background\"></div></div></div><div layout=\"row\" \nlayout-align=\"center start\" layout-wrap><div class=\"simple-pagination\" style=\"background-color:transparent\"><md-button \nclass=\"pagination-item\" md-no-ink ng-if=\"vm.nbr > 24\" ng-click=\"vm.previousPagination($index)\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button \nng-repeat=\"nb in vm.imagesBack | limitTo: vm.limitPaginat : vm.beginPagination\" ng-click=\"vm.pagination($index)\" \nclass=\"pagination-item active\" aria-label=\"Go to page {{$index}}+1\"><span>{{$index + vm.beginPagination+1}}</span>\n</md-button><md-button class=\"pagination-item\" ng-click=\"vm.nextPagination($index)\" ng-if=\"vm.nbr > 24\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div></div><md-radio-button \nng-hide=\"!vm.screen.background.allowedToUseBackgroundImage\" flex value=\"no\" style=\"margin-left: 0px\" \naria-label=\"use_color\" translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.use_color\"><span \ntranslate=\"TEMPALTEMANAGEREDITOR.use_color\">use_color</span></md-radio-button><div ng-switch-when=\"no\"><div \nlayout=\"row\" flex><md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.color\" \nstyle=\"margin-bottom: 30px\"></label><div md-color-picker=\"vm.mdColorPickerOptions\" \nng-model=\"vm.screen.background.color\"></div></md-input-container></div></div></md-radio-group>\n</ms-vertical-stepper-step><div ng-if=\"vm.intro\"><ms-vertical-stepper-step id=\"buttonstep5\" ng-form=\"step5\" step=\"5\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.video_list\'\" ng-click=\"vm.showModalVideo()\"></ms-vertical-stepper-step>\n</div></form></div></md-tab-body></md-tab><md-tab id=\"element_params\" ng-if=\"vm.type && vm.dispTabConfig==1\" \nstyle=\"padding: 12px 0px 12px 0px\"><md-tab-label><md-icon md-font-icon=\"icon-settings-custom\" class=\"s18\"><md-tooltip \nmd-direction=\"bottom\">{{\'TEMPALTEMANAGEREDITOR.element_params\'|translate}}</md-tooltip></md-icon></md-tab-label>\n<md-tab-body><div layout=\"row\" flex=\"100\" md-no-float><div flex=\"100\" layout-align=\"start center\"><div \nng-if=\"vm.type==\'infobar\'\"><form id=\"formDisplayFilInfo\" name=\"empMediaVideoForm\" method=\"post\" \nms-vertical-stepper=\"1\" ng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" \nnovalidate=\"novalidate\" \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\" \nstyle=\"font-size: 13px !important\"><ms-vertical-stepper-step id=\"displayFil\" ng-form=\"horizontalStep1\" step=\"1\" \nstep-title-translate=\"\'MESSAGES.form_step_basic_info\'\" step-title=\"form_step_basic_info\"><div layout=\"row\" flex=\"100\" \nmd-no-float ng-hide=\"true\"><ms-material-color-picker ms-model-type=\"class\" class=\"widget-material-color-picker\" \nng-class=\"vm.element.infoBarContainer.options.msColor\" ng-change=\"vm.showColor(vm.element.infoBarContainer.options)\" \nng-model=\"vm.element.infoBarContainer.options.msColor\"><md-button \nclass=\"md-raised widget-material-color-picker-button\" aria-label=\"color\"><md-icon \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" md-font-icon=\"icon-palette\" class=\"s20\"></md-icon><strong \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" translate=\"TEMPALTEMANAGEREDITOR.color\">color</strong></md-button>\n</ms-material-color-picker></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"start start\" flex=\"100\" \nclass=\"mb-8\"><span class=\"md-headline\" style=\"font-size: 18px !important\" \ntranslate=\"TEMPALTEMANAGEREDITOR.screen_info_bar_clock_container\">screen_info_bar_clock_container</span></div><div \nlayout=\"row\" flex=\"100\" md-no-float ng-hide=\"true\"><ms-material-color-picker ms-model-type=\"class\" \nclass=\"widget-material-color-picker\" ng-class=\"vm.element.clockContainer.options.msColor\" \nng-change=\"vm.showColor(vm.element.clockContainer.options)\" ng-model=\"vm.element.clockContainer.options.msColor\">\n<md-button class=\"md-raised widget-material-color-picker-button\" aria-label=\"color\"><md-icon \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" md-font-icon=\"icon-palette\" class=\"s20\"></md-icon><strong \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" translate=\"TEMPALTEMANAGEREDITOR.color\">color</strong></md-button>\n</ms-material-color-picker></div><div><div layout=\"row\" flex=\"100\" class=\"mt-8\" md-no-float><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.time_zone\">time_zone</label><md-select \nng-change=\"vm.initInfoBar()\" ng-model=\"vm.element.clockContainer.options.gmtOffset\" aria-label=\"time_zone\"><md-option \nng-repeat=\"gmtOffsetsChoice in vm.parentCtrl.editorConstants.infoBar.gmtOffsetsChoices track by $index\" \nng-value=\"gmtOffsetsChoice.value\">{{gmtOffsetsChoice.option}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex=\"100\" class=\"mt-8\" md-no-float><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.time_format\">time_format</label><md-select ng-change=\"vm.initInfoBar()\" \nng-model=\"vm.element.clockContainer.options.timeFormat\" aria-label=\"time_zone\"><md-option \nng-repeat=\"timeFormatChoice in vm.parentCtrl.editorConstants.infoBar.timeFormatChoices track by $index\" \nng-value=\"timeFormatChoice.value\">{{timeFormatChoice.option}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex=\"100\" class=\"mt-8\" md-no-float><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.fontSize\">fontSize</label><md-select ng-change=\"vm.initInfoBar()\" \nng-model=\"vm.element.clockContainer.options.fontClass\" aria-label=\"fontSize\"><md-option \nng-repeat=\"clockFontSizeChoice in vm.parentCtrl.editorConstants.infoBar.clockFontSizeChoices track by $index\" \nng-value=\"clockFontSizeChoice.value\">{{clockFontSizeChoice.option}}</md-option></md-select></md-input-container></div>\n<div layout=\"row\" layout-align=\"space-between center\" flex style=\"height: 70px\"><md-input-container flex md-no-float>\n<div md-color-picker=\"vm.mdColorPickerOptions\" ng-model=\"vm.element.clockContainer.options.clockColor\"></div>\n</md-input-container></div></div><div layout=\"row\" layout-gt-sm=\"row\" layout-align=\"space-between center\" flex=\"100\" \nclass=\"mb-8\" style=\"margin-top: 20px\"><span class=\"md-headline\" style=\"font-size: 18px!important\" \ntranslate=\"TEMPALTEMANAGEREDITOR.screen_info_bar_info_container\">screen_info_bar_info_container</span><div \nlayout=\"row\"><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.restore_informations\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.reInitialiszeInfoArray()\" \naria-label=\"restore_informations\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.restore_informations\">\n<md-icon md-font-icon=\"icon-refresh\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.sort_by_priority\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-if=\"vm.infoBar.data.informations && vm.infoBar.data.informations.length > 1\" \nng-click=\"vm.sortByPriority()\" aria-label=\"sort_by_priority\" translate \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.sort_by_priority\"><md-icon md-font-icon=\"icon-sort-descending\">\n</md-icon></md-button></a><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.delete_all\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.clearAllInformations()\" \naria-label=\"delete_all\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.delete_all\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon></md-button></a></div></div><div layout=\"row\" flex=\"100\" md-no-float \nng-hide=\"true\"><ms-material-color-picker ms-model-type=\"class\" class=\"widget-material-color-picker\" \nng-class=\"vm.element.infoContainer.options.msColor\" ng-change=\"vm.showColor(vm.element.infoContainer.options)\" \nng-model=\"vm.element.infoContainer.options.msColor\"><md-button class=\"md-raised widget-material-color-picker-button\" \naria-label=\"color\"><md-icon ng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" md-font-icon=\"icon-palette\" \nclass=\"s20\"></md-icon><strong ng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" \ntranslate=\"TEMPALTEMANAGEREDITOR.color\">color</strong></md-button></ms-material-color-picker></div><div layout=\"row\" \nflex=\"100\" md-no-float ng-if=\"vm.infoBar.data.informations\" \nng-repeat=\"info in vm.infoBar.data.informations track by $index\"><div layout=\"row\" flex=\"100\" \nlayout-align=\"start center\"><md-input-container class=\"md-block\" flex=\"50\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.information\">information</label><input ng-change=\"vm.changeFile()\" type=\"text\" \nname=\"content\" ng-model=\"info.content\" placeholder=\"{{\'TEMPALTEMANAGEREDITOR.input_information\'|translate}}\" \nautocomplete=\"off\" md-autofocus=\"!info.content\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\">\n<label translate=\"TEMPALTEMANAGEREDITOR.priority\">priority</label><md-select ng-model=\"info.priority\" \nng-change=\"vm.changeFile()\" aria-label=\"background repeat\"><md-option \nng-repeat=\"informationLevel in vm.informationsLevel\" ng-value=\"informationLevel.val\">\n{{\'TEMPALTEMANAGEREDITOR.\'+informationLevel.option|translate}}</md-option></md-select></md-input-container><div \nflex=\"10\"><a tooltips tooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.remove_info\'|translate}}\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button md-warn\" style=\"margin-top:4px\" ng-click=\"vm.removeInfo($index)\" \naria-label=\"remove_info\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.remove_info\"><md-icon \nmd-font-icon=\"icon-trash\"></md-icon></md-button></a></div><div flex=\"10\"><a tooltips \ntooltip-template=\"{{\'TEMPALTEMANAGEREDITOR.add_new_info\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button md-primary\" style=\"margin-top:4px\" ng-click=\"vm.addNewInfo()\" \naria-label=\"add_new_info\" translate translate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.add_new_info\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></a></div></div></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step id=\"displayFilImport\" ng-form=\"horizontalStep2\" step=\"2\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.infoFile\'\" step-title=\"form_step_further_info\"><div layout=\"column\" \nlayout-align=\"center center\" flex=\"100\"><div style=\"width: 100%;margin-top: -20px\" layout=\"column\" \nlayout-align=\"center center\"><div style=\"width: 100% ; margin-bottom: 15px\" layout=\"row\"><md-select \nstyle=\"display: block;margin-right: 0;margin-left: auto\" ng-model=\"vm.position\" ng-change=\"vm.selectPosition()\" \nplaceholder=\"Position\" class=\"md-no-underline\"><md-option value=\"left:20px\" \ntranslate=\"TEMPALTEMANAGEREDITOR.align_left\" ng-selected=\"true\">left</md-option><md-option value=\"right:20px\" \ntranslate=\"TEMPALTEMANAGEREDITOR.align_right\">right</md-option></md-select></div><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(255, 255, 255, 0.7);    padding-top: 0;margin-top: 0;    width: 100%;height: 220px;border-radius: 5px\" \nclass=\"product-detail-form-container\"><div class=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptionsFil\" \nflow-name=\"vm.ngFlowFil.flow\" flow-files-submitted=\"vm.uploadFileFil()\" flow-file-added=\"vm.fileAddedFil($file)\" \nflow-file-success=\"vm.fileSuccessFil($file, $message)\" flow-complete=\"vm.uploadCompleteFil()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nstyle=\"padding-bottom: 35px\" class=\"drop-text hint-text\" layout=\"column\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span> <span translate=\"MESSAGES.ou\">ou</span></div><div \nclass=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button class=\"cWhite-br\" style=\";border:1px solid\" \nflow-btn><md-icon md-font-icon=\"icon-plus\"></md-icon><span translate=\"TEMPALTEMANAGEREDITOR.choose_image\">choose_image\n</span></md-button></div></div></div></div></div><div layout=\"row\" layout-align=\"start start\" layout-wrap><div \nng-repeat=\"image in vm.imagesFile\"><div class=\"product-image uploading\" layout=\"row\" layout-align=\"start center\" \nstyle=\"width: 50px;height: 50px;margin: 0 10px 10px 0; cursor:pointer\"><img \nstyle=\"width:50px;height:50px;border:1px solid rgba(0,0,0,0.15)\" class=\"media\" ng-src=\"{{image}}\" \nng-click=\"vm.chooseImage(image)\" aria-label=\"select background\"></div></div></div></ms-vertical-stepper-step></form>\n</div><div ng-if=\"vm.type==\'toolbar\'\" style=\"padding: 24px\"><div layout=\"row\" flex=\"100\" md-no-float ng-hide=\"true\">\n<ms-material-color-picker ms-model-type=\"class\" class=\"widget-material-color-picker\" ng-class=\"vm.element.msColor\" \nng-change=\"vm.showColor(vm.element)\" ng-model=\"vm.element.msColor\"><md-button \nclass=\"md-raised widget-material-color-picker-button\" aria-label=\"color\"><md-icon \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" md-font-icon=\"icon-palette\" class=\"s20\"></md-icon><strong \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" translate=\"TEMPALTEMANAGEREDITOR.color\">color</strong></md-button>\n</ms-material-color-picker></div><div layout=\"row\" flex=\"100\" class=\"mv-24\" md-no-float><md-slider-container \nng-init=\"vm.convertToInt(vm.element,\'height\')\" flex class=\"md-block\" style=\"align-items:start!important\"><span><span \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</span> <span>{{\" (\"+vm.element.height+\")\"}}</span></span>\n<md-slider flex class=\"cWhite-fg\" ng-model=\"vm.element.height\" step=\"1\" min=\"50\" max=\"100\" aria-label=\"rating\">\n</md-slider></md-slider-container></div><div layout=\"row\" flex=\"100\" md-no-float><md-checkbox ng-true-value=\"true\" \nng-false-value=\"false\" ng-model=\"vm.element.putLogoToTheRightSide\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.putLogoToTheRightSide\">putLogoToTheRightSide</label></md-checkbox></div></div><div \nng-if=\"vm.type==\'programZone\'\" class=\"mv-10\"><div style=\"margin-left: 10%\"><md-checkbox \nng-if=\"vm.element.options.subLink\" ng-model=\"vm.autoplay\" ng-change=\"vm.checkOptionFunction(vm.autoplay,\'a\',\'1\')\" \naria-label=\"autoplay\"><label translate=\"TEMPALTEMANAGEREDITOR.video_autoplay\">video_autoplay</label></md-checkbox>\n<md-checkbox ng-if=\"vm.element.options.subLink\" ng-model=\"vm.boucle\" \nng-change=\"vm.checkOptionFunction(vm.boucle,\'loop\',\'1\')\" aria-label=\"boucle\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.video_Loop\">video_Loop</label></md-checkbox><md-checkbox \nng-if=\"vm.element.options.subLink\" ng-model=\"vm.controle\" ng-change=\"vm.checkOptionFunction(vm.controle,\'sc\',\'0\')\" \naria-label=\"controle\"><label translate=\"TEMPALTEMANAGEREDITOR.video_control_barr\">video_control_barr</label>\n</md-checkbox></div><form id=\"formDisplayProgramZone\" name=\"stepper\" name=\"empMediaVideoForm\" ms-vertical-stepper \nng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" method=\"post\" style=\"overflow-y: hidden\" \nnovalidate \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-vertical-stepper-step id=\"displayUrlVid\" ng-form=\"horizontalStep1\" step=\"1\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.link_playlist\'\" step-title=\"form_step_further_info\"><div layout=\"row\" \nflex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex class=\"md-block\" \nmd-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.parentCtrl.disposition.element.type==\'screenDispositionNumberFive\'\"><md-button \nng-click=\"vm.convertVideoToFullScreen(vm.element.options)\" class=\"md-accent md-raised\" aria-label=\"restore\" \ntranslate-attr-aria-label=\"TEMPALTEMANAGEREDITOR.restore_element_default_data\">player sur tout l\'espace dé l\'écran\n</md-button></div><div><div layout=\"row\" flex><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.link\">link</label><input type=\"text\" ng-model=\"vm.element.options.subLink\">\n</md-input-container></div></div></ms-vertical-stepper-step><ms-vertical-stepper-step id=\"displayBibVid\" \nng-form=\"horizontalStep2\" style=\"display : none\" step=\"2\" step-title-translate=\"\'TEMPALTEMANAGEREDITOR.video_list\'\" \nstep-title=\"form_step_further_info\" ng-click=\"vm.showModalVideo()\"></ms-vertical-stepper-step><ms-vertical-stepper-step\n id=\"displayPlaylistVid\" ng-form=\"horizontalStep2\" step=\"3\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.biblio_playlist\'\" step-title=\"form_step_further_info\"><md-content \nclass=\"todo-list-pane\" style=\"height: 300px; overflow-x: hidden !important\" flex ms-scroll><div \nng-if=\"vm.playlist.length\" style=\"background: #26292E\" class=\"simple-table-container md-whiteframe-4dp\"><table \nclass=\"simple row-border hover\" ms-responsive-table><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"TEMPALTEMANAGEREDITOR.builder_el_title\" style=\"color: #fff\">Playlist</span></div></th></tr></thead><tfoot>\n<tr><td></td></tr></tfoot><tbody><tr class=\"playlistDisplay\" style=\"cursor: pointer\" ng-repeat=\"p in vm.playlist\" \nng-click=\"vm.getPlaylistLink(p.urlLecture)\"><td style=\"text-align: left!important\" \nng-class=\"{\'is-active-playlist\':vm.element.options.subLink.indexOf(p.urlLecture)==0 && p.urlLecture.length>0}\"><div \nstyle=\"overflow: hidden;text-overflow: ellipsis;max-width: 220px;color: #fff\">{{p.title}}</div><span \nstyle=\"font-size: 12px\">{{p.duration * 3600}}</span></td></tr></tbody></table></div><div ng-if=\"!vm.playlist\"><span \ntranslate=\"TEMPALTEMANAGEREDITOR.no_playlist\">no_playlist</span></div></md-content></ms-vertical-stepper-step></form>\n</div><div ng-if=\"vm.type==\'youtube\'\" style=\"padding: 24px\"><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.link_chaine_youtube\">link_chaine_youtube</label>\n<input type=\"text\" ng-model=\"vm.element.options.url\"> <span class=\"isCustomWhiteBg\" \nstyle=\"color: #b55b5b!important;font-size: 11px\" ng-if=\"vm.element.options.url.indexOf(\'embed\')<0\" \ntranslate=\"TEMPALTEMANAGEREDITOR.link_must_chaine_youtube\">link_chaine_youtube</span></md-input-container></div></div>\n<div ng-if=\"vm.type==\'web\'\" style=\"padding: 24px\"><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.change_Web_link\">change_Web_link</label><input \ntype=\"text\" ng-model=\"vm.element.options.url\"></md-input-container></div></div><div ng-if=\"vm.type==\'feed\'\" \nstyle=\"padding: 24px\"><div layout=\"row\" flex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'height\')\">\n<md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height\n</label><input type=\"number\" ng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" \nflex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float>\n<label translate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.rss_link\">rss_link</label><input type=\"text\" \nng-model=\"vm.element.options.url\"></md-input-container></div></div><div ng-if=\"vm.type==\'scoop\'\" style=\"padding: 24px\">\n<div layout=\"row\" flex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input \ntype=\"number\" ng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.change_Scoop_link\">change_Scoop_link</label><input\n type=\"text\" ng-model=\"vm.element.options.url\"></md-input-container></div></div><div ng-if=\"vm.type==\'twitter\'\" \nstyle=\"padding: 24px\"><div layout=\"row\" flex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'height\')\">\n<md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height\n</label><input type=\"number\" ng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" \nflex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float>\n<label translate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.change_page_twitter_link\">change_page_twitter_link\n</label><input type=\"text\" ng-model=\"vm.element.options.url\" ng-change=\"vm.loadTwitter()\"></md-input-container></div>\n</div><div ng-if=\"vm.type==\'facebook\'\" style=\"padding: 24px\"><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\" ng-change=\"vm.addStyleToParent(vm.element.options.height,\'heightfb\')\">\n</md-input-container></div><div layout=\"row\" flex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'width\')\">\n<md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width\n</label><input type=\"number\" ng-model=\"vm.element.options.width\" max=\"320\" \nng-change=\"vm.addStyleToParent(vm.element.options.width,\'widthfb\')\"></md-input-container></div><div layout=\"row\" \nflex=\"100\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.change_page_facebook_link\">change_page_facebook_link</label><input type=\"text\" \nng-model=\"vm.element.options.url\" ng-change=\"vm.loadFacebook()\"></md-input-container></div></div><div \nng-if=\"vm.type==\'video\'\"><div style=\"margin-left: 10%\"><md-checkbox ng-if=\"vm.element.options.url\" \nng-model=\"vm.autoplay\" ng-change=\"vm.checkOptionVideo(vm.autoplay,\'a\',\'1\')\" aria-label=\"autoplay\"><label \ntranslate=\"TEMPALTEMANAGEREDITOR.video_autoplay\">video_autoplay</label></md-checkbox><md-checkbox \nng-if=\"vm.element.options.url\" ng-model=\"vm.boucle\" ng-change=\"vm.checkOptionVideo(vm.boucle,\'loop\',\'1\')\" \naria-label=\"boucle\"><label translate=\"TEMPALTEMANAGEREDITOR.video_Loop\">video_Loop</label></md-checkbox><md-checkbox \nng-if=\"vm.element.options.url\" ng-model=\"vm.controle\" ng-change=\"vm.checkOptionVideo(vm.controle,\'sc\',\'0\')\" \naria-label=\"controle\"><label translate=\"TEMPALTEMANAGEREDITOR.video_control_barr\">video_control_barr</label>\n</md-checkbox></div><form id=\"formDisplayVideo\" name=\"stepper\" name=\"empMediaVideoForm\" ms-vertical-stepper \nng-submit=\"empMediaVideoForm.$valid &amp;&amp; vm.showCondtionTerms($event)\" method=\"post\" style=\"overflow-y: hidden\" \nnovalidate \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-vertical-stepper-step id=\"displayUrlVideo\" ng-form=\"horizontalStep1\" step=\"1\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.link_video\'\" step-title=\"form_step_further_info\"><div><div \nng-show=\"vm.element.options.max_width !==\'100\'\" ng-disabled=\"true\" layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'height\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input id=\"height_placeholder\" ng-disabled=\"true\" \ntype=\"number\" placeholder=\"Auto\"></md-input-container></div><div ng-show=\"vm.element.options.max_width !==\'100\'\" \nlayout=\"row\" flex=\"100\" ng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input \ntype=\"number\" ng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\">\n<md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.video_link\">video_link\n</label><input type=\"text\" ng-model=\"vm.element.options.url\"></md-input-container></div></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step id=\"displayBibVideo\" ng-form=\"horizontalStep2\" step=\"2\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.video_list\'\" step-title=\"form_step_further_info\" \nng-click=\"vm.showModalVideo()\"></ms-vertical-stepper-step><ms-vertical-stepper-step id=\"displayPlaylistVideo\" \nstyle=\"display:none\" ng-form=\"horizontalStep2\" step=\"3\" step-title-translate=\"\'TEMPALTEMANAGEREDITOR.biblio_playlist\'\" \nstep-title=\"form_step_further_info\"><md-content class=\"todo-list-pane\" \nstyle=\"height: 300px; overflow-x: hidden !important\" flex ms-scroll><div ng-if=\"vm.playlist.length\" \nstyle=\"background: #26292E\" class=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple row-border hover\" \nms-responsive-table><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"TEMPALTEMANAGEREDITOR.builder_el_title\" style=\"color: #fff\">Playlist</span>\n</div></th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr class=\"playlistDisplay\" style=\"cursor: pointer\" \nng-repeat=\"p in vm.playlist\" ng-click=\"vm.getPlaylistLink(p.urlLecture)\"><td style=\"text-align: left!important\"><div \nstyle=\"overflow: hidden;text-overflow: ellipsis;max-width: 220px;color: #fff\">{{p.title}}</div><span \nstyle=\"font-size: 12px\">{{p.duration * 3600}}</span></td></tr></tbody></table></div><div ng-if=\"!vm.playlist\"><span \ntranslate=\"TEMPALTEMANAGEREDITOR.no_playlist\">no_playlist</span></div></md-content></ms-vertical-stepper-step></form>\n</div><div ng-if=\"vm.type==\'live\'\"><form id=\"formDisplayVideo\" name=\"stepper\" name=\"empMediaLiveForm\" \nms-vertical-stepper method=\"post\" style=\"overflow-y: hidden\" novalidate \nclass=\"button-hidden ms-stepper ng-pristine ng-isolate-scope flex-100 ng-valid-mindate ng-valid-maxdate ng-valid-filtered ng-valid-valid ng-invalid ng-invalid-required ng-valid-md-multiple\">\n<ms-vertical-stepper-step id=\"displayUrlVideo\" ng-form=\"horizontalStep1\" step=\"1\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.link_live\'\" step-title=\"form_step_further_info\"><div><div layout=\"row\" \nflex=\"100\"><md-input-container flex class=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.live_link\">\nlive_link</label><input type=\"text\" ng-change=\"vm.urlLive()\" ng-model=\"vm.element.options.url\"></md-input-container>\n</div><div layout=\"row\" flex=\"100\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.hls_link\">HLS Link</label><input type=\"text\" ng-model=\"vm.urlHls\" \nng-change=\"vm.urlToHls(vm.urlHls)\"></md-input-container></div></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step id=\"displayBibVideo\" ng-form=\"horizontalStep2\" step=\"2\" \nstep-title-translate=\"\'TEMPALTEMANAGEREDITOR.live_list\'\" step-title=\"form_step_further_info\" \nng-click=\"vm.showModalLive()\"></ms-vertical-stepper-step></form></div><div ng-if=\"vm.type==\'weather\'\" \nstyle=\"padding: 24px\"><div layout=\"row\" flex=\"100\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.location\">location</label><input type=\"text\" \nng-model=\"vm.element.options.location\"></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex style=\"height: 70px\"><span translate=\"TEMPALTEMANAGEREDITOR.backgroundColor\">\nbackgroundColor</span><md-input-container flex md-no-float><div md-color-picker=\"vm.mdColorPickerOptions\" \nng-model=\"vm.element.options.background\"></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex style=\"height: 70px\"><span translate=\"TEMPALTEMANAGEREDITOR.form_text_color\">\nform_text_color</span><md-input-container flex md-no-float><div md-color-picker=\"vm.mdColorPickerOptions\" \nng-model=\"vm.element.options.color\"></div></md-input-container></div></div><div ng-if=\"vm.type==\'clock\'\" \nstyle=\"padding: 24px\"><div layout=\"row\" flex=\"100\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input type=\"number\" \nng-model=\"vm.element.options.height\"></md-input-container></div></div><div ng-if=\"vm.type==\'logo\'|| vm.type==\'image\'\" \nstyle=\"padding: 24px\"><div layout=\"row\" flex=\"100\" ng-if=\"vm.element.logo.type==\'logo\'\"><div layout=\"row\" flex=\"100\">\n<div layout-padding layout-align=\"start center\"><div id=\"product-image-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.toolbarLogoUploadSuccess($file, $message,vm.element.logo.options,\'image\')\" \nflow-file-error=\"vm.uploadErrorIm($file,$message)\" flow-complete=\"vm.uploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><img \nalt=\"{{vm.element.logo.options.altTag}}\" border=\"0\" ng-src=\"{{vm.element.logo.options.image}}\" \nwidth=\"{{vm.element.logo.options.width}}\" style=\"display: block;margin: 0px;max-width: 100%;padding:0\"><div \nclass=\"upload-button\" layout=\"row\" layout-align=\"center center\"><md-button class=\"cWhite-br\" style=\";border:1px solid\" \nflow-btn ng-disabled=\"vm.uploadingInPogress\"><md-icon md-font-icon=\"icon-plus\"></md-icon><span \ntranslate=\"TEMPALTEMANAGEREDITOR.choose_image\">choose_image</span></md-button><md-progress-circular \nng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div><div \nng-if=\"vm.dropping\" class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div></div></div></div></div><div \nstyle=\"padding: 15px;background-color: #FBFBFB;border-radius: 10px;margin-bottom: 20px\" \nng-if=\"vm.element.logo.type==\'image\'\"><div layout=\"row\" flex=\"100\"><div layout=\"column\" layout-align=\"center center\" \nflex=\"100\"><div style=\"width: 100%\" layout=\"row\" layout-align=\"center center\"><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);    padding-top: 0;margin-top: 0;    width: 100%;height: 220px;border-radius: 5px\" \nclass=\"product-detail-form-container\"><div class=\"mv-24\" id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" \nflow-file-success=\"vm.toolbarLogoUploadSuccess($file, $message,vm.element.logo.options,\'image\')\" \nflow-file-error=\"vm.uploadErrorFil($file,$message)\" flow-complete=\"vm.uploadComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nstyle=\"padding-bottom: 20px\" class=\"drop-text hint-text\" layout=\"column\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\" style=\"color: #484848 !important\">drop_to_upload</span> <span \ntranslate=\"MESSAGES.ou\" style=\"color: #484848 !important\">ou</span></div><div class=\"upload-button\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"cWhite-br\" style=\";border:1px solid;color: #484848 !important\" flow-btn>\n<md-icon md-font-icon=\"icon-plus\" style=\"color: #484848 !important\"></md-icon><span \ntranslate=\"TEMPALTEMANAGEREDITOR.choose_image\" style=\"color: #484848 !important\">choose_image</span></md-button>\n<md-progress-circular ng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular>\n</div><div style=\"padding-top: 15px;text-align: center;width: 100%;color: #484848 !important\" \nng-if=\"vm.element.logo.type==\'image\'\">{{\'TEMPALTEMANAGEREDITOR.extension\' | translate}}<br>\n{{\'TEMPALTEMANAGEREDITOR.dimension\' | translate}}</div></div></div></div></div></div><div layout=\"row\" flex=\"100\" \nlayout-align=\"start start\" ng-if=\"vm.element.logo.type==\'image\'\" style=\"padding: 5px\"><span \nstyle=\"color: #484848 !important\">{{\'TEMPALTEMANAGEREDITOR.select_image\' | translate}}</span></div><div layout=\"row\" \nflex=\"100\" ng-if=\"vm.element.logo.type==\'image\'\" style=\"padding: 5px\"><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div ng-repeat=\"image in vm.images\"><div class=\"product-image uploading\" layout=\"row\" \nlayout-align=\"start center\" style=\"width: 50px;height: 50px;margin: 0 10px 10px 0; cursor:pointer\"><img \nstyle=\"width:50px;height:50px;border:1px solid rgba(0,0,0,0.15)\" class=\"media\" ng-src=\"{{image}}\" \nng-click=\"vm.chooseImageBloc(image)\" aria-label=\"select background\"></div></div></div></div></div><div layout=\"row\" \nflex=\"100\" ng-if=\"vm.element.logo.type==\'image\'||vm.element.logo.type==\'logo\'\"><md-input-container flex \nclass=\"md-block\" style=\"margin-top: 20px\"><label translate=\"TEMPALTEMANAGEREDITOR.imageUrl\">imageUrl</label><input \ntype=\"text\" ng-model=\"vm.element.logo.options.image\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.element.logo.type==\'image\'||vm.element.logo.type==\'logo\'\"><md-input-container flex class=\"md-block\" \nmd-no-float><label translate=\"TEMPALTEMANAGEREDITOR.altTag\">altTag</label><input type=\"text\" \nng-model=\"vm.element.logo.options.altTag\" md-maxlength=\"256\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nmd-no-float ng-if=\"vm.element.logo.type==\'logo\'\"><md-slider-container \nng-init=\"vm.convertToInt(vm.element.logo.options,\'height\')\" flex class=\"md-block\" style=\"align-items:start!important\">\n<span><span translate=\"TEMPALTEMANAGEREDITOR.width\">width</span> <span>{{\" (\"+vm.element.logo.options.width+\")\"}}\n</span></span><md-slider flex class=\"cWhite-fg\" ng-model=\"vm.element.logo.options.width\" step=\"5\" min=\"1\" max=\"400\" \naria-label=\"rating\"></md-slider></md-slider-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.element.logo.type==\'logo\'\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.width\">width</label><input type=\"text\" ng-model=\"vm.element.logo.options.width\">\n</md-input-container></div><div layout=\"row\" flex=\"100\" ng-if=\"vm.element.logo.type==\'image\'\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.altTag\">altTag</label><input type=\"text\" \nng-model=\"vm.element.logo.options.altTag\" md-maxlength=\"256\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-if=\"vm.element.logo.type==\'image\'\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.width\">width</label><input type=\"text\" ng-model=\"vm.element.logo.options.width\">\n</md-input-container></div><div layout=\"row\" flex=\"100\" ng-if=\"vm.element.logo.type==\'image\'\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.height\">height</label><input type=\"text\" \nng-model=\"vm.element.logo.options.height\"></md-input-container></div></div></div></div><div \nng-if=\"vm.type==\'textEditor\'\" style=\"padding: 24px\"><div layout=\"row\" flex=\"100\"><md-input-container flex \nclass=\"md-block\" md-no-float><label translate=\"TEMPALTEMANAGEREDITOR.form_height\">form_height</label><input \ntype=\"number\" ng-model=\"vm.element.options.height\"></md-input-container></div><div layout=\"row\" flex=\"100\" \nng-init=\"vm.convertToInt(vm.element.options,\'width\')\"><md-input-container flex class=\"md-block\" md-no-float><label \ntranslate=\"TEMPALTEMANAGEREDITOR.form_width\">form_width</label><input type=\"number\" \nng-model=\"vm.element.options.width\"></md-input-container></div><div layout=\"row\" flex=\"100\"><ms-material-color-picker \nms-model-type=\"class\" class=\"widget-material-color-picker\" ng-class=\"vm.element.options.msColor\" \nng-change=\"vm.showColor(vm.element.options)\" ng-model=\"vm.element.options.msColor\"><md-button \nclass=\"md-raised widget-material-color-picker-button\" aria-label=\"color\"><md-icon \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" md-font-icon=\"icon-palette\" class=\"s20\"></md-icon><strong \nng-class=\"{ \'isCustomWhiteBg\': vm.isWhiteColor() }\" translate=\"TEMPALTEMANAGEREDITOR.color\">color</strong></md-button>\n</ms-material-color-picker></div></div></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/main/display/template_manager/editor/side-nav/video.introd.html","<md-dialog class=\"event-form-dialog\" aria-label=\"addElementParams\" style=\"width:850px\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span \ntranslate=\"TEMPALTEMANAGEREDITOR.add_video_introduction\">{{\'TEMPALTEMANAGEREDITOR.add_video_introduction\'|translate}}\n</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll \nclass=\"flex-scrollable\" layout=\"column\"><md-content class=\"todo-list-pane\" \nstyle=\"height: 400px; overflow-x: hidden !important\" flex ms-scroll><div ng-if=\"vm.videos.length>0\" class=\"todo-items\">\n<div class=\"todo-item md-padding\" layout-wrap layout=\"row\"><md-card style=\"width: 28%\" \nmd-theme=\"{{ showDarkTheme ? \'dark-blue\' : \'default\' }}\" md-theme-watch ng-repeat=\"(key , video) in vm.videos\">\n<md-card-title layout=\"column\" layout-align=\"space-around center\" \nng-click=\"vm.getUrlLink(video.idVideo,$event,$index)\" ng-class=\"{\'video-play\': video.id}\"><div \nclass=\"md-media-md card-media no-label\" layout-align=\"end center\"><img ng-if=\"video.logo\" ng-src=\"{{ video.logo }}\">\n<md-icon class=\"s70\" ng-if=\"!video.logo\" md-font-icon=\"icon-no-image-custom\"></md-icon></div><md-card-title-text \nlayout=\"column\" layout-align=\"center start \"><a title=\"{{video.title}}\"><span class=\"md-headline\" \nstyle=\"font-size: 16px !important; color: #000000\">{{ vm.subTitle(video.title) }}</span> </a><span class=\"md-subhead\">\n<md-icon md-font-icon=\"icon-clock\" class=\"s14\"></md-icon>{{ video.duration |date:\"HH:mm:ss\" }}</span>\n</md-card-title-text></md-card-title></md-card></div></div><div ng-if=\"vm.videos.length===0\"><span \ntranslate=\"MESSAGES.no_videos\">no_videos</span></div></md-content><div layout=\"row\" flex=\"100\" md-no-float \nlayout-align=\"center center\" class=\"mv-24\"><md-button ng-click=\"vm.closeDialog()\" class=\"md-flat md-primary\" \naria-label=\"Apply\" translate=\"MESSAGES.alert_close\" translate-attr-aria-label=\"MESSAGES.alert_close\">CLOSE</md-button>\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/display/template_manager/editor/side-nav/videos-list.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"addInfomrations\" style=\"width:761px\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span>Liste des vidéos</span> </span><span flex></span>\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content style=\"overflow-x: hidden\"><div ng-if=\"vm.videos.length>0\" class=\"todo-items\"><div \nwhen-scrolled=\"loadMore()\" class=\"todo-item md-padding\" layout-wrap layout=\"row\" \nstyle=\"padding: 10px;cursor: auto; height: 530px;overflow: auto;overflow-x: hidden\"><div style=\"width: 225px\" \nng-repeat=\"(key , video) in vm.videos\" layout=\"column\"><md-card ng-class=\"{\'filter-vid\': video===vm.vid}\" \nng-click=\"vm.selectVideo(video,key)\" style=\"background: #ededed;  cursor: pointer;  box-shadow: 0 0 0 0 !important\">\n<md-icon ng-if=\"video===vm.vid\" class=\"thumbnailCheckbox2\" style=\"color: #00C853\" \nmd-font-icon=\"icon-checkbox-marked-circle\"></md-icon><md-icon style=\"height: 120px !important;    padding-top: 22px\" \nng-if=\"video.logo === null || video.logo === \'\' || video.logo === false || video.logo === \'not_found\'\" \nmd-font-icon=\"icon-no-image-custom\" class=\"s72\" width=\"100\" height=\"100\"></md-icon><div class=\"thumbnailDisp\" \nng-if=\"video.logo !== null && video.logo !== \'\' && video.logo !== false && video.logo !== \'not_found\'\"><img \nng-src=\"{{video.logo}}\" class=\"md-card-image cursor-pointer\" alt=\"Washed Out\" ng-click=\"vm.previewVideo(video,$event)\">\n</div><md-card-actions style=\"height: 20px\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" class=\"title\" \nlayout-align=\"start center\" flex><span title=\"{{video.title}}\" \nstyle=\"font-size: 0.87em; width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis\" class=\"name\">\n{{video.title}}</span></div><div style=\"margin-right: -105px\" layout=\"row\" class=\"title\" layout-align=\"end center\" \nflex><span style=\"font-size: 0.87em;width: 100%\" class=\"name\">{{ video.duration |date:\"HH:mm:ss\" }}</span></div>\n</md-card-actions></md-card></div></div></div><div ng-if=\"vm.videos.length===0\"><span translate=\"MESSAGES.no_videos\">\nno_videos</span></div></md-dialog-content><md-dialog-actions><md-button class=\"md-raised md-accent\" \nng-click=\"vm.validate()\">Valider</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/boitier/rmbox/interventions/add_edit_view/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><form name=\"empConfigurationRmboxInterventionForm\" method=\"post\" \nclass=\"md-inline-form ng-pristine ng-invalid ng-invalid-required\" id=\"empConfigurationRmboxInterventionForm\" \nnovalidate=\"novalidate\" \nng-submit=\"empConfigurationRmboxInterventionForm.$valid && vm.submitAddRmboxInterventionForm()\"><div \nclass=\"form-title\" ng-if=\"vm.isNew\"><md-icon md-font-icon=\"icon-information-outline\" class=\"s18\"></md-icon><span \ntranslate=\"INTERVENTIONS.add\">form_title</span></div><div class=\"form-title\" ng-if=\"!vm.isNew\"><md-icon \nmd-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"INTERVENTIONS.edit\">form_title</span></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"width: 100%\" class=\"md-block\"><label \ntranslate=\"INTERVENTIONS.remark\">Remarques</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empConfigurationRmboxInterventionForm_remarque\" name=\"empConfigurationRmboxInterventionForm[remarque]\" \nrequired=\"required\" ng-attr-name=\"remarque\" rows=\"5\" max-rows=\"8\" md-maxlength=\"450\" \nng-model=\"vm.empConfigurationRmboxInterventionForm.remarque\" aria-invalid=\"true\" ng-trim=\"false\" style=\"height: 120px\">\n</textarea><div class=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div \nng-messages=\"empConfigurationRmboxInterventionForm.remarque.$error\" role=\"alert\"><div ng-message=\"md-maxlength\" \ntranslate=\"MESSAGES.form_max_length\" translate-value-length=\"450\">form_max_length</div></div></md-input-container>\n</div><div layout=\"row\" layout-gt-sm=\"row\"><div layout=\"column\" layout-gt-sm=\"row\" flex=\"25\"><md-input-container \nstyle=\"width:100%\" flex><label class=\"md-no-float\" translate=\"INTERVENTIONS.receptionDate\">Date reception</label>\n<md-datepicker ng-model=\"vm.empConfigurationRmboxInterventionForm.receptionDate\" md-placeholder=\"Date\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"25\"><md-input-container class=\"md-block\">\n<label class=\"md-no-float\" translate=\"INTERVENTIONS.sendDate\">Date envoie</label><md-datepicker \nng-model=\"vm.empConfigurationRmboxInterventionForm.sendDate\" md-placeholder=\"Date\"></md-datepicker>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" flex=\"25\"><md-input-container class=\"md-block\">\n<label class=\"md-no-float\" translate=\"INTERVENTIONS.firstStartedDate\">Mise en marche</label><md-datepicker \nng-model=\"vm.empConfigurationRmboxInterventionForm.firstStartedDate\" md-placeholder=\"Date\"></md-datepicker>\n</md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"INTERVENTIONS.old\">Mac</label><input type=\"text\" id=\"empConfigurationRmboxInterventionForm_oldMac\" \nname=\"empConfigurationRmboxInterventionForm[oldMac]\" ng-attr-name=\"oldMac\" ng-name=\"oldMac\" \nng-model=\"vm.empConfigurationRmboxInterventionForm.oldMac\" \nng-pattern=\"/^([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]{1,2})$/\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationRmboxInterventionForm.oldMac.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_mac\">field_must_be_mac</div></div></md-input-container></div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><label translate=\"INTERVENTIONS.new\">Mac</label><input type=\"text\" \nid=\"empConfigurationRmboxInterventionForm_newMac\" name=\"empConfigurationRmboxInterventionForm[newMac]\" \nng-attr-name=\"newMac\" ng-name=\"newMac\" ng-model=\"vm.empConfigurationRmboxInterventionForm.newMac\" \nng-pattern=\"/^([0-9A-Fa-f]{1,2}[:-]){5}([0-9A-Fa-f]{1,2})$/\" aria-invalid=\"true\"><div \nng-messages=\"empConfigurationRmboxInterventionForm.newMac.$error\" role=\"alert\"><div ng-message=\"pattern\" \ntranslate=\"MESSAGES.field_must_be_mac\">field_must_be_mac</div></div></md-input-container></div><md-button \nclass=\"md-warn\" \nui-sref=\"app.configuration_rmbox_intervention_list({id: vm.empConfigurationRmboxInterventionForm.rmbox})\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationRmboxInterventionForm.$invalid || empConfigurationRmboxInterventionForm.$pristine\" \ntranslate=\"MESSAGES.form_add\">form_add</md-button><md-button ng-if=\"!vm.isNew\" type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empConfigurationRmboxInterventionForm.$invalid || empConfigurationRmboxInterventionForm.$pristine\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></form></div></div></div></div>");
$templateCache.put("app/main/boitier/rmbox/interventions/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content-card fullpage\" \nlayout=\"column\" flex><div class=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"space-between center\">\n<div flex=\"\" layout=\"row\"><md-input-container md-no-float class=\"md-block inputContainer\" style=\"margin-left:18px\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"black-text icon search-icon\"></md-icon><input id=\"stations-search\" \nclass=\"search-input ng-scope flex\" type=\"text\" placeholder=\"Search\" translate \ntranslate-attr-placeholder=\"MESSAGES.search\" flex ng-model=\"vm.searchWord\" ng-change=\"vm.searchRmboxs()\">\n</md-input-container></div><md-button class=\"md-fab add-module-button btn-add\" id=\"app-add-element-btn\" \nng-click=\"vm.addNewRmbox($event)\" aria-label=\"action_new_element\" \nhas-permission=\"configuration_rmbox_add_intervention_no_api\"><div class=\"span-btn-add\" layout=\"row\" \nlayout-align=\"center center\"><svg xmlns=\"https://www.w3.org/2000/svg\" class=\"mr-1\" width=\"24\" height=\"24\" \nviewBox=\"0 0 30 30\"><path id=\"Color\" \nd=\"M7.232,22.5A2.266,2.266,0,0,1,5,20.25V17.5H2.749A2.752,2.752,0,0,1,0,14.754V2.749A2.752,2.752,0,0,1,2.749,0H14.754A2.752,2.752,0,0,1,17.5,2.749V5H20.25A2.266,2.266,0,0,1,22.5,7.232V20.25a2.264,2.264,0,0,1-2.25,2.25ZM6.484,7.232V20.25A.748.748,0,0,0,7.232,21H20.25A.747.747,0,0,0,21,20.25V7.232a.748.748,0,0,0-.747-.748H7.232A.749.749,0,0,0,6.484,7.232ZM1.865,1.865a1.244,1.244,0,0,0-.362.884V14.754A1.247,1.247,0,0,0,2.749,16H5V7.232A2.269,2.269,0,0,1,7.232,5H16V2.749A1.247,1.247,0,0,0,14.754,1.5H2.739A1.241,1.241,0,0,0,1.865,1.865ZM12.97,17.751V14.5H9.755a.747.747,0,0,1,0-1.495H12.97V9.788a.747.747,0,0,1,1.494,0V13h3.287l-.032-.031a.747.747,0,1,1,0,1.494H14.464v3.287a.747.747,0,1,1-1.494,0Z\" \ntransform=\"translate(3.75 3.75)\" fill=\"#ffffff\"></path></svg> <span translate=\"MESSAGES.add\">Ajout</span></div>\n</md-button></div><div class=\"content fullpage-datatable\" layout=\"column\" flex><table \nclass=\"dataTable row-border hover\" datatable=\"\" dt-instance=\"vm.dtInstance\" dt-options=\"vm.dtOptions\" \ndt-columns=\"vm.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"INTERVENTIONS.remark\">Remarques</span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"INTERVENTIONS.receptionDate\">receptionDate</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"INTERVENTIONS.sendDate\">sendDate\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"RMBOXLIST.mac\">mac</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"INTERVENTIONS.firstStartedDate\">\nfirstStartedDate</span></div></th><th class=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table>\n</div></div></div>");
$templateCache.put("app/main/displayNew/schedule/calendar/detail/detail.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span flex=\"30\" class=\"title\">{{vm.calendarEvent.title}}</span> <span flex=\"70\"></span><div \nlayout=\"row\" ng-if=\"vm.calendarEvent.enable==true\" style=\"margin-right: 20px\"><md-icon class=\"s20\" \nstyle=\"margin-right: 5px\" md-font-icon=\"icon-check-circle\"></md-icon><span translate=\"DISPLAYSCHEDULECALENDAR.ENABLE\">\nEnable</span></div><div layout=\"row\" ng-if=\"vm.calendarEvent.enable==false\" style=\"margin-right: 20px\"><md-icon \nclass=\"s20\" style=\"margin-right: 5px\" md-font-icon=\"icon-block-helper\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.DISABLE\">Enable</span></div><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close Dialog\" translate translate-attr-aria-label=\"SB.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"space-around center\" style=\"margin-top: 30px\"><div layout=\"row\" style=\"margin-left: 20px\" \nlayout-align=\"start center\"><div ng-if=\"vm.status==-1\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" \nstyle=\"color: red\"></md-icon><span translate=\"DISPLAYSCHEDULECALENDAR.END\">Status</span></div><div \nng-if=\"vm.status==0\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" style=\"color: green\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.INPROGRESS\">Status</span></div><div ng-if=\"vm.status==1\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-circle\" style=\"color: orange\"></md-icon><span \ntranslate=\"DISPLAYSCHEDULECALENDAR.COME\">Status</span></div></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DAY\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.WEEK\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" \naria-label=\"Week\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.WEEK\"><md-icon \nmd-font-icon=\"icon-view-week\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.MONTH\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon>\n</md-button></a></div></div><div ng-if=\"vm.paramschedule==\'none\'\" style=\"margin-right: 50px\"><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Edit\" ng-click=\"vm.editSchedule()\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\"><md-icon md-font-icon=\"icon-border-color\"></md-icon>\n</md-button></a><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" \naria-label=\"Delete\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></a></div><div ng-if=\"vm.paramschedule==\'date\'\" \nstyle=\"margin-right: 50px\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" \nng-click=\"vm.editSchedule()\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\" \nng-hide=\"vm.testDate()\"><md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\" ng-hide=\"vm.testDate()\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button></a></div><div ng-if=\"(vm.paramschedule==\'actif\') && (vm.calendarEvent.enable===false)\" \nstyle=\"margin-right: 50px\"><a tooltips tooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.EDIT\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"Edit\" \nng-click=\"vm.editSchedule()\" translate translate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.EDIT\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'DISPLAYSCHEDULECALENDAR.DELETE\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button\n class=\"md-icon-button\" ng-click=\"vm.deleteTemplate(vm.calendarEvent)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"DISPLAYSCHEDULECALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</a></div></div><md-dialog-content ms-scroll><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"></md-dialog-actions></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/interactivity/comments/comments_lives/edit/edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><div \nng-include=\"\'app/main/interactivity/comments/comments_lives/edit/form.template.html\'\"></div></div></div></div></div>");
$templateCache.put("app/main/interactivity/comments/comments_lives/edit/form.template.html","<form name=\"emplivesCommentsForm\" method=\"post\" class=\"md-inline-form\" id=\"emplivesCommentsForm\" \nnovalidate=\"novalidate\" ng-submit=\"emplivesCommentsForm.$valid && vm.submitAddCommentsForm()\"><div class=\"form-title\">\n<md-icon md-font-icon=\"icon-pen\" class=\"s18\"></md-icon><span translate=\"COMMENTSEDIT.form_title\">form_title</span>\n</div><input type=\"hidden\" ng-model=\"vm.emplivesCommentsForm.img\" id=\"emplivesCommentsForm_img\" \nname=\"emplivesCommentsForm[img]\" class=\"btn btn-default\"><div class=\"mv-24\" id=\"file-uploader\" \nflow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><md-button flow-btn class=\"add-file-button md-primary md-raised\" \naria-label=\"form_add_file\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon><any translate=\"COMMENTSEDIT.choose_img\">choose_img</any></md-button></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label translate=\"COMMENTSEDIT.form_attr_email\" \nfor=\"emplivesCommentsForm_email\">COMMENTSEDIT.form_attr_email</label><input type=\"email\" \nid=\"emplivesCommentsForm_email\" name=\"emplivesCommentsForm[email]\" required ng-attr-name=\"email\" \nng-model=\"vm.emplivesCommentsForm.email\" aria-invalid=\"false\"><div ng-messages=\"emplivesCommentsForm.email.$error\" \nrole=\"alert\"><div ng-message=\"email\" translate=\"MESSAGES.form_is_email\">form_is_email</div></div></md-input-container>\n</div><md-input-container class=\"md-block\"><label translate=\"COMMENTSEDIT.form_attr_comment\" \nfor=\"emplivesCommentsForm_comment\">COMMENTSEDIT.form_attr_comment</label><div class=\"md-resize-wrapper\"><textarea \nid=\"emplivesCommentsForm_comment\" name=\"emplivesCommentsForm[comment]\" ng-attr-name=\"comment\" \nng-model=\"vm.emplivesCommentsForm.comment\" class=\"ng-pristine ng-valid md-input ng-not-empty ng-touched\" rows=\"1\" \naria-invalid=\"false\" style=\"height: 30px\" required></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"emplivesCommentsForm.comment.$error\" role=\"alert\"><div \nng-message=\"email\" translate=\"MESSAGES.form_is_required\">form_is_mail</div></div></md-input-container><md-button \nclass=\"md-warn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button type=\"submit\" \nclass=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-disabled=\"emplivesCommentsForm.$invalid || (emplivesCommentsForm.$pristine && !vm.is_image_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button></form>");
$templateCache.put("app/main/media/lives/live/addLive/addLive.template.html","<div id=\"addIframe\" class=\"page-layout simple fullwidth\" style=\"height: 100%\" layout=\"column\"><iframe id=\"iframe_live\" \niframe-onload=\"iframeLoadedCallBack()\" class=\"fullwidth\" style=\"height: 100%\" ng-src=\"{{ vm.addLink}}\" \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe></div>");
$templateCache.put("app/main/media/lives/live/calendar/calendar.template.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"breadcrumb breadcrumb-custom-list black-fg\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16 black-fg cursor-pointer\" ui-sref=\"app.dashboard\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 black-fg separator\"></md-icon><span class=\"parent\" \ntranslate=\"PAGESMENUSTITLES.lives_menuTitle\">lives_menuTitle</span><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 black-fg separator\"></md-icon><span class=\"parent\" translate=\"PAGESMENUSTITLES.lives_calendar_pagetitle\">\nlives_calendar_pagetitle</span></div><div class=\"header-top\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PAGESMENUSTITLES.lives_calendar_pagetitle\">lives__calendar_pagetitle</span></div><div class=\"header-bottom\" \nlayout=\"row\" layout-align=\"center center\"><a tooltips tooltip-template=\"{{\'MESSAGES.calendar_pervious\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"calendar_pervious\" translate translate-attr-aria-label=\"MESSAGES.calendar_pervious\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button></a><div class=\"title\">{{vm.calendarView.title}}</div><a \ntooltips tooltip-template=\"{{\'MESSAGES.calendar_next\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"calendar_next\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_next\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button>\n</a></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><a tooltips \ntooltip-template=\"{{\'PAGESMENUSTITLES.lives_list\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.returnToList()\" aria-label=\"lives_list\" translate \ntranslate-attr-aria-label=\"PAGESMENUSTITLES.lives_list\"><md-icon md-font-icon=\"icon-view-list\" \nclass=\"ng-scope md-default-theme md-font material-icons icon-view-list\" aria-hidden=\"true\"></md-icon></md-button></a><a\n tooltips tooltip-template=\"{{\'MESSAGES.calendar_today\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"calendar_today\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_today\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'MESSAGES.calendar_day\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"calendar_day\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_day\"><md-icon md-font-icon=\"icon-view-day\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.calendar_week\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"calendar_week\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_week\"><md-icon md-font-icon=\"icon-view-week\"></md-icon></md-button></a><a \ntooltips tooltip-template=\"{{\'MESSAGES.calendar_month\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"calendar_month\" translate \ntranslate-attr-aria-label=\"MESSAGES.calendar_month\"><md-icon md-font-icon=\"icon-view-module\"></md-icon></md-button></a>\n</div></div></div></div><div class=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" \nng-model=\"vm.lives\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/media/lives/live/calendarListLive/calendar.template.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" style=\"height: 100%\" layout=\"column\"><iframe id=\"iframe_live\" \niframe-onload=\"iframeLoadedCallBack()\" class=\"fullwidth\" style=\"height: 100%\" ng-src=\"{{ vm.calendarLink}}\" \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe></div>");
$templateCache.put("app/main/media/lives/live/detail/detail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"lives_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.lives_detail_pagetitle\">lives_detail_pagetitle</span> \n<span>{{vm.lives.title |json}}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\">\n<md-icon md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\"><md-list flex><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.id\">id</strong></h3></div><div class=\"md-secondary\">\n{{vm.lives.id}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.title\">title</strong></h3></div><div class=\"md-secondary\">\n{{vm.lives.title}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.description\">description</strong></h3></div><div \nclass=\"md-secondary\">{{vm.lives.description}}</div><md-divider></md-divider></md-list-item><md-list-item \nclass=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.tags\">tags</strong></h3></div><div \nclass=\"md-secondary\">{{vm.lives.tags}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\">\n<div class=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.date\">date</strong></h3></div><div \nclass=\"md-secondary\">\n{{vm.lives.dateStart | date:\"dd/MM/yyyy\"}} ({{vm.lives.dateStart | date:\"HH:mm\"}}-{{vm.lives.dateEnd| date : \"HH:mm\"}})\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"LIVESDETAIL.private\">private</strong></h3></div><div class=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.private==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.private}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.autoPub\">autoPub</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.autoPub==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.autoPub}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.active\">actif</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.active==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\"></div><md-divider>\n</md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"LIVESDETAIL.thumbnail\">thumbnail</strong></h3></div><div class=\"md-secondary\"><img \nng-if=\"vm.lives.thumbnail\" width=\"100\" height=\"100\" class=\"product-image\" ng-src=\"{{vm.lives.thumbnail}}\"> <span \nng-if=\"vm.lives.thumbnail === null || vm.lives.thumbnail === \'\' || vm.lives.thumbnail === false \">-</span></div>\n<md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3><strong \ntranslate=\"LIVESDETAIL.foLike\">foLike</strong></h3></div><div class=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.foLike==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">{{vm.lives.foLike}}\n</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div class=\"md-list-item-text\"><h3>\n<strong translate=\"LIVESDETAIL.foSondage\">foSondage</strong></h3></div><div class=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.foSondage==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\nvm.lives.foSondage</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.foSubscript\">foSubscript</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.foSubscript==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.foSubscript}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.foComment\">foComment</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.foComment==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.foComment}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.foFilesShare\">foFilesShare</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.foFilesShare==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.foFilesShare}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.screenShare\">screenShare</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.screenShare==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\">\n{{vm.lives.screenShare}}</div><md-divider></md-divider></md-list-item><md-list-item class=\"md-1-line\"><div \nclass=\"md-list-item-text\"><h3><strong translate=\"LIVESDETAIL.defaultConf\">defaultConf</strong></h3></div><div \nclass=\"md-secondary\" \nng-attr-translate=\"{{vm.lives.defaultConf==1 ? \'MESSAGES.form_choices_yes\':\'MESSAGES.form_choices_no\'}}\"></div>\n<md-divider></md-divider></md-list-item></md-list></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex>\n</span><md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/lives/live/editLive/editLive.template.html","<div id=\"addIframe\" class=\"page-layout simple fullwidth\" style=\"height: 100%\" layout=\"column\"><iframe id=\"iframe_live\" \niframe-onload=\"iframeLoadedCallBack()\" class=\"fullwidth\" style=\"height: 100%\" ng-src=\"{{ vm.editLink}}\" \nallowfullscreen=\"true\" webkitallowfullscreen=\"true\" mozallowfullscreen=\"true\"></iframe></div>");
$templateCache.put("app/main/media/lives/live/diffusion/add.chapter.html","<md-dialog style=\"min-width: 50%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span ng-if=\"add\" translate=\"MESSAGES.add_chapter\">chapter\n</span> <span ng-if=\"!add\" translate=\"MESSAGES.modify_chapter\">chapter</span></h2></div></md-toolbar><md-content><div \nlayout=\"row\" layout-align=\"space-around center\" class=\"addChapterContainer\"><div layout=\"column\" \nlayout-align=\"start center\" flex=\"30\"><md-input-container md-no-float class=\"md-block\" style=\"top:10px;width:30%\">\n<input ng-class=\"errorTime\" name=\"time\" ng-model=\"time\" placeholder=\"--:--:--\" ng-attr-data-duration=\"{{time}}\" \nui-mask=\"99:99:99\"></md-input-container></div><div layout=\"column\" layout-align=\"start none\" flex=\"70\">\n<md-input-container md-no-float class=\"md-block\" style=\"top:10px;width:90%\"><input ng-model=\"text\" placeholder=\"Text\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"nullError\" \nstyle=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" translate=\"LIVEDIFFUSION.error_time_null\">null\n</span> <span ng-if=\"invalidForm\" style=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" \ntranslate=\"LIVEDIFFUSION.error_time_invalid\">invalid</span> <span ng-if=\"timeExist\" \nstyle=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" translate=\"LIVEDIFFUSION.error_time_exist\">exist\n</span></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\" \ntranslate=\"MESSAGES.dialog_cancel\">Cancel</md-button><md-button class=\"md-raised md-primary\" ng-if=\"add\" \nng-click=\"confirmAdd()\" translate=\"MESSAGES.form_add\">Add</md-button><md-button class=\"md-raised md-primary\" \nng-if=\"!add\" ng-click=\"confirmModify()\" translate=\"MESSAGES.action_edit\">Modify</md-button></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/media/lives/live/diffusion/add.slide.html","<md-dialog style=\"min-width: 30%;min-height: 20%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span ng-if=\"add\" \ntranslate=\"MESSAGES.add_slide\">Slide</span> <span ng-if=\"!add\" translate=\"MESSAGES.modify_slide\">Slide</span></h2>\n</div></md-toolbar><md-content><div layout=\"column\" ng-if=\"progress\" class=\"waitingSWF\" layout-align=\"center center\" \nstyle=\"margin: 20px\"><md-progress-circular md-mode=\"determinate\" md-diameter=\"96\" ng-value=\"progressBarValue\">\n</md-progress-circular><span style=\"position: absolute;font-size: large;color: #2d2d2d\">{{progressBarValue}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"product-image-uploader\" \nflow-init=\"ngFlowImageOptions\" flow-name=\"ngFlowImage.flow\" flow-files-submitted=\"uploadFileImage()\" \nflow-file-added=\"fileImgAdded($file)\" flow-file-progress=\"fileProgress($file)\" \nflow-file-success=\"fileSuccess($file, $message)\" flow-complete=\"uploadComplete()\"><div class=\"upload-button\"><md-button\n flow-btn ng-if=\"!progress\" style=\"margin-top:20px\" class=\"md-list-item-content\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><span class=\"md-inline-list-icon-label\" \ntranslate=\"LIVEDIFFUSION.video_rich_media_slide_image\">Upload image</span></md-button></div></div></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/media/lives/live/diffusion/modalDiffusion.template.html","<md-dialog id=\"modal_confirm\" style=\"min-width: 25%;min-height: 20%\"><md-toolbar class=\"md-accent md-toolbarDiffusion\">\n<div class=\"md-toolbar-tools\" style=\"height: 58px\"><h2><span translate=\"MESSAGES.alert_live\"></span></h2></div>\n</md-toolbar><md-dialog-content style=\"height: 1em;text-align: center;overflow: hidden\"><div \nclass=\"md-dialog-content dialog-contentDiffusion\" flex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\" \ntranslate=\"MESSAGES.alert_message\"></div></md-dialog-content><md-dialog-actions layout=\"row\" class=\"buttons-modal\">\n<span flex></span><md-button class=\"md-accent cancelDiffusion dialogButton\" ng-click=\"cancel()\" \ntranslate=\"MESSAGES.form_cancel\">alert_close</md-button><md-button \nclass=\"md-accent confirm-Quitt-Diffusion dialogButton\" ng-click=\"confirm()\" translate=\"MESSAGES.alert_confirm\">save\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/lives/live/diffusion/template.diffusion.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout-video page-layout simple fullwidth\" layout=\"column\">\n<div class=\"content fullpage\" layout-align=\"center center\" style=\"height: 100%\"><div id=\"url_jitsi\" \nstyle=\"overflow: hidden;height: 100%\" layout=\"row\" layout-wrap><iframe \nallow=\"display-capture; geolocation; microphone; camera\" ng-src=\"{{vm.urlJitsi}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/media/lives/live/diffusion/templateExtern.diffusion.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout-video page-layout simple fullwidth\" layout=\"column\">\n<div class=\"content fullpage\" layout=\"row\" layout-align=\"center center\" style=\"height: 100%\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\" style=\"height: 100%\"><ms-widget layout=\"row\" \nflex-gt-md=\"100\" flex-gt-sm=\"100\" flex-gt-xs=\"100\" style=\"height: 100%\"><ms-widget-front \nstyle=\"background-color:#212121\"><md-toolbar class=\"md-hue-2 md-primary\" style=\"background-color:#303030\"><span \nstyle=\"margin: 20px;font-size: larger\">{{vm.lives.title}}</span></md-toolbar><md-content \nstyle=\"background-color:#424242;color:white;height: 100%\"><div layout=\"column\" style=\"height: 100%\"><div layout=\"row\" \nflex><div flex layout=\"column\" layout-align=\"none center\"><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"innerGlow\"><md-button style=\"text-transform: none\" ng-style=\"{\'background-color\': vm.recordButton}\" \nng-class=\"vm.recordClass\" class=\"md-raised md-primary\" translate=\"{{vm.translateStart}}\" \ntranslate-attr-aria-label=\"{{vm.translate}}\" aria-label=\"{{vm.translate}}\" ng-click=\"vm.recordingStart()\"></md-button>\n<span class=\"counterInstant\">{{vm.counter}}</span></div><div style=\"width: 100%\" id=\"content-extern-live\" \nng-class=\"{\'externContentLive\': !vm.lives.isRm}\"><iframe width=\"100%\" height=\"{{vm.height_iframe}}\" \nng-src=\"{{vm.url_live}}\" allowfullscreen frameborder=\"0\"></iframe></div></div><md-list class=\"innerGlow\" flex=\"30\" \nstyle=\"height: inherit\" md-scroll-y ng-if=\"vm.lives.isRm\"><md-list-item ng-if=\"vm.lives.isRm\" class=\"navigation-node\" \nng-class=\"{clicked : vm.clickedChapter}\" ng-click=\"vm.clickChapterListItem()\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\" translate=\"LIVEDIFFUSION.live_chapter\">Chapter</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"arrow-encoder\"></md-icon></md-list-item><md-list-item \nng-class=\"{show : vm.clickedChapter, hide : !vm.clickedChapter, scrolling: vm.chapters.length>3}\" class=\"rm-container\">\n<md-list class=\"rm-content\"><md-list-item layout=\"row\" layout-align=\"start center\" style=\"background-color:#43A047\" \nng-click=\"vm.addChapter()\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nstyle=\"margin-left: 0px;color:rgba(255,255,255,0.7)\"></md-icon><span class=\"title\" \ntranslate=\"LIVEDIFFUSION.add_chapter\">Chapter</span></md-list-item><md-list-item ng-repeat=\"chapter in vm.chapters\">\n<span class=\"rm-counter\">{{chapter.TimeCode}}</span><md-input-container md-no-float class=\"md-block\" \nstyle=\"top:10px;width:90%\"><input ng-model=\"chapter.Title\" placeholder=\"Title\" ng-readonly=\"chapter.Diffuse\" \nng-style=\"chapter.Diffuse && {\'border\':\'none\'}\"></md-input-container><a tooltips ng-if=\"!chapter.Diffuse\" \ntooltip-template=\"{{\'LIVEDIFFUSION.broadcast_slide\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Broadcast\" ng-click=\"vm.broadcastChapter(chapter)\"><md-icon \nmd-font-icon=\"icon-cast\"></md-icon></md-button></a><a tooltips ng-if=\"!chapter.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Modify\" ng-click=\"vm.modifyChapter(chapter)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" ng-if=\"!chapter.Diffuse\" tooltip-side=\"bottom\" \ntooltip-speed=\"fast\"><md-button class=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.confirmDeleteChapter(chapter)\">\n<md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></a></md-list-item></md-list></md-list-item><md-list-item \nng-if=\"vm.lives.isRm\" class=\"navigation-node\" ng-class=\"{clicked : vm.clickedSlide}\" \nng-click=\"vm.clickSlideListItem()\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\" \ntranslate=\"LIVEDIFFUSION.live_slide\">Slide</span><md-icon md-font-icon=\"icon-chevron-right\" class=\"arrow-encoder\">\n</md-icon></md-list-item><md-list-item \nng-class=\"{show : vm.clickedSlide, hide : !vm.clickedSlide, scrolling: vm.slides.length>3}\" class=\"rm-container\">\n<md-list class=\"rm-content\"><md-list-item layout=\"row\" layout-align=\"start center\" style=\"background-color:#43A047\" \nng-click=\"vm.addSlide()\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nstyle=\"margin-left: 0px;color:rgba(255,255,255,0.7)\"></md-icon><span class=\"title\" translate=\"LIVEDIFFUSION.add_slide\">\nSlide</span></md-list-item><md-list-item ng-repeat=\"slide in vm.slides\" layout=\"row\" layout-align=\"center center\"><div \nflex=\"30\"><span class=\"rm-counter\">{{slide.TimeCode}}</span></div><div layout=\"row\" flex=\"70\" \nlayout-align=\"start center\"><img src=\"{{slide.Name}}\" style=\"width: 20%;margin: 10px 5px 5px 5px\"><div \nlayout-align=\"end center\" style=\"position: absolute;right: 2px\"><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'LIVEDIFFUSION.broadcast_slide\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Broadcast\" ng-click=\"vm.broadcastSlide(slide)\">\n<md-icon md-font-icon=\"icon-cast\"></md-icon></md-button></a><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Modify\" ng-click=\"vm.modifySlide(slide)\">\n<md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Delete\" ng-click=\"vm.confirmDeleteSlide(slide)\">\n<md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></a></div></div></md-list-item></md-list></md-list-item>\n</md-list></div></div></md-content></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/media/lives/live/list/infoDetail.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"-\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"PAGESMENUSTITLES.info_detail_pagetitle\">info_detail_pagetitle</span> <span>{{vm.title}}</span></h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\" ng-click=\"vm.cancel()\" aria-label=\"alert_close\"></md-icon>\n</md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinner\" class=\"md-accent\">\n</md-progress-linear><form name=\"vm.form\" ng-submit=\"vm.save()\"><md-dialog-content class=\"md-dialog-content\"><div \nng-if=\"vm.spinner\"><md-input-container class=\"md-block\"><label><span translate=\"LIVESDETAIL.url_diffusion\">\nurl_encodage :</span></label><input type=\"text\" ng-value=\"vm.data.urlDiffusion\" disabled=\"disabled\">\n</md-input-container><md-input-container class=\"md-block\"><label><span translate=\"LIVESDETAIL.name_flux\">name_flux :\n</span></label><input type=\"text\" ng-value=\"vm.data.streamName\" disabled=\"disabled\"></md-input-container>\n<md-input-container class=\"md-block\"><label><span translate=\"LIVESDETAIL.login_live\">login_live :</span></label><input \ntype=\"text\" ng-value=\"vm.data.login\" disabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\">\n<label><span translate=\"LIVESDETAIL.pwd_live\">pwd_live :</span></label><input type=\"text\" ng-value=\"vm.data.pwd\" \ndisabled=\"disabled\"></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button \nng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/media/lives/live/list/linkExport.modal.html","<md-dialog class=\"video-url-dialog\" style=\"width: 60%;height: 310px\" aria-label=\"Video Detail\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span translate=\"PAGESMENUSTITLES.export_Live_links_pagetitle\">\nexport_links_pagetitle</span> <span>{{vm.title}}</span></h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar>\n<md-progress-linear md-mode=\"query\" ng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><form name=\"vm.form\" \nng-submit=\"vm.save()\"><md-dialog-content ms-scroll style=\"padding-top: 0;padding-bottom: 0\"><div \nstyle=\"overflow: hidden\" ng-if=\"vm.spinner\"><div layout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong\n class=\"fs-14\" translate=\"MESSAGES.export_links_permalien\"><label class=\"fs-14\">{{vm.title}}</label></strong></div><div\n layout=\"column\"><div ng-repeat=\"name in vm.data.permalien track by $index\" layout=\"row\"><div id=\"{{\'fo1\'+$index}}\" \nclass=\"fs-14\">{{name}}</div><md-button class=\"btn md-icon-button\" ngclipboard \ndata-clipboard-target=\"{{\'#fo1\'+$index}}\" aria-label=\"url_copy\" style=\"top: -8px\" ng-click=\"vm.copied =0+$index\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===0+$index}\"></md-icon>\n</md-button></div></div></div><div layout=\"row\" class=\"row_url\" layout-xs=\"column\"><div flex=\"20\"><strong \nclass=\"fs-14\" translate=\"MESSAGES.export_links_embed\"><label class=\"fs-14\">{{vm.title}}</label></strong></div><div \nflex=\"80\" id=\"fo12\"><md-input-container style=\"margin: 0\"><textarea style=\"border: 1px solid #EDEDED\" id=\"bar\" \nclass=\"fs-14\"><iframe src=\"{{vm.data.embed}}\"></iframe></textarea></md-input-container></div><md-button \nclass=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#fo12\" aria-label=\"url_copy\" ng-click=\"vm.copied =1\">\n<md-icon md-font-icon=\"icon-content-copy\" class=\"s18\" ng-class=\"{\'md-icon-copied\': vm.copied ===1}\"></md-icon>\n</md-button></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/media/lives/live/list/list.template.html","<div id=\"e-commerce-products\" class=\"page-layout simple fullwidth\" layout=\"column\" style=\"height: 100%\"><div \nclass=\"content-card fullpage\" layout=\"column\" flex><div class=\"content fullpage-datatable\" layout=\"column\" flex \nstyle=\"overflow: hidden; height: 1000px\"><iframe id=\"iframe_live\" ng-src=\"{{vm.urlLiveList}}\" \niframe-onload=\"iframeLoadedCallBack()\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div></div></div>");
$templateCache.put("app/main/media/lives/live/list/mail.modal.html","<md-dialog style=\"min-width: 70%;max-height: 70%\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span\n translate=\"PAGESMENUSTITLES.send_invitation_detail_pagetitle\">send_invitation_detail_pagetitle</span> <span>\n{{lives.title |json}}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><md-progress-linear md-mode=\"query\" \nng-hide=\"vm.spinner\" class=\"md-accent\"></md-progress-linear><form name=\"vm.form\" \nng-submit=\"vm.selectedItems.length > 0 && vm.save()\"><md-dialog-content class=\"md-dialog-content\"><div \nng-if=\"vm.spinner\"><md-list flex><md-list-item style=\"cursor:pointer\" class=\"md-1-line\" \nng-repeat=\"user in vm.users track by user.id\" ng-attr-data=\"{{$index}}\" \nng-attr-class=\"{{vm.selectedItems.indexOf(user) > - 1 ? \'md-primary-bg\':\'\'}}\"><p style=\"padding-left: 20px\" \nng-click=\"vm.toogle(user)\">{{user.email}}</p><md-divider></md-divider></md-list-item></md-list></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-wrap>\n<span style=\"font-size: 14px;padding-left: 20px;color: red\">{{vm.msg}}</span></div><div layout=\"row\" layout-wrap>\n<md-button ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">\"alert_close\"</md-button><md-button type=\"submit\" \ntranslate=\"MESSAGES.send\" ng-disabled=\"vm.selectedItems.length <= 0 \">\"send\"</md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/media/lives/live/screenShare/screen.share.template.html","<md-dialog style=\"min-width: 50%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span translate=\"LIVESLIST.output_type\">output_type</span></h2>\n<span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" aria-label=\"alert_close\"></md-icon></md-button>\n</div></md-toolbar><md-content><div layout=\"row\" layout-align=\"center center\" style=\"padding-top: 20px\">\n<md-input-container class=\"md-accent\" style=\"width:80%;margin-top: 20px\" layout-align=\"center center\"><label \ntranslate=\"LIVESLIST.screen_type\">screen_type</label><md-select name=\"param\" ng-model=\"vm.param\"><md-option \nvalue=\"pip\" ng-selected=\"true\">Picture In Picture (PIP)</md-option><md-option value=\"sbs\">Side by side</md-option>\n</md-select></md-input-container></div></md-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-worm\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.dialog_cancel\">form_validate</md-button><md-button\n class=\"md-raised md-accent\" ng-click=\"vm.validate()\" translate=\"MESSAGES.form_validate\">form_validate</md-button>\n</md-dialog-actions></md-dialog>");
$templateCache.put("app/main/media/lives/live/encodeurlive/confirmtemplate.html","<md-dialog style=\"min-width: 40%\" aria-label=\"lives_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"LIVESPEARL.config_activetemp\">config_activetemp</span> <span>\n{{vm.lives.title |json}}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon\n md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><div layout=\"column\" \nlayout-align=\"space-between center\"><span translate=\"LIVESPEARL.msg_Active_template\">msg_Active_template</span><div \nlayout=\"row\"><md-button ng-click=\"vm.activeTemplate( vm.canalid,vm.templateid)\"><span \ntranslate=\"MESSAGES.form_validate\">channel_stop</span></md-button><md-button ng-click=\"vm.cancel()\"><span \ntranslate=\"MESSAGES.alert_close\">alert_close</span></md-button></div></div></md-dialog>");
$templateCache.put("app/main/media/lives/live/encodeurlive/encodeur.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage pearlDesktop\" layout=\"column\"><md-button \nclass=\"md-fab md-primary md-icon-button add-module-button btn-conf\" ng-click=\"vm.popup()\" \naria-label=\"action_new_element\" has-permission=\"pearl_encoder_button_conf\"><md-tooltip md-autohide=\"true\" \nmd-direction=\"top\"><span translate=\"LIVESPEARL.config_streaming\">config_streaming</span></md-tooltip><md-icon \nmd-font-icon=\"icon-cog-box\"></md-icon></md-button><md-tabs id=\"tab-upload\" md-dynamic-height md-border-bottom><md-tab \nng-click=\"vm.activeWebcastTab()\"><md-tab-label><md-icon style=\"color: #0000008a !important\" class=\"tab-upload-icon\" \nmd-font-icon=\"icon-cast\"></md-icon><div style=\"margin-top: -50px\"><span style=\"text-transform: none\">Webcast</span>\n</div></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nstyle=\"height: 506px; background: #181b22;min-width: 700px\" layout=\"row\" ng-if=\"!vm.errorPage\"><div flex=\"10\" \nstyle=\"border: 1px solid #ededed;width: 100%;min-width: 201px;border-bottom: 0;height: 100%;overflow: auto;padding: 5px\" \nclass=\"navigation-simple\" layout=\"column\" ng-if=\"vm.listTemplate.length\"><div \nstyle=\"padding: 5px;    cursor: pointer;    min-width: 182px;    min-height: 107px\" layout=\"column\" \nng-repeat=\"v in vm.listTemplate track by v.id\" ng-attr-data-index=\"{{$index}}\"><img style=\"filter: brightness(70%)\" \nng-class=\"{\'filter-webcast\': v.id===vm.idtemplate}\" ng-click=\"vm.previewTemplate(v.id,false,v,\'template\')\" \nsrc=\"{{vm.tabImg[vm.listTemplate.indexOf(v)]}}\"><md-tooltip md-autohide=\"true\" md-direction=\"bottom\"><span \ntranslate=\"LIVESPEARL.activate_layout\">activate_layout</span></md-tooltip></div></div><div \nng-if=\"vm.selectedWebcast===\'sidebyside\' && vm.preview && vm.idChannel!==0 && vm.test===true && vm.nbr_source\" flex \nlayout=\"column\"><div style=\"height: 350px;padding: 15px\" layout=\"row\" layout-wrap><div flex=\"45\" \nlayout-align=\"center center\" layout=\"column\"><div><img src=\"{{vm.preview_template}}\"></div><div class=\"centerdiiv\" \nstyle=\"color: white\" translate=\"LIVESPEARL.preview\">PREVIEW</div></div><div flex=\"10\" layout-align=\"center center\" \nlayout=\"column\"><div style=\"height: 1px\"></div><div><md-button class=\"md-icon-button\" ng-click=\"vm.activeTemplate()\" \naria-label=\"Settings\"><md-icon md-font-icon=\" icon-checkbox-marked-circle\" class=\"s24\" \nstyle=\"font-size: 34px !important;color: #039be5\"></md-icon></md-button></div><div><any \nstyle=\"color: white;padding-left: 7px\" translate=\"LIVESPEARL.apply\">Apply</any></div></div><div flex=\"45\" \nlayout-align=\"center center\" layout=\"column\"><div><img src=\"{{vm.preview_template_final}}\"></div><div \nclass=\"centerdiiv\" style=\"color: white\" translate=\"LIVESPEARL.final\">Final</div></div></div><div style=\"height: 157px\" \nlayout=\"column\"><div class=\"centerdiiv\" style=\"color: white\">SOURCE</div><div style=\"width: 100%;overflow: auto\" \nlayout=\"row\"><div ng-if=\"vm.listSources.length\" \nstyle=\"padding: 5px;cursor: pointer;    min-width: 182px;height: 117px\" layout=\"row\" \nng-repeat=\"v in vm.listSources track by v.id\" ng-attr-data-index=\"{{$index}}\"><img style=\"filter: brightness(70%)\" \nng-class=\"{\'filter-webcast\': v.id===vm.idtemplate}\" ng-click=\"vm.previewTemplate(v.id,false,v,\'source\')\" \nsrc=\"{{vm.tabSrc[vm.listSources.indexOf(v)]}}\"></div><div ng-if=\"!vm.listSources.length\" layout-align=\"center center\" \nflex layout=\"column\"><span style=\"color: white;font-size: large;padding: 30px\" translate=\"LIVESPEARL.msg_empty_src\">\nLa liste des sources est vide</span></div></div></div></div><div \nng-if=\"(vm.selectedWebcast===\'sidebyside\' && !vm.preview) \" layout-align=\"center center\" flex layout=\"column\"><span \nstyle=\"color: white;font-size: x-large\" translate=\"LIVESPEARL.msg_preview_disabled\">Écran de prévisualisation désactivé\n</span></div><div ng-if=\"(vm.selectedWebcast===\'sidebyside\' && vm.idChannel===0) \" layout-align=\"center center\" flex \nlayout=\"column\"><span style=\"color: white;font-size: x-large\" translate=\"LIVESPEARL.msg_config_pearl\">\nVeuillez configurer PEARL</span></div><div ng-if=\"(vm.selectedWebcast===\'sidebyside\' && vm.test===false) \" \nlayout-align=\"center center\" flex layout=\"column\"><span style=\"color: white;font-size: x-large\" \ntranslate=\"LIVESPEARL.msg_config_pearl\">Veuillez configurer PEARL</span></div><div \nng-if=\"(vm.selectedWebcast===\'sidebyside\' && !vm.nbr_source && !vm.listTemplate.length)\" layout-align=\"center center\" \nflex layout=\"column\"><span style=\"color: white;font-size: x-large\" translate=\"LIVESPEARL.msg_config_pearl\">\nmsg_config_pearl</span></div></div><div style=\"min-width: 700px\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"!vm.errorPage\"><div style=\"padding-left: 195px\"><md-button ng-disabled=\"!vm.stream || vm.idChannel===0\" \nng-click=\"vm.startEndStreaming()\" class=\"md-raised\"><md-icon style=\"color: #00C853\" \nng-class=\"{\'stop\': vm.statusStreaming===false}\" md-font-icon=\"icon-wifi\"></md-icon><any \nng-if=\"vm.statusStreaming===false\" style=\"color: #00C853\" ng-class=\"{\'stop\': vm.statusStreaming===false}\">Start</any>\n<any ng-if=\"vm.statusStreaming===true\" style=\"color: #00C853\" ng-class=\"{\'stop\': vm.statusStreaming===false}\">Stop\n</any></md-button></div><div><md-button ng-click=\"vm.testApi()\" class=\"md-raised\">Test API Machine</md-button></div>\n<div><md-button ng-disabled=\"!vm.record || vm.idChannel===0 || !vm.statusRecording\" ng-click=\"vm.startEndRecording()\" \nclass=\"md-raised\"><md-icon ng-if=\"vm.statusRecording===\'0\'\" class=\"stop\" md-font-icon=\"icon-radiobox-marked\"></md-icon>\n<md-icon ng-if=\"vm.statusRecording===\'1\'\" style=\"color: #00C853\" md-font-icon=\"icon-stop\"></md-icon><span \nng-if=\"vm.statusRecording===\'0\'\" style=\"color: #00C853\" ng-class=\"{\'stop\': vm.statusRecording===\'0\'}\">00:00:00</span> \n<span style=\"color: #00C853\" ng-if=\"vm.statusRecording===\'1\'\">{{vm.timer}}</span></md-button></div></div><div \nstyle=\"height: 506px; background: #181b22;min-width: 700px\" layout=\"row\" ng-if=\"vm.errorPage\"><div \nid=\"content-live-error\" style=\"height:100%;width: 100%\" layout-align=\"center center\"><div \nstyle=\"text-align: center;color: #aaaaaa\" class=\"error_content\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s200\">\n</md-icon><div class=\"error_info\" translate=\"LIVEDIFFUSION.error_diffusion\">\nUne erreur est survenue lors de la diffusion</div><div class=\"error_message\" \ntranslate=\"LIVEDIFFUSION.error_alert_diffusion\">Veuillez réessayer plus tard</div></div></div></div></md-content>\n</md-tab-body></md-tab><md-tab ng-if=\"vm.permission.pearl_encoder_settings\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-cog\"></md-icon><div \nstyle=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"LIVESPEARL.settings\"></span></div>\n</md-tab-label><md-tab-body><md-content class=\"md-padding\"><div layout=\"row\" layout-wrap><div flex=\"30\" \nstyle=\"border: 1px solid #ededed;width: 100%;min-width: 145px;border-bottom: 0;height: 300px\" \nclass=\"navigation-simple\" layout=\"column\"><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nlayout-align=\"space-between center\"><div hide-xs ng-class=\"{\'selected2\':vm.selected===\'source\'}\"></div><md-button \nstyle=\"border-bottom: 1px solid #ededed;width: 100%;max-height: 70px;height: 60px;border-radius: 0px\" \nng-class=\"{\'selected\':vm.selected===\'source\'}\" class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.showDiv(\'source\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-camcorder\" class=\"s24\"></md-icon><span class=\"title\">SOURCE\n</span></div></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" layout-align=\"space-between center\"><div\n hide-xs ng-class=\"{\'selected2\':vm.selected===\'publish\'}\"></div><md-button \nstyle=\"border-bottom: 1px solid #ededed;width: 100%;max-height: 70px;height: 60px;border-radius: 0px\" \nng-class=\"{\'selected\':vm.selected===\'publish\'}\" class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.showDiv(\'publish\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon><span class=\"title\" \ntranslate=\"LIVESPEARL.publish\">PUBLISH</span></div></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nlayout-align=\"space-between center\"><div hide-xs ng-class=\"{\'selected2\':vm.selected===\'interact\'}\"></div><md-button \nstyle=\"border-bottom: 1px solid #ededed;width: 100%;max-height: 70px;height: 60px;border-radius: 0px\" \nng-class=\"{\'selected\':vm.selected===\'interact\'}\" class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.showDiv(\'interact\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-share-variant\" class=\"s24\"></md-icon><span class=\"title\" \ntranslate=\"LIVESPEARL.interact\">INTERACT</span></div></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" \nlayout-align=\"space-between center\"><div hide-xs ng-class=\"{\'selected2\':vm.selected===\'prerol\'}\"></div><md-button \nstyle=\"border-bottom: 1px solid #ededed;width: 100%;max-height: 70px;height: 60px;border-radius: 0px\" \nng-class=\"{\'selected\':vm.selected===\'prerol\'}\" class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.showDiv(\'prerol\')\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-movie\" class=\"s24\"></md-icon><span class=\"title\">PRE ROLL\n</span></div></md-button></div><div layout=\"column\" layout-gt-xs=\"row\" flex=\"\" layout-align=\"space-between center\"><div\n hide-xs ng-class=\"{\'selected2\':vm.selected===\'form\'}\"></div><md-button \nstyle=\"border-bottom: 1px solid #ededed;width: 100%;max-height: 70px;height: 60px;border-radius: 0px\" \nng-class=\"{\'selected\':vm.selected===\'form\'}\" class=\"item\" aria-label=\"All Tasks\" translate \ntranslate-attr-aria-label=\"TODO.ALL_TASKS\" ng-click=\"vm.showDiv(\'form\')\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-book-open\" class=\"s24\"></md-icon><span class=\"title\" translate=\"LIVESPEARL.streaming\">\nFORMULAIRE</span></div></md-button></div></div><div layout-align=\"center center\" layout=\"column\" \nng-if=\"vm.selected===\'publish\'\" flex><h3 style=\"margin-left: 6%\" translate=\"LIVESPEARL.publish_title\">\nDefine sources record and stream live</h3><div \nstyle=\"min-width: 166px; background: #f4f4f4;width:70%;margin-left: 3%;margin-top: 2%\"><div \nstyle=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" \nflex=\"80\"><label translate=\"LIVESPEARL.live_broadcast\">LIVE BROADCASTING</label></div><div flex><md-switch \nng-model=\"vm.stream\" aria-label=\"Switch 1\"></md-switch></div></div><div style=\"border-bottom: 1px solid #ededed\" \nlayout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label \ntranslate=\"LIVESPEARL.recording_sources\">RECORDING SOURCES</label></div><div flex><md-switch ng-model=\"vm.record\" \naria-label=\"Switch 1\"></md-switch></div></div><div style=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap>\n<div style=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label translate=\"LIVESPEARL.preview_screen\">PREVIEW SCREEN\n</label></div><div flex><md-switch ng-model=\"vm.preview\" aria-label=\"Switch 1\"></md-switch></div></div></div></div><div\n layout-align=\"center center\" layout=\"column\" ng-if=\"vm.selected===\'interact\'\" flex><h3 style=\"margin-left: 6%\" \ntranslate=\"LIVESPEARL.interact_title\">Please select interactive and social options</h3><div \nstyle=\"min-width: 250px; width: 60%;background: #f4f4f4;margin-left: 3%;margin-top: 2%\"><div \nstyle=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" \nflex=\"80\"><label>CHATROOM</label></div><div flex><md-switch ng-model=\"vm.chatRoom\" aria-label=\"Switch 1\"></md-switch>\n</div></div><div style=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div \nstyle=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label translate=\"LIVESPEARL.sondage\">SONDAGE</label></div><div \nflex><md-switch ng-model=\"vm.sondage\" aria-label=\"Switch 1\"></md-switch></div></div><div \nstyle=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" \nflex=\"80\"><label>QUESTIONS</label></div><div flex><md-switch ng-model=\"vm.questions\" aria-label=\"Switch 1\"></md-switch>\n</div></div><div style=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div \nstyle=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label translate=\"LIVESPEARL.comments\">COMMENTAIRES</label>\n</div><div flex><md-switch ng-model=\"vm.commentaires\" aria-label=\"Switch 1\"></md-switch></div></div><div \nstyle=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" \nflex=\"80\"><label>FACEBOOK</label></div><div flex><md-switch ng-model=\"vm.facebook\" aria-label=\"Switch 1\"></md-switch>\n</div></div><div style=\"border-bottom: 1px solid #ededed\" layout=\"row\" layout-wrap><div \nstyle=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label>TWITTER</label></div><div flex><md-switch \nng-model=\"vm.twitter\" aria-label=\"Switch 1\"></md-switch></div></div><div style=\"border-bottom: 1px solid #ededed\" \nlayout=\"row\" layout-wrap><div style=\"padding-top: 20px;padding-left: 20px\" flex=\"80\"><label>LINKEDIN</label></div><div \nflex><md-switch ng-model=\"vm.linkedIn\" aria-label=\"Switch 1\"></md-switch></div></div></div></div><div \nlayout-align=\"start start\" layout=\"column\" ng-if=\"vm.selected===\'prerol\'\" flex><h3 style=\"margin-left: 6%\" \ntranslate=\"LIVESPEARL.prerol_title\">Ajouter pre-rol vidéo et post-roll vidéo</h3><div \nstyle=\"min-width: 166px;width: 50%;margin-left: 3%;margin-top: 2%;height: 90%\"><div layout=\"row\" layout-sm=\"column\">\n<div style=\"min-width: 226px\" flex><span style=\"padding-left: 38%\">Pre-Roll</span><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);min-width: 224px\" class=\"product-detail-form-container\"><div \nclass=\"product-image-uploader\" flow-init=\"vm.ngFlowOptionsPre\" flow-name=\"vm.ngFlowPre.flow\" \nflow-files-submitted=\"vm.uploadFilePre()\" flow-file-added=\"vm.fileAddedPre($file)\" \nflow-file-progress=\"vm.fileProgressPre($file)\" flow-file-success=\"vm.fileSuccessPre($file, $message)\" \nflow-complete=\"vm.uploadCompletePre()\" flow-drop flow-drag-enter=\"vm.droppingPre=true\" \nflow-drag-leave=\"vm.droppingPre=false\" ng-class=\"{\'dropping\':vm.droppingPre}\"><div class=\"drop-text hint-text\" \nlayout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div \nstyle=\"padding-top: 10px\" class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressPre\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><md-button class=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" \nng-click=\"vm.cancelUploadPre()\" ng-if=\"vm.inProgressPre\">form_cancel</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressPre\"><div><p class=\"secondary-text mt-8 text-center\">\n<strong>{{vm.videoFilePre.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValuePre\">\n<strong>{{vm.roundWithPrecision(vm.progressBarValuePre,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressPre\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValuePre\">\n</md-progress-circular></div></div></div></div></div></div><div style=\"min-width: 226px\" flex><span \nstyle=\"padding-left: 38%\">Post-Roll</span><div layout-padding layout-margin \nstyle=\"border: 2px dashed rgba(0,0,0,0.15);min-width: 224px\" class=\"product-detail-form-container\"><div \nclass=\"product-image-uploader\" flow-init=\"vm.ngFlowOptionsPost\" flow-name=\"vm.ngFlowPost.flow\" \nflow-files-submitted=\"vm.uploadFilePost()\" flow-file-added=\"vm.fileAddedPost($file)\" \nflow-file-progress=\"vm.fileProgressPost($file)\" flow-file-success=\"vm.fileSuccessPost($file, $message)\" \nflow-complete=\"vm.uploadCompletePost()\" flow-drop flow-drag-enter=\"vm.droppingPost=true\" \nflow-drag-leave=\"vm.droppingPost=false\" ng-class=\"{\'dropping\':vm.droppingPost}\"><div class=\"drop-text hint-text\" \nlayout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div \nstyle=\"padding-top: 10px\" class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressPost\"><span \nstyle=\"font-weight: 600;text-decoration: underline;font-size: 16px;color: #5f5f5f\" translate=\"MESSAGES.choose_a_file\">\nchoose_a_file</span></md-button><md-button class=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" \nng-click=\"vm.cancelUploadPost()\" ng-if=\"vm.inProgressPost\">form_cancel</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressPost\"><div><p class=\"secondary-text mt-8 text-center\">\n<strong>{{vm.videoFilePost.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" \nng-if=\"vm.progressBarValuePost\"><strong>{{vm.roundWithPrecision(vm.progressBarValuePost,2)}}%</strong></p></div></div>\n<div layout=\"row\" layout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressPost\"><div \nng-switch-when=\"true\"><md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" \nng-value=\"vm.progressBarValuePost\"></md-progress-circular></div></div></div></div></div></div></div></div></div><div \nng-if=\"vm.selected===\'form\'\" flex><form name=\"streaming\" method=\"post\" id=\"streaming\" class=\"testyoussef\" \nnovalidate=\"novalidate\" ng-submit=\"streaming.$valid && vm.submitUpdatestreaming(vm.detailstream.idChannel)\"><fieldset>\n<legend><div class=\"form-title\"><md-icon md-font-icon=\"icon-view-stream\" class=\"s18\"></md-icon><span \ntranslate=\"LIVESPEARL.streaming\">streaming</span> {{vm.tem}}</div></legend><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"LIVESPEARL.streaming_url\">streaming_url</label><input type=\"text\" \nid=\"streaming_name\" name=\"streaming[name]\" ng-attr-name=\"name\" translate=\"\" ng-model=\"vm.detailstream.urlStreaming\" \nvalue=\"Default\" aria-invalid=\"true\"><div ng-messages=\"streaming.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.streaming.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESPEARL.streaming_name\">streaming_name</label><div class=\"md-resize-wrapper\"><textarea \nid=\"streaming_description\" name=\"streaming[description]\" ng-attr-name=\"description\" translate=\"\" \nng-model=\"vm.detailstream.nameStreaming\" rows=\"1\" aria-invalid=\"true\" style=\"height: 30px\"></textarea><div \nclass=\"md-resize-handle\" style=\"touch-action: pan-y\"></div></div><div ng-messages=\"streaming.description.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.description && vm.streaming.description === vm.empProfilesGroupError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"USERADD.form_attr_username\">Nom d\'utilisateur</label><input type=\"text\" id=\"loginStreaming\" \nname=\"empProfilesUserForm[loginStreaming]\" ng-attr-name=\"loginStreaming\" translate=\"\" \nng-model=\"vm.detailstream.loginStreaming\" aria-invalid=\"true\"><div ng-messages=\"empProfilesUserForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"USERADD.form_attr_first\">Password</label><input type=\"password\" id=\"pswStreaming\" \nname=\"empProfilesUserForm[pswStreaming]\" ng-attr-name=\"pswStreaming\" translate=\"\" pattern=\"\" \nng-model=\"vm.detailstream.pswStreaming\" aria-invalid=\"true\"><div ng-messages=\"empProfilesUserForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div></fieldset><div ng-if=\"vm.selected===\'form\'\" layout-align=\"end start mv-10\" layout=\"row\">\n<md-button class=\"md-warn md-flat\" ng-click=\"vm.returnToList()\" translate=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_validate\" \nng-click=\"vm.submitUpdatestreaming(vm.detailstream.idChannel)\" ng-disabled=\"streaming.$invalid || streaming.$pristine\">\n<md-icon md-font-icon=\"icon-check\"></md-icon><any translate=\"MESSAGES.form_validate\">form_validate</any></md-button>\n</div></form></div></div><div style=\"margin-top: 20px\" ng-if=\"vm.selected!==\'form\'\" layout-align=\"end start mv-10\" \nlayout=\"row\"><md-button class=\"md-warn md-flat\" ng-click=\"vm.returnToList()\" translate=\"MESSAGES.form_cancel\">\nform_cancel</md-button><md-button class=\"md-accent md-raised\" ng-click=\"vm.saveConf(vm.selected)\" \nng-disabled=\"vm.selected===\'prerol\'&& !vm.videoKeyNamePre && !vm.videoKeyNamePost\"><md-icon md-font-icon=\"icon-check\">\n</md-icon><any translate=\"MESSAGES.form_validate\">form_validate</any></md-button></div></md-content></md-tab-body>\n</md-tab><md-tab ng-if=\"vm.permission.pearl_encoder_interaction\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-share-variant\"></md-icon><div \nstyle=\"margin-top: -50px\"><span style=\"text-transform: none\">Interaction</span></div></md-tab-label><md-tab-body>\n<md-content class=\"md-padding\"></md-content></md-tab-body></md-tab><md-tab md-on-select=\"vm.get_url_live()\" \nng-if=\"vm.statusStreaming===true && vm.permission.pearl_encoder_vue_web\"><md-tab-label><md-icon \nstyle=\"color: #0000008a !important\" class=\"tab-upload-icon\" md-font-icon=\"icon-desktop-mac\"></md-icon><div \nstyle=\"margin-top: -50px\"><span style=\"text-transform: none\" translate=\"LIVESPEARL.webview\">webview</span></div>\n</md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nstyle=\"background: #eee;height: 605px;overflow: hidden;padding: 0;position: relative; text-align: center\" \nid=\"iframe_vue_web\"><md-progress-circular ng-if=\"vm.showLoading\" style=\"margin: 0 auto\" md-diameter=\"96\">\n</md-progress-circular><iframe style=\"position: relative;top: 0;left: 0;height: 100%\" \nwidth=\"{{vm.width_iframe_vue_web}}\" height=\"100%\" ng-src=\"{{vm.url_live_web}}\" frameborder=\"0\" ng-if=\"!vm.showLoading\" \nwebkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div></md-content></md-tab-body></md-tab></md-tabs>\n</div><div class=\"content fullpage pearlMobile\"><md-content style=\"width: 100%\"><md-card \nclass=\"md-padding md-whiteframe-4dp\"><md-card-header><span translate=\"LIVEDIFFUSION.form_encoder\" \nstyle=\"left: 15px;font-size: larger\">form_encoder</span><md-button ng-click=\"vm.recordingStart()\" ng-if=\"!vm.start\" \ntranslate=\"LIVEDIFFUSION.stop\" class=\"stopLive\" translate-attr-aria-label=\"LIVEDIFFUSION.stop\" \naria-label=\"LIVEDIFFUSION.stop\"></md-button></md-card-header><div id=\"content_urlLive\" ng-if=\"!vm.errorPage\"><div \nng-if=\" vm.start\" class=\"start_encoderPearl\"><img style=\"height: 22%;margin-bottom: 2%\" \nsrc=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MzcuMjc0IiBoZWlnaHQ9IjMxOC43NSIgdmlld0JveD0iMCAwIDQzNy4yNzQgMzE4Ljc1Ij4gIDxnIGlkPSJub3VuX2xpdmVfMjE0NjkxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTIuNSAtMTUuMzUpIj4gICAgPGcgaWQ9Ikdyb3VwZV8yIiBkYXRhLW5hbWU9Ikdyb3VwZSAyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyLjUgMTUuMzUpIj4gICAgICA8cGF0aCBpZD0iVHJhY8OpXzEiIGRhdGEtbmFtZT0iVHJhY8OpIDEiIGQ9Ik0xMDUuNCwyMC4xODNjLTYuNDQ0LTYuNDQ0LTE2LjU3LTYuNDQ0LTIyLjU1NCwwLTYuNDQ0LDYuNDQ0LTYuNDQ0LDE2LjU3LDAsMjIuNTU0YTE4Ni4yODYsMTg2LjI4NiwwLDAsMSw1NC4zMTQsMTMyLjFBMTgzLjc1OSwxODMuNzU5LDAsMCwxLDgyLjM4MywzMDYuNDgzYy02LjQ0NCw2LjQ0NC02LjQ0NCwxNi41NywwLDIyLjU1NGExNi42ODUsMTYuNjg1LDAsMCwwLDIzLjAxNCwwLDIxNi44NjksMjE2Ljg2OSwwLDAsMCw2My45OC0xNTQuNjU3QzE2OS4zNzgsMTE2LjM4MywxNDYuODIzLDYxLjE0OSwxMDUuNCwyMC4xODNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNjcuODk3IC0xNS4zNSkiIGZpbGw9IiNjN2M3YzciLz4gICAgICA8cGF0aCBpZD0iVHJhY8OpXzIiIGRhdGEtbmFtZT0iVHJhY8OpIDIiIGQ9Ik0zNC43MiwxNzQuNDhjMC01MC4xNzEsMTkuMzMyLTk2LjY2MSw1NC43NzQtMTMxLjY0Myw2LjQ0NC02LjQ0NCw2LjQ0NC0xNi41NywwLTIyLjU1NC02LjQ0NC02LjQ0NC0xNi41Ny02LjQ0NC0yMi41NTQsMEMyNS4wNTQsNjAuNzg4LDIuNSwxMTYuMDIzLDIuNSwxNzQuNDhBMjE2Ljg2OSwyMTYuODY5LDAsMCwwLDY2LjQ4LDMyOS4xMzdhMTYuNjg1LDE2LjY4NSwwLDAsMCwyMy4wMTQsMGM2LjQ0NC02LjQ0NCw2LjQ0NC0xNi41NywwLTIyLjU1NEExODUuNiwxODUuNiwwLDAsMSwzNC43MiwxNzQuNDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi41IC0xNC45OSkiIGZpbGw9IiNjN2M3YzciLz4gICAgICA8cGF0aCBpZD0iVHJhY8OpXzMiIGRhdGEtbmFtZT0iVHJhY8OpIDMiIGQ9Ik05My4yMzcsMzEuOTgzYy02LjQ0NC02LjQ0NC0xNi41Ny02LjQ0NC0yMi41NTQsMC02LjQ0NCw2LjQ0NC02LjQ0NCwxNi41NywwLDIyLjU1NGExMDkuMDUzLDEwOS4wNTMsMCwwLDEsMzIuMjIsNzcuMzI5LDEwOS4wNTIsMTA5LjA1MiwwLDAsMS0zMi4yMiw3Ny4zMjhjLTYuNDQ0LDYuNDQ0LTYuNDQ0LDE2LjU3LDAsMjIuNTU0YTE2LjY4NSwxNi42ODUsMCwwLDAsMjMuMDE0LDAsMTQwLjMxOCwxNDAuMzE4LDAsMCwwLDQxLjQyNi05OS44ODNBMTQzLjUzLDE0My41MywwLDAsMCw5My4yMzcsMzEuOTgzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjI1Ljc0MyAyNy4xNjQpIiBmaWxsPSIjYzdjN2M3Ii8+ICAgICAgPHBhdGggaWQ9IlRyYWPDqV80IiBkYXRhLW5hbWU9IlRyYWPDqSA0IiBkPSJNNTEuMDYsMTMxLjk2NkExMDguMjYxLDEwOC4yNjEsMCwwLDEsODMuMjgsNTQuNjM3YzYuNDQ0LTYuNDQ0LDYuNDQ0LTE2LjU3LDAtMjIuNTU0LTYuNDQ0LTYuNDQ0LTE2LjU3LTYuNDQ0LTIyLjU1NCwwYTE0MS42ODQsMTQxLjY4NCwwLDAsMCwuNDYsMjAwLjY4NkExNi4xMTIsMTYuMTEyLDAsMCwwLDg0LjIsMjEwLjIxNSwxMDkuMDc4LDEwOS4wNzgsMCwwLDEsNTEuMDYsMTMxLjk2NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU4LjAyOSAyNy41MjQpIiBmaWxsPSIjYzdjN2M3Ii8+ICAgICAgPHBhdGggaWQ9IlRyYWPDqV81IiBkYXRhLW5hbWU9IlRyYWPDqSA1IiBkPSJNNjMuNjU0LDM4LjgzNkExNC40ODEsMTQuNDgxLDAsMCwwLDQxLjEsNTAuOFYxNDdhMTQuNDgxLDE0LjQ4MSwwLDAsMCwyMi41NTQsMTEuOTY3bDcyLjI2NS00OC4zM2ExNC42MjEsMTQuNjIxLDAsMCwwLDAtMjQuNFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEzNi41NzEgNjAuMzU2KSIgZmlsbD0iI2M3YzdjNyIvPiAgICA8L2c+ICA8L2c+PC9zdmc+\">\n<md-button ng-click=\"vm.recordingStart()\" translate=\"LIVEDIFFUSION.start\" class=\"startLive\" \ntranslate-attr-aria-label=\"LIVEDIFFUSION.start\" aria-label=\"LIVEDIFFUSION.start\"></md-button><span class=\"indication\" \ntranslate=\"LIVEDIFFUSION.label_start_live\">Cliquer pour commencer le direct</span></div><iframe ng-if=\"!vm.start\" \nheight=\"{{vm.height_iframe}}\" width=\"100%\" ng-src=\"{{vm.url_live}}\" allowfullscreen frameborder=\"0\"></iframe></div>\n<md-card-title-group ng-if=\"!vm.errorPage\"><img mat-card-sm-image \nsrc=\"data:image/png;base64,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\">\n<md-card-title-text class=\"md-headline\">Live</md-card-title-text></md-card-title-group><md-card-footer \nng-if=\"!vm.errorPage\"><span>{{vm.counter}}</span></md-card-footer><div id=\"content_urlLive_error\" ng-if=\"vm.errorPage\" \nstyle=\"background: #181B22;height: 100%;border-top:1px solid #aaa\"><div id=\"content-live-error\" \nstyle=\"height:100%;width: 100%\" layout-align=\"center center\"><div style=\"text-align: center;color: #aaaaaa\" \nclass=\"error_content\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s100\"></md-icon><div class=\"error_info\" \ntranslate=\"LIVEDIFFUSION.error_diffusion\">Une erreur est survenue lors de la diffusion</div><div class=\"error_message\" \ntranslate=\"LIVEDIFFUSION.error_alert_diffusion\">Veuillez réessayer plus tard</div></div></div></div></md-card>\n</md-content></div></div>");
$templateCache.put("app/main/media/lives/live/encodeurlive/encodeur_template.html","<div id=\"forms\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"content\" layout=\"column\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"100\" flex-gt-md=\"100\"><ms-widget-front class=\"p-16\"><div layout=\"column\" layout-align=\"space-between\" flex>\n<div ng-include=\"\'app/main/media/lives/live/encodeurlive/encodeur.html\'\"></div></div></ms-widget-front></ms-widget>\n</div></div></div>");
$templateCache.put("app/main/media/lives/live/encodeurlive/popupconfig.html","<md-dialog style=\"min-width: 70%\" aria-label=\"lives_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2><span translate=\"LIVESPEARL.config_streaming\">config_streaming</span> <span>\n{{vm.lives.title |json}}</span></h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon\n md-font-icon=\"icon-close\" class=\"s24\" translate translate-attr-aria-label=\"MESSAGES.alert_close\" \naria-label=\"alert_close\"></md-icon></md-button></div></md-toolbar><form name=\"params\" method=\"post\" style=\"margin: 5%\" \nid=\"params\" class=\"testyoussef\" novalidate=\"novalidate\" ng-submit=\"params.$valid && vm.submitUpdateparams()\"><fieldset>\n<legend><div class=\"form-title\"><md-icon md-font-icon=\"icon-view-stream\" class=\"s18\"></md-icon><span \ntranslate=\"LIVESPEARL.streaming\">streaming</span></div></legend><div layout=\"column\" layout-gt-sm=\"row\">\n<md-input-container flex><label translate=\"LIVESPEARL.activate_pearl_encoder\">activate_pearl_encoder</label><input \ntype=\"text\" id=\"activate_pearl_encoder\" name=\"\" ng-attr-name=\"name\" translate=\"\" value=\"Default\" \nng-model=\"vm.paramspearl.activate_pearl_encoder\" aria-invalid=\"true\"><div ng-messages=\"params.name.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESPEARL.pearl_url\">pearl_url</label><input type=\"text\" id=\"pearl_url\" name=\"params[name]\" \nng-attr-name=\"name\" translate=\"\" ng-model=\"vm.paramspearl.pearl_url\" value=\"Default\" aria-invalid=\"true\"><div \nng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESPEARL.pearl_api_username\">pearl_api_username</label><input type=\"text\" id=\"pearl_api_username\" \nname=\"params[name]\" ng-attr-name=\"name\" translate=\"\" ng-model=\"vm.paramspearl.pearl_api_username\" value=\"Default\" \naria-invalid=\"true\"><div ng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESPEARL.pearl_api_pwd\">pearl_api_pwd</label><input type=\"text\" id=\"pearl_api_pwd\" name=\"params[name]\" \nng-attr-name=\"name\" translate=\"\" ng-model=\"vm.paramspearl.pearl_api_pwd\" value=\"Default\" aria-invalid=\"true\"><div \nng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \ntranslate=\"LIVESPEARL.pearl_live_url_preview\">pearl_live_url_preview</label><input type=\"text\" \nid=\"pearl_live_url_preview\" name=\"params[name]\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.paramspearl.pearl_live_url_preview\" value=\"Default\" aria-invalid=\"true\"><div \nng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\npearl_live_url_preview_layout</label><input type=\"text\" name=\"params[name]\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.paramspearl.pearl_live_url_preview_layout\" value=\"Default\" aria-invalid=\"true\"><div \nng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>\npearl_live_url_preview_source</label><input type=\"text\" name=\"params[name]\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.paramspearl.pearl_live_url_preview_source\" value=\"Default\" aria-invalid=\"true\"><div \nng-messages=\"params.name.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Id channel</label>\n<input type=\"text\" id=\"pearl_nb_max_channel\" name=\"params[name]\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.paramspearl.pearl_id_channel\" value=\"Default\" aria-invalid=\"true\"><div ng-messages=\"params.name.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empProfilesGroupError.name && vm.params.name === vm.empProfilesGroupError.name.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empProfilesGroupError.name.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nombre de sources\n</label><input type=\"text\" name=\"params[name]\" ng-attr-name=\"name\" translate=\"\" \nng-model=\"vm.paramspearl.pearl_nbr_source\" value=\"Default\" aria-invalid=\"true\"></md-input-container></div><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label>Nombre de layouts</label><input type=\"text\" \nname=\"params[name]\" ng-attr-name=\"name\" translate=\"\" ng-model=\"vm.paramspearl.pearl_nbr_layout\" value=\"Default\" \naria-invalid=\"true\"></md-input-container></div></fieldset><md-dialog-actions layout=\"row\"><span flex></span><md-button \ntype=\"submit\" class=\"md-raised md-accent\" aria-label=\"form_validate\" ng-disabled=\"params.$invalid || params.$pristine\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">form_validate</md-button>\n<md-button class=\"md-accent\" ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">alert_close</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/media/lives/live/pearl/add.chapter.html","<md-dialog style=\"min-width: 50%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div\n class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span ng-if=\"add\" translate=\"MESSAGES.add_chapter\">chapter\n</span> <span ng-if=\"!add\" translate=\"MESSAGES.modify_chapter\">chapter</span></h2></div></md-toolbar><md-content><div \nlayout=\"row\" layout-align=\"space-around center\" class=\"addChapterContainer\"><div layout=\"column\" \nlayout-align=\"start center\" flex=\"30\"><md-input-container md-no-float class=\"md-block\" style=\"top:10px;width:30%\">\n<input ng-class=\"errorTime\" name=\"time\" ng-model=\"time\" placeholder=\"--:--:--\" ng-attr-data-duration=\"{{time}}\" \nui-mask=\"99:99:99\"></md-input-container></div><div layout=\"column\" layout-align=\"start none\" flex=\"70\">\n<md-input-container md-no-float class=\"md-block\" style=\"top:10px;width:90%\"><input ng-model=\"text\" placeholder=\"Text\">\n</md-input-container></div></div><div layout=\"row\" layout-align=\"start center\"><span ng-if=\"nullError\" \nstyle=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" translate=\"LIVEDIFFUSION.error_time_null\">null\n</span> <span ng-if=\"invalidForm\" style=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" \ntranslate=\"LIVEDIFFUSION.error_time_invalid\">invalid</span> <span ng-if=\"timeExist\" \nstyle=\"margin: 30px;margin-bottom: 5px;margin-top: 6px;color: #f44336\" translate=\"LIVEDIFFUSION.error_time_exist\">exist\n</span></div><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-warn\" ng-click=\"cancel()\" \ntranslate=\"MESSAGES.dialog_cancel\">Cancel</md-button><md-button class=\"md-raised md-primary\" ng-if=\"add\" \nng-click=\"confirmAdd()\" translate=\"MESSAGES.form_add\">Add</md-button><md-button class=\"md-raised md-primary\" \nng-if=\"!add\" ng-click=\"confirmModify()\" translate=\"MESSAGES.action_edit\">Modify</md-button></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/media/lives/live/pearl/add.slide.html","<md-dialog style=\"min-width: 30%;min-height: 20%\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar \nclass=\"md-accent\"><div class=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span ng-if=\"add\" \ntranslate=\"MESSAGES.add_slide\">Slide</span> <span ng-if=\"!add\" translate=\"MESSAGES.modify_slide\">Slide</span></h2>\n</div></md-toolbar><md-content><div layout=\"column\" ng-if=\"progress\" class=\"waitingSWF\" layout-align=\"center center\" \nstyle=\"margin: 20px\"><md-progress-circular md-mode=\"determinate\" md-diameter=\"96\" ng-value=\"progressBarValue\">\n</md-progress-circular><span style=\"position: absolute;font-size: large;color: #2d2d2d\">{{progressBarValue}}</span>\n</div><div layout=\"row\" layout-align=\"center center\"><div class=\"product-image-uploader\" \nflow-init=\"ngFlowImageOptions\" flow-name=\"ngFlowImage.flow\" flow-files-submitted=\"uploadFileImage()\" \nflow-file-added=\"fileImgAdded($file)\" flow-file-progress=\"fileProgress($file)\" \nflow-file-success=\"fileSuccess($file, $message)\" flow-complete=\"uploadComplete()\"><div class=\"upload-button\"><md-button\n flow-btn ng-if=\"!progress\" style=\"margin-top:20px\" class=\"md-list-item-content\"><md-icon \nmd-font-icon=\"icon-image-area\"></md-icon><span class=\"md-inline-list-icon-label\" \ntranslate=\"LIVEDIFFUSION.video_rich_media_slide_image\">Upload image</span></md-button></div></div></div></md-content>\n</md-dialog>");
$templateCache.put("app/main/media/lives/live/pearl/template.diffusion.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"content fullpage\" layout-align=\"center center\" style=\"height: 100%\"><div ng-show=\"vm.use_jitsi\" id=\"url_jitsi\" \nstyle=\"overflow: hidden;height: 100%\" layout=\"row\" layout-wrap><iframe id=\"iframe_jitsi\" ng-if=\"vm.use_jitsi\" \nallow=\"display-capture; geolocation; microphone; camera\" ng-src=\"{{vm.urlJitsi}}\" allowfullscreen frameborder=\"0\" \nstyle=\"width: 100%;height: 100%;overflow: hidden\"></iframe></div><div ng-if=\"!vm.use_jitsi\" class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap layout-align=\"center center\"><ms-widget layout=\"row\" flex-gt-md=\"100\" \nflex-gt-sm=\"100\" flex-gt-xs=\"100\" style=\"width:100%\"><ms-widget-front style=\"background-color:#212121\"><md-toolbar \nclass=\"md-hue-2 md-primary\" style=\"background-color:#303030\"><span translate=\"LIVEDIFFUSION.form_encoder\" \nstyle=\"margin: 20px;font-size: larger\">form_encoder</span></md-toolbar><md-content \nstyle=\"background-color:#424242;color:white\"><div layout=\"column\"><div layout=\"row\"><div flex=\"70\" layout=\"column\" \nlayout-align=\"none center\" id=\"content-live\" ng-if=\"!vm.errorPage\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"innerGlow\" style=\"display: block\"><md-button \nstyle=\"text-transform: none;background-color: #E53935\" ng-if=\"!vm.start\" class=\"md-raised md-primary button-end-glow\" \ntranslate=\"LIVEDIFFUSION.stop\" translate-attr-aria-label=\"LIVEDIFFUSION.stop\" aria-label=\"LIVEDIFFUSION.stop\" \nng-click=\"vm.recordingStart()\"></md-button><span class=\"counterInstant\" style=\"float: right\">{{vm.counter}}</span>\n</div><div style=\"height:670px;width: 100%\" class=\"waitingSWF\" ng-if=\"!vm.activated\" layout-align=\"center center\"><div \nng-if=\"!vm.showLoading && vm.start\" class=\"center_div\"><img \nsrc=\"data:image/svg+xml;base64,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\">\n<div class=\"form\"><div class=\"elements\"><label style=\"font-size: 14px; font-weight: 300\" \ntranslate=\"LIVEDIFFUSION.label_export_live\">Copier le lien et partager</label><div id=\"permalien_live\" class=\"fs-14\">\n{{vm.permalien_live}}</div><md-button class=\"btn md-icon-button\" ngclipboard data-clipboard-target=\"#permalien_live\" \naria-label=\"url_copy\" style=\"top: -8px;font-weight: 400\" ng-click=\"vm.copied =10\">\n{{ \'LIVEDIFFUSION.copy_btn\'|translate}}</md-button></div><div><md-button \nstyle=\"text-transform: none;padding: 10px 35px; border: none;background-color:rgb(67, 160, 71);margin-top: 20px; margin-bottom: 10px\" \nng-class=\"vm.recordClass\" class=\"md-raised md-primary\" translate=\"{{vm.translateStart}}\" \ntranslate-attr-aria-label=\"{{vm.translate}}\" aria-label=\"{{vm.translate}}\" ng-click=\"vm.recordingStart()\"></md-button>\n<span class=\"indication\" translate=\"LIVEDIFFUSION.label_start_live\">Cliquer pour commencer le direct</span></div></div>\n</div><md-progress-circular ng-disabled=\"!vm.showLoading\" style=\"margin: 0 auto\" md-diameter=\"96\">\n</md-progress-circular></div><div style=\"width: 100%;float: left;height: 100%;height: 670px\" ng-if=\"vm.activated\">\n<iframe width=\"100%\" height=\"{{vm.height_iframe}}\" ng-src=\"{{vm.url_live}}\" allowfullscreen frameborder=\"0\"></iframe>\n</div><div id=\"flashContent\"></div><div class=\"imageOnlyContainer\" ng-if=\"!vm.videoActivate\"><img \nsrc=\"app/swf/no-video.gif\" class=\"imgAudioOnly\"></div></div><div flex=\"70\" layout=\"column\" layout-align=\"none center\" \nng-if=\"vm.errorPage\"><div id=\"content-live-error\" style=\"height:722px;width: 100%\" layout-align=\"center center\"><div \nstyle=\"text-align: center\" class=\"error_content\"><md-icon md-font-icon=\"icon-alert-circle\" class=\"s200\"></md-icon><div \nclass=\"error_info\" translate=\"LIVEDIFFUSION.error_diffusion\">Une erreur est survenue lors de la diffusion</div><div \nclass=\"error_message\" translate=\"LIVEDIFFUSION.error_alert_diffusion\">Veuillez réessayer plus tard</div></div></div>\n</div><md-list class=\"innerGlow\" flex=\"30\" style=\"height: inherit\" md-scroll-y ng-class=\"{disabled : vm.errorPage}\">\n<md-list-item ng-if=\"vm.lives.isRm\" class=\"navigation-node\" ng-class=\"{clicked : vm.clickedChapter}\" \nng-click=\"vm.clickChapterListItem()\" layout=\"row\" layout-align=\"space-between center\" ng-disabled=\"vm.errorPage\" \nng-style=\"vm.errorPage && {\'opacity\':\'0.5\'}\"><span class=\"title\" translate=\"LIVEDIFFUSION.live_chapter\">Chapter</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"arrow-encoder\"></md-icon></md-list-item><md-list-item \nng-class=\"{show : vm.clickedChapter, hide : !vm.clickedChapter, scrolling: vm.chapters.length>3}\" class=\"rm-container\">\n<md-list class=\"rm-content\"><md-list-item layout=\"row\" layout-align=\"start center\" style=\"background-color:#43A047\" \nng-click=\"vm.addChapter()\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nstyle=\"margin-left: 0px;color:rgba(255,255,255,0.7)\"></md-icon><span class=\"title\" \ntranslate=\"LIVEDIFFUSION.add_chapter\">Chapter</span></md-list-item><md-list-item ng-repeat=\"chapter in vm.chapters\">\n<span class=\"rm-counter\">{{chapter.TimeCode}}</span><md-input-container md-no-float class=\"md-block\" \nstyle=\"top:10px;width:90%\"><input ng-model=\"chapter.Title\" placeholder=\"Title\" ng-readonly=\"chapter.Diffuse\" \nng-style=\"chapter.Diffuse && {\'border\':\'none\'}\"></md-input-container><a tooltips ng-if=\"!chapter.Diffuse\" \ntooltip-template=\"{{\'LIVEDIFFUSION.broadcast_slide\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Broadcast\" ng-click=\"vm.broadcastChapter(chapter)\"><md-icon \nmd-font-icon=\"icon-cast\"></md-icon></md-button></a><a tooltips ng-if=\"!chapter.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Modify\" ng-click=\"vm.modifyChapter(chapter)\"><md-icon \nmd-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips ng-if=\"!chapter.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"Delete\" ng-click=\"vm.confirmDeleteChapter(chapter)\"><md-icon \nmd-font-icon=\"icon-cancel\"></md-icon></md-button></a></md-list-item></md-list></md-list-item><md-list-item \nng-if=\"vm.lives.isRm\" class=\"navigation-node\" ng-class=\"{clicked : vm.clickedSlide}\" \nng-click=\"vm.clickSlideListItem()\" layout=\"row\" layout-align=\"space-between center\" ng-disabled=\"vm.errorPage\" \nng-style=\"vm.errorPage && {\'opacity\':\'0.5\'}\"><span class=\"title\" translate=\"LIVEDIFFUSION.live_slide\">Slide</span>\n<md-icon md-font-icon=\"icon-chevron-right\" class=\"arrow-encoder\"></md-icon></md-list-item><md-list-item \nng-class=\"{show : vm.clickedSlide, hide : !vm.clickedSlide, scrolling: vm.slides.length>3}\" class=\"rm-container\">\n<md-list class=\"rm-content\"><md-list-item layout=\"row\" layout-align=\"start center\" style=\"background-color:#43A047\" \nng-click=\"vm.addSlide()\"><md-icon md-font-icon=\"icon-plus-circle-outline\" \nstyle=\"margin-left: 0px;color:rgba(255,255,255,0.7)\"></md-icon><span class=\"title\" translate=\"LIVEDIFFUSION.add_slide\">\nSlide</span></md-list-item><md-list-item ng-repeat=\"slide in vm.slides\" layout=\"row\" layout-align=\"center center\"><div \nflex=\"30\"><span class=\"rm-counter\">{{slide.TimeCode}}</span></div><div layout=\"row\" flex=\"70\" \nlayout-align=\"start center\"><img src=\"{{slide.Name}}\" style=\"width: 20%;margin: 10px 5px 5px 5px\"><div \nlayout-align=\"end center\" style=\"position: absolute;right: 2px\"><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'LIVEDIFFUSION.broadcast_slide\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Broadcast\" ng-click=\"vm.broadcastSlide(slide)\">\n<md-icon md-font-icon=\"icon-cast\"></md-icon></md-button></a><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Modify\" ng-click=\"vm.modifySlide(slide)\">\n<md-icon md-font-icon=\"icon-border-color\"></md-icon></md-button></a><a tooltips ng-if=\"!slide.Diffuse\" \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" ng-if=\"!vm.slideBroadcasted(slide)\" aria-label=\"Delete\" ng-click=\"vm.confirmDeleteSlide(slide)\">\n<md-icon md-font-icon=\"icon-cancel\"></md-icon></md-button></a></div></div></md-list-item></md-list></md-list-item>\n</md-list></div></div></md-content></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/media/lives/live/views_add_edit_live/add_edit.template.html","<div id=\"e-commerce-product\" class=\"e-commerce-product page-layout simple fullwidth IE-add-theme add-edit-live-form\" \nlayout=\"column\"><div class=\"content fullpage\" layout=\"column\"><div layout=\"row\"><div \nclass=\"form-wrapper md-whiteframe-1dp\" flex=\"100\" flex-gt-xs=\"100\" flex-gt-md=\"100\"><div layout=\"column\" \nlayout-align=\"space-between\" flex class=\"add-edit-live-form__form-wrapper\"><form name=\"empLivesForm\" method=\"post\" \nnovalidate=\"novalidate\" ng-submit=\"empLivesForm.$valid && vm.submitAddLivesForm()\"><input type=\"hidden\" \nid=\"empLivesForm_thumbnail\" name=\"empLivesForm[thumbnail]\" ng-model=\"vm.empLivesForm.thumbnail\" aria-invalid=\"false\">\n<div layout=\"row\" layout-align=\"center center\" class=\"add-edit-live-form__buttons-wrapper\"><md-button \nclass=\"md-raised cancel-btn\" ng-click=\"vm.returnToList()\" aria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" \ntranslate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" \nng-mousedown=\"vm.submitTriggered()\" class=\"md-raised md-primary m-0\" aria-label=\"form_add\" \nng-disabled=\"empLivesForm.$invalid || empLivesForm.$pristine || (vm.empLivesForm.defaultConf==1 && !vm.hasDefault && !vm.empLivesConfForm.type)|| vm.uploadingInPogressf2 || vm.uploadingInPogressf || vm.uploadingInPogress\" \ntranslate=\"MESSAGES.form_add\" translate-attr-aria-label=\"MESSAGES.form_add\">Ajouter</md-button><md-button \nng-if=\"!vm.isNew\" type=\"submit\" ng-mousedown=\"vm.submitTriggered()\" class=\"md-raised md-primary m-0\" \naria-label=\"form_validate\" \nng-disabled=\"(empLivesForm.$invalid || empLivesForm.$pristine || vm.uploadingInPogressf2 || vm.uploadingInPogressf || vm.uploadingInPogress) && !$root.is_changed\" \ntranslate=\"MESSAGES.form_validate\" translate-attr-aria-label=\"MESSAGES.form_validate\">Ajouter</md-button></div>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"{{\'LIVESADD.form_title\'|translate}}\"><md-content\n class=\"md-padding ph-5\"><div layout=\"row\" class=\"pv-15\"><div flex-gt-sm=\"33\" flex=\"100\" class=\"pr-20\"><div \nclass=\"p-relative\"><md-input-container><label class=\"md-no-float\" translate=\"LIVESADD.form_attr_add_thumbnail\">\nAjouter une vignette</label><div ng-if=\"vm.urlVignette==\'\' && vm.lives.thumbnail==null\" class=\"thumbnail-wrapper\"><img \nsrc=\"data:image/jpeg;base64,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\" \nalt=\"\" class=\"brad-3\"></div><div ng-if=\"vm.urlVignette==\'\' && vm.lives.thumbnail\" class=\"thumbnail-wrapper\"><img \nng-src=\"{{vm.lives.thumbnail}}\" class=\"brad-3\"></div><div ng-if=\"vm.urlVignette\"><img ng-src=\"{{vm.urlVignette}}\" \nclass=\"brad-3\"></div></md-input-container><div id=\"file-uploader\" flow-init=\"vm.ngFlowOptions\" \nflow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.uploadFile()\" flow-file-added=\"vm.fileAdded($file)\" \nflow-file-progress=\"vm.uploadingInPogress = 1\" flow-file-success=\"vm.fileSuccess($file, $message)\" \nflow-complete=\"vm.uploadComplete()\"><div class=\"upload-button\" layout=\"row\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised md-icon-button\" aria-label=\"form_add_file\" \nng-disabled=\"vm.uploadingInPogress\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon \nmd-font-icon=\"icon-camera\"></md-icon></md-button><md-progress-circular style=\"margin-top: 3px\" \nng-if=\"vm.uploadingInPogress\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div></div></div></div>\n<div flex-gt-sm=\"66\" flex=\"100\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"LIVESADD.form_attr_title\" for=\"empLivesForm_title\">Titre</label><input type=\"text\" \nid=\"empLivesForm_title\" name=\"empLivesForm[title]\" required=\"required\" ng-attr-name=\"title\" \nng-model=\"vm.empLivesForm.title\" aria-invalid=\"true\" placeholder=\"{{\'LIVESADD.form_attr_title\' | translate}}\"><div \nng-messages=\"empLivesForm.title.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div \nng-if=\"vm.empLivesError.title && vm.empLivesForm.title === vm.empLivesError.title.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.title.message}}\" class=\"validation_api\"></div></div></md-input-container>\n</div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label class=\"md-no-float\" \ntranslate=\"LIVESADD.form_attr_description\" for=\"empLivesForm_description\">Description</label><div \nclass=\"md-resize-wrapper\"><textarea placeholder=\"{{\'LIVESADD.form_attr_description\' | translate}}\" \nid=\"empLivesForm_description\" name=\"empLivesForm[description]\" required=\"required\" ng-attr-name=\"description\" \nng-model=\"vm.empLivesForm.description\" rows=\"5\" aria-invalid=\"true\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"empLivesForm.description.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empLivesError.description && vm.empLivesForm.description === vm.empLivesError.description.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.description.message}}\" class=\"validation_api\"></div></div>\n</md-input-container></div></div></div><div layout=\"row\"><div flex=\"50\"><div layout=\"column\" layout-gt-xs=\"row\" \nclass=\"date-container\"><md-input-container flex><label class=\"md-no-float\" translate=\"MESSAGES.start_date\">start_date\n</label><md-datepicker required ng-model=\"vm.empLivesForm.mdTime.date\" ng-change=\"vm.changeDate()\" ng-attr-name=\"date\" \nmd-min-date=\"vm.minDate\" md-open-on-focus></md-datepicker><div ng-messages=\"empLivesForm.date.$error\" role=\"alert\"><div\n ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"valid\" \ntranslate=\"MESSAGES.date_valid\">date_valid</div><div ng-message=\"mindate\" translate=\"MESSAGES.date_min\">date_min</div>\n<div ng-if=\"vm.empLivesError.date && vm.empLivesForm.date === vm.empLivesError.date.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.date.message}}\" class=\"validation_api\"></div></div></md-input-container>\n</div></div><div flex=\"25\" class=\"pl-20\"><div layout=\"column\" class=\"time-container\"><md-input-container flex><label \nclass=\"md-no-float md-required\" translate=\"MESSAGES.start_time\">start_time</label><mdp-time-picker \nng-change=\"vm.changeTime()\" ng-model=\"vm.empLivesForm.mdTime.time\" ng-attr-name=\"time\" mdp-format=\"HH:mm:ss\" \nmdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" required><div \nng-messages=\"empLivesForm.time.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.time_format\">time_format</div><div \nng-if=\"vm.empLivesError.time && vm.empLivesForm.time === vm.empLivesError.time.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.time.message}}\" class=\"validation_api\"></div></div></mdp-time-picker>\n</md-input-container></div></div><div flex=\"25\" class=\"pl-20\"><div layout=\"column\" class=\"time-container\">\n<md-input-container flex><label class=\"md-no-float md-required\" translate=\"LIVESADD.end_time\">end_time</label>\n<mdp-time-picker ng-change=\"vm.changeEndtime()\" ng-model=\"vm.empLivesForm.endtime\" ng-attr-name=\"endtime\" \nmdp-format=\"HH:mm:ss\" mdp-auto-switch=\"false\" mdp-ampm=\"true\" mdp-clear-on-cancel=\"false\" required><div \nng-messages=\"empLivesForm.endtime.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div ng-message=\"format\" translate=\"MESSAGES.time_format\">\ntime_format</div><div \nng-if=\"vm.empLivesError.endtime && vm.empLivesForm.endtime === vm.empLivesError.endtime.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.endtime.message}}\" class=\"validation_api\"></div></div></mdp-time-picker>\n</md-input-container></div></div></div><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex \nclass=\"chips-container\"><label class=\"md-no-float\">Tags</label><md-chips id=\"empLivesForm_tags\" \nname=\"empLivesForm[tags]\" ng-model=\"vm.empLivesForm.tags\" md-removable=\"1\" aria-hidden=\"true\" tabindex=\"-1\" \naria-invalid=\"false\" placeholder=\"{{ \'VIDEOADD.form_attr_keyword\' | translate }}\" secondary-placeholder=\"+Tag\">\n</md-chips></md-input-container></div></md-content></md-tab><md-tab \nlabel=\"{{\'LIVESADD.form_attr_settings\'|translate}}\" ng-if=\"vm.permission.lives_tab_settings\"><md-content \nclass=\"md-padding ph-15 pv-30\"><div layout=\"column\" layout-gt-sm=\"row\" class=\"inline-radio\"><md-input-container flex \nhas-permission=\"lives_type_no_api\"><label class=\"md-no-float\" translate=\"LIVESADD.form_attr_type\">Type du direct\n</label><md-radio-group ng-model=\"vm.empLivesForm.isCdn\" layout=\"row\" flex><md-radio-button value=\"1\"><label>Internet\n</label></md-radio-button><md-radio-button value=\"0\"><label>Intranet</label></md-radio-button></md-radio-group>\n</md-input-container></div><div layout=\"row\" flex layout-wrap><div flex=\"30\" has-permission=\"lives_private_no_api\">\n<md-checkbox ng-model=\"vm.empLivesForm.private\"><label translate=\"LIVESADD.form_attr_private\">Video privée</label>\n</md-checkbox></div><div flex=\"30\" has-permission=\"lives_active_no_api\"><md-checkbox ng-model=\"vm.empLivesForm.active\">\n<label translate=\"LIVESADD.form_attr_active\">Video Activée</label></md-checkbox><div \nng-messages=\"empLivesForm.active.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div></div></div><div flex=\"30\" has-permission=\"lives_autopub_no_api\"><md-checkbox \nng-model=\"vm.empLivesForm.autoPub\"><label translate=\"LIVESADD.form_attr_autoPub\">Publier automatique</label>\n</md-checkbox><div ng-messages=\"empLivesForm.autoPub.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></div></div><md-input-container class=\"inline-radio\" \nflex><label class=\"md-no-float\">Type du diffusion</label><md-radio-group ng-model=\"vm.empLivesForm.diffusion\" \nlayout=\"row\" flex><md-radio-button value=\"screenShare\" has-permission=\"lives_screen_share_no_api\"><label \ntranslate=\"LIVESADD.form_attr_screenShare\">Partage d\'écran</label></md-radio-button><md-radio-button value=\"webinar\" \nhas-permission=\"lives_webinar_no_api\"><label>Webinar</label></md-radio-button><md-radio-button value=\"isPearl\" \nhas-permission=\"lives_encoder_no_api\"><label translate=\"LIVESADD.form_attr_is_pearl\">Utilise encodeur Peal</label>\n</md-radio-button></md-radio-group></md-input-container><div layout=\"row\" flex layout-wrap \nng-if=\"vm.empLivesForm.diffusion ===\'screenShare\'\"><md-card-content flex><md-select class=\"m-0 mb-20 pr-30\" \nng-model=\"vm.empLivesForm.screenType\" required=\"required\" aria-label=\"a\" \nplaceholder=\"{{ \'LIVESADD.form_screenShare\'|translate}}\"><md-option value=\"pip\">Picture in Picture PIP</md-option>\n<md-option value=\"sbs\">Side by Side</md-option></md-select><div ng-messages=\"empLivesForm.screenType.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empLivesError.screenType && vm.empLivesForm.screenType === vm.empLivesError.screenType.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.screenType.message}}\" class=\"validation_api\"></div></div></md-card-content>\n</div><div flex=\"30\" has-permission=\"lives_rich_media_no_api\"><md-checkbox ng-model=\"vm.empLivesForm.isRm\"><label \ntranslate=\"LIVESADD.form_attr_is_rm\">rich-media</label></md-checkbox><div ng-messages=\"empLivesForm.isRm.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></div><div \nclass=\"ie-exception-1 rich_media_live\" layout=\" row \" layout-wrap ng-if=\"vm.empLivesForm.isRm\"><div \nclass=\"content fullpage brad-5 md-whiteframe-2dp ph-10\" flex><md-tabs id=\"tab-rm\" md-dynamic-height md-border-bottom \nmd-selected=\"$root.index\" \nng-class=\"{\'extended\': (vm.empLivesForm.chapters.length <= 5 && vm.currentTab==\'chapter\') ||\n                          (vm.empLivesForm.questions.length <= 5 && vm.currentTab==\'survey\')}\">\n<md-tab md-on-select=\"vm.selectTab(\'chapter\')\"><md-tab-label><span style=\"text-transform: none\" \ntranslate=\"MESSAGES.chapter_tooltip\">chapter_tooltip</span></md-tab-label><md-tab-body><md-content class=\"md-padding\">\n<div class=\"content_rm\"><div style=\"border-bottom: 1px solid #ededed;width: 100%;padding-top: 0\" \ndir-paginate=\"chapter in vm.empLivesForm.chapters | itemsPerPage: 5\" pagination-id=\"chapter_pag\" class=\"pt-20\" \nlayout=\"column\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\" id=\"chapter-{{chapter.id}}\"><span>\n{{chapter.title}}</span><div layout-align=\"center center\" layout=\"row\" class=\"ml-20\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 edit-button md-icon-button\" ng-click=\"vm.editChapter(chapter)\" aria-label=\"action_edit\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteChapter(chapter)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></div></div><dir-pagination-controls ng-if=\"vm.empLivesForm.chapters.length>5\" \npagination-id=\"chapter_pag\" template-url=\"app/main/media/lives/live/views_add_edit_live/pagination.html\" \nclass=\"paginationDir\" boundary-links=\"false\"></dir-pagination-controls><div \nng-if=\"vm.empLivesForm.chapters.length ==0\" class=\"nothing_rm\">\n{{\'MESSAGES.none\'|translate}} {{\'MESSAGES.chapter_tooltip\'|translate}}</div></div></md-content></md-tab-body></md-tab>\n<md-tab md-on-select=\"vm.selectTab(\'survey\')\"><md-tab-label><span style=\"text-transform: none\" \ntranslate=\"MESSAGES.question_tooltip\">question_tooltip</span></md-tab-label><md-tab-body><md-content><div \nclass=\"content_rm\"><div style=\"border-bottom: 1px solid #ededed;width: 100%;padding-top: 0\" \ndir-paginate=\"question in vm.empLivesForm.questions | itemsPerPage: 5\" pagination-id=\"question_pag\" class=\"pt-20\" \nlayout=\"column\" layout-gt-xs=\"row\" flex layout-align=\"space-between center\" id=\"question-{{question.id}}\"><span>\n{{question.question}}</span><div layout-align=\"center center\" layout=\"row\" class=\"ml-20\"><a tooltips \ntooltip-template=\"{{\'MESSAGES.action_edit\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\"><md-button \nclass=\"m16 edit-button md-icon-button\" ng-click=\"vm.editQuestion(question)\" aria-label=\"action_edit\" translate \ntranslate-attr-aria-label=\"MESSAGES.action_edit\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button>\n</a><a tooltips tooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" tooltip-side=\"left\" tooltip-speed=\"fast\">\n<md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteQuestion(question)\" aria-label=\"action_delete\" \ntranslate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button></a></div></div><dir-pagination-controls ng-if=\"vm.empLivesForm.questions.length>5\" \npagination-id=\"question_pag\" template-url=\"app/main/media/lives/live/views_add_edit_live/pagination.html\" \nclass=\"paginationDir\" boundary-links=\"false\"></dir-pagination-controls><div \nng-if=\"vm.empLivesForm.questions.length ==0\" class=\"nothing_rm\">\n{{\'MESSAGES.nonef\'|translate}} {{\'MESSAGES.question_tooltip\'|translate}}</div></div></md-content></md-tab-body>\n</md-tab><md-tab md-on-select=\"vm.selectTab(\'slide\')\"><md-tab-label><span style=\"text-transform: none\" \ntranslate=\"MESSAGES.slide_tooltip\">slide_tooltip</span></md-tab-label><md-tab-body><md-content class=\"md-padding\"><div \nclass=\"slides_live content_rm\" layout-wrap layout=\"row\"><div \nstyle=\"position: relative;padding-right: 15px;padding-bottom: 15px\" \ndir-paginate=\"(key,item) in vm.slidesChips | itemsPerPage: 8\" pagination-id=\"slide_pag\" layout=\"column\" \nclass=\"slide_chip\"><div class=\"icon_slide\"><md-icon md-font-icon=\"icon-video\" class=\"sb22\" \nng-if=\"vm.slidesTypes[key]==\'Video\'\"></md-icon><md-icon md-font-icon=\"icon-picture\" class=\"sb22\" \nng-if=\"vm.slidesTypes[key]==\'Image\'\"></md-icon></div><md-menu md-offset=\"0 -7\" class=\"more_detail_slide\"><md-button \nstyle=\"position: absolute;right: 7px;top: -5px\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\"><md-icon md-font-icon=\"icon-dots-vertical\" \nstyle=\"color: #fff;text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5)\" class=\"s18\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"vm.selectSlide(item)\" aria-label=\"btn_preview\" translate \ntranslate-attr-aria-label=\"MESSAGES.btn_preview\"><md-icon md-font-icon=\"icon-picture\" class=\"sb24\" \nng-if=\"vm.slidesTypes[key]==\'Image\'\"></md-icon><md-icon md-font-icon=\"icon-video\" class=\"sb24\" \nng-if=\"vm.slidesTypes[key]==\'Video\'\"></md-icon><any>{{\"MESSAGES.btn_preview\"|translate}}</any></md-button>\n</md-menu-item><md-menu-item ng-if=\"vm.slidesTypes[key]==\'Video\'\"><md-button ng-if=\"vm.slidesLoop[key]==0\" \nng-click=\"vm.loopSlideChip(item,1)\"><md-icon md-font-icon=\"icon-repeat\"></md-icon><any>\n{{\"MESSAGES.form_attr_loop\"|translate}}</any></md-button><md-button ng-if=\"vm.slidesLoop[key]==1\" \nng-click=\"vm.loopSlideChip(item,0)\"><md-icon md-font-icon=\"icon-repeat-off\"></md-icon><any>\n{{\"MESSAGES.form_attr_unique\"|translate}}</any></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deleteAddedSlideChip(item)\"><md-icon md-font-icon=\"icon-delete\"></md-icon><any>\n{{\"MESSAGES.delete_video\"|translate}}</any></md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"slide_live\" style=\"background: url(\'{{vm.vignetteSlidesUrl[key]}}\')\"></div></div><dir-pagination-controls \nng-if=\"vm.slidesChips.length>8\" pagination-id=\"slide_pag\" \ntemplate-url=\"app/main/media/lives/live/views_add_edit_live/pagination.html\" class=\"paginationDir\" \nboundary-links=\"false\"></dir-pagination-controls><div ng-if=\"vm.slidesChips.length ==0\" class=\"nothing_rm\">\n{{\'MESSAGES.nonef\'|translate}} {{\'MESSAGES.slide_tooltip\'|translate}}</div></div></md-content></md-tab-body></md-tab>\n</md-tabs><div class=\"add_rm_btn\" ng-class=\"{\'slides\': vm.currentTab==\'slide\'}\"><a \nng-if=\"vm.currentTab==\'chapter\' || vm.currentTab==\'survey\'\" tooltip-side=\"left\" tooltip-speed=\"fast\" \nng-click=\"vm.addInteract()\"><md-button style=\"padding: 0 !important\" class=\"m16 add-button md-icon-button\" \naria-label=\"add_chapter\" translate translate-attr-aria-label=\"{{vm.tooltip_name}}\"><md-icon md-font-icon=\"icon-plus\" \nstyle=\"font-size: 18px!important\" class=\"s30\"></md-icon></md-button><span \nng-if=\"vm.currentTab==\'chapter\' || vm.currentTab==\'survey\'\">{{vm.tooltip_name|translate}}</span> </a><a tooltips \ntooltip-template=\"{{vm.tooltip_name|translate}}\" ng-if=\"vm.currentTab==\'slide\'\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-menu md-offset=\"0 -7\"><md-button class=\"m16 add-button md-icon-button\" \nng-click=\"vm.openMenu($mdOpenMenu, $event)\" aria-label=\"add_slides\" translate \ntranslate-attr-aria-label=\"MESSAGES.add_slides\"><md-icon md-font-icon=\"icon-plus\" style=\"font-size: 18px!important\" \nclass=\"s30\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"vm.addSlide(\'Image\')\" \naria-label=\"add_slides_image\" translate translate-attr-aria-label=\"MESSAGES.add_slides_image\"><md-icon \nmd-font-icon=\"icon-picture\" class=\"sb24\"></md-icon><any>{{\"MESSAGES.add_slides_image\"|translate}}</any></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.addSlide(\'Video\')\"><md-icon md-font-icon=\"icon-video\"></md-icon>\n<any>{{\"MESSAGES.add_slides_video\"|translate}}</any></md-button></md-menu-item></md-menu-content></md-menu></a></div>\n</div></div><div layout=\"column\" layout-gt-sm=\"row\" has-permission=\"lives_associate_files_no_api\"><md-checkbox \nng-model=\"vm.joinFile\"><label translate=\"MESSAGES.join_files\">Joindre des fichiers</label></md-checkbox></div><div \nclass=\"md-padding\" layout-wrap layout=\"row\"><div style=\"position: relative\" ng-repeat=\"(key,item) in vm.filesChips\" \nlayout=\"column\"><md-button style=\"position: absolute;left: 97px;top: -13px\" class=\"md-icon-button\" aria-label=\"More\" \nng-click=\"vm.deleteAddedChip(item)\"><svg aria-hidden=\"true\" class=\"UppyIcon\" width=\"20\" height=\"30\" \nviewBox=\"0 0 60 60\" xmlns=\"https://www.w3.org/2000/svg\"><path stroke=\"#FFF\" stroke-width=\"1\" fill-rule=\"nonzero\" \nvector-effect=\"non-scaling-stroke\" d=\"M30 1C14 1 1 14 1 30s13 29 29 29 29-13 29-29S46 1 30 1z\"></path><path \nfill=\"#FFF\" vector-effect=\"non-scaling-stroke\" \nd=\"M42 39.667L39.667 42 30 32.333 20.333 42 18 39.667 27.667 30 18 20.333 20.333 18 30 27.667 39.667 18 42 20.333 32.333 30z\">\n</path></svg></md-button><md-card title=\"{{item}}\" id=\"mdcard\" ng-click=\"vm.selectChip(item)\" \nstyle=\"background: #0000000a;; cursor: pointer;box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)!important;height: 97px\">\n<md-icon ng-if=\"vm.testExtension(item)===\'video\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-video\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'audio\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-music\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'excel\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-excel\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'word\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-word\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'image\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file-image\"></md-icon><md-icon ng-if=\"vm.testExtension(item)===\'pdf\'\" \nstyle=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" md-font-icon=\"icon-file-pdf\"></md-icon><md-icon \nng-if=\"vm.testExtension(item)===\'other\'\" style=\"font-size: 50px;margin-left: 35px;margin-top: 22px\" \nmd-font-icon=\"icon-file\"></md-icon><md-card-actions style=\"height: 30px\" layout=\"row\" layout-align=\"start center\"><div \nstyle=\"text-align: center\" layout=\"column\" class=\"title\" layout-align=\"start center\" flex><span title=\"{{item}}\" \nstyle=\"font-size: 0.75em;width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;font-weight: 600\" \nclass=\"name\">{{item}}</span></div></md-card-actions></md-card></div></div><div ng-if=\"vm.joinFile\" \nclass=\"e-commerce-product\"><div layout-padding layout-margin class=\"product-detail-form-container dnd-file-upload\"><div\n class=\"product-image-uploader\" flow-init=\"vm.ngFlowOptionsFile\" flow-name=\"vm.ngFlowFile.flow\" \nflow-files-submitted=\"vm.uploadFilef()\" flow-file-added=\"vm.filefAdded($file)\" \nflow-file-progress=\"vm.filefProgress($file)\" flow-file-success=\"vm.filefSuccess($file, $message)\" \nflow-complete=\"vm.uploadfComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" \nng-class=\"{\'dropping\':vm.dropping}\"><div class=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span \ntranslate=\"MESSAGES.drop_to_upload\">drop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-icon style=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" \nmd-font-icon=\"icon-cloud-upload\" class=\"s24\"></md-icon><md-button style=\"margin-top: 15px\" flow-btn \nng-disabled=\"vm.inProgressf\"><span style=\"font-size: 16px; color:#b0b0b0\" translate=\"VIDEOADD.upload_files\">\nchoose_a_file</span></md-button><md-button class=\"md-warn md-flat\" translate=\"MESSAGES.form_cancel\" \nng-click=\"vm.cancelUploadf()\" ng-if=\"vm.inProgressf\">form_cancel</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressf\"><div><p class=\"secondary-text mt-8 text-center\">\n<strong>{{vm.videoFilePre.name}}</strong></p><p class=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValue\">\n<strong>{{vm.roundWithPrecision(vm.progressBarValue,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressf\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></div><div style=\"margin-top: 20px\" \nhas-permission=\"lives_associate_users_no_api\"><div layout=\"column\" layout-gt-xs=\"row\" class=\"pr-15\" flex>\n<md-card-content flex><md-input-container class=\"md-block\"><label translate=\"MESSAGES.form_attr_contributors\" \nclass=\"md-no-float\" for=\"empLivesForm_contributors\">Contributor</label><md-select translate \ntranslate=\"MESSAGES.form_attr_contributor\" name=\"empLivesForm[contributors][]\" id=\"empLivesForm_contributors\" \nng-model=\"vm.empLivesForm.contributors\" multiple=\"1\" ng-attr-name=\"contributors\"><md-option \nng-repeat=\"contributor in vm.contributors track by contributor.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"contributor.val\"><span ng-attr-translate=\"{{contributor.val==0 ? \'MESSAGES.none\':\'\'}}\">\n{{ contributor.option }}</span></md-option></md-select></md-input-container></md-card-content></div></div></md-content>\n</md-tab><md-tab label=\"{{\'LIVESADD.form_attr_fo\'|translate}}\" ng-if=\"vm.permission.lives_tab_fo_settings\"><md-content \nclass=\"md-padding ph-15 pv-30\"><div layout=\"row\" flex layout-wrap layout=\"column\"><md-input-container flex \nclass=\"inline-checkbox\"><label class=\"md-no-float\" \nhas-permission=\"lives_fo_like_no_api,lives_fo_chat_no_api,lives_social_media_no_api,lives_fo_files_share_no_api,lives_password_security_no_api,lives_fo_subscript_no_api,lives_fo_sondage_no_api,lives_fo_comment_no_api\">\nOptions</label><div flex layout=\"row\" layout-wrap><div flex=\"25\" has-permission=\"lives_fo_like_no_api\"><md-checkbox \nng-model=\"vm.empLivesForm.foLike\"><label translate=\"LIVESADD.form_attr_foLike\">Aimer</label></md-checkbox></div><div \nflex=\"25\" has-permission=\"lives_fo_chat_no_api\"><md-checkbox ng-model=\"vm.empLivesForm.chat\"><label>Chat</label>\n</md-checkbox></div><div flex=\"50\" has-permission=\"lives_social_media_no_api\" layout=\"column\"><md-checkbox \nng-model=\"vm.reseaux\"><label translate=\"LIVESADD.form_attr_socialMedia\">Réseaux sociaux</label></md-checkbox><div \nng-if=\"vm.reseaux !=\'\'\" flex class=\"mb-15 pl-30\"><div layout=\"row\" flex layout-align=\"center center\"><div flex=\"33\">\n<md-checkbox ng-model=\"vm.empLivesForm.foTwitter\"><label>Twitter</label></md-checkbox></div><div flex=\"33\"><md-checkbox\n ng-model=\"vm.empLivesForm.foFacebook\"><label>Facebook</label></md-checkbox></div><div flex=\"33\"><md-checkbox \nng-model=\"vm.empLivesForm.foWisembly\"><label>Wisembly</label></md-checkbox></div></div></div></div><div flex=\"25\" \nhas-permission=\"lives_fo_files_share_no_api\"><md-checkbox ng-model=\"vm.empLivesForm.foFilesShare\"><label \ntranslate=\"LIVESADD.form_attr_foFilesShare\">Documents partagés</label></md-checkbox></div><div flex=\"25\" \nhas-permission=\"lives_password_security_no_api\"><div flex layout=\"column\"><div flex><md-checkbox \nng-model=\"vm.password\"><label style=\"white-space: pre-wrap\" translate=\"LIVESADD.form_attr_passwordSecurity\">\nSécuriser live par mot de passe</label></md-checkbox></div><div ng-if=\"vm.password !=\'\'\"><div \nlayout-align=\"center center\"><md-input-container flex style=\"padding-left: 30px;margin-top: 2px\"><label \ntranslate=\"LIVESADD.password\" class=\"md-no-float f-400\" style=\"margin-bottom: 15px\">Mot de passe</label><input \ntype=\"text\" id=\"password\" required=\"required\" ng-attr-name=\"title\" translate=\"\" ng-model=\"vm.empLivesForm.pwd\" \naria-invalid=\"true\"></md-input-container></div></div></div></div><div flex=\"50\" \nhas-permission=\"lives_fo_subscript_no_api\"><div flex layout=\"column\"><div layout=\"column\" layout-gt-sm=\"row\">\n<md-checkbox ng-model=\"vm.empLivesForm.foSubscript\"><label translate=\"LIVESADD.form_attr_foSubscript\">\nInscription des abonnés</label></md-checkbox></div><div ng-if=\"vm.empLivesForm.foSubscript !=\'\'\" \nhas-permission=\"lives_fo_sondage_no_api\" layout=\"column\" class=\"pl-30 pr-50\" flex><div><md-checkbox class=\"mb-0\" \nng-model=\"vm.empLivesForm.foSondage\"><label class=\"f-400 md-container-ignore\" translate=\"LIVESADD.form_attr_foSondage\">\nSondage</label></md-checkbox></div><div ng-if=\"vm.empLivesForm.foSondage !=\'\'\"><md-card-content flex><md-select \nclass=\"mt-10\" ng-model=\"vm.empLivesForm.survey\" required=\"required\" aria-label=\"a\" \nplaceholder=\"{{ \'LIVESADD.form_attr_foSondage\'|translate}}\"><md-option value=\"\" translate=\"DASHBOARD.none\"></md-option>\n<md-option ng-repeat=\"sondage in vm.sondages track by sondage.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"sondage.val\" ng-attr-translate=\"{{sondage.val==0 ? \'MESSAGES.none\':\'\'}}\">{{sondage.option}}</md-option>\n</md-select><div ng-messages=\"empLivesForm.survey.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div><div \nng-if=\"vm.empLivesError.survey && vm.empLivesForm.survey === vm.empLivesError.survey.value_old\" \ntranslate=\"VALIDATIONS.{{vm.empLivesError.survey.message}}\" class=\"validation_api\"></div></div></md-card-content></div>\n</div></div></div><div flex=\"25\" has-permission=\"lives_fo_comment_no_api\"><div flex layout=\"column\"><md-checkbox \nng-model=\"vm.empLivesForm.foComment\"><label translate=\"LIVESADD.form_attr_foComment\">Envoi des commentaires</label>\n</md-checkbox><div has-permission=\"lives_fo_comment_confirmation_no_api\" ng-if=\"vm.empLivesForm.foComment !=\'\'\" \nclass=\"pl-30\"><md-checkbox ng-model=\"vm.empLivesForm.isCommentValidation\"><label class=\"f-400 md-container-ignore\" \ntranslate=\"LIVESADD.form_attr_isCommentValidation\">Avec validation</label></md-checkbox></div></div></div></div>\n</md-input-container></div><md-subheader has-permission=\"lives_conf_post_add\" class=\"md-no-sticky md-primary\"><h3 \ntranslate=\"LIVESADD.conf\">conf</h3></md-subheader><div class=\"inline-radio\" has-permission=\"lives_conf_post_add\">\n<md-input-container flex><md-radio-group ng-model=\"vm.empLivesForm.defaultConf\"><md-radio-button \nchecked=\"vm.empLivesForm.defaultConf?1:0==1\" value=\"1\" id=\"empLivesForm_defaultConf_0\" name=\"a\" ng-name=\"a\" \nclass=\"md-primary\"><label translate=\"LIVESADD.form_attr_default\">form_attr_default</label></md-radio-button>\n<md-radio-button ng-checked=\"vm.empLivesForm.defaultConf?0:1==0\" value=\"0\"><label \ntranslate=\"LIVESADD.form_attr_custom\">form_attr_custom</label></md-radio-button></md-radio-group></md-input-container>\n</div><div has-permission=\"lives_conf_post_add\" \nng-if=\"vm.empLivesForm.defaultConf==0 ||(vm.empLivesForm.defaultConf==1 && !vm.hasDefault)\"><h3 class=\"f-500\" \ntranslate=\"LIVESADD.custom_choice\"></h3><div layout=\"column\" layout-gt-sm=\"row\" \nhas-permission=\"lives_conf_configs_before_live\"><md-input-container flex><label \ntranslate=\"LIVESADD.form_attr_titleLive\" class=\"md-no-float\">Ajoutez un titre avant live</label><input type=\"text\" \nid=\"empLivesForm_conf_titleLive\" name=\"empLivesForm[conf][titleLive]\" ng-attr-name=\"titleLive\" \nng-model=\"vm.empLivesConfForm.titleLive\" aria-invalid=\"false\" \nplaceholder=\"{{\'LIVESADD.form_attr_titleLive\' | translate}}\"><div ng-messages=\"empLivesConfForm.conf.titleLive.$error\" \nrole=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div>\n</md-input-container></div><div layout=\"column\" layout-gt-sm=\"row\" has-permission=\"lives_conf_configs_before_live\">\n<md-input-container flex><label translate=\"LIVESADD.form_attr_descLive\" class=\"md-no-float\">Ajoutez un texte avant live\n</label><div class=\"md-resize-wrapper\"><textarea id=\"empLivesForm_conf_descLive\" name=\"empLivesForm[conf][descLive]\" \nng-attr-name=\"descLive\" ng-model=\"vm.empLivesConfForm.descLive\" rows=\"5\" aria-invalid=\"false\" \nplaceholder=\"{{\'LIVESADD.form_attr_descLive\' | translate}}\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div><div ng-messages=\"empLivesConfForm.conf.descLive.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></div></md-input-container>\n</div><md-subheader ng-if=\"vm.empLivesForm.defaultConf==1\" class=\"md-no-sticky md-primary\"><h4 \ntranslate=\"LIVESADD.default_conf\">default_conf</h4></md-subheader><div style=\"padding-top: 20px\" layout=\"column\" \nlayout-align=\" start\" class=\"ng-scope layout-column layout-align-start-start\"><md-radio-group \nng-model=\"vm.empLivesConfForm.type\" required=\"required\"><div><md-radio-button value=\"Message\"><label \ntranslate=\"LIVESADD.form_attr_Message\">form_attr_Message</label></md-radio-button><div \nng-if=\"vm.empLivesConfForm.type==\'Message\'\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container flex><label \nclass=\"md-no-float\" translate=\"LIVESADD.form_attr_message\">Message</label><div class=\"md-resize-wrapper\"><textarea \nid=\"empLivesForm_conf_message\" name=\"empLivesForm[conf][message]\" ng-attr-name=\"message\" required=\"required\" \nng-model=\"vm.empLivesConfForm.message\" rows=\"5\" aria-invalid=\"false\"></textarea><div class=\"md-resize-handle\" \nstyle=\"touch-action: pan-y\"></div></div><div ng-messages=\"empLivesConfForm.conf.message.$error\" role=\"alert\"><div \nng-message=\"required\" translate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div>\n</div></div><div><md-radio-button value=\"Video\"><label translate=\"LIVESADD.form_attr_Video\">form_attr_Video</label>\n</md-radio-button><md-card-content ng-if=\"vm.empLivesConfForm.type === \'Video\'\"><md-select ng-model=\"vm.vid\" \nmd-on-close=\"vm.clearSearchTerm()\" placeholder=\"Videos\" required=\"required\"><md-select-header \nclass=\"demo-select-header\"><input ng-model=\"vm.searchTerm\" type=\"search\" ng-keydown=\"$event.stopPropagation()\" \nplaceholder=\"Search\" translate translate-attr-placeholder=\"MESSAGES.search\" class=\"demo-header-searchbox md-text\">\n</md-select-header><md-option value=\"\" translate=\"MESSAGES.nonef\"></md-option><md-optgroup label=\"videos\"><md-option \nng-repeat=\"video in vm.videos| filter: vm.searchTerm track by video.val\" ng-attr-data-index=\"{{$index}}\" \nng-value=\"video.val\" ng-attr-translate=\"{{video.val==0 ? \'MESSAGES.none\':\'\'}}\">{{video.option}}</md-option>\n</md-optgroup></md-select></md-card-content></div><div><md-radio-button value=\"Image\"><label \ntranslate=\"LIVESADD.form_attr_Image\">form_attr_Image</label></md-radio-button><div \nng-if=\"vm.empLivesConfForm.type==\'Image\'\" style=\"position: relative;display: inline-block\"><div \nng-if=\"vm.urlVignette2==\'\' && vm.lives.conf.image==null\"><img \nsrc=\"data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wgARCAFEAkADAREAAhEBAxEB/8QAHgAAAgIDAQEBAQAAAAAAAAAAAgQBAwAFCQgGBwr/xAAcAQACAwEBAQEAAAAAAAAAAAAAAgEDBAYHBQj/2gAMAwEAAhADEAAAAPCfsfm72zM/tzPbMjurM7ooavoYtpudLGU2iFiFYFYEcFmtHqV61mtHCGFWrHBJFWEaEBHFQUIHgIQkYIXJMUwMDAkCDAIMEJggkQwIgiDdDFtIMWxkmQxJDAhAEequaKraKbVM96ea9PNpRy6E8ulDLpRzat/2HyHtmZ7bmf15HNWdzRQ1dQxbTc6m0EJAQjArAr1o1aPWs1K4KwKww9ayCuMMKEDioKEDwhgwhAQpIBBgTJJEpMuEGCkEiSBMEIYGKTqYtopEWNWUhCEEhCAK1VbU1WL03K57k82hPNoQy6EsupPLo1+XV9B2PyXtmV7bmd15XdOZzRS1dRdbVcy2C46YpC2ArVo9aNWr1q1asCuCSENWOKMKAjihCsJMK0QDBkEDQhJOBBGBIpBBMkSBOsgQhAQGyEQbrYKcJZMWTBMhCEEhCgK9Vc1VWL02q571M96ObSll0I5dSWTQjm07/sPkvbMr23O7ryu6c7d9DV1F1lVrqZGTERMKwo1aPWrVo9StWrVq8JNcNXDisjDCkxDDDQoKmRIw2QRBAYGBgSEwZJISJISBCkBOhARBspimLa1ZyGIbqYSJISpWrVpNNVtFNitF6ee9PLpSy6EMupHLpTyaN92PyntuR7Znd1ZXdOdq6lm6m6yqyQ3TIgVmIcEatbK1mtHrRq1atXFZBWCHFZFWFZGJhZGJhWiCIIDBoQyTIMCScEkmZiYiXWQICFICdDAxTZTEsmLGWwQmQ5ghZDAFHqQqrsoptWovTz3J5dKGXQll1a/LpTyaN/2Hyn92R7Vnd15m9Gdq6lm2m6ys2ggwUVkYcEetHrVq1etJrVq1cVatWCGFWFJiJhZGJGJxQYbImIIDIMmcIxSZMCZiYWZmSCCXQgIUwMUnWxlIS2VNosEsmCZCAxMCtXBSup16rVqLlM96ebSjl0IZdSOTShl0/Qdf8l/bke1ZndWdvRnaupYtqtZDZZCACHhJrV60srWa1etGrVgRxWa4cFmFYVkYkVmImFaIIhogiDAwMDAwMgmSRZCQJkkJAhDcMUiDdTZbBLBDCx0slTZCCWWVgQFHrRl6rVqLlM9yeXSjm0o5NKGTShl1fQ9f8l/bkd1ZndOdq/O1bUxbVYykLksICsir1I9avWjVq9asCtWjCsgrhDCsiswsxEjEwrRBkERMKYTgYGESRASEhIS6kEiEwQhAbhimKbqbJbEHKWOtghshyYwQgqQj1xNFVq9FylNyeXQjl0oZNSGTSjk0/R9f8h/Zkd1Z3NOdq6hi2q+yux0yJgIgrhwV667K1epGrVwVq4mtGhWrVhhhWYWRWYiYWRichogiDAwMQwMDJJCWjIWZJAgJ1IQmCEMDeCFsdDFtlTlbGQ2WxkIg2iRZAFetCpHXpvUotTzaUsulDJpQx6tfk0/Vdf8AIf1ZXNWZvRnZuoutqtZSZMARxgrVq1sqS2tHqVq1cEauJFWFJrhxWRWYWYiRWYhoUwBgxZwMJwMIwiQwJApMgl0kCFJwhCYsIIU3U3SwW0U2Wx1MSxkslSYkSQgmtWrRl6rVaLlM2hHNpQx6dfk16/Hp+16347urI5qzs3Z77qbbK5dJYhYCHrh6latXqS2pLKoYEYFauGBJFZrh4WYWRUiGhZiCCRVsgwMDFMDAwMCWghcAwwJdJAhScMQ2gxTZTlbHi0Q2WxkOVsdLBDaCFwJACakamu1Wm1XPoRy6EMmrX49evx6v0Tq/iOaczenPddRZbTL146hKhDhDUQ9SvUttVdtSvUrArAr1qwKCjAMKkK0LIrOQwrGE5AMNgZBgYGBkkiyGAQmMWBgE6SBim4TIYpupi2OtgtjLYyHKWiG6WNBCmETERNcTSli1VqlF6WXUhl0a/Fs12PV+udP8NnRnYvosuz5bUDoDpTJTDUxZSrLrbUttSWbTNpcpt+R00gjVq4LIRIw0LIrMK0Bv81r9T/H6aIJmDIMDAwBgkJDAl1kCCWQwwQnCFscIU2U5U2W0WxlN0N1tK7JSyxDIOVNlkIAEmqLF6rFab0c2hDJq1+PXrsev916H4bN9Fl1JW0V200uqzoowsOvDrRZQllC3bLNo7B+Ken/Db83JD1zz0EetWFZCJCJhWhZhSInpP5/1vsHlvvcUfWfP/g9eaAwiAknAwjAMICQl1kCZCCSCeDIIg3U2U5Q2LRLGQ3Wx0sEsdDaLRLCsnUicASK1deu1Wq5PPo1+TVr8mrXYdno37XxGb6DsrGyqm6lWxUXqRaUZdSHULF0soW7pp5T6D6n5Ho+MPtPmf5d9LICNXDikjE1w0KQrYoMT9Lmu7YeS9/8ACbM/GX1PgxkgJSZkyDHPrctu4pfQaKvm9FMgTrgb2lvq6blbEWdNzW+vuq+S25DdbCPuMV+wiUb6YZN1W1krZKmyGyafRm0GvJhIkAPQlitVydGhDNp1+LZr8er099L5LVtB2VhZWtZUnYmtsTWtGvZtfLpxapFn6t8P7HaDw71bln6rwXj3rue9Qct9/oZ551/FD2TzlUYUAARoQ7D+Vd35w+98vwJ2XN/vnxvpdq/KO95CemcT5S6H42BgYGBIdpfLO89EfF+pzP73kvAnZ8yQSBOvQrh+p6OcJ1nmLovi/lf0sPvHi+o/DPs/K4u+yeanMfTZ37p+G+sbmu3nf6Nw/pPmPvfvvwPtYGBgYHPz03zvw96HwZOQAJNMWK1XJ03o5tOvya9fk1eqNPzXbKrXrF0VsrQsXV2V6myNW5rJbXlisW9JPLPQvQ/Nfd4he3+X/TY9PcTw/wBQ8l9V8Llt6XxW1ovog1TKIRB704vpulvn/WcSvWuA/EPrfP7JeW91WRxw9P4bAwMCQwP6BfGPSvqabuOHp/C+Y+h+NIEEuvWjzPuPX/Mfd8D9ry/5Z9PD1L837b4Pbk4Te4eVmR7p4nqelPnHb/OX0cPPdvIu4HhXrn02fR447XkvjfoYiFJl8vdjyn5l9v5BBAgj0o61dylN6NGlHLp1+PX6sbE9ZUwyY9azrr3XU2pp7E09hqWnWzYktvbPwn13yb1vwOc/onHdA/Pew9ucT03Cr2zzTSuvU/zLtvQnwvqcsPR+N85/c+VgSjdsfJvQPzXfk5Kej8X7Z5XoOoHn/Wfz7ez+ba90wMDA+7yaO+fjvpGBwS9i83+C25MkKSZXuL5D6N+xfL38qvSuH/MfpYu0fkfoqxH8/PvXkcOvb3xT1D9T+bv8C99xvivuOS7neE+v4HDv3zxn5LfhtZLJQ2qN4IMZQWakdZblark6L0c2rXY9XqyujYPU2yG0UsmvsXT2JpLV0li6aw1k2FVo7yfnz2blL6v5/wCS+q+D2O8c9I/K/p4uXHpXGArdYvMO29hcr9+gjw72HPc1u85TR2J754vpOgnGdLwB9k82/cPk/R7f+Ud/wQ9g85/P9uWQwMD0x8H63ZbzDuvnrav59vavMskkgnh1D+gzxD1J6G4nev8AnH5r9HF358P9UIOEft/lX6z8vf2D8k9G0tlfD33TyT9k+P8AS68eP+mosnNP1TzspWyU8/dRznyH0MFjrjJgCrVFlFditdqlN6ObVrsmn1RkXa2VOytrLXMIWJp7F0NqaG5dI8aqX22bX3U8D9j5A+veceaej+R268T9P8h9V8Hnp3nKAj9YfMO39h8t97AwOd3bcxzi7rlvXfM/c62ea9n/ADxe1+Z/omLV3g8h9D4K+v8AnX5zuySGBIe9uO6TpxwfWef/ALHzOKnrHn5BLwRH6/8AM3dx/H/R6SP5/fcvK9XdV3h8T9Q+7x6uLvsXmnvrg+t9Ucz97w72/Jc2vTuE9z8J1vSDzXu8DAwMDjR7x4v+ZfY+TY6kxAgDVJZUrLV3J1XJZtWty6vU3z22717BkvlRmEXTT2r8/dX8/bGitTTs+V394/z97Lym9X8/8l9V8Lsf456P+VfSx8uPS+MBX6weX9t7D5b7qkr4G7TmudHccxrXX37xfSdAuL6X+f8A9l85/cPk7u33lHf8D/YfOfgdmXAwJDqp552Htnleg8SdZz/LH0TjJcIUmj11y/3OtXmXdfmW/Hwv9p8wIOw/k/oXpTn/ALPNT0XiekPnfaUTHEH3Lyn4j6OHp95b33sjjOp8udXzXivveOOVsZPw/o+fCxDlZaIFgatZpS1dLUqb0c2nX5tXqT5d25evZsjEqLKi6aa2vQXp87cmgsNO760bth4X615O63n+c3ofH9BvPux9s8T0vCv2zzXSudS/NOz/AH74X0+VXpPG/gf2PnQocT268l7/APLfoZOSPpHGe3OU+/074Dq/5+PZvN0LK5DAlztl5N337z8j6XMnv+Q8H9nzcusgQnRjg+s6FcN1nlfpPicjfVPPyc6X+c9n7p4rqPitWb7XLp8Z9jzHMP1LgTZOyni3qP7j8P6/OH0/z7xT33F2ytrJYQb1mRjGCYNUrUrYtXanTejn06/Lr9SfH07qyraMrUoDqhZXprqvn7q/nbl0FyaZrNaWdIfMu99E8z93iB7f5f8AU49XcPxD0/yX1PwuWfpnGbGi2gNeGQYh0D4rpujfCdTxO9Y4H8R+rh7JeX9uk0cefTuHwiSJcsiP6BvFPTd9Xb4N7Hmvxr63z5aK2Xx31vP9cfLO89W819zn53fJc6vQOQJo9rcZ0nUDzXucBWV4me3eV/mv1fn2sneb8/8Ase8pu8Q95xv5L9z4xyHMeder5n5jdjNlkjBRGqLKanVrtTp0I59Gvy6/Ufxdm8sp2rKy9YOmvtq0t9Xz91fz19egsjTu+ui39T+P9btB4l6jyw9U4Tx71vPequV6Do75z2HD32jznWyCgKzitiHXLzTtfPf2vm+Eex5z0H8P6faDyvveQHp3DeW+h+RkhC4R+j4tXd/xz0nAwMDA/Lfo4eG/tHmfcrxb039Q+ft5SeocF5G63niF/ffhfX7K+P8ApOB5N6znOVPq/ndjR+h4NncHwn1zAwMDAwOJ36D8Q+N+j845CIEUR6VehLFKrk6dCObTr8mv1F8PbvLadrYjD1VW16+6nSX0/P31aC5dHbGod0CxRbOnHlnf+o+U+9xc9o84/MvoZKhgVhRxQxTIMVsSZF+szXdrPJvQPzTfk46ep8HBGSZES59DRZ+0/K+gQpySRMx85qp/HfsfN9BfB+teH439j5mh0UkLs1f9z+J9Qpj8u+t875LdksF39Nn7J8f6ZupimyHMTK/hfT8+QhBgkDVw1K2L12qVXpZ70M+rX49fp74m3fWU7K6q6yum+jW3U6S+nQ6K9FdGmsNYzIliyPs6NHY/xj0r87+hk5GeucDWjhDQkxWxKREYoROIvS/gOw9X819riv6z578Vrz4GOTCSwUwYssFKzIUoUzMxMwUhTBETMELLwRBzBTBim6lKmyk62MpuljVmKZEiYFZZUrUJYtVenVelnvQy6tfi2emPka91bTsbajupWvp1mijTX1aS+vTXLqXlBrFEdeHrh9xnvbrt+O2U1owQ8VxNc4kSpkExEk7yl3Fb5rRmknHJIJghJcIJCXWQllIiSJYKYIg2UxSmCmDlSFloKYMU3WWgpU2U2Q3QhSeMQEmsalLF6rlKrk6L0s+nX5NWvx6vSXz9G0sqctpm6pW+nV6KdRfTqLl1lsIMKSy0PTD1DVI9ZIDVjV1sNTxXOJOQSoREwYRJEzEzBTBEFME0TMSwUxkhETME0TMEylMGynKlMFK2SpTBim62Shspiyyk6lME0FKkyYwJNaTUj013K13J03J59CObVr8elHHq9F1y+9V1lYXUqXVa2+vV3V662tFxRimZphqx64msauGrhq1etXrrYamFJhSFaYMCYiQkjJJImQpiZiZgiCaCmJmJmCaCZSeDmDZbJUmU5Wx1MSxksZLXS2UsauwQnWZJZZkmUGWria1emu1ZLVKLk6NCWfSjj0oZNKOPX+/XUNOhvXXbWpbUlbWlaqdirstLRXIEyBIRIDVDBEjDArUK9dbVowqwpIrOJOBgTMTJMkyshMwUwUxJEtBMERMwbKTwTKbKcqbLYy2ylj13Mlgl1ldzV2MthWboUksCy5DVkVq9C2r12K03KUXpZ9COXSjk1JY9KWPV+268l7obrlla9qK2JS6UutbqLQMxEgk5MBLASZK4y6TSllalatWPWhWsgNCGBgSEyEGMhATJMhMEEspTBim8E8E62TBshutkpayXPVYLe1dj13PXYLY6HClMYAyANVE0LaulitdqdFyefQlm0pZNSOTQlj1JZNH6xqysOljpFiVNAPXW6g6C645LLjLMmMFIw0Iqy5NcMETUTXE1o4QBDiAxGEmyxMzBLKUwcwUwTQTKUwTQbQUrY8XXVCs2OpslrKYtrV2SlzJayWMtk12C2ykkYRESCtUTRFi1diqWqU3pUXpZ9KWTSjl0JY9KeTQnlv8A0u6lixLng3SXSXXHWXQ2UnQ2QrIdZWXXWyKyVzIBVMhE0k1RNRNcSBMTOEY0M31UU2Gy2OpspstrQdkE62SpOhtBspMttiv6s62dzdTFOYslLJWxkslTFOFKFmIyFknAWqtoSxWuxVLU6r06b0c+jX5dKOXQjkvSyalMt6mW/wCzlbmW10N0stQ3U7EseLbUN0udN9ZWLroiRlcaIaBkrmQAImsYFBYh5ggpjcfSxp5bgRjaLXW1ltdbHU7VN1sZLGSx4JosZCmPp/r/AC9Vg0rrZY0WSpshkWNWZEiFC4s4pCwCMKPLwpTchmuTruSqvQovQzadfk1IZr0smlLLcpm0K5rvtamYdL7FvdGGW2ytixLLUYuXa3V6xlbtrB0JlKxBZZaK3AlammoAZYYh4l0ssVi1YJYepiVZdGWRmamHrYlGHWyUtZLXQ2g5U2U3ViVz6CWZVKVKUJVmYkiFXACIrlqIehLFUsVW1VLVardfm0q12azLp12bTrcurXZNeuyaEMmhHLoTzXrZrtvRbayXMt7qdq3PXdYv2ltVFteumE7FtsU7VJll4xlyVhoGQSIkiYKYJoseLbI+0+18rQ/P2ySzYjNqNWoxcrF1TFlbDrdZXa6WWJa8G6nMWMpTG71YfofmZ/i9u8mUpjBcFFYhQIkEimt6KnWqZejQpRYrTchTautgw2mwa9Pg3a7Lp1+bQhkvTzXp0XLUWM4ddtqWWJa6XMmwtT7O6rTymlabLEtZbLEsdSdSsjGjGXJMYyQpiWix0uZbnr3+7L9Z9TB8l8j6jdlbl1bjq3oRu6pm5GbKr7a7bUvsS11sdbGU2U5WWW2Y/bPkc7+Kfc6AYiBcFiChUit61alCitlqXWz3K1XJ0Wp0XI02o570qLTltbl0/P8Az92vx3o5rkc96lNytFl+HWw8MMt91e2sqtsXWzGWLc9dzray22JY6m0G6k6y8ZKywTLY8W2Qw6OW1tum500NKj0JsnTY3JsLVevqcuV6xGbK2HRi1L7FsdLmg2UmCmImMk3FWXT/AEqoy3hEUxFRFClETQkqpKlUp02oU3I1OjVdr6bUaL9fnu11GnXU6U6rlaLNNg16zNehRoSotSz3p4dbLLsGROVeeL3Q7UsdCdLLFtZTsUmgnQmgmUmMlSYsmLWRh1adHrl3Git1l2dtWzevaXVbSyvZX17C6p6+t22puxGrK2HRhlvsrtFtgJlJYyCGg6yLs1JYpL0QtJK5CyStDJpKdbpVPr6rUabUKLkabUM96FN6FWjX0367NdrMujWZr9fnvUps1uXQnTcpi1BMVOmStsrY0WtFjqdtZstjpY0E0FMG6E0WMHK2sXMjMjjK68fQ6afodVFSPtba9vdTuL6dtor2uijY6kf00v31OW0tW0tWIxajAtioRExGRESC0VMbHJTvfiN+bdXaokp1yojIoyNTp12IU2oU2a+q1HNehmtSz2pU3o0aEKLkctqOa5Cm5Km5Kl1q7Fabk6bPmseilw5DasyLnSwCctaCtqteSis7El1ILgmVtcaab5rclX7o2JH6X9TAnVZaG5vTcX1bm+jcXU7XRTstNL+ul/RU9ejludq2tgW6uuxJkiSBlRaK3ihyl5/a/P8A5H4x2f1Pltd6SGvqsQrs16WIU262uxDO6FFqGaxLPoRquSz3o0WIZ7089qNNiVF6lVidNilN6dViyT//xAAoEAACAQIFBAIDAQEAAAAAAAABAgADBQQGBxARCBITIBQwFRcYFkD/2gAIAQEAAQIBSJEiRYkWCD7T/wBAgg2EEEEG49zGjRo0eNHjRIkSLEixYIIPsP8A1CCCCCCCCDcepjRo0aPGjx4kSJFiRYsEH2n6+fqGw9BBBBBBBuPUxo0aNHjRo8SJEiRYkWDYexPqfp5259OdxsNxBBsIIIIIIPUwwxo0aNHjR4kSJEixIsEHuZz6H6ed+eeed+dxuPQQQQbD2MMaNGjR48MSJEiRYkWCDfnbnnmcw+3O/Ppz6c7Dceggggg3EHqYY0aNHjR40SJEixYsX255552559OfXn6xsPoEEEHudmhjRo8YNHiBIkWLFgggnPpzzOf+Xn1G43EEEEEGw9TDGjRo8ePHiBAgUKFg9uZzzzzzsT9PPrzuPYeo2EEEG49DDGDxwwcNEVFRVACj3JnO3P08788888+o9hBsIIIIIIINhvwYQwYOHDhwlNKaIECgcex9OSfp5+4bCCCD0EEGw2HsYY0YOHDhwtJKS0wnZ28cbHc+/Prz9XOw9hBsIIIINxBB7kEMHDhw4WitFaQpePsKkGGNDvabPmHKv1WPL+ZMo/WNhuNh6CCCCCCCCD04hhDBgwcOHCURRFHxmmaZRgQY0O1qtWl+mnUY/wBHM6Ta+dMl52yd9Y2Gwggg2EEEEEEEEEEEHqQQwcMHDhKQpeI0jTam6OrBo0MM6eNN8x5h1Bz6fqy3mPTjPut2mrDn1teUP1vdsselpsn65xmRrXlL9dXDJoggmByV+vMfk615UGn36+Gn3+A/wFzy2PRoQwcOGCUxT8XjNNqbo6uGjRppXk6nT6iNQponpFmHSWvT9dHdMte9EZovqEj9ReR/bQK1zq1um4nSXbJ1F3TpOuc1swYgmXLJabZOprOmhls9ep657mGGOHDBgiKnYabU3SolRaiuHjTpjy1qRmqpUynlvL1h1+1e5tdnuNt36edYK1HWDIU6fM4dRGV/bLFsnUddJxBOmC2TqxufStc5nnBiCdL2UZf73fLzlu2zOvUL/VH9Tf1LqJnj0MaPGDhxTCqF7GR0qpUWoHjxpp1aOqi+mdK+V84Zju91M6WbfnjTvUrRLZW0Yzt1NZVnStfrngrjg/TIls2z/cxBsJpFa51S3PQm5ytRr0UXTTKc6nM6ZItu2crkINhBuYY0aMHDinECjtZaiVUrLWFQPMBh6adS2Nmg1r6p7xt0u7PT1O6bbxZZ0m3nN1rmiWOmoVL06dLXL/cid8HhcHhZrVc8t3LbPWD0EyhLrc805h6frbMUP5j/AJk/mXN2VB6GGGNHjxxSlOKO0rUWstdaoqh5lrbqG20nnVpv0u+nVjXnS9K0xc0v21I9ekq1zXa57cTSK1SpUu9wEyNc5rbg+nfKE6ms6CdK9t9dULiPYxo0ePKUpRBwRUFUVxWFWVJgK9N+pbAzQe59U1m26Xdq9fU/qVx9wnSbZc13OaJYGag1fTpTtc6q7nuJ0w2ualXQbdPdymrOS6FHGYzO+aBOmG2zXjPI14/e372rVvYxo0ePKMpRAARUFWVxWlWVI005u/VRYjOlfNGcMuXe1TpZuefNS9R9Y9kp6P5J6mM1zpWsF1x+PxU420Otc6srpxxxx0mWudSNz26UrlP8zOpPOsE0Wtk6oriIIIPcxo0ePKMpRNjKkqyvK8qypGnTHmXUfKtWnlDM1hvevukBlvumOx+/TvpBXr6v59mgGT+orNE42RLHbZq3ob/Kn8qP0sgdNVrnVhctuli5bVq2o+bxKa2W3TVPRb+ZP5l/mbM+XPUwxi8ePKEoxIIxqGsaxrGtKkaaV5xp1OonT2aIavXfUi4Yn10j1e121vmiuniJ1C543404tfrqddZpla51OXMQDQq5bdROdIJp7bPbOly9jGLFy5oGiUPczVGrNWas1UuWjTp41IzLl3P+RPqytlfT7I2uOpRPG9gvv9Bf0D/QP9Afv/MGr3FHXn9/X6+8AW3H/vz9+ZmzXwBYr3++f3wNd/3t+9f3mIPTklixYuXNBqTI/e9SpUqvWeq9RnLQyz3jTLUjqOo78+3SimeM7ZxzbOOJxxxxxwBBsBxxxwBwABxxxwNhBB6ckksWLFy7UHo1FqeVqtStWq1qtV3dmJJ5s1+zDm3fnbnYSz3y+Zm3EA9h7DbjgDjgDjicDYQenJLFmZmZ2dqT06greZ69WtVrVKjuzEk+3PPPPPPd3d4fu7u/v7+/u7u7nu7ueeeeQeeeQQeRBOONxuTzySWZnZmdnanUWr5TXeu9apWeozliT9XPPM57u7nu57u7u7u7vDd3d3d3d3Bu4HnkEEQQe/M55JZmZmdmZmdkrriPkHEPiGrNVNQv3dxbnknnYgw+/M5nPM55BnIIPIPoIIsWCLBBBB68mElizMzMzs7My1lr+fyNVNU1TU7+/u7u7nnnxsSfrE5525Gw2HqAAAAAABwIIB6HYlizMzM7OzMzOy1VqCqavdDO3t7PH2ePxphwjzx+Px+Ps7Ozt7eOFQr2dnZ4/GKfj8fjFPxin4RTFPxCl4xTFMUwgUIFA7eNjDGLFi7OzMzMzszLixjRjvn/AD/n/P8An/P+f8/8hhsQcXibp875ny/lfJ+R5zXNXyeTvDOAwPdyG7u7uDdwbu7ldqfd3hgQ3IM55555DcGEkkuWLl2csWJLFagqCoGDciABPGKVK3Yu5luOOOOOCOOOOO3tt2FqwJ4xTFIU/EKIoij4RRFHw+Gzpibd4BQ8AoeAUfF4vF4/H2FeO56TKwePHjloxcsSVxAxAxQxYxgxgxgxi42YTH/M+R8n5Pyvk/J+V8r5PyfkefzivSqUagqCotVaorLWFcVxX8/m83n83lpYjDp8n5AxHn8/m83m8vkLl2csxLmVA5cvHjxo0aGCqKwr+cVxiBicFZ6lepdBXFcYj5Hn+R5/N5fL5fJ39wYN+JqVVilSsBUiKQQQwYMG7g2AOZ7J5RU8nf5PL5fL5fI1U1GdmZmZqwp4qi8ePGjwxoGDAghqFDCtjbz3hgwYN3c88888wQAKqWnCZluS0kpJRSitBcOuHGHGGGHGG+MMMMN8b43xqdJ8U2E+P4PB4PD4jT8ZQoVZWDxwwJGIxNCorqwYOCBSGHXDfHoYJ6j0xhRhRhRhRhPifD+F8L4XwvhfC+ALettS1fisBbfwqZeTLSZYTK6ZWXKq5VXKoyquVRlUZVGVf8t/lv8AL/5f/MYDL9W0/wCZOWv83/nDl05dOXzl9rA1ieytZntD2lrW9se3PgDh3w1bDvQai9NkGMp4s1zivyqXcXb8sLsLuLuLx+Y/MC7/AJf8t+U/Ji4jHrj0xyY6jVw1wS6UrpTulO607sl2S7Jdku63cXhbwLwLz+Z/M/mvzP5r/QYbEYi7m9/mzfDfGvpvrXxr216e9NeHvD3d7s10a5PcWx74ytX8tUszlsOlQ1hU7xUWoKgqB/ItQVPJ5RUD+RXV1ZTTNtwmGWkKa0lpLTWmKYpxIkUKFCzjbnkky143/Kmo1RqjVGqtVao9V6r1HqM7M7Mzs5YuWjDkipTLgjYQERduVI25DCcqViRYkpixLjDRFFaK0lpJTVFRUVUVEQIqdvHb29hTtKZUr37DMHDhw4cNHjR40aPGjR40aNDGjQn/xABiEAAABAIDBg0LDgkLBQEAAAABAgMEAAUGERIQEyFRU5EHFCIxQVJUVWGSk5TRFSAyQlZxgaHT4eIjJDAzQGJyc4KVoqSxwRYlNENQY7LD0hcnNURFYGZ1g7PCZHCl4/CA/9oACAEBAAM/Af8Autg/TmD+5Ov/ANkMH/6Dms+ellsmYLvHKnYpoktD/wDcMUjoquVtSGTuWJzhWS+lwH7w6w+xzqkz8srkMtXfOjYb2kWvBjHEHfiktEHJWdJJM4YKKBaJfAwHDgMGAf0dweyTCeTJvKJW2Mu6dHBNJMuyMSzQ6koIEsLTJwUBeOtsO1LiKESYuhw4LMrGmTLp6Rr7K+WsNXya/Y5N1LnbcLHVa/lOfbihZCz4LVqJLTuRLSKdI1kPhSVDs0VNg5Ym1BKQuKPzcmrSGtJUA1Kyewcv6ZLI5T+GU1Q9fzEnrYDfmUOk32RLKKyV1PZuve2zUlow7Jh2ChwjE20QZ6pN5icSolrK1bV6lBPEHDjH2ObUUnLeeyR0ZB02NWUQ1jBslENkB2YlmiJRpGeMaiLB6m6b14UVdkO9ihOn9FjqMkQ6sS0BWZm2T7ZLw/bAkESHAQEMAgPX0tnjbTslovN37e0JL61ZKKktBsVlAQjRD7g6RfNa/wDDFJJARNSe0emctKqIlTM7aHRAwhitAFfWzqermayOUPZisQtsybRA6pgLjECgODCEaIXcHSL5rX/himsuaqPphQ+dtW6IWlFlpeqQhAxiIlqCKVzttp2S0Ymz9vaEl9aslFSWsVZQEI0Qe4SkPzWv/DFLpQ0M/m1FZwybEqAyzhiqmQK9asxi1dZTKZNSPpdRKcumyuFNZBgqch+8IBUMU/7hqQfNi38MUulLU7+a0Wm7NsnVbWXYqJkLWNQVmEKteKUzltpuUUamr5C1YvrZmoqS1irKFUU+7h5/82rfwxT3uIn/AM2rfwxTzuIn/wA2rfwxTzuJn/zat/DFPO4mffNq38MUhkiZFp1IZiwIoNkhnLU6QGHEFoA9zjTembKUnJ60TG/ux/VF2PDgDwwRFMqSRQKQgWSlDYCD0ipENFZcv+LpQeyrVrKuO24utnuHp8/GcTkhySNmeo+wLk+0DgxxQOfSM8m/B1gz1FlFdugUiiRtg1YYR8MXhdRC0Br2YS1hs1ddRCVUHlr5WUM37yZNiOXDhdIqojbCuyFesUIbyZFSmlDmd7Zl/LmaYYEv1hODGGxcWoBS9FZZUepj8QbvSe92D/JGCKEBRMwGKYKyiGyEFopTYZqyRsMZ4AuS1axVvzhc+q8PXjKtCmSFMSo7kqjo3y1DCX6Nm5fJzIJLa/J2yzoQ+MNZD/bHrfV6RTkxewIg2IPftGN9hLnU7Qtfo2qjP10GpePbHxEGL5IZ9Jq/yZ2k5q+MJZ/dXNO6FlIUNepAq3EUKf8A43XdJJ6xkLH258uVEvvax7Ie8GGGkmljWUMCWG7JEiCQe9KFQXL65aUGZLahGp29q24+1kHwarwljqZoYScpi1HcFUcm+WcRL9GrrrT+RyYpvaklXJw+EIFL+wb3OVnR59SdUnqswWvCQ/qydJvsgKG0Lmc9KapdNK9t/jjYC9Pgg6qhlVTiY5xtGMOuIw9pfSNjR1h7a8VAgm2he2MPeCuJdRmTNJFKkb21ZpgmQMfCPCI4YGjLU9DqOr/jN2n66WD+rpDsB74fFcm08daSk0tcvV6q72gkJzVY8ETGUujsZoxXaOCdkksmJDB4B6w8tcoUBpI49ZrDYl65/wAyfJj70djEMJOUTt3CZVElSiQ5DBWBgHXCDaH1MnMsQIOkHPrlkb9WPa+AawuGpVofIIOlbbuUm0krXriUOwHiwFIdDd26TTrcykwPU/ghgP8AREYGBges6iUblUmqq0iyQb8QgB91zqloqzBGusrBBBqXiWx+kcet0locHeiGGYTBVX5JQKT7SjcsSaQSa1+UOVXIh8WWyH+4MaWprMpYY1RXsvE4fDIcv3GNc6oUKn7GrCvLHJA74pmqu6cm76mTlL1NgXSjURyxw1Y+AmD5dxlRySvZ7MTVN2KJlj4xq2A4RHBDykU5ezx+atw+WMsfgrHWDgDWCOo1HpZKKqtJM0W/FIAfdcJRKlD+jiVFNPAxOUl/0/e7Q2QEcF7HWrq14/wJ/wCU/wDVH+Bf/Kf+qP8AAv8A5P8A9UK6IFIerp2GkwBAiBEb7fLIBXs1BsiOx7nLIqDSSWAWoU2aZj/DMFo3jEYEjOTUbIf2053iod7Ul/5XCGNNaXrkwlqZN/tOP7MNqI0ZmFIXVVlkiJyl25+1L4Rqh9O5m6m8yWFVy7UMqoYcY3GaVCHkyIiXTK74xDqbIlKAVBFF6fsNJz9gBlCB6i6TwLI9433DgilOh8c70pBmUorwPES9gH6wva/ZdEhgOURAQGsBxQanVBGj90pafNfWjvhOXtvCFQwSdUE6upJVuZKsClf6k+pOH7I3BZUyfyE5/U5k0tl+MTHoE0JTKXOpcsUBI5ROkYBxCFUGl8wdMD9k2WOiPfKNXW9WaayKV1VlczBuQ/wLYWvFXd6s05n8zA1oq8xXEnwLYgXxVdb1I0M6OM6qhFiRcQ4VfVB/buaZp4yloDqWMuJX8M5zCPisx1L0VJGcw6hdQ7Y3y0zFD6QhcKuidA/YqFEo94YO2XVbK9mkcSG74DVBjmAhCiYxhqAADCIwWhdCpZIRLUuRK+uuFY+E+YcHeALl6QZ0GZK+3VPH1W1AfUyZ9V4Cx1XphJJZZrK5foEP8G2FrxV3eq9Lp1M66wcv11C/BtjV4qvYsHuDTcwbNcssRPOaCpJlSLrECyHegznRF0qI4GjJIgeGs333CyzQvlFWu6A7k3yjDB2lEJdJkz/l7y0fhImFf2iW7/N0t/mCv2FuEWIZJUhTkOFkxTBWAhEtnV9nNBrDB72R2Q+0q/B2g+KJrR6YKyqdMFmbtHs0lS1D57h0p1OpAY/qa6BHJQ98QavsNBJ1Rabyk5a9NslkvCJBq8dwWGinR9UB7NzeR+WUS/fcBGn9JkSaxJw8KHgWPA9Z1S0VZaoOEjFJd0biCUPpGLcLJpFMZubWYtFnPEIJvugTCJjDWIjhHrFHrtFkiHqi6hUid8w1BCLFoiyQCpNumVIgcABUFzqtoo0gXtVgk50qHBeigQfGUY6i0hlc4rq0i8RccQ4D913qfTafsqqgRmbkgd6+Gq8UfhTT9suulaZygNPLYhMA+pl41Q94o3GclljqbzFW9tmaRllTe9KFYw7pXSJ/SF7XfHywqWa67Be1J4C1B4I6o6J8uUHCRkms5NxBKH0jBccC1WBoJQXsGvQm1rVWCvwxT3feQcut5KKeb7yDl1vJRTvfeQ8ut5KH9C54rR6ZuWqzlApDHFuYwk1QVgFZgAdYQ2Pc4fhLKa93If7gXB/lTmXxSH+2Fwv8m1HLGtpBP7IPfaN7Spz/AMLv83S3+YK/YXrJGLaSoVpdVyqHHB2YIVbPyrh/5Shq1tILV/RgLypXrWRgum1rOtfDVZ4H+UajVW+jf9sLn84lKf8AOnv++e6Ny+z6fzqz+TNEmtfxh7X7q51K0KZ8rXql0iNi/wCocCj4hHrerGiXR1lZtAD4i4hwJeqD+xcIimZVQ1RSBaMOIIPNps9mqtdt44UcG75zCP33OrNDJHNLVZnMvQOf4VgLXjruaR0VKQI7ZYi3HTKb/lH4OUEJNV06nc8MDs3xP5oM1Zvl3NIShrQtkt6tMfXDurYRKOpD5Rg+hcvk7ns4q9oaptq/jD2v3fXdVtEKfu66/Xp0QHgT1Afs9Zg9x6UmDZ1kViHzGgqqZVCjgOFYd6DN9EXTQhgdskTh4Ky/dcJM9C+UVDhalO2N8k0Hd0Ql05TLXpB5ZP8AAUCr7QLd/m7W/wAwV+wtxBqidw5WIkkmFo5zmqKUMYjCDS/SXQ+qXW7E8xOGoL8WGz3xh9NXiswmbtVy5XNaUVVNaMYe+Nw55tO6QGL6mggRqT4RhrH9mCSai82myhqgaMllvCBBqjhgz/RSo+iAdg5vw/IKJvuuFXp9SVYuspN3hg8Kx+t0tQaYTQwap7MTFD4BCFq8YnuaWoTLpWU2qezEDjwkIQ33mL1undEc74xf6OYKrAPvjCUn2HNc6j0ApDMLVkxJesUg+/MWyXxiF3qjoWSwhjVnZHWbG8CgiH0TFuLUp0emEjIBrM2QbrLGDtUS1gc3FTGEmqBGzdMqaSRQIQoaxShrBDaXM1371YqTdsmZVU5tYpShWIw4pnSqY0iXtADpUb0Q35tIMBC8Wq5pahT+ZCGqeTAQD4BCF+8TXJ7QmRy09HH+lHjt2ICe9EP6mUo1hUcBDXEsaK3dV9RbeTjRW7qfqLbycaKvdT9Rb+ThVyso4XPaUVMJzmxiOv7j141+sLPaDSSZ2qxUZplP8MoWTeMBgTspNSQhPajnZqm7+qL9hrhPxrRBc+qGp63+w/8AxhtS2jMwo667B6iJANtD9qbwDVD2RzN1KJkkKTloqZJQo4wuMVaFvZWRcumm70xzp7NkwBUMUW0PWV/nbytwctaLNLCsr4NgOEYpToiLHQXV0jKgHUMUTan5Y9uN06pypplExzjZKAa4jA0EoMzlS5Knq3rp58abY8AVB4IJJaB9QklfXM6VBKr9UXVHH9kLgvaYP5+cvqctaXsvxig9AGhKVyx3MljABGqJ1jCOIoVwd+/cv1OzcqnVHvmGvrepOhXIEBLUZZAXQ/6pxOHiMFy+z+QyW1+TNFHIh8Yez+662pCkU6N250GpB71oxvtJc0hoXuW1f9IO0G3jvn7u7faOTyT7lekccoSr91cYjS8aYH1ToJeWXp4OxJfDHNnrDx47nUajSNFGStTqcjWvVrlbl/iNg7wGu9S9DKRIiGqVQFyP+ocTh4hC5faQSWU7mZnccoer917n1+tK9o8/owqf1WXrX9MP1Z+gweOAplQqZyEpa11Urbf44uEvjweGDpKGSVIJTkGyYBDCAw9ofSRjSJjhOzVAxibcnbFHvhXEvpHKGs8la19avEwUTN9w8Iawwak7Y1MKOIfjRqT1yiX+sphsh78PHGOJlKHOnJVMHDNcMF8QVEhs4Q9mTk7yYvFnS5+yVWOJzD4R6wXCqGiDSND1EmrliBu3Nlh72xCLVBRy4VKmkkUTnObABShriMH0QaZOJmiYdINvW7Io5MO28I4bhqJ6H7ZR0lYeTU2nVsYAPYBxaoCj+hy5ZEUqczg4MyfB1z+IOtMoYCEKJjGGoAxwSTyVhKE6rLFqk2CrEQoF+65TbRBpmvSCWzKTJM7ykiiVwuqBwAoYawBMQ7IR2Y0Q9+aO84X8jGiFvxR7nC/kYp8iQyp51R0CkCsRv6/kbmkNDFF3V/SLxdzmG9/u7lTSj0nAezUXcnD4IFKX9o128UwmkrNrPGF8D4SZy/cc11Jsio4XUKmmmUTnObABQDXGFKcUxmE+rNeDnvTUpu1QLgL0jwiNwxzAQgCJjDUAY4JKJOxlSdVlk2SbhViIUC/dcpjTul609l8xlCTS8pIolXWVA9RQw11JiHZCbZinm+8g5dbyUU732kHLreSinm+0h5dbyUPKJz51R6YLoLOGYlA50DCJKxKBsAiADs4vdA0Jpoymyh6mig3h18UbZ8GAfBBFkyqpmAxDhaKYNkIPR2kf4VS5H8XTg9pSrWScdtxtfPcGgj7qFPVDjI3Z669fSqm3D3uOKEyaTHnjikjBRApLZARXKc6vvSgA1iMFePnLwqYJguqZQCB2tY11ddQl5QuXSyZTppLH0tbkbqouTgmA2AqtFEcAgMIT9E9D6HO7bA35a7J+f94X3uO4rT6lqRXCQ9S5cILvDbAh2pPlD4oKQoEIAAUuAADYgtLabnYMlrbCSgLVOrWOr+cNnwfJ60ZzT2QS2zaKrMELYe8A4GN9EB67qLofUhmFdRiMFSEHEc4WC+MwXOo2h9R9gIWTEYInOGI5wtG8Yjc05ohJMAHUsGCRKvfGEx/sEt3qZopSU4mqI4OdsbhtkMAfSs3Ro7RDqCzVsvJ4Io8JUA9sHw4C+EbozenEil1msqr9G2HvAMAm8QD1/Vil85mYDWVw+WMT4NsbPiq9xa8a8a/Wln0n/A6ar/jCWk9biYfbkOkv2RLKVyR1IZujfGzolkcZR2DBwgMTfQ/nysnmZLSY6ps47VdPGH3+xzimE6QkUkbCs5XH5JC7JjDsAESvQ+o4hIZcFowatyvVqlldkw/dwQSgdGDtGC344mhRSagGukXtlfBscMCYRMYRER2etm1GJshPJI50u9a2hSVvZT2ayiUcBgENYR2I0Xu636g28nGi93XfUG3k40Xe676g28nGi73XfUG3k40Xe6z6g28nGiJSqUrSKfUi0yxcWb4lpVAlqya0GEpAHXALmiwgkVFKlVkhAApQ0g21g/040XO6z6g28nE2pPNl55PHemXrmzfVbBSWrJQKGAoAGsAXXkomDaaS5a9OmapF0T1ANk5RrAahwDhxxotd1n1Ft5ONFrus+otvJxSGmT8s0pJMjPHJEwRKcSEJUQBEaqigAbI3ZpRuaoTuTOQbvW1YpKWCns1lEBwGAQ1hHYjRY7q/qLbycaK/dV9RbeTjRX7qvqLbycaK3dT9Rb+TjRV7qfqLbycaKZgq/Cn6k3/g9ya/XTGQTRtOZS5Mg7aHBRM4Y4lWiLIyvG9lF+gAFeNa8KZsYe9HYiSn0N3CsysaaTXT0iPbXy1hq+TX7HJeoU4USvfVXTQAtt7xZCx4K7USWgciVnk5WwBqUUQ7NdTYKWJtTafuaQThWtVYdQQOxSJsELwB+kOH2Kc0eelmMjmS7FyXBfET2RqxcMUkpWsRekU6dPzJYCX0+AneDWD2OcUfeBMJJMnDFyXBfUDiUasUUgpO4K7pBOHT9UgWSCuoJrIcGL2YP0Jw/wByx/uBVHDHDHDA44GBgYGBuDA3B9hH9IlxQXF44Ji8cF17PjhL/wCGCVjg8cJ7XxwntfHCe08cJbTxwltPpQltPpQlk/pQlk/pQlk/pQlk/pQWq0ZOoO/CQDqQgm18cE2vjgm18cE2vjguLxwGKAxRwdYP6LGBgQ1gGDDjzQbEOaD4hzQbEOaDYhg3DBsQ5oNiHNA8OaB4c0cHig6g2SFEYSQ7UVT97UhCqnZAaDbUYNig2IYNtRg2KDYhgcQwMDigcUDigRHWgdgINigcUDiGBxDA4hgcQ5oNig2IYNiGDYhgcQwbajAiGtHAMGxQMDig2KBxQOIYHFA4oHFAxwRwe4ThrKGhXKmhXLGhXLnhbLmhbdB88L7pPC+6T54cbqUzw43WpDndameHW7FM8TFyYSoOFBs9kNeAvfGF2xhv7056tgo/fC7ha+345cFnBDjdKmeF90KZ4Xy588LboPnhXLnzwrlj54Uyxs8HyhoUyhoPlDQfbjBtuMH25oOmFRj4YHbGg22NBtubPBtuaD7c0HyhoPlDZ4PlDZ4PlT54Uyp88KZU8Hyh88KZU+eDAOFQwwsBBVKoNkMQwplT54PlD54UypoPlTQfKmg+UNBsoaDbc0G25oNtjQbbmg22GBxjFVYQY2sMDrCMcPs43BgYNBsUGxQfFCKIArMlbIa95IOrHv7WL4kVs2QTSQINZSEDxiOyMCbCYfZgOYzhT2tELQ8I7EXxQRAKro9YOKBxQOKOCOC5wRwQmqcWaxcCwXuurDh1vHCzJyo1WDVpGEowOKBuDijggcVzgujdEIKfsw8OzAhqgwhj9kY5FTjwwyKnKRL8grynmiW5BXlPNEtyCvK+aJXkFuV80SrILct5olWQX5bzRKhGrS62H9d5oYlLbUYuAD47zRLyFEzhJYx7WpsHs1BEjOPqrZ3VwLh0RItyOuXDoiR7kc8uHREj3I45fzRJdxuOX80SXca/L+aJPuNbl/NEp3Gry/miVbkV5bzRLNyKct5olm5VOW80S3cqnLeaJbuRTlvNEt3Gpy/miWbiV5fzRLDjVpFXnHmhokY+mEVDlEcBSqWcGaJNvevznzRJdmXL869GJJsyxxzv0YkW9bjnnoxIN6HHPfRiju8znn3oRRveV1z70Io1vI65/wChFGd43XP/AEIozvG6+cPQijO8br5w9CKMbxu+f+hFGN43fP8A0IoxvG7+cPQijG8jvn/oRRggibqM9rDW9f8AoRLlHCyyjVVdCrUEBeyYB4TVYc0Ub3oc8+9CKOb0OefehFHd6HPPvQij29DjnvoRR7ehzz30Io/vQ5576EUf3pc899CJBvS5556MSHetzzz0Yke9rnnfoxJt73HOvRiUbhX5x6MSzci/L+aJfuVblvNEv3OtyvmhpsJK8pCQqYCms4q4SDCJD54RxGzwl76E+GC8MFgOsGDY4GBgYNAw5M16ozITtm3ahgvqvwQH7RhogN8vIJm2CAa1V4YdKFvZVjkT2oG14Pthg+2GD4xg+2GD4xg+2GD7aD4xg+2GDYxg22GDbYYNjGDYxg2MYNjhVowbOnKRw00UTge0FQBsBV3sMKKnt2hqqqDvQpjHPB9sOeFNsMKbc0K7c2eFsobPC2UNnhbKGzwvlD54Xyh88L5Q+eF8qfPC+UPnhfKGzwvlDZ4Xyhs8C4KZmucwh7YXDn14eyU7NcUjIpvUQOBAUtAQ4a4V5h8ML5Q2eF9ubPC2UNnhbbmzwttzZ4Wyhs8LZQ2eFsobPC2UNnhXKGzwrtxzwpthzwpthg2OBxwbYEYte2YYSU9TEbNesfphZueyoXvCGsPsqipgDAWvHEulRQWIQFnGUVDUEH3obMOXagqCoY5h7cw4fBigRGsw4fcLZd6kV6cSt7YXwQ2Q4ICYOxvIVIAFhEtX5sODhu8EcEcEcEcF0cUDHBAwOKBxQOKBxQdI5VSdkUawiXTaiBpc/OJVkBBRkarOUR4MIZoMQwlMXCEe9j3scHWcFwOtquiXWjU3s1Ql2o60J1WkTDwlHYgQ2OuWyR+LC+RPxYXH8yfijChar4USV61oNeFde8KBwiXDCiIWEWiomxiQYfqjaO3XEfixh3uVfkxh3uRfkxh5uRfkxh5uNfkxh7uNxyQw93E45IYfbicckaH24nHJGh9uJxyQw+3E45IYe7icckMPdxuOTGHm43HJDD3cTjkxh9uFxyQw/wBwOeSNEyHWlzrkTdETBMoqKsHJCF1zmSMAB3xh27C22ZOFk09cUkhN9kTtY4qDJn+H/pj9ETwf7DmHNT9ET4daQzHmh+iJ9vBMuaH6In28My5ofoifbwzHmp+iJ9vFMean6Inu8Ux5qfoie7xTHmp+iJ7vHMean6Inu8cw5sfoiebxzDmx+iJ5vHMObH6Inm8kw5sfoiebyTDmx+iJ3vI/5sfoid7yP+bH6InYf2I/5sfoid7yTDmx+iJ1ZUaHkz4ANqyCLY+A2zsQ5UX0tpRXTJNTerA2x8GvE63lf82P0ROt5X/Nj9ETveV/zY/RE73lf82P0ROt5X3Nj9ETreZ/zY/RE63lf81P0ROt5X/NT9ETreWYc1P0ROQ/saYc1P0RN96H/Nj9ETfeh/zY/RE21upL7mx+iJrvS+5sfoiab1vebH6ImWzLHnNz9ETDe53yB+iH2yxc8iboh6n2TRerhTNCxgrBstyYwon2aZy98tUKiFYJmq70KbQ2aDbUc0DiGFsornGFzGsgqpxoXSLVfV68dYwsKgH1ZqsY1w8rwKrB4Rh+FdSy2HBhh/l184xMA/rDjOMP90OOMMP90OOMMPt0OeMMPt0uc4w+3S54ww+3Q54ww93Q54ww83Q44ww7H+sOM4w7y7jOMOsu4zjDgfz6+cYcZdfOMOMu4zjDnLuOMPTDrLueMbph04IBAXcKW9ctow+KHbWwDdRdO9mtakRq18GCJiOHTbzDh7M3TEx3Y95Q/TEx3Y/5Q/TEy3bMOUP0xNN2THlD9MTTdcx5Q/TE03ZMeUP0xNN1zHjn6Ymm65lxz9MTTdcy45+mJpuuZcc/TE03XMuOfpiabrmXGP0xNN1TLjH6Ymu6pnxz9MTXdUz45+mJtuqZ8c/TE33XNOOfpib7rmnHP0xOwIdMHkysnqrwn2PDDpd0o9IDwpyFARUMJrXY1CNrXiZpLGSTmMwUqADalQ46/hicbrmfHP0xOd2TPjn6YnW7Jpxz9MTrdsz45+mJ3u2Z8c/TE63bM+UU6YnW7plxz9MTrd8y5Q/TE63dMuUU6YnW7pjyp+mJzu6Y8qfpic7vmHKn6YnG+Ew5Y/TE33e+5Y/TE02Xr3lT9MTPdjzlDdMTHdTrjm6Yf7oXHvmGHmXX4ww4UKJTmOb4QwoAWbZwq4YV17RoPjGDYxi8F1YgZQeKXpgiQVECs2yaDCNdY3B2BgYHHA44HGMDtoNjgdsMDtoHbQMDjGB2wwbHA44HbQOOBxwOOFXq17TAw2S2hqGFZciKxi3pyashLIjgDZGDbYc8G2w54PthzwfbGzwptzZ4Vyh88K5Q+eFcofjDC2VPxhhbKn4wwtlVOMMLZU/GGFsqfjDC2VPxhhfKn4wwvlT8YYW2VlOMMLZY/GGFcqfjDC2VPxhhbLH4wwZo5qXOYzdcL0uWvXLE1FB+dFEoJIFviCiag1q1bAh8EYW178pxhhfKn4wwtlT8YYWyp+MMK5U/GGFcofjQplDZ4Uyhs8H25s8H25s8H2w54NthzwbbDBsYwOOBxwOOBx9YMBAhwwYw4RisOsru4LtdzDAxg9gBOXqKl7IxqhGBM6OUdYmpCAgICAgsBAQFUBAQWAgtUBAVQEBAYoLAQEBCijFExxrEBFLwBrQi1nDxBEtRCqjUGKAgIDrNfrMHWYOsq63/xAAoEAEAAgEEAQMEAwEBAAAAAAABABEhEDFBUWFxgZEgobHwwdHh8TD/2gAIAQEAAT8QLDOvibDTbXUHRYxcMWLhYsYsYseIsWLFixYsWLpZ/wCFug1oMWjZBubJynLWHUOYVoxjOepym91BvDS623SNPDS4pbouZe8WOzFixYsWPEWLFixYsWLrbpZ9Fss0t0HQag3FH9IPTsqDjTZo9RjM70c5jc5uixcz9p2hhz8ad+vS46Z0gxZeKixYsWLFykWLFjxFixYsWLFiy2WaLfos0t0s0UGKDUGDc2TZNk3aF9DZoxjNroMG85kO8O+kKuHSYc63SLMGtF9xYs40wRfMXMXzFix4ixYsWLFixdVmi2Wy2W6rJbFooMG4tQanKco5vmybJshunGjOU2M5zbOUO82syvQbhh50m9PDX5Q2lmjFixUR0LFix4ixYsWLFixdFssln0hZLNQ3LYNxQYNxwbg3os6FFOLig1CPMdo8w6RiGcoaYId5nZBpGIYPpKyLGFixhh3ZixhYqIsWLFi6Fi6rdLJZosln0LINRQag3FBqDUGtCnKOb9DavpGMMO8G8G8MG8O5xBvMW4YYYefoX9wlsWLHCMMMLvFqMeqLhixYuhYssi6rfoslmtss0UGKDBuDcG4Nwb0euoQg3DdP505Rg3hg3hxpuhsg30jUMMENQ4nLUdosWLGGF3j5S8xZeIuIsWLFiyyW6WSyW/Tj6Fssg1BuKDUHQNQanLWWhQzq78aMEEHMO5UF3BvBuQ1bBzp49QStoIaIFaLFi6FjlGHdmOEfKLONBYsWLLYst0s0Wy2Wy2W6LNLYtBuDUGDcUG4Nwbg6B0bIrGcoTibK04jBDpDS3q0DuM92EfSeBerGLGYIxyi7xYwsXDFlsWLFlsXRbLJZ/wCALdBigwbg1BgxaBqco9C0co4oE2St5WIwPogwMqvWmJRxO01imG6JUYxYsWKiLvF3i7x8p5IsXCRYsWLFi/Uslkslmtug6DFBmyLRsg3rv0b9HiHGk1piQsONG5N6blyiZGNMDZqpTiC4MTbGEjpXeLFRGLmMWLiLHCLFixZZqs/9Cg3oMG4NahOUU2RzZocujlNkDWiJEmLS3JvTcmJm4aeFxo0GCMOoxrKMZl9sopytbHaoIhP2JLs79lYxYsWLiLLYstlkOnKVoG6beZARfVRN5i1r8LpZ9VyzVaKD9DZqOpunKbPrgNCQX9AWJm5N6VXo4oqjNfEo4lUcX6SsBlUGXfgAtVwArBHpz53+7hHO7L+5opjF+dGeLiL5i4ixd5ZLYuor5XGDCnYVoT8ySVhscJ8JYx9+dAavpE+ESW65+ob0WnKDU2TlOU5Q4mybPpjMm2YTLWIESJrWCYPvCzNybpoj1K9aRwC9Dcm/DOeuF2uNl+fH24CM96QB5agO2NbwRvE7FvyMVEWLLYudF1tgbDtX6AhYDhJhE/KmPdW65Iv2GDGZTwduiRbLoCIjsm43otln0OSLsXmVATR6WYwEgozIEULg3oNwYri516C2FgtKtNMD6i8j6ODyoRwBNJhVq6AjCaU0KhOqAAVTRy0D61IdaK+FkIrQzwW4ADFoC3KkUHawcb2tgSCjzS+Tk5kkckDprqWGcpREicQb61Tc36m9AmMlKjO9ieLM35vYlcOolJT1FF92M4uQKAwB4ol41Vnqp8ZHzK7wPr94nN/A3ZFfUdJVgMocokZfyLesuSx6xZFjtGLGNfsGAlygEMQLub7X3HtIthv/AAaE1X3k9LhORNCJsjyVmHeFpo7XvI+ptiRvP0ZaVLfamontmg3psl/32fLekJ/z4H5JwY2r6paaoHV3ARrdksGbwWLwM73gKFueWjLo44iPmCegajmSer/oXfUln31dxEKlMTSYZuaG9N6BoE+KdxN+iJmbpUqublwbzC5X77hP7yR4pC8/h1v4UfRlFVqqu622sxl0hsO3xjUAvzb03bmwnlWVdKnBvtH8IpVcrmCENVWG6A0driUFv8UyiNdNZjiLpfdv5l3D9uIK9oAFIhyIokroa13t27KOYqi3VYov6oIGtu8lo/RBnUwDdTyvoUH7ec/b6GtDp829gTRqX9r6iT90fSsGlry/pPSz5p0cpkef5ID5Y9GlmvUBGPSAOVJv056iZOoKDgAgHGxGWnS1uxHefH2ygTTzaJ9z3f8Afr31oxEiQQGYJ2Tc0rZdAjot/E3JXc34d4d4baMqwzx66iti19gh/lnlLS7rfY32R503McBeVERDdzl19gug4Jygq+672zy2LkVKjHnq7sU7DczwGRfnOoYbgKKHCPDcOffTk5T9f1rgk3ddQ+Y6VWKtcNkmFE5FitfmN+t+4bL+59FEd1lvele8gdVYy38ftnQ5aKBtv/pLiTu1olx1Hr7TZCjfK2kTml7DoRg8ALFlMW5e5yQ/9FypoA3VcAQeYyfKuRKuiXM78zBvUKnflJ3TueQK1Sx+Err+1Wjlq5a8ocaBwzBMGkdIYxeKkwM3pRcpuZmHeYmvDHNRUMUCj0Cgi2343zJZVGvOzW+wSkFi+5pM1F1NNRAASwiO49My194lvyJe8FIH0nAawijp895vcAfEcetXqUYiKOEibwfzmj8GHpuL6VLwJPj4tWimAgXaoR+byiqt5VcrKYFQCW6jR2Sh8pBPdbBg+DQh6/ylHRUI8nCKESx0M9eXpJ80Riquwure46OdGa3fdRlBy0UHLG3BdobJPIR+IpGB58fEr0bPiShuvQWsLocQ5o0ici43TVlTmGsMcoENNmk3vBvBvDvN6ZQWS82myYpuTdm5N+b0NXPAc+j9l5sJKO/Rd3Lcdvp1lt3ZVXs8WlTMDXb+7j3q/SmADX7RevtP3rzajPeZ1OpiJ65aQCJ5y/L7oFQUCXMqLru4H20EMdRsAqvsQLsnN7r73AgIjxedT2q0IIonezB0XcBXprHQtXUi85z8KfSeUV10fxux9Wl2TsTfiP0jGb4N4YId5sn9JghONmFm/N2ZmDLA5mVqy5xU3DHJX7RYxus89yXmZh/Ey83+++k2mYmqp/3wxO6MAdssnm331/f1ijdON+2UvwGwYJTM+cL297Qey8vKD5CWqrZcqy92P4zR7jj6Vq+j3mCtx7P0bCWC93SWiBcCoIeF+miOkCs7HdN18e7Z3of2BoIvvZ1e8lOHIGugKA4AAqPEC6linoBY0KFvPl8Ae22GHQat2Kacwuatte0DzmwCUEKUo/gC5UmxlXBrxXcYkdPKcpsZz0m4VaGCYGDc0Bg7s5S42bkA4fXcVsePrAP5Y8oGjHG8mDPulEp7ngPIqHFs5EdPcdx5EYxG/beZerO4qM8fMqIkWxbH07/qgHBEleSFXSGqGgDdbaCHuv8AgEv2/rxia7/HPkGjdb+Kk+Jtho8AlfiXoZLy2V92Ud6M9yp77WWzaUiPt9hJAoQR/Hkvp6oavx7/ABkLgT/HL/m6arluzvBfKjOg0GJWLtP5PGDyHA0Yn/K9003/AG7qRnKGbPodFwk5Rx1c/nozNBxUDE2zYznmdk5TnicpvZZH7id/2glpYd4/Li3hRtGWwBRHkbKSXLWgIPZ4SiH6DzcHfoSw4RJZpq74eOwfhCigpGm8JCwvQbnJaNNZLqJgu2b8sr7v0Z97+kJFyWWUhUcACrDFy81to7umiPUohwOD+ggNZF5Xa/MSnRRod4Bi1LQBy2ylJUqiiVoQotrnWdaSoOTQDxr/AF+IISXRV9cD0x+8/wCCYXAlu69bVRqGhHBSlR2ABVYgeLM3RrhSyiEH6gBalwB2s8AyFRK0VfgeO1ir2EEjkanJONtp1xwnIEbFI69TzGco8aCijyx4GIjxFjeYKuYGb8PM3orWLLOcTFU/a0+7EUNKFiFidlREkQJreh8ZnzLHllfNpijlbE9Y1/q2KsXImwzbAOB4LqOluoUMs6BdAD1ImvHtB07+a5lMe34v5sXsPgwOqAFAOIeROreYvaemaZTKNGVd3d98X9VSs1sKKyB4lx6olIJaZHu+9HzMNDwV9Si/lqPjUqa/nz6cwuCO60+76+9cbzKqoPYwOpFi7xTcm9N7M3Zj30ce87aNY6Y47k39J3cW8zS2s6P52IPO57obxUR7IzdCYS7jzcDcYsWMTSiUSjSmeiPn6JBZWCTMNIr4nA4EKqN31U+ztKUAtTavKvboCpRoY9yV+wvKkyqclMI2QcixpFU1pjIrC0yDt5SCNHfCVBnQU896TgBxo2AhoFCkvV+sNAGgjsiQmxFhNPhSAGcs4tWGgZELN4yvLSLVMJIaeYCVEoXX8Rfk0uWlsdoxVApm5pYWb+njmKYm83Mw6c/MxuZlszezL1m/FvHvmOwCfYcPCIojhFGInmBfk7mVDfKqVnAedOeMWLop09pRMdzEEe102xTknBwCqmBYvy7BMDH1NFfED5bWUSkpoSSaZBHqQLg8Mp0CKw1g1ACAh1hAgVDCz1w1dVbs35XN+BnM2MzyymkY4bw8xvZlt5ll0y28y5ZuZ15gW8pUq3XA7ERhSCRZJ3rryIEfEYvnTbLdFkvxFcA/CLLbpHJjI2RvWvBCOweQC4EogEBAgVAuUTEK4lE5aioQqcoFQggNJpCCAqEBgTZNkL40XzHR4ZuZm5mb2czehNyqUwDdiagS0f5TA5m7mW3LLhZ0mKxWKxYpGH6HrAdkrKQNIYCU6gPEB4lfED4+ZSVlYDsgYGBgYSPmEknnA0CKQjzCDtAgVAPoURhjfZ5pwTcm/DzNzMohk21cxudF85IiuY7fMRcRisUbzMxuMSJEqMWOosh9E2l+4QQeUPLT6onDBcugn1sPOGkNGGGnV5ivxPVegzCkzAleNCudCxpHd9HW5mb+ZfN7M8lxOUQE/Cbcw9bIjhM7MZeftO5PGjJWgZL0SpbKWEcHxMLmW8SJ40Zlkvzpt0DKdzyYPmHlDyIkFgonLPJBRILBgwaj0LDmJl4nRy30codkxpcYVc6eKhm9p7rN+eaZGY1WUnD5ZQ/un6VFijgG590sDY4yjLs/Of8ATx6Xzj0fnP1qPH96cv5J+5R6XyjwfehnnvXmOC48rvEcPlHx/KL/AN0X/oizPi+YvX8yzp9JVoIGD9AoPh0BAuECN9IUGmUhhi9VAuBEjOUXSMvOlbedHdm7NzM3IttROwvGDmckfhm6b1FZu5f1S8fzo22Y9UH+5Fd/iZdx8GD/AMChyfIg+A+aeL5Ivt8pYxBbRQHauAlq9Si/sX7RsqPZj/mMe/Xoz/lMQvAejHevjxEs/Yn/AAI3bPwzjt8M8/4nmTKFUUtnxDu58Q73xD/KgNfiYf4zP9Mh2fhhy/Ewb+pn+KZxvxMNyezCzGJ4Ym/2mWrv7jDlH4geXuMO58M7f4ZvX4GbW3wwXP1qcJvmmdF+IvaIFP2SjsMWYqJ4ZToaXmUDMzF9pwXKbm9naX23N8nDpX9K28NXC5vDzN192H9gyvOnw6khdEHAVYgTATdkYMCVAWwpgPXeZgFRVL7fwA9YkAAgQFHpv6uYbhGratLLME/7KKdEOYi2N8Vmv3i/N7xT+dmfnj2huN5aUrpFPETj706V7wWQ3/vRO2PzD/dhPE90yDiWB8nvCeIgqhdOSDRVYyAuGurxAGAXEnhPrN/l9Zyflh/tz/SweT3AGJyF7wgYv5YL/Myoi5btg6r3gurjCoswjhIheUaP3FrePmmeWJmb5N+LN+dMTli7ZjPLFeYze8Ehewx/CnpGG8h2PeOwNzR5iAKgiT7Wwe3PiCyuwC+UZ8ziJqFe5aW0vTcio7tC2cxhcTtTL8CwXBMLtJ5soBzmYgC1owXOmCiiN0sf39IJ0DMj/hS9Zh6xDvDDhF3dw/bUMItSHfgfEIaUWiWLkYBBMV9oO5wsvSCnkQPpZft8aBBiKXiLNzQoRLWYKDgHnhh9g7QO+k3Igxc7wOYqUjeYmY96jZzFzUbIs3knM+H/AFDb/C/qF3+JBP4zHP8AjEdd9kCMr7IHt8SChdVGNrIHYxS7WHNlYQLqwn4G2FmltpgPYYr6zFG9K+GUo6/Cen3BLxXemLzGHmkPDb6IfBemMjXwIaKzQt6vTFxH4xY8pJ0m3wokwIWZlnK2FrA0dy60peL+F1P8ZwDuocpvdF3MUWX5Ecz2nG+fkRsH5cG2fKgeIGZ+TBwzhdAnBJltFLeRu1VdVzElGzKDs7sFjhe8E2c8Cbv60J2+Bo2/4WL/AOlBt/bQ8Pw5VwfGldaxHIl39SGGPhMUVD9RLdh9k5VhjgQW8JKFDjraN1JmNy+rhyEef8zN/AmRQPcjyqb7BwmJyzfC5XJmc496jrg9l8zu/LD174GF5+8K7sIK2ZmWklIrNjZHeAM0wGABGGPCMqbqHgCKHexeA6eGZ35GD2T30EJ/ZP8AtT/oT9DFv7mP+xH0bzHf+5BP7IW/zQeH+om4XjzLHRuC3S7tlnG4ReqwvdjsRWxN/t05vysdbAPVJtNrZtAbWeqPjt9p/rc4Ye+Wr+8hdvmxB/In+iT/AHKH+mn+vQ2EWkivAcBQG02GBmupiJnCJTgog2T5c5W/3gv9uf8Afzo+fHpvfLS/vonze+PhfVGt/IiDHzpvq/dORm5VltFvuzsvmGbEjdi2MTB22vdqP5PAmweAdebsiw9LlCfY8xJcTnE9k5MwuswwYmDGOGt5YS4obfMcjJnMFqnhMd116wC+LR/kPpfYmF3Tar0Nh4JdoVlXK+8c3bg7rU5rivNwHmGem+i3egeskqs6ZdGWWOEbjlLYtCt4OsVgKTd4KLroCMlVoowqtYTthtjCOvojuxE6Ya8viM4YPiOt9tEOaCE4ILmjNxY8+HZ8TJ402jJwQsO6RWESmDIa9GWqPISo5JTKbVK24aXhmdzMnMPm0u4Vt3Ay8DBRj5aSVcRxV47GPYUb5V5OmVWZMGleEcnnEcpjclVzOsoWdhHOPbWZvaR8psHsycMmdkRdYHLnGIPYa3L7TY/MvUWGjv8AK+kV+ySehWJuMR+u02v7/pB8n79Rf7/2lZ3P14ht/s+kG22Lr/CDG9+nUE2wfrtDn/Z8TPtfr1Aj9v4g+4fr1D+g/rjP1ftHc3Vf1RnKIKMess73QoLayxo0qA73po5eCDMF3QgH8Km2r6T52F7w0H5710fP5pHBJZ2WQFOZ8JzdCShAAOnLjFyiEcThMADD1B8hHmbWzrgxyrNVtGADQjUp7UCEpz5wCznOiiWRQrSDtrg+XP3mHEKn7qMea79+MBVnzAX+SQF0oCMPxwfbEXAeo/xClFWhYL0LzLBSLEaMvN+84NyPqoRz8UJwG+IU43e1AEKJkCM7Jm/MRZBfDFml33TeWGSWjmul7nFf9u4SHyv1fM/Qn5le/g/tnRf37hR5f1zD9p/Mt/s/MLc/u+Yfq/7zJX7XrDIP6fmbl+v5j9/sX5n7S/MUv2ot0e1I1LuDdB2bZ2vaXAaiqnJIaXGb3iK70pAtvLiP6LBdwEB+CEDL+J6JL4WnxfiangyuvHhzPhTZFdGCar4vSPcqaK/LlRtWIth9NyU+XWKpNqCmLcGLg87ZkNgvLi5xZpy/Zi40P02cn8c2YMjbcc6NHalBzekTxh2q4qnTv7kaFFYG2JXuDPvZ5eH3b+sh8vGpYnkuNu/cogA5pLEGOEChQgrwQBcxLBXaIz99nIDnmYwUvLReu78FEwtG7uvdbEfJl8tRjKr7w3km2VJwF7M2iolbqfLK6i+YAbvniUthPMXi0O18wHlnbvdn+s3gHPPlnKVnmdk+7G4t8sPy+ZZ3fLFgFjoUNgVq1oJZZIhPzA3jEXuqtrb5l2/BunUa6U8G9U43zZWuj3z/AFeAiSCHZgNuiUOZE7j6QH778w/s5VTrOIAPyJdEZHnh/Z4MWxE93BaLf3FuVVYXyart1RA2SUafkNJ2fc6szs+3gy1b1Uzl+XMm/Yc/22X6sfVMj86W1+6zM7J1awQ2z3cfy+Z2fzMht8szC3zERywreVI1rGhLvwx6tFcl1XkYrvTw5JmKrzzFgnRPcYNx+2ajW4ZgZEjRmbQWFxO7cW7kgqiMBW3jSQhEXxBs9Jh/f4Bgis7I9BmKWBUrn6B9TGtOwTLlEala6id9EowNIQKX8RmdyoGOTwxonaEzSTuzu3klgznUW69JfcS0kzsbQ8wFTzAm8adrMbCAjfozF1hLSDeADUOHyQFzf7XEGf/EACYRAAICAQQDAAMBAQEBAAAAAAECABEDBAUGEBITIBUWMBQXQAf/2gAIAQIBAQIAxTHMUSLFiQQfBhhhh+D2f539X/MdD5PTQxo0aNHmSPGmMYwkxxYsEEHyYYYYYej2fq5fd3f9x0Oh2YYY0aNHDRpkDRwkxRIkWLBB8GEwk9kmHsy5fVy//KOh8mHpo0YNGDhowaJMYSJEiwQdXZJhMMJMskm4TLuXcu/q/wCo+B2YYYY0aOHjxo8aJMUSJEiwQd2SSZdkkkkk3ZN3d3d3fV9Xcv8AmOhB8nohgwaOGDxhkGOYwkSJFggMu4SSTZhMJu7Ju7u7u7l93cv+Y6EHyYYYwYMGjhg4YYxjiRIkEEBuWSTd2SSSTd2Td3d3d/V9X/MdiD5IIaMGDBw0YOMYQKFgggly7skkkkkkwmybJu7u7u/q/wCw+B9EEMGDhg4cMMYQIEiQQdXd2SSSSSSSTZNk3d3d39Xcv+g6Er7IYMGDhw4yBAkWLEgg6sm7JJJJskkmybJu7uXfzd9X/EdjodVXwQQwYOHDhwwSJEixIO7u7JJJJJJJJsmybu7l383/AFHY6H8SGDBg4ZWDhIkUrAQQbu7JJuEmEkkwmybl9Xd3d3/4RBB2B2eiCCHDjIGDBIhWKQQbuzLJJJ1Gp0evJJJJsmzLmo1Wk1/V3d3/AHHYg7HY+SCGDBxkXIEKxSpBBBu7hJOp1G+b5w4WSSTZlmXOZLoNfoNd93/UdiD+VGEMHDjIMgUoQQwYMDd3ZJPMN60Wk2na4YYZdmXc1Wl3Pbtg3S+76y638ph1fxm1P5XHuObW/lcOv7fchu2Hcc+4DePzH5gbx+Z0+u7IIYMGDjIoKEEEEMGBu7J3/cr4htM5Hv2l31W6vrfN245v03zbq4zr5d31yHLOG4vjmeacVw80wzjjy9Xqc+WcJ23lGf5/+f6f4IIYOMgyKCCCCGDAg3dznGt2XQKNfrNVqeL7DM2ox5ur5Lsqtsu4zkWi41q/m9VlnGMXxy3LOF4eZYZtmTrmmvmk02k0+syza+G/oH/P/wDn2xbT8GEMGDjIBAQQQQQwIN3e86jguknNtbt+kwYTOY5du3Tat/6M3zQcV1c5bp8T4X+Nfl627DVVW9Zpw7DyPDFKMTvGvnCdt3LN1tmAQQfZhDBhkANg2CCCCCDeZzOGYjOT5uFaeGcu6B2nlWDUTmGDRZZviTbj8ckyzTYhL6d3ecfw6rF1teTk+vmDBoNJyzNEn7z+8/vW17j9GEMGGQA3AbBBBBBmu64lDN8nB++XfHDlvlZEQ7oZtfzzDLOP4q73rNAMGKbjhnHH5Zr5wrbZzrN88ewQfBhBjRxkAINg2CChEEEzIRwzKZybDwvUQzl/SptPFseOcwzaLFN9yTbR8ctyziGH45bmm04OuUYZsW4sceLa9DOb5pxLaf1H9S/UUQfR6aPMkBu7BEESLB3vGn4NqjObaLb9VhzEcxxbbtW1bGeid61/FtJOWajCmNPjfsk4bhHxzTNOJ4eua4Z/snDdtEA5LmnAsMH0Oz00eNAwIIIIiRIsHfN9Fs2uB1+i1Om4xvsy4UxHvku9KNl26ci1vGdJ8GZ8s2TkP7h+4rzGcszThGDrmmHpBs+3iXqc049yj96/exzzbtd9GGNHmQhgQRBFixIAJU37bq4juxnJNgwbRjQg/G87Lx7YZvu5TjWgrvc8vzs+Ct3zTh2HrkuHriG29bvn+to09fBJjRixyEEEERYkWIBAOjOXbPo9ZtW69How/Or1e47hsG1gSutRpv1r9Z/WP1j9Y0uww8Y/WNJpesuD9W/VNDoOtTpf1McS/Uv1H9PHEPkwwlixY5CChEESLEiQAfGp0+87PxFujDDD88wO36DQ6Puq6HVCVVVVV2BXQgI/kSSxcsXYQRYkSJFihYOzL1Om0mh6MYk3d3M+DTaXsQfyHdVVVAPihBB9EkkuzHIzsAAoQKEiQQEG7+bYkkk3d3d35eXl5eXl5eXl5eQN3YNg2CD1UEHQggg+CSWLMzMztkYABAAsSJAQbu7u7skwwgwy7u5d3d3fkD5eQYMCDYNg30CCOh2IIOrhJJLM7M2RnbI4ggiRCjBgwby8vLy8ru7hJJMIPxd+QN3d3fVgggiWIPkQSuh3d2SSxZmbI7szuwYMHDh1cOHD+fn5eYby8vLzLFieier7sHodiVBFAAFUABXQgldWOruybLMzMzu7Pkd2Dhw4cOMgyDKMgyB/P2Bw1+Vk3DCZRXx8UQr4ePr8AgxjH6hiGIYRiGH0jEMfrCDH4DH6wnj41UJlklmZmZmZ3d8jszsMgyBw6ZBkGQOHDhw6sG9nn5+fl5+fn5+fn5+YyOPMZPMZBkGX2jIMgye0ZPYuV09oyez2ewP5+V+Xl5+QaElixYuzM7Ozs7szOwcMHGUZRkDhgwbyEOQMGD+Xl5XVQCpW3abMwAHiECDGMfqGMYxjGMYxi0DHAMXqGL1er1+HiUKFSphId0jElizMzMzuzMzBhkDhgwcZBlXKGRw4yBw4YZPYMoyDN7hm9/vGoTNhze0ZfaMnlcESCKPEKE9agoJVAVKrx8SDDCSxyFnLO7s7MzOzF2Zg1+YyBg4YAN7hkDhwwbz9gyezz8/PzGQZFyDTPqBlGRMqZVyrlGUZRlGX2jKMgyez2afLodwGUZDk9pytkGX2tnOVsjZmynK2RshzhdQj5Hd3ZmdmYhxkDBrUhvaHDWHDjJ7Bk9gfzD+QYMGvQpum4AgpBMYUAAIoUKFCgBfHxCf5Tjqq8aKkQkszMSXJZnOUarOmQ5GYsWJPSMCkDCLBABBAAoFBQvgFCDGMA03pwIyiewZkzjUrqxrRuA3FdyG5jcxug3T8t+W/Lflsm8HVflfyn5T8n+SO4ncDr21zas6hs7ZGZiyMjIwZMiMjBoSG8r8g65Rl9vt94zDMM3uGcZ/9A1H+gaj/AEjUjVjWLmx6v/YNQudcoyKwIAHiMfr9fq9Ho/z/AOf/ADHQrBpfR6PScPp9RxNjKsGZmbK2c5zqW1b65tXl1BzO5dnMBuwbDBwwYEMH8w3kHD+YcMCHwLjdciujq6ZEyJkDqwZQAFI6rxoALr9IvICLLnIcpytmbOczZ2zvlfKXbIztkLs7OxLsWlj4PYI6BB6B8gbBBEvSTK4KkFShQoUKERDCSxckOHDWCDyDDteW4xMaNGjFySxJJYuWLEloxc9f/8QASBEAAQIDAQoKCAQDCQEBAAAAAQACAwQRUQUQEyExQVKRktESFCBTYXGhscHhIjAyQEKBotIVVGJyJPDxJTNDUGRwgsLiI5D/2gAIAQIBAz8A/wDyMxf7xQpSHhYzg1ozlS0+wvlnhwFnq4EpDwsZwaOlS883hy7g4fzm/wA6hy0J0aMaNAqSot2I/COJg9lviekqN+Jgw/ZoeFZT+tPVxeHDPwU+Vf6UUW58YRoJ6xmIsKhXQgiNCz5RYbP85M3G4lBPoNy9J3BRZ6M2Xgirj/NVBuRAEGFlznOT6uFOwjBjCoKiXNjmC/JmNoRubMUefQdiPRYVXly0u/gRorWmwkA9pUjzzNob1AmCWwXtdSwg93JgywrGeGjpIHepHn2bTd6k4rwxkZpJzBwJ71Ky7+BGitabC4A9pUhz7Npu9Skd3AhRWuNgcCdQPIkoDiyLGaHDKC4A6qq5/Ps2271KTDhDgxmuccwcCdQKk5Z/AjRWtNhcAe0q5/5hm23ern/mGbbd6uf+YZtt3q5v5hm23ernfmGbbd6lZs8GXitcRl4Lge4+7/hci6MPaOJvWd2VFxqcqEnLcbij035OgZteW8Llw8DB/vXDULdynpaMI2Ec7HjBJIPyXDAdbepyJqPNvY1xa1pIABpkz9afHIlZo1d8Jt6D02XhdKVLR7bcbd3zVMRXG5PBPPpMxfLNu+XLwt0onRQagPGt6kKLFtIGoV5OKDB6z3AeN7C3TadEE9lFSNCjWtI1Gvjewd1ITummsEX2ycB0d+RoJ/nrTpiK6NEyuJJ+d6jHz7xl9FvVnOtYe6sWwUGoCvbXlUhR5i0huoEnvHu5izLJQZGip6z5L8RnmS+Ymp6hjKAFG5FDkZZ0d+Ro12D5qJORnR4pq5xquOO45MD0AcQ0juF6FLs4cZwaOk0UOOzhwyCLRj5AitM7AHpD2haLesZ0WmoyhfiUqIp9oYndfne4pOkt9l2MePauLTwacjsW7t5eGjxIuk4nWb2Cua06RJ7aeHJwk/wNFoHefG9WLGjWADWa/wDVcKSZF0XdhB3C9gZ2C+xze8X8HAbJsON2M9Qyaz3XnzkZsCFlcaJknBbLw8jQAuMzD42k4nWa3nXRlGTJjcHhY6cGucjLwgv9R9H/ALX+o+j/ANofmfo/9oXFleLB3Cxkk0pl6KnMLfd+NT8aLa46hiHYFV8WZOajR3nwvH0JMfuPcPFOn5lkuz4j2KHLwhBhigAoLzjONhE4g3vUzcx/DgnFnGY/JS10xwPZfonwOe/Vfh845jfZOMdRzfJYGbwJyPHaMYvYSVbGGVp7CjBiB4zGqESGH2gHk4CVixbGnuxX8DKQ4djRrpj5OHuhGf8AqI1YvC9wJJ0TScdQA8arC3MiiwA6iD3XiwgjMg8AtzqmNy/EZ18fNWg6hiG+9Vzp94yei3xPguLyUaLY066Yr/F5ODBsa0fOmP3rBw3PsBKqargXN4ek47rxjXTi9FBqCD5uJGPwt7T5Vv8A8eP2jxvEGoUSBSDOek3SzjrtUOZhiJBILTnF6sJkbODTX/RYCYZEscD23sJc+KOiuo1vVkoJ/S3uHJwNznt0iB217hew8ZsLSIGs05ODYXuyAVRiOLzlJrewFzoQtFdZr4rjEu+DpNI1il/DSUF9rW9wXEZBzR7T/RHidXaReiTMVsGEKucQB80yQlmSzMjRTrtPzONYC5TxpEDtr3A3mteC/JXH1K52g/U37lc3m36m/crnaD9TfuUK60sJmCCGmtK0riNMxPu/8LF/a7uN7+yWdbu83v7Rj10ihSP/AMfG/wDx4/aPHkRqxTj4FB1V/peHEP8AkFjXoBfwMb9p7r38DB/Y3uHJpAhwrSTqFPG9hbpQxYSdQJ5OAufGf+kjaxeN4k0CECE2EPhAGoUvYCbiwrHHvxXsJcuC7oI1EjwXG54w2+zDxfPPuvYWM6deMTcTes5dQ771IEKDa4nZFPHlcXuXAZ+kHax+Pu+EhuZaCFQ0XDubwNFx33jBunF6aHWEIc2+Cfib2jyrf/jx+0eN4uNGipKL6Rp7ENHP802EwMhAADML1IUODnJJ1LDx2Q7XAdt4Q7nxT0U1ml6klBb+lvcOTwptsOxvaSfK9w5t0SxvaSNx5PAkOBpOA1VPgL2HnoTP1DUDU9l/BXTedIA9lPC8JK4To5+AuA6zSg1lFxLjjJTorxDYKkmg6ym3OlWSwzDH0nOdd7hzzIWi3tJPhS9AupMRBMt4TWtyVIxk4shGYFXH5n6n/crj8z9T/uVxua+p/wByENgYMgxe8cVn40Kxx1HGOwoB0WWOejh8sR8Lx9CcH7T3jxTpCZZMM+E9mdMmYQjQzUEVF57ZtsUj0S3L1KZum/gwRizk5Apa5Yq0cJ+kfCy+AKlfiE26KPZGIdQ3rDzmGORgr8ziHjewcq2DncewIxogY3OaIQ2BgzCnJwt0YpsNNQpepAixrSBqHnyccKD1nuA8b2EukDotJ8PG/wAGPCjWtI1Gv/a9E4pxMezwuEeugAvcYmTNvHosydZ3C/hrqRnWGmoAd4vUlo0a1wGoV8ffDCmWTYyOFD1jyX4dOsmMwND1HEUCKjImXQlnQH5HDUcx1qJJxnQIoo5poUJN3FZg+gTiNh3G9DjjgRWgiwiqZCZwGAAWDFyOCDIwDj+I+G9FxAblKFzpUQne0cbuvyvccnSG+y3EPHtXGZ4PzMx7u3k0WHiuin4iTrNb0ncyUEvEa4uqSaAU7xmopDRfqb9ykNF+pv3KRJoGO1N+69hLpFmiAPHxvVdGjdAGupPcL/Ck2RbHU1g7hfLiGjGShcySZAzgVPWcu7qF4AVRmIz4p+JxOs1vSNyZEQIrXF1STQCmPrcM1MyudoP1N+5XO0H6m/crm6D9TfuUO6cs2bhghrq0rlxEjMTZb7x+JyLoI9oY29Y35EQaFCcluKRT6bMnSM2rJe/E4eHlx/8ARvaLOuxTsxGEFsJwNc4IA61g4YZloKcqbZNuiQ2lzXGoIx5cxRlzxqbHpfCLOk9N4XOljQ+m7EN/yVVxOT4b/afj+Wbf8+TgJKLFsaddKDt5WHn4ML9Q1DGe69h5+M/9R1DEO69g5Av0nHsoN9/DXKijOKHUR4Vv8cnOMPHow8fzzast/i0hGi2NOulB28visjBg2Nbrpj7feeKRuOQR6D8vQfNRZCM2PBNHD+aKDdaXEaFlziw+rhSUIxoxoB/NAol0Y5jP+QsCN0I/DePQbjPTYN6pyYU3CMGMKtOUYx05sauXzX1O3q5fN/U7erl819Tt6uXzX1O3q5PM/U7epCSiiNAZRwyGrjlxZyReuW41MLGf1O+5XK5n6nfcoUnCEvBFGjIMZymufpvsmYb4UUVa4EEdBVyOZ+p33K5HNfU77lLXNZg5ZvBbWuUnH86m/CnoRgRxVpyipGeuUUKuPzP1P+5XG5n6n/crjcz9T/uVxuZ+p/3K43M/U/7lcbmPqf8Ad71Dm4RgxhVrhQqLciPwDjYfZNo3hRhdICH7JB4XV/Wnq4uGYD7FMVlc/wA6UUW6MYQYQ6zmAtUKRgiBDGIdpt/zqDNw8FHaHNsKlpIESzA2tnq4UwzgRmhwsKgygpBaGjo/2QN88o+pP+0NOVXkC+eQOUFVD1RRRRqiUUUU5FGxGxGxGxGxGxFEhFFFGxGxFGxGxFFFFH32qp7V4o3iiiiiiiijanWp0MYzjRtRtKdaUbSjaU+0p9pTrSn2lPtKdaU60p1pTwfSKihhig4gnaRTrSnWp1pTrSn2lG0o2lG1dJRtRtXSqDgon2UfdjetVnLr6gRCYz/Zbj3LCONnqzyGEOhxBiouAcWTN1Io3q+qog8UeiBXN7mEFiqgUxMUNQwodhUKwqDYVBsOtQbDrUGw61A0TrUtonWpbROvyUpoHX5KU0Dr8lKPPosOvyUKHVsQGhsNFJaB1qS0DrUroHWpb4WlQbFDzHsTbezzR0hq80dIbPmjpDZ808/ENnzT9MbPmommNnzUXTbs+ai6Y2fNRmEOD27PmosdlWOHCxVNK1txVxKNzjdjzUbnG7Hmo3Ot2PNR+dbs+ajabdnzUbTbs+ajH427PmovON2fNRNIbPmnWjZ8109nmmZ1CsKl7Cpaw61BGQHWoZdiBooYzFQ+lQ0xMQQ5VFW/VYqqidyzyyjewEFr4gNXY6+GrGnRXVRtTrU9PtTrU+1OGdRLU61OtTznT7U9OTrU9Vqw5ShN4QA1LHUyUxZsXZ8kU9PRTynpycnJyfaiBlRRRRVfaTImKtOlOgGj/UG/pXqrgBV9WOW2LGbhDRtUZh3BGTMOjz5Of1ZRRCjQ7qCZgj0Hij+g2gdOIql48iiN+irepyCxYqHGLE3KxU9QeQUTeIRRTk6xOsKiaJTzmKiWFRLColhUSwqLolRT8J1KPmYdSisFXtI+ScRw6eiFEeakID2lDHtEa1C0hrCgU9sawoA+NusKVzxW7QUpzrdoKSH+M3aCkeebtBSHPt2grn8+3aG9XP59u0Fc38wzaCub+YZtBXN59m0Fcz8wzaCuZ+YZtBXM/MM2grnwnCI2Ow5j6Q+WruKlzDEfht4B+KopryK535hm0Fc/8wzaCkOfZtBSHPt2hvUjz7dob1I8+3aG9SZyRm7QUpzjdoKW51u0FAOR7dYULM9usKHmcNYTDkcNYXT2hE5E45lE0Sop+EqMz4TqTn5inj2hRFHlFFURtRRCKJRRtT7Sn2p1pTxnKiWlRLSolpUS0qJpHWoukVF0jrUWIMpPQnsxNr4KIcpKKr7Q7F0diYfhGoKHoDUFBr/djZCg6A2RuUtzTdkblKn/AA27I3KS5puyFI8y3ZCuecsFuy1XN5luy3crncy3ZbuVzOZZst3K5vMt2W7lc3mm6m7lczmWbLdyuUXB5hNqK5hnUDBcWIbwCaAUFDjrSmQ9Kue0UfAaD+1quYP8Fuy1XO5luy3crn8w3ZbuUhzDdkKS5huyNylOYbsjcpbNBbsjcoPNN2RuULmhshQ9AbITdAaghmb2KmbsTrFEtUUZyowzlRtIqKc5UR4o4p+SqfaijepySOTT1ZRivKMuyuR2S8UUUUbUUbVW8Cm2BQ7AoWiNQULRGoKFojUFDPwjUoeiNSh6I1BQtEagoeiNSExBrCAD2nhNNM/moLY8JsY1LjQgj2a5/kRjUOwakwZghmF6iKNqNqKKKKKKN48k3zyaXzyDfKPIN4rgwi4IuilpzIoooo3jyDeKKKKKKKN4pkKZeG56HWnxpCFFflLRu9QUbxRRRRRRojeKN/8A/8QAIxEAAgIBBAMBAQEBAAAAAAAAAQIAEQMEBRASBhMgMBYVFP/aAAgBAwEBAgB48eNGjRo3B4EEEEAAlDgcD8a+6/A8n8hBFgiRIkWJEjTJGjxo0aNDweBAABAIAJQ4H3XFSua/Mw8Hg/IggiwRIkSLFiRpkjR40aGNwRwAAAABQAFAfNcVxVcVXFfgYYeD+AgixIkSJEgiFo0aPGjQw8HigKAAAoCqAqqripXFVVV+Z5PJ+hBBEgiRIkSLEjxo0aNG+SIAAAABQFUBQFVVVK4qqquKlfZhh4PJ+RBBEixIkQrFjR45eNyeaoAQAACgKAAqqqqqVKqqquKlfRh4PBh4P0IkWLEKFIhWNHjx40PB4rgAAAACgKAAqqqqlcVVVVcV+Bhh5PyfgQRYsUpEKRI0eNGjE8jmgAAAAKAoACqqqqVKqqqv1MMPBh/AEFShQqUiFC8csWhhMPwAkAAAAoCgAKqqqVxVVVVxX0eTDDyYYYeD8AgoQUKFCkU5IxYuWhhJI5AEAAAAqqAqqqqlcVVVX6Hkwww8kfA4BQqVKFChSMXjFi0J4EHAigAAAACqAqqlcVzVfFfieT8GHkjgSxFKFChQoULlyxYkmHgQQQBQIAAABVAVKlSq/CvyMMMPBhhh5PI4BBQoVKFChYsWjE/AgggCADDgzaMAACgKlSsODNpa+6/Mw8mGGGHkjgcWCCpQoUKFixMYfAAggijBh2ra/IyAIJQErivGzqtLqtLVcVX4mHgww8mHgww8GGHkEEFSpxlChaNDGBHFAACCLPG9s1Go1+vEAEqpXFYM2h1e66Cqr4x6X/hy6f4x4f8AgfRY9J/n5NGYeE0J23JoceiO1naztR2o7Tn0cuAgqVKFChaNwwIIIoQQRBs+hA8g3ATZtpzbWV4EqbZoN32mtr1oO96T62fHPJMnx4zjm+5PGMk3pDxp8GHFPKtf47i+fN8/IIilCkRkLQgggggiqEEA8U0u5aq9JptPg3vdJixPj52XcyNy0c2bU7zp/rTpN8yfHjyTybJ4081yHjxfRzU59Rn0uKbh5QfNP7b+43jc+RBEiRChQtGBBlEEVQAAm2YfKc4njGl1eoyZBPHcer0Ov2ngTa9Xvunnj+Z0dfjSY+NY/wAbXjnkeTZckIda23STynXaDFxr8phhh5MEBEQoUKFhCCKIIIoBJhUDyTIJsePyTMOPHuCNfsWXFPHcupxzanmsHxsmOZshN3aqizd8uDLxrk2HSTLl1mp8bxR5/I/x58O3LQmHkcCAqUOKMKIqqIIqhNFxv8E2ueT8CePfHkLTYODNv41vz45jm7ZJd3tmOE5chmiyTek8e0k8o1xniOL53zMYeRwIsSIcUYEEEUQQeRMLA+SIJseTyPEOPHuCdfvrvPHcWoyTakmtPx48k8hfi78dxzcMnGwZJuuiVXfX6ozxPFPJNx/pT5MfJ3Y8HgcLBEiRIwIqqI4MHAm2ZvKcAnjGp1WDJjnjuTWa/XbpwBtuk3zUV4/hyO5+NoxzyTJ8eMY55Bk48XyT/mnkutJM2LFPMc0MPB+BBFgiRIkYEEEGND8CCeK6rctLWk1GDNvW1iYsjvzsu2k7lrJs+m3nUXLuYcc3PaP5v+bPjc8exzyfKTfi+XgtuetJmDFN58f/AI/+O/jNbpDDDwOBFiTGEjAgg8NG4PAIm0awHf8AbxNm3XJuDtwOdt3Pdt1vatHN61fFzQ4/ncct7djnkmW5seXjyPXGXtuL63POTDwAAIoUYxjDAghgYY3B4EEE8d3LUafXaEcD5uXp8Gi0m76+7u7wZ/8Ad/3f93/e/wB7Pu1jff8Aez6iXiy/7/8AQavWEk6fU/0Z8kPkv9N/THyf4oABAgUIMYYMCGjRo0PAgAAGDLtu4+QDgfF3x42NZq9Tqviyb+Lu7u7sm7u7swww8Ek8ACIEVRjVAgYMCGDBoQRQAAAAGDNm1QFSqqqqsWXNqJd/hVVR5u7JuySbskmHgyoIgUIECKioDDGDRoQQZVACCCCCAUBVV169evTp16dOnXr169evXr169SpUr160RRh5Js/IgCgABVRUVFRSTDGBBUqV61QAFACCCCCDmqqqqqrrXXr16levXrRBBUqVKlSCDDDD9VQAChFRVVFVUWEEEFSCOvXr1qgAAKoACCDiqqqqiKqqqqoiiKoiEGGGGGEmH6EAACoqKioiKiopBBBUqU69SvXr169QKoADgCWPwI+rskw8GHgwk8H4IqpQAAVAioiIioqqgKFChUoUKdSnUjrVVBLEqhwObhYHsW7dr7Fu3buWLnKX7FzkOQ5C5cuWJLXcHAgACKioiKiKqKgRShUqU9Zx+s4+nQr1K9eoTp16hOoXr09fUqUWEdSpQp06FTjKFCvRsav1KlepQoRVdepFFIFChUVFRUVEUIqKoUUUKFehWuphBWBOvWqrgCXLstrM+OXLJvt39hyew5Dk9hybgcOpL9y5cuWLFu3btBKGNGESLECBVRUVAgUFSpQoUKFepRlKdSvQIVKdOgxnGcfq9RxHE+PLiOP1nEcRwnCcBwHD6Dh9RxHGcbYckOA4DgOD0nD6vX6wgxhAiqFGMKgREVFRUVQqoAChUqQQUKGFenUqV6kdenTr16detEUurXF1KlGUoyFShxlOhTp16dNUm35/UcXpOL0+r0+n1jF6lxJjCDGqDDeBkRFRUVQFAoqUKlSCvrIKlStFSvWq61XXqRNW+16KGNDGJJJZm7E9ixPbtbDDpQxNlu0UzqAAigIoVFRRjOmwssQJFAABWisYUQQQVKkQmWSW79i3c5TnOXPkGoOpOpbUHOcpcwocfrOL0+g4P+f/AJjgGDNoxPUcXr9fTqIGDjImZc6ZxqF1K51zJmVg2MoViRAYVMoqcZT19Chx+s4ji9JxeoYvV6jh9J0505w5NKdGdGdIdH/ynTnAcBxHEcZTp0qulQHKiDp6/X6fSNP/AMw0o0iaMaIaBNANCuhXRLpF0iaZMIxIoxhYQYVldSpToRRHXr069etFQpXKWVh1ZSjKV6FSrKVIogr169evXrmw4h6/WMfrGIYRiXEMYxjGiBFRUCqoUKFACAD4aGHmoVYV89YYg65phBBDRwwMaHhgYeesYV1466pMRggCgRREgixQoAEAWCACACACf//EAEURAAECAwIICwYFAwIHAAAAAAEAAgMEERBREhMhMUFSkdEFFCBTYXGSobHB4TAyQEKBoiIkYtLxUHLiY4AjJTNgZHDw/9oACAEDAQM/AMv+yLJ/7Xr/ALdYkw7AhAk3BRpU0jNLT0+ziTDsCECSo0saRmkf1p0xEEKEKk5lD4NhYIyuOc+XUoXETh56inX7NmA8fNXuUOchGHE/hRJOKYb/AOR/WeLwuNRB+J2boHqocrCMaIcgUXhCNjX5tAuHs4ks8RIZoQmTsIRG59IuKE5Bye8M272EaKMKGxxHQCVNc27sncosD/qNI6wRyYkc0hNJPQK+Cm+bd2TuUzDGE+G4AaSCo8duFDY4joBKm+ad2TuUzCbhxGOAvIIHImorQ9kNxB0hpI8FO8y7sncpqE3DiQ3AXlpA8FMzDMODDc4XgEjuCnuZd2XblPcw7su3Ke5h3ZduU/zDuy7cp/mH9l25TMsA6YY5oN4I8R8Px6abDdmznqCAFAuMxsQw/hb3n0zWcedjYvuDvN29SseFi8AC4gUIVDTlQIcs1xaCXCpJy50IQx8AZNIu6RYZOMCfdOQ7/oqri8xhjM7L9dPLxckzpqdp3WVeyHcCdv8AHJyxYnUPH0sxci4XkDvr5KsKJCuIO0elmMkIjeiuwg2vmYrYLM5NE2BDENmYCg+llS2TYc2V3XoHn9QsVwdD6anaTyqxIUG4E7cg8D8Pi5d0w7O40HUPVcTlXRtNMnWcyqap01GbBZnJTJaEIUPMFxccXgn8Rzm4b7IkU0YCT0J0E0eCD08jAIlomY5jd0IEUK4nHLBmOUdVnGJYNOduTcsfKk6W5d/LxUJrLgB3WYc44XADur58nAlK3uO7yspDZCvJOz+VSZcy9vgf5sxkrEZe0+FuHFdMnM3IOs5+7xsbLQnRn5miqdMxXRn53GqxEBkPVAGwWCSmXy4h4WDpwqaLsEr/AEPu/wAV/off/iv/AB/v/wAUeFpnHluDkApWubpoL/h+LycOH0DvylUYyCNOXyHnYPxTJ6h5oSsF0Z2gJ8dxivzmxoli+mUlQZ1mDFH10hRpPLnbfvtouNywec4yFY2WxgztPcbMCOYV48EIjCw6QsB5Fx5ONjsZe4eNuNmHvvcfHk4qTht6K7cvnZhzQZc3xJ9Fi55hvybRZUURYS06FVcSlWwdNMvWc9lA2TZpyu8gsfNQ4d7h424+aixb3Hx+Kw4gbeQqCiwp7BuaN9mLkWdOVYEu2HefC38qes2VTItXy2Q3aDuUSA7AiChFlHuhXiqxsFzLwbMCbYenxspMxR+o+J5OHON6KnusxUJz7gTs5JeQG6UGgAaLMbOxDcabMixUVsW4g7Dbi5qKy5x8VxqbDj7rcp8u+xsCGYj8wFSnzkZ0Z+dx/gfQLGcINOqCe6nibDgHAz0yKe1m7XftU7rM2u/ap4/Mza79qfwdHMtFILhTNWmXLpA+H/47P7h42f8AMHdQ8LPyUPqCyw/r5W/lT1nkQ6Mb83lZ+a+hWRZSvzTP7h42fmon9zvE8msWJEuAG3+LMXJPN+TaeTjZyGOmuzL5WUFVjYhedJJ22Y2WY+9o8LMXPxR012gFcXlMYc78v00b7MXCEqw5XZT1DNtNlY0WLcANpr5crjHCEZ/6iNmTy+HwHg3EKoqsGereBusxkizoybFhS7Yg0Hxt/KnrNgAqcyDawpbKb9ydEOG81JsrEfFuFFioTn3A2YU2zr8LKzMV36j48mku5958BZSXay8+A5OFN11QT5edmKlYj+g7rcZIN6KjvsMzws2EPmAJ6hn7ggwUGYIQ2F78gAqUZ2O6MdJydWizAlHRL3eAFkbg+Cwy7qOJuByAdNehcKc59rdy4U5z7W7lwrzv2t/ajEJJzn4jHycOJ+kd2RVayONFQfEednvS56x5oTMF0E6QnwIhhPzixplyyuUFQZFtYhy6BpKjTpocjbt99tVxOAGHOcp61ipbFjO7wsw4xiXDxQhsLzoCw3E38nFyTBeK7TWysVkO4E7f45OSJE6h4+lmLkSNYgeflbWC+HcQdo9LG8Z4zpwcHvrZiYAlmZ35+obzbiuDoYvFdprZWPDhXNJ2n/H4zDl3S5ztNR1H1XHJV8HTTJ1jMiDQp0nGbGZoKbMQxEZmK4wMfBH4hnF432OhmrCQehPiGrzU8ipEzFGT5R5oAVOZccjl4zDILOLywrndl3LESpbpdk38mqxMNrLgBssmZ2OYrCKUAFSdymtZu07lN6zdp3KaArhN2n9tmBJB2sSfLysoIcPrPh620mXMvb4H1tDRU5gjPzLo2jR1DNvsqsTCbDGgAbBSyb4TmzGhuaG0AFSa5PodNVPazNrv2qe1mbXftU/rM2u/aokjMOlohBLc9M2aumnxHEZpsQ5sx6igRULi8bHsH4Xdx9c9nEn4qJ7h7jfvUtCh4xzxToOdYbi688qXdLtY9waQKZciEUYiAcmk39HVYZyMK+6Mp3fWzjMzgDM3J9dPJxsyxn6hysTKRX9B78lmKlIbOgd9mHNhmqB35bcVPs6ajaN9vFpXEs95+T6abcdOQ2XuGyuXu5fGJ2LFvcdlcnd8TxiFxaIfxNzdI9FDm4RgxBkKiSMUwn/Q3j2b5mIIcMVJTJKEIbPqbyuJwcFnvuzb+VEl4giQjQj/AO0qf1+5u5T+v3N3Kf1+5u5T+v3N3Kf5zubuU3MwzCiPq09AHgLJ8DBD+5u5cIc53N3KJMxDEiGrjp7rXwXCKzIQajrC4R5zubuXCPO/a3co067GR3VNKaPK2JKRRGgmjhmOQ9GlcJ859rdy4U537W7lwpzv2t3LhXnPtb+1cK899rf2rhXnvtb+34qJLxBEhGhCh8IQsMZHDOFCMkS/PUU6/wCPZsxT9avdoUOShGJE+gvKfNxTEiZz3dH9aiS7sOESD0KNMmsZxd1+ziQH4cMkHoUWYNYjiT0/9lH/AGBn4CnsBYLQggggmoIIIIIIIAoIIIcoIe3r7eltOWLQghchcg85ELkLkLkLkLkLkLkLkLkLghcELghcECMyZhBhGVC5AaELkLkLkLkBoCB0IIIWBVyoDOFd7Yeyu9lTlFgEIZ3LAZyDZTlCwJ7AIzM7cu9NmITYrMxFbBYPZlmZVz5OVT2FbCLTadCcnpyiFOvURPvT7wol6iVzhRb+5RbxsUbWGxR9YbFH1hsUcD3hsUWJTFEVvpVTY+cbPVTeuNnqpvnW9n1U7zrez6qe51vZ9VP86Oz6qf51vZ9VP863s+qn+cb2fVT/ADjez6qf51vZ9VP863s+qnudb2fVT3ODs+qn+db2fVTzxgl7eyo0OG2GCA7Tk0dAU7zo2Ke50bFPc6Nnqp7nR2fVTvOjZ6qd50bPVT3ODZ6qe5wdn1U8PnHZ9VOa47PqpvXGxTWsNimdYbFM6w2KPeNijXjYnBmiqiXhRE9PRRR9lRCqr8EI8Z8Nh93J6oQxgpqCCCbcmXJtyYNCZcmXJlyYmplyZcm3LFERmdRUOZDmE1LT3JiYmIXIJlyYmoXIXIXIFBC6wKmZPZl7kyKKt9sXqns+jkG2JDguxY/FTIuLQvx+9nPX6W6PaC0PBadK4nNujA5TkpT3unoFMqDxW0+wpyq51lq1HM/kZPZBBC+wIXoXoIIdCZemXhNvCZeFDvChj5htULS4KETQOBTIeR5AKlwKYQ2qDrjaoJzPG1QtDhtUO8IXqvuo3FRNAOxRNU7FF1TsUXVOxRj8p2FRj8p2FRx8rthUbVdsKjarthUxqHYVMajthUwSHtY6vUU9jsChqdGmqjap2FRR8p2FRNU7CouqdhUTSDsRuOywBQ71C1goJ+YKDrDaoGuNqga42qBrjaoJ+YbVB1htUHWG1Qn5nBAaUChVCwWVsFgKFgQQQKCCCbcmoXJlwQuTLgmHQFDuCh3BQmGtAKKHF98AqDoaNig6oUK4KFcFDGgJvQheF096Ot3oj5u9PHzd6iH5u9RB83eVE1jtKiax2lRNY7Somue0VE1z2in84e0VF5w9ooihJqSc6iPFS47Sna3eU+vvd5RPzd5X6u8r9XemHSNqh3jaoRuUG4KD8wCgarVL6rdgUDVbsUDVbsCl9Vqg6o2KDqhQrgoVwTAciFaoKiFo5dPa1QhjKhFdg5wLaIGyiqhcguj2QQWMZgjIVjWh+2vkgggm3IXIXIIDQhcggLBZTl15VDkspyRVAcsWhBYUQNKGAhaEOSLclgsFgtCAimnWiWivIFg5FUELRaLAqZrf/9k=\" \nwidth=\"400\" class=\"brad-3\"></div><div ng-if=\"vm.urlVignette2==\'\' && vm.lives.conf.image\"><img \nng-src=\"{{vm.lives.conf.image}}\" width=\"400\" class=\"brad-3\"></div><div ng-if=\"vm.urlVignette2\"><img \nng-src=\"{{vm.urlVignette2}}\" class=\"brad-3\" width=\"400\"></div><div layout=\"column\"><div class=\"mv-24\" \nid=\"filef2-uploader\" flow-init=\"vm.ngFlowOptions2\" flow-name=\"vm.ngFlow2.flow\" flow-files-submitted=\"vm.uploadFile2()\" \nflow-file-added=\"vm.filef2Added($file)\" flow-file-progress=\"vm.uploadingInPogressf2 = 1\" \nflow-file-success=\"vm.filef2Success($file, $message)\" flow-complete=\"vm.uploadf2Complete()\" \nstyle=\"top: -24px;right: 0\"><div class=\"upload-button\" layout=\"row\"><md-button flow-btn \nclass=\"add-file-button md-primary md-raised md-icon-button\" aria-label=\"form_add_file\" \nng-disabled=\"vm.uploadingInPogressf2\" translate translate-attr-aria-label=\"MESSAGES.form_add_file\"><md-icon \nmd-font-icon=\"icon-camera\"></md-icon></md-button><md-progress-circular style=\"margin-top: 3px\" \nng-if=\"vm.uploadingInPogressf2\" class=\"md-primary mh-10\" md-diameter=\"20\"></md-progress-circular></div></div>\n<md-input-container flex><label class=\"md-no-float\" translate=\"LIVESADD.form_attr_imageText\">\nAjoutez un texte pour l\'afficher sur l\'image choisie</label><textarea id=\"empLivesForm_conf_imageText\" \nname=\"empLivesForm[conf][imageText]\" ng-attr-name=\"imageText\" translate=\"\" ng-model=\"vm.empLivesConfForm.imageText\" \nrows=\"5\" aria-invalid=\"false\"></textarea></md-input-container></div></div></div><div><md-radio-button value=\"Counter\">\n<label translate=\"LIVESADD.form_attr_Counter\">form_attr_Counter</label></md-radio-button></div><div><md-radio-button \nvalue=\"Pearl\" has-permission=\"lives_encoder_no_api\"><label translate=\"LIVESADD.form_attr_pearl\">form_attr_pearl</label>\n<span translate=\"LIVESADD.form_attr_pearl_tag\" style=\"color: rgba(0,0,0,0.54);font-size: small\">form_attr_pearl_tag\n</span></md-radio-button></div></md-radio-group></div></div></md-content></md-tab></md-tabs></md-content></form></div>\n</div></div></div></div>");
$templateCache.put("app/main/media/lives/live/views_add_edit_live/add_rich_media.modal.html","<md-dialog style=\"min-width: 70%\" aria-label=\"-\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\"><h2><span \ntranslate=\"MESSAGES.{{vm.action}}_{{vm.type}}\">info_detail_pagetitle</span> <span>{{vm.title}}</span></h2><span flex>\n</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\"><md-icon md-font-icon=\"icon-close\" class=\"s24\" \ntranslate translate-attr-aria-label=\"MESSAGES.alert_close\" ng-click=\"vm.cancel()\" aria-label=\"alert_close\"></md-icon>\n</md-button></div></md-toolbar><form ng-submit=\"vm.addRm(vm.action, vm.type)\" name=\"empRmForm\"><md-dialog-content \nclass=\"md-dialog-content\" ng-if=\"vm.type==\'chapter\'\"><md-input-container class=\"md-block\"><label><span \ntranslate=\"MESSAGES.chapter_tooltip\">chapter</span></label><input type=\"text\" name=\"empRmForm[title]\" \nng-model=\"vm.empRmForm.title\" required=\"required\"></md-input-container></md-dialog-content><md-dialog-content \nclass=\"md-dialog-content\" ng-if=\"vm.type==\'survey\'\"><md-input-container class=\"md-block\"><label><span \ntranslate=\"MESSAGES.question_tooltip\">question</span></label><input type=\"text\" name=\"empRmForm[title]\" \nng-model=\"vm.empRmForm.title\" required=\"required\"></md-input-container><md-radio-group ng-model=\"vm.empRmForm.nsp\" \nname=\"empRmForm[nsp]\"><md-radio-button value=\"0\"><label translate=\"LIVESADD.form_attr_on\"></label></md-radio-button>\n<md-radio-button value=\"1\"><label translate=\"LIVESADD.form_attr_onp\"></label></md-radio-button><md-radio-button \nvalue=\"2\"><label translate=\"MESSAGES.simple_choice\"></label></md-radio-button><md-radio-button value=\"3\"><label \ntranslate=\"MESSAGES.multiple_choice\"></label></md-radio-button></md-radio-group><div class=\"responses_question\" \nng-if=\"vm.empRmForm.nsp==2 || vm.empRmForm.nsp==3\"><md-input-container class=\"md-block\" \nng-repeat=\"choice in vm.choicesQuestion\"><label><span translate=\"MESSAGES.answer\">answer</span></label><input \ntype=\"text\" name=\"empRmForm[choices][]\" ng-model=\"choice.response\" ng-required=\"{{choice.required}}\"> <a tooltips \ntooltip-template=\"{{\'MESSAGES.action_delete\'|translate}}\" ng-if=\"!choice.required\" tooltip-side=\"left\" \ntooltip-speed=\"fast\"><md-button class=\"m16 delete-button md-icon-button\" ng-click=\"vm.deleteAnswer(choice)\" \naria-label=\"action_delete\" translate translate-attr-aria-label=\"MESSAGES.action_delete\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></a></md-input-container></div><div \nng-if=\"vm.empRmForm.nsp==2 || vm.empRmForm.nsp==3\"><md-button class=\"md-raised md-accent block\" \nng-click=\"vm.addAnswer()\" translate=\"MESSAGES.add_answer\">add_answer</md-button></div></md-dialog-content><div \nng-if=\"vm.type==\'slides\'\" class=\"e-commerce-product\"><div layout-padding layout-margin \nclass=\"product-detail-form-container dnd-file-upload\"><div class=\"product-image-uploader\" \nflow-init=\"vm.ngFlowOptionsSlide\" flow-name=\"vm.ngFlowSlide.flow\" flow-files-submitted=\"vm.uploadSlide()\" \nflow-file-added=\"vm.slideAdded($file)\" flow-file-progress=\"vm.slideProgress($file)\" \nflow-file-success=\"vm.slideSuccess($file, $message)\" flow-complete=\"vm.uploadSlideComplete()\" flow-drop \nflow-drag-enter=\"vm.dropping=true\" flow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\':vm.dropping}\"><div \nclass=\"drop-text hint-text\" layout=\"row\" layout-align=\"center center\"><span translate=\"MESSAGES.drop_to_upload\">\ndrop_to_upload</span></div><div class=\"upload-button\" layout=\"column\" layout-align=\"center center\"><md-icon \nstyle=\"padding-right: 43px; font-size: 50px !important;opacity: .25\" md-font-icon=\"icon-cloud-upload\" class=\"s24\">\n</md-icon><md-button style=\"margin-top: 15px\" flow-btn ng-disabled=\"vm.inProgressSlide\"><span \nstyle=\"font-size: 16px; color:#b0b0b0\" translate=\"MESSAGES.upload_slides_image\" ng-if=\"vm.typeSlide==\'Image\'\">\nchoose_a_file</span> <span style=\"font-size: 16px; color:#b0b0b0\" translate=\"MESSAGES.upload_slides_video\" \nng-if=\"vm.typeSlide==\'Video\'\">choose_a_file</span></md-button><md-button class=\"md-warn md-flat\" \ntranslate=\"MESSAGES.form_cancel\" ng-click=\"vm.cancelUploadSlide()\" ng-if=\"vm.inProgressSlide\">form_cancel</md-button>\n</div><div layout=\"row\" layout-align=\"center center\" layout-wrap ng-switch=\"vm.inProgressSlide\"><div><p \nclass=\"secondary-text mt-8 text-center\"><strong>{{vm.videoFilePre.name}}</strong></p><p \nclass=\"secondary-text mt-8 text-center\" ng-if=\"vm.progressBarValueSlide\"><strong>\n{{vm.roundWithPrecision(vm.progressBarValueSlide,2)}}%</strong></p></div></div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div ng-switch=\"vm.inProgressSlide\"><div ng-switch-when=\"true\">\n<md-progress-circular class=\"md-accent\" md-diameter=\"70\" md-mode=\"determinate\" ng-value=\"vm.progressBarValue\">\n</md-progress-circular></div></div></div></div></div></div><md-dialog-actions layout=\"row\" \nng-if=\"vm.type==\'chapter\' || vm.type==\'survey\'\"><md-button ng-click=\"vm.cancel()\" translate=\"MESSAGES.alert_close\">\nalert_close</md-button><md-button class=\"md-raised md-accent block\" ng-click=\"vm.addRm(vm.action, vm.type)\" \ntranslate=\"MESSAGES.form_validate\" ng-disabled=\"empRmForm.$invalid\">form_validate</md-button></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/media/lives/live/views_add_edit_live/pagination.html","<div class=\"range-btn\"><a href=\"\" title=\"Previous page\" data-pag=\"{{pagination.current}}\" \nng-class=\"{ disabled : pagination.current == 1 }\" ng-click=\"setCurrent(pagination.current - 1)\">&lsaquo;</a> <a \nhref=\"\" title=\"Next page\" ng-class=\"{ disabled : pagination.current == pagination.last }\" \nng-click=\"setCurrent(pagination.current + 1)\">&rsaquo;</a></div><div class=\"range-label\">\n{{ range.lower }} - {{ range.upper }} de {{ range.total }}</div>");
$templateCache.put("app/main/media/video/rich-media/survey-quiz/quiz.modal.template.html","<md-dialog style=\"width: 400px\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span class=\"title\"><md-icon md-font-icon=\"icon-poll-box\" \nclass=\"s24\"></md-icon><span>Quiz</span></span></h2><span flex></span> <a tooltips \ntooltip-template=\"{{\'MESSAGES.alert_close\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"CLOSE\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></a></div>\n</md-toolbar><div layout=\"column\"><md-content layout-align=\"center center\"><form name=\"empQuizForm\" method=\"post\" \nid=\"empQuizForm\" novalidate=\"novalidate\" ng-submit=\"empQuizForm.$valid && vm.submitAddQuizForm()\"><div layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container style=\"width: 370px\" flex>\n<label translate=\"VIDEOLIST.form_attr_question\" for=\"empQuizForm_question\" class=\"required ng-scope md-required\">\nform_attr_question</label><input type=\"text\" id=\"empQuizForm_question\" name=\"empQuizForm[question]\" \nng-model=\"vm.question\" ng-name=\"question\" ng-attr-name=\"question\" required><div \nng-messages=\"empQuizForm.question.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div \nstyle=\"display:inline\"><md-radio-group ng-model=\"vm.nsp\"><md-radio-button value=\"1\" class=\"md-primary\"><label \ntranslate=\"MESSAGES.simple_choice\">Choix simple</label></md-radio-button><md-radio-button value=\"0\"><label \ntranslate=\"MESSAGES.multiple_choice\">Choix multiple</label></md-radio-button></md-radio-group></div><div \nng-repeat=\"elemnt in vm.questionelemnt\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nstyle=\"width: 370px\" flex><label for=\"empQuizForm_reponse\" class=\"required ng-scope md-required\" \ntranslate=\"MESSAGES.answer\">Reponse</label><input type=\"text\" id=\"empQuizForm_reponse\" name=\"empQuizForm[reponse]\" \nng-model=\"elemnt.choice\" ng-name=\"reponse\" ng-attr-name=\"reponse\" required><div \nng-messages=\"empQuizForm.reponse.$error\" role=\"alert\"><div ng-message=\"required\" translate=\"MESSAGES.form_is_required\">\nform_is_required</div></div></md-input-container></div></div><div><md-button ng-disabled=\"vm.questionelemnt.length>=5\" \nng-click=\"vm.addFormField($event)\" aria-label=\"add\" translate translate-attr-aria-label=\"SONDAGEADD.add\" \nclass=\"md-accent md-raised\">{{ \'MESSAGES.add_answer\'|translate }}</md-button></div></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\" aria-label=\"form_cancel\" \ntranslate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel</md-button><md-button \nng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empQuizForm.$invalid || empQuizForm.$pristine\" translate=\"MESSAGES.form_add\">form_add</md-button>\n<md-button ng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empQuizForm.$invalid || (empQuizForm.$pristine && !vm.delete_question_is_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></div></form></md-content></div></md-dialog>");
$templateCache.put("app/main/media/video/rich-media/survey-quiz/survey.modal.template.html","<md-dialog style=\"width: 400px\" aria-label=\"configuration_server_detail_pagetitle\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\"><h2 class=\"md-toolbar-tools\"><span class=\"title\"><md-icon md-font-icon=\"icon-poll\" \nclass=\"s24\"></md-icon><span>Question</span></span></h2><span flex></span> <a tooltips \ntooltip-template=\"{{\'MESSAGES.alert_close\'|translate}}\" tooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button \nclass=\"md-icon-button\" aria-label=\"CLOSE\" ng-click=\"vm.closeDialog()\" translate \ntranslate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></a></div>\n</md-toolbar><div layout=\"column\"><md-content layout-align=\"center center\"><form name=\"empSondageForm\" method=\"post\" \nid=\"empSondageForm\" novalidate=\"novalidate\" ng-submit=\"empSondageForm.$valid && vm.submitAddSondageForm()\"><div \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-gt-sm=\"row\"><md-input-container \nstyle=\"width: 370px\" flex><label translate=\"VIDEOLIST.form_attr_question\" for=\"empSondageForm_question\" \nclass=\"required ng-scope md-required\">form_attr_question</label><input type=\"text\" id=\"empSondageForm_question\" \nname=\"empSondageForm[question]\" ng-model=\"vm.question\" ng-name=\"question\" ng-attr-name=\"question\" required><div \nng-messages=\"empSondageForm.question.$error\" role=\"alert\"><div ng-message=\"required\" \ntranslate=\"MESSAGES.form_is_required\">form_is_required</div></div></md-input-container></div><div \nstyle=\"display:inline\"><md-radio-group ng-model=\"vm.nsp\"><md-radio-button value=\"1\" class=\"md-primary\"><label \ntranslate=\"VIDEOLIST.form_attr_on\">form_attr_on</label></md-radio-button><md-radio-button value=\"0\"><label \ntranslate=\"VIDEOLIST.form_attr_onp\">form_attr_onp</label></md-radio-button></md-radio-group></div></div><div \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-warn\" ng-click=\"vm.closeDialog()\" \naria-label=\"form_cancel\" translate=\"MESSAGES.form_cancel\" translate-attr-aria-label=\"MESSAGES.form_cancel\">form_cancel\n</md-button><md-button ng-if=\"vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empSondageForm.$invalid || empSondageForm.$pristine\" translate=\"MESSAGES.form_add\">form_add</md-button>\n<md-button ng-if=\"!vm.isNew\" type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"empSondageForm.$invalid || (empSondageForm.$pristine && !vm.delete_question_is_not_pristine)\" \ntranslate=\"MESSAGES.form_validate\">form_validate</md-button></div></form></md-content></div></md-dialog>");
$templateCache.put("app/main/media/video/list/sidenav/details-sidenav.html","<div class=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\" \ntranslate=\"MESSAGES.preview\">Aperçu:</div><div style=\"cursor: pointer\" \nng-click=\"vm.previewVideo($root.selectedVideo ,$event)\" layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{$root.selectedVideo.logo}}\"> <span class=\"text-center font-size-12 mt-8\">{{$root.selectedVideo.title}}</span>\n</div></div><md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\" translate=\"MESSAGES.details\">\nDetails:</div><table><tr><th class=\"start\" translate=\"MESSAGES.title\">Titre</th><td style=\"border-right: 0\">\n{{$root.selectedVideo.title }}</td></tr><tr><th class=\"start\" translate=\"MESSAGES.form_attr_contributor\">Contributeur\n</th><td style=\"border-right: 0\">{{$root.selectedVideo.contributor.lastName }}</td></tr><tr><th class=\"start\" \ntranslate=\"MESSAGES.form_attr_themes\">Themes</th><td style=\"border-right: 0\"><ul ng-if=\"$root.selectedVideo.themes\" \nstyle=\"margin-left: -40px\"><li ng-repeat=\"v in $root.selectedVideo.themes\">{{v.title}}</li></ul><p \nng-if=\"$root.selectedVideo.themes.length===0\" translate=\"MESSAGES.none\" md-colors=\"{color: \'#000000\'}\"></p></td></tr>\n<tr><th class=\"start\" translate=\"MESSAGES.nb_visits\">Nombre de visites</th><td style=\"border-right: 0\">{{vm.visits}}\n</td></tr><tr has-permission=\"media_video_list_show_date\"><th class=\"start\" translate=\"MESSAGES.start_date\">Start date\n</th><td style=\"border-right: 0\">{{ $root.selectedVideo.startDate }}</td></tr></table></div><md-divider></md-divider>\n<div class=\"theme-option color-palettes\"><div class=\"option-title\">Actions:</div><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><action-button-video video=\"$root.selectedVideo\" layout=\"row\" \nlayout-align=\"start start\" layout-wrap></action-button-video></div></div></div>");
$templateCache.put("app/main/stats/charts/components/ChartView/audience-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url!==\'/stat/dashboard\'\"><md-card-title-text class=\"border-bottom\"><span \nclass=\"md-headline\">{{ $ctrl.chart_title |translate }}</span></md-card-title-text><div class=\"pv-8\" layout=\"row\" \nlayout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-if=\"$ctrl.permission===\'live_by_id\'\" ng-repeat=\"(key,range) in $ctrl.widget_audience.ranges\" \nng-disabled=\"$ctrl.widget_audience.currentRange === key\" ng-click=\"$ctrl.setQueryStatsFilter(key,range.code)\">\n{{range.value}}</md-button></div></md-card-title><md-card-content layout=\"column\" layout-align=\"space-between\"><div \nlayout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart id=\"{{ $ctrl.id_bar }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart GraphBar\" ng-class=\"$ctrl.showGraphBar && \'show\'\"></highchart><div \nflex=\"100\" layout=\"column\" ng-if=\"$ctrl.showGraphPie\"><div layout=\"row\"><highchart id=\"{{ $ctrl.id_pie }}\" \nconfig=\"$ctrl.pieConfig\" class=\"h-400 remove-x-lines remove-opacity\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"100\">\n</highchart></div><div layout=\"row\" layout-align=\"center center\"><md-radio-group ng-model=\"$ctrl.selectedSerieName\" \nng-change=\"$ctrl.changeSeries()\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"100\" \nstyle=\"overflow: hidden;margin-top: 25px;margin-left: 60px\"><md-radio-button \nng-repeat=\"serie in $ctrl.pieConfig.list_select\" ng-value=\"serie.val\" style=\"float: left;clear: none\"><span \nstyle=\"font-size: 12px; font-weight: bold;display:block;float: left;clear: none;padding: 2px 1em 0 0\">\n{{ serie.option }}</span></md-radio-button></md-radio-group></div></div><table ng-if=\"$ctrl.showGraphTable\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"$ctrl.graphe.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::$ctrl.graphe.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ column.title }}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::$ctrl.graphe.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{ cell.classes }}\">\n{{ cell.value }}</span></td></tr></tbody></table></div><div class=\"pb-64 pt-64\" flex-gt-xs=\"100\" \nng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any ng-if=\"$ctrl.chartConfig.loding_disabled\">\n{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div><md-card-actions has-permission=\"stats_button\" \nlayout=\"column\" flex-gt-xs=\"5\" ng-if=\"$ctrl.chartConfig.loding_disabled && $ctrl.enabled\"><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" ng-click=\"$ctrl.viewInTable()\"><md-icon \nng-class=\"$ctrl.showGraphTable && \'md-accent\'\" class=\"s20\" md-font-icon=\"icon-table-large\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-click=\"$ctrl.viewInPie()\"><md-icon \nmd-font-icon=\"icon-chart-pie\" ng-class=\"$ctrl.showGraphPie && \'md-accent\'\" class=\"s20\"></md-icon></md-button><md-button\n class=\"md-icon-button\" aria-label=\"Settings\" ng-click=\"$ctrl.viewInBar()\"><md-icon md-font-icon=\"icon-chart-bar\" \nng-class=\"$ctrl.showGraphBar && \'md-accent\'\" class=\"s20\"></md-icon></md-button><md-button class=\"md-icon-button\" \naria-label=\"Share\"><md-icon md-font-icon=\"icon-file-image\" class=\"s20\" ng-click=\"$ctrl.exportChart(\'image\')\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-file-pdf\" class=\"s20\" \nng-click=\"$ctrl.exportChart(\'pdf\')\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon\n md-font-icon=\"icon-file-excel\" class=\"s20\" ng-click=\"$ctrl.exportChart(\'excel\')\"></md-icon></md-button>\n</md-card-actions></div></md-card-content>");
$templateCache.put("app/main/stats/charts/components/ChartView/datatable-themes-widget.html","<md-card><div id=\"e-commerce-products\" class=\"\" layout=\"column\"><div class=\"content-card fullpage\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\" \nstyle=\"overflow:hidden\" datatable=\"\" dt-instance=\"$ctrl.dtInstance\" dt-options=\"$ctrl.dtOptions\" \ndt-columns=\"$ctrl.dtColumns\"><thead><tr><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\">Id</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\">\n<span class=\"column-title center-span\" translate=\"THEMELIST.title\">title</span></div></th><th class=\"secondary-text\">\n<div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"THEMELIST.startDate\">startDate\n</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"THEMELIST.endDate\">endDate</span></div></th><th class=\"secondary-text\"><div\n class=\"table-header centerdiiv\"><span class=\"column-title center-span\" translate=\"THEMELIST.total_registrations\">\nTotalRegistrations</span></div></th><th class=\"secondary-text\"><div class=\"table-header centerdiiv\"><span \nclass=\"column-title center-span\" translate=\"THEMELIST.registrations_ongoing\">RegistrationsOnGoing</span></div></th><th \nclass=\"secondary-text\" data-priority=\"1\"><div class=\"table-header centerdiiv\"><span class=\"column-title center-span\" \ntranslate=\"MESSAGES.actions\">actions</span></div></th></tr></thead></table></div></div></div></md-card>");
$templateCache.put("app/main/stats/charts/components/ChartView/mesure-by-ip-widget.html","<ms-widget flippable=\"true\"><md-progress-linear md-mode=\"query\" ng-disabled=\"$ctrl.mesureConfig.loding_disabled\" \nclass=\"md-accent\"></md-progress-linear><ms-widget-front class=\"p-16 white-fg\" \nstyle=\"background-color: {{ $ctrl.mesureConfig.color }}\" ng-style=\"{\'background-color\': $ctrl.mesureConfig.color}\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{ $ctrl.mesureConfig.title |translate }}</div>\n</div></div><div class=\"pb-24\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">\n{{$ctrl.mesureConfig.value.used}}</div><div class=\"h2 secondary-text pl-8\">/ {{$ctrl.mesureConfig.value.total}}</div>\n</div><md-progress-linear md-mode=\"determinate\" ng-value=\"$ctrl.mesureConfig.value.percentage\"></md-progress-linear>\n<div class=\"secondary-text\">{{$ctrl.mesureConfig.value.percentage}} %</div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/stats/charts/components/ChartView/mesure-widget-temps-reel.html","<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex>\n<div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\" \nstyle=\"color:{{ $ctrl.mesureConfig.visite_total.color }}\" ng-style=\"{\'color\':$ctrl.mesureConfig.visite_total.color}\">\n{{ $ctrl.mesureConfig.visite_total.value }}</span> <span class=\"font-weight-500 secondary-text\">\n{{ $ctrl.mesureConfig.visite_total.title |translate }}</span></div><div><md-icon md-font-icon=\"vm.icon\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\" ng-if=\"!$ctrl.query.vod_id\"><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex><div class=\"pl-8\" \nlayout=\"column\" layout-align=\"center start\"><span class=\"md-display-1 pb-8\" \nstyle=\"color:{{ $ctrl.mesureConfig.video_total.color }}\" ng-style=\"{\'color\': $ctrl.mesureConfig.video_total.color}\">\n{{ $ctrl.mesureConfig.video_total.value }}</span> <span class=\"font-weight-500 secondary-text\">\n{{ $ctrl.mesureConfig.video_total.title |translate }}</span></div><div><md-icon md-font-icon=\"vm.icon\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/stats/charts/components/ChartView/mesure-widget.html","<ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><md-progress-linear \nmd-mode=\"query\" ng-disabled=\"$ctrl.mesureConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear>\n<ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 pb-8\" style=\"color:{{ $ctrl.mesureConfig.color }}\" ng-style=\"{\'color\':$ctrl.mesureConfig.color }\">\n{{ $ctrl.mesureConfig.value }}</span> <span class=\"font-weight-500 secondary-text\">\n{{ $ctrl.mesureConfig.title |translate }}</span></div><div><md-icon md-font-icon=\"{{$ctrl.icon}}\" \nclass=\"s48 hint-text\"></md-icon></div></div></ms-widget-front></ms-widget>");
$templateCache.put("app/main/stats/charts/components/ChartView/mooc-expedition-voyage-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-content\n layout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart \nng-if=\"$ctrl.showGraph\" id=\"{{ $ctrl.id }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart\"></highchart><table ng-if=\"$ctrl.showGraphTable\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"$ctrl.graphe.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::$ctrl.graphe.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ column.title }}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::$ctrl.graphe.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{ cell.classes }}\">\n{{ cell.value }}</span></td></tr></tbody></table></div><div class=\"pb-64 pt-64\" flex-gt-xs=\"100\" \nng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any ng-if=\"$ctrl.chartConfig.loding_disabled\">\n{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div><md-card-actions has-permission=\"stats_button\" \nlayout=\"column\" flex-gt-xs=\"5\" ng-if=\"$ctrl.chartConfig.loding_disabled && $ctrl.enabled\"><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" ng-click=\"$ctrl.viewInTable()\"><md-icon \nng-class=\"$ctrl.showGraphTable && \'md-accent\'\" class=\"s20\" md-font-icon=\"icon-table-large\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-click=\"$ctrl.view()\"><md-icon md-font-icon=\"icon-chart-bar\" \nng-class=\"$ctrl.showGraph && \'md-accent\'\" class=\"s20\"></md-icon></md-button></md-card-actions></div></md-card-content>");
$templateCache.put("app/main/stats/charts/components/ChartView/mooc-view-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url!==\'/stat/dashboard\'\"><md-card-title-text class=\"border-bottom\"><span \nclass=\"md-headline\">{{ $ctrl.chart_title |translate }}</span></md-card-title-text></md-card-title><md-card-content \nlayout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart \nng-if=\"$ctrl.showGraphBar\" id=\"{{ $ctrl.id_bar }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart\"></highchart></div><div class=\"pb-64 pt-64\" flex-gt-xs=\"100\" \nng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any ng-if=\"$ctrl.chartConfig.loding_disabled\">\n{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div></div></md-card-content>");
$templateCache.put("app/main/stats/charts/components/ChartView/mooc-views-voyage-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-content\n layout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart \nng-if=\"$ctrl.showGraph\" id=\"{{ $ctrl.id }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart\"></highchart><table ng-if=\"$ctrl.showGraphTable\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"$ctrl.graphe.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::$ctrl.graphe.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ column.title }}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::$ctrl.graphe.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{ cell.classes }}\">\n{{ cell.value }}</span></td></tr></tbody></table></div><div class=\"pb-64 pt-64\" flex-gt-xs=\"100\" \nng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any ng-if=\"$ctrl.chartConfig.loding_disabled\">\n{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div><md-card-actions has-permission=\"stats_button\" \nlayout=\"column\" flex-gt-xs=\"5\" ng-if=\"$ctrl.chartConfig.loding_disabled && $ctrl.enabled\"><md-button \nclass=\"md-icon-button\" aria-label=\"Favorite\" ng-click=\"$ctrl.viewInTable()\"><md-icon \nng-class=\"$ctrl.showGraphTable && \'md-accent\'\" class=\"s20\" md-font-icon=\"icon-table-large\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" aria-label=\"Settings\" ng-click=\"$ctrl.view()\"><md-icon md-font-icon=\"icon-chart-bar\" \nng-class=\"$ctrl.showGraph && \'md-accent\'\" class=\"s20\"></md-icon></md-button></md-card-actions></div></md-card-content>");
$templateCache.put("app/main/stats/charts/components/ChartView/mooc-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-content\n layout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart \nng-if=\"$ctrl.showGraph\" id=\"{{ $ctrl.id }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart\"></highchart></div><div class=\"pb-64 pt-64\" flex-gt-xs=\"100\" \nng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any ng-if=\"$ctrl.chartConfig.loding_disabled\">\n{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div></div></md-card-content>");
$templateCache.put("app/main/stats/charts/components/ChartView/quiz-by-theme-widget.html","<md-progress-linear ng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -32px\" md-mode=\"query\" \nng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-title \nng-if=\"$root.state.current.url==\'/stat/dashboard\'\" style=\"margin-top: -12px;margin-left: 18px\"><md-card-title-text \nclass=\"border-bottom\" style=\"padding-bottom: 0px\"><span class=\"md-headline\">{{ $ctrl.chart_title |translate }}</span>\n</md-card-title-text></md-card-title><md-progress-linear ng-if=\"$root.state.current.url!==\'/stat/dashboard\'\" \nmd-mode=\"query\" ng-disabled=\"$ctrl.chartConfig.loding_disabled\" class=\"md-accent\"></md-progress-linear><md-card-content\n layout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><div flex-gt-xs=\"95\" ng-if=\"$ctrl.enabled\"><highchart \nng-if=\"$ctrl.showGraph\" id=\"{{ $ctrl.id }}\" config=\"$ctrl.chartConfig\" \nclass=\"h-400 remove-x-lines remove-opacity chart\"></highchart><table ng-if=\"$ctrl.showGraphTable\" \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"$ctrl.graphe.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::$ctrl.graphe.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{ column.title }}</span></div></th><th>Action</th></tr></thead><tbody><tr \nng-repeat=\"row in ::$ctrl.graphe.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{ cell.classes }}\">\n{{ cell.value }}</span></td><td><a tooltips tooltip-template=\"{{\'DIRECTIONLIST.detail_direction\'|translate}}\" \ntooltip-side=\"bottom\" tooltip-speed=\"fast\"><md-button class=\"show-button md-icon-button\" ng-click=\"$ctrl.click(row)\" \naria-label=\"detail_direction\" translate translate-attr-aria-label=\"DIRECTIONLIST.detail_direction\"><md-icon \nmd-font-icon=\"icon-eye\" class=\"s18\"></md-icon></md-button></a></td></tr></tbody></table></div><div class=\"pb-64 pt-64\" \nflex-gt-xs=\"100\" ng-if=\"!$ctrl.enabled\"><div class=\"subtitle h2 no_data_stats h-272\"><any \nng-if=\"$ctrl.chartConfig.loding_disabled\">{{\'VISITSWIDGETSTATS.stat_no_data\' |translate}}</any></div></div>\n<md-card-actions has-permission=\"stats_button\" layout=\"column\" flex-gt-xs=\"5\" \nng-if=\"$ctrl.chartConfig.loding_disabled && $ctrl.enabled\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\" \nng-click=\"$ctrl.viewInTable()\"><md-icon ng-class=\"$ctrl.showGraphTable && \'md-accent\'\" class=\"s20\" \nmd-font-icon=\"icon-table-large\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Settings\" \nng-click=\"$ctrl.view()\"><md-icon md-font-icon=\"icon-chart-bar\" ng-class=\"$ctrl.showGraph && \'md-accent\'\" class=\"s20\">\n</md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-file-excel\" \nclass=\"s20\"></md-icon></md-button></md-card-actions></div></md-card-content>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.audience.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats type=\"nombre_video\" \nng-show=\"!vm.isById\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\">\n</mesure-stats><mesure-stats type=\"visite_total\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"visite_unique\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"nombre_vue_par_visiteur\" \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats \ntype=\"nombre_vue_par_video\" ng-show=\"!vm.isById\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats></div><md-card><audience-stats query=\"vm.query\"></audience-stats>\n</md-card><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats type=\"duree_total\" \nquery=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats \ntype=\"duree_moyenne_par_visite\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"duree_moyenne_par_visiteur\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"duree_moyenne_par_video\" \nng-show=\"!vm.isById\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\">\n</mesure-stats><mesure-standard-deviation-stats query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-standard-deviation-stats></div><md-card><duree-stats query=\"vm.query\">\n</duree-stats></md-card></div></any>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.engagement.html","<any><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-by-ip-stats type=\"nombre_video\" \nquery=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"></mesure-by-ip-stats><mesure-by-ip-stats \ntype=\"visite_total\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"></mesure-by-ip-stats>\n<mesure-by-ip-stats type=\"visite_unique\" query=\"vm.query\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\">\n</mesure-by-ip-stats><mesure-by-ip-stats type=\"duree_total\" query=\"vm.query\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"></mesure-by-ip-stats></div><md-card><visits-ip-stats query=\"vm.query\">\n</visits-ip-stats></md-card><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><mesure-stats \ntype=\"nombre_vue_par_visiteur\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"nombre_vue_par_video\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-stats \ntype=\"duree_moyenne_par_visite\" query=\"vm.query\" class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"20\"></mesure-stats><mesure-stats type=\"duree_moyenne_par_visiteur\" query=\"vm.query\" class=\"h-140\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-stats><mesure-taux-rebond-stats query=\"vm.query\" \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"20\"></mesure-taux-rebond-stats></div><md-card>\n<duree-visite-stats query=\"vm.query\"></duree-visite-stats></md-card><md-card><most-popular-stats query=\"vm.query\">\n</most-popular-stats></md-card></div></any>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.geo.html","<any><div><md-card><map-geo-stats query=\"vm.query\"></map-geo-stats></md-card></div></any>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.mobile.html","<any><div><md-card><os-stats query=\"vm.query\"></os-stats></md-card><md-card><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card><referrer-stats query=\"vm.query\"></referrer-stats></md-card><md-card \nng-if=\"vm.list_right_mobile.referrer\"><device-stats query=\"vm.query\"></device-stats></md-card></div></any>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.technologie.html","<any><div><md-card><os-stats query=\"vm.query\"></os-stats></md-card><md-card><browser-stats query=\"vm.query\">\n</browser-stats></md-card><md-card><referrer-stats query=\"vm.query\"></referrer-stats></md-card></div></any>");
$templateCache.put("app/main/stats/export/vod_live/tabStats/stat.vod.temp_reel.html","<md-content><div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><time-reel-now-stats \ntype=\"visite_temps_reel\" query=\"vm.query\" class=\"h-140\" layout=\"row\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"50\">\n</time-reel-now-stats></div><md-card><time-reel-heure-stats query=\"vm.query\"></time-reel-heure-stats></md-card>\n<md-card><time-reel-minute-stats query=\"vm.query\"></time-reel-minute-stats></md-card></div></md-content>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber) && !MsStepper.twice, \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" \naria-label=\"Stepper navigation button\" layout=\"row\" layout-align=\"start center\"><div class=\"step\" layout=\"row\" \nlayout-align=\"center center\"><span><i class=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i></span>\n</div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">\n{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" ng-if=\"!stepInfo.stepTitleTranslate\">\n{{stepInfo.stepTitle}}</div><div class=\"subtitle\" ng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div>\n</div></md-button><div class=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" \nlayout=\"row\" layout-align=\"start center\" ng-if=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/display/template_manager/editor/side-nav/lives-list-modal/lives-list.modal.html","<md-dialog class=\"event-form-dialog\" aria-label=\"addInfomrations\" style=\"width:761px\"><md-toolbar class=\"md-accent\">\n<div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\"><md-icon \nmd-font-icon=\"icon-information-outline\" class=\"s24\"></md-icon><span translate=\"PAGESMENUSTITLES.lives_list\">\nListe des vidéos</span> </span><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"MESSAGES.alert_close\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content style=\"overflow-x: hidden\"><div \nng-if=\"vm.lives.length>0\" class=\"todo-items\"><div when-scrolled=\"loadMore()\" class=\"todo-item md-padding\" layout-wrap \nlayout=\"row\" style=\"padding: 10px;cursor: auto; height: 530px;overflow: auto;overflow-x: hidden\"><div \nstyle=\"width: 225px\" ng-repeat=\"(key , live) in vm.lives\" layout=\"column\"><md-card \nng-class=\"{\'filter-vid\': live===vm.vid}\" ng-click=\"vm.selectLive(live,key)\" \nstyle=\"background: #ededed;  cursor: pointer;  box-shadow: 0 0 0 0 !important\"><md-icon ng-if=\"live===vm.vid\" \nclass=\"thumbnailCheckbox2\" style=\"color: #00C853\" md-font-icon=\"icon-checkbox-marked-circle\"></md-icon><md-icon \nstyle=\"height: 120px !important;    padding-top: 22px\" md-font-icon=\"icon-no-image-custom\" class=\"s72\" width=\"100\" \nheight=\"100\"></md-icon><md-card-actions style=\"height: 20px\" layout=\"row\" layout-align=\"end center\"><div layout=\"row\" \nclass=\"title\" layout-align=\"start center\" flex><span title=\"{{live.title}}\" \nstyle=\"font-size: 0.87em; width: 120px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis\" class=\"name\">\n{{live.title}}</span></div></md-card-actions></md-card></div></div></div><div ng-if=\"vm.lives.length===0\"><span \ntranslate=\"MESSAGES.no_lives\">no_lives</span></div></md-dialog-content><md-dialog-actions><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.validate()\">Valider</md-button></md-dialog-actions></md-dialog>");}]);